var JSMpeg = {
  Player: null,
  VideoElement: null,
  BitBuffer: null,
  Source: {},
  Demuxer: {},
  Decoder: {},
  Renderer: {},
  AudioOutput: {},
  Now: function() {
    return window.performance ? window.performance.now() / 1e3 : Date.now() / 1e3
  },
  CreateVideoElements: function() {
    var elements = document.querySelectorAll(".jsmpeg");
    for (var i = 0; i < elements.length; i++) {
      new JSMpeg.VideoElement(elements[i])
    }
  },
  Fill: function(array, value) {
    if (array.fill) {
      array.fill(value)
    } else {
      for (var i = 0; i < array.length; i++) {
        array[i] = value
      }
    }
  }
};
if (document.readyState === "complete") {
  JSMpeg.CreateVideoElements()
} else {
  document.addEventListener("DOMContentLoaded", JSMpeg.CreateVideoElements)
}
JSMpeg.VideoElement = function() {
  "use strict";
  var VideoElement = function(element) {
    var url = element.dataset.url;
    if (!url) {
      throw "VideoElement has no `data-url` attribute"
    }
    var addStyles = function(element, styles) {
      for (var name in styles) {
        element.style[name] = styles[name]
      }
    };
    this.container = element;
    addStyles(this.container, {
      display: "inline-block",
      position: "relative",
      minWidth: "80px",
      minHeight: "80px"
    });
    this.canvas = document.createElement("canvas");
    this.canvas.width = 960;
    this.canvas.height = 540;
    addStyles(this.canvas, {
      display: "block",
      width: "100%"
    });
    this.container.appendChild(this.canvas);
    this.playButton = document.createElement("div");
    this.playButton.innerHTML = VideoElement.PLAY_BUTTON;
    addStyles(this.playButton, {
      zIndex: 2,
      position: "absolute",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
      maxWidth: "75px",
      maxHeight: "75px",
      margin: "auto",
      opacity: "0.7",
      cursor: "pointer"
    });
    this.container.appendChild(this.playButton);
    var options = {
      canvas: this.canvas
    };
    for (var option in element.dataset) {
      try {
        options[option] = JSON.parse(element.dataset[option])
      } catch (err) {
        options[option] = element.dataset[option]
      }
    }
    this.player = new JSMpeg.Player(url, options);
    element.playerInstance = this.player;
    if (options.poster && !options.autoplay && !this.player.options.streaming) {
      options.decodeFirstFrame = false;
      this.poster = new Image;
      this.poster.src = options.poster;
      this.poster.addEventListener("load", this.posterLoaded);
      addStyles(this.poster, {
        display: "block",
        zIndex: 1,
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      });
      this.container.appendChild(this.poster)
    }
    if (!this.player.options.streaming) {
      this.container.addEventListener("click", this.onClick.bind(this))
    }
    if (options.autoplay || this.player.options.streaming) {
      this.playButton.style.display = "none"
    }
    if (this.player.audioOut && !this.player.audioOut.unlocked) {
      var unlockAudioElement = this.container;
      if (options.autoplay || this.player.options.streaming) {
        this.unmuteButton = document.createElement("div");
        this.unmuteButton.innerHTML = VideoElement.UNMUTE_BUTTON;
        addStyles(this.unmuteButton, {
          zIndex: 2,
          position: "absolute",
          bottom: "10px",
          right: "20px",
          width: "75px",
          height: "75px",
          margin: "auto",
          opacity: "0.7",
          cursor: "pointer"
        });
        this.container.appendChild(this.unmuteButton);
        unlockAudioElement = this.unmuteButton
      }
      this.unlockAudioBound = this.onUnlockAudio.bind(this, unlockAudioElement);
      unlockAudioElement.addEventListener("touchstart", this.unlockAudioBound, false);
      unlockAudioElement.addEventListener("click", this.unlockAudioBound, true)
    }
  };
  VideoElement.prototype.onUnlockAudio = function(element, ev) {
    if (this.unmuteButton) {
      ev.preventDefault();
      ev.stopPropagation()
    }
    this.player.audioOut.unlock(function() {
      if (this.unmuteButton) {
        this.unmuteButton.style.display = "none"
      }
      element.removeEventListener("touchstart", this.unlockAudioBound);
      element.removeEventListener("click", this.unlockAudioBound)
    }.bind(this))
  };
  VideoElement.prototype.onClick = function(ev) {
    if (this.player.isPlaying) {
      this.player.pause();
      this.playButton.style.display = "block"
    } else {
      this.player.play();
      this.playButton.style.display = "none";
      if (this.poster) {
        this.poster.style.display = "none"
      }
    }
  };
  VideoElement.PLAY_BUTTON = '<svg style="max-width: 75px; max-height: 75px;" ' + 'viewBox="0 0 200 200" alt="Play video">' + '<circle cx="100" cy="100" r="90" fill="none" ' + 'stroke-width="15" stroke="#fff"/>' + '<polygon points="70, 55 70, 145 145, 100" fill="#fff"/>' + "</svg>";
  VideoElement.UNMUTE_BUTTON = '<svg style="max-width: 75px; max-height: 75px;" viewBox="0 0 75 75">' + '<polygon class="audio-speaker" stroke="none" fill="#fff" ' + 'points="39,13 22,28 6,28 6,47 21,47 39,62 39,13"/>' + '<g stroke="#fff" stroke-width="5">' + '<path d="M 49,50 69,26"/>' + '<path d="M 69,50 49,26"/>' + "</g>" + "</svg>";
  return VideoElement
}();
JSMpeg.Player = function() {
  "use strict";
  var Player = function(url, options) {
    this.options = options || {};
    if(typeof this.options.canvas === 'string'){
      this.options.canvas = document.querySelector(this.options.canvas)
    }
    this.source = new JSMpeg.Source.Pipe(url, options);
    options.streaming = true
    this.maxAudioLag = options.maxAudioLag || .25;
    this.loop = options.loop !== false;
    this.autoplay = true;
    this.demuxer = new JSMpeg.Demuxer.TS(options);
    this.source.connect(this.demuxer);
    this.write = this.demuxer.write
    if (options.video !== false) {
      this.video = new JSMpeg.Decoder.MPEG1Video(options);
      this.renderer = !options.disableGl && JSMpeg.Renderer.WebGL.IsSupported() ? new JSMpeg.Renderer.WebGL(options) : new JSMpeg.Renderer.Canvas2D(options);
      this.demuxer.connect(JSMpeg.Demuxer.TS.STREAM.VIDEO_1, this.video);
      this.video.connect(this.renderer)
    }
    if (options.audio !== false && JSMpeg.AudioOutput.WebAudio.IsSupported()) {
      this.audio = new JSMpeg.Decoder.MP2Audio(options);
      this.audioOut = new JSMpeg.AudioOutput.WebAudio(options);
      this.demuxer.connect(JSMpeg.Demuxer.TS.STREAM.AUDIO_1, this.audio);
      this.audio.connect(this.audioOut)
    }
    Object.defineProperty(this, "currentTime", {
      get: this.getCurrentTime,
      set: this.setCurrentTime
    });
    Object.defineProperty(this, "volume", {
      get: this.getVolume,
      set: this.setVolume
    });
    this.unpauseOnShow = false;
    if (options.pauseWhenHidden !== false) {
      document.addEventListener("visibilitychange", this.showHide.bind(this))
    }
    this.source.start();
    if (this.autoplay) {
      this.play()
    }
  };
  Player.prototype.showHide = function(ev) {
    if (document.visibilityState === "hidden") {
      this.unpauseOnShow = this.wantsToPlay;
      this.pause()
    } else if (this.unpauseOnShow) {
      this.play()
    }
  };
  Player.prototype.play = function(ev) {
    this.animationId = requestAnimationFrame(this.update.bind(this));
    this.wantsToPlay = true
  };
  Player.prototype.pause = function(ev) {
    cancelAnimationFrame(this.animationId);
    this.wantsToPlay = false;
    this.isPlaying = false;
    if (this.audio && this.audio.canPlay) {
      this.audioOut.stop();
      this.seek(this.currentTime)
    }
  };
  Player.prototype.getVolume = function() {
    return this.audioOut ? this.audioOut.volume : 0
  };
  Player.prototype.setVolume = function(volume) {
    if (this.audioOut) {
      this.audioOut.volume = volume
    }
  };
  Player.prototype.stop = function(ev) {
    this.pause();
    this.seek(0);
    if (this.video && this.options.decodeFirstFrame !== false) {
      this.video.decode()
    }
  };
  Player.prototype.destroy = function() {
    this.pause();
    this.source.destroy();
    this.renderer.destroy();
    this.audioOut.destroy()
  };
  Player.prototype.seek = function(time) {
    var startOffset = this.audio && this.audio.canPlay ? this.audio.startTime : this.video.startTime;
    if (this.video) {
      this.video.seek(time + startOffset)
    }
    if (this.audio) {
      this.audio.seek(time + startOffset)
    }
    this.startTime = JSMpeg.Now() - time
  };
  Player.prototype.getCurrentTime = function() {
    return this.audio && this.audio.canPlay ? this.audio.currentTime - this.audio.startTime : this.video.currentTime - this.video.startTime
  };
  Player.prototype.setCurrentTime = function(time) {
    this.seek(time)
  };
  Player.prototype.update = function() {
    this.animationId = requestAnimationFrame(this.update.bind(this));
    if (!this.source.established) {
      if (this.renderer) {
        this.renderer.renderProgress(this.source.progress)
      }
      return
    }
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.startTime = JSMpeg.Now() - this.currentTime
    }
    if (this.options.streaming) {
      this.updateForStreaming()
    } else {
      this.updateForStaticFile()
    }
  };
  Player.prototype.updateForStreaming = function() {
    if (this.video) {
      this.video.decode()
    }
    if (this.audio) {
      var decoded = false;
      do {
        if (this.audioOut.enqueuedTime > this.maxAudioLag) {
          this.audioOut.resetEnqueuedTime();
          this.audioOut.enabled = false
        }
        decoded = this.audio.decode()
      } while (decoded);
      this.audioOut.enabled = true
    }
  };
  Player.prototype.updateForStaticFile = function() {
    var notEnoughData = false,
      headroom = 0;
    if (this.audio && this.audio.canPlay) {
      while (!notEnoughData && this.audio.decodedTime - this.audio.currentTime < .25) {
        notEnoughData = !this.audio.decode()
      }
      if (this.video && this.video.currentTime < this.audio.currentTime) {
        notEnoughData = !this.video.decode()
      }
      headroom = this.demuxer.currentTime - this.audio.currentTime
    } else if (this.video) {
      var targetTime = JSMpeg.Now() - this.startTime + this.video.startTime,
        lateTime = targetTime - this.video.currentTime,
        frameTime = 1 / this.video.frameRate;
      if (this.video && lateTime > 0) {
        if (lateTime > frameTime * 2) {
          this.startTime += lateTime
        }
        notEnoughData = !this.video.decode()
      }
      headroom = this.demuxer.currentTime - targetTime
    }
    this.source.resume(headroom);
    if (notEnoughData && this.source.completed) {
      if (this.loop) {
        this.seek(0)
      } else {
        this.pause()
      }
    }
  };
  return Player
}();
JSMpeg.BitBuffer = function() {
  "use strict";
  var BitBuffer = function(bufferOrLength, mode) {
    if (typeof bufferOrLength === "object") {
      this.bytes = bufferOrLength instanceof Uint8Array ? bufferOrLength : new Uint8Array(bufferOrLength);
      this.byteLength = this.bytes.length
    } else {
      this.bytes = new Uint8Array(bufferOrLength || 1024 * 1024);
      this.byteLength = 0
    }
    this.mode = mode || BitBuffer.MODE.EXPAND;
    this.index = 0
  };
  BitBuffer.prototype.resize = function(size) {
    var newBytes = new Uint8Array(size);
    if (this.byteLength !== 0) {
      this.byteLength = Math.min(this.byteLength, size);
      newBytes.set(this.bytes, 0, this.byteLength)
    }
    this.bytes = newBytes;
    this.index = Math.min(this.index, this.byteLength << 3)
  };
  BitBuffer.prototype.evict = function(sizeNeeded) {
    var bytePos = this.index >> 3,
      available = this.bytes.length - this.byteLength;
    if (this.index === this.byteLength << 3 || sizeNeeded > available + bytePos) {
      this.byteLength = 0;
      this.index = 0;
      return
    } else if (bytePos === 0) {
      return
    }
    if (this.bytes.copyWithin) {
      this.bytes.copyWithin(0, bytePos, this.byteLength)
    } else {
      this.bytes.set(this.bytes.subarray(bytePos, this.byteLength))
    }
    this.byteLength = this.byteLength - bytePos;
    this.index -= bytePos << 3;
    return
  };
  BitBuffer.prototype.write = function(buffers,callback) {
    var isArrayOfBuffers = typeof buffers[0] === "object",
      totalLength = 0,
      available = this.bytes.length - this.byteLength;
    if (isArrayOfBuffers) {
      var totalLength = 0;
      for (var i = 0; i < buffers.length; i++) {
        totalLength += buffers[i].byteLength
      }
    } else {
      totalLength = buffers.byteLength
    }
    if (totalLength > available) {
      if (this.mode === BitBuffer.MODE.EXPAND) {
        var newSize = Math.max(this.bytes.length * 2, totalLength - available);
        this.resize(newSize)
      } else {
        this.evict(totalLength)
      }
    }
    if (isArrayOfBuffers) {
      for (var i = 0; i < buffers.length; i++) {
        this.appendSingleBuffer(buffers[i])
      }
    } else {
      this.appendSingleBuffer(buffers)
    }
    if(callback)callback()
  };
  BitBuffer.prototype.appendSingleBuffer = function(buffer) {
    buffer = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    this.bytes.set(buffer, this.byteLength);
    this.byteLength += buffer.length
  };
  BitBuffer.prototype.findNextStartCode = function() {
    for (var i = this.index + 7 >> 3; i < this.byteLength; i++) {
      if (this.bytes[i] == 0 && this.bytes[i + 1] == 0 && this.bytes[i + 2] == 1) {
        this.index = i + 4 << 3;
        return this.bytes[i + 3]
      }
    }
    this.index = this.byteLength << 3;
    return -1
  };
  BitBuffer.prototype.findStartCode = function(code) {
    var current = 0;
    while (true) {
      current = this.findNextStartCode();
      if (current === code || current === -1) {
        return current
      }
    }
    return -1
  };
  BitBuffer.prototype.nextBytesAreStartCode = function() {
    var i = this.index + 7 >> 3;
    return i >= this.byteLength || this.bytes[i] == 0 && this.bytes[i + 1] == 0 && this.bytes[i + 2] == 1
  };
  BitBuffer.prototype.peek = function(count) {
    var offset = this.index;
    var value = 0;
    while (count) {
      var currentByte = this.bytes[offset >> 3],
        remaining = 8 - (offset & 7),
        read = remaining < count ? remaining : count,
        shift = remaining - read,
        mask = 255 >> 8 - read;
      value = value << read | (currentByte & mask << shift) >> shift;
      offset += read;
      count -= read
    }
    return value
  };
  BitBuffer.prototype.read = function(count) {
    var value = this.peek(count);
    this.index += count;
    return value
  };
  BitBuffer.prototype.skip = function(count) {
    return this.index += count
  };
  BitBuffer.prototype.rewind = function(count) {
    this.index = Math.max(this.index - count, 0)
  };
  BitBuffer.prototype.has = function(count) {
    return (this.byteLength << 3) - this.index >= count
  };
  BitBuffer.MODE = {
    EVICT: 1,
    EXPAND: 2
  };
  return BitBuffer
}();
JSMpeg.Source.Pipe = function() {
  "use strict";
  var PipeSource = function(url, options) {
    this.options = options;
    this.completed = false;
    this.established = true;
    this.progress = 0;
    this.reconnectTimeoutId = 0
  };
  PipeSource.prototype.connect = function() {};
  PipeSource.prototype.destroy = function() {};
  PipeSource.prototype.start = function() {};
  PipeSource.prototype.resume = function() {};
  PipeSource.prototype.onOpen = function() {};
  PipeSource.prototype.onClose = function() {};
  PipeSource.prototype.onMessage = function() {};
  return PipeSource
}();
JSMpeg.Demuxer.TS = function() {
  "use strict";
  var pidsToStreamIds = {};
  var pesPacketInfo = {};
  var TS = function(options) {
    this.bits = null;
    this.leftoverBytes = null;
    this.guessVideoFrameEnd = true;
    this.startTime = 0;
    this.currentTime = 0
  };
  TS.prototype.connect = function(streamId, destination) {
    pesPacketInfo[streamId] = {
      destination: destination,
      currentLength: 0,
      totalLength: 0,
      pts: 0,
      buffers: []
    }
  };
  TS.prototype.write = function(buffer,callback) {
    if (this.leftoverBytes) {
      var totalLength = buffer.byteLength + this.leftoverBytes.byteLength;
      this.bits = new JSMpeg.BitBuffer(totalLength);
      this.bits.write([this.leftoverBytes, buffer],callback)
    } else {
      this.bits = new JSMpeg.BitBuffer(buffer)
      callback()
    }
    this.parsePacket=TS.prototype.parsePacket
    this.packetStart=TS.prototype.packetStart
    this.packetAddData=TS.prototype.packetAddData
    this.packetComplete=TS.prototype.packetComplete
    while (this.bits.has(188 << 3) && this.parsePacket()) {}
    var leftoverCount = this.bits.byteLength - (this.bits.index >> 3);
    this.leftoverBytes = leftoverCount > 0 ? this.bits.bytes.subarray(this.bits.index >> 3) : null
  };
  TS.prototype.parsePacket = function() {
    if (this.bits.read(8) !== 71) {
      if (!this.resync()) {
        return false
      }
    }
    var end = (this.bits.index >> 3) + 187;
    var transportError = this.bits.read(1),
      payloadStart = this.bits.read(1),
      transportPriority = this.bits.read(1),
      pid = this.bits.read(13),
      transportScrambling = this.bits.read(2),
      adaptationField = this.bits.read(2),
      continuityCounter = this.bits.read(4);
    var streamId = pidsToStreamIds[pid];
    if (payloadStart && streamId) {
      var pi = pesPacketInfo[streamId];
      if (pi && pi.currentLength) {
        this.packetComplete(pi)
      }
    }
    if (adaptationField & 1) {
      if (adaptationField & 2) {
        var adaptationFieldLength = this.bits.read(8);
        this.bits.skip(adaptationFieldLength << 3)
      }
      if (payloadStart && this.bits.nextBytesAreStartCode()) {
        this.bits.skip(24);
        streamId = this.bits.read(8);
        pidsToStreamIds[pid] = streamId;
        var packetLength = this.bits.read(16);
        this.bits.skip(8);
        var ptsDtsFlag = this.bits.read(2);
        this.bits.skip(6);
        var headerLength = this.bits.read(8);
        var payloadBeginIndex = this.bits.index + (headerLength << 3);
        var pi = pesPacketInfo[streamId];
        if (pi) {
          var pts = 0;
          if (ptsDtsFlag & 2) {
            this.bits.skip(4);
            var p32_30 = this.bits.read(3);
            this.bits.skip(1);
            var p29_15 = this.bits.read(15);
            this.bits.skip(1);
            var p14_0 = this.bits.read(15);
            this.bits.skip(1);
            pts = (p32_30 * 1073741824 + p29_15 * 32768 + p14_0) / 9e4;
            this.currentTime = pts;
            if (this.startTime === -1) {
              this.startTime = pts
            }
          }
          var payloadLength = packetLength ? packetLength - headerLength - 3 : 0;
          this.packetStart(pi, pts, payloadLength)
        }
        this.bits.index = payloadBeginIndex
      }
      if (streamId) {
        var pi = pesPacketInfo[streamId];
        if (pi) {
          var start = this.bits.index >> 3;
          var complete = this.packetAddData(pi, start, end);
          var hasPadding = !payloadStart && adaptationField & 2;
          if (complete || this.guessVideoFrameEnd && hasPadding) {
            this.packetComplete(pi)
          }
        }
      }
    }
    this.bits.index = end << 3;
    return true
  };
  TS.prototype.resync = function() {
    if (!this.bits.has(188 * 6 << 3)) {
      return false
    }
    var byteIndex = this.bits.index >> 3;
    for (var i = 0; i < 187; i++) {
      if (this.bits.bytes[byteIndex + i] === 71) {
        var foundSync = true;
        for (var j = 1; j < 5; j++) {
          if (this.bits.bytes[byteIndex + i + 188 * j] !== 71) {
            foundSync = false;
            break
          }
        }
        if (foundSync) {
          this.bits.index = byteIndex + i + 1 << 3;
          return true
        }
      }
    }
    console.warn("JSMpeg: Possible garbage data. Skipping.");
    this.bits.skip(187 << 3);
    return false
  };
  TS.prototype.packetStart = function(pi, pts, payloadLength) {
    pi.totalLength = payloadLength;
    pi.currentLength = 0;
    pi.pts = pts
  };
  TS.prototype.packetAddData = function(pi, start, end) {
    pi.buffers.push(this.bits.bytes.subarray(start, end));
    pi.currentLength += end - start;
    var complete = pi.totalLength !== 0 && pi.currentLength >= pi.totalLength;
    return complete
  };
  TS.prototype.packetComplete = function(pi) {
    pi.destination.write(pi.pts, pi.buffers);
    pi.totalLength = 0;
    pi.currentLength = 0;
    pi.buffers = []
  };
  TS.STREAM = {
    PACK_HEADER: 186,
    SYSTEM_HEADER: 187,
    PROGRAM_MAP: 188,
    PRIVATE_1: 189,
    PADDING: 190,
    PRIVATE_2: 191,
    AUDIO_1: 192,
    VIDEO_1: 224,
    DIRECTORY: 255
  };
  return TS
}();
JSMpeg.Decoder.Base = function() {
  "use strict";
  var BaseDecoder = function(options) {
    this.destination = null;
    this.canPlay = false;
    this.collectTimestamps = !options.streaming;
    this.timestamps = [];
    this.timestampIndex = 0;
    this.startTime = 0;
    this.decodedTime = 0;
    Object.defineProperty(this, "currentTime", {
      get: this.getCurrentTime
    })
  };
  BaseDecoder.prototype.connect = function(destination) {
    this.destination = destination
  };
  BaseDecoder.prototype.write = function(pts, buffers) {
    if (this.collectTimestamps) {
      if (this.timestamps.length === 0) {
        this.startTime = pts;
        this.decodedTime = pts
      }
      this.timestamps.push({
        index: this.bits.byteLength << 3,
        time: pts
      })
    }
    this.bits.write(buffers);
    this.canPlay = true
  };
  BaseDecoder.prototype.seek = function(time) {
    if (!this.collectTimestamps) {
      return
    }
    this.timestampIndex = 0;
    for (var i = 0; i < this.timestamps.length; i++) {
      if (this.timestamps[i].time > time) {
        break
      }
      this.timestampIndex = i
    }
    var ts = this.timestamps[this.timestampIndex];
    if (ts) {
      this.bits.index = ts.index;
      this.decodedTime = ts.time
    } else {
      this.bits.index = 0;
      this.decodedTime = this.startTime
    }
  };
  BaseDecoder.prototype.decode = function() {
    this.advanceDecodedTime(0)
  };
  BaseDecoder.prototype.advanceDecodedTime = function(seconds) {
    if (this.collectTimestamps) {
      var newTimestampIndex = -1;
      for (var i = this.timestampIndex; i < this.timestamps.length; i++) {
        if (this.timestamps[i].index > this.bits.index) {
          break
        }
        newTimestampIndex = i
      }
      if (newTimestampIndex !== -1 && newTimestampIndex !== this.timestampIndex) {
        this.timestampIndex = newTimestampIndex;
        this.decodedTime = this.timestamps[this.timestampIndex].time;
        return
      }
    }
    this.decodedTime += seconds
  };
  BaseDecoder.prototype.getCurrentTime = function() {
    return this.decodedTime
  };
  return BaseDecoder
}();
JSMpeg.Decoder.MPEG1Video = function() {
  "use strict";
  var MPEG1 = function(options) {
    JSMpeg.Decoder.Base.call(this, options);
    var bufferSize = options.videoBufferSize || 512 * 1024;
    var bufferMode = options.streaming ? JSMpeg.BitBuffer.MODE.EVICT : JSMpeg.BitBuffer.MODE.EXPAND;
    this.bits = new JSMpeg.BitBuffer(bufferSize, bufferMode);
    this.customIntraQuantMatrix = new Uint8Array(64);
    this.customNonIntraQuantMatrix = new Uint8Array(64);
    this.blockData = new Int32Array(64);
    this.currentFrame = 0;
    this.decodeFirstFrame = options.decodeFirstFrame !== false
  };
  MPEG1.prototype = Object.create(JSMpeg.Decoder.Base.prototype);
  MPEG1.prototype.constructor = MPEG1;
  MPEG1.prototype.write = function(pts, buffers) {
    JSMpeg.Decoder.Base.prototype.write.call(this, pts, buffers);
    if (!this.hasSequenceHeader) {
      if (this.bits.findStartCode(MPEG1.START.SEQUENCE) === -1) {
        return false
      }
      this.decodeSequenceHeader();
      if (this.decodeFirstFrame) {
        this.decode()
      }
    }
  };
  MPEG1.prototype.decode = function() {
    if (!this.hasSequenceHeader) {
      return false
    }
    if (this.bits.findStartCode(MPEG1.START.PICTURE) === -1) {
      var bufferedBytes = this.bits.byteLength - (this.bits.index >> 3);
      return false
    }
    this.decodePicture();
    this.advanceDecodedTime(1 / this.frameRate);
    return true
  };
  MPEG1.prototype.readHuffman = function(codeTable) {
    var state = 0;
    do {
      state = codeTable[state + this.bits.read(1)]
    } while (state >= 0 && codeTable[state] !== 0);
    return codeTable[state + 2]
  };
  MPEG1.prototype.frameRate = 30;
  MPEG1.prototype.decodeSequenceHeader = function() {
    var newWidth = this.bits.read(12),
      newHeight = this.bits.read(12);
    this.bits.skip(4);
    this.frameRate = MPEG1.PICTURE_RATE[this.bits.read(4)];
    this.bits.skip(18 + 1 + 10 + 1);
    if (newWidth !== this.width || newHeight !== this.height) {
      this.width = newWidth;
      this.height = newHeight;
      this.initBuffers();
      if (this.destination) {
        this.destination.resize(newWidth, newHeight)
      }
    }
    if (this.bits.read(1)) {
      for (var i = 0; i < 64; i++) {
        this.customIntraQuantMatrix[MPEG1.ZIG_ZAG[i]] = this.bits.read(8)
      }
      this.intraQuantMatrix = this.customIntraQuantMatrix
    }
    if (this.bits.read(1)) {
      for (var i = 0; i < 64; i++) {
        var idx = MPEG1.ZIG_ZAG[i];
        this.customNonIntraQuantMatrix[idx] = this.bits.read(8)
      }
      this.nonIntraQuantMatrix = this.customNonIntraQuantMatrix
    }
    this.hasSequenceHeader = true
  };
  MPEG1.prototype.initBuffers = function() {
    this.intraQuantMatrix = MPEG1.DEFAULT_INTRA_QUANT_MATRIX;
    this.nonIntraQuantMatrix = MPEG1.DEFAULT_NON_INTRA_QUANT_MATRIX;
    this.mbWidth = this.width + 15 >> 4;
    this.mbHeight = this.height + 15 >> 4;
    this.mbSize = this.mbWidth * this.mbHeight;
    this.codedWidth = this.mbWidth << 4;
    this.codedHeight = this.mbHeight << 4;
    this.codedSize = this.codedWidth * this.codedHeight;
    this.halfWidth = this.mbWidth << 3;
    this.halfHeight = this.mbHeight << 3;
    this.currentY = new Uint8ClampedArray(this.codedSize);
    this.currentY32 = new Uint32Array(this.currentY.buffer);
    this.currentCr = new Uint8ClampedArray(this.codedSize >> 2);
    this.currentCr32 = new Uint32Array(this.currentCr.buffer);
    this.currentCb = new Uint8ClampedArray(this.codedSize >> 2);
    this.currentCb32 = new Uint32Array(this.currentCb.buffer);
    this.forwardY = new Uint8ClampedArray(this.codedSize);
    this.forwardY32 = new Uint32Array(this.forwardY.buffer);
    this.forwardCr = new Uint8ClampedArray(this.codedSize >> 2);
    this.forwardCr32 = new Uint32Array(this.forwardCr.buffer);
    this.forwardCb = new Uint8ClampedArray(this.codedSize >> 2);
    this.forwardCb32 = new Uint32Array(this.forwardCb.buffer)
  };
  MPEG1.prototype.currentY = null;
  MPEG1.prototype.currentCr = null;
  MPEG1.prototype.currentCb = null;
  MPEG1.prototype.pictureType = 0;
  MPEG1.prototype.forwardY = null;
  MPEG1.prototype.forwardCr = null;
  MPEG1.prototype.forwardCb = null;
  MPEG1.prototype.fullPelForward = false;
  MPEG1.prototype.forwardFCode = 0;
  MPEG1.prototype.forwardRSize = 0;
  MPEG1.prototype.forwardF = 0;
  MPEG1.prototype.decodePicture = function(skipOutput) {
    this.currentFrame++;
    this.bits.skip(10);
    this.pictureType = this.bits.read(3);
    this.bits.skip(16);
    if (this.pictureType <= 0 || this.pictureType >= MPEG1.PICTURE_TYPE.B) {
      return
    }
    if (this.pictureType === MPEG1.PICTURE_TYPE.PREDICTIVE) {
      this.fullPelForward = this.bits.read(1);
      this.forwardFCode = this.bits.read(3);
      if (this.forwardFCode === 0) {
        return
      }
      this.forwardRSize = this.forwardFCode - 1;
      this.forwardF = 1 << this.forwardRSize
    }
    var code = 0;
    do {
      code = this.bits.findNextStartCode()
    } while (code === MPEG1.START.EXTENSION || code === MPEG1.START.USER_DATA);
    while (code >= MPEG1.START.SLICE_FIRST && code <= MPEG1.START.SLICE_LAST) {
      this.decodeSlice(code & 255);
      code = this.bits.findNextStartCode()
    }
    if (code !== -1) {
      this.bits.rewind(32)
    }
    if (this.destination) {
      this.destination.render(this.currentY, this.currentCr, this.currentCb)
    }
    if (this.pictureType === MPEG1.PICTURE_TYPE.INTRA || this.pictureType === MPEG1.PICTURE_TYPE.PREDICTIVE) {
      var tmpY = this.forwardY,
        tmpY32 = this.forwardY32,
        tmpCr = this.forwardCr,
        tmpCr32 = this.forwardCr32,
        tmpCb = this.forwardCb,
        tmpCb32 = this.forwardCb32;
      this.forwardY = this.currentY;
      this.forwardY32 = this.currentY32;
      this.forwardCr = this.currentCr;
      this.forwardCr32 = this.currentCr32;
      this.forwardCb = this.currentCb;
      this.forwardCb32 = this.currentCb32;
      this.currentY = tmpY;
      this.currentY32 = tmpY32;
      this.currentCr = tmpCr;
      this.currentCr32 = tmpCr32;
      this.currentCb = tmpCb;
      this.currentCb32 = tmpCb32
    }
  };
  MPEG1.prototype.quantizerScale = 0;
  MPEG1.prototype.sliceBegin = false;
  MPEG1.prototype.decodeSlice = function(slice) {
    this.sliceBegin = true;
    this.macroblockAddress = (slice - 1) * this.mbWidth - 1;
    this.motionFwH = this.motionFwHPrev = 0;
    this.motionFwV = this.motionFwVPrev = 0;
    this.dcPredictorY = 128;
    this.dcPredictorCr = 128;
    this.dcPredictorCb = 128;
    this.quantizerScale = this.bits.read(5);
    while (this.bits.read(1)) {
      this.bits.skip(8)
    }
    do {
      this.decodeMacroblock()
    } while (!this.bits.nextBytesAreStartCode())
  };
  MPEG1.prototype.macroblockAddress = 0;
  MPEG1.prototype.mbRow = 0;
  MPEG1.prototype.mbCol = 0;
  MPEG1.prototype.macroblockType = 0;
  MPEG1.prototype.macroblockIntra = false;
  MPEG1.prototype.macroblockMotFw = false;
  MPEG1.prototype.motionFwH = 0;
  MPEG1.prototype.motionFwV = 0;
  MPEG1.prototype.motionFwHPrev = 0;
  MPEG1.prototype.motionFwVPrev = 0;
  MPEG1.prototype.decodeMacroblock = function() {
    var increment = 0,
      t = this.readHuffman(MPEG1.MACROBLOCK_ADDRESS_INCREMENT);
    while (t === 34) {
      t = this.readHuffman(MPEG1.MACROBLOCK_ADDRESS_INCREMENT)
    }
    while (t === 35) {
      increment += 33;
      t = this.readHuffman(MPEG1.MACROBLOCK_ADDRESS_INCREMENT)
    }
    increment += t;
    if (this.sliceBegin) {
      this.sliceBegin = false;
      this.macroblockAddress += increment
    } else {
      if (this.macroblockAddress + increment >= this.mbSize) {
        return
      }
      if (increment > 1) {
        this.dcPredictorY = 128;
        this.dcPredictorCr = 128;
        this.dcPredictorCb = 128;
        if (this.pictureType === MPEG1.PICTURE_TYPE.PREDICTIVE) {
          this.motionFwH = this.motionFwHPrev = 0;
          this.motionFwV = this.motionFwVPrev = 0
        }
      }
      while (increment > 1) {
        this.macroblockAddress++;
        this.mbRow = this.macroblockAddress / this.mbWidth | 0;
        this.mbCol = this.macroblockAddress % this.mbWidth;
        this.copyMacroblock(this.motionFwH, this.motionFwV, this.forwardY, this.forwardCr, this.forwardCb);
        increment--
      }
      this.macroblockAddress++
    }
    this.mbRow = this.macroblockAddress / this.mbWidth | 0;
    this.mbCol = this.macroblockAddress % this.mbWidth;
    var mbTable = MPEG1.MACROBLOCK_TYPE[this.pictureType];
    this.macroblockType = this.readHuffman(mbTable);
    this.macroblockIntra = this.macroblockType & 1;
    this.macroblockMotFw = this.macroblockType & 8;
    if ((this.macroblockType & 16) !== 0) {
      this.quantizerScale = this.bits.read(5)
    }
    if (this.macroblockIntra) {
      this.motionFwH = this.motionFwHPrev = 0;
      this.motionFwV = this.motionFwVPrev = 0
    } else {
      this.dcPredictorY = 128;
      this.dcPredictorCr = 128;
      this.dcPredictorCb = 128;
      this.decodeMotionVectors();
      this.copyMacroblock(this.motionFwH, this.motionFwV, this.forwardY, this.forwardCr, this.forwardCb)
    }
    var cbp = (this.macroblockType & 2) !== 0 ? this.readHuffman(MPEG1.CODE_BLOCK_PATTERN) : this.macroblockIntra ? 63 : 0;
    for (var block = 0, mask = 32; block < 6; block++) {
      if ((cbp & mask) !== 0) {
        this.decodeBlock(block)
      }
      mask >>= 1
    }
  };
  MPEG1.prototype.decodeMotionVectors = function() {
    var code, d, r = 0;
    if (this.macroblockMotFw) {
      code = this.readHuffman(MPEG1.MOTION);
      if (code !== 0 && this.forwardF !== 1) {
        r = this.bits.read(this.forwardRSize);
        d = (Math.abs(code) - 1 << this.forwardRSize) + r + 1;
        if (code < 0) {
          d = -d
        }
      } else {
        d = code
      }
      this.motionFwHPrev += d;
      if (this.motionFwHPrev > (this.forwardF << 4) - 1) {
        this.motionFwHPrev -= this.forwardF << 5
      } else if (this.motionFwHPrev < -this.forwardF << 4) {
        this.motionFwHPrev += this.forwardF << 5
      }
      this.motionFwH = this.motionFwHPrev;
      if (this.fullPelForward) {
        this.motionFwH <<= 1
      }
      code = this.readHuffman(MPEG1.MOTION);
      if (code !== 0 && this.forwardF !== 1) {
        r = this.bits.read(this.forwardRSize);
        d = (Math.abs(code) - 1 << this.forwardRSize) + r + 1;
        if (code < 0) {
          d = -d
        }
      } else {
        d = code
      }
      this.motionFwVPrev += d;
      if (this.motionFwVPrev > (this.forwardF << 4) - 1) {
        this.motionFwVPrev -= this.forwardF << 5
      } else if (this.motionFwVPrev < -this.forwardF << 4) {
        this.motionFwVPrev += this.forwardF << 5
      }
      this.motionFwV = this.motionFwVPrev;
      if (this.fullPelForward) {
        this.motionFwV <<= 1
      }
    } else if (this.pictureType === MPEG1.PICTURE_TYPE.PREDICTIVE) {
      this.motionFwH = this.motionFwHPrev = 0;
      this.motionFwV = this.motionFwVPrev = 0
    }
  };
  MPEG1.prototype.copyMacroblock = function(motionH, motionV, sY, sCr, sCb) {
    var width, scan, H, V, oddH, oddV, src, dest, last;
    var dY = this.currentY32,
      dCb = this.currentCb32,
      dCr = this.currentCr32;
    width = this.codedWidth;
    scan = width - 16;
    H = motionH >> 1;
    V = motionV >> 1;
    oddH = (motionH & 1) === 1;
    oddV = (motionV & 1) === 1;
    src = ((this.mbRow << 4) + V) * width + (this.mbCol << 4) + H;
    dest = this.mbRow * width + this.mbCol << 2;
    last = dest + (width << 2);
    var x, y1, y2, y;
    if (oddH) {
      if (oddV) {
        while (dest < last) {
          y1 = sY[src] + sY[src + width];
          src++;
          for (x = 0; x < 4; x++) {
            y2 = sY[src] + sY[src + width];
            src++;
            y = y1 + y2 + 2 >> 2 & 255;
            y1 = sY[src] + sY[src + width];
            src++;
            y |= y1 + y2 + 2 << 6 & 65280;
            y2 = sY[src] + sY[src + width];
            src++;
            y |= y1 + y2 + 2 << 14 & 16711680;
            y1 = sY[src] + sY[src + width];
            src++;
            y |= y1 + y2 + 2 << 22 & 4278190080;
            dY[dest++] = y
          }
          dest += scan >> 2;
          src += scan - 1
        }
      } else {
        while (dest < last) {
          y1 = sY[src++];
          for (x = 0; x < 4; x++) {
            y2 = sY[src++];
            y = y1 + y2 + 1 >> 1 & 255;
            y1 = sY[src++];
            y |= y1 + y2 + 1 << 7 & 65280;
            y2 = sY[src++];
            y |= y1 + y2 + 1 << 15 & 16711680;
            y1 = sY[src++];
            y |= y1 + y2 + 1 << 23 & 4278190080;
            dY[dest++] = y
          }
          dest += scan >> 2;
          src += scan - 1
        }
      }
    } else {
      if (oddV) {
        while (dest < last) {
          for (x = 0; x < 4; x++) {
            y = sY[src] + sY[src + width] + 1 >> 1 & 255;
            src++;
            y |= sY[src] + sY[src + width] + 1 << 7 & 65280;
            src++;
            y |= sY[src] + sY[src + width] + 1 << 15 & 16711680;
            src++;
            y |= sY[src] + sY[src + width] + 1 << 23 & 4278190080;
            src++;
            dY[dest++] = y
          }
          dest += scan >> 2;
          src += scan
        }
      } else {
        while (dest < last) {
          for (x = 0; x < 4; x++) {
            y = sY[src];
            src++;
            y |= sY[src] << 8;
            src++;
            y |= sY[src] << 16;
            src++;
            y |= sY[src] << 24;
            src++;
            dY[dest++] = y
          }
          dest += scan >> 2;
          src += scan
        }
      }
    }
    width = this.halfWidth;
    scan = width - 8;
    H = motionH / 2 >> 1;
    V = motionV / 2 >> 1;
    oddH = (motionH / 2 & 1) === 1;
    oddV = (motionV / 2 & 1) === 1;
    src = ((this.mbRow << 3) + V) * width + (this.mbCol << 3) + H;
    dest = this.mbRow * width + this.mbCol << 1;
    last = dest + (width << 1);
    var cr1, cr2, cr, cb1, cb2, cb;
    if (oddH) {
      if (oddV) {
        while (dest < last) {
          cr1 = sCr[src] + sCr[src + width];
          cb1 = sCb[src] + sCb[src + width];
          src++;
          for (x = 0; x < 2; x++) {
            cr2 = sCr[src] + sCr[src + width];
            cb2 = sCb[src] + sCb[src + width];
            src++;
            cr = cr1 + cr2 + 2 >> 2 & 255;
            cb = cb1 + cb2 + 2 >> 2 & 255;
            cr1 = sCr[src] + sCr[src + width];
            cb1 = sCb[src] + sCb[src + width];
            src++;
            cr |= cr1 + cr2 + 2 << 6 & 65280;
            cb |= cb1 + cb2 + 2 << 6 & 65280;
            cr2 = sCr[src] + sCr[src + width];
            cb2 = sCb[src] + sCb[src + width];
            src++;
            cr |= cr1 + cr2 + 2 << 14 & 16711680;
            cb |= cb1 + cb2 + 2 << 14 & 16711680;
            cr1 = sCr[src] + sCr[src + width];
            cb1 = sCb[src] + sCb[src + width];
            src++;
            cr |= cr1 + cr2 + 2 << 22 & 4278190080;
            cb |= cb1 + cb2 + 2 << 22 & 4278190080;
            dCr[dest] = cr;
            dCb[dest] = cb;
            dest++
          }
          dest += scan >> 2;
          src += scan - 1
        }
      } else {
        while (dest < last) {
          cr1 = sCr[src];
          cb1 = sCb[src];
          src++;
          for (x = 0; x < 2; x++) {
            cr2 = sCr[src];
            cb2 = sCb[src++];
            cr = cr1 + cr2 + 1 >> 1 & 255;
            cb = cb1 + cb2 + 1 >> 1 & 255;
            cr1 = sCr[src];
            cb1 = sCb[src++];
            cr |= cr1 + cr2 + 1 << 7 & 65280;
            cb |= cb1 + cb2 + 1 << 7 & 65280;
            cr2 = sCr[src];
            cb2 = sCb[src++];
            cr |= cr1 + cr2 + 1 << 15 & 16711680;
            cb |= cb1 + cb2 + 1 << 15 & 16711680;
            cr1 = sCr[src];
            cb1 = sCb[src++];
            cr |= cr1 + cr2 + 1 << 23 & 4278190080;
            cb |= cb1 + cb2 + 1 << 23 & 4278190080;
            dCr[dest] = cr;
            dCb[dest] = cb;
            dest++
          }
          dest += scan >> 2;
          src += scan - 1
        }
      }
    } else {
      if (oddV) {
        while (dest < last) {
          for (x = 0; x < 2; x++) {
            cr = sCr[src] + sCr[src + width] + 1 >> 1 & 255;
            cb = sCb[src] + sCb[src + width] + 1 >> 1 & 255;
            src++;
            cr |= sCr[src] + sCr[src + width] + 1 << 7 & 65280;
            cb |= sCb[src] + sCb[src + width] + 1 << 7 & 65280;
            src++;
            cr |= sCr[src] + sCr[src + width] + 1 << 15 & 16711680;
            cb |= sCb[src] + sCb[src + width] + 1 << 15 & 16711680;
            src++;
            cr |= sCr[src] + sCr[src + width] + 1 << 23 & 4278190080;
            cb |= sCb[src] + sCb[src + width] + 1 << 23 & 4278190080;
            src++;
            dCr[dest] = cr;
            dCb[dest] = cb;
            dest++
          }
          dest += scan >> 2;
          src += scan
        }
      } else {
        while (dest < last) {
          for (x = 0; x < 2; x++) {
            cr = sCr[src];
            cb = sCb[src];
            src++;
            cr |= sCr[src] << 8;
            cb |= sCb[src] << 8;
            src++;
            cr |= sCr[src] << 16;
            cb |= sCb[src] << 16;
            src++;
            cr |= sCr[src] << 24;
            cb |= sCb[src] << 24;
            src++;
            dCr[dest] = cr;
            dCb[dest] = cb;
            dest++
          }
          dest += scan >> 2;
          src += scan
        }
      }
    }
  };
  MPEG1.prototype.dcPredictorY = 0;
  MPEG1.prototype.dcPredictorCr = 0;
  MPEG1.prototype.dcPredictorCb = 0;
  MPEG1.prototype.blockData = null;
  MPEG1.prototype.decodeBlock = function(block) {
    var n = 0,
      quantMatrix;
    if (this.macroblockIntra) {
      var predictor, dctSize;
      if (block < 4) {
        predictor = this.dcPredictorY;
        dctSize = this.readHuffman(MPEG1.DCT_DC_SIZE_LUMINANCE)
      } else {
        predictor = block === 4 ? this.dcPredictorCr : this.dcPredictorCb;
        dctSize = this.readHuffman(MPEG1.DCT_DC_SIZE_CHROMINANCE)
      }
      if (dctSize > 0) {
        var differential = this.bits.read(dctSize);
        if ((differential & 1 << dctSize - 1) !== 0) {
          this.blockData[0] = predictor + differential
        } else {
          this.blockData[0] = predictor + (-1 << dctSize | differential + 1)
        }
      } else {
        this.blockData[0] = predictor
      }
      if (block < 4) {
        this.dcPredictorY = this.blockData[0]
      } else if (block === 4) {
        this.dcPredictorCr = this.blockData[0]
      } else {
        this.dcPredictorCb = this.blockData[0]
      }
      this.blockData[0] <<= 3 + 5;
      quantMatrix = this.intraQuantMatrix;
      n = 1
    } else {
      quantMatrix = this.nonIntraQuantMatrix
    }
    var level = 0;
    while (true) {
      var run = 0,
        coeff = this.readHuffman(MPEG1.DCT_COEFF);
      if (coeff === 1 && n > 0 && this.bits.read(1) === 0) {
        break
      }
      if (coeff === 65535) {
        run = this.bits.read(6);
        level = this.bits.read(8);
        if (level === 0) {
          level = this.bits.read(8)
        } else if (level === 128) {
          level = this.bits.read(8) - 256
        } else if (level > 128) {
          level = level - 256
        }
      } else {
        run = coeff >> 8;
        level = coeff & 255;
        if (this.bits.read(1)) {
          level = -level
        }
      }
      n += run;
      var dezigZagged = MPEG1.ZIG_ZAG[n];
      n++;
      level <<= 1;
      if (!this.macroblockIntra) {
        level += level < 0 ? -1 : 1
      }
      level = level * this.quantizerScale * quantMatrix[dezigZagged] >> 4;
      if ((level & 1) === 0) {
        level -= level > 0 ? 1 : -1
      }
      if (level > 2047) {
        level = 2047
      } else if (level < -2048) {
        level = -2048
      }
      this.blockData[dezigZagged] = level * MPEG1.PREMULTIPLIER_MATRIX[dezigZagged]
    }
    var destArray, destIndex, scan;
    if (block < 4) {
      destArray = this.currentY;
      scan = this.codedWidth - 8;
      destIndex = this.mbRow * this.codedWidth + this.mbCol << 4;
      if ((block & 1) !== 0) {
        destIndex += 8
      }
      if ((block & 2) !== 0) {
        destIndex += this.codedWidth << 3
      }
    } else {
      destArray = block === 4 ? this.currentCb : this.currentCr;
      scan = (this.codedWidth >> 1) - 8;
      destIndex = (this.mbRow * this.codedWidth << 2) + (this.mbCol << 3)
    }
    if (this.macroblockIntra) {
      if (n === 1) {
        MPEG1.CopyValueToDestination(this.blockData[0] + 128 >> 8, destArray, destIndex, scan);
        this.blockData[0] = 0
      } else {
        MPEG1.IDCT(this.blockData);
        MPEG1.CopyBlockToDestination(this.blockData, destArray, destIndex, scan);
        JSMpeg.Fill(this.blockData, 0)
      }
    } else {
      if (n === 1) {
        MPEG1.AddValueToDestination(this.blockData[0] + 128 >> 8, destArray, destIndex, scan);
        this.blockData[0] = 0
      } else {
        MPEG1.IDCT(this.blockData);
        MPEG1.AddBlockToDestination(this.blockData, destArray, destIndex, scan);
        JSMpeg.Fill(this.blockData, 0)
      }
    }
    n = 0
  };
  MPEG1.CopyBlockToDestination = function(block, dest, index, scan) {
    for (var n = 0; n < 64; n += 8, index += scan + 8) {
      dest[index + 0] = block[n + 0];
      dest[index + 1] = block[n + 1];
      dest[index + 2] = block[n + 2];
      dest[index + 3] = block[n + 3];
      dest[index + 4] = block[n + 4];
      dest[index + 5] = block[n + 5];
      dest[index + 6] = block[n + 6];
      dest[index + 7] = block[n + 7]
    }
  };
  MPEG1.AddBlockToDestination = function(block, dest, index, scan) {
    for (var n = 0; n < 64; n += 8, index += scan + 8) {
      dest[index + 0] += block[n + 0];
      dest[index + 1] += block[n + 1];
      dest[index + 2] += block[n + 2];
      dest[index + 3] += block[n + 3];
      dest[index + 4] += block[n + 4];
      dest[index + 5] += block[n + 5];
      dest[index + 6] += block[n + 6];
      dest[index + 7] += block[n + 7]
    }
  };
  MPEG1.CopyValueToDestination = function(value, dest, index, scan) {
    for (var n = 0; n < 64; n += 8, index += scan + 8) {
      dest[index + 0] = value;
      dest[index + 1] = value;
      dest[index + 2] = value;
      dest[index + 3] = value;
      dest[index + 4] = value;
      dest[index + 5] = value;
      dest[index + 6] = value;
      dest[index + 7] = value
    }
  };
  MPEG1.AddValueToDestination = function(value, dest, index, scan) {
    for (var n = 0; n < 64; n += 8, index += scan + 8) {
      dest[index + 0] += value;
      dest[index + 1] += value;
      dest[index + 2] += value;
      dest[index + 3] += value;
      dest[index + 4] += value;
      dest[index + 5] += value;
      dest[index + 6] += value;
      dest[index + 7] += value
    }
  };
  MPEG1.IDCT = function(block) {
    var b1, b3, b4, b6, b7, tmp1, tmp2, m0, x0, x1, x2, x3, x4, y3, y4, y5, y6, y7;
    for (var i = 0; i < 8; ++i) {
      b1 = block[4 * 8 + i];
      b3 = block[2 * 8 + i] + block[6 * 8 + i];
      b4 = block[5 * 8 + i] - block[3 * 8 + i];
      tmp1 = block[1 * 8 + i] + block[7 * 8 + i];
      tmp2 = block[3 * 8 + i] + block[5 * 8 + i];
      b6 = block[1 * 8 + i] - block[7 * 8 + i];
      b7 = tmp1 + tmp2;
      m0 = block[0 * 8 + i];
      x4 = (b6 * 473 - b4 * 196 + 128 >> 8) - b7;
      x0 = x4 - ((tmp1 - tmp2) * 362 + 128 >> 8);
      x1 = m0 - b1;
      x2 = ((block[2 * 8 + i] - block[6 * 8 + i]) * 362 + 128 >> 8) - b3;
      x3 = m0 + b1;
      y3 = x1 + x2;
      y4 = x3 + b3;
      y5 = x1 - x2;
      y6 = x3 - b3;
      y7 = -x0 - (b4 * 473 + b6 * 196 + 128 >> 8);
      block[0 * 8 + i] = b7 + y4;
      block[1 * 8 + i] = x4 + y3;
      block[2 * 8 + i] = y5 - x0;
      block[3 * 8 + i] = y6 - y7;
      block[4 * 8 + i] = y6 + y7;
      block[5 * 8 + i] = x0 + y5;
      block[6 * 8 + i] = y3 - x4;
      block[7 * 8 + i] = y4 - b7
    }
    for (var i = 0; i < 64; i += 8) {
      b1 = block[4 + i];
      b3 = block[2 + i] + block[6 + i];
      b4 = block[5 + i] - block[3 + i];
      tmp1 = block[1 + i] + block[7 + i];
      tmp2 = block[3 + i] + block[5 + i];
      b6 = block[1 + i] - block[7 + i];
      b7 = tmp1 + tmp2;
      m0 = block[0 + i];
      x4 = (b6 * 473 - b4 * 196 + 128 >> 8) - b7;
      x0 = x4 - ((tmp1 - tmp2) * 362 + 128 >> 8);
      x1 = m0 - b1;
      x2 = ((block[2 + i] - block[6 + i]) * 362 + 128 >> 8) - b3;
      x3 = m0 + b1;
      y3 = x1 + x2;
      y4 = x3 + b3;
      y5 = x1 - x2;
      y6 = x3 - b3;
      y7 = -x0 - (b4 * 473 + b6 * 196 + 128 >> 8);
      block[0 + i] = b7 + y4 + 128 >> 8;
      block[1 + i] = x4 + y3 + 128 >> 8;
      block[2 + i] = y5 - x0 + 128 >> 8;
      block[3 + i] = y6 - y7 + 128 >> 8;
      block[4 + i] = y6 + y7 + 128 >> 8;
      block[5 + i] = x0 + y5 + 128 >> 8;
      block[6 + i] = y3 - x4 + 128 >> 8;
      block[7 + i] = y4 - b7 + 128 >> 8
    }
  };
  MPEG1.PICTURE_RATE = [0, 23.976, 24, 25, 29.97, 30, 50, 59.94, 60, 0, 0, 0, 0, 0, 0, 0];
  MPEG1.ZIG_ZAG = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);
  MPEG1.DEFAULT_INTRA_QUANT_MATRIX = new Uint8Array([8, 16, 19, 22, 26, 27, 29, 34, 16, 16, 22, 24, 27, 29, 34, 37, 19, 22, 26, 27, 29, 34, 34, 38, 22, 22, 26, 27, 29, 34, 37, 40, 22, 26, 27, 29, 32, 35, 40, 48, 26, 27, 29, 32, 35, 40, 48, 58, 26, 27, 29, 34, 38, 46, 56, 69, 27, 29, 35, 38, 46, 56, 69, 83]);
  MPEG1.DEFAULT_NON_INTRA_QUANT_MATRIX = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16]);
  MPEG1.PREMULTIPLIER_MATRIX = new Uint8Array([32, 44, 42, 38, 32, 25, 17, 9, 44, 62, 58, 52, 44, 35, 24, 12, 42, 58, 55, 49, 42, 33, 23, 12, 38, 52, 49, 44, 38, 30, 20, 10, 32, 44, 42, 38, 32, 25, 17, 9, 25, 35, 33, 30, 25, 20, 14, 7, 17, 24, 23, 20, 17, 14, 9, 5, 9, 12, 12, 10, 9, 7, 5, 2]);
  MPEG1.MACROBLOCK_ADDRESS_INCREMENT = new Int16Array([1 * 3, 2 * 3, 0, 3 * 3, 4 * 3, 0, 0, 0, 1, 5 * 3, 6 * 3, 0, 7 * 3, 8 * 3, 0, 9 * 3, 10 * 3, 0, 11 * 3, 12 * 3, 0, 0, 0, 3, 0, 0, 2, 13 * 3, 14 * 3, 0, 15 * 3, 16 * 3, 0, 0, 0, 5, 0, 0, 4, 17 * 3, 18 * 3, 0, 19 * 3, 20 * 3, 0, 0, 0, 7, 0, 0, 6, 21 * 3, 22 * 3, 0, 23 * 3, 24 * 3, 0, 25 * 3, 26 * 3, 0, 27 * 3, 28 * 3, 0, -1, 29 * 3, 0, -1, 30 * 3, 0, 31 * 3, 32 * 3, 0, 33 * 3, 34 * 3, 0, 35 * 3, 36 * 3, 0, 37 * 3, 38 * 3, 0, 0, 0, 9, 0, 0, 8, 39 * 3, 40 * 3, 0, 41 * 3, 42 * 3, 0, 43 * 3, 44 * 3, 0, 45 * 3, 46 * 3, 0, 0, 0, 15, 0, 0, 14, 0, 0, 13, 0, 0, 12, 0, 0, 11, 0, 0, 10, 47 * 3, -1, 0, -1, 48 * 3, 0, 49 * 3, 50 * 3, 0, 51 * 3, 52 * 3, 0, 53 * 3, 54 * 3, 0, 55 * 3, 56 * 3, 0, 57 * 3, 58 * 3, 0, 59 * 3, 60 * 3, 0, 61 * 3, -1, 0, -1, 62 * 3, 0, 63 * 3, 64 * 3, 0, 65 * 3, 66 * 3, 0, 67 * 3, 68 * 3, 0, 69 * 3, 70 * 3, 0, 71 * 3, 72 * 3, 0, 73 * 3, 74 * 3, 0, 0, 0, 21, 0, 0, 20, 0, 0, 19, 0, 0, 18, 0, 0, 17, 0, 0, 16, 0, 0, 35, 0, 0, 34, 0, 0, 33, 0, 0, 32, 0, 0, 31, 0, 0, 30, 0, 0, 29, 0, 0, 28, 0, 0, 27, 0, 0, 26, 0, 0, 25, 0, 0, 24, 0, 0, 23, 0, 0, 22]);
  MPEG1.MACROBLOCK_TYPE_INTRA = new Int8Array([1 * 3, 2 * 3, 0, -1, 3 * 3, 0, 0, 0, 1, 0, 0, 17]);
  MPEG1.MACROBLOCK_TYPE_PREDICTIVE = new Int8Array([1 * 3, 2 * 3, 0, 3 * 3, 4 * 3, 0, 0, 0, 10, 5 * 3, 6 * 3, 0, 0, 0, 2, 7 * 3, 8 * 3, 0, 0, 0, 8, 9 * 3, 10 * 3, 0, 11 * 3, 12 * 3, 0, -1, 13 * 3, 0, 0, 0, 18, 0, 0, 26, 0, 0, 1, 0, 0, 17]);
  MPEG1.MACROBLOCK_TYPE_B = new Int8Array([1 * 3, 2 * 3, 0, 3 * 3, 5 * 3, 0, 4 * 3, 6 * 3, 0, 8 * 3, 7 * 3, 0, 0, 0, 12, 9 * 3, 10 * 3, 0, 0, 0, 14, 13 * 3, 14 * 3, 0, 12 * 3, 11 * 3, 0, 0, 0, 4, 0, 0, 6, 18 * 3, 16 * 3, 0, 15 * 3, 17 * 3, 0, 0, 0, 8, 0, 0, 10, -1, 19 * 3, 0, 0, 0, 1, 20 * 3, 21 * 3, 0, 0, 0, 30, 0, 0, 17, 0, 0, 22, 0, 0, 26]);
  MPEG1.MACROBLOCK_TYPE = [null, MPEG1.MACROBLOCK_TYPE_INTRA, MPEG1.MACROBLOCK_TYPE_PREDICTIVE, MPEG1.MACROBLOCK_TYPE_B];
  MPEG1.CODE_BLOCK_PATTERN = new Int16Array([2 * 3, 1 * 3, 0, 3 * 3, 6 * 3, 0, 4 * 3, 5 * 3, 0, 8 * 3, 11 * 3, 0, 12 * 3, 13 * 3, 0, 9 * 3, 7 * 3, 0, 10 * 3, 14 * 3, 0, 20 * 3, 19 * 3, 0, 18 * 3, 16 * 3, 0, 23 * 3, 17 * 3, 0, 27 * 3, 25 * 3, 0, 21 * 3, 28 * 3, 0, 15 * 3, 22 * 3, 0, 24 * 3, 26 * 3, 0, 0, 0, 60, 35 * 3, 40 * 3, 0, 44 * 3, 48 * 3, 0, 38 * 3, 36 * 3, 0, 42 * 3, 47 * 3, 0, 29 * 3, 31 * 3, 0, 39 * 3, 32 * 3, 0, 0, 0, 32, 45 * 3, 46 * 3, 0, 33 * 3, 41 * 3, 0, 43 * 3, 34 * 3, 0, 0, 0, 4, 30 * 3, 37 * 3, 0, 0, 0, 8, 0, 0, 16, 0, 0, 44, 50 * 3, 56 * 3, 0, 0, 0, 28, 0, 0, 52, 0, 0, 62, 61 * 3, 59 * 3, 0, 52 * 3, 60 * 3, 0, 0, 0, 1, 55 * 3, 54 * 3, 0, 0, 0, 61, 0, 0, 56, 57 * 3, 58 * 3, 0, 0, 0, 2, 0, 0, 40, 51 * 3, 62 * 3, 0, 0, 0, 48, 64 * 3, 63 * 3, 0, 49 * 3, 53 * 3, 0, 0, 0, 20, 0, 0, 12, 80 * 3, 83 * 3, 0, 0, 0, 63, 77 * 3, 75 * 3, 0, 65 * 3, 73 * 3, 0, 84 * 3, 66 * 3, 0, 0, 0, 24, 0, 0, 36, 0, 0, 3, 69 * 3, 87 * 3, 0, 81 * 3, 79 * 3, 0, 68 * 3, 71 * 3, 0, 70 * 3, 78 * 3, 0, 67 * 3, 76 * 3, 0, 72 * 3, 74 * 3, 0, 86 * 3, 85 * 3, 0, 88 * 3, 82 * 3, 0, -1, 94 * 3, 0, 95 * 3, 97 * 3, 0, 0, 0, 33, 0, 0, 9, 106 * 3, 110 * 3, 0, 102 * 3, 116 * 3, 0, 0, 0, 5, 0, 0, 10, 93 * 3, 89 * 3, 0, 0, 0, 6, 0, 0, 18, 0, 0, 17, 0, 0, 34, 113 * 3, 119 * 3, 0, 103 * 3, 104 * 3, 0, 90 * 3, 92 * 3, 0, 109 * 3, 107 * 3, 0, 117 * 3, 118 * 3, 0, 101 * 3, 99 * 3, 0, 98 * 3, 96 * 3, 0, 100 * 3, 91 * 3, 0, 114 * 3, 115 * 3, 0, 105 * 3, 108 * 3, 0, 112 * 3, 111 * 3, 0, 121 * 3, 125 * 3, 0, 0, 0, 41, 0, 0, 14, 0, 0, 21, 124 * 3, 122 * 3, 0, 120 * 3, 123 * 3, 0, 0, 0, 11, 0, 0, 19, 0, 0, 7, 0, 0, 35, 0, 0, 13, 0, 0, 50, 0, 0, 49, 0, 0, 58, 0, 0, 37, 0, 0, 25, 0, 0, 45, 0, 0, 57, 0, 0, 26, 0, 0, 29, 0, 0, 38, 0, 0, 53, 0, 0, 23, 0, 0, 43, 0, 0, 46, 0, 0, 42, 0, 0, 22, 0, 0, 54, 0, 0, 51, 0, 0, 15, 0, 0, 30, 0, 0, 39, 0, 0, 47, 0, 0, 55, 0, 0, 27, 0, 0, 59, 0, 0, 31]);
  MPEG1.MOTION = new Int16Array([1 * 3, 2 * 3, 0, 4 * 3, 3 * 3, 0, 0, 0, 0, 6 * 3, 5 * 3, 0, 8 * 3, 7 * 3, 0, 0, 0, -1, 0, 0, 1, 9 * 3, 10 * 3, 0, 12 * 3, 11 * 3, 0, 0, 0, 2, 0, 0, -2, 14 * 3, 15 * 3, 0, 16 * 3, 13 * 3, 0, 20 * 3, 18 * 3, 0, 0, 0, 3, 0, 0, -3, 17 * 3, 19 * 3, 0, -1, 23 * 3, 0, 27 * 3, 25 * 3, 0, 26 * 3, 21 * 3, 0, 24 * 3, 22 * 3, 0, 32 * 3, 28 * 3, 0, 29 * 3, 31 * 3, 0, -1, 33 * 3, 0, 36 * 3, 35 * 3, 0, 0, 0, -4, 30 * 3, 34 * 3, 0, 0, 0, 4, 0, 0, -7, 0, 0, 5, 37 * 3, 41 * 3, 0, 0, 0, -5, 0, 0, 7, 38 * 3, 40 * 3, 0, 42 * 3, 39 * 3, 0, 0, 0, -6, 0, 0, 6, 51 * 3, 54 * 3, 0, 50 * 3, 49 * 3, 0, 45 * 3, 46 * 3, 0, 52 * 3, 47 * 3, 0, 43 * 3, 53 * 3, 0, 44 * 3, 48 * 3, 0, 0, 0, 10, 0, 0, 9, 0, 0, 8, 0, 0, -8, 57 * 3, 66 * 3, 0, 0, 0, -9, 60 * 3, 64 * 3, 0, 56 * 3, 61 * 3, 0, 55 * 3, 62 * 3, 0, 58 * 3, 63 * 3, 0, 0, 0, -10, 59 * 3, 65 * 3, 0, 0, 0, 12, 0, 0, 16, 0, 0, 13, 0, 0, 14, 0, 0, 11, 0, 0, 15, 0, 0, -16, 0, 0, -12, 0, 0, -14, 0, 0, -15, 0, 0, -11, 0, 0, -13]);
  MPEG1.DCT_DC_SIZE_LUMINANCE = new Int8Array([2 * 3, 1 * 3, 0, 6 * 3, 5 * 3, 0, 3 * 3, 4 * 3, 0, 0, 0, 1, 0, 0, 2, 9 * 3, 8 * 3, 0, 7 * 3, 10 * 3, 0, 0, 0, 0, 12 * 3, 11 * 3, 0, 0, 0, 4, 0, 0, 3, 13 * 3, 14 * 3, 0, 0, 0, 5, 0, 0, 6, 16 * 3, 15 * 3, 0, 17 * 3, -1, 0, 0, 0, 7, 0, 0, 8]);
  MPEG1.DCT_DC_SIZE_CHROMINANCE = new Int8Array([2 * 3, 1 * 3, 0, 4 * 3, 3 * 3, 0, 6 * 3, 5 * 3, 0, 8 * 3, 7 * 3, 0, 0, 0, 2, 0, 0, 1, 0, 0, 0, 10 * 3, 9 * 3, 0, 0, 0, 3, 12 * 3, 11 * 3, 0, 0, 0, 4, 14 * 3, 13 * 3, 0, 0, 0, 5, 16 * 3, 15 * 3, 0, 0, 0, 6, 17 * 3, -1, 0, 0, 0, 7, 0, 0, 8]);
  MPEG1.DCT_COEFF = new Int32Array([1 * 3, 2 * 3, 0, 4 * 3, 3 * 3, 0, 0, 0, 1, 7 * 3, 8 * 3, 0, 6 * 3, 5 * 3, 0, 13 * 3, 9 * 3, 0, 11 * 3, 10 * 3, 0, 14 * 3, 12 * 3, 0, 0, 0, 257, 20 * 3, 22 * 3, 0, 18 * 3, 21 * 3, 0, 16 * 3, 19 * 3, 0, 0, 0, 513, 17 * 3, 15 * 3, 0, 0, 0, 2, 0, 0, 3, 27 * 3, 25 * 3, 0, 29 * 3, 31 * 3, 0, 24 * 3, 26 * 3, 0, 32 * 3, 30 * 3, 0, 0, 0, 1025, 23 * 3, 28 * 3, 0, 0, 0, 769, 0, 0, 258, 0, 0, 1793, 0, 0, 65535, 0, 0, 1537, 37 * 3, 36 * 3, 0, 0, 0, 1281, 35 * 3, 34 * 3, 0, 39 * 3, 38 * 3, 0, 33 * 3, 42 * 3, 0, 40 * 3, 41 * 3, 0, 52 * 3, 50 * 3, 0, 54 * 3, 53 * 3, 0, 48 * 3, 49 * 3, 0, 43 * 3, 45 * 3, 0, 46 * 3, 44 * 3, 0, 0, 0, 2049, 0, 0, 4, 0, 0, 514, 0, 0, 2305, 51 * 3, 47 * 3, 0, 55 * 3, 57 * 3, 0, 60 * 3, 56 * 3, 0, 59 * 3, 58 * 3, 0, 61 * 3, 62 * 3, 0, 0, 0, 2561, 0, 0, 3329, 0, 0, 6, 0, 0, 259, 0, 0, 5, 0, 0, 770, 0, 0, 2817, 0, 0, 3073, 76 * 3, 75 * 3, 0, 67 * 3, 70 * 3, 0, 73 * 3, 71 * 3, 0, 78 * 3, 74 * 3, 0, 72 * 3, 77 * 3, 0, 69 * 3, 64 * 3, 0, 68 * 3, 63 * 3, 0, 66 * 3, 65 * 3, 0, 81 * 3, 87 * 3, 0, 91 * 3, 80 * 3, 0, 82 * 3, 79 * 3, 0, 83 * 3, 86 * 3, 0, 93 * 3, 92 * 3, 0, 84 * 3, 85 * 3, 0, 90 * 3, 94 * 3, 0, 88 * 3, 89 * 3, 0, 0, 0, 515, 0, 0, 260, 0, 0, 7, 0, 0, 1026, 0, 0, 1282, 0, 0, 4097, 0, 0, 3841, 0, 0, 3585, 105 * 3, 107 * 3, 0, 111 * 3, 114 * 3, 0, 104 * 3, 97 * 3, 0, 125 * 3, 119 * 3, 0, 96 * 3, 98 * 3, 0, -1, 123 * 3, 0, 95 * 3, 101 * 3, 0, 106 * 3, 121 * 3, 0, 99 * 3, 102 * 3, 0, 113 * 3, 103 * 3, 0, 112 * 3, 116 * 3, 0, 110 * 3, 100 * 3, 0, 124 * 3, 115 * 3, 0, 117 * 3, 122 * 3, 0, 109 * 3, 118 * 3, 0, 120 * 3, 108 * 3, 0, 127 * 3, 136 * 3, 0, 139 * 3, 140 * 3, 0, 130 * 3, 126 * 3, 0, 145 * 3, 146 * 3, 0, 128 * 3, 129 * 3, 0, 0, 0, 2050, 132 * 3, 134 * 3, 0, 155 * 3, 154 * 3, 0, 0, 0, 8, 137 * 3, 133 * 3, 0, 143 * 3, 144 * 3, 0, 151 * 3, 138 * 3, 0, 142 * 3, 141 * 3, 0, 0, 0, 10, 0, 0, 9, 0, 0, 11, 0, 0, 5377, 0, 0, 1538, 0, 0, 771, 0, 0, 5121, 0, 0, 1794, 0, 0, 4353, 0, 0, 4609, 0, 0, 4865, 148 * 3, 152 * 3, 0, 0, 0, 1027, 153 * 3, 150 * 3, 0, 0, 0, 261, 131 * 3, 135 * 3, 0, 0, 0, 516, 149 * 3, 147 * 3, 0, 172 * 3, 173 * 3, 0, 162 * 3, 158 * 3, 0, 170 * 3, 161 * 3, 0, 168 * 3, 166 * 3, 0, 157 * 3, 179 * 3, 0, 169 * 3, 167 * 3, 0, 174 * 3, 171 * 3, 0, 178 * 3, 177 * 3, 0, 156 * 3, 159 * 3, 0, 164 * 3, 165 * 3, 0, 183 * 3, 182 * 3, 0, 175 * 3, 176 * 3, 0, 0, 0, 263, 0, 0, 2562, 0, 0, 2306, 0, 0, 5633, 0, 0, 5889, 0, 0, 6401, 0, 0, 6145, 0, 0, 1283, 0, 0, 772, 0, 0, 13, 0, 0, 12, 0, 0, 14, 0, 0, 15, 0, 0, 517, 0, 0, 6657, 0, 0, 262, 180 * 3, 181 * 3, 0, 160 * 3, 163 * 3, 0, 196 * 3, 199 * 3, 0, 0, 0, 27, 203 * 3, 185 * 3, 0, 202 * 3, 201 * 3, 0, 0, 0, 19, 0, 0, 22, 197 * 3, 207 * 3, 0, 0, 0, 18, 191 * 3, 192 * 3, 0, 188 * 3, 190 * 3, 0, 0, 0, 20, 184 * 3, 194 * 3, 0, 0, 0, 21, 186 * 3, 193 * 3, 0, 0, 0, 23, 204 * 3, 198 * 3, 0, 0, 0, 25, 0, 0, 24, 200 * 3, 205 * 3, 0, 0, 0, 31, 0, 0, 30, 0, 0, 28, 0, 0, 29, 0, 0, 26, 0, 0, 17, 0, 0, 16, 189 * 3, 206 * 3, 0, 187 * 3, 195 * 3, 0, 218 * 3, 211 * 3, 0, 0, 0, 37, 215 * 3, 216 * 3, 0, 0, 0, 36, 210 * 3, 212 * 3, 0, 0, 0, 34, 213 * 3, 209 * 3, 0, 221 * 3, 222 * 3, 0, 219 * 3, 208 * 3, 0, 217 * 3, 214 * 3, 0, 223 * 3, 220 * 3, 0, 0, 0, 35, 0, 0, 267, 0, 0, 40, 0, 0, 268, 0, 0, 266, 0, 0, 32, 0, 0, 264, 0, 0, 265, 0, 0, 38, 0, 0, 269, 0, 0, 270, 0, 0, 33, 0, 0, 39, 0, 0, 7937, 0, 0, 6913, 0, 0, 7681, 0, 0, 4098, 0, 0, 7425, 0, 0, 7169, 0, 0, 271, 0, 0, 274, 0, 0, 273, 0, 0, 272, 0, 0, 1539, 0, 0, 2818, 0, 0, 3586, 0, 0, 3330, 0, 0, 3074, 0, 0, 3842]);
  MPEG1.PICTURE_TYPE = {
    INTRA: 1,
    PREDICTIVE: 2,
    B: 3
  };
  MPEG1.START = {
    SEQUENCE: 179,
    SLICE_FIRST: 1,
    SLICE_LAST: 175,
    PICTURE: 0,
    EXTENSION: 181,
    USER_DATA: 178
  };
  return MPEG1
}();
JSMpeg.Decoder.MP2Audio = function() {
  "use strict";
  var MP2 = function(options) {
    JSMpeg.Decoder.Base.call(this, options);
    var bufferSize = options.audioBufferSize || 128 * 1024;
    var bufferMode = options.streaming ? JSMpeg.BitBuffer.MODE.EVICT : JSMpeg.BitBuffer.MODE.EXPAND;
    this.bits = new JSMpeg.BitBuffer(bufferSize, bufferMode);
    this.left = new Float32Array(1152);
    this.right = new Float32Array(1152);
    this.sampleRate = 44100;
    this.D = new Float32Array(1024);
    this.D.set(MP2.SYNTHESIS_WINDOW, 0);
    this.D.set(MP2.SYNTHESIS_WINDOW, 512);
    this.V = new Float32Array(1024);
    this.U = new Int32Array(32);
    this.VPos = 0;
    this.allocation = [new Array(32), new Array(32)];
    this.scaleFactorInfo = [new Uint8Array(32), new Uint8Array(32)];
    this.scaleFactor = [new Array(32), new Array(32)];
    this.sample = [new Array(32), new Array(32)];
    for (var j = 0; j < 2; j++) {
      for (var i = 0; i < 32; i++) {
        this.scaleFactor[j][i] = [0, 0, 0];
        this.sample[j][i] = [0, 0, 0]
      }
    }
  };
  MP2.prototype = Object.create(JSMpeg.Decoder.Base.prototype);
  MP2.prototype.constructor = MP2;
  MP2.prototype.decode = function() {
    var pos = this.bits.index >> 3;
    if (pos >= this.bits.byteLength) {
      return false
    }
    var decoded = this.decodeFrame(this.left, this.right);
    this.bits.index = pos + decoded << 3;
    if (!decoded) {
      return false
    }
    if (this.destination) {
      this.destination.play(this.sampleRate, this.left, this.right)
    }
    this.advanceDecodedTime(this.left.length / this.sampleRate);
    return true
  };
  MP2.prototype.getCurrentTime = function() {
    var enqueuedTime = this.destination ? this.destination.enqueuedTime : 0;
    return this.decodedTime - enqueuedTime
  };
  MP2.prototype.decodeFrame = function(left, right) {
    var sync = this.bits.read(11),
      version = this.bits.read(2),
      layer = this.bits.read(2),
      hasCRC = !this.bits.read(1);
    if (sync !== MP2.FRAME_SYNC || version !== MP2.VERSION.MPEG_1 || layer !== MP2.LAYER.II) {
      return 0
    }
    var bitrateIndex = this.bits.read(4) - 1;
    if (bitrateIndex > 13) {
      return 0
    }
    var sampleRateIndex = this.bits.read(2);
    var sampleRate = MP2.SAMPLE_RATE[sampleRateIndex];
    if (sampleRateIndex === 3) {
      return 0
    }
    if (version === MP2.VERSION.MPEG_2) {
      sampleRateIndex += 4;
      bitrateIndex += 14
    }
    var padding = this.bits.read(1),
      privat = this.bits.read(1),
      mode = this.bits.read(2);
    var bound = 0;
    if (mode === MP2.MODE.JOINT_STEREO) {
      bound = this.bits.read(2) + 1 << 2
    } else {
      this.bits.skip(2);
      bound = mode === MP2.MODE.MONO ? 0 : 32
    }
    this.bits.skip(4);
    if (hasCRC) {
      this.bits.skip(16)
    }
    var bitrate = MP2.BIT_RATE[bitrateIndex],
      sampleRate = MP2.SAMPLE_RATE[sampleRateIndex],
      frameSize = 144e3 * bitrate / sampleRate + padding | 0;
    var tab3 = 0;
    var sblimit = 0;
    if (version === MP2.VERSION.MPEG_2) {
      tab3 = 2;
      sblimit = 30
    } else {
      var tab1 = mode === MP2.MODE.MONO ? 0 : 1;
      var tab2 = MP2.QUANT_LUT_STEP_1[tab1][bitrateIndex];
      tab3 = MP2.QUANT_LUT_STEP_2[tab2][sampleRateIndex];
      sblimit = tab3 & 63;
      tab3 >>= 6
    }
    if (bound > sblimit) {
      bound = sblimit
    }
    for (var sb = 0; sb < bound; sb++) {
      this.allocation[0][sb] = this.readAllocation(sb, tab3);
      this.allocation[1][sb] = this.readAllocation(sb, tab3)
    }
    for (var sb = bound; sb < sblimit; sb++) {
      this.allocation[0][sb] = this.allocation[1][sb] = this.readAllocation(sb, tab3)
    }
    var channels = mode === MP2.MODE.MONO ? 1 : 2;
    for (var sb = 0; sb < sblimit; sb++) {
      for (ch = 0; ch < channels; ch++) {
        if (this.allocation[ch][sb]) {
          this.scaleFactorInfo[ch][sb] = this.bits.read(2)
        }
      }
      if (mode === MP2.MODE.MONO) {
        this.scaleFactorInfo[1][sb] = this.scaleFactorInfo[0][sb]
      }
    }
    for (var sb = 0; sb < sblimit; sb++) {
      for (var ch = 0; ch < channels; ch++) {
        if (this.allocation[ch][sb]) {
          var sf = this.scaleFactor[ch][sb];
          switch (this.scaleFactorInfo[ch][sb]) {
            case 0:
              sf[0] = this.bits.read(6);
              sf[1] = this.bits.read(6);
              sf[2] = this.bits.read(6);
              break;
            case 1:
              sf[0] = sf[1] = this.bits.read(6);
              sf[2] = this.bits.read(6);
              break;
            case 2:
              sf[0] = sf[1] = sf[2] = this.bits.read(6);
              break;
            case 3:
              sf[0] = this.bits.read(6);
              sf[1] = sf[2] = this.bits.read(6);
              break
          }
        }
      }
      if (mode === MP2.MODE.MONO) {
        this.scaleFactor[1][sb][0] = this.scaleFactor[0][sb][0];
        this.scaleFactor[1][sb][1] = this.scaleFactor[0][sb][1];
        this.scaleFactor[1][sb][2] = this.scaleFactor[0][sb][2]
      }
    }
    var outPos = 0;
    for (var part = 0; part < 3; part++) {
      for (var granule = 0; granule < 4; granule++) {
        for (var sb = 0; sb < bound; sb++) {
          this.readSamples(0, sb, part);
          this.readSamples(1, sb, part)
        }
        for (var sb = bound; sb < sblimit; sb++) {
          this.readSamples(0, sb, part);
          this.sample[1][sb][0] = this.sample[0][sb][0];
          this.sample[1][sb][1] = this.sample[0][sb][1];
          this.sample[1][sb][2] = this.sample[0][sb][2]
        }
        for (var sb = sblimit; sb < 32; sb++) {
          this.sample[0][sb][0] = 0;
          this.sample[0][sb][1] = 0;
          this.sample[0][sb][2] = 0;
          this.sample[1][sb][0] = 0;
          this.sample[1][sb][1] = 0;
          this.sample[1][sb][2] = 0
        }
        for (var p = 0; p < 3; p++) {
          this.VPos = this.VPos - 64 & 1023;
          for (var ch = 0; ch < 2; ch++) {
            MP2.MatrixTransform(this.sample[ch], p, this.V, this.VPos);
            JSMpeg.Fill(this.U, 0);
            var dIndex = 512 - (this.VPos >> 1);
            var vIndex = this.VPos % 128 >> 1;
            while (vIndex < 1024) {
              for (var i = 0; i < 32; ++i) {
                this.U[i] += this.D[dIndex++] * this.V[vIndex++]
              }
              vIndex += 128 - 32;
              dIndex += 64 - 32
            }
            vIndex = 128 - 32 + 1024 - vIndex;
            dIndex -= 512 - 32;
            while (vIndex < 1024) {
              for (var i = 0; i < 32; ++i) {
                this.U[i] += this.D[dIndex++] * this.V[vIndex++]
              }
              vIndex += 128 - 32;
              dIndex += 64 - 32
            }
            var outChannel = ch === 0 ? left : right;
            for (var j = 0; j < 32; j++) {
              outChannel[outPos + j] = this.U[j] / 2147418112
            }
          }
          outPos += 32
        }
      }
    }
    this.sampleRate = sampleRate;
    return frameSize
  };
  MP2.prototype.readAllocation = function(sb, tab3) {
    var tab4 = MP2.QUANT_LUT_STEP_3[tab3][sb];
    var qtab = MP2.QUANT_LUT_STEP4[tab4 & 15][this.bits.read(tab4 >> 4)];
    return qtab ? MP2.QUANT_TAB[qtab - 1] : 0
  };
  MP2.prototype.readSamples = function(ch, sb, part) {
    var q = this.allocation[ch][sb],
      sf = this.scaleFactor[ch][sb][part],
      sample = this.sample[ch][sb],
      val = 0;
    if (!q) {
      sample[0] = sample[1] = sample[2] = 0;
      return
    }
    if (sf === 63) {
      sf = 0
    } else {
      var shift = sf / 3 | 0;
      sf = MP2.SCALEFACTOR_BASE[sf % 3] + (1 << shift >> 1) >> shift
    }
    var adj = q.levels;
    if (q.group) {
      val = this.bits.read(q.bits);
      sample[0] = val % adj;
      val = val / adj | 0;
      sample[1] = val % adj;
      sample[2] = val / adj | 0
    } else {
      sample[0] = this.bits.read(q.bits);
      sample[1] = this.bits.read(q.bits);
      sample[2] = this.bits.read(q.bits)
    }
    var scale = 65536 / (adj + 1) | 0;
    adj = (adj + 1 >> 1) - 1;
    val = (adj - sample[0]) * scale;
    sample[0] = val * (sf >> 12) + (val * (sf & 4095) + 2048 >> 12) >> 12;
    val = (adj - sample[1]) * scale;
    sample[1] = val * (sf >> 12) + (val * (sf & 4095) + 2048 >> 12) >> 12;
    val = (adj - sample[2]) * scale;
    sample[2] = val * (sf >> 12) + (val * (sf & 4095) + 2048 >> 12) >> 12
  };
  MP2.MatrixTransform = function(s, ss, d, dp) {
    var t01, t02, t03, t04, t05, t06, t07, t08, t09, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29, t30, t31, t32, t33;
    t01 = s[0][ss] + s[31][ss];
    t02 = (s[0][ss] - s[31][ss]) * .500602998235;
    t03 = s[1][ss] + s[30][ss];
    t04 = (s[1][ss] - s[30][ss]) * .505470959898;
    t05 = s[2][ss] + s[29][ss];
    t06 = (s[2][ss] - s[29][ss]) * .515447309923;
    t07 = s[3][ss] + s[28][ss];
    t08 = (s[3][ss] - s[28][ss]) * .53104259109;
    t09 = s[4][ss] + s[27][ss];
    t10 = (s[4][ss] - s[27][ss]) * .553103896034;
    t11 = s[5][ss] + s[26][ss];
    t12 = (s[5][ss] - s[26][ss]) * .582934968206;
    t13 = s[6][ss] + s[25][ss];
    t14 = (s[6][ss] - s[25][ss]) * .622504123036;
    t15 = s[7][ss] + s[24][ss];
    t16 = (s[7][ss] - s[24][ss]) * .674808341455;
    t17 = s[8][ss] + s[23][ss];
    t18 = (s[8][ss] - s[23][ss]) * .744536271002;
    t19 = s[9][ss] + s[22][ss];
    t20 = (s[9][ss] - s[22][ss]) * .839349645416;
    t21 = s[10][ss] + s[21][ss];
    t22 = (s[10][ss] - s[21][ss]) * .972568237862;
    t23 = s[11][ss] + s[20][ss];
    t24 = (s[11][ss] - s[20][ss]) * 1.16943993343;
    t25 = s[12][ss] + s[19][ss];
    t26 = (s[12][ss] - s[19][ss]) * 1.48416461631;
    t27 = s[13][ss] + s[18][ss];
    t28 = (s[13][ss] - s[18][ss]) * 2.05778100995;
    t29 = s[14][ss] + s[17][ss];
    t30 = (s[14][ss] - s[17][ss]) * 3.40760841847;
    t31 = s[15][ss] + s[16][ss];
    t32 = (s[15][ss] - s[16][ss]) * 10.1900081235;
    t33 = t01 + t31;
    t31 = (t01 - t31) * .502419286188;
    t01 = t03 + t29;
    t29 = (t03 - t29) * .52249861494;
    t03 = t05 + t27;
    t27 = (t05 - t27) * .566944034816;
    t05 = t07 + t25;
    t25 = (t07 - t25) * .64682178336;
    t07 = t09 + t23;
    t23 = (t09 - t23) * .788154623451;
    t09 = t11 + t21;
    t21 = (t11 - t21) * 1.06067768599;
    t11 = t13 + t19;
    t19 = (t13 - t19) * 1.72244709824;
    t13 = t15 + t17;
    t17 = (t15 - t17) * 5.10114861869;
    t15 = t33 + t13;
    t13 = (t33 - t13) * .509795579104;
    t33 = t01 + t11;
    t01 = (t01 - t11) * .601344886935;
    t11 = t03 + t09;
    t09 = (t03 - t09) * .899976223136;
    t03 = t05 + t07;
    t07 = (t05 - t07) * 2.56291544774;
    t05 = t15 + t03;
    t15 = (t15 - t03) * .541196100146;
    t03 = t33 + t11;
    t11 = (t33 - t11) * 1.30656296488;
    t33 = t05 + t03;
    t05 = (t05 - t03) * .707106781187;
    t03 = t15 + t11;
    t15 = (t15 - t11) * .707106781187;
    t03 += t15;
    t11 = t13 + t07;
    t13 = (t13 - t07) * .541196100146;
    t07 = t01 + t09;
    t09 = (t01 - t09) * 1.30656296488;
    t01 = t11 + t07;
    t07 = (t11 - t07) * .707106781187;
    t11 = t13 + t09;
    t13 = (t13 - t09) * .707106781187;
    t11 += t13;
    t01 += t11;
    t11 += t07;
    t07 += t13;
    t09 = t31 + t17;
    t31 = (t31 - t17) * .509795579104;
    t17 = t29 + t19;
    t29 = (t29 - t19) * .601344886935;
    t19 = t27 + t21;
    t21 = (t27 - t21) * .899976223136;
    t27 = t25 + t23;
    t23 = (t25 - t23) * 2.56291544774;
    t25 = t09 + t27;
    t09 = (t09 - t27) * .541196100146;
    t27 = t17 + t19;
    t19 = (t17 - t19) * 1.30656296488;
    t17 = t25 + t27;
    t27 = (t25 - t27) * .707106781187;
    t25 = t09 + t19;
    t19 = (t09 - t19) * .707106781187;
    t25 += t19;
    t09 = t31 + t23;
    t31 = (t31 - t23) * .541196100146;
    t23 = t29 + t21;
    t21 = (t29 - t21) * 1.30656296488;
    t29 = t09 + t23;
    t23 = (t09 - t23) * .707106781187;
    t09 = t31 + t21;
    t31 = (t31 - t21) * .707106781187;
    t09 += t31;
    t29 += t09;
    t09 += t23;
    t23 += t31;
    t17 += t29;
    t29 += t25;
    t25 += t09;
    t09 += t27;
    t27 += t23;
    t23 += t19;
    t19 += t31;
    t21 = t02 + t32;
    t02 = (t02 - t32) * .502419286188;
    t32 = t04 + t30;
    t04 = (t04 - t30) * .52249861494;
    t30 = t06 + t28;
    t28 = (t06 - t28) * .566944034816;
    t06 = t08 + t26;
    t08 = (t08 - t26) * .64682178336;
    t26 = t10 + t24;
    t10 = (t10 - t24) * .788154623451;
    t24 = t12 + t22;
    t22 = (t12 - t22) * 1.06067768599;
    t12 = t14 + t20;
    t20 = (t14 - t20) * 1.72244709824;
    t14 = t16 + t18;
    t16 = (t16 - t18) * 5.10114861869;
    t18 = t21 + t14;
    t14 = (t21 - t14) * .509795579104;
    t21 = t32 + t12;
    t32 = (t32 - t12) * .601344886935;
    t12 = t30 + t24;
    t24 = (t30 - t24) * .899976223136;
    t30 = t06 + t26;
    t26 = (t06 - t26) * 2.56291544774;
    t06 = t18 + t30;
    t18 = (t18 - t30) * .541196100146;
    t30 = t21 + t12;
    t12 = (t21 - t12) * 1.30656296488;
    t21 = t06 + t30;
    t30 = (t06 - t30) * .707106781187;
    t06 = t18 + t12;
    t12 = (t18 - t12) * .707106781187;
    t06 += t12;
    t18 = t14 + t26;
    t26 = (t14 - t26) * .541196100146;
    t14 = t32 + t24;
    t24 = (t32 - t24) * 1.30656296488;
    t32 = t18 + t14;
    t14 = (t18 - t14) * .707106781187;
    t18 = t26 + t24;
    t24 = (t26 - t24) * .707106781187;
    t18 += t24;
    t32 += t18;
    t18 += t14;
    t26 = t14 + t24;
    t14 = t02 + t16;
    t02 = (t02 - t16) * .509795579104;
    t16 = t04 + t20;
    t04 = (t04 - t20) * .601344886935;
    t20 = t28 + t22;
    t22 = (t28 - t22) * .899976223136;
    t28 = t08 + t10;
    t10 = (t08 - t10) * 2.56291544774;
    t08 = t14 + t28;
    t14 = (t14 - t28) * .541196100146;
    t28 = t16 + t20;
    t20 = (t16 - t20) * 1.30656296488;
    t16 = t08 + t28;
    t28 = (t08 - t28) * .707106781187;
    t08 = t14 + t20;
    t20 = (t14 - t20) * .707106781187;
    t08 += t20;
    t14 = t02 + t10;
    t02 = (t02 - t10) * .541196100146;
    t10 = t04 + t22;
    t22 = (t04 - t22) * 1.30656296488;
    t04 = t14 + t10;
    t10 = (t14 - t10) * .707106781187;
    t14 = t02 + t22;
    t02 = (t02 - t22) * .707106781187;
    t14 += t02;
    t04 += t14;
    t14 += t10;
    t10 += t02;
    t16 += t04;
    t04 += t08;
    t08 += t14;
    t14 += t28;
    t28 += t10;
    t10 += t20;
    t20 += t02;
    t21 += t16;
    t16 += t32;
    t32 += t04;
    t04 += t06;
    t06 += t08;
    t08 += t18;
    t18 += t14;
    t14 += t30;
    t30 += t28;
    t28 += t26;
    t26 += t10;
    t10 += t12;
    t12 += t20;
    t20 += t24;
    t24 += t02;
    d[dp + 48] = -t33;
    d[dp + 49] = d[dp + 47] = -t21;
    d[dp + 50] = d[dp + 46] = -t17;
    d[dp + 51] = d[dp + 45] = -t16;
    d[dp + 52] = d[dp + 44] = -t01;
    d[dp + 53] = d[dp + 43] = -t32;
    d[dp + 54] = d[dp + 42] = -t29;
    d[dp + 55] = d[dp + 41] = -t04;
    d[dp + 56] = d[dp + 40] = -t03;
    d[dp + 57] = d[dp + 39] = -t06;
    d[dp + 58] = d[dp + 38] = -t25;
    d[dp + 59] = d[dp + 37] = -t08;
    d[dp + 60] = d[dp + 36] = -t11;
    d[dp + 61] = d[dp + 35] = -t18;
    d[dp + 62] = d[dp + 34] = -t09;
    d[dp + 63] = d[dp + 33] = -t14;
    d[dp + 32] = -t05;
    d[dp + 0] = t05;
    d[dp + 31] = -t30;
    d[dp + 1] = t30;
    d[dp + 30] = -t27;
    d[dp + 2] = t27;
    d[dp + 29] = -t28;
    d[dp + 3] = t28;
    d[dp + 28] = -t07;
    d[dp + 4] = t07;
    d[dp + 27] = -t26;
    d[dp + 5] = t26;
    d[dp + 26] = -t23;
    d[dp + 6] = t23;
    d[dp + 25] = -t10;
    d[dp + 7] = t10;
    d[dp + 24] = -t15;
    d[dp + 8] = t15;
    d[dp + 23] = -t12;
    d[dp + 9] = t12;
    d[dp + 22] = -t19;
    d[dp + 10] = t19;
    d[dp + 21] = -t20;
    d[dp + 11] = t20;
    d[dp + 20] = -t13;
    d[dp + 12] = t13;
    d[dp + 19] = -t24;
    d[dp + 13] = t24;
    d[dp + 18] = -t31;
    d[dp + 14] = t31;
    d[dp + 17] = -t02;
    d[dp + 15] = t02;
    d[dp + 16] = 0
  };
  MP2.FRAME_SYNC = 2047;
  MP2.VERSION = {
    MPEG_2_5: 0,
    MPEG_2: 2,
    MPEG_1: 3
  };
  MP2.LAYER = {
    III: 1,
    II: 2,
    I: 3
  };
  MP2.MODE = {
    STEREO: 0,
    JOINT_STEREO: 1,
    DUAL_CHANNEL: 2,
    MONO: 3
  };
  MP2.SAMPLE_RATE = new Uint16Array([44100, 48e3, 32e3, 0, 22050, 24e3, 16e3, 0]);
  MP2.BIT_RATE = new Uint16Array([32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
  MP2.SCALEFACTOR_BASE = new Uint32Array([33554432, 26632170, 21137968]);
  MP2.SYNTHESIS_WINDOW = new Float32Array([0, -.5, -.5, -.5, -.5, -.5, -.5, -1, -1, -1, -1, -1.5, -1.5, -2, -2, -2.5, -2.5, -3, -3.5, -3.5, -4, -4.5, -5, -5.5, -6.5, -7, -8, -8.5, -9.5, -10.5, -12, -13, -14.5, -15.5, -17.5, -19, -20.5, -22.5, -24.5, -26.5, -29, -31.5, -34, -36.5, -39.5, -42.5, -45.5, -48.5, -52, -55.5, -58.5, -62.5, -66, -69.5, -73.5, -77, -80.5, -84.5, -88, -91.5, -95, -98, -101, -104, 106.5, 109, 111, 112.5, 113.5, 114, 114, 113.5, 112, 110.5, 107.5, 104, 100, 94.5, 88.5, 81.5, 73, 63.5, 53, 41.5, 28.5, 14.5, -1, -18, -36, -55.5, -76.5, -98.5, -122, -147, -173.5, -200.5, -229.5, -259.5, -290.5, -322.5, -355.5, -389.5, -424, -459.5, -495.5, -532, -568.5, -605, -641.5, -678, -714, -749, -783.5, -817, -849, -879.5, -908.5, -935, -959.5, -981, -1000.5, -1016, -1028.5, -1037.5, -1042.5, -1043.5, -1040, -1031.5, 1018.5, 1e3, 976, 946.5, 911, 869.5, 822, 767.5, 707, 640, 565.5, 485, 397, 302.5, 201, 92.5, -22.5, -144, -272.5, -407, -547.5, -694, -846, -1003, -1165, -1331.5, -1502, -1675.5, -1852.5, -2031.5, -2212.5, -2394, -2576.5, -2758.5, -2939.5, -3118.5, -3294.5, -3467.5, -3635.5, -3798.5, -3955, -4104.5, -4245.5, -4377.5, -4499, -4609.5, -4708, -4792.5, -4863.5, -4919, -4958, -4979.5, -4983, -4967.5, -4931.5, -4875, -4796, -4694.5, -4569.5, -4420, -4246, -4046, -3820, -3567, 3287, 2979.5, 2644, 2280.5, 1888, 1467.5, 1018.5, 541, 35, -499, -1061, -1650, -2266.5, -2909, -3577, -4270, -4987.5, -5727.5, -6490, -7274, -8077.5, -8899.5, -9739, -10594.5, -11464.5, -12347, -13241, -14144.5, -15056, -15973.5, -16895.5, -17820, -18744.5, -19668, -20588, -21503, -22410.5, -23308.5, -24195, -25068.5, -25926.5, -26767, -27589, -28389, -29166.5, -29919, -30644.5, -31342, -32009.5, -32645, -33247, -33814.5, -34346, -34839.5, -35295, -35710, -36084.5, -36417.5, -36707.5, -36954, -37156.5, -37315, -37428, -37496, 37519, 37496, 37428, 37315, 37156.5, 36954, 36707.5, 36417.5, 36084.5, 35710, 35295, 34839.5, 34346, 33814.5, 33247, 32645, 32009.5, 31342, 30644.5, 29919, 29166.5, 28389, 27589, 26767, 25926.5, 25068.5, 24195, 23308.5, 22410.5, 21503, 20588, 19668, 18744.5, 17820, 16895.5, 15973.5, 15056, 14144.5, 13241, 12347, 11464.5, 10594.5, 9739, 8899.5, 8077.5, 7274, 6490, 5727.5, 4987.5, 4270, 3577, 2909, 2266.5, 1650, 1061, 499, -35, -541, -1018.5, -1467.5, -1888, -2280.5, -2644, -2979.5, 3287, 3567, 3820, 4046, 4246, 4420, 4569.5, 4694.5, 4796, 4875, 4931.5, 4967.5, 4983, 4979.5, 4958, 4919, 4863.5, 4792.5, 4708, 4609.5, 4499, 4377.5, 4245.5, 4104.5, 3955, 3798.5, 3635.5, 3467.5, 3294.5, 3118.5, 2939.5, 2758.5, 2576.5, 2394, 2212.5, 2031.5, 1852.5, 1675.5, 1502, 1331.5, 1165, 1003, 846, 694, 547.5, 407, 272.5, 144, 22.5, -92.5, -201, -302.5, -397, -485, -565.5, -640, -707, -767.5, -822, -869.5, -911, -946.5, -976, -1e3, 1018.5, 1031.5, 1040, 1043.5, 1042.5, 1037.5, 1028.5, 1016, 1000.5, 981, 959.5, 935, 908.5, 879.5, 849, 817, 783.5, 749, 714, 678, 641.5, 605, 568.5, 532, 495.5, 459.5, 424, 389.5, 355.5, 322.5, 290.5, 259.5, 229.5, 200.5, 173.5, 147, 122, 98.5, 76.5, 55.5, 36, 18, 1, -14.5, -28.5, -41.5, -53, -63.5, -73, -81.5, -88.5, -94.5, -100, -104, -107.5, -110.5, -112, -113.5, -114, -114, -113.5, -112.5, -111, -109, 106.5, 104, 101, 98, 95, 91.5, 88, 84.5, 80.5, 77, 73.5, 69.5, 66, 62.5, 58.5, 55.5, 52, 48.5, 45.5, 42.5, 39.5, 36.5, 34, 31.5, 29, 26.5, 24.5, 22.5, 20.5, 19, 17.5, 15.5, 14.5, 13, 12, 10.5, 9.5, 8.5, 8, 7, 6.5, 5.5, 5, 4.5, 4, 3.5, 3.5, 3, 2.5, 2.5, 2, 2, 1.5, 1.5, 1, 1, 1, 1, .5, .5, .5, .5, .5, .5]);
  MP2.QUANT_LUT_STEP_1 = [
    [0, 0, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2],
    [0, 0, 0, 0, 0, 0, 1, 1, 1, 2, 2, 2, 2, 2]
  ];
  MP2.QUANT_TAB = {
    A: 27 | 64,
    B: 30 | 64,
    C: 8,
    D: 12
  };
  MP2.QUANT_LUT_STEP_2 = [
    [MP2.QUANT_TAB.C, MP2.QUANT_TAB.C, MP2.QUANT_TAB.D],
    [MP2.QUANT_TAB.A, MP2.QUANT_TAB.A, MP2.QUANT_TAB.A],
    [MP2.QUANT_TAB.B, MP2.QUANT_TAB.A, MP2.QUANT_TAB.B]
  ];
  MP2.QUANT_LUT_STEP_3 = [
    [68, 68, 52, 52, 52, 52, 52, 52, 52, 52, 52, 52],
    [67, 67, 67, 66, 66, 66, 66, 66, 66, 66, 66, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 32, 32, 32, 32, 32, 32, 32],
    [69, 69, 69, 69, 52, 52, 52, 52, 52, 52, 52, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36]
  ];
  MP2.QUANT_LUT_STEP4 = [
    [0, 1, 2, 17],
    [0, 1, 2, 3, 4, 5, 6, 17],
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 17],
    [0, 1, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
    [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17],
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
  ];
  MP2.QUANT_TAB = [{
    levels: 3,
    group: 1,
    bits: 5
  }, {
    levels: 5,
    group: 1,
    bits: 7
  }, {
    levels: 7,
    group: 0,
    bits: 3
  }, {
    levels: 9,
    group: 1,
    bits: 10
  }, {
    levels: 15,
    group: 0,
    bits: 4
  }, {
    levels: 31,
    group: 0,
    bits: 5
  }, {
    levels: 63,
    group: 0,
    bits: 6
  }, {
    levels: 127,
    group: 0,
    bits: 7
  }, {
    levels: 255,
    group: 0,
    bits: 8
  }, {
    levels: 511,
    group: 0,
    bits: 9
  }, {
    levels: 1023,
    group: 0,
    bits: 10
  }, {
    levels: 2047,
    group: 0,
    bits: 11
  }, {
    levels: 4095,
    group: 0,
    bits: 12
  }, {
    levels: 8191,
    group: 0,
    bits: 13
  }, {
    levels: 16383,
    group: 0,
    bits: 14
  }, {
    levels: 32767,
    group: 0,
    bits: 15
  }, {
    levels: 65535,
    group: 0,
    bits: 16
  }];
  return MP2
}();
JSMpeg.Renderer.WebGL = function() {
  "use strict";
  var WebGLRenderer = function(options) {
    this.canvas = options.canvas || document.createElement("canvas");
    this.width = this.canvas.width;
    this.height = this.canvas.height;
    this.enabled = true;
    var contextCreateOptions = {
      preserveDrawingBuffer: !!options.preserveDrawingBuffer,
      alpha: false,
      depth: false,
      stencil: false,
      antialias: false
    };
    this.gl = this.canvas.getContext("webgl", contextCreateOptions) || this.canvas.getContext("experimental-webgl", contextCreateOptions);
    if (!this.gl) {
      throw new Error("Failed to get WebGL Context")
    }
    var gl = this.gl;
    var vertexAttr = null;
    this.vertexBuffer = gl.createBuffer();
    var vertexCoords = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, vertexCoords, gl.STATIC_DRAW);
    this.program = this.createProgram(WebGLRenderer.SHADER.VERTEX_IDENTITY, WebGLRenderer.SHADER.FRAGMENT_YCRCB_TO_RGBA);
    vertexAttr = gl.getAttribLocation(this.program, "vertex");
    gl.enableVertexAttribArray(vertexAttr);
    gl.vertexAttribPointer(vertexAttr, 2, gl.FLOAT, false, 0, 0);
    this.textureY = this.createTexture(0, "textureY");
    this.textureCb = this.createTexture(1, "textureCb");
    this.textureCr = this.createTexture(2, "textureCr");
    this.loadingProgram = this.createProgram(WebGLRenderer.SHADER.VERTEX_IDENTITY, WebGLRenderer.SHADER.FRAGMENT_LOADING);
    vertexAttr = gl.getAttribLocation(this.loadingProgram, "vertex");
    gl.enableVertexAttribArray(vertexAttr);
    gl.vertexAttribPointer(vertexAttr, 2, gl.FLOAT, false, 0, 0);
    this.shouldCreateUnclampedViews = !this.allowsClampedTextureData()
  };
  WebGLRenderer.prototype.destroy = function() {
    var gl = this.gl;
    gl.deleteTexture(this.textureY);
    gl.deleteTexture(this.textureCb);
    gl.deleteTexture(this.textureCr);
    gl.deleteProgram(this.program);
    gl.deleteProgram(this.loadingProgram);
    gl.deleteBuffer(this.vertexBuffer)
  };
  WebGLRenderer.prototype.resize = function(width, height) {
    this.width = width | 0;
    this.height = height | 0;
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.gl.useProgram(this.program);
    this.gl.viewport(0, 0, this.width, this.height)
  };
  WebGLRenderer.prototype.createTexture = function(index, name) {
    var gl = this.gl;
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.uniform1i(gl.getUniformLocation(this.program, name), index);
    return texture
  };
  WebGLRenderer.prototype.createProgram = function(vsh, fsh) {
    var gl = this.gl;
    var program = gl.createProgram();
    gl.attachShader(program, this.compileShader(gl.VERTEX_SHADER, vsh));
    gl.attachShader(program, this.compileShader(gl.FRAGMENT_SHADER, fsh));
    gl.linkProgram(program);
    gl.useProgram(program);
    return program
  };
  WebGLRenderer.prototype.compileShader = function(type, source) {
    var gl = this.gl;
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      throw new Error(gl.getShaderInfoLog(shader))
    }
    return shader
  };
  WebGLRenderer.prototype.allowsClampedTextureData = function() {
    var gl = this.gl;
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, 1, 1, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, new Uint8ClampedArray([0]));
    return gl.getError() === 0
  };
  WebGLRenderer.prototype.renderProgress = function(progress) {
    var gl = this.gl;
    gl.useProgram(this.loadingProgram);
    var loc = gl.getUniformLocation(this.loadingProgram, "progress");
    gl.uniform1f(loc, progress);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4)
  };
  WebGLRenderer.prototype.render = function(y, cb, cr) {
    if (!this.enabled) {
      return
    }
    var gl = this.gl;
    var w = this.width + 15 >> 4 << 4,
      h = this.height,
      w2 = w >> 1,
      h2 = h >> 1;
    if (this.shouldCreateUnclampedViews) {
      y = new Uint8Array(y.buffer), cb = new Uint8Array(cb.buffer), cr = new Uint8Array(cr.buffer)
    }
    gl.useProgram(this.program);
    this.updateTexture(gl.TEXTURE0, this.textureY, w, h, y);
    this.updateTexture(gl.TEXTURE1, this.textureCb, w2, h2, cb);
    this.updateTexture(gl.TEXTURE2, this.textureCr, w2, h2, cr);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4)
  };
  WebGLRenderer.prototype.updateTexture = function(unit, texture, w, h, data) {
    var gl = this.gl;
    gl.activeTexture(unit);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, w, h, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, data)
  };
  WebGLRenderer.IsSupported = function() {
    try {
      if (!window.WebGLRenderingContext) {
        return false
      }
      var canvas = document.createElement("canvas");
      return !!(canvas.getContext("webgl") || canvas.getContext("experimental-webgl"))
    } catch (err) {
      return false
    }
  };
  WebGLRenderer.SHADER = {
    FRAGMENT_YCRCB_TO_RGBA: ["precision mediump float;", "uniform sampler2D textureY;", "uniform sampler2D textureCb;", "uniform sampler2D textureCr;", "varying vec2 texCoord;", "mat4 rec601 = mat4(", "1.16438,  0.00000,  1.59603, -0.87079,", "1.16438, -0.39176, -0.81297,  0.52959,", "1.16438,  2.01723,  0.00000, -1.08139,", "0, 0, 0, 1", ");", "void main() {", "float y = texture2D(textureY, texCoord).r;", "float cb = texture2D(textureCb, texCoord).r;", "float cr = texture2D(textureCr, texCoord).r;", "gl_FragColor = vec4(y, cr, cb, 1.0) * rec601;", "}"].join("\n"),
    FRAGMENT_LOADING: ["precision mediump float;", "uniform float progress;", "varying vec2 texCoord;", "void main() {", "float c = ceil(progress-(1.0-texCoord.y));", "gl_FragColor = vec4(c,c,c,1);", "}"].join("\n"),
    VERTEX_IDENTITY: ["attribute vec2 vertex;", "varying vec2 texCoord;", "void main() {", "texCoord = vertex;", "gl_Position = vec4((vertex * 2.0 - 1.0) * vec2(1, -1), 0.0, 1.0);", "}"].join("\n")
  };
  return WebGLRenderer
}();
JSMpeg.Renderer.Canvas2D = function() {
  "use strict";
  var CanvasRenderer = function(options) {
    this.canvas = options.canvas || document.createElement("canvas");
    this.width = this.canvas.width;
    this.height = this.canvas.height;
    this.enabled = true;
    this.context = this.canvas.getContext("2d")
  };
  CanvasRenderer.prototype.destroy = function() {};
  CanvasRenderer.prototype.resize = function(width, height) {
    this.width = width | 0;
    this.height = height | 0;
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.imageData = this.context.getImageData(0, 0, this.width, this.height);
    JSMpeg.Fill(this.imageData.data, 255)
  };
  CanvasRenderer.prototype.renderProgress = function(progress) {
    var w = this.canvas.width,
      h = this.canvas.height,
      ctx = this.context;
    ctx.fillStyle = "#222";
    ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, h - h * progress, w, h * progress)
  };
  CanvasRenderer.prototype.render = function(y, cb, cr) {
    this.YCbCrToRGBA(y, cb, cr, this.imageData.data);
    this.context.putImageData(this.imageData, 0, 0)
  };
  CanvasRenderer.prototype.YCbCrToRGBA = function(y, cb, cr, rgba) {
    if (!this.enabled) {
      return
    }
    var w = this.width + 15 >> 4 << 4,
      w2 = w >> 1;
    var yIndex1 = 0,
      yIndex2 = w,
      yNext2Lines = w + (w - this.width);
    var cIndex = 0,
      cNextLine = w2 - (this.width >> 1);
    var rgbaIndex1 = 0,
      rgbaIndex2 = this.width * 4,
      rgbaNext2Lines = this.width * 4;
    var cols = this.width >> 1,
      rows = this.height >> 1;
    var ccb, ccr, r, g, b;
    for (var row = 0; row < rows; row++) {
      for (var col = 0; col < cols; col++) {
        ccb = cb[cIndex];
        ccr = cr[cIndex];
        cIndex++;
        r = ccb + (ccb * 103 >> 8) - 179;
        g = (ccr * 88 >> 8) - 44 + (ccb * 183 >> 8) - 91;
        b = ccr + (ccr * 198 >> 8) - 227;
        var y1 = y[yIndex1++];
        var y2 = y[yIndex1++];
        rgba[rgbaIndex1] = y1 + r;
        rgba[rgbaIndex1 + 1] = y1 - g;
        rgba[rgbaIndex1 + 2] = y1 + b;
        rgba[rgbaIndex1 + 4] = y2 + r;
        rgba[rgbaIndex1 + 5] = y2 - g;
        rgba[rgbaIndex1 + 6] = y2 + b;
        rgbaIndex1 += 8;
        var y3 = y[yIndex2++];
        var y4 = y[yIndex2++];
        rgba[rgbaIndex2] = y3 + r;
        rgba[rgbaIndex2 + 1] = y3 - g;
        rgba[rgbaIndex2 + 2] = y3 + b;
        rgba[rgbaIndex2 + 4] = y4 + r;
        rgba[rgbaIndex2 + 5] = y4 - g;
        rgba[rgbaIndex2 + 6] = y4 + b;
        rgbaIndex2 += 8
      }
      yIndex1 += yNext2Lines;
      yIndex2 += yNext2Lines;
      rgbaIndex1 += rgbaNext2Lines;
      rgbaIndex2 += rgbaNext2Lines;
      cIndex += cNextLine
    }
  };
  return CanvasRenderer
}();
JSMpeg.AudioOutput.WebAudio = function() {
  "use strict";
  var WebAudioOut = function(options) {
    this.context = WebAudioOut.CachedContext = WebAudioOut.CachedContext || new(window.AudioContext || window.webkitAudioContext);
    this.gain = this.context.createGain();
    this.destination = this.gain;
    this.gain.connect(this.context.destination);
    this.context._connections = (this.context._connections || 0) + 1;
    this.startTime = 0;
    this.buffer = null;
    this.wallclockStartTime = 0;
    this.volume = 1;
    this.enabled = true;
    this.unlocked = !WebAudioOut.NeedsUnlocking();
    Object.defineProperty(this, "enqueuedTime", {
      get: this.getEnqueuedTime
    })
  };
  WebAudioOut.prototype.destroy = function() {
    this.gain.disconnect();
    this.context._connections--;
    if (this.context._connections === 0) {
      this.context.close();
      WebAudioOut.CachedContext = null
    }
  };
  WebAudioOut.prototype.play = function(sampleRate, left, right) {
    if (!this.enabled) {
      return
    }
    if (!this.unlocked) {
      var ts = JSMpeg.Now();
      if (this.wallclockStartTime < ts) {
        this.wallclockStartTime = ts
      }
      this.wallclockStartTime += left.length / sampleRate;
      return
    }
    this.gain.gain.value = this.volume;
    var buffer = this.context.createBuffer(2, left.length, sampleRate);
    buffer.getChannelData(0).set(left);
    buffer.getChannelData(1).set(right);
    var source = this.context.createBufferSource();
    source.buffer = buffer;
    source.connect(this.destination);
    var now = this.context.currentTime;
    var duration = buffer.duration;
    if (this.startTime < now) {
      this.startTime = now;
      this.wallclockStartTime = JSMpeg.Now()
    }
    source.start(this.startTime);
    this.startTime += duration;
    this.wallclockStartTime += duration
  };
  WebAudioOut.prototype.stop = function() {
    this.gain.gain.value = 0
  };
  WebAudioOut.prototype.getEnqueuedTime = function() {
    return Math.max(this.wallclockStartTime - JSMpeg.Now(), 0)
  };
  WebAudioOut.prototype.resetEnqueuedTime = function() {
    this.startTime = this.context.currentTime;
    this.wallclockStartTime = JSMpeg.Now()
  };
  WebAudioOut.prototype.unlock = function(callback) {
    if (this.unlocked) {
      if (callback) {
        callback()
      }
      return
    }
    this.unlockCallback = callback;
    var buffer = this.context.createBuffer(1, 1, 22050);
    var source = this.context.createBufferSource();
    source.buffer = buffer;
    source.connect(this.destination);
    source.start(0);
    setTimeout(this.checkIfUnlocked.bind(this, source, 0), 0)
  };
  WebAudioOut.prototype.checkIfUnlocked = function(source, attempt) {
    if (source.playbackState === source.PLAYING_STATE || source.playbackState === source.FINISHED_STATE) {
      this.unlocked = true;
      if (this.unlockCallback) {
        this.unlockCallback();
        this.unlockCallback = null
      }
    } else if (attempt < 10) {
      setTimeout(this.checkIfUnlocked.bind(this, source, attempt + 1), 100)
    }
  };
  WebAudioOut.NeedsUnlocking = function() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent)
  };
  WebAudioOut.IsSupported = function() {
    return window.AudioContext || window.webkitAudioContext
  };
  WebAudioOut.CachedContext = null;
  return WebAudioOut
}();

var intervalValidarMarker,primerMarker={id:1e4},agregado=!1;!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).atlas=t.atlas||{})}(this,function(t){"use strict";var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function i(t,e){return t(e={exports:{}},e.exports),e.exports}var r=i(function(t,e){function i(t,e){var i,a;r?n?(i="var sharedChunk = {}; ("+r+")(sharedChunk); ("+n+")(sharedChunk);",r(a={}),o=e(a),"undefined"!=typeof window&&(o.workerUrl=window.URL.createObjectURL(new Blob([i],{type:"text/javascript"})))):n=e:r=e}var r,n,o;t.exports=(i(0,function(t){function e(t,e){return t(e={exports:{}},e.exports),e.exports}var i="1.14.0-rc3",r=n;function n(t,e,i,r){this.cx=3*t,this.bx=3*(i-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(r-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=r,this.p2x=i,this.p2y=r}n.prototype.sampleCurveX=function(t){return((this.ax*t+this.bx)*t+this.cx)*t},n.prototype.sampleCurveY=function(t){return((this.ay*t+this.by)*t+this.cy)*t},n.prototype.sampleCurveDerivativeX=function(t){return(3*this.ax*t+2*this.bx)*t+this.cx},n.prototype.solveCurveX=function(t,e){var i,r,n,o,a;for(void 0===e&&(e=1e-6),n=t,a=0;a<8;a++){if(o=this.sampleCurveX(n)-t,Math.abs(o)<e)return n;var s=this.sampleCurveDerivativeX(n);if(Math.abs(s)<1e-6)break;n-=o/s}if((n=t)<(i=0))return i;if((r=1)<n)return r;for(;i<r;){if(o=this.sampleCurveX(n),Math.abs(o-t)<e)return n;o<t?i=n:r=n,n=.5*(r-i)+i}return n},n.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var o=a;function a(t,e){this.x=t,this.y=e}a.prototype={clone:function(){return new a(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x;return e*e+(t=t.y-this.y)*t},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[0]*this.x+t[1]*this.y;t=t[2]*this.x+t[3]*this.y;return this.x=e,this.y=t,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),i=Math.sin(t);t=e*this.x-i*this.y,e=i*this.x+e*this.y;return this.x=t,this.y=e,this},_rotateAround:function(t,e){var i=Math.cos(t),r=Math.sin(t);t=e.x+i*(this.x-e.x)-r*(this.y-e.y),e=e.y+r*(this.x-e.x)+i*(this.y-e.y);return this.x=t,this.y=e,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},a.convert=function(t){return t instanceof a||!Array.isArray(t)?t:new a(t[0],t[1])};var s="undefined"!=typeof self?self:{},l=Math.pow(2,53)-1;function u(t,e,i,n){var o=new r(t,e,i,n);return function(t){return o.solve(t)}}var c=u(.25,.1,.25,1);function p(t,e,i){return Math.min(i,Math.max(e,t))}function h(t,e,i){var r;return(r=((t-e)%(r=i-e)+r)%r+e)===e?i:r}function d(t){for(var e=[],i=arguments.length-1;0<i--;)e[i]=arguments[i+1];for(var r=0,n=e;r<n.length;r+=1){var o,a=n[r];for(o in a)t[o]=a[o]}return t}var f=1;function m(){return function t(e){return e?(e^16*Math.random()>>e/4).toString(16):([1e7]+-[1e3]+-4e3+-8e3+-1e11).replace(/[018]/g,t)}()}function y(t){return t&&/^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)}function g(t,e){t.forEach(function(t){e[t]&&(e[t]=e[t].bind(e))})}function v(t,e){return-1!==t.indexOf(e,t.length-e.length)}function _(t,e,i){var r,n={};for(r in t)n[r]=e.call(i||this,t[r],r,t);return n}function x(t,e,i){var r,n={};for(r in t)e.call(i||this,t[r],r,t)&&(n[r]=t[r]);return n}function b(t){return Array.isArray(t)?t.map(b):"object"==typeof t&&t?_(t,b):t}var w={};function S(t){w[t]||("undefined"!=typeof console&&console.warn(t),w[t]=!0)}function T(t,e,i){return(i.y-t.y)*(e.x-t.x)>(e.y-t.y)*(i.x-t.x)}function C(){return"undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope}function E(t){var e={};return t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,function(t,i,r,n){return n=r||n,e[i]=!n||n.toLowerCase(),""}),e["max-age"]&&(t=parseInt(e["max-age"],10),isNaN(t)?delete e["max-age"]:e["max-age"]=t),e}var I=null;function k(t){var e;return null==I&&(e=t.navigator?t.navigator.userAgent:null,I=!!t.safari||!(!e||!(/\b(iPad|iPhone|iPod)\b/.test(e)||e.match("Safari")&&!e.match("Chrome")))),I}function A(t){try{var e=s[t];return e.setItem("_mapbox_test_",1),e.removeItem("_mapbox_test_"),!0}catch(t){return!1}}var P,M,L,O,R=s.performance&&s.performance.now?s.performance.now.bind(s.performance):Date.now.bind(Date),z=s.requestAnimationFrame||s.mozRequestAnimationFrame||s.webkitRequestAnimationFrame||s.msRequestAnimationFrame,D=s.cancelAnimationFrame||s.mozCancelAnimationFrame||s.webkitCancelAnimationFrame||s.msCancelAnimationFrame,N={now:R,frame:function(t){var e=z(t);return{cancel:function(){return D(e)}}},getImageData:function(t,e){void 0===e&&(e=0);var i=s.document.createElement("canvas"),r=i.getContext("2d");if(!r)throw new Error("failed to create canvas 2d context");return i.width=t.width,i.height=t.height,r.drawImage(t,0,0,t.width,t.height),r.getImageData(-e,-e,t.width+2*e,t.height+2*e)},resolveURL:function(t){return(P=P||s.document.createElement("a")).href=t,P.href},hardwareConcurrency:s.navigator&&s.navigator.hardwareConcurrency||4,get devicePixelRatio(){return s.devicePixelRatio},get prefersReducedMotion(){return!!s.matchMedia&&(M=null==M?s.matchMedia("(prefers-reduced-motion: reduce)"):M).matches}},B={API_URL:"https://api.mapbox.com",get EVENTS_URL(){return this.API_URL?0===this.API_URL.indexOf("https://api.mapbox.cn")?"https://events.mapbox.cn/events/v2":0===this.API_URL.indexOf("https://api.mapbox.com")?"https://events.mapbox.com/events/v2":null:null},FEEDBACK_URL:"https://apps.mapbox.com/feedback",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null,MAX_PARALLEL_IMAGE_REQUESTS:16},F={supported:!1,testSupport:function(t){!U&&O&&(j?V(t):L=t)}},U=!1,j=!1;function V(t){var e=t.createTexture();t.bindTexture(t.TEXTURE_2D,e);try{if(t.texImage2D(t.TEXTURE_2D,0,t.RGBA,t.RGBA,t.UNSIGNED_BYTE,O),t.isContextLost())return;F.supported=!0}catch(t){}t.deleteTexture(e),U=!0}s.document&&((O=s.document.createElement("img")).onload=function(){L&&V(L),j=!(L=null)},O.onerror=function(){U=!0,L=null},O.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");var q="01";function H(t,e){this._transformRequestFn=t,this._customAccessToken=e,this._createSkuToken()}function G(t){return 0===t.indexOf("mapbox:")}H.prototype._createSkuToken=function(){var t=function(){for(var t="",e=0;e<10;e++)t+="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62*Math.random())];return{token:["1",q,t].join(""),tokenExpiresAt:Date.now()+432e5}}();this._skuToken=t.token,this._skuTokenExpiresAt=t.tokenExpiresAt},H.prototype._isSkuTokenExpired=function(){return Date.now()>this._skuTokenExpiresAt},H.prototype.transformRequest=function(t,e){return this._transformRequestFn&&this._transformRequestFn(t,e)||{url:t}},H.prototype.normalizeStyleURL=function(t,e){return G(t)?((t=X(t)).path="/styles/v1"+t.path,this._makeAPIURL(t,this._customAccessToken||e)):t},H.prototype.normalizeGlyphsURL=function(t,e){return G(t)?((t=X(t)).path="/fonts/v1"+t.path,this._makeAPIURL(t,this._customAccessToken||e)):t},H.prototype.normalizeSourceURL=function(t,e){return G(t)?((t=X(t)).path="/v4/"+t.authority+".json",t.params.push("secure"),this._makeAPIURL(t,this._customAccessToken||e)):t},H.prototype.normalizeSpriteURL=function(t,e,i,r){var n=X(t);return G(t)?(n.path="/styles/v1"+n.path+"/sprite"+e+i,this._makeAPIURL(n,this._customAccessToken||r)):(n.path+=""+e+i,Y(n))},H.prototype.normalizeTileURL=function(t,e){if(this._isSkuTokenExpired()&&this._createSkuToken(),t&&!G(t))return t;var i=X(t);t=2<=N.devicePixelRatio||512===e?"@2x":"",e=F.supported?".webp":"$1";return i.path=i.path.replace(/(\.(png|jpg)\d*)(?=$)/,t+e),i.path=i.path.replace(/^.+\/v4\//,"/"),i.path="/v4"+i.path,e=this._customAccessToken||function(t){for(var e=0,i=t;e<i.length;e+=1){var r=i[e].match(/^access_token=(.*)$/);if(r)return r[1]}return null}(i.params)||B.ACCESS_TOKEN,B.REQUIRE_ACCESS_TOKEN&&e&&this._skuToken&&i.params.push("sku="+this._skuToken),this._makeAPIURL(i,e)},H.prototype.canonicalizeTileURL=function(t,e){var i=X(t);return i.path.match(/(^\/v4\/)/)&&i.path.match(/\.[\w]+$/)?(t="mapbox://tiles/",t+=i.path.replace("/v4/",""),i=i.params,(i=e?i.filter(function(t){return!t.match(/^access_token=/)}):i).length&&(t+="?"+i.join("&")),t):t},H.prototype.canonicalizeTileset=function(t,e){for(var i=!!e&&G(e),r=[],n=0,o=t.tiles||[];n<o.length;n+=1){var a=o[n];W(a)?r.push(this.canonicalizeTileURL(a,i)):r.push(a)}return r},H.prototype._makeAPIURL=function(t,e){var i,r="See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes",n=X(B.API_URL);if(t.protocol=n.protocol,t.authority=n.authority,"http"!==t.protocol||0<=(i=t.params.indexOf("secure"))&&t.params.splice(i,1),"/"!==n.path&&(t.path=""+n.path+t.path),!B.REQUIRE_ACCESS_TOKEN)return Y(t);if(!(e=e||B.ACCESS_TOKEN))throw new Error("An API access token is required to use Mapbox GL. "+r);if("s"===e[0])throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). "+r);return t.params=t.params.filter(function(t){return-1===t.indexOf("access_token")}),t.params.push("access_token="+e),Y(t)};var Z=/^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;function W(t){return Z.test(t)}var K=/^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;function X(t){if(!(t=t.match(K)))throw new Error("Unable to parse URL object");return{protocol:t[1],authority:t[2],path:t[3]||"/",params:t[4]?t[4].split("&"):[]}}function Y(t){var e=t.params.length?"?"+t.params.join("&"):"";return t.protocol+"://"+t.authority+t.path+e}var J="mapbox.eventData";function Q(t){if(!t)return null;var e;if(!(t=t.split("."))||3!==t.length)return null;try{return JSON.parse((e=t[1],decodeURIComponent(s.atob(e).split("").map(function(t){return"%"+("00"+t.charCodeAt(0).toString(16)).slice(-2)}).join(""))))}catch(t){return null}}(Vs=function(t){this.type=t,this.anonId=null,this.eventData={},this.queue=[],this.pendingRequest=null}).prototype.getStorageKey=function(t){var e=Q(B.ACCESS_TOKEN),i=e&&e.u?(e=e.u,s.btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g,function(t,e){return String.fromCharCode(Number("0x"+e))}))):B.ACCESS_TOKEN||"";return t?J+"."+t+":"+i:J+":"+i},Vs.prototype.fetchEventData=function(){var t=A("localStorage"),e=this.getStorageKey(),i=this.getStorageKey("uuid");if(t)try{var r=s.localStorage.getItem(e);r&&(this.eventData=JSON.parse(r));var n=s.localStorage.getItem(i);n&&(this.anonId=n)}catch(t){S("Unable to read from LocalStorage")}},Vs.prototype.saveEventData=function(){var t=A("localStorage"),e=this.getStorageKey(),i=this.getStorageKey("uuid");if(t)try{s.localStorage.setItem(i,this.anonId),1<=Object.keys(this.eventData).length&&s.localStorage.setItem(e,JSON.stringify(this.eventData))}catch(t){S("Unable to write to LocalStorage")}},Vs.prototype.processRequests=function(t){},Vs.prototype.postEvent=function(t,e,r,n){var o,a=this;B.EVENTS_URL&&((o=X(B.EVENTS_URL)).params.push("access_token="+(n||B.ACCESS_TOKEN||"")),t={event:this.type,created:new Date(t).toISOString(),sdkIdentifier:"mapbox-gl-js",sdkVersion:i,skuId:q,userId:this.anonId},t=e?d(t,e):t,t={url:Y(o),headers:{"Content-Type":"text/plain"},body:JSON.stringify([t])},this.pendingRequest=Ct(t,function(t){a.pendingRequest=null,r(t),a.saveEventData(),a.processRequests(n)}))},Vs.prototype.queueRequest=function(t,e){this.queue.push(t),this.processRequests(e)};var $,tt,et=(($=Vs)&&(it.__proto__=$),((it.prototype=Object.create($&&$.prototype)).constructor=it).prototype.postMapLoadEvent=function(t,e,i,r){this.skuToken=i,(B.EVENTS_URL&&r||B.ACCESS_TOKEN&&Array.isArray(t)&&t.some(function(t){return G(t)||W(t)}))&&this.queueRequest({id:e,timestamp:Date.now()},r)},it.prototype.processRequests=function(t){var e,i,r=this;this.pendingRequest||0===this.queue.length||(i=this.queue.shift(),e=i.id,i=i.timestamp,e&&this.success[e]||(this.anonId||this.fetchEventData(),y(this.anonId)||(this.anonId=m()),this.postEvent(i,{skuToken:this.skuToken},function(t){t||e&&(r.success[e]=!0)},t)))},it);function it(){$.call(this,"map.load"),this.success={},this.skuToken=""}function rt(t){tt.call(this,"appUserTurnstile"),this._customAccessToken=t}var nt,ot,at=(Fo=new((tt=Vs)&&(rt.__proto__=tt),((rt.prototype=Object.create(tt&&tt.prototype)).constructor=rt).prototype.postTurnstileEvent=function(t,e){B.EVENTS_URL&&B.ACCESS_TOKEN&&Array.isArray(t)&&t.some(function(t){return G(t)||W(t)})&&this.queueRequest(Date.now(),e)},rt.prototype.processRequests=function(t){var e=this;if(!this.pendingRequest&&0!==this.queue.length){this.anonId&&this.eventData.lastSuccess&&this.eventData.tokenU||this.fetchEventData();var i=Q(B.ACCESS_TOKEN),r=i?i.u:B.ACCESS_TOKEN,n=r!==this.eventData.tokenU;y(this.anonId)||(this.anonId=m(),n=!0);var o,a,s=this.queue.shift();if(!(n=!this.eventData.lastSuccess||(o=new Date(this.eventData.lastSuccess),a=new Date(s),i=(s-this.eventData.lastSuccess)/864e5,n||1<=i||i<-1||o.getDate()!==a.getDate())))return this.processRequests();this.postEvent(s,{"enabled.telemetry":!1},function(t){t||(e.eventData.lastSuccess=s,e.eventData.tokenU=r)},t)}},rt)).postTurnstileEvent.bind(Fo),st=(va=new et).postMapLoadEvent.bind(va),lt="mapbox-tiles",ut=500,ct=50;function pt(){s.caches&&!nt&&(nt=s.caches.open(lt))}function ht(t){var e=t.indexOf("?");return e<0?t:t.slice(0,e)}var dt,ft=1/0;function mt(){return dt=null==dt?s.OffscreenCanvas&&new s.OffscreenCanvas(1,1).getContext("2d")&&"function"==typeof s.createImageBitmap:dt}var yt={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};"function"==typeof Object.freeze&&Object.freeze(yt);var gt,vt=((gt=Error)&&(_t.__proto__=gt),((_t.prototype=Object.create(gt&&gt.prototype)).constructor=_t).prototype.toString=function(){return this.name+": "+this.message+" ("+this.status+"): "+this.url},_t);function _t(t,e,i){401===e&&W(i)&&(t+=": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"),gt.call(this,t),this.status=e,this.url=i,this.name=this.constructor.name,this.message=t}var xt=C()?function(){return self.worker&&self.worker.referrer}:function(){return("blob:"===s.location.protocol?s.parent:s).location.href},bt=function(t){return/^file:/.test(t)||/^file:/.test(xt())&&!/^\w+:/.test(t)};function wt(t,e){var i=new s.AbortController,r=new s.Request(t.url,{method:t.method||"GET",body:t.body,credentials:t.credentials,headers:t.headers,referrer:xt(),signal:i.signal}),n=!1,o=!1,a=0<(u=r.url).indexOf("sku=")&&W(u);function l(i,a,l){("arrayBuffer"===t.type?i.arrayBuffer():"json"===t.type?i.json():i.text()).then(function(t){o||(a&&l&&function(t,e,i){var r,n;pt(),nt&&(r={status:e.status,statusText:e.statusText,headers:new s.Headers},e.headers.forEach(function(t,e){return r.headers.set(e,t)}),(n=E(e.headers.get("Cache-Control")||""))["no-store"]||(n["max-age"]&&r.headers.set("Expires",new Date(i+1e3*n["max-age"]).toUTCString()),new Date(r.headers.get("Expires")).getTime()-i<42e4||function(t,e){if(void 0===ot)try{new Response(new ReadableStream),ot=!0}catch(t){ot=!1}ot?e(t.body):t.blob().then(e)}(e,function(e){var i=new s.Response(e,r);pt(),nt&&nt.then(function(e){return e.put(ht(t.url),i)}).catch(function(t){return S(t.message)})})))}(r,a,l),n=!0,e(null,t,i.headers.get("Cache-Control"),i.headers.get("Expires")))}).catch(function(t){o||e(new Error(t.message))})}"json"===t.type&&r.headers.set("Accept","application/json");var u=function(i,n,u){if(!o){if(i&&"SecurityError"!==i.message&&S(i),n&&u)return l(n);var c=Date.now();s.fetch(r).then(function(i){if(i.ok){var r=a?i.clone():null;return l(i,r,c)}return e(new vt(i.statusText,i.status,t.url))}).catch(function(t){20!==t.code&&e(new Error(t.message))})}};return a?function(t,e){if(pt(),!nt)return e(null);var i=ht(t.url);nt.then(function(t){t.match(i).then(function(r){var n=function(t){if(!t)return!1;var e=new Date(t.headers.get("Expires")||0);return t=E(t.headers.get("Cache-Control")||""),e>Date.now()&&!t["no-cache"]}(r);t.delete(i),n&&t.put(i,r.clone()),e(null,r,n)}).catch(e)}).catch(e)}(r,u):u(null,null),{cancel:function(){o=!0,n||i.abort()}}}function St(t,e){if(!bt(t.url)){if(s.fetch&&s.Request&&s.AbortController&&s.Request.prototype.hasOwnProperty("signal"))return wt(t,e);if(C()&&self.worker&&self.worker.actor)return self.worker.actor.send("getResource",t,e,void 0,!0)}return function(t,e){var i,r=new s.XMLHttpRequest;for(i in r.open(t.method||"GET",t.url,!0),"arrayBuffer"===t.type&&(r.responseType="arraybuffer"),t.headers)r.setRequestHeader(i,t.headers[i]);return"json"===t.type&&(r.responseType="text",r.setRequestHeader("Accept","application/json")),r.withCredentials="include"===t.credentials,r.onerror=function(){e(new Error(r.statusText))},r.onload=function(){if((200<=r.status&&r.status<300||0===r.status)&&null!==r.response){var i=r.response;if("json"===t.type)try{i=JSON.parse(r.response)}catch(i){return e(i)}e(null,i,r.getResponseHeader("Cache-Control"),r.getResponseHeader("Expires"))}else e(new vt(r.statusText,r.status,t.url))},r.send(t.body),{cancel:function(){return r.abort()}}}(t,e)}var Tt=function(t,e){return St(d(t,{type:"arrayBuffer"}),e)},Ct=function(t,e){return St(d(t,{method:"POST"}),e)},Et="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";var It=[],kt=0;function At(t,e,i){i[t]&&-1!==i[t].indexOf(e)||(i[t]=i[t]||[],i[t].push(e))}function Pt(t,e,i){i&&i[t]&&-1!==(e=i[t].indexOf(e))&&i[t].splice(e,1)}var Mt,Lt=function(t,e){d(this,e=void 0===e?{}:e),this.type=t},Ot=((Mt=Lt)&&(Rt.__proto__=Mt),(Rt.prototype=Object.create(Mt&&Mt.prototype)).constructor=Rt);function Rt(t,e){Mt.call(this,"error",d({error:t},e=void 0===e?{}:e))}function zt(){}zt.prototype.on=function(t,e){return this._listeners=this._listeners||{},At(t,e,this._listeners),this},zt.prototype.off=function(t,e){return Pt(t,e,this._listeners),Pt(t,e,this._oneTimeListeners),this},zt.prototype.once=function(t,e){return this._oneTimeListeners=this._oneTimeListeners||{},At(t,e,this._oneTimeListeners),this},zt.prototype.fire=function(t,e){var i=(t="string"==typeof t?new Lt(t,e||{}):t).type;if(this.listens(i)){for(var r=0,n=(t.target=this)._listeners&&this._listeners[i]?this._listeners[i].slice():[];r<n.length;r+=1)n[r].call(this,t);for(var o=0,a=this._oneTimeListeners&&this._oneTimeListeners[i]?this._oneTimeListeners[i].slice():[];o<a.length;o+=1){var s=a[o];Pt(i,s,this._oneTimeListeners),s.call(this,t)}(e=this._eventedParent)&&(d(t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData),e.fire(t))}else t instanceof Ot&&console.error(t.error);return this},zt.prototype.listens=function(t){return this._listeners&&this._listeners[t]&&0<this._listeners[t].length||this._oneTimeListeners&&this._oneTimeListeners[t]&&0<this._oneTimeListeners[t].length||this._eventedParent&&this._eventedParent.listens(t)};var Dt={$version:8,$root:{version:{required:!0,type:"enum",values:[8]},name:{type:"string"},metadata:{type:"*"},center:{type:"array",value:"number"},zoom:{type:"number"},bearing:{type:"number",default:0,period:360,units:"degrees"},pitch:{type:"number",default:0,units:"degrees"},light:{type:"light"},sources:{required:!0,type:"sources"},sprite:{type:"string"},glyphs:{type:"string"},transition:{type:"transition"},layers:{required:!0,type:"array",value:"layer"}},sources:{"*":{type:"source"}},source:["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],source_vector:{type:{required:!0,type:"enum",values:{vector:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},attribution:{type:"string"},promoteId:{type:"promoteId"},volatile:{type:"boolean",default:!(zt.prototype.setEventedParent=function(t,e){return this._eventedParent=t,this._eventedParentData=e,this})},"*":{type:"*"}},source_raster:{type:{required:!0,type:"enum",values:{raster:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},attribution:{type:"string"},volatile:{type:"boolean",default:!1},"*":{type:"*"}},source_raster_dem:{type:{required:!0,type:"enum",values:{"raster-dem":{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},attribution:{type:"string"},encoding:{type:"enum",values:{terrarium:{},mapbox:{}},default:"mapbox"},volatile:{type:"boolean",default:!1},"*":{type:"*"}},source_geojson:{type:{required:!0,type:"enum",values:{geojson:{}}},data:{type:"*"},maxzoom:{type:"number",default:18},attribution:{type:"string"},buffer:{type:"number",default:128,maximum:512,minimum:0},filter:{type:"*"},tolerance:{type:"number",default:.375},cluster:{type:"boolean",default:!1},clusterRadius:{type:"number",default:50,minimum:0},clusterMaxZoom:{type:"number"},clusterMinPoints:{type:"number"},clusterProperties:{type:"*"},lineMetrics:{type:"boolean",default:!1},generateId:{type:"boolean",default:!1},promoteId:{type:"promoteId"}},source_video:{type:{required:!0,type:"enum",values:{video:{}}},urls:{required:!0,type:"array",value:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},source_image:{type:{required:!0,type:"enum",values:{image:{}}},url:{required:!0,type:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},layer:{id:{type:"string",required:!0},type:{type:"enum",values:{fill:{},line:{},symbol:{},circle:{},heatmap:{},"fill-extrusion":{},raster:{},hillshade:{},background:{}},required:!0},metadata:{type:"*"},source:{type:"string"},"source-layer":{type:"string"},minzoom:{type:"number",minimum:0,maximum:24},maxzoom:{type:"number",minimum:0,maximum:24},filter:{type:"filter"},layout:{type:"layout"},paint:{type:"paint"}},layout:["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background"],layout_background:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_fill:{"fill-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_circle:{"circle-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_heatmap:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},"layout_fill-extrusion":{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_line:{"line-cap":{type:"enum",values:{butt:{},round:{},square:{}},default:"butt",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-join":{type:"enum",values:{bevel:{},round:{},miter:{}},default:"miter",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{type:"number",default:2,requires:[{"line-join":"miter"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-round-limit":{type:"number",default:1.05,requires:[{"line-join":"round"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_symbol:{"symbol-placement":{type:"enum",values:{point:{},line:{},"line-center":{}},default:"point",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-spacing":{type:"number",default:250,minimum:1,units:"pixels",requires:[{"symbol-placement":"line"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{type:"boolean",default:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{type:"enum",values:{auto:{},"viewport-y":{},source:{}},default:"auto",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-optional":{type:"boolean",default:!1,requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-size":{type:"number",default:1,minimum:0,units:"factor of the original icon size",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{type:"enum",values:{none:{},width:{},height:{},both:{}},default:"none",requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{type:"array",value:"number",length:4,default:[0,0,0,0],units:"pixels",requires:["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-image":{type:"resolvedImage",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{type:"boolean",default:!1,requires:["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-offset":{type:"array",value:"number",length:2,default:[0,0],requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-field":{type:"formatted",default:"",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-font":{type:"array",value:"string",default:["Open Sans Regular","Arial Unicode MS Regular"],requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-size":{type:"number",default:16,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{type:"number",default:10,minimum:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{type:"number",default:1.2,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-letter-spacing":{type:"number",default:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-justify":{type:"enum",values:{auto:{},left:{},center:{},right:{}},default:"center",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{type:"number",units:"ems",default:0,requires:["text-field"],"property-type":"data-driven",expression:{interpolated:!0,parameters:["zoom","feature"]}},"text-variable-anchor":{type:"array",value:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},requires:["text-field",{"symbol-placement":["point"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["text-field",{"!":"text-variable-anchor"}],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{type:"number",default:45,units:"degrees",requires:["text-field",{"symbol-placement":["line","line-center"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-writing-mode":{type:"array",value:"enum",values:{horizontal:{},vertical:{}},requires:["text-field",{"symbol-placement":["point"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-keep-upright":{type:"boolean",default:!0,requires:["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-transform":{type:"enum",values:{none:{},uppercase:{},lowercase:{}},default:"none",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-offset":{type:"array",value:"number",units:"ems",length:2,default:[0,0],requires:["text-field",{"!":"text-radial-offset"}],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-optional":{type:"boolean",default:!1,requires:["text-field","icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_raster:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_hillshade:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},filter:{type:"array",value:"*"},filter_operator:{type:"enum",values:{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},in:{},"!in":{},all:{},any:{},none:{},has:{},"!has":{},within:{}}},geometry_type:{type:"enum",values:{Point:{},LineString:{},Polygon:{}}},function:{expression:{type:"expression"},stops:{type:"array",value:"function_stop"},base:{type:"number",default:1,minimum:0},property:{type:"string",default:"$zoom"},type:{type:"enum",values:{identity:{},exponential:{},interval:{},categorical:{}},default:"exponential"},colorSpace:{type:"enum",values:{rgb:{},lab:{},hcl:{}},default:"rgb"},default:{type:"*",required:!1}},function_stop:{type:"array",minimum:0,maximum:24,value:["number","color"],length:2},expression:{type:"array",value:"*",minimum:1},light:{anchor:{type:"enum",default:"viewport",values:{map:{},viewport:{}},"property-type":"data-constant",transition:!1,expression:{interpolated:!1,parameters:["zoom"]}},position:{type:"array",default:[1.15,210,30],length:3,value:"number","property-type":"data-constant",transition:!0,expression:{interpolated:!0,parameters:["zoom"]}},color:{type:"color","property-type":"data-constant",default:"#ffffff",expression:{interpolated:!0,parameters:["zoom"]},transition:!0},intensity:{type:"number","property-type":"data-constant",default:.5,minimum:0,maximum:1,expression:{interpolated:!0,parameters:["zoom"]},transition:!0}},paint:["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background"],paint_fill:{"fill-antialias":{type:"boolean",default:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{type:"color",transition:!0,requires:[{"!":"fill-pattern"},{"fill-antialias":!0}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-extrusion-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-extrusion-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{type:"number",default:0,minimum:0,units:"meters",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{type:"number",default:0,minimum:0,units:"meters",transition:!0,requires:["fill-extrusion-height"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{type:"boolean",default:!0,transition:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_line:{"line-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"line-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["line-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-width":{type:"number",default:1,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{type:"number",default:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{type:"array",value:"number",minimum:0,transition:!0,units:"line widths",requires:[{"!":"line-pattern"}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"line-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{type:"color",transition:!1,requires:[{"!":"line-dasharray"},{"!":"line-pattern"},{source:"geojson",has:{lineMetrics:!0}}],expression:{interpolated:!0,parameters:["line-progress"]},"property-type":"color-ramp"}},paint_circle:{"circle-radius":{type:"number",default:5,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{type:"number",default:0,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["circle-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{type:"enum",values:{map:{},viewport:{}},default:"map",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"}},paint_heatmap:{"heatmap-radius":{type:"number",default:30,minimum:1,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{type:"number",default:1,minimum:0,transition:!1,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{type:"number",default:1,minimum:0,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"heatmap-color":{type:"color",default:["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",.1,"royalblue",.3,"cyan",.5,"lime",.7,"yellow",1,"red"],transition:!1,expression:{interpolated:!0,parameters:["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_symbol:{"icon-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{type:"color",default:"#000000",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["icon-image","icon-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{type:"color",default:"#000000",transition:!0,overridable:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["text-field","text-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_raster:{"raster-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{type:"number",default:0,period:360,transition:!0,units:"degrees",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{type:"number",default:0,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-saturation":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-contrast":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-resampling":{type:"enum",values:{linear:{},nearest:{}},default:"linear",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{type:"number",default:300,minimum:0,transition:!1,units:"milliseconds",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_hillshade:{"hillshade-illumination-direction":{type:"number",default:335,minimum:0,maximum:359,transition:!1,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{type:"number",default:.5,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{type:"color",default:"#FFFFFF",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_background:{"background-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"background-pattern"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"background-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"background-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},transition:{duration:{type:"number",default:300,minimum:0,units:"milliseconds"},delay:{type:"number",default:0,minimum:0,units:"milliseconds"}},"property-type":{"data-driven":{type:"property-type"},"cross-faded":{type:"property-type"},"cross-faded-data-driven":{type:"property-type"},"color-ramp":{type:"property-type"},"data-constant":{type:"property-type"},constant:{type:"property-type"}},promoteId:{"*":{type:"string"}}},Nt=function(t,e,i,r){this.message=(t?t+": ":"")+i,r&&(this.identifier=r),null!=e&&e.__line__&&(this.line=e.__line__)};function Bt(t){var e=t.key;return(t=t.value)?[new Nt(e,t,"constants have been deprecated as of v8")]:[]}function Ft(t){for(var e=[],i=arguments.length-1;0<i--;)e[i]=arguments[i+1];for(var r=0,n=e;r<n.length;r+=1){var o,a=n[r];for(o in a)t[o]=a[o]}return t}function Ut(t){return t instanceof Number||t instanceof String||t instanceof Boolean?t.valueOf():t}function jt(t){if(Array.isArray(t))return t.map(jt);if(t instanceof Object&&!(t instanceof Number||t instanceof String||t instanceof Boolean)){var e,i={};for(e in t)i[e]=jt(t[e]);return i}return Ut(t)}var Vt,qt=((Vt=Error)&&(Ht.__proto__=Vt),(Ht.prototype=Object.create(Vt&&Vt.prototype)).constructor=Ht);function Ht(t,e){Vt.call(this,e),this.message=e,this.key=t}function Gt(t,e){void 0===e&&(e=[]),this.parent=t,this.bindings={};for(var i=0,r=e;i<r.length;i+=1){var n=(o=r[i])[0],o=o[1];this.bindings[n]=o}}Gt.prototype.concat=function(t){return new Gt(this,t)},Gt.prototype.get=function(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(t+" not found in scope.")},Gt.prototype.has=function(t){return!!this.bindings[t]||!!this.parent&&this.parent.has(t)};var Zt={kind:"null"},Wt={kind:"number"},Kt={kind:"string"},Xt={kind:"boolean"},Yt={kind:"color"},Jt={kind:"object"},Qt={kind:"value"},$t={kind:"collator"},te={kind:"formatted"},ee={kind:"resolvedImage"};function ie(t,e){return{kind:"array",itemType:t,N:e}}function re(t){if("array"!==t.kind)return t.kind;var e=re(t.itemType);return"number"==typeof t.N?"array<"+e+", "+t.N+">":"value"===t.itemType.kind?"array":"array<"+e+">"}var ne=[Zt,Wt,Kt,Xt,Yt,te,Jt,ie(Qt),ee];function oe(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&(0===e.N&&"value"===e.itemType.kind||!oe(t.itemType,e.itemType))&&("number"!=typeof t.N||t.N===e.N))return null}else{if(t.kind===e.kind)return null;if("value"===t.kind)for(var i=0,r=ne;i<r.length;i+=1)if(!oe(r[i],e))return null}return"Expected "+re(t)+" but found "+re(e)+" instead."}function ae(t,e){return e.some(function(e){return e.kind===t.kind})}function se(t,e){return e.some(function(e){return"null"===e?null===t:"array"===e?Array.isArray(t):"object"===e?t&&!Array.isArray(t)&&"object"==typeof t:e===typeof t})}var le=e(function(t,e){var i={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function r(t){return(t=Math.round(t))<0?0:255<t?255:t}function n(t){return t<0?0:1<t?1:t}function o(t){return"%"===t[t.length-1]?r(parseFloat(t)/100*255):r(parseInt(t))}function a(t){return"%"===t[t.length-1]?n(parseFloat(t)/100):n(parseFloat(t))}function s(t,e,i){return i<0?i+=1:1<i&&--i,6*i<1?t+(e-t)*i*6:2*i<1?e:3*i<2?t+(e-t)*(2/3-i)*6:t}try{e.parseCSSColor=function(t){var e=t.replace(/ /g,"").toLowerCase();if(e in i)return i[e].slice();if("#"===e[0])return 4===e.length?0<=(l=parseInt(e.substr(1),16))&&l<=4095?[(3840&l)>>4|(3840&l)>>8,240&l|(240&l)>>4,15&l|(15&l)<<4,1]:null:7===e.length&&0<=(l=parseInt(e.substr(1),16))&&l<=16777215?[(16711680&l)>>16,(65280&l)>>8,255&l,1]:null;var n=e.indexOf("(");t=e.indexOf(")");if(-1!==n&&t+1===e.length){var l=e.substr(0,n),u=e.substr(n+1,t-(n+1)).split(","),c=1;switch(l){case"rgba":if(4!==u.length)return null;c=a(u.pop());case"rgb":return 3!==u.length?null:[o(u[0]),o(u[1]),o(u[2]),c];case"hsla":if(4!==u.length)return null;c=a(u.pop());case"hsl":if(3!==u.length)return null;var p,h=(parseFloat(u[0])%360+360)%360/360,d=a(u[1]);return[r(255*s(p=2*(p=a(u[2]))-(d=p<=.5?p*(d+1):p+d-p*d),d,h+1/3)),r(255*s(p,d,h)),r(255*s(p,d,h-1/3)),c];default:return null}}return null}}catch(t){}}).parseCSSColor,ue=function(t,e,i,r){void 0===r&&(r=1),this.r=t,this.g=e,this.b=i,this.a=r};function ce(t,e,i){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=i,this.collator=new Intl.Collator(this.locale||[],{sensitivity:this.sensitivity,usage:"search"})}function pe(t,e,i,r,n){this.text=t,this.image=e,this.scale=i,this.fontStack=r,this.textColor=n}ue.parse=function(t){if(t){if(t instanceof ue)return t;if("string"==typeof t&&(t=le(t)))return new ue(t[0]/255*t[3],t[1]/255*t[3],t[2]/255*t[3],t[3])}},ue.prototype.toString=function(){var t=(r=this.toArray())[0],e=r[1],i=r[2],r=r[3];return"rgba("+Math.round(t)+","+Math.round(e)+","+Math.round(i)+","+r+")"},ue.prototype.toArray=function(){var t=this.r,e=this.g,i=this.b,r=this.a;return 0===r?[0,0,0,0]:[255*t/r,255*e/r,255*i/r,r]},ue.black=new ue(0,0,0,1),ue.white=new ue(1,1,1,1),ue.transparent=new ue(0,0,0,0),ue.red=new ue(1,0,0,1),ce.prototype.compare=function(t,e){return this.collator.compare(t,e)},ce.prototype.resolvedLocale=function(){return new Intl.Collator(this.locale||[]).resolvedOptions().locale};var he=function(t){this.sections=t};he.fromString=function(t){return new he([new pe(t,null,null,null,null)])},he.prototype.isEmpty=function(){return 0===this.sections.length||!this.sections.some(function(t){return 0!==t.text.length||t.image&&0!==t.image.name.length})},he.factory=function(t){return t instanceof he?t:he.fromString(t)},he.prototype.toString=function(){return 0===this.sections.length?"":this.sections.map(function(t){return t.text}).join("")},he.prototype.serialize=function(){for(var t=["format"],e=0,i=this.sections;e<i.length;e+=1){var r,n=i[e];n.image?t.push(["image",n.image.name]):(t.push(n.text),r={},n.fontStack&&(r["text-font"]=["literal",n.fontStack.split(",")]),n.scale&&(r["font-scale"]=n.scale),n.textColor&&(r["text-color"]=["rgba"].concat(n.textColor.toArray())),t.push(r))}return t};var de=function(t){this.name=t.name,this.available=t.available};function fe(t,e,i,r){return"number"==typeof t&&0<=t&&t<=255&&"number"==typeof e&&0<=e&&e<=255&&"number"==typeof i&&0<=i&&i<=255?void 0===r||"number"==typeof r&&0<=r&&r<=1?null:"Invalid rgba value ["+[t,e,i,r].join(", ")+"]: 'a' must be between 0 and 1.":"Invalid rgba value ["+("number"==typeof r?[t,e,i,r]:[t,e,i]).join(", ")+"]: 'r', 'g', and 'b' must be between 0 and 255."}function me(t){if(null===t)return 1;if("string"==typeof t)return 1;if("boolean"==typeof t)return 1;if("number"==typeof t)return 1;if(t instanceof ue)return 1;if(t instanceof ce)return 1;if(t instanceof he)return 1;if(t instanceof de)return 1;if(Array.isArray(t)){for(var e=0,i=t;e<i.length;e+=1)if(!me(i[e]))return;return 1}if("object"==typeof t){for(var r in t)if(!me(t[r]))return;return 1}}function ye(t){if(null===t)return Zt;if("string"==typeof t)return Kt;if("boolean"==typeof t)return Xt;if("number"==typeof t)return Wt;if(t instanceof ue)return Yt;if(t instanceof ce)return $t;if(t instanceof he)return te;if(t instanceof de)return ee;if(Array.isArray(t)){for(var e,i=t.length,r=0,n=t;r<n.length;r+=1){var o=ye(n[r]);if(e){if(e!==o){e=Qt;break}}else e=o}return ie(e||Qt,i)}return Jt}function ge(t){var e=typeof t;return null===t?"":"string"==e||"number"==e||"boolean"==e?String(t):t instanceof ue||t instanceof he||t instanceof de?t.toString():JSON.stringify(t)}function ve(t,e){this.type=t,this.value=e}function _e(t){this.name="ExpressionEvaluationError",this.message=t}function xe(t,e){this.type=t,this.args=e}de.prototype.toString=function(){return this.name},de.fromString=function(t){return t?new de({name:t,available:!1}):null},de.prototype.serialize=function(){return["image",this.name]},ve.parse=function(t,e){if(2!==t.length)return e.error("'literal' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(!me(t[1]))return e.error("invalid value");var i=t[1];t=ye(i),e=e.expectedType;return"array"!==t.kind||0!==t.N||!e||"array"!==e.kind||"number"==typeof e.N&&0!==e.N||(t=e),new ve(t,i)},ve.prototype.evaluate=function(){return this.value},ve.prototype.eachChild=function(){},ve.prototype.outputDefined=function(){return!0},ve.prototype.serialize=function(){return"array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof ue?["rgba"].concat(this.value.toArray()):this.value instanceof he?this.value.serialize():this.value},_e.prototype.toJSON=function(){return this.message};var be={string:Kt,number:Wt,boolean:Xt,object:Jt};function we(t){this.type=te,this.sections=t}function Se(t){this.type=ee,this.input=t}function Te(t,e){this.type=t,this.args=e}xe.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var i,r=1,n=t[0];if("array"===n){if(2<t.length){var o=t[1];if("string"!=typeof o||!(o in be)||"object"===o)return e.error('The item type argument of "array" must be one of string, number, boolean',1);o=be[o],r++}else o=Qt;if(3<t.length){if(null!==t[2]&&("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2])))return e.error('The length argument to "array" must be a positive integer literal',2);i=t[2],r++}i=ie(o,i)}else i=be[n];for(var a=[];r<t.length;r++){var s=e.parse(t[r],r,Qt);if(!s)return null;a.push(s)}return new xe(i,a)},xe.prototype.evaluate=function(t){for(var e=0;e<this.args.length;e++){var i=this.args[e].evaluate(t);if(!oe(this.type,ye(i)))return i;if(e===this.args.length-1)throw new _e("Expected value to be of type "+re(this.type)+", but found "+re(ye(i))+" instead.")}return null},xe.prototype.eachChild=function(t){this.args.forEach(t)},xe.prototype.outputDefined=function(){return this.args.every(function(t){return t.outputDefined()})},xe.prototype.serialize=function(){var t,e=this.type,i=[e.kind];return"array"===e.kind&&("string"!==(t=e.itemType).kind&&"number"!==t.kind&&"boolean"!==t.kind||(i.push(t.kind),("number"==typeof(e=e.N)||1<this.args.length)&&i.push(e))),i.concat(this.args.map(function(t){return t.serialize()}))},we.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var i=t[1];if(!Array.isArray(i)&&"object"==typeof i)return e.error("First argument must be an image or text section.");for(var r=[],n=!1,o=1;o<=t.length-1;++o){var a=t[o];if(n&&"object"==typeof a&&!Array.isArray(a)){n=!1;var s=null;if(a["font-scale"]&&!(s=e.parse(a["font-scale"],1,Wt)))return null;var l=null;if(a["text-font"]&&!(l=e.parse(a["text-font"],1,ie(Kt))))return null;var u=null;if(a["text-color"]&&!(u=e.parse(a["text-color"],1,Yt)))return null;var c=r[r.length-1];c.scale=s,c.font=l,c.textColor=u}else{if(!(c=e.parse(t[o],1,Qt)))return null;if("string"!==(u=c.type.kind)&&"value"!==u&&"null"!==u&&"resolvedImage"!==u)return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");n=!0,r.push({content:c,scale:null,font:null,textColor:null})}}return new we(r)},we.prototype.evaluate=function(t){return new he(this.sections.map(function(e){var i=e.content.evaluate(t);return ye(i)===ee?new pe("",i,null,null,null):new pe(ge(i),null,e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null,e.textColor?e.textColor.evaluate(t):null)}))},we.prototype.eachChild=function(t){for(var e=0,i=this.sections;e<i.length;e+=1){var r=i[e];t(r.content),r.scale&&t(r.scale),r.font&&t(r.font),r.textColor&&t(r.textColor)}},we.prototype.outputDefined=function(){return!1},we.prototype.serialize=function(){for(var t=["format"],e=0,i=this.sections;e<i.length;e+=1){var r=i[e];t.push(r.content.serialize());var n={};r.scale&&(n["font-scale"]=r.scale.serialize()),r.font&&(n["text-font"]=r.font.serialize()),r.textColor&&(n["text-color"]=r.textColor.serialize()),t.push(n)}return t},Se.parse=function(t,e){return 2!==t.length?e.error("Expected two arguments."):(t=e.parse(t[1],1,Kt))?new Se(t):e.error("No image name provided.")},Se.prototype.evaluate=function(t){var e=this.input.evaluate(t),i=de.fromString(e);return i&&t.availableImages&&(i.available=-1<t.availableImages.indexOf(e)),i},Se.prototype.eachChild=function(t){t(this.input)},Se.prototype.outputDefined=function(){return!1},Se.prototype.serialize=function(){return["image",this.input.serialize()]};var Ce={"to-boolean":Xt,"to-color":Yt,"to-number":Wt,"to-string":Kt};function Ee(){this.globals=null,this.feature=null,this.featureState=null,this.formattedSection=null,this._parseColorCache={},this.availableImages=null,this.canonical=null}Te.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");if(("to-boolean"===(i=t[0])||"to-string"===i)&&2!==t.length)return e.error("Expected one argument.");for(var i=Ce[i],r=[],n=1;n<t.length;n++){var o=e.parse(t[n],n,Qt);if(!o)return null;r.push(o)}return new Te(i,r)},Te.prototype.evaluate=function(t){if("boolean"===this.type.kind)return Boolean(this.args[0].evaluate(t));if("color"===this.type.kind){for(var e=0,i=this.args;e<i.length;e+=1){var r,n=null;if((r=i[e].evaluate(t))instanceof ue)return r;if("string"==typeof r){var o=t.parseColor(r);if(o)return o}else if(Array.isArray(r)&&!(n=r.length<3||4<r.length?"Invalid rbga value "+JSON.stringify(r)+": expected an array containing either three or four numeric values.":fe(r[0],r[1],r[2],r[3])))return new ue(r[0]/255,r[1]/255,r[2]/255,r[3])}throw new _e(n||"Could not parse color from value '"+("string"==typeof r?r:String(JSON.stringify(r)))+"'")}if("number"!==this.type.kind)return"formatted"===this.type.kind?he.fromString(ge(this.args[0].evaluate(t))):"resolvedImage"===this.type.kind?de.fromString(ge(this.args[0].evaluate(t))):ge(this.args[0].evaluate(t));for(var a=null,s=0,l=this.args;s<l.length;s+=1){if(null===(a=l[s].evaluate(t)))return 0;var u=Number(a);if(!isNaN(u))return u}throw new _e("Could not convert "+JSON.stringify(a)+" to number.")},Te.prototype.eachChild=function(t){this.args.forEach(t)},Te.prototype.outputDefined=function(){return this.args.every(function(t){return t.outputDefined()})},Te.prototype.serialize=function(){if("formatted"===this.type.kind)return new we([{content:this.args[0],scale:null,font:null,textColor:null}]).serialize();if("resolvedImage"===this.type.kind)return new Se(this.args[0]).serialize();var t=["to-"+this.type.kind];return this.eachChild(function(e){t.push(e.serialize())}),t};var Ie=["Unknown","Point","LineString","Polygon"];Ee.prototype.id=function(){return this.feature&&"id"in this.feature?this.feature.id:null},Ee.prototype.geometryType=function(){return this.feature?"number"==typeof this.feature.type?Ie[this.feature.type]:this.feature.type:null},Ee.prototype.geometry=function(){return this.feature&&"geometry"in this.feature?this.feature.geometry:null},Ee.prototype.canonicalID=function(){return this.canonical},Ee.prototype.properties=function(){return this.feature&&this.feature.properties||{}},Ee.prototype.parseColor=function(t){return this._parseColorCache[t]||(this._parseColorCache[t]=ue.parse(t))};var ke=function(t,e,i,r){this.name=t,this.type=e,this._evaluate=i,this.args=r};function Ae(t,e,i){this.type=$t,this.locale=i,this.caseSensitive=t,this.diacriticSensitive=e}ke.prototype.evaluate=function(t){return this._evaluate(t,this.args)},ke.prototype.eachChild=function(t){this.args.forEach(t)},ke.prototype.outputDefined=function(){return!1},ke.prototype.serialize=function(){return[this.name].concat(this.args.map(function(t){return t.serialize()}))},ke.parse=function(t,e){var i=t[0],r=ke.definitions[i];if(!r)return e.error('Unknown expression "'+i+'". If you wanted a literal array, use ["literal", [...]].',0);for(var n=Array.isArray(r)?r[0]:r.type,o=(_=Array.isArray(r)?[[r[1],r[2]]]:r.overloads).filter(function(e){return e=e[0],!Array.isArray(e)||e.length===t.length-1}),a=null,s=0,l=o;s<l.length;s+=1){for(var u=(c=l[s])[0],c=c[1],p=(a=new Ke(e.registry,e.path,null,e.scope),[]),h=!1,d=1;d<t.length;d++){var f=t[d],m=Array.isArray(u)?u[d-1]:u.type;if(!(m=a.parse(f,1+p.length,m))){h=!0;break}p.push(m)}if(!h)if(Array.isArray(u)&&u.length!==p.length)a.error("Expected "+u.length+" arguments, but found "+p.length+" instead.");else{for(var y=0;y<p.length;y++){var g=Array.isArray(u)?u[y]:u.type,v=p[y];a.concat(y+1).checkSubtype(g,v.type)}if(0===a.errors.length)return new ke(i,n,c,p)}}if(1===o.length)(r=e.errors).push.apply(r,a.errors);else{for(var _=(o.length?o:_).map(function(t){return t=t=t[0],Array.isArray(t)?"("+t.map(re).join(", ")+")":"("+re(t.type)+"...)"}).join(" | "),x=[],b=1;b<t.length;b++){var w=e.parse(t[b],1+x.length);if(!w)return null;x.push(re(w.type))}e.error("Expected arguments of type "+_+", but found ("+x.join(", ")+") instead.")}return null},ke.register=function(t,e){for(var i in ke.definitions=e)t[i]=ke},Ae.parse=function(t,e){if(2!==t.length)return e.error("Expected one argument.");var i=t[1];if("object"!=typeof i||Array.isArray(i))return e.error("Collator options argument must be an object.");var r=e.parse(void 0!==i["case-sensitive"]&&i["case-sensitive"],1,Xt);if(!r)return null;var n=e.parse(void 0!==i["diacritic-sensitive"]&&i["diacritic-sensitive"],1,Xt);return n?(t=null,i.locale&&!(t=e.parse(i.locale,1,Kt))?null:new Ae(r,n,t)):null},Ae.prototype.evaluate=function(t){return new ce(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)},Ae.prototype.eachChild=function(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale)},Ae.prototype.outputDefined=function(){return!1},Ae.prototype.serialize=function(){var t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]};var Pe=8192;function Me(t,e){t[0]=Math.min(t[0],e[0]),t[1]=Math.min(t[1],e[1]),t[2]=Math.max(t[2],e[0]),t[3]=Math.max(t[3],e[1])}function Le(t,e){return!(t[0]<=e[0]||t[2]>=e[2]||t[1]<=e[1]||t[3]>=e[3])}function Oe(t,e){var i=(180+t[0])/360;t=t[1],t=(180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))/360,e=Math.pow(2,e.z);return[Math.round(i*e*Pe),Math.round(t*e*Pe)]}function Re(t,e){for(var i,r,n,o,a=!1,s=0,l=e.length;s<l;s++)for(var u=e[s],c=0,p=u.length;c<p-1;c++){if(i=u[c],r=u[c+1],o=void 0,n=t[0]-i[0],o=t[1]-i[1],i=t[0]-r[0],n*(r=t[1]-r[1])-i*o==0&&n*i<=0&&o*r<=0)return;i=t,o=u[c],r=u[c+1],o[1]>i[1]!=r[1]>i[1]&&i[0]<(r[0]-o[0])*(i[1]-o[1])/(r[1]-o[1])+o[0]&&(a=!a)}return a}function ze(t,e,i,r){var n=t[0]-i[0],o=t[1]-i[1],a=e[0]-i[0];t=e[1]-i[1],e=r[0]-i[0],t=a*(i=r[1]-i[1])-e*t;return 0<(o=n*i-e*o)&&t<0||o<0&&0<t}function De(t,e,i){for(var r,n,o,a,s,l,u=0,c=i;u<c.length;u+=1)for(var p=c[u],h=0;h<p.length-1;++h)if(r=t,n=e,o=p[h],a=p[h+1],void 0,s=[n[0]-r[0],n[1]-r[1]],0!=(l=[a[0]-o[0],a[1]-o[1]])[0]*s[1]-l[1]*s[0]&&ze(r,n,o,a)&&ze(o,a,r,n))return 1}function Ne(t,e){for(var i=0;i<t.length;++i)if(!Re(t[i],e))return;for(var r=0;r<t.length-1;++r)if(De(t[r],t[r+1],e))return;return 1}function Be(t,e,i){for(var r=[],n=0;n<t.length;n++){for(var o=[],a=0;a<t[n].length;a++){var s=Oe(t[n][a],i);Me(e,s),o.push(s)}r.push(o)}return r}function Fe(t,e,i){for(var r=[],n=0;n<t.length;n++){var o=Be(t[n],e,i);r.push(o)}return r}function Ue(t,e,i,r){var n,o;(t[0]<i[0]||t[0]>i[2])&&(0===(o=t[0]-i[0]>(n=.5*r)?-r:i[0]-t[0]>n?r:0)&&(o=t[0]-i[2]>n?-r:i[2]-t[0]>n?r:0),t[0]+=o),Me(e,t)}function je(t,e,i,r){for(var n=Math.pow(2,r.z)*Pe,o=[r.x*Pe,r.y*Pe],a=[],s=0,l=t;s<l.length;s+=1)for(var u=0,c=l[s];u<c.length;u+=1){var p;Ue(p=[(p=c[u]).x+o[0],p.y+o[1]],e,i,n),a.push(p)}return a}function Ve(t,e,i,r){for(var n=Math.pow(2,r.z)*Pe,o=[r.x*Pe,r.y*Pe],a=[],s=0,l=t;s<l.length;s+=1){for(var u=[],c=0,p=l[s];c<p.length;c+=1){var h;Me(e,h=[(h=p[c]).x+o[0],h.y+o[1]]),u.push(h)}a.push(u)}if(e[2]-e[0]<=n/2){(t=e)[0]=t[1]=1/0,t[2]=t[3]=-1/0;for(var d=0,f=a;d<f.length;d+=1)for(var m=0,y=f[d];m<y.length;m+=1)Ue(y[m],e,i,n)}return a}var qe=function(t,e){this.type=Xt,this.geojson=t,this.geometries=e};function He(t){if(t instanceof ke){if("get"===t.name&&1===t.args.length)return!1;if("feature-state"===t.name)return!1;if("has"===t.name&&1===t.args.length)return!1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return!1;if(/^filter-/.test(t.name))return!1}if(t instanceof qe)return!1;var e=!0;return t.eachChild(function(t){e&&!He(t)&&(e=!1)}),e}function Ge(t){if(!(t instanceof ke&&"feature-state"===t.name)){var e=!0;return t.eachChild(function(t){e&&!Ge(t)&&(e=!1)}),e}}function Ze(t,e){if(t instanceof ke&&0<=e.indexOf(t.name))return!1;var i=!0;return t.eachChild(function(t){i&&!Ze(t,e)&&(i=!1)}),i}function We(t,e){this.type=e.type,this.name=t,this.boundExpression=e}qe.parse=function(t,e){if(2!==t.length)return e.error("'within' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(me(t[1])){var i=t[1];if("FeatureCollection"===i.type)for(var r=0;r<i.features.length;++r){var n=i.features[r].geometry.type;if("Polygon"===n||"MultiPolygon"===n)return new qe(i,i.features[r].geometry)}else if("Feature"===i.type){if("Polygon"===(t=i.geometry.type)||"MultiPolygon"===t)return new qe(i,i.geometry)}else if("Polygon"===i.type||"MultiPolygon"===i.type)return new qe(i,i)}return e.error("'within' expression requires valid geojson object that contains polygon geometry type.")},qe.prototype.evaluate=function(t){if(null!=t.geometry()&&null!=t.canonicalID()){if("Point"===t.geometryType())return function(t,e){var i=[1/0,1/0,-1/0,-1/0],r=[1/0,1/0,-1/0,-1/0],n=t.canonicalID();if("Polygon"===e.type){var o=Be(e.coordinates,r,n),a=je(t.geometry(),i,r,n);if(!Le(i,r))return!1;for(var s=0,l=a;s<l.length;s+=1)if(!Re(l[s],o))return!1}if("MultiPolygon"===e.type){var u=Fe(e.coordinates,r,n);if(n=je(t.geometry(),i,r,n),!Le(i,r))return!1;for(var c=0,p=n;c<p.length;c+=1)if(!function(t,e){for(var i=0;i<e.length;i++)if(Re(t,e[i]))return 1}(p[c],u))return!1}return!0}(t,this.geometries);if("LineString"===t.geometryType())return function(t,e){var i=[1/0,1/0,-1/0,-1/0],r=[1/0,1/0,-1/0,-1/0],n=t.canonicalID();if("Polygon"===e.type){var o=Be(e.coordinates,r,n),a=Ve(t.geometry(),i,r,n);if(!Le(i,r))return!1;for(var s=0,l=a;s<l.length;s+=1)if(!Ne(l[s],o))return!1}if("MultiPolygon"===e.type){var u=Fe(e.coordinates,r,n);if(n=Ve(t.geometry(),i,r,n),!Le(i,r))return!1;for(var c=0,p=n;c<p.length;c+=1)if(!function(t,e){for(var i=0;i<e.length;i++)if(Ne(t,e[i]))return 1}(p[c],u))return!1}return!0}(t,this.geometries)}return!1},qe.prototype.eachChild=function(){},qe.prototype.outputDefined=function(){return!0},qe.prototype.serialize=function(){return["within",this.geojson]},We.parse=function(t,e){return 2!==t.length||"string"!=typeof t[1]?e.error("'var' expression requires exactly one string literal argument."):(t=t[1],e.scope.has(t)?new We(t,e.scope.get(t)):e.error('Unknown variable "'+t+'". Make sure "'+t+'" has been bound in an enclosing "let" expression before using it.',1))},We.prototype.evaluate=function(t){return this.boundExpression.evaluate(t)},We.prototype.eachChild=function(){},We.prototype.outputDefined=function(){return!1},We.prototype.serialize=function(){return["var",this.name]};var Ke=function(t,e,i,r,n){void 0===e&&(e=[]),void 0===r&&(r=new Gt),void 0===n&&(n=[]),this.registry=t,this.path=e,this.key=e.map(function(t){return"["+t+"]"}).join(""),this.scope=r,this.errors=n,this.expectedType=i};function Xe(t,e){for(var i,r,n,o=t.length-1,a=0,s=o;a<=s;)if(r=t[i=Math.floor((a+s)/2)],n=t[i+1],r<=e){if(i===o||e<n)return i;a=i+1}else{if(!(e<r))throw new _e("Input is not a number.");s=i-1}return 0}Ke.prototype.parse=function(t,e,i,r,n){return void 0===n&&(n={}),(e?this.concat(e,i,r):this)._parse(t,n)},Ke.prototype._parse=function(t,e){function i(t,e,i){return"assert"===i?new xe(e,[t]):"coerce"===i?new Te(e,[t]):t}if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');var r=t[0];if("string"!=typeof r)return this.error("Expression name must be a string, but found "+typeof r+' instead. If you wanted a literal array, use ["literal", [...]].',0),null;if(a=this.registry[r]){var n=a.parse(t,this);if(!n)return null;if(this.expectedType){var o=this.expectedType,a=n.type;if("string"!==o.kind&&"number"!==o.kind&&"boolean"!==o.kind&&"object"!==o.kind&&"array"!==o.kind||"value"!==a.kind)if("color"!==o.kind&&"formatted"!==o.kind&&"resolvedImage"!==o.kind||"value"!==a.kind&&"string"!==a.kind){if(this.checkSubtype(o,a))return null}else n=i(n,o,e.typeAnnotation||"coerce");else n=i(n,o,e.typeAnnotation||"assert")}if(!(n instanceof ve)&&"resolvedImage"!==n.type.kind&&function t(e){if(e instanceof We)return t(e.boundExpression);if(e instanceof ke&&"error"===e.name)return!1;if(e instanceof Ae)return!1;if(e instanceof qe)return!1;var i=e instanceof Te||e instanceof xe,r=!0;return e.eachChild(function(e){r=i?r&&t(e):r&&e instanceof ve}),!!r&&(He(e)&&Ze(e,["zoom","heatmap-density","line-progress","accumulated","is-supported-script"]))}(n)){e=new Ee;try{n=new ve(n.type,n.evaluate(e))}catch(t){return this.error(t.message),null}}return n}return this.error('Unknown expression "'+r+'". If you wanted a literal array, use ["literal", [...]].',0)}return void 0===t?this.error("'undefined' value invalid. Use null instead."):"object"==typeof t?this.error('Bare objects invalid. Use ["literal", {...}] instead.'):this.error("Expected an array, but found "+typeof t+" instead.")},Ke.prototype.concat=function(t,e,i){return t="number"==typeof t?this.path.concat(t):this.path,i=i?this.scope.concat(i):this.scope,new Ke(this.registry,t,e||null,i,this.errors)},Ke.prototype.error=function(t){for(var e=[],i=arguments.length-1;0<i--;)e[i]=arguments[i+1];var r=""+this.key+e.map(function(t){return"["+t+"]"}).join("");this.errors.push(new qt(r,t))},Ke.prototype.checkSubtype=function(t,e){return(e=oe(t,e))&&this.error(e),e};var Ye=function(t,e,i){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(var r=0,n=i;r<n.length;r+=1){var o=(a=n[r])[0],a=a[1];this.labels.push(o),this.outputs.push(a)}};function Je(t,e,i){return t*(1-i)+e*i}Ye.parse=function(t,e){if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");var i=e.parse(t[1],1,Wt);if(!i)return null;var r=[],n=null;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);for(var o=1;o<t.length;o+=2){var a=1===o?-1/0:t[o],s=t[o+1],l=o,u=o+1;if("number"!=typeof a)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',l);if(r.length&&r[r.length-1][0]>=a)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',l);if(!(u=e.parse(s,u,n)))return null;n=n||u.type,r.push([a,u])}return new Ye(n,i,r)},Ye.prototype.evaluate=function(t){var e=this.labels,i=this.outputs;if(1===e.length)return i[0].evaluate(t);var r=this.input.evaluate(t);if(r<=e[0])return i[0].evaluate(t);var n=e.length;return(r>=e[n-1]?i[n-1]:i[Xe(e,r)]).evaluate(t)},Ye.prototype.eachChild=function(t){t(this.input);for(var e=0,i=this.outputs;e<i.length;e+=1)t(i[e])},Ye.prototype.outputDefined=function(){return this.outputs.every(function(t){return t.outputDefined()})},Ye.prototype.serialize=function(){for(var t=["step",this.input.serialize()],e=0;e<this.labels.length;e++)0<e&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t};var Qe=Object.freeze({__proto__:null,number:Je,color:function(t,e,i){return new ue(Je(t.r,e.r,i),Je(t.g,e.g,i),Je(t.b,e.b,i),Je(t.a,e.a,i))},array:function(t,e,i){return t.map(function(t,r){return Je(t,e[r],i)})}}),$e=4/29,ti=6/29,ei=3*ti*ti,ii=ti*ti*ti,ri=Math.PI/180,ni=180/Math.PI;function oi(t){return ii<t?Math.pow(t,1/3):t/ei+$e}function ai(t){return ti<t?t*t*t:ei*(t-$e)}function si(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function li(t){return(t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function ui(t){var e=li(t.r),i=li(t.g),r=li(t.b),n=oi((.4124564*e+.3575761*i+.1804375*r)/.95047),o=oi(.2126729*e+.7151522*i+.072175*r);return{l:116*o-16,a:500*(n-o),b:200*(o-oi((.0193339*e+.119192*i+.9503041*r)/1.08883)),alpha:t.a}}function ci(t){var e=(t.l+16)/116,i=isNaN(t.a)?e:e+t.a/500,r=isNaN(t.b)?e:e-t.b/200;e=+ai(e),i=.95047*ai(i),r=1.08883*ai(r);return new ue(si(3.2404542*i-1.5371385*e-.4985314*r),si(-.969266*i+1.8760108*e+.041556*r),si(.0556434*i-.2040259*e+1.0572252*r),t.alpha)}var pi={forward:ui,reverse:ci,interpolate:function(t,e,i){return{l:Je(t.l,e.l,i),a:Je(t.a,e.a,i),b:Je(t.b,e.b,i),alpha:Je(t.alpha,e.alpha,i)}}},hi={forward:function(t){var e=ui(t),i=e.l,r=e.a,n=e.b;return{h:(e=Math.atan2(n,r)*ni)<0?360+e:e,c:Math.sqrt(r*r+n*n),l:i,alpha:t.a}},reverse:function(t){var e=t.h*ri,i=t.c;return ci({l:t.l,a:Math.cos(e)*i,b:Math.sin(e)*i,alpha:t.alpha})},interpolate:function(t,e,i){return{h:(r=t.h,n=e.h,r+i*(180<(n-=r)||n<-180?n-360*Math.round(n/360):n)),c:Je(t.c,e.c,i),l:Je(t.l,e.l,i),alpha:Je(t.alpha,e.alpha,i)};var r,n}},di=Object.freeze({__proto__:null,lab:pi,hcl:hi}),fi=function(t,e,i,r,n){this.type=t,this.operator=e,this.interpolation=i,this.input=r,this.labels=[],this.outputs=[];for(var o=0,a=n;o<a.length;o+=1){var s=(l=a[o])[0],l=l[1];this.labels.push(s),this.outputs.push(l)}};function mi(t,e,i,r){return r-=i,i=t-i,0==r?0:1===e?i/r:(Math.pow(e,i)-1)/(Math.pow(e,r)-1)}fi.interpolationFactor=function(t,e,i,n){var o=0;return"exponential"===t.name?o=mi(e,t.base,i,n):"linear"===t.name?o=mi(e,1,i,n):"cubic-bezier"===t.name&&(t=t.controlPoints,o=new r(t[0],t[1],t[2],t[3]).solve(mi(e,1,i,n))),o},fi.parse=function(t,e){var i=t[0],r=t[1],n=t[2],o=t.slice(3);if(!Array.isArray(r)||0===r.length)return e.error("Expected an interpolation type expression.",1);if("linear"===r[0])r={name:"linear"};else if("exponential"===r[0]){var a=r[1];if("number"!=typeof a)return e.error("Exponential interpolation requires a numeric base.",1,1);r={name:"exponential",base:a}}else{if("cubic-bezier"!==r[0])return e.error("Unknown interpolation type "+String(r[0]),1,0);if(4!==(a=r.slice(1)).length||a.some(function(t){return"number"!=typeof t||t<0||1<t}))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);r={name:"cubic-bezier",controlPoints:a}}if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(n=e.parse(n,2,Wt)))return null;var s=[],l=null;"interpolate-hcl"===i||"interpolate-lab"===i?l=Yt:e.expectedType&&"value"!==e.expectedType.kind&&(l=e.expectedType);for(var u=0;u<o.length;u+=2){var c=o[u],p=o[u+1],h=u+3,d=u+4;if("number"!=typeof c)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',h);if(s.length&&s[s.length-1][0]>=c)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',h);if(!(d=e.parse(p,d,l)))return null;l=l||d.type,s.push([c,d])}return"number"===l.kind||"color"===l.kind||"array"===l.kind&&"number"===l.itemType.kind&&"number"==typeof l.N?new fi(l,i,r,n,s):e.error("Type "+re(l)+" is not interpolatable.")},fi.prototype.evaluate=function(t){var e=this.labels,i=this.outputs;if(1===e.length)return i[0].evaluate(t);var r=this.input.evaluate(t);if(r<=e[0])return i[0].evaluate(t);if(r>=e[(o=e.length)-1])return i[o-1].evaluate(t);var n=Xe(e,r),o=e[n];e=e[n+1],o=fi.interpolationFactor(this.interpolation,r,o,e),e=i[n].evaluate(t),t=i[n+1].evaluate(t);return"interpolate"===this.operator?Qe[this.type.kind.toLowerCase()](e,t,o):"interpolate-hcl"===this.operator?hi.reverse(hi.interpolate(hi.forward(e),hi.forward(t),o)):pi.reverse(pi.interpolate(pi.forward(e),pi.forward(t),o))},fi.prototype.eachChild=function(t){t(this.input);for(var e=0,i=this.outputs;e<i.length;e+=1)t(i[e])},fi.prototype.outputDefined=function(){return this.outputs.every(function(t){return t.outputDefined()})},fi.prototype.serialize=function(){for(var t="linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints),e=[this.operator,t,this.input.serialize()],i=0;i<this.labels.length;i++)e.push(this.labels[i],this.outputs[i].serialize());return e};var yi=function(t,e){this.type=t,this.args=e};yi.parse=function(t,e){if(t.length<2)return e.error("Expectected at least one argument.");var i=null,r=e.expectedType;r&&"value"!==r.kind&&(i=r);for(var n=[],o=0,a=t.slice(1);o<a.length;o+=1){var s=a[o];if(!(s=e.parse(s,1+n.length,i,void 0,{typeAnnotation:"omit"})))return null;i=i||s.type,n.push(s)}return t=r&&n.some(function(t){return oe(r,t.type)}),new yi(t?Qt:i,n)},yi.prototype.evaluate=function(t){for(var e,i=null,r=0,n=0,o=this.args;n<o.length&&(r++,(i=o[n].evaluate(t))&&i instanceof de&&!i.available&&(e=e||i.name,i=null,r===this.args.length&&(i=e)),null===i);n+=1);return i},yi.prototype.eachChild=function(t){this.args.forEach(t)},yi.prototype.outputDefined=function(){return this.args.every(function(t){return t.outputDefined()})},yi.prototype.serialize=function(){var t=["coalesce"];return this.eachChild(function(e){t.push(e.serialize())}),t};var gi=function(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e};function vi(t,e,i){this.type=t,this.index=e,this.input=i}function _i(t,e){this.type=Xt,this.needle=t,this.haystack=e}function xi(t,e,i){this.type=Wt,this.needle=t,this.haystack=e,this.fromIndex=i}function bi(t,e,i,r,n,o){this.inputType=t,this.type=e,this.input=i,this.cases=r,this.outputs=n,this.otherwise=o}function wi(t,e,i){this.type=t,this.branches=e,this.otherwise=i}function Si(t,e,i,r){this.type=t,this.input=e,this.beginIndex=i,this.endIndex=r}function Ti(t,e){return"=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function Ci(t,e,i,r){return 0===r.compare(e,i)}function Ei(t,e,i){var r="=="!==t&&"!="!==t;return n.parse=function(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");var i=t[0],o=e.parse(t[1],1,Qt);if(!o)return null;if(!Ti(i,o.type))return e.concat(1).error('"'+i+"\" comparisons are not supported for type '"+re(o.type)+"'.");var a=e.parse(t[2],2,Qt);if(!a)return null;if(!Ti(i,a.type))return e.concat(2).error('"'+i+"\" comparisons are not supported for type '"+re(a.type)+"'.");if(o.type.kind!==a.type.kind&&"value"!==o.type.kind&&"value"!==a.type.kind)return e.error("Cannot compare types '"+re(o.type)+"' and '"+re(a.type)+"'.");if(r&&("value"===o.type.kind&&"value"!==a.type.kind?o=new xe(a.type,[o]):"value"!==o.type.kind&&"value"===a.type.kind&&(a=new xe(o.type,[a]))),i=null,4===t.length){if("string"!==o.type.kind&&"string"!==a.type.kind&&"value"!==o.type.kind&&"value"!==a.type.kind)return e.error("Cannot use collator to compare non-string types.");if(!(i=e.parse(t[3],3,$t)))return null}return new n(o,a,i)},n.prototype.evaluate=function(n){var o=this.lhs.evaluate(n),a=this.rhs.evaluate(n);if(r&&this.hasUntypedArgument){var s=ye(o),l=ye(a);if(s.kind!==l.kind||"string"!==s.kind&&"number"!==s.kind)throw new _e('Expected arguments for "'+t+'" to be (string, string) or (number, number), but found ('+s.kind+", "+l.kind+") instead.")}return this.collator&&!r&&this.hasUntypedArgument&&(s=ye(o),l=ye(a),"string"!==s.kind||"string"!==l.kind)?e(n,o,a):this.collator?i(n,o,a,this.collator.evaluate(n)):e(n,o,a)},n.prototype.eachChild=function(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator)},n.prototype.outputDefined=function(){return!0},n.prototype.serialize=function(){var e=[t];return this.eachChild(function(t){e.push(t.serialize())}),e},n;function n(t,e,i){this.type=Xt,this.lhs=t,this.rhs=e,this.collator=i,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind}}function Ii(t,e,i,r,n){this.type=Kt,this.number=t,this.locale=e,this.currency=i,this.minFractionDigits=r,this.maxFractionDigits=n}gi.prototype.evaluate=function(t){return this.result.evaluate(t)},gi.prototype.eachChild=function(t){for(var e=0,i=this.bindings;e<i.length;e+=1)t(i[e][1]);t(this.result)},gi.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found "+(t.length-1)+" instead.");for(var i=[],r=1;r<t.length-1;r+=2){var n=t[r];if("string"!=typeof n)return e.error("Expected string, but found "+typeof n+" instead.",r);if(/[^a-zA-Z0-9_]/.test(n))return e.error("Variable names must contain only alphanumeric characters or '_'.",r);var o=e.parse(t[r+1],r+1);if(!o)return null;i.push([n,o])}var a=e.parse(t[t.length-1],t.length-1,e.expectedType,i);return a?new gi(i,a):null},gi.prototype.outputDefined=function(){return this.result.outputDefined()},gi.prototype.serialize=function(){for(var t=["let"],e=0,i=this.bindings;e<i.length;e+=1){var r=(n=i[e])[0],n=n[1];t.push(r,n.serialize())}return t.push(this.result.serialize()),t},vi.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var i=e.parse(t[1],1,Wt);t=e.parse(t[2],2,ie(e.expectedType||Qt));return i&&t?new vi((e=t.type).itemType,i,t):null},vi.prototype.evaluate=function(t){var e=this.index.evaluate(t);t=this.input.evaluate(t);if(e<0)throw new _e("Array index out of bounds: "+e+" < 0.");if(e>=t.length)throw new _e("Array index out of bounds: "+e+" > "+(t.length-1)+".");if(e!==Math.floor(e))throw new _e("Array index must be an integer, but found "+e+" instead.");return t[e]},vi.prototype.eachChild=function(t){t(this.index),t(this.input)},vi.prototype.outputDefined=function(){return!1},vi.prototype.serialize=function(){return["at",this.index.serialize(),this.input.serialize()]},_i.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var i=e.parse(t[1],1,Qt);t=e.parse(t[2],2,Qt);return i&&t?ae(i.type,[Xt,Kt,Wt,Zt,Qt])?new _i(i,t):e.error("Expected first argument to be of type boolean, string, number or null, but found "+re(i.type)+" instead"):null},_i.prototype.evaluate=function(t){var e=this.needle.evaluate(t);if(!(t=this.haystack.evaluate(t)))return!1;if(!se(e,["boolean","string","number","null"]))throw new _e("Expected first argument to be of type boolean, string, number or null, but found "+re(ye(e))+" instead.");if(!se(t,["string","array"]))throw new _e("Expected second argument to be of type array or string, but found "+re(ye(t))+" instead.");return 0<=t.indexOf(e)},_i.prototype.eachChild=function(t){t(this.needle),t(this.haystack)},_i.prototype.outputDefined=function(){return!0},_i.prototype.serialize=function(){return["in",this.needle.serialize(),this.haystack.serialize()]},xi.parse=function(t,e){if(t.length<=2||5<=t.length)return e.error("Expected 3 or 4 arguments, but found "+(t.length-1)+" instead.");var i=e.parse(t[1],1,Qt),r=e.parse(t[2],2,Qt);return i&&r?ae(i.type,[Xt,Kt,Wt,Zt,Qt])?4!==t.length?new xi(i,r):(t=e.parse(t[3],3,Wt))?new xi(i,r,t):null:e.error("Expected first argument to be of type boolean, string, number or null, but found "+re(i.type)+" instead"):null},xi.prototype.evaluate=function(t){var e=this.needle.evaluate(t),i=this.haystack.evaluate(t);if(!se(e,["boolean","string","number","null"]))throw new _e("Expected first argument to be of type boolean, string, number or null, but found "+re(ye(e))+" instead.");if(!se(i,["string","array"]))throw new _e("Expected second argument to be of type array or string, but found "+re(ye(i))+" instead.");return this.fromIndex?(t=this.fromIndex.evaluate(t),i.indexOf(e,t)):i.indexOf(e)},xi.prototype.eachChild=function(t){t(this.needle),t(this.haystack),this.fromIndex&&t(this.fromIndex)},xi.prototype.outputDefined=function(){return!1},xi.prototype.serialize=function(){if(null==this.fromIndex||void 0===this.fromIndex)return["index-of",this.needle.serialize(),this.haystack.serialize()];var t=this.fromIndex.serialize();return["index-of",this.needle.serialize(),this.haystack.serialize(),t]},bi.parse=function(t,e){if(t.length<5)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if(t.length%2!=1)return e.error("Expected an even number of arguments.");var i,r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);for(var n={},o=[],a=2;a<t.length-1;a+=2){var s=t[a],l=t[a+1];Array.isArray(s)||(s=[s]);var u=e.concat(a);if(0===s.length)return u.error("Expected at least one branch label.");for(var c=0,p=s;c<p.length;c+=1){var h=p[c];if("number"!=typeof h&&"string"!=typeof h)return u.error("Branch labels must be numbers or strings.");if("number"==typeof h&&Math.abs(h)>Number.MAX_SAFE_INTEGER)return u.error("Branch labels must be integers no larger than "+Number.MAX_SAFE_INTEGER+".");if("number"==typeof h&&Math.floor(h)!==h)return u.error("Numeric branch labels must be integer values.");if(i){if(u.checkSubtype(i,ye(h)))return null}else i=ye(h);if(void 0!==n[String(h)])return u.error("Branch labels must be unique.");n[String(h)]=o.length}if(!(l=e.parse(l,a,r)))return null;r=r||l.type,o.push(l)}var d=e.parse(t[1],1,Qt);if(!d)return null;var f=e.parse(t[t.length-1],t.length-1,r);return!f||"value"!==d.type.kind&&e.concat(1).checkSubtype(i,d.type)?null:new bi(i,r,d,n,o,f)},bi.prototype.evaluate=function(t){var e=this.input.evaluate(t);return(ye(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)},bi.prototype.eachChild=function(t){t(this.input),this.outputs.forEach(t),t(this.otherwise)},bi.prototype.outputDefined=function(){return this.outputs.every(function(t){return t.outputDefined()})&&this.otherwise.outputDefined()},bi.prototype.serialize=function(){for(var t=this,e=["match",this.input.serialize()],i=[],r={},n=0,o=Object.keys(this.cases).sort();n<o.length;n+=1){var a=o[n];void 0===(p=r[this.cases[a]])?(r[this.cases[a]]=i.length,i.push([this.cases[a],[a]])):i[p][1].push(a)}for(var s=function(e){return"number"===t.inputType.kind?Number(e):e},l=0,u=i;l<u.length;l+=1){var c,p=(c=u[l])[0];1===(c=c[1]).length?e.push(s(c[0])):e.push(c.map(s)),e.push(this.outputs[outputIndex$1].serialize())}return e.push(this.otherwise.serialize()),e},wi.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found only "+(t.length-1)+".");if(t.length%2!=0)return e.error("Expected an odd number of arguments.");var i;e.expectedType&&"value"!==e.expectedType.kind&&(i=e.expectedType);for(var r=[],n=1;n<t.length-1;n+=2){var o=e.parse(t[n],n,Xt);if(!o)return null;var a=e.parse(t[n+1],n+1,i);if(!a)return null;r.push([o,a]),i=i||a.type}var s=e.parse(t[t.length-1],t.length-1,i);return s?new wi(i,r,s):null},wi.prototype.evaluate=function(t){for(var e=0,i=this.branches;e<i.length;e+=1){var r=(n=i[e])[0],n=n[1];if(r.evaluate(t))return n.evaluate(t)}return this.otherwise.evaluate(t)},wi.prototype.eachChild=function(t){for(var e=0,i=this.branches;e<i.length;e+=1){var r=(n=i[e])[0],n=n[1];t(r),t(n)}t(this.otherwise)},wi.prototype.outputDefined=function(){return this.branches.every(function(t){return t[0],t[1].outputDefined()})&&this.otherwise.outputDefined()},wi.prototype.serialize=function(){var t=["case"];return this.eachChild(function(e){t.push(e.serialize())}),t},Si.parse=function(t,e){if(t.length<=2||5<=t.length)return e.error("Expected 3 or 4 arguments, but found "+(t.length-1)+" instead.");var i=e.parse(t[1],1,Qt),r=e.parse(t[2],2,Wt);return i&&r?ae(i.type,[ie(Qt),Kt,Qt])?4!==t.length?new Si(i.type,i,r):(t=e.parse(t[3],3,Wt))?new Si(i.type,i,r,t):null:e.error("Expected first argument to be of type array or string, but found "+re(i.type)+" instead"):null},Si.prototype.evaluate=function(t){var e=this.input.evaluate(t),i=this.beginIndex.evaluate(t);if(!se(e,["string","array"]))throw new _e("Expected first argument to be of type array or string, but found "+re(ye(e))+" instead.");return this.endIndex?(t=this.endIndex.evaluate(t),e.slice(i,t)):e.slice(i)},Si.prototype.eachChild=function(t){t(this.input),t(this.beginIndex),this.endIndex&&t(this.endIndex)},Si.prototype.outputDefined=function(){return!1},Si.prototype.serialize=function(){if(null==this.endIndex||void 0===this.endIndex)return["slice",this.input.serialize(),this.beginIndex.serialize()];var t=this.endIndex.serialize();return["slice",this.input.serialize(),this.beginIndex.serialize(),t]};var ki=Ei("==",function(t,e,i){return e===i},Ci),Ai=Ei("!=",function(t,e,i){return e!==i},function(t,e,i,r){return!Ci(0,e,i,r)}),Pi=Ei("<",function(t,e,i){return e<i},function(t,e,i,r){return r.compare(e,i)<0}),Mi=Ei(">",function(t,e,i){return i<e},function(t,e,i,r){return 0<r.compare(e,i)}),Li=Ei("<=",function(t,e,i){return e<=i},function(t,e,i,r){return r.compare(e,i)<=0}),Oi=Ei(">=",function(t,e,i){return i<=e},function(t,e,i,r){return 0<=r.compare(e,i)});function Ri(t){this.type=Wt,this.input=t}Ii.parse=function(t,e){if(3!==t.length)return e.error("Expected two arguments.");var i=e.parse(t[1],1,Wt);if(!i)return null;var r=t[2];if("object"!=typeof r||Array.isArray(r))return e.error("NumberFormat options argument must be an object.");var n=null;if(r.locale&&!(n=e.parse(r.locale,1,Kt)))return null;var o=null;if(r.currency&&!(o=e.parse(r.currency,1,Kt)))return null;var a=null;return r["min-fraction-digits"]&&!(a=e.parse(r["min-fraction-digits"],1,Wt))?null:(t=null,r["max-fraction-digits"]&&!(t=e.parse(r["max-fraction-digits"],1,Wt))?null:new Ii(i,n,o,a,t))},Ii.prototype.evaluate=function(t){return new Intl.NumberFormat(this.locale?this.locale.evaluate(t):[],{style:this.currency?"currency":"decimal",currency:this.currency?this.currency.evaluate(t):void 0,minimumFractionDigits:this.minFractionDigits?this.minFractionDigits.evaluate(t):void 0,maximumFractionDigits:this.maxFractionDigits?this.maxFractionDigits.evaluate(t):void 0}).format(this.number.evaluate(t))},Ii.prototype.eachChild=function(t){t(this.number),this.locale&&t(this.locale),this.currency&&t(this.currency),this.minFractionDigits&&t(this.minFractionDigits),this.maxFractionDigits&&t(this.maxFractionDigits)},Ii.prototype.outputDefined=function(){return!1},Ii.prototype.serialize=function(){var t={};return this.locale&&(t.locale=this.locale.serialize()),this.currency&&(t.currency=this.currency.serialize()),this.minFractionDigits&&(t["min-fraction-digits"]=this.minFractionDigits.serialize()),this.maxFractionDigits&&(t["max-fraction-digits"]=this.maxFractionDigits.serialize()),["number-format",this.number.serialize(),t]},Ri.parse=function(t,e){return 2!==t.length?e.error("Expected 1 argument, but found "+(t.length-1)+" instead."):(t=e.parse(t[1],1))?"array"!==t.type.kind&&"string"!==t.type.kind&&"value"!==t.type.kind?e.error("Expected argument of type string or array, but found "+re(t.type)+" instead."):new Ri(t):null},Ri.prototype.evaluate=function(t){if("string"==typeof(t=this.input.evaluate(t)))return t.length;if(Array.isArray(t))return t.length;throw new _e("Expected value to be of type string or array, but found "+re(ye(t))+" instead.")},Ri.prototype.eachChild=function(t){t(this.input)},Ri.prototype.outputDefined=function(){return!1},Ri.prototype.serialize=function(){var t=["length"];return this.eachChild(function(e){t.push(e.serialize())}),t};var zi={"==":ki,"!=":Ai,">":Mi,"<":Pi,">=":Oi,"<=":Li,array:xe,at:vi,boolean:xe,case:wi,coalesce:yi,collator:Ae,format:we,image:Se,in:_i,"index-of":xi,interpolate:fi,"interpolate-hcl":fi,"interpolate-lab":fi,length:Ri,let:gi,literal:ve,match:bi,number:xe,"number-format":Ii,object:xe,slice:Si,step:Ye,string:xe,"to-boolean":Te,"to-color":Te,"to-number":Te,"to-string":Te,var:We,within:qe};function Di(t,e){var i=e[0],r=e[1],n=e[2];e=e[3];if(t=fe(i=i.evaluate(t),r=r.evaluate(t),n=n.evaluate(t),e=e?e.evaluate(t):1))throw new _e(t);return new ue(i/255*e,r/255*e,n/255*e,e)}function Ni(t,e){return void 0===(t=e[t])?null:t}function Bi(t){return{type:t}}function Fi(t){return{result:"success",value:t}}function Ui(t){return{result:"error",value:t}}function ji(t){return"data-driven"===t["property-type"]||"cross-faded-data-driven"===t["property-type"]}function Vi(t){return t.expression&&-1<t.expression.parameters.indexOf("zoom")}function qi(t){return t.expression&&t.expression.interpolated}function Hi(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function Gi(t){return"object"==typeof t&&null!==t&&!Array.isArray(t)}function Zi(t){return t}function Wi(t,e,i){return void 0!==t?t:void 0!==e?e:void 0!==i?i:void 0}function Ki(t,e,i,r,n){return Wi(typeof i===n?r[i]:void 0,t.default,e.default)}function Xi(t,e,i){return"number"!==Hi(i)?Wi(t.default,e.default):1===(e=t.stops.length)?t.stops[0][1]:i<=t.stops[0][0]?t.stops[0][1]:i>=t.stops[e-1][0]?t.stops[e-1][1]:(i=Xe(t.stops.map(function(t){return t[0]}),i),t.stops[i][1])}function Yi(t,e,i){var r=void 0!==t.base?t.base:1;if("number"!==Hi(i))return Wi(t.default,e.default);if(1===(o=t.stops.length))return t.stops[0][1];if(i<=t.stops[0][0])return t.stops[0][1];if(i>=t.stops[o-1][0])return t.stops[o-1][1];var n,o=Xe(t.stops.map(function(t){return t[0]}),i),a=function(t,e,i,r){return r-=i,i=t-i,0==r?0:1===e?i/r:(Math.pow(e,i)-1)/(Math.pow(e,r)-1)}(i,r,t.stops[o][0],t.stops[o+1][0]),s=t.stops[o][1],l=t.stops[o+1][1],u=Qe[e.type]||Zi;return t.colorSpace&&"rgb"!==t.colorSpace&&(n=di[t.colorSpace],u=function(t,e){return n.reverse(n.interpolate(n.forward(t),n.forward(e),a))}),"function"==typeof s.evaluate?{evaluate:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];var i=s.evaluate.apply(void 0,t),r=l.evaluate.apply(void 0,t);if(void 0!==i&&void 0!==r)return u(i,r,a)}}:u(s,l,a)}function Ji(t,e,i){return"color"===e.type?i=ue.parse(i):"formatted"===e.type?i=he.fromString(i.toString()):"resolvedImage"===e.type?i=de.fromString(i.toString()):Hi(i)===e.type||"enum"===e.type&&e.values[i]||(i=void 0),Wi(i,t.default,e.default)}ke.register(zi,{error:[{kind:"error"},[Kt],function(t,e){throw new _e((e=e[0]).evaluate(t))}],typeof:[Kt,[Qt],function(t,e){return re(ye(e[0].evaluate(t)))}],"to-rgba":[ie(Wt,4),[Yt],function(t,e){return e[0].evaluate(t).toArray()}],rgb:[Yt,[Wt,Wt,Wt],Di],rgba:[Yt,[Wt,Wt,Wt,Wt],Di],has:{type:Xt,overloads:[[[Kt],function(t,e){return e[0].evaluate(t)in t.properties()}],[[Kt,Jt],function(t,e){var i=e[0];e=e[1];return i.evaluate(t)in e.evaluate(t)}]]},get:{type:Qt,overloads:[[[Kt],function(t,e){return Ni(e[0].evaluate(t),t.properties())}],[[Kt,Jt],function(t,e){var i=e[0];e=e[1];return Ni(i.evaluate(t),e.evaluate(t))}]]},"feature-state":[Qt,[Kt],function(t,e){return Ni(e[0].evaluate(t),t.featureState||{})}],properties:[Jt,[],function(t){return t.properties()}],"geometry-type":[Kt,[],function(t){return t.geometryType()}],id:[Qt,[],function(t){return t.id()}],zoom:[Wt,[],function(t){return t.globals.zoom}],"heatmap-density":[Wt,[],function(t){return t.globals.heatmapDensity||0}],"line-progress":[Wt,[],function(t){return t.globals.lineProgress||0}],accumulated:[Qt,[],function(t){return void 0===t.globals.accumulated?null:t.globals.accumulated}],"+":[Wt,Bi(Wt),function(t,e){for(var i=0,r=0,n=e;r<n.length;r+=1)i+=n[r].evaluate(t);return i}],"*":[Wt,Bi(Wt),function(t,e){for(var i=1,r=0,n=e;r<n.length;r+=1)i*=n[r].evaluate(t);return i}],"-":{type:Wt,overloads:[[[Wt,Wt],function(t,e){var i=e[0];e=e[1];return i.evaluate(t)-e.evaluate(t)}],[[Wt],function(t,e){return-e[0].evaluate(t)}]]},"/":[Wt,[Wt,Wt],function(t,e){var i=e[0];e=e[1];return i.evaluate(t)/e.evaluate(t)}],"%":[Wt,[Wt,Wt],function(t,e){var i=e[0];e=e[1];return i.evaluate(t)%e.evaluate(t)}],ln2:[Wt,[],function(){return Math.LN2}],pi:[Wt,[],function(){return Math.PI}],e:[Wt,[],function(){return Math.E}],"^":[Wt,[Wt,Wt],function(t,e){var i=e[0];e=e[1];return Math.pow(i.evaluate(t),e.evaluate(t))}],sqrt:[Wt,[Wt],function(t,e){return e=e[0],Math.sqrt(e.evaluate(t))}],log10:[Wt,[Wt],function(t,e){return e=e[0],Math.log(e.evaluate(t))/Math.LN10}],ln:[Wt,[Wt],function(t,e){return e=e[0],Math.log(e.evaluate(t))}],log2:[Wt,[Wt],function(t,e){return e=e[0],Math.log(e.evaluate(t))/Math.LN2}],sin:[Wt,[Wt],function(t,e){return e=e[0],Math.sin(e.evaluate(t))}],cos:[Wt,[Wt],function(t,e){return e=e[0],Math.cos(e.evaluate(t))}],tan:[Wt,[Wt],function(t,e){return e=e[0],Math.tan(e.evaluate(t))}],asin:[Wt,[Wt],function(t,e){return e=e[0],Math.asin(e.evaluate(t))}],acos:[Wt,[Wt],function(t,e){return e=e[0],Math.acos(e.evaluate(t))}],atan:[Wt,[Wt],function(t,e){return e=e[0],Math.atan(e.evaluate(t))}],min:[Wt,Bi(Wt),function(t,e){return Math.min.apply(Math,e.map(function(e){return e.evaluate(t)}))}],max:[Wt,Bi(Wt),function(t,e){return Math.max.apply(Math,e.map(function(e){return e.evaluate(t)}))}],abs:[Wt,[Wt],function(t,e){return e=e[0],Math.abs(e.evaluate(t))}],round:[Wt,[Wt],function(t,e){return(t=e[0].evaluate(t))<0?-Math.round(-t):Math.round(t)}],floor:[Wt,[Wt],function(t,e){return e=e[0],Math.floor(e.evaluate(t))}],ceil:[Wt,[Wt],function(t,e){return e=e[0],Math.ceil(e.evaluate(t))}],"filter-==":[Xt,[Kt,Qt],function(t,e){var i=e[0];e=e[1];return t.properties()[i.value]===e.value}],"filter-id-==":[Xt,[Qt],function(t,e){return e=e[0],t.id()===e.value}],"filter-type-==":[Xt,[Kt],function(t,e){return e=e[0],t.geometryType()===e.value}],"filter-<":[Xt,[Kt,Qt],function(t,e){var i=e[0];e=e[1];return typeof(i=t.properties()[i.value])==typeof(e=e.value)&&i<e}],"filter-id-<":[Xt,[Qt],function(t,e){return e=e[0],typeof(t=t.id())==typeof(e=e.value)&&t<e}],"filter->":[Xt,[Kt,Qt],function(t,e){var i=e[0];e=e[1];return typeof(i=t.properties()[i.value])==typeof(e=e.value)&&e<i}],"filter-id->":[Xt,[Qt],function(t,e){return e=e[0],typeof(t=t.id())==typeof(e=e.value)&&e<t}],"filter-<=":[Xt,[Kt,Qt],function(t,e){var i=e[0];e=e[1];return typeof(i=t.properties()[i.value])==typeof(e=e.value)&&i<=e}],"filter-id-<=":[Xt,[Qt],function(t,e){return e=e[0],typeof(t=t.id())==typeof(e=e.value)&&t<=e}],"filter->=":[Xt,[Kt,Qt],function(t,e){var i=e[0];e=e[1];return typeof(i=t.properties()[i.value])==typeof(e=e.value)&&e<=i}],"filter-id->=":[Xt,[Qt],function(t,e){return e=e[0],typeof(t=t.id())==typeof(e=e.value)&&e<=t}],"filter-has":[Xt,[Qt],function(t,e){return e[0].value in t.properties()}],"filter-has-id":[Xt,[],function(t){return null!==t.id()&&void 0!==t.id()}],"filter-type-in":[Xt,[ie(Kt)],function(t,e){return 0<=e[0].value.indexOf(t.geometryType())}],"filter-id-in":[Xt,[ie(Qt)],function(t,e){return 0<=e[0].value.indexOf(t.id())}],"filter-in-small":[Xt,[Kt,ie(Qt)],function(t,e){var i=e[0];return 0<=e[1].value.indexOf(t.properties()[i.value])}],"filter-in-large":[Xt,[Kt,ie(Qt)],function(t,e){var i=e[0];e=e[1];return function(t,e,i,r){for(;i<=r;){var n=i+r>>1;if(e[n]===t)return!0;e[n]>t?r=n-1:i=1+n}return!1}(t.properties()[i.value],e.value,0,e.value.length-1)}],all:{type:Xt,overloads:[[[Xt,Xt],function(t,e){var i=e[0];e=e[1];return i.evaluate(t)&&e.evaluate(t)}],[Bi(Xt),function(t,e){for(var i=0,r=e;i<r.length;i+=1)if(!r[i].evaluate(t))return!1;return!0}]]},any:{type:Xt,overloads:[[[Xt,Xt],function(t,e){var i=e[0];e=e[1];return i.evaluate(t)||e.evaluate(t)}],[Bi(Xt),function(t,e){for(var i=0,r=e;i<r.length;i+=1)if(r[i].evaluate(t))return!0;return!1}]]},"!":[Xt,[Xt],function(t,e){return!e[0].evaluate(t)}],"is-supported-script":[Xt,[Kt],function(t,e){var i=e[0];return!(e=t.globals&&t.globals.isSupportedScript)||e(i.evaluate(t))}],upcase:[Kt,[Kt],function(t,e){return e[0].evaluate(t).toUpperCase()}],downcase:[Kt,[Kt],function(t,e){return e[0].evaluate(t).toLowerCase()}],concat:[Kt,Bi(Qt),function(t,e){return e.map(function(e){return ge(e.evaluate(t))}).join("")}],"resolved-locale":[Kt,[$t],function(t,e){return e[0].evaluate(t).resolvedLocale()}]});var Qi=function(t,e){this.expression=t,this._warningHistory={},this._evaluator=new Ee,this._defaultValue=e?"color"===(t=e).type&&Gi(t.default)?new ue(0,0,0,0):"color"===t.type?ue.parse(t.default)||null:void 0===t.default?null:t.default:null,this._enumValues=e&&"enum"===e.type?e.values:null};function $i(t){return Array.isArray(t)&&0<t.length&&"string"==typeof t[0]&&t[0]in zi}function tr(t,e){var i,r;return(t=(r=new Ke(zi,[],e?(i={color:Yt,string:Kt,number:Wt,enum:Kt,boolean:Xt,formatted:te,resolvedImage:ee},"array"!==(r=e).type?i[r.type]:ie(i[r.value]||Qt,r.length)):void 0)).parse(t,void 0,void 0,void 0,e&&"string"===e.type?{typeAnnotation:"coerce"}:void 0))?Fi(new Qi(t,e)):Ui(r.errors)}function er(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!Ge(e.expression)}function ir(t,e,i,r){this.kind=t,this.zoomStops=i,this._styleExpression=e,this.isStateDependent="camera"!==t&&!Ge(e.expression),this.interpolationType=r}function rr(t,e){if("error"===(t=tr(t,e)).result)return t;var i=t.value.expression,r=He(i);if(!r&&!ji(e))return Ui([new qt("","data expressions not supported")]);var n=Ze(i,["zoom"]);return n||Vi(e)?(i=function t(e){var i=null;if(e instanceof gi)i=t(e.result);else if(e instanceof yi)for(var r=0,n=e.args;r<n.length;r+=1){var o=n[r];if(i=t(o))break}else(e instanceof Ye||e instanceof fi)&&e.input instanceof ke&&"zoom"===e.input.name&&(i=e);return i instanceof qt?i:(e.eachChild(function(e){(e=t(e))instanceof qt?i=e:!i&&e?i=new qt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):i&&e&&i!==e&&(i=new qt("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'))}),i)}(i))||n?i instanceof qt?Ui([i]):i instanceof fi&&!qi(e)?Ui([new qt("",'"interpolate" expressions cannot be used with this property')]):i?(e=i instanceof fi?i.interpolation:void 0,Fi(new ir(r?"camera":"composite",t.value,i.labels,e))):Fi(new er(r?"constant":"source",t.value)):Ui([new qt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]):Ui([new qt("","zoom expressions not supported")])}Qi.prototype.evaluateWithoutErrorHandling=function(t,e,i,r,n,o){return this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=i,this._evaluator.canonical=r,this._evaluator.availableImages=n||null,this._evaluator.formattedSection=o,this.expression.evaluate(this._evaluator)},Qi.prototype.evaluate=function(t,e,i,r,n,o){this._evaluator.globals=t,this._evaluator.feature=e||null,this._evaluator.featureState=i||null,this._evaluator.canonical=r,this._evaluator.availableImages=n||null,this._evaluator.formattedSection=o||null;try{var a=this.expression.evaluate(this._evaluator);if(null==a||"number"==typeof a&&a!=a)return this._defaultValue;if(this._enumValues&&!(a in this._enumValues))throw new _e("Expected value to be one of "+Object.keys(this._enumValues).map(function(t){return JSON.stringify(t)}).join(", ")+", but found "+JSON.stringify(a)+" instead.");return a}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}},er.prototype.evaluateWithoutErrorHandling=function(t,e,i,r,n,o){return this._styleExpression.evaluateWithoutErrorHandling(t,e,i,r,n,o)},er.prototype.evaluate=function(t,e,i,r,n,o){return this._styleExpression.evaluate(t,e,i,r,n,o)},ir.prototype.evaluateWithoutErrorHandling=function(t,e,i,r,n,o){return this._styleExpression.evaluateWithoutErrorHandling(t,e,i,r,n,o)},ir.prototype.evaluate=function(t,e,i,r,n,o){return this._styleExpression.evaluate(t,e,i,r,n,o)},ir.prototype.interpolationFactor=function(t,e,i){return this.interpolationType?fi.interpolationFactor(this.interpolationType,t,e,i):0};var nr=function(t,e){this._parameters=t,this._specification=e,Ft(this,function t(e,i){var r,n="color"===i.type,o=e.stops&&"object"==typeof e.stops[0][0],a=o||void 0!==e.property,s=o||!a;a=e.type||(qi(i)?"exponential":"interval");if(n&&((e=Ft({},e)).stops&&(e.stops=e.stops.map(function(t){return[t[0],ue.parse(t[1])]})),e.default?e.default=ue.parse(e.default):e.default=ue.parse(i.default)),e.colorSpace&&"rgb"!==e.colorSpace&&!di[e.colorSpace])throw new Error("Unknown color space: "+e.colorSpace);if("exponential"===a)l=Yi;else if("interval"===a)l=Xi;else if("categorical"===a){for(var l=Ki,u=Object.create(null),c=0,p=e.stops;c<p.length;c+=1){var h=p[c];u[h[0]]=h[1]}r=typeof e.stops[0][0]}else{if("identity"!==a)throw new Error('Unknown function type "'+a+'"');l=Ji}if(o){for(var d={},f=[],m=0;m<e.stops.length;m++){var y=e.stops[m],g=y[0].zoom;void 0===d[g]&&(d[g]={zoom:g,type:e.type,property:e.property,default:e.default,stops:[]},f.push(g)),d[g].stops.push([y[0].value,y[1]])}for(var v=[],_=0,x=f;_<x.length;_+=1){var b=x[_];v.push([d[b].zoom,t(d[b],i)])}return{kind:"composite",interpolationType:o={name:"linear"},interpolationFactor:fi.interpolationFactor.bind(void 0,o),zoomStops:v.map(function(t){return t[0]}),evaluate:function(t,r){return t=t.zoom,Yi({stops:v,base:e.base},i,t).evaluate(t,r)}}}return s?{kind:"camera",interpolationType:a="exponential"===a?{name:"exponential",base:void 0!==e.base?e.base:1}:null,interpolationFactor:fi.interpolationFactor.bind(void 0,a),zoomStops:e.stops.map(function(t){return t[0]}),evaluate:function(t){return t=t.zoom,l(e,i,t,u,r)}}:{kind:"source",evaluate:function(t,n){return void 0===(n=n&&n.properties?n.properties[e.property]:void 0)?Wi(e.default,i.default):l(e,i,n,u,r)}}}(this._parameters,this._specification))};function or(t){var e,i,r=t.key,n=t.value,o=t.valueSpec||{},a=t.objectElementValidators||{},s=t.style,l=t.styleSpec,u=[];if("object"!==(t=Hi(n)))return[new Nt(r,n,"object expected, "+t+" found")];for(e in n){var c=e.split(".")[0],p=o[c]||o["*"],h=void 0;if(a[c])h=a[c];else if(o[c])h=Pr;else if(a["*"])h=a["*"];else{if(!o["*"]){u.push(new Nt(r,n[e],'unknown property "'+e+'"'));continue}h=Pr}u=u.concat(h({key:(r&&r+".")+e,value:n[e],valueSpec:p,style:s,styleSpec:l,object:n,objectKey:e},n))}for(i in o)a[i]||o[i].required&&void 0===o[i].default&&void 0===n[i]&&u.push(new Nt(r,n,'missing required property "'+i+'"'));return u}function ar(t){var e=t.value,i=t.valueSpec,r=t.style,n=t.styleSpec,o=t.key,a=t.arrayElementValidator||Pr;if("array"!==Hi(e))return[new Nt(o,e,"array expected, "+Hi(e)+" found")];if(i.length&&e.length!==i.length)return[new Nt(o,e,"array length "+i.length+" expected, length "+e.length+" found")];if(i["min-length"]&&e.length<i["min-length"])return[new Nt(o,e,"array length at least "+i["min-length"]+" expected, length "+e.length+" found")];var s={type:i.value,values:i.values};n.$version<7&&(s.function=i.function),"object"===Hi(i.value)&&(s=i.value);for(var l=[],u=0;u<e.length;u++)l=l.concat(a({array:e,arrayIndex:u,value:e[u],valueSpec:s,style:r,styleSpec:n,key:o+"["+u+"]"}));return l}function sr(t){var e=t.key,i=t.value,r=t.valueSpec;return"number"!==(t="number"===(t=Hi(i))&&i!=i?"NaN":t)?[new Nt(e,i,"number expected, "+t+" found")]:"minimum"in r&&i<r.minimum?[new Nt(e,i,i+" is less than the minimum value "+r.minimum)]:"maximum"in r&&i>r.maximum?[new Nt(e,i,i+" is greater than the maximum value "+r.maximum)]:[]}function lr(t){var e,i,r,n=t.valueSpec,o=Ut(t.value.type),a={},s="categorical"!==o&&void 0===t.value.property,l=!s,u="array"===Hi(t.value.stops)&&"array"===Hi(t.value.stops[0])&&"object"===Hi(t.value.stops[0][0]),c=or({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===o)return[new Nt(t.key,t.value,'identity function may not have a "stops" property')];var e=[],i=t.value;return e=e.concat(ar({key:t.key,value:i,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:p})),"array"===Hi(i)&&0===i.length&&e.push(new Nt(t.key,i,"array must have at least one stop")),e},default:function(t){return Pr({key:t.key,value:t.value,valueSpec:n,style:t.style,styleSpec:t.styleSpec})}}});return"identity"===o&&s&&c.push(new Nt(t.key,t.value,'missing required property "property"')),"identity"===o||t.value.stops||c.push(new Nt(t.key,t.value,'missing required property "stops"')),"exponential"===o&&t.valueSpec.expression&&!qi(t.valueSpec)&&c.push(new Nt(t.key,t.value,"exponential functions not supported")),8<=t.styleSpec.$version&&(l&&!ji(t.valueSpec)?c.push(new Nt(t.key,t.value,"property functions not supported")):s&&!Vi(t.valueSpec)&&c.push(new Nt(t.key,t.value,"zoom functions not supported"))),"categorical"!==o&&!u||void 0!==t.value.property||c.push(new Nt(t.key,t.value,'"property" property is required')),c;function p(t){var e=[],o=t.value,s=t.key;if("array"!==Hi(o))return[new Nt(s,o,"array expected, "+Hi(o)+" found")];if(2!==o.length)return[new Nt(s,o,"array length 2 expected, length "+o.length+" found")];if(u){if("object"!==Hi(o[0]))return[new Nt(s,o,"object expected, "+Hi(o[0])+" found")];if(void 0===o[0].zoom)return[new Nt(s,o,"object stop key must have zoom")];if(void 0===o[0].value)return[new Nt(s,o,"object stop key must have value")];if(r&&r>Ut(o[0].zoom))return[new Nt(s,o[0].zoom,"stop zoom values must appear in ascending order")];Ut(o[0].zoom)!==r&&(r=Ut(o[0].zoom),i=void 0,a={}),e=e.concat(or({key:s+"[0]",value:o[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:sr,value:h}}))}else e=e.concat(h({key:s+"[0]",value:o[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},o));return $i(jt(o[1]))?e.concat([new Nt(s+"[1]",o[1],"expressions are not allowed in function stops.")]):e.concat(Pr({key:s+"[1]",value:o[1],valueSpec:n,style:t.style,styleSpec:t.styleSpec}))}function h(t,r){var s=Hi(t.value),l=Ut(t.value);r=null!==t.value?t.value:r;if(e){if(s!==e)return[new Nt(t.key,r,s+" stop domain type must match previous stop domain type "+e)]}else e=s;return"number"!==s&&"string"!==s&&"boolean"!==s?[new Nt(t.key,r,"stop domain value must be a number, string, or boolean")]:"number"===s||"categorical"===o?"categorical"!==o||"number"!==s||isFinite(l)&&Math.floor(l)===l?"categorical"!==o&&"number"===s&&void 0!==i&&l<i?[new Nt(t.key,r,"stop domain values must appear in ascending order")]:(i=l,"categorical"===o&&l in a?[new Nt(t.key,r,"stop domain values must be unique")]:(a[l]=!0,[])):[new Nt(t.key,r,"integer expected, found "+l)]:(s="number expected, "+s+" found",ji(n)&&void 0===o&&(s+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new Nt(t.key,r,s)])}}function ur(t){var e=("property"===t.expressionContext?rr:tr)(jt(t.value),t.valueSpec);if("error"===e.result)return e.value.map(function(e){return new Nt(""+t.key+e.key,t.value,e.message)});if(e=e.value.expression||e.value._styleExpression.expression,"property"===t.expressionContext&&"text-font"===t.propertyKey&&!e.outputDefined())return[new Nt(t.key,t.value,'Invalid data expression for "'+t.propertyKey+'". Output values must be contained as literals within the expression.')];if("property"===t.expressionContext&&"layout"===t.propertyType&&!Ge(e))return[new Nt(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')];if("filter"===t.expressionContext&&!Ge(e))return[new Nt(t.key,t.value,'"feature-state" data expressions are not supported with filters.')];if(t.expressionContext&&0===t.expressionContext.indexOf("cluster")){if(!Ze(e,["zoom","feature-state"]))return[new Nt(t.key,t.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];if("cluster-initial"===t.expressionContext&&!He(e))return[new Nt(t.key,t.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]}return[]}function cr(t){var e=t.key,i=t.value,r=t.valueSpec;t=[];return Array.isArray(r.values)?-1===r.values.indexOf(Ut(i))&&t.push(new Nt(e,i,"expected one of ["+r.values.join(", ")+"], "+JSON.stringify(i)+" found")):-1===Object.keys(r.values).indexOf(Ut(i))&&t.push(new Nt(e,i,"expected one of ["+Object.keys(r.values).join(", ")+"], "+JSON.stringify(i)+" found")),t}function pr(t){if(!0===t||!1===t)return 1;if(Array.isArray(t)&&0!==t.length)switch(t[0]){case"has":return 2<=t.length&&"$id"!==t[1]&&"$type"!==t[1];case"in":return 3<=t.length&&("string"!=typeof t[1]||Array.isArray(t[2]));case"!in":case"!has":case"none":return;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(var e=0,i=t.slice(1);e<i.length;e+=1){var r=i[e];if(!pr(r)&&"boolean"!=typeof r)return}return 1;default:return 1}}nr.deserialize=function(t){return new nr(t._parameters,t._specification)};var hr={type:"boolean",default:!(nr.serialize=function(t){return{_parameters:t._parameters,_specification:t._specification}}),transition:!1,"property-type":"data-driven",expression:{interpolated:!1,parameters:["zoom","feature"]}};function dr(t){if(null==t)return{filter:function(){return!0},needGeometry:!1};var e=tr(t=pr(t)?t:mr(t),hr);if("error"===e.result)throw new Error(e.value.map(function(t){return t.key+": "+t.message}).join(", "));return{filter:function(t,i,r){return e.value.evaluate(t,i,{},r)},needGeometry:function t(e){if(!Array.isArray(e))return!1;if("within"===e[0])return!0;for(var i=1;i<e.length;i++)if(t(e[i]))return!0;return!1}(t)}}function fr(t,e){return t<e?-1:e<t?1:0}function mr(t){if(!t)return!0;var e,i=t[0];return t.length<=1?"any"!==i:"=="===i?yr(t[1],t[2],"=="):"!="===i?_r(yr(t[1],t[2],"==")):"<"===i||">"===i||"<="===i||">="===i?yr(t[1],t[2],i):"any"===i?(e=t.slice(1),["any"].concat(e.map(mr))):"all"===i?["all"].concat(t.slice(1).map(mr)):"none"===i?["all"].concat(t.slice(1).map(mr).map(_r)):"in"===i?gr(t[1],t.slice(2)):"!in"===i?_r(gr(t[1],t.slice(2))):"has"===i?vr(t[1]):"!has"===i?_r(vr(t[1])):"within"!==i||t}function yr(t,e,i){switch(t){case"$type":return["filter-type-"+i,e];case"$id":return["filter-id-"+i,e];default:return["filter-"+i,t,e]}}function gr(t,e){if(0===e.length)return!1;switch(t){case"$type":return["filter-type-in",["literal",e]];case"$id":return["filter-id-in",["literal",e]];default:return 200<e.length&&!e.some(function(t){return typeof t!=typeof e[0]})?["filter-in-large",t,["literal",e.sort(fr)]]:["filter-in-small",t,["literal",e]]}}function vr(t){switch(t){case"$type":return!0;case"$id":return["filter-has-id"];default:return["filter-has",t]}}function _r(t){return["!",t]}function xr(t){return pr(jt(t.value))?ur(Ft({},t,{expressionContext:"filter",valueSpec:{value:"boolean"}})):function t(e){var i=e.value,r=e.key;if("array"!==Hi(i))return[new Nt(r,i,"array expected, "+Hi(i)+" found")];var n,o=e.styleSpec,a=[];if(i.length<1)return[new Nt(r,i,"filter array must have at least 1 element")];switch(a=a.concat(cr({key:r+"[0]",value:i[0],valueSpec:o.filter_operator,style:e.style,styleSpec:e.styleSpec})),Ut(i[0])){case"<":case"<=":case">":case">=":2<=i.length&&"$type"===Ut(i[1])&&a.push(new Nt(r,i,'"$type" cannot be use with operator "'+i[0]+'"'));case"==":case"!=":3!==i.length&&a.push(new Nt(r,i,'filter array for operator "'+i[0]+'" must have 3 elements'));case"in":case"!in":2<=i.length&&"string"!==(n=Hi(i[1]))&&a.push(new Nt(r+"[1]",i[1],"string expected, "+n+" found"));for(var s=2;s<i.length;s++)n=Hi(i[s]),"$type"===Ut(i[1])?a=a.concat(cr({key:r+"["+s+"]",value:i[s],valueSpec:o.geometry_type,style:e.style,styleSpec:e.styleSpec})):"string"!==n&&"number"!==n&&"boolean"!==n&&a.push(new Nt(r+"["+s+"]",i[s],"string, number, or boolean expected, "+n+" found"));break;case"any":case"all":case"none":for(var l=1;l<i.length;l++)a=a.concat(t({key:r+"["+l+"]",value:i[l],style:e.style,styleSpec:e.styleSpec}));break;case"has":case"!has":n=Hi(i[1]),2!==i.length?a.push(new Nt(r,i,'filter array for "'+i[0]+'" operator must have 2 elements')):"string"!==n&&a.push(new Nt(r+"[1]",i[1],"string expected, "+n+" found"));break;case"within":n=Hi(i[1]),2!==i.length?a.push(new Nt(r,i,'filter array for "'+i[0]+'" operator must have 2 elements')):"object"!==n&&a.push(new Nt(r+"[1]",i[1],"object expected, "+n+" found"))}return a}(t)}function br(t,e){var i=t.key,r=t.style,n=t.styleSpec,o=t.value,a=t.objectKey,s=n[e+"_"+t.layerType];if(!s)return[];var l=a.match(/^(.*)-transition$/);if("paint"===e&&l&&s[l[1]]&&s[l[1]].transition)return Pr({key:i,value:o,valueSpec:n.transition,style:r,styleSpec:n});if(!(s=t.valueSpec||s[a]))return[new Nt(i,o,'unknown property "'+a+'"')];if("string"===Hi(o)&&ji(s)&&!s.tokens&&(u=/^{([^}]+)}$/.exec(o)))return[new Nt(i,o,'"'+a+'" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": '+JSON.stringify(u[1])+" }`.")];var u=[];return"symbol"===t.layerType&&("text-field"===a&&r&&!r.glyphs&&u.push(new Nt(i,o,'use of "text-field" requires a style "glyphs" property')),"text-font"===a&&Gi(jt(o))&&"identity"===Ut(o.type)&&u.push(new Nt(i,o,'"text-font" does not support identity functions'))),u.concat(Pr({key:t.key,value:o,valueSpec:s,style:r,styleSpec:n,expressionContext:"property",propertyType:e,propertyKey:a}))}function wr(t){return br(t,"paint")}function Sr(t){return br(t,"layout")}function Tr(t){var e=[],i=t.value,r=t.key,n=t.style,o=t.styleSpec;i.type||i.ref||e.push(new Nt(r,i,'either "type" or "ref" is required'));var a,s,l,u=Ut(i.type),c=Ut(i.ref);if(i.id)for(var p=Ut(i.id),h=0;h<t.arrayIndex;h++){var d=n.layers[h];Ut(d.id)===p&&e.push(new Nt(r,i.id,'duplicate layer id "'+i.id+'", previously used at line '+d.id.__line__))}return"ref"in i?(["type","source","source-layer","filter","layout"].forEach(function(t){t in i&&e.push(new Nt(r,i[t],'"'+t+'" is prohibited for ref layers'))}),n.layers.forEach(function(t){Ut(t.id)===c&&(a=t)}),a?a.ref?e.push(new Nt(r,i.ref,"ref cannot reference another ref layer")):u=Ut(a.type):e.push(new Nt(r,i.ref,'ref layer "'+c+'" not found'))):"background"!==u&&(i.source?(l=(s=n.sources&&n.sources[i.source])&&Ut(s.type),s?"vector"===l&&"raster"===u?e.push(new Nt(r,i.source,'layer "'+i.id+'" requires a raster source')):"raster"===l&&"raster"!==u?e.push(new Nt(r,i.source,'layer "'+i.id+'" requires a vector source')):"vector"!==l||i["source-layer"]?"raster-dem"===l&&"hillshade"!==u?e.push(new Nt(r,i.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==u||!i.paint||!i.paint["line-gradient"]||"geojson"===l&&s.lineMetrics||e.push(new Nt(r,i,'layer "'+i.id+'" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')):e.push(new Nt(r,i,'layer "'+i.id+'" must specify a "source-layer"')):e.push(new Nt(r,i.source,'source "'+i.source+'" not found'))):e.push(new Nt(r,i,'missing required property "source"'))),e=e.concat(or({key:r,value:i,valueSpec:o.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(){return[]},type:function(){return Pr({key:r+".type",value:i.type,valueSpec:o.layer.type,style:t.style,styleSpec:t.styleSpec,object:i,objectKey:"type"})},filter:xr,layout:function(t){return or({layer:i,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return Sr(Ft({layerType:u},t))}}})},paint:function(t){return or({layer:i,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return wr(Ft({layerType:u},t))}}})}}}))}function Cr(t){var e=t.value,i=t.key;return"string"!==(t=Hi(e))?[new Nt(i,e,"string expected, "+t+" found")]:[]}var Er={promoteId:function(t){var e=t.key,i=t.value;if("string"===Hi(i))return Cr({key:e,value:i});var r,n=[];for(r in i)n.push.apply(n,Cr({key:e+"."+r,value:i[r]}));return n}};function Ir(t){var e=t.value,i=t.key,r=t.styleSpec,n=t.style;if(!e.type)return[new Nt(i,e,'"type" is required')];var o,a=Ut(e.type);switch(a){case"vector":case"raster":case"raster-dem":return or({key:i,value:e,valueSpec:r["source_"+a.replace("-","_")],style:t.style,styleSpec:r,objectElementValidators:Er});case"geojson":if(o=or({key:i,value:e,valueSpec:r.source_geojson,style:n,styleSpec:r,objectElementValidators:Er}),e.cluster)for(var s in e.clusterProperties){var l=(u=e.clusterProperties[s])[0],u=u[1];l="string"==typeof l?[l,["accumulated"],["get",s]]:l;o.push.apply(o,ur({key:i+"."+s+".map",value:u,expressionContext:"cluster-map"})),o.push.apply(o,ur({key:i+"."+s+".reduce",value:l,expressionContext:"cluster-reduce"}))}return o;case"video":return or({key:i,value:e,valueSpec:r.source_video,style:n,styleSpec:r});case"image":return or({key:i,value:e,valueSpec:r.source_image,style:n,styleSpec:r});case"canvas":return[new Nt(i,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];default:return cr({key:i+".type",value:e.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image"]},style:n,styleSpec:r})}}function kr(t){var e,i=t.value,r=t.styleSpec,n=r.light,o=t.style,a=[];t=Hi(i);if(void 0===i)return a;if("object"!==t)return a.concat([new Nt("light",i,"object expected, "+t+" found")]);for(e in i){var s=e.match(/^(.*)-transition$/);a=s&&n[s[1]]&&n[s[1]].transition?a.concat(Pr({key:e,value:i[e],valueSpec:r.transition,style:o,styleSpec:r})):n[e]?a.concat(Pr({key:e,value:i[e],valueSpec:n[e],style:o,styleSpec:r})):a.concat([new Nt(e,i[e],'unknown property "'+e+'"')])}return a}var Ar={"*":function(){return[]},array:ar,boolean:function(t){var e=t.value,i=t.key;return"boolean"!==(t=Hi(e))?[new Nt(i,e,"boolean expected, "+t+" found")]:[]},number:sr,color:function(t){var e=t.key,i=t.value;return"string"!==(t=Hi(i))?[new Nt(e,i,"color expected, "+t+" found")]:null===le(i)?[new Nt(e,i,'color expected, "'+i+'" found')]:[]},constants:Bt,enum:cr,filter:xr,function:lr,layer:Tr,object:or,source:Ir,light:kr,string:Cr,formatted:function(t){return 0===Cr(t).length?[]:ur(t)},resolvedImage:function(t){return 0===Cr(t).length?[]:ur(t)}};function Pr(t){var e=t.value,i=t.valueSpec,r=t.styleSpec;return i.expression&&Gi(Ut(e))?lr(t):i.expression&&$i(jt(e))?ur(t):i.type&&Ar[i.type]?Ar[i.type](t):or(Ft({},t,{valueSpec:i.type?r[i.type]:i}))}function Mr(t){var e=t.value,i=t.key;return(t=Cr(t)).length||(-1===e.indexOf("{fontstack}")&&t.push(new Nt(i,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&t.push(new Nt(i,e,'"glyphs" url must include a "{range}" token'))),t}function Lr(t,e){var i=(i=[]).concat(Pr({key:"",value:t,valueSpec:(e=void 0===e?Dt:e).$root,styleSpec:e,style:t,objectElementValidators:{glyphs:Mr,"*":function(){return[]}}}));return Or(i=t.constants?i.concat(Bt({key:"constants",value:t.constants,style:t,styleSpec:e})):i)}function Or(t){return[].concat(t).sort(function(t,e){return t.line-e.line})}function Rr(t){return function(){for(var e=[],i=arguments.length;i--;)e[i]=arguments[i];return Or(t.apply(this,e))}}Lr.source=Rr(Ir),Lr.light=Rr(kr),Lr.layer=Rr(Tr),Lr.filter=Rr(xr),Lr.paintProperty=Rr(wr),Lr.layoutProperty=Rr(Sr);var zr=Lr,Dr=zr.light,Nr=zr.paintProperty,Br=zr.layoutProperty;function Fr(t,e){var i=!1;if(e&&e.length)for(var r=0,n=e;r<n.length;r+=1){var o=n[r];t.fire(new Ot(new Error(o.message))),i=!0}return i}var Ur=Vr,jr=3;function Vr(t,e,i){var r=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var n=new Int32Array(this.arrayBuffer);t=n[0],e=n[1],i=n[2],this.d=e+2*i;for(var o=0;o<this.d*this.d;o++){var a=n[jr+o],s=n[jr+o+1];r.push(a===s?null:n.subarray(a,s))}var l=n[jr+r.length],u=n[jr+r.length+1];this.keys=n.subarray(l,u),this.bboxes=n.subarray(u),this.insert=this._insertReadonly}else{this.d=e+2*i;for(var c=0;c<this.d*this.d;c++)r.push([]);this.keys=[],this.bboxes=[]}this.n=e,this.extent=t,this.padding=i,this.scale=e/t,this.uid=0,e=i/e*t,this.min=-e,this.max=t+e}Vr.prototype.insert=function(t,e,i,r,n){this._forEachCell(e,i,r,n,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(e),this.bboxes.push(i),this.bboxes.push(r),this.bboxes.push(n)},Vr.prototype._insertReadonly=function(){throw"Cannot insert into a GridIndex created from an ArrayBuffer."},Vr.prototype._insertCell=function(t,e,i,r,n,o){this.cells[n].push(o)},Vr.prototype.query=function(t,e,i,r,n){var o=this.min,a=this.max;return t<=o&&e<=o&&a<=i&&a<=r&&!n?Array.prototype.slice.call(this.keys):(a=[],this._forEachCell(t,e,i,r,this._queryCell,a,{},n),a)},Vr.prototype._queryCell=function(t,e,i,r,n,o,a,s){var l=this.cells[n];if(null!==l)for(var u=this.keys,c=this.bboxes,p=0;p<l.length;p++){var h,d=l[p];void 0===a[d]&&(h=4*d,(s?s(c[0+h],c[1+h],c[2+h],c[3+h]):t<=c[2+h]&&e<=c[3+h]&&i>=c[0+h]&&r>=c[1+h])?(a[d]=!0,o.push(u[d])):a[d]=!1)}},Vr.prototype._forEachCell=function(t,e,i,r,n,o,a,s){for(var l=this._convertToCellCoord(t),u=this._convertToCellCoord(e),c=this._convertToCellCoord(i),p=this._convertToCellCoord(r),h=l;h<=c;h++)for(var d=u;d<=p;d++){var f=this.d*d+h;if((!s||s(this._convertFromCellCoord(h),this._convertFromCellCoord(d),this._convertFromCellCoord(h+1),this._convertFromCellCoord(d+1)))&&n.call(this,t,e,i,r,f,o,a,s))return}},Vr.prototype._convertFromCellCoord=function(t){return(t-this.padding)/this.scale},Vr.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},Vr.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,e=jr+this.cells.length+1+1,i=0,r=0;r<this.cells.length;r++)i+=this.cells[r].length;var n=new Int32Array(e+i+this.keys.length+this.bboxes.length);n[0]=this.extent,n[1]=this.n,n[2]=this.padding;for(var o=e,a=0;a<t.length;a++){var s=t[a];n[jr+a]=o,n.set(s,o),o+=s.length}return n[jr+t.length]=o,n.set(this.keys,o),o+=this.keys.length,n[jr+t.length+1]=o,n.set(this.bboxes,o),o+=this.bboxes.length,n.buffer};var qr,Hr=s.ImageData,Gr=s.ImageBitmap,Zr={};function Wr(t,e,i){void 0===i&&(i={}),Object.defineProperty(e,"_classRegistryKey",{value:t,writeable:!1}),Zr[t]={klass:e,omit:i.omit||[],shallow:i.shallow||[]}}for(qr in Wr("Object",Object),Ur.serialize=function(t,e){return t=t.toArrayBuffer(),e&&e.push(t),{buffer:t}},Ur.deserialize=function(t){return new Ur(t.buffer)},Wr("Grid",Ur),Wr("Color",ue),Wr("Error",Error),Wr("ResolvedImage",de),Wr("StylePropertyFunction",nr),Wr("StyleExpression",Qi,{omit:["_evaluator"]}),Wr("ZoomDependentExpression",ir),Wr("ZoomConstantExpression",er),Wr("CompoundExpression",ke,{omit:["_evaluate"]}),zi)zi[qr]._classRegistryKey||Wr("Expression_"+qr,zi[qr]);function Kr(t){return t&&"undefined"!=typeof ArrayBuffer&&(t instanceof ArrayBuffer||t.constructor&&"ArrayBuffer"===t.constructor.name)}function Xr(t){return Gr&&t instanceof Gr}function Yr(t,e){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp)return t;if(Kr(t)||Xr(t))return e&&e.push(t),t;if(ArrayBuffer.isView(t)){var i=t;return e&&e.push(i.buffer),i}if(t instanceof Hr)return e&&e.push(t.data.buffer),t;if(Array.isArray(t)){for(var r=[],n=0,o=t;n<o.length;n+=1){var a=o[n];r.push(Yr(a,e))}return r}if("object"!=typeof t)throw new Error("can't serialize object of type "+typeof t);var s=(i=t.constructor)._classRegistryKey;if(!s)throw new Error("can't serialize object of unregistered class");var l,u=i.serialize?i.serialize(t,e):{};if(!i.serialize){for(var c in t)t.hasOwnProperty(c)&&(0<=Zr[s].omit.indexOf(c)||(l=t[c],u[c]=0<=Zr[s].shallow.indexOf(c)?l:Yr(l,e)));t instanceof Error&&(u.message=t.message)}if(u.$name)throw new Error("$name property is reserved for worker serialization logic.");return"Object"!==s&&(u.$name=s),u}function Jr(t){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp||Kr(t)||Xr(t)||ArrayBuffer.isView(t)||t instanceof Hr)return t;if(Array.isArray(t))return t.map(Jr);if("object"!=typeof t)throw new Error("can't deserialize object of type "+typeof t);var e=t.$name||"Object",i=Zr[e].klass;if(!i)throw new Error("can't deserialize unregistered class "+e);if(i.deserialize)return i.deserialize(t);for(var r=Object.create(i.prototype),n=0,o=Object.keys(t);n<o.length;n+=1){var a,s=o[n];"$name"!==s&&(a=t[s],r[s]=0<=Zr[e].shallow.indexOf(s)?a:Jr(a))}return r}function Qr(){this.first=!0}Qr.prototype.update=function(t,e){var i=Math.floor(t);return this.first?(this.first=!1,this.lastIntegerZoom=i,this.lastIntegerZoomTime=0,this.lastZoom=t,this.lastFloorZoom=i,!0):(this.lastFloorZoom>i?(this.lastIntegerZoom=i+1,this.lastIntegerZoomTime=e):this.lastFloorZoom<i&&(this.lastIntegerZoom=i,this.lastIntegerZoomTime=e),t!==this.lastZoom&&(this.lastZoom=t,this.lastFloorZoom=i,!0))};var $r={"Latin-1 Supplement":function(t){return 128<=t&&t<=255},Arabic:function(t){return 1536<=t&&t<=1791},"Arabic Supplement":function(t){return 1872<=t&&t<=1919},"Arabic Extended-A":function(t){return 2208<=t&&t<=2303},"Hangul Jamo":function(t){return 4352<=t&&t<=4607},"Unified Canadian Aboriginal Syllabics":function(t){return 5120<=t&&t<=5759},Khmer:function(t){return 6016<=t&&t<=6143},"Unified Canadian Aboriginal Syllabics Extended":function(t){return 6320<=t&&t<=6399},"General Punctuation":function(t){return 8192<=t&&t<=8303},"Letterlike Symbols":function(t){return 8448<=t&&t<=8527},"Number Forms":function(t){return 8528<=t&&t<=8591},"Miscellaneous Technical":function(t){return 8960<=t&&t<=9215},"Control Pictures":function(t){return 9216<=t&&t<=9279},"Optical Character Recognition":function(t){return 9280<=t&&t<=9311},"Enclosed Alphanumerics":function(t){return 9312<=t&&t<=9471},"Geometric Shapes":function(t){return 9632<=t&&t<=9727},"Miscellaneous Symbols":function(t){return 9728<=t&&t<=9983},"Miscellaneous Symbols and Arrows":function(t){return 11008<=t&&t<=11263},"CJK Radicals Supplement":function(t){return 11904<=t&&t<=12031},"Kangxi Radicals":function(t){return 12032<=t&&t<=12255},"Ideographic Description Characters":function(t){return 12272<=t&&t<=12287},"CJK Symbols and Punctuation":function(t){return 12288<=t&&t<=12351},Hiragana:function(t){return 12352<=t&&t<=12447},Katakana:function(t){return 12448<=t&&t<=12543},Bopomofo:function(t){return 12544<=t&&t<=12591},"Hangul Compatibility Jamo":function(t){return 12592<=t&&t<=12687},Kanbun:function(t){return 12688<=t&&t<=12703},"Bopomofo Extended":function(t){return 12704<=t&&t<=12735},"CJK Strokes":function(t){return 12736<=t&&t<=12783},"Katakana Phonetic Extensions":function(t){return 12784<=t&&t<=12799},"Enclosed CJK Letters and Months":function(t){return 12800<=t&&t<=13055},"CJK Compatibility":function(t){return 13056<=t&&t<=13311},"CJK Unified Ideographs Extension A":function(t){return 13312<=t&&t<=19903},"Yijing Hexagram Symbols":function(t){return 19904<=t&&t<=19967},"CJK Unified Ideographs":function(t){return 19968<=t&&t<=40959},"Yi Syllables":function(t){return 40960<=t&&t<=42127},"Yi Radicals":function(t){return 42128<=t&&t<=42191},"Hangul Jamo Extended-A":function(t){return 43360<=t&&t<=43391},"Hangul Syllables":function(t){return 44032<=t&&t<=55215},"Hangul Jamo Extended-B":function(t){return 55216<=t&&t<=55295},"Private Use Area":function(t){return 57344<=t&&t<=63743},"CJK Compatibility Ideographs":function(t){return 63744<=t&&t<=64255},"Arabic Presentation Forms-A":function(t){return 64336<=t&&t<=65023},"Vertical Forms":function(t){return 65040<=t&&t<=65055},"CJK Compatibility Forms":function(t){return 65072<=t&&t<=65103},"Small Form Variants":function(t){return 65104<=t&&t<=65135},"Arabic Presentation Forms-B":function(t){return 65136<=t&&t<=65279},"Halfwidth and Fullwidth Forms":function(t){return 65280<=t&&t<=65519}};function tn(t){for(var e=0,i=t;e<i.length;e+=1)if(en(i[e].charCodeAt(0)))return!0;return!1}function en(t){return 746===t||747===t||!(t<4352)&&($r["Bopomofo Extended"](t)||$r.Bopomofo(t)||$r["CJK Compatibility Forms"](t)&&!(65097<=t&&t<=65103)||$r["CJK Compatibility Ideographs"](t)||$r["CJK Compatibility"](t)||$r["CJK Radicals Supplement"](t)||$r["CJK Strokes"](t)||!(!$r["CJK Symbols and Punctuation"](t)||12296<=t&&t<=12305||12308<=t&&t<=12319||12336===t)||$r["CJK Unified Ideographs Extension A"](t)||$r["CJK Unified Ideographs"](t)||$r["Enclosed CJK Letters and Months"](t)||$r["Hangul Compatibility Jamo"](t)||$r["Hangul Jamo Extended-A"](t)||$r["Hangul Jamo Extended-B"](t)||$r["Hangul Jamo"](t)||$r["Hangul Syllables"](t)||$r.Hiragana(t)||$r["Ideographic Description Characters"](t)||$r.Kanbun(t)||$r["Kangxi Radicals"](t)||$r["Katakana Phonetic Extensions"](t)||$r.Katakana(t)&&12540!==t||!(!$r["Halfwidth and Fullwidth Forms"](t)||65288===t||65289===t||65293===t||65306<=t&&t<=65310||65339===t||65341===t||65343===t||65371<=t&&t<=65503||65507===t||65512<=t&&t<=65519)||!(!$r["Small Form Variants"](t)||65112<=t&&t<=65118||65123<=t&&t<=65126)||$r["Unified Canadian Aboriginal Syllabics"](t)||$r["Unified Canadian Aboriginal Syllabics Extended"](t)||$r["Vertical Forms"](t)||$r["Yijing Hexagram Symbols"](t)||$r["Yi Syllables"](t)||!!$r["Yi Radicals"](t))}function rn(t){return!(en(t)||(t=t,$r["Latin-1 Supplement"](t)&&(167===t||169===t||174===t||177===t||188===t||189===t||190===t||215===t||247===t)||$r["General Punctuation"](t)&&(8214===t||8224===t||8225===t||8240===t||8241===t||8251===t||8252===t||8258===t||8263===t||8264===t||8265===t||8273===t)||$r["Letterlike Symbols"](t)||$r["Number Forms"](t)||$r["Miscellaneous Technical"](t)&&(8960<=t&&t<=8967||8972<=t&&t<=8991||8996<=t&&t<=9e3||9003===t||9085<=t&&t<=9114||9150<=t&&t<=9165||9167===t||9169<=t&&t<=9179||9186<=t&&t<=9215)||$r["Control Pictures"](t)&&9251!==t||$r["Optical Character Recognition"](t)||$r["Enclosed Alphanumerics"](t)||$r["Geometric Shapes"](t)||$r["Miscellaneous Symbols"](t)&&!(9754<=t&&t<=9759)||$r["Miscellaneous Symbols and Arrows"](t)&&(11026<=t&&t<=11055||11088<=t&&t<=11097||11192<=t&&t<=11243)||$r["CJK Symbols and Punctuation"](t)||$r.Katakana(t)||$r["Private Use Area"](t)||$r["CJK Compatibility Forms"](t)||$r["Small Form Variants"](t)||$r["Halfwidth and Fullwidth Forms"](t)||8734===t||8756===t||8757===t||9984<=t&&t<=10087||10102<=t&&t<=10131||65532===t||65533===t))}function nn(t){return 1424<=t&&t<=2303||$r["Arabic Presentation Forms-A"](t)||$r["Arabic Presentation Forms-B"](t)}var on={unavailable:"unavailable",deferred:"deferred",loading:"loading",loaded:"loaded",error:"error"},an=null,sn=on.unavailable,ln=null,un=function(t){t&&"string"==typeof t&&-1<t.indexOf("NetworkError")&&(sn=on.error),an&&an(t)};function cn(){dn.fire(new Lt("pluginStateChange",{pluginStatus:sn,pluginURL:ln}))}function pn(){if(sn!==on.deferred||!ln)throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");sn=on.loading,cn(),ln&&Tt({url:ln},function(t){t?un(t):(sn=on.loaded,cn())})}function hn(t,e){this.zoom=t,e?(this.now=e.now,this.fadeDuration=e.fadeDuration,this.zoomHistory=e.zoomHistory,this.transition=e.transition):(this.now=0,this.fadeDuration=0,this.zoomHistory=new Qr,this.transition={})}var dn=new zt,fn={applyArabicShaping:null,processBidirectionalText:null,processStyledBidirectionalText:null,isLoaded:function(){return sn===on.loaded||null!=fn.applyArabicShaping},isLoading:function(){return sn===on.loading},setState:function(t){sn=t.pluginStatus,ln=t.pluginURL},isParsed:function(){return null!=fn.applyArabicShaping&&null!=fn.processBidirectionalText&&null!=fn.processStyledBidirectionalText},getPluginURL:function(){return ln}};function mn(t,e){this.property=t,this.value=e,this.expression=function(t,e){if(Gi(t))return new nr(t,e);if($i(t)){var i=rr(t,e);if("error"===i.result)throw new Error(i.value.map(function(t){return t.key+": "+t.message}).join(", "));return i.value}var r=t;return"string"==typeof t&&"color"===e.type&&(r=ue.parse(t)),{kind:"constant",evaluate:function(){return r}}}(void 0===e?t.specification.default:e,t.specification)}function yn(t){this.property=t,this.value=new mn(t,void 0)}function gn(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues)}hn.prototype.isSupportedScript=function(t){return function(t,e){for(var i=0,r=t;i<r.length;i+=1){var n=r[i];if(n=n.charCodeAt(0),!e&&nn(n)||2304<=n&&n<=3583||3840<=n&&n<=4255||$r.Khmer(n))return!1}return!0}(t,fn.isLoaded())},hn.prototype.crossFadingFactor=function(){return 0===this.fadeDuration?1:Math.min((this.now-this.zoomHistory.lastIntegerZoomTime)/this.fadeDuration,1)},hn.prototype.getCrossfadeParameters=function(){var t=this.zoom,e=t-Math.floor(t),i=this.crossFadingFactor();return t>this.zoomHistory.lastIntegerZoom?{fromScale:2,toScale:1,t:e+(1-e)*i}:{fromScale:.5,toScale:1,t:1-(1-i)*e}},mn.prototype.isDataDriven=function(){return"source"===this.expression.kind||"composite"===this.expression.kind},mn.prototype.possiblyEvaluate=function(t,e,i){return this.property.possiblyEvaluate(this,t,e,i)},yn.prototype.transitioned=function(t,e){return new vn(this.property,this.value,e,d({},t.transition,this.transition),t.now)},yn.prototype.untransitioned=function(){return new vn(this.property,this.value,null,{},0)},gn.prototype.getValue=function(t){return b(this._values[t].value.value)},gn.prototype.setValue=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new yn(this._values[t].property)),this._values[t].value=new mn(this._values[t].property,null===e?void 0:b(e))},gn.prototype.getTransition=function(t){return b(this._values[t].transition)},gn.prototype.setTransition=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new yn(this._values[t].property)),this._values[t].transition=b(e)||void 0},gn.prototype.serialize=function(){for(var t={},e=0,i=Object.keys(this._values);e<i.length;e+=1){var r=i[e],n=this.getValue(r);void 0!==n&&(t[r]=n),void 0!==(n=this.getTransition(r))&&(t[r+"-transition"]=n)}return t},gn.prototype.transitioned=function(t,e){for(var i=new _n(this._properties),r=0,n=Object.keys(this._values);r<n.length;r+=1){var o=n[r];i._values[o]=this._values[o].transitioned(t,e._values[o])}return i},gn.prototype.untransitioned=function(){for(var t=new _n(this._properties),e=0,i=Object.keys(this._values);e<i.length;e+=1){var r=i[e];t._values[r]=this._values[r].untransitioned()}return t};var vn=function(t,e,i,r,n){this.property=t,this.value=e,this.begin=n+r.delay||0,this.end=this.begin+r.duration||0,t.specification.transition&&(r.delay||r.duration)&&(this.prior=i)};vn.prototype.possiblyEvaluate=function(t,e,i){var r=t.now||0,n=this.value.possiblyEvaluate(t,e,i),o=this.prior;return o?r>this.end?(this.prior=null,n):this.value.isDataDriven()?(this.prior=null,n):r<this.begin?o.possiblyEvaluate(t,e,i):(r=(r-this.begin)/(this.end-this.begin),this.property.interpolate(o.possiblyEvaluate(t,e,i),n,function(t){if(r<=0)return 0;if(1<=r)return 1;var e=r*r,i=e*r;return 4*(r<.5?i:3*(r-e)+i-.75)}())):n};var _n=function(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues)};function xn(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues)}function bn(t,e,i){this.property=t,this.value=e,this.parameters=i}_n.prototype.possiblyEvaluate=function(t,e,i){for(var r=new wn(this._properties),n=0,o=Object.keys(this._values);n<o.length;n+=1){var a=o[n];r._values[a]=this._values[a].possiblyEvaluate(t,e,i)}return r},_n.prototype.hasTransition=function(){for(var t=0,e=Object.keys(this._values);t<e.length;t+=1){var i=e[t];if(this._values[i].prior)return!0}return!1},xn.prototype.getValue=function(t){return b(this._values[t].value)},xn.prototype.setValue=function(t,e){this._values[t]=new mn(this._values[t].property,null===e?void 0:b(e))},xn.prototype.serialize=function(){for(var t={},e=0,i=Object.keys(this._values);e<i.length;e+=1){var r=i[e],n=this.getValue(r);void 0!==n&&(t[r]=n)}return t},xn.prototype.possiblyEvaluate=function(t,e,i){for(var r=new wn(this._properties),n=0,o=Object.keys(this._values);n<o.length;n+=1){var a=o[n];r._values[a]=this._values[a].possiblyEvaluate(t,e,i)}return r},bn.prototype.isConstant=function(){return"constant"===this.value.kind},bn.prototype.constantOr=function(t){return"constant"===this.value.kind?this.value.value:t},bn.prototype.evaluate=function(t,e,i,r){return this.property.evaluate(this.value,this.parameters,t,e,i,r)};var wn=function(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues)};function Sn(t){this.specification=t}wn.prototype.get=function(t){return this._values[t]},Sn.prototype.possiblyEvaluate=function(t,e){return t.expression.evaluate(e)},Sn.prototype.interpolate=function(t,e,i){var r=Qe[this.specification.type];return r?r(t,e,i):t},(Rc=function(t,e){this.specification=t,this.overrides=e}).prototype.possiblyEvaluate=function(t,e,i,r){return"constant"===t.expression.kind||"camera"===t.expression.kind?new bn(this,{kind:"constant",value:t.expression.evaluate(e,null,{},i,r)},e):new bn(this,t.expression,e)},Rc.prototype.interpolate=function(t,e,i){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0===t.value.value||void 0===e.value.value)return new bn(this,{kind:"constant",value:void 0},t.parameters);var r=Qe[this.specification.type];return r?new bn(this,{kind:"constant",value:r(t.value.value,e.value.value,i)},t.parameters):t},Rc.prototype.evaluate=function(t,e,i,r,n,o){return"constant"===t.kind?t.value:t.evaluate(e,i,r,n,o)};var Tn,Cn=((Tn=Rc)&&(En.__proto__=Tn),((En.prototype=Object.create(Tn&&Tn.prototype)).constructor=En).prototype.possiblyEvaluate=function(t,e,i,r){return void 0===t.value?new bn(this,{kind:"constant",value:void 0},e):"constant"===t.expression.kind?(r=t.expression.evaluate(e,null,{},i,r),r="resolvedImage"===t.property.specification.type&&"string"!=typeof r?r.name:r,new bn(this,{kind:"constant",value:r=this._calculate(r,r,r,e)},e)):"camera"!==t.expression.kind?new bn(this,t.expression,e):new bn(this,{kind:"constant",value:t=this._calculate(t.expression.evaluate({zoom:e.zoom-1}),t.expression.evaluate({zoom:e.zoom}),t.expression.evaluate({zoom:e.zoom+1}),e)},e)},En.prototype.evaluate=function(t,e,i,r,n,o){return"source"!==t.kind?"composite"===t.kind?this._calculate(t.evaluate({zoom:Math.floor(e.zoom)-1},i,r),t.evaluate({zoom:Math.floor(e.zoom)},i,r),t.evaluate({zoom:Math.floor(e.zoom)+1},i,r),e):t.value:(o=t.evaluate(e,i,r,n,o),this._calculate(o,o,o,e))},En.prototype._calculate=function(t,e,i,r){return r.zoom>r.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:i,to:e}},En.prototype.interpolate=function(t){return t},En);function En(){Tn.apply(this,arguments)}(jc=function(t){this.specification=t}).prototype.possiblyEvaluate=function(t,e,i,r){if(void 0!==t.value)return"constant"!==t.expression.kind?this._calculate(t.expression.evaluate(new hn(Math.floor(e.zoom-1),e)),t.expression.evaluate(new hn(Math.floor(e.zoom),e)),t.expression.evaluate(new hn(Math.floor(e.zoom+1),e)),e):(r=t.expression.evaluate(e,null,{},i,r),this._calculate(r,r,r,e))},jc.prototype._calculate=function(t,e,i,r){return r.zoom>r.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:i,to:e}},jc.prototype.interpolate=function(t){return t};var In=function(t){this.specification=t};function kn(t){for(var e in this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={},this.overridableProperties=[],t){(r=t[e]).specification.overridable&&this.overridableProperties.push(e);var i=this.defaultPropertyValues[e]=new mn(r,void 0),r=this.defaultTransitionablePropertyValues[e]=new yn(r);this.defaultTransitioningPropertyValues[e]=r.untransitioned(),this.defaultPossiblyEvaluatedValues[e]=i.possiblyEvaluate({})}}In.prototype.possiblyEvaluate=function(t,e,i,r){return!!t.expression.evaluate(e,null,{},i,r)},In.prototype.interpolate=function(){return!1},Wr("DataDrivenProperty",Rc),Wr("DataConstantProperty",Sn),Wr("CrossFadedDataDrivenProperty",Cn),Wr("CrossFadedProperty",jc),Wr("ColorRampProperty",In);var An,Pn="-transition",Mn=((An=zt)&&(Ln.__proto__=An),((Ln.prototype=Object.create(An&&An.prototype)).constructor=Ln).prototype.getCrossfadeParameters=function(){return this._crossfadeParameters},Ln.prototype.getLayoutProperty=function(t){return"visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)},Ln.prototype.setLayoutProperty=function(t,e,i){if(void 0===i&&(i={}),null!=e){var r="layers."+this.id+".layout."+t;if(this._validate(Br,r,t,e,i))return}"visibility"!==t?this._unevaluatedLayout.setValue(t,e):this.visibility=e},Ln.prototype.getPaintProperty=function(t){return v(t,Pn)?this._transitionablePaint.getTransition(t.slice(0,-Pn.length)):this._transitionablePaint.getValue(t)},Ln.prototype.setPaintProperty=function(t,e,i){if(void 0===i&&(i={}),null!=e){var r="layers."+this.id+".paint."+t;if(this._validate(Nr,r,t,e,i))return!1}if(v(t,Pn))return this._transitionablePaint.setTransition(t.slice(0,-Pn.length),e||void 0),!1;r="cross-faded-data-driven"===(n=this._transitionablePaint._values[t]).property.specification["property-type"],i=n.value.isDataDriven();var n=n.value;return this._transitionablePaint.setValue(t,e),this._handleSpecialPaintPropertyUpdate(t),(e=this._transitionablePaint._values[t].value).isDataDriven()||i||r||this._handleOverridablePaintPropertyUpdate(t,n,e)},Ln.prototype._handleSpecialPaintPropertyUpdate=function(t){},Ln.prototype._handleOverridablePaintPropertyUpdate=function(t,e,i){return!1},Ln.prototype.isHidden=function(t){return!!(this.minzoom&&t<this.minzoom)||!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility},Ln.prototype.updateTransitions=function(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint)},Ln.prototype.hasTransition=function(){return this._transitioningPaint.hasTransition()},Ln.prototype.recalculate=function(t,e){t.getCrossfadeParameters&&(this._crossfadeParameters=t.getCrossfadeParameters()),this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t,void 0,e)),this.paint=this._transitioningPaint.possiblyEvaluate(t,void 0,e)},Ln.prototype.serialize=function(){var t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return this.visibility&&(t.layout=t.layout||{},t.layout.visibility=this.visibility),x(t,function(t,e){return!(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)})},Ln.prototype._validate=function(t,e,i,r,n){return(!(n=void 0===n?{}:n)||!1!==n.validate)&&Fr(this,t.call(zr,{key:e,layerType:this.type,objectKey:i,value:r,styleSpec:Dt,style:{glyphs:!0,sprite:!0}}))},Ln.prototype.is3D=function(){return!1},Ln.prototype.isTileClipped=function(){return!1},Ln.prototype.hasOffscreenPass=function(){return!1},Ln.prototype.resize=function(){},Ln.prototype.isStateDependent=function(){for(var t in this.paint._values)if((t=this.paint.get(t))instanceof bn&&ji(t.property.specification)&&("source"===t.value.kind||"composite"===t.value.kind)&&t.value.isStateDependent)return!0;return!1},Ln);function Ln(t,e){if(An.call(this),this.id=t.id,this.type=t.type,this._featureFilter={filter:function(){return!0},needGeometry:!1},"custom"!==t.type&&(this.metadata=t.metadata,this.minzoom=t.minzoom,this.maxzoom=t.maxzoom,"background"!==t.type&&(this.source=t.source,this.sourceLayer=t["source-layer"],this.filter=t.filter),e.layout&&(this._unevaluatedLayout=new xn(e.layout)),e.paint)){for(var i in this._transitionablePaint=new gn(e.paint),t.paint)this.setPaintProperty(i,t.paint[i],{validate:!1});for(var r in t.layout)this.setLayoutProperty(r,t.layout[r],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned(),this.paint=new wn(e.paint)}}var On={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array},Rn=function(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8};function zn(t,e){void 0===e&&(e=1);var i=0,r=0;return{members:t.map(function(t){var n=(a=t.type,On[a].BYTES_PER_ELEMENT),o=i=Dn(i,Math.max(e,n)),a=t.components||1;return r=Math.max(r,n),i+=n*a,{name:t.name,type:t.type,components:a,offset:o}}),size:Dn(i,Math.max(r,e)),alignment:e}}function Dn(t,e){return Math.ceil(t/e)*e}(fs=function(){this.isTransferred=!1,this.capacity=-1,this.resize(0)}).serialize=function(t,e){return t._trim(),e&&(t.isTransferred=!0,e.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}},fs.deserialize=function(t){var e=Object.create(this.prototype);return e.arrayBuffer=t.arrayBuffer,e.length=t.length,e.capacity=t.arrayBuffer.byteLength/e.bytesPerElement,e._refreshViews(),e},fs.prototype._trim=function(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews())},fs.prototype.clear=function(){this.length=0},fs.prototype.resize=function(t){this.reserve(t),this.length=t},fs.prototype.reserve=function(t){t>this.capacity&&(this.capacity=Math.max(t,Math.floor(5*this.capacity),128),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement),t=this.uint8,this._refreshViews(),t&&this.uint8.set(t))},fs.prototype._refreshViews=function(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")};var Nn,Bn=((Nn=fs)&&(Fn.__proto__=Nn),((Fn.prototype=Object.create(Nn&&Nn.prototype)).constructor=Fn).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},Fn.prototype.emplaceBack=function(t,e){var i=this.length;return this.resize(i+1),this.emplace(i,t,e)},Fn.prototype.emplace=function(t,e,i){var r=2*t;return this.int16[0+r]=e,this.int16[1+r]=i,t},Fn);function Fn(){Nn.apply(this,arguments)}Bn.prototype.bytesPerElement=4,Wr("StructArrayLayout2i4",Bn);var Un,jn=((Un=fs)&&(Vn.__proto__=Un),((Vn.prototype=Object.create(Un&&Un.prototype)).constructor=Vn).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},Vn.prototype.emplaceBack=function(t,e,i,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,i,r)},Vn.prototype.emplace=function(t,e,i,r,n){var o=4*t;return this.int16[0+o]=e,this.int16[1+o]=i,this.int16[2+o]=r,this.int16[3+o]=n,t},Vn);function Vn(){Un.apply(this,arguments)}jn.prototype.bytesPerElement=8,Wr("StructArrayLayout4i8",jn);var qn,Hn=((qn=fs)&&(Gn.__proto__=qn),((Gn.prototype=Object.create(qn&&qn.prototype)).constructor=Gn).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},Gn.prototype.emplaceBack=function(t,e,i,r,n,o){var a=this.length;return this.resize(a+1),this.emplace(a,t,e,i,r,n,o)},Gn.prototype.emplace=function(t,e,i,r,n,o,a){var s=6*t;return this.int16[0+s]=e,this.int16[1+s]=i,this.int16[2+s]=r,this.int16[3+s]=n,this.int16[4+s]=o,this.int16[5+s]=a,t},Gn);function Gn(){qn.apply(this,arguments)}Hn.prototype.bytesPerElement=12,Wr("StructArrayLayout2i4i12",Hn);var Zn,Wn=((Zn=fs)&&(Kn.__proto__=Zn),((Kn.prototype=Object.create(Zn&&Zn.prototype)).constructor=Kn).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},Kn.prototype.emplaceBack=function(t,e,i,r,n,o){var a=this.length;return this.resize(a+1),this.emplace(a,t,e,i,r,n,o)},Kn.prototype.emplace=function(t,e,i,r,n,o,a){var s=4*t,l=8*t;return this.int16[0+s]=e,this.int16[1+s]=i,this.uint8[4+l]=r,this.uint8[5+l]=n,this.uint8[6+l]=o,this.uint8[7+l]=a,t},Kn);function Kn(){Zn.apply(this,arguments)}Wn.prototype.bytesPerElement=8,Wr("StructArrayLayout2i4ub8",Wn);var Xn,Yn=((Xn=fs)&&(Jn.__proto__=Xn),((Jn.prototype=Object.create(Xn&&Xn.prototype)).constructor=Jn).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},Jn.prototype.emplaceBack=function(t,e){var i=this.length;return this.resize(i+1),this.emplace(i,t,e)},Jn.prototype.emplace=function(t,e,i){var r=2*t;return this.float32[0+r]=e,this.float32[1+r]=i,t},Jn);function Jn(){Xn.apply(this,arguments)}Yn.prototype.bytesPerElement=8,Wr("StructArrayLayout2f8",Yn);var Qn,$n=((Qn=fs)&&(to.__proto__=Qn),((to.prototype=Object.create(Qn&&Qn.prototype)).constructor=to).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},to.prototype.emplaceBack=function(t,e,i,r,n,o,a,s,l,u){var c=this.length;return this.resize(c+1),this.emplace(c,t,e,i,r,n,o,a,s,l,u)},to.prototype.emplace=function(t,e,i,r,n,o,a,s,l,u,c){var p=10*t;return this.uint16[0+p]=e,this.uint16[1+p]=i,this.uint16[2+p]=r,this.uint16[3+p]=n,this.uint16[4+p]=o,this.uint16[5+p]=a,this.uint16[6+p]=s,this.uint16[7+p]=l,this.uint16[8+p]=u,this.uint16[9+p]=c,t},to);function to(){Qn.apply(this,arguments)}$n.prototype.bytesPerElement=20,Wr("StructArrayLayout10ui20",$n);var eo,io=((eo=fs)&&(ro.__proto__=eo),((ro.prototype=Object.create(eo&&eo.prototype)).constructor=ro).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},ro.prototype.emplaceBack=function(t,e,i,r,n,o,a,s,l,u,c,p){var h=this.length;return this.resize(h+1),this.emplace(h,t,e,i,r,n,o,a,s,l,u,c,p)},ro.prototype.emplace=function(t,e,i,r,n,o,a,s,l,u,c,p,h){var d=12*t;return this.int16[0+d]=e,this.int16[1+d]=i,this.int16[2+d]=r,this.int16[3+d]=n,this.uint16[4+d]=o,this.uint16[5+d]=a,this.uint16[6+d]=s,this.uint16[7+d]=l,this.int16[8+d]=u,this.int16[9+d]=c,this.int16[10+d]=p,this.int16[11+d]=h,t},ro);function ro(){eo.apply(this,arguments)}io.prototype.bytesPerElement=24,Wr("StructArrayLayout4i4ui4i24",io);var no,oo=((no=fs)&&(ao.__proto__=no),((ao.prototype=Object.create(no&&no.prototype)).constructor=ao).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},ao.prototype.emplaceBack=function(t,e,i){var r=this.length;return this.resize(r+1),this.emplace(r,t,e,i)},ao.prototype.emplace=function(t,e,i,r){var n=3*t;return this.float32[0+n]=e,this.float32[1+n]=i,this.float32[2+n]=r,t},ao);function ao(){no.apply(this,arguments)}oo.prototype.bytesPerElement=12,Wr("StructArrayLayout3f12",oo);var so,lo=((so=fs)&&(uo.__proto__=so),((uo.prototype=Object.create(so&&so.prototype)).constructor=uo).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer)},uo.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},uo.prototype.emplace=function(t,e){return this.uint32[+t+0]=e,t},uo);function uo(){so.apply(this,arguments)}lo.prototype.bytesPerElement=4,Wr("StructArrayLayout1ul4",lo);var co,po=((co=fs)&&(ho.__proto__=co),((ho.prototype=Object.create(co&&co.prototype)).constructor=ho).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},ho.prototype.emplaceBack=function(t,e,i,r,n,o,a,s,l){var u=this.length;return this.resize(u+1),this.emplace(u,t,e,i,r,n,o,a,s,l)},ho.prototype.emplace=function(t,e,i,r,n,o,a,s,l,u){var c=10*t,p=5*t;return this.int16[0+c]=e,this.int16[1+c]=i,this.int16[2+c]=r,this.int16[3+c]=n,this.int16[4+c]=o,this.int16[5+c]=a,this.uint32[3+p]=s,this.uint16[8+c]=l,this.uint16[9+c]=u,t},ho);function ho(){co.apply(this,arguments)}po.prototype.bytesPerElement=20,Wr("StructArrayLayout6i1ul2ui20",po);var fo,mo=((fo=fs)&&(yo.__proto__=fo),((yo.prototype=Object.create(fo&&fo.prototype)).constructor=yo).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},yo.prototype.emplaceBack=function(t,e,i,r,n,o){var a=this.length;return this.resize(a+1),this.emplace(a,t,e,i,r,n,o)},yo.prototype.emplace=function(t,e,i,r,n,o,a){var s=6*t;return this.int16[0+s]=e,this.int16[1+s]=i,this.int16[2+s]=r,this.int16[3+s]=n,this.int16[4+s]=o,this.int16[5+s]=a,t},yo);function yo(){fo.apply(this,arguments)}mo.prototype.bytesPerElement=12,Wr("StructArrayLayout2i2i2i12",mo);var go,vo=((go=fs)&&(_o.__proto__=go),((_o.prototype=Object.create(go&&go.prototype)).constructor=_o).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},_o.prototype.emplaceBack=function(t,e,i,r,n){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,i,r,n)},_o.prototype.emplace=function(t,e,i,r,n,o){var a=4*t,s=8*t;return this.float32[0+a]=e,this.float32[1+a]=i,this.float32[2+a]=r,this.int16[6+s]=n,this.int16[7+s]=o,t},_o);function _o(){go.apply(this,arguments)}vo.prototype.bytesPerElement=16,Wr("StructArrayLayout2f1f2i16",vo);var xo,bo=((xo=fs)&&(wo.__proto__=xo),((wo.prototype=Object.create(xo&&xo.prototype)).constructor=wo).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},wo.prototype.emplaceBack=function(t,e,i,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,i,r)},wo.prototype.emplace=function(t,e,i,r,n){var o=12*t,a=3*t;return this.uint8[0+o]=e,this.uint8[1+o]=i,this.float32[1+a]=r,this.float32[2+a]=n,t},wo);function wo(){xo.apply(this,arguments)}bo.prototype.bytesPerElement=12,Wr("StructArrayLayout2ub2f12",bo);var So,To,Co,Eo=((So=fs)&&(Io.__proto__=So),((Io.prototype=Object.create(So&&So.prototype)).constructor=Io).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},Io.prototype.emplaceBack=function(t,e,i){var r=this.length;return this.resize(r+1),this.emplace(r,t,e,i)},Io.prototype.emplace=function(t,e,i,r){var n=3*t;return this.uint16[0+n]=e,this.uint16[1+n]=i,this.uint16[2+n]=r,t},Io);function Io(){So.apply(this,arguments)}function ko(){To.apply(this,arguments)}function Ao(){Co.apply(this,arguments)}Eo.prototype.bytesPerElement=6,Wr("StructArrayLayout3ui6",Eo),(bs=((To=fs)&&(ko.__proto__=To),((ko.prototype=Object.create(To&&To.prototype)).constructor=ko).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},ko.prototype.emplaceBack=function(t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m,y){var g=this.length;return this.resize(g+1),this.emplace(g,t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m,y)},ko.prototype.emplace=function(t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m,y,g){var v=24*t,_=12*t,x=48*t;return this.int16[0+v]=e,this.int16[1+v]=i,this.uint16[2+v]=r,this.uint16[3+v]=n,this.uint32[2+_]=o,this.uint32[3+_]=a,this.uint32[4+_]=s,this.uint16[10+v]=l,this.uint16[11+v]=u,this.uint16[12+v]=c,this.float32[7+_]=p,this.float32[8+_]=h,this.uint8[36+x]=d,this.uint8[37+x]=f,this.uint8[38+x]=m,this.uint32[10+_]=y,this.int16[22+v]=g,t},ko)).prototype.bytesPerElement=48,Wr("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48",bs),(Cs=((Co=fs)&&(Ao.__proto__=Co),((Ao.prototype=Object.create(Co&&Co.prototype)).constructor=Ao).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},Ao.prototype.emplaceBack=function(t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m,y,g,v,_,x,b,w,S,T,C,E,I){var k=this.length;return this.resize(k+1),this.emplace(k,t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m,y,g,v,_,x,b,w,S,T,C,E,I)},Ao.prototype.emplace=function(t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m,y,g,v,_,x,b,w,S,T,C,E,I,k){var A=34*t,P=17*t;return this.int16[0+A]=e,this.int16[1+A]=i,this.int16[2+A]=r,this.int16[3+A]=n,this.int16[4+A]=o,this.int16[5+A]=a,this.int16[6+A]=s,this.int16[7+A]=l,this.uint16[8+A]=u,this.uint16[9+A]=c,this.uint16[10+A]=p,this.uint16[11+A]=h,this.uint16[12+A]=d,this.uint16[13+A]=f,this.uint16[14+A]=m,this.uint16[15+A]=y,this.uint16[16+A]=g,this.uint16[17+A]=v,this.uint16[18+A]=_,this.uint16[19+A]=x,this.uint16[20+A]=b,this.uint16[21+A]=w,this.uint16[22+A]=S,this.uint32[12+P]=T,this.float32[13+P]=C,this.float32[14+P]=E,this.float32[15+P]=I,this.float32[16+P]=k,t},Ao)).prototype.bytesPerElement=68,Wr("StructArrayLayout8i15ui1ul4f68",Cs);var Po,Mo,Lo,Oo=((Po=fs)&&(Ro.__proto__=Po),((Ro.prototype=Object.create(Po&&Po.prototype)).constructor=Ro).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},Ro.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},Ro.prototype.emplace=function(t,e){return this.float32[+t+0]=e,t},Ro);function Ro(){Po.apply(this,arguments)}function zo(){Mo.apply(this,arguments)}function Do(){Lo.apply(this,arguments)}Oo.prototype.bytesPerElement=4,Wr("StructArrayLayout1f4",Oo),(R=((Mo=fs)&&(zo.__proto__=Mo),((zo.prototype=Object.create(Mo&&Mo.prototype)).constructor=zo).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer)},zo.prototype.emplaceBack=function(t,e,i){var r=this.length;return this.resize(r+1),this.emplace(r,t,e,i)},zo.prototype.emplace=function(t,e,i,r){var n=3*t;return this.int16[0+n]=e,this.int16[1+n]=i,this.int16[2+n]=r,t},zo)).prototype.bytesPerElement=6,Wr("StructArrayLayout3i6",R),(Vs=((Lo=fs)&&(Do.__proto__=Lo),((Do.prototype=Object.create(Lo&&Lo.prototype)).constructor=Do).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},Do.prototype.emplaceBack=function(t,e,i){var r=this.length;return this.resize(r+1),this.emplace(r,t,e,i)},Do.prototype.emplace=function(t,e,i,r){var n=4*t;return this.uint32[0+2*t]=e,this.uint16[2+n]=i,this.uint16[3+n]=r,t},Do)).prototype.bytesPerElement=8,Wr("StructArrayLayout1ul2ui8",Vs);var No,Bo,Fo,Uo=((No=fs)&&(jo.__proto__=No),((jo.prototype=Object.create(No&&No.prototype)).constructor=jo).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},jo.prototype.emplaceBack=function(t,e){var i=this.length;return this.resize(i+1),this.emplace(i,t,e)},jo.prototype.emplace=function(t,e,i){var r=2*t;return this.uint16[0+r]=e,this.uint16[1+r]=i,t},jo);function jo(){No.apply(this,arguments)}function Vo(){Bo.apply(this,arguments)}Uo.prototype.bytesPerElement=4,Wr("StructArrayLayout2ui4",Uo),(Fo=((Bo=fs)&&(Vo.__proto__=Bo),((Vo.prototype=Object.create(Bo&&Bo.prototype)).constructor=Vo).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer)},Vo.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},Vo.prototype.emplace=function(t,e){return this.uint16[+t+0]=e,t},Vo)).prototype.bytesPerElement=2,Wr("StructArrayLayout1ui2",Fo);var qo,Ho=((qo=fs)&&(Go.__proto__=qo),((Go.prototype=Object.create(qo&&qo.prototype)).constructor=Go).prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer)},Go.prototype.emplaceBack=function(t,e,i,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,i,r)},Go.prototype.emplace=function(t,e,i,r,n){var o=4*t;return this.float32[0+o]=e,this.float32[1+o]=i,this.float32[2+o]=r,this.float32[3+o]=n,t},Go);function Go(){qo.apply(this,arguments)}Ho.prototype.bytesPerElement=16,Wr("StructArrayLayout4f16",Ho);var Zo=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var i={anchorPointX:{configurable:!0},anchorPointY:{configurable:!0},x1:{configurable:!0},y1:{configurable:!0},x2:{configurable:!0},y2:{configurable:!0},featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0},anchorPoint:{configurable:!0}};return i.anchorPointX.get=function(){return this._structArray.int16[this._pos2+0]},i.anchorPointY.get=function(){return this._structArray.int16[this._pos2+1]},i.x1.get=function(){return this._structArray.int16[this._pos2+2]},i.y1.get=function(){return this._structArray.int16[this._pos2+3]},i.x2.get=function(){return this._structArray.int16[this._pos2+4]},i.y2.get=function(){return this._structArray.int16[this._pos2+5]},i.featureIndex.get=function(){return this._structArray.uint32[this._pos4+3]},i.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+8]},i.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+9]},i.anchorPoint.get=function(){return new o(this.anchorPointX,this.anchorPointY)},Object.defineProperties(e.prototype,i),e}(Rn);Zo.prototype.size=20;var Wo,Ko=((Wo=po)&&(Xo.__proto__=Wo),((Xo.prototype=Object.create(Wo&&Wo.prototype)).constructor=Xo).prototype.get=function(t){return new Zo(this,t)},Xo);function Xo(){Wo.apply(this,arguments)}Wr("CollisionBoxArray",Ko);var Yo=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var i={anchorX:{configurable:!0},anchorY:{configurable:!0},glyphStartIndex:{configurable:!0},numGlyphs:{configurable:!0},vertexStartIndex:{configurable:!0},lineStartIndex:{configurable:!0},lineLength:{configurable:!0},segment:{configurable:!0},lowerSize:{configurable:!0},upperSize:{configurable:!0},lineOffsetX:{configurable:!0},lineOffsetY:{configurable:!0},writingMode:{configurable:!0},placedOrientation:{configurable:!0},hidden:{configurable:!0},crossTileID:{configurable:!0},associatedIconIndex:{configurable:!0}};return i.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},i.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},i.glyphStartIndex.get=function(){return this._structArray.uint16[this._pos2+2]},i.numGlyphs.get=function(){return this._structArray.uint16[this._pos2+3]},i.vertexStartIndex.get=function(){return this._structArray.uint32[this._pos4+2]},i.lineStartIndex.get=function(){return this._structArray.uint32[this._pos4+3]},i.lineLength.get=function(){return this._structArray.uint32[this._pos4+4]},i.segment.get=function(){return this._structArray.uint16[this._pos2+10]},i.lowerSize.get=function(){return this._structArray.uint16[this._pos2+11]},i.upperSize.get=function(){return this._structArray.uint16[this._pos2+12]},i.lineOffsetX.get=function(){return this._structArray.float32[this._pos4+7]},i.lineOffsetY.get=function(){return this._structArray.float32[this._pos4+8]},i.writingMode.get=function(){return this._structArray.uint8[this._pos1+36]},i.placedOrientation.get=function(){return this._structArray.uint8[this._pos1+37]},i.placedOrientation.set=function(t){this._structArray.uint8[this._pos1+37]=t},i.hidden.get=function(){return this._structArray.uint8[this._pos1+38]},i.hidden.set=function(t){this._structArray.uint8[this._pos1+38]=t},i.crossTileID.get=function(){return this._structArray.uint32[this._pos4+10]},i.crossTileID.set=function(t){this._structArray.uint32[this._pos4+10]=t},i.associatedIconIndex.get=function(){return this._structArray.int16[this._pos2+22]},Object.defineProperties(e.prototype,i),e}(Rn);Yo.prototype.size=48;var Jo,Qo=((Jo=bs)&&($o.__proto__=Jo),(($o.prototype=Object.create(Jo&&Jo.prototype)).constructor=$o).prototype.get=function(t){return new Yo(this,t)},$o);function $o(){Jo.apply(this,arguments)}Wr("PlacedSymbolArray",Qo);var ta=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var i={anchorX:{configurable:!0},anchorY:{configurable:!0},rightJustifiedTextSymbolIndex:{configurable:!0},centerJustifiedTextSymbolIndex:{configurable:!0},leftJustifiedTextSymbolIndex:{configurable:!0},verticalPlacedTextSymbolIndex:{configurable:!0},placedIconSymbolIndex:{configurable:!0},verticalPlacedIconSymbolIndex:{configurable:!0},key:{configurable:!0},textBoxStartIndex:{configurable:!0},textBoxEndIndex:{configurable:!0},verticalTextBoxStartIndex:{configurable:!0},verticalTextBoxEndIndex:{configurable:!0},iconBoxStartIndex:{configurable:!0},iconBoxEndIndex:{configurable:!0},verticalIconBoxStartIndex:{configurable:!0},verticalIconBoxEndIndex:{configurable:!0},featureIndex:{configurable:!0},numHorizontalGlyphVertices:{configurable:!0},numVerticalGlyphVertices:{configurable:!0},numIconVertices:{configurable:!0},numVerticalIconVertices:{configurable:!0},useRuntimeCollisionCircles:{configurable:!0},crossTileID:{configurable:!0},textBoxScale:{configurable:!0},textOffset0:{configurable:!0},textOffset1:{configurable:!0},collisionCircleDiameter:{configurable:!0}};return i.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},i.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},i.rightJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+2]},i.centerJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+3]},i.leftJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+4]},i.verticalPlacedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+5]},i.placedIconSymbolIndex.get=function(){return this._structArray.int16[this._pos2+6]},i.verticalPlacedIconSymbolIndex.get=function(){return this._structArray.int16[this._pos2+7]},i.key.get=function(){return this._structArray.uint16[this._pos2+8]},i.textBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+9]},i.textBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+10]},i.verticalTextBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+11]},i.verticalTextBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+12]},i.iconBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+13]},i.iconBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+14]},i.verticalIconBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+15]},i.verticalIconBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+16]},i.featureIndex.get=function(){return this._structArray.uint16[this._pos2+17]},i.numHorizontalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+18]},i.numVerticalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+19]},i.numIconVertices.get=function(){return this._structArray.uint16[this._pos2+20]},i.numVerticalIconVertices.get=function(){return this._structArray.uint16[this._pos2+21]},i.useRuntimeCollisionCircles.get=function(){return this._structArray.uint16[this._pos2+22]},i.crossTileID.get=function(){return this._structArray.uint32[this._pos4+12]},i.crossTileID.set=function(t){this._structArray.uint32[this._pos4+12]=t},i.textBoxScale.get=function(){return this._structArray.float32[this._pos4+13]},i.textOffset0.get=function(){return this._structArray.float32[this._pos4+14]},i.textOffset1.get=function(){return this._structArray.float32[this._pos4+15]},i.collisionCircleDiameter.get=function(){return this._structArray.float32[this._pos4+16]},Object.defineProperties(e.prototype,i),e}(Rn);ta.prototype.size=68;var ea,ia=((ea=Cs)&&(ra.__proto__=ea),((ra.prototype=Object.create(ea&&ea.prototype)).constructor=ra).prototype.get=function(t){return new ta(this,t)},ra);function ra(){ea.apply(this,arguments)}Wr("SymbolInstanceArray",ia);var na,oa=((na=Oo)&&(aa.__proto__=na),((aa.prototype=Object.create(na&&na.prototype)).constructor=aa).prototype.getoffsetX=function(t){return this.float32[+t+0]},aa);function aa(){na.apply(this,arguments)}Wr("GlyphOffsetArray",oa);var sa,la=((sa=R)&&(ua.__proto__=sa),((ua.prototype=Object.create(sa&&sa.prototype)).constructor=ua).prototype.getx=function(t){return this.int16[3*t+0]},ua.prototype.gety=function(t){return this.int16[3*t+1]},ua.prototype.gettileUnitDistanceFromAnchor=function(t){return this.int16[3*t+2]},ua);function ua(){sa.apply(this,arguments)}Wr("SymbolLineVertexArray",la);var ca=function(t){function e(){t.apply(this,arguments)}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var i={featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0}};return i.featureIndex.get=function(){return this._structArray.uint32[this._pos4+0]},i.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+2]},i.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+3]},Object.defineProperties(e.prototype,i),e}(Rn);ca.prototype.size=8;var pa,ha=((pa=Vs)&&(da.__proto__=pa),((da.prototype=Object.create(pa&&pa.prototype)).constructor=da).prototype.get=function(t){return new ca(this,t)},da);function da(){pa.apply(this,arguments)}function fa(t){this.segments=t=void 0===t?[]:t}Wr("FeatureIndexArray",ha);var ma=zn([{name:"a_pos",components:2,type:"Int16"}],4).members;function ya(t,e){return 256*(t=p(Math.floor(t),0,255))+p(Math.floor(e),0,255)}fa.prototype.prepareSegment=function(t,e,i,r){var n=this.segments[this.segments.length-1];return fa.MAX_VERTEX_ARRAY_LENGTH<t&&S("Max vertices per segment is "+fa.MAX_VERTEX_ARRAY_LENGTH+": bucket requested "+t),(!n||n.vertexLength+t>fa.MAX_VERTEX_ARRAY_LENGTH||n.sortKey!==r)&&(n={vertexOffset:e.length,primitiveOffset:i.length,vertexLength:0,primitiveLength:0},void 0!==r&&(n.sortKey=r),this.segments.push(n)),n},fa.prototype.get=function(){return this.segments},fa.prototype.destroy=function(){for(var t=0,e=this.segments;t<e.length;t+=1){var i,r=e[t];for(i in r.vaos)r.vaos[i].destroy()}},fa.simpleSegment=function(t,e,i,r){return new fa([{vertexOffset:t,primitiveOffset:e,vertexLength:i,primitiveLength:r,vaos:{},sortKey:0}])},fa.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,Wr("SegmentVector",fa);var ga=zn([{name:"a_pattern_from",components:4,type:"Uint16"},{name:"a_pattern_to",components:4,type:"Uint16"},{name:"a_pixel_ratio_from",components:1,type:"Uint16"},{name:"a_pixel_ratio_to",components:1,type:"Uint16"}]),va=(et=e(function(t){t.exports=function(t,e){for(var i,r,n=3&t.length,o=t.length-n,a=e,s=3432918353,l=461845907,u=0;u<o;)r=255&t.charCodeAt(u)|(255&t.charCodeAt(++u))<<8|(255&t.charCodeAt(++u))<<16|(255&t.charCodeAt(++u))<<24,++u,a=27492+(65535&(i=5*(65535&(a=(a^=r=(65535&(r=(r=(65535&r)*s+(((r>>>16)*s&65535)<<16)&4294967295)<<15|r>>>17))*l+(((r>>>16)*l&65535)<<16)&4294967295)<<13|a>>>19))+((5*(a>>>16)&65535)<<16)&4294967295))+((58964+(i>>>16)&65535)<<16);switch(r=0,n){case 3:r^=(255&t.charCodeAt(u+2))<<16;case 2:r^=(255&t.charCodeAt(u+1))<<8;case 1:a^=r=(65535&(r=(r=(65535&(r^=255&t.charCodeAt(u)))*s+(((r>>>16)*s&65535)<<16)&4294967295)<<15|r>>>17))*l+(((r>>>16)*l&65535)<<16)&4294967295}return a^=t.length,a=2246822507*(65535&(a^=a>>>16))+((2246822507*(a>>>16)&65535)<<16)&4294967295,a=3266489909*(65535&(a^=a>>>13))+((3266489909*(a>>>16)&65535)<<16)&4294967295,(a^=a>>>16)>>>0}}),e(function(t){t.exports=function(t,e){for(var i,r=t.length,n=e^r,o=0;4<=r;)i=1540483477*(65535&(i=255&t.charCodeAt(o)|(255&t.charCodeAt(++o))<<8|(255&t.charCodeAt(++o))<<16|(255&t.charCodeAt(++o))<<24))+((1540483477*(i>>>16)&65535)<<16),n=1540483477*(65535&n)+((1540483477*(n>>>16)&65535)<<16)^1540483477*(65535&(i^=i>>>24))+((1540483477*(i>>>16)&65535)<<16),r-=4,++o;switch(r){case 3:n^=(255&t.charCodeAt(o+2))<<16;case 2:n^=(255&t.charCodeAt(o+1))<<8;case 1:n=1540483477*(65535&(n^=255&t.charCodeAt(o)))+((1540483477*(n>>>16)&65535)<<16)}return n=1540483477*(65535&(n^=n>>>13))+((1540483477*(n>>>16)&65535)<<16),(n^=n>>>15)>>>0}})),_a=et;ki=va;function xa(){this.ids=[],this.positions=[],this.indexed=!1}_a.murmur3=et,_a.murmur2=ki,xa.prototype.add=function(t,e,i,r){this.ids.push(wa(t)),this.positions.push(e,i,r)},xa.prototype.getPositions=function(t){for(var e=wa(t),i=0,r=this.ids.length-1;i<r;){var n=i+r>>1;this.ids[n]>=e?r=n:i=1+n}for(var o=[];this.ids[i]===e;){var a=this.positions[3*i],s=this.positions[3*i+1],l=this.positions[3*i+2];o.push({index:a,start:s,end:l}),i++}return o},xa.serialize=function(t,e){var i=new Float64Array(t.ids);return function t(e,i,r,n){for(;r<n;){for(var o=e[r+n>>1],a=r-1,s=n+1;;){for(;e[++a]<o;);for(;e[--s]>o;);if(s<=a)break;Sa(e,a,s),Sa(i,3*a,3*s),Sa(i,3*a+1,3*s+1),Sa(i,3*a+2,3*s+2)}s-r<n-s?(t(e,i,r,s),r=s+1):(t(e,i,s+1,n),n=s)}}(i,t=new Uint32Array(t.positions),0,i.length-1),e&&e.push(i.buffer,t.buffer),{ids:i,positions:t}},xa.deserialize=function(t){var e=new xa;return e.ids=t.ids,e.positions=t.positions,e.indexed=!0,e};var ba=Math.pow(2,53)-1;function wa(t){var e=+t;return!isNaN(e)&&e<=ba?e:_a(String(t))}function Sa(t,e,i){var r=t[e];t[e]=t[i],t[i]=r}Wr("FeaturePositionMap",xa);var Ta;(Ta=Ai=function(t,e){this.gl=t.gl,this.location=e})&&(Ca.__proto__=Ta),((Ca.prototype=Object.create(Ta&&Ta.prototype)).constructor=Ca).prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1i(this.location,t))},Mi=Ca;function Ca(t,e){Ta.call(this,t,e),this.current=0}var Ea,Ia=((Ea=Ai)&&(ka.__proto__=Ea),((ka.prototype=Object.create(Ea&&Ea.prototype)).constructor=ka).prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1f(this.location,t))},ka);function ka(t,e){Ea.call(this,t,e),this.current=0}var Aa;(Aa=Ai)&&(Pa.__proto__=Aa),((Pa.prototype=Object.create(Aa&&Aa.prototype)).constructor=Pa).prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]||(this.current=t,this.gl.uniform2f(this.location,t[0],t[1]))},Pi=Pa;function Pa(t,e){Aa.call(this,t,e),this.current=[0,0]}var Ma;(Ma=Ai)&&(La.__proto__=Ma),((La.prototype=Object.create(Ma&&Ma.prototype)).constructor=La).prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]||(this.current=t,this.gl.uniform3f(this.location,t[0],t[1],t[2]))},Oi=La;function La(t,e){Ma.call(this,t,e),this.current=[0,0,0]}var Oa,Ra=((Oa=Ai)&&(za.__proto__=Oa),((za.prototype=Object.create(Oa&&Oa.prototype)).constructor=za).prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]&&t[3]===this.current[3]||(this.current=t,this.gl.uniform4f(this.location,t[0],t[1],t[2],t[3]))},za);function za(t,e){Oa.call(this,t,e),this.current=[0,0,0,0]}var Da,Na=((Da=Ai)&&(Ba.__proto__=Da),((Ba.prototype=Object.create(Da&&Da.prototype)).constructor=Ba).prototype.set=function(t){t.r===this.current.r&&t.g===this.current.g&&t.b===this.current.b&&t.a===this.current.a||(this.current=t,this.gl.uniform4f(this.location,t.r,t.g,t.b,t.a))},Ba);function Ba(t,e){Da.call(this,t,e),this.current=ue.transparent}var Fa,Ua=new Float32Array(16);(Fa=Ai)&&(ja.__proto__=Fa),((ja.prototype=Object.create(Fa&&Fa.prototype)).constructor=ja).prototype.set=function(t){if(t[12]!==this.current[12]||t[0]!==this.current[0])return this.current=t,void this.gl.uniformMatrix4fv(this.location,!1,t);for(var e=1;e<16;e++)if(t[e]!==this.current[e]){this.current=t,this.gl.uniformMatrix4fv(this.location,!1,t);break}},Li=ja;function ja(t,e){Fa.call(this,t,e),this.current=Ua}function Va(t){return[ya(255*t.r,255*t.g),ya(255*t.b,255*t.a)]}function qa(t,e,i){this.value=t,this.uniformNames=e.map(function(t){return"u_"+t}),this.type=i}function Ha(t,e){this.uniformNames=e.map(function(t){return"u_"+t}),this.patternFrom=null,this.patternTo=null,this.pixelRatioFrom=1,this.pixelRatioTo=1}function Ga(t,e,i,r){this.expression=t,this.type=i,this.maxValue=0,this.paintVertexAttributes=e.map(function(t){return{name:"a_"+t,type:"Float32",components:"color"===i?2:1,offset:0}}),this.paintVertexArray=new r}function Za(t,e,i,r,n,o){this.expression=t,this.uniformNames=e.map(function(t){return"u_"+t+"_t"}),this.type=i,this.useIntegerZoom=r,this.zoom=n,this.maxValue=0,this.paintVertexAttributes=e.map(function(t){return{name:"a_"+t,type:"Float32",components:"color"===i?4:2,offset:0}}),this.paintVertexArray=new o}function Wa(t,e,i,r,n,o){this.expression=t,this.type=e,this.useIntegerZoom=i,this.zoom=r,this.layerId=o,this.zoomInPaintVertexArray=new n,this.zoomOutPaintVertexArray=new n}function Ka(t,e,i){this.binders={},this._buffers=[];var r,n,o,a,s,l,u,c=[];for(r in t.paint._values)i(r)&&(a=t.paint.get(r))instanceof bn&&ji(a.property.specification)&&(l=r,u=t.type,n={"text-opacity":["opacity"],"icon-opacity":["opacity"],"text-color":["fill_color"],"icon-color":["fill_color"],"text-halo-color":["halo_color"],"icon-halo-color":["halo_color"],"text-halo-blur":["halo_blur"],"icon-halo-blur":["halo_blur"],"text-halo-width":["halo_width"],"icon-halo-width":["halo_width"],"line-gap-width":["gapwidth"],"line-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"],"fill-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"],"fill-extrusion-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"]}[l]||[l.replace(u+"-","").replace(/-/g,"_")],o=a.value,l=a.property.specification.type,u=a.property.useIntegerZoom,a="cross-faded"===(a=a.property.specification["property-type"])||"cross-faded-data-driven"===a,"constant"===o.kind?(this.binders[r]=a?new Ha(o.value,n):new qa(o.value,n,l),c.push("/u_"+r)):"source"===o.kind||a?(s=Ya(r,l,"source"),this.binders[r]=a?new Wa(o,l,u,e,s,t.id):new Ga(o,n,l,s),c.push("/a_"+r)):(s=Ya(r,l,"composite"),this.binders[r]=new Za(o,n,l,u,e,s),c.push("/z_"+r)));this.cacheKey=c.sort().join("")}function Xa(t,e,i){void 0===i&&(i=function(){return!0}),this.programConfigurations={};for(var r=0,n=t;r<n.length;r+=1){var o=n[r];this.programConfigurations[o.id]=new Ka(o,e,i)}this.needsUpload=!1,this._featureMap=new xa,this._bufferOffset=0}function Ya(t,e,i){return(t={"line-pattern":{source:$n,composite:$n},"fill-pattern":{source:$n,composite:$n},"fill-extrusion-pattern":{source:$n,composite:$n}}[t])&&t[i]||{color:{source:Yn,composite:Ho},number:{source:Oo,composite:Yn}}[e][i]}qa.prototype.setUniform=function(t,e,i){t.set(i.constantOr(this.value))},qa.prototype.getBinding=function(t,e,i){return new("color"===this.type?Na:Ia)(t,e)},Ha.prototype.setConstantPatternPositions=function(t,e){this.pixelRatioFrom=e.pixelRatio,this.pixelRatioTo=t.pixelRatio,this.patternFrom=e.tlbr,this.patternTo=t.tlbr},Ha.prototype.setUniform=function(t,e,i,r){(r="u_pattern_to"===r?this.patternTo:"u_pattern_from"===r?this.patternFrom:"u_pixel_ratio_to"===r?this.pixelRatioTo:"u_pixel_ratio_from"===r?this.pixelRatioFrom:null)&&t.set(r)},Ha.prototype.getBinding=function(t,e,i){return new("u_pattern"===i.substr(0,9)?Ra:Ia)(t,e)},Ga.prototype.populatePaintArray=function(t,e,i,r,n){var o=this.paintVertexArray.length;n=this.expression.evaluate(new hn(0),e,{},r,[],n);this.paintVertexArray.resize(t),this._setPaintValue(o,t,n)},Ga.prototype.updatePaintArray=function(t,e,i,r){r=this.expression.evaluate({zoom:0},i,r),this._setPaintValue(t,e,r)},Ga.prototype._setPaintValue=function(t,e,i){if("color"===this.type)for(var r=Va(i),n=t;n<e;n++)this.paintVertexArray.emplace(n,r[0],r[1]);else{for(var o=t;o<e;o++)this.paintVertexArray.emplace(o,i);this.maxValue=Math.max(this.maxValue,Math.abs(i))}},Ga.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent))},Ga.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy()},Za.prototype.populatePaintArray=function(t,e,i,r,n){var o=this.expression.evaluate(new hn(this.zoom),e,{},r,[],n);r=this.expression.evaluate(new hn(this.zoom+1),e,{},r,[],n),n=this.paintVertexArray.length;this.paintVertexArray.resize(t),this._setPaintValue(n,t,o,r)},Za.prototype.updatePaintArray=function(t,e,i,r){var n=this.expression.evaluate({zoom:this.zoom},i,r);r=this.expression.evaluate({zoom:this.zoom+1},i,r);this._setPaintValue(t,e,n,r)},Za.prototype._setPaintValue=function(t,e,i,r){if("color"===this.type)for(var n=Va(i),o=Va(r),a=t;a<e;a++)this.paintVertexArray.emplace(a,n[0],n[1],o[0],o[1]);else{for(var s=t;s<e;s++)this.paintVertexArray.emplace(s,i,r);this.maxValue=Math.max(this.maxValue,Math.abs(i),Math.abs(r))}},Za.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent))},Za.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy()},Za.prototype.setUniform=function(t,e){e=this.useIntegerZoom?Math.floor(e.zoom):e.zoom,e=p(this.expression.interpolationFactor(e,this.zoom,this.zoom+1),0,1),t.set(e)},Za.prototype.getBinding=function(t,e,i){return new Ia(t,e)},Wa.prototype.populatePaintArray=function(t,e,i){var r=this.zoomInPaintVertexArray.length;this.zoomInPaintVertexArray.resize(t),this.zoomOutPaintVertexArray.resize(t),this._setPaintValues(r,t,e.patterns&&e.patterns[this.layerId],i)},Wa.prototype.updatePaintArray=function(t,e,i,r,n){this._setPaintValues(t,e,i.patterns&&i.patterns[this.layerId],n)},Wa.prototype._setPaintValues=function(t,e,i,r){if(r&&i){var n=i.min,o=i.mid,a=(i=i.max,r[n]),s=r[o],l=r[i];if(a&&s&&l)for(var u=t;u<e;u++)this.zoomInPaintVertexArray.emplace(u,s.tl[0],s.tl[1],s.br[0],s.br[1],a.tl[0],a.tl[1],a.br[0],a.br[1],s.pixelRatio,a.pixelRatio),this.zoomOutPaintVertexArray.emplace(u,s.tl[0],s.tl[1],s.br[0],s.br[1],l.tl[0],l.tl[1],l.br[0],l.br[1],s.pixelRatio,l.pixelRatio)}},Wa.prototype.upload=function(t){this.zoomInPaintVertexArray&&this.zoomInPaintVertexArray.arrayBuffer&&this.zoomOutPaintVertexArray&&this.zoomOutPaintVertexArray.arrayBuffer&&(this.zoomInPaintVertexBuffer=t.createVertexBuffer(this.zoomInPaintVertexArray,ga.members,this.expression.isStateDependent),this.zoomOutPaintVertexBuffer=t.createVertexBuffer(this.zoomOutPaintVertexArray,ga.members,this.expression.isStateDependent))},Wa.prototype.destroy=function(){this.zoomOutPaintVertexBuffer&&this.zoomOutPaintVertexBuffer.destroy(),this.zoomInPaintVertexBuffer&&this.zoomInPaintVertexBuffer.destroy()},Ka.prototype.getMaxValue=function(t){return(t=this.binders[t])instanceof Ga||t instanceof Za?t.maxValue:0},Ka.prototype.populatePaintArrays=function(t,e,i,r,n){for(var o in this.binders)((o=this.binders[o])instanceof Ga||o instanceof Za||o instanceof Wa)&&o.populatePaintArray(t,e,i,r,n)},Ka.prototype.setConstantPatternPositions=function(t,e){for(var i in this.binders)(i=this.binders[i])instanceof Ha&&i.setConstantPatternPositions(t,e)},Ka.prototype.updatePaintArrays=function(t,e,i,r,n){var o,a=!1;for(o in t)for(var s=0,l=e.getPositions(o);s<l.length;s+=1){var u,c=l[s],p=i.feature(c.index);for(u in this.binders){var h,d=this.binders[u];(d instanceof Ga||d instanceof Za||d instanceof Wa)&&!0===d.expression.isStateDependent&&(h=r.paint.get(u),d.expression=h.value,d.updatePaintArray(c.start,c.end,p,t[o],n),a=!0)}}return a},Ka.prototype.defines=function(){var t,e=[];for(t in this.binders){var i=this.binders[t];(i instanceof qa||i instanceof Ha)&&e.push.apply(e,i.uniformNames.map(function(t){return"#define HAS_UNIFORM_"+t}))}return e},Ka.prototype.getBinderAttributes=function(){var t,e=[];for(t in this.binders){var i=this.binders[t];if(i instanceof Ga||i instanceof Za)for(var r=0;r<i.paintVertexAttributes.length;r++)e.push(i.paintVertexAttributes[r].name);else if(i instanceof Wa)for(var n=0;n<ga.members.length;n++)e.push(ga.members[n].name)}return e},Ka.prototype.getBinderUniforms=function(){var t,e=[];for(t in this.binders){var i=this.binders[t];if(i instanceof qa||i instanceof Ha||i instanceof Za)for(var r=0,n=i.uniformNames;r<n.length;r+=1){var o=n[r];e.push(o)}}return e},Ka.prototype.getPaintVertexBuffers=function(){return this._buffers},Ka.prototype.getUniforms=function(t,e){var i,r=[];for(i in this.binders){var n=this.binders[i];if(n instanceof qa||n instanceof Ha||n instanceof Za)for(var o=0,a=n.uniformNames;o<a.length;o+=1){var s,l=a[o];e[l]&&(s=n.getBinding(t,e[l],l),r.push({name:l,property:i,binding:s}))}}return r},Ka.prototype.setUniforms=function(t,e,i,r){for(var n=0,o=e;n<o.length;n+=1){var a=(l=o[n]).name,s=l.property,l=l.binding;this.binders[s].setUniform(l,r,i.get(s),a)}},Ka.prototype.updatePaintBuffers=function(t){for(var e in this._buffers=[],this.binders){var i=this.binders[e];t&&i instanceof Wa?(e=2===t.fromScale?i.zoomInPaintVertexBuffer:i.zoomOutPaintVertexBuffer)&&this._buffers.push(e):(i instanceof Ga||i instanceof Za)&&i.paintVertexBuffer&&this._buffers.push(i.paintVertexBuffer)}},Ka.prototype.upload=function(t){for(var e in this.binders)((e=this.binders[e])instanceof Ga||e instanceof Za||e instanceof Wa)&&e.upload(t);this.updatePaintBuffers()},Ka.prototype.destroy=function(){for(var t in this.binders)((t=this.binders[t])instanceof Ga||t instanceof Za||t instanceof Wa)&&t.destroy()},Xa.prototype.populatePaintArrays=function(t,e,i,r,n,o){for(var a in this.programConfigurations)this.programConfigurations[a].populatePaintArrays(t,e,r,n,o);void 0!==e.id&&this._featureMap.add(e.id,i,this._bufferOffset,t),this._bufferOffset=t,this.needsUpload=!0},Xa.prototype.updatePaintArrays=function(t,e,i,r){for(var n=0,o=i;n<o.length;n+=1){var a=o[n];this.needsUpload=this.programConfigurations[a.id].updatePaintArrays(t,this._featureMap,e,a,r)||this.needsUpload}},Xa.prototype.get=function(t){return this.programConfigurations[t]},Xa.prototype.upload=function(t){if(this.needsUpload){for(var e in this.programConfigurations)this.programConfigurations[e].upload(t);this.needsUpload=!1}},Xa.prototype.destroy=function(){for(var t in this.programConfigurations)this.programConfigurations[t].destroy()},Wr("ConstantBinder",qa),Wr("CrossFadedConstantBinder",Ha),Wr("SourceExpressionBinder",Ga),Wr("CrossFadedCompositeBinder",Wa),Wr("CompositeExpressionBinder",Za),Wr("ProgramConfiguration",Ka,{omit:["_buffers"]}),Wr("ProgramConfigurationSet",Xa);var Ja=8192,Qa=Math.pow(2,14)-1,$a=-Qa-1;function ts(t){for(var e=Ja/t.extent,i=t.loadGeometry(),r=0;r<i.length;r++)for(var n=i[r],o=0;o<n.length;o++){var a=n[o],s=Math.round(a.x*e),l=Math.round(a.y*e);a.x=p(s,$a,Qa),a.y=p(l,$a,Qa),(s<a.x||s>a.x+1||l<a.y||l>a.y+1)&&S("Geometry exceeds allowed extent, reduce your vector tile buffer size")}return i}function es(t,e){return{type:t.type,id:t.id,properties:t.properties,geometry:e?ts(t):[]}}function is(t,e,i,r,n){t.emplaceBack(2*e+(r+1)/2,2*i+(n+1)/2)}function rs(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new Bn,this.indexArray=new Eo,this.segments=new fa,this.programConfigurations=new Xa(t.layers,t.zoom),this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id})}function ns(t,e){for(var i=0;i<t.length;i++)if(cs(e,t[i]))return!0;for(var r=0;r<e.length;r++)if(cs(t,e[r]))return!0;return!!as(t,e)}function os(t,e){if(1===t.length)return us(e,t[0]);for(var i=0;i<e.length;i++)for(var r=e[i],n=0;n<r.length;n++)if(cs(t,r[n]))return!0;for(var o=0;o<t.length;o++)if(us(e,t[o]))return!0;for(var a=0;a<e.length;a++)if(as(t,e[a]))return!0;return!1}function as(t,e){if(0!==t.length&&0!==e.length)for(var i,r,n=0;n<t.length-1;n++)for(var o=t[n],a=t[n+1],s=0;s<e.length-1;s++){var l=e[s],u=e[s+1];if(r=a,T(i=o,l=l,u=u)!==T(r,l,u)&&T(i,r,l)!==T(i,r,u))return 1}}function ss(t,e,i){var r=i*i;if(1===e.length)return t.distSqr(e[0])<r;for(var n=1;n<e.length;n++)if(ls(t,e[n-1],e[n])<r)return 1}function ls(t,e,i){var r=e.distSqr(i);return 0===r?t.distSqr(e):(r=((t.x-e.x)*(i.x-e.x)+(t.y-e.y)*(i.y-e.y))/r)<0?t.distSqr(e):1<r?t.distSqr(i):t.distSqr(i.sub(e)._mult(r)._add(e))}function us(t,e){for(var i,r,n=!1,o=0;o<t.length;o++)for(var a,s=0,l=(a=t[o]).length-1;s<a.length;l=s++)i=a[s],r=a[l],i.y>e.y!=r.y>e.y&&e.x<(r.x-i.x)*(e.y-i.y)/(r.y-i.y)+i.x&&(n=!n);return n}function cs(t,e){for(var i=!1,r=0,n=t.length-1;r<t.length;n=r++){var o=t[r],a=t[n];o.y>e.y!=a.y>e.y&&e.x<(a.x-o.x)*(e.y-o.y)/(a.y-o.y)+o.x&&(i=!i)}return i}function ps(t,e,i){var r=e.paint.get(t).value;return"constant"===r.kind?r.value:i.programConfigurations.get(e.id).getMaxValue(t)}function hs(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function ds(t,e,i,r,n){if(!e[0]&&!e[1])return t;var a=o.convert(e)._mult(n);"viewport"===i&&a._rotate(-r);for(var s=[],l=0;l<t.length;l++){var u=t[l];s.push(u.sub(a))}return s}rs.prototype.populate=function(t,e,i){var r=this.layers[0],n=[],o=null;"circle"===r.type&&(o=r.layout.get("circle-sort-key"));for(var a=0,s=t;a<s.length;a+=1){var l=s[a],u=l.feature,c=l.id,p=l.index,h=l.sourceLayerIndex,d=this.layers[0]._featureFilter.needGeometry,f=es(u,d);this.layers[0]._featureFilter.filter(new hn(this.zoom),f,i)&&(l=o?o.evaluate(f,{},i):void 0,l={id:c,properties:u.properties,type:u.type,sourceLayerIndex:h,index:p,geometry:d?f.geometry:ts(u),patterns:{},sortKey:l},n.push(l))}o&&n.sort(function(t,e){return t.sortKey-e.sortKey});for(var m=0,y=n;m<y.length;m+=1){var g=y[m],v=g.geometry,_=g.index,x=g.sourceLayerIndex,b=t[_].feature;this.addFeature(g,v,_,i),e.featureIndex.insert(b,v,_,x,this.index)}},rs.prototype.update=function(t,e,i){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,i)},rs.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},rs.prototype.uploadPending=function(){return!this.uploaded||this.programConfigurations.needsUpload},rs.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,ma),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0},rs.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy())},rs.prototype.addFeature=function(t,e,i,r){for(var n=0,o=e;n<o.length;n+=1)for(var a=0,s=o[n];a<s.length;a+=1){var l,u=s[a],c=u.x,p=u.y;c<0||Ja<=c||p<0||Ja<=p||(u=(l=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray,t.sortKey)).vertexLength,is(this.layoutVertexArray,c,p,-1,-1),is(this.layoutVertexArray,c,p,1,-1),is(this.layoutVertexArray,c,p,1,1),is(this.layoutVertexArray,c,p,-1,1),this.indexArray.emplaceBack(u,u+1,u+2),this.indexArray.emplaceBack(u,u+3,u+2),l.vertexLength+=4,l.primitiveLength+=2)}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,i,{},r)},Wr("CircleBucket",rs,{omit:["layers"]});var fs=new kn({"circle-sort-key":new Rc(Dt.layout_circle["circle-sort-key"])}),ms={paint:new kn({"circle-radius":new Rc(Dt.paint_circle["circle-radius"]),"circle-color":new Rc(Dt.paint_circle["circle-color"]),"circle-blur":new Rc(Dt.paint_circle["circle-blur"]),"circle-opacity":new Rc(Dt.paint_circle["circle-opacity"]),"circle-translate":new Sn(Dt.paint_circle["circle-translate"]),"circle-translate-anchor":new Sn(Dt.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new Sn(Dt.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new Sn(Dt.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new Rc(Dt.paint_circle["circle-stroke-width"]),"circle-stroke-color":new Rc(Dt.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new Rc(Dt.paint_circle["circle-stroke-opacity"])}),layout:fs},ys="undefined"!=typeof Float32Array?Float32Array:Array;function gs(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function vs(t,e,i){var r=e[0],n=e[1],o=e[2],a=e[3],s=e[4],l=e[5],u=e[6],c=e[7],p=e[8],h=e[9],d=e[10],f=e[11],m=e[12],y=e[13],g=e[14],v=e[15],_=i[0],x=i[1],b=i[2];e=i[3];return t[0]=_*r+x*s+b*p+e*m,t[1]=_*n+x*l+b*h+e*y,t[2]=_*o+x*u+b*d+e*g,t[3]=_*a+x*c+b*f+e*v,_=i[4],x=i[5],b=i[6],e=i[7],t[4]=_*r+x*s+b*p+e*m,t[5]=_*n+x*l+b*h+e*y,t[6]=_*o+x*u+b*d+e*g,t[7]=_*a+x*c+b*f+e*v,_=i[8],x=i[9],b=i[10],e=i[11],t[8]=_*r+x*s+b*p+e*m,t[9]=_*n+x*l+b*h+e*y,t[10]=_*o+x*u+b*d+e*g,t[11]=_*a+x*c+b*f+e*v,_=i[12],x=i[13],b=i[14],e=i[15],t[12]=_*r+x*s+b*p+e*m,t[13]=_*n+x*l+b*h+e*y,t[14]=_*o+x*u+b*d+e*g,t[15]=_*a+x*c+b*f+e*v,t}Math.hypot||(Math.hypot=function(){for(var t=arguments,e=0,i=arguments.length;i--;)e+=t[i]*t[i];return Math.sqrt(e)}),po=vs;var _s,xs,bs=function(t,e,i){return t[0]=e[0]-i[0],t[1]=e[1]-i[1],t[2]=e[2]-i[2],t};function ws(t,e,i){var r=e[0],n=e[1],o=e[2];e=e[3];return t[0]=i[0]*r+i[4]*n+i[8]*o+i[12]*e,t[1]=i[1]*r+i[5]*n+i[9]*o+i[13]*e,t[2]=i[2]*r+i[6]*n+i[10]*o+i[14]*e,t[3]=i[3]*r+i[7]*n+i[11]*o+i[15]*e,t}_s=new ys(3),ys!=Float32Array&&(_s[0]=0,_s[1]=0,_s[2]=0),xs=new ys(4),ys!=Float32Array&&(xs[0]=0,xs[1]=0,xs[2]=0,xs[3]=0);var Ss,Ts,Cs=function(t){var e=t[0];return e*e+(t=t[1])*t};Ss=new ys(2),ys!=Float32Array&&(Ss[0]=0,Ss[1]=0),(Ts=Mn)&&(Es.__proto__=Ts),((Es.prototype=Object.create(Ts&&Ts.prototype)).constructor=Es).prototype.createBucket=function(t){return new rs(t)},Es.prototype.queryRadius=function(t){return ps("circle-radius",this,t)+ps("circle-stroke-width",this,t)+hs(this.paint.get("circle-translate"))},Es.prototype.queryIntersectsFeature=function(t,e,i,r,n,o,a,s){t=ds(t,this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),o.angle,a),i=this.paint.get("circle-radius").evaluate(e,i)+this.paint.get("circle-stroke-width").evaluate(e,i);for(var l,u="map"===this.paint.get("circle-pitch-alignment"),c=u?t:(l=s,t.map(function(t){return Is(t,l)})),p=u?i*a:i,h=0,d=r;h<d.length;h+=1)for(var f=0,m=d[h];f<m.length;f+=1){var y=m[f],g=u?y:Is(y,s),v=p;y=ws([],[y.x,y.y,0,1],s);if("viewport"===this.paint.get("circle-pitch-scale")&&"map"===this.paint.get("circle-pitch-alignment")?v*=y[3]/o.cameraToCenterDistance:"map"===this.paint.get("circle-pitch-scale")&&"viewport"===this.paint.get("circle-pitch-alignment")&&(v*=o.cameraToCenterDistance/y[3]),y=v,cs(v=c,g=g)||ss(g,v,y))return!0}return!1},R=Es;function Es(t){Ts.call(this,t,ms)}function Is(t,e){return e=ws([],[t.x,t.y,0,1],e),new o(e[0]/e[3],e[1]/e[3])}var ks,As=((ks=rs)&&(Ps.__proto__=ks),(Ps.prototype=Object.create(ks&&ks.prototype)).constructor=Ps);function Ps(){ks.apply(this,arguments)}function Ms(t,e,i,r){var n=e.width;e=e.height;if(r){if(r instanceof Uint8ClampedArray)r=new Uint8Array(r.buffer);else if(r.length!==n*e*i)throw new RangeError("mismatched image size")}else r=new Uint8Array(n*e*i);return t.width=n,t.height=e,t.data=r,t}function Ls(t,e,i){var r=e.width,n=e.height;r===t.width&&n===t.height||(Os(t,e=Ms({},{width:r,height:n},i),{x:0,y:0},{x:0,y:0},{width:Math.min(t.width,r),height:Math.min(t.height,n)},i),t.width=r,t.height=n,t.data=e.data)}function Os(t,e,i,r,n,o){if(0===n.width||0===n.height)return e;if(n.width>t.width||n.height>t.height||i.x>t.width-n.width||i.y>t.height-n.height)throw new RangeError("out of range source coordinates for image copy");if(n.width>e.width||n.height>e.height||r.x>e.width-n.width||r.y>e.height-n.height)throw new RangeError("out of range destination coordinates for image copy");for(var a=t.data,s=e.data,l=0;l<n.height;l++)for(var u=((i.y+l)*t.width+i.x)*o,c=((r.y+l)*e.width+r.x)*o,p=0;p<n.width*o;p++)s[c+p]=a[u+p];return e}function Rs(t,e){Ms(this,t,1,e)}function zs(t,e){Ms(this,t,4,e)}Wr("HeatmapBucket",As,{omit:["layers"]}),Rs.prototype.resize=function(t){Ls(this,t,1)},Rs.prototype.clone=function(){return new Rs({width:this.width,height:this.height},new Uint8Array(this.data))},Rs.copy=function(t,e,i,r,n){Os(t,e,i,r,n,1)},zs.prototype.resize=function(t){Ls(this,t,4)},zs.prototype.replace=function(t,e){e?this.data.set(t):t instanceof Uint8ClampedArray?this.data=new Uint8Array(t.buffer):this.data=t},zs.prototype.clone=function(){return new zs({width:this.width,height:this.height},new Uint8Array(this.data))},zs.copy=function(t,e,i,r,n){Os(t,e,i,r,n,4)},Wr("AlphaImage",Rs),Wr("RGBAImage",zs);var Ds={paint:new kn({"heatmap-radius":new Rc(Dt.paint_heatmap["heatmap-radius"]),"heatmap-weight":new Rc(Dt.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new Sn(Dt.paint_heatmap["heatmap-intensity"]),"heatmap-color":new In(Dt.paint_heatmap["heatmap-color"]),"heatmap-opacity":new Sn(Dt.paint_heatmap["heatmap-opacity"])})};function Ns(t){function e(e,r,n){i[t.evaluationKey]=n,n=t.expression.evaluate(i),o.data[e+r+0]=Math.floor(255*n.r/n.a),o.data[e+r+1]=Math.floor(255*n.g/n.a),o.data[e+r+2]=Math.floor(255*n.b/n.a),o.data[e+r+3]=Math.floor(255*n.a)}var i={},r=t.resolution||256,n=t.clips?t.clips.length:1,o=t.image||new zs({width:r,height:n});if(t.clips)for(var a=0,s=0;a<n;++a,s+=4*r)for(var l=0,u=0;l<r;l++,u+=4){var c=l/(r-1),p=t.clips[a];e(s,u,p.start*(1-c)+p.end*c)}else for(var h=0,d=0;h<r;h++,d+=4)e(0,d,h/(r-1));return o}var Bs;(Bs=Mn)&&(Fs.__proto__=Bs),((Fs.prototype=Object.create(Bs&&Bs.prototype)).constructor=Fs).prototype.createBucket=function(t){return new As(t)},Fs.prototype._handleSpecialPaintPropertyUpdate=function(t){"heatmap-color"===t&&this._updateColorRamp()},Fs.prototype._updateColorRamp=function(){var t=this._transitionablePaint._values["heatmap-color"].value.expression;this.colorRamp=Ns({expression:t,evaluationKey:"heatmapDensity",image:this.colorRamp}),this.colorRampTexture=null},Fs.prototype.resize=function(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null)},Fs.prototype.queryRadius=function(){return 0},Fs.prototype.queryIntersectsFeature=function(){return!1},Fs.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility},Rn=Fs;function Fs(t){Bs.call(this,t,Ds),this._updateColorRamp()}var Us,js={paint:new kn({"hillshade-illumination-direction":new Sn(Dt.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new Sn(Dt.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new Sn(Dt.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new Sn(Dt.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new Sn(Dt.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new Sn(Dt.paint_hillshade["hillshade-accent-color"])})},Vs=((Us=Mn)&&(qs.__proto__=Us),((qs.prototype=Object.create(Us&&Us.prototype)).constructor=qs).prototype.hasOffscreenPass=function(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility},qs);function qs(t){Us.call(this,t,js)}var Hs=zn([{name:"a_pos",components:2,type:"Int16"}],4).members,Gs=Zs;va=Zs;function Zs(t,e,i){i=i||2;var r,n,o,a,s,l=e&&e.length,u=l?e[0]*i:t.length,c=Ws(t,0,u,i,!0),p=[];if(!c||c.next===c.prev)return p;if(l&&(c=function(t,e,i,r){var n,o,a,s=[];for(n=0,o=e.length;n<o;n++)(a=Ws(t,e[n]*r,a=n<o-1?e[n+1]*r:t.length,r,!1))===a.next&&(a.steiner=!0),s.push(function(t){for(var e=t,i=t;(e.x<i.x||e.x===i.x&&e.y<i.y)&&(i=e),(e=e.next)!==t;);return i}(a));for(s.sort(Xs),n=0;n<s.length;n++)i=function(t,e){var i=function(t,e){var i,r=e,n=t.x,o=t.y,a=-1/0;do{if(o<=r.y&&o>=r.next.y&&r.next.y!==r.y){var s=r.x+(o-r.y)*(r.next.x-r.x)/(r.next.y-r.y);if(s<=n&&a<s){if((a=s)===n){if(o===r.y)return r;if(o===r.next.y)return r.next}i=r.x<r.next.x?r:r.next}}}while((r=r.next)!==e);if(!i)return null;if(n===a)return i;var l,u=i,c=i.x,p=i.y,h=1/0;for(r=i;n>=r.x&&r.x>=c&&n!==r.x&&Js(o<p?n:a,o,c,p,o<p?a:n,o,r.x,r.y)&&(l=Math.abs(o-r.y)/(n-r.x),rl(r,t)&&(l<h||l===h&&(r.x>i.x||r.x===i.x&&function(t,e){return Qs(t.prev,t,e.prev)<0&&Qs(e.next,t,t.next)<0}(i,r)))&&(i=r,h=l)),(r=r.next)!==u;);return i}(t,e);if(!i)return e;var r=nl(i,t);t=Ks(i,i.next);return Ks(r,r.next),e===i?t:e}(s[n],i),i=Ks(i,i.next);return i}(t,e,c,i)),t.length>80*i){for(var h=r=t[0],d=n=t[1],f=i;f<u;f+=i)(o=t[f])<h&&(h=o),(a=t[f+1])<d&&(d=a),r<o&&(r=o),n<a&&(n=a);s=0!==(s=Math.max(r-h,n-d))?1/s:0}return function t(e,i,r,n,o,a,s){if(e){!s&&a&&function(t,e,i,r){for(var n=t;null===n.z&&(n.z=Ys(n.x,n.y,e,i,r)),n.prevZ=n.prev,n.nextZ=n.next,(n=n.next)!==t;);n.prevZ.nextZ=null,n.prevZ=null,function(t){var e,i,r,n,o,a,s,l,u=1;do{for(i=t,o=t=null,a=0;i;){for(a++,r=i,e=s=0;e<u&&(s++,r=r.nextZ);e++);for(l=u;0<s||0<l&&r;)0!==s&&(0===l||!r||i.z<=r.z)?(i=(n=i).nextZ,s--):(r=(n=r).nextZ,l--),o?o.nextZ=n:t=n,n.prevZ=o,o=n;i=r}}while(o.nextZ=null,u*=2,1<a)}(n)}(e,n,o,a);for(var l,u,c=e;e.prev!==e.next;)if(l=e.prev,u=e.next,a?function(t,e,i,r){var n=t.prev,o=t,a=t.next;if(0<=Qs(n,o,a))return!1;for(var s=(n.x<o.x?n.x<a.x?n:a:o.x<a.x?o:a).x,l=(n.y<o.y?n.y<a.y?n:a:o.y<a.y?o:a).y,u=(n.x>o.x?n.x>a.x?n:a:o.x>a.x?o:a).x,c=(n.y>o.y?n.y>a.y?n:a:o.y>a.y?o:a).y,p=Ys(s,l,e,i,r),h=Ys(u,c,e,i,r),d=t.prevZ,f=t.nextZ;d&&d.z>=p&&f&&f.z<=h;){if(d!==t.prev&&d!==t.next&&Js(n.x,n.y,o.x,o.y,a.x,a.y,d.x,d.y)&&0<=Qs(d.prev,d,d.next))return!1;if(d=d.prevZ,f!==t.prev&&f!==t.next&&Js(n.x,n.y,o.x,o.y,a.x,a.y,f.x,f.y)&&0<=Qs(f.prev,f,f.next))return!1;f=f.nextZ}for(;d&&d.z>=p;){if(d!==t.prev&&d!==t.next&&Js(n.x,n.y,o.x,o.y,a.x,a.y,d.x,d.y)&&0<=Qs(d.prev,d,d.next))return!1;d=d.prevZ}for(;f&&f.z<=h;){if(f!==t.prev&&f!==t.next&&Js(n.x,n.y,o.x,o.y,a.x,a.y,f.x,f.y)&&0<=Qs(f.prev,f,f.next))return!1;f=f.nextZ}return!0}(e,n,o,a):function(t){var e=t.prev,i=t,r=t.next;if(0<=Qs(e,i,r))return!1;for(var n=t.next.next;n!==t.prev;){if(Js(e.x,e.y,i.x,i.y,r.x,r.y,n.x,n.y)&&0<=Qs(n.prev,n,n.next))return!1;n=n.next}return!0}(e))i.push(l.i/r),i.push(e.i/r),i.push(u.i/r),al(e),e=u.next,c=u.next;else if((e=u)===c){s?1===s?t(e=function(t,e,i){var r=t;do{var n=r.prev,o=r.next.next}while(!$s(n,o)&&tl(n,r,r.next,o)&&rl(n,o)&&rl(o,n)&&(e.push(n.i/i),e.push(r.i/i),e.push(o.i/i),al(r),al(r.next),r=t=o),(r=r.next)!==t);return Ks(r)}(Ks(e),i,r),i,r,n,o,a,2):2===s&&function(e,i,r,n,o,a){var s=e;do{for(var l=s.next.next;l!==s.prev;){if(s.i!==l.i&&function(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var i=t;do{if(i.i!==t.i&&i.next.i!==t.i&&i.i!==e.i&&i.next.i!==e.i&&tl(i,i.next,t,e))return!0}while((i=i.next)!==t);return!1}(t,e)&&(rl(t,e)&&rl(e,t)&&function(t,e){for(var i=t,r=!1,n=(t.x+e.x)/2,o=(t.y+e.y)/2;i.y>o!=i.next.y>o&&i.next.y!==i.y&&n<(i.next.x-i.x)*(o-i.y)/(i.next.y-i.y)+i.x&&(r=!r),(i=i.next)!==t;);return r}(t,e)&&(Qs(t.prev,t,e.prev)||Qs(t,e.prev,e))||$s(t,e)&&0<Qs(t.prev,t,t.next)&&0<Qs(e.prev,e,e.next))}(s,l)){var u=nl(s,l);return s=Ks(s,s.next),u=Ks(u,u.next),t(s,i,r,n,o,a),t(u,i,r,n,o,a)}l=l.next}}while((s=s.next)!==e)}(e,i,r,n,o,a):t(Ks(e),i,r,n,o,a,1);break}}}(c,p,i,h,d,s),p}function Ws(t,e,i,r,n){var o,a;if(n===0<ll(t,e,i,r))for(o=e;o<i;o+=r)a=ol(o,t[o],t[o+1],a);else for(o=i-r;e<=o;o-=r)a=ol(o,t[o],t[o+1],a);return a&&$s(a,a.next)&&(al(a),a=a.next),a}function Ks(t,e){if(!t)return t;e=e||t;var i,r=t;do{if(i=!1,r.steiner||!$s(r,r.next)&&0!==Qs(r.prev,r,r.next))r=r.next;else{if(al(r),(r=e=r.prev)===r.next)break;i=!0}}while(i||r!==e);return e}function Xs(t,e){return t.x-e.x}function Ys(t,e,i,r,n){return(t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=32767*(t-i)*n)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=32767*(e-r)*n)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function Js(t,e,i,r,n,o,a,s){return 0<=(n-a)*(e-s)-(t-a)*(o-s)&&0<=(t-a)*(r-s)-(i-a)*(e-s)&&0<=(i-a)*(o-s)-(n-a)*(r-s)}function Qs(t,e,i){return(e.y-t.y)*(i.x-e.x)-(e.x-t.x)*(i.y-e.y)}function $s(t,e){return t.x===e.x&&t.y===e.y}function tl(t,e,i,r){var n=il(Qs(t,e,i)),o=il(Qs(t,e,r)),a=il(Qs(i,r,t)),s=il(Qs(i,r,e));return n!==o&&a!==s||0===n&&el(t,i,e)||0===o&&el(t,r,e)||0===a&&el(i,t,r)||!(0!==s||!el(i,e,r))}function el(t,e,i){return e.x<=Math.max(t.x,i.x)&&e.x>=Math.min(t.x,i.x)&&e.y<=Math.max(t.y,i.y)&&e.y>=Math.min(t.y,i.y)}function il(t){return 0<t?1:t<0?-1:0}function rl(t,e){return Qs(t.prev,t,t.next)<0?0<=Qs(t,e,t.next)&&0<=Qs(t,t.prev,e):Qs(t,e,t.prev)<0||Qs(t,t.next,e)<0}function nl(t,e){var i=new sl(t.i,t.x,t.y),r=new sl(e.i,e.x,e.y),n=t.next,o=e.prev;return(t.next=e).prev=t,(i.next=n).prev=i,(r.next=i).prev=r,(o.next=r).prev=o,r}function ol(t,e,i,r){return i=new sl(t,e,i),r?(i.next=r.next,(i.prev=r).next.prev=i,r.next=i):(i.prev=i).next=i,i}function al(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ)}function sl(t,e,i){this.i=t,this.x=e,this.y=i,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1}function ll(t,e,i,r){for(var n=0,o=e,a=i-r;o<i;o+=r)n+=(t[a]-t[o])*(t[o+1]+t[a+1]),a=o;return n}function ul(t,e,i,r,n){!function t(e,i,r,n,o){for(;r<n;){var a,s,l,u,c;600<n-r&&(a=n-r+1,s=i-r+1,u=Math.log(a),l=.5*Math.exp(2*u/3),c=.5*Math.sqrt(u*l*(a-l)/a)*(s-a/2<0?-1:1),t(e,i,u=Math.max(r,Math.floor(i-s*l/a+c)),c=Math.min(n,Math.floor(i+(a-s)*l/a+c)),o));var p=e[i],h=r,d=n;for(cl(e,r,i),0<o(e[n],p)&&cl(e,r,n);h<d;){for(cl(e,h,d),h++,d--;o(e[h],p)<0;)h++;for(;0<o(e[d],p);)d--}0===o(e[r],p)?cl(e,r,d):cl(e,++d,n),d<=i&&(r=d+1),i<=d&&(n=d-1)}}(t,e,i||0,r||t.length-1,n||pl)}function cl(t,e,i){var r=t[e];t[e]=t[i],t[i]=r}function pl(t,e){return t<e?-1:e<t?1:0}function hl(t,e){var i=t.length;if(i<=1)return[t];for(var r,n,o=[],a=0;a<i;a++){var s=function(t){for(var e,i,r=0,n=0,o=t.length,a=o-1;n<o;a=n++)e=t[n],r+=((i=t[a]).x-e.x)*(e.y+i.y);return r}(t[a]);0!==s&&(t[a].area=Math.abs(s),(n=void 0===n?s<0:n)===s<0?(r&&o.push(r),r=[t[a]]):r.push(t[a]))}if(r&&o.push(r),1<e)for(var l=0;l<o.length;l++)o[l].length<=e||(ul(o[l],e,1,o[l].length-1,dl),o[l]=o[l].slice(0,e));return o}function dl(t,e){return e.area-t.area}function fl(t,e,i){for(var r=i.patternDependencies,n=!1,o=0,a=e;o<a.length;o+=1){var s=a[o].paint.get(t+"-pattern");s.isConstant()||(n=!0),(s=s.constantOr(null))&&(r[s.to]=n=!0,r[s.from]=!0)}return n}function ml(t,e,i,r,n){for(var o=n.patternDependencies,a=0,s=e;a<s.length;a+=1){var l,u,c=s[a],p=c.paint.get(t+"-pattern").value;"constant"!==p.kind&&(l=p.evaluate({zoom:r-1},i,{},n.availableImages),u=p.evaluate({zoom:r},i,{},n.availableImages),p=p.evaluate({zoom:r+1},i,{},n.availableImages),l=l&&l.name?l.name:l,u=u&&u.name?u.name:u,p=p&&p.name?p.name:p,o[l]=!0,o[u]=!0,o[p]=!0,i.patterns[c.id]={min:l,mid:u,max:p})}return i}function yl(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new Bn,this.indexArray=new Eo,this.indexArray2=new Uo,this.programConfigurations=new Xa(t.layers,t.zoom),this.segments=new fa,this.segments2=new fa,this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id})}Zs.deviation=function(t,e,i,r){var n=e&&e.length,o=n?e[0]*i:t.length,a=Math.abs(ll(t,0,o,i));if(n)for(var s=0,l=e.length;s<l;s++){var u=e[s]*i,c=s<l-1?e[s+1]*i:t.length;a-=Math.abs(ll(t,u,c,i))}var p=0;for(s=0;s<r.length;s+=3){var h=r[s]*i,d=r[s+1]*i,f=r[s+2]*i;p+=Math.abs((t[h]-t[f])*(t[1+d]-t[1+h])-(t[h]-t[d])*(t[1+f]-t[1+h]))}return 0===a&&0===p?0:Math.abs((p-a)/a)},Zs.flatten=function(t){for(var e=t[0][0].length,i={vertices:[],holes:[],dimensions:e},r=0,n=0;n<t.length;n++){for(var o=0;o<t[n].length;o++)for(var a=0;a<e;a++)i.vertices.push(t[n][o][a]);0<n&&(r+=t[n-1].length,i.holes.push(r))}return i},Gs.default=va,yl.prototype.populate=function(t,e,i){this.hasPattern=fl("fill",this.layers,e);for(var r=this.layers[0].layout.get("fill-sort-key"),n=[],o=0,a=t;o<a.length;o+=1){var s=a[o],l=s.feature,u=s.id,c=s.index,p=s.sourceLayerIndex,h=this.layers[0]._featureFilter.needGeometry,d=es(l,h);this.layers[0]._featureFilter.filter(new hn(this.zoom),d,i)&&(s=r?r.evaluate(d,{},i,e.availableImages):void 0,s={id:u,properties:l.properties,type:l.type,sourceLayerIndex:p,index:c,geometry:h?d.geometry:ts(l),patterns:{},sortKey:s},n.push(s))}r&&n.sort(function(t,e){return t.sortKey-e.sortKey});for(var f=0,m=n;f<m.length;f+=1){var y,g=m[f],v=g.geometry,_=g.index,x=g.sourceLayerIndex;this.hasPattern?(y=ml("fill",this.layers,g,this.zoom,e),this.patternFeatures.push(y)):this.addFeature(g,v,_,i,{}),g=t[_].feature,e.featureIndex.insert(g,v,_,x,this.index)}},yl.prototype.update=function(t,e,i){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,i)},yl.prototype.addFeatures=function(t,e,i){for(var r=0,n=this.patternFeatures;r<n.length;r+=1){var o=n[r];this.addFeature(o,o.geometry,o.index,e,i)}},yl.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},yl.prototype.uploadPending=function(){return!this.uploaded||this.programConfigurations.needsUpload},yl.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Hs),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.indexBuffer2=t.createIndexBuffer(this.indexArray2)),this.programConfigurations.upload(t),this.uploaded=!0},yl.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy())},yl.prototype.addFeature=function(t,e,i,r,n){for(var o=0,a=hl(e,500);o<a.length;o+=1){for(var s=a[o],l=0,u=0,c=s;u<c.length;u+=1)l+=c[u].length;for(var p=this.segments.prepareSegment(l,this.layoutVertexArray,this.indexArray),h=p.vertexLength,d=[],f=[],m=0,y=s;m<y.length;m+=1){var g=y[m];if(0!==g.length){g!==s[0]&&f.push(d.length/2);var v=this.segments2.prepareSegment(g.length,this.layoutVertexArray,this.indexArray2),_=v.vertexLength;this.layoutVertexArray.emplaceBack(g[0].x,g[0].y),this.indexArray2.emplaceBack(_+g.length-1,_),d.push(g[0].x),d.push(g[0].y);for(var x=1;x<g.length;x++)this.layoutVertexArray.emplaceBack(g[x].x,g[x].y),this.indexArray2.emplaceBack(_+x-1,_+x),d.push(g[x].x),d.push(g[x].y);v.vertexLength+=g.length,v.primitiveLength+=g.length}}for(var b=Gs(d,f),w=0;w<b.length;w+=3)this.indexArray.emplaceBack(h+b[w],h+b[w+1],h+b[w+2]);p.vertexLength+=l,p.primitiveLength+=b.length/3}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,i,n,r)},Wr("FillBucket",yl,{omit:["layers","patternFeatures"]});et=new kn({"fill-sort-key":new Rc(Dt.layout_fill["fill-sort-key"])});var gl,vl={paint:new kn({"fill-antialias":new Sn(Dt.paint_fill["fill-antialias"]),"fill-opacity":new Rc(Dt.paint_fill["fill-opacity"]),"fill-color":new Rc(Dt.paint_fill["fill-color"]),"fill-outline-color":new Rc(Dt.paint_fill["fill-outline-color"]),"fill-translate":new Sn(Dt.paint_fill["fill-translate"]),"fill-translate-anchor":new Sn(Dt.paint_fill["fill-translate-anchor"]),"fill-pattern":new Cn(Dt.paint_fill["fill-pattern"])}),layout:et};(gl=Mn)&&(_l.__proto__=gl),((_l.prototype=Object.create(gl&&gl.prototype)).constructor=_l).prototype.recalculate=function(t,e){gl.prototype.recalculate.call(this,t,e),"constant"===(e=this.paint._values["fill-outline-color"]).value.kind&&void 0===e.value.value&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"])},_l.prototype.createBucket=function(t){return new yl(t)},_l.prototype.queryRadius=function(){return hs(this.paint.get("fill-translate"))},_l.prototype.queryIntersectsFeature=function(t,e,i,r,n,o,a){return os(ds(t,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),o.angle,a),r)},_l.prototype.isTileClipped=function(){return!0},ki=_l;function _l(t){gl.call(this,t,vl)}var xl=zn([{name:"a_pos",components:2,type:"Int16"},{name:"a_normal_ed",components:4,type:"Int16"}],4).members,bl=wl;function wl(t,e,i,r,n){this.properties={},this.extent=i,this.type=0,this._pbf=t,this._geometry=-1,this._keys=r,this._values=n,t.readFields(Sl,this,e)}function Sl(t,e,i){1==t?e.id=i.readVarint():2==t?function(t,e){for(var i=t.readVarint()+t.pos;t.pos<i;){var r=e._keys[t.readVarint()],n=e._values[t.readVarint()];e.properties[r]=n}}(i,e):3==t?e.type=i.readVarint():4==t&&(e._geometry=i.pos)}wl.types=["Unknown","Point","LineString","Polygon"],wl.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,i,r=t.readVarint()+t.pos,n=1,a=0,s=0,l=0,u=[];t.pos<r;)if(a<=0&&(n=7&(i=t.readVarint()),a=i>>3),a--,1===n||2===n)s+=t.readSVarint(),l+=t.readSVarint(),1===n&&(e&&u.push(e),e=[]),e.push(new o(s,l));else{if(7!==n)throw new Error("unknown command "+n);e&&e.push(e[0].clone())}return e&&u.push(e),u},wl.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e,i=t.readVarint()+t.pos,r=1,n=0,o=0,a=0,s=1/0,l=-1/0,u=1/0,c=-1/0;t.pos<i;)if(n<=0&&(r=7&(e=t.readVarint()),n=e>>3),n--,1===r||2===r)(o+=t.readSVarint())<s&&(s=o),l<o&&(l=o),(a+=t.readSVarint())<u&&(u=a),c<a&&(c=a);else if(7!==r)throw new Error("unknown command "+r);return[s,u,l,c]},wl.prototype.toGeoJSON=function(t,e,i){var r,n=this.extent*Math.pow(2,i),o=this.extent*t,a=this.extent*e,s=this.loadGeometry();e=wl.types[this.type];function l(t){for(var e=0;e<t.length;e++){var i=t[e],r=180-360*(i.y+a)/n;t[e]=[360*(i.x+o)/n-180,360/Math.PI*Math.atan(Math.exp(r*Math.PI/180))-90]}}switch(this.type){case 1:for(var u=[],c=0;c<s.length;c++)u[c]=s[c][0];l(s=u);break;case 2:for(c=0;c<s.length;c++)l(s[c]);break;case 3:for(s=function(t){var e=t.length;if(e<=1)return[t];for(var i,r,n=[],o=0;o<e;o++){var a=function(t){for(var e,i,r=0,n=0,o=t.length,a=o-1;n<o;a=n++)e=t[n],r+=((i=t[a]).x-e.x)*(e.y+i.y);return r}(t[o]);0!==a&&((r=void 0===r?a<0:r)===a<0?(i&&n.push(i),i=[t[o]]):i.push(t[o]))}return i&&n.push(i),n}(s),c=0;c<s.length;c++)for(r=0;r<s[c].length;r++)l(s[c][r])}return 1===s.length?s=s[0]:e="Multi"+e,e={type:"Feature",geometry:{type:e,coordinates:s},properties:this.properties},"id"in this&&(e.id=this.id),e};var Tl=Cl;function Cl(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(El,this,e),this.length=this._features.length}function El(t,e,i){15===t?e.version=i.readVarint():1===t?e.name=i.readString():5===t?e.extent=i.readVarint():2===t?e._features.push(i.pos):3===t?e._keys.push(i.readString()):4===t&&e._values.push(function(t){for(var e=null,i=t.readVarint()+t.pos;t.pos<i;){var r=t.readVarint()>>3;e=1==r?t.readString():2==r?t.readFloat():3==r?t.readDouble():4==r?t.readVarint64():5==r?t.readVarint():6==r?t.readSVarint():7==r?t.readBoolean():null}return e}(i))}function Il(t,e,i){3!==t||(i=new Tl(i,i.readVarint()+i.pos)).length&&(e[i.name]=i)}Cl.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");return this._pbf.pos=this._features[t],t=this._pbf.readVarint()+this._pbf.pos,new bl(this._pbf,t,this.extent,this._keys,this._values)};var kl={VectorTile:function(t,e){this.layers=t.readFields(Il,{},e)},VectorTileFeature:bl,VectorTileLayer:Tl},Al=kl.VectorTileFeature.types,Pl=Math.pow(2,13);function Ml(t,e,i,r,n,o,a,s){t.emplaceBack(e,i,2*Math.floor(r*Pl)+a,n*Pl*2,o*Pl*2,Math.round(s))}function Ll(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new Hn,this.indexArray=new Eo,this.programConfigurations=new Xa(t.layers,t.zoom),this.segments=new fa,this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id})}Ll.prototype.populate=function(t,e,i){this.features=[],this.hasPattern=fl("fill-extrusion",this.layers,e);for(var r=0,n=t;r<n.length;r+=1){var o=(c=n[r]).feature,a=c.id,s=c.index,l=c.sourceLayerIndex,u=this.layers[0]._featureFilter.needGeometry,c=es(o,u);this.layers[0]._featureFilter.filter(new hn(this.zoom),c,i)&&(c={id:a,sourceLayerIndex:l,index:s,geometry:u?c.geometry:ts(o),properties:o.properties,type:o.type,patterns:{}},this.hasPattern?this.features.push(ml("fill-extrusion",this.layers,c,this.zoom,e)):this.addFeature(c,c.geometry,s,i,{}),e.featureIndex.insert(o,c.geometry,s,l,this.index,!0))}},Ll.prototype.addFeatures=function(t,e,i){for(var r=0,n=this.features;r<n.length;r+=1){var o=n[r],a=o.geometry;this.addFeature(o,a,o.index,e,i)}},Ll.prototype.update=function(t,e,i){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,i)},Ll.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Ll.prototype.uploadPending=function(){return!this.uploaded||this.programConfigurations.needsUpload},Ll.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,xl),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0},Ll.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy())},Ll.prototype.addFeature=function(t,e,i,r,n){for(var o,a=0,s=hl(e,500);a<s.length;a+=1){for(var l=s[a],u=0,c=0,p=l;c<p.length;c+=1)u+=p[c].length;for(var h=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray),d=0,f=l;d<f.length;d+=1){var m=f[d];if(0!==m.length&&!((o=m).every(function(t){return t.x<0})||o.every(function(t){return t.x>Ja})||o.every(function(t){return t.y<0})||o.every(function(t){return t.y>Ja})))for(var y=0,g=0;g<m.length;g++){var v,_,x,b=m[g];1<=g&&(x=v=m[g-1],(_=b).x===x.x&&(_.x<0||_.x>Ja)||_.y===x.y&&(_.y<0||_.y>Ja)||(h.vertexLength+4>fa.MAX_VERTEX_ARRAY_LENGTH&&(h=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray)),x=b.sub(v)._perp()._unit(),32768<y+(_=v.dist(b))&&(y=0),Ml(this.layoutVertexArray,b.x,b.y,x.x,x.y,0,0,y),Ml(this.layoutVertexArray,b.x,b.y,x.x,x.y,0,1,y),y+=_,Ml(this.layoutVertexArray,v.x,v.y,x.x,x.y,0,0,y),Ml(this.layoutVertexArray,v.x,v.y,x.x,x.y,0,1,y),x=h.vertexLength,this.indexArray.emplaceBack(x,x+2,x+1),this.indexArray.emplaceBack(x+1,x+2,x+3),h.vertexLength+=4,h.primitiveLength+=2))}}if(h.vertexLength+u>fa.MAX_VERTEX_ARRAY_LENGTH&&(h=this.segments.prepareSegment(u,this.layoutVertexArray,this.indexArray)),"Polygon"===Al[t.type]){for(var w=[],S=[],T=h.vertexLength,C=0,E=l;C<E.length;C+=1){var I=E[C];if(0!==I.length){I!==l[0]&&S.push(w.length/2);for(var k=0;k<I.length;k++){var A=I[k];Ml(this.layoutVertexArray,A.x,A.y,0,0,1,1,0),w.push(A.x),w.push(A.y)}}}for(var P=Gs(w,S),M=0;M<P.length;M+=3)this.indexArray.emplaceBack(T+P[M],T+P[M+2],T+P[M+1]);h.primitiveLength+=P.length/3,h.vertexLength+=u}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,i,n,r)},Wr("FillExtrusionBucket",Ll,{omit:["layers","features"]});var Ol,Rl={paint:new kn({"fill-extrusion-opacity":new Sn(Dt["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new Rc(Dt["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new Sn(Dt["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new Sn(Dt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new Cn(Dt["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new Rc(Dt["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new Rc(Dt["paint_fill-extrusion"]["fill-extrusion-base"]),"fill-extrusion-vertical-gradient":new Sn(Dt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])})};(Ol=Mn)&&(zl.__proto__=Ol),((zl.prototype=Object.create(Ol&&Ol.prototype)).constructor=zl).prototype.createBucket=function(t){return new Ll(t)},zl.prototype.queryRadius=function(){return hs(this.paint.get("fill-extrusion-translate"))},zl.prototype.is3D=function(){return!0},zl.prototype.queryIntersectsFeature=function(t,e,i,r,n,a,s,l){return a=ds(t,this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),a.angle,s),s=this.paint.get("fill-extrusion-height").evaluate(e,i),i=this.paint.get("fill-extrusion-base").evaluate(e,i),a=function(t,e,i){for(var r=[],n=0,a=t;n<a.length;n+=1){var s;ws(s=[(s=a[n]).x,s.y,0,1],s,e),r.push(new o(s[0]/s[3],s[1]/s[3]))}return r}(a,l),function(t,e,i){var r=1/0;os(i,e)&&(r=Nl(i,e[0]));for(var n=0;n<e.length;n++)for(var o=e[n],a=t[n],s=0;s<o.length-1;s++){var l=o[s],u=o[s+1],c=a[s];ns(i,l=[l,u,a[s+1],c,l])&&(r=Math.min(r,Nl(i,l)))}return r!==1/0&&r}((l=function(t,e,i,r){for(var n=[],a=[],s=r[8]*e,l=r[9]*e,u=r[10]*e,c=r[11]*e,p=r[8]*i,h=r[9]*i,d=r[10]*i,f=r[11]*i,m=0,y=t;m<y.length;m+=1){for(var g=[],v=[],_=0,x=y[m];_<x.length;_+=1){var b=(E=x[_]).x,w=E.y,S=r[0]*b+r[4]*w+r[12],T=r[1]*b+r[5]*w+r[13],C=(I=r[2]*b+r[6]*w+r[14])+u,E=(k=r[3]*b+r[7]*w+r[15])+c,I=(b=S+p,w=T+h,I+d),k=k+f;(T=new o((S+s)/E,(T+l)/E)).z=C/E,g.push(T),(w=new o(b/k,w/k)).z=I/k,v.push(w)}n.push(g),a.push(v)}return[n,a]}(r,i,s,l))[0],l[1],a)},Ai=zl;function zl(t){Ol.call(this,t,Rl)}function Dl(t,e){return t.x*e.x+t.y*e.y}function Nl(t,e){if(1===t.length){for(var i,r=0,n=e[r++];!i||n.equals(i);)if(!(i=e[r++]))return 1/0;for(;r<e.length;r++){var o=e[r],a=t[0],s=i.sub(n),l=o.sub(n),u=a.sub(n),c=Dl(s,s),p=Dl(s,l);a=((a=Dl(l,l))*(s=Dl(u,s))-p*(u=Dl(u,l)))/(l=c*a-p*p),l=(c*u-p*s)/l,l=n.z*(1-a-l)+i.z*a+o.z*l;if(isFinite(l))return l}return 1/0}for(var h=1/0,d=0,f=e;d<f.length;d+=1){var m=f[d];h=Math.min(h,m.z)}return h}function Bl(t){var e=this;this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.lineClipsArray=[],this.gradients={},this.layers.forEach(function(t){e.gradients[t.id]={}}),this.layoutVertexArray=new Wn,this.layoutVertexArray2=new Yn,this.indexArray=new Eo,this.programConfigurations=new Xa(t.layers,t.zoom),this.segments=new fa,this.maxLineLength=0,this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id})}var Fl=zn([{name:"a_pos_normal",components:2,type:"Int16"},{name:"a_data",components:4,type:"Uint8"}],4).members,Ul=zn([{name:"a_uv_x",components:1,type:"Float32"},{name:"a_split_index",components:1,type:"Float32"}]).members,jl=kl.VectorTileFeature.types,Vl=Math.cos(Math.PI/180*37.5),ql=Math.pow(2,14)/.5;Bl.prototype.populate=function(t,e,i){this.hasPattern=fl("line",this.layers,e);for(var r=this.layers[0].layout.get("line-sort-key"),n=[],o=0,a=t;o<a.length;o+=1){var s=a[o],l=s.feature,u=s.id,c=s.index,p=s.sourceLayerIndex,h=this.layers[0]._featureFilter.needGeometry,d=es(l,h);this.layers[0]._featureFilter.filter(new hn(this.zoom),d,i)&&(s=r?r.evaluate(d,{},i):void 0,s={id:u,properties:l.properties,type:l.type,sourceLayerIndex:p,index:c,geometry:h?d.geometry:ts(l),patterns:{},sortKey:s},n.push(s))}r&&n.sort(function(t,e){return t.sortKey-e.sortKey});for(var f=0,m=n;f<m.length;f+=1){var y,g=m[f],v=g.geometry,_=g.index,x=g.sourceLayerIndex;this.hasPattern?(y=ml("line",this.layers,g,this.zoom,e),this.patternFeatures.push(y)):this.addFeature(g,v,_,i,{}),g=t[_].feature,e.featureIndex.insert(g,v,_,x,this.index)}},Bl.prototype.update=function(t,e,i){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,i)},Bl.prototype.addFeatures=function(t,e,i){for(var r=0,n=this.patternFeatures;r<n.length;r+=1){var o=n[r];this.addFeature(o,o.geometry,o.index,e,i)}},Bl.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Bl.prototype.uploadPending=function(){return!this.uploaded||this.programConfigurations.needsUpload},Bl.prototype.upload=function(t){this.uploaded||(0!==this.layoutVertexArray2.length&&(this.layoutVertexBuffer2=t.createVertexBuffer(this.layoutVertexArray2,Ul)),this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Fl),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0},Bl.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy())},Bl.prototype.lineFeatureClips=function(t){if(t.properties&&t.properties.hasOwnProperty("mapbox_clip_start")&&t.properties.hasOwnProperty("mapbox_clip_end"))return{start:+t.properties.mapbox_clip_start,end:+t.properties.mapbox_clip_end}},Bl.prototype.addFeature=function(t,e,i,r,n){var o=this.layers[0].layout,a=o.get("line-join").evaluate(t,{}),s=o.get("line-cap"),l=o.get("line-miter-limit"),u=o.get("line-round-limit");this.lineClips=this.lineFeatureClips(t);for(var c=0,p=e;c<p.length;c+=1){var h=p[c];this.addLine(h,t,a,s,l,u)}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,i,n,r)},Bl.prototype.addLine=function(t,e,i,r,n,o){if(this.distance=0,this.scaledDistance=0,this.totalDistance=0,this.lineClips){this.lineClipsArray.push(this.lineClips);for(var a=0;a<t.length-1;a++)this.totalDistance+=t[a].dist(t[a+1]);this.updateScaledDistance(),this.maxLineLength=Math.max(this.maxLineLength,this.totalDistance)}for(var s="Polygon"===jl[e.type],l=t.length;2<=l&&t[l-1].equals(t[l-2]);)l--;for(var u=0;u<l-1&&t[u].equals(t[u+1]);)u++;if(!(l<(s?3:2))){"bevel"===i&&(n=1.05);var c=this.overscaling<=16?15*Ja/(512*this.overscaling):0,p=this.segments.prepareSegment(10*l,this.layoutVertexArray,this.indexArray),h=void 0,d=void 0,f=void 0,m=void 0;this.e1=this.e2=-1,s&&(g=t[l-2],m=t[u].sub(g)._unit()._perp());for(var y=u;y<l;y++)if(!(d=y===l-1?s?t[u+1]:void 0:t[y+1])||!t[y].equals(d)){m&&(f=m),g&&(h=g);var g=t[y],v=(m=d?d.sub(g)._unit()._perp():f,(f=f||m).add(m));0===v.x&&0===v.y||v._unit();var _=f.x*m.x+f.y*m.y,x=0!=(w=v.x*m.x+v.y*m.y)?1/w:1/0,b=2*Math.sqrt(2-2*w),w=w<Vl&&h&&d,S=0<f.x*m.y-f.y*m.x;w&&u<y&&2*c<(T=g.dist(h))&&(C=g.sub(g.sub(h)._mult(c/T)._round()),this.updateDistance(h,C),this.addCurrentVertex(C,f,0,0,p),h=C);var T=h&&d,C=T?i:s?"butt":r;if(T&&"round"===C&&(x<o?C="miter":x<=2&&(C="fakeround")),"bevel"===(C="miter"===C&&n<x?"bevel":C)&&(2<x&&(C="flipbevel"),x<n&&(C="miter")),h&&this.updateDistance(h,g),"miter"===C)v._mult(x),this.addCurrentVertex(g,v,0,0,p);else if("flipbevel"===C)100<x?v=m.mult(-1):(E=x*f.add(m).mag()/f.sub(m).mag(),v._perp()._mult(E*(S?-1:1))),this.addCurrentVertex(g,v,0,0,p),this.addCurrentVertex(g,v.mult(-1),0,0,p);else if("bevel"===C||"fakeround"===C){var E=-Math.sqrt(x*x-1);x=S?E:0,E=S?0:E;if(h&&this.addCurrentVertex(g,f,x,E,p),"fakeround"===C)for(var I=Math.round(180*b/Math.PI/20),k=1;k<I;k++){var A,P=k/I;.5!==P&&(P+=P*(A=P-.5)*(P-1)*((1.0904+_*(_*(3.55645-1.43519*_)-3.2452))*A*A+(.848013+_*(.215638*_-1.06021)))),P=m.sub(f)._mult(P)._add(f)._unit()._mult(S?-1:1),this.addHalfVertex(g,P.x,P.y,!1,S,0,p)}d&&this.addCurrentVertex(g,m,-x,-E,p)}else"butt"===C?this.addCurrentVertex(g,v,0,0,p):"square"===C?this.addCurrentVertex(g,v,v=h?1:-1,v,p):"round"===C&&(h&&(this.addCurrentVertex(g,f,0,0,p),this.addCurrentVertex(g,f,1,1,p,!0)),d&&(this.addCurrentVertex(g,m,-1,-1,p,!0),this.addCurrentVertex(g,m,0,0,p)));w&&y<l-1&&2*c<(w=g.dist(d))&&(w=g.add(d.sub(g)._mult(c/w)._round()),this.updateDistance(g,w),this.addCurrentVertex(w,m,0,0,p),g=w)}}},Bl.prototype.addCurrentVertex=function(t,e,i,r,n,o){var a=e.x+e.y*i,s=e.y-e.x*i,l=-e.x+e.y*r,u=-e.y-e.x*r;this.addHalfVertex(t,a,s,o=void 0!==o&&o,!1,i,n),this.addHalfVertex(t,l,u,o,!0,-r,n),this.distance>ql/2&&0===this.totalDistance&&(this.distance=0,this.addCurrentVertex(t,e,i,r,n,o))},Bl.prototype.addHalfVertex=function(t,e,i,r,n,o,a){var s=t.x,l=t.y;t=.5*(this.lineClips?this.scaledDistance*(ql-1):this.scaledDistance);this.layoutVertexArray.emplaceBack((s<<1)+(r?1:0),(l<<1)+(n?1:0),Math.round(63*e)+128,Math.round(63*i)+128,1+(0===o?0:o<0?-1:1)|(63&t)<<2,t>>6),this.lineClips&&(t=this.scaledDistance-this.lineClips.start,u=this.lineClips.end-this.lineClips.start,this.layoutVertexArray2.emplaceBack(t/u,this.lineClipsArray.length));var u=a.vertexLength++;0<=this.e1&&0<=this.e2&&(this.indexArray.emplaceBack(this.e1,this.e2,u),a.primitiveLength++),n?this.e2=u:this.e1=u},Bl.prototype.updateScaledDistance=function(){this.scaledDistance=this.lineClips?this.lineClips.start+(this.lineClips.end-this.lineClips.start)*this.distance/this.totalDistance:this.distance},Bl.prototype.updateDistance=function(t,e){this.distance+=t.dist(e),this.updateScaledDistance()},Wr("LineBucket",Bl,{omit:["layers","patternFeatures"]});fs=new kn({"line-cap":new Sn(Dt.layout_line["line-cap"]),"line-join":new Rc(Dt.layout_line["line-join"]),"line-miter-limit":new Sn(Dt.layout_line["line-miter-limit"]),"line-round-limit":new Sn(Dt.layout_line["line-round-limit"]),"line-sort-key":new Rc(Dt.layout_line["line-sort-key"])});var Hl,Gl={paint:new kn({"line-opacity":new Rc(Dt.paint_line["line-opacity"]),"line-color":new Rc(Dt.paint_line["line-color"]),"line-translate":new Sn(Dt.paint_line["line-translate"]),"line-translate-anchor":new Sn(Dt.paint_line["line-translate-anchor"]),"line-width":new Rc(Dt.paint_line["line-width"]),"line-gap-width":new Rc(Dt.paint_line["line-gap-width"]),"line-offset":new Rc(Dt.paint_line["line-offset"]),"line-blur":new Rc(Dt.paint_line["line-blur"]),"line-dasharray":new jc(Dt.paint_line["line-dasharray"]),"line-pattern":new Cn(Dt.paint_line["line-pattern"]),"line-gradient":new In(Dt.paint_line["line-gradient"])}),layout:fs};function Zl(){Hl.apply(this,arguments)}var Wl=new((Hl=Rc)&&(Zl.__proto__=Hl),((Zl.prototype=Object.create(Hl&&Hl.prototype)).constructor=Zl).prototype.possiblyEvaluate=function(t,e){return e=new hn(Math.floor(e.zoom),{now:e.now,fadeDuration:e.fadeDuration,zoomHistory:e.zoomHistory,transition:e.transition}),Hl.prototype.possiblyEvaluate.call(this,t,e)},Zl.prototype.evaluate=function(t,e,i,r){return e=d({},e,{zoom:Math.floor(e.zoom)}),Hl.prototype.evaluate.call(this,t,e,i,r)},Zl)(Gl.paint.properties["line-width"].specification);Wl.useIntegerZoom=!0;var Kl;(Kl=Mn)&&(Xl.__proto__=Kl),((Xl.prototype=Object.create(Kl&&Kl.prototype)).constructor=Xl).prototype._handleSpecialPaintPropertyUpdate=function(t){"line-gradient"===t&&(t=this._transitionablePaint._values["line-gradient"].value.expression,this.stepInterpolant=t._styleExpression.expression instanceof Ye,this.gradientVersion=(this.gradientVersion+1)%l)},Xl.prototype.gradientExpression=function(){return this._transitionablePaint._values["line-gradient"].value.expression},Xl.prototype.recalculate=function(t,e){Kl.prototype.recalculate.call(this,t,e),this.paint._values["line-floorwidth"]=Wl.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,t)},Xl.prototype.createBucket=function(t){return new Bl(t)},Xl.prototype.queryRadius=function(t){t=Yl(ps("line-width",this,e=t),ps("line-gap-width",this,e));var e=ps("line-offset",this,e);return t/2+Math.abs(e)+hs(this.paint.get("line-translate"))},Xl.prototype.queryIntersectsFeature=function(t,e,i,r,n,a,s){return t=ds(t,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),a.angle,s),a=s/2*Yl(this.paint.get("line-width").evaluate(e,i),this.paint.get("line-gap-width").evaluate(e,i)),function(t,e,i){for(var r=0;r<e.length;r++){var n=e[r];if(3<=t.length)for(var o=0;o<n.length;o++)if(cs(t,n[o]))return!0;if(function(t,e,i){if(1<t.length){if(as(t,e))return!0;for(var r=0;r<e.length;r++)if(ss(e[r],t,i))return!0}for(var n=0;n<t.length;n++)if(ss(t[n],e,i))return!0;return!1}(t,n,i))return!0}return!1}(t,r=(i=this.paint.get("line-offset").evaluate(e,i))?function(t,e){for(var i=[],r=new o(0,0),n=0;n<t.length;n++){for(var a=t[n],s=[],l=0;l<a.length;l++){var u=a[l-1],c=a[l],p=a[l+1];u=0===l?r:c.sub(u)._unit()._perp(),p=l===a.length-1?r:p.sub(c)._unit()._perp(),p=(u=u._add(p)._unit()).x*p.x+u.y*p.y;u._mult(1/p),s.push(u._mult(e)._add(c))}i.push(s)}return i}(r,i*s):r,a)},Xl.prototype.isTileClipped=function(){return!0},va=Xl;function Xl(t){Kl.call(this,t,Gl),this.gradientVersion=0}function Yl(t,e){return 0<e?e+2*t:t}var Jl=zn([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint16"},{name:"a_pixeloffset",components:4,type:"Int16"}],4),Ql=zn([{name:"a_projected_pos",components:3,type:"Float32"}],4),$l=(zn([{name:"a_fade_opacity",components:1,type:"Uint32"}],4),zn([{name:"a_placed",components:2,type:"Uint8"},{name:"a_shift",components:2,type:"Float32"}])),tu=(zn([{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int16",name:"x1"},{type:"Int16",name:"y1"},{type:"Int16",name:"x2"},{type:"Int16",name:"y2"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"}]),zn([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4));et=zn([{name:"a_pos",components:2,type:"Float32"},{name:"a_radius",components:1,type:"Float32"},{name:"a_flags",components:2,type:"Int16"}],4);function eu(t,e,i){return t.sections.forEach(function(t){var r;t.text=(r=t.text,t=i,"uppercase"===(t=e.layout.get("text-transform").evaluate(t,{}))?r=r.toLocaleUpperCase():"lowercase"===t&&(r=r.toLocaleLowerCase()),r=fn.applyArabicShaping?fn.applyArabicShaping(r):r)}),t}zn([{name:"triangle",components:3,type:"Uint16"}]),zn([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"placedOrientation"},{type:"Uint8",name:"hidden"},{type:"Uint32",name:"crossTileID"},{type:"Int16",name:"associatedIconIndex"}]),zn([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Int16",name:"rightJustifiedTextSymbolIndex"},{type:"Int16",name:"centerJustifiedTextSymbolIndex"},{type:"Int16",name:"leftJustifiedTextSymbolIndex"},{type:"Int16",name:"verticalPlacedTextSymbolIndex"},{type:"Int16",name:"placedIconSymbolIndex"},{type:"Int16",name:"verticalPlacedIconSymbolIndex"},{type:"Uint16",name:"key"},{type:"Uint16",name:"textBoxStartIndex"},{type:"Uint16",name:"textBoxEndIndex"},{type:"Uint16",name:"verticalTextBoxStartIndex"},{type:"Uint16",name:"verticalTextBoxEndIndex"},{type:"Uint16",name:"iconBoxStartIndex"},{type:"Uint16",name:"iconBoxEndIndex"},{type:"Uint16",name:"verticalIconBoxStartIndex"},{type:"Uint16",name:"verticalIconBoxEndIndex"},{type:"Uint16",name:"featureIndex"},{type:"Uint16",name:"numHorizontalGlyphVertices"},{type:"Uint16",name:"numVerticalGlyphVertices"},{type:"Uint16",name:"numIconVertices"},{type:"Uint16",name:"numVerticalIconVertices"},{type:"Uint16",name:"useRuntimeCollisionCircles"},{type:"Uint32",name:"crossTileID"},{type:"Float32",name:"textBoxScale"},{type:"Float32",components:2,name:"textOffset"},{type:"Float32",name:"collisionCircleDiameter"}]),zn([{type:"Float32",name:"offsetX"}]),zn([{type:"Int16",name:"x"},{type:"Int16",name:"y"},{type:"Int16",name:"tileUnitDistanceFromAnchor"}]);var iu={"!":"ï¸•","#":"ï¼ƒ",$:"ï¼„","%":"ï¼…","&":"ï¼†","(":"ï¸µ",")":"ï¸¶","*":"ï¼Š","+":"ï¼‹",",":"ï¸","-":"ï¸²",".":"ãƒ»","/":"ï¼",":":"ï¸“",";":"ï¸”","<":"ï¸¿","=":"ï¼",">":"ï¹€","?":"ï¸–","@":"ï¼ ","[":"ï¹‡","\\":"ï¼¼","]":"ï¹ˆ","^":"ï¼¾",_:"ï¸³","`":"ï½€","{":"ï¸·","|":"â€•","}":"ï¸¸","~":"ï½ž","Â¢":"ï¿ ","Â£":"ï¿¡","Â¥":"ï¿¥","Â¦":"ï¿¤","Â¬":"ï¿¢","Â¯":"ï¿£","â€“":"ï¸²","â€”":"ï¸±","â€˜":"ï¹ƒ","â€™":"ï¹„","â€œ":"ï¹","â€":"ï¹‚","â€¦":"ï¸™","â€§":"ãƒ»","â‚©":"ï¿¦","ã€":"ï¸‘","ã€‚":"ï¸’","ã€ˆ":"ï¸¿","ã€‰":"ï¹€","ã€Š":"ï¸½","ã€‹":"ï¸¾","ã€Œ":"ï¹","ã€":"ï¹‚","ã€Ž":"ï¹ƒ","ã€":"ï¹„","ã€":"ï¸»","ã€‘":"ï¸¼","ã€”":"ï¸¹","ã€•":"ï¸º","ã€–":"ï¸—","ã€—":"ï¸˜","ï¼":"ï¸•","ï¼ˆ":"ï¸µ","ï¼‰":"ï¸¶","ï¼Œ":"ï¸","ï¼":"ï¸²","ï¼Ž":"ãƒ»","ï¼š":"ï¸“","ï¼›":"ï¸”","ï¼œ":"ï¸¿","ï¼ž":"ï¹€","ï¼Ÿ":"ï¸–","ï¼»":"ï¹‡","ï¼½":"ï¹ˆ","ï¼¿":"ï¸³","ï½›":"ï¸·","ï½œ":"â€•","ï½":"ï¸¸","ï½Ÿ":"ï¸µ","ï½ ":"ï¸¶","ï½¡":"ï¸’","ï½¢":"ï¹","ï½£":"ï¹‚"},ru=24,nu=function(t,e,i,r,n){var o,a,s=8*n-r-1,l=(1<<s)-1,u=l>>1,c=-7,p=i?n-1:0,h=i?-1:1;i=t[e+p];for(p+=h,o=i&(1<<-c)-1,i>>=-c,c+=s;0<c;o=256*o+t[e+p],p+=h,c-=8);for(a=o&(1<<-c)-1,o>>=-c,c+=r;0<c;a=256*a+t[e+p],p+=h,c-=8);if(0===o)o=1-u;else{if(o===l)return a?NaN:1/0*(i?-1:1);a+=Math.pow(2,r),o-=u}return(i?-1:1)*a*Math.pow(2,o-r)},ou=function(t,e,i,r,n,o){var a,s,l=8*o-n-1,u=(1<<l)-1,c=u>>1,p=23===n?Math.pow(2,-24)-Math.pow(2,-77):0,h=r?0:o-1,d=r?1:-1;o=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,a=u):(a=Math.floor(Math.log(e)/Math.LN2),e*(r=Math.pow(2,-a))<1&&(a--,r*=2),2<=(e+=1<=a+c?p/r:p*Math.pow(2,1-c))*r&&(a++,r/=2),u<=a+c?(s=0,a=u):1<=a+c?(s=(e*r-1)*Math.pow(2,n),a+=c):(s=e*Math.pow(2,c-1)*Math.pow(2,n),a=0));8<=n;t[i+h]=255&s,h+=d,s/=256,n-=8);for(a=a<<n|s,l+=n;0<l;t[i+h]=255&a,h+=d,a/=256,l-=8);t[i+h-d]|=128*o},au=su;function su(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length}su.Varint=0,su.Fixed64=1,su.Bytes=2,su.Fixed32=5;var lu=4294967296,uu=1/lu,cu="undefined"==typeof TextDecoder?null:new TextDecoder("utf8");function pu(t){return t.type===su.Bytes?t.readVarint()+t.pos:t.pos+1}function hu(t,e,i){return i?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function du(t,e,i){var r=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));i.realloc(r);for(var n=i.pos-1;t<=n;n--)i.buf[n+r]=i.buf[n]}function fu(t,e){for(var i=0;i<t.length;i++)e.writeVarint(t[i])}function mu(t,e){for(var i=0;i<t.length;i++)e.writeSVarint(t[i])}function yu(t,e){for(var i=0;i<t.length;i++)e.writeFloat(t[i])}function gu(t,e){for(var i=0;i<t.length;i++)e.writeDouble(t[i])}function vu(t,e){for(var i=0;i<t.length;i++)e.writeBoolean(t[i])}function _u(t,e){for(var i=0;i<t.length;i++)e.writeFixed32(t[i])}function xu(t,e){for(var i=0;i<t.length;i++)e.writeSFixed32(t[i])}function bu(t,e){for(var i=0;i<t.length;i++)e.writeFixed64(t[i])}function wu(t,e){for(var i=0;i<t.length;i++)e.writeSFixed64(t[i])}function Su(t,e){return(t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function Tu(t,e,i){t[i]=e,t[i+1]=e>>>8,t[i+2]=e>>>16,t[i+3]=e>>>24}function Cu(t,e){return(t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}su.prototype={destroy:function(){this.buf=null},readFields:function(t,e,i){for(i=i||this.length;this.pos<i;){var r=this.readVarint(),n=r>>3,o=this.pos;this.type=7&r,t(n,e,this),this.pos===o&&this.skip(r)}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=Su(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=Cu(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=Su(this.buf,this.pos)+Su(this.buf,this.pos+4)*lu;return this.pos+=8,t},readSFixed64:function(){var t=Su(this.buf,this.pos)+Cu(this.buf,this.pos+4)*lu;return this.pos+=8,t},readFloat:function(){var t=nu(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=nu(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e=this.buf,i=e[this.pos++],r=127&i;return i<128?r:(r|=(127&(i=e[this.pos++]))<<7,i<128?r:(r|=(127&(i=e[this.pos++]))<<14,i<128?r:(r|=(127&(i=e[this.pos++]))<<21,i<128?r:function(t,e,i){var r,n,o=i.buf;if(r=(112&(n=o[i.pos++]))>>4,n<128)return hu(t,r,e);if(r|=(127&(n=o[i.pos++]))<<3,n<128)return hu(t,r,e);if(r|=(127&(n=o[i.pos++]))<<10,n<128)return hu(t,r,e);if(r|=(127&(n=o[i.pos++]))<<17,n<128)return hu(t,r,e);if(r|=(127&(n=o[i.pos++]))<<24,n<128)return hu(t,r,e);if(r|=(1&(n=o[i.pos++]))<<31,n<128)return hu(t,r,e);throw new Error("Expected varint not more than 10 bytes")}(r|=(15&e[this.pos])<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t,e=this.readVarint()+this.pos,i=this.pos;return 12<=(this.pos=e)-i&&cu?(t=this.buf,cu.decode(t.subarray(i,e))):function(t,e,i){for(var r,n,o,a="",s=e;s<i;){var l=t[s],u=null,c=239<l?4:223<l?3:191<l?2:1;if(i<s+c)break;1===c?l<128&&(u=l):2===c?128==(192&(r=t[s+1]))&&(u=(31&l)<<6|63&r)<=127&&(u=null):3===c?(r=t[s+1],n=t[s+2],128==(192&r)&&128==(192&n)&&((u=(15&l)<<12|(63&r)<<6|63&n)<=2047||55296<=u&&u<=57343)&&(u=null)):4===c&&(r=t[s+1],n=t[s+2],o=t[s+3],128==(192&r)&&128==(192&n)&&128==(192&o)&&((u=(15&l)<<18|(63&r)<<12|(63&n)<<6|63&o)<=65535||1114112<=u)&&(u=null)),null===u?(u=65533,c=1):65535<u&&(u-=65536,a+=String.fromCharCode(u>>>10&1023|55296),u=56320|1023&u),a+=String.fromCharCode(u),s+=c}return a}(this.buf,i,e)},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==su.Bytes)return t.push(this.readVarint(e));var i=pu(this);for(t=t||[];this.pos<i;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==su.Bytes)return t.push(this.readSVarint());var e=pu(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==su.Bytes)return t.push(this.readBoolean());var e=pu(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==su.Bytes)return t.push(this.readFloat());var e=pu(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==su.Bytes)return t.push(this.readDouble());var e=pu(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==su.Bytes)return t.push(this.readFixed32());var e=pu(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==su.Bytes)return t.push(this.readSFixed32());var e=pu(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==su.Bytes)return t.push(this.readFixed64());var e=pu(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==su.Bytes)return t.push(this.readSFixed64());var e=pu(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){if((t&=7)===su.Varint)for(;127<this.buf[this.pos++];);else if(t===su.Bytes)this.pos=this.readVarint()+this.pos;else if(t===su.Fixed32)this.pos+=4;else{if(t!==su.Fixed64)throw new Error("Unimplemented type: "+t);this.pos+=8}},writeTag:function(t,e){this.writeVarint(t<<3|e)},realloc:function(t){for(var e,i=this.length||16;i<this.pos+t;)i*=2;i!==this.length&&((e=new Uint8Array(i)).set(this.buf),this.buf=e,this.length=i)},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),Tu(this.buf,t,this.pos),this.pos+=4},writeSFixed32:function(t){this.realloc(4),Tu(this.buf,t,this.pos),this.pos+=4},writeFixed64:function(t){this.realloc(8),Tu(this.buf,-1&t,this.pos),Tu(this.buf,Math.floor(t*uu),this.pos+4),this.pos+=8},writeSFixed64:function(t){this.realloc(8),Tu(this.buf,-1&t,this.pos),Tu(this.buf,Math.floor(t*uu),this.pos+4),this.pos+=8},writeVarint:function(t){268435455<(t=+t||0)||t<0?function(t,e){var i,r;if(0<=t?(i=t%4294967296|0,r=t/4294967296|0):(r=~(-t/4294967296),4294967295^(i=~(-t%4294967296))?i=i+1|0:r=r+1|(i=0)),0x10000000000000000<=t||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e){e.buf[e.pos++]=127&t|128,t>>>=7,e.buf[e.pos++]=127&t|128,t>>>=7,e.buf[e.pos++]=127&t|128,t>>>=7,e.buf[e.pos++]=127&t|128,t>>>=7,e.buf[e.pos]=127&t}(i,e),function(t,e){var i=(7&t)<<4;e.buf[e.pos++]|=i|((t>>>=3)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t)))))}(r,e)}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(127<t?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(127<t?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(127<t?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))))},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t)},writeBoolean:function(t){this.writeVarint(Boolean(t))},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,i){for(var r,n,o=0;o<e.length;o++){if(55295<(r=e.charCodeAt(o))&&r<57344){if(!n){56319<r||o+1===e.length?(t[i++]=239,t[i++]=191,t[i++]=189):n=r;continue}if(r<56320){t[i++]=239,t[i++]=191,t[i++]=189,n=r;continue}r=n-55296<<10|r-56320|65536,n=null}else n&&(t[i++]=239,t[i++]=191,t[i++]=189,n=null);r<128?t[i++]=r:(r<2048?t[i++]=r>>6|192:(r<65536?t[i++]=r>>12|224:(t[i++]=r>>18|240,t[i++]=r>>12&63|128),t[i++]=r>>6&63|128),t[i++]=63&r|128)}return i}(this.buf,t,this.pos),128<=(t=this.pos-e)&&du(e,t,this),this.pos=e-1,this.writeVarint(t),this.pos+=t},writeFloat:function(t){this.realloc(4),ou(this.buf,t,this.pos,!0,23,4),this.pos+=4},writeDouble:function(t){this.realloc(8),ou(this.buf,t,this.pos,!0,52,8),this.pos+=8},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var i=0;i<e;i++)this.buf[this.pos++]=t[i]},writeRawMessage:function(t,e){this.pos++;var i=this.pos;t(e,this),128<=(e=this.pos-i)&&du(i,e,this),this.pos=i-1,this.writeVarint(e),this.pos+=e},writeMessage:function(t,e,i){this.writeTag(t,su.Bytes),this.writeRawMessage(e,i)},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,fu,e)},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,mu,e)},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,vu,e)},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,yu,e)},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,gu,e)},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,_u,e)},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,xu,e)},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,bu,e)},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,wu,e)},writeBytesField:function(t,e){this.writeTag(t,su.Bytes),this.writeBytes(e)},writeFixed32Field:function(t,e){this.writeTag(t,su.Fixed32),this.writeFixed32(e)},writeSFixed32Field:function(t,e){this.writeTag(t,su.Fixed32),this.writeSFixed32(e)},writeFixed64Field:function(t,e){this.writeTag(t,su.Fixed64),this.writeFixed64(e)},writeSFixed64Field:function(t,e){this.writeTag(t,su.Fixed64),this.writeSFixed64(e)},writeVarintField:function(t,e){this.writeTag(t,su.Varint),this.writeVarint(e)},writeSVarintField:function(t,e){this.writeTag(t,su.Varint),this.writeSVarint(e)},writeStringField:function(t,e){this.writeTag(t,su.Bytes),this.writeString(e)},writeFloatField:function(t,e){this.writeTag(t,su.Fixed32),this.writeFloat(e)},writeDoubleField:function(t,e){this.writeTag(t,su.Fixed64),this.writeDouble(e)},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e))}};var Eu=3;function Iu(t,e,i){1===t&&i.readMessage(ku,e)}function ku(t,e,i){var r,n,o,a,s;3===t&&(r=(s=i.readMessage(Au,{})).id,n=s.bitmap,o=s.width,a=s.height,t=s.left,i=s.top,s=s.advance,e.push({id:r,bitmap:new Rs({width:o+2*Eu,height:a+2*Eu},n),metrics:{width:o,height:a,left:t,top:i,advance:s}}))}function Au(t,e,i){1===t?e.id=i.readVarint():2===t?e.bitmap=i.readBytes():3===t?e.width=i.readVarint():4===t?e.height=i.readVarint():5===t?e.left=i.readSVarint():6===t?e.top=i.readSVarint():7===t&&(e.advance=i.readVarint())}var Pu=Eu;function Mu(t){for(var e=0,i=0,r=0,n=t;r<n.length;r+=1){var o=n[r];e+=o.w*o.h,i=Math.max(i,o.w)}t.sort(function(t,e){return e.h-t.h});for(var a=[{x:0,y:0,w:Math.max(Math.ceil(Math.sqrt(e/.95)),i),h:1/0}],s=0,l=0,u=0,c=t;u<c.length;u+=1)for(var p=c[u],h=a.length-1;0<=h;h--){var d,f=a[h];if(!(p.w>f.w||p.h>f.h)){p.x=f.x,p.y=f.y,l=Math.max(l,p.y+p.h),s=Math.max(s,p.x+p.w),p.w===f.w&&p.h===f.h?(d=a.pop(),h<a.length&&(a[h]=d)):p.h===f.h?(f.x+=p.w,f.w-=p.w):(p.w===f.w||a.push({x:f.x+p.w,y:f.y,w:f.w-p.w,h:p.h}),f.y+=p.h,f.h-=p.h);break}}return{w:s,h:l,fill:e/(s*l)||0}}function Lu(t,e){var i=e.pixelRatio,r=e.version,n=e.stretchX,o=e.stretchY;e=e.content;this.paddedRect=t,this.pixelRatio=i,this.stretchX=n,this.stretchY=o,this.content=e,this.version=r}var Ou=1;(Cn={tl:{configurable:!0},br:{configurable:!0},tlbr:{configurable:!0},displaySize:{configurable:!0}}).tl.get=function(){return[this.paddedRect.x+Ou,this.paddedRect.y+Ou]},Cn.br.get=function(){return[this.paddedRect.x+this.paddedRect.w-Ou,this.paddedRect.y+this.paddedRect.h-Ou]},Cn.tlbr.get=function(){return this.tl.concat(this.br)},Cn.displaySize.get=function(){return[(this.paddedRect.w-2*Ou)/this.pixelRatio,(this.paddedRect.h-2*Ou)/this.pixelRatio]},Object.defineProperties(Lu.prototype,Cn),(In=function(t,e){var i={},r={};this.haveRenderCallbacks=[];var n=[];this.addImages(t,i,n),this.addImages(e,r,n);var o,a,s,l=new zs({width:(n=(s=Mu(n)).w)||1,height:(s=s.h)||1});for(o in t){var u=t[o],c=i[o].paddedRect;zs.copy(u.data,l,{x:0,y:0},{x:c.x+Ou,y:c.y+Ou},u.data)}for(a in e){var p=e[a],h=(m=r[a].paddedRect).x+Ou,d=m.y+Ou,f=p.data.width,m=p.data.height;zs.copy(p.data,l,{x:0,y:0},{x:h,y:d},p.data),zs.copy(p.data,l,{x:0,y:m-1},{x:h,y:d-1},{width:f,height:1}),zs.copy(p.data,l,{x:0,y:0},{x:h,y:d+m},{width:f,height:1}),zs.copy(p.data,l,{x:f-1,y:0},{x:h-1,y:d},{width:1,height:m}),zs.copy(p.data,l,{x:0,y:0},{x:h+f,y:d},{width:1,height:m})}this.image=l,this.iconPositions=i,this.patternPositions=r}).prototype.addImages=function(t,e,i){for(var r in t){var n=t[r],o={x:0,y:0,w:n.data.width+2*Ou,h:n.data.height+2*Ou};i.push(o),e[r]=new Lu(o,n),n.hasRenderCallback&&this.haveRenderCallbacks.push(r)}},In.prototype.patchUpdatedImages=function(t,e){for(var i in t.dispatchRenderCallbacks(this.haveRenderCallbacks),t.updatedImages)this.patchUpdatedImage(this.iconPositions[i],t.getImage(i),e),this.patchUpdatedImage(this.patternPositions[i],t.getImage(i),e)},In.prototype.patchUpdatedImage=function(t,e,i){var r;t&&e&&t.version!==e.version&&(t.version=e.version,t=(r=t.tl)[0],r=r[1],i.update(e.data,void 0,{x:t,y:r}))},Wr("ImagePosition",Lu),Wr("ImageAtlas",In);var Ru={horizontal:1,vertical:2,horizontalOnly:3},zu=-17;function Du(){this.scale=1,this.fontStack="",this.imageName=null}Du.forText=function(t,e){var i=new Du;return i.scale=t||1,i.fontStack=e,i},Du.forImage=function(t){var e=new Du;return e.imageName=t,e};var Nu=function(){this.text="",this.sectionIndex=[],this.sections=[],this.imageSectionID=null};function Bu(t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m){var y=Nu.fromFeature(t,n);if(p===Ru.vertical&&y.verticalizePunctuation(),t=fn.processBidirectionalText,n=fn.processStyledBidirectionalText,t&&1===y.sections.length)for(var g=[],v=0,_=t(y.toString(),Hu(y,u,o,e,r,d,f));v<_.length;v+=1){var x=_[v],b=new Nu;b.text=x,b.sections=y.sections;for(var w=0;w<x.length;w++)b.sectionIndex.push(0);g.push(b)}else if(n){g=[];for(var S=0,T=n(y.text,y.sectionIndex,Hu(y,u,o,e,r,d,f));S<T.length;S+=1){var C=T[S],E=new Nu;E.text=C[0],E.sectionIndex=C[1],E.sections=y.sections,g.push(E)}}else g=function(t,e){for(var i=[],r=t.text,n=0,o=0,a=e;o<a.length;o+=1){var s=a[o];i.push(t.substring(n,s)),n=s}return n<r.length&&i.push(t.substring(n,r.length)),i}(y,Hu(y,u,o,e,r,d,f));return function(t,e,i,r,n,o,a,s,l,u,c,p){for(var h=0,d=zu,f=0,m=0,y="right"===s?1:"left"===s?0:.5,g=0,v=0,_=n;v<_.length;v+=1){var x=_[v];x.trim();var b=x.getMaxScale(),w=(b-1)*ru,S={positionedGlyphs:[],lineOffset:0},T=(t.positionedLines[g]=S).positionedGlyphs,C=0;if(x.length()){for(var E=0;E<x.length();E++){var I=x.getSection(E),k=x.getSectionIndex(E),A=x.getCharCode(E),P=0,M=null,L=null,O=null,R=ru,z=!(l===Ru.horizontal||!c&&!en(A)||c&&(Fu[A]||function(t){return $r.Arabic(t)||$r["Arabic Supplement"](t)||$r["Arabic Extended-A"](t)||$r["Arabic Presentation Forms-A"](t)||$r["Arabic Presentation Forms-B"](t)}(A)));if(I.imageName){var D=r[I.imageName];if(!D)continue;O=I.imageName,t.iconsInText=t.iconsInText||!0,L=D.paddedRect;var N=D.displaySize;I.scale=I.scale*ru/p,M={width:N[0],height:N[1],left:Ou,top:-Pu,advance:z?N[1]:N[0]},P=w+(D=ru-N[1]*I.scale),R=M.advance,0<(N=z?N[0]*I.scale-ru*b:N[1]*I.scale-ru*b)&&C<N&&(C=N)}else{if((N=(N=i[I.fontStack])&&N[A])&&N.rect)L=N.rect,M=N.metrics;else{if(!(N=(N=e[I.fontStack])&&N[A]))continue;M=N.metrics}P=(b-I.scale)*ru}z?(t.verticalizable=!0,T.push({glyph:A,imageName:O,x:h,y:d+P,vertical:z,scale:I.scale,fontStack:I.fontStack,sectionIndex:k,metrics:M,rect:L}),h+=R*I.scale+u):(T.push({glyph:A,imageName:O,x:h,y:d+P,vertical:z,scale:I.scale,fontStack:I.fontStack,sectionIndex:k,metrics:M,rect:L}),h+=M.advance*I.scale+u)}0!==T.length&&(B=h-u,f=Math.max(B,f),function(t,e,i,r,n){if(r||n)for(var o=(o=t[i]).metrics.advance*o.scale,a=(t[i].x+o)*r,s=0;s<=i;s++)t[s].x-=a,t[s].y+=n}(T,0,T.length-1,y,C)),h=0;var B=o*b+C;S.lineOffset=Math.max(C,w),d+=B,m=Math.max(B,m),++g}else d+=o,++g}var F=d-zu;a=(s=Gu(a)).horizontalAlign,s=s.verticalAlign;(function(t,e,i,r,n,o,a,s,l){var u,c=(e-i)*n;u=o!==a?-s*r-zu:(-r*l+.5)*a;for(var p=0,h=t;p<h.length;p+=1)for(var d=0,f=h[p].positionedGlyphs;d<f.length;d+=1){var m=f[d];m.x+=c,m.y+=u}})(t.positionedLines,y,a,s,f,m,o,F,n.length),t.top+=-s*F,t.bottom=t.top+F,t.left+=-a*f,t.right=t.left+f}(c={positionedLines:f=[],text:y.toString(),top:c[1],bottom:c[1],left:c[0],right:c[0],writingMode:p,iconsInText:!1,verticalizable:!1},e,i,r,g,a,s,l,p,u,h,m),!function(t){for(var e=0,i=f;e<i.length;e+=1)if(0!==i[e].positionedGlyphs.length)return;return 1}()&&c}Nu.fromFeature=function(t,e){for(var i=new Nu,r=0;r<t.sections.length;r++){var n=t.sections[r];n.image?i.addImageSection(n):i.addTextSection(n,e)}return i},Nu.prototype.length=function(){return this.text.length},Nu.prototype.getSection=function(t){return this.sections[this.sectionIndex[t]]},Nu.prototype.getSectionIndex=function(t){return this.sectionIndex[t]},Nu.prototype.getCharCode=function(t){return this.text.charCodeAt(t)},Nu.prototype.verticalizePunctuation=function(){this.text=function(t){for(var e="",i=0;i<t.length;i++){var r=t.charCodeAt(i+1)||null,n=t.charCodeAt(i-1)||null;r&&rn(r)&&!iu[t[i+1]]||n&&rn(n)&&!iu[t[i-1]]||!iu[t[i]]?e+=t[i]:e+=iu[t[i]]}return e}(this.text)},Nu.prototype.trim=function(){for(var t=0,e=0;e<this.text.length&&Fu[this.text.charCodeAt(e)];e++)t++;for(var i=this.text.length,r=this.text.length-1;0<=r&&t<=r&&Fu[this.text.charCodeAt(r)];r--)i--;this.text=this.text.substring(t,i),this.sectionIndex=this.sectionIndex.slice(t,i)},Nu.prototype.substring=function(t,e){var i;return(i=new Nu).text=this.text.substring(t,e),i.sectionIndex=this.sectionIndex.slice(t,e),i.sections=this.sections,i},Nu.prototype.toString=function(){return this.text},Nu.prototype.getMaxScale=function(){var t=this;return this.sectionIndex.reduce(function(e,i){return Math.max(e,t.sections[i].scale)},0)},Nu.prototype.addTextSection=function(t,e){this.text+=t.text,this.sections.push(Du.forText(t.scale,t.fontStack||e));for(var i=this.sections.length-1,r=0;r<t.text.length;++r)this.sectionIndex.push(i)},Nu.prototype.addImageSection=function(t){var e=t.image?t.image.name:"";0!==e.length?(t=this.getNextImageSectionCharCode())?(this.text+=String.fromCharCode(t),this.sections.push(Du.forImage(e)),this.sectionIndex.push(this.sections.length-1)):S("Reached maximum number of images 6401"):S("Can't add FormattedSection with an empty image.")},Nu.prototype.getNextImageSectionCharCode=function(){return this.imageSectionID?63743<=this.imageSectionID?null:++this.imageSectionID:(this.imageSectionID=57344,this.imageSectionID)};var Fu={9:!0,10:!0,11:!0,12:!0,13:!0,32:!0},Uu={};function ju(t,e,i,r,n,o){return e.imageName?(r=r[e.imageName])?r.displaySize[0]*e.scale*ru/o+n:0:(t=(i=i[e.fontStack])&&i[t])?t.metrics.advance*e.scale+n:0}function Vu(t,e,i,r){var n=Math.pow(t-e,2);return r?t<e?n/2:2*n:n+Math.abs(i)*i}function qu(t,e,i,r,n,o){for(var a=null,s=Vu(e,i,n,o),l=0,u=r;l<u.length;l+=1){var c=u[l],p=Vu(e-c.x,i,n,o)+c.badness;p<=s&&(a=c,s=p)}return{index:t,x:e,priorBreak:a,badness:s}}function Hu(t,e,i,r,n,o,a){if("point"!==o)return[];if(!t)return[];for(var s,l=[],u=function(t,e,i,r,n,o){for(var a=0,s=0;s<t.length();s++){var l=t.getSection(s);a+=ju(t.getCharCode(s),l,r,n,e,o)}return a/Math.max(1,Math.ceil(a/i))}(t,e,i,r,n,a),c=0<=t.text.indexOf("â€‹"),p=0,h=0;h<t.length();h++){var d,f=t.getSection(h),m=t.getCharCode(h);Fu[m]||(p+=ju(m,f,r,n,e,a)),h<t.length()-1&&(d=!!(!((s=m)<11904)&&($r["Bopomofo Extended"](s)||$r.Bopomofo(s)||$r["CJK Compatibility Forms"](s)||$r["CJK Compatibility Ideographs"](s)||$r["CJK Compatibility"](s)||$r["CJK Radicals Supplement"](s)||$r["CJK Strokes"](s)||$r["CJK Symbols and Punctuation"](s)||$r["CJK Unified Ideographs Extension A"](s)||$r["CJK Unified Ideographs"](s)||$r["Enclosed CJK Letters and Months"](s)||$r["Halfwidth and Fullwidth Forms"](s)||$r.Hiragana(s)||$r["Ideographic Description Characters"](s)||$r["Kangxi Radicals"](s)||$r["Katakana Phonetic Extensions"](s)||$r.Katakana(s)||$r["Vertical Forms"](s)||$r["Yi Radicals"](s)||$r["Yi Syllables"](s))),(Uu[m]||d||f.imageName)&&l.push(qu(h+1,p,u,l,(s=m,m=0,10===s&&(m-=1e4),d&&c&&(m+=150),40!==s&&65288!==s||(m+=50),41!==(f=t.getCharCode(h+1))&&65289!==f||(m+=50),m),!1)))}return function t(e){return e?t(e.priorBreak).concat(e.index):[]}(qu(t.length(),p,u,l,0,!0))}function Gu(t){var e=.5,i=.5;switch(t){case"right":case"top-right":case"bottom-right":e=1;break;case"left":case"top-left":case"bottom-left":e=0}switch(t){case"bottom":case"bottom-right":case"bottom-left":i=1;break;case"top":case"top-right":case"top-left":i=0}return{horizontalAlign:e,verticalAlign:i}}function Zu(t,e,i,r,n,o){var a;(t=t.image).content&&(u=t.content,c=t.pixelRatio||1,a=[u[0]/c,u[1]/c,t.displaySize[0]-u[2]/c,t.displaySize[1]-u[3]/c]);var s,l,u=e.left*o,c=e.right*o;u="width"===i||"both"===i?(l=n[0]+u-r[3],n[0]+c+r[1]):(l=n[0]+(u+c-t.displaySize[0])/2)+t.displaySize[0],c=e.top*o,o=e.bottom*o,o="height"===i||"both"===i?(s=n[1]+c-r[0],n[1]+o+r[2]):(s=n[1]+(c+o-t.displaySize[1])/2)+t.displaySize[1];return{image:t,top:s,right:u,bottom:o,left:l,collisionPadding:a}}Uu[10]=!0,Uu[32]=!0,Uu[38]=!0,Uu[40]=!0,Uu[41]=!0,Uu[43]=!0,Uu[45]=!0,Uu[47]=!0,Uu[173]=!0,Uu[183]=!0,Uu[8203]=!0,Uu[8208]=!0,Uu[8211]=!0,Uu[8231]=!0;var Wu,Ku=((Wu=o)&&(Xu.__proto__=Wu),((Xu.prototype=Object.create(Wu&&Wu.prototype)).constructor=Xu).prototype.clone=function(){return new Xu(this.x,this.y,this.angle,this.segment)},Xu);function Xu(t,e,i,r){Wu.call(this,t,e),this.angle=i,void 0!==r&&(this.segment=r)}Wr("Anchor",Ku);var Yu=128;function Ju(t,e){var i=e.expression;if("constant"===i.kind)return{kind:"constant",layoutSize:i.evaluate(new hn(t+1))};if("source"===i.kind)return{kind:"source"};for(var r=i.zoomStops,n=i.interpolationType,o=0;o<r.length&&r[o]<=t;)o++;for(var a=o=Math.max(0,o-1);a<r.length&&r[a]<t+1;)a++;a=Math.min(r.length-1,a);var s=r[o];e=r[a];return"composite"===i.kind?{kind:"composite",minZoom:s,maxZoom:e,interpolationType:n}:{kind:"camera",minZoom:s,maxZoom:e,minSize:i.evaluate(new hn(s)),maxSize:i.evaluate(new hn(e)),interpolationType:n}}function Qu(t,e,i){var r=e.uSize,n=e.uSizeT;e=i.lowerSize,i=i.upperSize;return"source"===t.kind?e/Yu:"composite"===t.kind?Je(e/Yu,i/Yu,n):r}function $u(t,e){var i,r,n,o=0,a=0;return"constant"===t.kind?a=t.layoutSize:"source"!==t.kind&&(i=t.interpolationType,r=t.minZoom,n=t.maxZoom,n=i?p(fi.interpolationFactor(i,e,r,n),0,1):0,"camera"===t.kind?a=Je(t.minSize,t.maxSize,n):o=n),{uSizeT:o,uSize:a}}function tc(t,e,i,r,n){if(void 0===e.segment)return 1;for(var o=e,a=e.segment+1,s=0;-i/2<s;){if(--a<0)return;s-=t[a].dist(o),o=t[a]}s+=t[a].dist(t[a+1]),a++;for(var l=[],u=0;s<i/2;){var c=t[a-1],p=t[a],h=t[a+1];if(!h)return;for(c=c.angleTo(p)-p.angleTo(h),c=Math.abs((c+3*Math.PI)%(2*Math.PI)-Math.PI),l.push({distance:s,angleDelta:c}),u+=c;s-l[0].distance>r;)u-=l.shift().angleDelta;if(n<u)return;a++,s+=p.dist(h)}return 1}function ec(t){for(var e=0,i=0;i<t.length-1;i++)e+=t[i].dist(t[i+1]);return e}function ic(t,e,i){return t?.6*e*i:0}function rc(t,e){return Math.max(t?t.right-t.left:0,e?e.right-e.left:0)}function nc(t,e,i,r,n,o,a,s,l){var u=ic(r,o,a),c=rc(r,n);return e-(r=c*a)<e/4&&(e=r+e/4),function t(e,i,r,n,o,a,s,l,u){for(var c=a/2,p=ec(e),h=0,d=i-r,f=[],m=0;m<e.length-1;m++){for(var y=e[m],g=e[m+1],v=y.dist(g),_=g.angleTo(y);d+r<h+v;){var x=((d+=r)-h)/v,b=Je(y.x,g.x,x);x=Je(y.y,g.y,x);0<=b&&b<u&&0<=x&&x<u&&0<=d-c&&d+c<=p&&((x=new Ku(b,x,_,m))._round(),n&&!tc(e,x,a,n,o)||f.push(x))}h+=v}return l||f.length||s||(f=t(e,h/2,r,n,o,a,s,!0,u)),f}(t,(n=0===t[0].x||t[0].x===l||0===t[0].y||t[0].y===l)?e/2*s%e:(c/2+2*o)*a*s%e,e,u,i,r,n,!1,l)}function oc(t,e,i,r,n){for(var a=[],s=0;s<t.length;s++)for(var l=t[s],u=void 0,c=0;c<l.length-1;c++){var p=l[c],h=l[c+1];p.x<e&&h.x<e||(p.x<e?p=new o(e,p.y+(h.y-p.y)*((e-p.x)/(h.x-p.x)))._round():h.x<e&&(h=new o(e,p.y+(h.y-p.y)*((e-p.x)/(h.x-p.x)))._round()),p.y<i&&h.y<i||(p.y<i?p=new o(p.x+(h.x-p.x)*((i-p.y)/(h.y-p.y)),i)._round():h.y<i&&(h=new o(p.x+(h.x-p.x)*((i-p.y)/(h.y-p.y)),i)._round()),p.x>=r&&h.x>=r||(p.x>=r?p=new o(r,p.y+(h.y-p.y)*((r-p.x)/(h.x-p.x)))._round():h.x>=r&&(h=new o(r,p.y+(h.y-p.y)*((r-p.x)/(h.x-p.x)))._round()),p.y>=n&&h.y>=n||(p.y>=n?p=new o(p.x+(h.x-p.x)*((n-p.y)/(h.y-p.y)),n)._round():h.y>=n&&(h=new o(p.x+(h.x-p.x)*((n-p.y)/(h.y-p.y)),n)._round()),u&&p.equals(u[u.length-1])||a.push(u=[p]),u.push(h)))))}return a}fs=Object.freeze({__proto__:null,getSizeData:Ju,evaluateSizeForFeature:Qu,evaluateSizeForZoom:$u,SIZE_PACK_FACTOR:Yu});var ac=Ou;function sc(t,e,i,r){var n=[],a=t.image,s=a.pixelRatio,l=a.paddedRect.w-2*ac,u=a.paddedRect.h-2*ac,c=t.right-t.left,p=t.bottom-t.top,h=a.stretchX||[[0,l]],d=a.stretchY||[[0,u]],f=function(t,e){return t+e[1]-e[0]},m=h.reduce(f,0),y=d.reduce(f,0),g=l-m,v=u-y,_=0,x=m,b=0,w=y,S=0,T=g,C=0,E=v;function I(r,n,l,u){var h=(r.stretch-_)/x*c+t.left,d=r.fixed-S-T*r.stretch/m,f=(n.stretch-b)/w*p+t.top,g=n.fixed-C-E*n.stretch/y,v=(l.stretch-_)/x*c+t.left,I=l.fixed-S-T*l.stretch/m,k=(u.stretch-b)/w*p+t.top,A=u.fixed-C-E*u.stretch/y,P=new o(h,f);f=new o(v,f),v=new o(v,k),k=new o(h,k),d=new o(d/s,g/s),g=new o(I/s,A/s);return(I=e*Math.PI/180)&&(A=Math.sin(I),I=Math.cos(I),P._matMult(I=[I,-A,A,I]),f._matMult(I),k._matMult(I),v._matMult(I)),r=r.stretch+r.fixed,l=l.stretch+l.fixed,n=n.stretch+n.fixed,u=u.stretch+u.fixed,{tl:P,tr:f,bl:k,br:v,tex:{x:a.paddedRect.x+ac+r,y:a.paddedRect.y+ac+n,w:l-r,h:u-n},writingMode:void 0,glyphOffset:[0,0],sectionIndex:0,pixelOffsetTL:d,pixelOffsetBR:g,minFontScaleX:T/s/c,minFontScaleY:E/s/p,isSDF:i}}if(a.content&&r&&(f=a.content,_=lc(h,0,f[0]),b=lc(d,0,f[1]),x=lc(h,f[0],f[2]),w=lc(d,f[1],f[3]),S=f[0]-_,C=f[1]-b,T=f[2]-f[0]-x,E=f[3]-f[1]-w),r&&(a.stretchX||a.stretchY))for(var k=uc(h,g,m),A=uc(d,v,y),P=0;P<k.length-1;P++)for(var M=k[P],L=k[P+1],O=0;O<A.length-1;O++){var R=A[O],z=A[O+1];n.push(I(M,R,L,z))}else n.push(I({fixed:0,stretch:-1},{fixed:0,stretch:-1},{fixed:0,stretch:1+l},{fixed:0,stretch:1+u}));return n}function lc(t,e,i){for(var r=0,n=0,o=t;n<o.length;n+=1){var a=o[n];r+=Math.max(e,Math.min(i,a[1]))-Math.max(e,Math.min(i,a[0]))}return r}function uc(t,e,i){for(var r=[{fixed:-ac,stretch:0}],n=0,o=t;n<o.length;n+=1){var a=(l=o[n])[0],s=l[1],l=r[r.length-1];r.push({fixed:a-l.stretch,stretch:l.stretch}),r.push({fixed:a-l.stretch,stretch:l.stretch+(s-a)})}return r.push({fixed:e+ac,stretch:i}),r}function cc(t,e,i,r,n,a,s,l,u,c){var p,h,d,f;this.boxStartIndex=t.length,u?(d=a.top,h=a.bottom,(p=a.collisionPadding)&&(d-=p[1],h+=p[3]),0<(f=h-d)&&(f=Math.max(10,f),this.circleDiameter=f)):(u=a.top*s-l,p=a.bottom*s+l,h=a.left*s-l,d=a.right*s+l,(f=a.collisionPadding)&&(h-=f[0]*s,u-=f[1]*s,d+=f[2]*s,p+=f[3]*s),c&&(l=new o(h,u),a=new o(d,u),f=new o(h,p),s=new o(d,p),c=c*Math.PI/180,l._rotate(c),a._rotate(c),f._rotate(c),s._rotate(c),h=Math.min(l.x,a.x,f.x,s.x),d=Math.max(l.x,a.x,f.x,s.x),u=Math.min(l.y,a.y,f.y,s.y),p=Math.max(l.y,a.y,f.y,s.y)),t.emplaceBack(e.x,e.y,h,u,d,p,i,r,n)),this.boxEndIndex=t.length}function pc(t,e){if(void 0===e&&(e=hc),this.data=t=void 0===t?[]:t,this.length=this.data.length,this.compare=e,0<this.length)for(var i=(this.length>>1)-1;0<=i;i--)this._down(i)}function hc(t,e){return t<e?-1:e<t?1:0}function dc(t,e,i){void 0===e&&(e=1),void 0===i&&(i=!1);for(var r=1/0,n=1/0,a=-1/0,s=-1/0,l=t[0],u=0;u<l.length;u++){var c=l[u];(!u||c.x<r)&&(r=c.x),(!u||c.y<n)&&(n=c.y),(!u||c.x>a)&&(a=c.x),(!u||c.y>s)&&(s=c.y)}var p=Math.min(a-r,s-n),h=p/2,d=new pc([],fc);if(0===p)return new o(r,n);for(var f=r;f<a;f+=p)for(var m=n;m<s;m+=p)d.push(new mc(f+h,m+h,h,t));for(var y=function(t){for(var e=0,i=0,r=0,n=t[0],o=0,a=n.length,s=a-1;o<a;s=o++){var l=n[o],u=n[s],c=l.x*u.y-u.x*l.y;i+=(l.x+u.x)*c,r+=(l.y+u.y)*c,e+=3*c}return new mc(i/e,r/e,0,t)}(t),g=d.length;d.length;){var v=d.pop();(v.d>y.d||!y.d)&&(y=v,i&&console.log("found best %d after %d probes",Math.round(1e4*v.d)/1e4,g)),v.max-y.d<=e||(h=v.h/2,d.push(new mc(v.p.x-h,v.p.y-h,h,t)),d.push(new mc(v.p.x+h,v.p.y-h,h,t)),d.push(new mc(v.p.x-h,v.p.y+h,h,t)),d.push(new mc(v.p.x+h,v.p.y+h,h,t)),g+=4)}return i&&(console.log("num probes: "+g),console.log("best distance: "+y.d)),y.p}function fc(t,e){return e.max-t.max}function mc(t,e,i,r){this.p=new o(t,e),this.h=i,this.d=function(t,e){for(var i=!1,r=1/0,n=0;n<e.length;n++)for(var o=e[n],a=0,s=o.length,l=s-1;a<s;l=a++){var u=o[a],c=o[l];u.y>t.y!=c.y>t.y&&t.x<(c.x-u.x)*(t.y-u.y)/(c.y-u.y)+u.x&&(i=!i),r=Math.min(r,ls(t,u,c))}return(i?1:-1)*Math.sqrt(r)}(this.p,r),this.max=this.d+this.h*Math.SQRT2}pc.prototype.push=function(t){this.data.push(t),this.length++,this._up(this.length-1)},pc.prototype.pop=function(){if(0!==this.length){var t=this.data[0],e=this.data.pop();return this.length--,0<this.length&&(this.data[0]=e,this._down(0)),t}},pc.prototype.peek=function(){return this.data[0]},pc.prototype._up=function(t){for(var e=this.data,i=this.compare,r=e[t];0<t;){var n=t-1>>1,o=e[n];if(0<=i(r,o))break;e[t]=o,t=n}e[t]=r},pc.prototype._down=function(t){for(var e=this.data,i=this.compare,r=this.length>>1,n=e[t];t<r;){var o=1+(t<<1),a=e[o],s=o+1;if(s<this.length&&i(e[s],a)<0&&(a=e[o=s]),0<=i(a,n))break;e[t]=a,t=o}e[t]=n};var yc=Number.POSITIVE_INFINITY;function gc(t,e){return e[1]!==yc?function(t,e,i){var r=0,n=0;switch(e=Math.abs(e),i=Math.abs(i),t){case"top-right":case"top-left":case"top":n=i-7;break;case"bottom-right":case"bottom-left":case"bottom":n=7-i}switch(t){case"top-right":case"bottom-right":case"right":r=-e;break;case"top-left":case"bottom-left":case"left":r=e}return[r,n]}(t,e[0],e[1]):function(t,e){var i=0,r=0,n=(e=e<0?0:e)/Math.sqrt(2);switch(t){case"top-right":case"top-left":r=n-7;break;case"bottom-right":case"bottom-left":r=7-n;break;case"bottom":r=7-e;break;case"top":r=e-7}switch(t){case"top-right":case"bottom-right":i=-n;break;case"top-left":case"bottom-left":i=n;break;case"left":i=e;break;case"right":i=-e}return[i,r]}(t,e[0])}function vc(t){switch(t){case"right":case"top-right":case"bottom-right":return"right";case"left":case"top-left":case"bottom-left":return"left"}return"center"}var _c=255,xc=_c*Yu;function bc(t,e,i,r,n,a,s,l,u,c,p,h,d,f,m){var y=function(t,e,i,r,n,a,s){for(var l=i.layout.get("text-rotate").evaluate(n,{})*Math.PI/180,u=[],c=0,p=t.positionedLines;c<p.length;c+=1)for(var h=p[c],d=0,f=h.positionedGlyphs;d<f.length;d+=1){var m,y,g,v,_,x,b,w,S,T,C,E,I,k,A=f[d];A.rect&&(m=A.rect||{},S=Pu+1,y=!0,_=1,w=0,T=(r||s)&&A.vertical,C=A.metrics.advance*A.scale/2,s&&t.verticalizable&&(b=(A.scale-1)*ru,E=(ru-A.metrics.width*A.scale)/2,w=h.lineOffset/2-(A.imageName?-E:b)),A.imageName&&(y=(x=a[A.imageName]).sdf,_=x.pixelRatio,S=Ou/_),g=r?[A.x+C,A.y]:[0,0],v=r?[0,0]:[A.x+C+e[0],A.y+e[1]-w],E=[0,0],T&&(E=v,v=[0,0]),b=(A.metrics.left-S)*A.scale-C+v[0],x=(-A.metrics.top-S)*A.scale+v[1],w=b+m.w*A.scale/_,S=x+m.h*A.scale/_,v=new o(b,x),_=new o(w,x),x=new o(b,S),b=new o(w,S),T&&(w=new o(-C,C-zu),S=-Math.PI/2,T=ru/2-C,C=A.imageName?T:0,C=new o(5-zu-T,-C),E=new(Function.prototype.bind.apply(o,[null].concat(E))),v._rotateAround(S,w)._add(C)._add(E),_._rotateAround(S,w)._add(C)._add(E),x._rotateAround(S,w)._add(C)._add(E),b._rotateAround(S,w)._add(C)._add(E)),l&&(k=Math.sin(l),I=Math.cos(l),v._matMult(k=[I,-k,k,I]),_._matMult(k),x._matMult(k),b._matMult(k)),I=new o(0,0),k=new o(0,0),u.push({tl:v,tr:_,bl:x,br:b,tex:m,writingMode:t.writingMode,glyphOffset:g,sectionIndex:A.sectionIndex,isSDF:y,pixelOffsetTL:I,pixelOffsetBR:k,minFontScaleX:0,minFontScaleY:0}))}return u}(i,l,n,a,s,r,t.allowVerticalPlacement);r=null;"source"===(i=t.textSizeData).kind?(r=[Yu*n.layout.get("text-size").evaluate(s,{})])[0]>xc&&S(t.layerIds[0]+': Value for "text-size" is >= '+_c+'. Reduce your "text-size".'):"composite"===i.kind&&((r=[Yu*f.compositeTextSizes[0].evaluate(s,{},m),Yu*f.compositeTextSizes[1].evaluate(s,{},m)])[0]>xc||r[1]>xc)&&S(t.layerIds[0]+': Value for "text-size" is >= '+_c+'. Reduce your "text-size".'),t.addSymbols(t.text,y,r,l,a,s,c,e,u.lineStartIndex,u.lineLength,d,m);for(var g=0,v=p;g<v.length;g+=1)h[v[g]]=t.text.placedSymbolArray.length-1;return 4*y.length}function wc(t){for(var e in t)return t[e];return null}var Sc=kl.VectorTileFeature.types,Tc=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}];function Cc(t,e,i,r,n,o,a,s,l,u,c,p,h){var d=s?Math.min(xc,Math.round(s[0])):0;s=s?Math.min(xc,Math.round(s[1])):0;t.emplaceBack(e,i,Math.round(32*r),Math.round(32*n),o,a,(d<<1)+(l?1:0),s,16*u,16*c,256*p,256*h)}function Ec(t,e,i){t.emplaceBack(e.x,e.y,i),t.emplaceBack(e.x,e.y,i),t.emplaceBack(e.x,e.y,i),t.emplaceBack(e.x,e.y,i)}function Ic(t){for(var e=0,i=t.sections;e<i.length;e+=1)if(function(t){for(var e=0,i=t;e<i.length;e+=1)if(nn(i[e].charCodeAt(0)))return 1}(i[e].text))return 1}function kc(t){this.layoutVertexArray=new io,this.indexArray=new Eo,this.programConfigurations=t,this.segments=new fa,this.dynamicLayoutVertexArray=new oo,this.opacityVertexArray=new lo,this.placedSymbolArray=new Qo}function Ac(t,e,i){this.layoutVertexArray=new t,this.layoutAttributes=e,this.indexArray=new i,this.segments=new fa,this.collisionVertexArray=new bo}function Pc(t){this.collisionBoxArray=t.collisionBoxArray,this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map(function(t){return t.id}),this.index=t.index,this.pixelRatio=t.pixelRatio,this.sourceLayerIndex=t.sourceLayerIndex,this.hasPattern=!1,this.hasRTLText=!1,this.sortKeyRanges=[],this.collisionCircleArray=[],this.placementInvProjMatrix=gs([]),this.placementViewportMatrix=gs([]);var e=this.layers[0]._unevaluatedLayout._values;this.textSizeData=Ju(this.zoom,e["text-size"]),this.iconSizeData=Ju(this.zoom,e["icon-size"]);var i=this.layers[0].layout,r=i.get("symbol-sort-key");e=i.get("symbol-z-order");this.canOverlap=i.get("text-allow-overlap")||i.get("icon-allow-overlap")||i.get("text-ignore-placement")||i.get("icon-ignore-placement"),this.sortFeaturesByKey="viewport-y"!==e&&void 0!==r.constantOr(1),e="viewport-y"===e||"auto"===e&&!this.sortFeaturesByKey,this.sortFeaturesByY=e&&this.canOverlap,"point"===i.get("symbol-placement")&&(this.writingModes=i.get("text-writing-mode").map(function(t){return Ru[t]})),this.stateDependentLayerIds=this.layers.filter(function(t){return t.isStateDependent()}).map(function(t){return t.id}),this.sourceID=t.sourceID}function Mc(t){this.type=t.property.overrides?t.property.overrides.runtimeType:Zt,this.defaultValue=t}kc.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length&&0===this.indexArray.length&&0===this.dynamicLayoutVertexArray.length&&0===this.opacityVertexArray.length},kc.prototype.upload=function(t,e,i,r){this.isEmpty()||(i&&(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Jl.members),this.indexBuffer=t.createIndexBuffer(this.indexArray,e),this.dynamicLayoutVertexBuffer=t.createVertexBuffer(this.dynamicLayoutVertexArray,Ql.members,!0),this.opacityVertexBuffer=t.createVertexBuffer(this.opacityVertexArray,Tc,!0),this.opacityVertexBuffer.itemSize=1),(i||r)&&this.programConfigurations.upload(t))},kc.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer.destroy())},Wr("SymbolBuffers",kc),Ac.prototype.upload=function(t){this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.collisionVertexBuffer=t.createVertexBuffer(this.collisionVertexArray,$l.members,!0)},Ac.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy(),this.collisionVertexBuffer.destroy())},Wr("CollisionBuffers",Ac),Pc.prototype.createArrays=function(){this.text=new kc(new Xa(this.layers,this.zoom,function(t){return/^text/.test(t)})),this.icon=new kc(new Xa(this.layers,this.zoom,function(t){return/^icon/.test(t)})),this.glyphOffsetArray=new oa,this.lineVertexArray=new la,this.symbolInstances=new ia},Pc.prototype.calculateGlyphDependencies=function(t,e,i,r,n){for(var o,a=0;a<t.length;a++)e[t.charCodeAt(a)]=!0,!i&&!r||!n||(o=iu[t.charAt(a)])&&(e[o.charCodeAt(0)]=!0)},Pc.prototype.populate=function(t,e,i){var r=this.layers[0],n=r.layout,o=n.get("text-font"),a=n.get("text-field"),s=n.get("icon-image"),l=("constant"!==a.value.kind||a.value.value instanceof he&&!a.value.value.isEmpty()||0<a.value.value.toString().length)&&("constant"!==o.value.kind||0<o.value.value.length),u="constant"!==s.value.kind||!!s.value.value||0<Object.keys(s.parameters).length,c=n.get("symbol-sort-key");if(this.features=[],l||u){for(var p=e.iconDependencies,h=e.glyphDependencies,d=e.availableImages,f=new hn(this.zoom),m=0,y=t;m<y.length;m+=1){var g=(w=y[m]).feature,v=w.id,_=w.index,x=w.sourceLayerIndex,b=r._featureFilter.needGeometry,w=es(g,b);if(r._featureFilter.filter(f,w,i)){b||(w.geometry=ts(g));var S=void 0;l&&(T=r.getValueAndResolveTokens("text-field",w,i,d),Ic(T=he.factory(T))&&(this.hasRTLText=!0),(!this.hasRTLText||"unavailable"===sn||this.hasRTLText&&fn.isParsed())&&(S=eu(T,r,w)));var T=void 0;if(u&&(T=(C=r.getValueAndResolveTokens("icon-image",w,i,d))instanceof de?C:de.fromString(C)),S||T){var C=this.sortFeaturesByKey?c.evaluate(w,{},i):void 0;C={id:v,text:S,icon:T,index:_,sourceLayerIndex:x,geometry:w.geometry,properties:g.properties,type:Sc[g.type],sortKey:C};if(this.features.push(C),T&&(p[T.name]=!0),S){var E=o.evaluate(w,{},i).join(","),I="map"===n.get("text-rotation-alignment")&&"point"!==n.get("symbol-placement");this.allowVerticalPlacement=this.writingModes&&0<=this.writingModes.indexOf(Ru.vertical);for(var k=0,A=S.sections;k<A.length;k+=1){var P,M,L=A[k];L.image?p[L.image.name]=!0:(P=tn(S.toString()),M=h[M=L.fontStack||E]=h[M]||{},this.calculateGlyphDependencies(L.text,M,I,this.allowVerticalPlacement,P))}}}}}"line"===n.get("symbol-placement")&&(this.features=function(t){var e={},i={},r=[],n=0;function o(e){r.push(t[e]),n++}function a(t,e,n){var o=i[t];return delete i[t],i[e]=o,r[o].geometry[0].pop(),r[o].geometry[0]=r[o].geometry[0].concat(n[0]),o}function s(t,i,n){var o=e[i];return delete e[i],e[t]=o,r[o].geometry[0].shift(),r[o].geometry[0]=n[0].concat(r[o].geometry[0]),o}function l(t,e,i){return t+":"+(e=i?e[0][e[0].length-1]:e[0][0]).x+":"+e.y}for(var u=0;u<t.length;u++){var c,p,h,d=t[u],f=d.geometry,m=d.text?d.text.toString():null;m?(c=l(m,f),p=l(m,f,!0),c in i&&p in e&&i[c]!==e[p]?(h=s(c,p,f),d=a(c,p,r[h].geometry),delete e[c],delete i[p],i[l(m,r[d].geometry,!0)]=d,r[h].geometry=null):c in i?a(c,p,f):p in e?s(c,p,f):(o(u),e[c]=n-1,i[p]=n-1)):o(u)}return r.filter(function(t){return t.geometry})}(this.features)),this.sortFeaturesByKey&&this.features.sort(function(t,e){return t.sortKey-e.sortKey})}},Pc.prototype.update=function(t,e,i){this.stateDependentLayers.length&&(this.text.programConfigurations.updatePaintArrays(t,e,this.layers,i),this.icon.programConfigurations.updatePaintArrays(t,e,this.layers,i))},Pc.prototype.isEmpty=function(){return 0===this.symbolInstances.length&&!this.hasRTLText},Pc.prototype.uploadPending=function(){return!this.uploaded||this.text.programConfigurations.needsUpload||this.icon.programConfigurations.needsUpload},Pc.prototype.upload=function(t){!this.uploaded&&this.hasDebugData()&&(this.textCollisionBox.upload(t),this.iconCollisionBox.upload(t)),this.text.upload(t,this.sortFeaturesByY,!this.uploaded,this.text.programConfigurations.needsUpload),this.icon.upload(t,this.sortFeaturesByY,!this.uploaded,this.icon.programConfigurations.needsUpload),this.uploaded=!0},Pc.prototype.destroyDebugData=function(){this.textCollisionBox.destroy(),this.iconCollisionBox.destroy()},Pc.prototype.destroy=function(){this.text.destroy(),this.icon.destroy(),this.hasDebugData()&&this.destroyDebugData()},Pc.prototype.addToLineVertexArray=function(t,e){var i=this.lineVertexArray.length;if(void 0!==t.segment){for(var r=t.dist(e[t.segment+1]),n=t.dist(e[t.segment]),o={},a=t.segment+1;a<e.length;a++)o[a]={x:e[a].x,y:e[a].y,tileUnitDistanceFromAnchor:r},a<e.length-1&&(r+=e[a+1].dist(e[a]));for(var s=t.segment||0;0<=s;s--)o[s]={x:e[s].x,y:e[s].y,tileUnitDistanceFromAnchor:n},0<s&&(n+=e[s-1].dist(e[s]));for(var l=0;l<e.length;l++){var u=o[l];this.lineVertexArray.emplaceBack(u.x,u.y,u.tileUnitDistanceFromAnchor)}}return{lineStartIndex:i,lineLength:this.lineVertexArray.length-i}},Pc.prototype.addSymbols=function(t,e,i,r,n,o,a,s,l,u,c,p){for(var h=t.indexArray,d=t.layoutVertexArray,f=t.segments.prepareSegment(4*e.length,d,h,this.canOverlap?o.sortKey:void 0),m=this.glyphOffsetArray.length,y=f.vertexLength,g=this.allowVerticalPlacement&&a===Ru.vertical?Math.PI/2:0,v=o.text&&o.text.sections,_=0;_<e.length;_++){var x=(O=e[_]).tl,b=O.tr,w=O.bl,S=O.br,T=O.tex,C=O.pixelOffsetTL,E=O.pixelOffsetBR,I=O.minFontScaleX,k=O.minFontScaleY,A=O.glyphOffset,P=O.isSDF,M=O.sectionIndex,L=f.vertexLength,O=A[1];Cc(d,s.x,s.y,x.x,O+x.y,T.x,T.y,i,P,C.x,C.y,I,k),Cc(d,s.x,s.y,b.x,O+b.y,T.x+T.w,T.y,i,P,E.x,C.y,I,k),Cc(d,s.x,s.y,w.x,O+w.y,T.x,T.y+T.h,i,P,C.x,E.y,I,k),Cc(d,s.x,s.y,S.x,O+S.y,T.x+T.w,T.y+T.h,i,P,E.x,E.y,I,k),Ec(t.dynamicLayoutVertexArray,s,g),h.emplaceBack(L,L+1,L+2),h.emplaceBack(L+1,L+2,L+3),f.vertexLength+=4,f.primitiveLength+=2,this.glyphOffsetArray.emplaceBack(A[0]),_!==e.length-1&&M===e[_+1].sectionIndex||t.programConfigurations.populatePaintArrays(d.length,o,o.index,{},p,v&&v[M])}t.placedSymbolArray.emplaceBack(s.x,s.y,m,this.glyphOffsetArray.length-m,y,l,u,s.segment,i?i[0]:0,i?i[1]:0,r[0],r[1],a,0,!1,0,c)},Pc.prototype._addCollisionDebugVertex=function(t,e,i,r,n,o){return e.emplaceBack(0,0),t.emplaceBack(i.x,i.y,r,n,Math.round(o.x),Math.round(o.y))},Pc.prototype.addCollisionDebugVertices=function(t,e,i,r,n,a,s){var l=n.segments.prepareSegment(4,n.layoutVertexArray,n.indexArray),u=l.vertexLength,c=n.layoutVertexArray,p=n.collisionVertexArray,h=s.anchorX;s=s.anchorY;this._addCollisionDebugVertex(c,p,a,h,s,new o(t,e)),this._addCollisionDebugVertex(c,p,a,h,s,new o(i,e)),this._addCollisionDebugVertex(c,p,a,h,s,new o(i,r)),this._addCollisionDebugVertex(c,p,a,h,s,new o(t,r)),l.vertexLength+=4,(n=n.indexArray).emplaceBack(u,u+1),n.emplaceBack(u+1,u+2),n.emplaceBack(u+2,u+3),n.emplaceBack(u+3,u),l.primitiveLength+=4},Pc.prototype.addDebugCollisionBoxes=function(t,e,i,r){for(var n=t;n<e;n++){var o=this.collisionBoxArray.get(n),a=o.x1,s=o.y1,l=o.x2,u=o.y2;this.addCollisionDebugVertices(a,s,l,u,r?this.textCollisionBox:this.iconCollisionBox,o.anchorPoint,i)}},Pc.prototype.generateCollisionDebugBuffers=function(){this.hasDebugData()&&this.destroyDebugData(),this.textCollisionBox=new Ac(mo,tu.members,Uo),this.iconCollisionBox=new Ac(mo,tu.members,Uo);for(var t=0;t<this.symbolInstances.length;t++){var e=this.symbolInstances.get(t);this.addDebugCollisionBoxes(e.textBoxStartIndex,e.textBoxEndIndex,e,!0),this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex,e.verticalTextBoxEndIndex,e,!0),this.addDebugCollisionBoxes(e.iconBoxStartIndex,e.iconBoxEndIndex,e,!1),this.addDebugCollisionBoxes(e.verticalIconBoxStartIndex,e.verticalIconBoxEndIndex,e,!1)}},Pc.prototype._deserializeCollisionBoxesForSymbol=function(t,e,i,r,n,o,a,s,l){for(var u={},c=e;c<i;c++){var p=t.get(c);u.textBox={x1:p.x1,y1:p.y1,x2:p.x2,y2:p.y2,anchorPointX:p.anchorPointX,anchorPointY:p.anchorPointY},u.textFeatureIndex=p.featureIndex;break}for(var h=r;h<n;h++){var d=t.get(h);u.verticalTextBox={x1:d.x1,y1:d.y1,x2:d.x2,y2:d.y2,anchorPointX:d.anchorPointX,anchorPointY:d.anchorPointY},u.verticalTextFeatureIndex=d.featureIndex;break}for(var f=o;f<a;f++){var m=t.get(f);u.iconBox={x1:m.x1,y1:m.y1,x2:m.x2,y2:m.y2,anchorPointX:m.anchorPointX,anchorPointY:m.anchorPointY},u.iconFeatureIndex=m.featureIndex;break}for(var y=s;y<l;y++){var g=t.get(y);u.verticalIconBox={x1:g.x1,y1:g.y1,x2:g.x2,y2:g.y2,anchorPointX:g.anchorPointX,anchorPointY:g.anchorPointY},u.verticalIconFeatureIndex=g.featureIndex;break}return u},Pc.prototype.deserializeCollisionBoxes=function(t){this.collisionArrays=[];for(var e=0;e<this.symbolInstances.length;e++){var i=this.symbolInstances.get(e);this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t,i.textBoxStartIndex,i.textBoxEndIndex,i.verticalTextBoxStartIndex,i.verticalTextBoxEndIndex,i.iconBoxStartIndex,i.iconBoxEndIndex,i.verticalIconBoxStartIndex,i.verticalIconBoxEndIndex))}},Pc.prototype.hasTextData=function(){return 0<this.text.segments.get().length},Pc.prototype.hasIconData=function(){return 0<this.icon.segments.get().length},Pc.prototype.hasDebugData=function(){return this.textCollisionBox&&this.iconCollisionBox},Pc.prototype.hasTextCollisionBoxData=function(){return this.hasDebugData()&&0<this.textCollisionBox.segments.get().length},Pc.prototype.hasIconCollisionBoxData=function(){return this.hasDebugData()&&0<this.iconCollisionBox.segments.get().length},Pc.prototype.addIndicesForPlacedSymbol=function(t,e){for(var i=(e=t.placedSymbolArray.get(e)).vertexStartIndex+4*e.numGlyphs,r=e.vertexStartIndex;r<i;r+=4)t.indexArray.emplaceBack(r,r+1,r+2),t.indexArray.emplaceBack(r+1,r+2,r+3)},Pc.prototype.getSortedSymbolIndexes=function(t){if(this.sortedAngle===t&&void 0!==this.symbolInstanceIndexes)return this.symbolInstanceIndexes;for(var e=Math.sin(t),i=Math.cos(t),r=[],n=[],o=[],a=0;a<this.symbolInstances.length;++a){o.push(a);var s=this.symbolInstances.get(a);r.push(0|Math.round(e*s.anchorX+i*s.anchorY)),n.push(s.featureIndex)}return o.sort(function(t,e){return r[t]-r[e]||n[e]-n[t]}),o},Pc.prototype.addToSortKeyRanges=function(t,e){var i=this.sortKeyRanges[this.sortKeyRanges.length-1];i&&i.sortKey===e?i.symbolInstanceEnd=t+1:this.sortKeyRanges.push({sortKey:e,symbolInstanceStart:t,symbolInstanceEnd:t+1})},Pc.prototype.sortFeatures=function(t){var e=this;if(this.sortFeaturesByY&&this.sortedAngle!==t&&!(1<this.text.segments.get().length||1<this.icon.segments.get().length)){this.symbolInstanceIndexes=this.getSortedSymbolIndexes(t),this.sortedAngle=t,this.text.indexArray.clear(),this.icon.indexArray.clear(),this.featureSortOrder=[];for(var i=0,r=this.symbolInstanceIndexes;i<r.length;i+=1){var n=r[i];n=this.symbolInstances.get(n);this.featureSortOrder.push(n.featureIndex),[n.rightJustifiedTextSymbolIndex,n.centerJustifiedTextSymbolIndex,n.leftJustifiedTextSymbolIndex].forEach(function(t,i,r){0<=t&&r.indexOf(t)===i&&e.addIndicesForPlacedSymbol(e.text,t)}),0<=n.verticalPlacedTextSymbolIndex&&this.addIndicesForPlacedSymbol(this.text,n.verticalPlacedTextSymbolIndex),0<=n.placedIconSymbolIndex&&this.addIndicesForPlacedSymbol(this.icon,n.placedIconSymbolIndex),0<=n.verticalPlacedIconSymbolIndex&&this.addIndicesForPlacedSymbol(this.icon,n.verticalPlacedIconSymbolIndex)}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray)}},Wr("SymbolBucket",Pc,{omit:["layers","collisionBoxArray","features","compareText"]}),Pc.MAX_GLYPHS=65535,Pc.addDynamicAttributes=Ec;Cn=new kn({"symbol-placement":new Sn(Dt.layout_symbol["symbol-placement"]),"symbol-spacing":new Sn(Dt.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new Sn(Dt.layout_symbol["symbol-avoid-edges"]),"symbol-sort-key":new Rc(Dt.layout_symbol["symbol-sort-key"]),"symbol-z-order":new Sn(Dt.layout_symbol["symbol-z-order"]),"icon-allow-overlap":new Sn(Dt.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new Sn(Dt.layout_symbol["icon-ignore-placement"]),"icon-optional":new Sn(Dt.layout_symbol["icon-optional"]),"icon-rotation-alignment":new Sn(Dt.layout_symbol["icon-rotation-alignment"]),"icon-size":new Rc(Dt.layout_symbol["icon-size"]),"icon-text-fit":new Sn(Dt.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new Sn(Dt.layout_symbol["icon-text-fit-padding"]),"icon-image":new Rc(Dt.layout_symbol["icon-image"]),"icon-rotate":new Rc(Dt.layout_symbol["icon-rotate"]),"icon-padding":new Sn(Dt.layout_symbol["icon-padding"]),"icon-keep-upright":new Sn(Dt.layout_symbol["icon-keep-upright"]),"icon-offset":new Rc(Dt.layout_symbol["icon-offset"]),"icon-anchor":new Rc(Dt.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new Sn(Dt.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new Sn(Dt.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new Sn(Dt.layout_symbol["text-rotation-alignment"]),"text-field":new Rc(Dt.layout_symbol["text-field"]),"text-font":new Rc(Dt.layout_symbol["text-font"]),"text-size":new Rc(Dt.layout_symbol["text-size"]),"text-max-width":new Rc(Dt.layout_symbol["text-max-width"]),"text-line-height":new Sn(Dt.layout_symbol["text-line-height"]),"text-letter-spacing":new Rc(Dt.layout_symbol["text-letter-spacing"]),"text-justify":new Rc(Dt.layout_symbol["text-justify"]),"text-radial-offset":new Rc(Dt.layout_symbol["text-radial-offset"]),"text-variable-anchor":new Sn(Dt.layout_symbol["text-variable-anchor"]),"text-anchor":new Rc(Dt.layout_symbol["text-anchor"]),"text-max-angle":new Sn(Dt.layout_symbol["text-max-angle"]),"text-writing-mode":new Sn(Dt.layout_symbol["text-writing-mode"]),"text-rotate":new Rc(Dt.layout_symbol["text-rotate"]),"text-padding":new Sn(Dt.layout_symbol["text-padding"]),"text-keep-upright":new Sn(Dt.layout_symbol["text-keep-upright"]),"text-transform":new Rc(Dt.layout_symbol["text-transform"]),"text-offset":new Rc(Dt.layout_symbol["text-offset"]),"text-allow-overlap":new Sn(Dt.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new Sn(Dt.layout_symbol["text-ignore-placement"]),"text-optional":new Sn(Dt.layout_symbol["text-optional"])});var Lc={paint:new kn({"icon-opacity":new Rc(Dt.paint_symbol["icon-opacity"]),"icon-color":new Rc(Dt.paint_symbol["icon-color"]),"icon-halo-color":new Rc(Dt.paint_symbol["icon-halo-color"]),"icon-halo-width":new Rc(Dt.paint_symbol["icon-halo-width"]),"icon-halo-blur":new Rc(Dt.paint_symbol["icon-halo-blur"]),"icon-translate":new Sn(Dt.paint_symbol["icon-translate"]),"icon-translate-anchor":new Sn(Dt.paint_symbol["icon-translate-anchor"]),"text-opacity":new Rc(Dt.paint_symbol["text-opacity"]),"text-color":new Rc(Dt.paint_symbol["text-color"],{runtimeType:Yt,getOverride:function(t){return t.textColor},hasOverride:function(t){return!!t.textColor}}),"text-halo-color":new Rc(Dt.paint_symbol["text-halo-color"]),"text-halo-width":new Rc(Dt.paint_symbol["text-halo-width"]),"text-halo-blur":new Rc(Dt.paint_symbol["text-halo-blur"]),"text-translate":new Sn(Dt.paint_symbol["text-translate"]),"text-translate-anchor":new Sn(Dt.paint_symbol["text-translate-anchor"])}),layout:Cn};Mc.prototype.evaluate=function(t){if(t.formattedSection){var e=this.defaultValue.property.overrides;if(e&&e.hasOverride(t.formattedSection))return e.getOverride(t.formattedSection)}return t.feature&&t.featureState?this.defaultValue.evaluate(t.feature,t.featureState):this.defaultValue.property.specification.default},Mc.prototype.eachChild=function(t){this.defaultValue.isConstant()||t(this.defaultValue.value._styleExpression.expression)},Mc.prototype.outputDefined=function(){return!1},Mc.prototype.serialize=function(){return null},Wr("FormatSectionOverride",Mc,{omit:["defaultValue"]});var Oc,Rc=((Oc=Mn)&&(zc.__proto__=Oc),((zc.prototype=Object.create(Oc&&Oc.prototype)).constructor=zc).prototype.recalculate=function(t,e){if(Oc.prototype.recalculate.call(this,t,e),"auto"===this.layout.get("icon-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["icon-rotation-alignment"]="map":this.layout._values["icon-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["text-rotation-alignment"]="map":this.layout._values["text-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment")),"point"===this.layout.get("symbol-placement"))if(e=this.layout.get("text-writing-mode")){for(var i=[],r=0,n=e;r<n.length;r+=1){var o=n[r];i.indexOf(o)<0&&i.push(o)}this.layout._values["text-writing-mode"]=i}else this.layout._values["text-writing-mode"]=["horizontal"];this._setPaintOverrides()},zc.prototype.getValueAndResolveTokens=function(t,e,i,r){var n;r=this.layout.get(t).evaluate(e,{},i,r);return(t=this._unevaluatedLayout._values[t]).isDataDriven()||$i(t.value)||!r?r:(n=e.properties,r.replace(/{([^{}]+)}/g,function(t,e){return e in n?String(n[e]):""}))},zc.prototype.createBucket=function(t){return new Pc(t)},zc.prototype.queryRadius=function(){return 0},zc.prototype.queryIntersectsFeature=function(){return!1},zc.prototype._setPaintOverrides=function(){for(var t=0,e=Lc.paint.overridableProperties;t<e.length;t+=1){var i,r,n,o=e[t];zc.hasPaintOverride(this.layout,o)&&(n=new Mc(i=this.paint.get(o)),r=new Qi(n,i.property.specification),n=null,n="constant"===i.value.kind||"source"===i.value.kind?new er("source",r):new ir("composite",r,i.value.zoomStops,i.value._interpolationType),this.paint._values[o]=new bn(i.property,n,i.parameters))}},zc.prototype._handleOverridablePaintPropertyUpdate=function(t,e,i){return!(!this.layout||e.isDataDriven()||i.isDataDriven())&&zc.hasPaintOverride(this.layout,t)},zc.hasPaintOverride=function(t,e){function i(t){for(var e=0,i=t;e<i.length;e+=1){var r=i[e];if(n.overrides&&n.overrides.hasOverride(r))return o=!0,0}}t=t.get("text-field");var r,n=Lc.paint.properties[e],o=!1;return"constant"===t.value.kind&&t.value.value instanceof he?i(t.value.value.sections):"source"===t.value.kind&&(r=function(t){o||(t instanceof ve&&ye(t.value)===te?i(t.value.sections):t instanceof we?i(t.sections):t.eachChild(r))},(t=t.value)._styleExpression&&r(t._styleExpression.expression)),o},zc);function zc(t){Oc.call(this,t,Lc)}var Dc,Nc={paint:new kn({"background-color":new Sn(Dt.paint_background["background-color"]),"background-pattern":new jc(Dt.paint_background["background-pattern"]),"background-opacity":new Sn(Dt.paint_background["background-opacity"])})};(Dc=Mn)&&(Bc.__proto__=Dc),Cn=(Bc.prototype=Object.create(Dc&&Dc.prototype)).constructor=Bc;function Bc(t){Dc.call(this,t,Nc)}var Fc,Uc={paint:new kn({"raster-opacity":new Sn(Dt.paint_raster["raster-opacity"]),"raster-hue-rotate":new Sn(Dt.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new Sn(Dt.paint_raster["raster-brightness-min"]),"raster-brightness-max":new Sn(Dt.paint_raster["raster-brightness-max"]),"raster-saturation":new Sn(Dt.paint_raster["raster-saturation"]),"raster-contrast":new Sn(Dt.paint_raster["raster-contrast"]),"raster-resampling":new Sn(Dt.paint_raster["raster-resampling"]),"raster-fade-duration":new Sn(Dt.paint_raster["raster-fade-duration"])})},jc=((Fc=Mn)&&(Vc.__proto__=Fc),(Vc.prototype=Object.create(Fc&&Fc.prototype)).constructor=Vc);function Vc(t){Fc.call(this,t,Uc)}var qc,Hc=((qc=Mn)&&(Gc.__proto__=qc),((Gc.prototype=Object.create(qc&&qc.prototype)).constructor=Gc).prototype.is3D=function(){return"3d"===this.implementation.renderingMode},Gc.prototype.hasOffscreenPass=function(){return void 0!==this.implementation.prerender},Gc.prototype.recalculate=function(){},Gc.prototype.updateTransitions=function(){},Gc.prototype.hasTransition=function(){},Gc.prototype.serialize=function(){},Gc.prototype.onAdd=function(t){this.implementation.onAdd&&this.implementation.onAdd(t,t.painter.context.gl)},Gc.prototype.onRemove=function(t){this.implementation.onRemove&&this.implementation.onRemove(t,t.painter.context.gl)},Gc);function Gc(t){qc.call(this,t,{}),this.implementation=t}var Zc={circle:R,heatmap:Rn,hillshade:Vs,fill:ki,"fill-extrusion":Ai,line:va,symbol:Rc,background:Cn,raster:jc};function Wc(t,e,i,r){this.context=t,this.format=i,this.texture=t.gl.createTexture(),this.update(e,r)}var Kc=s.HTMLImageElement,Xc=s.HTMLCanvasElement,Yc=s.HTMLVideoElement,Jc=s.ImageData,Qc=s.ImageBitmap;function $c(t){var e=this;this._callback=t,this._triggered=!1,"undefined"!=typeof MessageChannel&&(this._channel=new MessageChannel,this._channel.port2.onmessage=function(){e._triggered=!1,e._callback()})}function tp(t,e,i){return[t*(i=2*Math.PI*6378137/256/Math.pow(2,i))-2*Math.PI*6378137/2,e*i-2*Math.PI*6378137/2]}function ep(t,e){t&&(e?this.setSouthWest(t).setNorthEast(e):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]))}Wc.prototype.update=function(t,e,i){var r=t.width,n=t.height,o=!(this.size&&this.size[0]===r&&this.size[1]===n||i),a=this.context,s=a.gl;this.useMipmap=Boolean(e&&e.useMipmap),s.bindTexture(s.TEXTURE_2D,this.texture),a.pixelStoreUnpackFlipY.set(!1),a.pixelStoreUnpack.set(1),a.pixelStoreUnpackPremultiplyAlpha.set(this.format===s.RGBA&&(!e||!1!==e.premultiply)),o?(this.size=[r,n],t instanceof Kc||t instanceof Xc||t instanceof Yc||t instanceof Jc||Qc&&t instanceof Qc?s.texImage2D(s.TEXTURE_2D,0,this.format,this.format,s.UNSIGNED_BYTE,t):s.texImage2D(s.TEXTURE_2D,0,this.format,r,n,0,this.format,s.UNSIGNED_BYTE,t.data)):(i=(o=i||{x:0,y:0}).x,o=o.y,t instanceof Kc||t instanceof Xc||t instanceof Yc||t instanceof Jc||Qc&&t instanceof Qc?s.texSubImage2D(s.TEXTURE_2D,0,i,o,s.RGBA,s.UNSIGNED_BYTE,t):s.texSubImage2D(s.TEXTURE_2D,0,i,o,r,n,s.RGBA,s.UNSIGNED_BYTE,t.data)),this.useMipmap&&this.isSizePowerOfTwo()&&s.generateMipmap(s.TEXTURE_2D)},Wc.prototype.bind=function(t,e,i){var r=this.context.gl;r.bindTexture(r.TEXTURE_2D,this.texture),i!==r.LINEAR_MIPMAP_NEAREST||this.isSizePowerOfTwo()||(i=r.LINEAR),t!==this.filter&&(r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MAG_FILTER,t),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,i||t),this.filter=t),e!==this.wrap&&(r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,e),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,e),this.wrap=e)},Wc.prototype.isSizePowerOfTwo=function(){return this.size[0]===this.size[1]&&Math.log(this.size[0])/Math.LN2%1==0},Wc.prototype.destroy=function(){this.context.gl.deleteTexture(this.texture),this.texture=null},$c.prototype.trigger=function(){var t=this;this._triggered||(this._triggered=!0,this._channel?this._channel.port1.postMessage(!0):setTimeout(function(){t._triggered=!1,t._callback()},0))},$c.prototype.remove=function(){delete this._channel,this._callback=function(){}},(ki=function(t,e,i){this.target=t,this.parent=e,this.mapId=i,this.callbacks={},this.tasks={},this.taskQueue=[],this.cancelCallbacks={},g(["receive","process"],this),this.invoker=new $c(this.process),this.target.addEventListener("message",this.receive,!1),this.globalScope=C()?t:s}).prototype.send=function(t,e,i,r,n){var o=this;void 0===n&&(n=!1);var a=Math.round(1e18*Math.random()).toString(36).substring(0,10);i&&(this.callbacks[a]=i);var s=k(this.globalScope)?void 0:[];return this.target.postMessage({id:a,type:t,hasCallback:!!i,targetMapId:r,mustQueue:n,sourceMapId:this.mapId,data:Yr(e,s)},s),{cancel:function(){i&&delete o.callbacks[a],o.target.postMessage({id:a,type:"<cancel>",targetMapId:r,sourceMapId:o.mapId})}}},ki.prototype.receive=function(t){var e=t.data,i=e.id;i&&(e.targetMapId&&this.mapId!==e.targetMapId||("<cancel>"===e.type?(delete this.tasks[i],t=this.cancelCallbacks[i],delete this.cancelCallbacks[i],t&&t()):C()||e.mustQueue?(this.tasks[i]=e,this.taskQueue.push(i),this.invoker.trigger()):this.processTask(i,e)))},ki.prototype.process=function(){var t,e;this.taskQueue.length&&(t=this.taskQueue.shift(),e=this.tasks[t],delete this.tasks[t],this.taskQueue.length&&this.invoker.trigger(),e&&this.processTask(t,e))},ki.prototype.processTask=function(t,e){var i,r,n,o,a,s,l=this;"<response>"===e.type?(a=this.callbacks[t],delete this.callbacks[t],a&&(e.error?a(Jr(e.error)):a(null,Jr(e.data)))):(i=!1,r=k(this.globalScope)?void 0:[],n=e.hasCallback?function(e,n){i=!0,delete l.cancelCallbacks[t],l.target.postMessage({id:t,type:"<response>",sourceMapId:l.mapId,error:e?Yr(e):null,data:Yr(n,r)},r)}:function(t){i=!0},s=null,o=Jr(e.data),this.parent[e.type]?s=this.parent[e.type](e.sourceMapId,o,n):this.parent.getWorkerSource?(a=e.type.split("."),s=this.parent.getWorkerSource(e.sourceMapId,a[0],o.source)[a[1]](o,n)):n(new Error("Could not find function "+e.type)),!i&&s&&s.cancel&&(this.cancelCallbacks[t]=s.cancel))},ki.prototype.remove=function(){this.invoker.remove(),this.target.removeEventListener("message",this.receive,!1)},ep.prototype.setNorthEast=function(t){return this._ne=t instanceof rp?new rp(t.lng,t.lat):rp.convert(t),this},ep.prototype.setSouthWest=function(t){return this._sw=t instanceof rp?new rp(t.lng,t.lat):rp.convert(t),this},ep.prototype.extend=function(t){var e,i,r=this._sw,n=this._ne;if(t instanceof rp)i=e=t;else{if(!(t instanceof ep))return Array.isArray(t)?4===t.length||t.every(Array.isArray)?this.extend(ep.convert(t)):this.extend(rp.convert(t)):this;if(e=t._sw,i=t._ne,!e||!i)return this}return r||n?(r.lng=Math.min(e.lng,r.lng),r.lat=Math.min(e.lat,r.lat),n.lng=Math.max(i.lng,n.lng),n.lat=Math.max(i.lat,n.lat)):(this._sw=new rp(e.lng,e.lat),this._ne=new rp(i.lng,i.lat)),this},ep.prototype.getCenter=function(){return new rp((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)},ep.prototype.getSouthWest=function(){return this._sw},ep.prototype.getNorthEast=function(){return this._ne},ep.prototype.getNorthWest=function(){return new rp(this.getWest(),this.getNorth())},ep.prototype.getSouthEast=function(){return new rp(this.getEast(),this.getSouth())},ep.prototype.getWest=function(){return this._sw.lng},ep.prototype.getSouth=function(){return this._sw.lat},ep.prototype.getEast=function(){return this._ne.lng},ep.prototype.getNorth=function(){return this._ne.lat},ep.prototype.toArray=function(){return[this._sw.toArray(),this._ne.toArray()]},ep.prototype.toString=function(){return"LngLatBounds("+this._sw.toString()+", "+this._ne.toString()+")"},ep.prototype.isEmpty=function(){return!(this._sw&&this._ne)},ep.prototype.contains=function(t){var e=(i=rp.convert(t)).lng,i=(t=i.lat,this._sw.lat<=t&&t<=this._ne.lat);t=this._sw.lng<=e&&e<=this._ne.lng;return this._sw.lng>this._ne.lng&&(t=this._sw.lng>=e&&e>=this._ne.lng),i&&t},ep.convert=function(t){return!t||t instanceof ep?t:new ep(t)};var ip=6371008.8,rp=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid LngLat object: ("+t+", "+e+")");if(this.lng=+t,this.lat=+e,90<this.lat||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")};rp.prototype.wrap=function(){return new rp(h(this.lng,-180,180),this.lat)},rp.prototype.toArray=function(){return[this.lng,this.lat]},rp.prototype.toString=function(){return"LngLat("+this.lng+", "+this.lat+")"},rp.prototype.distanceTo=function(t){var e=Math.PI/180,i=this.lat*e,r=t.lat*e;e=Math.sin(i)*Math.sin(r)+Math.cos(i)*Math.cos(r)*Math.cos((t.lng-this.lng)*e);return ip*Math.acos(Math.min(e,1))},rp.prototype.toBounds=function(t){var e=360*(t=void 0===t?0:t)/40075017;t=e/Math.cos(Math.PI/180*this.lat);return new ep(new rp(this.lng-t,this.lat-e),new rp(this.lng+t,this.lat+e))},rp.convert=function(t){if(t instanceof rp)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new rp(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new rp(Number("lng"in t?t.lng:t.lon),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")};var np=2*Math.PI*ip;function op(t){return np*Math.cos(t*Math.PI/180)}function ap(t){return(180+t)/360}function sp(t){return(180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))/360}function lp(t,e){return t/op(e)}function up(t){return 360/Math.PI*Math.atan(Math.exp((180-360*t)*Math.PI/180))-90}function cp(t,e,i){void 0===i&&(i=0),this.x=+t,this.y=+e,this.z=+i}function pp(t,e,i){this.z=t,this.x=e,this.y=i,this.key=fp(0,t,t,e,i)}function hp(t,e){this.wrap=t,this.canonical=e,this.key=fp(t,e.z,e.z,e.x,e.y)}function dp(t,e,i,r,n){this.overscaledZ=t,this.wrap=e,this.canonical=new pp(i,+r,+n),this.key=fp(e,t,i,r,n)}function fp(t,e,i,r,n){var o=1<<i;return(o*o*(t=(t*=2)<0?-1*t-1:t)+o*n+r).toString(36)+i.toString(36)+e.toString(36)}function mp(t){this._stringToNumber={},this._numberToString=[];for(var e=0;e<t.length;e++){var i=t[e];this._stringToNumber[i]=e,this._numberToString[e]=i}}function yp(t,e,i,r,n){this.type="Feature",(this._vectorTileFeature=t)._z=e,t._x=i,t._y=r,this.properties=t.properties,this.id=n}function gp(t,e,i,r,n){return _(t,function(t,o){return(o=e instanceof wn?e.get(o):null)&&o.evaluate?o.evaluate(i,r,n):o})}function vp(t){for(var e=1/0,i=1/0,r=-1/0,n=-1/0,o=0,a=t;o<a.length;o+=1){var s=a[o];e=Math.min(e,s.x),i=Math.min(i,s.y),r=Math.max(r,s.x),n=Math.max(n,s.y)}return{minX:e,minY:i,maxX:r,maxY:n}}function _p(t,e){return e-t}cp.fromLngLat=function(t,e){return void 0===e&&(e=0),new cp(ap((t=rp.convert(t)).lng),sp(t.lat),lp(e,t.lat))},cp.prototype.toLngLat=function(){return new rp(360*this.x-180,up(this.y))},cp.prototype.toAltitude=function(){return this.z*op(up(this.y))},cp.prototype.meterInMercatorCoordinateUnits=function(){return 1/np*(t=up(this.y),1/Math.cos(t*Math.PI/180));var t},pp.prototype.equals=function(t){return this.z===t.z&&this.x===t.x&&this.y===t.y},pp.prototype.url=function(t,e){var i,r,n=(i=this.x,r=this.y,o=this.z,n=tp(256*i,256*(r=Math.pow(2,o)-r-1),o),o=tp(256*(i+1),256*(r+1),o),n[0]+","+n[1]+","+o[0]+","+o[1]),o=function(t,e,i){for(var r,n="",o=t;0<o;o--)n+=(e&(r=1<<o-1)?1:0)+(i&r?2:0);return n}(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace("{z}",String(this.z)).replace("{x}",String(this.x)).replace("{y}",String("tms"===e?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",o).replace("{bbox-epsg-3857}",n)},pp.prototype.getTilePoint=function(t){var e=Math.pow(2,this.z);return new o((t.x*e-this.x)*Ja,(t.y*e-this.y)*Ja)},pp.prototype.toString=function(){return this.z+"/"+this.x+"/"+this.y},dp.prototype.equals=function(t){return this.overscaledZ===t.overscaledZ&&this.wrap===t.wrap&&this.canonical.equals(t.canonical)},dp.prototype.scaledTo=function(t){var e=this.canonical.z-t;return t>this.canonical.z?new dp(t,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new dp(t,this.wrap,t,this.canonical.x>>e,this.canonical.y>>e)},dp.prototype.calculateScaledKey=function(t,e){var i=this.canonical.z-t;return t>this.canonical.z?fp(this.wrap*+e,t,this.canonical.z,this.canonical.x,this.canonical.y):fp(this.wrap*+e,t,t,this.canonical.x>>i,this.canonical.y>>i)},dp.prototype.isChildOf=function(t){if(t.wrap!==this.wrap)return!1;var e=this.canonical.z-t.canonical.z;return 0===t.overscaledZ||t.overscaledZ<this.overscaledZ&&t.canonical.x===this.canonical.x>>e&&t.canonical.y===this.canonical.y>>e},dp.prototype.children=function(t){if(this.overscaledZ>=t)return[new dp(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];var e=this.canonical.z+1,i=2*this.canonical.x;t=2*this.canonical.y;return[new dp(e,this.wrap,e,i,t),new dp(e,this.wrap,e,1+i,t),new dp(e,this.wrap,e,i,1+t),new dp(e,this.wrap,e,1+i,1+t)]},dp.prototype.isLessThan=function(t){return this.wrap<t.wrap||!(this.wrap>t.wrap)&&(this.overscaledZ<t.overscaledZ||!(this.overscaledZ>t.overscaledZ)&&(this.canonical.x<t.canonical.x||!(this.canonical.x>t.canonical.x)&&this.canonical.y<t.canonical.y))},dp.prototype.wrapped=function(){return new dp(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)},dp.prototype.unwrapTo=function(t){return new dp(this.overscaledZ,t,this.canonical.z,this.canonical.x,this.canonical.y)},dp.prototype.overscaleFactor=function(){return Math.pow(2,this.overscaledZ-this.canonical.z)},dp.prototype.toUnwrapped=function(){return new hp(this.wrap,this.canonical)},dp.prototype.toString=function(){return this.overscaledZ+"/"+this.canonical.x+"/"+this.canonical.y},dp.prototype.getTilePoint=function(t){return this.canonical.getTilePoint(new cp(t.x-this.wrap,t.y))},Wr("CanonicalTileID",pp),Wr("OverscaledTileID",dp,{omit:["posMatrix"]}),(Ai=function(t,e,i){if(this.uid=t,e.height!==e.width)throw new RangeError("DEM tiles must be square");if(i&&"mapbox"!==i&&"terrarium"!==i)return S('"'+i+'" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');this.stride=e.height;var r=this.dim=e.height-2;this.data=new Uint32Array(e.data.buffer),this.encoding=i||"mapbox";for(var n=0;n<r;n++)this.data[this._idx(-1,n)]=this.data[this._idx(0,n)],this.data[this._idx(r,n)]=this.data[this._idx(r-1,n)],this.data[this._idx(n,-1)]=this.data[this._idx(n,0)],this.data[this._idx(n,r)]=this.data[this._idx(n,r-1)];this.data[this._idx(-1,-1)]=this.data[this._idx(0,0)],this.data[this._idx(r,-1)]=this.data[this._idx(r-1,0)],this.data[this._idx(-1,r)]=this.data[this._idx(0,r-1)],this.data[this._idx(r,r)]=this.data[this._idx(r-1,r-1)]}).prototype.get=function(t,e){var i=new Uint8Array(this.data.buffer);e=4*this._idx(t,e);return("terrarium"===this.encoding?this._unpackTerrarium:this._unpackMapbox)(i[e],i[1+e],i[2+e])},Ai.prototype.getUnpackVector=function(){return"terrarium"===this.encoding?[256,1,1/256,32768]:[6553.6,25.6,.1,1e4]},Ai.prototype._idx=function(t,e){if(t<-1||t>=this.dim+1||e<-1||e>=this.dim+1)throw new RangeError("out of range source coordinates for DEM data");return(e+1)*this.stride+(t+1)},Ai.prototype._unpackMapbox=function(t,e,i){return(256*t*256+256*e+i)/10-1e4},Ai.prototype._unpackTerrarium=function(t,e,i){return 256*t+e+i/256-32768},Ai.prototype.getPixels=function(){return new zs({width:this.stride,height:this.stride},new Uint8Array(this.data.buffer))},Ai.prototype.backfillBorder=function(t,e,i){if(this.dim!==t.dim)throw new Error("dem dimension mismatch");var r=e*this.dim,n=e*this.dim+this.dim,o=i*this.dim,a=i*this.dim+this.dim;switch(e){case-1:r=n-1;break;case 1:n=r+1}switch(i){case-1:o=a-1;break;case 1:a=o+1}for(var s=-e*this.dim,l=-i*this.dim,u=o;u<a;u++)for(var c=r;c<n;c++)this.data[this._idx(c,u)]=t.data[this._idx(c+s,u+l)]},Wr("DEMData",Ai),mp.prototype.encode=function(t){return this._stringToNumber[t]},mp.prototype.decode=function(t){return this._numberToString[t]},(va={geometry:{configurable:!0}}).geometry.get=function(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x,this._vectorTileFeature._y,this._vectorTileFeature._z).geometry),this._geometry},va.geometry.set=function(t){this._geometry=t},yp.prototype.toJSON=function(){var t,e={geometry:this.geometry};for(t in this)"_geometry"!==t&&"_vectorTileFeature"!==t&&(e[t]=this[t]);return e},Object.defineProperties(yp.prototype,va),(Rc=function(){this.state={},this.stateChanges={},this.deletedStates={}}).prototype.updateState=function(t,e,i){var r=String(e);if(this.stateChanges[t]=this.stateChanges[t]||{},this.stateChanges[t][r]=this.stateChanges[t][r]||{},d(this.stateChanges[t][r],i),null===this.deletedStates[t])for(var n in this.deletedStates[t]={},this.state[t])n!==r&&(this.deletedStates[t][n]=null);else if(this.deletedStates[t]&&null===this.deletedStates[t][r])for(var o in this.deletedStates[t][r]={},this.state[t][r])i[o]||(this.deletedStates[t][r][o]=null);else for(var a in i)this.deletedStates[t]&&this.deletedStates[t][r]&&null===this.deletedStates[t][r][a]&&delete this.deletedStates[t][r][a]},Rc.prototype.removeFeatureState=function(t,e,i){if(null!==this.deletedStates[t]){var r=String(e);if(this.deletedStates[t]=this.deletedStates[t]||{},i&&void 0!==e)null!==this.deletedStates[t][r]&&(this.deletedStates[t][r]=this.deletedStates[t][r]||{},this.deletedStates[t][r][i]=null);else if(void 0!==e)if(this.stateChanges[t]&&this.stateChanges[t][r])for(i in this.deletedStates[t][r]={},this.stateChanges[t][r])this.deletedStates[t][r][i]=null;else this.deletedStates[t][r]=null;else this.deletedStates[t]=null}},Rc.prototype.getState=function(t,e){var i=String(e),r=this.state[t]||{},n=this.stateChanges[t]||{},o=d({},r[i],n[i]);if(null===this.deletedStates[t])return{};if(this.deletedStates[t]){var a;if(null===(e=this.deletedStates[t][e]))return{};for(a in e)delete o[a]}return o},Rc.prototype.initializeTileState=function(t,e){t.setFeatureState(this.state,e)},Rc.prototype.coalesceChanges=function(t,e){var i,r,n={};for(i in this.stateChanges){this.state[i]=this.state[i]||{};var o,a={};for(o in this.stateChanges[i])this.state[i][o]||(this.state[i][o]={}),d(this.state[i][o],this.stateChanges[i][o]),a[o]=this.state[i][o];n[i]=a}for(r in this.deletedStates){this.state[r]=this.state[r]||{};var s={};if(null===this.deletedStates[r])for(var l in this.state[r])s[l]={},this.state[r][l]={};else for(var u in this.deletedStates[r]){if(null===this.deletedStates[r][u])this.state[r][u]={};else for(var c=0,p=Object.keys(this.deletedStates[r][u]);c<p.length;c+=1){var h=p[c];delete this.state[r][u][h]}s[u]=this.state[r][u]}n[r]=n[r]||{},d(n[r],s)}if(this.stateChanges={},this.deletedStates={},0!==Object.keys(n).length)for(var f in t)t[f].setFeatureState(n,e)},(Cn=function(t,e){this.tileID=t,this.x=t.canonical.x,this.y=t.canonical.y,this.z=t.canonical.z,this.grid=new Ur(Ja,16,0),this.grid3D=new Ur(Ja,16,0),this.featureIndexArray=new ha,this.promoteId=e}).prototype.insert=function(t,e,i,r,n,o){var a=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(i,r,n);for(var s=o?this.grid3D:this.grid,l=0;l<e.length;l++){for(var u=e[l],c=[1/0,1/0,-1/0,-1/0],p=0;p<u.length;p++){var h=u[p];c[0]=Math.min(c[0],h.x),c[1]=Math.min(c[1],h.y),c[2]=Math.max(c[2],h.x),c[3]=Math.max(c[3],h.y)}c[0]<Ja&&c[1]<Ja&&0<=c[2]&&0<=c[3]&&s.insert(a,c[0],c[1],c[2],c[3])}},Cn.prototype.loadVTLayers=function(){return this.vtLayers||(this.vtLayers=new kl.VectorTile(new au(this.rawTileData)).layers,this.sourceLayerCoder=new mp(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"])),this.vtLayers},Cn.prototype.query=function(t,e,i,r){var n=this;this.loadVTLayers();for(var a=t.params||{},s=Ja/t.tileSize/t.scale,l=dr(a.filter),u=t.queryGeometry,c=t.queryPadding*s,p=vp(u),h=this.grid.query(p.minX-c,p.minY-c,p.maxX+c,p.maxY+c),d=(p=vp(t.cameraQueryGeometry),0),f=this.grid3D.query(p.minX-c,p.minY-c,p.maxX+c,p.maxY+c,function(e,i,r,n){return function(t,e,i,r,n){for(var a=0,s=t;a<s.length;a+=1){var l=s[a];if(e<=l.x&&i<=l.y&&r>=l.x&&n>=l.y)return!0}var u=[new o(e,i),new o(e,n),new o(r,n),new o(r,i)];if(2<t.length)for(var c=0,p=u;c<p.length;c+=1)if(cs(t,p[c]))return!0;for(var h=0;h<t.length-1;h++)if(function(t,e,i){var r=i[0],n=i[2];return!(t.x<r.x&&e.x<r.x||t.x>n.x&&e.x>n.x||t.y<r.y&&e.y<r.y||t.y>n.y&&e.y>n.y||(n=T(t,e,i[0]))===T(t,e,i[1])&&n===T(t,e,i[2])&&n===T(t,e,i[3]))}(t[h],t[h+1],u))return!0;return!1}(t.cameraQueryGeometry,e-c,i-c,r+c,n+c)});d<f.length;d+=1){var m=f[d];h.push(m)}h.sort(_p);for(var y,g={},v=0;v<h.length;v++)!function(o){var c;(o=h[o])!==y&&(y=o,o=n.featureIndexArray.get(o),c=null,n.loadMatchingFeature(g,o.bucketIndex,o.sourceLayerIndex,o.featureIndex,l,a.layers,a.availableImages,e,i,r,function(e,i,r){return c=c||ts(e),i.queryIntersectsFeature(u,e,r,c,n.z,t.transform,s,t.pixelPosMatrix)}))}(v);return g},Cn.prototype.loadMatchingFeature=function(t,e,i,r,n,o,a,s,l,u,c){var p=this.bucketLayerIDs[e];if(!o||function(t,e){for(var i=0;i<t.length;i++)if(0<=e.indexOf(t[i]))return 1}(o,p)){e=this.sourceLayerCoder.decode(i);var h=this.vtLayers[e].feature(r);if(n.needGeometry){if(i=es(h,!0),!n.filter(new hn(this.tileID.overscaledZ),i,this.tileID.canonical))return}else if(!n.filter(new hn(this.tileID.overscaledZ),h))return;for(var f=this.getId(h,e),m=0;m<p.length;m++){var y,g,v,_=p[m];o&&o.indexOf(_)<0||(y=s[_])&&(g={},void 0!==f&&u&&(g=u.getState(y.sourceLayer||"_geojsonTileLayer",f)),(v=d({},l[_])).paint=gp(v.paint,y.paint,h,g,a),v.layout=gp(v.layout,y.layout,h,g,a),(y=!c||c(h,y,g))&&((g=new yp(h,this.z,this.x,this.y,f)).layer=v,(v=void 0===(v=t[_])?t[_]=[]:v).push({featureIndex:r,feature:g,intersectionZ:y})))}}},Cn.prototype.lookupSymbolFeatures=function(t,e,i,r,n,o,a,s){var l={};this.loadVTLayers();for(var u=dr(n),c=0,p=t;c<p.length;c+=1){var h=p[c];this.loadMatchingFeature(l,i,r,h,u,o,a,s,e)}return l},Cn.prototype.hasLayer=function(t){for(var e=0,i=this.bucketLayerIDs;e<i.length;e+=1)for(var r=0,n=i[e];r<n.length;r+=1)if(t===n[r])return!0;return!1},Cn.prototype.getId=function(t,e){var i=t.id;return this.promoteId&&(e="string"==typeof this.promoteId?this.promoteId:this.promoteId[e],"boolean"==typeof(i=t.properties[e])&&(i=Number(i))),i},Wr("FeatureIndex",Cn,{omit:["rawTileData","sourceLayerCoder"]}),(jc=function(t,e){this.tileID=t,this.uid=f++,this.uses=0,this.tileSize=e,this.buckets={},this.expirationTime=null,this.queryPadding=0,this.hasSymbolBuckets=!1,this.hasRTLText=!1,this.dependencies={},this.expiredRequestCount=0,this.state="loading"}).prototype.registerFadeDuration=function(t){(t+=this.timeAdded)<N.now()||this.fadeEndTime&&t<this.fadeEndTime||(this.fadeEndTime=t)},jc.prototype.wasRequested=function(){return"errored"===this.state||"loaded"===this.state||"reloading"===this.state},jc.prototype.loadVectorData=function(t,e,i){if(this.hasData()&&this.unloadVectorData(),this.state="loaded",t){for(var r in t.featureIndex&&(this.latestFeatureIndex=t.featureIndex,t.rawTileData?(this.latestRawTileData=t.rawTileData,this.latestFeatureIndex.rawTileData=t.rawTileData):this.latestRawTileData&&(this.latestFeatureIndex.rawTileData=this.latestRawTileData)),this.collisionBoxArray=t.collisionBoxArray,this.buckets=function(t,e){var i={};if(!e)return i;for(var r=0,n=t;r<n.length;r+=1)!function(){var t=n[r],o=t.layerIds.map(function(t){return e.getLayer(t)}).filter(Boolean);if(0!==o.length){t.layers=o,t.stateDependentLayerIds&&(t.stateDependentLayers=t.stateDependentLayerIds.map(function(t){return o.filter(function(e){return e.id===t})[0]}));for(var a=0,s=o;a<s.length;a+=1){var l=s[a];i[l.id]=t}}}();return i}(t.buckets,e.style),this.hasSymbolBuckets=!1,this.buckets)if((r=this.buckets[r])instanceof Pc){if(this.hasSymbolBuckets=!0,!i)break;r.justReloaded=!0}if(this.hasRTLText=!1,this.hasSymbolBuckets)for(var n in this.buckets)if((n=this.buckets[n])instanceof Pc&&n.hasRTLText){this.hasRTLText=!0,fn.isLoading()||fn.isLoaded()||"deferred"!==sn||pn();break}for(var o in this.queryPadding=0,this.buckets){var a=this.buckets[o];this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(o).queryRadius(a))}t.imageAtlas&&(this.imageAtlas=t.imageAtlas),t.glyphAtlasImage&&(this.glyphAtlasImage=t.glyphAtlasImage)}else this.collisionBoxArray=new Ko},jc.prototype.unloadVectorData=function(){for(var t in this.buckets)this.buckets[t].destroy();this.buckets={},this.imageAtlasTexture&&this.imageAtlasTexture.destroy(),this.imageAtlas&&(this.imageAtlas=null),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.latestFeatureIndex=null,this.state="unloaded"},jc.prototype.getBucket=function(t){return this.buckets[t.id]},jc.prototype.upload=function(t){for(var e in this.buckets)(e=this.buckets[e]).uploadPending()&&e.upload(t);var i=t.gl;this.imageAtlas&&!this.imageAtlas.uploaded&&(this.imageAtlasTexture=new Wc(t,this.imageAtlas.image,i.RGBA),this.imageAtlas.uploaded=!0),this.glyphAtlasImage&&(this.glyphAtlasTexture=new Wc(t,this.glyphAtlasImage,i.ALPHA),this.glyphAtlasImage=null)},jc.prototype.prepare=function(t){this.imageAtlas&&this.imageAtlas.patchUpdatedImages(t,this.imageAtlasTexture)},jc.prototype.queryRenderedFeatures=function(t,e,i,r,n,o,a,s,l,u){return this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData?this.latestFeatureIndex.query({queryGeometry:r,cameraQueryGeometry:n,scale:o,tileSize:this.tileSize,pixelPosMatrix:u,transform:s,params:a,queryPadding:this.queryPadding*l},t,e,i):{}},jc.prototype.querySourceFeatures=function(t,e){var i=this.latestFeatureIndex;if(i&&i.rawTileData){var r=i.loadVTLayers(),n=e?e.sourceLayer:"",o=r._geojsonTileLayer||r[n];if(o)for(var a=dr(e&&e.filter),s=(e=this.tileID.canonical).z,l=e.x,u=e.y,c={z:s,x:l,y:u},p=0;p<o.length;p++){var h=o.feature(p);if(a.needGeometry){var d=es(h,!0);if(!a.filter(new hn(this.tileID.overscaledZ),d,this.tileID.canonical))continue}else if(!a.filter(new hn(this.tileID.overscaledZ),h))continue;(d=new yp(h,s,l,u,d=i.getId(h,n))).tile=c,t.push(d)}}},jc.prototype.hasData=function(){return"loaded"===this.state||"reloading"===this.state||"expired"===this.state},jc.prototype.patternsLoaded=function(){return this.imageAtlas&&!!Object.keys(this.imageAtlas.patternPositions).length},jc.prototype.setExpiryData=function(t){var e,i,r=this.expirationTime;t.cacheControl?(e=E(t.cacheControl))["max-age"]&&(this.expirationTime=Date.now()+1e3*e["max-age"]):t.expires&&(this.expirationTime=new Date(t.expires).getTime()),this.expirationTime&&(e=Date.now(),t=!1,this.expirationTime>e?t=!1:!r||this.expirationTime<r||!(i=this.expirationTime-r)?t=!0:this.expirationTime=e+Math.max(i,3e4),t?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0)},jc.prototype.getExpiryTimeout=function(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)},jc.prototype.setFeatureState=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData&&0!==Object.keys(t).length){var i,r,n,o,a=this.latestFeatureIndex.loadVTLayers();for(i in this.buckets)e.style.hasLayer(i)&&(o=a[n=(r=this.buckets[i]).layers[0].sourceLayer||"_geojsonTileLayer"],n=t[n],o&&n&&0!==Object.keys(n).length&&(r.update(n,o,this.imageAtlas&&this.imageAtlas.patternPositions||{}),(o=e&&e.style&&e.style.getLayer(i))&&(this.queryPadding=Math.max(this.queryPadding,o.queryRadius(r)))))}},jc.prototype.holdingForFade=function(){return void 0!==this.symbolFadeHoldUntil},jc.prototype.symbolFadeFinished=function(){return!this.symbolFadeHoldUntil||this.symbolFadeHoldUntil<N.now()},jc.prototype.clearFadeHold=function(){this.symbolFadeHoldUntil=void 0},jc.prototype.setHoldDuration=function(t){this.symbolFadeHoldUntil=N.now()+t},jc.prototype.setDependencies=function(t,e){for(var i={},r=0,n=e;r<n.length;r+=1)i[n[r]]=!0;this.dependencies[t]=i},jc.prototype.hasDependency=function(t,e){for(var i=0,r=t;i<r.length;i+=1){var n=r[i],o=this.dependencies[n];if(o)for(var a=0,s=e;a<s.length;a+=1)if(o[s[a]])return!0}return!1};var xp=s.performance;(va=function(t){this._marks={start:[t.url,"start"].join("#"),end:[t.url,"end"].join("#"),measure:t.url.toString()},xp.mark(this._marks.start)}).prototype.finish=function(){xp.mark(this._marks.end);var t=xp.getEntriesByName(this._marks.measure);return 0===t.length&&(xp.measure(this._marks.measure,this._marks.start,this._marks.end),t=xp.getEntriesByName(this._marks.measure),xp.clearMarks(this._marks.start),xp.clearMarks(this._marks.end),xp.clearMeasures(this._marks.measure)),t},t.Actor=ki,t.AlphaImage=Rs,t.CanonicalTileID=pp,t.CollisionBoxArray=Ko,t.Color=ue,t.DEMData=Ai,t.DataConstantProperty=Sn,t.DictionaryCoder=mp,t.EXTENT=Ja,t.ErrorEvent=Ot,t.EvaluationParameters=hn,t.Event=Lt,t.Evented=zt,t.FeatureIndex=Cn,t.FillBucket=yl,t.FillExtrusionBucket=Ll,t.ImageAtlas=In,t.ImagePosition=Lu,t.LineBucket=Bl,t.LngLat=rp,t.LngLatBounds=ep,t.MercatorCoordinate=cp,t.ONE_EM=ru,t.OverscaledTileID=dp,t.Point=o,t.Point$1=o,t.Properties=kn,t.Protobuf=au,t.RGBAImage=zs,t.RequestManager=H,t.RequestPerformance=va,t.ResourceType=yt,t.SegmentVector=fa,t.SourceFeatureState=Rc,t.StructArrayLayout1ui2=Fo,t.StructArrayLayout2f1f2i16=vo,t.StructArrayLayout2i4=Bn,t.StructArrayLayout3ui6=Eo,t.StructArrayLayout4i8=jn,t.SymbolBucket=Pc,t.Texture=Wc,t.Tile=jc,t.Transitionable=gn,t.Uniform1f=Ia,t.Uniform1i=Mi,t.Uniform2f=Pi,t.Uniform3f=Oi,t.Uniform4f=Ra,t.UniformColor=Na,t.UniformMatrix4f=Li,t.UnwrappedTileID=hp,t.ValidationError=Nt,t.WritingMode=Ru,t.ZoomHistory=Qr,t.add=function(t,e,i){return t[0]=e[0]+i[0],t[1]=e[1]+i[1],t[2]=e[2]+i[2],t},t.addDynamicAttributes=Ec,t.asyncAll=function(t,e,i){if(!t.length)return i(null,[]);var r=t.length,n=new Array(t.length),o=null;t.forEach(function(t,a){e(t,function(t,e){t&&(o=t),n[a]=e,0==--r&&i(o,n)})})},t.bezier=u,t.bindAll=g,t.browser=N,t.cacheEntryPossiblyAdded=function(t){ct<++ft&&(t.getActor().send("enforceCacheSizeLimit",ut),ft=0)},t.clamp=p,t.clearTileCache=function(t){var e=s.caches.delete(lt);t&&e.catch(t).then(function(){return t()})},t.clipLine=oc,t.clone=function(t){var e=new ys(16);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e[4]=t[4],e[5]=t[5],e[6]=t[6],e[7]=t[7],e[8]=t[8],e[9]=t[9],e[10]=t[10],e[11]=t[11],e[12]=t[12],e[13]=t[13],e[14]=t[14],e[15]=t[15],e},t.clone$1=b,t.clone$2=function(t){var e=new ys(3);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e},t.collisionCircleLayout=et,t.config=B,t.create=function(){var t=new ys(16);return ys!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0),t[0]=1,t[5]=1,t[10]=1,t[15]=1,t},t.create$1=function(){var t=new ys(9);return ys!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[5]=0,t[6]=0,t[7]=0),t[0]=1,t[4]=1,t[8]=1,t},t.create$2=function(){var t=new ys(4);return ys!=Float32Array&&(t[1]=0,t[2]=0),t[0]=1,t[3]=1,t},t.createCommonjsModule=e,t.createExpression=tr,t.createLayout=zn,t.createStyleLayer=function(t){return new("custom"===t.type?Hc:Zc[t.type])(t)},t.cross=function(t,e,i){var r=e[0],n=e[1],o=e[2],a=i[0];e=i[1],i=i[2];return t[0]=n*i-o*e,t[1]=o*a-r*i,t[2]=r*e-n*a,t},t.deepEqual=function t(e,i){if(Array.isArray(e)){if(!Array.isArray(i)||e.length!==i.length)return!1;for(var r=0;r<e.length;r++)if(!t(e[r],i[r]))return!1;return!0}if("object"!=typeof e||null===e||null===i)return e===i;if("object"!=typeof i)return!1;if(Object.keys(e).length!==Object.keys(i).length)return!1;for(var n in e)if(!t(e[n],i[n]))return!1;return!0},t.dot=function(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]},t.dot$1=function(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]+t[3]*e[3]},t.ease=c,t.emitValidationErrors=Fr,t.endsWith=v,t.enforceCacheSizeLimit=function(t){pt(),nt&&nt.then(function(e){e.keys().then(function(i){for(var r=0;r<i.length-t;r++)e.delete(i[r])})})},t.evaluateSizeForFeature=Qu,t.evaluateSizeForZoom=$u,t.evaluateVariableOffset=gc,t.evented=dn,t.extend=d,t.featureFilter=dr,t.filterObject=x,t.fromRotation=function(t,e){var i=Math.sin(e);e=Math.cos(e);return t[0]=e,t[1]=i,t[2]=0,t[3]=-i,t[4]=e,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t},t.getAnchorAlignment=Gu,t.getAnchorJustification=vc,t.getArrayBuffer=Tt,t.getImage=function t(e,i){if(F.supported&&(e.headers||(e.headers={}),e.headers.accept="image/webp,*/*"),kt>=B.MAX_PARALLEL_IMAGE_REQUESTS){var r={requestParameters:e,callback:i,cancelled:!1,cancel:function(){this.cancelled=!0}};return It.push(r),r}function n(){if(!o)for(o=!0,kt--;It.length&&kt<B.MAX_PARALLEL_IMAGE_REQUESTS;){var e=It.shift(),i=e.requestParameters,r=e.callback;e.cancelled||(e.cancel=t(i,r).cancel)}}kt++;var o=!1,a=Tt(e,function(t,e,r,o){var a;n(),t?i(t):e&&(mt()?(t=e,a=i,t=new s.Blob([new Uint8Array(e)],{type:"image/png"}),s.createImageBitmap(t).then(function(t){a(null,t)}).catch(function(t){a(new Error("Could not load image because of "+t.message+". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."))})):function(t,e,i,r){var n=new s.Image,o=s.URL;n.onload=function(){e(null,n),o.revokeObjectURL(n.src),n.onload=null,s.requestAnimationFrame(function(){n.src=Et})},n.onerror=function(){return e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."))};var a=new s.Blob([new Uint8Array(t)],{type:"image/png"});n.cacheControl=i,n.expires=r,n.src=t.byteLength?o.createObjectURL(a):Et}(e,i,r,o))});return{cancel:function(){a.cancel(),n()}}},t.getJSON=function(t,e){return St(d(t,{type:"json"}),e)},t.getRTLTextPluginStatus=function(){return sn},t.getReferrer=xt,t.getVideo=function(t,e){var i=s.document.createElement("video");i.muted=!0,i.onloadstart=function(){e(null,i)};for(var r,n,o=0;o<t.length;o++){var a=s.document.createElement("source");r=t[o],n=void 0,(n=s.document.createElement("a")).href=r,n.protocol===s.document.location.protocol&&n.host===s.document.location.host||(i.crossOrigin="Anonymous"),a.src=t[o],i.appendChild(a)}return{cancel:function(){}}},t.identity=gs,t.invert=function(t,e){var i=e[0],r=e[1],n=e[2],o=e[3],a=e[4],s=e[5],l=e[6],u=e[7],c=e[8],p=e[9],h=e[10],d=e[11],f=e[12],m=e[13],y=e[14],g=e[15],v=i*s-r*a,_=i*l-n*a,x=i*u-o*a,b=r*l-n*s,w=r*u-o*s,S=n*u-o*l,T=c*m-p*f,C=c*y-h*f,E=c*g-d*f,I=p*y-h*m,k=p*g-d*m,A=h*g-d*y;return(e=v*A-_*k+x*I+b*E-w*C+S*T)?(t[0]=(s*A-l*k+u*I)*(e=1/e),t[1]=(n*k-r*A-o*I)*e,t[2]=(m*S-y*w+g*b)*e,t[3]=(h*w-p*S-d*b)*e,t[4]=(l*E-a*A-u*C)*e,t[5]=(i*A-n*E+o*C)*e,t[6]=(y*x-f*S-g*_)*e,t[7]=(c*S-h*x+d*_)*e,t[8]=(a*k-s*E+u*T)*e,t[9]=(r*E-i*k-o*T)*e,t[10]=(f*w-m*x+g*v)*e,t[11]=(p*x-c*w-d*v)*e,t[12]=(s*C-a*I-l*T)*e,t[13]=(i*I-r*C+n*T)*e,t[14]=(m*_-f*b-y*v)*e,t[15]=(c*b-p*_+h*v)*e,t):null},t.isChar=$r,t.isMapboxURL=G,t.keysDifference=function(t,e){var i,r=[];for(i in t)i in e||r.push(i);return r},t.makeRequest=St,t.mapObject=_,t.mercatorXfromLng=ap,t.mercatorYfromLat=sp,t.mercatorZfromAltitude=lp,t.mul=po,t.multiply=vs,t.mvt=kl,t.nextPowerOfTwo=function(t){return t<=1?1:Math.pow(2,Math.ceil(Math.log(t)/Math.LN2))},t.normalize=function(t,e){var i=e[0],r=e[1],n=e[2];return 0<(n=i*i+r*r+n*n)&&(n=1/Math.sqrt(n)),t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t},t.number=Je,t.offscreenCanvasSupported=mt,t.ortho=function(t,e,i,r,n,o,a){var s=1/(e-i),l=1/(r-n),u=1/(o-a);return t[0]=-2*s,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*l,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*u,t[11]=0,t[12]=(e+i)*s,t[13]=(n+r)*l,t[14]=(a+o)*u,t[15]=1,t},t.parseGlyphPBF=function(t){return new au(t).readFields(Iu,[])},t.pbf=au,t.performSymbolLayout=function(t,e,i,r,n,o,a){t.createArrays();var s=512*t.overscaling;t.tilePixelRatio=Ja/s,t.compareText={},t.iconsNeedLinear=!1;var l,u,c=t.layers[0].layout,p=(s=t.layers[0]._unevaluatedLayout._values,{});"composite"===t.textSizeData.kind&&(u=(l=t.textSizeData).minZoom,l=l.maxZoom,p.compositeTextSizes=[s["text-size"].possiblyEvaluate(new hn(u),a),s["text-size"].possiblyEvaluate(new hn(l),a)]),"composite"===t.iconSizeData.kind&&(l=(u=t.iconSizeData).minZoom,u=u.maxZoom,p.compositeIconSizes=[s["icon-size"].possiblyEvaluate(new hn(l),a),s["icon-size"].possiblyEvaluate(new hn(u),a)]),p.layoutTextSize=s["text-size"].possiblyEvaluate(new hn(t.zoom+1),a),p.layoutIconSize=s["icon-size"].possiblyEvaluate(new hn(t.zoom+1),a),p.textMaxSize=s["text-size"].possiblyEvaluate(new hn(18));for(var h=c.get("text-line-height")*ru,d="map"===c.get("text-rotation-alignment")&&"point"!==c.get("symbol-placement"),f=c.get("text-keep-upright"),m=c.get("text-size"),y=function(){var o=v[g],s=c.get("text-font").evaluate(o,{},a).join(","),l=m.evaluate(o,{},a),u=p.layoutTextSize.evaluate(o,{},a),y=p.layoutIconSize.evaluate(o,{},a),_={horizontal:{},vertical:void 0},x=o.text,b=[0,0];if(x){var w=x.toString(),T=c.get("text-letter-spacing").evaluate(o,{},a)*ru,C=function(t){for(var e=0,i=t;e<i.length;e+=1)if(!function(t){return!($r.Arabic(t)||$r["Arabic Supplement"](t)||$r["Arabic Extended-A"](t)||$r["Arabic Presentation Forms-A"](t)||$r["Arabic Presentation Forms-B"](t))}(i[e].charCodeAt(0)))return;return 1}(w)?T:0,E=c.get("text-anchor").evaluate(o,{},a),I=c.get("text-variable-anchor");I||(B=c.get("text-radial-offset").evaluate(o,{},a),b=B?gc(E,[B*ru,yc]):c.get("text-offset").evaluate(o,{},a).map(function(t){return t*ru}));var k=d?"center":c.get("text-justify").evaluate(o,{},a),A=c.get("symbol-placement"),P="point"===A?c.get("text-max-width").evaluate(o,{},a)*ru:0,M=function(){t.allowVerticalPlacement&&tn(w)&&(_.vertical=Bu(x,e,i,n,s,P,h,E,"left",C,b,Ru.vertical,!0,A,u,l))};if(!d&&I){for(var L="auto"===k?I.map(vc):[k],O=!1,R=0;R<L.length;R++){var z,D=L[R];_.horizontal[D]||(O?_.horizontal[D]=_.horizontal[0]:(z=Bu(x,e,i,n,s,P,h,"center",D,C,b,Ru.horizontal,!1,A,u,l))&&(O=1===(_.horizontal[D]=z).positionedLines.length))}M()}else{"auto"===k&&(k=vc(E));var N=Bu(x,e,i,n,s,P,h,E,k,C,b,Ru.horizontal,!1,A,u,l);N&&(_.horizontal[k]=N),M(),tn(w)&&d&&f&&(_.vertical=Bu(x,e,i,n,s,P,h,E,k,C,b,Ru.vertical,!1,A,u,l))}}var B,F=void 0;T=!1;o.icon&&o.icon.name&&(U=r[o.icon.name])&&(B=n[o.icon.name],I=c.get("icon-offset").evaluate(o,{},a),k=(M=Gu(N=c.get("icon-anchor").evaluate(o,{},a))).horizontalAlign,N=M.verticalAlign,M=I[0],I=I[1],k=(M-=B.displaySize[0]*k)+B.displaySize[0],F={image:B,top:N=I-B.displaySize[1]*N,bottom:N+B.displaySize[1],left:M,right:k},T=U.sdf,void 0===t.sdfIcons?t.sdfIcons=U.sdf:t.sdfIcons!==U.sdf&&S("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),U.pixelRatio===t.pixelRatio&&0===c.get("icon-rotate").constantOr(1)||(t.iconsNeedLinear=!0));var U=wc(_.horizontal)||_.vertical;t.iconsInText=!!U&&U.iconsInText,(U||F)&&function(t,e,i,r,n,o,a,s,l,u,c){void 0===(E=o.textMaxSize.evaluate(e,{}))&&(E=a);var p,h=t.layers[0].layout,d=h.get("icon-offset").evaluate(e,{},c),f=wc(i.horizontal),m=a/24,y=t.tilePixelRatio*m,g=t.tilePixelRatio*E/24,v=t.tilePixelRatio*s,_=t.tilePixelRatio*h.get("symbol-spacing"),x=h.get("text-padding")*t.tilePixelRatio,b=h.get("icon-padding")*t.tilePixelRatio,w=h.get("text-max-angle")/180*Math.PI,T="map"===h.get("text-rotation-alignment")&&"point"!==h.get("symbol-placement"),C="map"===h.get("icon-rotation-alignment")&&"point"!==h.get("symbol-placement"),E=h.get("symbol-placement"),I=_/2;s=h.get("icon-text-fit");function k(s,h){h.x<0||h.x>=Ja||h.y<0||h.y>=Ja||function(t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m,y,g,v,_,x,b,w,T,C){var E,I,k,A,P,M=t.addToLineVertexArray(e,i),L=0,O=0,R=0,z=0,D=-1,N=-1,B={},F=_a(""),U=0;i=0;for(k in i=void 0===s._unevaluatedLayout.getValue("text-radial-offset")?(U=(A=s.layout.get("text-offset").evaluate(x,{},T).map(function(t){return t*ru}))[0],A[1]):(U=s.layout.get("text-radial-offset").evaluate(x,{},T)*ru,yc),t.allowVerticalPlacement&&r.vertical&&(A=s.layout.get("text-rotate").evaluate(x,{},T)+90,P=new cc(l,e,u,c,p,P=r.vertical,h,d,f,A),a&&(K=new cc(l,e,u,c,p,a,y,g,f,A))),n&&(G=sc(n,q=s.layout.get("icon-rotate").evaluate(x,{}),w,W="none"!==s.layout.get("icon-text-fit")),Z=a?sc(a,q,w,W):void 0,I=new cc(l,e,u,c,p,n,y,g,!1,q),L=4*G.length,W=null,"source"===(H=t.iconSizeData).kind?(W=[Yu*s.layout.get("icon-size").evaluate(x,{})])[0]>xc&&S(t.layerIds[0]+': Value for "icon-size" is >= '+_c+'. Reduce your "icon-size".'):"composite"===H.kind&&((W=[Yu*b.compositeIconSizes[0].evaluate(x,{},T),Yu*b.compositeIconSizes[1].evaluate(x,{},T)])[0]>xc||W[1]>xc)&&S(t.layerIds[0]+': Value for "icon-size" is >= '+_c+'. Reduce your "icon-size".'),t.addSymbols(t.icon,G,W,_,v,x,!1,e,M.lineStartIndex,M.lineLength,-1,T),D=t.icon.placedSymbolArray.length-1,Z&&(O=4*Z.length,t.addSymbols(t.icon,Z,W,_,v,x,Ru.vertical,e,M.lineStartIndex,M.lineLength,-1,T),N=t.icon.placedSymbolArray.length-1)),r.horizontal){var j=r.horizontal[k];E||(F=_a(j.text),E=new cc(l,e,u,c,p,j,h,d,f,V=s.layout.get("text-rotate").evaluate(x,{},T)));var V=1===j.positionedLines.length;if(R+=bc(t,e,j,o,s,f,x,m,M,r.vertical?Ru.horizontal:Ru.horizontalOnly,V?Object.keys(r.horizontal):[k],B,D,b,T),V)break}r.vertical&&(z+=bc(t,e,r.vertical,o,s,f,x,m,M,Ru.vertical,["vertical"],B,N,b,T));n=E?E.boxStartIndex:t.collisionBoxArray.length,y=E?E.boxEndIndex:t.collisionBoxArray.length,g=P?P.boxStartIndex:t.collisionBoxArray.length;var q=P?P.boxEndIndex:t.collisionBoxArray.length,H=I?I.boxStartIndex:t.collisionBoxArray.length,G=I?I.boxEndIndex:t.collisionBoxArray.length,Z=K?K.boxStartIndex:t.collisionBoxArray.length,W=K?K.boxEndIndex:t.collisionBoxArray.length;_=(v=function(t,e){return t&&t.circleDiameter?Math.max(t.circleDiameter,e):e})(E,_=-1),_=v(P,_),_=v(I,_);var K=-1<(_=v(K,_))?1:0;K&&(_*=C/ru),t.glyphOffsetArray.length>=Pc.MAX_GLYPHS&&S("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"),void 0!==x.sortKey&&t.addToSortKeyRanges(t.symbolInstances.length,x.sortKey),t.symbolInstances.emplaceBack(e.x,e.y,0<=B.right?B.right:-1,0<=B.center?B.center:-1,0<=B.left?B.left:-1,B.vertical||-1,D,N,F,n,y,g,q,H,G,Z,W,u,R,z,L,O,K,0,h,U,i,_)}(t,h,s,i,r,n,p,t.layers[0],t.collisionBoxArray,e.index,e.sourceLayerIndex,t.index,y,x,T,l,v,b,C,d,e,o,u,c,a)}if(r&&"none"!==s&&(t.allowVerticalPlacement&&i.vertical&&(p=Zu(r,i.vertical,s,h.get("icon-text-fit-padding"),d,m)),f&&(r=Zu(r,f,s,h.get("icon-text-fit-padding"),d,m))),"line"===E)for(var A=0,P=oc(e.geometry,0,0,Ja,Ja);A<P.length;A+=1)for(var M=P[A],L=0,O=nc(M,_,w,i.vertical||f,r,24,g,t.overscaling,Ja);L<O.length;L+=1){var R=O[L];f&&function(t,e,i,r){if(e in(t=t.compareText)){for(var n=t[e],o=n.length-1;0<=o;o--)if(r.dist(n[o])<i)return!0}else t[e]=[];return t[e].push(r),!1}(t,f.text,I,R)||k(M,R)}else if("line-center"===E)for(var z=0,D=e.geometry;z<D.length;z+=1){var N,B=D[z];1<B.length&&(N=function(t,e,i,r,n,o){for(var a=ic(i,24,o),s=rc(i,r)*o,l=0,u=ec(t)/2,c=0;c<t.length-1;c++){var p=t[c],h=t[c+1],d=p.dist(h);if(u<l+d){var f=(u-l)/d,m=Je(p.x,h.x,f);f=Je(p.y,h.y,f);return(p=new Ku(m,f,h.angleTo(p),c))._round(),!a||tc(t,p,s,a,e)?p:void 0}l+=d}}(B,w,i.vertical||f,r,0,g))&&k(B,N)}else if("Polygon"===e.type)for(var F=0,U=hl(e.geometry,0);F<U.length;F+=1){var j=U[F],V=dc(j,16);k(j[0],new Ku(V.x,V.y,0))}else if("LineString"===e.type)for(var q=0,H=e.geometry;q<H.length;q+=1){var G=H[q];k(G,new Ku(G[0].x,G[0].y,0))}else if("Point"===e.type)for(var Z=0,W=e.geometry;Z<W.length;Z+=1)for(var K=0,X=W[Z];K<X.length;K+=1){var Y=X[K];k([Y],new Ku(Y.x,Y.y,0))}}(t,o,_,F,r,p,u,y,b,T,a)},g=0,v=t.features;g<v.length;g+=1)y();o&&t.generateCollisionDebugBuffers()},t.perspective=function(t,e,i,r,n){return e=1/Math.tan(e/2),t[0]=e/i,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=e,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=-1,t[12]=0,t[13]=0,t[15]=0,null!=n&&n!==1/0?(t[10]=(n+r)*(e=1/(r-n)),t[14]=2*n*r*e):(t[10]=-1,t[14]=-2*r),t},t.pick=function(t,e){for(var i={},r=0;r<e.length;r++){var n=e[r];n in t&&(i[n]=t[n])}return i},t.plugin=fn,t.polygonIntersectsPolygon=ns,t.postMapLoadEvent=st,t.postTurnstileEvent=at,t.potpack=Mu,t.refProperties=["type","source","source-layer","minzoom","maxzoom","filter","layout"],t.register=Wr,t.registerForPluginStateChange=function(t){return t({pluginStatus:sn,pluginURL:ln}),dn.on("pluginStateChange",t),t},t.renderColorRamp=Ns,t.rotate=function(t,e,i){var r=e[0],n=e[1],o=e[2],a=e[3];e=Math.sin(i),i=Math.cos(i);return t[0]=r*i+o*e,t[1]=n*i+a*e,t[2]=r*-e+o*i,t[3]=n*-e+a*i,t},t.rotateX=function(t,e,i){var r=Math.sin(i),n=Math.cos(i),o=e[4],a=e[5],s=e[6],l=e[7],u=e[8],c=e[9],p=e[10];i=e[11];return e!==t&&(t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[4]=o*n+u*r,t[5]=a*n+c*r,t[6]=s*n+p*r,t[7]=l*n+i*r,t[8]=u*n-o*r,t[9]=c*n-a*r,t[10]=p*n-s*r,t[11]=i*n-l*r,t},t.rotateZ=function(t,e,i){var r=Math.sin(i),n=Math.cos(i),o=e[0],a=e[1],s=e[2],l=e[3],u=e[4],c=e[5],p=e[6];i=e[7];return e!==t&&(t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=o*n+u*r,t[1]=a*n+c*r,t[2]=s*n+p*r,t[3]=l*n+i*r,t[4]=u*n-o*r,t[5]=c*n-a*r,t[6]=p*n-s*r,t[7]=i*n-l*r,t},t.scale=function(t,e,i){var r=i[0],n=i[1];i=i[2];return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t[3]=e[3]*r,t[4]=e[4]*n,t[5]=e[5]*n,t[6]=e[6]*n,t[7]=e[7]*n,t[8]=e[8]*i,t[9]=e[9]*i,t[10]=e[10]*i,t[11]=e[11]*i,t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t},t.scale$1=function(t,e,i){return t[0]=e[0]*i,t[1]=e[1]*i,t[2]=e[2]*i,t[3]=e[3]*i,t},t.scale$2=function(t,e,i){return t[0]=e[0]*i,t[1]=e[1]*i,t[2]=e[2]*i,t},t.setCacheLimits=function(t,e){ut=t,ct=e},t.setRTLTextPlugin=function(t,e,i){if(void 0===i&&(i=!1),sn===on.deferred||sn===on.loading||sn===on.loaded)throw new Error("setRTLTextPlugin cannot be called multiple times.");ln=N.resolveURL(t),sn=on.deferred,an=e,cn(),i||pn()},t.sphericalToCartesian=function(t){var e=t[0],i=t[1];t=t[2];return i+=90,i*=Math.PI/180,t*=Math.PI/180,{x:e*Math.cos(i)*Math.sin(t),y:e*Math.sin(i)*Math.sin(t),z:e*Math.cos(t)}},t.sqrLen=Cs,t.styleSpec=Dt,t.sub=bs,t.symbolSize=fs,t.transformMat3=function(t,e,i){var r=e[0],n=e[1];e=e[2];return t[0]=r*i[0]+n*i[3]+e*i[6],t[1]=r*i[1]+n*i[4]+e*i[7],t[2]=r*i[2]+n*i[5]+e*i[8],t},t.transformMat4=ws,t.translate=function(t,e,i){var r,n,o,a,s,l,u,c,p,h,d,f=i[0],m=i[1],y=i[2];return e===t?(t[12]=e[0]*f+e[4]*m+e[8]*y+e[12],t[13]=e[1]*f+e[5]*m+e[9]*y+e[13],t[14]=e[2]*f+e[6]*m+e[10]*y+e[14],t[15]=e[3]*f+e[7]*m+e[11]*y+e[15]):(r=e[0],n=e[1],o=e[2],a=e[3],s=e[4],l=e[5],u=e[6],c=e[7],p=e[8],h=e[9],d=e[10],i=e[11],t[0]=r,t[1]=n,t[2]=o,t[3]=a,t[4]=s,t[5]=l,t[6]=u,t[7]=c,t[8]=p,t[9]=h,t[10]=d,t[11]=i,t[12]=r*f+s*m+p*y+e[12],t[13]=n*f+l*m+h*y+e[13],t[14]=o*f+u*m+d*y+e[14],t[15]=a*f+c*m+i*y+e[15]),t},t.triggerPluginCompletionEvent=un,t.uniqueId=function(){return f++},t.validateCustomStyleLayer=function(t){var e=[],i=t.id;return void 0===i&&e.push({message:"layers."+i+': missing required property "id"'}),void 0===t.render&&e.push({message:"layers."+i+': missing required method "render"'}),t.renderingMode&&"2d"!==t.renderingMode&&"3d"!==t.renderingMode&&e.push({message:"layers."+i+': property "renderingMode" must be either "2d" or "3d"'}),e},t.validateLight=Dr,t.validateStyle=zr,t.values=function(t){var e,i=[];for(e in t)i.push(t[e]);return i},t.vectorTile=kl,t.version=i,t.warnOnce=S,t.webpSupported=F,t.window=s,t.wrap=h}),i(0,function(t){function e(e){for(var i="",r=0,n=t.refProperties;r<n.length;r+=1)i+="/"+function t(e){var i=typeof e;if("number"==i||"boolean"==i||"string"==i||null==e)return JSON.stringify(e);if(Array.isArray(e)){for(var r="[",n=0,o=e;n<o.length;n+=1)r+=t(o[n])+",";return r+"]"}for(var a=Object.keys(e).sort(),s="{",l=0;l<a.length;l++)s+=JSON.stringify(a[l])+":"+t(e[a[l]])+",";return s+"}"}(e[n[r]]);return i}function i(t){this.keyCache={},t&&this.replace(t)}function r(e){var i,r={},n=[];for(i in e){var o,a=e[i],s=r[i]={};for(o in a){var l,u=a[+o];u&&0!==u.bitmap.width&&0!==u.bitmap.height&&(l={x:0,y:0,w:u.bitmap.width+2,h:u.bitmap.height+2},n.push(l),s[o]={rect:l,metrics:u.metrics})}}var c,p=(h=t.potpack(n)).w,h=h.h,d=new t.AlphaImage({width:p||1,height:h||1});for(c in e){var f,m=e[c];for(f in m){var y,g=m[+f];g&&0!==g.bitmap.width&&0!==g.bitmap.height&&(y=r[c][f].rect,t.AlphaImage.copy(g.bitmap,d,{x:0,y:0},{x:y.x+1,y:y.y+1},g.bitmap))}}this.image=d,this.positions=r}function n(e){this.tileID=new t.OverscaledTileID(e.tileID.overscaledZ,e.tileID.wrap,e.tileID.canonical.z,e.tileID.canonical.x,e.tileID.canonical.y),this.uid=e.uid,this.zoom=e.zoom,this.pixelRatio=e.pixelRatio,this.tileSize=e.tileSize,this.source=e.source,this.overscaling=this.tileID.overscaleFactor(),this.showCollisionBoxes=e.showCollisionBoxes,this.collectResourceTiming=!!e.collectResourceTiming,this.returnDependencies=!!e.returnDependencies,this.promoteId=e.promoteId}function o(e,i,r){for(var n=new t.EvaluationParameters(i),o=0,a=e;o<a.length;o+=1)a[o].recalculate(n,r)}function a(e,i){var r=t.getArrayBuffer(e.request,function(e,r,n,o){e?i(e):r&&i(null,{vectorTile:new t.vectorTile.VectorTile(new t.pbf(r)),rawData:r,cacheControl:n,expires:o})});return function(){r.cancel(),i()}}function s(t,e,i,r){this.actor=t,this.layerIndex=e,this.availableImages=i,this.loadVectorData=r||a,this.loading={},this.loaded={}}function l(){this.loaded={}}i.prototype.replace=function(t){this._layerConfigs={},this._layers={},this.update(t,[])},i.prototype.update=function(i,r){for(var n=this,o=0,a=i;o<a.length;o+=1){var s=a[o];this._layerConfigs[s.id]=s;var l=this._layers[s.id]=t.createStyleLayer(s);l._featureFilter=t.featureFilter(l.filter),this.keyCache[s.id]&&delete this.keyCache[s.id]}for(var u=0,c=r;u<c.length;u+=1){var p=c[u];delete this.keyCache[p],delete this._layerConfigs[p],delete this._layers[p]}this.familiesBySource={};for(var h=0,d=function(t,i){for(var r={},n=0;n<t.length;n++){var o=i&&i[t[n].id]||e(t[n]);i&&(i[t[n].id]=o),(r[o]||(r[o]=[])).push(t[n])}var a,s=[];for(a in r)s.push(r[a]);return s}(t.values(this._layerConfigs),this.keyCache);h<d.length;h+=1){var f,m,y=d[h].map(function(t){return n._layers[t.id]}),g=y[0];"none"!==g.visibility&&(f=g.source||"",((m=(m=this.familiesBySource[f])||(this.familiesBySource[f]={}))[g=g.sourceLayer||"_geojsonTileLayer"]||(m[g]=[])).push(y))}},t.register("GlyphAtlas",r),n.prototype.parse=function(e,i,n,a,s){var l=this;this.status="parsing",this.data=e,this.collisionBoxArray=new t.CollisionBoxArray;var u=new t.DictionaryCoder(Object.keys(e.layers).sort()),c=new t.FeatureIndex(this.tileID,this.promoteId);c.bucketLayerIDs=[];var p,h,d,f,m,y={},g={featureIndex:c,iconDependencies:{},patternDependencies:{},glyphDependencies:{},availableImages:n},v=i.familiesBySource[this.source];for(p in v){var _=e.layers[p];if(_){1===_.version&&t.warnOnce('Vector tile source "'+this.source+'" layer "'+p+'" does not use vector tile spec v2 and therefore may have some rendering errors.');for(var x=u.encode(p),b=[],w=0;w<_.length;w++){var S=_.feature(w),T=c.getId(S,p);b.push({feature:S,id:T,index:w,sourceLayerIndex:x})}for(var C=0,E=v[p];C<E.length;C+=1){var I=E[C],k=I[0];k.minzoom&&this.zoom<Math.floor(k.minzoom)||k.maxzoom&&this.zoom>=k.maxzoom||"none"!==k.visibility&&(o(I,this.zoom,n),(y[k.id]=k.createBucket({index:c.bucketLayerIDs.length,layers:I,zoom:this.zoom,pixelRatio:this.pixelRatio,overscaling:this.overscaling,collisionBoxArray:this.collisionBoxArray,sourceLayerIndex:x,sourceID:this.source})).populate(b,g,this.tileID.canonical),c.bucketLayerIDs.push(I.map(function(t){return t.id})))}}}function A(){if(h)return s(h);if(d&&f&&m){var e,i=new r(d),a=new t.ImageAtlas(f,m);for(e in y){var l=y[e];l instanceof t.SymbolBucket?(o(l.layers,this.zoom,n),t.performSymbolLayout(l,d,i.positions,f,a.iconPositions,this.showCollisionBoxes,this.tileID.canonical)):l.hasPattern&&(l instanceof t.LineBucket||l instanceof t.FillBucket||l instanceof t.FillExtrusionBucket)&&(o(l.layers,this.zoom,n),l.addFeatures(g,this.tileID.canonical,a.patternPositions))}this.status="done",s(null,{buckets:t.values(y).filter(function(t){return!t.isEmpty()}),featureIndex:c,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:i.image,imageAtlas:a,glyphMap:this.returnDependencies?d:null,iconMap:this.returnDependencies?f:null,glyphPositions:this.returnDependencies?i.positions:null})}}i=t.mapObject(g.glyphDependencies,function(t){return Object.keys(t).map(Number)}),Object.keys(i).length?a.send("getGlyphs",{uid:this.uid,stacks:i},function(t,e){h||(h=t,d=e,A.call(l))}):d={},(i=Object.keys(g.iconDependencies)).length?a.send("getImages",{icons:i,source:this.source,tileID:this.tileID,type:"icons"},function(t,e){h||(h=t,f=e,A.call(l))}):f={},(i=Object.keys(g.patternDependencies)).length?a.send("getImages",{icons:i,source:this.source,tileID:this.tileID,type:"patterns"},function(t,e){h||(h=t,m=e,A.call(l))}):m={},A.call(this)},s.prototype.loadTile=function(e,i){var r=this,o=e.uid;this.loading||(this.loading={});var a=!!(e&&e.request&&e.request.collectResourceTiming)&&new t.RequestPerformance(e.request),s=this.loading[o]=new n(e);s.abort=this.loadVectorData(e,function(e,n){if(delete r.loading[o],e||!n)return s.status="done",r.loaded[o]=s,i(e);var l=n.rawData,u={};n.expires&&(u.expires=n.expires),n.cacheControl&&(u.cacheControl=n.cacheControl);var c={};!a||(e=a.finish())&&(c.resourceTiming=JSON.parse(JSON.stringify(e))),s.vectorTile=n.vectorTile,s.parse(n.vectorTile,r.layerIndex,r.availableImages,r.actor,function(e,r){return e||!r?i(e):void i(null,t.extend({rawTileData:l.slice(0)},r,u,c))}),r.loaded=r.loaded||{},r.loaded[o]=s})},s.prototype.reloadTile=function(t,e){var i,r=this,n=this.loaded,o=t.uid,a=this;n&&n[o]&&((i=n[o]).showCollisionBoxes=t.showCollisionBoxes,t=function(t,n){var o=i.reloadCallback;o&&(delete i.reloadCallback,i.parse(i.vectorTile,a.layerIndex,r.availableImages,a.actor,o)),e(t,n)},"parsing"===i.status?i.reloadCallback=t:"done"===i.status&&(i.vectorTile?i.parse(i.vectorTile,this.layerIndex,this.availableImages,this.actor,t):t()))},s.prototype.abortTile=function(t,e){var i=this.loading;t=t.uid;i&&i[t]&&i[t].abort&&(i[t].abort(),delete i[t]),e()},s.prototype.removeTile=function(t,e){var i=this.loaded;t=t.uid;i&&i[t]&&delete i[t],e()};var u=t.window.ImageBitmap;l.prototype.loadTile=function(e,i){var r=e.uid,n=e.encoding;e=e.rawImageData,e=u&&e instanceof u?this.getImageData(e):e,n=new t.DEMData(r,e,n);this.loaded=this.loaded||{},i(null,this.loaded[r]=n)},l.prototype.getImageData=function(e){return this.offscreenCanvas&&this.offscreenCanvasContext||(this.offscreenCanvas=new OffscreenCanvas(e.width,e.height),this.offscreenCanvasContext=this.offscreenCanvas.getContext("2d")),this.offscreenCanvas.width=e.width,this.offscreenCanvas.height=e.height,this.offscreenCanvasContext.drawImage(e,0,0,e.width,e.height),e=this.offscreenCanvasContext.getImageData(-1,-1,e.width+2,e.height+2),this.offscreenCanvasContext.clearRect(0,0,this.offscreenCanvas.width,this.offscreenCanvas.height),new t.RGBAImage({width:e.width,height:e.height},e.data)},l.prototype.removeTile=function(t){var e=this.loaded;t=t.uid;e&&e[t]&&delete e[t]};var c=function t(e,i){var r,n=e&&e.type;if("FeatureCollection"===n)for(r=0;r<e.features.length;r++)t(e.features[r],i);else if("GeometryCollection"===n)for(r=0;r<e.geometries.length;r++)t(e.geometries[r],i);else if("Feature"===n)t(e.geometry,i);else if("Polygon"===n)p(e.coordinates,i);else if("MultiPolygon"===n)for(r=0;r<e.coordinates.length;r++)p(e.coordinates[r],i);return e};function p(t,e){if(0!==t.length){h(t[0],e);for(var i=1;i<t.length;i++)h(t[i],!e)}}function h(t,e){for(var i=0,r=0,n=0,o=t.length,a=o-1;n<o;a=n++){var s=(t[n][0]-t[a][0])*(t[a][1]+t[n][1]),l=i+s;r+=Math.abs(i)>=Math.abs(s)?i-l+s:s-l+i,i=l}0<=i+r!=!!e&&t.reverse()}function d(e){this._feature=e,this.extent=t.EXTENT,this.type=e.type,this.properties=e.tags,"id"in e&&!isNaN(e.id)&&(this.id=parseInt(e.id,10))}var f=t.vectorTile.VectorTileFeature.prototype.toGeoJSON;d.prototype.loadGeometry=function(){if(1===this._feature.type){for(var e=[],i=0,r=this._feature.geometry;i<r.length;i+=1){var n=r[i];e.push([new t.Point$1(n[0],n[1])])}return e}for(var o=[],a=0,s=this._feature.geometry;a<s.length;a+=1){for(var l=[],u=0,c=s[a];u<c.length;u+=1){var p=c[u];l.push(new t.Point$1(p[0],p[1]))}o.push(l)}return o},d.prototype.toGeoJSON=function(t,e,i){return f.call(this,t,e,i)};var m=function(e){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=t.EXTENT,this.length=e.length,this._features=e};m.prototype.feature=function(t){return new d(this._features[t])};var y=t.vectorTile.VectorTileFeature,g=v;function v(t,e){this.options=e||{},this.features=t,this.length=t.length}function _(t,e){this.id="number"==typeof t.id?t.id:void 0,this.type=t.type,this.rawGeometry=1===t.type?[t.geometry]:t.geometry,this.properties=t.tags,this.extent=e||4096}v.prototype.feature=function(t){return new _(this.features[t],this.options.extent)},_.prototype.loadGeometry=function(){var e=this.rawGeometry;this.geometry=[];for(var i=0;i<e.length;i++){for(var r=e[i],n=[],o=0;o<r.length;o++)n.push(new t.Point$1(r[o][0],r[o][1]));this.geometry.push(n)}return this.geometry},_.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var t=this.geometry,e=1/0,i=-1/0,r=1/0,n=-1/0,o=0;o<t.length;o++)for(var a=t[o],s=0;s<a.length;s++){var l=a[s];e=Math.min(e,l.x),i=Math.max(i,l.x),r=Math.min(r,l.y),n=Math.max(n,l.y)}return[e,r,i,n]},_.prototype.toGeoJSON=y.prototype.toGeoJSON;var x=b;y=g;function b(e){var i=new t.pbf;return function(t,e){for(var i in t.layers)e.writeMessage(3,w,t.layers[i])}(e,i),i.finish()}function w(t,e){e.writeVarintField(15,t.version||1),e.writeStringField(1,t.name||""),e.writeVarintField(5,t.extent||4096);for(var i={keys:[],values:[],keycache:{},valuecache:{}},r=0;r<t.length;r++)i.feature=t.feature(r),e.writeMessage(2,S,i);var n=i.keys;for(r=0;r<n.length;r++)e.writeStringField(3,n[r]);var o=i.values;for(r=0;r<o.length;r++)e.writeMessage(4,k,o[r])}function S(t,e){var i=t.feature;void 0!==i.id&&e.writeVarintField(1,i.id),e.writeMessage(2,T,t),e.writeVarintField(3,i.type),e.writeMessage(4,I,i)}function T(t,e){var i,r=t.feature,n=t.keys,o=t.values,a=t.keycache,s=t.valuecache;for(i in r.properties){var l,u=r.properties[i],c=a[i];null!==u&&(void 0===c&&(n.push(i),c=n.length-1,a[i]=c),e.writeVarint(c),void 0===(l=s[c=(l=typeof u)+":"+(u="string"!=l&&"boolean"!=l&&"number"!=l?JSON.stringify(u):u)])&&(o.push(u),l=o.length-1,s[c]=l),e.writeVarint(l))}}function C(t,e){return(e<<3)+(7&t)}function E(t){return t<<1^t>>31}function I(t,e){for(var i=t.loadGeometry(),r=t.type,n=0,o=0,a=i.length,s=0;s<a;s++){var l=i[s],u=1;1===r&&(u=l.length),e.writeVarint(C(1,u));for(var c=3===r?l.length-1:l.length,p=0;p<c;p++){1===p&&1!==r&&e.writeVarint(C(2,c-1));var h=l[p].x-n,d=l[p].y-o;e.writeVarint(E(h)),e.writeVarint(E(d)),n+=h,o+=d}3===r&&e.writeVarint(15)}}function k(t,e){var i=typeof t;"string"==i?e.writeStringField(1,t):"boolean"==i?e.writeBooleanField(7,t):"number"==i&&(t%1!=0?e.writeDoubleField(3,t):t<0?e.writeSVarintField(6,t):e.writeVarintField(5,t))}function A(t,e,i,r){P(t,i,r),P(e,2*i,2*r),P(e,2*i+1,2*r+1)}function P(t,e,i){var r=t[e];t[e]=t[i],t[i]=r}function M(t,e,i,r){return(i=t-i)*i+(r=e-r)*r}function L(t){return t[0]}function O(t){return t[1]}function R(t,e,i,r,n){void 0===e&&(e=L),void 0===i&&(i=O),void 0===r&&(r=64),void 0===n&&(n=Float64Array),this.nodeSize=r;for(var o=(this.points=t).length<65536?Uint16Array:Uint32Array,a=this.ids=new o(t.length),s=this.coords=new n(2*t.length),l=0;l<t.length;l++)s[2*(a[l]=l)]=e(t[l]),s[2*l+1]=i(t[l]);!function t(e,i,r,n,o,a){var s;o-n<=r||(function t(e,i,r,n,o,a){for(;n<o;){var s,l,u,c,p;600<o-n&&(s=o-n+1,l=r-n+1,c=Math.log(s),u=.5*Math.exp(2*c/3),p=.5*Math.sqrt(c*u*(s-u)/s)*(l-s/2<0?-1:1),t(e,i,r,c=Math.max(n,Math.floor(r-l*u/s+p)),p=Math.min(o,Math.floor(r+(s-l)*u/s+p)),a));var h=i[2*r+a],d=n,f=o;for(A(e,i,n,r),i[2*o+a]>h&&A(e,i,n,o);d<f;){for(A(e,i,d,f),d++,f--;i[2*d+a]<h;)d++;for(;i[2*f+a]>h;)f--}i[2*n+a]===h?A(e,i,n,f):A(e,i,++f,o),f<=r&&(n=f+1),r<=f&&(o=f-1)}}(e,i,s=n+o>>1,n,o,a%2),t(e,i,r,n,s-1,a+1),t(e,i,r,1+s,o,a+1))}(a,s,r,0,a.length-1,0)}function z(t){this.options=q(Object.create(N),t),this.trees=new Array(this.options.maxZoom+1)}x.fromVectorTileJs=b,x.fromGeojsonVt=function(t,e){e=e||{};var i,r={};for(i in t)r[i]=new g(t[i].features,e),r[i].name=i,r[i].version=e.version,r[i].extent=e.extent;return b({layers:r})},x.GeoJSONWrapper=y,R.prototype.range=function(t,e,i,r){return function(t,e,i,r,n,o,a){for(var s=[0,t.length-1,0],l=[];s.length;){var u=s.pop(),c=s.pop(),p=s.pop();if(c-p<=a)for(var h=p;h<=c;h++)f=e[2*h],m=e[2*h+1],i<=f&&f<=n&&r<=m&&m<=o&&l.push(t[h]);else{var d=Math.floor((p+c)/2),f=e[2*d],m=e[2*d+1];i<=f&&f<=n&&r<=m&&m<=o&&l.push(t[d]);var y=(u+1)%2;(0===u?i<=f:r<=m)&&(s.push(p),s.push(d-1),s.push(y)),(0===u?f<=n:m<=o)&&(s.push(d+1),s.push(c),s.push(y))}}return l}(this.ids,this.coords,t,e,i,r,this.nodeSize)};var D,N={minZoom:0,maxZoom:16,minPoints:2,radius:40,extent:512,nodeSize:64,log:!(R.prototype.within=function(t,e,i){return function(t,e,i,r,n,o){for(var a=[0,t.length-1,0],s=[],l=n*n;a.length;){var u=a.pop(),c=a.pop(),p=a.pop();if(c-p<=o)for(var h=p;h<=c;h++)M(e[2*h],e[2*h+1],i,r)<=l&&s.push(t[h]);else{var d=Math.floor((p+c)/2),f=e[2*d],m=e[2*d+1];M(f,m,i,r)<=l&&s.push(t[d]);var y=(u+1)%2;(0===u?i-n<=f:r-n<=m)&&(a.push(p),a.push(d-1),a.push(y)),(0===u?f<=i+n:m<=r+n)&&(a.push(d+1),a.push(c),a.push(y))}}return s}(this.ids,this.coords,t,e,i,this.nodeSize)}),generateId:!1,reduce:null,map:function(t){return t}},B=Math.fround||(D=new Float32Array(1),function(t){return D[0]=+t,D[0]});function F(t){return{type:"Feature",id:t.id,properties:U(t),geometry:{type:"Point",coordinates:[360*(t.x-.5),function(t){return t=(180-360*t)*Math.PI/180,360*Math.atan(Math.exp(t))/Math.PI-90}(t.y)]}}}function U(t){var e=t.numPoints,i=1e4<=e?Math.round(e/1e3)+"k":1e3<=e?Math.round(e/100)/10+"k":e;return q(q({},t.properties),{cluster:!0,cluster_id:t.id,point_count:e,point_count_abbreviated:i})}function j(t){return t/360+.5}function V(t){return t=Math.sin(t*Math.PI/180),(t=.5-.25*Math.log((1+t)/(1-t))/Math.PI)<0?0:1<t?1:t}function q(t,e){for(var i in e)t[i]=e[i];return t}function H(t){return t.x}function G(t){return t.y}function Z(t,e,i,r){return function(t){var e=t.geometry,i=t.type;if("Point"===i||"MultiPoint"===i||"LineString"===i)W(t,e);else if("Polygon"===i||"MultiLineString"===i)for(var r=0;r<e.length;r++)W(t,e[r]);else if("MultiPolygon"===i)for(r=0;r<e.length;r++)for(var n=0;n<e[r].length;n++)W(t,e[r][n])}(r={id:void 0===t?null:t,type:e,geometry:i,tags:r,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0}),r}function W(t,e){for(var i=0;i<e.length;i+=3)t.minX=Math.min(t.minX,e[i]),t.minY=Math.min(t.minY,e[i+1]),t.maxX=Math.max(t.maxX,e[i]),t.maxY=Math.max(t.maxY,e[i+1])}function K(t,e,i,r){if(e.geometry){var n=e.geometry.coordinates,o=e.geometry.type,a=Math.pow(i.tolerance/((1<<i.maxZoom)*i.extent),2),s=[],l=e.id;if(i.promoteId?l=e.properties[i.promoteId]:i.generateId&&(l=r||0),"Point"===o)X(n,s);else if("MultiPoint"===o)for(var u=0;u<n.length;u++)X(n[u],s);else if("LineString"===o)Y(n,s,a,!1);else if("MultiLineString"===o){if(i.lineMetrics){for(u=0;u<n.length;u++)Y(n[u],s=[],a,!1),t.push(Z(l,"LineString",s,e.properties));return}J(n,s,a,!1)}else if("Polygon"===o)J(n,s,a,!0);else{if("MultiPolygon"!==o){if("GeometryCollection"!==o)throw new Error("Input data is not a valid GeoJSON object.");for(u=0;u<e.geometry.geometries.length;u++)K(t,{id:l,geometry:e.geometry.geometries[u],properties:e.properties},i,r);return}for(u=0;u<n.length;u++){var c=[];J(n[u],c,a,!0),s.push(c)}}t.push(Z(l,o,s,e.properties))}}function X(t,e){e.push(Q(t[0])),e.push($(t[1])),e.push(0)}function Y(t,e,i,r){for(var n,o,a=0,s=0;s<t.length;s++){var l=Q(t[s][0]),u=$(t[s][1]);e.push(l),e.push(u),e.push(0),0<s&&(a+=r?(n*u-l*o)/2:Math.sqrt(Math.pow(l-n,2)+Math.pow(u-o,2))),n=l,o=u}var c=e.length-3;e[2]=1,function t(e,i,r,n){for(var o,a=n,s=r-i>>1,l=r-i,u=e[i],c=e[i+1],p=e[r],h=e[r+1],d=i+3;d<r;d+=3){var f=function(t,e,i,r,n,o){var a,s=p-i,l=h-r;return 0===s&&0===l||(1<(a=((t-i)*s+(e-r)*l)/(s*s+l*l))?(i=p,r=h):0<a&&(i+=s*a,r+=l*a)),(s=t-i)*s+(l=e-r)*l}(e[d],e[d+1],u,c);a<f?(o=d,a=f):f!==a||(f=Math.abs(d-s))<l&&(o=d,l=f)}n<a&&(3<o-i&&t(e,i,o,n),e[o+2]=a,3<r-o&&t(e,o,r,n))}(e,0,c,i),e[2+c]=1,e.size=Math.abs(a),e.start=0,e.end=e.size}function J(t,e,i,r){for(var n=0;n<t.length;n++){var o=[];Y(t[n],o,i,r),e.push(o)}}function Q(t){return t/360+.5}function $(t){return t=Math.sin(t*Math.PI/180),(t=.5-.25*Math.log((1+t)/(1-t))/Math.PI)<0?0:1<t?1:t}function tt(t,e,i,r,n,o,a,s){if(r/=e,(i/=e)<=o&&a<r)return t;if(a<i||r<=o)return null;for(var l=[],u=0;u<t.length;u++){var c=t[u],p=c.geometry,h=c.type,d=0===n?c.minX:c.minY,f=0===n?c.maxX:c.maxY;if(i<=d&&f<r)l.push(c);else if(!(f<i||r<=d)){var m=[];if("Point"===h||"MultiPoint"===h)!function(t,e,i,r,n){for(var o=0;o<t.length;o+=3){var a=t[o+n];i<=a&&a<=r&&(e.push(t[o]),e.push(t[o+1]),e.push(t[o+2]))}}(p,m,i,r,n);else if("LineString"===h)et(p,m,i,r,n,!1,s.lineMetrics);else if("MultiLineString"===h)rt(p,m,i,r,n,!1);else if("Polygon"===h)rt(p,m,i,r,n,!0);else if("MultiPolygon"===h)for(var y=0;y<p.length;y++){var g=[];rt(p[y],g,i,r,n,!0),g.length&&m.push(g)}if(m.length)if(s.lineMetrics&&"LineString"===h)for(y=0;y<m.length;y++)l.push(Z(c.id,h,m[y],c.tags));else"LineString"!==h&&"MultiLineString"!==h||(1===m.length?(h="LineString",m=m[0]):h="MultiLineString"),"Point"!==h&&"MultiPoint"!==h||(h=3===m.length?"Point":"MultiPoint"),l.push(Z(c.id,h,m,c.tags))}}return l.length?l:null}function et(t,e,i,r,n,o,a){for(var s,l,u=it(t),c=0===n?ot:at,p=t.start,h=0;h<t.length-3;h+=3){var d=t[h],f=t[h+1],m=t[h+2],y=t[h+3],g=t[h+4],v=0===n?d:f,_=0===n?y:g,x=!1;a&&(s=Math.sqrt(Math.pow(d-y,2)+Math.pow(f-g,2))),v<i?i<_&&(l=c(u,d,f,y,g,i),a&&(u.start=p+s*l)):r<v?_<r&&(l=c(u,d,f,y,g,r),a&&(u.start=p+s*l)):nt(u,d,f,m),_<i&&i<=v&&(l=c(u,d,f,y,g,i),x=!0),r<_&&v<=r&&(l=c(u,d,f,y,g,r),x=!0),!o&&x&&(a&&(u.end=p+s*l),e.push(u),u=it(t)),a&&(p+=s)}var b=t.length-3;d=t[b],f=t[1+b],m=t[2+b];i<=(v=0===n?d:f)&&v<=r&&nt(u,d,f,m),b=u.length-3,o&&3<=b&&(u[b]!==u[0]||u[1+b]!==u[1])&&nt(u,u[0],u[1],u[2]),u.length&&e.push(u)}function it(t){var e=[];return e.size=t.size,e.start=t.start,e.end=t.end,e}function rt(t,e,i,r,n,o){for(var a=0;a<t.length;a++)et(t[a],e,i,r,n,o,!1)}function nt(t,e,i,r){t.push(e),t.push(i),t.push(r)}function ot(t,e,i,r,n,o){return e=(o-e)/(r-e),t.push(o),t.push(i+(n-i)*e),t.push(1),e}function at(t,e,i,r,n,o){return i=(o-i)/(n-i),t.push(e+(r-e)*i),t.push(o),t.push(1),i}function st(t,e){for(var i=[],r=0;r<t.length;r++){var n=t[r],o=n.type;if("Point"===o||"MultiPoint"===o||"LineString"===o)a=lt(n.geometry,e);else if("MultiLineString"===o||"Polygon"===o)for(var a=[],s=0;s<n.geometry.length;s++)a.push(lt(n.geometry[s],e));else if("MultiPolygon"===o)for(a=[],s=0;s<n.geometry.length;s++){for(var l=[],u=0;u<n.geometry[s].length;u++)l.push(lt(n.geometry[s][u],e));a.push(l)}i.push(Z(n.id,o,a,n.tags))}return i}function lt(t,e){var i=[];i.size=t.size,void 0!==t.start&&(i.start=t.start,i.end=t.end);for(var r=0;r<t.length;r+=3)i.push(t[r]+e,t[r+1],t[r+2]);return i}function ut(t,e){if(t.transformed)return t;for(var i,r=1<<t.z,n=t.x,o=t.y,a=0;a<t.features.length;a++){var s=t.features[a],l=s.geometry,u=s.type;if(s.geometry=[],1===u)for(i=0;i<l.length;i+=2)s.geometry.push(ct(l[i],l[i+1],e,r,n,o));else for(i=0;i<l.length;i++){for(var c=[],p=0;p<l[i].length;p+=2)c.push(ct(l[i][p],l[i][p+1],e,r,n,o));s.geometry.push(c)}}return t.transformed=!0,t}function ct(t,e,i,r,n,o){return[Math.round(i*(t*r-n)),Math.round(i*(e*r-o))]}function pt(t,e,i,r,n){for(var o=e===n.maxZoom?0:n.tolerance/((1<<e)*n.extent),a={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:i,y:r,z:e,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},s=0;s<t.length;s++){a.numFeatures++,function(t,e,i,r){var n=e.geometry,o=e.type,a=[];if("Point"===o||"MultiPoint"===o)for(var s=0;s<n.length;s+=3)a.push(n[s]),a.push(n[s+1]),t.numPoints++,t.numSimplified++;else if("LineString"===o)ht(a,n,t,i,!1,!1);else if("MultiLineString"===o||"Polygon"===o)for(s=0;s<n.length;s++)ht(a,n[s],t,i,"Polygon"===o,0===s);else if("MultiPolygon"===o)for(var l=0;l<n.length;l++){var u=n[l];for(s=0;s<u.length;s++)ht(a,u[s],t,i,!0,0===s)}if(a.length){var c=e.tags||null;if("LineString"===o&&r.lineMetrics){for(var p in c={},e.tags)c[p]=e.tags[p];c.mapbox_clip_start=n.start/n.size,c.mapbox_clip_end=n.end/n.size}r={geometry:a,type:"Polygon"===o||"MultiPolygon"===o?3:"LineString"===o||"MultiLineString"===o?2:1,tags:c},null!==e.id&&(r.id=e.id),t.features.push(r)}}(a,t[s],o,n);var l=t[s].minX,u=t[s].minY,c=t[s].maxX,p=t[s].maxY;l<a.minX&&(a.minX=l),u<a.minY&&(a.minY=u),c>a.maxX&&(a.maxX=c),p>a.maxY&&(a.maxY=p)}return a}function ht(t,e,i,r,n,o){var a=r*r;if(0<r&&e.size<(n?a:r))i.numPoints+=e.length/3;else{for(var s=[],l=0;l<e.length;l+=3)(0===r||e[l+2]>a)&&(i.numSimplified++,s.push(e[l]),s.push(e[l+1])),i.numPoints++;n&&function(t,e){for(var i=0,r=0,n=t.length,o=n-2;r<n;o=r,r+=2)i+=(t[r]-t[o])*(t[r+1]+t[o+1]);if(0<i===e)for(r=0,n=t.length;r<n/2;r+=2){var a=t[r],s=t[r+1];t[r]=t[n-2-r],t[r+1]=t[n-1-r],t[n-2-r]=a,t[n-1-r]=s}}(s,o),t.push(s)}}function dt(t,e){var i=(e=this.options=function(t,e){for(var i in e)t[i]=e[i];return t}(Object.create(this.options),e)).debug;if(i&&console.time("preprocess data"),e.maxZoom<0||24<e.maxZoom)throw new Error("maxZoom should be in the 0-24 range");if(e.promoteId&&e.generateId)throw new Error("promoteId and generateId cannot be used together.");var r,n,o,a,s=function(t,e){var i=[];if("FeatureCollection"===t.type)for(var r=0;r<t.features.length;r++)K(i,t.features[r],e,r);else"Feature"===t.type?K(i,t,e):K(i,{geometry:t},e);return i}(t,e);this.tiles={},this.tileCoords=[],i&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",e.indexMaxZoom,e.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),t=tt(a=r=s,1,-1-(o=(n=e).buffer/n.extent),o,0,-1,2,n),e=tt(r,1,1-o,2+o,0,-1,2,n),(t||e)&&(a=tt(r,1,-o,1+o,0,-1,2,n)||[],t&&(a=st(t,1).concat(a)),e&&(a=a.concat(st(e,-1)))),(s=a).length&&this.splitTile(s,0,0,0),i&&(s.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)))}function ft(t,e,i){return 32*((1<<t)*i+e)+t}function mt(t,e){var i=t.tileID.canonical;return this._geoJSONIndex&&(t=this._geoJSONIndex.getTile(i.z,i.x,i.y))?void e(null,{vectorTile:i=new m(t.features),rawData:(t=0!==(t=x(i)).byteOffset||t.byteLength!==t.buffer.byteLength?new Uint8Array(t):t).buffer}):e(null,null)}z.prototype.load=function(t){var e=this.options,i=e.log,r=e.minZoom,n=e.maxZoom,o=e.nodeSize;i&&console.time("total time"),e="prepare "+t.length+" points",i&&console.time(e),this.points=t;for(var a,s,l,u=[],c=0;c<t.length;c++)t[c].geometry&&u.push((s=c,l=void 0,a=(l=(a=t[c]).geometry.coordinates)[0],l=l[1],{x:B(j(a)),y:B(V(l)),zoom:1/0,index:s,parentId:-1}));this.trees[n+1]=new R(u,H,G,o,Float32Array),i&&console.timeEnd(e);for(var p=n;r<=p;p--){var h=+Date.now();u=this._cluster(u,p);this.trees[p]=new R(u,H,G,o,Float32Array),i&&console.log("z%d: %d clusters in %dms",p,u.length,+Date.now()-h)}return i&&console.timeEnd("total time"),this},z.prototype.getClusters=function(t,e){var i=((t[0]+180)%360+360)%360-180,r=Math.max(-90,Math.min(90,t[1])),n=180===t[2]?180:((t[2]+180)%360+360)%360-180,o=Math.max(-90,Math.min(90,t[3]));if(360<=t[2]-t[0])i=-180,n=180;else if(n<i){var a=this.getClusters([i,r,180,o],e);t=this.getClusters([-180,r,n,o],e);return a.concat(t)}for(var s=this.trees[this._limitZoom(e)],l=[],u=0,c=s.range(j(i),V(o),j(n),V(r));u<c.length;u+=1){var p=c[u];p=s.points[p];l.push(p.numPoints?F(p):this.points[p.index])}return l},z.prototype.getChildren=function(t){var e=this._getOriginId(t),i=this._getOriginZoom(t),r="No cluster with the specified id.",n=this.trees[i];if(!n)throw new Error(r);if(!(e=n.points[e]))throw new Error(r);i=this.options.radius/(this.options.extent*Math.pow(2,i-1));for(var o=[],a=0,s=n.within(e.x,e.y,i);a<s.length;a+=1){var l=s[a];(l=n.points[l]).parentId===t&&o.push(l.numPoints?F(l):this.points[l.index])}if(0===o.length)throw new Error(r);return o},z.prototype.getLeaves=function(t,e,i){var r=[];return this._appendLeaves(r,t,e=e||10,i=i||0,0),r},z.prototype.getTile=function(t,e,i){var r=this.trees[this._limitZoom(t)],n=Math.pow(2,t),o=(s=this.options).extent,a=s.radius/o,s=(t=(i-a)/n,(i+1+a)/n);o={features:[]};return this._addTileFeatures(r.range((e-a)/n,t,(e+1+a)/n,s),r.points,e,i,n,o),0===e&&this._addTileFeatures(r.range(1-a/n,t,1,s),r.points,n,i,n,o),e===n-1&&this._addTileFeatures(r.range(0,t,a/n,s),r.points,-1,i,n,o),o.features.length?o:null},z.prototype.getClusterExpansionZoom=function(t){for(var e=this._getOriginZoom(t)-1;e<=this.options.maxZoom;){var i=this.getChildren(t);if(e++,1!==i.length)break;t=i[0].properties.cluster_id}return e},z.prototype._appendLeaves=function(t,e,i,r,n){for(var o=0,a=this.getChildren(e);o<a.length;o+=1){var s=a[o],l=s.properties;if(l&&l.cluster?n+l.point_count<=r?n+=l.point_count:n=this._appendLeaves(t,l.cluster_id,i,r,n):n<r?n++:t.push(s),t.length===i)break}return n},z.prototype._addTileFeatures=function(t,e,i,r,n,o){for(var a=0,s=t;a<s.length;a+=1){var l,u=e[s[a]],c=u.numPoints,p=void 0,h=void 0,d=void 0;d=c?(p=U(u),h=u.x,u.y):(p=(l=this.points[u.index]).properties,h=j(l.geometry.coordinates[0]),V(l.geometry.coordinates[1])),d={type:1,geometry:[[Math.round(this.options.extent*(h*n-i)),Math.round(this.options.extent*(d*n-r))]],tags:p},p=void 0,c?p=u.id:this.options.generateId?p=u.index:this.points[u.index].id&&(p=this.points[u.index].id),void 0!==p&&(d.id=p),o.features.push(d)}},z.prototype._limitZoom=function(t){return Math.max(this.options.minZoom,Math.min(+t,this.options.maxZoom+1))},z.prototype._cluster=function(t,e){for(var i,r,n,o=[],a=this.options,s=a.radius,l=a.extent,u=a.reduce,c=a.minPoints,p=s/(l*Math.pow(2,e)),h=0;h<t.length;h++){var d=t[h];if(!(d.zoom<=e)){d.zoom=e;for(var f=this.trees[e+1],m=f.within(d.x,d.y,p),y=d.numPoints||1,g=y,v=0,_=m;v<_.length;v+=1){var x=_[v];(x=f.points[x]).zoom>e&&(g+=x.numPoints||1)}if(c<=g){for(var b=d.x*y,w=d.y*y,S=u&&1<y?this._map(d,!0):null,T=(h<<5)+(e+1)+this.points.length,C=0,E=m;C<E.length;C+=1){var I=E[C],k=f.points[I];k.zoom<=e||(k.zoom=e,I=k.numPoints||1,b+=k.x*I,w+=k.y*I,k.parentId=T,u&&u(S=S||this._map(d,!0),this._map(k)))}d.parentId=T,o.push((i=w/g,r=T,n=S,{x:B(b/(y=g)),y:B(i),zoom:1/0,id:r,parentId:-1,numPoints:y,properties:n}))}else if(o.push(d),1<g)for(var A=0,P=m;A<P.length;A+=1){var M=P[A];(M=f.points[M]).zoom<=e||(M.zoom=e,o.push(M))}}}return o},z.prototype._getOriginId=function(t){return t-this.points.length>>5},z.prototype._getOriginZoom=function(t){return(t-this.points.length)%32},dt.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!(z.prototype._map=function(t,e){if(t.numPoints)return e?q({},t.properties):t.properties;var i=this.points[t.index].properties;t=this.options.map(i);return e&&t===i?q({},t):t}),promoteId:null,generateId:!1,debug:0},dt.prototype.splitTile=function(t,e,i,r,n,o,a){for(var s=[t,e,i,r],l=this.options,u=l.debug;s.length;){r=s.pop(),i=s.pop(),e=s.pop(),t=s.pop();var c,p,h,d,f,m,y,g,v=1<<e,_=ft(e,i,r),x=this.tiles[_];if(x||(1<u&&console.time("creation"),x=this.tiles[_]=pt(t,e,i,r,l),this.tileCoords.push({z:e,x:i,y:r}),u&&(1<u&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",e,i,r,x.numFeatures,x.numPoints,x.numSimplified),console.timeEnd("creation")),this.stats[g="z"+e]=(this.stats[g]||0)+1,this.total++)),x.source=t,n){if(e===l.maxZoom||e===n)continue;var b=1<<n-e;if(i!==Math.floor(o/b)||r!==Math.floor(a/b))continue}else if(e===l.indexMaxZoom||x.numPoints<=l.indexMaxPoints)continue;x.source=null,0!==t.length&&(1<u&&console.time("clipping"),p=.5-(c=.5*l.buffer/l.extent),h=1+c,y=d=f=m=null,g=tt(t,v,i-c,i+(_=.5+c),0,x.minX,x.maxX,l),b=tt(t,v,i+p,i+h,0,x.minX,x.maxX,l),t=null,g&&(y=tt(g,v,r-c,r+_,1,x.minY,x.maxY,l),d=tt(g,v,r+p,r+h,1,x.minY,x.maxY,l),g=null),b&&(f=tt(b,v,r-c,r+_,1,x.minY,x.maxY,l),m=tt(b,v,r+p,r+h,1,x.minY,x.maxY,l),b=null),1<u&&console.timeEnd("clipping"),s.push(y||[],e+1,2*i,2*r),s.push(d||[],e+1,2*i,2*r+1),s.push(f||[],e+1,2*i+1,2*r),s.push(m||[],e+1,2*i+1,2*r+1))}},dt.prototype.getTile=function(t,e,i){var r=this.options,n=r.extent,o=r.debug;if(t<0||24<t)return null;if(r=ft(t,e=(e%(r=1<<t)+r)%r,i),this.tiles[r])return ut(this.tiles[r],n);1<o&&console.log("drilling down to z%d-%d-%d",t,e,i);for(var a,s=t,l=e,u=i;!a&&0<s;)s--,l=Math.floor(l/2),u=Math.floor(u/2),a=this.tiles[ft(s,l,u)];return a&&a.source?(1<o&&console.log("found parent tile z%d-%d-%d",s,l,u),1<o&&console.time("drilling down"),this.splitTile(a.source,s,l,u,t,e,i),1<o&&console.timeEnd("drilling down"),this.tiles[r]?ut(this.tiles[r],n):null):null};var yt,gt=((yt=s)&&(vt.__proto__=yt),((vt.prototype=Object.create(yt&&yt.prototype)).constructor=vt).prototype.loadData=function(t,e){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),this._pendingCallback=e,this._pendingLoadDataParams=t,this._state&&"Idle"!==this._state?this._state="NeedsLoadData":(this._state="Coalescing",this._loadData())},vt.prototype._loadData=function(){var e,i,r,n=this;this._pendingCallback&&this._pendingLoadDataParams&&(e=this._pendingCallback,i=this._pendingLoadDataParams,delete this._pendingCallback,delete this._pendingLoadDataParams,r=!!(i&&i.request&&i.request.collectResourceTiming)&&new t.RequestPerformance(i.request),this.loadGeoJSON(i,function(o,a){if(o||!a)return e(o);if("object"!=typeof a)return e(new Error("Input data given to '"+i.source+"' is not a valid GeoJSON object."));c(a,!0);try{if(i.filter){var s=t.createExpression(i.filter,{type:"boolean","property-type":"data-driven",overridable:!1,transition:!1});if("error"===s.result)throw new Error(s.value.map(function(t){return t.key+": "+t.message}).join(", "));a={type:"FeatureCollection",features:a.features.filter(function(t){return s.value.evaluate({zoom:0},t)})}}n._geoJSONIndex=i.cluster?new z(function(e){var i=e.superclusterOptions,r=e.clusterProperties;if(!r||!i)return i;for(var n={},o={},a={accumulated:null,zoom:0},s={properties:null},l=Object.keys(r),u=0,c=l;u<c.length;u+=1){var p=c[u],h=(d=r[p])[0],d=d[1];d=t.createExpression(d),h=t.createExpression("string"==typeof h?[h,["accumulated"],["get",p]]:h);n[p]=d.value,o[p]=h.value}return i.map=function(t){s.properties=t;for(var e={},i=0,r=l;i<r.length;i+=1){var o=r[i];e[o]=n[o].evaluate(a,s)}return e},i.reduce=function(t,e){s.properties=e;for(var i=0,r=l;i<r.length;i+=1){var n=r[i];a.accumulated=t[n],t[n]=o[n].evaluate(a,s)}},i}(i)).load(a.features):new dt(u=a,l=i.geojsonVtOptions)}catch(o){return e(o)}n.loaded={};var l,u={};!r||(l=r.finish())&&(u.resourceTiming={},u.resourceTiming[i.source]=JSON.parse(JSON.stringify(l))),e(null,u)}))},vt.prototype.coalesce=function(){"Coalescing"===this._state?this._state="Idle":"NeedsLoadData"===this._state&&(this._state="Coalescing",this._loadData())},vt.prototype.reloadTile=function(t,e){var i=this.loaded,r=t.uid;return i&&i[r]?yt.prototype.reloadTile.call(this,t,e):this.loadTile(t,e)},vt.prototype.loadGeoJSON=function(e,i){if(e.request)t.getJSON(e.request,i);else{if("string"!=typeof e.data)return i(new Error("Input data given to '"+e.source+"' is not a valid GeoJSON object."));try{return i(null,JSON.parse(e.data))}catch(t){return i(new Error("Input data given to '"+e.source+"' is not a valid GeoJSON object."))}}},vt.prototype.removeSource=function(t,e){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),e()},vt.prototype.getClusterExpansionZoom=function(t,e){try{e(null,this._geoJSONIndex.getClusterExpansionZoom(t.clusterId))}catch(t){e(t)}},vt.prototype.getClusterChildren=function(t,e){try{e(null,this._geoJSONIndex.getChildren(t.clusterId))}catch(t){e(t)}},vt.prototype.getClusterLeaves=function(t,e){try{e(null,this._geoJSONIndex.getLeaves(t.clusterId,t.limit,t.offset))}catch(t){e(t)}},vt);function vt(t,e,i,r){yt.call(this,t,e,i,mt),r&&(this.loadGeoJSON=r)}return(y=function(e){var i=this;this.self=e,this.actor=new t.Actor(e,this),this.layerIndexes={},this.availableImages={},this.workerSourceTypes={vector:s,geojson:gt},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=function(t,e){if(i.workerSourceTypes[t])throw new Error('Worker source with name "'+t+'" already registered.');i.workerSourceTypes[t]=e},this.self.registerRTLTextPlugin=function(e){if(t.plugin.isParsed())throw new Error("RTL text plugin already registered.");t.plugin.applyArabicShaping=e.applyArabicShaping,t.plugin.processBidirectionalText=e.processBidirectionalText,t.plugin.processStyledBidirectionalText=e.processStyledBidirectionalText}}).prototype.setReferrer=function(t,e){this.referrer=e},y.prototype.setImages=function(t,e,i){for(var r in this.availableImages[t]=e,this.workerSources[t]){var n,o=this.workerSources[t][r];for(n in o)o[n].availableImages=e}i()},y.prototype.setLayers=function(t,e,i){this.getLayerIndex(t).replace(e),i()},y.prototype.updateLayers=function(t,e,i){this.getLayerIndex(t).update(e.layers,e.removedIds),i()},y.prototype.loadTile=function(t,e,i){this.getWorkerSource(t,e.type,e.source).loadTile(e,i)},y.prototype.loadDEMTile=function(t,e,i){this.getDEMWorkerSource(t,e.source).loadTile(e,i)},y.prototype.reloadTile=function(t,e,i){this.getWorkerSource(t,e.type,e.source).reloadTile(e,i)},y.prototype.abortTile=function(t,e,i){this.getWorkerSource(t,e.type,e.source).abortTile(e,i)},y.prototype.removeTile=function(t,e,i){this.getWorkerSource(t,e.type,e.source).removeTile(e,i)},y.prototype.removeDEMTile=function(t,e){this.getDEMWorkerSource(t,e.source).removeTile(e)},y.prototype.removeSource=function(t,e,i){var r;this.workerSources[t]&&this.workerSources[t][e.type]&&this.workerSources[t][e.type][e.source]&&(r=this.workerSources[t][e.type][e.source],delete this.workerSources[t][e.type][e.source],void 0!==r.removeSource?r.removeSource(e,i):i())},y.prototype.loadWorkerSource=function(t,e,i){try{this.self.importScripts(e.url),i()}catch(t){i(t.toString())}},y.prototype.syncRTLPluginState=function(e,i,r){try{t.plugin.setState(i);var n,o=t.plugin.getPluginURL();t.plugin.isLoaded()&&!t.plugin.isParsed()&&null!=o&&(this.self.importScripts(o),r((n=t.plugin.isParsed())?void 0:new Error("RTL Text Plugin failed to import scripts from "+o),n))}catch(e){r(e.toString())}},y.prototype.getAvailableImages=function(t){return this.availableImages[t]||[]},y.prototype.getLayerIndex=function(t){return this.layerIndexes[t]||(this.layerIndexes[t]=new i)},y.prototype.getWorkerSource=function(t,e,i){var r=this;return this.workerSources[t]||(this.workerSources[t]={}),this.workerSources[t][e]||(this.workerSources[t][e]={}),this.workerSources[t][e][i]||(this.workerSources[t][e][i]=new this.workerSourceTypes[e]({send:function(e,i,n){r.actor.send(e,i,n,t)}},this.getLayerIndex(t),this.getAvailableImages(t))),this.workerSources[t][e][i]},y.prototype.getDEMWorkerSource=function(t,e){return this.demWorkerSources[t]||(this.demWorkerSources[t]={}),this.demWorkerSources[t][e]||(this.demWorkerSources[t][e]=new l),this.demWorkerSources[t][e]},y.prototype.enforceCacheSizeLimit=function(e,i){t.enforceCacheSizeLimit(i)},"undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope&&(self.worker=new y(self)),y}),i(0,function(t){var e=t.createCommonjsModule(function(t){function e(t){return!i(t)}function i(t){return"undefined"==typeof window||"undefined"==typeof document?"not a browser":Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray?Function.prototype&&Function.prototype.bind?Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions?"JSON"in window&&"parse"in JSON&&"stringify"in JSON?function(){if(!("Worker"in window&&"Blob"in window&&"URL"in window))return!1;var t,e,i=new Blob([""],{type:"text/javascript"});i=URL.createObjectURL(i);try{e=new Worker(i),t=!0}catch(e){t=!1}return e&&e.terminate(),URL.revokeObjectURL(i),t}()?"Uint8ClampedArray"in window?ArrayBuffer.isView?function(){var t=document.createElement("canvas");t.width=t.height=1;var e=t.getContext("2d");return!!e&&((e=e.getImageData(0,0,1,1))&&e.width===t.width)}()?function(t){return void 0===r[t]&&(r[t]=function(t){var i=function(t){var i=document.createElement("canvas"),r=Object.create(e.webGLContextAttributes);return r.failIfMajorPerformanceCaveat=t,i.probablySupportsContext?i.probablySupportsContext("webgl",r)||i.probablySupportsContext("experimental-webgl",r):i.supportsContext?i.supportsContext("webgl",r)||i.supportsContext("experimental-webgl",r):i.getContext("webgl",r)||i.getContext("experimental-webgl",r)}(t);return!!i&&(!(!(t=i.createShader(i.VERTEX_SHADER))||i.isContextLost())&&(i.shaderSource(t,"void main() {}"),i.compileShader(t),!0===i.getShaderParameter(t,i.COMPILE_STATUS)))}(t)),r[t]}(t&&t.failIfMajorPerformanceCaveat)?void 0:"insufficient WebGL support":"insufficient Canvas/getImageData support":"insufficient ArrayBuffer support":"insufficient Uint8ClampedArray support":"insufficient worker support":"insufficient JSON support":"insufficient Object support":"insufficient Function support":"insufficent Array support"}t.exports?t.exports=e:window&&(window.mapboxgl=window.mapboxgl||{},window.mapboxgl.supported=e,window.mapboxgl.notSupportedReason=i);var r={};e.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0}}),i={create:function(e,i,r){return e=t.window.document.createElement(e),void 0!==i&&(e.className=i),r&&r.appendChild(e),e},createNS:function(e,i){return t.window.document.createElementNS(e,i)}},r=t.window.document&&t.window.document.documentElement.style;function n(t){if(!r)return t[0];for(var e=0;e<t.length;e++)if(t[e]in r)return t[e];return t[0]}var o,a=n(["userSelect","MozUserSelect","WebkitUserSelect","msUserSelect"]);i.disableDrag=function(){r&&a&&(o=r[a],r[a]="none")},i.enableDrag=function(){r&&a&&(r[a]=o)};var s=n(["transform","WebkitTransform"]),l=!(i.setTransform=function(t,e){t.style[s]=e});try{var u=Object.defineProperty({},"passive",{get:function(){l=!0}});t.window.addEventListener("test",u,u),t.window.removeEventListener("test",u,u)}catch(n){l=!1}function c(e){e.preventDefault(),e.stopPropagation(),t.window.removeEventListener("click",c,!0)}i.addEventListener=function(t,e,i,r){"passive"in(r=void 0===r?{}:r)&&l?t.addEventListener(e,i,r):t.addEventListener(e,i,r.capture)},i.removeEventListener=function(t,e,i,r){"passive"in(r=void 0===r?{}:r)&&l?t.removeEventListener(e,i,r):t.removeEventListener(e,i,r.capture)},i.suppressClick=function(){t.window.addEventListener("click",c,!0),t.window.setTimeout(function(){t.window.removeEventListener("click",c,!0)},0)},i.mousePos=function(e,i){var r=e.getBoundingClientRect();return new t.Point(i.clientX-r.left-e.clientLeft,i.clientY-r.top-e.clientTop)},i.touchPos=function(e,i){for(var r=e.getBoundingClientRect(),n=[],o=0;o<i.length;o++)n.push(new t.Point(i[o].clientX-r.left-e.clientLeft,i[o].clientY-r.top-e.clientTop));return n},i.mouseButton=function(e){return void 0!==t.window.InstallTrigger&&2===e.button&&e.ctrlKey&&0<=t.window.navigator.platform.toUpperCase().indexOf("MAC")?0:e.button},i.remove=function(t){t.parentNode&&t.parentNode.removeChild(t)};var p,h=((p=t.Evented)&&(d.__proto__=p),((d.prototype=Object.create(p&&p.prototype)).constructor=d).prototype.isLoaded=function(){return this.loaded},d.prototype.setLoaded=function(t){if(this.loaded!==t&&(this.loaded=t)){for(var e=0,i=this.requestors;e<i.length;e+=1){var r=(n=i[e]).ids,n=n.callback;this._notify(r,n)}this.requestors=[]}},d.prototype.getImage=function(t){return this.images[t]},d.prototype.addImage=function(t,e){this._validate(t,e)&&(this.images[t]=e)},d.prototype._validate=function(e,i){var r=!0;return this._validateStretch(i.stretchX,i.data&&i.data.width)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "stretchX" value'))),r=!1),this._validateStretch(i.stretchY,i.data&&i.data.height)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "stretchY" value'))),r=!1),this._validateContent(i.content,i)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "content" value'))),r=!1),r},d.prototype._validateStretch=function(t,e){if(!t)return!0;for(var i=0,r=0,n=t;r<n.length;r+=1){var o=n[r];if(o[0]<i||o[1]<o[0]||e<o[1])return!1;i=o[1]}return!0},d.prototype._validateContent=function(t,e){return!(t&&(4!==t.length||t[0]<0||e.data.width<t[0]||t[1]<0||e.data.height<t[1]||t[2]<0||e.data.width<t[2]||t[3]<0||e.data.height<t[3]||t[2]<t[0]||t[3]<t[1]))},d.prototype.updateImage=function(t,e){var i=this.images[t];e.version=i.version+1,this.images[t]=e,this.updatedImages[t]=!0},d.prototype.removeImage=function(t){var e=this.images[t];delete this.images[t],delete this.patterns[t],e.userImage&&e.userImage.onRemove&&e.userImage.onRemove()},d.prototype.listImages=function(){return Object.keys(this.images)},d.prototype.getImages=function(t,e){var i=!0;if(!this.isLoaded())for(var r=0,n=t;r<n.length;r+=1){var o=n[r];this.images[o]||(i=!1)}this.isLoaded()||i?this._notify(t,e):this.requestors.push({ids:t,callback:e})},d.prototype._notify=function(e,i){for(var r={},n=0,o=e;n<o.length;n+=1){var a=o[n];this.images[a]||this.fire(new t.Event("styleimagemissing",{id:a}));var s=this.images[a];s?r[a]={data:s.data.clone(),pixelRatio:s.pixelRatio,sdf:s.sdf,version:s.version,stretchX:s.stretchX,stretchY:s.stretchY,content:s.content,hasRenderCallback:Boolean(s.userImage&&s.userImage.render)}:t.warnOnce('Image "'+a+'" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.')}i(null,r)},d.prototype.getPixelSize=function(){var t=this.atlasImage;return{width:t.width,height:t.height}},d.prototype.getPattern=function(e){var i=this.patterns[e],r=this.getImage(e);return r?i&&i.position.version===r.version?i.position:(i?i.position.version=r.version:(i={w:r.data.width+2,h:r.data.height+2,x:0,y:0},r=new t.ImagePosition(i,r),this.patterns[e]={bin:i,position:r}),this._updatePatternAtlas(),this.patterns[e].position):null},d.prototype.bind=function(e){var i=e.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new t.Texture(e,this.atlasImage,i.RGBA),this.atlasTexture.bind(i.LINEAR,i.CLAMP_TO_EDGE)},d.prototype._updatePatternAtlas=function(){var e,i=[];for(e in this.patterns)i.push(this.patterns[e].bin);var r,n=(o=t.potpack(i)).w,o=o.h,a=this.atlasImage;for(r in a.resize({width:n||1,height:o||1}),this.patterns){var s=(p=this.patterns[r].bin).x+1,l=p.y+1,u=this.images[r].data,c=u.width,p=u.height;t.RGBAImage.copy(u,a,{x:0,y:0},{x:s,y:l},{width:c,height:p}),t.RGBAImage.copy(u,a,{x:0,y:p-1},{x:s,y:l-1},{width:c,height:1}),t.RGBAImage.copy(u,a,{x:0,y:0},{x:s,y:l+p},{width:c,height:1}),t.RGBAImage.copy(u,a,{x:c-1,y:0},{x:s-1,y:l},{width:1,height:p}),t.RGBAImage.copy(u,a,{x:0,y:0},{x:s+c,y:l},{width:1,height:p})}this.dirty=!0},d.prototype.beginFrame=function(){this.callbackDispatchedThisFrame={}},d.prototype.dispatchRenderCallbacks=function(t){for(var e,i,r=0,n=t;r<n.length;r+=1){var o,a=n[r];this.callbackDispatchedThisFrame[a]||(this.callbackDispatchedThisFrame[a]=!0,i=void 0,(i=(e=o=this.images[a]).userImage)&&i.render&&i.render()&&(e.data.replace(new Uint8Array(i.data.buffer)),1)&&this.updateImage(a,o))}},d);function d(){p.call(this),this.images={},this.updatedImages={},this.callbackDispatchedThisFrame={},this.loaded=!1,this.requestors=[],this.patterns={},this.atlasImage=new t.RGBAImage({width:1,height:1}),this.dirty=!0}var f=g,m=g,y=1e20;function g(t,e,i,r,n,o){this.fontSize=t||24,this.buffer=void 0===e?3:e,this.cutoff=r||.25,this.fontFamily=n||"sans-serif",this.fontWeight=o||"normal",this.radius=i||8,i=(o=this.size=this.fontSize+2*this.buffer)+2*this.buffer,this.canvas=document.createElement("canvas"),this.canvas.width=this.canvas.height=o,this.ctx=this.canvas.getContext("2d"),this.ctx.font=this.fontWeight+" "+this.fontSize+"px "+this.fontFamily,this.ctx.textAlign="left",this.ctx.fillStyle="black",this.gridOuter=new Float64Array(i*i),this.gridInner=new Float64Array(i*i),this.f=new Float64Array(i),this.z=new Float64Array(i+1),this.v=new Uint16Array(i),this.useMetrics=void 0!==this.ctx.measureText("A").actualBoundingBoxLeft,this.middle=Math.round(o/2*(0<=navigator.userAgent.indexOf("Gecko/")?1.2:1))}function v(t,e,i,r,n,o){for(var a=0;a<e;a++)_(t,a,e,i,r,n,o);for(var s=0;s<i;s++)_(t,s*e,1,e,r,n,o)}function _(t,e,i,r,n,o,a){var s,l,u,c;for(a[o[0]=0]=-y,a[1]=y,s=0;s<r;s++)n[s]=t[e+s*i];for(s=1,u=l=0;s<r;s++){for(;c=o[l],(u=(n[s]-n[c]+s*s-c*c)/(s-c)/2)<=a[l]&&-1<--l;);o[++l]=s,a[l]=u,a[l+1]=y}for(l=s=0;s<r;s++){for(;a[l+1]<s;)l++;c=o[l],t[e+s*i]=n[c]+(s-c)*(s-c)}}function x(t,e){this.requestManager=t,this.localIdeographFontFamily=e,this.entries={}}g.prototype._draw=function(t,e){var i,r,n,o,a,s,l,u,c=this.ctx.measureText(t),p=c.width,h=2*this.buffer;e&&this.useMetrics?(a=Math.floor(c.actualBoundingBoxAscent),l=this.buffer+Math.ceil(c.actualBoundingBoxAscent),d=this.buffer,s=this.buffer,i=(r=Math.min(this.size,Math.ceil(c.actualBoundingBoxRight-c.actualBoundingBoxLeft)))+h,n=(o=Math.min(this.size-d,Math.ceil(c.actualBoundingBoxAscent+c.actualBoundingBoxDescent)))+h,this.ctx.textBaseline="alphabetic"):(i=r=this.size,n=o=this.size,a=19*this.fontSize/24,d=s=0,l=this.middle,this.ctx.textBaseline="middle"),r&&o&&(this.ctx.clearRect(s,d,r,o),this.ctx.fillText(t,this.buffer,l),u=this.ctx.getImageData(s,d,r,o));var d=new Uint8ClampedArray(i*n);return function(t,e,i,r,n,o,a){o.fill(y,0,e*i),a.fill(0,0,e*i);for(var s=(e-r)/2,l=0;l<n;l++)for(var u=0;u<r;u++){var c,p=(l+s)*e+u+s,h=t.data[4*(l*r+u)+3]/255;1==h?(o[p]=0,a[p]=y):0==h?(o[p]=y,a[p]=0):(c=Math.max(0,.5-h),h=Math.max(0,h-.5),o[p]=c*c,a[p]=h*h)}}(u,i,n,r,o,this.gridOuter,this.gridInner),v(this.gridOuter,i,n,this.f,this.v,this.z),v(this.gridInner,i,n,this.f,this.v,this.z),function(t,e,i,r,n,o,a){for(var s=0;s<e*i;s++){var l=Math.sqrt(r[s])-Math.sqrt(n[s]);t[s]=Math.round(255-255*(l/o+a))}}(d,i,n,this.gridOuter,this.gridInner,this.radius,this.cutoff),{data:d,metrics:{width:r,height:o,sdfWidth:i,sdfHeight:n,top:a,left:0,advance:p}}},g.prototype.draw=function(t){return this._draw(t,!1).data},g.prototype.drawWithMetrics=function(t){return this._draw(t,!0)},f.default=m,x.prototype.setURL=function(t){this.url=t},x.prototype.getGlyphs=function(e,i){var r,n=this,o=[];for(r in e)for(var a=0,s=e[r];a<s.length;a+=1){var l=s[a];o.push({stack:r,id:l})}t.asyncAll(o,function(t,e){var i=t.stack,r=t.id,o=n.entries[i];if(void 0===(t=(o=o||(n.entries[i]={glyphs:{},requests:{},ranges:{}})).glyphs[r])){if(t=n._tinySDF(o,i,r))return o.glyphs[r]=t,void e(null,{stack:i,id:r,glyph:t});var a,s=Math.floor(r/256);65535<256*s?e(new Error("glyphs > 65535 not supported")):o.ranges[s]?e(null,{stack:i,id:r,glyph:t}):((a=o.requests[s])||(a=o.requests[s]=[],x.loadGlyphRange(i,s,n.url,n.requestManager,function(t,e){if(e){for(var i in e)n._doesCharSupportLocalGlyph(+i)||(o.glyphs[+i]=e[+i]);o.ranges[s]=!0}for(var r=0,l=a;r<l.length;r+=1)(0,l[r])(t,e);delete o.requests[s]})),a.push(function(t,n){t?e(t):n&&e(null,{stack:i,id:r,glyph:n[r]||null})}))}else e(null,{stack:i,id:r,glyph:t})},function(t,e){if(t)i(t);else if(e){for(var r={},n=0,o=e;n<o.length;n+=1){var a=(l=o[n]).stack,s=l.id,l=l.glyph;(r[a]||(r[a]={}))[s]=l&&{id:l.id,bitmap:l.bitmap.clone(),metrics:l.metrics}}i(null,r)}})},x.prototype._doesCharSupportLocalGlyph=function(e){return!!this.localIdeographFontFamily&&(t.isChar["CJK Unified Ideographs"](e)||t.isChar["Hangul Syllables"](e)||t.isChar.Hiragana(e)||t.isChar.Katakana(e))},x.prototype._tinySDF=function(e,i,r){var n=this.localIdeographFontFamily;if(n&&this._doesCharSupportLocalGlyph(r)){var o,a=e.tinySDF;return a||(o="400",/bold/i.test(i)?o="900":/medium/i.test(i)?o="500":/light/i.test(i)&&(o="200"),a=e.tinySDF=new x.TinySDF(24,3,8,.25,n,o)),{id:r,bitmap:new t.AlphaImage({width:30,height:30},a.draw(String.fromCharCode(r))),metrics:{width:24,height:24,left:0,top:-8,advance:24}}}},x.loadGlyphRange=function(e,i,r,n,o){var a=256*i;i=255+a,i=n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}",e).replace("{range}",a+"-"+i),t.ResourceType.Glyphs);t.getArrayBuffer(i,function(e,i){if(e)o(e);else if(i){for(var r={},n=0,a=t.parseGlyphPBF(i);n<a.length;n+=1){var s=a[n];r[s.id]=s}o(null,r)}})},x.TinySDF=f,(Rr=function(){this.specification=t.styleSpec.light.position}).prototype.possiblyEvaluate=function(e,i){return t.sphericalToCartesian(e.expression.evaluate(i))},Rr.prototype.interpolate=function(e,i,r){return{x:t.number(e.x,i.x,r),y:t.number(e.y,i.y,r),z:t.number(e.z,i.z,r)}};var b,w=new t.Properties({anchor:new t.DataConstantProperty(t.styleSpec.light.anchor),position:new Rr,color:new t.DataConstantProperty(t.styleSpec.light.color),intensity:new t.DataConstantProperty(t.styleSpec.light.intensity)}),S="-transition",T=((b=t.Evented)&&(C.__proto__=b),((C.prototype=Object.create(b&&b.prototype)).constructor=C).prototype.getLight=function(){return this._transitionable.serialize()},C.prototype.setLight=function(e,i){if(!this._validate(t.validateLight,e,i=void 0===i?{}:i))for(var r in e){var n=e[r];t.endsWith(r,S)?this._transitionable.setTransition(r.slice(0,-S.length),n):this._transitionable.setValue(r,n)}},C.prototype.updateTransitions=function(t){this._transitioning=this._transitionable.transitioned(t,this._transitioning)},C.prototype.hasTransition=function(){return this._transitioning.hasTransition()},C.prototype.recalculate=function(t){this.properties=this._transitioning.possiblyEvaluate(t)},C.prototype._validate=function(e,i,r){return(!r||!1!==r.validate)&&t.emitValidationErrors(this,e.call(t.validateStyle,t.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:t.styleSpec})))},C);function C(e){b.call(this),this._transitionable=new t.Transitionable(w),this.setLight(e),this._transitioning=this._transitionable.untransitioned()}function E(t,e){this.width=t,this.height=e,this.nextRow=0,this.data=new Uint8Array(this.width*this.height),this.dashEntry={}}function I(e,i){this.workerPool=e,this.actors=[],this.currentActor=0,this.id=t.uniqueId();for(var r=this.workerPool.acquire(this.id),n=0;n<r.length;n++){var o=r[n];(o=new I.Actor(o,i,this.id)).name="Worker "+n,this.actors.push(o)}}function k(e,i,r){function n(n,o){if(n)return r(n);o&&(n=t.pick(t.extend(o,e),["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds","scheme","tileSize","encoding"]),o.vector_layers&&(n.vectorLayers=o.vector_layers,n.vectorLayerIds=n.vectorLayers.map(function(t){return t.id})),n.tiles=i.canonicalizeTileset(n,e.url),r(null,n))}return e.url?t.getJSON(i.transformRequest(i.normalizeSourceURL(e.url),t.ResourceType.Source),n):t.browser.frame(function(){return n(null,e)})}function A(e,i,r){this.bounds=t.LngLatBounds.convert(this.validateBounds(e)),this.minzoom=i||0,this.maxzoom=r||24}E.prototype.getDash=function(t,e){var i=t.join(",")+String(e);return this.dashEntry[i]||(this.dashEntry[i]=this.addDash(t,e)),this.dashEntry[i]},E.prototype.getDashRanges=function(t,e,i){var r=[],n=t.length%2==1?-t[t.length-1]*i:0,o=t[0]*i,a=!0;r.push({left:n,right:o,isDash:a,zeroLength:0===t[0]});for(var s=t[0],l=1;l<t.length;l++){a=!a;var u=t[l];n=s*i;s+=u,r.push({left:n,right:s*i,isDash:a,zeroLength:0===u})}return r},E.prototype.addRoundDash=function(t,e,i){for(var r=e/2,n=-i;n<=i;n++)for(var o=this.nextRow+i+n,a=this.width*o,s=0,l=t[s],u=0;u<this.width;u++){1<u/l.right&&(l=t[++s]);var c,p=Math.abs(u-l.left),h=Math.abs(u-l.right),d=Math.min(p,h);p=n/i*(1+r);c=l.isDash?(h=r-Math.abs(p),Math.sqrt(d*d+h*h)):r-Math.sqrt(d*d+p*p),this.data[a+u]=Math.max(0,Math.min(255,c+128))}},E.prototype.addRegularDash=function(t){for(var e=t.length-1;0<=e;--e){var i=t[e],r=t[e+1];i.zeroLength?t.splice(e,1):r&&r.isDash===i.isDash&&(r.left=i.left,t.splice(e,1))}var n=t[0],o=t[t.length-1];n.isDash===o.isDash&&(n.left=o.left-this.width,o.right=n.right+this.width);for(var a=this.width*this.nextRow,s=0,l=t[s],u=0;u<this.width;u++){1<u/l.right&&(l=t[++s]);var c=Math.abs(u-l.left),p=Math.abs(u-l.right);p=Math.min(c,p),p=l.isDash?p:-p;this.data[a+u]=Math.max(0,Math.min(255,p+128))}},E.prototype.addDash=function(e,i){var r=i?7:0,n=2*r+1;if(this.nextRow+n>this.height)return t.warnOnce("LineAtlas out of space"),null;for(var o,a,s=0,l=0;l<e.length;l++)s+=e[l];return 0!==s&&(o=this.width/s,a=this.getDashRanges(e,this.width,o),i?this.addRoundDash(a,o,r):this.addRegularDash(a)),r={y:(this.nextRow+r+.5)/this.height,height:2*r/this.height,width:s},this.nextRow+=n,this.dirty=!0,r},E.prototype.bind=function(t){t=t.gl,this.texture?(t.bindTexture(t.TEXTURE_2D,this.texture),this.dirty&&(this.dirty=!1,t.texSubImage2D(t.TEXTURE_2D,0,0,0,this.width,this.height,t.ALPHA,t.UNSIGNED_BYTE,this.data))):(this.texture=t.createTexture(),t.bindTexture(t.TEXTURE_2D,this.texture),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_S,t.REPEAT),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_WRAP_T,t.REPEAT),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MIN_FILTER,t.LINEAR),t.texParameteri(t.TEXTURE_2D,t.TEXTURE_MAG_FILTER,t.LINEAR),t.texImage2D(t.TEXTURE_2D,0,t.ALPHA,this.width,this.height,0,t.ALPHA,t.UNSIGNED_BYTE,this.data))},I.prototype.broadcast=function(e,i,r){t.asyncAll(this.actors,function(t,r){t.send(e,i,r)},r=r||function(){})},I.prototype.getActor=function(){return this.currentActor=(this.currentActor+1)%this.actors.length,this.actors[this.currentActor]},I.prototype.remove=function(){this.actors.forEach(function(t){t.remove()}),this.actors=[],this.workerPool.release(this.id)},I.Actor=t.Actor,A.prototype.validateBounds=function(t){return Array.isArray(t)&&4===t.length?[Math.max(-180,t[0]),Math.max(-90,t[1]),Math.min(180,t[2]),Math.min(90,t[3])]:[-180,-90,180,90]},A.prototype.contains=function(e){var i=Math.pow(2,e.z),r=Math.floor(t.mercatorXfromLng(this.bounds.getWest())*i),n=Math.floor(t.mercatorYfromLat(this.bounds.getNorth())*i),o=Math.ceil(t.mercatorXfromLng(this.bounds.getEast())*i);i=Math.ceil(t.mercatorYfromLat(this.bounds.getSouth())*i);return e.x>=r&&e.x<o&&e.y>=n&&e.y<i};var P,M=((P=t.Evented)&&(L.__proto__=P),((L.prototype=Object.create(P&&P.prototype)).constructor=L).prototype.load=function(){var e=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=k(this._options,this.map._requestManager,function(i,r){e._tileJSONRequest=null,e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):r&&(t.extend(e,r),r.bounds&&(e.tileBounds=new A(r.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(r.tiles,e.map._requestManager._customAccessToken),t.postMapLoadEvent(r.tiles,e.map._getMapId(),e.map._requestManager._skuToken,e.map._requestManager._customAccessToken),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})))})},L.prototype.loaded=function(){return this._loaded},L.prototype.hasTile=function(t){return!this.tileBounds||this.tileBounds.contains(t.canonical)},L.prototype.onAdd=function(t){this.map=t,this.load()},L.prototype.setSourceProperty=function(t){this._tileJSONRequest&&this._tileJSONRequest.cancel(),t(),this.map.style.sourceCaches[this.id].clearTiles(),this.load()},L.prototype.setTiles=function(t){var e=this;return this.setSourceProperty(function(){e._options.tiles=t}),this},L.prototype.setUrl=function(t){var e=this;return this.setSourceProperty(function(){e.url=t,e._options.url=t}),this},L.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null)},L.prototype.serialize=function(){return t.extend({},this._options)},L.prototype.loadTile=function(e,i){var r=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme));function n(r,n){return delete e.request,e.aborted?i(null):r&&404!==r.status?i(r):(n&&n.resourceTiming&&(e.resourceTiming=n.resourceTiming),this.map._refreshExpiredTiles&&n&&e.setExpiryData(n),e.loadVectorData(n,this.map.painter),t.cacheEntryPossiblyAdded(this.dispatcher),i(null),void(e.reloadCallback&&(this.loadTile(e,e.reloadCallback),e.reloadCallback=null)))}(r={request:this.map._requestManager.transformRequest(r,t.ResourceType.Tile),uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,tileSize:this.tileSize*e.tileID.overscaleFactor(),type:this.type,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId}).request.collectResourceTiming=this._collectResourceTiming,e.actor&&"expired"!==e.state?"loading"===e.state?e.reloadCallback=i:e.request=e.actor.send("reloadTile",r,n.bind(this)):(e.actor=this.dispatcher.getActor(),e.request=e.actor.send("loadTile",r,n.bind(this)))},L.prototype.abortTile=function(t){t.request&&(t.request.cancel(),delete t.request),t.actor&&t.actor.send("abortTile",{uid:t.uid,type:this.type,source:this.id},void 0)},L.prototype.unloadTile=function(t){t.unloadVectorData(),t.actor&&t.actor.send("removeTile",{uid:t.uid,type:this.type,source:this.id},void 0)},L.prototype.hasTransition=function(){return!1},L);function L(e,i,r,n){if(P.call(this),this.id=e,this.dispatcher=r,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,this._loaded=!1,t.extend(this,t.pick(i,["url","scheme","tileSize","promoteId"])),this._options=t.extend({type:"vector"},i),this._collectResourceTiming=i.collectResourceTiming,512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(n)}var O,R=((O=t.Evented)&&(z.__proto__=O),((z.prototype=Object.create(O&&O.prototype)).constructor=z).prototype.load=function(){var e=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=k(this._options,this.map._requestManager,function(i,r){e._tileJSONRequest=null,e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):r&&(t.extend(e,r),r.bounds&&(e.tileBounds=new A(r.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(r.tiles),t.postMapLoadEvent(r.tiles,e.map._getMapId(),e.map._requestManager._skuToken),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})))})},z.prototype.loaded=function(){return this._loaded},z.prototype.onAdd=function(t){this.map=t,this.load()},z.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null)},z.prototype.serialize=function(){return t.extend({},this._options)},z.prototype.hasTile=function(t){return!this.tileBounds||this.tileBounds.contains(t.canonical)},z.prototype.loadTile=function(e,i){var r=this,n=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.tileSize);e.request=t.getImage(this.map._requestManager.transformRequest(n,t.ResourceType.Tile),function(n,o){var a;delete e.request,e.aborted?(e.state="unloaded",i(null)):n?(e.state="errored",i(n)):o&&(r.map._refreshExpiredTiles&&e.setExpiryData(o),delete o.cacheControl,delete o.expires,n=(a=r.map.painter.context).gl,e.texture=r.map.painter.getTileTexture(o.width),e.texture?e.texture.update(o,{useMipmap:!0}):(e.texture=new t.Texture(a,o,n.RGBA,{useMipmap:!0}),e.texture.bind(n.LINEAR,n.CLAMP_TO_EDGE,n.LINEAR_MIPMAP_NEAREST),a.extTextureFilterAnisotropic&&n.texParameterf(n.TEXTURE_2D,a.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,a.extTextureFilterAnisotropicMax)),e.state="loaded",t.cacheEntryPossiblyAdded(r.dispatcher),i(null))})},z.prototype.abortTile=function(t,e){t.request&&(t.request.cancel(),delete t.request),e()},z.prototype.unloadTile=function(t,e){t.texture&&this.map.painter.saveTileTexture(t.texture),e()},z.prototype.hasTransition=function(){return!1},z);function z(e,i,r,n){O.call(this),this.id=e,this.dispatcher=r,this.setEventedParent(n),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=t.extend({type:"raster"},i),t.extend(this,t.pick(i,["url","scheme","tileSize"]))}var D,N=((D=R)&&(B.__proto__=D),((B.prototype=Object.create(D&&D.prototype)).constructor=B).prototype.serialize=function(){return{type:"raster-dem",url:this.url,tileSize:this.tileSize,tiles:this.tiles,bounds:this.bounds,encoding:this.encoding}},B.prototype.loadTile=function(e,i){var r=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.tileSize);e.request=t.getImage(this.map._requestManager.transformRequest(r,t.ResourceType.Tile),function(r,n){delete e.request,e.aborted?(e.state="unloaded",i(null)):r?(e.state="errored",i(r)):n&&(this.map._refreshExpiredTiles&&e.setExpiryData(n),delete n.cacheControl,delete n.expires,n=t.window.ImageBitmap&&n instanceof t.window.ImageBitmap&&t.offscreenCanvasSupported()?n:t.browser.getImageData(n,1),n={uid:e.uid,coord:e.tileID,source:this.id,rawImageData:n,encoding:this.encoding},e.actor&&"expired"!==e.state||(e.actor=this.dispatcher.getActor(),e.actor.send("loadDEMTile",n,function(t,r){t&&(e.state="errored",i(t)),r&&(e.dem=r,e.needsHillshadePrepare=!0,e.state="loaded",i(null))}.bind(this))))}.bind(this)),e.neighboringTiles=this._getNeighboringTiles(e.tileID)},B.prototype._getNeighboringTiles=function(e){var i=e.canonical,r=Math.pow(2,i.z),n=(i.x-1+r)%r,o=0===i.x?e.wrap-1:e.wrap,a=(i.x+1+r)%r,s=i.x+1===r?e.wrap+1:e.wrap,l={};return l[new t.OverscaledTileID(e.overscaledZ,o,i.z,n,i.y).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,a,i.y).key]={backfilled:!1},0<i.y&&(l[new t.OverscaledTileID(e.overscaledZ,o,i.z,n,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,a,i.y-1).key]={backfilled:!1}),i.y+1<r&&(l[new t.OverscaledTileID(e.overscaledZ,o,i.z,n,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,a,i.y+1).key]={backfilled:!1}),l},B.prototype.unloadTile=function(t){t.demTexture&&this.map.painter.saveTileTexture(t.demTexture),t.fbo&&(t.fbo.destroy(),delete t.fbo),t.dem&&delete t.dem,delete t.neighboringTiles,t.state="unloaded",t.actor&&t.actor.send("removeDEMTile",{uid:t.uid,source:this.id})},B);function B(e,i,r,n){D.call(this,e,i,r,n),this.type="raster-dem",this.maxzoom=22,this._options=t.extend({type:"raster-dem"},i),this.encoding=i.encoding||"mapbox"}var F,U=((F=t.Evented)&&(j.__proto__=F),((j.prototype=Object.create(F&&F.prototype)).constructor=j).prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData(function(i){i?e.fire(new t.ErrorEvent(i)):(i={dataType:"source",sourceDataType:"metadata"},e._collectResourceTiming&&e._resourceTiming&&0<e._resourceTiming.length&&(i.resourceTiming=e._resourceTiming,e._resourceTiming=[]),e.fire(new t.Event("data",i)))})},j.prototype.onAdd=function(t){this.map=t,this.load()},j.prototype.setData=function(e){var i=this;return this._data=e,this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData(function(e){e?i.fire(new t.ErrorEvent(e)):(e={dataType:"source",sourceDataType:"content"},i._collectResourceTiming&&i._resourceTiming&&0<i._resourceTiming.length&&(e.resourceTiming=i._resourceTiming,i._resourceTiming=[]),i.fire(new t.Event("data",e)))}),this},j.prototype.getClusterExpansionZoom=function(t,e){return this.actor.send("geojson.getClusterExpansionZoom",{clusterId:t,source:this.id},e),this},j.prototype.getClusterChildren=function(t,e){return this.actor.send("geojson.getClusterChildren",{clusterId:t,source:this.id},e),this},j.prototype.getClusterLeaves=function(t,e,i,r){return this.actor.send("geojson.getClusterLeaves",{source:this.id,clusterId:t,limit:e,offset:i},r),this},j.prototype._updateWorkerData=function(e){var i=this;this._loaded=!1;var r=t.extend({},this.workerOptions),n=this._data;"string"==typeof n?(r.request=this.map._requestManager.transformRequest(t.browser.resolveURL(n),t.ResourceType.Source),r.request.collectResourceTiming=this._collectResourceTiming):r.data=JSON.stringify(n),this.actor.send(this.type+".loadData",r,function(t,n){i._removed||n&&n.abandoned||(i._loaded=!0,n&&n.resourceTiming&&n.resourceTiming[i.id]&&(i._resourceTiming=n.resourceTiming[i.id].slice(0)),i.actor.send(i.type+".coalesce",{source:r.source},null),e(t))})},j.prototype.loaded=function(){return this._loaded},j.prototype.loadTile=function(e,i){var r=this,n=e.actor?"reloadTile":"loadTile";e.actor=this.actor;var o={type:this.type,uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId};e.request=this.actor.send(n,o,function(t,o){return delete e.request,e.unloadVectorData(),e.aborted?i(null):t?i(t):(e.loadVectorData(o,r.map.painter,"reloadTile"==n),i(null))})},j.prototype.abortTile=function(t){t.request&&(t.request.cancel(),delete t.request),t.aborted=!0},j.prototype.unloadTile=function(t){t.unloadVectorData(),this.actor.send("removeTile",{uid:t.uid,type:this.type,source:this.id})},j.prototype.onRemove=function(){this._removed=!0,this.actor.send("removeSource",{type:this.type,source:this.id})},j.prototype.serialize=function(){return t.extend({},this._options,{type:this.type,data:this._data})},j.prototype.hasTransition=function(){return!1},j);function j(e,i,r,n){F.call(this),this.id=e,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this._removed=!1,this._loaded=!1,this.actor=r.getActor(),this.setEventedParent(n),this._data=i.data,this._options=t.extend({},i),this._collectResourceTiming=i.collectResourceTiming,this._resourceTiming=[],void 0!==i.maxzoom&&(this.maxzoom=i.maxzoom),i.type&&(this.type=i.type),i.attribution&&(this.attribution=i.attribution),this.promoteId=i.promoteId,n=t.EXTENT/this.tileSize,this.workerOptions=t.extend({source:this.id,cluster:i.cluster||!1,geojsonVtOptions:{buffer:(void 0!==i.buffer?i.buffer:128)*n,tolerance:(void 0!==i.tolerance?i.tolerance:.375)*n,extent:t.EXTENT,maxZoom:this.maxzoom,lineMetrics:i.lineMetrics||!1,generateId:i.generateId||!1},superclusterOptions:{maxZoom:void 0!==i.clusterMaxZoom?Math.min(i.clusterMaxZoom,this.maxzoom-1):this.maxzoom-1,minPoints:Math.max(2,i.clusterMinPoints||2),extent:t.EXTENT,radius:(i.clusterRadius||50)*n,log:!1,generateId:i.generateId||!1},clusterProperties:i.clusterProperties,filter:i.filter},i.workerOptions)}var V,q=t.createLayout([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]),H=((V=t.Evented)&&(G.__proto__=V),((G.prototype=Object.create(V&&V.prototype)).constructor=G).prototype.load=function(e,i){var r=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this.url=this.options.url,t.getImage(this.map._requestManager.transformRequest(this.url,t.ResourceType.Image),function(n,o){r._loaded=!0,n?r.fire(new t.ErrorEvent(n)):o&&(r.image=o,e&&(r.coordinates=e),i&&i(),r._finishLoading())})},G.prototype.loaded=function(){return this._loaded},G.prototype.updateImage=function(t){var e=this;return this.image&&t.url&&(this.options.url=t.url,this.load(t.coordinates,function(){e.texture=null})),this},G.prototype._finishLoading=function(){this.map&&(this.setCoordinates(this.coordinates),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})))},G.prototype.onAdd=function(t){this.map=t,this.load()},G.prototype.setCoordinates=function(e){var i=this;e=(this.coordinates=e).map(t.MercatorCoordinate.fromLngLat);return this.tileID=function(e){for(var i=1/0,r=1/0,n=-1/0,o=-1/0,a=0,s=e;a<s.length;a+=1){var l=s[a];i=Math.min(i,l.x),r=Math.min(r,l.y),n=Math.max(n,l.x),o=Math.max(o,l.y)}var u=n-i;e=o-r,u=Math.max(u,e),e=Math.max(0,Math.floor(-Math.log(u)/Math.LN2)),u=Math.pow(2,e);return new t.CanonicalTileID(e,Math.floor((i+n)/2*u),Math.floor((r+o)/2*u))}(e),this.minzoom=this.maxzoom=this.tileID.z,e=e.map(function(t){return i.tileID.getTilePoint(t)._round()}),this._boundsArray=new t.StructArrayLayout4i8,this._boundsArray.emplaceBack(e[0].x,e[0].y,0,0),this._boundsArray.emplaceBack(e[1].x,e[1].y,t.EXTENT,0),this._boundsArray.emplaceBack(e[3].x,e[3].y,0,t.EXTENT),this._boundsArray.emplaceBack(e[2].x,e[2].y,t.EXTENT,t.EXTENT),this.boundsBuffer&&(this.boundsBuffer.destroy(),delete this.boundsBuffer),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})),this},G.prototype.prepare=function(){if(0!==Object.keys(this.tiles).length&&this.image){var e,i=this.map.painter.context,r=i.gl;for(e in this.boundsBuffer||(this.boundsBuffer=i.createVertexBuffer(this._boundsArray,q.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture||(this.texture=new t.Texture(i,this.image,r.RGBA),this.texture.bind(r.LINEAR,r.CLAMP_TO_EDGE)),this.tiles){var n=this.tiles[e];"loaded"!==n.state&&(n.state="loaded",n.texture=this.texture)}}},G.prototype.loadTile=function(t,e){this.tileID&&this.tileID.equals(t.tileID.canonical)?(this.tiles[String(t.tileID.wrap)]=t).buckets={}:t.state="errored",e(null)},G.prototype.serialize=function(){return{type:"image",url:this.options.url,coordinates:this.coordinates}},G.prototype.hasTransition=function(){return!1},G);function G(t,e,i,r){V.call(this),this.id=t,this.dispatcher=i,this.coordinates=e.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this._loaded=!1,this.setEventedParent(r),this.options=e}var Z,W=((Z=H)&&(K.__proto__=Z),((K.prototype=Object.create(Z&&Z.prototype)).constructor=K).prototype.load=function(){var e=this;this._loaded=!1;var i=this.options;this.urls=[];for(var r=0,n=i.urls;r<n.length;r+=1){var o=n[r];this.urls.push(this.map._requestManager.transformRequest(o,t.ResourceType.Source).url)}t.getVideo(this.urls,function(i,r){e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):r&&(e.video=r,e.video.loop=!0,e.video.addEventListener("playing",function(){e.map.triggerRepaint()}),e.map&&e.video.play(),e._finishLoading())})},K.prototype.pause=function(){this.video&&this.video.pause()},K.prototype.play=function(){this.video&&this.video.play()},K.prototype.seek=function(e){var i;this.video&&(e<(i=this.video.seekable).start(0)||e>i.end(0)?this.fire(new t.ErrorEvent(new t.ValidationError("sources."+this.id,null,"Playback for this video can be set only between the "+i.start(0)+" and "+i.end(0)+"-second mark."))):this.video.currentTime=e)},K.prototype.getVideo=function(){return this.video},K.prototype.onAdd=function(t){this.map||(this.map=t,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)))},K.prototype.prepare=function(){if(!(0===Object.keys(this.tiles).length||this.video.readyState<2)){var e,i=this.map.painter.context,r=i.gl;for(e in this.boundsBuffer||(this.boundsBuffer=i.createVertexBuffer(this._boundsArray,q.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?this.video.paused||(this.texture.bind(r.LINEAR,r.CLAMP_TO_EDGE),r.texSubImage2D(r.TEXTURE_2D,0,0,0,r.RGBA,r.UNSIGNED_BYTE,this.video)):(this.texture=new t.Texture(i,this.video,r.RGBA),this.texture.bind(r.LINEAR,r.CLAMP_TO_EDGE)),this.tiles){var n=this.tiles[e];"loaded"!==n.state&&(n.state="loaded",n.texture=this.texture)}}},K.prototype.serialize=function(){return{type:"video",urls:this.urls,coordinates:this.coordinates}},K.prototype.hasTransition=function(){return this.video&&!this.video.paused},K);function K(t,e,i,r){Z.call(this,t,e,i,r),this.roundZoom=!0,this.type="video",this.options=e}var X,Y=((X=H)&&(J.__proto__=X),((J.prototype=Object.create(X&&X.prototype)).constructor=J).prototype.load=function(){this._loaded=!0,this.canvas||(this.canvas=this.options.canvas instanceof t.window.HTMLCanvasElement?this.options.canvas:t.window.document.getElementById(this.options.canvas)),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions()?this.fire(new t.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))):(this.play=function(){this._playing=!0,this.map.triggerRepaint()},this.pause=function(){this._playing&&(this.prepare(),this._playing=!1)},this._finishLoading())},J.prototype.getCanvas=function(){return this.canvas},J.prototype.onAdd=function(t){this.map=t,this.load(),this.canvas&&this.animate&&this.play()},J.prototype.onRemove=function(){this.pause()},J.prototype.prepare=function(){var e=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,e=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,e=!0),!this._hasInvalidDimensions()&&0!==Object.keys(this.tiles).length){var i,r=this.map.painter.context,n=r.gl;for(i in this.boundsBuffer||(this.boundsBuffer=r.createVertexBuffer(this._boundsArray,q.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?(e||this._playing)&&this.texture.update(this.canvas,{premultiply:!0}):this.texture=new t.Texture(r,this.canvas,n.RGBA,{premultiply:!0}),this.tiles){var o=this.tiles[i];"loaded"!==o.state&&(o.state="loaded",o.texture=this.texture)}}},J.prototype.serialize=function(){return{type:"canvas",coordinates:this.coordinates}},J.prototype.hasTransition=function(){return this._playing},J.prototype._hasInvalidDimensions=function(){for(var t=0,e=[this.canvas.width,this.canvas.height];t<e.length;t+=1){var i=e[t];if(isNaN(i)||i<=0)return!0}return!1},J);function J(e,i,r,n){X.call(this,e,i,r,n),i.coordinates?Array.isArray(i.coordinates)&&4===i.coordinates.length&&!i.coordinates.some(function(t){return!Array.isArray(t)||2!==t.length||t.some(function(t){return"number"!=typeof t})})||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+e,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+e,null,'missing required property "coordinates"'))),i.animate&&"boolean"!=typeof i.animate&&this.fire(new t.ErrorEvent(new t.ValidationError("sources."+e,null,'optional "animate" property must be a boolean value'))),i.canvas?"string"==typeof i.canvas||i.canvas instanceof t.window.HTMLCanvasElement||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+e,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+e,null,'missing required property "canvas"'))),this.options=i,this.animate=void 0===i.animate||i.animate}var Q={vector:M,raster:R,"raster-dem":N,geojson:U,video:W,image:H,canvas:Y};function $(e,i,r,n,o,a){var s=function(t,e,i){if(t)for(var r=0,n=t;r<n.length;r+=1){var o=e[n[r]];if(o&&o.source===i&&"fill-extrusion"===o.type)return!0}else for(var a in e)if((a=e[a]).source===i&&"fill-extrusion"===a.type)return!0;return!1}(o&&o.layers,i,e.id),l=a.maxPitchScaleFactor();(s=e.tilesIn(n,l,s)).sort(tt);for(var u,c,p=[],h=0,d=s;h<d.length;h+=1){var f=d[h];p.push({wrappedTileID:f.tileID.wrapped().key,queryResults:f.tile.queryRenderedFeatures(i,r,e._state,f.queryGeometry,f.cameraQueryGeometry,f.scale,o,a,l,(u=e.transform,c=f.tileID,f=void 0,f=t.identity([]),t.translate(f,f,[1,1,0]),t.scale(f,f,[.5*u.width,.5*u.height,1]),t.multiply(f,f,u.calculatePosMatrix(c.toUnwrapped()))))})}var m,y=function(t){for(var e={},i={},r=0,n=t;r<n.length;r+=1){var o,a,s=(a=n[r]).queryResults,l=i[a=a.wrappedTileID]=i[a]||{};for(o in s)for(var u=s[o],c=l[o]=l[o]||{},p=e[o]=e[o]||[],h=0,d=u;h<d.length;h+=1){var f=d[h];c[f.featureIndex]||(c[f.featureIndex]=!0,p.push(f))}}return e}(p);for(m in y)y[m].forEach(function(t){var i=t.feature;t=e.getFeatureState(i.layer["source-layer"],i.id);i.source=i.layer.source,i.layer["source-layer"]&&(i.sourceLayer=i.layer["source-layer"]),i.state=t});return y}function tt(t,e){return t=t.tileID,e=e.tileID,t.overscaledZ-e.overscaledZ||t.canonical.y-e.canonical.y||t.wrap-e.wrap||t.canonical.x-e.canonical.x}function et(t,e){this.max=t,this.onRemove=e,this.reset()}function it(t,e,i){var r=(this.context=t).gl;this.buffer=r.createBuffer(),this.dynamicDraw=Boolean(i),this.context.unbindVAO(),t.bindElementBuffer.set(this.buffer),r.bufferData(r.ELEMENT_ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?r.DYNAMIC_DRAW:r.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer}function rt(t,e,i,r){this.length=e.length,this.attributes=i,this.itemSize=e.bytesPerElement,this.dynamicDraw=r,r=(this.context=t).gl,this.buffer=r.createBuffer(),t.bindVertexBuffer.set(this.buffer),r.bufferData(r.ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?r.DYNAMIC_DRAW:r.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer}et.prototype.reset=function(){for(var t in this.data)for(var e=0,i=this.data[t];e<i.length;e+=1){var r=i[e];r.timeout&&clearTimeout(r.timeout),this.onRemove(r.value)}return this.data={},this.order=[],this},et.prototype.add=function(t,e,i){var r=this,n=t.wrapped().key;void 0===this.data[n]&&(this.data[n]=[]);var o={value:e,timeout:void 0};return void 0!==i&&(o.timeout=setTimeout(function(){r.remove(t,o)},i)),this.data[n].push(o),this.order.push(n),this.order.length>this.max&&(n=this._getAndRemoveByKey(this.order[0]))&&this.onRemove(n),this},et.prototype.has=function(t){return t.wrapped().key in this.data},et.prototype.getAndRemove=function(t){return this.has(t)?this._getAndRemoveByKey(t.wrapped().key):null},et.prototype._getAndRemoveByKey=function(t){var e=this.data[t].shift();return e.timeout&&clearTimeout(e.timeout),0===this.data[t].length&&delete this.data[t],this.order.splice(this.order.indexOf(t),1),e.value},et.prototype.getByKey=function(t){return(t=this.data[t])?t[0].value:null},et.prototype.get=function(t){return this.has(t)?this.data[t.wrapped().key][0].value:null},et.prototype.remove=function(t,e){if(!this.has(t))return this;var i=t.wrapped().key;t=void 0===e?0:this.data[i].indexOf(e),e=this.data[i][t];return this.data[i].splice(t,1),e.timeout&&clearTimeout(e.timeout),0===this.data[i].length&&delete this.data[i],this.onRemove(e.value),this.order.splice(this.order.indexOf(i),1),this},et.prototype.setMaxSize=function(t){for(this.max=t;this.order.length>this.max;){var e=this._getAndRemoveByKey(this.order[0]);e&&this.onRemove(e)}return this},et.prototype.filter=function(t){var e,i=[];for(e in this.data)for(var r=0,n=this.data[e];r<n.length;r+=1){var o=n[r];t(o.value)||i.push(o)}for(var a=0,s=i;a<s.length;a+=1){var l=s[a];this.remove(l.value.tileID,l)}},it.prototype.bind=function(){this.context.bindElementBuffer.set(this.buffer)},it.prototype.updateData=function(t){var e=this.context.gl;this.context.unbindVAO(),this.bind(),e.bufferSubData(e.ELEMENT_ARRAY_BUFFER,0,t.arrayBuffer)},it.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer)};var nt={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"};rt.prototype.bind=function(){this.context.bindVertexBuffer.set(this.buffer)},rt.prototype.updateData=function(t){var e=this.context.gl;this.bind(),e.bufferSubData(e.ARRAY_BUFFER,0,t.arrayBuffer)},rt.prototype.enableAttributes=function(t,e){for(var i=0;i<this.attributes.length;i++){var r=this.attributes[i];void 0!==(r=e.attributes[r.name])&&t.enableVertexAttribArray(r)}},rt.prototype.setVertexAttribPointers=function(t,e,i){for(var r=0;r<this.attributes.length;r++){var n=this.attributes[r],o=e.attributes[n.name];void 0!==o&&t.vertexAttribPointer(o,n.components,t[nt[n.type]],!1,this.itemSize,n.offset+this.itemSize*(i||0))}},rt.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer)},(zr=function(t){this.gl=t.gl,this.default=this.getDefault(),this.current=this.default,this.dirty=!1}).prototype.get=function(){return this.current},zr.prototype.set=function(t){},zr.prototype.getDefault=function(){return this.default},zr.prototype.setDefault=function(){this.set(this.default)};var ot,at=((ot=zr)&&(st.__proto__=ot),((st.prototype=Object.create(ot&&ot.prototype)).constructor=st).prototype.getDefault=function(){return t.Color.transparent},st.prototype.set=function(t){var e=this.current;t.r===e.r&&t.g===e.g&&t.b===e.b&&t.a===e.a&&!this.dirty||(this.gl.clearColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1)},st);function st(){ot.apply(this,arguments)}var lt,ut=((lt=zr)&&(ct.__proto__=lt),((ct.prototype=Object.create(lt&&lt.prototype)).constructor=ct).prototype.getDefault=function(){return 1},ct.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.clearDepth(t),this.current=t,this.dirty=!1)},ct);function ct(){lt.apply(this,arguments)}var pt,ht=((pt=zr)&&(dt.__proto__=pt),((dt.prototype=Object.create(pt&&pt.prototype)).constructor=dt).prototype.getDefault=function(){return 0},dt.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.clearStencil(t),this.current=t,this.dirty=!1)},dt);function dt(){pt.apply(this,arguments)}var ft,mt=((ft=zr)&&(yt.__proto__=ft),((yt.prototype=Object.create(ft&&ft.prototype)).constructor=yt).prototype.getDefault=function(){return[!0,!0,!0,!0]},yt.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]&&!this.dirty||(this.gl.colorMask(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1)},yt);function yt(){ft.apply(this,arguments)}var gt,vt=((gt=zr)&&(_t.__proto__=gt),((_t.prototype=Object.create(gt&&gt.prototype)).constructor=_t).prototype.getDefault=function(){return!0},_t.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.depthMask(t),this.current=t,this.dirty=!1)},_t);function _t(){gt.apply(this,arguments)}var xt,bt=((xt=zr)&&(wt.__proto__=xt),((wt.prototype=Object.create(xt&&xt.prototype)).constructor=wt).prototype.getDefault=function(){return 255},wt.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.stencilMask(t),this.current=t,this.dirty=!1)},wt);function wt(){xt.apply(this,arguments)}var St,Tt=((St=zr)&&(Ct.__proto__=St),((Ct.prototype=Object.create(St&&St.prototype)).constructor=Ct).prototype.getDefault=function(){return{func:this.gl.ALWAYS,ref:0,mask:255}},Ct.prototype.set=function(t){var e=this.current;t.func===e.func&&t.ref===e.ref&&t.mask===e.mask&&!this.dirty||(this.gl.stencilFunc(t.func,t.ref,t.mask),this.current=t,this.dirty=!1)},Ct);function Ct(){St.apply(this,arguments)}var Et,It=((Et=zr)&&(kt.__proto__=Et),((kt.prototype=Object.create(Et&&Et.prototype)).constructor=kt).prototype.getDefault=function(){var t=this.gl;return[t.KEEP,t.KEEP,t.KEEP]},kt.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&!this.dirty||(this.gl.stencilOp(t[0],t[1],t[2]),this.current=t,this.dirty=!1)},kt);function kt(){Et.apply(this,arguments)}var At,Pt=((At=zr)&&(Mt.__proto__=At),((Mt.prototype=Object.create(At&&At.prototype)).constructor=Mt).prototype.getDefault=function(){return!1},Mt.prototype.set=function(t){var e;t===this.current&&!this.dirty||(e=this.gl,t?e.enable(e.STENCIL_TEST):e.disable(e.STENCIL_TEST),this.current=t,this.dirty=!1)},Mt);function Mt(){At.apply(this,arguments)}var Lt,Ot=((Lt=zr)&&(Rt.__proto__=Lt),((Rt.prototype=Object.create(Lt&&Lt.prototype)).constructor=Rt).prototype.getDefault=function(){return[0,1]},Rt.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&!this.dirty||(this.gl.depthRange(t[0],t[1]),this.current=t,this.dirty=!1)},Rt);function Rt(){Lt.apply(this,arguments)}var zt,Dt=((zt=zr)&&(Nt.__proto__=zt),((Nt.prototype=Object.create(zt&&zt.prototype)).constructor=Nt).prototype.getDefault=function(){return!1},Nt.prototype.set=function(t){var e;t===this.current&&!this.dirty||(e=this.gl,t?e.enable(e.DEPTH_TEST):e.disable(e.DEPTH_TEST),this.current=t,this.dirty=!1)},Nt);function Nt(){zt.apply(this,arguments)}var Bt,Ft=((Bt=zr)&&(Ut.__proto__=Bt),((Ut.prototype=Object.create(Bt&&Bt.prototype)).constructor=Ut).prototype.getDefault=function(){return this.gl.LESS},Ut.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.depthFunc(t),this.current=t,this.dirty=!1)},Ut);function Ut(){Bt.apply(this,arguments)}var jt,Vt=((jt=zr)&&(qt.__proto__=jt),((qt.prototype=Object.create(jt&&jt.prototype)).constructor=qt).prototype.getDefault=function(){return!1},qt.prototype.set=function(t){var e;t===this.current&&!this.dirty||(e=this.gl,t?e.enable(e.BLEND):e.disable(e.BLEND),this.current=t,this.dirty=!1)},qt);function qt(){jt.apply(this,arguments)}var Ht,Gt=((Ht=zr)&&(Zt.__proto__=Ht),((Zt.prototype=Object.create(Ht&&Ht.prototype)).constructor=Zt).prototype.getDefault=function(){var t=this.gl;return[t.ONE,t.ZERO]},Zt.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&!this.dirty||(this.gl.blendFunc(t[0],t[1]),this.current=t,this.dirty=!1)},Zt);function Zt(){Ht.apply(this,arguments)}var Wt,Kt=((Wt=zr)&&(Xt.__proto__=Wt),((Xt.prototype=Object.create(Wt&&Wt.prototype)).constructor=Xt).prototype.getDefault=function(){return t.Color.transparent},Xt.prototype.set=function(t){var e=this.current;t.r===e.r&&t.g===e.g&&t.b===e.b&&t.a===e.a&&!this.dirty||(this.gl.blendColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1)},Xt);function Xt(){Wt.apply(this,arguments)}var Yt,Jt=((Yt=zr)&&(Qt.__proto__=Yt),((Qt.prototype=Object.create(Yt&&Yt.prototype)).constructor=Qt).prototype.getDefault=function(){return this.gl.FUNC_ADD},Qt.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.blendEquation(t),this.current=t,this.dirty=!1)},Qt);function Qt(){Yt.apply(this,arguments)}var $t,te=(($t=zr)&&(ee.__proto__=$t),((ee.prototype=Object.create($t&&$t.prototype)).constructor=ee).prototype.getDefault=function(){return!1},ee.prototype.set=function(t){var e;t===this.current&&!this.dirty||(e=this.gl,t?e.enable(e.CULL_FACE):e.disable(e.CULL_FACE),this.current=t,this.dirty=!1)},ee);function ee(){$t.apply(this,arguments)}var ie,re=((ie=zr)&&(ne.__proto__=ie),((ne.prototype=Object.create(ie&&ie.prototype)).constructor=ne).prototype.getDefault=function(){return this.gl.BACK},ne.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.cullFace(t),this.current=t,this.dirty=!1)},ne);function ne(){ie.apply(this,arguments)}var oe,ae=((oe=zr)&&(se.__proto__=oe),((se.prototype=Object.create(oe&&oe.prototype)).constructor=se).prototype.getDefault=function(){return this.gl.CCW},se.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.frontFace(t),this.current=t,this.dirty=!1)},se);function se(){oe.apply(this,arguments)}var le,ue=((le=zr)&&(ce.__proto__=le),((ce.prototype=Object.create(le&&le.prototype)).constructor=ce).prototype.getDefault=function(){return null},ce.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.useProgram(t),this.current=t,this.dirty=!1)},ce);function ce(){le.apply(this,arguments)}var pe,he=((pe=zr)&&(de.__proto__=pe),((de.prototype=Object.create(pe&&pe.prototype)).constructor=de).prototype.getDefault=function(){return this.gl.TEXTURE0},de.prototype.set=function(t){t===this.current&&!this.dirty||(this.gl.activeTexture(t),this.current=t,this.dirty=!1)},de);function de(){pe.apply(this,arguments)}var fe,me=((fe=zr)&&(ye.__proto__=fe),((ye.prototype=Object.create(fe&&fe.prototype)).constructor=ye).prototype.getDefault=function(){var t=this.gl;return[0,0,t.drawingBufferWidth,t.drawingBufferHeight]},ye.prototype.set=function(t){var e=this.current;t[0]===e[0]&&t[1]===e[1]&&t[2]===e[2]&&t[3]===e[3]&&!this.dirty||(this.gl.viewport(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1)},ye);function ye(){fe.apply(this,arguments)}var ge,ve=((ge=zr)&&(_e.__proto__=ge),((_e.prototype=Object.create(ge&&ge.prototype)).constructor=_e).prototype.getDefault=function(){return null},_e.prototype.set=function(t){var e;t===this.current&&!this.dirty||((e=this.gl).bindFramebuffer(e.FRAMEBUFFER,t),this.current=t,this.dirty=!1)},_e);function _e(){ge.apply(this,arguments)}var xe,be=((xe=zr)&&(we.__proto__=xe),((we.prototype=Object.create(xe&&xe.prototype)).constructor=we).prototype.getDefault=function(){return null},we.prototype.set=function(t){var e;t===this.current&&!this.dirty||((e=this.gl).bindRenderbuffer(e.RENDERBUFFER,t),this.current=t,this.dirty=!1)},we);function we(){xe.apply(this,arguments)}var Se,Te=((Se=zr)&&(Ce.__proto__=Se),((Ce.prototype=Object.create(Se&&Se.prototype)).constructor=Ce).prototype.getDefault=function(){return null},Ce.prototype.set=function(t){var e;t===this.current&&!this.dirty||((e=this.gl).bindTexture(e.TEXTURE_2D,t),this.current=t,this.dirty=!1)},Ce);function Ce(){Se.apply(this,arguments)}var Ee,Ie=((Ee=zr)&&(ke.__proto__=Ee),((ke.prototype=Object.create(Ee&&Ee.prototype)).constructor=ke).prototype.getDefault=function(){return null},ke.prototype.set=function(t){var e;t===this.current&&!this.dirty||((e=this.gl).bindBuffer(e.ARRAY_BUFFER,t),this.current=t,this.dirty=!1)},ke);function ke(){Ee.apply(this,arguments)}var Ae,Pe=((Ae=zr)&&(Me.__proto__=Ae),((Me.prototype=Object.create(Ae&&Ae.prototype)).constructor=Me).prototype.getDefault=function(){return null},Me.prototype.set=function(t){var e=this.gl;e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,t),this.current=t,this.dirty=!1},Me);function Me(){Ae.apply(this,arguments)}var Le,Oe=((Le=zr)&&(Re.__proto__=Le),((Re.prototype=Object.create(Le&&Le.prototype)).constructor=Re).prototype.getDefault=function(){return null},Re.prototype.set=function(t){this.vao&&(t!==this.current||this.dirty)&&(this.vao.bindVertexArrayOES(t),this.current=t,this.dirty=!1)},Re);function Re(t){Le.call(this,t),this.vao=t.extVertexArrayObject}var ze,De=((ze=zr)&&(Ne.__proto__=ze),((Ne.prototype=Object.create(ze&&ze.prototype)).constructor=Ne).prototype.getDefault=function(){return 4},Ne.prototype.set=function(t){var e;t===this.current&&!this.dirty||((e=this.gl).pixelStorei(e.UNPACK_ALIGNMENT,t),this.current=t,this.dirty=!1)},Ne);function Ne(){ze.apply(this,arguments)}var Be,Fe=((Be=zr)&&(Ue.__proto__=Be),((Ue.prototype=Object.create(Be&&Be.prototype)).constructor=Ue).prototype.getDefault=function(){return!1},Ue.prototype.set=function(t){var e;t===this.current&&!this.dirty||((e=this.gl).pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,t),this.current=t,this.dirty=!1)},Ue);function Ue(){Be.apply(this,arguments)}var je,Ve=((je=zr)&&(qe.__proto__=je),((qe.prototype=Object.create(je&&je.prototype)).constructor=qe).prototype.getDefault=function(){return!1},qe.prototype.set=function(t){var e;t===this.current&&!this.dirty||((e=this.gl).pixelStorei(e.UNPACK_FLIP_Y_WEBGL,t),this.current=t,this.dirty=!1)},qe);function qe(){je.apply(this,arguments)}var He,Ge=((He=zr)&&(Ze.__proto__=He),((Ze.prototype=Object.create(He&&He.prototype)).constructor=Ze).prototype.getDefault=function(){return null},Ze);function Ze(t,e){He.call(this,t),this.context=t,this.parent=e}var We,Ke=((We=Ge)&&(Xe.__proto__=We),((Xe.prototype=Object.create(We&&We.prototype)).constructor=Xe).prototype.setDirty=function(){this.dirty=!0},Xe.prototype.set=function(t){var e;t===this.current&&!this.dirty||(this.context.bindFramebuffer.set(this.parent),(e=this.gl).framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0),this.current=t,this.dirty=!1)},Xe);function Xe(){We.apply(this,arguments)}var Ye,Je=((Ye=Ge)&&(Qe.__proto__=Ye),((Qe.prototype=Object.create(Ye&&Ye.prototype)).constructor=Qe).prototype.set=function(t){var e;t===this.current&&!this.dirty||(this.context.bindFramebuffer.set(this.parent),(e=this.gl).framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t),this.current=t,this.dirty=!1)},Qe);function Qe(){Ye.apply(this,arguments)}function $e(t,e,i,r){this.context=t,this.width=e,this.height=i,i=t.gl,i=this.framebuffer=i.createFramebuffer(),this.colorAttachment=new Ke(t,i),r&&(this.depthAttachment=new Je(t,i))}var ti=function(t,e,i){this.func=t,this.mask=e,this.range=i};ti.ReadOnly=!($e.prototype.destroy=function(){var t=this.context.gl,e=this.colorAttachment.get();e&&t.deleteTexture(e),!this.depthAttachment||(e=this.depthAttachment.get())&&t.deleteRenderbuffer(e),t.deleteFramebuffer(this.framebuffer)}),ti.ReadWrite=!0,ti.disabled=new ti(519,ti.ReadOnly,[0,1]);var ei=function(t,e,i,r,n,o){this.test=t,this.ref=e,this.mask=i,this.fail=r,this.depthFail=n,this.pass=o};ei.disabled=new ei({func:519,mask:0},0,0,7680,7680,7680);var ii=function(t,e,i){this.blendFunction=t,this.blendColor=e,this.mask=i};ii.disabled=new ii(ii.Replace=[1,0],t.Color.transparent,[!1,!1,!1,!1]),ii.unblended=new ii(ii.Replace,t.Color.transparent,[!0,!0,!0,!0]),ii.alphaBlended=new ii([1,771],t.Color.transparent,[!0,!0,!0,!0]);var ri=function(t,e,i){this.enable=t,this.mode=e,this.frontFace=i};function ni(t){this.gl=t,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),this.clearColor=new at(this),this.clearDepth=new ut(this),this.clearStencil=new ht(this),this.colorMask=new mt(this),this.depthMask=new vt(this),this.stencilMask=new bt(this),this.stencilFunc=new Tt(this),this.stencilOp=new It(this),this.stencilTest=new Pt(this),this.depthRange=new Ot(this),this.depthTest=new Dt(this),this.depthFunc=new Ft(this),this.blend=new Vt(this),this.blendFunc=new Gt(this),this.blendColor=new Kt(this),this.blendEquation=new Jt(this),this.cullFace=new te(this),this.cullFaceSide=new re(this),this.frontFace=new ae(this),this.program=new ue(this),this.activeTexture=new he(this),this.viewport=new me(this),this.bindFramebuffer=new ve(this),this.bindRenderbuffer=new be(this),this.bindTexture=new Te(this),this.bindVertexBuffer=new Ie(this),this.bindElementBuffer=new Pe(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new Oe(this),this.pixelStoreUnpack=new De(this),this.pixelStoreUnpackPremultiplyAlpha=new Fe(this),this.pixelStoreUnpackFlipY=new Ve(this),this.extTextureFilterAnisotropic=t.getExtension("EXT_texture_filter_anisotropic")||t.getExtension("MOZ_EXT_texture_filter_anisotropic")||t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureHalfFloat=t.getExtension("OES_texture_half_float"),this.extTextureHalfFloat&&(t.getExtension("OES_texture_half_float_linear"),this.extRenderToTextureHalfFloat=t.getExtension("EXT_color_buffer_half_float")),this.extTimerQuery=t.getExtension("EXT_disjoint_timer_query"),this.maxTextureSize=t.getParameter(t.MAX_TEXTURE_SIZE)}ri.disabled=new ri(!1,1029,2305),ri.backCCW=new ri(!0,1029,2305),ni.prototype.setDefault=function(){this.unbindVAO(),this.clearColor.setDefault(),this.clearDepth.setDefault(),this.clearStencil.setDefault(),this.colorMask.setDefault(),this.depthMask.setDefault(),this.stencilMask.setDefault(),this.stencilFunc.setDefault(),this.stencilOp.setDefault(),this.stencilTest.setDefault(),this.depthRange.setDefault(),this.depthTest.setDefault(),this.depthFunc.setDefault(),this.blend.setDefault(),this.blendFunc.setDefault(),this.blendColor.setDefault(),this.blendEquation.setDefault(),this.cullFace.setDefault(),this.cullFaceSide.setDefault(),this.frontFace.setDefault(),this.program.setDefault(),this.activeTexture.setDefault(),this.bindFramebuffer.setDefault(),this.pixelStoreUnpack.setDefault(),this.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.pixelStoreUnpackFlipY.setDefault()},ni.prototype.setDirty=function(){this.clearColor.dirty=!0,this.clearDepth.dirty=!0,this.clearStencil.dirty=!0,this.colorMask.dirty=!0,this.depthMask.dirty=!0,this.stencilMask.dirty=!0,this.stencilFunc.dirty=!0,this.stencilOp.dirty=!0,this.stencilTest.dirty=!0,this.depthRange.dirty=!0,this.depthTest.dirty=!0,this.depthFunc.dirty=!0,this.blend.dirty=!0,this.blendFunc.dirty=!0,this.blendColor.dirty=!0,this.blendEquation.dirty=!0,this.cullFace.dirty=!0,this.cullFaceSide.dirty=!0,this.frontFace.dirty=!0,this.program.dirty=!0,this.activeTexture.dirty=!0,this.viewport.dirty=!0,this.bindFramebuffer.dirty=!0,this.bindRenderbuffer.dirty=!0,this.bindTexture.dirty=!0,this.bindVertexBuffer.dirty=!0,this.bindElementBuffer.dirty=!0,this.extVertexArrayObject&&(this.bindVertexArrayOES.dirty=!0),this.pixelStoreUnpack.dirty=!0,this.pixelStoreUnpackPremultiplyAlpha.dirty=!0,this.pixelStoreUnpackFlipY.dirty=!0},ni.prototype.createIndexBuffer=function(t,e){return new it(this,t,e)},ni.prototype.createVertexBuffer=function(t,e,i){return new rt(this,t,e,i)},ni.prototype.createRenderbuffer=function(t,e,i){var r=this.gl,n=r.createRenderbuffer();return this.bindRenderbuffer.set(n),r.renderbufferStorage(r.RENDERBUFFER,t,e,i),this.bindRenderbuffer.set(null),n},ni.prototype.createFramebuffer=function(t,e,i){return new $e(this,t,e,i)},ni.prototype.clear=function(t){var e=t.color,i=t.depth,r=this.gl;t=0;e&&(t|=r.COLOR_BUFFER_BIT,this.clearColor.set(e),this.colorMask.set([!0,!0,!0,!0])),void 0!==i&&(t|=r.DEPTH_BUFFER_BIT,this.depthRange.set([0,1]),this.clearDepth.set(i),this.depthMask.set(!0)),r.clear(t)},ni.prototype.setCullFace=function(t){!1===t.enable?this.cullFace.set(!1):(this.cullFace.set(!0),this.cullFaceSide.set(t.mode),this.frontFace.set(t.frontFace))},ni.prototype.setDepthMode=function(t){t.func!==this.gl.ALWAYS||t.mask?(this.depthTest.set(!0),this.depthFunc.set(t.func),this.depthMask.set(t.mask),this.depthRange.set(t.range)):this.depthTest.set(!1)},ni.prototype.setStencilMode=function(t){t.test.func!==this.gl.ALWAYS||t.mask?(this.stencilTest.set(!0),this.stencilMask.set(t.mask),this.stencilOp.set([t.fail,t.depthFail,t.pass]),this.stencilFunc.set({func:t.test.func,ref:t.ref,mask:t.test.mask})):this.stencilTest.set(!1)},ni.prototype.setColorMode=function(e){t.deepEqual(e.blendFunction,ii.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(e.blendFunction),this.blendColor.set(e.blendColor)),this.colorMask.set(e.mask)},ni.prototype.unbindVAO=function(){this.extVertexArrayObject&&this.bindVertexArrayOES.set(null)};var oi,ai=((oi=t.Evented)&&(si.__proto__=oi),((si.prototype=Object.create(oi&&oi.prototype)).constructor=si).prototype.onAdd=function(t){this.map=t,this._maxTileCacheSize=t?t._maxTileCacheSize:null,this._source&&this._source.onAdd&&this._source.onAdd(t)},si.prototype.onRemove=function(t){this._source&&this._source.onRemove&&this._source.onRemove(t)},si.prototype.loaded=function(){if(this._sourceErrored)return!0;if(!this._sourceLoaded)return!1;if(!this._source.loaded())return!1;for(var t in this._tiles)if("loaded"!==(t=this._tiles[t]).state&&"errored"!==t.state)return!1;return!0},si.prototype.getSource=function(){return this._source},si.prototype.pause=function(){this._paused=!0},si.prototype.resume=function(){var t;this._paused&&(t=this._shouldReloadOnResume,this._paused=!1,this._shouldReloadOnResume=!1,t&&this.reload(),this.transform&&this.update(this.transform))},si.prototype._loadTile=function(t,e){return this._source.loadTile(t,e)},si.prototype._unloadTile=function(t){if(this._source.unloadTile)return this._source.unloadTile(t,function(){})},si.prototype._abortTile=function(t){if(this._source.abortTile)return this._source.abortTile(t,function(){})},si.prototype.serialize=function(){return this._source.serialize()},si.prototype.prepare=function(t){for(var e in this._source.prepare&&this._source.prepare(),this._state.coalesceChanges(this._tiles,this.map?this.map.painter:null),this._tiles)(e=this._tiles[e]).upload(t),e.prepare(this.map.style.imageManager)},si.prototype.getIds=function(){return t.values(this._tiles).map(function(t){return t.tileID}).sort(li).map(function(t){return t.key})},si.prototype.getRenderableIds=function(e){var i,r=this,n=[];for(i in this._tiles)this._isIdRenderable(i,e)&&n.push(this._tiles[i]);return e?n.sort(function(e,i){var n=e.tileID,o=i.tileID;e=new t.Point(n.canonical.x,n.canonical.y)._rotate(r.transform.angle),i=new t.Point(o.canonical.x,o.canonical.y)._rotate(r.transform.angle);return n.overscaledZ-o.overscaledZ||i.y-e.y||i.x-e.x}).map(function(t){return t.tileID.key}):n.map(function(t){return t.tileID}).sort(li).map(function(t){return t.key})},si.prototype.hasRenderableParent=function(t){return!!(t=this.findLoadedParent(t,0))&&this._isIdRenderable(t.tileID.key)},si.prototype._isIdRenderable=function(t,e){return this._tiles[t]&&this._tiles[t].hasData()&&!this._coveredTiles[t]&&(e||!this._tiles[t].holdingForFade())},si.prototype.reload=function(){if(this._paused)this._shouldReloadOnResume=!0;else for(var t in this._cache.reset(),this._tiles)"errored"!==this._tiles[t].state&&this._reloadTile(t,"reloading")},si.prototype._reloadTile=function(t,e){var i=this._tiles[t];i&&("loading"!==i.state&&(i.state=e),this._loadTile(i,this._tileLoaded.bind(this,i,t,e)))},si.prototype._tileLoaded=function(e,i,r,n){if(n)return e.state="errored",void(404!==n.status?this._source.fire(new t.ErrorEvent(n,{tile:e})):this.update(this.transform));e.timeAdded=t.browser.now(),"expired"===r&&(e.refreshedUponExpiration=!0),this._setTileReloadTimer(i,e),"raster-dem"===this.getSource().type&&e.dem&&this._backfillDEM(e),this._state.initializeTileState(e,this.map?this.map.painter:null),this._source.fire(new t.Event("data",{dataType:"source",tile:e,coord:e.tileID}))},si.prototype._backfillDEM=function(t){for(var e=this.getRenderableIds(),i=0;i<e.length;i++){var r=e[i];t.neighboringTiles&&t.neighboringTiles[r]&&(n(t,r=this.getTileByID(r)),n(r,t))}function n(t,e){t.needsHillshadePrepare=!0;var i=e.tileID.canonical.x-t.tileID.canonical.x,r=e.tileID.canonical.y-t.tileID.canonical.y,n=Math.pow(2,t.tileID.canonical.z),o=e.tileID.key;0===i&&0==r||1<Math.abs(r)||(1<Math.abs(i)&&(1===Math.abs(i+n)?i+=n:1===Math.abs(i-n)&&(i-=n)),e.dem&&t.dem&&(t.dem.backfillBorder(e.dem,i,r),t.neighboringTiles&&t.neighboringTiles[o]&&(t.neighboringTiles[o].backfilled=!0)))}},si.prototype.getTile=function(t){return this.getTileByID(t.key)},si.prototype.getTileByID=function(t){return this._tiles[t]},si.prototype._retainLoadedChildren=function(t,e,i,r){for(var n in this._tiles){var o=this._tiles[n];if(!(r[n]||!o.hasData()||o.tileID.overscaledZ<=e||o.tileID.overscaledZ>i)){for(var a=o.tileID;o&&o.tileID.overscaledZ>e+1;){var s=o.tileID.scaledTo(o.tileID.overscaledZ-1);(o=this._tiles[s.key])&&o.hasData()&&(a=s)}for(var l=a;l.overscaledZ>e;)if(t[(l=l.scaledTo(l.overscaledZ-1)).key]){r[a.key]=a;break}}}},si.prototype.findLoadedParent=function(t,e){if(t.key in this._loadedParentTiles){var i=this._loadedParentTiles[t.key];return i&&i.tileID.overscaledZ>=e?i:null}for(var r=t.overscaledZ-1;e<=r;r--){var n=t.scaledTo(r);if(n=this._getLoadedTile(n))return n}},si.prototype._getLoadedTile=function(t){var e=this._tiles[t.key];return e&&e.hasData()?e:this._cache.getByKey(t.wrapped().key)},si.prototype.updateCacheSize=function(t){var e=Math.ceil(t.width/this._source.tileSize)+1;t=Math.ceil(t.height/this._source.tileSize)+1,t=Math.floor(e*t*5),t="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,t):t;this._cache.setMaxSize(t)},si.prototype.handleWrapJump=function(t){var e=void 0===this._prevLng?t:this._prevLng,i=Math.round((t-e)/360);if(this._prevLng=t,i){var r,n,o,a={};for(r in this._tiles){var s=this._tiles[r];s.tileID=s.tileID.unwrapTo(s.tileID.wrap+i),a[s.tileID.key]=s}for(n in this._tiles=a,this._timers)clearTimeout(this._timers[n]),delete this._timers[n];for(o in this._tiles){var l=this._tiles[o];this._setTileReloadTimer(o,l)}}},si.prototype.update=function(e){var i,r=this;if(this.transform=e,this._sourceLoaded&&!this._paused){this.updateCacheSize(e),this.handleWrapJump(this.transform.center.lng),this._coveredTiles={},this.used?this._source.tileID?i=e.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e){return new t.OverscaledTileID(e.canonical.z,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y)}):(i=e.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}),this._source.hasTile&&(i=i.filter(function(t){return r._source.hasTile(t)}))):i=[];var n,o=e.coveringZoomLevel(this._source),a=Math.max(o-si.maxOverzooming,this._source.minzoom),s=(e=Math.max(o+si.maxUnderzooming,this._source.minzoom),this._updateRetainedTiles(i,o));if(ui(this._source.type)){for(var l,u={},c={},p=0,h=Object.keys(s);p<h.length;p+=1){var d=h[p],f=s[d],m=this._tiles[d];!m||m.fadeEndTime&&m.fadeEndTime<=t.browser.now()||((m=this.findLoadedParent(f,a))&&(this._addTile(m.tileID),u[m.tileID.key]=m.tileID),c[d]=f)}for(l in this._retainLoadedChildren(c,o,e,s),u)s[l]||(this._coveredTiles[l]=!0,s[l]=u[l])}for(n in s)this._tiles[n].clearFadeHold();for(var y=0,g=t.keysDifference(this._tiles,s);y<g.length;y+=1){var v=g[y],_=this._tiles[v];_.hasSymbolBuckets&&!_.holdingForFade()?_.setHoldDuration(this.map._fadeDuration):_.hasSymbolBuckets&&!_.symbolFadeFinished()||this._removeTile(v)}this._updateLoadedParentTileCache()}},si.prototype.releaseSymbolFadeTiles=function(){for(var t in this._tiles)this._tiles[t].holdingForFade()&&this._removeTile(t)},si.prototype._updateRetainedTiles=function(t,e){for(var i={},r={},n=Math.max(e-si.maxOverzooming,this._source.minzoom),o=Math.max(e+si.maxUnderzooming,this._source.minzoom),a={},s=0,l=t;s<l.length;s+=1){var u=l[s],c=this._addTile(u);i[u.key]=u,c.hasData()||e<this._source.maxzoom&&(a[u.key]=u)}this._retainLoadedChildren(a,e,o,i);for(var p=0,h=t;p<h.length;p+=1){var d=h[p],f=this._tiles[d.key];if(!f.hasData()){if(e+1>this._source.maxzoom){var m=d.children(this._source.maxzoom)[0],y=this.getTile(m);if(y&&y.hasData()){i[m.key]=m;continue}}else if(i[(m=d.children(this._source.maxzoom))[0].key]&&i[m[1].key]&&i[m[2].key]&&i[m[3].key])continue;for(var g=f.wasRequested(),v=d.overscaledZ-1;n<=v;--v){var _=d.scaledTo(v);if(r[_.key])break;if(r[_.key]=!0,(f=!(f=this.getTile(_))&&g?this._addTile(_):f)&&(i[_.key]=_,g=f.wasRequested(),f.hasData()))break}}}return i},si.prototype._updateLoadedParentTileCache=function(){for(var t in this._loadedParentTiles={},this._tiles){for(var e=[],i=void 0,r=this._tiles[t].tileID;0<r.overscaledZ;){if(r.key in this._loadedParentTiles){i=this._loadedParentTiles[r.key];break}e.push(r.key);var n=r.scaledTo(r.overscaledZ-1);if(i=this._getLoadedTile(n))break;r=n}for(var o=0,a=e;o<a.length;o+=1){var s=a[o];this._loadedParentTiles[s]=i}}},si.prototype._addTile=function(e){var i=this._tiles[e.key];if(i)return i;(i=this._cache.getAndRemove(e))&&(this._setTileReloadTimer(e.key,i),i.tileID=e,this._state.initializeTileState(i,this.map?this.map.painter:null),this._cacheTimers[e.key]&&(clearTimeout(this._cacheTimers[e.key]),delete this._cacheTimers[e.key],this._setTileReloadTimer(e.key,i)));var r=Boolean(i);return r||(i=new t.Tile(e,this._source.tileSize*e.overscaleFactor()),this._loadTile(i,this._tileLoaded.bind(this,i,e.key,i.state))),i?(i.uses++,this._tiles[e.key]=i,r||this._source.fire(new t.Event("dataloading",{tile:i,coord:i.tileID,dataType:"source"})),i):null},si.prototype._setTileReloadTimer=function(t,e){var i=this;t in this._timers&&(clearTimeout(this._timers[t]),delete this._timers[t]),(e=e.getExpiryTimeout())&&(this._timers[t]=setTimeout(function(){i._reloadTile(t,"expired"),delete i._timers[t]},e))},si.prototype._removeTile=function(t){var e=this._tiles[t];e&&(e.uses--,delete this._tiles[t],this._timers[t]&&(clearTimeout(this._timers[t]),delete this._timers[t]),0<e.uses||(e.hasData()&&"reloading"!==e.state?this._cache.add(e.tileID,e,e.getExpiryTimeout()):(e.aborted=!0,this._abortTile(e),this._unloadTile(e))))},si.prototype.clearTiles=function(){for(var t in this._shouldReloadOnResume=!1,this._paused=!1,this._tiles)this._removeTile(t);this._cache.reset()},si.prototype.tilesIn=function(e,i,r){var n=this,o=[],a=this.transform;if(!a)return o;r=r?a.getCameraQueryGeometry(e):e;for(var s=e.map(function(t){return a.pointCoordinate(t)}),l=r.map(function(t){return a.pointCoordinate(t)}),u=this.getIds(),c=1/0,p=1/0,h=-1/0,d=-1/0,f=0,m=l;f<m.length;f+=1){var y=m[f];c=Math.min(c,y.x),p=Math.min(p,y.y),h=Math.max(h,y.x),d=Math.max(d,y.y)}for(var g=0;g<u.length;g++)!function(e){var r,f,m,y=n._tiles[u[e]];y.holdingForFade()||(r=y.tileID,f=Math.pow(2,a.zoom-y.tileID.overscaledZ),m=i*y.queryPadding*t.EXTENT/y.tileSize/f,(e=[r.getTilePoint(new t.MercatorCoordinate(c,p)),r.getTilePoint(new t.MercatorCoordinate(h,d))])[0].x-m<t.EXTENT&&e[0].y-m<t.EXTENT&&0<=e[1].x+m&&0<=e[1].y+m&&(e=s.map(function(t){return r.getTilePoint(t)}),m=l.map(function(t){return r.getTilePoint(t)}),o.push({tile:y,tileID:r,queryGeometry:e,cameraQueryGeometry:m,scale:f})))}(g);return o},si.prototype.getVisibleCoordinates=function(t){for(var e=this,i=0,r=t=this.getRenderableIds(t).map(function(t){return e._tiles[t].tileID});i<r.length;i+=1){var n=r[i];n.posMatrix=this.transform.calculatePosMatrix(n.toUnwrapped())}return t},si.prototype.hasTransition=function(){if(this._source.hasTransition())return!0;if(ui(this._source.type))for(var e in this._tiles)if(void 0!==(e=this._tiles[e]).fadeEndTime&&e.fadeEndTime>=t.browser.now())return!0;return!1},si.prototype.setFeatureState=function(t,e,i){this._state.updateState(t=t||"_geojsonTileLayer",e,i)},si.prototype.removeFeatureState=function(t,e,i){this._state.removeFeatureState(t=t||"_geojsonTileLayer",e,i)},si.prototype.getFeatureState=function(t,e){return this._state.getState(t=t||"_geojsonTileLayer",e)},si.prototype.setDependencies=function(t,e,i){(t=this._tiles[t])&&t.setDependencies(e,i)},si.prototype.reloadTilesForDependencies=function(t,e){for(var i in this._tiles)this._tiles[i].hasDependency(t,e)&&this._reloadTile(i,"reloading");this._cache.filter(function(i){return!i.hasDependency(t,e)})},si);function si(e,i,r){var n=this;oi.call(this),this.id=e,this.dispatcher=r,this.on("data",function(t){"source"===t.dataType&&"metadata"===t.sourceDataType&&(n._sourceLoaded=!0),n._sourceLoaded&&!n._paused&&"source"===t.dataType&&"content"===t.sourceDataType&&(n.reload(),n.transform&&n.update(n.transform))}),this.on("error",function(){n._sourceErrored=!0}),this._source=function(e,i,r,n){if((n=new Q[i.type](e,i,r,n)).id!==e)throw new Error("Expected Source id to be "+e+" instead of "+n.id);return t.bindAll(["load","abort","unload","serialize","prepare"],n),n}(e,i,r,this),this._tiles={},this._cache=new et(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._maxTileCacheSize=null,this._loadedParentTiles={},this._coveredTiles={},this._state=new t.SourceFeatureState}function li(t,e){var i=Math.abs(2*t.wrap)-(t.wrap<0),r=Math.abs(2*e.wrap)-(e.wrap<0);return t.overscaledZ-e.overscaledZ||r-i||e.canonical.y-t.canonical.y||e.canonical.x-t.canonical.x}function ui(t){return"raster"===t||"image"===t||"video"===t}function ci(){return new t.window.Worker(ma.workerUrl)}ai.maxOverzooming=10,ai.maxUnderzooming=3;var pi="mapboxgl_preloaded_worker_pool",hi=function(){this.active={}};hi.prototype.acquire=function(t){if(!this.workers)for(this.workers=[];this.workers.length<hi.workerCount;)this.workers.push(new ci);return this.active[t]=!0,this.workers.slice()},hi.prototype.release=function(t){delete this.active[t],0===this.numActive()&&(this.workers.forEach(function(t){t.terminate()}),this.workers=null)},hi.prototype.isPreloaded=function(){return!!this.active[pi]},hi.prototype.numActive=function(){return Object.keys(this.active).length};var di,fi=Math.floor(t.browser.hardwareConcurrency/2);function mi(){return di=di||new hi}function yi(e){e=e.slice();for(var i=Object.create(null),r=0;r<e.length;r++)i[e[r].id]=e[r];for(var n=0;n<e.length;n++)"ref"in e[n]&&(e[n]=function(e,i){var r,n={};for(r in e)"ref"!==r&&(n[r]=e[r]);return t.refProperties.forEach(function(t){t in i&&(n[t]=i[t])}),n}(e[n],i[e[n].ref]));return e}function gi(){var e,i={},r=t.styleSpec.$version;for(e in t.styleSpec.$root){var n,o=t.styleSpec.$root[e];!o.required||null!=(n="version"===e?r:"array"===o.type?[]:{})&&(i[e]=n)}return i}hi.workerCount=Math.max(Math.min(fi,6),1);var vi={setStyle:"setStyle",addLayer:"addLayer",moveLayer:"moveLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight"};function _i(t,e,i){i.push({command:vi.addSource,args:[t,e[t]]})}function xi(t,e,i){e.push({command:vi.removeSource,args:[t]}),i[t]=!0}function bi(e,i,r,n,o,a){for(var s in i=i||{},e=e||{})e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||r.push({command:a,args:[n,s,i[s],o]}));for(s in i)i.hasOwnProperty(s)&&!e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||r.push({command:a,args:[n,s,i[s],o]}))}function wi(t){return t.id}function Si(t,e){return t[e.id]=e,t}function Ti(e,i){if(!e)return[{command:vi.setStyle,args:[i]}];var r=[];try{if(!t.deepEqual(e.version,i.version))return[{command:vi.setStyle,args:[i]}];t.deepEqual(e.center,i.center)||r.push({command:vi.setCenter,args:[i.center]}),t.deepEqual(e.zoom,i.zoom)||r.push({command:vi.setZoom,args:[i.zoom]}),t.deepEqual(e.bearing,i.bearing)||r.push({command:vi.setBearing,args:[i.bearing]}),t.deepEqual(e.pitch,i.pitch)||r.push({command:vi.setPitch,args:[i.pitch]}),t.deepEqual(e.sprite,i.sprite)||r.push({command:vi.setSprite,args:[i.sprite]}),t.deepEqual(e.glyphs,i.glyphs)||r.push({command:vi.setGlyphs,args:[i.glyphs]}),t.deepEqual(e.transition,i.transition)||r.push({command:vi.setTransition,args:[i.transition]}),t.deepEqual(e.light,i.light)||r.push({command:vi.setLight,args:[i.light]});var n={},o=[];!function(e,i,r,n){var o,a,s,l;for(o in i=i||{},e=e||{})e.hasOwnProperty(o)&&(i.hasOwnProperty(o)||xi(o,r,n));for(o in i)i.hasOwnProperty(o)&&(e.hasOwnProperty(o)?t.deepEqual(e[o],i[o])||("geojson"===e[o].type&&"geojson"===i[o].type&&function(e,i,r){for(var n in e[r])if(e[r].hasOwnProperty(n)&&"data"!==n&&!t.deepEqual(e[r][n],i[r][n]))return;for(n in i[r])if(i[r].hasOwnProperty(n)&&"data"!==n&&!t.deepEqual(e[r][n],i[r][n]))return;return 1}(e,i,o)?r.push({command:vi.setGeoJSONSourceData,args:[o,i[o].data]}):(s=i,xi(a=o,l=r,n),_i(a,s,l))):_i(o,i,r))}(e.sources,i.sources,o,n);var a=[];e.layers&&e.layers.forEach(function(t){n[t.source]?r.push({command:vi.removeLayer,args:[t.id]}):a.push(t)}),r=r.concat(o),function(e,i,r){i=i||[];for(var n,o,a,s,l,u=(e=e||[]).map(wi),c=i.map(wi),p=e.reduce(Si,{}),h=i.reduce(Si,{}),d=u.slice(),f=Object.create(null),m=0,y=0;m<u.length;m++)n=u[m],h.hasOwnProperty(n)?y++:(r.push({command:vi.removeLayer,args:[n]}),d.splice(d.indexOf(n,y),1));for(y=m=0;m<c.length;m++)n=c[c.length-1-m],d[d.length-1-m]!==n&&(p.hasOwnProperty(n)?(r.push({command:vi.removeLayer,args:[n]}),d.splice(d.lastIndexOf(n,d.length-y),1)):y++,s=d[d.length-m],r.push({command:vi.addLayer,args:[h[n],s]}),d.splice(d.length-m,0,n),f[n]=!0);for(m=0;m<c.length;m++)if(o=p[n=c[m]],a=h[n],!f[n]&&!t.deepEqual(o,a))if(t.deepEqual(o.source,a.source)&&t.deepEqual(o["source-layer"],a["source-layer"])&&t.deepEqual(o.type,a.type)){for(l in bi(o.layout,a.layout,r,n,null,vi.setLayoutProperty),bi(o.paint,a.paint,r,n,null,vi.setPaintProperty),t.deepEqual(o.filter,a.filter)||r.push({command:vi.setFilter,args:[n,a.filter]}),t.deepEqual(o.minzoom,a.minzoom)&&t.deepEqual(o.maxzoom,a.maxzoom)||r.push({command:vi.setLayerZoomRange,args:[n,a.minzoom,a.maxzoom]}),o)o.hasOwnProperty(l)&&"layout"!==l&&"paint"!==l&&"filter"!==l&&"metadata"!==l&&"minzoom"!==l&&"maxzoom"!==l&&(0===l.indexOf("paint.")?bi(o[l],a[l],r,n,l.slice(6),vi.setPaintProperty):t.deepEqual(o[l],a[l])||r.push({command:vi.setLayerProperty,args:[n,l,a[l]]}));for(l in a)a.hasOwnProperty(l)&&!o.hasOwnProperty(l)&&"layout"!==l&&"paint"!==l&&"filter"!==l&&"metadata"!==l&&"minzoom"!==l&&"maxzoom"!==l&&(0===l.indexOf("paint.")?bi(o[l],a[l],r,n,l.slice(6),vi.setPaintProperty):t.deepEqual(o[l],a[l])||r.push({command:vi.setLayerProperty,args:[n,l,a[l]]}))}else r.push({command:vi.removeLayer,args:[n]}),s=d[d.lastIndexOf(n)+1],r.push({command:vi.addLayer,args:[a,s]})}(a,i.layers,r)}catch(e){console.warn("Unable to compute style diff:",e),r=[{command:vi.setStyle,args:[i]}]}return r}function Ci(t,e){this.reset(t,e)}function Ei(t,e,i){var r=this.boxCells=[],n=this.circleCells=[];this.xCellCount=Math.ceil(t/i),this.yCellCount=Math.ceil(e/i);for(var o=0;o<this.xCellCount*this.yCellCount;o++)r.push([]),n.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=t,this.height=e,this.xScale=this.xCellCount/t,this.yScale=this.yCellCount/e,this.boxUid=0,this.circleUid=0}function Ii(e,i,r,n,o){var a=t.create();return i?(t.scale(a,a,[1/o,1/o,1]),r||t.rotateZ(a,a,n.angle)):t.multiply(a,n.labelPlaneMatrix,e),a}function ki(e,i,r,n,o){return i?(e=t.clone(e),t.scale(e,e,[o,o,1]),r||t.rotateZ(e,e,-n.angle),e):n.glCoordMatrix}function Ai(e,i){return Bi(e=[e.x,e.y,0,1],e,i),i=e[3],{point:new t.Point(e[0]/i,e[1]/i),signedDistanceFromCamera:i}}function Pi(t,e){return.5+t/e*.5}function Mi(t,e,i,r,n,o,a,s,l,u,c){var p=s.glyphStartIndex+s.numGlyphs,h=s.lineStartIndex,d=s.lineStartIndex+s.lineLength,f=e.getoffsetX(s.glyphStartIndex);p=e.getoffsetX(p-1);return(f=zi(t*f,i,r,n,o,a,s.segment,h,d,l,u,c))&&(c=zi(t*p,i,r,n,o,a,s.segment,h,d,l,u,c))?{first:f,last:c}:null}function Li(e,i,r,n){if(e===t.WritingMode.horizontal){var o=Math.abs(r.y-i.y);if(Math.abs(r.x-i.x)*n<o)return{useVertical:!0}}return(e===t.WritingMode.vertical?i.y<r.y:i.x>r.x)?{needsFlipping:!0}:null}function Oi(e,i,r,n,o,a,s,l,u,c,p,h,d,f){var m=i/24,y=e.lineOffsetX*m,g=e.lineOffsetY*m;if(1<e.numGlyphs){var v=e.glyphStartIndex+e.numGlyphs,_=e.lineStartIndex,x=e.lineStartIndex+e.lineLength;if(!(S=Mi(m,l,y,g,r,p,h,e,u,a,d)))return{notEnoughRoom:!0};if(i=Ai(S.first.point,s).point,s=Ai(S.last.point,s).point,n&&!r&&(s=Li(e.writingMode,i,s,f)))return s;for(var b=[S.first],w=e.glyphStartIndex+1;w<v-1;w++)b.push(zi(m*l.getoffsetX(w),y,g,r,p,h,e.segment,_,x,u,a,d));b.push(S.last)}else{if(n&&!r){var S=Ai(h,o).point,T=(n=e.lineStartIndex+e.segment+1,0<(n=Ai(T=new t.Point(u.getx(n),u.gety(n)),o)).signedDistanceFromCamera?n.point:Ri(h,T,S,1,o));if(T=Li(e.writingMode,S,T,f))return T}if(!(T=zi(m*l.getoffsetX(e.glyphStartIndex),y,g,r,p,h,e.segment,e.lineStartIndex,e.lineStartIndex+e.lineLength,u,a,d)))return{notEnoughRoom:!0};b=[T]}for(var C=0,E=b;C<E.length;C+=1){var I=E[C];t.addDynamicAttributes(c,I.point,I.angle)}return{}}function Ri(t,e,i,r,n){return n=Ai(t.add(t.sub(e)._unit()),n).point,n=i.sub(n),i.add(n._mult(r/n.mag()))}function zi(e,i,r,n,o,a,s,l,u,c,p,h){var d=0<(e=n?e-i:e+i)?1:-1;i=0;n&&(d*=-1,i=Math.PI),d<0&&(i+=Math.PI);for(var f=0<d?l+s:l+s+1,m=o,y=o,g=0,v=0,_=Math.abs(e),x=[];g+v<=_;){if((f+=d)<l||u<=f)return null;var b,w;y=m;x.push(m),void 0===(m=h[f])&&(m=0<(w=Ai(b=new t.Point(c.getx(f),c.gety(f)),p)).signedDistanceFromCamera?h[f]=w.point:(w=f-d,Ri(0===g?a:new t.Point(c.getx(w),c.gety(w)),b,y,_-g+1,p))),g+=v,v=y.dist(m)}return o=(_-g)/v,(o=(e=m.sub(y)).mult(o)._add(y))._add(e._unit()._perp()._mult(r*d)),i+=Math.atan2(m.y-y.y,m.x-y.x),x.push(o),{point:o,angle:i,path:x}}Ci.prototype.reset=function(t,e){this.points=t||[],this._distances=[0];for(var i=1;i<this.points.length;i++)this._distances[i]=this._distances[i-1]+this.points[i].dist(this.points[i-1]);this.length=this._distances[this._distances.length-1],this.padding=Math.min(e||0,.5*this.length),this.paddedLength=this.length-2*this.padding},Ci.prototype.lerp=function(e){if(1===this.points.length)return this.points[0];e=t.clamp(e,0,1);for(var i=1,r=this._distances[i],n=e*this.paddedLength+this.padding;r<n&&i<this._distances.length;)r=this._distances[++i];var o=i-1,a=this._distances[o];e=0<(e=r-a)?(n-a)/e:0;return this.points[o].mult(1-e).add(this.points[i].mult(e))},Ei.prototype.keysLength=function(){return this.boxKeys.length+this.circleKeys.length},Ei.prototype.insert=function(t,e,i,r,n){this._forEachCell(e,i,r,n,this._insertBoxCell,this.boxUid++),this.boxKeys.push(t),this.bboxes.push(e),this.bboxes.push(i),this.bboxes.push(r),this.bboxes.push(n)},Ei.prototype.insertCircle=function(t,e,i,r){this._forEachCell(e-r,i-r,e+r,i+r,this._insertCircleCell,this.circleUid++),this.circleKeys.push(t),this.circles.push(e),this.circles.push(i),this.circles.push(r)},Ei.prototype._insertBoxCell=function(t,e,i,r,n,o){this.boxCells[n].push(o)},Ei.prototype._insertCircleCell=function(t,e,i,r,n,o){this.circleCells[n].push(o)},Ei.prototype._query=function(t,e,i,r,n,o){if(i<0||t>this.width||r<0||e>this.height)return!n&&[];var a=[];if(t<=0&&e<=0&&this.width<=i&&this.height<=r){if(n)return!0;for(var s=0;s<this.boxKeys.length;s++)a.push({key:this.boxKeys[s],x1:this.bboxes[4*s],y1:this.bboxes[4*s+1],x2:this.bboxes[4*s+2],y2:this.bboxes[4*s+3]});for(var l=0;l<this.circleKeys.length;l++){var u=this.circles[3*l],c=this.circles[3*l+1],p=this.circles[3*l+2];a.push({key:this.circleKeys[l],x1:u-p,y1:c-p,x2:u+p,y2:c+p})}return o?a.filter(o):a}return this._forEachCell(t,e,i,r,this._queryCell,a,{hitTest:n,seenUids:{box:{},circle:{}}},o),n?0<a.length:a},Ei.prototype._queryCircle=function(t,e,i,r,n){var o=t-i,a=t+i,s=e-i,l=e+i;if(a<0||o>this.width||l<0||s>this.height)return!r&&[];var u=[];return this._forEachCell(o,s,a,l,this._queryCellCircle,u,{hitTest:r,circle:{x:t,y:e,radius:i},seenUids:{box:{},circle:{}}},n),r?0<u.length:u},Ei.prototype.query=function(t,e,i,r,n){return this._query(t,e,i,r,!1,n)},Ei.prototype.hitTest=function(t,e,i,r,n){return this._query(t,e,i,r,!0,n)},Ei.prototype.hitTestCircle=function(t,e,i,r){return this._queryCircle(t,e,i,!0,r)},Ei.prototype._queryCell=function(t,e,i,r,n,o,a,s){var l=a.seenUids,u=this.boxCells[n];if(null!==u)for(var c=this.bboxes,p=0,h=u;p<h.length;p+=1){var d=h[p];if(!l.box[d]){l.box[d]=!0;var f=4*d;if(t<=c[2+f]&&e<=c[3+f]&&i>=c[0+f]&&r>=c[1+f]&&(!s||s(this.boxKeys[d]))){if(a.hitTest)return o.push(!0),!0;o.push({key:this.boxKeys[d],x1:c[f],y1:c[1+f],x2:c[2+f],y2:c[3+f]})}}}if(null!==(n=this.circleCells[n]))for(var m=this.circles,y=0,g=n;y<g.length;y+=1){var v=g[y];if(!l.circle[v]){l.circle[v]=!0;var _=3*v;if(this._circleAndRectCollide(m[_],m[1+_],m[2+_],t,e,i,r)&&(!s||s(this.circleKeys[v]))){if(a.hitTest)return o.push(!0),!0;var x=m[_],b=m[1+_];_=m[2+_];o.push({key:this.circleKeys[v],x1:x-_,y1:b-_,x2:x+_,y2:b+_})}}}},Ei.prototype._queryCellCircle=function(t,e,i,r,n,o,a,s){var l=a.circle,u=a.seenUids;if(null!==(a=this.boxCells[n]))for(var c=this.bboxes,p=0,h=a;p<h.length;p+=1){var d=h[p];if(!u.box[d]){u.box[d]=!0;var f=4*d;if(this._circleAndRectCollide(l.x,l.y,l.radius,c[0+f],c[1+f],c[2+f],c[3+f])&&(!s||s(this.boxKeys[d])))return o.push(!0),!0}}if(null!==(n=this.circleCells[n]))for(var m=this.circles,y=0,g=n;y<g.length;y+=1){var v=g[y];if(!u.circle[v]){u.circle[v]=!0;var _=3*v;if(this._circlesCollide(m[_],m[1+_],m[2+_],l.x,l.y,l.radius)&&(!s||s(this.circleKeys[v])))return o.push(!0),!0}}},Ei.prototype._forEachCell=function(t,e,i,r,n,o,a,s){for(var l=this._convertToXCellCoord(t),u=this._convertToYCellCoord(e),c=this._convertToXCellCoord(i),p=this._convertToYCellCoord(r),h=l;h<=c;h++)for(var d=u;d<=p;d++){var f=this.xCellCount*d+h;if(n.call(this,t,e,i,r,f,o,a,s))return}},Ei.prototype._convertToXCellCoord=function(t){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(t*this.xScale)))},Ei.prototype._convertToYCellCoord=function(t){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(t*this.yScale)))},Ei.prototype._circlesCollide=function(t,e,i,r,n,o){return(t=r-t)*t+(e=n-e)*e<(o=i+o)*o},Ei.prototype._circleAndRectCollide=function(t,e,i,r,n,o,a){return!((o=(o-r)/2)+i<(r=Math.abs(t-(r+o))))&&(!((a=(a-n)/2)+i<(n=Math.abs(e-(n+a))))&&(r<=o||n<=a||(o=r-o)*o+(a=n-a)*a<=i*i))};var Di=new Float32Array([-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0]);function Ni(t,e){for(var i=0;i<t;i++){var r=e.length;e.resize(r+4),e.float32.set(Di,3*r)}}function Bi(t,e,i){var r=e[0];e=e[1];return t[0]=i[0]*r+i[4]*e+i[12],t[1]=i[1]*r+i[5]*e+i[13],t[3]=i[3]*r+i[7]*e+i[15],t}function Fi(t,e,i){void 0===e&&(e=new Ei(t.width+200,t.height+200,25)),void 0===i&&(i=new Ei(t.width+200,t.height+200,25)),this.transform=t,this.grid=e,this.ignoredGrid=i,this.pitchfactor=Math.cos(t._pitch)*t.cameraToCenterDistance,this.screenRightBoundary=t.width+100,this.screenBottomBoundary=t.height+100,this.gridRightBoundary=t.width+200,this.gridBottomBoundary=t.height+200}function Ui(e,i,r){return i*(t.EXTENT/(e.tileSize*Math.pow(2,r-e.tileID.overscaledZ)))}function ji(t,e,i,r){this.opacity=t?Math.max(0,Math.min(1,t.opacity+(t.placed?e:-e))):r&&i?1:0,this.placed=i}function Vi(t,e,i,r,n){this.text=new ji(t?t.text:null,e,i,n),this.icon=new ji(t?t.icon:null,e,r,n)}function qi(t,e,i){this.text=t,this.icon=e,this.skipFade=i}function Hi(){this.invProjMatrix=t.create(),this.viewportMatrix=t.create(),this.circles=[]}function Gi(t,e,i,r,n){this.bucketInstanceId=t,this.featureIndex=e,this.sourceLayerIndex=i,this.bucketIndex=r,this.tileID=n}function Zi(t){this.crossSourceCollisions=t,this.maxGroupID=0,this.collisionGroups={}}function Wi(e,i,r,n,o){var a=t.getAnchorAlignment(e);i=-(a.horizontalAlign-.5)*i,r=-(a.verticalAlign-.5)*r,n=t.evaluateVariableOffset(e,n);return new t.Point(i+n[0]*o,r+n[1]*o)}function Ki(e,i,r,n,o,a){var s=e.x1,l=e.x2,u=e.y1,c=e.y2,p=e.anchorPointX;e=e.anchorPointY,r=new t.Point(i,r);return n&&r._rotate(o?a:-a),{x1:s+r.x,y1:u+r.y,x2:l+r.x,y2:c+r.y,anchorPointX:p,anchorPointY:e}}function Xi(t,e,i,r){this.transform=t.clone(),this.collisionIndex=new Fi(this.transform),this.placements={},this.opacities={},this.variableOffsets={},this.stale=!1,this.commitTime=0,this.fadeDuration=e,this.retainedQueryData={},this.collisionGroups=new Zi(i),this.collisionCircleArrays={},(this.prevPlacement=r)&&(r.prevPlacement=void 0),this.placedOrientations={}}function Yi(t,e,i,r,n){t.emplaceBack(e?1:0,i?1:0,r||0,n||0),t.emplaceBack(e?1:0,i?1:0,r||0,n||0),t.emplaceBack(e?1:0,i?1:0,r||0,n||0),t.emplaceBack(e?1:0,i?1:0,r||0,n||0)}Fi.prototype.placeCollisionBox=function(t,e,i,r,n){var o=i*(s=this.projectAndGetPerspectiveRatio(r,t.anchorPointX,t.anchorPointY)).perspectiveRatio,a=t.x1*o+s.point.x,s=(r=t.y1*o+s.point.y,i=t.x2*o+s.point.x,t.y2*o+s.point.y);return!this.isInsideGrid(a,r,i,s)||!e&&this.grid.hitTest(a,r,i,s,n)?{box:[],offscreen:!1}:{box:[a,r,i,s],offscreen:this.isOffscreen(a,r,i,s)}},Fi.prototype.placeCollisionCircles=function(e,i,r,n,o,a,s,l,u,c,p,h,d){var f=[],m=new t.Point(i.anchorX,i.anchorY),y=(a=Ai(m,a),a=Pi(this.transform.cameraToCenterDistance,a.signedDistanceFromCamera),c=(c?o/a:o*a)/t.ONE_EM,o=Ai(m,s).point,!1),g=!1,v=!0;if(s=Mi(c,n,i.lineOffsetX*c,i.lineOffsetY*c,!1,o,m,i,r,s,{})){for(var _=.5*h*a+d,x=(h=new t.Point(-100,-100),a=new t.Point(this.screenRightBoundary,this.screenBottomBoundary),new Ci),b=s.first,w=s.last,S=[],T=b.path.length-1;1<=T;T--)S.push(b.path[T]);for(var C=1;C<w.path.length;C++)S.push(w.path[C]);var E=2.5*_;d=[];if(0<(S=l?(s=S.map(function(t){return Ai(t,l)})).some(function(t){return t.signedDistanceFromCamera<=0})?[]:s.map(function(t){return t.point}):S).length){for(var I=S[0].clone(),k=S[0].clone(),A=1;A<S.length;A++)I.x=Math.min(I.x,S[A].x),I.y=Math.min(I.y,S[A].y),k.x=Math.max(k.x,S[A].x),k.y=Math.max(k.y,S[A].y);d=I.x>=h.x&&k.x<=a.x&&I.y>=h.y&&k.y<=a.y?[S]:k.x<h.x||I.x>a.x||k.y<h.y||I.y>a.y?[]:t.clipLine([S],h.x,h.y,a.x,a.y)}for(var P=0,M=d;P<M.length;P+=1){var L=M[P];x.reset(L,.25*_);for(var O=x.length<=.5*_?1:Math.ceil(x.paddedLength/E)+1,R=0;R<O;R++){var z=R/Math.max(O-1,1),D=(U=x.lerp(z)).x+100,N=U.y+100;f.push(D,N,_,0);var B=D-_,F=N-_,U=(z=D+_,N+_);v=v&&this.isOffscreen(B,F,z,U),g=g||this.isInsideGrid(B,F,z,U);if(!e&&this.grid.hitTestCircle(D,N,_,p)&&(y=!0,!u))return{circles:[],offscreen:!1,collisionDetected:y}}}}return{circles:!u&&y||!g?[]:f,offscreen:v,collisionDetected:y}},Fi.prototype.queryRenderedSymbols=function(e){if(0===e.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return{};for(var i=[],r=1/0,n=1/0,o=-1/0,a=-1/0,s=0,l=e;s<l.length;s+=1){var u=l[s];u=new t.Point(u.x+100,u.y+100),r=Math.min(r,u.x),n=Math.min(n,u.y),o=Math.max(o,u.x),a=Math.max(a,u.y);i.push(u)}for(var c={},p={},h=0,d=this.grid.query(r,n,o,a).concat(this.ignoredGrid.query(r,n,o,a));h<d.length;h+=1){var f=d[h],m=f.key;void 0===c[m.bucketInstanceId]&&(c[m.bucketInstanceId]={}),c[m.bucketInstanceId][m.featureIndex]||(f=[new t.Point(f.x1,f.y1),new t.Point(f.x2,f.y1),new t.Point(f.x2,f.y2),new t.Point(f.x1,f.y2)],t.polygonIntersectsPolygon(i,f)&&(c[m.bucketInstanceId][m.featureIndex]=!0,void 0===p[m.bucketInstanceId]&&(p[m.bucketInstanceId]=[]),p[m.bucketInstanceId].push(m.featureIndex)))}return p},Fi.prototype.insertCollisionBox=function(t,e,i,r,n){(e?this.ignoredGrid:this.grid).insert({bucketInstanceId:i,featureIndex:r,collisionGroupID:n},t[0],t[1],t[2],t[3])},Fi.prototype.insertCollisionCircles=function(t,e,i,r,n){for(var o=e?this.ignoredGrid:this.grid,a={bucketInstanceId:i,featureIndex:r,collisionGroupID:n},s=0;s<t.length;s+=4)o.insertCircle(a,t[s],t[s+1],t[s+2])},Fi.prototype.projectAndGetPerspectiveRatio=function(e,i,r){return Bi(r=[i,r,0,1],r,e),{point:new t.Point((r[0]/r[3]+1)/2*this.transform.width+100,(-r[1]/r[3]+1)/2*this.transform.height+100),perspectiveRatio:.5+this.transform.cameraToCenterDistance/r[3]*.5}},Fi.prototype.isOffscreen=function(t,e,i,r){return i<100||t>=this.screenRightBoundary||r<100||e>this.screenBottomBoundary},Fi.prototype.isInsideGrid=function(t,e,i,r){return 0<=i&&t<this.gridRightBoundary&&0<=r&&e<this.gridBottomBoundary},Fi.prototype.getViewportMatrix=function(){var e=t.identity([]);return t.translate(e,e,[-100,-100,0]),e},ji.prototype.isHidden=function(){return 0===this.opacity&&!this.placed},Vi.prototype.isHidden=function(){return this.text.isHidden()&&this.icon.isHidden()},Zi.prototype.get=function(t){return this.crossSourceCollisions?{ID:0,predicate:null}:(this.collisionGroups[t]||(e=++this.maxGroupID,this.collisionGroups[t]={ID:e,predicate:function(t){return t.collisionGroupID===e}}),this.collisionGroups[t]);var e},Xi.prototype.getBucketParts=function(e,i,r,n){var o=r.getBucket(i),a=r.latestFeatureIndex;if(o&&a&&i.id===o.layerIds[0]){var s=r.collisionBoxArray,l=o.layers[0].layout,u=Math.pow(2,this.transform.zoom-r.tileID.overscaledZ),c=r.tileSize/t.EXTENT,p=this.transform.calculatePosMatrix(r.tileID.toUnwrapped()),h="map"===l.get("text-pitch-alignment"),d="map"===l.get("text-rotation-alignment"),f=Ui(r,1,this.transform.zoom),m=Ii(p,h,d,this.transform,f);i=null;h&&(f=ki(p,h,d,this.transform,f),i=t.multiply([],this.transform.labelPlaneMatrix,f)),this.retainedQueryData[o.bucketInstanceId]=new Gi(o.bucketInstanceId,a,o.sourceLayerIndex,o.index,r.tileID);var y={bucket:o,layout:l,posMatrix:p,textLabelPlaneMatrix:m,labelToScreenMatrix:i,scale:u,textPixelRatio:c,holdingForFade:r.holdingForFade(),collisionBoxArray:s,partiallyEvaluatedTextSize:t.evaluateSizeForZoom(o.textSizeData,this.transform.zoom),collisionGroup:this.collisionGroups.get(o.sourceID)};if(n)for(var g=0,v=o.sortKeyRanges;g<v.length;g+=1){var _=(b=v[g]).sortKey,x=b.symbolInstanceStart,b=b.symbolInstanceEnd;e.push({sortKey:_,symbolInstanceStart:x,symbolInstanceEnd:b,parameters:y})}else e.push({symbolInstanceStart:0,symbolInstanceEnd:o.symbolInstances.length,parameters:y})}},Xi.prototype.attemptAnchorPlacement=function(t,e,i,r,n,o,a,s,l,u,c,p,h,d,f){var m,y=[p.textOffset0,p.textOffset1],g=Wi(t,i,r,y,n);e=this.collisionIndex.placeCollisionBox(Ki(e,g.x,g.y,o,a,this.transform.angle),c,s,l,u.predicate);if(!f||0!==this.collisionIndex.placeCollisionBox(Ki(f,g.x,g.y,o,a,this.transform.angle),c,s,l,u.predicate).box.length)return 0<e.box.length?(this.prevPlacement&&this.prevPlacement.variableOffsets[p.crossTileID]&&this.prevPlacement.placements[p.crossTileID]&&this.prevPlacement.placements[p.crossTileID].text&&(m=this.prevPlacement.variableOffsets[p.crossTileID].anchor),this.variableOffsets[p.crossTileID]={textOffset:y,width:i,height:r,anchor:t,textBoxScale:n,prevAnchor:m},this.markUsedJustification(h,t,p,d),h.allowVerticalPlacement&&(this.markUsedOrientation(h,d,p),this.placedOrientations[p.crossTileID]=d),{shift:g,placedGlyphBoxes:e}):void 0},Xi.prototype.placeLayerBucketPart=function(e,i,r){var n=this,o=(w=e.parameters).bucket,a=w.layout,s=w.posMatrix,l=w.textLabelPlaneMatrix,u=w.labelToScreenMatrix,c=w.textPixelRatio,p=w.holdingForFade,h=w.collisionBoxArray,d=w.partiallyEvaluatedTextSize,f=w.collisionGroup,m=a.get("text-optional"),y=a.get("icon-optional"),g=a.get("text-allow-overlap"),v=a.get("icon-allow-overlap"),_="map"===a.get("text-rotation-alignment"),x="map"===a.get("text-pitch-alignment"),b="none"!==a.get("icon-text-fit"),w="viewport-y"===a.get("symbol-z-order"),S=g&&(v||!o.hasIconData()||y),T=v&&(g||!o.hasTextData()||m);function C(e,h){if(!i[e.crossTileID])if(p)n.placements[e.crossTileID]=new qi(!1,!1,!1);else{var w=!1,C=!1,E=!0,I=null,k={box:null,offscreen:null},A={box:null,offscreen:null},P=null,M=null,L=0,O=0,R=0;h.textFeatureIndex?L=h.textFeatureIndex:e.useRuntimeCollisionCircles&&(L=e.featureIndex),h.verticalTextFeatureIndex&&(O=h.verticalTextFeatureIndex);var z,D,N,B,F,U,j,V,q=h.textBox;q&&(V=function(i){var r=t.WritingMode.horizontal;return!o.allowVerticalPlacement||i||!n.prevPlacement||(i=n.prevPlacement.placedOrientations[e.crossTileID])&&(n.placedOrientations[e.crossTileID]=i,n.markUsedOrientation(o,r=i,e)),r},j=function(i,r){if(o.allowVerticalPlacement&&0<e.numVerticalGlyphVertices&&h.verticalTextBox)for(var n=0,a=o.writingModes;n<a.length&&(a[n]===t.WritingMode.vertical?(k=r(),A=k):k=i(),!(k&&k.box&&k.box.length));n+=1);else k=i()},a.get("text-variable-anchor")?(z=a.get("text-variable-anchor"),n.prevPlacement&&n.prevPlacement.variableOffsets[e.crossTileID]&&(D=n.prevPlacement.variableOffsets[e.crossTileID],0<z.indexOf(D.anchor)&&(z=z.filter(function(t){return t!==D.anchor})).unshift(D.anchor)),N=function(t,i,r){for(var a=t.x2-t.x1,l=t.y2-t.y1,u=e.textBoxScale,p=b&&!v?i:null,h={box:[],offscreen:!1},d=g?2*z.length:z.length,m=0;m<d;++m){var y=z[m%z.length],S=m>=z.length;if((S=n.attemptAnchorPlacement(y,t,a,l,u,_,x,c,s,f,S,e,o,r,p))&&(h=S.placedGlyphBoxes)&&h.box&&h.box.length){w=!0,I=S.shift;break}}return h},j(function(){return N(q,h.iconBox,t.WritingMode.horizontal)},function(){var i=h.verticalTextBox,r=k&&k.box&&k.box.length;return o.allowVerticalPlacement&&!r&&0<e.numVerticalGlyphVertices&&i?N(i,h.verticalIconBox,t.WritingMode.vertical):{box:null,offscreen:null}}),k&&(w=k.box,E=k.offscreen),U=V(k&&k.box),w||!n.prevPlacement||(B=n.prevPlacement.variableOffsets[e.crossTileID])&&(n.variableOffsets[e.crossTileID]=B,n.markUsedJustification(o,B.anchor,e,U))):(F=function(t,i){return(t=n.collisionIndex.placeCollisionBox(t,g,c,s,f.predicate))&&t.box&&t.box.length&&(n.markUsedOrientation(o,i,e),n.placedOrientations[e.crossTileID]=i),t},j(function(){return F(q,t.WritingMode.horizontal)},function(){var i=h.verticalTextBox;return o.allowVerticalPlacement&&0<e.numVerticalGlyphVertices&&i?F(i,t.WritingMode.vertical):{box:null,offscreen:null}}),V(k&&k.box&&k.box.length))),w=(B=k)&&B.box&&0<B.box.length,E=B&&B.offscreen,e.useRuntimeCollisionCircles&&(U=o.text.placedSymbolArray.get(e.centerJustifiedTextSymbolIndex),j=t.evaluateSizeForFeature(o.textSizeData,d,U),H=a.get("text-padding"),V=e.collisionCircleDiameter,P=n.collisionIndex.placeCollisionCircles(g,U,o.lineVertexArray,o.glyphOffsetArray,j,s,l,u,r,x,f.predicate,V,H),w=g||0<P.circles.length&&!P.collisionDetected,E=E&&P.offscreen),h.iconFeatureIndex&&(R=h.iconFeatureIndex),h.iconBox&&(G=function(t){return t=b&&I?Ki(t,I.x,I.y,_,x,n.transform.angle):t,n.collisionIndex.placeCollisionBox(t,v,c,s,f.predicate)},C=A&&A.box&&A.box.length&&h.verticalIconBox?0<(M=G(h.verticalIconBox)).box.length:0<(M=G(h.iconBox)).box.length,E=E&&M.offscreen);var H=m||0===e.numHorizontalGlyphVertices&&0===e.numVerticalGlyphVertices,G=y||0===e.numIconVertices;if(H||G?G?H||(C=C&&w):w=C&&w:C=w=C&&w,w&&B&&B.box&&(A&&A.box&&O?n.collisionIndex.insertCollisionBox(B.box,a.get("text-ignore-placement"),o.bucketInstanceId,O,f.ID):n.collisionIndex.insertCollisionBox(B.box,a.get("text-ignore-placement"),o.bucketInstanceId,L,f.ID)),C&&M&&n.collisionIndex.insertCollisionBox(M.box,a.get("icon-ignore-placement"),o.bucketInstanceId,R,f.ID),P&&(w&&n.collisionIndex.insertCollisionCircles(P.circles,a.get("text-ignore-placement"),o.bucketInstanceId,L,f.ID),r)){L=o.bucketInstanceId;var Z=n.collisionCircleArrays[L];void 0===Z&&(Z=n.collisionCircleArrays[L]=new Hi);for(var W=0;W<P.circles.length;W+=4)Z.circles.push(P.circles[W+0]),Z.circles.push(P.circles[W+1]),Z.circles.push(P.circles[W+2]),Z.circles.push(P.collisionDetected?1:0)}n.placements[e.crossTileID]=new qi(w||S,C||T,E||o.justReloaded),i[e.crossTileID]=!0}}if(!o.collisionArrays&&h&&o.deserializeCollisionBoxes(h),w)for(var E=o.getSortedSymbolIndexes(this.transform.angle),I=E.length-1;0<=I;--I){var k=E[I];C(o.symbolInstances.get(k),o.collisionArrays[k])}else for(var A=e.symbolInstanceStart;A<e.symbolInstanceEnd;A++)C(o.symbolInstances.get(A),o.collisionArrays[A]);r&&o.bucketInstanceId in this.collisionCircleArrays&&(w=this.collisionCircleArrays[o.bucketInstanceId],t.invert(w.invProjMatrix,s),w.viewportMatrix=this.collisionIndex.getViewportMatrix()),o.justReloaded=!1},Xi.prototype.markUsedJustification=function(e,i,r,n){for(var o={left:r.leftJustifiedTextSymbolIndex,center:r.centerJustifiedTextSymbolIndex,right:r.rightJustifiedTextSymbolIndex},a=n===t.WritingMode.vertical?r.verticalPlacedTextSymbolIndex:o[t.getAnchorJustification(i)],s=0,l=[r.leftJustifiedTextSymbolIndex,r.centerJustifiedTextSymbolIndex,r.rightJustifiedTextSymbolIndex,r.verticalPlacedTextSymbolIndex];s<l.length;s+=1){var u=l[s];0<=u&&(e.text.placedSymbolArray.get(u).crossTileID=0<=a&&u!==a?0:r.crossTileID)}},Xi.prototype.markUsedOrientation=function(e,i,r){for(var n=i===t.WritingMode.horizontal||i===t.WritingMode.horizontalOnly?i:0,o=(i=i===t.WritingMode.vertical?i:0,0),a=[r.leftJustifiedTextSymbolIndex,r.centerJustifiedTextSymbolIndex,r.rightJustifiedTextSymbolIndex];o<a.length;o+=1)e.text.placedSymbolArray.get(a[o]).placedOrientation=n;r.verticalPlacedTextSymbolIndex&&(e.text.placedSymbolArray.get(r.verticalPlacedTextSymbolIndex).placedOrientation=i)},Xi.prototype.commit=function(t){this.commitTime=t,this.zoomAtLastRecencyCheck=this.transform.zoom;var e=this.prevPlacement,i=!1;this.prevZoomAdjustment=e?e.zoomAdjustment(this.transform.zoom):0;var r,n,o,a,s=e?e.symbolFadeChange(t):1,l=e?e.opacities:{},u=e?e.variableOffsets:{},c=e?e.placedOrientations:{};for(r in this.placements){var p=this.placements[r],h=l[r];i=h?(this.opacities[r]=new Vi(h,s,p.text,p.icon),i||p.text!==h.text.placed||p.icon!==h.icon.placed):(this.opacities[r]=new Vi(null,s,p.text,p.icon,p.skipFade),i||p.text||p.icon)}for(n in l){var d,f=l[n];this.opacities[n]||(d=new Vi(f,s,!1,!1)).isHidden()||(this.opacities[n]=d,i=i||f.text.placed||f.icon.placed)}for(o in u)this.variableOffsets[o]||!this.opacities[o]||this.opacities[o].isHidden()||(this.variableOffsets[o]=u[o]);for(a in c)this.placedOrientations[a]||!this.opacities[a]||this.opacities[a].isHidden()||(this.placedOrientations[a]=c[a]);i?this.lastPlacementChangeTime=t:"number"!=typeof this.lastPlacementChangeTime&&(this.lastPlacementChangeTime=e?e.lastPlacementChangeTime:t)},Xi.prototype.updateLayerOpacities=function(t,e){for(var i={},r=0,n=e;r<n.length;r+=1){var o=n[r],a=o.getBucket(t);a&&o.latestFeatureIndex&&t.id===a.layerIds[0]&&this.updateBucketOpacities(a,i,o.collisionBoxArray)}},Xi.prototype.updateBucketOpacities=function(e,i,r){var n=this;e.hasTextData()&&e.text.opacityVertexArray.clear(),e.hasIconData()&&e.icon.opacityVertexArray.clear(),e.hasIconCollisionBoxData()&&e.iconCollisionBox.collisionVertexArray.clear(),e.hasTextCollisionBoxData()&&e.textCollisionBox.collisionVertexArray.clear();var o=e.layers[0].layout,a=new Vi(null,0,!1,!1,!0),s=o.get("text-allow-overlap"),l=o.get("icon-allow-overlap"),u=o.get("text-variable-anchor"),c="map"===o.get("text-rotation-alignment"),p="map"===o.get("text-pitch-alignment"),h="none"!==o.get("icon-text-fit"),d=new Vi(null,0,s&&(l||!e.hasIconData()||o.get("icon-optional")),l&&(s||!e.hasTextData()||o.get("text-optional")),!0);!e.collisionArrays&&r&&(e.hasIconCollisionBoxData()||e.hasTextCollisionBoxData())&&e.deserializeCollisionBoxes(r);for(var f=function(t,e,i){for(var r=0;r<e/4;r++)t.opacityVertexArray.emplaceBack(i)},m=0;m<e.symbolInstances.length;m++)!function(r){var o=e.symbolInstances.get(r),s=o.numHorizontalGlyphVertices,l=o.numVerticalGlyphVertices,m=o.crossTileID,y=i[m],g=n.opacities[m];y?g=a:g||(n.opacities[m]=g=d),i[m]=!0;var v,_,x=0<o.numIconVertices,b=n.placedOrientations[o.crossTileID],w=b===t.WritingMode.vertical,S=b===t.WritingMode.horizontal||b===t.WritingMode.horizontalOnly;(0<s||0<l)&&(y=nr(g.text),f(e.text,s,w?ar:y),f(e.text,l,S?ar:y),v=g.text.isHidden(),[o.rightJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.leftJustifiedTextSymbolIndex].forEach(function(t){0<=t&&(e.text.placedSymbolArray.get(t).hidden=v||w?1:0)}),0<=o.verticalPlacedTextSymbolIndex&&(e.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).hidden=v||S?1:0),(y=n.variableOffsets[o.crossTileID])&&n.markUsedJustification(e,y.anchor,o,b),(b=n.placedOrientations[o.crossTileID])&&(n.markUsedJustification(e,"left",o,b),n.markUsedOrientation(e,b,o))),x&&(_=nr(g.icon),x=!(h&&o.verticalPlacedIconSymbolIndex&&w),0<=o.placedIconSymbolIndex&&(f(e.icon,o.numIconVertices,x?_:ar),e.icon.placedSymbolArray.get(o.placedIconSymbolIndex).hidden=g.icon.isHidden()),0<=o.verticalPlacedIconSymbolIndex&&(f(e.icon,o.numVerticalIconVertices,x?ar:_),e.icon.placedSymbolArray.get(o.verticalPlacedIconSymbolIndex).hidden=g.icon.isHidden())),!e.hasIconCollisionBoxData()&&!e.hasTextCollisionBoxData()||(_=e.collisionArrays[r])&&(o=new t.Point(0,0),(_.textBox||_.verticalTextBox)&&(r=!0,u&&((m=n.variableOffsets[m])?(o=Wi(m.anchor,m.width,m.height,m.textOffset,m.textBoxScale),c&&o._rotate(p?n.transform.angle:-n.transform.angle)):r=!1),_.textBox&&Yi(e.textCollisionBox.collisionVertexArray,g.text.placed,!r||w,o.x,o.y),_.verticalTextBox&&Yi(e.textCollisionBox.collisionVertexArray,g.text.placed,!r||S,o.x,o.y)),S=Boolean(!S&&_.verticalIconBox),_.iconBox&&Yi(e.iconCollisionBox.collisionVertexArray,g.icon.placed,S,h?o.x:0,h?o.y:0),_.verticalIconBox&&Yi(e.iconCollisionBox.collisionVertexArray,g.icon.placed,!S,h?o.x:0,h?o.y:0))}(m);e.sortFeatures(this.transform.angle),this.retainedQueryData[e.bucketInstanceId]&&(this.retainedQueryData[e.bucketInstanceId].featureSortOrder=e.featureSortOrder),e.hasTextData()&&e.text.opacityVertexBuffer&&e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray),e.hasIconData()&&e.icon.opacityVertexBuffer&&e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray),e.hasIconCollisionBoxData()&&e.iconCollisionBox.collisionVertexBuffer&&e.iconCollisionBox.collisionVertexBuffer.updateData(e.iconCollisionBox.collisionVertexArray),e.hasTextCollisionBoxData()&&e.textCollisionBox.collisionVertexBuffer&&e.textCollisionBox.collisionVertexBuffer.updateData(e.textCollisionBox.collisionVertexArray),e.bucketInstanceId in this.collisionCircleArrays&&(r=this.collisionCircleArrays[e.bucketInstanceId],e.placementInvProjMatrix=r.invProjMatrix,e.placementViewportMatrix=r.viewportMatrix,e.collisionCircleArray=r.circles,delete this.collisionCircleArrays[e.bucketInstanceId])},Xi.prototype.symbolFadeChange=function(t){return 0===this.fadeDuration?1:(t-this.commitTime)/this.fadeDuration+this.prevZoomAdjustment},Xi.prototype.zoomAdjustment=function(t){return Math.max(0,(this.transform.zoom-t)/1.5)},Xi.prototype.hasTransitions=function(t){return this.stale||t-this.lastPlacementChangeTime<this.fadeDuration},Xi.prototype.stillRecent=function(t,e){var i=this.zoomAtLastRecencyCheck===e?1-this.zoomAdjustment(e):1;return this.zoomAtLastRecencyCheck=e,this.commitTime+this.fadeDuration*i>t},Xi.prototype.setStale=function(){this.stale=!0};var Ji=Math.pow(2,25),Qi=Math.pow(2,24),$i=Math.pow(2,17),tr=Math.pow(2,16),er=Math.pow(2,9),ir=Math.pow(2,8),rr=Math.pow(2,1);function nr(t){if(0===t.opacity&&!t.placed)return 0;if(1===t.opacity&&t.placed)return 4294967295;var e=t.placed?1:0;return(t=Math.floor(127*t.opacity))*Ji+e*Qi+t*$i+e*tr+t*er+e*ir+t*rr+e}function or(t){this._sortAcrossTiles="viewport-y"!==t.layout.get("symbol-z-order")&&void 0!==t.layout.get("symbol-sort-key").constantOr(1),this._currentTileIndex=0,this._currentPartIndex=0,this._seenCrossTileIDs={},this._bucketParts=[]}var ar=0;function sr(t,e,i,r,n,o,a){this.placement=new Xi(t,n,o,a),this._currentPlacementIndex=e.length-1,this._forceFullPlacement=i,this._showCollisionBoxes=r,this._done=!1}function lr(t,e,i){this.tileID=t,this.indexedSymbolInstances={},this.bucketInstanceId=i;for(var r=0;r<e.length;r++){var n=e.get(r),o=n.key;this.indexedSymbolInstances[o]||(this.indexedSymbolInstances[o]=[]),this.indexedSymbolInstances[o].push({crossTileID:n.crossTileID,coord:this.getScaledCoordinates(n,t)})}}or.prototype.continuePlacement=function(t,e,i,r,n){for(var o=this._bucketParts;this._currentTileIndex<t.length;){var a=t[this._currentTileIndex];if(e.getBucketParts(o,r,a,this._sortAcrossTiles),this._currentTileIndex++,n())return!0}for(this._sortAcrossTiles&&(this._sortAcrossTiles=!1,o.sort(function(t,e){return t.sortKey-e.sortKey}));this._currentPartIndex<o.length;){var s=o[this._currentPartIndex];if(e.placeLayerBucketPart(s,this._seenCrossTileIDs,i),this._currentPartIndex++,n())return!0}return!1},sr.prototype.isDone=function(){return this._done},sr.prototype.continuePlacement=function(e,i,r){for(var n=this,o=t.browser.now(),a=function(){var e=t.browser.now()-o;return!n._forceFullPlacement&&2<e};0<=this._currentPlacementIndex;){var s=i[e[this._currentPlacementIndex]],l=this.placement.collisionIndex.transform.zoom;if("symbol"===s.type&&(!s.minzoom||s.minzoom<=l)&&(!s.maxzoom||s.maxzoom>l)){if(this._inProgressLayer||(this._inProgressLayer=new or(s)),this._inProgressLayer.continuePlacement(r[s.source],this.placement,this._showCollisionBoxes,s,a))return;delete this._inProgressLayer}this._currentPlacementIndex--}this._done=!0},sr.prototype.commit=function(t){return this.placement.commit(t),this.placement};var ur=512/t.EXTENT/2;function cr(){this.maxCrossTileID=0}function pr(){this.indexes={},this.usedCrossTileIDs={},this.lng=0}function hr(){this.layerIndexes={},this.crossTileIDs=new cr,this.maxBucketInstanceId=0,this.bucketsInCurrentPlacement={}}function dr(e,i){return t.emitValidationErrors(e,i&&i.filter(function(t){return"source.canvas"!==t.identifier}))}lr.prototype.getScaledCoordinates=function(e,i){var r=i.canonical.z-this.tileID.canonical.z;r=ur/Math.pow(2,r);return{x:Math.floor((i.canonical.x*t.EXTENT+e.anchorX)*r),y:Math.floor((i.canonical.y*t.EXTENT+e.anchorY)*r)}},lr.prototype.findMatches=function(t,e,i){for(var r=this.tileID.canonical.z<e.canonical.z?1:Math.pow(2,this.tileID.canonical.z-e.canonical.z),n=0;n<t.length;n++){var o=t.get(n);if(!o.crossTileID){var a=this.indexedSymbolInstances[o.key];if(a)for(var s=this.getScaledCoordinates(o,e),l=0,u=a;l<u.length;l+=1){var c=u[l];if(Math.abs(c.coord.x-s.x)<=r&&Math.abs(c.coord.y-s.y)<=r&&!i[c.crossTileID]){i[c.crossTileID]=!0,o.crossTileID=c.crossTileID;break}}}}},cr.prototype.generate=function(){return++this.maxCrossTileID},pr.prototype.handleWrapJump=function(t){var e=Math.round((t-this.lng)/360);if(0!==e)for(var i in this.indexes){var r,n=this.indexes[i],o={};for(r in n){var a=n[r];a.tileID=a.tileID.unwrapTo(a.tileID.wrap+e),o[a.tileID.key]=a}this.indexes[i]=o}this.lng=t},pr.prototype.addBucket=function(t,e,i){if(this.indexes[t.overscaledZ]&&this.indexes[t.overscaledZ][t.key]){if(this.indexes[t.overscaledZ][t.key].bucketInstanceId===e.bucketInstanceId)return!1;this.removeBucketCrossTileIDs(t.overscaledZ,this.indexes[t.overscaledZ][t.key])}for(var r=0;r<e.symbolInstances.length;r++)e.symbolInstances.get(r).crossTileID=0;this.usedCrossTileIDs[t.overscaledZ]||(this.usedCrossTileIDs[t.overscaledZ]={});var n,o=this.usedCrossTileIDs[t.overscaledZ];for(n in this.indexes){var a=this.indexes[n];if(Number(n)>t.overscaledZ)for(var s in a)(s=a[s]).tileID.isChildOf(t)&&s.findMatches(e.symbolInstances,t,o);else{var l=a[t.scaledTo(Number(n)).key];l&&l.findMatches(e.symbolInstances,t,o)}}for(var u=0;u<e.symbolInstances.length;u++){var c=e.symbolInstances.get(u);c.crossTileID||(c.crossTileID=i.generate(),o[c.crossTileID]=!0)}return void 0===this.indexes[t.overscaledZ]&&(this.indexes[t.overscaledZ]={}),this.indexes[t.overscaledZ][t.key]=new lr(t,e.symbolInstances,e.bucketInstanceId),!0},pr.prototype.removeBucketCrossTileIDs=function(t,e){for(var i in e.indexedSymbolInstances)for(var r=0,n=e.indexedSymbolInstances[i];r<n.length;r+=1){var o=n[r];delete this.usedCrossTileIDs[t][o.crossTileID]}},pr.prototype.removeStaleBuckets=function(t){var e,i=!1;for(e in this.indexes){var r,n=this.indexes[e];for(r in n)t[n[r].bucketInstanceId]||(this.removeBucketCrossTileIDs(e,n[r]),delete n[r],i=!0)}return i},hr.prototype.addLayer=function(t,e,i){var r=this.layerIndexes[t.id],n=!1,o={};(r=void 0===r?this.layerIndexes[t.id]=new pr:r).handleWrapJump(i);for(var a=0,s=e;a<s.length;a+=1){var l=s[a],u=l.getBucket(t);u&&t.id===u.layerIds[0]&&(u.bucketInstanceId||(u.bucketInstanceId=++this.maxBucketInstanceId),r.addBucket(l.tileID,u,this.crossTileIDs)&&(n=!0),o[u.bucketInstanceId]=!0)}return!!r.removeStaleBuckets(o)||n},hr.prototype.pruneUnusedLayers=function(t){var e,i={};for(e in t.forEach(function(t){i[t]=!0}),this.layerIndexes)i[e]||delete this.layerIndexes[e]};var fr,mr=t.pick(vi,["moveLayer","addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData"]),yr=t.pick(vi,["setCenter","setZoom","setBearing","setPitch"]),gr=gi(),vr=((fr=t.Evented)&&(_r.__proto__=fr),((_r.prototype=Object.create(fr&&fr.prototype)).constructor=_r).prototype.loadURL=function(e,i){var r=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"})),i.validate="boolean"==typeof i.validate?i.validate:!t.isMapboxURL(e),e=this.map._requestManager.normalizeStyleURL(e,i.accessToken),e=this.map._requestManager.transformRequest(e,t.ResourceType.Style),this._request=t.getJSON(e,function(e,n){r._request=null,e?r.fire(new t.ErrorEvent(e)):n&&r._load(n,i)})},_r.prototype.loadJSON=function(e,i){var r=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"})),this._request=t.browser.frame(function(){r._request=null,i.validate=!1!==i.validate,r._load(e,i)})},_r.prototype.loadEmpty=function(){this.fire(new t.Event("dataloading",{dataType:"style"})),this._load(gr,{validate:!1})},_r.prototype._load=function(e,i){var r=this;if(!i.validate||!dr(this,t.validateStyle(e))){var n,o=[];for(n in i.stylePatch&&(o=this._buildStylePatch(e,i),this.sourceCaches={}),this._loaded=!0,(this.stylesheet=e).sources)this.addSource(n,e.sources[n],{validate:!1});e.sprite?this._loadSprite(e.sprite):this.imageManager.setLoaded(!0),this.glyphManager.setURL(e.glyphs),i=yi(this.stylesheet.layers),this._order=i.map(function(t){return t.id}),this._layers={},this._serializedLayers={};for(var a=0,s=i;a<s.length;a+=1){var l=s[a];(l=t.createStyleLayer(l)).setEventedParent(this,{layer:{id:l.id}}),this._layers[l.id]=l,this._serializedLayers[l.id]=l.serialize()}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new T(this.stylesheet.light),o.filter(function(t){return t.command!==vi.moveLayer}).forEach(function(t){r[t.command].apply(r,t.args)}),this.fire(new t.Event("data",{dataType:"style"})),this.fire(new t.Event("style.load"))}},_r.prototype._loadSprite=function(e){var i,r,n,o,a,s,l,u,c=this;function p(){if(s)n(s);else if(o&&a){var e,i=t.browser.getImageData(a),r={};for(e in o){var l=(g=o[e]).width,u=g.height,c=g.x,p=g.y,h=g.sdf,d=g.pixelRatio,f=g.stretchX,m=g.stretchY,y=g.content,g=new t.RGBAImage({width:l,height:u});t.RGBAImage.copy(i,g,{x:c,y:p},{x:0,y:0},{width:l,height:u}),r[e]={data:g,pixelRatio:d,sdf:h,stretchX:f,stretchY:m,content:y}}n(null,r)}}this._spriteRequest=(i=e,r=this.map._requestManager,n=function(e,i){if(c._spriteRequest=null,e)c.fire(new t.ErrorEvent(e));else if(i)for(var r in i)c.imageManager.addImage(r,i[r]);c.imageManager.setLoaded(!0),c._availableImages=c.imageManager.listImages(),c.dispatcher.broadcast("setImages",c._availableImages),c.fire(new t.Event("data",{dataType:"style"}))},e=1<t.browser.devicePixelRatio?"@2x":"",l=t.getJSON(r.transformRequest(r.normalizeSpriteURL(i,e,".json"),t.ResourceType.SpriteJSON),function(t,e){l=null,s||(s=t,o=e,p())}),u=t.getImage(r.transformRequest(r.normalizeSpriteURL(i,e,".png"),t.ResourceType.SpriteImage),function(t,e){u=null,s||(s=t,a=e,p())}),{cancel:function(){l&&(l.cancel(),l=null),u&&(u.cancel(),u=null)}})},_r.prototype._validateLayer=function(e){var i,r=this.sourceCaches[e.source];r&&(!(i=e.sourceLayer)||("geojson"===(r=r.getSource()).type||r.vectorLayerIds&&-1===r.vectorLayerIds.indexOf(i))&&this.fire(new t.ErrorEvent(new Error('Source layer "'+i+'" does not exist on source "'+r.id+'" as specified by style layer "'+e.id+'"'))))},_r.prototype.loaded=function(){if(!this._loaded)return!1;if(Object.keys(this._updatedSources).length)return!1;for(var t in this.sourceCaches)if(!this.sourceCaches[t].loaded())return!1;return!!this.imageManager.isLoaded()},_r.prototype._serializeLayers=function(t){for(var e=[],i=0,r=t;i<r.length;i+=1){var n=r[i];"custom"!==(n=this._layers[n]).type&&e.push(n.serialize())}return e},_r.prototype.hasTransitions=function(){if(this.light&&this.light.hasTransition())return!0;for(var t in this.sourceCaches)if(this.sourceCaches[t].hasTransition())return!0;for(var e in this._layers)if(this._layers[e].hasTransition())return!0;return!1},_r.prototype._checkLoaded=function(){if(!this._loaded)throw new Error("Style is not done loading")},_r.prototype.update=function(e){if(this.loaded){var i=this._changed;if(this._changed){var r,n,o=Object.keys(this._updatedLayers),a=Object.keys(this._removedLayers);for(r in(o.length||a.length)&&this._updateWorkerLayers(o,a),this._updatedSources){var s=this._updatedSources[r];"reload"===s?this._reloadSource(r):"clear"===s&&this._clearSource(r)}for(n in this._updateTilesForChangedImages(),this._updatedPaintProps)this._layers[n].updateTransitions(e),this._serializedLayers[n]=this._layers[n].serialize();this.light.updateTransitions(e),this._resetUpdates()}var l,u={};for(l in this.sourceCaches){var c=this.sourceCaches[l];u[l]=c.used,c.used=!1}for(var p,h=0,d=this._order;h<d.length;h+=1){var f=d[h];(f=this._layers[f]).recalculate(e,this._availableImages),!f.isHidden(e.zoom)&&f.source&&(this.sourceCaches[f.source].used=!0)}for(p in u){var m=this.sourceCaches[p];u[p]!==m.used&&m.fire(new t.Event("data",{sourceDataType:"visibility",dataType:"source",sourceId:p}))}this.light.recalculate(e),this.z=e.zoom,i&&this.fire(new t.Event("data",{dataType:"style"}))}},_r.prototype._updateTilesForChangedImages=function(){var t=Object.keys(this._changedImages);if(t.length){for(var e in this.sourceCaches)this.sourceCaches[e].reloadTilesForDependencies(["icons","patterns"],t);this._changedImages={}}},_r.prototype._updateWorkerLayers=function(t,e){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(t),removedIds:e})},_r.prototype._resetUpdates=function(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={},this._changedImages={}},_r.prototype.setState=function(e,i){var r=this;if(void 0===i&&(i={}),this._checkLoaded(),dr(this,t.validateStyle(e)))return!1;(e=t.clone$1(e)).layers=yi(e.layers);var n=[],o={},a={};n=(n=i.stylePatch?this._buildStylePatch(e,i):n).filter(function(t){return t.command===vi.addLayer&&r._serializedLayers.hasOwnProperty(t.args[0].id)?!(o[t.args[0].id]=!0):t.command===vi.moveLayer&&r._serializedLayers.hasOwnProperty(t.args[0])?o[t.args[0]]=!0:t.command!==vi.addSource||!r.sourceCaches.hasOwnProperty(t.args[0])||!(a[t.args[0]]=!0)});if(0===(i=(i=Ti(this.serialize(),e).filter(function(t){return!(t.command in yr)})).concat(n)).length)return!1;if(0<(n=i.filter(function(t){return!(t.command in mr)})).length)throw new Error("Unimplemented: "+n.map(function(t){return t.command}).join(", ")+".");return i.forEach(function(t){"setTransition"!==t.command&&(t.command===vi.removeLayer&&o.hasOwnProperty(t.args[0])||(t.command===vi.addSource||t.command===vi.removeSource)&&a.hasOwnProperty(t.args[0])||r[t.command].apply(r,t.args))}),this.stylesheet=e,!0},_r.prototype.addImage=function(e,i){if(this.getImage(e))return this.fire(new t.ErrorEvent(new Error("An image with this name already exists.")));this.imageManager.addImage(e,i),this._afterImageUpdated(e)},_r.prototype.updateImage=function(t,e){this.imageManager.updateImage(t,e)},_r.prototype.getImage=function(t){return this.imageManager.getImage(t)},_r.prototype.removeImage=function(e){if(!this.getImage(e))return this.fire(new t.ErrorEvent(new Error("No image with this name exists.")));this.imageManager.removeImage(e),this._afterImageUpdated(e)},_r.prototype._afterImageUpdated=function(e){this._availableImages=this.imageManager.listImages(),this._changedImages[e]=!0,this._changed=!0,this.dispatcher.broadcast("setImages",this._availableImages),this.fire(new t.Event("data",{dataType:"style"}))},_r.prototype.listImages=function(){return this._checkLoaded(),this.imageManager.listImages()},_r.prototype.addSource=function(e,i,r){var n,o=this;if(void 0===r&&(r={}),this._checkLoaded(),void 0!==this.sourceCaches[e])throw new Error("There is already a source with this ID");if(!i.type)throw new Error("The type property must be defined, but only the following properties were given: "+Object.keys(i).join(", ")+".");0<=["vector","raster","geojson","video","image"].indexOf(i.type)&&this._validate(t.validateStyle.source,"sources."+e,i,null,r)||(this.map&&this.map._collectResourceTiming&&(i.collectResourceTiming=!0),(n=this.sourceCaches[e]=new ai(e,i,this.dispatcher)).style=this,n.setEventedParent(this,function(){return{isSourceLoaded:o.loaded(),source:n.serialize(),sourceId:e}}),n.onAdd(this.map),this._changed=!0)},_r.prototype.removeSource=function(e){if(this._checkLoaded(),void 0===this.sourceCaches[e])throw new Error("There is no source with this ID");for(var i in this._layers)if(this._layers[i].source===e)return this.fire(new t.ErrorEvent(new Error('Source "'+e+'" cannot be removed while layer "'+i+'" is using it.')));var r=this.sourceCaches[e];delete this.sourceCaches[e],delete this._updatedSources[e],r.fire(new t.Event("data",{sourceDataType:"metadata",dataType:"source",sourceId:e})),r.setEventedParent(null),r.clearTiles(),r.onRemove&&r.onRemove(this.map),this._changed=!0},_r.prototype.setGeoJSONSourceData=function(t,e){this._checkLoaded(),this.sourceCaches[t].getSource().setData(e),this._changed=!0},_r.prototype.getSource=function(t){return this.sourceCaches[t]&&this.sourceCaches[t].getSource()},_r.prototype.addLayer=function(e,i,r){void 0===r&&(r={}),this._checkLoaded();var n,o=e.id;if(this.getLayer(o))this.fire(new t.ErrorEvent(new Error('Layer with id "'+o+'" already exists on this map')));else{if("custom"===e.type){if(dr(this,t.validateCustomStyleLayer(e)))return;n=t.createStyleLayer(e)}else{if("object"==typeof e.source&&(this.addSource(o,e.source),e=t.clone$1(e),e=t.extend(e,{source:o})),this._validate(t.validateStyle.layer,"layers."+o,e,{arrayIndex:-1},r))return;n=t.createStyleLayer(e),this._validateLayer(n),n.setEventedParent(this,{layer:{id:o}}),this._serializedLayers[n.id]=n.serialize()}e=i?this._order.indexOf(i):this._order.length,i&&-1===e?this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.'))):(this._order.splice(e,0,o),this._layerOrderChanged=!0,this._layers[o]=n,this._removedLayers[o]&&n.source&&"custom"!==n.type&&(e=this._removedLayers[o],delete this._removedLayers[o],e.type!==n.type?this._updatedSources[n.source]="clear":(this._updatedSources[n.source]="reload",this.sourceCaches[n.source].pause())),this._updateLayer(n),n.onAdd&&n.onAdd(this.map))}},_r.prototype.moveLayer=function(e,i){var r;this._checkLoaded(),this._changed=!0,this._layers[e]?e!==i&&(r=this._order.indexOf(e),this._order.splice(r,1),r=i?this._order.indexOf(i):this._order.length,i&&-1===r?this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.'))):(this._order.splice(r,0,e),this._layerOrderChanged=!0)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be moved.")))},_r.prototype.removeLayer=function(e){this._checkLoaded();var i,r=this._layers[e];r?(r.setEventedParent(null),i=this._order.indexOf(e),this._order.splice(i,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[e]=r,delete this._layers[e],delete this._serializedLayers[e],delete this._updatedLayers[e],delete this._updatedPaintProps[e],r.onRemove&&r.onRemove(this.map)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be removed.")))},_r.prototype.getLayer=function(t){return this._layers[t]},_r.prototype.hasLayer=function(t){return t in this._layers},_r.prototype.setLayerZoomRange=function(e,i,r){this._checkLoaded();var n=this.getLayer(e);n?n.minzoom===i&&n.maxzoom===r||(null!=i&&(n.minzoom=i),null!=r&&(n.maxzoom=r),this._updateLayer(n)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot have zoom extent.")))},_r.prototype.setFilter=function(e,i,r){void 0===r&&(r={}),this._checkLoaded();var n=this.getLayer(e);if(n){if(!t.deepEqual(n.filter,i))return null==i?(n.filter=void 0,void this._updateLayer(n)):void(this._validate(t.validateStyle.filter,"layers."+n.id+".filter",i,null,r)||(n.filter=t.clone$1(i),this._updateLayer(n)))}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be filtered.")))},_r.prototype.getFilter=function(e){return t.clone$1(this.getLayer(e).filter)},_r.prototype.setLayoutProperty=function(e,i,r,n){void 0===n&&(n={}),this._checkLoaded();var o=this.getLayer(e);o?t.deepEqual(o.getLayoutProperty(i),r)||(o.setLayoutProperty(i,r,n),this._serializedLayers[e]=o.serialize(),this._updateLayer(o)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")))},_r.prototype.getLayoutProperty=function(e,i){var r=this.getLayer(e);if(r)return r.getLayoutProperty(i);this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style.")))},_r.prototype.setPaintProperty=function(e,i,r,n){void 0===n&&(n={}),this._checkLoaded();var o=this.getLayer(e);o?t.deepEqual(o.getPaintProperty(i),r)||(o.setPaintProperty(i,r,n)&&this._updateLayer(o),this._changed=!0,this._updatedPaintProps[e]=!0):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")))},_r.prototype.getPaintProperty=function(t,e){return this.getLayer(t).getPaintProperty(e)},_r.prototype.setFeatureState=function(e,i){this._checkLoaded();var r,n=e.source,o=e.sourceLayer,a=this.sourceCaches[n];void 0!==a?"geojson"===(r=a.getSource().type)&&o?this.fire(new t.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))):"vector"!==r||o?(void 0===e.id&&this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))),a.setFeatureState(o,e.id,i)):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types."))):this.fire(new t.ErrorEvent(new Error("The source '"+n+"' does not exist in the map's style.")))},_r.prototype.removeFeatureState=function(e,i){this._checkLoaded();var r,n,o=e.source,a=this.sourceCaches[o];void 0!==a?(n="vector"===(r=a.getSource().type)?e.sourceLayer:void 0,"vector"!==r||n?i&&"string"!=typeof e.id&&"number"!=typeof e.id?this.fire(new t.ErrorEvent(new Error("A feature id is required to remove its specific state property."))):a.removeFeatureState(n,e.id,i):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")))):this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")))},_r.prototype.getFeatureState=function(e){this._checkLoaded();var i=e.source,r=e.sourceLayer,n=this.sourceCaches[i];if(void 0!==n){if("vector"!==n.getSource().type||r)return void 0===e.id&&this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))),n.getFeatureState(r,e.id);this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")))}else this.fire(new t.ErrorEvent(new Error("The source '"+i+"' does not exist in the map's style.")))},_r.prototype.getTransition=function(){return t.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)},_r.prototype.serialize=function(){return this._loaded?t.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,sources:t.mapObject(this.sourceCaches,function(t){return t.serialize()}),layers:this._serializeLayers(this._order)},function(t){return void 0!==t}):gr},_r.prototype._buildStylePatch=function(e,i){var r=this,n=[],o=[],a=[],s=e.layers.reduce(function(t,e){return t[e.id]=e,t},{});return i.stylePatch&&i.stylePatch(this.serialize(),e,function(i,l){var u;r.hasLayer(i)?(u=r._serializedLayers[i],e.sources.hasOwnProperty(u.source)||o.includes(u.source)||(n.push({command:"addSource",args:[u.source,r.sourceCaches[u.source].serialize(),{validate:!1}]}),o.push(u.source)),s.hasOwnProperty(i)&&n.push({command:"removeLayer",args:[i]}),l=s.hasOwnProperty(l)||a.find(function(t){return t.id===l})?l:void 0,n.push({command:"moveLayer",args:[u.id,l,{validate:!0}]}),n.push({command:"addLayer",args:[u,l,{validate:!0}]}),a.push(i)):t.warnOnce("Cannot preserve layer "+i+" that is not in the previous style.")}.bind(this),function(e,i,r){s.hasOwnProperty(e)||a.includes(e)?n.push({command:"setPaintProperty",args:[e,i,r,{validate:!0}]}):t.warnOnce("Cannot update paint property on layer "+e+" that is not in the next style.")}.bind(this),function(e,i,r){s.hasOwnProperty(e)||a.includes(e)?n.push({command:"setLayoutProperty",args:[e,i,r,{validate:!0}]}):t.warnOnce("Cannot update layout property on layer "+e+" that is not in the next style.")}.bind(this),function(e,i,r){s.hasOwnProperty(e)||a.includes(e)?n.push({command:"setFilter",args:[e,i,r,{validate:!0}]}):t.warnOnce("Cannot update filter on layer "+e+" that is not in the next style.")}.bind(this)),n},_r.prototype._updateLayer=function(t){this._updatedLayers[t.id]=!0,t.source&&!this._updatedSources[t.source]&&"raster"!==this.sourceCaches[t.source].getSource().type&&(this._updatedSources[t.source]="reload",this.sourceCaches[t.source].pause()),this._changed=!0},_r.prototype._flattenAndSortRenderedFeatures=function(t){for(var e=this,i=function(t){return"fill-extrusion"===e._layers[t].type},r={},n=[],o=this._order.length-1;0<=o;o--){var a=this._order[o];if(i(a)){r[a]=o;for(var s=0,l=t;s<l.length;s+=1){var u=l[s][a];if(u)for(var c=0,p=u;c<p.length;c+=1){var h=p[c];n.push(h)}}}}n.sort(function(t,e){return e.intersectionZ-t.intersectionZ});for(var d=[],f=this._order.length-1;0<=f;f--){var m=this._order[f];if(i(m))for(var y=n.length-1;0<=y;y--){var g=n[y].feature;if(r[g.layer.id]<f)break;d.push(g),n.pop()}else for(var v=0,_=t;v<_.length;v+=1){var x=_[v][m];if(x)for(var b=0,w=x;b<w.length;b+=1){var S=w[b];d.push(S.feature)}}}return d},_r.prototype.queryRenderedFeatures=function(e,i,r){i&&i.filter&&this._validate(t.validateStyle.filter,"queryRenderedFeatures.filter",i.filter,null,i);var n={};if(i&&i.layers){if(!Array.isArray(i.layers))return this.fire(new t.ErrorEvent(new Error("parameters.layers must be an Array."))),[];for(var o=0,a=i.layers;o<a.length;o+=1){var s=a[o],l=this._layers[s];if(!l)return this.fire(new t.ErrorEvent(new Error("The layer '"+s+"' does not exist in the map's style and cannot be queried for features."))),[];n[l.source]=!0}}var u,c=[];for(u in i.availableImages=this._availableImages,this.sourceCaches)i.layers&&!n[u]||c.push($(this.sourceCaches[u],this._layers,this._serializedLayers,e,i,r));return this.placement&&c.push(function(t,e,i,r,n,o,a){for(var s={},l=o.queryRenderedSymbols(r),u=[],c=0,p=Object.keys(l).map(Number);c<p.length;c+=1){var h=p[c];u.push(a[h])}u.sort(tt);for(var d=0,f=u;d<f.length;d+=1)!function(){var i,r=f[d],o=r.featureIndex.lookupSymbolFeatures(l[r.bucketInstanceId],e,r.bucketIndex,r.sourceLayerIndex,n.filter,n.layers,n.availableImages,t);for(i in o){var a=s[i]=s[i]||[],u=o[i];u.sort(function(t,e){var i=r.featureSortOrder;if(i){var n=i.indexOf(t.featureIndex);return i.indexOf(e.featureIndex)-n}return e.featureIndex-t.featureIndex});for(var c=0,p=u;c<p.length;c+=1){var h=p[c];a.push(h)}}}();for(var m in s)!function(e){s[e].forEach(function(r){var n=r.feature;r=t[e],r=i[r.source].getFeatureState(n.layer["source-layer"],n.id),n.source=n.layer.source,n.layer["source-layer"]&&(n.sourceLayer=n.layer["source-layer"]),n.state=r})}(m);return s}(this._layers,this._serializedLayers,this.sourceCaches,e,i,this.placement.collisionIndex,this.placement.retainedQueryData)),this._flattenAndSortRenderedFeatures(c)},_r.prototype.querySourceFeatures=function(e,i){return i&&i.filter&&this._validate(t.validateStyle.filter,"querySourceFeatures.filter",i.filter,null,i),(e=this.sourceCaches[e])?function(t,e){for(var i=t.getRenderableIds().map(function(e){return t.getTileByID(e)}),r=[],n={},o=0;o<i.length;o++){var a=i[o],s=a.tileID.canonical.key;n[s]||(n[s]=!0,a.querySourceFeatures(r,e))}return r}(e,i):[]},_r.prototype.addSourceType=function(t,e,i){return _r.getSourceType(t)?i(new Error('A source type called "'+t+'" already exists.')):(_r.setSourceType(t,e),e.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:t,url:e.workerSourceURL},i):i(null,null))},_r.prototype.getLight=function(){return this.light.getLight()},_r.prototype.setLight=function(e,i){void 0===i&&(i={}),this._checkLoaded();var r,n,o=this.light.getLight(),a=!1;for(r in e)if(!t.deepEqual(e[r],o[r])){a=!0;break}a&&(n={now:t.browser.now(),transition:t.extend({duration:300,delay:0},this.stylesheet.transition)},this.light.setLight(e,i),this.light.updateTransitions(n))},_r.prototype._validate=function(e,i,r,n,o){return(!(o=void 0===o?{}:o)||!1!==o.validate)&&dr(this,e.call(t.validateStyle,t.extend({key:i,style:this.serialize(),value:r,styleSpec:t.styleSpec},n)))},_r.prototype._remove=function(){for(var e in this._request&&(this._request.cancel(),this._request=null),this._spriteRequest&&(this._spriteRequest.cancel(),this._spriteRequest=null),t.evented.off("pluginStateChange",this._rtlTextPluginCallback),this._layers)this._layers[e].setEventedParent(null);for(var i in this.sourceCaches)this.sourceCaches[i].clearTiles(),this.sourceCaches[i].setEventedParent(null);this.imageManager.setEventedParent(null),this.setEventedParent(null),this.dispatcher.remove()},_r.prototype._clearSource=function(t){this.sourceCaches[t].clearTiles()},_r.prototype._reloadSource=function(t){this.sourceCaches[t].resume(),this.sourceCaches[t].reload()},_r.prototype._updateSources=function(t){for(var e in this.sourceCaches)this.sourceCaches[e].update(t)},_r.prototype._generateCollisionBoxes=function(){for(var t in this.sourceCaches)this._reloadSource(t)},_r.prototype._updatePlacement=function(e,i,r,n,o){void 0===o&&(o=!1);for(var a=!1,s=!1,l={},u=0,c=this._order;u<c.length;u+=1){var p,h=c[u];"symbol"===(h=this._layers[h]).type&&(l[h.source]||(p=this.sourceCaches[h.source],l[h.source]=p.getRenderableIds(!0).map(function(t){return p.getTileByID(t)}).sort(function(t,e){return e.tileID.overscaledZ-t.tileID.overscaledZ||(t.tileID.isLessThan(e.tileID)?-1:1)})),h=this.crossTileSymbolIndex.addLayer(h,l[h.source],e.center.lng),a=a||h)}if(this.crossTileSymbolIndex.pruneUnusedLayers(this._order),((o=o||this._layerOrderChanged||0===r)||!this.pauseablePlacement||this.pauseablePlacement.isDone()&&!this.placement.stillRecent(t.browser.now(),e.zoom))&&(this.pauseablePlacement=new sr(e,this._order,o,i,r,n,this.placement),this._layerOrderChanged=!1),this.pauseablePlacement.isDone()?this.placement.setStale():(this.pauseablePlacement.continuePlacement(this._order,this._layers,l),this.pauseablePlacement.isDone()&&(this.placement=this.pauseablePlacement.commit(t.browser.now()),s=!0),a&&this.pauseablePlacement.placement.setStale()),s||a)for(var d=0,f=this._order;d<f.length;d+=1){var m=f[d];"symbol"===(m=this._layers[m]).type&&this.placement.updateLayerOpacities(m,l[m.source])}return!this.pauseablePlacement.isDone()||this.placement.hasTransitions(t.browser.now())},_r.prototype._releaseSymbolFadeTiles=function(){for(var t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles()},_r.prototype.getImages=function(t,e,i){this.imageManager.getImages(e.icons,i),this._updateTilesForChangedImages(),(i=this.sourceCaches[e.source])&&i.setDependencies(e.tileID.key,e.type,e.icons)},_r.prototype.getGlyphs=function(t,e,i){this.glyphManager.getGlyphs(e.stacks,i)},_r.prototype.getResource=function(e,i,r){return t.makeRequest(i,r)},_r);function _r(e,i){var r=this;void 0===i&&(i={}),fr.call(this),this.map=e,this.dispatcher=new I(mi(),this),this.imageManager=new h,this.imageManager.setEventedParent(this),this.glyphManager=new x(e._requestManager,i.localIdeographFontFamily),this.lineAtlas=new E(256,512),this.crossTileSymbolIndex=new hr,this._layers={},this._serializedLayers={},this._order=[],this.sourceCaches={},this.zoomHistory=new t.ZoomHistory,this._loaded=!1,this._availableImages=[],this._resetUpdates(),this.dispatcher.broadcast("setReferrer",t.getReferrer());var n=this;this._rtlTextPluginCallback=_r.registerForPluginStateChange(function(e){e={pluginStatus:e.pluginStatus,pluginURL:e.pluginURL},n.dispatcher.broadcast("syncRTLPluginState",e,function(e,i){if(t.triggerPluginCompletionEvent(e),i&&i.every(function(t){return t}))for(var r in n.sourceCaches)n.sourceCaches[r].reload()})}),this.on("data",function(t){if("source"===t.dataType&&"metadata"===t.sourceDataType&&(t=r.sourceCaches[t.sourceId])){var e=t.getSource();if(e&&e.vectorLayerIds)for(var i in r._layers)(i=r._layers[i]).source===e.id&&r._validateLayer(i)}})}vr.getSourceType=function(t){return Q[t]},vr.setSourceType=function(t,e){Q[t]=e},vr.registerForPluginStateChange=t.registerForPluginStateChange;var xr=t.createLayout([{name:"a_pos",type:"Int16",components:2}]),br=Dr("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif","#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"),wr=Dr("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Sr=Dr("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),Tr=Dr("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),Cr=Dr("void main() {gl_FragColor=vec4(1.0);}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Er=Dr("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),Ir=Dr("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),kr=Dr("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}","attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),Ar=Dr("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}","attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),Pr=Dr("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}","attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}"),Mr=Dr("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),Lr=Dr("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),Or=Dr("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),Rr=(u=Dr("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),m=Dr("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),f=Dr("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),Dr("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}")),zr=(M=Dr("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),R=Dr("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),N=Dr("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),U=Dr("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),W=Dr("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),Y=Dr("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),Dr("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"));Ge=Dr("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),fi=Dr("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}");function Dr(t,e){var i=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,r=e.match(/attribute ([\w]+) ([\w]+)/g),n=t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g),o=e.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g),a=(n=o?o.concat(n):n,{});return{fragmentSource:t=t.replace(i,function(t,e,i,r,n){return a[n]=!0,"define"===e?"\n#ifndef HAS_UNIFORM_u_"+n+"\nvarying "+i+" "+r+" "+n+";\n#else\nuniform "+i+" "+r+" u_"+n+";\n#endif\n":"\n#ifdef HAS_UNIFORM_u_"+n+"\n    "+i+" "+r+" "+n+" = u_"+n+";\n#endif\n"}),vertexSource:e=e.replace(i,function(t,e,i,r,n){var o="float"===r?"vec2":"vec4",s=n.match(/color/)?"color":o;return a[n]?"define"===e?"\n#ifndef HAS_UNIFORM_u_"+n+"\nuniform lowp float u_"+n+"_t;\nattribute "+i+" "+o+" a_"+n+";\nvarying "+i+" "+r+" "+n+";\n#else\nuniform "+i+" "+r+" u_"+n+";\n#endif\n":"vec4"==s?"\n#ifndef HAS_UNIFORM_u_"+n+"\n    "+n+" = a_"+n+";\n#else\n    "+i+" "+r+" "+n+" = u_"+n+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+n+"\n    "+n+" = unpack_mix_"+s+"(a_"+n+", u_"+n+"_t);\n#else\n    "+i+" "+r+" "+n+" = u_"+n+";\n#endif\n":"define"===e?"\n#ifndef HAS_UNIFORM_u_"+n+"\nuniform lowp float u_"+n+"_t;\nattribute "+i+" "+o+" a_"+n+";\n#else\nuniform "+i+" "+r+" u_"+n+";\n#endif\n":"vec4"==s?"\n#ifndef HAS_UNIFORM_u_"+n+"\n    "+i+" "+r+" "+n+" = a_"+n+";\n#else\n    "+i+" "+r+" "+n+" = u_"+n+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+n+"\n    "+i+" "+r+" "+n+" = unpack_mix_"+s+"(a_"+n+", u_"+n+"_t);\n#else\n    "+i+" "+r+" "+n+" = u_"+n+";\n#endif\n"}),staticAttributes:r,staticUniforms:n}}function Nr(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffer=null,this.vao=null}var Br=Object.freeze({__proto__:null,prelude:br,background:wr,backgroundPattern:Sr,circle:Tr,clippingMask:Cr,heatmap:Er,heatmapTexture:Ir,collisionBox:kr,collisionCircle:Ar,debug:Pr,fill:Mr,fillOutline:Lr,fillOutlinePattern:Or,fillPattern:u,fillExtrusion:m,fillExtrusionPattern:f,hillshadePrepare:Rr,hillshade:M,line:R,lineGradient:N,linePattern:U,lineSDF:W,raster:Y,symbolIcon:zr,symbolSDF:Ge,symbolTextAndIcon:fi});function Fr(t){for(var e,i=[],r=0;r<t.length;r++)null!==t[r]&&(e=t[r].split(" "),i.push(e.pop()));return i}function Ur(t,e,i,r,n,o){var a=t.gl;this.program=a.createProgram();for(var s=Fr(i.staticAttributes),l=r?r.getBinderAttributes():[],u=s.concat(l),c=(s=i.staticUniforms?Fr(i.staticUniforms):[],l=r?r.getBinderUniforms():[],[]),p=0,h=s.concat(l);p<h.length;p+=1){var d=h[p];c.indexOf(d)<0&&c.push(d)}if(l=r?r.defines():[],o&&l.push("#define OVERDRAW_INSPECTOR;"),o=l.concat(br.fragmentSource,i.fragmentSource).join("\n"),l=l.concat(br.vertexSource,i.vertexSource).join("\n"),i=a.createShader(a.FRAGMENT_SHADER),a.isContextLost())this.failedToCreate=!0;else if(a.shaderSource(i,o),a.compileShader(i),a.attachShader(this.program,i),o=a.createShader(a.VERTEX_SHADER),a.isContextLost())this.failedToCreate=!0;else{a.shaderSource(o,l),a.compileShader(o),a.attachShader(this.program,o),this.attributes={};var f={};this.numAttributes=u.length;for(var m=0;m<this.numAttributes;m++)u[m]&&(a.bindAttribLocation(this.program,m,u[m]),this.attributes[u[m]]=m);a.linkProgram(this.program),a.deleteShader(o),a.deleteShader(i);for(var y=0;y<c.length;y++){var g,v=c[y];!v||f[v]||(g=a.getUniformLocation(this.program,v))&&(f[v]=g)}this.fixedUniforms=n(t,f),this.binderUniforms=r?r.getUniforms(t,f):[]}}function jr(t,e,i){var r=1/Ui(i,1,e.transform.tileZoom),n=Math.pow(2,i.tileID.overscaledZ);n=(e=i.tileSize*Math.pow(2,e.transform.tileZoom)/n)*(i.tileID.canonical.x+i.tileID.wrap*n),e*=i.tileID.canonical.y;return{u_image:0,u_texsize:i.imageAtlasTexture.size,u_scale:[r,t.fromScale,t.toScale],u_fade:t.t,u_pixel_coord_upper:[n>>16,e>>16],u_pixel_coord_lower:[65535&n,65535&e]}}function Vr(t){return{u_matrix:t}}Nr.prototype.bind=function(t,e,i,r,n,o,a,s){this.context=t;for(var l=this.boundPaintVertexBuffers.length!==r.length,u=0;!l&&u<r.length;u++)this.boundPaintVertexBuffers[u]!==r[u]&&(l=!0);var c=!this.vao||this.boundProgram!==e||this.boundLayoutVertexBuffer!==i||l||this.boundIndexBuffer!==n||this.boundVertexOffset!==o||this.boundDynamicVertexBuffer!==a||this.boundDynamicVertexBuffer2!==s;!t.extVertexArrayObject||c?this.freshBind(e,i,r,n,o,a,s):(t.bindVertexArrayOES.set(this.vao),a&&a.bind(),n&&n.dynamicDraw&&n.bind(),s&&s.bind())},Nr.prototype.freshBind=function(t,e,i,r,n,o,a){var s=t.numAttributes,l=this.context,u=l.gl;if(l.extVertexArrayObject)this.vao&&this.destroy(),this.vao=l.extVertexArrayObject.createVertexArrayOES(),l.bindVertexArrayOES.set(this.vao),c=0,this.boundProgram=t,this.boundLayoutVertexBuffer=e,this.boundPaintVertexBuffers=i,this.boundIndexBuffer=r,this.boundVertexOffset=n,this.boundDynamicVertexBuffer=o,this.boundDynamicVertexBuffer2=a;else for(var c=l.currentNumAttributes||0,p=s;p<c;p++)u.disableVertexAttribArray(p);e.enableAttributes(u,t);for(var h=0,d=i;h<d.length;h+=1)d[h].enableAttributes(u,t);o&&o.enableAttributes(u,t),a&&a.enableAttributes(u,t),e.bind(),e.setVertexAttribPointers(u,t,n);for(var f=0,m=i;f<m.length;f+=1){var y=m[f];y.bind(),y.setVertexAttribPointers(u,t,n)}o&&(o.bind(),o.setVertexAttribPointers(u,t,n)),r&&r.bind(),a&&(a.bind(),a.setVertexAttribPointers(u,t,n)),l.currentNumAttributes=s},Nr.prototype.destroy=function(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null)},Ur.prototype.draw=function(t,e,i,r,n,o,a,s,l,u,c,p,h,d,f,m){var y=t.gl;if(!this.failedToCreate){for(var g in t.program.set(this.program),t.setDepthMode(i),t.setStencilMode(r),t.setColorMode(n),t.setCullFace(o),this.fixedUniforms)this.fixedUniforms[g].set(a[g]);d&&d.setUniforms(t,this.binderUniforms,p,{zoom:h});for(var v=((h={})[y.LINES]=2,h[y.TRIANGLES]=3,h[y.LINE_STRIP]=1,h[e]),_=0,x=c.get();_<x.length;_+=1){var b=x[_],w=b.vaos||(b.vaos={});(w[s]||(w[s]=new Nr)).bind(t,this,l,d?d.getPaintVertexBuffers():[],u,b.vertexOffset,f,m),y.drawElements(e,b.primitiveLength*v,y.UNSIGNED_SHORT,b.primitiveOffset*v*2)}}};var qr=function(e,i,r,n){var o=i.style.light,a=[(s=o.properties.get("position")).x,s.y,s.z],s=t.create$1();return"viewport"===o.properties.get("anchor")&&t.fromRotation(s,-i.transform.angle),t.transformMat3(a,a,s),s=o.properties.get("color"),{u_matrix:e,u_lightpos:a,u_lightintensity:o.properties.get("intensity"),u_lightcolor:[s.r,s.g,s.b],u_vertical_gradient:+r,u_opacity:n}},Hr=function(e,i,r,n,o,a,s){return t.extend(qr(e,i,r,n),jr(a,i,s),{u_height_factor:-Math.pow(2,o.overscaledZ)/s.tileSize/8})},Gr=function(t){return{u_matrix:t}},Zr=function(e,i,r,n){return t.extend(Gr(e),jr(r,i,n))},Wr=function(t,e){return{u_matrix:t,u_world:e}},Kr=function(e,i,r,n,o){return t.extend(Zr(e,i,r,n),{u_world:o})},Xr=function(t,e,i){var r=Ui(i,1,e.zoom),n=Math.pow(2,e.zoom-i.tileID.overscaledZ);i=i.tileID.overscaleFactor();return{u_matrix:t,u_camera_to_center_distance:e.cameraToCenterDistance,u_pixels_to_tile_units:r,u_extrude_scale:[e.pixelsToGLUnits[0]/(r*n),e.pixelsToGLUnits[1]/(r*n)],u_overscale_factor:i}},Yr=function(t,e,i){return{u_matrix:t,u_inv_matrix:e,u_camera_to_center_distance:i.cameraToCenterDistance,u_viewport_size:[i.width,i.height]}},Jr=function(t,e,i){return{u_matrix:t,u_color:e,u_overlay:0,u_overlay_scale:i=void 0===i?1:i}},Qr=function(e,i,r){var n=r.paint.get("hillshade-shadow-color"),o=r.paint.get("hillshade-highlight-color"),a=r.paint.get("hillshade-accent-color"),s=r.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===r.paint.get("hillshade-illumination-anchor")&&(s-=e.transform.angle);var l=!e.options.moving;return{u_matrix:e.transform.calculatePosMatrix(i.tileID.toUnwrapped(),l),u_image:0,u_latrange:(l=i.tileID,i=Math.pow(2,l.canonical.z),l=l.canonical.y,[new t.MercatorCoordinate(0,l/i).toLngLat().lat,new t.MercatorCoordinate(0,(l+1)/i).toLngLat().lat]),u_light:[r.paint.get("hillshade-exaggeration"),s],u_shadow:n,u_highlight:o,u_accent:a}},$r=function(e,i){var r=i.stride,n=t.create();return t.ortho(n,0,t.EXTENT,-t.EXTENT,0,0,1),t.translate(n,n,[0,-t.EXTENT,0]),{u_matrix:n,u_image:1,u_dimension:[r,r],u_zoom:e.overscaledZ,u_unpack:i.getUnpackVector()}},tn=function(e,i,r){var n=e.transform;return{u_matrix:rn(e,i,r),u_ratio:1/Ui(i,1,n.zoom),u_device_pixel_ratio:t.browser.devicePixelRatio,u_units_to_pixels:[1/n.pixelsToGLUnits[0],1/n.pixelsToGLUnits[1]]}};function en(t,e){return 1/Ui(t,1,e.tileZoom)}function rn(t,e,i){return t.translatePosMatrix(e.tileID.posMatrix,e,i.paint.get("line-translate"),i.paint.get("line-translate-anchor"))}function nn(t,e,i,r,n){return{u_matrix:t,u_tl_parent:e,u_scale_parent:i,u_buffer_scale:1,u_fade_t:r.mix,u_opacity:r.opacity*n.paint.get("raster-opacity"),u_image0:0,u_image1:1,u_brightness_low:n.paint.get("raster-brightness-min"),u_brightness_high:n.paint.get("raster-brightness-max"),u_saturation_factor:0<(r=n.paint.get("raster-saturation"))?1-1/(1.001-r):-r,u_contrast_factor:0<(r=n.paint.get("raster-contrast"))?1/(1-r):1+r,u_spin_weights:function(t){t*=Math.PI/180;var e=Math.sin(t);return[(2*(t=Math.cos(t))+1)/3,(-Math.sqrt(3)*e-t+1)/3,(Math.sqrt(3)*e-t+1)/3]}(n.paint.get("raster-hue-rotate"))}}function on(e,i,r,n,o,a){return t.extend((s=n,l=a,c=o,p=(u=r).imageManager.getPattern(s.from.toString()),n=u.imageManager.getPattern(s.to.toString()),o=(a=u.imageManager.getPixelSize()).width,r=a.height,s=Math.pow(2,c.tileID.overscaledZ),s=(a=c.tileSize*Math.pow(2,u.transform.tileZoom)/s)*(c.tileID.canonical.x+c.tileID.wrap*s),a*=c.tileID.canonical.y,{u_image:0,u_pattern_tl_a:p.tl,u_pattern_br_a:p.br,u_pattern_tl_b:n.tl,u_pattern_br_b:n.br,u_texsize:[o,r],u_mix:l.t,u_pattern_size_a:p.displaySize,u_pattern_size_b:n.displaySize,u_scale_a:l.fromScale,u_scale_b:l.toScale,u_tile_units_to_pixels:1/Ui(c,1,u.transform.tileZoom),u_pixel_coord_upper:[s>>16,a>>16],u_pixel_coord_lower:[65535&s,65535&a]}),{u_matrix:e,u_opacity:i});var s,l,u,c,p}var an,sn=function(t,e,i,r,n,o,a,s,l,u){var c=n.transform;return{u_is_size_zoom_constant:+("constant"===t||"source"===t),u_is_size_feature_constant:+("constant"===t||"camera"===t),u_size_t:e?e.uSizeT:0,u_size:e?e.uSize:0,u_camera_to_center_distance:c.cameraToCenterDistance,u_pitch:c.pitch/360*2*Math.PI,u_rotate_symbol:+i,u_aspect_ratio:c.width/c.height,u_fade_change:n.options.fadeDuration?n.symbolFadeChange:1,u_matrix:o,u_label_plane_matrix:a,u_coord_matrix:s,u_is_text:+l,u_pitch_with_map:+r,u_texsize:u,u_texture:0}},ln=function(e,i,r,n,o,a,s,l,u,c,p){var h=o.transform;return t.extend(sn(e,i,r,n,o,a,s,l,u,c),{u_gamma_scale:n?Math.cos(h._pitch)*h.cameraToCenterDistance:1,u_device_pixel_ratio:t.browser.devicePixelRatio,u_is_halo:+p})},un=function(e,i,r,n,o,a,s,l,u,c){return t.extend(ln(e,i,r,n,o,a,s,l,!0,u,!0),{u_texsize_icon:c,u_texture_icon:1})},cn={fillExtrusion:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fillExtrusionPattern:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_height_factor:new t.Uniform1f(e,i.u_height_factor),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform3f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fill:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},fillPattern:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform3f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},fillOutline:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world)}},fillOutlinePattern:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform3f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},circle:function(e,i){return{u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_scale_with_map:new t.Uniform1i(e,i.u_scale_with_map),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},collisionBox:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pixels_to_tile_units:new t.Uniform1f(e,i.u_pixels_to_tile_units),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_overscale_factor:new t.Uniform1f(e,i.u_overscale_factor)}},collisionCircle:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_inv_matrix:new t.UniformMatrix4f(e,i.u_inv_matrix),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_viewport_size:new t.Uniform2f(e,i.u_viewport_size)}},debug:function(e,i){return{u_color:new t.UniformColor(e,i.u_color),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_overlay:new t.Uniform1i(e,i.u_overlay),u_overlay_scale:new t.Uniform1f(e,i.u_overlay_scale)}},clippingMask:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmap:function(e,i){return{u_extrude_scale:new t.Uniform1f(e,i.u_extrude_scale),u_intensity:new t.Uniform1f(e,i.u_intensity),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmapTexture:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_color_ramp:new t.Uniform1i(e,i.u_color_ramp),u_opacity:new t.Uniform1f(e,i.u_opacity)}},hillshade:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_latrange:new t.Uniform2f(e,i.u_latrange),u_light:new t.Uniform2f(e,i.u_light),u_shadow:new t.UniformColor(e,i.u_shadow),u_highlight:new t.UniformColor(e,i.u_highlight),u_accent:new t.UniformColor(e,i.u_accent)}},hillshadePrepare:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_dimension:new t.Uniform2f(e,i.u_dimension),u_zoom:new t.Uniform1f(e,i.u_zoom),u_unpack:new t.Uniform4f(e,i.u_unpack)}},line:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels)}},lineGradient:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_image:new t.Uniform1i(e,i.u_image),u_image_height:new t.Uniform1f(e,i.u_image_height)}},linePattern:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_texsize:new t.Uniform2f(e,i.u_texsize),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_image:new t.Uniform1i(e,i.u_image),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_scale:new t.Uniform3f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},lineSDF:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_patternscale_a:new t.Uniform2f(e,i.u_patternscale_a),u_patternscale_b:new t.Uniform2f(e,i.u_patternscale_b),u_sdfgamma:new t.Uniform1f(e,i.u_sdfgamma),u_image:new t.Uniform1i(e,i.u_image),u_tex_y_a:new t.Uniform1f(e,i.u_tex_y_a),u_tex_y_b:new t.Uniform1f(e,i.u_tex_y_b),u_mix:new t.Uniform1f(e,i.u_mix)}},raster:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_tl_parent:new t.Uniform2f(e,i.u_tl_parent),u_scale_parent:new t.Uniform1f(e,i.u_scale_parent),u_buffer_scale:new t.Uniform1f(e,i.u_buffer_scale),u_fade_t:new t.Uniform1f(e,i.u_fade_t),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image0:new t.Uniform1i(e,i.u_image0),u_image1:new t.Uniform1i(e,i.u_image1),u_brightness_low:new t.Uniform1f(e,i.u_brightness_low),u_brightness_high:new t.Uniform1f(e,i.u_brightness_high),u_saturation_factor:new t.Uniform1f(e,i.u_saturation_factor),u_contrast_factor:new t.Uniform1f(e,i.u_contrast_factor),u_spin_weights:new t.Uniform3f(e,i.u_spin_weights)}},symbolIcon:function(e,i){return{u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1i(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture)}},symbolSDF:function(e,i){return{u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1i(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture),u_gamma_scale:new t.Uniform1f(e,i.u_gamma_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_is_halo:new t.Uniform1i(e,i.u_is_halo)}},symbolTextAndIcon:function(e,i){return{u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1i(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texsize_icon:new t.Uniform2f(e,i.u_texsize_icon),u_texture:new t.Uniform1i(e,i.u_texture),u_texture_icon:new t.Uniform1i(e,i.u_texture_icon),u_gamma_scale:new t.Uniform1f(e,i.u_gamma_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_is_halo:new t.Uniform1i(e,i.u_is_halo)}},background:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_color:new t.UniformColor(e,i.u_color)}},backgroundPattern:function(e,i){return{u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image:new t.Uniform1i(e,i.u_image),u_pattern_tl_a:new t.Uniform2f(e,i.u_pattern_tl_a),u_pattern_br_a:new t.Uniform2f(e,i.u_pattern_br_a),u_pattern_tl_b:new t.Uniform2f(e,i.u_pattern_tl_b),u_pattern_br_b:new t.Uniform2f(e,i.u_pattern_br_b),u_texsize:new t.Uniform2f(e,i.u_texsize),u_mix:new t.Uniform1f(e,i.u_mix),u_pattern_size_a:new t.Uniform2f(e,i.u_pattern_size_a),u_pattern_size_b:new t.Uniform2f(e,i.u_pattern_size_b),u_scale_a:new t.Uniform1f(e,i.u_scale_a),u_scale_b:new t.Uniform1f(e,i.u_scale_b),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_tile_units_to_pixels:new t.Uniform1f(e,i.u_tile_units_to_pixels)}}};function pn(e,i,r,n,o,a,s){for(var l=e.context,u=l.gl,c=e.useProgram("collisionBox"),p=[],h=0,d=0,f=0;f<n.length;f++){var m,y,g,v,_=n[f],x=i.getTile(_),b=x.getBucket(r);b&&(m=_.posMatrix,0===o[0]&&0===o[1]||(m=e.translatePosMatrix(_.posMatrix,x,o,a)),y=s?b.textCollisionBox:b.iconCollisionBox,0<(g=b.collisionCircleArray).length&&(v=t.create(),_=m,t.mul(v,b.placementInvProjMatrix,e.transform.glCoordMatrix),t.mul(v,v,b.placementViewportMatrix),p.push({circleArray:g,circleOffset:d,transform:_,invTransform:v}),d=h+=g.length/4),y&&c.draw(l,u.LINES,ti.disabled,ei.disabled,e.colorModeForRenderPass(),ri.disabled,Xr(m,e.transform,x),r.id,y.layoutVertexBuffer,y.indexBuffer,y.segments,null,e.transform.zoom,null,null,y.collisionVertexBuffer))}if(s&&p.length){var w=e.useProgram("collisionCircle"),S=new t.StructArrayLayout2f1f2i16;S.resize(4*h),S._trim();for(var T=0,C=0,E=p;C<E.length;C+=1)for(var I=E[C],k=0;k<I.circleArray.length/4;k++){var A=4*k,P=I.circleArray[0+A],M=I.circleArray[1+A],L=I.circleArray[2+A];A=I.circleArray[3+A];S.emplace(T++,P,M,L,A,0),S.emplace(T++,P,M,L,A,1),S.emplace(T++,P,M,L,A,2),S.emplace(T++,P,M,L,A,3)}(!an||an.length<2*h)&&(an=function(e){var i=2*h,r=new t.StructArrayLayout3ui6;r.resize(i),r._trim();for(var n=0;n<i;n++){var o=6*n;r.uint16[0+o]=4*n+0,r.uint16[1+o]=4*n+1,r.uint16[2+o]=4*n+2,r.uint16[3+o]=4*n+2,r.uint16[4+o]=4*n+3,r.uint16[5+o]=4*n+0}return r}());for(var O=l.createIndexBuffer(an,!0),R=l.createVertexBuffer(S,t.collisionCircleLayout.members,!0),z=0,D=p;z<D.length;z+=1){var N=D[z],B=Yr(N.transform,N.invTransform,e.transform);w.draw(l,u.TRIANGLES,ti.disabled,ei.disabled,e.colorModeForRenderPass(),ri.disabled,B,r.id,R,O,t.SegmentVector.simpleSegment(0,2*N.circleOffset,N.circleArray.length,N.circleArray.length/2),null,e.transform.zoom,null,null,null)}R.destroy(),O.destroy()}}var hn=t.identity(new Float32Array(16));function dn(e,i,r,n,o,a,s,l,u,c,p,h){for(var d=e.context,f=d.gl,m=e.transform,y="map"===l,g="map"===u,v=y&&"point"!==r.layout.get("symbol-placement"),_=y&&!g&&!v,x=void 0!==r.layout.get("symbol-sort-key").constantOr(1),b=!1,w=e.depthModeForSublayer(0,ti.ReadOnly),S=r.layout.get("text-variable-anchor"),T=[],C=0,E=n;C<E.length;C+=1){var I=E[C],k=(q=i.getTile(I)).getBucket(r);if(k){var A=o?k.text:k.icon;if(A&&A.segments.get().length){var P=A.programConfigurations.get(r.id),M=o||k.sdfIcons,L=o?k.textSizeData:k.iconSizeData,O=g||0!==m.pitch,R=e.useProgram((U=M,F=o,k.iconsInText&&F?"symbolTextAndIcon":U?"symbolSDF":"symbolIcon"),P),z=t.evaluateSizeForZoom(L,m.zoom),D=void 0,N=[0,0],B=void 0,F=void 0,U=null;P=void 0;o?(B=q.glyphAtlasTexture,F=f.LINEAR,D=q.glyphAtlasTexture.size,k.iconsInText&&(N=q.imageAtlasTexture.size,U=q.imageAtlasTexture,j="composite"===L.kind||"camera"===L.kind,P=O||e.options.rotating||e.options.zooming||j?f.LINEAR:f.NEAREST)):(V=1!==r.layout.get("icon-size").constantOr(0)||k.iconsNeedLinear,B=q.imageAtlasTexture,F=M||e.options.rotating||e.options.zooming||V||O?f.LINEAR:f.NEAREST,D=q.imageAtlasTexture.size);var j=Ui(q,1,e.transform.zoom),V=Ii(I.posMatrix,g,y,e.transform,j);O=ki(I.posMatrix,g,y,e.transform,j),j=S&&k.hasTextData(),j="none"!==r.layout.get("icon-text-fit")&&j&&k.hasIconData();v&&function(e,i,r,n,o,a,s,l){var u=n?e.textSizeData:e.iconSizeData,c=t.evaluateSizeForZoom(u,r.transform.zoom),p=[256/r.width*2+1,256/r.height*2+1],h=(n?e.text:e.icon).dynamicLayoutVertexArray;h.clear();for(var d=e.lineVertexArray,f=(n?e.text:e.icon).placedSymbolArray,m=r.transform.width/r.transform.height,y=!1,g=0;g<f.length;g++){var v,_,x,b,w,S=f.get(g);S.hidden||S.writingMode===t.WritingMode.vertical&&!y?Ni(S.numGlyphs,h):(y=!1,x=[S.anchorX,S.anchorY,0,1],t.transformMat4(x,x,i),_=p,b=void 0,b=(v=x)[0]/v[3],v=v[1]/v[3],b>=-_[0]&&b<=_[0]&&v>=-_[1]&&v<=_[1]?(w=Pi(r.transform.cameraToCenterDistance,x[3]),b=t.evaluateSizeForFeature(u,c,S),v=s?b/w:b*w,x=Ai(_=new t.Point(S.anchorX,S.anchorY),o).point,y=(w=Oi(S,v,!(b={}),l,i,o,a,e.glyphOffsetArray,d,h,x,_,b,m)).useVertical,(w.notEnoughRoom||y||w.needsFlipping&&Oi(S,v,!0,l,i,o,a,e.glyphOffsetArray,d,h,x,_,b,m).notEnoughRoom)&&Ni(S.numGlyphs,h)):Ni(S.numGlyphs,h))}(n?e.text:e.icon).dynamicLayoutVertexBuffer.updateData(h)}(k,I.posMatrix,e,o,V,O,g,c);I=e.translatePosMatrix(I.posMatrix,q,a,s),V=v||o&&S||j?hn:V,O=e.translatePosMatrix(O,q,a,s,!0);var q=M&&0!==r.paint.get(o?"text-halo-width":"icon-halo-width").constantOr(1),H={program:R,buffers:A,uniformValues:M?k.iconsInText?un(L.kind,z,_,g,e,I,V,O,D,N):ln(L.kind,z,_,g,e,I,V,O,o,D,!0):sn(L.kind,z,_,g,e,I,V,O,o,D),atlasTexture:B,atlasTextureIcon:U,atlasInterpolation:F,atlasInterpolationIcon:P,isSDF:M,hasHalo:q};if(x&&k.canOverlap){b=!0;for(var G=0,Z=A.segments.get();G<Z.length;G+=1){var W=Z[G];T.push({segments:new t.SegmentVector([W]),sortKey:W.sortKey,state:H})}}else T.push({segments:A.segments,sortKey:0,state:H})}}}b&&T.sort(function(t,e){return t.sortKey-e.sortKey});for(var K=0,X=T;K<X.length;K+=1){var Y,J=X[K],Q=J.state;d.activeTexture.set(f.TEXTURE0),Q.atlasTexture.bind(Q.atlasInterpolation,f.CLAMP_TO_EDGE),Q.atlasTextureIcon&&(d.activeTexture.set(f.TEXTURE1),Q.atlasTextureIcon&&Q.atlasTextureIcon.bind(Q.atlasInterpolationIcon,f.CLAMP_TO_EDGE)),Q.isSDF&&(Y=Q.uniformValues,Q.hasHalo&&(Y.u_is_halo=1,fn(Q.buffers,J.segments,r,e,Q.program,w,p,h,Y)),Y.u_is_halo=0),fn(Q.buffers,J.segments,r,e,Q.program,w,p,h,Q.uniformValues)}}function fn(t,e,i,r,n,o,a,s,l){var u=r.context,c=u.gl;n.draw(u,c.TRIANGLES,o,a,s,ri.disabled,l,i.id,t.layoutVertexBuffer,t.indexBuffer,e,i.paint,r.transform.zoom,t.programConfigurations.get(i.id),t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer)}function mn(t,e,i,r,n,o,a){for(var s,l=t.context.gl,u=i.paint.get("fill-pattern"),c=u&&u.constantOr(1),p=i.getCrossfadeParameters(),h=a?(s=c&&!i.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline",l.LINES):(s=c?"fillPattern":"fill",l.TRIANGLES),d=0,f=r;d<f.length;d+=1){var m,y,g,v,_,x,b,w,S=f[d],T=e.getTile(S);c&&!T.patternsLoaded()||(m=T.getBucket(i))&&(y=m.programConfigurations.get(i.id),g=t.useProgram(s,y),c&&(t.context.activeTexture.set(l.TEXTURE0),T.imageAtlasTexture.bind(l.LINEAR,l.CLAMP_TO_EDGE),y.updatePaintBuffers(p)),(v=u.constantOr(null))&&T.imageAtlas&&(w=(b=T.imageAtlas).patternPositions[v.to.toString()],b=b.patternPositions[v.from.toString()],w&&b&&y.setConstantPatternPositions(w,b)),w=t.translatePosMatrix(S.posMatrix,T,i.paint.get("fill-translate"),i.paint.get("fill-translate-anchor")),w=a?(_=m.indexBuffer2,x=m.segments2,b=[l.drawingBufferWidth,l.drawingBufferHeight],"fillOutlinePattern"===s&&c?Kr(w,t,p,T,b):Wr(w,b)):(_=m.indexBuffer,x=m.segments,c?Zr(w,t,p,T):Gr(w)),g.draw(t.context,h,n,t.stencilModeForClipping(S),o,ri.disabled,w,i.id,m.layoutVertexBuffer,_,x,i.paint,t.transform.zoom,y))}}function yn(t,e,i,r,n,o,a){for(var s=t.context,l=s.gl,u=i.paint.get("fill-extrusion-pattern"),c=u.constantOr(1),p=i.getCrossfadeParameters(),h=i.paint.get("fill-extrusion-opacity"),d=0,f=r;d<f.length;d+=1){var m,y,g,v,_,x=f[d],b=e.getTile(x),w=b.getBucket(i);w&&(m=w.programConfigurations.get(i.id),y=t.useProgram(c?"fillExtrusionPattern":"fillExtrusion",m),c&&(t.context.activeTexture.set(l.TEXTURE0),b.imageAtlasTexture.bind(l.LINEAR,l.CLAMP_TO_EDGE),m.updatePaintBuffers(p)),(g=u.constantOr(null))&&b.imageAtlas&&(v=(_=b.imageAtlas).patternPositions[g.to.toString()],_=_.patternPositions[g.from.toString()],v&&_&&m.setConstantPatternPositions(v,_)),v=t.translatePosMatrix(x.posMatrix,b,i.paint.get("fill-extrusion-translate"),i.paint.get("fill-extrusion-translate-anchor")),_=i.paint.get("fill-extrusion-vertical-gradient"),_=c?Hr(v,t,_,h,x,p,b):qr(v,t,_,h),y.draw(s,s.gl.TRIANGLES,n,o,a,ri.backCCW,_,i.id,w.layoutVertexBuffer,w.indexBuffer,w.segments,i.paint,t.transform.zoom,m))}}var gn=new t.Color(1,0,0,1),vn=new t.Color(0,1,0,1),_n=new t.Color(0,0,1,1),xn=new t.Color(1,0,1,1),bn=new t.Color(0,1,1,1);function wn(t,e,i,r){Tn(t,0,e+i/2,t.transform.width,i,r)}function Sn(t,e,i,r){Tn(t,e-i/2,0,i,t.transform.height,r)}function Tn(e,i,r,n,o,a){var s=e.context;(e=s.gl).enable(e.SCISSOR_TEST),e.scissor(i*t.browser.devicePixelRatio,r*t.browser.devicePixelRatio,n*t.browser.devicePixelRatio,o*t.browser.devicePixelRatio),s.clear({color:a}),e.disable(e.SCISSOR_TEST)}function Cn(t,e){this.context=new ni(t),this.transform=e,this._tileTextures={},this.setup(),this.numSublayers=ai.maxUnderzooming+ai.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.crossTileSymbolIndex=new hr,this.gpuTimers={}}var En={symbol:function(e,i,r,n,o){var a,s;"translucent"===e.renderPass&&(a=ei.disabled,s=e.colorModeForRenderPass(),r.layout.get("text-variable-anchor")&&function(e,i,r,n,o,a,s){for(var l=i.transform,u="map"===o,c="map"===a,p=0,h=e;p<h.length;p+=1){var d,f,m,y=h[p],g=n.getTile(y),v=g.getBucket(r);v&&v.text&&v.text.segments.get().length&&(f=v.textSizeData,d=t.evaluateSizeForZoom(f,l.zoom),m=Ui(g,1,i.transform.zoom),f=Ii(y.posMatrix,c,u,i.transform,m),m="none"!==r.layout.get("icon-text-fit")&&v.hasIconData(),d&&(g=Math.pow(2,l.zoom-g.tileID.overscaledZ),function(e,i,r,n,o,a,s,l,u,c,p){var h=e.text.placedSymbolArray,d=e.text.dynamicLayoutVertexArray,f=e.icon.dynamicLayoutVertexArray,m={};d.clear();for(var y=0;y<h.length;y++){var g=h.get(y),v=e.allowVerticalPlacement&&!g.placedOrientation;if(S=g.hidden||!g.crossTileID||v?null:n[g.crossTileID]){var _=new t.Point(g.anchorX,g.anchorY),x=Ai(_,r?l:s),b=Pi(a.cameraToCenterDistance,x.signedDistanceFromCamera),w=o.evaluateSizeForFeature(e.textSizeData,c,g)*b/t.ONE_EM;r&&(w*=e.tilePixelRatio/u);for(var S,T=S.width,C=S.height,E=(w=function(e,i,r,n,o,a){var s;i=-((s=t.getAnchorAlignment(e)).horizontalAlign-.5)*i,r=-((s=s.verticalAlign)-.5)*r,n=t.evaluateVariableOffset(e,n);return new t.Point((i/o+n[0])*a,(r/o+n[1])*a)}(v=S.anchor,T,C,b=S.textOffset,S=S.textBoxScale,w),r?Ai(_.add(w),s).point:x.point.add(i?w.rotate(-a.angle):w)),I=e.allowVerticalPlacement&&g.placedOrientation===t.WritingMode.vertical?Math.PI/2:0,k=0;k<g.numGlyphs;k++)t.addDynamicAttributes(d,E,I);p&&0<=g.associatedIconIndex&&(m[g.associatedIconIndex]={shiftedAnchor:E,angle:I})}else Ni(g.numGlyphs,d)}if(p){f.clear();for(var A=e.icon.placedSymbolArray,P=0;P<A.length;P++){var M=A.get(P);if(M.hidden)Ni(M.numGlyphs,f);else{var L=m[P];if(L)for(var O=0;O<M.numGlyphs;O++)t.addDynamicAttributes(f,L.shiftedAnchor,L.angle);else Ni(M.numGlyphs,f)}}e.icon.dynamicLayoutVertexBuffer.updateData(f)}e.text.dynamicLayoutVertexBuffer.updateData(d)}(v,u,c,s,t.symbolSize,l,f,y.posMatrix,g,d,m)))}}(n,e,r,i,r.layout.get("text-rotation-alignment"),r.layout.get("text-pitch-alignment"),o),0!==r.paint.get("icon-opacity").constantOr(1)&&dn(e,i,r,n,!1,r.paint.get("icon-translate"),r.paint.get("icon-translate-anchor"),r.layout.get("icon-rotation-alignment"),r.layout.get("icon-pitch-alignment"),r.layout.get("icon-keep-upright"),a,s),0!==r.paint.get("text-opacity").constantOr(1)&&dn(e,i,r,n,!0,r.paint.get("text-translate"),r.paint.get("text-translate-anchor"),r.layout.get("text-rotation-alignment"),r.layout.get("text-pitch-alignment"),r.layout.get("text-keep-upright"),a,s),i.map.showCollisionBoxes&&(pn(e,i,r,n,r.paint.get("text-translate"),r.paint.get("text-translate-anchor"),!0),pn(e,i,r,n,r.paint.get("icon-translate"),r.paint.get("icon-translate-anchor"),!1)))},circle:function(e,i,r,n){if("translucent"===e.renderPass){var o=r.paint.get("circle-opacity"),a=r.paint.get("circle-stroke-width"),s=r.paint.get("circle-stroke-opacity"),l=void 0!==r.layout.get("circle-sort-key").constantOr(1);if(0!==o.constantOr(1)||0!==a.constantOr(1)&&0!==s.constantOr(1)){for(var u,c,p,h,d=e.context,f=d.gl,m=e.depthModeForSublayer(0,ti.ReadOnly),y=ei.disabled,g=e.colorModeForRenderPass(),v=[],_=0;_<n.length;_++){var x=n[_],b=i.getTile(x),w=b.getBucket(r);if(w){var S=w.programConfigurations.get(r.id),T={programConfiguration:S,program:e.useProgram("circle",S),layoutVertexBuffer:w.layoutVertexBuffer,indexBuffer:w.indexBuffer,uniformValues:(u=x,c=b,p=r,x=S=h=void 0,x=(b=e).transform,S="map"===p.paint.get("circle-pitch-alignment")?(h=!0,[S=Ui(c,1,x.zoom),S]):(h=!1,x.pixelsToGLUnits),{u_camera_to_center_distance:x.cameraToCenterDistance,u_scale_with_map:+("map"===p.paint.get("circle-pitch-scale")),u_matrix:b.translatePosMatrix(u.posMatrix,c,p.paint.get("circle-translate"),p.paint.get("circle-translate-anchor")),u_pitch_with_map:+h,u_device_pixel_ratio:t.browser.devicePixelRatio,u_extrude_scale:S})};if(l)for(var C=0,E=w.segments.get();C<E.length;C+=1){var I=E[C];v.push({segments:new t.SegmentVector([I]),sortKey:I.sortKey,state:T})}else v.push({segments:w.segments,sortKey:0,state:T})}}l&&v.sort(function(t,e){return t.sortKey-e.sortKey});for(var k=0,A=v;k<A.length;k+=1){var P=(R=(z=A[k]).state).programConfiguration,M=R.program,L=R.layoutVertexBuffer,O=R.indexBuffer,R=R.uniformValues,z=z.segments;M.draw(d,f.TRIANGLES,m,y,g,ri.disabled,R,r.id,L,O,z,r.paint,e.transform.zoom,P)}}}},heatmap:function(e,i,r,n){var o,a,s,l,u;if(0!==r.paint.get("heatmap-opacity"))if("offscreen"===e.renderPass){var c=e.context,p=c.gl,h=ei.disabled,d=new ii([p.ONE,p.ONE],t.Color.transparent,[!0,!0,!0,!0]);!function(t,e,i){var r=t.gl;t.activeTexture.set(r.TEXTURE1),t.viewport.set([0,0,e.width/4,e.height/4]);var n,o=i.heatmapFbo;o?(r.bindTexture(r.TEXTURE_2D,o.colorAttachment.get()),t.bindFramebuffer.set(o.framebuffer)):(n=r.createTexture(),r.bindTexture(r.TEXTURE_2D,n),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_S,r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_WRAP_T,r.CLAMP_TO_EDGE),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MIN_FILTER,r.LINEAR),r.texParameteri(r.TEXTURE_2D,r.TEXTURE_MAG_FILTER,r.LINEAR),o=i.heatmapFbo=t.createFramebuffer(e.width/4,e.height/4,!1),function(t,e,i,r){var n=t.gl;t=t.extRenderToTextureHalfFloat?t.extTextureHalfFloat.HALF_FLOAT_OES:n.UNSIGNED_BYTE;n.texImage2D(n.TEXTURE_2D,0,n.RGBA,e.width/4,e.height/4,0,n.RGBA,t,null),r.colorAttachment.set(i)}(t,e,n,o))}(c,e,r),c.clear({color:t.Color.transparent});for(var f=0;f<n.length;f++){var m,y,g,v,_,x=n[f];i.hasRenderableParent(x)||(y=(m=i.getTile(x)).getBucket(r))&&(g=y.programConfigurations.get(r.id),v=e.useProgram("heatmap",g),_=e.transform.zoom,v.draw(c,p.TRIANGLES,ti.disabled,h,d,ri.disabled,(v=x.posMatrix,x=m,m=_,_=r.paint.get("heatmap-intensity"),{u_matrix:v,u_extrude_scale:Ui(x,1,m),u_intensity:_}),r.id,y.layoutVertexBuffer,y.indexBuffer,y.segments,r.paint,e.transform.zoom,g))}c.viewport.set([0,0,e.width,e.height])}else"translucent"===e.renderPass&&(e.context.setColorMode(e.colorModeForRenderPass()),a=r,l=(s=(o=e).context).gl,(u=a.heatmapFbo)&&(s.activeTexture.set(l.TEXTURE0),l.bindTexture(l.TEXTURE_2D,u.colorAttachment.get()),s.activeTexture.set(l.TEXTURE1),(a.colorRampTexture||(a.colorRampTexture=new t.Texture(s,a.colorRamp,l.RGBA))).bind(l.LINEAR,l.CLAMP_TO_EDGE),o.useProgram("heatmapTexture").draw(s,l.TRIANGLES,ti.disabled,ei.disabled,o.colorModeForRenderPass(),ri.disabled,function(e,i,r,n){var o=t.create();return t.ortho(o,0,e.width,e.height,0,0,1),{u_matrix:o,u_world:[(e=e.context.gl).drawingBufferWidth,e.drawingBufferHeight],u_image:r,u_color_ramp:n,u_opacity:i.paint.get("heatmap-opacity")}}(o,a,0,1),a.id,o.viewportBuffer,o.quadTriangleIndexBuffer,o.viewportSegments,a.paint,o.transform.zoom)))},line:function(e,i,r,n){if("translucent"===e.renderPass){var o=r.paint.get("line-opacity"),a=r.paint.get("line-width");if(0!==o.constantOr(1)&&0!==a.constantOr(1))for(var s,l,u,c,p,h,d=e.depthModeForSublayer(0,ti.ReadOnly),f=e.colorModeForRenderPass(),m=r.paint.get("line-dasharray"),y=r.paint.get("line-pattern"),g=y.constantOr(1),v=r.paint.get("line-gradient"),_=r.getCrossfadeParameters(),x=g?"linePattern":m?"lineSDF":v?"lineGradient":"line",b=e.context,w=b.gl,S=!0,T=0,C=n;T<C.length;T+=1){var E,I,k,A,P,M,L,O,R,z,D,N=C[T],B=i.getTile(N);g&&!B.patternsLoaded()||(E=B.getBucket(r))&&(I=E.programConfigurations.get(r.id),P=e.context.program.get(),k=e.useProgram(x,I),z=S||k.program!==P,(A=y.constantOr(null))&&B.imageAtlas&&(P=(M=B.imageAtlas).patternPositions[A.to.toString()],M=M.patternPositions[A.from.toString()],P&&M&&I.setConstantPatternPositions(P,M)),L=g?(u=r,c=_,h=p=void 0,h=en(l=B,p=(s=e).transform),{u_matrix:rn(s,l,u),u_texsize:l.imageAtlasTexture.size,u_ratio:1/Ui(l,1,p.zoom),u_device_pixel_ratio:t.browser.devicePixelRatio,u_image:0,u_scale:[h,c.fromScale,c.toScale],u_fade:c.t,u_units_to_pixels:[1/p.pixelsToGLUnits[0],1/p.pixelsToGLUnits[1]]}):m?(M=B,s=r,u=m,R=_,c=O=L=c=h=l=O=void 0,O=(p=e).transform,l=p.lineAtlas,h=en(M,O),c="round"===s.layout.get("line-cap"),L=l.getDash(u.from,c),O=l.getDash(u.to,c),u=L.width*R.fromScale,c=O.width*R.toScale,t.extend(tn(p,M,s),{u_patternscale_a:[h/u,-L.height/2],u_patternscale_b:[h/c,-O.height/2],u_sdfgamma:l.width/(256*Math.min(u,c)*t.browser.devicePixelRatio)/2,u_image:0,u_tex_y_a:L.y,u_tex_y_b:O.y,u_mix:R.t})):v?(D=E.lineClipsArray.length,t.extend(tn(e,B,r),{u_image:0,u_image_height:D})):tn(e,B,r),g?(b.activeTexture.set(w.TEXTURE0),B.imageAtlasTexture.bind(w.LINEAR,w.CLAMP_TO_EDGE),I.updatePaintBuffers(_)):m&&(z||e.lineAtlas.dirty)?(b.activeTexture.set(w.TEXTURE0),e.lineAtlas.bind(b)):v&&(R=(O=E.gradients[r.id]).texture,r.gradientVersion!==O.version&&(D=256,r.stepInterpolant&&(B=i.getSource().maxzoom,z=N.canonical.z===B?Math.ceil(1<<e.transform.maxZoom-N.canonical.z):1,B=E.maxLineLength/t.EXTENT,D=t.clamp(t.nextPowerOfTwo(1024*B*z),256,b.maxTextureSize)),O.gradient=t.renderColorRamp({expression:r.gradientExpression(),evaluationKey:"lineProgress",resolution:D,image:O.gradient||void 0,clips:E.lineClipsArray}),O.texture?O.texture.update(O.gradient):O.texture=new t.Texture(b,O.gradient,w.RGBA),O.version=r.gradientVersion,R=O.texture),b.activeTexture.set(w.TEXTURE0),R.bind(r.stepInterpolant?w.NEAREST:w.LINEAR,w.CLAMP_TO_EDGE)),k.draw(b,w.TRIANGLES,d,e.stencilModeForClipping(N),f,ri.disabled,L,r.id,E.layoutVertexBuffer,E.indexBuffer,E.segments,r.paint,e.transform.zoom,I,E.layoutVertexBuffer2),S=!1)}}},fill:function(e,i,r,n){var o,a,s,l=r.paint.get("fill-color"),u=r.paint.get("fill-opacity");0!==u.constantOr(1)&&(o=e.colorModeForRenderPass(),a=r.paint.get("fill-pattern"),u=e.opaquePassEnabledForLayer()&&!a.constantOr(1)&&1===l.constantOr(t.Color.transparent).a&&1===u.constantOr(0)?"opaque":"translucent",e.renderPass===u&&(s=e.depthModeForSublayer(1,"opaque"===e.renderPass?ti.ReadWrite:ti.ReadOnly),mn(e,i,r,n,s,o,!1)),"translucent"===e.renderPass&&r.paint.get("fill-antialias")&&(s=e.depthModeForSublayer(r.getPaintProperty("fill-outline-color")?2:0,ti.ReadOnly),mn(e,i,r,n,s,o,!0)))},"fill-extrusion":function(t,e,i,r){var n,o=i.paint.get("fill-extrusion-opacity");0!==o&&"translucent"===t.renderPass&&(n=new ti(t.context.gl.LEQUAL,ti.ReadWrite,t.depthRangeFor3D),1!==o||i.paint.get("fill-extrusion-pattern").constantOr(1)?(yn(t,e,i,r,n,ei.disabled,ii.disabled),yn(t,e,i,r,n,t.stencilModeFor3D(),t.colorModeForRenderPass())):(o=t.colorModeForRenderPass(),yn(t,e,i,r,n,ei.disabled,o)))},hillshade:function(e,i,r,n){if("offscreen"===e.renderPass||"translucent"===e.renderPass){for(var o,a,s,l,u,c,p,h,d=e.context,f=e.depthModeForSublayer(0,ti.ReadOnly),m=e.colorModeForRenderPass(),y=(n="translucent"===e.renderPass?e.stencilConfigForOverlap(n):[{},n])[0],g=0,v=n[1];g<v.length;g+=1){var _=v[g],x=i.getTile(_);x.needsHillshadePrepare&&"offscreen"===e.renderPass?function(e,i,r,n,o,a){var s,l,u,c,p=e.context,h=p.gl,d=i.dem;d&&d.data&&(s=d.dim,l=d.stride,c=d.getPixels(),p.activeTexture.set(h.TEXTURE1),p.pixelStoreUnpackPremultiplyAlpha.set(!1),i.demTexture=i.demTexture||e.getTileTexture(l),i.demTexture?((u=i.demTexture).update(c,{premultiply:!1}),u.bind(h.NEAREST,h.CLAMP_TO_EDGE)):(i.demTexture=new t.Texture(p,c,h.RGBA,{premultiply:!1}),i.demTexture.bind(h.NEAREST,h.CLAMP_TO_EDGE)),p.activeTexture.set(h.TEXTURE0),(u=i.fbo)||((c=new t.Texture(p,{width:s,height:s,data:null},h.RGBA)).bind(h.LINEAR,h.CLAMP_TO_EDGE),(u=i.fbo=p.createFramebuffer(s,s,!0)).colorAttachment.set(c.texture)),p.bindFramebuffer.set(u.framebuffer),p.viewport.set([0,0,s,s]),e.useProgram("hillshadePrepare").draw(p,h.TRIANGLES,n,o,a,ri.disabled,$r(i.tileID,d),r.id,e.rasterBoundsBuffer,e.quadTriangleIndexBuffer,e.rasterBoundsSegments),i.needsHillshadePrepare=!1)}(e,x,r,f,ei.disabled,m):"translucent"===e.renderPass&&(o=e,a=x,s=r,l=f,u=y[_.overscaledZ],c=m,_=x=h=p=void 0,x=(h=o.context).gl,(_=a.fbo)&&(p=o.useProgram("hillshade"),h.activeTexture.set(x.TEXTURE0),x.bindTexture(x.TEXTURE_2D,_.colorAttachment.get()),a=Qr(o,a,s),p.draw(h,x.TRIANGLES,l,u,c,ri.disabled,a,s.id,o.rasterBoundsBuffer,o.quadTriangleIndexBuffer,o.rasterBoundsSegments)))}d.viewport.set([0,0,e.width,e.height])}},raster:function(e,i,r,n){if("translucent"===e.renderPass&&0!==r.paint.get("raster-opacity")&&n.length)for(var o=e.context,a=o.gl,s=i.getSource(),l=e.useProgram("raster"),u=e.colorModeForRenderPass(),c=(n=s instanceof H?[{},n]:e.stencilConfigForOverlap(n))[0],p=(n=n[1])[n.length-1].overscaledZ,h=!e.options.moving,d=0,f=n;d<f.length;d+=1){var m=f[d],y=e.depthModeForSublayer(m.overscaledZ-p,1===r.paint.get("raster-opacity")?ti.ReadWrite:ti.ReadOnly,a.LESS),g=i.getTile(m),v=e.transform.calculatePosMatrix(m.toUnwrapped(),h);g.registerFadeDuration(r.paint.get("raster-fade-duration"));var _=i.findLoadedParent(m,0),x=function(e,i,r,n,o){if(0<(s=n.paint.get("raster-fade-duration"))){var a=t.browser.now(),s=(n=(a-e.timeAdded)/s,i?(a-i.timeAdded)/s:-1);r=r.getSource(),r=o.coveringZoomLevel({tileSize:r.tileSize,roundZoom:r.roundZoom}),s=(r=!i||Math.abs(i.tileID.overscaledZ-r)>Math.abs(e.tileID.overscaledZ-r))&&e.refreshedUponExpiration?1:t.clamp(r?n:1-s,0,1);return e.refreshedUponExpiration&&1<=n&&(e.refreshedUponExpiration=!1),i?{opacity:1,mix:1-s}:{opacity:s,mix:0}}return{opacity:1,mix:0}}(g,_,i,r,e.transform),b=void 0,w=void 0,S="nearest"===r.paint.get("raster-resampling")?a.NEAREST:a.LINEAR;o.activeTexture.set(a.TEXTURE0),g.texture.bind(S,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),o.activeTexture.set(a.TEXTURE1),_?(_.texture.bind(S,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),b=Math.pow(2,_.tileID.overscaledZ-g.tileID.overscaledZ),w=[g.tileID.canonical.x*b%1,g.tileID.canonical.y*b%1]):g.texture.bind(S,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),x=nn(v,w||[0,0],b||1,x,r),s instanceof H?l.draw(o,a.TRIANGLES,y,ei.disabled,u,ri.disabled,x,r.id,s.boundsBuffer,e.quadTriangleIndexBuffer,s.boundsSegments):l.draw(o,a.TRIANGLES,y,c[m.overscaledZ],u,ri.disabled,x,r.id,e.rasterBoundsBuffer,e.quadTriangleIndexBuffer,e.rasterBoundsSegments)}},background:function(t,e,i){var r=i.paint.get("background-color"),n=i.paint.get("background-opacity");if(0!==n){var o=t.context,a=o.gl,s=(f=t.transform).tileSize,l=i.paint.get("background-pattern");if(!t.isPatternMissing(l)){var u=!l&&1===r.a&&1===n&&t.opaquePassEnabledForLayer()?"opaque":"translucent";if(t.renderPass===u){var c=ei.disabled,p=t.depthModeForSublayer(0,"opaque"==u?ti.ReadWrite:ti.ReadOnly),h=t.colorModeForRenderPass(),d=t.useProgram(l?"backgroundPattern":"background"),f=f.coveringTiles({tileSize:s});l&&(o.activeTexture.set(a.TEXTURE0),t.imageManager.bind(t.context));for(var m=i.getCrossfadeParameters(),y=0,g=f;y<g.length;y+=1){var v=g[y],_=t.transform.calculatePosMatrix(v.toUnwrapped());_=l?on(_,n,t,l,{tileID:v,tileSize:s},m):{u_matrix:_,u_opacity:n,u_color:r};d.draw(o,a.TRIANGLES,p,c,h,ri.disabled,_,i.id,t.tileExtentBuffer,t.quadTriangleIndexBuffer,t.tileExtentSegments)}}}}},debug:function(e,i,r){for(var n=0;n<r.length;n++)!function(e,i,r){var n=e.context,o=n.gl,a=r.posMatrix,s=e.useProgram("debug"),l=ti.disabled,u=ei.disabled,c=e.colorModeForRenderPass();n.activeTexture.set(o.TEXTURE0),e.emptyTexture.bind(o.LINEAR,o.CLAMP_TO_EDGE),s.draw(n,o.LINE_STRIP,l,u,c,ri.disabled,Jr(a,t.Color.red),"$debug",e.debugBuffer,e.tileBorderIndexBuffer,e.debugSegments);c=(p=i.getTileByID(r.key).latestRawTileData)&&p.byteLength||0;var p=Math.floor(c/1024);c=i.getTile(r).tileSize,i=512/Math.min(c,512)*(r.overscaledZ/e.transform.zoom)*.5,c=r.canonical.toString();r.overscaledZ!==r.canonical.z&&(c+=" => "+r.overscaledZ),function(t,e){t.initDebugOverlayCanvas();var i=t.debugOverlayCanvas,r=t.context.gl,n=t.debugOverlayCanvas.getContext("2d");n.clearRect(0,0,i.width,i.height),n.shadowColor="white",n.shadowBlur=2,n.lineWidth=1.5,n.strokeStyle="white",n.textBaseline="top",n.font="bold 36px Open Sans, sans-serif",n.fillText(e,5,5),n.strokeText(e,5,5),t.debugOverlayTexture.update(i),t.debugOverlayTexture.bind(r.LINEAR,r.CLAMP_TO_EDGE)}(e,c+" "+p+"kb"),s.draw(n,o.TRIANGLES,l,u,ii.alphaBlended,ri.disabled,Jr(a,t.Color.transparent,i),"$debug",e.debugBuffer,e.quadTriangleIndexBuffer,e.debugSegments)}(e,i,r[n])},custom:function(t,e,i){var r,n=t.context;i=i.implementation;"offscreen"===t.renderPass?(r=i.prerender)&&(t.setCustomLayerDefaults(),n.setColorMode(t.colorModeForRenderPass()),r.call(i,n.gl,t.transform.customLayerMatrix()),n.setDirty(),t.setBaseState()):"translucent"===t.renderPass&&(t.setCustomLayerDefaults(),n.setColorMode(t.colorModeForRenderPass()),n.setStencilMode(ei.disabled),r="3d"===i.renderingMode?new ti(t.context.gl.LEQUAL,ti.ReadWrite,t.depthRangeFor3D):t.depthModeForSublayer(0,ti.ReadOnly),n.setDepthMode(r),i.render(n.gl,t.transform.customLayerMatrix()),n.setDirty(),t.setBaseState(),n.bindFramebuffer.set(null))}};function In(t,e){this.points=t,this.planes=e}function kn(e,i){this.min=e,this.max=i,this.center=t.scale$2([],t.add([],this.min,this.max),.5)}function An(t,e,i,r){if(void 0===t&&(t=0),void 0===e&&(e=0),void 0===i&&(i=0),void 0===r&&(r=0),isNaN(t)||t<0||isNaN(e)||e<0||isNaN(i)||i<0||isNaN(r)||r<0)throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");this.top=t,this.bottom=e,this.left=i,this.right=r}function Pn(e,i,r,n,o){this.tileSize=512,this.maxValidLatitude=85.051129,this._renderWorldCopies=void 0===o||o,this._minZoom=e||0,this._maxZoom=i||22,this._minPitch=null==r?0:r,this._maxPitch=null==n?60:n,this.setMaxBounds(),this.width=0,this.height=0,this._center=new t.LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._unmodified=!0,this._edgeInsets=new An,this._posMatrixCache={},this._alignedPosMatrixCache={}}function Mn(e){function i(){a=null,o&&(r(),a=setTimeout(i,n),o=!1)}var r,n,o,a;this._hashName=e&&encodeURIComponent(e),t.bindAll(["_getCurrentHash","_onHashChange","_updateHash"],this),this._updateHash=(r=this._updateHashUnthrottled.bind(this),o=!(n=300),a=null,function(){return o=!0,a||i(),a})}function Ln(t){this._map=t,this.clear()}Cn.prototype.resize=function(e,i){if(this.width=e*t.browser.devicePixelRatio,this.height=i*t.browser.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(var r=0,n=this.style._order;r<n.length;r+=1){var o=n[r];this.style._layers[o].resize()}},Cn.prototype.setup=function(){var e=this.context,i=new t.StructArrayLayout2i4;i.emplaceBack(0,0),i.emplaceBack(t.EXTENT,0),i.emplaceBack(0,t.EXTENT),i.emplaceBack(t.EXTENT,t.EXTENT),this.tileExtentBuffer=e.createVertexBuffer(i,xr.members),this.tileExtentSegments=t.SegmentVector.simpleSegment(0,0,4,2),(i=new t.StructArrayLayout2i4).emplaceBack(0,0),i.emplaceBack(t.EXTENT,0),i.emplaceBack(0,t.EXTENT),i.emplaceBack(t.EXTENT,t.EXTENT),this.debugBuffer=e.createVertexBuffer(i,xr.members),this.debugSegments=t.SegmentVector.simpleSegment(0,0,4,5),(i=new t.StructArrayLayout4i8).emplaceBack(0,0,0,0),i.emplaceBack(t.EXTENT,0,t.EXTENT,0),i.emplaceBack(0,t.EXTENT,0,t.EXTENT),i.emplaceBack(t.EXTENT,t.EXTENT,t.EXTENT,t.EXTENT),this.rasterBoundsBuffer=e.createVertexBuffer(i,q.members),this.rasterBoundsSegments=t.SegmentVector.simpleSegment(0,0,4,2),(i=new t.StructArrayLayout2i4).emplaceBack(0,0),i.emplaceBack(1,0),i.emplaceBack(0,1),i.emplaceBack(1,1),this.viewportBuffer=e.createVertexBuffer(i,xr.members),this.viewportSegments=t.SegmentVector.simpleSegment(0,0,4,2),(i=new t.StructArrayLayout1ui2).emplaceBack(0),i.emplaceBack(1),i.emplaceBack(3),i.emplaceBack(2),i.emplaceBack(0),this.tileBorderIndexBuffer=e.createIndexBuffer(i),(i=new t.StructArrayLayout3ui6).emplaceBack(0,1,2),i.emplaceBack(2,1,3),this.quadTriangleIndexBuffer=e.createIndexBuffer(i),this.emptyTexture=new t.Texture(e,{width:1,height:1,data:new Uint8Array([0,0,0,0])},e.gl.RGBA),e=this.context.gl,this.stencilClearMode=new ei({func:e.ALWAYS,mask:0},0,255,e.ZERO,e.ZERO,e.ZERO)},Cn.prototype.clearStencil=function(){var e=this.context,i=e.gl;this.nextStencilID=1,this.currentStencilSource=void 0;var r=t.create();t.ortho(r,0,this.width,this.height,0,0,1),t.scale(r,r,[i.drawingBufferWidth,i.drawingBufferHeight,0]),this.useProgram("clippingMask").draw(e,i.TRIANGLES,ti.disabled,this.stencilClearMode,ii.disabled,ri.disabled,Vr(r),"$clipping",this.viewportBuffer,this.quadTriangleIndexBuffer,this.viewportSegments)},Cn.prototype._renderTileClippingMasks=function(t,e){if(this.currentStencilSource!==t.source&&t.isTileClipped()&&e&&e.length){this.currentStencilSource=t.source;var i=this.context,r=i.gl;256<this.nextStencilID+e.length&&this.clearStencil(),i.setColorMode(ii.disabled),i.setDepthMode(ti.disabled);var n=this.useProgram("clippingMask");this._tileClippingMaskIDs={};for(var o=0,a=e;o<a.length;o+=1){var s=a[o],l=this._tileClippingMaskIDs[s.key]=this.nextStencilID++;n.draw(i,r.TRIANGLES,ti.disabled,new ei({func:r.ALWAYS,mask:0},l,255,r.KEEP,r.KEEP,r.REPLACE),ii.disabled,ri.disabled,Vr(s.posMatrix),"$clipping",this.tileExtentBuffer,this.quadTriangleIndexBuffer,this.tileExtentSegments)}}},Cn.prototype.stencilModeFor3D=function(){this.currentStencilSource=void 0,256<this.nextStencilID+1&&this.clearStencil();var t=this.nextStencilID++,e=this.context.gl;return new ei({func:e.NOTEQUAL,mask:255},t,255,e.KEEP,e.KEEP,e.REPLACE)},Cn.prototype.stencilModeForClipping=function(t){var e=this.context.gl;return new ei({func:e.EQUAL,mask:255},this._tileClippingMaskIDs[t.key],0,e.KEEP,e.KEEP,e.REPLACE)},Cn.prototype.stencilConfigForOverlap=function(t){var e=this.context.gl,i=t.sort(function(t,e){return e.overscaledZ-t.overscaledZ}),r=i[i.length-1].overscaledZ,n=i[0].overscaledZ-r+1;if(1<n){this.currentStencilSource=void 0,256<this.nextStencilID+n&&this.clearStencil();for(var o={},a=0;a<n;a++)o[a+r]=new ei({func:e.GEQUAL,mask:255},a+this.nextStencilID,255,e.KEEP,e.KEEP,e.REPLACE);return this.nextStencilID+=n,[o,i]}return[((t={})[r]=ei.disabled,t),i]},Cn.prototype.colorModeForRenderPass=function(){var e=this.context.gl;return this._showOverdrawInspector?new ii([e.CONSTANT_COLOR,e.ONE],new t.Color(1/8,1/8,1/8,0),[!0,!0,!0,!0]):"opaque"===this.renderPass?ii.unblended:ii.alphaBlended},Cn.prototype.depthModeForSublayer=function(t,e,i){return this.opaquePassEnabledForLayer()?(t=1-((1+this.currentLayer)*this.numSublayers+t)*this.depthEpsilon,new ti(i||this.context.gl.LEQUAL,e,[t,t])):ti.disabled},Cn.prototype.opaquePassEnabledForLayer=function(){return this.currentLayer<this.opaquePassCutoff},Cn.prototype.render=function(e,i){var r=this;this.style=e,this.options=i,this.lineAtlas=e.lineAtlas,this.imageManager=e.imageManager,this.glyphManager=e.glyphManager,this.symbolFadeChange=e.placement.symbolFadeChange(t.browser.now()),this.imageManager.beginFrame();var n,o=this.style._order,a=this.style.sourceCaches;for(n in a){var s=a[n];s.used&&s.prepare(this.context)}var l,u={},c={},p={};for(l in a){var h=a[l];u[l]=h.getVisibleCoordinates(),c[l]=u[l].slice().reverse(),p[l]=h.getVisibleCoordinates(!0).reverse()}this.opaquePassCutoff=1/0;for(var d=0;d<o.length;d++){var f=o[d];if(this.style._layers[f].is3D()){this.opaquePassCutoff=d;break}}this.renderPass="offscreen";for(var m,y,g=0,v=o;g<v.length;g+=1){var _=v[g],x=this.style._layers[_];x.hasOffscreenPass()&&!x.isHidden(this.transform.zoom)&&(_=c[x.source],"custom"!==x.type&&!_.length||this.renderLayer(this,a[x.source],x,_))}for(this.context.bindFramebuffer.set(null),this.context.clear({color:i.showOverdrawInspector?t.Color.black:t.Color.transparent,depth:1}),this.clearStencil(),this._showOverdrawInspector=i.showOverdrawInspector,this.depthRangeFor3D=[0,1-(e._order.length+2)*this.numSublayers*this.depthEpsilon],this.renderPass="opaque",this.currentLayer=o.length-1;0<=this.currentLayer;this.currentLayer--){var b=this.style._layers[o[this.currentLayer]],w=a[b.source],S=u[b.source];this._renderTileClippingMasks(b,S),this.renderLayer(this,w,b,S)}for(this.renderPass="translucent",this.currentLayer=0;this.currentLayer<o.length;this.currentLayer++){var T=this.style._layers[o[this.currentLayer]],C=a[T.source],E=("symbol"===T.type?p:c)[T.source];this._renderTileClippingMasks(T,u[T.source]),this.renderLayer(this,C,T,E)}this.options.showTileBoundaries&&(t.values(this.style._layers).forEach(function(t){t.source&&!t.isHidden(r.transform.zoom)&&(t.source!==(y&&y.id)&&(y=r.style.sourceCaches[t.source]),(!m||m.getSource().maxzoom<y.getSource().maxzoom)&&(m=y))}),m&&En.debug(this,m,m.getVisibleCoordinates())),this.options.showPadding&&function(t){var e=t.transform.padding;wn(t,t.transform.height-(e.top||0),3,gn),wn(t,e.bottom||0,3,vn),Sn(t,e.left||0,3,_n),Sn(t,t.transform.width-(e.right||0),3,xn);var i,r=t.transform.centerPoint;Tn(i=t,(e=r.x)-1,(t=t.transform.height-r.y)-10,2,20,r=bn),Tn(i,e-10,t-1,20,2,r)}(this),this.context.setDefault()},Cn.prototype.renderLayer=function(t,e,i,r){i.isHidden(this.transform.zoom)||"background"!==i.type&&"custom"!==i.type&&!r.length||(this.id=i.id,this.gpuTimingStart(i),En[i.type](t,e,i,r,this.style.placement.variableOffsets),this.gpuTimingEnd())},Cn.prototype.gpuTimingStart=function(t){var e,i;this.options.gpuTiming&&(e=this.context.extTimerQuery,(i=(i=this.gpuTimers[t.id])||(this.gpuTimers[t.id]={calls:0,cpuTime:0,query:e.createQueryEXT()})).calls++,e.beginQueryEXT(e.TIME_ELAPSED_EXT,i.query))},Cn.prototype.gpuTimingEnd=function(){var t;this.options.gpuTiming&&(t=this.context.extTimerQuery).endQueryEXT(t.TIME_ELAPSED_EXT)},Cn.prototype.collectGpuTimers=function(){var t=this.gpuTimers;return this.gpuTimers={},t},Cn.prototype.queryGpuTimers=function(t){var e,i={};for(e in t){var r=t[e],n=this.context.extTimerQuery,o=n.getQueryObjectEXT(r.query,n.QUERY_RESULT_EXT)/1e6;n.deleteQueryEXT(r.query),i[e]=o}return i},Cn.prototype.translatePosMatrix=function(e,i,r,n,o){if(!r[0]&&!r[1])return e;var a=o?"map"===n?this.transform.angle:0:"viewport"===n?-this.transform.angle:0;return a&&(n=Math.sin(a),a=Math.cos(a),r=[r[0]*a-r[1]*n,r[0]*n+r[1]*a]),i=[o?r[0]:Ui(i,r[0],this.transform.zoom),o?r[1]:Ui(i,r[1],this.transform.zoom),0],r=new Float32Array(16),t.translate(r,e,i),r},Cn.prototype.saveTileTexture=function(t){var e=this._tileTextures[t.size[0]];e?e.push(t):this._tileTextures[t.size[0]]=[t]},Cn.prototype.getTileTexture=function(t){return(t=this._tileTextures[t])&&0<t.length?t.pop():null},Cn.prototype.isPatternMissing=function(t){if(!t)return!1;if(!t.from||!t.to)return!0;var e=this.imageManager.getPattern(t.from.toString());t=this.imageManager.getPattern(t.to.toString());return!e||!t},Cn.prototype.useProgram=function(t,e){this.cache=this.cache||{};var i=""+t+(e?e.cacheKey:"")+(this._showOverdrawInspector?"/overdraw":"");return this.cache[i]||(this.cache[i]=new Ur(this.context,0,Br[t],e,cn[t],this._showOverdrawInspector)),this.cache[i]},Cn.prototype.setCustomLayerDefaults=function(){this.context.unbindVAO(),this.context.cullFace.setDefault(),this.context.activeTexture.setDefault(),this.context.pixelStoreUnpack.setDefault(),this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.context.pixelStoreUnpackFlipY.setDefault()},Cn.prototype.setBaseState=function(){var t=this.context.gl;this.context.cullFace.set(!1),this.context.viewport.set([0,0,this.width,this.height]),this.context.blendEquation.set(t.FUNC_ADD)},Cn.prototype.initDebugOverlayCanvas=function(){var e;null==this.debugOverlayCanvas&&(this.debugOverlayCanvas=t.window.document.createElement("canvas"),this.debugOverlayCanvas.width=512,this.debugOverlayCanvas.height=512,e=this.context.gl,this.debugOverlayTexture=new t.Texture(this.context,this.debugOverlayCanvas,e.RGBA))},Cn.prototype.destroy=function(){this.emptyTexture.destroy(),this.debugOverlayTexture&&this.debugOverlayTexture.destroy()},In.fromInvProjectionMatrix=function(e,i,r){var n=Math.pow(2,r),o=[[-1,1,-1,1],[1,1,-1,1],[1,-1,-1,1],[-1,-1,-1,1],[-1,1,1,1],[1,1,1,1],[1,-1,1,1],[-1,-1,1,1]].map(function(i){return t.transformMat4([],i,e)}).map(function(e){return t.scale$1([],e,1/e[3]/i*n)});r=[[0,1,2],[6,5,4],[0,3,7],[2,1,5],[3,2,6],[0,4,5]].map(function(e){var i=t.sub([],o[e[0]],o[e[1]]),r=t.sub([],o[e[2]],o[e[1]]);r=t.normalize([],t.cross([],i,r)),e=-t.dot(r,o[e[1]]);return r.concat(e)});return new In(o,r)},kn.prototype.quadrant=function(e){for(var i=[e%2==0,e<2],r=t.clone$2(this.min),n=t.clone$2(this.max),o=0;o<i.length;o++)r[o]=(i[o]?this.min:this.center)[o],n[o]=(i[o]?this.center:this.max)[o];return n[2]=this.max[2],new kn(r,n)},kn.prototype.distanceX=function(t){return Math.max(Math.min(this.max[0],t[0]),this.min[0])-t[0]},kn.prototype.distanceY=function(t){return Math.max(Math.min(this.max[1],t[1]),this.min[1])-t[1]},kn.prototype.intersects=function(e){for(var i=[[this.min[0],this.min[1],0,1],[this.max[0],this.min[1],0,1],[this.max[0],this.max[1],0,1],[this.min[0],this.max[1],0,1]],r=!0,n=0;n<e.planes.length;n++){for(var o=e.planes[n],a=0,s=0;s<i.length;s++)a+=0<=t.dot$1(o,i[s]);if(0===a)return 0;a!==i.length&&(r=!1)}if(r)return 2;for(var l=0;l<3;l++){for(var u=Number.MAX_VALUE,c=-Number.MAX_VALUE,p=0;p<e.points.length;p++){var h=e.points[p][l]-this.min[l];u=Math.min(u,h),c=Math.max(c,h)}if(c<0||u>this.max[l]-this.min[l])return 0}return 1},An.prototype.interpolate=function(e,i,r){return null!=i.top&&null!=e.top&&(this.top=t.number(e.top,i.top,r)),null!=i.bottom&&null!=e.bottom&&(this.bottom=t.number(e.bottom,i.bottom,r)),null!=i.left&&null!=e.left&&(this.left=t.number(e.left,i.left,r)),null!=i.right&&null!=e.right&&(this.right=t.number(e.right,i.right,r)),this},An.prototype.getCenter=function(e,i){return e=t.clamp((this.left+e-this.right)/2,0,e),i=t.clamp((this.top+i-this.bottom)/2,0,i),new t.Point(e,i)},An.prototype.equals=function(t){return this.top===t.top&&this.bottom===t.bottom&&this.left===t.left&&this.right===t.right},An.prototype.clone=function(){return new An(this.top,this.bottom,this.left,this.right)},An.prototype.toJSON=function(){return{top:this.top,bottom:this.bottom,left:this.left,right:this.right}},U={minZoom:{configurable:!0},maxZoom:{configurable:!0},minPitch:{configurable:!0},maxPitch:{configurable:!0},renderWorldCopies:{configurable:!0},worldSize:{configurable:!0},centerOffset:{configurable:!0},size:{configurable:!0},bearing:{configurable:!0},pitch:{configurable:!0},fov:{configurable:!0},zoom:{configurable:!0},center:{configurable:!0},padding:{configurable:!0},centerPoint:{configurable:!0},unmodified:{configurable:!0},point:{configurable:!0}},Pn.prototype.clone=function(){var t;return(t=new Pn(this._minZoom,this._maxZoom,this._minPitch,this.maxPitch,this._renderWorldCopies)).tileSize=this.tileSize,t.latRange=this.latRange,t.width=this.width,t.height=this.height,t._center=this._center,t.zoom=this.zoom,t.angle=this.angle,t._fov=this._fov,t._pitch=this._pitch,t._unmodified=this._unmodified,t._edgeInsets=this._edgeInsets.clone(),t._calcMatrices(),t},U.minZoom.get=function(){return this._minZoom},U.minZoom.set=function(t){this._minZoom!==t&&(this._minZoom=t,this.zoom=Math.max(this.zoom,t))},U.maxZoom.get=function(){return this._maxZoom},U.maxZoom.set=function(t){this._maxZoom!==t&&(this._maxZoom=t,this.zoom=Math.min(this.zoom,t))},U.minPitch.get=function(){return this._minPitch},U.minPitch.set=function(t){this._minPitch!==t&&(this._minPitch=t,this.pitch=Math.max(this.pitch,t))},U.maxPitch.get=function(){return this._maxPitch},U.maxPitch.set=function(t){this._maxPitch!==t&&(this._maxPitch=t,this.pitch=Math.min(this.pitch,t))},U.renderWorldCopies.get=function(){return this._renderWorldCopies},U.renderWorldCopies.set=function(t){void 0===t?t=!0:null===t&&(t=!1),this._renderWorldCopies=t},U.worldSize.get=function(){return this.tileSize*this.scale},U.centerOffset.get=function(){return this.centerPoint._sub(this.size._div(2))},U.size.get=function(){return new t.Point(this.width,this.height)},U.bearing.get=function(){return-this.angle/Math.PI*180},U.bearing.set=function(e){e=-t.wrap(e,-180,180)*Math.PI/180,this.angle!==e&&(this._unmodified=!1,this.angle=e,this._calcMatrices(),this.rotationMatrix=t.create$2(),t.rotate(this.rotationMatrix,this.rotationMatrix,this.angle))},U.pitch.get=function(){return this._pitch/Math.PI*180},U.pitch.set=function(e){e=t.clamp(e,this.minPitch,this.maxPitch)/180*Math.PI,this._pitch!==e&&(this._unmodified=!1,this._pitch=e,this._calcMatrices())},U.fov.get=function(){return this._fov/Math.PI*180},U.fov.set=function(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=t/180*Math.PI,this._calcMatrices())},U.zoom.get=function(){return this._zoom},U.zoom.set=function(t){t=Math.min(Math.max(t,this.minZoom),this.maxZoom),this._zoom!==t&&(this._unmodified=!1,this._zoom=t,this.scale=this.zoomScale(t),this.tileZoom=Math.floor(t),this.zoomFraction=t-this.tileZoom,this._constrain(),this._calcMatrices())},U.center.get=function(){return this._center},U.center.set=function(t){t.lat===this._center.lat&&t.lng===this._center.lng||(this._unmodified=!1,this._center=t,this._constrain(),this._calcMatrices())},U.padding.get=function(){return this._edgeInsets.toJSON()},U.padding.set=function(t){this._edgeInsets.equals(t)||(this._unmodified=!1,this._edgeInsets.interpolate(this._edgeInsets,t,1),this._calcMatrices())},U.centerPoint.get=function(){return this._edgeInsets.getCenter(this.width,this.height)},Pn.prototype.isPaddingEqual=function(t){return this._edgeInsets.equals(t)},Pn.prototype.interpolatePadding=function(t,e,i){this._unmodified=!1,this._edgeInsets.interpolate(t,e,i),this._constrain(),this._calcMatrices()},Pn.prototype.coveringZoomLevel=function(t){return t=(t.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/t.tileSize)),Math.max(0,t)},Pn.prototype.getVisibleUnwrappedCoordinates=function(e){var i=[new t.UnwrappedTileID(0,e)];if(this._renderWorldCopies)for(var r=this.pointCoordinate(new t.Point(0,0)),n=this.pointCoordinate(new t.Point(this.width,0)),o=this.pointCoordinate(new t.Point(this.width,this.height)),a=this.pointCoordinate(new t.Point(0,this.height)),s=Math.floor(Math.min(r.x,n.x,o.x,a.x)),l=Math.floor(Math.max(r.x,n.x,o.x,a.x)),u=s-1;u<=l+1;u++)0!==u&&i.push(new t.UnwrappedTileID(u,e));return i},Pn.prototype.coveringTiles=function(e){var i=this.coveringZoomLevel(e),r=i;if(void 0!==e.minzoom&&i<e.minzoom)return[];void 0!==e.maxzoom&&i>e.maxzoom&&(i=e.maxzoom);var n=t.MercatorCoordinate.fromLngLat(this.center),o=Math.pow(2,i),a=[o*n.x,o*n.y,0],s=In.fromInvProjectionMatrix(this.invProjMatrix,this.worldSize,i),l=e.minzoom||0;function u(t){return{aabb:new kn([t*o,0,0],[(t+1)*o,o,0]),zoom:0,x:0,y:0,wrap:t,fullyVisible:!1}}this.pitch<=60&&this._edgeInsets.top<.1&&(l=i);var c=[],p=[],h=i,d=e.reparseOverscaled?r:i;if(this._renderWorldCopies)for(var f=1;f<=3;f++)c.push(u(-f)),c.push(u(f));for(c.push(u(0));0<c.length;){var m=c.pop(),y=m.x,g=m.y,v=m.fullyVisible;if(!v){if(0===(x=m.aabb.intersects(s)))continue;v=2===x}var _=m.aabb.distanceX(a),x=m.aabb.distanceY(a);_=Math.max(Math.abs(_),Math.abs(x)),x=3+(1<<h-m.zoom)-2;if(m.zoom===h||x<_&&m.zoom>=l)p.push({tileID:new t.OverscaledTileID(m.zoom===h?d:m.zoom,m.wrap,m.zoom,y,g),distanceSq:t.sqrLen([a[0]-.5-y,a[1]-.5-g])});else for(var b=0;b<4;b++){var w=(y<<1)+b%2,S=(g<<1)+(b>>1);c.push({aabb:m.aabb.quadrant(b),zoom:m.zoom+1,x:w,y:S,wrap:m.wrap,fullyVisible:v})}}return p.sort(function(t,e){return t.distanceSq-e.distanceSq}).map(function(t){return t.tileID})},Pn.prototype.resize=function(t,e){this.width=t,this.height=e,this.pixelsToGLUnits=[2/t,-2/e],this._constrain(),this._calcMatrices()},U.unmodified.get=function(){return this._unmodified},Pn.prototype.zoomScale=function(t){return Math.pow(2,t)},Pn.prototype.scaleZoom=function(t){return Math.log(t)/Math.LN2},Pn.prototype.project=function(e){var i=t.clamp(e.lat,-this.maxValidLatitude,this.maxValidLatitude);return new t.Point(t.mercatorXfromLng(e.lng)*this.worldSize,t.mercatorYfromLat(i)*this.worldSize)},Pn.prototype.unproject=function(e){return new t.MercatorCoordinate(e.x/this.worldSize,e.y/this.worldSize).toLngLat()},U.point.get=function(){return this.project(this.center)},Pn.prototype.setLocationAtPoint=function(e,i){var r=this.pointCoordinate(i);i=this.pointCoordinate(this.centerPoint),e=this.locationCoordinate(e),i=new t.MercatorCoordinate(e.x-(r.x-i.x),e.y-(r.y-i.y));this.center=this.coordinateLocation(i),this._renderWorldCopies&&(this.center=this.center.wrap())},Pn.prototype.locationPoint=function(t){return this.coordinatePoint(this.locationCoordinate(t))},Pn.prototype.pointLocation=function(t){return this.coordinateLocation(this.pointCoordinate(t))},Pn.prototype.locationCoordinate=function(e){return t.MercatorCoordinate.fromLngLat(e)},Pn.prototype.coordinateLocation=function(t){return t.toLngLat()},Pn.prototype.pointCoordinate=function(e){var i=[e.x,e.y,0,1],r=[e.x,e.y,1,1];t.transformMat4(i,i,this.pixelMatrixInverse),t.transformMat4(r,r,this.pixelMatrixInverse);var n=i[3],o=r[3],a=i[1]/n,s=r[1]/o,l=(l=i[2]/n)==(e=r[2]/o)?0:(0-l)/(e-l);return new t.MercatorCoordinate(t.number(i[0]/n,r[0]/o,l)/this.worldSize,t.number(a,s,l)/this.worldSize)},Pn.prototype.coordinatePoint=function(e){return e=[e.x*this.worldSize,e.y*this.worldSize,0,1],t.transformMat4(e,e,this.pixelMatrix),new t.Point(e[0]/e[3],e[1]/e[3])},Pn.prototype.getBounds=function(){return(new t.LngLatBounds).extend(this.pointLocation(new t.Point(0,0))).extend(this.pointLocation(new t.Point(this.width,0))).extend(this.pointLocation(new t.Point(this.width,this.height))).extend(this.pointLocation(new t.Point(0,this.height)))},Pn.prototype.getMaxBounds=function(){return this.latRange&&2===this.latRange.length&&this.lngRange&&2===this.lngRange.length?new t.LngLatBounds([this.lngRange[0],this.latRange[0]],[this.lngRange[1],this.latRange[1]]):null},Pn.prototype.setMaxBounds=function(t){t?(this.lngRange=[t.getWest(),t.getEast()],this.latRange=[t.getSouth(),t.getNorth()],this._constrain()):(this.lngRange=null,this.latRange=[-this.maxValidLatitude,this.maxValidLatitude])},Pn.prototype.calculatePosMatrix=function(e,i){var r=e.key,n=(i=void 0!==i&&i)?this._alignedPosMatrixCache:this._posMatrixCache;if(n[r])return n[r];var o=e.canonical,a=this.worldSize/this.zoomScale(o.z),s=o.x+Math.pow(2,o.z)*e.wrap;e=t.identity(new Float64Array(16));return t.translate(e,e,[s*a,o.y*a,0]),t.scale(e,e,[a/t.EXTENT,a/t.EXTENT,1]),t.multiply(e,i?this.alignedProjMatrix:this.projMatrix,e),n[r]=new Float32Array(e),n[r]},Pn.prototype.customLayerMatrix=function(){return this.mercatorMatrix.slice()},Pn.prototype._constrain=function(){if(this.center&&this.width&&this.height&&!this._constraining){this._constraining=!0;var e,i,r,n,o=-90,a=90,s=-180,l=180,u=this.size,c=this._unmodified;this.latRange&&(h=this.latRange,o=t.mercatorYfromLat(h[1])*this.worldSize,r=(a=t.mercatorYfromLat(h[0])*this.worldSize)-o<u.y?u.y/(a-o):0),this.lngRange&&(d=this.lngRange,s=t.mercatorXfromLng(d[0])*this.worldSize,n=(l=t.mercatorXfromLng(d[1])*this.worldSize)-s<u.x?u.x/(l-s):0);var p,h=this.point,d=Math.max(n||0,r||0);if(d)return this.center=this.unproject(new t.Point(n?(l+s)/2:h.x,r?(a+o)/2:h.y)),this.zoom+=this.scaleZoom(d),this._unmodified=c,void(this._constraining=!1);this.latRange&&((d=h.y)-(p=u.y/2)<o&&(i=o+p),a<d+p&&(i=a-p)),this.lngRange&&((p=h.x)-(u=u.x/2)<s&&(e=s+u),l<p+u&&(e=l-u)),void 0===e&&void 0===i||(this.center=this.unproject(new t.Point(void 0!==e?e:h.x,void 0!==i?i:h.y))),this._unmodified=c,this._constraining=!1}},Pn.prototype._calcMatrices=function(){if(this.height){var e=this._fov/2,i=this.centerOffset;this.cameraToCenterDistance=.5/Math.tan(e)*this.height;var r=Math.PI/2+this._pitch,n=this._fov*(.5+i.y/this.height),o=Math.sin(n)*this.cameraToCenterDistance/Math.sin(t.clamp(Math.PI-r-n,.01,Math.PI-.01)),a=(s=this.point).x,s=(e=s.y,r=1.01*(Math.cos(Math.PI/2-this._pitch)*o+this.cameraToCenterDistance),n=this.height/50,new Float64Array(16));if(t.perspective(s,this._fov,this.width/this.height,n,r),s[8]=2*-i.x/this.width,s[9]=2*i.y/this.height,t.scale(s,s,[1,-1,1]),t.translate(s,s,[0,0,-this.cameraToCenterDistance]),t.rotateX(s,s,this._pitch),t.rotateZ(s,s,this.angle),t.translate(s,s,[-a,-e,0]),this.mercatorMatrix=t.scale([],s,[this.worldSize,this.worldSize,this.worldSize]),t.scale(s,s,[1,1,t.mercatorZfromAltitude(1,this.center.lat)*this.worldSize,1]),this.projMatrix=s,this.invProjMatrix=t.invert([],this.projMatrix),o=this.width%2/2,n=this.height%2/2,r=Math.cos(this.angle),i=Math.sin(this.angle),a=a-Math.round(a)+r*o+i*n,i=e-Math.round(e)+r*n+i*o,o=new Float64Array(s),t.translate(o,o,[.5<a?a-1:a,.5<i?i-1:i,0]),this.alignedProjMatrix=o,s=t.create(),t.scale(s,s,[this.width/2,-this.height/2,1]),t.translate(s,s,[1,-1,0]),this.labelPlaneMatrix=s,s=t.create(),t.scale(s,s,[1,-1,1]),t.translate(s,s,[-1,-1,0]),t.scale(s,s,[2/this.width,2/this.height,1]),this.glCoordMatrix=s,this.pixelMatrix=t.multiply(new Float64Array(16),this.labelPlaneMatrix,this.projMatrix),!(s=t.invert(new Float64Array(16),this.pixelMatrix)))throw new Error("failed to invert matrix");this.pixelMatrixInverse=s,this._posMatrixCache={},this._alignedPosMatrixCache={}}},Pn.prototype.maxPitchScaleFactor=function(){if(!this.pixelMatrixInverse)return 1;var e=[(e=this.pointCoordinate(new t.Point(0,0))).x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(e,e,this.pixelMatrix)[3]/this.cameraToCenterDistance},Pn.prototype.getCameraPoint=function(){var e=this._pitch;e=Math.tan(e)*(this.cameraToCenterDistance||1);return this.centerPoint.add(new t.Point(0,e))},Pn.prototype.getCameraQueryGeometry=function(e){var i=this.getCameraPoint();if(1===e.length)return[e[0],i];for(var r=i.x,n=i.y,o=i.x,a=i.y,s=0,l=e;s<l.length;s+=1){var u=l[s];r=Math.min(r,u.x),n=Math.min(n,u.y),o=Math.max(o,u.x),a=Math.max(a,u.y)}return[new t.Point(r,n),new t.Point(o,n),new t.Point(o,a),new t.Point(r,a),new t.Point(r,n)]},Object.defineProperties(Pn.prototype,U),Mn.prototype.addTo=function(e){return this._map=e,t.window.addEventListener("hashchange",this._onHashChange,!1),this._map.on("moveend",this._updateHash),this},Mn.prototype.remove=function(){return t.window.removeEventListener("hashchange",this._onHashChange,!1),this._map.off("moveend",this._updateHash),clearTimeout(this._updateHash()),delete this._map,this},Mn.prototype.getHashString=function(e){var i=this._map.getCenter(),r=Math.round(100*this._map.getZoom())/100,n=Math.ceil((r*Math.LN2+Math.log(512/360/.5))/Math.LN10),o=Math.pow(10,n),a=Math.round(i.lng*o)/o,s=(n=Math.round(i.lat*o)/o,i=this._map.getBearing(),o=this._map.getPitch(),"");if(s+=e?"/"+a+"/"+n+"/"+r:r+"/"+n+"/"+a,(i||o)&&(s+="/"+Math.round(10*i)/10),o&&(s+="/"+Math.round(o)),this._hashName){var l=this._hashName,u=!1;o=t.window.location.hash.slice(1).split("&").map(function(t){var e=t.split("=")[0];return e===l?(u=!0,e+"="+s):t}).filter(function(t){return t});return u||o.push(l+"="+s),"#"+o.join("&")}return"#"+s},Mn.prototype._getCurrentHash=function(){var e,i=this,r=t.window.location.hash.replace("#","");return this._hashName?(r.split("&").map(function(t){return t.split("=")}).forEach(function(t){t[0]===i._hashName&&(e=t)}),(e&&e[1]||"").split("/")):r.split("/")},Mn.prototype._onHashChange=function(){var t=this._getCurrentHash();if(3<=t.length&&!t.some(function(t){return isNaN(t)})){var e=this._map.dragRotate.isEnabled()&&this._map.touchZoomRotate.isEnabled()?+(t[3]||0):this._map.getBearing();return this._map.jumpTo({center:[+t[2],+t[1]],zoom:+t[0],bearing:e,pitch:+(t[4]||0)}),!0}return!1},Mn.prototype._updateHashUnthrottled=function(){var e=t.window.location.href.replace(/(#.+)?$/,this.getHashString());try{t.window.history.replaceState(t.window.history.state,null,e)}catch(e){}};W={linearity:.3,easing:t.bezier(0,0,.3,1)};var On=t.extend({deceleration:2500,maxSpeed:1400},W),Rn=t.extend({deceleration:20,maxSpeed:1400},W),zn=t.extend({deceleration:1e3,maxSpeed:360},W),Dn=t.extend({deceleration:1e3,maxSpeed:90},W);function Nn(t,e){(!t.duration||t.duration<e.duration)&&(t.duration=e.duration,t.easing=e.easing)}function Bn(e,i,r){var n=r.maxSpeed,o=r.linearity,a=r.deceleration;n=t.clamp(e*o/(i/1e3),-n,n),o=Math.abs(n)/(a*o);return{easing:r.easing,duration:1e3*o,amount:n*(o/2)}}function Fn(t,e){this._map=t,this._clickTolerance=e.clickTolerance}Ln.prototype.clear=function(){this._inertiaBuffer=[]},Ln.prototype.record=function(e){this._drainInertiaBuffer(),this._inertiaBuffer.push({time:t.browser.now(),settings:e})},Ln.prototype._drainInertiaBuffer=function(){for(var e=this._inertiaBuffer,i=t.browser.now();0<e.length&&160<i-e[0].time;)e.shift()},Ln.prototype._onMoveEnd=function(e){if(this._drainInertiaBuffer(),!(this._inertiaBuffer.length<2)){for(var i={zoom:0,bearing:0,pitch:0,pan:new t.Point(0,0),pinchAround:void 0,around:void 0},r=0,n=this._inertiaBuffer;r<n.length;r+=1){var o=n[r].settings;i.zoom+=o.zoomDelta||0,i.bearing+=o.bearingDelta||0,i.pitch+=o.pitchDelta||0,o.panDelta&&i.pan._add(o.panDelta),o.around&&(i.around=o.around),o.pinchAround&&(i.pinchAround=o.pinchAround)}var a,s,l=this._inertiaBuffer[this._inertiaBuffer.length-1].time-this._inertiaBuffer[0].time,u={};return i.pan.mag()&&(e=Bn(i.pan.mag(),l,t.extend({},On,e||{})),u.offset=i.pan.mult(e.amount/i.pan.mag()),u.center=this._map.transform.center,Nn(u,e)),i.zoom&&(a=Bn(i.zoom,l,Rn),u.zoom=this._map.transform.zoom+a.amount,Nn(u,a)),i.bearing&&(a=Bn(i.bearing,l,zn),u.bearing=this._map.transform.bearing+t.clamp(a.amount,-179,179),Nn(u,a)),i.pitch&&(s=Bn(i.pitch,l,Dn),u.pitch=this._map.transform.pitch+s.amount,Nn(u,s)),(u.zoom||u.bearing)&&(s=void 0===i.pinchAround?i.around:i.pinchAround,u.around=s?this._map.unproject(s):this._map.getCenter()),this.clear(),t.extend(u,{noMoveStart:!0})}};var Un=function(e){function r(r,n,o,a){void 0===a&&(a={});var s=i.mousePos(n.getCanvasContainer(),o),l=n.unproject(s);e.call(this,r,t.extend({point:s,lngLat:l,originalEvent:o},a)),this._defaultPrevented=!1,this.target=n}e&&(r.__proto__=e);var n={defaultPrevented:{configurable:!0}};return((r.prototype=Object.create(e&&e.prototype)).constructor=r).prototype.preventDefault=function(){this._defaultPrevented=!0},n.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(r.prototype,n),r}(t.Event),jn=function(e){function r(r,n,o){var a="touchend"===r?o.changedTouches:o.touches,s=i.touchPos(n.getCanvasContainer(),a),l=s.map(function(t){return n.unproject(t)}),u=s.reduce(function(t,e,i,r){return t.add(e.div(r.length))},new t.Point(0,0));a=n.unproject(u);e.call(this,r,{points:s,point:u,lngLats:l,lngLat:a,originalEvent:o}),this._defaultPrevented=!1}e&&(r.__proto__=e);var n={defaultPrevented:{configurable:!0}};return((r.prototype=Object.create(e&&e.prototype)).constructor=r).prototype.preventDefault=function(){this._defaultPrevented=!0},n.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(r.prototype,n),r}(t.Event),Vn=function(t){function e(e,i,r){t.call(this,e,{originalEvent:r}),this._defaultPrevented=!1}t&&(e.__proto__=t);var i={defaultPrevented:{configurable:!0}};return((e.prototype=Object.create(t&&t.prototype)).constructor=e).prototype.preventDefault=function(){this._defaultPrevented=!0},i.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(e.prototype,i),e}(t.Event);function qn(t){this._map=t}function Hn(t,e){this._map=t,this._el=t.getCanvasContainer(),this._container=t.getContainer(),this._clickTolerance=e.clickTolerance||1}function Gn(t,e){for(var i={},r=0;r<t.length;r++)i[t[r].identifier]=e[r];return i}function Zn(t){this.reset(),this.numTouches=t.numTouches}function Wn(t){this.singleTap=new Zn(t),this.numTaps=t.numTaps,this.reset()}function Kn(){this._zoomIn=new Wn({numTouches:1,numTaps:2}),this._zoomOut=new Wn({numTouches:2,numTaps:1}),this.reset()}Fn.prototype.reset=function(){delete this._mousedownPos},Fn.prototype.wheel=function(t){return this._firePreventable(new Vn(t.type,this._map,t))},Fn.prototype.mousedown=function(t,e){return this._mousedownPos=e,this._firePreventable(new Un(t.type,this._map,t))},Fn.prototype.mouseup=function(t){this._map.fire(new Un(t.type,this._map,t))},Fn.prototype.click=function(t,e){this._mousedownPos&&this._mousedownPos.dist(e)>=this._clickTolerance||this._map.fire(new Un(t.type,this._map,t))},Fn.prototype.dblclick=function(t){return this._firePreventable(new Un(t.type,this._map,t))},Fn.prototype.mouseover=function(t){this._map.fire(new Un(t.type,this._map,t))},Fn.prototype.mouseout=function(t){this._map.fire(new Un(t.type,this._map,t))},Fn.prototype.touchstart=function(t){return this._firePreventable(new jn(t.type,this._map,t))},Fn.prototype.touchmove=function(t){this._map.fire(new jn(t.type,this._map,t))},Fn.prototype.touchend=function(t){this._map.fire(new jn(t.type,this._map,t))},Fn.prototype.touchcancel=function(t){this._map.fire(new jn(t.type,this._map,t))},Fn.prototype._firePreventable=function(t){if(this._map.fire(t),t.defaultPrevented)return{}},Fn.prototype.isEnabled=function(){return!0},Fn.prototype.isActive=function(){return!1},Fn.prototype.enable=function(){},Fn.prototype.disable=function(){},qn.prototype.reset=function(){this._delayContextMenu=!1,delete this._contextMenuEvent},qn.prototype.mousemove=function(t){this._map.fire(new Un(t.type,this._map,t))},qn.prototype.mousedown=function(){this._delayContextMenu=!0},qn.prototype.mouseup=function(){this._delayContextMenu=!1,this._contextMenuEvent&&(this._map.fire(new Un("contextmenu",this._map,this._contextMenuEvent)),delete this._contextMenuEvent)},qn.prototype.contextmenu=function(t){this._delayContextMenu?this._contextMenuEvent=t:this._map.fire(new Un(t.type,this._map,t)),this._map.listens("contextmenu")&&t.preventDefault()},qn.prototype.isEnabled=function(){return!0},qn.prototype.isActive=function(){return!1},qn.prototype.enable=function(){},qn.prototype.disable=function(){},Hn.prototype.isEnabled=function(){return!!this._enabled},Hn.prototype.isActive=function(){return!!this._active},Hn.prototype.enable=function(){this.isEnabled()||(this._enabled=!0)},Hn.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1)},Hn.prototype.mousedown=function(t,e){this.isEnabled()&&t.shiftKey&&0===t.button&&(i.disableDrag(),this._startPos=this._lastPos=e,this._active=!0)},Hn.prototype.mousemoveWindow=function(t,e){var r,n,o;this._active&&(this._lastPos.equals(o=e)||!this._box&&o.dist(this._startPos)<this._clickTolerance||(r=this._startPos,this._lastPos=o,this._box||(this._box=i.create("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",t)),n=Math.min(r.x,o.x),e=Math.max(r.x,o.x),t=Math.min(r.y,o.y),o=Math.max(r.y,o.y),i.setTransform(this._box,"translate("+n+"px,"+t+"px)"),this._box.style.width=e-n+"px",this._box.style.height=o-t+"px"))},Hn.prototype.mouseupWindow=function(e,r){var n=this;if(this._active&&0===e.button){var o=this._startPos,a=r;if(this.reset(),i.suppressClick(),o.x!==a.x||o.y!==a.y)return this._map.fire(new t.Event("boxzoomend",{originalEvent:e})),{cameraAnimation:function(t){return t.fitScreenCoordinates(o,a,n._map.getBearing(),{linear:!0})}};this._fireEvent("boxzoomcancel",e)}},Hn.prototype.keydown=function(t){this._active&&27===t.keyCode&&(this.reset(),this._fireEvent("boxzoomcancel",t))},Hn.prototype.reset=function(){this._active=!1,this._container.classList.remove("mapboxgl-crosshair"),this._box&&(i.remove(this._box),this._box=null),i.enableDrag(),delete this._startPos,delete this._lastPos},Hn.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,{originalEvent:i}))},Zn.prototype.reset=function(){delete this.centroid,delete this.startTime,delete this.touches,this.aborted=!1},Zn.prototype.touchstart=function(e,i,r){(this.centroid||r.length>this.numTouches)&&(this.aborted=!0),this.aborted||(void 0===this.startTime&&(this.startTime=e.timeStamp),r.length===this.numTouches&&(this.centroid=function(e){for(var i=new t.Point(0,0),r=0,n=e;r<n.length;r+=1){var o=n[r];i._add(o)}return i.div(e.length)}(i),this.touches=Gn(r,i)))},Zn.prototype.touchmove=function(t,e,i){if(!this.aborted&&this.centroid){var r,n=Gn(i,e);for(r in this.touches){var o=this.touches[r],a=n[r];(!a||30<a.dist(o))&&(this.aborted=!0)}}},Zn.prototype.touchend=function(t,e,i){if((!this.centroid||500<t.timeStamp-this.startTime)&&(this.aborted=!0),0===i.length&&(i=!this.aborted&&this.centroid,this.reset(),i))return i},Wn.prototype.reset=function(){this.lastTime=1/0,delete this.lastTap,this.count=0,this.singleTap.reset()},Wn.prototype.touchstart=function(t,e,i){this.singleTap.touchstart(t,e,i)},Wn.prototype.touchmove=function(t,e,i){this.singleTap.touchmove(t,e,i)},Wn.prototype.touchend=function(t,e,i){var r=this.singleTap.touchend(t,e,i);if(r&&(e=t.timeStamp-this.lastTime<500,i=!this.lastTap||this.lastTap.dist(r)<30,e&&i||this.reset(),this.count++,this.lastTime=t.timeStamp,this.lastTap=r,this.count===this.numTaps))return this.reset(),r},Kn.prototype.reset=function(){this._active=!1,this._zoomIn.reset(),this._zoomOut.reset()},Kn.prototype.touchstart=function(t,e,i){this._zoomIn.touchstart(t,e,i),this._zoomOut.touchstart(t,e,i)},Kn.prototype.touchmove=function(t,e,i){this._zoomIn.touchmove(t,e,i),this._zoomOut.touchmove(t,e,i)},Kn.prototype.touchend=function(t,e,i){var r=this,n=this._zoomIn.touchend(t,e,i),o=this._zoomOut.touchend(t,e,i);return n?(this._active=!0,t.preventDefault(),setTimeout(function(){return r.reset()},0),{cameraAnimation:function(e){return e.easeTo({duration:300,zoom:e.getZoom()+1,around:e.unproject(n)},{originalEvent:t})}}):o?(this._active=!0,t.preventDefault(),setTimeout(function(){return r.reset()},0),{cameraAnimation:function(e){return e.easeTo({duration:300,zoom:e.getZoom()-1,around:e.unproject(o)},{originalEvent:t})}}):void 0},Kn.prototype.touchcancel=function(){this.reset()},Kn.prototype.enable=function(){this._enabled=!0},Kn.prototype.disable=function(){this._enabled=!1,this.reset()},Kn.prototype.isEnabled=function(){return this._enabled},Kn.prototype.isActive=function(){return this._active};var Xn={0:1,2:2};(Y=function(t){this.reset(),this._clickTolerance=t.clickTolerance||1}).prototype.reset=function(){this._active=!1,this._moved=!1,delete this._lastPoint,delete this._eventButton},Y.prototype._correctButton=function(t,e){return!1},Y.prototype._move=function(t,e){return{}},Y.prototype.mousedown=function(t,e){var r;this._lastPoint||(r=i.mouseButton(t),this._correctButton(t,r)&&(this._lastPoint=e,this._eventButton=r))},Y.prototype.mousemoveWindow=function(t,e){var i,r=this._lastPoint;if(r)if(t.preventDefault(),i=t,t=this._eventButton,t=Xn[t],void 0!==i.buttons&&(i.buttons&t)===t){if(this._moved||!(e.dist(r)<this._clickTolerance))return this._moved=!0,this._lastPoint=e,this._move(r,e)}else this.reset()},Y.prototype.mouseupWindow=function(t){this._lastPoint&&i.mouseButton(t)===this._eventButton&&(this._moved&&i.suppressClick(),this.reset())},Y.prototype.enable=function(){this._enabled=!0},Y.prototype.disable=function(){this._enabled=!1,this.reset()},Y.prototype.isEnabled=function(){return this._enabled},Y.prototype.isActive=function(){return this._active};var Yn,Jn=((Yn=Y)&&(Qn.__proto__=Yn),((Qn.prototype=Object.create(Yn&&Yn.prototype)).constructor=Qn).prototype.mousedown=function(t,e){Yn.prototype.mousedown.call(this,t,e),this._lastPoint&&(this._active=!0)},Qn.prototype._correctButton=function(t,e){return 0===e&&!t.ctrlKey},Qn.prototype._move=function(t,e){return{around:e,panDelta:e.sub(t)}},Qn);function Qn(){Yn.apply(this,arguments)}var $n,to=(($n=Y)&&(eo.__proto__=$n),((eo.prototype=Object.create($n&&$n.prototype)).constructor=eo).prototype._correctButton=function(t,e){return 0===e&&t.ctrlKey||2===e},eo.prototype._move=function(t,e){if(t=.8*(e.x-t.x))return this._active=!0,{bearingDelta:t}},eo.prototype.contextmenu=function(t){t.preventDefault()},eo);function eo(){$n.apply(this,arguments)}var io,ro=((io=Y)&&(no.__proto__=io),((no.prototype=Object.create(io&&io.prototype)).constructor=no).prototype._correctButton=function(t,e){return 0===e&&t.ctrlKey||2===e},no.prototype._move=function(t,e){if(t=-.5*(e.y-t.y))return this._active=!0,{pitchDelta:t}},no.prototype.contextmenu=function(t){t.preventDefault()},no);function no(){io.apply(this,arguments)}function oo(t){this._minTouches=1,this._clickTolerance=t.clickTolerance||1,this.reset()}function ao(t,e,i){for(var r=0;r<t.length;r++)if(t[r].identifier===i)return e[r]}function so(t,e){return Math.log(t/e)/Math.LN2}oo.prototype.reset=function(){this._active=!1,this._touches={},this._sum=new t.Point(0,0)},oo.prototype.touchstart=function(t,e,i){return this._calculateTransform(t,e,i)},oo.prototype.touchmove=function(t,e,i){if(this._active&&!(i.length<this._minTouches))return t.preventDefault(),this._calculateTransform(t,e,i)},oo.prototype.touchend=function(t,e,i){this._calculateTransform(t,e,i),this._active&&i.length<this._minTouches&&this.reset()},oo.prototype.touchcancel=function(){this.reset()},oo.prototype._calculateTransform=function(e,i,r){0<r.length&&(this._active=!0);var n,o=Gn(r,i),a=new t.Point(0,0),s=new t.Point(0,0),l=0;for(n in o){var u=o[n],c=this._touches[n];c&&(a._add(u),s._add(u.sub(c)),l++,o[n]=u)}if(this._touches=o,!(l<this._minTouches)&&s.mag()&&(i=s.div(l),this._sum._add(i),!(this._sum.mag()<this._clickTolerance)))return{around:a.div(l),panDelta:i}},oo.prototype.enable=function(){this._enabled=!0},oo.prototype.disable=function(){this._enabled=!1,this.reset()},oo.prototype.isEnabled=function(){return this._enabled},oo.prototype.isActive=function(){return this._active},(zr=function(){this.reset()}).prototype.reset=function(){this._active=!1,delete this._firstTwoTouches},zr.prototype._start=function(t){},zr.prototype._move=function(t,e,i){return{}},zr.prototype.touchstart=function(t,e,i){this._firstTwoTouches||i.length<2||(this._firstTwoTouches=[i[0].identifier,i[1].identifier],this._start([e[0],e[1]]))},zr.prototype.touchmove=function(t,e,i){if(this._firstTwoTouches){t.preventDefault();var r=(n=this._firstTwoTouches)[0],n=n[1];r=ao(i,e,r),e=ao(i,e,n);if(r&&e)return n=this._aroundCenter?null:r.add(e).div(2),this._move([r,e],n,t)}},zr.prototype.touchend=function(t,e,r){var n,o;this._firstTwoTouches&&(n=(o=this._firstTwoTouches)[0],o=o[1],n=ao(r,e,n),o=ao(r,e,o),n&&o||(this._active&&i.suppressClick(),this.reset()))},zr.prototype.touchcancel=function(){this.reset()},zr.prototype.enable=function(t){this._enabled=!0,this._aroundCenter=!!t&&"center"===t.around},zr.prototype.disable=function(){this._enabled=!1,this.reset()},zr.prototype.isEnabled=function(){return this._enabled},zr.prototype.isActive=function(){return this._active};var lo,uo=((lo=zr)&&(co.__proto__=lo),((co.prototype=Object.create(lo&&lo.prototype)).constructor=co).prototype.reset=function(){lo.prototype.reset.call(this),delete this._distance,delete this._startDistance},co.prototype._start=function(t){this._startDistance=this._distance=t[0].dist(t[1])},co.prototype._move=function(t,e){var i=this._distance;if(this._distance=t[0].dist(t[1]),this._active||!(Math.abs(so(this._distance,this._startDistance))<.1))return this._active=!0,{zoomDelta:so(this._distance,i),pinchAround:e}},co);function co(){lo.apply(this,arguments)}function po(t,e){return 180*t.angleWith(e)/Math.PI}var ho,fo=((ho=zr)&&(mo.__proto__=ho),((mo.prototype=Object.create(ho&&ho.prototype)).constructor=mo).prototype.reset=function(){ho.prototype.reset.call(this),delete this._minDiameter,delete this._startVector,delete this._vector},mo.prototype._start=function(t){this._startVector=this._vector=t[0].sub(t[1]),this._minDiameter=t[0].dist(t[1])},mo.prototype._move=function(t,e){var i=this._vector;if(this._vector=t[0].sub(t[1]),this._active||!this._isBelowThreshold(this._vector))return this._active=!0,{bearingDelta:po(this._vector,i),pinchAround:e}},mo.prototype._isBelowThreshold=function(t){this._minDiameter=Math.min(this._minDiameter,t.mag());var e=25/(Math.PI*this._minDiameter)*360;t=po(t,this._startVector);return Math.abs(t)<e},mo);function mo(){ho.apply(this,arguments)}function yo(t){return Math.abs(t.y)>Math.abs(t.x)}var go,vo=((go=zr)&&(_o.__proto__=go),((_o.prototype=Object.create(go&&go.prototype)).constructor=_o).prototype.reset=function(){go.prototype.reset.call(this),this._valid=void 0,delete this._firstMove,delete this._lastPoints},_o.prototype._start=function(t){yo((this._lastPoints=t)[0].sub(t[1]))&&(this._valid=!1)},_o.prototype._move=function(t,e,i){var r=t[0].sub(this._lastPoints[0]),n=t[1].sub(this._lastPoints[1]);if(this._valid=this.gestureBeginsVertically(r,n,i.timeStamp),this._valid)return this._lastPoints=t,this._active=!0,{pitchDelta:(r.y+n.y)/2*-.5}},_o.prototype.gestureBeginsVertically=function(t,e,i){if(void 0!==this._valid)return this._valid;var r=2<=t.mag(),n=2<=e.mag();return r||n?r&&n?(i=0<t.y==0<e.y,yo(t)&&yo(e)&&i):(void 0===this._firstMove&&(this._firstMove=i),i-this._firstMove<100&&void 0):void 0},_o);function _o(){go.apply(this,arguments)}function xo(){var t=bo;this._panStep=t.panStep,this._bearingStep=t.bearingStep,this._pitchStep=t.pitchStep,this._rotationDisabled=!1}var bo={panStep:100,bearingStep:15,pitchStep:10};function wo(t){return t*(2-t)}function So(e,i){this._map=e,this._el=e.getCanvasContainer(),this._handler=i,this._delta=0,this._defaultZoomRate=.01,this._wheelZoomRate=1/450,t.bindAll(["_onTimeout"],this)}xo.prototype.reset=function(){this._active=!1},xo.prototype.keydown=function(t){var e=this;if(!(t.altKey||t.ctrlKey||t.metaKey)){var i=0,r=0,n=0,o=0,a=0;switch(t.keyCode){case 61:case 107:case 171:case 187:i=1;break;case 189:case 109:case 173:i=-1;break;case 37:t.shiftKey?r=-1:(t.preventDefault(),o=-1);break;case 39:t.shiftKey?r=1:(t.preventDefault(),o=1);break;case 38:t.shiftKey?n=1:(t.preventDefault(),a=-1);break;case 40:t.shiftKey?n=-1:(t.preventDefault(),a=1);break;default:return}return this._rotationDisabled&&(n=r=0),{cameraAnimation:function(s){var l=s.getZoom();s.easeTo({duration:300,easeId:"keyboardHandler",easing:wo,zoom:i?Math.round(l)+i*(t.shiftKey?2:1):l,bearing:s.getBearing()+r*e._bearingStep,pitch:s.getPitch()+n*e._pitchStep,offset:[-o*e._panStep,-a*e._panStep],center:s.getCenter()},{originalEvent:t})}}}},xo.prototype.enable=function(){this._enabled=!0},xo.prototype.disable=function(){this._enabled=!1,this.reset()},xo.prototype.isEnabled=function(){return this._enabled},xo.prototype.isActive=function(){return this._active},xo.prototype.disableRotation=function(){this._rotationDisabled=!0},xo.prototype.enableRotation=function(){this._rotationDisabled=!1};var To=4.000244140625;function Co(t,e){this._clickZoom=t,this._tapZoom=e}function Eo(){this.reset()}function Io(){this._tap=new Wn({numTouches:1,numTaps:1}),this.reset()}function ko(t,e,i){this._el=t,this._mousePan=e,this._touchPan=i}function Ao(t,e,i){this._pitchWithRotate=t.pitchWithRotate,this._mouseRotate=e,this._mousePitch=i}function Po(t,e,i,r){this._el=t,this._touchZoom=e,this._touchRotate=i,this._tapDragZoom=r,this._rotationDisabled=!1,this._enabled=!0}function Mo(t){return t.zoom||t.drag||t.pitch||t.rotate}So.prototype.setZoomRate=function(t){this._defaultZoomRate=t},So.prototype.setWheelZoomRate=function(t){this._wheelZoomRate=t},So.prototype.isEnabled=function(){return!!this._enabled},So.prototype.isActive=function(){return!!this._active||void 0!==this._finishTimeout},So.prototype.isZooming=function(){return!!this._zooming},So.prototype.enable=function(t){this.isEnabled()||(this._enabled=!0,this._aroundCenter=t&&"center"===t.around)},So.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1)},So.prototype.wheel=function(e){var i,r,n;this.isEnabled()&&(i=e.deltaMode===t.window.WheelEvent.DOM_DELTA_LINE?40*e.deltaY:e.deltaY,n=(r=t.browser.now())-(this._lastWheelEventTime||0),this._lastWheelEventTime=r,0!==i&&i%To==0?this._type="wheel":0!==i&&Math.abs(i)<4?this._type="trackpad":400<n?(this._type=null,this._lastValue=i,this._timeout=setTimeout(this._onTimeout,40,e)):this._type||(this._type=Math.abs(n*i)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,i+=this._lastValue)),e.shiftKey&&i&&(i/=4),this._type&&(this._lastWheelEvent=e,this._delta-=i,this._active||this._start(e)),e.preventDefault())},So.prototype._onTimeout=function(t){this._type="wheel",this._delta-=this._lastValue,this._active||this._start(t)},So.prototype._start=function(e){this._delta&&(this._frameId&&(this._frameId=null),this._active=!0,this.isZooming()||(this._zooming=!0),this._finishTimeout&&(clearTimeout(this._finishTimeout),delete this._finishTimeout),e=i.mousePos(this._el,e),this._around=t.LngLat.convert(this._aroundCenter?this._map.getCenter():this._map.unproject(e)),this._aroundPoint=this._map.transform.locationPoint(this._around),this._frameId||(this._frameId=!0,this._handler._triggerRenderFrame()))},So.prototype.renderFrame=function(){var e=this;if(this._frameId&&(this._frameId=null,this.isActive())){var i=this._map.transform;0!==this._delta&&(o="wheel"===this._type&&Math.abs(this._delta)>To?this._wheelZoomRate:this._defaultZoomRate,s=2/(1+Math.exp(-Math.abs(this._delta*o))),this._delta<0&&0!==s&&(s=1/s),a="number"==typeof this._targetZoom?i.zoomScale(this._targetZoom):i.scale,this._targetZoom=Math.min(i.maxZoom,Math.max(i.minZoom,i.scaleZoom(a*s))),"wheel"===this._type&&(this._startZoom=i.zoom,this._easing=this._smoothOutEasing(200)),this._delta=0);var r,n="number"==typeof this._targetZoom?this._targetZoom:i.zoom,o=this._startZoom,a=this._easing,s=!1;return"wheel"===this._type&&o&&a?(r=a(a=Math.min((t.browser.now()-this._lastWheelEventTime)/200,1)),r=t.number(o,n,r),a<1?this._frameId||(this._frameId=!0):s=!0):(r=n,s=!0),this._active=!0,s&&(this._active=!1,this._finishTimeout=setTimeout(function(){e._zooming=!1,e._handler._triggerRenderFrame(),delete e._targetZoom,delete e._finishTimeout},200)),{noInertia:!0,needsRenderFrame:!s,zoomDelta:r-i.zoom,around:this._aroundPoint,originalEvent:this._lastWheelEvent}}},So.prototype._smoothOutEasing=function(e){var i,r,n=t.ease;return this._prevEase&&(r=this._prevEase,i=(t.browser.now()-r.start)/r.duration,r=r.easing(.01+i)-r.easing(i),i=.27/Math.sqrt(r*r+1e-4)*.01,r=Math.sqrt(.0729-i*i),n=t.bezier(i,r,.25,1)),this._prevEase={start:t.browser.now(),duration:e,easing:n},n},So.prototype.reset=function(){this._active=!1},Co.prototype.enable=function(){this._clickZoom.enable(),this._tapZoom.enable()},Co.prototype.disable=function(){this._clickZoom.disable(),this._tapZoom.disable()},Co.prototype.isEnabled=function(){return this._clickZoom.isEnabled()&&this._tapZoom.isEnabled()},Co.prototype.isActive=function(){return this._clickZoom.isActive()||this._tapZoom.isActive()},Eo.prototype.reset=function(){this._active=!1},Eo.prototype.dblclick=function(t,e){return t.preventDefault(),{cameraAnimation:function(i){i.easeTo({duration:300,zoom:i.getZoom()+(t.shiftKey?-1:1),around:i.unproject(e)},{originalEvent:t})}}},Eo.prototype.enable=function(){this._enabled=!0},Eo.prototype.disable=function(){this._enabled=!1,this.reset()},Eo.prototype.isEnabled=function(){return this._enabled},Eo.prototype.isActive=function(){return this._active},Io.prototype.reset=function(){this._active=!1,delete this._swipePoint,delete this._swipeTouch,delete this._tapTime,this._tap.reset()},Io.prototype.touchstart=function(t,e,i){this._swipePoint||(this._tapTime&&500<t.timeStamp-this._tapTime&&this.reset(),this._tapTime?0<i.length&&(this._swipePoint=e[0],this._swipeTouch=i[0].identifier):this._tap.touchstart(t,e,i))},Io.prototype.touchmove=function(t,e,i){if(this._tapTime){if(this._swipePoint&&i[0].identifier===this._swipeTouch){var r=e[0],n=r.y-this._swipePoint.y;return this._swipePoint=r,t.preventDefault(),this._active=!0,{zoomDelta:n/128}}}else this._tap.touchmove(t,e,i)},Io.prototype.touchend=function(t,e,i){this._tapTime?this._swipePoint&&0===i.length&&this.reset():this._tap.touchend(t,e,i)&&(this._tapTime=t.timeStamp)},Io.prototype.touchcancel=function(){this.reset()},Io.prototype.enable=function(){this._enabled=!0},Io.prototype.disable=function(){this._enabled=!1,this.reset()},Io.prototype.isEnabled=function(){return this._enabled},Io.prototype.isActive=function(){return this._active},ko.prototype.enable=function(t){this._inertiaOptions=t||{},this._mousePan.enable(),this._touchPan.enable(),this._el.classList.add("mapboxgl-touch-drag-pan")},ko.prototype.disable=function(){this._mousePan.disable(),this._touchPan.disable(),this._el.classList.remove("mapboxgl-touch-drag-pan")},ko.prototype.isEnabled=function(){return this._mousePan.isEnabled()&&this._touchPan.isEnabled()},ko.prototype.isActive=function(){return this._mousePan.isActive()||this._touchPan.isActive()},Ao.prototype.enable=function(){this._mouseRotate.enable(),this._pitchWithRotate&&this._mousePitch.enable()},Ao.prototype.disable=function(){this._mouseRotate.disable(),this._mousePitch.disable()},Ao.prototype.isEnabled=function(){return this._mouseRotate.isEnabled()&&(!this._pitchWithRotate||this._mousePitch.isEnabled())},Ao.prototype.isActive=function(){return this._mouseRotate.isActive()||this._mousePitch.isActive()},Po.prototype.enable=function(t){this._touchZoom.enable(t),this._rotationDisabled||this._touchRotate.enable(t),this._tapDragZoom.enable(),this._el.classList.add("mapboxgl-touch-zoom-rotate")},Po.prototype.disable=function(){this._touchZoom.disable(),this._touchRotate.disable(),this._tapDragZoom.disable(),this._el.classList.remove("mapboxgl-touch-zoom-rotate")},Po.prototype.isEnabled=function(){return this._touchZoom.isEnabled()&&(this._rotationDisabled||this._touchRotate.isEnabled())&&this._tapDragZoom.isEnabled()},Po.prototype.isActive=function(){return this._touchZoom.isActive()||this._touchRotate.isActive()||this._tapDragZoom.isActive()},Po.prototype.disableRotation=function(){this._rotationDisabled=!0,this._touchRotate.disable()},Po.prototype.enableRotation=function(){this._rotationDisabled=!1,this._touchZoom.isEnabled()&&this._touchRotate.enable()};var Lo,Oo=((Lo=t.Event)&&(Ro.__proto__=Lo),(Ro.prototype=Object.create(Lo&&Lo.prototype)).constructor=Ro);function Ro(){Lo.apply(this,arguments)}function zo(t){return t.panDelta&&t.panDelta.mag()||t.zoomDelta||t.bearingDelta||t.pitchDelta}function Do(e,r){this._map=e,this._el=this._map.getCanvasContainer(),this._handlers=[],this._handlersById={},this._changes=[],this._inertia=new Ln(e),this._bearingSnap=r.bearingSnap,this._previousActiveHandlers={},this._eventsInProgress={},this._addDefaultHandlers(r),t.bindAll(["handleEvent","handleWindowEvent"],this),r=this._el,this._listeners=[[r,"touchstart",{passive:!0}],[r,"touchmove",{passive:!1}],[r,"touchend",void 0],[r,"touchcancel",void 0],[r,"mousedown",void 0],[r,"mousemove",void 0],[r,"mouseup",void 0],[t.window.document,"mousemove",{capture:!0}],[t.window.document,"mouseup",void 0],[r,"mouseover",void 0],[r,"mouseout",void 0],[r,"dblclick",void 0],[r,"click",void 0],[r,"keydown",{capture:!1}],[r,"keyup",void 0],[r,"wheel",{passive:!1}],[r,"contextmenu",void 0],[t.window,"blur",void 0]];for(var n=0,o=this._listeners;n<o.length;n+=1){var a=(l=o[n])[0],s=l[1],l=l[2];i.addEventListener(a,s,a===t.window.document?this.handleWindowEvent:this.handleEvent,l)}}Do.prototype.destroy=function(){for(var e=0,r=this._listeners;e<r.length;e+=1){var n=(a=r[e])[0],o=a[1],a=a[2];i.removeEventListener(n,o,n===t.window.document?this.handleWindowEvent:this.handleEvent,a)}},Do.prototype._addDefaultHandlers=function(t){var e=this._map,i=e.getCanvasContainer();this._add("mapEvent",new Fn(e,t));var r=e.boxZoom=new Hn(e,t);this._add("boxZoom",r);var n=new Kn,o=new Eo;e.doubleClickZoom=new Co(o,n),this._add("tapZoom",n),this._add("clickZoom",o),r=new Io,this._add("tapDragZoom",r),n=e.touchPitch=new vo,this._add("touchPitch",n),o=new to(t),n=new ro(t),e.dragRotate=new Ao(t,o,n),this._add("mouseRotate",o,["mousePitch"]),this._add("mousePitch",n,["mouseRotate"]),o=new Jn(t),n=new oo(t),e.dragPan=new ko(i,o,n),this._add("mousePan",o),this._add("touchPan",n,["touchZoom","touchRotate"]),o=new fo,n=new uo,e.touchZoomRotate=new Po(i,n,o,r),this._add("touchRotate",o,["touchPan","touchZoom"]),this._add("touchZoom",n,["touchPan","touchRotate"]),n=e.scrollZoom=new So(e,this),this._add("scrollZoom",n,["mousePan"]),n=e.keyboard=new xo,this._add("keyboard",n),this._add("blockableMapEvent",new qn(e));for(var a=0,s=["boxZoom","doubleClickZoom","tapDragZoom","touchPitch","dragRotate","dragPan","touchZoomRotate","scrollZoom","keyboard"];a<s.length;a+=1){var l=s[a];t.interactive&&t[l]&&e[l].enable(t[l])}},Do.prototype._add=function(t,e,i){this._handlers.push({handlerName:t,handler:e,allowed:i}),this._handlersById[t]=e},Do.prototype.stop=function(t){if(!this._updatingCamera){for(var e=0,i=this._handlers;e<i.length;e+=1)i[e].handler.reset();this._inertia.clear(),this._fireEvents({},{},t),this._changes=[]}},Do.prototype.isActive=function(){for(var t=0,e=this._handlers;t<e.length;t+=1)if(e[t].handler.isActive())return!0;return!1},Do.prototype.isZooming=function(){return!!this._eventsInProgress.zoom||this._map.scrollZoom.isZooming()},Do.prototype.isRotating=function(){return!!this._eventsInProgress.rotate},Do.prototype.isMoving=function(){return Boolean(Mo(this._eventsInProgress))||this.isZooming()},Do.prototype._blockedByActive=function(t,e,i){for(var r in t)if(r!==i&&(!e||e.indexOf(r)<0))return!0;return!1},Do.prototype.handleWindowEvent=function(t){this.handleEvent(t,t.type+"Window")},Do.prototype._getMapTouches=function(t){for(var e=[],i=0,r=t;i<r.length;i+=1){var n=r[i],o=n.target;this._el.contains(o)&&e.push(n)}return e},Do.prototype.handleEvent=function(t,e){if("blur"!==t.type){this._updatingCamera=!0;for(var r="renderFrame"===t.type?void 0:t,n={needsRenderFrame:!1},o={},a={},s=t.touches?this._getMapTouches(t.touches):void 0,l=s?i.touchPos(this._el,s):i.mousePos(this._el,t),u=0,c=this._handlers;u<c.length;u+=1){var p=c[u],h=p.handlerName,d=p.handler,f=p.allowed;d.isEnabled()&&(p=void 0,this._blockedByActive(a,f,h)?d.reset():d[e||t.type]&&(p=d[e||t.type](t,l,s),this.mergeHandlerResult(n,o,p,h,r),p&&p.needsRenderFrame&&this._triggerRenderFrame()),(p||d.isActive())&&(a[h]=d))}var m,y={};for(m in this._previousActiveHandlers)a[m]||(y[m]=r);this._previousActiveHandlers=a,(Object.keys(y).length||zo(n))&&(this._changes.push([n,o,y]),this._triggerRenderFrame()),(Object.keys(a).length||zo(n))&&this._map._stop(!0),this._updatingCamera=!1;var g=n.cameraAnimation;g&&(this._inertia.clear(),this._fireEvents({},{},!0),this._changes=[],g(this._map))}else this.stop(!0)},Do.prototype.mergeHandlerResult=function(e,i,r,n,o){r&&(t.extend(e,r),o={handlerName:n,originalEvent:r.originalEvent||o},void 0!==r.zoomDelta&&(i.zoom=o),void 0!==r.panDelta&&(i.drag=o),void 0!==r.pitchDelta&&(i.pitch=o),void 0!==r.bearingDelta&&(i.rotate=o))},Do.prototype._applyChanges=function(){for(var e={},i={},r={},n=0,o=this._changes;n<o.length;n+=1){var a=(l=o[n])[0],s=l[1],l=l[2];a.panDelta&&(e.panDelta=(e.panDelta||new t.Point(0,0))._add(a.panDelta)),a.zoomDelta&&(e.zoomDelta=(e.zoomDelta||0)+a.zoomDelta),a.bearingDelta&&(e.bearingDelta=(e.bearingDelta||0)+a.bearingDelta),a.pitchDelta&&(e.pitchDelta=(e.pitchDelta||0)+a.pitchDelta),void 0!==a.around&&(e.around=a.around),void 0!==a.pinchAround&&(e.pinchAround=a.pinchAround),a.noInertia&&(e.noInertia=a.noInertia),t.extend(i,s),t.extend(r,l)}this._updateMapTransform(e,i,r),this._changes=[]},Do.prototype._updateMapTransform=function(t,e,i){var r=this._map,n=r.transform;if(!zo(t))return this._fireEvents(e,i,!0);var o=t.panDelta,a=t.zoomDelta,s=t.bearingDelta,l=t.pitchDelta,u=t.around,c=t.pinchAround;void 0!==c&&(u=c),r._stop(!0),u=u||r.transform.centerPoint,o=n.pointLocation(o?u.sub(o):u),s&&(n.bearing+=s),l&&(n.pitch+=l),a&&(n.zoom+=a),n.setLocationAtPoint(o,u),this._map._update(),t.noInertia||this._inertia.record(t),this._fireEvents(e,i,!0)},Do.prototype._fireEvents=function(e,i,r){var n,o,a,s=this,l=Mo(this._eventsInProgress),u=Mo(e),c={};for(n in e){var p=e[n].originalEvent;this._eventsInProgress[n]||(c[n+"start"]=p),this._eventsInProgress[n]=e[n]}for(o in!l&&u&&this._fireEvent("movestart",u.originalEvent),c)this._fireEvent(o,c[o]);for(a in u&&this._fireEvent("move",u.originalEvent),e){var h=e[a].originalEvent;this._fireEvent(a,h)}var d,f,m,y={};for(f in this._eventsInProgress){var g=(v=this._eventsInProgress[f]).handlerName,v=v.originalEvent;this._handlersById[g].isActive()||(delete this._eventsInProgress[f],d=i[g]||v,y[f+"end"]=d)}for(m in y)this._fireEvent(m,y[m]);var _=Mo(this._eventsInProgress);r&&(l||u)&&!_&&(this._updatingCamera=!0,u=function(t){return 0!==t&&-s._bearingSnap<t&&t<s._bearingSnap},(_=this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions))?(u(_.bearing||this._map.getBearing())&&(_.bearing=0),this._map.easeTo(_,{originalEvent:d})):(this._map.fire(new t.Event("moveend",{originalEvent:d})),u(this._map.getBearing())&&this._map.resetNorth()),this._updatingCamera=!1)},Do.prototype._fireEvent=function(e,i){this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},Do.prototype._requestFrame=function(){var t=this;return this._map.triggerRepaint(),this._map._renderTaskQueue.add(function(e){delete t._frameId,t.handleEvent(new Oo("renderFrame",{timeStamp:e})),t._applyChanges()})},Do.prototype._triggerRenderFrame=function(){void 0===this._frameId&&(this._frameId=this._requestFrame())};var No;(No=t.Evented)&&(Bo.__proto__=No),((Bo.prototype=Object.create(No&&No.prototype)).constructor=Bo).prototype.getCenter=function(){return new t.LngLat(this.transform.center.lng,this.transform.center.lat)},Bo.prototype.setCenter=function(t,e){return this.jumpTo({center:t},e)},Bo.prototype.panBy=function(e,i,r){return e=t.Point.convert(e).mult(-1),this.panTo(this.transform.center,t.extend({offset:e},i),r)},Bo.prototype.panTo=function(e,i,r){return this.easeTo(t.extend({center:e},i),r)},Bo.prototype.getZoom=function(){return this.transform.zoom},Bo.prototype.setZoom=function(t,e){return this.jumpTo({zoom:t},e),this},Bo.prototype.zoomTo=function(e,i,r){return this.easeTo(t.extend({zoom:e},i),r)},Bo.prototype.zoomIn=function(t,e){return this.zoomTo(this.getZoom()+1,t,e),this},Bo.prototype.zoomOut=function(t,e){return this.zoomTo(this.getZoom()-1,t,e),this},Bo.prototype.getBearing=function(){return this.transform.bearing},Bo.prototype.setBearing=function(t,e){return this.jumpTo({bearing:t},e),this},Bo.prototype.getPadding=function(){return this.transform.padding},Bo.prototype.setPadding=function(t,e){return this.jumpTo({padding:t},e),this},Bo.prototype.rotateTo=function(e,i,r){return this.easeTo(t.extend({bearing:e},i),r)},Bo.prototype.resetNorth=function(e,i){return this.rotateTo(0,t.extend({duration:1e3},e),i),this},Bo.prototype.resetNorthPitch=function(e,i){return this.easeTo(t.extend({bearing:0,pitch:0,duration:1e3},e),i),this},Bo.prototype.snapToNorth=function(t,e){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(t,e):this},Bo.prototype.getPitch=function(){return this.transform.pitch},Bo.prototype.setPitch=function(t,e){return this.jumpTo({pitch:t},e),this},Bo.prototype.cameraForBounds=function(e,i){e=t.LngLatBounds.convert(e);var r=i&&i.bearing||0;return this._cameraForBoxAndBearing(e.getNorthWest(),e.getSouthEast(),r,i)},Bo.prototype._cameraForBoxAndBearing=function(e,i,r,n){var o={top:0,bottom:0,right:0,left:0};"number"==typeof(n=t.extend({padding:o,offset:[0,0],maxZoom:this.transform.maxZoom},n)).padding&&(u=n.padding,n.padding={top:u,bottom:u,right:u,left:u}),n.padding=t.extend(o,n.padding);var a=this.transform,s=a.padding,l=a.project(t.LngLat.convert(e)),u=a.project(t.LngLat.convert(i));o=l.rotate(-r*Math.PI/180),e=u.rotate(-r*Math.PI/180),i=new t.Point(Math.max(o.x,e.x),Math.max(o.y,e.y)),e=new t.Point(Math.min(o.x,e.x),Math.min(o.y,e.y)),i=i.sub(e),e=(a.width-(s.left+s.right+n.padding.left+n.padding.right))/i.x;if(!((s=(a.height-(s.top+s.bottom+n.padding.top+n.padding.bottom))/i.y)<0||e<0))return i=Math.min(a.scaleZoom(a.scale*Math.min(e,s)),n.maxZoom),e="number"==typeof n.offset.x?new t.Point(n.offset.x,n.offset.y):t.Point.convert(n.offset),s=(n.padding.left-n.padding.right)/2,n=(n.padding.top-n.padding.bottom)/2,n=new t.Point(s,n).rotate(r*Math.PI/180),n=e.add(n).mult(a.scale/a.zoomScale(i)),{center:a.unproject(l.add(u).div(2).sub(n)),zoom:i,bearing:r};t.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.")},Bo.prototype.fitBounds=function(t,e,i){return this._fitInternal(this.cameraForBounds(t,e),e,i)},Bo.prototype.fitScreenCoordinates=function(e,i,r,n,o){return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t.Point.convert(e)),this.transform.pointLocation(t.Point.convert(i)),r,n),n,o)},Bo.prototype._fitInternal=function(e,i,r){return e?(delete(i=t.extend(e,i)).padding,i.linear?this.easeTo(i,r):this.flyTo(i,r)):this},Bo.prototype.jumpTo=function(e,i){this.stop();var r=this.transform,n=!1,o=!1,a=!1;return"zoom"in e&&r.zoom!==+e.zoom&&(n=!0,r.zoom=+e.zoom),void 0!==e.center&&(r.center=t.LngLat.convert(e.center)),"bearing"in e&&r.bearing!==+e.bearing&&(o=!0,r.bearing=+e.bearing),"pitch"in e&&r.pitch!==+e.pitch&&(a=!0,r.pitch=+e.pitch),null==e.padding||r.isPaddingEqual(e.padding)||(r.padding=e.padding),this.fire(new t.Event("movestart",i)).fire(new t.Event("move",i)),n&&this.fire(new t.Event("zoomstart",i)).fire(new t.Event("zoom",i)).fire(new t.Event("zoomend",i)),o&&this.fire(new t.Event("rotatestart",i)).fire(new t.Event("rotate",i)).fire(new t.Event("rotateend",i)),a&&this.fire(new t.Event("pitchstart",i)).fire(new t.Event("pitch",i)).fire(new t.Event("pitchend",i)),this.fire(new t.Event("moveend",i))},Bo.prototype.easeTo=function(e,i){var r=this;this._stop(!1,e.easeId),(!1===(e=t.extend({offset:[0,0],duration:500,easing:t.ease},e)).animate||!e.essential&&t.browser.prefersReducedMotion)&&(e.duration=0);var n=this.transform,o=this.getZoom(),a=this.getBearing(),s=this.getPitch(),l=this.getPadding(),u="zoom"in e?+e.zoom:o,c="bearing"in e?this._normalizeBearing(e.bearing,a):a,p="pitch"in e?+e.pitch:s,h=("padding"in e?e:n).padding,d=t.Point.convert(e.offset),f=n.centerPoint.add(d),m=n.pointLocation(f),y=t.LngLat.convert(e.center||m);this._normalizeCenter(y);var g,v,_=n.project(m),x=n.project(y).sub(_),b=n.zoomScale(u-o);return e.around&&(g=t.LngLat.convert(e.around),v=n.locationPoint(g)),y={moving:this._moving,zooming:this._zooming,rotating:this._rotating,pitching:this._pitching},this._zooming=this._zooming||u!==o,this._rotating=this._rotating||a!==c,this._pitching=this._pitching||p!==s,this._padding=!n.isPaddingEqual(h),this._easeId=e.easeId,this._prepareEase(i,e.noMoveStart,y),this._ease(function(e){var m,y;r._zooming&&(n.zoom=t.number(o,u,e)),r._rotating&&(n.bearing=t.number(a,c,e)),r._pitching&&(n.pitch=t.number(s,p,e)),r._padding&&(n.interpolatePadding(l,h,e),f=n.centerPoint.add(d)),g?n.setLocationAtPoint(g,v):(y=n.zoomScale(n.zoom-o),m=o<u?Math.min(2,b):Math.max(.5,b),m=Math.pow(m,1-e),y=n.unproject(_.add(x.mult(e*m)).mult(y)),n.setLocationAtPoint(n.renderWorldCopies?y.wrap():y,f)),r._fireMoveEvents(i)},function(t){r._afterEase(i,t)},e),this},Bo.prototype._prepareEase=function(e,i,r){void 0===r&&(r={}),this._moving=!0,i||r.moving||this.fire(new t.Event("movestart",e)),this._zooming&&!r.zooming&&this.fire(new t.Event("zoomstart",e)),this._rotating&&!r.rotating&&this.fire(new t.Event("rotatestart",e)),this._pitching&&!r.pitching&&this.fire(new t.Event("pitchstart",e))},Bo.prototype._fireMoveEvents=function(e){this.fire(new t.Event("move",e)),this._zooming&&this.fire(new t.Event("zoom",e)),this._rotating&&this.fire(new t.Event("rotate",e)),this._pitching&&this.fire(new t.Event("pitch",e))},Bo.prototype._afterEase=function(e,i){var r,n;this._easeId&&i&&this._easeId===i||(delete this._easeId,r=this._zooming,n=this._rotating,i=this._pitching,this._moving=!1,this._zooming=!1,this._rotating=!1,this._pitching=!1,this._padding=!1,r&&this.fire(new t.Event("zoomend",e)),n&&this.fire(new t.Event("rotateend",e)),i&&this.fire(new t.Event("pitchend",e)),this.fire(new t.Event("moveend",e)))},Bo.prototype.flyTo=function(e,i){var r=this;if(!e.essential&&t.browser.prefersReducedMotion){var n=t.pick(e,["center","zoom","bearing","pitch","around"]);return this.jumpTo(n,i)}this.stop(),e=t.extend({offset:[0,0],speed:1.2,curve:1.42,easing:t.ease},e);var o=this.transform,a=this.getZoom(),s=this.getBearing(),l=this.getPitch(),u=this.getPadding(),c="zoom"in e?t.clamp(+e.zoom,o.minZoom,o.maxZoom):a,p="bearing"in e?this._normalizeBearing(e.bearing,s):s,h="pitch"in e?+e.pitch:l,d=("padding"in e?e:o).padding,f=o.zoomScale(c-a),m=t.Point.convert(e.offset),y=o.centerPoint.add(m),g=(n=o.pointLocation(y),t.LngLat.convert(e.center||n));this._normalizeCenter(g);var v=o.project(n),_=o.project(g).sub(v),x=e.curve,b=Math.max(o.width,o.height),w=b/f,S=_.mag();"minZoom"in e&&(k=t.clamp(Math.min(e.minZoom,a,c),o.minZoom,o.maxZoom),k=b/o.zoomScale(k-a),x=Math.sqrt(k/S*2));var T=x*x;function C(t){return t=(w*w-b*b+(t?-1:1)*T*T*S*S)/(2*(t?w:b)*T*S),Math.log(Math.sqrt(t*t+1)-t)}function E(t){return(Math.exp(t)-Math.exp(-t))/2}function I(t){return(Math.exp(t)+Math.exp(-t))/2}var k,A=C(0),P=function(t){return I(A)/I(A+x*t)},M=function(t){return b*((I(A)*(E(t=A+x*t)/I(t))-E(A))/T)/S},L=(C(1)-A)/x;if(Math.abs(S)<1e-6||!isFinite(L)){if(Math.abs(b-w)<1e-6)return this.easeTo(e,i);var O=w<b?-1:1;L=Math.abs(Math.log(w/b))/x,M=function(){return 0},P=function(t){return Math.exp(O*x*t)}}return"duration"in e?e.duration=+e.duration:(k="screenSpeed"in e?+e.screenSpeed/x:+e.speed,e.duration=1e3*L/k),e.maxDuration&&e.duration>e.maxDuration&&(e.duration=0),this._zooming=!0,this._rotating=s!==p,this._pitching=h!==l,this._padding=!o.isPaddingEqual(d),this._prepareEase(i,!1),this._ease(function(e){var n=e*L,f=1/P(n);o.zoom=1===e?c:a+o.scaleZoom(f),r._rotating&&(o.bearing=t.number(s,p,e)),r._pitching&&(o.pitch=t.number(l,h,e)),r._padding&&(o.interpolatePadding(u,d,e),y=o.centerPoint.add(m)),f=1===e?g:o.unproject(v.add(_.mult(M(n))).mult(f)),o.setLocationAtPoint(o.renderWorldCopies?f.wrap():f,y),r._fireMoveEvents(i)},function(){return r._afterEase(i)},e),this},Bo.prototype.isEasing=function(){return!!this._easeFrameId},Bo.prototype.stop=function(){return this._stop()},Bo.prototype._stop=function(t,e){var i;return this._easeFrameId&&(this._cancelRenderFrame(this._easeFrameId),delete this._easeFrameId,delete this._onEaseFrame),this._onEaseEnd&&(i=this._onEaseEnd,delete this._onEaseEnd,i.call(this,e)),t||(t=this.handlers)&&t.stop(!1),this},Bo.prototype._ease=function(e,i,r){!1===r.animate||0===r.duration?(e(1),i()):(this._easeStart=t.browser.now(),this._easeOptions=r,this._onEaseFrame=e,this._onEaseEnd=i,this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback))},Bo.prototype._renderFrameCallback=function(){var e=Math.min((t.browser.now()-this._easeStart)/this._easeOptions.duration,1);this._onEaseFrame(this._easeOptions.easing(e)),e<1?this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback):this.stop()},Bo.prototype._normalizeBearing=function(e,i){e=t.wrap(e,-180,180);var r=Math.abs(e-i);return Math.abs(e-360-i)<r&&(e-=360),Math.abs(e+360-i)<r&&(e+=360),e},Bo.prototype._normalizeCenter=function(t){var e=this.transform;e.renderWorldCopies&&!e.lngRange&&(e=t.lng-e.center.lng,t.lng+=180<e?-360:e<-180?360:0)},Ge=Bo;function Bo(e,i){No.call(this),this._moving=!1,this._zooming=!1,this.transform=e,this._bearingSnap=i.bearingSnap,t.bindAll(["_renderFrameCallback"],this)}function Fo(e){this.options=e=void 0===e?{}:e,t.bindAll(["_toggleAttribution","_updateEditLink","_updateData","_updateCompact"],this)}function Uo(){t.bindAll(["_updateLogo"],this),t.bindAll(["_updateCompact"],this)}function jo(){this._queue=[],this._id=0,this._cleared=!1,this._currentlyRunning=!1}Fo.prototype.getDefaultPosition=function(){return"bottom-right"},Fo.prototype.onAdd=function(t){var e=this.options&&this.options.compact;return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),this._compactButton=i.create("button","mapboxgl-ctrl-attrib-button",this._container),this._compactButton.addEventListener("click",this._toggleAttribution),this._setElementTitle(this._compactButton,"ToggleAttribution"),this._innerContainer=i.create("div","mapboxgl-ctrl-attrib-inner",this._container),this._innerContainer.setAttribute("role","list"),e&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("styledata",this._updateData),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===e&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container},Fo.prototype.onRemove=function(){i.remove(this._container),this._map.off("styledata",this._updateData),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0,this._attribHTML=void 0},Fo.prototype._setElementTitle=function(t,e){e=this._map._getUIString("AttributionControl."+e),t.title=e,t.setAttribute("aria-label",e)},Fo.prototype._toggleAttribution=function(){this._container.classList.contains("mapboxgl-compact-show")?(this._container.classList.remove("mapboxgl-compact-show"),this._compactButton.setAttribute("aria-pressed","false")):(this._container.classList.add("mapboxgl-compact-show"),this._compactButton.setAttribute("aria-pressed","true"))},Fo.prototype._updateEditLink=function(){var e,i=(i=this._editLink)||(this._editLink=this._container.querySelector(".mapbox-improve-map")),r=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:this._map._requestManager._customAccessToken||t.config.ACCESS_TOKEN}];i&&(e=r.reduce(function(t,e,i){return e.value&&(t+=e.key+"="+e.value+(i<r.length-1?"&":"")),t},"?"),i.href=t.config.FEEDBACK_URL+"/"+e+(this._map._hash?this._map._hash.getHashString(!0):""),i.rel="noopener nofollow",this._setElementTitle(i,"MapFeedback"))},Fo.prototype._updateData=function(t){!t||"metadata"!==t.sourceDataType&&"visibility"!==t.sourceDataType&&"style"!==t.dataType||(this._updateAttributions(),this._updateEditLink())},Fo.prototype._updateAttributions=function(){if(this._map.style){var t=[];this.options.customAttribution&&(Array.isArray(this.options.customAttribution)?t=t.concat(this.options.customAttribution.map(function(t){return"string"!=typeof t?"":t})):"string"==typeof this.options.customAttribution&&t.push(this.options.customAttribution)),this._map.style.stylesheet&&(n=this._map.style.stylesheet,this.styleOwner=n.owner,this.styleId=n.id);var e,i=this._map.style.sourceCaches;for(e in i){var r=i[e];!r.used||(r=r.getSource()).attribution&&t.indexOf(r.attribution)<0&&t.push(r.attribution)}t.sort(function(t,e){return t.length-e.length});var n=(t=t.filter(function(e,i){for(var r=i+1;r<t.length;r++)if(0<=t[r].indexOf(e))return!1;return!0})).join(" | ");n!==this._attribHTML&&(this._attribHTML=n,t.length?(this._innerContainer.innerHTML=n,this._container.classList.remove("mapboxgl-attrib-empty")):this._container.classList.add("mapboxgl-attrib-empty"),this._editLink=null)}},Fo.prototype._updateCompact=function(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact","mapboxgl-compact-show")},Uo.prototype.onAdd=function(t){return this._map=t,this._container=i.create("div","mapboxgl-ctrl"),(t=i.create("a","mapboxgl-ctrl-logo")).target="_blank",t.rel="noopener nofollow",t.href="https://www.mapbox.com/",t.setAttribute("aria-label",this._map._getUIString("LogoControl.Title")),t.setAttribute("rel","noopener nofollow"),this._container.appendChild(t),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._map.on("resize",this._updateCompact),this._updateCompact(),this._container},Uo.prototype.onRemove=function(){i.remove(this._container),this._map.off("sourcedata",this._updateLogo),this._map.off("resize",this._updateCompact)},Uo.prototype.getDefaultPosition=function(){return"bottom-left"},Uo.prototype._updateLogo=function(t){t&&"metadata"!==t.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none")},Uo.prototype._logoRequired=function(){if(this._map.style){var t,e=this._map.style.sourceCaches;for(t in e)if(e[t].getSource().mapbox_logo)return!0;return!1}},Uo.prototype._updateCompact=function(){var t=this._container.children;t.length&&(t=t[0],this._map.getCanvasContainer().offsetWidth<250?t.classList.add("mapboxgl-compact"):t.classList.remove("mapboxgl-compact"))},jo.prototype.add=function(t){var e=++this._id;return this._queue.push({callback:t,id:e,cancelled:!1}),e},jo.prototype.remove=function(t){for(var e=this._currentlyRunning,i=0,r=e?this._queue.concat(e):this._queue;i<r.length;i+=1){var n=r[i];if(n.id===t)return void(n.cancelled=!0)}},jo.prototype.run=function(t){void 0===t&&(t=0);var e=this._currentlyRunning=this._queue;this._queue=[];for(var i=0,r=e;i<r.length;i+=1){var n=r[i];if(!n.cancelled&&(n.callback(t),this._cleared))break}this._cleared=!1,this._currentlyRunning=!1};var Vo={"AttributionControl.ToggleAttribution":"Toggle attribution","AttributionControl.MapFeedback":"Map feedback","FullscreenControl.Enter":"Enter fullscreen","FullscreenControl.Exit":"Exit fullscreen","GeolocateControl.FindMyLocation":"Find my location","GeolocateControl.LocationNotAvailable":"Location not available","LogoControl.Title":"Mapbox logo","NavigationControl.ResetBearing":"Reset bearing to north","NavigationControl.ZoomIn":"Zoom in","NavigationControl.ZoomOut":"Zoom out","ScaleControl.Feet":"ft","ScaleControl.Meters":"m","ScaleControl.Kilometers":"km","ScaleControl.Miles":"mi","ScaleControl.NauticalMiles":"nm"},qo=t.window.HTMLImageElement,Ho=t.window.HTMLElement,Go=t.window.ImageBitmap,Zo={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:-2,maxZoom:22,minPitch:0,maxPitch:60,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,touchPitch:!0,bearingSnap:7,clickTolerance:3,pitchWithRotate:!0,hash:!(jo.prototype.clear=function(){this._currentlyRunning&&(this._cleared=!0),this._queue=[]}),attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,maxTileCacheSize:null,localIdeographFontFamily:"sans-serif",transformRequest:null,accessToken:null,fadeDuration:300,crossSourceCollisions:!0};fi=function(r){function n(e){var i=this;if(null!=(e=t.extend({},Zo,e)).minZoom&&null!=e.maxZoom&&e.minZoom>e.maxZoom)throw new Error("maxZoom must be greater than or equal to minZoom");if(null!=e.minPitch&&null!=e.maxPitch&&e.minPitch>e.maxPitch)throw new Error("maxPitch must be greater than or equal to minPitch");if(null!=e.minPitch&&e.minPitch<0)throw new Error("minPitch must be greater than or equal to 0");if(null!=e.maxPitch&&60<e.maxPitch)throw new Error("maxPitch must be less than or equal to 60");var n=new Pn(e.minZoom,e.maxZoom,e.minPitch,e.maxPitch,e.renderWorldCopies);if(r.call(this,n,e),this._interactive=e.interactive,this._maxTileCacheSize=e.maxTileCacheSize,this._failIfMajorPerformanceCaveat=e.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=e.preserveDrawingBuffer,this._antialias=e.antialias,this._trackResize=e.trackResize,this._bearingSnap=e.bearingSnap,this._refreshExpiredTiles=e.refreshExpiredTiles,this._fadeDuration=e.fadeDuration,this._crossSourceCollisions=e.crossSourceCollisions,this._crossFadingFactor=1,this._collectResourceTiming=e.collectResourceTiming,this._renderTaskQueue=new jo,this._controls=[],this._mapId=t.uniqueId(),this._locale=t.extend({},Vo,e.locale),this._clickTolerance=e.clickTolerance,this._requestManager=new t.RequestManager(e.transformRequest,e.accessToken),"string"==typeof e.container){if(this._container=t.window.document.getElementById(e.container),!this._container)throw new Error("Container '"+e.container+"' not found.")}else{if(!(e.container instanceof Ho))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=e.container}if(e.maxBounds&&this.setMaxBounds(e.maxBounds),t.bindAll(["_onWindowOnline","_onWindowResize","_onMapScroll","_contextLost","_contextRestored"],this),this._setupContainer(),this._setupPainter(),void 0===this.painter)throw new Error("Failed to initialize WebGL.");this.on("move",function(){return i._update(!1)}),this.on("moveend",function(){return i._update(!1)}),this.on("zoom",function(){return i._update(!0)}),void 0!==t.window&&(t.window.addEventListener("online",this._onWindowOnline,!1),t.window.addEventListener("resize",this._onWindowResize,!1),t.window.addEventListener("orientationchange",this._onWindowResize,!1)),this.handlers=new Do(this,e),n="string"==typeof e.hash&&e.hash||void 0,this._hash=e.hash&&new Mn(n).addTo(this),this._hash&&this._hash._onHashChange()||(this.jumpTo({center:e.center,zoom:e.zoom,bearing:e.bearing,pitch:e.pitch}),e.bounds&&(this.resize(),this.fitBounds(e.bounds,t.extend({},e.fitBoundsOptions,{duration:0})))),this.resize(),this._localIdeographFontFamily=e.localIdeographFontFamily,e.style&&this.setStyle(e.style,{localIdeographFontFamily:e.localIdeographFontFamily}),e.attributionControl&&this.addControl(new Fo({customAttribution:e.customAttribution})),this.addControl(new Uo,e.logoPosition),this.on("style.load",function(){i.transform.unmodified&&i.jumpTo(i.style.stylesheet)}),this.on("data",function(e){i._update("style"===e.dataType),i.fire(new t.Event(e.dataType+"data",e))}),this.on("dataloading",function(e){i.fire(new t.Event(e.dataType+"dataloading",e))})}r&&(n.__proto__=r);var o={showTileBoundaries:{configurable:!0},showPadding:{configurable:!0},showCollisionBoxes:{configurable:!0},showOverdrawInspector:{configurable:!0},repaint:{configurable:!0},vertices:{configurable:!0},version:{configurable:!0}};return((n.prototype=Object.create(r&&r.prototype)).constructor=n).prototype._getMapId=function(){return this._mapId},n.prototype.addControl=function(e,i){if(void 0===i&&(i=e.getDefaultPosition?e.getDefaultPosition():"top-right"),!e||!e.onAdd)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));var r=e.onAdd(this);return this._controls.push(e),e=this._controlPositions[i],-1!==i.indexOf("bottom")?e.insertBefore(r,e.firstChild):e.appendChild(r),this},n.prototype.removeControl=function(e){if(!e||!e.onRemove)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));var i=this._controls.indexOf(e);return-1<i&&this._controls.splice(i,1),e.onRemove(this),this},n.prototype.hasControl=function(t){return-1<this._controls.indexOf(t)},n.prototype.resize=function(e){var i=(r=this._containerDimensions())[0],r=r[1];return this._resizeCanvas(i,r),this.transform.resize(i,r),this.painter.resize(i,r),(r=!this._moving)&&(this.stop(),this.fire(new t.Event("movestart",e)).fire(new t.Event("move",e))),this.fire(new t.Event("resize",e)),r&&this.fire(new t.Event("moveend",e)),this},n.prototype.getBounds=function(){return this.transform.getBounds()},n.prototype.getMaxBounds=function(){return this.transform.getMaxBounds()},n.prototype.setMaxBounds=function(e){return this.transform.setMaxBounds(t.LngLatBounds.convert(e)),this._update()},n.prototype.setMinZoom=function(t){if(-2<=(t=null==t?-2:t)&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t&&this.setZoom(t),this;throw new Error("minZoom must be between -2 and the current maxZoom, inclusive")},n.prototype.getMinZoom=function(){return this.transform.minZoom},n.prototype.setMaxZoom=function(t){if((t=null==t?22:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t&&this.setZoom(t),this;throw new Error("maxZoom must be greater than the current minZoom")},n.prototype.getMaxZoom=function(){return this.transform.maxZoom},n.prototype.setMinPitch=function(t){if((t=null==t?0:t)<0)throw new Error("minPitch must be greater than or equal to 0");if(0<=t&&t<=this.transform.maxPitch)return this.transform.minPitch=t,this._update(),this.getPitch()<t&&this.setPitch(t),this;throw new Error("minPitch must be between 0 and the current maxPitch, inclusive")},n.prototype.getMinPitch=function(){return this.transform.minPitch},n.prototype.setMaxPitch=function(t){if(60<(t=null==t?60:t))throw new Error("maxPitch must be less than or equal to 60");if(t>=this.transform.minPitch)return this.transform.maxPitch=t,this._update(),this.getPitch()>t&&this.setPitch(t),this;throw new Error("maxPitch must be greater than the current minPitch")},n.prototype.getMaxPitch=function(){return this.transform.maxPitch},n.prototype.getRenderWorldCopies=function(){return this.transform.renderWorldCopies},n.prototype.setRenderWorldCopies=function(t){return this.transform.renderWorldCopies=t,this._update()},n.prototype.project=function(e){return this.transform.locationPoint(t.LngLat.convert(e))},n.prototype.unproject=function(e){return this.transform.pointLocation(t.Point.convert(e))},n.prototype.isMoving=function(){return this._moving||this.handlers.isMoving()},n.prototype.isZooming=function(){return this._zooming||this.handlers.isZooming()},n.prototype.isRotating=function(){return this._rotating||this.handlers.isRotating()},n.prototype._createDelegatedListener=function(t,e,i){var r,n=this;if("mouseenter"===t||"mouseover"===t){var o=!1;return{layer:e,listener:i,delegates:{mousemove:function(r){var a=n.getLayer(e)?n.queryRenderedFeatures(r.point,{layers:[e]}):[];a.length?o||(o=!0,i.call(n,new Un(t,n,r.originalEvent,{features:a}))):o=!1},mouseout:function(){o=!1}}}}if("mouseleave"===t||"mouseout"===t){var a=!1;return{layer:e,listener:i,delegates:{mousemove:function(r){(n.getLayer(e)?n.queryRenderedFeatures(r.point,{layers:[e]}):[]).length?a=!0:a&&(a=!1,i.call(n,new Un(t,n,r.originalEvent)))},mouseout:function(e){a&&(a=!1,i.call(n,new Un(t,n,e.originalEvent)))}}}}return{layer:e,listener:i,delegates:((r={})[t]=function(t){var r=n.getLayer(e)?n.queryRenderedFeatures(t.point,{layers:[e]}):[];r.length&&(t.features=r,i.call(n,t),delete t.features)},r)}},n.prototype.on=function(t,e,i){if(void 0===i)return r.prototype.on.call(this,t,e);var n,o=this._createDelegatedListener(t,e,i);for(n in this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[t]=this._delegatedListeners[t]||[],this._delegatedListeners[t].push(o),o.delegates)this.on(n,o.delegates[n]);return this},n.prototype.once=function(t,e,i){if(void 0===i)return r.prototype.once.call(this,t,e);var n,o=this._createDelegatedListener(t,e,i);for(n in o.delegates)this.once(n,o.delegates[n]);return this},n.prototype.off=function(t,e,i){var n=this;return void 0===i?r.prototype.off.call(this,t,e):(this._delegatedListeners&&this._delegatedListeners[t]&&function(r){for(var o=r[t],a=0;a<o.length;a++){var s=o[a];if(s.layer===e&&s.listener===i){for(var l in s.delegates)n.off(l,s.delegates[l]);return o.splice(a,1)}}}(this._delegatedListeners),this)},n.prototype.queryRenderedFeatures=function(e,i){return this.style?(void 0!==i||void 0===e||e instanceof t.Point||Array.isArray(e)||(i=e,e=void 0),i=i||{},r=(e=e||[[0,0],[this.transform.width,this.transform.height]])instanceof t.Point||"number"==typeof e[0]?[t.Point.convert(e)]:(r=t.Point.convert(e[0]),e=t.Point.convert(e[1]),[r,new t.Point(e.x,r.y),e,new t.Point(r.x,e.y),r]),this.style.queryRenderedFeatures(r,i,this.transform)):[];var r},n.prototype.querySourceFeatures=function(t,e){return this.style.querySourceFeatures(t,e)},n.prototype.setStyle=function(e,i){return!1!==(i=t.extend({},{localIdeographFontFamily:this._localIdeographFontFamily},i)).diff&&i.localIdeographFontFamily===this._localIdeographFontFamily&&this.style&&e?(this._diffStyle(e,i),this):(this._localIdeographFontFamily=i.localIdeographFontFamily,this._updateStyle(e,i))},n.prototype._getUIString=function(t){var e=this._locale[t];if(null==e)throw new Error("Missing UI string '"+t+"'");return e},n.prototype._updateStyle=function(t,e){if((e=void 0===e?{}:e).stylePatch)t=t||gi();else{if(this.style&&(this.style.setEventedParent(null),this.style._remove()),!t)return delete this.style,this;this.style=new vr(this,e),this.style.setEventedParent(this,{style:this.style})}return this.style||(this.style=new vr(this,e),this.style.setEventedParent(this,{style:this.style})),"string"==typeof t?this.style.loadURL(t,e):this.style.loadJSON(t,e),this},n.prototype._lazyInitEmptyStyle=function(){this.style||(this.style=new vr(this,{}),this.style.setEventedParent(this,{style:this.style}),this.style.loadEmpty())},n.prototype._diffStyle=function(e,i){var r,n=this;void 0===i&&(i={}),"string"==typeof e?(r=this._requestManager.normalizeStyleURL(e),r=this._requestManager.transformRequest(r,t.ResourceType.Style),t.getJSON(r,function(e,r){e?n.fire(new t.ErrorEvent(e)):r&&n._updateDiff(r,i)})):"object"==typeof e&&this._updateDiff(e,i)},n.prototype._updateDiff=function(e,i){void 0===i&&(i={});try{this.style.setState(e,i)&&this._update(!0)}catch(r){t.warnOnce("Unable to perform style diff: "+(r.message||r.error||r)+".  Rebuilding the style from scratch."),this._updateStyle(e,i)}},n.prototype.getStyle=function(){if(this.style)return this.style.serialize()},n.prototype.isStyleLoaded=function(){return this.style?this.style.loaded():t.warnOnce("There is no style added to the map.")},n.prototype.addSource=function(t,e){return this._lazyInitEmptyStyle(),this.style.addSource(t,e),this._update(!0)},n.prototype.isSourceLoaded=function(e){var i=this.style&&this.style.sourceCaches[e];if(void 0!==i)return i.loaded();this.fire(new t.ErrorEvent(new Error("There is no source with ID '"+e+"'")))},n.prototype.areTilesLoaded=function(){var t,e=this.style&&this.style.sourceCaches;for(t in e){var i,r=e[t]._tiles;for(i in r){var n=r[i];if("loaded"!==n.state&&"errored"!==n.state)return!1}}return!0},n.prototype.addSourceType=function(t,e,i){return this._lazyInitEmptyStyle(),this.style.addSourceType(t,e,i)},n.prototype.removeSource=function(t){return this.style.removeSource(t),this._update(!0)},n.prototype.getSource=function(t){return this.style.getSource(t)},n.prototype.addImage=function(e,i,r){var n=(r=void 0===r?{}:r).pixelRatio;void 0===n&&(n=1);var o=r.sdf;void 0===o&&(o=!1);var a=r.stretchX,s=r.stretchY;r=r.content;if(this._lazyInitEmptyStyle(),i instanceof qo||Go&&i instanceof Go){var l=(c=t.browser.getImageData(i)).width,u=c.height,c=c.data;this.style.addImage(e,{data:new t.RGBAImage({width:l,height:u},c),pixelRatio:n,stretchX:a,stretchY:s,content:r,sdf:o,version:0})}else{if(void 0===i.width||void 0===i.height)return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));l=i.width,u=i.height,c=i.data,i=i,this.style.addImage(e,{data:new t.RGBAImage({width:l,height:u},new Uint8Array(c)),pixelRatio:n,stretchX:a,stretchY:s,content:r,sdf:o,version:0,userImage:i}),i.onAdd&&i.onAdd(this,e)}},n.prototype.updateImage=function(e,i){var r=this.style.getImage(e);if(!r)return this.fire(new t.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));var n=(a=i instanceof qo||Go&&i instanceof Go?t.browser.getImageData(i):i).width,o=a.height,a=a.data;return void 0===n||void 0===o?this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))):n!==r.data.width||o!==r.data.height?this.fire(new t.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image"))):(r.data.replace(a,!(i instanceof qo||Go&&i instanceof Go)),void this.style.updateImage(e,r))},n.prototype.hasImage=function(e){return e?!!this.style.getImage(e):(this.fire(new t.ErrorEvent(new Error("Missing required image id"))),!1)},n.prototype.removeImage=function(t){this.style.removeImage(t)},n.prototype.loadImage=function(e,i){t.getImage(this._requestManager.transformRequest(e,t.ResourceType.Image),i)},n.prototype.listImages=function(){return this.style.listImages()},n.prototype.addLayer=function(t,e){return this._lazyInitEmptyStyle(),this.style.addLayer(t,e),this._update(!0)},n.prototype.moveLayer=function(t,e){return this.style.moveLayer(t,e),this._update(!0)},n.prototype.removeLayer=function(t){return this.style.removeLayer(t),this._update(!0)},n.prototype.getLayer=function(t){return this.style.getLayer(t)},n.prototype.setLayerZoomRange=function(t,e,i){return this.style.setLayerZoomRange(t,e,i),this._update(!0)},n.prototype.setFilter=function(t,e,i){return this.style.setFilter(t,e,i=void 0===i?{}:i),this._update(!0)},n.prototype.getFilter=function(t){return this.style.getFilter(t)},n.prototype.setPaintProperty=function(t,e,i,r){return this.style.setPaintProperty(t,e,i,r=void 0===r?{}:r),this._update(!0)},n.prototype.getPaintProperty=function(t,e){return this.style.getPaintProperty(t,e)},n.prototype.setLayoutProperty=function(t,e,i,r){return this.style.setLayoutProperty(t,e,i,r=void 0===r?{}:r),this._update(!0)},n.prototype.getLayoutProperty=function(t,e){return this.style.getLayoutProperty(t,e)},n.prototype.setLight=function(t,e){return void 0===e&&(e={}),this._lazyInitEmptyStyle(),this.style.setLight(t,e),this._update(!0)},n.prototype.getLight=function(){return this.style.getLight()},n.prototype.setFeatureState=function(t,e){return this.style.setFeatureState(t,e),this._update()},n.prototype.removeFeatureState=function(t,e){return this.style.removeFeatureState(t,e),this._update()},n.prototype.getFeatureState=function(t){return this.style.getFeatureState(t)},n.prototype.getContainer=function(){return this._container},n.prototype.getCanvasContainer=function(){return this._canvasContainer},n.prototype.getCanvas=function(){return this._canvas},n.prototype._containerDimensions=function(){var t=0,e=0;return this._container&&(t=this._container.clientWidth||400,e=this._container.clientHeight||300),[t,e]},n.prototype._detectMissingCSS=function(){"rgb(250, 128, 114)"!==t.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color")&&t.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.")},n.prototype._setupContainer=function(){var t=this._container;t.classList.add("mapboxgl-map"),(this._missingCSSCanary=i.create("div","mapboxgl-canary",t)).style.visibility="hidden",this._detectMissingCSS();var e=this._canvasContainer=i.create("div","mapboxgl-canvas-container",t);this._interactive&&e.classList.add("mapboxgl-interactive"),this._canvas=i.create("canvas","mapboxgl-canvas",e),this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label","Map"),this._canvas.setAttribute("role","region"),e=this._containerDimensions(),this._resizeCanvas(e[0],e[1]);var r=this._controlContainer=i.create("div","mapboxgl-control-container",t),n=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach(function(t){n[t]=i.create("div","mapboxgl-ctrl-"+t,r)}),this._container.addEventListener("scroll",this._onMapScroll,!1)},n.prototype._resizeCanvas=function(e,i){var r=t.browser.devicePixelRatio||1;this._canvas.width=r*e,this._canvas.height=r*i,this._canvas.style.width=e+"px",this._canvas.style.height=i+"px"},n.prototype._setupPainter=function(){var i=t.extend({},e.webGLContextAttributes,{failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer,antialias:this._antialias||!1});(i=this._canvas.getContext("webgl",i)||this._canvas.getContext("experimental-webgl",i))?(this.painter=new Cn(i,this.transform),t.webpSupported.testSupport(i)):this.fire(new t.ErrorEvent(new Error("Failed to initialize WebGL")))},n.prototype._contextLost=function(e){e.preventDefault(),this._frame&&(this._frame.cancel(),this._frame=null),this.fire(new t.Event("webglcontextlost",{originalEvent:e}))},n.prototype._contextRestored=function(e){this._setupPainter(),this.resize(),this._update(),this.fire(new t.Event("webglcontextrestored",{originalEvent:e}))},n.prototype._onMapScroll=function(t){if(t.target===this._container)return this._container.scrollTop=0,this._container.scrollLeft=0,!1},n.prototype.loaded=function(){return!this._styleDirty&&!this._sourcesDirty&&!!this.style&&this.style.loaded()},n.prototype._update=function(t){return this.style&&(this._styleDirty=this._styleDirty||t,this._sourcesDirty=!0,this.triggerRepaint()),this},n.prototype._requestRenderFrame=function(t){return this._update(),this._renderTaskQueue.add(t)},n.prototype._cancelRenderFrame=function(t){this._renderTaskQueue.remove(t)},n.prototype._render=function(e){var i,r=this,n=0,o=this.painter.context.extTimerQuery;if(this.listens("gpu-timing-frame")&&(i=o.createQueryEXT(),o.beginQueryEXT(o.TIME_ELAPSED_EXT,i),n=t.browser.now()),this.painter.context.setDirty(),this.painter.setBaseState(),this._renderTaskQueue.run(e),!this._removed){var a,s,l,u=!1;return this.style&&this._styleDirty&&(this._styleDirty=!1,a=this.transform.zoom,e=t.browser.now(),this.style.zoomHistory.update(a,e),1===(e=(a=new t.EvaluationParameters(a,{now:e,fadeDuration:this._fadeDuration,zoomHistory:this.style.zoomHistory,transition:this.style.getTransition()})).crossFadingFactor())&&e===this._crossFadingFactor||(u=!0,this._crossFadingFactor=e),this.style.update(a)),this.style&&this._sourcesDirty&&(this._sourcesDirty=!1,this.style._updateSources(this.transform)),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,this._fadeDuration,this._crossSourceCollisions),this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showOverdrawInspector:this._showOverdrawInspector,rotating:this.isRotating(),zooming:this.isZooming(),moving:this.isMoving(),fadeDuration:this._fadeDuration,showPadding:this.showPadding,gpuTiming:!!this.listens("gpu-timing-layer")}),this.fire(new t.Event("render")),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire(new t.Event("load"))),this.style&&(this.style.hasTransitions()||u)&&(this._styleDirty=!0),this.style&&!this._placementDirty&&this.style._releaseSymbolFadeTiles(),this.listens("gpu-timing-frame")&&(s=t.browser.now()-n,o.endQueryEXT(o.TIME_ELAPSED_EXT,i),setTimeout(function(){var e=o.getQueryObjectEXT(i,o.QUERY_RESULT_EXT)/1e6;o.deleteQueryEXT(i),r.fire(new t.Event("gpu-timing-frame",{cpuTime:s,gpuTime:e}))},50)),this.listens("gpu-timing-layer")&&(l=this.painter.collectGpuTimers(),setTimeout(function(){var e=r.painter.queryGpuTimers(l);r.fire(new t.Event("gpu-timing-layer",{layerTimes:e}))},50)),(n=this._sourcesDirty||this._styleDirty||this._placementDirty)||this._repaint?this.triggerRepaint():!this.isMoving()&&this.loaded()&&this.fire(new t.Event("idle")),!this._loaded||this._fullyLoaded||n||(this._fullyLoaded=!0),this}},n.prototype.remove=function(){this._hash&&this._hash.remove();for(var e=0,i=this._controls;e<i.length;e+=1)i[e].onRemove(this);this._controls=[],this._frame&&(this._frame.cancel(),this._frame=null),this._renderTaskQueue.clear(),this.painter.destroy(),this.handlers.destroy(),delete this.handlers,this.setStyle(null),void 0!==t.window&&(t.window.removeEventListener("resize",this._onWindowResize,!1),t.window.removeEventListener("orientationchange",this._onWindowResize,!1),t.window.removeEventListener("online",this._onWindowOnline,!1));var r=this.painter.context.gl.getExtension("WEBGL_lose_context");r&&r.loseContext(),Wo(this._canvasContainer),Wo(this._controlContainer),Wo(this._missingCSSCanary),this._container.classList.remove("mapboxgl-map"),this._removed=!0,this.fire(new t.Event("remove"))},n.prototype.triggerRepaint=function(){var e=this;this.style&&!this._frame&&(this._frame=t.browser.frame(function(t){e._frame=null,e._render(t)}))},n.prototype._onWindowOnline=function(){this._update()},n.prototype._onWindowResize=function(t){this._trackResize&&this.resize({originalEvent:t})._update()},o.showTileBoundaries.get=function(){return!!this._showTileBoundaries},o.showTileBoundaries.set=function(t){this._showTileBoundaries!==t&&(this._showTileBoundaries=t,this._update())},o.showPadding.get=function(){return!!this._showPadding},o.showPadding.set=function(t){this._showPadding!==t&&(this._showPadding=t,this._update())},o.showCollisionBoxes.get=function(){return!!this._showCollisionBoxes},o.showCollisionBoxes.set=function(t){this._showCollisionBoxes!==t&&((this._showCollisionBoxes=t)?this.style._generateCollisionBoxes():this._update())},o.showOverdrawInspector.get=function(){return!!this._showOverdrawInspector},o.showOverdrawInspector.set=function(t){this._showOverdrawInspector!==t&&(this._showOverdrawInspector=t,this._update())},o.repaint.get=function(){return!!this._repaint},o.repaint.set=function(t){this._repaint!==t&&(this._repaint=t,this.triggerRepaint())},o.vertices.get=function(){return!!this._vertices},o.vertices.set=function(t){this._vertices=t,this._update()},n.prototype._setCacheLimits=function(e,i){t.setCacheLimits(e,i)},o.version.get=function(){return t.version},Object.defineProperties(n.prototype,o),n}(Ge);function Wo(t){t.parentNode&&t.parentNode.removeChild(t)}var Ko={showCompass:!0,showZoom:!0,visualizePitch:!1};(U=function(e){var r=this;this.options=t.extend({},Ko,e),this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this.options.showZoom&&(t.bindAll(["_setButtonTitle","_updateZoomButtons"],this),this._zoomInButton=this._createButton("mapboxgl-ctrl-zoom-in",function(t){return r._map.zoomIn({},{originalEvent:t})}),i.create("span","mapboxgl-ctrl-icon",this._zoomInButton).setAttribute("aria-hidden",!0),this._zoomOutButton=this._createButton("mapboxgl-ctrl-zoom-out",function(t){return r._map.zoomOut({},{originalEvent:t})}),i.create("span","mapboxgl-ctrl-icon",this._zoomOutButton).setAttribute("aria-hidden",!0)),this.options.showCompass&&(t.bindAll(["_rotateCompassArrow"],this),this._compass=this._createButton("mapboxgl-ctrl-compass",function(t){r.options.visualizePitch?r._map.resetNorthPitch({},{originalEvent:t}):r._map.resetNorth({},{originalEvent:t})}),this._compassIcon=i.create("span","mapboxgl-ctrl-icon",this._compass),this._compassIcon.setAttribute("aria-hidden",!0))}).prototype._updateZoomButtons=function(){var t=(e=this._map.getZoom())===this._map.getMaxZoom(),e=e===this._map.getMinZoom();this._zoomInButton.disabled=t,this._zoomOutButton.disabled=e,this._zoomInButton.setAttribute("aria-disabled",t.toString()),this._zoomOutButton.setAttribute("aria-disabled",e.toString())},U.prototype._rotateCompassArrow=function(){var t=this.options.visualizePitch?"scale("+1/Math.pow(Math.cos(this._map.transform.pitch*(Math.PI/180)),.5)+") rotateX("+this._map.transform.pitch+"deg) rotateZ("+this._map.transform.angle*(180/Math.PI)+"deg)":"rotate("+this._map.transform.angle*(180/Math.PI)+"deg)";this._compassIcon.style.transform=t},U.prototype.onAdd=function(t){return this._map=t,this.options.showZoom&&(this._setButtonTitle(this._zoomInButton,"ZoomIn"),this._setButtonTitle(this._zoomOutButton,"ZoomOut"),this._map.on("zoom",this._updateZoomButtons),this._updateZoomButtons()),this.options.showCompass&&(this._setButtonTitle(this._compass,"ResetBearing"),this.options.visualizePitch&&this._map.on("pitch",this._rotateCompassArrow),this._map.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new Xo(this._map,this._compass,this.options.visualizePitch)),this._container},U.prototype.onRemove=function(){i.remove(this._container),this.options.showZoom&&this._map.off("zoom",this._updateZoomButtons),this.options.showCompass&&(this.options.visualizePitch&&this._map.off("pitch",this._rotateCompassArrow),this._map.off("rotate",this._rotateCompassArrow),this._handler.off(),delete this._handler),delete this._map},U.prototype._createButton=function(t,e){return(t=i.create("button",t,this._container)).type="button",t.addEventListener("click",e),t},U.prototype._setButtonTitle=function(t,e){e=this._map._getUIString("NavigationControl."+e),t.title=e,t.setAttribute("aria-label",e)};var Xo=function(e,r,n){void 0===n&&(n=!1),this._clickTolerance=10,this.element=r,this.mouseRotate=new to({clickTolerance:e.dragRotate._mouseRotate._clickTolerance}),this.map=e,n&&(this.mousePitch=new ro({clickTolerance:e.dragRotate._mousePitch._clickTolerance})),t.bindAll(["mousedown","mousemove","mouseup","touchstart","touchmove","touchend","reset"],this),i.addEventListener(r,"mousedown",this.mousedown),i.addEventListener(r,"touchstart",this.touchstart,{passive:!1}),i.addEventListener(r,"touchmove",this.touchmove),i.addEventListener(r,"touchend",this.touchend),i.addEventListener(r,"touchcancel",this.reset)};function Yo(e,i,r){var n,o,a;for(e=new t.LngLat(e.lng,e.lat),i&&(n=new t.LngLat(e.lng-360,e.lat),o=new t.LngLat(e.lng+360,e.lat),a=r.locationPoint(e).distSqr(i),r.locationPoint(n).distSqr(i)<a?e=n:r.locationPoint(o).distSqr(i)<a&&(e=o));180<Math.abs(e.lng-r.center.lng);){var s=r.locationPoint(e);if(0<=s.x&&0<=s.y&&s.x<=r.width&&s.y<=r.height)break;e.lng>r.center.lng?e.lng-=360:e.lng+=360}return e}Xo.prototype.down=function(t,e){this.mouseRotate.mousedown(t,e),this.mousePitch&&this.mousePitch.mousedown(t,e),i.disableDrag()},Xo.prototype.move=function(t,e){var i=this.map,r=this.mouseRotate.mousemoveWindow(t,e);r&&r.bearingDelta&&i.setBearing(i.getBearing()+r.bearingDelta),!this.mousePitch||(e=this.mousePitch.mousemoveWindow(t,e))&&e.pitchDelta&&i.setPitch(i.getPitch()+e.pitchDelta)},Xo.prototype.off=function(){var t=this.element;i.removeEventListener(t,"mousedown",this.mousedown),i.removeEventListener(t,"touchstart",this.touchstart,{passive:!1}),i.removeEventListener(t,"touchmove",this.touchmove),i.removeEventListener(t,"touchend",this.touchend),i.removeEventListener(t,"touchcancel",this.reset),this.offTemp()},Xo.prototype.offTemp=function(){i.enableDrag(),i.removeEventListener(t.window,"mousemove",this.mousemove),i.removeEventListener(t.window,"mouseup",this.mouseup)},Xo.prototype.mousedown=function(e){this.down(t.extend({},e,{ctrlKey:!0,preventDefault:function(){return e.preventDefault()}}),i.mousePos(this.element,e)),i.addEventListener(t.window,"mousemove",this.mousemove),i.addEventListener(t.window,"mouseup",this.mouseup)},Xo.prototype.mousemove=function(t){this.move(t,i.mousePos(this.element,t))},Xo.prototype.mouseup=function(t){this.mouseRotate.mouseupWindow(t),this.mousePitch&&this.mousePitch.mouseupWindow(t),this.offTemp()},Xo.prototype.touchstart=function(t){1!==t.targetTouches.length?this.reset():(this._startPos=this._lastPos=i.touchPos(this.element,t.targetTouches)[0],this.down({type:"mousedown",button:0,ctrlKey:!0,preventDefault:function(){return t.preventDefault()}},this._startPos))},Xo.prototype.touchmove=function(t){1!==t.targetTouches.length?this.reset():(this._lastPos=i.touchPos(this.element,t.targetTouches)[0],this.move({preventDefault:function(){return t.preventDefault()}},this._lastPos))},Xo.prototype.touchend=function(t){0===t.targetTouches.length&&this._startPos&&this._lastPos&&this._startPos.dist(this._lastPos)<this._clickTolerance&&this.element.click(),this.reset()},Xo.prototype.reset=function(){this.mouseRotate.reset(),this.mousePitch&&this.mousePitch.reset(),delete this._startPos,delete this._lastPos,this.offTemp()};var Jo={center:"translate(-50%,-50%)",top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"};function Qo(t,e,i){var r,n=t.classList;for(r in Jo)n.remove("mapboxgl-"+i+"-anchor-"+r);n.add("mapboxgl-"+i+"-anchor-"+e)}var $o,ta=(($o=t.Evented)&&(ea.__proto__=$o),((ea.prototype=Object.create($o&&$o.prototype)).constructor=ea).prototype.addTo=function(t){return this.remove(),(this._map=t).getCanvasContainer().appendChild(this._element),t.on("move",this._update),t.on("moveend",this._update),this.setDraggable(this._draggable),this._update(),this._map.on("click",this._onMapClick),this},ea.prototype.remove=function(){return this._map&&(this._map.off("click",this._onMapClick),this._map.off("move",this._update),this._map.off("moveend",this._update),this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler),this._map.off("mouseup",this._onUp),this._map.off("touchend",this._onUp),this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),delete this._map),i.remove(this._element),this._popup&&this._popup.remove(),this},ea.prototype.getLngLat=function(){return this._lngLat},ea.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(),this},ea.prototype.getElement=function(){return this._element},ea.prototype.setPopup=function(t){var e;return this._popup&&(this._popup.remove(),this._popup=null,this._element.removeEventListener("keypress",this._onKeyPress),this._originalTabIndex||this._element.removeAttribute("tabindex")),t&&("offset"in t.options||(e=Math.sqrt(Math.pow(13.5,2)/2),t.options.offset=this._defaultMarker?{top:[0,0],"top-left":[0,0],"top-right":[0,0],bottom:[0,-38.1],"bottom-left":[e,-1*(24.6+e)],"bottom-right":[-e,-1*(24.6+e)],left:[13.5,-24.6],right:[-13.5,-24.6]}:this._offset),this._popup=t,this._lngLat&&this._popup.setLngLat(this._lngLat),this._originalTabIndex=this._element.getAttribute("tabindex"),this._originalTabIndex||this._element.setAttribute("tabindex","0"),this._element.addEventListener("keypress",this._onKeyPress)),this},ea.prototype._onKeyPress=function(t){var e=t.code;t=t.charCode||t.keyCode;"Space"!==e&&"Enter"!==e&&32!==t&&13!==t||this.togglePopup()},ea.prototype._onMapClick=function(t){var e=t.originalEvent.target;t=this._element;this._popup&&(e===t||t.contains(e))&&this.togglePopup()},ea.prototype.getPopup=function(){return this._popup},ea.prototype.togglePopup=function(){var t=this._popup;return t&&(t.isOpen()?t.remove():t.addTo(this._map)),this},ea.prototype._update=function(t){var e,r;this._map&&(this._map.transform.renderWorldCopies&&(this._lngLat=Yo(this._lngLat,this._pos,this._map.transform)),this._pos=this._map.project(this._lngLat)._add(this._offset),e="","viewport"===this._rotationAlignment||"auto"===this._rotationAlignment?e="rotateZ("+this._rotation+"deg)":"map"===this._rotationAlignment&&(e="rotateZ("+(this._rotation-this._map.getBearing())+"deg)"),r="","viewport"===this._pitchAlignment||"auto"===this._pitchAlignment?r="rotateX(0deg)":"map"===this._pitchAlignment&&(r="rotateX("+this._map.getPitch()+"deg)"),t&&"moveend"!==t.type||(this._pos=this._pos.round()),i.setTransform(this._element,Jo[this._anchor]+" translate("+this._pos.x+"px, "+this._pos.y+"px) "+r+" "+e))},ea.prototype.getOffset=function(){return this._offset},ea.prototype.setOffset=function(e){return this._offset=t.Point.convert(e),this._update(),this},ea.prototype._onMove=function(e){var i;this._isDragging||(i=this._clickTolerance||this._map._clickTolerance,this._isDragging=e.point.dist(this._pointerdownPos)>=i),this._isDragging&&(this._pos=e.point.sub(this._positionDelta),this._lngLat=this._map.unproject(this._pos),this.setLngLat(this._lngLat),this._element.style.pointerEvents="none","pending"===this._state&&(this._state="active",this.fire(new t.Event("dragstart"))),this.fire(new t.Event("drag")))},ea.prototype._onUp=function(){this._element.style.pointerEvents="auto",this._positionDelta=null,this._pointerdownPos=null,this._isDragging=!1,this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),"active"===this._state&&this.fire(new t.Event("dragend")),this._state="inactive"},ea.prototype._addDragHandler=function(t){this._element.contains(t.originalEvent.target)&&(t.preventDefault(),this._positionDelta=t.point.sub(this._pos).add(this._offset),this._pointerdownPos=t.point,this._state="pending",this._map.on("mousemove",this._onMove),this._map.on("touchmove",this._onMove),this._map.once("mouseup",this._onUp),this._map.once("touchend",this._onUp))},ea.prototype.setDraggable=function(t){return this._draggable=!!t,this._map&&(t?(this._map.on("mousedown",this._addDragHandler),this._map.on("touchstart",this._addDragHandler)):(this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler))),this},ea.prototype.isDraggable=function(){return this._draggable},ea.prototype.setRotation=function(t){return this._rotation=t||0,this._update(),this},ea.prototype.getRotation=function(){return this._rotation},ea.prototype.setRotationAlignment=function(t){return this._rotationAlignment=t||"auto",this._update(),this},ea.prototype.getRotationAlignment=function(){return this._rotationAlignment},ea.prototype.setPitchAlignment=function(t){return this._pitchAlignment=t&&"auto"!==t?t:this._rotationAlignment,this._update(),this},ea.prototype.getPitchAlignment=function(){return this._pitchAlignment},ea);function ea(e,r){if($o.call(this),(e instanceof t.window.HTMLElement||r)&&(e=t.extend({element:e},r)),t.bindAll(["_update","_onMove","_onUp","_addDragHandler","_onMapClick","_onKeyPress"],this),this._anchor=e&&e.anchor||"center",this._color=e&&e.color||"#3FB1CE",this._scale=e&&e.scale||1,this._draggable=e&&e.draggable||!1,this._clickTolerance=e&&e.clickTolerance||0,this._isDragging=!1,this._state="inactive",this._rotation=e&&e.rotation||0,this._rotationAlignment=e&&e.rotationAlignment||"auto",this._pitchAlignment=e&&e.pitchAlignment&&"auto"!==e.pitchAlignment?e.pitchAlignment:this._rotationAlignment,e&&e.element)this._element=e.element,this._offset=t.Point.convert(e&&e.offset||[0,0]);else{this._defaultMarker=!0,this._element=i.create("div"),this._element.setAttribute("aria-label","Map marker");var n=i.createNS("http://www.w3.org/2000/svg","svg");n.setAttributeNS(null,"display","block"),n.setAttributeNS(null,"height","41px"),n.setAttributeNS(null,"width","27px"),n.setAttributeNS(null,"viewBox","0 0 27 41");var o=i.createNS("http://www.w3.org/2000/svg","g");o.setAttributeNS(null,"stroke","none"),o.setAttributeNS(null,"stroke-width","1"),o.setAttributeNS(null,"fill","none"),o.setAttributeNS(null,"fill-rule","evenodd");var a=i.createNS("http://www.w3.org/2000/svg","g");a.setAttributeNS(null,"fill-rule","nonzero");var s=i.createNS("http://www.w3.org/2000/svg","g");s.setAttributeNS(null,"transform","translate(3.0, 29.0)"),s.setAttributeNS(null,"fill","#000000");for(var l=0,u=[{rx:"10.5",ry:"5.25002273"},{rx:"10.5",ry:"5.25002273"},{rx:"9.5",ry:"4.77275007"},{rx:"8.5",ry:"4.29549936"},{rx:"7.5",ry:"3.81822308"},{rx:"6.5",ry:"3.34094679"},{rx:"5.5",ry:"2.86367051"},{rx:"4.5",ry:"2.38636864"}];l<u.length;l+=1){var c=u[l],p=i.createNS("http://www.w3.org/2000/svg","ellipse");p.setAttributeNS(null,"opacity","0.04"),p.setAttributeNS(null,"cx","10.5"),p.setAttributeNS(null,"cy","5.80029008"),p.setAttributeNS(null,"rx",c.rx),p.setAttributeNS(null,"ry",c.ry),s.appendChild(p)}var h=i.createNS("http://www.w3.org/2000/svg","g");h.setAttributeNS(null,"fill",this._color);var d=i.createNS("http://www.w3.org/2000/svg","path");d.setAttributeNS(null,"d","M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"),h.appendChild(d);var f=i.createNS("http://www.w3.org/2000/svg","g");f.setAttributeNS(null,"opacity","0.25"),f.setAttributeNS(null,"fill","#000000");var m=i.createNS("http://www.w3.org/2000/svg","path");m.setAttributeNS(null,"d","M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"),f.appendChild(m),(r=i.createNS("http://www.w3.org/2000/svg","g")).setAttributeNS(null,"transform","translate(6.0, 7.0)"),r.setAttributeNS(null,"fill","#FFFFFF"),(o=i.createNS("http://www.w3.org/2000/svg","g")).setAttributeNS(null,"transform","translate(8.0, 8.0)"),(d=i.createNS("http://www.w3.org/2000/svg","circle")).setAttributeNS(null,"fill","#000000"),d.setAttributeNS(null,"opacity","0.25"),d.setAttributeNS(null,"cx","5.5"),d.setAttributeNS(null,"cy","5.5"),d.setAttributeNS(null,"r","5.4999962"),(m=i.createNS("http://www.w3.org/2000/svg","circle")).setAttributeNS(null,"fill","#FFFFFF"),m.setAttributeNS(null,"cx","5.5"),m.setAttributeNS(null,"cy","5.5"),m.setAttributeNS(null,"r","5.4999962"),o.appendChild(d),o.appendChild(m),a.appendChild(s),a.appendChild(h),a.appendChild(f),a.appendChild(r),a.appendChild(o),n.appendChild(a),n.setAttributeNS(null,"height",41*this._scale+"px"),n.setAttributeNS(null,"width",27*this._scale+"px"),this._element.appendChild(n),this._offset=t.Point.convert(e&&e.offset||[0,-14])}this._element.classList.add("mapboxgl-marker"),this._element.addEventListener("dragstart",function(t){t.preventDefault()}),this._element.addEventListener("mousedown",function(t){t.preventDefault()}),Qo(this._element,this._anchor,"marker"),this._popup=null}var ia,ra,na={positionOptions:{enableHighAccuracy:!1,maximumAge:0,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showAccuracyCircle:!0,showUserLocation:!0},oa=0,aa=!1;(ra=t.Evented)&&(sa.__proto__=ra),((sa.prototype=Object.create(ra&&ra.prototype)).constructor=sa).prototype.onAdd=function(e){var r;return this._map=e,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),r=this._setupUI,void 0!==ia?r(ia):void 0!==t.window.navigator.permissions?t.window.navigator.permissions.query({name:"geolocation"}).then(function(t){ia="denied"!==t.state,r(ia)}):(ia=!!t.window.navigator.geolocation,r(ia)),this._container},sa.prototype.onRemove=function(){void 0!==this._geolocationWatchID&&(t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker&&this._userLocationDotMarker.remove(),this.options.showAccuracyCircle&&this._accuracyCircleMarker&&this._accuracyCircleMarker.remove(),i.remove(this._container),this._map.off("zoom",this._onZoom),this._map=void 0,oa=0,aa=!1},sa.prototype._isOutOfMapMaxBounds=function(t){var e=this._map.getMaxBounds();t=t.coords;return e&&(t.longitude<e.getWest()||t.longitude>e.getEast()||t.latitude<e.getSouth()||t.latitude>e.getNorth())},sa.prototype._setErrorState=function(){switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting")}},sa.prototype._onSuccess=function(e){if(this._map){if(this._isOutOfMapMaxBounds(e))return this._setErrorState(),this.fire(new t.Event("outofmaxbounds",e)),this._updateMarker(),void this._finish();if(this.options.trackUserLocation)switch(this._lastKnownPosition=e,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background")}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(e),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(e),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("geolocate",e)),this._finish()}},sa.prototype._updateCamera=function(e){var i=new t.LngLat(e.coords.longitude,e.coords.latitude),r=e.coords.accuracy;e=this._map.getBearing(),e=t.extend({bearing:e},this.options.fitBoundsOptions);this._map.fitBounds(i.toBounds(r),e,{geolocateSource:!0})},sa.prototype._updateMarker=function(e){var i;e?(i=new t.LngLat(e.coords.longitude,e.coords.latitude),this._accuracyCircleMarker.setLngLat(i).addTo(this._map),this._userLocationDotMarker.setLngLat(i).addTo(this._map),this._accuracy=e.coords.accuracy,this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius()):(this._userLocationDotMarker.remove(),this._accuracyCircleMarker.remove())},sa.prototype._updateCircleRadius=function(){var t=this._map._container.clientHeight/2,e=this._map.unproject([0,t]);t=this._map.unproject([1,t]),t=e.distanceTo(t),t=Math.ceil(2*this._accuracy/t);this._circleElement.style.width=t+"px",this._circleElement.style.height=t+"px"},sa.prototype._onZoom=function(){this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius()},sa.prototype._onError=function(e){if(this._map){if(this.options.trackUserLocation)if(1===e.code){this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.disabled=!0;var i=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.title=i,this._geolocateButton.setAttribute("aria-label",i),void 0!==this._geolocationWatchID&&this._clearWatch()}else{if(3===e.code&&aa)return;this._setErrorState()}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("error",e)),this._finish()}},sa.prototype._finish=function(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0},sa.prototype._setupUI=function(e){var r,n=this;this._container.addEventListener("contextmenu",function(t){return t.preventDefault()}),this._geolocateButton=i.create("button","mapboxgl-ctrl-geolocate",this._container),i.create("span","mapboxgl-ctrl-icon",this._geolocateButton).setAttribute("aria-hidden",!0),!(this._geolocateButton.type="button")===e?(t.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled."),r=this._map._getUIString("GeolocateControl.LocationNotAvailable"),this._geolocateButton.disabled=!0,this._geolocateButton.title=r,this._geolocateButton.setAttribute("aria-label",r)):(r=this._map._getUIString("GeolocateControl.FindMyLocation"),this._geolocateButton.title=r,this._geolocateButton.setAttribute("aria-label",r)),this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=i.create("div","mapboxgl-user-location-dot"),this._userLocationDotMarker=new ta(this._dotElement),this._circleElement=i.create("div","mapboxgl-user-location-accuracy-circle"),this._accuracyCircleMarker=new ta({element:this._circleElement,pitchAlignment:"map"}),this.options.trackUserLocation&&(this._watchState="OFF"),this._map.on("zoom",this._onZoom)),this._geolocateButton.addEventListener("click",this.trigger.bind(this)),this._setup=!0,this.options.trackUserLocation&&this._map.on("movestart",function(e){var i=e.originalEvent&&"resize"===e.originalEvent.type;e.geolocateSource||"ACTIVE_LOCK"!==n._watchState||i||(n._watchState="BACKGROUND",n._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),n._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),n.fire(new t.Event("trackuserlocationend")))})},sa.prototype.trigger=function(){if(!this._setup)return t.warnOnce("Geolocate control triggered before added to a map"),!1;if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire(new t.Event("trackuserlocationstart"));break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":oa--,aa=!1,this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire(new t.Event("trackuserlocationend"));break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire(new t.Event("trackuserlocationstart"))}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error")}var e;"OFF"===this._watchState&&void 0!==this._geolocationWatchID?this._clearWatch():void 0===this._geolocationWatchID&&(this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),aa=1<++oa?(e={maximumAge:6e5,timeout:0},!0):(e=this.options.positionOptions,!1),this._geolocationWatchID=t.window.navigator.geolocation.watchPosition(this._onSuccess,this._onError,e))}else t.window.navigator.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4);return!0},sa.prototype._clearWatch=function(){t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null)},W=sa;function sa(e){ra.call(this),this.options=t.extend({},na,e),t.bindAll(["_onSuccess","_onError","_onZoom","_finish","_setupUI","_updateCamera","_updateMarker"],this)}var la={maxWidth:100,unit:"metric"};function ua(t,e,i){var r=i&&i.maxWidth||100,n=t._container.clientHeight/2,o=t.unproject([0,n]);n=t.unproject([r,n]),o=o.distanceTo(n);i&&"imperial"===i.unit?5280<(n=3.2808*o)?ca(e,r,n/5280,t._getUIString("ScaleControl.Miles")):ca(e,r,n,t._getUIString("ScaleControl.Feet")):i&&"nautical"===i.unit?ca(e,r,o/1852,t._getUIString("ScaleControl.NauticalMiles")):1e3<=o?ca(e,r,o/1e3,t._getUIString("ScaleControl.Kilometers")):ca(e,r,o,t._getUIString("ScaleControl.Meters"))}function ca(t,e,i,r){var n,o=(o=i,(n=Math.pow(10,(""+Math.floor(o)).length-1))*(o=10<=(o/=n)?10:5<=o?5:3<=o?3:2<=o?2:1<=o?1:function(t){var e=Math.pow(10,Math.ceil(-Math.log(t)/Math.LN10));return Math.round(t*e)/e}(o)));t.style.width=e*(o/i)+"px",t.innerHTML=o+"&nbsp;"+r}(Y=function(e){this.options=t.extend({},la,e),t.bindAll(["_onMove","setUnit"],this)}).prototype.getDefaultPosition=function(){return"bottom-left"},Y.prototype._onMove=function(){ua(this._map,this._container,this.options)},Y.prototype.onAdd=function(t){return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-scale",t.getContainer()),this._map.on("move",this._onMove),this._onMove(),this._container},Y.prototype.onRemove=function(){i.remove(this._container),this._map.off("move",this._onMove),this._map=void 0},Y.prototype.setUnit=function(t){this.options.unit=t,ua(this._map,this._container,this.options)},(zr=function(e){this._fullscreen=!1,e&&e.container&&(e.container instanceof t.window.HTMLElement?this._container=e.container:t.warnOnce("Full screen control 'container' must be a DOM element.")),t.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in t.window.document?this._fullscreenchange="fullscreenchange":"onmozfullscreenchange"in t.window.document?this._fullscreenchange="mozfullscreenchange":"onwebkitfullscreenchange"in t.window.document?this._fullscreenchange="webkitfullscreenchange":"onmsfullscreenchange"in t.window.document&&(this._fullscreenchange="MSFullscreenChange")}).prototype.onAdd=function(e){return this._map=e,this._container||(this._container=this._map.getContainer()),this._controlContainer=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._controlContainer.style.display="none",t.warnOnce("This device does not support fullscreen mode.")),this._controlContainer},zr.prototype.onRemove=function(){i.remove(this._controlContainer),this._map=null,t.window.document.removeEventListener(this._fullscreenchange,this._changeIcon)},zr.prototype._checkFullscreenSupport=function(){return!!(t.window.document.fullscreenEnabled||t.window.document.mozFullScreenEnabled||t.window.document.msFullscreenEnabled||t.window.document.webkitFullscreenEnabled)},zr.prototype._setupUI=function(){var e=this._fullscreenButton=i.create("button","mapboxgl-ctrl-fullscreen",this._controlContainer);i.create("span","mapboxgl-ctrl-icon",e).setAttribute("aria-hidden",!0),e.type="button",this._updateTitle(),this._fullscreenButton.addEventListener("click",this._onClickFullscreen),t.window.document.addEventListener(this._fullscreenchange,this._changeIcon)},zr.prototype._updateTitle=function(){var t=this._getTitle();this._fullscreenButton.setAttribute("aria-label",t),this._fullscreenButton.title=t},zr.prototype._getTitle=function(){return this._map._getUIString(this._isFullscreen()?"FullscreenControl.Exit":"FullscreenControl.Enter")},zr.prototype._isFullscreen=function(){return this._fullscreen},zr.prototype._changeIcon=function(){(t.window.document.fullscreenElement||t.window.document.mozFullScreenElement||t.window.document.webkitFullscreenElement||t.window.document.msFullscreenElement)===this._container!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"),this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"),this._updateTitle())},zr.prototype._onClickFullscreen=function(){this._isFullscreen()?t.window.document.exitFullscreen?t.window.document.exitFullscreen():t.window.document.mozCancelFullScreen?t.window.document.mozCancelFullScreen():t.window.document.msExitFullscreen?t.window.document.msExitFullscreen():t.window.document.webkitCancelFullScreen&&t.window.document.webkitCancelFullScreen():this._container.requestFullscreen?this._container.requestFullscreen():this._container.mozRequestFullScreen?this._container.mozRequestFullScreen():this._container.msRequestFullscreen?this._container.msRequestFullscreen():this._container.webkitRequestFullscreen&&this._container.webkitRequestFullscreen()};var pa,ha={closeButton:!0,closeOnClick:!0,focusAfterOpen:!0,className:"",maxWidth:"240px"},da=["a[href]","[tabindex]:not([tabindex='-1'])","[contenteditable]:not([contenteditable='false'])","button:not([disabled])","input:not([disabled])","select:not([disabled])","textarea:not([disabled])"].join(", ");(pa=t.Evented)&&(fa.__proto__=pa),((fa.prototype=Object.create(pa&&pa.prototype)).constructor=fa).prototype.addTo=function(e){return this._map&&this.remove(),this._map=e,this.options.closeOnClick&&this._map.on("click",this._onClose),this.options.closeOnMove&&this._map.on("move",this._onClose),this._map.on("remove",this.remove),this._update(),this._focusFirstElement(),this._trackPointer?(this._map.on("mousemove",this._onMouseMove),this._map.on("mouseup",this._onMouseUp),this._container&&this._container.classList.add("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.add("mapboxgl-track-pointer")):this._map.on("move",this._update),this.fire(new t.Event("open")),this},fa.prototype.isOpen=function(){return!!this._map},fa.prototype.remove=function(){return this._content&&i.remove(this._content),this._container&&(i.remove(this._container),delete this._container),this._map&&(this._map.off("move",this._update),this._map.off("move",this._onClose),this._map.off("click",this._onClose),this._map.off("remove",this.remove),this._map.off("mousemove",this._onMouseMove),this._map.off("mouseup",this._onMouseUp),this._map.off("drag",this._onDrag),delete this._map),this.fire(new t.Event("close")),this},fa.prototype.getLngLat=function(){return this._lngLat},fa.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._trackPointer=!1,this._update(),this._map&&(this._map.on("move",this._update),this._map.off("mousemove",this._onMouseMove),this._container&&this._container.classList.remove("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")),this},fa.prototype.trackPointer=function(){return this._trackPointer=!0,this._pos=null,this._update(),this._map&&(this._map.off("move",this._update),this._map.on("mousemove",this._onMouseMove),this._map.on("drag",this._onDrag),this._container&&this._container.classList.add("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.add("mapboxgl-track-pointer")),this},fa.prototype.getElement=function(){return this._container},fa.prototype.setText=function(e){return this.setDOMContent(t.window.document.createTextNode(e))},fa.prototype.setHTML=function(e){var i,r=t.window.document.createDocumentFragment(),n=t.window.document.createElement("body");for(n.innerHTML=e;i=n.firstChild;)r.appendChild(i);return this.setDOMContent(r)},fa.prototype.getMaxWidth=function(){return this._container&&this._container.style.maxWidth},fa.prototype.setMaxWidth=function(t){return this.options.maxWidth=t,this._update(),this},fa.prototype.setDOMContent=function(t){if(this._content)for(;this._content.hasChildNodes();)this._content.firstChild&&this._content.removeChild(this._content.firstChild);else this._content=i.create("div","mapboxgl-popup-content",this._container);return this._content.appendChild(t),this._createCloseButton(),this._update(),this._focusFirstElement(),this},fa.prototype.addClassName=function(t){this._container&&this._container.classList.add(t)},fa.prototype.removeClassName=function(t){this._container&&this._container.classList.remove(t)},fa.prototype.setOffset=function(t){return this.options.offset=t,this._update(),this},fa.prototype.toggleClassName=function(t){if(this._container)return this._container.classList.toggle(t)},fa.prototype._createCloseButton=function(){this.options.closeButton&&(this._closeButton=i.create("button","mapboxgl-popup-close-button",this._content),this._closeButton.type="button",this._closeButton.setAttribute("aria-label","Close popup"),this._closeButton.innerHTML="&#215;",this._closeButton.addEventListener("click",this._onClose))},fa.prototype._onMouseUp=function(t){this._update(t.point)},fa.prototype._onMouseMove=function(t){this._update(t.point)},fa.prototype._onDrag=function(t){this._update(t.point)},fa.prototype._update=function(e){var r,n,o,a=this,s=this._lngLat||this._trackPointer;this._map&&s&&this._content&&(this._container||(this._container=i.create("div","mapboxgl-popup",this._map.getContainer()),this._tip=i.create("div","mapboxgl-popup-tip",this._container),this._container.appendChild(this._content),this.options.className&&this.options.className.split(" ").forEach(function(t){return a._container.classList.add(t)}),this._trackPointer&&this._container.classList.add("mapboxgl-popup-track-pointer")),this.options.maxWidth&&this._container.style.maxWidth!==this.options.maxWidth&&(this._container.style.maxWidth=this.options.maxWidth),this._map.transform.renderWorldCopies&&!this._trackPointer&&(this._lngLat=Yo(this._lngLat,this._pos,this._map.transform)),this._trackPointer&&!e||(r=this._pos=this._trackPointer&&e?e:this._map.project(this._lngLat),n=this.options.anchor,o=function e(i){if(i){if("number"==typeof i){var r=Math.round(Math.sqrt(.5*Math.pow(i,2)));return{center:new t.Point(0,0),top:new t.Point(0,i),"top-left":new t.Point(r,r),"top-right":new t.Point(-r,r),bottom:new t.Point(0,-i),"bottom-left":new t.Point(r,-r),"bottom-right":new t.Point(-r,-r),left:new t.Point(i,0),right:new t.Point(-i,0)}}return i instanceof t.Point||Array.isArray(i)?{center:r=t.Point.convert(i),top:r,"top-left":r,"top-right":r,bottom:r,"bottom-left":r,"bottom-right":r,left:r,right:r}:{center:t.Point.convert(i.center||[0,0]),top:t.Point.convert(i.top||[0,0]),"top-left":t.Point.convert(i["top-left"]||[0,0]),"top-right":t.Point.convert(i["top-right"]||[0,0]),bottom:t.Point.convert(i.bottom||[0,0]),"bottom-left":t.Point.convert(i["bottom-left"]||[0,0]),"bottom-right":t.Point.convert(i["bottom-right"]||[0,0]),left:t.Point.convert(i.left||[0,0]),right:t.Point.convert(i.right||[0,0])}}return e(new t.Point(0,0))}(this.options.offset),n||(s=this._container.offsetWidth,e=this._container.offsetHeight,e=r.y+o.bottom.y<e?["top"]:r.y>this._map.transform.height-e?["bottom"]:[],r.x<s/2?e.push("left"):r.x>this._map.transform.width-s/2&&e.push("right"),n=0===e.length?"bottom":e.join("-")),o=r.add(o[n]).round(),i.setTransform(this._container,Jo[n]+" translate("+o.x+"px,"+o.y+"px)"),Qo(this._container,n,"popup")))},fa.prototype._focusFirstElement=function(){var t;this.options.focusAfterOpen&&this._container&&(t=this._container.querySelector(da))&&t.focus()},fa.prototype._onClose=function(){this.remove()},Ge=fa;function fa(e){pa.call(this),this.options=t.extend(Object.create(ha),e),t.bindAll(["_update","_onClose","remove","_onMouseMove","_onMouseUp","_onDrag"],this)}var ma={version:t.version,supported:e,setRTLTextPlugin:t.setRTLTextPlugin,getRTLTextPluginStatus:t.getRTLTextPluginStatus,Map:fi,NavigationControl:U,GeolocateControl:W,AttributionControl:Fo,ScaleControl:Y,FullscreenControl:zr,Popup:Ge,Marker:ta,Style:vr,LngLat:t.LngLat,LngLatBounds:t.LngLatBounds,Point:t.Point,MercatorCoordinate:t.MercatorCoordinate,Evented:t.Evented,config:t.config,prewarm:function(){mi().acquire(pi)},clearPrewarmedResources:function(){var t=di;t&&(t.isPreloaded()&&1===t.numActive()?(t.release(pi),di=null):console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"))},get accessToken(){return t.config.ACCESS_TOKEN},set accessToken(e){t.config.ACCESS_TOKEN=e},get baseApiUrl(){return t.config.API_URL},set baseApiUrl(e){t.config.API_URL=e},get workerCount(){return hi.workerCount},set workerCount(t){hi.workerCount=t},get maxParallelImageRequests(){return t.config.MAX_PARALLEL_IMAGE_REQUESTS},set maxParallelImageRequests(e){t.config.MAX_PARALLEL_IMAGE_REQUESTS=e},clearStorage:function(e){t.clearTileCache(e)},workerUrl:""};return ma}),o)}),n=(r.Map,r.setRTLTextPlugin),o=(r.supported,r.Marker),a="atlas.microsoft.com",s="atlas.microsoft.com",l="styling",u="2021-02-01",c="e96cb745-c6f5-409c-a775-c4313e468c1d",p="api-version",h="{{azMapsDomain}}",d="{azMapsDomain}",f="{{azMapsView}}",m="{{azMapsLanguage}}",y="{{azMapsStylingPath}}",g="{{azMapsStylePath}}",v="styling",_="styles",x="https://atlas.microsoft.com/",b=function(t,e){return(b=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(t,e)};function w(t,e){function i(){this.constructor=t}b(t,e),t.prototype=null===e?Object.create(e):(i.prototype=e.prototype,new i)}var S=function(){return(S=Object.assign||function(t){for(var e,i=1,r=arguments.length;i<r;i++)for(var n in e=arguments[i])Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t}).apply(this,arguments)};function T(t,e,i,r){return new(i=i||Promise)(function(n,o){function a(t){try{l(r.next(t))}catch(t){o(t)}}function s(t){try{l(r.throw(t))}catch(t){o(t)}}function l(t){var e;t.done?n(t.value):((e=t.value)instanceof i?e:new i(function(t){t(e)})).then(a,s)}l((r=r.apply(t,e||[])).next())})}function C(t,e){var i,r,n,o={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]},a={next:s(0),throw:s(1),return:s(2)};return"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function s(a){return function(s){return function(a){if(i)throw new TypeError("Generator is already executing.");for(;o;)try{if(i=1,r&&(n=2&a[0]?r.return:a[0]?r.throw||((n=r.return)&&n.call(r),0):r.next)&&!(n=n.call(r,a[1])).done)return n;switch(r=0,(a=n?[2&a[0],n.value]:a)[0]){case 0:case 1:n=a;break;case 4:return o.label++,{value:a[1],done:!1};case 5:o.label++,r=a[1],a=[0];continue;case 7:a=o.ops.pop(),o.trys.pop();continue;default:if(!(n=0<(n=o.trys).length&&n[n.length-1])&&(6===a[0]||2===a[0])){o=0;continue}if(3===a[0]&&(!n||a[1]>n[0]&&a[1]<n[3])){o.label=a[1];break}if(6===a[0]&&o.label<n[1]){o.label=n[1],n=a;break}if(n&&o.label<n[2]){o.label=n[2],o.ops.push(a);break}n[2]&&o.ops.pop(),o.trys.pop();continue}a=e.call(t,o)}catch(t){a=[6,t],r=0}finally{i=n=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,s])}}}function E(t){var e="function"==typeof Symbol&&Symbol.iterator,i=e&&t[e],r=0;if(i)return i.call(t);if(t&&"number"==typeof t.length)return{next:function(){return{value:(t=t&&r>=t.length?void 0:t)&&t[r++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function I(t,e){var i="function"==typeof Symbol&&t[Symbol.iterator];if(!i)return t;var r,n,o=i.call(t),a=[];try{for(;(void 0===e||0<e--)&&!(r=o.next()).done;)a.push(r.value)}catch(t){n={error:t}}finally{try{r&&!r.done&&(i=o.return)&&i.call(o)}finally{if(n)throw n.error}}return a}function k(){for(var t=[],e=0;e<arguments.length;e++)t=t.concat(I(arguments[e]));return t}var A=(P.prototype.merge=function(){for(var t,e,i,r=[],n=0;n<arguments.length;n++)r[n]=arguments[n];try{for(var o=E(r),a=o.next();!a.done;a=o.next()){var s=a.value;if(s)for(var l in s)s.hasOwnProperty(l)&&this.hasOwnProperty(l)&&(void 0!==s[l]&&null!=s[l]?this[l]instanceof P?this[l].merge(s[l]):this[l]=s[l]:(i=i||new(Object.getPrototypeOf(this).constructor),this[l]=i[l]))}}catch(e){t={error:e}}finally{try{a&&!a.done&&(e=o.return)&&e.call(o)}finally{if(t)throw t.error}}return this},P);function P(){}var M,L=(w(O,M=A),O);function O(){var t=null!==M&&M.apply(this,arguments)||this;return t.domain=void 0,t.headers={},t.path="",t.protocol="https",t.queryParams={},t.subdomain="",t}var R=(z.prototype.get=function(){return fetch(this.toString(),{method:"GET",mode:"cors",headers:new Headers(this.options.headers)}).then(function(t){if(t.ok)return t.json();throw new Error("HTTP "+t.status+": "+t.statusText)})},z.prototype.toString=function(){var t=Object.entries(this.options.queryParams).map(function(t){return(t=I(t,2))[0]+"="+t[1]}).join("&"),e=[],i=this.options.path||"";return z.protoRegEx.test(i)?e.push(i):(this.options.domain&&(z.protoRegEx.test(this.options.domain)||(e.push(this.options.protocol+"://"),e.push(this.options.subdomain?this.options.subdomain+".":"")),e.push(this.options.domain)),e.push(this.options.path?"/"+i:"")),e.push(t?"?"+t:""),e.join("")},z.protoRegEx=new RegExp(/^(((file|http|https):\/\/)|blob:)/i),z);function z(t){this.options=(new L).merge(t)}var D="2.1.4",N=(B.getFullVersion=function(){return D},B.getEndpointVersion=function(){var t=D.indexOf(".");return-1===(t=D.indexOf(".",t+1))?D:D.substring(0,t)},B);function B(){}(St=t.ControlPosition||(t.ControlPosition={})).TopLeft="top-left",St.TopRight="top-right",St.BottomLeft="bottom-left",St.BottomRight="bottom-right",St.NonFixed="non-fixed";var F,U=(w(j,F=A),j);function j(){var e=null!==F&&F.apply(this,arguments)||this;return e.position=t.ControlPosition.NonFixed,e}var V=(q.prototype.getLuminosity=function(){for(var t=[this.r,this.g,this.b],e=[],i=0;i<t.length;i++){var r=t[i]/255;e[i]=r<=.03928?r/12.92:Math.pow((.055+r)/1.055,2.4)}return.2126*e[0]+.7152*e[1]+.0722*e[2]},q.prototype.getRBGA=function(t){var e=document.createElement("canvas").getContext("2d");return e.globalAlpha=1,e.fillStyle=t,e.fillRect(0,0,1,1),[(e=e.getImageData(0,0,1,1).data)[0],e[1],e[2],e[3]]},q);function q(t){var e;t&&(void 0,3<=(e="string"==typeof t?this.getRBGA(t):t).length&&(this.r=e[0],this.g=e[1],this.b=e[2],3<e.length&&(this.a=e[3])))}(Ct=t.ControlStyle||(t.ControlStyle={})).light="light",Ct.dark="dark",Ct.auto="auto";var H=Map,G=(Z.prototype._addEventListener=function(t,e,i){this.listeners.has(t)||this.listeners.set(t,new H),this.listeners.get(t).set(e,i)},Z.prototype._removeEventListener=function(t,e){this.listeners.has(t)&&this.listeners.get(t).delete(e)},Z.prototype._invokeEvent=function(t,e){var i=this;this.listeners.has(t)&&this.listeners.get(t).forEach(function(r,n){r&&i._removeEventListener(t,n);try{n(e)}catch(r){console.error(r)}})},Z);function Z(){this.listeners=new H}var W,K=Object.freeze({__proto__:null,EventEmitter:G}),X=(w(Y,W=G),Y.prototype.onRemove=function(){this._container&&(this._container.remove(),delete this._container),this._map&&(this._map.events.remove("styledata",this._onStyleChange),delete this._map),this._observer&&(this._observer.disconnect(),delete this._observer),delete this._theme},Y.prototype.buildContainer=function(e,i,r,n){var o=this;return this._map=e,this._container=document.createElement(n||"div"),this._container.classList.add("azure-maps-control-container"),"string"==typeof r&&this._container.setAttribute("aria-label",r),i.toLowerCase()===t.ControlStyle.auto?this._map.styles.initialize().then(function(){o._map&&(o._onStyleChange(),o._map.events.add("styledata",o._onStyleChange))}):this._container.classList.add(i),this._container},Y.prototype._setTheme=function(t){this._theme!==t&&(this._container.classList.remove(this._theme),this._container.classList.add(t),this._theme=t)},Y.activateClickDelay=100,Y);function Y(){var e=null!==W&&W.apply(this,arguments)||this;return e._onStyleChange=function(){var t;e._map.getStyle().style.toLowerCase().startsWith("blank")?e._observer||(e._onBackgroundChange(),e._observer=new MutationObserver(e._onBackgroundChange),e._observer.observe(e._map.getMapContainer(),{attributes:!0,attributeFilter:["style"]})):(e._observer&&(e._observer.disconnect(),delete e._observer),t=e._map.styles.getTheme(e._map.getStyle()),e._setTheme(t))},e._onBackgroundChange=function(){var i=new V(e._map.getMapContainer().style.backgroundColor).getLuminosity();i=isNaN(i)||.5<i?t.ControlStyle.light:t.ControlStyle.dark;e._setTheme(i)},e}var J,Q=(w($,J=A),$);function $(){var e=null!==J&&J.apply(this,arguments)||this;return e.rotationDegreesDelta=15,e.style=t.ControlStyle.light,e}var tt,et=(w(it,tt=X),it.prototype.onAdd=function(t,e){var i=this,r=this.buildContainer(t,this.options.style,"Rotation Control"),n=this.constructRotationButton(t),o=this.constructRotationGrid(t,e);return r.addEventListener("mouseover",function(t){i.lastActiveTime=i.lastActiveTime||t.timeStamp,i.hasMouse=!0,r.classList.add("in-use"),o.classList.remove("hidden-accessible-element")}),r.addEventListener("focusin",function(t){i.lastActiveTime=i.lastActiveTime||t.timeStamp,i.hasFocus=!0,r.classList.add("in-use"),o.classList.remove("hidden-accessible-element")}),r.addEventListener("mouseleave",function(){i.hasMouse=!1,i.hasFocus||(delete i.lastActiveTime,r.classList.remove("in-use"),o.classList.add("hidden-accessible-element"))}),r.addEventListener("focusout",function(t){t.relatedTarget instanceof Node&&r.contains(t.relatedTarget)||(i.hasFocus=!1,i.hasMouse||(delete i.lastActiveTime,r.classList.remove("in-use"),o.classList.add("hidden-accessible-element")))}),e&&it.InvertOrderPositions.includes(e.position)?(r.appendChild(o),r.appendChild(n)):(r.appendChild(n),r.appendChild(o)),r},it.prototype.constructRotationGrid=function(t,e){var i=document.createElement("div");i.classList.add("sub-container"),i.classList.add("hidden-accessible-element");var r=this.constructRightRotationButton(t);t=this.constructLeftRotationButton(t);return e&&it.InvertOrderPositions.includes(e.position)?(i.appendChild(r),i.appendChild(t)):(i.appendChild(t),i.appendChild(r)),i},it.prototype.constructRotationButton=function(t){var e=this,i=document.createElement("button");i.classList.add("azure-maps-control-button"),i.classList.add("rotation"),i.setAttribute("title","Reset to Default Rotation"),i.setAttribute("alt","Reset to Default Rotation"),i.setAttribute("type","button");var r=document.createElement("div");return i.appendChild(r),i.addEventListener("click",function(i){i.timeStamp-e.lastActiveTime>X.activateClickDelay&&t.setCamera({bearing:it.DefaultRotation},!0)}),t.events.add("rotate",function(t){r.style.transform="rotate("+-t.map.getCamera().bearing+"deg)"}),i},it.prototype.constructRightRotationButton=function(t){var e=this,i=document.createElement("button");return i.classList.add("azure-maps-control-button"),i.classList.add("rotation-right"),i.setAttribute("title","Rotate Right"),i.setAttribute("alt","Rotate Right"),i.setAttribute("type","button"),i.addEventListener("click",function(){t.setCamera({bearing:t.getCamera().bearing-e.options.rotationDegreesDelta,duration:it.RotationDuration,type:"ease"},!0)}),i},it.prototype.constructLeftRotationButton=function(t){var e=this,i=document.createElement("button");return i.classList.add("azure-maps-control-button"),i.classList.add("rotation-left"),i.setAttribute("title","Rotate Left"),i.setAttribute("alt","Rotate Left"),i.setAttribute("type","button"),i.addEventListener("click",function(){t.setCamera({bearing:t.getCamera().bearing+e.options.rotationDegreesDelta,duration:it.RotationDuration,type:"ease"},!0)}),i},it.DefaultRotation=0,it.RotationDuration=100,it.InvertOrderPositions=[t.ControlPosition.BottomRight,t.ControlPosition.TopRight],it);function it(t){var e=tt.call(this)||this;return e.hasMouse=!1,e.hasFocus=!1,e.options=(new Q).merge(t),e}var rt,nt=(w(ot,rt=A),ot);function ot(){var e=null!==rt&&rt.apply(this,arguments)||this;return e.pitchDegreesDelta=10,e.style=t.ControlStyle.light,e}var at,st=(w(lt,at=X),lt.prototype.onAdd=function(t,e){var i=this,r=this.buildContainer(t,this.options.style,"Pitch Control"),n=this.constructPitchButton(t),o=this.constructPitchGrid(t,e);return r.addEventListener("mouseover",function(t){i.lastActiveTime=i.lastActiveTime||t.timeStamp,i.hasMouse=!0,r.classList.add("in-use"),o.classList.remove("hidden-accessible-element")}),r.addEventListener("focusin",function(t){i.lastActiveTime=i.lastActiveTime||t.timeStamp,i.hasFocus=!0,r.classList.add("in-use"),o.classList.remove("hidden-accessible-element")}),r.addEventListener("mouseleave",function(){i.hasMouse=!1,i.hasFocus||(delete i.lastActiveTime,r.classList.remove("in-use"),o.classList.add("hidden-accessible-element"))}),r.addEventListener("focusout",function(t){t.relatedTarget instanceof Node&&r.contains(t.relatedTarget)||(i.hasFocus=!1,i.hasMouse||(delete i.lastActiveTime,r.classList.remove("in-use"),o.classList.add("hidden-accessible-element")))}),e&&lt.INVERT_ORDER_POSITIONS.includes(e.position)?(r.appendChild(o),r.appendChild(n)):(r.appendChild(n),r.appendChild(o)),this.map=t,this.container=r,t.events.add("pitch",this.pitchChanged),r},lt.prototype.onRemove=function(){this.container&&(this.container.remove(),this.container=null,this.pitchIncrementButton=null,this.pitchDecrementButton=null),this.map&&(this.map.events.remove("pitch",this.pitchChanged),this.map=null)},lt.prototype.constructPitchGrid=function(t,e){var i=document.createElement("div");return i.classList.add("sub-container"),i.classList.add("hidden-accessible-element"),this.pitchIncrementButton=this.constructPitchIncrementButton(t),this.pitchDecrementButton=this.constructPitchDecrementButton(t),e&&lt.INVERT_ORDER_POSITIONS.includes(e.position)?(i.appendChild(this.pitchDecrementButton),i.appendChild(this.pitchIncrementButton)):(i.appendChild(this.pitchIncrementButton),i.appendChild(this.pitchDecrementButton)),i},lt.prototype.constructPitchButton=function(t){var e=this,i=document.createElement("button");return i.classList.add("azure-maps-control-button"),i.classList.add("pitch"),i.setAttribute("title","Reset to Default Pitch"),i.setAttribute("alt","Reset to Default Pitch"),i.setAttribute("type","button"),i.addEventListener("click",function(){event.timeStamp-e.lastActiveTime>X.activateClickDelay&&t.setCamera({pitch:lt.DEFAULT_PITCH},!0)}),i},lt.prototype.constructPitchDecrementButton=function(t){var e=this,i=document.createElement("button");return i.classList.add("azure-maps-control-button"),i.classList.add("pitch-down"),i.setAttribute("title","Decrease Pitch"),i.setAttribute("alt","Decrease Pitch"),i.setAttribute("type","button"),i.addEventListener("click",function(){t.setCamera({pitch:t.getCamera().pitch-e.options.pitchDegreesDelta,duration:lt.PITCH_DURATION_MS,type:"ease"},!0)}),i},lt.prototype.constructPitchIncrementButton=function(t){var e=this,i=document.createElement("button");return i.classList.add("azure-maps-control-button"),i.classList.add("pitch-up"),i.setAttribute("title","Increase Pitch"),i.setAttribute("alt","Increase Pitch"),i.setAttribute("type","button"),i.addEventListener("click",function(){t.setCamera({pitch:t.getCamera().pitch+e.options.pitchDegreesDelta,duration:lt.PITCH_DURATION_MS,type:"ease"},!0)}),i},lt.PITCH_DURATION_MS=100,lt.DEFAULT_PITCH=0,lt.INVERT_ORDER_POSITIONS=[t.ControlPosition.BottomRight,t.ControlPosition.TopRight],lt);function lt(t){var e=at.call(this)||this;return e.container=null,e.map=null,e.pitchIncrementButton=null,e.pitchDecrementButton=null,e.hasMouse=!1,e.hasFocus=!1,e.pitchChanged=function(t){return e.updatePitchButtonsState()},e.updatePitchButtonsState=function(){var t=e.map.getCamera().pitch<=0,i=60<=e.map.getCamera().pitch;e.pitchIncrementButton&&e.pitchIncrementButton.disabled!=i&&(e.pitchIncrementButton.disabled=i),e.pitchDecrementButton&&e.pitchDecrementButton.disabled!=t&&(e.pitchDecrementButton.disabled=t)},e.options=(new nt).merge(t),e}var ut=function(t,e){return t===e||t!=t&&e!=e},ct=function(t,e){for(var i=t.length;i--;)if(ut(t[i][0],e))return i;return-1},pt=Array.prototype.splice,ht=function(t){var e=this.__data__;return!((t=ct(e,t))<0||(t==e.length-1?e.pop():pt.call(e,t,1),--this.size,0))},dt=function(t){var e=this.__data__;return(t=ct(e,t))<0?void 0:e[t][1]},ft=function(t){return-1<ct(this.__data__,t)},mt=function(t,e){var i=this.__data__,r=ct(i,t);return r<0?(++this.size,i.push([t,e])):i[r][1]=e,this};function yt(t){var e=-1,i=null==t?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}yt.prototype.clear=function(){this.__data__=[],this.size=0},yt.prototype.delete=ht,yt.prototype.get=dt,yt.prototype.has=ft,yt.prototype.set=mt;var gt=yt,vt=function(){this.__data__=new gt,this.size=0},_t=function(t){var e=this.__data__;t=e.delete(t);return this.size=e.size,t},xt=function(t){return this.__data__.get(t)},bt=function(t){return this.__data__.has(t)},wt="object"==typeof e&&e&&e.Object===Object&&e,St="object"==typeof self&&self&&self.Object===Object&&self,Tt=wt||St||Function("return this")(),Ct=Tt.Symbol,Et=(ht=Object.prototype).hasOwnProperty,It=ht.toString,kt=Ct?Ct.toStringTag:void 0,At=Object.prototype.toString,Pt=Ct?Ct.toStringTag:void 0,Mt=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":(Pt&&Pt in Object(t)?function(t){var e=Et.call(t,kt),i=t[kt];try{var r=!(t[kt]=void 0)}catch(t){}var n=It.call(t);return r&&(e?t[kt]=i:delete t[kt]),n}:function(t){return At.call(t)})(t)},Lt=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)},Ot=function(t){return!!Lt(t)&&("[object Function]"==(t=Mt(t))||"[object GeneratorFunction]"==t||"[object AsyncFunction]"==t||"[object Proxy]"==t)},Rt=(dt=Tt["__core-js_shared__"],(ft=/[^.]+$/.exec(dt&&dt.keys&&dt.keys.IE_PROTO||""))?"Symbol(src)_1."+ft:""),zt=Function.prototype.toString,Dt=function(t){if(null!=t){try{return zt.call(t)}catch(t){}try{return t+""}catch(t){}}return""},Nt=/^\[object .+?Constructor\]$/,Bt=(mt=Function.prototype,e=Object.prototype,St=mt.toString,ht=e.hasOwnProperty,RegExp("^"+St.call(ht).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$")),Ft=function(t){return!(!Lt(t)||function(t){return!!Rt&&Rt in t}(t))&&(Ot(t)?Bt:Nt).test(Dt(t))},Ut=function(t,e){return e=function(t,e){return null==t?void 0:t[e]}(t,e),Ft(e)?e:void 0},jt=Ut(Tt,"Map"),Vt=Ut(Object,"create"),qt=(dt=function(t){return t=this.has(t)&&delete this.__data__[t],this.size-=t?1:0,t},Object.prototype.hasOwnProperty),Ht=(ft=function(t){var e=this.__data__;if(Vt){var i=e[t];return"__lodash_hash_undefined__"===i?void 0:i}return qt.call(e,t)?e[t]:void 0},Object.prototype.hasOwnProperty);function Gt(t){var e=-1,i=null==t?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}mt=function(t){var e=this.__data__;return Vt?void 0!==e[t]:Ht.call(e,t)},e=function(t,e){var i=this.__data__;return this.size+=this.has(t)?0:1,i[t]=Vt&&void 0===e?"__lodash_hash_undefined__":e,this},Gt.prototype.clear=function(){this.__data__=Vt?Vt(null):{},this.size=0},Gt.prototype.delete=dt,Gt.prototype.get=ft,Gt.prototype.has=mt,Gt.prototype.set=e;var Zt=Gt;St=function(){this.size=0,this.__data__={hash:new Zt,map:new(jt||gt),string:new Zt}};var Wt=function(t,e){return t=t.__data__,function(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}(e)?t["string"==typeof e?"string":"hash"]:t.map};function Kt(t){var e=-1,i=null==t?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}ht=function(t){return t=Wt(this,t).delete(t),this.size-=t?1:0,t},dt=function(t){return Wt(this,t).get(t)},ft=function(t){return Wt(this,t).has(t)},mt=function(t,e){var i=Wt(this,t),r=i.size;return i.set(t,e),this.size+=i.size==r?0:1,this},Kt.prototype.clear=St,Kt.prototype.delete=ht,Kt.prototype.get=dt,Kt.prototype.has=ft,Kt.prototype.set=mt;var Xt=Kt;function Yt(t){t=this.__data__=new gt(t),this.size=t.size}e=function(t,e){var i=this.__data__;if(i instanceof gt){var r=i.__data__;if(!jt||r.length<199)return r.push([t,e]),this.size=++i.size,this;i=this.__data__=new Xt(r)}return i.set(t,e),this.size=i.size,this},Yt.prototype.clear=vt,Yt.prototype.delete=_t,Yt.prototype.get=xt,Yt.prototype.has=bt,Yt.prototype.set=e;var Jt=Yt,Qt=function(){try{var t=Ut(Object,"defineProperty");return t({},"",{}),t}catch(t){}}(),$t=function(t,e,i){"__proto__"==e&&Qt?Qt(t,e,{configurable:!0,enumerable:!0,value:i,writable:!0}):t[e]=i},te=Object.prototype.hasOwnProperty,ee=function(t,e,i){var r=t[e];te.call(t,e)&&ut(r,i)&&(void 0!==i||e in t)||$t(t,e,i)},ie=function(t,e,i,r){var n=!i;i=i||{};for(var o=-1,a=e.length;++o<a;){var s=e[o],l=r?r(i[s],t[s],s,i,t):void 0;void 0===l&&(l=t[s]),(n?$t:ee)(i,s,l)}return i},re=function(t){return null!=t&&"object"==typeof t},ne=(St=function(t){return re(t)&&"[object Arguments]"==Mt(t)},(ht=Object.prototype).hasOwnProperty),oe=ht.propertyIsEnumerable,ae=St(function(){return arguments}())?St:function(t){return re(t)&&ne.call(t,"callee")&&!oe.call(t,"callee")},se=Array.isArray;function le(){return!1}var ue=i(function(t,e){var i=(i=(e=(i=e&&!e.nodeType&&e)&&t&&!t.nodeType&&t)&&e.exports===i?Tt.Buffer:void 0)?i.isBuffer:void 0;t.exports=i||le}),ce=/^(?:0|[1-9]\d*)$/,pe=function(t,e){var i=typeof t;return!!(e=null==e?9007199254740991:e)&&("number"==i||"symbol"!=i&&ce.test(t))&&-1<t&&t%1==0&&t<e},he=function(t){return"number"==typeof t&&-1<t&&t%1==0&&t<=9007199254740991},de={};de["[object Float32Array]"]=de["[object Float64Array]"]=de["[object Int8Array]"]=de["[object Int16Array]"]=de["[object Int32Array]"]=de["[object Uint8Array]"]=de["[object Uint8ClampedArray]"]=de["[object Uint16Array]"]=de["[object Uint32Array]"]=!0,de["[object Arguments]"]=de["[object Array]"]=de["[object ArrayBuffer]"]=de["[object Boolean]"]=de["[object DataView]"]=de["[object Date]"]=de["[object Error]"]=de["[object Function]"]=de["[object Map]"]=de["[object Number]"]=de["[object Object]"]=de["[object RegExp]"]=de["[object Set]"]=de["[object String]"]=de["[object WeakMap]"]=!1,dt=function(t){return re(t)&&he(t.length)&&!!de[Mt(t)]};ft=function(t){return function(e){return t(e)}};var fe=(vt=(mt=i(function(t,e){var i=(e=e&&!e.nodeType&&e)&&t&&!t.nodeType&&t,r=i&&i.exports===e&&wt.process;e=function(){try{var t=i&&i.require&&i.require("util").types;return t||r&&r.binding&&r.binding("util")}catch(t){}}();t.exports=e}))&&mt.isTypedArray)?ft(vt):dt,me=Object.prototype.hasOwnProperty,ye=function(t,e){var i,r=se(t),n=!r&&ae(t),o=!r&&!n&&ue(t),a=!r&&!n&&!o&&fe(t),s=r||n||o||a,l=s?function(t,e){for(var i=-1,r=Array(t);++i<t;)r[i]=e(i);return r}(t.length,String):[],u=l.length;for(i in t)!e&&!me.call(t,i)||s&&("length"==i||o&&("offset"==i||"parent"==i)||a&&("buffer"==i||"byteLength"==i||"byteOffset"==i)||pe(i,u))||l.push(i);return l},ge=Object.prototype,ve=function(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||ge)},_e=(_t=function(t,e){return function(i){return t(e(i))}})(Object.keys,Object),xe=Object.prototype.hasOwnProperty,be=function(t){return null!=t&&he(t.length)&&!Ot(t)},we=function(t){return(be(t)?ye:function(t){if(!ve(t))return _e(t);var e,i=[];for(e in Object(t))xe.call(t,e)&&"constructor"!=e&&i.push(e);return i})(t)},Se=Object.prototype.hasOwnProperty,Te=function(t){if(!Lt(t))return function(t){var e=[];if(null!=t)for(var i in Object(t))e.push(i);return e}(t);var e,i=ve(t),r=[];for(e in t)("constructor"!=e||!i&&Se.call(t,e))&&r.push(e);return r},Ce=function(t){return be(t)?ye(t,!0):Te(t)},Ee=i(function(t,e){var i,r=(i=(e=(i=e&&!e.nodeType&&e)&&t&&!t.nodeType&&t)&&e.exports===i?Tt.Buffer:void 0)?i.allocUnsafe:void 0;t.exports=function(t,e){return e?t.slice():(e=t.length,e=r?r(e):new t.constructor(e),t.copy(e),e)}}),Ie=function(t,e){var i=-1,r=t.length;for(e=e||Array(r);++i<r;)e[i]=t[i];return e},ke=(xt=function(){return[]},Object.prototype.propertyIsEnumerable),Ae=Object.getOwnPropertySymbols,Pe=Ae?function(t){return null==t?[]:(t=Object(t),function(t,e){for(var i=-1,r=null==t?0:t.length,n=0,o=[];++i<r;){var a=t[i];e(a,i,t)&&(o[n++]=a)}return o}(Ae(t),function(e){return ke.call(t,e)}))}:xt,Me=function(t,e){for(var i=-1,r=e.length,n=t.length;++i<r;)t[n+i]=e[i];return t},Le=_t(Object.getPrototypeOf,Object),Oe=Object.getOwnPropertySymbols?function(t){for(var e=[];t;)Me(e,Pe(t)),t=Le(t);return e}:xt,Re=function(t,e,i){return e=e(t),se(t)?e:Me(e,i(t))},ze=function(t){return Re(t,we,Pe)};function De(t){return Re(t,Ce,Oe)}bt=Ut(Tt,"DataView"),e=Ut(Tt,"Promise"),ht=Ut(Tt,"Set"),St=Ut(Tt,"WeakMap");var Ne="[object Map]",Be="[object Promise]",Fe="[object Set]",Ue="[object WeakMap]",je="[object DataView]",Ve=Dt(bt),qe=Dt(jt),He=Dt(e),Ge=Dt(ht),Ze=Dt(St),We=(vt=Mt,vt=bt&&vt(new bt(new ArrayBuffer(1)))!=je||jt&&vt(new jt)!=Ne||e&&vt(e.resolve())!=Be||ht&&vt(new ht)!=Fe||St&&vt(new St)!=Ue?function(t){var e=Mt(t);if(t=(t="[object Object]"==e?t.constructor:void 0)?Dt(t):"")switch(t){case Ve:return je;case qe:return Ne;case He:return Be;case Ge:return Fe;case Ze:return Ue}return e}:vt),Ke=Object.prototype.hasOwnProperty,Xe=Tt.Uint8Array,Ye=function(t){var e=new t.constructor(t.byteLength);return new Xe(e).set(new Xe(t)),e},Je=/\w*$/,Qe=(dt=Ct?Ct.prototype:void 0)?dt.valueOf:void 0,$e=function(t,e){return e=e?Ye(t.buffer):t.buffer,new t.constructor(e,t.byteOffset,t.length)},ti=function(t,e,i){var r=t.constructor;switch(e){case"[object ArrayBuffer]":return Ye(t);case"[object Boolean]":case"[object Date]":return new r(+t);case"[object DataView]":return function(t,e){return e=e?Ye(t.buffer):t.buffer,new t.constructor(e,t.byteOffset,t.byteLength)}(t,i);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return $e(t,i);case"[object Map]":return new r;case"[object Number]":case"[object String]":return new r(t);case"[object RegExp]":return function(t){var e=new t.constructor(t.source,Je.exec(t));return e.lastIndex=t.lastIndex,e}(t);case"[object Set]":return new r;case"[object Symbol]":return function(t){return Qe?Object(Qe.call(t)):{}}(t)}},ei=Object.create;function ii(){}var ri=function(t){return"function"!=typeof t.constructor||ve(t)?{}:function(t){return Lt(t)?ei?ei(t):(ii.prototype=t,t=new ii,ii.prototype=void 0,t):{}}(Le(t))},ni=(_t=function(t){return re(t)&&"[object Map]"==We(t)},(xt=mt&&mt.isMap)?ft(xt):_t),oi=(bt=function(t){return re(t)&&"[object Set]"==We(t)},(e=mt&&mt.isSet)?ft(e):bt),ai="[object Arguments]",si="[object Function]",li="[object Object]",ui={};ui[ai]=ui["[object Array]"]=ui["[object ArrayBuffer]"]=ui["[object DataView]"]=ui["[object Boolean]"]=ui["[object Date]"]=ui["[object Float32Array]"]=ui["[object Float64Array]"]=ui["[object Int8Array]"]=ui["[object Int16Array]"]=ui["[object Int32Array]"]=ui["[object Map]"]=ui["[object Number]"]=ui[li]=ui["[object RegExp]"]=ui["[object Set]"]=ui["[object String]"]=ui["[object Symbol]"]=ui["[object Uint8Array]"]=ui["[object Uint8ClampedArray]"]=ui["[object Uint16Array]"]=ui["[object Uint32Array]"]=!0,ui["[object Error]"]=ui[si]=ui["[object WeakMap]"]=!1;var ci,pi=function t(e,i,r,n,o,a){var s,l=1&i,u=2&i,c=4&i;if(void 0!==(s=r?o?r(e,n,o,a):r(e):s))return s;if(!Lt(e))return e;var p=se(e);if(p){if(s=function(t){var e=t.length,i=new t.constructor(e);return e&&"string"==typeof t[0]&&Ke.call(t,"index")&&(i.index=t.index,i.input=t.input),i}(e),!l)return Ie(e,s)}else{var h=We(e);n=h==si||"[object GeneratorFunction]"==h;if(ue(e))return Ee(e,l);if(h==li||h==ai||n&&!o){if(s=u||n?{}:ri(e),!l)return u?function(t,e){return ie(t,Oe(t),e)}(e,function(t,e){return t&&ie(e,Ce(e),t)}(s,e)):function(t,e){return ie(t,Pe(t),e)}(e,function(t,e){return t&&ie(e,we(e),t)}(s,e))}else{if(!ui[h])return o?e:{};s=ti(e,h,l)}}if(l=(a=a||new Jt).get(e))return l;a.set(e,s),oi(e)?e.forEach(function(n){s.add(t(n,i,r,n,e,a))}):ni(e)&&e.forEach(function(n,o){s.set(o,t(n,i,r,o,e,a))});u=c?u?De:ze:u?keysIn:we;var d=p?void 0:u(e);return function(t,e){for(var i=-1,r=null==t?0:t.length;++i<r&&!1!==e(t[i],i,t););}(d||e,function(n,o){d&&(n=e[o=n]),ee(s,o,t(n,i,r,o,e,a))}),s},hi=function(t){return pi(t,5)},di=(w(fi,ci=A),fi);function fi(){var e=null!==ci&&ci.apply(this,arguments)||this;return e.layout="icons",e.mapStyles=["road","grayscale_light","grayscale_dark","night","road_shaded_relief"],e.style=t.ControlStyle.light,e.autoSelectionMode=!0,e}var mi;w(yi,mi=X),yi.prototype.onAdd=function(t,e){var i=this;this.map=t;var r=this.buildContainer(t,this.options.style,"Map Style Control"),n=this.buildStyleOpsGrid(r);t=this.buildCurrStyleBtn(r,n);return r.addEventListener("mouseover",function(){i.hasMouse=!0,r.classList.add(yi.Css.inUse),n.classList.remove("hidden-accessible-element")}),r.addEventListener("focusin",function(){i.hasFocus=!0,r.classList.add(yi.Css.inUse),n.classList.remove("hidden-accessible-element")}),r.addEventListener("mouseleave",function(){i.hasMouse=!1,i.hasFocus||(r.classList.remove(yi.Css.inUse),n.classList.add("hidden-accessible-element"))}),r.addEventListener("focusout",function(t){t.relatedTarget instanceof Node&&r.contains(t.relatedTarget)||(i.hasFocus=!1,i.hasMouse||(r.classList.remove(yi.Css.inUse),n.classList.add("hidden-accessible-element")))}),e&&yi.InvertOrderPositions.includes(e.position)?(r.appendChild(n),r.appendChild(t)):(r.appendChild(t),r.appendChild(n)),r},yi.prototype.onRemove=function(){mi.prototype.onRemove.call(this),this.styleButtons.clear(),this.map.events.remove("styledata",this.onStyleChange)},yi.prototype.setSelectedStyle=function(t){var e,i;this.styleIcons.has(t)&&(e=this.currStyleImage,i=this.styleIcons.get(t),e.src!==i&&(e.src=i),t=this.mapToFriendlyStyleName(t),e.alt!==t&&(e.alt=t))},yi.prototype.disableStyle=function(t){(t=this.styleButtons[t])&&t.setAttribute("disabled","true")},yi.prototype.enableStyle=function(t){(t=this.styleButtons[t])&&t.removeAttribute("disabled")},yi.prototype.buildSelectStyleBtn=function(t,e){var i=this,r=document.createElement("button"),n=this.mapToFriendlyStyleName(t);r.setAttribute("title",n),r.setAttribute("alt",n),r.setAttribute("type","button");var o=new Image;return o.src=e,o.alt=n,r.appendChild(o),"icons"===this.options.layout?r.classList.add(yi.Css.button):r.appendChild(document.createTextNode(n)),r.addEventListener("click",function(){var e=i.styleButtons[t];e&&!e.hasAttribute("disabled")&&(i._invokeEvent("styleselected",t),i.options.autoSelectionMode&&i.map.setStyle({style:t}))}),r},yi.prototype.buildCurrStyleBtn=function(t,e){var i=document.createElement("button");i.classList.add(yi.Css.button),i.classList.add(yi.Css.currentStyle),i.setAttribute("title","Select Style"),i.setAttribute("alt","Select Style"),i.setAttribute("type","button"),this.currStyleImage=new Image,i.appendChild(this.currStyleImage);var r=document.createElement("div");return r.classList.add("icon"),i.appendChild(r),i},yi.prototype.buildStyleOpsGrid=function(t){var e=this,i=document.createElement("div");return i.classList.add(yi.Css.styleOptions),i.classList.add(this.options.layout),i.setAttribute("aria-label","Style Options"),i.classList.add("hidden-accessible-element"),this.map.styles.initialize().then(function(){var t,r,n,o=e.map.styles.getDef(),a=e.map.getStyle().style;try{for(var l=E(o.styles),u=l.next();!u.done;u=l.next()){var c=u.value,h=c.thumbnail;(-1<h.indexOf(y)||-1<h.indexOf(g))&&(h=new R({domain:s,path:c.thumbnail.replace(y,v).replace(g,_),queryParams:((n={})[p]="2.0",n)}).toString()),e.styleIcons.set(c.name,h),c.name===a&&(e.currStyleImage.src=h,e.currStyleImage.alt=e.mapToFriendlyStyleName(c.name))}}catch(r){t={error:r}}finally{try{u&&!u.done&&(r=l.return)&&r.call(l)}finally{if(t)throw t.error}}"all"===e.options.mapStyles?e.styleIcons.forEach(function(t,r){t=e.buildSelectStyleBtn(r,t),i.appendChild(t),e.styleButtons[r]=t}):e.options.mapStyles.filter(function(t){return e.styleIcons.has(t)}).forEach(function(t){var r=e.styleIcons.get(t);r=e.buildSelectStyleBtn(t,r);i.appendChild(r),e.styleButtons[t]=r}),e.map.events.add("styledata",e.onStyleChange)}),i},yi.prototype.mapToFriendlyStyleName=function(t){return yi.StyleNamesMap[t]||yi.StyleNamesMap[t+"_indoor"]||t},yi.InvertOrderPositions=[t.ControlPosition.TopRight,t.ControlPosition.BottomRight],yi.Css={button:"azure-maps-control-button",currentStyle:"curr-style",inUse:"in-use",styleOptions:"style-options"},yi.StyleNamesMap={road:"Road",satellite:"Satellite",satellite_road_labels:"Hybrid",grayscale_dark:"Grayscale (Dark)",grayscale_light:"Grayscale (Light)",night:"Night",road_shaded_relief:"Terra",blank:"Blank",blank_accessible:"Blank (Accessible)",high_contrast_dark:"High contrast (Dark)",high_contrast_light:"High contrast (Light)"},ht=yi;function yi(t){var e=mi.call(this)||this;return e.hasMouse=!1,e.hasFocus=!1,e.styleButtons=new H,e.styleIcons=new H,e.onStyleChange=function(){var t;e.options.autoSelectionMode&&(t=e.map.getStyle().style,e.setSelectedStyle(t))},e.options=(new di).merge(hi(t)),e}var gi,vi=(w(_i,gi=A),_i);function _i(){var e=null!==gi&&gi.apply(this,arguments)||this;return e.flow="relative",e.incidents=!0,e.isActive=!1,e.style=t.ControlStyle.light,e}var xi;w(bi,xi=X),bi.prototype.onAdd=function(t){return this.container=this.buildContainer(t,this.options.style,"Traffic Control"),this.container.style.flexDirection="column",t=this.constructTrafficButton(t),this.container.appendChild(t),this.container},bi.prototype.getOptions=function(){return hi(this.options)},bi.prototype.constructTrafficButton=function(t){var e=this,i=document.createElement("button");return i.classList.add("azure-maps-control-button"),i.classList.add("traffic"),i.setAttribute("title","Toggle Traffic Display"),i.setAttribute("alt","Toggle Traffic Display"),i.setAttribute("type","button"),i.addEventListener("click",function(){var i=t.getTraffic();e.options.isActive=!("none"!==i.flow||i.incidents),e.options.isActive?(t.setTraffic({flow:e.options.flow,incidents:e.options.incidents}),e.container.classList.add("in-use")):(t.setTraffic({flow:"none",incidents:!1}),e.container.classList.remove("in-use"))}),t.events.addOnce("styledata",function(){e.options.isActive&&i.dispatchEvent(new Event("click"))}),i},St=bi;function bi(t){var e=xi.call(this)||this;return e.hasMouse=!1,e.hasFocus=!1,e.options=(new vi).merge(t),e}var wi;w(Si,wi=X),Si.prototype.onAdd=function(e){var i=this.buildContainer(e,t.ControlStyle.auto,"Traffic Legend");e=this.buildTrafficLegendDiv(e);return i.appendChild(e),i},Si.prototype.buildTrafficLegendDiv=function(t){var e,i,r,n,o=document.createElement("div");o.classList.add("traffic-legend","hidden"),o.setAttribute("title","Traffic Legend"),o.setAttribute("alt","Traffic Legend");var a=document.createElement("table"),s=document.createElement("tr"),l=document.createElement("td");l.setAttribute("title","Traffic"),l.setAttribute("alt","Traffic"),l.appendChild(document.createTextNode("Traffic")),l.classList.add("traffic-legend-title"),l.colSpan=6,s.appendChild(l),a.appendChild(s);var u=document.createElement("tr");try{for(var c=E(this.table),p=c.next();!p.done;p=c.next()){var h=p.value,d=document.createElement("td");if("Fast"===h||"Slow"===h)d.setAttribute("title",h),d.setAttribute("alt",h),d.appendChild(document.createTextNode(h)),d.classList.add("traffic-legend-text");else{d.classList.add("traffic-legend-colors");try{for(var f=(r=void 0,E(h)),m=f.next();!m.done;m=f.next()){var y=m.value,g=document.createElement("div");g.classList.add(y),d.appendChild(g)}}catch(i){r={error:i}}finally{try{m&&!m.done&&(n=f.return)&&n.call(f)}finally{if(r)throw r.error}}}u.appendChild(d)}}catch(i){e={error:i}}finally{try{p&&!p.done&&(i=c.return)&&i.call(c)}finally{if(e)throw e.error}}return a.appendChild(u),o.appendChild(a),t.events.add("styledata",function(e){"style"===e.dataType&&((e=t.getTraffic()).flow&&"none"!==e.flow?o.classList.remove("hidden"):o.classList.add("hidden"))}),o},vt=Si;function Si(){var t=wi.call(this)||this;return t.table=["Fast",["green","yellow","red","dark-red"],"Slow"],t}function Ti(t){var e=-1,i=null==t?0:t.length;for(this.__data__=new Xt;++e<i;)this.add(t[e])}dt=function(t){return this.__data__.has(t)},Ti.prototype.add=Ti.prototype.push=function(t){return this.__data__.set(t,"__lodash_hash_undefined__"),this},Ti.prototype.has=dt;var Ci=Ti,Ei=function(t,e){for(var i=-1,r=null==t?0:t.length;++i<r;)if(e(t[i],i,t))return!0;return!1},Ii=function(t,e){return t.has(e)},ki=function(t,e,i,r,n,o){var a=1&i,s=t.length,l=e.length;if(s!=l&&!(a&&s<l))return!1;if((l=o.get(t))&&o.get(e))return l==e;var u=-1,c=!0,p=2&i?new Ci:void 0;for(o.set(t,e),o.set(e,t);++u<s;){var h,d=t[u],f=e[u];if(void 0!==(h=r?a?r(f,d,u,e,t,o):r(d,f,u,t,e,o):h)){if(h)continue;c=!1;break}if(p){if(!Ei(e,function(t,e){if(!Ii(p,e)&&(d===t||n(d,t,i,r,o)))return p.push(e)})){c=!1;break}}else if(d!==f&&!n(d,f,i,r,o)){c=!1;break}}return o.delete(t),o.delete(e),c};function Ai(t){var e=-1,i=Array(t.size);return t.forEach(function(t,r){i[++e]=[r,t]}),i}function Pi(t){var e=-1,i=Array(t.size);return t.forEach(function(t){i[++e]=t}),i}var Mi,Li=(xt=Ct?Ct.prototype:void 0)?xt.valueOf:void 0,Oi=Object.prototype.hasOwnProperty,Ri="[object Arguments]",zi="[object Array]",Di="[object Object]",Ni=Object.prototype.hasOwnProperty,Bi=function(t,e,i,r,n,o){var a=se(t),s=se(e),l=a?zi:We(t),u=s?zi:We(e),c=(l=l==Ri?Di:l)==Di;s=(u=u==Ri?Di:u)==Di;if((u=l==u)&&ue(t)){if(!ue(e))return!1;c=!(a=!0)}return u&&!c?(o=o||new Jt,a||fe(t)?ki(t,e,i,r,n,o):function(t,e,i,r,n,o,a){switch(i){case"[object DataView]":if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case"[object ArrayBuffer]":return!(t.byteLength!=e.byteLength||!o(new Xe(t),new Xe(e)));case"[object Boolean]":case"[object Date]":case"[object Number]":return ut(+t,+e);case"[object Error]":return t.name==e.name&&t.message==e.message;case"[object RegExp]":case"[object String]":return t==e+"";case"[object Map]":var s=Ai;case"[object Set]":if(s=s||Pi,t.size!=e.size&&!(1&r))return!1;var l=a.get(t);return l?l==e:(r|=2,a.set(t,e),s=ki(s(t),s(e),r,n,o,a),a.delete(t),s);case"[object Symbol]":if(Li)return Li.call(t)==Li.call(e)}return!1}(t,e,l,i,r,n,o)):1&i||(c=c&&Ni.call(t,"__wrapped__"),s=s&&Ni.call(e,"__wrapped__"),!c&&!s)?!!u&&function(t,e,i,r,n,o){var a=1&i,s=ze(t),l=s.length;if(l!=ze(e).length&&!a)return!1;for(var u=l;u--;){var c=s[u];if(!(a?c in e:Oi.call(e,c)))return!1}var p=o.get(t);if(p&&o.get(e))return p==e;var h=!0;o.set(t,e),o.set(e,t);for(var d,f=a;++u<l;){var m,y=t[c=s[u]],g=e[c];if(!(void 0===(m=r?a?r(g,y,c,e,t,o):r(y,g,c,t,e,o):m)?y===g||n(y,g,i,r,o):m)){h=!1;break}f=f||"constructor"==c}return!h||f||(d=t.constructor)!=(p=e.constructor)&&"constructor"in t&&"constructor"in e&&!("function"==typeof d&&d instanceof d&&"function"==typeof p&&p instanceof p)&&(h=!1),o.delete(t),o.delete(e),h}(t,e,i,r,n,o=o||new Jt):n(c?t.value():t,s?e.value():e,i,r,o=o||new Jt)},Fi=function(t,e){return function t(e,i,r,n,o){return e===i||(null==e||null==i||!re(e)&&!re(i)?e!=e&&i!=i:Bi(e,i,r,n,t,o))}(t,e)},Ui=(Mi=Object.freeze({__proto__:null,default:{}}))&&Mi.default||Mi,ji=i(function(t){!function(){for(var e,i,r=0,n=[],o=0;o<256;o++)n[o]=(o+256).toString(16).substr(1);function a(){var t;return(t=(t=16,(!e||s.BUFFER_SIZE<r+t)&&(r=0,e=s.randomBytes(s.BUFFER_SIZE)),e.slice(r,r+=t)))[6]=15&t[6]|64,t[8]=63&t[8]|128,t}function s(){var t=a();return n[t[0]]+n[t[1]]+n[t[2]]+n[t[3]]+"-"+n[t[4]]+n[t[5]]+"-"+n[t[6]]+n[t[7]]+"-"+n[t[8]]+n[t[9]]+"-"+n[t[10]]+n[t[11]]+n[t[12]]+n[t[13]]+n[t[14]]+n[t[15]]}s.BUFFER_SIZE=4096,s.bin=a,s.clearBuffer=function(){e=null,r=0},s.test=function(t){return"string"==typeof t&&/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)},"undefined"!=typeof crypto?i=crypto:"undefined"!=typeof window&&void 0!==window.msCrypto&&(i=window.msCrypto),i=i||Ui,(t.exports=s).randomBytes=function(){if(i){if(i.randomBytes)return i.randomBytes;if(i.getRandomValues)return"function"!=typeof Uint8Array.prototype.slice?function(t){return t=new Uint8Array(t),i.getRandomValues(t),Array.from(t)}:function(t){return t=new Uint8Array(t),i.getRandomValues(t),t}}return function(t){for(var e=[],i=0;i<t;i++)e.push(Math.floor(256*Math.random()));return e}}()}()}),Vi=(qi.TYPE="Feature",qi);function qi(t,e,i,r){this.type="Feature",this.type=qi.TYPE,this.properties=e||{},this.id=i,this.geometry=t,this.bbox=r}var Hi,Gi=(w(Zi,Hi=Array),Zi.fromData=function(t){var e=NaN,i=NaN,r=new Set(["y"]),n=new Set(["x"]);return Object.keys(t).forEach(function(o){var a=o.toLowerCase();isNaN(e)&&r.has(a)&&"number"==typeof t[o]?e=t[o]:isNaN(i)&&n.has(a)&&"number"==typeof t[o]&&(i=t[o])}),isNaN(e)||isNaN(i)?null:new Zi(e,i)},Zi.getX=function(t){return 0<t.length?t[0]:NaN},Zi.getY=function(t){return 1<t.length?t[1]:NaN},Zi.getDestination=function(t,e,i){return new Zi(Zi.getX(t)+i*Math.cos((e+270)*Math.PI/180),Zi.getY(t)+i*Math.sin((e+270)*Math.PI/180))},Zi.getDistance=function(t,e){var i=Zi.getX(t)-Zi.getX(e);e=Zi.getY(t)-Zi.getY(e);return Math.sqrt(i*i+e*e)},Zi.getHeading=function(t,e){var i=Zi.getX(e)-Zi.getX(t);e=Zi.getY(t)-Zi.getY(e);return 180*(2.5*Math.PI-Math.atan2(e,i))/Math.PI%360},Zi);function Zi(t,e){return Hi.call(this,t,e)||this}var Wi=(Ki.TYPE="Point",Ki);function Ki(t){this.type="Point",this.type=Ki.TYPE,this.coordinates=t}var Xi,Yi=i(function(t,e){function i(t,e){return t*t+e*e}e.__esModule=!0,e.SimplifyAP=function(t,e,r){if(t.length<=2)return t;var n,o=(e=void 0===e?1:e)*e;return t=(r=void 0!==r&&r)?t:function(t,e){for(var r,n,o,a=t[0],s=[a],l=1,u=t.length;l<u;l++)o=a,i((n=r=t[l])[0]-o[0],n[1]-o[1])>e&&(s.push(r),a=r);return a!==r&&s.push(r),s}(t,o),e=(n=t).length-1,function t(e,r,n,o,a){for(var s,l,u,c,p,h,d,f=o,m=r+1;m<n;m++){var y=(l=e[m],u=e[r],c=e[n],y=p=void 0,p=u[0],y=u[1],h=c[0]-p,d=c[1]-y,0==h&&0==d||(1<(u=((l[0]-p)*h+(l[1]-y)*d)/i(h,d))?(p=c[0],y=c[1]):0<u&&(p+=h*u,y+=d*u)),i(l[0]-p,l[1]-y));f<y&&(s=m,f=y)}o<f&&(1<s-r&&t(e,r,s,o,a),a.push(e[s]),1<n-s&&t(e,s,n,o,a))}(n,0,e,o,r=[n[0]]),r.push(n[e]),r}});(Xi=Yi)&&Xi.__esModule&&Object.prototype.hasOwnProperty.call(Xi,"default")&&Xi.default;var Ji,Qi,$i,tr,er,ir=Yi.SimplifyAP,rr=6378137,nr=Math.PI/180,or=180/Math.PI,ar=[1,10,100,1e3,1e4,1e5,1e6,1e7,1e8,1e9];function sr(t){return t*nr}function lr(t,e,i){return Math.min(Math.max(t,e),i)}function ur(t,e){var i=sr(e[1]-t[1]),r=sr(e[0]-t[0]);r=Math.pow(Math.sin(i/2),2)+Math.cos(sr(t[1]))*Math.cos(sr(e[1]))*Math.pow(Math.sin(r/2),2),r=2*Math.atan2(Math.sqrt(r),Math.sqrt(1-r));return Math.round(rr*r*100)/100}function cr(t){if(t)switch(t.toLowerCase()){case"feet":case"foot":case"ft":return Qi.feet;case"kilometers":case"kilometer":case"kilometres":case"kilometre":case"km":case"kms":return Qi.kilometers;case"miles":case"mile":case"mi":return Qi.miles;case"nauticalmiles":case"nauticalmile":case"nms":case"nm":return Qi.nauticalMiles;case"yards":case"yard":case"yds":case"yrd":case"yrds":return Qi.yards;default:return Qi.meters}return Qi.meters}function pr(t){if(t)switch(t.toLowerCase()){case"milespersecondsquared":case"milepersecondsquared":case"mi/s^2":case"mi/s2":return er.milesPerSecondSquared;case"kilometerspersecondsquared":case"kilometrespersecondsquared":case"kilometerpersecondsquared":case"kilometrepersecondsquared":case"km/s^2":case"km/s2":return er.kilometersPerSecondSquared;case"knotspersecond":case"knotpersecond":case"knts/s":case"kn/s":case"kt/s":return er.knotsPerSecond;case"standardgravity":case"g":return er.standardGravity;case"feetpersecondsquared":case"footpersecondsquared":case"ft/s^2":case"ft/s2":return er.feetPerSecondSquared;case"yardspersecondsquared":case"yardpersecondsquared":case"yds/s^2":case"yds/s2":case"yd/s^2":case"yd/s2":return er.yardsPerSecondSquared;case"milesperhoursecond":case"mileperhoursecond":case"milesperhourseconds":case"mileperhourseconds":case"mi/h/s":return er.milesPerHourSecond;case"kilometersperhoursecond":case"kilometrespersoursecond":case"kilometerperhoursecond":case"kilometrepersoursecond":case"kilometersperhourssecond":case"kilometrespersourssecond":case"kilometerperhourssecond":case"kilometrepersourssecond":case"kmhs":case"km/h/s":return er.kilometersPerHourSecond;default:return er.metersPerSecondSquared}return er.metersPerSecondSquared}function hr(t){if(t)switch(t){case"acres":case"ac":return Ji.acres;case"hectares":case"ha":return Ji.hectares;case"squareFeet":case"ft^2":case"ft2":return Ji.squareFeet;case"squareYards":case"squareYard":case"yds^2":case"yds2":case"yd^2":case"yd2":return Ji.squareYards;case"squareKilometers":case"squareKilometres":case"squareKilometer":case"squareKilometre":case"km^2":case"km2":return Ji.squareKilometers;case"squareMiles":case"squareMile":case"mi^2":case"mi2":return Ji.squareMiles;default:return Ji.squareMeters}return Ji.squareMeters}function dr(t){if(t)switch(t.toLowerCase()){case"feetpersecond":case"footsecond":case"ftps":case"ft/s":return tr.feetPerSecond;case"milesperhour":case"mileperhour":case"mph":case"mi/hr":case"mi/h":return tr.milesPerHour;case"knots":case"knot":case"knts":case"knt":case"kn":case"kt":return tr.knots;case"mach":case"m":return tr.mach;case"kilometersperhour":case"kilometresperhour":case"kmperhour":case"kmph":case"km/hr":case"km/h":return tr.kilometersPerHour;default:return tr.metersPerSecond}return tr.metersPerSecond}function fr(t){if(t)switch(t.toLowerCase()){case"milliseconds":case"ms":return $i.ms;case"minutes":case"minute":case"mins":case"min":return $i.minutes;case"hours":case"hour":case"hr":case"h":return $i.hours;case"days":case"day":case"d":return $i.days;default:return $i.seconds}return $i.seconds}function mr(t){var e=0;if(t&&0<t.length){e=Math.abs(yr(t[0]));for(var i=1,r=t.length;i<r;i++)e-=Math.abs(yr(t[i]))}return e}function yr(t){var e=0;if(3<=t.length){for(var i=void 0,r=void 0,n=0,o=t.length;n<o;n++)e+=(sr(t[n===o-2?(i=o-2,r=o-1,0):n===o-1?(i=o-1,r=0,1):(r=(i=n)+1,n+2)][0])-sr(t[i][0]))*Math.sin(sr(t[r][1]));e=e*rr*rr/2}return e}function gr(t,e,i){return(t[0]-i[0])*(e[1]-i[1])-(t[1]-i[1])*(e[0]-i[0])}function vr(t,e,i){if(2<=i.length){for(var r,n,o=1/0,a=null,s=Or(i,22),l=0,u=s.length-1;l<u;l++)n=function(t,e,i){if(e[0]===i[0]&&e[1]===i[1])return e;var r=t[0]-e[0],n=t[1]-e[1],o=i[0]-e[0];return(n=(o*r+(t=i[1]-e[1])*n)/(o*o+t*t))<0?e:1<n?i:[e[0]+o*n,e[1]+t*n]}(e,s[l],s[l+1]),(r=Gi.getDistance(e,n))<o&&(o=r,a=n);if(a){var c=Lr([a],22)[0];return new Vi(new Wi(c),{distance:wr(t,c)})}}else if(1===i.length)return new Vi(new Wi(i[0]),{distance:wr(t,i[0])});return null}function _r(t,e){var i;return!isNaN(t)&&"number"==typeof e&&0<=e&&(void 0,i=e<ar.length?ar[e]:Math.pow(10,e),t=Math.round(t*i)/i),t}function xr(t,e,i,r){switch(cr(e)){case Qi.meters:t/=1e3;break;case Qi.feet:t/=3280.8399;break;case Qi.miles:t/=.62137119;break;case Qi.yards:t/=1093.6133;break;case Qi.nauticalMiles:t/=.5399568;break;case Qi.kilometers:}switch(cr(i)){case Qi.meters:t*=1e3;break;case Qi.feet:t*=3280.8399;break;case Qi.miles:t*=.62137119;break;case Qi.yards:t*=1093.6133;break;case Qi.nauticalMiles:t*=.5399568;break;case Qi.kilometers:}return"number"==typeof r&&0<=r&&(r=Math.pow(10,r),t=Math.round(t*r)/r),t}function br(t,e,i,r){r=r||"meters",t=qr(t);var n=Sr(r);r=sr(t[1]),t=sr(t[0]),e*=nr,i/=n,n=Math.asin(Math.sin(r)*Math.cos(i)+Math.cos(r)*Math.sin(i)*Math.cos(e)),r=t+Math.atan2(Math.sin(e)*Math.sin(i)*Math.cos(r),Math.cos(i)-Math.sin(r)*Math.sin(n)),n=lr(Ar(n*or),-85,85);return[Pr(r*or),n]}function wr(t,e,i){return e=ur(t=qr(t),e=qr(e)),"meters"===i?e:xr(e,"meters",i||"meters")}function Sr(t){return t=cr(t),xr(rr,Qi.meters,t)}function Tr(t,e){if(t=qr(t),e=qr(e),t&&2<=t.length&&e&&2<=e.length){var i=sr(t[1]),r=sr(e[1]);e=sr(e[0]-t[0]),t=Math.sin(e)*Math.cos(r),e=Math.cos(i)*Math.sin(r)-Math.sin(i)*Math.cos(r)*Math.cos(e);return(function(t){return t*or}(Math.atan2(t,e))+360)%360}return NaN}function Cr(t,e){var i,r=0;Array.isArray(t)?i=t:t.type&&"LineString"===t.type&&(i=t.coordinates);for(var n=0,o=i.length-1;n<o;n++)r+=ur(i[n],i[n+1]);return xr(r,"meters",e||"meters")}function Er(t,e,i){i=i||"meters";var r,n,o=0;if(Array.isArray(t)?n=t:t.type&&"LineString"===t.type&&(n=t.coordinates),2<=n.length){for(var a=n.length,s=1;s<a;s++){if(e<=o+(r=wr(n[s-1],n[s],i))){var l=Tr(n[s-1],n[s]);return br(n[s-1],l,e-o,i)}o+=r}return o<=e?n[a-1]:n[0]}return null}function Ir(t,e,i,r,n){r=r||"meters",n=n||0,t=qr(t);for(var o=[],a=360/i,s=0;s<=i;s++)o.push(br(t,(s*a+n)%360,e,r));return o}function kr(t,e,i){i=void 0===i?.5:i;var r=wr(t=qr(t),e=qr(e),"kilometers");return br(t,Tr(t,e),r*i,"kilometers")}function Ar(t){return 90<t?180<(t=(t+90)%360)?90-(t-180):t-90:t<-90?(t=(t-90)%360)<-180?-90-(t+180):t+90:t}function Pr(t){return 180<t?(t+180)%360-180:t<-180?(t-180)%360+180:t}function Mr(t,e,i){if(0===i)return Object.assign({},t);e=qr(e);for(var r,n,o=[],a=0,s=t.length;a<s;a++)r=wr(e,t[a]),n=Tr(e,t[a]),o.push(br(e,n+i,r));return o}function Lr(t,e){for(var i,r,n=512*Math.pow(2,e),o=[],a=0,s=t.length;a<s;a++)i=t[a][0]/n-.5,r=.5-t[a][1]/n,o.push([360*i,90-360*Math.atan(Math.exp(2*-r*Math.PI))/Math.PI]);return o}function Or(t,e){for(var i,r,n=512*Math.pow(2,e),o=[],a=0,s=t.length;a<s;a++)r=Math.sin(t[a][1]*Math.PI/180),i=(t[a][0]+180)/360,r=.5-Math.log((1+r)/(1-r))/(4*Math.PI),o.push([Math.round(i*n),Math.round(r*n)]);return o}function Rr(t,e,i,r){switch(pr(e)){case er.kilometersPerHourSecond:t/=3.6;break;case er.milesPerHourSecond:t/=2.236936292054;break;case er.knotsPerSecond:t/=1.943844492441;break;case er.standardGravity:t/=.1019716212978;break;case er.kilometersPerSecondSquared:t/=.001;break;case er.milesPerSecondSquared:t/=.000621371192;break;case er.feetPerSecondSquared:t/=3.280839895012;break;case er.yardsPerSecondSquared:t/=1.093613298338;break;case er.metersPerSecondSquared:}switch(pr(i)){case er.kilometersPerHourSecond:t*=3.6;break;case er.milesPerHourSecond:t*=2.236936292054;break;case er.knotsPerSecond:t*=1.943844492441;break;case er.standardGravity:t*=.1019716212978;break;case er.kilometersPerSecondSquared:t*=.001;break;case er.milesPerSecondSquared:t*=.000621371192;break;case er.feetPerSecondSquared:t*=3.280839895012;break;case er.yardsPerSecondSquared:t*=1.093613298338;break;case er.metersPerSecondSquared:}return _r(t,r)}function zr(t,e,i,r){switch(hr(e)){case Ji.acres:t*=4046.8564224;break;case Ji.hectares:t*=1e4;break;case Ji.squareFeet:t*=.09290304;break;case Ji.squareKilometers:t*=1e6;break;case Ji.squareMiles:t*=259e4;break;case Ji.squareYards:t*=.83612736;break;case Ji.squareMeters:}switch(hr(i)){case Ji.acres:t/=4046.8564224;break;case Ji.hectares:t/=1e4;break;case Ji.squareFeet:t/=.09290304;break;case Ji.squareKilometers:t/=1e6;break;case Ji.squareMiles:t/=259e4;break;case Ji.squareYards:t/=.83612736;break;case Ji.squareMeters:}return _r(t,r)}function Dr(t,e,i,r){switch(dr(e)){case tr.feetPerSecond:t*=1.09728;break;case tr.milesPerHour:t*=1.6093;break;case tr.knots:t*=1.852;break;case tr.metersPerSecond:t*=3.6;break;case tr.mach:t*=1234.8;break;case tr.kilometersPerHour:}switch(dr(i)){case tr.feetPerSecond:t/=1.09728;break;case tr.milesPerHour:t/=1.6093;break;case tr.knots:t/=1.852;break;case tr.metersPerSecond:t/=3.6;break;case tr.mach:t/=1234.8;break;case tr.kilometersPerHour:}return _r(t,r)}function Nr(t,e,i,r){switch(fr(e)){case $i.ms:t/=1e3;break;case $i.hours:t*=3600;break;case $i.minutes:t*=60;break;case $i.days:t*=86400;break;case $i.seconds:}switch(fr(i)){case $i.ms:t*=1e3;break;case $i.hours:t/=3600;break;case $i.minutes:t/=60;break;case $i.days:t/=86400;break;case $i.seconds:}return _r(t,r)}function Br(t,e,i,r,n,o,a,s){return n=xr(e,n,Qi.meters),o=Nr(i,o,$i.seconds),Rr(2*(n-Dr(t,r,tr.metersPerSecond)*o)/(o*o),er.metersPerSecondSquared,a,s)}function Fr(t,e,i,r,n,o,a){return t=Dr(t,r,tr.metersPerSecond),Rr((Dr(e,r,tr.metersPerSecond)-t)/Nr(i,n,$i.seconds),er.metersPerSecondSquared,o,a)}function Ur(t,e,i,r){return t=jr(t),e=jr(e),null!=t&&null!=e?Nr(e.getTime()-t.getTime(),$i.ms,i,r):NaN}function jr(t){if("[object Date]"===Object.prototype.toString.call(t))return t;if("string"==typeof t){var e=Date.parse(t);if(!isNaN(e))return new Date(e);if(0<=t.indexOf("Date("))return e=0,e=0<(t=t.replace("/Date(","").replace(")/","")).indexOf("+")?parseInt(t.substr(0,t.indexOf("+")),10):0<t.indexOf("-")?parseInt(t.substr(0,t.indexOf("-")),10):parseInt(t,10),new Date(e)}else if("number"==typeof t)return new Date(t);return null}function Vr(t){var e=[],i=null,r=null;if(Array.isArray(t)&&0<t.length)if(Array.isArray(t[0])&&"number"==typeof t[0][0])e=t;else for(var n=t.length,o=0;o<n;o++)e=e.concat(Vr(t[o]));else if(t.type)switch(t.type){case"Point":e=[t.coordinates];break;case"LineString":e=t.coordinates;break;case"Polygon":i=t.coordinates;break;case"MultiPoint":e=t.coordinates;break;case"MultiLineString":i=t.coordinates;break;case"MultiPolygon":r=t.coordinates;break;case"Feature":var a=t;e=tn._isCircle(a)?tn._getCirclePositions(a):Vr(a.geometry);break;case"FeatureCollection":e=Vr(t.features);break;case"GeometryCollection":e=Vr(t.geometries)}else if(t instanceof tn)return Vr(t.toJson());if(i)for(n=i.length,o=0;o<n;o++)e=e.concat(i[o]);else if(r){var s=r.length;for(o=0;o<s;o++)for(var l=r[o].length,u=0;u<l;u++)e=e.concat(r[o][u])}return e}function qr(t){if(Array.isArray(t)&&"number"==typeof t[0])return t;if(t.type){if("Point"===t.type)return t.coordinates;if("Feature"===t.type&&"Point"===t.geometry.type)return t.geometry.coordinates}else if(t instanceof tn&&"Point"===t.getType())return t.getCoordinates();return null}function Hr(t,e,i){i=i||"meters";var r,n,o=0;if(Array.isArray(t)?n=t:t.type&&"LineString"===t.type&&(n=t.coordinates),2<=n.length){for(var a=n.length,s=1;s<a;s++){if(e<=o+(r=wr(n[s-1],n[s],i))){var l=Tr(n[s-1],n[s]),u=br(n[s-1],l,e-o,i);return new Vi(new Wi(u),{heading:l})}o+=r}return o<=e?new Vi(new Wi(n[a-1]),{heading:Tr(n[a-2],n[a-1])}):new Vi(new Wi(n[0]),{heading:Tr(n[0],n[1])})}return null}function Gr(t,e,i,r){var n=qr(t),o=Or([n],22)[0],a=null,s=1/0;switch((e=e instanceof tn?e.toJson():e).type){case"Feature":return Gr(t,e.geometry,i);case"Point":d=[[e.coordinates]];break;case"MultiPoint":for(var l,u=e.coordinates,c=0,p=u.length;c<p;c++)(l=wr(n,u[c]))<s&&(s=l,a=new Vi(new Wi(u[c]),{distance:l}));break;case"LineString":d=[e.coordinates];break;case"Polygon":case"MultiLineString":d=e.coordinates;break;case"MultiPolygon":var h=e.coordinates;if(0<h.length){var d=h[0];for(c=1,p=h.length;c<p;c++)d=d.concat(h[c])}}if(d){var f;for(c=0,p=d.length;c<p;c++)(f=vr(n,o,d[c]))&&f.properties.distance<s&&(s=f.properties.distance,a=f)}return a&&(a.properties.distance=xr(a.properties.distance,"meters",i,r)),a}(_t=Ji=Ji||{}).squareMeters="squareMeters",_t.acres="acres",_t.hectares="hectares",_t.squareFeet="squareFeet",_t.squareKilometers="squareKilometers",_t.squareMiles="squareMiles",_t.squareYards="squareYards",(mt=Qi=Qi||{}).meters="meters",mt.kilometers="kilometers",mt.feet="feet",mt.miles="miles",mt.nauticalMiles="nauticalMiles",mt.yards="yards",(ft=$i=$i||{}).seconds="seconds",ft.hours="hours",ft.ms="ms",ft.minutes="minutes",ft.days="days",(e=tr=tr||{}).metersPerSecond="metersPerSecond",e.kilometersPerHour="kilometersPerHour",e.feetPerSecond="feetPerSecond",e.milesPerHour="milesPerHour",e.knots="knots",e.mach="mach",(bt=er=er||{}).milesPerSecondSquared="milesPerSecondSquared",bt.kilometersPerSecondSquared="kilometersPerSecondSquared",bt.knotsPerSecond="knotsPerSecond",bt.standardGravity="standardGravity",bt.feetPerSecondSquared="feetPerSecondSquared",bt.yardsPerSecondSquared="yardsPerSecondSquared",bt.milesPerHourSecond="milesPerHourSecond",bt.kilometersPerHourSecond="kilometersPerHourSecond",bt.metersPerSecondSquared="metersPerSecondSquared";var Zr,Wr=(w(Kr,Zr=Array),Kr.fromPosition=function(t){return 2===t.length?new Kr(t[0],t[1]):2<t.length?new Kr(t[0],t[1],t[2]):null},Kr.areEqual=function(t,e,i){if(void 0===i&&(i=6),t&&2<=t.length&&e&&2<=e.length){var r=Math.pow(10,i),n=Ar(t[1]);i=Ar(e[1]),t=Pr(t[0]),e=Pr(e[0]);return 0==Math.round((n-i)*r)/r&&(0==(r=Math.round((t-e)*r)/r)||360==r)}return!1},Kr.fromLatLng=function(t,e,i){var r,n,o,a,s,l,u=[];return"number"==typeof t?(u.push(t),"number"==typeof e&&u.push(e),"number"==typeof i&&u.push(i)):Array.isArray(t)?2<=t.length&&"number"==typeof t[0]&&"number"==typeof t[1]&&(3<=t.length&&"number"==typeof t[2]?u.push(t[0],t[1],t[2]):u.push(t[0],t[1])):"object"==typeof t&&(r=["lat","latitude","y"],n=["lng","longitude","lon","x"],o=["elv","elevation","alt","altitude","z"],l=s=a=NaN,Object.keys(t).forEach(function(e,i,u){var c=e.toLowerCase();isNaN(a)&&0<=r.indexOf(c)&&"number"==typeof t[e]?a=t[e]:isNaN(s)&&0<=n.indexOf(c)&&"number"==typeof t[e]?s=t[e]:isNaN(l)&&0<=o.indexOf(c)&&"number"==typeof t[e]&&(l=t[e])}),isNaN(a)||isNaN(s)||(u.push(s,a),isNaN(l)||u.push(l))),2<=u.length?u:null},Kr.fromLatLngs=function(t){var e=[];if(Array.isArray(t))for(var i=0,r=t.length;i<r;i++){var n=Kr.fromLatLng(t[i]);n&&e.push(n)}return e},Kr._getDimensions=function(t){for(var e=0;Array.isArray(t);)t=t[0],e++;return"number"==typeof t&&e--,e},Kr);function Kr(t,e,i){return i?Zr.call(this,t,e,i)||this:Zr.call(this,t,e)||this}var Xr=(Yr.TYPE="Polygon",Yr);function Yr(t,e){this.type="Polygon",this.type=Yr.TYPE,1===Wr._getDimensions(t)?this.coordinates=[t]:this.coordinates=t,this.bbox=e}var Jr=(Qr.prototype.toTarget=function(t,e){return this.transformArray(t,this.M,e)},Qr.prototype.toSource=function(t,e){return this.transformArray(t,this.inverseM,e)},Qr.prototype.transformArray=function(t,e,i){var r,n;if(t&&Array.isArray(t)&&Array.isArray(t[0])){var o=[];try{for(var a=E(t),s=a.next();!s.done;s=a.next()){var l=s.value;o.push(this.transform(l,e,i))}}catch(t){r={error:t}}finally{try{s&&!s.done&&(n=a.return)&&n.call(a)}finally{if(r)throw r.error}}return o}return null},Qr.prototype.transform=function(t,e,i){var r=t[0]*e[0][3]+t[1]*e[1][3]+e[2][3];e=t[0]*e[0][4]+t[1]*e[1][4]+e[2][4];return"number"==typeof i&&0<=i?[_r(r,i),_r(e,i)]:[_r(r,6),_r(e,6)]},Qr._calculateAffineTransform=function(t,e){if(t.length!==e.length||t.length<1)throw new Error("Error: source and target arrays must have the same length.");var i=Math.min(t[0].length,e[0].length),r=i+1;if(t.length<i)throw new Error("Erorr: At least "+i+" reference points required.");for(var n=[],o=[],a=0;a<r;a++){o[a]=[];for(var s=0;s<r;s++){s<i&&(n[s]=0);for(var l=o[a][s]=0;l<t.length;l++)s<i&&(n[s]+=a<i?t[l][a]*e[l][s]:e[l][s]),o[a][s]+=i<=a&&i<=s?1:i<=a?t[l][s]:i<=s?t[l][a]:t[l][a]*t[l][s]}o[a]=o[a].concat(n)}if(!this._gaussJordanElimination(o))throw new Error("Error: Singular matrix. Points are likely coplanar.");return o},Qr._gaussJordanElimination=function(t){for(var e,i=t.length,r=2*i-1,n=0;n<i;n++){for(var o=n,a=n+1;a<i;a++)Math.abs(t[a][n])>Math.abs(t[o][n])&&(o=a);if(e=t[o],t[o]=t[n],t[n]=e,Math.abs(t[n][n])<=1e-10)return!1;for(var s=n+1;s<i;s++)for(var l=t[s][n]/t[n][n],u=n;u<r;u++)t[s][u]-=t[n][u]*l}for(n=i-1;-1<n;n--){for(l=t[n][n],a=0;a<n;a++)for(var c=r-1;n-1<c;c--)t[a][c]-=t[n][c]*t[a][n]/l;t[n][n]/=l;for(var p=i;p<r;p++)t[n][p]/=l}return!0},Qr);function Qr(t,e){this.M=Qr._calculateAffineTransform(t,e),this.inverseM=Qr._calculateAffineTransform(e,t)}dt=Object.freeze({__proto__:null,AffineTransform:Jr,_precision:_r,get AreaUnits(){return Ji},get DistanceUnits(){return Qi},get TimeUnits(){return $i},get SpeedUnits(){return tr},get AccelerationUnits(){return er},boundingBoxToPolygon:function(t){var e=Pr(nn.getWest(t)),i=Pr(nn.getEast(t)),r=Ar(nn.getNorth(t)),n=Ar(nn.getSouth(t));r=[[e,r],[e,n],[(t=nn.getCenter(t))[0],n],[i,n],[i,r],[t[0],r],[e,r]];return new Xr([r])},convertDistance:xr,getCardinalSpline:function(t,e,i,r){if(!t||t.length<=2)return o;"number"!=typeof e&&(e=.5),("number"!=typeof i||i<=0)&&(i=15);var n=t.length,o=t.slice(0);r?(Wr.areEqual(o[0],o[n-1])&&(o.pop(),n--),o.unshift(t[n-1]),o.push(t[0]),o.push(t[1]),n++):(o.unshift(t[0]),o.push(t[n-1]));var a,s,l,u=[];u.push([1,0,0,0]);for(var c=1;c<i-1;c++)u.push([2*(l=(a=c/i)*(s=a*a))-3*s+1,-2*l+3*s,l-2*s+a,l-s]);u.push([0,1,0,0]);var p,h,d,f,m,y,g=[];for(c=1;c<n;c++)for(p=e*(o[c+1][0]-o[c-1][0]),h=e*(o[c+1][1]-o[c-1][1]),d=e*(o[c+2][0]-o[c][0]),f=e*(o[c+2][1]-o[c][1]),a=0;a<i;a++)y=(m=u[a])[0]*o[c][0]+m[1]*o[c+1][0]+m[2]*p+m[3]*d,m=lr(m[0]*o[c][1]+m[1]*o[c+1][1]+m[2]*h+m[3]*f,-85,85),g.push([y,m]);return g},getDestination:br,getDistanceTo:wr,getEarthRadius:Sr,getGeodesicPath:function(t,e){var i;(!e||e<=0)&&(e=15),Array.isArray(t)?i=t:t.type&&"LineString"===t.type&&(i=t.coordinates);for(var r=i.length-1,n=[],o=0;o<r;o++)for(var a=sr(i[o][1]),s=sr(i[o][0]),l=sr(i[o+1][1]),u=sr(i[o+1][0]),c=2*Math.asin(Math.sqrt(Math.pow(Math.sin((a-l)/2),2)+Math.cos(a)*Math.cos(l)*Math.pow(Math.sin((s-u)/2),2))),p=0;p<=e;p++){var h=p/e,d=Math.sin((1-h)*c)/Math.sin(c),f=Math.sin(h*c)/Math.sin(c),m=d*Math.cos(a)*Math.cos(s)+f*Math.cos(l)*Math.cos(u);h=d*Math.cos(a)*Math.sin(s)+f*Math.cos(l)*Math.sin(u),f=d*Math.sin(a)+f*Math.sin(l),f=Math.atan2(f,Math.sqrt(Math.pow(m,2)+Math.pow(h,2))),m=Math.atan2(h,m),f=lr(f*or,-85,85);m*=or,n.push([m,f])}return n},getHeading:Tr,getLengthOfPath:Cr,getPositionAlongPath:Er,getRegularPolygonPath:Ir,interpolate:kr,normalizeLatitude:Ar,normalizeLongitude:Pr,rotatePositions:Mr,getPixelHeading:function(t,e){t=(i=I(Or([t=qr(t),e=qr(e)],21),2))[0];var i=(e=i[1])[0]-t[0];e=t[1]-e[1];return(2.5*Math.PI-Math.atan2(e,i))*or%360},mercatorPixelsToPositions:Lr,mercatorPositionsToPixels:Or,convertAcceleration:Rr,convertArea:zr,convertSpeed:Dr,convertTimespan:Nr,getAcceleration:Br,getAccelerationFromSpeeds:Fr,getAccelerationFromFeatures:function(t,e,i,r,n,o,a){if("string"==typeof i&&"Feature"===t.type&&"Point"===t.geometry.type&&"Feature"===e.type&&"Point"===e.geometry.type){var s=Ur(t.properties[i],e.properties[i],$i.seconds);if(!isNaN(s)){var l=0;return r&&"string"==typeof r&&(i=t.properties[r],r=e.properties[r],"number"==typeof i&&(l=i,"number"==typeof r))?Fr(i,r,s,n,$i.seconds,o,a):Br(l,wr(t.geometry.coordinates,e.geometry.coordinates,Qi.meters),s,n,Qi.meters,$i.seconds,o,a)}}return NaN},getArea:function t(e,i,r){if(e){var n=0;switch((e=e instanceof tn?e.toJson():e).type){case"Feature":var o=e;if(e.geometry)return t(o.geometry,i,r);break;case"Polygon":(o=e).coordinates&&(n=mr(o.coordinates));break;case"MultiPolygon":var a=e;if(a.coordinates)for(var s=0,l=a.coordinates.length;s<l;s++)n+=mr(a.coordinates[s])}return zr(n,Ji.squareMeters,i,r)}return 0},getSpeed:function(t,e,i,r,n,o){return t=qr(t),e=qr(e),t&&e?(r=Nr(i,r,$i.seconds),Dr(wr(t,e,Qi.meters)/r,tr.metersPerSecond,n,o)):0},getSpeedFromFeatures:function(t,e,i,r,n){return"string"!=typeof i||"Feature"!==t.type||"Point"!==t.geometry.type||"Feature"!==e.type||"Point"!==e.geometry.type||(i=this.getTimespan(t.properties[i],e.properties[i],$i.seconds),isNaN(i))?NaN:(e=this.getDistanceTo(t.geometry.coordinates,e.geometry.coordinates,Qi.meters),this.convertSpeed(e/i,tr.metersPerSecond,r,n))},getTimespan:Ur,getTravelDistance:function(t,e,i,r,n,o,a,s){return e=this.convertTimespan(e,n,$i.seconds),i=(i=this.convertSpeed(i,o,tr.metersPerSecond))*e,"number"==typeof r&&(i+=.5*this.convertAcceleration(r,a,er.metersPerSecondSquared)*e*e),this.convertDistance(i,Qi.meters,t,s)},parseTimestamp:jr,getConvexHull:function(t){var e,i,r=Vr(t).map(function(t){return[Pr(t[0]),Ar(t[1])]});r.sort(function(t,e){return t[0]===e[0]?t[1]-e[1]:t[0]-e[0]});var n=[];try{for(var o=E(r),a=o.next();!a.done;a=o.next()){for(var s=a.value;2<=n.length&&gr(n[n.length-2],n[n.length-1],s)<=0;)n.pop();n.push(s)}}catch(t){e={error:t}}finally{try{a&&!a.done&&(i=o.return)&&i.call(o)}finally{if(e)throw e.error}}for(var l=[],u=r.length-1;0<=u;u--){for(;2<=l.length&&gr(l[l.length-2],l[l.length-1],r[u])<=0;)l.pop();l.push(r[u])}return new Xr([n.concat(l)])},getPositions:Vr,getPosition:qr,getPositionsAlongPath:function(t,e){if(e<2)return[];for(var i=[],r=Cr(t,Qi.meters)/(e-1),n=0;n<e;n++){var o=Er(t,r*n,Qi.meters);null!=o&&i.push(o)}return i},getPointWithHeadingAlongPath:Hr,getPointsWithHeadingsAlongPath:function(t,e){if(e<=0)return[];for(var i=[],r=Cr(t,Qi.meters)/(e-1),n=0;n<e;n++){var o=Hr(t,r*n,Qi.meters);null!=o&&i.push(o)}return i},getClosestPointOnGeometry:Gr,simplify:function(t,e){return ir(t,e,!0)}});var $r,tn=(w(en,$r=G),en.prototype.addProperty=function(t,e){Fi(this.data.properties[t],e)||(this.data.properties[t]=hi(e),"subType"!==t&&"radius"!==t||this._handleCircle(),this.dataSource&&this.dataSource._updateSource(),this._invokeEvent("shapechanged",this))},en.prototype.getBounds=function(){var t,e,i,r,n,o=this.getCoordinates(),a=this.getType();if("Point"===a)n=this.circlePolygon?(s=this.circlePolygon.geometry.coordinates,nn.fromPositions(s[0])):new nn(s=o,s);else if("MultiPoint"===a||"LineString"===a){var s=o;n=nn.fromPositions(s)}else if("Polygon"===a)s=o,n=nn.fromPositions(s[0]);else if("MultiLineString"===a){s=o;try{for(var l=E(s),u=l.next();!u.done;u=l.next()){var c=u.value;n=nn.merge(n,nn.fromPositions(c))}}catch(e){t={error:e}}finally{try{u&&!u.done&&(e=l.return)&&e.call(l)}finally{if(t)throw t.error}}}else if("MultiPolygon"===a){s=o;try{for(var p=E(s),h=p.next();!h.done;h=p.next()){var d=h.value;n=nn.merge(n,nn.fromPositions(d[0]))}}catch(e){i={error:e}}finally{try{h&&!h.done&&(r=p.return)&&r.call(p)}finally{if(i)throw i.error}}}return n},en.prototype.getCoordinates=function(){return hi(this.data.geometry.coordinates)},en.prototype.getCircleCoordinates=function(){return this.circlePolygon?hi(this.circlePolygon.geometry.coordinates[0]):null},en.prototype.getId=function(){return this.data.id},en.prototype.getProperties=function(){return hi(this.data.properties)},en.prototype.getType=function(){return this.data.geometry.type},en.prototype.isCircle=function(){return en._isCircle(this.data)},en.prototype.isRectangle=function(){return en._isRectangle(this.data)},en.prototype.setCoordinates=function(t){t="Polygon"===this.getType()&&1===Wr._getDimensions(t)?[t]:t,Fi(this.data.geometry.coordinates,t)||(this.data.geometry.coordinates=hi(t),this._handleCircle(),this.dataSource&&this.dataSource._updateSource(),this._invokeEvent("shapechanged",this))},en.prototype.setProperties=function(t){t[en._shapeIdPropName]=this.data.id,Fi(this.data.properties,t)||(this.data.properties=hi(t),this._handleCircle(),this.dataSource&&this.dataSource._updateSource(),this._invokeEvent("shapechanged",this))},en.prototype.toJson=function(){return JSON.parse(JSON.stringify(this.data))},en.prototype._toJson=function(){return this.circlePolygon||this.data},en.prototype._setDataSource=function(t){void 0===t||null==t?delete this.dataSource:this.dataSource=t},en.prototype._handleCircle=function(){var t;this.isCircle()?(t=en._getCirclePositions(this.data),this.circlePolygon=new Vi(new Xr([t]),this.data.properties,this.data.id),this.data.properties.subType="Circle"):delete this.circlePolygon},en._isCircle=function(t){return t&&t.geometry&&"Point"===t.geometry.type&&t.geometry.coordinates&&t.properties&&"string"==typeof t.properties.subType&&"circle"===t.properties.subType.toLowerCase()&&"number"==typeof t.properties.radius},en._isRectangle=function(t){if("Polygon"===t.geometry.type&&t.geometry.coordinates&&"string"==typeof t.properties.subType&&"rectangle"===t.properties.subType.toLowerCase()&&1===(t=t.geometry.coordinates).length){if(5===(t=t[0]).length)return t[0][0]===t[4][0]&&t[0][1]===t[4][1];if(4===t.length)return!0}return!1},en._getCirclePositions=function(t){return Ir(t.geometry.coordinates,t.properties.radius,72,"meters")},en._shapeIdPropName="_azureMapsShapeId",en);function en(t,e,i){var r,n,o=$r.call(this)||this;return"Feature"===t.type?(n=hi((r=t).geometry),i=r.properties?hi(r.properties):{},e=null==r.id||""===r.id?ji():r.id):(n=hi(t),e=null==e||""===e?ji():e,i=i?hi(i):{}),i[en._shapeIdPropName]=e,o.data=new Vi(n,i,e),o._handleCircle(),o}var rn,nn=(w(on,rn=Array),on.fromBoundingBox=function(t){var e=on.getWest(t),i=on.getSouth(t),r=on.getEast(t);t=on.getNorth(t);return new on([e,i,r,t])},on.fromDimensions=function(t,e,i){var r=t[0],n=t[1];t=Math.min(Math.max(n+i/2,-85.5),85.5),n=Math.min(Math.max(n-i/2,-85.5),85.5),i=Pr(r+e/2);return new on([Pr(r-e/2),n,i,t])},on.fromEdges=function(t,e,i,r){return new on([t,e,i,r])},on.containsPosition=function(t,e){var i=on.getCenter(t),r=Math.abs(i[1]-e[1]);return 180<(i=Math.abs(i[0]-e[0]))&&(i=360-i),e=on.getHeight(t),t=on.getWidth(t),r<=e/2+1e-8&&i<=t/2+1e-8},on.containsBoundingBox=function(t,e){var i=t&&4===t.length,r=e&&4===e.length;return!(!i||!r)&&on.getWest(t)<on.getWest(e)&&on.getWest(e)<on.getEast(t)&&on.getWest(t)<on.getEast(e)&&on.getEast(e)<on.getEast(t)&&on.getSouth(t)<on.getSouth(e)&&on.getSouth(e)<on.getNorth(t)&&on.getSouth(t)<on.getNorth(e)&&on.getNorth(e)<on.getNorth(t)},on.crossesAntimeridian=function(t){return Pr(on.getEast(t))-Pr(on.getWest(t))<0||on.isBoundingBoxWithSixOrMoreElementsLargerThanGlobe(t)||on.isBoundingBoxWithLessThanSixElementsLargerThanGlobe(t)},on.getCenter=function(t){var e=Pr(on.getEast(t)),i=Pr(on.getWest(t));return e<i&&(e+=360),i=Pr((i+e)/2),e=Ar(on.getSouth(t)),t=Ar(on.getNorth(t)),[i,Ar((e+t)/2)]},on.getHeight=function(t){return t=Ar(on.getNorth(t))-Ar(on.getSouth(t)),isNaN(t)?0:t},on.getWidth=function(t){return t=Pr(on.getEast(t))-Pr(on.getWest(t)),isNaN(t)?0:t<0?t+360:t},on.getSouthWest=function(t){var e=this.getSouth(t);t=this.getWest(t);return isNaN(e)||isNaN(t)?null:[t,e]},on.getNorthEast=function(t){var e=this.getNorth(t);t=this.getEast(t);return isNaN(e)||isNaN(t)?null:[t,e]},on.getNorthWest=function(t){var e=this.getNorth(t);t=this.getWest(t);return isNaN(e)||isNaN(t)?null:[t,e]},on.getSouthEast=function(t){var e=this.getSouth(t);t=this.getEast(t);return isNaN(e)||isNaN(t)?null:[t,e]},on.getSouth=function(t){return t&&4<=t.length?Number(t[1]):NaN},on.getWest=function(t){return t&&4<=t.length?Number(t[0]):NaN},on.getNorth=function(t){if(t){if(4===t.length)return Number(t[3]);if(6===t.length)return Number(t[4])}return NaN},on.getEast=function(t){if(t){if(4===t.length)return Number(t[2]);if(6===t.length)return Number(t[3])}return NaN},on.intersect=function(t,e){var i=on.getCenter(t),r=on.getCenter(e),n=Math.abs(i[1]-r[1]),o=Math.abs(i[0]-r[0]);return 180<o&&(o=360-o),i=on.getHeight(t),r=on.getWidth(t),t=on.getHeight(e),e=on.getWidth(e),n<=i/2+t/2&&o<=r/2+e/2},on.merge=function(t,e){var i=t&&4===t.length,r=e&&4===e.length;if(i&&!r)return t;if(r&&!i)return e;if(!i&&!r)return null;i=Math.max(Ar(on.getNorth(t)),Ar(on.getNorth(e))),r=Math.min(Ar(on.getSouth(t)),Ar(on.getSouth(e)));var n=[t,e],o=[],a=0;for(a=0;a<n.length;a++){var s=n[a],l=Pr(on.getWest(s)),u=Pr(on.getEast(s));on.crossesAntimeridian(s)?(o.push([l,180]),o.push([-180,u])):o.push([l,u])}o.sort(function(t,e){return t[0]===e[0]?t[1]-e[1]:t[0]-e[0]});var c=[],p=o[0];for(a=1;a<o.length;){var h=o[a];p[1]>=h[0]?p[1]=Math.max(p[1],h[1]):(c.push(p),p=h),a++}c.push(p);var d=c.length,f=c[0][0]+360-c[d-1][1],m=[c[d-1][1],c[0][0]];for(a=1;a<d;a++){var y=c[a][0]-c[a-1][1];f<y&&(f=y,m=[c[a-1][1],c[a][0]])}return new on([m[1],r],[m[0],i])},on.fromPositions=function(t){for(var e,i,r=NaN,n=NaN,o=NaN,a=NaN,s=t.length,l=new Array(s),u=0;s--;)(i=t[s])&&2<=i.length&&(e=Ar(i[1]),r=isNaN(r)?e:Math.max(r,e),n=isNaN(n)?e:Math.min(n,e),l[u++]=Pr(i[0]));if(u){l.length=u,l.sort(function(t,e){return t-e});var c=l[0]+360-l[u-1],p=0;for(s=1;s<u;s++){var h=l[s]-l[s-1];c<h&&(c=h,p=s)}o=l[p],a=l[(p||u)-1]}return isNaN(o)||isNaN(n)||isNaN(a)||isNaN(r)?null:new on([o,n,a,r])},on.fromLatLngs=function(t){return on.fromPositions(Wr.fromLatLngs(t))},on.fromData=function(t){var e,i,r=null;if(Array.isArray(t)&&0<t.length){try{for(var n=E(t),o=n.next();!o.done;o=n.next()){var a,s=o.value;null!=(a=on.fromData(s))&&(r=null===r?a:on.merge(r,a))}}catch(t){e={error:t}}finally{try{o&&!o.done&&(i=n.return)&&i.call(n)}finally{if(e)throw e.error}}return r}if(t instanceof tn)return t.getBounds();if(t&&t.type){var l=t;if(l.bbox&&4===l.bbox.length)return l.bbox;switch(l.type){case"FeatureCollection":return on.fromData(l.features);case"Feature":return tn._isCircle(l)?on.fromPositions(tn._getCirclePositions(l)):on.fromData(l.geometry);case"GeometryCollection":return on.fromData(l.geometries);case"Point":var u=l.coordinates;if(u&&2<=u.length)return[u[0],u[1],u[0],u[1]];break;case"LineString":case"MultiPoint":return on.fromPositions(l.coordinates);case"Polygon":case"MultiLineString":var c=l.coordinates;if(c&&0<c.length){for(var p=0,h=c.length;p<h;p++)null!=(a=on.fromPositions(c[p]))&&(r=null===r?a:on.merge(r,a));if(null!=r)return r}break;case"MultiPolygon":var d=l.coordinates;if(d&&0<d.length){for(p=0,h=d.length;p<h;p++)for(var f=0,m=d[p].length;f<m;f++)null!=(a=on.fromPositions(d[p][f]))&&(r=null===r?a:on.merge(r,a));return r}}}return null},on.splitOnAntimeridian=function(t){var e,i,r,n,o,a,s=[];return on.isBoundingBoxWithSixOrMoreElementsLargerThanGlobe(t)?[[-180,t[1],t[2],180,t[4],t[5]]]:on.isBoundingBoxWithLessThanSixElementsLargerThanGlobe(t)?[[-180,t[1],180,t[3]]]:(on.crossesAntimeridian(t)?(e=void 0,i=Pr(on.getWest(t)),r=Pr(on.getEast(t)),n=Ar(on.getNorth(t)),o=Ar(on.getSouth(t)),a=6<=t.length?(e=[i,o,t[2],180,n,t[5]],[-180,o,t[2],r,n,t[5]]):(e=[i,o,180,n],[-180,o,r,n]),s.push(e,a)):s.push(t),s)},on.isBoundingBoxWithSixOrMoreElementsLargerThanGlobe=function(t){return 6<=t.length&&360<t[3]-t[0]},on.isBoundingBoxWithLessThanSixElementsLargerThanGlobe=function(t){return t.length<6&&360<t[2]-t[0]},on);function on(t,e){var i,r=this;return t&&e?r=(i=t)[2]&&e[2]?rn.call(this,i[0],i[1],i[2]||0,e[0],e[1],e[2]||0)||this:rn.call(this,i[0],i[1],e[0],e[1])||this:!t||(t=t)&&(4===t.length?r=rn.call(this,t[0],t[1],t[2],t[3])||this:6<=t.length&&(r=rn.call(this,t[0],t[1],t[2],t[3],t[4],t[5])||this)),r}var an=(sn.TYPE="FeatureCollection",sn);function sn(t,e){this.type="FeatureCollection",this.type=sn.TYPE,this.features=t,this.bbox=e}function ln(t){this.type="GeometryCollection",this.type=ln.TYPE,this.geometries=t}function un(t,e){this.type="LineString",this.type=un.TYPE,this.coordinates=t,this.bbox=e}function cn(t,e){this.type="MultiLineString",this.type=cn.TYPE,this.coordinates=t,this.bbox=e}function pn(t,e){this.type="MultiPoint",this.type=pn.TYPE,this.coordinates=t,this.bbox=e}function hn(t,e){this.type="MultiPolygon",this.type=hn.TYPE,this.coordinates=t,this.bbox=e}ln.TYPE="GeometryCollection",Ct=ln,un.TYPE="LineString",xt=un,cn.TYPE="MultiLineString",_t=cn,pn.TYPE="MultiPoint",mt=pn,hn.TYPE="MultiPolygon",ft=hn;e=Object.freeze({__proto__:null,Feature:Vi,FeatureCollection:an,LineString:xt,Point:Wi,Polygon:Xr,Position:Wr,BoundingBox:nn,MultiLineString:_t,MultiPoint:mt,MultiPolygon:ft,GeometryCollection:Ct});var dn,fn=(w(mn,dn=A),mn);function mn(){var e=null!==dn&&dn.apply(this,arguments)||this;return e.zoomDelta=1,e.style=t.ControlStyle.light,e}var yn;w(gn,yn=X),gn.prototype.onAdd=function(t){return this.container=this.buildContainer(t,this.options.style,"Zoom Control"),this.container.style.flexDirection="column",this.zoomInButton=this.constructZoomInButton(t),this.zoomOutButton=this.constructZoomOutButton(t),this.container.appendChild(this.zoomInButton),this.container.appendChild(this.zoomOutButton),t.events.add("zoom",this.zoomChanged),t.events.add("minzoomchanged",this.minZoomChanged),t.events.add("maxzoomchanged",this.maxZoomChanged),this.map=t,this.container},gn.prototype.onRemove=function(){this.map&&(this.map.events.remove("zoom",this.zoomChanged),this.map.events.remove("minzoomchanged",this.minZoomChanged),this.map.events.remove("maxzoomchanged",this.maxZoomChanged),this.map=null),this.container&&(this.container.remove(),this.container=null,this.zoomInButton=null,this.zoomOutButton=null)},gn.prototype.updateZoomButtonsState=function(){var t=this.map.getCamera().zoom>=this.map._getMap().getMaxZoom(),e=nn.getSouth(this.map.getCamera().bounds)<=-gn.WEBMERCATOR_MAXLAT&&nn.getNorth(this.map.getCamera().bounds)>=gn.WEBMERCATOR_MAXLAT;e=this.map.getCamera().zoom<=this.map._getMap().getMinZoom()||e;this.zoomInButton&&this.zoomInButton.disabled!=t&&(this.zoomInButton.disabled=t),this.zoomOutButton&&this.zoomOutButton.disabled!=e&&(this.zoomOutButton.disabled=e)},gn.prototype.constructZoomInButton=function(t){var e=this,i=document.createElement("button");return i.classList.add("azure-maps-control-button"),i.classList.add("zoom-in"),i.setAttribute("title","Zoom In"),i.setAttribute("alt","Zoom In"),i.setAttribute("type","button"),i.addEventListener("click",function(){t.setCamera({zoom:t.getCamera().zoom+e.options.zoomDelta,duration:gn.ZOOM_DURATION_MS,type:"ease"},!0)}),i},gn.prototype.constructZoomOutButton=function(t){var e=this,i=document.createElement("button");return i.classList.add("azure-maps-control-button"),i.classList.add("zoom-out"),i.setAttribute("title","Zoom Out"),i.setAttribute("alt","Zoom Out"),i.setAttribute("type","button"),i.addEventListener("click",function(){t.setCamera({zoom:t.getCamera().zoom-e.options.zoomDelta,duration:gn.ZOOM_DURATION_MS,type:"ease"},!0)}),i},gn.WEBMERCATOR_MAXLAT=85.0511,gn.ZOOM_DURATION_MS=200,bt=gn;function gn(t){var e=yn.call(this)||this;return e.container=null,e.zoomInButton=null,e.zoomOutButton=null,e.zoomChanged=function(t){return e.updateZoomButtonsState()},e.minZoomChanged=function(t){return e.updateZoomButtonsState()},e.maxZoomChanged=function(t){return e.updateZoomButtonsState()},e.options=(new fn).merge(t),e}xt=Object.freeze({__proto__:null,ControlBase:X,PitchControl:st,CompassControl:et,ZoomControl:bt,StyleControl:ht,TrafficControl:St,TrafficLegendControl:vt});var vn,_n=function(t,e){return pi(t,5,e="function"==typeof e?e:void 0)},xn=(w(bn,vn=A),bn);function bn(){var t=null!==vn&&vn.apply(this,arguments)||this;return t.buffer=128,t.maxZoom=18,t.cluster=!1,t.clusterRadius=50,t.clusterMaxZoom=void 0,t.clusterProperties=void 0,t.lineMetrics=!1,t.tolerance=.375,t}var wn,Sn=(w(Tn,wn=G),Tn.prototype.getId=function(){return this.id},Tn.prototype._setMap=function(t){var e;null==t||void 0===t?(e=this.map,delete this.map,this._invokeEvent("sourceremoved",this),e&&e.events.invoke("sourceremoved",this)):(this.map=t,this._invokeEvent("sourceadded",this),this.map.events.invoke("sourceadded",this))},Tn);function Tn(t){var e=wn.call(this)||this;return e.id=t||ji(),e}var Cn,En=(w(In,Cn=Sn),In.prototype.add=function(t,e){this._addNoUpdate(t,e),this._updateSource()},In.prototype.clear=function(){this._clearNoUpdate(),this._updateSource()},In.prototype.dispose=function(){this.options=null,this.shapes=null,this.shapesMap=null,this.map=null},In.prototype.getClusterExpansionZoom=function(t){var e=this;return new Promise(function(i,r){var n;e.map?(n=e.map._getMap().getSource(e.getId()))&&"geojson"===n.type&&n.getClusterExpansionZoom(t,function(t,e){t?r(t):"number"==typeof e&&i(e)}):r("The DataSource hasn't been added to a map.")})},In.prototype.getClusterChildren=function(t){var e=this;return new Promise(function(i,r){var n;e.map?(n=e.map._getMap().getSource(e.getId()))&&"geojson"===n.type&&n.getClusterChildren(t,function(t,n){t?r(t):n&&i(e.map.sources._mapFeaturesToShapes(n,!1,e))}):r("The DataSource hasn't been added to a map.")})},In.prototype.getClusterLeaves=function(t,e,i){var r=this;return new Promise(function(n,o){var a;r.map?(a=r.map._getMap().getSource(r.getId()))&&"geojson"===a.type&&a.getClusterLeaves(t,e,i,function(t,e){t?o(t):e&&n(r.map.sources._mapFeaturesToShapes(e,!1,r))}):o("The DataSource hasn't been added to a map.")})},In.prototype.getOptions=function(){return hi(this.options)},In.prototype.getShapes=function(){return Array.from(this.shapes)},In.prototype.importDataFromUrl=function(t){var e=this;return fetch(t,{method:"GET",mode:"cors"}).then(function(t){if(t.ok)return t.json();throw new Error("HTTP "+t.status+": "+t.statusText)}).then(function(t){e.add(t)})},In.prototype.getShapeById=function(t){return this.shapes[this.shapesMap.get(t)]||null},In.prototype.remove=function(t){var e,i;t=Array.isArray(t)?t:[t];try{for(var r=E(t),n=r.next();!n.done;n=r.next()){var o=n.value;"number"==typeof o?this._removeByIndex(o):this._removeById(o)}}catch(t){e={error:t}}finally{try{n&&!n.done&&(i=r.return)&&i.call(r)}finally{if(e)throw e.error}}this._updateSource()},In.prototype.removeById=function(t){var e,i;t=Array.isArray(t)?t:[t];try{for(var r=E(t),n=r.next();!n.done;n=r.next()){var o=n.value;this._removeById(o)}}catch(t){e={error:t}}finally{try{n&&!n.done&&(i=r.return)&&i.call(r)}finally{if(e)throw e.error}}this._updateSource()},In.prototype.setOptions=function(t){t=(new xn).merge(this.options,hi(t)),Fi(this.options,t)||(this._invokeEvent("datasourceupdated",this),this.options=t,this.map&&this.map._rebuildStyle())},In.prototype.setShapes=function(t){this._clearNoUpdate(),this.add(t)},In.prototype.toJson=function(){return new an(this.shapes.map(function(t){return t.toJson()}))},In.prototype._toJson=function(){return new an(this.shapes.map(function(t){return t._toJson()}))},In.prototype._buildSource=function(){var t={type:"geojson",data:this._toJson(),maxzoom:this.options.maxZoom,cluster:this.options.cluster,clusterRadius:this.options.clusterRadius,tolerance:this.options.tolerance,lineMetrics:this.options.lineMetrics,clusterProperties:this.options.clusterProperties,buffer:this.options.buffer};return"number"==typeof this.options.clusterMaxZoom&&(t.clusterMaxZoom=this.options.clusterMaxZoom),t},In.prototype._addNoUpdate=function(t,e){var i;t instanceof tn?(this._addToSources(t,e),i=[t]):Array.isArray(t)?(i=t.map(function(t){return t instanceof tn?t:new tn(t)}),this._addToSources(i,e)):"FeatureCollection"===t.type?(i=t.features.map(function(t){return new tn(t)}),this._addToSources(i,e)):"GeometryCollection"===t.type?(i=t.geometries.map(function(t){return new tn(t)}),this._addToSources(i,e)):(t=new tn(t),this._addToSources(t,e),i=[t]),this._invokeEvent("dataadded",i)},In.prototype._clearNoUpdate=function(){var t=this.shapes;this.shapes=[],this.shapesMap=new H,t&&0<t.length&&this._invokeEvent("dataremoved",t)},In.prototype._updateSource=function(){var t=this;void 0!==this.requestId||(this.requestId=requestAnimationFrame(function(){t._updateMboxSource(),t.requestId=void 0}))},In.prototype._addToSources=function(t,e){var i,r,n,o;if(t=Array.isArray(t)?t:[t],"number"!=typeof e)try{for(var a=E(t),s=a.next();!s.done;s=a.next()){var l=s.value;this.shapes.push(l),this.shapesMap.set(l.getId(),this.shapes.length-1)}}catch(t){i={error:t}}finally{try{s&&!s.done&&(r=a.return)&&r.call(a)}finally{if(i)throw i.error}}else for(var u=t.length-1;0<=u;u--)this.shapes.splice(e,0,t[u]),this._updateShapesMap(e);try{for(var c=E(t),p=c.next();!p.done;p=c.next())(l=p.value)._setDataSource(this)}catch(t){n={error:t}}finally{try{p&&!p.done&&(o=c.return)&&o.call(c)}finally{if(n)throw n.error}}},In.prototype._removeById=function(t){var e=t instanceof tn?t.getId():"string"==typeof t||"number"==typeof t?t:t.id;(t=this.shapes[this.shapesMap.get(e)])&&(t._setDataSource(null),this.shapes.splice(this.shapesMap.get(e),1),this._updateShapesMap(this.shapesMap.get(e)),this.shapesMap.delete(e),this._invokeEvent("dataremoved",[t]))},In.prototype._removeByIndex=function(t){var e;if(t>=this.shapes.length)throw new Error("The specified remove index '"+t+"' is greater than the maximum possible index '"+(this.shapes.length-1)+"'");e=this.shapes[t],this.shapesMap.delete(e.getId()),e._setDataSource(null),this.shapes.splice(t,1),this._updateShapesMap(t),this._invokeEvent("dataremoved",[e])},In.prototype._updateShapesMap=function(t){for(var e=t;e<this.shapes.length;e++)this.shapesMap.set(this.shapes[e].getId(),e)},In.prototype._updateMboxSource=function(){var t;this.map&&this.map._getMap()&&(t=this.map._getMap().getSource(this.getId()))&&"geojson"===t.type&&t.setData(this._toJson())},In);function In(t,e){return(t=Cn.call(this,t)||this).requestId=void 0,t.options=(new xn).merge(hi(e)),t.shapes=[],t.shapesMap=new H,t}var kn,An=(w(Pn,kn=A),Pn);function Pn(){var t=null!==kn&&kn.apply(this,arguments)||this;return t.bounds=void 0,t.minZoom=0,t.maxZoom=22,t.isTMS=!1,t.tiles=void 0,t.url=void 0,t}var Mn,Ln=(w(On,Mn=Sn),On.prototype.getOptions=function(){return hi(this.options)},On.prototype.getShape=function(t,e){return this.map._getMap().querySourceFeatures(this.getId(),{sourceLayer:t,filter:e})},On.prototype._buildSource=function(){var t={type:"vector"};return this.options.bounds&&(t.bounds=this.options.bounds),this.options.tiles?(t.tiles=this.options.tiles,t.minzoom=this.options.minZoom,t.maxzoom=this.options.maxZoom):this.options.url&&(t.url=this.options.url),this.options.isTMS&&(t.scheme="tms"),t},On);function On(t,e){return(t=Mn.call(this,t)||this).options=(new An).merge(hi(e)),t}_t=Object.freeze({__proto__:null,Source:Sn,DataSource:En,VectorTileSource:Ln});var Rn,zn=(w(Dn,Rn=G),Dn.prototype.getId=function(){return this.id},Dn.prototype.getMap=function(){return this.map||null},Dn.prototype.onAdd=function(t){this.map=t,this._invokeEvent("layeradded",this),this.map.events.invoke("layeradded",this)},Dn.prototype.onRemove=function(){var t=this.map;delete this.map,this._invokeEvent("layerremoved",this),t&&t.events.invoke("layerremoved",this)},Dn._isMBoxEvent=function(t){return!this.LayerEvents.hasOwnProperty(t)},Dn.prototype._updateBaseProperties=function(t,e){this._updateFilter(t.filter,e.filter),this._updateZoomRange(t.minZoom,e.minZoom,t.maxZoom,e.maxZoom),this._updateLayoutProperty("visibility",t.visible,e.visible,t.visible?"visible":"none")},Dn.prototype._updateFilter=function(t,e){Fi(t,e)||this.map._getMap().setFilter(this.id,t)},Dn.prototype._updatePaintProperty=function(t,e,i,r){Fi(e,i)||this.map._getMap().setPaintProperty(this.id,t,r||e)},Dn.prototype._updateLayoutProperty=function(t,e,i,r){Fi(e,i)||this.map._getMap().setLayoutProperty(this.id,t,r||e)},Dn.prototype._updateZoomRange=function(t,e,i,r){t===e&&r===i||this.map._getMap().setLayerZoomRange(this.id,t,i)},Dn.LayerEvents={layeradded:void 0,layerremoved:void 0},Dn);function Dn(t){var e=Rn.call(this)||this;return e.id=t||ji(),e}var Nn;w(Bn,Nn=A),Bn._cloneCustomizer=function(t){if(t instanceof Sn)return t},mt=Bn;function Bn(){var t=null!==Nn&&Nn.apply(this,arguments)||this;return t.filter=void 0,t.minZoom=0,t.maxZoom=24,t.visible=!0,t}var Fn,Un=(w(jn,Fn=mt),jn);function jn(){var t=null!==Fn&&Fn.apply(this,arguments)||this;return t.source=void 0,t.sourceLayer=void 0,t.color="#1A73AA",t.blur=0,t.opacity=1,t.strokeColor="#FFFFFF",t.strokeOpacity=1,t.strokeWidth=2,t.pitchAlignment="viewport",t.radius=8,t}var Vn,qn=(w(Hn,Vn=zn),Hn.prototype.getOptions=function(){return _n(this.options,Un._cloneCustomizer)},Hn.prototype.getSource=function(){return this.options.source},Hn.prototype.setOptions=function(t){if(t=(new Un).merge(this.options,_n(t,Un._cloneCustomizer)),this.map){if(t.source!==this.options.source||t.sourceLayer!==this.options.sourceLayer)return this.options=t,void this.map.layers.add(this);this._updateBaseProperties(t,this.options),this._updatePaintProperty("circle-blur",t.blur,this.options.blur),this._updatePaintProperty("circle-color",t.color,this.options.color),this._updatePaintProperty("circle-opacity",t.opacity,this.options.opacity),this._updatePaintProperty("circle-radius",t.radius,this.options.radius),this._updatePaintProperty("circle-stroke-color",t.strokeColor,this.options.strokeColor),this._updatePaintProperty("circle-stroke-opacity",t.strokeOpacity,this.options.strokeOpacity),this._updatePaintProperty("circle-stroke-width",t.strokeWidth,this.options.strokeWidth),this._updatePaintProperty("circle-pitch-alignment",t.pitchAlignment,this.options.pitchAlignment)}this.options=t},Hn.prototype._buildLayers=function(){var t={id:this.id,type:"circle",source:this.options.source instanceof Sn?this.options.source.getId():this.options.source,layout:{visibility:this.options.visible?"visible":"none"},paint:{"circle-color":this.options.color,"circle-blur":this.options.blur,"circle-opacity":this.options.opacity,"circle-stroke-color":this.options.strokeColor,"circle-stroke-opacity":this.options.strokeOpacity,"circle-stroke-width":this.options.strokeWidth,"circle-pitch-alignment":this.options.pitchAlignment,"circle-radius":this.options.radius},minzoom:this.options.minZoom,maxzoom:this.options.maxZoom};return this.options.filter&&(t.filter=this.options.filter),this.options.sourceLayer&&(t["source-layer"]=this.options.sourceLayer),[t]},Hn.prototype._getLayerIds=function(){return[this.id]},Hn.prototype._getSourceIds=function(){var t=new Set;return this.options.source instanceof Sn?t.add(this.options.source.getId()):t.add(this.options.source),t},Hn);function Hn(t,e,i){return(e=Vn.call(this,e)||this).options=(new Un).merge(_n(i,Un._cloneCustomizer)),e.options.source=t||e.options.source,e}var Gn,Zn=(w(Wn,Gn=mt),Wn._cloneCustomizer=function(t){if(t instanceof Sn)return t},Wn);function Wn(){var t=null!==Gn&&Gn.apply(this,arguments)||this;return t.source=void 0,t.sourceLayer=void 0,t.color=["interpolate",["linear"],["heatmap-density"],0,"rgba(0,0, 255,0)",.1,"royalblue",.3,"cyan",.5,"lime",.7,"yellow",1,"red"],t.intensity=1,t.opacity=1,t.radius=30,t.weight=1,t}var Kn;w(Xn,Kn=zn),Xn.prototype.getOptions=function(){return _n(this.options,Zn._cloneCustomizer)},Xn.prototype.getSource=function(){return this.options.source},Xn.prototype.setOptions=function(t){if(t=(new Zn).merge(this.options,_n(t,Zn._cloneCustomizer)),this.map){if(t.source!==this.options.source||t.sourceLayer!==this.options.sourceLayer)return this.options=t,void this.map.layers.add(this);this._updateBaseProperties(t,this.options),this._updatePaintProperty("heatmap-color",t.color,this.options.color),this._updatePaintProperty("heatmap-intensity",t.intensity,this.options.intensity),this._updatePaintProperty("heatmap-opacity",t.opacity,this.options.opacity),this._updatePaintProperty("heatmap-radius",t.radius,this.options.radius),this._updatePaintProperty("heatmap-weight",t.weight,this.options.weight)}this.options=t},Xn.prototype._buildLayers=function(){var t={id:this.id,type:"heatmap",source:this.options.source instanceof Sn?this.options.source.getId():this.options.source,layout:{visibility:this.options.visible?"visible":"none"},paint:{"heatmap-color":this.options.color,"heatmap-intensity":this.options.intensity,"heatmap-opacity":this.options.opacity,"heatmap-radius":this.options.radius,"heatmap-weight":this.options.weight},minzoom:this.options.minZoom,maxzoom:this.options.maxZoom};return this.options.filter&&(t.filter=this.options.filter),this.options.sourceLayer&&(t["source-layer"]=this.options.sourceLayer),[t]},Xn.prototype._getLayerIds=function(){return[this.id]},Xn.prototype._getSourceIds=function(){var t=new Set;return this.options.source instanceof Sn?t.add(this.options.source.getId()):t.add(this.options.source),t},ft=Xn;function Xn(t,e,i){return(e=Kn.call(this,e)||this).options=(new Zn).merge(_n(i,Zn._cloneCustomizer)),e.options.source=t||e.options.source,e}var Yn;w(Jn,Yn=mt),Ct=Jn;function Jn(){var t=null!==Yn&&Yn.apply(this,arguments)||this;return t.contrast=0,t.fadeDuration=300,t.hueRotation=0,t.maxBrightness=1,t.minBrightness=0,t.opacity=1,t.saturation=0,t}var Qn,$n=(w(to,Qn=Ct),to._cloneCustomizer=function(t){if(t instanceof Sn)return t},to);function to(){var t=null!==Qn&&Qn.apply(this,arguments)||this;return t.url=void 0,t.coordinates=void 0,t}var eo,io=(w(ro,eo=zn),ro.prototype._getSourceIds=function(){var t=new Set;return t.add(this._getSourceId()),t},ro);function ro(){return null!==eo&&eo.apply(this,arguments)||this}var no;w(oo,no=io),oo.prototype.getOptions=function(){return _n(this.options,$n._cloneCustomizer)},oo.prototype.setOptions=function(t){var e=(new $n).merge(this.options,_n(t,$n._cloneCustomizer)),i="string"==typeof t.url&&t.url!==this.getOptions().url,r=void 0!==t.coordinates&&t.coordinates!==this.getOptions().coordinates;this.map&&(this._updateBaseProperties(e,this.options),this._updatePaintProperty("raster-contrast",e.contrast,this.options.contrast),this._updatePaintProperty("raster-fade-duration",e.fadeDuration,this.options.fadeDuration),this._updatePaintProperty("raster-hue-rotate",e.hueRotation,this.options.hueRotation),this._updatePaintProperty("raster-brightness-max",e.maxBrightness,this.options.maxBrightness),this._updatePaintProperty("raster-opacity",e.opacity,this.options.opacity),this._updatePaintProperty("raster-saturation",e.saturation,this.options.saturation),(t=this.map._getMap().getSource(this._getSourceId()))&&t.updateImage(e)),this.options=e,i?this.reloadImage():r&&this.updateTransform()},oo.prototype.getPositions=function(t){return this.transform.then(function(e){return e.toTarget(t)})},oo.prototype.getPixels=function(t){return this.transform.then(function(e){return e.toSource(t)})},oo.getCoordinatesFromRefPoints=function(t,e,i,r){return new Jr(i,r).toTarget([[0,0],[t,0],[t,e],[0,e]])},oo.getCoordinatesFromEdges=function(t,e,i,r,n){return"number"!=typeof n&&(n=0),i=[Math.min(r,i),e,Math.max(r,i),t],t=nn.getCenter(i),Mr([nn.getNorthWest(i),nn.getNorthEast(i),nn.getSouthEast(i),nn.getSouthWest(i)],t,n)},oo.prototype._buildLayers=function(){var t={id:this.id,type:"raster",source:this._getSourceId(),layout:{visibility:this.options.visible?"visible":"none"},paint:{"raster-opacity":this.options.opacity,"raster-hue-rotate":this.options.hueRotation,"raster-brightness-min":this.options.minBrightness,"raster-brightness-max":this.options.maxBrightness,"raster-saturation":this.options.saturation,"raster-contrast":this.options.contrast,"raster-fade-duration":this.options.fadeDuration},minzoom:this.options.minZoom,maxzoom:this.options.maxZoom};return this.options.filter&&(t.filter=this.options.filter),[t]},oo.prototype._getLayerIds=function(){return[this.id]},oo.prototype._buildSource=function(){return{type:"image",url:this.options.url,coordinates:this.options.coordinates}},oo.prototype._getSourceId=function(){return this.getId()+"-ImageSource"},oo.prototype.reloadImage=function(){var t=this;this.options.url&&(this.transform=new Promise(function(e,i){t.img.onload=function(){var i=[[0,0],[t.img.width,0],[t.img.width,t.img.height],[0,t.img.height]];e(new Jr(i,t.options.coordinates)),t.isLoading=!1},t.img.onerror=t.img.onabort=function(){i("Failed to load image")},t.isLoading=!0,t.img.src=t.options.url}))},oo.prototype.updateTransform=function(){var t;this.isLoading||(t=[[0,0],[this.img.width,0],[this.img.width,this.img.height],[0,this.img.height]],this.transform=Promise.resolve(new Jr(t,this.options.coordinates)))},st=oo;function oo(t,e){return(e=no.call(this,e)||this).isLoading=!1,e.options=(new $n).merge(_n(t,$n._cloneCustomizer)),e.img=new Image,e.reloadImage(),e}var ao,so=(w(lo,ao=mt),lo);function lo(){var t=null!==ao&&ao.apply(this,arguments)||this;return t.source=void 0,t.sourceLayer=void 0,t.lineCap="round",t.lineJoin="round",t.blur=0,t.strokeColor="#1E90FF",t.strokeDashArray=void 0,t.strokeGradient=void 0,t.offset=0,t.strokeOpacity=1,t.translate=new Gi(0,0),t.translateAnchor="map",t.strokeWidth=2,t}var uo,co=(w(po,uo=zn),po.prototype.getOptions=function(){return _n(this.options,so._cloneCustomizer)},po.prototype.getSource=function(){return this.options.source},po.prototype.setOptions=function(t){if(t=(new so).merge(this.options,_n(t,so._cloneCustomizer)),this.map){if(t.source!==this.options.source||t.sourceLayer!==this.options.sourceLayer)return this.options=t,void this.map.layers.add(this);this._updateBaseProperties(t,this.options),this._updatePaintProperty("line-blur",t.blur,this.options.blur),this._updateLayoutProperty("line-cap",t.lineCap,this.options.lineCap),this._updateLayoutProperty("line-join",t.lineJoin,this.options.lineJoin),this._updatePaintProperty("line-offset",t.offset,this.options.offset),this._updatePaintProperty("line-color",t.strokeColor,this.options.strokeColor),this._updatePaintProperty("line-dasharray",t.strokeDashArray,this.options.strokeDashArray),this._updatePaintProperty("line-gradient",t.strokeGradient,this.options.strokeGradient),this._updatePaintProperty("line-opacity",t.strokeOpacity,this.options.strokeOpacity),this._updatePaintProperty("line-width",t.strokeWidth,this.options.strokeWidth),this._updatePaintProperty("line-translate",t.translate,this.options.translate),this._updatePaintProperty("line-translate-anchor",t.translateAnchor,this.options.translateAnchor)}this.options=t},po.prototype._buildLayers=function(){return[S(S(S(S({id:this.id,type:"line"},this.options.sourceLayer&&{"source-layer":this.options.sourceLayer}),{source:this.options.source instanceof Sn?this.options.source.getId():this.options.source,layout:{visibility:this.options.visible?"visible":"none","line-cap":this.options.lineCap,"line-join":this.options.lineJoin},paint:S(S(S({"line-blur":this.options.blur,"line-color":this.options.strokeColor},this.options.strokeDashArray&&{"line-dasharray":this.options.strokeDashArray}),this.options.strokeGradient&&{"line-gradient":this.options.strokeGradient}),{"line-offset":this.options.offset,"line-opacity":this.options.strokeOpacity,"line-translate":this.options.translate,"line-translate-anchor":this.options.translateAnchor,"line-width":this.options.strokeWidth})}),this.options.filter&&{filter:this.options.filter}),{minzoom:this.options.minZoom,maxzoom:this.options.maxZoom})]},po.prototype._getLayerIds=function(){return[this.id]},po.prototype._getSourceIds=function(){var t=new Set;return this.options.source instanceof Sn?t.add(this.options.source.getId()):t.add(this.options.source),t},po);function po(t,e,i){return(e=uo.call(this,e)||this).options=(new so).merge(_n(i,so._cloneCustomizer)),e.options.source=t||e.options.source,e}var ho,fo=(w(mo,ho=mt),mo);function mo(){var t=null!==ho&&ho.apply(this,arguments)||this;return t.source=void 0,t.sourceLayer=void 0,t.base=0,t.fillColor="#1E90FF",t.height=0,t.fillOpacity=1,t.fillPattern=void 0,t.translate=new Gi(0,0),t.translateAnchor="map",t.verticalGradient=!0,t}var yo;w(go,yo=zn),go.prototype.getOptions=function(){return _n(this.options,fo._cloneCustomizer)},go.prototype.getSource=function(){return this.options.source},go.prototype.setOptions=function(t){if(t=(new fo).merge(this.options,_n(t,fo._cloneCustomizer)),this.map){if(t.source!==this.options.source||t.sourceLayer!==this.options.sourceLayer)return this.options=t,void this.map.layers.add(this);this._updateBaseProperties(t,this.options),this._updatePaintProperty("fill-extrusion-base",t.base,this.options.base),this._updatePaintProperty("fill-extrusion-color",t.fillColor,this.options.fillColor),this._updatePaintProperty("fill-extrusion-height",t.height,this.options.height),this._updatePaintProperty("fill-extrusion-opacity",t.fillOpacity,this.options.fillOpacity),this._updatePaintProperty("fill-extrusion-pattern",t.fillPattern,this.options.fillPattern),this._updatePaintProperty("fill-extrusion-translate",t.translate,this.options.translate),this._updatePaintProperty("fill-extrusion-translate-anchor",t.translateAnchor,this.options.translateAnchor),this._updatePaintProperty("fill-extrusion-vertical-gradient",t.verticalGradient,this.options.verticalGradient)}this.options=t},go.prototype._buildLayers=function(){return[S(S(S(S({id:this.id,type:"fill-extrusion"},this.options.sourceLayer&&{"source-layer":this.options.sourceLayer}),{source:this.options.source instanceof Sn?this.options.source.getId():this.options.source,layout:{visibility:this.options.visible?"visible":"none"},paint:S(S({"fill-extrusion-base":this.options.base,"fill-extrusion-height":this.options.height,"fill-extrusion-opacity":this.options.fillOpacity},this.options.fillPattern?{"fill-extrusion-pattern":this.options.fillPattern}:{"fill-extrusion-color":this.options.fillColor}),{"fill-extrusion-translate":this.options.translate,"fill-extrusion-translate-anchor":this.options.translateAnchor,"fill-extrusion-vertical-gradient":this.options.verticalGradient})}),this.options.filter&&{filter:this.options.filter}),{minzoom:this.options.minZoom,maxzoom:this.options.maxZoom})]},go.prototype._getLayerIds=function(){return[this.id]},go.prototype._getSourceIds=function(){var t=new Set;return this.options.source instanceof Sn?t.add(this.options.source.getId()):t.add(this.options.source),t},bt=go;function go(t,e,i){return(e=yo.call(this,e)||this).options=(new fo).merge(_n(i,fo._cloneCustomizer)),e.options.source=t||e.options.source,e}var vo,_o=(w(xo,vo=mt),xo.prototype.merge=function(){for(var t,e=[],i=0;i<arguments.length;i++)e[i]=arguments[i];var r=!1,n=!1;try{for(var o=E(e),a=o.next();!a.done;a=o.next()){var s=a.value;s&&(s.hasOwnProperty("fillColor")?n=!(r=!0):s.hasOwnProperty("fillPattern")&&(r=!(n=!0)))}}catch(t){l={error:t}}finally{try{a&&!a.done&&(t=o.return)&&t.call(o)}finally{if(l)throw l.error}}var l=vo.prototype.merge.apply(this,k(e));return r?l.fillPattern=void 0:n&&(l.fillColor=void 0),l},xo);function xo(){var t=null!==vo&&vo.apply(this,arguments)||this;return t.source=void 0,t.sourceLayer=void 0,t.fillColor="#1E90FF",t.fillOpacity=.5,t.fillPattern=void 0,t}var bo,wo=(w(So,bo=zn),So.prototype.getOptions=function(){return _n(this.options,_o._cloneCustomizer)},So.prototype.getSource=function(){return this.options.source},So.prototype.setOptions=function(t){if(t=(new _o).merge(this.options,_n(t,_o._cloneCustomizer)),this.map){if(t.source!==this.options.source||t.sourceLayer!==this.options.sourceLayer)return this.options=t,void this.map.layers.add(this);this._updateBaseProperties(t,this.options),this._updatePaintProperty("fill-color",t.fillColor,this.options.fillColor),this._updatePaintProperty("fill-opacity",t.fillOpacity,this.options.fillOpacity),this._updatePaintProperty("fill-pattern",t.fillPattern,this.options.fillPattern)}this.options=t},So.prototype._buildLayers=function(){var t={id:this.id,type:"fill",source:this.options.source instanceof Sn?this.options.source.getId():this.options.source,layout:{visibility:this.options.visible?"visible":"none"},paint:{"fill-opacity":this.options.fillOpacity},minzoom:this.options.minZoom,maxzoom:this.options.maxZoom};return this.options.filter&&(t.filter=this.options.filter),this.options.sourceLayer&&(t["source-layer"]=this.options.sourceLayer),this.options.fillPattern?t.paint["fill-pattern"]=this.options.fillPattern:t.paint["fill-color"]=this.options.fillColor,[t]},So.prototype._getLayerIds=function(){return[this.id]},So.prototype._getSourceIds=function(){var t=new Set;return this.options.source instanceof Sn?t.add(this.options.source.getId()):t.add(this.options.source),t},So);function So(t,e,i){return(e=bo.call(this,e)||this).options=(new _o).merge(_n(i,_o._cloneCustomizer)),e.options.source=t||e.options.source,e}var To,Co=(w(Eo,To=A),Eo);function Eo(){var t=null!==To&&To.apply(this,arguments)||this;return t.allowOverlap=!1,t.anchor="bottom",t.ignorePlacement=!1,t.image="marker-blue",t.offset=new Gi(0,0),t.optional=!1,t.pitchAlignment="auto",t.rotation=0,t.rotationAlignment="auto",t.size=1,t.opacity=1,t}var Io,ko=(w(Ao,Io=A),Ao);function Ao(){var t=null!==Io&&Io.apply(this,arguments)||this;return t.allowOverlap=!1,t.anchor="center",t.textField=void 0,t.font=["StandardFont-Regular"],t.ignorePlacement=!1,t.offset=new Gi(0,0),t.optional=!1,t.pitchAlignment="auto",t.rotation=0,t.rotationAlignment="auto",t.size=16,t.color="#000000",t.haloBlur=0,t.haloColor="rgba(0,0,0,0)",t.haloWidth=0,t.opacity=1,t}var Po,Mo=(w(Lo,Po=mt),Lo);function Lo(){var t=null!==Po&&Po.apply(this,arguments)||this;return t.source=void 0,t.sourceLayer=void 0,t.iconOptions=new Co,t.textOptions=new ko,t.placement="point",t.lineSpacing=250,t}var Oo,Ro=(w(zo,Oo=zn),zo.prototype.getOptions=function(){return _n(this.options,Mo._cloneCustomizer)},zo.prototype.getSource=function(){return this.options.source},zo.prototype.setOptions=function(t){if(t=(new Mo).merge(this.options,_n(t,Mo._cloneCustomizer)),this.map){if(t.source!==this.options.source||t.sourceLayer!==this.options.sourceLayer)return this.options=t,void this.map.layers.add(this);this._updateBaseProperties(t,this.options),this._updateLayoutProperty("symbol-spacing",t.lineSpacing,this.options.lineSpacing),this._updateLayoutProperty("symbol-placement",t.placement,this.options.placement),this._updateLayoutProperty("icon-allow-overlap",t.iconOptions.allowOverlap,this.options.iconOptions.allowOverlap),this._updateLayoutProperty("icon-anchor",t.iconOptions.anchor,this.options.iconOptions.anchor),this._updateLayoutProperty("icon-ignore-placement",t.iconOptions.ignorePlacement,this.options.iconOptions.ignorePlacement),this._updateLayoutProperty("icon-image",t.iconOptions.image,this.options.iconOptions.image),this._updateLayoutProperty("icon-offset",t.iconOptions.offset,this.options.iconOptions.offset),this._updatePaintProperty("icon-opacity",t.iconOptions.opacity,this.options.iconOptions.opacity),this._updateLayoutProperty("icon-optional",t.iconOptions.optional,this.options.iconOptions.optional),this._updateLayoutProperty("icon-pitch-alignment",t.iconOptions.pitchAlignment,this.options.iconOptions.pitchAlignment),this._updateLayoutProperty("icon-rotate",t.iconOptions.rotation,this.options.iconOptions.rotation),this._updateLayoutProperty("icon-rotation-alignment",t.iconOptions.rotationAlignment,this.options.iconOptions.rotationAlignment),this._updateLayoutProperty("icon-size",t.iconOptions.size,this.options.iconOptions.size),this._updateLayoutProperty("text-allow-overlap",t.textOptions.allowOverlap,this.options.textOptions.allowOverlap),this._updateLayoutProperty("text-anchor",t.textOptions.anchor,this.options.textOptions.anchor),this._updatePaintProperty("text-color",t.textOptions.color,this.options.textOptions.color),this._updateLayoutProperty("text-font",t.textOptions.font,this.options.textOptions.font),this._updateLayoutProperty("text-ignore-placement",t.textOptions.ignorePlacement,this.options.textOptions.ignorePlacement),this._updatePaintProperty("text-halo-blur",t.textOptions.haloBlur,this.options.textOptions.haloBlur),this._updatePaintProperty("text-halo-color",t.textOptions.haloColor,this.options.textOptions.haloColor),this._updatePaintProperty("text-halo-width",t.textOptions.haloWidth,this.options.textOptions.haloWidth),this._updateLayoutProperty("text-offset",t.textOptions.offset,this.options.textOptions.offset),this._updatePaintProperty("text-opacity",t.textOptions.opacity,this.options.textOptions.opacity),this._updateLayoutProperty("text-optional",t.textOptions.optional,this.options.textOptions.optional),this._updateLayoutProperty("text-pitch-alignment",t.textOptions.pitchAlignment,this.options.textOptions.pitchAlignment),this._updateLayoutProperty("text-rotate",t.textOptions.rotation,this.options.textOptions.rotation),this._updateLayoutProperty("text-rotation-alignment",t.textOptions.rotationAlignment,this.options.textOptions.rotationAlignment),this._updateLayoutProperty("text-size",t.textOptions.size,this.options.textOptions.size),this._updateLayoutProperty("text-field",t.textOptions.textField,this.options.textOptions.textField)}this.options=t},zo.prototype._buildLayers=function(){return[S(S(S(S({id:this.id,type:"symbol"},this.options.sourceLayer&&{"source-layer":this.options.sourceLayer}),{source:this.options.source instanceof Sn?this.options.source.getId():this.options.source,layout:S(S({visibility:this.options.visible?"visible":"none","symbol-placement":this.options.placement,"symbol-spacing":this.options.lineSpacing,"text-allow-overlap":this.options.textOptions.allowOverlap,"text-anchor":this.options.textOptions.anchor},this.options.textOptions.textField&&{"text-field":this.options.textOptions.textField}),{"text-font":this.options.textOptions.font,"text-ignore-placement":this.options.textOptions.ignorePlacement,"text-offset":this.options.textOptions.offset,"text-optional":this.options.textOptions.optional,"text-pitch-alignment":this.options.textOptions.pitchAlignment,"text-rotate":this.options.textOptions.rotation,"text-rotation-alignment":this.options.textOptions.rotationAlignment,"text-size":this.options.textOptions.size,"icon-allow-overlap":this.options.iconOptions.allowOverlap,"icon-anchor":this.options.iconOptions.anchor,"icon-ignore-placement":this.options.iconOptions.ignorePlacement,"icon-image":this.options.iconOptions.image,"icon-offset":this.options.iconOptions.offset,"icon-optional":this.options.iconOptions.optional,"icon-pitch-alignment":this.options.iconOptions.pitchAlignment,"icon-rotate":this.options.iconOptions.rotation,"icon-rotation-alignment":this.options.iconOptions.rotationAlignment,"icon-size":this.options.iconOptions.size}),paint:{"text-color":this.options.textOptions.color,"text-halo-blur":this.options.textOptions.haloBlur,"text-halo-color":this.options.textOptions.haloColor,"text-halo-width":this.options.textOptions.haloWidth,"text-opacity":this.options.textOptions.opacity,"icon-opacity":this.options.iconOptions.opacity}}),this.options.filter&&{filter:this.options.filter}),{minzoom:this.options.minZoom,maxzoom:this.options.maxZoom})]},zo.prototype._getLayerIds=function(){return[this.id]},zo.prototype._getSourceIds=function(){var t=new Set;return this.options.source instanceof Sn?t.add(this.options.source.getId()):t.add(this.options.source),t},zo);function zo(t,e,i){return(e=Oo.call(this,e)||this).options=(new Mo).merge(_n(i,Mo._cloneCustomizer)),e.options.source=t||e.options.source,e}var Do,No=(w(Bo,Do=Ct),Bo);function Bo(){var t=null!==Do&&Do.apply(this,arguments)||this;return t.bounds=[-180,-85.0511,180,85.0511],t.minSourceZoom=0,t.maxSourceZoom=22,t.tileSize=512,t.isTMS=!1,t.subdomains=void 0,t.tileUrl=void 0,t}var Fo,Uo=(w(jo,Fo=io),jo.prototype.getOptions=function(){return _n(this.options,No._cloneCustomizer)},jo.prototype.setOptions=function(t){if(t=(new No).merge(this.options,_n(t,No._cloneCustomizer)),this.map){if(!Fi(t.bounds,this.options.bounds)||t.isTMS!==this.options.isTMS||t.maxSourceZoom!==this.options.maxSourceZoom||t.minSourceZoom!==this.options.minSourceZoom||!Fi(t.subdomains,this.options.subdomains)||t.tileSize!==this.options.tileSize||t.tileUrl!==this.options.tileUrl)return this.options=t,void this.map.layers.add(this);this._updateBaseProperties(t,this.options),this._updatePaintProperty("raster-contrast",t.contrast,this.options.contrast),this._updatePaintProperty("raster-fade-duration",t.fadeDuration,this.options.fadeDuration),this._updatePaintProperty("raster-hue-rotate",t.hueRotation,this.options.hueRotation),this._updatePaintProperty("raster-brightness-max",t.maxBrightness,this.options.maxBrightness),this._updatePaintProperty("raster-opacity",t.opacity,this.options.opacity),this._updatePaintProperty("raster-saturation",t.saturation,this.options.saturation)}this.options=t},jo.prototype._setOptionsNoUpdate=function(t){this.options=(new No).merge(this.options,_n(t,No._cloneCustomizer))},jo.prototype._buildLayers=function(){return[S(S({id:this.id,type:"raster",source:this._getSourceId(),layout:{visibility:this.options.visible?"visible":"none"},paint:{"raster-contrast":this.options.contrast,"raster-fade-duration":this.options.fadeDuration,"raster-hue-rotate":this.options.hueRotation,"raster-brightness-max":this.options.maxBrightness,"raster-brightness-min":this.options.minBrightness,"raster-opacity":this.options.opacity,"raster-saturation":this.options.saturation}},this.options.filter&&{filter:this.options.filter}),{minzoom:this.options.minZoom,maxzoom:this.options.maxZoom})]},jo.prototype._getLayerIds=function(){return[this.id]},jo.prototype._buildSource=function(){var t,e;if(this.options.tileUrl){if(-1===this.options.tileUrl.indexOf("{"))return{type:"raster",url:this.options.tileUrl};if(-1!==this.options.tileUrl.indexOf("{subdomain}")){if(!(this.options.subdomains&&0<this.options.subdomains.length))throw new Error("The {subdomain} placeholder was included in the tileUrl but no subdomains were specified");var i=[];try{for(var r=E(this.options.subdomains),n=r.next();!n.done;n=r.next()){var o=n.value;i.push(this.options.tileUrl.replace(/{subdomain}/g,o))}}catch(t){e={error:t}}finally{try{n&&!n.done&&(t=r.return)&&t.call(r)}finally{if(e)throw e.error}}e=i}else e=[this.options.tileUrl]}return S({type:"raster",bounds:this.options.bounds,maxzoom:this.options.maxSourceZoom,minzoom:this.options.minSourceZoom,scheme:this.options.isTMS?"tms":"xyz",tileSize:this.options.tileSize},e&&{tiles:e})},jo.prototype._getSourceId=function(){return this.getId()+"-RasterSource"},jo);function jo(t,e){return e=Fo.call(this,e)||this,t&&e.setOptions(t),e}ht=Object.freeze({__proto__:null,BubbleLayer:qn,Layer:zn,LineLayer:co,PolygonExtrusionLayer:bt,PolygonLayer:wo,SymbolLayer:Ro,TileLayer:Uo,HeatMapLayer:ft,ImageLayer:st});var Vo=(qo.convertHtmlString=function(t){if("string"!=typeof t)return t;var e=document.createElement("div");return e.innerHTML=t,e},qo.parseWithFilter=function(t,e,i,r){var n=this;if(void 0===e&&(e=function(t){return!0}),void 0===i&&(i=function(t){return t}),void 0===r&&(r=function(){return document.createElement("div")}),"string"==typeof t){if(0==(a=(new DOMParser).parseFromString(t,"text/html").body).children.length)return i(a.innerHTML);var o,a=1==a.children.length&&1==a.childNodes.length?a.children[0]:(o=r(),Array.from(a.childNodes).map(function(t){return o.append(t)}),o)}else a=t;return Array.from(a.children).forEach(function(t){return n.parseWithFilter(t,e,i)}),e(a)?i(a):(a.parentNode&&a.parentNode.removeChild(a),null)},qo);function qo(){}St=Function.prototype,vt=Object.prototype;var Ho,Go=St.toString,Zo=vt.hasOwnProperty,Wo=Go.call(Object),Ko=function(t){return!(!re(t)||"[object Object]"!=Mt(t))&&(null===(t=Le(t))||"function"==typeof(t=Zo.call(t,"constructor")&&t.constructor)&&t instanceof t&&Go.call(t)==Wo)},Xo=function(t){return re(t)&&1===t.nodeType&&!Ko(t)},Yo=(w(Jo,Ho=A),Jo._cloneCustomizer=function(t){if(Xo(t))return t},Jo);function Jo(){var t=null!==Ho&&Ho.apply(this,arguments)||this;return t.anchor="none",t.draggable=!1,t.closeButton=!0,t.content=document.createElement("span"),t.fillColor="#FFFFFF",t.pixelOffset=new Gi(0,0),t.position=new Wr(0,0),t.showPointer=!0,t}var Qo,$o=(w(ta,Qo=G),ta.prototype.setPopupOptions=function(t){this.setOptions(t)},ta.prototype.setOptions=function(t){(t=(new Yo).merge(this.options,_n(t,Yo._cloneCustomizer))).content!==this.options.content?(this.htmlContent.remove(),this.htmlContent=this._createHtmlContent(t),this.contentDiv.prepend(this.htmlContent)):t.draggable!==this.options.draggable&&this._setDraggable(this.htmlContent,t.draggable),t.closeButton&&!this.closeBtn?(this.closeBtn=this._createCloseButton(),this.contentDiv.appendChild(this.closeBtn)):!t.closeButton&&this.closeBtn&&(this.contentDiv.removeChild(this.closeBtn),delete this.closeBtn),t.showPointer&&!this.arrowDiv?(this.arrowDiv=this._createArrowDiv(),this.containerDiv.appendChild(this.arrowDiv)):!t.showPointer&&this.arrowDiv&&(this.containerDiv.removeChild(this.arrowDiv),delete this.arrowDiv),t.fillColor!==this.options.fillColor&&(this.containerDiv.style.borderColor=t.fillColor,this.contentDiv.style.backgroundColor=t.fillColor),this.marker&&(t.anchor!==this.options.anchor?"none"===this.options.anchor?(this.autoAnchor!==t.anchor&&this._replaceMarker(this.map,t),this.map.events.remove("move",this._onMove),delete this.autoAnchor):(this._replaceMarker(this.map,t),"none"===t.anchor&&this.map.events.add("move",this._onMove)):(Fi(t.position,this.options.position)||this.marker.setLngLat(t.position),Fi(t.pixelOffset,this.options.pixelOffset)||this.marker.setOffset(t.pixelOffset))),this.options=t},ta.prototype.getPopupOptions=function(){return this.getOptions()},ta.prototype.getOptions=function(){return _n(this.options,Yo._cloneCustomizer)},ta.prototype._dragToPixel=function(t){this.dragging||(this.dragging=!0,this.contentDiv.style.pointerEvents="none",this._invokeEvent("dragstart",{type:"dragstart",target:this})),t=[t[0]+this.dragOffset[0],t[1]+this.dragOffset[1]],t=I(this.map.pixelsToPositions([t]),1)[0],this.options.position=t,this.marker.setLngLat(this.options.position),this._invokeEvent("drag",{type:"drag",target:this})},ta.prototype._onUp=function(){this.dragging&&(this.contentDiv.style.pointerEvents="",this._invokeEvent("dragend",{type:"dragend",target:this}),"none"===this.options.anchor&&this._onMove()),delete this.dragOffset,delete this.dragging},ta.prototype._createContainerDiv=function(t){var e=this,i=document.createElement("div");i.classList.add(ta.Css.container),i.classList.add(ta.Css.hidden),i.style.borderColor=t.fillColor,i.setAttribute("role","dialog"),i.setAttribute("aria-label","Map Information Window");var r=!1;return i.addEventListener("keydown",function(t){"Tab"!==t.key&&"Escape"!==t.key&&"Esc"!==t.key||(r=!0)}),i.addEventListener("keyup",function(t){"Tab"!==t.key&&"Escape"!==t.key&&"Esc"!==t.key||(r=!1)}),i.addEventListener("focusin",function(t){e.map&&!e.isOpen()&&(e.open(e.map),t.target instanceof HTMLElement&&t.target.focus())}),i.addEventListener("focusout",function(t){r&&t.relatedTarget instanceof Node&&!i.contains(t.relatedTarget)&&(r=!1,e.isOpen()&&e.close())}),i},ta.prototype._createContentDiv=function(t){var e=document.createElement("div");return e.classList.add(ta.Css.content),e.style.backgroundColor=t.fillColor,e.setAttribute("tabindex","0"),this.htmlContent=this._createHtmlContent(t),e.appendChild(this.htmlContent),e},ta.prototype._createArrowDiv=function(){var t=document.createElement("div");return t.classList.add(ta.Css.arrow),t},ta.prototype._createCloseButton=function(){var t=document.createElement("button");return t.addEventListener("click",this.close),t.classList.add(ta.Css.close),t.setAttribute("aria-label","close"),t.setAttribute("title","close"),t.setAttribute("tabindex","0"),t.innerHTML="&times;",t},ta.prototype._createHtmlContent=function(t){var e=Vo.convertHtmlString(t.content);return t.draggable&&this._setDraggable(e,t.draggable),e},ta.prototype._createMarker=function(t,e){var i=this.marker?this.marker.getLngLat():t.position;return i="none"===t.anchor?(this.autoAnchor=e||"bottom",this.containerDiv.classList.add(this.autoAnchor),new o({anchor:this.autoAnchor,element:this.containerDiv,offset:t.pixelOffset}).setLngLat(i)):(this.containerDiv.classList.add(t.anchor),new o({anchor:t.anchor,element:this.containerDiv,offset:t.pixelOffset}).setLngLat(i))},ta.prototype._getAutoAnchor=function(t,e){var i,r,n,o=this.containerDiv.offsetWidth,a=this.containerDiv.offsetHeight,s=[];return(n=this.marker?(r=(i=t._getMap().project(this.marker.getLngLat())).x,i.y):(n=I(t.positionsToPixels([e.position]),1),r=(n=I(n[0],2))[0],n[1]))<a?s.push("top"):n>t.getCanvas().offsetHeight-a&&s.push("bottom"),r<o/2?s.push("left"):r>t.getCanvas().offsetWidth-o/2&&s.push("right"),0<s.length?s.join("-"):"bottom"},ta.prototype._replaceMarker=function(t,e,i){var r=this.containerDiv.nextElementSibling;this.marker.remove(),this.containerDiv.classList.remove(this.autoAnchor||this.options.anchor),this.marker=this._createMarker(e,i),this.marker.addTo(t._getMap()),t.popups._getCollectionDiv().insertBefore(this.containerDiv,r||null)},ta.prototype._setDraggable=function(t,e){e?(t.addEventListener("mousedown",this._onDown),t.addEventListener("touchstart",this._onDown),t.addEventListener("dragstart",this._onDragStart)):(t.removeEventListener("mousedown",this._onDown),t.removeEventListener("touchstart",this._onDown),t.removeEventListener("dragstart",this._onDragStart))},ta.Css={arrow:"popup-arrow",close:"popup-close",container:"popup-container",content:"popup-content-container",hidden:"hidden-accessible-element"},ta);function ta(t){var e=Qo.call(this)||this;return e.attach=function(t){e.map!==t&&(e.map&&e.remove(),e.map=t,e.marker=e._createMarker(e.options),e.marker.addTo(e.map._getMap()),e.map.popups._getCollectionDiv().appendChild(e.containerDiv),e.map.popups.add(e))},e.open=function(t){if(!t&&!e.map)throw new Error("Must specify a map to open on or attach to a map in advance");e.attach(t||e.map),e.containerDiv.classList.remove(ta.Css.hidden),e.map.events.add("move",e._onMove),e._onMove(),e._invokeEvent("open",{target:e,type:"open"})},e.close=function(){e.map&&e.map.events.remove("move",e._onMove),e.containerDiv.classList.add(ta.Css.hidden),e._invokeEvent("close",{target:e,type:"close"})},e.remove=function(){e.map&&(e.marker.remove(),e.containerDiv.classList.remove(e.autoAnchor||e.options.anchor),e.map.events.remove("move",e._onMove),e.map.popups.remove(e),delete e.map,delete e.marker,delete e.autoAnchor)},e.isOpen=function(){return e.map&&!e.containerDiv.classList.contains(ta.Css.hidden)},e._onMove=function(){var t=e._getAutoAnchor(e.map,e.options);t!==e.autoAnchor&&(e._replaceMarker(e.map,e.options,t),e.map.events.add("move",e._onMove))},e._onDown=function(t){e.map.popups._addDraggedPopup(e);var i=I(e.map.positionsToPixels([e.options.position]),1)[0];"mousedown"===t.type?e.dragOffset=[i[0]-t.clientX,i[1]-t.clientY]:"touchstart"===t.type&&(e.dragOffset=[i[0]-t.touches[0].clientX,i[1]-t.touches[0].clientY])},e._onDragStart=function(t){t.preventDefault()},e.options=(new Yo).merge(_n(t,Yo._cloneCustomizer)),e.containerDiv=e._createContainerDiv(e.options),e.contentDiv=e._createContentDiv(e.options),e.containerDiv.appendChild(e.contentDiv),e.options.showPointer&&(e.arrowDiv=e._createArrowDiv(),e.containerDiv.appendChild(e.arrowDiv)),e.options.closeButton&&(e.closeBtn=e._createCloseButton(),e.contentDiv.appendChild(e.closeBtn)),e}var ea,ia=(w(ra,ea=A),ra._cloneCustomizer=function(t){if(t instanceof $o||Xo(t))return t},ra);function ra(){var t=null!==ea&&ea.apply(this,arguments)||this;return t.anchor="bottom",t.color="#1A73AA",t.draggable=!1,t.htmlContent='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.5 36.5" id="marker_'+ji()+'" width="24.5" height="36.5" display="block"><path d="M12.25.25a12.2543,12.2543,0,0,0-12,12.4937c0,6.4436,6.4879,12.1093,11.059,22.5641.5493,1.2563,1.3327,1.2563,1.882,0C17.7621,24.8529,24.25,19.1857,24.25,12.7437A12.2543,12.2543,0,0,0,12.25.25Z"   fill="{color}" stroke="{secondaryColor}" stroke-width="0.5"/><text style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; fill: white;" text-anchor="middle" x="12" y="18">{text}</text></svg>',t.pixelOffset=new Gi(0,0),t.position=new Wr(0,0),t.popup=void 0,t.secondaryColor="white",t.text=void 0,t.visible=!0,t}var na,oa=(w(aa,na=G),aa.prototype.getOptions=function(){return _n(this.options,ia._cloneCustomizer)},aa.prototype.getElement=function(){return this.marker.getElement()},aa.prototype.setOptions=function(t){t=(new ia).merge(this.options,_n(t,ia._cloneCustomizer)),Fi(t.htmlContent,this.options.htmlContent)&&t.anchor===this.options.anchor?("string"!=typeof t.htmlContent||t.color===this.options.color&&t.text===this.options.text&&t.secondaryColor===this.options.secondaryColor||(this.element.innerHTML=this._getSubbedHtmlString(t)),t.draggable!==this.options.draggable&&(this._setDraggable(t.draggable),this.marker.setDraggable(t.draggable)),Fi(t.pixelOffset,this.options.pixelOffset)||this.marker.setOffset(t.pixelOffset),Fi(t.position,this.options.position)||this.marker.setLngLat(t.position),t.visible!==this.options.visible&&(t.visible?this.element.classList.remove(aa.hiddenClass):this.element.classList.add(aa.hiddenClass))):(this.marker.remove(),this._buildMarker(t),this.map&&(this.marker.addTo(this.map._getMap()),this._getCollectionContainer().appendChild(this.element))),this.options=t},aa.prototype.togglePopup=function(){if(this.options.popup)if(this.options.popup.isOpen())this.options.popup.close();else{if(!this.map)throw new Error("The marker must be added to a map before calling togglePopup().");this.options.popup.setOptions({position:this.options.position}),this.options.popup.open(this.map)}},aa.prototype._addToMap=function(t,e){this.map&&this.map!==t&&this._removeFromMap(),e&&(this.options.position=hi(e),this.marker.setLngLat(this.options.position)),this.map!==t&&(this.map=t,this.marker.addTo(t._getMap()),this._getCollectionContainer().appendChild(this.element))},aa.prototype._removeFromMap=function(){this.map&&(this.marker.remove(),delete this.map)},aa.prototype._getId=function(){if(this.element)return("string"==typeof this.options.htmlContent?this.element.firstChild:this.element).id},aa.prototype._buildMarker=function(t){var e;"string"==typeof t.htmlContent?(e=this._getSubbedHtmlString(t),this.element=Vo.convertHtmlString(e)):this.element=t.htmlContent,this.element.classList.add(aa.containerClass),t.draggable&&this._setDraggable(!0),t.visible||this.element.classList.add(aa.hiddenClass),this.marker=new o({element:this.element,offset:t.pixelOffset,draggable:t.draggable,anchor:t.anchor}).setLngLat(t.position),this.marker.on("drag",this._onDrag),this.marker.on("dragstart",this._onDragStart),this.marker.on("dragend",this._onDragEnd),this.element.addEventListener("click",this._bubbleElementEvent),this.element.addEventListener("dblclick",this._bubbleElementEvent),this.element.addEventListener("contextmenu",this._bubbleElementEvent),this.element.addEventListener("keydown",this._bubbleElementEvent),this.element.addEventListener("keypress",this._bubbleElementEvent),this.element.addEventListener("keyup",this._bubbleElementEvent),this.element.addEventListener("mousedown",this._bubbleElementEvent),this.element.addEventListener("mouseenter",this._bubbleElementEvent),this.element.addEventListener("mouseleave",this._bubbleElementEvent),this.element.addEventListener("mousemove",this._bubbleElementEvent),this.element.addEventListener("mouseout",this._bubbleElementEvent),this.element.addEventListener("mouseover",this._bubbleElementEvent),this.element.addEventListener("mouseup",this._bubbleElementEvent)},aa.prototype._getSubbedHtmlString=function(t){if("string"==typeof t.htmlContent)return t.htmlContent.replace(/{color}/gi,t.color||"").replace(/{secondaryColor}/gi,t.secondaryColor||"").replace(/{text}/gi,t.text||"")},aa.prototype._getCollectionContainer=function(){var t=this.map.getCanvasContainer().querySelector("."+aa.collectionContainerClass);return t||((t=document.createElement("div")).classList.add(aa.collectionContainerClass),this.map.getCanvasContainer().appendChild(t)),t},aa.prototype._setDraggable=function(t){t?this.element.addEventListener("dragstart",this._onEleDragStart):this.element.removeEventListener("dragstart",this._onEleDragStart)},aa.collectionContainerClass="marker-collection-container",aa.hiddenClass="hidden-accessible-element",aa.containerClass="marker-container",aa);function aa(t){var e=na.call(this)||this;return e._onDrag=function(){var t=e.marker.getLngLat().wrap();e.options.position=new Wr(t.lng,t.lat),e._invokeEvent("drag",{type:"drag",target:e})},e._onDragStart=function(){e._invokeEvent("dragstart",{type:"dragstart",target:e})},e._onDragEnd=function(){e._invokeEvent("dragend",{type:"dragend",target:e})},e._bubbleElementEvent=function(t){e._invokeEvent(t.type,{type:t.type,target:e})},e._onEleDragStart=function(t){t.preventDefault()},e.options=(new ia).merge(_n(t,ia._cloneCustomizer)),e._buildMarker(e.options),e}var sa=function(t,e,i){(void 0===i||ut(t[e],i))&&(void 0!==i||e in t)||$t(t,e,i)},la=function(t,e,i){for(var r=-1,n=Object(t),o=i(t),a=o.length;a--;){var s=o[++r];if(!1===e(n[s],s,n))break}return t},ua=function(t,e){if(("constructor"!==e||"function"!=typeof t[e])&&"__proto__"!=e)return t[e]},ca=function(t,e,i,r,n,o,a){var s,l,u,c=ua(t,i),p=ua(e,i),h=a.get(p);h?sa(t,i,h):((s=void 0===(u=o?o(c,p,i+"",t,e,a):void 0))&&(h=!(l=se(p))&&ue(p),e=!l&&!h&&fe(p),u=p,l||h||e?u=se(c)?c:function(t){return re(t)&&be(t)}(c)?Ie(c):h?Ee(p,!(s=!1)):e?$e(p,!(s=!1)):[]:Ko(p)||ae(p)?ae(u=c)?u=function(t){return ie(t,Ce(t))}(c):Lt(c)&&!Ot(c)||(u=ri(p)):s=!1),s&&(a.set(p,u),n(u,p,r,o,a),a.delete(p)),sa(t,i,u))};function pa(t){return t}var ha=Math.max,da=function(t){return function(){return t}},fa=Date.now,ma=function(t){var e=0,i=0;return function(){var r=fa(),n=16-(r-i);if(i=r,0<n){if(800<=++e)return arguments[0]}else e=0;return t.apply(void 0,arguments)}}(Qt?function(t,e){return Qt(t,"toString",{configurable:!0,enumerable:!1,value:da(e),writable:!0})}:pa),ya=function(t,e){return ma((i=t,n=pa,r=ha(void 0===(r=e)?i.length-1:r,0),function(){for(var t=arguments,e=-1,o=ha(t.length-r,0),a=Array(o);++e<o;)a[e]=t[r+e];e=-1;for(var s=Array(r+1);++e<r;)s[e]=t[e];return s[r]=n(a),function(t,e,i){switch(i.length){case 0:return t.call(e);case 1:return t.call(e,i[0]);case 2:return t.call(e,i[0],i[1]);case 3:return t.call(e,i[0],i[1],i[2])}return t.apply(e,i)}(i,this,s)}),t+"");var i,r,n},ga=function(t){return ya(function(e,i){var r=-1,n=i.length,o=1<n?i[n-1]:void 0,a=2<n?i[2]:void 0;o=3<t.length&&"function"==typeof o?(n--,o):void 0;for(a&&function(t,e,i){if(!Lt(i))return!1;var r=typeof e;return!!("number"==r?be(i)&&pe(e,i.length):"string"==r&&e in i)&&ut(i[e],t)}(i[0],i[1],a)&&(o=n<3?void 0:o,n=1),e=Object(e);++r<n;){var s=i[r];s&&t(e,s,r)}return e})}(function(t,e,i){!function t(e,i,r,n,o){e!==i&&la(i,function(a,s){var l;o=o||new Jt,Lt(a)?ca(e,i,s,r,t,n,o):(l=n?n(ua(e,s),a,s+"",e,i,o):void 0,sa(e,s,l=void 0===l?a:l))},Ce)}(t,e,i)}),va=(_a.parse=function(t){var e=(t=t.toLowerCase()).lastIndexOf("-");return-1!==e?{code:t,language:t.substring(0,e),region:t.substring(e+1)}:{code:t,language:t}},_a);function _a(){}var xa={localizationsPath:"locs/mapcontrol/2019-3-12",sensitiveUserRegions:["il","kr","pk","in","cn","ar","bh","eg","jo","sa","kw","om","qa","ma","ae"],locales:{defaultLanguage:{defaultRegion:{code:"NGT",strings:"en/resource.json"}},ar:{defaultRegion:{code:"ar",strings:"ar-sa/resource.json"}},bg:{defaultRegion:{code:"bg-BG",strings:"bg-bg/resource.json"}},cs:{defaultRegion:{code:"cs-CZ",strings:"cs-cz/resource.json"}},da:{defaultRegion:{code:"da-DK",strings:"da-dk/resource.json"}},de:{defaultRegion:{code:"de-DE",strings:"de-de/resource.json"}},el:{defaultRegion:{code:"el-GR",strings:"el-gr/resource.json"}},en:{defaultRegion:{code:"en",strings:"en/resource.json"},us:{code:"en-US",strings:"en/resource.json"}},es:{defaultRegion:{code:"es-ES",strings:"es-es/resource.json"},mx:{code:"es-MX",strings:"es-mx/resource.json"}},fi:{defaultRegion:{code:"fi-FI",strings:"fi-fi/resource.json"}},fr:{defaultRegion:{code:"fr-FR",strings:"fr-fr/resource.json"}},hu:{defaultRegion:{code:"hu-HU",strings:"hu-hu/resource.json"}},id:{defaultRegion:{code:"id-ID",strings:"id-id/resource.json"}},it:{defaultRegion:{code:"it-IT",strings:"it-it/resource.json"}},ko:{defaultRegion:{code:"ko-KR",strings:"ko-kr/resource.json"}},lt:{defaultRegion:{code:"lt-LT",strings:"lt-lt/resource.json"}},ms:{defaultRegion:{code:"ms-MY",strings:"ms-my/resource.json"}},nb:{defaultRegion:{code:"nb-NO",strings:"nb-no/resource.json"}},nl:{defaultRegion:{code:"nl-NL",strings:"nl-nl/resource.json"}},pl:{defaultRegion:{code:"pl-PL",strings:"pl-pl/resource.json"}},pt:{defaultRegion:{code:"pt-PT",strings:"pt-pt/resource.json"},br:{code:"pt-BR",strings:"pt-br/resource.json"}},ru:{defaultRegion:{code:"ru-RU",strings:"ru-ru/resource.json"}},sk:{defaultRegion:{code:"sk-SK",strings:"sk-sk/resource.json"}},sl:{defaultRegion:{code:"sl-SL",strings:"sl-sl/resource.json"}},sv:{defaultRegion:{code:"sv-SE",strings:"sv-se/resource.json"}},th:{defaultRegion:{code:"th-TH",strings:"th-th/resource.json"}},tr:{defaultRegion:{code:"tr-TR",strings:"tr-tr/resource.json"}},zh:{defaultRegion:{code:"zh-Hant",strings:"zh-tw/resource.json"}},"zh-hant":{defaultRegion:{code:"zh-Hant",strings:"zh-tw/resource.json"}}}},ba=function(){this.Unknown="Unknown",this.Accident="Accident",this.Fog="Fog",this.Danger="Danger",this.Rain="Rain",this.Ice="Ice",this.Jam="Jam",this.LaneClosed="Lane Closed",this.RoadClosed="Road Closed",this.RoadWorks="Road Works",this.Wind="Wind",this.Flood="Flood",this.Detour="Detour"},wa=(Sa.getCode=function(t){var e=va.parse(t);return-1===xa.sensitiveUserRegions.indexOf(e.region)?this.getLocaleData(e).code:t},Sa.getStrings=function(t){return t=this.getLocaleData(t),new R({domain:s,path:xa.localizationsPath+"/"+t.strings}).get().then(function(t){return t},function(){return new ba})},Sa.getLocaleData=function(t){if("string"==typeof t&&(t=va.parse(t)),xa.locales[t.code])return xa.locales[t.code].defaultRegion;var e;if(xa.locales[t.language])e=xa.locales[t.language];else{if(-1!==t.language.indexOf("-"))return this.getLocaleData(t.language);e=xa.locales.defaultLanguage}return t.region&&e[t.region]?e[t.region]:e.defaultRegion},Sa);function Sa(){}var Ta=(Ca.getEdgeOrIEVersion=function(){var t=window.navigator.userAgent,e=t.indexOf("MSIE ");if(0<e)return parseInt(t.substring(e+5,t.indexOf(".",e)),10);if(0<t.indexOf("Trident/")){var i=t.indexOf("rv:");return parseInt(t.substring(i+3,t.indexOf(".",i)),10)}return 0<(i=t.indexOf("Edge/"))?parseInt(t.substring(i+5,t.indexOf(".",i)),10):-1},Ca.isEdgeOrIE=function(){return-1!==this.getEdgeOrIEVersion()},Ca.isIE=function(){var t=this.getEdgeOrIEVersion();return-1!==t&&t<=11},Ca);function Ca(){}(mt=t.AuthenticationType||(t.AuthenticationType={})).subscriptionKey="subscriptionKey",mt.aad="aad",mt.anonymous="anonymous";var Ea,Ia,ka=(w(Aa,Ea=A),Aa.prototype.setSubscriptionKey=function(e){this.authType=t.AuthenticationType.subscriptionKey,this.subscriptionKey=e},Aa.prototype.setAadProperties=function(e,i,r,n,o){this.authType=t.AuthenticationType.aad,this.authContext=o||this.authContext,this.aadInstance=n||this.aadInstance,this.clientId=e,this.aadAppId=i,this.aadTenant=r},Aa.prototype.setTokenCallbackFunction=function(e){this.authType=t.AuthenticationType.anonymous,this.getToken=e},Aa.prototype.merge=function(){for(var e=[],i=0;i<arguments.length;i++)e[i]=arguments[i];var r=Ea.prototype.merge.apply(this,k(e));return r.authType===t.AuthenticationType.subscriptionKey?r.authContext=r.aadAppId=r.getToken=void 0:r.authType===t.AuthenticationType.aad?r.subscriptionKey=r.getToken=void 0:r.authType===t.AuthenticationType.anonymous&&(r.subscriptionKey=r.authContext=r.aadAppId=void 0),r},Aa);function Aa(){var t=null!==Ea&&Ea.apply(this,arguments)||this;return t.authType=void 0,t.subscriptionKey=void 0,t.clientId=void 0,t.aadAppId=void 0,t.aadTenant=void 0,t.aadInstance=void 0,t.getToken=void 0,t.authContext=void 0,t}var Pa="NGT",Ma=ji(),La=a,Oa=s,Ra=l,za=u,Da=new ka,Na=!1,Ba=!1,Fa=!1,Ua=!1,ja=!1,Va=!1,qa=!1,Ha=!1,Ga=!1;function Za(){return Object.assign({},Da)}function Wa(){return r.workerCount}function Ka(){return r.maxParallelImageRequests}function Xa(){return Da.authType===t.AuthenticationType.subscriptionKey?Da.subscriptionKey:void 0}function Ya(t){return!Ta.isIE()&&r.supported({failIfMajorPerformanceCaveat:t})}function Ja(t){Da=(new ka).merge(Da,t),Ga=!0}function Qa(t){La=t,Ba=!0}function $a(t){Ra=t,Fa=!0}function ts(t){za=t,Ua=!0}function es(t){0<t&&(r.workerCount=t,ja=!0)}function is(t){0<t&&(r.maxParallelImageRequests=t,Va=!0)}function rs(t){Pa=wa.getCode(t),qa=!0}function ns(t){Ma=t,Ha=!0}function os(t){Da.setSubscriptionKey(t),Ga=!0}function as(t){Ia=t,Na=!0}function ss(t,e){if(e=Math.abs(e||1),"string"==typeof t&&ls[t.toLowerCase()]){for(var i=ls[t.toLowerCase()],r=/calc\(([0-9.]+)[px]*\s*\*\s*\{scale\}\)/gi,n=i,o=r.exec(i);o;)n=n.replace(o[0],parseFloat(o[1])*e+""),o=r.exec(i);return n.replace("{scale}",e+"")}throw new Error("Invalid templateName.")}var ls={marker:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(27 * {scale})" height="calc(39 * {scale})" viewBox="-1 -1 26 38"><path d="M12.25.25a12.254 12.254 0 0 0-12 12.494c0 6.444 6.488 12.109 11.059 22.564.549 1.256 1.333 1.256 1.882 0C17.762 24.853 24.25 19.186 24.25 12.744A12.254 12.254 0 0 0 12.25.25Z" style="fill:{color};stroke:{secondaryColor};stroke-width:1"/><text x="12.5" y="17.5" style="font-size:14px;fill:#fff;text-anchor:middle">{text}</text></svg>',"marker-thick":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(28 * {scale})" height="calc(39 * {scale})" viewBox="-1 -1 27 38"><path d="M12.25.25a12.254 12.254 0 0 0-12 12.494c0 6.444 6.488 12.109 11.059 22.564.549 1.256 1.333 1.256 1.882 0C17.762 24.853 24.25 19.186 24.25 12.744A12.254 12.254 0 0 0 12.25.25Z" style="fill:{color};stroke:{secondaryColor};stroke-width:2"/><text x="12.5" y="18.5" style="font-size:14px;fill:#fff;text-anchor:middle">{text}</text></svg>',"marker-circle":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(28 * {scale})" height="calc(39 * {scale})" viewBox="-1 -1 27 38"><path d="M12.25.25a12.254 12.254 0 0 0-12 12.494c0 6.444 6.488 12.109 11.059 22.564.549 1.256 1.333 1.256 1.882 0C17.762 24.853 24.25 19.186 24.25 12.744A12.254 12.254 0 0 0 12.25.25Z" style="fill:{color};stroke:{secondaryColor};stroke-width:1"/><circle cx="12.5" cy="12.5" r="9" fill="{secondaryColor}"/><text x="12" y="17.5" style="font-size:14px;fill:#000;text-anchor:middle">{text}</text></svg>',pin:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(24 * {scale})" height="calc(28 * {scale})" viewBox="0 0 24 28"><path d="m11.988 16.615a5.15 5.15 0 0 1-2.268-.525 4.909 4.909 0 0 1-2.805-4.442 5.019 5.019 0 0 1 5.072-4.936h.012a5.03 5.03 0 0 1 5.085 4.961 4.907 4.907 0 0 1-.549 2.224 5.114 5.114 0 0 1-4.548 2.718zm0-8.06a3.173 3.173 0 0 0-3.226 3.099 3.081 3.081 0 0 0 1.77 2.782 3.299 3.299 0 0 0 4.365-1.386 3.049 3.049 0 0 0 .342-1.381 3.184 3.184 0 0 0-3.239-3.114h-.012z" fill="{secondaryColor}"/><path d="m11.999.922a10.908 10.908 0 0 0-11.076 10.732 10.639 10.639 0 0 0 4.418 8.598l6.658 6.464 6.658-6.463a10.537 10.537 0 0 0 2.198-15.041 11.182 11.182 0 0 0-8.856-4.289zm1.873 14.341a4.221 4.221 0 0 1-5.589-1.789 3.945 3.945 0 0 1-.445-1.8 4.164 4.164 0 0 1 8.323-.037 4.028 4.028 0 0 1-2.289 3.626Z" fill="{color}"/><path d="m11.999 28-7.256-7.044a11.611 11.611 0 0 1-4.743-9.303 11.844 11.844 0 0 1 11.988-11.652.102 .102 0 0 1 .02 0 12.164 12.164 0 0 1 9.577 4.647 11.357 11.357 0 0 1 2.299 8.614 11.521 11.521 0 0 1-4.63 7.695zm-.01-26.157a9.997 9.997 0 0 0-10.143 9.812 9.769 9.769 0 0 0 4.04 7.853l.099.083 6.014 5.838 6.113-5.922a9.7 9.7 0 0 0 3.945-6.505 9.533 9.533 0 0 0-1.933-7.229 10.305 10.305 0 0 0-8.116-3.931h-.021zm.021 14.772a5.11 5.11 0 0 1-4.547-2.718 4.868 4.868 0 0 1 .932-5.743 5.118 5.118 0 0 1 3.58-1.46h.024a5.031 5.031 0 0 1 5.084 4.938 4.92 4.92 0 0 1-2.805 4.457h0a5.152 5.152 0 0 1-2.269.525zm-.011-8.079h-.015a3.277 3.277 0 0 0-2.295.933 3.029 3.029 0 0 0-.587 3.58 3.297 3.297 0 0 0 4.364 1.386h0a3.092 3.092 0 0 0 1.772-2.795 3.185 3.185 0 0 0-3.239-3.105z" fill="{secondaryColor}"/><text x="12" y="17" style="font-size:14px;fill:#000;text-anchor:middle">{text}</text></svg>',"pin-round":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(25 * {scale})" height="calc(25 * {scale})" viewBox="0 0 25 25"><g transform="translate(0 1)"><circle cx="12.25" cy="11.5833" r="11" fill="{color}"/><path d="m12.25 23.583a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-22a10 10 0 1 0 10 10 10 10 0 0 0-10-10z" fill="{secondaryColor}"/><circle cx="12.25" cy="11.5833" r="4.2386" fill="{secondaryColor}"/></g><text x="12.5" y="17" style="font-size:14px;fill:#000;text-anchor:middle">{text}</text></svg>',"marker-flat":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(27 * {scale})" height="calc(42.8 * {scale})"  viewBox="0 0 1600 2570"><g fill="{color}"><path d="M691 2419c-409-575-641-1086-683-1504-10-106-10-136 5-224 31-188 105-330 241-458 129-124 270-190 453-214 69-9 113-10 182-1 373 46 655 326 703 698 40 308-120 801-424 1309-134 224-348 535-369 535-4 0-53-63-108-141z"/></g><g fill="rgba(0,0,0,0.15)" style="transform:scale(-1,1);transform-origin:center"><path d="M691 2419c-407-571-639-1083-682-1498-14-139-3-249 37-371 69-208 254-402 459-481 68-27 217-59 271-59h24v160 180 940 635c0 349-2 635-5 635-2 0-49-63-104-141z"/></g><circle cx="800" cy="800" r="600" fill="{secondaryColor}"/><text x="800" y="1100" style="font-size:800px;fill:#000;text-anchor:middle">{text}</text></svg>',"marker-arrow":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(25.47 * {scale})" height="calc(35.18 * {scale})" viewBox="0 0 4330 5980"><g fill="{color}"><path d="m2080 5969c-49-20-93-63-115-113-25-55-1928-5486-1953-5573-40-138 67-282 210-283 36 0 246 73 987 345 518 190 947 345 955 345 8 0 438-155 955-345 615-226 954-345 979-345 87 0 165 47 204 123 46 91 107-95-957 2942-537 1535-986 2805-997 2823-11 18-43 46-72 62-41 24-62 30-111 29-33 0-71-5-85-10z"/></g><g fill="{secondaryColor}"><path d="m2200 1600c-36 10-83 2-484-84-243-53-451-94-461-91-11 4-22 18-25 31-5 19 114 371 436 1292 244 697 448 1273 454 1281 19 24 50 30 71 12z"/><path d="m2200 1600c-36 10-83 2-484-84-243-53-451-94-461-91-11 4-22 18-25 31-5 19 114 371 436 1292 244 697 448 1273 454 1281 19 24 50 30 71 12z" style="transform:scale(-1,1);transform-origin:center"/></g><g fill="rgba(0,0,0,0.2)" ><path d="m2165 685c8 0 438-155 955-345 615-226 954-345 979-345 87 0 165 47 204 123 46 91 107-95-957 2942-537 1535-986 2805-997 2823-11 18-43 46-72 62-41 24-62 30-111 29z"/></g><text x="2165" y="3300" style="font-size:2500px;fill:#fff;text-anchor:middle">{text}</text></svg>',"marker-ball-pin":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(15.67 * {scale})" height="calc(33.33 * {scale})" viewBox="0 0 235 452"><g transform="translate(-135 10)"><path fill="{secondaryColor}" d="m256 442 0 0c-13 0-18-11-18-24l-6-323c0-13 11-24 24-24h0c13 0 24 11 24 24l-6 323c0 13-5 24-18 24z"/><circle style="fill:{color};stroke-width:10;stroke:{secondaryColor}" cx="256" cy="112" r="111"/><ellipse transform="matrix(0.834 0.5518 -0.5518 0.834 65.7916 -97.18)" fill="rgba(255,255,255,0.3)" cx="194.399" cy="60.749" rx="19.076" ry="32.428"/></g><text x="117.5" y="160" style="font-size:160px;fill:#fff;text-anchor:middle">{text}</text></svg>',"marker-square":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(26.67 * {scale})" height="calc(32.27 * {scale})" viewBox="0 0 2000 2420"><g transform="translate(100 100)" style="stroke:{secondaryColor};stroke-width:100;fill:{color}"><path d="M845 2152c-22-37-58-95-80-129-22-35-62-99-90-143l-50-80-312 0-313 0 0-900 0-900 900 0 900 0 0 900 0 900-313 0-313 0-34 58c-19 31-38 59-42 60-5 2-8 8-8 12 0 9-69 123-88 145-5 6-11 15-13 21-16 39-77 123-89 124-8 0-33-31-55-68z"/></g><text x="1000" y="1300" style="font-size:1000px;fill:#fff;text-anchor:middle">{text}</text></svg>',"marker-square-cluster":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(33.33 * {scale})" height="calc(38.8 * {scale})" viewBox="0 0 2500 2910"><g transform="translate(100 100)" style="stroke:{secondaryColor};stroke-width:100;fill:{color}"><path d="m866 2652c-17-31-37-68-46-82-9-14-32-54-51-90-19-36-50-92-70-125l-36-60-332-3-331-2 0-905 0-905 660 0 660 0 0-38c0-71 50-196 102-258 71-85 189-164 244-164 12 0 26-4 29-10 8-13 222-13 230 0 3 6 17 10 30 10 25 0 117 45 154 76 130 107 191 232 191 392 0 155-63 284-190 386-36 29-129 76-150 76-11 0-22 5-25 10-3 6-31 10-61 10l-54 0 0 660 0 660-332 2-332 3-29 50c-17 28-48 84-70 125-22 41-47 86-56 100-9 14-30 51-46 83-17 32-36 57-45 57-8 0-28-25-44-58z"/></g><text x="1650" y="900" style="font-size:1000px;fill:#fff">+</text><text x="1000" y="1800" style="font-size:1000px;fill:#fff;text-anchor:middle">{text}</text></svg>',"marker-square-rounded":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(26.8 * {scale})" height="calc(32.27 * {scale})" viewBox="0 0 2010 2410"><g transform="translate(100 100)" style="stroke:{secondaryColor};stroke-width:100;fill:{color}"><path d="M856 2155c-20-30-36-59-36-65 0-5-4-10-10-10-5 0-10-5-10-11 0-5-18-37-40-69-22-32-40-64-40-69 0-6-4-11-10-11-5 0-10-5-10-10 0-6-15-33-32-60l-33-50-127 0c-74 0-129-4-133-10-3-5-17-10-30-10-25 0-116-45-155-76-87-69-142-151-178-265-15-46-17-1075-2-1084 5-3 10-17 10-30 0-13 5-27 10-30 6-3 10-13 10-22 0-22 83-135 122-168 57-46 62-50 112-75l50-25 585 0 586 0 63 34c84 46 169 133 212 218l35 68 0 565 0 565-28 59c-32 69-100 157-139 180-15 9-33 22-40 29-23 22-99 57-123 57-13 0-27 5-30 10-4 6-60 10-135 10l-128 0-128 205c-84 136-133 205-144 205-10 0-33-24-54-55z"/></g><text x="1000" y="1300" style="font-size:1000px;fill:#fff;text-anchor:middle">{text}</text></svg>',"marker-square-rounded-cluster":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(33.33 * {scale})" height="calc(32.13 * {scale})" viewBox="0 0 2500 2900"><g transform="translate(100 100)" style="stroke:{secondaryColor};stroke-width:100;fill:{color}"><path d="m874 2669c-9-18-26-49-37-68-11-20-30-55-43-78-13-24-36-64-51-90-14-27-38-69-52-95l-26-48-142 0c-84 0-144-4-148-10-3-5-17-10-30-10-25 0-118-46-154-76-91-76-136-142-175-254-13-38-16-119-16-554 0-358 3-520 12-545 40-125 106-219 195-278 127-84 116-83 646-83l467 0 0-42c0-46 11-87 45-163 54-121 169-220 306-264 46-14 232-14 278 0 165 53 284 175 340 350 19 61 14 204-10 273-32 91-94 178-169 240-38 31-130 76-155 76-13 0-27 5-30 10-3 6-28 10-56 10l-49 0 0 462c0 446-1 464-21 522-32 91-94 178-169 240-38 31-130 76-155 76-13 0-27 5-30 10-4 6-65 10-149 10-138 0-143 1-154 23-12 23-62 114-112 202-16 28-44 79-63 115-42 77-67 88-93 39z"/></g><text x="1650" y="900" style="font-size:1000px;fill:#fff">+</text><text x="1000" y="1800" style="font-size:1000px;fill:#fff;text-anchor:middle">{text}</text></svg>',flag:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(23.5 * {scale})" height="calc(40 * {scale})" viewBox="34 28 198 308"><path style="stroke:{secondaryColor};stroke-width:15;stroke-linecap:round;" d="M42 327l0 -291"/><path style="fill:{color};stroke:{secondaryColor};stroke-width:10;stroke-linejoin:round;" d="M49 50c70 30 104 28 178 2-21 42-21 74 0 116-72 25-101 25-178 0l0-118z"/><text x="130" y="165" style="font-size:100px;fill:#fff;text-anchor:middle">{text}</text></svg>',"flag-triangle":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(27 * {scale})" height="calc(35.33 * {scale})" viewBox="0 0 40.5 53"><g transform="translate(-31 -20)"><path fill="{secondaryColor}" d="M34.7,73.3V48.4l34.6-10.1c0.7-0.2,1.2-0.8,1.2-1.5s-0.4-1.4-1-1.7L33.7,20.5c-0.5-0.2-1.1-0.2-1.6,0.2 c-0.5,0.3-0.7,0.8-0.7,1.4v51.2H34.7z"/><polygon points="34.7,24.5 66,36.5 34.7,45 34.7,10" fill="{color}"/></g><text x="11" y="21" style="font-size:14px;fill:#fff;text-anchor:middle">{text}</text></svg>',"rounded-square":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(34 * {scale})" height="calc(34 * {scale})" viewBox="0 0 34 34"><g transform="translate(2 2)"><rect x="0" y="0" rx="8" ry="8" width="30" height="30" style="stroke:{secondaryColor};stroke-width:2;fill:{color}"/></g><text x="17" y="22" style="font-size:14px;fill:#fff;text-anchor:middle">{text}</text></svg>',"rounded-square-thick":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(38 * {scale})" height="calc(38 * {scale})" viewBox="0 0 38 38"><g transform="translate(4 4)"><rect x="0" y="0" rx="8" ry="8" width="30" height="30" style="stroke:{secondaryColor};stroke-width:4;fill:{color}"/></g><text x="19" y="24" style="font-size:14px;fill:#fff;text-anchor:middle">{text}</text></svg>',triangle:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(36 * {scale})" height="calc(36 * {scale})" viewBox="0 0 36 36"><g transform="translate(2 2)"><polygon points="16,0 32,32 0,32 16,0" style="stroke:{secondaryColor};stroke-width:2;fill:{color}"/></g><text x="17.5" y="30" style="font-size:12px;fill:#fff;text-anchor:middle">{text}</text></svg>',"triangle-thick":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(40 * {scale})" height="calc(40 * {scale})" viewBox="0 0 40 40"><g transform="translate(4 4)"><polygon points="16,0 32,32 0,32 16,0" style="stroke:{secondaryColor};stroke-width:4;fill:{color}"/></g><text x="19.5" y="32" style="font-size:12px;fill:#fff;text-anchor:middle">{text}</text></svg>',hexagon:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(35 * {scale})" height="calc(40 * {scale})" viewBox="0 0 35 40"><g transform="translate(2 2)"><path d="M31 9 15.5 0 0 9 0 27 15.5 36 31 27 31 9Z" style="stroke:{secondaryColor};stroke-width:2;fill:{color}"/></g><text x="17.5" y="25" style="font-size:14px;fill:#fff;text-anchor:middle">{text}</text></svg>',"hexagon-thick":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(39 * {scale})" height="calc(44 * {scale})" viewBox="0 0 39 44"><g transform="translate(4 4)"><path d="M31 9 15.5 0 0 9 0 27 15.5 36 31 27 31 9Z" style="stroke:{secondaryColor};stroke-width:4;fill:{color}"/></g><text x="19.5" y="27" style="font-size:14px;fill:#fff;text-anchor:middle">{text}</text></svg>',"hexagon-rounded":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(40 * {scale})" height="calc(40 * {scale})" viewBox="0 0 1100 1100"><g transform="translate(50 50)"><path style="stroke:{secondaryColor};stroke-width:50;fill:{color}" d="M881 210 561 25c-33-19-88-19-121 0L119 210c-33 19-61 67-61 105v370c0 39 27 86 61 105l321 185c33 19 88 19 122 0l321-185c33-19 61-67 61-105V315C942 276 915 229 881 210z"/></g><text x="550" y="700" style="font-size:400px;fill:#fff;text-anchor:middle">{text}</text></svg>',"hexagon-rounded-thick":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(40 * {scale})" height="calc(40 * {scale})" viewBox="0 0 1200 1200"><g transform="translate(100 100)"><path style="stroke:{secondaryColor};stroke-width:100;fill:{color}" d="M881 210 561 25c-33-19-88-19-121 0L119 210c-33 19-61 67-61 105v370c0 39 27 86 61 105l321 185c33 19 88 19 122 0l321-185c33-19 61-67 61-105V315C942 276 915 229 881 210z"/></g><text x="600" y="750" style="font-size:400px;fill:#fff;text-anchor:middle">{text}</text></svg>',"triangle-arrow-up":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(28 * {scale})" height="calc(28 * {scale})" viewBox="0 0 28 28"><g transform="translate(2 2)"><polygon points="12,0 0,24 12,17 24,24" stroke-width="2" stroke="{secondaryColor}" fill="{color}"/></g><text x="14" y="17" style="font-size:8px;fill:#fff;text-anchor:middle">{text}</text></svg>',"triangle-arrow-left":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(28 * {scale})" height="calc(28 * {scale})" viewBox="0 0 28 28"><g transform="translate(2 2)"><polygon points="24,12 0,0 7,12 0,24" stroke-width="2" stroke="{secondaryColor}" fill="{color}"/></g><text x="14" y="16.5" style="font-size:8px;fill:#fff;text-anchor:middle">{text}</text></svg>',"arrow-up":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(12.16 * {scale})" height="calc(30.1 * {scale})" viewBox="0 0 902 364"><g fill="{color}" transform="matrix(0,2.4,-2.4,0,897,-930)"><polygon points="902,222 233,222 233,364 0,182 233,0 233,141 902,141 902,222"/></g><text x="450" y="700" style="font-size:900px;fill:#000;text-anchor:middle">{text}</text></svg>',"arrow-up-thin":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(16 * {scale})" height="calc(33.33 * {scale})" viewBox="0 0 12 25"><g transform="translate(-136.91823 -751.91998)"><path fill="{color}" d="m148.271 760.71c-1.641-.547-3.186-1.47-4.633-2.769l0 18.07-1.675 0 0-18.07c-1.447 1.299-2.986 2.222-4.616 2.769l0-1.231c2.325-1.596 4.006-3.812 5.043-6.65l.838 0c1.037 2.838 2.718 5.055 5.043 6.65l0 1.231z"/></g><text x="6" y="20" style="font-size:10px;fill:#000;text-anchor:middle">{text}</text></svg>',car:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(21.93 * {scale})" height="calc(40.9 * {scale})" viewBox="0 0 6580 12270"><g transform="translate(0 12270) rotate(-90)"><path fill="{secondaryColor}" d="M7045 6566c-42-13-105-44-105-51 0-2 23-105 50-228 28-123 50-230 50-236 0-8-241-11-907-11-855 0-1145 6-1513 30-85 6-189 13-230 15-41 3-133 10-205 15-286 21-430 32-705 50-953 63-1459 18-2335-205-304-77-746-209-799-238-131-72-221-408-285-1062-34-345-42-532-48-1130-16-1557 108-2532 336-2649 32-17 469-149 676-205 409-110 819-191 1205-238 116-14 224-18 540-18 395 1 494 5 1140 50 1124 79 1224 82 2496 78l641-3-53-237c-29-131-52-238-51-239 1-1 31-14 66-29 56-23 76-26 142-23 67 3 83 7 120 33 23 17 50 41 61 55 10 14 51 117 91 230l73 205 674 3 675 2 90-39c98-43 198-72 315-93 122-21 829-18 990 5 321 45 626 143 849 270 293 168 516 378 704 662 266 402 416 893 467 1527 15 174 8 882-9 998-6 41-18 127-27 190-69 502-253 969-523 1325-79 105-262 284-381 374-189 142-355 229-574 300-336 110-526 139-952 148-457 9-685-23-887-124l-47-24-678-6-678-6-64 179c-79 224-92 253-121 284-67 70-177 97-274 66zm-2752-5073c-23-2-64-2-90 0-26 2-7 3 42 3 50 0 71-1 48-3zm395 0c-21-2-55-2-75 0-21 2-4 4 37 4 41 0 58-2 38-4z"/><path fill="{color}" d="M7043 6498c-13-6-23-19-23-28 0-9 23-117 50-240 28-123 50-230 50-237 0-22-2126-13-2465 10-132 10-400 28-595 42-661 47-824 55-1160 62-435 7-656-8-1040-73-415-70-865-183-1447-365-168-53-272-556-325-1569-16-319-16-1311 0-1630 45-872 129-1366 257-1518 22-26 51-39 172-77 557-177 1122-310 1563-369 271-36 351-40 690-40 361 1 463 6 1165 54 1122 78 1288 83 2337 79 460-2 840-7 843-11 4-4-17-117-47-252l-55-245 39-16c76-30 180-8 224 47 10 13 54 124 98 246l79 222 709 0 709 0 47-24c74-37 219-83 322-101 122-22 606-32 802-16 374 29 658 102 933 238 124 62 271 155 361 230l61 51 6 100c19 278 103 497 247 643 88 89 173 136 278 152l70 11 41 131c116 369 159 673 168 1170 10 584-38 984-167 1397l-40 126-70 12c-193 33-348 175-441 405-56 139-89 302-89 445 0 43-3 47-58 91-290 235-644 384-1068 450-191 29-796 39-974 16-135-18-263-54-368-102l-75-35-701 0-701 0-79 223c-82 232-102 267-163 293-38 16-138 17-170 2zm-2023-820c332-15 1155-12 1835 6 308 8 563 12 566 8 4-4 10-21 13-38 7-30 6-31-92-77-518-244-1197-396-2112-474-295-25-1282-25-1579 0-231 20-473 46-479 51-6 7 49 110 93 171 160 226 416 335 855 365 142 10 539 5 900-12zm3304-263c525-111 899-887 934-1935 19-557-37-1023-172-1435-186-563-521-900-896-899-81 0-158 14-525 92-426 91-431 92-540 146-195 96-287 207-306 368-12 104-11 2985 1 3078 22 170 135 291 365 389 49 21 191 55 480 115 226 47 419 87 430 89 45 10 164 6 229-8zm-5570-485c112-43 197-156 216-291 12-83 13-2623 1-2706-23-158-125-273-270-304-44-9-100-1-542 75-272 47-514 91-539 98-266 68-487 424-594 958-56 280-70 548-40 800 56 484 207 878 414 1081 115 114 122 116 702 218 277 49 524 90 550 90 26 1 72-8 102-19zm2111-3440c1023-44 1884-213 2462-486l113-53-7-33c-3-18-8-35-10-37-2-3-236 1-521 7-993 24-1271 26-1708 11-541-18-1128-18-1249-1-377 56-588 181-734 437-32 55-41 79-32 84 12 8 246 32 491 51 356 28 815 36 1195 20z"/></g><text x="3250" y="8250" style="font-size:3000px;fill:#fff;text-anchor:middle">{text}</text></svg>',checker:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(16 * {scale})" height="calc(16 * {scale})" viewBox="0 0 16 16"><pattern id="p" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse"><rect fill="{color}" x="0" width="8" height="8" y="0"/><rect fill="{color}" x="8" width="8" height="8" y="8"/></pattern><rect x="0" y="0" width="16" height="16" fill="{secondaryColor}"/><rect x="0" y="0" width="16" height="16" fill="url(#p)"/></svg>',"checker-rotated":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(16 * {scale})" height="calc(16 * {scale})" viewBox="0 0 60 60"><rect width="60" height="60" fill="{secondaryColor}"/><rect width="42.42" height="42.42" transform="translate(30 0) rotate(45)" fill="{color}"/></svg>',"zig-zag":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(15 * {scale})" height="calc(15 * {scale})" viewBox="0 0 120 120"><rect x="0" y="0" width="120" height="120" fill="{secondaryColor}"/><polygon fill="{color}" points="120 120 60 120 90 90 120 60 120 0 120 0 60 60 0 0 0 60 30 90 60 120 120 120"/></svg>',"zig-zag-vertical":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(15 * {scale})" height="calc(15 * {scale})" viewBox="0 0 120 120"><rect x="0" y="0" width="120" height="120" fill="{secondaryColor}"/><polygon fill="{color}" points="120 0 120 60 90 30 60 0 0 0 0 0 60 60 0 120 60 120 90 90 120 60 120 0"/></svg>',"circles-spaced":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(20 * {scale})" height="calc(20 * {scale})" viewBox="0 0 20 20"><defs><pattern id="p" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="2" stroke="none" fill="{color}"/></pattern></defs><rect x="0" y="0" width="20" height="20" fill="{secondaryColor}"/><rect x="0" y="0" width="100" height="100" fill="url(#p)"/></svg>',circles:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(7 * {scale})" height="calc(7 * {scale})" viewBox="0 0 20 20"><defs><pattern id="p" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="6" stroke="none" fill="{color}"/></pattern></defs><rect x="0" y="0" width="20" height="20" fill="{secondaryColor}"/><rect x="0" y="0" width="100" height="100" fill="url(#p)"/></svg>',"diagonal-lines-up":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(18 * {scale})" height="calc(18 * {scale})" viewBox="0 0 6 6"><rect x="0" y="0" width="6" height="6" fill="{secondaryColor}"/><g fill="{color}"><path d="M5 0h1L0 6V5zM6 5v1H5z"/></g></svg>',"diagonal-lines-down":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(18 * {scale})" height="calc(18 * {scale})" viewBox="0 0 6 6"><rect x="0" y="0" width="6" height="6" fill="{secondaryColor}"/><g transform="rotate(90 3 3)" fill="{color}"><path d="M5 0h1L0 6V5zM6 5v1H5z"/></g></svg>',"diagonal-stripes-up":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(20 * {scale})" height="calc(20 * {scale})" viewBox="0 0 40 40"><rect x="0" y="0" width="40" height="40" fill="{secondaryColor}"/><g fill="{color}"><path d="M0 40L40 0H20L0 20M40 40V20L20 40"/></g></svg>',"diagonal-stripes-down":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(20 * {scale})" height="calc(20 * {scale})" viewBox="0 0 40 40"><rect x="0" y="0" width="40" height="40" fill="{secondaryColor}"/><g transform="rotate(90 20 20)" fill="{color}"><path d="M0 40L40 0H20L0 20M40 40V20L20 40"/></g></svg>',"grid-lines":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(14 * {scale})" height="calc(14 * {scale})" viewBox="0 0 6 6"><rect x="0" y="0" width="6" height="6" fill="{secondaryColor}"/><g transform="rotate(45 3 3)" fill="{color}"><path d="M5 0h1L0 6V5zM6 5v1H5z"/></g><g fill="{color}" transform="rotate(-45 3 3)"><path d="M5 0h1L0 6V5zM6 5v1H5z"/></g></svg>',"rotated-grid-lines":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(18 * {scale})" height="calc(18 * {scale})" viewBox="0 0 6 6"><rect x="0" y="0" width="6" height="6" fill="{secondaryColor}"/><g transform="rotate(90 3 3)" fill="{color}"><path d="M5 0h1L0 6V5zM6 5v1H5z"/></g><g fill="{color}"><path d="M5 0h1L0 6V5zM6 5v1H5z"/></g></svg>',"rotated-grid-stripes":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(20 * {scale})" height="calc(20 * {scale})" viewBox="0 0 40 40"><rect x="0" y="0" width="40" height="40" fill="{secondaryColor}"/><g transform="rotate(90 20 20)" fill="{color}"><path d="M0 40L40 0H20L0 20M40 40V20L20 40"/></g><g fill="{color}"><path d="M0 40L40 0H20L0 20M40 40V20L20 40"/></g></svg>',"x-fill":'<svg xmlns="http://www.w3.org/2000/svg" width="calc(40 * {scale})" height="calc(40 * {scale})" viewBox="0 0 40 40"><rect x="0" y="0" width="45.3" height="45.3" fill="{secondaryColor}"/><g fill="{color}"><path d="M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z"/></g></svg>',dots:'<svg xmlns="http://www.w3.org/2000/svg" width="calc(13 * {scale})" height="calc(13 * {scale})" viewBox="0 0 20 20"><rect x="0" y="0" width="20" height="20" fill="{secondaryColor}"/><g fill="{color}"><circle cx="3" cy="3" r="3"/><circle cx="13" cy="13" r="3"/></g></svg>'},us=(cs.getHighContrastMode=function(){return matchMedia("(-ms-high-contrast: white-on-black)").matches?"dark":matchMedia("(-ms-high-contrast: black-on-white)").matches?"light":matchMedia("(-ms-high-contrast: active)").matches?"dark":matchMedia("(inverted-colors: inverted)").matches?"invert":null},cs);function cs(){}var ps=2,hs="function",ds="object",fs="undefined",ms="prototype",ys="hasOwnProperty",gs=Object,vs=gs[ms],_s=gs.assign,xs=gs.create,bs=(Ct=gs.defineProperty,vs[ys]);function ws(){return typeof globalThis!==fs&&globalThis?globalThis:typeof self!==fs&&self?self:typeof window!==fs&&window?window:typeof global!==fs&&global?global:null}function Ss(t){throw new TypeError(t)}function Ts(t){if(xs)return xs(t);if(null==t)return{};var e=typeof t;function i(){}return e!==ds&&e!==hs&&Ss("Object prototype may only be an Object:"+t),i[ms]=t,new i}(ws()||{}).Symbol,(ws()||{}).Reflect;var Cs=_s||function(t){for(var e,i=1,r=arguments.length;i<r;i++)for(var n in e=arguments[i])vs[ys].call(e,n)&&(t[n]=e[n]);return t},Es=function(t,e){return(Es=gs.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e[ys](i)&&(t[i]=e[i])})(t,e)};function Is(t,e){function i(){this.constructor=t}typeof e!==hs&&null!==e&&Ss("Class extends value "+String(e)+" is not a constructor or null"),Es(t,e),t[ms]=null===e?Ts(e):(i[ms]=e[ms],new i)}var ks,As="constructor",Ps="prototype",Ms="function",Ls="_dynInstFuncs",Os="_isDynProxy",Rs="_dynClass",zs="_dynInstChk",Ds=zs,Ns="_dfOpts",Bs="_unknown_",Fs="__proto__",Us="useBaseInst",js="setInstFuncs",Vs=Object,qs=Vs.getPrototypeOf,Hs=0;function Gs(t,e){return t&&Vs[Ps].hasOwnProperty.call(t,e)}function Zs(t){return t&&(t===Vs[Ps]||t===Array[Ps])}function Ws(t){return Zs(t)||t===Function[Ps]}function Ks(t){if(t){if(qs)return qs(t);if(t=t[Fs]||t[Ps]||(t[As]?t[As][Ps]:null))return t}return null}function Xs(t,e){var i=[],r=Vs.getOwnPropertyNames;if(r)i=r(t);else for(var n in t)"string"==typeof n&&Gs(t,n)&&i.push(n);if(i&&0<i.length)for(var o=0;o<i.length;o++)e(i[o])}function Ys(t,e,i){return e!==As&&typeof t[e]===Ms&&(i||Gs(t,e))}function Js(t){throw new TypeError("DynamicProto: "+t)}function Qs(t,e){for(var i=t.length-1;0<=i;i--)if(t[i]===e)return 1}function $s(t,e,i,r,n){var o,a;Zs(t)||(o=i[Ls]=i[Ls]||{},a=o[e]=o[e]||{},!1!==o[Ds]&&(o[Ds]=!!n),Xs(i,function(e){Ys(i,e,!1)&&i[e]!==r[e]&&(a[e]=i[e],delete i[e],Gs(t,e)&&(!t[e]||t[e][Os])||(t[e]=function(t,e){function i(){var r,n,o,a;return(function(t,e,i,r){var n=null;if(t&&Gs(i,Rs)){var o=t[Ls]||{};if((n=(o[i[Rs]]||{})[e])||Js("Missing ["+e+"] "+Ms),!n[zs]&&!1!==o[Ds]){for(var a=!Gs(t,e),s=Ks(t),l=[];a&&s&&!Ws(s)&&!Qs(l,s);){var u=s[e];if(u){a=u===r;break}l.push(s),s=Ks(s)}try{a&&(t[e]=n),n[zs]=1}catch(t){o[Ds]=!1}}}return n}(this,e,t,i)||(o=i,typeof(a=(a=(n=t)[r=e])===o?Ks(n)[r]:a)!==Ms&&Js("["+r+"] is not a "+Ms),a)).apply(this,arguments)}return i[Os]=1,i}(t,e)))}))}function tl(t,e){return Gs(t,Ps)?t.name||e||Bs:((t||{})[As]||{}).name||e||Bs}function el(t,e,i,r){Gs(t,Ps)||Js("theClass is an invalid class definition.");var n=t[Ps];!function(t,e){if(qs)for(var i=[],r=Ks(e);r&&!Ws(r)&&!Qs(i,r);){if(r===t)return 1;i.push(r),r=Ks(r)}}(n,e)&&Js("["+tl(t)+"] is not in class hierarchy of ["+tl(e)+"]");var o=null;Gs(n,Rs)?o=n[Rs]:(o="_dynCls$"+tl(t,"_")+"$"+Hs,Hs++,n[Rs]=o);var a,s,l=el[Ns],u=!!l[Us];u&&r&&void 0!==r[Us]&&(u=!!r[Us]),i(e,function(t,e,i,r){function n(t,e,i){var n,o=e[i];return o[Os]&&r&&!1!==(n=t[Ls]||{})[Ds]&&(o=(n[e[Rs]]||{})[i]||o),function(){return o.apply(t,arguments)}}var o={};Xs(i,function(t){o[t]=n(e,i,t)});for(var a=Ks(t),s=[];a&&!Ws(a)&&!Qs(s,a);)Xs(a,function(t){!o[t]&&Ys(a,t,!qs)&&(o[t]=n(e,a,t))}),s.push(a),a=Ks(a);return o}(n,e,t=(s={},Xs(a=e,function(t){!s[t]&&Ys(a,t,!1)&&(s[t]=a[t])}),s),u)),$s(n,o,e,t,!1!==(l=(l=!!qs&&!!l[js])&&r?!!r[js]:l))}el[Ns]={setInstFuncs:!0,useBaseInst:!0},(bt=ks=ks||{})[bt.CRITICAL=1]="CRITICAL",bt[bt.WARNING=2]="WARNING";var il={BrowserDoesNotSupportLocalStorage:0,BrowserCannotReadLocalStorage:1,BrowserCannotReadSessionStorage:2,BrowserCannotWriteLocalStorage:3,BrowserCannotWriteSessionStorage:4,BrowserFailedRemovalFromLocalStorage:5,BrowserFailedRemovalFromSessionStorage:6,CannotSendEmptyTelemetry:7,ClientPerformanceMathError:8,ErrorParsingAISessionCookie:9,ErrorPVCalc:10,ExceptionWhileLoggingError:11,FailedAddingTelemetryToBuffer:12,FailedMonitorAjaxAbort:13,FailedMonitorAjaxDur:14,FailedMonitorAjaxOpen:15,FailedMonitorAjaxRSC:16,FailedMonitorAjaxSend:17,FailedMonitorAjaxGetCorrelationHeader:18,FailedToAddHandlerForOnBeforeUnload:19,FailedToSendQueuedTelemetry:20,FailedToReportDataLoss:21,FlushFailed:22,MessageLimitPerPVExceeded:23,MissingRequiredFieldSpecification:24,NavigationTimingNotSupported:25,OnError:26,SessionRenewalDateIsZero:27,SenderNotInitialized:28,StartTrackEventFailed:29,StopTrackEventFailed:30,StartTrackFailed:31,StopTrackFailed:32,TelemetrySampledAndNotSent:33,TrackEventFailed:34,TrackExceptionFailed:35,TrackMetricFailed:36,TrackPVFailed:37,TrackPVFailedCalc:38,TrackTraceFailed:39,TransmissionFailed:40,FailedToSetStorageBuffer:41,FailedToRestoreStorageBuffer:42,InvalidBackendResponse:43,FailedToFixDepricatedValues:44,InvalidDurationValue:45,TelemetryEnvelopeInvalid:46,CreateEnvelopeError:47,CannotSerializeObject:48,CannotSerializeObjectNonSerializable:49,CircularReferenceDetected:50,ClearAuthContextFailed:51,ExceptionTruncated:52,IllegalCharsInName:53,ItemNotInArray:54,MaxAjaxPerPVExceeded:55,MessageTruncated:56,NameTooLong:57,SampleRateOutOfRange:58,SetAuthContextFailed:59,SetAuthContextFailedAccountName:60,StringValueTooLong:61,StartCalledMoreThanOnce:62,StopCalledWithoutStart:63,TelemetryInitializerFailed:64,TrackArgumentsNotSpecified:65,UrlTooLong:66,SessionStorageBufferFull:67,CannotAccessCookie:68,IdTooLong:69,InvalidEvent:70,FailedMonitorAjaxSetRequestHeader:71,SendBrowserInfoOnUserInit:72,PluginException:73,NotificationException:74,SnippetScriptLoadFailure:99,InvalidInstrumentationKey:100,CannotParseAiBlobValue:101,InvalidContentBlob:102,TrackPageActionEventFailed:103},rl="attachEvent",nl="addEventListener",ol="detachEvent",al="removeEventListener",sl=Ct;function ll(t){return vs.toString.call(t)}function ul(t){return void 0===t||typeof t===fs}function cl(t){return null===t||ul(t)}function pl(t){return!cl(t)}function hl(t,e){return t&&bs.call(t,e)}function dl(t){return typeof t===ds}function fl(t){return typeof t===hs}function ml(t,e,i,r){void 0===r&&(r=!1);var n=!1;if(!cl(t))try{cl(t[nl])?cl(t[rl])||(t[rl]("on"+e,i),n=!0):(t[nl](e,i,r),n=!0)}catch(t){}return n}function yl(t,e,i,r){if(void 0===r&&(r=!1),!cl(t))try{cl(t[al])?cl(t[ol])||t[ol]("on"+e,i):t[al](e,i,r)}catch(t){}}function gl(t,e){if(t)for(var i in t)bs.call(t,i)&&e.call(t,i,t[i])}function vl(t,e){return!(!t||!e)&&-1!==t.indexOf(e)}function _l(t){return"[object Array]"===ll(t)}function xl(t){return"[object Error]"===ll(t)}function bl(t){return"string"==typeof t}function wl(t){return"number"==typeof t}function Sl(t){if("[object Date]"===ll(t)){var e=function(t){return 1===(t=String(t)).length?"0"+t:t};return t.getUTCFullYear()+"-"+e(t.getUTCMonth()+1)+"-"+e(t.getUTCDate())+"T"+e(t.getUTCHours())+":"+e(t.getUTCMinutes())+":"+e(t.getUTCSeconds())+"."+String((t.getUTCMilliseconds()/1e3).toFixed(3)).slice(2,5)+"Z"}}function Tl(t,e,i){for(var r=t.length,n=0;n<r&&!(n in t&&-1===e.call(i||t,t[n],n,t));n++);}function Cl(t,e,i){for(var r=t.length,n=(i=i||0,Math.max(0<=i?i:r-Math.abs(i),0));n<r;n++)if(n in t&&t[n]===e)return n;return-1}function El(t,e,i){for(var r=t.length,n=i||t,o=new Array(r),a=0;a<r;a++)a in t&&(o[a]=e.call(n,t[a],t));return o}function Il(t){return"string"!=typeof t?t:t.replace(/^\s+|\s+$/g,"")}var kl=!{toString:null}.propertyIsEnumerable("toString"),Al=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"];function Pl(t){var e=typeof t;e===hs||e===ds&&null!==t||Ss("objKeys called on non-object");var i,r=[];for(i in t)t&&bs.call(t,i)&&r.push(i);if(kl)for(var n=Al.length,o=0;o<n;o++)t&&bs.call(t,Al[o])&&r.push(Al[o]);return r}function Ml(t,e,i,r){if(sl)try{var n={enumerable:!0,configurable:!0};return i&&(n.get=i),r&&(n.set=r),sl(t,e,n),!0}catch(t){}return!1}function Ll(){var t=Date;return t.now?t.now():(new t).getTime()}function Ol(t){return xl(t)?t.name:""}function Rl(t,e,i,r,n){var o=i;return t&&((o=t[e])===i||n&&!n(o)||r&&!r(i)||(t[e]=o=i)),o}function zl(t,e,i){var r;return t?!(r=t[e])&&cl(r)&&(r=ul(i)?{}:i,t[e]=r):r=ul(i)?{}:i,r}function Dl(t){return!t}function Nl(t){return!!t}function Bl(t){throw new Error(t)}function Fl(t){return t&&gs(_s?_s({},t):t)}var Ul="window",jl="document",Vl="navigator",ql="history",Hl="location",Gl="performance",Zl="JSON",Wl="msie",Kl="trident/",Xl=null,Yl=null,Jl=!1;function Ql(t){var e=ws();return e&&e[t]?e[t]:t===Ul&&$l()?window:null}function $l(){return Boolean(typeof window===ds&&window)}function tu(){return $l()?window:Ql(Ul)}function eu(){return Boolean(typeof document===ds&&document)}function iu(){return eu()?document:Ql(jl)}function ru(){return Boolean(typeof navigator===ds&&navigator)?navigator:Ql(Vl)}function nu(t){return t&&Jl&&(t=Ql("__mockLocation"))?t:typeof location===ds&&location?location:Ql(Hl)}function ou(){return Ql(Gl)}function au(){return Boolean(typeof JSON===ds&&JSON||null!==Ql(Zl))}function su(){return au()?JSON||Ql(Zl):null}function lu(){var t=ru();return!t||t.userAgent===Yl&&null!==Xl||(t=((Yl=t.userAgent)||"").toLowerCase(),Xl=vl(t,Wl)||vl(t,Kl)),Xl}function uu(t){var e;return vl(t=((t=(t=void 0===t?null:t)?t:(e=ru()||{})?(e.userAgent||"").toLowerCase():"")||"").toLowerCase(),Wl)?parseInt(t.split(Wl)[1]):vl(t,Kl)&&(t=parseInt(t.split(Kl)[1]))?t+4:null}function cu(t){var e=Object[ms].toString.call(t),i="";return"[object Error]"===e?i="{ stack: '"+t.stack+"', message: '"+t.message+"', name: '"+t.name+"'":au()&&(i=su().stringify(t)),e+i}function pu(t){return t?'"'+t.replace(/\"/g,"")+'"':""}var hu=(du.dataType="MessageData",du);function du(t,e,i,r){void 0===i&&(i=!1),this.messageId=t,this.message=(i?"AI: ":"AI (Internal): ")+t,t="",au()&&(t=su().stringify(r)),t=(e?" message:"+pu(e):"")+(r?" props:"+pu(t):""),this.message+=t}function fu(t,e){return(t||{}).logger||new mu(e)}var mu=function t(e){this.identifier="DiagnosticLogger",this.queue=[];var i=0,r={};el(t,this,function(t){function n(t,i){return cl(t=e[t])?i:t}cl(e)&&(e={}),t.consoleLoggingLevel=function(){return n("loggingLevelConsole",0)},t.telemetryLoggingLevel=function(){return n("loggingLevelTelemetry",1)},t.maxInternalMessageLimit=function(){return n("maxMessageLimit",25)},t.enableDebugExceptions=function(){return n("enableDebugExceptions",!1)},t.throwInternal=function(e,i,n,o,a){if(n=new hu(i,n,a=void 0!==a&&a,o),t.enableDebugExceptions())throw n;ul(n.message)||(o=t.consoleLoggingLevel(),a?(a=+n.messageId,!r[a]&&o>=ks.WARNING&&(t.warnToConsole(n.message),r[a]=!0)):o>=ks.WARNING&&t.warnToConsole(n.message),t.logInternalMessage(e,n))},t.warnToConsole=function(t){var e,i=typeof console!==fs?console:Ql("console");i&&(e="log",fl(i[e=i.warn?"warn":e])&&i[e](t))},t.resetInternalMessageCount=function(){i=0,r={}},t.logInternalMessage=function(e,n){var o,a;i>=t.maxInternalMessageLimit()||(o=!0,a="AITR_"+n.messageId,r[a]?o=!1:r[a]=!0,o&&(e<=t.telemetryLoggingLevel()&&(t.queue.push(n),i++),i===t.maxInternalMessageLimit()&&(n=new hu(il.MessageLimitPerPVExceeded,e="Internal events throttle limit per PageView reached for this app.",!1),t.queue.push(n),t.warnToConsole(e))))}})},yu=(gu.ParentContextKey="parent",gu.ChildrenContextKey="childEvts",gu);function gu(t,e,i){var r,n=this,o=!1;n.start=Ll(),n.name=t,n.isAsync=i,n.isChildEvt=function(){return!1},fl(e)&&(o=Ml(n,"payload",function(){return!r&&fl(e)&&(r=e(),e=null),r})),n.getCtx=function(t){return t?(t===gu.ParentContextKey||t===gu.ChildrenContextKey?n:n.ctx||{})[t]:null},n.setCtx=function(t,e){t&&(t===gu.ParentContextKey?(n[t]||(n.isChildEvt=function(){return!0}),n[t]=e):t===gu.ChildrenContextKey?n[t]=e:(n.ctx=n.ctx||{})[t]=e)},n.complete=function(){var t=0,i=n.getCtx(gu.ChildrenContextKey);if(_l(i))for(var r=0;r<i.length;r++){var a=i[r];a&&(t+=a.time)}n.time=Ll()-n.start,n.exTime=n.time-t,n.complete=function(){},!o&&fl(e)&&(n.payload=e())}}var vu=function t(e){this.ctx={},el(t,this,function(t){t.create=function(t,e,i){return new yu(t,e,i)},t.fire=function(t){t&&(t.complete(),e&&e.perfEvent(t))},t.setCtx=function(e,i){e&&((t.ctx=t.ctx||{})[e]=i)},t.getCtx=function(e){return(t.ctx||{})[e]}})},_u="CoreUtils.doPerf";function xu(t,e,i,r,n){if(t){var o=t;if(o=fl(o.getPerfMgr)?o.getPerfMgr():o){var a=void 0;t=o.getCtx(_u);try{var s;if(a=o.create(e(),r,n))return t&&a.setCtx&&(a.setCtx(yu.ParentContextKey,t),t.getCtx&&t.setCtx&&((s=t.getCtx(yu.ChildrenContextKey))||(s=[],t.setCtx(yu.ChildrenContextKey,s)),s.push(a))),o.setCtx(_u,a),i(a)}catch(t){a&&a.setCtx&&a.setCtx("exception",t)}finally{a&&o.fire(a),o.setCtx(_u,t)}}}return i()}var bu=function(t,e){var i=this,r=null,n=fl(t.processTelemetry),o=fl(t.setNextPlugin);i._hasRun=!1,i.getPlugin=function(){return t},i.getNext=function(){return r},i.setNext=function(t){r=t},i.processTelemetry=function(a,s){s=s||e;var l=t?t.identifier:"TelemetryPluginChain";xu(s?s.core():null,function(){return l+":processTelemetry"},function(){if(t&&n){i._hasRun=!0;try{s.setNext(r),o&&t.setNextPlugin(r),r&&(r._hasRun=!1),t.processTelemetry(a,s)}catch(i){var e=r&&r._hasRun;r&&e||s.diagLog().throwInternal(ks.CRITICAL,il.PluginException,"Plugin ["+t.identifier+"] failed during processTelemetry - "+i),r&&!e&&r.processTelemetry(a,s)}}else r&&(i._hasRun=!0,r.processTelemetry(a,s))},function(){return{item:a}},!a.sync)}};function wu(t,e){var i=[];if(t&&0<t.length)for(var r=null,n=0;n<t.length;n++){var o=t[n];o&&fl(o.processTelemetry)&&(o=new bu(o,e),i.push(o),r&&r.setNext(o),r=o)}return 0<i.length?i[0]:null}var Su=function t(e,i,r,n){var o,a,s,l,u,c=this,p=null;null!==n&&(e&&fl(e.getPlugin)?p=function(t,e,i){var r=[],n=!i;if(t)for(;t;){var o=t.getPlugin();!n&&o!==i||(n=!0,r.push(o)),t=t.getNext()}return n||r.push(i),wu(r,e)}(e,c,n||e.getPlugin()):n?(a=c,l=o=e,u=!1,(s=n)&&o&&(l=[],Tl(o,function(t){!u&&t!==s||(u=!0,l.push(t))})),s&&!u&&(l=l||[]).push(s),p=wu(l,a)):ul(n)&&(p=wu(e,c))),c.core=function(){return r},c.diagLog=function(){return fu(r,i)},c.getCfg=function(){return i},c.getExtCfg=function(t,e){var r,n;return void 0===e&&(e={}),!i||(n=i.extensionConfig)&&t&&(r=n[t]),r||e},c.getConfig=function(t,e,r){var n;return void 0===r&&(r=!1),(t=c.getExtCfg(t,null))&&!cl(t[e])?n=t[e]:i&&!cl(i[e])&&(n=i[e]),cl(n)?r:n},c.hasNext=function(){return null!=p},c.getNext=function(){return p},c.setNext=function(t){p=t},c.processNext=function(t){var e=p;e&&(p=e.getNext(),e.processTelemetry(t,c))},c.createNew=function(e,n){return new t((e=void 0===e?null:e)||p,i,r,n)}},Tu="extensionConfig",Cu="getPlugin";Eu.prototype.initialize=function(t,e,i,r){this._baseTelInit(t,e,i,r)},ft=Eu;function Eu(){var t=this,e=!1,i=null,r=null;t.core=null,t.diagLog=function(e){return t._getTelCtx(e).diagLog()},t.isInitialized=function(){return e},t.setInitialized=function(t){e=t},t.setNextPlugin=function(t){r=t},t.processNext=function(t,e){e?e.processNext(t):r&&fl(r.processTelemetry)&&r.processTelemetry(t,null)},t._getTelCtx=function(e){var n=e=void 0===e?null:e;return n||(e=i||new Su(null,{},t.core),n=r&&r[Cu]?e.createNew(null,r[Cu]):e.createNew(null,r)),n},t._baseTelInit=function(n,o,a,s){n&&Rl(n,Tu,[],null,cl),!s&&o&&(s=o.getProcessTelContext().getNext());var l=r;r&&r[Cu]&&(l=r[Cu]()),t.core=o,i=new Su(s,n,o,l),e=!0}}var Iu="processTelemetry",ku="priority",Au="setNextPlugin",Pu="isInitialized";function Mu(t,e){for(var i=[],r=null,n=t.getNext();n;){var o=n.getPlugin();o&&(r&&fl(r[Au])&&fl(o[Iu])&&r[Au](o),fl(o[Pu])&&o[Pu]()||i.push(o),r=o,n=n.getNext())}Tl(i,function(i){i.initialize(t.getCfg(),t.core(),e,t.getNext())})}function Lu(t){return t.sort(function(t,e){var i=0,r=fl(e[Iu]);return fl(t[Iu])?i=r?t[ku]-e[ku]:1:r&&(i=-1),i})}var Ou,Ru=(Is(zu,Ou=ft),zu._staticInit=(Ml(st=zu.prototype,"ChannelControls",st.getChannelControls),void Ml(st,"channelQueue",st.getChannelControls)),zu);function zu(){var t,e=Ou.call(this)||this;function i(e){e&&0<e.length&&(Tl(e=e.sort(function(t,e){return t.priority-e.priority}),function(t){t.priority<500&&Bl("Channel has invalid priority"+t.identifier)}),t.push(e))}return e.identifier="ChannelControllerPlugin",e.priority=500,el(zu,e,function(r,n){r.setNextPlugin=function(t){},r.processTelemetry=function(i,r){t&&Tl(t,function(t){0<t.length&&e._getTelCtx(r).createNew(t).processNext(i)})},r.getChannelControls=function(){return t},r.initialize=function(e,o,a){r.isInitialized()||(n.initialize(e,o,a),function(e,r){var n;t=[],e&&Tl(e,i),r&&(n=[],Tl(r,function(t){500<t.priority&&n.push(t)}),i(n))}((e||{}).channels,a),Tl(t,function(t){return Mu(new Su(t,e,o),a)}))}}),e}var Du="toGMTString",Nu="toUTCString",Bu="cookie",Fu="expires",Uu="enabled",ju="isCookieUseDisabled",Vu="disableCookiesUsage",qu="_ckMgr",Hu="",Gu=null,Zu=null,Wu=null,Ku=iu(),Xu={},Yu={};function Ju(t){return!t||t.isEnabled()}function Qu(t,e){var i,r;return t?i=t.getCookieMgr():e&&(i=e.cookieCfg[qu]||$u(e)),i||(r=e,e=(t||{}).logger,(t=$u[qu]||Yu[qu])||(t=$u[qu]=$u(r,e),Yu[qu]=t),i=t),i}function $u(t,e){var i,r,n=(Rl(r=(i=t||Yu).cookieCfg=i.cookieCfg||{},"domain",i.cookieDomain,pl,cl),Rl(r,"path",i.cookiePath||"/",null,cl),cl(r[Uu])&&(t=void 0,ul(i[ju])||(t=!i[ju]),ul(i[Vu])||(t=!i[Vu]),r[Uu]=t),r),o=n.path||"/",a=n.domain,s=!1!==n[Uu],l={isEnabled:function(){var t=s&&tc(e),i=Yu[qu];return t&&i&&l!==i?Ju(i):t},setEnabled:function(t){s=!1!==t},set:function(t,e,i,r,s){var u,c,p;Ju(l)&&(u={},-1!==(p=(c=Il(e||Hu)).indexOf(";"))&&(c=Il(e.substring(0,p)),u=ec(e.substring(p+1))),Rl(u,"domain",r||a,Nl,ul),cl(i)||(e=lu(),!ul(u[Fu])||0<(p=Ll()+1e3*i)&&((r=new Date).setTime(p),Rl(u,Fu,ic(r,e?Du:Nu)||ic(r,e?Du:Nu)||Hu,Nl)),e||Rl(u,"max-age",Hu+i,null,ul)),(i=nu())&&"https:"===i.protocol&&(Rl(u,"secure",null,null,ul),(Zu=null===Zu?!function(t){return!!bl(t)&&(!(!vl(t,"CPU iPhone OS 12")&&!vl(t,"iPad; CPU OS 12"))||(!!(vl(t,"Macintosh; Intel Mac OS X 10_14")&&vl(t,"Version/")&&vl(t,"Safari"))||(!(!vl(t,"Macintosh; Intel Mac OS X 10_14")||!function(t,e){if(t){var i=e.length,r=t.length;if(t===e)return 1;if(i<=r){for(var n=r-1,o=i-1;0<=o;o--){if(t[n]!=e[o])return;n--}return 1}}}(t,"AppleWebKit/605.1.15 (KHTML, like Gecko)"))||(!(!vl(t,"Chrome/5")&&!vl(t,"Chrome/6"))||(!(!vl(t,"UnrealEngine")||vl(t,"Chrome"))||!(!vl(t,"UCBrowser/12")&&!vl(t,"UCBrowser/11")))))))}((ru()||{}).userAgent):Zu)&&Rl(u,"SameSite","None",null,ul)),Rl(u,"path",s||o,null,ul),(n.setCookie||nc)(t,rc(c,u)))},get:function(t){var e=Hu;return Ju(l)?(n.getCookie||function(t){var e,i=Hu;return Ku&&(e=Ku[Bu]||Hu,Wu!==e&&(Xu=ec(e),Wu=e),i=Il(Xu[t]||Hu)),i})(t):e},del:function(t,e){Ju(l)&&l.purge(t,e)},purge:function(t,i){var r;tc(e)&&((r={}).path=i||"/",r[Fu]="Thu, 01 Jan 1970 00:00:01 GMT",r=r,lu()||(r["max-age"]="0"),(n.delCookie||nc)(t,rc(Hu,r)))}};return l[qu]=l}function tc(t){if(null===Gu){Gu=!1;try{Gu=void 0!==(Ku||{})[Bu]}catch(e){t&&t.throwInternal(ks.WARNING,il.CannotAccessCookie,"Cannot access document.cookie - "+Ol(e),{exception:cu(e)})}}return Gu}function ec(t){var e={};return t&&t.length&&Tl(Il(t).split(";"),function(t){var i;(t=Il(t||Hu))&&(-1===(i=t.indexOf("="))?e[t]=null:e[Il(t.substring(0,i))]=Il(t.substring(i+1)))}),e}function ic(t,e){return fl(t[e])?t[e]():null}function rc(t,e){var i=t||Hu;return gl(e,function(t,e){i+="; "+t+(cl(e)?Hu:"="+e)}),i}function nc(t,e){Ku&&(Ku[Bu]=t+"="+e)}var oc,ac="_notificationManager",sc=function t(e){this.listeners=[];var i=!!(e||{}).perfEvtsSendAll;el(t,this,function(t){t.addNotificationListener=function(e){t.listeners.push(e)},t.removeNotificationListener=function(e){for(var i=Cl(t.listeners,e);-1<i;)t.listeners.splice(i,1),i=Cl(t.listeners,e)},t.eventsSent=function(e){Tl(t.listeners,function(t){t&&t.eventsSent&&setTimeout(function(){return t.eventsSent(e)},0)})},t.eventsDiscarded=function(e,i){Tl(t.listeners,function(t){t&&t.eventsDiscarded&&setTimeout(function(){return t.eventsDiscarded(e,i)},0)})},t.eventsSendRequest=function(e,i){Tl(t.listeners,function(t){if(t&&t.eventsSendRequest)if(i)setTimeout(function(){return t.eventsSendRequest(e,i)},0);else try{t.eventsSendRequest(e,i)}catch(t){}})},t.perfEvent=function(e){e&&(!i&&e.isChildEvt()||Tl(t.listeners,function(t){if(t&&t.perfEvent)if(e.isAsync)setTimeout(function(){return t.perfEvent(e)},0);else try{t.perfEvent(e)}catch(t){}}))}})},lc=(Is(uc,oc=function t(){var e,i,r,n,o,a=!1;el(t,this,function(t){t._extensions=new Array,i=new Ru,t.logger=Ts({throwInternal:function(t,e,i,r,n){},warnToConsole:function(t){},resetInternalMessageCount:function(){}}),e=[],t.isInitialized=function(){return a},t.initialize=function(e,n,o,s){t.isInitialized()&&Bl("Core should not be initialized more than once"),e&&!cl(e.instrumentationKey)||Bl("Please provide instrumentation key"),r=s,t[ac]=s,t.config=e||{},e.extensions=cl(e.extensions)?[]:e.extensions,zl(e,Tu).NotificationManager=s,o&&(t.logger=o),(s=[]).push.apply(s,n.concat(e.extensions));s=Lu(s);var l=[],u={};Tl(s,function(t){(cl(t)||cl(t.initialize))&&Bl("Extensions must provide callback to initialize");var e=t.priority,r=t.identifier;t&&e&&(cl(u[e])?u[e]=r:o.warnToConsole("Two extensions have same priority #"+e+" - "+u[e]+", "+r)),(!e||e<i.priority)&&l.push(t)}),s.push(i),l.push(i),s=Lu(s),t._extensions=s,Mu(new Su([i],e,t),s),Mu(new Su(l,e,t),s),t._extensions=l,0===t.getTransmissionControls().length&&Bl("No channels available"),a=!0,t.releaseQueue()},t.getTransmissionControls=function(){return i.getChannelControls()},t.track=function(i){Rl(i,"iKey",t.config.instrumentationKey,null,Dl),Rl(i,"time",Sl(new Date),null,Dl),Rl(i,"ver","4.0",null,cl),t.isInitialized()?t.getProcessTelContext().processNext(i):e.push(i)},t.getProcessTelContext=function(){var e=t._extensions,r=e;return e&&0!==e.length||(r=[i]),new Su(r,t.config,t)},t.getNotifyMgr=function(){return r||(r=Ts({addNotificationListener:function(t){},removeNotificationListener:function(t){},eventsSent:function(t){},eventsDiscarded:function(t,e){},eventsSendRequest:function(t,e){}}),t[ac]=r),r},t.getCookieMgr=function(){return o=o||$u(t.config,t.logger)},t.setCookieMgr=function(t){o=t},t.getPerfMgr=function(){return n||t.config&&t.config.enablePerfMgr&&(n=new vu(t.getNotifyMgr())),n},t.setPerfMgr=function(t){n=t},t.eventCnt=function(){return e.length},t.releaseQueue=function(){0<e.length&&(Tl(e,function(e){t.getProcessTelContext().processNext(e)}),e=[])}})}),uc);function uc(){var t=oc.call(this)||this;return el(uc,t,function(t,e){function i(e){var i=t.getNotifyMgr();i&&i.eventsDiscarded([e],ps)}t.initialize=function(t,i,r,n){e.initialize(t,i,r||new mu(t),n||new sc(t))},t.track=function(r){xu(t.getPerfMgr(),function(){return"AppInsightsCore:track"},function(){null===r&&(i(r),Bl("Invalid telemetry item")),function(t){if(cl(t.name))throw i(t),Error("telemetry name required")}(r),e.track(r)},function(){return{item:r}},!r.sync)},t.addNotificationListener=function(e){var i=t.getNotifyMgr();i&&i.addNotificationListener(e)},t.removeNotificationListener=function(e){var i=t.getNotifyMgr();i&&i.removeNotificationListener(e)},t.pollInternalLogs=function(e){var i=t.config.diagnosticLogInterval;return i&&0<i||(i=1e4),setInterval(function(){var i=t.logger?t.logger.queue:[];Tl(i,function(i){i={name:e||"InternalMessageId: "+i.messageId,iKey:t.config.instrumentationKey,time:Sl(new Date),baseType:hu.dataType,baseData:{message:i.message}},t.track(i)}),i.length=0},i)}}),t}var cc=4294967296,pc=4294967295,hc=!1,dc=123456789,fc=987654321;function mc(t){var e=(e=Ql("crypto")||Ql("msCrypto"))&&e.getRandomValues?e.getRandomValues(new Uint32Array(1))[0]&pc:lu()?(hc||function(){try{var t=2147483647&Ll();(e=(Math.random()*cc^t)+t)<0&&(e>>>=0),dc=123456789+e&pc,fc=987654321-e&pc,hc=!0}catch(t){}var e}(),function(t){var e=((fc=36969*(65535&fc)+(fc>>16)&pc)<<16)+(65535&(dc=18e3*(65535&dc)+(dc>>16)&pc))>>>0&pc|0;return e>>>=0}()&pc):Math.floor(cc*Math.random()|0);return t||(e>>>=0),e}function yc(t,e){var i=!1,r=tu();return r&&(i=ml(r,t,e),i=ml(r.body,t,e)||i),(r=iu())&&_c.Attach(r,t,e)||i}function gc(t){void 0===t&&(t=22);for(var e=mc()>>>0,i=0,r="";r.length<t;)i++,r+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(63&e),e>>>=6,5===i&&(e=(mc()<<2&4294967295|3&e)>>>0,i=0);return r}function vc(){for(var t,e=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"],i="",r=0;r<4;r++)i+=e[15&(t=mc())]+e[t>>4&15]+e[t>>8&15]+e[t>>12&15]+e[t>>16&15]+e[t>>20&15]+e[t>>24&15]+e[t>>28&15];var n=e[8+(3&mc())|0];return i.substr(0,8)+i.substr(9,4)+"4"+i.substr(13,3)+n+i.substr(16,3)+i.substr(19,12)}var _c={Attach:ml,AttachEvent:ml,Detach:yl,DetachEvent:yl},xc="_aiHooks",bc=["req","rsp","hkErr","fnErr"];function wc(t,e){if(t)for(var i=0;i<t.length&&!e(t[i],i);i++);}function Sc(t,e,i,r,n){0<=n&&n<=2&&wc(t,function(t,o){var a=t.cbks;if(t=a[bc[n]]){e.ctx=function(){return r[o]=r[o]||{}};try{t.apply(e.inst,i)}catch(o){t=e.err;try{var s=a[bc[2]];s&&(e.err=o,s.apply(e.inst,i))}catch(o){}finally{e.err=t}}}})}var Tc=Object.getPrototypeOf;function Cc(t,e,i,r){if(void 0===r&&(r=!0),t&&e&&i&&(t=function t(e,i,r){var n=null;return e&&(hl(e,i)?n=e:r&&(n=t(function(t){if(t){if(Tc)return Tc(t);if(t=t.__proto__||t[ms]||t.constructor)return t}return null}(e),i,!1))),n}(t,e,r))&&typeof(r=t[e])===hs){var n=r[xc];return n||((o=n={i:0,n:e,f:r,h:[]},r=function(){var t=arguments,e=o.h,i={name:o.n,inst:this,ctx:null,set:function(e,r){(t=a([],t))[e]=r,n=a([i],t)}},r=[],n=a([i],t);function a(t,e){return wc(e,function(e){t.push(e)}),t}Sc(e,i,n,r,0);var s=o.f;try{i.rslt=s.apply(this,t)}catch(s){throw i.err=s,Sc(e,i,n,r,3),s}return Sc(e,i,n,r,1),i.rslt})[xc]=n,t[e]=r),i={id:n.i,cbks:i,rm:function(){var t=this.id;wc(n.h,function(e,i){return e.id===t&&(n.h.splice(i,1),1)})}},n.i++,n.h.push(i),i}var o;return null}var Ec="Request-Context",Ic="appId=cid-v1:",kc="Request-Id",Ac="traceparent",Pc="Sdk-Context",Mc="appId",Lc="request-context";function Oc(t,e,i){var r=e.length,n=function(t,e){var i;return e&&150<(e=Il(e.toString())).length&&(i=e.substring(0,150),t.throwInternal(ks.WARNING,il.NameTooLong,"name is too long.  It has been truncated to 150 characters.",{name:e},!0)),i||e}(t,e);if(n.length!==r){for(var o=0,a=n;void 0!==i[a];)o++,a=n.substring(0,147)+function(t){return(t="00"+t).substr(t.length-3)}(o);n=a}return n}function Rc(t,e,i){var r;return void 0===i&&(i=1024),e&&(i=i||1024,(e=Il(e)).toString().length>i&&(r=e.toString().substring(0,i),t.throwInternal(ks.WARNING,il.StringValueTooLong,"string value is too long. It has been truncated to "+i+" characters.",{value:e},!0))),r||e}function zc(t,e){return Fc(t,e,2048,il.UrlTooLong)}function Dc(t,e){var i;return e&&32768<e.length&&(i=e.substring(0,32768),t.throwInternal(ks.WARNING,il.MessageTruncated,"message is too long, it has been truncated to 32768 characters.",{message:e},!0)),i||e}function Nc(t,e){var i;return e&&(i={},gl(e,function(e,r){if(dl(r)&&au())try{r=su().stringify(r)}catch(e){t.throwInternal(ks.WARNING,il.CannotSerializeObjectNonSerializable,"custom property is not valid",{exception:e},!0)}r=Rc(t,r,8192),e=Oc(t,e,i),i[e]=r}),e=i),e}function Bc(t,e){var i;return e&&(i={},gl(e,function(e,r){e=Oc(t,e,i),i[e]=r}),e=i),e}function Fc(t,e,i,r){var n;return e&&(e=Il(e)).length>i&&(n=e.substring(0,i),t.throwInternal(ks.WARNING,r,"input is too long, it has been truncated to "+i+" characters.",{data:e},!0)),n||e}function Uc(t){var e,i=null;return fl(Event)?i=new Event(t):(e=iu())&&e.createEvent&&(i=e.createEvent("Event")).initEvent(t,!0,!0),i}function jc(t,e){return void 0===e&&(e=!1),null==t?e:"true"===t.toString().toLowerCase()}function Vc(t){(isNaN(t)||t<0)&&(t=0);var e=""+(t=Math.round(t))%1e3,i=""+Math.floor(t/1e3)%60,r=""+Math.floor(t/6e4)%60,n=""+Math.floor(t/36e5)%24;t=Math.floor(t/864e5),e=1===e.length?"00"+e:2===e.length?"0"+e:e,i=i.length<2?"0"+i:i,r=r.length<2?"0"+r:r;return(0<t?t+".":"")+(n=n.length<2?"0"+n:n)+":"+r+":"+i+"."+e}function qc(){var t=ru();return"sendBeacon"in t&&t.sendBeacon}var Hc,Gc,Zc="Microsoft_ApplicationInsights_BypassAjaxInstrumentation",Wc="sampleRate",Kc="ProcessLegacy",Xc="http.method",Yc="https://dc.services.visualstudio.com",Jc="not_specified";(St=Hc=Hc||{})[St.LocalStorage=0]="LocalStorage",St[St.SessionStorage=1]="SessionStorage",(vt=Gc=Gc||{})[vt.AI=0]="AI",vt[vt.AI_AND_W3C=1]="AI_AND_W3C",vt[vt.W3C=2]="W3C";var Qc=void 0,$c=void 0;function tp(){return rp()?ep(Hc.LocalStorage):null}function ep(t){try{if(cl(ws()))return null;var e=new Date,i=Ql(t===Hc.LocalStorage?"localStorage":"sessionStorage");i.setItem(e.toString(),e.toString());var r=i.getItem(e.toString())!==e.toString();if(i.removeItem(e.toString()),!r)return i}catch(t){}return null}function ip(){return np()?ep(Hc.SessionStorage):null}function rp(){return Qc=void 0===Qc?!!ep(Hc.LocalStorage):Qc}function np(){return $c=void 0===$c?!!ep(Hc.SessionStorage):$c}function op(t,e){var i=ip();if(null!==i)try{return i.getItem(e)}catch(e){$c=!1,t.throwInternal(ks.WARNING,il.BrowserCannotReadSessionStorage,"Browser failed read of session storage. "+Ol(e),{exception:cu(e)})}return null}function ap(t,e,i){var r=ip();if(null!==r)try{return r.setItem(e,i),1}catch(e){$c=!1,t.throwInternal(ks.WARNING,il.BrowserCannotWriteSessionStorage,"Browser failed write to session storage. "+Ol(e),{exception:cu(e)})}}var sp=iu()||{},lp=0,up=[null,null,null,null,null];function cp(t){var e=lp,i=up,r=i[e];return sp.createElement?i[e]||(r=i[e]=sp.createElement("a")):r={host:function(t,e){return(t=pp(t,e)||"")&&null!=(e=t.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i))&&3<e.length&&bl(e[2])&&0<e[2].length?e[2]+(e[3]||""):t}(t,!0)},r.href=t,++e>=i.length&&(e=0),lp=e,r}function pp(t,e){var i=null;return!t||null!=(t=t.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i))&&2<t.length&&bl(t[2])&&0<t[2].length&&(i=t[2]||"",e&&2<t.length&&(e=(t[1]||"").toLowerCase(),t=t[3]||"",i+=t="http"===e&&":80"===t||"https"===e&&":443"===t?"":t)),i}var hp=["https://dc.services.visualstudio.com/v2/track","https://breeze.aimon.applicationinsights.io/v2/track","https://dc-int.services.visualstudio.com/v2/track"];function dp(t){return-1!==hp.indexOf(t.toLowerCase())}var fp={correlationIdPrefix:"cid-v1:",canIncludeCorrelationHeader:function(t,e,i){if(!e||t&&t.disableCorrelationHeaders)return!1;if(t&&t.correlationHeaderExcludePatterns)for(var r=0;r<t.correlationHeaderExcludePatterns.length;r++)if(t.correlationHeaderExcludePatterns[r].test(e))return!1;var n,o=cp(e).host.toLowerCase();if(!o||-1===o.indexOf(":443")&&-1===o.indexOf(":80")||(o=(pp(e,!0)||"").toLowerCase()),(!t||!t.enableCorsCorrelation)&&o&&o!==i)return!1;if((i=t&&t.correlationHeaderDomains)&&(Tl(i,function(t){t=new RegExp(t.toLowerCase().replace(/\\/g,"\\\\").replace(/\./g,"\\.").replace(/\*/g,".*")),n=n||t.test(o)}),!n))return!1;var a=t&&t.correlationHeaderExcludedDomains;if(!a||0===a.length)return!0;for(r=0;r<a.length;r++)if(new RegExp(a[r].toLowerCase().replace(/\\/g,"\\\\").replace(/\./g,"\\.").replace(/\*/g,".*")).test(o))return!1;return o&&0<o.length},getCorrelationContext:function(t){if(t&&(t=fp.getCorrelationContextValue(t,"appId"))&&t!==fp.correlationIdPrefix)return t},getCorrelationContextValue:function(t,e){if(t)for(var i=t.split(","),r=0;r<i.length;++r){var n=i[r].split("=");if(2===n.length&&n[0]===e)return n[1]}}};function mp(){var t=ou();return t&&t.now&&t.timing&&0<(t=t.now()+t.timing.navigationStart)?t:Ll()}function yp(t,e){var i=null;return 0===t||0===e||cl(t)||cl(e)?i:e-t}var gp=";",vp="=";var _p;Is(xp,_p=function(){}),mt=xp;function xp(){return _p.call(this)||this}var bp,wp=(Is(Sp,bp=function(){this.ver=1,this.sampleRate=100,this.tags={}}),Sp);function Sp(t,e,i){var r=bp.call(this)||this;return r.name=Rc(t,i)||Jc,r.data=e,r.time=Sl(new Date),r.aiDataContract={time:1,iKey:1,name:1,sampleRate:function(){return 100===r.sampleRate?4:1},tags:1,data:1},r}var Tp,Cp=(Is(Ep,Tp=l=function(){this.ver=2,this.properties={},this.measurements={}}),Ep.envelopeType="Microsoft.ApplicationInsights.{0}.Event",Ep.dataType="EventData",Ep);function Ep(t,e,i,r){var n=Tp.call(this)||this;return n.aiDataContract={ver:1,name:1,properties:0,measurements:0},n.name=Rc(t,e)||Jc,n.properties=Nc(t,i),n.measurements=Bc(t,r),n}u=function(){},bt=function(){this.hasFullStack=!0,this.parsedStack=[]};var Ip="error",kp="stack",Ap="stackDetails",Pp="errorSrc",Mp="message",Lp="description";function Op(t,e){var i=t;return i&&!bl(i)&&(JSON&&JSON.stringify?(i=JSON.stringify(t),!e||i&&"{}"!==i||(i=fl(t.toString)?t.toString():""+t)):i=t+" - (Missing JSON.stringify)"),i||""}function Rp(t,e){var i=t;return t&&((i=i&&!bl(i)&&(t[Mp]||t[Lp])||i)&&!bl(i)&&(i=Op(i,!0)),t.filename&&(i=i+" @"+(t.filename||"")+":"+(t.lineno||"?")+":"+(t.colno||"?"))),(i=e&&"String"!==e&&"Object"!==e&&"Error"!==e&&-1===(i||"").indexOf(e)?e+": "+i:i)||""}function zp(t){return t&&t.src&&bl(t.src)&&t.obj&&_l(t.obj)}function Dp(t){var e=t||"";t=(e=bl(e)?e:bl(e[kp])?e[kp]:""+e).split("\n");return{src:e,obj:t}}function Np(t){var e,i=null;if(t)try{t[kp]?i=Dp(t[kp]):t[Ip]&&t[Ip][kp]?i=Dp(t[Ip][kp]):t.exception&&t.exception[kp]?i=Dp(t.exception[kp]):zp(t)?i=t:zp(t[Ap])?i=t[Ap]:window.opera&&t[Mp]?i=function(t){for(var e=[],i=t.split("\n"),r=0;r<i.length;r++){var n=i[r];i[r+1]&&(n+="@"+i[r+1],r++),e.push(n)}return{src:t,obj:e}}(t.message):bl(t)?i=Dp(t):(e=t[Mp]||t[Lp]||"",bl(t[Pp])&&(e&&(e+="\n"),e+=" from "+t[Pp]),e&&(i=Dp(e)))}catch(t){i=Dp(t)}return i||{src:"",obj:null}}function Bp(t){var e="";if(t&&!(e=t.typeName||t.name||""))try{var i=/function (.{1,200})\(/.exec(t.constructor.toString());e=i&&1<i.length?i[1]:""}catch(t){}return e}function Fp(t){if(t)try{if(!bl(t)){var e=Bp(t),i=Op(t,!1);return i&&"{}"!==i||(t[Ip]&&(e=Bp(t=t[Ip])),i=Op(t,!0)),0!==i.indexOf(e)&&"String"!==e?e+":"+i:i}}catch(t){}return""+(t||"")}var Up,jp=(Is(Vp,Up=function(){this.ver=2,this.exceptions=[],this.properties={},this.measurements={}}),Vp.CreateAutoException=function(t,e,i,r,n,o,a,s){var l=Bp(n||o||t);return{message:Rp(t,l),url:e,lineNumber:i,columnNumber:r,error:Fp(n||o||t),evt:Fp(o||t),typeName:l,stackDetails:Np(a||n||o),errorSrc:s}},Vp.CreateFromInterface=function(t,e,i,r){var n=e.exceptions&&El(e.exceptions,function(e){return Hp.CreateFromInterface(t,e)});return new Vp(t,Cs({},e,{exceptions:n}),i,r)},Vp.prototype.toInterface=function(){var t=this.exceptions,e=this.properties,i=this.measurements,r=this.severityLevel,n=(this.ver,this.problemGroup),o=this.id,a=this.isManual;return{ver:"4.0",exceptions:t instanceof Array&&El(t,function(t){return t.toInterface()})||void 0,severityLevel:r,properties:e,measurements:i,problemGroup:n,id:o,isManual:a}},Vp.CreateSimpleException=function(t,e,i,r,n,o){return{exceptions:[{hasFullStack:!0,message:t,stack:n,typeName:e}]}},Vp.envelopeType="Microsoft.ApplicationInsights.{0}.Exception",Vp.dataType="ExceptionData",Vp.formatError=Fp,Vp);function Vp(t,e,i,r,n,o){var a,s=Up.call(this)||this;return s.aiDataContract={ver:1,exceptions:1,severityLevel:0,properties:0,measurements:0},dl(a=e)&&"ver"in a&&"exceptions"in a&&"properties"in a?(s.exceptions=e.exceptions,s.properties=e.properties,s.measurements=e.measurements,e.severityLevel&&(s.severityLevel=e.severityLevel),e.id&&(s.id=e.id),e.problemGroup&&(s.problemGroup=e.problemGroup),s.ver=2,cl(e.isManual)||(s.isManual=e.isManual)):(s.exceptions=[new Hp(t,e,i=i||{})],s.properties=Nc(t,i),s.measurements=Bc(t,r),n&&(s.severityLevel=n),o&&(s.id=o)),s}var qp,Hp=(Is(Gp,qp=bt),Gp.prototype.toInterface=function(){var t=this.parsedStack instanceof Array&&El(this.parsedStack,function(t){return t.toInterface()});return{id:this.id,outerId:this.outerId,typeName:this.typeName,message:this.message,hasFullStack:this.hasFullStack,stack:this[kp],parsedStack:t||void 0}},Gp.CreateFromInterface=function(t,e){var i=e.parsedStack instanceof Array&&El(e.parsedStack,function(t){return Wp.CreateFromInterface(t)})||e.parsedStack;return new Gp(t,Cs({},e,{parsedStack:i}))},Gp);function Gp(t,e,i){var r,n,o,a,s=qp.call(this)||this;return s.aiDataContract={id:0,outerId:0,typeName:1,message:1,hasFullStack:0,stack:0,parsedStack:2},dl(a=e)&&"hasFullStack"in a&&"typeName"in a?(s.typeName=e.typeName,s.message=e.message,s[kp]=e[kp],s.parsedStack=e.parsedStack,s.hasFullStack=e.hasFullStack):(a=(r=e)&&r.evt,xl(r)||(r=r[Ip]||a||r),s.typeName=Rc(t,Bp(r))||Jc,s.message=Dc(t,Rp(e||r,s.typeName))||Jc,r=e[Ap]||Np(e),s.parsedStack=function(t){if((t=t.obj)&&0<t.length){var e=[],i=0,r=0;if(Tl(t,function(t){t=t.toString(),Wp.regex.test(t)&&(t=new Wp(t,i++),r+=t.sizeInBytes,e.push(t))}),32768<r)for(var n=0,o=e.length-1,a=0,s=n,l=o;n<o;){if(32768<(a+=e[n].sizeInBytes+e[o].sizeInBytes)){e.splice(s,l-s+1);break}s=n,l=o,n++,o--}}return e}(r),s[kp]=(e=t,o="",(t=r)&&(t.obj?Tl(t.obj,function(t){o+=t+"\n"}):o=t.src||""),!(r=o)||32768<(t=""+r).length&&(n=t.substring(0,32768),e.throwInternal(ks.WARNING,il.ExceptionTruncated,"exception is too long, it has been truncated to 32768 characters.",{exception:r},!0)),n||r),s.hasFullStack=_l(s.parsedStack)&&0<s.parsedStack.length,i&&(i.typeName=i.typeName||s.typeName)),s}var Zp,Wp=(Is(Kp,Zp=u),Kp.CreateFromInterface=function(t){return new Kp(t,null)},Kp.prototype.toInterface=function(){return{level:this.level,method:this.method,assembly:this.assembly,fileName:this.fileName,line:this.line}},Kp.regex=/^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/,Kp.baseSize=58,Kp);function Kp(t,e){var i,r=Zp.call(this)||this;return r.sizeInBytes=0,r.aiDataContract={level:1,method:1,assembly:0,fileName:0,line:0},"string"==typeof t?(i=t,r.level=e,r.method="<no_method>",r.assembly=Il(i),r.fileName="",r.line=0,(i=i.match(Kp.regex))&&5<=i.length&&(r.method=Il(i[2])||r.method,r.fileName=Il(i[4]),r.line=parseInt(i[5])||0)):(r.level=t.level,r.method=t.method,r.assembly=t.assembly,r.fileName=t.fileName,r.line=t.line,r.sizeInBytes=0),r.sizeInBytes+=r.method.length,r.sizeInBytes+=r.fileName.length,r.sizeInBytes+=r.assembly.length,r.sizeInBytes+=Kp.baseSize,r.sizeInBytes+=r.level.toString().length,r.sizeInBytes+=r.line.toString().length,r}var Xp;Ct=function(){this.ver=2,this.metrics=[],this.properties={},this.measurements={}};(st=Xp=Xp||{})[st.Measurement=0]="Measurement",st[st.Aggregation=1]="Aggregation";var Yp,Jp=(Is(Qp,Yp=function(){this.kind=Xp.Measurement}),Qp);function Qp(){var t=null!==Yp&&Yp.apply(this,arguments)||this;return t.aiDataContract={name:1,kind:0,value:1,count:0,min:0,max:0,stdDev:0},t}var $p,th=(Is(eh,$p=Ct),eh.envelopeType="Microsoft.ApplicationInsights.{0}.Metric",eh.dataType="MetricData",eh);function eh(t,e,i,r,n,o,a,s){var l=$p.call(this)||this;l.aiDataContract={ver:1,metrics:1,properties:0};var u=new Jp;return u.count=0<r?r:void 0,u.max=isNaN(o)||null===o?void 0:o,u.min=isNaN(n)||null===n?void 0:n,u.name=Rc(t,e)||Jc,u.value=i,l.metrics=[u],l.properties=Nc(t,a),l.measurements=Bc(t,s),l}var ih;Is(rh,ih=l),St=rh;function rh(){var t=ih.call(this)||this;return t.ver=2,t.properties={},t.measurements={},t}var nh,oh=(Is(ah,nh=St),ah.envelopeType="Microsoft.ApplicationInsights.{0}.Pageview",ah.dataType="PageviewData",ah);function ah(t,e,i,r,n,o,a){var s=nh.call(this)||this;return s.aiDataContract={ver:1,name:0,url:0,duration:0,properties:0,measurements:0,id:0},s.id=(a=a)&&Fc(t,a,128,il.IdTooLong).toString(),s.url=zc(t,i),s.name=Rc(t,e)||Jc,isNaN(r)||(s.duration=Vc(r)),s.properties=Nc(t,n),s.measurements=Bc(t,o),s}var sh,lh=(Is(uh,sh=function(){this.ver=2,this.success=!0,this.properties={},this.measurements={}}),uh.envelopeType="Microsoft.ApplicationInsights.{0}.RemoteDependency",uh.dataType="RemoteDependencyData",uh);function uh(t,e,i,r,n,o,a,s,l,u,c,p){void 0===l&&(l="Ajax");var h=sh.call(this)||this;h.aiDataContract={id:1,ver:1,name:0,resultCode:0,duration:0,success:0,data:0,target:0,type:0,properties:0,measurements:0,kind:0,value:0,count:0,min:0,max:0,stdDev:0,dependencyKind:0,dependencySource:0,commandName:0,dependencyTypeName:0},h.id=e,h.duration=Vc(n),h.success=o,h.resultCode=a+"",h.type=Rc(t,l);var d,f;d=t,e=s,a=o=n=r,o=(l=i)&&0<l.length?(f=(s=cp(l)).host,o||(null!=s.pathname?("/"!==(i=0===s.pathname.length?"/":s.pathname).charAt(0)&&(i="/"+i),a=s.pathname,Rc(d,e?e+" "+i:i)):Rc(d,l))):f=n,a={target:f,name:o,data:a};return h.data=zc(t,r)||a.data,h.target=Rc(t,a.target),u&&(h.target=h.target+" | "+u),h.name=Rc(t,a.name),h.properties=Nc(t,c),h.measurements=Bc(t,p),h}var ch,ph=(Is(hh,ch=function(){this.ver=2,this.properties={},this.measurements={}}),hh.envelopeType="Microsoft.ApplicationInsights.{0}.Message",hh.dataType="MessageData",hh);function hh(t,e,i,r,n){var o=ch.call(this)||this;return o.aiDataContract={ver:1,message:1,severityLevel:0,properties:0},o.message=Dc(t,e=e||Jc),o.properties=Nc(t,r),o.measurements=Bc(t,n),i&&(o.severityLevel=i),o}var dh;Is(fh,dh=St),vt=fh;function fh(){var t=dh.call(this)||this;return t.ver=2,t.properties={},t.measurements={},t}var mh,yh=(Is(gh,mh=vt),gh.envelopeType="Microsoft.ApplicationInsights.{0}.PageviewPerformance",gh.dataType="PageviewPerformanceData",gh);function gh(t,e,i,r,n,o,a){var s=mh.call(this)||this;return s.aiDataContract={ver:1,name:0,url:0,duration:0,perfTotal:0,networkConnect:0,sentRequest:0,receivedResponse:0,domProcessing:0,properties:0,measurements:0},s.url=zc(t,i),s.name=Rc(t,e)||Jc,s.properties=Nc(t,n),s.measurements=Bc(t,o),a&&(s.domProcessing=a.domProcessing,s.duration=a.duration,s.networkConnect=a.networkConnect,s.perfTotal=a.perfTotal,s.receivedResponse=a.receivedResponse,s.sentRequest=a.sentRequest),s}var vh,_h,xh=(Is(bh,vh=mt),bh);function bh(t,e){var i=vh.call(this)||this;return i.aiDataContract={baseType:1,baseData:1},i.baseType=t,i.baseData=e,i}function wh(t){var e="ai."+t+".";return function(t){return e+t}}(bt=_h=_h||{})[bt.Verbose=0]="Verbose",bt[bt.Information=1]="Information",bt[bt.Warning=2]="Warning",bt[bt.Error=3]="Error",bt[bt.Critical=4]="Critical";u=wh("application"),st=wh("device"),Ct=wh("location"),l=wh("operation"),St=wh("session"),vt=wh("user"),mt=wh("cloud"),bt=wh("internal");var Sh,Th,Ch=(Th={applicationVersion:u("ver"),applicationBuild:u("build"),applicationTypeId:u("typeId"),applicationId:u("applicationId"),applicationLayer:u("layer"),deviceId:st("id"),deviceIp:st("ip"),deviceLanguage:st("language"),deviceLocale:st("locale"),deviceModel:st("model"),deviceFriendlyName:st("friendlyName"),deviceNetwork:st("network"),deviceNetworkName:st("networkName"),deviceOEMName:st("oemName"),deviceOS:st("os"),deviceOSVersion:st("osVersion"),deviceRoleInstance:st("roleInstance"),deviceRoleName:st("roleName"),deviceScreenResolution:st("screenResolution"),deviceType:st("type"),deviceMachineName:st("machineName"),deviceVMName:st("vmName"),deviceBrowser:st("browser"),deviceBrowserVersion:st("browserVersion"),locationIp:Ct("ip"),locationCountry:Ct("country"),locationProvince:Ct("province"),locationCity:Ct("city"),operationId:l("id"),operationName:l("name"),operationParentId:l("parentId"),operationRootId:l("rootId"),operationSyntheticSource:l("syntheticSource"),operationCorrelationVector:l("correlationVector"),sessionId:St("id"),sessionIsFirst:St("isFirst"),sessionIsNew:St("isNew"),userAccountAcquisitionDate:vt("accountAcquisitionDate"),userAccountId:vt("accountId"),userAgent:vt("userAgent"),userId:vt("id"),userStoreRegion:vt("storeRegion"),userAuthUserId:vt("authUserId"),userAnonymousUserAcquisitionDate:vt("anonUserAcquisitionDate"),userAuthenticatedUserAcquisitionDate:vt("authUserAcquisitionDate"),cloudName:mt("name"),cloudRole:mt("role"),cloudRoleVer:mt("roleVer"),cloudRoleInstance:mt("roleInstance"),cloudEnvironment:mt("environment"),cloudLocation:mt("location"),cloudDeploymentUnit:mt("deploymentUnit"),internalNodeName:bt("nodeName"),internalSdkVersion:bt("sdkVersion"),internalAgentVersion:bt("agentVersion"),internalSnippet:bt("snippet"),internalSdkSrc:bt("sdkSrc")},Is(Eh,Sh=function(){var t=this;Th&&gl(Th,function(e,i){t[e]=i})}),Eh);function Eh(){return Sh.call(this)||this}var Ih=(kh.create=function(t,e,i,r,n,o){if(i=Rc(r,i)||Jc,cl(t)||cl(e)||cl(i))throw Error("Input doesn't contain all required fields");var a={name:i,time:Sl(new Date),iKey:"",ext:o||{},tags:[],data:{},baseType:e,baseData:t};return cl(n)||gl(n,function(t,e){a.data[t]=e}),a},kh);function kh(){}var Ah=new Ch,Ph="AppInsightsPropertiesPlugin",Mh="AppInsightsChannelPlugin",Lh=function t(e,i,r,n){el(t,this,function(t){var o,a=null,s=[],l=!1;function u(){r&&Tl(r.getTransmissionControls(),function(t){Tl(t,function(t){return t.flush(!0)})})}r&&(o=r.logger),t.trackPageView=function(t,r){var c=t.name;!cl(c)&&"string"==typeof c||(p=iu(),c=t.name=p&&p.title||"");var p,h=t.uri;if(!cl(h)&&"string"==typeof h||(p=nu(),h=t.uri=p&&p.href||""),!n.isPerformanceTimingSupported())return e.sendPageViewInternal(t,r),u(),void o.throwInternal(ks.WARNING,il.NavigationTimingNotSupported,"trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");var d,f,m=!1,y=n.getPerformanceTiming().navigationStart;0<y&&(d=yp(y,+new Date),n.shouldCollectDuration(d)||(d=void 0)),cl(r)||cl(r.duration)||(f=r.duration),!i&&isNaN(f)||(isNaN(f)&&((r=r||{}).duration=d),e.sendPageViewInternal(t,r),u(),m=!0),r=r||{},f=function(){var i,a=!1;try{n.isPerformanceTimingDataReady()?(a=!0,i={name:c,uri:h},n.populatePageViewPerformanceEvent(i),i.isValid||m?(m||(r.duration=i.durationMs,e.sendPageViewInternal(t,r)),l||(e.sendPageViewPerformanceInternal(i,r),l=!0)):(r.duration=d,e.sendPageViewInternal(t,r))):0<y&&6e4<yp(y,+new Date)&&(a=!0,m||(r.duration=6e4,e.sendPageViewInternal(t,r)))}catch(i){o.throwInternal(ks.CRITICAL,il.TrackPVFailedCalc,"trackPageView failed on page load calculation: "+Ol(i),{exception:cu(i)})}return a},s.push(f),a=a||setInterval(function(){var t=s.slice(0),e=!1;s=[],Tl(t,function(t){t()?e=!0:s.push(t)}),0===s.length&&(clearInterval(a),a=null),e&&u()},100)}})},Oh=(Rh.prototype.trackPreviousPageVisit=function(t,e){try{var i=this.restartPageVisitTimer(t,e);i&&this.pageVisitTimeTrackingHandler(i.pageName,i.pageUrl,i.pageVisitTime)}catch(t){this._logger.warnToConsole("Auto track page visit time failed, metric will not be collected: "+cu(t))}},Rh.prototype.restartPageVisitTimer=function(t,e){try{var i=this.stopPageVisitTimer();return this.startPageVisitTimer(t,e),i}catch(t){return this._logger.warnToConsole("Call to restart failed: "+cu(t)),null}},Rh.prototype.startPageVisitTimer=function(t,e){try{var i,r;np()&&(null!=op(this._logger,this.prevPageVisitDataKeyName)&&Bl("Cannot call startPageVisit consecutively without first calling stopPageVisit"),i=new zh(t,e),r=su().stringify(i),ap(this._logger,this.prevPageVisitDataKeyName,r))}catch(t){this._logger.warnToConsole("Call to start failed: "+cu(t))}},Rh.prototype.stopPageVisitTimer=function(){try{if(np()){var t=Ll(),e=op(this._logger,this.prevPageVisitDataKeyName);if(e&&au()){var i=su().parse(e);return i.pageVisitTime=t-i.pageVisitStartTime,function(t,e){var i=ip();if(null!==i)try{i.removeItem(e)}catch(e){$c=!1,t.throwInternal(ks.WARNING,il.BrowserFailedRemovalFromSessionStorage,"Browser failed removal of session storage item. "+Ol(e),{exception:cu(e)})}}(this._logger,this.prevPageVisitDataKeyName),i}return null}return null}catch(t){return this._logger.warnToConsole("Stop page visit timer failed: "+cu(t)),null}},Rh);function Rh(t,e){this.prevPageVisitDataKeyName="prevPageVisitData",this.pageVisitTimeTrackingHandler=e,this._logger=t}var zh=function(t,e){this.pageVisitStartTime=Ll(),this.pageName=t,this.pageUrl=e},Dh=(Nh.prototype.populatePageViewPerformanceEvent=function(t){t.isValid=!1;var e=this.getPerformanceNavigationTiming(),i=this.getPerformanceTiming(),r=0,n=0,o=0,a=0,s=0;(e||i)&&(s=e?(r=e.duration,n=0===e.startTime?e.connectEnd:yp(e.startTime,e.connectEnd),o=yp(e.requestStart,e.responseStart),a=yp(e.responseStart,e.responseEnd),yp(e.responseEnd,e.loadEventEnd)):(r=yp(i.navigationStart,i.loadEventEnd),n=yp(i.navigationStart,i.connectEnd),o=yp(i.requestStart,i.responseStart),a=yp(i.responseStart,i.responseEnd),yp(i.responseEnd,i.loadEventEnd)),0===r?this._logger.throwInternal(ks.WARNING,il.ErrorPVCalc,"error calculating page view performance.",{total:r,network:n,request:o,response:a,dom:s}):this.shouldCollectDuration(r,n,o,a,s)?r<Math.floor(n)+Math.floor(o)+Math.floor(a)+Math.floor(s)?this._logger.throwInternal(ks.WARNING,il.ClientPerformanceMathError,"client performance math error.",{total:r,network:n,request:o,response:a,dom:s}):(t.durationMs=r,t.perfTotal=t.duration=Vc(r),t.networkConnect=Vc(n),t.sentRequest=Vc(o),t.receivedResponse=Vc(a),t.domProcessing=Vc(s),t.isValid=!0):this._logger.throwInternal(ks.WARNING,il.InvalidDurationValue,"Invalid page load duration value. Browser perf data won't be sent.",{total:r,network:n,request:o,response:a,dom:s}))},Nh.prototype.getPerformanceTiming=function(){return this.isPerformanceTimingSupported()?ou().timing:null},Nh.prototype.getPerformanceNavigationTiming=function(){return this.isPerformanceNavigationTimingSupported()?ou().getEntriesByType("navigation")[0]:null},Nh.prototype.isPerformanceNavigationTimingSupported=function(){var t=ou();return t&&t.getEntriesByType&&0<t.getEntriesByType("navigation").length},Nh.prototype.isPerformanceTimingSupported=function(){var t=ou();return t&&t.timing},Nh.prototype.isPerformanceTimingDataReady=function(){var t;return(t=(t=ou())?t.timing:0)&&0<t.domainLookupStart&&0<t.navigationStart&&0<t.responseStart&&0<t.requestStart&&0<t.loadEventEnd&&0<t.responseEnd&&0<t.connectEnd&&0<t.domLoading},Nh.prototype.shouldCollectDuration=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var i=["googlebot","adsbot-google","apis-google","mediapartners-google"],r=(ru()||{}).userAgent,n=!1;if(r)for(var o=0;o<i.length;o++)n=n||-1!==r.toLowerCase().indexOf(i[o]);if(n)return!1;for(o=0;o<t.length;o++)if(t[o]<0||t[o]>=this.MAX_DURATION_ALLOWED)return!1;return!0},Nh);function Nh(t){this.MAX_DURATION_ALLOWED=36e5,t&&(this._logger=t.logger)}var Bh="duration",Fh="event";function Uh(t,e){t&&t.dispatchEvent&&e&&t.dispatchEvent(e)}var jh,Vh=(Is(qh,jh=ft),qh.getDefaultConfig=function(t){return(t=t||{}).sessionRenewalMs=18e5,t.sessionExpirationMs=864e5,t.disableExceptionTracking=jc(t.disableExceptionTracking),t.autoTrackPageVisitTime=jc(t.autoTrackPageVisitTime),t.overridePageViewDuration=jc(t.overridePageViewDuration),t.enableUnhandledPromiseRejectionTracking=jc(t.enableUnhandledPromiseRejectionTracking),(isNaN(t.samplingPercentage)||t.samplingPercentage<=0||100<=t.samplingPercentage)&&(t.samplingPercentage=100),t.isStorageUseDisabled=jc(t.isStorageUseDisabled),t.isBrowserLinkTrackingEnabled=jc(t.isBrowserLinkTrackingEnabled),t.enableAutoRouteTracking=jc(t.enableAutoRouteTracking),t.namePrefix=t.namePrefix||"",t.enableDebug=jc(t.enableDebug),t.disableFlushOnBeforeUnload=jc(t.disableFlushOnBeforeUnload),t.disableFlushOnUnload=jc(t.disableFlushOnUnload,t.disableFlushOnBeforeUnload),t},qh.Version="2.6.5",qh);function qh(){var t,e,i,r,n,o=jh.call(this)||this;return o.identifier="ApplicationInsightsAnalytics",o.priority=180,o.autoRoutePVDelay=500,el(qh,o,function(a,s){var l=nu(!0);r=l&&l.href||"",a.getCookieMgr=function(){return Qu(a.core)},a.processTelemetry=function(t,e){xu(a.core,function(){return a.identifier+":processTelemetry"},function(){var i=!1,r=a._telemetryInitializers.length;e=a._getTelCtx(e);for(var n=0;n<r;++n){var o=a._telemetryInitializers[n];if(o)try{if(!1===o.apply(null,[t])){i=!0;break}}catch(i){e.diagLog().throwInternal(ks.CRITICAL,il.TelemetryInitializerFailed,"One of telemetry initializers failed, telemetry item will not be sent: "+Ol(i),{exception:cu(i)},!0)}}i||a.processNext(t,e)},function(){return{item:t}},!t.sync)},a.trackEvent=function(t,e){try{var i=Ih.create(t,Cp.dataType,Cp.envelopeType,a.diagLog(),e);a.core.track(i)}catch(t){a.diagLog().throwInternal(ks.WARNING,il.TrackTraceFailed,"trackTrace failed, trace will not be collected: "+Ol(t),{exception:cu(t)})}},a.startTrackEvent=function(e){try{t.start(e)}catch(e){a.diagLog().throwInternal(ks.CRITICAL,il.StartTrackEventFailed,"startTrackEvent failed, event will not be collected: "+Ol(e),{exception:cu(e)})}},a.stopTrackEvent=function(e,i,r){try{t.stop(e,void 0,i)}catch(e){a.diagLog().throwInternal(ks.CRITICAL,il.StopTrackEventFailed,"stopTrackEvent failed, event will not be collected: "+Ol(e),{exception:cu(e)})}},a.trackTrace=function(t,e){try{var i=Ih.create(t,ph.dataType,ph.envelopeType,a.diagLog(),e);a.core.track(i)}catch(t){a.diagLog().throwInternal(ks.WARNING,il.TrackTraceFailed,"trackTrace failed, trace will not be collected: "+Ol(t),{exception:cu(t)})}},a.trackMetric=function(t,e){try{var i=Ih.create(t,th.dataType,th.envelopeType,a.diagLog(),e);a.core.track(i)}catch(t){a.diagLog().throwInternal(ks.CRITICAL,il.TrackMetricFailed,"trackMetric failed, metric will not be collected: "+Ol(t),{exception:cu(t)})}},a.trackPageView=function(t,e){try{var i=t||{};a._pageViewManager.trackPageView(i,Cs({},i.properties,i.measurements,e)),a.config.autoTrackPageVisitTime&&a._pageVisitTimeManager.trackPreviousPageVisit(i.name,i.uri)}catch(t){a.diagLog().throwInternal(ks.CRITICAL,il.TrackPVFailed,"trackPageView failed, page view will not be collected: "+Ol(t),{exception:cu(t)})}},a.sendPageViewInternal=function(t,e,i){var r=iu();r&&(t.refUri=void 0===t.refUri?r.referrer:t.refUri),i=Ih.create(t,oh.dataType,oh.envelopeType,a.diagLog(),e,i),a.core.track(i)},a.sendPageViewPerformanceInternal=function(t,e,i){i=Ih.create(t,yh.dataType,yh.envelopeType,a.diagLog(),e,i),a.core.track(i)},a.trackPageViewPerformance=function(t,e){try{a._pageViewPerformanceManager.populatePageViewPerformanceEvent(t),a.sendPageViewPerformanceInternal(t,e)}catch(t){a.diagLog().throwInternal(ks.CRITICAL,il.TrackPVFailed,"trackPageViewPerformance failed, page view will not be collected: "+Ol(t),{exception:cu(t)})}},a.startTrackPage=function(t){try{var i;"string"!=typeof t&&(t=(i=iu())&&i.title||""),e.start(t)}catch(t){a.diagLog().throwInternal(ks.CRITICAL,il.StartTrackFailed,"startTrackPage failed, page view may not be collected: "+Ol(t),{exception:cu(t)})}},a.stopTrackPage=function(t,i,r,n){try{var o,s;"string"!=typeof t&&(t=(o=iu())&&o.title||""),"string"!=typeof i&&(i=(s=nu())&&s.href||""),e.stop(t,i,r,n),a.config.autoTrackPageVisitTime&&a._pageVisitTimeManager.trackPreviousPageVisit(t,i)}catch(t){a.diagLog().throwInternal(ks.CRITICAL,il.StopTrackFailed,"stopTrackPage failed, page view will not be collected: "+Ol(t),{exception:cu(t)})}},a.sendExceptionInternal=function(t,e,i){var r=t.exception||t.error||new Error(Jc);t=new jp(a.diagLog(),r,t.properties||e,t.measurements,t.severityLevel,t.id).toInterface(),i=Ih.create(t,jp.dataType,jp.envelopeType,a.diagLog(),e,i);a.core.track(i)},a.trackException=function(t,e){try{a.sendExceptionInternal(t,e)}catch(t){a.diagLog().throwInternal(ks.CRITICAL,il.TrackExceptionFailed,"trackException failed, exception will not be collected: "+Ol(t),{exception:cu(t)})}},a._onerror=function(t){var e,i,r=t&&t.error,n=t&&t.evt;try{n||(e=tu())&&(n=e[Fh]);var o=t&&t.url||(iu()||{}).URL,s=t.errorSrc||"window.onerror@"+o+":"+(t.lineNumber||0)+":"+(t.columnNumber||0),l={errorSrc:s,url:o,lineNumber:t.lineNumber||0,columnNumber:t.columnNumber||0,message:t.message};i=t.message,t.url,t.lineNumber,t.columnNumber,t.error||!bl(i)||"Script error."!==i&&"Script error"!==i?(t.errorSrc||(t.errorSrc=s),a.trackException({exception:t,severityLevel:_h.Error},l)):function(t,e){e=Ih.create(t,jp.dataType,jp.envelopeType,a.diagLog(),e),a.core.track(e)}(jp.CreateAutoException("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.",o,t.lineNumber||0,t.columnNumber||0,r,n,null,s),l)}catch(t){r=r?r.name+", "+r.message:"null",a.diagLog().throwInternal(ks.CRITICAL,il.ExceptionWhileLoggingError,"_onError threw exception while logging error, error will not be collected: "+Ol(t),{exception:cu(t),errorString:r})}},a.addTelemetryInitializer=function(t){a._telemetryInitializers.push(t)},a.initialize=function(l,u,c,p){if(!a.isInitialized()){if(cl(u))throw Error("Error initializing");s.initialize(l,u,c,p),a.setInitialized(!1);var h=a._getTelCtx(),d=a.identifier;a.config=h.getExtCfg(d),void 0!==(u=qh.getDefaultConfig(l))&&gl(u,function(t,e){a.config[t]=h.getConfig(d,t,e),void 0===a.config[t]&&(a.config[t]=e)}),a.config.isStorageUseDisabled&&($c=Qc=!1),p={instrumentationKey:function(){return l.instrumentationKey},accountId:function(){return a.config.accountId||l.accountId},sessionRenewalMs:function(){return a.config.sessionRenewalMs||l.sessionRenewalMs},sessionExpirationMs:function(){return a.config.sessionExpirationMs||l.sessionExpirationMs},sampleRate:function(){return a.config.samplingPercentage||l.samplingPercentage},sdkExtension:function(){return a.config.sdkExtension||l.sdkExtension},isBrowserLinkTrackingEnabled:function(){return a.config.isBrowserLinkTrackingEnabled||l.isBrowserLinkTrackingEnabled},appId:function(){return a.config.appId||l.appId}},a._pageViewPerformanceManager=new Dh(a.core),a._pageViewManager=new Lh(o,a.config.overridePageViewDuration,a.core,a._pageViewPerformanceManager),a._pageVisitTimeManager=new Oh(a.diagLog(),function(t,e,i){e={PageName:t,PageUrl:e},a.trackMetric({name:"PageVisitTime",average:i,max:i,min:i,sampleCount:1},e)}),a._telemetryInitializers=a._telemetryInitializers||[],function(t){var e;t.isBrowserLinkTrackingEnabled()||(e=["/browserLinkSignalR/","/__browserLink/"],a._telemetryInitializers.push(function(t){if(t.baseType===lh.dataType){var i=t.baseData;if(i)for(var r=0;r<e.length;r++)if(i.target&&0<=i.target.indexOf(e[r]))return!1}return!0}))}(p),(t=new Hh(a.diagLog(),"trackEvent")).action=function(t,e,i,r){(r=r||{})[Bh]=i.toString(),a.trackEvent({name:t,properties:r})},(e=new Hh(a.diagLog(),"trackPageView")).action=function(t,e,i,r,n){(r=cl(r)?{}:r)[Bh]=i.toString(),a.sendPageViewInternal({name:t,uri:e,properties:r,measurements:n},r)};var f,m,y,g,v,_=tu(),x=(u=Boolean(typeof history===ds&&history)?history:Ql(ql),nu(!0)),b=o;!1===a.config.disableExceptionTracking&&!a.config.autoExceptionInstrumented&&_&&(f=_.onerror,_.onerror=function(t,e,i,r,n){var o=_[Fh],a=f&&f(t,e,i,r,n);return!0!==a&&b._onerror(jp.CreateAutoException(t,e,i,r,n,o)),a},a.config.autoExceptionInstrumented=!0),!1===a.config.disableExceptionTracking&&!0===a.config.enableUnhandledPromiseRejectionTracking&&!a.config.autoUnhandledPromiseInstrumented&&_&&(m=_[p="onunhandledrejection"],_[p]=function(t){var e=_[Fh],i=m&&m.call(_,t);return!0!==i&&b._onerror(jp.CreateAutoException(function(t){if(t&&t.reason){var e=t.reason;return!bl(e)&&fl(e.toString)?e.toString():cu(e)}return t||""}(t),x?x.href:"",0,0,t,e)),i},a.config.autoUnhandledPromiseInstrumented=!0),!0===a.config.enableAutoRouteTracking&&u&&fl(u.pushState)&&fl(u.replaceState)&&_&&"undefined"!=typeof Event&&(y=o,Tl(c,function(t){t.identifier===Ph&&(i=t)}),u.pushState=(v=u.pushState,function(){var t=v.apply(this,arguments);return Uh(_,Uc(y.config.namePrefix+"pushState")),Uh(_,Uc(y.config.namePrefix+"locationchange")),t}),u.replaceState=(g=u.replaceState,function(){var t=g.apply(this,arguments);return Uh(_,Uc(y.config.namePrefix+"replaceState")),Uh(_,Uc(y.config.namePrefix+"locationchange")),t}),_.addEventListener&&(_.addEventListener(y.config.namePrefix+"popstate",function(){Uh(_,Uc(y.config.namePrefix+"locationchange"))}),_.addEventListener(y.config.namePrefix+"locationchange",function(){var t;i&&i.context&&i.context.telemetryTrace&&(i.context.telemetryTrace.traceID=vc(),t="_unknown_",x&&x.pathname&&(t=x.pathname+(x.hash||"")),i.context.telemetryTrace.name=t),n&&(r=n),n=x&&x.href||"",setTimeout(function(t){y.trackPageView({refUri:t,properties:{duration:0}})}.bind(o,r),y.autoRoutePVDelay)}))),a.setInitialized(!0)}}}),o}var Hh=function(t,e){var i=this,r={};i.start=function(e){void 0!==r[e]&&t.throwInternal(ks.WARNING,il.StartCalledMoreThanOnce,"start was called more than once for this event without calling stop.",{name:e,key:e},!0),r[e]=+new Date},i.stop=function(e,n,o,a){var s=r[e];isNaN(s)?t.throwInternal(ks.WARNING,il.StopCalledWithoutStart,"stop was called without a corresponding start.",{name:e,key:e},!0):(s=yp(s,+new Date),i.action(e,n,s,o,a)),delete r[e],r[e]=void 0}},Gh=function t(e){var i=[];el(t,this,function(t){t.enqueue=function(t){i.push(t)},t.count=function(){return i.length},t.clear=function(){i.length=0},t.getItems=function(){return i.slice(0)},t.batchPayloads=function(t){return t&&0<t.length?e.emitLineDelimitedJson()?t.join("\n"):"["+t.join(",")+"]":null},t.markAsSent=function(e){t.clear()},t.clearSent=function(t){}})},Zh=(Wh.BUFFER_KEY="AI_buffer",Wh.SENT_BUFFER_KEY="AI_sentBuffer",Wh.MAX_BUFFER_SIZE=2e3,Wh);function Wh(t,e){var i,r=!1;el(Wh,this,function(n){var o=l(Wh.BUFFER_KEY),a=l(Wh.SENT_BUFFER_KEY);function s(t,e){var i=[];return Tl(e,function(e){fl(e)||-1!==Cl(t,e)||i.push(e)}),i}function l(i){try{i=e.namePrefix&&e.namePrefix()?e.namePrefix()+"_"+i:i;var r=op(t,i);if(r){var n=su().parse(r);if((n=bl(n)?su().parse(n):n)&&_l(n))return n}}catch(r){t.throwInternal(ks.CRITICAL,il.FailedToRestoreStorageBuffer," storage key: "+i+", "+Ol(r),{exception:cu(r)})}return[]}function u(i,r){try{i=e.namePrefix&&e.namePrefix()?e.namePrefix()+"_"+i:i;var n=JSON.stringify(r);ap(t,i,n)}catch(r){ap(t,i,JSON.stringify([])),t.throwInternal(ks.WARNING,il.FailedToSetStorageBuffer," storage key: "+i+", "+Ol(r)+". Buffer cleared",{exception:cu(r)})}}(i=o.concat(a)).length>Wh.MAX_BUFFER_SIZE&&(i.length=Wh.MAX_BUFFER_SIZE),u(Wh.SENT_BUFFER_KEY,[]),u(Wh.BUFFER_KEY,i),n.enqueue=function(e){i.length>=Wh.MAX_BUFFER_SIZE?r||(t.throwInternal(ks.WARNING,il.SessionStorageBufferFull,"Maximum buffer size reached: "+i.length,!0),r=!0):(i.push(e),u(Wh.BUFFER_KEY,i))},n.count=function(){return i.length},n.clear=function(){i=[],u(Wh.BUFFER_KEY,[]),u(Wh.SENT_BUFFER_KEY,[]),r=!1},n.getItems=function(){return i.slice(0)},n.batchPayloads=function(t){return t&&0<t.length?e.emitLineDelimitedJson()?t.join("\n"):"["+t.join(",")+"]":null},n.markAsSent=function(e){i=s(e,i),u(Wh.BUFFER_KEY,i);var r=l(Wh.SENT_BUFFER_KEY);r instanceof Array&&e instanceof Array&&((r=r.concat(e)).length>Wh.MAX_BUFFER_SIZE&&(t.throwInternal(ks.CRITICAL,il.SessionStorageBufferFull,"Sent buffer reached its maximum size: "+r.length,!0),r.length=Wh.MAX_BUFFER_SIZE),u(Wh.SENT_BUFFER_KEY,r))},n.clearSent=function(t){t=s(t,t=l(Wh.SENT_BUFFER_KEY)),u(Wh.SENT_BUFFER_KEY,t)}})}var Kh="baseType",Xh="baseData",Yh="properties";function Jh(t,e,i){return Rl(t,e,i,Nl)}var Qh=($h.extractPropsAndMeasurements=function(t,e,i){cl(t)||gl(t,function(t,r){wl(r)?i[t]=r:bl(r)?e[t]=r:au()&&(e[t]=su().stringify(r))})},$h.createEnvelope=function(t,e,i,r){return Jh(r=new wp(t,r,e),"sampleRate",i[Wc]),(i[Xh]||{}).startTime&&(r.time=Sl(i[Xh].startTime)),r.iKey=i.iKey,e=i.iKey.replace(/-/g,""),r.name=r.name.replace("{0}",e),$h.extractPartAExtensions(i,r),i.tags=i.tags||[],Fl(r)},$h.extractPartAExtensions=function(t,e){var i=e.tags=e.tags||{},r=t.ext=t.ext||{},n=t.tags=t.tags||[],o=r.user;o&&(Jh(i,Ah.userAuthUserId,o.authId),Jh(i,Ah.userId,o.id||o.localId)),(o=r.app)&&Jh(i,Ah.sessionId,o.sesId),(o=r.device)&&(Jh(i,Ah.deviceId,o.id||o.localId),Jh(i,Ah.deviceType,o.deviceClass),Jh(i,Ah.deviceIp,o.ip),Jh(i,Ah.deviceModel,o.model),Jh(i,Ah.deviceType,o.deviceType)),(o=t.ext.web)&&(Jh(i,Ah.deviceLanguage,o.browserLang),Jh(i,Ah.deviceBrowserVersion,o.browserVer),Jh(i,Ah.deviceBrowser,o.browser),Jh(t=(t=(t=e.data=e.data||{})[Xh]=t[Xh]||{})[Yh]=t[Yh]||{},"domain",o.domain),Jh(t,"isManual",o.isManual?"true":null),Jh(t,"screenRes",o.screenRes),Jh(t,"userConsent",o.userConsent?"true":null)),(o=r.os)&&Jh(i,Ah.deviceOS,o.name),(r=r.trace)&&(Jh(i,Ah.operationParentId,r.parentID),Jh(i,Ah.operationName,r.name),Jh(i,Ah.operationId,r.traceID));for(var a={},s=n.length-1;0<=s;s--)gl(n[s],function(t,e){a[t]=e}),n.splice(s,1);gl(n,function(t,e){a[t]=e}),(i=Cs({},i,a))[Ah.internalSdkVersion]||(i[Ah.internalSdkVersion]="javascript:"+$h.Version),e.tags=Fl(i)},$h.prototype.Init=function(t,e){this._logger=t,cl(e[Xh])&&this._logger.throwInternal(ks.CRITICAL,il.TelemetryEnvelopeInvalid,"telemetryItem.baseData cannot be null.")},$h.Version="2.6.5",$h);function $h(){}var td,ed=(Is(id,td=Qh),id.prototype.Create=function(t,e){td.prototype.Init.call(this,t,e);var i=e[Xh].measurements||{},r=e[Xh][Yh]||{};Qh.extractPropsAndMeasurements(e.data,r,i);var n=e[Xh];if(cl(n))return t.warnToConsole("Invalid input for dependency data"),null;var o=n[Yh]&&n[Yh][Xc]?n[Yh][Xc]:"GET";i=new lh(t,n.id,n.target,n.name,n.duration,n.success,n.responseCode,o,n.type,n.correlationContext,r,i),i=new xh(lh.dataType,i);return Qh.createEnvelope(t,lh.envelopeType,e,i)},id.DependencyEnvelopeCreator=new id,id);function id(){return null!==td&&td.apply(this,arguments)||this}var rd,nd=(Is(od,rd=Qh),od.prototype.Create=function(t,e){rd.prototype.Init.call(this,t,e);var i={},r={};e[Kh]!==Cp.dataType&&(i.baseTypeSource=e[Kh]),e[Kh]===Cp.dataType?(i=e[Xh][Yh]||{},r=e[Xh].measurements||{}):e[Xh]&&Qh.extractPropsAndMeasurements(e[Xh],i,r),Qh.extractPropsAndMeasurements(e.data,i,r);var n=e[Xh].name;r=new Cp(t,n,i,r),r=new xh(Cp.dataType,r);return Qh.createEnvelope(t,Cp.envelopeType,e,r)},od.EventEnvelopeCreator=new od,od);function od(){return null!==rd&&rd.apply(this,arguments)||this}var ad,sd=(Is(ld,ad=Qh),ld.prototype.Create=function(t,e){ad.prototype.Init.call(this,t,e);var i=e[Xh].measurements||{},r=e[Xh][Yh]||{};Qh.extractPropsAndMeasurements(e.data,r,i);var n=e[Xh];i=jp.CreateFromInterface(t,n,r,i),i=new xh(jp.dataType,i);return Qh.createEnvelope(t,jp.envelopeType,e,i)},ld.ExceptionEnvelopeCreator=new ld,ld);function ld(){return null!==ad&&ad.apply(this,arguments)||this}var ud,cd=(Is(pd,ud=Qh),pd.prototype.Create=function(t,e){ud.prototype.Init.call(this,t,e);var i=e[Xh],r=i[Yh]||{},n=i.measurements||{};return Qh.extractPropsAndMeasurements(e.data,r,n),n=new th(t,i.name,i.average,i.sampleCount,i.min,i.max,r,n),n=new xh(th.dataType,n),Qh.createEnvelope(t,th.envelopeType,e,n)},pd.MetricEnvelopeCreator=new pd,pd);function pd(){return null!==ud&&ud.apply(this,arguments)||this}var hd,dd=(Is(fd,hd=Qh),fd.prototype.Create=function(t,e){hd.prototype.Init.call(this,t,e);var i,r="duration";cl(a=e[Xh])||cl(a[Yh])||cl(a[Yh][r])?cl(e.data)||cl(e.data[r])||(i=e.data[r],delete e.data[r]):(i=a[Yh][r],delete a[Yh][r]);var n=e[Xh];((e.ext||{}).trace||{}).traceID&&(l=e.ext.trace.traceID);var o=n.id||l,a=n.name,s=(r=n.uri,n[Yh]||{}),l=n.measurements||{};return cl(n.refUri)||(s.refUri=n.refUri),cl(n.pageType)||(s.pageType=n.pageType),cl(n.isLoggedIn)||(s.isLoggedIn=n.isLoggedIn.toString()),cl(n[Yh])||gl(n[Yh],function(t,e){s[t]=e}),Qh.extractPropsAndMeasurements(e.data,s,l),o=new oh(t,a,r,i,s,l,o),o=new xh(oh.dataType,o),Qh.createEnvelope(t,oh.envelopeType,e,o)},fd.PageViewEnvelopeCreator=new fd,fd);function fd(){return null!==hd&&hd.apply(this,arguments)||this}var md,yd=(Is(gd,md=Qh),gd.prototype.Create=function(t,e){md.prototype.Init.call(this,t,e);var i=e[Xh],r=i.name,n=i.uri||i.url,o=i[Yh]||{},a=i.measurements||{};return Qh.extractPropsAndMeasurements(e.data,o,a),i=new yh(t,r,n,void 0,o,a,i),i=new xh(yh.dataType,i),Qh.createEnvelope(t,yh.envelopeType,e,i)},gd.PageViewPerformanceEnvelopeCreator=new gd,gd);function gd(){return null!==md&&md.apply(this,arguments)||this}var vd,_d=(Is(xd,vd=Qh),xd.prototype.Create=function(t,e){vd.prototype.Init.call(this,t,e);var i=e[Xh].message,r=e[Xh].severityLevel,n=e[Xh][Yh]||{},o=e[Xh].measurements||{};return Qh.extractPropsAndMeasurements(e.data,n,o),o=new ph(t,i,r,n,o),o=new xh(ph.dataType,o),Qh.createEnvelope(t,ph.envelopeType,e,o)},xd.TraceEnvelopeCreator=new xd,xd);function xd(){return null!==vd&&vd.apply(this,arguments)||this}var bd=function t(e){el(t,this,function(t){function i(t,o){var a="__aiCircularRefCheck",s={};if(!t)return e.throwInternal(ks.CRITICAL,il.CannotSerializeObject,"cannot serialize object because it is null or undefined",{name:o},!0),s;if(t[a])return e.throwInternal(ks.WARNING,il.CircularReferenceDetected,"Circular reference detected while serializing object",{name:o},!0),s;if(t.aiDataContract)return t[a]=!0,gl(t.aiDataContract,function(n,a){var l=fl(a)?1&a():1&a,u=fl(a)?4&a():4&a,c=2&a,p=void 0!==t[n];a=dl(t[n])&&null!==t[n];!l||p||c?u||(u=void 0)!==(u=a?(c?r:i)(t[n],n):t[n])&&(s[n]=u):e.throwInternal(ks.CRITICAL,il.MissingRequiredFieldSpecification,"Missing required field specification. The field is required but not present on source",{field:n,name:o})}),delete t[a],s;if("measurements"===o)s=n(t,"number",o);else if("properties"===o)s=n(t,"string",o);else if("tags"===o)s=n(t,"string",o);else if(_l(t))s=r(t,o);else{e.throwInternal(ks.WARNING,il.CannotSerializeObjectNonSerializable,"Attempting to serialize an object which does not implement ISerializable",{name:o},!0);try{su().stringify(t),s=t}catch(a){e.throwInternal(ks.CRITICAL,il.CannotSerializeObject,a&&fl(a.toString)?a.toString():"Error serializing object",null,!0)}}return s}function r(t,r){if(t)if(_l(t))for(var n=[],o=0;o<t.length;o++){var a=i(t[o],r+"["+o+"]");n.push(a)}else e.throwInternal(ks.CRITICAL,il.ItemNotInArray,"This field was specified as an array in the contract but the item is not an array.\r\n",{name:r},!0);return n}function n(t,i,r){var n;return t&&(n={},gl(t,function(t,o){"string"===i?void 0===o?n[t]="undefined":null===o?n[t]="null":o.toString?n[t]=o.toString():n[t]="invalid field: toString() is not defined.":"number"===i?void 0===o?n[t]="undefined":null===o?n[t]="null":(o=parseFloat(o),isNaN(o)?n[t]="NaN":n[t]=o):(n[t]="invalid field: "+r+" is of unknown type.",e.throwInternal(ks.CRITICAL,n[t],null,!0))})),n}t.serialize=function(t){t=i(t,"root");try{return su().stringify(t)}catch(t){e.throwInternal(ks.CRITICAL,il.CannotSerializeObject,t&&fl(t.toString)?t.toString():"Error serializing object",null,!0)}}})};function wd(){var t=tu(),e=iu(),i=!1,r=!0;el(wd,this,function(n){try{var o,a;t&&_c.Attach(t,"online",s)&&(_c.Attach(t,"offline",l),i=!0),e&&(ul((o=e.body||e).ononline)||(o.ononline=s,o.onoffline=l,i=!0)),!i||(a=ru())&&!cl(a.onLine)&&(r=a.onLine)}catch(n){i=!1}function s(){r=!0}function l(){r=!1}n.isListening=i,n.isOnline=function(){var t=!0,e=ru();return i?t=r:e&&!cl(e.onLine)&&(t=e.onLine),t},n.isOffline=function(){return!n.isOnline()}})}var Sd=(wd.Offline=new wd,wd).Offline,Td=(Cd.prototype.getHashCodeScore=function(t){return this.getHashCode(t)/Cd.INT_MAX_VALUE*100},Cd.prototype.getHashCode=function(t){if(""===t)return 0;for(;t.length<Cd.MIN_INPUT_LENGTH;)t=t.concat(t);for(var e=5381,i=0;i<t.length;++i)e=(e<<5)+e+t.charCodeAt(i),e&=e;return Math.abs(e)},Cd.INT_MAX_VALUE=2147483647,Cd.MIN_INPUT_LENGTH=8,Cd);function Cd(){}var Ed=(Id.prototype.getSamplingScore=function(t){return t.tags&&t.tags[this.keys.userId]?this.hashCodeGeneragor.getHashCodeScore(t.tags[this.keys.userId]):t.ext&&t.ext.user&&t.ext.user.id?this.hashCodeGeneragor.getHashCodeScore(t.ext.user.id):t.tags&&t.tags[this.keys.operationId]?this.hashCodeGeneragor.getHashCodeScore(t.tags[this.keys.operationId]):t.ext&&t.ext.telemetryTrace&&t.ext.telemetryTrace.traceID?this.hashCodeGeneragor.getHashCodeScore(t.ext.telemetryTrace.traceID):100*Math.random()},Id);function Id(){this.hashCodeGeneragor=new Td,this.keys=new Ch}var kd=(Ad.prototype.isSampledIn=function(t){var e=this.sampleRate;return null==e||100<=e||t.baseType===th.dataType||this.samplingScoreGenerator.getSamplingScore(t)<e},Ad);function Ad(t,e){this.INT_MAX_VALUE=2147483647,this._logger=e||fu(null),(100<t||t<0)&&(this._logger.throwInternal(ks.WARNING,il.SampleRateOutOfRange,"Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.",{samplingRate:t},!0),t=100),this.sampleRate=t,this.samplingScoreGenerator=new Ed}function Pd(t){try{return t.responseText}catch(t){}return null}var Md,Ld=(Is(Od,Md=ft),Od.constructEnvelope=function(t,e,i){var r=e===t.iKey||cl(e)?t:Cs({},t,{iKey:e});switch(r.baseType){case Cp.dataType:return nd.EventEnvelopeCreator.Create(i,r);case ph.dataType:return _d.TraceEnvelopeCreator.Create(i,r);case oh.dataType:return dd.PageViewEnvelopeCreator.Create(i,r);case yh.dataType:return yd.PageViewPerformanceEnvelopeCreator.Create(i,r);case jp.dataType:return sd.ExceptionEnvelopeCreator.Create(i,r);case th.dataType:return cd.MetricEnvelopeCreator.Create(i,r);case lh.dataType:return ed.DependencyEnvelopeCreator.Create(i,r);default:return nd.EventEnvelopeCreator.Create(i,r)}},Od._getDefaultAppInsightsChannelConfig=function(){return{endpointUrl:function(){return"https://dc.services.visualstudio.com/v2/track"},emitLineDelimitedJson:function(){return!1},maxBatchInterval:function(){return 15e3},maxBatchSizeInBytes:function(){return 102400},disableTelemetry:function(){return!1},enableSessionStorageBuffer:function(){return!0},isRetryDisabled:function(){return!1},isBeaconApiDisabled:function(){return!0},onunloadDisableBeacon:function(){return!1},instrumentationKey:function(){},namePrefix:function(){},samplingPercentage:function(){return 100},customHeaders:function(){}}},Od._getEmptyAppInsightsChannelConfig=function(){return{endpointUrl:void 0,emitLineDelimitedJson:void 0,maxBatchInterval:void 0,maxBatchSizeInBytes:void 0,disableTelemetry:void 0,enableSessionStorageBuffer:void 0,isRetryDisabled:void 0,isBeaconApiDisabled:void 0,onunloadDisableBeacon:void 0,instrumentationKey:void 0,namePrefix:void 0,samplingPercentage:void 0,customHeaders:void 0}},Od);function Od(){var t,e,i,r,n,o=Md.call(this)||this;o.priority=1001,o.identifier=Mh,o._XMLHttpRequestSupported=!1;var a={};return el(Od,o,function(s,l){function u(){Bl("Method not implemented.")}function c(e,i,r,n,o,a){var l=null;s._appId||(l=m(a))&&l.appId&&(s._appId=l.appId),(e<200||300<=e)&&0!==e?(301!==e&&307!==e&&308!==e||p(r))&&!s._senderConfig.isRetryDisabled()&&v(e)?(y(i),s.diagLog().throwInternal(ks.WARNING,il.TransmissionFailed,". Response code "+e+". Will retry to send "+i.length+" items.")):s._onError(i,o):Sd.isOffline()?s._senderConfig.isRetryDisabled()||(y(i,10),s.diagLog().throwInternal(ks.WARNING,il.TransmissionFailed,". Offline - Response Code: "+e+". Offline status: "+Sd.isOffline()+". Will retry to send "+i.length+" items.")):(p(r),206===e?(l=l||m(a))&&!s._senderConfig.isRetryDisabled()?s._onPartialSuccess(i,l):s._onError(i,o):(t=0,s._onSuccess(i,n)))}function p(t){return!(10<=n)&&!cl(t)&&""!==t&&t!==s._senderConfig.endpointUrl()&&(s._senderConfig.endpointUrl=function(){return t},++n,1)}function h(t,e){var i=s._senderConfig.endpointUrl(),r=s._buffer.batchPayloads(t);r=new Blob([r],{type:"text/plain;charset=UTF-8"});ru().sendBeacon(i,r)?(s._buffer.markAsSent(t),s._onSuccess(t,t.length)):(d(t,!0),s.diagLog().throwInternal(ks.WARNING,il.TransmissionFailed,". Failed to send telemetry with Beacon API, retried with xhrSender."))}function d(t,e){var i=new XMLHttpRequest,r=s._senderConfig.endpointUrl();try{i[Zc]=!0}catch(e){}i.open("POST",r,e),i.setRequestHeader("Content-type","application/json"),dp(r)&&i.setRequestHeader(Pc,Mc),Tl(Pl(a),function(t){i.setRequestHeader(t,a[t])}),i.onreadystatechange=function(){return s._xhrReadyStateChange(i,t,t.length)},i.onerror=function(e){return s._onError(t,_(i),e)},r=s._buffer.batchPayloads(t),i.send(r),s._buffer.markAsSent(t)}function f(t,e){var i=s._senderConfig.endpointUrl(),r=s._buffer.batchPayloads(t),n=(r=new Blob([r],{type:"text/plain;charset=UTF-8"}),new Headers);dp(i)&&n.append(Pc,Mc),Tl(Pl(a),function(t){n.append(t,a[t])}),r=new Request(i,{method:"POST",headers:n,body:r}),fetch(r).then(function(e){if(!e.ok)throw Error(e.statusText);e.text().then(function(i){c(e.status,t,e.url,t.length,e.statusText,i)}),s._buffer.markAsSent(t)}).catch(function(e){s._onError(t,e.message)})}function m(t){try{if(t&&""!==t){var e=su().parse(t);if(e&&e.itemsReceived&&e.itemsReceived>=e.itemsAccepted&&e.itemsReceived-e.itemsAccepted===e.errors.length)return e}}catch(e){s.diagLog().throwInternal(ks.CRITICAL,il.InvalidBackendResponse,"Cannot parse the response. "+Ol(e),{response:t})}return null}function y(i,r){if(void 0===r&&(r=1),i&&0!==i.length){s._buffer.clearSent(i),t++;for(var n=0,o=i;n<o.length;n++){var a=o[n];s._buffer.enqueue(a)}!function(i){r=t<=1?10:(r=(Math.pow(2,t)-1)/2,r=Math.floor(Math.random()*r*10)+1,r*=i,Math.max(Math.min(r,3600),10));var r=Ll()+1e3*r;e=r}(r),g()}}function g(){var t;i||(t=e?Math.max(0,e-Ll()):0,t=Math.max(s._senderConfig.maxBatchInterval(),t),i=setTimeout(function(){s.triggerSend(!0,null,1)},t))}function v(t){return 408===t||429===t||500===t||503===t}function _(t,e){return t?"XMLHttpRequest,Status:"+t.status+",Response:"+Pd(t)||t.response||"":e}function x(t,e){var i=tu(),r=new XDomainRequest;if(r.onload=function(){return s._xdrOnLoad(r,t)},r.onerror=function(e){return s._onError(t,b(r),e)},i=i&&i.location&&i.location.protocol||"",0!==s._senderConfig.endpointUrl().lastIndexOf(i,0))return s.diagLog().throwInternal(ks.WARNING,il.TransmissionFailed,". Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol."),void s._buffer.clear();i=s._senderConfig.endpointUrl().replace(/^(https?:)/,""),r.open("POST",i),i=s._buffer.batchPayloads(t),r.send(i),s._buffer.markAsSent(t)}function b(t,e){return t?"XDomainRequest,Response:"+Pd(t)||"":e}s.pause=u,s.resume=u,s.flush=function(){try{s.triggerSend(!0,null,1)}catch(t){s.diagLog().throwInternal(ks.CRITICAL,il.FlushFailed,"flush failed, telemetry will not be collected: "+Ol(t),{exception:cu(t)})}},s.onunloadFlush=function(){if(!1!==s._senderConfig.onunloadDisableBeacon()&&!1!==s._senderConfig.isBeaconApiDisabled()||!qc())s.flush();else try{s.triggerSend(!0,h,2)}catch(t){s.diagLog().throwInternal(ks.CRITICAL,il.FailedToSendQueuedTelemetry,"failed to flush with beacon sender on page unload, telemetry will not be collected: "+Ol(t),{exception:cu(t)})}},s.teardown=u,s.addHeader=function(t,e){a[t]=e},s.initialize=function(i,a,u,c){l.initialize(i,a,u,c);var p=s._getTelCtx(),m=s.identifier;r=new bd(a.logger),t=0,e=null,s._sender=null,n=0,a=Od._getDefaultAppInsightsChannelConfig(),s._senderConfig=Od._getEmptyAppInsightsChannelConfig(),gl(a,function(t,e){s._senderConfig[t]=function(){return p.getConfig(m,t,e())}}),s._buffer=s._senderConfig.enableSessionStorageBuffer()&&np()?new Zh(s.diagLog(),s._senderConfig):new Gh(s._senderConfig),s._sample=new kd(s._senderConfig.samplingPercentage(),s.diagLog()),function(t){return!(cl(t.disableInstrumentationKeyValidation)||!t.disableInstrumentationKeyValidation)||new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$").test(t.instrumentationKey)}(i)||s.diagLog().throwInternal(ks.CRITICAL,il.InvalidInstrumentationKey,"Invalid Instrumentation key "+i.instrumentationKey),!dp(s._senderConfig.endpointUrl())&&s._senderConfig.customHeaders()&&0<s._senderConfig.customHeaders().length&&Tl(s._senderConfig.customHeaders(),function(t){o.addHeader(t.header,t.value)}),!s._senderConfig.isBeaconApiDisabled()&&qc()?s._sender=h:(i=Ql("XMLHttpRequest"))?"withCredentials"in new i?(s._sender=d,s._XMLHttpRequestSupported=!0):typeof XDomainRequest!==fs&&(s._sender=x):Ql("fetch")&&(s._sender=f)},s.processTelemetry=function(t,e){e=s._getTelCtx(e);try{if(s._senderConfig.disableTelemetry())return;if(!t)return void e.diagLog().throwInternal(ks.CRITICAL,il.CannotSendEmptyTelemetry,"Cannot send empty telemetry");if(t.baseData&&!t.baseType)return void e.diagLog().throwInternal(ks.CRITICAL,il.InvalidEvent,"Cannot send telemetry without baseData and baseType");if(t.baseType||(t.baseType="EventData"),!s._sender)return void e.diagLog().throwInternal(ks.CRITICAL,il.SenderNotInitialized,"Sender was not initialized");if(!s._sample.isSampledIn(t))return void e.diagLog().throwInternal(ks.WARNING,il.TelemetrySampledAndNotSent,"Telemetry item was sampled out and not sent",{SampleRate:s._sample.sampleRate});t[Wc]=s._sample.sampleRate;var i=Od.constructEnvelope(t,s._senderConfig.instrumentationKey(),e.diagLog());if(!i)return void e.diagLog().throwInternal(ks.CRITICAL,il.CreateEnvelopeError,"Unable to create an AppInsights envelope");var n=!1;if(t.tags&&t.tags[Kc]&&(Tl(t.tags[Kc],function(t){try{t&&!1===t(i)&&(n=!0,e.diagLog().warnToConsole("Telemetry processor check returns false"))}catch(t){e.diagLog().throwInternal(ks.CRITICAL,il.TelemetryInitializerFailed,"One of telemetry initializers failed, telemetry item will not be sent: "+Ol(t),{exception:cu(t)},!0)}}),delete t.tags[Kc]),n)return;var o=r.serialize(i),a=s._buffer.getItems(),l=s._buffer.batchPayloads(a);l&&l.length+o.length>s._senderConfig.maxBatchSizeInBytes()&&s.triggerSend(!0,null,10),s._buffer.enqueue(o),g()}catch(t){e.diagLog().throwInternal(ks.WARNING,il.FailedAddingTelemetryToBuffer,"Failed adding telemetry to the sender's buffer, some telemetry will be lost: "+Ol(t),{exception:cu(t)})}s.processNext(t,e)},s._xhrReadyStateChange=function(t,e,i){4===t.readyState&&c(t.status,e,t.responseURL,i,_(t),Pd(t)||t.response)},s.triggerSend=function(t,r,n){void 0===t&&(t=!0);try{var a;s._senderConfig.disableTelemetry()?s._buffer.clear():0<s._buffer.count()&&(a=s._buffer.getItems(),function(t,e){var i=function(){var t="getNotifyMgr";return s.core[t]?s.core[t]():s.core._notificationManager}();if(i&&i.eventsSendRequest)try{i.eventsSendRequest(t,e)}catch(t){s.diagLog().throwInternal(ks.CRITICAL,il.NotificationException,"send request notification failed: "+Ol(t),{exception:cu(t)})}}(n||0,t),r?r.call(o,a,t):s._sender(a,t)),clearTimeout(i),e=i=null}catch(r){(!(t=uu())||9<t)&&s.diagLog().throwInternal(ks.CRITICAL,il.TransmissionFailed,"Telemetry transmission failed, some telemetry will be lost: "+Ol(r),{exception:cu(r)})}},s._onError=function(t,e,i){s.diagLog().throwInternal(ks.WARNING,il.OnError,"Failed to send telemetry.",{message:e}),s._buffer.clearSent(t)},s._onPartialSuccess=function(t,e){for(var i=[],r=[],n=0,o=e.errors.reverse();n<o.length;n++){var a=o[n],l=t.splice(a.index,1)[0];(v(a.statusCode)?r:i).push(l)}0<t.length&&s._onSuccess(t,e.itemsAccepted),0<i.length&&s._onError(i,_(null,["partial success",e.itemsAccepted,"of",e.itemsReceived].join(" "))),0<r.length&&(y(r),s.diagLog().throwInternal(ks.WARNING,il.TransmissionFailed,"Partial success. Delivered: "+t.length+", Failed: "+i.length+". Will retry to send "+r.length+" our of "+e.itemsReceived+" items"))},s._onSuccess=function(t,e){s._buffer.clearSent(t)},s._xdrOnLoad=function(e,i){var r=Pd(e);!e||r+""!="200"&&""!==r?(r=m(r))&&r.itemsReceived&&r.itemsReceived>r.itemsAccepted&&!s._senderConfig.isRetryDisabled()?s._onPartialSuccess(i,r):s._onError(i,b(e)):(t=0,s._onSuccess(i,0))}}),o}var Rd=function(){},zd=(Dd.acquisitionSpan=864e5,Dd.renewalSpan=18e5,Dd.cookieUpdateInterval=6e4,Dd);function Dd(t,e){var i,r,n=fu(e),o=Qu(e);el(Dd,this,function(e){fl((t=t||{}).sessionExpirationMs)||(t.sessionExpirationMs=function(){return Dd.acquisitionSpan}),fl(t.sessionRenewalMs)||(t.sessionRenewalMs=function(){return Dd.renewalSpan}),e.config=t;var a=e.config.sessionCookiePostfix&&e.config.sessionCookiePostfix()?e.config.sessionCookiePostfix():e.config.namePrefix&&e.config.namePrefix()?e.config.namePrefix():"";function s(t,e){var i=!1,r=", session will be reset",o=e.split("|");if(2<=o.length)try{var a=+o[1]||0,s=+o[2]||0;isNaN(a)||a<=0?n.throwInternal(ks.WARNING,il.SessionRenewalDateIsZero,"AI session acquisition date is 0"+r):isNaN(s)||s<=0?n.throwInternal(ks.WARNING,il.SessionRenewalDateIsZero,"AI session renewal date is 0"+r):o[0]&&(t.id=o[0],t.acquisitionDate=a,t.renewalDate=s,i=!0)}catch(t){n.throwInternal(ks.CRITICAL,il.ErrorParsingAISessionCookie,"Error parsing ai_session value ["+(e||"")+"]"+r+" - "+Ol(t),{exception:cu(t)})}return i}function l(t,n){var a=t.acquisitionDate;t.renewalDate=n;var s=e.config,l=s.sessionRenewalMs(),u=a+s.sessionExpirationMs()-n;t=[t.id,a,n],a=0,a=u<l?u/1e3:l/1e3,l=s.cookieDomain?s.cookieDomain():null;o.set(i(),t.join("|"),0<s.sessionExpirationMs()?a:null,l),r=n}i=function(){return"ai_session"+a},e.automaticSession=new Rd,e.update=function(){var t=Ll(),a=!1,u=e.automaticSession;u.id||(a=!function(t){var e=!1,r=o.get(i());return r&&fl(r.split)?e=s(t,r):(r=function(t,e){var i=tp();if(null!==i)try{return i.getItem(e)}catch(e){Qc=!1,t.throwInternal(ks.WARNING,il.BrowserCannotReadLocalStorage,"Browser failed read of local storage. "+Ol(e),{exception:cu(e)})}return null}(n,i()))&&(e=s(t,r)),e||!!t.id}(u));var c,p,h,d=e.config.sessionExpirationMs();!a&&0<d&&(p=e.config.sessionRenewalMs(),c=t-u.acquisitionDate,h=t-u.renewalDate,a=(a=(a=c<0||h<0)||d<c)||p<h),a?(p=t,a=((h=e.config||{}).getNewId?h.getNewId():null)||gc,e.automaticSession.id=a(h.idLength?h.idLength():22),e.automaticSession.acquisitionDate=p,l(e.automaticSession,p),rp()||n.throwInternal(ks.WARNING,il.BrowserDoesNotSupportLocalStorage,"Browser does not support local storage. Session durations will be inaccurate.")):(!r||Dd.cookieUpdateInterval<t-r)&&l(u,t)},e.backup=function(){var t,r,o=e.automaticSession;t=o.id,r=o.acquisitionDate,o=o.renewalDate,function(t,e,i){var r=tp();if(null!==r)try{r.setItem(e,i)}catch(e){Qc=!1,t.throwInternal(ks.WARNING,il.BrowserCannotWriteLocalStorage,"Browser failed write to local storage. "+Ol(e),{exception:cu(e)})}}(n,i(),[t,r,o].join("|"))}})}var Nd=function(){},Bd=function(){this.id="browser",this.deviceClass="Browser"},Fd=function(t){this.sdkVersion=(t.sdkExtension&&t.sdkExtension()?t.sdkExtension()+"_":"")+"javascript:2.6.5"};function Ud(t){return!("string"!=typeof t||!t||t.match(/,|;|=| |\|/))}var jd=(Vd.cookieSeparator="|",Vd.userCookieName="ai_user",Vd.authUserCookieName="ai_authUser",Vd);function Vd(t,e){this.isNewUser=!1;var i,r=fu(e),n=Qu(e);el(Vd,this,function(e){e.config=t;var o=e.config.userCookiePostfix&&e.config.userCookiePostfix()?e.config.userCookiePostfix():"";i=function(){return Vd.userCookieName+o};var a,s=n.get(i());s&&(e.isNewUser=!1,0<(a=s.split(Vd.cookieSeparator)).length&&(e.id=a[0])),e.id||(a=((l=t||{}).getNewId?l.getNewId():null)||gc,e.id=a(l.idLength?t.idLength():22),l=Sl(new Date),e.accountAcquisitionDate=l,e.isNewUser=!0,l=[e.id,l],n.set(i(),l.join(Vd.cookieSeparator),31536e3),l=t.namePrefix&&t.namePrefix()?t.namePrefix()+"ai_session":"ai_session",function(t,e){var i=tp();if(null!==i)try{i.removeItem(e)}catch(e){Qc=!1,t.throwInternal(ks.WARNING,il.BrowserFailedRemovalFromLocalStorage,"Browser failed removal of local storage item. "+Ol(e),{exception:cu(e)})}}(r,l)),e.accountId=t.accountId?t.accountId():void 0;var l=n.get(Vd.authUserCookieName);l&&((l=(l=decodeURI(l)).split(Vd.cookieSeparator))[0]&&(e.authenticatedId=l[0]),1<l.length&&l[1]&&(e.accountId=l[1])),e.setAuthenticatedUserContext=function(t,i,o){void 0===o&&(o=!1),!Ud(t)||i&&!Ud(i)?r.throwInternal(ks.WARNING,il.SetAuthContextFailedAccountName,"Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.",!0):(e.authenticatedId=t,t=e.authenticatedId,i&&(e.accountId=i,t=[e.authenticatedId,e.accountId].join(Vd.cookieSeparator)),o&&n.set(Vd.authUserCookieName,encodeURI(t)))},e.clearAuthenticatedUserContext=function(){e.authenticatedId=null,e.accountId=null,n.del(Vd.authUserCookieName)}})}var qd=function(){},Hd=function(t,e,i,r){this.traceID=t||vc(),this.parentID=e,this.name=i,e=nu(),!i&&e&&e.pathname&&(this.name=e.pathname),this.name=Rc(r,this.name)},Gd="ext",Zd="tags";function Wd(t,e){t&&t[e]&&0===Pl(t[e]).length&&delete t[e]}var Kd,Xd=function t(e,i){var r=this,n=e.logger;this.appId=function(){return null},el(t,this,function(t){t.application=new Nd,t.internal=new Fd(i),$l()&&(t.sessionManager=new zd(i,e),t.device=new Bd,t.location=new qd,t.user=new jd(i,e),t.telemetryTrace=new Hd(void 0,void 0,void 0,n),t.session=new Rd),t.applySessionContext=function(e,i){var r=t.session,n=t.sessionManager;r&&bl(r.id)?Rl(zl(e.ext,"app"),"sesId",r.id):n&&n.automaticSession&&Rl(zl(e.ext,"app"),"sesId",n.automaticSession.id,bl)},t.applyOperatingSystemContxt=function(e,i){Rl(e.ext,"os",t.os)},t.applyApplicationContext=function(e,i){var r=t.application;r&&(Rl(e=zl(e,Zd),Ah.applicationVersion,r.ver,bl),Rl(e,Ah.applicationBuild,r.build,bl))},t.applyDeviceContext=function(e,i){var r=t.device;r&&(Rl(e=zl(zl(e,Gd),"device"),"localId",r.id,bl),Rl(e,"ip",r.ip,bl),Rl(e,"model",r.model,bl),Rl(e,"deviceClass",r.deviceClass,bl))},t.applyInternalContext=function(e,i){var r,n=t.internal;n&&(Rl(r=zl(e,Zd),Ah.internalAgentVersion,n.agentVersion,bl),Rl(r,Ah.internalSdkVersion,n.sdkVersion,bl),e.baseType!==hu.dataType&&e.baseType!==oh.dataType||(Rl(r,Ah.internalSnippet,n.snippetVer,bl),Rl(r,Ah.internalSdkSrc,n.sdkSrc,bl)))},t.applyLocationContext=function(t,e){var i=r.location;i&&Rl(zl(t,Zd,[]),Ah.locationIp,i.ip,bl)},t.applyOperationContext=function(e,i){var r=t.telemetryTrace;r&&(Rl(e=zl(zl(e,Gd),"trace",{traceID:void 0,parentID:void 0}),"traceID",r.traceID,bl),Rl(e,"name",r.name,bl),Rl(e,"parentID",r.parentID,bl))},t.applyWebContext=function(t,e){var i=r.web;i&&Rl(zl(t,Gd),"web",i)},t.applyUserContext=function(e,i){var r=t.user;r&&(Rl(zl(e,Zd,[]),Ah.userAccountId,r.accountId,bl),Rl(e=zl(zl(e,Gd),"user"),"id",r.id,bl),Rl(e,"authId",r.authenticatedId,bl))},t.cleanUp=function(t,e){(t=t.ext)&&(Wd(t,"device"),Wd(t,"user"),Wd(t,"web"),Wd(t,"os"),Wd(t,"app"),Wd(t,"trace"))}})},Yd=(Is(Jd,Kd=ft),Jd.getDefaultConfig=function(){return{instrumentationKey:function(){},accountId:function(){return null},sessionRenewalMs:function(){return 18e5},samplingPercentage:function(){return 100},sessionExpirationMs:function(){return 864e5},cookieDomain:function(){return null},sdkExtension:function(){return null},isBrowserLinkTrackingEnabled:function(){return!1},appId:function(){return null},namePrefix:function(){},sessionCookiePostfix:function(){},userCookiePostfix:function(){},idLength:function(){return 22},getNewId:function(){return null}}},Jd);function Jd(){var t,e,i=Kd.call(this)||this;return i.priority=110,i.identifier=Ph,el(Jd,i,function(i,r){i.initialize=function(n,o,a,s){r.initialize(n,o,a,s);var l,u,c=i._getTelCtx(),p=i.identifier;s=Jd.getDefaultConfig();e=e||{},gl(s,function(t,i){e[t]=function(){return c.getConfig(p,t,i())}}),i.context=new Xd(o,e),l=Mh,u=null,Tl(a,function(t){if(t.identifier===l)return u=t,-1}),t=u,i.context.appId=function(){return t?t._appId:null},i._extConfig=e},i.processTelemetry=function(t,e){var r;cl(t)||(e=i._getTelCtx(e),t.name===oh.envelopeType&&e.diagLog().resetInternalMessageCount(),(r=i.context||{}).session&&"string"!=typeof i.context.session.id&&r.sessionManager&&r.sessionManager.update(),function(t,e){zl(t,"tags",[]),zl(t,"ext",{});var r=i.context;r.applySessionContext(t,e),r.applyApplicationContext(t,e),r.applyDeviceContext(t,e),r.applyOperationContext(t,e),r.applyUserContext(t,e),r.applyOperatingSystemContxt(t,e),r.applyWebContext(t,e),r.applyLocationContext(t,e),r.applyInternalContext(t,e),r.cleanUp(t,e)}(t,e),r.user&&r.user.isNewUser&&(r.user.isNewUser=!1,r=new hu(il.SendBrowserInfoOnUserInit,(ru()||{}).userAgent||""),e.diagLog().logInternalMessage(ks.CRITICAL,r)),i.processNext(t,e))}}),i}var Qd="properties";function $d(t,e,i){var r=0;e=t[e],i=t[i];return e&&i?yp(e,i):r}function tf(t,e,i,r,n){var o=0;return(n=$d(i,r,n))?ef(t,e,Vc(n)):o}function ef(t,e,i){var r=0;return t&&e&&i&&((t.ajaxPerf=t.ajaxPerf||{})[e]=i,r=1),r}var rf=function(){this.openDone=!1,this.setRequestHeaderDone=!1,this.sendDone=!1,this.abortDone=!1,this.stateChangeAttached=!1},nf=function t(e,i,r){var n=this,o=r,a="responseText";n.perfMark=null,n.completed=!1,n.requestHeadersSize=null,n.requestHeaders=null,n.responseReceivingDuration=null,n.callbackDuration=null,n.ajaxTotalDuration=null,n.aborted=0,n.pageUrl=null,n.requestUrl=null,n.requestSize=0,n.method=null,n.status=null,n.requestSentTime=null,n.responseStartedTime=null,n.responseFinishedTime=null,n.callbackFinishedTime=null,n.endTime=null,n.xhrMonitoringState=new rf,n.clientFailure=0,n.traceID=e,n.spanID=i,el(t,n,function(t){t.getAbsoluteUrl=function(){return t.requestUrl?i=(e=cp(e=t.requestUrl))?e.href:i:null;var e,i},t.getPathName=function(){return t.requestUrl?zc(o,(e=t.method,i=t.requestUrl,e?e.toUpperCase()+" "+i:i)):null;var e,i},t.CreateTrackItem=function(e,i,r){return t.ajaxTotalDuration=Math.round(1e3*yp(t.requestSentTime,t.responseFinishedTime))/1e3,t.ajaxTotalDuration<0?null:((e={id:"|"+t.traceID+"."+t.spanID,target:t.getAbsoluteUrl(),name:t.getPathName(),type:e,startTime:null,duration:t.ajaxTotalDuration,success:200<=+t.status&&+t.status<400,responseCode:+t.status,method:t.method})[Qd]={HttpMethod:t.method},t.requestSentTime&&(e.startTime=new Date,e.startTime.setTime(t.requestSentTime)),function(t,e){var i,r=t.perfTiming,n=e[Qd]||{},o=0,a="connect",s="request",l="response",u=a+"End",c=s+(m="Start"),p=l+"End",h="transferSize",d="encodedBodySize",f="decodedBodySize",m="serverTiming";r?(o|=tf(n,"End",r,"redirectStart","End"),o|=tf(n,"domainLookup",r,"domainLookupStart","domainLookupEnd"),o|=tf(n,a,r,"connectStart",u),o|=tf(n,s,r,c,"requestEnd"),o|=tf(n,l,r,"responseStart",p),o|=tf(n,"networkConnect",r,"startTime",u),o|=tf(n,"sentRequest",r,c,p),o|=ef(n,"duration",c=(c=r.duration)||$d(r,"startTime",p)||0),o|=ef(n,"perfTotal",c),(c=r[m])&&(i={},Tl(c,function(t,e){r=t.name||""+e,e=e=(n=/([^\w\d_$])/g).test(e=r)?r.replace(n,"_"):e;var r,n,o=i[e]||{};gl(t,function(t,e){("name"!==t&&bl(e)||wl(e))&&(!(e=o[t]?o[t]+";"+e:e)&&bl(e)||(o[t]=e))}),i[e]=o}),o|=ef(n,m,i)),o|=ef(n,h,r[h]),o|=ef(n,d,r[d]),o|=ef(n,f,r[f])):t.perfMark&&(o|=ef(n,"missing",t.perfAttempts)),o&&(e[Qd]=n)}(t,e),i&&0<Pl(t.requestHeaders).length&&(e[Qd]=e[Qd]||{},e[Qd].requestHeaders=t.requestHeaders),!r||(i=r())&&((r=i.correlationContext)&&(e.correlationContext=r),i.headerMap&&0<Pl(i.headerMap).length&&(e[Qd]=e[Qd]||{},e[Qd].responseHeaders=i.headerMap),400<=t.status&&(r=i.type,e[Qd]=e[Qd]||{},""!==r&&"text"!==r||(e[Qd][a]=i[a]?i.statusText+" - "+i[a]:i.statusText),"json"===r&&(e[Qd][a]=i.response?i.statusText+" - "+JSON.stringify(i.response):i.statusText))),e)}})},of=(af.isValidTraceId=function(t){return t.match(/^[0-9a-f]{32}$/)&&"00000000000000000000000000000000"!==t},af.isValidSpanId=function(t){return t.match(/^[0-9a-f]{16}$/)&&"0000000000000000"!==t},af.prototype.toString=function(){return this.version+"-"+this.traceId+"-"+this.spanId+"-"+this.traceFlag},af.DEFAULT_TRACE_FLAG="01",af.DEFAULT_VERSION="00",af);function af(t,e){this.traceFlag=af.DEFAULT_TRACE_FLAG,this.version=af.DEFAULT_VERSION,t&&af.isValidTraceId(t)?this.traceId=t:this.traceId=vc(),e&&af.isValidSpanId(e)?this.spanId=e:this.spanId=vc().substr(0,16)}var sf="ai.ajxmn.",lf="diagLog",uf="ajaxData",cf="throwInternal",pf="fetch",hf=0;function df(t){var e="";try{cl(t)||cl(t[uf])||cl(t[uf].requestUrl)||(e+="(url: '"+t[uf].requestUrl+"')")}catch(t){}return e}function ff(t,e,i,r,n){t[lf]()[cf](ks.CRITICAL,e,i,r,n)}function mf(t,e,i,r,n){t[lf]()[cf](ks.WARNING,e,i,r,n)}function yf(t,e,i){return function(r){ff(t,e,i,{ajaxDiagnosticsMessage:df(r.inst),exception:cu(r.err)})}}function gf(t,e){return t&&e?t.indexOf(e):-1}var vf,_f,xf=(Is(bf,vf=ft),bf.getDefaultConfig=function(){return{maxAjaxCallsPerView:500,disableAjaxTracking:!1,disableFetchTracking:!0,excludeRequestFromAutoTrackingPatterns:void 0,disableCorrelationHeaders:!1,distributedTracingMode:Gc.AI_AND_W3C,correlationHeaderExcludedDomains:["*.blob.core.windows.net","*.blob.core.chinacloudapi.cn","*.blob.core.cloudapi.de","*.blob.core.usgovcloudapi.net"],correlationHeaderDomains:void 0,correlationHeaderExcludePatterns:void 0,appId:void 0,enableCorsCorrelation:!1,enableRequestHeaderTracking:!1,enableResponseHeaderTracking:!1,enableAjaxErrorStatusText:!1,enableAjaxPerfTracking:!1,maxAjaxPerfLookupAttempts:3,ajaxPerfLookupDelay:25,ignoreHeaders:["Authorization","X-API-Key","WWW-Authenticate"]}},bf.getEmptyConfig=function(){var t=this.getDefaultConfig();return gl(t,function(e){t[e]=void 0}),t},bf.prototype.processTelemetry=function(t,e){this.processNext(t,e)},bf.identifier="AjaxDependencyPlugin",bf);function bf(){var t=vf.call(this)||this;t.identifier=bf.identifier,t.priority=120;var e,i,r,n,o,a="trackDependencyDataInternal",s=nu(),l=!1,u=!1,c=s&&s.host&&s.host.toLowerCase(),p=bf.getEmptyConfig(),h=!1,d=0,f=!1,m=0,y=!1,g=[],v={};return el(bf,t,function(t,s){function _(t){var e=!0;return(t||p.ignoreHeaders)&&Tl(p.ignoreHeaders,function(i){if(i.toLowerCase()===t.toLowerCase())return e=!1,-1}),e}function x(t,e,i){g.push((e=e,i=i,(t=t)?Cc(t[ms],e,i,!1):null))}function b(t,e,i){var r=!1,n=((bl(e)?e:(e||{}).url||"")||"").toLowerCase();if(Tl(o,function(t){var e=t;bl(t)&&(e=new RegExp(t)),r=r||e.test(n)}),r)return r;var a=gf(n,"?"),s=gf(n,"#");return-1!==(a=-1===a||-1!==s&&s<a?s:a)&&(n=n.substring(0,a)),cl(t)?cl(e)||(r="object"==typeof e&&!0===e[Zc]||!!i&&!0===i[Zc]):r=!0===t[Zc]||!0===n[Zc],r?v[n]||(v[n]=1):v[n]&&(r=!0),r}function w(t,e){var i=!0,r=u;return cl(t)||(i=!0===e||!cl(t[uf])),r&&i}function S(t,e){var i;e.requestUrl&&n&&f&&(i=ou())&&fl(i.mark)&&(t=n+t+"#"+ ++hf,i.mark(t),(t=i.getEntriesByName(t))&&1===t.length&&(e.perfMark=t[0]))}function T(t,e,i,r){var n=e.perfMark,o=ou(),a=p.maxAjaxPerfLookupAttempts,s=p.ajaxPerfLookupDelay,l=e.requestUrl,u=0;!function c(){try{if(o&&n){u++;for(var p=null,h=o.getEntries(),d=h.length-1;0<=d;d--){var f=h[d];if(f){if("resource"===f.entryType)f.initiatorType!==t||-1===gf(f.name,l)&&-1===gf(l,f.name)||(p=f);else if("mark"===f.entryType&&f.name===n.name){e.perfTiming=p;break}if(f.startTime<n.startTime-1e3)break}}}!n||e.perfTiming||a<=u||!1===e.async?(n&&fl(o.clearMarks)&&o.clearMarks(n.name),e.perfAttempts=u,i()):setTimeout(c,s)}catch(c){r(c)}}()}function C(e){var i="";try{cl(e)||(i+="string"==typeof e?"(url: '"+e+"')":"(url: '"+e.url+"')")}catch(e){ff(t,il.FailedMonitorAjaxOpen,"Failed to grab failed fetch diagnostics message",{exception:cu(e)})}return i}function E(e,i,r,n,o){function s(e,i,n){(n=n||{}).fetchDiagnosticsMessage=C(r),i&&(n.exception=cu(i)),mf(t,e,"Failed to calculate the duration of the fetch call, monitoring data for this fetch call won't be sent.",n)}n&&(n.responseFinishedTime=mp(),n.status=i,T("fetch",n,function(){var e=n.CreateTrackItem("Fetch",h,o);e?t[a](e):s(il.FailedMonitorAjaxDur,null,{requestSentTime:n.requestSentTime,responseFinishedTime:n.responseFinishedTime})},function(t){s(il.FailedMonitorAjaxGetCorrelationHeader,t,null)}))}t.initialize=function(c,d,v,I){if(!t.isInitialized()){s.initialize(c,d,v,I);var k=t._getTelCtx();if(gl(bf.getDefaultConfig(),function(t,e){p[t]=k.getConfig(bf.identifier,t,e)}),I=p.distributedTracingMode,h=p.enableRequestHeaderTracking,f=p.enableAjaxPerfTracking,m=p.maxAjaxCallsPerView,y=p.enableResponseHeaderTracking,o=p.excludeRequestFromAutoTrackingPatterns,r=I===Gc.AI||I===Gc.AI_AND_W3C,i=I===Gc.AI_AND_W3C||I===Gc.W3C,f&&(M=c.instrumentationKey||"unkwn",n=5<M.length?sf+M.substring(M.length-5)+".":sf+M+"."),!1===p.disableAjaxTracking&&(!function(t){var e=!1;typeof XMLHttpRequest===fs||cl(XMLHttpRequest)||(e=!(cl(i=XMLHttpRequest[ms])||cl(i.open)||cl(i.send)||cl(i.abort)));var i=uu();if(e=!(i&&i<9)&&e)try{(new XMLHttpRequest)[uf]={};var r=XMLHttpRequest[ms].open;XMLHttpRequest[ms].open=r}catch(i){e=!1,ff(t,il.FailedMonitorAjaxOpen,"Failed to enable XMLHttpRequest monitoring, extension is not supported",{exception:cu(i)})}return e}(t)||u||(x(XMLHttpRequest,"open",{req:function(i,r,n,o){var s=i.inst,l=s[uf];b(s,n)||!w(s,!0)||l&&l.xhrMonitoringState.openDone||(i=s,l=r,s=n,r=o,n=e&&e.telemetryTrace&&e.telemetryTrace.traceID||vc(),o=vc().substr(0,16),(o=new nf(n,o,t[lf]())).method=l,o.requestUrl=s,o.xhrMonitoringState.openDone=!0,o.requestHeaders={},o.async=r,i[uf]=o,function(e){e[uf].xhrMonitoringState.stateChangeAttached=_c.Attach(e,"readystatechange",function(){try{e&&4===e.readyState&&w(e)&&((o=(n=e)[uf]).responseFinishedTime=mp(),o.status=n.status,T("xmlhttprequest",o,function(){try{var e=o.CreateTrackItem("Ajax",h,function(){var e,i,r={statusText:n.statusText,headerMap:null,correlationContext:function(e){try{var i=e.getAllResponseHeaders();if(null!==i&&-1!==gf(i.toLowerCase(),Lc)){var r=e.getResponseHeader(Ec);return fp.getCorrelationContext(r)}}catch(i){mf(t,il.FailedMonitorAjaxGetCorrelationHeader,"Failed to get Request-Context correlation header as it may be not included in the response or not accessible.",{ajaxDiagnosticsMessage:df(e),exception:cu(i)})}}(n),type:n.responseType,responseText:function(t){try{var e=t.responseType;if(""===e||"text"===e)return t.responseText}catch(t){}return null}(n),response:n.response};return!y||(e=n.getAllResponseHeaders())&&(e=Il(e).split(/[\r\n]+/),i={},Tl(e,function(t){t=(e=t.split(": ")).shift();var e=e.join(": ");_(t)&&(i[t]=e)}),r.headerMap=i),r});e?t[a](e):r(null,{requestSentTime:o.requestSentTime,responseFinishedTime:o.responseFinishedTime})}finally{try{n[uf]=null}catch(e){}}},function(t){r(t,null)}))}catch(r){var i=cu(r);i&&-1!==gf(i.toLowerCase(),"c00c023f")||ff(t,il.FailedMonitorAjaxRSC,"Failed to monitor XMLHttpRequest 'readystatechange' event handler, monitoring data for this ajax call may be incorrect.",{ajaxDiagnosticsMessage:df(e),exception:i})}function r(e,i){(i=i||{}).ajaxDiagnosticsMessage=df(n),e&&(i.exception=cu(e)),mf(t,il.FailedMonitorAjaxDur,"Failed to calculate the duration of the ajax call, monitoring data for this ajax call won't be sent.",i)}var n,o})}(i))},hkErr:yf(t,il.FailedMonitorAjaxOpen,"Failed to monitor XMLHttpRequest.open, monitoring data for this ajax call may be incorrect.")}),x(XMLHttpRequest,"send",{req:function(e,i){var r=e.inst;e=r[uf];w(r)&&!e.xhrMonitoringState.sendDone&&(S("xhr",e),e.requestSentTime=mp(),t.includeCorrelationHeaders(e,void 0,void 0,r),e.xhrMonitoringState.sendDone=!0)},hkErr:yf(t,il.FailedMonitorAjaxSend,"Failed to monitor XMLHttpRequest, monitoring data for this ajax call may be incorrect.")}),x(XMLHttpRequest,"abort",{req:function(t){var e=t.inst;t=e[uf];w(e)&&!t.xhrMonitoringState.abortDone&&(t.aborted=1,t.xhrMonitoringState.abortDone=!0)},hkErr:yf(t,il.FailedMonitorAjaxAbort,"Failed to monitor XMLHttpRequest.abort, monitoring data for this ajax call may be incorrect.")}),h&&x(XMLHttpRequest,"setRequestHeader",{req:function(t,e,i){w(t=t.inst)&&_(e)&&(t[uf].requestHeaders[e]=i)},hkErr:yf(t,il.FailedMonitorAjaxSetRequestHeader,"Failed to monitor XMLHttpRequest.setRequestHeader, monitoring data for this ajax call may be incorrect.")}),u=!0)),(c=function(){var t=ws();return!t||cl(t.Request)||cl(t.Request[ms])||cl(t[pf])?null:t[pf]}())&&(M=ws(),L=c.polyfill,!1===p.disableFetchTracking?(g.push(Cc(M,pf,{req:function(i,r,n){var o,a;!l||b(null,r,n)||L&&u||(o=i.ctx(),a=function(i,r){var n=e&&e.telemetryTrace&&e.telemetryTrace.traceID||vc(),o=vc().substr(0,16);(n=new nf(n,o,t[lf]())).requestSentTime=mp(),i instanceof Request?n.requestUrl=i?i.url:"":n.requestUrl=i,o="GET",r&&r.method?o=r.method:i&&i instanceof Request&&(o=i.method),n.method=o;var a={};return h&&new Headers((r?r.headers:0)||i instanceof Request&&i.headers||{}).forEach(function(t,e){_(e)&&(a[e]=t)}),n.requestHeaders=a,S("fetch",n),n}(r,n),(r=t.includeCorrelationHeaders(a,r,n))!==n&&i.set(1,r),o.data=a)},rsp:function(e,i){var r=e.ctx().data;r&&(e.rslt=e.rslt.then(function(e){return E(0,(e||{}).status,e,r,function(){var i,r={statusText:e.statusText,headerMap:null,correlationContext:function(e){if(e&&e.headers)try{var i=e.headers.get(Ec);return fp.getCorrelationContext(i)}catch(i){mf(t,il.FailedMonitorAjaxGetCorrelationHeader,"Failed to get Request-Context correlation header as it may be not included in the response or not accessible.",{fetchDiagnosticsMessage:C(e),exception:cu(i)})}}(e)};return y&&(i={},e.headers.forEach(function(t,e){_(e)&&(i[e]=t)}),r.headerMap=i),r}),e}).catch(function(t){throw E(0,0,i,r,null,t.message),t}))},hkErr:yf(t,il.FailedMonitorAjaxOpen,"Failed to monitor Window.fetch, monitoring data for this fetch call may be incorrect.")})),l=!0):L&&g.push(Cc(M,pf,{req:function(t,e,i){b(null,e,i)}})),L&&(M[pf].polyfill=L)),0<v.length&&v){for(var A=void 0,P=0;!A&&P<v.length;)v[P]&&v[P].identifier===Ph&&(A=v[P]),P++;A&&(e=A.context)}}var M,L},t.teardown=function(){Tl(g,function(t){t.rm()}),u=l=!(g=[]),t.setInitialized(!1)},t.trackDependencyData=function(e,i){t[a](e,i)},t.includeCorrelationHeaders=function(n,o,a,s){var l,u,d,f=t._currentWindowHost||c;return o?(fp.canIncludeCorrelationHeader(p,n.getAbsoluteUrl(),f)&&((a=a||{}).headers=new Headers(a.headers||o instanceof Request&&o.headers||{}),r&&(l="|"+n.traceID+"."+n.spanID,a.headers.set(kc,l),h&&(n.requestHeaders[kc]=l)),(u=p.appId||e&&e.appId())&&(a.headers.set(Ec,Ic+u),h&&(n.requestHeaders[Ec]=Ic+u)),i&&(d=new of(n.traceID,n.spanID),a.headers.set(Ac,d.toString()),h&&(n.requestHeaders[Ac]=d.toString()))),a):s?(fp.canIncludeCorrelationHeader(p,n.getAbsoluteUrl(),f)&&(r&&(l="|"+n.traceID+"."+n.spanID,s.setRequestHeader(kc,l),h&&(n.requestHeaders[kc]=l)),(u=p.appId||e&&e.appId())&&(s.setRequestHeader(Ec,Ic+u),h&&(n.requestHeaders[Ec]=Ic+u)),i&&(d=new of(n.traceID,n.spanID),s.setRequestHeader(Ac,d.toString()),h&&(n.requestHeaders[Ac]=d.toString()))),s):void 0},t[a]=function(e,i,r){-1===m||d<m?(p.distributedTracingMode!==Gc.W3C&&p.distributedTracingMode!==Gc.AI_AND_W3C||"string"!=typeof e.id||"."===e.id[e.id.length-1]||(e.id+="."),cl(e.startTime)&&(e.startTime=new Date),r=Ih.create(e,lh.dataType,lh.envelopeType,t[lf](),i,r),t.core.track(r)):d===m&&ff(t,il.MaxAjaxPerPVExceeded,"Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.",!0),++d}}),t}var wf=["snippet","dependencies","properties","_snippetVersion","appInsightsNew","getSKUDefaults"],Sf=(Tf.prototype.getCookieMgr=function(){return this.appInsights.getCookieMgr()},Tf.prototype.trackEvent=function(t,e){this.appInsights.trackEvent(t,e)},Tf.prototype.trackPageView=function(t){this.appInsights.trackPageView(t||{})},Tf.prototype.trackPageViewPerformance=function(t){this.appInsights.trackPageViewPerformance(t||{})},Tf.prototype.trackException=function(t){t&&!t.exception&&t.error&&(t.exception=t.error),this.appInsights.trackException(t)},Tf.prototype._onerror=function(t){this.appInsights._onerror(t)},Tf.prototype.trackTrace=function(t,e){this.appInsights.trackTrace(t,e)},Tf.prototype.trackMetric=function(t,e){this.appInsights.trackMetric(t,e)},Tf.prototype.startTrackPage=function(t){this.appInsights.startTrackPage(t)},Tf.prototype.stopTrackPage=function(t,e,i,r){this.appInsights.stopTrackPage(t,e,i,r)},Tf.prototype.startTrackEvent=function(t){this.appInsights.startTrackEvent(t)},Tf.prototype.stopTrackEvent=function(t,e,i){this.appInsights.stopTrackEvent(t,e,i)},Tf.prototype.addTelemetryInitializer=function(t){return this.appInsights.addTelemetryInitializer(t)},Tf.prototype.setAuthenticatedUserContext=function(t,e,i){this.properties.context.user.setAuthenticatedUserContext(t,e,i=void 0!==i&&i)},Tf.prototype.clearAuthenticatedUserContext=function(){this.properties.context.user.clearAuthenticatedUserContext()},Tf.prototype.trackDependencyData=function(t){this.dependencies.trackDependencyData(t)},Tf.prototype.flush=function(t){var e=this;void 0===t&&(t=!0),xu(this.core,function(){return"AISKU.flush"},function(){Tl(e.core.getTransmissionControls(),function(e){Tl(e,function(e){e.flush(t)})})},null,t)},Tf.prototype.onunloadFlush=function(t){void 0===t&&(t=!0),Tl(this.core.getTransmissionControls(),function(e){Tl(e,function(e){e.onunloadFlush?e.onunloadFlush():e.flush(t)})})},Tf.prototype.loadAppInsights=function(t,e,i){var r=this,n=this;return(t=void 0!==t&&t)&&n.config.extensions&&0<n.config.extensions.length&&Bl("Extensions not allowed in legacy mode"),xu(n.core,function(){return"AISKU.loadAppInsights"},function(){var o,a=[];a.push(n._sender),a.push(n.properties),a.push(n.dependencies),a.push(n.appInsights),n.core.initialize(n.config,a,e,i),n.context=n.properties.context,_f&&n.context&&(n.context.internal.sdkSrc=_f),(o=n.snippet)&&(a="",cl(n._snippetVersion)||(a+=n._snippetVersion),t&&(a+=".lg"),n.context&&n.context.internal&&(n.context.internal.snippetVer=a||"-"),gl(n,function(t,e){bl(t)&&!fl(e)&&t&&"_"!==t[0]&&-1===wf.indexOf(t)&&(o[t]=e)})),n.emptyQueue(),n.pollInternalLogs(),n.addHousekeepingBeforeUnload(r)}),n},Tf.prototype.updateSnippetDefinitions=function(t){!function(t,e,i){if(t&&e&&t!==e&&dl(t)&&dl(e))for(var r in e)!function(r){var n,o;bl(r)&&(fl(n=e[r])?i&&!i(r,!0,e,t)||(t[r]=(o=r,function(){return e[o].apply(e,arguments)})):i&&!i(r,!1,e,t)||(hl(t,r)&&delete t[r],Ml(t,r,function(){return e[r]},function(t){e[r]=t})||(t[r]=n)))}(r)}(t,this,function(t){return t&&-1===wf.indexOf(t)})},Tf.prototype.emptyQueue=function(){try{if(_l(this.snippet.queue)){for(var t=this.snippet.queue.length,e=0;e<t;e++)(0,this.snippet.queue[e])();this.snippet.queue=void 0,delete this.snippet.queue}}catch(t){t&&fl(t.toString)&&t.toString()}},Tf.prototype.pollInternalLogs=function(){this.core.pollInternalLogs()},Tf.prototype.addHousekeepingBeforeUnload=function(t){var e,i;($l()||eu())&&(e=function(){t.onunloadFlush(!1),Tl(t.appInsights.core._extensions,function(t){if(t.identifier===Ph)return t&&t.context&&t.context._sessionManager&&t.context._sessionManager.backup(),-1})},t.appInsights.config.disableFlushOnBeforeUnload||(i=yc("beforeunload",e),i=yc("unload",e)||i,i=yc("pagehide",e)||i,(i=yc("visibilitychange",e)||i)||(i=ru())&&i.product&&"ReactNative"===i.product||t.appInsights.core.logger.throwInternal(ks.CRITICAL,il.FailedToAddHandlerForOnBeforeUnload,"Could not add handler for beforeunload and pagehide")),t.appInsights.config.disableFlushOnUnload||(yc("pagehide",e),yc("visibilitychange",e)))},Tf.prototype.getSender=function(){return this._sender},Tf.prototype.getSKUDefaults=function(){this.config.diagnosticLogInterval=this.config.diagnosticLogInterval&&0<this.config.diagnosticLogInterval?this.config.diagnosticLogInterval:1e4},Tf);function Tf(t){this._snippetVersion=""+(t.sv||t.version||""),t.queue=t.queue||[],t.version=t.version||2;var e,i,r=t.config||{};r.connectionString&&(i=(e=function(t){if(!t)return{};var e=function(t,e,i){var r,n=t.length,o=0;if(3<=arguments.length)r={};else{for(;o<n&&!(o in t);)o++;r=t[o++]}for(;o<n;)o in t&&(r=e(r,t[o])),o++;return r}(t.split(gp),function(t,e){var i=e.split(vp);return 2===i.length&&(e=i[0].toLowerCase(),i=i[1],t[e]=i),t},{});return 0<Pl(e).length&&(e.endpointsuffix&&(t=e.location?e.location+".":"",e.ingestionendpoint=e.ingestionendpoint||"https://"+t+"dc."+e.endpointsuffix),e.ingestionendpoint=e.ingestionendpoint||Yc),e}(r.connectionString)).ingestionendpoint,r.endpointUrl=i?i+"/v2/track":r.endpointUrl,r.instrumentationKey=e.instrumentationkey||r.instrumentationKey),this.appInsights=new Vh,this.properties=new Yd,this.dependencies=new xf,this.core=new lc,this._sender=new Ld,this.snippet=t,this.config=r,this.getSKUDefaults()}!function(){var t=null,e=["://js.monitor.azure.com/","://az416426.vo.msecnd.net/"];try{var i=(document||{}).currentScript;i&&(t=i.src)}catch(t){}if(t)try{var r=t.toLowerCase();if(r)for(var n="",o=0;o<e.length;o++)if(-1!==r.indexOf(e[o])){n="cdn"+(o+1),-1===r.indexOf("/scripts/")&&(-1!==r.indexOf("/next/")?n+="-next":-1!==r.indexOf("/beta/")&&(n+="-beta")),_f=n+"";break}}catch(t){}}();var Cf=(Ef.prototype.trackEvent=function(t,e){!this.options.disableTelemetry&&this.appInsights&&this.appInsights.trackEvent(t,e)},Ef.prototype.setAuthenticatedUserContext=function(t,e){!this.options.disableTelemetry&&this.appInsights&&this.appInsights.setAuthenticatedUserContext(t,e)},Ef.prototype.trackException=function(t){!this.options.disableTelemetry&&this.appInsights&&this.appInsights.trackException(t)},Ef.prototype.flush=function(t){!this.options.disableTelemetry&&this.appInsights&&this.appInsights.flush(t)},Ef);function Ef(t){this.options=t,!this.options.disableTelemetry&&c&&(this.appInsights=new Sf({config:{instrumentationKey:c,disableExceptionTracking:!0,disableAjaxTracking:!0,isCookieUseDisabled:!0,maxBatchInterval:5e3}}),this.appInsights.loadAppInsights(),this.appInsights.addTelemetryInitializer(function(t){t.tags[Ah.applicationVersion]=N.getFullVersion()}))}var If,kf=(w(Af,If=A),Af);function Af(){var t=null!==If&&If.apply(this,arguments)||this;return t.copyrightMessage=void 0,t.copyrightContent=void 0,t.customAttribution=void 0,t.showFeedbackLink=!0,t.showLogo=!0,t}var Pf,Mf=(w(Lf,Pf=X),Lf.prototype.onAdd=function(e){return this.container=this.buildContainer(e,t.ControlStyle.auto),this.container.className="map-copyright",this.copyrightDiv=this.buildCopyrightDiv(),this.copyrightDiv.className="azure-map-copyright",this.container.appendChild(this.copyrightDiv),this.options.showLogo&&this.addRemoveLogo(!0),this.options.showFeedbackLink&&this.addRemoveFeedbackDiv(!0),this.container},Lf.prototype.onRemove=function(){Pf.prototype.onRemove.call(this),delete this.container},Lf.prototype.setOptions=function(t){var e=this,i=(new kf).merge(this.options,t);i.copyrightMessage===this.options.copyrightMessage&&i.customAttribution===this.options.customAttribution||(this.copyrightDiv.innerText=this.textAttribution(i)),i.copyrightContent!==this.options.copyrightContent&&(this.options.copyrightContent&&(t=Array.from(this.copyrightDiv.children).find(function(t){return t===e.options.copyrightContent}),this.copyrightDiv.removeChild(t)),0<this.copyrightDiv.childNodes.length?this.copyrightDiv.insertBefore(i.copyrightContent,this.copyrightDiv.childNodes[0]):this.copyrightDiv.appendChild(i.copyrightContent),this.options.copyrightContent=i.copyrightContent),!i.showLogo&&this.logoDiv?this.addRemoveLogo(!1):i.showLogo&&!this.logoDiv&&this.addRemoveLogo(!0),!i.showFeedbackLink&&this.feedbackDiv?this.addRemoveFeedbackDiv(!1):i.showFeedbackLink&&!this.feedbackDiv&&this.addRemoveFeedbackDiv(!0),this.options=i},Lf.prototype.getDefaultAttributions=function(){var t=(new Date).getFullYear(),e=["Â©"+t+" TomTom"];return this.options.showLogo||e.push("Â©"+t+" Microsoft"),e},Lf.prototype.buildCopyrightDiv=function(){var t=document.createElement("div");return t.innerText=this.textAttribution(this.options)||"",t},Lf.prototype.buildFeedbackLink=function(){var t=this,e=document.createElement("a");return e.href="https://feedback.azuremaps.com",e.target="_blank",e.rel="noopener",e.className="azure-map-feedback",e.onmouseover=function(){t.tooltip.style.visibility="visible"},e.onmouseout=function(){t.tooltip.style.visibility="hidden"},e},Lf.prototype.addToolTip=function(){var t=document.createElement("div"),e=document.createElement("div");e.innerText="Give Feedback",e.className="azure-map-feedback-tooltip";var i=document.createElement("div");return i.className="azure-map-feedback-tooltip-beak",t.appendChild(e),t.appendChild(i),t.style.visibility="hidden",t.style.zIndex="1000",t},Lf.prototype.addRemoveFeedbackDiv=function(t){t?(this.feedbackDiv=this.buildFeedbackLink(),this.container.appendChild(this.feedbackDiv),this.tooltip=this.addToolTip(),this.container.appendChild(this.tooltip)):(this.feedbackDiv.remove(),this.tooltip.remove(),delete this.tooltip,delete this.feedbackDiv)},Lf.prototype.addRemoveLogo=function(t){t?(this.logoDiv=document.createElement("div"),this.logoDiv.className="azure-map-logo",this.container.appendChild(this.logoDiv)):(this.logoDiv.remove(),delete this.logoDiv)},Lf);function Lf(t){var e=Pf.call(this)||this;return e.textAttribution=function(t){return[e.options.copyrightMessage,e.options.customAttribution].filter(function(t){return t}).join("")},e.options=(new kf).merge(t),e}var Of=(Rf.throwOnError=function(t,e){function i(t){throw r.off("error",i),t.error}var r=t instanceof jy?t._getMap():t;return r.on("error",i),e=e(),r.off("error",i),e},Rf.tryCatch=function(t,e,i,r){try{return this.throwOnError(t,e)}catch(t){return i(t)}finally{"function"==typeof r&&r()}},Rf.tryFinally=function(t,e,i){try{return this.throwOnError(t,e)}finally{i()}},Rf);function Rf(){}var zf=(Df.prototype.request=function(t){return t={domain:this.map.getServiceOptions().domain,path:"search/address/reverse/json",queryParams:S({"api-version":"1.0",language:t.style.language,limit:1,query:Ar(t.position[1])+","+Pr(t.position[0])},t.style.view&&{view:t.style.view})},new R(this.map.authentication.signRequest(t)).get()},Df);function Df(t){this.map=t}var Nf=(Bf.prototype.cache=function(t,e,i,r){r=t+"_"+i[0]+"_"+i[1]+"_"+r,this._labelIdx[e.labelType]||(this._labelIdx[e.labelType]=[],this._labelCache[e.labelType]=[]),-1===this._labelIdx[e.labelType].indexOf(r)&&(this._labelCache[e.labelType].push({name:t,radius:e.radius,minZoom:e.minZoom,maxZoom:e.maxZoom||24,position:i}),this._labelIdx[e.labelType].push(r))},Bf.prototype.getNearestLabel=function(t,e,i){var r=null,n=this._labelCache[t];if(n)for(var o,a=1/0,s=0,l=n.length;s<l;s++)i>=n[s].minZoom&&i<=n[s].maxZoom&&(o=wr(n[s].position,e))<=n[s].radius&&o<=a&&(a=o,r=n[s]);return r},Bf.prototype._preloadCache=function(t){if(!this._preloadedCache.has(t)){this._preloadedCache.add(t);var e={source:["Ocean label","Ocean name"],labelType:"water",minZoom:0,radius:395e4,polygonSources:["Ocean","Ocean or sea"]},i=t,r=i.indexOf("-");switch(i=-1!==r?i.substr(0,r):i){case"fr":this.cache("OcÃ©an Pacifique",e,[-170,32],t),this.cache("OcÃ©an Pacifique",e,[-138,-27],t),this.cache("OcÃ©an Atlantique",e,[-40,32],t),this.cache("OcÃ©an Atlantique",e,[-17,-29],t);break;case"es":this.cache("OcÃ©an Pacifique",e,[-170,32],t),this.cache("OcÃ©an Pacifique",e,[-138,-27],t),this.cache("OcÃ©ano AtlÃ¡ntico",e,[-40,32],t),this.cache("OcÃ©ano AtlÃ¡ntico",e,[-17,-29],t);break;case"pt":this.cache("Oceano PacÃ­fico",e,[-170,32],t),this.cache("Oceano PacÃ­fico",e,[-138,-27],t),this.cache("Oceano AtlÃ¢ntico",e,[-40,32],t),this.cache("Oceano AtlÃ¢ntico",e,[-17,-29],t);break;case"ja":this.cache("å¤ªå¹³æ´‹",e,[-170,32],t),this.cache("å¤ªå¹³æ´‹",e,[-138,-27],t);break;case"en":this.cache("Pacific Ocean",e,[-170,32],t),this.cache("Pacific Ocean",e,[-138,-27],t),this.cache("Atlantic Ocean",e,[-40,32],t),this.cache("Atlantic Ocean",e,[-17,-29],t),this.cache("Indian Ocean",e,[77,-26],t)}}},Bf);function Bf(){this._labelCache={},this._labelIdx={},this._preloadedCache=new Set}var Ff=(Uf.prototype.dispose=function(){this._disposed=!0,this._map._getMap().off("move",this._onMove),this._map._getMap().off("moveend",this._onMoveEnd),this._map._getMap().off("styledata",this._onStyleData),this._map._getMap().off("rotate",this._onRotate),this._map.getCanvas().removeEventListener("mousedown",this._onPointerDown),this._map.getCanvas().removeEventListener("touchstart",this._onPointerDown),this._map.getMapContainer().removeEventListener("keydown",this._shortcutListener)},Uf.prototype._getEventPos=function(t){if("touches"in t){var e=t.touches[0],i=t.target.getBoundingClientRect();return[e.pageX-i.left,e.pageY-i.top]}return[t.offsetX,t.offsetY]},Uf.prototype._checkThresholds=function(t,e){return this._checkZoomThreshold(t.zoom,e.zoom)||this._checkPitchThreshold(t.pitch,e.pitch)||this._checkLocThreshold(t.center,e.center)||this._checkHeadingThreshold(t.bearing,e.bearing)},Uf.prototype._checkZoomThreshold=function(t,e){return this._round(t)!==this._round(e)},Uf.prototype._checkPitchThreshold=function(t,e){return Math.abs(t-e)>=this._pitchThreshold},Uf.prototype._checkLocThreshold=function(t,e){return t=(e=I(this._map.positionsToPixels([e,t]),2))[0],e=e[1],Gi.getDistance(t,e)>=this._moveThreshold},Uf.prototype._checkHeadingThreshold=function(t,e){return t<0&&(t+=360),e<0&&(e+=360),(e=180<(e=Math.abs(t-e))?360-e:e)>=this._headingThreshold},Uf.prototype._getLocDesc=function(t,e,i){return T(this,void 0,void 0,function(){var r,n,o,a,s,l,u,c,p,h=this;return C(this,function(d){switch(d.label){case 0:return"blank"===i?[3,3]:this._map._getMap().loaded()?[3,2]:[4,new Promise(function(t){return h._map._getMap().once("idle",t)})];case 1:d.sent(),d.label=2;case 2:for(r={},n=this._map.positionsToPixels([t.center])[0],Of.tryCatch(this._map,function(){o=h._map._getMap().queryRenderedFeatures(n,{layers:h._polygonStyleLayer,filter:["==",["geometry-type"],"Polygon"]})},function(){}),a=null,o&&0<o.length&&(a=o[0]),s=null,l=0,u=this._lableConfig.length;l<u;l++)c=this._lableConfig[l],t.zoom>=c.minZoom?c.polygonSources?a&&-1!==c.polygonSources.indexOf(a.layer["source-layer"])?(s=c.labelType,this._getClosestLabel(c,t,e,r,!1)):this._getClosestLabel(c,t,e,r,!0):this._getClosestLabel(c,t,e,r,!1):this._getClosestLabel(c,t,e,r,!0);return 8<=t.zoom&&this._processRoads(r,t,e),this._labelCache.forEach(function(e){r[e]||(p=null,(p="water"!==e&&"majorPoi"!==e||e===s?Uf._labelCache.getNearestLabel(e,t.center,t.zoom):p)&&(r[e]=p.name))}),[2,this._processLocInfo(t,s,r,!0,this._restFallback)];case 3:return[2,this._processLocInfo(t,null,null,!1,!1)]}})})},Uf.prototype._getHeadingDesc=function(t){var e=t.bearing;switch(e<0&&(e+=360),e=this._round(e,this._headingThreshold)){case 0:case 360:return"north";case 45:return"north east";case 90:return"east";case 135:return"south east";case 180:return"south";case 225:return"south west";case 270:return"west";case 315:return"north west";default:return e+" degrees"}},Uf.prototype._getClosestLabel=function(t,e,i,r,n){for(var o=t.radius,a=0,s=t.source.length;a<s;a++){var l={sourceLayer:t.source[a]},u=this._map._getMap().querySourceFeatures(this._baseVectorTileSourceId,l),c=null,p=1/0,h=this._labelCache.has(t.labelType);if(!n||h)for(var d=0,f=u.length;d<f;d++){var m,y="Point"===u[d].geometry.type?u[d]:Gr(e.center,u[d].geometry);n||(m="Point"===u[d].geometry.type?wr(e.center,y.geometry.coordinates):y.properties.distance)<p&&(p=m,c=u[d]),h&&Uf._labelCache.cache(u[d].properties.name,t,y.geometry.coordinates,i)}n||(l=t.labelType+"Dis",c&&p<=o&&("number"!=typeof r[l]||p<=r[l])&&(r[t.labelType]=c.properties.name,r[l]=p))}},Uf.prototype._processRoads=function(t,e,i,r){var n=this._map._getMap().queryRenderedFeatures(r,{filter:["==",["geometry-type"],"LineString"]});if(n){for(var o,a=void 0,s=void 0,l=void 0,u=void 0,c=0,p=n.length;c<p;c++)this._roadLayers.has(n[c].layer["source-layer"])&&n[c].properties.name&&""!==n[c].properties.name&&(o=Gr(e.center,n[c]),(!l||o.properties.distance<l.properties.distance)&&(a&&n[c].properties.name===a.properties.name?l=o:a&&n[c].properties.name===a.properties.name?(!u||o.properties.distance<u.properties.distance)&&(u=o,s=n[c]):(u=l,s=a,l=o,a=n[c])));a&&(t.country||(t.country=a.properties.country_code,t.countryDis=0,Uf._labelCache.cache(t.country,{source:["Country name"],labelType:"country",radius:5e3,minZoom:0},l.geometry.coordinates,i)),t.state||(t.state=a.properties.country_subdivision,t.stateDis=0,Uf._labelCache.cache(t.state,{source:["State name"],labelType:"state",radius:5e3,minZoom:4},l.geometry.coordinates,i)),15<=e.zoom&&(r=this._map.positionsToPixels([e.center,l.geometry.coordinates]),(Gi.getDistance(r[0],r[1])<this._roadPixelRadius||l.properties.distance<this._minRoadDistance)&&(t.road=a.properties.name),s&&(i=this._map.positionsToPixels([u.geometry.coordinates]),(Gi.getDistance(r[0],i[0])<this._minIntersectionPixelDistance||u.properties.distance<this._minRoadDistance)&&(t.secondRoad=s.properties.name,t.secondRoadDis=u.properties.distance))))}},Uf.prototype._getActionDesc=function(t){if(this._lastCam){var e,i,r=[];return this._checkLocThreshold(t.center,this._lastCam.center)&&(i=["panned"],0===(e=Math.round(Tr(this._lastCam.center,t.center)))||360===e?i.push("north"):e<90?i.push("north east"):90===e?i.push("east"):e<180?i.push("south east"):180===e?i.push("south"):e<270?i.push("south west"):270===e?i.push("west"):e<360&&i.push("north west"),e=wr(this._lastCam.center,t.center,Qi.meters),i.push(1e3<e?_r(e/1e3,2)+" kilometers":_r(e,2)+" meters"),r.push(i.join(" "))),this._checkZoomThreshold(t.zoom,this._lastCam.zoom)&&((i=["zoomed"]).push(this._lastCam.zoom<t.zoom?"in":"out"),1<=(e=Math.abs(this._lastCam.zoom-t.zoom))&&(e=Math.ceil(e),i.push(1<e?e+" levels":e+" level")),this._getCanonicalZoom(this._lastCam.zoom)!==this._getCanonicalZoom(t.zoom)&&i.push("to "+this._getCanonicalZoom(t.zoom)+" level"),r.push(i.join(" "))),this._checkPitchThreshold(t.pitch,this._lastCam.pitch)&&(i=this._round(t.pitch,this._pitchThreshold),r.push("pitched to "+i+" degrees"),60!==t.pitch&&0!==t.pitch||(i=60===t.pitch?"maximum":"minimum",r.push("reached "+i+" of "+t.pitch+" degrees"))),this._checkHeadingThreshold(this._lastCam.bearing,t.bearing)&&r.push("rotated to "+this._getHeadingDesc(t)),r.join(" and ")||null}return null},Uf.prototype._getCanonicalZoom=function(t){return(t=this._round(t))<2?"world":t<5?"country":t<11?"state province":t<15?"city":"street"},Uf.prototype._processLocInfo=function(t,e,i,r,n){var o=this;return new Promise(function(a,s){var l=[];if(r){var u=[];if(i&&(e&&("water"===e&&i.water?u.push(i.water):"majorPoi"===e&&i.majorPoi&&u.push(i.majorPoi)),0===u.length&&(i.majorPoi&&8<=t.zoom?u.push(i.majorPoi):(i.poi&&14<=t.zoom?u.push(i.poi):i.road&&15<=t.zoom&&(i.secondRoad?u.push(i.road+" & "+i.secondRoad):u.push(i.road)),i.neighbourhood&&12<=t.zoom&&u.push(i.neighbourhood),i.city&&6<=t.zoom&&u.push(i.city)),i.state&&4<=t.zoom&&u.push(i.state),0===u.length?i.water?u.push(i.water):i.country&&u.push(i.country):1===u.length&&i.state&&4<=t.zoom&&i.country&&u.push(i.country))),0<u.length)l.push("<p>Location: ",u.join(", "),".</p>");else if(n&&"water"!==e)return void o._reverseGeocodeDescription(t).then(function(t){a(t)},function(){s("<p>Location: unknown</p>")})}o._returnDetailedDescriptions&&(l.push("<p>Zoom: ",_r(t.zoom,2),".</p>"),l.push("<p>Latitude: ",_r(t.center[1],5),".</p>"),l.push("<p>Longitude: ",_r(t.center[0],5),".</p>")),a(l.join(""))})},Uf.prototype._reverseGeocodeDescription=function(t){var e=this;return new Promise(function(i){var r=e._map.getStyle();e._reverseSearch.request({position:t.center,style:r}).then(function(n){var o={};n&&n.addresses&&0<n.addresses.length&&n.addresses[0].address&&((n=n.addresses[0].address).country&&(o.country=n.country,Uf._labelCache.cache(o.country,{source:["Country name"],labelType:"country",radius:5e3,minZoom:0},t.center,r.language)),n.countrySubdivision&&(o.state=n.countrySubdivision,Uf._labelCache.cache(o.state,{source:["State name"],labelType:"state",radius:5e3,minZoom:4},t.center,r.language)),n.municipality&&(o.city=n.municipality,Uf._labelCache.cache(o.state,{source:["Small city"],labelType:"city",radius:1e3,minZoom:10},t.center,r.language)),n.streetNameAndNumber?o.road=n.streetNameAndNumber:n.street&&(o.road=n.street)),e._processLocInfo(t,null,o,!0,!1).then(function(t){i(t)})},function(r){e._processLocInfo(t,null,null,!0,!1).then(function(t){i(t)})}).catch(function(r){e._processLocInfo(t,null,null,!0,!1).then(function(t){i(t)})})})},Uf.prototype._round=function(t,e){return void 0===e&&(e=1),Math.round(t/e)*e},Uf);function Uf(t,e){var i=this;this._disposed=!1,this._lastHeadingTime=0,this._actionQueue=[],this._pointerUpdateDelay=3e3,this._camUpdateDelay=1e3,this._headUpdateLimit=1e3,this._controlEventDelay=500,this._moveThreshold=25,this._headingThreshold=5,this._pitchThreshold=5,this._roadPixelRadius=120,this._minRoadDistance=25,this._minIntersectionPixelDistance=50,this._baseVectorTileSourceId="vectorTiles",this._lableConfig=[{source:["Ocean label","Ocean name"],labelType:"water",minZoom:0,radius:395e4,polygonSources:["Ocean","Ocean or sea"]},{source:["Sea label"],labelType:"water",minZoom:3,radius:1e6,polygonSources:["Sea","Ocean or sea"]},{source:["Country name"],labelType:"country",minZoom:0,maxZoom:5,radius:3e5},{source:["State name","State name short"],labelType:"state",minZoom:4,maxZoom:7,radius:3e5},{source:["Capital city","Large city"],labelType:"city",minZoom:8,radius:4e4},{source:["Medium city"],labelType:"city",minZoom:8,radius:3e4},{source:["Small city"],labelType:"city",minZoom:8,radius:2e4},{source:["Island label"],labelType:"city",minZoom:8,radius:1e4},{source:["Town"],labelType:"city",minZoom:10,radius:1e4},{source:["Village"],labelType:"neighbourhood",minZoom:12,radius:6e3},{source:["Amusement area label"],labelType:"poi",minZoom:14,radius:2e3,polygonSources:["Amusement park"]},{source:["Hospital label"],labelType:"poi",minZoom:14,radius:1e3,polygonSources:["Hospital"]},{source:["Shopping centre label"],labelType:"poi",minZoom:14,radius:1e3,polygonSources:["Shopping"]},{source:["Stadium label"],labelType:"poi",minZoom:14,radius:1e3,polygonSources:["Stadium"]},{source:["University/School label"],labelType:"poi",minZoom:14,radius:1e3,polygonSources:["University"]},{source:["Zoo label"],labelType:"poi",minZoom:14,radius:1e3,polygonSources:["Zoo"]},{source:["Airport Label","Airport name","Airport POI"],labelType:"majorPoi",minZoom:11,radius:3e3,polygonSources:["Airport","Runway"]},{source:["National park label"],labelType:"majorPoi",minZoom:7,radius:15e3,polygonSources:["National or state park","National park","Forest"]},{source:["Reservation label"],labelType:"majorPoi",minZoom:7,radius:15e3,polygonSources:["Reservation"]}],this._polygonStyleLayer=["National or state park","National park","Reservation","Airport","Runway","Stadium","University","Zoo","Shopping","Hospital","Amusement park","Ocean","Sea","Ocean or sea"],this._labelCache=new Set(["city","state","country","water","majorPoi"]),this._roadLayers=new Set(["Connecting road","Connecting road tunnel","International road","International road tunnel","Local road","Local road tunnel","Major local road","Major local road tunnel","Major road","Major road tunnel","Minor local road","Minor local road tunnel","Motorway","Motorway tunnel","Secondary road","Secondary road tunnel","Toll connecting road","Toll connecting road tunnel","Toll international road","Toll international road tunnel","Toll local road","Toll local road tunnel","Toll major local road","Toll major local road tunnel","Toll major road","Toll major road tunnel","Toll minor local road","Toll minor local road tunnel","Toll motorway","Toll motorway tunnel","Toll secondary road","Toll secondary road tunnel"]),this._returnDetailedDescriptions=!1,this._shortcutListener=function(t){return T(i,void 0,void 0,function(){var e,i,r;return C(this,function(n){switch(n.label){case 0:return t.altKey&&t.ctrlKey&&68===t.keyCode?(this._returnDetailedDescriptions=!this._returnDetailedDescriptions,e=this._map.getCamera(),r=this._map.getStyle(),i=r.language.toLowerCase(),r=r.style.toLowerCase(),[4,this._getLocDesc(e,i,r)]):[3,2];case 1:r=n.sent(),this._descCallback(r),n.label=2;case 2:return[2]}})})},this._onRotate=function(){i._rotateTimeout||(Date.now()-i._lastHeadingTime>=i._headUpdateLimit?i._rotateTimeout=setTimeout(i._updateHeading,et.RotationDuration+25):i._rotateTimeout=setTimeout(i._updateHeading,i._headUpdateLimit-(Date.now()-i._lastHeadingTime)))},this._onMove=function(){i._moveTimeout&&(clearTimeout(i._moveTimeout),delete i._moveTimeout),i._controlTimeout&&(clearTimeout(i._controlTimeout),delete i._controlTimeout)},this._onMoveEnd=function(t){t.fromControl?i._controlTimeout=setTimeout(i._updateCam,i._controlEventDelay):i._updateCam()},this._onStyleData=function(){setTimeout(i._updateStyle)},this._onPointerDown=function(t){i._lastPointerPos=i._getEventPos(t),i._pointerTimeout=setTimeout(function(){return T(i,void 0,void 0,function(){var t,e,i;return C(this,function(r){switch(r.label){case 0:return e=this._map.getStyle(),t=e.language.toLowerCase(),i=e.style.toLowerCase(),(e=this._map.getCamera()).center=this._map.pixelsToPositions([this._lastPointerPos])[0],[4,this._getLocDesc(e,t,i)];case 1:return i=r.sent(),this._descCallback(i),this._onPointerUp(),[2]}})})},i._pointerUpdateDelay),i._map.getCanvas().addEventListener("mousemove",i._onPointerMove),i._map.getCanvas().addEventListener("touchmove",i._onPointerMove),i._map.getCanvas().addEventListener("mouseup",i._onPointerUp),i._map.getCanvas().addEventListener("touchend",i._onPointerUp)},this._onPointerMove=function(t){var e=i._getEventPos(t);t=i._lastPointerPos[0]-e[0],e=i._lastPointerPos[1]-e[1];Math.sqrt(t*t+e*e)>i._moveThreshold&&i._onPointerUp()},this._onPointerUp=function(){clearTimeout(i._pointerTimeout),delete i._pointerTimeout,i._map.getCanvas().removeEventListener("mousemove",i._onPointerMove),i._map.getCanvas().removeEventListener("touchmove",i._onPointerMove),i._map.getCanvas().removeEventListener("mouseup",i._onPointerUp),i._map.getCanvas().removeEventListener("touchend",i._onPointerUp)},this._updateHeading=function(){var t,e=i._map.getCamera();i._lastHead&&!i._checkHeadingThreshold(e.bearing,i._lastHead)||(t=i._getHeadingDesc(e),i._lastHead=e.bearing,i._descCallback("<p>Map heading "+t+".</p>"),i._lastHeadingTime=Date.now()),delete i._rotateTimeout},this._updateStyle=function(){return T(i,void 0,void 0,function(){var t,e,i,r;return C(this,function(n){switch(n.label){case 0:return t=this._map.getCamera(),i=this._map.getStyle(),e=i.language.toLowerCase(),i=i.style.toLowerCase(),this._lastLang===e?[3,2]:(Uf._labelCache._preloadCache(e),[4,this._getLocDesc(t,e,i)]);case 1:return r=n.sent(),[3,4];case 2:return this._lastStyle===i||"blank"!==this._lastStyle?[3,4]:[4,this._getLocDesc(t,e,i)];case 3:r=n.sent(),n.label=4;case 4:return this._lastLang=e,this._lastStyle=i,r&&this._descCallback(r),[2]}})})},this._updateCam=function(t){void 0===t&&(t=!1);var e,r,n,o=i._map.getCamera();(!i._lastCam||0<i._actionQueue.length||i._checkThresholds(o,i._lastCam))&&(n=i._map.getStyle(),e=n.language.toLowerCase(),r=n.style.toLowerCase(),(n=i._getActionDesc(o))&&i._actionQueue.push(n),i._lastCam=o,i._moveTimeout&&(clearTimeout(i._moveTimeout),delete i._moveTimeout),i._moveTimeout=setTimeout(function(){return T(i,void 0,void 0,function(){var t;return C(this,function(i){switch(i.label){case 0:return clearTimeout(this._rotateTimeout),delete this._rotateTimeout,[4,this._getLocDesc(o,e,r)];case 1:return t=i.sent(),0<this._actionQueue.length?(this._descCallback("<p>Map "+this._actionQueue.join(", then ")+".</p>"+t),this._actionQueue=[]):this._descCallback(t),[2]}})})},t?0:i._camUpdateDelay))},this._map=t,this._restFallback=t.getServiceOptions().enableAccessibilityLocationFallback,this._descCallback=e,this._reverseSearch=new zf(t),Uf._labelCache||(Uf._labelCache=new Nf),this._lastLang=this._map.getStyle().language.toLowerCase(),Uf._labelCache._preloadCache(this._lastLang),this._map.events.addOnce("load",function(){i._disposed||(i._updateCam(!0),i._map._getMap().on("move",i._onMove),i._map._getMap().on("moveend",i._onMoveEnd),i._map._getMap().on("styledata",i._onStyleData),i._map._getMap().on("rotate",i._onRotate),i._map.getCanvas().addEventListener("mousedown",i._onPointerDown),i._map.getCanvas().addEventListener("touchstart",i._onPointerDown))}),this._map.getMapContainer().addEventListener("keydown",this._shortcutListener)}var jf,Vf,qf=function(t){var e=this;this.addToMap=function(){e.initializeMapLiveStateInfo(),e.initializeMapStyleInfo(),e.createMapKeyBindingInfo(),e.map.getMapContainer().setAttribute("role","application"),e.map.getMapContainer().setAttribute("aria-label","Map Application"),e.map.getCanvas().setAttribute("aria-label","Interactive Map"),e.map.getCanvas().setAttribute("aria-describedby","atlas-map-state atlas-map-style atlas-map-shortcuts"),e.map.getCanvas().setAttribute("alt","Interactive Map")},this.removeFromMap=function(){null!=e.mapViewDesc&&e.mapViewDesc.dispose(),delete e.mapViewDesc,null!=e.atlasMapKeyBindings&&e.map.getCanvasContainer().removeChild(e.atlasMapKeyBindings),delete e.atlasMapKeyBindings,null!=e.atlasMapLiveStateInfo&&e.map.getCanvasContainer().removeChild(e.atlasMapLiveStateInfo),delete e.atlasMapLiveStateInfo,null!=e.atlasMapStyleInfo&&e.map.getCanvasContainer().removeChild(e.atlasMapStyleInfo),delete e.atlasMapStyleInfo,e.map.getMapContainer().removeAttribute("role"),e.map.getMapContainer().removeAttribute("aria-label"),e.map.getCanvas().removeAttribute("aria-label"),e.map.getCanvas().removeAttribute("aria-describedby"),e.map.getCanvas().removeAttribute("alt"),e.map.events.remove("styledata",e.updateMapStyle)},this.createMapKeyBindingInfo=function(){e.atlasMapKeyBindings=document.createElement("div"),e.atlasMapKeyBindings.setAttribute("tabindex","-1"),e.atlasMapKeyBindings.setAttribute("aria-hidden","true"),e.atlasMapKeyBindings.id="atlas-map-shortcuts",e.atlasMapKeyBindings.classList.add("hidden-accessible-element"),e.atlasMapKeyBindings.innerHTML=["Map shortcuts:","Zoom out: hyphen.","Zoom in: plus.","Pan right 100 pixels: right arrow.","Pan left 100 pixels: left arrow.","Pan up 100 pixels: up arrow.","Pan down 100 pixels: down arrow.","Rotate 15 degrees clockwise: shift + right arrow.","Rotate 15 degrees counter clockwise: shift + left arrow.","Increase pitch 10 degrees: shift + up arrow.","Decrease pitch 10 degrees: shift + down arrow.","Toggle verbose map state: control + alt + D.","Jump focus to the map: Escape."].join("\n"),e.map.getCanvasContainer().appendChild(e.atlasMapKeyBindings),e.atlasMapKeyBindings.setAttribute("aria-live","polite")},this.initializeMapLiveStateInfo=function(){e.mapViewDesc=new Ff(e.map,e.updateMapState),e.atlasMapLiveStateInfo=document.createElement("div"),e.atlasMapLiveStateInfo.setAttribute("tabindex","-1"),e.atlasMapLiveStateInfo.setAttribute("aria-hidden","true"),e.atlasMapLiveStateInfo.id="atlas-map-state",e.atlasMapLiveStateInfo.classList.add("hidden-accessible-element"),e.map.getCanvasContainer().appendChild(e.atlasMapLiveStateInfo),e.atlasMapLiveStateInfo.setAttribute("aria-live","polite")},this.initializeMapStyleInfo=function(){e.atlasMapStyleInfo=document.createElement("div"),e.atlasMapStyleInfo.setAttribute("tabindex","-1"),e.atlasMapStyleInfo.setAttribute("aria-hidden","true"),e.atlasMapStyleInfo.id="atlas-map-style",e.atlasMapStyleInfo.classList.add("hidden-accessible-element"),e.updateMapStyle(),e.map.events.add("styledata",e.updateMapStyle),e.map.getCanvasContainer().appendChild(e.atlasMapStyleInfo),e.atlasMapStyleInfo.setAttribute("aria-live","polite")},this.updateMapStyle=function(){e.atlasMapStyleInfo.innerHTML="<p>Map style: "+e.map.getStyle().style+".</p>"},this.updateMapState=function(t){e.atlasMapLiveStateInfo.innerHTML=t},this.map=t},Hf=function(t){var e=this;this.listenerEnabled=!1,this.lastFlowMode="none",this.addToMap=function(){if(!e.map._isReady())throw new Error("Traffic flow could not be added to the map because the map is not ready. Please use a ready event listener to guarantee the map is ready before enabling traffic flow.");e.listenerEnabled||(e.map.events.add("styledata",e.addToMap),e.listenerEnabled=!0);var t,i=e.map.getTraffic();"none"===i.flow||(t=e.map.layers.getLayerById("traffic_"+i.flow))&&(e.lastFlowMode=i.flow,t._updateLayoutProperty("visibility","visible","none"))},this.removeFromMap=function(){var t;e.map.getTraffic(),"none"!=e.lastFlowMode&&((t=e.map.layers.getLayerById("traffic_"+e.lastFlowMode))&&t._updateLayoutProperty("visibility","none","visible"),e.lastFlowMode="none"),e.listenerEnabled&&(e.map.events.remove("styledata",e.addToMap),e.listenerEnabled=!1)},this.map=t},Gf=(w(Zf,jf=Vi),Zf.getIncidentTypeName=function(t,e){switch(t){case 0:return e.Unknown;case 1:return e.Accident;case 2:return e.Fog;case 3:return e.Danger;case 4:return e.Rain;case 5:return e.Ice;case 6:return e.Jam;case 7:return e.LaneClosed;case 8:return e.RoadClosed;case 9:return e.RoadWorks;case 10:return e.Wind;case 11:return e.Flood;case 12:return e.Detour;default:return e.Unknown}},Zf.getIncidentTypeIconName=function(t){switch(t){case 0:return"unknown";case 1:return"accident";case 2:return"fog";case 3:return"danger";case 4:return"rain";case 5:return"ice";case 6:return"jam";case 7:return"lane-closed";case 8:return"road-closed";case 9:return"road-work";case 10:return"wind";case 11:return"flood";case 12:return"detour";default:return"unknown"}},Zf.getSeverityColorName=function(t){switch(t){case 0:return"grey";case 1:return"yellow";case 2:return"orange";case 3:return"red";default:return"grey"}},Zf.getSeverityColorHexCode=function(t){switch(t){case 0:return"#B5B6B7";case 1:return"#F4C951";case 2:return"#F4873F";case 3:return"#F04F4E";default:return"#B5B6B7"}},Zf);function Zf(t,e,i){var r=null!==(n=null!==(r=null!==(n=null!==(r=null!==(n=null!==(r=null!==(n=null!==(r=null!==(n=null!==(r=null!==(n=null!==(r=null!==(n=t.icon_category_12)&&void 0!==n?n:t.icon_category_11)&&void 0!==r?r:t.icon_category_10)&&void 0!==n?n:t.icon_category_9)&&void 0!==r?r:t.icon_category_8)&&void 0!==n?n:t.icon_category_7)&&void 0!==r?r:t.icon_category_6)&&void 0!==n?n:t.icon_category_5)&&void 0!==r?r:t.icon_category_4)&&void 0!==n?n:t.icon_category_3)&&void 0!==r?r:t.icon_category_2)&&void 0!==n?n:t.icon_category_1)&&void 0!==r?r:t.icon_category_0)&&void 0!==n?n:t.icon_category,n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=null!==(n=t.description_12)&&void 0!==n?n:t.description_11)&&void 0!==n?n:t.description_10)&&void 0!==n?n:t.description_9)&&void 0!==n?n:t.description_8)&&void 0!==n?n:t.description_7)&&void 0!==n?n:t.description_6)&&void 0!==n?n:t.description_5)&&void 0!==n?n:t.description_4)&&void 0!==n?n:t.description_3)&&void 0!==n?n:t.description_2)&&void 0!==n?n:t.description_1)&&void 0!==n?n:t.description_0)&&void 0!==n?n:t.description;t={icon:Zf.getSeverityColorName(t.magnitude)+"-"+Zf.getIncidentTypeIconName(r),incidentType:Zf.getIncidentTypeName(r,i),description:n,delay:t.delay,color:Zf.getSeverityColorHexCode(t.magnitude),id:t.id};return jf.call(this,e,t)||this}(ft=Vf=Vf||{}).DELAY="delay",ft.LENGTH="length",ft.FROM="from",ft.TO="to";var Wf=(Kf.build=function(t,e){void 0===e&&(e="en-US");var i=document.createElement("div");i.classList.add("incident-popup-title"),i.classList.add("font-segoeui-b"),i.setAttribute("tabindex","0"),i.innerText=t.properties.incidentType,i.setAttribute("aria-label","Incident Type "+t.properties.incidentType),(a=document.createElement("div")).classList.add("incident-popup-subtitle"),a.classList.add("font-segoeui-b"),a.setAttribute("aria-label","Incident Description "+t.properties.description),a.setAttribute("tabindex","0"),a.innerText=t.properties.description;var r,n,o,a,s=document.createElement("div");s.classList.add("incident-popup-header"),s.style.backgroundColor=t.properties.color,s.appendChild(i),s.appendChild(a),(a=document.createElement("div")).classList.add("incident-popup-body"),t.properties.delay&&(r=Math.floor(t.properties.delay/60)+" min",r=this.createInfoSection(r,Vf.DELAY),a.appendChild(r)),t.properties.length&&(r=new Intl.NumberFormat([e,"en-US"],{maximumFractionDigits:2}),o=void 0,o="en-US"===e?(n=xr(t.properties.length,"meters","miles"),r.format(n)+" miles"):(n=xr(t.properties.length,"meters","kilometers"),r.format(n)+" km"),o=this.createInfoSection(o,Vf.LENGTH),a.appendChild(o)),t.properties.from&&(o=this.createInfoSection(t.properties.from,Vf.FROM),a.appendChild(o)),t.properties.to&&(l=this.createInfoSection(t.properties.to,Vf.TO),a.appendChild(l));var l=document.createElement("div");return l.classList.add("incident-popup-content"),l.appendChild(s),l.appendChild(a),new $o({content:l,position:t.geometry.coordinates})},Kf.createInfoSection=function(t,e){var i=document.createElement("div");i.classList.add("incident-popup-info");var r=document.createElement("div");r.classList.add("icon"),r.classList.add(e);var n=document.createElement("span");return n.classList.add("message"),n.classList.add("font-segoeui"),n.setAttribute("aria-label","Incident "+e+" "+t),n.setAttribute("tabindex","0"),n.innerText=t,i.appendChild(r),i.appendChild(n),i},Kf);function Kf(){}var Xf=(Yf.prototype.getIncidentIconImageExpression=function(){return["concat",["let","magnitude",["get","magnitude"],["case",["==",["var","magnitude"],0],"grey",["==",["var","magnitude"],1],"yellow",["==",["var","magnitude"],2],"orange",["==",["var","magnitude"],3],"red",["==",["var","magnitude"],4],"grey","grey"]],"-",["let","category",["coalesce",["get","icon_category_12"],["get","icon_category_11"],["get","icon_category_10"],["get","icon_category_9"],["get","icon_category_8"],["get","icon_category_7"],["get","icon_category_6"],["get","icon_category_5"],["get","icon_category_4"],["get","icon_category_3"],["get","icon_category_2"],["get","icon_category_0"],["get","icon_category"],0],["case",["==",["var","category"],0],"unknown",["==",["var","category"],1],"accident",["==",["var","category"],2],"fog",["==",["var","category"],3],"danger",["==",["var","category"],4],"rain",["==",["var","category"],5],"ice",["==",["var","category"],6],"jam",["==",["var","category"],7],"lane-closed",["==",["var","category"],8],"road-closed",["==",["var","category"],9],"road-work",["==",["var","category"],10],"wind",["==",["var","category"],11],"flood",["==",["var","category"],12],"detour","unknown"]]]},Yf);function Yf(t){var e=this;this.incidentLayerName="incidents",this.incidentSourceName="mapcontrol_traffic_incident",this.addToMap=function(){e.map.sources.getById(e.incidentSourceName)||e.map.sources.add(e.vectorTileSource),e.map.layers.getLayerById(e.incidentLayerName)||e.map.layers.add(e.incidentLayer,"labels"),e.popup=new $o({position:[0,0],pixelOffset:[0,-18]}),e.map.addEventListener("mouseover",e.incidentLayerName,e.cursorToPointer),e.map.addEventListener("mouseleave",e.incidentLayerName,e.cursorToDefault),e.map.addEventListener("click",e.incidentLayerName,e.openIncidentPopup)},this.removeFromMap=function(){null!=e.map.layers.getLayerById(e.incidentLayerName)&&e.map.layers.remove(e.incidentLayerName),null!=e.map.sources.getById(e.incidentSourceName)&&e.map.sources.remove(e.incidentSourceName)},this.cursorToPointer=function(t){e.map.getCanvas().style.cursor="pointer"},this.cursorToDefault=function(t){e.map.getCanvas().style.cursor=""},this.openIncidentPopup=function(t){e.popup.remove();var i=t.position,r=t.features[0];e.map._getLocalizedStrings().then(function(t){var n=new Wi(new Wr(i[0],i[1]));t=new Gf(r.properties,n,t);e.popup=Wf.build(t,e.incidentLanguage),e.popup.open(e.map)})},this.map=t,this.vectorTileSource=new Ln(this.incidentSourceName,{maxZoom:22,tiles:["https://"+h+"/traffic/incident/tile/pbf?api-version=1.0&zoom={z}&x={x}&y={y}"]}),t=this.getIncidentIconImageExpression(),this.incidentLayer=new Ro(this.incidentSourceName,this.incidentLayerName,{sourceLayer:"Traffic incident POI",iconOptions:{ignorePlacement:!0,allowOverlap:!0,image:t,size:.75}})}var Jf,Qf=(w($f,Jf=A),$f);function $f(){var t=null!==Jf&&Jf.apply(this,arguments)||this;return t.interactive=!0,t.scrollZoomInteraction=!0,t.boxZoomInteraction=!0,t.dragRotateInteraction=!0,t.dragPanInteraction=!0,t.keyboardInteraction=!0,t.dblClickZoomInteraction=!0,t.touchInteraction=!0,t.wheelZoomRate=1/450,t}var tm=(em.prototype.enable=function(){this.map.getMapContainer().addEventListener("keydown",this._onKeyDown)},em.prototype.disable=function(){this.map.getMapContainer().removeEventListener("keydown",this._onKeyDown)},em);function em(t){var e=this;this._onKeyDown=function(t){27===t.keyCode&&e.map.getCanvas().focus()},this.map=t}var im=(rm.prototype.enable=function(){this.map._getMap().on("touchstart",this._onTouchStart),this.map._getMap().on("touchmove",this._onTouchMove),this.map._getMap().on("touchend",this._onTouchEnd),this.map._getMap().on("touchcancel",this._onTouchCancel)},rm.prototype.disable=function(){this.map._getMap().off("touchstart",this._onTouchStart),this.map._getMap().off("touchmove",this._onTouchMove),this.map._getMap().off("touchend",this._onTouchEnd),this.map._getMap().off("touchcancel",this._onTouchCancel)},rm);function rm(t){var e=this;this.minDiffX=70,this.maxDiffY=100,this.minDiff=30,this.delay=160,this._onTouchStart=function(t){var i,r;2===t.points.length&&(i=t.points[0].y-t.points[1].y,r=t.points[0].x-t.points[1].x,Math.abs(r)>=e.minDiffX&&Math.abs(i)<=e.maxDiffY&&(t.originalEvent.preventDefault(),e.map._getMap().touchZoomRotate.disable(),e.map._getMap().dragPan.disable(),e.dpPoint=t.point,e.dpPitch=e.map._getMap().getPitch(),e.startTiming=Date.now(),e.startDistance=Math.hypot(r,i),e.startEventData=t))},this._onTouchMove=function(t){if(void 0!==e.dpPoint&&void 0!==e.dpPitch){t.preventDefault(),t.originalEvent.preventDefault();var i=t.points[0].y-t.points[1].y,r=t.points[0].x-t.points[1].x;i=Math.hypot(r,i);if(Math.abs(i-e.startDistance)>=e.minDiff)return e.dpPoint&&(e.map._getMap().touchZoomRotate.enable(),e.map._getMap().dragPan.enable(),e.map._getMap().touchZoomRotate.onStart((Date.now()-e.startTiming>=e.delay?t:e.startEventData).originalEvent)),void(e.dpPoint=void 0);Date.now()-e.startTiming>=e.delay&&(t=.5*(e.dpPoint.y-t.point.y),e.map._getMap().setPitch(e.dpPitch+t))}},this._onTouchEnd=function(){e.dpPoint&&(e.map._getMap().touchZoomRotate.enable(),e.map._getMap().dragPan.enable()),e.dpPoint=void 0},this._onTouchCancel=function(){e.dpPoint&&(e.map._getMap().touchZoomRotate.enable(),e.map._getMap().dragPan.enable()),e.dpPoint=void 0},this.map=t}var nm=(om.prototype.enable=function(){this.map.getCanvasContainer().addEventListener("gesturestart",this._onGestureStart),this.map.getCanvasContainer().addEventListener("gesturechange",this._onGestureChange),this.map.getCanvasContainer().addEventListener("touchstart",this._onTouchStart),this.map.getCanvasContainer().addEventListener("touchend",this._onTouchEnd)},om.prototype.disable=function(){this.map.getCanvasContainer().removeEventListener("gesturestart",this._onGestureStart),this.map.getCanvasContainer().removeEventListener("gesturechange",this._onGestureChange),this.map.getCanvasContainer().removeEventListener("touchstart",this._onTouchStart),this.map.getCanvasContainer().removeEventListener("touchend",this._onTouchEnd)},om);function om(t){var e=this;this._onGestureStart=function(t){e.hasTouch||(t.preventDefault(),e.initZoom=e.map.getCamera().zoom)},this._onGestureChange=function(t){e.hasTouch||(t.preventDefault(),e.map.setCamera({zoom:e.initZoom+t.scale-1}))},this._onTouchStart=function(t){e.hasTouch=!0},this._onTouchEnd=function(t){0===t.touches.length&&(e.hasTouch=!1)},this.map=t}var am=(sm.prototype.addToMap=function(){this.added||(this.added=!0,this._setInteractions(this.options))},sm.prototype.removeFromMap=function(){this.added&&(this.added=!1,this._setInteractions({interactive:!1}))},sm.prototype.setOptions=function(t){this.options=(new Qf).merge(this.options,t),this.added&&this._setInteractions(this.options)},sm.prototype.getOptions=function(){return Object.assign({},this.options)},sm.prototype._setInteractions=function(t){t.interactive?(t.boxZoomInteraction?this.map._getMap().boxZoom.enable():this.map._getMap().boxZoom.disable(),t.dblClickZoomInteraction?this.map._getMap().doubleClickZoom.enable():this.map._getMap().doubleClickZoom.disable(),t.dragPanInteraction?this.map._getMap().dragPan.enable():this.map._getMap().dragPan.disable(),t.dragRotateInteraction?this.map._getMap().dragRotate.enable():this.map._getMap().dragRotate.disable(),t.keyboardInteraction?(this.map._getMap().keyboard.enable(),this.focusShortcut.enable()):(this.map._getMap().keyboard.disable(),this.focusShortcut.disable()),t.scrollZoomInteraction?(this.map._getMap().scrollZoom.enable(),this.map._getMap().scrollZoom.setWheelZoomRate(t.wheelZoomRate)):this.map._getMap().scrollZoom.disable(),t.touchInteraction?(this.map._getMap().touchZoomRotate.enable(),this.mobilePitch.enable()):(this.map._getMap().touchZoomRotate.disable(),this.mobilePitch.disable()),this.pinchZoom.enable()):(this.map._getMap().boxZoom.disable(),this.map._getMap().doubleClickZoom.disable(),this.map._getMap().dragPan.disable(),this.map._getMap().dragRotate.disable(),this.map._getMap().keyboard.disable(),this.focusShortcut.disable(),this.map._getMap().scrollZoom.disable(),this.map._getMap().touchZoomRotate.disable(),this.mobilePitch.disable(),this.pinchZoom.disable())},sm);function sm(t,e){this.added=!1,this.map=t,this.mobilePitch=new im(t),this.focusShortcut=new tm(t),this.pinchZoom=new nm(t),this.options=(new Qf).merge(e)}function lm(t,e,i){var r={type:"Feature"};return 0!==(i=void 0===i?{}:i).id&&!i.id||(r.id=i.id),i.bbox&&(r.bbox=i.bbox),r.properties=e||{},r.geometry=t,r}function um(t){return"Feature"===t.type?t.geometry:t}var cm=i(function(t,e){t.exports=function(){function t(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function e(t,e){for(var i=0;i<e.length;i++){var r=e[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function i(t,i,r){return i&&e(t.prototype,i),r&&e(t,r),t}var r=function(){return function(t,e){this.next=null,this.key=t,this.data=e,this.left=null,this.right=null}}();function n(t,e){return t>e?1:t<e?-1:0}function o(t,e,i){for(var n=new r(null,null),o=n,a=n;;){var s=i(t,e.key);if(s<0){if(null===e.left)break;if(i(t,e.left.key)<0){var l=e.left;if(e.left=l.right,l.right=e,null===(e=l).left)break}a.left=e,a=e,e=e.left}else{if(!(s>0))break;if(null===e.right)break;if(i(t,e.right.key)>0){l=e.right;if(e.right=l.left,l.left=e,null===(e=l).right)break}o.right=e,o=e,e=e.right}}return o.right=e.left,a.left=e.right,e.left=n.right,e.right=n.left,e}function a(t,e,i,n){var a=new r(t,e);if(null===i)return a.left=a.right=null,a;var s=n(t,(i=o(t,i,n)).key);return s<0?(a.left=i.left,a.right=i,i.left=null):s>=0&&(a.right=i.right,a.left=i,i.right=null),a}function s(t,e,i){var r=null,n=null;if(e){var a=i((e=o(t,e,i)).key,t);0===a?(r=e.left,n=e.right):a<0?(n=e.right,e.right=null,r=e):(r=e.left,e.left=null,n=e)}return{left:r,right:n}}var l=function(){function t(t){void 0===t&&(t=n),this._root=null,this._size=0,this._comparator=t}return t.prototype.insert=function(t,e){return this._size++,this._root=a(t,e,this._root,this._comparator)},t.prototype.add=function(t,e){var i=new r(t,e);null===this._root&&(i.left=i.right=null,this._size++,this._root=i);var n=this._comparator,a=o(t,this._root,n),s=n(t,a.key);return 0===s?this._root=a:(s<0?(i.left=a.left,i.right=a,a.left=null):s>0&&(i.right=a.right,i.left=a,a.right=null),this._size++,this._root=i),this._root},t.prototype.remove=function(t){this._root=this._remove(t,this._root,this._comparator)},t.prototype._remove=function(t,e,i){var r;return null===e?null:0===i(t,(e=o(t,e,i)).key)?(null===e.left?r=e.right:(r=o(t,e.left,i)).right=e.right,this._size--,r):e},t.prototype.pop=function(){var t=this._root;if(t){for(;t.left;)t=t.left;return this._root=o(t.key,this._root,this._comparator),this._root=this._remove(t.key,this._root,this._comparator),{key:t.key,data:t.data}}return null},t.prototype.findStatic=function(t){for(var e=this._root,i=this._comparator;e;){var r=i(t,e.key);if(0===r)return e;e=r<0?e.left:e.right}return null},t.prototype.find=function(t){return this._root&&(this._root=o(t,this._root,this._comparator),0!==this._comparator(t,this._root.key))?null:this._root},t.prototype.contains=function(t){for(var e=this._root,i=this._comparator;e;){var r=i(t,e.key);if(0===r)return!0;e=r<0?e.left:e.right}return!1},t.prototype.forEach=function(t,e){for(var i=this._root,r=[],n=!1;!n;)null!==i?(r.push(i),i=i.left):0!==r.length?(i=r.pop(),t.call(e,i),i=i.right):n=!0;return this},t.prototype.range=function(t,e,i,r){for(var n=[],o=this._comparator,a=this._root;0!==n.length||a;)if(a)n.push(a),a=a.left;else{if(o((a=n.pop()).key,e)>0)break;if(o(a.key,t)>=0&&i.call(r,a))return this;a=a.right}return this},t.prototype.keys=function(){var t=[];return this.forEach(function(e){var i=e.key;return t.push(i)}),t},t.prototype.values=function(){var t=[];return this.forEach(function(e){var i=e.data;return t.push(i)}),t},t.prototype.min=function(){return this._root?this.minNode(this._root).key:null},t.prototype.max=function(){return this._root?this.maxNode(this._root).key:null},t.prototype.minNode=function(t){if(void 0===t&&(t=this._root),t)for(;t.left;)t=t.left;return t},t.prototype.maxNode=function(t){if(void 0===t&&(t=this._root),t)for(;t.right;)t=t.right;return t},t.prototype.at=function(t){for(var e=this._root,i=!1,r=0,n=[];!i;)if(e)n.push(e),e=e.left;else if(n.length>0){if(e=n.pop(),r===t)return e;r++,e=e.right}else i=!0;return null},t.prototype.next=function(t){var e=this._root,i=null;if(t.right){for(i=t.right;i.left;)i=i.left;return i}for(var r=this._comparator;e;){var n=r(t.key,e.key);if(0===n)break;n<0?(i=e,e=e.left):e=e.right}return i},t.prototype.prev=function(t){var e=this._root,i=null;if(null!==t.left){for(i=t.left;i.right;)i=i.right;return i}for(var r=this._comparator;e;){var n=r(t.key,e.key);if(0===n)break;n<0?e=e.left:(i=e,e=e.right)}return i},t.prototype.clear=function(){return this._root=null,this._size=0,this},t.prototype.toList=function(){return function(t){var e=t,i=[],n=!1,o=new r(null,null),a=o;for(;!n;)e?(i.push(e),e=e.left):i.length>0?e=(e=a=a.next=i.pop()).right:n=!0;return a.next=null,o.next}(this._root)},t.prototype.load=function(t,e,i){void 0===e&&(e=[]),void 0===i&&(i=!1);var n=t.length,o=this._comparator;if(i&&function t(e,i,r,n,o){if(r>=n)return;var a=e[r+n>>1];var s=r-1;var l=n+1;for(;;){do{s++}while(o(e[s],a)<0);do{l--}while(o(e[l],a)>0);if(s>=l)break;var u=e[s];e[s]=e[l],e[l]=u,u=i[s],i[s]=i[l],i[l]=u}t(e,i,r,l,o);t(e,i,l+1,n,o)}(t,e,0,n-1,o),null===this._root)this._root=function t(e,i,n,o){var a=o-n;if(a>0){var s=n+Math.floor(a/2),l=e[s],u=i[s],c=new r(l,u);return c.left=t(e,i,n,s),c.right=t(e,i,s+1,o),c}return null}(t,e,0,n),this._size=n;else{var a=function(t,e,i){var n=new r(null,null),o=n,a=t,s=e;for(;null!==a&&null!==s;)i(a.key,s.key)<0?(o.next=a,a=a.next):(o.next=s,s=s.next),o=o.next;null!==a?o.next=a:null!==s&&(o.next=s);return n.next}(this.toList(),function(t,e){for(var i=new r(null,null),n=i,o=0;o<t.length;o++)n=n.next=new r(t[o],e[o]);return n.next=null,i.next}(t,e),o);n=this._size+n,this._root=function t(e,i,r){var n=r-i;if(n>0){var o=i+Math.floor(n/2),a=t(e,i,o),s=e.head;return s.left=a,e.head=e.head.next,s.right=t(e,o+1,r),s}return null}({head:a},0,n)}return this},t.prototype.isEmpty=function(){return null===this._root},Object.defineProperty(t.prototype,"size",{get:function(){return this._size},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"root",{get:function(){return this._root},enumerable:!0,configurable:!0}),t.prototype.toString=function(t){void 0===t&&(t=function(t){return String(t.key)});var e=[];return function t(e,i,r,n,o){if(e){n(i+(r?"â””â”€â”€ ":"â”œâ”€â”€ ")+o(e)+"\n");var a=i+(r?"    ":"â”‚   ");e.left&&t(e.left,a,!1,n,o),e.right&&t(e.right,a,!0,n,o)}}(this._root,"",!0,function(t){return e.push(t)},t),e.join("")},t.prototype.update=function(t,e,i){var r=this._comparator,n=s(t,this._root,r),l=n.left,u=n.right;r(t,e)<0?u=a(e,i,u,r):l=a(e,i,l,r),this._root=function(t,e,i){return null===e?t:null===t?e:((e=o(t.key,e,i)).left=t,e)}(l,u,r)},t.prototype.split=function(t){return s(t,this._root,this._comparator)},t}();var u=function(t,e){return t.ll.x<=e.x&&e.x<=t.ur.x&&t.ll.y<=e.y&&e.y<=t.ur.y},c=function(t,e){if(e.ur.x<t.ll.x||t.ur.x<e.ll.x||e.ur.y<t.ll.y||t.ur.y<e.ll.y)return null;var i=t.ll.x<e.ll.x?e.ll.x:t.ll.x,r=t.ur.x<e.ur.x?t.ur.x:e.ur.x;return{ll:{x:i,y:t.ll.y<e.ll.y?e.ll.y:t.ll.y},ur:{x:r,y:t.ur.y<e.ur.y?t.ur.y:e.ur.y}}},p=Number.EPSILON;void 0===p&&(p=Math.pow(2,-52));var h=p*p,d=function(t,e){if(-p<t&&t<p&&-p<e&&e<p)return 0;var i=t-e;return i*i<h*t*e?0:t<e?-1:1},f=function(){function e(){t(this,e),this.reset()}return i(e,[{key:"reset",value:function(){this.xRounder=new m,this.yRounder=new m}},{key:"round",value:function(t,e){return{x:this.xRounder.round(t),y:this.yRounder.round(e)}}}]),e}(),m=function(){function e(){t(this,e),this.tree=new l,this.round(0)}return i(e,[{key:"round",value:function(t){var e=this.tree.add(t),i=this.tree.prev(e);if(null!==i&&0===d(e.key,i.key))return this.tree.remove(t),i.key;var r=this.tree.next(e);return null!==r&&0===d(e.key,r.key)?(this.tree.remove(t),r.key):t}}]),e}(),y=new f,g=function(t,e){return t.x*e.y-t.y*e.x},v=function(t,e){return t.x*e.x+t.y*e.y},_=function(t,e,i){var r={x:e.x-t.x,y:e.y-t.y},n={x:i.x-t.x,y:i.y-t.y},o=g(r,n);return d(o,0)},x=function(t){return Math.sqrt(v(t,t))},b=function(t,e,i){var r={x:e.x-t.x,y:e.y-t.y},n={x:i.x-t.x,y:i.y-t.y};return g(n,r)/x(n)/x(r)},w=function(t,e,i){var r={x:e.x-t.x,y:e.y-t.y},n={x:i.x-t.x,y:i.y-t.y};return v(n,r)/x(n)/x(r)},S=function(t,e,i){return 0===e.y?null:{x:t.x+e.x/e.y*(i-t.y),y:i}},T=function(t,e,i){return 0===e.x?null:{x:i,y:t.y+e.y/e.x*(i-t.x)}},C=function(){function e(i,r){t(this,e),void 0===i.events?i.events=[this]:i.events.push(this),this.point=i,this.isLeft=r}return i(e,null,[{key:"compare",value:function(t,i){var r=e.comparePoints(t.point,i.point);return 0!==r?r:(t.point!==i.point&&t.link(i),t.isLeft!==i.isLeft?t.isLeft?1:-1:I.compare(t.segment,i.segment))}},{key:"comparePoints",value:function(t,e){return t.x<e.x?-1:t.x>e.x?1:t.y<e.y?-1:t.y>e.y?1:0}}]),i(e,[{key:"link",value:function(t){if(t.point===this.point)throw new Error("Tried to link already linked events");for(var e=t.point.events,i=0,r=e.length;i<r;i++){var n=e[i];this.point.events.push(n),n.point=this.point}this.checkForConsuming()}},{key:"checkForConsuming",value:function(){for(var t=this.point.events.length,e=0;e<t;e++){var i=this.point.events[e];if(void 0===i.segment.consumedBy)for(var r=e+1;r<t;r++){var n=this.point.events[r];void 0===n.consumedBy&&(i.otherSE.point.events===n.otherSE.point.events&&i.segment.consume(n.segment))}}}},{key:"getAvailableLinkedEvents",value:function(){for(var t=[],e=0,i=this.point.events.length;e<i;e++){var r=this.point.events[e];r!==this&&!r.segment.ringOut&&r.segment.isInResult()&&t.push(r)}return t}},{key:"getLeftmostComparator",value:function(t){var e=this,i=new Map,r=function(r){var n=r.otherSE;i.set(r,{sine:b(e.point,t.point,n.point),cosine:w(e.point,t.point,n.point)})};return function(t,e){i.has(t)||r(t),i.has(e)||r(e);var n=i.get(t),o=n.sine,a=n.cosine,s=i.get(e),l=s.sine,u=s.cosine;return o>=0&&l>=0?a<u?1:a>u?-1:0:o<0&&l<0?a<u?-1:a>u?1:0:l<o?-1:l>o?1:0}}}]),e}(),E=0,I=function(){function e(i,r,n,o){t(this,e),this.id=++E,this.leftSE=i,i.segment=this,i.otherSE=r,this.rightSE=r,r.segment=this,r.otherSE=i,this.rings=n,this.windings=o}return i(e,null,[{key:"compare",value:function(t,e){var i=t.leftSE.point.x,r=e.leftSE.point.x,n=t.rightSE.point.x,o=e.rightSE.point.x;if(o<i)return 1;if(n<r)return-1;var a=t.leftSE.point.y,s=e.leftSE.point.y,l=t.rightSE.point.y,u=e.rightSE.point.y;if(i<r){if(s<a&&s<l)return 1;if(s>a&&s>l)return-1;var c=t.comparePoint(e.leftSE.point);if(c<0)return 1;if(c>0)return-1;var p=e.comparePoint(t.rightSE.point);return 0!==p?p:-1}if(i>r){if(a<s&&a<u)return-1;if(a>s&&a>u)return 1;var h=e.comparePoint(t.leftSE.point);if(0!==h)return h;var d=t.comparePoint(e.rightSE.point);return d<0?1:d>0?-1:1}if(a<s)return-1;if(a>s)return 1;if(n<o){var f=e.comparePoint(t.rightSE.point);if(0!==f)return f}if(n>o){var m=t.comparePoint(e.rightSE.point);if(m<0)return 1;if(m>0)return-1}if(n!==o){var y=l-a,g=n-i,v=u-s,_=o-r;if(y>g&&v<_)return 1;if(y<g&&v>_)return-1}return n>o?1:n<o?-1:l<u?-1:l>u?1:t.id<e.id?-1:t.id>e.id?1:0}}]),i(e,[{key:"replaceRightSE",value:function(t){this.rightSE=t,this.rightSE.segment=this,this.rightSE.otherSE=this.leftSE,this.leftSE.otherSE=this.rightSE}},{key:"bbox",value:function(){var t=this.leftSE.point.y,e=this.rightSE.point.y;return{ll:{x:this.leftSE.point.x,y:t<e?t:e},ur:{x:this.rightSE.point.x,y:t>e?t:e}}}},{key:"vector",value:function(){return{x:this.rightSE.point.x-this.leftSE.point.x,y:this.rightSE.point.y-this.leftSE.point.y}}},{key:"isAnEndpoint",value:function(t){return t.x===this.leftSE.point.x&&t.y===this.leftSE.point.y||t.x===this.rightSE.point.x&&t.y===this.rightSE.point.y}},{key:"comparePoint",value:function(t){if(this.isAnEndpoint(t))return 0;var e=this.leftSE.point,i=this.rightSE.point,r=this.vector();if(e.x===i.x)return t.x===e.x?0:t.x<e.x?1:-1;var n=(t.y-e.y)/r.y,o=e.x+n*r.x;if(t.x===o)return 0;var a=(t.x-e.x)/r.x,s=e.y+a*r.y;return t.y===s?0:t.y<s?-1:1}},{key:"getIntersection",value:function(t){var e=this.bbox(),i=t.bbox(),r=c(e,i);if(null===r)return null;var n=this.leftSE.point,o=this.rightSE.point,a=t.leftSE.point,s=t.rightSE.point,l=u(e,a)&&0===this.comparePoint(a),p=u(i,n)&&0===t.comparePoint(n),h=u(e,s)&&0===this.comparePoint(s),d=u(i,o)&&0===t.comparePoint(o);if(p&&l)return d&&!h?o:!d&&h?s:null;if(p)return h&&n.x===s.x&&n.y===s.y?null:n;if(l)return d&&o.x===a.x&&o.y===a.y?null:a;if(d&&h)return null;if(d)return o;if(h)return s;var f=function(t,e,i,r){if(0===e.x)return T(i,r,t.x);if(0===r.x)return T(t,e,i.x);if(0===e.y)return S(i,r,t.y);if(0===r.y)return S(t,e,i.y);var n=g(e,r);if(0==n)return null;var o={x:i.x-t.x,y:i.y-t.y},a=g(o,e)/n,s=g(o,r)/n;return{x:(t.x+s*e.x+(i.x+a*r.x))/2,y:(t.y+s*e.y+(i.y+a*r.y))/2}}(n,this.vector(),a,t.vector());return null===f?null:u(r,f)?y.round(f.x,f.y):null}},{key:"split",value:function(t){var i=[],r=void 0!==t.events,n=new C(t,!0),o=new C(t,!1),a=this.rightSE;this.replaceRightSE(o),i.push(o),i.push(n);var s=new e(n,a,this.rings.slice(),this.windings.slice());return C.comparePoints(s.leftSE.point,s.rightSE.point)>0&&s.swapEvents(),C.comparePoints(this.leftSE.point,this.rightSE.point)>0&&this.swapEvents(),r&&(n.checkForConsuming(),o.checkForConsuming()),i}},{key:"swapEvents",value:function(){var t=this.rightSE;this.rightSE=this.leftSE,this.leftSE=t,this.leftSE.isLeft=!0,this.rightSE.isLeft=!1;for(var e=0,i=this.windings.length;e<i;e++)this.windings[e]*=-1}},{key:"consume",value:function(t){for(var i=this,r=t;i.consumedBy;)i=i.consumedBy;for(;r.consumedBy;)r=r.consumedBy;var n=e.compare(i,r);if(0!==n){if(n>0){var o=i;i=r,r=o}if(i.prev===r){var a=i;i=r,r=a}for(var s=0,l=r.rings.length;s<l;s++){var u=r.rings[s],c=r.windings[s],p=i.rings.indexOf(u);-1===p?(i.rings.push(u),i.windings.push(c)):i.windings[p]+=c}r.rings=null,r.windings=null,r.consumedBy=i,r.leftSE.consumedBy=i.leftSE,r.rightSE.consumedBy=i.rightSE}}},{key:"prevInResult",value:function(){return void 0!==this._prevInResult?this._prevInResult:(this.prev?this.prev.isInResult()?this._prevInResult=this.prev:this._prevInResult=this.prev.prevInResult():this._prevInResult=null,this._prevInResult)}},{key:"beforeState",value:function(){if(void 0!==this._beforeState)return this._beforeState;if(this.prev){var t=this.prev.consumedBy||this.prev;this._beforeState=t.afterState()}else this._beforeState={rings:[],windings:[],multiPolys:[]};return this._beforeState}},{key:"afterState",value:function(){if(void 0!==this._afterState)return this._afterState;var t=this.beforeState();this._afterState={rings:t.rings.slice(0),windings:t.windings.slice(0),multiPolys:[]};for(var e=this._afterState.rings,i=this._afterState.windings,r=this._afterState.multiPolys,n=0,o=this.rings.length;n<o;n++){var a=this.rings[n],s=this.windings[n],l=e.indexOf(a);-1===l?(e.push(a),i.push(s)):i[l]+=s}for(var u=[],c=[],p=0,h=e.length;p<h;p++)if(0!==i[p]){var d=e[p],f=d.poly;if(-1===c.indexOf(f))if(d.isExterior)u.push(f);else{-1===c.indexOf(f)&&c.push(f);var m=u.indexOf(d.poly);-1!==m&&u.splice(m,1)}}for(var y=0,g=u.length;y<g;y++){var v=u[y].multiPoly;-1===r.indexOf(v)&&r.push(v)}return this._afterState}},{key:"isInResult",value:function(){if(this.consumedBy)return!1;if(void 0!==this._isInResult)return this._isInResult;var t=this.beforeState().multiPolys,e=this.afterState().multiPolys;switch(N.type){case"union":var i=0===t.length,r=0===e.length;this._isInResult=i!==r;break;case"intersection":var n,o;t.length<e.length?(n=t.length,o=e.length):(n=e.length,o=t.length),this._isInResult=o===N.numMultiPolys&&n<o;break;case"xor":var a=Math.abs(t.length-e.length);this._isInResult=a%2==1;break;case"difference":var s=function(t){return 1===t.length&&t[0].isSubject};this._isInResult=s(t)!==s(e);break;default:throw new Error("Unrecognized operation type found ".concat(N.type))}return this._isInResult}}],[{key:"fromRing",value:function(t,i,r){var n,o,a,s=C.comparePoints(t,i);if(s<0)n=t,o=i,a=1;else{if(!(s>0))throw new Error("Tried to create degenerate segment at [".concat(t.x,", ").concat(t.y,"]"));n=i,o=t,a=-1}return new e(new C(n,!0),new C(o,!1),[r],[a])}}]),e}(),k=function(){function e(i,r,n){if(t(this,e),!Array.isArray(i)||0===i.length)throw new Error("Input geometry is not a valid Polygon or MultiPolygon");if(this.poly=r,this.isExterior=n,this.segments=[],"number"!=typeof i[0][0]||"number"!=typeof i[0][1])throw new Error("Input geometry is not a valid Polygon or MultiPolygon");var o=y.round(i[0][0],i[0][1]);this.bbox={ll:{x:o.x,y:o.y},ur:{x:o.x,y:o.y}};for(var a=o,s=1,l=i.length;s<l;s++){if("number"!=typeof i[s][0]||"number"!=typeof i[s][1])throw new Error("Input geometry is not a valid Polygon or MultiPolygon");var u=y.round(i[s][0],i[s][1]);u.x===a.x&&u.y===a.y||(this.segments.push(I.fromRing(a,u,this)),u.x<this.bbox.ll.x&&(this.bbox.ll.x=u.x),u.y<this.bbox.ll.y&&(this.bbox.ll.y=u.y),u.x>this.bbox.ur.x&&(this.bbox.ur.x=u.x),u.y>this.bbox.ur.y&&(this.bbox.ur.y=u.y),a=u)}o.x===a.x&&o.y===a.y||this.segments.push(I.fromRing(a,o,this))}return i(e,[{key:"getSweepEvents",value:function(){for(var t=[],e=0,i=this.segments.length;e<i;e++){var r=this.segments[e];t.push(r.leftSE),t.push(r.rightSE)}return t}}]),e}(),A=function(){function e(i,r){if(t(this,e),!Array.isArray(i))throw new Error("Input geometry is not a valid Polygon or MultiPolygon");this.exteriorRing=new k(i[0],this,!0),this.bbox={ll:{x:this.exteriorRing.bbox.ll.x,y:this.exteriorRing.bbox.ll.y},ur:{x:this.exteriorRing.bbox.ur.x,y:this.exteriorRing.bbox.ur.y}},this.interiorRings=[];for(var n=1,o=i.length;n<o;n++){var a=new k(i[n],this,!1);a.bbox.ll.x<this.bbox.ll.x&&(this.bbox.ll.x=a.bbox.ll.x),a.bbox.ll.y<this.bbox.ll.y&&(this.bbox.ll.y=a.bbox.ll.y),a.bbox.ur.x>this.bbox.ur.x&&(this.bbox.ur.x=a.bbox.ur.x),a.bbox.ur.y>this.bbox.ur.y&&(this.bbox.ur.y=a.bbox.ur.y),this.interiorRings.push(a)}this.multiPoly=r}return i(e,[{key:"getSweepEvents",value:function(){for(var t=this.exteriorRing.getSweepEvents(),e=0,i=this.interiorRings.length;e<i;e++)for(var r=this.interiorRings[e].getSweepEvents(),n=0,o=r.length;n<o;n++)t.push(r[n]);return t}}]),e}(),P=function(){function e(i,r){if(t(this,e),!Array.isArray(i))throw new Error("Input geometry is not a valid Polygon or MultiPolygon");try{"number"==typeof i[0][0][0]&&(i=[i])}catch(i){}this.polys=[],this.bbox={ll:{x:Number.POSITIVE_INFINITY,y:Number.POSITIVE_INFINITY},ur:{x:Number.NEGATIVE_INFINITY,y:Number.NEGATIVE_INFINITY}};for(var n=0,o=i.length;n<o;n++){var a=new A(i[n],this);a.bbox.ll.x<this.bbox.ll.x&&(this.bbox.ll.x=a.bbox.ll.x),a.bbox.ll.y<this.bbox.ll.y&&(this.bbox.ll.y=a.bbox.ll.y),a.bbox.ur.x>this.bbox.ur.x&&(this.bbox.ur.x=a.bbox.ur.x),a.bbox.ur.y>this.bbox.ur.y&&(this.bbox.ur.y=a.bbox.ur.y),this.polys.push(a)}this.isSubject=r}return i(e,[{key:"getSweepEvents",value:function(){for(var t=[],e=0,i=this.polys.length;e<i;e++)for(var r=this.polys[e].getSweepEvents(),n=0,o=r.length;n<o;n++)t.push(r[n]);return t}}]),e}(),M=function(){function e(i){t(this,e),this.events=i;for(var r=0,n=i.length;r<n;r++)i[r].segment.ringOut=this;this.poly=null}return i(e,null,[{key:"factory",value:function(t){for(var i=[],r=0,n=t.length;r<n;r++){var o=t[r];if(o.isInResult()&&!o.ringOut){for(var a=null,s=o.leftSE,l=o.rightSE,u=[s],c=s.point,p=[];a=s,s=l,u.push(s),s.point!==c;)for(;;){var h=s.getAvailableLinkedEvents();if(0===h.length){var d=u[0].point,f=u[u.length-1].point;throw new Error("Unable to complete output ring starting at [".concat(d.x,",")+" ".concat(d.y,"]. Last matching segment found ends at")+" [".concat(f.x,", ").concat(f.y,"]."))}if(1===h.length){l=h[0].otherSE;break}for(var m=null,y=0,g=p.length;y<g;y++)if(p[y].point===s.point){m=y;break}if(null===m){p.push({index:u.length,point:s.point});var v=s.getLeftmostComparator(a);l=h.sort(v)[0].otherSE;break}var _=p.splice(m)[0],x=u.splice(_.index);x.unshift(x[0].otherSE),i.push(new e(x.reverse()))}i.push(new e(u))}}return i}}]),i(e,[{key:"getGeom",value:function(){for(var t=this.events[0].point,e=[t],i=1,r=this.events.length-1;i<r;i++){var n=this.events[i].point,o=this.events[i+1].point;0!==_(n,t,o)&&(e.push(n),t=n)}if(1===e.length)return null;var a=e[0],s=e[1];0===_(a,t,s)&&e.shift(),e.push(e[0]);for(var l=this.isExteriorRing()?1:-1,u=this.isExteriorRing()?0:e.length-1,c=this.isExteriorRing()?e.length:-1,p=[],h=u;h!=c;h+=l)p.push([e[h].x,e[h].y]);return p}},{key:"isExteriorRing",value:function(){if(void 0===this._isExteriorRing){var t=this.enclosingRing();this._isExteriorRing=!t||!t.isExteriorRing()}return this._isExteriorRing}},{key:"enclosingRing",value:function(){return void 0===this._enclosingRing&&(this._enclosingRing=this._calcEnclosingRing()),this._enclosingRing}},{key:"_calcEnclosingRing",value:function(){for(var t=this.events[0],e=1,i=this.events.length;e<i;e++){var r=this.events[e];C.compare(t,r)>0&&(t=r)}for(var n=t.segment.prevInResult(),o=n?n.prevInResult():null;;){if(!n)return null;if(!o)return n.ringOut;if(o.ringOut!==n.ringOut)return o.ringOut.enclosingRing()!==n.ringOut?n.ringOut:n.ringOut.enclosingRing();n=o.prevInResult(),o=n?n.prevInResult():null}}}]),e}(),L=function(){function e(i){t(this,e),this.exteriorRing=i,i.poly=this,this.interiorRings=[]}return i(e,[{key:"addInterior",value:function(t){this.interiorRings.push(t),t.poly=this}},{key:"getGeom",value:function(){var t=[this.exteriorRing.getGeom()];if(null===t[0])return null;for(var e=0,i=this.interiorRings.length;e<i;e++){var r=this.interiorRings[e].getGeom();null!==r&&t.push(r)}return t}}]),e}(),O=function(){function e(i){t(this,e),this.rings=i,this.polys=this._composePolys(i)}return i(e,[{key:"getGeom",value:function(){for(var t=[],e=0,i=this.polys.length;e<i;e++){var r=this.polys[e].getGeom();null!==r&&t.push(r)}return t}},{key:"_composePolys",value:function(t){for(var e=[],i=0,r=t.length;i<r;i++){var n=t[i];if(!n.poly)if(n.isExteriorRing())e.push(new L(n));else{var o=n.enclosingRing();o.poly||e.push(new L(o)),o.poly.addInterior(n)}}return e}}]),e}(),R=function(){function e(i){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:I.compare;t(this,e),this.queue=i,this.tree=new l(r),this.segments=[]}return i(e,[{key:"process",value:function(t){var e=t.segment,i=[];if(t.consumedBy)return t.isLeft?this.queue.remove(t.otherSE):this.tree.remove(e),i;var r=t.isLeft?this.tree.insert(e):this.tree.find(e);if(!r)throw new Error("Unable to find segment #".concat(e.id," ")+"[".concat(e.leftSE.point.x,", ").concat(e.leftSE.point.y,"] -> ")+"[".concat(e.rightSE.point.x,", ").concat(e.rightSE.point.y,"] ")+"in SweepLine tree. Please submit a bug report.");for(var n=r,o=r,a=void 0,s=void 0;void 0===a;)null===(n=this.tree.prev(n))?a=null:void 0===n.key.consumedBy&&(a=n.key);for(;void 0===s;)null===(o=this.tree.next(o))?s=null:void 0===o.key.consumedBy&&(s=o.key);if(t.isLeft){var l=null;if(a){var u=a.getIntersection(e);if(null!==u&&(e.isAnEndpoint(u)||(l=u),!a.isAnEndpoint(u)))for(var c=this._splitSafely(a,u),p=0,h=c.length;p<h;p++)i.push(c[p])}var d=null;if(s){var f=s.getIntersection(e);if(null!==f&&(e.isAnEndpoint(f)||(d=f),!s.isAnEndpoint(f)))for(var m=this._splitSafely(s,f),y=0,g=m.length;y<g;y++)i.push(m[y])}if(null!==l||null!==d){var v=null;if(null===l)v=d;else if(null===d)v=l;else{v=C.comparePoints(l,d)<=0?l:d}this.queue.remove(e.rightSE),i.push(e.rightSE);for(var _=e.split(v),x=0,b=_.length;x<b;x++)i.push(_[x])}i.length>0?(this.tree.remove(e),i.push(t)):(this.segments.push(e),e.prev=a)}else{if(a&&s){var w=a.getIntersection(s);if(null!==w){if(!a.isAnEndpoint(w))for(var S=this._splitSafely(a,w),T=0,E=S.length;T<E;T++)i.push(S[T]);if(!s.isAnEndpoint(w))for(var I=this._splitSafely(s,w),k=0,A=I.length;k<A;k++)i.push(I[k])}}this.tree.remove(e)}return i}},{key:"_splitSafely",value:function(t,e){this.tree.remove(t);var i=t.rightSE;this.queue.remove(i);var r=t.split(e);return r.push(i),void 0===t.consumedBy&&this.tree.insert(t),r}}]),e}(),z="undefined"!=typeof process&&process.env.POLYGON_CLIPPING_MAX_QUEUE_SIZE||1e6,D="undefined"!=typeof process&&process.env.POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS||1e6,N=new(function(){function e(){t(this,e)}return i(e,[{key:"run",value:function(t,e,i){N.type=t,y.reset();for(var r=[new P(e,!0)],n=0,o=i.length;n<o;n++)r.push(new P(i[n],!1));if(N.numMultiPolys=r.length,"difference"===N.type)for(var a=r[0],s=1;s<r.length;)null!==c(r[s].bbox,a.bbox)?s++:r.splice(s,1);if("intersection"===N.type)for(var u=0,p=r.length;u<p;u++)for(var h=r[u],d=u+1,f=r.length;d<f;d++)if(null===c(h.bbox,r[d].bbox))return[];for(var m=new l(C.compare),g=0,v=r.length;g<v;g++)for(var _=r[g].getSweepEvents(),x=0,b=_.length;x<b;x++)if(m.insert(_[x]),m.size>z)throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big). Please file a bug report.");for(var w=new R(m),S=m.size,T=m.pop();T;){var E=T.key;if(m.size===S){var I=E.segment;throw new Error("Unable to pop() ".concat(E.isLeft?"left":"right"," SweepEvent ")+"[".concat(E.point.x,", ").concat(E.point.y,"] from segment #").concat(I.id," ")+"[".concat(I.leftSE.point.x,", ").concat(I.leftSE.point.y,"] -> ")+"[".concat(I.rightSE.point.x,", ").concat(I.rightSE.point.y,"] from queue. ")+"Please file a bug report.")}if(m.size>z)throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big). Please file a bug report.");if(w.segments.length>D)throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments). Please file a bug report.");for(var k=w.process(E),A=0,L=k.length;A<L;A++){var B=k[A];void 0===B.consumedBy&&m.insert(B)}S=m.size,T=m.pop()}y.reset();var F=M.factory(w.segments);return new O(F).getGeom()}}]),e}());return{union:function(t){for(var e=arguments.length,i=new Array(e>1?e-1:0),r=1;r<e;r++)i[r-1]=arguments[r];return N.run("union",t,i)},intersection:function(t){for(var e=arguments.length,i=new Array(e>1?e-1:0),r=1;r<e;r++)i[r-1]=arguments[r];return N.run("intersection",t,i)},xor:function(t){for(var e=arguments.length,i=new Array(e>1?e-1:0),r=1;r<e;r++)i[r-1]=arguments[r];return N.run("xor",t,i)},difference:function(t){for(var e=arguments.length,i=new Array(e>1?e-1:0),r=1;r<e;r++)i[r-1]=arguments[r];return N.run("difference",t,i)}}}()});var pm=["DIV","SPAN","A"],hm=["data-azure-maps-attribution-minzoom","data-azure-maps-attribution-maxzoom","data-azure-maps-attribution-geometry","data-azure-maps-attribution-tileset","data-azure-maps-attribution-order","data-azure-maps-attribution-dynamic"],dm=k(["href"],hm),fm=(mm.prototype.equals=function(t){return this.stringRepresentation===t.stringRepresentation},Object.defineProperty(mm.prototype,"stringRepresentation",{get:function(){return[void 0!==this.minZoom?"minzoom="+this.minZoom:"",void 0!==this.maxZoom?"maxzoom="+this.maxZoom:"",void 0!==this.geometry?this.element.attributes.getNamedItem("data-azure-maps-attribution-geometry").value:"",void 0!==this.tilesetId?"tilesetId="+this.tilesetId:"",this.dynamic?"dynamic":""].filter(function(t){return 0<t.length}).join(";")},enumerable:!1,configurable:!0}),mm.applicable=function(t){return Array.from(t.attributes).map(function(t){return hm.includes(t.name)}).reduce(function(t,e){return t||e},!1)},Object.defineProperty(mm.prototype,"minZoom",{get:function(){var t=this.element.attributes.getNamedItem("data-azure-maps-attribution-minzoom");return t&&!isNaN(t.value)?parseInt(t.value):void 0},enumerable:!1,configurable:!0}),Object.defineProperty(mm.prototype,"maxZoom",{get:function(){var t=this.element.attributes.getNamedItem("data-azure-maps-attribution-maxzoom");return t&&!isNaN(t.value)?parseInt(t.value):void 0},enumerable:!1,configurable:!0}),Object.defineProperty(mm.prototype,"geometry",{get:function(){var t=this.element.attributes.getNamedItem("data-azure-maps-attribution-geometry");if(t&&t.value)try{return JSON.parse(t.value)}catch(t){return}},enumerable:!1,configurable:!0}),Object.defineProperty(mm.prototype,"tilesetId",{get:function(){var t=this.element.attributes.getNamedItem("data-azure-maps-attribution-tileset");return t&&t.value?t.value:void 0},enumerable:!1,configurable:!0}),Object.defineProperty(mm.prototype,"order",{get:function(){var t=this.element.attributes.getNamedItem("data-azure-maps-attribution-order");return t&&!isNaN(t.value)?parseInt(t.value):void 0},enumerable:!1,configurable:!0}),Object.defineProperty(mm.prototype,"dynamic",{get:function(){return null!==this.element.attributes.getNamedItem("data-azure-maps-attribution-dynamic")},enumerable:!1,configurable:!0}),Object.defineProperty(mm.prototype,"hidesElement",{get:function(){return"none"==this.element.style.display},enumerable:!1,configurable:!0}),mm.prototype.forceHide=function(){this.element.style.display="none"},mm.prototype.satisfied=function(t){var e=!this.minZoom||!t.zoom||t.zoom>=this.minZoom,i=!this.maxZoom||!t.zoom||t.zoom<=this.maxZoom,r=!0;return this.geometry&&t.bounds&&(r=null!==function(t,e,i){var r;return void 0===i&&(i={}),t=um(t),e=um(e),0===(e=cm.intersection(t.coordinates,e.coordinates)).length?null:1===e.length?function(t,e,i){void 0===i&&(i={});for(var r=0,n=t;r<n.length;r++){var o=n[r];if(o.length<4)throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");for(var a=0;a<o[o.length-1].length;a++)if(o[o.length-1][a]!==o[0][a])throw new Error("First and last Position are not equivalent.")}return lm({type:"Polygon",coordinates:t},e,i)}(e[0],i.properties):lm({type:"MultiPolygon",coordinates:e},i=i.properties,r=void 0===r?{}:r)}({type:"Feature",geometry:this.geometry,properties:{}},{type:"Feature",geometry:{type:"Polygon",coordinates:[[nn.getNorthWest(t.bounds),nn.getNorthEast(t.bounds),nn.getSouthEast(t.bounds),nn.getSouthWest(t.bounds),nn.getNorthWest(t.bounds)]]},properties:{}})),e&&i&&r},mm.prototype.apply=function(t,e){var i=this;void 0===e&&(e=null);var r=this.satisfied(t.getCamera()),n=this.dynamic&&this.tilesetId,o=this.hidesElement;e=e&&["dragend","zoomend","pitchend"].includes(e.type);return r||o?r&&(o||n)&&(r&&o&&this.element.style.removeProperty("display"),n&&(e?t.events.addOnce("idle",function(e){return i.fetchAndApplyDynamicAttribution(t)}):this.fetchAndApplyDynamicAttribution(t))):this.element.style.display="none",r===o},mm.prototype.fetchAndApplyDynamicAttribution=function(t){var e,i,r,n=this,o=t.getCamera();this.lastFetchState&&nn.containsBoundingBox(this.lastFetchState.bounds,o.bounds)&&Math.floor(this.lastFetchState.zoom)==Math.floor(o.zoom)||(e=kr(o.center,nn.getSouthWest(o.bounds),mm.viewportBufferExpansionRatio),r=((i=kr(o.center,nn.getNorthEast(o.bounds),mm.viewportBufferExpansionRatio))[0]<e[0]?[[e[0],e[1],180,i[1]],[-180,e[1],i[0],i[1]]]:[[e[0],e[1],i[0],i[1]]]).map(function(e){var i=new URLSearchParams({"api-version":"2.1",tilesetId:n.tilesetId,zoom:void 0!==o.zoom?""+Math.floor(o.zoom):void 0,bounds:e.join(",")}),r="https://{{azMapsDomain}}/map/attribution";e={url:r};return t._substituteDomainLanguageViewAndSignInRequest(r,e),i=e.url+"&"+i.toString(),t._sendRequest(i,"Attribution").then(function(t){return t.json()})}),Promise.all(r).then(function(t){n.applyAttributionResponse(t),n.lastFetchState={bounds:new nn([e[0],e[1],i[0],i[1]]),zoom:o.zoom}}).catch(function(t){return console.error(t)}))},mm.prototype.applyAttributionResponse=function(t){var e,i,r=this,n=t.map(function(t){return t.copyrights||[]}).reduce(function(t,e){return k(t,e)},[]);0!=n.length&&(null!==(t=Vo.parseWithFilter(n.join(""),function(t){return!0},function(t){return t},function(){return r.element.innerHTML="",r.element}))?(t="string"==typeof t?((n=document.createElement("span")).innerHTML=t,n):t,i=t===this.element?(e=document.createElement("span"),Array.from(this.element.childNodes).forEach(function(t){return e.appendChild(t)}),e):t,Array.from(this.element.attributes).filter(function(t){return hm.includes(t.name)}).forEach(function(t){return i.attributes.setNamedItem(t.cloneNode())}),i.style.display=this.element.style.display,t=this.element.parentElement,this.element.remove(),t.append(i),this.element=i,this.attributionChangeCallback(this)):console.warn("Dynamic attribution is empty after filtering"))},mm.viewportBufferExpansionRatio=2,function(t,e,i,r){var n,o=arguments.length,a=o<3?e:null===r?r=Object.getOwnPropertyDescriptor(e,i):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(t,e,i,r);else for(var s=t.length-1;0<=s;s--)(n=t[s])&&(a=(o<3?n(a):3<o?n(e,i,a):n(e,i))||a);3<o&&a&&Object.defineProperty(e,i,a)}([(1e3,function(t,e,i){var r=i.value,n=new Map;return i.value=function(){var t=this,e=arguments;n.get(t)||(r.apply(t,e),n.set(t,!0),setTimeout(function(){return n.delete(t)},1e3))},i})],mm.prototype,"fetchAndApplyDynamicAttribution",null),mm);function mm(t,e){var i=this;this.lastFetchState={bounds:null,zoom:null},this.getElement=function(){return i.element},this.element=t,this.attributionChangeCallback=e}var ym=[/all rights reserved/gi],gm=(vm.prototype.addToMap=function(){this.map.events.add("stylechanged",this.loadAttributionOnceSourcesLoaded),this.map.events.add("dragend",this.applyRules),this.map.events.add("zoomend",this.applyRules),this.map.events.add("pitchend",this.applyRules)},vm.prototype.removeFromMap=function(){this.map.events.remove("stylechanged",this.loadAttributionOnceSourcesLoaded),this.map.events.remove("dragend",this.applyRules),this.map.events.remove("zoomend",this.applyRules),this.map.events.remove("pitchend",this.applyRules)},vm.prototype.getDefaultAttribution=function(){return this.copyrightControl.getDefaultAttributions().map(function(t){return e=t,(t=document.createElement("a")).textContent=e,t;var e})},vm);function vm(t,e,i){var r,n=this;this.rules=[],this.virtualContext=((r=document.createElement("span")).className="azure-map-copyright-context",r),this.renderContext=this.virtualContext.cloneNode(!1),this.addAttributionFromSource=function(t){},this.removeAttributionFromSource=function(t){},this.getMapStyleSources=function(){var t=n.map._getMap();return Object.entries(t.getStyle().sources).map(function(e){return e=I(e,1)[0],t.getSource(e)})},this.loadAttributionOnceSourcesLoaded=function(){var t=n.getMapStyleSources();Promise.all(t.map(function(t){return new Promise(function(e,i){"tiles"in t?e(t):(t.on("data",function i(r){"metadata"==r.sourceDataType&&(t.off("data",i),e(t))}),t.on("error",function e(r){t.off("error",e),i(r)}))}).then(function(t){return{status:"fulfilled",value:t}}).catch(function(t){return{status:"rejected",reason:t}})})).then(function(t){n.reloadAttribution()})},this.reloadAttribution=function(){var t=n.getMapStyleSources(),e=new Set,i={},r=Object.values(t).filter(function(t){return"attribution"in t&&t.attribution&&"tiles"in t&&0<t.tiles.length}).map(function(t){return t}).map(function(t){return t=t.attribution,Vo.parseWithFilter(t,function(t){return pm.includes(t.tagName)&&Array.from(t.attributes).map(function(t){return dm.includes(t.name)}).reduce(function(t,e){return t&&e},!0)},function(t){var r,o=null;return t instanceof HTMLElement&&fm.applicable(t)&&(o=new fm(t,function(){return n.renderAttribution()}),e.add(o),void 0!==o.order&&(t.style.order=""+o.order)),o&&t instanceof HTMLElement&&(!((r=o.stringRepresentation)in i)||void 0!==o.order&&void 0!==i[r].order&&o.order<i[r].order||void 0!==o.order&&void 0===i[r].order)&&(i[r]=o),t},function(){return document.createElement("span")})}),o=new Set(Object.values(i)),a=(t=new Set(k(e).filter(function(t){return!o.has(t)})),new Set(k(t).map(function(t){return t.getElement()})));k(a).filter(function(t){return null!==t.parentElement}).forEach(function(t){return t.parentElement.removeChild(t)}),n.rules=Object.values(i);r=r.filter(function(t){return"string"==typeof t||!a.has(t)}).map(function(t){return"string"==typeof t?new Text(t):t});var s=document.createElement("span");0<r.length?r.forEach(function(t){return s.appendChild(t)}):n.getDefaultAttribution().forEach(function(t){return s.appendChild(t)}),n.virtualContext=s,n.copyrightControl.setOptions({copyrightContent:n.renderContext}),n.applyRules(),n.renderAttribution()},this.applyRules=function(t){void 0===t&&(t=null),n.rules.reduce(function(e,i){return i=i.apply(n.map,t),e||i},!1)&&n.renderAttribution()},this.renderAttribution=function(){var t=function(e){return Array.from("none"!=e.style.display?e.children:[]).map(function(e){return t(e)}).reduce(function(t,e){return k(t,e)},Array.from("none"!=e.style.display?e.childNodes:[]).filter(function(t){return t.nodeType==t.TEXT_NODE}))},e=n.virtualContext.cloneNode(!0),i=t(e);i.forEach(function(t){return t.textContent=k(ym).reduce(function(t,e){return t.replace(e,"").trim()},t.textContent)}),i.reduce(function(t,e){return t.has(e.textContent)?(e.textContent="",e.parentElement&&e.parentElement.removeChild(e)):t.add(e.textContent),t},new Set),n.renderContext.innerHTML="",Array.from(e.childNodes).forEach(function(t){return n.renderContext.appendChild(t)})},this.map=t,this.copyrightControl=e,this.options=i}var _m=i(function(t){var e=(e=function(t){if(this.REQUEST_TYPE={LOGIN:"LOGIN",RENEW_TOKEN:"RENEW_TOKEN",UNKNOWN:"UNKNOWN"},this.RESPONSE_TYPE={ID_TOKEN_TOKEN:"id_token token",TOKEN:"token"},this.CONSTANTS={ACCESS_TOKEN:"access_token",EXPIRES_IN:"expires_in",ID_TOKEN:"id_token",ERROR_DESCRIPTION:"error_description",SESSION_STATE:"session_state",ERROR:"error",STORAGE:{TOKEN_KEYS:"adal.token.keys",ACCESS_TOKEN_KEY:"adal.access.token.key",EXPIRATION_KEY:"adal.expiration.key",STATE_LOGIN:"adal.state.login",STATE_RENEW:"adal.state.renew",NONCE_IDTOKEN:"adal.nonce.idtoken",SESSION_STATE:"adal.session.state",USERNAME:"adal.username",IDTOKEN:"adal.idtoken",ERROR:"adal.error",ERROR_DESCRIPTION:"adal.error.description",LOGIN_REQUEST:"adal.login.request",LOGIN_ERROR:"adal.login.error",RENEW_STATUS:"adal.token.renew.status",ANGULAR_LOGIN_REQUEST:"adal.angular.login.request"},RESOURCE_DELIMETER:"|",CACHE_DELIMETER:"||",LOADFRAME_TIMEOUT:6e3,TOKEN_RENEW_STATUS_CANCELED:"Canceled",TOKEN_RENEW_STATUS_COMPLETED:"Completed",TOKEN_RENEW_STATUS_IN_PROGRESS:"In Progress",LOGGING_LEVEL:{ERROR:0,WARN:1,INFO:2,VERBOSE:3},LEVEL_STRING_MAP:{0:"ERROR:",1:"WARNING:",2:"INFO:",3:"VERBOSE:"},POPUP_WIDTH:483,POPUP_HEIGHT:600},e.prototype._singletonInstance)return e.prototype._singletonInstance;if((e.prototype._singletonInstance=this).instance="https://login.microsoftonline.com/",this.config={},this.callback=null,this.popUp=!1,this.isAngular=!1,this._user=null,this._activeRenewals={},this._loginInProgress=!1,this._acquireTokenInProgress=!1,this._renewStates=[],this._callBackMappedToRenewStates={},this._callBacksMappedToRenewStates={},this._openedWindows=[],this._requestType=this.REQUEST_TYPE.LOGIN,window._adalInstance=this,t.displayCall&&"function"!=typeof t.displayCall)throw new Error("displayCall is not a function");if(!t.clientId)throw new Error("clientId is required");this.config=this._cloneConfig(t),void 0===this.config.navigateToLoginRequestUrl&&(this.config.navigateToLoginRequestUrl=!0),this.config.popUp&&(this.popUp=!0),this.config.callback&&"function"==typeof this.config.callback&&(this.callback=this.config.callback),this.config.instance&&(this.instance=this.config.instance),this.config.loginResource||(this.config.loginResource=this.config.clientId),this.config.redirectUri||(this.config.redirectUri=window.location.href.split("?")[0].split("#")[0]),this.config.postLogoutRedirectUri||(this.config.postLogoutRedirectUri=window.location.href.split("?")[0].split("#")[0]),this.config.anonymousEndpoints||(this.config.anonymousEndpoints=[]),this.config.isAngular&&(this.isAngular=this.config.isAngular),this.config.loadFrameTimeout&&(this.CONSTANTS.LOADFRAME_TIMEOUT=this.config.loadFrameTimeout)},"undefined"!=typeof window&&(window.Logging={piiLoggingEnabled:!1,level:0,log:function(t){}}),e.prototype.login=function(){var t,e;this._loginInProgress?this.info("Login in progress"):(this._loginInProgress=!0,t=this._guid(),this.config.state=t,this._idTokenNonce=this._guid(),(e=this._getItem(this.CONSTANTS.STORAGE.ANGULAR_LOGIN_REQUEST))&&""!==e?this._saveItem(this.CONSTANTS.STORAGE.ANGULAR_LOGIN_REQUEST,""):e=window.location.href,this.verbose("Expected state: "+t+" startPage:"+e),this._saveItem(this.CONSTANTS.STORAGE.LOGIN_REQUEST,e),this._saveItem(this.CONSTANTS.STORAGE.LOGIN_ERROR,""),this._saveItem(this.CONSTANTS.STORAGE.STATE_LOGIN,t,!0),this._saveItem(this.CONSTANTS.STORAGE.NONCE_IDTOKEN,this._idTokenNonce,!0),this._saveItem(this.CONSTANTS.STORAGE.ERROR,""),this._saveItem(this.CONSTANTS.STORAGE.ERROR_DESCRIPTION,""),e=this._getNavigateUrl("id_token",null)+"&nonce="+encodeURIComponent(this._idTokenNonce),this.config.displayCall?this.config.displayCall(e):this.popUp?(this._saveItem(this.CONSTANTS.STORAGE.STATE_LOGIN,""),this._renewStates.push(t),this.registerCallback(t,this.config.clientId,this.callback),this._loginPopup(e)):this.promptUser(e))},e.prototype._openPopup=function(t,e,i,r){try{var n=window.screenLeft||window.screenX,o=window.screenTop||window.screenY,a=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,s=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight,l=a/2-i/2+n,u=s/2-r/2+o,c=window.open(t,e,"width="+i+", height="+r+", top="+u+", left="+l);return c.focus&&c.focus(),c}catch(t){return this.warn("Error opening popup, "+t.message),this._loginInProgress=!1,this._acquireTokenInProgress=!1,null}},e.prototype._handlePopupError=function(t,e,i,r,n){this.warn(r),this._saveItem(this.CONSTANTS.STORAGE.ERROR,i),this._saveItem(this.CONSTANTS.STORAGE.ERROR_DESCRIPTION,r),this._saveItem(this.CONSTANTS.STORAGE.LOGIN_ERROR,n),e&&this._activeRenewals[e]&&(this._activeRenewals[e]=null),this._loginInProgress=!1,this._acquireTokenInProgress=!1,t&&t(r,null,i)},e.prototype._loginPopup=function(t,e,i){var r,n,o,a=this._openPopup(t,"login",this.CONSTANTS.POPUP_WIDTH,this.CONSTANTS.POPUP_HEIGHT),s=i||this.callback;null!=a?(this._openedWindows.push(a),r=-1!=this.config.redirectUri.indexOf("#")?this.config.redirectUri.split("#")[0]:this.config.redirectUri,n=this,o=window.setInterval(function(){if(!a||a.closed||void 0===a.closed){var t="Popup Window closed",i="Popup Window closed by UI action/ Popup Window handle destroyed due to cross zone navigation in IE/Edge";return n.isAngular&&n._broadcast("adal:popUpClosed",i+n.CONSTANTS.RESOURCE_DELIMETER+t),n._handlePopupError(s,e,t,i,i),void window.clearInterval(o)}try{var l=a.location;if(-1!=encodeURI(l.href).indexOf(encodeURI(r)))return n.isAngular?n._broadcast("adal:popUpHashChanged",l.hash):n.handleWindowCallback(l.hash),window.clearInterval(o),n._loginInProgress=!1,n._acquireTokenInProgress=!1,n.info("Closing popup window"),n._openedWindows=[],void a.close()}catch(t){}},1)):this._handlePopupError(s,e,"Error opening popup",i="Popup Window is null. This can happen if you are using IE",i)},e.prototype._broadcast=function(t,e){function i(t,e){e=e||{bubbles:!1,cancelable:!1,detail:void 0};var i=document.createEvent("CustomEvent");return i.initCustomEvent(t,e.bubbles,e.cancelable,e.detail),i}"function"!=typeof window.CustomEvent&&(i.prototype=window.Event.prototype,window.CustomEvent=i),e=new CustomEvent(t,{detail:e}),window.dispatchEvent(e)},e.prototype.loginInProgress=function(){return this._loginInProgress},e.prototype._hasResource=function(t){var e=this._getItem(this.CONSTANTS.STORAGE.TOKEN_KEYS);return e&&!this._isEmpty(e)&&-1<e.indexOf(t+this.CONSTANTS.RESOURCE_DELIMETER)},e.prototype.getCachedToken=function(t){if(!this._hasResource(t))return null;var e=this._getItem(this.CONSTANTS.STORAGE.ACCESS_TOKEN_KEY+t),i=this._getItem(this.CONSTANTS.STORAGE.EXPIRATION_KEY+t),r=this.config.expireOffsetSeconds||300;return i&&i>this._now()+r?e:(this._saveItem(this.CONSTANTS.STORAGE.ACCESS_TOKEN_KEY+t,""),this._saveItem(this.CONSTANTS.STORAGE.EXPIRATION_KEY+t,0),null)},e.prototype.getCachedUser=function(){if(this._user)return this._user;var t=this._getItem(this.CONSTANTS.STORAGE.IDTOKEN);return this._user=this._createUser(t),this._user},e.prototype.registerCallback=function(t,e,i){this._activeRenewals[e]=t,this._callBacksMappedToRenewStates[t]||(this._callBacksMappedToRenewStates[t]=[]);var r=this;this._callBacksMappedToRenewStates[t].push(i),this._callBackMappedToRenewStates[t]||(this._callBackMappedToRenewStates[t]=function(i,n,o,a){r._activeRenewals[e]=null;for(var s=0;s<r._callBacksMappedToRenewStates[t].length;++s)try{r._callBacksMappedToRenewStates[t][s](i,n,o,a)}catch(o){r.warn(o)}r._callBacksMappedToRenewStates[t]=null,r._callBackMappedToRenewStates[t]=null})},e.prototype._renewToken=function(t,e,i){this.info("renewToken is called for resource:"+t);var r=this._addAdalFrame("adalRenewFrame"+t),n=this._guid()+"|"+t;this.config.state=n,this._renewStates.push(n),this.verbose("Renew token Expected state: "+n);var o=this._urlRemoveQueryStringParameter(this._getNavigateUrl(i=i||"token",t),"prompt");i===this.RESPONSE_TYPE.ID_TOKEN_TOKEN&&(this._idTokenNonce=this._guid(),this._saveItem(this.CONSTANTS.STORAGE.NONCE_IDTOKEN,this._idTokenNonce,!0),o+="&nonce="+encodeURIComponent(this._idTokenNonce)),o=this._addHintParameters(o+="&prompt=none"),this.registerCallback(n,t,e),this.verbosePii("Navigate to:"+o),r.src="about:blank",this._loadFrameTimeout(o,"adalRenewFrame"+t,t)},e.prototype._renewIdToken=function(t,e){this.info("renewIdToken is called");var i=this._addAdalFrame("adalIdTokenFrame"),r=this._guid()+"|"+this.config.clientId;this._idTokenNonce=this._guid(),this._saveItem(this.CONSTANTS.STORAGE.NONCE_IDTOKEN,this._idTokenNonce,!0),this.config.state=r,this._renewStates.push(r),this.verbose("Renew Idtoken Expected state: "+r);var n=null==e?null:this.config.clientId;e=e||"id_token",n=this._urlRemoveQueryStringParameter(this._getNavigateUrl(e,n),"prompt"),n=this._addHintParameters(n+="&prompt=none");n+="&nonce="+encodeURIComponent(this._idTokenNonce),this.registerCallback(r,this.config.clientId,t),this.verbosePii("Navigate to:"+n),i.src="about:blank",this._loadFrameTimeout(n,"adalIdTokenFrame",this.config.clientId)},e.prototype._urlContainsQueryStringParameter=function(t,e){return new RegExp("[\\?&]"+t+"=").test(e)},e.prototype._urlRemoveQueryStringParameter=function(t,e){var i=new RegExp("(\\&"+e+"=)[^&]+");return t=t.replace(i,""),i=new RegExp("("+e+"=)[^&]+&"),t=t.replace(i,""),i=new RegExp("("+e+"=)[^&]+"),t.replace(i,"")},e.prototype._loadFrameTimeout=function(t,e,i){this.verbose("Set loading state to pending for: "+i),this._saveItem(this.CONSTANTS.STORAGE.RENEW_STATUS+i,this.CONSTANTS.TOKEN_RENEW_STATUS_IN_PROGRESS),this._loadFrame(t,e);var r=this;setTimeout(function(){var t;r._getItem(r.CONSTANTS.STORAGE.RENEW_STATUS+i)===r.CONSTANTS.TOKEN_RENEW_STATUS_IN_PROGRESS&&(r.verbose("Loading frame has timed out after: "+r.CONSTANTS.LOADFRAME_TIMEOUT/1e3+" seconds for resource "+i),(t=r._activeRenewals[i])&&r._callBackMappedToRenewStates[t]&&r._callBackMappedToRenewStates[t]("Token renewal operation failed due to timeout",null,"Token Renewal Failed"),r._saveItem(r.CONSTANTS.STORAGE.RENEW_STATUS+i,r.CONSTANTS.TOKEN_RENEW_STATUS_CANCELED))},r.CONSTANTS.LOADFRAME_TIMEOUT)},e.prototype._loadFrame=function(t,e){var i=this;i.info("LoadFrame: "+e);var r=e;setTimeout(function(){var e=i._addAdalFrame(r);""!==e.src&&"about:blank"!==e.src||(e.src=t,i._loadFrame(t,r))},500)},e.prototype.acquireToken=function(t,e){if(this._isEmpty(t))return this.warn("resource is required"),void e("resource is required",null,"resource is required");var i=this.getCachedToken(t);return i?(this.info("Token is already in cache for resource:"+t),void e(null,i,null)):this._user||this.config.extraQueryParameter&&-1!==this.config.extraQueryParameter.indexOf("login_hint")?void(this._activeRenewals[t]?this.registerCallback(this._activeRenewals[t],t,e):(this._requestType=this.REQUEST_TYPE.RENEW_TOKEN,t===this.config.clientId?this._user?(this.verbose("renewing idtoken"),this._renewIdToken(e)):(this.verbose("renewing idtoken and access_token"),this._renewIdToken(e,this.RESPONSE_TYPE.ID_TOKEN_TOKEN)):this._user?(this.verbose("renewing access_token"),this._renewToken(t,e)):(this.verbose("renewing idtoken and access_token"),this._renewToken(t,e,this.RESPONSE_TYPE.ID_TOKEN_TOKEN)))):(this.warn("User login is required"),void e("User login is required",null,"login required"))},e.prototype.acquireTokenPopup=function(t,e,i,r){if(this._isEmpty(t))return this.warn("resource is required"),void r("resource is required",null,"resource is required");if(!this._user)return this.warn("User login is required"),void r("User login is required",null,"login required");if(this._acquireTokenInProgress)return this.warn("Acquire token interactive is already in progress"),void r("Acquire token interactive is already in progress",null,"Acquire token interactive is already in progress");var n=this._guid()+"|"+t;this.config.state=n,this._renewStates.push(n),this._requestType=this.REQUEST_TYPE.RENEW_TOKEN,this.verbose("Renew token Expected state: "+n);var o=this._urlRemoveQueryStringParameter(this._getNavigateUrl("token",t),"prompt");if(o+="&prompt=select_account",e&&(o+=e),i&&-1===o.indexOf("&claims"))o+="&claims="+encodeURIComponent(i);else if(i&&-1!==o.indexOf("&claims"))throw new Error("Claims cannot be passed as an extraQueryParameter");o=this._addHintParameters(o),this._acquireTokenInProgress=!0,this.info("acquireToken interactive is called for the resource "+t),this.registerCallback(n,t,r),this._loginPopup(o,t,r)},e.prototype.acquireTokenRedirect=function(t,e,i){if(this._isEmpty(t))return this.warn("resource is required"),void r("resource is required",null,"resource is required");var r=this.callback;if(!this._user)return this.warn("User login is required"),void r("User login is required",null,"login required");if(this._acquireTokenInProgress)return this.warn("Acquire token interactive is already in progress"),void r("Acquire token interactive is already in progress",null,"Acquire token interactive is already in progress");var n=this._guid()+"|"+t;if(this.config.state=n,this.verbose("Renew token Expected state: "+n),r=this._urlRemoveQueryStringParameter(this._getNavigateUrl("token",t),"prompt"),r+="&prompt=select_account",e&&(r+=e),i&&-1===r.indexOf("&claims"))r+="&claims="+encodeURIComponent(i);else if(i&&-1!==r.indexOf("&claims"))throw new Error("Claims cannot be passed as an extraQueryParameter");r=this._addHintParameters(r),this._acquireTokenInProgress=!0,this.info("acquireToken interactive is called for the resource "+t),this._saveItem(this.CONSTANTS.STORAGE.LOGIN_REQUEST,window.location.href),this._saveItem(this.CONSTANTS.STORAGE.STATE_RENEW,n,!0),this.promptUser(r)},e.prototype.promptUser=function(t){t?(this.infoPii("Navigate to:"+t),window.location.replace(t)):this.info("Navigate url is empty")},e.prototype.clearCache=function(){this._saveItem(this.CONSTANTS.STORAGE.LOGIN_REQUEST,""),this._saveItem(this.CONSTANTS.STORAGE.ANGULAR_LOGIN_REQUEST,""),this._saveItem(this.CONSTANTS.STORAGE.SESSION_STATE,""),this._saveItem(this.CONSTANTS.STORAGE.STATE_LOGIN,""),this._saveItem(this.CONSTANTS.STORAGE.STATE_RENEW,""),this._renewStates=[],this._saveItem(this.CONSTANTS.STORAGE.NONCE_IDTOKEN,""),this._saveItem(this.CONSTANTS.STORAGE.IDTOKEN,""),this._saveItem(this.CONSTANTS.STORAGE.ERROR,""),this._saveItem(this.CONSTANTS.STORAGE.ERROR_DESCRIPTION,""),this._saveItem(this.CONSTANTS.STORAGE.LOGIN_ERROR,""),this._saveItem(this.CONSTANTS.STORAGE.LOGIN_ERROR,"");var t=this._getItem(this.CONSTANTS.STORAGE.TOKEN_KEYS);if(!this._isEmpty(t)){t=t.split(this.CONSTANTS.RESOURCE_DELIMETER);for(var e=0;e<t.length&&""!==t[e];e++)this._saveItem(this.CONSTANTS.STORAGE.ACCESS_TOKEN_KEY+t[e],""),this._saveItem(this.CONSTANTS.STORAGE.EXPIRATION_KEY+t[e],0)}this._saveItem(this.CONSTANTS.STORAGE.TOKEN_KEYS,"")},e.prototype.clearCacheForResource=function(t){this._saveItem(this.CONSTANTS.STORAGE.STATE_RENEW,""),this._saveItem(this.CONSTANTS.STORAGE.ERROR,""),this._saveItem(this.CONSTANTS.STORAGE.ERROR_DESCRIPTION,""),this._hasResource(t)&&(this._saveItem(this.CONSTANTS.STORAGE.ACCESS_TOKEN_KEY+t,""),this._saveItem(this.CONSTANTS.STORAGE.EXPIRATION_KEY+t,0))},e.prototype.logOut=function(){var t,e;this.clearCache(),this._user=null,e=this.config.logOutUri||(t="common",e="",this.config.tenant&&(t=this.config.tenant),this.config.postLogoutRedirectUri&&(e="post_logout_redirect_uri="+encodeURIComponent(this.config.postLogoutRedirectUri)),this.instance+t+"/oauth2/logout?"+e),this.infoPii("Logout navigate to: "+e),this.promptUser(e)},e.prototype._isEmpty=function(t){return void 0===t||!t||0===t.length},e.prototype.getUser=function(t){if("function"!=typeof t)throw new Error("callback is not a function");var e;this._user?t(null,this._user):(e=this._getItem(this.CONSTANTS.STORAGE.IDTOKEN),this._isEmpty(e)?(this.warn("User information is not available"),t("User information is not available",null)):(this.info("User exists in cache: "),this._user=this._createUser(e),t(null,this._user)))},e.prototype._addHintParameters=function(t){var e;return this._user&&this._user.profile&&(this._user.profile.sid&&-1!==t.indexOf("&prompt=none")?this._urlContainsQueryStringParameter("sid",t)||(t+="&sid="+encodeURIComponent(this._user.profile.sid)):this._user.profile.upn&&(this._urlContainsQueryStringParameter("login_hint",t)||(t+="&login_hint="+encodeURIComponent(this._user.profile.upn)),!this._urlContainsQueryStringParameter("domain_hint",t)&&-1<this._user.profile.upn.indexOf("@")&&(e=this._user.profile.upn.split("@"),t+="&domain_hint="+encodeURIComponent(e[e.length-1])))),t},e.prototype._createUser=function(t){var e=null;return(t=this._extractIdToken(t))&&t.hasOwnProperty("aud")&&(t.aud.toLowerCase()===this.config.clientId.toLowerCase()?(e={userName:"",profile:t},t.hasOwnProperty("upn")?e.userName=t.upn:t.hasOwnProperty("email")&&(e.userName=t.email)):this.warn("IdToken has invalid aud field")),e},e.prototype._getHash=function(t){return-1<t.indexOf("#/")?t=t.substring(t.indexOf("#/")+2):-1<t.indexOf("#")&&(t=t.substring(1)),t},e.prototype.isCallback=function(t){return t=this._getHash(t),(t=this._deserialize(t)).hasOwnProperty(this.CONSTANTS.ERROR_DESCRIPTION)||t.hasOwnProperty(this.CONSTANTS.ACCESS_TOKEN)||t.hasOwnProperty(this.CONSTANTS.ID_TOKEN)},e.prototype.getLoginError=function(){return this._getItem(this.CONSTANTS.STORAGE.LOGIN_ERROR)},e.prototype.getRequestInfo=function(t){t=this._getHash(t);var e=this._deserialize(t),i={valid:!1,parameters:{},stateMatch:!1,stateResponse:"",requestType:this.REQUEST_TYPE.UNKNOWN};if(e&&((i.parameters=e).hasOwnProperty(this.CONSTANTS.ERROR_DESCRIPTION)||e.hasOwnProperty(this.CONSTANTS.ACCESS_TOKEN)||e.hasOwnProperty(this.CONSTANTS.ID_TOKEN))){if(i.valid=!0,t="",!e.hasOwnProperty("state"))return this.warn("No state returned"),i;if(this.verbose("State: "+e.state),t=e.state,i.stateResponse=t,this._matchState(i))return i;if(!i.stateMatch&&window.parent){i.requestType=this._requestType;for(var r=this._renewStates,n=0;n<r.length;n++)if(r[n]===i.stateResponse){i.stateMatch=!0;break}}}return i},e.prototype._matchNonce=function(t){if(e=this._getItem(this.CONSTANTS.STORAGE.NONCE_IDTOKEN))for(var e=e.split(this.CONSTANTS.CACHE_DELIMETER),i=0;i<e.length;i++)if(e[i]&&e[i]===t.profile.nonce)return!0;return!1},e.prototype._matchState=function(t){if(e=this._getItem(this.CONSTANTS.STORAGE.STATE_LOGIN))for(var e=e.split(this.CONSTANTS.CACHE_DELIMETER),i=0;i<e.length;i++)if(e[i]&&e[i]===t.stateResponse)return t.requestType=this.REQUEST_TYPE.LOGIN,t.stateMatch=!0;if(r=this._getItem(this.CONSTANTS.STORAGE.STATE_RENEW)){var r=r.split(this.CONSTANTS.CACHE_DELIMETER);for(i=0;i<r.length;i++)if(r[i]&&r[i]===t.stateResponse)return t.requestType=this.REQUEST_TYPE.RENEW_TOKEN,t.stateMatch=!0}return!1},e.prototype._getResourceFromState=function(t){if(t){var e=t.indexOf("|");if(-1<e&&e+1<t.length)return t.substring(e+1)}return""},e.prototype.saveTokenFromHash=function(t){this.info("State status:"+t.stateMatch+"; Request type:"+t.requestType),this._saveItem(this.CONSTANTS.STORAGE.ERROR,""),this._saveItem(this.CONSTANTS.STORAGE.ERROR_DESCRIPTION,"");var e,i=this._getResourceFromState(t.stateResponse);t.parameters.hasOwnProperty(this.CONSTANTS.ERROR_DESCRIPTION)?(this.infoPii("Error :"+t.parameters.error+"; Error description:"+t.parameters[this.CONSTANTS.ERROR_DESCRIPTION]),this._saveItem(this.CONSTANTS.STORAGE.ERROR,t.parameters.error),this._saveItem(this.CONSTANTS.STORAGE.ERROR_DESCRIPTION,t.parameters[this.CONSTANTS.ERROR_DESCRIPTION]),t.requestType===this.REQUEST_TYPE.LOGIN&&(this._loginInProgress=!1,this._saveItem(this.CONSTANTS.STORAGE.LOGIN_ERROR,t.parameters.error_description))):t.stateMatch?(this.info("State is right"),t.parameters.hasOwnProperty(this.CONSTANTS.SESSION_STATE)&&this._saveItem(this.CONSTANTS.STORAGE.SESSION_STATE,t.parameters[this.CONSTANTS.SESSION_STATE]),t.parameters.hasOwnProperty(this.CONSTANTS.ACCESS_TOKEN)&&(this.info("Fragment has access token"),this._hasResource(i)||(e=this._getItem(this.CONSTANTS.STORAGE.TOKEN_KEYS)||"",this._saveItem(this.CONSTANTS.STORAGE.TOKEN_KEYS,e+i+this.CONSTANTS.RESOURCE_DELIMETER)),this._saveItem(this.CONSTANTS.STORAGE.ACCESS_TOKEN_KEY+i,t.parameters[this.CONSTANTS.ACCESS_TOKEN]),this._saveItem(this.CONSTANTS.STORAGE.EXPIRATION_KEY+i,this._expiresIn(t.parameters[this.CONSTANTS.EXPIRES_IN]))),t.parameters.hasOwnProperty(this.CONSTANTS.ID_TOKEN)&&(this.info("Fragment has id token"),this._loginInProgress=!1,this._user=this._createUser(t.parameters[this.CONSTANTS.ID_TOKEN]),this._user&&this._user.profile?this._matchNonce(this._user)?(this._saveItem(this.CONSTANTS.STORAGE.IDTOKEN,t.parameters[this.CONSTANTS.ID_TOKEN]),i=this.config.loginResource||this.config.clientId,this._hasResource(i)||(e=this._getItem(this.CONSTANTS.STORAGE.TOKEN_KEYS)||"",this._saveItem(this.CONSTANTS.STORAGE.TOKEN_KEYS,e+i+this.CONSTANTS.RESOURCE_DELIMETER)),this._saveItem(this.CONSTANTS.STORAGE.ACCESS_TOKEN_KEY+i,t.parameters[this.CONSTANTS.ID_TOKEN]),this._saveItem(this.CONSTANTS.STORAGE.EXPIRATION_KEY+i,this._user.profile.exp)):(this._saveItem(this.CONSTANTS.STORAGE.LOGIN_ERROR,"Nonce received: "+this._user.profile.nonce+" is not same as requested: "+this._getItem(this.CONSTANTS.STORAGE.NONCE_IDTOKEN)),this._user=null):(t.parameters.error="invalid id_token",t.parameters.error_description="Invalid id_token. id_token: "+t.parameters[this.CONSTANTS.ID_TOKEN],this._saveItem(this.CONSTANTS.STORAGE.ERROR,"invalid id_token"),this._saveItem(this.CONSTANTS.STORAGE.ERROR_DESCRIPTION,"Invalid id_token. id_token: "+t.parameters[this.CONSTANTS.ID_TOKEN])))):(t.parameters.error="Invalid_state",t.parameters.error_description="Invalid_state. state: "+t.stateResponse,this._saveItem(this.CONSTANTS.STORAGE.ERROR,"Invalid_state"),this._saveItem(this.CONSTANTS.STORAGE.ERROR_DESCRIPTION,"Invalid_state. state: "+t.stateResponse)),this._saveItem(this.CONSTANTS.STORAGE.RENEW_STATUS+i,this.CONSTANTS.TOKEN_RENEW_STATUS_COMPLETED)},e.prototype.getResourceForEndpoint=function(t){if(this.config&&this.config.anonymousEndpoints)for(var e=0;e<this.config.anonymousEndpoints.length;e++)if(-1<t.indexOf(this.config.anonymousEndpoints[e]))return null;if(this.config&&this.config.endpoints)for(var i in this.config.endpoints)if(-1<t.indexOf(i))return this.config.endpoints[i];return(-1<t.indexOf("http://")||-1<t.indexOf("https://"))&&this._getHostFromUri(t)!==this._getHostFromUri(this.config.redirectUri)?null:this.config.loginResource},e.prototype._getHostFromUri=function(t){return String(t).replace(/^(https?:)\/\//,"").split("/")[0]},e.prototype.handleWindowCallback=function(t){if(null==t&&(t=window.location.hash),this.isCallback(t)){var e=null,i=!1;0<this._openedWindows.length&&this._openedWindows[this._openedWindows.length-1].opener&&this._openedWindows[this._openedWindows.length-1].opener._adalInstance?(e=this._openedWindows[this._openedWindows.length-1].opener._adalInstance,i=!0):window.parent&&window.parent._adalInstance&&(e=window.parent._adalInstance);var r,n=e.getRequestInfo(t),o=null,a=i||window.parent!==window?e._callBackMappedToRenewStates[n.stateResponse]:e.callback;e.info("Returned from redirect url"),e.saveTokenFromHash(n),n.requestType===this.REQUEST_TYPE.RENEW_TOKEN&&window.parent?(window.parent!==window?e.verbose("Window is in iframe, acquiring token silently"):e.verbose("acquiring token interactive in progress"),r=n.parameters[e.CONSTANTS.ACCESS_TOKEN]||n.parameters[e.CONSTANTS.ID_TOKEN],o=e.CONSTANTS.ACCESS_TOKEN):n.requestType===this.REQUEST_TYPE.LOGIN&&(r=n.parameters[e.CONSTANTS.ID_TOKEN],o=e.CONSTANTS.ID_TOKEN),t=n.parameters[e.CONSTANTS.ERROR_DESCRIPTION],n=n.parameters[e.CONSTANTS.ERROR];try{a&&a(t,r,n,o)}catch(t){e.error("Error occurred in user defined callback function: "+t)}window.parent!==window||i||(e.config.navigateToLoginRequestUrl?window.location.href=e._getItem(e.CONSTANTS.STORAGE.LOGIN_REQUEST):window.location.hash="")}},e.prototype._getNavigateUrl=function(t,e){var i="common";return this.config.tenant&&(i=this.config.tenant),e=this.instance+i+"/oauth2/authorize"+this._serialize(t,this.config,e)+this._addLibMetadata(),this.info("Navigate url:"+e),e},e.prototype._extractIdToken=function(t){if(!(t=this._decodeJwt(t)))return null;try{var e=t.JWSPayload,i=this._base64DecodeStringUrlSafe(e);return i?JSON.parse(i):(this.info("The returned id_token could not be base64 url safe decoded."),null)}catch(t){this.error("The returned id_token could not be decoded",t)}return null},e.prototype._base64DecodeStringUrlSafe=function(t){return t=t.replace(/-/g,"+").replace(/_/g,"/"),window.atob?decodeURIComponent(escape(window.atob(t))):decodeURIComponent(escape(this._decode(t)))},e.prototype._decode=function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",i=(t=String(t).replace(/=+$/,"")).length;if(i%4==1)throw new Error("The token to be decoded is not correctly encoded.");for(var r,n,o,a,s,l,u,c="",p=0;p<i;p+=4){if(r=e.indexOf(t.charAt(p)),n=e.indexOf(t.charAt(p+1)),o=e.indexOf(t.charAt(p+2)),a=e.indexOf(t.charAt(p+3)),p+2===i-1){l=(s=r<<18|n<<12|o<<6)>>16&255,u=s>>8&255,c+=String.fromCharCode(l,u);break}if(p+1===i-1){l=(s=r<<18|n<<12)>>16&255,c+=String.fromCharCode(l);break}l=(s=r<<18|n<<12|o<<6|a)>>16&255,u=s>>8&255,c+=String.fromCharCode(l,u,255&s)}return c},e.prototype._decodeJwt=function(t){return this._isEmpty(t)?null:!(t=/^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/.exec(t))||t.length<4?(this.warn("The returned id_token is not parseable."),null):{header:t[1],JWSPayload:t[2],JWSSig:t[3]}},e.prototype._convertUrlSafeToRegularBase64EncodedString=function(t){return t.replace("-","+").replace("_","/")},e.prototype._serialize=function(t,e,i){var r=[];return null!==e&&(r.push("?response_type="+t),r.push("client_id="+encodeURIComponent(e.clientId)),i&&r.push("resource="+encodeURIComponent(i)),r.push("redirect_uri="+encodeURIComponent(e.redirectUri)),r.push("state="+encodeURIComponent(e.state)),e.hasOwnProperty("slice")&&r.push("slice="+encodeURIComponent(e.slice)),e.hasOwnProperty("extraQueryParameter")&&r.push(e.extraQueryParameter),e=e.correlationId||this._guid(),r.push("client-request-id="+encodeURIComponent(e))),r.join("&")},e.prototype._deserialize=function(t){for(var e=/\+/g,i=/([^&=]+)=([^&]*)/g,r=function(t){return decodeURIComponent(t.replace(e," "))},n={},o=i.exec(t);o;)n[r(o[1])]=r(o[2]),o=i.exec(t);return n},e.prototype._decimalToHex=function(t){for(var e=t.toString(16);e.length<2;)e="0"+e;return e},e.prototype._guid=function(){var t=window.crypto||window.msCrypto;if(t&&t.getRandomValues){var e=new Uint8Array(16);return t.getRandomValues(e),e[6]|=64,e[6]&=79,e[8]|=128,e[8]&=191,this._decimalToHex(e[0])+this._decimalToHex(e[1])+this._decimalToHex(e[2])+this._decimalToHex(e[3])+"-"+this._decimalToHex(e[4])+this._decimalToHex(e[5])+"-"+this._decimalToHex(e[6])+this._decimalToHex(e[7])+"-"+this._decimalToHex(e[8])+this._decimalToHex(e[9])+"-"+this._decimalToHex(e[10])+this._decimalToHex(e[11])+this._decimalToHex(e[12])+this._decimalToHex(e[13])+this._decimalToHex(e[14])+this._decimalToHex(e[15])}for(var i="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx",r="0123456789abcdef",n=0,o="",a=0;a<36;a++)"-"!==i[a]&&"4"!==i[a]&&(n=16*Math.random()|0),"x"===i[a]?o+=r[n]:"y"===i[a]?(n&=3,o+=r[n|=8]):o+=i[a];return o},e.prototype._expiresIn=function(t){return t=t||3599,this._now()+parseInt(t,10)},e.prototype._now=function(){return Math.round((new Date).getTime()/1e3)},e.prototype._addAdalFrame=function(t){if(void 0!==t){this.info("Add adal frame to document:"+t);var e,i=document.getElementById(t);return i||(document.createElement&&document.documentElement&&(window.opera||-1===window.navigator.userAgent.indexOf("MSIE 5.0"))?((e=document.createElement("iframe")).setAttribute("id",t),e.setAttribute("aria-hidden","true"),e.style.visibility="hidden",e.style.position="absolute",e.style.width=e.style.height=e.borderWidth="0px",i=document.getElementsByTagName("body")[0].appendChild(e)):document.body&&document.body.insertAdjacentHTML&&document.body.insertAdjacentHTML("beforeEnd",'<iframe name="'+t+'" id="'+t+'" style="display:none"></iframe>'),window.frames&&window.frames[t]&&(i=window.frames[t])),i}},e.prototype._saveItem=function(t,e,i){return this.config&&this.config.cacheLocation&&"localStorage"===this.config.cacheLocation?this._supportsLocalStorage()?(i?(i=this._getItem(t)||"",localStorage.setItem(t,i+e+this.CONSTANTS.CACHE_DELIMETER)):localStorage.setItem(t,e),!0):(this.info("Local storage is not supported"),!1):this._supportsSessionStorage()?(sessionStorage.setItem(t,e),!0):(this.info("Session storage is not supported"),!1)},e.prototype._getItem=function(t){return this.config&&this.config.cacheLocation&&"localStorage"===this.config.cacheLocation?this._supportsLocalStorage()?localStorage.getItem(t):(this.info("Local storage is not supported"),null):this._supportsSessionStorage()?sessionStorage.getItem(t):(this.info("Session storage is not supported"),null)},e.prototype._supportsLocalStorage=function(){try{return!!window.localStorage&&(window.localStorage.setItem("storageTest","A"),"A"==window.localStorage.getItem("storageTest")&&(window.localStorage.removeItem("storageTest"),!window.localStorage.getItem("storageTest")))}catch(t){return!1}},e.prototype._supportsSessionStorage=function(){try{return!!window.sessionStorage&&(window.sessionStorage.setItem("storageTest","A"),"A"==window.sessionStorage.getItem("storageTest")&&(window.sessionStorage.removeItem("storageTest"),!window.sessionStorage.getItem("storageTest")))}catch(t){return!1}},e.prototype._cloneConfig=function(t){if(null===t||"object"!=typeof t)return t;var e,i={};for(e in t)t.hasOwnProperty(e)&&(i[e]=t[e]);return i},e.prototype._addLibMetadata=function(){return"&x-client-SKU=Js&x-client-Ver="+this._libVersion()},e.prototype.log=function(t,e,i,r){var n;t<=Logging.level&&(!Logging.piiLoggingEnabled&&r||(n=(new Date).toUTCString(),r="",r=this.config.correlationId?n+":"+this.config.correlationId+"-"+this._libVersion()+"-"+this.CONSTANTS.LEVEL_STRING_MAP[t]+" "+e:n+":"+this._libVersion()+"-"+this.CONSTANTS.LEVEL_STRING_MAP[t]+" "+e,i&&(r+="\nstack:\n"+i.stack),Logging.log(r)))},e.prototype.error=function(t,e){this.log(this.CONSTANTS.LOGGING_LEVEL.ERROR,t,e)},e.prototype.warn=function(t){this.log(this.CONSTANTS.LOGGING_LEVEL.WARN,t,null)},e.prototype.info=function(t){this.log(this.CONSTANTS.LOGGING_LEVEL.INFO,t,null)},e.prototype.verbose=function(t){this.log(this.CONSTANTS.LOGGING_LEVEL.VERBOSE,t,null)},e.prototype.errorPii=function(t,e){this.log(this.CONSTANTS.LOGGING_LEVEL.ERROR,t,e,!0)},e.prototype.warnPii=function(t){this.log(this.CONSTANTS.LOGGING_LEVEL.WARN,t,null,!0)},e.prototype.infoPii=function(t){this.log(this.CONSTANTS.LOGGING_LEVEL.INFO,t,null,!0)},e.prototype.verbosePii=function(t){this.log(this.CONSTANTS.LOGGING_LEVEL.VERBOSE,t,null,!0)},e.prototype._libVersion=function(){return"1.0.18"},t.exports&&(t.exports=e,t.exports.inject=function(t){return new e(t)}),e)});function xm(t){this.message=t}_m.inject,(xm.prototype=new Error).name="InvalidCharacterError";var bm="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(t){var e=String(t).replace(/=+$/,"");if(e.length%4==1)throw new xm("'atob' failed: The string to be decoded is not correctly encoded.");for(var i,r,n=0,o=0,a="";r=e.charAt(o++);~r&&(i=n%4?64*i+r:r,n++%4)&&(a+=String.fromCharCode(255&i>>(-2*n&6))))r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r);return a};function wm(t){this.message=t}function Sm(t,e){if("string"!=typeof t)throw new wm("Invalid token specified");e=!0===(e=e||{}).header?0:1;try{return JSON.parse(function(t){var e=t.replace(/-/g,"+").replace(/_/g,"/");switch(e.length%4){case 0:break;case 2:e+="==";break;case 3:e+="=";break;default:throw"Illegal base64url string!"}try{return decodeURIComponent(bm(e).replace(/(.)/g,function(t,e){return"%"+((e=e.charCodeAt(0).toString(16).toUpperCase()).length<2?"0"+e:e)}))}catch(t){return bm(e)}}(t.split(".")[e]))}catch(t){throw new wm("Invalid token specified: "+t.message)}}(wm.prototype=new Error).name="InvalidTokenError",Sm.InvalidTokenError=wm;var Tm=(Cm.prototype.initialize=function(){var e=this;return this.initPromise||(this.initPromise=new Promise(function(i,r){e.options.authType===t.AuthenticationType.subscriptionKey?i():e.options.authType===t.AuthenticationType.aad?(e.options.authContext=e.options.authContext||Cm.getDefaultAuthContext(e.options),e.options.authContext.handleWindowCallback(),e.options.authContext.getLoginError()?r(new Error("Error logging in the AAD users: "+e.options.authContext.getLoginError())):e.options.authContext.isCallback(window.location.hash)?e.map.dispose():setTimeout(function(){return e._loginAndAcquire(i,r)})):e.options.authType===t.AuthenticationType.anonymous?i(e._triggerTokenFetch()):r(new Error("An invalid authentication type was specified."))})),this.initPromise},Cm.getDefaultAuthContext=function(t){if(!t.aadAppId)throw new Error("No AAD app ID was specified.");if(!t.aadTenant)throw new Error("No AAD tenant was specified.");return this.defaultAuthContext||(this.defaultAuthContext=new _m({instance:t.aadInstance||"https://login.microsoftonline.com/",tenant:t.aadTenant,clientId:t.aadAppId,cacheLocation:this.constants.preferredCacheLocation})),this.defaultAuthContext},Cm.prototype._loginAndAcquire=function(t,e){function i(){n.options.authContext.acquireToken(x,function(i){i?e(new Error(i)):(i={map:n.map,type:Cm.constants.events.tokenAcquired},n.map.events.invoke(Cm.constants.events.tokenAcquired,i),t())})}var r,n=this,o=this.options.authContext.getCachedToken(this.options.aadAppId),a=this.options.authContext.getCachedUser();o&&a?i():(this.options.authContext.loginInProgress()||this.options.authContext.login(),r=setInterval(function(){n.options.authContext.loginInProgress()||(clearInterval(r),n.options.authContext.getCachedToken(n.options.aadAppId)?i():e(new Error(n.options.authContext.getLoginError()||"The AAD authentication context is not logged-in for the specified app ID: "+n.options.aadAppId)))},25))},Cm.prototype.getAuthType=function(){return this.options.authType},Cm.prototype.getClientId=function(){return this.options.clientId},Cm.prototype.getToken=function(){var e=this;if(this.options.authType===t.AuthenticationType.aad){var i=this.options.authContext.getCachedToken(x);return i||(this.options.authContext.getCachedUser()||this.options.authContext.login(),this.options.authContext.acquireToken(x,function(t,r){t||(i=r,r={map:e.map,type:Cm.constants.events.tokenAcquired},e.map.events.invoke(Cm.constants.events.tokenAcquired,r))})),i}if(this.options.authType===t.AuthenticationType.anonymous){var r=this._getItem(Cm.constants.storage.accessTokenKey);if(r){var n=this._getTokenExpiry(r);if(n<300&&0<n)this._triggerTokenFetch();else if(n<=0)throw this._saveItem(Cm.constants.storage.accessTokenKey,""),new Error(Cm.constants.errors.tokenExpired)}else this._triggerTokenFetch();return r}if(this.options.authType===t.AuthenticationType.subscriptionKey)return this.options.subscriptionKey},Cm.prototype._getTokenExpiry=function(t){var e=Sm(t).exp;return 0<e-(t=this._getCurrentTime())?e-t:-1},Cm.prototype._storeAccessToken=function(t){this._saveItem(Cm.constants.storage.accessTokenKey,t),t={map:this.map,type:Cm.constants.events.tokenAcquired},this.map.events.invoke(Cm.constants.events.tokenAcquired,t)},Cm.prototype._saveItem=function(t,e){return this._supportsLocalStorage()?localStorage.setItem(t,e):this._supportsSessionStorage()?sessionStorage.setItem(t,e):this.fallbackStorage[t]=e,!0},Cm.prototype._getItem=function(t){return this._supportsLocalStorage()?localStorage.getItem(t):this._supportsSessionStorage()?sessionStorage.getItem(t):t in this.fallbackStorage?this.fallbackStorage[t]:null},Cm.prototype._supportsLocalStorage=function(){try{return!!window.localStorage&&(window.localStorage.setItem(Cm.constants.storage.testStorageKey,"A"),"A"===window.localStorage.getItem(Cm.constants.storage.testStorageKey)&&(window.localStorage.removeItem(Cm.constants.storage.testStorageKey),!window.localStorage.getItem(Cm.constants.storage.testStorageKey)))}catch(t){return!1}},Cm.prototype._supportsSessionStorage=function(){try{return!!window.sessionStorage&&(window.sessionStorage.setItem(Cm.constants.storage.testStorageKey,"A"),"A"===window.sessionStorage.getItem(Cm.constants.storage.testStorageKey)&&(window.sessionStorage.removeItem(Cm.constants.storage.testStorageKey),!window.sessionStorage.getItem(Cm.constants.storage.testStorageKey)))}catch(t){return!1}},Cm.prototype._getCurrentTime=function(){return Math.round((new Date).getTime()/1e3)},Cm.prototype.signRequest=function(e){e.headers=e.headers||{},e.headers["Session-Id"]=this.sessionId,e.headers["Ms-Am-Request-Origin"]="MapControl",e.headers["Map-Agent"]="MapControl/2.1.4 (Web)";var i=this.getToken();switch(this.options.authType){case t.AuthenticationType.aad:case t.AuthenticationType.anonymous:e.headers["x-ms-client-id"]=this.options.clientId,e.headers.Authorization="Bearer "+i;break;case t.AuthenticationType.subscriptionKey:if("url"in e)-1!==e.url.indexOf("?")?e.url+="&subscription-key="+i:e.url+="?&subscription-key="+i;else{if(!("domain"in e))throw new Error("Could not determine if the provided object was UrlOptions or RequestParameters");e.queryParams=e.queryParams||{},e.queryParams["subscription-key"]=i}break;default:throw new Error("An invalid authentication type was specified")}return e},Cm.constants={preferredCacheLocation:"localStorage",storage:{accessTokenKey:"access.token.key",testStorageKey:"testStorage"},events:{tokenAcquired:"tokenacquired"},tokenExpiresIn:3599,tokenRefreshClockSkew:300,errors:{tokenExpired:"Token Expired, Try again"}},Cm);function Cm(t){var e=this;this.fallbackStorage={},this._triggerTokenFetch=function(){return new Promise(function(t,i){e.options.getToken(function(r){try{var n=e._getTokenExpiry(r)-Cm.constants.tokenRefreshClockSkew;e._storeAccessToken(r),clearTimeout(e.tokenTimeOutHandle),e.tokenTimeOutHandle=setTimeout(e._triggerTokenFetch,1e3*n),t()}catch(r){i(new Error("Invalid token returned by getToken function"))}},function(t){i(t)},e.map)})};var i=t.getServiceOptions();this.options=i.authOptions,this.sessionId=i.sessionId,this.map=t}var Em=(Im.prototype.add=function(t,e){var i,r;if(Array.isArray(t))try{for(var n=E(t),o=n.next();!o.done;o=n.next()){var a=o.value;this._add(a,e)}}catch(t){i={error:t}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(i)throw i.error}}else this._add(t,e)},Im.prototype.getControls=function(){return Array.from(this.controls)},Im.prototype.remove=function(t){var e,i;if(Array.isArray(t))try{for(var r=E(t),n=r.next();!n.done;n=r.next()){var o=n.value;this._remove(o)}}catch(t){e={error:t}}finally{try{n&&!n.done&&(i=r.return)&&i.call(r)}finally{if(e)throw e.error}}else this._remove(t)},Im.prototype._add=function(t,e){this.controls.add(t);var i=(new U).merge(e);t=t.onAdd(this.map,e);if(!(0<(e=this.controlContainer.getElementsByClassName(i.position)).length))throw new Error("Control position "+i.position+" does not exist.");e.item(0).appendChild(t)},Im.prototype._remove=function(t){t.onRemove(),this.controls.delete(t)},Im);function Im(e){for(var i in this.map=e,this.controlContainer=document.createElement("div"),this.controlContainer.classList.add("atlas-control-container"),t.ControlPosition){var r;t.ControlPosition.hasOwnProperty(i)&&((r=document.createElement("div")).classList.add(t.ControlPosition[i]),r.classList.add("subcontrol-container"),this.controlContainer.appendChild(r))}this.map.getMapContainer().appendChild(this.controlContainer),this.controls=new Set}var km=(Am.prototype.addCallback=function(t,e,i,r,n){var o,a,s=this;if(r)o=function(t){var e=t.lngLat?new Wr(t.lngLat.lng,t.lngLat.lat):void 0,r=t.point?[t.point.x,t.point.y]:void 0,n=t.features?t.features.map(function(t){return new Vi(t.geometry,t.properties,t.id)}):[];n={type:t.type,originalEvent:t.originalEvent,position:e,coordinate:r,features:n};i(n)};else switch(t){case"data":case"sourcedata":case"styledata":o=function(r){r=S(S({dataType:r.dataType},"source"===r.dataType&&S(S(S({isSourceLoaded:r.isSourceLoaded},r.sourceDataType&&{sourceDataType:r.sourceDataType}),{source:s.map.sources.getById(r.sourceId)}),r.tile&&{tile:{id:{x:r.tile.tileID.canonical.x,y:r.tile.tileID.canonical.y,z:r.tile.tileID.canonical.z},size:r.tile.tileSize,state:r.tile.state}})),{map:s.map,type:r.type}),n&&s.map.events._removeListener(t,e,i),i(r)};break;case"error":o=function(r){r={error:r.error,map:s.map,type:r.type},n&&s.map.events._removeListener(t,e,i),i(r)};break;case"touchstart":case"touchend":case"touchmove":case"touchcancel":o=function(r){if(r.originalEvent){if(r.originalEvent===a)return;a=r.originalEvent}var o=r.point?new Gi(r.point.x,r.point.y):void 0,l=r.points?r.points.map(function(t){return new Gi(t.x,t.y)}):[],u=r.lngLat?new Wr(r.lngLat.lng,r.lngLat.lat):void 0,c=r.lngLats?r.lngLats.map(function(t){return new Wr(t.lng,t.lat)}):[],p=u?s.map.layers.getRenderedShapes(new Wi(u),e?[e]:void 0):[];p={map:s.map,originalEvent:r.originalEvent,pixel:o,pixels:l,position:u,positions:c,shapes:p,layerId:e||void 0,preventDefault:function(){return r.preventDefault()},type:r.type};n&&s.map.events._removeListener(t,e,i),i(p)};break;case"mousedown":case"mouseup":case"mouseover":case"mousemove":case"click":case"dblclick":case"mouseout":case"mouseenter":case"mouseleave":case"contextmenu":o=function(r){if(r.originalEvent){if(r.originalEvent===a)return;a=r.originalEvent}var o=r.lngLat?new Wr(r.lngLat.lng,r.lngLat.lat):void 0,l=r.point?new Gi(r.point.x,r.point.y):void 0,u=o?s.map.layers.getRenderedShapes(new Wi(o),e?[e]:void 0):[];u={map:s.map,originalEvent:r.originalEvent,position:o,pixel:l,preventDefault:function(){return r.preventDefault()},shapes:u,layerId:e||void 0,type:r.type};n&&s.map.events._removeListener(t,e,i),i(u)};break;case"styleimagemissing":o=function(r){n&&s.map.events._removeListener(t,e,i),i(r.id)};break;case"wheel":o=function(r){if(r.originalEvent){if(r.originalEvent===a)return;a=r.originalEvent}var o={map:s.map,originalEvent:r.originalEvent,preventDefault:function(){return r.preventDefault()},type:r.type};n&&s.map.events._removeListener(t,e,i),i(o)};break;case"resize":o=function(r){var o,a={map:s.map,type:r.type};for(o in r)"type"!==o&&"target"!==o&&(a[o]=r[o]);n&&s.map.events._removeListener(t,e,i),i(a)};break;default:o=function(r){var o={map:s.map,type:r.type};r.originalEvent&&(o.originalEvent=r.originalEvent),n&&s.map.events._removeListener(t,e,i),i(o)}}this.callbacks.has(e)||this.callbacks.set(e,new H),this.callbacks.get(e).has(t)||this.callbacks.get(e).set(t,new Map),this.callbacks.get(e).get(t).set(i,[o,n])},Am.prototype.removeCallback=function(t,e,i){this.callbacks.has(e)&&this.callbacks.get(e).has(t)&&this.callbacks.get(e).get(t).has(i)&&this.callbacks.get(e).get(t).delete(i)},Am.prototype.getModifiedCallback=function(t,e,i){if(this.callbacks.has(e)&&this.callbacks.get(e).has(t)&&this.callbacks.get(e).get(t).has(i))return this.callbacks.get(e).get(t).get(i)[0]},Am.prototype.getLayerCallbacks=function(t){if(this.callbacks.has(t))return this.callbacks.get(t)},Am.prototype.getEventCallbacks=function(t,e){if(this.callbacks.has(e)&&(e=this.callbacks.get(e)).has(t))return e.get(t)},Am);function Am(t){this.callbacks=new H,this.map=t}var Pm=(Mm.prototype.add=function(t,e,i){var r,n;if("function"==typeof e)this._addGlobalListener(t,e,!1,!1);else{e=Array.isArray(e)?e:[e];try{for(var o=E(e),a=o.next();!a.done;a=o.next()){var s=a.value;s instanceof zn&&zn._isMBoxEvent(t)?this._addLayerListener(t,s,i,!1,!1):s._addEventListener(t,i,!1)}}catch(t){r={error:t}}finally{try{a&&!a.done&&(n=o.return)&&n.call(o)}finally{if(r)throw r.error}}}},Mm.prototype.addOnce=function(t,e,i){"function"==typeof e?this._addGlobalListener(t,e,!1,!0):e instanceof zn&&zn._isMBoxEvent(t)?this._addLayerListener(t,e,i,!1,!0):e._addEventListener(t,i,!0)},Mm.prototype._addLegacy=function(t,e,i){"function"==typeof e?this._addGlobalListener(t,e,!0,!1):this._addLayerListener(t,e,i,!0,!1)},Mm.prototype._addLayerListener=function(t,e,i,r,n){var o,a,s,l,u=e instanceof zn?e.getId():e,c=(e=this.map.layers.getLayerById(u),this.mapCallbackHandler.getModifiedCallback(t,u,i));if(c&&e)try{for(var p=E(e._getLayerIds()),h=p.next();!h.done;h=p.next()){var d=h.value;this.map._getMap().off(t,d,c)}}catch(t){o={error:t}}finally{try{h&&!h.done&&(a=p.return)&&a.call(p)}finally{if(o)throw o.error}}if(this.mapCallbackHandler.addCallback(t,u,i,r,n),e){c=this.mapCallbackHandler.getModifiedCallback(t,u,i);try{for(var f=E(e._getLayerIds()),m=f.next();!m.done;m=f.next())d=m.value,this.map._getMap().on(t,d,c)}catch(t){s={error:t}}finally{try{m&&!m.done&&(l=f.return)&&l.call(f)}finally{if(s)throw s.error}}}},Mm.prototype._addGlobalListener=function(t,e,i,r){var n=this.mapCallbackHandler.getModifiedCallback(t,"",e);this.mapCallbackHandler.addCallback(t,"",e,i,r);var o,a,s=this.mapCallbackHandler.getModifiedCallback(t,"",e);"load"===t&&this.map._isLoaded()?(o={type:"load",map:this.map},setTimeout(function(){return s(o)})):"ready"===t?this.map._isReady()&&(a={type:"ready",map:this.map},setTimeout(function(){return s(a)})):["minzoomchanged","maxzoomchanged"].includes(t)?this.map._addEventListener(t,e,r):(n&&this.map._getMap().off(t,n),this.map._getMap().on(t,s))},Mm.prototype.invoke=function(t,e,i){if(void 0===i)this._invokeListeners(t,"",e);else if(e instanceof zn&&zn._isMBoxEvent(t))this._invokeListeners(t,e.getId(),i);else{if(!(e instanceof G))throw new Error("The invoke target is invalid.");e._invokeEvent(t,i)}},Mm.prototype._invokeListeners=function(t,e,i){var r=this,n=this.mapCallbackHandler.getEventCallbacks(t,e);n?n.forEach(function(n,o){(n=I(n,2))[0],n[1]&&r._removeListener(t,e,o),o(i)}):"error"===t&&console.error("error"in i?i.error:i)},Mm.prototype.remove=function(t,e,i){var r,n;if("function"==typeof e)this._removeListener(t,"",e);else{e=Array.isArray(e)?e:[e];try{for(var o=E(e),a=o.next();!a.done;a=o.next()){var s=a.value;s instanceof zn&&zn._isMBoxEvent(t)?this._removeListener(t,s,i):s._removeEventListener(t,i)}}catch(t){r={error:t}}finally{try{a&&!a.done&&(n=o.return)&&n.call(o)}finally{if(r)throw r.error}}}},Mm.prototype._removeLegacy=function(t,e,i){"function"==typeof e?this._removeListener(t,"",e):this._removeListener(t,e,i)},Mm.prototype._removeListener=function(t,e,i){var r,n,o=e instanceof zn?e.getId():e,a=this.mapCallbackHandler.getModifiedCallback(t,o,i);if(a)if(o){if(e=this.map.layers.getLayerById(o))try{for(var s=E(e._getLayerIds()),l=s.next();!l.done;l=s.next()){var u=l.value;this.map._getMap().off(t,u,a)}}catch(t){r={error:t}}finally{try{l&&!l.done&&(n=s.return)&&n.call(s)}finally{if(r)throw r.error}}}else this.map._getMap().off(t,a);this.mapCallbackHandler.removeCallback(t,o,i)},Mm.prototype._enableLayerEvents=function(t){var e=this,i=this.mapCallbackHandler.getLayerCallbacks(t.getId());i&&i.forEach(function(i,r){i.forEach(function(i){var n,o,a=I(i,1)[0];try{for(var s=E(t._getLayerIds()),l=s.next();!l.done;l=s.next()){var u=l.value;e.map._getMap().on(r,u,a)}}catch(i){n={error:i}}finally{try{l&&!l.done&&(o=s.return)&&o.call(s)}finally{if(n)throw n.error}}})})},Mm.prototype._disableLayerEvents=function(t){var e=this,i=this.mapCallbackHandler.getLayerCallbacks(t.getId());i&&i.forEach(function(i,r){i.forEach(function(i){var n,o,a=I(i,1)[0];try{for(var s=E(t._getLayerIds()),l=s.next();!l.done;l=s.next()){var u=l.value;e.map._getMap().off(r,u,a)}}catch(i){n={error:i}}finally{try{l&&!l.done&&(o=s.return)&&o.call(s)}finally{if(n)throw n.error}}})})},Mm);function Mm(t){this.map=t,this.mapCallbackHandler=new km(this.map)}var Lm=(Om.prototype.add=function(t,e){var i,r;if(Array.isArray(t))try{for(var n=E(t),o=n.next();!o.done;o=n.next()){var a=o.value;this._addMarker(a,e)}}catch(t){i={error:t}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(i)throw i.error}}else this._addMarker(t,e)},Om.prototype._addMarker=function(t,e){t._addToMap(this.map,e),this.markers.add(t)},Om.prototype.getMarkers=function(){return Array.from(this.markers)},Om.prototype.remove=function(t){var e,i;if(Array.isArray(t))try{for(var r=E(t),n=r.next();!n.done;n=r.next()){var o=n.value;this._removeMarker(o)}}catch(t){e={error:t}}finally{try{n&&!n.done&&(i=r.return)&&i.call(r)}finally{if(e)throw e.error}}else this._removeMarker(t)},Om.prototype._removeMarker=function(t){var e=this;t instanceof oa?(t._removeFromMap(),this.markers.delete(t)):this.markers.forEach(function(i){i._getId()===t&&(i._removeFromMap(),e.markers.delete(i))})},Om.prototype.clear=function(){var t=this;this.markers.forEach(function(e){e._removeFromMap(),t.markers.delete(e)})},Om);function Om(t){this.markers=new Set,this.map=t}var Rm=(zm.prototype.add=function(t,e){var i=this;return new Promise(function(r,n){var o,a,s;i.userImages.has(t)?r():e instanceof HTMLImageElement||e instanceof ImageData?(i.map._getMap().addImage(t,e),i.userImages.set(t,e),r()):"string"==typeof e&&(void 0,a=/<svg/i.test(e)&&!/^data:/i.test(e)?"data:image/svg+xml;base64,"+window.btoa(e):e,s=!1,i.map._sendRequest(a,"Image").then(function(t){if(!s)return t.blob()}).then(function(e){var a;s||(clearTimeout(o),(a=new Image).onload=function(){i.map._getMap().addImage(t,a),i.userImages.set(t,a),r()},a.onerror=a.onabort=function(){n("Failed to load image into HTML element.")},a.src=URL.createObjectURL(e))}).catch(function(){s||(clearTimeout(o),n("Failed to load image into HTML element."))}),o=setTimeout(function(){s=!0,n("Failed to load image within specified timeout: "+i.imageLoadTimeout+" ms.")},i.imageLoadTimeout))})},zm.prototype.clear=function(){var t=this;this.userImages.forEach(function(e,i){t.map._getMap().removeImage(i)}),this.userImages.clear()},zm.prototype.getImageIds=function(){var t=[];return this.userImages.forEach(function(e,i){t.push(i)}),t},zm.prototype.createFromTemplate=function(t,e,i,r,n){return i=i||"#1A73AA",r=r||"#fff",n=(n=ss(e,n)).replace(/{color}/g,i).replace(/{secondaryColor}/g,r).replace(/{text}/g,""),this.add(t,n)},zm.prototype.hasImage=function(t){return this.userImages.has(t)},zm.prototype.remove=function(t){this.map._getMap().removeImage(t),this.userImages.delete(t)},zm.prototype._restoreImages=function(){var t=this;this.userImages.forEach(function(e,i){t.map._getMap().hasImage(i)||t.map._getMap().addImage(i,e)})},zm);function zm(t){this.userImages=new H,this.imageLoadTimeout=5e3,this.map=t}var Dm,Nm=(w(Bm,Dm=zn),Bm.prototype._buildLayers=function(){return this.layers},Bm.prototype._getLayerIds=function(){return this.layers.map(function(t){return t.id})},Bm.prototype._getSourceIds=function(){var t,e,i=new Set;try{for(var r=E(this.layers),n=r.next();!n.done;n=r.next()){var o=n.value;"string"==typeof o.source?i.add(o.source):o.source&&i.add(o.id)}}catch(e){t={error:e}}finally{try{n&&!n.done&&(e=r.return)&&e.call(r)}finally{if(t)throw t.error}}return i},Bm.prototype._updateLayoutProperty=function(t,e,i,r){var n=this;this.layers.forEach(function(o){Fi(e,i)||n.map._getMap().setLayoutProperty(o.id,t,r||e)})},Bm);function Bm(t,e){return(e=Dm.call(this,e)||this).layers=t,e}var Fm=(Um.prototype.add=function(t,e){var i,r,n=e instanceof zn?e.getId():e;if(Array.isArray(t))try{for(var o=E(t),a=o.next();!a.done;a=o.next()){var s=a.value;this._addLayer(s,n)}}catch(t){i={error:t}}finally{try{a&&!a.done&&(r=o.return)&&r.call(o)}finally{if(i)throw i.error}}else this._addLayer(t,n)},Um.prototype._addLayer=function(t,e){if(!(this.map._isReady()||t instanceof Nm))throw new Error("The layer '"+t.getId()+"' could not be added to the map because the map is not ready. Please use a ready event listener to guarantee the map is ready before adding a layer to it.");var i,r,n;e!==t.getId()&&this.layerIndex.find(function(t){return e===t.getId()})?this._getMapboxLayerExists(t)?(r=this.layerIndex.findIndex(function(e){return e.getId()===t.getId()}),n=this.layerIndex[r],this._removeMapboxLayers(t),this._addMapboxLayers(t,e),this.map.events._disableLayerEvents(n),this.map.events._enableLayerEvents(t),this.layerIndex.splice(r,1),i=this.layerIndex.findIndex(function(t){return t.getId()===e}),this.layerIndex.splice(i,0,t),t instanceof Nm||this.userLayers.push({layer:t,before:e}),n.onRemove()):(this._addMapboxLayers(t,e),this.map.events._enableLayerEvents(t),i=this.layerIndex.findIndex(function(t){return t.getId()===e}),this.layerIndex.splice(i,0,t),t instanceof Nm||this.userLayers.push({layer:t,before:e})):0<=(r=this.layerIndex.findIndex(function(e){return e.getId()===t.getId()}))?(n=this.layerIndex[r],this._removeMapboxLayers(n),this._addMapboxLayers(t,r+1),this.map.events._disableLayerEvents(n),this.map.events._enableLayerEvents(t),this.layerIndex[r]=t,n.onRemove()):(this._addMapboxLayers(t),this.map.events._enableLayerEvents(t),this.layerIndex.push(t),t instanceof Nm||this.userLayers.push({layer:t,before:e})),t.onAdd(this.map)},Um.prototype._addMapboxLayers=function(t,e){var i,r;if(!(t instanceof Uo)||t.getOptions().tileUrl)if(t instanceof Nm)this.map.events._enableLayerEvents(t);else{t instanceof io&&this.map._getMap().addSource(t._getSourceId(),t._buildSource());var n=this._getMapboxBefore(e);try{for(var o=E(t._buildLayers()),a=o.next();!a.done;a=o.next()){var s=a.value;this.map._getMap().addLayer(s,n)}}catch(t){i={error:t}}finally{try{a&&!a.done&&(r=o.return)&&r.call(o)}finally{if(i)throw i.error}}this.map.events._enableLayerEvents(t)}},Um.prototype._removeMapboxLayers=function(t,e){var i,r;if(t instanceof Nm&&!e)this.map.events._disableLayerEvents(t);else{try{for(var n=E(t._getLayerIds()),o=n.next();!o.done;o=n.next()){var a=o.value;this.map._getMap().getLayer(a)&&this.map._getMap().removeLayer(a)}}catch(t){i={error:t}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(i)throw i.error}}this.map.events._disableLayerEvents(t),t instanceof io&&this.map._getMap().getSource(t._getSourceId())&&this.map._getMap().removeSource(t._getSourceId())}},Um.prototype._getMapboxLayerExists=function(t){var e=this,i=!1;return"string"==typeof t?!!(t=this.layerIndex.find(function(e){return e.getId()===t})):(t._getLayerIds().forEach(function(t){e.map._getMap().getLayer(t)&&(i=!0)}),i)},Um.prototype._getMapboxBefore=function(t){var e,i,r,n;if("string"==typeof t){var o=this.layerIndex.find(function(e){return e.getId()===t});if(!o)return;try{for(var a=E(o._getLayerIds()),s=a.next();!s.done;s=a.next()){var l=s.value;if(this.map._getMap().getLayer(l))return l}}catch(i){e={error:i}}finally{try{s&&!s.done&&(i=a.return)&&i.call(a)}finally{if(e)throw e.error}}t=this.layerIndex.findIndex(function(e){return e.getId()===t})+1}for(var u=t;u<this.layerIndex.length;u++)try{for(var c=(r=void 0,E(this.layerIndex[u]._getLayerIds())),p=c.next();!p.done;p=c.next())if(l=p.value,this.map._getMap().getLayer(l))return l}catch(i){r={error:i}}finally{try{p&&!p.done&&(n=c.return)&&n.call(c)}finally{if(r)throw r.error}}},Um.prototype.clear=function(){for(var t=this.layerIndex.length-1;0<=t;t--){var e=this.layerIndex[t];this._removeMapboxLayers(e,!0),this.layerIndex.splice(t,1),e.onRemove()}this.userLayers=[]},Um.prototype.getLayerById=function(t){var e=this.layerIndex.find(function(e){return e.getId()===t});if(e)return e},Um.prototype.getLayers=function(){return this.layerIndex.slice(0)},Um.prototype._getSourceIds=function(){var t,e,i=new Set;try{for(var r=E(this.layerIndex),n=r.next();!n.done;n=r.next())n.value._getSourceIds().forEach(function(t){return i.add(t)})}catch(e){t={error:e}}finally{try{n&&!n.done&&(e=r.return)&&e.call(r)}finally{if(t)throw t.error}}return i},Um.prototype._getUserLayers=function(){return Array.from(this.userLayers)},Um.prototype.move=function(t,e){var i=t instanceof zn?t.getId():t,r=e instanceof zn?e.getId():e;if(!this.layerIndex.find(function(t){return t.getId()===i}))throw new Error("The layer '"+i+"' has not been added to the map and cannot be moved.");e=this.layerIndex.findIndex(function(t){return t.getId()===i}),this._moveMapboxLayers(this.layerIndex[e],r),t=this.layerIndex[e],this.layerIndex.splice(e,1),-1<(e=this.layerIndex.findIndex(function(t){return t.getId()===r}))?this.layerIndex.splice(e,0,t):this.layerIndex.push(t)},Um.prototype._moveMapboxLayers=function(t,e){var i,r,n=this._getMapboxBefore(e);try{for(var o=E(t._getLayerIds()),a=o.next();!a.done;a=o.next()){var s=a.value;this.map._getMap().moveLayer(s,n)}}catch(t){i={error:t}}finally{try{a&&!a.done&&(r=o.return)&&r.call(o)}finally{if(i)throw i.error}}},Um.prototype.getRenderedShapes=function(t,e,i){var r,n,o,a=this;if(t=t||[-180,-85.0511,180,85.0511],Array.isArray(t)?4===t.length||6===t.length?o=this.map.positionsToPixels([nn.getSouthWest(t),nn.getNorthEast(t)]):2!==t.length&&3!==t.length||(o=this.map.positionsToPixels([t])[0]):o=this.map.positionsToPixels([t.coordinates])[0],e){e=Array.isArray(e)?e:[e];var s=[],l=this;try{for(var u=E(e),c=u.next();!c.done;c=u.next())!function(t){var e=t instanceof zn?t.getId():t;if(!(-1<(t=l.layerIndex.findIndex(function(t){return t.getId()===e}))))throw new Error("The layer '"+e+"' has not been added to the map and its rendered features cannot be retrieved.");s.push.apply(s,k(l.layerIndex[t]._getLayerIds().filter(function(t){return!!a.map._getMap().getLayer(t)})))}(c.value)}catch(t){r={error:t}}finally{try{c&&!c.done&&(n=u.return)&&n.call(u)}finally{if(r)throw r.error}}}return i=this.map._getMap().queryRenderedFeatures(o,{layers:s,filter:i}),this.map.sources._mapFeaturesToShapes(i)},Um.prototype.remove=function(t){var e,i;if(Array.isArray(t))try{for(var r=E(t),n=r.next();!n.done;n=r.next()){var o=n.value;this._removeLayer(o)}}catch(t){e={error:t}}finally{try{n&&!n.done&&(i=r.return)&&i.call(r)}finally{if(e)throw e.error}}else this._removeLayer(t)},Um.prototype._removeLayer=function(t){var e=t instanceof zn?t.getId():t;if(!this.layerIndex.find(function(t){return t.getId()===e}))throw new Error("The layer '"+e+"' has not been added to the map and cannot be removed.");t=this.layerIndex.findIndex(function(t){return t.getId()===e});var i=this.layerIndex[t];this._removeMapboxLayers(i),this.layerIndex.splice(t,1),0<=(t=this.userLayers.findIndex(function(t){return t.layer.getId()===i.getId()}))&&this.userLayers.splice(t,1),i.onRemove()},Um);function Um(t){this.layerIndex=[],this.userLayers=[],this.map=t}var jm=(Vm.prototype.add=function(t){var e,i;t=Array.isArray(t)?t:[t];try{for(var r=E(t),n=r.next();!n.done;n=r.next()){var o=n.value;this.popups.has(o)||(this.popups.add(o),o.attach(this.map))}}catch(t){e={error:t}}finally{try{n&&!n.done&&(i=r.return)&&i.call(r)}finally{if(e)throw e.error}}},Vm.prototype.clear=function(){var t=this;this.popups.forEach(function(e){t.popups.delete(e),e.remove()})},Vm.prototype.remove=function(t){var e,i;t=Array.isArray(t)?t:[t];try{for(var r=E(t),n=r.next();!n.done;n=r.next()){var o=n.value;this.popups.has(o)&&(this.popups.delete(o),o.remove())}}catch(t){e={error:t}}finally{try{n&&!n.done&&(i=r.return)&&i.call(r)}finally{if(e)throw e.error}}},Vm.prototype.getPopups=function(){return Array.from(this.popups)},Vm.prototype._getCollectionDiv=function(){var t=this.map.getMapContainer().querySelector("."+Vm.Css.collection);return t||((t=document.createElement("div")).classList.add(Vm.Css.collection),t.setAttribute("aria-label","Map Information"),this.map.getMapContainer().appendChild(t)),t},Vm.prototype._addDraggedPopup=function(t){0===this.draggedPopups.size&&(this.map.getMapContainer().addEventListener("mousemove",this._onDrag),this.map.getMapContainer().addEventListener("touchmove",this._onDrag),this.map.getMapContainer().addEventListener("mouseup",this._onUp),this.map.getMapContainer().addEventListener("touchend",this._onUp)),this.draggedPopups.add(t)},Vm.Css={collection:"popup-collection-container"},Vm);function Vm(t){var e=this;this._onDrag=function(t){var i,r;"mousemove"===t.type?(i=t.clientX,r=t.clientY):"touchmove"===t.type&&(i=t.touches[0].clientX,r=t.touches[0].clientY),e.draggedPopups.forEach(function(t){t._dragToPixel([i,r])})},this._onUp=function(){e.map.getMapContainer().removeEventListener("mousemove",e._onDrag),e.map.getMapContainer().removeEventListener("touchmove",e._onDrag),e.map.getMapContainer().removeEventListener("mouseup",e._onUp),e.map.getMapContainer().removeEventListener("touchend",e._onUp),e.draggedPopups.forEach(function(t){e.draggedPopups.delete(t),t._onUp()})},this.map=t,this.popups=new Set,this.draggedPopups=new Set}var qm,Hm=(w(Gm,qm=Sn),Gm.prototype._buildSource=function(){return this.source},Gm.prototype._modifySource=function(t,e){if(t.tiles){var i=t.tiles.map(function(t){return"string"==typeof t?t:new R({domain:h,path:t.path,queryParams:S(S({},e),t.queryParams)}).toString()});t.tiles=i}else{if(!t.url)throw new Error("Source definition must define a TileJSON 'url' or a 'tiles' array.");t.url="string"==typeof t.url?t.url:new R({domain:h,path:t.url.path,queryParams:S(S({},e),t.url.queryParams)}).toString()}return t},Gm);function Gm(t,e,i){return(t=qm.call(this,t)||this).source=t._modifySource(e,i),t}var Zm=(Wm.prototype.add=function(t,e){var i,r;if(void 0===e&&(e=!0),Array.isArray(t))try{for(var n=E(t),o=n.next();!o.done;o=n.next()){var a=o.value;this._addSource(a,e)}}catch(t){i={error:t}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(i)throw i.error}}else this._addSource(t,e)},Wm.prototype.getRenderedShapes=function(t,e,i){return t="string"==typeof t?t:t.getId(),e=this.map._getMap().querySourceFeatures(t,{sourceLayer:i,filter:e}),this.map.sources._mapFeaturesToShapes(e,!0,this.sources.get(t))},Wm.prototype._buildSources=function(){var t={};return this.sources.forEach(function(e){t[e.getId()]=e._buildSource()}),t},Wm.prototype.clear=function(){var t=this;this.sources.forEach(function(e){t.remove(e)})},Wm.prototype.getById=function(t){return this.sources.get(t)},Wm.prototype.getSources=function(){return Array.from(this.sources.values())},Wm.prototype.isSourceLoaded=function(t){return t=t instanceof Sn?t.getId():t,this.map._getMap().isSourceLoaded(t)},Wm.prototype.remove=function(t,e){var i,r;if(void 0===e&&(e=!0),Array.isArray(t))try{for(var n=E(t),o=n.next();!o.done;o=n.next()){var a=o.value;this._removeSource(a,e)}}catch(t){i={error:t}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(i)throw i.error}}else this._removeSource(t,e)},Wm.prototype._removeSource=function(t,e){if(t=t instanceof Sn?t.getId():t,this.sources.has(t)){if(this.map._getMap().getSource(t)&&e&&this.map._getMap().removeSource(t),this.map._getMap().getSource(t)&&e)throw new Error("One or more layers have a dependency on the source '"+t+"'");return this.sources.get(t)._setMap(null),void this.sources.delete(t)}throw new Error("'"+t+"' is not added to the map")},Wm.prototype._addSource=function(t,e){if(this.sources.has(t.getId())){if(e)throw new Error("'"+t.getId()+"' is already added to the map");this.sources.get(t.getId())._setMap(null),this.sources.delete(t.getId())}if(e){if(!this.map._isReady())throw new Error("The source '"+t.getId()+"' could not be added to the map because the map is not ready. Please use a ready event listener to guarantee the map is ready before adding a source to it.");this.map._getMap().addSource(t.getId(),t._buildSource())}this.sources.set(t.getId(),t),t._setMap(this.map)},Wm.prototype._mapFeaturesToShapes=function(t,e,i){var r,n,o=[];try{for(var a=E(t),s=a.next();!s.done;s=a.next()){var l=s.value;if((i||"string"==typeof l.source)&&"string"==typeof l.properties[tn._shapeIdPropName]){var u=i||this.sources.get(l.source);if(u instanceof En){var c=u.getShapeById(l.properties[tn._shapeIdPropName]);if(c instanceof tn){o.push(c);continue}}}e||o.push(l)}}catch(t){r={error:t}}finally{try{s&&!s.done&&(n=a.return)&&n.call(a)}finally{if(r)throw r.error}}return o},Wm.prototype._syncSources=function(t){var e=this;t&&(Object.keys(t).forEach(function(i){if(!e.sources.has(i)){var r=t[i];if("vector"===r.type){var n=new Hm(i,{name:i,tiles:r.tiles,type:"vector",url:r.url});e.sources.set(i,n),n._setMap(e.map)}else{if("raster"!==r.type)throw new Error("Unable to construct source with ID "+i+".");n=new Hm(i,{name:i,tiles:r.tiles,type:"raster",url:r.url}),e.sources.set(i,n),n._setMap(e.map)}}}),Object.keys(this.sources).forEach(function(i){t.hasOwnProperty(i)||(e.sources.get(i)._setMap(null),e.sources.delete(i))}))},Wm);function Wm(t){this.map=t,this.sources=new H}var Km,Xm=(w(Ym,Km=A),Ym);function Ym(){var t=null!==Km&&Km.apply(this,arguments)||this;return t.duration=1e3,t.type="jump",t}var Jm,Qm=(w($m,Jm=A),$m);function $m(){var t=null!==Jm&&Jm.apply(this,arguments)||this;return t.bottom=0,t.left=0,t.right=0,t.top=0,t}var ty,ey=(w(iy,ty=A),iy.prototype.merge=function(){for(var t,e,i=[],r=0;r<arguments.length;r++)i[r]=arguments[r];try{for(var n=E(i),o=n.next();!o.done;o=n.next()){var a=o.value;a&&"number"==typeof a.padding&&(a.padding={top:a.padding,bottom:a.padding,left:a.padding,right:a.padding})}}catch(e){t={error:e}}finally{try{o&&!o.done&&(e=n.return)&&e.call(n)}finally{if(t)throw t.error}}return ty.prototype.merge.apply(this,k(i))},iy);function iy(){var t=null!==ty&&ty.apply(this,arguments)||this;return t.bounds=[-180,-89,180,90],t.maxBounds=void 0,t.maxZoom=20,t.offset=new Gi(0,0),t.padding=new Qm,t}var ry,ny=(w(oy,ry=A),oy);function oy(){var t=null!==ry&&ry.apply(this,arguments)||this;return t.zoom=1,t.center=new Wr(0,0),t.centerOffset=new Gi(0,0),t.bearing=0,t.pitch=0,t.minZoom=1,t.maxZoom=20,t.maxBounds=void 0,t}var ay;w(sy,ay=A),ft=sy;function sy(){var t=null!==ay&&ay.apply(this,arguments)||this;return t.name=void 0,t.before=void 0,t.minZoom=1,t.maxZoom=20,t.overwrite=!1,t.opacity=1,t}var ly,uy=(w(cy,ly=ft),cy);function cy(){var t=null!==ly&&ly.apply(this,arguments)||this;return t.color="rgba(0,0,0,.5)",t.outlineColor="#000",t.radius=1,t.outlineWidth=5,t.name="default-circles",t}var py,hy=(w(dy,py=ft),dy);function dy(){var t=null!==py&&py.apply(this,arguments)||this;return t.cap="butt",t.join="miter",t.name="default-linestrings",t.color="#000",t.width=1,t}var fy,my=(w(yy,fy=ft),yy);function yy(){var t=null!==fy&&fy.apply(this,arguments)||this;return t.iconSize=1,t.fontSize=14,t.fontColor="#000",t.textFont="SegoeUi-Regular",t.cluster=!0,t.clusterIcon=void 0,t.textOffset=[0,0],t.name="default-pins",t.icon="pin-darkblue",t.title="",t}var gy,vy=(w(_y,gy=ft),_y);function _y(){var t=null!==gy&&gy.apply(this,arguments)||this;return t.color="rgba(0,0,0,.5)",t.outlineColor="#000",t.name="default-polygons",t}var xy,by=(w(wy,xy=ft),wy);function wy(){var t=null!==xy&&xy.apply(this,arguments)||this;return t.name="default-raster",t}var Sy,Ty=(w(Cy,Sy=A),Cy);function Cy(){var t=null!==Sy&&Sy.apply(this,arguments)||this;return t.anchor="map",t.color="#FFFFFF",t.intensity=.5,t.position=[1.15,210,30],t}var Ey,Iy=(w(ky,Ey=A),ky.prototype.merge=function(){for(var t,e,i=[],r=0;r<arguments.length;r++)i[r]=arguments[r];try{for(var n=E(i),o=n.next();!o.done;o=n.next()){var a=o.value;a&&(a.hasOwnProperty("view")?a.userRegion=a.view:a.hasOwnProperty("userRegion")&&(a.view=a.userRegion),"string"==typeof a.language&&(a.language=wa.getCode(a.language)))}}catch(e){t={error:e}}finally{try{o&&!o.done&&(e=n.return)&&e.call(n)}finally{if(t)throw t.error}}return Ey.prototype.merge.apply(this,k(i))},ky);function ky(){var t=null!==Ey&&Ey.apply(this,arguments)||this;return t.autoResize=!0,t.language=Pa,t.light=new Ty,t.preserveDrawingBuffer=!1,t.renderWorldCopies=!0,t.showBuildingModels=!1,t.showFeedbackLink=!0,t.showLogo=!0,t.customAttribution=void 0,t.showTileBoundaries=!1,t.style="road",t.view=Ia,t.userRegion=t.view,t}var Ay,Py=(w(My,Ay=A),My);function My(){var t=null!==Ay&&Ay.apply(this,arguments)||this;return t.flow="none",t.incidents=!1,t}function Ly(t){return 0==t.length?void 0:t.slice(1).reduce(function(t,e){return function(i,r){return i=t(i,r),S(S({},i),e(i.url,r))}},t[0])}var Oy,Ry=(w(zy,Oy=A),zy.prototype.merge=function(){for(var e=[],i=0;i<arguments.length;i++)e[i]=arguments[i];try{for(var r=E(e),n=r.next();!n.done;n=r.next()){var o=n.value;o&&(o.authOptions?"string"==typeof o.authOptions.subscriptionKey&&(o.subscriptionKey=o["subscription-key"]=o.authOptions.subscriptionKey):"string"==typeof o.subscriptionKey?(o["subscription-key"]=o.subscriptionKey,o.authOptions={authType:t.AuthenticationType.subscriptionKey,subscriptionKey:o.subscriptionKey}):"string"==typeof o["subscription-key"]&&(o.subscriptionKey=o["subscription-key"],o.authOptions={authType:t.AuthenticationType.subscriptionKey,subscriptionKey:o["subscription-key"]}),"string"==typeof o.sessionId?o["session-id"]=o.sessionId:"string"==typeof o["session-id"]&&(o.sessionId=o["session-id"]),"boolean"==typeof o.disableTelemetry?o["disable-telemetry"]=o.disableTelemetry:"boolean"==typeof o["disable-telemetry"]&&(o.disableTelemetry=o["disable-telemetry"]),"boolean"==typeof o.enableAccessibility?o["enable-accessibility"]=o.enableAccessibility:"boolean"==typeof o["enable-accessibility"]&&(o.enableAccessibility=o["enable-accessibility"]))}}catch(e){l={error:e}}finally{try{n&&!n.done&&(s=r.return)&&s.call(r)}finally{if(l)throw l.error}}var a=this._transformers,s=e?e.filter(function(t){return void 0!==t}).reduce(function(t,e){return k(t,e._transformers||[])},[]):[],l=Oy.prototype.merge.apply(this,k(e));return l.authOptions.authType!==t.AuthenticationType.subscriptionKey&&(l["subscription-key"]=l.subscriptionKey=void 0),this._transformers=k(a||[],s.filter(function(t){return!a.includes(t)})),this.transformRequest&&!this._transformers.includes(this.transformRequest)&&this._transformers.push(this.transformRequest),this.transformRequest=Ly(this._transformers),l},zy.prototype.addTransformer=function(t){this._transformers||(this._transformers=[]),this._transformers.push(t),this.transformRequest=Ly(this._transformers)},zy.prototype.removeTransformer=function(t){this._transformers&&(this._transformers=this._transformers.filter(function(e){return t!==e}),this.transformRequest=Ly(this._transformers))},zy._cloneCustomizer=function(t){if("object"==typeof t)return Object.assign({},t)},zy);function zy(){var t=null!==Oy&&Oy.apply(this,arguments)||this;return t.authOptions=Za(),t.disableTelemetry=!1,t["disable-telemetry"]=t.disableTelemetry,t.domain=La,t.staticAssetsDomain=Oa,t.styleDefinitionsPath=Ra,t.styleDefinitionsVersion=za,t.enableAccessibility=!0,t["enable-accessibility"]=t.enableAccessibility,t.enableAccessibilityLocationFallback=!0,t.maxParallelImageRequests=Ka(),t.refreshExpiredTiles=!0,t.subscriptionKey=Xa(),t["subscription-key"]=t.subscriptionKey,t.sessionId=Ma,t["session-id"]=t.sessionId,t._transformers=[],t.transformRequest=void 0,t.workerCount=Wa(),t}var Dy=(Ny.getLayerGroup=function(t){var e;if((t=null!==(e=null==t?void 0:t.id)&&void 0!==e?e:t).startsWith("microsoft."))return 4<=(t=t.split(".")).length?t[3]:void 0},Ny);function Ny(){}var By=(Fy.prototype.initialize=function(){var t=this;return this.initPromise||(this.initPromise=this._request(this.serviceOptions.staticAssetsDomain,v+"/"+_,"StyleDefinitions").then(function(e){t.definitions=e}).catch(function(t){throw new Error("Failed to retrieve the style definitions: "+t)})),this.styleSet="base",this.initPromise},Fy.prototype.getStyleUrl=function(t){t=this._lookUp(t);return new R({domain:this.serviceOptions.staticAssetsDomain,path:v+"/"+_+"/"+t.name,queryParams:((t={})[p]=this.apiVersion,t.version=this.definitions.version,t),protocol:"https"}).toString()},Fy.prototype.setStyleUrl=function(t){t=this.getStyleUrl(t);try{this.map._getMap().setStyle(t,{diff:!0,stylePatch:this._stylePatch.bind(this)})}catch(t){throw t}},Fy.prototype.getTheme=function(t){return this._lookUp(t).theme.toLowerCase()||"light"},Fy.prototype.setStyleSet=function(t){t!==this.styleSet&&(this.styleSet=t,this.setStyleUrl(this.map.getStyle()))},Fy.prototype.getStyleSet=function(){return this.styleSet},Fy.prototype.clearStyleSet=function(){"base"!==this.styleSet&&(this.styleSet="base",this.setStyleUrl(this.map.getStyle()))},Fy.prototype.getDef=function(){var t=Object.assign({},this.definitions);return t.styles=t.styles.filter(function(t){return!t.name.endsWith("_indoor")&&!t.name.endsWith("_indoor_dark")}),t},Fy.prototype._stylePatch=function(t,e,i,r,n,o){function a(t){u.push(s._buildFundamentalLayerFrom(p,c)),c=t,p=[]}var s=this,l=this.map.layers.getLayers(),u=[],c="",p=[],h=this.map.getStyle(),d=this.map.getTraffic();e.layers.forEach(function(t){var e,i,r=Dy.getLayerGroup(t.id);c=c||r,h.showBuildingModels||"fill-extrusion"!==t.type?"fill-extrusion"===t.type&&(n(t.id,"visibility","visible"),t.layout=null!==(e=t.layout)&&void 0!==e?e:{},t.layout.visibility="visible"):(n(t.id,"visibility","none"),t.layout=null!==(i=t.layout)&&void 0!==i?i:{},t.layout.visibility="none"),"none"!==d.flow&&r&&r==="traffic_"+d.flow&&"line"==t.type&&(n(t.id,"visibility","visible"),t.layout=null!==(i=t.layout)&&void 0!==i?i:{},t.layout.visibility="visible"),r?(0<p.length&&r!=c&&a(r),p.push(t)):0<p.length&&a(r)}),0<p.length&&a("");var f=this.map.layers._getUserLayers(),m=f[0],y=l.filter(function(t){return u.findIndex(function(e){return t.getId()===e.getId()})<0&&f.findIndex(function(e){return t.getId()===e.layer.getId()})<0}),g=u.filter(function(t){return l.find(function(e){return e.getId()===t.getId()})}).entries(),v=g.next();u.forEach(function(t){var e;v.value&&v.value[1].getId()===t.getId()?(e=l.findIndex(function(e){return e.getId()===t.getId()}),s.map.layers.remove(t.getId()),s.map.layers.add(t,l[e].getId()),v=g.next()):v.value?s.map.layers.add(t,v.value[1]):s.map.layers.add(t,null==m?void 0:m.layer)}),y.forEach(function(t){s.map.layers.remove(t)}),f.forEach(function(t){var e,r=void 0;s.map.layers.getLayerById(t.before)&&(r=0<(e=s.map.layers.getLayerById(t.before)._buildLayers()).length?e[0]:void 0),i(t.layer.getId(),null==r?void 0:r.id)}),this.map.sources._syncSources(e.sources),this.map.events.addOnce("styledata",function(t){s.map.events.invoke("stylechanged",{style:s._lookUp(s.map.getStyle()).name,map:s.map,type:"stylechanged"})})},Fy.prototype._buildFundamentalLayerFrom=function(t,e){if(t&&0<t.length)return(t=new Nm(t,e)).onAdd(this.map),t;throw new Error("Unable to construct fundamental map layer for ID: "+e+".")},Fy.prototype._lookUp=function(t){var e,i,r,n=(t.style||this.definitions.defaultStyle).concat("indoor"===this.styleSet?"_indoor":"").concat("indoor_dark"===this.styleSet?"_indoor_dark":""),o=this.definitions.defaultStyle.concat("indoor"===this.styleSet?"_indoor":"").concat("indoor_dark"===this.styleSet?"_indoor_dark":"");try{for(var a=E((this.definitions||{}).styles),s=a.next();!s.done;s=a.next()){var l=s.value;if(l.name===n)return l;l.name===o&&(r=l)}}catch(t){e={error:t}}finally{try{s&&!s.done&&(i=a.return)&&i.call(a)}finally{if(e)throw e.error}}return r},Fy.prototype._transformStyleRequest=function(t,e){t.includes(h)&&(e.url=e.url.replace(h,this.serviceOptions.staticAssetsDomain)),t.includes(y)&&(e.url=e.url.replace(y,v)),t.includes(g)&&(e.url=e.url.replace(g,_)),e.url=e.url+(t.includes("?")?"&":"?")+p+"="+this.apiVersion},Fy.prototype._request=function(t,e,i){return T(this,void 0,void 0,function(){var r,n,o;return C(this,function(a){switch(a.label){case 0:return n=new R({protocol:"https",domain:t,path:e,queryParams:((o={})[p]=this.apiVersion,o.version=this.serviceOptions.styleDefinitionsVersion,o)}).toString(),"function"==typeof this.serviceOptions.transformRequest&&i&&(r=this.serviceOptions.transformRequest(n,i)),o={method:"GET",mode:"cors"},r&&(r.credentials&&(o.credentials=r.credentials),r.headers&&(o.headers=r.headers),n=r.url||n),o=new Request(n,o),[4,fetch(o).then(function(t){if(t.ok)return t.json();throw new Error("HTTP "+t.status+": "+t.statusText+" ")})];case 1:return[2,a.sent()]}})})},Fy);function Fy(t,e){this.apiVersion="2.0",this.map=t,this.serviceOptions=e}var Uy,jy=(w(Vy,Uy=G),Vy.prototype.getCanvas=function(){return this.map.getCanvas()},Vy.prototype.getCanvasContainer=function(){return this.map.getCanvasContainer()},Vy.prototype.getMapContainer=function(){return this.map.getContainer()},Vy.prototype.getServiceOptions=function(){return _n(this.serviceOptions,Ry._cloneCustomizer)},Vy.prototype.setServiceOptions=function(t){this.serviceOptions=(new Ry).merge(this.serviceOptions,t),this.serviceOptions["enable-accessibility"]?this.accessibleMapDelegate.addToMap():this.accessibleMapDelegate.removeFromMap()},Vy.prototype.addRequestTransformer=function(t){this.serviceOptions.addTransformer(t)},Vy.prototype.removeRequestTransformer=function(t){this.serviceOptions.removeTransformer(t)},Vy.prototype.setCamera=function(t,e){if(void 0===e&&(e=!1),"padding"in t||"offset"in t||"bounds"in t){var i,r=(new ey).merge({maxZoom:this.getCamera().maxZoom},t),n=this._generateSafeBounds(r.bounds);if(!(i=this.map.cameraForBounds(n,{padding:r.padding,offset:r.offset,maxZoom:r.maxZoom})))throw new Error("The map cannot be fit to the current canvas with the given CameraBoundsOptions.");this.map.setMaxZoom(r.maxZoom),this._invokeEvent("maxzoomchanged",this.map.getMaxZoom()),a=this._generateSafeBounds(r.maxBounds)}else{var o=(new ny).merge(this.getCamera(),t);o.centerOffset&&2<=o.centerOffset.length&&(n=o.centerOffset,(r=Or([o.center],o.zoom))[0][0]+=n[0],r[0][1]+=n[1],o.center=Lr(r,o.zoom)[0]),i={center:o.center,zoom:o.zoom,bearing:o.bearing,pitch:o.pitch,around:void 0},this.map.setMinZoom(o.minZoom),this.map.setMaxZoom(o.maxZoom),this._invokeEvent("minzoomchanged",this.map.getMinZoom()),this._invokeEvent("maxzoomchanged",this.map.getMaxZoom()),a=this._generateSafeBounds(o.maxBounds)}a?this.map.setMaxBounds(a):this.map.setMaxBounds(null);var a=(new Xm).merge(t);t={duration:a.duration,easing:function(t){return t},offset:[0,0],animate:!0},e={fromControl:e};"jump"===a.type?this.map.jumpTo(i,e):"ease"===a.type?this.map.easeTo(S(S({},i),t),e):"fly"===a.type&&this.map.flyTo(S(S({},i),t),e)},Vy.prototype.setCameraBounds=function(t){this.setCamera(t)},Vy.prototype.getCamera=function(){var t=this.map.getBounds().getSouthWest().toArray(),e=this.map.getBounds().getNorthEast().toArray();return{zoom:this.map.getZoom(),center:this.map.getCenter().toArray(),bearing:this.map.getBearing(),pitch:this.map.getPitch(),bounds:new nn(t,e),minZoom:this.map.getMinZoom(),maxZoom:this.map.getMaxZoom()}},Vy.prototype.setStyle=function(t){delete t.preserveDrawingBuffer,(t=(new Iy).merge(this.styleOptions,t)).autoResize!==this.styleOptions.autoResize&&this._setAutoResize(t.autoResize),t.language!==this.styleOptions.language&&(this.localizedStringsPromise=wa.getStrings(t.language)),t.renderWorldCopies!==this.styleOptions.renderWorldCopies&&this.map.setRenderWorldCopies(t.renderWorldCopies),t.showFeedbackLink!==this.styleOptions.showFeedbackLink&&this.copyrightControl.setOptions({showFeedbackLink:t.showFeedbackLink}),t.customAttribution!==this.styleOptions.customAttribution&&this.copyrightControl.setOptions({customAttribution:t.customAttribution}),t.showLogo!==this.styleOptions.showLogo&&this.copyrightControl.setOptions({showLogo:t.showLogo}),t.showTileBoundaries!==this.styleOptions.showTileBoundaries&&(this.map.showTileBoundaries=t.showTileBoundaries),this.styleOptions=t,this._setStyleComponents(t)},Vy.prototype.getStyle=function(){return hi(this.styleOptions)},Vy.prototype.addIcon=function(t,e){this.imageSprite.add(t,e)},Vy.prototype.addPins=function(t,e){var i,r=(new my).merge(e),n=this.layers.getLayerById(r.name),o=!1;if(n||(o=!0,n=new Ro(r.name+"-source",r.name,{source:r.name+"-source",minZoom:r.minZoom,maxZoom:r.maxZoom,iconOptions:{anchor:"center",size:r.iconSize,image:["case",["has","icon"],["get","icon"],r.icon],ignorePlacement:!r.cluster,opacity:r.opacity},textOptions:{anchor:"center",textField:["case",["has","point_count"],["to-string",["get","point_count"]],["has","title"],["to-string",["get","title"]],r.title],font:["case",["has","point_count"],["literal",["StandardFontCondensed-Bold"]],["literal",[r.textFont]]],size:["case",["has","point_count"],20,r.fontSize],ignorePlacement:!r.cluster,opacity:r.opacity,offset:["case",["has","point_count"],["literal",[.5,-.45]],["literal",[r.textOffset[0]/16,r.textOffset[1]/16]]],color:r.fontColor}})),!(n instanceof Ro))throw new Error("A layer with name '"+r.name+"' already exists but it is not a SymbolLayer.A SymbolLayer should be used for rendering pins.");var a=n.getSource();if("string"==typeof a?(i=a,a=this.sources.getById(i)):i=a.getId(),e=!1,a||(e=!0,a=new En(i,{cluster:r.cluster})),!(a instanceof En))throw new Error("The source with name '"+i+"' already exists but it is not a DataSource.New data can only be added to a DataSource.");e&&this.sources.add(a),o&&this.layers.add(n,r.before),t=new an(t),r.overwrite?a.setShapes(t):a.add(t)},Vy.prototype.addCircles=function(t,e){var i,r=(new uy).merge(e),n=this.layers.getLayerById(r.name),o=!1;if(n||(o=!0,n=new qn(r.name+"-source",r.name,{source:r.name+"-source",minZoom:r.minZoom,maxZoom:r.maxZoom,opacity:r.opacity,radius:["case",["has","radius"],["get","radius"],r.radius],color:["case",["has","color"],["get","color"],r.color],strokeColor:["case",["has","outlineColor"],["get","outlineColor"],r.outlineColor],strokeWidth:["case",["has","outlineWidth"],["get","outlineWidth"],r.outlineWidth]})),!(n instanceof qn))throw new Error("A layer with name '"+r.name+"' already exists but it is not a BubbleLayer.A BubbleLayer should be used for rendering circles.");var a=n.getSource();if("string"==typeof a?(i=a,a=this.sources.getById(i)):i=a.getId(),e=!1,a||(e=!0,a=new En(i)),!(a instanceof En))throw new Error("The source with name '"+i+"' already exists but it is not a DataSource.New data can only be added to a DataSource.");e&&this.sources.add(a),o&&this.layers.add(n,r.before),t=new an(t),r.overwrite?a.setShapes(t):a.add(t)},Vy.prototype.addLinestrings=function(t,e){var i,r=(new hy).merge(e),n=this.layers.getLayerById(r.name),o=!1;if(n||(o=!0,n=new co(r.name+"-source",r.name,{source:r.name+"-source",minZoom:r.minZoom,maxZoom:r.maxZoom,lineCap:r.cap,lineJoin:r.join,strokeOpacity:r.opacity,strokeColor:["case",["has","color"],["get","color"],r.color],strokeWidth:["case",["has","width"],["get","width"],r.width]})),!(n instanceof co))throw new Error("A layer with name '"+r.name+"' already exists but it is not a LineLayer.A LineLayer should be used for rendering linestrings.");var a=n.getSource();if("string"==typeof a?(i=a,a=this.sources.getById(i)):i=a.getId(),e=!1,a||(e=!0,a=new En(i)),!(a instanceof En))throw new Error("The source with name '"+i+"' already exists but it is not a DataSource.New data can only be added to a DataSource.");e&&this.sources.add(a),o&&this.layers.add(n,r.before),t=new an(t),r.overwrite?a.setShapes(t):a.add(t)},Vy.prototype.addPolygons=function(t,e){var i,r=(new vy).merge(e),n=this.layers.getLayerById(r.name),o=!1;if(n||(o=!0,n=new wo(r.name+"-source",r.name,{source:r.name+"-source",minZoom:r.minZoom,maxZoom:r.maxZoom,fillOpacity:r.opacity,fillColor:["case",["has","color"],["get","color"],r.color]})),!(n instanceof wo))throw new Error("A layer with name '"+r.name+"' already exists but it is not a PolygonLayer.A PolygonLayer should be used for rendering linestrings.");var a=n.getSource();if("string"==typeof a?(i=a,a=this.sources.getById(i)):i=a.getId(),e=!1,a||(e=!0,a=new En(i)),!(a instanceof En))throw new Error("The source with name '"+i+"' already exists but it is not a DataSource.New data can only be added to a DataSource.");e&&this.sources.add(a),o&&this.layers.add(n,r.before),t=new an(t),r.overwrite?a.setShapes(t):a.add(t)},Vy.prototype.addRaster=function(t,e){var i=(new by).merge(e),r=this.layers.getLayerById(i.name);if(!((r=r||new Uo({maxZoom:i.maxZoom,minZoom:i.minZoom,opacity:i.opacity,tileSize:256,tileUrl:"{subdomain}"},i.name))instanceof Uo))throw new Error("A layer with name '"+i.name+"' already exists but it is not a TileLayer.A TileLayer should be used for rendering raster images.");if("{subdomain}"!==r.getOptions().tileUrl)throw new Error("A TileLayer with name '"+i.name+"' already exists but was configured for a single tile url [default for new TileLayer(...)].");(e=!i.overwrite&&r.getOptions().subdomains||[]).push.apply(e,k(t)),r._setOptionsNoUpdate({subdomains:e}),this.layers.add(r,i.before)},Vy.prototype.getLayers=function(){return this.layers.getLayers().map(function(t){return t.getId()})},Vy.prototype.removeLayers=function(t){var e,i;try{for(var r=E(t),n=r.next();!n.done;n=r.next()){var o,a=n.value;this.layers.getLayerById(a)&&(this.layers.remove(a),o=a+"-source",this.sources.getById(o)&&this.sources.remove(o))}}catch(t){e={error:t}}finally{try{n&&!n.done&&(i=r.return)&&i.call(r)}finally{if(e)throw e.error}}},Vy.prototype.addHtml=function(t,e){t.id||(t.id="marker_"+ji());var i=new oa({htmlContent:t});return this.markers.add(i,e),t.id},Vy.prototype.removeHtml=function(t){this.markers.remove(t)},Vy.prototype.addEventListener=function(t,e,i){this.events._addLegacy(t,e,i)},Vy.prototype.removeEventListener=function(t,e,i){this.events._removeLegacy(t,e,i)},Vy.prototype.setUserInteraction=function(t){this.userInteractionDelegate.setOptions(t)},Vy.prototype.getUserInteraction=function(){return this.userInteractionDelegate.getOptions()},Vy.prototype.addControl=function(t,e){this.controls.add(t,e)},Vy.prototype.removeControl=function(t){this.controls.remove(t)},Vy.prototype.setTraffic=function(t){var e=this.trafficOptions.incidents,i=this.trafficOptions.flow;if(this.trafficOptions=(new Py).merge(this.trafficOptions,t),this.incidentDelegate&&(this.trafficOptions.incidents?e||this.incidentDelegate.addToMap():this.incidentDelegate.removeFromMap()),this.trafficOptions.flow&&"none"!==this.trafficOptions.flow)try{this.trafficOptions.flow!==i&&this.flowDelegate.addToMap()}catch(t){throw this.trafficOptions.flow=i,t}else this.flowDelegate.removeFromMap()},Vy.prototype.getTraffic=function(){return hi(this.trafficOptions)},Vy.prototype.remove=function(){this.dispose()},Vy.prototype.clear=function(){this.popups.clear(),this.layers.clear(),this.sources.clear(),this.markers.clear()},Vy.prototype.dispose=function(){for(this.clear(),this.map.remove(),this.removed=!0;this.getMapContainer().firstChild;){var t=this.getMapContainer().firstChild;this.getMapContainer().removeChild(t)}},Vy.prototype.resize=function(t,e,i){"number"!=typeof t&&"string"!=typeof t||"number"!=typeof e&&"string"!=typeof e?i=t:(t=t,this.getMapContainer().style.height="number"==typeof t?t+"px":t,this.getMapContainer().style.width="number"==typeof e?e+"px":e),e=this.getMapContainer().style.overflow,this.getMapContainer().style.overflow="hidden",this.map.resize(i),this.getMapContainer().style.overflow=e},Vy.prototype.pixelsToPositions=function(t){var e,i,r=[];try{for(var n=E(t),o=n.next();!o.done;o=n.next()){var a=o.value,s=this.map.unproject(a);r.push(new Wr(s.lng,s.lat))}}catch(t){e={error:t}}finally{try{o&&!o.done&&(i=n.return)&&i.call(n)}finally{if(e)throw e.error}}return r},Vy.prototype.positionsToPixels=function(t){var e,i,r=[];try{for(var n=E(t),o=n.next();!o.done;o=n.next()){var a=o.value,s=this.map.project(a);r.push(new Gi(s.x,s.y))}}catch(t){e={error:t}}finally{try{o&&!o.done&&(i=n.return)&&i.call(n)}finally{if(e)throw e.error}}return r},Vy.prototype.areTilesLoaded=function(){return this.map.areTilesLoaded()},Vy.prototype.stop=function(){this.map.stop()},Vy.prototype._getMap=function(){return this.map},Vy.prototype._rebuildStyle=function(){return T(this,void 0,void 0,function(){return C(this,function(t){return this.styles.setStyleUrl(this.styleOptions),this.imageSprite._restoreImages(),[2]})})},Vy.prototype._isLoaded=function(){return this.loaded},Vy.prototype._isReady=function(){return this.ready},Vy.prototype._getLocalizedStrings=function(){return this.localizedStringsPromise},Vy.prototype._sendRequest=function(t,e,i){var r;return(r="function"==typeof this.serviceOptions.transformRequest?this.serviceOptions.transformRequest(t,e):r)?fetch(r.url||t,{credentials:r.credentials,headers:S(S({},i),r.headers),method:"GET",mode:"cors"}):fetch(t,{headers:i,method:"GET",mode:"cors"})},Vy.prototype._substituteDomainLanguageViewAndSignInRequest=function(t,e){var i;(t.includes(d)||t.includes(h))&&(i=new RegExp("[^{]"+d+"[^}]"),t.match(i)&&(e.url=e.url.replace(d,h)),R.protoRegEx.test(this.serviceOptions.domain)?(i=e.url.indexOf(h),e.url=this.serviceOptions.domain+e.url.substring(i+h.length)):e.url=e.url.replace(h,this.serviceOptions.domain)),e.url.toLocaleLowerCase().includes(this.serviceOptions.domain.toLocaleLowerCase())&&this.authentication&&this.authentication.signRequest(e),t.includes(m)&&(e.url=e.url.replace(m,this.styleOptions.language)),t.includes(f)&&(e.url=this.styleOptions.view?e.url.replace(f,this.styleOptions.view):e.url.replace(f,"").replace("&view=",""))},Vy.prototype._setAutoResize=function(t){t?window.addEventListener("resize",this._windowResizeCallback):window.removeEventListener("resize",this._windowResizeCallback)},Vy.prototype._setStyleComponents=function(t){this.removed||(this.styleOptions=t,this._rebuildStyle())},Vy.prototype._updateGlobalDefaults=function(t){t&&(t.authOptions&&!Ga&&Ja(t.authOptions),t.domain&&!Ba&&Qa(t.domain),t.styleDefinitionsPath&&!Fa&&$a(t.styleDefinitionsPath),t.styleDefinitionsVersion&&!Ua&&ts(t.styleDefinitionsVersion),t.workerCount&&!ja&&es(t.workerCount),t.maxParallelImageRequests&&!Va&&is(t.maxParallelImageRequests),!t.subscriptionKey&&!t["subscription-key"]||Ga||os(t.subscriptionKey||t["subscription-key"]),!t.sessionId&&!t["session-id"]||Ha||ns(t.sessionId||t["session-id"]),t.language&&!qa&&rs(t.language),!t.userRegion&&!t.view||Na||as(t.userRegion||t.view))},Vy.prototype._generateSafeBounds=function(t){if(t){var e=nn.getSouth(t),i=nn.getWest(t),r=nn.getNorth(t),n=nn.getEast(t);if(isNaN(e)||isNaN(i)||isNaN(r)||isNaN(n))throw new Error("The bounds specified are invalid: ["+t+"]");for(;n<i;)n+=360;return new nn([i,e,n,r])}return t},Vy.prototype._detectHighContrast=function(){var t,e;switch(us.getHighContrastMode()){case"invert":case"light":t=Vy.Css.hcLight,e="high_contrast_light";break;case"dark":t=Vy.Css.hcDark,e="high_contrast_dark"}t&&this.map.getContainer().classList.add(t),e&&"road"===this.styleOptions.style&&(this.styleOptions.style=e)},Vy.Css={canvasContainer:"atlas-map-canvas-container",canvas:"atlas-map-canvas",container:"atlas-map",hcDark:"high-contrast-dark",hcLight:"high-contrast-light"},Vy);function Vy(e,i){var n=Uy.call(this)||this;n.styleSourceIds=new Set,n.removed=!1,n.loaded=!1,n.ready=!1,n._windowResizeCallback=function(){return n.resize()};var o,a,s=!0;n._updateGlobalDefaults(i),n.serviceOptions=(new Ry).merge(i),n.styleOptions=(new Iy).merge(i),n.trafficOptions=new Py,n.styles=new By(n,n.serviceOptions),n.insights=new Cf(n.serviceOptions),n.serviceOptions.authOptions.subscriptionKey&&(n.serviceOptions.authOptions.subscriptionKey=encodeURIComponent(n.serviceOptions.authOptions.subscriptionKey)),o=n.serviceOptions.authOptions.clientId||(n.serviceOptions.authOptions.subscriptionKey?n.serviceOptions.authOptions.subscriptionKey.replace(/.(?=.{3,}$)/g,"*"):"invalid-setting"),n.insights&&n.insights.setAuthenticatedUserContext(n.serviceOptions.sessionId,o),arguments[2]&&"ENVIRONMENT"in window&&window.ENVIRONMENT.hmr?(a=arguments[2],n.ready=!0,n.loaded=!0):(e={attributionControl:!1,container:e,preserveDrawingBuffer:n.styleOptions.preserveDrawingBuffer,refreshExpiredTiles:n.serviceOptions.refreshExpiredTiles,renderWorldCopies:n.styleOptions.renderWorldCopies,trackResize:!1,transformRequest:function(t,e){var i={url:t};return"Tile"===e||"Source"===e?(t.includes(d)&&n.insights&&n.insights.trackEvent({name:"TileLoad"}),n._substituteDomainLanguageViewAndSignInRequest(t,i)):"SpriteJSON"!==e&&"SpriteImage"!==e&&"Glyphs"!==e||n.styles._transformStyleRequest(t,i),n.serviceOptions.transformRequest&&ga(i,n.serviceOptions.transformRequest(i.url,e)),i}},a=new r.Map(e));try{n.map=a,n.authentication=new Tm(n),n.controls=new Em(n),n.events=new Pm(n),n.imageSprite=new Rm(n),n.layers=new Fm(n),n.markers=new Lm(n),n.sources=new Zm(n),n.popups=new jm(n),n.map.getContainer().classList.add(Vy.Css.container),n.map.getCanvasContainer().classList.add(Vy.Css.canvasContainer),n.map.getCanvas().classList.add(Vy.Css.canvas),n._detectHighContrast(),n.copyrightControl=new Mf({showFeedbackLink:n.styleOptions.showFeedbackLink,showLogo:n.styleOptions.showLogo,customAttribution:n.styleOptions.customAttribution}),n.controls.add(n.copyrightControl,{position:t.ControlPosition.NonFixed});var l=n.authentication?n.authentication.initialize():Promise.resolve();if(n.removed)return n;var u=function(){n.loaded=!0,n.map.off("load",u)};n.map.on("load",u);var c=function(){n.ready=!0,n.map.off("styledata",c),n.events.invoke("ready",{map:n,type:"ready"})};n.map.on("styledata",c),n._setAutoResize(n.styleOptions.autoResize),n.map.showTileBoundaries=n.styleOptions.showTileBoundaries,n.localizedStringsPromise=wa.getStrings(n.styleOptions.language);var p=n.styles.initialize();Promise.all([l,p]).then(function(){if(!n.removed){if(n.authentication&&!n.authentication.getToken())throw new Error("AuthenticationManager finished initializing, but no token is available");n.serviceOptions["enable-accessibility"]&&n.accessibleMapDelegate.addToMap(),n._setStyleComponents(n.styleOptions),n.copyrightDelegate&&n.copyrightDelegate.addToMap()}}).catch(function(t){t=t instanceof Error?t:new Error(t),n.insights&&n.insights.trackException({error:t}),n.events.invoke("error",{map:n,type:"error",error:t})}),n.setCamera(S(S({},i),{type:"jump",duration:0})),n.incidentDelegate=new Xf(n),n.flowDelegate=new Hf(n),n.accessibleMapDelegate=new qf(n),n.userInteractionDelegate=new am(n,i),n.userInteractionDelegate.addToMap(),n.copyrightDelegate=new gm(n,n.copyrightControl,n.styleOptions)}catch(e){throw s=!1,n.insights&&n.insights.trackException({error:e instanceof Error?e:new Error(e)}),e}finally{n.insights&&(n.insights.trackEvent({name:"MapLoad"},{success:s,supported:Ya(!1),supportedWithPerformance:Ya(!0)}),n.insights.flush())}return n}function qy(){this.detectHyperlinks=!0,this.parsePropertyPaths=!0}qy.applyTemplate=function(t,e){var i,r,n,o=this,a=document.createElement("div");return a.classList.add(qy.Css.template),t&&("boolean"!=typeof(e=e||{}).singleDescription&&(e.singleDescription=!0),e.sandboxContent="boolean"!=typeof e.sandboxContent||e.sandboxContent,e.title&&"string"==typeof e.content&&(e.content.includes("{title}")||e.content.includes("{name}"))||(t.title?e.title="{title}":t.name&&(e.title="{name}")),"boolean"!=typeof e.detectHyperlinks&&(e.detectHyperlinks=!0),"boolean"!=typeof e.parsePropertyPaths&&(e.parsePropertyPaths=!0),e.textColor&&(a.style.color=e.textColor),e.fillColor&&(a.style.backgroundColor=e.fillColor),e.title&&((n=this._applyStringTemplate(t,e.title,e)).innerText=n.textContent||n.innerText||"",this._appendChild(a,n,qy.Css.title)),(i=document.createElement("div")).classList.add(qy.Css.content),Array.isArray(e.content)?0<e.content.length&&e.content[0].propertyPath?this._appendChild(i,this._generateContent(t,e.content,e),qy.Css.item):e.content.forEach(function(r){o._appendChild(i,o._generateContent(t,r,e),qy.Css.item)}):(r=0,t.description&&Object.keys(t).forEach(function(e){o._ignoreProperty(e,t[e])||r++}),n=void 0,1===r||e.singleDescription&&t.description||2===r&&t.Snippet?(n=document.createElement("div")).innerHTML=t.description:n=this._generateContent(t,e.content,e),this._appendChild(i,n,qy.Css.item)),""!==i.innerHTML&&(e.sandboxContent?a.appendChild(qy._createSandboxedIframe(i,e)):a.appendChild(i))),a},qy._createSandboxedIframe=function(t,e){var i=document.createElement("iframe");i.sandbox.add("allow-popups");var r=t.innerHTML,n=!1,o=100,a=550,s=10,l=0;document.body.scrollWidth<=340&&(a=300,o=50);var u=r.split(/<(tr|div|br|li|h[0-9]|p>)/);l=Math.max.apply(Math,k(u.map(function(t){return t.replace(/<[a-zA-Z0-9\s=\/]+>/g,"").length})))-1;return(t=Math.ceil(3.5*l))<a&&(a=t,o=l),r.includes("<img")||r.includes("<video")?(n=!0,i.width="550px"):(l=-1<r.indexOf(qy.Css.table)?25:20,s+=Math.max(.5*u.length*l,Math.ceil(r.replace(/<[a-zA-Z0-9\s=\/]+>/g,"").length/o)*l)),i.width=a+"px",i.height=n||280<s?"280px":s+"px",s=e.textColor?"color:"+e.textColor+";":"",e=e.fillColor?"background-color:"+e.fillColor+";":"",r='<html><head><title></title><meta charset="utf-8" /><meta http-equiv="x-ua-compatible" content="IE=Edge" /><link rel="stylesheet" href="'+qy._cssUrl+'" type="text/css"/><style>html, body{margin:0;padding:0;'+s+e+'}</style></head><body><div class="'+qy.Css.template+'" style="padding:0;width:'+(a-20)+'px">'+r+"</div></body></html>",void 0===i.srcdoc?i.src="data:text/html;charset=utf-8,"+encodeURI(r):i.srcdoc=r,i},qy._appendChild=function(t,e,i){e&&(i&&(e.className=(e.className?e.className+" ":"")+i),t.appendChild(e))},qy._generateContent=function(t,e,i){return e?Array.isArray(e)?this._generatePropertyInfoTable(t,e,i):this._applyStringTemplate(t,e,i):(t=this._generateDynamicTableHtml(t,null,i))?((i=document.createElement("div")).innerHTML=t,i):null},qy._applyStringTemplate=function(t,e,i){if(e){for(var r,n=e,o=this._placeholderRx.exec(e);o;)2<=o.length&&(r=this._getPropertyValue(t,o[1],i),n=n.replace(o[0],r)),o=this._placeholderRx.exec(e);if(n){(n=n.trim()).includes("<")&&(n=n.replace(/[\r\n]+/g,"<br/>"));var a=document.createElement("div");return a.innerHTML=n,a}}return null},qy._getPropertyValue=function(t,e,i,r){var n=i.parsePropertyPaths?e.split("/"):[e],o=n.length;if(0<o&&t){var a=n[0],s=t[a];if(i.detectHyperlinks&&"link"===e&&(!r||r.hyperlinkFormat)){var l,u=[];if(Array.isArray(s)?s.forEach(function(t){t.href?u.push(t):"string"==typeof t&&u.push({href:t})}):s.href&&u.push(s),0<u.length){r&&r.hyperlinkFormat?l=r.hyperlinkFormat:i&&i.hyperlinkFormat&&(l=i.hyperlinkFormat);var c=l&&l.target?l.target:"_blank",p=[];return u.forEach(function(t){t.title||l&&l.label||!t.rel||p.push(t.rel," - "),p.push('<a href="',t.href,'" target="',c,'">'),t.title?p.push(t.title):l&&l.label?p.push(l.label):p.push(t.href),p.push("</a>","<br/>")}),p.pop(),p.join("")}}if(null!=s){var h=void 0;for(h=1;h<o&&(s=s[n[h]],a=n[h],null!=s);h++);if(h===o&&null!=s){var d=void 0;if((d=void 0!==s.value?s.value:s)instanceof Date)return r&&r.dateFormat?d.toLocaleString(void 0,r.dateFormat):i.dateFormat?d.toLocaleString(void 0,i.dateFormat):d.toISOString();if("object"==typeof d)return(m=this._generateDynamicTableHtml(d,n.slice(1),i))||"";if("number"==typeof d){if(r){if(r.dateFormat)return new Date(d).toLocaleString(void 0,r.dateFormat);if(r.numberFormat)return d.toLocaleString(void 0,r.numberFormat)}else if(/(timestamp|date)/gi.test(a))return new Date(d).toISOString();return d.toLocaleString(void 0,i.numberFormat)}if("string"==typeof d&&""!==d&&!/[\n\r<>\s]/g.test(d)&&(i.detectHyperlinks||r&&r.hyperlinkFormat)){d=d.trim();var f=this._isUrlRx.test(d)||r&&r.hyperlinkFormat;t=this._isImageUrlRx.test(d)&&(f||d.startsWith("data:image")),e=this._emailRx.test(d);if(f||t||e){f=void 0,r&&r.hyperlinkFormat?f=r.hyperlinkFormat:i&&i.hyperlinkFormat&&(f=i.hyperlinkFormat);var m=void 0;return m=f&&f.target?' target="'+f.target+'"':' target="_blank"',i=""+(f&&f.label?f.label:d),f&&f.scheme?d=f.scheme+d:e&&(d="mailto:"+d),e=f&&f.label?' alt="'+f.label+'"':"",'<a href="'+d+'"'+m+">"+(i=f&&f.isImage||t?'<img src="'+d+'" style="max-width:100%"'+e+'"/>':i)+"</a>"}}return d.toString()}}}return""},qy._generatePropertyInfoTable=function(t,e,i){if(t&&e&&0<e.length){var r=[],n=this;return r.push('<table class="'+n.Css.table+'">'),e.forEach(function(e){var o=n._getPropertyValue(t,e.propertyPath,i,e);e.hideLabel?r.push('<tr><td colspan="2">',o,"</td></tr>"):(e=e.label||e.propertyPath.split("/")[0],r.push("<tr><th>",e,"</th><td>",o,"</td></tr>"))}),r.push("</table>"),(e=document.createElement("div")).innerHTML=r.join(""),e}return null},qy._generateDynamicTableHtml=function(t,e,i){var r=this;if(t){var n=[],o=this;n.push('<table class="'+o.Css.table+'">');var a=e&&0<e.length?e.join("/")+"/":"",s=0;return Object.keys(t).forEach(function(e){r._ignoreProperty(e,t[e])||(n.push("<tr><th>",e,"</th><td>",o._getPropertyValue(t,a+e,i),"</td></tr>"),s++)}),0===s?null:(n.push("</table>"),n.join(""))}return null},qy._ignoreProperty=function(t,e){switch(t){case"title":case"name":case"base":case"popupTemplate":case"anchor":case"icon":case"image":case"imageUrl":case"rotation":case"color":case"size":case"offset":case"strokeColor":case"strokeWidth":case"strokeOpacity":case"subType":case"fillColor":case"fillOpacity":case"visibility":case"visible":return!0;default:if(0===t.indexOf("_")||null==e||""===e)return!0}return!1},qy._placeholderRx=/\{([a-zA-Z0-9_\/\s]+)\}/gi,qy._isUrlRx=/^(http|https|ftp|tel|mailto):\/\//i,qy._isImageUrlRx=/(^data:image|.png$|.jpg$|.jpeg$|.gif$|.bmp$|.svg|.tif|.tiff$)/i,qy._emailRx=/^[^\.\s@:](?:[^\s@:]*[^\s@:\.])?@[^\.\s@]+(?:\.[^\.\s@]+)*$/,qy._cssUrl=new R({domain:s,path:"sdk/javascript/mapcontrol/"+N.getEndpointVersion()+"/atlas.min.css"}).toString(),qy.Css={template:"azure-maps-control-popup-template",title:"azure-maps-control-popup-template-title",content:"azure-maps-control-popup-template-content",item:"azure-maps-control-popup-template-content-item",table:"azure-maps-control-popup-template-table"},A=qy,n(new R({domain:s,path:"sdk/javascript/mapcontrol/"+N.getEndpointVersion()+"/mapbox-gl-rtl-text.min.js"}).toString(),function(t){t&&console.warn(t)},!0),t.HtmlMarker=oa,t.Map=jy,t.Pixel=Gi,t.Popup=$o,t.PopupTemplate=A,t.Shape=tn,t._getAssetDomain=function(){return a},t._getDomain=function(){return La},t._hasMaxParallelImageRequests=function(){return Va},t._hasSetAuthenticationOptions=function(){return Ga},t._hasSetDomain=function(){return Ba},t._hasSetLanguage=function(){return qa},t._hasSetSessionId=function(){return Ha},t._hasSetStyleDefinitionsPath=function(){return Fa},t._hasSetStyleDefinitionsVersion=function(){return Ua},t._hasSetView=function(){return Na},t._hasWorkerCount=function(){return ja},t.addImageTemplate=function(t,e,i){!i&&ls[t.toLowerCase()]||(ls[t.toLowerCase()]=e)},t.clearPrewarmedResources=function(){r.clearPrewarmedResources()},t.control=xt,t.data=e,t.getAllImageTemplateNames=function(){return Object.keys(ls)},t.getAuthenticationOptions=Za,t.getDomain=function(){return La},t.getImageTemplate=ss,t.getLanguage=function(){return Pa},t.getMaxParallelImageRequests=Ka,t.getSessionId=function(){return Ma},t.getStaticAssetsDomain=function(){return Oa},t.getStyleDefinitionsPath=function(){return Ra},t.getStyleDefinitionsVersion=function(){return za},t.getSubscriptionKey=Xa,t.getUserRegion=function(){return Ia},t.getVersion=function(){return N.getFullVersion()},t.getView=function(){return Ia},t.getWorkerCount=Wa,t.internal=K,t.isSupported=Ya,t.layer=ht,t.math=dt,t.prewarm=function(){r.prewarm()},t.setAuthenticationOptions=Ja,t.setDomain=Qa,t.setLanguage=rs,t.setMaxParallelImageRequests=is,t.setSessionId=ns,t.setStyleDefinitionsPath=$a,t.setStyleDefinitionsVersion=ts,t.setSubscriptionKey=os,t.setUserRegion=as,t.setView=function(t){Ia=t,Na=!0},t.setWorkerCount=es,t.source=_t,Object.defineProperty(t,"__esModule",{value:!0})});var ubicacion,mainMap,dataMainMap,datasourceMainMap,cluster,amrker,_0x8134=["random","length","info_soportes","floor","latitud","longitud","mainMap","es-Es","Auto","grayscale_light","subscriptionKey","ready","clear","error","add","events","road","night","grayscale_dark","high_contrast_dark","list","control","bottom-right","controls","concat","get","camaras","dataSoporte","+","source","sources","blue","layer","layers","data","none","","id_soporte","calle","push","map",",",":","join","https://{azMapsDomain}/route/directions/json?api-version=1&query={query}&routeRepresentation=polyline&travelMode=car&view=Auto","{query}","replace","&computeBestOrder=true","routes","optimizedWaypoints","optimizedIndex","then","{azMapsDomain}","getDomain","signRequest","authentication","tranformRequest","getServiceOptions","json","url","GET","cors","headers","legs","longitude","latitude","points"],mostrarCluster=!0,maxBoundDefault=[-118.851303,32.721998,-117.659286,34.831255],listoMainMap=!1;function initMainMap(){let t=Math[_0x8134[3]](Math[_0x8134[0]]()*dataMainMap[_0x8134[2]][_0x8134[1]]);dataMainMap[_0x8134[2]][t][_0x8134[4]],dataMainMap[_0x8134[2]][t][_0x8134[5]];mainMap=new atlas.Map(_0x8134[6],{preserveDrawingBuffer:!1,renderWorldCopies:!1,showBuildingModels:!1,showFeedbackLink:!1,showLogo:!1,zoom:12,maxZoom:23,minZoom:10,language:_0x8134[7],view:_0x8134[8],style:_0x8134[9],dragPanInteraction:!0,authOptions:{authType:_0x8134[10],subscriptionKey:subscriptionKey}}),readyMap()}function readyMap(){mainMap[_0x8134[15]][_0x8134[14]](_0x8134[11],function(){console[_0x8134[12]](),configurarDataSource(),agregarControles(),mainMap[_0x8134[15]][_0x8134[14]](_0x8134[13],t=>{})})}function agregarControles(){mainMap[_0x8134[23]][_0x8134[14]](new atlas[_0x8134[21]].StyleControl({mapStyles:[_0x8134[16],_0x8134[9],_0x8134[17],_0x8134[18],_0x8134[19]],layout:_0x8134[20]}),{position:_0x8134[22]}),mainMap[_0x8134[23]][_0x8134[14]](new atlas[_0x8134[21]].BringDataIntoViewControl,{position:_0x8134[22]}),mainMap[_0x8134[23]][_0x8134[14]]([new atlas[_0x8134[21]].ZoomControl],{position:_0x8134[22]})}async function configurarDataSource(){datasourceMainMap=new atlas[_0x8134[29]].DataSource(null,{cluster:mostrarCluster,clusterRadius:300,clusterMaxZoom:21,maxZoom:21,clusterProperties:{Camaras:[_0x8134[24],[_0x8134[25],_0x8134[26],[_0x8134[25],_0x8134[27]]]],Puntero:[_0x8134[28],[_0x8134[1],[_0x8134[25],_0x8134[26],[_0x8134[25],_0x8134[27]]]]],Numero_Camaras:[_0x8134[28],[_0x8134[1],[_0x8134[25],_0x8134[26],[_0x8134[25],_0x8134[27]]]]],Position_Cam:[_0x8134[28],0]}}),mainMap[_0x8134[30]][_0x8134[14]](datasourceMainMap),mainMap[_0x8134[33]][_0x8134[14]]([new atlas[_0x8134[32]].LineLayer(datasourceMainMap,null,{strokeColor:_0x8134[31],strokeWidth:4})]),await datasourceMainMap[_0x8134[14]](getPointsMainMap(dataMainMap[_0x8134[2]])),await calcularZoomDefault(),setTimeout(()=>{},1e3)}function getPointsMainMap(t){const e=[];return t[_0x8134[40]]((t,i)=>{e[_0x8134[39]](new atlas[_0x8134[34]].Feature(new atlas[_0x8134[34]].Point([Number(t[_0x8134[5]]),Number(t[_0x8134[4]])]),{dataSoporte:t,image:_0x8134[35],id_soporte:`${_0x8134[36]}${t[_0x8134[37]]}${_0x8134[36]}`,calle:`${_0x8134[36]}${t[_0x8134[38]]}${_0x8134[36]}`,posicion:i+1},i+1))}),listoMainMap=!0,e}function armarTramo(t){for(var e=[],i=[],r=t,n=0;n<r[_0x8134[1]];n++)e[_0x8134[39]](r[n][1]+_0x8134[41]+r[n][0]),i[_0x8134[39]](n);var o=e[_0x8134[43]](_0x8134[42]),a=_0x8134[44][_0x8134[46]](_0x8134[45],o);processRequest2(a+=_0x8134[47])[_0x8134[51]](t=>{addRouteToMap2(t[_0x8134[48]][0]);for(var e=[0],i=0;i<t[_0x8134[49]][_0x8134[1]];i++)e[_0x8134[39]](t[_0x8134[49]][i][_0x8134[50]]+1);e[_0x8134[39]](r[_0x8134[1]]-1)})}function processRequest2(t){return new Promise((e,i)=>{t=t[_0x8134[46]](_0x8134[52],atlas[_0x8134[53]]());var r=mainMap[_0x8134[55]][_0x8134[54]]({url:t}),n=mainMap[_0x8134[57]]()[_0x8134[56]];n&&(r=n(t)),fetch(r[_0x8134[59]],{method:_0x8134[60],mode:_0x8134[61],headers:new Headers(r[_0x8134[62]])})[_0x8134[51]](t=>t[_0x8134[58]](),t=>i(t))[_0x8134[51]](t=>{e(t)},t=>i(t))})}function addRouteToMap2(t){for(var e,i=[],r=0;r<t[_0x8134[63]][_0x8134[1]];r++){var n=t[_0x8134[63]][r][_0x8134[66]][_0x8134[40]](function(t){return[t[_0x8134[64]],t[_0x8134[65]]]});i=i[_0x8134[24]](n)}e=new atlas.Shape(new atlas[_0x8134[34]].LineString(i)),datasourceMainMap[_0x8134[14]](e)}var map,emailFile,subscriptionKey,popup,datasource,soporte,markerLayer,marker,velocidad,distanciaEnKm,umenor,umayor,HtmlMarkerLayer,dataImage,actualizar,p2,u2,c2,_0xe86d=["getAllImageTemplateNames","myMap","es-Es","Auto","subscriptionKey","ready","add","events","control","bottom-right","controls","output","getElementById","innerHTML","","appendChild","message","then","getImage","MapImageExporter","open",'<img src="','"/>',"write","document","getDataUri","getBlob","Map Image","To: ","\nSubject: ",'\nX-Unsent: 1\nContent-Type: text/html\n\n<html lang="en">\n<body>',"</body>\n</html>","text/plain","revokeObjectURL","URL","createObjectURL","emailLink","href","display","style","block","source","sources","blue","layer","layers","cluster","dataSoporte","parse","random","length","camaras","floor",'\r\n\r\n<html>\r\n\r\n<div class="" style="\r\nmargin:0px;\r\npadding:0px;\r\nwidth: auto;\r\nheight: auto;\r\n" >\r\n\r\n<div class="" style="\r\nbackground-color: #fff;\r\nfont-size: smaller;\r\ntext-align: start;\r\n">\r\n<p>\r\nSoporte: <b> ',"Descripcion"," </b>\r\n<br/>\r\nCalle: <b> ","Calle"," </b>\r\n<br/>\r\nCámaras: <b> ",' </b>\r\n</p>\r\n\r\n</div>\r\n\r\n<div style="display:none;">\r\n\r\n<p style="margin-right:20px">\r\nLatitud:\r\n<br/>\r\n<b>',"Latitud","</b>\r\n</p>\r\n\r\n<p>\r\nLongitud:\r\n<br/>\r\n<b>","Longitud",'</b>\r\n</p>\r\n\r\n</div>\r\n\r\n<div style="width: 100%;height: 77%; display: grid;\r\n                  text-align: center;">\r\n\r\n<div style="width: 100%;\r\ndisplay: inline-flex;">\r\n\r\n\r\n\r\n\r\n</div>\r\n\r\n</div>   \r\n\r\n</div>\r\n\r\n</html>\r\n\r\n',"setOptions","IdSoporte","green","A","B","soportes","map","black","getImageTemplate","click","mouseenter","mouseleave","marker","popup","options","target","close","][","split","properties","Maximo alcanzado","No se puede seleccionar el mismo soporte","push",",",":","join","https://{azMapsDomain}/route/directions/json?api-version=1&query={query}&routeRepresentation=polyline&travelMode=car&view=Auto","{query}","replace","&computeBestOrder=true","routes","optimizedWaypoints","optimizedIndex","summary","lengthInMeters","round","travelTimeInSeconds","velocidad_maxima","umbral_maximo","umbral_minimo","{azMapsDomain}","getDomain","signRequest","authentication","tranformRequest","getServiceOptions","json","url","GET","cors","headers","legs","longitude","latitude","points","concat","data","getProperties","getShapeById","none","id_soporte","calle","posicion","setProperties","get","punto","#fff"],primeraCarga=!0,zoom=12,minZoom=10,soportes=[],deshabilitarChek=!0,icons=atlas[_0xe86d[0]](),existImage=!1,parametrosTramo=[],armarRuta2=!1;function initMapSoporteTramo(t,e){map=new atlas.Map(_0xe86d[1],{preserveDrawingBuffer:!0,renderWorldCopies:!1,showBuildingModels:!1,showFeedbackLink:!1,showLogo:!1,zoom:zoom,maxZoom:18,minZoom:minZoom,language:_0xe86d[2],view:_0xe86d[3],dragPanInteraction:!0,authOptions:{authType:_0xe86d[4],subscriptionKey:subscriptionKey}}),primeraCarga=!1,map[_0xe86d[7]][_0xe86d[6]](_0xe86d[5],function(){loadSampleData(),agregarControles2()})}function agregarControles2(){map[_0xe86d[10]][_0xe86d[6]](new atlas[_0xe86d[8]].BringDataIntoViewControl,{position:_0xe86d[9]}),map[_0xe86d[10]][_0xe86d[6]]([new atlas[_0xe86d[8]].ZoomControl],{position:_0xe86d[9]})}function loadInDiv(){atlas[_0xe86d[19]][_0xe86d[18]](map)[_0xe86d[17]](function(t){var e=document[_0xe86d[12]](_0xe86d[11]);e[_0xe86d[13]]=_0xe86d[14],e[_0xe86d[15]](t)},function(t){alert(t[_0xe86d[16]])})}function openInNewWindow(){atlas[_0xe86d[19]][_0xe86d[25]](map)[_0xe86d[17]](function(t){window[_0xe86d[20]]()[_0xe86d[24]][_0xe86d[23]](_0xe86d[21]+t+_0xe86d[22])},function(t){alert(t)})}function downloadMapImage(){atlas[_0xe86d[19]][_0xe86d[26]](map)[_0xe86d[17]](function(t){dataImage=t,existImage=!0},function(t){alert(t[_0xe86d[16]])})}function generateEmail(){var t=_0xe86d[14],e=_0xe86d[27];atlas[_0xe86d[19]][_0xe86d[25]](map)[_0xe86d[17]](function(i){var r=_0xe86d[21]+i+_0xe86d[22],n=new Blob([_0xe86d[28]+t+_0xe86d[29]+e+_0xe86d[30]+r+_0xe86d[31]],{type:_0xe86d[32]});null!==emailFile&&window[_0xe86d[34]][_0xe86d[33]](emailFile),emailFile=window[_0xe86d[34]][_0xe86d[35]](n);var o=document[_0xe86d[12]](_0xe86d[36]);o[_0xe86d[37]]=emailFile,o[_0xe86d[39]][_0xe86d[38]]=_0xe86d[40]})}async function loadSampleData(){popup=new atlas.Popup,datasource=new atlas[_0xe86d[41]].DataSource,map[_0xe86d[42]][_0xe86d[6]](datasource),map[_0xe86d[45]][_0xe86d[6]]([new atlas[_0xe86d[44]].LineLayer(datasource,null,{strokeColor:_0xe86d[43],strokeWidth:5})]),await datasource[_0xe86d[6]](getPoints(soporte)),await calcularZoomDefault(),markerLayer=new atlas[_0xe86d[44]].HtmlMarkerLayer(datasource,null,{markerCallback:(t,e,i)=>{i[_0xe86d[46]];var r=JSON[_0xe86d[48]](i[_0xe86d[47]]);popup=null,popup=new atlas.Popup;var n,o=_0xe86d[14],a=Math[_0xe86d[52]](Math[_0xe86d[49]]()*r[_0xe86d[51]][_0xe86d[50]]);r[_0xe86d[51]][a];o=`${_0xe86d[53]}${r[_0xe86d[54]]}${_0xe86d[55]}${r[_0xe86d[56]]}${_0xe86d[57]}${r[_0xe86d[51]][_0xe86d[50]]}${_0xe86d[58]}${r[_0xe86d[59]]}${_0xe86d[60]}${r[_0xe86d[61]]}${_0xe86d[62]}`,popup[_0xe86d[63]]({closeButton:!1,pixelOffset:[0,-40],draggable:!1,content:o,position:e});var s=_0xe86d[14],l=!1;return soportes[_0xe86d[69]]((t,e)=>{t[_0xe86d[64]]==r[_0xe86d[64]]?(n=_0xe86d[65],s=0==e?_0xe86d[66]:_0xe86d[67],l=!0):this[_0xe86d[68]][_0xe86d[50]]!=e+1||l||(n=_0xe86d[43])}),marker=new atlas.HtmlMarker({position:e,color:n,draggable:!1,secondaryColor:_0xe86d[70],htmlContent:atlas[_0xe86d[71]](icons[0]),text:s,pixelOffset:[0,0],popup:popup}),map[_0xe86d[7]][_0xe86d[6]](_0xe86d[72],marker,agregarSoporte),map[_0xe86d[7]][_0xe86d[6]](_0xe86d[73],marker,mouseEnterMarker),map[_0xe86d[7]][_0xe86d[6]](_0xe86d[74],marker,mouseLeaveMarker),this[_0xe86d[75]]}}),map[_0xe86d[45]][_0xe86d[6]](markerLayer),armarRuta2&&(armarRuta2=!1,armarRutaDos())}function armarRutaDos(){for(var t=[],e=[],i=[[Number(soportes[0].Longitud),Number(soportes[0].Latitud)],[Number(soportes[1].Longitud),Number(soportes[1].Latitud)]],r=0;r<i[_0xe86d[50]];r++)t[_0xe86d[85]](i[r][1]+_0xe86d[86]+i[r][0]),e[_0xe86d[85]](r);var n=t[_0xe86d[88]](_0xe86d[87]),o=_0xe86d[89][_0xe86d[91]](_0xe86d[90],n);processRequest(o+=_0xe86d[92])[_0xe86d[17]](t=>{addRouteToMap(t[_0xe86d[93]][0]);for(var e=[0],r=0;r<t[_0xe86d[94]][_0xe86d[50]];r++)e[_0xe86d[85]](t[_0xe86d[94]][r][_0xe86d[95]]+1);e[_0xe86d[85]](i[_0xe86d[50]]-1)})}function armarRuta(){for(var t=[],e=[],i=[[Number(soportes[0].Longitud),Number(soportes[0].Latitud)],[Number(soportes[1].Longitud),Number(soportes[1].Latitud)]],r=0;r<i[_0xe86d[50]];r++)t[_0xe86d[85]](i[r][1]+_0xe86d[86]+i[r][0]),e[_0xe86d[85]](r);var n=t[_0xe86d[88]](_0xe86d[87]),o=_0xe86d[89][_0xe86d[91]](_0xe86d[90],n);processRequest(o+=_0xe86d[92])[_0xe86d[17]](t=>{addRouteToMap(t[_0xe86d[93]][0]);var e=t[_0xe86d[93]][0][_0xe86d[96]],r=Math[_0xe86d[98]](e[_0xe86d[97]]/10)/100,n=e[_0xe86d[99]];velocidad=r/(n/3600),distanciaEnKm=r;var o=!1;parametrosTramo[_0xe86d[69]]((t,e)=>{velocidad<t[_0xe86d[100]]&&!o?(o=!0,umayor=t[_0xe86d[101]],umenor=t[_0xe86d[102]],velocidad=t[_0xe86d[100]]):e!=parametrosTramo[_0xe86d[50]]-1||o||(umayor=parametrosTramo[0][_0xe86d[101]],umenor=parametrosTramo[0][_0xe86d[102]],velocidad=parametrosTramo[0][_0xe86d[100]])});for(var a=[0],s=0;s<t[_0xe86d[94]][_0xe86d[50]];s++)a[_0xe86d[85]](t[_0xe86d[94]][s][_0xe86d[95]]+1);a[_0xe86d[85]](i[_0xe86d[50]]-1)})}function processRequest(t){return new Promise((e,i)=>{t=t[_0xe86d[91]](_0xe86d[103],atlas[_0xe86d[104]]());var r=map[_0xe86d[106]][_0xe86d[105]]({url:t}),n=map[_0xe86d[108]]()[_0xe86d[107]];n&&(r=n(t)),fetch(r[_0xe86d[110]],{method:_0xe86d[111],mode:_0xe86d[112],headers:new Headers(r[_0xe86d[113]])})[_0xe86d[17]](t=>t[_0xe86d[109]](),t=>i(t))[_0xe86d[17]](t=>{e(t)},t=>i(t))})}function addRouteToMap(t){for(var e,i=[],r=0;r<t[_0xe86d[114]][_0xe86d[50]];r++){var n=t[_0xe86d[114]][r][_0xe86d[117]][_0xe86d[69]](function(t){return[t[_0xe86d[115]],t[_0xe86d[116]]]});i=i[_0xe86d[118]](n)}e=new atlas.Shape(new atlas[_0xe86d[119]].LineString(i)),datasource[_0xe86d[6]](e),setTimeout(()=>{downloadMapImage()},1e3)}function agregarPuntos(){var t=null,e=null;soporte[_0xe86d[69]]((i,r)=>{soportes[0][_0xe86d[64]]==i[_0xe86d[64]]&&(t=r+1),soportes[1][_0xe86d[64]]==i[_0xe86d[64]]&&(e=r+1)}),datasource[_0xe86d[121]](t)[_0xe86d[126]]({dataSoporte:datasource[_0xe86d[121]](t)[_0xe86d[120]]()[_0xe86d[47]],image:_0xe86d[122],id_soporte:datasource[_0xe86d[121]](t)[_0xe86d[120]]()[_0xe86d[123]],calle:datasource[_0xe86d[121]](t)[_0xe86d[120]]()[_0xe86d[124]],punto:`${_0xe86d[66]}`,posicion:datasource[_0xe86d[121]](t)[_0xe86d[120]]()[_0xe86d[125]]}),datasource[_0xe86d[121]](e)[_0xe86d[126]]({dataSoporte:datasource[_0xe86d[121]](e)[_0xe86d[120]]()[_0xe86d[47]],image:_0xe86d[122],id_soporte:datasource[_0xe86d[121]](e)[_0xe86d[120]]()[_0xe86d[123]],calle:datasource[_0xe86d[121]](e)[_0xe86d[120]]()[_0xe86d[124]],punto:`${_0xe86d[67]}`,posicion:datasource[_0xe86d[121]](e)[_0xe86d[120]]()[_0xe86d[125]]}),map[_0xe86d[45]][_0xe86d[6]](new atlas[_0xe86d[44]].SymbolLayer(datasource,null,{iconOptions:{size:1.2},textOptions:{textField:[_0xe86d[127],_0xe86d[128]],color:_0xe86d[129],offset:[0,-1.2]}}))}function getPoints(t){const e=[];for(let i=0;i<t[_0xe86d[50]];i++)e[_0xe86d[85]](new atlas[_0xe86d[119]].Feature(new atlas[_0xe86d[119]].Point([Number(t[i].Longitud),Number(t[i].Latitud)]),{dataSoporte:t[i],image:_0xe86d[122],id_soporte:`${_0xe86d[14]}${t[i][_0xe86d[64]]}${_0xe86d[14]}`,calle:`${_0xe86d[14]}${t[i][_0xe86d[56]]}${_0xe86d[14]}`,punto:`${_0xe86d[14]}`,posicion:i+1},i+1));return e}mouseEnterMarker=(t=>{t[_0xe86d[78]][_0xe86d[77]][_0xe86d[76]][_0xe86d[20]](map)}),mouseLeaveMarker=(t=>{t[_0xe86d[78]][_0xe86d[77]][_0xe86d[76]][_0xe86d[79]]()}),agregarSoporte=(t=>{var e=JSON[_0xe86d[48]](t[_0xe86d[78]][_0xe86d[82]][_0xe86d[47]][_0xe86d[81]](_0xe86d[80]));if(2==soportes[_0xe86d[50]])alert(_0xe86d[83]);else{var i=!0;soportes[_0xe86d[69]](t=>{t[_0xe86d[64]]==e[_0xe86d[64]]&&(i=!1,alert(_0xe86d[84]))}),setTimeout(()=>{_0xe86d[14];i&&(1==soportes[_0xe86d[50]]?_0xe86d[66]:_0xe86d[67],t[_0xe86d[78]][_0xe86d[63]]({color:_0xe86d[65]}),soportes[_0xe86d[85]](e),2==soportes[_0xe86d[50]]&&(agregarPuntos(),setTimeout(()=>{armarRuta()},200),deshabilitarChek=!1))},50)}}),function(t,e){"use strict";var i=function(){return(i=Object.assign||function(t){for(var e,i=1,r=arguments.length;i<r;i++)for(var n in e=arguments[i])Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t}).apply(this,arguments)},r=(n.merge=function(t,e){for(var r=window||global,n=0,o=t.split(".");n<o.length;n++){var a=o[n];if(!r[a])return e;r=r[a]}return i(i({},r),e)},n);function n(){}var o=(a.prototype.onAdd=function(t,i){var r=this,n=(r._map=t).getMapContainer().classList;n.contains("high-contrast-dark")?r._hclStyle="dark":n.contains("high-contrast-light")&&(r._hclStyle="light");var o="light";r._hclStyle?"dark"===r._hclStyle&&(o=r._darkColor):o=r._options.style,"light"===o?o="white":"dark"===o?o=r._darkColor:"auto"===o&&(t.events.add("styledata",r._mapStyleChanged),o=r._getColorFromMapStyle());var s=a._getAriaLabel(t.getStyle().language),l=document.createElement("style");l.innerHTML=r._buttonCSS,document.body.appendChild(l);var u=document.createElement("div");u.classList.add("azure-maps-control-container"),u.setAttribute("aria-label",s),u.style.flexDirection="column",r._container=u;var c=document.createElement("button");return u2=t,c2=r,c.classList.add("azmaps-bringDataIntoViewBtn"),c.style.backgroundColor=o,c.setAttribute("title",s),c.setAttribute("alt",s),c.setAttribute("type","button"),(r._button=c).addEventListener("click",function(){var i=e.data.BoundingBox,n=[];t.sources.getSources().forEach(function(t){t instanceof e.source.DataSource&&(n=n.concat(t.toJson().features))});var o=null;0<n.length&&(o=i.fromData(n));for(var a=[],s=0,l=t.markers.markers.values();s<l.length;s++){var u=l[s];a.push(u.getOptions().position)}if(0<a.length){var c=i.fromPositions(a);o=null===o?c:i.merge(o,c)}for(var p=t.layers.getLayers(),h=0;h<p.length;h++)p[h]instanceof e.layer.ImageLayer&&(c=i.fromPositions(p[h].getOptions().coordinates),o=null===o?c:i.merge(o,c));if(null!==o){var d=i.getWidth(o),f=i.getHeight(o);d<1e-6||f<1e-6?t.setCamera({center:i.getCenter(o),zoom:12}):t.setCamera({bounds:o,padding:r._options.padding}),setTimeout(()=>{t.setCamera({bounds:o,padding:r._options.padding})},50)}}),u.appendChild(c),u},a.prototype.onRemove=function(){var t=this;t._container&&(t._container.remove(),t._container=null),"auto"===t._options.style&&t._map.events.remove("styledata",t._mapStyleChanged),t._map=null},a.prototype._getColorFromMapStyle=function(){return-1<["satellite","satellite_road_labels","grayscale_dark","night"].indexOf(this._map.getStyle().style)?this._darkColor:"white"},a._getAriaLabel=function(t){t&&0<t.indexOf("-")&&(t=t.substring(0,t.indexOf("-")));var e={af:"Bring data in die oog",ar:"جلب البيانات في الرأي",eu:"Ekarri datuak ikusteko",bg:"Привеждане на данните в изглед",zh:"将数据带入视图",hr:"Donesite podatke u prikaz",cs:"Přenést data do zobrazení",da:"Få vist data i visningen",nl:"Gegevens in beeld brengen",et:"Andmete vaatamine",fi:"Tuo tiedot näkymään",fr:"Mettre les données en vue",gl:"Fai ver os datos",de:"Daten in den Blick bringen",el:"Εισαγωγή δεδομένων σε προβολή",hi:"डेटा को दृश्य में लाएं",hu:"Adatok áthozása a nézetbe",id:"Bawa data ke tampilan",it:"Portare i dati in vista",ja:"データをビューに取り込む",kk:"Деректерді көрініске енгізіңіз",ko:"데이터를 뷰로 가져오기",es:"Lleve los datos a la vista",lv:"Datu skatīšana skatā",lt:"Atvesti duomenis į rodinį",ms:"Membawa data ke dalam paparan",nb:"Hent data til visning",pl:"Przynieś dane do widoku",pt:"Colocar os dados em exibição",ro:"Aducerea datelor în vizualizare",ru:"Перенесите данные в представление",sr:"Uskladi podatke u prikaz",sk:"Preniesť údaje do zobrazenia",sl:"Prinesite podatke v pogled",sv:"Ta fram data i vyn",th:"นำข้อมูลมาไว้ในมุมมอง",tr:"Verileri görünüme getirme",uk:"Приведення даних у режим перегляду",vi:"Mang dữ liệu vào chế độ xem",en:"Bring data into view"};return e[t.toLowerCase()]||e.en},a);function a(t){var e=this;this._darkColor="#011c2c",this._hclStyle=null,this._options={style:"light",padding:100},this._buttonCSS=".azmaps-bringDataIntoViewBtn{margin:0;padding:0;border:none;border-collapse:collapse;width:32px;height:32px;text-align:center;cursor:pointer;line-height:32px;background-repeat:no-repeat;background-size:20px;background-position:center center;z-index:200;box-shadow:0px 0px 4px rgba(0,0,0,0.16);background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAABcRAAAXEQHKJvM/AAAAB3RJTUUH4wMIFTgXULHJFAAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAhUlEQVRo3u3asQ2AIBAF0MO4p42FI1nYOKlugAUnJvL+BLzwcxGw7Md5RUO2dSmRkNZ1TPGTgICADAIptbGXNVqzUluraoGADAKZv/rIy56UqvVFartVVEu1QEBAQEBAQEBAQEAaz+xuGlXrpWr1PlvbERAQEJCIhzfEnqPYLxwgICBjQW7ewSYPr/zk7gAAAABJRU5ErkJggg==);}.azmaps-bringDataIntoViewBtn:hover{background-color:red;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAABcRAAAXEQHKJvM/AAAAB3RJTUUH4wMIFTcYR5bISgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAABDklEQVRo3u2aMQ+CMBSE7wjGwURXd1cHhb8Cv1L/ikDi7Goc1UESElMXN0UiLaToXcIEbe57vFd4TbneZnsAS7RUnkSEA623mbEZH9hA+KQAPyKBDAXEeOz5rbew5mECWAA4NUxKZ+6MGZMcNQRxDuDwDQgAlHkS3foKc5HGFYCqYYkuVewCEcifg4QWP3mzDr43zJPo0isIgHNHwWWbe8GHIaVv6ZMn0fHp+eWiRWqZjszyr4tdIAIRiEAEIhCBCEQgAhHI8Hr2ugbJGDMr0vjqk9nVZjclefnqjZCc+Bb1T55Cy7md76K0Tq2+e2sVu0AEIpDOQO4e+q31RBdbny6WYhdHOFQjAhGIQIajB80LO3KY+u0wAAAAAElFTkSuQmCC);}",this._mapStyleChanged=function(){e._button&&!e._hclStyle&&(e._button.style.backgroundColor=e._getColorFromMapStyle())},this._options=Object.assign(this._options,t||{})}var s=Object.freeze({__proto__:null,BringDataIntoViewControl:o}),l=r.merge("atlas.control",s);t.control=l,p2=e}(this.atlas=this.atlas||{},atlas);var _0x8f19=["BoundingBox","data","DataSource","source","features","toJson","concat","forEach","getSources","sources","length","fromData","values","markers","position","getOptions","push","fromPositions","merge","getLayers","layers","ImageLayer","layer","coordinates","getWidth","getHeight","getCenter","setCamera","padding","_options"];function calcularZoomDefault(){var t=p2[_0x8f19[1]][_0x8f19[0]],e=[];u2[_0x8f19[9]][_0x8f19[8]]()[_0x8f19[7]](function(t){t instanceof p2[_0x8f19[3]][_0x8f19[2]]&&(e=e[_0x8f19[6]](t[_0x8f19[5]]()[_0x8f19[4]]))});var i=null;0<e[_0x8f19[10]]&&(i=t[_0x8f19[11]](e));for(var r=[],n=0,o=u2[_0x8f19[13]][_0x8f19[13]][_0x8f19[12]]();n<o[_0x8f19[10]];n++){var a=o[n];r[_0x8f19[16]](a[_0x8f19[15]]()[_0x8f19[14]])}if(0<r[_0x8f19[10]]){var s=t[_0x8f19[17]](r);i=null===i?s:t[_0x8f19[18]](i,s)}for(var l=u2[_0x8f19[20]][_0x8f19[19]](),u=0;u<l[_0x8f19[10]];u++)l[u]instanceof p2[_0x8f19[22]][_0x8f19[21]]&&(s=t[_0x8f19[17]](l[u][_0x8f19[15]]()[_0x8f19[23]]),i=null===i?s:t[_0x8f19[18]](i,s));if(null!==i){var c=t[_0x8f19[24]](i),p=t[_0x8f19[25]](i);c<1e-6||p<1e-6?u2[_0x8f19[27]]({center:t[_0x8f19[26]](i),zoom:12}):u2[_0x8f19[27]]({bounds:i,padding:c2[_0x8f19[29]][_0x8f19[28]]}),setTimeout(()=>{u2[_0x8f19[27]]({center:t[_0x8f19[26]](i),zoom:12,bounds:i,padding:c2[_0x8f19[29]][_0x8f19[28]]})},50)}}!function(t,e){"use strict";var i=function(t,e){return(i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(t,e)};function r(t,e){function r(){this.constructor=t}i(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}var n=function(){return(n=Object.assign||function(t){for(var e,i=1,r=arguments.length;i<r;i++)for(var n in e=arguments[i])Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t}).apply(this,arguments)},o=(a.merge=function(t,e){for(var i=window||global,r=0,o=t.split(".");r<o.length;r++){var a=o[r];if(!i[a])return e;i=i[a]}return n(n({},i),e)},a);function a(){}var s,l=(r(u,s=e.layer.BubbleLayer),u.prototype.getOptions=function(){return Object.assign({},this._options)},u.prototype.setOptions=function(t){var e=this._options,i={},r=!1;t.source&&e.source!==t.source&&(e.source=t.source,i.source=t.source,r=!0),t.sourceLayer&&e.sourceLayer!==t.sourceLayer&&(e.sourceLayer=t.sourceLayer,i.sourceLayer=t.sourceLayer,r=!0),t.filter&&e.filter!==t.filter&&(e.filter=t.filter,i.filter=t.filter,r=!0),"number"==typeof t.minZoom&&e.minZoom!==t.minZoom&&(e.minZoom=t.minZoom,i.minZoom=t.minZoom),"number"==typeof t.maxZoom&&e.maxZoom!==t.maxZoom&&(e.maxZoom=t.maxZoom,i.maxZoom=t.maxZoom),void 0!==t.visible&&e.visible!==t.visible&&(e.visible=t.visible,i.visible=t.visible),t.markerCallback&&e.markerCallback!=t.markerCallback&&(e.markerCallback=t.markerCallback,r=!0),"boolean"==typeof t.updateWhileMoving&&e.updateWhileMoving!==t.updateWhileMoving&&(e.updateWhileMoving=t.updateWhileMoving),r?this._clearCache(!0):this._updateMarkers(),s.prototype.setOptions.call(this,i)},u.prototype.update=function(){this._clearCache(!0),this._updateMarkers()},u.prototype.onAdd=function(t){var e=this,i=t.events;t&&(i.remove("moveend",e._updateMarkers),i.remove("move",e._mapMoved),i.remove("sourcedata",e._sourceUpdated)),(i=(e._map=t).events).add("moveend",e._updateMarkers),i.add("move",e._mapMoved),i.add("sourcedata",e._sourceUpdated),s.prototype.onAdd.call(this,t)},u.prototype.onRemove=function(){var t=this,e=t._map;if(e){var i=e.events;i.remove("moveend",t._updateMarkers),i.remove("move",t._mapMoved),i.remove("sourcedata",t._sourceUpdated)}t._clearCache(!1),t._map=null,s.prototype.onRemove.call(this)},u.prototype._getSourceClass=function(){var t=this.getSource();return"string"==typeof t&&null!==this._map?this._map.sources.getById(t):t instanceof e.source.Source?t:null},u.prototype._clearCache=function(t){var e=this;if(e._markerCache={},e._map)for(var i=0,r=e._markers.length;i<r;i++){var n=e._markers[i];e._removeEvents(n),n._eventsAttached=!1,e._map.markers.remove(n)}e._markers=[],e._markerIds=[],t&&e._updateMarkers()},u.prototype._getMarker=function(t,e,i){var r=this._markerCache,n=this._options;if(r[t=t||e.join(",")+JSON.stringify(i||{})])return r[t];var o=n.markerCallback(i.posicion,e,i);return o?(o.properties=i,o.id=t,o.setOptions({position:e}),r[t]=o):null},u.prototype._addEvents=function(t){var e=this;e._supportedEvents.forEach(function(i){e.map.events.add(i,t,e._wrappedEvent)})},u.prototype._removeEvents=function(t){var e=this;e._supportedEvents.forEach(function(i){e.map.events.remove(i,t,e._wrappedEvent)})},u);function u(t,i,r){var n=s.call(this,t,i)||this;return n._options={minZoom:0,maxZoom:24,visible:!0,updateWhileMoving:!1,filter:["==",["geometry-type"],"Point"],markerCallback:function(t,i,r){return r.cluster?new e.HtmlMarker({position:i,text:r.point_count_abbreviated}):new e.HtmlMarker({position:i})}},n._markers=[],n._markerIds=[],n._markerCache={},n._supportedEvents=["click","contextmenu","dblclick","drag","dragstart","dragend","keydown","keypress","keyup","mousedown","mouseenter","mouseleave","mousemove","mouseout","mouseover","mouseup"],n._mapMoved=function(){n._options.updateWhileMoving&&n._updateMarkers()},n._sourceUpdated=function(t){var e=n._getSourceClass();e&&e.getId()===t.source.id&&(n._timer&&clearTimeout(n._timer),n._timer=setTimeout(n._sourceUpdater,33))},n._sourceUpdater=function(){n._timer=null,n._clearCache(!0)},n._updateMarkers=function(){var t=n,i=t._map,r=t._markers,o=t._options,a=i?i.getCamera().zoom:void 0;if(o.visible&&void 0!==a&&a>=o.minZoom&&a<=o.maxZoom){for(var s=t.getSource(),l="string"==typeof s?s:s.getId(),u=i.map.querySourceFeatures(l,{sourceLayer:t.getOptions().sourceLayer,filter:o.filter}),c=[],p=[],h=void 0,d=void 0,f=void 0,m=void 0,y=void 0,g=void 0,v=0,_=u.length;v<_;v++)g=null,u[v]instanceof e.Shape?"Point"===(m=u[v]).getType()&&(f=m.getCoordinates(),d=m.getProperties(),h=m.getId()):"Point"===(y=u[v]).geometry.type&&(f=y.geometry.coordinates,(d=y.properties)&&d.cluster?h="cluster_"+y.properties.cluster_id:y.id&&(h=y.id)),f&&((g=t._getMarker(h,f,d))._eventsAttached||(t._addEvents(g),g._eventsAttached=!0),g&&(g.id&&p.push(g.id),g.id&&-1!==t._markerIds.indexOf(g.id)||(c.push(g),i.markers.add(g))));for(v=r.length-1;0<=v;v--)r[v].id&&-1!==p.indexOf(r[v].id)||(i.markers.remove(r[v]),r.splice(v,1));t._markers=r.concat(c),t._markerIds=p}else 0<t._markers.length&&(i.markers.remove(t._markers),t._markers=[])},n._wrappedEvent=function(t){n.map.events.invoke(t.type,n,t)},s.prototype.setOptions.call(n,{color:"transparent",radius:0,strokeWidth:0}),n.setOptions(r||{}),n}var c,p=Object.freeze({__proto__:null,HtmlMarkerLayer:l}),h=(r(d,c=e.HtmlMarker),d.prototype.getTotalValue=function(){return this._total},d.prototype.getSliceValue=function(t){var e=this._options.values;return 0<=t&&t<e.length?e[t]:0},d.prototype.getSlicePercentage=function(t){return 0<this._total?Math.round(this.getSliceValue(t)/this._total*1e4)/100:0},d.prototype.getOptions=function(){return Object.assign({},c.prototype.getOptions.call(this),this._options)},d.prototype.setOptions=function(t){var e=this._options,i=JSON.stringify,r=!1;t.radius&&0<t.radius&&t.radius!=e.radius&&(e.radius=t.radius,r=!0),0<=t.innerRadius&&t.innerRadius!=e.innerRadius&&(e.innerRadius=t.innerRadius,r=!0),t.colors&&i(t.colors)!==i(e.colors)&&(e.colors=t.colors,r=!0),t.fillColor&&i(t.fillColor)!==i(e.fillColor)&&(e.fillColor=t.fillColor,r=!0),t.strokeColor&&t.strokeColor!==e.strokeColor&&(e.strokeColor=t.strokeColor,r=!0),0<=t.strokeWidth&&t.strokeWidth!=e.strokeWidth&&(e.strokeWidth=t.strokeWidth,r=!0),void 0!==t.tooltipCallback&&e.tooltipCallback!=t.tooltipCallback&&(e.tooltipCallback=t.tooltipCallback,r=!0),t.values&&i(t.values)!==i(e.values)&&(e.values=t.values,r=!0),t.text!==e.text&&(c.prototype.setOptions.call(this,{text:t.text}),r=!0),t.textClassName!==e.textClassName&&(e.textClassName=t.textClassName,r=!0),r&&this._render(),c.prototype.setOptions.call(this,t)},d.prototype._render=function(){var t=this,e=t._options,i=e.values,r=e.radius,n=0,o=0;if(i){t._total=i.reduce(function(t,e){return t+e},0);for(var a=d._moreColors,s=Math.random,l=Math.round,u=0;i.length>e.colors.length;)a.length<i.length&&a.push("hsl("+l(360*s())+","+(l(20*s())+70)+"%,"+(l(40*s())+30)+"%)"),e.colors.push(a[u]),u++;var p=r+e.strokeWidth,h=['<svg xmlns="http://www.w3.org/2000/svg" width="'+2*p+'px" height="'+2*p+'px">'],f="",m=void 0;if(0<e.innerRadius&&e.innerRadius<=e.radius&&(m="piechart-innercircle-"+l(1e7*s()),h.push('<defs><mask id="'+m+'"><rect width="100%" height="100%" fill="white"/><circle r="'+e.innerRadius+'" cx="'+p+'" cy="'+p+'" fill="black"/></mask></defs>\n                    <circle r="'+e.innerRadius+'" cx="'+p+'" cy="'+p+'" style="fill:'+e.fillColor+";stroke:"+e.strokeColor+";stroke-width:"+2*e.strokeWidth+'px;"/>')),0<t._total)for(var y=e.tooltipCallback,g=2*Math.PI/t._total,v=0;v<i.length;v++){o=g*i[v],y&&(f=y(t,v));var _=v<e.colors.length?e.colors[v]:a[v];h.push(t._createSlice(p,p,r,n,o,_,f,m)),n+=o}var x=c.prototype.getOptions.call(this).text;x&&h.push('<text x="'+p+'" y="'+(p+7)+'" style="font-size:16px;font-family:arial;fill:#000;font-weight:bold;" class="'+(e.textClassName||"")+'" text-anchor="middle">'+x+"</text>"),h.push("</svg>"),c.prototype.getOptions.call(this).htmlContent.innerHTML=h.join("")}},d.prototype._createSlice=function(t,e,i,r,n,o,a,s){var l=this._options,u=Math.PI,c="";if(s&&(c=' mask="url(#'+s+'"'),2*u*.99<n)return'<circle r="'+i+'" cx="'+t+'" cy="'+e+'" style="fill:'+o+";stroke:"+l.strokeColor+";stroke-width:"+l.strokeWidth+'px;"'+c+"><title>"+a+"</title></circle>";var p=Math.sin,h=Math.cos,d=t+i*p(r),f=e-i*h(r),m=t+i*p(r+n),y=e-i*h(r+n),g=(l.innerRadius,p(r),l.innerRadius,h(r),l.innerRadius,p(r+n),l.innerRadius,h(r+n),0);return u<n&&(g=1),'<path d="M'+t+" "+e+" L "+d+" "+f+" A "+i+","+i+" 0 "+g+" 1 "+m+" "+y+'z" style="fill:'+o+";stroke:"+l.strokeColor+";stroke-width:"+l.strokeWidth+'px;"'+c+"><title>"+a+"</title></path>"},d._moreColors=[],d);function d(t){var e=c.call(this,t)||this;return e._options={values:[],radius:40,colors:["#d7191c","#fdae61","#ffffbf","#abdda4","#2b83ba"],fillColor:"transparent",strokeWidth:0,strokeColor:"#666666",innerRadius:0},e._total=0,e.properties={},c.prototype.setOptions.call(e,{htmlContent:document.createElement("div"),pixelOffset:[0,0],anchor:"center"}),e.setOptions(t),e}var f=o.merge("atlas.layer",p);t.PieChartMarker=h,t.layer=f}(this.atlas=this.atlas||{},atlas),function(t){"use strict";function e(t,e,i,r){return new(i=i||Promise)(function(n,o){function a(t){try{l(r.next(t))}catch(t){o(t)}}function s(t){try{l(r.throw(t))}catch(t){o(t)}}function l(t){var e;t.done?n(t.value):((e=t.value)instanceof i?e:new i(function(t){t(e)})).then(a,s)}l((r=r.apply(t,e||[])).next())})}function i(t,e){var i,r,n,o,a={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(i)throw new TypeError("Generator is already executing.");for(;a;)try{if(i=1,r&&(n=2&o[0]?r.return:o[0]?r.throw||((n=r.return)&&n.call(r),0):r.next)&&!(n=n.call(r,o[1])).done)return n;switch(r=0,n&&(o=[2&o[0],n.value]),o[0]){case 0:case 1:n=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,r=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!(n=0<(n=a.trys).length&&n[n.length-1])&&(6===o[0]||2===o[0])){a=0;continue}if(3===o[0]&&(!n||o[1]>n[0]&&o[1]<n[3])){a.label=o[1];break}if(6===o[0]&&a.label<n[1]){a.label=n[1],n=o;break}if(n&&a.label<n[2]){a.label=n[2],a.ops.push(o);break}n[2]&&a.ops.pop(),a.trys.pop();continue}o=e.call(t,a)}catch(t){o=[6,t],r=0}finally{i=n=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,s])}}}var r=(n.getImage=function(t){return e(this,void 0,void 0,function(){var e;return i(this,function(i){switch(i.label){case 0:return[4,this.getDataUri(t)];case 1:return e=i.sent(),[2,this._getImage(e)]}})})},n.getDataUri=function(t,r){return e(this,void 0,void 0,function(){return i(this,function(e){switch(e.label){case 0:return[4,this._getMapCanvas(t)];case 1:return[2,e.sent().toDataURL(r)]}})})},n.getBlob=function(t){return e(this,void 0,void 0,function(){var e;return i(this,function(i){switch(i.label){case 0:return[4,this.getDataUri(t)];case 1:return e=i.sent(),[2,this._dataUriToBlob(e)]}})})},n._getImage=function(t){return new Promise(function(e,i){var r=new Image;r.onload=function(){e(r)},r.onerror=function(){i("Error creating image.")},-1<t.indexOf("<svg")&&(t="data:image/svg+xml;base64,"+window.btoa(t.substr(t.indexOf("<svg")))),r.src=t})},n._getMapCanvas=function(t){return e(this,void 0,void 0,function(){var e,r,n,o,a,s,l,u,c,p,h,d,f,m,y,g,v;return i(this,function(i){switch(i.label){case 0:if(e=t.getCanvas(),r=t.getMapContainer(),n=e.width,o=e.height,(a=document.createElement("canvas")).width=n,a.height=o,(s=a.getContext("2d")).drawImage(e,0,0),(l=r.getElementsByClassName("map-copyright"))&&0<l.length)try{u=window.getComputedStyle(l[0].firstElementChild),c=l[0].innerText,s.font=u.font,s.fillStyle=u.color,p=s.measureText(c).width,s.fillText(c,n-p-5,o-3)}catch(i){}if(!((h=r.getElementsByClassName("azure-map-logo"))&&0<h.length))return[3,4];if(d=window.getComputedStyle(h[0]),!((f=d?d.backgroundImage:null)&&0<=f.indexOf("data:image")))return[3,4];i.label=1;case 1:return i.trys.push([1,3,,4]),m=f.slice(5,f.length-2),m=decodeURIComponent(m.replace(/(\\')/g,"'")),y=this._logoHeight,[4,this._getImage(m)];case 2:return g=i.sent(),v=y*(g.width/g.height),s.drawImage(g,n-v-5,o-y-15,v,y),[2,a];case 3:return i.sent(),[3,4];case 4:return[2,a]}})})},n._dataUriToBlob=function(t){for(var e=atob(t.split(",")[1]),i=t.split(",")[0].split(":")[1].split(";")[0],r=new ArrayBuffer(e.length),n=new DataView(r),o=0;o<e.length;o++)n.setUint8(o,e.charCodeAt(o));return new Blob([r],{type:i})},n._logoHeight=25,n);function n(){}t.MapImageExporter=r}(this.atlas=this.atlas||{});var saveAs=saveAs||function(t){"use strict";if(!(void 0===t||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var e=t.document,i=function(){return t.URL||t.webkitURL||t},r=e.createElementNS("http://www.w3.org/1999/xhtml","a"),n="download"in r,o=/constructor/i.test(t.HTMLElement)||t.safari,a=/CriOS\/[\d]+/.test(navigator.userAgent),s=function(e){(t.setImmediate||t.setTimeout)(function(){throw e},0)},l=function(t){setTimeout(function(){"string"==typeof t?i().revokeObjectURL(t):t.remove()},4e4)},u=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},c=function(e,c,p){p||(e=u(e));var h,d=this,f="application/octet-stream"===e.type,m=function(){!function(t,e,i){for(var r=(e=[].concat(e)).length;r--;){var n=t["on"+e[r]];if("function"==typeof n)try{n.call(t,i||t)}catch(t){s(t)}}}(d,"writestart progress write writeend".split(" "))};if(d.readyState=d.INIT,n)return h=i().createObjectURL(e),void setTimeout(function(){var t,e;r.href=h,r.download=c,t=r,e=new MouseEvent("click"),t.dispatchEvent(e),m(),l(h),d.readyState=d.DONE});!function(){if((a||f&&o)&&t.FileReader){var r=new FileReader;return r.onloadend=function(){var e=a?r.result:r.result.replace(/^data:[^;]*;/,"data:attachment/file;");t.open(e,"_blank")||(t.location.href=e),e=void 0,d.readyState=d.DONE,m()},r.readAsDataURL(e),void(d.readyState=d.INIT)}h||(h=i().createObjectURL(e)),f?t.location.href=h:t.open(h,"_blank")||(t.location.href=h);d.readyState=d.DONE,m(),l(h)}()},p=c.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,i){return e=e||t.name||"download",i||(t=u(t)),navigator.msSaveOrOpenBlob(t,e)}:(p.abort=function(){},p.readyState=p.INIT=0,p.WRITING=1,p.DONE=2,p.error=p.onwritestart=p.onprogress=p.onwrite=p.onabort=p.onerror=p.onwriteend=null,function(t,e,i){return new c(t,e||t.name||"download",i)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||this.content);"undefined"!=typeof module&&module.exports?module.exports.saveAs=saveAs:"undefined"!=typeof define&&null!==define&&null!==define.amd&&define("FileSaver.js",function(){return saveAs}),function(t,e){"use strict";var i="default"in e?e.default:e,r=function(t,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i])})(t,e)};function n(t,e){function i(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(i.prototype=e.prototype,new i)}var o=function(){return(o=Object.assign||function(t){for(var e,i=1,r=arguments.length;i<r;i++)for(var n in e=arguments[i])Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t}).apply(this,arguments)},a=(s.merge=function(t,e){for(var i=window||global,r=0,n=t.split(".");r<n.length;r++){var a=n[r];if(!i[a])return e;i=i[a]}return o(o({},i),e)},s);function s(){}var l=function(t,e){return t===e||t!=t&&e!=e},u=function(t,e){for(var i=t.length;i--;)if(l(t[i][0],e))return i;return-1},c=Array.prototype.splice,p=function(t){var e=this.__data__;return!((t=u(e,t))<0||(t==e.length-1?e.pop():c.call(e,t,1),--this.size,0))},h=function(t){var e=this.__data__;return(t=u(e,t))<0?void 0:e[t][1]},d=function(t){return-1<u(this.__data__,t)},f=function(t,e){var i=this.__data__,r=u(i,t);return r<0?(++this.size,i.push([t,e])):i[r][1]=e,this};function m(t){var e=-1,i=null==t?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}m.prototype.clear=function(){this.__data__=[],this.size=0},m.prototype.delete=p,m.prototype.get=h,m.prototype.has=d,m.prototype.set=f;var y=m,g=function(){this.__data__=new y,this.size=0},v=function(t){var e=this.__data__;t=e.delete(t);return this.size=e.size,t},_=function(t){return this.__data__.get(t)},x=function(t){return this.__data__.has(t)};function b(t,e){return t(e={exports:{}},e.exports),e.exports}var w="object"==typeof(N="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{})&&N&&N.Object===Object&&N,S="object"==typeof self&&self&&self.Object===Object&&self,T=w||S||Function("return this")(),C=(p=T.Symbol,(h=Object.prototype).hasOwnProperty),E=h.toString,I=p?p.toStringTag:void 0,k=Object.prototype.toString,A=p?p.toStringTag:void 0,P=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":(A&&A in Object(t)?function(t){var e=C.call(t,I),i=t[I];try{var r=!(t[I]=void 0)}catch(t){}var n=E.call(t);return r&&(e?t[I]=i:delete t[I]),n}:function(t){return k.call(t)})(t)},M=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)},L=function(t){return!!M(t)&&("[object Function]"==(t=P(t))||"[object GeneratorFunction]"==t||"[object AsyncFunction]"==t||"[object Proxy]"==t)},O=(d=T["__core-js_shared__"],(f=/[^.]+$/.exec(d&&d.keys&&d.keys.IE_PROTO||""))?"Symbol(src)_1."+f:""),R=Function.prototype.toString,z=function(t){if(null!=t){try{return R.call(t)}catch(t){}try{return t+""}catch(t){}}return""},D=/^\[object .+?Constructor\]$/,N=Function.prototype,B=(S=Object.prototype,h=N.toString,d=S.hasOwnProperty,RegExp("^"+h.call(d).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$")),F=function(t){return!(!M(t)||function(t){return!!O&&O in t}(t))&&(L(t)?B:D).test(z(t))},U=function(t,e){return e=function(t,e){return null==t?void 0:t[e]}(t,e),F(e)?e:void 0},j=U(T,"Map"),V=U(Object,"create"),q=(f=function(t){return t=this.has(t)&&delete this.__data__[t],this.size-=t?1:0,t},Object.prototype.hasOwnProperty),H=(N=function(t){var e=this.__data__;if(V){var i=e[t];return"__lodash_hash_undefined__"===i?void 0:i}return q.call(e,t)?e[t]:void 0},Object.prototype.hasOwnProperty);function G(t){var e=-1,i=null==t?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}S=function(t){var e=this.__data__;return V?void 0!==e[t]:H.call(e,t)},h=function(t,e){var i=this.__data__;return this.size+=this.has(t)?0:1,i[t]=V&&void 0===e?"__lodash_hash_undefined__":e,this},G.prototype.clear=function(){this.__data__=V?V(null):{},this.size=0},G.prototype.delete=f,G.prototype.get=N,G.prototype.has=S,G.prototype.set=h;var Z=G;d=function(){this.size=0,this.__data__={hash:new Z,map:new(j||y),string:new Z}};var W=function(t,e){return t=t.__data__,function(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}(e)?t["string"==typeof e?"string":"hash"]:t.map};function K(t){var e=-1,i=null==t?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}f=function(t){return t=W(this,t).delete(t),this.size-=t?1:0,t},N=function(t){return W(this,t).get(t)},S=function(t){return W(this,t).has(t)},h=function(t,e){var i=W(this,t),r=i.size;return i.set(t,e),this.size+=i.size==r?0:1,this},K.prototype.clear=d,K.prototype.delete=f,K.prototype.get=N,K.prototype.has=S,K.prototype.set=h;var X=K;function Y(t){t=this.__data__=new y(t),this.size=t.size}N=function(t,e){var i=this.__data__;if(i instanceof y){var r=i.__data__;if(!j||r.length<199)return r.push([t,e]),this.size=++i.size,this;i=this.__data__=new X(r)}return i.set(t,e),this.size=i.size,this},Y.prototype.clear=g,Y.prototype.delete=v,Y.prototype.get=_,Y.prototype.has=x,Y.prototype.set=N;var J=Y,Q=function(){try{var t=U(Object,"defineProperty");return t({},"",{}),t}catch(t){}}(),$=function(t,e,i){"__proto__"==e&&Q?Q(t,e,{configurable:!0,enumerable:!0,value:i,writable:!0}):t[e]=i},tt=Object.prototype.hasOwnProperty,et=function(t,e,i){var r=t[e];tt.call(t,e)&&l(r,i)&&(void 0!==i||e in t)||$(t,e,i)},it=function(t,e,i,r){var n=!i;i=i||{};for(var o=-1,a=e.length;++o<a;){var s=e[o],l=r?r(i[s],t[s],s,i,t):void 0;void 0===l&&(l=t[s]),(n?$:et)(i,s,l)}return i},rt=function(t){return null!=t&&"object"==typeof t},nt=(S=function(t){return rt(t)&&"[object Arguments]"==P(t)},(h=Object.prototype).hasOwnProperty),ot=h.propertyIsEnumerable,at=S(function(){return arguments}())?S:function(t){return rt(t)&&nt.call(t,"callee")&&!ot.call(t,"callee")},st=Array.isArray;function lt(){return!1}var ut=b(function(t,e){var i=(i=(e=(i=e&&!e.nodeType&&e)&&t&&!t.nodeType&&t)&&e.exports===i?T.Buffer:void 0)?i.isBuffer:void 0;t.exports=i||lt}),ct=/^(?:0|[1-9]\d*)$/,pt=function(t,e){var i=typeof t;return!!(e=null==e?9007199254740991:e)&&("number"==i||"symbol"!=i&&ct.test(t))&&-1<t&&t%1==0&&t<e},ht=function(t){return"number"==typeof t&&-1<t&&t%1==0&&t<=9007199254740991},dt={};dt["[object Float32Array]"]=dt["[object Float64Array]"]=dt["[object Int8Array]"]=dt["[object Int16Array]"]=dt["[object Int32Array]"]=dt["[object Uint8Array]"]=dt["[object Uint8ClampedArray]"]=dt["[object Uint16Array]"]=dt["[object Uint32Array]"]=!0,dt["[object Arguments]"]=dt["[object Array]"]=dt["[object ArrayBuffer]"]=dt["[object Boolean]"]=dt["[object DataView]"]=dt["[object Date]"]=dt["[object Error]"]=dt["[object Function]"]=dt["[object Map]"]=dt["[object Number]"]=dt["[object Object]"]=dt["[object RegExp]"]=dt["[object Set]"]=dt["[object String]"]=dt["[object WeakMap]"]=!1,g=function(t){return rt(t)&&ht(t.length)&&!!dt[P(t)]};v=function(t){return function(e){return t(e)}};var ft=(x=(_=b(function(t,e){var i=(e=e&&!e.nodeType&&e)&&t&&!t.nodeType&&t,r=i&&i.exports===e&&w.process;e=function(){try{var t=i&&i.require&&i.require("util").types;return t||r&&r.binding&&r.binding("util")}catch(t){}}();t.exports=e}))&&_.isTypedArray)?v(x):g,mt=Object.prototype.hasOwnProperty,yt=function(t,e){var i,r=st(t),n=!r&&at(t),o=!r&&!n&&ut(t),a=!r&&!n&&!o&&ft(t),s=r||n||o||a,l=s?function(t,e){for(var i=-1,r=Array(t);++i<t;)r[i]=e(i);return r}(t.length,String):[],u=l.length;for(i in t)!e&&!mt.call(t,i)||s&&("length"==i||o&&("offset"==i||"parent"==i)||a&&("buffer"==i||"byteLength"==i||"byteOffset"==i)||pt(i,u))||l.push(i);return l},gt=Object.prototype,vt=function(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||gt)},_t=(N=function(t,e){return function(i){return t(e(i))}})(Object.keys,Object),xt=Object.prototype.hasOwnProperty,bt=function(t){return null!=t&&ht(t.length)&&!L(t)},wt=function(t){return(bt(t)?yt:function(t){if(!vt(t))return _t(t);var e,i=[];for(e in Object(t))xt.call(t,e)&&"constructor"!=e&&i.push(e);return i})(t)},St=Object.prototype.hasOwnProperty,Tt=function(t){if(!M(t))return function(t){var e=[];if(null!=t)for(var i in Object(t))e.push(i);return e}(t);var e,i=vt(t),r=[];for(e in t)("constructor"!=e||!i&&St.call(t,e))&&r.push(e);return r},Ct=function(t){return bt(t)?yt(t,!0):Tt(t)},Et=b(function(t,e){var i,r=(i=(e=(i=e&&!e.nodeType&&e)&&t&&!t.nodeType&&t)&&e.exports===i?T.Buffer:void 0)?i.allocUnsafe:void 0;t.exports=function(t,e){return e?t.slice():(e=t.length,e=r?r(e):new t.constructor(e),t.copy(e),e)}}),It=(h=function(){return[]},Object.prototype.propertyIsEnumerable),kt=Object.getOwnPropertySymbols,At=kt?function(t){return null==t?[]:(t=Object(t),function(t,e){for(var i=-1,r=null==t?0:t.length,n=0,o=[];++i<r;){var a=t[i];e(a,i,t)&&(o[n++]=a)}return o}(kt(t),function(e){return It.call(t,e)}))}:h,Pt=function(t,e){for(var i=-1,r=e.length,n=t.length;++i<r;)t[n+i]=e[i];return t},Mt=N(Object.getPrototypeOf,Object),Lt=Object.getOwnPropertySymbols?function(t){for(var e=[];t;)Pt(e,At(t)),t=Mt(t);return e}:h,Ot=function(t,e,i){return e=e(t),st(t)?e:Pt(e,i(t))},Rt=function(t){return Ot(t,wt,At)},zt=(S=U(T,"DataView"),x=U(T,"Promise"),g=U(T,"Set"),N=U(T,"WeakMap"),"[object Map]"),Dt="[object Promise]",Nt="[object Set]",Bt="[object WeakMap]",Ft="[object DataView]",Ut=z(S),jt=z(j),Vt=z(x),qt=z(g),Ht=z(N),Gt=(h=P,h=S&&h(new S(new ArrayBuffer(1)))!=Ft||j&&h(new j)!=zt||x&&h(x.resolve())!=Dt||g&&h(new g)!=Nt||N&&h(new N)!=Bt?function(t){var e=P(t);if(t=(t="[object Object]"==e?t.constructor:void 0)?z(t):"")switch(t){case Ut:return Ft;case jt:return zt;case Vt:return Dt;case qt:return Nt;case Ht:return Bt}return e}:h),Zt=Object.prototype.hasOwnProperty,Wt=T.Uint8Array,Kt=function(t){var e=new t.constructor(t.byteLength);return new Wt(e).set(new Wt(t)),e},Xt=/\w*$/,Yt=(N=p?p.prototype:void 0)?N.valueOf:void 0,Jt=function(t,e,i){var r=t.constructor;switch(e){case"[object ArrayBuffer]":return Kt(t);case"[object Boolean]":case"[object Date]":return new r(+t);case"[object DataView]":return function(t,e){return e=e?Kt(t.buffer):t.buffer,new t.constructor(e,t.byteOffset,t.byteLength)}(t,i);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return function(t,e){return e=e?Kt(t.buffer):t.buffer,new t.constructor(e,t.byteOffset,t.length)}(t,i);case"[object Map]":return new r;case"[object Number]":case"[object String]":return new r(t);case"[object RegExp]":return function(t){var e=new t.constructor(t.source,Xt.exec(t));return e.lastIndex=t.lastIndex,e}(t);case"[object Set]":return new r;case"[object Symbol]":return function(t){return Yt?Object(Yt.call(t)):{}}(t)}},Qt=Object.create;function $t(){}var te=function(t){return"function"!=typeof t.constructor||vt(t)?{}:function(t){return M(t)?Qt?Qt(t):($t.prototype=t,t=new $t,$t.prototype=void 0,t):{}}(Mt(t))},ee=(h=function(t){return rt(t)&&"[object Map]"==Gt(t)},(N=_&&_.isMap)?v(N):h),ie=(h=function(t){return rt(t)&&"[object Set]"==Gt(t)},(_=_&&_.isSet)?v(_):h),re="[object Arguments]",ne="[object Function]",oe="[object Object]",ae={};ae[re]=ae["[object Array]"]=ae["[object ArrayBuffer]"]=ae["[object DataView]"]=ae["[object Boolean]"]=ae["[object Date]"]=ae["[object Float32Array]"]=ae["[object Float64Array]"]=ae["[object Int8Array]"]=ae["[object Int16Array]"]=ae["[object Int32Array]"]=ae["[object Map]"]=ae["[object Number]"]=ae[oe]=ae["[object RegExp]"]=ae["[object Set]"]=ae["[object String]"]=ae["[object Symbol]"]=ae["[object Uint8Array]"]=ae["[object Uint8ClampedArray]"]=ae["[object Uint16Array]"]=ae["[object Uint32Array]"]=!0,ae["[object Error]"]=ae[ne]=ae["[object WeakMap]"]=!1;var se=function t(e,i,r,n,o,a){var s,l=1&i,u=2&i,c=4&i;if(void 0!==(s=r?o?r(e,n,o,a):r(e):s))return s;if(!M(e))return e;var p=st(e);if(p){if(s=function(t){var e=t.length,i=new t.constructor(e);return e&&"string"==typeof t[0]&&Zt.call(t,"index")&&(i.index=t.index,i.input=t.input),i}(e),!l)return function(t,e){var i=-1,r=t.length;for(e=e||Array(r);++i<r;)e[i]=t[i];return e}(e,s)}else{var h=Gt(e);n=h==ne||"[object GeneratorFunction]"==h;if(ut(e))return Et(e,l);if(h==oe||h==re||n&&!o){if(s=u||n?{}:te(e),!l)return u?function(t,e){return it(t,Lt(t),e)}(e,function(t,e){return t&&it(e,Ct(e),t)}(s,e)):function(t,e){return it(t,At(t),e)}(e,function(t,e){return t&&it(e,wt(e),t)}(s,e))}else{if(!ae[h])return o?e:{};s=Jt(e,h,l)}}if(l=(a=a||new J).get(e))return l;a.set(e,s),ie(e)?e.forEach(function(n){s.add(t(n,i,r,n,e,a))}):ee(e)&&e.forEach(function(n,o){s.set(o,t(n,i,r,o,e,a))});var d=p?void 0:(c?u?function(t){return Ot(t,Ct,Lt)}:Rt:u?Ct:wt)(e);return function(t,e){for(var i=-1,r=null==t?0:t.length;++i<r&&!1!==e(t[i],i,t););}(d||e,function(n,o){d&&(n=e[o=n]),et(s,o,t(n,i,r,o,e,a))}),s},le=function(t){return se(t,5)};function ue(t){var e=-1,i=null==t?0:t.length;for(this.__data__=new X;++e<i;)this.add(t[e])}v=function(t){return this.__data__.has(t)},ue.prototype.add=ue.prototype.push=function(t){return this.__data__.set(t,"__lodash_hash_undefined__"),this},ue.prototype.has=v;var ce=ue,pe=function(t,e){for(var i=-1,r=null==t?0:t.length;++i<r;)if(e(t[i],i,t))return!0;return!1},he=function(t,e){return t.has(e)},de=function(t,e,i,r,n,o){var a=1&i,s=t.length;if(s!=(u=e.length)&&!(a&&s<u))return!1;var l=o.get(t),u=o.get(e);if(l&&u)return l==e&&u==t;var c=-1,p=!0,h=2&i?new ce:void 0;for(o.set(t,e),o.set(e,t);++c<s;){var d,f=t[c],m=e[c];if(void 0!==(d=r?a?r(m,f,c,e,t,o):r(f,m,c,t,e,o):d)){if(d)continue;p=!1;break}if(h){if(!pe(e,function(t,e){if(!he(h,e)&&(f===t||n(f,t,i,r,o)))return h.push(e)})){p=!1;break}}else if(f!==m&&!n(f,m,i,r,o)){p=!1;break}}return o.delete(t),o.delete(e),p};function fe(t){var e=-1,i=Array(t.size);return t.forEach(function(t,r){i[++e]=[r,t]}),i}function me(t){var e=-1,i=Array(t.size);return t.forEach(function(t){i[++e]=t}),i}var ye,ge=(_=p?p.prototype:void 0)?_.valueOf:void 0,ve=function(t,e,i,r,n,o,a){switch(i){case"[object DataView]":if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case"[object ArrayBuffer]":return!(t.byteLength!=e.byteLength||!o(new Wt(t),new Wt(e)));case"[object Boolean]":case"[object Date]":case"[object Number]":return l(+t,+e);case"[object Error]":return t.name==e.name&&t.message==e.message;case"[object RegExp]":case"[object String]":return t==e+"";case"[object Map]":var s=fe;case"[object Set]":if(s=s||me,t.size!=e.size&&!(1&r))return!1;var u=a.get(t);return u?u==e:(r|=2,a.set(t,e),s=de(s(t),s(e),r,n,o,a),a.delete(t),s);case"[object Symbol]":if(ge)return ge.call(t)==ge.call(e)}return!1},_e=Object.prototype.hasOwnProperty,xe="[object Arguments]",be="[object Array]",we="[object Object]",Se=Object.prototype.hasOwnProperty,Te=function(t,e,i,r,n,o){var a=st(t),s=st(e),l=a?be:Gt(t),u=s?be:Gt(e),c=(l=l==xe?we:l)==we;s=(u=u==xe?we:u)==we;if((u=l==u)&&ut(t)){if(!ut(e))return!1;c=!(a=!0)}return u&&!c?(o=o||new J,a||ft(t)?de(t,e,i,r,n,o):ve(t,e,l,i,r,n,o)):1&i||(c=c&&Se.call(t,"__wrapped__"),s=s&&Se.call(e,"__wrapped__"),!c&&!s)?!!u&&function(t,e,i,r,n,o){var a=1&i,s=Rt(t),l=s.length;if(l!=Rt(e).length&&!a)return!1;for(var u=l;u--;){var c=s[u];if(!(a?c in e:_e.call(e,c)))return!1}var p=o.get(t),h=o.get(e);if(p&&h)return p==e&&h==t;var d=!0;o.set(t,e),o.set(e,t);for(var f=a;++u<l;){var m,y=t[c=s[u]],g=e[c];if(!(void 0===(m=r?a?r(g,y,c,e,t,o):r(y,g,c,t,e,o):m)?y===g||n(y,g,i,r,o):m)){d=!1;break}f=f||"constructor"==c}return!d||f||(p=t.constructor)!=(h=e.constructor)&&"constructor"in t&&"constructor"in e&&!("function"==typeof p&&p instanceof p&&"function"==typeof h&&h instanceof h)&&(d=!1),o.delete(t),o.delete(e),d}(t,e,i,r,n,o=o||new J):n(c?t.value():t,s?e.value():e,i,r,o=o||new J)},Ce=function(t,e){return function t(e,i,r,n,o){return e===i||(null==e||null==i||!rt(e)&&!rt(i)?e!=e&&i!=i:Te(e,i,r,n,t,o))}(t,e)};function Ee(){}(h=ye=ye||{}).drawPoint="draw-point",h.drawLine="draw-line",h.drawPolygon="draw-polygon",h.drawCircle="draw-circle",h.drawRectangle="draw-rectangle",h.editGeometry="edit-geometry",h.eraseGeometry="erase-geometry",h.idle="idle",Ee.prototype.merge=function(){for(var t,e=[],i=0;i<arguments.length;i++)e[i]=arguments[i];for(var r=0,n=e;r<n.length;r++){var a=n[r];if(a)for(var s in a)a.hasOwnProperty(s)&&this.hasOwnProperty(s)&&(void 0!==a[s]&&null!=a[s]?this[s]instanceof Ee?this[s].merge(a[s]):this[s]="dragHandleStyle"===s||"secondaryDragHandleStyle"===s?o(o({},this[s]),a[s]):a[s]:(t=t||new(Object.getPrototypeOf(this).constructor),this[s]=t[s]))}return this};var Ie,ke=(n(Ae,Ie=v=Ee),Ae);function Ae(){var t=null!==Ie&&Ie.apply(this,arguments)||this;return t.containerId=void 0,t.position=e.ControlPosition.NonFixed,t.buttons=[ye.drawPoint,ye.drawLine,ye.drawPolygon,ye.drawCircle,ye.drawRectangle,ye.editGeometry,ye.eraseGeometry],t.numColumns=1/0,t.style="light",t.visible=!0,t}var Pe=(Me.prototype.getOptions=function(){return le(this.options)},Me.prototype.setOptions=function(t){var i=(new ke).merge(this.options,le(t));if(this.toolbar){if(i.visible!==this.options.visible&&(i.visible?this.toolbar.classList.remove(Me.Css.hide):this.toolbar.classList.add(Me.Css.hide)),i.containerId!==this.options.containerId)if(i.containerId){if(!(t=document.getElementById(i.containerId)))throw new Error("There is no container with ID '"+this.options.containerId+" to add the toolbar to.");this.map.controls.remove(this),t.appendChild(this.toolbar)}else this.toolbar.remove(),i.position!==e.ControlPosition.NonFixed&&this._constructControl(),this.map.controls.add(this,{position:i.position});else i.containerId||i.position===this.options.position||(this.map.controls.remove(this),i.position!==e.ControlPosition.NonFixed&&this._constructControl(),this.map.controls.add(this,{position:i.position}));if(i.style!==this.options.style&&(this._setStyle(i),"auto"===i.style?this.map.events.add("styledata",this._updateStyle):this.map.events.remove("styledata",this._updateStyle)),Ce(i.buttons,this.options.buttons)){if(i.numColumns!==this.options.numColumns)for(var r=this.toolbar.children,n=0;n<r.length;n++){var o=r.item(n);(n+1)%i.numColumns!=0?o.style.cssFloat="left":o.style.cssFloat=null}}else{for(;this.toolbar.firstChild;)this.toolbar.removeChild(this.toolbar.firstChild);this._addButtons(this.drawMgr,i)}}this.options=i},Me.prototype.onAdd=function(){if(!this.toolbar)throw new Error("The toolbar cannot be added directly to the map, it must be passed to a DrawingManager");return this.control||this.toolbar},Me.prototype.onRemove=function(){(this.control||this.toolbar).remove(),delete this.control},Me.prototype._open=function(t,i){if(this.toolbar)throw new Error("The toolbar is already opened, it cannot be opened again.");if(this.map=i,this.drawMgr=t,this.options.containerId){var r=document.getElementById(this.options.containerId);if(!r)throw new Error("There is no container with ID '"+this.options.containerId+" to add the toolbar to.");this._constructToolbar(t,i),r.appendChild(this.toolbar)}else this._constructToolbar(t,i),this.options.position!==e.ControlPosition.NonFixed&&this._constructControl(),i.controls.add(this,{position:this.options.position})},Me.prototype._close=function(){if(!this.toolbar)throw new Error("Cannot close the toolbar, it has not been opened yet.");this.options.containerId?this.toolbar.remove():this.map.controls.remove(this),this.map.events.remove("drawingmodechanged",this.drawMgr,this._updateMode),this.map.events.remove("styledata",this._updateStyle),delete this.toolbar,delete this.drawMgr,delete this.map},Me.prototype._isOpen=function(){return!!this.toolbar},Me.prototype._dispose=function(){this._close()},Me.prototype._constructToolbar=function(t,e){this.toolbar=document.createElement("div"),this.toolbar.classList.add(Me.Css.toolbar),this._setStyle(this.options),"auto"===this.options.style&&e.events.add("styledata",this._updateStyle),this.options.visible||this.toolbar.classList.add(Me.Css.hide),e.events.add("drawingmodechanged",t,this._updateMode),this._addButtons(t,this.options)},Me.prototype._addButtons=function(t,e){for(var i=t.getOptions().mode,r=0;r<e.buttons.length;r++){var n=e.buttons[r],o=document.createElement("button");o.type="button",o.dataset.mode=n,o.setAttribute("aria-label",n),o.setAttribute("title",n),o.classList.add(Me.Css.button,n),o.addEventListener("click",this._getBtnCallback(o,t)),(r+1)%e.numColumns!=0&&(o.style.cssFloat="left"),i===n&&o.classList.add(Me.Css.active),this.toolbar.appendChild(o)}},Me.prototype._getBtnCallback=function(t,e){switch(t.dataset.mode){case ye.drawPoint:case ye.drawLine:case ye.drawPolygon:case ye.drawCircle:case ye.drawRectangle:case ye.editGeometry:case ye.eraseGeometry:return function(){var i=e.getOptions().mode;t.dataset.mode===i?e.setOptions({mode:ye.idle}):e.setOptions({mode:t.dataset.mode})};default:throw new Error("Invalid button type specified '"+t.dataset.mode+"'.")}},Me.prototype._constructControl=function(){this.control=document.createElement("div"),this.control.classList.add(Me.Css.control),this.control.appendChild(this.toolbar)},Me.prototype._setStyle=function(t){for(var e=0,i=Object.keys(Me.Css.styles);e<i.length;e++){var r=i[e];this.toolbar.classList.remove(Me.Css.styles[r])}if("auto"===t.style)this.toolbar.classList.add(Me.Css.styles.light);else{if(!Me.Css.styles.hasOwnProperty(t.style))throw new Error("An invalid style '"+t.style+"' was specified for the toolbar.");this.toolbar.classList.add(Me.Css.styles[t.style])}},Me.Css={active:"active",button:"azure-maps-drawtoolbar-button",container:"azure-maps-drawtoolbar-container",control:"azure-maps-control-container",hide:"hidden-accessible-element",styles:{dark:"dark",light:"light"},toolbar:"azure-maps-drawtoolbar"},Me);function Me(t){var e=this;this._updateStyle=function(){e._setStyle(e.options)},this._updateMode=function(t){for(var i=0;i<e.toolbar.children.length;i++){var r=e.toolbar.children.item(i);r.dataset.mode===t?r.classList.add(Me.Css.active):r.classList.remove(Me.Css.active)}},this.options=(new ke).merge(le(t))}p=Object.freeze({__proto__:null,DrawingToolbar:Pe});var Le,Oe=function(t,e){return se(t,5,e="function"==typeof e?e:void 0)},Re=function(){},ze=(n(De,Le=v),De);function De(){var t=null!==Le&&Le.apply(this,arguments)||this;return t.container=void 0,t.backgroundColor="rgba(0, 0, 0, 0.3)",t.style="light",t}var Ne,Be=(Fe.prototype.close=function(){},Fe.prototype.edit=function(t){if(this.shape!==t){this._clearProps(),this.shape=t,this.tempProps=t.getProperties();for(var i=0,r=Object.keys(this.tempProps);i<r.length;i++){var n=r[i];n.startsWith("_azureMaps")||this._addProp(n,this.tempProps[n])}}if(!this.container.parentElement)if("string"==typeof this.options.container){if(!(t=document.getElementById(this.options.container)))throw new Error("There is no element with ID '"+this.options.container+" to add the editor to.");t.appendChild(this.container)}else this.options.container,e.Map},Fe.prototype.getOptions=function(){return Object.assign({},this.options)},Fe.prototype.save=function(){this.close()},Fe.prototype.setOptions=function(t){t=(new ze).merge(this.options,Object.assign({},t)),this.options=t},Fe.prototype._constructDialog=function(t){var e=this;this.container=document.createElement("div"),this.container.classList.add(Fe.Css.container),this.container.style.backgroundColor=t.backgroundColor,this.dialog=document.createElement("div"),this.dialog.classList.add(Fe.Css.dialog),this._updateStyle(t),this.container.appendChild(this.dialog);var i=document.createElement("label");i.classList.add(Fe.Css.labels.base,Fe.Css.labels.property),i.innerHTML="Property",this.dialog.appendChild(i),(t=document.createElement("label")).classList.add(Fe.Css.labels.base,Fe.Css.labels.type),t.innerHTML="Type",this.dialog.appendChild(t),(i=document.createElement("label")).classList.add(Fe.Css.labels.base,Fe.Css.labels.value),i.innerHTML="Value",this.dialog.appendChild(i),(t=document.createElement("hr")).classList.add(Fe.Css.labels.base,Fe.Css.labels.bar),this.dialog.appendChild(t),this.propsList=document.createElement("ul"),this.propsList.classList.add(Fe.Css.table.base,Fe.Css.table.list),this.dialog.appendChild(this.propsList),(i=document.createElement("button")).classList.add(Fe.Css.buttons.base,Fe.Css.buttons.add),i.addEventListener("click",function(){return e._addProp()}),this.dialog.appendChild(i),t=document.createElement("div"),i.appendChild(t),this.addPropLbl=document.createElement("label"),i.appendChild(this.addPropLbl),this.cancelBtn=document.createElement("button"),this.cancelBtn.classList.add(Fe.Css.buttons.base,Fe.Css.buttons.cancel),this.cancelBtn.addEventListener("click",function(){return e.close()}),this.dialog.appendChild(this.cancelBtn),this.saveBtn=document.createElement("button"),this.saveBtn.classList.add(Fe.Css.buttons.base,Fe.Css.buttons.save),this.saveBtn.addEventListener("click",function(){return e.save()}),this.dialog.appendChild(this.saveBtn),this._setLocalizedText()},Fe.prototype._addProp=function(t,e){var i=this,r=document.createElement("div");r.classList.add(Fe.Css.table.base,Fe.Css.table.row),this.propsList.appendChild(r);var n=document.createElement("input");n.classList.add(Fe.Css.table.base,Fe.Css.table.name),n.type="text",n.value=t||"",r.appendChild(n);var o=document.createElement("select");o.classList.add(Fe.Css.table.base,Fe.Css.table.type),r.appendChild(o);for(var a=0,s=Fe.Types;a<s.length;a++){var l=s[a],u=document.createElement("option");u.value=l,u.innerText=l,o.add(u),(e&&typeof e===l||!e&&"string"===l)&&(u.selected=!0)}var c=document.createElement("div");c.classList.add(Fe.Css.table.base,Fe.Css.table.value),c.addEventListener("keydown",function(t){return i._constrainSize(o,c,t)}),c.innerText=e?JSON.stringify(e,null,2):"",c.contentEditable="true",r.appendChild(c),(n=document.createElement("button")).classList.add(Fe.Css.table.base,Fe.Css.table.delete),n.addEventListener("click",function(){return i.propsList.removeChild(r)}),r.appendChild(n)},Fe.prototype._clearProps=function(){for(delete this.tempProps;this.propsList.firstChild;)this.propsList.removeChild(this.propsList.firstChild)},Fe.prototype._constrainSize=function(t,e,i){"object"!==t.value&&13===i.keyCode&&i.preventDefault()},Fe.prototype._updateStyle=function(t){for(var e=0,i=Object.keys(Fe.Css.styles);e<i.length;e++){var r=i[e];this.dialog.classList.remove(Fe.Css.styles[r])}if("auto"===t.style)this.dialog.classList.add(Fe.Css.styles.light);else{if(!Fe.Css.styles.hasOwnProperty(t.style))throw new Error("An invalid style '"+t.style+"' was specified for the editor.");this.dialog.classList.add(Fe.Css.styles[t.style])}},Fe.prototype._setLocalizedText=function(){this.saveBtn.innerText="Save",this.cancelBtn.innerText="Cancel",this.addPropLbl.innerText="Add property"},Fe._countLines=function(t){return(t=t.match(this.LineCountRegEx))?t.length+1:1},Fe.Css={buttons:{add:"add",base:"azure-maps-propedit-button",cancel:"cancel",save:"save"},container:"azure-maps-propedit-container",dialog:"azure-maps-propedit-dialog",hide:"hidden-accessible-element",labels:{bar:"bar",base:"azure-maps-propedit-label",property:"prop",type:"type",value:"value"},styles:{dark:"dark",light:"light"},table:{base:"azure-maps-propedit-table",delete:"delete",list:"list",name:"name",row:"row",type:"type",value:"value"}},Fe.Types=["boolean","number","object","string"],Fe.LineCountRegEx=new RegExp("\r*\n","g"),Fe.Render=document.createElement("canvas").getContext("2d"),Fe);function Fe(t){this.options=(new ze).merge(Object.assign({},t)),this._constructDialog(this.options)}(_=Ne=Ne||{}).hybrid="hybrid",_.freehand="freehand",_.click="click";var Ue,je=(n(Ve,Ue=v),Ve._cloneCustomizer=function(t){if(t instanceof Pe||t instanceof e.source.DataSource||t instanceof Be)return t},Ve);function Ve(){var t=null!==Ue&&Ue.apply(this,arguments)||this;return t.dragHandleStyle={anchor:"center",draggable:!0,htmlContent:"<svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'> <circle class='dragHandleCircle' cx = '6' cy = '6' r = '5.5' fill='#FFFFFF' stroke='#4E4C4C'/> </svg>"},t.freehandInterval=3,t.interactionType=Ne.hybrid,t.mode=ye.idle,t.secondaryDragHandleStyle={anchor:"center",draggable:!0,htmlContent:"<svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'> <circle class='dragHandleCircle' cx = '6' cy = '6' r = '5.5' fill='#A6A6A6' stroke='#4E4C4C'/> </svg>"},t.shapeDraggingEnabled=!0,t.shapeRotationEnabled=!0,t.source=void 0,t.toolbar=void 0,t}var qe,He=(Ge.prototype.dispose=function(){this.previewLayers&&(this.map.layers.remove(this.previewLayers.lineLayer),this.map.layers.remove(this.previewLayers.polygonLayer),this.map.layers.remove(this.previewLayers.polygonOutlineLayer),this.map.layers.remove(this.previewLayers.pointLayer)),this.map=null,this.options=null,this.previewLayers=null},Ge.prototype.setOptions=function(t){this.options.mode!==t.mode&&this.finish(),this.options=t},Ge.prototype.pixelDifference=function(t,e){var i=t[0]-e[0];e=t[1]-e[1];return Math.sqrt(i*i+e*e)},Ge.prototype.updateActiveShape=function(t){var e=this.activeShapeCoordinates[this.activeShapeCoordinates.length-1];0<this.activeShapeCoordinates.length?e[0]===t.position[0]&&e[1]===t.position[1]||(this.activeShapeCoordinates.push(t.position),this.activeShape.setCoordinates(this.activeShapeCoordinates),this.drawMgr._invokeEvent("drawingchanged",this.activeShape)):(this.activeShapeCoordinates.push(t.position),this.activeShape.setCoordinates(this.activeShapeCoordinates),this.drawMgr._invokeEvent("drawingstarted",null))},Ge);function Ge(t,i){var r=this;this.options={},this.strokeColor="#2266E3",this.parentIdProp="parent_id",this.outlineProp="outline",this.addCoord=function(t,i){r.options.mode===ye.drawPoint&&(r.finalShape=new e.Shape(new e.data.Point([])),r.activeShape=new e.Shape(new e.data.Point(t.position)),r.activeShape.addProperty(r.parentIdProp,r.finalShape.getId()),r.drawMgr._invokeEvent("drawingstarted",null),r.finish()),r.options.mode!==ye.drawLine&&r.options.mode!==ye.drawPolygon||("click"!==t.type&&!i||r.options.interactionType!==Ne.click&&r.options.interactionType!==Ne.hybrid?!r.isMouseDown||"mousemove"!==t.type&&"touchmove"!==t.type||r.options.interactionType!==Ne.freehand&&r.options.interactionType!==Ne.hybrid||(r.previewShape&&(r.previewSource.remove(r.previewShape),r.previewShape=null,r.previewShapeCoordinates=[]),r.activeShape||(r.activeShape=new e.Shape(new e.data.LineString([])),r.options.mode===ye.drawPolygon?(r.finalShape=new e.Shape(new e.data.Polygon([])),r.activeShape.addProperty(r.outlineProp,!0)):r.finalShape=new e.Shape(new e.data.LineString([])),r.activeShape.addProperty(r.parentIdProp,r.finalShape.getId()),r.options.source.add(r.activeShape)),i=r.map.positionsToPixels(r.activeShapeCoordinates)[0],(0===r.activeShapeCoordinates.length||r.pixelDifference(i,t.pixel)>r.options.freehandInterval)&&r.updateActiveShape(t)):(r.activeShape||(r.activeShape=new e.Shape(new e.data.LineString([])),r.options.mode===ye.drawPolygon?(r.finalShape=new e.Shape(new e.data.Polygon([])),r.activeShape.addProperty(r.outlineProp,!0)):r.finalShape=new e.Shape(new e.data.LineString([])),r.activeShape.addProperty(r.parentIdProp,r.finalShape.getId()),r.options.source.add(r.activeShape)),r.previewShape||r.updateActiveShape(t),r.previewShape&&(r.activeShapeCoordinates.push(t.position),r.activeShape.setCoordinates(r.activeShapeCoordinates),r.drawMgr._invokeEvent("drawingchanged",r.activeShape),r.previewSource.remove(r.previewShape),r.previewShape=null,r.previewShapeCoordinates=[]))),r.options.mode===ye.drawRectangle&&(!r.isMouseDown||"mousemove"!==t.type&&"touchmove"!==t.type||(r.activeShape?(r.activeShapeCoordinates=[r.firstRectangleCorner,[t.position[0],r.firstRectangleCorner[1]],t.position,[r.firstRectangleCorner[0],t.position[1]],r.firstRectangleCorner],r.activeShape.setCoordinates(r.activeShapeCoordinates),r.drawMgr._invokeEvent("drawingchanging",r.activeShape)):(r.finalShape=new e.Shape(new e.data.Polygon([])),r.activeShape=new e.Shape(new e.data.Polygon([])),r.activeShape.addProperty(r.parentIdProp,r.finalShape.getId()),r.activeShape.addProperty("subType","Rectangle"),r.options.source.add(r.activeShape),r.firstRectangleCorner=t.position,r.drawMgr._invokeEvent("drawingstarted",null)))),r.options.mode===ye.drawCircle&&(!r.isMouseDown||"mousemove"!==t.type&&"touchmove"!==t.type||(r.activeShape?(r.activeShape.addProperty("radius",e.math.getDistanceTo(r.circleCenterPosition,t.position)),r.drawMgr._invokeEvent("drawingchanging",r.activeShape)):(r.finalShape=new e.Shape(new e.data.Point([])),r.activeShape=new e.Shape(new e.data.Point(t.position)),r.activeShape.addProperty(r.parentIdProp,r.finalShape.getId()),r.activeShape.addProperty("subType","Circle"),r.activeShape.addProperty("radius",1),r.options.source.add(r.activeShape),r.circleCenterPosition=t.position,r.drawMgr._invokeEvent("drawingstarted",null))))},this.previewCoord=function(t){r.isMouseDown||!r.activeShape||r.options.mode!==ye.drawLine&&r.options.mode!==ye.drawPolygon||r.options.interactionType!==Ne.click&&r.options.interactionType!==Ne.hybrid||(r.previewShape||(r.previewShapeCoordinates=[r.activeShapeCoordinates[r.activeShapeCoordinates.length-1]],r.previewShape=new e.Shape(new e.data.LineString(r.previewShapeCoordinates)),r.previewSource.add(r.previewShape)),r.previewShapeCoordinates[1]=t.position,r.previewShape.setCoordinates(r.previewShapeCoordinates),t=function(){for(var t=0,e=0,i=arguments.length;e<i;e++)t+=arguments[e].length;var r=Array(t),n=0;for(e=0;e<i;e++)for(var o=arguments[e],a=0,s=o.length;a<s;a++,n++)r[n]=o[a];return r}(r.activeShapeCoordinates,[t.position]),(t=new e.Shape(new e.data.LineString(t))).addProperty(r.parentIdProp,r.finalShape.getId()),r.drawMgr._invokeEvent("drawingchanging",t))},this.finish=function(t){t&&t.preventDefault();var e=!1;r.activeShape&&(r.options.mode!==ye.drawCircle&&r.options.mode!==ye.drawRectangle||r.drawMgr._invokeEvent("drawingchanged",r.activeShape),r.options.mode===ye.drawPolygon?0<r.activeShapeCoordinates.length&&(r.activeShapeCoordinates.push(r.activeShapeCoordinates[0]),r.finalShape.setCoordinates(r.activeShapeCoordinates)):r.finalShape.setCoordinates(r.activeShape.getCoordinates()),delete(t=r.activeShape.getProperties())[r.parentIdProp],delete t[r.outlineProp],r.options.source.getShapeById(r.activeShape.getId())&&r.options.source.remove(r.activeShape),r.finalShape.setProperties(t),r.options.source.add(r.finalShape),e=!(r.activeShape=null)),r.activeShapeCoordinates=[],r.previewShape&&r.previewSource.remove(r.previewShape),r.previewShapeCoordinates=[],r.previewShape=null,r.isMouseDown=!1,e&&(e=!1,r.drawMgr._invokeEvent("drawingcomplete",r.finalShape))},this.cancel=function(){r.activeShape&&(r.options.source.remove(r.activeShape),r.activeShapeCoordinates=[],r.activeShape=null,r.previewShape&&(r.previewSource.remove(r.previewShape),r.previewShapeCoordinates=[],r.previewShape=null),r.isMouseDown=!1)},this.setMouseDown=function(){r.isMouseDown=!0},this.setMouseUp=function(){r.isMouseDown=!1,r.options.interactionType===Ne.freehand&&r.finish()},this.getPreviewLayers=function(){return r.previewLayers},this.drawMgr=i,this.map=t,this.previewLayers=new Re,this.previewSource=new e.source.DataSource,this.map.sources.add(this.previewSource),this.previewLayers.pointLayer=new e.layer.SymbolLayer(this.previewSource,null,{filter:["==",["geometry-type"],"Point"]}),this.previewLayers.lineLayer=new e.layer.LineLayer(this.previewSource,null,{filter:["all",["==",["geometry-type"],"LineString"],["!",["has",this.outlineProp]]],strokeColor:this.strokeColor}),this.previewLayers.polygonLayer=new e.layer.PolygonLayer(this.previewSource,null,{filter:["==",["geometry-type"],"Polygon"],strokeColor:this.strokeColor}),this.previewLayers.polygonOutlineLayer=new e.layer.LineLayer(this.previewSource,null,{filter:["all",["==",["geometry-type"],"LineString"],["has",this.outlineProp]],strokeColor:this.strokeColor}),this.map.layers.add([this.previewLayers.polygonLayer,this.previewLayers.polygonOutlineLayer,this.previewLayers.lineLayer,this.previewLayers.pointLayer]),this.activeShapeCoordinates=[],this.previewShapeCoordinates=[]}(h=qe=qe||{}).primary="primary",h.secondary="secondary",h.rotational="rotational";var Ze,We=(n(Ke,Ze=e.HtmlMarker),Ke.prototype.setStyle=function(t){this.style=t,this.setOptions(this.style)},Ke.prototype.setState=function(t){this.handleType=t,this.handleType===qe.primary?this.setOptions({htmlContent:this.primaryHtmlContent}):this.handleType===qe.secondary&&this.setOptions({htmlContent:this.secondaryHtmlContent})},Ke.prototype.setIndex=function(t){this.index=t},Ke.prototype.setPosition=function(t){this.setOptions({position:t})},Ke.prototype.getPosition=function(){return this.getOptions().position},Ke.prototype.getHandleType=function(){return this.handleType},Ke.prototype.getIndex=function(){return this.index},Ke);function Ke(t,e,i,r,n,o){var a=Ze.call(this,t)||this;return a.promoteHandle=function(t){a.getHandleType()===qe.secondary&&a.editHelper.promoteHandle(a,a.index,t)},a.moveHandle=function(){a.editHelper.moveHandle(a,a.index)},a.showHandles=function(){a.getHandleType()===qe.primary&&a.editHelper.showHandles(a,a.index)},a.primaryHtmlContent=o.dragHandleStyle.htmlContent,a.secondaryHtmlContent=o.secondaryDragHandleStyle.htmlContent,a.mp=e,a.editHelper=i,a.handleType=r,a.index=n,a.mp.events.add("dragend",a,a.promoteHandle),a.mp.events.add("dragend",a,a.showHandles),a.mp.events.add("drag",a,a.moveHandle),a}var Xe=(Ye.prototype.setOptions=function(t){if(this.options.mode!==t.mode||this.options.freehandInterval!==t.freehandInterval||this.options.interactionType!==t.interactionType)switch(this.options=t,this.options.mode===ye.editGeometry&&this.options.shapeDraggingEnabled?(this.map.events.remove("mouseover",Object.values(this.layers),this.setMouseCursorToPointer),this.map.events.remove("mouseout",Object.values(this.layers),this.setMouseCursorToGrab),this.map.events.add("mouseover",Object.values(this.layers),this.setMouseCursorToMove),this.map.events.add("mouseout",Object.values(this.layers),this.setMouseCursorToGrab)):this.options.mode===ye.eraseGeometry?(this.map.events.remove("mouseover",Object.values(this.layers),this.setMouseCursorToMove),this.map.events.remove("mouseout",Object.values(this.layers),this.setMouseCursorToGrab),this.map.events.add("mouseover",Object.values(this.layers),this.setMouseCursorToPointer),this.map.events.add("mouseout",Object.values(this.layers),this.setMouseCursorToGrab)):(this.map.events.remove("mouseover",Object.values(this.layers),this.setMouseCursorToMove),this.map.events.remove("mouseover",Object.values(this.layers),this.setMouseCursorToPointer),this.map.events.remove("mouseout",Object.values(this.layers),this.setMouseCursorToGrab),this.options.mode===ye.idle?this.setMouseCursorToGrab():this.setMouseCursorToCrossHair()),this.options.mode){case ye.drawPoint:this._clear(),this.map.events.add("click",this.drawingHelper.addCoord),this.map.events.add("touchstart",this.drawingHelper.addCoord),this.map.events.add("mousemove",this.trackMousePosition),this.map.getMapContainer().addEventListener("keypress",this.fKeyPressed),this.map.getMapContainer().addEventListener("keypress",this.cKeyPressed),this.map.getMapContainer().addEventListener("keydown",this.escKeyPressed);break;case ye.drawLine:case ye.drawPolygon:this._clear(),Ye.lockMap(this.map),this.options.interactionType!==Ne.click&&this.options.interactionType!==Ne.hybrid||(this.map.events.add("click",this.drawingHelper.addCoord),this.map.events.add("mousemove",this.drawingHelper.previewCoord)),this.options.interactionType!==Ne.freehand&&this.options.interactionType!==Ne.hybrid||(this.map.events.add("mousedown",this.drawingHelper.setMouseDown),this.map.events.add("mousemove",this.drawingHelper.addCoord),this.map.events.add("mouseup",this.drawingHelper.setMouseUp),this.map.events.add("touchstart",this.drawingHelper.setMouseDown),this.map.events.add("touchmove",this.drawingHelper.addCoord),this.map.events.add("touchend",this.drawingHelper.finish)),this.map.events.add("dblclick",this.drawingHelper.finish),this.map.events.add("mousemove",this.trackMousePosition),this.map.getMapContainer().addEventListener("keypress",this.fKeyPressed),this.map.getMapContainer().addEventListener("keypress",this.cKeyPressed),this.map.getMapContainer().addEventListener("keydown",this.escKeyPressed);break;case ye.drawCircle:case ye.drawRectangle:this._clear(),Ye.lockMap(this.map),this.map.events.add("mousedown",this.drawingHelper.setMouseDown),this.map.events.add("mousemove",this.drawingHelper.addCoord),this.map.events.add("mouseup",this.drawingHelper.finish),this.map.events.add("touchstart",this.drawingHelper.setMouseDown),this.map.events.add("touchmove",this.drawingHelper.addCoord),this.map.events.add("touchend",this.drawingHelper.finish),this.map.events.add("mousemove",this.trackMousePosition),this.map.getMapContainer().addEventListener("keypress",this.fKeyPressed),this.map.getMapContainer().addEventListener("keypress",this.cKeyPressed),this.map.getMapContainer().addEventListener("keydown",this.escKeyPressed);break;case ye.editGeometry:Ye.unLockMap(this.map),this.map.events.add("click",this.editHelper.selectShape),this.map.events.add("touchstart",this.editHelper.selectShape),this.map.events.add("mousedown",this.editHelper.setMouseDown),this.map.events.add("mouseup",this.editHelper.setMouseUp),this.map.events.add("touchstart",this.editHelper.setMouseDown),this.map.events.add("touchend",this.editHelper.setMouseUp),this.map.getMapContainer().addEventListener("keydown",this.escKeyPressed),this.map.getMapContainer().addEventListener("keydown",this.deleteKeyPressed);break;case ye.eraseGeometry:Ye.unLockMap(this.map),this.map.events.add("click",this.editHelper.selectShape),this.map.events.add("touchstart",this.editHelper.selectShape),this.map.events.add("mousedown",this.editHelper.setMouseDown),this.map.events.add("mouseup",this.editHelper.setMouseUp),this.map.events.add("touchstart",this.editHelper.setMouseDown),this.map.events.add("touchend",this.editHelper.setMouseUp),this.map.getMapContainer().addEventListener("keydown",this.deleteKeyPressed);break;default:Ye.unLockMap(this.map),this._clear()}},Ye.prototype._clear=function(){this.drawingHelper.finish(),this.editHelper.finish(),this.map.events.remove("click",this.drawingHelper.addCoord),this.map.events.remove("touchstart",this.drawingHelper.addCoord),this.map.events.remove("drag",this.drawingHelper.addCoord),this.map.events.remove("mousemove",this.drawingHelper.previewCoord),this.map.events.remove("mousemove",this.drawingHelper.addCoord),this.map.events.remove("mouseup",this.drawingHelper.finish),this.map.events.remove("mouseup",this.drawingHelper.addCoord),this.map.events.remove("mouseup",this.drawingHelper.setMouseUp),this.map.events.remove("mousedown",this.drawingHelper.setMouseDown),this.map.events.remove("dblclick",this.drawingHelper.finish),this.map.events.remove("mousemove",this.trackMousePosition),this.map.events.remove("touchstart",this.drawingHelper.setMouseDown),this.map.events.remove("touchmove",this.drawingHelper.addCoord),this.map.events.remove("touchend",this.drawingHelper.finish),this.map.events.remove("click",this.editHelper.selectShape),this.map.events.remove("touchstart",this.editHelper.selectShape),this.map.events.remove("mousedown",this.editHelper.setMouseDown),this.map.events.remove("mouseup",this.editHelper.setMouseUp),this.map.events.remove("touchstart",this.editHelper.setMouseDown),this.map.events.remove("touchend",this.editHelper.setMouseUp),this.map.getMapContainer().removeEventListener("keypress",this.fKeyPressed),this.map.getMapContainer().removeEventListener("keypress",this.cKeyPressed),this.map.getMapContainer().removeEventListener("keydown",this.deleteKeyPressed),this.map.getMapContainer().removeEventListener("keydown",this.escKeyPressed)},Ye.lockMap=function(t){t.setUserInteraction({dblClickZoomInteraction:!1,dragPanInteraction:!1}),t.getMapContainer().style.touchAction="none"},Ye.unLockMap=function(t){t.setUserInteraction({dblClickZoomInteraction:!0,dragPanInteraction:!0}),t.getMapContainer().style.touchAction=null},Ye);function Ye(t,e,i,r,n){var o=this;this.options={},this.trackMousePosition=function(t){o.mouseEvent=t},this.fKeyPressed=function(t){70!==t.keyCode&&102!==t.keyCode||o.drawingHelper.addCoord(o.mouseEvent,!0)},this.cKeyPressed=function(t){67!==t.keyCode&&99!==t.keyCode||(o.drawingHelper.finish(),o.editHelper.finish())},this.deleteKeyPressed=function(t){46!==t.keyCode&&8!==t.keyCode||o.editHelper.erase()},this.escKeyPressed=function(t){27===t.keyCode&&(o.drawingHelper.cancel(),o.editHelper.finish())},this.setMouseCursorToMove=function(){o.map.getCanvas().style.cursor="move"},this.setMouseCursorToPointer=function(){o.map.getCanvas().style.cursor="default"},this.setMouseCursorToCrossHair=function(){o.map.getCanvas().style.cursor="crosshair"},this.setMouseCursorToGrab=function(){o.map.getCanvas().style.cursor="grab"},this.map=t,this.layers=i,this.editHelper=n,this.drawingHelper=r,this.setOptions(this.options)}var Je=(Qe.prototype.setOptions=function(t){this.finish(),this.options=t},Qe.prototype.finish=function(){this._clearHandlesAndListeners();var t=this.shape;this.shape=null,t&&this.drawMgr._invokeEvent("drawingcomplete",t),this.currentReferencedPixel=null,Xe.unLockMap(this.map)},Qe.prototype.edit=function(t){this.shape&&this.drawMgr._invokeEvent("drawingcomplete",this.shape),this.drawMgr._invokeEvent("drawingstarted",t),this._disableShapeDragAndRotate(),this._clearHandlesAndListeners(),this.shape=t,this.selectedShapeCoordinates=this.shape.getCoordinates(),"Point"!==this.shape.getType()||this.shape.isCircle()?0===this.primaryHandles.length&&(this.shape.isCircle()?this._generateDragHandles(this.selectedShapeCoordinates):this.shape.isRectangle()?this._generateDragHandles(this.selectedShapeCoordinates[0]):"LineString"===this.shape.getType()?this._generateDragHandles(this.selectedShapeCoordinates):"Polygon"===this.shape.getType()&&this._generateDragHandles(this.selectedShapeCoordinates[0])):this.shape.addProperty("_azureMapsMarker",this.editedPointStyle),this._enableShapeDragAndRotate()},Qe.prototype.promoteHandle=function(t,e,i){this.isSecondaryHandleMoving=!1,t.setOptions({visible:!0});var r=t.getPosition(),n=this.primaryHandles.length;"LineString"===this.shape.getType()?s=(a=e)+1:"Polygon"===this.shape.getType()&&(a=0===e?n-1:e-1,s=e===n-1?0:e+1);n=this.primaryHandles[a];var o,a=this.primaryHandles[s],s=this._getMidPosition(r,n.getPosition());n=this._getMidPosition(r,a.getPosition()),r=new We(this.options.secondaryDragHandleStyle,this.map,this,qe.secondary,e,this.options),a=new We(this.options.secondaryDragHandleStyle,this.map,this,qe.secondary,e+1,this.options);for(r.setPosition(s),a.setPosition(n),t.setState(qe.primary),t.setIndex(e+1),t.setStyle(this.options.dragHandleStyle),this.secondaryHandles[e]=r,this.secondaryHandles.splice(e+1,0,a),this.primaryHandles.splice(e+1,0,t),o=e+2;o<this.secondaryHandles.length;o++)this.primaryHandles[o].setIndex(o),this.secondaryHandles[o].setIndex(o);"LineString"===this.shape.getType()&&this.primaryHandles[o].setIndex(o),this.map.markers.add([r,a])},Qe.prototype.moveHandle=function(t,i){this.drawMgr._invokeEvent("drawingchanged",this.shape),this._disableShapeDragAndRotate();var r,n,o,a,s,l=t.getPosition();this.shape.isCircle()?(a=this.selectedShapeCoordinates,this.shape.setProperties({radius:e.math.getDistanceTo(a,t.getPosition()),subType:"Circle"}),this.primaryHandles.forEach(function(t){t.setOptions({visible:!1})})):this.shape.isRectangle()?(t.setOptions({visible:!1}),r=void 0,(s=this.selectedShapeCoordinates[0])[i]=l,n=0===i?(r=this.primaryHandles.length-1,i+1):(r=i-1,i===this.primaryHandles.length-1?0:i+1),o=this.primaryHandles[r],a=this.primaryHandles[n],0===i||2===i?(s[r][0]=l[0],s[n][1]=l[1]):1!==i&&3!==i||(s[r][1]=l[1],s[n][0]=l[0]),o.setPosition(s[r]),a.setPosition(s[n]),o.setOptions({visible:!1}),a.setOptions({visible:!1}),s[s.length-1]=s[0],this.shape.setCoordinates([s])):"LineString"===this.shape.getType()?(t.setOptions({visible:!1}),t.getHandleType()===qe.primary&&((s=this.selectedShapeCoordinates)[i]=l,this.shape.setCoordinates(s),0<i&&this.secondaryHandles[i-1].setOptions({visible:!1}),i<this.primaryHandles.length-1&&this.secondaryHandles[i].setOptions({visible:!1})),t.getHandleType()===qe.secondary&&(s=this.selectedShapeCoordinates,this.isSecondaryHandleMoving?s[i+1]=l:(s.splice(i+1,0,l),this.isSecondaryHandleMoving=!0),this.shape.setCoordinates(s))):"Polygon"===this.shape.getType()&&(t.setOptions({visible:!1}),t.getHandleType()===qe.primary&&((s=this.selectedShapeCoordinates[0])[i]=l,0===i?(this.secondaryHandles[i].setOptions({visible:!1}),this.secondaryHandles[this.secondaryHandles.length-1].setOptions({visible:!1})):(0<i&&this.secondaryHandles[i-1].setOptions({visible:!1}),i<this.primaryHandles.length&&this.secondaryHandles[i].setOptions({visible:!1})),s[s.length-1]=s[0],this.shape.setCoordinates([s])),t.getHandleType()===qe.secondary&&(s=this.selectedShapeCoordinates[0],this.isSecondaryHandleMoving?s[i+1]=l:(s.splice(i+1,0,l),this.isSecondaryHandleMoving=!0),this.shape.setCoordinates([s])))},Qe.prototype.showHandles=function(t,i){var r,n,o,a,s,l,u,c,p;this.shape.isCircle()?(r=this.selectedShapeCoordinates,n=this.shape.getProperties().radius,o=0,this.primaryHandles.forEach(function(t){t.setPosition(e.math.getDestination(r,o+=90,n)),t.setOptions({visible:!0})})):(a=t.getPosition(),s=this.primaryHandles.length,p=u=c=l=void 0,"LineString"===this.shape.getType()?(l=0<i?i-1:null,c=i<s-1?i+1:null,u=i-1,p=i):"Polygon"===this.shape.getType()&&(c=i===s-1?0:i+1,u=l=0===i?s-1:i-1,p=i),null!=l&&(l=this.primaryHandles[l],this.shape.isRectangle()?l.setOptions({visible:!0}):(l=this._getMidPosition(a,l.getPosition()),(u=this.secondaryHandles[u]).setPosition(l),this.map.markers.add(u),u.setOptions({visible:!0}))),null!=c&&(c=this.primaryHandles[c],this.shape.isRectangle()?c.setOptions({visible:!0}):(c=this._getMidPosition(a,c.getPosition()),(p=this.secondaryHandles[p]).setPosition(c),this.map.markers.add(p),p.setOptions({visible:!0})))),t.setOptions({visible:!0}),this._enableShapeDragAndRotate()},Qe.prototype._generateDragHandles=function(t){if(this.shape.isCircle())for(var i=t,r=this.shape.getProperties().radius,n=0,o=0;o<4;o++){var a=e.math.getDestination(i,n+=90,r);(s=new We(this.options.dragHandleStyle,this.map,this,qe.primary,o,this.options)).setPosition(a),this.map.markers.add(s),this.primaryHandles.push(s)}else{var s,l,u;for(o=0;o<t.length;o++)(s=new We(this.options.dragHandleStyle,this.map,this,qe.primary,o,this.options)).setPosition(t[o]),this.primaryHandles.push(s),this.map.markers.add(s),this.shape.isRectangle()||o<t.length-1&&(l=this._getMidPosition(t[o],t[o+1]),(u=new We(this.options.secondaryDragHandleStyle,this.map,this,qe.secondary,o,this.options)).setPosition(l),this.map.markers.add(u),this.secondaryHandles.push(u));"Polygon"===this.shape.getType()&&this.map.markers.remove(this.primaryHandles.pop())}},Qe.prototype._getMidPosition=function(t,e){return t=this.map.positionsToPixels([t])[0],e=this.map.positionsToPixels([e])[0],e=[(t[0]+e[0])/2,(t[1]+e[1])/2],this.map.pixelsToPositions([e])[0]},Qe.prototype._clearHandlesAndListeners=function(){this.map.markers.remove(this.primaryHandles),this.map.markers.remove(this.secondaryHandles),this.primaryHandles=[],this.secondaryHandles=[],this._disableShapeDragAndRotate(),this.removeRotateHandle(),this.shape&&"Point"===this.shape.getType()&&!this.shape.isCircle()&&this.shape.addProperty("_azureMapsMarker",this.defaultPointStyle)},Qe.prototype._enableShapeDragAndRotate=function(){this._dragOrRotateEnabled()&&(this.map.events.add("mousedown",this._startDragAndRotate),this.map.events.add("mousemove",this._dragAndRotate),this.map.events.add("mouseup",this._endDragAndRotate),this._shouldRotate()&&(this._unselectShapeForRotate(),this.initCentroid=i.data.BoundingBox.getCenter(i.data.BoundingBox.fromData(this.shape)),this.initCoordinates=this.shape.getCoordinates(),this.initHeading=null,this.rotateInitHandlePosition=this.getInitHandlePosition(this.shape),this.rotateHandle=new e.HtmlMarker({position:this.rotateInitHandlePosition,htmlContent:'<div class="rotateHandleIcon" />'}),this.map.markers.add(this.rotateHandle),this.map.events.add("mousedown",this.rotateHandle,this._handleMouseDownOnRotateHandle)))},Qe.prototype._dragOrRotateEnabled=function(){return this.options&&(this.options.shapeDraggingEnabled||this.options.shapeRotationEnabled)},Qe.prototype._shouldRotate=function(){return this.options&&this.options.shapeRotationEnabled&&"Point"!==this.shape.getType()&&!this.shape.isCircle()},Qe.prototype._disableShapeDragAndRotate=function(){this._dragOrRotateEnabled()&&(this.map.events.remove("mousedown",this._startDragAndRotate),this.map.events.remove("mousemove",this._dragAndRotate),this.map.events.remove("mouseup",this._endDragAndRotate))},Qe.prototype.isEventShapeSameAsSelectedShape=function(t){var e;return(e=(t=t.shapes&&t.shapes.filter(function(t){return t&&t.getProperties}))&&0<t.length?t[0]:e)&&this.shape&&this.shape.getId()===e.getId()},Qe.prototype._freezeMap=function(t,e){this.shape=t,Xe.lockMap(this.map),this.currentReferencedPixel=e.pixel},Qe.prototype._pixelAccurateUpdate=function(t){var i=e.Pixel.getX(this.currentReferencedPixel)-e.Pixel.getX(t.pixel),r=e.Pixel.getY(this.currentReferencedPixel)-e.Pixel.getY(t.pixel);if("Point"===this.shape.getType()){var n=this.shape.getCoordinates();this.shape.setCoordinates(this._pixelShiftLocations(n,i,r))}else{var o=void 0;"Polygon"===this.shape.getType()?o=this.shape.getCoordinates()[0]:"LineString"===this.shape.getType()&&(o=this.shape.getCoordinates());for(var a=0,s=o.length;a<s;a++)o[a]=this._pixelShiftLocations(o[a],i,r);this.shape.setCoordinates(o)}this.currentReferencedPixel=t.pixel},Qe.prototype._pixelShiftLocations=function(t,e,i){return(t=this.map.positionsToPixels([t])[0])[0]-=e,t[1]-=i,this.map.pixelsToPositions([t])[0]},Qe.prototype._showOrHideDragHandles=function(t){this.primaryHandles.forEach(function(e){e.setOptions({visible:t})}),this.secondaryHandles.forEach(function(e){e.setOptions({visible:t})})},Qe.prototype._unselectShapeForRotate=function(){this.initCentroid=null,this.initCoordinates=null,this.initHeading=null,this.isRotating=!1,this.removeRotateHandle()},Qe.prototype.rotateShape=function(t,i,r,n){switch(t.getType()){case"LineString":case"MultiPoint":t.setCoordinates(e.math.rotatePositions(i,r,n));break;case"Polygon":case"MultiLineString":var o=i.map(function(t){return e.math.rotatePositions(t,r,n)});t.setCoordinates(o);break;case"MultiPolygon":o=i.map(function(t){return t.map(function(t){return e.math.rotatePositions(t,r,n)})}),t.setCoordinates(o)}this.rotateHandle&&this.rotateHandle.setOptions({position:e.math.rotatePositions([this.rotateInitHandlePosition],r,n)[0]})},Qe.prototype.getInitHandlePosition=function(t){return t=t.getCoordinates(),e.math.getPositions(t)[0]},Qe);function Qe(t,r,n,o){var a=this;this.editedPointStyle="marker-blue",this.isDragging=!1,this.erase=function(){a.shape&&(a.options.source.remove(a.shape),a.selectedShapeCoordinates=[],a._clearHandlesAndListeners(),a.drawMgr._invokeEvent("drawingerased",a.shape),a.shape=null,a.isMouseDown=!1)},this.selectShape=function(t){var i,r;t.originalEvent.target===a.map.getCanvas()&&(i=[t.pixel[0]-3,t.pixel[1]+3],r=[t.pixel[0]+3,t.pixel[1]-3],i=a.map.pixelsToPositions([i])[0],r=a.map.pixelsToPositions([r])[0],r=new e.data.BoundingBox(i,r),(r=a.map.layers.getRenderedShapes(r,Object.values(a.layers)))&&0<r.length&&(r=r[0])&&(a.options.mode===ye.eraseGeometry?(a.shape=r,a.erase(),a.drawMgr.setOptions({mode:ye.idle})):a.edit(r)),t.originalEvent.stopImmediatePropagation())},this.setMouseDown=function(){a.isMouseDown=!0},this.setMouseUp=function(){a.isMouseDown=!1},this._startDragAndRotate=function(t){a.isEventShapeSameAsSelectedShape(t)&&(a.options.shapeDraggingEnabled&&(a.rotateHandle&&a.rotateHandle.setOptions({visible:!1}),a.isDragging=!0),a._freezeMap(a.shape,t))},this._dragAndRotate=function(t){if(a.shape&&a.isMouseDown){if(a.isDragging){var r=e.Pixel.getX(a.currentReferencedPixel)-e.Pixel.getX(t.pixel),n=e.Pixel.getY(a.currentReferencedPixel)-e.Pixel.getY(t.pixel);if(r*r+n*n<=25)return;a.map.markers.remove(a.primaryHandles),a.map.markers.remove(a.secondaryHandles),a.primaryHandles=[],a.secondaryHandles=[],a._pixelAccurateUpdate(t)}a.isRotating&&(t=a.map.positionsToPixels([a.initCentroid,t.position]),t=i.Pixel.getHeading(t[0],t[1])-a.initHeading+180,a._showOrHideDragHandles(!1),a.rotateShape(a.shape,a.initCoordinates,a.initCentroid,t))}},this._endDragAndRotate=function(t){var e;Xe.unLockMap(a.map),a.isDragging&&(a.isDragging=!1,a.shape&&"Point"===a.shape.getType()&&!a.shape.isCircle()&&(delete(e=a.shape.getProperties())._azureMapsMarker,a.shape.setProperties(e)),a.rotateHandle&&a.rotateHandle.setOptions({visible:!0})),a.isRotating&&(a.isRotating=!1,a._showOrHideDragHandles(!0)),a.edit(a.shape)},this._handleMouseDownOnRotateHandle=function(t){var e=a.map.positionsToPixels([a.rotateInitHandlePosition,a.initCentroid]);a.initHeading=i.Pixel.getHeading(e[0],e[1]),a.map.setUserInteraction({dragPanInteraction:!1}),a.isRotating=!0},this._startRotate=function(t){a._freezeMap(a.shape,t)},this.removeRotateHandle=function(){a.rotateHandle&&(a.map.events.remove("mousedown",a.rotateHandle,a._handleMouseDownOnRotateHandle),a.map.markers.remove(a.rotateHandle),a.rotateHandle=null)},this.map=t,this.options=r,this.primaryHandles=[],this.secondaryHandles=[],this.layers=n,this.drawMgr=o,this.defaultPointStyle=this.layers.pointLayer?this.layers.pointLayer.getOptions().iconOptions.image:"marker-black"}var $e;n(ti,$e=e.internal.EventEmitter),ti.prototype.dispose=function(){this.options.toolbar&&this.options.toolbar._dispose(),this.drawingLayers&&(this.map.layers.remove(this.drawingLayers.lineLayer),this.map.layers.remove(this.drawingLayers.polygonLayer),this.map.layers.remove(this.drawingLayers.polygonOutlineLayer),this.map.layers.remove(this.drawingLayers.pointLayer)),this.drawingHelper&&this.drawingHelper.dispose(),this.map=null,this.options=null,this.drawingLayers=null,this.source=null,this.drawingHelper=null,this.editHelper=null,this.inputHelper=null},ti.prototype.edit=function(t){t&&(this.source&&!this.source.getShapeById(t.getId())&&this.source.add(t),this.setOptions({mode:ye.editGeometry}),this.editHelper.edit(t))},ti.prototype.getOptions=function(){return this.options},ti.prototype.getLayers=function(){return this.drawingLayers},ti.prototype.getPreviewLayers=function(){return this.drawingHelper.getPreviewLayers()},ti.prototype.getSource=function(){return this.source},ti.prototype.setOptions=function(t){(t=(new je).merge(this.options,Oe(t,je._cloneCustomizer))).dragHandleStyle.draggable=!0,t.secondaryDragHandleStyle.draggable=!0,t.source=t.source||this.options.source,this.options.toolbar!==t.toolbar?(this.options.toolbar&&this.options.toolbar._close(),this.options.toolbar=t.toolbar,this.options.toolbar&&this.options.toolbar._open(this,this.map)):this.options.toolbar&&!this.options.toolbar._isOpen()&&this.options.toolbar._open(this,this.map),this.options.source?this.options.source!==t.source&&(this.source=this.options.source,t.mode=ye.idle,this._setLayerSources()):(this.source=new e.source.DataSource,this.map.sources.add(this.source),this._setLayerSources()),this.options.mode!==t.mode&&this._invokeEvent("drawingmodechanged",t.mode),this.options=t,this.options.source=this.source,this.editHelper.setOptions(this.options),this.inputHelper.setOptions(this.options),this.drawingHelper.setOptions(this.options),this.inputHelper.setOptions(this.options)},ti.prototype._getMap=function(){return this.map},ti.prototype._setLayerSources=function(){this.drawingLayers.polygonLayer?this.drawingLayers.polygonLayer.setOptions({filter:["==",["geometry-type"],"Polygon"],source:this.source}):(this.drawingLayers.polygonLayer=new e.layer.PolygonLayer(this.source,null,{fillColor:"rgba(0, 0, 0, 0.12)",filter:["all",["==",["geometry-type"],"Polygon"],["!",["has","_incomplete"]]]}),this.map.layers.add(this.drawingLayers.polygonLayer)),this.drawingLayers.polygonOutlineLayer?this.drawingLayers.polygonOutlineLayer.setOptions({filter:["any",["==",["geometry-type"],"Polygon"],["all",["==",["geometry-type"],"LineString"],["has","_outline"]]],source:this.source}):(this.drawingLayers.polygonOutlineLayer=new e.layer.LineLayer(this.source,null,{filter:["any",["==",["geometry-type"],"Polygon"],["all",["==",["geometry-type"],"LineString"],["has","_outline"]]],strokeColor:"#000000"}),this.map.layers.add(this.drawingLayers.polygonOutlineLayer)),this.drawingLayers.lineLayer?this.drawingLayers.lineLayer.setOptions({filter:["all",["==",["geometry-type"],"LineString"],["!",["has","_outline"]]],source:this.source}):(this.drawingLayers.lineLayer=new e.layer.LineLayer(this.source,null,{filter:["all",["==",["geometry-type"],"LineString"],["!",["has","_outline"]]],strokeColor:"#000000"}),this.map.layers.add(this.drawingLayers.lineLayer)),this.drawingLayers.pointLayer?this.drawingLayers.pointLayer.setOptions({filter:["==",["geometry-type"],"Point"],source:this.source}):(this.drawingLayers.pointLayer=new e.layer.SymbolLayer(this.source,null,{filter:["==",["geometry-type"],"Point"],iconOptions:{allowOverlap:!0,ignorePlacement:!0,image:["case",["has","_azureMapsMarker"],["get","_azureMapsMarker"],"marker-black"],size:.5}}),this.map.layers.add(this.drawingLayers.pointLayer))},_=ti;function ti(t,e){var i=$e.call(this)||this;return i.map=t,i.options=(new je).merge(Oe(e,je._cloneCustomizer)),i.drawingLayers=new Re,i.drawingHelper=new He(i.map,i),i.editHelper=new Je(i.map,e,i.drawingLayers,i),i.inputHelper=new Xe(i.map,i.options,i.drawingLayers,i.drawingHelper,i.editHelper),i.setOptions(i.options),i}function ei(t,i){var r=this;this._options={resolution:15,showGrid:!1,removeDuplicates:!0,enabled:!0,simplify:!0},this._mapSize24=512*Math.pow(2,24),this._updateGrid=function(){var t=r,i=t._map.getCamera(),n=Math.round(i.zoom),o=t._options.resolution*Math.pow(2,24-n),a=e.data.BoundingBox,s=t._mapSize24,l=t.clip,u=(i=r.splitOnAntimeridian(i.bounds),[]);i.forEach(function(i){i=(r=t.fastPositionsToPixels([a.getNorthWest(i),a.getSouthEast(i)],!1,!1,o))[0];for(var r=r[1],n=l(i[0]-i[0]%o-o,0,s),c=l(r[0]-r[0]%o+o,0,s),p=l(i[1]-i[1]%o-o,0,s),h=l(r[1]-r[1]%o+o,0,s),d=p;d<h;d+=o)u.push(new e.data.LineString(t.fastPixelsToPositions([[n,d],[c,d]])));for(var f=n;f<c;f+=o)u.push(new e.data.LineString(t.fastPixelsToPositions([[f,p],[f,h]])))}),t._source.setShapes(u)};var n=this;n._map=t,n._source=new e.source.DataSource,t.sources.add(n._source),n._layer=new e.layer.LineLayer(n._source,null,{strokeColor:"#c3a77e",strokeWidth:1,visible:!1}),t.layers.add(n._layer,"transit"),n.setOptions(i||{})}ei.prototype.dispose=function(){var t=this;t._map.events.remove("move",t._updateGrid),t._map.events.remove("resize",t._updateGrid),Object.keys(t).forEach(function(e){t[e]=null})},ei.prototype.getOptions=function(){return Object.assign({},this._options)},ei.prototype.getGridLayer=function(){return this._layer},ei.simplify=function(t,i){return e.math.simplify(t,i)},ei.prototype.snapPositions=function(t,e){var i=this._options;if(!i.enabled)return t;e="number"==typeof e?Math.round(Math.abs(e)):Math.round(this._map.getCamera().zoom);for(var r,n,o=i.resolution*Math.pow(2,24-e),a=this.fastPositionsToPixels(t,i.removeDuplicates,i.simplify,o),s=0,l=a.length;s<l;s++){.5*o<=(n=(r=a[s])[0]%o)&&(n-=o);var u=r[1]%o;.5*o<=u&&(u-=o),r[0]-=n,r[1]-=u}return this.fastPixelsToPositions(a)},ei.prototype.snapShape=function(t,i){var r;this._options.enabled&&(t instanceof e.Shape?(r=t.toJson(),this.snapFeature(r,i),t.setCoordinates(r.geometry.coordinates)):"Feature"===t.type&&this.snapFeature(t,i))},ei.prototype.setOptions=function(t){var e,i,r,n;t&&(i=(e=this)._map,r=e._options,n=!1,"boolean"==typeof t.removeDuplicates&&t.removeDuplicates!==r.removeDuplicates&&(r.removeDuplicates=t.removeDuplicates),"boolean"==typeof t.simplify&&t.simplify!==r.simplify&&(r.simplify=t.simplify),"boolean"==typeof t.enabled&&t.enabled!==r.enabled&&(r.enabled=t.enabled),"number"==typeof t.resolution&&0<t.resolution&&(r.resolution=t.resolution,n=!0),"boolean"==typeof t.showGrid&&t.showGrid!==r.showGrid&&(r.showGrid=t.showGrid,r.showGrid?(i.events.add("move",e._updateGrid),i.events.add("resize",e._updateGrid),n=!0):(i.events.remove("move",e._updateGrid),i.events.remove("resize",e._updateGrid)),e._layer.setOptions({visible:r.showGrid})),n&&(e._source.clear(),e._updateGrid()))},ei.prototype.snapFeature=function(t,e){var i=this,r=t.geometry;switch(r.type){case"Point":r.coordinates=i.snapPositions([r.coordinates],e)[0];break;case"LineString":case"MultiPoint":r.coordinates=i.snapPositions(r.coordinates,e);break;case"Polygon":case"MultiLineString":r.coordinates=r.coordinates.map(function(t){return i.snapPositions(t,e)});break;case"MultiPolygon":r.coordinates=r.coordinates.map(function(t){return t.map(function(t){return i.snapPositions(t,e)})})}},ei.prototype.fastPositionsToPixels=function(t,i,r,n){for(var o,a,s=[],l=this._mapSize24,u=0,c=t.length;u<c;u++){var p=Math.sin(t[u][1]*Math.PI/180),h=Math.round((e.math.normalizeLongitude(t[u][0])+180)/360*l);p=Math.round((.5-Math.log((1+p)/(1-p))/(4*Math.PI))*l);0!==u&&i&&o===h&&a===p||s.push([h,p]),o=h,a=p}return r&&1<s.length?e.math.simplify(s,.5*n):s},ei.prototype.fastPixelsToPositions=function(t){for(var e=[],i=0,r=t.length;i<r;i++)e.push(this.fastPixelToPosition(t[i]));return e},ei.prototype.fastPixelToPosition=function(t){var e=this._mapSize24;return[360*(t[0]/e-.5),90-360*Math.atan(Math.exp(2*-(.5-t[1]/e)*Math.PI))/Math.PI]},ei.prototype.clip=function(t,e,i){return Math.max(Math.min(t,i),e)},ei.prototype.splitOnAntimeridian=function(t){var i,r,n,o,a,s,l=[];return 6<=t.length&&360<t[3]-t[0]?[[-180,t[1],t[2],180,t[4],t[5]]]:t.length<6&&360<t[2]-t[0]?[[-180,t[1],180,t[3]]]:(this.crossesAntimeridian(t)?(i=void 0,r=e.math.normalizeLongitude(e.data.BoundingBox.getWest(t)),n=e.math.normalizeLongitude(e.data.BoundingBox.getEast(t)),o=e.math.normalizeLatitude(e.data.BoundingBox.getNorth(t)),a=e.math.normalizeLatitude(e.data.BoundingBox.getSouth(t)),s=6<=t.length?(i=[r,a,t[2],180,o,t[5]],[-180,a,t[2],n,o,t[5]]):(i=[r,a,180,o],[-180,a,n,o]),l.push(i,s)):l.push(t),l)},ei.prototype.crossesAntimeridian=function(t){return e.math.normalizeLongitude(e.data.BoundingBox.getEast(t))-e.math.normalizeLongitude(e.data.BoundingBox.getWest(t))<0||6<=t.length&&360<t[3]-t[0]||t.length<6&&360<t[2]-t[9]},v=ei,h=Object.freeze({__proto__:null,SnapGridManager:v}),v=Object.freeze({__proto__:null,DrawingManager:_,get DrawingMode(){return ye},get DrawingInteractionType(){return Ne},SnapGridManager:v}),p=a.merge("atlas.control",p),v=a.merge("atlas.drawing",v),h=a.merge("atlas.drawing",h),t.control=p,t.drawing=v,t.snapGrid=h}(this.atlas=this.atlas||{},atlas);
/* MIT License - Copyright (c) Microsoft Corporation. */


!function(e,_){"use strict";var d="default"in _?_.default:_,o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var a in t)t.hasOwnProperty(a)&&(e[a]=t[a])})(e,t)};function t(e,t){function a(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(a.prototype=t.prototype,new a)}var i=function(){return(i=Object.assign||function(e){for(var t,a=1,o=arguments.length;a<o;a++)for(var n in t=arguments[a])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e}).apply(this,arguments)},a=(n.merge=function(e,t){for(var a=window||global,o=0,n=e.split(".");o<n.length;o++){var r=n[o];if(!a[r])return t;a=a[r]}return i(i({},a),t)},n);function n(){}var M=(s.getString=function(e,t,a,o){if(void 0!==e){if("number"==typeof e)return e.toLocaleString(a,o);if(""!==e)return Number.toString(),t&&t[e]?t[e]:e}return""},s.uuid=function(){return([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,function(e){return(e^crypto.getRandomValues(new Uint8Array(1))[0]&15>>e/4).toString(16)})},s.getLayer=function(e,t){return"string"==typeof e?t.layers.getLayerById(e):e},s.colorToRGBA=function(e){var t=document.createElement("canvas");t.setAttribute("width","1"),t.setAttribute("height","1");var a=t.getContext("2d");a.fillStyle=e,a.fillRect(0,0,1,1);var o=a.getImageData(0,0,1,1).data;return[o[0],o[1],o[2],o[3]]},s.getColorTheme=function(e){var t=s.colorToRGBA(e);return 127<Math.sqrt(.299*t[0]*t[0]+.587*t[1]*t[1]+.114*t[2]*t[2])?"light":"dark"},s.getElement=function(e){if(e){if("string"!=typeof e)return e;var t=document.getElementById(e);return t=t||document.querySelector(e)}return null},s.replacePlaceholder=function(e,t,a,o){o&&(t="[\"']?"+t+"[\"']?");var n=RegExp(t,"gi");return JSON.parse(JSON.stringify(e).replace(n,a+""))},s.setZoomRangeAttr=function(e,t,a,o){var n="data-zoom-behavior",r=e.minZoom+"",i=e.maxZoom+"",l=e.zoomBehavior||t.zoomBehavior||"";a.setAttribute("data-min-zoom",r),a.setAttribute("data-max-zoom",i),a.setAttribute(n,l),o&&(o.setAttribute("data-min-zoom",r),o.setAttribute("data-max-zoom",i),o.setAttribute(n,l))},s.processZoomRangeAttr=function(e,t){for(var a="data-min-zoom",o="atlas-carousel-disabled-text",n=0;n<e.length;n++){var r=e[n];if(r.hasAttribute(a)){var i=parseInt(r.getAttribute(a)),l=parseInt(r.getAttribute("data-max-zoom")),s=r.getAttribute("data-zoom-behavior"),c=i<=t&&Math.ceil(t)<=l;if("hide"===s)r.style.display=c?"":"none";else{for(var d=r.querySelectorAll("input, option"),u=0;u<d.length;u++)d[u].disabled=!c;c?r.classList.remove(o):r.classList.add(o)}}}},s.getZoomRange=function(e){if(e&&0<e.length){var a={minZoom:24,maxZoom:0};if(e.forEach(function(e){if(e.getOptions){var t=e.getOptions();a.minZoom=Math.min(t.minZoom||0,a.minZoom),a.maxZoom=Math.max(t.maxZoom||24,a.maxZoom)}}),a.minZoom>a.maxZoom){var t=a.maxZoom;a.maxZoom=a.minZoom,a.minZoom=t}return a}return{minZoom:0,maxZoom:24}},s.addClearDiv=function(e){var t=document.createElement("div");t.className="atlas-control-clear",e.appendChild(t)},s.measureText=function(e,t,a){var o=document.createElement("canvas").getContext("2d");return o.font=t+"px "+(a||"Arial"),s.HexCharRx.test(e)&&(e=e.replace(s.HexCharRx,"W")),o.measureText(e)},s.addStringDiv=function(e,t,a,o,n,r){if(t&&""!==t){if(""!==(t=s.getString(t,o))){var i=document.createElement("div");if(i.className=a,i.innerHTML=t,i.setAttribute("aria-label",t),e.appendChild(i),!r){var l=s.measureText(t,14);i.style.minWidth=Math.ceil(l.width+20)+"px"}n&&s.addClearDiv(e)}return t}return""},s.getNumber=function(e,t,a,o){var n=e[t];return"number"==typeof n?Math.max(a,n):o},s.getNumber2=function(e,t,a,o,n){var r=e[a];return"number"==typeof r||"number"==typeof(r=t[a])?Math.max(o,r):n},s.getMapLayers=function(e,t){var a=[];if(e){var o=e.layers.getLayers(),n=[],r=[];t&&0<t.length&&t.forEach(function(e){r.push("string"==typeof e?e:e.getId())});var i=_.control.DrawingToolbar;i&&e.controls.getControls().forEach(function(e){if(e instanceof i){var t=i.drawMgr.getLayers();r.push(t.lineLayer.getId()),r.push(t.pointLayer.getId()),r.push(t.polygonLayer.getId()),r.push(t.polygonOutlineLayer.getId())}});var l=_.layer.SimpleDataLayer;o.forEach(function(e){var t=e.layers&&0<e.layers.length?e.layers[0].id:e.getId();if(l&&e instanceof l){n.push(e);var o=e.getLayers();Object.keys(o).forEach(function(e){var t=o[e],a=n.indexOf(t);-1<a&&n.splice(a,1),r.push(t.getId())})}else t.startsWith("microsoft.maps.")||n.push(e)}),n.forEach(function(e){var t=e.layers&&0<e.layers.length?e.layers[0].id:e.getId();-1===r.indexOf(t)&&a.push(e)})}return a},s.decimalPlaces=function(e){var t=(""+e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);return t?Math.max(0,(t[1]?t[1].length:0)-(t[2]?+t[2]:0)):0},s.round=function(e,t){var a=Math.pow(10,t);return Math.round(e*a)/a},s.HexCharRx=/&#x[0-9a-zA-Z]+;/g,s);function s(){}var f=(C.serializeLayerOptions=function(e){if(e.getOptions){var o=e.getOptions(),t={radius:o.radius,color:o.color,fillColor:o.fillColor,fillPattern:o.fillPattern,strokeColor:o.strokeColor,strokeWidth:o.strokeWidth,strokeGradient:o.strokeGradient,image:o.iconOptions?o.iconOptions.image:0,minZoom:o.minZoom,maxZoom:o.maxZoom,visible:o.visible,activeLayers:o.activeLayers};if(_.layer.SimpleDataLayer&&e instanceof _.layer.SimpleDataLayer){var n=[t],r=e.getLayers();return["bubbleLayer","extrudedPolygonLayer","lineLayer","polygonLayer","symbolLayer"].forEach(function(e){var t=r[e],a="extrudedPolygonLayer"===e;t&&(!a||a&&o.allowExtrusions)&&n.push(C.serializeLayerOptions(t))}),JSON.stringify(n)}return JSON.stringify(t)}},C.parse=function(e,t){var a=C,o=[],n=M.getLayer(e.layer,t._map);if(n){var r=_.layer,i=a._parseStyle,l=a._overrideCategoryValue,s={};if(n.getOptions&&(s=n.getOptions()),s.visible)if(n instanceof r.BubbleLayer){i(n,"color","color",e,t,o);var c=i(n,"radius","scale",e,t,o);c&&("category"===c.type&&c.items.forEach(function(e){e.shapeSize*=2}),"string"==typeof s.color&&l(c,"color",s.color))}else if(n instanceof r.LineLayer){var d=i(n,"strokeGradient","color",e,t,o,!0);l(d||i(n,"strokeColor","color",e,t,o,!0),"shape","line");var u=i(n,"strokeWidth","scale",e,t,o);l(u,"shape","line"),u&&!d&&"string"==typeof s.strokeColor&&l(u,"color",s.strokeColor)}else if(n instanceof r.PolygonLayer||n instanceof r.PolygonExtrusionLayer){var p=i(n,"fillPattern","image",e,t,o);l(p||i(n,"fillColor","color",e,t,o),"shape","square")}else if(n instanceof r.HeatMapLayer)i(n,"color","color",e,t,o,!0);else if(n instanceof r.SymbolLayer){var m=s.iconOptions;if(m)if("string"==typeof m.image){if(m.size&&Array.isArray(m.size)){var g=a._getValue(m.image,"image",t);g&&g.shape&&l(i(n,"size","scale",e,t,o),"shape",g.shape)}}else i(n,"image","image",e,t,o)}else if(r.OgcMapLayer&&n instanceof r.OgcMapLayer){var f=n;f.onActiveLayersChanged=function(e){e._client._capabilities?t._rebuildContainer():e.getCapabilities().then(function(e){e&&t._rebuildContainer()})};var y=e.defaultImage||{},h=s.activeLayers,v=f._client;if(v&&v._capabilities&&h){var b=v._capabilities.sublayers;b&&h.forEach(function(e){for(var t=0;t<b.length;t++)if("string"==typeof e&&e===b[t].id||e.id===b[t].id){var a=e.styles;a&&0<a.length&&a[0].legendUrl&&""!==a[0].legendUrl&&o.push({type:"image",url:a[0].legendUrl.replace(/\&amp;/g,"&"),subtitle:e.title||e.subtitle||b[t].id||"",footer:e.description||e.abstract||"",minZoom:e.minZoom,maxZoom:e.maxZoom,maxHeight:y.maxHeight,maxWidth:y.maxWidth})}})}}else r.SimpleDataLayer&&r.SimpleDataLayer}return o},C._parseStyle=function(e,t,a,o,n,r,i){if(e.getOptions){var l=C,s=e.getOptions(),c=s[t];if(!c&&s.iconOptions&&"image"===t&&"image"===a&&(c=s.iconOptions[t]),l._isExp(c)){var d=void 0;switch(c[0]){case"step":d=l._parseStep(e,c,a,o,n);break;case"match":d=l._parseMatch(e,c,a,o,n);break;case"interpolate":d=l._parseInterpolation(e,c,a,o)}if(d){switch(d.type){case"category":o.defaultCategory&&Object.assign(d,o.defaultCategory);break;case"gradient":if(i){var u=d;u.stops.forEach(function(e){e.label=void 0}),u.stops[0].label="low",u.stops[u.stops.length-1].label="high"}o.defaultGradient&&Object.assign(d,o.defaultGradient);break;case"image":o.defaultImage&&Object.assign(d,o.defaultImage)}return"number"==typeof s.minZoom&&(d.minZoom=s.minZoom),"number"==typeof s.maxZoom&&(d.maxZoom=s.maxZoom),d.cssClass=o.cssClass,r.push(d),d}}}},C._parseStep=function(e,t,a,o,n){if(5<=t.length&&t.length%2==1){var r=C,i=M.getString,l=[],s=t.length,c=t[2],d=n.getOptions().resx;if(("color"===a||"image"===a)&&"string"!=typeof c||"scale"===a&&"number"!=typeof c)return;var u=r._getValue(c,a,n);if(!u)return;var p=o.defaultCategory,m=void 0,g=void 0;p&&(m=p.numberFormat,g=p.numberFormatLocales);var f=i(t[3],d,g,m);u.label="<"+f,l.push(u);for(var y=3;y<s;y+=2){var h=r._getValue(t[y+1],a,n);if(!h)return;if(h.label=i(t[y],d,g,m),y===s-2)h.label=">"+f;else{var v=i(t[y+2],d,g,m);h.label=f+" - "+v,f=v}l.push(h)}return{type:"category",items:l,subtitle:o.subtitle||r._getSubtitle(o.subtitleFallback,t[1],e),footer:o.footer||r._getFooter(o.footerFallback,e),layout:"image"!==a?"column-reverse":"column",collapse:"color"===a}}},C._parseMatch=function(e,t,a,o,n){if(5<=t.length&&t.length%2==1){for(var r=C,i=[],l=2,s=t.length-1;l<s;l+=2){var c=r._getValue(t[l+1],a,n);if(!c)return;c.label=t[l],i.push(c)}var d=r._getValue(t[t.length-1],a,n);if(!stop)return;return d.label="no data",i.push(d),{type:"category",items:i,subtitle:o.subtitle||r._getSubtitle(o.subtitleFallback,t[1],e),footer:o.footer||r._getFooter(o.footerFallback,e),collapse:"color"===a}}},C._parseInterpolation=function(e,t,a,o){if(7<=t.length&&t.length%2==1){var n=C,r=o.subtitle||n._getSubtitle(o.subtitleFallback,t[2],e),i=o.footer||n._getFooter(o.footerFallback,e),l=t[3],s=t[t.length-2];if("color"===a){if(v=n._getInterpFn(t[1],l,s)){for(var c=[],d=-1,u=3,p=t.length;u<p;u+=2){var m=t[u];if("string"!=typeof(y=t[u+1]))return;var g=v(m);g-d<.05&&(m=void 0,d=g),c.push({offset:g,label:m,color:y})}return{type:"gradient",stops:c,subtitle:r,footer:i}}}else if("scale"===a){var f=[];for(u=3,p=t.length;u<p;u+=2){var y;if(m=t[u],"number"!=typeof(y=t[u+1]))return;f.push({shapeSize:0===y?.01:y,label:m})}if(7===t.length){var h=l+(s-l)/2,v=n._getInterpFn(t[1],l,s),b=t[4],_=t[6],x=v(h)*(_-b)+b;h=M.round(h,Math.max(M.decimalPlaces(l),M.decimalPlaces(s))+1),f.splice(f.length-1,0,{shapeSize:x,label:h})}return{type:"category",items:f,layout:"column-reverse",subtitle:r,footer:i,fitItems:!0}}}},C._parseInputGetter=function(e){if(Array.isArray(e)&&"get"===e[0]&&"string"==typeof e[1])return e[1]},C._getInterpFn=function(e,a,t){var o=e[0],n=t-a;if(0==n)return function(e){return 0};if("linear"===o)return function(e){return(e-a)/n};if("exponential"===o){var r=e[1];return function(e){var t=e-a;return(Math.pow(r,t)-1)/(Math.pow(r,n)-1)}}},C._isExp=function(e){return e&&Array.isArray(e)&&0<e.length&&"string"==typeof e[0]},C._overrideCategoryValue=function(e,t,a){e&&"category"===e.type&&!e[t]&&(e[t]=a)},C._getValue=function(e,t,a){var o,n="string"==typeof e;if("color"===t&&n)o={color:e};else if("scale"===t&&"number"==typeof e)o={shapeSize:0===e?.01:e};else if("image"===t&&n&&a._map){var r=this._getImage(a._map,e);r&&(o={shape:r})}return o},C._getImage=function(e,t){if(e&&"none"!==t){if(e.imageSprite.hasImage(t))return e.imageSprite.userImages.get(t).src;var a=void 0,o=void 0;if(t.startsWith("marker")?(a="marker",o=t.replace("marker-","")):t.startsWith("pin-round")?(a="pin-round",o=t.replace("pin-round-","")):t.startsWith("pin")&&(a="pin",o=t.replace("pin-","")),a&&(o={black:"#231f20",blue:"#1a73aa",darkblue:"#003963",red:"#ef4c4c",yellow:"#f2c851"}[o]))return _.getImageTemplate(a,1).replace(/{color}/g,o).replace(/{secondaryColor}/g,"#fff").replace(/{text}/g,"")}},C._getSubtitle=function(e,t,a){if("none"!==(e=e||"auto")){var o=a.metadata||{},n=a.getId();return"auto"===e?o.title||o.subtitle||n:"expression"===e?this._parseInputGetter(t)||n:o[e]||""}},C._getFooter=function(e,t){e=e||"auto";var a=t.metadata||{};return"auto"===e?a.footer||a.description||a.abstract||"":"none"!==e?a[e]||"":void 0},C);function C(){}var r,l=(t(u,r=_.internal.EventEmitter),u.prototype.onAdd=function(e,t){var a=this,o=(a._map=e).getStyle().language||d.getLanguage();o&&0<o.indexOf("-")&&(o=o.substring(0,o.indexOf("-")));var n=u._translations,r=n[o];r=r||n.en,a._localization=r,t&&(a._controlPosition=t.position);var i=document.createElement("div");i.classList.add("azure-maps-control-container"),a._cssClass&&i.classList.add(a._cssClass);var l=r[a._nameIdx];l&&i.setAttribute("aria-label",l),a._container=i;var s=e.getMapContainer().classList;if(s.contains("high-contrast-dark")?a._hclStyle="dark":s.contains("high-contrast-light")&&(a._hclStyle="light"),a._setStyle(a._baseOptions.style),a._rebuildContainer(),void 0!==a._baseOptions.visible){var c=a._baseOptions.visible?"":"none";i&&(i.style.display=c),a._content&&(a._content.style.display=c)}return a._controlWatcher=setInterval(a._checkControlCount,1e3),e.events.add("zoomend",a._mapZoomChanged),a._mapZoomChanged(null),i},u.prototype.onRemove=function(){var e=this;e._content&&(e._content.remove(),e._content=null),e._container&&(e._container.remove(),e._container=null),e._controlWatcher&&(clearInterval(e._controlWatcher),e._controlWatcher=null);var t=e._map;t&&(e._baseOptions.style.startsWith("auto")&&t.events.remove("styledata",e._mapStyleChanged),t.events.remove("zoomend",e._mapZoomChanged)),e._map=null},u.prototype.setOptions=function(e){e=e||{};var t=this,a=t._baseOptions,o=t._container,n=t._content,r=!1;if(void 0!==e.style&&(a.style=e.style,t._setStyle(e.style)),void 0!==e.zoomBehavior&&(a.zoomBehavior=e.zoomBehavior,t._needsRebuild=!0),void 0!==e.visible){a.visible=e.visible;var i=e.visible?"":"none";o&&(o.style.display=i),n&&(n.style.display=i),r=!0}void 0!==e.minimized&&a.minimized!==e.minimized&&(a.minimized=e.minimized,t._setBtnState()),void 0!==e.container&&(a.minimized=!1,t._setBtnState(),a.container=e.container,t._needsRebuild=!0),void 0!==e.layout&&a.layout!==e.layout&&(a.layout=e.layout,t._needsRebuild=!0),void 0!==e.showToggle&&a.showToggle!==e.showToggle&&(a.showToggle=e.showToggle,e.showToggle||(e.minimized=!1),t._setBtnState()),t._needsRebuild&&t._map?t._rebuildContainer():r&&t._mapZoomChanged(null)},u.prototype._addCard=function(e,t,a,o){var n,r=this,i=r._content,l=r._baseOptions.layout;if("carousel"===l?((n=document.createElement("button")).className="atlas-carousel-dot",t.appendChild(n)):"accordion"===l?((n=document.createElement("button")).className="atlas-accordion-button",n.innerHTML=o,i.appendChild(n)):r._baseOptions.layout="list",i.appendChild(e),n){var s=e.getAttribute("rel");n.setAttribute("rel",s),n.setAttribute("aria-label",o),n.setAttribute("title",o),n.setAttribute("aria-controls",e.id),n.onclick=r._handledClicked.bind(r),r._currentIdx===parseInt(s)?(e.style.display="",n.setAttribute("aria-expanded","true"),n.classList.add("active")):(n.setAttribute("aria-expanded","false"),e.style.display="none")}M.setZoomRangeAttr(a,r._baseOptions,e,n)},u.prototype._adjustSize=function(){var e=this,t=e._baseOptions,a=e._container;if(e._map){var o="unset",n="unset";if(!t.container){var r=e._map.getCanvasContainer().getClientRects()[0];o=r.width-20+"px";var i=r.height-20,l=e._controlPosition;if(l&&""!==l&&"non-fixed"!==l){var s=-1<l.indexOf("left")?"left":"right",c=0,d=e._map.controls.controlContainer.children;Array.from(d).forEach(function(e){-1<e.className.indexOf(s)&&(c+=e.children.length)}),1<c&&(c--,-1<l.indexOf("right")&&c++,i=Math.min(i,r.height-35*c-20))}Object.assign(a.style,{maxHeight:i+"px",maxWidth:o}),"accordion"===t.layout?(i=i-30*a.querySelectorAll(".atlas-accordion-button").length-20,n=i+"px"):"carousel"===t.layout&&(i=r.height-110,n=i+"px"),i<=40&&(n="unset"),a.querySelectorAll(".atlas-layer-legend-card").forEach(function(e){Object.assign(e.style,{maxHeight:n,maxWidth:o})})}}},u.prototype._setStyle=function(e){if(e){var t=this,a=t._map;a&&(e.startsWith("auto")&&!t._hclStyle?(a.events.add("styledata",t._mapStyleChanged),t._setColorFromMapStyle()):(a.events.remove("styledata",t._mapStyleChanged),t._setControlColor(e)))}},u.prototype._setColorFromMapStyle=function(){var e=this,t="light";if(-1<["satellite","satellite_road_labels","grayscale_dark","night","high_contrast_dark"].indexOf(e._map.getStyle().style))t="dark";else if(-1===["road","grayscale_light","road_shaded_relief","blank","blank_accessible","high_contrast_light"].indexOf(e._map.getStyle().style))for(var a=e._map.map.getStyle(),o=0;o<a.length;o++){var n=a[o];if("background"===n.type){n.paint&&"string"==typeof n.paint["background-color"]&&(t=M.getColorTheme(n.paint["background-color"]));break}}"auto-reverse"===e._baseOptions.style&&(t="light"===t?"dark":"light"),e._setControlColor(t)},u.prototype._setControlColor=function(e){var t=this;if(t._container||t._content){e=t._hclStyle||e;var a=t._darkColor,o="white",n=a;"light"===e||"dark"===e||e.startsWith("auto")?"dark"===e&&(o=a,n="white"):(o=e,n="dark"===(e=M.getColorTheme(e))?"white":a);var r={backgroundColor:o,color:n};t._content&&Object.assign(t._content.style,r),t._container&&Object.assign(t._container.style,r),t._btn&&(t._btn.style.backgroundColor=o),t._fontColor=n,t._bgColor=o}},u.prototype._setCardIdx=function(e,t){var a=this;if(a._content){var o=a._content.getElementsByClassName("atlas-layer-legend-card"),n=a._content.querySelectorAll(".atlas-carousel-dot, .atlas-accordion-button"),r=a._baseOptions.layout,i=o.length;0===n.length&&(n=null),i<=e&&(e=i-1),e<0&&"accordion"!==r&&(e=0),a._currentIdx=e;for(var l=0;l<i;l++){var s=o[l],c=parseInt(s.getAttribute("rel"));if("carousel"===r)c!==e?(s.style.display="none",n&&(n[l].classList.remove("atlas-carousel-dot-active"),n[l].setAttribute("aria-expanded","false"))):(s.style.display="block",n&&(n[l].classList.add("atlas-carousel-dot-active"),n[l].setAttribute("aria-expanded","true")),t&&a._setItemFocus(s));else if("accordion"===r)c!==e?(s.style.display="none",n&&(n[l].classList.remove("active"),n[l].setAttribute("aria-expanded","false"))):(s.style.display="block",n&&(n[l].classList.add("active"),n[l].setAttribute("aria-expanded","true")),t&&a._setItemFocus(s));else if(c===e){s.scrollIntoView(),t&&a._setItemFocus(s);break}}}},u.prototype._setItemFocus=function(e){var t=e.querySelectorAll("input, button, select, a");0<t.length&&t[0].focus()},u.prototype._setBtnState=function(){var e=this,t=e._btn,a=e._baseOptions;if(t&&!a.container){var o=e._btnCSS,n="32px",r="32px",i="none",l=!1,s=e._localization[e._nameIdx],c=a.minimized&&a.showToggle;c?s+=" - "+e._localization[2]:(l=a.showToggle,i="",n=r="unset"),t.setAttribute("aria-expanded",!c+"");var d=e._container;if(d){e._content&&a.visible&&(e._content.style.display=i),d.setAttribute("aria-expanded",!c+"");var u=d.classList;l?(u.contains(o)||u.add(o),t.style.display="",d.style.cursor=""):(u.remove(o),t.style.display="none",c&&(d.style.cursor="pointer")),d.setAttribute("title",s),d.setAttribute("alt",s),Object.assign(d.style,{height:r,width:n})}a.minimized!==c&&e._invokeEvent("toggled",{minimized:c,type:"toggled"})}},u._translations={en:["Legend control","Layer control","Expand","Collapse"],af:["Legende beheer","Laagbeheer","Uitbrei","Inval"],ar:["السيطرة على الأسطورة","التحكم في الطبقة","وسعت","انهيار"],eu:["Kondaira kontrol","Geruzaren kontrola","Hedatu","Erroiztu"],bg:["Контрол на легендата","Контрол на слоя","Разширяване","С колапс"],zh:["传说控制","层控制","扩张","坍塌"],hr:["Legenda kontrola","Kontrola sloja","Proširiti","Kolaps"],cs:["Kontrola legendy","Řízení vrstvy","Rozšířit","Kolaps"],da:["Legend Control.","Lagstyring","Udvide","Falde sammen"],nl:["Legend Control","Laagregeling","Uitbreiden","Instorten"],et:["Legendikontroll","Kihi juhtimine","Laiendama","Kollaps"],fi:["Legend Control","Kerrosohjaus","Laajentaa","Romahdus"],fr:["Lutte contre la légende","Contrôle de couche","Développer","Effondrer"],gl:["Control de lendas","Control de capa","Expandir.","Colapso"],de:["Legend Control.","Schichtregelung","Expandieren","Zusammenbruch"],el:["Έλεγχος θρύλου","Έλεγχος στρώματος","Επεκτείνουν","Κατάρρευση"],hi:["पौराणिक नियंत्रण","परत नियंत्रण","विस्तार करना","ढहने"],hu:["Legenda irányítás","Rétegszabályozás","Kiterjed","Összeomlás"],id:["Kontrol legenda","Kontrol lapisan","Mengembangkan","Jatuh"],it:["Controllo della legenda","Controllo del livello","Espandere","Crollo"],ja:["伝説のコントロール","レイヤコントロール","拡大","崩壊"],kk:["Аңызды бақылау","Қабатты бақылау","Кеңейту","Күйреу"],ko:["전설 제어","레이어 제어","확장하다","무너지다"],es:["Control de leyenda","Control de la capa","Expandir","Colapso"],lv:["Leģenda kontrole","Slāņa kontrole","Paplašināt","Sabrukums"],lt:["Legend Control.","Sluoksnio kontrolė","Išplėsti","Žlugimas"],ms:["Kawalan Legend.","Kawalan lapisan","Berkembang","Runtuh"],nb:["Legenden kontrollen","Lagkontroll","Utvide","Kollapse"],pl:["Kontrola legendy","Kontrola warstwy","Zwiększać","Zawalić się"],pt:["Controle da legenda","Controle de camada","Expandir","Colapso"],ro:["Controlul legendei","Controlul stratului","Extinde","Colaps"],ru:["Легендант контроля","Управление слоем","Расширять","Крах"],sr:["Контрола легенде","Контрола слоја","Проширити","Колапс"],sk:["Legenda","Ovládanie vrstvy","Rozbaľovať","Kolaps"],sl:["Legenda Control.","Kontrola plasti","Razširi","Spanje."],sv:["Legendkontroll","Lagkontroll","Bygga ut","Kollaps"],th:["การควบคุมตำนาน","การควบคุมเลเยอร์","ขยาย","ทรุด"],tr:["Efsane kontrolü","Katman kontrolü","Genişletmek","Yıkılmak"],uk:["Легенда контроль","Керування шаром","Розширювати","Розвал"],vi:["Kiểm soát huyền thoại","Lớp kiểm soát","Mở rộng","Sự sụp đổ"]},u);function u(e,t,a){var h=r.call(this)||this;h._needsRebuild=!1,h._rebuildOnStyleChange=!1,h._darkColor="#011c2c",h._baseOptions={layout:"carousel",style:"light",visible:!0,zoomBehavior:"hide",showToggle:!0,minimized:!1},h._currentIdx=0,h._hasZoomableContent=!1,h._btnRotation=0,h._controlCount=0,h._checkControlCount=function(){var e=h,t=e._map;if(t){var a=t.controls.getControls().length;e._controlCount!==a&&(e._controlCount=a,e._adjustSize())}},h._mapZoomChanged=function(e){var t=h,a=t._content,o=t._baseOptions;if(a)if(t._hasZoomableContent){for(var n=t._map.getCamera().zoom,r=void 0,i=a.querySelectorAll(".atlas-layer-legend-card"),l=a.querySelectorAll(".atlas-carousel-dot, .atlas-accordion-button"),s=0;s<i.length;s++){var c=i[s],d=parseInt(c.getAttribute("rel")),u=parseInt(c.getAttribute("data-min-zoom")),p=parseInt(c.getAttribute("data-max-zoom")),m=c.getAttribute("data-zoom-behavior"),g=u<=n&&Math.ceil(n)<=p,f=g?"":"none";"hide"===m&&("carousel"===o.layout||"accordion"===o.layout?0<l.length&&(l[s].style.display=f):c.style.display=f),!g||void 0!==r&&d!==t._currentIdx||(r=d);var y=c.querySelectorAll("label, option");M.processZoomRangeAttr(y,n)}"hide"===o.zoomBehavior&&(o.visible&&!o.minimized&&(a.style.display=void 0===r?"none":""),t._currentIdx!==r&&t._setItemIndex(r,!0))}else o.visible&&!o.minimized&&(a.style.display="")},h._rebuildContainer=function(){var e=h,t=e._baseOptions,a=e._container;e._createContent(),e._setStyle(t.style);var o=e._content;if(t.visible||(a.style.display="none",o.style.display="none"),!t.container){e._btn&&e._btn.remove();var n={display:t.showToggle?"":"none",backgroundColor:e._bgColor},r=90,i=e._controlPosition;i&&"non-fixed"!==i||(i="top-left");var l=-1<i.indexOf("left");r=-1<i.indexOf("top")?(n.bottom="0",l?180:270):(n.top="0",l?90:0),l?n.right="0":n.left="0",n.transform="rotate("+r+"deg)",e._btnRotation=r,a.onclick=e._contentBtnClicked;var s=document.createElement("button");s.setAttribute("type","button"),s.classList.add("atlas-layer-legend-expand-btn"),Object.assign(s.style,n),s.addEventListener("click",e._toggle),a.appendChild(s);var c=e._localization[e._nameIdx]+" - "+e._localization[3];s.setAttribute("title",c),s.setAttribute("alt",c),e._btn=s,e._setBtnState()}e._mapZoomChanged(null),e._adjustSize()},h._mapStyleChanged=function(){h._setColorFromMapStyle(),h._rebuildOnStyleChange&&h._rebuildContainer()},h._handledClicked=function(e){var t=h,a=e.target,o=parseInt(a.getAttribute("rel"));"accordion"===t._baseOptions.layout&&a.classList.contains("active")&&(o=-1),t._setItemIndex(o,!0)},h._toggle=function(e){var t=h,a=t._baseOptions;return a.minimized=!a.minimized,t._setBtnState(),e.stopPropagation(),e.preventDefault(),!1},h._contentBtnClicked=function(e){h._baseOptions.minimized&&h._toggle(e)};var o=h;return o._nameIdx=e,o._cssClass=t,o._btnCSS=a,h}var c,p=(t(m,c=l),m.prototype.getOptions=function(){return Object.assign({},this._options)},m.prototype.setOptions=function(n){n=n||{};var r=this,i=r._options;Object.keys(n).forEach(function(e){var t=n[e];if(void 0!==t)switch(e){case"style":case"visible":case"container":case"layout":case"zoomBehavior":i[e]=t;break;case"legends":var a=0;null!==(i[e]=t)&&r._currentLegend&&-1!==(a=t.indexOf(r._currentLegend))||(r._currentLegend=null,a=0),r._legendIdx=a;var o=!1;t.forEach(function(e){e.minZoom=M.getNumber(e,"minZoom",0,0),e.maxZoom=M.getNumber(e,"maxZoom",0,24),0===e.minZoom&&24===e.maxZoom&&"dynamic"!==e.type||(o=!0)}),r._hasZoomableContent=o,t&&r.setLegendIdx(a),r._needsRebuild=!0;break;default:i[e]=t,r._needsRebuild=!0}}),c.prototype.setOptions.call(this,n)},m.prototype.setLegendIdx=function(e,t){this._setItemIndex(e,t)},m.prototype.add=function(e,t,a){var o=this,n=o._getLegendIdx(e);-1===n?(o._options.legends.push(e),focus&&(o._legendIdx=o._options.legends.length-1,o._currentLegend=e),e.minZoom=M.getNumber(e,"minZoom",0,0),e.maxZoom=M.getNumber(e,"maxZoom",0,24),0===e.minZoom&&24===e.maxZoom||(o._hasZoomableContent=!0),a||o._rebuildContainer()):t&&o.setLegendIdx(n)},m.prototype.focus=function(e){var t=this._getLegendIdx(e);-1!==t&&this.setLegendIdx(t)},m.prototype.remove=function(e,t){var a=this,o=a._getLegendIdx(e),n=a._options.legends;-1<o&&n.length>o&&(a._legendIdx===o&&(1<n.length?(a._legendIdx=o-1,a._currentLegend=n[o-1]):(a._legendIdx=-1,a._currentLegend=null)),n.splice(o,1),t||a._rebuildContainer())},m.prototype.onAdd=function(e,t){return e.events.add("styledata",this._styleDataChanged),c.prototype.onAdd.call(this,e,t)},m.prototype.onRemove=function(){this._map&&this._map.events.remove("styledata",this._styleDataChanged),c.prototype.onRemove.call(this)},m.prototype._replaceMany=function(e,t){var a=this;e&&e.forEach(function(e){a.remove(e,!0)});var o=a._currentLegend,n=a._legendIdx;t&&t.forEach(function(e){a.add(e,!1,!0)}),-1<n&&o&&(a._currentLegend=o,a._legendIdx=n),a._rebuildContainer()},m.prototype._setItemIndex=function(e,t){var a=this;if(a._content){a._setCardIdx(e,t),e=a._currentIdx;var o=a._options.legends,n=void 0!==e&&o.length>e?o[e]:null;a._currentLegend=n,a._invokeEvent("legendfocused",{legendIdx:e,legend:n,type:"legendfocused"})}},m.prototype._getLegendIdx=function(e){return this._options.legends.indexOf(e)},m.prototype._createContent=function(){var n=this,e=n._options,t=e.resx||{},a=e.layout,r={};n._layerOptCache=r;var i=[];e.legends.forEach(function(e){if("dynamic"===e.type){var t=e,a=f.parse(t,n);if(a&&0<a.length){i=i.concat(a),a.forEach(function(e){0===e.minZoom&&24===e.maxZoom||(n._hasZoomableContent=!0)});var o=M.getLayer(t.layer,n._map);o.getOptions&&(r[o.getId()]=f.serializeLayerOptions(o))}}else i.push(e)}),n._content&&n._content.remove();var o=document.createElement("div");if(o.className="atlas-legend-control",n._content=o,M.addStringDiv(o,e.title,"atlas-legend-title",t,!0),i&&0<i.length){for(var l=document.createElement("div"),s=!(l.className="atlas-carousel-dot-container"),c=0;c<i.length;c++){var d=i[c];if(d){var u=M.uuid(),p=document.createElement("div");p.classList.add("atlas-layer-legend-card"),p.id=u,p.setAttribute("rel",c+"");var m=void 0;switch(m="accordion"===e.layout?M.getString(d.subtitle,t):M.addStringDiv(p,d.subtitle,"atlas-legend-subtitle",t,!0),d.type){case"category":n._createCategoryLegend(p,d,t);break;case"image":n._createImageLegend(p,d,t);break;case"html":n._createHtmlLegend(p,d);break;case"gradient":s=!0,n._createGradientLegend(p,d,t)}M.addStringDiv(p,d.footer,"atlas-legend-footer",t,!1,!0),n._addCard(p,l,d,m)}}n._rebuildOnStyleChange=s,"carousel"===a&&(1<l.children.length&&(M.addClearDiv(o),o.appendChild(l)),n.setLegendIdx(n._legendIdx))}var g=M.getElement(e.container);g?g.appendChild(o):n._container&&n._container.appendChild(o)},m.prototype._createCategoryLegend=function(e,g,f){if(g.items){var y=document.createElement("div");y.classList.add("atlas-legend-category-legend"),g.cssClass&&y.classList.add(g.cssClass),g.layout&&(y.style.flexDirection=g.layout);var h=g.fitItems&&g.layout&&g.layout.startsWith("row")&&g.itemLayout&&g.itemLayout.startsWith("column"),v=0;if(g.items.forEach(function(e){var t=document.createElement("div");t.classList.add("atlas-legend-category-item"),t.style.flexDirection=g.itemLayout?g.itemLayout:"row";var a,o,n=e.color||g.color||"transparent",r=e.shape||g.shape||"circle",i=M.getNumber2(e,g,"strokeWidth",0,1),l=M.getNumber2(e,g,"shapeSize",1,20),s=l-2*i,c=.5*l;switch(r){case"line":var d=.5*l;a='<line x1="0" y1="'+d+'" x2="'+l+'" y2="'+d+'" stroke="'+n+'" stroke-width="'+i+'" />';break;case"square":a='<rect x="'+i+'" y="'+i+'" height="'+s+'" width="'+s+'" fill="'+n+'" stroke-width="'+i+'"/>';break;case"triangle":a='<polygon points="'+i+" "+s+", "+s+" "+s+", "+.5*(s+i)+" "+i+'" fill="'+n+'" stroke-width="'+i+'"/>';break;case"circle":a='<circle cx="'+c+'" cy="'+c+'" r="'+(c-i)+'" fill="'+n+'" stroke-width="'+i+'"/>';break;default:o=/<svg/i.test(r)&&!/^data:/i.test(r)?"data:image/svg+xml;base64,"+window.btoa(r):r}v=Math.max(v,l);var u=document.createElement("div");a?u.innerHTML='<svg class="atlas-legend-category-shape" style="width:'+l+'px;" viewBox="0 0 '+l+" "+l+'" xmlns="http://www.w3.org/2000/svg">'+a+"</svg>":o&&(u.innerHTML='<img class="atlas-legend-category-shape" style="width:'+l+'px;" src="'+o+'"/>'),e.cssClass&&t.classList.add(e.cssClass),g.collapse&&(t.style.padding="0px"),t.appendChild(u),h&&(Object.assign(u.style,{position:"relative"}),Object.assign(u.firstChild.style,{position:"absolute",top:0,bottom:0,left:0,right:0}));var p=M.getString(e.label,f,g.numberFormatLocales,g.numberFormat),m=document.createElement("span");m.innerHTML=p,m.setAttribute("aria-label",p),g.labelsOverlapShapes&&Object.assign(m.style,{position:"absolute",left:0,right:0,textAlign:"center",margin:"0 auto"}),t.appendChild(m),y.appendChild(t)}),g.fitItems){var t=y.getElementsByClassName("atlas-legend-category-item"),a=v+"px",o={};h?o.height=a:o.width=a;var n=h||g.layout&&g.layout.startsWith("row")&&g.itemLayout&&g.itemLayout.startsWith("row");Array.prototype.forEach.call(t,function(e){n&&(o.width=e.firstChild.firstChild.style.width),Object.assign(e.firstChild.style,o)})}e.appendChild(y)}},m.prototype._createImageLegend=function(e,t,a){if(t.url){var o=document.createElement("div");o.classList.add("atlas-legend-image-legend"),t.cssClass&&o.classList.add(t.cssClass);var n=document.createElement("img"),r=M.getString(t.altText||t.subtitle,a);""!==r&&(n.setAttribute("alt",r),n.setAttribute("title",r)),n.onerror=function(){console.log("Unable to load legend image: "+t.url),o.remove()};var i=t.maxHeight,l=t.maxWidth;i&&0<i&&(n.style.maxWidth=i+"px"),l&&0<l&&(n.style.maxWidth=l+"px");var s=t.url;/<svg/i.test(s)&&!/^data:/i.test(s)&&(s="data:image/svg+xml;base64,"+window.btoa(s)),n.src=s,o.appendChild(n),e.appendChild(o)}},m.prototype._createHtmlLegend=function(e,t){if(t.html){var a=document.createElement("div");t.cssClass&&a.classList.add(t.cssClass),"string"==typeof t.html?a.innerHTML=t.html:a.appendChild(t.html),e.appendChild(a)}},m.prototype._createGradientLegend=function(e,n,r){if(n.stops&&0<n.stops.length){var t=document.createElement("div");t.classList.add("atlas-legend-gradient-legend"),n.cssClass&&t.classList.add(n.cssClass);var a=this._fontColor,o=M.getNumber,i="vertical"===n.orientation,l=o(n,"fontSize",1,12),s=n.fontFamily||"'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif";s=s.replace(/"/g,"'");var c=o(n,"barThickness",1,20),d=o(n,"barLength",1,200),u=o(n,"tickSize",0,5),p=[],m=[],g=[],f=void 0,y=void 0,h=void 0,v=void 0,b=void 0,_=void 0,x=void 0,C=void 0;if(n.stops.sort(function(e,t){return e.offset-t.offset}),i){b='x1="0%" y1="0%" x2="0%" y2="100%" gradientTransform="rotate(180,0.5,0.5)"',_="fill:"+a+";font-size:"+l+"px;font-family:"+s+';text-align:center;text-anchor:start;dominant-baseline:middle;"',C=d;var L=0,k=(x=c)+3,S=k+u,O=S+3;0<u&&m.push('<line x1="'+k+'" y1="0" x2="'+k+'" y2="'+d+'" />'),n.stops.forEach(function(e){var t=e.color||"black";p.push('<stop offset="'+100*e.offset+'%" stop-color="'+t+'" />');var a=M.getString(e.label,r,n.numberFormatLocales,n.numberFormat);if(a&&""!==a){var o=d*(1-e.offset);0===e.offset?--o:1===e.offset&&(o+=1),0<u&&m.push('<line x1="'+k+'" y1="'+o+'" x2="'+S+'" y2="'+o+'" />'),g.push('<text x="'+O+'" y="'+o+'">'+a+"</text>"),L=Math.max(M.measureText(a,l,s).width,L)}}),y=f=Math.ceil(O+L),v=(h=d)+l}else{b='x1="0%" y1="0%" x2="100%" y2="0%"',_="fill:"+a+";font-size:"+l+"px;font-family:"+s+";text-align:center;text-anchor:middle;dominant-baseline:hanging;",x=d;var E=0,w=(C=c)+3,I=w+u,Z=I+3;0<u&&m.push('<line x1="0" y1="'+w+'" x2="'+d+'" y2="'+w+'" />'),n.stops.forEach(function(e){var t=e.color||"black";p.push('<stop offset="'+100*e.offset+'%" stop-color="'+t+'" />');var a=M.getString(e.label,r,n.numberFormatLocales,n.numberFormat);if(a&&""!==a){var o=d*e.offset;1===e.offset?--o:0===e.offset&&(o+=1),0<u&&m.push('<line x1="'+o+'" y1="'+w+'" x2="'+o+'" y2="'+I+'" />'),g.push('<text x="'+o+'" y="'+Z+'">'+a+"</text>"),E=Math.max(M.measureText(a,l,s).width,E)}}),y=E+(f=d),v=h=Z+(0<g.length?1.33*l:0)}var A=M.uuid(),z='\n                <svg width="'+y+'" height="'+v+'" viewBox="0 0 '+f+" "+h+'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n                    <defs>                    \n                        <pattern id="atlas-pattern-'+A+'" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">\n                            <rect x="0" y="0" width="10" height="10" fill="white"/>\n                            <rect x="0" y="0" width="5" height="5" fill="#ccc"/>\n                            <rect x="5" y="5" width="5" height="5" fill="#ccc"/>\n                        </pattern>\n\n                        <linearGradient id="atlas-gradient-'+A+'" '+b+">"+p.join("")+'</linearGradient>\n                    </defs>\n\n                    <rect x="0" y="0" width="'+x+'" height="'+C+'" fill="url(\'#atlas-pattern-'+A+'\')" />  \n                    <rect x="0" y="0" width="'+x+'" height="'+C+'" fill="url(\'#atlas-gradient-'+A+'\')" />\n\n                    <g style="stroke:'+a+';stroke-width:2;">'+m.join("")+'</g>\n\n                    <g style="'+_+'">'+g.join("")+"</g>\n                </svg>\n                ";t.innerHTML=z,e.appendChild(t)}},m);function m(e){var t=c.call(this,0,"atlas-legend-control-container","atlas-legend-btn")||this;return t._options={resx:{},layout:"carousel",style:"light",visible:!0,legends:[],zoomBehavior:"hide",showToggle:!0,minimized:!1},t._legendIdx=0,t._currentLegend=null,t._layerOptCache={},t._styleDataChanged=function(){var e=t,a=e._layerOptCache,o=e._map,n=!1;Object.keys(a).forEach(function(e){var t=o.layers.getLayerById(e);a[e]!==f.serializeLayerOptions(t)&&(n=!0)}),n&&e._rebuildContainer()},t.setOptions(e),t}var g,y=(t(h,g=l),h.prototype.getOptions=function(){return this._options},h.prototype.setOptions=function(a){a=a||{};var o=this,n=o._options;Object.keys(a).forEach(function(e){var t=a[e];if(void 0!==t)switch(e){case"style":case"visible":case"container":case"layout":case"zoomBehavior":n[e]=t;break;default:n[e]=t,o._needsRebuild=!0}}),g.prototype.setOptions.call(this,a)},h.prototype.onAdd=function(e,t){return e.events.add("layeradded",this._layerChanged),e.events.add("layerremoved",this._layerChanged),g.prototype.onAdd.call(this,e,t)},h.prototype.onRemove=function(){var e=this._map;return e&&(e.events.remove("layeradded",this._layerChanged),e.events.remove("layerremoved",this._layerChanged)),g.prototype.onRemove.call(this)},h.prototype.refresh=function(){this._rebuildContainer()},h.prototype._setItemIndex=function(e,t){this._setCardIdx(e,t)},h.prototype._createContent=function(){var d=this,u=d._options,p=u.resx||{},m=u.layout,g=!1,f=u.layerGroups?u.layerGroups.map(function(e){return e}):[],e=u.dynamicLayerGroup;if(e){var t=d._getLayerGroup(e);if(t){g=!0;var a=e.layerGroupIdx;if(("number"!=typeof a||a<0||a>f.length)&&(a=0),f.splice(a,0,t),u.legendControl){var o=[];t.items.forEach(function(e){e.layers&&e.layers.forEach(function(e){o.push({type:"dynamic",layer:e})})}),u.legendControl._replaceMany(d._dynamicLegends,o),d._dynamicLegends=o}}}d._content&&d._content.remove();var n=document.createElement("div");if(n.className="atlas-layer-control",d._content=n,M.addStringDiv(n,u.title,"atlas-layer-title",p,!0),f&&0<f.length){var y=document.createElement("div");y.className="atlas-carousel-dot-container";for(var r=function(e){var t=M.uuid(),o=f[e],a=M.getZoomRange(d._getAllAzLayers(null,o));o.minZoom=M.getNumber2(o,a,"minZoom",0,0),o.maxZoom=M.getNumber2(o,a,"maxZoom",0,24),0===o.minZoom&&24===o.maxZoom||(g=!0),o.items&&o.items.forEach(function(e){var t=d._getAllAzLayers(e,o);d._inflateLayerStateStyles(e,t);var a=M.getZoomRange(t);e.minZoom=Math.max(M.getNumber2(e,a,"minZoom",0,0),o.minZoom),e.maxZoom=Math.min(M.getNumber2(e,a,"maxZoom",0,24),o.maxZoom),0!==e.minZoom&&24!==e.maxZoom&&(g=!0)});var n=document.createElement("div");n.classList.add("atlas-layer-legend-card"),n.id=t,o.cssClass&&n.classList.add(o.cssClass),n.setAttribute("rel",e+"");var r=void 0;if(r="accordion"===m?M.getString(o.groupTitle,p):M.addStringDiv(n,o.groupTitle,"atlas-layer-group-title",p,!0),o.legends&&u.legendControl)for(var i=0;i<o.legends.length;i++){var l=o.legends[i];l.minZoom=M.getNumber2(l,o,"minZoom",0,0),l.maxZoom=M.getNumber2(l,o,"maxZoom",0,24),u.legendControl.add(l,0===i)}var s=o.layout||"checkbox",c=void 0;switch(s){case"dropdown":c=d._createDropdown(o,r);break;case"checkbox":case"radio":c=d._createChoiceGroup(s,o);break;case"range":c=d._createRange(o)}c&&n.appendChild(c),d._addCard(n,y,o,r)},i=0;i<f.length;i++)r(i);d._hasZoomableContent=g,"carousel"===m&&(1<y.children.length&&(M.addClearDiv(n),n.appendChild(y)),d._setCardIdx(0))}var l=M.getElement(u.container);l?l.appendChild(n):d._container&&d._container.appendChild(n)},h.prototype._bindLayerState=function(e,t,a,o){var n=this,r=n._getAllAzLayers(e,t),i=n._itemChanged.bind(n,e,r,t,a,!0);a instanceof HTMLOptionElement?a.parentElement.addEventListener("change",i):(a.onchange=i,o&&(a.oninput=i)),n._itemChanged(e,r,t,a,!1)},h.prototype._createDropdown=function(a,e){var o=this,n=document.createElement("select");return n.className="atlas-layer-dropdown",n.title=e,a.items&&(n.name=M.uuid(),a.items.forEach(function(e){var t=document.createElement("option");e.label&&(t.innerHTML=M.getString(e.label,o._options.resx)),e.enabled&&(t.selected=!0),M.setZoomRangeAttr(e,o._baseOptions,t),n.appendChild(t),o._bindLayerState(e,a,t)})),n},h.prototype._createChoiceGroup=function(n,r){var i=this,l=document.createElement("div");if(r.items){var e=r.items,s=M.uuid();e.forEach(function(e){var t=document.createElement("label");t.className="atlas-layer-"+n;var a=document.createElement("input");"radio"===(a.type=n)&&(a.name=s),a.checked=e.enabled,t.appendChild(a);var o=document.createElement("span");o.innerHTML=M.getString(e.label,i._options.resx),t.appendChild(o),i._bindLayerState(e,r,a),M.setZoomRangeAttr(e,i._baseOptions,t),l.appendChild(t)})}return l},h.prototype._createRange=function(d){var u=this,p=document.createElement("div");if(d.items){var e=d.items,m=M.getNumber,g=M.measureText,f="{rangeValue}";e.forEach(function(e){var t=document.createElement("label");t.className="atlas-layer-range";var a=document.createElement("input");a.type="range";var o=m(e,"min",0,0),n=m(e,"max",0,1),r=m(e,"step",0,.1),i=m(e,"value",0,1);a.setAttribute("min",o+""),a.setAttribute("max",n+""),a.setAttribute("step",r+""),a.value=i+"",t.appendChild(a);var l=document.createElement("span"),s=e.label?M.getString(e.label,u._options.resx):f,c=new Intl.NumberFormat(void 0,e.numberFormat||{});l.innerHTML=s.replace(f,c.format(i)),l.style.minWidth=Math.max(g(s.replace(f,c.format(i)),12,"Arial").width,g(s.replace(f,c.format(o)),12,"Arial").width,g(s.replace(f,c.format(n)),12,"Arial").width,g(s.replace(f,c.format(n-r)),12,"Arial").width)+"px",t.appendChild(l),M.setZoomRangeAttr(e,u._baseOptions,t),u._bindLayerState(e,d,a,e.updateOnInput),p.appendChild(t)})}return p},h.prototype._updateStateCache=function(e,t,a){var o=this,n=o._options.legendControl;if(a instanceof HTMLInputElement&&"radio"===a.type||a instanceof HTMLSelectElement){var r=e,i=o._stateCache[a.name];if(i&&i!==e){i.enabled=!r.enabled;var l=i.enabled?i.enabledStyle:i.disabledStyle;if(l&&i.layers&&i.layers.forEach(function(e){return o._setLayerStyle(e,l)}),n&&i.legends&&i.legends.forEach(function(e){n.remove(e)}),r.enabled)return o._stateCache[a.name]=r,i}else!i&&r.enabled&&(o._stateCache[a.name]=r)}return null},h.prototype._inflateLayerStateStyles=function(e,t){e.enabledStyle&&this._inflateStyle(e.enabledStyle,t),e.disabledStyle&&this._inflateStyle(e.disabledStyle,t),e.style&&this._inflateStyle(e.style,t)},h.prototype._inflateStyle=function(t,e){if(t){var a={},o=Object.keys(t),n=!1,r=!1;e.forEach(function(e){e instanceof _.layer.BubbleLayer?n=!0:e instanceof _.layer.LineLayer&&(r=!0)}),o.forEach(function(e){switch(e){case"color":t.fillColor||(a.fillColor=t.color);break;case"fillColor":t.color||(a.color=t.fillColor),!r||n||t.strokeColor||(a.strokeColor=t.fillColor);break;case"opacity":t.fillOpacity||(a.fillOpacity=t.opacity);break;case"fillOpacity":t.opacity||(a.opacity=t.fillOpacity),!r||n||t.strokeOpacity||(a.strokeOpacity=t.strokeOpacity)}}),Object.assign(t,a)}},h.prototype._setLayerStyle=function(e,t){if(e&&(e=M.getLayer(e,this._map)).setOptions){var a=t;e instanceof _.layer.LineLayer&&(!t.strokeColor&&t.color&&(a=Object.assign({strokeColor:t.color},a)),!t.strokeOpacity&&t.opacity&&(a=Object.assign({strokeOpacity:t.opacity},a))),e.setOptions(a)}},h.prototype._getAllAzLayers=function(e,t){var a=this._map,o=[];return a&&(t&&t.layers&&t.layers.forEach(function(e){var t=M.getLayer(e,a);t&&o.push(t)}),e?e.layers&&e.layers.forEach(function(e){var t=M.getLayer(e,a);-1===o.indexOf(t)&&o.push(t)}):t.items.forEach(function(e){e.layers&&e.layers.forEach(function(e){var t=M.getLayer(e,a);-1===o.indexOf(t)&&o.push(t)})})),o},h.prototype._getLayerGroup=function(e){if(e.layout){var g=this,f={cssClass:e.cssClass,groupTitle:e.groupTitle,legends:e.legends,items:[],layout:e.layout||"checkbox"},t=M.getMapLayers(g._map,e.layerFilter),y=e.labelProperty;if(t&&0<t.length){var h=!1;return t.forEach(function(e){var t=e.getOptions?e.getOptions():{},a=t.visible;void 0===a&&(a=!0),"dropdown"!==f.layout&&"radio"!==f.layout||(h?(a=!1,e.setOptions&&e.setOptions({visible:!1})):a&&(h=!0));var o=M.getString(y&&e.metadata&&e.metadata[y]&&""!==e.metadata[y]?e.metadata[y]:e.getId(),g._options.resx),n=_.layer.OgcMapLayer,r=_.layer.SimpleDataLayer;if(e.getId()===o&&-1<o.indexOf("-"))if(n&&e instanceof n){var i=e,l=i._client;if(l&&l._capabilities){var s=l._capabilities;if(s.title&&""!==s.title&&"wms"===s.title.toLowerCase())o=s.title;else{var c=i.getOptions().activeLayers,d=s.sublayers;if(1===c.length&&d)for(var u=c[0],p=0;p<d.length;p++)if("string"==typeof u&&u===d[p].id||u.id===d[p].id){var m=u.styles;m&&0<m.length&&m[0].legendUrl&&""!==m[0].legendUrl&&(o=u.title||u.subtitle||d[p].id||"")}}}else i.getCapabilities().then(function(e){e&&g._rebuildContainer()})}else r&&e instanceof r&&e.metadata&&(o=e.metadata.title||e.metadata.name||"");f.items.push({layers:[e],label:o,enabled:a,enabledStyle:{visible:!0},disabledStyle:{visible:!1},minZoom:M.getNumber(t,"minZoom",0,0),maxZoom:M.getNumber(t,"maxZoom",0,24)})}),h||"dropdown"!==f.layout&&"radio"!==f.layout||(f.items[0].enabled=!0,t[0].setOptions&&t[0].setOptions({visible:!0})),f}}},h);function h(e){var v=g.call(this,1,"atlas-layer-control-container","atlas-layer-btn")||this;return v._options={resx:{},layout:"list",style:"light",visible:!0,zoomBehavior:"disable",showToggle:!0,minimized:!1},v._stateCache={},v._layerChanged=function(e){v._rebuildContainer()},v._itemChanged=function(e,t,a,o,n){if(t){var r=v,i=r._options.legendControl;if(o instanceof HTMLInputElement&&"range"===o.type){var l=e,s=parseFloat(o.value),c=l.style;if(c){var d=(e.label?M.getString(e.label,r._options.resx):"{rangeValue}").replace("{rangeValue}",new Intl.NumberFormat(void 0,l.numberFormat||{}).format(s));o.parentElement.children[1].innerHTML=d;var u=M.replacePlaceholder(c,"{rangeValue}",s,!0);t.forEach(function(e){return r._setLayerStyle(e,u)})}l.value=s}else{var p=void 0!==o.checked?o.checked:o.selected;void 0===p&&(p=!1),o instanceof HTMLOptionElement&&(p=o.parentElement.selectedOptions[0]===o);l=e;var m=p?l.enabledStyle:l.disabledStyle||{};if(m&&t.forEach(function(e){return r._setLayerStyle(e,m)}),l.legends&&i)for(var g=0;g<l.legends.length;g++){var f=l.legends[g];p?(f.minZoom=M.getNumber2(f,l,"minZoom",0,0),f.maxZoom=M.getNumber2(f,l,"maxZoom",0,24),i.add(f,0===g&&n)):i.remove(f)}l.enabled=p;var y=r._options.legendControl;"boolean"==typeof m.visible&&y&&y._rebuildContainer()}var h=r._updateStateCache(e,t,o instanceof HTMLOptionElement?o.parentElement:o);r._invokeEvent("statechanged",{type:"statechanged",layerGroup:a,oldState:h,newState:e})}},v.setOptions(Object.assign({},v._options,e)),v}var v=Object.freeze({__proto__:null,LegendControl:p,LayerControl:y}),b=a.merge("atlas.control",v);e.control=b}(this.atlas=this.atlas||{},atlas);
class VideoRTC extends HTMLElement {
  constructor() {
    super();

    this.DISCONNECT_TIMEOUT = 5000;
    this.RECONNECT_TIMEOUT = 30000;

    this.CODECS = [];

    this.BASE_URL;

    this.supportsHwDecoding = true;

    this.cameraId = "";

    /**
     * [config] Authentication token.
     * @type {string}
     */
    this.authentication = ''

    /**
     * [config] Supported modes (webrtc, mse, mp4, mjpeg).
     * @type {string}
     */
    this.mode = "webrtc,mse,mp4,mjpeg";

    /**
     * [config] Run stream when not displayed on the screen. Default `false`.
     * @type {boolean}
     */
    this.background = false;

    /**
     * [config] Run stream only when player in the viewport. Stop when user scroll out player.
     * Value is percentage of visibility from `0` (not visible) to `1` (full visible).
     * Default `0` - disable;
     * @type {number}
     */
    this.visibilityThreshold = 0;

    /**
     * [config] Run stream only when browser page on the screen. Stop when user change browser
     * tab or minimise browser windows.
     * @type {boolean}
     */
    this.visibilityCheck = true;

    /**
     * [config] WebRTC configuration
     * @type {RTCConfiguration}
     */
    this.pcConfig = {
      iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
      sdpSemantics: "unified-plan", // important for Chromecast 1
    };

    /**
     * [info] WebSocket connection state. Values: CONNECTING, OPEN, CLOSED
     * @type {number}
     */
    this.wsState = WebSocket.CLOSED;

    /**
     * [info] WebRTC connection state.
     * @type {number}
     */
    this.pcState = WebSocket.CLOSED;

    /**
     * [info] Error status.
     * @type {string}
     */
    this.error = null;

    /**
     * @type {HTMLVideoElement}
     */
    this.video = null;

    /**
     * @type {WebSocket}
     */
    this.ws = null;

    /**
     * @type {string|URL}
     */
    this.wsURL = "";

    /**
     * @type {RTCPeerConnection}
     */
    this.pc = null;

    /**
     * @type {number}
     */
    this.connectTS = 0;

    /**
     * @type {string}
     */
    this.mseCodecs = "";
    /**

     * [internal] Disconnect TimeoutID.
     * @type {number}
     */
    this.disconnectTID = 0;

    /**
     * [internal] Reconnect TimeoutID.
     * @type {number}
     */
    this.reconnectTID = 0;

    /**
     * [internal] Handler for receiving Binary from WebSocket.
     * @type {Function}
     */
    this.ondata = null;

    /**
     * [internal] Handlers list for receiving JSON from WebSocket
     * @type {Object.<string,Function>}}
     */
    this.onmessage = null;
  }

  /**
   * Set video source (WebSocket URL). Support relative path.
   * @param {string|URL} value
   */
  set src(value) {
    if (typeof value !== "string") value = value.toString();
    if (value.startsWith("http")) {
      value = `ws${value.substring(4)}`;
    } else if (value.startsWith("/")) {
      value = `ws${location.origin.substring(4)}${value}`;
    }

    this.wsURL = value;

    this.onconnect();
  }

  /**
   * Set video source (Camera).
   * @param {string} value
   */
  set camera(value) {
    this.wsURL = `${this.BASE_URL.replace(/^http/, "ws")}/ws?src=${value}&Authorization=Bearer ${this.authentication}`;
    this.onconnect();
  }

  /**
   * Play video. Support automute when autoplay blocked.
   * https://developer.chrome.com/blog/autoplay/
   */
  play() {
    this.video.play().catch((er) => {
      if (er.name === "NotAllowedError" && !this.video.muted) {
        this.video.muted = true;
        this.video.play().catch(() => { });
      }
    });
  }

  /**
   * Send message to server via WebSocket
   * @param {Object} value
   */
  send(value) {
    if (this.ws) this.ws.send(JSON.stringify(value));
  }

  /** @param {Function} isSupported */
  codecs(isSupported) {
    return this.CODECS.filter((codec) => isSupported(`video/mp4; codecs="${codec}"`)).join();
  }

  /**
   * `CustomElement`. Invoked each time the custom element is appended into a
   * document-connected element.
   */
  connectedCallback() {
    if (this.disconnectTID) {
      clearTimeout(this.disconnectTID);
      this.disconnectTID = 0;
    }

    // because video autopause on disconnected from DOM
    if (this.video) {
      const seek = this.video.seekable;
      if (seek.length > 0) {
        this.video.currentTime = seek.end(seek.length - 1);
      }
      this.play();
    } else {
      this.oninit();
    }

    this.onconnect();
  }

  /**
   * `CustomElement`. Invoked each time the custom element is disconnected from the
   * document's DOM.
   */
  disconnectedCallback() {
    if (this.background || this.disconnectTID) return;
    if (this.wsState === WebSocket.CLOSED && this.pcState === WebSocket.CLOSED)
      return;

    this.disconnectTID = setTimeout(() => {
      if (this.reconnectTID) {
        clearTimeout(this.reconnectTID);
        this.reconnectTID = 0;
      }

      this.disconnectTID = 0;

      this.ondisconnect();
    }, this.DISCONNECT_TIMEOUT);
  }

  /**
   * Creates child DOM elements. Called automatically once on `connectedCallback`.
   */
  oninit() {
    this.video = document.createElement("video");
    this.video.controls = false;
    this.video.id = this.cameraId;
    this.video.playsInline = true;
    this.video.preload = "auto";
    this.video.muted = true;

    this.video.style.display = "block"; // fix bottom margin 4px
    this.video.style.width = "100%";
    this.video.style.height = "100%";
    this.video.style.objectFit = "fill";

    this.appendChild(this.video);
    this.style.display = "block"; // Needed for resize observer to change substreams
    this.style.height = "100%"; // fix bottom margin 4px
    this.style.position = "relative";

    if (this.background) return;

    if ("hidden" in document && this.visibilityCheck) {
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          this.disconnectedCallback();
        } else if (this.isConnected) {
          this.connectedCallback();
        }
      });
    }

    if ("IntersectionObserver" in window && this.visibilityThreshold) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              this.disconnectedCallback();
            } else if (this.isConnected) {
              this.connectedCallback();
            }
          });
        },
        { threshold: this.visibilityThreshold }
      );
      observer.observe(this);
    }
  }

  /**
   * Connect to WebSocket. Called automatically on `connectedCallback`.
   * @return {boolean} true if the connection has started.
   */
  onconnect() {
    if (!this.isConnected || !this.wsURL || this.ws || this.pc) return false;

    // CLOSED or CONNECTING => CONNECTING
    this.wsState = WebSocket.CONNECTING;
    this.dispatchCustomEvent("CONNECTING");

    this.connectTS = Date.now();

    this.ws = new WebSocket(this.wsURL);
    this.ws.binaryType = "arraybuffer";

    document.getElementById('errorDiv')?.remove();

    // Error handling
    this.ws.addEventListener("message", (message) => {
      if (typeof message.data == "string" && JSON.parse(message.data).type === "error") {
        this.error = JSON.parse(message.data).value;
        // console.log("Stream Error", this.error);
        

        if (this.error.indexOf("streams: codecs not matched:") >= 0) {
          this.supportsHwDecoding = false;

          // this.video.insertAdjacentHTML("afterend", `
          //   <div style='height: 100%;width: 100%;position: absolute;top: 0;color: #000;display: grid;align-items: center;text-align: center;font-size: 40%;padding: 3rem;'>
          //   </div>`
          // );
        } else {
          const detail = { message: "Error desconocido, contacte soporte", raw: this.error ?? null };
          window.dispatchEvent(new CustomEvent('mseplayer-error', { detail }));
          this.video.insertAdjacentHTML("afterend", `<div id="errorDiv" style='position: absolute;top: 0;color: #FFF;'>Error desconocido contacte soporte</div>`);
        }

        this.ondisconnect();
      }
    });

    this.ws.addEventListener("open", this.onopen.bind(this));
    this.ws.addEventListener("close", this.onclose.bind(this));


    return true;
  }

  ondisconnect() {
    this.wsState = WebSocket.CLOSED;
    if (this.ws) {
      this.ws.close();
      this.ws.removeEventListener("open", this.onopen)
      this.ws.removeEventListener("close", this.onclose)
      this.ws = null;
    }

    this.pcState = WebSocket.CLOSED;
    if (this.pc) {
      this.pc.close();
      this.pc = null;
    }

    this.dispatchCustomEvent("CLOSED");

  }

  /**
   * @returns {Array.<string>} of modes (mse, webrtc, etc.)
   */
  onopen() {
    // CONNECTING => OPEN
    this.wsState = WebSocket.OPEN;
    this.dispatchCustomEvent("OPEN");

    this.ws.addEventListener("message", (ev) => {
      if (typeof ev.data === "string") {
        const msg = JSON.parse(ev.data);
        for (const mode in this.onmessage) {
          this.onmessage[mode](msg);
        }
      } else {
        this.ondata(ev.data);
      }
    });

    this.ondata = null;
    this.onmessage = {};

    const modes = [];

    if (
      this.mode.indexOf("mse") >= 0 &&
      ("MediaSource" in window || "ManagedMediaSource" in window)
    ) {
      // iPhone
      modes.push("mse");
      this.onmse();
    } else if (this.mode.indexOf("mp4") >= 0) {
      modes.push("mp4");
      this.onmp4();
    }

    if (this.mode.indexOf("webrtc") >= 0 && "RTCPeerConnection" in window) {
      // macOS Desktop app
      modes.push("webrtc");
      this.onwebrtc();
    }

    if (this.mode.indexOf("mjpeg") >= 0) {
      if (modes.length) {
        this.onmessage["mjpeg"] = (msg) => {
          if (msg.type !== "error" || msg.value.indexOf(modes[0]) !== 0) return;
          this.onmjpeg();
        };
      } else {
        modes.push("mjpeg");
        this.onmjpeg();
      }
    }

    return modes;
  }

  /**
   * @return {boolean} true if reconnection has started.
   */
  onclose() {
    if (this.wsState === WebSocket.CLOSED) return false;

    // CONNECTING, OPEN => CONNECTING
    this.wsState = WebSocket.CONNECTING;
    this.dispatchCustomEvent("CONNECTING");
    this.ws = null;


    // reconnect no more than once every X seconds
    const delay = Math.max(
      this.RECONNECT_TIMEOUT - (Date.now() - this.connectTS),
      0
    );

    this.reconnectTID = setTimeout(() => {
      this.reconnectTID = 0;
      this.onconnect();
    }, delay);

    return true;
  }

  onmse() {
    /** @type {MediaSource} */
    let ms;

    if ("ManagedMediaSource" in window) {
      const MediaSource = window.ManagedMediaSource;

      ms = new MediaSource();
      ms.addEventListener(
        "sourceopen",
        () => {
          this.send({
            type: "mse",
            value: this.codecs(MediaSource.isTypeSupported),
          });
        },
        { once: true }
      );

      this.video.disableRemotePlayback = true;
      this.video.srcObject = ms;
    } else {
      ms = new MediaSource();
      ms.addEventListener(
        "sourceopen",
        () => {
          URL.revokeObjectURL(this.video.src);
          this.send({
            type: "mse",
            value: this.codecs(MediaSource.isTypeSupported),
          });
        },
        { once: true }
      );

      this.video.src = URL.createObjectURL(ms);
      this.video.srcObject = null;
    }
    this.play();

    this.mseCodecs = "";

    this.onmessage["mse"] = (msg) => {
      if (msg.type !== "mse") return;

      this.mseCodecs = msg.value;

      const sb = ms.addSourceBuffer(msg.value);
      sb.mode = "segments"; // segments or sequence
      sb.addEventListener("updateend", () => {
        if (sb.updating) return;

        try {
          if (bufLen > 0) {
            const data = buf.slice(0, bufLen);
            bufLen = 0;
            sb.appendBuffer(data);
          } else if (sb.buffered && sb.buffered.length) {
            const end = sb.buffered.end(sb.buffered.length - 1) - 15;
            const start = sb.buffered.start(0);
            if (end > start) {
              sb.remove(start, end);
              ms.setLiveSeekableRange(end, end + 15);
            }
            // console.debug("VideoRTC.buffered", start, end);
          }
        } catch (e) {
          // console.debug(e);
        }
      });

      const buf = new Uint8Array(2 * 1024 * 1024);
      let bufLen = 0;

      this.ondata = (data) => {
        if (sb.updating || bufLen > 0) {
          const b = new Uint8Array(data);
          buf.set(b, bufLen);
          bufLen += b.byteLength;
          // console.debug("VideoRTC.buffer", b.byteLength, bufLen);
        } else {
          try {
            sb.appendBuffer(data);
          } catch (e) {
            // console.debug(e);
          }
        }
      };
    };
  }

  onwebrtc() {
    const pc = new RTCPeerConnection(this.pcConfig);

    /** @type {HTMLVideoElement} */
    const video2 = document.createElement("video");
    video2.addEventListener("loadeddata", (ev) => this.onpcvideo(ev), {
      once: true,
    });

    pc.addEventListener("icecandidate", (ev) => {
      const candidate = ev.candidate ? ev.candidate.toJSON().candidate : "";
      this.send({ type: "webrtc/candidate", value: candidate });
    });

    pc.addEventListener("track", (ev) => {
      // when stream already init
      if (video2.srcObject !== null) return;

      // when audio track not exist in Chrome
      if (ev.streams.length === 0) return;

      // when audio track not exist in Firefox
      if (ev.streams[0].id[0] === "{") return;

      video2.srcObject = ev.streams[0];
    });

    pc.addEventListener("connectionstatechange", () => {
      if (
        pc.connectionState === "failed" ||
        pc.connectionState === "disconnected"
      ) {
        pc.close(); // stop next events

        this.pcState = WebSocket.CLOSED;
        this.pc = null;

        this.onconnect();
      }
    });

    this.onmessage["webrtc"] = (msg) => {
      switch (msg.type) {
        case "webrtc/candidate":
          pc.addIceCandidate({
            candidate: msg.value,
            sdpMid: "0",
          }).catch(() => { });
          break;
        case "webrtc/answer":
          pc.setRemoteDescription({
            type: "answer",
            sdp: msg.value,
          }).catch(() => { });
          break;
        case "error":
          if (msg.value.indexOf("webrtc/offer") < 0) return;
          pc.close();
      }
    };

    // Safari doesn't support "offerToReceiveVideo"
    pc.addTransceiver("video", { direction: "recvonly" });
    pc.addTransceiver("audio", { direction: "recvonly" });

    pc.createOffer().then((offer) => {
      pc.setLocalDescription(offer).then(() => {
        this.send({ type: "webrtc/offer", value: offer.sdp });
      });
    });

    this.pcState = WebSocket.CONNECTING;
    this.pc = pc;
  }

  /**
   * @param ev {Event}
   */
  onpcvideo(ev) {
    if (!this.pc) return;

    /** @type {HTMLVideoElement} */
    const video2 = ev.target;
    const state = this.pc.connectionState;

    // Firefox doesn't support pc.connectionState
    if (state === "connected" || state === "connecting" || !state) {
      // Video+Audio > Video, H265 > H264, Video > Audio, WebRTC > MSE
      let rtcPriority = 0,
        msePriority = 0;

      /** @type {MediaStream} */
      const ms = video2.srcObject;
      if (ms.getVideoTracks().length > 0) rtcPriority += 0x220;
      if (ms.getAudioTracks().length > 0) rtcPriority += 0x102;

      if (this.mseCodecs.indexOf("hvc1.") >= 0) msePriority += 0x230;
      if (this.mseCodecs.indexOf("avc1.") >= 0) msePriority += 0x210;
      if (this.mseCodecs.indexOf("mp4a.") >= 0) msePriority += 0x101;

      if (rtcPriority >= msePriority) {
        this.video.srcObject = ms;
        this.play();

        this.pcState = WebSocket.OPEN;

        this.wsState = WebSocket.CLOSED;
        this.ws.close();
        this.ws = null;
        this.dispatchCustomEvent("CLOSED");
      } else {
        this.pcState = WebSocket.CLOSED;
        this.dispatchCustomEvent("CLOSED");
        this.pc.close();
        this.pc = null;
      }
    }

    video2.srcObject = null;
  }

  onmjpeg() {
    this.ondata = (data) => {
      this.video.controls = false;
      this.video.poster = `data:image/jpeg;base64,${VideoRTC.btoa(data)}`;
    };

    this.send({ type: "mjpeg" });
  }

  onmp4() {
    /** @type {HTMLCanvasElement} **/
    const canvas = document.createElement("canvas");
    /** @type {CanvasRenderingContext2D} */
    let context;

    /** @type {HTMLVideoElement} */
    const video2 = document.createElement("video");
    video2.autoplay = true;
    video2.playsInline = true;
    video2.muted = true;

    video2.addEventListener("loadeddata", (_) => {
      if (!context) {
        canvas.width = video2.videoWidth;
        canvas.height = video2.videoHeight;
        context = canvas.getContext("2d");
      }

      context.drawImage(video2, 0, 0, canvas.width, canvas.height);

      this.video.controls = false;
      this.video.poster = canvas.toDataURL("image/jpeg");
    });

    this.ondata = (data) => {
      video2.src = `data:video/mp4;base64,${VideoRTC.btoa(data)}`;
    };

    this.send({ type: "mp4", value: this.codecs(this.video.canPlayType) });
  }

  dispatchCustomEvent(type) {
    // Create a new event
    let event = new CustomEvent(`ws-state:${type}`, {
      bubbles: true,
      cancelable: true,
      detail: { state: this.wsState },
    });

    // Dispatch the event
    return this.dispatchEvent(event);
  }

  static btoa(buffer) {
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    let binary = "";
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
}

class VideoStream extends VideoRTC {
  /**
   * Custom GUI
   */
  oninit() {
    super.oninit();
    const info = this.querySelector(".info");
    this.insertBefore(this.video, info);
  }

  onconnect() {
    const result = super.onconnect();
    if (result) this.divMode = "loading";
    return result;
  }

  ondisconnect() {
    super.ondisconnect();
  }

  onopen() {
    const result = super.onopen();

    this.onmessage["stream"] = (_) => { };

    return result;
  }

  onclose() {
    return super.onclose();
  }

  onpcvideo(ev) {
    super.onpcvideo(ev);

    if (this.pcState !== WebSocket.CLOSED) {
      this.divMode = "RTC";
    }
  }
}

class MSEPlayer extends VideoStream {
  constructor() {
    super();

    this.resizeObserver = null;
    this.currentResolution = "";
    this.isSubstreamChange = false;

    /**
     * [config] Id of the current substream.
     * @type {string}
     */
    this.currentSubstream = "";

    /**
     * [config] Substream Id by resolution.
     * @type {Object.<"720p"|"480p"|"240p",string>}
     */
    this._substreams = {};
  }

  /**
   * Set substreams.
   * @param {Object.<"720p"|"480p"|"240p",string>} value
   */
  set substreams(value) {
    if (typeof value === 'object') {
      this._substreams = value;
      this.adjustResolution(this.video.clientWidth);
    }
  }

  oninit() {
    super.oninit();

    // Initialize ResizeObserver
    if (!this.resizeObserver) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          this.adjustResolution(entry.contentRect.width);
        }
      });
      this.resizeObserver.observe(this);
    }
  }

  onconnect() {
    super.onconnect();

    // if (this.resizeObserver) {
    //   this.resizeObserver.observe(this);
    // }
  }

  ondisconnect() {
    super.ondisconnect();

    // if (this.resizeObserver) {
    //   this.resizeObserver.unobserve(this);
    // }
  }

  onopen() {
    super.onopen();
    this.isSubstreamChange = false;
  }

  onclose() {
    if (!this.isSubstreamChange) {
      super.onclose();
    }
  }

  adjustResolution(width) {
    let newResolution;
    
    if (width >= 1920) {
      newResolution = '1080p';
    } else if (width >= 1280) {
      newResolution = '720p';
    } else if (width >= 854) {
      newResolution = '480p';
    } else {
      newResolution = '240p';
    }

    if (this.currentResolution !== newResolution) {
      this.currentResolution = newResolution;
      this.changeSubstream(this._substreams[newResolution]);
    }
  }

  /**
   * Change the video source to the substream.
   * @param {string} substream - The subtream for the selected resolution substream.
   */
  changeSubstream(substream) {
    if (this.currentSubstream !== substream) {
      this.isSubstreamChange = true;
      this.ondisconnect();
      this.currentSubstream = substream;
      this.camera = substream; // Connection to ws
    }
  }
}


if (customElements.get("mse-player") == undefined) {
  customElements.define("mse-player", MSEPlayer);
}


// https://iconos8.es/icons/set/next

const iconNext=`>`;

const iconBack=`<`;

const iconAmpliar=`Ampliar`;

const iconVerVideo=`Video`;

const iconBusAvanzada=`Busq. A.`;

const iconOpenSop=`Open`;
/**
 * @preserve libde265.js HEVC/H.265 decoder
 * (c)2014 struktur AG, http://www.struktur.de, opensource@struktur.de
 *
 * This file is part of libde265.js
 * https://github.com/strukturag/libde265.js
 *
 * libde265.js is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * libde265.js is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with libde265.js.  If not, see <http://www.gnu.org/licenses/>.
 */
(function() {
    var Module = {
        print: function(text) {
            text = Array.prototype.slice.call(arguments).join(' ');
            // ;
        },
        printErr: function(text) {
            text = Array.prototype.slice.call(arguments).join(' ');
            // console.error(text);
        },
        canvas: {},
        noInitialRun: true
    };

    // Note: For maximum-speed code, see "Optimizing Code" on the Emscripten wiki, https://github.com/kripken/emscripten/wiki/Optimizing-Code
    // Note: Some Emscripten settings may limit the speed of the generated code.
    // The Module object: Our interface to the outside world. We import
    // and export values on it, and do the work to get that through
    // closure compiler if necessary. There are various ways Module can be used:
    // 1. Not defined. We create it here
    // 2. A function parameter, function(Module) { ..generated code.. }
    // 3. pre-run appended it, var Module = {}; ..generated code..
    // 4. External script tag defines var Module.
    // We need to do an eval in order to handle the closure compiler
    // case, where this code here is minified but Module was defined
    // elsewhere (e.g. case 4 above). We also need to check if Module
    // already exists (e.g. case 3 above).
    // Note that if you want to run closure, and also to use Module
    // after the generated code, you will need to define   var Module = {};
    // before the code. Then that object will be used in the code, and you
    // can continue to use Module afterwards as well.
    var Module;
    if (!Module) Module = eval('(function() { try { return Module || {} } catch(e) { return {} } })()');

    // Sometimes an existing Module object exists with properties
    // meant to overwrite the default module functionality. Here
    // we collect those properties and reapply _after_ we configure
    // the current environment's defaults to avoid having to be so
    // defensive during initialization.
    var moduleOverrides = {};
    for (var key in Module) {
        if (Module.hasOwnProperty(key)) {
            moduleOverrides[key] = Module[key];
        }
    }

    // The environment setup code below is customized to use Module.
    // *** Environment setup code ***
    var ENVIRONMENT_IS_NODE = typeof process === 'object' && typeof require === 'function';
    var ENVIRONMENT_IS_WEB = typeof window === 'object';
    var ENVIRONMENT_IS_WORKER = typeof importScripts === 'function';
    var ENVIRONMENT_IS_SHELL = !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_NODE && !ENVIRONMENT_IS_WORKER;
    var fileBuffer = false;

    if (ENVIRONMENT_IS_NODE) {
        // Expose functionality in the same simple way that the shells work
        // Note that we pollute the global namespace here, otherwise we break in node
        if (!Module['print']) Module['print'] = function print(x) {
            process['stdout'].write(x + '\n');
        };
        if (!Module['printErr']) Module['printErr'] = function printErr(x) {
            process['stderr'].write(x + '\n');
        };

        var nodeFS = require('fs');
        var nodePath = require('path');

        Module['read'] = function read(filename, binary) {
            filename = nodePath['normalize'](filename);
            var ret = nodeFS['readFileSync'](filename);
            // The path is absolute if the normalized version is the same as the resolved.
            if (!ret && filename != nodePath['resolve'](filename)) {
                filename = path.join(__dirname, '..', 'src', filename);
                ret = nodeFS['readFileSync'](filename);
            }
            if (ret && !binary) ret = ret.toString();
            return ret;
        };

        Module['readBinary'] = function readBinary(filename) { return Module['read'](filename, true) };

        Module['load'] = function load(f) {
            globalEval(read(f));
        };

        Module['arguments'] = process['argv'].slice(2);

        module['exports'] = Module;
    } else if (ENVIRONMENT_IS_SHELL) {
        if (!Module['print']) Module['print'] = print;
        if (typeof printErr != 'undefined') Module['printErr'] = printErr; // not present in v8 or older sm

        if (typeof read != 'undefined') {
            Module['read'] = read;
        } else {
            Module['read'] = function read() { throw 'no read() available (jsc?)' };
        }

        Module['readBinary'] = function readBinary(f) {
            return read(f, 'binary');
        };

        if (typeof scriptArgs != 'undefined') {
            Module['arguments'] = scriptArgs;
        } else if (typeof arguments != 'undefined') {
            Module['arguments'] = arguments;
        }

        this['Module'] = Module;

        eval("if (typeof gc === 'function' && gc.toString().indexOf('[native code]') > 0) var gc = undefined"); // wipe out the SpiderMonkey shell 'gc' function, which can confuse closure (uses it as a minified name, and it is then initted to a non-falsey value unexpectedly)
    } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
        Module['read'] = function read(url) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, false);
            xhr.send(null);
            return xhr.responseText;
        };

        if (typeof arguments != 'undefined') {
            Module['arguments'] = arguments;
        }

        if (typeof console !== 'undefined') {
            if (!Module['print']) Module['print'] = function print(x) {
                // ;
            };
            if (!Module['printErr']) Module['printErr'] = function printErr(x) {
                // ;
            };
        } else {
            // Probably a worker, and without console.log. We can do very little here...
            var TRY_USE_DUMP = false;
            if (!Module['print']) Module['print'] = (TRY_USE_DUMP && (typeof(dump) !== "undefined") ? (function(x) {
                dump(x);
            }) : (function(x) {
                // self.postMessage(x); // enable this if you want stdout to be sent as messages
            }));
        }

        if (ENVIRONMENT_IS_WEB) {
            this['Module'] = Module;
        } else {
            Module['load'] = importScripts;
        }
    } else {
        // Unreachable because SHELL is dependant on the others
        throw 'Unknown runtime environment. Where are we?';
    }

    function globalEval(x) {
        eval.call(null, x);
    }
    if (!Module['load'] == 'undefined' && Module['read']) {
        Module['load'] = function load(f) {
            globalEval(Module['read'](f));
        };
    }
    if (!Module['print']) {
        Module['print'] = function() {};
    }
    if (!Module['printErr']) {
        Module['printErr'] = Module['print'];
    }
    if (!Module['arguments']) {
        Module['arguments'] = [];
    }
    // *** Environment setup code ***

    // Closure helpers
    Module.print = Module['print'];
    Module.printErr = Module['printErr'];

    // Callbacks
    Module['preRun'] = [];
    Module['postRun'] = [];

    // Merge back in the overrides
    for (var key in moduleOverrides) {
        if (moduleOverrides.hasOwnProperty(key)) {
            Module[key] = moduleOverrides[key];
        }
    }



    // === Auto-generated preamble library stuff ===

    //========================================
    // Runtime code shared with compiler
    //========================================

    var Runtime = {
        stackSave: function() {
            return STACKTOP;
        },
        stackRestore: function(stackTop) {
            STACKTOP = stackTop;
        },
        forceAlign: function(target, quantum) {
            quantum = quantum || 4;
            if (quantum == 1) return target;
            if (isNumber(target) && isNumber(quantum)) {
                return Math.ceil(target / quantum) * quantum;
            } else if (isNumber(quantum) && isPowerOfTwo(quantum)) {
                return '(((' + target + ')+' + (quantum - 1) + ')&' + -quantum + ')';
            }
            return 'Math.ceil((' + target + ')/' + quantum + ')*' + quantum;
        },
        isNumberType: function(type) {
            return type in Runtime.INT_TYPES || type in Runtime.FLOAT_TYPES;
        },
        isPointerType: function isPointerType(type) {
            return type[type.length - 1] == '*';
        },
        isStructType: function isStructType(type) {
            if (isPointerType(type)) return false;
            if (isArrayType(type)) return true;
            if (/<?\{ ?[^}]* ?\}>?/.test(type)) return true; // { i32, i8 } etc. - anonymous struct types
            // See comment in isStructPointerType()
            return type[0] == '%';
        },
        INT_TYPES: { "i1": 0, "i8": 0, "i16": 0, "i32": 0, "i64": 0 },
        FLOAT_TYPES: { "float": 0, "double": 0 },
        or64: function(x, y) {
            var l = (x | 0) | (y | 0);
            var h = (Math.round(x / 4294967296) | Math.round(y / 4294967296)) * 4294967296;
            return l + h;
        },
        and64: function(x, y) {
            var l = (x | 0) & (y | 0);
            var h = (Math.round(x / 4294967296) & Math.round(y / 4294967296)) * 4294967296;
            return l + h;
        },
        xor64: function(x, y) {
            var l = (x | 0) ^ (y | 0);
            var h = (Math.round(x / 4294967296) ^ Math.round(y / 4294967296)) * 4294967296;
            return l + h;
        },
        getNativeTypeSize: function(type) {
            switch (type) {
                case 'i1':
                case 'i8':
                    return 1;
                case 'i16':
                    return 2;
                case 'i32':
                    return 4;
                case 'i64':
                    return 8;
                case 'float':
                    return 4;
                case 'double':
                    return 8;
                default:
                    {
                        if (type[type.length - 1] === '*') {
                            return Runtime.QUANTUM_SIZE; // A pointer
                        } else if (type[0] === 'i') {
                            var bits = parseInt(type.substr(1));
                            assert(bits % 8 === 0);
                            return bits / 8;
                        } else {
                            return 0;
                        }
                    }
            }
        },
        getNativeFieldSize: function(type) {
            return Math.max(Runtime.getNativeTypeSize(type), Runtime.QUANTUM_SIZE);
        },
        dedup: function dedup(items, ident) {
            var seen = {};
            if (ident) {
                return items.filter(function(item) {
                    if (seen[item[ident]]) return false;
                    seen[item[ident]] = true;
                    return true;
                });
            } else {
                return items.filter(function(item) {
                    if (seen[item]) return false;
                    seen[item] = true;
                    return true;
                });
            }
        },
        set: function set() {
            var args = typeof arguments[0] === 'object' ? arguments[0] : arguments;
            var ret = {};
            for (var i = 0; i < args.length; i++) {
                ret[args[i]] = 0;
            }
            return ret;
        },
        STACK_ALIGN: 8,
        getAlignSize: function(type, size, vararg) {
            // we align i64s and doubles on 64-bit boundaries, unlike x86
            if (vararg) return 8;
            if (!vararg && (type == 'i64' || type == 'double')) return 8;
            if (!type) return Math.min(size, 8); // align structures internally to 64 bits
            return Math.min(size || (type ? Runtime.getNativeFieldSize(type) : 0), Runtime.QUANTUM_SIZE);
        },
        calculateStructAlignment: function calculateStructAlignment(type) {
            type.flatSize = 0;
            type.alignSize = 0;
            var diffs = [];
            var prev = -1;
            var index = 0;
            type.flatIndexes = type.fields.map(function(field) {
                index++;
                var size, alignSize;
                if (Runtime.isNumberType(field) || Runtime.isPointerType(field)) {
                    size = Runtime.getNativeTypeSize(field); // pack char; char; in structs, also char[X]s.
                    alignSize = Runtime.getAlignSize(field, size);
                } else if (Runtime.isStructType(field)) {
                    if (field[1] === '0') {
                        // this is [0 x something]. When inside another structure like here, it must be at the end,
                        // and it adds no size
                        // XXX this happens in java-nbody for example... assert(index === type.fields.length, 'zero-length in the middle!');
                        size = 0;
                        if (Types.types[field]) {
                            alignSize = Runtime.getAlignSize(null, Types.types[field].alignSize);
                        } else {
                            alignSize = type.alignSize || QUANTUM_SIZE;
                        }
                    } else {
                        size = Types.types[field].flatSize;
                        alignSize = Runtime.getAlignSize(null, Types.types[field].alignSize);
                    }
                } else if (field[0] == 'b') {
                    // bN, large number field, like a [N x i8]
                    size = field.substr(1) | 0;
                    alignSize = 1;
                } else if (field[0] === '<') {
                    // vector type
                    size = alignSize = Types.types[field].flatSize; // fully aligned
                } else if (field[0] === 'i') {
                    // illegal integer field, that could not be legalized because it is an internal structure field
                    // it is ok to have such fields, if we just use them as markers of field size and nothing more complex
                    size = alignSize = parseInt(field.substr(1)) / 8;
                    assert(size % 1 === 0, 'cannot handle non-byte-size field ' + field);
                } else {
                    assert(false, 'invalid type for calculateStructAlignment');
                }
                if (type.packed) alignSize = 1;
                type.alignSize = Math.max(type.alignSize, alignSize);
                var curr = Runtime.alignMemory(type.flatSize, alignSize); // if necessary, place this on aligned memory
                type.flatSize = curr + size;
                if (prev >= 0) {
                    diffs.push(curr - prev);
                }
                prev = curr;
                return curr;
            });
            if (type.name_ && type.name_[0] === '[') {
                // arrays have 2 elements, so we get the proper difference. then we scale here. that way we avoid
                // allocating a potentially huge array for [999999 x i8] etc.
                type.flatSize = parseInt(type.name_.substr(1)) * type.flatSize / 2;
            }
            type.flatSize = Runtime.alignMemory(type.flatSize, type.alignSize);
            if (diffs.length == 0) {
                type.flatFactor = type.flatSize;
            } else if (Runtime.dedup(diffs).length == 1) {
                type.flatFactor = diffs[0];
            }
            type.needsFlattening = (type.flatFactor != 1);
            return type.flatIndexes;
        },
        generateStructInfo: function(struct, typeName, offset) {
            var type, alignment;
            if (typeName) {
                offset = offset || 0;
                type = (typeof Types === 'undefined' ? Runtime.typeInfo : Types.types)[typeName];
                if (!type) return null;
                if (type.fields.length != struct.length) {
                    printErr('Number of named fields must match the type for ' + typeName + ': possibly duplicate struct names. Cannot return structInfo');
                    return null;
                }
                alignment = type.flatIndexes;
            } else {
                var type = { fields: struct.map(function(item) { return item[0] }) };
                alignment = Runtime.calculateStructAlignment(type);
            }
            var ret = {
                __size__: type.flatSize
            };
            if (typeName) {
                struct.forEach(function(item, i) {
                    if (typeof item === 'string') {
                        ret[item] = alignment[i] + offset;
                    } else {
                        // embedded struct
                        var key;
                        for (var k in item) key = k;
                        ret[key] = Runtime.generateStructInfo(item[key], type.fields[i], alignment[i]);
                    }
                });
            } else {
                struct.forEach(function(item, i) {
                    ret[item[1]] = alignment[i];
                });
            }
            return ret;
        },
        dynCall: function(sig, ptr, args) {
            if (args && args.length) {
                if (!args.splice) args = Array.prototype.slice.call(args);
                args.splice(0, 0, ptr);
                return Module['dynCall_' + sig].apply(null, args);
            } else {
                return Module['dynCall_' + sig].call(null, ptr);
            }
        },
        functionPointers: [],
        addFunction: function(func) {
            for (var i = 0; i < Runtime.functionPointers.length; i++) {
                if (!Runtime.functionPointers[i]) {
                    Runtime.functionPointers[i] = func;
                    return 2 * (1 + i);
                }
            }
            throw 'Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.';
        },
        removeFunction: function(index) {
            Runtime.functionPointers[(index - 2) / 2] = null;
        },
        getAsmConst: function(code, numArgs) {
            // code is a constant string on the heap, so we can cache these
            if (!Runtime.asmConstCache) Runtime.asmConstCache = {};
            var func = Runtime.asmConstCache[code];
            if (func) return func;
            var args = [];
            for (var i = 0; i < numArgs; i++) {
                args.push(String.fromCharCode(36) + i); // $0, $1 etc
            }
            code = Pointer_stringify(code);
            if (code[0] === '"') {
                // tolerate EM_ASM("..code..") even though EM_ASM(..code..) is correct
                if (code.indexOf('"', 1) === code.length - 1) {
                    code = code.substr(1, code.length - 2);
                } else {
                    // something invalid happened, e.g. EM_ASM("..code($0)..", input)
                    abort('invalid EM_ASM input |' + code + '|. Please use EM_ASM(..code..) (no quotes) or EM_ASM({ ..code($0).. }, input) (to input values)');
                }
            }
            return Runtime.asmConstCache[code] = eval('(function(' + args.join(',') + '){ ' + code + ' })'); // new Function does not allow upvars in node
        },
        warnOnce: function(text) {
            if (!Runtime.warnOnce.shown) Runtime.warnOnce.shown = {};
            if (!Runtime.warnOnce.shown[text]) {
                Runtime.warnOnce.shown[text] = 1;
                Module.printErr(text);
            }
        },
        funcWrappers: {},
        getFuncWrapper: function(func, sig) {
            assert(sig);
            if (!Runtime.funcWrappers[func]) {
                Runtime.funcWrappers[func] = function dynCall_wrapper() {
                    return Runtime.dynCall(sig, func, arguments);
                };
            }
            return Runtime.funcWrappers[func];
        },
        UTF8Processor: function() {
            var buffer = [];
            var needed = 0;
            this.processCChar = function(code) {
                code = code & 0xFF;

                if (buffer.length == 0) {
                    if ((code & 0x80) == 0x00) { // 0xxxxxxx
                        return String.fromCharCode(code);
                    }
                    buffer.push(code);
                    if ((code & 0xE0) == 0xC0) { // 110xxxxx
                        needed = 1;
                    } else if ((code & 0xF0) == 0xE0) { // 1110xxxx
                        needed = 2;
                    } else { // 11110xxx
                        needed = 3;
                    }
                    return '';
                }

                if (needed) {
                    buffer.push(code);
                    needed--;
                    if (needed > 0) return '';
                }

                var c1 = buffer[0];
                var c2 = buffer[1];
                var c3 = buffer[2];
                var c4 = buffer[3];
                var ret;
                if (buffer.length == 2) {
                    ret = String.fromCharCode(((c1 & 0x1F) << 6) | (c2 & 0x3F));
                } else if (buffer.length == 3) {
                    ret = String.fromCharCode(((c1 & 0x0F) << 12) | ((c2 & 0x3F) << 6) | (c3 & 0x3F));
                } else {
                    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                    var codePoint = ((c1 & 0x07) << 18) | ((c2 & 0x3F) << 12) |
                        ((c3 & 0x3F) << 6) | (c4 & 0x3F);
                    ret = String.fromCharCode(
                        Math.floor((codePoint - 0x10000) / 0x400) + 0xD800,
                        (codePoint - 0x10000) % 0x400 + 0xDC00);
                }
                buffer.length = 0;
                return ret;
            }
            this.processJSString = function processJSString(string) {
                string = unescape(encodeURIComponent(string));
                var ret = [];
                for (var i = 0; i < string.length; i++) {
                    ret.push(string.charCodeAt(i));
                }
                return ret;
            }
        },
        getCompilerSetting: function(name) {
            throw 'You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work';
        },
        stackAlloc: function(size) {
            var ret = STACKTOP;
            STACKTOP = (STACKTOP + size) | 0;
            STACKTOP = (((STACKTOP) + 7) & -8);
            return ret;
        },
        staticAlloc: function(size) {
            var ret = STATICTOP;
            STATICTOP = (STATICTOP + size) | 0;
            STATICTOP = (((STATICTOP) + 7) & -8);
            return ret;
        },
        dynamicAlloc: function(size) {
            var ret = DYNAMICTOP;
            DYNAMICTOP = (DYNAMICTOP + size) | 0;
            DYNAMICTOP = (((DYNAMICTOP) + 7) & -8);
            if (DYNAMICTOP >= TOTAL_MEMORY) enlargeMemory();;
            return ret;
        },
        alignMemory: function(size, quantum) { var ret = size = Math.ceil((size) / (quantum ? quantum : 8)) * (quantum ? quantum : 8); return ret; },
        makeBigInt: function(low, high, unsigned) { var ret = (unsigned ? ((+((low >>> 0))) + ((+((high >>> 0))) * (+4294967296))) : ((+((low >>> 0))) + ((+((high | 0))) * (+4294967296)))); return ret; },
        GLOBAL_BASE: 8,
        QUANTUM_SIZE: 4,
        __dummy__: 0
    }


    Module['Runtime'] = Runtime;









    //========================================
    // Runtime essentials
    //========================================

    var __THREW__ = 0; // Used in checking for thrown exceptions.

    var ABORT = false; // whether we are quitting the application. no code should run after this. set in exit() and abort()
    var EXITSTATUS = 0;

    var undef = 0;
    // tempInt is used for 32-bit signed values or smaller. tempBigInt is used
    // for 32-bit unsigned values or more than 32 bits. TODO: audit all uses of tempInt
    var tempValue, tempInt, tempBigInt, tempInt2, tempBigInt2, tempPair, tempBigIntI, tempBigIntR, tempBigIntS, tempBigIntP, tempBigIntD, tempDouble, tempFloat;
    var tempI64, tempI64b;
    var tempRet0, tempRet1, tempRet2, tempRet3, tempRet4, tempRet5, tempRet6, tempRet7, tempRet8, tempRet9;

    function assert(condition, text) {
        if (!condition) {
            abort('Assertion failed: ' + text);
        }
    }

    var globalScope = this;

    // C calling interface. A convenient way to call C functions (in C files, or
    // defined with extern "C").
    //
    // Note: LLVM optimizations can inline and remove functions, after which you will not be
    //       able to call them. Closure can also do so. To avoid that, add your function to
    //       the exports using something like
    //
    //         -s EXPORTED_FUNCTIONS='["_main", "_myfunc"]'
    //
    // @param ident      The name of the C function (note that C++ functions will be name-mangled - use extern "C")
    // @param returnType The return type of the function, one of the JS types 'number', 'string' or 'array' (use 'number' for any C pointer, and
    //                   'array' for JavaScript arrays and typed arrays; note that arrays are 8-bit).
    // @param argTypes   An array of the types of arguments for the function (if there are no arguments, this can be ommitted). Types are as in returnType,
    //                   except that 'array' is not possible (there is no way for us to know the length of the array)
    // @param args       An array of the arguments to the function, as native JS values (as in returnType)
    //                   Note that string arguments will be stored on the stack (the JS string will become a C string on the stack).
    // @return           The return value, as a native JS value (as in returnType)
    function ccall(ident, returnType, argTypes, args) {
        return ccallFunc(getCFunc(ident), returnType, argTypes, args);
    }
    Module["ccall"] = ccall;

    // Returns the C function with a specified identifier (for C++, you need to do manual name mangling)
    function getCFunc(ident) {
        try {
            var func = Module['_' + ident]; // closure exported function
            if (!func) func = eval('_' + ident); // explicit lookup
        } catch (e) {}
        assert(func, 'Cannot call unknown function ' + ident + ' (perhaps LLVM optimizations or closure removed it?)');
        return func;
    }

    // Internal function that does a C call using a function, not an identifier
    function ccallFunc(func, returnType, argTypes, args) {
        var stack = 0;

        function toC(value, type) {
            if (type == 'string') {
                if (value === null || value === undefined || value === 0) return 0; // null string
                value = intArrayFromString(value);
                type = 'array';
            }
            if (type == 'array') {
                if (!stack) stack = Runtime.stackSave();
                var ret = Runtime.stackAlloc(value.length);
                writeArrayToMemory(value, ret);
                return ret;
            }
            return value;
        }

        function fromC(value, type) {
            if (type == 'string') {
                return Pointer_stringify(value);
            }
            assert(type != 'array');
            return value;
        }
        var i = 0;
        var cArgs = args ? args.map(function(arg) {
            return toC(arg, argTypes[i++]);
        }) : [];
        var ret = fromC(func.apply(null, cArgs), returnType);
        if (stack) Runtime.stackRestore(stack);
        return ret;
    }

    // Returns a native JS wrapper for a C function. This is similar to ccall, but
    // returns a function you can call repeatedly in a normal way. For example:
    //
    //   var my_function = cwrap('my_c_function', 'number', ['number', 'number']);
    //   alert(my_function(5, 22));
    //   alert(my_function(99, 12));
    //
    function cwrap(ident, returnType, argTypes) {
        var func = getCFunc(ident);
        return function() {
            return ccallFunc(func, returnType, argTypes, Array.prototype.slice.call(arguments));
        }
    }
    Module["cwrap"] = cwrap;

    // Sets a value in memory in a dynamic way at run-time. Uses the
    // type data. This is the same as makeSetValue, except that
    // makeSetValue is done at compile-time and generates the needed
    // code then, whereas this function picks the right code at
    // run-time.
    // Note that setValue and getValue only do *aligned* writes and reads!
    // Note that ccall uses JS types as for defining types, while setValue and
    // getValue need LLVM types ('i8', 'i32') - this is a lower-level operation
    function setValue(ptr, value, type, noSafe) {
        type = type || 'i8';
        if (type.charAt(type.length - 1) === '*') type = 'i32'; // pointers are 32-bit
        switch (type) {
            case 'i1':
                HEAP8[(ptr)] = value;
                break;
            case 'i8':
                HEAP8[(ptr)] = value;
                break;
            case 'i16':
                HEAP16[((ptr) >> 1)] = value;
                break;
            case 'i32':
                HEAP32[((ptr) >> 2)] = value;
                break;
            case 'i64':
                (tempI64 = [value >>> 0, (tempDouble = value, (+(Math_abs(tempDouble))) >= (+1) ? (tempDouble > (+0) ? ((Math_min((+(Math_floor((tempDouble) / (+4294967296)))), (+4294967295))) | 0) >>> 0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble))) >>> 0)) / (+4294967296)))))) >>> 0) : 0)], HEAP32[((ptr) >> 2)] = tempI64[0], HEAP32[(((ptr) + (4)) >> 2)] = tempI64[1]);
                break;
            case 'float':
                HEAPF32[((ptr) >> 2)] = value;
                break;
            case 'double':
                HEAPF64[((ptr) >> 3)] = value;
                break;
            default:
                abort('invalid type for setValue: ' + type);
        }
    }
    Module['setValue'] = setValue;

    // Parallel to setValue.
    function getValue(ptr, type, noSafe) {
        type = type || 'i8';
        if (type.charAt(type.length - 1) === '*') type = 'i32'; // pointers are 32-bit
        switch (type) {
            case 'i1':
                return HEAP8[(ptr)];
            case 'i8':
                return HEAP8[(ptr)];
            case 'i16':
                return HEAP16[((ptr) >> 1)];
            case 'i32':
                return HEAP32[((ptr) >> 2)];
            case 'i64':
                return HEAP32[((ptr) >> 2)];
            case 'float':
                return HEAPF32[((ptr) >> 2)];
            case 'double':
                return HEAPF64[((ptr) >> 3)];
            default:
                abort('invalid type for setValue: ' + type);
        }
        return null;
    }
    Module['getValue'] = getValue;

    var ALLOC_NORMAL = 0; // Tries to use _malloc()
    var ALLOC_STACK = 1; // Lives for the duration of the current function call
    var ALLOC_STATIC = 2; // Cannot be freed
    var ALLOC_DYNAMIC = 3; // Cannot be freed except through sbrk
    var ALLOC_NONE = 4; // Do not allocate
    Module['ALLOC_NORMAL'] = ALLOC_NORMAL;
    Module['ALLOC_STACK'] = ALLOC_STACK;
    Module['ALLOC_STATIC'] = ALLOC_STATIC;
    Module['ALLOC_DYNAMIC'] = ALLOC_DYNAMIC;
    Module['ALLOC_NONE'] = ALLOC_NONE;

    // allocate(): This is for internal use. You can use it yourself as well, but the interface
    //             is a little tricky (see docs right below). The reason is that it is optimized
    //             for multiple syntaxes to save space in generated code. So you should
    //             normally not use allocate(), and instead allocate memory using _malloc(),
    //             initialize it with setValue(), and so forth.
    // @slab: An array of data, or a number. If a number, then the size of the block to allocate,
    //        in *bytes* (note that this is sometimes confusing: the next parameter does not
    //        affect this!)
    // @types: Either an array of types, one for each byte (or 0 if no type at that position),
    //         or a single type which is used for the entire block. This only matters if there
    //         is initial data - if @slab is a number, then this does not matter at all and is
    //         ignored.
    // @allocator: How to allocate memory, see ALLOC_*
    function allocate(slab, types, allocator, ptr) {
        var zeroinit, size;
        if (typeof slab === 'number') {
            zeroinit = true;
            size = slab;
        } else {
            zeroinit = false;
            size = slab.length;
        }

        var singleType = typeof types === 'string' ? types : null;

        var ret;
        if (allocator == ALLOC_NONE) {
            ret = ptr;
        } else {
            ret = [_malloc, Runtime.stackAlloc, Runtime.staticAlloc, Runtime.dynamicAlloc][allocator === undefined ? ALLOC_STATIC : allocator](Math.max(size, singleType ? 1 : types.length));
        }

        if (zeroinit) {
            var ptr = ret,
                stop;
            assert((ret & 3) == 0);
            stop = ret + (size & ~3);
            for (; ptr < stop; ptr += 4) {
                HEAP32[((ptr) >> 2)] = 0;
            }
            stop = ret + size;
            while (ptr < stop) {
                HEAP8[((ptr++) | 0)] = 0;
            }
            return ret;
        }

        if (singleType === 'i8') {
            if (slab.subarray || slab.slice) {
                HEAPU8.set(slab, ret);
            } else {
                HEAPU8.set(new Uint8Array(slab), ret);
            }
            return ret;
        }

        var i = 0,
            type, typeSize, previousType;
        while (i < size) {
            var curr = slab[i];

            if (typeof curr === 'function') {
                curr = Runtime.getFunctionIndex(curr);
            }

            type = singleType || types[i];
            if (type === 0) {
                i++;
                continue;
            }

            if (type == 'i64') type = 'i32'; // special case: we have one i32 here, and one i32 later

            setValue(ret + i, curr, type);

            // no need to look up size unless type changes, so cache it
            if (previousType !== type) {
                typeSize = Runtime.getNativeTypeSize(type);
                previousType = type;
            }
            i += typeSize;
        }

        return ret;
    }
    Module['allocate'] = allocate;

    function Pointer_stringify(ptr, /* optional */ length) {
        // TODO: use TextDecoder
        // Find the length, and check for UTF while doing so
        var hasUtf = false;
        var t;
        var i = 0;
        while (1) {
            t = HEAPU8[(((ptr) + (i)) | 0)];
            if (t >= 128) hasUtf = true;
            else if (t == 0 && !length) break;
            i++;
            if (length && i == length) break;
        }
        if (!length) length = i;

        var ret = '';

        if (!hasUtf) {
            var MAX_CHUNK = 1024; // split up into chunks, because .apply on a huge string can overflow the stack
            var curr;
            while (length > 0) {
                curr = String.fromCharCode.apply(String, HEAPU8.subarray(ptr, ptr + Math.min(length, MAX_CHUNK)));
                ret = ret ? ret + curr : curr;
                ptr += MAX_CHUNK;
                length -= MAX_CHUNK;
            }
            return ret;
        }

        var utf8 = new Runtime.UTF8Processor();
        for (i = 0; i < length; i++) {
            t = HEAPU8[(((ptr) + (i)) | 0)];
            ret += utf8.processCChar(t);
        }
        return ret;
    }
    Module['Pointer_stringify'] = Pointer_stringify;

    // Given a pointer 'ptr' to a null-terminated UTF16LE-encoded string in the emscripten HEAP, returns
    // a copy of that string as a Javascript String object.
    function UTF16ToString(ptr) {
        var i = 0;

        var str = '';
        while (1) {
            var codeUnit = HEAP16[(((ptr) + (i * 2)) >> 1)];
            if (codeUnit == 0)
                return str;
            ++i;
            // fromCharCode constructs a character from a UTF-16 code unit, so we can pass the UTF16 string right through.
            str += String.fromCharCode(codeUnit);
        }
    }
    Module['UTF16ToString'] = UTF16ToString;

    // Copies the given Javascript String object 'str' to the emscripten HEAP at address 'outPtr',
    // null-terminated and encoded in UTF16LE form. The copy will require at most (str.length*2+1)*2 bytes of space in the HEAP.
    function stringToUTF16(str, outPtr) {
        for (var i = 0; i < str.length; ++i) {
            // charCodeAt returns a UTF-16 encoded code unit, so it can be directly written to the HEAP.
            var codeUnit = str.charCodeAt(i); // possibly a lead surrogate
            HEAP16[(((outPtr) + (i * 2)) >> 1)] = codeUnit;
        }
        // Null-terminate the pointer to the HEAP.
        HEAP16[(((outPtr) + (str.length * 2)) >> 1)] = 0;
    }
    Module['stringToUTF16'] = stringToUTF16;

    // Given a pointer 'ptr' to a null-terminated UTF32LE-encoded string in the emscripten HEAP, returns
    // a copy of that string as a Javascript String object.
    function UTF32ToString(ptr) {
        var i = 0;

        var str = '';
        while (1) {
            var utf32 = HEAP32[(((ptr) + (i * 4)) >> 2)];
            if (utf32 == 0)
                return str;
            ++i;
            // Gotcha: fromCharCode constructs a character from a UTF-16 encoded code (pair), not from a Unicode code point! So encode the code point to UTF-16 for constructing.
            if (utf32 >= 0x10000) {
                var ch = utf32 - 0x10000;
                str += String.fromCharCode(0xD800 | (ch >> 10), 0xDC00 | (ch & 0x3FF));
            } else {
                str += String.fromCharCode(utf32);
            }
        }
    }
    Module['UTF32ToString'] = UTF32ToString;

    // Copies the given Javascript String object 'str' to the emscripten HEAP at address 'outPtr',
    // null-terminated and encoded in UTF32LE form. The copy will require at most (str.length+1)*4 bytes of space in the HEAP,
    // but can use less, since str.length does not return the number of characters in the string, but the number of UTF-16 code units in the string.
    function stringToUTF32(str, outPtr) {
        var iChar = 0;
        for (var iCodeUnit = 0; iCodeUnit < str.length; ++iCodeUnit) {
            // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code unit, not a Unicode code point of the character! We must decode the string to UTF-32 to the heap.
            var codeUnit = str.charCodeAt(iCodeUnit); // possibly a lead surrogate
            if (codeUnit >= 0xD800 && codeUnit <= 0xDFFF) {
                var trailSurrogate = str.charCodeAt(++iCodeUnit);
                codeUnit = 0x10000 + ((codeUnit & 0x3FF) << 10) | (trailSurrogate & 0x3FF);
            }
            HEAP32[(((outPtr) + (iChar * 4)) >> 2)] = codeUnit;
            ++iChar;
        }
        // Null-terminate the pointer to the HEAP.
        HEAP32[(((outPtr) + (iChar * 4)) >> 2)] = 0;
    }
    Module['stringToUTF32'] = stringToUTF32;

    function demangle(func) {
        var i = 3;
        // params, etc.
        var basicTypes = {
            'v': 'void',
            'b': 'bool',
            'c': 'char',
            's': 'short',
            'i': 'int',
            'l': 'long',
            'f': 'float',
            'd': 'double',
            'w': 'wchar_t',
            'a': 'signed char',
            'h': 'unsigned char',
            't': 'unsigned short',
            'j': 'unsigned int',
            'm': 'unsigned long',
            'x': 'long long',
            'y': 'unsigned long long',
            'z': '...'
        };
        var subs = [];
        var first = true;

        function dump(x) {
            //return;
            if (x) Module.print(x);
            Module.print(func);
            var pre = '';
            for (var a = 0; a < i; a++) pre += ' ';
            Module.print(pre + '^');
        }

        function parseNested() {
            i++;
            if (func[i] === 'K') i++; // ignore const
            var parts = [];
            while (func[i] !== 'E') {
                if (func[i] === 'S') { // substitution
                    i++;
                    var next = func.indexOf('_', i);
                    var num = func.substring(i, next) || 0;
                    parts.push(subs[num] || '?');
                    i = next + 1;
                    continue;
                }
                if (func[i] === 'C') { // constructor
                    parts.push(parts[parts.length - 1]);
                    i += 2;
                    continue;
                }
                var size = parseInt(func.substr(i));
                var pre = size.toString().length;
                if (!size || !pre) { i--; break; } // counter i++ below us
                var curr = func.substr(i + pre, size);
                parts.push(curr);
                subs.push(curr);
                i += pre + size;
            }
            i++; // skip E
            return parts;
        }

        function parse(rawList, limit, allowVoid) { // main parser
            limit = limit || Infinity;
            var ret = '',
                list = [];

            function flushList() {
                return '(' + list.join(', ') + ')';
            }
            var name;
            if (func[i] === 'N') {
                // namespaced N-E
                name = parseNested().join('::');
                limit--;
                if (limit === 0) return rawList ? [name] : name;
            } else {
                // not namespaced
                if (func[i] === 'K' || (first && func[i] === 'L')) i++; // ignore const and first 'L'
                var size = parseInt(func.substr(i));
                if (size) {
                    var pre = size.toString().length;
                    name = func.substr(i + pre, size);
                    i += pre + size;
                }
            }
            first = false;
            if (func[i] === 'I') {
                i++;
                var iList = parse(true);
                var iRet = parse(true, 1, true);
                ret += iRet[0] + ' ' + name + '<' + iList.join(', ') + '>';
            } else {
                ret = name;
            }
            paramLoop: while (i < func.length && limit-- > 0) {
                //dump('paramLoop');
                var c = func[i++];
                if (c in basicTypes) {
                    list.push(basicTypes[c]);
                } else {
                    switch (c) {
                        case 'P':
                            list.push(parse(true, 1, true)[0] + '*');
                            break; // pointer
                        case 'R':
                            list.push(parse(true, 1, true)[0] + '&');
                            break; // reference
                        case 'L':
                            { // literal
                                i++; // skip basic type
                                var end = func.indexOf('E', i);
                                var size = end - i;
                                list.push(func.substr(i, size));
                                i += size + 2; // size + 'EE'
                                break;
                            }
                        case 'A':
                            { // array
                                var size = parseInt(func.substr(i));
                                i += size.toString().length;
                                if (func[i] !== '_') throw '?';
                                i++; // skip _
                                list.push(parse(true, 1, true)[0] + ' [' + size + ']');
                                break;
                            }
                        case 'E':
                            break paramLoop;
                        default:
                            ret += '?' + c;
                            break paramLoop;
                    }
                }
            }
            if (!allowVoid && list.length === 1 && list[0] === 'void') list = []; // avoid (void)
            return rawList ? list : ret + flushList();
        }
        try {
            // Special-case the entry point, since its name differs from other name mangling.
            if (func == 'Object._main' || func == '_main') {
                return 'main()';
            }
            if (typeof func === 'number') func = Pointer_stringify(func);
            if (func[0] !== '_') return func;
            if (func[1] !== '_') return func; // C function
            if (func[2] !== 'Z') return func;
            switch (func[3]) {
                case 'n':
                    return 'operator new()';
                case 'd':
                    return 'operator delete()';
            }
            return parse();
        } catch (e) {
            return func;
        }
    }

    function demangleAll(text) {
        return text.replace(/__Z[\w\d_]+/g, function(x) { var y = demangle(x); return x === y ? x : (x + ' [' + y + ']') });
    }

    function stackTrace() {
        var stack = new Error().stack;
        return stack ? demangleAll(stack) : '(no stack trace available)'; // Stack trace is not available at least on IE10 and Safari 6.
    }

    // Memory management

    var PAGE_SIZE = 4096;

    function alignMemoryPage(x) {
        return (x + 4095) & -4096;
    }

    var HEAP;
    var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;

    var STATIC_BASE = 0,
        STATICTOP = 0,
        staticSealed = false; // static area
    var STACK_BASE = 0,
        STACKTOP = 0,
        STACK_MAX = 0; // stack area
    var DYNAMIC_BASE = 0,
        DYNAMICTOP = 0; // dynamic area handled by sbrk

    function enlargeMemory() {
        // TOTAL_MEMORY is the current size of the actual array, and DYNAMICTOP is the new top.

        while (TOTAL_MEMORY <= DYNAMICTOP) { // Simple heuristic.
            TOTAL_MEMORY = alignMemoryPage(2 * TOTAL_MEMORY);
        }
        assert(TOTAL_MEMORY <= Math.pow(2, 30)); // 2^30==1GB is a practical maximum - 2^31 is already close to possible negative numbers etc.
        var oldHEAP8 = HEAP8;
        var buffer = new ArrayBuffer(TOTAL_MEMORY);
        Module['HEAP8'] = HEAP8 = new Int8Array(buffer);
        Module['HEAP16'] = HEAP16 = new Int16Array(buffer);
        Module['HEAP32'] = HEAP32 = new Int32Array(buffer);
        Module['HEAPU8'] = HEAPU8 = new Uint8Array(buffer);
        Module['HEAPU16'] = HEAPU16 = new Uint16Array(buffer);
        Module['HEAPU32'] = HEAPU32 = new Uint32Array(buffer);
        Module['HEAPF32'] = HEAPF32 = new Float32Array(buffer);
        Module['HEAPF64'] = HEAPF64 = new Float64Array(buffer);
        HEAP8.set(oldHEAP8);
        _emscripten_replace_memory(HEAP8, HEAP16, HEAP32, HEAPU8, HEAPU16, HEAPU32, HEAPF32, HEAPF64);
    }

    var TOTAL_STACK = Module['TOTAL_STACK'] || 5242880;
    var TOTAL_MEMORY = Module['TOTAL_MEMORY'] || 16777216;
    var FAST_MEMORY = Module['FAST_MEMORY'] || 2097152;

    var totalMemory = 4096;
    while (totalMemory < TOTAL_MEMORY || totalMemory < 2 * TOTAL_STACK) {
        if (totalMemory < 16 * 1024 * 1024) {
            totalMemory *= 2;
        } else {
            totalMemory += 16 * 1024 * 1024
        }
    }
    if (totalMemory !== TOTAL_MEMORY) {
        Module.printErr('increasing TOTAL_MEMORY to ' + totalMemory + ' to be more reasonable');
        TOTAL_MEMORY = totalMemory;
    }

    // Initialize the runtime's memory
    // check for full engine support (use string 'subarray' to avoid closure compiler confusion)
    assert(typeof Int32Array !== 'undefined' && typeof Float64Array !== 'undefined' && !!(new Int32Array(1)['subarray']) && !!(new Int32Array(1)['set']),
        'JS engine does not provide full typed array support');

    var buffer = new ArrayBuffer(TOTAL_MEMORY);
    HEAP8 = new Int8Array(buffer);
    HEAP16 = new Int16Array(buffer);
    HEAP32 = new Int32Array(buffer);
    HEAPU8 = new Uint8Array(buffer);
    HEAPU16 = new Uint16Array(buffer);
    HEAPU32 = new Uint32Array(buffer);
    HEAPF32 = new Float32Array(buffer);
    HEAPF64 = new Float64Array(buffer);

    // Endianness check (note: assumes compiler arch was little-endian)
    HEAP32[0] = 255;
    assert(HEAPU8[0] === 255 && HEAPU8[3] === 0, 'Typed arrays 2 must be run on a little-endian system');

    Module['HEAP'] = HEAP;
    Module['HEAP8'] = HEAP8;
    Module['HEAP16'] = HEAP16;
    Module['HEAP32'] = HEAP32;
    Module['HEAPU8'] = HEAPU8;
    Module['HEAPU16'] = HEAPU16;
    Module['HEAPU32'] = HEAPU32;
    Module['HEAPF32'] = HEAPF32;
    Module['HEAPF64'] = HEAPF64;

    function callRuntimeCallbacks(callbacks) {
        while (callbacks.length > 0) {
            var callback = callbacks.shift();
            if (typeof callback == 'function') {
                callback();
                continue;
            }
            var func = callback.func;
            if (typeof func === 'number') {
                if (callback.arg === undefined) {
                    Runtime.dynCall('v', func);
                } else {
                    Runtime.dynCall('vi', func, [callback.arg]);
                }
            } else {
                func(callback.arg === undefined ? null : callback.arg);
            }
        }
    }

    var __ATPRERUN__ = []; // functions called before the runtime is initialized
    var __ATINIT__ = []; // functions called during startup
    var __ATMAIN__ = []; // functions called when main() is to be run
    var __ATEXIT__ = []; // functions called during shutdown
    var __ATPOSTRUN__ = []; // functions called after the runtime has exited

    var runtimeInitialized = false;

    function preRun() {
        // compatibility - merge in anything from Module['preRun'] at this time
        if (Module['preRun']) {
            if (typeof Module['preRun'] == 'function') Module['preRun'] = [Module['preRun']];
            while (Module['preRun'].length) {
                addOnPreRun(Module['preRun'].shift());
            }
        }
        callRuntimeCallbacks(__ATPRERUN__);
    }

    function ensureInitRuntime() {
        if (runtimeInitialized) return;
        runtimeInitialized = true;
        callRuntimeCallbacks(__ATINIT__);
    }

    function preMain() {
        callRuntimeCallbacks(__ATMAIN__);
    }

    function exitRuntime() {
        callRuntimeCallbacks(__ATEXIT__);
    }

    function postRun() {
        // compatibility - merge in anything from Module['postRun'] at this time
        if (Module['postRun']) {
            if (typeof Module['postRun'] == 'function') Module['postRun'] = [Module['postRun']];
            while (Module['postRun'].length) {
                addOnPostRun(Module['postRun'].shift());
            }
        }
        callRuntimeCallbacks(__ATPOSTRUN__);
    }

    function addOnPreRun(cb) {
        __ATPRERUN__.unshift(cb);
    }
    Module['addOnPreRun'] = Module.addOnPreRun = addOnPreRun;

    function addOnInit(cb) {
        __ATINIT__.unshift(cb);
    }
    Module['addOnInit'] = Module.addOnInit = addOnInit;

    function addOnPreMain(cb) {
        __ATMAIN__.unshift(cb);
    }
    Module['addOnPreMain'] = Module.addOnPreMain = addOnPreMain;

    function addOnExit(cb) {
        __ATEXIT__.unshift(cb);
    }
    Module['addOnExit'] = Module.addOnExit = addOnExit;

    function addOnPostRun(cb) {
        __ATPOSTRUN__.unshift(cb);
    }
    Module['addOnPostRun'] = Module.addOnPostRun = addOnPostRun;

    // Tools

    // This processes a JS string into a C-line array of numbers, 0-terminated.
    // For LLVM-originating strings, see parser.js:parseLLVMString function
    function intArrayFromString(stringy, dontAddNull, length /* optional */ ) {
        var ret = (new Runtime.UTF8Processor()).processJSString(stringy);
        if (length) {
            ret.length = length;
        }
        if (!dontAddNull) {
            ret.push(0);
        }
        return ret;
    }
    Module['intArrayFromString'] = intArrayFromString;

    function intArrayToString(array) {
        var ret = [];
        for (var i = 0; i < array.length; i++) {
            var chr = array[i];
            if (chr > 0xFF) {
                chr &= 0xFF;
            }
            ret.push(String.fromCharCode(chr));
        }
        return ret.join('');
    }
    Module['intArrayToString'] = intArrayToString;

    // Write a Javascript array to somewhere in the heap
    function writeStringToMemory(string, buffer, dontAddNull) {
        var array = intArrayFromString(string, dontAddNull);
        var i = 0;
        while (i < array.length) {
            var chr = array[i];
            HEAP8[(((buffer) + (i)) | 0)] = chr;
            i = i + 1;
        }
    }
    Module['writeStringToMemory'] = writeStringToMemory;

    function writeArrayToMemory(array, buffer) {
        for (var i = 0; i < array.length; i++) {
            HEAP8[(((buffer) + (i)) | 0)] = array[i];
        }
    }
    Module['writeArrayToMemory'] = writeArrayToMemory;

    function writeAsciiToMemory(str, buffer, dontAddNull) {
        for (var i = 0; i < str.length; i++) {
            HEAP8[(((buffer) + (i)) | 0)] = str.charCodeAt(i);
        }
        if (!dontAddNull) HEAP8[(((buffer) + (str.length)) | 0)] = 0;
    }
    Module['writeAsciiToMemory'] = writeAsciiToMemory;

    function unSign(value, bits, ignore) {
        if (value >= 0) {
            return value;
        }
        return bits <= 32 ? 2 * Math.abs(1 << (bits - 1)) + value // Need some trickery, since if bits == 32, we are right at the limit of the bits JS uses in bitshifts
            :
            Math.pow(2, bits) + value;
    }

    function reSign(value, bits, ignore) {
        if (value <= 0) {
            return value;
        }
        var half = bits <= 32 ? Math.abs(1 << (bits - 1)) // abs is needed if bits == 32
            :
            Math.pow(2, bits - 1);
        if (value >= half && (bits <= 32 || value > half)) { // for huge values, we can hit the precision limit and always get true here. so don't do that
            // but, in general there is no perfect solution here. With 64-bit ints, we get rounding and errors
            // TODO: In i64 mode 1, resign the two parts separately and safely
            value = -2 * half + value; // Cannot bitshift half, as it may be at the limit of the bits JS uses in bitshifts
        }
        return value;
    }

    Math['imul'] = function imul(a, b) {
        return (a * b) | 0; // fast but imprecise
    };
    Math.imul = Math['imul'];


    var Math_abs = Math.abs;
    var Math_cos = Math.cos;
    var Math_sin = Math.sin;
    var Math_tan = Math.tan;
    var Math_acos = Math.acos;
    var Math_asin = Math.asin;
    var Math_atan = Math.atan;
    var Math_atan2 = Math.atan2;
    var Math_exp = Math.exp;
    var Math_log = Math.log;
    var Math_sqrt = Math.sqrt;
    var Math_ceil = Math.ceil;
    var Math_floor = Math.floor;
    var Math_pow = Math.pow;
    var Math_imul = Math.imul;
    var Math_fround = Math.fround;
    var Math_min = Math.min;

    // A counter of dependencies for calling run(). If we need to
    // do asynchronous work before running, increment this and
    // decrement it. Incrementing must happen in a place like
    // PRE_RUN_ADDITIONS (used by emcc to add file preloading).
    // Note that you can add dependencies in preRun, even though
    // it happens right before run - run will be postponed until
    // the dependencies are met.
    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null; // overridden to take different actions when all run dependencies are fulfilled

    function addRunDependency(id) {
        runDependencies++;
        if (Module['monitorRunDependencies']) {
            Module['monitorRunDependencies'](runDependencies);
        }
    }
    Module['addRunDependency'] = addRunDependency;

    function removeRunDependency(id) {
        runDependencies--;
        if (Module['monitorRunDependencies']) {
            Module['monitorRunDependencies'](runDependencies);
        }
        if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
                clearInterval(runDependencyWatcher);
                runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
                var callback = dependenciesFulfilled;
                dependenciesFulfilled = null;
                callback(); // can add another dependenciesFulfilled
            }
        }
    }
    Module['removeRunDependency'] = removeRunDependency;

    Module["preloadedImages"] = {}; // maps url to image data
    Module["preloadedAudios"] = {}; // maps url to audio data


    var memoryInitializer = null;

    // === Body ===



    STATIC_BASE = 8;

    STATICTOP = STATIC_BASE + 51944;



    var _stdout;
    var _stdout = _stdout = allocate(1, "i32*", ALLOC_STATIC);
    var _stdin;
    var _stdin = _stdin = allocate(1, "i32*", ALLOC_STATIC);
    var _stderr;
    var _stderr = _stderr = allocate(1, "i32*", ALLOC_STATIC);

    /* global initializers */
    __ATINIT__.push({ func: function() { runPostSets() } }, { func: function() { __GLOBAL__I_a() } });





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    var ___dso_handle;
    var ___dso_handle = ___dso_handle = allocate(1, "i32*", ALLOC_STATIC);










































































































































    var __ZTVN10__cxxabiv120__si_class_type_infoE;
    __ZTVN10__cxxabiv120__si_class_type_infoE = allocate([0, 0, 0, 0, 160, 105, 0, 0, 250, 0, 0, 0, 172, 0, 0, 0, 70, 0, 0, 0, 178, 0, 0, 0, 8, 0, 0, 0, 10, 0, 0, 0, 6, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "i8", ALLOC_STATIC);;
    var __ZTVN10__cxxabiv117__class_type_infoE;
    __ZTVN10__cxxabiv117__class_type_infoE = allocate([0, 0, 0, 0, 176, 105, 0, 0, 250, 0, 0, 0, 38, 1, 0, 0, 70, 0, 0, 0, 178, 0, 0, 0, 8, 0, 0, 0, 28, 0, 0, 0, 8, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "i8", ALLOC_STATIC);;




























































































































































































    var __ZTISt9exception;
    var __ZTISt9exception = __ZTISt9exception = allocate([allocate([1, 0, 0, 0, 0, 0, 0], "i8", ALLOC_STATIC) + 8, 0], "i32", ALLOC_STATIC);






















































































































































































































































































































































































































































    var __ZN19context_model_tableC1Ev;
    var __ZN19context_model_tableC1ERKS_;
    var __ZN19context_model_tableD1Ev;
    var __ZN15decoder_contextC1Ev;
    var __ZN22decoded_picture_bufferC1Ev;
    var __ZN22decoded_picture_bufferD1Ev;
    var __ZN11de265_imageC1Ev;
    var __ZN11de265_imageD1Ev;
    var __ZN10NAL_ParserC1Ev;
    var __ZN10NAL_ParserD1Ev;
    var __ZN17pic_parameter_setC1Ev;
    var __ZN17pic_parameter_setD1Ev;
    var __ZN17seq_parameter_setC1Ev;
    var __ZN17seq_parameter_setD1Ev;
    var __ZN19de265_progress_lockC1Ev;
    var __ZN19de265_progress_lockD1Ev;
    var __ZN27video_usability_informationC1Ev;
    var __ZNSt13runtime_errorC1EPKc;
    var __ZNSt13runtime_errorD1Ev;
    var __ZNSt12length_errorD1Ev;
    var __ZNSt3__16localeC1Ev;
    var __ZNSt3__16localeC1ERKS0_;
    var __ZNSt3__16localeD1Ev;
    var __ZNSt8bad_castC1Ev;
    var __ZNSt8bad_castD1Ev;
    /* memory initializer */
    allocate([29, 0, 0, 0, 30, 0, 0, 0, 31, 0, 0, 0, 32, 0, 0, 0, 33, 0, 0, 0, 33, 0, 0, 0, 34, 0, 0, 0, 34, 0, 0, 0, 35, 0, 0, 0, 35, 0, 0, 0, 36, 0, 0, 0, 36, 0, 0, 0, 37, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 26, 0, 0, 0, 21, 0, 0, 0, 17, 0, 0, 0, 13, 0, 0, 0, 9, 0, 0, 0, 5, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 254, 255, 255, 255, 251, 255, 255, 255, 247, 255, 255, 255, 243, 255, 255, 255, 239, 255, 255, 255, 235, 255, 255, 255, 230, 255, 255, 255, 224, 255, 255, 255, 230, 255, 255, 255, 235, 255, 255, 255, 239, 255, 255, 255, 243, 255, 255, 255, 247, 255, 255, 255, 251, 255, 255, 255, 254, 255, 255, 255, 0, 0, 0, 0, 2, 0, 0, 0, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 0, 0, 0, 26, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 95, 112, 137, 0, 255, 9, 47, 15, 10, 0, 0, 0, 100, 0, 0, 0, 232, 3, 0, 0, 16, 39, 0, 0, 160, 134, 1, 0, 64, 66, 15, 0, 128, 150, 152, 0, 0, 225, 245, 5, 111, 118, 101, 114, 115, 99, 97, 110, 95, 97, 112, 112, 114, 111, 112, 114, 105, 97, 116, 101, 95, 102, 108, 97, 103, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 74, 117, 108, 0, 0, 0, 0, 0, 118, 112, 115, 95, 109, 97, 120, 95, 115, 117, 98, 95, 108, 97, 121, 101, 114, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 80, 80, 83, 32, 37, 100, 32, 104, 97, 115, 32, 110, 111, 116, 32, 98, 101, 101, 110, 32, 114, 101, 97, 100, 10, 0, 0, 0, 0, 0, 0, 0, 74, 117, 110, 0, 0, 0, 0, 0, 52, 58, 50, 58, 48, 0, 0, 0, 65, 112, 114, 0, 0, 0, 0, 0, 77, 97, 114, 0, 0, 0, 0, 0, 70, 101, 98, 0, 0, 0, 0, 0, 99, 111, 110, 116, 101, 120, 116, 32, 62, 61, 32, 48, 32, 38, 38, 32, 99, 111, 110, 116, 101, 120, 116, 32, 60, 61, 32, 50, 0, 0, 0, 0, 108, 111, 103, 50, 95, 115, 97, 111, 95, 111, 102, 102, 115, 101, 116, 95, 115, 99, 97, 108, 101, 95, 99, 104, 114, 111, 109, 97, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 99, 97, 110, 110, 111, 116, 32, 115, 116, 97, 114, 116, 32, 100, 101, 99, 111, 100, 105, 110, 103, 32, 116, 104, 114, 101, 97, 100, 115, 0, 0, 0, 74, 97, 110, 0, 0, 0, 0, 0, 102, 97, 108, 115, 101, 0, 0, 0, 46, 46, 47, 108, 105, 98, 100, 101, 50, 54, 53, 47, 105, 109, 97, 103, 101, 46, 104, 0, 0, 0, 0, 0, 117, 110, 105, 116, 88, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 88, 32, 60, 32, 119, 105, 100, 116, 104, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 0, 42, 114, 101, 102, 99, 110, 116, 62, 49, 0, 0, 0, 0, 0, 0, 0, 68, 101, 99, 101, 109, 98, 101, 114, 0, 0, 0, 0, 0, 0, 0, 0, 105, 100, 120, 60, 105, 110, 116, 114, 97, 80, 114, 101, 100, 77, 111, 100, 101, 67, 46, 100, 97, 116, 97, 95, 115, 105, 122, 101, 0, 0, 0, 0, 99, 111, 109, 112, 111, 110, 101, 110, 116, 0, 0, 0, 0, 0, 0, 0, 78, 111, 118, 101, 109, 98, 101, 114, 0, 0, 0, 0, 0, 0, 0, 0, 121, 60, 115, 112, 115, 46, 80, 105, 99, 72, 101, 105, 103, 104, 116, 73, 110, 77, 105, 110, 80, 85, 115, 0, 79, 99, 116, 111, 98, 101, 114, 0, 117, 110, 115, 117, 112, 112, 111, 114, 116, 101, 100, 32, 108, 111, 99, 97, 108, 101, 32, 102, 111, 114, 32, 115, 116, 97, 110, 100, 97, 114, 100, 32, 105, 110, 112, 117, 116, 0, 0, 0, 120, 60, 115, 112, 115, 46, 80, 105, 99, 87, 105, 100, 116, 104, 73, 110, 77, 105, 110, 80, 85, 115, 0, 0, 83, 101, 112, 116, 101, 109, 98, 101, 114, 0, 0, 0, 0, 0, 0, 0, 117, 110, 105, 116, 89, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 89, 32, 60, 32, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 111, 118, 101, 114, 115, 99, 97, 110, 95, 105, 110, 102, 111, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 65, 117, 103, 117, 115, 116, 0, 0, 46, 46, 47, 108, 105, 98, 100, 101, 50, 54, 53, 47, 105, 109, 97, 103, 101, 46, 104, 0, 0, 0, 0, 0, 118, 112, 115, 95, 109, 97, 120, 95, 108, 97, 121, 101, 114, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 104, 100, 114, 45, 62, 110, 117, 109, 95, 114, 101, 102, 95, 105, 100, 120, 95, 108, 49, 95, 97, 99, 116, 105, 118, 101, 32, 60, 61, 32, 49, 54, 0, 0, 0, 0, 0, 0, 0, 0, 74, 117, 108, 121, 0, 0, 0, 0, 117, 110, 105, 116, 88, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 88, 32, 60, 32, 119, 105, 100, 116, 104, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 0, 74, 117, 110, 101, 0, 0, 0, 0, 109, 111, 110, 111, 99, 104, 114, 111, 109, 101, 0, 0, 0, 0, 0, 0, 77, 97, 121, 0, 0, 0, 0, 0, 65, 112, 114, 105, 108, 0, 0, 0, 115, 108, 105, 99, 101, 45, 115, 101, 103, 109, 101, 110, 116, 45, 37, 100, 59, 37, 100, 0, 0, 0, 0, 0, 108, 111, 103, 50, 95, 115, 97, 111, 95, 111, 102, 102, 115, 101, 116, 95, 115, 99, 97, 108, 101, 95, 108, 117, 109, 97, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 68, 80, 66, 47, 111, 117, 116, 112, 117, 116, 32, 113, 117, 101, 117, 101, 32, 102, 117, 108, 108, 0, 0, 0, 69, 82, 82, 58, 32, 0, 0, 0, 77, 97, 114, 99, 104, 0, 0, 0, 99, 116, 98, 45, 114, 111, 119, 45, 37, 100, 0, 0, 0, 0, 0, 0, 117, 110, 105, 116, 88, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 88, 32, 60, 32, 119, 105, 100, 116, 104, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 0, 70, 101, 98, 114, 117, 97, 114, 121, 0, 0, 0, 0, 0, 0, 0, 0, 37, 112, 32, 97, 115, 115, 105, 103, 110, 32, 61, 32, 37, 112, 10, 0, 98, 97, 115, 105, 99, 95, 115, 116, 114, 105, 110, 103, 0, 0, 0, 0, 33, 40, 116, 114, 97, 102, 111, 68, 101, 112, 116, 104, 61, 61, 48, 32, 38, 38, 32, 108, 111, 103, 50, 84, 114, 97, 102, 111, 83, 105, 122, 101, 61, 61, 50, 41, 0, 0, 0, 0, 74, 97, 110, 117, 97, 114, 121, 0, 80, 114, 101, 100, 77, 111, 100, 101, 32, 61, 61, 32, 99, 117, 80, 114, 101, 100, 77, 111, 100, 101, 0, 0, 99, 98, 102, 95, 108, 117, 109, 97, 32, 33, 61, 32, 45, 49, 0, 0, 68, 0, 0, 0, 101, 0, 0, 0, 99, 0, 0, 0, 0, 0, 0, 0, 99, 98, 102, 95, 99, 114, 32, 33, 61, 32, 45, 49, 0, 0, 0, 0, 108, 101, 110, 103, 116, 104, 32, 62, 61, 32, 48, 0, 0, 0, 0, 0, 99, 97, 98, 97, 99, 95, 98, 121, 112, 97, 115, 115, 95, 97, 108, 105, 103, 110, 109, 101, 110, 116, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 115, 97, 109, 112, 108, 101, 32, 97, 115, 112, 101, 99, 116, 32, 114, 97, 116, 105, 111, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 58, 37, 100, 10, 0, 0, 0, 0, 0, 78, 0, 0, 0, 111, 0, 0, 0, 118, 0, 0, 0, 0, 0, 0, 0, 99, 98, 102, 95, 99, 98, 32, 33, 61, 32, 45, 49, 0, 0, 0, 0, 112, 101, 114, 115, 105, 115, 116, 101, 110, 116, 95, 114, 105, 99, 101, 95, 97, 100, 97, 112, 116, 97, 116, 105, 111, 110, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 118, 105, 100, 101, 111, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 115, 101, 116, 95, 105, 100, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 104, 100, 114, 45, 62, 110, 117, 109, 95, 114, 101, 102, 95, 105, 100, 120, 95, 108, 48, 95, 97, 99, 116, 105, 118, 101, 32, 60, 61, 32, 49, 54, 0, 0, 0, 0, 0, 0, 0, 0, 79, 0, 0, 0, 99, 0, 0, 0, 116, 0, 0, 0, 0, 0, 0, 0, 99, 116, 120, 73, 100, 120, 76, 111, 111, 107, 117, 112, 91, 108, 111, 103, 50, 119, 45, 50, 93, 91, 99, 73, 100, 120, 93, 91, 115, 99, 97, 110, 73, 100, 120, 93, 91, 112, 114, 101, 118, 67, 115, 98, 102, 93, 91, 120, 67, 43, 40, 121, 67, 60, 60, 108, 111, 103, 50, 119, 41, 93, 32, 61, 61, 32, 99, 116, 120, 73, 100, 120, 73, 110, 99, 0, 0, 0, 0, 0, 104, 105, 103, 104, 95, 112, 114, 101, 99, 105, 115, 105, 111, 110, 95, 111, 102, 102, 115, 101, 116, 115, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 105, 110, 105, 116, 84, 121, 112, 101, 32, 62, 61, 32, 48, 32, 38, 38, 32, 105, 110, 105, 116, 84, 121, 112, 101, 32, 60, 61, 32, 50, 0, 0, 100, 101, 98, 108, 111, 99, 107, 45, 37, 100, 0, 0, 0, 0, 0, 0, 83, 0, 0, 0, 101, 0, 0, 0, 112, 0, 0, 0, 0, 0, 0, 0, 99, 104, 114, 111, 109, 97, 95, 102, 111, 114, 109, 97, 116, 95, 105, 100, 99, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 32, 40, 37, 115, 41, 10, 0, 0, 0, 0, 0, 0, 116, 104, 114, 101, 97, 100, 95, 99, 111, 110, 116, 101, 120, 116, 115, 61, 61, 78, 85, 76, 76, 0, 0, 0, 105, 110, 116, 114, 97, 95, 115, 109, 111, 111, 116, 104, 105, 110, 103, 95, 100, 105, 115, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 65, 0, 0, 0, 117, 0, 0, 0, 103, 0, 0, 0, 0, 0, 0, 0, 101, 110, 116, 114, 121, 32, 112, 111, 105, 110, 116, 32, 91, 37, 105, 93, 32, 58, 32, 37, 100, 10, 0, 0, 101, 120, 116, 101, 110, 100, 101, 100, 95, 112, 114, 101, 99, 105, 115, 105, 111, 110, 95, 112, 114, 111, 99, 101, 115, 115, 105, 110, 103, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 74, 0, 0, 0, 117, 0, 0, 0, 108, 0, 0, 0, 0, 0, 0, 0, 111, 102, 102, 115, 101, 116, 95, 108, 101, 110, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 99, 114, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 95, 108, 105, 115, 116, 91, 37, 100, 93, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 101, 120, 112, 108, 105, 99, 105, 116, 95, 114, 100, 112, 99, 109, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 99, 111, 100, 101, 100, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 111, 117, 116, 32, 111, 102, 32, 114, 97, 110, 103, 101, 0, 0, 0, 0, 74, 0, 0, 0, 117, 0, 0, 0, 110, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 95, 101, 110, 116, 114, 121, 95, 112, 111, 105, 110, 116, 95, 111, 102, 102, 115, 101, 116, 115, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 77, 86, 80, 67, 97, 110, 100, 76, 88, 61, 61, 50, 0, 105, 109, 112, 108, 105, 99, 105, 116, 95, 114, 100, 112, 99, 109, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 110, 84, 104, 114, 101, 97, 100, 115, 82, 117, 110, 110, 105, 110, 103, 32, 62, 61, 32, 48, 0, 0, 0, 0, 77, 0, 0, 0, 97, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 99, 111, 110, 116, 101, 120, 116, 109, 111, 100, 101, 108, 46, 99, 99, 0, 115, 108, 105, 99, 101, 95, 108, 111, 111, 112, 95, 102, 105, 108, 116, 101, 114, 95, 97, 99, 114, 111, 115, 115, 95, 115, 108, 105, 99, 101, 115, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 115, 107, 105, 112, 95, 99, 111, 110, 116, 101, 120, 116, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 65, 0, 0, 0, 112, 0, 0, 0, 114, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 116, 99, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 115, 107, 105, 112, 95, 114, 111, 116, 97, 116, 105, 111, 110, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 77, 0, 0, 0, 97, 0, 0, 0, 114, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 98, 101, 116, 97, 95, 111, 102, 102, 115, 101, 116, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 32, 83, 80, 83, 45, 114, 97, 110, 103, 101, 45, 101, 120, 116, 101, 110, 115, 105, 111, 110, 32, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 10, 0, 0, 0, 0, 0, 0, 0, 0, 114, 101, 102, 60, 55, 0, 0, 0, 70, 0, 0, 0, 101, 0, 0, 0, 98, 0, 0, 0, 0, 0, 0, 0, 40, 102, 114, 111, 109, 32, 112, 112, 115, 41, 0, 0, 0, 0, 0, 0, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 32, 86, 85, 73, 32, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 10, 0, 0, 0, 0, 0, 0, 0, 0, 74, 0, 0, 0, 97, 0, 0, 0, 110, 0, 0, 0, 0, 0, 0, 0, 40, 111, 118, 101, 114, 114, 105, 100, 101, 41, 0, 0, 0, 0, 0, 0, 115, 99, 97, 108, 105, 110, 103, 95, 108, 105, 115, 116, 95, 112, 114, 101, 100, 95, 109, 97, 116, 114, 105, 120, 95, 105, 100, 95, 100, 101, 108, 116, 97, 61, 61, 49, 0, 0, 0, 0, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 32, 86, 80, 83, 32, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 10, 0, 0, 0, 0, 0, 0, 0, 0, 117, 110, 105, 116, 89, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 89, 32, 60, 32, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 68, 0, 0, 0, 101, 0, 0, 0, 99, 0, 0, 0, 101, 0, 0, 0, 109, 0, 0, 0, 98, 0, 0, 0, 101, 0, 0, 0, 114, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 105, 100, 120, 62, 61, 48, 0, 0, 115, 108, 105, 99, 101, 95, 100, 101, 98, 108, 111, 99, 107, 105, 110, 103, 95, 102, 105, 108, 116, 101, 114, 95, 100, 105, 115, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 32, 37, 115, 10, 0, 0, 48, 0, 0, 0, 0, 0, 0, 0, 100, 101, 98, 108, 111, 99, 107, 105, 110, 103, 95, 102, 105, 108, 116, 101, 114, 95, 111, 118, 101, 114, 114, 105, 100, 101, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 78, 0, 0, 0, 111, 0, 0, 0, 118, 0, 0, 0, 101, 0, 0, 0, 109, 0, 0, 0, 98, 0, 0, 0, 101, 0, 0, 0, 114, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 115, 101, 113, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 115, 101, 116, 95, 105, 100, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 114, 101, 102, 80, 105, 99, 81, 48, 61, 61, 114, 101, 102, 80, 105, 99, 81, 49, 0, 0, 0, 0, 0, 0, 83, 117, 98, 72, 101, 105, 103, 104, 116, 67, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 79, 0, 0, 0, 99, 0, 0, 0, 116, 0, 0, 0, 111, 0, 0, 0, 98, 0, 0, 0, 101, 0, 0, 0, 114, 0, 0, 0, 0, 0, 0, 0, 105, 110, 102, 105, 110, 105, 116, 121, 0, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 99, 114, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 83, 117, 98, 87, 105, 100, 116, 104, 67, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 83, 0, 0, 0, 101, 0, 0, 0, 112, 0, 0, 0, 116, 0, 0, 0, 101, 0, 0, 0, 109, 0, 0, 0, 98, 0, 0, 0, 101, 0, 0, 0, 114, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 99, 98, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 99, 98, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 95, 108, 105, 115, 116, 91, 37, 100, 93, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 80, 105, 99, 72, 101, 105, 103, 104, 116, 73, 110, 67, 116, 98, 115, 89, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 111, 117, 116, 32, 111, 102, 32, 109, 101, 109, 111, 114, 121, 0, 0, 0, 65, 0, 0, 0, 117, 0, 0, 0, 103, 0, 0, 0, 117, 0, 0, 0, 115, 0, 0, 0, 116, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 113, 112, 95, 100, 101, 108, 116, 97, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 114, 101, 102, 73, 100, 120, 66, 62, 61, 48, 0, 0, 0, 0, 0, 0, 117, 110, 105, 116, 89, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 89, 32, 60, 32, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 80, 105, 99, 87, 105, 100, 116, 104, 73, 110, 67, 116, 98, 115, 89, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 101, 110, 100, 32, 37, 32, 50, 32, 61, 61, 32, 48, 0, 0, 0, 0, 74, 0, 0, 0, 117, 0, 0, 0, 108, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 114, 101, 102, 99, 110, 116, 0, 0, 102, 105, 118, 101, 95, 109, 105, 110, 117, 115, 95, 109, 97, 120, 95, 110, 117, 109, 95, 109, 101, 114, 103, 101, 95, 99, 97, 110, 100, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 77, 97, 120, 84, 66, 83, 105, 122, 101, 89, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 74, 0, 0, 0, 117, 0, 0, 0, 110, 0, 0, 0, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 67, 104, 114, 111, 109, 97, 79, 102, 102, 115, 101, 116, 95, 76, 37, 100, 91, 37, 100, 93, 91, 37, 100, 93, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 77, 105, 110, 84, 66, 83, 105, 122, 101, 89, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 67, 104, 114, 111, 109, 97, 87, 101, 105, 103, 104, 116, 95, 76, 37, 100, 91, 37, 100, 93, 91, 37, 100, 93, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 77, 97, 120, 67, 98, 83, 105, 122, 101, 89, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 108, 117, 109, 97, 95, 111, 102, 102, 115, 101, 116, 95, 108, 37, 100, 91, 37, 100, 93, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 65, 0, 0, 0, 112, 0, 0, 0, 114, 0, 0, 0, 105, 0, 0, 0, 108, 0, 0, 0, 0, 0, 0, 0, 77, 105, 110, 67, 98, 83, 105, 122, 101, 89, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 76, 117, 109, 97, 87, 101, 105, 103, 104, 116, 95, 76, 37, 100, 91, 37, 100, 93, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 117, 110, 115, 112, 101, 99, 105, 102, 105, 101, 100, 0, 0, 0, 0, 0, 77, 0, 0, 0, 97, 0, 0, 0, 114, 0, 0, 0, 99, 0, 0, 0, 104, 0, 0, 0, 0, 0, 0, 0, 76, 111, 103, 50, 77, 97, 120, 84, 114, 97, 110, 115, 102, 111, 114, 109, 83, 107, 105, 112, 83, 105, 122, 101, 32, 32, 32, 32, 40, 82, 69, 120, 116, 41, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 67, 116, 98, 83, 105, 122, 101, 89, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 67, 104, 114, 111, 109, 97, 76, 111, 103, 50, 87, 101, 105, 103, 104, 116, 68, 101, 110, 111, 109, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 46, 46, 47, 108, 105, 98, 100, 101, 50, 54, 53, 47, 105, 109, 97, 103, 101, 46, 104, 0, 0, 0, 0, 0, 99, 116, 120, 45, 62, 100, 112, 98, 46, 104, 97, 115, 95, 102, 114, 101, 101, 95, 100, 112, 98, 95, 112, 105, 99, 116, 117, 114, 101, 40, 116, 114, 117, 101, 41, 0, 0, 0, 0, 0, 70, 0, 0, 0, 101, 0, 0, 0, 98, 0, 0, 0, 114, 0, 0, 0, 117, 0, 0, 0, 97, 0, 0, 0, 114, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 76, 111, 103, 50, 77, 105, 110, 67, 117, 67, 104, 114, 111, 109, 97, 81, 112, 79, 102, 102, 115, 101, 116, 83, 105, 122, 101, 32, 40, 82, 69, 120, 116, 41, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 115, 112, 115, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 54, 98, 105, 116, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 108, 117, 109, 97, 95, 108, 111, 103, 50, 95, 119, 101, 105, 103, 104, 116, 95, 100, 101, 110, 111, 109, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 117, 110, 105, 116, 89, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 89, 32, 60, 32, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 74, 0, 0, 0, 97, 0, 0, 0, 110, 0, 0, 0, 117, 0, 0, 0, 97, 0, 0, 0, 114, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 115, 112, 115, 95, 116, 101, 109, 112, 111, 114, 97, 108, 95, 105, 100, 95, 110, 101, 115, 116, 105, 110, 103, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 76, 111, 103, 50, 77, 105, 110, 67, 117, 81, 112, 68, 101, 108, 116, 97, 83, 105, 122, 101, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 115, 112, 115, 95, 109, 117, 108, 116, 105, 108, 97, 121, 101, 114, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 99, 111, 108, 108, 111, 99, 97, 116, 101, 100, 95, 114, 101, 102, 95, 105, 100, 120, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 112, 112, 115, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 54, 98, 105, 116, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 115, 112, 115, 95, 114, 97, 110, 103, 101, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 99, 111, 108, 108, 111, 99, 97, 116, 101, 100, 95, 102, 114, 111, 109, 95, 108, 48, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 80, 77, 0, 0, 0, 0, 0, 0, 112, 112, 115, 95, 109, 117, 108, 116, 105, 108, 97, 121, 101, 114, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 99, 104, 114, 111, 109, 97, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 95, 108, 105, 115, 116, 95, 108, 101, 110, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 115, 112, 115, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 99, 97, 98, 97, 99, 95, 105, 110, 105, 116, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 67, 84, 66, 32, 111, 117, 116, 115, 105, 100, 101, 32, 111, 102, 32, 105, 109, 97, 103, 101, 32, 97, 114, 101, 97, 0, 0, 0, 0, 0, 0, 0, 65, 77, 0, 0, 0, 0, 0, 0, 82, 73, 100, 120, 62, 61, 48, 0, 112, 112, 115, 95, 114, 97, 110, 103, 101, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 114, 101, 102, 80, 105, 99, 76, 105, 115, 116, 62, 61, 48, 0, 0, 0, 46, 46, 47, 108, 105, 98, 100, 101, 50, 54, 53, 47, 105, 109, 97, 103, 101, 46, 104, 0, 0, 0, 0, 0, 118, 117, 105, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 109, 118, 100, 95, 108, 49, 95, 122, 101, 114, 111, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 102, 105, 114, 115, 116, 32, 37, 32, 50, 32, 61, 61, 32, 48, 0, 0, 112, 112, 115, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 37, 112, 32, 100, 101, 99, 111, 117, 112, 108, 101, 32, 40, 37, 112, 41, 10, 0, 0, 0, 0, 0, 0, 0, 115, 116, 114, 111, 110, 103, 95, 105, 110, 116, 114, 97, 95, 115, 109, 111, 111, 116, 104, 105, 110, 103, 95, 101, 110, 97, 98, 108, 101, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 114, 101, 102, 95, 112, 105, 99, 95, 108, 105, 115, 116, 95, 109, 111, 100, 105, 102, 105, 99, 97, 116, 105, 111, 110, 95, 102, 108, 97, 103, 95, 108, 49, 32, 58, 32, 37, 100, 10, 0, 80, 0, 0, 0, 77, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 115, 101, 103, 109, 101, 110, 116, 95, 104, 101, 97, 100, 101, 114, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 115, 112, 115, 95, 116, 101, 109, 112, 111, 114, 97, 108, 95, 109, 118, 112, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 37, 100, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 65, 0, 0, 0, 77, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 95, 101, 120, 116, 114, 97, 95, 115, 108, 105, 99, 101, 95, 104, 101, 97, 100, 101, 114, 95, 98, 105, 116, 115, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 40, 117, 110, 107, 110, 111, 119, 110, 41, 0, 0, 0, 0, 0, 0, 0, 108, 116, 95, 114, 101, 102, 95, 112, 105, 99, 95, 112, 111, 99, 95, 108, 115, 98, 95, 115, 112, 115, 91, 37, 100, 93, 32, 58, 32, 37, 100, 32, 32, 32, 40, 117, 115, 101, 100, 95, 98, 121, 95, 99, 117, 114, 114, 95, 112, 105, 99, 95, 108, 116, 95, 115, 112, 115, 95, 102, 108, 97, 103, 61, 37, 100, 41, 10, 0, 0, 0, 0, 114, 101, 102, 95, 112, 105, 99, 95, 108, 105, 115, 116, 95, 109, 111, 100, 105, 102, 105, 99, 97, 116, 105, 111, 110, 95, 102, 108, 97, 103, 95, 108, 48, 32, 58, 32, 37, 100, 10, 0, 108, 111, 103, 50, 95, 112, 97, 114, 97, 108, 108, 101, 108, 95, 109, 101, 114, 103, 101, 95, 108, 101, 118, 101, 108, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 70, 111, 114, 109, 97, 116, 82, 97, 110, 103, 101, 69, 120, 116, 101, 110, 115, 105, 111, 110, 115, 0, 0, 0, 110, 117, 109, 95, 108, 111, 110, 103, 95, 116, 101, 114, 109, 95, 114, 101, 102, 95, 112, 105, 99, 115, 95, 115, 112, 115, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 95, 114, 101, 102, 95, 105, 100, 120, 95, 108, 49, 95, 97, 99, 116, 105, 118, 101, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 32, 37, 115, 10, 0, 108, 105, 115, 116, 115, 95, 109, 111, 100, 105, 102, 105, 99, 97, 116, 105, 111, 110, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 77, 65, 67, 0, 0, 0, 0, 0, 99, 104, 97, 110, 110, 101, 108, 62, 61, 48, 32, 38, 38, 32, 99, 104, 97, 110, 110, 101, 108, 32, 60, 61, 32, 50, 0, 0, 0, 0, 0, 0, 77, 97, 105, 110, 83, 116, 105, 108, 108, 80, 105, 99, 116, 117, 114, 101, 0, 0, 0, 0, 0, 0, 0, 0, 108, 111, 110, 103, 95, 116, 101, 114, 109, 95, 114, 101, 102, 95, 112, 105, 99, 115, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 40, 102, 114, 111, 109, 32, 80, 80, 83, 41, 0, 0, 0, 0, 0, 0, 112, 105, 99, 95, 115, 99, 97, 108, 105, 110, 103, 95, 108, 105, 115, 116, 95, 100, 97, 116, 97, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 117, 110, 105, 116, 88, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 88, 32, 60, 32, 119, 105, 100, 116, 104, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 0, 110, 97, 108, 0, 0, 0, 0, 0, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 32, 80, 80, 83, 32, 114, 97, 110, 103, 101, 45, 101, 120, 116, 101, 110, 115, 105, 111, 110, 32, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 10, 0, 0, 0, 0, 0, 0, 100, 101, 50, 54, 53, 46, 99, 99, 0, 0, 0, 0, 0, 0, 0, 0, 77, 97, 105, 110, 49, 48, 0, 0, 114, 101, 102, 95, 112, 105, 99, 95, 115, 101, 116, 91, 32, 37, 50, 100, 32, 93, 58, 32, 0, 0, 0, 0, 116, 99, 95, 111, 102, 102, 115, 101, 116, 58, 32, 32, 32, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 46, 46, 47, 108, 105, 98, 100, 101, 50, 54, 53, 47, 105, 109, 97, 103, 101, 46, 104, 0, 0, 0, 0, 0, 115, 112, 115, 95, 109, 97, 120, 95, 115, 117, 98, 95, 108, 97, 121, 101, 114, 115, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 102, 97, 108, 115, 101, 0, 0, 0, 77, 97, 105, 110, 0, 0, 0, 0, 110, 117, 109, 95, 115, 104, 111, 114, 116, 95, 116, 101, 114, 109, 95, 114, 101, 102, 95, 112, 105, 99, 95, 115, 101, 116, 115, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 95, 114, 101, 102, 95, 105, 100, 120, 95, 108, 48, 95, 97, 99, 116, 105, 118, 101, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 32, 37, 115, 10, 0, 98, 101, 116, 97, 95, 111, 102, 102, 115, 101, 116, 58, 32, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 117, 110, 107, 110, 111, 119, 110, 32, 101, 114, 114, 111, 114, 0, 0, 0, 112, 99, 109, 95, 108, 111, 111, 112, 95, 102, 105, 108, 116, 101, 114, 95, 100, 105, 115, 97, 98, 108, 101, 95, 102, 108, 97, 103, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 112, 101, 110, 100, 105, 110, 103, 95, 105, 110, 112, 117, 116, 95, 78, 65, 76, 32, 61, 61, 32, 78, 85, 76, 76, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 95, 114, 101, 102, 95, 105, 100, 120, 95, 97, 99, 116, 105, 118, 101, 95, 111, 118, 101, 114, 114, 105, 100, 101, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 115, 97, 111, 45, 37, 100, 0, 0, 112, 105, 99, 95, 100, 105, 115, 97, 98, 108, 101, 95, 100, 101, 98, 108, 111, 99, 107, 105, 110, 103, 95, 102, 105, 108, 116, 101, 114, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 99, 111, 108, 108, 111, 99, 97, 116, 101, 100, 32, 109, 111, 116, 105, 111, 110, 45, 118, 101, 99, 116, 111, 114, 32, 105, 115, 32, 111, 117, 116, 115, 105, 100, 101, 32, 105, 109, 97, 103, 101, 32, 97, 114, 101, 97, 0, 0, 32, 32, 80, 114, 111, 102, 105, 108, 101, 47, 84, 105, 101, 114, 47, 76, 101, 118, 101, 108, 32, 91, 76, 97, 121, 101, 114, 32, 37, 100, 93, 10, 0, 0, 0, 0, 0, 0, 0, 0, 100, 105, 102, 102, 95, 99, 117, 95, 99, 104, 114, 111, 109, 97, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 95, 100, 101, 112, 116, 104, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 108, 111, 103, 50, 95, 100, 105, 102, 102, 95, 109, 97, 120, 95, 109, 105, 110, 95, 112, 99, 109, 95, 108, 117, 109, 97, 95, 99, 111, 100, 105, 110, 103, 95, 98, 108, 111, 99, 107, 95, 115, 105, 122, 101, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 115, 97, 111, 95, 99, 104, 114, 111, 109, 97, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 100, 101, 98, 108, 111, 99, 107, 105, 110, 103, 95, 102, 105, 108, 116, 101, 114, 95, 111, 118, 101, 114, 114, 105, 100, 101, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 105, 109, 97, 103, 101, 32, 99, 104, 101, 99, 107, 115, 117, 109, 32, 109, 105, 115, 109, 97, 116, 99, 104, 0, 83, 80, 83, 32, 104, 101, 97, 100, 101, 114, 32, 109, 105, 115, 115, 105, 110, 103, 44, 32, 99, 97, 110, 110, 111, 116, 32, 100, 101, 99, 111, 100, 101, 32, 83, 69, 73, 0, 0, 0, 32, 32, 37, 115, 95, 108, 101, 118, 101, 108, 95, 105, 100, 99, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 32, 40, 37, 52, 46, 50, 102, 41, 10, 0, 0, 0, 0, 117, 110, 105, 116, 88, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 88, 32, 60, 32, 119, 105, 100, 116, 104, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 0, 108, 111, 103, 50, 95, 109, 105, 110, 95, 112, 99, 109, 95, 108, 117, 109, 97, 95, 99, 111, 100, 105, 110, 103, 95, 98, 108, 111, 99, 107, 95, 115, 105, 122, 101, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 115, 97, 111, 95, 108, 117, 109, 97, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 115, 116, 100, 58, 58, 98, 97, 100, 95, 99, 97, 115, 116, 0, 0, 0, 100, 101, 98, 108, 111, 99, 107, 105, 110, 103, 95, 102, 105, 108, 116, 101, 114, 95, 99, 111, 110, 116, 114, 111, 108, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 102, 97, 108, 115, 101, 0, 0, 0, 99, 97, 110, 110, 111, 116, 32, 97, 112, 112, 108, 121, 32, 83, 65, 79, 32, 98, 101, 99, 97, 117, 115, 101, 32, 119, 101, 32, 114, 97, 110, 32, 111, 117, 116, 32, 111, 102, 32, 109, 101, 109, 111, 114, 121, 0, 0, 0, 32, 32, 108, 111, 103, 50, 95, 109, 97, 120, 95, 109, 118, 95, 108, 101, 110, 103, 116, 104, 95, 118, 101, 114, 116, 105, 99, 97, 108, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 32, 32, 37, 115, 95, 102, 114, 97, 109, 101, 95, 111, 110, 108, 121, 95, 99, 111, 110, 115, 116, 114, 97, 105, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 37, 112, 32, 114, 101, 108, 101, 97, 115, 101, 32, 37, 112, 10, 0, 0, 112, 99, 109, 95, 115, 97, 109, 112, 108, 101, 95, 98, 105, 116, 95, 100, 101, 112, 116, 104, 95, 99, 104, 114, 111, 109, 97, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 116, 101, 109, 112, 111, 114, 97, 108, 95, 109, 118, 112, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 112, 112, 115, 95, 108, 111, 111, 112, 95, 102, 105, 108, 116, 101, 114, 95, 97, 99, 114, 111, 115, 115, 95, 115, 108, 105, 99, 101, 115, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 110, 111, 110, 45, 101, 120, 105, 115, 116, 105, 110, 103, 32, 108, 111, 110, 103, 45, 116, 101, 114, 109, 32, 114, 101, 102, 101, 114, 101, 110, 99, 101, 32, 99, 97, 110, 100, 105, 100, 97, 116, 101, 32, 115, 112, 101, 99, 105, 102, 105, 101, 100, 32, 105, 110, 32, 115, 108, 105, 99, 101, 32, 104, 101, 97, 100, 101, 114, 0, 0, 0, 0, 32, 32, 108, 111, 103, 50, 95, 109, 97, 120, 95, 109, 118, 95, 108, 101, 110, 103, 116, 104, 95, 104, 111, 114, 105, 122, 111, 110, 116, 97, 108, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 32, 32, 37, 115, 95, 110, 111, 110, 95, 112, 97, 99, 107, 101, 100, 95, 99, 111, 110, 115, 116, 114, 97, 105, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 112, 99, 109, 95, 115, 97, 109, 112, 108, 101, 95, 98, 105, 116, 95, 100, 101, 112, 116, 104, 95, 108, 117, 109, 97, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 110, 117, 109, 95, 108, 111, 110, 103, 95, 116, 101, 114, 109, 95, 112, 105, 99, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 108, 111, 111, 112, 95, 102, 105, 108, 116, 101, 114, 95, 97, 99, 114, 111, 115, 115, 95, 116, 105, 108, 101, 115, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 116, 104, 114, 101, 97, 100, 115, 32, 108, 105, 109, 105, 116, 101, 100, 32, 116, 111, 32, 109, 97, 120, 105, 109, 117, 109, 32, 97, 109, 111, 117, 110, 116, 0, 0, 0, 0, 0, 32, 32, 109, 97, 120, 95, 98, 105, 116, 115, 95, 112, 101, 114, 95, 109, 105, 110, 95, 99, 117, 95, 100, 101, 110, 111, 109, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 32, 32, 37, 115, 95, 105, 110, 116, 101, 114, 108, 97, 99, 101, 100, 95, 115, 111, 117, 114, 99, 101, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 112, 99, 109, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 95, 108, 111, 110, 103, 95, 116, 101, 114, 109, 95, 115, 112, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 116, 105, 108, 101, 32, 114, 111, 119, 32, 98, 111, 117, 110, 100, 97, 114, 105, 101, 115, 58, 32, 0, 0, 0, 100, 101, 112, 101, 110, 100, 101, 110, 116, 32, 115, 108, 105, 99, 101, 32, 119, 105, 116, 104, 32, 97, 100, 100, 114, 101, 115, 115, 32, 48, 0, 0, 32, 32, 109, 97, 120, 95, 98, 121, 116, 101, 115, 95, 112, 101, 114, 95, 112, 105, 99, 95, 100, 101, 110, 111, 109, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 32, 32, 37, 115, 95, 112, 114, 111, 103, 114, 101, 115, 115, 105, 118, 101, 95, 115, 111, 117, 114, 99, 101, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 115, 97, 109, 112, 108, 101, 95, 97, 100, 97, 112, 116, 105, 118, 101, 95, 111, 102, 102, 115, 101, 116, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 32, 115, 101, 103, 109, 101, 110, 116, 32, 97, 100, 100, 114, 101, 115, 115, 32, 105, 110, 118, 97, 108, 105, 100, 0, 0, 0, 115, 104, 111, 114, 116, 95, 116, 101, 114, 109, 95, 114, 101, 102, 95, 112, 105, 99, 95, 115, 101, 116, 95, 105, 100, 120, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 42, 10, 0, 0, 0, 0, 0, 0, 83, 69, 67, 65, 77, 0, 0, 0, 108, 111, 99, 97, 108, 101, 32, 110, 111, 116, 32, 115, 117, 112, 112, 111, 114, 116, 101, 100, 0, 0, 0, 0, 49, 46, 48, 46, 50, 0, 0, 0, 32, 32, 109, 105, 110, 95, 115, 112, 97, 116, 105, 97, 108, 95, 115, 101, 103, 109, 101, 110, 116, 97, 116, 105, 111, 110, 95, 105, 100, 99, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 42, 10, 0, 0, 0, 0, 0, 0, 97, 109, 112, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 102, 97, 108, 115, 101, 0, 0, 0, 114, 101, 102, 95, 112, 105, 99, 95, 115, 101, 116, 91, 32, 37, 50, 100, 32, 93, 58, 32, 0, 0, 0, 0, 42, 37, 100, 32, 0, 0, 0, 0, 114, 100, 112, 99, 109, 77, 111, 100, 101, 61, 61, 48, 0, 0, 0, 0, 105, 109, 103, 45, 62, 110, 117, 109, 95, 116, 104, 114, 101, 97, 100, 115, 95, 97, 99, 116, 105, 118, 101, 40, 41, 32, 61, 61, 32, 48, 0, 0, 105, 110, 118, 97, 108, 105, 100, 32, 99, 104, 114, 111, 109, 97, 32, 102, 111, 114, 109, 97, 116, 32, 105, 110, 32, 83, 80, 83, 32, 104, 101, 97, 100, 101, 114, 0, 0, 0, 0, 0, 32, 32, 114, 101, 115, 116, 114, 105, 99, 116, 101, 100, 95, 114, 101, 102, 95, 112, 105, 99, 95, 108, 105, 115, 116, 115, 95, 102, 108, 97, 103, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 42, 37, 100, 0, 0, 0, 0, 0, 115, 104, 100, 114, 45, 62, 115, 108, 105, 99, 101, 95, 116, 121, 112, 101, 32, 61, 61, 32, 83, 76, 73, 67, 69, 95, 84, 89, 80, 69, 95, 66, 0, 0, 0, 0, 0, 0, 0, 0, 115, 99, 97, 108, 105, 110, 103, 32, 108, 105, 115, 116, 32, 108, 111, 103, 103, 105, 110, 103, 32, 111, 117, 116, 112, 117, 116, 32, 110, 111, 116, 32, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 0, 0, 0, 0, 0, 109, 97, 120, 105, 109, 117, 109, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 114, 101, 102, 101, 114, 101, 110, 99, 101, 32, 112, 105, 99, 116, 117, 114, 101, 115, 32, 101, 120, 99, 101, 101, 100, 101, 100, 0, 0, 0, 115, 104, 111, 114, 116, 95, 116, 101, 114, 109, 95, 114, 101, 102, 95, 112, 105, 99, 95, 115, 101, 116, 95, 115, 112, 115, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 116, 105, 108, 101, 32, 99, 111, 108, 117, 109, 110, 32, 98, 111, 117, 110, 100, 97, 114, 105, 101, 115, 58, 32, 0, 0, 0, 0, 0, 0, 0, 0, 37, 0, 0, 0, 73, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 77, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 83, 0, 0, 0, 32, 0, 0, 0, 37, 0, 0, 0, 112, 0, 0, 0, 0, 0, 0, 0, 117, 110, 105, 116, 88, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 88, 32, 60, 32, 119, 105, 100, 116, 104, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 0, 102, 97, 108, 115, 101, 0, 0, 0, 118, 105, 100, 101, 111, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 115, 101, 116, 95, 105, 100, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 32, 32, 109, 111, 116, 105, 111, 110, 95, 118, 101, 99, 116, 111, 114, 115, 95, 111, 118, 101, 114, 95, 112, 105, 99, 95, 98, 111, 117, 110, 100, 97, 114, 105, 101, 115, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 42, 44, 0, 0, 0, 0, 0, 0, 115, 112, 115, 95, 115, 99, 97, 108, 105, 110, 103, 95, 108, 105, 115, 116, 95, 100, 97, 116, 97, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 112, 105, 99, 95, 111, 114, 100, 101, 114, 95, 99, 110, 116, 95, 108, 115, 98, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 117, 110, 105, 102, 111, 114, 109, 95, 115, 112, 97, 99, 105, 110, 103, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 37, 73, 58, 37, 77, 58, 37, 83, 32, 37, 112, 0, 0, 0, 0, 0, 115, 116, 100, 58, 58, 98, 97, 100, 95, 97, 108, 108, 111, 99, 0, 0, 101, 110, 100, 95, 111, 102, 95, 115, 117, 98, 95, 115, 116, 114, 101, 97, 109, 95, 111, 110, 101, 95, 98, 105, 116, 32, 110, 111, 116, 32, 115, 101, 116, 32, 116, 111, 32, 49, 32, 119, 104, 101, 110, 32, 105, 116, 32, 115, 104, 111, 117, 108, 100, 32, 98, 101, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 116, 105, 108, 101, 115, 95, 102, 105, 120, 101, 100, 95, 115, 116, 114, 117, 99, 116, 117, 114, 101, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 37, 115, 95, 112, 114, 111, 102, 105, 108, 101, 95, 99, 111, 109, 112, 97, 116, 105, 98, 105, 108, 105, 116, 121, 95, 102, 108, 97, 103, 115, 58, 32, 0, 0, 0, 0, 0, 0, 115, 99, 97, 108, 105, 110, 103, 95, 108, 105, 115, 116, 95, 101, 110, 97, 98, 108, 101, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 99, 111, 108, 111, 117, 114, 95, 112, 108, 97, 110, 101, 95, 105, 100, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 117, 110, 105, 116, 89, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 89, 32, 60, 32, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 110, 117, 109, 95, 116, 105, 108, 101, 95, 114, 111, 119, 115, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 106, 62, 61, 48, 32, 38, 38, 32, 106, 32, 60, 32, 77, 65, 88, 95, 78, 85, 77, 95, 82, 69, 70, 95, 80, 73, 67, 83, 0, 0, 0, 0, 37, 0, 0, 0, 97, 0, 0, 0, 32, 0, 0, 0, 37, 0, 0, 0, 98, 0, 0, 0, 32, 0, 0, 0, 37, 0, 0, 0, 100, 0, 0, 0, 32, 0, 0, 0, 37, 0, 0, 0, 72, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 77, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 83, 0, 0, 0, 32, 0, 0, 0, 37, 0, 0, 0, 89, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 102, 97, 117, 108, 116, 121, 32, 114, 101, 102, 101, 114, 101, 110, 99, 101, 32, 112, 105, 99, 116, 117, 114, 101, 32, 108, 105, 115, 116, 0, 0, 0, 98, 105, 116, 115, 116, 114, 101, 97, 109, 95, 114, 101, 115, 116, 114, 105, 99, 116, 105, 111, 110, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 37, 115, 95, 112, 114, 111, 102, 105, 108, 101, 95, 105, 100, 99, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 115, 10, 0, 0, 0, 0, 99, 104, 114, 111, 109, 97, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 95, 108, 105, 115, 116, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 109, 97, 120, 95, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 104, 105, 101, 114, 97, 114, 99, 104, 121, 95, 100, 101, 112, 116, 104, 95, 105, 110, 116, 114, 97, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 112, 105, 99, 95, 111, 117, 116, 112, 117, 116, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 110, 117, 109, 95, 116, 105, 108, 101, 95, 99, 111, 108, 117, 109, 110, 115, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 99, 111, 101, 102, 102, 105, 99, 105, 101, 110, 116, 32, 111, 117, 116, 32, 111, 102, 32, 105, 109, 97, 103, 101, 32, 98, 111, 117, 110, 100, 115, 0, 37, 97, 32, 37, 98, 32, 37, 100, 32, 37, 72, 58, 37, 77, 58, 37, 83, 32, 37, 89, 0, 0, 0, 0, 115, 104, 111, 114, 116, 45, 116, 101, 114, 109, 32, 114, 101, 102, 45, 112, 105, 99, 45, 115, 101, 116, 32, 105, 110, 100, 101, 120, 32, 111, 117, 116, 32, 111, 102, 32, 114, 97, 110, 103, 101, 0, 0, 0, 0, 0, 0, 0, 118, 117, 105, 95, 104, 114, 100, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 32, 32, 37, 115, 95, 116, 105, 101, 114, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 102, 97, 108, 115, 101, 0, 0, 0, 105, 110, 116, 114, 97, 80, 114, 101, 100, 77, 111, 100, 101, 62, 61, 50, 0, 0, 0, 0, 0, 0, 0, 0, 109, 97, 120, 95, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 104, 105, 101, 114, 97, 114, 99, 104, 121, 95, 100, 101, 112, 116, 104, 95, 105, 110, 116, 101, 114, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 116, 121, 112, 101, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 99, 10, 0, 0, 0, 0, 0, 0, 101, 110, 116, 114, 111, 112, 121, 95, 99, 111, 100, 105, 110, 103, 95, 115, 121, 110, 99, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 48, 0, 0, 0, 0, 0, 0, 0, 37, 0, 0, 0, 72], "i8", ALLOC_NONE, Runtime.GLOBAL_BASE);
    /* memory initializer */
    allocate([58, 0, 0, 0, 37, 0, 0, 0, 77, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 83, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 115, 104, 111, 114, 116, 45, 116, 101, 114, 109, 32, 114, 101, 102, 45, 112, 105, 99, 45, 115, 101, 116, 115, 32, 111, 117, 116, 32, 111, 102, 32, 114, 97, 110, 103, 101, 0, 0, 118, 117, 105, 95, 110, 117, 109, 95, 116, 105, 99, 107, 115, 95, 112, 111, 99, 95, 100, 105, 102, 102, 95, 111, 110, 101, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 32, 32, 37, 115, 95, 112, 114, 111, 102, 105, 108, 101, 95, 115, 112, 97, 99, 101, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 108, 111, 103, 50, 95, 100, 105, 102, 102, 95, 109, 97, 120, 95, 109, 105, 110, 95, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 98, 108, 111, 99, 107, 95, 115, 105, 122, 101, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 37, 112, 32, 105, 110, 105, 116, 10, 0, 0, 0, 0, 0, 0, 0, 0, 115, 108, 105, 99, 101, 95, 115, 101, 103, 109, 101, 110, 116, 95, 97, 100, 100, 114, 101, 115, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 116, 105, 108, 101, 115, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 37, 72, 58, 37, 77, 58, 37, 83, 0, 0, 0, 0, 0, 0, 0, 0, 110, 117, 109, 77, 86, 95, 80, 32, 33, 61, 32, 110, 117, 109, 77, 86, 95, 81, 32, 105, 110, 32, 100, 101, 98, 108, 111, 99, 107, 105, 110, 103, 0, 0, 0, 0, 0, 0, 0, 0, 118, 117, 105, 95, 112, 111, 99, 95, 112, 114, 111, 112, 111, 114, 116, 105, 111, 110, 97, 108, 95, 116, 111, 95, 116, 105, 109, 105, 110, 103, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 115, 117, 98, 95, 108, 97, 121, 101, 114, 0, 0, 0, 0, 0, 0, 0, 108, 111, 103, 50, 95, 109, 105, 110, 95, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 98, 108, 111, 99, 107, 95, 115, 105, 122, 101, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 100, 101, 112, 101, 110, 100, 101, 110, 116, 95, 115, 108, 105, 99, 101, 95, 115, 101, 103, 109, 101, 110, 116, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 116, 114, 97, 110, 115, 113, 117, 97, 110, 116, 95, 98, 121, 112, 97, 115, 115, 95, 101, 110, 97, 98, 108, 101, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 37, 0, 0, 0, 109, 0, 0, 0, 47, 0, 0, 0, 37, 0, 0, 0, 100, 0, 0, 0, 47, 0, 0, 0, 37, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 110, 111, 110, 45, 101, 120, 105, 115, 116, 105, 110, 103, 32, 114, 101, 102, 101, 114, 101, 110, 99, 101, 32, 112, 105, 99, 116, 117, 114, 101, 32, 97, 99, 99, 101, 115, 115, 101, 100, 0, 32, 32, 118, 117, 105, 95, 116, 105, 109, 101, 95, 115, 99, 97, 108, 101, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 103, 101, 110, 101, 114, 97, 108, 0, 108, 111, 103, 50, 95, 100, 105, 102, 102, 95, 109, 97, 120, 95, 109, 105, 110, 95, 108, 117, 109, 97, 95, 99, 111, 100, 105, 110, 103, 95, 98, 108, 111, 99, 107, 95, 115, 105, 122, 101, 32, 58, 32, 37, 100, 10, 0, 0, 115, 108, 105, 99, 101, 95, 112, 105, 99, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 115, 101, 116, 95, 105, 100, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 111, 117, 116, 112, 117, 116, 95, 102, 108, 97, 103, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 37, 109, 47, 37, 100, 47, 37, 121, 0, 0, 0, 0, 0, 0, 0, 0, 98, 111, 116, 104, 32, 112, 114, 101, 100, 70, 108, 97, 103, 115, 91, 93, 32, 97, 114, 101, 32, 122, 101, 114, 111, 32, 105, 110, 32, 77, 67, 0, 32, 32, 118, 117, 105, 95, 110, 117, 109, 95, 117, 110, 105, 116, 115, 95, 105, 110, 95, 116, 105, 99, 107, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 118, 112, 115, 95, 101, 120, 116, 101, 110, 115, 105, 111, 110, 95, 102, 108, 97, 103, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 108, 111, 103, 50, 95, 109, 105, 110, 95, 108, 117, 109, 97, 95, 99, 111, 100, 105, 110, 103, 95, 98, 108, 111, 99, 107, 95, 115, 105, 122, 101, 32, 58, 32, 37, 100, 10, 0, 0, 0, 110, 111, 95, 111, 117, 116, 112, 117, 116, 95, 111, 102, 95, 112, 114, 105, 111, 114, 95, 112, 105, 99, 115, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 119, 101, 105, 103, 104, 116, 101, 100, 95, 98, 105, 112, 114, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 78, 84, 83, 67, 0, 0, 0, 0, 33, 114, 101, 111, 114, 100, 101, 114, 95, 111, 117, 116, 112, 117, 116, 95, 113, 117, 101, 117, 101, 46, 101, 109, 112, 116, 121, 40, 41, 0, 0, 0, 110, 111, 110, 45, 101, 120, 105, 115, 116, 105, 110, 103, 32, 83, 80, 83, 32, 114, 101, 102, 101, 114, 101, 110, 99, 101, 100, 0, 0, 0, 0, 0, 118, 117, 105, 95, 116, 105, 109, 105, 110, 103, 95, 105, 110, 102, 111, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 32, 32, 115, 112, 115, 95, 109, 97, 120, 95, 108, 97, 116, 101, 110, 99, 121, 95, 105, 110, 99, 114, 101, 97, 115, 101, 95, 112, 108, 117, 115, 49, 32, 58, 32, 37, 100, 10, 0, 0, 102, 105, 114, 115, 116, 76, 97, 121, 101, 114, 82, 101, 97, 100, 32, 60, 32, 77, 65, 88, 95, 84, 69, 77, 80, 79, 82, 65, 76, 95, 83, 85, 66, 76, 65, 89, 69, 82, 83, 0, 102, 105, 114, 115, 116, 95, 115, 108, 105, 99, 101, 95, 115, 101, 103, 109, 101, 110, 116, 95, 105, 110, 95, 112, 105, 99, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 119, 101, 105, 103, 104, 116, 101, 100, 95, 112, 114, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 48, 0, 0, 0, 0, 0, 0, 0, 102, 0, 0, 0, 97, 0, 0, 0, 108, 0, 0, 0, 115, 0, 0, 0, 101, 0, 0, 0, 0, 0, 0, 0, 110, 111, 110, 45, 101, 120, 105, 115, 116, 105, 110, 103, 32, 80, 80, 83, 32, 114, 101, 102, 101, 114, 101, 110, 99, 101, 100, 0, 0, 0, 0, 0, 32, 32, 100, 101, 102, 95, 100, 105, 115, 112, 95, 119, 105, 110, 95, 98, 111, 116, 116, 111, 109, 95, 111, 102, 102, 115, 101, 116, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 102, 97, 108, 115, 101, 0, 0, 0, 104, 114, 100, 95, 108, 97, 121, 101, 114, 95, 115, 101, 116, 95, 105, 100, 120, 91, 37, 100, 93, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 37, 112, 0, 0, 0, 0, 0, 0, 32, 32, 115, 112, 115, 95, 109, 97, 120, 95, 110, 117, 109, 95, 114, 101, 111, 114, 100, 101, 114, 95, 112, 105, 99, 115, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 32, 83, 76, 73, 67, 69, 32, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 10, 0, 0, 0, 0, 0, 0, 83, 69, 73, 32, 100, 101, 99, 111, 100, 101, 100, 32, 112, 105, 99, 116, 117, 114, 101, 32, 104, 97, 115, 104, 58, 32, 37, 48, 52, 120, 44, 32, 100, 101, 99, 111, 100, 101, 100, 32, 112, 105, 99, 116, 117, 114, 101, 58, 32, 37, 48, 52, 120, 32, 40, 80, 79, 67, 61, 37, 100, 41, 10, 0, 112, 112, 115, 95, 115, 108, 105, 99, 101, 95, 99, 104, 114, 111, 109, 97, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 115, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 102, 97, 108, 115, 101, 0, 0, 0, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 32, 83, 80, 83, 32, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 10, 0, 0, 0, 0, 0, 0, 0, 0, 105, 109, 112, 111, 115, 115, 105, 98, 108, 101, 32, 109, 111, 116, 105, 111, 110, 32, 118, 101, 99, 116, 111, 114, 32, 115, 99, 97, 108, 105, 110, 103, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 100, 101, 102, 95, 100, 105, 115, 112, 95, 119, 105, 110, 95, 116, 111, 112, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 118, 112, 115, 95, 110, 117, 109, 95, 104, 114, 100, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 32, 32, 32, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 115, 112, 115, 95, 109, 97, 120, 95, 100, 101, 99, 95, 112, 105, 99, 95, 98, 117, 102, 102, 101, 114, 105, 110, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 115, 108, 105, 99, 101, 32, 104, 101, 97, 100, 101, 114, 32, 105, 110, 118, 97, 108, 105, 100, 0, 0, 0, 0, 115, 112, 115, 45, 62, 115, 112, 115, 95, 114, 101, 97, 100, 0, 0, 0, 83, 69, 73, 32, 100, 101, 99, 111, 100, 101, 100, 32, 112, 105, 99, 116, 117, 114, 101, 32, 77, 68, 53, 32, 109, 105, 115, 109, 97, 116, 99, 104, 32, 40, 80, 79, 67, 61, 37, 100, 41, 10, 0, 0, 0, 0, 0, 0, 112, 105, 99, 95, 99, 114, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 116, 0, 0, 0, 114, 0, 0, 0, 117, 0, 0, 0, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 118, 97, 108, 117, 101, 62, 48, 0, 32, 32, 100, 101, 102, 95, 100, 105, 115, 112, 95, 119, 105, 110, 95, 114, 105, 103, 104, 116, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 118, 112, 115, 95, 110, 117, 109, 95, 116, 105, 99, 107, 115, 95, 112, 111, 99, 95, 100, 105, 102, 102, 95, 111, 110, 101, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 76, 97, 121, 101, 114, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 112, 112, 115, 45, 62, 112, 112, 115, 95, 114, 101, 97, 100, 0, 0, 0, 46, 46, 47, 108, 105, 98, 100, 101, 50, 54, 53, 47, 105, 109, 97, 103, 101, 46, 104, 0, 0, 0, 0, 0, 112, 105, 99, 95, 99, 98, 95, 113, 112, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 82, 73, 100, 120, 32, 62, 61, 32, 48, 32, 38, 38, 32, 82, 73, 100, 120, 32, 60, 32, 115, 101, 116, 115, 46, 115, 105, 122, 101, 40, 41, 0, 116, 114, 117, 101, 0, 0, 0, 0, 112, 112, 115, 32, 104, 101, 97, 100, 101, 114, 32, 105, 110, 118, 97, 108, 105, 100, 0, 0, 0, 0, 0, 0, 32, 32, 100, 101, 102, 95, 100, 105, 115, 112, 95, 119, 105, 110, 95, 108, 101, 102, 116, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 118, 112, 115, 95, 112, 111, 99, 95, 112, 114, 111, 112, 111, 114, 116, 105, 111, 110, 97, 108, 95, 116, 111, 95, 116, 105, 109, 105, 110, 103, 95, 102, 108, 97, 103, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 99, 114, 111, 115, 115, 95, 99, 111, 109, 112, 111, 110, 101, 110, 116, 95, 112, 114, 101, 100, 105, 99, 116, 105, 111, 110, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 115, 112, 115, 95, 115, 117, 98, 95, 108, 97, 121, 101, 114, 95, 111, 114, 100, 101, 114, 105, 110, 103, 95, 105, 110, 102, 111, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 115, 112, 115, 32, 104, 101, 97, 100, 101, 114, 32, 105, 110, 118, 97, 108, 105, 100, 0, 0, 0, 0, 0, 0, 100, 105, 102, 102, 95, 99, 117, 95, 113, 112, 95, 100, 101, 108, 116, 97, 95, 100, 101, 112, 116, 104, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 58, 32, 0, 0, 0, 0, 0, 0, 110, 111, 32, 115, 117, 99, 104, 32, 102, 105, 108, 101, 0, 0, 0, 0, 37, 112, 32, 99, 39, 116, 111, 114, 32, 61, 32, 37, 112, 10, 0, 0, 100, 101, 102, 97, 117, 108, 116, 95, 100, 105, 115, 112, 108, 97, 121, 95, 119, 105, 110, 100, 111, 119, 95, 102, 108, 97, 103, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 118, 112, 115, 95, 116, 105, 109, 101, 95, 115, 99, 97, 108, 101, 32, 32, 32, 32, 32, 32, 32, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 99, 116, 120, 45, 62, 104, 97, 115, 95, 105, 109, 97, 103, 101, 40, 99, 111, 108, 80, 105, 99, 41, 0, 0, 105, 110, 116, 114, 97, 80, 114, 101, 100, 77, 111, 100, 101, 60, 51, 53, 0, 0, 0, 0, 0, 0, 0, 0, 108, 111, 103, 50, 95, 109, 97, 120, 95, 112, 105, 99, 95, 111, 114, 100, 101, 114, 95, 99, 110, 116, 95, 108, 115, 98, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 67, 84, 66, 32, 111, 117, 116, 115, 105, 100, 101, 32, 111, 102, 32, 105, 109, 97, 103, 101, 32, 97, 114, 101, 97, 32, 40, 99, 111, 110, 99, 101, 97, 108, 105, 110, 103, 32, 115, 116, 114, 101, 97, 109, 32, 101, 114, 114, 111, 114, 46, 46, 46, 41, 0, 0, 99, 117, 95, 113, 112, 95, 100, 101, 108, 116, 97, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 115, 112, 115, 0, 0, 0, 0, 0, 102, 114, 97, 109, 101, 95, 102, 105, 101, 108, 100, 95, 105, 110, 102, 111, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 48, 0, 0, 0, 0, 0, 0, 0, 118, 112, 115, 95, 110, 117, 109, 95, 117, 110, 105, 116, 115, 95, 105, 110, 95, 116, 105, 99, 107, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 98, 105, 116, 95, 100, 101, 112, 116, 104, 95, 99, 104, 114, 111, 109, 97, 32, 58, 32, 37, 100, 10, 0, 0, 73, 110, 99, 111, 114, 114, 101, 99, 116, 32, 101, 110, 116, 114, 121, 45, 112, 111, 105, 110, 116, 32, 111, 102, 102, 115, 101, 116, 115, 0, 0, 0, 109, 102, 114, 101, 101, 32, 37, 112, 10, 0, 0, 0, 0, 0, 0, 0, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 115, 107, 105, 112, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 108, 111, 103, 50, 87, 68, 62, 61, 49, 0, 0, 0, 0, 0, 0, 0, 102, 105, 101, 108, 100, 95, 115, 101, 113, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 118, 112, 115, 95, 116, 105, 109, 105, 110, 103, 95, 105, 110, 102, 111, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 98, 105, 116, 95, 100, 101, 112, 116, 104, 95, 108, 117, 109, 97, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 80, 114, 101, 109, 97, 116, 117, 114, 101, 32, 101, 110, 100, 32, 111, 102, 32, 115, 108, 105, 99, 101, 32, 115, 101, 103, 109, 101, 110, 116, 0, 0, 99, 111, 110, 115, 116, 114, 97, 105, 110, 101, 100, 95, 105, 110, 116, 114, 97, 95, 112, 114, 101, 100, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 105, 111, 115, 95, 98, 97, 115, 101, 58, 58, 99, 108, 101, 97, 114, 0, 110, 101, 117, 116, 114, 97, 108, 95, 99, 104, 114, 111, 109, 97, 95, 105, 110, 100, 105, 99, 97, 116, 105, 111, 110, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 108, 97, 121, 101, 114, 95, 105, 100, 95, 105, 110, 99, 108, 117, 100, 101, 100, 95, 102, 108, 97, 103, 91, 37, 100, 93, 91, 37, 100, 93, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 99, 111, 110, 102, 95, 119, 105, 110, 95, 98, 111, 116, 116, 111, 109, 95, 111, 102, 102, 115, 101, 116, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 84, 111, 111, 32, 109, 97, 110, 121, 32, 119, 97, 114, 110, 105, 110, 103, 115, 32, 113, 117, 101, 117, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 112, 105, 99, 95, 105, 110, 105, 116, 95, 113, 112, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 40, 119, 105, 100, 116, 104, 38, 49, 41, 61, 61, 48, 0, 0, 0, 0, 32, 32, 99, 104, 114, 111, 109, 97, 95, 115, 97, 109, 112, 108, 101, 95, 108, 111, 99, 95, 116, 121, 112, 101, 95, 98, 111, 116, 116, 111, 109, 95, 102, 105, 101, 108, 100, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 118, 112, 115, 95, 110, 117, 109, 95, 108, 97, 121, 101, 114, 95, 115, 101, 116, 115, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 99, 111, 110, 102, 95, 119, 105, 110, 95, 116, 111, 112, 95, 111, 102, 102, 115, 101, 116, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 67, 97, 110, 110, 111, 116, 32, 114, 117, 110, 32, 100, 101, 99, 111, 100, 101, 114, 32, 109, 117, 108, 116, 105, 45, 116, 104, 114, 101, 97, 100, 101, 100, 32, 98, 101, 99, 97, 117, 115, 101, 32, 115, 116, 114, 101, 97, 109, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 115, 117, 112, 112, 111, 114, 116, 32, 87, 80, 80, 0, 0, 0, 110, 117, 109, 95, 114, 101, 102, 95, 105, 100, 120, 95, 108, 49, 95, 100, 101, 102, 97, 117, 108, 116, 95, 97, 99, 116, 105, 118, 101, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 80, 65, 76, 0, 0, 0, 0, 0, 99, 97, 98, 97, 99, 46, 99, 99, 0, 0, 0, 0, 0, 0, 0, 0, 117, 110, 105, 116, 89, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 89, 32, 60, 32, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 32, 32, 99, 104, 114, 111, 109, 97, 95, 115, 97, 109, 112, 108, 101, 95, 108, 111, 99, 95, 116, 121, 112, 101, 95, 116, 111, 112, 95, 102, 105, 101, 108, 100, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 118, 112, 115, 95, 109, 97, 120, 95, 108, 97, 121, 101, 114, 95, 105, 100, 32, 32, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 99, 111, 110, 102, 95, 119, 105, 110, 95, 114, 105, 103, 104, 116, 95, 111, 102, 102, 115, 101, 116, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 118, 112, 115, 46, 99, 99, 0, 0, 48, 0, 0, 0, 0, 0, 0, 0, 117, 110, 115, 112, 101, 99, 105, 102, 105, 101, 100, 32, 100, 101, 99, 111, 100, 105, 110, 103, 32, 101, 114, 114, 111, 114, 0, 0, 0, 0, 0, 0, 110, 117, 109, 95, 114, 101, 102, 95, 105, 100, 120, 95, 108, 48, 95, 100, 101, 102, 97, 117, 108, 116, 95, 97, 99, 116, 105, 118, 101, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 73, 78, 70, 79, 58, 32, 0, 0, 116, 114, 97, 110, 115, 102, 111, 114, 109, 46, 99, 99, 0, 0, 0, 0, 99, 104, 114, 111, 109, 97, 95, 108, 111, 99, 95, 105, 110, 102, 111, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 46, 46, 47, 108, 105, 98, 100, 101, 50, 54, 53, 47, 105, 109, 97, 103, 101, 46, 104, 0, 0, 0, 0, 0, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 112, 115, 95, 109, 97, 120, 95, 108, 97, 116, 101, 110, 99, 121, 95, 105, 110, 99, 114, 101, 97, 115, 101, 32, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 100, 101, 99, 99, 116, 120, 46, 99, 99, 0, 0, 0, 0, 0, 0, 0, 99, 111, 110, 102, 95, 119, 105, 110, 95, 108, 101, 102, 116, 95, 111, 102, 102, 115, 101, 116, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 110, 97, 110, 0, 0, 0, 0, 0, 112, 114, 101, 109, 97, 116, 117, 114, 101, 32, 101, 110, 100, 32, 111, 102, 32, 115, 108, 105, 99, 101, 32, 100, 97, 116, 97, 0, 0, 0, 0, 0, 99, 97, 98, 97, 99, 95, 105, 110, 105, 116, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 67, 0, 0, 0, 0, 0, 0, 0, 115, 112, 115, 46, 99, 99, 0, 0, 32, 32, 109, 97, 116, 114, 105, 120, 95, 99, 111, 101, 102, 102, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 117, 110, 105, 116, 88, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 88, 32, 60, 32, 119, 105, 100, 116, 104, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 0, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 112, 115, 95, 109, 97, 120, 95, 110, 117, 109, 95, 114, 101, 111, 114, 100, 101, 114, 95, 112, 105, 99, 115, 32, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 100, 101, 98, 108, 111, 99, 107, 46, 99, 99, 0, 0, 0, 0, 0, 0, 99, 111, 110, 102, 111, 114, 109, 97, 110, 99, 101, 95, 119, 105, 110, 100, 111, 119, 95, 102, 108, 97, 103, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 102, 105, 114, 115, 116, 32, 115, 108, 105, 99, 101, 32, 109, 105, 115, 115, 105, 110, 103, 44, 32, 99, 97, 110, 110, 111, 116, 32, 100, 101, 99, 111, 100, 101, 32, 100, 101, 112, 101, 110, 100, 101, 110, 116, 32, 115, 108, 105, 99, 101, 0, 0, 0, 0, 0, 0, 115, 105, 103, 110, 95, 100, 97, 116, 97, 95, 104, 105, 100, 105, 110, 103, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 118, 101, 99, 116, 111, 114, 0, 0, 115, 108, 105, 99, 101, 46, 99, 99, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 116, 114, 97, 110, 115, 102, 101, 114, 95, 99, 104, 97, 114, 97, 99, 116, 101, 114, 105, 115, 116, 105, 99, 115, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 108, 97, 121, 101, 114, 32, 40, 97, 108, 108, 41, 58, 32, 118, 112, 115, 95, 109, 97, 120, 95, 100, 101, 99, 95, 112, 105, 99, 95, 98, 117, 102, 102, 101, 114, 105, 110, 103, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 112, 105, 99, 95, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 108, 117, 109, 97, 95, 115, 97, 109, 112, 108, 101, 115, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 117, 110, 105, 116, 88, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 88, 32, 60, 32, 119, 105, 100, 116, 104, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 0, 99, 111, 109, 109, 97, 110, 100, 45, 108, 105, 110, 101, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 101, 114, 114, 111, 114, 0, 0, 0, 0, 100, 101, 112, 101, 110, 100, 101, 110, 116, 95, 115, 108, 105, 99, 101, 95, 115, 101, 103, 109, 101, 110, 116, 115, 95, 101, 110, 97, 98, 108, 101, 100, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 114, 101, 102, 112, 105, 99, 46, 99, 99, 0, 0, 0, 0, 0, 0, 0, 37, 46, 48, 76, 102, 0, 0, 0, 98, 105, 116, 115, 116, 114, 101, 97, 109, 46, 99, 99, 0, 0, 0, 0, 32, 32, 99, 111, 108, 111, 117, 114, 95, 112, 114, 105, 109, 97, 114, 105, 101, 115, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 112, 115, 95, 109, 97, 120, 95, 108, 97, 116, 101, 110, 99, 121, 95, 105, 110, 99, 114, 101, 97, 115, 101, 32, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 108, 111, 103, 50, 95, 109, 97, 120, 95, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 115, 107, 105, 112, 95, 98, 108, 111, 99, 107, 95, 115, 105, 122, 101, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 112, 105, 99, 95, 119, 105, 100, 116, 104, 95, 105, 110, 95, 108, 117, 109, 97, 95, 115, 97, 109, 112, 108, 101, 115, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 110, 97, 108, 45, 112, 97, 114, 115, 101, 114, 46, 99, 99, 0, 0, 0, 83, 69, 73, 32, 100, 97, 116, 97, 32, 99, 97, 110, 110, 111, 116, 32, 98, 101, 32, 112, 114, 111, 99, 101, 115, 115, 101, 100, 0, 0, 0, 0, 115, 101, 113, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 115, 101, 116, 95, 105, 100, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 105, 109, 103, 45, 62, 115, 112, 115, 46, 66, 105, 116, 68, 101, 112, 116, 104, 95, 67, 32, 62, 61, 32, 56, 32, 38, 38, 32, 105, 109, 103, 45, 62, 115, 112, 115, 46, 66, 105, 116, 68, 101, 112, 116, 104, 95, 67, 32, 60, 61, 32, 49, 54, 0, 0, 0, 109, 111, 110, 101, 121, 95, 103, 101, 116, 32, 101, 114, 114, 111, 114, 0, 110, 111, 32, 101, 114, 114, 111, 114, 0, 0, 0, 0, 0, 0, 0, 0, 32, 32, 99, 111, 108, 111, 117, 114, 95, 100, 101, 115, 99, 114, 105, 112, 116, 105, 111, 110, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 46, 47, 100, 101, 99, 99, 116, 120, 46, 104, 0, 0, 0, 0, 0, 0, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 112, 115, 95, 109, 97, 120, 95, 110, 117, 109, 95, 114, 101, 111, 114, 100, 101, 114, 95, 112, 105, 99, 115, 32, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 109, 111, 116, 105, 111, 110, 46, 99, 99, 0, 0, 0, 0, 0, 0, 0, 105, 110, 116, 114, 97, 112, 114, 101, 100, 46, 99, 99, 0, 0, 0, 0, 115, 101, 112, 97, 114, 97, 116, 101, 95, 99, 111, 108, 111, 117, 114, 95, 112, 108, 97, 110, 101, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 42, 37, 115, 10, 0, 0, 0, 0, 110, 111, 32, 109, 111, 114, 101, 32, 105, 110, 112, 117, 116, 32, 100, 97, 116, 97, 44, 32, 100, 101, 99, 111, 100, 101, 114, 32, 115, 116, 97, 108, 108, 101, 100, 0, 0, 0, 0, 0, 105, 111, 115, 116, 114, 101, 97, 109, 0, 0, 0, 0, 0, 0, 0, 0, 112, 105, 99, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 115, 101, 116, 95, 105, 100, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 0, 83, 97, 116, 0, 0, 0, 0, 0, 105, 109, 103, 45, 62, 115, 112, 115, 46, 66, 105, 116, 68, 101, 112, 116, 104, 95, 89, 32, 62, 61, 32, 56, 32, 38, 38, 32, 105, 109, 103, 45, 62, 115, 112, 115, 46, 66, 105, 116, 68, 101, 112, 116, 104, 95, 89, 32, 60, 61, 32, 49, 54, 0, 0, 0, 70, 114, 105, 0, 0, 0, 0, 0, 37, 76, 102, 0, 0, 0, 0, 0, 105, 109, 97, 103, 101, 46, 99, 99, 0, 0, 0, 0, 0, 0, 0, 0, 84, 104, 117, 0, 0, 0, 0, 0, 87, 101, 100, 0, 0, 0, 0, 0, 84, 117, 101, 0, 0, 0, 0, 0, 32, 32, 118, 105, 100, 101, 111, 95, 102, 117, 108, 108, 95, 114, 97, 110, 103, 101, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 100, 112, 98, 46, 99, 99, 0, 0, 110, 32, 60, 32, 110, 84, 104, 114, 101, 97, 100, 67, 111, 110, 116, 101, 120, 116, 115, 0, 0, 0, 0, 0, 77, 111, 110, 0, 0, 0, 0, 0, 108, 97, 121, 101, 114, 32, 37, 100, 58, 32, 118, 112, 115, 95, 109, 97, 120, 95, 100, 101, 99, 95, 112, 105, 99, 95, 98, 117, 102, 102, 101, 114, 105, 110, 103, 32, 61, 32, 37, 100, 10, 0, 0, 0, 0, 0, 0, 0, 83, 117, 110, 0, 0, 0, 0, 0, 48, 0, 0, 0, 0, 0, 0, 0, 117, 110, 107, 110, 111, 119, 110, 0, 83, 97, 116, 117, 114, 100, 97, 121, 0, 0, 0, 0, 0, 0, 0, 0, 70, 114, 105, 100, 97, 121, 0, 0, 42, 37, 100, 37, 99, 32, 0, 0, 84, 104, 117, 114, 115, 100, 97, 121, 0, 0, 0, 0, 0, 0, 0, 0, 117, 110, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 32, 100, 101, 99, 111, 100, 101, 114, 32, 102, 101, 97, 116, 117, 114, 101, 0, 0, 0, 37, 112, 32, 100, 101, 115, 116, 114, 117, 99, 116, 111, 114, 10, 0, 0, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 32, 80, 80, 83, 32, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 10, 0, 0, 0, 0, 0, 0, 0, 0, 87, 101, 100, 110, 101, 115, 100, 97, 121, 0, 0, 0, 0, 0, 0, 0, 109, 111, 100, 101, 108, 91, 105, 93, 46, 115, 116, 97, 116, 101, 32, 60, 61, 32, 54, 50, 0, 0, 0, 0, 84, 117, 101, 115, 100, 97, 121, 0, 77, 111, 110, 100, 97, 121, 0, 0, 83, 117, 110, 100, 97, 121, 0, 0, 102, 97, 108, 108, 98, 97, 99, 107, 45, 109, 111, 116, 105, 111, 110, 46, 99, 99, 0, 0, 0, 0, 0, 0, 32, 32, 118, 105, 100, 101, 111, 95, 102, 111, 114, 109, 97, 116, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 115, 10, 0, 0, 0, 0, 0, 83, 0, 0, 0, 97, 0, 0, 0, 116, 0, 0, 0, 0, 0, 0, 0, 118, 112, 115, 95, 115, 117, 98, 95, 108, 97, 121, 101, 114, 95, 111, 114, 100, 101, 114, 105, 110, 103, 95, 105, 110, 102, 111, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 32, 58, 32, 37, 100, 10, 0, 0, 70, 0, 0, 0, 114, 0, 0, 0, 105, 0, 0, 0, 0, 0, 0, 0, 52, 58, 52, 58, 52, 0, 0, 0, 84, 0, 0, 0, 104, 0, 0, 0, 117, 0, 0, 0, 0, 0, 0, 0, 87, 0, 0, 0, 101, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 99, 97, 110, 110, 111, 116, 32, 102, 114, 101, 101, 32, 108, 105, 98, 114, 97, 114, 121, 32, 100, 97, 116, 97, 32, 40, 110, 111, 116, 32, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 100, 0, 0, 0, 0, 0, 0, 0, 84, 0, 0, 0, 117, 0, 0, 0, 101, 0, 0, 0, 0, 0, 0, 0, 112, 112, 115, 46, 99, 99, 0, 0, 77, 0, 0, 0, 111, 0, 0, 0, 110, 0, 0, 0, 0, 0, 0, 0, 117, 110, 115, 112, 101, 99, 105, 102, 105, 101, 100, 32, 105, 111, 115, 116, 114, 101, 97, 109, 95, 99, 97, 116, 101, 103, 111, 114, 121, 32, 101, 114, 114, 111, 114, 0, 0, 0, 0, 0, 117, 110, 105, 116, 89, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 89, 32, 60, 32, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 83, 0, 0, 0, 117, 0, 0, 0, 110, 0, 0, 0, 0, 0, 0, 0, 102, 97, 108, 108, 98, 97, 99, 107, 45, 100, 99, 116, 46, 99, 99, 0, 83, 0, 0, 0, 97, 0, 0, 0, 116, 0, 0, 0, 117, 0, 0, 0, 114, 0, 0, 0, 100, 0, 0, 0, 97, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 70, 0, 0, 0, 114, 0, 0, 0, 105, 0, 0, 0, 100, 0, 0, 0, 97, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 84, 0, 0, 0, 104, 0, 0, 0, 117, 0, 0, 0, 114, 0, 0, 0, 115, 0, 0, 0, 100, 0, 0, 0, 97, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 118, 105, 100, 101, 111, 95, 115, 105, 103, 110, 97, 108, 95, 116, 121, 112, 101, 95, 112, 114, 101, 115, 101, 110, 116, 95, 102, 108, 97, 103, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 87, 0, 0, 0, 101, 0, 0, 0, 100, 0, 0, 0, 110, 0, 0, 0, 101, 0, 0, 0, 115, 0, 0, 0, 100, 0, 0, 0, 97, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 118, 112, 115, 95, 116, 101, 109, 112, 111, 114, 97, 108, 95, 105, 100, 95, 110, 101, 115, 116, 105, 110, 103, 95, 102, 108, 97, 103, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 58, 32, 37, 100, 10, 0, 0, 0, 0, 0, 109, 111, 114, 101, 62, 61, 45, 49, 32, 38, 38, 32, 109, 111, 114, 101, 60, 61, 49, 0, 0, 0, 0, 0, 84, 0, 0, 0, 117, 0, 0, 0, 101, 0, 0, 0, 115, 0, 0, 0, 100, 0, 0, 0, 97, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 52, 58, 50, 58, 50, 0, 0, 0, 77, 0, 0, 0, 111, 0, 0, 0, 110, 0, 0, 0, 100, 0, 0, 0, 97, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 0, 0, 0, 117, 0, 0, 0, 110, 0, 0, 0, 100, 0, 0, 0, 97, 0, 0, 0, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 116, 105, 108, 101, 88, 62, 61, 48, 32, 38, 38, 32, 116, 105, 108, 101, 89, 62, 61, 48, 0, 0, 0, 0, 103, 108, 111, 98, 97, 108, 32, 108, 105, 98, 114, 97, 114, 121, 32, 105, 110, 105, 116, 105, 97, 108, 105, 122, 97, 116, 105, 111, 110, 32, 102, 97, 105, 108, 101, 100, 0, 0, 0, 0, 68, 101, 99, 0, 0, 0, 0, 0, 117, 110, 105, 116, 89, 32, 62, 61, 32, 48, 32, 38, 38, 32, 117, 110, 105, 116, 89, 32, 60, 32, 104, 101, 105, 103, 104, 116, 95, 105, 110, 95, 117, 110, 105, 116, 115, 0, 0, 0, 37, 112, 32, 40, 97, 108, 108, 111, 99, 41, 10, 0, 0, 0, 0, 0, 46, 47, 105, 109, 97, 103, 101, 46, 104, 0, 0, 0, 0, 0, 0, 0, 78, 111, 118, 0, 0, 0, 0, 0, 79, 99, 116, 0, 0, 0, 0, 0, 83, 101, 112, 0, 0, 0, 0, 0, 65, 117, 103, 0, 0, 0, 0, 0, 100, 101, 50, 54, 53, 95, 115, 101, 116, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 105, 110, 116, 0, 100, 101, 50, 54, 53, 95, 115, 101, 116, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 98, 111, 111, 108, 0, 0, 0, 0, 0, 0, 0, 0, 100, 101, 50, 54, 53, 95, 103, 101, 116, 95, 112, 97, 114, 97, 109, 101, 116, 101, 114, 95, 98, 111, 111, 108, 0, 0, 0, 0, 0, 0, 0, 0, 100, 101, 50, 54, 53, 95, 103, 101, 116, 95, 105, 109, 97, 103, 101, 95, 112, 108, 97, 110, 101, 95, 117, 115, 101, 114, 95, 100, 97, 116, 97, 0, 100, 101, 50, 54, 53, 95, 103, 101, 116, 95, 105, 109, 97, 103, 101, 95, 112, 108, 97, 110, 101, 0, 0, 0, 100, 117, 109, 112, 95, 115, 108, 105, 99, 101, 95, 115, 101, 103, 109, 101, 110, 116, 95, 104, 101, 97, 100, 101, 114, 0, 0, 0, 0, 0, 0, 0, 103, 101, 116, 0, 0, 0, 0, 0, 103, 101, 116, 0, 0, 0, 0, 0, 103, 101, 116, 0, 0, 0, 0, 0, 103, 101, 116, 0, 0, 0, 0, 0, 103, 101, 116, 0, 0, 0, 0, 0, 103, 101, 116, 0, 0, 0, 0, 0, 103, 101, 116, 0, 0, 0, 0, 0, 103, 101, 116, 0, 0, 0, 0, 0, 110, 101, 119, 95, 105, 109, 97, 103, 101, 0, 0, 0, 0, 0, 0, 0, 111, 117, 116, 112, 117, 116, 95, 110, 101, 120, 116, 95, 112, 105, 99, 116, 117, 114, 101, 95, 105, 110, 95, 114, 101, 111, 114, 100, 101, 114, 95, 98, 117, 102, 102, 101, 114, 0, 0, 0, 114, 101, 97, 100, 0, 0, 0, 0, 100, 101, 99, 111, 117, 112, 108, 101, 0, 0, 0, 0, 0, 0, 0, 0, 100, 101, 99, 111, 117, 112, 108, 101, 95, 111, 114, 95, 97, 108, 108, 111, 99, 95, 119, 105, 116, 104, 95, 101, 109, 112, 116, 121, 95, 100, 97, 116, 97, 0, 0, 0, 0, 0, 0, 0, 114, 101, 97, 100, 0, 0, 0, 0, 115, 101, 116, 95, 100, 101, 114, 105, 118, 101, 100, 95, 118, 97, 108, 117, 101, 115, 0, 0, 0, 0, 0, 0, 100, 101, 99, 111, 100, 101, 0, 0, 103, 101, 110, 101, 114, 97, 116, 101, 95, 117, 110, 97, 118, 97, 105, 108, 97, 98, 108, 101, 95, 114, 101, 102, 101, 114, 101, 110, 99, 101, 95, 112, 105, 99, 116, 117, 114, 101, 0, 0, 99, 111, 110, 115, 116, 114, 117, 99, 116, 95, 114, 101, 102, 101, 114, 101, 110, 99, 101, 95, 112, 105, 99, 116, 117, 114, 101, 95, 108, 105, 115, 116, 115, 0, 0, 0, 0, 0, 0, 0, 112, 114, 111, 99, 101, 115, 115, 95, 115, 108, 105, 99, 101, 95, 115, 101, 103, 109, 101, 110, 116, 95, 104, 101, 97, 100, 101, 114, 0, 0, 0, 0, 100, 101, 99, 111, 100, 101, 95, 115, 108, 105, 99, 101, 95, 117, 110, 105, 116, 95, 112, 97, 114, 97, 108, 108, 101, 108, 0, 0, 0, 0, 0, 0, 100, 101, 99, 111, 100, 101, 95, 115, 108, 105, 99, 101, 95, 117, 110, 105, 116, 95, 116, 105, 108, 101, 115, 0, 100, 101, 99, 111, 100, 101, 95, 115, 108, 105, 99, 101, 95, 117, 110, 105, 116, 95, 87, 80, 80, 0, 0, 0, 99, 104, 97, 110, 103, 101, 95, 102, 114, 97, 109, 101, 114, 97, 116, 101, 0, 0, 0, 0, 0, 0, 0, 0, 115, 101, 116, 95, 73, 110, 116, 114, 97, 80, 114, 101, 100, 77, 111, 100, 101, 67, 0, 0, 0, 0, 0, 0, 116, 104, 114, 101, 97, 100, 95, 102, 105, 110, 105, 115, 104, 101, 115, 0, 99, 111, 112, 121, 95, 108, 105, 110, 101, 115, 95, 102, 114, 111, 109, 0, 97, 108, 108, 111, 99, 95, 105, 109, 97, 103, 101, 0, 0, 0, 0, 0, 97, 108, 108, 111, 99, 97, 116, 101, 95, 116, 104, 114, 101, 97, 100, 95, 99, 111, 110, 116, 101, 120, 116, 115, 0, 0, 0, 0, 0, 0, 0, 0, 103, 101, 116, 95, 116, 104, 114, 101, 97, 100, 95, 99, 111, 110, 116, 101, 120, 116, 0, 0, 0, 0, 0, 0, 112, 117, 115, 104, 95, 78, 65, 76, 0, 0, 0, 0, 0, 0, 0, 0, 100, 101, 99, 111, 100, 101, 95, 115, 112, 108, 105, 116, 95, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 102, 108, 97, 103, 0, 0, 0, 0, 0, 100, 101, 50, 54, 53, 95, 105, 109, 97, 103, 101, 95, 103, 101, 116, 95, 98, 117, 102, 102, 101, 114, 0, 0, 100, 101, 99, 111, 100, 101, 95, 112, 97, 114, 116, 95, 109, 111, 100, 101, 0, 0, 0, 0, 0, 0, 0, 0, 115, 101, 116, 95, 105, 110, 105, 116, 86, 97, 108, 117, 101, 0, 0, 0, 109, 99, 95, 99, 104, 114, 111, 109, 97, 0, 0, 0, 0, 0, 0, 0, 103, 101, 116, 95, 117, 118, 108, 99, 0, 0, 0, 0, 0, 0, 0, 0, 97, 108, 108, 111, 99, 95, 97, 110, 100, 95, 105, 110, 105, 116, 95, 115, 105, 103, 110, 105, 102, 105, 99, 97, 110, 116, 95, 99, 111, 101, 102, 102, 95, 99, 116, 120, 73, 100, 120, 95, 108, 111, 111, 107, 117, 112, 84, 97, 98, 108, 101, 0, 0, 0, 0, 0, 100, 101, 114, 105, 118, 101, 95, 99, 111, 109, 98, 105, 110, 101, 100, 95, 98, 105, 112, 114, 101, 100, 105, 99, 116, 105, 118, 101, 95, 109, 101, 114, 103, 105, 110, 103, 95, 99, 97, 110, 100, 105, 100, 97, 116, 101, 115, 0, 100, 101, 114, 105, 118, 101, 95, 115, 112, 97, 116, 105, 97, 108, 95, 108, 117, 109, 97, 95, 118, 101, 99, 116, 111, 114, 95, 112, 114, 101, 100, 105, 99, 116, 105, 111, 110, 0, 0, 0, 102, 105, 108, 108, 95, 108, 117, 109, 97, 95, 109, 111, 116, 105, 111, 110, 95, 118, 101, 99, 116, 111, 114, 95, 112, 114, 101, 100, 105, 99, 116, 111, 114, 115, 0, 0, 0, 0, 0, 0, 112, 117, 116, 95, 119, 101, 105, 103, 104, 116, 101, 100, 95, 112, 114, 101, 100, 95, 97, 118, 103, 95, 49, 54, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 0, 0, 0, 0, 0, 0, 105, 110, 116, 114, 97, 95, 112, 114, 101, 100, 105, 99, 116, 105, 111, 110, 95, 115, 97, 109, 112, 108, 101, 95, 102, 105, 108, 116, 101, 114, 105, 110, 103, 0, 0, 0, 0, 0, 0, 0, 103, 101, 110, 101, 114, 97, 116, 101, 95, 105, 110, 116, 101, 114, 95, 112, 114, 101, 100, 105, 99, 116, 105, 111, 110, 95, 115, 97, 109, 112, 108, 101, 115, 0, 0, 0, 0, 0, 0, 0, 112, 117, 116, 95, 119, 101, 105, 103, 104, 116, 101, 100, 95, 112, 114, 101, 100, 95, 97, 118, 103, 95, 56, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 0, 0, 0, 0, 0, 0, 0, 100, 101, 114, 105, 118, 101, 95, 99, 111, 108, 108, 111, 99, 97, 116, 101, 100, 95, 109, 111, 116, 105, 111, 110, 95, 118, 101, 99, 116, 111, 114, 115, 0, 0, 0, 0, 0, 0, 0, 0, 112, 117, 116, 95, 119, 101, 105, 103, 104, 116, 101, 100, 95, 98, 105, 112, 114, 101, 100, 95, 49, 54, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 112, 117, 116, 95, 117, 110, 119, 101, 105, 103, 104, 116, 101, 100, 95, 112, 114, 101, 100, 95, 49, 54, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 112, 117, 116, 95, 119, 101, 105, 103, 104, 116, 101, 100, 95, 98, 105, 112, 114, 101, 100, 95, 56, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 0, 112, 117, 116, 95, 117, 110, 119, 101, 105, 103, 104, 116, 101, 100, 95, 112, 114, 101, 100, 95, 56, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 0, 112, 117, 116, 95, 119, 101, 105, 103, 104, 116, 101, 100, 95, 112, 114, 101, 100, 95, 49, 54, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 0, 0, 112, 117, 116, 95, 119, 101, 105, 103, 104, 116, 101, 100, 95, 112, 114, 101, 100, 95, 56, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 0, 0, 0, 115, 99, 97, 108, 101, 95, 99, 111, 101, 102, 102, 105, 99, 105, 101, 110, 116, 115, 95, 105, 110, 116, 101, 114, 110, 97, 108, 0, 0, 0, 0, 0, 114, 101, 97, 100, 95, 115, 104, 111, 114, 116, 95, 116, 101, 114, 109, 95, 114, 101, 102, 95, 112, 105, 99, 95, 115, 101, 116, 0, 0, 0, 0, 0, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 115, 107, 105, 112, 95, 49, 54, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 0, 0, 0, 0, 0, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 115, 107, 105, 112, 95, 56, 95, 102, 97, 108, 108, 98, 97, 99, 107, 0, 0, 0, 0, 0, 0, 0, 105, 110, 116, 114, 97, 95, 112, 114, 101, 100, 105, 99, 116, 105, 111, 110, 95, 97, 110, 103, 117, 108, 97, 114, 0, 0, 0, 0, 0, 0, 0, 0, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 95, 67, 65, 66, 65, 67, 95, 109, 111, 100, 101, 108, 115, 0, 100, 101, 114, 105, 118, 101, 95, 98, 111, 117, 110, 100, 97, 114, 121, 83, 116, 114, 101, 110, 103, 116, 104, 0, 114, 101, 97, 100, 95, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 117, 110, 105, 116, 0, 0, 0, 0, 0, 114, 101, 97, 100, 95, 116, 114, 97, 110, 115, 102, 111, 114, 109, 95, 116, 114, 101, 101, 0, 0, 0, 0, 0, 102, 105, 108, 108, 95, 115, 99, 97, 108, 105, 110, 103, 95, 102, 97, 99, 116, 111, 114, 0, 0, 0, 0, 0, 105, 110, 105, 116, 95, 67, 65, 66, 65, 67, 95, 100, 101, 99, 111, 100, 101, 114, 0, 0, 0, 0, 0, 0, 114, 101, 97, 100, 95, 115, 99, 97, 108, 105, 110, 103, 95, 108, 105, 115, 116, 0, 0, 0, 0, 0, 0, 0, 114, 101, 97, 100, 95, 99, 111, 100, 105, 110, 103, 95, 117, 110, 105, 116, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 192, 3, 0, 0, 192, 4, 0, 0, 192, 5, 0, 0, 192, 6, 0, 0, 192, 7, 0, 0, 192, 8, 0, 0, 192, 9, 0, 0, 192, 10, 0, 0, 192, 11, 0, 0, 192, 12, 0, 0, 192, 13, 0, 0, 192, 14, 0, 0, 192, 15, 0, 0, 192, 16, 0, 0, 192, 17, 0, 0, 192, 18, 0, 0, 192, 19, 0, 0, 192, 20, 0, 0, 192, 21, 0, 0, 192, 22, 0, 0, 192, 23, 0, 0, 192, 24, 0, 0, 192, 25, 0, 0, 192, 26, 0, 0, 192, 27, 0, 0, 192, 28, 0, 0, 192, 29, 0, 0, 192, 30, 0, 0, 192, 31, 0, 0, 192, 0, 0, 0, 179, 1, 0, 0, 195, 2, 0, 0, 195, 3, 0, 0, 195, 4, 0, 0, 195, 5, 0, 0, 195, 6, 0, 0, 195, 7, 0, 0, 195, 8, 0, 0, 195, 9, 0, 0, 195, 10, 0, 0, 195, 11, 0, 0, 195, 12, 0, 0, 195, 13, 0, 0, 211, 14, 0, 0, 195, 15, 0, 0, 195, 0, 0, 12, 187, 1, 0, 12, 195, 2, 0, 12, 195, 3, 0, 12, 195, 4, 0, 12, 211, 0, 0, 0, 0, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 0, 0, 0, 0, 0, 0, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 0, 0, 0, 0, 0, 0, 37, 0, 0, 0, 89, 0, 0, 0, 45, 0, 0, 0, 37, 0, 0, 0, 109, 0, 0, 0, 45, 0, 0, 0, 37, 0, 0, 0, 100, 0, 0, 0, 37, 0, 0, 0, 72, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 77, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 83, 0, 0, 0, 37, 0, 0, 0, 72, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 77, 0, 0, 0, 0, 0, 0, 0, 37, 0, 0, 0, 73, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 77, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 83, 0, 0, 0, 32, 0, 0, 0, 37, 0, 0, 0, 112, 0, 0, 0, 0, 0, 0, 0, 37, 0, 0, 0, 109, 0, 0, 0, 47, 0, 0, 0, 37, 0, 0, 0, 100, 0, 0, 0, 47, 0, 0, 0, 37, 0, 0, 0, 121, 0, 0, 0, 37, 0, 0, 0, 72, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 77, 0, 0, 0, 58, 0, 0, 0, 37, 0, 0, 0, 83, 0, 0, 0, 37, 72, 58, 37, 77, 58, 37, 83, 37, 72, 58, 37, 77, 0, 0, 0, 37, 73, 58, 37, 77, 58, 37, 83, 32, 37, 112, 0, 0, 0, 0, 0, 37, 89, 45, 37, 109, 45, 37, 100, 37, 109, 47, 37, 100, 47, 37, 121, 37, 72, 58, 37, 77, 58, 37, 83, 37, 0, 0, 0, 0, 0, 0, 0, 37, 112, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0, 10, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 184, 99, 0, 0, 174, 0, 0, 0, 138, 0, 0, 0, 68, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 200, 99, 0, 0, 236, 0, 0, 0, 190, 0, 0, 0, 36, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 216, 99, 0, 0, 76, 0, 0, 0, 62, 1, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 232, 99, 0, 0, 110, 0, 0, 0, 8, 0, 0, 0, 104, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 248, 99, 0, 0, 110, 0, 0, 0, 26, 0, 0, 0, 104, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 100, 0, 0, 228, 0, 0, 0, 90, 0, 0, 0, 56, 0, 0, 0, 2, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 100, 0, 0, 54, 1, 0, 0, 220, 0, 0, 0, 56, 0, 0, 0, 4, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 80, 100, 0, 0, 188, 0, 0, 0, 222, 0, 0, 0, 56, 0, 0, 0, 30, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 112, 100, 0, 0, 56, 1, 0, 0, 162, 0, 0, 0, 56, 0, 0, 0, 28, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 101, 0, 0, 48, 1, 0, 0, 108, 0, 0, 0, 56, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 101, 0, 0, 186, 0, 0, 0, 128, 0, 0, 0, 56, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 80, 101, 0, 0, 46, 0, 0, 0, 130, 0, 0, 0, 56, 0, 0, 0, 120, 0, 0, 0, 4, 0, 0, 0, 60, 0, 0, 0, 10, 0, 0, 0, 38, 0, 0, 0, 88, 0, 0, 0, 4, 0, 0, 0, 248, 255, 255, 255, 80, 101, 0, 0, 22, 0, 0, 0, 10, 0, 0, 0, 34, 0, 0, 0, 16, 0, 0, 0, 2, 0, 0, 0, 32, 0, 0, 0, 124, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 120, 101, 0, 0, 36, 1, 0, 0, 20, 1, 0, 0, 56, 0, 0, 0, 20, 0, 0, 0, 24, 0, 0, 0, 92, 0, 0, 0, 54, 0, 0, 0, 34, 0, 0, 0, 2, 0, 0, 0, 8, 0, 0, 0, 248, 255, 255, 255, 120, 101, 0, 0, 64, 0, 0, 0, 100, 0, 0, 0, 114, 0, 0, 0, 44, 0, 0, 0, 88, 0, 0, 0, 42, 0, 0, 0, 54, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 101, 0, 0, 84, 0, 0, 0, 226, 0, 0, 0, 56, 0, 0, 0, 46, 0, 0, 0, 122, 0, 0, 0, 8, 0, 0, 0, 50, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 176, 101, 0, 0, 68, 0, 0, 0, 72, 0, 0, 0, 56, 0, 0, 0, 40, 0, 0, 0, 76, 0, 0, 0, 12, 0, 0, 0, 64, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 192, 101, 0, 0, 40, 1, 0, 0, 2, 0, 0, 0, 56, 0, 0, 0, 24, 0, 0, 0, 32, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 224, 101, 0, 0, 54, 0, 0, 0, 6, 1, 0, 0, 56, 0, 0, 0, 38, 0, 0, 0, 14, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 102, 0, 0, 10, 1, 0, 0, 132, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 102, 0, 0, 38, 0, 0, 0, 160, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 102, 0, 0, 6, 0, 0, 0, 202, 0, 0, 0, 56, 0, 0, 0, 8, 0, 0, 0, 6, 0, 0, 0, 18, 0, 0, 0, 4, 0, 0, 0, 16, 0, 0, 0, 4, 0, 0, 0, 2, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 56, 102, 0, 0, 116, 0, 0, 0, 24, 0, 0, 0, 56, 0, 0, 0, 22, 0, 0, 0, 26, 0, 0, 0, 62, 0, 0, 0, 24, 0, 0, 0, 42, 0, 0, 0, 8, 0, 0, 0, 6, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 102, 0, 0, 48, 0, 0, 0, 32, 0, 0, 0, 56, 0, 0, 0, 78, 0, 0, 0, 76, 0, 0, 0, 68, 0, 0, 0, 70, 0, 0, 0, 58, 0, 0, 0, 74, 0, 0, 0, 66, 0, 0, 0, 46, 0, 0, 0, 82, 0, 0, 0, 80, 0, 0, 0, 50, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 120, 102, 0, 0, 60, 0, 0, 0, 4], "i8", ALLOC_NONE, Runtime.GLOBAL_BASE + 10240);
    /* memory initializer */
    allocate([56, 0, 0, 0, 110, 0, 0, 0, 102, 0, 0, 0, 96, 0, 0, 0, 98, 0, 0, 0, 90, 0, 0, 0, 100, 0, 0, 0, 94, 0, 0, 0, 108, 0, 0, 0, 106, 0, 0, 0, 104, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 152, 102, 0, 0, 78, 0, 0, 0, 106, 0, 0, 0, 56, 0, 0, 0, 6, 0, 0, 0, 32, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 102, 0, 0, 36, 0, 0, 0, 204, 0, 0, 0, 56, 0, 0, 0, 16, 0, 0, 0, 38, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 102, 0, 0, 14, 0, 0, 0, 218, 0, 0, 0, 56, 0, 0, 0, 2, 0, 0, 0, 10, 0, 0, 0, 14, 0, 0, 0, 118, 0, 0, 0, 94, 0, 0, 0, 24, 0, 0, 0, 110, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 216, 102, 0, 0, 210, 0, 0, 0, 154, 0, 0, 0, 56, 0, 0, 0, 14, 0, 0, 0, 16, 0, 0, 0, 18, 0, 0, 0, 50, 0, 0, 0, 8, 0, 0, 0, 20, 0, 0, 0, 84, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 248, 102, 0, 0, 210, 0, 0, 0, 28, 0, 0, 0, 56, 0, 0, 0, 6, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 92, 0, 0, 0, 60, 0, 0, 0, 10, 0, 0, 0, 126, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 103, 0, 0, 210, 0, 0, 0, 118, 0, 0, 0, 56, 0, 0, 0, 12, 0, 0, 0, 8, 0, 0, 0, 22, 0, 0, 0, 30, 0, 0, 0, 14, 0, 0, 0, 8, 0, 0, 0, 128, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 56, 103, 0, 0, 210, 0, 0, 0, 42, 0, 0, 0, 56, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 72, 103, 0, 0, 64, 0, 0, 0, 182, 0, 0, 0, 56, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 103, 0, 0, 210, 0, 0, 0, 86, 0, 0, 0, 56, 0, 0, 0, 20, 0, 0, 0, 2, 0, 0, 0, 6, 0, 0, 0, 12, 0, 0, 0, 20, 0, 0, 0, 28, 0, 0, 0, 26, 0, 0, 0, 6, 0, 0, 0, 6, 0, 0, 0, 10, 0, 0, 0, 10, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 120, 103, 0, 0, 60, 1, 0, 0, 44, 0, 0, 0, 56, 0, 0, 0, 14, 0, 0, 0, 4, 0, 0, 0, 2, 0, 0, 0, 36, 0, 0, 0, 10, 0, 0, 0, 8, 0, 0, 0, 26, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 103, 0, 0, 74, 0, 0, 0, 94, 0, 0, 0, 70, 0, 0, 0, 34, 0, 0, 0, 14, 0, 0, 0, 32, 0, 0, 0, 36, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 103, 0, 0, 210, 0, 0, 0, 92, 0, 0, 0, 56, 0, 0, 0, 12, 0, 0, 0, 8, 0, 0, 0, 22, 0, 0, 0, 30, 0, 0, 0, 14, 0, 0, 0, 8, 0, 0, 0, 128, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 200, 103, 0, 0, 210, 0, 0, 0, 192, 0, 0, 0, 56, 0, 0, 0, 12, 0, 0, 0, 8, 0, 0, 0, 22, 0, 0, 0, 30, 0, 0, 0, 14, 0, 0, 0, 8, 0, 0, 0, 128, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 216, 103, 0, 0, 150, 0, 0, 0, 30, 1, 0, 0, 84, 0, 0, 0, 22, 0, 0, 0, 16, 0, 0, 0, 34, 0, 0, 0, 80, 0, 0, 0, 96, 0, 0, 0, 34, 0, 0, 0, 28, 0, 0, 0, 26, 0, 0, 0, 8, 0, 0, 0, 44, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 224, 103, 0, 0, 12, 0, 0, 0, 140, 0, 0, 0, 68, 0, 0, 0, 40, 0, 0, 0, 30, 0, 0, 0, 30, 0, 0, 0, 48, 0, 0, 0, 78, 0, 0, 0, 18, 0, 0, 0, 6, 0, 0, 0, 12, 0, 0, 0, 30, 0, 0, 0, 16, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 16, 104, 0, 0, 52, 0, 0, 0, 2, 1, 0, 0, 252, 255, 255, 255, 252, 255, 255, 255, 16, 104, 0, 0, 168, 0, 0, 0, 148, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 40, 104, 0, 0, 12, 1, 0, 0, 32, 1, 0, 0, 252, 255, 255, 255, 252, 255, 255, 255, 40, 104, 0, 0, 126, 0, 0, 0, 240, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 64, 104, 0, 0, 98, 0, 0, 0, 44, 1, 0, 0, 248, 255, 255, 255, 248, 255, 255, 255, 64, 104, 0, 0, 212, 0, 0, 0, 28, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 88, 104, 0, 0, 124, 0, 0, 0, 248, 0, 0, 0, 248, 255, 255, 255, 248, 255, 255, 255, 88, 104, 0, 0, 158, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 112, 104, 0, 0, 244, 0, 0, 0, 214, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 152, 104, 0, 0, 42, 1, 0, 0, 216, 0, 0, 0, 18, 0, 0, 0, 22, 0, 0, 0, 16, 0, 0, 0, 34, 0, 0, 0, 56, 0, 0, 0, 96, 0, 0, 0, 34, 0, 0, 0, 28, 0, 0, 0, 26, 0, 0, 0, 8, 0, 0, 0, 30, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 104, 0, 0, 180, 0, 0, 0, 206, 0, 0, 0, 42, 0, 0, 0, 40, 0, 0, 0, 30, 0, 0, 0, 30, 0, 0, 0, 82, 0, 0, 0, 78, 0, 0, 0, 18, 0, 0, 0, 6, 0, 0, 0, 12, 0, 0, 0, 30, 0, 0, 0, 42, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 216, 104, 0, 0, 18, 1, 0, 0, 166, 0, 0, 0, 56, 0, 0, 0, 62, 0, 0, 0, 116, 0, 0, 0, 34, 0, 0, 0, 90, 0, 0, 0, 4, 0, 0, 0, 38, 0, 0, 0, 52, 0, 0, 0, 28, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 248, 104, 0, 0, 122, 0, 0, 0, 62, 0, 0, 0, 56, 0, 0, 0, 108, 0, 0, 0, 4, 0, 0, 0, 74, 0, 0, 0, 24, 0, 0, 0, 86, 0, 0, 0, 30, 0, 0, 0, 112, 0, 0, 0, 60, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 105, 0, 0, 22, 1, 0, 0, 134, 0, 0, 0, 56, 0, 0, 0, 18, 0, 0, 0, 58, 0, 0, 0, 6, 0, 0, 0, 54, 0, 0, 0, 92, 0, 0, 0, 62, 0, 0, 0, 86, 0, 0, 0, 66, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 56, 105, 0, 0, 82, 0, 0, 0, 200, 0, 0, 0, 56, 0, 0, 0, 98, 0, 0, 0, 102, 0, 0, 0, 36, 0, 0, 0, 82, 0, 0, 0, 32, 0, 0, 0, 26, 0, 0, 0, 72, 0, 0, 0, 80, 0, 0, 0, 78, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 112, 105, 0, 0, 100, 0, 0, 0, 22, 0, 0, 0, 44, 0, 0, 0, 22, 0, 0, 0, 16, 0, 0, 0, 34, 0, 0, 0, 80, 0, 0, 0, 96, 0, 0, 0, 34, 0, 0, 0, 66, 0, 0, 0, 74, 0, 0, 0, 16, 0, 0, 0, 44, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 105, 0, 0, 18, 0, 0, 0, 14, 1, 0, 0, 70, 0, 0, 0, 40, 0, 0, 0, 30, 0, 0, 0, 30, 0, 0, 0, 48, 0, 0, 0, 78, 0, 0, 0, 18, 0, 0, 0, 90, 0, 0, 0, 24, 0, 0, 0, 4, 0, 0, 0, 16, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 144, 105, 0, 0, 250, 0, 0, 0, 238, 0, 0, 0, 70, 0, 0, 0, 178, 0, 0, 0, 8, 0, 0, 0, 2, 0, 0, 0, 12, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 208, 105, 0, 0, 50, 1, 0, 0, 26, 1, 0, 0, 0, 1, 0, 0, 88, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 224, 105, 0, 0, 4, 1, 0, 0, 8, 1, 0, 0, 246, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 240, 105, 0, 0, 46, 1, 0, 0, 80, 0, 0, 0, 104, 0, 0, 0, 76, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 106, 0, 0, 34, 1, 0, 0, 66, 0, 0, 0, 184, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 106, 0, 0, 24, 1, 0, 0, 242, 0, 0, 0, 12, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 32, 106, 0, 0, 254, 0, 0, 0, 120, 0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 116, 57, 116, 121, 112, 101, 95, 105, 110, 102, 111, 0, 0, 0, 0, 83, 116, 57, 98, 97, 100, 95, 97, 108, 108, 111, 99, 0, 0, 0, 0, 83, 116, 56, 98, 97, 100, 95, 99, 97, 115, 116, 0, 0, 0, 0, 0, 83, 116, 49, 51, 114, 117, 110, 116, 105, 109, 101, 95, 101, 114, 114, 111, 114, 0, 0, 0, 0, 0, 0, 0, 83, 116, 49, 50, 108, 101, 110, 103, 116, 104, 95, 101, 114, 114, 111, 114, 0, 0, 0, 0, 0, 0, 0, 0, 83, 116, 49, 49, 108, 111, 103, 105, 99, 95, 101, 114, 114, 111, 114, 0, 78, 83, 116, 51, 95, 95, 49, 57, 116, 105, 109, 101, 95, 98, 97, 115, 101, 69, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 109, 111, 110, 101, 121, 95, 112, 117, 116, 73, 119, 78, 83, 95, 49, 57, 111, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 69, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 109, 111, 110, 101, 121, 95, 112, 117, 116, 73, 99, 78, 83, 95, 49, 57, 111, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 69, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 109, 111, 110, 101, 121, 95, 103, 101, 116, 73, 119, 78, 83, 95, 49, 57, 105, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 69, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 109, 111, 110, 101, 121, 95, 103, 101, 116, 73, 99, 78, 83, 95, 49, 57, 105, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 69, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 98, 97, 115, 105, 99, 95, 105, 111, 115, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 98, 97, 115, 105, 99, 95, 105, 111, 115, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 95, 95, 110, 117, 109, 95, 112, 117, 116, 73, 119, 69, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 95, 95, 110, 117, 109, 95, 112, 117, 116, 73, 99, 69, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 95, 95, 110, 117, 109, 95, 103, 101, 116, 73, 119, 69, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 57, 95, 95, 110, 117, 109, 95, 103, 101, 116, 73, 99, 69, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 116, 105, 109, 101, 95, 112, 117, 116, 73, 119, 78, 83, 95, 49, 57, 111, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 69, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 116, 105, 109, 101, 95, 112, 117, 116, 73, 99, 78, 83, 95, 49, 57, 111, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 69, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 116, 105, 109, 101, 95, 103, 101, 116, 73, 119, 78, 83, 95, 49, 57, 105, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 69, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 116, 105, 109, 101, 95, 103, 101, 116, 73, 99, 78, 83, 95, 49, 57, 105, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 69, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 110, 117, 109, 112, 117, 110, 99, 116, 73, 119, 69, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 110, 117, 109, 112, 117, 110, 99, 116, 73, 99, 69, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 109, 101, 115, 115, 97, 103, 101, 115, 73, 119, 69, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 109, 101, 115, 115, 97, 103, 101, 115, 73, 99, 69, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 105, 111, 115, 95, 98, 97, 115, 101, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 56, 105, 111, 115, 95, 98, 97, 115, 101, 55, 102, 97, 105, 108, 117, 114, 101, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 110, 117, 109, 95, 112, 117, 116, 73, 119, 78, 83, 95, 49, 57, 111, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 110, 117, 109, 95, 112, 117, 116, 73, 99, 78, 83, 95, 49, 57, 111, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 110, 117, 109, 95, 103, 101, 116, 73, 119, 78, 83, 95, 49, 57, 105, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 110, 117, 109, 95, 103, 101, 116, 73, 99, 78, 83, 95, 49, 57, 105, 115, 116, 114, 101, 97, 109, 98, 117, 102, 95, 105, 116, 101, 114, 97, 116, 111, 114, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 99, 111, 108, 108, 97, 116, 101, 73, 119, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 99, 111, 108, 108, 97, 116, 101, 73, 99, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 99, 111, 100, 101, 99, 118, 116, 73, 119, 99, 49, 49, 95, 95, 109, 98, 115, 116, 97, 116, 101, 95, 116, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 99, 111, 100, 101, 99, 118, 116, 73, 99, 99, 49, 49, 95, 95, 109, 98, 115, 116, 97, 116, 101, 95, 116, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 99, 111, 100, 101, 99, 118, 116, 73, 68, 115, 99, 49, 49, 95, 95, 109, 98, 115, 116, 97, 116, 101, 95, 116, 69, 69, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 55, 99, 111, 100, 101, 99, 118, 116, 73, 68, 105, 99, 49, 49, 95, 95, 109, 98, 115, 116, 97, 116, 101, 95, 116, 69, 69, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 54, 108, 111, 99, 97, 108, 101, 53, 102, 97, 99, 101, 116, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 54, 108, 111, 99, 97, 108, 101, 53, 95, 95, 105, 109, 112, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 53, 99, 116, 121, 112, 101, 73, 119, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 53, 99, 116, 121, 112, 101, 73, 99, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 50, 48, 95, 95, 116, 105, 109, 101, 95, 103, 101, 116, 95, 99, 95, 115, 116, 111, 114, 97, 103, 101, 73, 119, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 50, 48, 95, 95, 116, 105, 109, 101, 95, 103, 101, 116, 95, 99, 95, 115, 116, 111, 114, 97, 103, 101, 73, 99, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 57, 95, 95, 105, 111, 115, 116, 114, 101, 97, 109, 95, 99, 97, 116, 101, 103, 111, 114, 121, 69, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 55, 95, 95, 119, 105, 100, 101, 110, 95, 102, 114, 111, 109, 95, 117, 116, 102, 56, 73, 76, 106, 51, 50, 69, 69, 69, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 54, 95, 95, 110, 97, 114, 114, 111, 119, 95, 116, 111, 95, 117, 116, 102, 56, 73, 76, 106, 51, 50, 69, 69, 69, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 53, 98, 97, 115, 105, 99, 95, 115, 116, 114, 101, 97, 109, 98, 117, 102, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 53, 98, 97, 115, 105, 99, 95, 115, 116, 114, 101, 97, 109, 98, 117, 102, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 52, 101, 114, 114, 111, 114, 95, 99, 97, 116, 101, 103, 111, 114, 121, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 52, 95, 95, 115, 104, 97, 114, 101, 100, 95, 99, 111, 117, 110, 116, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 52, 95, 95, 110, 117, 109, 95, 112, 117, 116, 95, 98, 97, 115, 101, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 52, 95, 95, 110, 117, 109, 95, 103, 101, 116, 95, 98, 97, 115, 101, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 51, 109, 101, 115, 115, 97, 103, 101, 115, 95, 98, 97, 115, 101, 69, 0, 78, 83, 116, 51, 95, 95, 49, 49, 51, 98, 97, 115, 105, 99, 95, 111, 115, 116, 114, 101, 97, 109, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 51, 98, 97, 115, 105, 99, 95, 111, 115, 116, 114, 101, 97, 109, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 51, 98, 97, 115, 105, 99, 95, 105, 115, 116, 114, 101, 97, 109, 73, 119, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 119, 69, 69, 69, 69, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 51, 98, 97, 115, 105, 99, 95, 105, 115, 116, 114, 101, 97, 109, 73, 99, 78, 83, 95, 49, 49, 99, 104, 97, 114, 95, 116, 114, 97, 105, 116, 115, 73, 99, 69, 69, 69, 69, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 50, 115, 121, 115, 116, 101, 109, 95, 101, 114, 114, 111, 114, 69, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 50, 99, 111, 100, 101, 99, 118, 116, 95, 98, 97, 115, 101, 69, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 50, 95, 95, 100, 111, 95, 109, 101, 115, 115, 97, 103, 101, 69, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 49, 95, 95, 115, 116, 100, 111, 117, 116, 98, 117, 102, 73, 119, 69, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 49, 95, 95, 115, 116, 100, 111, 117, 116, 98, 117, 102, 73, 99, 69, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 49, 95, 95, 109, 111, 110, 101, 121, 95, 112, 117, 116, 73, 119, 69, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 49, 95, 95, 109, 111, 110, 101, 121, 95, 112, 117, 116, 73, 99, 69, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 49, 95, 95, 109, 111, 110, 101, 121, 95, 103, 101, 116, 73, 119, 69, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 49, 95, 95, 109, 111, 110, 101, 121, 95, 103, 101, 116, 73, 99, 69, 69, 0, 0, 0, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 109, 111, 110, 101, 121, 112, 117, 110, 99, 116, 73, 119, 76, 98, 49, 69, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 109, 111, 110, 101, 121, 112, 117, 110, 99, 116, 73, 119, 76, 98, 48, 69, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 109, 111, 110, 101, 121, 112, 117, 110, 99, 116, 73, 99, 76, 98, 49, 69, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 109, 111, 110, 101, 121, 112, 117, 110, 99, 116, 73, 99, 76, 98, 48, 69, 69, 69, 0, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 109, 111, 110, 101, 121, 95, 98, 97, 115, 101, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 99, 116, 121, 112, 101, 95, 98, 97, 115, 101, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 95, 95, 116, 105, 109, 101, 95, 112, 117, 116, 69, 0, 0, 0, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 95, 95, 115, 116, 100, 105, 110, 98, 117, 102, 73, 119, 69, 69, 0, 78, 83, 116, 51, 95, 95, 49, 49, 48, 95, 95, 115, 116, 100, 105, 110, 98, 117, 102, 73, 99, 69, 69, 0, 78, 49, 48, 95, 95, 99, 120, 120, 97, 98, 105, 118, 49, 50, 49, 95, 95, 118, 109, 105, 95, 99, 108, 97, 115, 115, 95, 116, 121, 112, 101, 95, 105, 110, 102, 111, 69, 0, 0, 0, 78, 49, 48, 95, 95, 99, 120, 120, 97, 98, 105, 118, 49, 50, 48, 95, 95, 115, 105, 95, 99, 108, 97, 115, 115, 95, 116, 121, 112, 101, 95, 105, 110, 102, 111, 69, 0, 0, 0, 0, 78, 49, 48, 95, 95, 99, 120, 120, 97, 98, 105, 118, 49, 49, 55, 95, 95, 99, 108, 97, 115, 115, 95, 116, 121, 112, 101, 95, 105, 110, 102, 111, 69, 0, 0, 0, 0, 0, 0, 0, 78, 49, 48, 95, 95, 99, 120, 120, 97, 98, 105, 118, 49, 49, 54, 95, 95, 115, 104, 105, 109, 95, 116, 121, 112, 101, 95, 105, 110, 102, 111, 69, 0, 0, 0, 0, 0, 0, 0, 0, 50, 54, 116, 104, 114, 101, 97, 100, 95, 116, 97, 115, 107, 95, 100, 101, 98, 108, 111, 99, 107, 95, 67, 84, 66, 82, 111, 119, 0, 0, 0, 0, 50, 53, 116, 104, 114, 101, 97, 100, 95, 116, 97, 115, 107, 95, 115, 108, 105, 99, 101, 95, 115, 101, 103, 109, 101, 110, 116, 0, 0, 0, 0, 0, 49, 57, 116, 104, 114, 101, 97, 100, 95, 116, 97, 115, 107, 95, 99, 116, 98, 95, 114, 111, 119, 0, 0, 0, 49, 53, 116, 104, 114, 101, 97, 100, 95, 116, 97, 115, 107, 95, 115, 97, 111, 0, 0, 0, 0, 0, 0, 0, 49, 53, 100, 101, 99, 111, 100, 101, 114, 95, 99, 111, 110, 116, 101, 120, 116, 0, 0, 0, 0, 0, 0, 0, 49, 50, 98, 97, 115, 101, 95, 99, 111, 110, 116, 101, 120, 116, 0, 0, 49, 49, 116, 104, 114, 101, 97, 100, 95, 116, 97, 115, 107, 0, 0, 0, 49, 49, 101, 114, 114, 111, 114, 95, 113, 117, 101, 117, 101, 0, 0, 0, 0, 0, 0, 0, 96, 87, 0, 0, 0, 0, 0, 0, 112, 87, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 87, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 144, 87, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 87, 0, 0, 248, 99, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 192, 87, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 208, 87, 0, 0, 120, 86, 0, 0, 232, 87, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 184, 104, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 48, 88, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 192, 104, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 120, 88, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 200, 104, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 192, 88, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 208, 104, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 89, 0, 0, 0, 102, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 56, 89, 0, 0, 0, 102, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 104, 89, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 248, 103, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 128, 89, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 248, 103, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 152, 89, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 104, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 176, 89, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 104, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 200, 89, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 104, 105, 0, 0, 0, 8, 0, 0, 120, 86, 0, 0, 16, 90, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 104, 105, 0, 0, 0, 8, 0, 0, 120, 86, 0, 0, 88, 90, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 8, 100, 0, 0, 2, 0, 0, 0, 152, 103, 0, 0, 0, 8, 0, 0, 120, 86, 0, 0, 160, 90, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 8, 100, 0, 0, 2, 0, 0, 0, 160, 103, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 232, 90, 0, 0, 56, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 91, 0, 0, 56, 103, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 24, 91, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 8, 104, 0, 0, 2, 0, 0, 0, 120, 86, 0, 0, 48, 91, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 8, 104, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 72, 91, 0, 0, 0, 0, 0, 0, 96, 91, 0, 0, 112, 104, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 128, 91, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 176, 100, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 200, 91, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 200, 100, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 16, 92, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 224, 100, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 88, 92, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 248, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 92, 0, 0, 56, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 92, 0, 0, 56, 103, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 208, 92, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 128, 104, 0, 0, 2, 0, 0, 0, 120, 86, 0, 0, 248, 92, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 128, 104, 0, 0, 2, 0, 0, 0, 120, 86, 0, 0, 32, 93, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 128, 104, 0, 0, 2, 0, 0, 0, 120, 86, 0, 0, 72, 93, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 128, 104, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 112, 93, 0, 0, 240, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 136, 93, 0, 0, 56, 103, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 160, 93, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 96, 105, 0, 0, 2, 0, 0, 0, 120, 86, 0, 0, 184, 93, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 96, 105, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 208, 93, 0, 0, 0, 0, 0, 0, 248, 93, 0, 0, 0, 0, 0, 0, 32, 94, 0, 0, 136, 104, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 94, 0, 0, 24, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 104, 94, 0, 0, 24, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 144, 94, 0, 0, 0, 0, 0, 0, 200, 94, 0, 0, 0, 0, 0, 0, 0, 95, 0, 0, 0, 0, 0, 0, 32, 95, 0, 0, 0, 0, 0, 0, 64, 95, 0, 0, 0, 0, 0, 0, 96, 95, 0, 0, 0, 0, 0, 0, 128, 95, 0, 0, 120, 86, 0, 0, 152, 95, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 144, 100, 0, 0, 3, 244, 255, 255, 120, 86, 0, 0, 200, 95, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 160, 100, 0, 0, 3, 244, 255, 255, 120, 86, 0, 0, 248, 95, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 144, 100, 0, 0, 3, 244, 255, 255, 120, 86, 0, 0, 40, 96, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 160, 100, 0, 0, 3, 244, 255, 255, 0, 0, 0, 0, 88, 96, 0, 0, 216, 99, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 112, 96, 0, 0, 0, 0, 0, 0, 136, 96, 0, 0, 232, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 96, 0, 0, 216, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 192, 96, 0, 0, 224, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 224, 96, 0, 0, 0, 0, 0, 0, 0, 97, 0, 0, 0, 0, 0, 0, 32, 97, 0, 0, 0, 0, 0, 0, 64, 97, 0, 0, 120, 86, 0, 0, 96, 97, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 88, 105, 0, 0, 2, 0, 0, 0, 120, 86, 0, 0, 128, 97, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 88, 105, 0, 0, 2, 0, 0, 0, 120, 86, 0, 0, 160, 97, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 88, 105, 0, 0, 2, 0, 0, 0, 120, 86, 0, 0, 192, 97, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 56, 103, 0, 0, 2, 0, 0, 0, 88, 105, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 224, 97, 0, 0, 0, 0, 0, 0, 248, 97, 0, 0, 0, 0, 0, 0, 16, 98, 0, 0, 0, 0, 0, 0, 40, 98, 0, 0, 216, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 98, 0, 0, 224, 103, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 98, 0, 0, 176, 105, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 98, 0, 0, 176, 105, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 98, 0, 0, 192, 105, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 208, 98, 0, 0, 176, 99, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 248, 98, 0, 0, 56, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 99, 0, 0, 56, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 56, 99, 0, 0, 56, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 80, 99, 0, 0, 56, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 104, 99, 0, 0, 32, 106, 0, 0, 0, 0, 0, 0, 120, 86, 0, 0, 128, 99, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 64, 106, 0, 0, 2, 4, 0, 0, 0, 0, 0, 0, 144, 99, 0, 0, 0, 0, 0, 0, 160, 99, 0, 0, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 97, 98, 99, 100, 101, 102, 65, 66, 67, 68, 69, 70, 120, 88, 43, 45, 112, 80, 105, 73, 110, 78, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 42, 0, 0, 0, 29, 55, 74, 84, 74, 74, 0, 182, 84, 227, 182, 55, 55, 172, 74, 227, 0, 1, 4, 5, 2, 3, 4, 5, 6, 6, 8, 8, 7, 7, 8, 99, 128, 176, 208, 240, 128, 167, 197, 227, 128, 158, 187, 216, 123, 150, 178, 205, 116, 142, 169, 195, 111, 135, 160, 185, 105, 128, 152, 175, 100, 122, 144, 166, 95, 116, 137, 158, 90, 110, 130, 150, 85, 104, 123, 142, 81, 99, 117, 135, 77, 94, 111, 128, 73, 89, 105, 122, 69, 85, 100, 116, 66, 80, 95, 110, 62, 76, 90, 104, 59, 72, 86, 99, 56, 69, 81, 94, 53, 65, 77, 89, 51, 62, 73, 85, 48, 59, 69, 80, 46, 56, 66, 76, 43, 53, 63, 72, 41, 50, 59, 69, 39, 48, 56, 65, 37, 45, 54, 62, 35, 43, 51, 59, 33, 41, 48, 56, 32, 39, 46, 53, 30, 37, 43, 50, 29, 35, 41, 48, 27, 33, 39, 45, 26, 31, 37, 43, 24, 30, 35, 41, 23, 28, 33, 39, 22, 27, 32, 37, 21, 26, 30, 35, 20, 24, 29, 33, 19, 23, 27, 31, 18, 22, 26, 30, 17, 21, 25, 28, 16, 20, 23, 27, 15, 19, 22, 25, 14, 18, 21, 24, 14, 17, 20, 23, 13, 16, 19, 22, 12, 15, 18, 21, 12, 14, 17, 20, 11, 14, 16, 19, 11, 13, 15, 18, 10, 12, 15, 17, 10, 12, 14, 16, 9, 11, 13, 15, 9, 11, 12, 14, 8, 10, 12, 14, 8, 9, 11, 13, 7, 9, 11, 12, 7, 9, 10, 12, 7, 8, 10, 11, 6, 8, 9, 11, 6, 7, 9, 10, 6, 7, 8, 9, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 232, 201, 0, 0, 104, 201, 0, 0, 104, 199, 0, 0, 104, 191, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 72, 191, 0, 0, 200, 190, 0, 0, 200, 188, 0, 0, 200, 180, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 180, 0, 0, 40, 180, 0, 0, 40, 178, 0, 0, 40, 170, 0, 0, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 64, 90, 90, 88, 85, 82, 78, 73, 67, 61, 54, 46, 38, 31, 22, 13, 4, 252, 243, 234, 225, 218, 210, 202, 195, 189, 183, 178, 174, 171, 168, 166, 166, 90, 87, 80, 70, 57, 43, 25, 9, 247, 231, 213, 199, 186, 176, 169, 166, 166, 169, 176, 186, 199, 213, 231, 247, 9, 25, 43, 57, 70, 80, 87, 90, 90, 82, 67, 46, 22, 252, 225, 202, 183, 171, 166, 168, 178, 195, 218, 243, 13, 38, 61, 78, 88, 90, 85, 73, 54, 31, 4, 234, 210, 189, 174, 166, 89, 75, 50, 18, 238, 206, 181, 167, 167, 181, 206, 238, 18, 50, 75, 89, 89, 75, 50, 18, 238, 206, 181, 167, 167, 181, 206, 238, 18, 50, 75, 89, 88, 67, 31, 243, 202, 174, 166, 178, 210, 252, 38, 73, 90, 85, 61, 22, 234, 195, 171, 166, 183, 218, 4, 46, 78, 90, 82, 54, 13, 225, 189, 168, 87, 57, 9, 213, 176, 166, 186, 231, 25, 70, 90, 80, 43, 247, 199, 169, 169, 199, 247, 43, 80, 90, 70, 25, 231, 186, 166, 176, 213, 9, 57, 87, 85, 46, 243, 189, 166, 183, 234, 38, 82, 88, 54, 252, 195, 166, 178, 225, 31, 78, 90, 61, 4, 202, 168, 174, 218, 22, 73, 90, 67, 13, 210, 171, 83, 36, 220, 173, 173, 220, 36, 83, 83, 36, 220, 173, 173, 220, 36, 83, 83, 36, 220, 173, 173, 220, 36, 83, 83, 36, 220, 173, 173, 220, 36, 83, 82, 22, 202, 166, 195, 13, 78, 85, 31, 210, 166, 189, 4, 73, 88, 38, 218, 168, 183, 252, 67, 90, 46, 225, 171, 178, 243, 61, 90, 54, 234, 174, 80, 9, 186, 169, 231, 57, 90, 43, 213, 166, 199, 25, 87, 70, 247, 176, 176, 247, 70, 87, 25, 199, 166, 213, 43, 90, 57, 231, 169, 186, 9, 80, 78, 252, 174, 183, 13, 85, 67, 234, 168, 195, 31, 90, 54, 218, 166, 210, 46, 90, 38, 202, 166, 225, 61, 88, 22, 189, 171, 243, 73, 82, 4, 178, 75, 238, 167, 206, 50, 89, 18, 181, 181, 18, 89, 50, 206, 167, 238, 75, 75, 238, 167, 206, 50, 89, 18, 181, 181, 18, 89, 50, 206, 167, 238, 75, 73, 225, 166, 234, 78, 67, 218, 166, 243, 82, 61, 210, 168, 252, 85, 54, 202, 171, 4, 88, 46, 195, 174, 13, 90, 38, 189, 178, 22, 90, 31, 183, 70, 213, 169, 9, 90, 25, 176, 199, 57, 80, 231, 166, 247, 87, 43, 186, 186, 43, 87, 247, 166, 231, 80, 57, 199, 176, 25, 90, 9, 169, 213, 70, 67, 202, 178, 38, 85, 234, 166, 4, 90, 13, 168, 225, 82, 46, 183, 195, 61, 73, 210, 174, 31, 88, 243, 166, 252, 90, 22, 171, 218, 78, 54, 189, 64, 192, 192, 64, 64, 192, 192, 64, 64, 192, 192, 64, 64, 192, 192, 64, 64, 192, 192, 64, 64, 192, 192, 64, 64, 192, 192, 64, 64, 192, 192, 64, 61, 183, 210, 82, 31, 168, 243, 90, 252, 166, 22, 85, 218, 178, 54, 67, 189, 202, 78, 38, 171, 234, 90, 4, 166, 13, 88, 225, 174, 46, 73, 195, 57, 176, 231, 90, 247, 169, 43, 70, 186, 213, 87, 9, 166, 25, 80, 199, 199, 80, 25, 166, 9, 87, 213, 186, 70, 43, 169, 247, 90, 231, 176, 57, 54, 171, 252, 88, 210, 195, 82, 13, 166, 38, 67, 178, 234, 90, 225, 183, 73, 31, 166, 22, 78, 189, 218, 90, 243, 174, 61, 46, 168, 4, 85, 202, 50, 167, 18, 75, 181, 238, 89, 206, 206, 89, 238, 181, 75, 18, 167, 50, 50, 167, 18, 75, 181, 238, 89, 206, 206, 89, 238, 181, 75, 18, 167, 50, 46, 166, 38, 54, 166, 31, 61, 168, 22, 67, 171, 13, 73, 174, 4, 78, 178, 252, 82, 183, 243, 85, 189, 234, 88, 195, 225, 90, 202, 218, 90, 210, 43, 166, 57, 25, 169, 70, 9, 176, 80, 247, 186, 87, 231, 199, 90, 213, 213, 90, 199, 231, 87, 186, 247, 80, 176, 9, 70, 169, 25, 57, 166, 43, 38, 168, 73, 252, 189, 90, 210, 225, 85, 178, 13, 61, 166, 54, 22, 174, 82, 234, 202, 90, 195, 243, 78, 171, 31, 46, 166, 67, 4, 183, 88, 218, 36, 173, 83, 220, 220, 83, 173, 36, 36, 173, 83, 220, 220, 83, 173, 36, 36, 173, 83, 220, 220, 83, 173, 36, 36, 173, 83, 220, 220, 83, 173, 36, 31, 178, 90, 195, 4, 54, 168, 82, 218, 234, 73, 166, 67, 243, 210, 85, 171, 46, 13, 189, 90, 183, 22, 38, 174, 88, 202, 252, 61, 166, 78, 225, 25, 186, 90, 176, 43, 9, 199, 87, 169, 57, 247, 213, 80, 166, 70, 231, 231, 70, 166, 80, 213, 247, 57, 169, 87, 199, 9, 43, 176, 90, 186, 25, 22, 195, 85, 166, 73, 218, 252, 46, 178, 90, 174, 54, 243, 225, 67, 168, 88, 189, 31, 13, 202, 82, 166, 78, 210, 4, 38, 183, 90, 171, 61, 234, 18, 206, 75, 167, 89, 181, 50, 238, 238, 50, 181, 89, 167, 75, 206, 18, 18, 206, 75, 167, 89, 181, 50, 238, 238, 50, 181, 89, 167, 75, 206, 18, 13, 218, 61, 178, 88, 166, 85, 183, 54, 225, 4, 22, 210, 67, 174, 90, 166, 82, 189, 46, 234, 252, 31, 202, 73, 171, 90, 168, 78, 195, 38, 243, 9, 231, 43, 199, 70, 176, 87, 166, 90, 169, 80, 186, 57, 213, 25, 247, 247, 25, 213, 57, 186, 80, 169, 90, 166, 87, 176, 70, 199, 43, 231, 9, 4, 243, 22, 225, 38, 210, 54, 195, 67, 183, 78, 174, 85, 168, 90, 166, 90, 166, 88, 171, 82, 178, 73, 189, 61, 202, 46, 218, 31, 234, 13, 252, 24, 170, 0, 0, 192, 148, 0, 0, 160, 148, 0, 0, 32, 148, 0, 0, 32, 146, 0, 0, 32, 138, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 170, 0, 0, 104, 159, 0, 0, 72, 159, 0, 0, 200, 158, 0, 0, 200, 156, 0, 0, 200, 148, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 170, 0, 0, 16, 170, 0, 0, 240, 169, 0, 0, 112, 169, 0, 0, 112, 167, 0, 0, 112, 159, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 110, 0, 0, 0, 110, 0, 0, 0, 124, 0, 0, 0, 125, 0, 0, 0, 140, 0, 0, 0, 153, 0, 0, 0, 125, 0, 0, 0, 127, 0, 0, 0, 140, 0, 0, 0, 109, 0, 0, 0, 111, 0, 0, 0, 143, 0, 0, 0, 127, 0, 0, 0, 111, 0, 0, 0, 79, 0, 0, 0, 108, 0, 0, 0, 123, 0, 0, 0, 63, 0, 0, 0, 125, 0, 0, 0, 110, 0, 0, 0, 94, 0, 0, 0, 110, 0, 0, 0, 95, 0, 0, 0, 79, 0, 0, 0, 125, 0, 0, 0, 111, 0, 0, 0, 110, 0, 0, 0, 78, 0, 0, 0, 110, 0, 0, 0, 111, 0, 0, 0, 111, 0, 0, 0, 95, 0, 0, 0, 94, 0, 0, 0, 108, 0, 0, 0, 123, 0, 0, 0, 108, 0, 0, 0, 125, 0, 0, 0, 110, 0, 0, 0, 124, 0, 0, 0, 110, 0, 0, 0, 95, 0, 0, 0, 94, 0, 0, 0, 125, 0, 0, 0, 111, 0, 0, 0, 111, 0, 0, 0, 79, 0, 0, 0, 125, 0, 0, 0, 126, 0, 0, 0, 111, 0, 0, 0, 111, 0, 0, 0, 79, 0, 0, 0, 108, 0, 0, 0, 123, 0, 0, 0, 93, 0, 0, 0, 141, 0, 0, 0, 111, 0, 0, 0, 140, 0, 0, 0, 140, 0, 0, 0, 140, 0, 0, 0, 140, 0, 0, 0, 138, 0, 0, 0, 153, 0, 0, 0, 136, 0, 0, 0, 167, 0, 0, 0, 152, 0, 0, 0, 152, 0, 0, 0, 107, 0, 0, 0, 167, 0, 0, 0, 91, 0, 0, 0, 122, 0, 0, 0, 107, 0, 0, 0, 167, 0, 0, 0, 107, 0, 0, 0, 167, 0, 0, 0, 91, 0, 0, 0, 107, 0, 0, 0, 107, 0, 0, 0, 167, 0, 0, 0, 140, 0, 0, 0, 92, 0, 0, 0, 137, 0, 0, 0, 138, 0, 0, 0, 140, 0, 0, 0, 152, 0, 0, 0, 138, 0, 0, 0, 139, 0, 0, 0, 153, 0, 0, 0, 74, 0, 0, 0, 149, 0, 0, 0, 92, 0, 0, 0, 139, 0, 0, 0, 107, 0, 0, 0, 122, 0, 0, 0, 152, 0, 0, 0, 140, 0, 0, 0, 179, 0, 0, 0, 166, 0, 0, 0, 182, 0, 0, 0, 140, 0, 0, 0, 227, 0, 0, 0, 122, 0, 0, 0, 197, 0, 0, 0, 154, 0, 0, 0, 196, 0, 0, 0, 196, 0, 0, 0, 167, 0, 0, 0, 154, 0, 0, 0, 152, 0, 0, 0, 167, 0, 0, 0, 182, 0, 0, 0, 182, 0, 0, 0, 134, 0, 0, 0, 149, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 121, 0, 0, 0, 136, 0, 0, 0, 137, 0, 0, 0, 169, 0, 0, 0, 194, 0, 0, 0, 166, 0, 0, 0, 167, 0, 0, 0, 154, 0, 0, 0, 167, 0, 0, 0, 137, 0, 0, 0, 182, 0, 0, 0, 154, 0, 0, 0, 196, 0, 0, 0, 167, 0, 0, 0, 167, 0, 0, 0, 154, 0, 0, 0, 152, 0, 0, 0, 167, 0, 0, 0, 182, 0, 0, 0, 182, 0, 0, 0, 134, 0, 0, 0, 149, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 121, 0, 0, 0, 136, 0, 0, 0, 122, 0, 0, 0, 169, 0, 0, 0, 208, 0, 0, 0, 166, 0, 0, 0, 167, 0, 0, 0, 154, 0, 0, 0, 152, 0, 0, 0, 167, 0, 0, 0, 182, 0, 0, 0, 200, 0, 0, 0, 185, 0, 0, 0, 160, 0, 0, 0, 0, 0, 0, 0, 184, 0, 0, 0, 154, 0, 0, 0, 183, 0, 0, 0, 0, 0, 0, 0, 154, 0, 0, 0, 154, 0, 0, 0, 154, 0, 0, 0, 0, 0, 0, 0, 111, 0, 0, 0, 111, 0, 0, 0, 125, 0, 0, 0, 110, 0, 0, 0, 110, 0, 0, 0, 94, 0, 0, 0, 124, 0, 0, 0, 108, 0, 0, 0, 124, 0, 0, 0, 107, 0, 0, 0, 125, 0, 0, 0, 141, 0, 0, 0, 179, 0, 0, 0, 153, 0, 0, 0, 125, 0, 0, 0, 107, 0, 0, 0, 125, 0, 0, 0, 141, 0, 0, 0, 179, 0, 0, 0, 153, 0, 0, 0, 125, 0, 0, 0, 107, 0, 0, 0, 125, 0, 0, 0, 141, 0, 0, 0, 179, 0, 0, 0, 153, 0, 0, 0, 125, 0, 0, 0, 140, 0, 0, 0, 139, 0, 0, 0, 182, 0, 0, 0, 182, 0, 0, 0, 152, 0, 0, 0, 136, 0, 0, 0, 152, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 136, 0, 0, 0, 139, 0, 0, 0, 111, 0, 0, 0, 136, 0, 0, 0, 139, 0, 0, 0, 111, 0, 0, 0, 155, 0, 0, 0, 154, 0, 0, 0, 139, 0, 0, 0, 153, 0, 0, 0, 139, 0, 0, 0, 123, 0, 0, 0, 123, 0, 0, 0, 63, 0, 0, 0, 153, 0, 0, 0, 166, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 154, 0, 0, 0, 166, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 154, 0, 0, 0, 166, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 154, 0, 0, 0, 170, 0, 0, 0, 153, 0, 0, 0, 123, 0, 0, 0, 123, 0, 0, 0, 107, 0, 0, 0, 121, 0, 0, 0, 107, 0, 0, 0, 121, 0, 0, 0, 167, 0, 0, 0, 151, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 151, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 170, 0, 0, 0, 154, 0, 0, 0, 139, 0, 0, 0, 153, 0, 0, 0, 139, 0, 0, 0, 123, 0, 0, 0, 123, 0, 0, 0, 63, 0, 0, 0, 124, 0, 0, 0, 166, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 154, 0, 0, 0, 166, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 154, 0, 0, 0, 166, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 136, 0, 0, 0, 153, 0, 0, 0, 154, 0, 0, 0, 170, 0, 0, 0, 153, 0, 0, 0, 138, 0, 0, 0, 138, 0, 0, 0, 122, 0, 0, 0, 121, 0, 0, 0, 122, 0, 0, 0, 121, 0, 0, 0, 167, 0, 0, 0, 151, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 151, 0, 0, 0, 183, 0, 0, 0, 140, 0, 0, 0, 63, 0, 0, 0, 152, 0, 0, 0, 152, 0, 0, 0, 0, 0, 0, 0, 140, 0, 0, 0, 198, 0, 0, 0, 169, 0, 0, 0, 198, 0, 0, 0, 153, 0, 0, 0, 153, 0, 0, 0, 153, 0, 0, 0, 0, 0, 0, 0, 153, 0, 0, 0, 138, 0, 0, 0, 138, 0, 0, 0, 124, 0, 0, 0, 138, 0, 0, 0, 94, 0, 0, 0, 224, 0, 0, 0, 167, 0, 0, 0, 122, 0, 0, 0, 0, 0, 0, 0, 91, 0, 0, 0, 171, 0, 0, 0, 134, 0, 0, 0, 141, 0, 0, 0, 121, 0, 0, 0, 140, 0, 0, 0, 61, 0, 0, 0, 154, 0, 0, 0, 121, 0, 0, 0, 140, 0, 0, 0, 61, 0, 0, 0, 154, 0, 0, 0, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 17, 16, 17, 16, 17, 18, 17, 18, 18, 17, 18, 21, 19, 20, 21, 20, 19, 21, 24, 22, 22, 24, 24, 22, 22, 24, 25, 25, 27, 30, 27, 25, 25, 29, 31, 35, 35, 31, 29, 36, 41, 44, 41, 36, 47, 54, 54, 47, 65, 70, 65, 88, 88, 115, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 20, 20, 20, 20, 20, 20, 20, 24, 24, 24, 24, 24, 24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 28, 28, 28, 28, 28, 28, 33, 33, 33, 33, 33, 41, 41, 41, 41, 54, 54, 54, 71, 71, 91, 149, 0, 0, 0, 134, 0, 0, 0, 139, 0, 0, 0, 141, 0, 0, 0, 157, 0, 0, 0, 107, 0, 0, 0, 139, 0, 0, 0, 126, 0, 0, 0, 107, 0, 0, 0, 139, 0, 0, 0, 126, 0, 0, 0, 0, 0, 0, 0, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 197, 0, 0, 0, 185, 0, 0, 0, 201, 0, 0, 0, 197, 0, 0, 0, 185, 0, 0, 0, 201, 0, 0, 0, 110, 0, 0, 0, 154, 0, 0, 0, 94, 0, 0, 0, 138, 0, 0, 0, 182, 0, 0, 0, 154, 0, 0, 0, 149, 0, 0, 0, 107, 0, 0, 0, 167, 0, 0, 0, 154, 0, 0, 0, 149, 0, 0, 0, 92, 0, 0, 0, 167, 0, 0, 0, 154, 0, 0, 0, 184, 0, 0, 0, 154, 0, 0, 0, 139, 0, 0, 0, 154, 0, 0, 0, 154, 0, 0, 0, 154, 0, 0, 0, 139, 0, 0, 0, 154, 0, 0, 0, 154, 0, 0, 0, 0, 0, 0, 0, 122, 0, 0, 0, 137, 0, 0, 0, 111, 0, 0, 0, 141, 0, 0, 0, 153, 0, 0, 0, 111, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 0, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 62, 63, 0, 0, 1, 2, 2, 4, 4, 5, 6, 7, 8, 9, 9, 11, 11, 12, 13, 13, 15, 15, 16, 16, 18, 18, 19, 19, 21, 21, 22, 22, 23, 24, 24, 25, 26, 26, 27, 27, 28, 29, 29, 30, 30, 30, 31, 32, 32, 33, 33, 33, 34, 34, 35, 35, 35, 36, 36, 36, 37, 37, 37, 38, 38, 63, 0, 1, 2, 2, 2, 2, 3, 5, 7, 8, 10, 12, 13, 15, 17, 18, 19, 20, 21, 22, 23, 23, 24, 24, 25, 25, 26, 27, 27, 28, 28, 29, 29, 30, 31, 0, 0, 0, 0, 0, 0, 240, 255, 255, 154, 249, 255, 255, 114, 252, 255, 255, 138, 253, 255, 255, 30, 254, 255, 255, 122, 254, 255, 255, 197, 254, 255, 255, 0, 255, 255, 255, 197, 254, 255, 255, 122, 254, 255, 255, 30, 254, 255, 255, 138, 253, 255, 255, 114, 252, 255, 255, 154, 249, 255, 255, 0, 240, 255, 255, 0, 0, 0, 0, 255, 255, 255, 255, 2, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 5, 5, 6, 6, 7, 8, 9, 10, 11, 13, 14, 16, 18, 20, 22, 24, 0, 0, 255, 255, 255, 255, 2], "i8", ALLOC_NONE, Runtime.GLOBAL_BASE + 20480);
    /* memory initializer */
    allocate([2, 0, 0, 0, 1, 0, 0, 0, 6, 5, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 3, 0, 0, 0, 3, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 3, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 12, 0, 11, 0, 10, 0, 11, 0, 16, 0, 11, 0, 40, 0, 33, 0, 24, 0, 11, 0, 20, 0, 11, 0, 32, 0, 11, 0, 80, 0, 33, 0, 18, 0, 11, 0, 15, 0, 11, 0, 64, 0, 33, 0, 160, 0, 99, 0, 4, 0, 3, 0, 3, 0, 2, 0, 2, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 1, 0, 0, 0, 3, 0, 0, 0, 2, 0, 0, 0, 3, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 1, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 1, 0, 0, 0, 3, 0, 0, 0, 2, 0, 0, 0, 40, 0, 0, 0, 45, 0, 0, 0, 51, 0, 0, 0, 57, 0, 0, 0, 64, 0, 0, 0, 72, 0, 0, 0], "i8", ALLOC_NONE, Runtime.GLOBAL_BASE + 30720);



    var tempDoublePtr = Runtime.alignMemory(allocate(12, "i8", ALLOC_STATIC), 8);

    assert(tempDoublePtr % 8 == 0);

    function copyTempFloat(ptr) { // functions, because inlining this code increases code size too much

        HEAP8[tempDoublePtr] = HEAP8[ptr];

        HEAP8[tempDoublePtr + 1] = HEAP8[ptr + 1];

        HEAP8[tempDoublePtr + 2] = HEAP8[ptr + 2];

        HEAP8[tempDoublePtr + 3] = HEAP8[ptr + 3];

    }

    function copyTempDouble(ptr) {

        HEAP8[tempDoublePtr] = HEAP8[ptr];

        HEAP8[tempDoublePtr + 1] = HEAP8[ptr + 1];

        HEAP8[tempDoublePtr + 2] = HEAP8[ptr + 2];

        HEAP8[tempDoublePtr + 3] = HEAP8[ptr + 3];

        HEAP8[tempDoublePtr + 4] = HEAP8[ptr + 4];

        HEAP8[tempDoublePtr + 5] = HEAP8[ptr + 5];

        HEAP8[tempDoublePtr + 6] = HEAP8[ptr + 6];

        HEAP8[tempDoublePtr + 7] = HEAP8[ptr + 7];

    }



    function __ZSt18uncaught_exceptionv() { // std::uncaught_exception()
        return !!__ZSt18uncaught_exceptionv.uncaught_exception;
    }



    function ___cxa_is_number_type(type) {
        var isNumber = false;
        try { if (type == __ZTIi) isNumber = true } catch (e) {}
        try { if (type == __ZTIj) isNumber = true } catch (e) {}
        try { if (type == __ZTIl) isNumber = true } catch (e) {}
        try { if (type == __ZTIm) isNumber = true } catch (e) {}
        try { if (type == __ZTIx) isNumber = true } catch (e) {}
        try { if (type == __ZTIy) isNumber = true } catch (e) {}
        try { if (type == __ZTIf) isNumber = true } catch (e) {}
        try { if (type == __ZTId) isNumber = true } catch (e) {}
        try { if (type == __ZTIe) isNumber = true } catch (e) {}
        try { if (type == __ZTIc) isNumber = true } catch (e) {}
        try { if (type == __ZTIa) isNumber = true } catch (e) {}
        try { if (type == __ZTIh) isNumber = true } catch (e) {}
        try { if (type == __ZTIs) isNumber = true } catch (e) {}
        try { if (type == __ZTIt) isNumber = true } catch (e) {}
        return isNumber;
    }

    function ___cxa_does_inherit(definiteType, possibilityType, possibility) {
        if (possibility == 0) return false;
        if (possibilityType == 0 || possibilityType == definiteType)
            return true;
        var possibility_type_info;
        if (___cxa_is_number_type(possibilityType)) {
            possibility_type_info = possibilityType;
        } else {
            var possibility_type_infoAddr = HEAP32[((possibilityType) >> 2)] - 8;
            possibility_type_info = HEAP32[((possibility_type_infoAddr) >> 2)];
        }
        switch (possibility_type_info) {
            case 0: // possibility is a pointer
                // See if definite type is a pointer
                var definite_type_infoAddr = HEAP32[((definiteType) >> 2)] - 8;
                var definite_type_info = HEAP32[((definite_type_infoAddr) >> 2)];
                if (definite_type_info == 0) {
                    // Also a pointer; compare base types of pointers
                    var defPointerBaseAddr = definiteType + 8;
                    var defPointerBaseType = HEAP32[((defPointerBaseAddr) >> 2)];
                    var possPointerBaseAddr = possibilityType + 8;
                    var possPointerBaseType = HEAP32[((possPointerBaseAddr) >> 2)];
                    return ___cxa_does_inherit(defPointerBaseType, possPointerBaseType, possibility);
                } else
                    return false; // one pointer and one non-pointer
            case 1: // class with no base class
                return false;
            case 2: // class with base class
                var parentTypeAddr = possibilityType + 8;
                var parentType = HEAP32[((parentTypeAddr) >> 2)];
                return ___cxa_does_inherit(definiteType, parentType, possibility);
            default:
                return false; // some unencountered type
        }
    }



    var ___cxa_last_thrown_exception = 0;

    function ___resumeException(ptr) {
        if (!___cxa_last_thrown_exception) { ___cxa_last_thrown_exception = ptr; }
        throw ptr + " - Exception catching is disabled, this exception cannot be caught. Compile with -s DISABLE_EXCEPTION_CATCHING=0 or DISABLE_EXCEPTION_CATCHING=2 to catch.";
    }

    var ___cxa_exception_header_size = 8;

    function ___cxa_find_matching_catch(thrown, throwntype) {
        if (thrown == -1) thrown = ___cxa_last_thrown_exception;
        header = thrown - ___cxa_exception_header_size;
        if (throwntype == -1) throwntype = HEAP32[((header) >> 2)];
        var typeArray = Array.prototype.slice.call(arguments, 2);

        // If throwntype is a pointer, this means a pointer has been
        // thrown. When a pointer is thrown, actually what's thrown
        // is a pointer to the pointer. We'll dereference it.
        if (throwntype != 0 && !___cxa_is_number_type(throwntype)) {
            var throwntypeInfoAddr = HEAP32[((throwntype) >> 2)] - 8;
            var throwntypeInfo = HEAP32[((throwntypeInfoAddr) >> 2)];
            if (throwntypeInfo == 0)
                thrown = HEAP32[((thrown) >> 2)];
        }
        // The different catch blocks are denoted by different types.
        // Due to inheritance, those types may not precisely match the
        // type of the thrown object. Find one which matches, and
        // return the type of the catch block which should be called.
        for (var i = 0; i < typeArray.length; i++) {
            if (___cxa_does_inherit(typeArray[i], throwntype, thrown))
                return ((asm["setTempRet0"](typeArray[i]), thrown) | 0);
        }
        // Shouldn't happen unless we have bogus data in typeArray
        // or encounter a type for which emscripten doesn't have suitable
        // typeinfo defined. Best-efforts match just in case.
        return ((asm["setTempRet0"](throwntype), thrown) | 0);
    }

    function ___gxx_personality_v0() {}

    function ___assert_fail(condition, filename, line, func) {
        ABORT = true;
        throw 'Assertion failed: ' + Pointer_stringify(condition) + ', at: ' + [filename ? Pointer_stringify(filename) : 'unknown filename', line, func ? Pointer_stringify(func) : 'unknown function'] + ' at ' + stackTrace();
    }



    function _emscripten_memcpy_big(dest, src, num) {
        HEAPU8.set(HEAPU8.subarray(src, src + num), dest);
        return dest;
    }
    Module["_memcpy"] = _memcpy;
    var _llvm_memcpy_p0i8_p0i8_i32 = _memcpy;

    function ___cxa_allocate_exception(size) {
        var ptr = _malloc(size + ___cxa_exception_header_size);
        return ptr + ___cxa_exception_header_size;
    }

    function ___cxa_free_exception(ptr) {
        try {
            return _free(ptr - ___cxa_exception_header_size);
        } catch (e) { // XXX FIXME
        }
    }

    function ___cxa_throw(ptr, type, destructor) {
        if (!___cxa_throw.initialized) {
            try {
                HEAP32[((__ZTVN10__cxxabiv119__pointer_type_infoE) >> 2)] = 0; // Workaround for libcxxabi integration bug
            } catch (e) {}
            try {
                HEAP32[((__ZTVN10__cxxabiv117__class_type_infoE) >> 2)] = 1; // Workaround for libcxxabi integration bug
            } catch (e) {}
            try {
                HEAP32[((__ZTVN10__cxxabiv120__si_class_type_infoE) >> 2)] = 2; // Workaround for libcxxabi integration bug
            } catch (e) {}
            ___cxa_throw.initialized = true;
        }
        var header = ptr - ___cxa_exception_header_size;
        HEAP32[((header) >> 2)] = type;
        HEAP32[(((header) + (4)) >> 2)] = destructor;
        ___cxa_last_thrown_exception = ptr;
        if (!("uncaught_exception" in __ZSt18uncaught_exceptionv)) {
            __ZSt18uncaught_exceptionv.uncaught_exception = 1;
        } else {
            __ZSt18uncaught_exceptionv.uncaught_exception++;
        }
        throw ptr + " - Exception catching is disabled, this exception cannot be caught. Compile with -s DISABLE_EXCEPTION_CATCHING=0 or DISABLE_EXCEPTION_CATCHING=2 to catch.";
    }



    var ERRNO_CODES = { EPERM: 1, ENOENT: 2, ESRCH: 3, EINTR: 4, EIO: 5, ENXIO: 6, E2BIG: 7, ENOEXEC: 8, EBADF: 9, ECHILD: 10, EAGAIN: 11, EWOULDBLOCK: 11, ENOMEM: 12, EACCES: 13, EFAULT: 14, ENOTBLK: 15, EBUSY: 16, EEXIST: 17, EXDEV: 18, ENODEV: 19, ENOTDIR: 20, EISDIR: 21, EINVAL: 22, ENFILE: 23, EMFILE: 24, ENOTTY: 25, ETXTBSY: 26, EFBIG: 27, ENOSPC: 28, ESPIPE: 29, EROFS: 30, EMLINK: 31, EPIPE: 32, EDOM: 33, ERANGE: 34, ENOMSG: 42, EIDRM: 43, ECHRNG: 44, EL2NSYNC: 45, EL3HLT: 46, EL3RST: 47, ELNRNG: 48, EUNATCH: 49, ENOCSI: 50, EL2HLT: 51, EDEADLK: 35, ENOLCK: 37, EBADE: 52, EBADR: 53, EXFULL: 54, ENOANO: 55, EBADRQC: 56, EBADSLT: 57, EDEADLOCK: 35, EBFONT: 59, ENOSTR: 60, ENODATA: 61, ETIME: 62, ENOSR: 63, ENONET: 64, ENOPKG: 65, EREMOTE: 66, ENOLINK: 67, EADV: 68, ESRMNT: 69, ECOMM: 70, EPROTO: 71, EMULTIHOP: 72, EDOTDOT: 73, EBADMSG: 74, ENOTUNIQ: 76, EBADFD: 77, EREMCHG: 78, ELIBACC: 79, ELIBBAD: 80, ELIBSCN: 81, ELIBMAX: 82, ELIBEXEC: 83, ENOSYS: 38, ENOTEMPTY: 39, ENAMETOOLONG: 36, ELOOP: 40, EOPNOTSUPP: 95, EPFNOSUPPORT: 96, ECONNRESET: 104, ENOBUFS: 105, EAFNOSUPPORT: 97, EPROTOTYPE: 91, ENOTSOCK: 88, ENOPROTOOPT: 92, ESHUTDOWN: 108, ECONNREFUSED: 111, EADDRINUSE: 98, ECONNABORTED: 103, ENETUNREACH: 101, ENETDOWN: 100, ETIMEDOUT: 110, EHOSTDOWN: 112, EHOSTUNREACH: 113, EINPROGRESS: 115, EALREADY: 114, EDESTADDRREQ: 89, EMSGSIZE: 90, EPROTONOSUPPORT: 93, ESOCKTNOSUPPORT: 94, EADDRNOTAVAIL: 99, ENETRESET: 102, EISCONN: 106, ENOTCONN: 107, ETOOMANYREFS: 109, EUSERS: 87, EDQUOT: 122, ESTALE: 116, ENOTSUP: 95, ENOMEDIUM: 123, EILSEQ: 84, EOVERFLOW: 75, ECANCELED: 125, ENOTRECOVERABLE: 131, EOWNERDEAD: 130, ESTRPIPE: 86 };

    var ERRNO_MESSAGES = { 0: "Success", 1: "Not super-user", 2: "No such file or directory", 3: "No such process", 4: "Interrupted system call", 5: "I/O error", 6: "No such device or address", 7: "Arg list too long", 8: "Exec format error", 9: "Bad file number", 10: "No children", 11: "No more processes", 12: "Not enough core", 13: "Permission denied", 14: "Bad address", 15: "Block device required", 16: "Mount device busy", 17: "File exists", 18: "Cross-device link", 19: "No such device", 20: "Not a directory", 21: "Is a directory", 22: "Invalid argument", 23: "Too many open files in system", 24: "Too many open files", 25: "Not a typewriter", 26: "Text file busy", 27: "File too large", 28: "No space left on device", 29: "Illegal seek", 30: "Read only file system", 31: "Too many links", 32: "Broken pipe", 33: "Math arg out of domain of func", 34: "Math result not representable", 35: "File locking deadlock error", 36: "File or path name too long", 37: "No record locks available", 38: "Function not implemented", 39: "Directory not empty", 40: "Too many symbolic links", 42: "No message of desired type", 43: "Identifier removed", 44: "Channel number out of range", 45: "Level 2 not synchronized", 46: "Level 3 halted", 47: "Level 3 reset", 48: "Link number out of range", 49: "Protocol driver not attached", 50: "No CSI structure available", 51: "Level 2 halted", 52: "Invalid exchange", 53: "Invalid request descriptor", 54: "Exchange full", 55: "No anode", 56: "Invalid request code", 57: "Invalid slot", 59: "Bad font file fmt", 60: "Device not a stream", 61: "No data (for no delay io)", 62: "Timer expired", 63: "Out of streams resources", 64: "Machine is not on the network", 65: "Package not installed", 66: "The object is remote", 67: "The link has been severed", 68: "Advertise error", 69: "Srmount error", 70: "Communication error on send", 71: "Protocol error", 72: "Multihop attempted", 73: "Cross mount point (not really error)", 74: "Trying to read unreadable message", 75: "Value too large for defined data type", 76: "Given log. name not unique", 77: "f.d. invalid for this operation", 78: "Remote address changed", 79: "Can   access a needed shared lib", 80: "Accessing a corrupted shared lib", 81: ".lib section in a.out corrupted", 82: "Attempting to link in too many libs", 83: "Attempting to exec a shared library", 84: "Illegal byte sequence", 86: "Streams pipe error", 87: "Too many users", 88: "Socket operation on non-socket", 89: "Destination address required", 90: "Message too long", 91: "Protocol wrong type for socket", 92: "Protocol not available", 93: "Unknown protocol", 94: "Socket type not supported", 95: "Not supported", 96: "Protocol family not supported", 97: "Address family not supported by protocol family", 98: "Address already in use", 99: "Address not available", 100: "Network interface is not configured", 101: "Network is unreachable", 102: "Connection reset by network", 103: "Connection aborted", 104: "Connection reset by peer", 105: "No buffer space available", 106: "Socket is already connected", 107: "Socket is not connected", 108: "Can't send after socket shutdown", 109: "Too many references", 110: "Connection timed out", 111: "Connection refused", 112: "Host is down", 113: "Host is unreachable", 114: "Socket already connected", 115: "Connection already in progress", 116: "Stale file handle", 122: "Quota exceeded", 123: "No medium (in tape drive)", 125: "Operation canceled", 130: "Previous owner died", 131: "State not recoverable" };


    var ___errno_state = 0;

    function ___setErrNo(value) {
        // For convenient setting and returning of errno.
        HEAP32[((___errno_state) >> 2)] = value;
        return value;
    }

    var PATH = {
        splitPath: function(filename) {
            var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
            return splitPathRe.exec(filename).slice(1);
        },
        normalizeArray: function(parts, allowAboveRoot) {
            // if the path tries to go above the root, `up` ends up > 0
            var up = 0;
            for (var i = parts.length - 1; i >= 0; i--) {
                var last = parts[i];
                if (last === '.') {
                    parts.splice(i, 1);
                } else if (last === '..') {
                    parts.splice(i, 1);
                    up++;
                } else if (up) {
                    parts.splice(i, 1);
                    up--;
                }
            }
            // if the path is allowed to go above the root, restore leading ..s
            if (allowAboveRoot) {
                for (; up--; up) {
                    parts.unshift('..');
                }
            }
            return parts;
        },
        normalize: function(path) {
            var isAbsolute = path.charAt(0) === '/',
                trailingSlash = path.substr(-1) === '/';
            // Normalize the path
            path = PATH.normalizeArray(path.split('/').filter(function(p) {
                return !!p;
            }), !isAbsolute).join('/');
            if (!path && !isAbsolute) {
                path = '.';
            }
            if (path && trailingSlash) {
                path += '/';
            }
            return (isAbsolute ? '/' : '') + path;
        },
        dirname: function(path) {
            var result = PATH.splitPath(path),
                root = result[0],
                dir = result[1];
            if (!root && !dir) {
                // No dirname whatsoever
                return '.';
            }
            if (dir) {
                // It has a dirname, strip trailing slash
                dir = dir.substr(0, dir.length - 1);
            }
            return root + dir;
        },
        basename: function(path) {
            // EMSCRIPTEN return '/'' for '/', not an empty string
            if (path === '/') return '/';
            var lastSlash = path.lastIndexOf('/');
            if (lastSlash === -1) return path;
            return path.substr(lastSlash + 1);
        },
        extname: function(path) {
            return PATH.splitPath(path)[3];
        },
        join: function() {
            var paths = Array.prototype.slice.call(arguments, 0);
            return PATH.normalize(paths.join('/'));
        },
        join2: function(l, r) {
            return PATH.normalize(l + '/' + r);
        },
        resolve: function() {
            var resolvedPath = '',
                resolvedAbsolute = false;
            for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
                var path = (i >= 0) ? arguments[i] : FS.cwd();
                // Skip empty and invalid entries
                if (typeof path !== 'string') {
                    throw new TypeError('Arguments to path.resolve must be strings');
                } else if (!path) {
                    continue;
                }
                resolvedPath = path + '/' + resolvedPath;
                resolvedAbsolute = path.charAt(0) === '/';
            }
            // At this point the path should be resolved to a full absolute path, but
            // handle relative paths to be safe (might happen when process.cwd() fails)
            resolvedPath = PATH.normalizeArray(resolvedPath.split('/').filter(function(p) {
                return !!p;
            }), !resolvedAbsolute).join('/');
            return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
        },
        relative: function(from, to) {
            from = PATH.resolve(from).substr(1);
            to = PATH.resolve(to).substr(1);

            function trim(arr) {
                var start = 0;
                for (; start < arr.length; start++) {
                    if (arr[start] !== '') break;
                }
                var end = arr.length - 1;
                for (; end >= 0; end--) {
                    if (arr[end] !== '') break;
                }
                if (start > end) return [];
                return arr.slice(start, end - start + 1);
            }
            var fromParts = trim(from.split('/'));
            var toParts = trim(to.split('/'));
            var length = Math.min(fromParts.length, toParts.length);
            var samePartsLength = length;
            for (var i = 0; i < length; i++) {
                if (fromParts[i] !== toParts[i]) {
                    samePartsLength = i;
                    break;
                }
            }
            var outputParts = [];
            for (var i = samePartsLength; i < fromParts.length; i++) {
                outputParts.push('..');
            }
            outputParts = outputParts.concat(toParts.slice(samePartsLength));
            return outputParts.join('/');
        }
    };

    var TTY = {
        ttys: [],
        init: function() {
            // https://github.com/kripken/emscripten/pull/1555
            // if (ENVIRONMENT_IS_NODE) {
            //   // currently, FS.init does not distinguish if process.stdin is a file or TTY
            //   // device, it always assumes it's a TTY device. because of this, we're forcing
            //   // process.stdin to UTF8 encoding to at least make stdin reading compatible
            //   // with text files until FS.init can be refactored.
            //   process['stdin']['setEncoding']('utf8');
            // }
        },
        shutdown: function() {
            // https://github.com/kripken/emscripten/pull/1555
            // if (ENVIRONMENT_IS_NODE) {
            //   // inolen: any idea as to why node -e 'process.stdin.read()' wouldn't exit immediately (with process.stdin being a tty)?
            //   // isaacs: because now it's reading from the stream, you've expressed interest in it, so that read() kicks off a _read() which creates a ReadReq operation
            //   // inolen: I thought read() in that case was a synchronous operation that just grabbed some amount of buffered data if it exists?
            //   // isaacs: it is. but it also triggers a _read() call, which calls readStart() on the handle
            //   // isaacs: do process.stdin.pause() and i'd think it'd probably close the pending call
            //   process['stdin']['pause']();
            // }
        },
        register: function(dev, ops) {
            TTY.ttys[dev] = { input: [], output: [], ops: ops };
            FS.registerDevice(dev, TTY.stream_ops);
        },
        stream_ops: {
            open: function(stream) {
                var tty = TTY.ttys[stream.node.rdev];
                if (!tty) {
                    throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
                }
                stream.tty = tty;
                stream.seekable = false;
            },
            close: function(stream) {
                // flush any pending line data
                if (stream.tty.output.length) {
                    stream.tty.ops.put_char(stream.tty, 10);
                }
            },
            read: function(stream, buffer, offset, length, pos /* ignored */ ) {
                if (!stream.tty || !stream.tty.ops.get_char) {
                    throw new FS.ErrnoError(ERRNO_CODES.ENXIO);
                }
                var bytesRead = 0;
                for (var i = 0; i < length; i++) {
                    var result;
                    try {
                        result = stream.tty.ops.get_char(stream.tty);
                    } catch (e) {
                        throw new FS.ErrnoError(ERRNO_CODES.EIO);
                    }
                    if (result === undefined && bytesRead === 0) {
                        throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
                    }
                    if (result === null || result === undefined) break;
                    bytesRead++;
                    buffer[offset + i] = result;
                }
                if (bytesRead) {
                    stream.node.timestamp = Date.now();
                }
                return bytesRead;
            },
            write: function(stream, buffer, offset, length, pos) {
                if (!stream.tty || !stream.tty.ops.put_char) {
                    throw new FS.ErrnoError(ERRNO_CODES.ENXIO);
                }
                for (var i = 0; i < length; i++) {
                    try {
                        stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                    } catch (e) {
                        throw new FS.ErrnoError(ERRNO_CODES.EIO);
                    }
                }
                if (length) {
                    stream.node.timestamp = Date.now();
                }
                return i;
            }
        },
        default_tty_ops: {
            get_char: function(tty) {
                if (!tty.input.length) {
                    var result = null;
                    if (ENVIRONMENT_IS_NODE) {
                        result = process['stdin']['read']();
                        if (!result) {
                            if (process['stdin']['_readableState'] && process['stdin']['_readableState']['ended']) {
                                return null; // EOF
                            }
                            return undefined; // no data available
                        }
                    } else if (typeof window != 'undefined' &&
                        typeof window.prompt == 'function') {
                        // Browser.
                        result = window.prompt('Input: '); // returns null on cancel
                        if (result !== null) {
                            result += '\n';
                        }
                    } else if (typeof readline == 'function') {
                        // Command line.
                        result = readline();
                        if (result !== null) {
                            result += '\n';
                        }
                    }
                    if (!result) {
                        return null;
                    }
                    tty.input = intArrayFromString(result, true);
                }
                return tty.input.shift();
            },
            put_char: function(tty, val) {
                if (val === null || val === 10) {
                    Module['print'](tty.output.join(''));
                    tty.output = [];
                } else {
                    tty.output.push(TTY.utf8.processCChar(val));
                }
            }
        },
        default_tty1_ops: {
            put_char: function(tty, val) {
                if (val === null || val === 10) {
                    Module['printErr'](tty.output.join(''));
                    tty.output = [];
                } else {
                    tty.output.push(TTY.utf8.processCChar(val));
                }
            }
        }
    };

    var MEMFS = {
        ops_table: null,
        CONTENT_OWNING: 1,
        CONTENT_FLEXIBLE: 2,
        CONTENT_FIXED: 3,
        mount: function(mount) {
            return MEMFS.createNode(null, '/', 16384 | 511 /* 0777 */ , 0);
        },
        createNode: function(parent, name, mode, dev) {
            if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
                // no supported
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            if (!MEMFS.ops_table) {
                MEMFS.ops_table = {
                    dir: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            lookup: MEMFS.node_ops.lookup,
                            mknod: MEMFS.node_ops.mknod,
                            rename: MEMFS.node_ops.rename,
                            unlink: MEMFS.node_ops.unlink,
                            rmdir: MEMFS.node_ops.rmdir,
                            readdir: MEMFS.node_ops.readdir,
                            symlink: MEMFS.node_ops.symlink
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek
                        }
                    },
                    file: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek,
                            read: MEMFS.stream_ops.read,
                            write: MEMFS.stream_ops.write,
                            allocate: MEMFS.stream_ops.allocate,
                            mmap: MEMFS.stream_ops.mmap
                        }
                    },
                    link: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            readlink: MEMFS.node_ops.readlink
                        },
                        stream: {}
                    },
                    chrdev: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: FS.chrdev_stream_ops
                    },
                };
            }
            var node = FS.createNode(parent, name, mode, dev);
            if (FS.isDir(node.mode)) {
                node.node_ops = MEMFS.ops_table.dir.node;
                node.stream_ops = MEMFS.ops_table.dir.stream;
                node.contents = {};
            } else if (FS.isFile(node.mode)) {
                node.node_ops = MEMFS.ops_table.file.node;
                node.stream_ops = MEMFS.ops_table.file.stream;
                node.contents = [];
                node.contentMode = MEMFS.CONTENT_FLEXIBLE;
            } else if (FS.isLink(node.mode)) {
                node.node_ops = MEMFS.ops_table.link.node;
                node.stream_ops = MEMFS.ops_table.link.stream;
            } else if (FS.isChrdev(node.mode)) {
                node.node_ops = MEMFS.ops_table.chrdev.node;
                node.stream_ops = MEMFS.ops_table.chrdev.stream;
            }
            node.timestamp = Date.now();
            // add the new node to the parent
            if (parent) {
                parent.contents[name] = node;
            }
            return node;
        },
        ensureFlexible: function(node) {
            if (node.contentMode !== MEMFS.CONTENT_FLEXIBLE) {
                var contents = node.contents;
                node.contents = Array.prototype.slice.call(contents);
                node.contentMode = MEMFS.CONTENT_FLEXIBLE;
            }
        },
        node_ops: {
            getattr: function(node) {
                var attr = {};
                // device numbers reuse inode numbers.
                attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                attr.ino = node.id;
                attr.mode = node.mode;
                attr.nlink = 1;
                attr.uid = 0;
                attr.gid = 0;
                attr.rdev = node.rdev;
                if (FS.isDir(node.mode)) {
                    attr.size = 4096;
                } else if (FS.isFile(node.mode)) {
                    attr.size = node.contents.length;
                } else if (FS.isLink(node.mode)) {
                    attr.size = node.link.length;
                } else {
                    attr.size = 0;
                }
                attr.atime = new Date(node.timestamp);
                attr.mtime = new Date(node.timestamp);
                attr.ctime = new Date(node.timestamp);
                // NOTE: In our implementation, st_blocks = Math.ceil(st_size/st_blksize),
                //       but this is not required by the standard.
                attr.blksize = 4096;
                attr.blocks = Math.ceil(attr.size / attr.blksize);
                return attr;
            },
            setattr: function(node, attr) {
                if (attr.mode !== undefined) {
                    node.mode = attr.mode;
                }
                if (attr.timestamp !== undefined) {
                    node.timestamp = attr.timestamp;
                }
                if (attr.size !== undefined) {
                    MEMFS.ensureFlexible(node);
                    var contents = node.contents;
                    if (attr.size < contents.length) contents.length = attr.size;
                    else
                        while (attr.size > contents.length) contents.push(0);
                }
            },
            lookup: function(parent, name) {
                throw FS.genericErrors[ERRNO_CODES.ENOENT];
            },
            mknod: function(parent, name, mode, dev) {
                return MEMFS.createNode(parent, name, mode, dev);
            },
            rename: function(old_node, new_dir, new_name) {
                // if we're overwriting a directory at new_name, make sure it's empty.
                if (FS.isDir(old_node.mode)) {
                    var new_node;
                    try {
                        new_node = FS.lookupNode(new_dir, new_name);
                    } catch (e) {}
                    if (new_node) {
                        for (var i in new_node.contents) {
                            throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY);
                        }
                    }
                }
                // do the internal rewiring
                delete old_node.parent.contents[old_node.name];
                old_node.name = new_name;
                new_dir.contents[new_name] = old_node;
                old_node.parent = new_dir;
            },
            unlink: function(parent, name) {
                delete parent.contents[name];
            },
            rmdir: function(parent, name) {
                var node = FS.lookupNode(parent, name);
                for (var i in node.contents) {
                    throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY);
                }
                delete parent.contents[name];
            },
            readdir: function(node) {
                var entries = ['.', '..']
                for (var key in node.contents) {
                    if (!node.contents.hasOwnProperty(key)) {
                        continue;
                    }
                    entries.push(key);
                }
                return entries;
            },
            symlink: function(parent, newname, oldpath) {
                var node = MEMFS.createNode(parent, newname, 511 /* 0777 */ | 40960, 0);
                node.link = oldpath;
                return node;
            },
            readlink: function(node) {
                if (!FS.isLink(node.mode)) {
                    throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
                }
                return node.link;
            }
        },
        stream_ops: {
            read: function(stream, buffer, offset, length, position) {
                var contents = stream.node.contents;
                if (position >= contents.length)
                    return 0;
                var size = Math.min(contents.length - position, length);
                assert(size >= 0);
                if (size > 8 && contents.subarray) { // non-trivial, and typed array
                    buffer.set(contents.subarray(position, position + size), offset);
                } else {
                    for (var i = 0; i < size; i++) {
                        buffer[offset + i] = contents[position + i];
                    }
                }
                return size;
            },
            write: function(stream, buffer, offset, length, position, canOwn) {
                var node = stream.node;
                node.timestamp = Date.now();
                var contents = node.contents;
                if (length && contents.length === 0 && position === 0 && buffer.subarray) {
                    // just replace it with the new data
                    if (canOwn && offset === 0) {
                        node.contents = buffer; // this could be a subarray of Emscripten HEAP, or allocated from some other source.
                        node.contentMode = (buffer.buffer === HEAP8.buffer) ? MEMFS.CONTENT_OWNING : MEMFS.CONTENT_FIXED;
                    } else {
                        node.contents = new Uint8Array(buffer.subarray(offset, offset + length));
                        node.contentMode = MEMFS.CONTENT_FIXED;
                    }
                    return length;
                }
                MEMFS.ensureFlexible(node);
                var contents = node.contents;
                while (contents.length < position) contents.push(0);
                for (var i = 0; i < length; i++) {
                    contents[position + i] = buffer[offset + i];
                }
                return length;
            },
            llseek: function(stream, offset, whence) {
                var position = offset;
                if (whence === 1) { // SEEK_CUR.
                    position += stream.position;
                } else if (whence === 2) { // SEEK_END.
                    if (FS.isFile(stream.node.mode)) {
                        position += stream.node.contents.length;
                    }
                }
                if (position < 0) {
                    throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
                }
                stream.ungotten = [];
                stream.position = position;
                return position;
            },
            allocate: function(stream, offset, length) {
                MEMFS.ensureFlexible(stream.node);
                var contents = stream.node.contents;
                var limit = offset + length;
                while (limit > contents.length) contents.push(0);
            },
            mmap: function(stream, buffer, offset, length, position, prot, flags) {
                if (!FS.isFile(stream.node.mode)) {
                    throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
                }
                var ptr;
                var allocated;
                var contents = stream.node.contents;
                // Only make a new copy when MAP_PRIVATE is specified.
                if (!(flags & 2) &&
                    (contents.buffer === buffer || contents.buffer === buffer.buffer)) {
                    // We can't emulate MAP_SHARED when the file is not backed by the buffer
                    // we're mapping to (e.g. the HEAP buffer).
                    allocated = false;
                    ptr = contents.byteOffset;
                } else {
                    // Try to avoid unnecessary slices.
                    if (position > 0 || position + length < contents.length) {
                        if (contents.subarray) {
                            contents = contents.subarray(position, position + length);
                        } else {
                            contents = Array.prototype.slice.call(contents, position, position + length);
                        }
                    }
                    allocated = true;
                    ptr = _malloc(length);
                    if (!ptr) {
                        throw new FS.ErrnoError(ERRNO_CODES.ENOMEM);
                    }
                    buffer.set(contents, ptr);
                }
                return { ptr: ptr, allocated: allocated };
            }
        }
    };

    var IDBFS = {
        dbs: {},
        indexedDB: function() {
            return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        },
        DB_VERSION: 21,
        DB_STORE_NAME: "FILE_DATA",
        mount: function(mount) {
            // reuse all of the core MEMFS functionality
            return MEMFS.mount.apply(null, arguments);
        },
        syncfs: function(mount, populate, callback) {
            IDBFS.getLocalSet(mount, function(err, local) {
                if (err) return callback(err);

                IDBFS.getRemoteSet(mount, function(err, remote) {
                    if (err) return callback(err);

                    var src = populate ? remote : local;
                    var dst = populate ? local : remote;

                    IDBFS.reconcile(src, dst, callback);
                });
            });
        },
        getDB: function(name, callback) {
            // check the cache first
            var db = IDBFS.dbs[name];
            if (db) {
                return callback(null, db);
            }

            var req;
            try {
                req = IDBFS.indexedDB().open(name, IDBFS.DB_VERSION);
            } catch (e) {
                return callback(e);
            }
            req.onupgradeneeded = function(e) {
                var db = e.target.result;
                var transaction = e.target.transaction;

                var fileStore;

                if (db.objectStoreNames.contains(IDBFS.DB_STORE_NAME)) {
                    fileStore = transaction.objectStore(IDBFS.DB_STORE_NAME);
                } else {
                    fileStore = db.createObjectStore(IDBFS.DB_STORE_NAME);
                }

                fileStore.createIndex('timestamp', 'timestamp', { unique: false });
            };
            req.onsuccess = function() {
                db = req.result;

                // add to the cache
                IDBFS.dbs[name] = db;
                callback(null, db);
            };
            req.onerror = function() {
                callback(this.error);
            };
        },
        getLocalSet: function(mount, callback) {
            var entries = {};

            function isRealDir(p) {
                return p !== '.' && p !== '..';
            };

            function toAbsolute(root) {
                return function(p) {
                    return PATH.join2(root, p);
                }
            };

            var check = FS.readdir(mount.mountpoint).filter(isRealDir).map(toAbsolute(mount.mountpoint));

            while (check.length) {
                var path = check.pop();
                var stat;

                try {
                    stat = FS.stat(path);
                } catch (e) {
                    return callback(e);
                }

                if (FS.isDir(stat.mode)) {
                    check.push.apply(check, FS.readdir(path).filter(isRealDir).map(toAbsolute(path)));
                }

                entries[path] = { timestamp: stat.mtime };
            }

            return callback(null, { type: 'local', entries: entries });
        },
        getRemoteSet: function(mount, callback) {
            var entries = {};

            IDBFS.getDB(mount.mountpoint, function(err, db) {
                if (err) return callback(err);

                var transaction = db.transaction([IDBFS.DB_STORE_NAME], 'readonly');
                transaction.onerror = function() { callback(this.error); };

                var store = transaction.objectStore(IDBFS.DB_STORE_NAME);
                var index = store.index('timestamp');

                index.openKeyCursor().onsuccess = function(event) {
                    var cursor = event.target.result;

                    if (!cursor) {
                        return callback(null, { type: 'remote', db: db, entries: entries });
                    }

                    entries[cursor.primaryKey] = { timestamp: cursor.key };

                    cursor.continue();
                };
            });
        },
        loadLocalEntry: function(path, callback) {
            var stat, node;

            try {
                var lookup = FS.lookupPath(path);
                node = lookup.node;
                stat = FS.stat(path);
            } catch (e) {
                return callback(e);
            }

            if (FS.isDir(stat.mode)) {
                return callback(null, { timestamp: stat.mtime, mode: stat.mode });
            } else if (FS.isFile(stat.mode)) {
                return callback(null, { timestamp: stat.mtime, mode: stat.mode, contents: node.contents });
            } else {
                return callback(new Error('node type not supported'));
            }
        },
        storeLocalEntry: function(path, entry, callback) {
            try {
                if (FS.isDir(entry.mode)) {
                    FS.mkdir(path, entry.mode);
                } else if (FS.isFile(entry.mode)) {
                    FS.writeFile(path, entry.contents, { encoding: 'binary', canOwn: true });
                } else {
                    return callback(new Error('node type not supported'));
                }

                FS.utime(path, entry.timestamp, entry.timestamp);
            } catch (e) {
                return callback(e);
            }

            callback(null);
        },
        removeLocalEntry: function(path, callback) {
            try {
                var lookup = FS.lookupPath(path);
                var stat = FS.stat(path);

                if (FS.isDir(stat.mode)) {
                    FS.rmdir(path);
                } else if (FS.isFile(stat.mode)) {
                    FS.unlink(path);
                }
            } catch (e) {
                return callback(e);
            }

            callback(null);
        },
        loadRemoteEntry: function(store, path, callback) {
            var req = store.get(path);
            req.onsuccess = function(event) { callback(null, event.target.result); };
            req.onerror = function() { callback(this.error); };
        },
        storeRemoteEntry: function(store, path, entry, callback) {
            var req = store.put(entry, path);
            req.onsuccess = function() { callback(null); };
            req.onerror = function() { callback(this.error); };
        },
        removeRemoteEntry: function(store, path, callback) {
            var req = store.delete(path);
            req.onsuccess = function() { callback(null); };
            req.onerror = function() { callback(this.error); };
        },
        reconcile: function(src, dst, callback) {
            var total = 0;

            var create = [];
            Object.keys(src.entries).forEach(function(key) {
                var e = src.entries[key];
                var e2 = dst.entries[key];
                if (!e2 || e.timestamp > e2.timestamp) {
                    create.push(key);
                    total++;
                }
            });

            var remove = [];
            Object.keys(dst.entries).forEach(function(key) {
                var e = dst.entries[key];
                var e2 = src.entries[key];
                if (!e2) {
                    remove.push(key);
                    total++;
                }
            });

            if (!total) {
                return callback(null);
            }

            var errored = false;
            var completed = 0;
            var db = src.type === 'remote' ? src.db : dst.db;
            var transaction = db.transaction([IDBFS.DB_STORE_NAME], 'readwrite');
            var store = transaction.objectStore(IDBFS.DB_STORE_NAME);

            function done(err) {
                if (err) {
                    if (!done.errored) {
                        done.errored = true;
                        return callback(err);
                    }
                    return;
                }
                if (++completed >= total) {
                    return callback(null);
                }
            };

            transaction.onerror = function() { done(this.error); };

            // sort paths in ascending order so directory entries are created
            // before the files inside them
            create.sort().forEach(function(path) {
                if (dst.type === 'local') {
                    IDBFS.loadRemoteEntry(store, path, function(err, entry) {
                        if (err) return done(err);
                        IDBFS.storeLocalEntry(path, entry, done);
                    });
                } else {
                    IDBFS.loadLocalEntry(path, function(err, entry) {
                        if (err) return done(err);
                        IDBFS.storeRemoteEntry(store, path, entry, done);
                    });
                }
            });

            // sort paths in descending order so files are deleted before their
            // parent directories
            remove.sort().reverse().forEach(function(path) {
                if (dst.type === 'local') {
                    IDBFS.removeLocalEntry(path, done);
                } else {
                    IDBFS.removeRemoteEntry(store, path, done);
                }
            });
        }
    };

    var NODEFS = {
        isWindows: false,
        staticInit: function() {
            NODEFS.isWindows = !!process.platform.match(/^win/);
        },
        mount: function(mount) {
            assert(ENVIRONMENT_IS_NODE);
            return NODEFS.createNode(null, '/', NODEFS.getMode(mount.opts.root), 0);
        },
        createNode: function(parent, name, mode, dev) {
            if (!FS.isDir(mode) && !FS.isFile(mode) && !FS.isLink(mode)) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            var node = FS.createNode(parent, name, mode);
            node.node_ops = NODEFS.node_ops;
            node.stream_ops = NODEFS.stream_ops;
            return node;
        },
        getMode: function(path) {
            var stat;
            try {
                stat = fs.lstatSync(path);
                if (NODEFS.isWindows) {
                    // On Windows, directories return permission bits 'rw-rw-rw-', even though they have 'rwxrwxrwx', so
                    // propagate write bits to execute bits.
                    stat.mode = stat.mode | ((stat.mode & 146) >> 1);
                }
            } catch (e) {
                if (!e.code) throw e;
                throw new FS.ErrnoError(ERRNO_CODES[e.code]);
            }
            return stat.mode;
        },
        realPath: function(node) {
            var parts = [];
            while (node.parent !== node) {
                parts.push(node.name);
                node = node.parent;
            }
            parts.push(node.mount.opts.root);
            parts.reverse();
            return PATH.join.apply(null, parts);
        },
        flagsToPermissionStringMap: { 0: "r", 1: "r+", 2: "r+", 64: "r", 65: "r+", 66: "r+", 129: "rx+", 193: "rx+", 514: "w+", 577: "w", 578: "w+", 705: "wx", 706: "wx+", 1024: "a", 1025: "a", 1026: "a+", 1089: "a", 1090: "a+", 1153: "ax", 1154: "ax+", 1217: "ax", 1218: "ax+", 4096: "rs", 4098: "rs+" },
        flagsToPermissionString: function(flags) {
            if (flags in NODEFS.flagsToPermissionStringMap) {
                return NODEFS.flagsToPermissionStringMap[flags];
            } else {
                return flags;
            }
        },
        node_ops: {
            getattr: function(node) {
                var path = NODEFS.realPath(node);
                var stat;
                try {
                    stat = fs.lstatSync(path);
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
                // node.js v0.10.20 doesn't report blksize and blocks on Windows. Fake them with default blksize of 4096.
                // See http://support.microsoft.com/kb/140365
                if (NODEFS.isWindows && !stat.blksize) {
                    stat.blksize = 4096;
                }
                if (NODEFS.isWindows && !stat.blocks) {
                    stat.blocks = (stat.size + stat.blksize - 1) / stat.blksize | 0;
                }
                return {
                    dev: stat.dev,
                    ino: stat.ino,
                    mode: stat.mode,
                    nlink: stat.nlink,
                    uid: stat.uid,
                    gid: stat.gid,
                    rdev: stat.rdev,
                    size: stat.size,
                    atime: stat.atime,
                    mtime: stat.mtime,
                    ctime: stat.ctime,
                    blksize: stat.blksize,
                    blocks: stat.blocks
                };
            },
            setattr: function(node, attr) {
                var path = NODEFS.realPath(node);
                try {
                    if (attr.mode !== undefined) {
                        fs.chmodSync(path, attr.mode);
                        // update the common node structure mode as well
                        node.mode = attr.mode;
                    }
                    if (attr.timestamp !== undefined) {
                        var date = new Date(attr.timestamp);
                        fs.utimesSync(path, date, date);
                    }
                    if (attr.size !== undefined) {
                        fs.truncateSync(path, attr.size);
                    }
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            },
            lookup: function(parent, name) {
                var path = PATH.join2(NODEFS.realPath(parent), name);
                var mode = NODEFS.getMode(path);
                return NODEFS.createNode(parent, name, mode);
            },
            mknod: function(parent, name, mode, dev) {
                var node = NODEFS.createNode(parent, name, mode, dev);
                // create the backing node for this in the fs root as well
                var path = NODEFS.realPath(node);
                try {
                    if (FS.isDir(node.mode)) {
                        fs.mkdirSync(path, node.mode);
                    } else {
                        fs.writeFileSync(path, '', { mode: node.mode });
                    }
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
                return node;
            },
            rename: function(oldNode, newDir, newName) {
                var oldPath = NODEFS.realPath(oldNode);
                var newPath = PATH.join2(NODEFS.realPath(newDir), newName);
                try {
                    fs.renameSync(oldPath, newPath);
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            },
            unlink: function(parent, name) {
                var path = PATH.join2(NODEFS.realPath(parent), name);
                try {
                    fs.unlinkSync(path);
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            },
            rmdir: function(parent, name) {
                var path = PATH.join2(NODEFS.realPath(parent), name);
                try {
                    fs.rmdirSync(path);
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            },
            readdir: function(node) {
                var path = NODEFS.realPath(node);
                try {
                    return fs.readdirSync(path);
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            },
            symlink: function(parent, newName, oldPath) {
                var newPath = PATH.join2(NODEFS.realPath(parent), newName);
                try {
                    fs.symlinkSync(oldPath, newPath);
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            },
            readlink: function(node) {
                var path = NODEFS.realPath(node);
                try {
                    return fs.readlinkSync(path);
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            }
        },
        stream_ops: {
            open: function(stream) {
                var path = NODEFS.realPath(stream.node);
                try {
                    if (FS.isFile(stream.node.mode)) {
                        stream.nfd = fs.openSync(path, NODEFS.flagsToPermissionString(stream.flags));
                    }
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            },
            close: function(stream) {
                try {
                    if (FS.isFile(stream.node.mode) && stream.nfd) {
                        fs.closeSync(stream.nfd);
                    }
                } catch (e) {
                    if (!e.code) throw e;
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
            },
            read: function(stream, buffer, offset, length, position) {
                // FIXME this is terrible.
                var nbuffer = new Buffer(length);
                var res;
                try {
                    res = fs.readSync(stream.nfd, nbuffer, 0, length, position);
                } catch (e) {
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
                if (res > 0) {
                    for (var i = 0; i < res; i++) {
                        buffer[offset + i] = nbuffer[i];
                    }
                }
                return res;
            },
            write: function(stream, buffer, offset, length, position) {
                // FIXME this is terrible.
                var nbuffer = new Buffer(buffer.subarray(offset, offset + length));
                var res;
                try {
                    res = fs.writeSync(stream.nfd, nbuffer, 0, length, position);
                } catch (e) {
                    throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                }
                return res;
            },
            llseek: function(stream, offset, whence) {
                var position = offset;
                if (whence === 1) { // SEEK_CUR.
                    position += stream.position;
                } else if (whence === 2) { // SEEK_END.
                    if (FS.isFile(stream.node.mode)) {
                        try {
                            var stat = fs.fstatSync(stream.nfd);
                            position += stat.size;
                        } catch (e) {
                            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
                        }
                    }
                }

                if (position < 0) {
                    throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
                }

                stream.position = position;
                return position;
            }
        }
    };

    var _stdin = allocate(1, "i32*", ALLOC_STATIC);

    var _stdout = allocate(1, "i32*", ALLOC_STATIC);

    var _stderr = allocate(1, "i32*", ALLOC_STATIC);

    function _fflush(stream) {
        // int fflush(FILE *stream);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/fflush.html
        // we don't currently perform any user-space buffering of data
    }
    var FS = {
        root: null,
        mounts: [],
        devices: [null],
        streams: [],
        nextInode: 1,
        nameTable: null,
        currentPath: "/",
        initialized: false,
        ignorePermissions: true,
        ErrnoError: null,
        genericErrors: {},
        handleFSError: function(e) {
            if (!(e instanceof FS.ErrnoError)) throw e + ' : ' + stackTrace();
            return ___setErrNo(e.errno);
        },
        lookupPath: function(path, opts) {
            path = PATH.resolve(FS.cwd(), path);
            opts = opts || {};

            var defaults = {
                follow_mount: true,
                recurse_count: 0
            };
            for (var key in defaults) {
                if (opts[key] === undefined) {
                    opts[key] = defaults[key];
                }
            }

            if (opts.recurse_count > 8) { // max recursive lookup of 8
                throw new FS.ErrnoError(ERRNO_CODES.ELOOP);
            }

            // split the path
            var parts = PATH.normalizeArray(path.split('/').filter(function(p) {
                return !!p;
            }), false);

            // start at the root
            var current = FS.root;
            var current_path = '/';

            for (var i = 0; i < parts.length; i++) {
                var islast = (i === parts.length - 1);
                if (islast && opts.parent) {
                    // stop resolving
                    break;
                }

                current = FS.lookupNode(current, parts[i]);
                current_path = PATH.join2(current_path, parts[i]);

                // jump to the mount's root node if this is a mountpoint
                if (FS.isMountpoint(current)) {
                    if (!islast || (islast && opts.follow_mount)) {
                        current = current.mounted.root;
                    }
                }

                // by default, lookupPath will not follow a symlink if it is the final path component.
                // setting opts.follow = true will override this behavior.
                if (!islast || opts.follow) {
                    var count = 0;
                    while (FS.isLink(current.mode)) {
                        var link = FS.readlink(current_path);
                        current_path = PATH.resolve(PATH.dirname(current_path), link);

                        var lookup = FS.lookupPath(current_path, { recurse_count: opts.recurse_count });
                        current = lookup.node;

                        if (count++ > 40) { // limit max consecutive symlinks to 40 (SYMLOOP_MAX).
                            throw new FS.ErrnoError(ERRNO_CODES.ELOOP);
                        }
                    }
                }
            }

            return { path: current_path, node: current };
        },
        getPath: function(node) {
            var path;
            while (true) {
                if (FS.isRoot(node)) {
                    var mount = node.mount.mountpoint;
                    if (!path) return mount;
                    return mount[mount.length - 1] !== '/' ? mount + '/' + path : mount + path;
                }
                path = path ? node.name + '/' + path : node.name;
                node = node.parent;
            }
        },
        hashName: function(parentid, name) {
            var hash = 0;


            for (var i = 0; i < name.length; i++) {
                hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
            }
            return ((parentid + hash) >>> 0) % FS.nameTable.length;
        },
        hashAddNode: function(node) {
            var hash = FS.hashName(node.parent.id, node.name);
            node.name_next = FS.nameTable[hash];
            FS.nameTable[hash] = node;
        },
        hashRemoveNode: function(node) {
            var hash = FS.hashName(node.parent.id, node.name);
            if (FS.nameTable[hash] === node) {
                FS.nameTable[hash] = node.name_next;
            } else {
                var current = FS.nameTable[hash];
                while (current) {
                    if (current.name_next === node) {
                        current.name_next = node.name_next;
                        break;
                    }
                    current = current.name_next;
                }
            }
        },
        lookupNode: function(parent, name) {
            var err = FS.mayLookup(parent);
            if (err) {
                throw new FS.ErrnoError(err);
            }
            var hash = FS.hashName(parent.id, name);
            for (var node = FS.nameTable[hash]; node; node = node.name_next) {
                var nodeName = node.name;
                if (node.parent.id === parent.id && nodeName === name) {
                    return node;
                }
            }
            // if we failed to find it in the cache, call into the VFS
            return FS.lookup(parent, name);
        },
        createNode: function(parent, name, mode, rdev) {
            if (!FS.FSNode) {
                FS.FSNode = function(parent, name, mode, rdev) {
                    if (!parent) {
                        parent = this; // root node sets parent to itself
                    }
                    this.parent = parent;
                    this.mount = parent.mount;
                    this.mounted = null;
                    this.id = FS.nextInode++;
                    this.name = name;
                    this.mode = mode;
                    this.node_ops = {};
                    this.stream_ops = {};
                    this.rdev = rdev;
                };

                FS.FSNode.prototype = {};

                // compatibility
                var readMode = 292 | 73;
                var writeMode = 146;

                // NOTE we must use Object.defineProperties instead of individual calls to
                // Object.defineProperty in order to make closure compiler happy
                Object.defineProperties(FS.FSNode.prototype, {
                    read: {
                        get: function() { return (this.mode & readMode) === readMode; },
                        set: function(val) { val ? this.mode |= readMode : this.mode &= ~readMode; }
                    },
                    write: {
                        get: function() { return (this.mode & writeMode) === writeMode; },
                        set: function(val) { val ? this.mode |= writeMode : this.mode &= ~writeMode; }
                    },
                    isFolder: {
                        get: function() { return FS.isDir(this.mode); },
                    },
                    isDevice: {
                        get: function() { return FS.isChrdev(this.mode); },
                    },
                });
            }

            var node = new FS.FSNode(parent, name, mode, rdev);

            FS.hashAddNode(node);

            return node;
        },
        destroyNode: function(node) {
            FS.hashRemoveNode(node);
        },
        isRoot: function(node) {
            return node === node.parent;
        },
        isMountpoint: function(node) {
            return !!node.mounted;
        },
        isFile: function(mode) {
            return (mode & 61440) === 32768;
        },
        isDir: function(mode) {
            return (mode & 61440) === 16384;
        },
        isLink: function(mode) {
            return (mode & 61440) === 40960;
        },
        isChrdev: function(mode) {
            return (mode & 61440) === 8192;
        },
        isBlkdev: function(mode) {
            return (mode & 61440) === 24576;
        },
        isFIFO: function(mode) {
            return (mode & 61440) === 4096;
        },
        isSocket: function(mode) {
            return (mode & 49152) === 49152;
        },
        flagModes: { "r": 0, "rs": 1052672, "r+": 2, "w": 577, "wx": 705, "xw": 705, "w+": 578, "wx+": 706, "xw+": 706, "a": 1089, "ax": 1217, "xa": 1217, "a+": 1090, "ax+": 1218, "xa+": 1218 },
        modeStringToFlags: function(str) {
            var flags = FS.flagModes[str];
            if (typeof flags === 'undefined') {
                throw new Error('Unknown file open mode: ' + str);
            }
            return flags;
        },
        flagsToPermissionString: function(flag) {
            var accmode = flag & 2097155;
            var perms = ['r', 'w', 'rw'][accmode];
            if ((flag & 512)) {
                perms += 'w';
            }
            return perms;
        },
        nodePermissions: function(node, perms) {
            if (FS.ignorePermissions) {
                return 0;
            }
            // return 0 if any user, group or owner bits are set.
            if (perms.indexOf('r') !== -1 && !(node.mode & 292)) {
                return ERRNO_CODES.EACCES;
            } else if (perms.indexOf('w') !== -1 && !(node.mode & 146)) {
                return ERRNO_CODES.EACCES;
            } else if (perms.indexOf('x') !== -1 && !(node.mode & 73)) {
                return ERRNO_CODES.EACCES;
            }
            return 0;
        },
        mayLookup: function(dir) {
            return FS.nodePermissions(dir, 'x');
        },
        mayCreate: function(dir, name) {
            try {
                var node = FS.lookupNode(dir, name);
                return ERRNO_CODES.EEXIST;
            } catch (e) {}
            return FS.nodePermissions(dir, 'wx');
        },
        mayDelete: function(dir, name, isdir) {
            var node;
            try {
                node = FS.lookupNode(dir, name);
            } catch (e) {
                return e.errno;
            }
            var err = FS.nodePermissions(dir, 'wx');
            if (err) {
                return err;
            }
            if (isdir) {
                if (!FS.isDir(node.mode)) {
                    return ERRNO_CODES.ENOTDIR;
                }
                if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
                    return ERRNO_CODES.EBUSY;
                }
            } else {
                if (FS.isDir(node.mode)) {
                    return ERRNO_CODES.EISDIR;
                }
            }
            return 0;
        },
        mayOpen: function(node, flags) {
            if (!node) {
                return ERRNO_CODES.ENOENT;
            }
            if (FS.isLink(node.mode)) {
                return ERRNO_CODES.ELOOP;
            } else if (FS.isDir(node.mode)) {
                if ((flags & 2097155) !== 0 || // opening for write
                    (flags & 512)) {
                    return ERRNO_CODES.EISDIR;
                }
            }
            return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
        },
        MAX_OPEN_FDS: 4096,
        nextfd: function(fd_start, fd_end) {
            fd_start = fd_start || 0;
            fd_end = fd_end || FS.MAX_OPEN_FDS;
            for (var fd = fd_start; fd <= fd_end; fd++) {
                if (!FS.streams[fd]) {
                    return fd;
                }
            }
            throw new FS.ErrnoError(ERRNO_CODES.EMFILE);
        },
        getStream: function(fd) {
            return FS.streams[fd];
        },
        createStream: function(stream, fd_start, fd_end) {
            if (!FS.FSStream) {
                FS.FSStream = function() {};
                FS.FSStream.prototype = {};
                // compatibility
                Object.defineProperties(FS.FSStream.prototype, {
                    object: {
                        get: function() { return this.node; },
                        set: function(val) { this.node = val; }
                    },
                    isRead: {
                        get: function() { return (this.flags & 2097155) !== 1; }
                    },
                    isWrite: {
                        get: function() { return (this.flags & 2097155) !== 0; }
                    },
                    isAppend: {
                        get: function() { return (this.flags & 1024); }
                    }
                });
            }
            if (stream.__proto__) {
                // reuse the object
                stream.__proto__ = FS.FSStream.prototype;
            } else {
                var newStream = new FS.FSStream();
                for (var p in stream) {
                    newStream[p] = stream[p];
                }
                stream = newStream;
            }
            var fd = FS.nextfd(fd_start, fd_end);
            stream.fd = fd;
            FS.streams[fd] = stream;
            return stream;
        },
        closeStream: function(fd) {
            FS.streams[fd] = null;
        },
        getStreamFromPtr: function(ptr) {
            return FS.streams[ptr - 1];
        },
        getPtrForStream: function(stream) {
            return stream ? stream.fd + 1 : 0;
        },
        chrdev_stream_ops: {
            open: function(stream) {
                var device = FS.getDevice(stream.node.rdev);
                // override node's stream ops with the device's
                stream.stream_ops = device.stream_ops;
                // forward the open call
                if (stream.stream_ops.open) {
                    stream.stream_ops.open(stream);
                }
            },
            llseek: function() {
                throw new FS.ErrnoError(ERRNO_CODES.ESPIPE);
            }
        },
        major: function(dev) {
            return ((dev) >> 8);
        },
        minor: function(dev) {
            return ((dev) & 0xff);
        },
        makedev: function(ma, mi) {
            return ((ma) << 8 | (mi));
        },
        registerDevice: function(dev, ops) {
            FS.devices[dev] = { stream_ops: ops };
        },
        getDevice: function(dev) {
            return FS.devices[dev];
        },
        getMounts: function(mount) {
            var mounts = [];
            var check = [mount];

            while (check.length) {
                var m = check.pop();

                mounts.push(m);

                check.push.apply(check, m.mounts);
            }

            return mounts;
        },
        syncfs: function(populate, callback) {
            if (typeof(populate) === 'function') {
                callback = populate;
                populate = false;
            }

            var mounts = FS.getMounts(FS.root.mount);
            var completed = 0;

            function done(err) {
                if (err) {
                    if (!done.errored) {
                        done.errored = true;
                        return callback(err);
                    }
                    return;
                }
                if (++completed >= mounts.length) {
                    callback(null);
                }
            };

            // sync all mounts
            mounts.forEach(function(mount) {
                if (!mount.type.syncfs) {
                    return done(null);
                }
                mount.type.syncfs(mount, populate, done);
            });
        },
        mount: function(type, opts, mountpoint) {
            var root = mountpoint === '/';
            var pseudo = !mountpoint;
            var node;

            if (root && FS.root) {
                throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
            } else if (!root && !pseudo) {
                var lookup = FS.lookupPath(mountpoint, { follow_mount: false });

                mountpoint = lookup.path; // use the absolute path
                node = lookup.node;

                if (FS.isMountpoint(node)) {
                    throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
                }

                if (!FS.isDir(node.mode)) {
                    throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR);
                }
            }

            var mount = {
                type: type,
                opts: opts,
                mountpoint: mountpoint,
                mounts: []
            };

            // create a root node for the fs
            var mountRoot = type.mount(mount);
            mountRoot.mount = mount;
            mount.root = mountRoot;

            if (root) {
                FS.root = mountRoot;
            } else if (node) {
                // set as a mountpoint
                node.mounted = mount;

                // add the new mount to the current mount's children
                if (node.mount) {
                    node.mount.mounts.push(mount);
                }
            }

            return mountRoot;
        },
        unmount: function(mountpoint) {
            var lookup = FS.lookupPath(mountpoint, { follow_mount: false });

            if (!FS.isMountpoint(lookup.node)) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }

            // destroy the nodes for this mount, and all its child mounts
            var node = lookup.node;
            var mount = node.mounted;
            var mounts = FS.getMounts(mount);

            Object.keys(FS.nameTable).forEach(function(hash) {
                var current = FS.nameTable[hash];

                while (current) {
                    var next = current.name_next;

                    if (mounts.indexOf(current.mount) !== -1) {
                        FS.destroyNode(current);
                    }

                    current = next;
                }
            });

            // no longer a mountpoint
            node.mounted = null;

            // remove this mount from the child mounts
            var idx = node.mount.mounts.indexOf(mount);
            assert(idx !== -1);
            node.mount.mounts.splice(idx, 1);
        },
        lookup: function(parent, name) {
            return parent.node_ops.lookup(parent, name);
        },
        mknod: function(path, mode, dev) {
            var lookup = FS.lookupPath(path, { parent: true });
            var parent = lookup.node;
            var name = PATH.basename(path);
            var err = FS.mayCreate(parent, name);
            if (err) {
                throw new FS.ErrnoError(err);
            }
            if (!parent.node_ops.mknod) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            return parent.node_ops.mknod(parent, name, mode, dev);
        },
        create: function(path, mode) {
            mode = mode !== undefined ? mode : 438 /* 0666 */ ;
            mode &= 4095;
            mode |= 32768;
            return FS.mknod(path, mode, 0);
        },
        mkdir: function(path, mode) {
            mode = mode !== undefined ? mode : 511 /* 0777 */ ;
            mode &= 511 | 512;
            mode |= 16384;
            return FS.mknod(path, mode, 0);
        },
        mkdev: function(path, mode, dev) {
            if (typeof(dev) === 'undefined') {
                dev = mode;
                mode = 438 /* 0666 */ ;
            }
            mode |= 8192;
            return FS.mknod(path, mode, dev);
        },
        symlink: function(oldpath, newpath) {
            var lookup = FS.lookupPath(newpath, { parent: true });
            var parent = lookup.node;
            var newname = PATH.basename(newpath);
            var err = FS.mayCreate(parent, newname);
            if (err) {
                throw new FS.ErrnoError(err);
            }
            if (!parent.node_ops.symlink) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            return parent.node_ops.symlink(parent, newname, oldpath);
        },
        rename: function(old_path, new_path) {
            var old_dirname = PATH.dirname(old_path);
            var new_dirname = PATH.dirname(new_path);
            var old_name = PATH.basename(old_path);
            var new_name = PATH.basename(new_path);
            // parents must exist
            var lookup, old_dir, new_dir;
            try {
                lookup = FS.lookupPath(old_path, { parent: true });
                old_dir = lookup.node;
                lookup = FS.lookupPath(new_path, { parent: true });
                new_dir = lookup.node;
            } catch (e) {
                throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
            }
            // need to be part of the same mount
            if (old_dir.mount !== new_dir.mount) {
                throw new FS.ErrnoError(ERRNO_CODES.EXDEV);
            }
            // source must exist
            var old_node = FS.lookupNode(old_dir, old_name);
            // old path should not be an ancestor of the new path
            var relative = PATH.relative(old_path, new_dirname);
            if (relative.charAt(0) !== '.') {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            // new path should not be an ancestor of the old path
            relative = PATH.relative(new_path, old_dirname);
            if (relative.charAt(0) !== '.') {
                throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY);
            }
            // see if the new path already exists
            var new_node;
            try {
                new_node = FS.lookupNode(new_dir, new_name);
            } catch (e) {
                // not fatal
            }
            // early out if nothing needs to change
            if (old_node === new_node) {
                return;
            }
            // we'll need to delete the old entry
            var isdir = FS.isDir(old_node.mode);
            var err = FS.mayDelete(old_dir, old_name, isdir);
            if (err) {
                throw new FS.ErrnoError(err);
            }
            // need delete permissions if we'll be overwriting.
            // need create permissions if new doesn't already exist.
            err = new_node ?
                FS.mayDelete(new_dir, new_name, isdir) :
                FS.mayCreate(new_dir, new_name);
            if (err) {
                throw new FS.ErrnoError(err);
            }
            if (!old_dir.node_ops.rename) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            if (FS.isMountpoint(old_node) || (new_node && FS.isMountpoint(new_node))) {
                throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
            }
            // if we are going to change the parent, check write permissions
            if (new_dir !== old_dir) {
                err = FS.nodePermissions(old_dir, 'w');
                if (err) {
                    throw new FS.ErrnoError(err);
                }
            }
            // remove the node from the lookup hash
            FS.hashRemoveNode(old_node);
            // do the underlying fs rename
            try {
                old_dir.node_ops.rename(old_node, new_dir, new_name);
            } catch (e) {
                throw e;
            } finally {
                // add the node back to the hash (in case node_ops.rename
                // changed its name)
                FS.hashAddNode(old_node);
            }
        },
        rmdir: function(path) {
            var lookup = FS.lookupPath(path, { parent: true });
            var parent = lookup.node;
            var name = PATH.basename(path);
            var node = FS.lookupNode(parent, name);
            var err = FS.mayDelete(parent, name, true);
            if (err) {
                throw new FS.ErrnoError(err);
            }
            if (!parent.node_ops.rmdir) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            if (FS.isMountpoint(node)) {
                throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
            }
            parent.node_ops.rmdir(parent, name);
            FS.destroyNode(node);
        },
        readdir: function(path) {
            var lookup = FS.lookupPath(path, { follow: true });
            var node = lookup.node;
            if (!node.node_ops.readdir) {
                throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR);
            }
            return node.node_ops.readdir(node);
        },
        unlink: function(path) {
            var lookup = FS.lookupPath(path, { parent: true });
            var parent = lookup.node;
            var name = PATH.basename(path);
            var node = FS.lookupNode(parent, name);
            var err = FS.mayDelete(parent, name, false);
            if (err) {
                // POSIX says unlink should set EPERM, not EISDIR
                if (err === ERRNO_CODES.EISDIR) err = ERRNO_CODES.EPERM;
                throw new FS.ErrnoError(err);
            }
            if (!parent.node_ops.unlink) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            if (FS.isMountpoint(node)) {
                throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
            }
            parent.node_ops.unlink(parent, name);
            FS.destroyNode(node);
        },
        readlink: function(path) {
            var lookup = FS.lookupPath(path);
            var link = lookup.node;
            if (!link.node_ops.readlink) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            return link.node_ops.readlink(link);
        },
        stat: function(path, dontFollow) {
            var lookup = FS.lookupPath(path, { follow: !dontFollow });
            var node = lookup.node;
            if (!node.node_ops.getattr) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            return node.node_ops.getattr(node);
        },
        lstat: function(path) {
            return FS.stat(path, true);
        },
        chmod: function(path, mode, dontFollow) {
            var node;
            if (typeof path === 'string') {
                var lookup = FS.lookupPath(path, { follow: !dontFollow });
                node = lookup.node;
            } else {
                node = path;
            }
            if (!node.node_ops.setattr) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            node.node_ops.setattr(node, {
                mode: (mode & 4095) | (node.mode & ~4095),
                timestamp: Date.now()
            });
        },
        lchmod: function(path, mode) {
            FS.chmod(path, mode, true);
        },
        fchmod: function(fd, mode) {
            var stream = FS.getStream(fd);
            if (!stream) {
                throw new FS.ErrnoError(ERRNO_CODES.EBADF);
            }
            FS.chmod(stream.node, mode);
        },
        chown: function(path, uid, gid, dontFollow) {
            var node;
            if (typeof path === 'string') {
                var lookup = FS.lookupPath(path, { follow: !dontFollow });
                node = lookup.node;
            } else {
                node = path;
            }
            if (!node.node_ops.setattr) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            node.node_ops.setattr(node, {
                timestamp: Date.now()
                    // we ignore the uid / gid for now
            });
        },
        lchown: function(path, uid, gid) {
            FS.chown(path, uid, gid, true);
        },
        fchown: function(fd, uid, gid) {
            var stream = FS.getStream(fd);
            if (!stream) {
                throw new FS.ErrnoError(ERRNO_CODES.EBADF);
            }
            FS.chown(stream.node, uid, gid);
        },
        truncate: function(path, len) {
            if (len < 0) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            var node;
            if (typeof path === 'string') {
                var lookup = FS.lookupPath(path, { follow: true });
                node = lookup.node;
            } else {
                node = path;
            }
            if (!node.node_ops.setattr) {
                throw new FS.ErrnoError(ERRNO_CODES.EPERM);
            }
            if (FS.isDir(node.mode)) {
                throw new FS.ErrnoError(ERRNO_CODES.EISDIR);
            }
            if (!FS.isFile(node.mode)) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            var err = FS.nodePermissions(node, 'w');
            if (err) {
                throw new FS.ErrnoError(err);
            }
            node.node_ops.setattr(node, {
                size: len,
                timestamp: Date.now()
            });
        },
        ftruncate: function(fd, len) {
            var stream = FS.getStream(fd);
            if (!stream) {
                throw new FS.ErrnoError(ERRNO_CODES.EBADF);
            }
            if ((stream.flags & 2097155) === 0) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            FS.truncate(stream.node, len);
        },
        utime: function(path, atime, mtime) {
            var lookup = FS.lookupPath(path, { follow: true });
            var node = lookup.node;
            node.node_ops.setattr(node, {
                timestamp: Math.max(atime, mtime)
            });
        },
        open: function(path, flags, mode, fd_start, fd_end) {
            flags = typeof flags === 'string' ? FS.modeStringToFlags(flags) : flags;
            mode = typeof mode === 'undefined' ? 438 /* 0666 */ : mode;
            if ((flags & 64)) {
                mode = (mode & 4095) | 32768;
            } else {
                mode = 0;
            }
            var node;
            if (typeof path === 'object') {
                node = path;
            } else {
                path = PATH.normalize(path);
                try {
                    var lookup = FS.lookupPath(path, {
                        follow: !(flags & 131072)
                    });
                    node = lookup.node;
                } catch (e) {
                    // ignore
                }
            }
            // perhaps we need to create the node
            if ((flags & 64)) {
                if (node) {
                    // if O_CREAT and O_EXCL are set, error out if the node already exists
                    if ((flags & 128)) {
                        throw new FS.ErrnoError(ERRNO_CODES.EEXIST);
                    }
                } else {
                    // node doesn't exist, try to create it
                    node = FS.mknod(path, mode, 0);
                }
            }
            if (!node) {
                throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
            }
            // can't truncate a device
            if (FS.isChrdev(node.mode)) {
                flags &= ~512;
            }
            // check permissions
            var err = FS.mayOpen(node, flags);
            if (err) {
                throw new FS.ErrnoError(err);
            }
            // do truncation if necessary
            if ((flags & 512)) {
                FS.truncate(node, 0);
            }
            // we've already handled these, don't pass down to the underlying vfs
            flags &= ~(128 | 512);

            // register the stream with the filesystem
            var stream = FS.createStream({
                node: node,
                path: FS.getPath(node), // we want the absolute path to the node
                flags: flags,
                seekable: true,
                position: 0,
                stream_ops: node.stream_ops,
                // used by the file family libc calls (fopen, fwrite, ferror, etc.)
                ungotten: [],
                error: false
            }, fd_start, fd_end);
            // call the new stream's open function
            if (stream.stream_ops.open) {
                stream.stream_ops.open(stream);
            }
            if (Module['logReadFiles'] && !(flags & 1)) {
                if (!FS.readFiles) FS.readFiles = {};
                if (!(path in FS.readFiles)) {
                    FS.readFiles[path] = 1;
                    Module['printErr']('read file: ' + path);
                }
            }
            return stream;
        },
        close: function(stream) {
            try {
                if (stream.stream_ops.close) {
                    stream.stream_ops.close(stream);
                }
            } catch (e) {
                throw e;
            } finally {
                FS.closeStream(stream.fd);
            }
        },
        llseek: function(stream, offset, whence) {
            if (!stream.seekable || !stream.stream_ops.llseek) {
                throw new FS.ErrnoError(ERRNO_CODES.ESPIPE);
            }
            return stream.stream_ops.llseek(stream, offset, whence);
        },
        read: function(stream, buffer, offset, length, position) {
            if (length < 0 || position < 0) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            if ((stream.flags & 2097155) === 1) {
                throw new FS.ErrnoError(ERRNO_CODES.EBADF);
            }
            if (FS.isDir(stream.node.mode)) {
                throw new FS.ErrnoError(ERRNO_CODES.EISDIR);
            }
            if (!stream.stream_ops.read) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            var seeking = true;
            if (typeof position === 'undefined') {
                position = stream.position;
                seeking = false;
            } else if (!stream.seekable) {
                throw new FS.ErrnoError(ERRNO_CODES.ESPIPE);
            }
            var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
            if (!seeking) stream.position += bytesRead;
            return bytesRead;
        },
        write: function(stream, buffer, offset, length, position, canOwn) {
            if (length < 0 || position < 0) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            if ((stream.flags & 2097155) === 0) {
                throw new FS.ErrnoError(ERRNO_CODES.EBADF);
            }
            if (FS.isDir(stream.node.mode)) {
                throw new FS.ErrnoError(ERRNO_CODES.EISDIR);
            }
            if (!stream.stream_ops.write) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            var seeking = true;
            if (typeof position === 'undefined') {
                position = stream.position;
                seeking = false;
            } else if (!stream.seekable) {
                throw new FS.ErrnoError(ERRNO_CODES.ESPIPE);
            }
            if (stream.flags & 1024) {
                // seek to the end before writing in append mode
                FS.llseek(stream, 0, 2);
            }
            var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
            if (!seeking) stream.position += bytesWritten;
            return bytesWritten;
        },
        allocate: function(stream, offset, length) {
            if (offset < 0 || length <= 0) {
                throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
            }
            if ((stream.flags & 2097155) === 0) {
                throw new FS.ErrnoError(ERRNO_CODES.EBADF);
            }
            if (!FS.isFile(stream.node.mode) && !FS.isDir(node.mode)) {
                throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
            }
            if (!stream.stream_ops.allocate) {
                throw new FS.ErrnoError(ERRNO_CODES.EOPNOTSUPP);
            }
            stream.stream_ops.allocate(stream, offset, length);
        },
        mmap: function(stream, buffer, offset, length, position, prot, flags) {
            // TODO if PROT is PROT_WRITE, make sure we have write access
            if ((stream.flags & 2097155) === 1) {
                throw new FS.ErrnoError(ERRNO_CODES.EACCES);
            }
            if (!stream.stream_ops.mmap) {
                throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
            }
            return stream.stream_ops.mmap(stream, buffer, offset, length, position, prot, flags);
        },
        ioctl: function(stream, cmd, arg) {
            if (!stream.stream_ops.ioctl) {
                throw new FS.ErrnoError(ERRNO_CODES.ENOTTY);
            }
            return stream.stream_ops.ioctl(stream, cmd, arg);
        },
        readFile: function(path, opts) {
            opts = opts || {};
            opts.flags = opts.flags || 'r';
            opts.encoding = opts.encoding || 'binary';
            if (opts.encoding !== 'utf8' && opts.encoding !== 'binary') {
                throw new Error('Invalid encoding type "' + opts.encoding + '"');
            }
            var ret;
            var stream = FS.open(path, opts.flags);
            var stat = FS.stat(path);
            var length = stat.size;
            var buf = new Uint8Array(length);
            FS.read(stream, buf, 0, length, 0);
            if (opts.encoding === 'utf8') {
                ret = '';
                var utf8 = new Runtime.UTF8Processor();
                for (var i = 0; i < length; i++) {
                    ret += utf8.processCChar(buf[i]);
                }
            } else if (opts.encoding === 'binary') {
                ret = buf;
            }
            FS.close(stream);
            return ret;
        },
        writeFile: function(path, data, opts) {
            opts = opts || {};
            opts.flags = opts.flags || 'w';
            opts.encoding = opts.encoding || 'utf8';
            if (opts.encoding !== 'utf8' && opts.encoding !== 'binary') {
                throw new Error('Invalid encoding type "' + opts.encoding + '"');
            }
            var stream = FS.open(path, opts.flags, opts.mode);
            if (opts.encoding === 'utf8') {
                var utf8 = new Runtime.UTF8Processor();
                var buf = new Uint8Array(utf8.processJSString(data));
                FS.write(stream, buf, 0, buf.length, 0, opts.canOwn);
            } else if (opts.encoding === 'binary') {
                FS.write(stream, data, 0, data.length, 0, opts.canOwn);
            }
            FS.close(stream);
        },
        cwd: function() {
            return FS.currentPath;
        },
        chdir: function(path) {
            var lookup = FS.lookupPath(path, { follow: true });
            if (!FS.isDir(lookup.node.mode)) {
                throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR);
            }
            var err = FS.nodePermissions(lookup.node, 'x');
            if (err) {
                throw new FS.ErrnoError(err);
            }
            FS.currentPath = lookup.path;
        },
        createDefaultDirectories: function() {
            FS.mkdir('/tmp');
        },
        createDefaultDevices: function() {
            // create /dev
            FS.mkdir('/dev');
            // setup /dev/null
            FS.registerDevice(FS.makedev(1, 3), {
                read: function() { return 0; },
                write: function() { return 0; }
            });
            FS.mkdev('/dev/null', FS.makedev(1, 3));
            // setup /dev/tty and /dev/tty1
            // stderr needs to print output using Module['printErr']
            // so we register a second tty just for it.
            TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
            TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
            FS.mkdev('/dev/tty', FS.makedev(5, 0));
            FS.mkdev('/dev/tty1', FS.makedev(6, 0));
            // we're not going to emulate the actual shm device,
            // just create the tmp dirs that reside in it commonly
            FS.mkdir('/dev/shm');
            FS.mkdir('/dev/shm/tmp');
        },
        createStandardStreams: function() {
            // TODO deprecate the old functionality of a single
            // input / output callback and that utilizes FS.createDevice
            // and instead require a unique set of stream ops

            // by default, we symlink the standard streams to the
            // default tty devices. however, if the standard streams
            // have been overwritten we create a unique device for
            // them instead.
            if (Module['stdin']) {
                FS.createDevice('/dev', 'stdin', Module['stdin']);
            } else {
                FS.symlink('/dev/tty', '/dev/stdin');
            }
            if (Module['stdout']) {
                FS.createDevice('/dev', 'stdout', null, Module['stdout']);
            } else {
                FS.symlink('/dev/tty', '/dev/stdout');
            }
            if (Module['stderr']) {
                FS.createDevice('/dev', 'stderr', null, Module['stderr']);
            } else {
                FS.symlink('/dev/tty1', '/dev/stderr');
            }

            // open default streams for the stdin, stdout and stderr devices
            var stdin = FS.open('/dev/stdin', 'r');
            HEAP32[((_stdin) >> 2)] = FS.getPtrForStream(stdin);
            assert(stdin.fd === 0, 'invalid handle for stdin (' + stdin.fd + ')');

            var stdout = FS.open('/dev/stdout', 'w');
            HEAP32[((_stdout) >> 2)] = FS.getPtrForStream(stdout);
            assert(stdout.fd === 1, 'invalid handle for stdout (' + stdout.fd + ')');

            var stderr = FS.open('/dev/stderr', 'w');
            HEAP32[((_stderr) >> 2)] = FS.getPtrForStream(stderr);
            assert(stderr.fd === 2, 'invalid handle for stderr (' + stderr.fd + ')');
        },
        ensureErrnoError: function() {
            if (FS.ErrnoError) return;
            FS.ErrnoError = function ErrnoError(errno) {
                this.errno = errno;
                for (var key in ERRNO_CODES) {
                    if (ERRNO_CODES[key] === errno) {
                        this.code = key;
                        break;
                    }
                }
                this.message = ERRNO_MESSAGES[errno];
            };
            FS.ErrnoError.prototype = new Error();
            FS.ErrnoError.prototype.constructor = FS.ErrnoError;
            // Some errors may happen quite a bit, to avoid overhead we reuse them (and suffer a lack of stack info)
            [ERRNO_CODES.ENOENT].forEach(function(code) {
                FS.genericErrors[code] = new FS.ErrnoError(code);
                FS.genericErrors[code].stack = '<generic error, no stack>';
            });
        },
        staticInit: function() {
            FS.ensureErrnoError();

            FS.nameTable = new Array(4096);

            FS.mount(MEMFS, {}, '/');

            FS.createDefaultDirectories();
            FS.createDefaultDevices();
        },
        init: function(input, output, error) {
            assert(!FS.init.initialized, 'FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)');
            FS.init.initialized = true;

            FS.ensureErrnoError();

            // Allow Module.stdin etc. to provide defaults, if none explicitly passed to us here
            Module['stdin'] = input || Module['stdin'];
            Module['stdout'] = output || Module['stdout'];
            Module['stderr'] = error || Module['stderr'];

            FS.createStandardStreams();
        },
        quit: function() {
            FS.init.initialized = false;
            for (var i = 0; i < FS.streams.length; i++) {
                var stream = FS.streams[i];
                if (!stream) {
                    continue;
                }
                FS.close(stream);
            }
        },
        getMode: function(canRead, canWrite) {
            var mode = 0;
            if (canRead) mode |= 292 | 73;
            if (canWrite) mode |= 146;
            return mode;
        },
        joinPath: function(parts, forceRelative) {
            var path = PATH.join.apply(null, parts);
            if (forceRelative && path[0] == '/') path = path.substr(1);
            return path;
        },
        absolutePath: function(relative, base) {
            return PATH.resolve(base, relative);
        },
        standardizePath: function(path) {
            return PATH.normalize(path);
        },
        findObject: function(path, dontResolveLastLink) {
            var ret = FS.analyzePath(path, dontResolveLastLink);
            if (ret.exists) {
                return ret.object;
            } else {
                ___setErrNo(ret.error);
                return null;
            }
        },
        analyzePath: function(path, dontResolveLastLink) {
            // operate from within the context of the symlink's target
            try {
                var lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
                path = lookup.path;
            } catch (e) {}
            var ret = {
                isRoot: false,
                exists: false,
                error: 0,
                name: null,
                path: null,
                object: null,
                parentExists: false,
                parentPath: null,
                parentObject: null
            };
            try {
                var lookup = FS.lookupPath(path, { parent: true });
                ret.parentExists = true;
                ret.parentPath = lookup.path;
                ret.parentObject = lookup.node;
                ret.name = PATH.basename(path);
                lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
                ret.exists = true;
                ret.path = lookup.path;
                ret.object = lookup.node;
                ret.name = lookup.node.name;
                ret.isRoot = lookup.path === '/';
            } catch (e) {
                ret.error = e.errno;
            };
            return ret;
        },
        createFolder: function(parent, name, canRead, canWrite) {
            var path = PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name);
            var mode = FS.getMode(canRead, canWrite);
            return FS.mkdir(path, mode);
        },
        createPath: function(parent, path, canRead, canWrite) {
            parent = typeof parent === 'string' ? parent : FS.getPath(parent);
            var parts = path.split('/').reverse();
            while (parts.length) {
                var part = parts.pop();
                if (!part) continue;
                var current = PATH.join2(parent, part);
                try {
                    FS.mkdir(current);
                } catch (e) {
                    // ignore EEXIST
                }
                parent = current;
            }
            return current;
        },
        createFile: function(parent, name, properties, canRead, canWrite) {
            var path = PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name);
            var mode = FS.getMode(canRead, canWrite);
            return FS.create(path, mode);
        },
        createDataFile: function(parent, name, data, canRead, canWrite, canOwn) {
            var path = name ? PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name) : parent;
            var mode = FS.getMode(canRead, canWrite);
            var node = FS.create(path, mode);
            if (data) {
                if (typeof data === 'string') {
                    var arr = new Array(data.length);
                    for (var i = 0, len = data.length; i < len; ++i) arr[i] = data.charCodeAt(i);
                    data = arr;
                }
                // make sure we can write to the file
                FS.chmod(node, mode | 146);
                var stream = FS.open(node, 'w');
                FS.write(stream, data, 0, data.length, 0, canOwn);
                FS.close(stream);
                FS.chmod(node, mode);
            }
            return node;
        },
        createDevice: function(parent, name, input, output) {
            var path = PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name);
            var mode = FS.getMode(!!input, !!output);
            if (!FS.createDevice.major) FS.createDevice.major = 64;
            var dev = FS.makedev(FS.createDevice.major++, 0);
            // Create a fake device that a set of stream ops to emulate
            // the old behavior.
            FS.registerDevice(dev, {
                open: function(stream) {
                    stream.seekable = false;
                },
                close: function(stream) {
                    // flush any pending line data
                    if (output && output.buffer && output.buffer.length) {
                        output(10);
                    }
                },
                read: function(stream, buffer, offset, length, pos /* ignored */ ) {
                    var bytesRead = 0;
                    for (var i = 0; i < length; i++) {
                        var result;
                        try {
                            result = input();
                        } catch (e) {
                            throw new FS.ErrnoError(ERRNO_CODES.EIO);
                        }
                        if (result === undefined && bytesRead === 0) {
                            throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
                        }
                        if (result === null || result === undefined) break;
                        bytesRead++;
                        buffer[offset + i] = result;
                    }
                    if (bytesRead) {
                        stream.node.timestamp = Date.now();
                    }
                    return bytesRead;
                },
                write: function(stream, buffer, offset, length, pos) {
                    for (var i = 0; i < length; i++) {
                        try {
                            output(buffer[offset + i]);
                        } catch (e) {
                            throw new FS.ErrnoError(ERRNO_CODES.EIO);
                        }
                    }
                    if (length) {
                        stream.node.timestamp = Date.now();
                    }
                    return i;
                }
            });
            return FS.mkdev(path, mode, dev);
        },
        createLink: function(parent, name, target, canRead, canWrite) {
            var path = PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name);
            return FS.symlink(target, path);
        },
        forceLoadFile: function(obj) {
            if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
            var success = true;
            if (typeof XMLHttpRequest !== 'undefined') {
                throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
            } else if (Module['read']) {
                // Command-line.
                try {
                    // WARNING: Can't read binary files in V8's d8 or tracemonkey's js, as
                    //          read() will try to parse UTF8.
                    obj.contents = intArrayFromString(Module['read'](obj.url), true);
                } catch (e) {
                    success = false;
                }
            } else {
                throw new Error('Cannot load without read() or XMLHttpRequest.');
            }
            if (!success) ___setErrNo(ERRNO_CODES.EIO);
            return success;
        },
        createLazyFile: function(parent, name, url, canRead, canWrite) {
            if (typeof XMLHttpRequest !== 'undefined') {
                if (!ENVIRONMENT_IS_WORKER) throw 'Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc';
                // Lazy chunked Uint8Array (implements get and length from Uint8Array). Actual getting is abstracted away for eventual reuse.
                function LazyUint8Array() {
                    this.lengthKnown = false;
                    this.chunks = []; // Loaded chunks. Index is the chunk number
                }
                LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
                    if (idx > this.length - 1 || idx < 0) {
                        return undefined;
                    }
                    var chunkOffset = idx % this.chunkSize;
                    var chunkNum = Math.floor(idx / this.chunkSize);
                    return this.getter(chunkNum)[chunkOffset];
                }
                LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
                    this.getter = getter;
                }
                LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
                    // Find length
                    var xhr = new XMLHttpRequest();
                    xhr.open('HEAD', url, false);
                    xhr.send(null);
                    if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                    var datalength = Number(xhr.getResponseHeader("Content-length"));
                    var header;
                    var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                    var chunkSize = 1024 * 1024; // Chunk size in bytes

                    if (!hasByteServing) chunkSize = datalength;

                    // Function to get a range from the remote URL.
                    var doXHR = (function(from, to) {
                        if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                        if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");

                        // TODO: Use mozResponseArrayBuffer, responseStream, etc. if available.
                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', url, false);
                        if (datalength !== chunkSize) xhr.setRequestHeader("Range", "bytes=" + from + "-" + to);

                        // Some hints to the browser that we want binary data.
                        if (typeof Uint8Array != 'undefined') xhr.responseType = 'arraybuffer';
                        if (xhr.overrideMimeType) {
                            xhr.overrideMimeType('text/plain; charset=x-user-defined');
                        }

                        xhr.send(null);
                        if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                        if (xhr.response !== undefined) {
                            return new Uint8Array(xhr.response || []);
                        } else {
                            return intArrayFromString(xhr.responseText || '', true);
                        }
                    });
                    var lazyArray = this;
                    lazyArray.setDataGetter(function(chunkNum) {
                        var start = chunkNum * chunkSize;
                        var end = (chunkNum + 1) * chunkSize - 1; // including this byte
                        end = Math.min(end, datalength - 1); // if datalength-1 is selected, this is the last block
                        if (typeof(lazyArray.chunks[chunkNum]) === "undefined") {
                            lazyArray.chunks[chunkNum] = doXHR(start, end);
                        }
                        if (typeof(lazyArray.chunks[chunkNum]) === "undefined") throw new Error("doXHR failed!");
                        return lazyArray.chunks[chunkNum];
                    });

                    this._length = datalength;
                    this._chunkSize = chunkSize;
                    this.lengthKnown = true;
                }

                var lazyArray = new LazyUint8Array();
                Object.defineProperty(lazyArray, "length", {
                    get: function() {
                        if (!this.lengthKnown) {
                            this.cacheLength();
                        }
                        return this._length;
                    }
                });
                Object.defineProperty(lazyArray, "chunkSize", {
                    get: function() {
                        if (!this.lengthKnown) {
                            this.cacheLength();
                        }
                        return this._chunkSize;
                    }
                });

                var properties = { isDevice: false, contents: lazyArray };
            } else {
                var properties = { isDevice: false, url: url };
            }

            var node = FS.createFile(parent, name, properties, canRead, canWrite);
            // This is a total hack, but I want to get this lazy file code out of the
            // core of MEMFS. If we want to keep this lazy file concept I feel it should
            // be its own thin LAZYFS proxying calls to MEMFS.
            if (properties.contents) {
                node.contents = properties.contents;
            } else if (properties.url) {
                node.contents = null;
                node.url = properties.url;
            }
            // override each stream op with one that tries to force load the lazy file first
            var stream_ops = {};
            var keys = Object.keys(node.stream_ops);
            keys.forEach(function(key) {
                var fn = node.stream_ops[key];
                stream_ops[key] = function forceLoadLazyFile() {
                    if (!FS.forceLoadFile(node)) {
                        throw new FS.ErrnoError(ERRNO_CODES.EIO);
                    }
                    return fn.apply(null, arguments);
                };
            });
            // use a custom read function
            stream_ops.read = function stream_ops_read(stream, buffer, offset, length, position) {
                if (!FS.forceLoadFile(node)) {
                    throw new FS.ErrnoError(ERRNO_CODES.EIO);
                }
                var contents = stream.node.contents;
                if (position >= contents.length)
                    return 0;
                var size = Math.min(contents.length - position, length);
                assert(size >= 0);
                if (contents.slice) { // normal array
                    for (var i = 0; i < size; i++) {
                        buffer[offset + i] = contents[position + i];
                    }
                } else {
                    for (var i = 0; i < size; i++) { // LazyUint8Array from sync binary XHR
                        buffer[offset + i] = contents.get(position + i);
                    }
                }
                return size;
            };
            node.stream_ops = stream_ops;
            return node;
        },
        createPreloadedFile: function(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn) {
            Browser.init();
            // TODO we should allow people to just pass in a complete filename instead
            // of parent and name being that we just join them anyways
            var fullname = name ? PATH.resolve(PATH.join2(parent, name)) : parent;

            function processData(byteArray) {
                function finish(byteArray) {
                    if (!dontCreateFile) {
                        FS.createDataFile(parent, name, byteArray, canRead, canWrite, canOwn);
                    }
                    if (onload) onload();
                    removeRunDependency('cp ' + fullname);
                }
                var handled = false;
                Module['preloadPlugins'].forEach(function(plugin) {
                    if (handled) return;
                    if (plugin['canHandle'](fullname)) {
                        plugin['handle'](byteArray, fullname, finish, function() {
                            if (onerror) onerror();
                            removeRunDependency('cp ' + fullname);
                        });
                        handled = true;
                    }
                });
                if (!handled) finish(byteArray);
            }
            addRunDependency('cp ' + fullname);
            if (typeof url == 'string') {
                Browser.asyncLoad(url, function(byteArray) {
                    processData(byteArray);
                }, onerror);
            } else {
                processData(url);
            }
        },
        indexedDB: function() {
            return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        },
        DB_NAME: function() {
            return 'EM_FS_' + window.location.pathname;
        },
        DB_VERSION: 20,
        DB_STORE_NAME: "FILE_DATA",
        saveFilesToDB: function(paths, onload, onerror) {
            onload = onload || function() {};
            onerror = onerror || function() {};
            var indexedDB = FS.indexedDB();
            try {
                var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
            } catch (e) {
                return onerror(e);
            }
            openRequest.onupgradeneeded = function openRequest_onupgradeneeded() {
                console.log('creating db');
                var db = openRequest.result;
                db.createObjectStore(FS.DB_STORE_NAME);
            };
            openRequest.onsuccess = function openRequest_onsuccess() {
                var db = openRequest.result;
                var transaction = db.transaction([FS.DB_STORE_NAME], 'readwrite');
                var files = transaction.objectStore(FS.DB_STORE_NAME);
                var ok = 0,
                    fail = 0,
                    total = paths.length;

                function finish() {
                    if (fail == 0) onload();
                    else onerror();
                }
                paths.forEach(function(path) {
                    var putRequest = files.put(FS.analyzePath(path).object.contents, path);
                    putRequest.onsuccess = function putRequest_onsuccess() { ok++; if (ok + fail == total) finish() };
                    putRequest.onerror = function putRequest_onerror() { fail++; if (ok + fail == total) finish() };
                });
                transaction.onerror = onerror;
            };
            openRequest.onerror = onerror;
        },
        loadFilesFromDB: function(paths, onload, onerror) {
            onload = onload || function() {};
            onerror = onerror || function() {};
            var indexedDB = FS.indexedDB();
            try {
                var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
            } catch (e) {
                return onerror(e);
            }
            openRequest.onupgradeneeded = onerror; // no database to load from
            openRequest.onsuccess = function openRequest_onsuccess() {
                var db = openRequest.result;
                try {
                    var transaction = db.transaction([FS.DB_STORE_NAME], 'readonly');
                } catch (e) {
                    onerror(e);
                    return;
                }
                var files = transaction.objectStore(FS.DB_STORE_NAME);
                var ok = 0,
                    fail = 0,
                    total = paths.length;

                function finish() {
                    if (fail == 0) onload();
                    else onerror();
                }
                paths.forEach(function(path) {
                    var getRequest = files.get(path);
                    getRequest.onsuccess = function getRequest_onsuccess() {
                        if (FS.analyzePath(path).exists) {
                            FS.unlink(path);
                        }
                        FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                        ok++;
                        if (ok + fail == total) finish();
                    };
                    getRequest.onerror = function getRequest_onerror() { fail++; if (ok + fail == total) finish() };
                });
                transaction.onerror = onerror;
            };
            openRequest.onerror = onerror;
        }
    };




    function _mkport() { throw 'TODO' }
    var SOCKFS = {
        mount: function(mount) {
            return FS.createNode(null, '/', 16384 | 511 /* 0777 */ , 0);
        },
        createSocket: function(family, type, protocol) {
            var streaming = type == 1;
            if (protocol) {
                assert(streaming == (protocol == 6)); // if SOCK_STREAM, must be tcp
            }

            // create our internal socket structure
            var sock = {
                family: family,
                type: type,
                protocol: protocol,
                server: null,
                peers: {},
                pending: [],
                recv_queue: [],
                sock_ops: SOCKFS.websocket_sock_ops
            };

            // create the filesystem node to store the socket structure
            var name = SOCKFS.nextname();
            var node = FS.createNode(SOCKFS.root, name, 49152, 0);
            node.sock = sock;

            // and the wrapping stream that enables library functions such
            // as read and write to indirectly interact with the socket
            var stream = FS.createStream({
                path: name,
                node: node,
                flags: FS.modeStringToFlags('r+'),
                seekable: false,
                stream_ops: SOCKFS.stream_ops
            });

            // map the new stream to the socket structure (sockets have a 1:1
            // relationship with a stream)
            sock.stream = stream;

            return sock;
        },
        getSocket: function(fd) {
            var stream = FS.getStream(fd);
            if (!stream || !FS.isSocket(stream.node.mode)) {
                return null;
            }
            return stream.node.sock;
        },
        stream_ops: {
            poll: function(stream) {
                var sock = stream.node.sock;
                return sock.sock_ops.poll(sock);
            },
            ioctl: function(stream, request, varargs) {
                var sock = stream.node.sock;
                return sock.sock_ops.ioctl(sock, request, varargs);
            },
            read: function(stream, buffer, offset, length, position /* ignored */ ) {
                var sock = stream.node.sock;
                var msg = sock.sock_ops.recvmsg(sock, length);
                if (!msg) {
                    // socket is closed
                    return 0;
                }
                buffer.set(msg.buffer, offset);
                return msg.buffer.length;
            },
            write: function(stream, buffer, offset, length, position /* ignored */ ) {
                var sock = stream.node.sock;
                return sock.sock_ops.sendmsg(sock, buffer, offset, length);
            },
            close: function(stream) {
                var sock = stream.node.sock;
                sock.sock_ops.close(sock);
            }
        },
        nextname: function() {
            if (!SOCKFS.nextname.current) {
                SOCKFS.nextname.current = 0;
            }
            return 'socket[' + (SOCKFS.nextname.current++) + ']';
        },
        websocket_sock_ops: {
            createPeer: function(sock, addr, port) {
                var ws;

                if (typeof addr === 'object') {
                    ws = addr;
                    addr = null;
                    port = null;
                }

                if (ws) {
                    // for sockets that've already connected (e.g. we're the server)
                    // we can inspect the _socket property for the address
                    if (ws._socket) {
                        addr = ws._socket.remoteAddress;
                        port = ws._socket.remotePort;
                    }
                    // if we're just now initializing a connection to the remote,
                    // inspect the url property
                    else {
                        var result = /ws[s]?:\/\/([^:]+):(\d+)/.exec(ws.url);
                        if (!result) {
                            throw new Error('WebSocket URL must be in the format ws(s)://address:port');
                        }
                        addr = result[1];
                        port = parseInt(result[2], 10);
                    }
                } else {
                    // create the actual websocket object and connect
                    try {
                        var url = 'ws://' + addr + ':' + port;
                        // the node ws library API is slightly different than the browser's
                        var opts = ENVIRONMENT_IS_NODE ? { headers: { 'websocket-protocol': ['binary'] } } : ['binary'];
                        // If node we use the ws library.
                        var WebSocket = ENVIRONMENT_IS_NODE ? require('ws') : window['WebSocket'];
                        ws = new WebSocket(url, opts);
                        ws.binaryType = 'arraybuffer';
                    } catch (e) {
                        throw new FS.ErrnoError(ERRNO_CODES.EHOSTUNREACH);
                    }
                }


                var peer = {
                    addr: addr,
                    port: port,
                    socket: ws,
                    dgram_send_queue: []
                };

                SOCKFS.websocket_sock_ops.addPeer(sock, peer);
                SOCKFS.websocket_sock_ops.handlePeerEvents(sock, peer);

                // if this is a bound dgram socket, send the port number first to allow
                // us to override the ephemeral port reported to us by remotePort on the
                // remote end.
                if (sock.type === 2 && typeof sock.sport !== 'undefined') {
                    peer.dgram_send_queue.push(new Uint8Array([
                        255, 255, 255, 255,
                        'p'.charCodeAt(0), 'o'.charCodeAt(0), 'r'.charCodeAt(0), 't'.charCodeAt(0),
                        ((sock.sport & 0xff00) >> 8), (sock.sport & 0xff)
                    ]));
                }

                return peer;
            },
            getPeer: function(sock, addr, port) {
                return sock.peers[addr + ':' + port];
            },
            addPeer: function(sock, peer) {
                sock.peers[peer.addr + ':' + peer.port] = peer;
            },
            removePeer: function(sock, peer) {
                delete sock.peers[peer.addr + ':' + peer.port];
            },
            handlePeerEvents: function(sock, peer) {
                var first = true;

                var handleOpen = function() {
                    try {
                        var queued = peer.dgram_send_queue.shift();
                        while (queued) {
                            peer.socket.send(queued);
                            queued = peer.dgram_send_queue.shift();
                        }
                    } catch (e) {
                        // not much we can do here in the way of proper error handling as we've already
                        // lied and said this data was sent. shut it down.
                        peer.socket.close();
                    }
                };

                function handleMessage(data) {
                    assert(typeof data !== 'string' && data.byteLength !== undefined); // must receive an ArrayBuffer
                    data = new Uint8Array(data); // make a typed array view on the array buffer


                    // if this is the port message, override the peer's port with it
                    var wasfirst = first;
                    first = false;
                    if (wasfirst &&
                        data.length === 10 &&
                        data[0] === 255 && data[1] === 255 && data[2] === 255 && data[3] === 255 &&
                        data[4] === 'p'.charCodeAt(0) && data[5] === 'o'.charCodeAt(0) && data[6] === 'r'.charCodeAt(0) && data[7] === 't'.charCodeAt(0)) {
                        // update the peer's port and it's key in the peer map
                        var newport = ((data[8] << 8) | data[9]);
                        SOCKFS.websocket_sock_ops.removePeer(sock, peer);
                        peer.port = newport;
                        SOCKFS.websocket_sock_ops.addPeer(sock, peer);
                        return;
                    }

                    sock.recv_queue.push({ addr: peer.addr, port: peer.port, data: data });
                };

                if (ENVIRONMENT_IS_NODE) {
                    peer.socket.on('open', handleOpen);
                    peer.socket.on('message', function(data, flags) {
                        if (!flags.binary) {
                            return;
                        }
                        handleMessage((new Uint8Array(data)).buffer); // copy from node Buffer -> ArrayBuffer
                    });
                    peer.socket.on('error', function() {
                        // don't throw
                    });
                } else {
                    peer.socket.onopen = handleOpen;
                    peer.socket.onmessage = function peer_socket_onmessage(event) {
                        handleMessage(event.data);
                    };
                }
            },
            poll: function(sock) {
                if (sock.type === 1 && sock.server) {
                    // listen sockets should only say they're available for reading
                    // if there are pending clients.
                    return sock.pending.length ? (64 | 1) : 0;
                }

                var mask = 0;
                var dest = sock.type === 1 ? // we only care about the socket state for connection-based sockets
                    SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport) :
                    null;

                if (sock.recv_queue.length ||
                    !dest || // connection-less sockets are always ready to read
                    (dest && dest.socket.readyState === dest.socket.CLOSING) ||
                    (dest && dest.socket.readyState === dest.socket.CLOSED)) { // let recv return 0 once closed
                    mask |= (64 | 1);
                }

                if (!dest || // connection-less sockets are always ready to write
                    (dest && dest.socket.readyState === dest.socket.OPEN)) {
                    mask |= 4;
                }

                if ((dest && dest.socket.readyState === dest.socket.CLOSING) ||
                    (dest && dest.socket.readyState === dest.socket.CLOSED)) {
                    mask |= 16;
                }

                return mask;
            },
            ioctl: function(sock, request, arg) {
                switch (request) {
                    case 21531:
                        var bytes = 0;
                        if (sock.recv_queue.length) {
                            bytes = sock.recv_queue[0].data.length;
                        }
                        HEAP32[((arg) >> 2)] = bytes;
                        return 0;
                    default:
                        return ERRNO_CODES.EINVAL;
                }
            },
            close: function(sock) {
                // if we've spawned a listen server, close it
                if (sock.server) {
                    try {
                        sock.server.close();
                    } catch (e) {}
                    sock.server = null;
                }
                // close any peer connections
                var peers = Object.keys(sock.peers);
                for (var i = 0; i < peers.length; i++) {
                    var peer = sock.peers[peers[i]];
                    try {
                        peer.socket.close();
                    } catch (e) {}
                    SOCKFS.websocket_sock_ops.removePeer(sock, peer);
                }
                return 0;
            },
            bind: function(sock, addr, port) {
                if (typeof sock.saddr !== 'undefined' || typeof sock.sport !== 'undefined') {
                    throw new FS.ErrnoError(ERRNO_CODES.EINVAL); // already bound
                }
                sock.saddr = addr;
                sock.sport = port || _mkport();
                // in order to emulate dgram sockets, we need to launch a listen server when
                // binding on a connection-less socket
                // note: this is only required on the server side
                if (sock.type === 2) {
                    // close the existing server if it exists
                    if (sock.server) {
                        sock.server.close();
                        sock.server = null;
                    }
                    // swallow error operation not supported error that occurs when binding in the
                    // browser where this isn't supported
                    try {
                        sock.sock_ops.listen(sock, 0);
                    } catch (e) {
                        if (!(e instanceof FS.ErrnoError)) throw e;
                        if (e.errno !== ERRNO_CODES.EOPNOTSUPP) throw e;
                    }
                }
            },
            connect: function(sock, addr, port) {
                if (sock.server) {
                    throw new FS.ErrnoError(ERRNO_CODS.EOPNOTSUPP);
                }

                // TODO autobind
                // if (!sock.addr && sock.type == 2) {
                // }

                // early out if we're already connected / in the middle of connecting
                if (typeof sock.daddr !== 'undefined' && typeof sock.dport !== 'undefined') {
                    var dest = SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport);
                    if (dest) {
                        if (dest.socket.readyState === dest.socket.CONNECTING) {
                            throw new FS.ErrnoError(ERRNO_CODES.EALREADY);
                        } else {
                            throw new FS.ErrnoError(ERRNO_CODES.EISCONN);
                        }
                    }
                }

                // add the socket to our peer list and set our
                // destination address / port to match
                var peer = SOCKFS.websocket_sock_ops.createPeer(sock, addr, port);
                sock.daddr = peer.addr;
                sock.dport = peer.port;

                // always "fail" in non-blocking mode
                throw new FS.ErrnoError(ERRNO_CODES.EINPROGRESS);
            },
            listen: function(sock, backlog) {
                if (!ENVIRONMENT_IS_NODE) {
                    throw new FS.ErrnoError(ERRNO_CODES.EOPNOTSUPP);
                }
                if (sock.server) {
                    throw new FS.ErrnoError(ERRNO_CODES.EINVAL); // already listening
                }
                var WebSocketServer = require('ws').Server;
                var host = sock.saddr;
                sock.server = new WebSocketServer({
                    host: host,
                    port: sock.sport
                        // TODO support backlog
                });

                sock.server.on('connection', function(ws) {
                    if (sock.type === 1) {
                        var newsock = SOCKFS.createSocket(sock.family, sock.type, sock.protocol);

                        // create a peer on the new socket
                        var peer = SOCKFS.websocket_sock_ops.createPeer(newsock, ws);
                        newsock.daddr = peer.addr;
                        newsock.dport = peer.port;

                        // push to queue for accept to pick up
                        sock.pending.push(newsock);
                    } else {
                        // create a peer on the listen socket so calling sendto
                        // with the listen socket and an address will resolve
                        // to the correct client
                        SOCKFS.websocket_sock_ops.createPeer(sock, ws);
                    }
                });
                sock.server.on('closed', function() {
                    sock.server = null;
                });
                sock.server.on('error', function() {
                    // don't throw
                });
            },
            accept: function(listensock) {
                if (!listensock.server) {
                    throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
                }
                var newsock = listensock.pending.shift();
                newsock.stream.flags = listensock.stream.flags;
                return newsock;
            },
            getname: function(sock, peer) {
                var addr, port;
                if (peer) {
                    if (sock.daddr === undefined || sock.dport === undefined) {
                        throw new FS.ErrnoError(ERRNO_CODES.ENOTCONN);
                    }
                    addr = sock.daddr;
                    port = sock.dport;
                } else {
                    // TODO saddr and sport will be set for bind()'d UDP sockets, but what
                    // should we be returning for TCP sockets that've been connect()'d?
                    addr = sock.saddr || 0;
                    port = sock.sport || 0;
                }
                return { addr: addr, port: port };
            },
            sendmsg: function(sock, buffer, offset, length, addr, port) {
                if (sock.type === 2) {
                    // connection-less sockets will honor the message address,
                    // and otherwise fall back to the bound destination address
                    if (addr === undefined || port === undefined) {
                        addr = sock.daddr;
                        port = sock.dport;
                    }
                    // if there was no address to fall back to, error out
                    if (addr === undefined || port === undefined) {
                        throw new FS.ErrnoError(ERRNO_CODES.EDESTADDRREQ);
                    }
                } else {
                    // connection-based sockets will only use the bound
                    addr = sock.daddr;
                    port = sock.dport;
                }

                // find the peer for the destination address
                var dest = SOCKFS.websocket_sock_ops.getPeer(sock, addr, port);

                // early out if not connected with a connection-based socket
                if (sock.type === 1) {
                    if (!dest || dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
                        throw new FS.ErrnoError(ERRNO_CODES.ENOTCONN);
                    } else if (dest.socket.readyState === dest.socket.CONNECTING) {
                        throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
                    }
                }

                // create a copy of the incoming data to send, as the WebSocket API
                // doesn't work entirely with an ArrayBufferView, it'll just send
                // the entire underlying buffer
                var data;
                if (buffer instanceof Array || buffer instanceof ArrayBuffer) {
                    data = buffer.slice(offset, offset + length);
                } else { // ArrayBufferView
                    data = buffer.buffer.slice(buffer.byteOffset + offset, buffer.byteOffset + offset + length);
                }

                // if we're emulating a connection-less dgram socket and don't have
                // a cached connection, queue the buffer to send upon connect and
                // lie, saying the data was sent now.
                if (sock.type === 2) {
                    if (!dest || dest.socket.readyState !== dest.socket.OPEN) {
                        // if we're not connected, open a new connection
                        if (!dest || dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
                            dest = SOCKFS.websocket_sock_ops.createPeer(sock, addr, port);
                        }
                        dest.dgram_send_queue.push(data);
                        return length;
                    }
                }

                try {
                    // send the actual data
                    dest.socket.send(data);
                    return length;
                } catch (e) {
                    throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
                }
            },
            recvmsg: function(sock, length) {
                // http://pubs.opengroup.org/onlinepubs/7908799/xns/recvmsg.html
                if (sock.type === 1 && sock.server) {
                    // tcp servers should not be recv()'ing on the listen socket
                    throw new FS.ErrnoError(ERRNO_CODES.ENOTCONN);
                }

                var queued = sock.recv_queue.shift();
                if (!queued) {
                    if (sock.type === 1) {
                        var dest = SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport);

                        if (!dest) {
                            // if we have a destination address but are not connected, error out
                            throw new FS.ErrnoError(ERRNO_CODES.ENOTCONN);
                        } else if (dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
                            // return null if the socket has closed
                            return null;
                        } else {
                            // else, our socket is in a valid state but truly has nothing available
                            throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
                        }
                    } else {
                        throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
                    }
                }

                // queued.data will be an ArrayBuffer if it's unadulterated, but if it's
                // requeued TCP data it'll be an ArrayBufferView
                var queuedLength = queued.data.byteLength || queued.data.length;
                var queuedOffset = queued.data.byteOffset || 0;
                var queuedBuffer = queued.data.buffer || queued.data;
                var bytesRead = Math.min(length, queuedLength);
                var res = {
                    buffer: new Uint8Array(queuedBuffer, queuedOffset, bytesRead),
                    addr: queued.addr,
                    port: queued.port
                };


                // push back any unread data for TCP connections
                if (sock.type === 1 && bytesRead < queuedLength) {
                    var bytesRemaining = queuedLength - bytesRead;
                    queued.data = new Uint8Array(queuedBuffer, queuedOffset + bytesRead, bytesRemaining);
                    sock.recv_queue.unshift(queued);
                }

                return res;
            }
        }
    };

    function _send(fd, buf, len, flags) {
        var sock = SOCKFS.getSocket(fd);
        if (!sock) {
            ___setErrNo(ERRNO_CODES.EBADF);
            return -1;
        }
        // TODO honor flags
        return _write(fd, buf, len);
    }

    function _pwrite(fildes, buf, nbyte, offset) {
        // ssize_t pwrite(int fildes, const void *buf, size_t nbyte, off_t offset);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/write.html
        var stream = FS.getStream(fildes);
        if (!stream) {
            ___setErrNo(ERRNO_CODES.EBADF);
            return -1;
        }
        try {
            var slab = HEAP8;
            return FS.write(stream, slab, buf, nbyte, offset);
        } catch (e) {
            FS.handleFSError(e);
            return -1;
        }
    }

    function _write(fildes, buf, nbyte) {
        // ssize_t write(int fildes, const void *buf, size_t nbyte);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/write.html
        var stream = FS.getStream(fildes);
        if (!stream) {
            ___setErrNo(ERRNO_CODES.EBADF);
            return -1;
        }


        try {
            var slab = HEAP8;
            return FS.write(stream, slab, buf, nbyte);
        } catch (e) {
            FS.handleFSError(e);
            return -1;
        }
    }

    function _fileno(stream) {
        // int fileno(FILE *stream);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/fileno.html
        return FS.getStreamFromPtr(stream).fd;
    }

    function _fwrite(ptr, size, nitems, stream) {
        // size_t fwrite(const void *restrict ptr, size_t size, size_t nitems, FILE *restrict stream);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/fwrite.html
        var bytesToWrite = nitems * size;
        if (bytesToWrite == 0) return 0;
        var fd = _fileno(stream);
        var bytesWritten = _write(fd, ptr, bytesToWrite);
        if (bytesWritten == -1) {
            var streamObj = FS.getStreamFromPtr(stream);
            if (streamObj) streamObj.error = true;
            return 0;
        } else {
            return Math.floor(bytesWritten / size);
        }
    }



    Module["_memset"] = _memset;
    var _llvm_memset_p0i8_i64 = _memset;

    function ___cxa_pure_virtual() {
        ABORT = true;
        throw 'Pure virtual function called!';
    }

    function _llvm_lifetime_start() {}

    function _llvm_lifetime_end() {}




    Module["_strlen"] = _strlen;

    function __reallyNegative(x) {
        return x < 0 || (x === 0 && (1 / x) === -Infinity);
    }

    function __formatString(format, varargs) {
        var textIndex = format;
        var argIndex = 0;

        function getNextArg(type) {
            // NOTE: Explicitly ignoring type safety. Otherwise this fails:
            //       int x = 4; printf("%c\n", (char)x);
            var ret;
            if (type === 'double') {
                ret = HEAPF64[(((varargs) + (argIndex)) >> 3)];
            } else if (type == 'i64') {
                ret = [HEAP32[(((varargs) + (argIndex)) >> 2)],
                    HEAP32[(((varargs) + (argIndex + 8)) >> 2)]
                ];
                argIndex += 8; // each 32-bit chunk is in a 64-bit block

            } else {
                type = 'i32'; // varargs are always i32, i64, or double
                ret = HEAP32[(((varargs) + (argIndex)) >> 2)];
            }
            argIndex += Math.max(Runtime.getNativeFieldSize(type), Runtime.getAlignSize(type, null, true));
            return ret;
        }

        var ret = [];
        var curr, next, currArg;
        while (1) {
            var startTextIndex = textIndex;
            curr = HEAP8[(textIndex)];
            if (curr === 0) break;
            next = HEAP8[((textIndex + 1) | 0)];
            if (curr == 37) {
                // Handle flags.
                var flagAlwaysSigned = false;
                var flagLeftAlign = false;
                var flagAlternative = false;
                var flagZeroPad = false;
                var flagPadSign = false;
                flagsLoop: while (1) {
                    switch (next) {
                        case 43:
                            flagAlwaysSigned = true;
                            break;
                        case 45:
                            flagLeftAlign = true;
                            break;
                        case 35:
                            flagAlternative = true;
                            break;
                        case 48:
                            if (flagZeroPad) {
                                break flagsLoop;
                            } else {
                                flagZeroPad = true;
                                break;
                            }
                        case 32:
                            flagPadSign = true;
                            break;
                        default:
                            break flagsLoop;
                    }
                    textIndex++;
                    next = HEAP8[((textIndex + 1) | 0)];
                }

                // Handle width.
                var width = 0;
                if (next == 42) {
                    width = getNextArg('i32');
                    textIndex++;
                    next = HEAP8[((textIndex + 1) | 0)];
                } else {
                    while (next >= 48 && next <= 57) {
                        width = width * 10 + (next - 48);
                        textIndex++;
                        next = HEAP8[((textIndex + 1) | 0)];
                    }
                }

                // Handle precision.
                var precisionSet = false,
                    precision = -1;
                if (next == 46) {
                    precision = 0;
                    precisionSet = true;
                    textIndex++;
                    next = HEAP8[((textIndex + 1) | 0)];
                    if (next == 42) {
                        precision = getNextArg('i32');
                        textIndex++;
                    } else {
                        while (1) {
                            var precisionChr = HEAP8[((textIndex + 1) | 0)];
                            if (precisionChr < 48 ||
                                precisionChr > 57) break;
                            precision = precision * 10 + (precisionChr - 48);
                            textIndex++;
                        }
                    }
                    next = HEAP8[((textIndex + 1) | 0)];
                }
                if (precision < 0) {
                    precision = 6; // Standard default.
                    precisionSet = false;
                }

                // Handle integer sizes. WARNING: These assume a 32-bit architecture!
                var argSize;
                switch (String.fromCharCode(next)) {
                    case 'h':
                        var nextNext = HEAP8[((textIndex + 2) | 0)];
                        if (nextNext == 104) {
                            textIndex++;
                            argSize = 1; // char (actually i32 in varargs)
                        } else {
                            argSize = 2; // short (actually i32 in varargs)
                        }
                        break;
                    case 'l':
                        var nextNext = HEAP8[((textIndex + 2) | 0)];
                        if (nextNext == 108) {
                            textIndex++;
                            argSize = 8; // long long
                        } else {
                            argSize = 4; // long
                        }
                        break;
                    case 'L': // long long
                    case 'q': // int64_t
                    case 'j': // intmax_t
                        argSize = 8;
                        break;
                    case 'z': // size_t
                    case 't': // ptrdiff_t
                    case 'I': // signed ptrdiff_t or unsigned size_t
                        argSize = 4;
                        break;
                    default:
                        argSize = null;
                }
                if (argSize) textIndex++;
                next = HEAP8[((textIndex + 1) | 0)];

                // Handle type specifier.
                switch (String.fromCharCode(next)) {
                    case 'd':
                    case 'i':
                    case 'u':
                    case 'o':
                    case 'x':
                    case 'X':
                    case 'p':
                        {
                            // Integer.
                            var signed = next == 100 || next == 105;
                            argSize = argSize || 4;
                            var currArg = getNextArg('i' + (argSize * 8));
                            var origArg = currArg;
                            var argText;
                            // Flatten i64-1 [low, high] into a (slightly rounded) double
                            if (argSize == 8) {
                                currArg = Runtime.makeBigInt(currArg[0], currArg[1], next == 117);
                            }
                            // Truncate to requested size.
                            if (argSize <= 4) {
                                var limit = Math.pow(256, argSize) - 1;
                                currArg = (signed ? reSign : unSign)(currArg & limit, argSize * 8);
                            }
                            // Format the number.
                            var currAbsArg = Math.abs(currArg);
                            var prefix = '';
                            if (next == 100 || next == 105) {
                                if (argSize == 8 && i64Math) argText = i64Math.stringify(origArg[0], origArg[1], null);
                                else
                                    argText = reSign(currArg, 8 * argSize, 1).toString(10);
                            } else if (next == 117) {
                                if (argSize == 8 && i64Math) argText = i64Math.stringify(origArg[0], origArg[1], true);
                                else
                                    argText = unSign(currArg, 8 * argSize, 1).toString(10);
                                currArg = Math.abs(currArg);
                            } else if (next == 111) {
                                argText = (flagAlternative ? '0' : '') + currAbsArg.toString(8);
                            } else if (next == 120 || next == 88) {
                                prefix = (flagAlternative && currArg != 0) ? '0x' : '';
                                if (argSize == 8 && i64Math) {
                                    if (origArg[1]) {
                                        argText = (origArg[1] >>> 0).toString(16);
                                        var lower = (origArg[0] >>> 0).toString(16);
                                        while (lower.length < 8) lower = '0' + lower;
                                        argText += lower;
                                    } else {
                                        argText = (origArg[0] >>> 0).toString(16);
                                    }
                                } else
                                if (currArg < 0) {
                                    // Represent negative numbers in hex as 2's complement.
                                    currArg = -currArg;
                                    argText = (currAbsArg - 1).toString(16);
                                    var buffer = [];
                                    for (var i = 0; i < argText.length; i++) {
                                        buffer.push((0xF - parseInt(argText[i], 16)).toString(16));
                                    }
                                    argText = buffer.join('');
                                    while (argText.length < argSize * 2) argText = 'f' + argText;
                                } else {
                                    argText = currAbsArg.toString(16);
                                }
                                if (next == 88) {
                                    prefix = prefix.toUpperCase();
                                    argText = argText.toUpperCase();
                                }
                            } else if (next == 112) {
                                if (currAbsArg === 0) {
                                    argText = '(nil)';
                                } else {
                                    prefix = '0x';
                                    argText = currAbsArg.toString(16);
                                }
                            }
                            if (precisionSet) {
                                while (argText.length < precision) {
                                    argText = '0' + argText;
                                }
                            }

                            // Add sign if needed
                            if (currArg >= 0) {
                                if (flagAlwaysSigned) {
                                    prefix = '+' + prefix;
                                } else if (flagPadSign) {
                                    prefix = ' ' + prefix;
                                }
                            }

                            // Move sign to prefix so we zero-pad after the sign
                            if (argText.charAt(0) == '-') {
                                prefix = '-' + prefix;
                                argText = argText.substr(1);
                            }

                            // Add padding.
                            while (prefix.length + argText.length < width) {
                                if (flagLeftAlign) {
                                    argText += ' ';
                                } else {
                                    if (flagZeroPad) {
                                        argText = '0' + argText;
                                    } else {
                                        prefix = ' ' + prefix;
                                    }
                                }
                            }

                            // Insert the result into the buffer.
                            argText = prefix + argText;
                            argText.split('').forEach(function(chr) {
                                ret.push(chr.charCodeAt(0));
                            });
                            break;
                        }
                    case 'f':
                    case 'F':
                    case 'e':
                    case 'E':
                    case 'g':
                    case 'G':
                        {
                            // Float.
                            var currArg = getNextArg('double');
                            var argText;
                            if (isNaN(currArg)) {
                                argText = 'nan';
                                flagZeroPad = false;
                            } else if (!isFinite(currArg)) {
                                argText = (currArg < 0 ? '-' : '') + 'inf';
                                flagZeroPad = false;
                            } else {
                                var isGeneral = false;
                                var effectivePrecision = Math.min(precision, 20);

                                // Convert g/G to f/F or e/E, as per:
                                // http://pubs.opengroup.org/onlinepubs/9699919799/functions/printf.html
                                if (next == 103 || next == 71) {
                                    isGeneral = true;
                                    precision = precision || 1;
                                    var exponent = parseInt(currArg.toExponential(effectivePrecision).split('e')[1], 10);
                                    if (precision > exponent && exponent >= -4) {
                                        next = ((next == 103) ? 'f' : 'F').charCodeAt(0);
                                        precision -= exponent + 1;
                                    } else {
                                        next = ((next == 103) ? 'e' : 'E').charCodeAt(0);
                                        precision--;
                                    }
                                    effectivePrecision = Math.min(precision, 20);
                                }

                                if (next == 101 || next == 69) {
                                    argText = currArg.toExponential(effectivePrecision);
                                    // Make sure the exponent has at least 2 digits.
                                    if (/[eE][-+]\d$/.test(argText)) {
                                        argText = argText.slice(0, -1) + '0' + argText.slice(-1);
                                    }
                                } else if (next == 102 || next == 70) {
                                    argText = currArg.toFixed(effectivePrecision);
                                    if (currArg === 0 && __reallyNegative(currArg)) {
                                        argText = '-' + argText;
                                    }
                                }

                                var parts = argText.split('e');
                                if (isGeneral && !flagAlternative) {
                                    // Discard trailing zeros and periods.
                                    while (parts[0].length > 1 && parts[0].indexOf('.') != -1 &&
                                        (parts[0].slice(-1) == '0' || parts[0].slice(-1) == '.')) {
                                        parts[0] = parts[0].slice(0, -1);
                                    }
                                } else {
                                    // Make sure we have a period in alternative mode.
                                    if (flagAlternative && argText.indexOf('.') == -1) parts[0] += '.';
                                    // Zero pad until required precision.
                                    while (precision > effectivePrecision++) parts[0] += '0';
                                }
                                argText = parts[0] + (parts.length > 1 ? 'e' + parts[1] : '');

                                // Capitalize 'E' if needed.
                                if (next == 69) argText = argText.toUpperCase();

                                // Add sign.
                                if (currArg >= 0) {
                                    if (flagAlwaysSigned) {
                                        argText = '+' + argText;
                                    } else if (flagPadSign) {
                                        argText = ' ' + argText;
                                    }
                                }
                            }

                            // Add padding.
                            while (argText.length < width) {
                                if (flagLeftAlign) {
                                    argText += ' ';
                                } else {
                                    if (flagZeroPad && (argText[0] == '-' || argText[0] == '+')) {
                                        argText = argText[0] + '0' + argText.slice(1);
                                    } else {
                                        argText = (flagZeroPad ? '0' : ' ') + argText;
                                    }
                                }
                            }

                            // Adjust case.
                            if (next < 97) argText = argText.toUpperCase();

                            // Insert the result into the buffer.
                            argText.split('').forEach(function(chr) {
                                ret.push(chr.charCodeAt(0));
                            });
                            break;
                        }
                    case 's':
                        {
                            // String.
                            var arg = getNextArg('i8*');
                            var argLength = arg ? _strlen(arg) : '(null)'.length;
                            if (precisionSet) argLength = Math.min(argLength, precision);
                            if (!flagLeftAlign) {
                                while (argLength < width--) {
                                    ret.push(32);
                                }
                            }
                            if (arg) {
                                for (var i = 0; i < argLength; i++) {
                                    ret.push(HEAPU8[((arg++) | 0)]);
                                }
                            } else {
                                ret = ret.concat(intArrayFromString('(null)'.substr(0, argLength), true));
                            }
                            if (flagLeftAlign) {
                                while (argLength < width--) {
                                    ret.push(32);
                                }
                            }
                            break;
                        }
                    case 'c':
                        {
                            // Character.
                            if (flagLeftAlign) ret.push(getNextArg('i8'));
                            while (--width > 0) {
                                ret.push(32);
                            }
                            if (!flagLeftAlign) ret.push(getNextArg('i8'));
                            break;
                        }
                    case 'n':
                        {
                            // Write the length written so far to the next parameter.
                            var ptr = getNextArg('i32*');
                            HEAP32[((ptr) >> 2)] = ret.length;
                            break;
                        }
                    case '%':
                        {
                            // Literal percent sign.
                            ret.push(curr);
                            break;
                        }
                    default:
                        {
                            // Unknown specifiers remain untouched.
                            for (var i = startTextIndex; i < textIndex + 2; i++) {
                                ret.push(HEAP8[(i)]);
                            }
                        }
                }
                textIndex += 2;
                // TODO: Support a/A (hex float) and m (last error) specifiers.
                // TODO: Support %1${specifier} for arg selection.
            } else {
                ret.push(curr);
                textIndex += 1;
            }
        }
        return ret;
    }

    function _fprintf(stream, format, varargs) {
        // int fprintf(FILE *restrict stream, const char *restrict format, ...);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
        var result = __formatString(format, varargs);
        var stack = Runtime.stackSave();
        var ret = _fwrite(allocate(result, 'i8', ALLOC_STACK), 1, result.length, stream);
        Runtime.stackRestore(stack);
        return ret;
    }


    var ___cxa_caught_exceptions = [];

    function ___cxa_begin_catch(ptr) {
        __ZSt18uncaught_exceptionv.uncaught_exception--;
        ___cxa_caught_exceptions.push(___cxa_last_thrown_exception);
        return ptr;
    }



    function __exit(status) {
        // void _exit(int status);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/exit.html
        Module['exit'](status);
    }

    function _exit(status) {
        __exit(status);
    }

    function __ZSt9terminatev() {
        _exit(-1234);
    }

    function ___cxa_end_catch() {
        if (___cxa_end_catch.rethrown) {
            ___cxa_end_catch.rethrown = false;
            return;
        }
        // Clear state flag.
        asm['setThrew'](0);
        // Call destructor if one is registered then clear it.
        var ptr = ___cxa_caught_exceptions.pop();
        if (ptr) {
            header = ptr - ___cxa_exception_header_size;
            var destructor = HEAP32[(((header) + (4)) >> 2)];
            if (destructor) {
                Runtime.dynCall('vi', destructor, [ptr]);
                HEAP32[(((header) + (4)) >> 2)] = 0;
            }
            ___cxa_free_exception(ptr);
            ___cxa_last_thrown_exception = 0;
        }
    }


    var _llvm_memset_p0i8_i32 = _memset;




    Module["_memmove"] = _memmove;
    var _llvm_memmove_p0i8_p0i8_i32 = _memmove;

    function _printf(format, varargs) {
        // int printf(const char *restrict format, ...);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
        var stdout = HEAP32[((_stdout) >> 2)];
        return _fprintf(stdout, format, varargs);
    }


    function _snprintf(s, n, format, varargs) {
        // int snprintf(char *restrict s, size_t n, const char *restrict format, ...);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
        var result = __formatString(format, varargs);
        var limit = (n === undefined) ? result.length :
            Math.min(result.length, Math.max(n - 1, 0));
        if (s < 0) {
            s = -s;
            var buf = _malloc(limit + 1);
            HEAP32[((s) >> 2)] = buf;
            s = buf;
        }
        for (var i = 0; i < limit; i++) {
            HEAP8[(((s) + (i)) | 0)] = result[i];
        }
        if (limit < n || (n === undefined)) HEAP8[(((s) + (i)) | 0)] = 0;
        return result.length;
    }

    function _sprintf(s, format, varargs) {
        // int sprintf(char *restrict s, const char *restrict format, ...);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
        return _snprintf(s, undefined, format, varargs);
    }

    function _llvm_umul_with_overflow_i32(x, y) {
        x = x >>> 0;
        y = y >>> 0;
        return ((asm["setTempRet0"](x * y > 4294967295), (x * y) >>> 0) | 0);
    }

    function _llvm_uadd_with_overflow_i32(x, y) {
        x = x >>> 0;
        y = y >>> 0;
        return ((asm["setTempRet0"](x + y > 4294967295), (x + y) >>> 0) | 0);
    }

    var _llvm_memcpy_p0i8_p0i8_i64 = _memcpy;

    function ___cxa_rethrow() {
        ___cxa_end_catch.rethrown = true;
        var ptr = ___cxa_caught_exceptions.pop();
        throw ptr + " - Exception catching is disabled, this exception cannot be caught. Compile with -s DISABLE_EXCEPTION_CATCHING=0 or DISABLE_EXCEPTION_CATCHING=2 to catch.";
    }


    function _pthread_create() {
        Module['printErr']('missing function: pthread_create');
        abort(-1);
    }

    function _pthread_join() { throw 'TODO: ' + aborter }

    function _pthread_mutex_init() {}

    function _pthread_mutex_destroy() {}

    function _pthread_mutex_lock() {}

    function _pthread_mutex_unlock() {}

    function _pthread_cond_init() {}

    function _pthread_cond_destroy() {}

    function _pthread_cond_broadcast() {
        return 0;
    }

    function _pthread_cond_wait() {
        return 0;
    }

    function _pthread_cond_signal() { throw 'TODO: ' + aborter }

    var _llvm_va_start = undefined;

    function _vfprintf(s, f, va_arg) {
        return _fprintf(s, f, HEAP32[((va_arg) >> 2)]);
    }

    function _llvm_va_end() {}

    function ___cxa_guard_acquire(variable) {
        if (!HEAP8[(variable)]) { // ignore SAFE_HEAP stuff because llvm mixes i64 and i8 here
            HEAP8[(variable)] = 1;
            return 1;
        }
        return 0;
    }

    function ___cxa_guard_release() {}


    function _atexit(func, arg) {
        __ATEXIT__.unshift({ func: func, arg: arg });
    }
    var ___cxa_atexit = _atexit;

    function _ungetc(c, stream) {
        // int ungetc(int c, FILE *stream);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/ungetc.html
        stream = FS.getStreamFromPtr(stream);
        if (!stream) {
            return -1;
        }
        if (c === -1) {
            // do nothing for EOF character
            return c;
        }
        c = unSign(c & 0xFF);
        stream.ungotten.push(c);
        stream.eof = false;
        return c;
    }





    function _recv(fd, buf, len, flags) {
        var sock = SOCKFS.getSocket(fd);
        if (!sock) {
            ___setErrNo(ERRNO_CODES.EBADF);
            return -1;
        }
        // TODO honor flags
        return _read(fd, buf, len);
    }

    function _pread(fildes, buf, nbyte, offset) {
        // ssize_t pread(int fildes, void *buf, size_t nbyte, off_t offset);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/read.html
        var stream = FS.getStream(fildes);
        if (!stream) {
            ___setErrNo(ERRNO_CODES.EBADF);
            return -1;
        }
        try {
            var slab = HEAP8;
            return FS.read(stream, slab, buf, nbyte, offset);
        } catch (e) {
            FS.handleFSError(e);
            return -1;
        }
    }

    function _read(fildes, buf, nbyte) {
        // ssize_t read(int fildes, void *buf, size_t nbyte);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/read.html
        var stream = FS.getStream(fildes);
        if (!stream) {
            ___setErrNo(ERRNO_CODES.EBADF);
            return -1;
        }


        try {
            var slab = HEAP8;
            return FS.read(stream, slab, buf, nbyte);
        } catch (e) {
            FS.handleFSError(e);
            return -1;
        }
    }

    function _fread(ptr, size, nitems, stream) {
        // size_t fread(void *restrict ptr, size_t size, size_t nitems, FILE *restrict stream);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/fread.html
        var bytesToRead = nitems * size;
        if (bytesToRead == 0) {
            return 0;
        }
        var bytesRead = 0;
        var streamObj = FS.getStreamFromPtr(stream);
        if (!streamObj) {
            ___setErrNo(ERRNO_CODES.EBADF);
            return 0;
        }
        while (streamObj.ungotten.length && bytesToRead > 0) {
            HEAP8[((ptr++) | 0)] = streamObj.ungotten.pop();
            bytesToRead--;
            bytesRead++;
        }
        var err = _read(streamObj.fd, ptr, bytesToRead);
        if (err == -1) {
            if (streamObj) streamObj.error = true;
            return 0;
        }
        bytesRead += err;
        if (bytesRead < bytesToRead) streamObj.eof = true;
        return Math.floor(bytesRead / size);
    }

    function _fgetc(stream) {
        // int fgetc(FILE *stream);
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/fgetc.html
        var streamObj = FS.getStreamFromPtr(stream);
        if (!streamObj) return -1;
        if (streamObj.eof || streamObj.error) return -1;
        var ret = _fread(_fgetc.ret, 1, 1, stream);
        if (ret == 0) {
            return -1;
        } else if (ret == -1) {
            streamObj.error = true;
            return -1;
        } else {
            return HEAPU8[((_fgetc.ret) | 0)];
        }
    }
    var _getc = _fgetc;

    function __ZNSt9exceptionD2Ev() {}

    function ___errno_location() {
        return ___errno_state;
    }


    function _strerror_r(errnum, strerrbuf, buflen) {
        if (errnum in ERRNO_MESSAGES) {
            if (ERRNO_MESSAGES[errnum].length > buflen - 1) {
                return ___setErrNo(ERRNO_CODES.ERANGE);
            } else {
                var msg = ERRNO_MESSAGES[errnum];
                writeAsciiToMemory(msg, strerrbuf);
                return 0;
            }
        } else {
            return ___setErrNo(ERRNO_CODES.EINVAL);
        }
    }

    function _strerror(errnum) {
        if (!_strerror.buffer) _strerror.buffer = _malloc(256);
        _strerror_r(errnum, _strerror.buffer, 256);
        return _strerror.buffer;
    }

    function _abort() {
        Module['abort']();
    }


    function _sysconf(name) {
        // long sysconf(int name);
        // http://pubs.opengroup.org/onlinepubs/009695399/functions/sysconf.html
        switch (name) {
            case 30:
                return PAGE_SIZE;
            case 132:
            case 133:
            case 12:
            case 137:
            case 138:
            case 15:
            case 235:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 149:
            case 13:
            case 10:
            case 236:
            case 153:
            case 9:
            case 21:
            case 22:
            case 159:
            case 154:
            case 14:
            case 77:
            case 78:
            case 139:
            case 80:
            case 81:
            case 79:
            case 82:
            case 68:
            case 67:
            case 164:
            case 11:
            case 29:
            case 47:
            case 48:
            case 95:
            case 52:
            case 51:
            case 46:
                return 200809;
            case 27:
            case 246:
            case 127:
            case 128:
            case 23:
            case 24:
            case 160:
            case 161:
            case 181:
            case 182:
            case 242:
            case 183:
            case 184:
            case 243:
            case 244:
            case 245:
            case 165:
            case 178:
            case 179:
            case 49:
            case 50:
            case 168:
            case 169:
            case 175:
            case 170:
            case 171:
            case 172:
            case 97:
            case 76:
            case 32:
            case 173:
            case 35:
                return -1;
            case 176:
            case 177:
            case 7:
            case 155:
            case 8:
            case 157:
            case 125:
            case 126:
            case 92:
            case 93:
            case 129:
            case 130:
            case 131:
            case 94:
            case 91:
                return 1;
            case 74:
            case 60:
            case 69:
            case 70:
            case 4:
                return 1024;
            case 31:
            case 42:
            case 72:
                return 32;
            case 87:
            case 26:
            case 33:
                return 2147483647;
            case 34:
            case 1:
                return 47839;
            case 38:
            case 36:
                return 99;
            case 43:
            case 37:
                return 2048;
            case 0:
                return 2097152;
            case 3:
                return 65536;
            case 28:
                return 32768;
            case 44:
                return 32767;
            case 75:
                return 16384;
            case 39:
                return 1000;
            case 89:
                return 700;
            case 71:
                return 256;
            case 40:
                return 255;
            case 2:
                return 100;
            case 180:
                return 64;
            case 25:
                return 20;
            case 5:
                return 16;
            case 6:
                return 6;
            case 73:
                return 4;
            case 84:
                return 1;
        }
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
    }

    function ___cxa_guard_abort() {}


    function _isxdigit(chr) {
        return (chr >= 48 && chr <= 57) ||
            (chr >= 97 && chr <= 102) ||
            (chr >= 65 && chr <= 70);
    }

    function _isxdigit_l(chr) {
        return _isxdigit(chr); // no locale support yet
    }


    function _isdigit(chr) {
        return chr >= 48 && chr <= 57;
    }

    function _isdigit_l(chr) {
        return _isdigit(chr); // no locale support yet
    }



    function __getFloat(text) {
        return /^[+-]?[0-9]*\.?[0-9]+([eE][+-]?[0-9]+)?/.exec(text);
    }

    function __scanString(format, get, unget, varargs) {
        if (!__scanString.whiteSpace) {
            __scanString.whiteSpace = {};
            __scanString.whiteSpace[32] = 1;
            __scanString.whiteSpace[9] = 1;
            __scanString.whiteSpace[10] = 1;
            __scanString.whiteSpace[11] = 1;
            __scanString.whiteSpace[12] = 1;
            __scanString.whiteSpace[13] = 1;
        }
        // Supports %x, %4x, %d.%d, %lld, %s, %f, %lf.
        // TODO: Support all format specifiers.
        format = Pointer_stringify(format);
        var soFar = 0;
        if (format.indexOf('%n') >= 0) {
            // need to track soFar
            var _get = get;
            get = function get() {
                soFar++;
                return _get();
            }
            var _unget = unget;
            unget = function unget() {
                soFar--;
                return _unget();
            }
        }
        var formatIndex = 0;
        var argsi = 0;
        var fields = 0;
        var argIndex = 0;
        var next;

        mainLoop:
            for (var formatIndex = 0; formatIndex < format.length;) {
                if (format[formatIndex] === '%' && format[formatIndex + 1] == 'n') {
                    var argPtr = HEAP32[(((varargs) + (argIndex)) >> 2)];
                    argIndex += Runtime.getAlignSize('void*', null, true);
                    HEAP32[((argPtr) >> 2)] = soFar;
                    formatIndex += 2;
                    continue;
                }

                if (format[formatIndex] === '%') {
                    var nextC = format.indexOf('c', formatIndex + 1);
                    if (nextC > 0) {
                        var maxx = 1;
                        if (nextC > formatIndex + 1) {
                            var sub = format.substring(formatIndex + 1, nextC);
                            maxx = parseInt(sub);
                            if (maxx != sub) maxx = 0;
                        }
                        if (maxx) {
                            var argPtr = HEAP32[(((varargs) + (argIndex)) >> 2)];
                            argIndex += Runtime.getAlignSize('void*', null, true);
                            fields++;
                            for (var i = 0; i < maxx; i++) {
                                next = get();
                                HEAP8[((argPtr++) | 0)] = next;
                                if (next === 0) return i > 0 ? fields : fields - 1; // we failed to read the full length of this field
                            }
                            formatIndex += nextC - formatIndex + 1;
                            continue;
                        }
                    }
                }

                // handle %[...]
                if (format[formatIndex] === '%' && format.indexOf('[', formatIndex + 1) > 0) {
                    var match = /\%([0-9]*)\[(\^)?(\]?[^\]]*)\]/.exec(format.substring(formatIndex));
                    if (match) {
                        var maxNumCharacters = parseInt(match[1]) || Infinity;
                        var negateScanList = (match[2] === '^');
                        var scanList = match[3];

                        // expand "middle" dashs into character sets
                        var middleDashMatch;
                        while ((middleDashMatch = /([^\-])\-([^\-])/.exec(scanList))) {
                            var rangeStartCharCode = middleDashMatch[1].charCodeAt(0);
                            var rangeEndCharCode = middleDashMatch[2].charCodeAt(0);
                            for (var expanded = ''; rangeStartCharCode <= rangeEndCharCode; expanded += String.fromCharCode(rangeStartCharCode++));
                            scanList = scanList.replace(middleDashMatch[1] + '-' + middleDashMatch[2], expanded);
                        }

                        var argPtr = HEAP32[(((varargs) + (argIndex)) >> 2)];
                        argIndex += Runtime.getAlignSize('void*', null, true);
                        fields++;

                        for (var i = 0; i < maxNumCharacters; i++) {
                            next = get();
                            if (negateScanList) {
                                if (scanList.indexOf(String.fromCharCode(next)) < 0) {
                                    HEAP8[((argPtr++) | 0)] = next;
                                } else {
                                    unget();
                                    break;
                                }
                            } else {
                                if (scanList.indexOf(String.fromCharCode(next)) >= 0) {
                                    HEAP8[((argPtr++) | 0)] = next;
                                } else {
                                    unget();
                                    break;
                                }
                            }
                        }

                        // write out null-terminating character
                        HEAP8[((argPtr++) | 0)] = 0;
                        formatIndex += match[0].length;

                        continue;
                    }
                }
                // remove whitespace
                while (1) {
                    next = get();
                    if (next == 0) return fields;
                    if (!(next in __scanString.whiteSpace)) break;
                }
                unget();

                if (format[formatIndex] === '%') {
                    formatIndex++;
                    var suppressAssignment = false;
                    if (format[formatIndex] == '*') {
                        suppressAssignment = true;
                        formatIndex++;
                    }
                    var maxSpecifierStart = formatIndex;
                    while (format[formatIndex].charCodeAt(0) >= 48 &&
                        format[formatIndex].charCodeAt(0) <= 57) {
                        formatIndex++;
                    }
                    var max_;
                    if (formatIndex != maxSpecifierStart) {
                        max_ = parseInt(format.slice(maxSpecifierStart, formatIndex), 10);
                    }
                    var long_ = false;
                    var half = false;
                    var longLong = false;
                    if (format[formatIndex] == 'l') {
                        long_ = true;
                        formatIndex++;
                        if (format[formatIndex] == 'l') {
                            longLong = true;
                            formatIndex++;
                        }
                    } else if (format[formatIndex] == 'h') {
                        half = true;
                        formatIndex++;
                    }
                    var type = format[formatIndex];
                    formatIndex++;
                    var curr = 0;
                    var buffer = [];
                    // Read characters according to the format. floats are trickier, they may be in an unfloat state in the middle, then be a valid float later
                    if (type == 'f' || type == 'e' || type == 'g' ||
                        type == 'F' || type == 'E' || type == 'G') {
                        next = get();
                        while (next > 0 && (!(next in __scanString.whiteSpace))) {
                            buffer.push(String.fromCharCode(next));
                            next = get();
                        }
                        var m = __getFloat(buffer.join(''));
                        var last = m ? m[0].length : 0;
                        for (var i = 0; i < buffer.length - last + 1; i++) {
                            unget();
                        }
                        buffer.length = last;
                    } else {
                        next = get();
                        var first = true;

                        // Strip the optional 0x prefix for %x.
                        if ((type == 'x' || type == 'X') && (next == 48)) {
                            var peek = get();
                            if (peek == 120 || peek == 88) {
                                next = get();
                            } else {
                                unget();
                            }
                        }

                        while ((curr < max_ || isNaN(max_)) && next > 0) {
                            if (!(next in __scanString.whiteSpace) && // stop on whitespace
                                (type == 's' ||
                                    ((type === 'd' || type == 'u' || type == 'i') && ((next >= 48 && next <= 57) ||
                                        (first && next == 45))) ||
                                    ((type === 'x' || type === 'X') && (next >= 48 && next <= 57 ||
                                        next >= 97 && next <= 102 ||
                                        next >= 65 && next <= 70))) &&
                                (formatIndex >= format.length || next !== format[formatIndex].charCodeAt(0))) { // Stop when we read something that is coming up
                                buffer.push(String.fromCharCode(next));
                                next = get();
                                curr++;
                                first = false;
                            } else {
                                break;
                            }
                        }
                        unget();
                    }
                    if (buffer.length === 0) return 0; // Failure.
                    if (suppressAssignment) continue;

                    var text = buffer.join('');
                    var argPtr = HEAP32[(((varargs) + (argIndex)) >> 2)];
                    argIndex += Runtime.getAlignSize('void*', null, true);
                    switch (type) {
                        case 'd':
                        case 'u':
                        case 'i':
                            if (half) {
                                HEAP16[((argPtr) >> 1)] = parseInt(text, 10);
                            } else if (longLong) {
                                (tempI64 = [parseInt(text, 10) >>> 0, (tempDouble = parseInt(text, 10), (+(Math_abs(tempDouble))) >= (+1) ? (tempDouble > (+0) ? ((Math_min((+(Math_floor((tempDouble) / (+4294967296)))), (+4294967295))) | 0) >>> 0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble))) >>> 0)) / (+4294967296)))))) >>> 0) : 0)], HEAP32[((argPtr) >> 2)] = tempI64[0], HEAP32[(((argPtr) + (4)) >> 2)] = tempI64[1]);
                            } else {
                                HEAP32[((argPtr) >> 2)] = parseInt(text, 10);
                            }
                            break;
                        case 'X':
                        case 'x':
                            HEAP32[((argPtr) >> 2)] = parseInt(text, 16);
                            break;
                        case 'F':
                        case 'f':
                        case 'e':
                        case 'G':
                        case 'g':
                        case 'E':
                            // fallthrough intended
                            if (long_) {
                                HEAPF64[((argPtr) >> 3)] = parseFloat(text);
                            } else {
                                HEAPF32[((argPtr) >> 2)] = parseFloat(text);
                            }
                            break;
                        case 's':
                            var array = intArrayFromString(text);
                            for (var j = 0; j < array.length; j++) {
                                HEAP8[(((argPtr) + (j)) | 0)] = array[j];
                            }
                            break;
                    }
                    fields++;
                } else if (format[formatIndex].charCodeAt(0) in __scanString.whiteSpace) {
                    next = get();
                    while (next in __scanString.whiteSpace) {
                        if (next <= 0) break mainLoop; // End of input.
                        next = get();
                    }
                    unget(next);
                    formatIndex++;
                } else {
                    // Not a specifier.
                    next = get();
                    if (format[formatIndex].charCodeAt(0) !== next) {
                        unget(next);
                        break mainLoop;
                    }
                    formatIndex++;
                }
            }
        return fields;
    }

    function _sscanf(s, format, varargs) {
        // int sscanf(const char *restrict s, const char *restrict format, ... );
        // http://pubs.opengroup.org/onlinepubs/000095399/functions/scanf.html
        var index = 0;

        function get() { return HEAP8[(((s) + (index++)) | 0)]; };

        function unget() { index--; };
        return __scanString(format, get, unget, varargs);
    }

    function _catopen(name, oflag) {
        // nl_catd catopen (const char *name, int oflag)
        return -1;
    }

    function _catgets(catd, set_id, msg_id, s) {
        // char *catgets (nl_catd catd, int set_id, int msg_id, const char *s)
        return s;
    }

    function _catclose(catd) {
        // int catclose (nl_catd catd)
        return 0;
    }

    function _newlocale(mask, locale, base) {
        return _malloc(4);
    }

    function _freelocale(locale) {
        _free(locale);
    }

    function ___ctype_b_loc() {
        // http://refspecs.freestandards.org/LSB_3.0.0/LSB-Core-generic/LSB-Core-generic/baselib---ctype-b-loc.html
        var me = ___ctype_b_loc;
        if (!me.ret) {
            var values = [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 8195, 8194, 8194, 8194, 8194, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 24577, 49156, 49156, 49156,
                49156, 49156, 49156, 49156, 49156, 49156, 49156, 49156, 49156, 49156, 49156, 49156, 55304, 55304, 55304, 55304, 55304, 55304, 55304, 55304,
                55304, 55304, 49156, 49156, 49156, 49156, 49156, 49156, 49156, 54536, 54536, 54536, 54536, 54536, 54536, 50440, 50440, 50440, 50440, 50440,
                50440, 50440, 50440, 50440, 50440, 50440, 50440, 50440, 50440, 50440, 50440, 50440, 50440, 50440, 50440, 49156, 49156, 49156, 49156, 49156,
                49156, 54792, 54792, 54792, 54792, 54792, 54792, 50696, 50696, 50696, 50696, 50696, 50696, 50696, 50696, 50696, 50696, 50696, 50696, 50696,
                50696, 50696, 50696, 50696, 50696, 50696, 50696, 49156, 49156, 49156, 49156, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ];
            var i16size = 2;
            var arr = _malloc(values.length * i16size);
            for (var i = 0; i < values.length; i++) {
                HEAP16[(((arr) + (i * i16size)) >> 1)] = values[i];
            }
            me.ret = allocate([arr + 128 * i16size], 'i16*', ALLOC_NORMAL);
        }
        return me.ret;
    }

    function ___ctype_tolower_loc() {
        // http://refspecs.freestandards.org/LSB_3.1.1/LSB-Core-generic/LSB-Core-generic/libutil---ctype-tolower-loc.html
        var me = ___ctype_tolower_loc;
        if (!me.ret) {
            var values = [
                128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157,
                158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187,
                188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217,
                218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247,
                248, 249, 250, 251, 252, 253, 254, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
                33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 97, 98, 99, 100, 101, 102, 103,
                104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103,
                104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133,
                134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163,
                164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193,
                194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223,
                224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253,
                254, 255
            ];
            var i32size = 4;
            var arr = _malloc(values.length * i32size);
            for (var i = 0; i < values.length; i++) {
                HEAP32[(((arr) + (i * i32size)) >> 2)] = values[i];
            }
            me.ret = allocate([arr + 128 * i32size], 'i32*', ALLOC_NORMAL);
        }
        return me.ret;
    }

    function ___ctype_toupper_loc() {
        // http://refspecs.freestandards.org/LSB_3.1.1/LSB-Core-generic/LSB-Core-generic/libutil---ctype-toupper-loc.html
        var me = ___ctype_toupper_loc;
        if (!me.ret) {
            var values = [
                128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157,
                158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187,
                188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217,
                218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247,
                248, 249, 250, 251, 252, 253, 254, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
                33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72,
                73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
                81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
                145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174,
                175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204,
                205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234,
                235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255
            ];
            var i32size = 4;
            var arr = _malloc(values.length * i32size);
            for (var i = 0; i < values.length; i++) {
                HEAP32[(((arr) + (i * i32size)) >> 2)] = values[i];
            }
            me.ret = allocate([arr + 128 * i32size], 'i32*', ALLOC_NORMAL);
        }
        return me.ret;
    }



    function __isLeapYear(year) {
        return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    }

    function __arraySum(array, index) {
        var sum = 0;
        for (var i = 0; i <= index; sum += array[i++]);
        return sum;
    }


    var __MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    var __MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    function __addDays(date, days) {
        var newDate = new Date(date.getTime());
        while (days > 0) {
            var leap = __isLeapYear(newDate.getFullYear());
            var currentMonth = newDate.getMonth();
            var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];

            if (days > daysInCurrentMonth - newDate.getDate()) {
                // we spill over to next month
                days -= (daysInCurrentMonth - newDate.getDate() + 1);
                newDate.setDate(1);
                if (currentMonth < 11) {
                    newDate.setMonth(currentMonth + 1)
                } else {
                    newDate.setMonth(0);
                    newDate.setFullYear(newDate.getFullYear() + 1);
                }
            } else {
                // we stay in current month
                newDate.setDate(newDate.getDate() + days);
                return newDate;
            }
        }

        return newDate;
    }

    function _strftime(s, maxsize, format, tm) {
        // size_t strftime(char *restrict s, size_t maxsize, const char *restrict format, const struct tm *restrict timeptr);
        // http://pubs.opengroup.org/onlinepubs/009695399/functions/strftime.html

        var date = {
            tm_sec: HEAP32[((tm) >> 2)],
            tm_min: HEAP32[(((tm) + (4)) >> 2)],
            tm_hour: HEAP32[(((tm) + (8)) >> 2)],
            tm_mday: HEAP32[(((tm) + (12)) >> 2)],
            tm_mon: HEAP32[(((tm) + (16)) >> 2)],
            tm_year: HEAP32[(((tm) + (20)) >> 2)],
            tm_wday: HEAP32[(((tm) + (24)) >> 2)],
            tm_yday: HEAP32[(((tm) + (28)) >> 2)],
            tm_isdst: HEAP32[(((tm) + (32)) >> 2)]
        };

        var pattern = Pointer_stringify(format);

        // expand format
        var EXPANSION_RULES_1 = {
            '%c': '%a %b %d %H:%M:%S %Y', // Replaced by the locale's appropriate date and time representation - e.g., Mon Aug  3 14:02:01 2013
            '%D': '%m/%d/%y', // Equivalent to %m / %d / %y
            '%F': '%Y-%m-%d', // Equivalent to %Y - %m - %d
            '%h': '%b', // Equivalent to %b
            '%r': '%I:%M:%S %p', // Replaced by the time in a.m. and p.m. notation
            '%R': '%H:%M', // Replaced by the time in 24-hour notation
            '%T': '%H:%M:%S', // Replaced by the time
            '%x': '%m/%d/%y', // Replaced by the locale's appropriate date representation
            '%X': '%H:%M:%S', // Replaced by the locale's appropriate date representation
        };
        for (var rule in EXPANSION_RULES_1) {
            pattern = pattern.replace(new RegExp(rule, 'g'), EXPANSION_RULES_1[rule]);
        }

        var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        function leadingSomething(value, digits, character) {
            var str = typeof value === 'number' ? value.toString() : (value || '');
            while (str.length < digits) {
                str = character[0] + str;
            }
            return str;
        };

        function leadingNulls(value, digits) {
            return leadingSomething(value, digits, '0');
        };

        function compareByDay(date1, date2) {
            function sgn(value) {
                return value < 0 ? -1 : (value > 0 ? 1 : 0);
            };

            var compare;
            if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                    compare = sgn(date1.getDate() - date2.getDate());
                }
            }
            return compare;
        };

        function getFirstWeekStartDate(janFourth) {
            switch (janFourth.getDay()) {
                case 0: // Sunday
                    return new Date(janFourth.getFullYear() - 1, 11, 29);
                case 1: // Monday
                    return janFourth;
                case 2: // Tuesday
                    return new Date(janFourth.getFullYear(), 0, 3);
                case 3: // Wednesday
                    return new Date(janFourth.getFullYear(), 0, 2);
                case 4: // Thursday
                    return new Date(janFourth.getFullYear(), 0, 1);
                case 5: // Friday
                    return new Date(janFourth.getFullYear() - 1, 11, 31);
                case 6: // Saturday
                    return new Date(janFourth.getFullYear() - 1, 11, 30);
            }
        };

        function getWeekBasedYear(date) {
            var thisDate = __addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);

            var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
            var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);

            var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
            var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);

            if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                // this date is after the start of the first week of this year
                if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                    return thisDate.getFullYear() + 1;
                } else {
                    return thisDate.getFullYear();
                }
            } else {
                return thisDate.getFullYear() - 1;
            }
        };

        var EXPANSION_RULES_2 = {
            '%a': function(date) {
                return WEEKDAYS[date.tm_wday].substring(0, 3);
            },
            '%A': function(date) {
                return WEEKDAYS[date.tm_wday];
            },
            '%b': function(date) {
                return MONTHS[date.tm_mon].substring(0, 3);
            },
            '%B': function(date) {
                return MONTHS[date.tm_mon];
            },
            '%C': function(date) {
                var year = date.tm_year + 1900;
                return leadingNulls(Math.floor(year / 100), 2);
            },
            '%d': function(date) {
                return leadingNulls(date.tm_mday, 2);
            },
            '%e': function(date) {
                return leadingSomething(date.tm_mday, 2, ' ');
            },
            '%g': function(date) {
                // %g, %G, and %V give values according to the ISO 8601:2000 standard week-based year.
                // In this system, weeks begin on a Monday and week 1 of the year is the week that includes
                // January 4th, which is also the week that includes the first Thursday of the year, and
                // is also the first week that contains at least four days in the year.
                // If the first Monday of January is the 2nd, 3rd, or 4th, the preceding days are part of
                // the last week of the preceding year; thus, for Saturday 2nd January 1999,
                // %G is replaced by 1998 and %V is replaced by 53. If December 29th, 30th,
                // or 31st is a Monday, it and any following days are part of week 1 of the following year.
                // Thus, for Tuesday 30th December 1997, %G is replaced by 1998 and %V is replaced by 01.

                return getWeekBasedYear(date).toString().substring(2);
            },
            '%G': function(date) {
                return getWeekBasedYear(date);
            },
            '%H': function(date) {
                return leadingNulls(date.tm_hour, 2);
            },
            '%I': function(date) {
                return leadingNulls(date.tm_hour < 13 ? date.tm_hour : date.tm_hour - 12, 2);
            },
            '%j': function(date) {
                // Day of the year (001-366)
                return leadingNulls(date.tm_mday + __arraySum(__isLeapYear(date.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date.tm_mon - 1), 3);
            },
            '%m': function(date) {
                return leadingNulls(date.tm_mon + 1, 2);
            },
            '%M': function(date) {
                return leadingNulls(date.tm_min, 2);
            },
            '%n': function() {
                return '\n';
            },
            '%p': function(date) {
                if (date.tm_hour > 0 && date.tm_hour < 13) {
                    return 'AM';
                } else {
                    return 'PM';
                }
            },
            '%S': function(date) {
                return leadingNulls(date.tm_sec, 2);
            },
            '%t': function() {
                return '\t';
            },
            '%u': function(date) {
                var day = new Date(date.tm_year + 1900, date.tm_mon + 1, date.tm_mday, 0, 0, 0, 0);
                return day.getDay() || 7;
            },
            '%U': function(date) {
                // Replaced by the week number of the year as a decimal number [00,53].
                // The first Sunday of January is the first day of week 1;
                // days in the new year before this are in week 0. [ tm_year, tm_wday, tm_yday]
                var janFirst = new Date(date.tm_year + 1900, 0, 1);
                var firstSunday = janFirst.getDay() === 0 ? janFirst : __addDays(janFirst, 7 - janFirst.getDay());
                var endDate = new Date(date.tm_year + 1900, date.tm_mon, date.tm_mday);

                // is target date after the first Sunday?
                if (compareByDay(firstSunday, endDate) < 0) {
                    // calculate difference in days between first Sunday and endDate
                    var februaryFirstUntilEndMonth = __arraySum(__isLeapYear(endDate.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, endDate.getMonth() - 1) - 31;
                    var firstSundayUntilEndJanuary = 31 - firstSunday.getDate();
                    var days = firstSundayUntilEndJanuary + februaryFirstUntilEndMonth + endDate.getDate();
                    return leadingNulls(Math.ceil(days / 7), 2);
                }

                return compareByDay(firstSunday, janFirst) === 0 ? '01' : '00';
            },
            '%V': function(date) {
                // Replaced by the week number of the year (Monday as the first day of the week)
                // as a decimal number [01,53]. If the week containing 1 January has four
                // or more days in the new year, then it is considered week 1.
                // Otherwise, it is the last week of the previous year, and the next week is week 1.
                // Both January 4th and the first Thursday of January are always in week 1. [ tm_year, tm_wday, tm_yday]
                var janFourthThisYear = new Date(date.tm_year + 1900, 0, 4);
                var janFourthNextYear = new Date(date.tm_year + 1901, 0, 4);

                var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);

                var endDate = __addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);

                if (compareByDay(endDate, firstWeekStartThisYear) < 0) {
                    // if given date is before this years first week, then it belongs to the 53rd week of last year
                    return '53';
                }

                if (compareByDay(firstWeekStartNextYear, endDate) <= 0) {
                    // if given date is after next years first week, then it belongs to the 01th week of next year
                    return '01';
                }

                // given date is in between CW 01..53 of this calendar year
                var daysDifference;
                if (firstWeekStartThisYear.getFullYear() < date.tm_year + 1900) {
                    // first CW of this year starts last year
                    daysDifference = date.tm_yday + 32 - firstWeekStartThisYear.getDate()
                } else {
                    // first CW of this year starts this year
                    daysDifference = date.tm_yday + 1 - firstWeekStartThisYear.getDate();
                }
                return leadingNulls(Math.ceil(daysDifference / 7), 2);
            },
            '%w': function(date) {
                var day = new Date(date.tm_year + 1900, date.tm_mon + 1, date.tm_mday, 0, 0, 0, 0);
                return day.getDay();
            },
            '%W': function(date) {
                // Replaced by the week number of the year as a decimal number [00,53].
                // The first Monday of January is the first day of week 1;
                // days in the new year before this are in week 0. [ tm_year, tm_wday, tm_yday]
                var janFirst = new Date(date.tm_year, 0, 1);
                var firstMonday = janFirst.getDay() === 1 ? janFirst : __addDays(janFirst, janFirst.getDay() === 0 ? 1 : 7 - janFirst.getDay() + 1);
                var endDate = new Date(date.tm_year + 1900, date.tm_mon, date.tm_mday);

                // is target date after the first Monday?
                if (compareByDay(firstMonday, endDate) < 0) {
                    var februaryFirstUntilEndMonth = __arraySum(__isLeapYear(endDate.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, endDate.getMonth() - 1) - 31;
                    var firstMondayUntilEndJanuary = 31 - firstMonday.getDate();
                    var days = firstMondayUntilEndJanuary + februaryFirstUntilEndMonth + endDate.getDate();
                    return leadingNulls(Math.ceil(days / 7), 2);
                }
                return compareByDay(firstMonday, janFirst) === 0 ? '01' : '00';
            },
            '%y': function(date) {
                // Replaced by the last two digits of the year as a decimal number [00,99]. [ tm_year]
                return (date.tm_year + 1900).toString().substring(2);
            },
            '%Y': function(date) {
                // Replaced by the year as a decimal number (for example, 1997). [ tm_year]
                return date.tm_year + 1900;
            },
            '%z': function(date) {
                // Replaced by the offset from UTC in the ISO 8601:2000 standard format ( +hhmm or -hhmm ),
                // or by no characters if no timezone is determinable.
                // For example, "-0430" means 4 hours 30 minutes behind UTC (west of Greenwich).
                // If tm_isdst is zero, the standard time offset is used.
                // If tm_isdst is greater than zero, the daylight savings time offset is used.
                // If tm_isdst is negative, no characters are returned.
                // FIXME: we cannot determine time zone (or can we?)
                return '';
            },
            '%Z': function(date) {
                // Replaced by the timezone name or abbreviation, or by no bytes if no timezone information exists. [ tm_isdst]
                // FIXME: we cannot determine time zone (or can we?)
                return '';
            },
            '%%': function() {
                return '%';
            }
        };
        for (var rule in EXPANSION_RULES_2) {
            if (pattern.indexOf(rule) >= 0) {
                pattern = pattern.replace(new RegExp(rule, 'g'), EXPANSION_RULES_2[rule](date));
            }
        }

        var bytes = intArrayFromString(pattern, false);
        if (bytes.length > maxsize) {
            return 0;
        }

        writeArrayToMemory(bytes, s);
        return bytes.length - 1;
    }

    function _strftime_l(s, maxsize, format, tm) {
        return _strftime(s, maxsize, format, tm); // no locale support yet
    }




    function _isspace(chr) {
        return (chr == 32) || (chr >= 9 && chr <= 13);
    }

    function __parseInt64(str, endptr, base, min, max, unsign) {
        var isNegative = false;
        // Skip space.
        while (_isspace(HEAP8[(str)])) str++;

        // Check for a plus/minus sign.
        if (HEAP8[(str)] == 45) {
            str++;
            isNegative = true;
        } else if (HEAP8[(str)] == 43) {
            str++;
        }

        // Find base.
        var ok = false;
        var finalBase = base;
        if (!finalBase) {
            if (HEAP8[(str)] == 48) {
                if (HEAP8[((str + 1) | 0)] == 120 ||
                    HEAP8[((str + 1) | 0)] == 88) {
                    finalBase = 16;
                    str += 2;
                } else {
                    finalBase = 8;
                    ok = true; // we saw an initial zero, perhaps the entire thing is just "0"
                }
            }
        } else if (finalBase == 16) {
            if (HEAP8[(str)] == 48) {
                if (HEAP8[((str + 1) | 0)] == 120 ||
                    HEAP8[((str + 1) | 0)] == 88) {
                    str += 2;
                }
            }
        }
        if (!finalBase) finalBase = 10;
        var start = str;

        // Get digits.
        var chr;
        while ((chr = HEAP8[(str)]) != 0) {
            var digit = parseInt(String.fromCharCode(chr), finalBase);
            if (isNaN(digit)) {
                break;
            } else {
                str++;
                ok = true;
            }
        }

        if (!ok) {
            ___setErrNo(ERRNO_CODES.EINVAL);
            return ((asm["setTempRet0"](0), 0) | 0);
        }

        // Set end pointer.
        if (endptr) {
            HEAP32[((endptr) >> 2)] = str;
        }

        try {
            var numberString = isNegative ? '-' + Pointer_stringify(start, str - start) : Pointer_stringify(start, str - start);
            i64Math.fromString(numberString, finalBase, min, max, unsign);
        } catch (e) {
            ___setErrNo(ERRNO_CODES.ERANGE); // not quite correct
        }

        return ((asm["setTempRet0"](((HEAP32[(((tempDoublePtr) + (4)) >> 2)]) | 0)), ((HEAP32[((tempDoublePtr) >> 2)]) | 0)) | 0);
    }

    function _strtoull(str, endptr, base) {
        return __parseInt64(str, endptr, base, 0, '18446744073709551615', true); // ULONG_MAX.
    }

    function _strtoull_l(str, endptr, base) {
        return _strtoull(str, endptr, base); // no locale support yet
    }


    function _strtoll(str, endptr, base) {
        return __parseInt64(str, endptr, base, '-9223372036854775808', '9223372036854775807'); // LLONG_MIN, LLONG_MAX.
    }

    function _strtoll_l(str, endptr, base) {
        return _strtoll(str, endptr, base); // no locale support yet
    }

    function _uselocale(locale) {
        return 0;
    }


    function _asprintf(s, format, varargs) {
        return _sprintf(-s, format, varargs);
    }

    function _vasprintf(s, format, va_arg) {
        return _asprintf(s, format, HEAP32[((va_arg) >> 2)]);
    }

    function _vsnprintf(s, n, format, va_arg) {
        return _snprintf(s, n, format, HEAP32[((va_arg) >> 2)]);
    }

    function _vsscanf(s, format, va_arg) {
        return _sscanf(s, format, HEAP32[((va_arg) >> 2)]);
    }


    var _fabs = Math_abs;

    function _sbrk(bytes) {
        // Implement a Linux-like 'memory area' for our 'process'.
        // Changes the size of the memory area by |bytes|; returns the
        // address of the previous top ('break') of the memory area
        // We control the "dynamic" memory - DYNAMIC_BASE to DYNAMICTOP
        var self = _sbrk;
        if (!self.called) {
            DYNAMICTOP = alignMemoryPage(DYNAMICTOP); // make sure we start out aligned
            self.called = true;
            assert(Runtime.dynamicAlloc);
            self.alloc = Runtime.dynamicAlloc;
            Runtime.dynamicAlloc = function() { abort('cannot dynamically allocate, sbrk now has control') };
        }
        var ret = DYNAMICTOP;
        if (bytes != 0) self.alloc(bytes);
        return ret; // Previous break location.
    }

    function _time(ptr) {
        var ret = Math.floor(Date.now() / 1000);
        if (ptr) {
            HEAP32[((ptr) >> 2)] = ret;
        }
        return ret;
    }

    function ___cxa_call_unexpected(exception) {
        Module.printErr('Unexpected exception thrown, this is not properly supported - aborting');
        ABORT = true;
        throw exception;
    }


    function _copysign(a, b) {
        return __reallyNegative(a) === __reallyNegative(b) ? a : -a;
    }
    var _copysignl = _copysign;


    function _fmod(x, y) {
        return x % y;
    }
    var _fmodl = _fmod;






    Module["_emscripten_replace_memory"] = _emscripten_replace_memory;
    FS.staticInit();
    __ATINIT__.unshift({ func: function() { if (!Module["noFSInit"] && !FS.init.initialized) FS.init() } });
    __ATMAIN__.push({ func: function() { FS.ignorePermissions = false } });
    __ATEXIT__.push({ func: function() { FS.quit() } });
    Module["FS_createFolder"] = FS.createFolder;
    Module["FS_createPath"] = FS.createPath;
    Module["FS_createDataFile"] = FS.createDataFile;
    Module["FS_createPreloadedFile"] = FS.createPreloadedFile;
    Module["FS_createLazyFile"] = FS.createLazyFile;
    Module["FS_createLink"] = FS.createLink;
    Module["FS_createDevice"] = FS.createDevice;
    ___errno_state = Runtime.staticAlloc(4);
    HEAP32[((___errno_state) >> 2)] = 0;
    __ATINIT__.unshift({ func: function() { TTY.init() } });
    __ATEXIT__.push({ func: function() { TTY.shutdown() } });
    TTY.utf8 = new Runtime.UTF8Processor();
    if (ENVIRONMENT_IS_NODE) {
        var fs = require("fs");
        NODEFS.staticInit();
    }
    __ATINIT__.push({ func: function() { SOCKFS.root = FS.mount(SOCKFS, {}, null); } });
    _fgetc.ret = allocate([0], "i8", ALLOC_STATIC);
    STACK_BASE = STACKTOP = Runtime.alignMemory(STATICTOP);

    staticSealed = true; // seal the static portion of memory

    STACK_MAX = STACK_BASE + 5242880;

    DYNAMIC_BASE = DYNAMICTOP = Runtime.alignMemory(STACK_MAX);

    assert(DYNAMIC_BASE < TOTAL_MEMORY, "TOTAL_MEMORY not big enough for stack");

    var ctlz_i8 = allocate([8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], "i8", ALLOC_DYNAMIC);
    var cttz_i8 = allocate([8, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 6, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 7, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 6, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 5, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0, 4, 0, 1, 0, 2, 0, 1, 0, 3, 0, 1, 0, 2, 0, 1, 0], "i8", ALLOC_DYNAMIC);

    var Math_min = Math.min;

    function invoke_viiiii(index, a1, a2, a3, a4, a5) {
        try {
            Module["dynCall_viiiii"](index, a1, a2, a3, a4, a5);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_vi(index, a1) {
        try {
            Module["dynCall_vi"](index, a1);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_vii(index, a1, a2) {
        try {
            Module["dynCall_vii"](index, a1, a2);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_ii(index, a1) {
        try {
            return Module["dynCall_ii"](index, a1);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_iiiiii(index, a1, a2, a3, a4, a5) {
        try {
            return Module["dynCall_iiiiii"](index, a1, a2, a3, a4, a5);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_iiii(index, a1, a2, a3) {
        try {
            return Module["dynCall_iiii"](index, a1, a2, a3);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiid(index, a1, a2, a3, a4, a5, a6) {
        try {
            Module["dynCall_viiiiid"](index, a1, a2, a3, a4, a5, a6);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8) {
        try {
            Module["dynCall_viiiiiiii"](index, a1, a2, a3, a4, a5, a6, a7, a8);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiii(index, a1, a2, a3, a4, a5, a6) {
        try {
            Module["dynCall_viiiiii"](index, a1, a2, a3, a4, a5, a6);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) {
        try {
            Module["dynCall_viiiiiiiiiiiii"](index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
        try {
            Module["dynCall_viiiiiii"](index, a1, a2, a3, a4, a5, a6, a7);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiiid(index, a1, a2, a3, a4, a5, a6, a7) {
        try {
            Module["dynCall_viiiiiid"](index, a1, a2, a3, a4, a5, a6, a7);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        try {
            Module["dynCall_viiiiiiiii"](index, a1, a2, a3, a4, a5, a6, a7, a8, a9);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
        try {
            Module["dynCall_viiiiiiiiii"](index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_iii(index, a1, a2) {
        try {
            return Module["dynCall_iii"](index, a1, a2);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12) {
        try {
            Module["dynCall_viiiiiiiiiiii"](index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_iiiii(index, a1, a2, a3, a4) {
        try {
            return Module["dynCall_iiiii"](index, a1, a2, a3, a4);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viii(index, a1, a2, a3) {
        try {
            Module["dynCall_viii"](index, a1, a2, a3);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_v(index) {
        try {
            Module["dynCall_v"](index);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_iiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8) {
        try {
            return Module["dynCall_iiiiiiiii"](index, a1, a2, a3, a4, a5, a6, a7, a8);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function invoke_viiii(index, a1, a2, a3, a4) {
        try {
            Module["dynCall_viiii"](index, a1, a2, a3, a4);
        } catch (e) {
            if (typeof e !== 'number' && e !== 'longjmp') throw e;
            asm["setThrew"](1, 0);
        }
    }

    function asmPrintInt(x, y) {
        Module.print('int ' + x + ',' + y); // + ' ' + new Error().stack);
    }

    function asmPrintFloat(x, y) {
        Module.print('float ' + x + ',' + y); // + ' ' + new Error().stack);
    }
    // EMSCRIPTEN_START_ASM
    var asm = (function(global, env, buffer) {
        "almost asm";
        var a = new global.Int8Array(buffer);
        var b = new global.Int16Array(buffer);
        var c = new global.Int32Array(buffer);
        var d = new global.Uint8Array(buffer);
        var e = new global.Uint16Array(buffer);
        var f = new global.Uint32Array(buffer);
        var g = new global.Float32Array(buffer);
        var h = new global.Float64Array(buffer);
        var i = env.STACKTOP | 0;
        var j = env.STACK_MAX | 0;
        var k = env.tempDoublePtr | 0;
        var l = env.ABORT | 0;
        var m = env.cttz_i8 | 0;
        var n = env.ctlz_i8 | 0;
        var o = env._stdin | 0;
        var p = env.__ZTVN10__cxxabiv117__class_type_infoE | 0;
        var q = env._stderr | 0;
        var r = env.__ZTISt9exception | 0;
        var s = env.__ZTVN10__cxxabiv120__si_class_type_infoE | 0;
        var t = env._stdout | 0;
        var u = env.___dso_handle | 0;
        var v = +env.NaN;
        var w = +env.Infinity;
        var x = 0;
        var y = 0;
        var z = 0;
        var A = 0;
        var B = 0,
            C = 0,
            D = 0,
            E = 0,
            F = 0.0,
            G = 0,
            H = 0,
            I = 0,
            J = 0.0;
        var K = 0;
        var L = 0;
        var M = 0;
        var N = 0;
        var O = 0;
        var P = 0;
        var Q = 0;
        var R = 0;
        var S = 0;
        var T = 0;
        var U = global.Math.floor;
        var V = global.Math.abs;
        var W = global.Math.sqrt;
        var X = global.Math.pow;
        var Y = global.Math.cos;
        var Z = global.Math.sin;
        var _ = global.Math.tan;
        var $ = global.Math.acos;
        var aa = global.Math.asin;
        var ba = global.Math.atan;
        var ca = global.Math.atan2;
        var da = global.Math.exp;
        var ea = global.Math.log;
        var fa = global.Math.ceil;
        var ga = global.Math.imul;
        var ha = env.abort;
        var ia = env.assert;
        var ja = env.asmPrintInt;
        var ka = env.asmPrintFloat;
        var la = env.min;
        var ma = env.invoke_viiiii;
        var na = env.invoke_vi;
        var oa = env.invoke_vii;
        var pa = env.invoke_ii;
        var qa = env.invoke_iiiiii;
        var ra = env.invoke_iiii;
        var sa = env.invoke_viiiiid;
        var ta = env.invoke_viiiiiiii;
        var ua = env.invoke_viiiiii;
        var va = env.invoke_viiiiiiiiiiiii;
        var wa = env.invoke_viiiiiii;
        var xa = env.invoke_viiiiiid;
        var ya = env.invoke_viiiiiiiii;
        var za = env.invoke_viiiiiiiiii;
        var Aa = env.invoke_iii;
        var Ba = env.invoke_viiiiiiiiiiii;
        var Ca = env.invoke_iiiii;
        var Da = env.invoke_viii;
        var Ea = env.invoke_v;
        var Fa = env.invoke_iiiiiiiii;
        var Ga = env.invoke_viiii;
        var Ha = env._llvm_lifetime_end;
        var Ia = env.__scanString;
        var Ja = env._pthread_mutex_lock;
        var Ka = env.___cxa_end_catch;
        var La = env._strtoull;
        var Ma = env._fflush;
        var Na = env.__isLeapYear;
        var Oa = env._fwrite;
        var Pa = env._send;
        var Qa = env._pthread_mutex_init;
        var Ra = env._llvm_umul_with_overflow_i32;
        var Sa = env._isspace;
        var Ta = env._read;
        var Ua = env._isxdigit_l;
        var Va = env._fileno;
        var Wa = env.___cxa_guard_abort;
        var Xa = env._newlocale;
        var Ya = env.___gxx_personality_v0;
        var Za = env._pthread_cond_wait;
        var _a = env.___cxa_rethrow;
        var $a = env._fmod;
        var ab = env.___resumeException;
        var bb = env._llvm_va_end;
        var cb = env._vsscanf;
        var db = env._snprintf;
        var eb = env._fgetc;
        var fb = env.__getFloat;
        var gb = env._pthread_cond_signal;
        var hb = env.___cxa_free_exception;
        var ib = env._isdigit_l;
        var jb = env.___setErrNo;
        var kb = env._isxdigit;
        var lb = env._exit;
        var mb = env._sprintf;
        var nb = env._asprintf;
        var ob = env.___ctype_b_loc;
        var pb = env._freelocale;
        var qb = env._catgets;
        var rb = env.___cxa_is_number_type;
        var sb = env._llvm_uadd_with_overflow_i32;
        var tb = env.___cxa_does_inherit;
        var ub = env.___cxa_guard_acquire;
        var vb = env.___cxa_begin_catch;
        var wb = env._emscripten_memcpy_big;
        var xb = env._recv;
        var yb = env.__parseInt64;
        var zb = env.__ZSt18uncaught_exceptionv;
        var Ab = env.__ZNSt9exceptionD2Ev;
        var Bb = env._mkport;
        var Cb = env._copysign;
        var Db = env.__exit;
        var Eb = env._strftime;
        var Fb = env.___cxa_throw;
        var Gb = env._printf;
        var Hb = env._pread;
        var Ib = env._strtoull_l;
        var Jb = env.__arraySum;
        var Kb = env._sysconf;
        var Lb = env._strtoll_l;
        var Mb = env.___cxa_find_matching_catch;
        var Nb = env.__formatString;
        var Ob = env._pthread_cond_broadcast;
        var Pb = env.__ZSt9terminatev;
        var Qb = env._vfprintf;
        var Rb = env._pthread_mutex_unlock;
        var Sb = env.___cxa_call_unexpected;
        var Tb = env._sbrk;
        var Ub = env._atexit;
        var Vb = env.___errno_location;
        var Wb = env._strerror;
        var Xb = env._pthread_mutex_destroy;
        var Yb = env._catclose;
        var Zb = env._llvm_lifetime_start;
        var _b = env.___cxa_guard_release;
        var $b = env._ungetc;
        var ac = env._pthread_cond_destroy;
        var bc = env._uselocale;
        var cc = env._vsnprintf;
        var dc = env._sscanf;
        var ec = env.___assert_fail;
        var fc = env._fread;
        var gc = env._strftime_l;
        var hc = env._abort;
        var ic = env._fprintf;
        var jc = env._isdigit;
        var kc = env._strtoll;
        var lc = env.__addDays;
        var mc = env._fabs;
        var nc = env.__reallyNegative;
        var oc = env._write;
        var pc = env.___cxa_allocate_exception;
        var qc = env.___cxa_pure_virtual;
        var rc = env._vasprintf;
        var sc = env._catopen;
        var tc = env.___ctype_toupper_loc;
        var uc = env.___ctype_tolower_loc;
        var vc = env._pthread_join;
        var wc = env._pthread_cond_init;
        var xc = env._pwrite;
        var yc = env._strerror_r;
        var zc = env._pthread_create;
        var Ac = env._time;
        var Bc = 0.0;
        // EMSCRIPTEN_START_FUNCS
        function Xc(a) {
            a = a | 0;
            var b = 0;
            b = i;
            i = i + a | 0;
            i = i + 7 & -8;
            return b | 0
        }

        function Yc() { return i | 0 }

        function Zc(a) {
            a = a | 0;
            i = a
        }

        function _c(a, b) {
            a = a | 0;
            b = b | 0;
            if ((x | 0) == 0) {
                x = a;
                y = b
            }
        }

        function $c(b) {
            b = b | 0;
            a[k] = a[b];
            a[k + 1 | 0] = a[b + 1 | 0];
            a[k + 2 | 0] = a[b + 2 | 0];
            a[k + 3 | 0] = a[b + 3 | 0]
        }

        function ad(b) {
            b = b | 0;
            a[k] = a[b];
            a[k + 1 | 0] = a[b + 1 | 0];
            a[k + 2 | 0] = a[b + 2 | 0];
            a[k + 3 | 0] = a[b + 3 | 0];
            a[k + 4 | 0] = a[b + 4 | 0];
            a[k + 5 | 0] = a[b + 5 | 0];
            a[k + 6 | 0] = a[b + 6 | 0];
            a[k + 7 | 0] = a[b + 7 | 0]
        }

        function bd(a) {
            a = a | 0;
            K = a
        }

        function cd(a) {
            a = a | 0;
            L = a
        }

        function dd(a) {
            a = a | 0;
            M = a
        }

        function ed(a) {
            a = a | 0;
            N = a
        }

        function fd(a) {
            a = a | 0;
            O = a
        }

        function gd(a) {
            a = a | 0;
            P = a
        }

        function hd(a) {
            a = a | 0;
            Q = a
        }

        function id(a) {
            a = a | 0;
            R = a
        }

        function jd(a) {
            a = a | 0;
            S = a
        }

        function kd(a) {
            a = a | 0;
            T = a
        }

        function ld() {
            c[6380] = p + 8;
            c[6382] = s + 8;
            c[6384] = r;
            c[6386] = s + 8;
            c[6388] = r;
            c[6390] = s + 8;
            c[6392] = r;
            c[6394] = s + 8;
            c[6398] = s + 8;
            c[6400] = r;
            c[6402] = p + 8;
            c[6436] = s + 8;
            c[6440] = s + 8;
            c[6504] = s + 8;
            c[6508] = s + 8;
            c[6528] = p + 8;
            c[6530] = s + 8;
            c[6566] = s + 8;
            c[6570] = s + 8;
            c[6606] = s + 8;
            c[6610] = s + 8;
            c[6630] = p + 8;
            c[6632] = p + 8;
            c[6634] = s + 8;
            c[6638] = s + 8;
            c[6642] = s + 8;
            c[6646] = p + 8;
            c[6648] = p + 8;
            c[6650] = p + 8;
            c[6652] = p + 8;
            c[6654] = p + 8;
            c[6656] = p + 8;
            c[6658] = p + 8;
            c[6684] = s + 8;
            c[6688] = p + 8;
            c[6690] = s + 8;
            c[6694] = s + 8;
            c[6698] = s + 8;
            c[6702] = p + 8;
            c[6704] = p + 8;
            c[6706] = p + 8;
            c[6708] = p + 8;
            c[6742] = p + 8;
            c[6744] = p + 8;
            c[6746] = p + 8;
            c[6748] = s + 8;
            c[6752] = s + 8;
            c[6756] = s + 8;
            c[6760] = s + 8;
            c[6764] = s + 8;
            c[6768] = s + 8;
            c[6772] = s + 8;
            c[6776] = s + 8;
            c[6780] = s + 8;
            c[6784] = s + 8;
            c[6788] = s + 8;
            c[6798] = p + 8;
            c[6800] = p + 8
        }

        function md(a, b, e) {
            a = a | 0;
            b = b | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            f = a | 0;
            c[f >> 2] = b;
            g = a + 4 | 0;
            c[g >> 2] = e;
            h = a + 8 | 0;
            c[h >> 2] = 0;
            c[h + 4 >> 2] = 0;
            i = a + 16 | 0;
            c[i >> 2] = 0;
            a = 64;
            j = e;
            e = b;
            b = 0;
            k = 0;
            while (1) {
                if ((j | 0) == 0) {
                    l = a;
                    m = 4;
                    break
                }
                n = e + 1 | 0;
                c[f >> 2] = n;
                o = d[e] | 0;
                p = j - 1 | 0;
                c[g >> 2] = p;
                q = a - 8 | 0;
                r = jv(o | 0, 0, q | 0) | 0;
                o = r | k;
                r = K | b;
                c[h >> 2] = o;
                c[h + 4 >> 2] = r;
                if ((q | 0) > 7) {
                    a = q;
                    j = p;
                    e = n;
                    b = r;
                    k = o
                } else {
                    l = q;
                    m = 4;
                    break
                }
            }
            if ((m | 0) == 4) { c[i >> 2] = 64 - l; return }
        }

        function nd(a, b) {
            a = a | 0;
            b = b | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            e = a + 16 | 0;
            f = c[e >> 2] | 0;
            if ((f | 0) < (b | 0)) {
                g = 64 - f | 0;
                h = a + 4 | 0;
                a: do {
                    if ((g | 0) > 7) {
                        i = a | 0;
                        j = a + 8 | 0;
                        k = g;
                        l = c[h >> 2] | 0;
                        while (1) {
                            if ((l | 0) == 0) { m = k; break a }
                            n = c[i >> 2] | 0;
                            c[i >> 2] = n + 1;
                            o = d[n] | 0;
                            n = l - 1 | 0;
                            c[h >> 2] = n;
                            p = k - 8 | 0;
                            q = jv(o | 0, 0, p | 0) | 0;
                            o = K | c[j + 4 >> 2];
                            c[j >> 2] = q | c[j >> 2];
                            c[j + 4 >> 2] = o;
                            if ((p | 0) > 7) {
                                k = p;
                                l = n
                            } else { m = p; break }
                        }
                    } else { m = g }
                } while (0);
                g = 64 - m | 0;
                c[e >> 2] = g;
                r = g
            } else { r = f }
            f = a + 8 | 0;
            a = c[f >> 2] | 0;
            g = c[f + 4 >> 2] | 0;
            m = kv(a | 0, g | 0, 64 - b | 0) | 0;
            h = jv(a | 0, g | 0, b | 0) | 0;
            c[f >> 2] = h;
            c[f + 4 >> 2] = K;
            c[e >> 2] = r - b;
            return m | 0
        }

        function od(a, b) {
            a = a | 0;
            b = b | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            e = a + 16 | 0;
            f = c[e >> 2] | 0;
            if ((f | 0) < (b | 0)) {
                g = 64 - f | 0;
                h = a + 4 | 0;
                a: do {
                    if ((g | 0) > 7) {
                        i = a | 0;
                        j = a + 8 | 0;
                        k = g;
                        l = c[h >> 2] | 0;
                        while (1) {
                            if ((l | 0) == 0) { m = k; break a }
                            n = c[i >> 2] | 0;
                            c[i >> 2] = n + 1;
                            o = d[n] | 0;
                            n = l - 1 | 0;
                            c[h >> 2] = n;
                            p = k - 8 | 0;
                            q = jv(o | 0, 0, p | 0) | 0;
                            o = K | c[j + 4 >> 2];
                            c[j >> 2] = q | c[j >> 2];
                            c[j + 4 >> 2] = o;
                            if ((p | 0) > 7) {
                                k = p;
                                l = n
                            } else { m = p; break }
                        }
                    } else { m = g }
                } while (0);
                g = 64 - m | 0;
                c[e >> 2] = g;
                r = g
            } else { r = f }
            f = a + 8 | 0;
            a = jv(c[f >> 2] | 0, c[f + 4 >> 2] | 0, b | 0) | 0;
            c[f >> 2] = a;
            c[f + 4 >> 2] = K;
            c[e >> 2] = r - b;
            return
        }

        function pd(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0;
            b = a + 16 | 0;
            d = a + 8 | 0;
            e = (c[b >> 2] & -8 | 0) / 8 | 0;
            f = a | 0;
            c[f >> 2] = (c[f >> 2] | 0) + (-e | 0);
            f = a + 4 | 0;
            c[f >> 2] = (c[f >> 2] | 0) + e;
            c[d >> 2] = 0;
            c[d + 4 >> 2] = 0;
            c[b >> 2] = 0;
            return
        }

        function qd(a) {
            a = a | 0;
            var b = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0;
            b = a + 16 | 0;
            e = a + 4 | 0;
            f = a | 0;
            g = a + 8 | 0;
            a = 0;
            h = c[b >> 2] | 0;
            while (1) {
                if ((h | 0) < 1) {
                    i = 64 - h | 0;
                    a: do {
                        if ((i | 0) > 7) {
                            j = i;
                            k = c[e >> 2] | 0;
                            while (1) {
                                if ((k | 0) == 0) { l = j; break a }
                                m = c[f >> 2] | 0;
                                c[f >> 2] = m + 1;
                                n = d[m] | 0;
                                m = k - 1 | 0;
                                c[e >> 2] = m;
                                o = j - 8 | 0;
                                p = jv(n | 0, 0, o | 0) | 0;
                                n = K | c[g + 4 >> 2];
                                c[g >> 2] = p | c[g >> 2];
                                c[g + 4 >> 2] = n;
                                if ((o | 0) > 7) {
                                    j = o;
                                    k = m
                                } else { l = o; break }
                            }
                        } else { l = i }
                    } while (0);
                    i = 64 - l | 0;
                    c[b >> 2] = i;
                    q = i
                } else { q = h }
                i = c[g >> 2] | 0;
                k = c[g + 4 >> 2] | 0;
                r = i << 1 | 0 >>> 31;
                s = k << 1 | i >>> 31;
                c[g >> 2] = r;
                c[g + 4 >> 2] = s;
                t = q - 1 | 0;
                c[b >> 2] = t;
                j = -1;
                if (!((k | 0) > (j | 0) | (k | 0) == (j | 0) & i >>> 0 > -1 >>> 0)) { break }
                if ((a | 0) > 19) {
                    u = -99999;
                    v = 19;
                    break
                } else {
                    a = a + 1 | 0;
                    h = t
                }
            }
            if ((v | 0) == 19) { return u | 0 }
            if ((a | 0) == 0) { u = 0; return u | 0 }
            if ((q | 0) > (a | 0)) {
                w = t;
                x = s;
                y = r
            } else {
                t = 65 - q | 0;
                b: do {
                    if ((t | 0) > 7) {
                        q = t;
                        v = c[e >> 2] | 0;
                        h = s;
                        l = r;
                        while (1) {
                            if ((v | 0) == 0) {
                                z = q;
                                A = h;
                                B = l;
                                break b
                            }
                            i = c[f >> 2] | 0;
                            c[f >> 2] = i + 1;
                            j = d[i] | 0;
                            i = v - 1 | 0;
                            c[e >> 2] = i;
                            k = q - 8 | 0;
                            o = jv(j | 0, 0, k | 0) | 0;
                            j = o | l;
                            o = K | h;
                            c[g >> 2] = j;
                            c[g + 4 >> 2] = o;
                            if ((k | 0) > 7) {
                                q = k;
                                v = i;
                                h = o;
                                l = j
                            } else {
                                z = k;
                                A = o;
                                B = j;
                                break
                            }
                        }
                    } else {
                        z = t;
                        A = s;
                        B = r
                    }
                } while (0);
                r = 64 - z | 0;
                c[b >> 2] = r;
                w = r;
                x = A;
                y = B
            }
            B = kv(y | 0, x | 0, 64 - a | 0) | 0;
            A = jv(y | 0, x | 0, a | 0) | 0;
            c[g >> 2] = A;
            c[g + 4 >> 2] = K;
            c[b >> 2] = w - a;
            w = (1 << a) - 1 + B | 0;
            if ((w | 0) > 0) { u = w; return u | 0 } else { ec(12320, 15064, 146, 17992); return 0 }
            return 0
        }

        function rd(a) {
            a = a | 0;
            var b = 0,
                c = 0;
            b = qd(a) | 0;
            if ((b | 0) == (-99999 | 0)) { c = -99999 } else if ((b | 0) == 0) { c = 0 } else { c = (((b & 1 | 0) == 0 ? -b | 0 : b + 1 | 0) | 0) / 2 | 0 }
            return c | 0
        }

        function sd(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            if ((d | 0) > -1) {
                c[a >> 2] = b;
                c[a + 4 >> 2] = b;
                c[a + 8 >> 2] = b + d;
                return
            } else { ec(1440, 13952, 138, 18864) }
        }

        function td(a) {
            a = a | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            e = a + 4 | 0;
            f = c[e >> 2] | 0;
            g = (c[a + 8 >> 2] | 0) - f | 0;
            c[a + 12 >> 2] = 510;
            h = a + 20 | 0;
            b[h >> 1] = 8;
            i = a + 16 | 0;
            c[i >> 2] = 0;
            if ((g | 0) <= 0) { return }
            a = f + 1 | 0;
            c[e >> 2] = a;
            j = (d[f] | 0) << 8;
            c[i >> 2] = j;
            b[h >> 1] = 0;
            if ((g | 0) <= 1) { return }
            c[e >> 2] = f + 2;
            c[i >> 2] = j | (d[a] | 0);
            b[h >> 1] = -8;
            return
        }

        function ud(f, g) {
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            h = f + 12 | 0;
            i = c[h >> 2] | 0;
            j = g | 0;
            g = d[(i >>> 6) - 4 + (27288 + (((d[j] | 0) >>> 1 & 255) << 2)) | 0] | 0;
            k = i - g | 0;
            c[h >> 2] = k;
            i = k << 7;
            l = f + 16 | 0;
            m = c[l >> 2] | 0;
            if (m >>> 0 < i >>> 0) {
                n = a[j] | 0;
                o = n & 1;
                p = o & 255;
                a[j] = a[30416 + ((n & 255) >>> 1 & 255) | 0] << 1 | o;
                if (!(i >>> 0 < 32768 >>> 0)) { q = p; return q | 0 }
                c[h >> 2] = k << 1 & 67108862;
                k = c[l >> 2] << 1;
                c[l >> 2] = k;
                o = f + 20 | 0;
                n = (b[o >> 1] | 0) + 1 & 65535;
                b[o >> 1] = n;
                if (!(n << 16 >> 16 == 0)) { q = p; return q | 0 }
                b[o >> 1] = -8;
                o = f + 4 | 0;
                n = c[o >> 2] | 0;
                if (!(n >>> 0 < (c[f + 8 >> 2] | 0) >>> 0)) { q = p; return q | 0 }
                c[o >> 2] = n + 1;
                c[l >> 2] = k | (d[n] | 0);
                q = p;
                return q | 0
            } else {
                p = d[30736 + (g >>> 3) | 0] | 0;
                c[l >> 2] = m - i << p;
                c[h >> 2] = g << p;
                g = a[j] | 0;
                h = g & 1 ^ 1;
                if ((g & 255) >>> 0 < 2 >>> 0) {
                    i = h & 255 | g & -2;
                    a[j] = i;
                    r = i
                } else { r = g }
                a[j] = a[30480 + ((r & 255) >>> 1 & 255) | 0] << 1 | r & 1;
                r = f + 20 | 0;
                j = (e[r >> 1] | 0) + p & 65535;
                b[r >> 1] = j;
                if (!(j << 16 >> 16 > -1)) { q = h; return q | 0 }
                p = f + 4 | 0;
                g = c[p >> 2] | 0;
                if (g >>> 0 < (c[f + 8 >> 2] | 0) >>> 0) {
                    c[p >> 2] = g + 1;
                    c[l >> 2] = (d[g] | 0) << (j << 16 >> 16) | c[l >> 2]
                }
                b[r >> 1] = j - 8;
                q = h;
                return q | 0
            }
            return 0
        }

        function vd(a) {
            a = a | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            e = a + 12 | 0;
            f = (c[e >> 2] | 0) - 2 | 0;
            c[e >> 2] = f;
            g = f << 7;
            h = a + 16 | 0;
            i = c[h >> 2] | 0;
            if (!(i >>> 0 < g >>> 0)) { j = 1; return j | 0 }
            if (!(g >>> 0 < 32768 >>> 0)) { j = 0; return j | 0 }
            c[e >> 2] = f << 1 & 67108862;
            f = i << 1;
            c[h >> 2] = f;
            i = a + 20 | 0;
            e = (b[i >> 1] | 0) + 1 & 65535;
            b[i >> 1] = e;
            if (!(e << 16 >> 16 == 0)) { j = 0; return j | 0 }
            b[i >> 1] = -8;
            i = a + 4 | 0;
            e = c[i >> 2] | 0;
            if (!(e >>> 0 < (c[a + 8 >> 2] | 0) >>> 0)) { j = 0; return j | 0 }
            c[i >> 2] = e + 1;
            c[h >> 2] = f + (d[e] | 0);
            j = 0;
            return j | 0
        }

        function wd(a) {
            a = a | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            e = a + 16 | 0;
            f = c[e >> 2] << 1;
            c[e >> 2] = f;
            g = a + 20 | 0;
            h = (b[g >> 1] | 0) + 1 & 65535;
            b[g >> 1] = h;
            do {
                if (h << 16 >> 16 > -1) {
                    i = a + 4 | 0;
                    j = c[i >> 2] | 0;
                    if (!((c[a + 8 >> 2] | 0) >>> 0 > j >>> 0)) { k = f; break }
                    b[g >> 1] = -8;
                    c[i >> 2] = j + 1;
                    i = f | (d[j] | 0);
                    c[e >> 2] = i;
                    k = i
                } else { k = f }
            } while (0);
            f = c[a + 12 >> 2] << 7;
            if (k >>> 0 < f >>> 0) { l = 0; return l | 0 }
            c[e >> 2] = k - f;
            l = 1;
            return l | 0
        }

        function xd(a, e) {
            a = a | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            if ((e | 0) <= 0) { f = e; return f | 0 }
            g = a + 16 | 0;
            h = a + 20 | 0;
            i = a + 8 | 0;
            j = a + 4 | 0;
            k = a + 12 | 0;
            a = 0;
            l = c[g >> 2] | 0;
            m = b[h >> 1] | 0;
            while (1) {
                n = l << 1;
                c[g >> 2] = n;
                o = m + 1 & 65535;
                b[h >> 1] = o;
                do {
                    if (o << 16 >> 16 > -1) {
                        p = c[j >> 2] | 0;
                        if (!((c[i >> 2] | 0) >>> 0 > p >>> 0)) {
                            q = n;
                            r = o;
                            break
                        }
                        b[h >> 1] = -8;
                        c[j >> 2] = p + 1;
                        s = d[p] | 0 | n;
                        c[g >> 2] = s;
                        q = s;
                        r = -8
                    } else {
                        q = n;
                        r = o
                    }
                } while (0);
                o = c[k >> 2] << 7;
                if (q >>> 0 < o >>> 0) {
                    f = a;
                    t = 8;
                    break
                }
                n = q - o | 0;
                c[g >> 2] = n;
                o = a + 1 | 0;
                if ((o | 0) < (e | 0)) {
                    a = o;
                    l = n;
                    m = r
                } else {
                    f = e;
                    t = 8;
                    break
                }
            }
            if ((t | 0) == 8) { return f | 0 }
            return 0
        }

        function yd(a, f) {
            a = a | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            if ((f | 0) < 9) {
                if ((f | 0) == 0) { g = 0; return g | 0 }
                h = a + 16 | 0;
                i = c[h >> 2] << f;
                c[h >> 2] = i;
                j = a + 20 | 0;
                k = (e[j >> 1] | 0) + f & 65535;
                b[j >> 1] = k;
                do {
                    if (k << 16 >> 16 > -1) {
                        l = a + 4 | 0;
                        m = c[l >> 2] | 0;
                        if (!((c[a + 8 >> 2] | 0) >>> 0 > m >>> 0)) { n = i; break }
                        c[l >> 2] = m + 1;
                        l = (d[m] | 0) << (k << 16 >> 16);
                        b[j >> 1] = k - 8;
                        m = l | i;
                        c[h >> 2] = m;
                        n = m
                    } else { n = i }
                } while (0);
                i = c[a + 12 >> 2] << 7;
                k = (n >>> 0) / (i >>> 0) | 0;
                j = 1 << f;
                m = (k | 0) < (j | 0) ? k : j - 1 | 0;
                j = n - (ga(m, i) | 0) | 0;
                c[h >> 2] = j;
                g = m;
                return g | 0
            }
            m = a + 16 | 0;
            j = c[m >> 2] << 8;
            c[m >> 2] = j;
            h = a + 20 | 0;
            i = b[h >> 1] | 0;
            n = i + 8 & 65535;
            b[h >> 1] = n;
            do {
                if (n << 16 >> 16 > -1) {
                    k = a + 4 | 0;
                    l = c[k >> 2] | 0;
                    if (!((c[a + 8 >> 2] | 0) >>> 0 > l >>> 0)) {
                        o = j;
                        p = n;
                        break
                    }
                    c[k >> 2] = l + 1;
                    k = (d[l] | 0) << (n << 16 >> 16);
                    b[h >> 1] = i;
                    l = k | j;
                    c[m >> 2] = l;
                    o = l;
                    p = i
                } else {
                    o = j;
                    p = n
                }
            } while (0);
            n = c[a + 12 >> 2] << 7;
            j = (o >>> 0) / (n >>> 0) | 0;
            i = (j | 0) > 255 ? 255 : j;
            j = o - (ga(i, n) | 0) | 0;
            c[m >> 2] = j;
            o = f - 8 | 0;
            if ((o | 0) == 0) { g = i; return g | 0 }
            f = a + 8 | 0;
            l = a + 4 | 0;
            a = o;
            o = i;
            i = j;
            j = p;
            while (1) {
                p = a - 1 | 0;
                k = o << 1;
                q = i << 1;
                c[m >> 2] = q;
                r = j + 1 & 65535;
                b[h >> 1] = r;
                do {
                    if (r << 16 >> 16 > -1) {
                        s = c[l >> 2] | 0;
                        if (!((c[f >> 2] | 0) >>> 0 > s >>> 0)) {
                            t = q;
                            u = r;
                            break
                        }
                        b[h >> 1] = -8;
                        c[l >> 2] = s + 1;
                        v = d[s] | 0 | q;
                        c[m >> 2] = v;
                        t = v;
                        u = -8
                    } else {
                        t = q;
                        u = r
                    }
                } while (0);
                if (t >>> 0 < n >>> 0) {
                    w = 0;
                    x = t
                } else {
                    r = t - n | 0;
                    c[m >> 2] = r;
                    w = 1;
                    x = r
                }
                r = w | k;
                if ((p | 0) == 0) { g = r; break } else {
                    a = p;
                    o = r;
                    i = x;
                    j = u
                }
            }
            return g | 0
        }

        function zd(a, e) {
            a = a | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            f = a + 16 | 0;
            g = a + 20 | 0;
            h = a + 8 | 0;
            i = a + 4 | 0;
            j = a + 12 | 0;
            k = e + 31 | 0;
            l = 0;
            m = e;
            e = c[f >> 2] | 0;
            n = b[g >> 1] | 0;
            while (1) {
                o = e << 1;
                c[f >> 2] = o;
                p = n + 1 & 65535;
                b[g >> 1] = p;
                do {
                    if (p << 16 >> 16 > -1) {
                        q = c[i >> 2] | 0;
                        if (!((c[h >> 2] | 0) >>> 0 > q >>> 0)) {
                            r = o;
                            s = p;
                            break
                        }
                        b[g >> 1] = -8;
                        c[i >> 2] = q + 1;
                        t = d[q] | 0 | o;
                        c[f >> 2] = t;
                        r = t;
                        s = -8
                    } else {
                        r = o;
                        s = p
                    }
                } while (0);
                p = c[j >> 2] << 7;
                if (r >>> 0 < p >>> 0) { break }
                o = r - p | 0;
                c[f >> 2] = o;
                if ((m | 0) == (k | 0)) {
                    u = 0;
                    v = 8;
                    break
                } else {
                    l = l + (1 << m) | 0;
                    m = m + 1 | 0;
                    e = o;
                    n = s
                }
            }
            if ((v | 0) == 8) { return u | 0 }
            u = (yd(a, m) | 0) + l | 0;
            return u | 0
        }

        function Ad(a) {
            a = a | 0;
            vb(a | 0) | 0;
            Pb()
        }

        function Bd(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            k = i;
            i = i + 16 | 0;
            l = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[l >> 2];
            l = k | 0;
            m = d | 0;
            d = c[m >> 2] | 0;
            if ((d | 0) == 0) {
                c[b >> 2] = 0;
                i = k;
                return
            }
            n = g;
            g = e;
            o = n - g | 0;
            p = h + 12 | 0;
            h = c[p >> 2] | 0;
            q = (h | 0) > (o | 0) ? h - o | 0 : 0;
            o = f;
            h = o - g | 0;
            do {
                if ((h | 0) > 0) {
                    if ((Hc[c[(c[d >> 2] | 0) + 48 >> 2] & 63](d, e, h) | 0) == (h | 0)) { break }
                    c[m >> 2] = 0;
                    c[b >> 2] = 0;
                    i = k;
                    return
                }
            } while (0);
            do {
                if ((q | 0) > 0) {
                    if (q >>> 0 < 11 >>> 0) {
                        h = q << 1 & 255;
                        e = l;
                        a[e] = h;
                        r = l + 1 | 0;
                        s = h;
                        t = e
                    } else {
                        e = q + 16 & -16;
                        h = Nu(e) | 0;
                        c[l + 8 >> 2] = h;
                        g = e | 1;
                        c[l >> 2] = g;
                        c[l + 4 >> 2] = q;
                        r = h;
                        s = g & 255;
                        t = l
                    }
                    dv(r | 0, j | 0, q | 0) | 0;
                    a[r + q | 0] = 0;
                    if ((s & 1) == 0) { u = l + 1 | 0 } else { u = c[l + 8 >> 2] | 0 }
                    if ((Hc[c[(c[d >> 2] | 0) + 48 >> 2] & 63](d, u, q) | 0) == (q | 0)) {
                        if ((a[t] & 1) == 0) { break }
                        Pu(c[l + 8 >> 2] | 0);
                        break
                    }
                    c[m >> 2] = 0;
                    c[b >> 2] = 0;
                    if ((a[t] & 1) == 0) { i = k; return }
                    Pu(c[l + 8 >> 2] | 0);
                    i = k;
                    return
                }
            } while (0);
            l = n - o | 0;
            do {
                if ((l | 0) > 0) {
                    if ((Hc[c[(c[d >> 2] | 0) + 48 >> 2] & 63](d, f, l) | 0) == (l | 0)) { break }
                    c[m >> 2] = 0;
                    c[b >> 2] = 0;
                    i = k;
                    return
                }
            } while (0);
            c[p >> 2] = 0;
            c[b >> 2] = d;
            i = k;
            return
        }

        function Cd(a) {
            a = a | 0;
            c[a >> 2] = 0;
            c[a + 4 >> 2] = 0;
            return
        }

        function Dd(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0;
            e = i;
            if ((a[51944] | 0) != 0) {
                Gb(12840, (f = i, i = i + 16 | 0, c[f >> 2] = b, c[f + 8 >> 2] = d, f) | 0) | 0;
                i = f
            }
            f = c[d + 4 >> 2] | 0;
            if ((f | 0) != 0) { c[f >> 2] = (c[f >> 2] | 0) + 1 }
            c[b + 4 >> 2] = f;
            c[b >> 2] = c[d >> 2];
            i = e;
            return
        }

        function Ed(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0;
            d = i;
            if ((a[51944] | 0) != 0) {
                Gb(16064, (e = i, i = i + 8 | 0, c[e >> 2] = b, e) | 0) | 0;
                i = e
            }
            f = b + 4 | 0;
            g = c[f >> 2] | 0;
            if ((g | 0) == 0) { i = d; return }
            h = (c[g >> 2] | 0) - 1 | 0;
            c[g >> 2] = h;
            if ((h | 0) != 0) { i = d; return }
            h = b | 0;
            if ((a[51944] | 0) != 0) {
                Gb(13256, (e = i, i = i + 8 | 0, c[e >> 2] = c[h >> 2], e) | 0) | 0;
                i = e
            }
            e = c[h >> 2] | 0;
            if ((e | 0) != 0) { Qu(e | 0) }
            e = c[f >> 2] | 0;
            if ((e | 0) == 0) { i = d; return }
            Pu(e);
            i = d;
            return
        }

        function Fd(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0;
            f = i;
            if ((a[51944] | 0) != 0) {
                Gb(10456, (g = i, i = i + 8 | 0, c[g >> 2] = b, g) | 0) | 0;
                i = g
            }
            h = b + 4 | 0;
            j = c[h >> 2] | 0;
            do {
                if ((j | 0) != 0) {
                    k = c[j >> 2] | 0;
                    if ((k | 0) == 1) {
                        l = c[b >> 2] | 0;
                        Gd(l, d, e);
                        i = f;
                        return
                    }
                    if ((k | 0) > 1) { c[j >> 2] = k - 1; break } else { ec(608, 2464, 177, 17440) }
                }
            } while (0);
            if ((a[51944] | 0) != 0) {
                Gb(17056, (g = i, i = i + 8 | 0, c[g >> 2] = b, g) | 0) | 0;
                i = g
            }
            g = Ou(172) | 0;
            c[b >> 2] = g;
            b = Nu(4) | 0;
            c[h >> 2] = b;
            c[b >> 2] = 1;
            l = g;
            Gd(l, d, e);
            i = f;
            return
        }

        function Gd(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            do {
                if ((d | 0) > 0) {
                    f = d - 1 | 0;
                    Kd(e, b + 5 | 0, c[30216 + (f * 12 | 0) >> 2] | 0, 1);
                    Kd(e, b + 6 | 0, c[30220 + (f * 12 | 0) >> 2] | 0, 1);
                    Kd(e, b + 7 | 0, c[30224 + (f * 12 | 0) >> 2] | 0, 1);
                    Kd(e, b + 149 | 0, c[30152 + (f << 2) >> 2] | 0, 1);
                    Kd(e, b + 147 | 0, c[30240 + (f << 2) >> 2] | 0, 1);
                    Kd(e, b + 148 | 0, c[30336 + (f << 2) >> 2] | 0, 1);
                    Kd(e, b + 156 | 0, 95, 1);
                    Kd(e, b + 157 | 0, 79, 1);
                    Kd(e, b + 158 | 0, 63, 1);
                    Kd(e, b + 159 | 0, 31, 1);
                    Kd(e, b + 160 | 0, 31, 1);
                    Kd(e, b + 154 | 0, 153, 1);
                    Kd(e, b + 155 | 0, 153, 1);
                    f = (d | 0) == 1 ? 0 : 2;
                    Kd(e, b + 150 | 0, c[29904 + (f << 2) >> 2] | 0, 1);
                    Kd(e, b + 151 | 0, c[29904 + ((f | 1) << 2) >> 2] | 0, 1);
                    Kd(e, b + 152 | 0, 168, 1);
                    Kd(e, b + 153 | 0, 79, 1);
                    f = (e | 0) < 0;
                    do {
                        if (f) { g = 72 } else {
                            h = ((e * -5 | 0) >> 4) + 72 | 0;
                            i = (e | 0) < 52;
                            if ((h | 0) < 1 & i) { g = 1; break }
                            if ((h | 0) > 126 & i) { g = 126; break }
                            g = (e | 0) > 51 ? 56 : h
                        }
                    } while (0);
                    h = (g | 0) > 63;
                    i = h ? g + 64 | 0 : 63 - g | 0;
                    j = (i & 255) << 1 | h & 1;
                    h = b + 143 | 0;
                    if (!((i & 127) >>> 0 < 63 >>> 0)) {
                        a[h] = j;
                        ec(16144, 2464, 210, 17960)
                    }
                    dv(h | 0, j | 0, 2) | 0;
                    do {
                        if (f) { k = 72 } else {
                            j = ((e * -5 | 0) >> 4) + 72 | 0;
                            h = (e | 0) < 52;
                            if ((j | 0) < 1 & h) { k = 1; break }
                            if ((j | 0) > 126 & h) { k = 126; break }
                            k = (e | 0) > 51 ? 56 : j
                        }
                    } while (0);
                    f = (k | 0) > 63;
                    j = f ? k + 64 | 0 : 63 - k | 0;
                    h = (j & 255) << 1 | f & 1;
                    f = b + 145 | 0;
                    if ((j & 127) >>> 0 < 63 >>> 0) { dv(f | 0, h | 0, 2) | 0; break } else {
                        a[f] = h;
                        ec(16144, 2464, 210, 17960)
                    }
                }
            } while (0);
            Kd(e, b + 2 | 0, c[30160 + (d * 12 | 0) >> 2] | 0, 1);
            Kd(e, b + 3 | 0, c[30164 + (d * 12 | 0) >> 2] | 0, 1);
            Kd(e, b + 4 | 0, c[30168 + (d * 12 | 0) >> 2] | 0, 1);
            k = (d | 0) != 2 ? d : 5;
            Kd(e, b + 8 | 0, c[30296 + (k << 2) >> 2] | 0, 1);
            Kd(e, b + 9 | 0, c[30296 + (k + 1 << 2) >> 2] | 0, 1);
            Kd(e, b + 10 | 0, c[30296 + (k + 2 << 2) >> 2] | 0, 1);
            Kd(e, b + 11 | 0, c[30296 + (k + 3 << 2) >> 2] | 0, 1);
            Kd(e, b + 12 | 0, c[29352 + (d << 2) >> 2] | 0, 1);
            Kd(e, b + 13 | 0, c[29888 + (d << 2) >> 2] | 0, 1);
            k = (d | 0) == 0 ? 0 : 2;
            Kd(e, b + 14 | 0, c[30344 + (k << 2) >> 2] | 0, 1);
            Kd(e, b + 15 | 0, c[30344 + ((k | 1) << 2) >> 2] | 0, 1);
            k = d << 2;
            Kd(e, b + 16 | 0, c[30248 + (k << 2) >> 2] | 0, 1);
            g = k | 1;
            Kd(e, b + 17 | 0, c[30248 + (g << 2) >> 2] | 0, 1);
            h = k | 2;
            Kd(e, b + 18 | 0, c[30248 + (h << 2) >> 2] | 0, 1);
            f = k | 3;
            Kd(e, b + 19 | 0, c[30248 + (f << 2) >> 2] | 0, 1);
            j = d * 3 | 0;
            Kd(e, b + 20 | 0, c[29936 + (j << 2) >> 2] | 0, 1);
            Kd(e, b + 21 | 0, c[29936 + (j + 1 << 2) >> 2] | 0, 1);
            Kd(e, b + 22 | 0, c[29936 + (j + 2 << 2) >> 2] | 0, 1);
            j = d * 18 | 0;
            i = 0;
            while (1) {
                Kd(e, b + (i + 25) | 0, c[28736 + (i + j << 2) >> 2] | 0, 1);
                l = i + 1 | 0;
                if ((l | 0) < 18) { i = l } else { m = 0; break }
            }
            do {
                Kd(e, b + (m + 43) | 0, c[28736 + (m + j << 2) >> 2] | 0, 1);
                m = m + 1 | 0;
            } while ((m | 0) < 18);
            Kd(e, b + 61 | 0, c[29976 + (k << 2) >> 2] | 0, 1);
            Kd(e, b + 62 | 0, c[29976 + (g << 2) >> 2] | 0, 1);
            Kd(e, b + 63 | 0, c[29976 + (h << 2) >> 2] | 0, 1);
            Kd(e, b + 64 | 0, c[29976 + (f << 2) >> 2] | 0, 1);
            f = 0;
            do {
                Kd(e, b + (f + 65) | 0, c[29384 + (d * 168 | 0) + (f << 2) >> 2] | 0, 1);
                f = f + 1 | 0;
            } while ((f | 0) < 42);
            Kd(e, b + 107 | 0, c[28952 + (d << 3) >> 2] | 0, 1);
            Kd(e, b + 108 | 0, c[28956 + (d << 3) >> 2] | 0, 1);
            f = d * 24 | 0;
            h = 0;
            do {
                Kd(e, b + (h + 109) | 0, c[29048 + (h + f << 2) >> 2] | 0, 1);
                h = h + 1 | 0;
            } while ((h | 0) < 24);
            h = d * 6 | 0;
            Kd(e, b + 133 | 0, c[28976 + (h << 2) >> 2] | 0, 1);
            Kd(e, b + 134 | 0, c[28976 + ((h | 1) << 2) >> 2] | 0, 1);
            Kd(e, b + 135 | 0, c[28976 + (h + 2 << 2) >> 2] | 0, 1);
            Kd(e, b + 136 | 0, c[28976 + (h + 3 << 2) >> 2] | 0, 1);
            Kd(e, b + 137 | 0, c[28976 + (h + 4 << 2) >> 2] | 0, 1);
            Kd(e, b + 138 | 0, c[28976 + (h + 5 << 2) >> 2] | 0, 1);
            Kd(e, b, c[29920 + (d << 2) >> 2] | 0, 1);
            Kd(e, b + 1 | 0, c[29336 + (d << 2) >> 2] | 0, 1);
            Kd(e, b + 139 | 0, 154, 1);
            Kd(e, b + 140 | 0, 154, 1);
            Kd(e, b + 141 | 0, 139, 1);
            Kd(e, b + 142 | 0, 139, 1);
            Kd(e, b + 161 | 0, c[29368 + (d << 2) >> 2] | 0, 1);
            a[b + 23 | 0] = 1;
            a[b + 24 | 0] = 1;
            dv(b + 162 | 0, 1, 10) | 0;
            return
        }

        function Hd(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0;
            d = i;
            e = b + 4 | 0;
            if ((a[51944] | 0) != 0) {
                f = c[e >> 2] | 0;
                Gb(7336, (g = i, i = i + 16 | 0, c[g >> 2] = b, c[g + 8 >> 2] = f, g) | 0) | 0;
                i = g
            }
            g = c[e >> 2] | 0;
            if ((g | 0) == 0) { i = d; return }
            c[g >> 2] = (c[g >> 2] | 0) - 1;
            c[b >> 2] = 0;
            c[e >> 2] = 0;
            i = d;
            return
        }

        function Id(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0;
            d = i;
            e = b + 4 | 0;
            if ((a[51944] | 0) != 0) {
                f = c[e >> 2] | 0;
                Gb(5320, (g = i, i = i + 16 | 0, c[g >> 2] = b, c[g + 8 >> 2] = f, g) | 0) | 0;
                i = g
            }
            g = c[e >> 2] | 0;
            if ((g | 0) == 0) { ec(3784, 2464, 95, 17424) }
            f = c[g >> 2] | 0;
            if ((f | 0) <= 1) { i = d; return }
            c[g >> 2] = f - 1;
            f = b | 0;
            b = c[f >> 2] | 0;
            g = Ou(172) | 0;
            c[f >> 2] = g;
            f = Nu(4) | 0;
            c[e >> 2] = f;
            c[f >> 2] = 1;
            cv(g | 0, b | 0, 172) | 0;
            i = d;
            return
        }

        function Jd(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0;
            e = i;
            if ((a[51944] | 0) != 0) {
                Gb(1288, (f = i, i = i + 16 | 0, c[f >> 2] = b, c[f + 8 >> 2] = d, f) | 0) | 0;
                i = f
            }
            g = d + 4 | 0;
            h = c[g >> 2] | 0;
            if ((h | 0) == 0) {
                j = b + 4 | 0;
                if ((a[51944] | 0) != 0) {
                    k = c[j >> 2] | 0;
                    Gb(7336, (f = i, i = i + 16 | 0, c[f >> 2] = b, c[f + 8 >> 2] = k, f) | 0) | 0;
                    i = f
                }
                k = c[j >> 2] | 0;
                if ((k | 0) == 0) { i = e; return b | 0 }
                c[k >> 2] = (c[k >> 2] | 0) - 1;
                c[b >> 2] = 0;
                c[j >> 2] = 0;
                i = e;
                return b | 0
            }
            c[h >> 2] = (c[h >> 2] | 0) + 1;
            h = b + 4 | 0;
            if ((a[51944] | 0) != 0) {
                j = c[h >> 2] | 0;
                Gb(7336, (f = i, i = i + 16 | 0, c[f >> 2] = b, c[f + 8 >> 2] = j, f) | 0) | 0;
                i = f
            }
            f = c[h >> 2] | 0;
            if ((f | 0) == 0) { l = b | 0 } else {
                c[f >> 2] = (c[f >> 2] | 0) - 1;
                f = b | 0;
                c[f >> 2] = 0;
                c[h >> 2] = 0;
                l = f
            }
            c[l >> 2] = c[d >> 2];
            c[h >> 2] = c[g >> 2];
            i = e;
            return b | 0
        }

        function Kd(b, c, d, e) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            f = ((d >> 4) * 5 | 0) - 45 | 0;
            g = (d << 3 & 120) - 16 | 0;
            d = (b | 0) < 0;
            if (d) { h = 0 } else { h = (b | 0) > 51 ? 51 : b }
            do {
                if ((((ga(h, f) | 0) >> 4) + g | 0) < 1) { i = 1 } else {
                    if (d) { j = 0 } else { j = (b | 0) > 51 ? 51 : b }
                    if ((((ga(j, f) | 0) >> 4) + g | 0) > 126) { i = 126; break }
                    if (d) { k = 0 } else { k = (b | 0) > 51 ? 51 : b }
                    i = ((ga(k, f) | 0) >> 4) + g | 0
                }
            } while (0);
            if ((e | 0) <= 0) { return }
            g = (i | 0) > 63;
            f = g ? i + 64 | 0 : 63 - i | 0;
            i = (f & 255) << 1 | g & 1;
            if ((f & 127) >>> 0 < 63 >>> 0) { l = 0 } else {
                a[c | 0] = i;
                ec(16144, 2464, 210, 17960)
            }
            do {
                a[c + l | 0] = i;
                l = l + 1 | 0;
            } while ((l | 0) < (e | 0));
            return
        }

        function Ld() { return 8320 }

        function Md() { return 16777728 }

        function Nd(a) {
            a = a | 0;
            var b = 0;
            switch (a | 0) {
                case 1006:
                    { b = 12544; break };
                case 1007:
                    { b = 12168; break };
                case 1008:
                    { b = 12008; break };
                case 1009:
                    { b = 11632; break };
                case 15:
                    { b = 14960; break };
                case 1015:
                    { b = 9944; break };
                case 1016:
                    { b = 9600; break };
                case 1017:
                    { b = 9176; break };
                case 1018:
                    { b = 8704; break };
                case 1019:
                    { b = 8520; break };
                case 502:
                    { b = 16032; break };
                case 1004:
                    { b = 13016; break };
                case 1005:
                    { b = 12752; break };
                case 1002:
                    { b = 13432; break };
                case 1003:
                    { b = 13224; break };
                case 11:
                    { b = 16968; break };
                case 1:
                    { b = 12824; break };
                case 4:
                    { b = 9888; break };
                case 17:
                    { b = 14400; break };
                case 18:
                    { b = 14136; break };
                case 1020:
                    { b = 8200; break };
                case 1021:
                    { b = 8032; break };
                case 1022:
                    { b = 7776; break };
                case 1023:
                    { b = 7480; break };
                case 1024:
                    { b = 7200; break };
                case 1025:
                    { b = 6920; break };
                case 1026:
                    { b = 6616; break };
                case 0:
                    { b = 15416; break };
                case 1e3:
                    { b = 13832; break };
                case 1001:
                    { b = 13632; break };
                case 16:
                    { b = 14672; break };
                case 1010:
                    { b = 11360; break };
                case 1011:
                    { b = 11088; break };
                case 1012:
                    { b = 10848; break };
                case 1013:
                    { b = 10576; break };
                case 1014:
                    { b = 10280; break };
                case 12:
                    { b = 16376; break };
                case 13:
                    { b = 15616; break };
                case 14:
                    { b = 15272; break };
                case 8:
                    { b = 2272; break };
                case 7:
                    { b = 3576; break };
                case 5:
                    { b = 6896; break };
                case 6:
                    { b = 5048; break };
                case 9:
                    { b = 1176; break };
                case 10:
                    { b = 496; break };
                default:
                    { b = 6440 }
            }
            return b | 0
        }

        function Od(a) { a = a | 0; var b = 0; if ((a | 0) == 0) { b = 1 } else { b = (a | 0) > 999 | 0 } return b | 0 }

        function Pd() {
            var a = 0,
                b = 0;
            do {
                if (((I = c[12984] | 0, c[12984] = I + 1, I) + 1 | 0) <= 1) {
                    Ej();
                    if (Mj() | 0) { break }
                    I = c[12984] | 0, c[12984] = I - 1, I;
                    a = 0;
                    return a | 0
                }
            } while (0);
            b = Nu(377228) | 0;
            Le(b);
            if ((b | 0) != 0) { a = b; return a | 0 }
            b = (I = c[12984] | 0, c[12984] = I - 1, I) - 1 | 0;
            if ((b | 0) < 0) {
                I = c[12984] | 0, c[12984] = I + 1, I;
                a = 0;
                return a | 0
            }
            if ((b | 0) != 0) { a = 0; return a | 0 }
            Nj();
            a = 0;
            return a | 0
        }

        function Qd(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = a;
            Oe(b);
            if ((a | 0) != 0) { Dc[c[(c[a >> 2] | 0) + 4 >> 2] & 511](b) }
            b = (I = c[12984] | 0, c[12984] = I - 1, I) - 1 | 0;
            if ((b | 0) < 0) {
                I = c[12984] | 0, c[12984] = I + 1, I;
                d = 12;
                return d | 0
            }
            if ((b | 0) != 0) { d = 0; return d | 0 }
            Nj();
            d = 0;
            return d | 0
        }

        function Rd(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            return Xi(a + 548 | 0, b, c, d, e, f) | 0
        }

        function Sd(b) {
            b = b | 0;
            var c = 0;
            c = b + 548 | 0;
            b = c;
            Zi(b) | 0;
            Zi(b) | 0;
            a[c] = 1;
            return 0
        }

        function Td(a, b) {
            a = a | 0;
            b = b | 0;
            return cf(a, b) | 0
        }

        function Ud(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            return Yi(a + 548 | 0, b, c, d, e, f) | 0
        }

        function Vd(a) {
            a = a | 0;
            Zi(a + 548 | 0) | 0;
            return
        }

        function Wd(b) {
            b = b | 0;
            Zi(b + 548 | 0) | 0;
            a[b + 549 | 0] = 1;
            return
        }

        function Xd(a) {
            a = a | 0;
            Pe(a);
            return
        }

        function Yd(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0;
            if ((c[b + 376196 >> 2] | 0) <= 0) { d = 0; return d | 0 }
            e = c[b + 376192 >> 2] | 0;
            f = c[(c[(c[b + 376180 >> 2] | 0) + (e >>> 10 << 2) >> 2] | 0) + ((e & 1023) << 2) >> 2] | 0;
            if ((f | 0) == 0) { d = 0; return d | 0 }
            a[f + 100 | 0] = 0;
            Dh(b + 376144 | 0);
            d = f;
            return d | 0
        }

        function Zd(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            if ((c[a + 376196 >> 2] | 0) <= 0) { b = 0; return b | 0 }
            d = c[a + 376192 >> 2] | 0;
            b = c[(c[(c[a + 376180 >> 2] | 0) + (d >>> 10 << 2) >> 2] | 0) + ((d & 1023) << 2) >> 2] | 0;
            return b | 0
        }

        function _d(b) {
            b = b | 0;
            var d = 0;
            if ((c[b + 376196 >> 2] | 0) == 0) { return }
            d = c[b + 376192 >> 2] | 0;
            a[(c[(c[(c[b + 376180 >> 2] | 0) + (d >>> 10 << 2) >> 2] | 0) + ((d & 1023) << 2) >> 2] | 0) + 100 | 0] = 0;
            Dh(b + 376144 | 0);
            return
        }

        function $d(a) { a = a | 0; return jf(a) | 0 }

        function ae(a) { a = a | 0; return c[a + 375908 >> 2] | 0 }

        function be(a, b) {
            a = a | 0;
            b = b | 0;
            kf(a, b);
            return
        }

        function ce(a, b) {
            a = a | 0;
            b = b | 0;
            mf(a, b);
            return
        }

        function de(a, b) {
            a = a | 0;
            b = b | 0;
            return lf(a, b) | 0
        }

        function ee(a) { a = a | 0; return nf(a + 4 | 0) | 0 }

        function fe(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((c | 0) == 8) { a[b + 533 | 0] = (d | 0) != 0 | 0; return } else if ((c | 0) == 7) { a[b + 532 | 0] = (d | 0) != 0 | 0; return } else if ((c | 0) == 6) { a[b + 514 | 0] = (d | 0) != 0 | 0; return } else if ((c | 0) == 0) { a[b + 512 | 0] = (d | 0) != 0 | 0; return } else { ec(6320, 6192, 503, 17144) }
        }

        function ge(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            switch (b | 0) {
                case 4:
                    { c[a + 528 >> 2] = d; return };
                case 5:
                    { Ke(a, d); return };
                case 1:
                    { c[a + 516 >> 2] = d; return };
                case 2:
                    { c[a + 520 >> 2] = d; return };
                case 3:
                    { c[a + 524 >> 2] = d; return };
                default:
                    { ec(6320, 6192, 536, 17120) }
            }
        }

        function he(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            if ((b | 0) == 8) { c = a + 533 | 0 } else if ((b | 0) == 7) { c = a + 532 | 0 } else if ((b | 0) == 0) { c = a + 512 | 0 } else if ((b | 0) == 6) { c = a + 514 | 0 } else { ec(6320, 6192, 571, 17176); return 0 }
            return d[c] | 0 | 0
        }

        function ie(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            b = c[a + 584 >> 2] | 0;
            d = c[a + 556 >> 2] | 0;
            if ((d | 0) == 0) { e = b; return e | 0 }
            e = (c[d + 24 >> 2] | 0) + b | 0;
            return e | 0
        }

        function je(a) { a = a | 0; return ((c[a + 556 >> 2] | 0) != 0) + (c[a + 580 >> 2] | 0) | 0 }

        function ke(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if ((b | 0) == 1 | (b | 0) == 2) { d = c[a + 80 >> 2] | 0 } else if ((b | 0) == 0) { d = c[a + 72 >> 2] | 0 } else { d = 0 }
            return d | 0
        }

        function le(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if ((b | 0) == 0) { d = c[a + 76 >> 2] | 0 } else if ((b | 0) == 1 | (b | 0) == 2) { d = c[a + 84 >> 2] | 0 } else { d = 0 }
            return d | 0
        }

        function me(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if ((b | 0) == 1 | (b | 0) == 2) { d = c[a + 5768 >> 2] | 0 } else if ((b | 0) == 0) { d = c[a + 5760 >> 2] | 0 } else { d = 0 }
            return d | 0
        }

        function ne(a) { a = a | 0; return c[a + 20 >> 2] | 0 }

        function oe(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            if (!(b >>> 0 < 3 >>> 0)) { ec(5944, 6192, 639, 17240); return 0 }
            e = c[a + 60 + (b << 2) >> 2] | 0;
            if ((d | 0) == 0) { return e | 0 }
            f = c[((b | 0) == 0 ? a + 40 | 0 : a + 44 | 0) >> 2] | 0;
            if ((b | 0) == 1 | (b | 0) == 2) { g = c[a + 5768 >> 2] | 0 } else if ((b | 0) == 0) { g = c[a + 5760 >> 2] | 0 } else { g = 0 }
            a = ga((g + 7 | 0) / 8 | 0, f) | 0;
            c[d >> 2] = a;
            return e | 0
        }

        function pe(a, b) {
            a = a | 0;
            b = b | 0;
            if (b >>> 0 < 3 >>> 0) { return c[a + 10492 + (b << 2) >> 2] | 0 } else { ec(5944, 6192, 650, 17208); return 0 }
            return 0
        }

        function qe(a) {
            a = a | 0;
            var b = 0;
            b = a + 10480 | 0;
            return (K = c[b + 4 >> 2] | 0, c[b >> 2] | 0) | 0
        }

        function re(a) { a = a | 0; return c[a + 10488 >> 2] | 0 }

        function se(a, b) {
            a = a | 0;
            b = b | 0;
            c[a + 10488 >> 2] = b;
            return
        }

        function te(b, e, f, g, h, i, j) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            k = b + 10448 | 0;
            l = c[k >> 2] | 0;
            m = e >> l;
            if (!((m | 0) > -1)) { ec(8880, 6264, 118, 17352) }
            n = b + 10452 | 0;
            o = b + 10456 | 0;
            p = b + 10440 | 0;
            q = e;
            e = f;
            r = g;
            g = h;
            h = i;
            i = j;
            j = m;
            m = f >> l;
            while (1) {
                l = c[n >> 2] | 0;
                if ((j | 0) >= (l | 0)) { s = 4; break }
                if (!((m | 0) > -1)) { s = 7; break }
                if ((m | 0) >= (c[o >> 2] | 0)) { s = 7; break }
                f = (ga(l, m) | 0) + j | 0;
                t = 1 << r;
                if (((d[(c[p >> 2] | 0) + f | 0] | 0) & 1 << g | 0) == 0) { s = 9; break }
                f = t >> 1;
                l = f + q | 0;
                u = f + e | 0;
                f = r - 1 | 0;
                v = g + 1 | 0;
                te(b, q, e, f, v, h, i);
                te(b, l, e, f, v, 16, i);
                te(b, q, u, f, v, h, 32);
                w = c[k >> 2] | 0;
                x = l >> w;
                if ((x | 0) > -1) {
                    q = l;
                    e = u;
                    r = f;
                    g = v;
                    h = 16;
                    i = 32;
                    j = x;
                    m = u >> w
                } else { s = 4; break }
            }
            if ((s | 0) == 4) { ec(8880, 6264, 118, 17352) } else if ((s | 0) == 7) { ec(4520, 6264, 119, 17352) } else if ((s | 0) == 9) {
                s = (t | 0) > 0;
                if (!s) { return }
                m = h & 255;
                h = (q | 0) / 4 | 0;
                j = b + 10472 | 0;
                g = b + 10476 | 0;
                r = b + 10460 | 0;
                k = 0;
                do {
                    p = (k + e | 0) / 4 | 0;
                    o = c[j >> 2] | 0;
                    do {
                        if ((h | 0) < (o | 0)) {
                            if ((p | 0) >= (c[g >> 2] | 0)) { break }
                            n = (ga(o, p) | 0) + h | 0;
                            w = (c[r >> 2] | 0) + n | 0;
                            a[w] = a[w] | m
                        }
                    } while (0);
                    k = k + 4 | 0;
                } while ((k | 0) < (t | 0));
                if (!s) { return }
                s = i & 255;
                i = (e | 0) / 4 | 0;
                e = b + 10472 | 0;
                k = b + 10476 | 0;
                m = b + 10460 | 0;
                b = 0;
                do {
                    r = (b + q | 0) / 4 | 0;
                    h = c[e >> 2] | 0;
                    do {
                        if ((r | 0) < (h | 0)) {
                            if ((i | 0) >= (c[k >> 2] | 0)) { break }
                            g = (ga(h, i) | 0) + r | 0;
                            j = (c[m >> 2] | 0) + g | 0;
                            a[j] = a[j] | s
                        }
                    } while (0);
                    b = b + 4 | 0;
                } while ((b | 0) < (t | 0));
                return
            }
        }

        function ue(b, e, f, g, h, i) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            i = c[b + 10368 >> 2] | 0;
            h = e >> i;
            j = f >> i;
            if (!((h | 0) > -1)) { ec(8880, 6264, 118, 17352) }
            i = c[b + 10372 >> 2] | 0;
            if ((h | 0) >= (i | 0)) { ec(8880, 6264, 118, 17352) }
            if (!((j | 0) > -1)) { ec(4520, 6264, 119, 17352) }
            if ((j | 0) >= (c[b + 10376 >> 2] | 0)) { ec(4520, 6264, 119, 17352) }
            k = (ga(i, j) | 0) + h | 0;
            h = (c[b + 10360 >> 2] | 0) + (k * 3 | 0) | 0;
            k = 1 << g;
            j = 1 << g - 1;
            i = 1 << g - 2;
            switch (((d[h] | d[h + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 3 & 255 & 7 | 0) {
                case 2:
                    {
                        if ((k | 0) <= 0) { return }
                        h = (j + e | 0) / 4 | 0;g = b + 10472 | 0;l = b + 10476 | 0;m = b + 10460 | 0;n = 0;do {
                            o = (n + f | 0) / 4 | 0;
                            p = c[g >> 2] | 0;
                            do {
                                if ((h | 0) < (p | 0)) {
                                    if ((o | 0) >= (c[l >> 2] | 0)) { break }
                                    q = (ga(p, o) | 0) + h | 0;
                                    r = (c[m >> 2] | 0) + q | 0;
                                    a[r] = a[r] | 64
                                }
                            } while (0);
                            n = n + 1 | 0;
                        } while ((n | 0) < (k | 0));
                        return
                    };
                case 3:
                    {
                        if ((k | 0) <= 0) { return }
                        n = (j + e | 0) / 4 | 0;m = b + 10472 | 0;h = b + 10476 | 0;l = b + 10460 | 0;g = (j + f | 0) / 4 | 0;o = 0;do {
                            p = (o + f | 0) / 4 | 0;
                            r = c[m >> 2] | 0;
                            do {
                                if ((n | 0) < (r | 0)) {
                                    if ((p | 0) >= (c[h >> 2] | 0)) { s = r; break }
                                    q = (ga(r, p) | 0) + n | 0;
                                    t = (c[l >> 2] | 0) + q | 0;
                                    a[t] = a[t] | 64;
                                    s = c[m >> 2] | 0
                                } else { s = r }
                            } while (0);
                            r = (o + e | 0) / 4 | 0;
                            do {
                                if ((r | 0) < (s | 0)) {
                                    if ((g | 0) >= (c[h >> 2] | 0)) { break }
                                    p = (ga(s, g) | 0) + r | 0;
                                    t = (c[l >> 2] | 0) + p | 0;
                                    a[t] = a[t] | -128
                                }
                            } while (0);
                            o = o + 1 | 0;
                        } while ((o | 0) < (k | 0));
                        return
                    };
                case 6:
                    {
                        if ((k | 0) <= 0) { return }
                        o = (i + e | 0) / 4 | 0;l = b + 10472 | 0;g = b + 10476 | 0;s = b + 10460 | 0;h = 0;do {
                            m = (h + f | 0) / 4 | 0;
                            n = c[l >> 2] | 0;
                            do {
                                if ((o | 0) < (n | 0)) {
                                    if ((m | 0) >= (c[g >> 2] | 0)) { break }
                                    r = (ga(n, m) | 0) + o | 0;
                                    t = (c[s >> 2] | 0) + r | 0;
                                    a[t] = a[t] | 64
                                }
                            } while (0);
                            h = h + 1 | 0;
                        } while ((h | 0) < (k | 0));
                        return
                    };
                case 4:
                    {
                        if ((k | 0) <= 0) { return }
                        h = (i + f | 0) / 4 | 0;s = b + 10472 | 0;o = b + 10476 | 0;g = b + 10460 | 0;l = 0;do {
                            m = (l + e | 0) / 4 | 0;
                            n = c[s >> 2] | 0;
                            do {
                                if ((m | 0) < (n | 0)) {
                                    if ((h | 0) >= (c[o >> 2] | 0)) { break }
                                    t = (ga(n, h) | 0) + m | 0;
                                    r = (c[g >> 2] | 0) + t | 0;
                                    a[r] = a[r] | -128
                                }
                            } while (0);
                            l = l + 1 | 0;
                        } while ((l | 0) < (k | 0));
                        return
                    };
                case 7:
                    {
                        if ((k | 0) <= 0) { return }
                        l = (j + e + i | 0) / 4 | 0;g = b + 10472 | 0;h = b + 10476 | 0;o = b + 10460 | 0;s = 0;do {
                            m = (s + f | 0) / 4 | 0;
                            n = c[g >> 2] | 0;
                            do {
                                if ((l | 0) < (n | 0)) {
                                    if ((m | 0) >= (c[h >> 2] | 0)) { break }
                                    r = (ga(n, m) | 0) + l | 0;
                                    t = (c[o >> 2] | 0) + r | 0;
                                    a[t] = a[t] | 64
                                }
                            } while (0);
                            s = s + 1 | 0;
                        } while ((s | 0) < (k | 0));
                        return
                    };
                case 1:
                    {
                        if ((k | 0) <= 0) { return }
                        s = (j + f | 0) / 4 | 0;o = b + 10472 | 0;l = b + 10476 | 0;h = b + 10460 | 0;g = 0;do {
                            m = (g + e | 0) / 4 | 0;
                            n = c[o >> 2] | 0;
                            do {
                                if ((m | 0) < (n | 0)) {
                                    if ((s | 0) >= (c[l >> 2] | 0)) { break }
                                    t = (ga(n, s) | 0) + m | 0;
                                    r = (c[h >> 2] | 0) + t | 0;
                                    a[r] = a[r] | -128
                                }
                            } while (0);
                            g = g + 1 | 0;
                        } while ((g | 0) < (k | 0));
                        return
                    };
                case 5:
                    {
                        if ((k | 0) <= 0) { return }
                        g = (j + f + i | 0) / 4 | 0;i = b + 10472 | 0;f = b + 10476 | 0;j = b + 10460 | 0;b = 0;do {
                            h = (b + e | 0) / 4 | 0;
                            s = c[i >> 2] | 0;
                            do {
                                if ((h | 0) < (s | 0)) {
                                    if ((g | 0) >= (c[f >> 2] | 0)) { break }
                                    l = (ga(s, g) | 0) + h | 0;
                                    o = (c[j >> 2] | 0) + l | 0;
                                    a[o] = a[o] | -128
                                }
                            } while (0);
                            b = b + 1 | 0;
                        } while ((b | 0) < (k | 0));
                        return
                    };
                default:
                    { return }
            }
        }

        function ve(b, f) {
            b = b | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0;
            g = c[b + 5808 >> 2] | 0;
            h = c[b + 5804 >> 2] | 0;
            i = (1 << h) - 1 | 0;
            j = c[b + 5820 >> 2] | 0;
            k = c[b + 5800 >> 2] | 0;
            l = f << h >> k;
            m = f + 1 << h >> k;
            k = c[b + 5824 >> 2] | 0;
            f = (k | 0) < (m | 0) ? k : m;
            if ((l | 0) >= (f | 0)) { n = 0; return n | 0 }
            m = b + 5816 | 0;
            k = b + 10372 | 0;
            o = b + 10360 | 0;
            p = b + 10348 | 0;
            q = b + 10352 | 0;
            r = b + 10356 | 0;
            s = b + 10340 | 0;
            t = b + 52 | 0;
            u = b + 48 | 0;
            v = b + 5977 | 0;
            w = b + 10308 | 0;
            x = l;
            l = 0;
            y = c[m >> 2] | 0;
            a: while (1) {
                if ((y | 0) > 0) {
                    z = ga(x, g) | 0;
                    A = (z | 0) == 0;
                    B = A ? 0 : 32;
                    C = z & i;
                    D = z - 1 | 0;
                    E = ga(z >> h, j) | 0;
                    F = ga(D >> h, j) | 0;
                    G = 0;
                    H = l;
                    I = y;
                    while (1) {
                        J = (ga(c[k >> 2] | 0, x) | 0) + G | 0;
                        K = (c[o >> 2] | 0) + (J * 3 | 0) | 0;
                        J = (d[K] | d[K + 1 | 0] << 8) << 16 >> 16 & 7;
                        K = J & 255;
                        do {
                            if (J << 24 >> 24 == 0) {
                                L = H;
                                M = I
                            } else {
                                N = ga(G, g) | 0;
                                O = N >> h;
                                P = c[p >> 2] | 0;
                                Q = N >> P;
                                R = z >> P;
                                if (!((Q | 0) > -1)) { S = 8; break a }
                                T = c[q >> 2] | 0;
                                if ((Q | 0) >= (T | 0)) { S = 8; break a }
                                if (!((R | 0) > -1)) { S = 11; break a }
                                U = c[r >> 2] | 0;
                                if ((R | 0) >= (U | 0)) { S = 11; break a }
                                V = ga(T, R) | 0;
                                R = c[s >> 2] | 0;
                                W = e[R + ((V + Q | 0) * 24 | 0) + 2 >> 1] | 0;
                                X = c[u >> 2] | 0;
                                Y = (c[t >> 2] | 0) - X >> 2;
                                if (!(W >>> 0 < Y >>> 0)) {
                                    n = 0;
                                    S = 34;
                                    break a
                                }
                                Z = c[X + (W << 2) >> 2] | 0;
                                W = (N | 0) == 0;
                                _ = W ? 0 : 16;
                                b: do {
                                    if (W) { $ = _ } else {
                                        if ((N & i | 0) != 0) { $ = _; break }
                                        do {
                                            if ((a[Z + 764 | 0] | 0) == 0) {
                                                aa = N - 1 >> P;
                                                if (!((aa | 0) > -1 & (aa | 0) < (T | 0))) { S = 17; break a }
                                                ba = e[R + ((V + aa | 0) * 24 | 0) + 2 >> 1] | 0;
                                                if (!(ba >>> 0 < Y >>> 0)) { break }
                                                if ((c[Z + 800 >> 2] | 0) != (c[(c[X + (ba << 2) >> 2] | 0) + 800 >> 2] | 0)) { $ = 0; break b }
                                            }
                                        } while (0);
                                        if ((a[v] | 0) != 0) { $ = _; break }
                                        ba = c[w >> 2] | 0;
                                        $ = (c[ba + (O + E << 2) >> 2] | 0) == (c[ba + ((N - 1 >> h) + E << 2) >> 2] | 0) ? _ : 0
                                    }
                                } while (0);
                                c: do {
                                    if (A | (C | 0) != 0) { ca = B } else {
                                        do {
                                            if ((a[Z + 764 | 0] | 0) == 0) {
                                                _ = D >> P;
                                                if (!((_ | 0) > -1 & (_ | 0) < (U | 0))) { S = 25; break a }
                                                V = R + (((ga(T, _) | 0) + Q | 0) * 24 | 0) + 2 | 0;
                                                _ = e[V >> 1] | 0;
                                                if (!(_ >>> 0 < Y >>> 0)) { break }
                                                if ((c[Z + 800 >> 2] | 0) != (c[(c[X + (_ << 2) >> 2] | 0) + 800 >> 2] | 0)) { ca = 0; break c }
                                            }
                                        } while (0);
                                        if ((a[v] | 0) != 0) { ca = B; break }
                                        _ = c[w >> 2] | 0;
                                        ca = (c[_ + (O + E << 2) >> 2] | 0) == (c[_ + (O + F << 2) >> 2] | 0) ? B : 0
                                    }
                                } while (0);
                                if ((a[Z + 754 | 0] | 0) != 0) {
                                    L = H;
                                    M = I;
                                    break
                                }
                                te(b, N, z, K, 0, $ & 255, ca & 255);
                                ue(b, N, z, K, 0, 0);
                                L = 1;
                                M = c[m >> 2] | 0
                            }
                        } while (0);
                        K = G + 1 | 0;
                        if ((K | 0) < (M | 0)) {
                            G = K;
                            H = L;
                            I = M
                        } else {
                            da = L;
                            ea = M;
                            break
                        }
                    }
                } else {
                    da = l;
                    ea = y
                }
                I = x + 1 | 0;
                if ((I | 0) < (f | 0)) {
                    x = I;
                    l = da;
                    y = ea
                } else {
                    n = da;
                    S = 34;
                    break
                }
            }
            if ((S | 0) == 8) { ec(8880, 6264, 118, 17352); return 0 } else if ((S | 0) == 11) { ec(4520, 6264, 119, 17352); return 0 } else if ((S | 0) == 17) { ec(8880, 6264, 118, 17352); return 0 } else if ((S | 0) == 25) { ec(4520, 6264, 119, 17352); return 0 } else if ((S | 0) == 34) { return n | 0 }
            return 0
        }

        function we(f, g, h, i, j, k) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0;
            l = g ? 2 : 1;
            m = g ? 1 : 2;
            n = g & 1;
            o = n ^ 1;
            p = g ? 80 : 160;
            q = g ? 16 : 32;
            g = f + 10472 | 0;
            r = c[g >> 2] | 0;
            s = (r | 0) > (k | 0) ? k : r;
            r = c[f + 10476 >> 2] | 0;
            k = (r | 0) > (i | 0) ? i : r;
            if ((k | 0) <= (h | 0)) { return }
            r = (s | 0) > (j | 0);
            i = f + 10460 | 0;
            t = f + 10368 | 0;
            u = f + 10372 | 0;
            v = f + 10376 | 0;
            w = f + 10360 | 0;
            x = f + 10388 | 0;
            y = f + 10392 | 0;
            z = f + 10396 | 0;
            A = f + 10380 | 0;
            B = f + 10348 | 0;
            C = f + 10352 | 0;
            D = f + 10356 | 0;
            E = f + 10340 | 0;
            F = f + 52 | 0;
            G = f + 48 | 0;
            H = f + 10332 | 0;
            I = f + 10516 | 0;
            J = f + 10448 | 0;
            K = f + 10452 | 0;
            L = f + 10456 | 0;
            M = f + 10440 | 0;
            f = h;
            a: while (1) {
                if (r) {
                    h = f << 2;
                    N = (h | 0) / 4 | 0;
                    O = h - o | 0;
                    P = j;
                    do {
                        Q = P << 2;
                        R = (Q | 0) / 4 | 0;
                        S = (ga(c[g >> 2] | 0, N) | 0) + R | 0;
                        T = (c[i >> 2] | 0) + S | 0;
                        S = a[T] | 0;
                        U = S & 255;
                        if ((U & p | 0) == 0) { a[T] = S & -4 } else {
                            S = Q - n | 0;
                            T = c[t >> 2] | 0;
                            V = S >> T;
                            W = O >> T;
                            if (!((V | 0) > -1)) { X = 8; break a }
                            Y = c[u >> 2] | 0;
                            if ((V | 0) >= (Y | 0)) { X = 8; break a }
                            if (!((W | 0) > -1)) { X = 11; break a }
                            Z = c[v >> 2] | 0;
                            if ((W | 0) >= (Z | 0)) { X = 11; break a }
                            _ = (ga(Y, W) | 0) + V | 0;
                            V = c[w >> 2] | 0;
                            W = V + (_ * 3 | 0) | 0;
                            _ = Q >> T;
                            $ = h >> T;
                            if (!((_ | 0) > -1 & (_ | 0) < (Y | 0))) { X = 13; break a }
                            if (!(($ | 0) > -1 & ($ | 0) < (Z | 0))) { X = 15; break a }
                            Z = V + (((ga(Y, $) | 0) + _ | 0) * 3 | 0) | 0;
                            b: do {
                                if (((d[W] | d[W + 1 | 0] << 8) << 16 >> 16 & 768) == 0 | ((d[Z] | d[Z + 1 | 0] << 8) << 16 >> 16 & 768) == 0) { aa = 2 } else {
                                    if ((U & q | 0) != 0) {
                                        _ = c[J >> 2] | 0;
                                        $ = Q >> _;
                                        Y = h >> _;
                                        if (!(($ | 0) > -1)) { X = 20; break a }
                                        V = c[K >> 2] | 0;
                                        if (($ | 0) >= (V | 0)) { X = 20; break a }
                                        if (!((Y | 0) > -1)) { X = 23; break a }
                                        T = c[L >> 2] | 0;
                                        if ((Y | 0) >= (T | 0)) { X = 23; break a }
                                        ba = (ga(V, Y) | 0) + $ | 0;
                                        $ = c[M >> 2] | 0;
                                        if (!((a[$ + ba | 0] | 0) > -1)) { aa = 1; break }
                                        ba = S >> _;
                                        Y = O >> _;
                                        if (!((ba | 0) > -1 & (ba | 0) < (V | 0))) { X = 26; break a }
                                        if (!((Y | 0) > -1 & (Y | 0) < (T | 0))) { X = 28; break a }
                                        T = $ + ((ga(V, Y) | 0) + ba) | 0;
                                        if (!((a[T] | 0) > -1)) { aa = 1; break }
                                    }
                                    T = c[x >> 2] | 0;
                                    ba = S >> T;
                                    Y = O >> T;
                                    if (!((ba | 0) > -1)) { X = 32; break a }
                                    V = c[y >> 2] | 0;
                                    if ((ba | 0) >= (V | 0)) { X = 32; break a }
                                    if (!((Y | 0) > -1)) { X = 35; break a }
                                    $ = c[z >> 2] | 0;
                                    if ((Y | 0) >= ($ | 0)) { X = 35; break a }
                                    _ = (ga(V, Y) | 0) + ba | 0;
                                    ba = c[A >> 2] | 0;
                                    Y = Q >> T;
                                    ca = h >> T;
                                    if (!((Y | 0) > -1 & (Y | 0) < (V | 0))) { X = 37; break a }
                                    if (!((ca | 0) > -1 & (ca | 0) < ($ | 0))) { X = 39; break a }
                                    $ = (ga(V, ca) | 0) + Y | 0;
                                    Y = c[B >> 2] | 0;
                                    ca = S >> Y;
                                    V = O >> Y;
                                    if (!((ca | 0) > -1)) { X = 42; break a }
                                    T = c[C >> 2] | 0;
                                    if ((ca | 0) >= (T | 0)) { X = 42; break a }
                                    if (!((V | 0) > -1)) { X = 45; break a }
                                    da = c[D >> 2] | 0;
                                    if ((V | 0) >= (da | 0)) { X = 45; break a }
                                    ea = (ga(T, V) | 0) + ca | 0;
                                    ca = c[E >> 2] | 0;
                                    V = e[ca + (ea * 24 | 0) + 2 >> 1] | 0;
                                    ea = c[G >> 2] | 0;
                                    fa = (c[F >> 2] | 0) - ea >> 2;
                                    if (V >>> 0 < fa >>> 0) { ha = c[ea + (V << 2) >> 2] | 0 } else { ha = 0 }
                                    V = Q >> Y;
                                    ia = h >> Y;
                                    if (!((V | 0) > -1 & (V | 0) < (T | 0))) { X = 49; break a }
                                    if (!((ia | 0) > -1 & (ia | 0) < (da | 0))) { X = 51; break a }
                                    da = ca + (((ga(T, ia) | 0) + V | 0) * 24 | 0) + 2 | 0;
                                    V = e[da >> 1] | 0;
                                    if (V >>> 0 < fa >>> 0) { ja = c[ea + (V << 2) >> 2] | 0 } else { ja = 0 }
                                    V = a[ba + (_ * 12 | 0) | 0] | 0;
                                    ea = V << 24 >> 24 == 0;
                                    if (ea) { ka = -1 } else { ka = c[ha + 916 + (a[ba + (_ * 12 | 0) + 2 | 0] << 2) >> 2] | 0 }
                                    fa = a[ba + (_ * 12 | 0) + 1 | 0] | 0;
                                    da = fa << 24 >> 24 == 0;
                                    if (da) { la = -1 } else { la = c[ha + 980 + (a[ba + (_ * 12 | 0) + 3 | 0] << 2) >> 2] | 0 }
                                    ia = a[ba + ($ * 12 | 0) | 0] | 0;
                                    T = ia << 24 >> 24 == 0;
                                    if (T) { ma = -1 } else { ma = c[ja + 916 + (a[ba + ($ * 12 | 0) + 2 | 0] << 2) >> 2] | 0 }
                                    ca = a[ba + ($ * 12 | 0) + 1 | 0] | 0;
                                    Y = ca << 24 >> 24 == 0;
                                    if (Y) { na = -1 } else { na = c[ja + 980 + (a[ba + ($ * 12 | 0) + 3 | 0] << 2) >> 2] | 0 }
                                    oa = (ka | 0) == (ma | 0);
                                    if (!(oa & (la | 0) == (na | 0))) { if (!((ka | 0) == (na | 0) & (la | 0) == (ma | 0))) { aa = 1; break } }
                                    pa = ea ? 0 : b[ba + (_ * 12 | 0) + 6 >> 1] | 0;
                                    qa = ea ? 0 : b[ba + (_ * 12 | 0) + 4 >> 1] | 0;
                                    ea = da ? 0 : b[ba + (_ * 12 | 0) + 10 >> 1] | 0;
                                    ra = da ? 0 : b[ba + (_ * 12 | 0) + 8 >> 1] | 0;
                                    _ = T ? 0 : b[ba + ($ * 12 | 0) + 6 >> 1] | 0;
                                    da = T ? 0 : b[ba + ($ * 12 | 0) + 4 >> 1] | 0;
                                    T = Y ? 0 : b[ba + ($ * 12 | 0) + 10 >> 1] | 0;
                                    sa = Y ? 0 : b[ba + ($ * 12 | 0) + 8 >> 1] | 0;
                                    if (((fa & 255) + (V & 255) | 0) != ((ca & 255) + (ia & 255) | 0)) {
                                        Ue((c[H >> 2] | 0) + 4 | 0, 1013, 0);
                                        a[I] = 3
                                    }
                                    if ((ka | 0) == (la | 0)) {
                                        if ((ma | 0) != (na | 0)) { X = 79; break a }
                                        ia = qa << 16 >> 16;
                                        ca = da << 16 >> 16;
                                        V = ia - ca | 0;
                                        do {
                                            if ((((V | 0) < 0 ? -V | 0 : V) | 0) <= 3) {
                                                fa = (pa << 16 >> 16) - (_ << 16 >> 16) | 0;
                                                if ((((fa | 0) < 0 ? -fa | 0 : fa) | 0) > 3) { break }
                                                fa = (ra << 16 >> 16) - (sa << 16 >> 16) | 0;
                                                if ((((fa | 0) < 0 ? -fa | 0 : fa) | 0) > 3) { break }
                                                fa = (ea << 16 >> 16) - (T << 16 >> 16) | 0;
                                                if ((((fa | 0) < 0 ? -fa | 0 : fa) | 0) <= 3) { aa = 0; break b }
                                            }
                                        } while (0);
                                        V = ia - (sa << 16 >> 16) | 0;
                                        do {
                                            if ((((V | 0) < 0 ? -V | 0 : V) | 0) <= 3) {
                                                fa = (pa << 16 >> 16) - (T << 16 >> 16) | 0;
                                                if ((((fa | 0) < 0 ? -fa | 0 : fa) | 0) > 3) { break }
                                                fa = (ra << 16 >> 16) - ca | 0;
                                                if ((((fa | 0) < 0 ? -fa | 0 : fa) | 0) > 3) { break }
                                                fa = (ea << 16 >> 16) - (_ << 16 >> 16) | 0;
                                                if ((((fa | 0) < 0 ? -fa | 0 : fa) | 0) <= 3) { aa = 0; break b }
                                            }
                                        } while (0);
                                        aa = 1;
                                        break
                                    }
                                    ca = qa << 16 >> 16;
                                    if (oa) {
                                        V = ca - (da << 16 >> 16) | 0;
                                        do {
                                            if ((((V | 0) < 0 ? -V | 0 : V) | 0) <= 3) {
                                                ia = (pa << 16 >> 16) - (_ << 16 >> 16) | 0;
                                                if ((((ia | 0) < 0 ? -ia | 0 : ia) | 0) > 3) { break }
                                                ia = (ra << 16 >> 16) - (sa << 16 >> 16) | 0;
                                                if ((((ia | 0) < 0 ? -ia | 0 : ia) | 0) > 3) { break }
                                                ia = (ea << 16 >> 16) - (T << 16 >> 16) | 0;
                                                if ((((ia | 0) < 0 ? -ia | 0 : ia) | 0) <= 3) { aa = 0; break b }
                                            }
                                        } while (0);
                                        aa = 1;
                                        break
                                    } else {
                                        V = ca - (sa << 16 >> 16) | 0;
                                        do {
                                            if ((((V | 0) < 0 ? -V | 0 : V) | 0) <= 3) {
                                                oa = (pa << 16 >> 16) - (T << 16 >> 16) | 0;
                                                if ((((oa | 0) < 0 ? -oa | 0 : oa) | 0) > 3) { break }
                                                oa = (ra << 16 >> 16) - (da << 16 >> 16) | 0;
                                                if ((((oa | 0) < 0 ? -oa | 0 : oa) | 0) > 3) { break }
                                                oa = (ea << 16 >> 16) - (_ << 16 >> 16) | 0;
                                                if ((((oa | 0) < 0 ? -oa | 0 : oa) | 0) <= 3) { aa = 0; break b }
                                            }
                                        } while (0);
                                        aa = 1;
                                        break
                                    }
                                }
                            } while (0);
                            Q = (ga(c[g >> 2] | 0, N) | 0) + R | 0;
                            S = (c[i >> 2] | 0) + Q | 0;
                            a[S] = a[S] & -4 | aa
                        }
                        P = P + l | 0;
                    } while ((P | 0) < (s | 0))
                }
                P = f + m | 0;
                if ((P | 0) < (k | 0)) { f = P } else { X = 93; break }
            }
            if ((X | 0) == 8) { ec(8880, 6264, 118, 17352) } else if ((X | 0) == 11) { ec(4520, 6264, 119, 17352) } else if ((X | 0) == 13) { ec(8880, 6264, 118, 17352) } else if ((X | 0) == 15) { ec(4520, 6264, 119, 17352) } else if ((X | 0) == 20) { ec(8880, 6264, 118, 17352) } else if ((X | 0) == 23) { ec(4520, 6264, 119, 17352) } else if ((X | 0) == 26) { ec(8880, 6264, 118, 17352) } else if ((X | 0) == 28) { ec(4520, 6264, 119, 17352) } else if ((X | 0) == 32) { ec(8880, 6264, 118, 17352) } else if ((X | 0) == 35) { ec(4520, 6264, 119, 17352) } else if ((X | 0) == 37) { ec(8880, 6264, 118, 17352) } else if ((X | 0) == 39) { ec(4520, 6264, 119, 17352) } else if ((X | 0) == 42) { ec(8880, 6264, 118, 17352) } else if ((X | 0) == 45) { ec(4520, 6264, 119, 17352) } else if ((X | 0) == 49) { ec(8880, 6264, 118, 17352) } else if ((X | 0) == 51) { ec(4520, 6264, 119, 17352) } else if ((X | 0) == 79) { ec(3256, 14616, 343, 18768) } else if ((X | 0) == 93) { return }
        }

        function xe(f, g, h, j, k, l) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0,
                Fa = 0,
                Ga = 0,
                Ha = 0,
                Ia = 0,
                Ja = 0,
                Ka = 0,
                La = 0,
                Ma = 0,
                Na = 0,
                Oa = 0,
                Pa = 0,
                Qa = 0,
                Ra = 0,
                Sa = 0,
                Ta = 0,
                Ua = 0,
                Va = 0,
                Wa = 0,
                Xa = 0,
                Ya = 0,
                Za = 0,
                _a = 0,
                $a = 0,
                ab = 0,
                bb = 0,
                cb = 0,
                db = 0,
                eb = 0,
                fb = 0,
                gb = 0,
                hb = 0,
                ib = 0,
                jb = 0,
                kb = 0,
                lb = 0,
                mb = 0,
                nb = 0,
                ob = 0,
                pb = 0,
                qb = 0,
                rb = 0,
                sb = 0,
                tb = 0,
                ub = 0,
                vb = 0,
                wb = 0,
                xb = 0,
                yb = 0,
                zb = 0,
                Ab = 0,
                Bb = 0,
                Cb = 0;
            m = i;
            i = i + 64 | 0;
            n = m | 0;
            o = m + 32 | 0;
            p = g ? 2 : 1;
            q = g ? 1 : 2;
            r = f + 40 | 0;
            s = c[r >> 2] | 0;
            t = c[f + 5760 >> 2] | 0;
            u = c[f + 10472 >> 2] | 0;
            v = (u | 0) > (l | 0) ? l : u;
            l = c[f + 10476 >> 2] | 0;
            w = (l | 0) > (j | 0) ? j : l;
            if ((w | 0) <= (h | 0)) { i = m; return }
            l = (v | 0) > (k | 0);
            j = f + 10460 | 0;
            x = f + 4 | 0;
            y = f + 10368 | 0;
            z = f + 10372 | 0;
            A = f + 10376 | 0;
            B = f + 10360 | 0;
            C = f + 10348 | 0;
            D = f + 10352 | 0;
            E = f + 10356 | 0;
            F = f + 10340 | 0;
            G = f + 48 | 0;
            H = t - 8 | 0;
            I = o + 4 | 0;
            J = o + 2 | 0;
            K = o | 0;
            L = o + 28 | 0;
            M = o + 26 | 0;
            N = o + 24 | 0;
            O = n + 4 | 0;
            P = n + 2 | 0;
            Q = n | 0;
            R = n + 28 | 0;
            S = n + 26 | 0;
            T = n + 24 | 0;
            U = o + 6 | 0;
            V = n + 6 | 0;
            W = o + 30 | 0;
            X = n + 30 | 0;
            Y = f + 5480 | 0;
            f = (1 << t) - 1 | 0;
            t = f & 65535;
            Z = s << 1;
            _ = h;
            a: while (1) {
                if (l) {
                    h = _ << 2;
                    $ = (h | 0) / 4 | 0;
                    aa = h - 1 | 0;
                    ba = c[j >> 2] | 0;
                    ca = k;
                    do {
                        da = ca << 2;
                        ea = ba + ((ga(u, $) | 0) + ((da | 0) / 4 | 0)) | 0;
                        fa = a[ea] & 3;
                        ea = fa & 255;
                        b: do {
                            if (!(fa << 24 >> 24 == 0)) {
                                ha = (c[x >> 2] | 0) + ((ga(c[r >> 2] | 0, h) | 0) + da << 1) | 0;
                                if (g) {
                                    ia = 0;
                                    do {
                                        ja = ga(ia, s) | 0;
                                        b[n + (ia << 3) >> 1] = b[ha + (ja << 1) >> 1] | 0;
                                        b[o + (ia << 3) >> 1] = b[ha + (ja - 1 << 1) >> 1] | 0;
                                        b[n + (ia << 3) + 2 >> 1] = b[ha + (ja + 1 << 1) >> 1] | 0;
                                        b[o + (ia << 3) + 2 >> 1] = b[ha + (ja - 2 << 1) >> 1] | 0;
                                        b[n + (ia << 3) + 4 >> 1] = b[ha + (ja + 2 << 1) >> 1] | 0;
                                        b[o + (ia << 3) + 4 >> 1] = b[ha + (ja - 3 << 1) >> 1] | 0;
                                        b[n + (ia << 3) + 6 >> 1] = b[ha + (ja + 3 << 1) >> 1] | 0;
                                        b[o + (ia << 3) + 6 >> 1] = b[ha + (ja - 4 << 1) >> 1] | 0;
                                        ia = ia + 1 | 0;
                                    } while ((ia | 0) < 4)
                                } else {
                                    ia = 0;
                                    do {
                                        b[n + (ia << 3) >> 1] = b[ha + (ia << 1) >> 1] | 0;
                                        b[o + (ia << 3) >> 1] = b[ha + (ia - s << 1) >> 1] | 0;
                                        b[n + (ia << 3) + 2 >> 1] = b[ha + (s + ia << 1) >> 1] | 0;
                                        b[o + (ia << 3) + 2 >> 1] = b[ha + (ia - (s << 1) << 1) >> 1] | 0;
                                        b[n + (ia << 3) + 4 >> 1] = b[ha + ((s << 1) + ia << 1) >> 1] | 0;
                                        b[o + (ia << 3) + 4 >> 1] = b[ha + (ia + (s * -3 | 0) << 1) >> 1] | 0;
                                        b[n + (ia << 3) + 6 >> 1] = b[ha + ((s * 3 | 0) + ia << 1) >> 1] | 0;
                                        b[o + (ia << 3) + 6 >> 1] = b[ha + (ia - (s << 2) << 1) >> 1] | 0;
                                        ia = ia + 1 | 0;
                                    } while ((ia | 0) < 4)
                                }
                                ia = c[y >> 2] | 0;
                                ja = da >> ia;
                                ka = h >> ia;
                                if (!((ja | 0) > -1)) { la = 11; break a }
                                ma = c[z >> 2] | 0;
                                if ((ja | 0) >= (ma | 0)) { la = 11; break a }
                                if (!((ka | 0) > -1)) { la = 14; break a }
                                na = c[A >> 2] | 0;
                                if ((ka | 0) >= (na | 0)) { la = 14; break a }
                                oa = ga(ma, ka) | 0;
                                ka = oa + ja | 0;
                                pa = c[B >> 2] | 0;
                                qa = a[pa + (ka * 3 | 0) + 2 | 0] | 0;
                                if (g) {
                                    ra = da - 1 >> ia;
                                    if (!((ra | 0) > -1 & (ra | 0) < (ma | 0))) { la = 17; break a }
                                    sa = oa + ra | 0
                                } else {
                                    ra = aa >> ia;
                                    if (!((ra | 0) > -1 & (ra | 0) < (na | 0))) { la = 20; break a }
                                    sa = (ga(ma, ra) | 0) + ja | 0
                                }
                                ra = qa + 1 + (a[pa + (sa * 3 | 0) + 2 | 0] | 0) >> 1;
                                qa = c[C >> 2] | 0;
                                ta = da >> qa;
                                ua = h >> qa;
                                if (!((ta | 0) > -1)) { la = 24; break a }
                                qa = c[D >> 2] | 0;
                                if ((ta | 0) >= (qa | 0)) { la = 24; break a }
                                if (!((ua | 0) > -1)) { la = 27; break a }
                                if ((ua | 0) >= (c[E >> 2] | 0)) { la = 27; break a }
                                va = (ga(qa, ua) | 0) + ta | 0;
                                ta = c[(c[G >> 2] | 0) + (e[(c[F >> 2] | 0) + (va * 24 | 0) + 2 >> 1] << 2) >> 2] | 0;
                                va = (c[ta + 756 >> 2] | 0) + ra | 0;
                                if ((va | 0) < 0) { wa = 0 } else { wa = (va | 0) > 51 ? 51 : va }
                                va = d[30360 + wa | 0] << H;
                                ua = (ea << 1) - 2 + ra + (c[ta + 760 >> 2] | 0) | 0;
                                if ((ua | 0) < 0) { xa = 0 } else { xa = (ua | 0) > 53 ? 53 : ua }
                                ua = d[30664 + xa | 0] << H;
                                ta = b[I >> 1] | 0;
                                ra = b[J >> 1] | 0;
                                qa = b[K >> 1] | 0;
                                ya = qa & 65535;
                                za = (ta & 65535) - ((ra & 65535) << 1) + ya | 0;
                                Aa = (za | 0) < 0 ? -za | 0 : za;
                                za = e[N >> 1] | 0;
                                Ba = (e[L >> 1] | 0) - (e[M >> 1] << 1) + za | 0;
                                Ca = (Ba | 0) < 0 ? -Ba | 0 : Ba;
                                Ba = b[O >> 1] | 0;
                                Da = b[P >> 1] | 0;
                                Ea = b[Q >> 1] | 0;
                                Fa = Ea & 65535;
                                Ga = (Ba & 65535) - ((Da & 65535) << 1) + Fa | 0;
                                Ha = (Ga | 0) < 0 ? -Ga | 0 : Ga;
                                Ga = e[T >> 1] | 0;
                                Ia = (e[R >> 1] | 0) - (e[S >> 1] << 1) + Ga | 0;
                                Ja = (Ia | 0) < 0 ? -Ia | 0 : Ia;
                                Ia = Ha + Aa | 0;
                                Ka = Ja + Ca | 0;
                                La = Ca + Aa | 0;
                                Aa = Ja + Ha | 0;
                                if ((Ka + Ia | 0) >= (va | 0)) { break }
                                Ha = va >> 2;
                                do {
                                    if ((Ia << 1 | 0) < (Ha | 0)) {
                                        Ja = (e[U >> 1] | 0) - ya | 0;
                                        Ca = Fa - (e[V >> 1] | 0) | 0;
                                        if ((((Ca | 0) < 0 ? -Ca | 0 : Ca) + ((Ja | 0) < 0 ? -Ja | 0 : Ja) | 0) >= (va >> 3 | 0)) { Ma = 1; break }
                                        Ja = ya - Fa | 0;
                                        Ma = (((Ja | 0) < 0 ? -Ja | 0 : Ja) | 0) >= ((ua * 5 | 0) + 1 >> 1 | 0)
                                    } else { Ma = 1 }
                                } while (0);
                                do {
                                    if ((Ka << 1 | 0) < (Ha | 0)) {
                                        Fa = (e[W >> 1] | 0) - za | 0;
                                        ya = Ga - (e[X >> 1] | 0) | 0;
                                        if ((((ya | 0) < 0 ? -ya | 0 : ya) + ((Fa | 0) < 0 ? -Fa | 0 : Fa) | 0) >= (va >> 3 | 0)) { Na = 1; break }
                                        Fa = za - Ga | 0;
                                        Na = (((Fa | 0) < 0 ? -Fa | 0 : Fa) | 0) >= ((ua * 5 | 0) + 1 >> 1 | 0)
                                    } else { Na = 1 }
                                } while (0);
                                Ga = Ma | Na;
                                za = (va >> 1) + va >> 3;
                                Ha = a[Y] | 0;
                                Ka = Ha << 24 >> 24 != 0;
                                if (g) {
                                    Fa = da - 1 >> ia;
                                    if (Ka) {
                                        if (!((Fa | 0) > -1 & (Fa | 0) < (ma | 0))) { la = 42; break a }
                                        ya = pa + ((oa + Fa | 0) * 3 | 0) | 0;
                                        Oa = (((d[ya] | d[ya + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 10 & 1 ^ 1) & 255
                                    } else { Oa = 1 }
                                    if (!((Fa | 0) > -1 & (Fa | 0) < (ma | 0))) { la = 45; break a }
                                    ya = pa + ((oa + Fa | 0) * 3 | 0) | 0;
                                    if (Ha << 24 >> 24 == 0) { Pa = 1 } else {
                                        Fa = pa + (ka * 3 | 0) | 0;
                                        Pa = ((d[Fa] | d[Fa + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    Fa = pa + (ka * 3 | 0) | 0;
                                    Qa = ((d[ya] | d[ya + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Oa << 24 >> 24 != 0;
                                    Ra = ((d[Fa] | d[Fa + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Pa
                                } else {
                                    Fa = aa >> ia;
                                    if (Ka) {
                                        if (!((Fa | 0) > -1 & (Fa | 0) < (na | 0))) { la = 51; break a }
                                        Ka = pa + (((ga(ma, Fa) | 0) + ja | 0) * 3 | 0) | 0;
                                        Sa = ((d[Ka] | d[Ka + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    } else { Sa = 1 }
                                    if (!((Fa | 0) > -1 & (Fa | 0) < (na | 0))) { la = 54; break a }
                                    Ka = pa + (((ga(ma, Fa) | 0) + ja | 0) * 3 | 0) | 0;
                                    if (Ha << 24 >> 24 == 0) { Ta = 1 } else {
                                        Ha = pa + (ka * 3 | 0) | 0;
                                        Ta = ((d[Ha] | d[Ha + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    Ha = pa + (ka * 3 | 0) | 0;
                                    Qa = ((d[Ka] | d[Ka + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Sa;
                                    Ra = ((d[Ha] | d[Ha + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Ta
                                }
                                Ha = ua * 10 | 0;
                                Ka = -ua | 0;
                                Fa = (La | 0) >= (za | 0) | Qa ^ 1;
                                ya = (Aa | 0) >= (za | 0) | Ra ^ 1;
                                za = ua >> 1;
                                Ia = -za | 0;
                                Ja = ua << 1;
                                Ca = 0;
                                Ua = qa;
                                Va = ra;
                                Wa = ta;
                                Xa = Ea;
                                Ya = Da;
                                Za = Ba;
                                while (1) {
                                    _a = b[o + (Ca << 3) + 6 >> 1] | 0;
                                    $a = b[n + (Ca << 3) + 6 >> 1] | 0;
                                    do {
                                        if (Ga) {
                                            ab = Xa & 65535;
                                            bb = Ua & 65535;
                                            cb = Ya & 65535;
                                            db = Va & 65535;
                                            eb = ((ab - bb | 0) * 9 | 0) + 8 + ((cb - db | 0) * -3 | 0) >> 4;
                                            if ((((eb | 0) < 0 ? -eb | 0 : eb) | 0) >= (Ha | 0)) { break }
                                            if ((eb | 0) < (Ka | 0)) { fb = Ka } else { fb = (eb | 0) > (ua | 0) ? ua : eb }
                                            do {
                                                if (g) {
                                                    if (Qa) {
                                                        eb = fb + bb | 0;
                                                        if ((eb | 0) < 0) { gb = 0 } else { gb = (eb | 0) > (f | 0) ? t : eb & 65535 }
                                                        eb = ha + ((ga(Ca, s) | 0) - 1 << 1) | 0;
                                                        b[eb >> 1] = gb
                                                    }
                                                    if (!Ra) { break }
                                                    eb = ab - fb | 0;
                                                    if ((eb | 0) < 0) { hb = 0 } else { hb = (eb | 0) > (f | 0) ? t : eb & 65535 }
                                                    eb = ha + ((ga(Ca, s) | 0) << 1) | 0;
                                                    b[eb >> 1] = hb
                                                } else {
                                                    if (Qa) {
                                                        eb = fb + bb | 0;
                                                        if ((eb | 0) < 0) { ib = 0 } else { ib = (eb | 0) > (f | 0) ? t : eb & 65535 }
                                                        b[ha + (Ca - s << 1) >> 1] = ib
                                                    }
                                                    if (!Ra) { break }
                                                    eb = ab - fb | 0;
                                                    if ((eb | 0) < 0) { jb = 0 } else { jb = (eb | 0) > (f | 0) ? t : eb & 65535 }
                                                    b[ha + (Ca << 1) >> 1] = jb
                                                }
                                            } while (0);
                                            do {
                                                if (!Fa) {
                                                    eb = fb + (((bb + 1 + (Wa & 65535) | 0) >>> 1) - db) | 0;
                                                    kb = eb >> 1;
                                                    if ((kb | 0) < (Ia | 0)) { lb = Ia } else { lb = ((kb | 0) > (za | 0) ? ua : eb) >> 1 }
                                                    eb = lb + db | 0;
                                                    kb = (eb | 0) < 0;
                                                    if (g) {
                                                        if (kb) { mb = 0 } else { mb = (eb | 0) > (f | 0) ? t : eb & 65535 }
                                                        nb = ha + ((ga(Ca, s) | 0) - 2 << 1) | 0;
                                                        b[nb >> 1] = mb;
                                                        break
                                                    } else {
                                                        if (kb) { ob = 0 } else { ob = (eb | 0) > (f | 0) ? t : eb & 65535 }
                                                        b[ha + (Ca - Z << 1) >> 1] = ob;
                                                        break
                                                    }
                                                }
                                            } while (0);
                                            if (ya) { break }
                                            db = ((ab + 1 + (Za & 65535) | 0) >>> 1) - cb - fb | 0;
                                            bb = db >> 1;
                                            if ((bb | 0) < (Ia | 0)) { pb = Ia } else { pb = ((bb | 0) > (za | 0) ? ua : db) >> 1 }
                                            db = pb + cb | 0;
                                            bb = (db | 0) < 0;
                                            if (g) {
                                                if (bb) { qb = 0 } else { qb = (db | 0) > (f | 0) ? t : db & 65535 }
                                                eb = ha + ((ga(Ca, s) | 0) + 1 << 1) | 0;
                                                b[eb >> 1] = qb;
                                                break
                                            } else {
                                                if (bb) { rb = 0 } else { rb = (db | 0) > (f | 0) ? t : db & 65535 }
                                                b[ha + (Ca + s << 1) >> 1] = rb;
                                                break
                                            }
                                        } else {
                                            db = Wa & 65535;
                                            bb = Va & 65535;
                                            eb = Ua & 65535;
                                            kb = Xa & 65535;
                                            nb = kb << 1;
                                            sb = Ya & 65535;
                                            tb = (eb << 1) + 4 | 0;
                                            ub = tb + (bb << 1) + db + nb + sb >> 3;
                                            vb = eb - Ja | 0;
                                            do { if ((ub | 0) < (vb | 0)) { wb = vb & 65535 } else { xb = eb + Ja | 0; if ((ub | 0) > (xb | 0)) { wb = xb & 65535; break } else { wb = ub & 65535; break } } } while (0);
                                            ub = (eb + 2 + bb + db + kb | 0) >>> 2;
                                            vb = bb - Ja | 0;
                                            do { if ((ub | 0) < (vb | 0)) { yb = vb & 65535 } else { cb = bb + Ja | 0; if ((ub | 0) > (cb | 0)) { yb = cb & 65535; break } else { yb = ub & 65535; break } } } while (0);
                                            ub = eb + 4 + bb + (db * 3 | 0) + ((_a & 65535) << 1) + kb >> 3;
                                            vb = db - Ja | 0;
                                            do { if ((ub | 0) < (vb | 0)) { zb = vb & 65535 } else { cb = db + Ja | 0; if ((ub | 0) > (cb | 0)) { zb = cb & 65535; break } else { zb = ub & 65535; break } } } while (0);
                                            ub = Za & 65535;
                                            db = tb + bb + nb + (sb << 1) + ub >> 3;
                                            vb = kb - Ja | 0;
                                            do { if ((db | 0) < (vb | 0)) { Ab = vb & 65535 } else { cb = kb + Ja | 0; if ((db | 0) > (cb | 0)) { Ab = cb & 65535; break } else { Ab = db & 65535; break } } } while (0);
                                            db = kb + eb + sb | 0;
                                            vb = (ub + 2 + db | 0) >>> 2;
                                            nb = sb - Ja | 0;
                                            do { if ((vb | 0) < (nb | 0)) { Bb = nb & 65535 } else { bb = sb + Ja | 0; if ((vb | 0) > (bb | 0)) { Bb = bb & 65535; break } else { Bb = vb & 65535; break } } } while (0);
                                            vb = (db + 4 + (ub * 3 | 0) + (($a & 65535) << 1) | 0) >>> 3;
                                            sb = ub - Ja | 0;
                                            do { if ((vb | 0) < (sb | 0)) { Cb = sb & 65535 } else { nb = ub + Ja | 0; if ((vb | 0) > (nb | 0)) { Cb = nb & 65535; break } else { Cb = vb & 65535; break } } } while (0);
                                            if (g) {
                                                vb = ga(Ca, s) | 0;
                                                if (Qa) { b[ha + (vb - 1 << 1) >> 1] = wb }
                                                if (Ra) { b[ha + (vb << 1) >> 1] = Ab }
                                                if (Qa) { b[ha + (vb - 2 << 1) >> 1] = yb }
                                                if (Ra) { b[ha + (vb + 1 << 1) >> 1] = Bb }
                                                if (Qa) { b[ha + (vb - 3 << 1) >> 1] = zb }
                                                if (!Ra) { break }
                                                b[ha + (vb + 2 << 1) >> 1] = Cb;
                                                break
                                            } else {
                                                if (Qa) { b[ha + (Ca - s << 1) >> 1] = wb }
                                                if (Ra) { b[ha + (Ca << 1) >> 1] = Ab }
                                                if (Qa) { b[ha + (Ca - (s << 1) << 1) >> 1] = yb }
                                                if (Ra) { b[ha + (s + Ca << 1) >> 1] = Bb }
                                                if (Qa) { b[ha + (Ca + (s * -3 | 0) << 1) >> 1] = zb }
                                                if (!Ra) { break }
                                                b[ha + ((s << 1) + Ca << 1) >> 1] = Cb;
                                                break
                                            }
                                        }
                                    } while (0);
                                    $a = Ca + 1 | 0;
                                    if (($a | 0) >= 4) { break b }
                                    Ca = $a;
                                    Ua = b[o + ($a << 3) >> 1] | 0;
                                    Va = b[o + ($a << 3) + 2 >> 1] | 0;
                                    Wa = b[o + ($a << 3) + 4 >> 1] | 0;
                                    Xa = b[n + ($a << 3) >> 1] | 0;
                                    Ya = b[n + ($a << 3) + 2 >> 1] | 0;
                                    Za = b[n + ($a << 3) + 4 >> 1] | 0
                                }
                            }
                        } while (0);
                        ca = ca + p | 0;
                    } while ((ca | 0) < (v | 0))
                }
                ca = _ + q | 0;
                if ((ca | 0) < (w | 0)) { _ = ca } else { la = 145; break }
            }
            if ((la | 0) == 11) { ec(8880, 6264, 118, 17352) } else if ((la | 0) == 14) { ec(4520, 6264, 119, 17352) } else if ((la | 0) == 17) { ec(8880, 6264, 118, 17352) } else if ((la | 0) == 20) { ec(4520, 6264, 119, 17352) } else if ((la | 0) == 24) { ec(8880, 6264, 118, 17352) } else if ((la | 0) == 27) { ec(4520, 6264, 119, 17352) } else if ((la | 0) == 42) { ec(8880, 6264, 118, 17352) } else if ((la | 0) == 45) { ec(8880, 6264, 118, 17352) } else if ((la | 0) == 51) { ec(4520, 6264, 119, 17352) } else if ((la | 0) == 54) { ec(4520, 6264, 119, 17352) } else if ((la | 0) == 145) { i = m; return }
        }

        function ye(b, f, g, h, j, k) {
            b = b | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0,
                Fa = 0,
                Ga = 0,
                Ha = 0,
                Ia = 0,
                Ja = 0,
                Ka = 0,
                La = 0,
                Ma = 0,
                Na = 0,
                Oa = 0,
                Pa = 0,
                Qa = 0,
                Ra = 0,
                Sa = 0,
                Ta = 0,
                Ua = 0,
                Va = 0,
                Wa = 0,
                Xa = 0,
                Ya = 0,
                Za = 0,
                _a = 0,
                $a = 0,
                ab = 0,
                bb = 0,
                cb = 0,
                db = 0,
                eb = 0,
                fb = 0,
                gb = 0,
                hb = 0,
                ib = 0,
                jb = 0,
                kb = 0,
                lb = 0,
                mb = 0,
                nb = 0,
                ob = 0,
                pb = 0,
                qb = 0,
                rb = 0,
                sb = 0,
                tb = 0,
                ub = 0,
                vb = 0,
                wb = 0,
                xb = 0,
                yb = 0,
                zb = 0,
                Ab = 0,
                Bb = 0,
                Cb = 0,
                Db = 0,
                Eb = 0,
                Fb = 0,
                Gb = 0,
                Hb = 0;
            l = i;
            i = i + 32 | 0;
            m = l | 0;
            n = l + 16 | 0;
            o = f ? 2 : 1;
            p = f ? 1 : 2;
            q = b + 40 | 0;
            r = c[q >> 2] | 0;
            s = c[b + 5760 >> 2] | 0;
            t = b + 10472 | 0;
            u = c[t >> 2] | 0;
            v = (u | 0) > (k | 0) ? k : u;
            u = c[b + 10476 >> 2] | 0;
            k = (u | 0) > (h | 0) ? h : u;
            if ((k | 0) <= (g | 0)) { i = l; return }
            u = (v | 0) > (j | 0);
            h = b + 10460 | 0;
            w = b + 4 | 0;
            x = b + 10368 | 0;
            y = b + 10372 | 0;
            z = b + 10376 | 0;
            A = b + 10360 | 0;
            B = b + 10348 | 0;
            C = b + 10352 | 0;
            D = b + 10356 | 0;
            E = b + 10340 | 0;
            F = b + 48 | 0;
            G = s - 8 | 0;
            H = n + 2 | 0;
            I = n + 1 | 0;
            J = n | 0;
            K = n + 14 | 0;
            L = n + 13 | 0;
            M = n + 12 | 0;
            N = m + 2 | 0;
            O = m + 1 | 0;
            P = m | 0;
            Q = m + 14 | 0;
            R = m + 13 | 0;
            S = m + 12 | 0;
            T = n + 3 | 0;
            U = m + 3 | 0;
            V = n + 15 | 0;
            W = m + 15 | 0;
            X = b + 5480 | 0;
            b = (1 << s) - 1 | 0;
            s = b & 255;
            Y = r << 1;
            Z = g;
            a: while (1) {
                if (u) {
                    g = Z << 2;
                    _ = (g | 0) / 4 | 0;
                    $ = g - 1 | 0;
                    aa = j;
                    do {
                        ba = aa << 2;
                        ca = (ga(c[t >> 2] | 0, _) | 0) + ((ba | 0) / 4 | 0) | 0;
                        da = a[(c[h >> 2] | 0) + ca | 0] & 3;
                        ca = da & 255;
                        b: do {
                            if (!(da << 24 >> 24 == 0)) {
                                ea = c[w >> 2] | 0;
                                fa = (ga(c[q >> 2] | 0, g) | 0) + ba | 0;
                                ha = 0;
                                do {
                                    ia = (ga(ha, r) | 0) + fa | 0;
                                    ja = ha + fa | 0;
                                    if (f) {
                                        a[m + (ha << 2) | 0] = a[ea + ia | 0] | 0;
                                        a[n + (ha << 2) | 0] = a[ea + (ia - 1) | 0] | 0;
                                        a[m + (ha << 2) + 1 | 0] = a[ea + (ia + 1) | 0] | 0;
                                        a[n + (ha << 2) + 1 | 0] = a[ea + (ia - 2) | 0] | 0;
                                        a[m + (ha << 2) + 2 | 0] = a[ea + (ia + 2) | 0] | 0;
                                        a[n + (ha << 2) + 2 | 0] = a[ea + (ia - 3) | 0] | 0;
                                        a[m + (ha << 2) + 3 | 0] = a[ea + (ia + 3) | 0] | 0;
                                        a[n + (ha << 2) + 3 | 0] = a[ea + (ia - 4) | 0] | 0
                                    } else {
                                        a[m + (ha << 2) | 0] = a[ea + ja | 0] | 0;
                                        a[n + (ha << 2) | 0] = a[ea + (ja - r) | 0] | 0;
                                        a[m + (ha << 2) + 1 | 0] = a[ea + (ja + r) | 0] | 0;
                                        a[n + (ha << 2) + 1 | 0] = a[ea + (ja - (r << 1)) | 0] | 0;
                                        a[m + (ha << 2) + 2 | 0] = a[ea + (ja + (r << 1)) | 0] | 0;
                                        a[n + (ha << 2) + 2 | 0] = a[ea + (ja + (r * -3 | 0)) | 0] | 0;
                                        a[m + (ha << 2) + 3 | 0] = a[ea + (ja + (r * 3 | 0)) | 0] | 0;
                                        a[n + (ha << 2) + 3 | 0] = a[ea + (ja - (r << 2)) | 0] | 0
                                    }
                                    ha = ha + 1 | 0;
                                } while ((ha | 0) < 4);
                                ha = c[x >> 2] | 0;
                                ja = ba >> ha;
                                ia = g >> ha;
                                if (!((ja | 0) > -1)) { ka = 12; break a }
                                la = c[y >> 2] | 0;
                                if ((ja | 0) >= (la | 0)) { ka = 12; break a }
                                if (!((ia | 0) > -1)) { ka = 15; break a }
                                ma = c[z >> 2] | 0;
                                if ((ia | 0) >= (ma | 0)) { ka = 15; break a }
                                na = ga(la, ia) | 0;
                                ia = na + ja | 0;
                                oa = c[A >> 2] | 0;
                                pa = a[oa + (ia * 3 | 0) + 2 | 0] | 0;
                                if (f) {
                                    qa = ba - 1 >> ha;
                                    if (!((qa | 0) > -1 & (qa | 0) < (la | 0))) { ka = 18; break a }
                                    ra = na + qa | 0
                                } else {
                                    qa = $ >> ha;
                                    if (!((qa | 0) > -1 & (qa | 0) < (ma | 0))) { ka = 21; break a }
                                    ra = (ga(la, qa) | 0) + ja | 0
                                }
                                qa = pa + 1 + (a[oa + (ra * 3 | 0) + 2 | 0] | 0) >> 1;
                                pa = c[B >> 2] | 0;
                                sa = ba >> pa;
                                ta = g >> pa;
                                if (!((sa | 0) > -1)) { ka = 25; break a }
                                pa = c[C >> 2] | 0;
                                if ((sa | 0) >= (pa | 0)) { ka = 25; break a }
                                if (!((ta | 0) > -1)) { ka = 28; break a }
                                if ((ta | 0) >= (c[D >> 2] | 0)) { ka = 28; break a }
                                ua = (ga(pa, ta) | 0) + sa | 0;
                                sa = c[(c[F >> 2] | 0) + (e[(c[E >> 2] | 0) + (ua * 24 | 0) + 2 >> 1] << 2) >> 2] | 0;
                                ua = (c[sa + 756 >> 2] | 0) + qa | 0;
                                if ((ua | 0) < 0) { va = 0 } else { va = (ua | 0) > 51 ? 51 : ua }
                                ua = d[30360 + va | 0] << G;
                                ta = (ca << 1) - 2 + qa + (c[sa + 760 >> 2] | 0) | 0;
                                if ((ta | 0) < 0) { wa = 0 } else { wa = (ta | 0) > 53 ? 53 : ta }
                                ta = d[30664 + wa | 0] << G;
                                sa = a[H] | 0;
                                qa = a[I] | 0;
                                pa = a[J] | 0;
                                xa = pa & 255;
                                ya = (sa & 255) - ((qa & 255) << 1) + xa | 0;
                                za = (ya | 0) < 0 ? -ya | 0 : ya;
                                ya = d[M] | 0;
                                Aa = (d[K] | 0) - (d[L] << 1) + ya | 0;
                                Ba = (Aa | 0) < 0 ? -Aa | 0 : Aa;
                                Aa = a[N] | 0;
                                Ca = a[O] | 0;
                                Da = a[P] | 0;
                                Ea = Da & 255;
                                Fa = (Aa & 255) - ((Ca & 255) << 1) + Ea | 0;
                                Ga = (Fa | 0) < 0 ? -Fa | 0 : Fa;
                                Fa = d[S] | 0;
                                Ha = (d[Q] | 0) - (d[R] << 1) + Fa | 0;
                                Ia = (Ha | 0) < 0 ? -Ha | 0 : Ha;
                                Ha = Ga + za | 0;
                                Ja = Ia + Ba | 0;
                                Ka = Ba + za | 0;
                                za = Ia + Ga | 0;
                                if ((Ja + Ha | 0) >= (ua | 0)) { break }
                                Ga = ua >> 2;
                                do {
                                    if ((Ha << 1 | 0) < (Ga | 0)) {
                                        Ia = (d[T] | 0) - xa | 0;
                                        Ba = Ea - (d[U] | 0) | 0;
                                        if ((((Ba | 0) < 0 ? -Ba | 0 : Ba) + ((Ia | 0) < 0 ? -Ia | 0 : Ia) | 0) >= (ua >> 3 | 0)) { La = 1; break }
                                        Ia = xa - Ea | 0;
                                        La = (((Ia | 0) < 0 ? -Ia | 0 : Ia) | 0) >= ((ta * 5 | 0) + 1 >> 1 | 0)
                                    } else { La = 1 }
                                } while (0);
                                do {
                                    if ((Ja << 1 | 0) < (Ga | 0)) {
                                        Ea = (d[V] | 0) - ya | 0;
                                        xa = Fa - (d[W] | 0) | 0;
                                        if ((((xa | 0) < 0 ? -xa | 0 : xa) + ((Ea | 0) < 0 ? -Ea | 0 : Ea) | 0) >= (ua >> 3 | 0)) { Ma = 1; break }
                                        Ea = ya - Fa | 0;
                                        Ma = (((Ea | 0) < 0 ? -Ea | 0 : Ea) | 0) >= ((ta * 5 | 0) + 1 >> 1 | 0)
                                    } else { Ma = 1 }
                                } while (0);
                                Fa = La | Ma;
                                ya = (ua >> 1) + ua >> 3;
                                Ga = a[X] | 0;
                                Ja = Ga << 24 >> 24 != 0;
                                if (f) {
                                    Ea = ba - 1 >> ha;
                                    if (Ja) {
                                        if (!((Ea | 0) > -1 & (Ea | 0) < (la | 0))) { ka = 43; break a }
                                        xa = oa + ((na + Ea | 0) * 3 | 0) | 0;
                                        Na = (((d[xa] | d[xa + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 10 & 1 ^ 1) & 255
                                    } else { Na = 1 }
                                    if (!((Ea | 0) > -1 & (Ea | 0) < (la | 0))) { ka = 46; break a }
                                    xa = oa + ((na + Ea | 0) * 3 | 0) | 0;
                                    if (Ga << 24 >> 24 == 0) { Oa = 1 } else {
                                        Ea = oa + (ia * 3 | 0) | 0;
                                        Oa = ((d[Ea] | d[Ea + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    Ea = oa + (ia * 3 | 0) | 0;
                                    Pa = ((d[xa] | d[xa + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Na << 24 >> 24 != 0;
                                    Qa = ((d[Ea] | d[Ea + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Oa
                                } else {
                                    Ea = $ >> ha;
                                    if (Ja) {
                                        if (!((Ea | 0) > -1 & (Ea | 0) < (ma | 0))) { ka = 52; break a }
                                        Ja = oa + (((ga(la, Ea) | 0) + ja | 0) * 3 | 0) | 0;
                                        Ra = ((d[Ja] | d[Ja + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    } else { Ra = 1 }
                                    if (!((Ea | 0) > -1 & (Ea | 0) < (ma | 0))) { ka = 55; break a }
                                    Ja = oa + (((ga(la, Ea) | 0) + ja | 0) * 3 | 0) | 0;
                                    if (Ga << 24 >> 24 == 0) { Sa = 1 } else {
                                        Ga = oa + (ia * 3 | 0) | 0;
                                        Sa = ((d[Ga] | d[Ga + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    Ga = oa + (ia * 3 | 0) | 0;
                                    Pa = ((d[Ja] | d[Ja + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Ra;
                                    Qa = ((d[Ga] | d[Ga + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Sa
                                }
                                Ga = ta * 10 | 0;
                                Ja = -ta | 0;
                                Ea = fa - 1 | 0;
                                xa = (Ka | 0) >= (ya | 0) | Pa ^ 1;
                                Ha = (za | 0) >= (ya | 0) | Qa ^ 1;
                                ya = ta >> 1;
                                Ia = -ya | 0;
                                Ba = fa | 1;
                                Ta = fa + r | 0;
                                Ua = fa - 2 | 0;
                                Va = fa - Y | 0;
                                Wa = fa - r | 0;
                                Xa = ta << 1;
                                Ya = 0;
                                Za = pa;
                                _a = qa;
                                $a = sa;
                                ab = Da;
                                bb = Ca;
                                cb = Aa;
                                while (1) {
                                    db = a[n + (Ya << 2) + 3 | 0] | 0;
                                    eb = a[m + (Ya << 2) + 3 | 0] | 0;
                                    do {
                                        if (Fa) {
                                            fb = ab & 255;
                                            gb = Za & 255;
                                            hb = bb & 255;
                                            ib = _a & 255;
                                            jb = ((fb - gb | 0) * 9 | 0) + 8 + ((hb - ib | 0) * -3 | 0) >> 4;
                                            if ((((jb | 0) < 0 ? -jb | 0 : jb) | 0) >= (Ga | 0)) { break }
                                            if ((jb | 0) < (Ja | 0)) { kb = Ja } else { kb = (jb | 0) > (ta | 0) ? ta : jb }
                                            do {
                                                if (f) {
                                                    if (Pa) {
                                                        jb = kb + gb | 0;
                                                        if ((jb | 0) < 0) { lb = 0 } else { lb = (jb | 0) > (b | 0) ? s : jb & 255 }
                                                        jb = ea + (Ea + (ga(Ya, r) | 0)) | 0;
                                                        a[jb] = lb
                                                    }
                                                    if (!Qa) { break }
                                                    jb = fb - kb | 0;
                                                    if ((jb | 0) < 0) { mb = 0 } else { mb = (jb | 0) > (b | 0) ? s : jb & 255 }
                                                    jb = ea + ((ga(Ya, r) | 0) + fa) | 0;
                                                    a[jb] = mb
                                                } else {
                                                    if (Pa) {
                                                        jb = kb + gb | 0;
                                                        if ((jb | 0) < 0) { nb = 0 } else { nb = (jb | 0) > (b | 0) ? s : jb & 255 }
                                                        a[ea + (Wa + Ya) | 0] = nb
                                                    }
                                                    if (!Qa) { break }
                                                    jb = fb - kb | 0;
                                                    if ((jb | 0) < 0) { ob = 0 } else { ob = (jb | 0) > (b | 0) ? s : jb & 255 }
                                                    a[ea + (Ya + fa) | 0] = ob
                                                }
                                            } while (0);
                                            do {
                                                if (!xa) {
                                                    jb = kb + (((gb + 1 + ($a & 255) | 0) >>> 1) - ib) | 0;
                                                    pb = jb >> 1;
                                                    if ((pb | 0) < (Ia | 0)) { qb = Ia } else { qb = ((pb | 0) > (ya | 0) ? ta : jb) >> 1 }
                                                    jb = qb + ib | 0;
                                                    pb = (jb | 0) < 0;
                                                    if (f) {
                                                        if (pb) { rb = 0 } else { rb = (jb | 0) > (b | 0) ? s : jb & 255 }
                                                        sb = ea + (Ua + (ga(Ya, r) | 0)) | 0;
                                                        a[sb] = rb;
                                                        break
                                                    } else {
                                                        if (pb) { tb = 0 } else { tb = (jb | 0) > (b | 0) ? s : jb & 255 }
                                                        a[ea + (Va + Ya) | 0] = tb;
                                                        break
                                                    }
                                                }
                                            } while (0);
                                            if (Ha) { break }
                                            ib = ((fb + 1 + (cb & 255) | 0) >>> 1) - hb - kb | 0;
                                            gb = ib >> 1;
                                            if ((gb | 0) < (Ia | 0)) { ub = Ia } else { ub = ((gb | 0) > (ya | 0) ? ta : ib) >> 1 }
                                            ib = ub + hb | 0;
                                            gb = (ib | 0) < 0;
                                            if (f) {
                                                if (gb) { vb = 0 } else { vb = (ib | 0) > (b | 0) ? s : ib & 255 }
                                                jb = ea + (Ba + (ga(Ya, r) | 0)) | 0;
                                                a[jb] = vb;
                                                break
                                            } else {
                                                if (gb) { wb = 0 } else { wb = (ib | 0) > (b | 0) ? s : ib & 255 }
                                                a[ea + (Ta + Ya) | 0] = wb;
                                                break
                                            }
                                        } else {
                                            ib = $a & 255;
                                            gb = _a & 255;
                                            jb = Za & 255;
                                            pb = ab & 255;
                                            sb = pb << 1;
                                            xb = bb & 255;
                                            yb = (jb << 1) + 4 | 0;
                                            zb = yb + (gb << 1) + ib + sb + xb >> 3;
                                            Ab = jb - Xa | 0;
                                            do { if ((zb | 0) < (Ab | 0)) { Bb = Ab & 255 } else { Cb = jb + Xa | 0; if ((zb | 0) > (Cb | 0)) { Bb = Cb & 255; break } else { Bb = zb & 255; break } } } while (0);
                                            zb = (jb + 2 + gb + ib + pb | 0) >>> 2;
                                            Ab = gb - Xa | 0;
                                            do { if ((zb | 0) < (Ab | 0)) { Db = Ab & 255 } else { hb = gb + Xa | 0; if ((zb | 0) > (hb | 0)) { Db = hb & 255; break } else { Db = zb & 255; break } } } while (0);
                                            zb = jb + 4 + gb + (ib * 3 | 0) + ((db & 255) << 1) + pb >> 3;
                                            Ab = ib - Xa | 0;
                                            do { if ((zb | 0) < (Ab | 0)) { Eb = Ab & 255 } else { hb = ib + Xa | 0; if ((zb | 0) > (hb | 0)) { Eb = hb & 255; break } else { Eb = zb & 255; break } } } while (0);
                                            zb = cb & 255;
                                            ib = yb + gb + sb + (xb << 1) + zb >> 3;
                                            Ab = pb - Xa | 0;
                                            do { if ((ib | 0) < (Ab | 0)) { Fb = Ab & 255 } else { hb = pb + Xa | 0; if ((ib | 0) > (hb | 0)) { Fb = hb & 255; break } else { Fb = ib & 255; break } } } while (0);
                                            ib = pb + jb + xb | 0;
                                            Ab = (zb + 2 + ib | 0) >>> 2;
                                            sb = xb - Xa | 0;
                                            do { if ((Ab | 0) < (sb | 0)) { Gb = sb & 255 } else { gb = xb + Xa | 0; if ((Ab | 0) > (gb | 0)) { Gb = gb & 255; break } else { Gb = Ab & 255; break } } } while (0);
                                            Ab = (ib + 4 + (zb * 3 | 0) + ((eb & 255) << 1) | 0) >>> 3;
                                            xb = zb - Xa | 0;
                                            do { if ((Ab | 0) < (xb | 0)) { Hb = xb & 255 } else { sb = zb + Xa | 0; if ((Ab | 0) > (sb | 0)) { Hb = sb & 255; break } else { Hb = Ab & 255; break } } } while (0);
                                            if (f) {
                                                Ab = (ga(Ya, r) | 0) + fa | 0;
                                                if (Pa) { a[ea + (Ab - 1) | 0] = Bb }
                                                if (Qa) { a[ea + Ab | 0] = Fb }
                                                if (Pa) { a[ea + (Ab - 2) | 0] = Db }
                                                if (Qa) { a[ea + (Ab + 1) | 0] = Gb }
                                                if (Pa) { a[ea + (Ab - 3) | 0] = Eb }
                                                if (!Qa) { break }
                                                a[ea + (Ab + 2) | 0] = Hb;
                                                break
                                            } else {
                                                Ab = Ya + fa | 0;
                                                if (Pa) { a[ea + (Ab - r) | 0] = Bb }
                                                if (Qa) { a[ea + Ab | 0] = Fb }
                                                if (Pa) { a[ea + (Ab - (r << 1)) | 0] = Db }
                                                if (Qa) { a[ea + (Ab + r) | 0] = Gb }
                                                if (Pa) { a[ea + (Ab + (r * -3 | 0)) | 0] = Eb }
                                                if (!Qa) { break }
                                                a[ea + (Ab + (r << 1)) | 0] = Hb;
                                                break
                                            }
                                        }
                                    } while (0);
                                    eb = Ya + 1 | 0;
                                    if ((eb | 0) >= 4) { break b }
                                    Ya = eb;
                                    Za = a[n + (eb << 2) | 0] | 0;
                                    _a = a[n + (eb << 2) + 1 | 0] | 0;
                                    $a = a[n + (eb << 2) + 2 | 0] | 0;
                                    ab = a[m + (eb << 2) | 0] | 0;
                                    bb = a[m + (eb << 2) + 1 | 0] | 0;
                                    cb = a[m + (eb << 2) + 2 | 0] | 0
                                }
                            }
                        } while (0);
                        aa = aa + o | 0;
                    } while ((aa | 0) < (v | 0))
                }
                aa = Z + p | 0;
                if ((aa | 0) < (k | 0)) { Z = aa } else { ka = 146; break }
            }
            if ((ka | 0) == 12) { ec(8880, 6264, 118, 17352) } else if ((ka | 0) == 15) { ec(4520, 6264, 119, 17352) } else if ((ka | 0) == 18) { ec(8880, 6264, 118, 17352) } else if ((ka | 0) == 21) { ec(4520, 6264, 119, 17352) } else if ((ka | 0) == 25) { ec(8880, 6264, 118, 17352) } else if ((ka | 0) == 28) { ec(4520, 6264, 119, 17352) } else if ((ka | 0) == 43) { ec(8880, 6264, 118, 17352) } else if ((ka | 0) == 46) { ec(8880, 6264, 118, 17352) } else if ((ka | 0) == 52) { ec(4520, 6264, 119, 17352) } else if ((ka | 0) == 55) { ec(4520, 6264, 119, 17352) } else if ((ka | 0) == 146) { i = l; return }
        }

        function ze(f, g, h, j, k, l) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0;
            m = i;
            i = i + 32 | 0;
            n = m | 0;
            o = m + 16 | 0;
            p = c[f + 5780 >> 2] | 0;
            q = c[f + 5784 >> 2] | 0;
            r = ga(p, g ? 2 : 1) | 0;
            s = ga(q, g ? 1 : 2) | 0;
            t = f + 44 | 0;
            u = c[t >> 2] | 0;
            v = c[f + 10472 >> 2] | 0;
            w = (v | 0) > (l | 0) ? l : v;
            l = c[f + 10476 >> 2] | 0;
            x = (l | 0) > (j | 0) ? j : l;
            l = c[f + 5768 >> 2] | 0;
            if ((x | 0) <= (h | 0)) { i = m; return }
            j = (w | 0) > (k | 0);
            y = 3 - p | 0;
            z = 3 - q | 0;
            A = f + 10460 | 0;
            B = f + 5952 | 0;
            C = f + 5956 | 0;
            D = f + 10368 | 0;
            E = f + 10372 | 0;
            F = f + 10376 | 0;
            G = f + 10360 | 0;
            H = f + 5776 | 0;
            I = f + 10348 | 0;
            J = f + 10352 | 0;
            K = f + 10356 | 0;
            L = f + 10340 | 0;
            M = f + 48 | 0;
            N = f + 5480 | 0;
            O = (1 << l) - 1 | 0;
            P = O & 65535;
            Q = h;
            a: while (1) {
                if (j) {
                    h = Q << z;
                    R = ga(h, q) | 0;
                    S = (R | 0) / 4 | 0;
                    T = R - 1 | 0;
                    U = c[A >> 2] | 0;
                    V = k;
                    do {
                        W = V << y;
                        X = ga(W, p) | 0;
                        Y = U + ((ga(v, S) | 0) + ((X | 0) / 4 | 0)) | 0;
                        Z = a[Y] & 3;
                        if ((Z & 255) >>> 0 > 1 >>> 0) {
                            Y = X - 1 | 0;
                            _ = ((Z & 255) << 1) - 2 | 0;
                            Z = 0;
                            do {
                                $ = c[((Z | 0) == 0 ? B : C) >> 2] | 0;
                                Z = Z + 1 | 0;
                                aa = (c[f + 4 + (Z << 2) >> 2] | 0) + ((ga(c[t >> 2] | 0, h) | 0) + W << 1) | 0;
                                ba = 0;
                                while (1) {
                                    ca = ~ba;
                                    da = ga(ba, u) | 0;
                                    ea = ba + 1 | 0;
                                    fa = ga(ea, u) | 0;
                                    if (g) {
                                        b[o + (ba << 3) >> 1] = b[aa + (ba << 1) >> 1] | 0;
                                        b[n + (ba << 3) >> 1] = b[aa + (ca << 1) >> 1] | 0;
                                        b[o + (ba << 3) + 2 >> 1] = b[aa + (u + ba << 1) >> 1] | 0;
                                        b[n + (ba << 3) + 2 >> 1] = b[aa + (u + ca << 1) >> 1] | 0;
                                        ha = u << 1;
                                        b[o + (ba << 3) + 4 >> 1] = b[aa + (ha + ba << 1) >> 1] | 0;
                                        b[n + (ba << 3) + 4 >> 1] = b[aa + (ha + ca << 1) >> 1] | 0;
                                        ha = u * 3 | 0;
                                        b[o + (ba << 3) + 6 >> 1] = b[aa + (ha + ba << 1) >> 1] | 0;
                                        b[n + (ba << 3) + 6 >> 1] = b[aa + (ha + ca << 1) >> 1] | 0
                                    } else {
                                        b[o + (ba << 3) >> 1] = b[aa + (da << 1) >> 1] | 0;
                                        b[n + (ba << 3) >> 1] = b[aa + (-fa << 1) >> 1] | 0;
                                        b[o + (ba << 3) + 2 >> 1] = b[aa + (da + 1 << 1) >> 1] | 0;
                                        b[n + (ba << 3) + 2 >> 1] = b[aa + (1 - fa << 1) >> 1] | 0;
                                        b[o + (ba << 3) + 4 >> 1] = b[aa + (da + 2 << 1) >> 1] | 0;
                                        b[n + (ba << 3) + 4 >> 1] = b[aa + (2 - fa << 1) >> 1] | 0;
                                        b[o + (ba << 3) + 6 >> 1] = b[aa + (da + 3 << 1) >> 1] | 0;
                                        b[n + (ba << 3) + 6 >> 1] = b[aa + (3 - fa << 1) >> 1] | 0
                                    }
                                    if ((ea | 0) < 2) { ba = ea } else { break }
                                }
                                ba = c[D >> 2] | 0;
                                ea = X >> ba;
                                fa = R >> ba;
                                if (!((ea | 0) > -1)) { ia = 14; break a }
                                da = c[E >> 2] | 0;
                                if ((ea | 0) >= (da | 0)) { ia = 14; break a }
                                if (!((fa | 0) > -1)) { ia = 17; break a }
                                ca = c[F >> 2] | 0;
                                if ((fa | 0) >= (ca | 0)) { ia = 17; break a }
                                ha = ga(da, fa) | 0;
                                fa = ha + ea | 0;
                                ja = c[G >> 2] | 0;
                                ka = a[ja + (fa * 3 | 0) + 2 | 0] | 0;
                                if (g) {
                                    la = Y >> ba;
                                    if (!((la | 0) > -1 & (la | 0) < (da | 0))) { ia = 20; break a }
                                    ma = ha + la | 0
                                } else {
                                    la = T >> ba;
                                    if (!((la | 0) > -1 & (la | 0) < (ca | 0))) { ia = 23; break a }
                                    ma = (ga(da, la) | 0) + ea | 0
                                }
                                la = (ka + 1 + (a[ja + (ma * 3 | 0) + 2 | 0] | 0) >> 1) + $ | 0;
                                do { if ((c[H >> 2] | 0) == 1) { if ((la | 0) < 30) { na = la; break } if ((la | 0) > 42) { na = la - 6 | 0; break } else { na = c[8 + (la - 30 << 2) >> 2] | 0; break } } else { na = (la | 0) < 51 ? la : 51 } } while (0);
                                la = c[I >> 2] | 0;
                                $ = X >> la;
                                ka = R >> la;
                                if (!(($ | 0) > -1)) { ia = 33; break a }
                                la = c[J >> 2] | 0;
                                if (($ | 0) >= (la | 0)) { ia = 33; break a }
                                if (!((ka | 0) > -1)) { ia = 36; break a }
                                if ((ka | 0) >= (c[K >> 2] | 0)) { ia = 36; break a }
                                oa = (ga(la, ka) | 0) + $ | 0;
                                $ = _ + na + (c[(c[(c[M >> 2] | 0) + (e[(c[L >> 2] | 0) + (oa * 24 | 0) + 2 >> 1] << 2) >> 2] | 0) + 760 >> 2] | 0) | 0;
                                if (($ | 0) < 0) { pa = 0 } else { pa = ($ | 0) > 53 ? 53 : $ }
                                $ = d[30664 + pa | 0] << l - 8;
                                oa = (a[N] | 0) == 0;
                                if (g) {
                                    ka = Y >> ba;
                                    if (oa) { qa = 1 } else {
                                        if (!((ka | 0) > -1 & (ka | 0) < (da | 0))) { ia = 42; break a }
                                        la = ja + ((ha + ka | 0) * 3 | 0) | 0;
                                        qa = ((d[la] | d[la + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    if (!((ka | 0) > -1 & (ka | 0) < (da | 0))) { ia = 45; break a }
                                    la = ja + ((ha + ka | 0) * 3 | 0) | 0;
                                    ka = ((d[la] | d[la + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & qa;
                                    if (oa) { ra = 1 } else {
                                        la = ja + (fa * 3 | 0) | 0;
                                        ra = ((d[la] | d[la + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    la = ja + (fa * 3 | 0) | 0;
                                    sa = ((d[la] | d[la + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & ra;
                                    la = -$ | 0;
                                    ta = 0;
                                    do {
                                        ua = e[o + (ta << 1) >> 1] | 0;
                                        va = e[n + (ta << 1) >> 1] | 0;
                                        wa = (e[n + 8 + (ta << 1) >> 1] | 0) + 4 + (ua - va << 2) - (e[o + 8 + (ta << 1) >> 1] | 0) >> 3;
                                        if ((wa | 0) < (la | 0)) { xa = la } else { xa = (wa | 0) > ($ | 0) ? $ : wa }
                                        if (ka) {
                                            wa = va + xa | 0;
                                            if ((wa | 0) < 0) { ya = 0 } else { ya = (wa | 0) > (O | 0) ? P : wa & 65535 }
                                            wa = aa + ((ga(ta, u) | 0) - 1 << 1) | 0;
                                            b[wa >> 1] = ya
                                        }
                                        if (sa) {
                                            wa = ua - xa | 0;
                                            if ((wa | 0) < 0) { za = 0 } else { za = (wa | 0) > (O | 0) ? P : wa & 65535 }
                                            wa = aa + ((ga(ta, u) | 0) << 1) | 0;
                                            b[wa >> 1] = za
                                        }
                                        ta = ta + 1 | 0;
                                    } while ((ta | 0) < 4)
                                } else {
                                    ta = T >> ba;
                                    if (oa) { Aa = 1 } else {
                                        if (!((ta | 0) > -1 & (ta | 0) < (ca | 0))) { ia = 62; break a }
                                        sa = ja + (((ga(da, ta) | 0) + ea | 0) * 3 | 0) | 0;
                                        Aa = ((d[sa] | d[sa + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    if (!((ta | 0) > -1 & (ta | 0) < (ca | 0))) { ia = 65; break a }
                                    sa = ja + (((ga(da, ta) | 0) + ea | 0) * 3 | 0) | 0;
                                    ta = ((d[sa] | d[sa + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Aa;
                                    if (oa) { Ba = 1 } else {
                                        sa = ja + (fa * 3 | 0) | 0;
                                        Ba = ((d[sa] | d[sa + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    sa = ja + (fa * 3 | 0) | 0;
                                    ka = ((d[sa] | d[sa + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Ba;
                                    sa = -$ | 0;
                                    la = 0;
                                    do {
                                        ha = e[o + (la << 1) >> 1] | 0;
                                        wa = e[n + (la << 1) >> 1] | 0;
                                        ua = (e[n + 8 + (la << 1) >> 1] | 0) + 4 + (ha - wa << 2) - (e[o + 8 + (la << 1) >> 1] | 0) >> 3;
                                        if ((ua | 0) < (sa | 0)) { Ca = sa } else { Ca = (ua | 0) > ($ | 0) ? $ : ua }
                                        if (ta) {
                                            ua = wa + Ca | 0;
                                            if ((ua | 0) < 0) { Da = 0 } else { Da = (ua | 0) > (O | 0) ? P : ua & 65535 }
                                            b[aa + (la - u << 1) >> 1] = Da
                                        }
                                        if (ka) {
                                            ua = ha - Ca | 0;
                                            if ((ua | 0) < 0) { Ea = 0 } else { Ea = (ua | 0) > (O | 0) ? P : ua & 65535 }
                                            b[aa + (la << 1) >> 1] = Ea
                                        }
                                        la = la + 1 | 0;
                                    } while ((la | 0) < 4)
                                }
                            } while ((Z | 0) < 2)
                        }
                        V = V + r | 0;
                    } while ((V | 0) < (w | 0))
                }
                V = Q + s | 0;
                if ((V | 0) < (x | 0)) { Q = V } else { ia = 82; break }
            }
            if ((ia | 0) == 14) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 17) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 20) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 23) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 33) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 36) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 42) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 45) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 62) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 65) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 82) { i = m; return }
        }

        function Ae(b, f, g, h, j, k) {
            b = b | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0;
            l = i;
            i = i + 16 | 0;
            m = l | 0;
            n = l + 8 | 0;
            o = c[b + 5780 >> 2] | 0;
            p = c[b + 5784 >> 2] | 0;
            q = ga(o, f ? 2 : 1) | 0;
            r = ga(p, f ? 1 : 2) | 0;
            s = b + 44 | 0;
            t = c[s >> 2] | 0;
            u = b + 10472 | 0;
            v = c[u >> 2] | 0;
            w = (v | 0) > (k | 0) ? k : v;
            v = c[b + 10476 >> 2] | 0;
            k = (v | 0) > (h | 0) ? h : v;
            v = b + 5768 | 0;
            if ((k | 0) <= (g | 0)) { i = l; return }
            h = (w | 0) > (j | 0);
            x = 3 - o | 0;
            y = 3 - p | 0;
            z = b + 10460 | 0;
            A = b + 5952 | 0;
            B = b + 5956 | 0;
            C = b + 10368 | 0;
            D = b + 10372 | 0;
            E = b + 10376 | 0;
            F = b + 10360 | 0;
            G = b + 5776 | 0;
            H = b + 10348 | 0;
            I = b + 10352 | 0;
            J = b + 10356 | 0;
            K = b + 10340 | 0;
            L = b + 48 | 0;
            M = b + 5480 | 0;
            N = (1 << c[v >> 2]) - 1 | 0;
            O = N & 255;
            P = g;
            a: while (1) {
                if (h) {
                    g = P << y;
                    Q = ga(g, p) | 0;
                    R = (Q | 0) / 4 | 0;
                    S = Q - 1 | 0;
                    T = j;
                    do {
                        U = T << x;
                        V = ga(U, o) | 0;
                        W = (ga(c[u >> 2] | 0, R) | 0) + ((V | 0) / 4 | 0) | 0;
                        X = a[(c[z >> 2] | 0) + W | 0] & 3;
                        if ((X & 255) >>> 0 > 1 >>> 0) {
                            W = V - 1 | 0;
                            Y = ((X & 255) << 1) - 2 | 0;
                            X = 0;
                            do {
                                Z = c[((X | 0) == 0 ? A : B) >> 2] | 0;
                                X = X + 1 | 0;
                                _ = c[b + 4 + (X << 2) >> 2] | 0;
                                $ = (ga(c[s >> 2] | 0, g) | 0) + U | 0;
                                aa = 0;
                                while (1) {
                                    ba = aa + $ | 0;
                                    ca = $ + ~aa | 0;
                                    da = (ga(aa, t) | 0) + $ | 0;
                                    ea = aa + 1 | 0;
                                    fa = $ - (ga(ea, t) | 0) | 0;
                                    if (f) {
                                        a[n + (aa << 2) | 0] = a[_ + ba | 0] | 0;
                                        a[m + (aa << 2) | 0] = a[_ + ca | 0] | 0;
                                        a[n + (aa << 2) + 1 | 0] = a[_ + (ba + t) | 0] | 0;
                                        a[m + (aa << 2) + 1 | 0] = a[_ + (ca + t) | 0] | 0;
                                        ha = t << 1;
                                        a[n + (aa << 2) + 2 | 0] = a[_ + (ba + ha) | 0] | 0;
                                        a[m + (aa << 2) + 2 | 0] = a[_ + (ca + ha) | 0] | 0;
                                        ha = t * 3 | 0;
                                        a[n + (aa << 2) + 3 | 0] = a[_ + (ba + ha) | 0] | 0;
                                        a[m + (aa << 2) + 3 | 0] = a[_ + (ca + ha) | 0] | 0
                                    } else {
                                        a[n + (aa << 2) | 0] = a[_ + da | 0] | 0;
                                        a[m + (aa << 2) | 0] = a[_ + fa | 0] | 0;
                                        a[n + (aa << 2) + 1 | 0] = a[_ + (da + 1) | 0] | 0;
                                        a[m + (aa << 2) + 1 | 0] = a[_ + (fa + 1) | 0] | 0;
                                        a[n + (aa << 2) + 2 | 0] = a[_ + (da + 2) | 0] | 0;
                                        a[m + (aa << 2) + 2 | 0] = a[_ + (fa + 2) | 0] | 0;
                                        a[n + (aa << 2) + 3 | 0] = a[_ + (da + 3) | 0] | 0;
                                        a[m + (aa << 2) + 3 | 0] = a[_ + (fa + 3) | 0] | 0
                                    }
                                    if ((ea | 0) < 2) { aa = ea } else { break }
                                }
                                aa = c[C >> 2] | 0;
                                ea = V >> aa;
                                fa = Q >> aa;
                                if (!((ea | 0) > -1)) { ia = 14; break a }
                                da = c[D >> 2] | 0;
                                if ((ea | 0) >= (da | 0)) { ia = 14; break a }
                                if (!((fa | 0) > -1)) { ia = 17; break a }
                                ha = c[E >> 2] | 0;
                                if ((fa | 0) >= (ha | 0)) { ia = 17; break a }
                                ca = ga(da, fa) | 0;
                                fa = ca + ea | 0;
                                ba = c[F >> 2] | 0;
                                ja = a[ba + (fa * 3 | 0) + 2 | 0] | 0;
                                if (f) {
                                    ka = W >> aa;
                                    if (!((ka | 0) > -1 & (ka | 0) < (da | 0))) { ia = 20; break a }
                                    la = ca + ka | 0
                                } else {
                                    ka = S >> aa;
                                    if (!((ka | 0) > -1 & (ka | 0) < (ha | 0))) { ia = 23; break a }
                                    la = (ga(da, ka) | 0) + ea | 0
                                }
                                ka = (ja + 1 + (a[ba + (la * 3 | 0) + 2 | 0] | 0) >> 1) + Z | 0;
                                do { if ((c[G >> 2] | 0) == 1) { if ((ka | 0) < 30) { ma = ka; break } if ((ka | 0) > 42) { ma = ka - 6 | 0; break } else { ma = c[8 + (ka - 30 << 2) >> 2] | 0; break } } else { ma = (ka | 0) < 51 ? ka : 51 } } while (0);
                                ka = c[H >> 2] | 0;
                                Z = V >> ka;
                                ja = Q >> ka;
                                if (!((Z | 0) > -1)) { ia = 33; break a }
                                ka = c[I >> 2] | 0;
                                if ((Z | 0) >= (ka | 0)) { ia = 33; break a }
                                if (!((ja | 0) > -1)) { ia = 36; break a }
                                if ((ja | 0) >= (c[J >> 2] | 0)) { ia = 36; break a }
                                na = (ga(ka, ja) | 0) + Z | 0;
                                Z = Y + ma + (c[(c[(c[L >> 2] | 0) + (e[(c[K >> 2] | 0) + (na * 24 | 0) + 2 >> 1] << 2) >> 2] | 0) + 760 >> 2] | 0) | 0;
                                if ((Z | 0) < 0) { oa = 0 } else { oa = (Z | 0) > 53 ? 53 : Z }
                                Z = d[30664 + oa | 0] << (c[v >> 2] | 0) - 8;
                                na = (a[M] | 0) == 0;
                                if (f) {
                                    ja = W >> aa;
                                    if (na) { pa = 1 } else {
                                        if (!((ja | 0) > -1 & (ja | 0) < (da | 0))) { ia = 42; break a }
                                        ka = ba + ((ca + ja | 0) * 3 | 0) | 0;
                                        pa = ((d[ka] | d[ka + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    if (!((ja | 0) > -1 & (ja | 0) < (da | 0))) { ia = 45; break a }
                                    ka = ba + ((ca + ja | 0) * 3 | 0) | 0;
                                    ja = ((d[ka] | d[ka + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & pa;
                                    if (na) { qa = 1 } else {
                                        ka = ba + (fa * 3 | 0) | 0;
                                        qa = ((d[ka] | d[ka + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    ka = ba + (fa * 3 | 0) | 0;
                                    ra = ((d[ka] | d[ka + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & qa;
                                    ka = -Z | 0;
                                    sa = $ - 1 | 0;
                                    ta = 0;
                                    do {
                                        ua = d[n + ta | 0] | 0;
                                        va = d[m + ta | 0] | 0;
                                        wa = (d[m + 4 + ta | 0] | 0) + 4 + (ua - va << 2) - (d[n + 4 + ta | 0] | 0) >> 3;
                                        if ((wa | 0) < (ka | 0)) { xa = ka } else { xa = (wa | 0) > (Z | 0) ? Z : wa }
                                        if (ja) {
                                            wa = va + xa | 0;
                                            if ((wa | 0) < 0) { ya = 0 } else { ya = (wa | 0) > (N | 0) ? O : wa & 255 }
                                            wa = _ + (sa + (ga(ta, t) | 0)) | 0;
                                            a[wa] = ya
                                        }
                                        if (ra) {
                                            wa = ua - xa | 0;
                                            if ((wa | 0) < 0) { za = 0 } else { za = (wa | 0) > (N | 0) ? O : wa & 255 }
                                            wa = _ + ((ga(ta, t) | 0) + $) | 0;
                                            a[wa] = za
                                        }
                                        ta = ta + 1 | 0;
                                    } while ((ta | 0) < 4)
                                } else {
                                    ta = S >> aa;
                                    if (na) { Aa = 1 } else {
                                        if (!((ta | 0) > -1 & (ta | 0) < (ha | 0))) { ia = 62; break a }
                                        ra = ba + (((ga(da, ta) | 0) + ea | 0) * 3 | 0) | 0;
                                        Aa = ((d[ra] | d[ra + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    if (!((ta | 0) > -1 & (ta | 0) < (ha | 0))) { ia = 65; break a }
                                    ra = ba + (((ga(da, ta) | 0) + ea | 0) * 3 | 0) | 0;
                                    ta = ((d[ra] | d[ra + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Aa;
                                    if (na) { Ba = 1 } else {
                                        ra = ba + (fa * 3 | 0) | 0;
                                        Ba = ((d[ra] | d[ra + 1 | 0] << 8) << 16 >> 16 & 1024) == 0
                                    }
                                    ra = ba + (fa * 3 | 0) | 0;
                                    sa = ((d[ra] | d[ra + 1 | 0] << 8) << 16 >> 16 & 2048) == 0 & Ba;
                                    ra = -Z | 0;
                                    ja = $ - t | 0;
                                    ka = 0;
                                    do {
                                        ca = d[n + ka | 0] | 0;
                                        wa = d[m + ka | 0] | 0;
                                        ua = (d[m + 4 + ka | 0] | 0) + 4 + (ca - wa << 2) - (d[n + 4 + ka | 0] | 0) >> 3;
                                        if ((ua | 0) < (ra | 0)) { Ca = ra } else { Ca = (ua | 0) > (Z | 0) ? Z : ua }
                                        if (ta) {
                                            ua = wa + Ca | 0;
                                            if ((ua | 0) < 0) { Da = 0 } else { Da = (ua | 0) > (N | 0) ? O : ua & 255 }
                                            a[_ + (ja + ka) | 0] = Da
                                        }
                                        if (sa) {
                                            ua = ca - Ca | 0;
                                            if ((ua | 0) < 0) { Ea = 0 } else { Ea = (ua | 0) > (N | 0) ? O : ua & 255 }
                                            a[_ + (ka + $) | 0] = Ea
                                        }
                                        ka = ka + 1 | 0;
                                    } while ((ka | 0) < 4)
                                }
                            } while ((X | 0) < 2)
                        }
                        T = T + q | 0;
                    } while ((T | 0) < (w | 0))
                }
                T = P + r | 0;
                if ((T | 0) < (k | 0)) { P = T } else { ia = 82; break }
            }
            if ((ia | 0) == 14) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 17) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 20) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 23) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 33) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 36) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 42) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 45) { ec(8880, 6264, 118, 17352) } else if ((ia | 0) == 62) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 65) { ec(4520, 6264, 119, 17352) } else if ((ia | 0) == 82) { i = l; return }
        }

        function Be(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0;
            d = b | 0;
            e = b + 4 | 0;
            c[e >> 2] = 1;
            f = b + 8 | 0;
            Wh(c[f >> 2] | 0, d);
            g = c[f >> 2] | 0;
            h = c[g + 10472 >> 2] | 0;
            i = (c[g + 5812 >> 2] | 0) / 4 | 0;
            j = b + 12 | 0;
            k = c[j >> 2] | 0;
            l = ga(k, i) | 0;
            m = k + 1 | 0;
            n = ga(m, i) | 0;
            i = c[g + 10476 >> 2] | 0;
            o = (n | 0) > (i | 0) ? i : n;
            n = b + 16 | 0;
            b = (a[n] | 0) != 0;
            i = b ? 2 : 3;
            p = c[g + 5820 >> 2] | 0;
            q = p - 1 | 0;
            do {
                if (b) {
                    r = (c[g + 5828 >> 2] | 0) - 1 | 0;
                    Yh(g, d, q, (r | 0) < (m | 0) ? r : m, 1)
                } else {
                    if ((k | 0) > 0) {
                        Yh(g, d, q, k - 1 | 0, 2);
                        s = c[f >> 2] | 0;
                        t = c[j >> 2] | 0
                    } else {
                        s = g;
                        t = k
                    }
                    Yh(s, d, q, t, 2);
                    r = (c[j >> 2] | 0) + 1 | 0;
                    u = c[f >> 2] | 0;
                    if ((r | 0) >= (c[u + 5828 >> 2] | 0)) { break }
                    Yh(u, d, q, r, 2)
                }
            } while (0);
            t = c[f >> 2] | 0;
            s = c[j >> 2] | 0;
            do {
                if ((a[n] | 0) == 0) {
                    k = ga(c[t + 10352 >> 2] | 0, s) | 0;
                    if ((a[(c[t + 10340 >> 2] | 0) + (k * 24 | 0) + 21 | 0] | 0) != 0) {
                        v = t;
                        w = 0;
                        x = 11
                    }
                } else {
                    k = ve(t, s) | 0;
                    g = c[f >> 2] | 0;
                    m = ga(c[g + 10352 >> 2] | 0, c[j >> 2] | 0) | 0;
                    a[(c[g + 10340 >> 2] | 0) + (m * 24 | 0) + 21 | 0] = k & 1;
                    if (!k) { break }
                    v = g;
                    w = (a[n] | 0) != 0;
                    x = 11
                }
            } while (0);
            do {
                if ((x | 0) == 11) {
                    we(v, w, l, o, 0, h);
                    s = c[f >> 2] | 0;
                    t = (a[n] | 0) != 0;
                    if ((c[s + 5760 >> 2] | 0) > 8) { xe(s, t, l, o, 0, h) } else { ye(s, t, l, o, 0, h) }
                    t = c[f >> 2] | 0;
                    if ((c[t + 5776 >> 2] | 0) == 0) { break }
                    s = (a[n] | 0) != 0;
                    if ((c[t + 5768 >> 2] | 0) > 8) { ze(t, s, l, o, 0, h); break } else { Ae(t, s, l, o, 0, h); break }
                }
            } while (0);
            if ((p | 0) < 1) {
                c[e >> 2] = 3;
                y = c[f >> 2] | 0;
                Xh(y, d);
                return
            } else { z = 0 }
            while (1) {
                p = c[f >> 2] | 0;
                h = (ga(c[j >> 2] | 0, c[p + 5820 >> 2] | 0) | 0) + z | 0;
                Ek((c[p + 10524 >> 2] | 0) + (h * 76 | 0) | 0, i);
                if ((z | 0) >= (q | 0)) { break }
                z = z + 1 | 0
            }
            c[e >> 2] = 3;
            y = c[f >> 2] | 0;
            Xh(y, d);
            return
        }

        function Ce(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            d = i;
            i = i + 8 | 0;
            e = d | 0;
            f = c[b >> 2] | 0;
            g = c[f + 10332 >> 2] | 0;
            h = f + 5828 | 0;
            Vh(f, c[h >> 2] << 1);
            j = b + 10668 | 0;
            k = b + 10672 | 0;
            l = g + 375396 | 0;
            g = b + 10664 | 0;
            if ((c[h >> 2] | 0) > 0) { m = 0 } else { i = d; return }
            do {
                b = Nu(20) | 0;
                c[b + 4 >> 2] = 0;
                c[b >> 2] = 22184;
                c[b + 8 >> 2] = f;
                c[b + 12 >> 2] = m;
                a[b + 16 | 0] = 1;
                n = b;
                c[e >> 2] = n;
                b = c[j >> 2] | 0;
                if (b >>> 0 < (c[k >> 2] | 0) >>> 0) {
                    if ((b | 0) == 0) { o = 0 } else {
                        c[b >> 2] = n;
                        o = c[j >> 2] | 0
                    }
                    c[j >> 2] = o + 4
                } else { He(g, e) }
                Kk(l, n);
                m = m + 1 | 0;
                p = c[h >> 2] | 0;
            } while ((m | 0) < (p | 0));
            if ((p | 0) > 0) { q = 0 } else { i = d; return }
            do {
                p = Nu(20) | 0;
                c[p + 4 >> 2] = 0;
                c[p >> 2] = 22184;
                c[p + 8 >> 2] = f;
                c[p + 12 >> 2] = q;
                a[p + 16 | 0] = 0;
                m = p;
                c[e >> 2] = m;
                p = c[j >> 2] | 0;
                if (p >>> 0 < (c[k >> 2] | 0) >>> 0) {
                    if ((p | 0) == 0) { r = 0 } else {
                        c[p >> 2] = m;
                        r = c[j >> 2] | 0
                    }
                    c[j >> 2] = r + 4
                } else { He(g, e) }
                Kk(l, m);
                q = q + 1 | 0;
            } while ((q | 0) < (c[h >> 2] | 0));
            i = d;
            return
        }

        function De(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0;
            b = a + 5828 | 0;
            if ((c[b >> 2] | 0) > 0) {
                d = 0;
                e = 0
            } else { return }
            do {
                d = d | (ve(a, e) | 0);
                e = e + 1 | 0;
            } while ((e | 0) < (c[b >> 2] | 0));
            if (!d) { return }
            d = a + 10476 | 0;
            b = a + 10472 | 0;
            we(a, 1, 0, c[d >> 2] | 0, 0, c[b >> 2] | 0);
            e = c[d >> 2] | 0;
            f = c[b >> 2] | 0;
            g = a + 5760 | 0;
            if ((c[g >> 2] | 0) > 8) { xe(a, 1, 0, e, 0, f) } else { ye(a, 1, 0, e, 0, f) }
            f = a + 5776 | 0;
            do {
                if ((c[f >> 2] | 0) != 0) {
                    e = c[d >> 2] | 0;
                    h = c[b >> 2] | 0;
                    if ((c[a + 5768 >> 2] | 0) > 8) { ze(a, 1, 0, e, 0, h); break } else { Ae(a, 1, 0, e, 0, h); break }
                }
            } while (0);
            we(a, 0, 0, c[d >> 2] | 0, 0, c[b >> 2] | 0);
            h = c[d >> 2] | 0;
            e = c[b >> 2] | 0;
            if ((c[g >> 2] | 0) > 8) { xe(a, 0, 0, h, 0, e) } else { ye(a, 0, 0, h, 0, e) }
            if ((c[f >> 2] | 0) == 0) { return }
            f = c[d >> 2] | 0;
            d = c[b >> 2] | 0;
            if ((c[a + 5768 >> 2] | 0) > 8) { ze(a, 0, 0, f, 0, d); return } else { Ae(a, 0, 0, f, 0, d); return }
        }

        function Ee(a) { a = a | 0; return }

        function Fe(a) {
            a = a | 0;
            Pu(a);
            return
        }

        function Ge(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            e = i;
            i = i + 104 | 0;
            f = e | 0;
            mb(f | 0, 1888, (g = i, i = i + 8 | 0, c[g >> 2] = c[d + 12 >> 2], g) | 0) | 0;
            i = g;
            g = ev(f | 0) | 0;
            if (g >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (g >>> 0 < 11 >>> 0) {
                a[b] = g << 1;
                h = b + 1 | 0;
                cv(h | 0, f | 0, g) | 0;
                j = h + g | 0;
                a[j] = 0;
                k = 100;
                l = 0;
                i = e;
                return
            } else {
                d = g + 16 & -16;
                m = Nu(d) | 0;
                c[b + 8 >> 2] = m;
                c[b >> 2] = d | 1;
                c[b + 4 >> 2] = g;
                h = m;
                cv(h | 0, f | 0, g) | 0;
                j = h + g | 0;
                a[j] = 0;
                k = 100;
                l = 0;
                i = e;
                return
            }
        }

        function He(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = h >> 2;
            j = i + 1 | 0;
            if (j >>> 0 > 1073741823 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = (c[k >> 2] | 0) - g | 0;
            if (a >> 2 >>> 0 < 536870911 >>> 0) {
                g = a >> 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 1073741823;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n << 2) | 0;
                m = n
            }
            n = l + (i << 2) | 0;
            if ((n | 0) != 0) { c[n >> 2] = c[b >> 2] }
            b = f;
            cv(l | 0, b | 0, h) | 0;
            c[e >> 2] = l;
            c[d >> 2] = l + (j << 2);
            c[k >> 2] = l + (m << 2);
            if ((f | 0) == 0) { return }
            Pu(b);
            return
        }

        function Ie(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            d = a + 132 | 0;
            if ((c[d >> 2] | 0) != 0) { ec(1960, 14344, 169, 17808) }
            e = Ra(b | 0, 18624) | 0;
            f = K;
            g = sb(e | 0, 16) | 0;
            e = Ou(f | K ? -1 : g) | 0;
            c[e + 12 >> 2] = b;
            g = e + 16 | 0;
            if ((b | 0) == 0) {
                c[d >> 2] = g;
                h = a + 136 | 0;
                c[h >> 2] = b;
                return
            }
            e = g + (b * 18624 | 0) | 0;
            f = g;
            do {
                Cd(f + 18580 | 0);
                i = f + 48 | 0;
                j = i & 15;
                dv(f + 18508 | 0, 0, 20) | 0;
                dv(f + 18592 | 0, 0, 20) | 0;
                if ((j | 0) == 0) {
                    c[f + 2112 >> 2] = i;
                    k = i
                } else {
                    l = i + (16 - j) | 0;
                    c[f + 2112 >> 2] = l;
                    k = l
                }
                dv(k | 0, 0, 2048) | 0;
                f = f + 18624 | 0;
            } while ((f | 0) != (e | 0));
            c[d >> 2] = g;
            h = a + 136 | 0;
            c[h >> 2] = b;
            return
        }

        function Je(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            b = a + 10636 | 0;
            d = c[b >> 2] | 0;
            e = a + 10632 | 0;
            f = c[e >> 2] | 0;
            if ((d | 0) != (f | 0)) {
                g = 0;
                h = f;
                f = d;
                while (1) {
                    d = c[h + (g << 2) >> 2] | 0;
                    if ((d | 0) == 0) {
                        i = f;
                        j = h
                    } else {
                        Vi((c[d + 140 >> 2] | 0) + 548 | 0, c[d >> 2] | 0);
                        k = c[d + 132 >> 2] | 0;
                        if ((k | 0) != 0) {
                            l = k - 18624 + 18608 | 0;
                            m = l;
                            n = c[l + 12 >> 2] | 0;
                            if ((n | 0) != 0) {
                                l = k + (n * 18624 | 0) | 0;
                                while (1) {
                                    n = l - 18624 | 0;
                                    Ed(l - 18624 + 18580 | 0);
                                    if ((n | 0) == (k | 0)) { break } else { l = n }
                                }
                            }
                            Qu(m)
                        }
                        Ck(d + 44 | 0);
                        Pu(d);
                        i = c[b >> 2] | 0;
                        j = c[e >> 2] | 0
                    }
                    l = g + 1 | 0;
                    if (l >>> 0 < i - j >> 2 >>> 0) {
                        g = l;
                        h = j;
                        f = i
                    } else { break }
                }
            }
            i = a + 10668 | 0;
            f = c[i >> 2] | 0;
            j = a + 10664 | 0;
            h = c[j >> 2] | 0;
            if ((f | 0) == (h | 0)) { o = f } else {
                g = 0;
                l = h;
                h = f;
                while (1) {
                    f = c[l + (g << 2) >> 2] | 0;
                    if ((f | 0) == 0) {
                        p = h;
                        q = l
                    } else {
                        Dc[c[(c[f >> 2] | 0) + 4 >> 2] & 511](f);
                        p = c[i >> 2] | 0;
                        q = c[j >> 2] | 0
                    }
                    f = g + 1 | 0;
                    if (f >>> 0 < p - q >> 2 >>> 0) {
                        g = f;
                        l = q;
                        h = p
                    } else { o = q; break }
                }
            }
            q = a + 10676 | 0;
            p = c[q >> 2] | 0;
            if ((p | 0) == 0) { r = o } else {
                o = a + 10680 | 0;
                h = c[o >> 2] | 0;
                if ((h | 0) == (p | 0)) { s = p } else {
                    l = h;
                    do {
                        h = l - 8 | 0;
                        c[o >> 2] = h;
                        Ed(h);
                        l = c[o >> 2] | 0;
                    } while ((l | 0) != (p | 0));
                    s = c[q >> 2] | 0
                }
                Pu(s);
                r = c[j >> 2] | 0
            }
            if ((r | 0) != 0) {
                j = c[i >> 2] | 0;
                if ((j | 0) != (r | 0)) { c[i >> 2] = j + (~((j - 4 + (-r | 0) | 0) >>> 2) << 2) }
                Pu(r)
            }
            r = c[a + 10644 >> 2] | 0;
            if ((r | 0) != 0) {
                j = a + 10648 | 0;
                i = c[j >> 2] | 0;
                if ((i | 0) != (r | 0)) { c[j >> 2] = i + (~(((i - 80 + (-r | 0) | 0) >>> 0) / 80 | 0) * 80 | 0) }
                Pu(r)
            }
            r = c[e >> 2] | 0;
            if ((r | 0) == 0) {
                t = a + 8 | 0;
                Rh(t);
                return
            }
            e = c[b >> 2] | 0;
            if ((e | 0) != (r | 0)) { c[b >> 2] = e + (~((e - 4 + (-r | 0) | 0) >>> 2) << 2) }
            Pu(r);
            t = a + 8 | 0;
            Rh(t);
            return
        }

        function Ke(a, b) {
            a = a | 0;
            b = b | 0;
            Lf(a + 172 | 0);
            return
        }

        function Le(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            c[b + 84 >> 2] = 0;
            c[b + 168 >> 2] = 0;
            d = b | 0;
            c[d >> 2] = 22344;
            Lf(b + 172 | 0);
            c[d >> 2] = 22312;
            Si(b + 548 | 0);
            c[b + 1192 >> 2] = 0;
            c[b + 1196 >> 2] = 0;
            c[b + 1200 >> 2] = 0;
            dv(b + 1228 | 0, 0, 24) | 0;
            c[b + 1848 >> 2] = 0;
            c[b + 1852 >> 2] = 0;
            c[b + 1856 >> 2] = 0;
            dv(b + 1884 | 0, 0, 24) | 0;
            c[b + 2504 >> 2] = 0;
            c[b + 2508 >> 2] = 0;
            c[b + 2512 >> 2] = 0;
            dv(b + 2540 | 0, 0, 24) | 0;
            c[b + 3160 >> 2] = 0;
            c[b + 3164 >> 2] = 0;
            c[b + 3168 >> 2] = 0;
            dv(b + 3196 | 0, 0, 24) | 0;
            c[b + 3816 >> 2] = 0;
            c[b + 3820 >> 2] = 0;
            c[b + 3824 >> 2] = 0;
            dv(b + 3852 | 0, 0, 24) | 0;
            c[b + 4472 >> 2] = 0;
            c[b + 4476 >> 2] = 0;
            c[b + 4480 >> 2] = 0;
            dv(b + 4508 | 0, 0, 24) | 0;
            c[b + 5128 >> 2] = 0;
            c[b + 5132 >> 2] = 0;
            c[b + 5136 >> 2] = 0;
            dv(b + 5164 | 0, 0, 24) | 0;
            c[b + 5784 >> 2] = 0;
            c[b + 5788 >> 2] = 0;
            c[b + 5792 >> 2] = 0;
            dv(b + 5820 | 0, 0, 24) | 0;
            c[b + 6440 >> 2] = 0;
            c[b + 6444 >> 2] = 0;
            c[b + 6448 >> 2] = 0;
            dv(b + 6476 | 0, 0, 24) | 0;
            c[b + 7096 >> 2] = 0;
            c[b + 7100 >> 2] = 0;
            c[b + 7104 >> 2] = 0;
            dv(b + 7132 | 0, 0, 24) | 0;
            c[b + 7752 >> 2] = 0;
            c[b + 7756 >> 2] = 0;
            c[b + 7760 >> 2] = 0;
            dv(b + 7788 | 0, 0, 24) | 0;
            c[b + 8408 >> 2] = 0;
            c[b + 8412 >> 2] = 0;
            c[b + 8416 >> 2] = 0;
            dv(b + 8444 | 0, 0, 24) | 0;
            c[b + 9064 >> 2] = 0;
            c[b + 9068 >> 2] = 0;
            c[b + 9072 >> 2] = 0;
            dv(b + 9100 | 0, 0, 24) | 0;
            c[b + 9720 >> 2] = 0;
            c[b + 9724 >> 2] = 0;
            c[b + 9728 >> 2] = 0;
            dv(b + 9756 | 0, 0, 24) | 0;
            c[b + 10376 >> 2] = 0;
            c[b + 10380 >> 2] = 0;
            c[b + 10384 >> 2] = 0;
            dv(b + 10412 | 0, 0, 24) | 0;
            c[b + 11032 >> 2] = 0;
            c[b + 11036 >> 2] = 0;
            c[b + 11040 >> 2] = 0;
            dv(b + 11068 | 0, 0, 24) | 0;
            d = b + 93784 | 0;
            e = b + 11096 | 0;
            do {
                ik(e);
                e = e + 5168 | 0;
            } while ((e | 0) != (d | 0));
            d = b + 375384 | 0;
            e = b + 93784 | 0;
            do {
                jj(e);
                e = e + 4400 | 0;
            } while ((e | 0) != (d | 0));
            dv(b + 375400 | 0, 0, 24) | 0;
            sh(b + 376144 | 0);
            c[b + 377212 >> 2] = 0;
            c[b + 377216 >> 2] = 0;
            c[b + 377220 >> 2] = 0;
            a[b + 512 | 0] = 0;
            a[b + 513 | 0] = 1;
            a[b + 514 | 0] = 0;
            a[b + 532 | 0] = 0;
            a[b + 533 | 0] = 0;
            d = b + 536 | 0;
            dv(b + 516 | 0, -1 | 0, 16) | 0;
            e = 27248;
            f = c[e + 4 >> 2] | 0;
            c[d >> 2] = c[e >> 2];
            c[d + 4 >> 2] = f;
            c[b + 544 >> 2] = 0;
            c[b + 375384 >> 2] = 0;
            c[b + 375388 >> 2] = 0;
            c[b + 375392 >> 2] = 0;
            c[b + 375888 >> 2] = 0;
            f = b + 375892 | 0;
            c[f >> 2] = 6;
            c[b + 375896 >> 2] = 100;
            c[b + 375900 >> 2] = 6;
            c[b + 375908 >> 2] = 6;
            c[b + 375904 >> 2] = 100;
            d = 6;
            while (1) {
                e = d * 100 | 0;
                g = (e | 0) / 7 | 0;
                h = (e + 100 | 0) / 7 | 0;
                a: do {
                    if ((g | 0) > (h | 0)) { i = d } else {
                        e = h - g | 0;
                        j = d;
                        k = g;
                        while (1) {
                            l = c[f >> 2] | 0;
                            m = (j | 0) > (l | 0);
                            n = m ? l : j;
                            a[b + 375912 + (k << 1) | 0] = n;
                            a[b + 375912 + (k << 1) + 1 | 0] = m ? 100 : (((k - g | 0) * 100 | 0 | 0) / (e | 0) | 0) & 255;
                            if ((k | 0) >= (h | 0)) { i = n; break a }
                            j = n;
                            k = k + 1 | 0
                        }
                    }
                } while (0);
                c[b + 376116 + (i << 2) >> 2] = h;
                if ((i | 0) > 0) { d = i - 1 | 0 } else { break }
            }
            i = b + 376200 | 0;
            dv(i | 0, 0, 24) | 0;
            a[b + 376204 | 0] = 1;
            c[i >> 2] = -1;
            return
        }

        function Me(a) {
            a = a | 0;
            Ne(a);
            Pu(a);
            return
        }

        function Ne(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            c[a >> 2] = 22312;
            b = a + 377212 | 0;
            d = c[b >> 2] | 0;
            e = a + 377216 | 0;
            f = c[e >> 2] | 0;
            if ((d | 0) == (f | 0)) { g = d } else {
                h = f;
                f = d;
                while (1) {
                    d = c[h - 4 >> 2] | 0;
                    if ((d | 0) == 0) {
                        i = h;
                        j = f
                    } else {
                        Je(d);
                        Pu(d);
                        i = c[e >> 2] | 0;
                        j = c[b >> 2] | 0
                    }
                    d = i - 4 | 0;
                    k = i + (~((d + (-d | 0) | 0) >>> 2) << 2) | 0;
                    c[e >> 2] = k;
                    if ((j | 0) == (k | 0)) { g = j; break } else {
                        h = k;
                        f = j
                    }
                }
            }
            if ((g | 0) != 0) { Pu(g) }
            th(a + 376144 | 0);
            g = a + 375400 | 0;
            Kf(g | 0);
            j = a + 375404 | 0;
            f = c[j >> 2] | 0;
            h = a + 375408 | 0;
            e = c[h >> 2] | 0;
            do {
                if ((f | 0) != (e | 0)) {
                    i = f;
                    do {
                        Pu(c[i >> 2] | 0);
                        i = i + 4 | 0;
                    } while ((i | 0) != (e | 0));
                    i = c[j >> 2] | 0;
                    b = c[h >> 2] | 0;
                    if ((b | 0) == (i | 0)) { break }
                    c[h >> 2] = b + (~((b - 4 + (-i | 0) | 0) >>> 2) << 2)
                }
            } while (0);
            h = c[g >> 2] | 0;
            if ((h | 0) != 0) { Pu(h) }
            h = a + 93784 | 0;
            g = a + 375384 | 0;
            do {
                g = g - 4400 | 0;
                kj(g);
            } while ((g | 0) != (h | 0));
            jk(a + 88616 | 0);
            jk(a + 83448 | 0);
            jk(a + 78280 | 0);
            jk(a + 73112 | 0);
            jk(a + 67944 | 0);
            jk(a + 62776 | 0);
            jk(a + 57608 | 0);
            jk(a + 52440 | 0);
            jk(a + 47272 | 0);
            jk(a + 42104 | 0);
            jk(a + 36936 | 0);
            jk(a + 31768 | 0);
            jk(a + 26600 | 0);
            jk(a + 21432 | 0);
            jk(a + 16264 | 0);
            jk(a + 11096 | 0);
            Jf(a + 10440 | 0);
            Jf(a + 9784 | 0);
            Jf(a + 9128 | 0);
            Jf(a + 8472 | 0);
            Jf(a + 7816 | 0);
            Jf(a + 7160 | 0);
            Jf(a + 6504 | 0);
            Jf(a + 5848 | 0);
            Jf(a + 5192 | 0);
            Jf(a + 4536 | 0);
            Jf(a + 3880 | 0);
            Jf(a + 3224 | 0);
            Jf(a + 2568 | 0);
            Jf(a + 1912 | 0);
            Jf(a + 1256 | 0);
            Jf(a + 600 | 0);
            Ti(a + 548 | 0);
            return
        }

        function Oe(a) {
            a = a | 0;
            if ((c[a + 375888 >> 2] | 0) <= 0) { return }
            Jk(a + 375396 | 0);
            return
        }

        function Pe(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            d = b + 375888 | 0;
            if ((c[d >> 2] | 0) > 0) { Jk(b + 375396 | 0) }
            c[b + 376220 >> 2] = 0;
            c[b + 376200 >> 2] = -1;
            a[b + 376204 | 0] = 1;
            Bh(b + 376144 | 0);
            _i(b + 548 | 0);
            e = b + 377212 | 0;
            f = c[e >> 2] | 0;
            g = b + 377216 | 0;
            h = c[g >> 2] | 0;
            if ((f | 0) != (h | 0)) {
                i = h;
                h = f;
                while (1) {
                    f = c[i - 4 >> 2] | 0;
                    if ((f | 0) == 0) {
                        j = i;
                        k = h
                    } else {
                        Je(f);
                        Pu(f);
                        j = c[g >> 2] | 0;
                        k = c[e >> 2] | 0
                    }
                    f = j - 4 | 0;
                    l = j + (~((f + (-f | 0) | 0) >>> 2) << 2) | 0;
                    c[g >> 2] = l;
                    if ((k | 0) == (l | 0)) { break } else {
                        i = l;
                        h = k
                    }
                }
            }
            k = c[d >> 2] | 0;
            if ((k | 0) <= 0) { return }
            Hk(b + 375396 | 0, k) | 0;
            c[d >> 2] = k;
            return
        }

        function Qe(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            dv(d + 48 | 0, 0, 2064) | 0;
            c[d + 18532 >> 2] = -1;
            c[d + 18536 >> 2] = -1;
            b = c[d + 18596 >> 2] | 0;
            e = c[(c[d + 18600 >> 2] | 0) + 16 >> 2] | 0;
            if ((e | 0) <= 0) { return }
            f = c[(c[b + 10284 >> 2] | 0) + ((c[(c[b + 10272 >> 2] | 0) + (e << 2) >> 2] | 0) - 1 << 2) >> 2] | 0;
            e = c[b + 5820 >> 2] | 0;
            g = c[b + 5804 >> 2] | 0;
            h = (((f | 0) % (e | 0) | 0) + 1 << g) - 1 | 0;
            i = (((f | 0) / (e | 0) | 0) + 1 << g) - 1 | 0;
            g = (c[b + 1248 >> 2] | 0) - 1 | 0;
            e = (c[b + 1252 >> 2] | 0) - 1 | 0;
            f = c[b + 10368 >> 2] | 0;
            j = ((g | 0) < (h | 0) ? g : h) >> f;
            h = ((e | 0) < (i | 0) ? e : i) >> f;
            if (!((j | 0) > -1)) { ec(14528, 14272, 118, 17304) }
            f = c[b + 10372 >> 2] | 0;
            if ((j | 0) >= (f | 0)) { ec(14528, 14272, 118, 17304) }
            if (!((h | 0) > -1)) { ec(13968, 14272, 119, 17304) }
            if ((h | 0) >= (c[b + 10376 >> 2] | 0)) { ec(13968, 14272, 119, 17304) }
            i = (ga(f, h) | 0) + j | 0;
            c[d + 18528 >> 2] = a[(c[b + 10360 >> 2] | 0) + (i * 3 | 0) + 2 | 0] | 0;
            return
        }

        function Re(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            e = i;
            i = i + 656 | 0;
            f = e | 0;
            g = f;
            h = f + 592 | 0;
            c[h >> 2] = 0;
            j = f + 596 | 0;
            c[j >> 2] = 0;
            c[f + 600 >> 2] = 0;
            k = f + 628 | 0;
            dv(k | 0, 0, 24) | 0;
            l = _k(f, b + 4 | 0, d) | 0;
            if ((l | 0) == 0) {
                d = c[b + 520 >> 2] | 0;
                if ((d | 0) > -1) { cl(f, d) }
                d = c[f >> 2] | 0;
                m = b + 600 + (d * 656 | 0) | 0;
                cv(m | 0, g | 0, 592) | 0;
                if ((m | 0) == (f | 0)) { cv(b + 600 + (d * 656 | 0) + 604 | 0, f + 604 | 0, 24) | 0 } else {
                    Cf(b + 600 + (d * 656 | 0) + 592 | 0, c[h >> 2] | 0, c[j >> 2] | 0);
                    cv(b + 600 + (d * 656 | 0) + 604 | 0, f + 604 | 0, 24) | 0;
                    Bf(b + 600 + (d * 656 | 0) + 628 | 0, c[k >> 2] | 0, c[f + 632 >> 2] | 0);
                    Af(b + 600 + (d * 656 | 0) + 640 | 0, c[f + 640 >> 2] | 0, c[f + 644 >> 2] | 0)
                }
                a[b + 600 + (d * 656 | 0) + 652 | 0] = a[f + 652 | 0] | 0;
                n = 0
            } else { n = l }
            l = c[f + 640 >> 2] | 0;
            if ((l | 0) != 0) {
                d = f + 644 | 0;
                if ((c[d >> 2] | 0) != (l | 0)) { c[d >> 2] = l }
                Pu(l)
            }
            l = c[k >> 2] | 0;
            if ((l | 0) != 0) {
                k = f + 632 | 0;
                f = c[k >> 2] | 0;
                if ((f | 0) != (l | 0)) { c[k >> 2] = f + (~((f - 2 + (-l | 0) | 0) >>> 1) << 1) }
                Pu(l)
            }
            l = c[h >> 2] | 0;
            if ((l | 0) == 0) {
                o = 656;
                p = 0;
                i = e;
                return n | 0
            }
            f = c[j >> 2] | 0;
            if ((f | 0) == (l | 0)) { q = l } else {
                k = f;
                while (1) {
                    f = k - 12 | 0;
                    c[j >> 2] = f;
                    d = c[f >> 2] | 0;
                    if ((d | 0) == 0) { r = f } else {
                        Pu(d);
                        r = c[j >> 2] | 0
                    }
                    if ((r | 0) == (l | 0)) { break } else { k = r }
                }
                q = c[h >> 2] | 0
            }
            Pu(q);
            o = 656;
            p = 0;
            i = e;
            return n | 0
        }

        function Se(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0;
            e = i;
            i = i + 4400 | 0;
            f = e | 0;
            jj(f);
            g = mj(f, d, b) | 0;
            d = c[b + 524 >> 2] | 0;
            if ((d | 0) > -1) { oj(f, d) }
            if (!g) {
                h = g ? 0 : 1006;
                kj(f);
                j = 4400;
                k = 0;
                i = e;
                return h | 0
            }
            d = a[f + 1 | 0] | 0;
            l = b + 93784 + (d * 4400 | 0) | 0;
            cv(l | 0, f | 0, 4340) | 0;
            if ((l | 0) == (f | 0)) {
                h = g ? 0 : 1006;
                kj(f);
                j = 4400;
                k = 0;
                i = e;
                return h | 0
            }
            tf(b + 93784 + (d * 4400 | 0) + 4340 | 0, c[f + 4340 >> 2] | 0, c[f + 4344 >> 2] | 0);
            tf(b + 93784 + (d * 4400 | 0) + 4352 | 0, c[f + 4352 >> 2] | 0, c[f + 4356 >> 2] | 0);
            tf(b + 93784 + (d * 4400 | 0) + 4364 | 0, c[f + 4364 >> 2] | 0, c[f + 4368 >> 2] | 0);
            tf(b + 93784 + (d * 4400 | 0) + 4376 | 0, c[f + 4376 >> 2] | 0, c[f + 4380 >> 2] | 0);
            tf(b + 93784 + (d * 4400 | 0) + 4388 | 0, c[f + 4388 >> 2] | 0, c[f + 4392 >> 2] | 0);
            h = g ? 0 : 1006;
            kj(f);
            j = 4400;
            k = 0;
            i = e;
            return h | 0
        }

        function Te(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            e = i;
            i = i + 80 | 0;
            f = e | 0;
            g = f;
            h = a + 375388 | 0;
            j = Fj(b, f, d, c[h >> 2] | 0) | 0;
            do {
                if ((j | 0) == 0) {
                    Gj(f, c[h >> 2] | 0);
                    b = c[a + 377216 >> 2] | 0;
                    if ((c[a + 377212 >> 2] | 0) == (b | 0) | d ^ 1) { break }
                    k = c[b - 4 >> 2] | 0;
                    b = k + 10648 | 0;
                    l = c[b >> 2] | 0;
                    if ((l | 0) == (c[k + 10652 >> 2] | 0)) { xf(k + 10644 | 0, f); break }
                    if ((l | 0) == 0) { m = 0 } else {
                        cv(l | 0, g | 0, 80) | 0;
                        m = c[b >> 2] | 0
                    }
                    c[b >> 2] = m + 80
                } else {
                    b = a + 84 | 0;
                    l = c[b >> 2] | 0;
                    if ((l | 0) == 20) { c[a + 80 >> 2] = 1001; break } else {
                        c[b >> 2] = l + 1;
                        c[a + 4 + (l << 2) >> 2] = j;
                        break
                    }
                }
            } while (0);
            i = e;
            return j | 0
        }

        function Ue(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            a: do {
                if (d) {
                    e = a + 164 | 0;
                    f = c[e >> 2] | 0;
                    do { if ((f | 0) > 0) { g = 0; while (1) { h = g + 1 | 0; if ((c[a + 84 + (g << 2) >> 2] | 0) == (b | 0)) { i = 10; break } if ((h | 0) < (f | 0)) { g = h } else { i = 5; break } } if ((i | 0) == 5) { if ((f | 0) < 20) { break } else { break a } } else if ((i | 0) == 10) { return } } } while (0);
                    c[e >> 2] = f + 1;
                    c[a + 84 + (f << 2) >> 2] = b
                }
            } while (0);
            i = a + 80 | 0;
            d = c[i >> 2] | 0;
            if ((d | 0) == 20) { c[a + 76 >> 2] = 1001; return } else {
                c[i >> 2] = d + 1;
                c[a + (d << 2) >> 2] = b;
                return
            }
        }

        function Ve(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            g = i;
            i = i + 48 | 0;
            h = g | 0;
            j = g + 8 | 0;
            k = g + 16 | 0;
            l = g + 24 | 0;
            m = g + 32 | 0;
            n = g + 40 | 0;
            o = Nu(1356) | 0;
            p = o;
            If(p);
            q = Kj(p, d, b, j) | 0;
            c[k >> 2] = q;
            if ((a[j] | 0) == 0) {
                j = c[b + 376220 >> 2] | 0;
                if ((j | 0) != 0) { a[j + 10516 | 0] = 2 }
                Vi(b + 548 | 0, e);
                if ((o | 0) == 0) {
                    r = q;
                    i = g;
                    return r | 0
                }
                j = c[o + 1344 >> 2] | 0;
                if ((j | 0) != 0) {
                    s = o + 1348 | 0;
                    t = c[s >> 2] | 0;
                    if ((t | 0) != (j | 0)) { c[s >> 2] = t + (~((t - 4 + (-j | 0) | 0) >>> 2) << 2) }
                    Pu(j)
                }
                Ed(o + 1332 | 0);
                j = c[o + 776 >> 2] | 0;
                if ((j | 0) != 0) {
                    t = o + 780 | 0;
                    s = c[t >> 2] | 0;
                    if ((s | 0) != (j | 0)) { c[t >> 2] = s + (~((s - 4 + (-j | 0) | 0) >>> 2) << 2) }
                    Pu(j)
                }
                Pu(o);
                r = q;
                i = g;
                return r | 0
            }
            q = c[b + 528 >> 2] | 0;
            if ((q | 0) > -1) { Lj(p, b, q) }
            q = e + 8 | 0;
            j = We(b, b, p, k, c[q >> 2] | 0, c[q + 4 >> 2] | 0, f, c[e + 16 >> 2] | 0) | 0;
            f = b + 376220 | 0;
            q = c[f >> 2] | 0;
            if (!j) {
                if ((q | 0) != 0) { a[q + 10516 | 0] = 2 }
                Vi(b + 548 | 0, e);
                if ((o | 0) != 0) {
                    j = c[o + 1344 >> 2] | 0;
                    if ((j | 0) != 0) {
                        s = o + 1348 | 0;
                        t = c[s >> 2] | 0;
                        if ((t | 0) != (j | 0)) { c[s >> 2] = t + (~((t - 4 + (-j | 0) | 0) >>> 2) << 2) }
                        Pu(j)
                    }
                    Ed(o + 1332 | 0);
                    j = c[o + 776 >> 2] | 0;
                    if ((j | 0) != 0) {
                        t = o + 780 | 0;
                        s = c[t >> 2] | 0;
                        if ((s | 0) != (j | 0)) { c[t >> 2] = s + (~((s - 4 + (-j | 0) | 0) >>> 2) << 2) }
                        Pu(j)
                    }
                    Pu(o)
                }
                r = c[k >> 2] | 0;
                i = g;
                return r | 0
            }
            c[h >> 2] = p;
            j = q + 48 | 0;
            s = q + 52 | 0;
            t = c[s >> 2] | 0;
            c[o >> 2] = t - (c[j >> 2] | 0) >> 2;
            if ((t | 0) == (c[q + 56 >> 2] | 0)) { Hf(j, h) } else {
                if ((t | 0) == 0) { u = 0 } else {
                    c[t >> 2] = p;
                    u = c[s >> 2] | 0
                }
                c[s >> 2] = u + 4
            }
            od(d, 1);
            pd(d);
            u = (c[d >> 2] | 0) - (c[e + 20 >> 2] | 0) | 0;
            s = o + 768 | 0;
            if ((c[s >> 2] | 0) > 0) {
                t = o + 776 | 0;
                h = 0;
                j = c[t >> 2] | 0;
                do {
                    q = Qi(e, c[j + (h << 2) >> 2] | 0, u) | 0;
                    j = c[t >> 2] | 0;
                    v = j + (h << 2) | 0;
                    c[v >> 2] = (c[v >> 2] | 0) - q;
                    h = h + 1 | 0;
                } while ((h | 0) < (c[s >> 2] | 0))
            }
            do {
                if ((a[o + 4 | 0] | 0) == 0) { w = b + 377216 | 0 } else {
                    s = Nu(10688) | 0;
                    Oh(s + 8 | 0);
                    h = s;
                    dv(s + 10632 | 0, 0, 56) | 0;
                    c[l >> 2] = h;
                    c[s >> 2] = c[f >> 2];
                    s = b + 377216 | 0;
                    j = c[s >> 2] | 0;
                    if ((j | 0) == (c[b + 377220 >> 2] | 0)) {
                        wf(b + 377212 | 0, l);
                        w = s;
                        break
                    }
                    if ((j | 0) == 0) { x = 0 } else {
                        c[j >> 2] = h;
                        x = c[s >> 2] | 0
                    }
                    c[s >> 2] = x + 4;
                    w = s
                }
            } while (0);
            do {
                if ((c[b + 377212 >> 2] | 0) != (c[w >> 2] | 0)) {
                    x = Nu(144) | 0;
                    l = x;
                    c[l >> 2] = 0;
                    c[x + 4 >> 2] = 0;
                    c[x + 32 >> 2] = 0;
                    a[x + 36 | 0] = 0;
                    Bk(x + 44 | 0);
                    f = x;
                    c[x + 120 >> 2] = 0;
                    c[x + 124 >> 2] = -1;
                    c[x + 128 >> 2] = -1;
                    c[x + 132 >> 2] = 0;
                    c[x + 140 >> 2] = b;
                    c[x + 40 >> 2] = 0;
                    c[x + 136 >> 2] = 0;
                    c[m >> 2] = f;
                    c[l >> 2] = e;
                    c[x + 4 >> 2] = p;
                    l = x + 8 | 0;
                    o = d;
                    c[l >> 2] = c[o >> 2];
                    c[l + 4 >> 2] = c[o + 4 >> 2];
                    c[l + 8 >> 2] = c[o + 8 >> 2];
                    c[l + 12 >> 2] = c[o + 12 >> 2];
                    c[l + 16 >> 2] = c[o + 16 >> 2];
                    c[l + 20 >> 2] = c[o + 20 >> 2];
                    a[x + 36 | 0] = a[b + 377224 | 0] | 0;
                    x = c[(c[w >> 2] | 0) - 4 >> 2] | 0;
                    o = x + 10636 | 0;
                    l = c[o >> 2] | 0;
                    if ((l | 0) == (c[x + 10640 >> 2] | 0)) { vf(x + 10632 | 0, m); break }
                    if ((l | 0) == 0) { y = 0 } else {
                        c[l >> 2] = f;
                        y = c[o >> 2] | 0
                    }
                    c[o >> 2] = y + 4
                }
            } while (0);
            y = Xe(b, n) | 0;
            c[k >> 2] = y;
            r = 0;
            i = g;
            return r | 0
        }

        function We(b, d, e, f, g, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            l = i;
            c[f >> 2] = 0;
            a[b + 377224 | 0] = 0;
            m = c[e + 8 >> 2] | 0;
            n = d + 93784 + (m * 4400 | 0) | 0;
            if ((a[n | 0] | 0) == 0) {
                Yk(1, 344, (o = i, i = i + 8 | 0, c[o >> 2] = m, o) | 0);
                i = o;
                ec(11704, 14344, 1987, 17600);
                return 0
            }
            o = d + 375392 | 0;
            c[o >> 2] = n;
            n = a[d + 93784 + (m * 4400 | 0) + 2 | 0] | 0;
            m = d + 375388 | 0;
            c[m >> 2] = d + 11096 + (n * 5168 | 0);
            p = d + 375384 | 0;
            c[p >> 2] = d + 600 + ((a[d + 11096 + (n * 5168 | 0) + 1 | 0] | 0) * 656 | 0);
            hf(b);
            n = e + 4 | 0;
            do {
                if ((a[n] | 0) == 0) {
                    if ((c[d + 376220 >> 2] | 0) == 0) { q = 0 } else { break }
                    i = l;
                    return q | 0
                } else {
                    c[d + 376200 >> 2] = c[e + 28 >> 2];
                    r = c[m >> 2] | 0;
                    if ((a[r + 4703 | 0] | 0) == 0) { s = 1 } else { s = (a[d + 533 | 0] | 0) != 0 }
                    t = Ch(d + 376144 | 0, r, b, g, h, k, s) | 0;
                    if ((t | 0) == -1) {
                        c[f >> 2] = 9;
                        q = 0;
                        i = l;
                        return q | 0
                    }
                    r = c[d + 376152 >> 2] | 0;
                    if ((c[d + 376156 >> 2] | 0) - r >> 2 >>> 0 > t >>> 0) { u = c[r + (t << 2) >> 2] | 0 } else { u = 0 }
                    t = u + 10518 | 0;
                    r = j | 0;
                    a[t] = a[r] | 0;
                    a[t + 1 | 0] = a[r + 1 | 0] | 0;
                    a[t + 2 | 0] = a[r + 2 | 0] | 0;
                    r = d + 376220 | 0;
                    c[r >> 2] = u;
                    t = u + 108 | 0;
                    v = c[p >> 2] | 0;
                    cv(t | 0, v | 0, 592) | 0;
                    if ((t | 0) == (v | 0)) { cv(u + 712 | 0, u + 712 | 0, 24) | 0 } else {
                        Cf(u + 700 | 0, c[v + 592 >> 2] | 0, c[v + 596 >> 2] | 0);
                        cv(u + 712 | 0, v + 604 | 0, 24) | 0;
                        Bf(u + 736 | 0, c[v + 628 >> 2] | 0, c[v + 632 >> 2] | 0);
                        Af(u + 748 | 0, c[v + 640 >> 2] | 0, c[v + 644 >> 2] | 0)
                    }
                    a[u + 760 | 0] = a[v + 652 | 0] | 0;
                    v = u + 5932 | 0;
                    t = c[o >> 2] | 0;
                    cv(v | 0, t | 0, 4340) | 0;
                    if ((v | 0) != (t | 0)) {
                        tf(u + 10272 | 0, c[t + 4340 >> 2] | 0, c[t + 4344 >> 2] | 0);
                        tf(u + 10284 | 0, c[t + 4352 >> 2] | 0, c[t + 4356 >> 2] | 0);
                        tf(u + 10296 | 0, c[t + 4364 >> 2] | 0, c[t + 4368 >> 2] | 0);
                        tf(u + 10308 | 0, c[t + 4376 >> 2] | 0, c[t + 4380 >> 2] | 0);
                        tf(u + 10320 | 0, c[t + 4388 >> 2] | 0, c[t + 4392 >> 2] | 0)
                    }
                    c[u + 10332 >> 2] = d;
                    $h(u);
                    t = d + 377208 | 0;
                    a: do {
                        if (Ni(a[t] | 0) | 0) {
                            do {
                                if (!(Ki(a[t] | 0) | 0)) {
                                    if (Li(a[t] | 0) | 0) { break }
                                    if ((a[d + 376204 | 0] | 0) != 0) { break }
                                    if ((a[d + 376207 | 0] | 0) != 0) { break }
                                    a[d + 376205 | 0] = 0;
                                    a[d + 376206 | 0] = 0;
                                    break a
                                }
                            } while (0);
                            a[d + 376205 | 0] = 1;
                            a[d + 376207 | 0] = 0
                        }
                    } while (0);
                    do {
                        if (Mi(a[t] | 0) | 0) {
                            if ((a[d + 376205 | 0] | 0) == 0) { w = 25; break }
                            a[(c[r >> 2] | 0) + 100 | 0] = 0
                        } else { w = 25 }
                    } while (0);
                    if ((w | 0) == 25) { a[(c[r >> 2] | 0) + 100 | 0] = (a[e + 24 | 0] | 0) != 0 | 0 }
                    df(b, d, e);
                    t = u + 96 | 0;
                    if ((a[n] | 0) != 0) {
                        c[t >> 2] = 1;
                        ff(b, d, e)
                    }
                    c[t >> 2] = 1;
                    Wk(c[(c[r >> 2] | 0) + 92 >> 2] | 0);
                    a[b + 376204 | 0] = 0
                }
            } while (0);
            do {
                if ((c[e + 20 >> 2] | 0) >>> 0 < 2 >>> 0) {
                    if (gf(0, d, e) | 0) { break } else { q = 0 }
                    i = l;
                    return q | 0
                }
            } while (0);
            uh(d + 376144 | 0);
            if ((a[e + 12 | 0] | 0) == 0) {
                c[e + 800 >> 2] = c[e + 16 >> 2];
                x = d + 376224 | 0
            } else {
                b = d + 376224 | 0;
                c[e + 800 >> 2] = c[(c[b >> 2] | 0) + 800 >> 2];
                x = b
            }
            c[x >> 2] = e;
            q = 1;
            i = l;
            return q | 0
        }

        function Xe(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0;
            a[d] = 0;
            e = b + 377212 | 0;
            f = c[e >> 2] | 0;
            g = b + 377216 | 0;
            h = c[g >> 2] | 0;
            if ((f | 0) == (h | 0)) { i = 0; return i | 0 }
            j = c[f >> 2] | 0;
            k = c[j + 10636 >> 2] | 0;
            l = c[j + 10632 >> 2] | 0;
            a: do {
                if ((k | 0) == (l | 0)) {
                    m = h;
                    n = f
                } else {
                    o = k - l >> 2;
                    p = 0;
                    while (1) {
                        q = c[l + (p << 2) >> 2] | 0;
                        r = p + 1 | 0;
                        if ((c[q + 40 >> 2] | 0) == 0) { break }
                        if (r >>> 0 < o >>> 0) { p = r } else {
                            m = h;
                            n = f;
                            break a
                        }
                    }
                    if ((q | 0) == 0) {
                        m = h;
                        n = f;
                        break
                    }
                    if ((a[q + 36 | 0] | 0) != 0) { Ah(b + 376144 | 0) | 0 }
                    a[d] = 1;
                    p = Ye(b, j, q) | 0;
                    if ((p | 0) == 0) {
                        m = c[g >> 2] | 0;
                        n = c[e >> 2] | 0;
                        break
                    } else { i = p; return i | 0 }
                }
            } while (0);
            do {
                if (m - n >> 2 >>> 0 > 1 >>> 0) {
                    q = c[n >> 2] | 0;
                    j = c[q + 10636 >> 2] | 0;
                    if ((j | 0) == (c[q + 10632 >> 2] | 0)) { s = q; break }
                    if ((c[(c[j - 4 >> 2] | 0) + 40 >> 2] | 0) == 0) { t = 14 } else { s = q }
                } else { t = 14 }
            } while (0);
            do {
                if ((t | 0) == 14) {
                    if ((m | 0) == (n | 0)) { i = 0; return i | 0 }
                    q = c[n >> 2] | 0;
                    j = c[q + 10636 >> 2] | 0;
                    do { if ((j | 0) != (c[q + 10632 >> 2] | 0)) { if ((c[(c[j - 4 >> 2] | 0) + 40 >> 2] | 0) == 0) { i = 0 } else { break } return i | 0 } } while (0);
                    if (((c[b + 556 >> 2] | 0) != 0 | 0) != (-(c[b + 580 >> 2] | 0) | 0)) { i = 0; return i | 0 }
                    if ((a[b + 548 | 0] | 0) != 0) { s = q; break }
                    if ((a[b + 549 | 0] | 0) == 0) { i = 0 } else { s = q; break }
                    return i | 0
                }
            } while (0);
            a[d] = 1;
            d = s | 0;
            n = c[d >> 2] | 0;
            m = n + 10344 | 0;
            if ((c[m >> 2] | 0) > 0) {
                j = n + 10524 | 0;
                f = 0;
                do {
                    Ek((c[j >> 2] | 0) + (f * 76 | 0) | 0, 1);
                    f = f + 1 | 0;
                } while ((f | 0) < (c[m >> 2] | 0));
                u = c[d >> 2] | 0
            } else { u = n }
            n = u + 10332 | 0;
            m = c[n >> 2] | 0;
            f = (a[m + 532 | 0] | 0) == 0;
            do {
                if ((c[(c[(c[b + 376220 >> 2] | 0) + 10332 >> 2] | 0) + 375888 >> 2] | 0) == 0) {
                    if (f) {
                        De(u);
                        v = c[n >> 2] | 0
                    } else { v = m }
                    if ((a[v + 533 | 0] | 0) != 0) { break }
                    uj(u)
                } else {
                    if (f) {
                        Ce(s);
                        w = 3;
                        x = c[n >> 2] | 0
                    } else {
                        w = 1;
                        x = m
                    }
                    if ((a[x + 533 | 0] | 0) == 0) { wj(s, w) | 0 }
                    _h(u)
                }
            } while (0);
            u = s + 10648 | 0;
            w = s + 10644 | 0;
            x = c[w >> 2] | 0;
            b: do {
                if ((c[u >> 2] | 0) == (x | 0)) { t = 38 } else {
                    m = 0;
                    n = x;
                    while (1) {
                        y = Hj(n + (m * 80 | 0) | 0, c[d >> 2] | 0) | 0;
                        f = m + 1 | 0;
                        if ((y | 0) != 0) { break }
                        v = c[w >> 2] | 0;
                        if (f >>> 0 < (((c[u >> 2] | 0) - v | 0) / 80 | 0) >>> 0) {
                            m = f;
                            n = v
                        } else { t = 38; break b }
                    }
                    Ze(b, s) | 0;
                    z = y;
                    t = 39
                }
            } while (0);
            if ((t | 0) == 38) {
                Ze(b, s) | 0;
                if ((s | 0) == 0) { A = 0 } else {
                    z = 0;
                    t = 39
                }
            }
            if ((t | 0) == 39) {
                Je(s);
                Pu(s);
                A = z
            }
            z = c[g >> 2] | 0;
            s = c[e >> 2] | 0;
            if (z - s >> 2 >>> 0 > 1 >>> 0) {
                t = 1;
                b = s;
                while (1) {
                    c[b + (t - 1 << 2) >> 2] = c[b + (t << 2) >> 2];
                    s = t + 1 | 0;
                    y = c[g >> 2] | 0;
                    u = c[e >> 2] | 0;
                    if (s >>> 0 < y - u >> 2 >>> 0) {
                        t = s;
                        b = u
                    } else { B = y; break }
                }
            } else { B = z }
            z = B - 4 | 0;
            c[g >> 2] = B + (~((z + (-z | 0) | 0) >>> 2) << 2);
            i = A;
            return i | 0
        }

        function Ye(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0;
            f = e + 4 | 0;
            g = c[f >> 2] | 0;
            h = g + 1348 | 0;
            i = g + 1344 | 0;
            g = c[i >> 2] | 0;
            if ((c[h >> 2] | 0) != (g | 0)) {
                j = b + 376144 | 0;
                k = b + 376152 | 0;
                l = 0;
                m = g;
                do {
                    g = yh(j, c[m + (l << 2) >> 2] | 0) | 0;
                    if ((g | 0) > -1) { c[(c[(c[k >> 2] | 0) + (g << 2) >> 2] | 0) + 96 >> 2] = 0 }
                    l = l + 1 | 0;
                    m = c[i >> 2] | 0;
                } while (l >>> 0 < (c[h >> 2] | 0) - m >> 2 >>> 0)
            }
            m = d | 0;
            h = c[m >> 2] | 0;
            l = e + 40 | 0;
            c[l >> 2] = 1;
            i = c[h + 10332 >> 2] | 0;
            a: do {
                if ((c[i + 375888 >> 2] | 0) > 0) {
                    k = a[h + 5965 | 0] | 0;
                    j = k << 24 >> 24 != 0;
                    g = (a[h + 5966 | 0] | 0) != 0;
                    if (!(k << 24 >> 24 == 0)) {
                        n = j;
                        o = g;
                        break
                    }
                    if ((a[h + 5966 | 0] | 0) != 0) {
                        n = j;
                        o = g;
                        break
                    }
                    k = i + 168 | 0;
                    p = c[k >> 2] | 0;
                    if ((p | 0) > 0) {
                        q = 0;
                        while (1) {
                            r = q + 1 | 0;
                            if ((c[i + 88 + (q << 2) >> 2] | 0) == 1e3) {
                                n = j;
                                o = g;
                                break a
                            }
                            if ((r | 0) < (p | 0)) { q = r } else { break }
                        }
                        if ((p | 0) < 20) { s = 13 }
                    } else { s = 13 }
                    if ((s | 0) == 13) {
                        c[k >> 2] = p + 1;
                        c[i + 88 + (p << 2) >> 2] = 1e3
                    }
                    q = i + 84 | 0;
                    r = c[q >> 2] | 0;
                    if ((r | 0) == 20) {
                        c[i + 80 >> 2] = 1001;
                        n = j;
                        o = g;
                        break
                    } else {
                        c[q >> 2] = r + 1;
                        c[i + 4 + (r << 2) >> 2] = 1e3;
                        n = j;
                        o = g;
                        break
                    }
                } else {
                    n = 0;
                    o = 0
                }
            } while (0);
            i = d + 10636 | 0;
            r = c[i >> 2] | 0;
            q = d + 10632 | 0;
            t = c[q >> 2] | 0;
            do {
                if ((r | 0) == (t | 0)) {
                    u = r;
                    v = r
                } else {
                    if ((c[t >> 2] | 0) != (e | 0)) {
                        u = r;
                        v = t;
                        break
                    }
                    w = c[(c[f >> 2] | 0) + 16 >> 2] | 0;
                    if ((w | 0) <= 0) {
                        u = r;
                        v = t;
                        break
                    }
                    x = h + 10524 | 0;
                    y = 0;
                    do {
                        Ek((c[x >> 2] | 0) + (y * 76 | 0) | 0, 1);
                        y = y + 1 | 0;
                    } while ((y | 0) < (w | 0));
                    u = c[i >> 2] | 0;
                    v = c[q >> 2] | 0
                }
            } while (0);
            h = u - v >> 2;
            b: do {
                if (h >>> 0 > 1 >>> 0) {
                    u = 1;
                    while (1) { t = u + 1 | 0; if ((c[v + (u << 2) >> 2] | 0) == (e | 0)) { break } if (t >>> 0 < h >>> 0) { u = t } else { break b } }
                    t = c[v + (u - 1 << 2) >> 2] | 0;
                    if ((t | 0) == 0) { break }
                    if ((c[t + 40 >> 2] | 0) != 2) { break }
                    r = h - 1 | 0;
                    w = 0;
                    while (1) {
                        if (!(w >>> 0 < r >>> 0)) { break b }
                        z = w + 1 | 0;
                        if ((c[v + (w << 2) >> 2] | 0) == (t | 0)) { break } else { w = z }
                    }
                    w = c[v + (z << 2) >> 2] | 0;
                    if ((w | 0) == 0) { break }
                    r = c[(c[t + 4 >> 2] | 0) + 16 >> 2] | 0;
                    u = w + 4 | 0;
                    if ((r | 0) < (c[(c[u >> 2] | 0) + 16 >> 2] | 0)) { A = r } else { break }
                    do {
                        r = c[m >> 2] | 0;
                        if ((A | 0) >= (c[r + 10344 >> 2] | 0)) { break b }
                        Ek((c[r + 10524 >> 2] | 0) + (A * 76 | 0) | 0, 1);
                        A = A + 1 | 0;
                    } while ((A | 0) < (c[(c[u >> 2] | 0) + 16 >> 2] | 0))
                }
            } while (0);
            if (!(n | o)) {
                A = _e(b, d, e) | 0;
                c[l >> 2] = 2;
                z = c[q >> 2] | 0;
                v = ((c[i >> 2] | 0) - z >> 2) - 1 | 0;
                h = 0;
                while (1) {
                    if (!(h >>> 0 < v >>> 0)) {
                        B = A;
                        s = 61;
                        break
                    }
                    C = h + 1 | 0;
                    if ((c[z + (h << 2) >> 2] | 0) == (e | 0)) { break } else { h = C }
                }
                if ((s | 0) == 61) { return B | 0 }
                h = c[z + (C << 2) >> 2] | 0;
                if ((h | 0) == 0) { B = A; return B | 0 }
                C = c[(c[f >> 2] | 0) + 16 >> 2] | 0;
                z = h + 4 | 0;
                if ((C | 0) < (c[(c[z >> 2] | 0) + 16 >> 2] | 0)) { D = C } else { B = A; return B | 0 }
                while (1) {
                    C = c[m >> 2] | 0;
                    if ((D | 0) >= (c[C + 10344 >> 2] | 0)) {
                        B = A;
                        s = 61;
                        break
                    }
                    Ek((c[C + 10524 >> 2] | 0) + (D * 76 | 0) | 0, 1);
                    C = D + 1 | 0;
                    if ((C | 0) < (c[(c[z >> 2] | 0) + 16 >> 2] | 0)) { D = C } else {
                        B = A;
                        s = 61;
                        break
                    }
                }
                if ((s | 0) == 61) { return B | 0 }
            }
            if (n & o) { B = 1006; return B | 0 }
            if (n) {
                $e(b, d, e) | 0;
                c[l >> 2] = 2;
                n = c[q >> 2] | 0;
                A = ((c[i >> 2] | 0) - n >> 2) - 1 | 0;
                D = 0;
                while (1) {
                    if (!(D >>> 0 < A >>> 0)) {
                        B = 0;
                        s = 61;
                        break
                    }
                    E = D + 1 | 0;
                    if ((c[n + (D << 2) >> 2] | 0) == (e | 0)) { break } else { D = E }
                }
                if ((s | 0) == 61) { return B | 0 }
                D = c[n + (E << 2) >> 2] | 0;
                if ((D | 0) == 0) { B = 0; return B | 0 }
                E = c[(c[f >> 2] | 0) + 16 >> 2] | 0;
                n = D + 4 | 0;
                if ((E | 0) < (c[(c[n >> 2] | 0) + 16 >> 2] | 0)) { F = E } else { B = 0; return B | 0 }
                while (1) {
                    E = c[m >> 2] | 0;
                    if ((F | 0) >= (c[E + 10344 >> 2] | 0)) {
                        B = 0;
                        s = 61;
                        break
                    }
                    Ek((c[E + 10524 >> 2] | 0) + (F * 76 | 0) | 0, 1);
                    E = F + 1 | 0;
                    if ((E | 0) < (c[(c[n >> 2] | 0) + 16 >> 2] | 0)) { F = E } else {
                        B = 0;
                        s = 61;
                        break
                    }
                }
                if ((s | 0) == 61) { return B | 0 }
            }
            if (!o) { ec(11704, 14344, 971, 17632); return 0 }
            o = af(b, d, e) | 0;
            c[l >> 2] = 2;
            l = c[q >> 2] | 0;
            q = ((c[i >> 2] | 0) - l >> 2) - 1 | 0;
            i = 0;
            while (1) {
                if (!(i >>> 0 < q >>> 0)) {
                    B = o;
                    s = 61;
                    break
                }
                G = i + 1 | 0;
                if ((c[l + (i << 2) >> 2] | 0) == (e | 0)) { break } else { i = G }
            }
            if ((s | 0) == 61) { return B | 0 }
            i = c[l + (G << 2) >> 2] | 0;
            if ((i | 0) == 0) { B = o; return B | 0 }
            G = c[(c[f >> 2] | 0) + 16 >> 2] | 0;
            f = i + 4 | 0;
            if ((G | 0) < (c[(c[f >> 2] | 0) + 16 >> 2] | 0)) { H = G } else { B = o; return B | 0 }
            while (1) {
                G = c[m >> 2] | 0;
                if ((H | 0) >= (c[G + 10344 >> 2] | 0)) {
                    B = o;
                    s = 61;
                    break
                }
                Ek((c[G + 10524 >> 2] | 0) + (H * 76 | 0) | 0, 1);
                G = H + 1 | 0;
                if ((G | 0) < (c[(c[f >> 2] | 0) + 16 >> 2] | 0)) { H = G } else {
                    B = o;
                    s = 61;
                    break
                }
            }
            if ((s | 0) == 61) { return B | 0 }
            return 0
        }

        function Ze(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0;
            e = i;
            i = i + 8 | 0;
            f = e | 0;
            g = c[d >> 2] | 0;
            if ((g | 0) == 0) { i = e; return 0 }
            do {
                if ((a[g + 100 | 0] | 0) != 0) {
                    if ((a[g + 10516 | 0] | 0) != 0) { if ((a[b + 514 | 0] | 0) != 0) { break } }
                    c[f >> 2] = g;
                    d = b + 376168 | 0;
                    h = c[d >> 2] | 0;
                    if ((h | 0) == (c[b + 376172 >> 2] | 0)) { yf(b + 376164 | 0, f); break }
                    if ((h | 0) == 0) { j = 0 } else {
                        c[h >> 2] = g;
                        j = c[d >> 2] | 0
                    }
                    c[d >> 2] = j + 4
                }
            } while (0);
            j = b + 376144 | 0;
            if (((c[b + 376168 >> 2] | 0) - (c[b + 376164 >> 2] | 0) >> 2 | 0) > (c[g + 596 + (((c[g + 116 >> 2] | 0) - 1 | 0) * 12 | 0) + 4 >> 2] | 0)) { zh(j) }
            Eh(j);
            i = e;
            return 0
        }

        function _e(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            f = i;
            i = i + 18624 | 0;
            g = f | 0;
            h = e + 4 | 0;
            j = c[h >> 2] | 0;
            k = j + 1348 | 0;
            l = j + 1344 | 0;
            m = c[l >> 2] | 0;
            if ((c[k >> 2] | 0) == (m | 0)) { n = j } else {
                j = b + 376144 | 0;
                o = b + 376152 | 0;
                p = 0;
                q = m;
                do {
                    m = yh(j, c[q + (p << 2) >> 2] | 0) | 0;
                    if ((m | 0) > -1) { c[(c[(c[o >> 2] | 0) + (m << 2) >> 2] | 0) + 96 >> 2] = 0 }
                    p = p + 1 | 0;
                    q = c[l >> 2] | 0;
                } while (p >>> 0 < (c[k >> 2] | 0) - q >> 2 >>> 0);
                n = c[h >> 2] | 0
            }
            q = d | 0;
            k = c[q >> 2] | 0;
            if (!((c[n + 16 >> 2] | 0) >>> 0 < (c[k + 10276 >> 2] | 0) - (c[k + 10272 >> 2] | 0) >> 2 >>> 0)) {
                r = 6;
                i = f;
                return r | 0
            }
            k = g + 18580 | 0;
            Cd(k);
            n = g + 18592 | 0;
            p = g + 48 | 0;
            dv(g + 18508 | 0, 0, 20) | 0;
            dv(n | 0, 0, 16) | 0;
            c[g + 2112 >> 2] = p;
            dv(p | 0, 0, 2048) | 0;
            p = c[h >> 2] | 0;
            c[g + 18600 >> 2] = p;
            l = c[q >> 2] | 0;
            c[g + 18596 >> 2] = l;
            c[n >> 2] = b;
            c[g + 18604 >> 2] = d;
            c[g + 18608 >> 2] = e;
            c[g + 4 >> 2] = c[(c[l + 10272 >> 2] | 0) + (c[p + 16 >> 2] << 2) >> 2];
            c[g + 18612 >> 2] = 0;
            Qe(0, g);
            p = c[e + 12 >> 2] | 0;
            if ((p | 0) < 1) { s = 17 } else {
                sd(g + 18556 | 0, c[e + 8 >> 2] | 0, p);
                do {
                    if ((a[b + 93817 | 0] | 0) != 0) {
                        if ((a[(c[h >> 2] | 0) + 4 | 0] | 0) == 0) { break }
                        p = d + 10676 | 0;
                        l = (c[(c[b + 376220 >> 2] | 0) + 5828 >> 2] | 0) - 1 | 0;
                        n = d + 10680 | 0;
                        q = c[n >> 2] | 0;
                        o = c[p >> 2] | 0;
                        j = q - o >> 3;
                        if (j >>> 0 < l >>> 0) { uf(p, l - j | 0); break }
                        if (!(j >>> 0 > l >>> 0)) { break }
                        j = o + (l << 3) | 0;
                        if ((q | 0) == (j | 0)) { break } else { t = q }
                        do {
                            q = t - 8 | 0;
                            c[n >> 2] = q;
                            Ed(q);
                            t = c[n >> 2] | 0;
                        } while ((t | 0) != (j | 0))
                    }
                } while (0);
                c[e + 120 >> 2] = 1;
                t = dk(g) | 0;
                Ek(e + 44 | 0, 1);
                s = t
            }
            Ed(k);
            r = s;
            i = f;
            return r | 0
        }

        function $e(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            h = c[d >> 2] | 0;
            j = c[e + 4 >> 2] | 0;
            k = c[j + 768 >> 2] | 0;
            l = k + 1 | 0;
            m = c[h + 5820 >> 2] | 0;
            if ((c[h + 10536 >> 2] | 0) != (-(c[h + 10532 >> 2] | 0) | 0)) { ec(8488, 14344, 989, 17688); return 0 }
            do {
                if ((a[j + 4 | 0] | 0) != 0) {
                    n = d + 10676 | 0;
                    o = (c[h + 5828 >> 2] | 0) - 1 | 0;
                    p = d + 10680 | 0;
                    q = c[p >> 2] | 0;
                    r = c[n >> 2] | 0;
                    s = q - r >> 3;
                    if (s >>> 0 < o >>> 0) { uf(n, o - s | 0); break }
                    if (!(s >>> 0 > o >>> 0)) { break }
                    s = r + (o << 3) | 0;
                    if ((q | 0) == (s | 0)) { break } else { t = q }
                    do {
                        q = t - 8 | 0;
                        c[p >> 2] = q;
                        Ed(q);
                        t = c[p >> 2] | 0;
                    } while ((t | 0) != (s | 0))
                }
            } while (0);
            Ie(e, l);
            t = c[j + 16 >> 2] | 0;
            s = (t | 0) / (m | 0) | 0;
            a: do {
                if ((k | 0) > -1) {
                    p = e + 136 | 0;
                    q = e + 132 | 0;
                    o = h + 10332 | 0;
                    r = h + 10272 | 0;
                    n = e + 12 | 0;
                    u = e + 8 | 0;
                    v = e + 120 | 0;
                    w = b + 375396 | 0;
                    x = j + 776 | 0;
                    if ((k | 0) > 0) {
                        y = t;
                        z = s;
                        A = 0
                    } else {
                        B = t;
                        C = s;
                        D = 0;
                        while (1) {
                            if ((D | 0) > 0) {
                                E = C + 1 | 0;
                                F = E;
                                G = ga(E, m) | 0
                            } else {
                                F = C;
                                G = B
                            }
                            if ((c[p >> 2] | 0) <= (D | 0)) { break }
                            E = c[q >> 2] | 0;
                            H = E + (D * 18624 | 0) | 0;
                            c[E + (D * 18624 | 0) + 18600 >> 2] = j;
                            c[E + (D * 18624 | 0) + 18592 >> 2] = c[o >> 2];
                            c[E + (D * 18624 | 0) + 18596 >> 2] = h;
                            I = E + (D * 18624 | 0) + 18604 | 0;
                            c[I >> 2] = d;
                            c[E + (D * 18624 | 0) + 18608 >> 2] = e;
                            c[E + (D * 18624 | 0) + 4 >> 2] = c[(c[r >> 2] | 0) + (G << 2) >> 2];
                            Qe(0, H);
                            J = (D | 0) == 0;
                            if (J) { K = 0 } else { K = c[(c[x >> 2] | 0) + (D - 1 << 2) >> 2] | 0 }
                            if ((D | 0) == (k | 0)) { L = n } else { L = (c[x >> 2] | 0) + (D << 2) | 0 }
                            M = c[L >> 2] | 0;
                            if ((K | 0) < 0) { break a }
                            if (!((M | 0) <= (c[n >> 2] | 0) & (M | 0) > (K | 0))) { break a }
                            sd(E + (D * 18624 | 0) + 18556 | 0, (c[u >> 2] | 0) + K | 0, M - K | 0);
                            Vh(h, 1);
                            c[v >> 2] = (c[v >> 2] | 0) + 1;
                            M = Nu(20) | 0;
                            c[M + 4 >> 2] = 0;
                            c[M >> 2] = 22248;
                            a[M + 8 | 0] = J & 1;
                            c[M + 16 >> 2] = H;
                            c[M + 12 >> 2] = F;
                            H = M;
                            c[E + (D * 18624 | 0) + 18612 >> 2] = H;
                            Kk(w, H);
                            E = c[I >> 2] | 0;
                            c[g >> 2] = H;
                            I = E + 10668 | 0;
                            M = c[I >> 2] | 0;
                            if (M >>> 0 < (c[E + 10672 >> 2] | 0) >>> 0) {
                                if ((M | 0) == 0) { N = 0 } else {
                                    c[M >> 2] = H;
                                    N = c[I >> 2] | 0
                                }
                                c[I >> 2] = N + 4
                            } else { He(E + 10664 | 0, g) }
                            E = D + 1 | 0;
                            if ((E | 0) < (l | 0)) {
                                B = G;
                                C = F;
                                D = E
                            } else { break a }
                        }
                        ec(15880, 15472, 170, 17840);
                        return 0
                    }
                    while (1) {
                        if ((A | 0) > 0) {
                            D = z + 1 | 0;
                            O = D;
                            P = ga(D, m) | 0
                        } else {
                            if (((y | 0) % (m | 0) | 0 | 0) == 0) {
                                O = z;
                                P = y
                            } else { break a }
                        }
                        if ((c[p >> 2] | 0) <= (A | 0)) { break }
                        D = c[q >> 2] | 0;
                        C = D + (A * 18624 | 0) | 0;
                        c[D + (A * 18624 | 0) + 18600 >> 2] = j;
                        c[D + (A * 18624 | 0) + 18592 >> 2] = c[o >> 2];
                        c[D + (A * 18624 | 0) + 18596 >> 2] = h;
                        B = D + (A * 18624 | 0) + 18604 | 0;
                        c[B >> 2] = d;
                        c[D + (A * 18624 | 0) + 18608 >> 2] = e;
                        c[D + (A * 18624 | 0) + 4 >> 2] = c[(c[r >> 2] | 0) + (P << 2) >> 2];
                        Qe(0, C);
                        E = (A | 0) == 0;
                        if (E) { Q = 0 } else { Q = c[(c[x >> 2] | 0) + (A - 1 << 2) >> 2] | 0 }
                        if ((A | 0) == (k | 0)) { R = n } else { R = (c[x >> 2] | 0) + (A << 2) | 0 }
                        I = c[R >> 2] | 0;
                        if ((Q | 0) < 0) { break a }
                        if (!((I | 0) <= (c[n >> 2] | 0) & (I | 0) > (Q | 0))) { break a }
                        sd(D + (A * 18624 | 0) + 18556 | 0, (c[u >> 2] | 0) + Q | 0, I - Q | 0);
                        Vh(h, 1);
                        c[v >> 2] = (c[v >> 2] | 0) + 1;
                        I = Nu(20) | 0;
                        c[I + 4 >> 2] = 0;
                        c[I >> 2] = 22248;
                        a[I + 8 | 0] = E & 1;
                        c[I + 16 >> 2] = C;
                        c[I + 12 >> 2] = O;
                        C = I;
                        c[D + (A * 18624 | 0) + 18612 >> 2] = C;
                        Kk(w, C);
                        D = c[B >> 2] | 0;
                        c[g >> 2] = C;
                        B = D + 10668 | 0;
                        I = c[B >> 2] | 0;
                        if (I >>> 0 < (c[D + 10672 >> 2] | 0) >>> 0) {
                            if ((I | 0) == 0) { S = 0 } else {
                                c[I >> 2] = C;
                                S = c[B >> 2] | 0
                            }
                            c[B >> 2] = S + 4
                        } else { He(D + 10664 | 0, g) }
                        D = A + 1 | 0;
                        if ((D | 0) < (l | 0)) {
                            y = P;
                            z = O;
                            A = D
                        } else { break a }
                    }
                    ec(15880, 15472, 170, 17840);
                    return 0
                }
            } while (0);
            _h(h);
            h = d + 10668 | 0;
            A = c[h >> 2] | 0;
            O = d + 10664 | 0;
            d = c[O >> 2] | 0;
            if ((A | 0) == (d | 0)) { i = f; return 0 } else {
                T = 0;
                U = d;
                V = A
            }
            while (1) {
                A = c[U + (T << 2) >> 2] | 0;
                if ((A | 0) == 0) {
                    W = V;
                    X = U
                } else {
                    Dc[c[(c[A >> 2] | 0) + 4 >> 2] & 511](A);
                    W = c[h >> 2] | 0;
                    X = c[O >> 2] | 0
                }
                A = T + 1 | 0;
                Y = X;
                if (A >>> 0 < W - Y >> 2 >>> 0) {
                    T = A;
                    U = X;
                    V = W
                } else { break }
            }
            if ((W | 0) == (X | 0)) { i = f; return 0 }
            c[h >> 2] = W + (~((W - 4 + (-Y | 0) | 0) >>> 2) << 2);
            i = f;
            return 0
        }

        function af(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            h = c[d >> 2] | 0;
            j = c[e + 4 >> 2] | 0;
            k = c[j + 768 >> 2] | 0;
            l = k + 1 | 0;
            m = c[h + 5820 >> 2] | 0;
            if ((c[h + 10536 >> 2] | 0) != (-(c[h + 10532 >> 2] | 0) | 0)) { ec(8488, 14344, 1103, 17664); return 0 }
            Ie(e, l);
            n = c[j + 16 >> 2] | 0;
            a: do {
                if ((k | 0) > -1) {
                    o = h + 5968 | 0;
                    p = h + 5972 | 0;
                    q = e + 136 | 0;
                    r = e + 132 | 0;
                    s = h + 10332 | 0;
                    t = h + 10272 | 0;
                    u = e + 12 | 0;
                    v = e + 8 | 0;
                    w = e + 120 | 0;
                    x = b + 375396 | 0;
                    y = j + 776 | 0;
                    z = 0;
                    A = c[(c[h + 10308 >> 2] | 0) + (n << 2) >> 2] | 0;
                    B = n;
                    while (1) {
                        if ((z | 0) > 0) {
                            C = A + 1 | 0;
                            D = c[o >> 2] | 0;
                            if ((C | 0) >= (ga(c[p >> 2] | 0, D) | 0)) { E = 1007; break a }
                            F = (ga(c[h + 10228 + (((C | 0) / (D | 0) | 0) << 2) >> 2] | 0, m) | 0) + (c[h + 10184 + (((C | 0) % (D | 0) | 0) << 2) >> 2] | 0) | 0;
                            G = C
                        } else {
                            F = B;
                            G = A
                        }
                        if ((c[q >> 2] | 0) <= (z | 0)) { break }
                        C = c[r >> 2] | 0;
                        D = C + (z * 18624 | 0) | 0;
                        c[C + (z * 18624 | 0) + 18600 >> 2] = j;
                        c[C + (z * 18624 | 0) + 18592 >> 2] = c[s >> 2];
                        c[C + (z * 18624 | 0) + 18596 >> 2] = h;
                        H = C + (z * 18624 | 0) + 18604 | 0;
                        c[H >> 2] = d;
                        c[C + (z * 18624 | 0) + 18608 >> 2] = e;
                        c[C + (z * 18624 | 0) + 4 >> 2] = c[(c[t >> 2] | 0) + (F << 2) >> 2];
                        Qe(0, D);
                        I = (z | 0) == 0;
                        if (I) { J = 0 } else { J = c[(c[y >> 2] | 0) + (z - 1 << 2) >> 2] | 0 }
                        if ((z | 0) == (k | 0)) { K = u } else { K = (c[y >> 2] | 0) + (z << 2) | 0 }
                        L = c[K >> 2] | 0;
                        if ((J | 0) < 0) { E = 17; break a }
                        if (!((L | 0) <= (c[u >> 2] | 0) & (L | 0) > (J | 0))) { E = 17; break a }
                        sd(C + (z * 18624 | 0) + 18556 | 0, (c[v >> 2] | 0) + J | 0, L - J | 0);
                        Vh(h, 1);
                        c[w >> 2] = (c[w >> 2] | 0) + 1;
                        L = Nu(24) | 0;
                        c[L + 4 >> 2] = 0;
                        c[L >> 2] = 22216;
                        a[L + 8 | 0] = I & 1;
                        c[L + 20 >> 2] = D;
                        c[L + 12 >> 2] = (F | 0) % (m | 0) | 0;
                        c[L + 16 >> 2] = (F | 0) / (m | 0) | 0;
                        D = L;
                        c[C + (z * 18624 | 0) + 18612 >> 2] = D;
                        Kk(x, D);
                        C = c[H >> 2] | 0;
                        c[g >> 2] = D;
                        H = C + 10668 | 0;
                        L = c[H >> 2] | 0;
                        if (L >>> 0 < (c[C + 10672 >> 2] | 0) >>> 0) {
                            if ((L | 0) == 0) { M = 0 } else {
                                c[L >> 2] = D;
                                M = c[H >> 2] | 0
                            }
                            c[H >> 2] = M + 4
                        } else { He(C + 10664 | 0, g) }
                        C = z + 1 | 0;
                        if ((C | 0) < (l | 0)) {
                            z = C;
                            A = G;
                            B = F
                        } else { E = 0; break a }
                    }
                    ec(15880, 15472, 170, 17840);
                    return 0
                } else { E = 0 }
            } while (0);
            _h(h);
            h = d + 10668 | 0;
            F = c[h >> 2] | 0;
            G = d + 10664 | 0;
            d = c[G >> 2] | 0;
            if ((F | 0) == (d | 0)) { i = f; return E | 0 } else {
                N = 0;
                O = d;
                P = F
            }
            while (1) {
                F = c[O + (N << 2) >> 2] | 0;
                if ((F | 0) == 0) {
                    Q = P;
                    R = O
                } else {
                    Dc[c[(c[F >> 2] | 0) + 4 >> 2] & 511](F);
                    Q = c[h >> 2] | 0;
                    R = c[G >> 2] | 0
                }
                F = N + 1 | 0;
                S = R;
                if (F >>> 0 < Q - S >> 2 >>> 0) {
                    N = F;
                    O = R;
                    P = Q
                } else { break }
            }
            if ((Q | 0) == (R | 0)) { i = f; return E | 0 }
            c[h >> 2] = Q + (~((Q - 4 + (-S | 0) | 0) >>> 2) << 2);
            i = f;
            return E | 0
        }

        function bf(b, e) {
            b = b | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            f = i;
            i = i + 5200 | 0;
            g = f | 0;
            h = f + 5168 | 0;
            j = f + 5192 | 0;
            md(h, c[e + 20 >> 2] | 0, c[e + 24 >> 2] | 0);
            k = j | 0;
            a[k] = 0;
            l = j + 1 | 0;
            a[l] = 0;
            m = j + 2 | 0;
            a[m] = 0;
            Ji(j, h);
            n = a[k] | 0;
            a[b + 377208 | 0] = n;
            a[b + 377209 | 0] = (n - 19 & 255) >>> 0 < 2 >>> 0 | 0;
            a[b + 377210 | 0] = (n - 16 & 255) >>> 0 < 8 >>> 0 | 0;
            if ((a[l] | 0) != 0) {
                Vi(b + 548 | 0, e);
                o = 0;
                i = f;
                return o | 0
            }
            if ((d[m] | 0) > (c[b + 375908 >> 2] | 0)) {
                Vi(b + 548 | 0, e);
                o = 0;
                i = f;
                return o | 0
            }
            if ((n & 255) >>> 0 < 32 >>> 0) {
                o = Ve(b, h, e, j) | 0;
                i = f;
                return o | 0
            }
            switch (n & 255 | 0) {
                case 33:
                    {
                        j = g | 0;ik(g);m = kk(g, b + 4 | 0, h) | 0;
                        if ((m | 0) == 0) {
                            l = c[b + 516 >> 2] | 0;
                            if ((l | 0) > -1) { pk(g, l) }
                            l = c[g + 472 >> 2] | 0;
                            k = b + 11096 + (l * 5168 | 0) | 0;
                            cv(k | 0, j | 0, 4717) | 0;
                            if ((k | 0) != (g | 0)) { zf(b + 11096 + (l * 5168 | 0) + 4720 | 0, c[g + 4720 >> 2] | 0, c[g + 4724 >> 2] | 0) }
                            cv(b + 11096 + (l * 5168 | 0) + 4732 | 0, g + 4732 | 0, 436) | 0;
                            p = 0
                        } else { p = m }
                        jk(g);Vi(b + 548 | 0, e);o = p;i = f;
                        return o | 0
                    };
                case 32:
                    { p = Re(b, h) | 0;Vi(b + 548 | 0, e);o = p;i = f; return o | 0 };
                case 34:
                    { p = Se(b, h) | 0;Vi(b + 548 | 0, e);o = p;i = f; return o | 0 };
                case 39:
                case 40:
                    { p = Te(b, h, n << 24 >> 24 == 40) | 0;Vi(b + 548 | 0, e);o = p;i = f; return o | 0 };
                case 36:
                    { a[b + 376207 | 0] = 1;Vi(b + 548 | 0, e);o = 0;i = f; return o | 0 };
                default:
                    { Vi(b + 548 | 0, e);o = 0;i = f; return o | 0 }
            }
            return 0
        }

        function cf(b, e) {
            b = b | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            h = b + 548 | 0;
            j = b + 580 | 0;
            k = (c[j >> 2] | 0) == 0;
            l = a[h | 0] | 0;
            do {
                if (k) {
                    if (l << 24 >> 24 == 0) { if ((a[b + 549 | 0] | 0) == 0) { m = 8; break } }
                    if ((c[b + 377212 >> 2] | 0) != (c[b + 377216 >> 2] | 0)) { m = 7; break }
                    Ah(b + 376144 | 0) | 0;
                    if ((e | 0) == 0) {
                        n = 0;
                        i = f;
                        return n | 0
                    }
                    c[e >> 2] = c[b + 376196 >> 2];
                    n = 0;
                    i = f;
                    return n | 0
                } else { m = 7 }
            } while (0);
            if ((m | 0) == 7) { if (l << 24 >> 24 == 0) { m = 8 } }
            do {
                if ((m | 0) == 8) {
                    if ((a[b + 549 | 0] | 0) != 0 | k ^ 1) { break }
                    if ((e | 0) == 0) {
                        n = 13;
                        i = f;
                        return n | 0
                    }
                    c[e >> 2] = 1;
                    n = 13;
                    i = f;
                    return n | 0
                }
            } while (0);
            if (!(vh(b + 376144 | 0, 0) | 0)) {
                if ((e | 0) == 0) {
                    n = 9;
                    i = f;
                    return n | 0
                }
                c[e >> 2] = 1;
                n = 9;
                i = f;
                return n | 0
            }
            a[g] = 0;
            do {
                if ((c[j >> 2] | 0) == 0) {
                    do {
                        if ((a[b + 549 | 0] | 0) != 0) {
                            if ((c[b + 377212 >> 2] | 0) != (c[b + 377216 >> 2] | 0)) { break }
                            if ((e | 0) == 0) {
                                n = 13;
                                i = f;
                                return n | 0
                            }
                            c[e >> 2] = 1;
                            n = 13;
                            i = f;
                            return n | 0
                        }
                    } while (0);
                    o = Xe(b, g) | 0
                } else {
                    k = Ui(h) | 0;
                    if ((k | 0) == 0) { ec(6136, 14344, 1314, 17512); return 0 } else {
                        m = bf(b, k) | 0;
                        a[g] = 1;
                        o = m;
                        break
                    }
                }
            } while (0);
            if ((e | 0) == 0) {
                n = o;
                i = f;
                return n | 0
            }
            if ((o | 0) == 0) { p = d[g] | 0 } else { p = 0 }
            c[e >> 2] = p;
            n = o;
            i = f;
            return n | 0
        }

        function df(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            f = d + 377208 | 0;
            do {
                if (Ni(a[f] | 0) | 0) {
                    if ((a[d + 376205 | 0] | 0) == 0) { g = 4; break }
                    c[d + 376208 >> 2] = 0;
                    a[b + 377224 | 0] = 1;
                    h = 0;
                    i = e + 28 | 0
                } else { g = 4 }
            } while (0);
            a: do {
                if ((g | 0) == 4) {
                    b = c[(c[d + 375388 >> 2] | 0) + 5032 >> 2] | 0;
                    j = e + 28 | 0;
                    k = c[j >> 2] | 0;
                    l = c[d + 376212 >> 2] | 0;
                    do {
                        if ((k | 0) < (l | 0)) {
                            if ((l - k | 0) < ((b | 0) / 2 | 0 | 0)) { break }
                            m = (c[d + 376216 >> 2] | 0) + b | 0;
                            c[d + 376208 >> 2] = m;
                            h = m;
                            i = j;
                            break a
                        }
                    } while (0);
                    do {
                        if ((k | 0) > (l | 0)) {
                            if ((k - l | 0) <= ((b | 0) / 2 | 0 | 0)) { break }
                            m = (c[d + 376216 >> 2] | 0) - b | 0;
                            c[d + 376208 >> 2] = m;
                            h = m;
                            i = j;
                            break a
                        }
                    } while (0);
                    b = c[d + 376216 >> 2] | 0;
                    c[d + 376208 >> 2] = b;
                    h = b;
                    i = j
                }
            } while (0);
            e = c[d + 376220 >> 2] | 0;
            c[e + 92 >> 2] = (c[i >> 2] | 0) + h;
            c[e + 88 >> 2] = c[i >> 2];
            if ((a[e + 10520 | 0] | 0) != 0) { return }
            if (Pi(a[f] | 0) | 0) { return }
            if (Mi(a[f] | 0) | 0) { return }
            if (Oi(a[f] | 0) | 0) { return }
            c[d + 376212 >> 2] = c[i >> 2];
            c[d + 376216 >> 2] = c[d + 376208 >> 2];
            return
        }

        function ef(b, e, f, g, h) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            i = e + 376144 | 0;
            if (!(vh(i, 1) | 0)) { ec(4312, 14344, 1433, 17520); return 0 }
            j = Ch(i, c[e + 375388 >> 2] | 0, b, 0, 0, 0, 0) | 0;
            if (!((j | 0) > -1)) { ec(3080, 14344, 1436, 17520); return 0 }
            b = c[e + 376152 >> 2] | 0;
            if ((c[e + 376156 >> 2] | 0) - b >> 2 >>> 0 > j >>> 0) { k = c[b + (j << 2) >> 2] | 0 } else { k = 0 }
            b = 1 << (c[f + 5004 >> 2] | 0) - 1;
            Sh(k, 1 << (c[f + 4996 >> 2] | 0) - 1, b, b);
            b = k + 10364 | 0;
            if ((c[b >> 2] | 0) <= 0) {
                l = k + 92 | 0;
                c[l >> 2] = g;
                m = f + 5032 | 0;
                n = c[m >> 2] | 0;
                o = n - 1 | 0;
                p = o & g;
                q = k + 88 | 0;
                c[q >> 2] = p;
                r = k + 100 | 0;
                a[r] = 0;
                s = h ? 2 : 1;
                t = k + 96 | 0;
                c[t >> 2] = s;
                u = k + 10516 | 0;
                a[u] = 1;
                return j | 0
            }
            e = k + 10360 | 0;
            i = 0;
            do {
                v = (c[e >> 2] | 0) + (i * 3 | 0) | 0;
                C = (d[v] | d[v + 1 | 0] << 8) << 16 >> 16 & -769;
                a[v] = C;
                C = C >> 8;
                a[v + 1 | 0] = C;
                i = i + 1 | 0;
            } while ((i | 0) < (c[b >> 2] | 0));
            l = k + 92 | 0;
            c[l >> 2] = g;
            m = f + 5032 | 0;
            n = c[m >> 2] | 0;
            o = n - 1 | 0;
            p = o & g;
            q = k + 88 | 0;
            c[q >> 2] = p;
            r = k + 100 | 0;
            a[r] = 0;
            s = h ? 2 : 1;
            t = k + 96 | 0;
            c[t >> 2] = s;
            u = k + 10516 | 0;
            a[u] = 1;
            return j | 0
        }

        function ff(e, f, g) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0;
            h = i;
            i = i + 40 | 0;
            j = h | 0;
            k = h + 16 | 0;
            l = h + 32 | 0;
            m = j | 0;
            c[m >> 2] = 0;
            n = j + 4 | 0;
            c[n >> 2] = 0;
            o = j + 8 | 0;
            c[o >> 2] = 0;
            p = f + 376220 | 0;
            q = c[c[p >> 2] >> 2] | 0;
            r = f + 377208 | 0;
            a: do {
                if (Ni(a[r] | 0) | 0) {
                    if ((a[f + 376205 | 0] | 0) == 0) { break }
                    s = c[p >> 2] | 0;
                    t = c[s + 92 >> 2] | 0;
                    u = e + 376156 | 0;
                    v = c[u >> 2] | 0;
                    w = e + 376152 | 0;
                    x = c[w >> 2] | 0;
                    if ((v - x | 0) <= 0) { break }
                    y = f + 376156 | 0;
                    z = f + 376152 | 0;
                    A = 0;
                    B = v;
                    v = x;
                    x = s;
                    b: while (1) {
                        s = c[z >> 2] | 0;
                        if ((c[y >> 2] | 0) - s >> 2 >>> 0 > A >>> 0) { C = c[s + (A << 2) >> 2] | 0 } else { C = 0 }
                        do {
                            if ((c[C + 96 >> 2] | 0) == 0) {
                                D = B;
                                E = v;
                                F = x
                            } else {
                                if ((c[C + 92 >> 2] | 0) >= (t | 0)) {
                                    D = B;
                                    E = v;
                                    F = x;
                                    break
                                }
                                s = C + 104 | 0;
                                if (!((c[s >> 2] | 0) >>> 0 > (c[x >> 2] | 0) >>> 0)) {
                                    D = B;
                                    E = v;
                                    F = x;
                                    break
                                }
                                G = c[C >> 2] | 0;
                                H = c[n >> 2] | 0;
                                I = c[o >> 2] | 0;
                                do {
                                    if (H >>> 0 < I >>> 0) {
                                        if ((H | 0) != 0) { c[H >> 2] = G }
                                        c[n >> 2] = H + 4;
                                        J = x;
                                        K = B;
                                        L = v
                                    } else {
                                        M = c[m >> 2] | 0;
                                        N = M;
                                        O = H - N | 0;
                                        P = O >> 2;
                                        Q = P + 1 | 0;
                                        if (Q >>> 0 > 1073741823 >>> 0) { break b }
                                        R = I - N | 0;
                                        if (R >> 2 >>> 0 < 536870911 >>> 0) {
                                            N = R >> 1;
                                            R = N >>> 0 < Q >>> 0 ? Q : N;
                                            if ((R | 0) == 0) {
                                                S = 0;
                                                T = 0
                                            } else {
                                                U = R;
                                                V = 20
                                            }
                                        } else {
                                            U = 1073741823;
                                            V = 20
                                        }
                                        if ((V | 0) == 20) {
                                            V = 0;
                                            S = Nu(U << 2) | 0;
                                            T = U
                                        }
                                        R = S + (P << 2) | 0;
                                        if ((R | 0) != 0) { c[R >> 2] = G }
                                        R = M;
                                        cv(S | 0, R | 0, O) | 0;
                                        c[m >> 2] = S;
                                        c[n >> 2] = S + (Q << 2);
                                        c[o >> 2] = S + (T << 2);
                                        if ((M | 0) == 0) {
                                            J = x;
                                            K = B;
                                            L = v;
                                            break
                                        }
                                        Pu(R);
                                        J = c[p >> 2] | 0;
                                        K = c[u >> 2] | 0;
                                        L = c[w >> 2] | 0
                                    }
                                } while (0);
                                c[s >> 2] = c[J >> 2];
                                D = K;
                                E = L;
                                F = J
                            }
                        } while (0);
                        G = A + 1 | 0;
                        if ((G | 0) < (D - E >> 2 | 0)) {
                            A = G;
                            B = D;
                            v = E;
                            x = F
                        } else { break a }
                    }
                    Nr(0)
                }
            } while (0);
            if (Ki(a[r] | 0) | 0) { dv(f + 376548 | 0, 0, 20) | 0 } else {
                r = g + 908 | 0;
                if ((a[r] | 0) == 0) {
                    W = 0;
                    X = 0
                } else {
                    F = 0;
                    E = 0;
                    D = 0;
                    while (1) {
                        J = (b[g + 812 + (D << 1) >> 1] | 0) + (c[(c[p >> 2] | 0) + 92 >> 2] | 0) | 0;
                        if ((a[g + 876 + D | 0] | 0) == 0) {
                            c[f + 376696 + (F << 2) >> 2] = J;
                            Y = E;
                            Z = F + 1 | 0
                        } else {
                            c[f + 376568 + (E << 2) >> 2] = J;
                            Y = E + 1 | 0;
                            Z = F
                        }
                        J = D + 1 | 0;
                        if ((J | 0) < (d[r] | 0)) {
                            F = Z;
                            E = Y;
                            D = J
                        } else {
                            W = Z;
                            X = Y;
                            break
                        }
                    }
                }
                c[f + 376548 >> 2] = X;
                X = g + 909 | 0;
                if ((a[X] | 0) == 0) {
                    _ = W;
                    $ = 0
                } else {
                    Y = W;
                    W = 0;
                    Z = 0;
                    while (1) {
                        D = (b[g + 844 + (Z << 1) >> 1] | 0) + (c[(c[p >> 2] | 0) + 92 >> 2] | 0) | 0;
                        if ((a[g + 892 + Z | 0] | 0) == 0) {
                            c[f + 376696 + (Y << 2) >> 2] = D;
                            aa = W;
                            ba = Y + 1 | 0
                        } else {
                            c[f + 376632 + (W << 2) >> 2] = D;
                            aa = W + 1 | 0;
                            ba = Y
                        }
                        D = Z + 1 | 0;
                        if ((D | 0) < (d[X] | 0)) {
                            Y = ba;
                            W = aa;
                            Z = D
                        } else {
                            _ = ba;
                            $ = aa;
                            break
                        }
                    }
                }
                c[f + 376552 >> 2] = $;
                c[f + 376556 >> 2] = _;
                _ = g + 140 | 0;
                $ = g + 144 | 0;
                if (((c[$ >> 2] | 0) + (c[_ >> 2] | 0) | 0) > 0) {
                    aa = g + 28 | 0;
                    ba = f + 375388 | 0;
                    Z = 0;
                    W = 0;
                    Y = 0;
                    while (1) {
                        X = c[f + 376228 + (Y << 2) >> 2] | 0;
                        D = g + 244 + Y | 0;
                        if ((a[D] | 0) == 0) { ca = X } else { ca = (c[(c[p >> 2] | 0) + 92 >> 2] | 0) + X - (c[aa >> 2] | 0) - (ga(c[(c[ba >> 2] | 0) + 5032 >> 2] | 0, c[f + 376356 + (Y << 2) >> 2] | 0) | 0) | 0 }
                        if ((c[f + 376292 + (Y << 2) >> 2] | 0) == 0) {
                            c[f + 376824 + (Z << 2) >> 2] = ca;
                            c[f + 376484 + (Z << 2) >> 2] = a[D] | 0;
                            da = W;
                            ea = Z + 1 | 0
                        } else {
                            c[f + 376760 + (W << 2) >> 2] = ca;
                            c[f + 376420 + (W << 2) >> 2] = a[D] | 0;
                            da = W + 1 | 0;
                            ea = Z
                        }
                        D = Y + 1 | 0;
                        if ((D | 0) < ((c[$ >> 2] | 0) + (c[_ >> 2] | 0) | 0)) {
                            Z = ea;
                            W = da;
                            Y = D
                        } else {
                            fa = ea;
                            ha = da;
                            break
                        }
                    }
                } else {
                    fa = 0;
                    ha = 0
                }
                c[f + 376560 >> 2] = ha;
                c[f + 376564 >> 2] = fa
            }
            fa = e + 376156 | 0;
            ha = e + 376152 | 0;
            da = (c[fa >> 2] | 0) - (c[ha >> 2] | 0) >> 2;
            a[l] = 0;
            sf(k, da, l);
            uh(e + 376144 | 0);
            l = f + 376560 | 0;
            da = c[l >> 2] | 0;
            if ((da | 0) > 0) {
                ea = f + 376144 | 0;
                Y = c[k >> 2] | 0;
                W = f + 376152 | 0;
                Z = f + 375388 | 0;
                _ = 0;
                while (1) {
                    $ = f + 376760 + (_ << 2) | 0;
                    ca = c[$ >> 2] | 0;
                    if ((c[f + 376420 + (_ << 2) >> 2] | 0) == 0) { ia = xh(ea, ca, q, 1) | 0 } else { ia = wh(ea, ca, q, 1) | 0 }
                    ca = f + 377080 + (_ << 2) | 0;
                    c[ca >> 2] = ia;
                    if ((ia | 0) > -1) {
                        ba = Y + (ia >>> 5 << 2) | 0;
                        c[ba >> 2] = c[ba >> 2] | 1 << (ia & 31);
                        ja = ia
                    } else {
                        ba = ef(e, f, c[Z >> 2] | 0, c[$ >> 2] | 0, 1) | 0;
                        c[ca >> 2] = ba;
                        ca = Y + (ba >>> 5 << 2) | 0;
                        c[ca >> 2] = c[ca >> 2] | 1 << (ba & 31);
                        ja = ba
                    }
                    if ((a[(c[(c[W >> 2] | 0) + (ja << 2) >> 2] | 0) + 10516 | 0] | 0) != 0) { a[(c[p >> 2] | 0) + 10516 | 0] = 4 }
                    ba = _ + 1 | 0;
                    ca = c[l >> 2] | 0;
                    if ((ba | 0) < (ca | 0)) { _ = ba } else { ka = ca; break }
                }
            } else { ka = da }
            da = f + 376564 | 0;
            _ = c[da >> 2] | 0;
            if ((_ | 0) > 0) {
                ja = f + 376144 | 0;
                W = c[k >> 2] | 0;
                Y = f + 375388 | 0;
                Z = 0;
                do {
                    ia = f + 376824 + (Z << 2) | 0;
                    ea = c[ia >> 2] | 0;
                    if ((c[f + 376484 + (Z << 2) >> 2] | 0) == 0) { la = xh(ja, ea, q, 1) | 0 } else { la = wh(ja, ea, q, 1) | 0 }
                    ea = f + 377144 + (Z << 2) | 0;
                    c[ea >> 2] = la;
                    if ((la | 0) > -1) {
                        ca = W + (la >>> 5 << 2) | 0;
                        c[ca >> 2] = c[ca >> 2] | 1 << (la & 31)
                    } else {
                        ca = ef(e, f, c[Y >> 2] | 0, c[ia >> 2] | 0, 1) | 0;
                        c[ea >> 2] = ca;
                        ea = W + (ca >>> 5 << 2) | 0;
                        c[ea >> 2] = c[ea >> 2] | 1 << (ca & 31)
                    }
                    Z = Z + 1 | 0;
                    ma = c[da >> 2] | 0;
                } while ((Z | 0) < (ma | 0));
                na = c[l >> 2] | 0;
                oa = ma
            } else {
                na = ka;
                oa = _
            }
            if ((na | 0) > 0) {
                _ = c[f + 376152 >> 2] | 0;
                ka = 0;
                do {
                    c[(c[_ + (c[f + 377080 + (ka << 2) >> 2] << 2) >> 2] | 0) + 96 >> 2] = 2;
                    ka = ka + 1 | 0;
                } while ((ka | 0) < (na | 0))
            }
            if ((oa | 0) > 0) {
                na = c[f + 376152 >> 2] | 0;
                ka = 0;
                do {
                    c[(c[na + (c[f + 377144 + (ka << 2) >> 2] << 2) >> 2] | 0) + 96 >> 2] = 2;
                    ka = ka + 1 | 0;
                } while ((ka | 0) < (oa | 0))
            }
            oa = f + 376548 | 0;
            if ((c[oa >> 2] | 0) > 0) {
                ka = f + 376144 | 0;
                na = c[k >> 2] | 0;
                _ = f + 376152 | 0;
                ma = f + 375388 | 0;
                l = 0;
                do {
                    Z = f + 376568 + (l << 2) | 0;
                    da = wh(ka, c[Z >> 2] | 0, q, 0) | 0;
                    W = f + 376888 + (l << 2) | 0;
                    c[W >> 2] = da;
                    if ((da | 0) > -1) {
                        Y = na + (da >>> 5 << 2) | 0;
                        c[Y >> 2] = c[Y >> 2] | 1 << (da & 31);
                        pa = da
                    } else {
                        da = ef(e, f, c[ma >> 2] | 0, c[Z >> 2] | 0, 0) | 0;
                        c[W >> 2] = da;
                        W = na + (da >>> 5 << 2) | 0;
                        c[W >> 2] = c[W >> 2] | 1 << (da & 31);
                        pa = da
                    }
                    if ((a[(c[(c[_ >> 2] | 0) + (pa << 2) >> 2] | 0) + 10516 | 0] | 0) != 0) { a[(c[p >> 2] | 0) + 10516 | 0] = 4 }
                    l = l + 1 | 0;
                } while ((l | 0) < (c[oa >> 2] | 0))
            }
            oa = f + 376552 | 0;
            if ((c[oa >> 2] | 0) > 0) {
                l = f + 376144 | 0;
                pa = c[k >> 2] | 0;
                _ = f + 376152 | 0;
                na = f + 375388 | 0;
                ma = 0;
                do {
                    ka = f + 376632 + (ma << 2) | 0;
                    da = wh(l, c[ka >> 2] | 0, q, 0) | 0;
                    W = f + 376952 + (ma << 2) | 0;
                    c[W >> 2] = da;
                    if ((da | 0) > -1) {
                        Z = pa + (da >>> 5 << 2) | 0;
                        c[Z >> 2] = c[Z >> 2] | 1 << (da & 31);
                        qa = da
                    } else {
                        da = ef(e, f, c[na >> 2] | 0, c[ka >> 2] | 0, 0) | 0;
                        c[W >> 2] = da;
                        W = pa + (da >>> 5 << 2) | 0;
                        c[W >> 2] = c[W >> 2] | 1 << (da & 31);
                        qa = da
                    }
                    if ((a[(c[(c[_ >> 2] | 0) + (qa << 2) >> 2] | 0) + 10516 | 0] | 0) != 0) { a[(c[p >> 2] | 0) + 10516 | 0] = 4 }
                    ma = ma + 1 | 0;
                } while ((ma | 0) < (c[oa >> 2] | 0))
            }
            oa = f + 376556 | 0;
            if ((c[oa >> 2] | 0) > 0) {
                ma = f + 376144 | 0;
                qa = c[k >> 2] | 0;
                _ = 0;
                do {
                    pa = wh(ma, c[f + 376696 + (_ << 2) >> 2] | 0, q, 0) | 0;
                    c[f + 377016 + (_ << 2) >> 2] = pa;
                    if ((pa | 0) > -1) {
                        na = qa + (pa >>> 5 << 2) | 0;
                        c[na >> 2] = c[na >> 2] | 1 << (pa & 31)
                    }
                    _ = _ + 1 | 0;
                } while ((_ | 0) < (c[oa >> 2] | 0))
            }
            oa = c[fa >> 2] | 0;
            _ = c[ha >> 2] | 0;
            c: do {
                if ((oa - _ | 0) > 0) {
                    qa = c[k >> 2] | 0;
                    q = f + 376156 | 0;
                    ma = f + 376152 | 0;
                    pa = 0;
                    na = oa;
                    e = _;
                    d: while (1) {
                        do {
                            if ((c[qa + (pa >>> 5 << 2) >> 2] & 1 << (pa & 31) | 0) == 0) {
                                l = c[ma >> 2] | 0;
                                if ((c[q >> 2] | 0) - l >> 2 >>> 0 > pa >>> 0) { ra = c[l + (pa << 2) >> 2] | 0 } else { ra = 0 }
                                l = c[p >> 2] | 0;
                                if ((ra | 0) == (l | 0)) {
                                    sa = na;
                                    ta = e;
                                    break
                                }
                                da = ra + 104 | 0;
                                if (!((c[da >> 2] | 0) >>> 0 > (c[l >> 2] | 0) >>> 0)) {
                                    sa = na;
                                    ta = e;
                                    break
                                }
                                if ((c[ra + 96 >> 2] | 0) == 0) {
                                    sa = na;
                                    ta = e;
                                    break
                                }
                                W = c[ra >> 2] | 0;
                                ka = c[n >> 2] | 0;
                                Z = c[o >> 2] | 0;
                                do {
                                    if (ka >>> 0 < Z >>> 0) {
                                        if ((ka | 0) != 0) { c[ka >> 2] = W }
                                        c[n >> 2] = ka + 4;
                                        ua = l;
                                        va = na;
                                        wa = e
                                    } else {
                                        Y = c[m >> 2] | 0;
                                        la = Y;
                                        ja = ka - la | 0;
                                        ca = ja >> 2;
                                        ea = ca + 1 | 0;
                                        if (ea >>> 0 > 1073741823 >>> 0) { break d }
                                        ia = Z - la | 0;
                                        if (ia >> 2 >>> 0 < 536870911 >>> 0) {
                                            la = ia >> 1;
                                            ia = la >>> 0 < ea >>> 0 ? ea : la;
                                            if ((ia | 0) == 0) {
                                                xa = 0;
                                                ya = 0
                                            } else {
                                                za = ia;
                                                V = 136
                                            }
                                        } else {
                                            za = 1073741823;
                                            V = 136
                                        }
                                        if ((V | 0) == 136) {
                                            V = 0;
                                            xa = Nu(za << 2) | 0;
                                            ya = za
                                        }
                                        ia = xa + (ca << 2) | 0;
                                        if ((ia | 0) != 0) { c[ia >> 2] = W }
                                        ia = Y;
                                        cv(xa | 0, ia | 0, ja) | 0;
                                        c[m >> 2] = xa;
                                        c[n >> 2] = xa + (ea << 2);
                                        c[o >> 2] = xa + (ya << 2);
                                        if ((Y | 0) == 0) {
                                            ua = l;
                                            va = na;
                                            wa = e;
                                            break
                                        }
                                        Pu(ia);
                                        ua = c[p >> 2] | 0;
                                        va = c[fa >> 2] | 0;
                                        wa = c[ha >> 2] | 0
                                    }
                                } while (0);
                                c[da >> 2] = c[ua >> 2];
                                sa = va;
                                ta = wa
                            } else {
                                sa = na;
                                ta = e
                            }
                        } while (0);
                        l = pa + 1 | 0;
                        if ((l | 0) < (sa - ta >> 2 | 0)) {
                            pa = l;
                            na = sa;
                            e = ta
                        } else { break c }
                    }
                    Nr(0)
                }
            } while (0);
            ta = g + 1344 | 0;
            if ((ta | 0) != (j | 0)) { tf(ta, c[m >> 2] | 0, c[n >> 2] | 0) }
            ta = c[k >> 2] | 0;
            if ((ta | 0) != 0) { Pu(ta) }
            ta = c[m >> 2] | 0;
            if ((ta | 0) == 0) { i = h; return }
            m = c[n >> 2] | 0;
            if ((m | 0) != (ta | 0)) { c[n >> 2] = m + (~((m - 4 + (-ta | 0) | 0) >>> 2) << 2) }
            Pu(ta);
            i = h;
            return
        }

        function gf(b, e, f) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            b = i;
            i = i + 480 | 0;
            g = b | 0;
            h = b + 192 | 0;
            j = b + 384 | 0;
            k = c[f + 912 >> 2] | 0;
            l = f + 328 | 0;
            m = c[l >> 2] | 0;
            n = (m | 0) > (k | 0) ? m : k;
            dv(j | 0, 0, 96) | 0;
            o = e + 376548 | 0;
            p = e + 376552 | 0;
            q = e + 376560 | 0;
            r = (k | 0) > (m | 0) ? k : m;
            s = e + 376888 | 0;
            t = e + 376952 | 0;
            u = e + 377080 | 0;
            v = 0;
            while (1) {
                if ((v | 0) >= (n | 0)) { w = 13; break }
                x = c[o >> 2] | 0;
                if ((x | 0) > 0) {
                    y = (x | 0) > 1 ? -x | 0 : -1;
                    x = v - r | 0;
                    z = y >>> 0 > x >>> 0 ? y : x;
                    cv(g + (v << 2) | 0, s | 0, z * -4 | 0) | 0;
                    A = v - z | 0
                } else { A = v }
                z = c[p >> 2] | 0;
                if ((z | 0) > 0 & (A | 0) < (n | 0)) {
                    x = (z | 0) > 1 ? -z | 0 : -1;
                    z = A - r | 0;
                    y = x >>> 0 > z >>> 0 ? x : z;
                    cv(g + (A << 2) | 0, t | 0, y * -4 | 0) | 0;
                    B = A - y | 0
                } else { B = A }
                y = c[q >> 2] | 0;
                if ((y | 0) > 0 & (B | 0) < (n | 0)) {
                    z = (y | 0) > 1 ? -y | 0 : -1;
                    y = B - r | 0;
                    x = z >>> 0 > y >>> 0 ? z : y;
                    cv(g + (B << 2) | 0, u | 0, x * -4 | 0) | 0;
                    dv(j + B | 0, 1, -x | 0) | 0;
                    C = B - x | 0
                } else { C = B }
                if ((C | 0) == 0) { w = 10; break } else { v = C }
            }
            a: do {
                if ((w | 0) == 10) {
                    C = e + 84 | 0;
                    v = c[C >> 2] | 0;
                    if ((v | 0) == 20) {
                        c[e + 80 >> 2] = 1001;
                        D = 0;
                        break
                    } else {
                        c[C >> 2] = v + 1;
                        c[e + 4 + (v << 2) >> 2] = 1016;
                        D = 0;
                        break
                    }
                } else if ((w | 0) == 13) {
                    if ((m | 0) >= 17) { ec(1672, 14344, 1781, 17560); return 0 }
                    if ((m | 0) > 0) {
                        v = f + 336 | 0;
                        C = e + 376156 | 0;
                        B = e + 376152 | 0;
                        r = 0;
                        while (1) {
                            if ((a[v] | 0) == 0) { E = r } else { E = d[f + 338 + r | 0] | 0 }
                            n = f + 916 + (r << 2) | 0;
                            c[n >> 2] = c[g + (E << 2) >> 2];
                            a[f + 1300 + r | 0] = a[j + E | 0] | 0;
                            A = c[n >> 2] | 0;
                            n = c[B >> 2] | 0;
                            if (!((c[C >> 2] | 0) - n >> 2 >>> 0 > A >>> 0)) { D = 0; break a }
                            x = c[n + (A << 2) >> 2] | 0;
                            if ((x | 0) == 0) { D = 0; break a }
                            c[f + 1044 + (r << 2) >> 2] = c[x + 92 >> 2];
                            c[f + 1172 + (r << 2) >> 2] = c[x + 96 >> 2];
                            x = r + 1 | 0;
                            A = c[l >> 2] | 0;
                            if ((x | 0) < (A | 0)) { r = x } else { F = A; break }
                        }
                    } else { F = m }
                    if ((c[f + 20 >> 2] | 0) != 0) { D = 1; break }
                    r = f + 332 | 0;
                    C = c[r >> 2] | 0;
                    B = (C | 0) > (k | 0) ? C : k;
                    v = (k | 0) > (C | 0) ? k : C;
                    A = 0;
                    while (1) {
                        if ((A | 0) >= (B | 0)) { break }
                        x = c[p >> 2] | 0;
                        if ((x | 0) > 0) {
                            n = (x | 0) > 1 ? -x | 0 : -1;
                            x = A - v | 0;
                            y = n >>> 0 > x >>> 0 ? n : x;
                            cv(h + (A << 2) | 0, t | 0, y * -4 | 0) | 0;
                            G = A - y | 0
                        } else { G = A }
                        y = c[o >> 2] | 0;
                        if ((y | 0) > 0 & (G | 0) < (B | 0)) {
                            x = (y | 0) > 1 ? -y | 0 : -1;
                            y = G - v | 0;
                            n = x >>> 0 > y >>> 0 ? x : y;
                            cv(h + (G << 2) | 0, s | 0, n * -4 | 0) | 0;
                            H = G - n | 0
                        } else { H = G }
                        n = c[q >> 2] | 0;
                        if ((n | 0) > 0 & (H | 0) < (B | 0)) {
                            y = (n | 0) > 1 ? -n | 0 : -1;
                            n = H - v | 0;
                            x = y >>> 0 > n >>> 0 ? y : n;
                            cv(h + (H << 2) | 0, u | 0, x * -4 | 0) | 0;
                            dv(j + 48 + H | 0, 1, -x | 0) | 0;
                            I = H - x | 0
                        } else { I = H }
                        if ((I | 0) == 0) { w = 32; break } else { A = I }
                    }
                    if ((w | 0) == 32) {
                        A = e + 84 | 0;
                        v = c[A >> 2] | 0;
                        if ((v | 0) == 20) {
                            c[e + 80 >> 2] = 1001;
                            D = 0;
                            break
                        } else {
                            c[A >> 2] = v + 1;
                            c[e + 4 + (v << 2) >> 2] = 1016;
                            D = 0;
                            break
                        }
                    }
                    if ((F | 0) > 16) {
                        v = e + 84 | 0;
                        A = c[v >> 2] | 0;
                        if ((A | 0) == 20) {
                            c[e + 80 >> 2] = 1001;
                            D = 0;
                            break
                        } else {
                            c[v >> 2] = A + 1;
                            c[e + 4 + (A << 2) >> 2] = 1012;
                            D = 0;
                            break
                        }
                    }
                    if ((C | 0) >= 17) { ec(976, 14344, 1834, 17560); return 0 }
                    if ((C | 0) <= 0) { D = 1; break }
                    A = f + 337 | 0;
                    v = e + 376156 | 0;
                    B = e + 376152 | 0;
                    x = 0;
                    while (1) {
                        if ((a[A] | 0) == 0) { J = x } else { J = d[f + 354 + x | 0] | 0 }
                        n = f + 980 + (x << 2) | 0;
                        c[n >> 2] = c[h + (J << 2) >> 2];
                        a[f + 1316 + x | 0] = a[j + 48 + J | 0] | 0;
                        y = c[n >> 2] | 0;
                        n = c[B >> 2] | 0;
                        if (!((c[v >> 2] | 0) - n >> 2 >>> 0 > y >>> 0)) { D = 0; break a }
                        z = c[n + (y << 2) >> 2] | 0;
                        if ((z | 0) == 0) { D = 0; break a }
                        c[f + 1108 + (x << 2) >> 2] = c[z + 92 >> 2];
                        c[f + 1236 + (x << 2) >> 2] = c[z + 96 >> 2];
                        z = x + 1 | 0;
                        if ((z | 0) < (c[r >> 2] | 0)) { x = z } else { D = 1; break }
                    }
                }
            } while (0);
            i = b;
            return D | 0
        }

        function hf(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            d = c[b + 375388 >> 2] | 0;
            e = (d | 0) == 0;
            do {
                if (e) {
                    f = c[b + 375384 >> 2] | 0;
                    if ((f | 0) == 0) { g = 6; break }
                    g = (c[f + 8 >> 2] | 0) - 1 | 0
                } else { g = (a[d + 2 | 0] | 0) - 1 | 0 }
            } while (0);
            do {
                if ((a[b + 376112 | 0] | 0) != (g | 0)) {
                    do {
                        if (e) {
                            f = c[b + 375384 >> 2] | 0;
                            if ((f | 0) == 0) { h = 6; break }
                            i = c[f + 8 >> 2] | 0;
                            j = 10
                        } else {
                            i = a[d + 2 | 0] | 0;
                            j = 10
                        }
                    } while (0);
                    if ((j | 0) == 10) { if ((i | 0) > 0) { h = i - 1 | 0 } else { break } }
                    f = h + 1 | 0;
                    k = b + 375892 | 0;
                    l = h;
                    while (1) {
                        m = l * 100 | 0;
                        n = (m | 0) / (f | 0) | 0;
                        o = (m + 100 | 0) / (f | 0) | 0;
                        if ((n | 0) > (o | 0)) { p = l } else {
                            m = o - n | 0;
                            q = l;
                            r = n;
                            while (1) {
                                s = c[k >> 2] | 0;
                                t = (q | 0) > (s | 0);
                                u = t ? s : q;
                                a[b + 375912 + (r << 1) | 0] = u;
                                a[b + 375912 + (r << 1) + 1 | 0] = t ? 100 : (((r - n | 0) * 100 | 0 | 0) / (m | 0) | 0) & 255;
                                if ((r | 0) < (o | 0)) {
                                    q = u;
                                    r = r + 1 | 0
                                } else { p = u; break }
                            }
                        }
                        c[b + 376116 + (p << 2) >> 2] = o;
                        if ((p | 0) > 0) { l = p - 1 | 0 } else { break }
                    }
                }
            } while (0);
            p = c[b + 375896 >> 2] | 0;
            h = a[b + 375912 + (p << 1) | 0] | 0;
            c[b + 375900 >> 2] = h;
            c[b + 375904 >> 2] = a[b + 375912 + (p << 1) + 1 | 0] | 0;
            c[b + 375908 >> 2] = h;
            return
        }

        function jf(b) {
            b = b | 0;
            var d = 0,
                e = 0;
            d = c[b + 375388 >> 2] | 0;
            if ((d | 0) != 0) { e = (a[d + 2 | 0] | 0) - 1 | 0; return e | 0 }
            d = c[b + 375384 >> 2] | 0;
            if ((d | 0) == 0) { e = 6; return e | 0 }
            e = (c[d + 8 >> 2] | 0) - 1 | 0;
            return e | 0
        }

        function kf(a, b) {
            a = a | 0;
            b = b | 0;
            c[a + 375892 >> 2] = b;
            hf(a);
            return
        }

        function lf(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            e = c[b + 375388 >> 2] | 0;
            if ((e | 0) == 0) {
                f = b + 375896 | 0;
                g = c[f >> 2] | 0;
                return g | 0
            }
            h = (a[e + 2 | 0] | 0) - 1 | 0;
            if (!((d + 1 | 0) >>> 0 < 3 >>> 0)) { ec(16816, 14344, 2161, 17712); return 0 }
            e = b + 375900 | 0;
            i = (c[e >> 2] | 0) + d | 0;
            d = (i | 0) < 0 ? 0 : i;
            i = (h | 0) < (d | 0) ? h : d;
            c[e >> 2] = i;
            e = b + 375896 | 0;
            c[e >> 2] = c[b + 376116 + (i << 2) >> 2];
            hf(b);
            f = e;
            g = c[f >> 2] | 0;
            return g | 0
        }

        function mf(a, b) {
            a = a | 0;
            b = b | 0;
            c[a + 375896 >> 2] = b;
            hf(a);
            return
        }

        function nf(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0;
            b = a + 80 | 0;
            d = c[b >> 2] | 0;
            if ((d | 0) == 0) { e = 0; return e | 0 }
            f = c[a >> 2] | 0;
            g = d - 1 | 0;
            c[b >> 2] = g;
            fv(a | 0, a + 4 | 0, g << 2 | 0) | 0;
            e = f;
            return e | 0
        }

        function of(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0;
            d = c[a + 376152 >> 2] | 0;
            if (!((c[a + 376156 >> 2] | 0) - d >> 2 >>> 0 > b >>> 0)) { e = 0; return e | 0 }
            e = c[d + (b << 2) >> 2] | 0;
            return e | 0
        }

        function pf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if (!((b | 0) > -1)) { d = 0; return d | 0 }
            d = ((c[a + 376156 >> 2] | 0) - (c[a + 376152 >> 2] | 0) >> 2 | 0) > (b | 0);
            return d | 0
        }

        function qf(a) { a = a | 0; return }

        function rf(a) {
            a = a | 0;
            Pu(a);
            return
        }

        function sf(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            f = b | 0;
            c[f >> 2] = 0;
            g = b + 4 | 0;
            c[g >> 2] = 0;
            h = b + 8 | 0;
            c[h >> 2] = 0;
            if ((d | 0) == 0) { return }
            if ((d | 0) < 0) { Nr(0) }
            b = ((d - 1 | 0) >>> 5) + 1 | 0;
            i = Nu(b << 2) | 0;
            j = i;
            c[f >> 2] = j;
            c[h >> 2] = b;
            b = (a[e] | 0) == 0;
            c[g >> 2] = d;
            g = d >>> 5;
            e = g << 2;
            if (b) {
                dv(i | 0, 0, e | 0) | 0;
                b = g << 5;
                if ((b | 0) == (d | 0)) { return }
                h = j + (g << 2) | 0;
                c[h >> 2] = c[h >> 2] & ~(-1 >>> ((32 - d + b | 0) >>> 0));
                return
            } else {
                dv(i | 0, -1 | 0, e | 0) | 0;
                e = g << 5;
                if ((e | 0) == (d | 0)) { return }
                i = j + (g << 2) | 0;
                c[i >> 2] = c[i >> 2] | -1 >>> ((32 - d + e | 0) >>> 0);
                return
            }
        }

        function tf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            e = b;
            f = d - e >> 2;
            g = a + 8 | 0;
            h = c[g >> 2] | 0;
            i = a | 0;
            j = c[i >> 2] | 0;
            k = j;
            if (!(f >>> 0 > h - k >> 2 >>> 0)) {
                l = a + 4 | 0;
                m = (c[l >> 2] | 0) - k | 0;
                n = m >> 2;
                if (!(f >>> 0 > n >>> 0)) {
                    o = d - e | 0;
                    fv(j | 0, b | 0, o | 0) | 0;
                    p = j + (o >> 2 << 2) | 0;
                    o = c[l >> 2] | 0;
                    if ((o | 0) == (p | 0)) { return }
                    c[l >> 2] = o + (~((o - 4 + (-p | 0) | 0) >>> 2) << 2);
                    return
                }
                p = b + (n << 2) | 0;
                fv(j | 0, b | 0, m | 0) | 0;
                if ((p | 0) == (d | 0)) { return }
                m = c[l >> 2] | 0;
                n = (d - 4 + (-p | 0) | 0) >>> 2;
                o = p;
                p = m;
                while (1) {
                    if ((p | 0) != 0) { c[p >> 2] = c[o >> 2] }
                    q = o + 4 | 0;
                    if ((q | 0) == (d | 0)) { break } else {
                        o = q;
                        p = p + 4 | 0
                    }
                }
                c[l >> 2] = m + (n + 1 << 2);
                return
            }
            if ((j | 0) == 0) { r = h } else {
                h = a + 4 | 0;
                n = c[h >> 2] | 0;
                if ((n | 0) != (j | 0)) { c[h >> 2] = n + (~((n - 4 + (-k | 0) | 0) >>> 2) << 2) }
                Pu(j);
                c[g >> 2] = 0;
                c[h >> 2] = 0;
                c[i >> 2] = 0;
                r = 0
            }
            if (f >>> 0 > 1073741823 >>> 0) { Nr(0) }
            h = r;
            do {
                if (h >> 2 >>> 0 < 536870911 >>> 0) {
                    r = h >> 1;
                    j = r >>> 0 < f >>> 0 ? f : r;
                    if (!(j >>> 0 > 1073741823 >>> 0)) { s = j; break }
                    Nr(0)
                } else { s = 1073741823 }
            } while (0);
            f = Nu(s << 2) | 0;
            h = a + 4 | 0;
            c[h >> 2] = f;
            c[i >> 2] = f;
            c[g >> 2] = f + (s << 2);
            if ((b | 0) == (d | 0)) { return }
            s = (d - 4 + (-e | 0) | 0) >>> 2;
            e = b;
            b = f;
            while (1) {
                if ((b | 0) != 0) { c[b >> 2] = c[e >> 2] }
                g = e + 4 | 0;
                if ((g | 0) == (d | 0)) { break } else {
                    e = g;
                    b = b + 4 | 0
                }
            }
            c[h >> 2] = f + (s + 1 << 2);
            return
        }

        function uf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            d = a + 8 | 0;
            e = a + 4 | 0;
            f = c[e >> 2] | 0;
            g = c[d >> 2] | 0;
            h = f;
            if (!(g - h >> 3 >>> 0 < b >>> 0)) {
                i = b;
                j = f;
                do {
                    if ((j | 0) == 0) { k = 0 } else {
                        Cd(j);
                        k = c[e >> 2] | 0
                    }
                    j = k + 8 | 0;
                    c[e >> 2] = j;
                    i = i - 1 | 0;
                } while ((i | 0) != 0);
                return
            }
            i = a | 0;
            a = c[i >> 2] | 0;
            j = h - a >> 3;
            h = j + b | 0;
            if (h >>> 0 > 536870911 >>> 0) { Nr(0) }
            k = g - a | 0;
            if (k >> 3 >>> 0 < 268435455 >>> 0) {
                a = k >> 2;
                k = a >>> 0 < h >>> 0 ? h : a;
                if ((k | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = k;
                    o = 9
                }
            } else {
                n = 536870911;
                o = 9
            }
            if ((o | 0) == 9) {
                l = Nu(n << 3) | 0;
                m = n
            }
            n = l + (j << 3) | 0;
            j = l + (m << 3) | 0;
            m = b;
            b = n;
            do {
                if ((b | 0) == 0) { p = 0 } else {
                    Cd(b);
                    p = b
                }
                b = p + 8 | 0;
                m = m - 1 | 0;
            } while ((m | 0) != 0);
            m = c[i >> 2] | 0;
            p = c[e >> 2] | 0;
            do {
                if ((p | 0) == (m | 0)) {
                    c[i >> 2] = n;
                    c[e >> 2] = b;
                    c[d >> 2] = j;
                    q = m
                } else {
                    l = p;
                    o = n;
                    do {
                        o = o - 8 | 0;
                        l = l - 8 | 0;
                        Dd(o, l);
                    } while ((l | 0) != (m | 0));
                    l = c[i >> 2] | 0;
                    k = c[e >> 2] | 0;
                    c[i >> 2] = o;
                    c[e >> 2] = b;
                    c[d >> 2] = j;
                    if ((k | 0) == (l | 0)) { q = l; break } else { r = k }
                    while (1) {
                        k = r - 8 | 0;
                        Ed(k);
                        if ((k | 0) == (l | 0)) { q = l; break } else { r = k }
                    }
                }
            } while (0);
            if ((q | 0) == 0) { return }
            Pu(q);
            return
        }

        function vf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = h >> 2;
            j = i + 1 | 0;
            if (j >>> 0 > 1073741823 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = (c[k >> 2] | 0) - g | 0;
            if (a >> 2 >>> 0 < 536870911 >>> 0) {
                g = a >> 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 1073741823;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n << 2) | 0;
                m = n
            }
            n = l + (i << 2) | 0;
            if ((n | 0) != 0) { c[n >> 2] = c[b >> 2] }
            b = f;
            cv(l | 0, b | 0, h) | 0;
            c[e >> 2] = l;
            c[d >> 2] = l + (j << 2);
            c[k >> 2] = l + (m << 2);
            if ((f | 0) == 0) { return }
            Pu(b);
            return
        }

        function wf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = h >> 2;
            j = i + 1 | 0;
            if (j >>> 0 > 1073741823 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = (c[k >> 2] | 0) - g | 0;
            if (a >> 2 >>> 0 < 536870911 >>> 0) {
                g = a >> 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 1073741823;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n << 2) | 0;
                m = n
            }
            n = l + (i << 2) | 0;
            if ((n | 0) != 0) { c[n >> 2] = c[b >> 2] }
            b = f;
            cv(l | 0, b | 0, h) | 0;
            c[e >> 2] = l;
            c[d >> 2] = l + (j << 2);
            c[k >> 2] = l + (m << 2);
            if ((f | 0) == 0) { return }
            Pu(b);
            return
        }

        function xf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = (h | 0) / 80 | 0;
            j = i + 1 | 0;
            if (j >>> 0 > 53687091 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = ((c[k >> 2] | 0) - g | 0) / 80 | 0;
            if (a >>> 0 < 26843545 >>> 0) {
                g = a << 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 53687091;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n * 80 | 0) | 0;
                m = n
            }
            n = l + (i * 80 | 0) | 0;
            if ((n | 0) != 0) { cv(n | 0, b | 0, 80) | 0 }
            b = l + ((((h | 0) / -80 | 0) + i | 0) * 80 | 0) | 0;
            i = f;
            cv(b | 0, i | 0, h) | 0;
            c[e >> 2] = b;
            c[d >> 2] = l + (j * 80 | 0);
            c[k >> 2] = l + (m * 80 | 0);
            if ((f | 0) == 0) { return }
            Pu(i);
            return
        }

        function yf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = h >> 2;
            j = i + 1 | 0;
            if (j >>> 0 > 1073741823 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = (c[k >> 2] | 0) - g | 0;
            if (a >> 2 >>> 0 < 536870911 >>> 0) {
                g = a >> 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 1073741823;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n << 2) | 0;
                m = n
            }
            n = l + (i << 2) | 0;
            if ((n | 0) != 0) { c[n >> 2] = c[b >> 2] }
            b = f;
            cv(l | 0, b | 0, h) | 0;
            c[e >> 2] = l;
            c[d >> 2] = l + (j << 2);
            c[k >> 2] = l + (m << 2);
            if ((f | 0) == 0) { return }
            Pu(b);
            return
        }

        function zf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            e = b;
            f = (d - e | 0) / 100 | 0;
            g = a + 8 | 0;
            h = c[g >> 2] | 0;
            i = a | 0;
            j = c[i >> 2] | 0;
            k = j;
            if (!(f >>> 0 > ((h - k | 0) / 100 | 0) >>> 0)) {
                l = a + 4 | 0;
                m = (c[l >> 2] | 0) - k | 0;
                n = (m | 0) / 100 | 0;
                if (!(f >>> 0 > n >>> 0)) {
                    o = d - e | 0;
                    fv(j | 0, b | 0, o | 0) | 0;
                    e = j + (((o | 0) / 100 | 0) * 100 | 0) | 0;
                    o = c[l >> 2] | 0;
                    if ((o | 0) == (e | 0)) { return }
                    c[l >> 2] = o + (~(((o - 100 + (-e | 0) | 0) >>> 0) / 100 | 0) * 100 | 0);
                    return
                }
                e = b + (n * 100 | 0) | 0;
                fv(j | 0, b | 0, m | 0) | 0;
                if ((e | 0) == (d | 0)) { return }
                m = e;
                e = c[l >> 2] | 0;
                do {
                    if ((e | 0) == 0) { p = 0 } else {
                        cv(e | 0, m | 0, 100) | 0;
                        p = c[l >> 2] | 0
                    }
                    e = p + 100 | 0;
                    c[l >> 2] = e;
                    m = m + 100 | 0;
                } while ((m | 0) != (d | 0));
                return
            }
            if ((j | 0) == 0) { q = h } else {
                h = a + 4 | 0;
                m = c[h >> 2] | 0;
                if ((m | 0) != (j | 0)) { c[h >> 2] = m + (~(((m - 100 + (-k | 0) | 0) >>> 0) / 100 | 0) * 100 | 0) }
                Pu(j);
                c[g >> 2] = 0;
                c[h >> 2] = 0;
                c[i >> 2] = 0;
                q = 0
            }
            if (f >>> 0 > 42949672 >>> 0) { Nr(0) }
            h = (q | 0) / 100 | 0;
            do {
                if (h >>> 0 < 21474836 >>> 0) {
                    q = h << 1;
                    j = q >>> 0 < f >>> 0 ? f : q;
                    if (!(j >>> 0 > 42949672 >>> 0)) { r = j; break }
                    Nr(0)
                } else { r = 42949672 }
            } while (0);
            f = Nu(r * 100 | 0) | 0;
            h = a + 4 | 0;
            c[h >> 2] = f;
            c[i >> 2] = f;
            c[g >> 2] = f + (r * 100 | 0);
            if ((b | 0) == (d | 0)) { return } else {
                s = b;
                t = f
            }
            do {
                if ((t | 0) == 0) { u = 0 } else {
                    cv(t | 0, s | 0, 100) | 0;
                    u = c[h >> 2] | 0
                }
                t = u + 100 | 0;
                c[h >> 2] = t;
                s = s + 100 | 0;
            } while ((s | 0) != (d | 0));
            return
        }

        function Af(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            f = e - d | 0;
            g = b + 8 | 0;
            h = c[g >> 2] | 0;
            i = b | 0;
            j = c[i >> 2] | 0;
            k = j;
            if (!(f >>> 0 > (h - k | 0) >>> 0)) {
                l = b + 4 | 0;
                m = (c[l >> 2] | 0) - k | 0;
                if (!(f >>> 0 > m >>> 0)) {
                    fv(j | 0, d | 0, f | 0) | 0;
                    k = j + f | 0;
                    if ((c[l >> 2] | 0) == (k | 0)) { return }
                    c[l >> 2] = k;
                    return
                }
                k = d + m | 0;
                fv(j | 0, d | 0, m | 0) | 0;
                if ((k | 0) == (e | 0)) { return }
                m = k;
                k = c[l >> 2] | 0;
                do {
                    if ((k | 0) == 0) { n = 0 } else {
                        a[k] = a[m] | 0;
                        n = c[l >> 2] | 0
                    }
                    k = n + 1 | 0;
                    c[l >> 2] = k;
                    m = m + 1 | 0;
                } while ((m | 0) != (e | 0));
                return
            }
            if ((j | 0) == 0) { o = h } else {
                h = b + 4 | 0;
                if ((c[h >> 2] | 0) != (j | 0)) { c[h >> 2] = j }
                Pu(j);
                c[g >> 2] = 0;
                c[h >> 2] = 0;
                c[i >> 2] = 0;
                o = 0
            }
            if ((f | 0) < 0) { Nr(0) }
            do {
                if (o >>> 0 < 1073741823 >>> 0) {
                    h = o << 1;
                    j = h >>> 0 < f >>> 0 ? f : h;
                    if ((j | 0) >= 0) { p = j; break }
                    Nr(0)
                } else { p = 2147483647 }
            } while (0);
            f = Nu(p) | 0;
            o = b + 4 | 0;
            c[o >> 2] = f;
            c[i >> 2] = f;
            c[g >> 2] = f + p;
            if ((d | 0) == (e | 0)) { return } else {
                q = d;
                r = f
            }
            do {
                if ((r | 0) == 0) { s = 0 } else {
                    a[r] = a[q] | 0;
                    s = c[o >> 2] | 0
                }
                r = s + 1 | 0;
                c[o >> 2] = r;
                q = q + 1 | 0;
            } while ((q | 0) != (e | 0));
            return
        }

        function Bf(a, d, e) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            f = d;
            g = e - f | 0;
            h = g >> 1;
            i = a + 8 | 0;
            j = c[i >> 2] | 0;
            k = a | 0;
            l = c[k >> 2] | 0;
            m = l;
            if (!(h >>> 0 > j - m >> 1 >>> 0)) {
                n = a + 4 | 0;
                o = (c[n >> 2] | 0) - m | 0;
                p = o >> 1;
                if (!(h >>> 0 > p >>> 0)) {
                    q = e - f | 0;
                    fv(l | 0, d | 0, q | 0) | 0;
                    r = l + (q >> 1 << 1) | 0;
                    q = c[n >> 2] | 0;
                    if ((q | 0) == (r | 0)) { return }
                    c[n >> 2] = q + (~((q - 2 + (-r | 0) | 0) >>> 1) << 1);
                    return
                }
                r = d + (p << 1) | 0;
                fv(l | 0, d | 0, o | 0) | 0;
                if ((r | 0) == (e | 0)) { return }
                o = c[n >> 2] | 0;
                p = (e - 2 + (-r | 0) | 0) >>> 1;
                q = r;
                r = o;
                while (1) {
                    if ((r | 0) != 0) { b[r >> 1] = b[q >> 1] | 0 }
                    s = q + 2 | 0;
                    if ((s | 0) == (e | 0)) { break } else {
                        q = s;
                        r = r + 2 | 0
                    }
                }
                c[n >> 2] = o + (p + 1 << 1);
                return
            }
            if ((l | 0) == 0) { t = j } else {
                j = a + 4 | 0;
                p = c[j >> 2] | 0;
                if ((p | 0) != (l | 0)) { c[j >> 2] = p + (~((p - 2 + (-m | 0) | 0) >>> 1) << 1) }
                Pu(l);
                c[i >> 2] = 0;
                c[j >> 2] = 0;
                c[k >> 2] = 0;
                t = 0
            }
            if ((g | 0) < 0) { Nr(0) }
            g = t;
            do {
                if (g >> 1 >>> 0 < 1073741823 >>> 0) {
                    t = g >>> 0 < h >>> 0 ? h : g;
                    if ((t | 0) >= 0) { u = t; break }
                    Nr(0)
                } else { u = 2147483647 }
            } while (0);
            g = Nu(u << 1) | 0;
            h = a + 4 | 0;
            c[h >> 2] = g;
            c[k >> 2] = g;
            c[i >> 2] = g + (u << 1);
            if ((d | 0) == (e | 0)) { return }
            u = (e - 2 + (-f | 0) | 0) >>> 1;
            f = d;
            d = g;
            while (1) {
                if ((d | 0) != 0) { b[d >> 1] = b[f >> 1] | 0 }
                i = f + 2 | 0;
                if ((i | 0) == (e | 0)) { break } else {
                    f = i;
                    d = d + 2 | 0
                }
            }
            c[h >> 2] = g + (u + 1 << 1);
            return
        }

        function Cf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            e = b;
            f = (d - e | 0) / 12 | 0;
            g = a + 8 | 0;
            h = c[g >> 2] | 0;
            i = a | 0;
            j = c[i >> 2] | 0;
            k = j;
            if (f >>> 0 > ((h - k | 0) / 12 | 0) >>> 0) {
                if ((j | 0) == 0) { l = h } else {
                    h = a + 4 | 0;
                    m = c[h >> 2] | 0;
                    if ((m | 0) == (j | 0)) { n = j } else {
                        o = m;
                        while (1) {
                            m = o - 12 | 0;
                            c[h >> 2] = m;
                            p = c[m >> 2] | 0;
                            if ((p | 0) == 0) { q = m } else {
                                Pu(p);
                                q = c[h >> 2] | 0
                            }
                            if ((q | 0) == (j | 0)) { break } else { o = q }
                        }
                        n = c[i >> 2] | 0
                    }
                    Pu(n);
                    c[g >> 2] = 0;
                    c[h >> 2] = 0;
                    c[i >> 2] = 0;
                    l = 0
                }
                if (f >>> 0 > 357913941 >>> 0) { Nr(0) }
                h = (l | 0) / 12 | 0;
                do {
                    if (h >>> 0 < 178956970 >>> 0) {
                        l = h << 1;
                        n = l >>> 0 < f >>> 0 ? f : l;
                        if (!(n >>> 0 > 357913941 >>> 0)) { r = n; break }
                        Nr(0)
                    } else { r = 357913941 }
                } while (0);
                h = Nu(r * 12 | 0) | 0;
                c[a + 4 >> 2] = h;
                c[i >> 2] = h;
                c[g >> 2] = h + (r * 12 | 0);
                Df(a, b, d);
                return
            }
            r = a + 4 | 0;
            h = ((c[r >> 2] | 0) - k | 0) / 12 | 0;
            if (f >>> 0 > h >>> 0) {
                s = 1;
                t = b + (h * 12 | 0) | 0
            } else {
                s = 0;
                t = d
            }
            if ((t | 0) == (b | 0)) { u = j } else {
                h = t - 12 + (-e | 0) | 0;
                e = b;
                b = j;
                while (1) {
                    Gf(b, e) | 0;
                    f = e + 12 | 0;
                    if ((f | 0) == (t | 0)) { break } else {
                        e = f;
                        b = b + 12 | 0
                    }
                }
                u = j + ((((h >>> 0) / 12 | 0) + 1 | 0) * 12 | 0) | 0
            }
            if (s) { Df(a, t, d); return }
            d = c[r >> 2] | 0;
            if ((d | 0) == (u | 0)) { return } else { v = d }
            while (1) {
                d = v - 12 | 0;
                c[r >> 2] = d;
                t = c[d >> 2] | 0;
                if ((t | 0) == 0) { w = d } else {
                    Pu(t);
                    w = c[r >> 2] | 0
                }
                if ((w | 0) == (u | 0)) { break } else { v = w }
            }
            return
        }

        function Df(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            e = i;
            i = i + 16 | 0;
            f = e | 0;
            g = e + 8 | 0;
            if ((b | 0) == (d | 0)) { i = e; return }
            h = a + 4 | 0;
            a = f | 0;
            j = f + 4 | 0;
            k = g | 0;
            l = g + 4 | 0;
            m = b;
            b = c[h >> 2] | 0;
            a: while (1) {
                do {
                    if ((b | 0) != 0) {
                        n = b | 0;
                        c[n >> 2] = 0;
                        o = b + 4 | 0;
                        c[o >> 2] = 0;
                        p = b + 8 | 0;
                        c[p >> 2] = 0;
                        q = m + 4 | 0;
                        r = c[q >> 2] | 0;
                        if ((r | 0) == 0) { break }
                        if ((r | 0) < 0) { s = 6; break a }
                        t = ((r - 1 | 0) >>> 5) + 1 | 0;
                        r = Nu(t << 2) | 0;
                        c[n >> 2] = r;
                        c[o >> 2] = 0;
                        c[p >> 2] = t;
                        t = c[m >> 2] | 0;
                        c[a >> 2] = t;
                        c[j >> 2] = 0;
                        p = c[q >> 2] | 0;
                        c[k >> 2] = t + (p >>> 5 << 2);
                        c[l >> 2] = p & 31;
                        Ef(b, f, g)
                    }
                } while (0);
                p = (c[h >> 2] | 0) + 12 | 0;
                c[h >> 2] = p;
                t = m + 12 | 0;
                if ((t | 0) == (d | 0)) { s = 9; break } else {
                    m = t;
                    b = p
                }
            }
            if ((s | 0) == 6) { Nr(0) } else if ((s | 0) == 9) { i = e; return }
        }

        function Ef(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0;
            e = i;
            i = i + 32 | 0;
            f = b;
            b = i;
            i = i + 8 | 0;
            c[b >> 2] = c[f >> 2];
            c[b + 4 >> 2] = c[f + 4 >> 2];
            f = d;
            d = i;
            i = i + 8 | 0;
            c[d >> 2] = c[f >> 2];
            c[d + 4 >> 2] = c[f + 4 >> 2];
            f = e | 0;
            g = e + 8 | 0;
            h = e + 16 | 0;
            j = e + 24 | 0;
            k = a + 4 | 0;
            l = c[k >> 2] | 0;
            m = b;
            b = c[m >> 2] | 0;
            n = c[m + 4 >> 2] | 0;
            m = d;
            d = c[m >> 2] | 0;
            o = c[m + 4 >> 2] | 0;
            m = b;
            p = n;
            q = o;
            r = d - m << 3;
            c[k >> 2] = l - p + q + r;
            k = c[a >> 2] | 0;
            a = l >>> 5;
            s = k + (a << 2) | 0;
            t = l & 31;
            if ((p | 0) != (t | 0)) {
                c[f >> 2] = b;
                c[f + 4 >> 2] = n;
                c[g >> 2] = d;
                c[g + 4 >> 2] = o;
                c[h >> 2] = s;
                c[h + 4 >> 2] = t;
                Ff(j, f, g, h);
                u = 8;
                v = 0;
                w = 8;
                x = 0;
                y = 8;
                z = 0;
                i = e;
                return
            }
            h = m;
            m = q - p + r | 0;
            do {
                if ((m | 0) > 0) {
                    if ((p | 0) == 0) {
                        A = m;
                        B = h;
                        C = s;
                        D = 0
                    } else {
                        r = 32 - p | 0;
                        q = (m | 0) < (r | 0) ? m : r;
                        g = -1 >>> ((r - q | 0) >>> 0) & -1 << p;
                        c[s >> 2] = c[s >> 2] & ~g | c[h >> 2] & g;
                        g = q + p | 0;
                        A = m - q | 0;
                        B = h + 4 | 0;
                        C = k + ((g >>> 5) + a << 2) | 0;
                        D = g & 31
                    }
                    g = A >>> 5;
                    fv(C | 0, B | 0, g << 2 | 0) | 0;
                    q = A - (g << 5) | 0;
                    r = C + (g << 2) | 0;
                    if ((q | 0) <= 0) {
                        E = r;
                        F = D;
                        break
                    }
                    f = -1 >>> ((32 - q | 0) >>> 0);
                    c[r >> 2] = c[r >> 2] & ~f | c[B + (g << 2) >> 2] & f;
                    E = r;
                    F = q
                } else {
                    E = s;
                    F = p
                }
            } while (0);
            c[j >> 2] = E;
            c[j + 4 >> 2] = F;
            u = 8;
            v = 0;
            w = 8;
            x = 0;
            y = 8;
            z = 0;
            i = e;
            return
        }

        function Ff(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0;
            f = i;
            g = b;
            b = i;
            i = i + 8 | 0;
            c[b >> 2] = c[g >> 2];
            c[b + 4 >> 2] = c[g + 4 >> 2];
            g = d;
            d = i;
            i = i + 8 | 0;
            c[d >> 2] = c[g >> 2];
            c[d + 4 >> 2] = c[g + 4 >> 2];
            g = b | 0;
            h = c[g >> 2] | 0;
            j = c[b + 4 >> 2] | 0;
            b = (c[d + 4 >> 2] | 0) - j + ((c[d >> 2] | 0) - h << 3) | 0;
            if ((b | 0) <= 0) {
                k = e + 4 | 0;
                l = a | 0;
                m = e | 0;
                n = c[m >> 2] | 0;
                c[l >> 2] = n;
                o = a + 4 | 0;
                p = c[k >> 2] | 0;
                c[o >> 2] = p;
                i = f;
                return
            }
            if ((j | 0) == 0) {
                q = b;
                r = h;
                s = c[e + 4 >> 2] | 0
            } else {
                d = 32 - j | 0;
                t = (b | 0) < (d | 0) ? b : d;
                u = -1 >>> ((d - t | 0) >>> 0) & -1 << j & c[h >> 2];
                d = e + 4 | 0;
                v = c[d >> 2] | 0;
                w = 32 - v | 0;
                x = w >>> 0 < t >>> 0 ? w : t;
                y = e | 0;
                z = c[y >> 2] | 0;
                A = c[z >> 2] & ~(-1 >>> ((w - x | 0) >>> 0) & -1 << v);
                c[z >> 2] = A;
                v = c[d >> 2] | 0;
                if (v >>> 0 > j >>> 0) { B = u << v - j } else { B = u >>> ((j - v | 0) >>> 0) }
                c[z >> 2] = A | B;
                B = (c[d >> 2] | 0) + x | 0;
                A = z + (B >>> 5 << 2) | 0;
                c[y >> 2] = A;
                y = B & 31;
                c[d >> 2] = y;
                B = t - x | 0;
                if ((B | 0) > 0) {
                    c[A >> 2] = c[A >> 2] & ~(-1 >>> ((32 - B | 0) >>> 0)) | u >>> ((j + x | 0) >>> 0);
                    c[d >> 2] = B;
                    C = B
                } else { C = y }
                y = h + 4 | 0;
                c[g >> 2] = y;
                q = b - t | 0;
                r = y;
                s = C
            }
            C = e + 4 | 0;
            y = 32 - s | 0;
            t = -1 << s;
            if (q >>> 0 > 31 >>> 0) {
                s = ~t;
                b = e | 0;
                h = c[b >> 2] | 0;
                B = q;
                d = r;
                x = h;
                j = c[h >> 2] | 0;
                do {
                    h = c[d >> 2] | 0;
                    u = j & s;
                    c[x >> 2] = u;
                    c[x >> 2] = u | h << c[C >> 2];
                    x = x + 4 | 0;
                    j = c[x >> 2] & t | h >>> (y >>> 0);
                    c[x >> 2] = j;
                    B = B - 32 | 0;
                    d = d + 4 | 0;
                } while (B >>> 0 > 31 >>> 0);
                c[g >> 2] = d;
                c[b >> 2] = x;
                D = B;
                E = d
            } else {
                D = q;
                E = r
            }
            if ((D | 0) <= 0) {
                k = C;
                l = a | 0;
                m = e | 0;
                n = c[m >> 2] | 0;
                c[l >> 2] = n;
                o = a + 4 | 0;
                p = c[k >> 2] | 0;
                c[o >> 2] = p;
                i = f;
                return
            }
            r = c[E >> 2] & -1 >>> ((32 - D | 0) >>> 0);
            E = (y | 0) < (D | 0) ? y : D;
            q = e | 0;
            d = c[q >> 2] | 0;
            B = c[d >> 2] & ~(-1 << c[C >> 2] & -1 >>> ((y - E | 0) >>> 0));
            c[d >> 2] = B;
            c[d >> 2] = B | r << c[C >> 2];
            B = (c[C >> 2] | 0) + E | 0;
            y = d + (B >>> 5 << 2) | 0;
            c[q >> 2] = y;
            c[C >> 2] = B & 31;
            B = D - E | 0;
            if ((B | 0) <= 0) {
                k = C;
                l = a | 0;
                m = e | 0;
                n = c[m >> 2] | 0;
                c[l >> 2] = n;
                o = a + 4 | 0;
                p = c[k >> 2] | 0;
                c[o >> 2] = p;
                i = f;
                return
            }
            c[y >> 2] = c[y >> 2] & ~(-1 >>> ((32 - B | 0) >>> 0)) | r >>> (E >>> 0);
            c[C >> 2] = B;
            k = C;
            l = a | 0;
            m = e | 0;
            n = c[m >> 2] | 0;
            c[l >> 2] = n;
            o = a + 4 | 0;
            p = c[k >> 2] | 0;
            c[o >> 2] = p;
            i = f;
            return
        }

        function Gf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            if ((a | 0) == (b | 0)) { return a | 0 }
            d = b + 4 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) == 0) { f = 0 } else {
                g = a + 8 | 0;
                h = a | 0;
                i = c[h >> 2] | 0;
                do {
                    if (e >>> 0 > c[g >> 2] << 5 >>> 0) {
                        if ((i | 0) == 0) { j = e } else {
                            Pu(i);
                            c[h >> 2] = 0;
                            c[g >> 2] = 0;
                            c[a + 4 >> 2] = 0;
                            j = c[d >> 2] | 0
                        }
                        if ((j | 0) < 0) { Nr(0); return 0 } else {
                            k = ((j - 1 | 0) >>> 5) + 1 | 0;
                            l = Nu(k << 2) | 0;
                            c[h >> 2] = l;
                            c[a + 4 >> 2] = 0;
                            c[g >> 2] = k;
                            m = c[d >> 2] | 0;
                            n = l;
                            break
                        }
                    } else {
                        m = e;
                        n = i
                    }
                } while (0);
                fv(n | 0, c[b >> 2] | 0, ((m - 1 | 0) >>> 5 << 2) + 4 | 0) | 0;
                f = c[d >> 2] | 0
            }
            c[a + 4 >> 2] = f;
            return a | 0
        }

        function Hf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = h >> 2;
            j = i + 1 | 0;
            if (j >>> 0 > 1073741823 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = (c[k >> 2] | 0) - g | 0;
            if (a >> 2 >>> 0 < 536870911 >>> 0) {
                g = a >> 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 1073741823;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n << 2) | 0;
                m = n
            }
            n = l + (i << 2) | 0;
            if ((n | 0) != 0) { c[n >> 2] = c[b >> 2] }
            b = f;
            cv(l | 0, b | 0, h) | 0;
            c[e >> 2] = l;
            c[d >> 2] = l + (j << 2);
            c[k >> 2] = l + (m << 2);
            if ((f | 0) == 0) { return }
            Pu(b);
            return
        }

        function If(a) {
            a = a | 0;
            c[a + 776 >> 2] = 0;
            c[a + 780 >> 2] = 0;
            c[a + 784 >> 2] = 0;
            Cd(a + 1332 | 0);
            c[a + 1344 >> 2] = 0;
            c[a + 1348 >> 2] = 0;
            c[a + 1352 >> 2] = 0;
            Jj(a);
            return
        }

        function Jf(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            b = c[a + 640 >> 2] | 0;
            if ((b | 0) != 0) {
                d = a + 644 | 0;
                if ((c[d >> 2] | 0) != (b | 0)) { c[d >> 2] = b }
                Pu(b)
            }
            b = c[a + 628 >> 2] | 0;
            if ((b | 0) != 0) {
                d = a + 632 | 0;
                e = c[d >> 2] | 0;
                if ((e | 0) != (b | 0)) { c[d >> 2] = e + (~((e - 2 + (-b | 0) | 0) >>> 1) << 1) }
                Pu(b)
            }
            b = a + 592 | 0;
            e = c[b >> 2] | 0;
            if ((e | 0) == 0) { return }
            d = a + 596 | 0;
            a = c[d >> 2] | 0;
            if ((a | 0) == (e | 0)) { f = e } else {
                g = a;
                while (1) {
                    a = g - 12 | 0;
                    c[d >> 2] = a;
                    h = c[a >> 2] | 0;
                    if ((h | 0) == 0) { i = a } else {
                        Pu(h);
                        i = c[d >> 2] | 0
                    }
                    if ((i | 0) == (e | 0)) { break } else { g = i }
                }
                f = c[b >> 2] | 0
            }
            Pu(f);
            return
        }

        function Kf(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            b = a + 4 | 0;
            d = c[b >> 2] | 0;
            e = a + 16 | 0;
            f = c[e >> 2] | 0;
            g = d + (f >>> 10 << 2) | 0;
            h = a + 8 | 0;
            i = c[h >> 2] | 0;
            if ((i | 0) == (d | 0)) {
                j = 0;
                k = 0;
                l = a + 20 | 0
            } else {
                m = a + 20 | 0;
                a = f + (c[m >> 2] | 0) | 0;
                j = (c[d + (a >>> 10 << 2) >> 2] | 0) + ((a & 1023) << 2) | 0;
                k = (c[g >> 2] | 0) + ((f & 1023) << 2) | 0;
                l = m
            }
            m = g;
            g = k;
            a: while (1) {
                k = g;
                do {
                    if ((k | 0) == (j | 0)) { break a }
                    k = k + 4 | 0;
                } while ((k - (c[m >> 2] | 0) | 0) != 4096);
                k = m + 4 | 0;
                m = k;
                g = c[k >> 2] | 0
            }
            c[l >> 2] = 0;
            l = i - d >> 2;
            if (l >>> 0 > 2 >>> 0) {
                i = d;
                while (1) {
                    Pu(c[i >> 2] | 0);
                    d = (c[b >> 2] | 0) + 4 | 0;
                    c[b >> 2] = d;
                    g = (c[h >> 2] | 0) - d >> 2;
                    if (g >>> 0 > 2 >>> 0) { i = d } else { n = g; break }
                }
            } else { n = l }
            if ((n | 0) == 2) { c[e >> 2] = 1024; return } else if ((n | 0) == 1) { c[e >> 2] = 512; return } else { return }
        }

        function Lf(a) {
            a = a | 0;
            c[a >> 2] = 30;
            c[a + 4 >> 2] = 20;
            c[a + 8 >> 2] = 2;
            c[a + 12 >> 2] = 2;
            c[a + 16 >> 2] = 8;
            c[a + 20 >> 2] = 40;
            c[a + 24 >> 2] = 6;
            c[a + 28 >> 2] = 2;
            c[a + 32 >> 2] = 6;
            c[a + 36 >> 2] = 8;
            c[a + 40 >> 2] = 8;
            c[a + 44 >> 2] = 8;
            c[a + 48 >> 2] = 26;
            c[a + 52 >> 2] = 28;
            c[a + 56 >> 2] = 52;
            c[a + 60 >> 2] = 44;
            c[a + 64 >> 2] = 86;
            c[a + 68 >> 2] = 6;
            c[a + 72 >> 2] = 36;
            c[a + 76 >> 2] = 56;
            c[a + 80 >> 2] = 14;
            c[a + 84 >> 2] = 64;
            c[a + 88 >> 2] = 48;
            c[a + 92 >> 2] = 112;
            c[a + 96 >> 2] = 8;
            c[a + 100 >> 2] = 22;
            c[a + 104 >> 2] = 32;
            c[a + 108 >> 2] = 84;
            c[a + 112 >> 2] = 2;
            c[a + 116 >> 2] = 4;
            c[a + 120 >> 2] = 4;
            c[a + 124 >> 2] = 4;
            c[a + 128 >> 2] = 42;
            c[a + 132 >> 2] = 6;
            c[a + 136 >> 2] = 18;
            c[a + 140 >> 2] = 12;
            c[a + 144 >> 2] = 2;
            c[a + 148 >> 2] = 26;
            c[a + 152 >> 2] = 24;
            c[a + 156 >> 2] = 32;
            c[a + 160 >> 2] = 40;
            c[a + 164 >> 2] = 34;
            c[a + 168 >> 2] = 20;
            c[a + 172 >> 2] = 36;
            c[a + 176 >> 2] = 22;
            c[a + 180 >> 2] = 14;
            c[a + 184 >> 2] = 4;
            c[a + 188 >> 2] = 44;
            c[a + 204 >> 2] = 22;
            c[a + 212 >> 2] = 20;
            c[a + 208 >> 2] = 36;
            c[a + 192 >> 2] = 4;
            c[a + 200 >> 2] = 10;
            c[a + 196 >> 2] = 40;
            c[a + 216 >> 2] = 28;
            c[a + 220 >> 2] = 12;
            c[a + 224 >> 2] = 38;
            c[a + 228 >> 2] = 16;
            c[a + 232 >> 2] = 30;
            c[a + 236 >> 2] = 16;
            c[a + 240 >> 2] = 40;
            c[a + 244 >> 2] = 12;
            c[a + 248 >> 2] = 18;
            c[a + 252 >> 2] = 24;
            c[a + 256 >> 2] = 26;
            c[a + 260 >> 2] = 52;
            c[a + 284 >> 2] = 14;
            c[a + 288 >> 2] = 4;
            c[a + 296 >> 2] = 16;
            c[a + 292 >> 2] = 2;
            c[a + 300 >> 2] = 10;
            c[a + 264 >> 2] = 10;
            c[a + 268 >> 2] = 4;
            c[a + 272 >> 2] = 14;
            c[a + 276 >> 2] = 2;
            c[a + 280 >> 2] = 28;
            c[a + 304 >> 2] = 24;
            c[a + 308 >> 2] = 8;
            c[a + 312 >> 2] = 32;
            c[a + 316 >> 2] = 14;
            c[a + 320 >> 2] = 20;
            c[a + 324 >> 2] = 18;
            c[a + 328 >> 2] = 6;
            c[a + 332 >> 2] = 2;
            c[a + 336 >> 2] = 26;
            return
        }

        function Mf(b, e, f, g, h) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            if ((g | 0) <= 0) { return }
            i = (1 << h) - 1 | 0;
            h = 0;
            do {
                j = ga(h, e) | 0;
                k = ga(h, g) | 0;
                l = 0;
                do {
                    m = b + (l + j) | 0;
                    n = (d[m] | 0) + (c[f + (l + k << 2) >> 2] | 0) | 0;
                    if ((n | 0) < 0) { o = 0 } else { o = ((n | 0) > (i | 0) ? i : n) & 255 }
                    a[m] = o;
                    l = l + 1 | 0;
                } while ((l | 0) < (g | 0));
                h = h + 1 | 0;
            } while ((h | 0) < (g | 0));
            return
        }

        function Nf(a, d, f, g, h) {
            a = a | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            if ((g | 0) <= 0) { return }
            i = (1 << h) - 1 | 0;
            h = 0;
            do {
                j = ga(h, d) | 0;
                k = ga(h, g) | 0;
                l = 0;
                do {
                    m = a + (l + j << 1) | 0;
                    n = (e[m >> 1] | 0) + (c[f + (l + k << 2) >> 2] | 0) | 0;
                    if ((n | 0) < 0) { o = 0 } else { o = ((n | 0) > (i | 0) ? i : n) & 65535 }
                    b[m >> 1] = o;
                    l = l + 1 | 0;
                } while ((l | 0) < (g | 0));
                h = h + 1 | 0;
            } while ((h | 0) < (g | 0));
            return
        }

        function Of(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            ec(15968, 16560, 51, 18680)
        }

        function Pf(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            ec(15968, 16560, 68, 18648)
        }

        function Qf(a, d, e, f, g) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            h = 1 << g - 1;
            if ((e | 0) > 0) { i = 0 } else { return }
            do {
                j = ga(i, e) | 0;
                k = 0;
                do {
                    l = k + j | 0;
                    c[a + (l << 2) >> 2] = (b[d + (l << 1) >> 1] << f) + h >> g;
                    k = k + 1 | 0;
                } while ((k | 0) < (e | 0));
                i = i + 1 | 0;
            } while ((i | 0) < (e | 0));
            return
        }

        function Rf(c, e, f, g) {
            c = c | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            h = f + 5 | 0;
            i = 1 << f;
            if ((i | 0) > 0) { j = 0 } else { return }
            do {
                k = 0;
                l = 0;
                do {
                    k = ((b[e + ((l << f) + j << 1) >> 1] << h) + 2048 >> 12) + k | 0;
                    m = c + ((ga(l, g) | 0) + j) | 0;
                    n = k + (d[m] | 0) | 0;
                    if ((n | 0) < 0) { o = 0 } else { o = (n | 0) > 255 ? -1 : n & 255 }
                    a[m] = o;
                    l = l + 1 | 0;
                } while ((l | 0) < (i | 0));
                j = j + 1 | 0;
            } while ((j | 0) < (i | 0));
            return
        }

        function Sf(c, e, f, g) {
            c = c | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            h = f + 5 | 0;
            i = 1 << f;
            if ((i | 0) > 0) { j = 0 } else { return }
            do {
                k = j << f;
                l = ga(j, g) | 0;
                m = 0;
                n = 0;
                do {
                    m = ((b[e + (n + k << 1) >> 1] << h) + 2048 >> 12) + m | 0;
                    o = c + (n + l) | 0;
                    p = m + (d[o] | 0) | 0;
                    if ((p | 0) < 0) { q = 0 } else { q = (p | 0) > 255 ? -1 : p & 255 }
                    a[o] = q;
                    n = n + 1 | 0;
                } while ((n | 0) < (i | 0));
                j = j + 1 | 0;
            } while ((j | 0) < (i | 0));
            return
        }

        function Tf(a, d, e) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0;
            if ((e | 0) > 0) { f = 0 } else { return }
            do {
                g = 0;
                h = 0;
                do {
                    i = (ga(h, e) | 0) + f | 0;
                    g = (b[d + (i << 1) >> 1] | 0) + g | 0;
                    c[a + (i << 2) >> 2] = g;
                    h = h + 1 | 0;
                } while ((h | 0) < (e | 0));
                f = f + 1 | 0;
            } while ((f | 0) < (e | 0));
            return
        }

        function Uf(a, d, e) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            if ((e | 0) > 0) { f = 0 } else { return }
            do {
                g = ga(f, e) | 0;
                h = 0;
                i = 0;
                do {
                    j = i + g | 0;
                    h = (b[d + (j << 1) >> 1] | 0) + h | 0;
                    c[a + (j << 2) >> 2] = h;
                    i = i + 1 | 0;
                } while ((i | 0) < (e | 0));
                f = f + 1 | 0;
            } while ((f | 0) < (e | 0));
            return
        }

        function Vf(a, d, e, f, g) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            h = 1 << g - 1;
            if ((e | 0) > 0) { i = 0 } else { return }
            do {
                j = 0;
                k = 0;
                do {
                    l = (ga(k, e) | 0) + i | 0;
                    j = ((b[d + (l << 1) >> 1] << f) + h >> g) + j | 0;
                    c[a + (l << 2) >> 2] = j;
                    k = k + 1 | 0;
                } while ((k | 0) < (e | 0));
                i = i + 1 | 0;
            } while ((i | 0) < (e | 0));
            return
        }

        function Wf(a, d, e, f, g) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            h = 1 << g - 1;
            if ((e | 0) > 0) { i = 0 } else { return }
            do {
                j = ga(i, e) | 0;
                k = 0;
                l = 0;
                do {
                    m = l + j | 0;
                    k = ((b[d + (m << 1) >> 1] << f) + h >> g) + k | 0;
                    c[a + (m << 2) >> 2] = k;
                    l = l + 1 | 0;
                } while ((l | 0) < (e | 0));
                i = i + 1 | 0;
            } while ((i | 0) < (e | 0));
            return
        }

        function Xf(a, d, e) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0;
            if ((e | 0) > 0) { f = 0 } else { return }
            do {
                g = ga(f, e) | 0;
                h = 0;
                do {
                    i = h + g | 0;
                    c[a + (i << 2) >> 2] = b[d + (i << 1) >> 1] | 0;
                    h = h + 1 | 0;
                } while ((h | 0) < (e | 0));
                f = f + 1 | 0;
            } while ((f | 0) < (e | 0));
            return
        }

        function Yf(a, c) {
            a = a | 0;
            c = c | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            d = (c | 0) / 2 | 0;
            if ((c | 0) <= 1) { return }
            e = c - 1 | 0;
            f = 0;
            do {
                g = ga(f, c) | 0;
                h = e + (ga(e - f | 0, c) | 0) | 0;
                i = 0;
                do {
                    j = a + (i + g << 1) | 0;
                    k = a + (h - i << 1) | 0;
                    l = b[j >> 1] | 0;
                    b[j >> 1] = b[k >> 1] | 0;
                    b[k >> 1] = l;
                    i = i + 1 | 0;
                } while ((i | 0) < (c | 0));
                f = f + 1 | 0;
            } while ((f | 0) < (d | 0));
            return
        }

        function Zf(c, e, f) {
            c = c | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            g = i;
            i = i + 32 | 0;
            h = g | 0;
            j = 0;
            while (1) {
                k = b[e + (j << 1) >> 1] | 0;
                l = 0;
                do {
                    m = ga(k << 16 >> 16, a[27256 + l | 0] | 0) | 0;
                    n = (ga(b[e + (j + 4 << 1) >> 1] | 0, a[27260 + l | 0] | 0) | 0) + m | 0;
                    m = (ga(b[e + (j + 8 << 1) >> 1] | 0, a[27264 + l | 0] | 0) | 0) + n | 0;
                    n = (ga(b[e + (j + 12 << 1) >> 1] | 0, a[27268 + l | 0] | 0) | 0) + m + 64 >> 7;
                    if ((n | 0) < -32768) { o = -32768 } else { o = (n | 0) > 32767 ? 32767 : n & 65535 }
                    b[h + (l << 3) + (j << 1) >> 1] = o;
                    l = l + 1 | 0;
                } while ((l | 0) < 4);
                l = j + 1 | 0;
                if ((l | 0) < 4) { j = l } else { p = 0; break }
            }
            do {
                j = ga(p, f) | 0;
                o = b[h + (p << 3) >> 1] | 0;
                e = b[h + (p << 3) + 2 >> 1] | 0;
                l = b[h + (p << 3) + 4 >> 1] | 0;
                k = b[h + (p << 3) + 6 >> 1] | 0;
                n = 0;
                do {
                    m = ga(o << 16 >> 16, a[27256 + n | 0] | 0) | 0;
                    q = (ga(e << 16 >> 16, a[27260 + n | 0] | 0) | 0) + m | 0;
                    m = (ga(l << 16 >> 16, a[27264 + n | 0] | 0) | 0) + q | 0;
                    q = (ga(k << 16 >> 16, a[27268 + n | 0] | 0) | 0) + m + 2048 >> 12;
                    if ((q | 0) < -32768) { r = -32768 } else { r = (q | 0) > 32767 ? 32767 : q }
                    q = c + (n + j) | 0;
                    m = (d[q] | 0) + r | 0;
                    if ((m | 0) < 0) { s = 0 } else { s = (m | 0) > 255 ? -1 : m & 255 }
                    a[q] = s;
                    n = n + 1 | 0;
                } while ((n | 0) < 4);
                p = p + 1 | 0;
            } while ((p | 0) < 4);
            i = g;
            return
        }

        function _f(c, d, f, g) {
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            h = i;
            i = i + 32 | 0;
            j = h | 0;
            k = 20 - g | 0;
            l = k - 1 | 0;
            m = 0;
            do {
                n = b[d + (m << 1) >> 1] | 0;
                o = 0;
                do {
                    p = ga(n << 16 >> 16, a[27256 + o | 0] | 0) | 0;
                    q = (ga(b[d + (m + 4 << 1) >> 1] | 0, a[27260 + o | 0] | 0) | 0) + p | 0;
                    p = (ga(b[d + (m + 8 << 1) >> 1] | 0, a[27264 + o | 0] | 0) | 0) + q | 0;
                    q = (ga(b[d + (m + 12 << 1) >> 1] | 0, a[27268 + o | 0] | 0) | 0) + p + 64 >> 7;
                    if ((q | 0) < -32768) { r = -32768 } else { r = (q | 0) > 32767 ? 32767 : q & 65535 }
                    b[j + (o << 3) + (m << 1) >> 1] = r;
                    o = o + 1 | 0;
                } while ((o | 0) < 4);
                m = m + 1 | 0;
            } while ((m | 0) < 4);
            m = 1 << l;
            l = (1 << g) - 1 | 0;
            g = 0;
            do {
                r = ga(g, f) | 0;
                d = b[j + (g << 3) >> 1] | 0;
                o = b[j + (g << 3) + 2 >> 1] | 0;
                n = b[j + (g << 3) + 4 >> 1] | 0;
                q = b[j + (g << 3) + 6 >> 1] | 0;
                p = 0;
                do {
                    s = ga(d << 16 >> 16, a[27256 + p | 0] | 0) | 0;
                    t = (ga(o << 16 >> 16, a[27260 + p | 0] | 0) | 0) + s | 0;
                    s = (ga(n << 16 >> 16, a[27264 + p | 0] | 0) | 0) + t | 0;
                    t = (ga(q << 16 >> 16, a[27268 + p | 0] | 0) | 0) + s + m >> k;
                    if ((t | 0) < -32768) { u = -32768 } else { u = (t | 0) > 32767 ? 32767 : t }
                    t = c + (p + r << 1) | 0;
                    s = (e[t >> 1] | 0) + u | 0;
                    if ((s | 0) < 0) { v = 0 } else { v = ((s | 0) > (l | 0) ? l : s) & 65535 }
                    b[t >> 1] = v;
                    p = p + 1 | 0;
                } while ((p | 0) < 4);
                g = g + 1 | 0;
            } while ((g | 0) < 4);
            i = h;
            return
        }

        function $f(c, d, e) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            f = i;
            i = i + 32 | 0;
            g = f | 0;
            h = 0;
            while (1) {
                j = b[d + (h << 1) >> 1] | 0;
                k = 0;
                do {
                    l = ga(j << 16 >> 16, a[27256 + (k << 2) | 0] | 0) | 0;
                    m = (ga(b[d + (h + e << 1) >> 1] | 0, a[27257 + (k << 2) | 0] | 0) | 0) + l | 0;
                    l = (ga(b[d + ((e << 1) + h << 1) >> 1] | 0, a[27258 + (k << 2) | 0] | 0) | 0) + m | 0;
                    m = (ga(b[d + ((e * 3 | 0) + h << 1) >> 1] | 0, a[27259 + (k << 2) | 0] | 0) | 0) + l + 1 >> 1;
                    if ((m | 0) < -32768) { n = -32768 } else { n = (m | 0) > 32767 ? 32767 : m & 65535 }
                    b[g + ((k << 2) + h << 1) >> 1] = n;
                    k = k + 1 | 0;
                } while ((k | 0) < 4);
                k = h + 1 | 0;
                if ((k | 0) < 4) { h = k } else { o = 0; break }
            }
            do {
                h = o << 2;
                n = b[g + (h << 1) >> 1] | 0;
                e = 0;
                do {
                    d = ga(n << 16 >> 16, a[27256 + (e << 2) | 0] | 0) | 0;
                    k = (ga(b[g + ((h | 1) << 1) >> 1] | 0, a[27257 + (e << 2) | 0] | 0) | 0) + d | 0;
                    d = (ga(b[g + ((h | 2) << 1) >> 1] | 0, a[27258 + (e << 2) | 0] | 0) | 0) + k | 0;
                    k = ((ga(b[g + ((h | 3) << 1) >> 1] | 0, a[27259 + (e << 2) | 0] | 0) | 0) + d + 128 | 0) >>> 8 & 65535;
                    b[c + (e + h << 1) >> 1] = k;
                    e = e + 1 | 0;
                } while ((e | 0) < 4);
                o = o + 1 | 0;
            } while ((o | 0) < 4);
            i = f;
            return
        }

        function ag(d, e, f, g) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            h = i;
            i = i + 32 | 0;
            j = h | 0;
            k = f - 1 | 0;
            l = 1 << g;
            g = l - 1 | 0;
            m = -l | 0;
            l = m & 65535;
            n = 0;
            do {
                o = b[e + (n << 1) >> 1] | 0;
                p = 0;
                do {
                    q = ga(o << 16 >> 16, a[27256 + p | 0] | 0) | 0;
                    r = (ga(b[e + (n + 4 << 1) >> 1] | 0, a[27260 + p | 0] | 0) | 0) + q | 0;
                    q = (ga(b[e + (n + 8 << 1) >> 1] | 0, a[27264 + p | 0] | 0) | 0) + r | 0;
                    r = (ga(b[e + (n + 12 << 1) >> 1] | 0, a[27268 + p | 0] | 0) | 0) + q + 64 >> 7;
                    if ((r | 0) < (m | 0)) { s = l } else { s = ((r | 0) > (g | 0) ? g : r) & 65535 }
                    b[j + (p << 3) + (n << 1) >> 1] = s;
                    p = p + 1 | 0;
                } while ((p | 0) < 4);
                n = n + 1 | 0;
            } while ((n | 0) < 4);
            n = 1 << k;
            k = 0;
            do {
                s = k << 2;
                g = b[j + (k << 3) >> 1] | 0;
                l = b[j + (k << 3) + 2 >> 1] | 0;
                m = b[j + (k << 3) + 4 >> 1] | 0;
                e = b[j + (k << 3) + 6 >> 1] | 0;
                p = 0;
                do {
                    o = ga(g << 16 >> 16, a[27256 + p | 0] | 0) | 0;
                    r = (ga(l << 16 >> 16, a[27260 + p | 0] | 0) | 0) + o | 0;
                    o = (ga(m << 16 >> 16, a[27264 + p | 0] | 0) | 0) + r | 0;
                    r = (ga(e << 16 >> 16, a[27268 + p | 0] | 0) | 0) + o + n >> f;
                    c[d + (p + s << 2) >> 2] = r;
                    p = p + 1 | 0;
                } while ((p | 0) < 4);
                k = k + 1 | 0;
            } while ((k | 0) < 4);
            i = h;
            return
        }

        function bg(d, e, f, g, h) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0;
            j = i;
            i = i + 2048 | 0;
            k = j | 0;
            if ((e | 0) > 1) {
                l = e;
                m = 0;
                while (1) {
                    n = m + 1 | 0;
                    o = l >> 1;
                    if ((o | 0) > 1) {
                        l = o;
                        m = n
                    } else { p = n; break }
                }
            } else { p = 0 }
            m = 5 - p | 0;
            p = 1 << g - 1;
            l = 1 << h;
            h = l - 1 | 0;
            n = -l | 0;
            l = (e | 0) > 0;
            if (!l) {
                q = 2048;
                r = 0;
                i = j;
                return
            }
            o = n & 65535;
            s = 0;
            do {
                t = e;
                while (1) {
                    u = t - 1 | 0;
                    if ((t | 0) <= 0) { break }
                    v = f + ((ga(u, e) | 0) + s << 1) | 0;
                    if ((b[v >> 1] | 0) == 0) { t = u } else { break }
                }
                v = (t | 0) < 1;
                w = 0;
                do {
                    if (v) { x = 0 } else {
                        y = 0;
                        z = 0;
                        while (1) {
                            A = f + ((ga(z, e) | 0) + s << 1) | 0;
                            B = (ga(b[A >> 1] | 0, a[27616 + (z << m << 5) + w | 0] | 0) | 0) + y | 0;
                            if ((z | 0) < (u | 0)) {
                                y = B;
                                z = z + 1 | 0
                            } else { break }
                        }
                        x = B + 64 >> 7
                    }
                    if ((x | 0) < (n | 0)) { C = o } else { C = ((x | 0) > (h | 0) ? h : x) & 65535 }
                    z = k + ((ga(w, e) | 0) + s << 1) | 0;
                    b[z >> 1] = C;
                    w = w + 1 | 0;
                } while ((w | 0) < (e | 0));
                s = s + 1 | 0;
            } while ((s | 0) < (e | 0));
            if (l) { D = 0 } else {
                q = 2048;
                r = 0;
                i = j;
                return
            }
            do {
                l = ga(D, e) | 0;
                s = e;
                while (1) { E = s - 1 | 0; if ((s | 0) <= 0) { break } if ((b[k + (E + l << 1) >> 1] | 0) == 0) { s = E } else { break } }
                C = (s | 0) < 1;
                x = 0;
                do {
                    if (C) { F = 0 } else {
                        h = 0;
                        o = 0;
                        while (1) {
                            n = (ga(b[k + (o + l << 1) >> 1] | 0, a[27616 + (o << m << 5) + x | 0] | 0) | 0) + h | 0;
                            if ((o | 0) < (E | 0)) {
                                h = n;
                                o = o + 1 | 0
                            } else { F = n; break }
                        }
                    }
                    c[d + (x + l << 2) >> 2] = F + p >> g;
                    x = x + 1 | 0;
                } while ((x | 0) < (e | 0));
                D = D + 1 | 0;
            } while ((D | 0) < (e | 0));
            q = 2048;
            r = 0;
            i = j;
            return
        }

        function cg(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            bg(a, 4, b, c, d);
            return
        }

        function dg(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            bg(a, 8, b, c, d);
            return
        }

        function eg(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            bg(a, 16, b, c, d);
            return
        }

        function fg(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            bg(a, 32, b, c, d);
            return
        }

        function gg(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            hg(a, c, 4, b, 8);
            return
        }

        function hg(c, e, f, g, h) {
            c = c | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0;
            j = i;
            i = i + 2048 | 0;
            k = j | 0;
            l = 20 - h | 0;
            m = 1 << l - 1;
            if ((f | 0) > 1) {
                n = f;
                o = 0;
                while (1) {
                    p = o + 1 | 0;
                    q = n >> 1;
                    if ((q | 0) > 1) {
                        n = q;
                        o = p
                    } else { r = p; break }
                }
            } else { r = 0 }
            o = 5 - r | 0;
            r = (f | 0) > 0;
            if (r) { s = 0 } else {
                t = 2048;
                u = 0;
                i = j;
                return
            }
            do {
                n = f;
                while (1) {
                    v = n - 1 | 0;
                    if ((n | 0) <= 0) { break }
                    p = g + ((ga(v, f) | 0) + s << 1) | 0;
                    if ((b[p >> 1] | 0) == 0) { n = v } else { break }
                }
                p = (n | 0) < 1;
                q = 0;
                do {
                    if (p) {
                        w = 0;
                        x = 13
                    } else {
                        y = 0;
                        z = 0;
                        while (1) {
                            A = g + ((ga(z, f) | 0) + s << 1) | 0;
                            B = (ga(b[A >> 1] | 0, a[27616 + (z << o << 5) + q | 0] | 0) | 0) + y | 0;
                            if ((z | 0) < (v | 0)) {
                                y = B;
                                z = z + 1 | 0
                            } else { break }
                        }
                        z = B + 64 >> 7;
                        if ((z | 0) < -32768) { C = -32768 } else {
                            w = z;
                            x = 13
                        }
                    }
                    if ((x | 0) == 13) {
                        x = 0;
                        C = (w | 0) > 32767 ? 32767 : w & 65535
                    }
                    z = k + ((ga(q, f) | 0) + s << 1) | 0;
                    b[z >> 1] = C;
                    q = q + 1 | 0;
                } while ((q | 0) < (f | 0));
                s = s + 1 | 0;
            } while ((s | 0) < (f | 0));
            if (!r) {
                t = 2048;
                u = 0;
                i = j;
                return
            }
            r = (1 << h) - 1 | 0;
            h = 0;
            do {
                s = ga(h, f) | 0;
                C = f;
                while (1) { D = C - 1 | 0; if ((C | 0) <= 0) { break } if ((b[k + (D + s << 1) >> 1] | 0) == 0) { C = D } else { break } }
                w = (C | 0) < 1;
                x = ga(h, e) | 0;
                B = 0;
                do {
                    if (w) { E = 0 } else {
                        v = 0;
                        g = 0;
                        while (1) {
                            q = (ga(b[k + (g + s << 1) >> 1] | 0, a[27616 + (g << o << 5) + B | 0] | 0) | 0) + v | 0;
                            if ((g | 0) < (D | 0)) {
                                v = q;
                                g = g + 1 | 0
                            } else { E = q; break }
                        }
                    }
                    g = c + (B + x) | 0;
                    v = (d[g] | 0) + (E + m >> l) | 0;
                    if ((v | 0) < 0) { F = 0 } else { F = ((v | 0) > (r | 0) ? r : v) & 255 }
                    a[g] = F;
                    B = B + 1 | 0;
                } while ((B | 0) < (f | 0));
                h = h + 1 | 0;
            } while ((h | 0) < (f | 0));
            t = 2048;
            u = 0;
            i = j;
            return
        }

        function ig(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            hg(a, c, 8, b, 8);
            return
        }

        function jg(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            hg(a, c, 16, b, 8);
            return
        }

        function kg(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            hg(a, c, 32, b, 8);
            return
        }

        function lg(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            mg(a, c, 4, b, d);
            return
        }



        function kk(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            f = (nd(e, 4) | 0) & 255;
            a[b + 1 | 0] = f;
            f = (nd(e, 3) | 0) + 1 & 255;
            g = b + 2 | 0;
            a[g] = f;
            if (f << 24 >> 24 > 7) { h = 8; return h | 0 }
            f = (nd(e, 1) | 0) & 255;
            a[b + 3 | 0] = f;
            $k(b + 4 | 0, e, a[g] | 0);
            f = qd(e) | 0;
            if ((f | 0) == -99999) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            }
            c[b + 472 >> 2] = f;
            if ((f | 0) > 15) { h = 8; return h | 0 }
            f = qd(e) | 0;
            if ((f | 0) == -99999) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            }
            i = b + 476 | 0;
            c[i >> 2] = f;
            do {
                if ((f | 0) == 3) {
                    j = (nd(e, 1) | 0) & 255;
                    a[b + 480 | 0] = j;
                    if (j << 24 >> 24 == 0) { k = 11; break }
                    c[b + 5012 >> 2] = 0;
                    l = c[i >> 2] | 0
                } else {
                    a[b + 480 | 0] = 0;
                    k = 11
                }
            } while (0);
            if ((k | 0) == 11) {
                f = c[i >> 2] | 0;
                c[b + 5012 >> 2] = f;
                l = f
            }
            if (l >>> 0 > 3 >>> 0) {
                Ue(d, 1019, 0);
                h = 8;
                return h | 0
            }
            l = qd(e) | 0;
            if ((l | 0) == -99999) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            }
            f = b + 484 | 0;
            c[f >> 2] = l;
            l = qd(e) | 0;
            if ((l | 0) == -99999) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            }
            c[b + 488 >> 2] = l;
            i = c[f >> 2] | 0;
            if ((i | 0) == 0 | (l | 0) == 0) { h = 8; return h | 0 }
            if ((i | 0) > 7e4 | (l | 0) > 7e4) { h = 8; return h | 0 }
            l = (nd(e, 1) | 0) & 255;
            a[b + 492 | 0] = l;
            do {
                if (l << 24 >> 24 == 0) { dv(b + 496 | 0, 0, 16) | 0 } else {
                    i = qd(e) | 0;
                    if ((i | 0) == -99999) {
                        Ue(d, 8, 0);
                        h = 8;
                        return h | 0
                    }
                    c[b + 496 >> 2] = i;
                    i = qd(e) | 0;
                    if ((i | 0) == -99999) {
                        Ue(d, 8, 0);
                        h = 8;
                        return h | 0
                    }
                    c[b + 500 >> 2] = i;
                    i = qd(e) | 0;
                    if ((i | 0) == -99999) {
                        Ue(d, 8, 0);
                        h = 8;
                        return h | 0
                    }
                    c[b + 504 >> 2] = i;
                    i = qd(e) | 0;
                    if (!((i | 0) == -99999)) { c[b + 508 >> 2] = i; break }
                    Ue(d, 8, 0);
                    h = 8;
                    return h | 0
                }
            } while (0);
            l = qd(e) | 0;
            if ((l | 0) == -99999) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            }
            c[b + 512 >> 2] = l + 8;
            l = qd(e) | 0;
            if ((l | 0) == -99999) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            }
            c[b + 516 >> 2] = l + 8;
            l = qd(e) | 0;
            if ((l | 0) == -99999) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            }
            i = l + 4 | 0;
            l = b + 520 | 0;
            c[l >> 2] = i;
            c[b + 5032 >> 2] = 1 << i;
            i = (nd(e, 1) | 0) & 255;
            f = b + 524 | 0;
            a[f] = i;
            if (i << 24 >> 24 == 0) {
                i = a[g] | 0;
                m = (i << 24 >> 24) - 1 | 0;
                n = i
            } else {
                o = 0;
                k = 39
            }
            while (1) {
                if ((k | 0) == 39) {
                    k = 0;
                    m = o;
                    n = a[g] | 0
                }
                p = (n << 24 >> 24) - 1 | 0;
                if ((m | 0) > (p | 0)) { k = 48; break }
                i = qd(e) | 0;
                if ((i | 0) == -99999 | (i | 0) > 15) { k = 42; break }
                c[b + 528 + (m << 2) >> 2] = i + 1;
                i = qd(e) | 0;
                if ((i | 0) == -99999) { k = 44; break }
                j = b + 556 + (m << 2) | 0;
                c[j >> 2] = i;
                i = qd(e) | 0;
                if ((i | 0) == -99999) { k = 46; break }
                c[b + 584 + (m << 2) >> 2] = i;
                c[b + 5128 + (m << 2) >> 2] = i - 1 + (c[j >> 2] | 0);
                o = m + 1 | 0;
                k = 39
            }
            if ((k | 0) == 42) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            } else if ((k | 0) == 44) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            } else if ((k | 0) == 46) {
                Ue(d, 8, 0);
                h = 8;
                return h | 0
            } else if ((k | 0) == 48) {
                do {
                    if ((a[f] | 0) != 0) {
                        if (!(n << 24 >> 24 < 8)) { ec(2792, 14480, 317, 17480); return 0 }
                        if ((p | 0) <= 0) { break }
                        k = b + 528 + (p << 2) | 0;
                        m = b + 556 + (p << 2) | 0;
                        o = b + 584 + (p << 2) | 0;
                        j = 0;
                        do {
                            c[b + 528 + (j << 2) >> 2] = c[k >> 2];
                            c[b + 556 + (j << 2) >> 2] = c[m >> 2];
                            c[b + 584 + (j << 2) >> 2] = c[o >> 2];
                            j = j + 1 | 0;
                        } while ((j | 0) < ((a[g] | 0) - 1 | 0))
                    }
                } while (0);
                g = qd(e) | 0;
                if ((g | 0) == -99999) {
                    Ue(d, 8, 0);
                    h = 8;
                    return h | 0
                }
                p = b + 612 | 0;
                c[p >> 2] = g + 3;
                g = qd(e) | 0;
                if ((g | 0) == -99999) {
                    Ue(d, 8, 0);
                    h = 8;
                    return h | 0
                }
                n = b + 616 | 0;
                c[n >> 2] = g;
                g = qd(e) | 0;
                if ((g | 0) == -99999) {
                    Ue(d, 8, 0);
                    h = 8;
                    return h | 0
                }
                f = b + 620 | 0;
                c[f >> 2] = g + 2;
                g = qd(e) | 0;
                if ((g | 0) == -99999) {
                    Ue(d, 8, 0);
                    h = 8;
                    return h | 0
                }
                j = b + 624 | 0;
                c[j >> 2] = g;
                g = qd(e) | 0;
                if ((g | 0) == -99999) {
                    Ue(d, 8, 0);
                    h = 8;
                    return h | 0
                }
                c[b + 628 >> 2] = g;
                g = qd(e) | 0;
                if ((g | 0) == -99999) {
                    Ue(d, 8, 0);
                    h = 8;
                    return h | 0
                }
                c[b + 632 >> 2] = g;
                g = c[p >> 2] | 0;
                if ((g | 0) > 6) { h = 8; return h | 0 }
                if (((c[n >> 2] | 0) + g | 0) > 6) { h = 8; return h | 0 }
                g = c[f >> 2] | 0;
                if ((g | 0) > 5) { h = 8; return h | 0 }
                if (((c[j >> 2] | 0) + g | 0) > 5) { h = 8; return h | 0 }
                g = (nd(e, 1) | 0) & 255;
                a[b + 636 | 0] = g;
                do {
                    if (!(g << 24 >> 24 == 0)) {
                        j = (nd(e, 1) | 0) & 255;
                        a[b + 637 | 0] = j;
                        f = b + 638 | 0;
                        if (j << 24 >> 24 == 0) { mk(f); break }
                        j = lk(e, 0, f, 0) | 0;
                        if ((j | 0) == 0) { break } else { h = j }
                        return h | 0
                    }
                } while (0);
                g = (nd(e, 1) | 0) & 255;
                a[b + 4702 | 0] = g;
                g = (nd(e, 1) | 0) & 255;
                a[b + 4703 | 0] = g;
                g = (nd(e, 1) | 0) & 255;
                a[b + 4704 | 0] = g;
                do {
                    if (g << 24 >> 24 == 0) {
                        a[b + 4705 | 0] = 0;
                        a[b + 4706 | 0] = 0;
                        c[b + 4708 >> 2] = 0;
                        c[b + 4712 >> 2] = 0;
                        a[b + 4716 | 0] = 0
                    } else {
                        j = (nd(e, 4) | 0) + 1 & 255;
                        a[b + 4705 | 0] = j;
                        j = (nd(e, 4) | 0) + 1 & 255;
                        a[b + 4706 | 0] = j;
                        j = qd(e) | 0;
                        if ((j | 0) == -99999) {
                            Ue(d, 8, 0);
                            h = 8;
                            return h | 0
                        }
                        c[b + 4708 >> 2] = j + 3;
                        j = qd(e) | 0;
                        if (!((j | 0) == -99999)) {
                            c[b + 4712 >> 2] = j;
                            j = (nd(e, 1) | 0) & 255;
                            a[b + 4716 | 0] = j;
                            break
                        }
                        Ue(d, 8, 0);
                        h = 8;
                        return h | 0
                    }
                } while (0);
                g = qd(e) | 0;
                if ((g | 0) == -99999) {
                    Ue(d, 8, 0);
                    h = 8;
                    return h | 0
                }
                if (g >>> 0 > 64 >>> 0) {
                    Ue(d, 1014, 0);
                    h = 8;
                    return h | 0
                }
                j = b + 4720 | 0;
                f = b + 4724 | 0;
                n = c[f >> 2] | 0;
                p = j | 0;
                o = c[p >> 2] | 0;
                m = (n - o | 0) / 100 | 0;
                do {
                    if (m >>> 0 < g >>> 0) { sk(j, g - m | 0) } else {
                        if (!(m >>> 0 > g >>> 0)) { break }
                        k = o + (g * 100 | 0) | 0;
                        if ((n | 0) == (k | 0)) { break }
                        c[f >> 2] = n + (~(((n - 100 + (-k | 0) | 0) >>> 0) / 100 | 0) * 100 | 0)
                    }
                } while (0);
                a: do { if ((g | 0) > 0) { n = 0; while (1) { f = n + 1 | 0; if (!(sj(d, b, e, (c[p >> 2] | 0) + (n * 100 | 0) | 0, n, j, 0) | 0)) { h = 1005; break } if ((f | 0) < (g | 0)) { n = f } else { break a } } return h | 0 } } while (0);
                g = (nd(e, 1) | 0) & 255;
                a[b + 4732 | 0] = g;
                do {
                    if (g << 24 >> 24 == 0) { c[b + 4736 >> 2] = 0 } else {
                        j = qd(e) | 0;
                        if ((j | 0) == -99999) {
                            Ue(d, 8, 0);
                            h = 8;
                            return h | 0
                        }
                        p = b + 4736 | 0;
                        c[p >> 2] = j;
                        if ((j | 0) > 32) { h = 8; return h | 0 }
                        if ((j | 0) > 0) { q = 0 } else { break }
                        do {
                            j = nd(e, c[l >> 2] | 0) | 0;
                            c[b + 4740 + (q << 2) >> 2] = j;
                            j = (nd(e, 1) | 0) & 255;
                            a[b + 4868 + q | 0] = j;
                            q = q + 1 | 0;
                        } while ((q | 0) < (c[p >> 2] | 0))
                    }
                } while (0);
                q = (nd(e, 1) | 0) & 255;
                a[b + 4900 | 0] = q;
                q = (nd(e, 1) | 0) & 255;
                a[b + 4901 | 0] = q;
                q = (nd(e, 1) | 0) & 255;
                a[b + 4902 | 0] = q;
                if (!(q << 24 >> 24 == 0)) { ll(b + 4904 | 0, d, e, b) | 0 }
                d = (nd(e, 1) | 0) & 255;
                a[b + 4980 | 0] = d;
                do {
                    if (d << 24 >> 24 == 0) { a[b + 4981 | 0] = 0 } else {
                        q = (nd(e, 1) | 0) & 255;
                        l = b + 4981 | 0;
                        a[l] = q;
                        q = (nd(e, 1) | 0) & 255;
                        a[b + 4982 | 0] = q;
                        q = (nd(e, 6) | 0) & 255;
                        a[b + 4983 | 0] = q;
                        if ((a[l] | 0) == 0) { break }
                        nk(b + 4984 | 0, 0, e) | 0
                    }
                } while (0);
                e = ok(b) | 0;
                if ((e | 0) != 0) { h = e; return h | 0 }
                a[b | 0] = 1;
                h = 0;
                return h | 0
            }
            return 0
        }

        function lk(b, e, f, g) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0;
            g = i;
            i = i + 6240 | 0;
            e = g | 0;
            h = g + 96 | 0;
            j = 0;
            a: while (1) {
                k = (j | 0) == 3;
                l = k ? 2 : 6;
                m = (j | 0) == 0;
                n = k ^ 1;
                o = m ? 16 : 64;
                p = (j | 0) > 1;
                q = 0;
                do {
                    r = h + (q << 10) | 0;
                    s = k & (q | 0) == 1;
                    do {
                        if (((nd(b, 1) | 0) & 255) << 24 >> 24 == 0) {
                            t = qd(b) | 0;
                            if ((t | 0) == -99999 | (t | 0) > (q | 0)) {
                                u = 8;
                                v = 29;
                                break a
                            }
                            w = e + (j * 24 | 0) + (q << 2) | 0;
                            c[w >> 2] = 16;
                            if ((t | 0) != 0) {
                                if (!((t | 0) == 1 | n)) { v = 12; break a }
                                x = q - t | 0;
                                cv(r | 0, h + (x << 10) | 0, o) | 0;
                                t = c[e + (j * 24 | 0) + (x << 2) >> 2] | 0;
                                c[w >> 2] = t;
                                y = t & 255;
                                v = 20;
                                break
                            }
                            if (m) {
                                cv(r | 0, 30200, 16) | 0;
                                v = 21;
                                break
                            }
                            if ((q | 0) < 3 & (s ^ 1)) {
                                cv(r | 0, 30024, 64) | 0;
                                y = 16;
                                v = 20;
                                break
                            } else {
                                cv(r | 0, 30088, 64) | 0;
                                y = 16;
                                v = 20;
                                break
                            }
                        } else {
                            if (p) {
                                t = rd(b) | 0;
                                if ((t + 7 | 0) >>> 0 > 254 >>> 0) {
                                    u = 8;
                                    v = 29;
                                    break a
                                }
                                w = t + 8 | 0;
                                c[e + (j * 24 | 0) + (q << 2) >> 2] = w;
                                z = w;
                                A = w & 255
                            } else {
                                z = 8;
                                A = 16
                            }
                            w = z;
                            t = 0;
                            while (1) {
                                x = rd(b) | 0;
                                if ((x + 128 | 0) >>> 0 > 255 >>> 0) {
                                    u = 8;
                                    v = 29;
                                    break a
                                }
                                B = (w + 256 + x | 0) % 256 | 0;
                                a[h + (q << 10) + t | 0] = B;
                                x = t + 1 | 0;
                                if ((x | 0) < (o | 0)) {
                                    w = B;
                                    t = x
                                } else {
                                    y = A;
                                    v = 20;
                                    break
                                }
                            }
                        }
                    } while (0);
                    do {
                        if ((v | 0) == 20) {
                            v = 0;
                            if ((j | 0) == 2) {
                                s = f + 480 + (q << 8) | 0;
                                rk(s, r, 2);
                                a[s] = y;
                                break
                            } else if ((j | 0) == 3) {
                                s = f + 2016 + (q << 10) | 0;
                                rk(s, r, 3);
                                a[s] = y;
                                break
                            } else if ((j | 0) == 1) {
                                s = Cj(3, 0) | 0;
                                t = 0;
                                do {
                                    a[((d[s + (t << 1) + 1 | 0] | 0) << 3) + (d[s + (t << 1) | 0] | 0) + (f + 96 + (q << 6)) | 0] = a[h + (q << 10) + t | 0] | 0;
                                    t = t + 1 | 0;
                                } while ((t | 0) < 64)
                            } else if ((j | 0) == 0) { v = 21; break } else { break }
                        }
                    } while (0);
                    if ((v | 0) == 21) {
                        v = 0;
                        r = Cj(2, 0) | 0;
                        t = 0;
                        do {
                            a[((d[r + (t << 1) + 1 | 0] | 0) << 2) + (d[r + (t << 1) | 0] | 0) + (f + (q << 4)) | 0] = a[h + (q << 10) + t | 0] | 0;
                            t = t + 1 | 0;
                        } while ((t | 0) < 16)
                    }
                    q = q + 1 | 0;
                } while ((q | 0) < (l | 0));
                l = j + 1 | 0;
                if ((l | 0) < 4) { j = l } else {
                    u = 0;
                    v = 29;
                    break
                }
            }
            if ((v | 0) == 12) { ec(2912, 14480, 873, 18888); return 0 } else if ((v | 0) == 29) { i = g; return u | 0 }
            return 0
        }

        function mk(b) {
            b = b | 0;
            var c = 0,
                e = 0;
            c = Cj(2, 0) | 0;
            e = 0;
            do {
                a[b + (((d[c + (e << 1) + 1 | 0] | 0) << 2) + (d[c + (e << 1) | 0] | 0)) | 0] = a[30200 + e | 0] | 0;
                e = e + 1 | 0;
            } while ((e | 0) < 16);
            e = Cj(2, 0) | 0;
            c = 0;
            do {
                a[((d[e + (c << 1) + 1 | 0] | 0) << 2) + (d[e + (c << 1) | 0] | 0) + (b + 16) | 0] = a[30200 + c | 0] | 0;
                c = c + 1 | 0;
            } while ((c | 0) < 16);
            c = Cj(2, 0) | 0;
            e = 0;
            do {
                a[((d[c + (e << 1) + 1 | 0] | 0) << 2) + (d[c + (e << 1) | 0] | 0) + (b + 32) | 0] = a[30200 + e | 0] | 0;
                e = e + 1 | 0;
            } while ((e | 0) < 16);
            e = Cj(2, 0) | 0;
            c = 0;
            do {
                a[((d[e + (c << 1) + 1 | 0] | 0) << 2) + (d[e + (c << 1) | 0] | 0) + (b + 48) | 0] = a[30200 + c | 0] | 0;
                c = c + 1 | 0;
            } while ((c | 0) < 16);
            c = Cj(2, 0) | 0;
            e = 0;
            do {
                a[((d[c + (e << 1) + 1 | 0] | 0) << 2) + (d[c + (e << 1) | 0] | 0) + (b + 64) | 0] = a[30200 + e | 0] | 0;
                e = e + 1 | 0;
            } while ((e | 0) < 16);
            e = Cj(2, 0) | 0;
            c = 0;
            do {
                a[((d[e + (c << 1) + 1 | 0] | 0) << 2) + (d[e + (c << 1) | 0] | 0) + (b + 80) | 0] = a[30200 + c | 0] | 0;
                c = c + 1 | 0;
            } while ((c | 0) < 16);
            c = Cj(3, 0) | 0;
            e = 0;
            do {
                a[((d[c + (e << 1) + 1 | 0] | 0) << 3) + (d[c + (e << 1) | 0] | 0) + (b + 96) | 0] = a[30024 + e | 0] | 0;
                e = e + 1 | 0;
            } while ((e | 0) < 64);
            e = Cj(3, 0) | 0;
            c = 0;
            do {
                a[((d[e + (c << 1) + 1 | 0] | 0) << 3) + (d[e + (c << 1) | 0] | 0) + (b + 288) | 0] = a[30088 + c | 0] | 0;
                c = c + 1 | 0;
            } while ((c | 0) < 64);
            c = Cj(3, 0) | 0;
            e = 0;
            do {
                a[((d[c + (e << 1) + 1 | 0] | 0) << 3) + (d[c + (e << 1) | 0] | 0) + (b + 160) | 0] = a[30024 + e | 0] | 0;
                e = e + 1 | 0;
            } while ((e | 0) < 64);
            e = Cj(3, 0) | 0;
            c = 0;
            do {
                a[((d[e + (c << 1) + 1 | 0] | 0) << 3) + (d[e + (c << 1) | 0] | 0) + (b + 352) | 0] = a[30088 + c | 0] | 0;
                c = c + 1 | 0;
            } while ((c | 0) < 64);
            c = Cj(3, 0) | 0;
            e = 0;
            do {
                a[((d[c + (e << 1) + 1 | 0] | 0) << 3) + (d[c + (e << 1) | 0] | 0) + (b + 224) | 0] = a[30024 + e | 0] | 0;
                e = e + 1 | 0;
            } while ((e | 0) < 64);
            e = Cj(3, 0) | 0;
            c = 0;
            do {
                a[((d[e + (c << 1) + 1 | 0] | 0) << 3) + (d[e + (c << 1) | 0] | 0) + (b + 416) | 0] = a[30088 + c | 0] | 0;
                c = c + 1 | 0;
            } while ((c | 0) < 64);
            rk(b + 480 | 0, 30024, 2);
            rk(b + 1248 | 0, 30088, 2);
            rk(b + 736 | 0, 30024, 2);
            rk(b + 1504 | 0, 30088, 2);
            rk(b + 992 | 0, 30024, 2);
            rk(b + 1760 | 0, 30088, 2);
            rk(b + 2016 | 0, 30024, 3);
            rk(b + 3040 | 0, 30088, 3);
            return
        }

        function nk(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            c = (nd(d, 1) | 0) & 255;
            a[b | 0] = c;
            c = (nd(d, 1) | 0) & 255;
            a[b + 1 | 0] = c;
            c = (nd(d, 1) | 0) & 255;
            a[b + 2 | 0] = c;
            c = (nd(d, 1) | 0) & 255;
            a[b + 3 | 0] = c;
            c = (nd(d, 1) | 0) & 255;
            a[b + 4 | 0] = c;
            c = (nd(d, 1) | 0) & 255;
            a[b + 5 | 0] = c;
            c = (nd(d, 1) | 0) & 255;
            a[b + 6 | 0] = c;
            c = (nd(d, 1) | 0) & 255;
            a[b + 7 | 0] = c;
            c = (nd(d, 1) | 0) & 255;
            a[b + 8 | 0] = c;
            return 0
        }

        function ok(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            d = c[b + 476 >> 2] | 0;
            e = c[30720 + (d << 2) >> 2] | 0;
            c[b + 5016 >> 2] = e;
            f = c[30648 + (d << 2) >> 2] | 0;
            c[b + 5020 >> 2] = f;
            g = b + 5024 | 0;
            if ((c[b + 5012 >> 2] | 0) == 0) {
                c[g >> 2] = 1;
                c[b + 5028 >> 2] = 1
            } else {
                c[g >> 2] = e;
                c[b + 5028 >> 2] = f
            }
            g = c[b + 512 >> 2] | 0;
            c[b + 4996 >> 2] = g;
            c[b + 5e3 >> 2] = (g * 6 | 0) - 48;
            h = c[b + 516 >> 2] | 0;
            c[b + 5004 >> 2] = h;
            c[b + 5008 >> 2] = (h * 6 | 0) - 48;
            i = c[b + 612 >> 2] | 0;
            c[b + 5036 >> 2] = i;
            j = (c[b + 616 >> 2] | 0) + i | 0;
            c[b + 5040 >> 2] = j;
            k = 1 << i;
            c[b + 5044 >> 2] = k;
            l = 1 << j;
            c[b + 5048 >> 2] = l;
            m = c[b + 484 >> 2] | 0;
            n = m - 1 | 0;
            o = (n + k | 0) / (k | 0) | 0;
            c[b + 5052 >> 2] = o;
            p = (n + l | 0) / (l | 0) | 0;
            c[b + 5056 >> 2] = p;
            n = c[b + 488 >> 2] | 0;
            q = n - 1 | 0;
            r = (q + k | 0) / (k | 0) | 0;
            c[b + 5060 >> 2] = r;
            s = (q + l | 0) / (l | 0) | 0;
            c[b + 5064 >> 2] = s;
            q = ga(r, o) | 0;
            c[b + 5068 >> 2] = q;
            q = ga(s, p) | 0;
            c[b + 5072 >> 2] = q;
            q = ga(n, m) | 0;
            c[b + 5076 >> 2] = q;
            do {
                if ((d | 0) == 0) { t = 6 } else {
                    if ((a[b + 480 | 0] | 0) != 0) { t = 6; break }
                    c[b + 5080 >> 2] = (l | 0) / (e | 0) | 0;
                    c[b + 5084 >> 2] = (l | 0) / (f | 0) | 0
                }
            } while (0);
            if ((t | 0) == 6) {
                c[b + 5080 >> 2] = 0;
                c[b + 5084 >> 2] = 0
            }
            t = c[b + 620 >> 2] | 0;
            c[b + 5100 >> 2] = t;
            f = (c[b + 624 >> 2] | 0) + t | 0;
            c[b + 5104 >> 2] = f;
            l = j - t | 0;
            if ((c[b + 628 >> 2] | 0) > (l | 0)) { u = 8; return u | 0 }
            if ((c[b + 632 >> 2] | 0) > (l | 0)) { u = 8; return u | 0 }
            e = i - 1 | 0;
            c[b + 5108 >> 2] = e;
            d = j - e | 0;
            c[b + 5112 >> 2] = p << d;
            c[b + 5116 >> 2] = s << d;
            d = c[b + 4708 >> 2] | 0;
            c[b + 5120 >> 2] = d;
            c[b + 5124 >> 2] = (c[b + 4712 >> 2] | 0) + d;
            d = p << l;
            c[b + 5088 >> 2] = d;
            p = s << l;
            c[b + 5092 >> 2] = p;
            l = ga(p, d) | 0;
            c[b + 5096 >> 2] = l;
            if ((a[b + 4990 | 0] | 0) == 0) {
                a[b + 5156 | 0] = g + 248;
                a[b + 5157 | 0] = h + 248;
                c[b + 5160 >> 2] = 128;
                c[b + 5164 >> 2] = 128
            } else {
                a[b + 5156 | 0] = 0;
                a[b + 5157 | 0] = 0;
                c[b + 5160 >> 2] = 1 << g - 1;
                c[b + 5164 >> 2] = 1 << h - 1
            }
            if (((m | 0) % (k | 0) | 0 | 0) != 0) { u = 8; return u | 0 }
            if (((n | 0) % (k | 0) | 0 | 0) != 0 | (t | 0) > (i | 0)) { u = 8; return u | 0 }
            if ((f | 0) > (((j | 0) < 5 ? j : 5) | 0)) { u = 8; return u | 0 }
            if ((g - 8 | 0) >>> 0 > 8 >>> 0) { u = 8; return u | 0 }
            if ((h - 8 | 0) >>> 0 > 8 >>> 0) { u = 8; return u | 0 }
            a[b | 0] = 1;
            u = 0;
            return u | 0
        }

        function pk(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                r = 0;
            e = i;
            if ((d | 0) == 2) { f = q } else if ((d | 0) == 1) { f = t } else { i = e; return }
            g = c[f >> 2] | 0;
            Zk(g, 11960, (f = i, i = i + 1 | 0, i = i + 7 & -8, c[f >> 2] = 0, f) | 0);
            i = f;
            Zk(g, 8928, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 1 | 0] | 0, f) | 0);
            i = f;
            h = b + 2 | 0;
            Zk(g, 6288, (f = i, i = i + 8 | 0, c[f >> 2] = a[h] | 0, f) | 0);
            i = f;
            Zk(g, 4592, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 3 | 0] | 0, f) | 0);
            i = f;
            dl(b + 4 | 0, a[h] | 0, g);
            Zk(g, 3224, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 472 >> 2], f) | 0);
            i = f;
            j = b + 476 | 0;
            k = c[j >> 2] | 0;
            do {
                if ((k | 0) == 0) { l = 1072 } else {
                    if ((k | 0) == 1) { l = 384; break }
                    if ((k | 0) == 2) { l = 16872; break }
                    l = (k | 0) == 3 ? 16336 : 15976
                }
            } while (0);
            Zk(g, 1920, (f = i, i = i + 16 | 0, c[f >> 2] = k, c[f + 8 >> 2] = l, f) | 0);
            i = f;
            if ((c[j >> 2] | 0) == 3) {
                Zk(g, 15568, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 480 | 0] | 0, f) | 0);
                i = f
            }
            Zk(g, 15216, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 484 >> 2], f) | 0);
            i = f;
            Zk(g, 14880, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 488 >> 2], f) | 0);
            i = f;
            j = b + 492 | 0;
            Zk(g, 14632, (f = i, i = i + 8 | 0, c[f >> 2] = a[j] | 0, f) | 0);
            i = f;
            if ((a[j] | 0) != 0) {
                Zk(g, 14360, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 496 >> 2], f) | 0);
                i = f;
                Zk(g, 14088, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 500 >> 2], f) | 0);
                i = f;
                Zk(g, 13800, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 504 >> 2], f) | 0);
                i = f;
                Zk(g, 13600, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 508 >> 2], f) | 0);
                i = f
            }
            Zk(g, 13408, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 512 >> 2], f) | 0);
            i = f;
            Zk(g, 13200, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 516 >> 2], f) | 0);
            i = f;
            Zk(g, 12976, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 520 >> 2], f) | 0);
            i = f;
            j = b + 524 | 0;
            Zk(g, 12704, (f = i, i = i + 8 | 0, c[f >> 2] = a[j] | 0, f) | 0);
            i = f;
            l = a[h] | 0;
            if ((a[j] | 0) == 0) { m = (l << 24 >> 24) - 1 | 0 } else { m = 0 }
            if ((m | 0) <= ((l << 24 >> 24) - 1 | 0)) {
                l = m;
                while (1) {
                    Zk(g, 12408, (f = i, i = i + 8 | 0, c[f >> 2] = l, f) | 0);
                    i = f;
                    Zk(g, 12128, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 528 + (l << 2) >> 2], f) | 0);
                    i = f;
                    Zk(g, 11752, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 556 + (l << 2) >> 2], f) | 0);
                    i = f;
                    Zk(g, 11432, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 584 + (l << 2) >> 2], f) | 0);
                    i = f;
                    if ((l | 0) < ((a[h] | 0) - 1 | 0)) { l = l + 1 | 0 } else { break }
                }
            }
            l = b + 612 | 0;
            Zk(g, 11192, (f = i, i = i + 8 | 0, c[f >> 2] = c[l >> 2], f) | 0);
            i = f;
            h = b + 616 | 0;
            Zk(g, 10936, (f = i, i = i + 8 | 0, c[f >> 2] = c[h >> 2], f) | 0);
            i = f;
            m = b + 620 | 0;
            Zk(g, 10680, (f = i, i = i + 8 | 0, c[f >> 2] = c[m >> 2], f) | 0);
            i = f;
            j = b + 624 | 0;
            Zk(g, 10408, (f = i, i = i + 8 | 0, c[f >> 2] = c[j >> 2], f) | 0);
            i = f;
            Zk(g, 10096, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 628 >> 2], f) | 0);
            i = f;
            Zk(g, 9760, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 632 >> 2], f) | 0);
            i = f;
            k = b + 636 | 0;
            Zk(g, 9328, (f = i, i = i + 8 | 0, c[f >> 2] = a[k] | 0, f) | 0);
            i = f;
            do {
                if ((a[k] | 0) != 0) {
                    n = b + 637 | 0;
                    Zk(g, 9016, (f = i, i = i + 8 | 0, c[f >> 2] = a[n] | 0, f) | 0);
                    i = f;
                    if ((a[n] | 0) == 0) { break }
                    Zk(g, 8656, (f = i, i = i + 1 | 0, i = i + 7 & -8, c[f >> 2] = 0, f) | 0);
                    i = f
                }
            } while (0);
            Zk(g, 8384, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4702 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 8152, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4703 | 0] | 0, f) | 0);
            i = f;
            k = b + 4704 | 0;
            Zk(g, 7912, (f = i, i = i + 8 | 0, c[f >> 2] = a[k] | 0, f) | 0);
            i = f;
            if ((a[k] | 0) != 0) {
                Zk(g, 7640, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4705 | 0] | 0, f) | 0);
                i = f;
                Zk(g, 7352, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4706 | 0] | 0, f) | 0);
                i = f;
                Zk(g, 7040, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 4708 >> 2], f) | 0);
                i = f;
                Zk(g, 6752, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 4712 >> 2], f) | 0);
                i = f;
                Zk(g, 6456, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4716 | 0] | 0, f) | 0);
                i = f
            }
            k = b + 4724 | 0;
            n = b + 4720 | 0;
            Zk(g, 6336, (f = i, i = i + 8 | 0, c[f >> 2] = ((c[k >> 2] | 0) - (c[n >> 2] | 0) | 0) / 100 | 0, f) | 0);
            i = f;
            if ((c[k >> 2] | 0) != (c[n >> 2] | 0)) {
                o = 0;
                do {
                    Zk(g, 6216, (f = i, i = i + 8 | 0, c[f >> 2] = o, f) | 0);
                    i = f;
                    tj((c[n >> 2] | 0) + (o * 100 | 0) | 0, 16, g);
                    o = o + 1 | 0;
                } while (o >>> 0 < (((c[k >> 2] | 0) - (c[n >> 2] | 0) | 0) / 100 | 0) >>> 0)
            }
            n = b + 4732 | 0;
            Zk(g, 6e3, (f = i, i = i + 8 | 0, c[f >> 2] = a[n] | 0, f) | 0);
            i = f;
            do {
                if ((a[n] | 0) != 0) {
                    k = b + 4736 | 0;
                    Zk(g, 5816, (f = i, i = i + 8 | 0, c[f >> 2] = c[k >> 2], f) | 0);
                    i = f;
                    if ((c[k >> 2] | 0) > 0) { p = 0 } else { break }
                    do {
                        o = c[b + 4740 + (p << 2) >> 2] | 0;
                        r = a[b + 4868 + p | 0] | 0;
                        Zk(g, 5640, (f = i, i = i + 24 | 0, c[f >> 2] = p, c[f + 8 >> 2] = o, c[f + 16 >> 2] = r, f) | 0);
                        i = f;
                        p = p + 1 | 0;
                    } while ((p | 0) < (c[k >> 2] | 0))
                }
            } while (0);
            Zk(g, 5504, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4900 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 5344, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4901 | 0] | 0, f) | 0);
            i = f;
            p = b + 4902 | 0;
            Zk(g, 5176, (f = i, i = i + 8 | 0, c[f >> 2] = a[p] | 0, f) | 0);
            i = f;
            Zk(g, 4968, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4980 | 0] | 0, f) | 0);
            i = f;
            n = b + 4981 | 0;
            Zk(g, 4792, (f = i, i = i + 8 | 0, c[f >> 2] = a[n] | 0, f) | 0);
            i = f;
            Zk(g, 4672, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4982 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 4440, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4983 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 4224, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 5048 >> 2], f) | 0);
            i = f;
            Zk(g, 4072, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 5044 >> 2], f) | 0);
            i = f;
            Zk(g, 3984, (f = i, i = i + 8 | 0, c[f >> 2] = 1 << (c[h >> 2] | 0) + (c[l >> 2] | 0), f) | 0);
            i = f;
            Zk(g, 3920, (f = i, i = i + 8 | 0, c[f >> 2] = 1 << c[m >> 2], f) | 0);
            i = f;
            Zk(g, 3832, (f = i, i = i + 8 | 0, c[f >> 2] = 1 << (c[j >> 2] | 0) + (c[m >> 2] | 0), f) | 0);
            i = f;
            Zk(g, 3712, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 5056 >> 2], f) | 0);
            i = f;
            Zk(g, 3544, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 5064 >> 2], f) | 0);
            i = f;
            Zk(g, 3392, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 5016 >> 2], f) | 0);
            i = f;
            Zk(g, 3280, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 5020 >> 2], f) | 0);
            i = f;
            if ((a[n] | 0) != 0) { qk(b + 4984 | 0, d) }
            if ((a[p] | 0) == 0) { i = e; return }
            ml(b + 4904 | 0, d);
            i = e;
            return
        }

        function qk(a, b) {
            a = a | 0;
            b = b | 0;
            var e = 0,
                f = 0;
            e = i;
            if ((b | 0) == 1) { f = t } else if ((b | 0) == 2) { f = q } else { i = e; return }
            b = c[f >> 2] | 0;
            Zk(b, 2728, (f = i, i = i + 1 | 0, i = i + 7 & -8, c[f >> 2] = 0, f) | 0);
            i = f;
            Zk(b, 2632, (f = i, i = i + 8 | 0, c[f >> 2] = d[a | 0] | 0, f) | 0);
            i = f;
            Zk(b, 2536, (f = i, i = i + 8 | 0, c[f >> 2] = d[a + 1 | 0] | 0, f) | 0);
            i = f;
            Zk(b, 2376, (f = i, i = i + 8 | 0, c[f >> 2] = d[a + 2 | 0] | 0, f) | 0);
            i = f;
            Zk(b, 2224, (f = i, i = i + 8 | 0, c[f >> 2] = d[a + 3 | 0] | 0, f) | 0);
            i = f;
            Zk(b, 2072, (f = i, i = i + 8 | 0, c[f >> 2] = d[a + 4 | 0] | 0, f) | 0);
            i = f;
            Zk(b, 1984, (f = i, i = i + 8 | 0, c[f >> 2] = d[a + 5 | 0] | 0, f) | 0);
            i = f;
            Zk(b, 1808, (f = i, i = i + 8 | 0, c[f >> 2] = d[a + 6 | 0] | 0, f) | 0);
            i = f;
            Zk(b, 1576, (f = i, i = i + 8 | 0, c[f >> 2] = d[a + 7 | 0] | 0, f) | 0);
            i = f;
            Zk(b, 1456, (f = i, i = i + 8 | 0, c[f >> 2] = d[a + 8 | 0] | 0, f) | 0);
            i = f;
            i = e;
            return
        }

        function rk(b, c, e) {
            b = b | 0;
            c = c | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            if ((e | 0) == 3) {
                f = Cj(3, 0) | 0;
                g = 0;
                do {
                    h = f + (g << 1) | 0;
                    i = f + (g << 1) + 1 | 0;
                    j = c + g | 0;
                    k = 0;
                    do {
                        a[b + (((d[h] | 0) << 2) + (((d[i] | 0) << 2) + k << 5)) | 0] = a[j] | 0;
                        a[b + (((d[h] | 0) << 2 | 1) + (((d[i] | 0) << 2) + k << 5)) | 0] = a[j] | 0;
                        a[b + (((d[h] | 0) << 2 | 2) + (((d[i] | 0) << 2) + k << 5)) | 0] = a[j] | 0;
                        a[b + (((d[h] | 0) << 2 | 3) + (((d[i] | 0) << 2) + k << 5)) | 0] = a[j] | 0;
                        k = k + 1 | 0;
                    } while ((k | 0) < 4);
                    g = g + 1 | 0;
                } while ((g | 0) < 64);
                return
            } else if ((e | 0) == 1) {
                g = Cj(3, 0) | 0;
                f = 0;
                do {
                    a[b + (((d[g + (f << 1) + 1 | 0] | 0) << 3) + (d[g + (f << 1) | 0] | 0)) | 0] = a[c + f | 0] | 0;
                    f = f + 1 | 0;
                } while ((f | 0) < 64);
                return
            } else if ((e | 0) == 0) {
                f = Cj(2, 0) | 0;
                g = 0;
                do {
                    a[b + (((d[f + (g << 1) + 1 | 0] | 0) << 2) + (d[f + (g << 1) | 0] | 0)) | 0] = a[c + g | 0] | 0;
                    g = g + 1 | 0;
                } while ((g | 0) < 16);
                return
            } else if ((e | 0) == 2) {
                e = Cj(3, 0) | 0;
                g = 0;
                do {
                    f = e + (g << 1) | 0;
                    k = e + (g << 1) + 1 | 0;
                    j = c + g | 0;
                    a[b + (((d[f] | 0) << 1) + ((d[k] | 0) << 5)) | 0] = a[j] | 0;
                    a[b + (((d[f] | 0) << 1 | 1) + ((d[k] | 0) << 5)) | 0] = a[j] | 0;
                    a[b + (((d[f] | 0) << 1) + ((d[k] | 0) << 5 | 16)) | 0] = a[j] | 0;
                    a[b + (((d[f] | 0) << 1 | 1) + ((d[k] | 0) << 5 | 16)) | 0] = a[j] | 0;
                    g = g + 1 | 0;
                } while ((g | 0) < 64);
                return
            } else { ec(3136, 14480, 810, 18840) }
        }

        function sk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            d = a + 8 | 0;
            e = a + 4 | 0;
            f = c[e >> 2] | 0;
            g = c[d >> 2] | 0;
            h = f;
            if (!(((g - h | 0) / 100 | 0) >>> 0 < b >>> 0)) {
                i = b;
                j = f;
                do {
                    if ((j | 0) == 0) { k = 0 } else {
                        dv(j | 0, 0, 100) | 0;
                        k = c[e >> 2] | 0
                    }
                    j = k + 100 | 0;
                    c[e >> 2] = j;
                    i = i - 1 | 0;
                } while ((i | 0) != 0);
                return
            }
            i = a | 0;
            a = c[i >> 2] | 0;
            j = (h - a | 0) / 100 | 0;
            h = j + b | 0;
            if (h >>> 0 > 42949672 >>> 0) { Nr(0) }
            k = (g - a | 0) / 100 | 0;
            if (k >>> 0 < 21474836 >>> 0) {
                a = k << 1;
                k = a >>> 0 < h >>> 0 ? h : a;
                if ((k | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = k;
                    o = 9
                }
            } else {
                n = 42949672;
                o = 9
            }
            if ((o | 0) == 9) {
                l = Nu(n * 100 | 0) | 0;
                m = n
            }
            n = b;
            b = l + (j * 100 | 0) | 0;
            do {
                if ((b | 0) == 0) { p = 0 } else {
                    dv(b | 0, 0, 100) | 0;
                    p = b
                }
                b = p + 100 | 0;
                n = n - 1 | 0;
            } while ((n | 0) != 0);
            n = c[i >> 2] | 0;
            p = (c[e >> 2] | 0) - n | 0;
            o = l + ((((p | 0) / -100 | 0) + j | 0) * 100 | 0) | 0;
            j = n;
            cv(o | 0, j | 0, p) | 0;
            c[i >> 2] = o;
            c[e >> 2] = b;
            c[d >> 2] = l + (m * 100 | 0);
            if ((n | 0) == 0) { return }
            Pu(j);
            return
        }

        function tk(a) {
            a = a | 0;
            var b = 0;
            b;
            return
        }

        function uk(a) {
            a = a | 0;
            var b = 0;
            b;
            return
        }

        function vk(a) {
            a = a | 0;
            var b = 0;
            b;
            return
        }

        function wk(a) {
            a = a | 0;
            var b = 0;
            b;
            return
        }

        function xk(a) {
            a = a | 0;
            var b = 0;
            b;
            return
        }

        function yk(a) {
            a = a | 0;
            var b = 0;
            b;
            return
        }

        function zk(a, b) {
            a = a | 0;
            b = b | 0;
            Ob(a | 0) | 0;
            return
        }

        function Ak(a, b) {
            a = a | 0;
            b = b | 0;
            Za(a | 0, b | 0) | 0;
            return
        }

        function Bk(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            c[a >> 2] = 0;
            b;
            d;
            return
        }

        function Ck(a) {
            a = a | 0;
            var b = 0,
                c = 0;
            b;
            c;
            return
        }

        function Dk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0;
            d = a | 0;
            if ((c[d >> 2] | 0) >= (b | 0)) { return }
            e = a + 4 | 0;
            f;
            if ((c[d >> 2] | 0) < (b | 0)) {
                f = a + 28 | 0;
                do { Za(f | 0, e | 0) | 0; } while ((c[d >> 2] | 0) < (b | 0))
            }
            g;
            return
        }

        function Ek(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0;
            d;
            d = a | 0;
            if ((c[d >> 2] | 0) >= (b | 0)) { e; return }
            c[d >> 2] = b;
            Ob(a + 28 | 0) | 0;
            e;
            return
        }

        function Fk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0;
            d;
            d = a | 0;
            c[d >> 2] = (c[d >> 2] | 0) + b;
            Ob(a + 28 | 0) | 0;
            e;
            return
        }

        function Gk(a) { a = a | 0; return c[a >> 2] | 0 }

        function Hk(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            e = (d | 0) > 32;
            f = e ? 32 : d;
            d = e ? 1022 : 0;
            e = b + 156 | 0;
            c[e >> 2] = 0;
            g;
            h;
            i;
            c[b + 160 >> 2] = 0;
            i = b | 0;
            a[i] = 0;
            j;
            if ((f | 0) > 0) { k = 0 } else { l = d; return l | 0 }
            while (1) {
                if ((zc(b + 28 + (k << 2) | 0, 0, 106, i | 0) | 0) != 0) {
                    l = 10;
                    m = 4;
                    break
                }
                c[e >> 2] = (c[e >> 2] | 0) + 1;
                j = k + 1 | 0;
                if ((j | 0) < (f | 0)) { k = j } else {
                    l = d;
                    m = 4;
                    break
                }
            }
            if ((m | 0) == 4) { return l | 0 }
            return 0
        }

        function Ik(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            d = b + 420 | 0;
            e;
            if ((a[b] | 0) != 0) { f; return 0 }
            e = b + 24 | 0;
            g = b + 444 | 0;
            h = b + 8 | 0;
            i = b + 20 | 0;
            j = b + 160 | 0;
            do {
                k = c[e >> 2] | 0;
                if ((k | 0) == 0) { Za(g | 0, d | 0) | 0 } else {
                    l = c[h >> 2] | 0;
                    m = c[i >> 2] | 0;
                    n = c[(c[l + (m >>> 10 << 2) >> 2] | 0) + ((m & 1023) << 2) >> 2] | 0;
                    c[e >> 2] = k - 1;
                    k = m + 1 | 0;
                    c[i >> 2] = k;
                    if (k >>> 0 > 2047 >>> 0) {
                        Pu(c[l >> 2] | 0);
                        c[h >> 2] = (c[h >> 2] | 0) + 4;
                        c[i >> 2] = (c[i >> 2] | 0) - 1024
                    }
                    c[j >> 2] = (c[j >> 2] | 0) + 1;
                    o;
                    Dc[c[(c[n >> 2] | 0) + 8 >> 2] & 511](n);
                    p;
                    c[j >> 2] = (c[j >> 2] | 0) - 1
                }
            } while ((a[b] | 0) == 0);
            f;
            return 0
        }

        function Jk(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0;
            d;
            a[b | 0] = 1;
            e;
            Ob(b + 444 | 0) | 0;
            e = b + 156 | 0;
            if ((c[e >> 2] | 0) > 0) { f = 0 } else {
                g;
                h;
                return
            }
            do {
                vc(c[b + 28 + (f << 2) >> 2] | 0, 0) | 0;
                f = f + 1 | 0;
            } while ((f | 0) < (c[e >> 2] | 0));
            g;
            h;
            return
        }

        function Kk(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            e;
            if ((a[b | 0] | 0) != 0) { f; return }
            e = b + 12 | 0;
            g = c[e >> 2] | 0;
            h = b + 8 | 0;
            i = c[h >> 2] | 0;
            if ((g | 0) == (i | 0)) { j = 0 } else { j = (g - i << 8) - 1 | 0 }
            k = b + 20 | 0;
            l = c[k >> 2] | 0;
            m = b + 24 | 0;
            n = c[m >> 2] | 0;
            if ((j - l | 0) == (n | 0)) {
                Lk(b + 4 | 0);
                o = c[m >> 2] | 0;
                p = c[k >> 2] | 0;
                q = c[h >> 2] | 0;
                r = c[e >> 2] | 0
            } else {
                o = n;
                p = l;
                q = i;
                r = g
            }
            g = o + p | 0;
            do {
                if ((r | 0) != (q | 0)) {
                    p = (c[q + (g >>> 10 << 2) >> 2] | 0) + ((g & 1023) << 2) | 0;
                    if ((p | 0) == 0) { break }
                    c[p >> 2] = d
                }
            } while (0);
            c[m >> 2] = o + 1;
            gb(b + 444 | 0) | 0;
            f;
            return
        }

        function Lk(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0;
            b = i;
            i = i + 48 | 0;
            d = b | 0;
            e = b + 8 | 0;
            f = b + 16 | 0;
            g = b + 40 | 0;
            h = a + 16 | 0;
            j = c[h >> 2] | 0;
            if (j >>> 0 > 1023 >>> 0) {
                c[h >> 2] = j - 1024;
                j = a + 4 | 0;
                h = c[j >> 2] | 0;
                k = c[h >> 2] | 0;
                l = h + 4 | 0;
                c[j >> 2] = l;
                m = a + 8 | 0;
                n = c[m >> 2] | 0;
                o = a + 12 | 0;
                do {
                    if ((n | 0) == (c[o >> 2] | 0)) {
                        p = a | 0;
                        q = c[p >> 2] | 0;
                        if (l >>> 0 > q >>> 0) {
                            r = l;
                            s = ((r - q >> 2) + 1 | 0) / -2 | 0;
                            t = n - r | 0;
                            fv(h + (s + 1 << 2) | 0, l | 0, t | 0) | 0;
                            r = h + ((t >> 2) + 1 + s << 2) | 0;
                            c[m >> 2] = r;
                            c[j >> 2] = (c[j >> 2] | 0) + (s << 2);
                            u = r;
                            v = 13;
                            break
                        }
                        r = n - q >> 1;
                        s = (r | 0) == 0 ? 1 : r;
                        r = Nu(s << 2) | 0;
                        t = r + (s >>> 2 << 2) | 0;
                        w = r + (s << 2) | 0;
                        if ((l | 0) == (n | 0)) {
                            x = t;
                            y = q
                        } else {
                            q = l;
                            s = t;
                            do {
                                if ((s | 0) == 0) { z = 0 } else {
                                    c[s >> 2] = c[q >> 2];
                                    z = s
                                }
                                s = z + 4 | 0;
                                q = q + 4 | 0;
                            } while ((q | 0) != (n | 0));
                            x = s;
                            y = c[p >> 2] | 0
                        }
                        c[p >> 2] = r;
                        c[j >> 2] = t;
                        c[m >> 2] = x;
                        c[o >> 2] = w;
                        if ((y | 0) == 0) {
                            A = x;
                            v = 12;
                            break
                        }
                        Pu(y);
                        A = c[m >> 2] | 0;
                        v = 12
                    } else {
                        A = n;
                        v = 12
                    }
                } while (0);
                if ((v | 0) == 12) {
                    if ((A | 0) == 0) { B = 0 } else {
                        u = A;
                        v = 13
                    }
                }
                if ((v | 0) == 13) {
                    c[u >> 2] = k;
                    B = c[m >> 2] | 0
                }
                c[m >> 2] = B + 4;
                i = b;
                return
            }
            B = a | 0;
            m = a + 8 | 0;
            k = c[m >> 2] | 0;
            u = a + 4 | 0;
            A = k - (c[u >> 2] | 0) >> 2;
            n = a + 12 | 0;
            y = c[n >> 2] | 0;
            x = a | 0;
            o = y - (c[x >> 2] | 0) | 0;
            if (!(A >>> 0 < o >> 2 >>> 0)) {
                j = o >> 1;
                o = (j | 0) == 0 ? 1 : j;
                j = f + 12 | 0;
                c[f + 16 >> 2] = a + 12;
                a = Nu(o << 2) | 0;
                z = f | 0;
                c[z >> 2] = a;
                l = a + (A << 2) | 0;
                A = f + 8 | 0;
                c[A >> 2] = l;
                h = f + 4 | 0;
                c[h >> 2] = l;
                c[j >> 2] = a + (o << 2);
                o = Nu(4096) | 0;
                c[g >> 2] = o;
                Ok(f, g);
                g = c[m >> 2] | 0;
                while (1) {
                    if ((g | 0) == (c[u >> 2] | 0)) { break }
                    o = g - 4 | 0;
                    Pk(f, o);
                    g = o
                }
                f = c[x >> 2] | 0;
                c[x >> 2] = c[z >> 2];
                c[z >> 2] = f;
                c[u >> 2] = c[h >> 2];
                c[h >> 2] = g;
                h = c[m >> 2] | 0;
                c[m >> 2] = c[A >> 2];
                c[A >> 2] = h;
                z = c[n >> 2] | 0;
                c[n >> 2] = c[j >> 2];
                c[j >> 2] = z;
                if ((h | 0) != (g | 0)) { c[A >> 2] = h + (~((h - 4 + (-g | 0) | 0) >>> 2) << 2) }
                if ((f | 0) == 0) { i = b; return }
                Pu(f);
                i = b;
                return
            }
            f = Nu(4096) | 0;
            if ((y | 0) != (k | 0)) {
                c[d >> 2] = f;
                Mk(B, d);
                i = b;
                return
            }
            c[e >> 2] = f;
            Nk(B, e);
            e = c[u >> 2] | 0;
            B = c[e >> 2] | 0;
            f = e + 4 | 0;
            c[u >> 2] = f;
            d = c[m >> 2] | 0;
            do {
                if ((d | 0) == (c[n >> 2] | 0)) {
                    k = c[x >> 2] | 0;
                    if (f >>> 0 > k >>> 0) {
                        y = f;
                        g = ((y - k >> 2) + 1 | 0) / -2 | 0;
                        h = d - y | 0;
                        fv(e + (g + 1 << 2) | 0, f | 0, h | 0) | 0;
                        y = e + ((h >> 2) + 1 + g << 2) | 0;
                        c[m >> 2] = y;
                        c[u >> 2] = (c[u >> 2] | 0) + (g << 2);
                        C = y;
                        v = 29;
                        break
                    }
                    y = d - k >> 1;
                    g = (y | 0) == 0 ? 1 : y;
                    y = Nu(g << 2) | 0;
                    h = y + (g >>> 2 << 2) | 0;
                    A = y + (g << 2) | 0;
                    if ((f | 0) == (d | 0)) {
                        D = h;
                        E = k
                    } else {
                        k = f;
                        g = h;
                        do {
                            if ((g | 0) == 0) { F = 0 } else {
                                c[g >> 2] = c[k >> 2];
                                F = g
                            }
                            g = F + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (d | 0));
                        D = g;
                        E = c[x >> 2] | 0
                    }
                    c[x >> 2] = y;
                    c[u >> 2] = h;
                    c[m >> 2] = D;
                    c[n >> 2] = A;
                    if ((E | 0) == 0) {
                        G = D;
                        v = 28;
                        break
                    }
                    Pu(E);
                    G = c[m >> 2] | 0;
                    v = 28
                } else {
                    G = d;
                    v = 28
                }
            } while (0);
            if ((v | 0) == 28) {
                if ((G | 0) == 0) { H = 0 } else {
                    C = G;
                    v = 29
                }
            }
            if ((v | 0) == 29) {
                c[C >> 2] = B;
                H = c[m >> 2] | 0
            }
            c[m >> 2] = H + 4;
            i = b;
            return
        }

        function Mk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            f = a + 12 | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 4 | 0;
                    h = c[g >> 2] | 0;
                    i = a | 0;
                    j = c[i >> 2] | 0;
                    if (h >>> 0 > j >>> 0) {
                        k = h;
                        l = ((k - j >> 2) + 1 | 0) / -2 | 0;
                        m = e - k | 0;
                        fv(h + (l << 2) | 0, h | 0, m | 0) | 0;
                        k = h + (l + (m >> 2) << 2) | 0;
                        c[d >> 2] = k;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = k;
                        break
                    }
                    k = e - j >> 1;
                    l = (k | 0) == 0 ? 1 : k;
                    k = Nu(l << 2) | 0;
                    m = k + (l >>> 2 << 2) | 0;
                    o = k + (l << 2) | 0;
                    if ((h | 0) == (e | 0)) {
                        p = m;
                        q = j
                    } else {
                        j = h;
                        h = m;
                        do {
                            if ((h | 0) == 0) { r = 0 } else {
                                c[h >> 2] = c[j >> 2];
                                r = h
                            }
                            h = r + 4 | 0;
                            j = j + 4 | 0;
                        } while ((j | 0) != (e | 0));
                        p = h;
                        q = c[i >> 2] | 0
                    }
                    c[i >> 2] = k;
                    c[g >> 2] = m;
                    c[d >> 2] = p;
                    c[f >> 2] = o;
                    if ((q | 0) == 0) { n = p; break }
                    Pu(q);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            if ((n | 0) == 0) {
                s = 0;
                t = s + 4 | 0;
                c[d >> 2] = t;
                return
            }
            c[n >> 2] = c[b >> 2];
            s = c[d >> 2] | 0;
            t = s + 4 | 0;
            c[d >> 2] = t;
            return
        }

        function Nk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            d = a + 4 | 0;
            e = c[d >> 2] | 0;
            f = a | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 8 | 0;
                    h = c[g >> 2] | 0;
                    i = a + 12 | 0;
                    j = c[i >> 2] | 0;
                    k = j;
                    if (h >>> 0 < j >>> 0) {
                        j = h;
                        l = ((k - j >> 2) + 1 | 0) / 2 | 0;
                        m = j - e | 0;
                        j = h + (l - (m >> 2) << 2) | 0;
                        fv(j | 0, e | 0, m | 0) | 0;
                        c[d >> 2] = j;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = j;
                        break
                    }
                    j = k - e >> 1;
                    k = (j | 0) == 0 ? 1 : j;
                    j = Nu(k << 2) | 0;
                    l = j + ((k + 3 | 0) >>> 2 << 2) | 0;
                    m = j + (k << 2) | 0;
                    if ((e | 0) == (h | 0)) {
                        o = l;
                        p = e
                    } else {
                        k = e;
                        q = l;
                        do {
                            if ((q | 0) == 0) { r = 0 } else {
                                c[q >> 2] = c[k >> 2];
                                r = q
                            }
                            q = r + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (h | 0));
                        o = q;
                        p = c[f >> 2] | 0
                    }
                    c[f >> 2] = j;
                    c[d >> 2] = l;
                    c[g >> 2] = o;
                    c[i >> 2] = m;
                    if ((p | 0) == 0) { n = l; break }
                    Pu(p);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            c[n - 4 >> 2] = c[b >> 2];
            c[d >> 2] = (c[d >> 2] | 0) - 4;
            return
        }

        function Ok(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            f = a + 12 | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 4 | 0;
                    h = c[g >> 2] | 0;
                    i = a | 0;
                    j = c[i >> 2] | 0;
                    if (h >>> 0 > j >>> 0) {
                        k = h;
                        l = ((k - j >> 2) + 1 | 0) / -2 | 0;
                        m = e - k | 0;
                        fv(h + (l << 2) | 0, h | 0, m | 0) | 0;
                        k = h + (l + (m >> 2) << 2) | 0;
                        c[d >> 2] = k;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = k;
                        break
                    }
                    k = e - j >> 1;
                    l = (k | 0) == 0 ? 1 : k;
                    k = Nu(l << 2) | 0;
                    m = k + (l >>> 2 << 2) | 0;
                    o = k + (l << 2) | 0;
                    if ((h | 0) == (e | 0)) {
                        p = m;
                        q = j
                    } else {
                        j = h;
                        h = m;
                        do {
                            if ((h | 0) == 0) { r = 0 } else {
                                c[h >> 2] = c[j >> 2];
                                r = h
                            }
                            h = r + 4 | 0;
                            j = j + 4 | 0;
                        } while ((j | 0) != (e | 0));
                        p = h;
                        q = c[i >> 2] | 0
                    }
                    c[i >> 2] = k;
                    c[g >> 2] = m;
                    c[d >> 2] = p;
                    c[f >> 2] = o;
                    if ((q | 0) == 0) { n = p; break }
                    Pu(q);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            if ((n | 0) == 0) {
                s = 0;
                t = s + 4 | 0;
                c[d >> 2] = t;
                return
            }
            c[n >> 2] = c[b >> 2];
            s = c[d >> 2] | 0;
            t = s + 4 | 0;
            c[d >> 2] = t;
            return
        }

        function Pk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            d = a + 4 | 0;
            e = c[d >> 2] | 0;
            f = a | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 8 | 0;
                    h = c[g >> 2] | 0;
                    i = a + 12 | 0;
                    j = c[i >> 2] | 0;
                    k = j;
                    if (h >>> 0 < j >>> 0) {
                        j = h;
                        l = ((k - j >> 2) + 1 | 0) / 2 | 0;
                        m = j - e | 0;
                        j = h + (l - (m >> 2) << 2) | 0;
                        fv(j | 0, e | 0, m | 0) | 0;
                        c[d >> 2] = j;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = j;
                        break
                    }
                    j = k - e >> 1;
                    k = (j | 0) == 0 ? 1 : j;
                    j = Nu(k << 2) | 0;
                    l = j + ((k + 3 | 0) >>> 2 << 2) | 0;
                    m = j + (k << 2) | 0;
                    if ((e | 0) == (h | 0)) {
                        o = l;
                        p = e
                    } else {
                        k = e;
                        q = l;
                        do {
                            if ((q | 0) == 0) { r = 0 } else {
                                c[q >> 2] = c[k >> 2];
                                r = q
                            }
                            q = r + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (h | 0));
                        o = q;
                        p = c[f >> 2] | 0
                    }
                    c[f >> 2] = j;
                    c[d >> 2] = l;
                    c[g >> 2] = o;
                    c[i >> 2] = m;
                    if ((p | 0) == 0) { n = l; break }
                    Pu(p);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            c[n - 4 >> 2] = c[b >> 2];
            c[d >> 2] = (c[d >> 2] | 0) - 4;
            return
        }

        function Qk(b, e, f, g, h) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0;
            f = b + 18596 | 0;
            e = c[f >> 2] | 0;
            i = e + 5932 | 0;
            j = b + 18600 | 0;
            k = c[j >> 2] | 0;
            l = -1 << c[e + 10092 >> 2];
            m = l & g;
            n = l & h;
            l = b + 18532 | 0;
            o = b + 18536 | 0;
            if ((m | 0) == (c[l >> 2] | 0)) { if ((n | 0) != (c[o >> 2] | 0)) { p = 3 } } else { p = 3 }
            if ((p | 0) == 3) {
                c[b + 18540 >> 2] = c[b + 18528 >> 2];
                c[l >> 2] = m;
                c[o >> 2] = n
            }
            o = e + 5804 | 0;
            if ((m | 0) == 0) { q = ((1 << c[o >> 2]) - 1 & n | 0) == 0 } else { q = 0 }
            l = c[k + 800 >> 2] | 0;
            r = c[e + 5820 >> 2] | 0;
            s = c[e + 5812 >> 2] | 0;
            if ((ga(s, (l | 0) % (r | 0) | 0) | 0) == (m | 0)) { t = (ga((l | 0) / (r | 0) | 0, s) | 0) == (n | 0) } else { t = 0 }
            do {
                if ((a[e + 5966 | 0] | 0) == 0) { u = 0 } else {
                    s = c[o >> 2] | 0;
                    r = (1 << s) - 1 | 0;
                    if ((r & m | 0) != 0) { u = 0; break }
                    if ((r & n | 0) != 0) { u = 0; break }
                    u = pj(i, m >> s, n >> s) | 0
                }
            } while (0);
            do {
                if (t | u) { p = 15 } else {
                    if (q) { if ((a[e + 5965 | 0] | 0) != 0) { p = 15; break } }
                    v = b + 18540 | 0
                }
            } while (0);
            if ((p | 0) == 15) { v = (c[j >> 2] | 0) + 792 | 0 }
            j = c[v >> 2] | 0;
            v = m - 1 | 0;
            do {
                if (bi(c[f >> 2] | 0, m, n, v, n) | 0) {
                    p = c[e + 5864 >> 2] | 0;
                    q = (ga(n >> p, c[e + 5852 >> 2] | 0) | 0) + (v >> p) | 0;
                    if ((c[(c[e + 10320 >> 2] | 0) + (q << 2) >> 2] >> ((c[o >> 2] | 0) - p << 1) | 0) != (c[b + 4 >> 2] | 0)) { w = j; break }
                    p = c[f >> 2] | 0;
                    q = c[p + 10368 >> 2] | 0;
                    u = v >> q;
                    t = n >> q;
                    if (!((u | 0) > -1)) { ec(6096, 4288, 118, 17312) }
                    q = c[p + 10372 >> 2] | 0;
                    if ((u | 0) >= (q | 0)) { ec(6096, 4288, 118, 17312) }
                    if (!((t | 0) > -1)) { ec(3e3, 4288, 119, 17312) }
                    if ((t | 0) < (c[p + 10376 >> 2] | 0)) {
                        i = (ga(q, t) | 0) + u | 0;
                        w = a[(c[p + 10360 >> 2] | 0) + (i * 3 | 0) + 2 | 0] | 0;
                        break
                    } else { ec(3e3, 4288, 119, 17312) }
                } else { w = j }
            } while (0);
            v = n - 1 | 0;
            do {
                if (bi(c[f >> 2] | 0, m, n, m, v) | 0) {
                    i = c[e + 5864 >> 2] | 0;
                    p = (ga(v >> i, c[e + 5852 >> 2] | 0) | 0) + (m >> i) | 0;
                    if ((c[(c[e + 10320 >> 2] | 0) + (p << 2) >> 2] >> ((c[o >> 2] | 0) - i << 1) | 0) != (c[b + 4 >> 2] | 0)) { x = j; break }
                    i = c[f >> 2] | 0;
                    p = c[i + 10368 >> 2] | 0;
                    u = m >> p;
                    t = v >> p;
                    if (!((u | 0) > -1)) { ec(6096, 4288, 118, 17312) }
                    p = c[i + 10372 >> 2] | 0;
                    if ((u | 0) >= (p | 0)) { ec(6096, 4288, 118, 17312) }
                    if (!((t | 0) > -1)) { ec(3e3, 4288, 119, 17312) }
                    if ((t | 0) < (c[i + 10376 >> 2] | 0)) {
                        q = (ga(p, t) | 0) + u | 0;
                        x = a[(c[i + 10360 >> 2] | 0) + (q * 3 | 0) + 2 | 0] | 0;
                        break
                    } else { ec(3e3, 4288, 119, 17312) }
                } else { x = j }
            } while (0);
            j = c[e + 5764 >> 2] | 0;
            v = ((c[b + 18512 >> 2] | 0) + 52 + (w + 1 + x >> 1) + (j << 1) | 0) % (j + 52 | 0) | 0;
            x = v - j | 0;
            c[b + 18544 >> 2] = v;
            v = x + (c[e + 5952 >> 2] | 0) + (c[k + 744 >> 2] | 0) + (c[b + 18520 >> 2] | 0) | 0;
            j = e + 5772 | 0;
            w = c[j >> 2] | 0;
            m = -w | 0;
            if ((v | 0) < (m | 0)) { y = m } else { y = (v | 0) > 57 ? 57 : v }
            v = (c[e + 5956 >> 2] | 0) + x + (c[k + 748 >> 2] | 0) + (c[b + 18524 >> 2] | 0) | 0;
            if ((v | 0) < (m | 0)) { z = m } else { z = (v | 0) > 57 ? 57 : v }
            do {
                if ((c[e + 5776 >> 2] | 0) == 1) {
                    do { if ((y | 0) < 30) { A = y } else { if ((y | 0) > 42) { A = y - 6 | 0; break } else { A = c[8 + (y - 30 << 2) >> 2] | 0; break } } } while (0);
                    if ((z | 0) < 30) {
                        B = z;
                        C = A;
                        break
                    }
                    if ((z | 0) > 42) {
                        B = z - 6 | 0;
                        C = A;
                        break
                    } else {
                        B = c[8 + (z - 30 << 2) >> 2] | 0;
                        C = A;
                        break
                    }
                } else {
                    B = z;
                    C = y
                }
            } while (0);
            c[b + 18548 >> 2] = w + C;
            c[b + 18552 >> 2] = (c[j >> 2] | 0) + B;
            B = c[f >> 2] | 0;
            f = c[B + 10368 >> 2] | 0;
            j = g >> f;
            g = h >> f;
            if (!((j | 0) > -1)) { ec(6096, 4288, 118, 17312) }
            h = B + 10372 | 0;
            C = c[h >> 2] | 0;
            if ((j | 0) >= (C | 0)) { ec(6096, 4288, 118, 17312) }
            if (!((g | 0) > -1)) { ec(3e3, 4288, 119, 17312) }
            if ((g | 0) >= (c[B + 10376 >> 2] | 0)) { ec(3e3, 4288, 119, 17312) }
            w = (ga(C, g) | 0) + j | 0;
            C = B + 10360 | 0;
            B = (c[C >> 2] | 0) + (w * 3 | 0) | 0;
            w = (d[B] | d[B + 1 | 0] << 8) << 16 >> 16 & 255 & 7;
            B = 1 << (w >>> 0 < 3 >>> 0 ? 3 : w) - f;
            f = B + g | 0;
            if ((B | 0) <= 0) {
                D = b + 18528 | 0;
                c[D >> 2] = x;
                return
            }
            w = B + j | 0;
            B = x & 255;
            y = g;
            do {
                g = j;
                do {
                    z = (ga(c[h >> 2] | 0, y) | 0) + g | 0;
                    a[(c[C >> 2] | 0) + (z * 3 | 0) + 2 | 0] = B;
                    g = g + 1 | 0;
                } while ((g | 0) < (w | 0));
                y = y + 1 | 0;
            } while ((y | 0) < (f | 0));
            D = b + 18528 | 0;
            c[D >> 2] = x;
            return
        }

        function Rk(a, b, d, e, f, g, h, i, j, k) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            f = c[a + 18596 >> 2] | 0;
            if ((c[((h | 0) == 0 ? f + 5760 | 0 : f + 5768 | 0) >> 2] | 0) > 8) { Sk(a, b, d, 0, 0, g, h, i, j, k); return } else { Tk(a, b, d, 0, 0, g, h, i, j, k); return }
        }

        function Sk(e, f, g, h, j, k, l, m, n, o) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            var p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            j = i;
            i = i + 8192 | 0;
            h = j | 0;
            p = j + 4096 | 0;
            q = e + 18596 | 0;
            r = c[q >> 2] | 0;
            if ((l | 0) == 2) { s = e + 18552 | 0 } else if ((l | 0) == 0) { s = e + 18544 | 0 } else if ((l | 0) == 1) { s = e + 18548 | 0 } else { ec(11600, 14216, 367, 18584) }
            t = c[s >> 2] | 0;
            s = e + 2112 | 0;
            u = c[s >> 2] | 0;
            v = (l | 0) == 0;
            w = c[(v ? r + 40 | 0 : r + 44 | 0) >> 2] | 0;
            x = (c[r + 4 + (l << 2) >> 2] | 0) + ((ga(w, g) | 0) + f << 1) | 0;
            y = c[(v ? r + 5760 | 0 : r + 5768 | 0) >> 2] | 0;
            z = c[r + 10368 >> 2] | 0;
            A = f >> z;
            f = g >> z;
            if (!((A | 0) > -1)) { ec(6096, 4288, 118, 17312) }
            z = c[r + 10372 >> 2] | 0;
            if ((A | 0) >= (z | 0)) { ec(6096, 4288, 118, 17312) }
            if (!((f | 0) > -1)) { ec(3e3, 4288, 119, 17312) }
            if ((f | 0) >= (c[r + 10376 >> 2] | 0)) { ec(3e3, 4288, 119, 17312) }
            g = (ga(z, f) | 0) + A | 0;
            A = (c[r + 10360 >> 2] | 0) + (g * 3 | 0) | 0;
            g = ((d[A] | d[A + 1 | 0] << 8) << 16 >> 16 & 768) == 0;
            A = (k | 0) == 4;
            f = (a[r + 5748 | 0] | 0) != 0 & A & g;
            do {
                if ((a[e + 32 | 0] | 0) == 0) {
                    z = (k | 0) > 1;
                    if (z) {
                        B = k;
                        C = 0;
                        while (1) {
                            D = C + 1 | 0;
                            E = B >> 1;
                            if ((E | 0) > 1) {
                                B = E;
                                C = D
                            } else { F = D; break }
                        }
                    } else { F = 0 }
                    C = F + y | 0;
                    B = C - 5 | 0;
                    do {
                        if ((a[r + 1400 | 0] | 0) == 0) {
                            D = C - 9 | 0;
                            E = 1 << C - 10;
                            G = c[31e3 + (((t | 0) % 6 | 0) << 2) >> 2] << ((t | 0) / 6 | 0);
                            H = e + 14404 + (l << 1) | 0;
                            if ((b[H >> 1] | 0) > 0) { I = 0 } else { break }
                            do {
                                J = (ga(b[e + 2116 + (l << 11) + (I << 1) >> 1] | 0, G) | 0) + E >> D;
                                if ((J | 0) < -32768) { L = -32768 } else { L = (J | 0) > 32767 ? 32767 : J & 65535 }
                                b[u + (b[e + 8260 + (l << 11) + (I << 1) >> 1] << 1) >> 1] = L;
                                I = I + 1 | 0;
                            } while ((I | 0) < (b[H >> 1] | 0))
                        } else {
                            H = 1 << C - 6;
                            do { if (n) { M = l } else { if ((k | 0) < 32) { M = l + 3 | 0; break } else { M = l + 1 | 0; break } } } while (0);
                            if ((k | 0) == 16) { N = r + 6473 + (M << 8) | 0 } else if ((k | 0) == 8) { N = r + 6089 + (M << 6) | 0 } else if ((k | 0) == 4) { N = r + 5993 + (M << 4) | 0 } else if ((k | 0) == 32) { N = r + 8009 + (M << 10) | 0 } else { ec(11600, 14216, 492, 18584) }
                            D = e + 14404 + (l << 1) | 0;
                            if ((b[D >> 1] | 0) <= 0) { break }
                            E = c[31e3 + (((t | 0) % 6 | 0) << 2) >> 2] | 0;
                            G = (t | 0) / 6 | 0;
                            J = H;
                            O = (H | 0) < 0 | 0 ? -1 : 0;
                            P = B;
                            Q = 0;
                            do {
                                R = b[e + 8260 + (l << 11) + (Q << 1) >> 1] | 0;
                                S = (ga(E, d[N + R | 0] | 0) | 0) << G;
                                T = b[e + 2116 + (l << 11) + (Q << 1) >> 1] | 0;
                                U = rv(T << 16 >> 16, T << 16 >> 16 < 0 | 0 ? -1 : 0, S, (S | 0) < 0 | 0 ? -1 : 0) | 0;
                                S = hv(U, K, J, O) | 0;
                                U = lv(S | 0, K | 0, P | 0) | 0;
                                S = K;
                                T = -1;
                                if ((S | 0) < (T | 0) | (S | 0) == (T | 0) & U >>> 0 < -32768 >>> 0) { V = -32768 } else {
                                    T = 0;
                                    V = (S | 0) > (T | 0) | (S | 0) == (T | 0) & U >>> 0 > 32767 >>> 0 ? 32767 : U & 65535
                                }
                                b[u + (R << 1) >> 1] = V;
                                Q = Q + 1 | 0;
                            } while ((Q | 0) < (b[D >> 1] | 0))
                        }
                    } while (0);
                    B = (k | 0) > 0;
                    if (!m) {
                        C = A & v & g;
                        if ((o | 0) != 0) { ec(8472, 14216, 591, 18584) }
                        if ((a[r + 10071 | 0] | 0) != 0) { Vk(e, u, 0, k, C & 1, x, w, y, l); break }
                        D = c[e + 18592 >> 2] | 0;
                        if (C) { Wc[c[D + 412 >> 2] & 63](x, u, w, y); break }
                        if ((k | 0) == 8) { Wc[c[D + 420 >> 2] & 63](x, u, w, y); break } else if ((k | 0) == 4) { Wc[c[D + 416 >> 2] & 63](x, u, w, y); break } else if ((k | 0) == 16) { Wc[c[D + 424 >> 2] & 63](x, u, w, y); break } else { Wc[c[D + 428 >> 2] & 63](x, u, w, y); break }
                    }
                    if (z) {
                        D = k;
                        C = 0;
                        while (1) {
                            Q = D >> 1;
                            if ((Q | 0) > 1) {
                                D = Q;
                                C = C + 1 | 0
                            } else { break }
                        }
                        W = C + 6 | 0
                    } else { W = 5 }
                    D = 20 - y | 0;
                    z = (D | 0) > 0 ? D : 0;
                    if (f) { Ec[c[(c[e + 18592 >> 2] | 0) + 432 >> 2] & 127](u, 4) }
                    D = v ? e + 14412 | 0 : p | 0;
                    do { if ((o | 0) == 0) { Cc[c[(c[e + 18592 >> 2] | 0) + 472 >> 2] & 31](D, u, k, W, z) } else { Q = c[e + 18592 >> 2] | 0; if ((o | 0) == 2) { Cc[c[Q + 464 >> 2] & 31](D, u, k, W, z); break } else { Cc[c[Q + 468 >> 2] & 31](D, u, k, W, z); break } } } while (0);
                    do {
                        if (!v) {
                            z = e + 28 | 0;
                            if ((c[z >> 2] | 0) == 0) { break }
                            C = c[q >> 2] | 0;
                            Q = c[C + 5768 >> 2] | 0;
                            P = c[C + 5760 >> 2] | 0;
                            if (B) { X = 0 } else { break }
                            do {
                                C = ga(X, k) | 0;
                                O = 0;
                                do {
                                    J = O + C | 0;
                                    G = (ga(c[e + 14412 + (J << 2) >> 2] << Q >> P, c[z >> 2] | 0) | 0) >> 3;
                                    E = D + (J << 2) | 0;
                                    c[E >> 2] = G + (c[E >> 2] | 0);
                                    O = O + 1 | 0;
                                } while ((O | 0) < (k | 0));
                                X = X + 1 | 0;
                            } while ((X | 0) < (k | 0))
                        }
                    } while (0);
                    Cc[c[(c[e + 18592 >> 2] | 0) + 460 >> 2] & 31](x, w, D, k, y);
                    if (!f) { break }
                    dv(u | 0, 0, 32) | 0
                } else {
                    B = v ? e + 14412 | 0 : h | 0;
                    z = e + 14404 + (l << 1) | 0;
                    if ((b[z >> 1] | 0) > 0) {
                        P = 0;
                        do {
                            b[u + (b[e + 8260 + (l << 11) + (P << 1) >> 1] << 1) >> 1] = b[e + 2116 + (l << 11) + (P << 1) >> 1] | 0;
                            P = P + 1 | 0;
                        } while ((P | 0) < (b[z >> 1] | 0))
                    }
                    if (f) { Ec[c[(c[e + 18592 >> 2] | 0) + 432 >> 2] & 127](u, 4) }
                    do { if ((o | 0) == 0) { Tc[c[(c[e + 18592 >> 2] | 0) + 364 >> 2] & 63](B, u, k) } else { z = c[e + 18592 >> 2] | 0; if ((o | 0) == 2) { Tc[c[z + 368 >> 2] & 63](B, u, k); break } else { Tc[c[z + 372 >> 2] & 63](B, u, k); break } } } while (0);
                    do {
                        if (!v) {
                            z = e + 28 | 0;
                            if ((c[z >> 2] | 0) == 0) { break }
                            P = c[q >> 2] | 0;
                            D = c[P + 5768 >> 2] | 0;
                            Q = c[P + 5760 >> 2] | 0;
                            if ((k | 0) > 0) { Y = 0 } else { break }
                            do {
                                P = ga(Y, k) | 0;
                                O = 0;
                                do {
                                    C = O + P | 0;
                                    E = (ga(c[e + 14412 + (C << 2) >> 2] << D >> Q, c[z >> 2] | 0) | 0) >> 3;
                                    G = B + (C << 2) | 0;
                                    c[G >> 2] = E + (c[G >> 2] | 0);
                                    O = O + 1 | 0;
                                } while ((O | 0) < (k | 0));
                                Y = Y + 1 | 0;
                            } while ((Y | 0) < (k | 0))
                        }
                    } while (0);
                    Cc[c[(c[e + 18592 >> 2] | 0) + 460 >> 2] & 31](x, w, B, k, y);
                    if (!f) { break }
                    dv(u | 0, 0, 32) | 0
                }
            } while (0);
            u = e + 14404 + (l << 1) | 0;
            if ((b[u >> 1] | 0) <= 0) { i = j; return }
            f = c[s >> 2] | 0;
            s = 0;
            do {
                b[f + (b[e + 8260 + (l << 11) + (s << 1) >> 1] << 1) >> 1] = 0;
                s = s + 1 | 0;
            } while ((s | 0) < (b[u >> 1] | 0));
            i = j;
            return
        }

        function Tk(e, f, g, h, j, k, l, m, n, o) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            var p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            j = i;
            i = i + 8192 | 0;
            h = j | 0;
            p = j + 4096 | 0;
            q = e + 18596 | 0;
            r = c[q >> 2] | 0;
            if ((l | 0) == 1) { s = e + 18548 | 0 } else if ((l | 0) == 2) { s = e + 18552 | 0 } else if ((l | 0) == 0) { s = e + 18544 | 0 } else { ec(11600, 14216, 367, 18584) }
            t = c[s >> 2] | 0;
            s = e + 2112 | 0;
            u = c[s >> 2] | 0;
            v = (l | 0) == 0;
            w = c[(v ? r + 40 | 0 : r + 44 | 0) >> 2] | 0;
            x = (c[r + 4 + (l << 2) >> 2] | 0) + ((ga(w, g) | 0) + f) | 0;
            y = c[r + 10368 >> 2] | 0;
            z = f >> y;
            f = g >> y;
            if (!((z | 0) > -1)) { ec(6096, 4288, 118, 17312) }
            y = c[r + 10372 >> 2] | 0;
            if ((z | 0) >= (y | 0)) { ec(6096, 4288, 118, 17312) }
            if (!((f | 0) > -1)) { ec(3e3, 4288, 119, 17312) }
            if ((f | 0) >= (c[r + 10376 >> 2] | 0)) { ec(3e3, 4288, 119, 17312) }
            g = (ga(y, f) | 0) + z | 0;
            z = (c[r + 10360 >> 2] | 0) + (g * 3 | 0) | 0;
            g = ((d[z] | d[z + 1 | 0] << 8) << 16 >> 16 & 768) == 0;
            z = (k | 0) == 4;
            f = (a[r + 5748 | 0] | 0) != 0 & z & g;
            do {
                if ((a[e + 32 | 0] | 0) == 0) {
                    y = c[(v ? r + 5760 | 0 : r + 5768 | 0) >> 2] | 0;
                    A = (k | 0) > 1;
                    if (A) {
                        B = k;
                        C = 0;
                        while (1) {
                            D = C + 1 | 0;
                            E = B >> 1;
                            if ((E | 0) > 1) {
                                B = E;
                                C = D
                            } else { F = D; break }
                        }
                    } else { F = 0 }
                    C = F + y | 0;
                    B = C - 5 | 0;
                    do {
                        if ((a[r + 1400 | 0] | 0) == 0) {
                            D = C - 9 | 0;
                            E = 1 << C - 10;
                            G = c[31e3 + (((t | 0) % 6 | 0) << 2) >> 2] << ((t | 0) / 6 | 0);
                            H = e + 14404 + (l << 1) | 0;
                            if ((b[H >> 1] | 0) > 0) { I = 0 } else { break }
                            do {
                                J = (ga(b[e + 2116 + (l << 11) + (I << 1) >> 1] | 0, G) | 0) + E >> D;
                                if ((J | 0) < -32768) { L = -32768 } else { L = (J | 0) > 32767 ? 32767 : J & 65535 }
                                b[u + (b[e + 8260 + (l << 11) + (I << 1) >> 1] << 1) >> 1] = L;
                                I = I + 1 | 0;
                            } while ((I | 0) < (b[H >> 1] | 0))
                        } else {
                            H = 1 << C - 6;
                            do { if (n) { M = l } else { if ((k | 0) < 32) { M = l + 3 | 0; break } else { M = l + 1 | 0; break } } } while (0);
                            if ((k | 0) == 8) { N = r + 6089 + (M << 6) | 0 } else if ((k | 0) == 4) { N = r + 5993 + (M << 4) | 0 } else if ((k | 0) == 16) { N = r + 6473 + (M << 8) | 0 } else if ((k | 0) == 32) { N = r + 8009 + (M << 10) | 0 } else { ec(11600, 14216, 492, 18584) }
                            D = e + 14404 + (l << 1) | 0;
                            if ((b[D >> 1] | 0) <= 0) { break }
                            E = c[31e3 + (((t | 0) % 6 | 0) << 2) >> 2] | 0;
                            G = (t | 0) / 6 | 0;
                            J = H;
                            O = (H | 0) < 0 | 0 ? -1 : 0;
                            P = B;
                            Q = 0;
                            do {
                                R = b[e + 8260 + (l << 11) + (Q << 1) >> 1] | 0;
                                S = (ga(E, d[N + R | 0] | 0) | 0) << G;
                                T = b[e + 2116 + (l << 11) + (Q << 1) >> 1] | 0;
                                U = rv(T << 16 >> 16, T << 16 >> 16 < 0 | 0 ? -1 : 0, S, (S | 0) < 0 | 0 ? -1 : 0) | 0;
                                S = hv(U, K, J, O) | 0;
                                U = lv(S | 0, K | 0, P | 0) | 0;
                                S = K;
                                T = -1;
                                if ((S | 0) < (T | 0) | (S | 0) == (T | 0) & U >>> 0 < -32768 >>> 0) { V = -32768 } else {
                                    T = 0;
                                    V = (S | 0) > (T | 0) | (S | 0) == (T | 0) & U >>> 0 > 32767 >>> 0 ? 32767 : U & 65535
                                }
                                b[u + (R << 1) >> 1] = V;
                                Q = Q + 1 | 0;
                            } while ((Q | 0) < (b[D >> 1] | 0))
                        }
                    } while (0);
                    B = (k | 0) > 0;
                    if (!m) {
                        C = z & v & g;
                        if ((o | 0) != 0) { ec(8472, 14216, 591, 18584) }
                        if ((a[r + 10071 | 0] | 0) != 0) { Uk(e, u, 0, k, C & 1, x, w, 8, l); break }
                        y = c[e + 18592 >> 2] | 0;
                        if (C) { Tc[c[y + 388 >> 2] & 63](x, u, w); break }
                        if ((k | 0) == 4) { Tc[c[y + 392 >> 2] & 63](x, u, w); break } else if ((k | 0) == 8) { Tc[c[y + 396 >> 2] & 63](x, u, w); break } else if ((k | 0) == 16) { Tc[c[y + 400 >> 2] & 63](x, u, w); break } else { Tc[c[y + 404 >> 2] & 63](x, u, w); break }
                    }
                    if (A) {
                        y = k;
                        C = 0;
                        while (1) {
                            D = y >> 1;
                            if ((D | 0) > 1) {
                                y = D;
                                C = C + 1 | 0
                            } else { break }
                        }
                        W = C + 6 | 0
                    } else { W = 5 }
                    if (f) { Ec[c[(c[e + 18592 >> 2] | 0) + 432 >> 2] & 127](u, 4) }
                    y = v ? e + 14412 | 0 : p | 0;
                    do { if ((o | 0) == 0) { Cc[c[(c[e + 18592 >> 2] | 0) + 472 >> 2] & 31](y, u, k, W, 12) } else { A = c[e + 18592 >> 2] | 0; if ((o | 0) == 2) { Cc[c[A + 464 >> 2] & 31](y, u, k, W, 12); break } else { Cc[c[A + 468 >> 2] & 31](y, u, k, W, 12); break } } } while (0);
                    do {
                        if (!v) {
                            C = e + 28 | 0;
                            if ((c[C >> 2] | 0) == 0) { break }
                            A = c[q >> 2] | 0;
                            D = c[A + 5768 >> 2] | 0;
                            Q = c[A + 5760 >> 2] | 0;
                            if (B) { X = 0 } else { break }
                            do {
                                A = ga(X, k) | 0;
                                P = 0;
                                do {
                                    O = P + A | 0;
                                    J = (ga(c[e + 14412 + (O << 2) >> 2] << D >> Q, c[C >> 2] | 0) | 0) >> 3;
                                    G = y + (O << 2) | 0;
                                    c[G >> 2] = J + (c[G >> 2] | 0);
                                    P = P + 1 | 0;
                                } while ((P | 0) < (k | 0));
                                X = X + 1 | 0;
                            } while ((X | 0) < (k | 0))
                        }
                    } while (0);
                    Cc[c[(c[e + 18592 >> 2] | 0) + 456 >> 2] & 31](x, w, y, k, 8);
                    if (!f) { break }
                    dv(u | 0, 0, 32) | 0
                } else {
                    B = v ? e + 14412 | 0 : h | 0;
                    C = e + 14404 + (l << 1) | 0;
                    if ((b[C >> 1] | 0) > 0) {
                        Q = 0;
                        do {
                            b[u + (b[e + 8260 + (l << 11) + (Q << 1) >> 1] << 1) >> 1] = b[e + 2116 + (l << 11) + (Q << 1) >> 1] | 0;
                            Q = Q + 1 | 0;
                        } while ((Q | 0) < (b[C >> 1] | 0))
                    }
                    if (f) { Ec[c[(c[e + 18592 >> 2] | 0) + 432 >> 2] & 127](u, 4) }
                    do { if ((o | 0) == 0) { Tc[c[(c[e + 18592 >> 2] | 0) + 364 >> 2] & 63](B, u, k) } else { C = c[e + 18592 >> 2] | 0; if ((o | 0) == 2) { Tc[c[C + 368 >> 2] & 63](B, u, k); break } else { Tc[c[C + 372 >> 2] & 63](B, u, k); break } } } while (0);
                    do {
                        if (!v) {
                            C = e + 28 | 0;
                            if ((c[C >> 2] | 0) == 0) { break }
                            Q = c[q >> 2] | 0;
                            y = c[Q + 5768 >> 2] | 0;
                            D = c[Q + 5760 >> 2] | 0;
                            if ((k | 0) > 0) { Y = 0 } else { break }
                            do {
                                Q = ga(Y, k) | 0;
                                P = 0;
                                do {
                                    A = P + Q | 0;
                                    G = (ga(c[e + 14412 + (A << 2) >> 2] << y >> D, c[C >> 2] | 0) | 0) >> 3;
                                    J = B + (A << 2) | 0;
                                    c[J >> 2] = G + (c[J >> 2] | 0);
                                    P = P + 1 | 0;
                                } while ((P | 0) < (k | 0));
                                Y = Y + 1 | 0;
                            } while ((Y | 0) < (k | 0))
                        }
                    } while (0);
                    Cc[c[(c[e + 18592 >> 2] | 0) + 456 >> 2] & 31](x, w, B, k, 8);
                    if (!f) { break }
                    dv(u | 0, 0, 32) | 0
                }
            } while (0);
            u = e + 14404 + (l << 1) | 0;
            if ((b[u >> 1] | 0) <= 0) { i = j; return }
            f = c[s >> 2] | 0;
            s = 0;
            do {
                b[f + (b[e + 8260 + (l << 11) + (s << 1) >> 1] << 1) >> 1] = 0;
                s = s + 1 | 0;
            } while ((s | 0) < (b[u >> 1] | 0));
            i = j;
            return
        }

        function Uk(a, b, d, e, f, g, h, j, k) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = i;
            i = i + 4096 | 0;
            l = c[a + 18592 >> 2] | 0;
            m = (k | 0) == 0;
            k = m ? a + 14412 | 0 : d | 0;
            n = 20 - j | 0;
            do { if ((f | 0) == 1) { Wc[c[l + 436 >> 2] & 63](k, b, n, 15) } else { if ((e | 0) == 16) { Wc[c[l + 448 >> 2] & 63](k, b, n, 15); break } else if ((e | 0) == 4) { Wc[c[l + 440 >> 2] & 63](k, b, n, 15); break } else if ((e | 0) == 8) { Wc[c[l + 444 >> 2] & 63](k, b, n, 15); break } else { Wc[c[l + 452 >> 2] & 63](k, b, n, 15); break } } } while (0);
            do {
                if (!m) {
                    n = a + 28 | 0;
                    if ((c[n >> 2] | 0) == 0) { break }
                    b = c[a + 18596 >> 2] | 0;
                    f = c[b + 5768 >> 2] | 0;
                    o = c[b + 5760 >> 2] | 0;
                    if ((e | 0) > 0) { p = 0 } else { break }
                    do {
                        b = ga(p, e) | 0;
                        q = 0;
                        do {
                            r = q + b | 0;
                            s = (ga(c[a + 14412 + (r << 2) >> 2] << f >> o, c[n >> 2] | 0) | 0) >> 3;
                            t = k + (r << 2) | 0;
                            c[t >> 2] = s + (c[t >> 2] | 0);
                            q = q + 1 | 0;
                        } while ((q | 0) < (e | 0));
                        p = p + 1 | 0;
                    } while ((p | 0) < (e | 0))
                }
            } while (0);
            Cc[c[l + 456 >> 2] & 31](g, h, k, e, j);
            i = d;
            return
        }

        function Vk(a, b, d, e, f, g, h, j, k) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = i;
            i = i + 4096 | 0;
            l = c[a + 18592 >> 2] | 0;
            m = (k | 0) == 0;
            k = m ? a + 14412 | 0 : d | 0;
            n = 20 - j | 0;
            do { if ((f | 0) == 1) { Wc[c[l + 436 >> 2] & 63](k, b, n, 15) } else { if ((e | 0) == 8) { Wc[c[l + 444 >> 2] & 63](k, b, n, 15); break } else if ((e | 0) == 16) { Wc[c[l + 448 >> 2] & 63](k, b, n, 15); break } else if ((e | 0) == 4) { Wc[c[l + 440 >> 2] & 63](k, b, n, 15); break } else { Wc[c[l + 452 >> 2] & 63](k, b, n, 15); break } } } while (0);
            do {
                if (!m) {
                    n = a + 28 | 0;
                    if ((c[n >> 2] | 0) == 0) { break }
                    b = c[a + 18596 >> 2] | 0;
                    f = c[b + 5768 >> 2] | 0;
                    o = c[b + 5760 >> 2] | 0;
                    if ((e | 0) > 0) { p = 0 } else { break }
                    do {
                        b = ga(p, e) | 0;
                        q = 0;
                        do {
                            r = q + b | 0;
                            s = (ga(c[a + 14412 + (r << 2) >> 2] << f >> o, c[n >> 2] | 0) | 0) >> 3;
                            t = k + (r << 2) | 0;
                            c[t >> 2] = s + (c[t >> 2] | 0);
                            q = q + 1 | 0;
                        } while ((q | 0) < (e | 0));
                        p = p + 1 | 0;
                    } while ((p | 0) < (e | 0))
                }
            } while (0);
            Cc[c[l + 460 >> 2] & 31](g, h, k, e, j);
            i = d;
            return
        }

        function Wk(a) {
            a = a | 0;
            c[12934] = a;
            return
        }

        function Xk(a) { a = a | 0; return }

        function Yk(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0;
            f = i;
            i = i + 16 | 0;
            g = f | 0;
            if ((c[12934] | 0) < -9999) { i = f; return }
            if ((a[51720 + b | 0] | 0) != 0) { i = f; return }
            b = (a[d] | 0) == 42;
            h = c[t >> 2] | 0;
            if (!b) { Oa(1200, 5, 1, h | 0) | 0 }
            j = g;
            c[j >> 2] = e;
            c[j + 4 >> 2] = 0;
            Qb(h | 0, d + (b & 1) | 0, g | 0) | 0;
            Ma(h | 0) | 0;
            i = f;
            return
        }

        function Zk(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0;
            f = i;
            i = i + 16 | 0;
            g = f | 0;
            h = (a[d] | 0) == 42;
            j = c[t >> 2] | 0;
            if (!h) { Oa(14208, 6, 1, j | 0) | 0 }
            k = g;
            c[k >> 2] = e;
            c[k + 4 >> 2] = 0;
            Qb(b | 0, d + (h & 1) | 0, g | 0) | 0;
            Ma(j | 0) | 0;
            i = f;
            return
        }

        function _k(d, e, f) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            g = nd(f, 4) | 0;
            c[d >> 2] = g;
            if ((g | 0) > 15) { h = 8; return h | 0 }
            od(f, 2);
            g = nd(f, 6) | 0;
            c[d + 4 >> 2] = g + 1;
            if ((g | 0) > 62) { h = 8; return h | 0 }
            g = nd(f, 3) | 0;
            i = d + 8 | 0;
            c[i >> 2] = g + 1;
            if ((g | 0) > 6) { h = 8; return h | 0 }
            g = nd(f, 1) | 0;
            c[d + 12 >> 2] = g;
            od(f, 16);
            $k(d + 16 | 0, f, c[i >> 2] | 0);
            g = nd(f, 1) | 0;
            j = d + 484 | 0;
            c[j >> 2] = g;
            k = c[i >> 2] | 0;
            if ((g | 0) == 0) {
                l = k - 1 | 0;
                m = 7
            } else {
                if ((k | 0) > 0) {
                    l = 0;
                    m = 7
                }
            }
            do {
                if ((m | 0) == 7) {
                    k = l;
                    while (1) {
                        g = qd(f) | 0;
                        n = d + 488 + (k * 12 | 0) | 0;
                        c[n >> 2] = g;
                        g = qd(f) | 0;
                        o = d + 488 + (k * 12 | 0) + 4 | 0;
                        c[o >> 2] = g;
                        g = qd(f) | 0;
                        c[d + 488 + (k * 12 | 0) + 8 >> 2] = g;
                        if ((c[n >> 2] | 0) == -99999) {
                            h = 8;
                            m = 52;
                            break
                        }
                        n = k + 1 | 0;
                        if ((c[o >> 2] | 0) == -99999 | (g | 0) == -99999) {
                            h = 8;
                            m = 52;
                            break
                        }
                        if ((n | 0) < (c[i >> 2] | 0)) { k = n } else { m = 11; break }
                    }
                    if ((m | 0) == 11) {
                        if ((c[j >> 2] | 0) != 0) { break }
                        if ((l | 0) >= 8) { ec(11472, 14120, 144, 17416); return 0 }
                        if ((l | 0) <= 0) { break }
                        k = d + 488 + (l * 12 | 0) | 0;
                        n = d + 488 + (l * 12 | 0) + 4 | 0;
                        g = d + 488 + (l * 12 | 0) + 8 | 0;
                        o = 0;
                        do {
                            c[d + 488 + (o * 12 | 0) >> 2] = c[k >> 2];
                            c[d + 488 + (o * 12 | 0) + 4 >> 2] = c[n >> 2];
                            c[d + 488 + (o * 12 | 0) + 8 >> 2] = c[g >> 2];
                            o = o + 1 | 0;
                        } while ((o | 0) < (l | 0))
                    } else if ((m | 0) == 52) { return h | 0 }
                }
            } while (0);
            m = (nd(f, 6) | 0) & 255;
            l = d + 584 | 0;
            a[l] = m;
            m = qd(f) | 0;
            j = d + 588 | 0;
            c[j >> 2] = m;
            i = m + 1 | 0;
            if ((i | 0) < 0 | (m | 0) > 1022 | (m | 0) == -99999) {
                Ue(e, 8, 0);
                h = 8;
                return h | 0
            }
            c[j >> 2] = i;
            e = d + 592 | 0;
            m = d + 596 | 0;
            o = c[m >> 2] | 0;
            g = e | 0;
            n = c[g >> 2] | 0;
            k = (o - n | 0) / 12 | 0;
            do {
                if (k >>> 0 < i >>> 0) { jl(e, i - k | 0) } else {
                    if (!(k >>> 0 > i >>> 0)) { break }
                    p = n + (i * 12 | 0) | 0;
                    if ((o | 0) == (p | 0)) { break } else { q = o }
                    while (1) {
                        r = q - 12 | 0;
                        c[m >> 2] = r;
                        s = c[r >> 2] | 0;
                        if ((s | 0) == 0) { t = r } else {
                            Pu(s);
                            t = c[m >> 2] | 0
                        }
                        if ((t | 0) == (p | 0)) { break } else { q = t }
                    }
                }
            } while (0);
            a: do {
                if ((c[j >> 2] | 0) >= 2) {
                    t = 1;
                    q = a[l] | 0;
                    while (1) {
                        al((c[g >> 2] | 0) + (t * 12 | 0) | 0, (q & 255) + 1 | 0, 0);
                        m = 0;
                        while (1) {
                            o = (c[(c[g >> 2] | 0) + (t * 12 | 0) >> 2] | 0) + (m >>> 5 << 2) | 0;
                            i = 1 << (m & 31);
                            if ((nd(f, 1) | 0) == 0) { u = c[o >> 2] & ~i } else { u = c[o >> 2] | i }
                            c[o >> 2] = u;
                            v = a[l] | 0;
                            if ((m | 0) < (v & 255 | 0)) { m = m + 1 | 0 } else { break }
                        }
                        if ((t | 0) >= ((c[j >> 2] | 0) - 1 | 0)) { break a }
                        t = t + 1 | 0;
                        q = v
                    }
                }
            } while (0);
            v = (nd(f, 1) | 0) & 255;
            a[d + 604 | 0] = v;
            do {
                if (!(v << 24 >> 24 == 0)) {
                    j = nd(f, 32) | 0;
                    c[d + 608 >> 2] = j;
                    j = nd(f, 32) | 0;
                    c[d + 612 >> 2] = j;
                    j = (nd(f, 1) | 0) & 255;
                    a[d + 616 | 0] = j;
                    if (j << 24 >> 24 == 0) { break }
                    j = (qd(f) | 0) + 1 | 0;
                    c[d + 620 >> 2] = j;
                    j = qd(f) | 0;
                    l = d + 624 | 0;
                    c[l >> 2] = j;
                    if ((j | 0) > 1023) { ec(8432, 14120, 189, 17416); return 0 }
                    u = d + 628 | 0;
                    g = d + 632 | 0;
                    q = c[g >> 2] | 0;
                    t = u | 0;
                    m = c[t >> 2] | 0;
                    o = q - m >> 1;
                    do {
                        if (o >>> 0 < j >>> 0) {
                            gl(u, j - o | 0);
                            w = c[l >> 2] | 0
                        } else {
                            if (!(o >>> 0 > j >>> 0)) { w = j; break }
                            i = m + (j << 1) | 0;
                            if ((q | 0) == (i | 0)) { w = j; break }
                            c[g >> 2] = q + (~((q - 2 + (-i | 0) | 0) >>> 1) << 1);
                            w = j
                        }
                    } while (0);
                    j = d + 640 | 0;
                    q = d + 644 | 0;
                    g = c[q >> 2] | 0;
                    m = c[j >> 2] | 0;
                    o = g - m | 0;
                    do {
                        if (o >>> 0 < w >>> 0) {
                            fl(j, w - o | 0);
                            x = c[l >> 2] | 0
                        } else {
                            if (!(o >>> 0 > w >>> 0)) { x = w; break }
                            u = m + w | 0;
                            if ((g | 0) == (u | 0)) { x = w; break }
                            c[q >> 2] = u;
                            x = w
                        }
                    } while (0);
                    if ((x | 0) <= 0) { break }
                    q = (qd(f) | 0) & 65535;
                    b[c[t >> 2] >> 1] = q;
                    h = 0;
                    return h | 0
                }
            } while (0);
            x = (nd(f, 1) | 0) & 255;
            a[d + 652 | 0] = x;
            h = 0;
            return h | 0
        }

        function $k(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            a[b | 0] = 1;
            a[b + 44 | 0] = 1;
            bl(b | 0, c);
            e = d - 1 | 0;
            f = (e | 0) > 0;
            if (f) {
                g = 0;
                do {
                    h = (nd(c, 1) | 0) & 255;
                    a[b + 52 + (g * 52 | 0) | 0] = h;
                    h = (nd(c, 1) | 0) & 255;
                    a[b + 52 + (g * 52 | 0) + 44 | 0] = h;
                    g = g + 1 | 0;
                } while ((g | 0) < (e | 0))
            }
            if ((d - 2 | 0) >>> 0 < 7 >>> 0) {
                d = e;
                do {
                    od(c, 2);
                    d = d + 1 | 0;
                } while ((d | 0) < 8)
            }
            if (f) { i = 0 } else { return }
            do {
                bl(b + 52 + (i * 52 | 0) | 0, c);
                i = i + 1 | 0;
            } while ((i | 0) < (e | 0));
            return
        }

        function al(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            e = i;
            i = i + 24 | 0;
            f = e | 0;
            g = e + 16 | 0;
            h = g;
            j = a + 4 | 0;
            k = c[j >> 2] | 0;
            if (!(k >>> 0 < b >>> 0)) {
                c[j >> 2] = b;
                i = e;
                return
            }
            l = a + 8 | 0;
            m = c[l >> 2] | 0;
            n = m << 5;
            o = b - k | 0;
            do {
                if (o >>> 0 > n >>> 0 | k >>> 0 > (n - o | 0) >>> 0) {
                    p = f | 0;
                    c[p >> 2] = 0;
                    q = f + 4 | 0;
                    c[q >> 2] = 0;
                    r = f + 8 | 0;
                    c[r >> 2] = 0;
                    if ((b | 0) < 0) { Nr(0) }
                    if (n >>> 0 > 1073741822 >>> 0) { s = 2147483647 } else {
                        t = m << 6;
                        u = b + 31 & -32;
                        s = t >>> 0 < u >>> 0 ? u : t
                    }
                    hl(f, s);
                    t = c[j >> 2] | 0;
                    u = t + o | 0;
                    c[q >> 2] = u;
                    v = a | 0;
                    w = c[p >> 2] | 0;
                    do {
                        if ((t | 0) > 0) {
                            x = c[v >> 2] | 0;
                            y = t >>> 5;
                            fv(w | 0, x | 0, y << 2 | 0) | 0;
                            z = t - (y << 5) | 0;
                            A = w + (y << 2) | 0;
                            if ((z | 0) <= 0) {
                                B = A;
                                C = 0;
                                break
                            }
                            D = -1 >>> ((32 - z | 0) >>> 0);
                            c[A >> 2] = c[A >> 2] & ~D | c[x + (y << 2) >> 2] & D;
                            B = A;
                            C = z
                        } else {
                            B = w;
                            C = 0
                        }
                    } while (0);
                    c[g >> 2] = B;
                    c[h + 4 >> 2] = C;
                    t = c[g >> 2] | 0;
                    z = c[g + 4 >> 2] | 0;
                    A = c[v >> 2] | 0;
                    c[v >> 2] = w;
                    c[p >> 2] = A;
                    D = c[j >> 2] | 0;
                    c[j >> 2] = u;
                    c[q >> 2] = D;
                    D = c[l >> 2] | 0;
                    c[l >> 2] = c[r >> 2];
                    c[r >> 2] = D;
                    if ((A | 0) == 0) {
                        E = t;
                        F = z;
                        break
                    }
                    Pu(A);
                    E = t;
                    F = z
                } else {
                    z = (c[a >> 2] | 0) + (k >>> 5 << 2) | 0;
                    c[j >> 2] = b;
                    E = z;
                    F = k & 31
                }
            } while (0);
            if ((k | 0) == (b | 0)) { i = e; return }
            b = (F | 0) == 0;
            if (d) {
                if (b) {
                    G = o;
                    H = E
                } else {
                    d = 32 - F | 0;
                    k = d >>> 0 > o >>> 0 ? o : d;
                    c[E >> 2] = c[E >> 2] | -1 >>> ((d - k | 0) >>> 0) & -1 << F;
                    G = o - k | 0;
                    H = E + 4 | 0
                }
                k = G >>> 5;
                dv(H | 0, -1 | 0, k << 2 | 0) | 0;
                d = k << 5;
                if ((G | 0) == (d | 0)) { i = e; return }
                j = H + (k << 2) | 0;
                c[j >> 2] = c[j >> 2] | -1 >>> ((32 - G + d | 0) >>> 0);
                i = e;
                return
            } else {
                if (b) {
                    I = o;
                    J = E
                } else {
                    b = 32 - F | 0;
                    d = b >>> 0 > o >>> 0 ? o : b;
                    c[E >> 2] = c[E >> 2] & ~(-1 >>> ((b - d | 0) >>> 0) & -1 << F);
                    I = o - d | 0;
                    J = E + 4 | 0
                }
                E = I >>> 5;
                dv(J | 0, 0, E << 2 | 0) | 0;
                d = E << 5;
                if ((I | 0) == (d | 0)) { i = e; return }
                o = J + (E << 2) | 0;
                c[o >> 2] = c[o >> 2] & ~(-1 >>> ((32 - I + d | 0) >>> 0));
                i = e;
                return
            }
        }

        function bl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0;
            if ((a[b | 0] | 0) != 0) {
                e = (nd(d, 2) | 0) & 255;
                a[b + 1 | 0] = e;
                e = (nd(d, 1) | 0) & 255;
                a[b + 2 | 0] = e;
                e = nd(d, 5) | 0;
                c[b + 4 >> 2] = e;
                e = 0;
                f = (nd(d, 1) | 0) & 255;
                do {
                    a[b + 8 + e | 0] = f;
                    e = e + 1 | 0;
                    f = (nd(d, 1) | 0) & 255
                } while ((e | 0) < 32);
                a[b + 40 | 0] = f;
                f = (nd(d, 1) | 0) & 255;
                a[b + 41 | 0] = f;
                f = (nd(d, 1) | 0) & 255;
                a[b + 42 | 0] = f;
                f = (nd(d, 1) | 0) & 255;
                a[b + 43 | 0] = f;
                od(d, 44)
            }
            if ((a[b + 44 | 0] | 0) == 0) { return }
            f = nd(d, 8) | 0;
            c[b + 48 >> 2] = f;
            return
        }

        function cl(b, f) {
            b = b | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                r = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            if ((f | 0) == 2) { j = q } else if ((f | 0) == 1) { j = t } else { i = g; return }
            f = c[j >> 2] | 0;
            Zk(f, 2952, (j = i, i = i + 1 | 0, i = i + 7 & -8, c[j >> 2] = 0, j) | 0);
            i = j;
            Zk(f, 1624, (j = i, i = i + 8 | 0, c[j >> 2] = c[b >> 2], j) | 0);
            i = j;
            Zk(f, 928, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 4 >> 2], j) | 0);
            i = j;
            k = b + 8 | 0;
            Zk(f, 296, (j = i, i = i + 8 | 0, c[j >> 2] = c[k >> 2], j) | 0);
            i = j;
            Zk(f, 16768, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 12 >> 2], j) | 0);
            i = j;
            l = c[k >> 2] | 0;
            el(b + 16 | 0, 1, f);
            m = l - 1 | 0;
            if ((m | 0) > 0) {
                l = 0;
                do {
                    Zk(f, 6664, (j = i, i = i + 8 | 0, c[j >> 2] = l, j) | 0);
                    i = j;
                    el(b + 68 + (l * 52 | 0) | 0, 0, f);
                    l = l + 1 | 0;
                } while ((l | 0) < (m | 0))
            }
            m = b + 484 | 0;
            Zk(f, 16272, (j = i, i = i + 8 | 0, c[j >> 2] = c[m >> 2], j) | 0);
            i = j;
            do {
                if ((c[m >> 2] | 0) == 0) {
                    Zk(f, 14832, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 488 >> 2], j) | 0);
                    i = j;
                    Zk(f, 14568, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 492 >> 2], j) | 0);
                    i = j;
                    Zk(f, 14296, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 496 >> 2], j) | 0);
                    i = j
                } else {
                    if ((c[k >> 2] | 0) > 0) { n = 0 } else { break }
                    do {
                        l = c[b + 488 + (n * 12 | 0) >> 2] | 0;
                        Zk(f, 15912, (j = i, i = i + 16 | 0, c[j >> 2] = n, c[j + 8 >> 2] = l, j) | 0);
                        i = j;
                        Zk(f, 15488, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 488 + (n * 12 | 0) + 4 >> 2], j) | 0);
                        i = j;
                        Zk(f, 15120, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 488 + (n * 12 | 0) + 8 >> 2], j) | 0);
                        i = j;
                        n = n + 1 | 0;
                    } while ((n | 0) < (c[k >> 2] | 0))
                }
            } while (0);
            k = b + 584 | 0;
            Zk(f, 14056, (j = i, i = i + 8 | 0, c[j >> 2] = d[k] | 0, j) | 0);
            i = j;
            n = b + 588 | 0;
            Zk(f, 13768, (j = i, i = i + 8 | 0, c[j >> 2] = c[n >> 2], j) | 0);
            i = j;
            if ((c[n >> 2] | 0) >= 2) {
                m = b + 592 | 0;
                l = h | 0;
                o = h + 4 | 0;
                p = 1;
                while (1) {
                    r = 0;
                    while (1) {
                        c[l >> 2] = (c[(c[m >> 2] | 0) + (p * 12 | 0) >> 2] | 0) + (r >>> 5 << 2);
                        c[o >> 2] = 1 << (r & 31);
                        Zk(f, 13560, (j = i, i = i + 24 | 0, c[j >> 2] = p, c[j + 8 >> 2] = r, c[j + 16 >> 2] = c[h >> 2], c[j + 20 >> 2] = c[h + 4 >> 2], j) | 0);
                        i = j;
                        if ((r | 0) < (d[k] | 0)) { r = r + 1 | 0 } else { break }
                    }
                    if ((p | 0) < ((c[n >> 2] | 0) - 1 | 0)) { p = p + 1 | 0 } else { break }
                }
            }
            p = b + 604 | 0;
            Zk(f, 13368, (j = i, i = i + 8 | 0, c[j >> 2] = a[p] | 0, j) | 0);
            i = j;
            do {
                if ((a[p] | 0) != 0) {
                    Zk(f, 13168, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 608 >> 2], j) | 0);
                    i = j;
                    Zk(f, 12896, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 612 >> 2], j) | 0);
                    i = j;
                    n = b + 616 | 0;
                    Zk(f, 12608, (j = i, i = i + 8 | 0, c[j >> 2] = a[n] | 0, j) | 0);
                    i = j;
                    if ((a[n] | 0) == 0) { break }
                    Zk(f, 12368, (j = i, i = i + 8 | 0, c[j >> 2] = c[b + 620 >> 2], j) | 0);
                    i = j;
                    n = b + 624 | 0;
                    Zk(f, 12088, (j = i, i = i + 8 | 0, c[j >> 2] = c[n >> 2], j) | 0);
                    i = j;
                    if ((c[n >> 2] | 0) <= 0) { break }
                    n = e[c[b + 628 >> 2] >> 1] | 0;
                    Zk(f, 11712, (j = i, i = i + 16 | 0, c[j >> 2] = 0, c[j + 8 >> 2] = n, j) | 0);
                    i = j;
                    i = g;
                    return
                }
            } while (0);
            Zk(f, 11160, (j = i, i = i + 8 | 0, c[j >> 2] = a[b + 652 | 0] | 0, j) | 0);
            i = j;
            i = g;
            return
        }

        function dl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            e = i;
            el(a | 0, 1, d);
            f = b - 1 | 0;
            if ((f | 0) > 0) { g = 0 } else { i = e; return }
            do {
                Zk(d, 6664, (b = i, i = i + 8 | 0, c[b >> 2] = g, b) | 0);
                i = b;
                el(a + 52 + (g * 52 | 0) | 0, 0, d);
                g = g + 1 | 0;
            } while ((g | 0) < (f | 0));
            i = e;
            return
        }

        function el(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                j = 0,
                k = 0;
            f = i;
            g = d ? 10928 : 10664;
            if ((a[b | 0] | 0) != 0) {
                d = a[b + 1 | 0] | 0;
                Zk(e, 10376, (j = i, i = i + 16 | 0, c[j >> 2] = g, c[j + 8 >> 2] = d, j) | 0);
                i = j;
                d = a[b + 2 | 0] | 0;
                Zk(e, 10032, (j = i, i = i + 16 | 0, c[j >> 2] = g, c[j + 8 >> 2] = d, j) | 0);
                i = j;
                d = c[b + 4 >> 2] | 0;
                if ((d | 0) == 3) { k = 5976 } else if ((d | 0) == 4) { k = 5792 } else if ((d | 0) == 2) { k = 6208 } else if ((d | 0) == 1) { k = 6328 } else { k = 5624 }
                Zk(e, 9680, (j = i, i = i + 16 | 0, c[j >> 2] = g, c[j + 8 >> 2] = k, j) | 0);
                i = j;
                Zk(e, 9288, (j = i, i = i + 8 | 0, c[j >> 2] = g, j) | 0);
                i = j;
                k = 0;
                do {
                    if ((k | 0) != 0) {
                        Zk(e, 9008, (j = i, i = i + 1 | 0, i = i + 7 & -8, c[j >> 2] = 0, j) | 0);
                        i = j
                    }
                    Zk(e, 8608, (j = i, i = i + 8 | 0, c[j >> 2] = a[b + 8 + k | 0] | 0, j) | 0);
                    i = j;
                    k = k + 1 | 0;
                } while ((k | 0) < 32);
                Zk(e, 8376, (j = i, i = i + 1 | 0, i = i + 7 & -8, c[j >> 2] = 0, j) | 0);
                i = j;
                k = a[b + 40 | 0] | 0;
                Zk(e, 8112, (j = i, i = i + 16 | 0, c[j >> 2] = g, c[j + 8 >> 2] = k, j) | 0);
                i = j;
                k = a[b + 41 | 0] | 0;
                Zk(e, 7872, (j = i, i = i + 16 | 0, c[j >> 2] = g, c[j + 8 >> 2] = k, j) | 0);
                i = j;
                k = a[b + 42 | 0] | 0;
                Zk(e, 7600, (j = i, i = i + 16 | 0, c[j >> 2] = g, c[j + 8 >> 2] = k, j) | 0);
                i = j;
                k = a[b + 43 | 0] | 0;
                Zk(e, 7296, (j = i, i = i + 16 | 0, c[j >> 2] = g, c[j + 8 >> 2] = k, j) | 0);
                i = j
            }
            if ((a[b + 44 | 0] | 0) == 0) { i = f; return }
            k = c[b + 48 >> 2] | 0;
            Zk(e, 6960, (j = i, i = i + 24 | 0, c[j >> 2] = g, c[j + 8 >> 2] = k, h[j + 16 >> 3] = +(k | 0) / 30.0, j) | 0);
            i = j;
            i = f;
            return
        }

        function fl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            e = b + 8 | 0;
            f = b + 4 | 0;
            g = c[f >> 2] | 0;
            h = c[e >> 2] | 0;
            i = g;
            if (!((h - i | 0) >>> 0 < d >>> 0)) {
                j = d;
                k = g;
                do {
                    if ((k | 0) == 0) { l = 0 } else {
                        a[k] = 0;
                        l = c[f >> 2] | 0
                    }
                    k = l + 1 | 0;
                    c[f >> 2] = k;
                    j = j - 1 | 0;
                } while ((j | 0) != 0);
                return
            }
            j = b | 0;
            b = c[j >> 2] | 0;
            k = i - b | 0;
            i = k + d | 0;
            if ((i | 0) < 0) { Nr(0) }
            l = h - b | 0;
            if (l >>> 0 < 1073741823 >>> 0) {
                b = l << 1;
                l = b >>> 0 < i >>> 0 ? i : b;
                if ((l | 0) == 0) {
                    m = 0;
                    n = 0
                } else {
                    o = l;
                    p = 9
                }
            } else {
                o = 2147483647;
                p = 9
            }
            if ((p | 0) == 9) {
                m = Nu(o) | 0;
                n = o
            }
            o = d;
            d = m + k | 0;
            do {
                if ((d | 0) == 0) { q = 0 } else {
                    a[d] = 0;
                    q = d
                }
                d = q + 1 | 0;
                o = o - 1 | 0;
            } while ((o | 0) != 0);
            o = c[j >> 2] | 0;
            q = (c[f >> 2] | 0) - o | 0;
            p = m + (k - q) | 0;
            cv(p | 0, o | 0, q) | 0;
            c[j >> 2] = p;
            c[f >> 2] = d;
            c[e >> 2] = m + n;
            if ((o | 0) == 0) { return }
            Pu(o);
            return
        }

        function gl(a, d) {
            a = a | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            e = a + 8 | 0;
            f = a + 4 | 0;
            g = c[f >> 2] | 0;
            h = c[e >> 2] | 0;
            i = g;
            if (!(h - i >> 1 >>> 0 < d >>> 0)) {
                j = d;
                k = g;
                while (1) {
                    if ((k | 0) != 0) { b[k >> 1] = 0 }
                    l = j - 1 | 0;
                    if ((l | 0) == 0) { break } else {
                        j = l;
                        k = k + 2 | 0
                    }
                }
                c[f >> 2] = g + (d << 1);
                return
            }
            g = a | 0;
            a = c[g >> 2] | 0;
            k = a;
            j = i - k | 0;
            i = j >> 1;
            l = i + d | 0;
            if ((l | 0) < 0) { Nr(0) }
            m = h - k | 0;
            if (m >> 1 >>> 0 < 1073741823 >>> 0) {
                k = m >>> 0 < l >>> 0 ? l : m;
                if ((k | 0) == 0) {
                    n = 0;
                    o = 0
                } else {
                    p = k;
                    q = 10
                }
            } else {
                p = 2147483647;
                q = 10
            }
            if ((q | 0) == 10) {
                n = Nu(p << 1) | 0;
                o = p
            }
            p = d;
            d = n + (i << 1) | 0;
            while (1) {
                if ((d | 0) != 0) { b[d >> 1] = 0 }
                i = p - 1 | 0;
                if ((i | 0) == 0) { break } else {
                    p = i;
                    d = d + 2 | 0
                }
            }
            d = a;
            cv(n | 0, d | 0, j) | 0;
            c[g >> 2] = n;
            c[f >> 2] = n + (l << 1);
            c[e >> 2] = n + (o << 1);
            if ((a | 0) == 0) { return }
            Pu(d);
            return
        }

        function hl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = i;
            i = i + 32 | 0;
            e = d | 0;
            f = d + 8 | 0;
            g = d + 16 | 0;
            h = a + 8 | 0;
            if (!(c[h >> 2] << 5 >>> 0 < b >>> 0)) { i = d; return }
            if ((b | 0) < 0) { Nr(0) }
            j = ((b - 1 | 0) >>> 5) + 1 | 0;
            b = Nu(j << 2) | 0;
            k = a | 0;
            l = c[k >> 2] | 0;
            m = a + 4 | 0;
            a = c[m >> 2] | 0;
            n = a >>> 5;
            o = a & 31;
            c[e >> 2] = l;
            c[e + 4 >> 2] = 0;
            c[f >> 2] = l + (n << 2);
            c[f + 4 >> 2] = o;
            c[g >> 2] = b;
            c[g + 4 >> 2] = 0;
            il(d + 24 | 0, e, f, g);
            g = c[k >> 2] | 0;
            c[k >> 2] = b;
            c[m >> 2] = n << 5 | o;
            c[h >> 2] = j;
            if ((g | 0) == 0) { i = d; return }
            Pu(g);
            i = d;
            return
        }

        function il(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            f = b | 0;
            g = c[f >> 2] | 0;
            h = c[b + 4 >> 2] | 0;
            b = (c[d + 4 >> 2] | 0) - h + ((c[d >> 2] | 0) - g << 3) | 0;
            if ((b | 0) <= 0) {
                i = c[e >> 2] | 0;
                j = a | 0;
                c[j >> 2] = i;
                k = a + 4 | 0;
                l = e + 4 | 0;
                m = c[l >> 2] | 0;
                c[k >> 2] = m;
                return
            }
            if ((h | 0) == 0) {
                n = b;
                o = g;
                p = e | 0
            } else {
                d = 32 - h | 0;
                q = (b | 0) < (d | 0) ? b : d;
                r = -1 >>> ((d - q | 0) >>> 0) & -1 << h;
                h = e | 0;
                d = c[h >> 2] | 0;
                c[d >> 2] = c[d >> 2] & ~r | c[g >> 2] & r;
                r = e + 4 | 0;
                g = (c[r >> 2] | 0) + q | 0;
                c[h >> 2] = d + (g >>> 5 << 2);
                c[r >> 2] = g & 31;
                g = (c[f >> 2] | 0) + 4 | 0;
                c[f >> 2] = g;
                n = b - q | 0;
                o = g;
                p = h
            }
            h = n >>> 5;
            fv(c[p >> 2] | 0, o | 0, h << 2 | 0) | 0;
            o = n - (h << 5) | 0;
            n = (c[p >> 2] | 0) + (h << 2) | 0;
            c[p >> 2] = n;
            if ((o | 0) <= 0) {
                i = n;
                j = a | 0;
                c[j >> 2] = i;
                k = a + 4 | 0;
                l = e + 4 | 0;
                m = c[l >> 2] | 0;
                c[k >> 2] = m;
                return
            }
            n = (c[f >> 2] | 0) + (h << 2) | 0;
            c[f >> 2] = n;
            f = -1 >>> ((32 - o | 0) >>> 0);
            h = c[p >> 2] | 0;
            c[h >> 2] = c[h >> 2] & ~f | c[n >> 2] & f;
            c[e + 4 >> 2] = o;
            i = h;
            j = a | 0;
            c[j >> 2] = i;
            k = a + 4 | 0;
            l = e + 4 | 0;
            m = c[l >> 2] | 0;
            c[k >> 2] = m;
            return
        }

        function jl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = a + 8 | 0;
            e = a + 4 | 0;
            f = c[e >> 2] | 0;
            g = c[d >> 2] | 0;
            h = f;
            if (!(((g - h | 0) / 12 | 0) >>> 0 < b >>> 0)) {
                i = b;
                j = f;
                do {
                    if ((j | 0) == 0) { k = 0 } else {
                        c[j >> 2] = 0;
                        c[j + 4 >> 2] = 0;
                        c[j + 8 >> 2] = 0;
                        k = c[e >> 2] | 0
                    }
                    j = k + 12 | 0;
                    c[e >> 2] = j;
                    i = i - 1 | 0;
                } while ((i | 0) != 0);
                return
            }
            i = a | 0;
            a = c[i >> 2] | 0;
            j = (h - a | 0) / 12 | 0;
            h = j + b | 0;
            if (h >>> 0 > 357913941 >>> 0) { Nr(0) }
            k = (g - a | 0) / 12 | 0;
            if (k >>> 0 < 178956970 >>> 0) {
                a = k << 1;
                k = a >>> 0 < h >>> 0 ? h : a;
                if ((k | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = k;
                    o = 9
                }
            } else {
                n = 357913941;
                o = 9
            }
            if ((o | 0) == 9) {
                l = Nu(n * 12 | 0) | 0;
                m = n
            }
            n = l + (j * 12 | 0) | 0;
            o = b;
            b = n;
            do {
                if ((b | 0) == 0) { p = 0 } else {
                    c[b >> 2] = 0;
                    c[b + 4 >> 2] = 0;
                    c[b + 8 >> 2] = 0;
                    p = b
                }
                b = p + 12 | 0;
                o = o - 1 | 0;
            } while ((o | 0) != 0);
            o = l + (m * 12 | 0) | 0;
            m = c[i >> 2] | 0;
            p = c[e >> 2] | 0;
            do {
                if ((p | 0) == (m | 0)) {
                    c[i >> 2] = n;
                    c[e >> 2] = b;
                    c[d >> 2] = o;
                    q = m
                } else {
                    k = j - 1 - (((p - 12 + (-m | 0) | 0) >>> 0) / 12 | 0) | 0;
                    a = p;
                    h = n;
                    while (1) {
                        g = a - 12 | 0;
                        f = g | 0;
                        c[h - 12 >> 2] = c[f >> 2];
                        r = a - 12 + 4 | 0;
                        c[h - 12 + 4 >> 2] = c[r >> 2];
                        s = a - 12 + 8 | 0;
                        c[h - 12 + 8 >> 2] = c[s >> 2];
                        c[f >> 2] = 0;
                        c[r >> 2] = 0;
                        c[s >> 2] = 0;
                        if ((g | 0) == (m | 0)) { break } else {
                            a = g;
                            h = h - 12 | 0
                        }
                    }
                    h = c[i >> 2] | 0;
                    a = c[e >> 2] | 0;
                    c[i >> 2] = l + (k * 12 | 0);
                    c[e >> 2] = b;
                    c[d >> 2] = o;
                    if ((a | 0) == (h | 0)) { q = h; break } else { t = a }
                    while (1) {
                        a = t - 12 | 0;
                        g = c[a >> 2] | 0;
                        if ((g | 0) != 0) { Pu(g) }
                        if ((a | 0) == (h | 0)) { q = h; break } else { t = a }
                    }
                }
            } while (0);
            if ((q | 0) == 0) { return }
            Pu(q);
            return
        }

        function kl(d) {
            d = d | 0;
            a[d | 0] = 0;
            dv(d + 2 | 0, 0, 7) | 0;
            c[d + 12 >> 2] = 5;
            a[d + 16 | 0] = 0;
            a[d + 17 | 0] = 0;
            a[d + 18 | 0] = 2;
            a[d + 19 | 0] = 2;
            a[d + 20 | 0] = 2;
            c[d + 48 >> 2] = 0;
            c[d + 52 >> 2] = 0;
            a[d + 56 | 0] = 0;
            dv(d + 21 | 0, 0, 24) | 0;
            c[d + 60 >> 2] = 1;
            a[d + 64 | 0] = 0;
            a[d + 65 | 0] = 0;
            a[d + 66 | 0] = 0;
            a[d + 67 | 0] = 1;
            a[d + 68 | 0] = 0;
            b[d + 70 >> 1] = 0;
            a[d + 72 | 0] = 2;
            a[d + 73 | 0] = 1;
            a[d + 74 | 0] = 15;
            a[d + 75 | 0] = 15;
            return
        }

        function ll(d, e, f, g) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            g = (nd(f, 1) | 0) != 0;
            a[d | 0] = g & 1;
            do {
                if (g) {
                    h = nd(f, 8) | 0;
                    if ((h | 0) < 18) {
                        b[d + 2 >> 1] = b[30800 + (h << 2) >> 1] | 0;
                        b[d + 4 >> 1] = b[30802 + (h << 2) >> 1] | 0;
                        break
                    }
                    if ((h | 0) == 255) {
                        h = (nd(f, 16) | 0) & 65535;
                        b[d + 2 >> 1] = h;
                        h = (nd(f, 16) | 0) & 65535;
                        b[d + 4 >> 1] = h;
                        break
                    } else {
                        b[d + 2 >> 1] = 0;
                        b[d + 4 >> 1] = 0;
                        break
                    }
                } else {
                    b[d + 2 >> 1] = 0;
                    b[d + 4 >> 1] = 0
                }
            } while (0);
            g = (nd(f, 1) | 0) != 0;
            a[d + 6 | 0] = g & 1;
            if (g) {
                g = (nd(f, 1) | 0) != 0 | 0;
                a[d + 7 | 0] = g
            }
            g = d + 12 | 0;
            c[g >> 2] = 5;
            h = d + 16 | 0;
            a[h] = 0;
            i = d + 18 | 0;
            a[i] = 2;
            j = d + 19 | 0;
            a[j] = 2;
            k = d + 20 | 0;
            a[k] = 2;
            l = (nd(f, 1) | 0) != 0;
            a[d + 8 | 0] = l & 1;
            do {
                if (l) {
                    m = nd(f, 3) | 0;
                    c[g >> 2] = (m | 0) > 5 ? 5 : m;
                    m = (nd(f, 1) | 0) != 0 | 0;
                    a[h] = m;
                    m = (nd(f, 1) | 0) != 0;
                    a[d + 17 | 0] = m & 1;
                    if (!m) { break }
                    m = nd(f, 8) | 0;
                    a[i] = m;
                    n = m & 255;
                    if ((n | 0) == 0 | (n | 0) == 3) { o = 14 } else { if (n >>> 0 > 10 >>> 0) { o = 14 } }
                    if ((o | 0) == 14) { a[i] = 2 }
                    n = nd(f, 8) | 0;
                    a[j] = n;
                    m = n & 255;
                    if ((m | 0) == 0 | (m | 0) == 3) { o = 17 } else { if (m >>> 0 > 17 >>> 0) { o = 17 } }
                    if ((o | 0) == 17) { a[j] = 2 }
                    m = nd(f, 8) | 0;
                    n = m & 255;
                    a[k] = (n | 0) == 0 | n >>> 0 > 10 >>> 0 ? 2 : m & 255
                }
            } while (0);
            k = (nd(f, 1) | 0) != 0;
            a[d + 21 | 0] = k & 1;
            do {
                if (k) {
                    j = qd(f) | 0;
                    if ((j | 0) == -99999) {
                        Ue(e, 8, 0);
                        p = 8;
                        return p | 0
                    }
                    a[d + 22 | 0] = j;
                    j = qd(f) | 0;
                    if (!((j | 0) == -99999)) { a[d + 23 | 0] = j; break }
                    Ue(e, 8, 0);
                    p = 8;
                    return p | 0
                } else {
                    a[d + 22 | 0] = 0;
                    a[d + 23 | 0] = 0
                }
            } while (0);
            k = (nd(f, 1) | 0) != 0 | 0;
            a[d + 24 | 0] = k;
            k = (nd(f, 1) | 0) != 0 | 0;
            a[d + 25 | 0] = k;
            k = (nd(f, 1) | 0) != 0 | 0;
            a[d + 26 | 0] = k;
            k = (nd(f, 1) | 0) != 0;
            a[d + 27 | 0] = k & 1;
            do {
                if (k) {
                    j = qd(f) | 0;
                    if ((j | 0) == -99999) {
                        Ue(e, 8, 0);
                        p = 8;
                        return p | 0
                    }
                    c[d + 28 >> 2] = j;
                    j = qd(f) | 0;
                    if ((j | 0) == -99999) {
                        Ue(e, 8, 0);
                        p = 8;
                        return p | 0
                    }
                    c[d + 32 >> 2] = j;
                    j = qd(f) | 0;
                    if ((j | 0) == -99999) {
                        Ue(e, 8, 0);
                        p = 8;
                        return p | 0
                    }
                    c[d + 36 >> 2] = j;
                    j = qd(f) | 0;
                    if (!((j | 0) == -99999)) { c[d + 40 >> 2] = j; break }
                    Ue(e, 8, 0);
                    p = 8;
                    return p | 0
                } else { dv(d + 28 | 0, 0, 16) | 0 }
            } while (0);
            k = (nd(f, 1) | 0) != 0;
            a[d + 44 | 0] = k & 1;
            if (k) {
                k = nd(f, 32) | 0;
                c[d + 48 >> 2] = k;
                k = nd(f, 32) | 0;
                c[d + 52 >> 2] = k
            }
            k = (nd(f, 1) | 0) != 0 | 0;
            a[d + 56 | 0] = k;
            k = qd(f) | 0;
            if ((k | 0) == -99999) {
                Ue(e, 8, 0);
                p = 8;
                return p | 0
            }
            c[d + 60 >> 2] = k + 1;
            k = (nd(f, 1) | 0) != 0;
            a[d + 64 | 0] = k & 1;
            if (k) { p = 502; return p | 0 }
            k = (nd(f, 1) | 0) != 0;
            a[d + 65 | 0] = k & 1;
            if (!k) {
                a[d + 66 | 0] = 0;
                a[d + 67 | 0] = 1;
                a[d + 68 | 0] = 0;
                b[d + 70 >> 1] = 0;
                a[d + 72 | 0] = 2;
                a[d + 73 | 0] = 1;
                a[d + 74 | 0] = 15;
                a[d + 75 | 0] = 15;
                p = 0;
                return p | 0
            }
            k = (nd(f, 1) | 0) != 0 | 0;
            a[d + 66 | 0] = k;
            k = (nd(f, 1) | 0) != 0 | 0;
            a[d + 67 | 0] = k;
            k = (nd(f, 1) | 0) != 0 | 0;
            a[d + 68 | 0] = k;
            k = qd(f) | 0;
            if ((k | 0) == -99999) {
                Ue(e, 8, 0);
                p = 8;
                return p | 0
            }
            j = d + 70 | 0;
            b[j >> 1] = k;
            if ((k & 61440) >>> 0 > 4095 >>> 0) {
                Ue(e, 8, 0);
                b[j >> 1] = 0
            }
            j = qd(f) | 0;
            if ((j | 0) == -99999) {
                Ue(e, 8, 0);
                p = 8;
                return p | 0
            }
            k = d + 72 | 0;
            a[k] = j;
            if ((j & 255) >>> 0 > 16 >>> 0) {
                Ue(e, 8, 0);
                a[k] = 2
            }
            k = qd(f) | 0;
            if ((k | 0) == -99999) {
                Ue(e, 8, 0);
                p = 8;
                return p | 0
            }
            j = d + 73 | 0;
            a[j] = k;
            if ((k & 255) >>> 0 > 16 >>> 0) {
                Ue(e, 8, 0);
                a[j] = 1
            }
            j = qd(f) | 0;
            if ((j | 0) == -99999) {
                Ue(e, 8, 0);
                p = 8;
                return p | 0
            }
            k = d + 74 | 0;
            a[k] = j;
            if ((j & 240) >>> 0 > 15 >>> 0) {
                Ue(e, 8, 0);
                a[k] = 15
            }
            k = qd(f) | 0;
            if ((k | 0) == -99999) {
                Ue(e, 8, 0);
                p = 8;
                return p | 0
            }
            f = d + 75 | 0;
            a[f] = k;
            if (!((k & 240) >>> 0 > 15 >>> 0)) { p = 0; return p | 0 }
            Ue(e, 8, 0);
            a[f] = 15;
            p = 0;
            return p | 0
        }

        function ml(b, f) {
            b = b | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0;
            g = i;
            if ((f | 0) == 2) { h = q } else if ((f | 0) == 1) { h = t } else { i = g; return }
            f = c[h >> 2] | 0;
            Zk(f, 2832, (h = i, i = i + 1 | 0, i = i + 7 & -8, c[h >> 2] = 0, h) | 0);
            i = h;
            j = e[b + 4 >> 1] | 0;
            Zk(f, 1504, (h = i, i = i + 16 | 0, c[h >> 2] = e[b + 2 >> 1] | 0, c[h + 8 >> 2] = j, h) | 0);
            i = h;
            Zk(f, 856, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 6 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 248, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 7 | 0] | 0, h) | 0);
            i = h;
            j = b + 8 | 0;
            Zk(f, 16688, (h = i, i = i + 8 | 0, c[h >> 2] = d[j] | 0, h) | 0);
            i = h;
            if ((a[j] | 0) != 0) {
                switch (c[b + 12 >> 2] | 0) {
                    case 2:
                        { k = 11320; break };
                    case 3:
                        { k = 8288; break };
                    case 1:
                        { k = 13944; break };
                    case 4:
                        { k = 5936; break };
                    case 0:
                        { k = 672; break };
                    default:
                        { k = 4136 }
                }
                Zk(f, 16216, (h = i, i = i + 8 | 0, c[h >> 2] = k, h) | 0);
                i = h;
                Zk(f, 15832, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 16 | 0] | 0, h) | 0);
                i = h;
                Zk(f, 15432, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 17 | 0] | 0, h) | 0);
                i = h;
                Zk(f, 15080, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 18 | 0] | 0, h) | 0);
                i = h;
                Zk(f, 14792, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 19 | 0] | 0, h) | 0);
                i = h;
                Zk(f, 14488, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 20 | 0] | 0, h) | 0);
                i = h
            }
            k = b + 21 | 0;
            Zk(f, 14232, (h = i, i = i + 8 | 0, c[h >> 2] = d[k] | 0, h) | 0);
            i = h;
            if ((a[k] | 0) != 0) {
                Zk(f, 14008, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 22 | 0] | 0, h) | 0);
                i = h;
                Zk(f, 13720, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 23 | 0] | 0, h) | 0);
                i = h
            }
            Zk(f, 13520, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 24 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 13328, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 25 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 13120, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 26 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 12856, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 27 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 12568, (h = i, i = i + 8 | 0, c[h >> 2] = c[b + 28 >> 2], h) | 0);
            i = h;
            Zk(f, 12328, (h = i, i = i + 8 | 0, c[h >> 2] = c[b + 32 >> 2], h) | 0);
            i = h;
            Zk(f, 12048, (h = i, i = i + 8 | 0, c[h >> 2] = c[b + 36 >> 2], h) | 0);
            i = h;
            Zk(f, 11664, (h = i, i = i + 8 | 0, c[h >> 2] = c[b + 40 >> 2], h) | 0);
            i = h;
            k = b + 44 | 0;
            Zk(f, 11392, (h = i, i = i + 8 | 0, c[h >> 2] = d[k] | 0, h) | 0);
            i = h;
            if ((a[k] | 0) != 0) {
                Zk(f, 11120, (h = i, i = i + 8 | 0, c[h >> 2] = c[b + 48 >> 2], h) | 0);
                i = h;
                Zk(f, 10888, (h = i, i = i + 8 | 0, c[h >> 2] = c[b + 52 >> 2], h) | 0);
                i = h
            }
            Zk(f, 10616, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 56 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 10328, (h = i, i = i + 8 | 0, c[h >> 2] = c[b + 60 >> 2], h) | 0);
            i = h;
            Zk(f, 9992, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 64 | 0] | 0, h) | 0);
            i = h;
            k = b + 65 | 0;
            Zk(f, 9632, (h = i, i = i + 8 | 0, c[h >> 2] = d[k] | 0, h) | 0);
            i = h;
            if ((a[k] | 0) == 0) { i = g; return }
            Zk(f, 9240, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 66 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 8960, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 67 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 8560, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 68 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 8328, (h = i, i = i + 8 | 0, c[h >> 2] = e[b + 70 >> 1] | 0, h) | 0);
            i = h;
            Zk(f, 8064, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 72 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 7824, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 73 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 7552, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 74 | 0] | 0, h) | 0);
            i = h;
            Zk(f, 7248, (h = i, i = i + 8 | 0, c[h >> 2] = d[b + 75 | 0] | 0, h) | 0);
            i = h;
            i = g;
            return
        }

        function nl(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0;
            b = i;
            i = i + 32 | 0;
            d = b | 0;
            e = b + 8 | 0;
            f = b + 16 | 0;
            g = b + 24 | 0;
            h = c[o >> 2] | 0;
            Jl(34232, h, 34360);
            c[8806] = 21516;
            c[8808] = 21536;
            c[8807] = 0;
            Mm(35232, 34232);
            c[8826] = 0;
            c[8827] = -1;
            j = c[t >> 2] | 0;
            c[8534] = 21296;
            Tr(34140);
            dv(34144, 0, 24) | 0;
            c[8534] = 21664;
            c[8542] = j;
            Ur(g, 34140);
            k = Wr(g, 34560) | 0;
            l = k;
            Vr(g);
            c[8543] = l;
            c[8544] = 34368;
            g = (Fc[c[(c[k >> 2] | 0) + 28 >> 2] & 255](l) | 0) & 1;
            a[34180] = g;
            c[8740] = 21420;
            c[8741] = 21440;
            Mm(34964, 34136);
            c[8759] = 0;
            c[8760] = -1;
            g = c[q >> 2] | 0;
            c[8546] = 21296;
            Tr(34188);
            dv(34192, 0, 24) | 0;
            c[8546] = 21664;
            c[8554] = g;
            Ur(f, 34188);
            l = Wr(f, 34560) | 0;
            k = l;
            Vr(f);
            c[8555] = k;
            c[8556] = 34376;
            f = (Fc[c[(c[l >> 2] | 0) + 28 >> 2] & 255](k) | 0) & 1;
            a[34228] = f;
            c[8784] = 21420;
            c[8785] = 21440;
            Mm(35140, 34184);
            c[8803] = 0;
            c[8804] = -1;
            f = c[(c[(c[8784] | 0) - 12 >> 2] | 0) + 35160 >> 2] | 0;
            c[8762] = 21420;
            c[8763] = 21440;
            Mm(35052, f);
            c[8781] = 0;
            c[8782] = -1;
            c[(c[(c[8806] | 0) - 12 >> 2] | 0) + 35296 >> 2] = 34960;
            f = (c[(c[8784] | 0) - 12 >> 2] | 0) + 35140 | 0;
            c[f >> 2] = c[f >> 2] | 8192;
            c[(c[(c[8784] | 0) - 12 >> 2] | 0) + 35208 >> 2] = 34960;
            vl(34080, h, 34384);
            c[8718] = 21468;
            c[8720] = 21488;
            c[8719] = 0;
            Mm(34880, 34080);
            c[8738] = 0;
            c[8739] = -1;
            c[8496] = 21224;
            Tr(33988);
            dv(33992, 0, 24) | 0;
            c[8496] = 21592;
            c[8504] = j;
            Ur(e, 33988);
            j = Wr(e, 34552) | 0;
            h = j;
            Vr(e);
            c[8505] = h;
            c[8506] = 34392;
            e = (Fc[c[(c[j >> 2] | 0) + 28 >> 2] & 255](h) | 0) & 1;
            a[34028] = e;
            c[8648] = 21372;
            c[8649] = 21392;
            Mm(34596, 33984);
            c[8667] = 0;
            c[8668] = -1;
            c[8508] = 21224;
            Tr(34036);
            dv(34040, 0, 24) | 0;
            c[8508] = 21592;
            c[8516] = g;
            Ur(d, 34036);
            g = Wr(d, 34552) | 0;
            e = g;
            Vr(d);
            c[8517] = e;
            c[8518] = 34400;
            d = (Fc[c[(c[g >> 2] | 0) + 28 >> 2] & 255](e) | 0) & 1;
            a[34076] = d;
            c[8692] = 21372;
            c[8693] = 21392;
            Mm(34772, 34032);
            c[8711] = 0;
            c[8712] = -1;
            d = c[(c[(c[8692] | 0) - 12 >> 2] | 0) + 34792 >> 2] | 0;
            c[8670] = 21372;
            c[8671] = 21392;
            Mm(34684, d);
            c[8689] = 0;
            c[8690] = -1;
            c[(c[(c[8718] | 0) - 12 >> 2] | 0) + 34944 >> 2] = 34592;
            d = (c[(c[8692] | 0) - 12 >> 2] | 0) + 34772 | 0;
            c[d >> 2] = c[d >> 2] | 8192;
            c[(c[(c[8692] | 0) - 12 >> 2] | 0) + 34840 >> 2] = 34592;
            i = b;
            return
        }

        function ol(a) {
            a = a | 0;
            sn(34960) | 0;
            sn(35048) | 0;
            xn(34592) | 0;
            xn(34680) | 0;
            return
        }

        function pl(a) {
            a = a | 0;
            c[a >> 2] = 21224;
            Vr(a + 4 | 0);
            return
        }

        function ql(a) {
            a = a | 0;
            c[a >> 2] = 21224;
            Vr(a + 4 | 0);
            Pu(a);
            return
        }

        function rl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0;
            Fc[c[(c[b >> 2] | 0) + 24 >> 2] & 255](b) | 0;
            e = Wr(d, 34552) | 0;
            d = e;
            c[b + 36 >> 2] = d;
            f = (Fc[c[(c[e >> 2] | 0) + 28 >> 2] & 255](d) | 0) & 1;
            a[b + 44 | 0] = f;
            return
        }

        function sl(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            b = i;
            i = i + 16 | 0;
            d = b | 0;
            e = b + 8 | 0;
            f = a + 36 | 0;
            g = a + 40 | 0;
            h = d | 0;
            j = d + 8 | 0;
            k = d;
            d = a + 32 | 0;
            while (1) {
                a = c[f >> 2] | 0;
                l = Gc[c[(c[a >> 2] | 0) + 20 >> 2] & 31](a, c[g >> 2] | 0, h, j, e) | 0;
                a = (c[e >> 2] | 0) - k | 0;
                if ((Oa(h | 0, 1, a | 0, c[d >> 2] | 0) | 0) != (a | 0)) {
                    m = -1;
                    n = 5;
                    break
                }
                if ((l | 0) == 2) {
                    m = -1;
                    n = 5;
                    break
                } else if ((l | 0) != 1) { n = 4; break }
            }
            if ((n | 0) == 4) {
                m = ((Ma(c[d >> 2] | 0) | 0) != 0) << 31 >> 31;
                i = b;
                return m | 0
            } else if ((n | 0) == 5) { i = b; return m | 0 }
            return 0
        }

        function tl(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            if ((a[b + 44 | 0] | 0) != 0) { f = Oa(d | 0, 4, e | 0, c[b + 32 >> 2] | 0) | 0; return f | 0 }
            g = b;
            if ((e | 0) > 0) {
                h = d;
                i = 0
            } else { f = 0; return f | 0 }
            while (1) {
                if ((Qc[c[(c[g >> 2] | 0) + 52 >> 2] & 63](b, c[h >> 2] | 0) | 0) == -1) {
                    f = i;
                    j = 6;
                    break
                }
                d = i + 1 | 0;
                if ((d | 0) < (e | 0)) {
                    h = h + 4 | 0;
                    i = d
                } else {
                    f = d;
                    j = 6;
                    break
                }
            }
            if ((j | 0) == 6) { return f | 0 }
            return 0
        }

        function ul(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            e = i;
            i = i + 32 | 0;
            f = e | 0;
            g = e + 8 | 0;
            h = e + 16 | 0;
            j = e + 24 | 0;
            k = (d | 0) == -1;
            a: do {
                if (!k) {
                    c[g >> 2] = d;
                    if ((a[b + 44 | 0] | 0) != 0) {
                        if ((Oa(g | 0, 4, 1, c[b + 32 >> 2] | 0) | 0) == 1) { break } else { l = -1 }
                        i = e;
                        return l | 0
                    }
                    m = f | 0;
                    c[h >> 2] = m;
                    n = g + 4 | 0;
                    o = b + 36 | 0;
                    p = b + 40 | 0;
                    q = f + 8 | 0;
                    r = f;
                    s = b + 32 | 0;
                    t = g;
                    while (1) {
                        u = c[o >> 2] | 0;
                        v = Vc[c[(c[u >> 2] | 0) + 12 >> 2] & 31](u, c[p >> 2] | 0, t, n, j, m, q, h) | 0;
                        if ((c[j >> 2] | 0) == (t | 0)) {
                            l = -1;
                            w = 12;
                            break
                        }
                        if ((v | 0) == 3) { w = 7; break }
                        u = (v | 0) == 1;
                        if (!(v >>> 0 < 2 >>> 0)) {
                            l = -1;
                            w = 12;
                            break
                        }
                        v = (c[h >> 2] | 0) - r | 0;
                        if ((Oa(m | 0, 1, v | 0, c[s >> 2] | 0) | 0) != (v | 0)) {
                            l = -1;
                            w = 12;
                            break
                        }
                        if (u) { t = u ? c[j >> 2] | 0 : t } else { break a }
                    }
                    if ((w | 0) == 7) {
                        if ((Oa(t | 0, 1, 1, c[s >> 2] | 0) | 0) == 1) { break } else { l = -1 }
                        i = e;
                        return l | 0
                    } else if ((w | 0) == 12) { i = e; return l | 0 }
                }
            } while (0);
            l = k ? 0 : d;
            i = e;
            return l | 0
        }

        function vl(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            h = b | 0;
            c[h >> 2] = 21224;
            j = b + 4 | 0;
            Tr(j);
            dv(b + 8 | 0, 0, 24) | 0;
            c[h >> 2] = 21992;
            c[b + 32 >> 2] = d;
            c[b + 40 >> 2] = e;
            c[b + 48 >> 2] = -1;
            a[b + 52 | 0] = 0;
            Ur(g, j);
            j = Wr(g, 34552) | 0;
            e = j;
            d = b + 36 | 0;
            c[d >> 2] = e;
            h = Fc[c[(c[j >> 2] | 0) + 24 >> 2] & 255](e) | 0;
            e = b + 44 | 0;
            c[e >> 2] = h;
            h = c[d >> 2] | 0;
            d = (Fc[c[(c[h >> 2] | 0) + 28 >> 2] & 255](h) | 0) & 1;
            a[b + 53 | 0] = d;
            if ((c[e >> 2] | 0) <= 8) {
                Vr(g);
                i = f;
                return
            }
            dr(736);
            Vr(g);
            i = f;
            return
        }

        function wl(a) {
            a = a | 0;
            c[a >> 2] = 21224;
            Vr(a + 4 | 0);
            return
        }

        function xl(a) {
            a = a | 0;
            c[a >> 2] = 21224;
            Vr(a + 4 | 0);
            Pu(a);
            return
        }

        function yl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            e = Wr(d, 34552) | 0;
            d = e;
            f = b + 36 | 0;
            c[f >> 2] = d;
            g = Fc[c[(c[e >> 2] | 0) + 24 >> 2] & 255](d) | 0;
            d = b + 44 | 0;
            c[d >> 2] = g;
            g = c[f >> 2] | 0;
            f = (Fc[c[(c[g >> 2] | 0) + 28 >> 2] & 255](g) | 0) & 1;
            a[b + 53 | 0] = f;
            if ((c[d >> 2] | 0) <= 8) { return }
            dr(736);
            return
        }

        function zl(a) { a = a | 0; return Cl(a, 0) | 0 }

        function Al(a) { a = a | 0; return Cl(a, 1) | 0 }

        function Bl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            e = i;
            i = i + 32 | 0;
            f = e | 0;
            g = e + 8 | 0;
            h = e + 16 | 0;
            j = e + 24 | 0;
            k = b + 52 | 0;
            l = (a[k] | 0) != 0;
            if ((d | 0) == -1) {
                if (l) {
                    m = -1;
                    i = e;
                    return m | 0
                }
                n = c[b + 48 >> 2] | 0;
                a[k] = (n | 0) != -1 | 0;
                m = n;
                i = e;
                return m | 0
            }
            n = b + 48 | 0;
            a: do {
                if (l) {
                    c[h >> 2] = c[n >> 2];
                    o = c[b + 36 >> 2] | 0;
                    p = f | 0;
                    q = Vc[c[(c[o >> 2] | 0) + 12 >> 2] & 31](o, c[b + 40 >> 2] | 0, h, h + 4 | 0, j, p, f + 8 | 0, g) | 0;
                    if ((q | 0) == 3) {
                        a[p] = c[n >> 2];
                        c[g >> 2] = f + 1
                    } else if ((q | 0) == 2 | (q | 0) == 1) {
                        m = -1;
                        i = e;
                        return m | 0
                    }
                    q = b + 32 | 0;
                    while (1) {
                        o = c[g >> 2] | 0;
                        if (!(o >>> 0 > p >>> 0)) { break a }
                        r = o - 1 | 0;
                        c[g >> 2] = r;
                        if (($b(a[r] | 0, c[q >> 2] | 0) | 0) == -1) { m = -1; break }
                    }
                    i = e;
                    return m | 0
                }
            } while (0);
            c[n >> 2] = d;
            a[k] = 1;
            m = d;
            i = e;
            return m | 0
        }

        function Cl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0;
            e = i;
            i = i + 32 | 0;
            f = e | 0;
            g = e + 8 | 0;
            h = e + 16 | 0;
            j = e + 24 | 0;
            k = b + 52 | 0;
            if ((a[k] | 0) != 0) {
                l = b + 48 | 0;
                m = c[l >> 2] | 0;
                if (!d) {
                    n = m;
                    i = e;
                    return n | 0
                }
                c[l >> 2] = -1;
                a[k] = 0;
                n = m;
                i = e;
                return n | 0
            }
            m = c[b + 44 >> 2] | 0;
            k = (m | 0) > 1 ? m : 1;
            a: do {
                if ((k | 0) > 0) {
                    m = b + 32 | 0;
                    l = 0;
                    while (1) {
                        o = eb(c[m >> 2] | 0) | 0;
                        if ((o | 0) == -1) { n = -1; break }
                        a[f + l | 0] = o;
                        l = l + 1 | 0;
                        if ((l | 0) >= (k | 0)) { break a }
                    }
                    i = e;
                    return n | 0
                }
            } while (0);
            b: do {
                if ((a[b + 53 | 0] | 0) == 0) {
                    l = b + 40 | 0;
                    m = b + 36 | 0;
                    o = f | 0;
                    p = g + 4 | 0;
                    q = b + 32 | 0;
                    r = k;
                    while (1) {
                        s = c[l >> 2] | 0;
                        t = s;
                        u = c[t >> 2] | 0;
                        v = c[t + 4 >> 2] | 0;
                        t = c[m >> 2] | 0;
                        w = f + r | 0;
                        x = Vc[c[(c[t >> 2] | 0) + 16 >> 2] & 31](t, s, o, w, h, g, p, j) | 0;
                        if ((x | 0) == 3) { y = 14; break } else if ((x | 0) == 2) {
                            n = -1;
                            y = 22;
                            break
                        } else if ((x | 0) != 1) { z = r; break b }
                        x = c[l >> 2] | 0;
                        c[x >> 2] = u;
                        c[x + 4 >> 2] = v;
                        if ((r | 0) == 8) {
                            n = -1;
                            y = 22;
                            break
                        }
                        v = eb(c[q >> 2] | 0) | 0;
                        if ((v | 0) == -1) {
                            n = -1;
                            y = 22;
                            break
                        }
                        a[w] = v;
                        r = r + 1 | 0
                    }
                    if ((y | 0) == 14) {
                        c[g >> 2] = a[o] | 0;
                        z = r;
                        break
                    } else if ((y | 0) == 22) { i = e; return n | 0 }
                } else {
                    c[g >> 2] = a[f | 0] | 0;
                    z = k
                }
            } while (0);
            if (d) {
                d = c[g >> 2] | 0;
                c[b + 48 >> 2] = d;
                n = d;
                i = e;
                return n | 0
            }
            d = b + 32 | 0;
            b = z;
            while (1) {
                if ((b | 0) <= 0) { break }
                z = b - 1 | 0;
                if (($b(a[f + z | 0] | 0, c[d >> 2] | 0) | 0) == -1) {
                    n = -1;
                    y = 22;
                    break
                } else { b = z }
            }
            if ((y | 0) == 22) { i = e; return n | 0 }
            n = c[g >> 2] | 0;
            i = e;
            return n | 0
        }

        function Dl(a) {
            a = a | 0;
            c[a >> 2] = 21296;
            Vr(a + 4 | 0);
            return
        }

        function El(a) {
            a = a | 0;
            c[a >> 2] = 21296;
            Vr(a + 4 | 0);
            Pu(a);
            return
        }

        function Fl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0;
            Fc[c[(c[b >> 2] | 0) + 24 >> 2] & 255](b) | 0;
            e = Wr(d, 34560) | 0;
            d = e;
            c[b + 36 >> 2] = d;
            f = (Fc[c[(c[e >> 2] | 0) + 28 >> 2] & 255](d) | 0) & 1;
            a[b + 44 | 0] = f;
            return
        }

        function Gl(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            b = i;
            i = i + 16 | 0;
            d = b | 0;
            e = b + 8 | 0;
            f = a + 36 | 0;
            g = a + 40 | 0;
            h = d | 0;
            j = d + 8 | 0;
            k = d;
            d = a + 32 | 0;
            while (1) {
                a = c[f >> 2] | 0;
                l = Gc[c[(c[a >> 2] | 0) + 20 >> 2] & 31](a, c[g >> 2] | 0, h, j, e) | 0;
                a = (c[e >> 2] | 0) - k | 0;
                if ((Oa(h | 0, 1, a | 0, c[d >> 2] | 0) | 0) != (a | 0)) {
                    m = -1;
                    n = 5;
                    break
                }
                if ((l | 0) == 2) {
                    m = -1;
                    n = 5;
                    break
                } else if ((l | 0) != 1) { n = 4; break }
            }
            if ((n | 0) == 4) {
                m = ((Ma(c[d >> 2] | 0) | 0) != 0) << 31 >> 31;
                i = b;
                return m | 0
            } else if ((n | 0) == 5) { i = b; return m | 0 }
            return 0
        }

        function Hl(b, e, f) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            if ((a[b + 44 | 0] | 0) != 0) { g = Oa(e | 0, 1, f | 0, c[b + 32 >> 2] | 0) | 0; return g | 0 }
            h = b;
            if ((f | 0) > 0) {
                i = e;
                j = 0
            } else { g = 0; return g | 0 }
            while (1) {
                if ((Qc[c[(c[h >> 2] | 0) + 52 >> 2] & 63](b, d[i] | 0) | 0) == -1) {
                    g = j;
                    k = 6;
                    break
                }
                e = j + 1 | 0;
                if ((e | 0) < (f | 0)) {
                    i = i + 1 | 0;
                    j = e
                } else {
                    g = e;
                    k = 6;
                    break
                }
            }
            if ((k | 0) == 6) { return g | 0 }
            return 0
        }

        function Il(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            e = i;
            i = i + 32 | 0;
            f = e | 0;
            g = e + 8 | 0;
            h = e + 16 | 0;
            j = e + 24 | 0;
            k = (d | 0) == -1;
            a: do {
                if (!k) {
                    a[g] = d;
                    if ((a[b + 44 | 0] | 0) != 0) {
                        if ((Oa(g | 0, 1, 1, c[b + 32 >> 2] | 0) | 0) == 1) { break } else { l = -1 }
                        i = e;
                        return l | 0
                    }
                    m = f | 0;
                    c[h >> 2] = m;
                    n = g + 1 | 0;
                    o = b + 36 | 0;
                    p = b + 40 | 0;
                    q = f + 8 | 0;
                    r = f;
                    s = b + 32 | 0;
                    t = g;
                    while (1) {
                        u = c[o >> 2] | 0;
                        v = Vc[c[(c[u >> 2] | 0) + 12 >> 2] & 31](u, c[p >> 2] | 0, t, n, j, m, q, h) | 0;
                        if ((c[j >> 2] | 0) == (t | 0)) {
                            l = -1;
                            w = 12;
                            break
                        }
                        if ((v | 0) == 3) { w = 7; break }
                        u = (v | 0) == 1;
                        if (!(v >>> 0 < 2 >>> 0)) {
                            l = -1;
                            w = 12;
                            break
                        }
                        v = (c[h >> 2] | 0) - r | 0;
                        if ((Oa(m | 0, 1, v | 0, c[s >> 2] | 0) | 0) != (v | 0)) {
                            l = -1;
                            w = 12;
                            break
                        }
                        if (u) { t = u ? c[j >> 2] | 0 : t } else { break a }
                    }
                    if ((w | 0) == 7) {
                        if ((Oa(t | 0, 1, 1, c[s >> 2] | 0) | 0) == 1) { break } else { l = -1 }
                        i = e;
                        return l | 0
                    } else if ((w | 0) == 12) { i = e; return l | 0 }
                }
            } while (0);
            l = k ? 0 : d;
            i = e;
            return l | 0
        }

        function Jl(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            h = b | 0;
            c[h >> 2] = 21296;
            j = b + 4 | 0;
            Tr(j);
            dv(b + 8 | 0, 0, 24) | 0;
            c[h >> 2] = 22064;
            c[b + 32 >> 2] = d;
            c[b + 40 >> 2] = e;
            c[b + 48 >> 2] = -1;
            a[b + 52 | 0] = 0;
            Ur(g, j);
            j = Wr(g, 34560) | 0;
            e = j;
            d = b + 36 | 0;
            c[d >> 2] = e;
            h = Fc[c[(c[j >> 2] | 0) + 24 >> 2] & 255](e) | 0;
            e = b + 44 | 0;
            c[e >> 2] = h;
            h = c[d >> 2] | 0;
            d = (Fc[c[(c[h >> 2] | 0) + 28 >> 2] & 255](h) | 0) & 1;
            a[b + 53 | 0] = d;
            if ((c[e >> 2] | 0) <= 8) {
                Vr(g);
                i = f;
                return
            }
            dr(736);
            Vr(g);
            i = f;
            return
        }

        function Kl(a) {
            a = a | 0;
            c[a >> 2] = 21296;
            Vr(a + 4 | 0);
            return
        }

        function Ll(a) {
            a = a | 0;
            c[a >> 2] = 21296;
            Vr(a + 4 | 0);
            Pu(a);
            return
        }

        function Ml(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            e = Wr(d, 34560) | 0;
            d = e;
            f = b + 36 | 0;
            c[f >> 2] = d;
            g = Fc[c[(c[e >> 2] | 0) + 24 >> 2] & 255](d) | 0;
            d = b + 44 | 0;
            c[d >> 2] = g;
            g = c[f >> 2] | 0;
            f = (Fc[c[(c[g >> 2] | 0) + 28 >> 2] & 255](g) | 0) & 1;
            a[b + 53 | 0] = f;
            if ((c[d >> 2] | 0) <= 8) { return }
            dr(736);
            return
        }

        function Nl(a) { a = a | 0; return Ql(a, 0) | 0 }

        function Ol(a) { a = a | 0; return Ql(a, 1) | 0 }

        function Pl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            e = i;
            i = i + 32 | 0;
            f = e | 0;
            g = e + 8 | 0;
            h = e + 16 | 0;
            j = e + 24 | 0;
            k = b + 52 | 0;
            l = (a[k] | 0) != 0;
            if ((d | 0) == -1) {
                if (l) {
                    m = -1;
                    i = e;
                    return m | 0
                }
                n = c[b + 48 >> 2] | 0;
                a[k] = (n | 0) != -1 | 0;
                m = n;
                i = e;
                return m | 0
            }
            n = b + 48 | 0;
            a: do {
                if (l) {
                    a[h] = c[n >> 2];
                    o = c[b + 36 >> 2] | 0;
                    p = f | 0;
                    q = Vc[c[(c[o >> 2] | 0) + 12 >> 2] & 31](o, c[b + 40 >> 2] | 0, h, h + 1 | 0, j, p, f + 8 | 0, g) | 0;
                    if ((q | 0) == 2 | (q | 0) == 1) {
                        m = -1;
                        i = e;
                        return m | 0
                    } else if ((q | 0) == 3) {
                        a[p] = c[n >> 2];
                        c[g >> 2] = f + 1
                    }
                    q = b + 32 | 0;
                    while (1) {
                        o = c[g >> 2] | 0;
                        if (!(o >>> 0 > p >>> 0)) { break a }
                        r = o - 1 | 0;
                        c[g >> 2] = r;
                        if (($b(a[r] | 0, c[q >> 2] | 0) | 0) == -1) { m = -1; break }
                    }
                    i = e;
                    return m | 0
                }
            } while (0);
            c[n >> 2] = d;
            a[k] = 1;
            m = d;
            i = e;
            return m | 0
        }

        function Ql(b, e) {
            b = b | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0;
            f = i;
            i = i + 32 | 0;
            g = f | 0;
            h = f + 8 | 0;
            j = f + 16 | 0;
            k = f + 24 | 0;
            l = b + 52 | 0;
            if ((a[l] | 0) != 0) {
                m = b + 48 | 0;
                n = c[m >> 2] | 0;
                if (!e) {
                    o = n;
                    i = f;
                    return o | 0
                }
                c[m >> 2] = -1;
                a[l] = 0;
                o = n;
                i = f;
                return o | 0
            }
            n = c[b + 44 >> 2] | 0;
            l = (n | 0) > 1 ? n : 1;
            a: do {
                if ((l | 0) > 0) {
                    n = b + 32 | 0;
                    m = 0;
                    while (1) {
                        p = eb(c[n >> 2] | 0) | 0;
                        if ((p | 0) == -1) { o = -1; break }
                        a[g + m | 0] = p;
                        m = m + 1 | 0;
                        if ((m | 0) >= (l | 0)) { break a }
                    }
                    i = f;
                    return o | 0
                }
            } while (0);
            b: do {
                if ((a[b + 53 | 0] | 0) == 0) {
                    m = b + 40 | 0;
                    n = b + 36 | 0;
                    p = g | 0;
                    q = h + 1 | 0;
                    r = b + 32 | 0;
                    s = l;
                    while (1) {
                        t = c[m >> 2] | 0;
                        u = t;
                        v = c[u >> 2] | 0;
                        w = c[u + 4 >> 2] | 0;
                        u = c[n >> 2] | 0;
                        x = g + s | 0;
                        y = Vc[c[(c[u >> 2] | 0) + 16 >> 2] & 31](u, t, p, x, j, h, q, k) | 0;
                        if ((y | 0) == 3) { z = 14; break } else if ((y | 0) == 2) {
                            o = -1;
                            z = 23;
                            break
                        } else if ((y | 0) != 1) { A = s; break b }
                        y = c[m >> 2] | 0;
                        c[y >> 2] = v;
                        c[y + 4 >> 2] = w;
                        if ((s | 0) == 8) {
                            o = -1;
                            z = 23;
                            break
                        }
                        w = eb(c[r >> 2] | 0) | 0;
                        if ((w | 0) == -1) {
                            o = -1;
                            z = 23;
                            break
                        }
                        a[x] = w;
                        s = s + 1 | 0
                    }
                    if ((z | 0) == 14) {
                        a[h] = a[p] | 0;
                        A = s;
                        break
                    } else if ((z | 0) == 23) { i = f; return o | 0 }
                } else {
                    a[h] = a[g | 0] | 0;
                    A = l
                }
            } while (0);
            do {
                if (e) {
                    l = a[h] | 0;
                    c[b + 48 >> 2] = l & 255;
                    B = l
                } else {
                    l = b + 32 | 0;
                    k = A;
                    while (1) {
                        if ((k | 0) <= 0) { z = 21; break }
                        j = k - 1 | 0;
                        if (($b(d[g + j | 0] | 0, c[l >> 2] | 0) | 0) == -1) {
                            o = -1;
                            z = 23;
                            break
                        } else { k = j }
                    }
                    if ((z | 0) == 21) { B = a[h] | 0; break } else if ((z | 0) == 23) { i = f; return o | 0 }
                }
            } while (0);
            o = B & 255;
            i = f;
            return o | 0
        }

        function Rl() {
            nl(0);
            Ub(164, 35312, u | 0) | 0;
            return
        }

        function Sl(a) { a = a | 0; return }

        function Tl(a) {
            a = a | 0;
            var b = 0;
            b = a + 4 | 0;
            I = c[b >> 2] | 0, c[b >> 2] = I + 1, I;
            return
        }

        function Ul(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = a + 4 | 0;
            if (((I = c[b >> 2] | 0, c[b >> 2] = I + -1, I) | 0) != 0) { d = 0; return d | 0 }
            Dc[c[(c[a >> 2] | 0) + 8 >> 2] & 511](a);
            d = 1;
            return d | 0
        }

        function Vl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0;
            c[a >> 2] = 19600;
            d = ev(b | 0) | 0;
            e = Ou(d + 13 | 0) | 0;
            c[e + 4 >> 2] = d;
            c[e >> 2] = d;
            f = e + 12 | 0;
            c[a + 4 >> 2] = f;
            c[e + 8 >> 2] = 0;
            cv(f | 0, b | 0, d + 1 | 0) | 0;
            return
        }

        function Wl(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0;
            c[a >> 2] = 19600;
            b = a + 4 | 0;
            d = (c[b >> 2] | 0) - 4 | 0;
            if (((I = c[d >> 2] | 0, c[d >> 2] = I + -1, I) - 1 | 0) >= 0) {
                e = a | 0;
                f = a;
                Pu(f);
                return
            }
            Qu((c[b >> 2] | 0) - 12 | 0);
            e = a | 0;
            f = a;
            Pu(f);
            return
        }

        function Xl(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            c[a >> 2] = 19600;
            b = a + 4 | 0;
            d = (c[b >> 2] | 0) - 4 | 0;
            if (((I = c[d >> 2] | 0, c[d >> 2] = I + -1, I) - 1 | 0) >= 0) { e = a | 0; return }
            Qu((c[b >> 2] | 0) - 12 | 0);
            e = a | 0;
            return
        }

        function Yl(a) { a = a | 0; return c[a + 4 >> 2] | 0 }

        function Zl(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            c[b >> 2] = 19536;
            if ((a[d] & 1) == 0) { e = d + 1 | 0 } else { e = c[d + 8 >> 2] | 0 }
            d = ev(e | 0) | 0;
            f = Ou(d + 13 | 0) | 0;
            c[f + 4 >> 2] = d;
            c[f >> 2] = d;
            g = f + 12 | 0;
            c[b + 4 >> 2] = g;
            c[f + 8 >> 2] = 0;
            cv(g | 0, e | 0, d + 1 | 0) | 0;
            return
        }

        function _l(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0;
            c[a >> 2] = 19536;
            d = ev(b | 0) | 0;
            e = Ou(d + 13 | 0) | 0;
            c[e + 4 >> 2] = d;
            c[e >> 2] = d;
            f = e + 12 | 0;
            c[a + 4 >> 2] = f;
            c[e + 8 >> 2] = 0;
            cv(f | 0, b | 0, d + 1 | 0) | 0;
            return
        }

        function $l(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0;
            c[a >> 2] = 19536;
            b = a + 4 | 0;
            d = (c[b >> 2] | 0) - 4 | 0;
            if (((I = c[d >> 2] | 0, c[d >> 2] = I + -1, I) - 1 | 0) >= 0) {
                e = a | 0;
                f = a;
                Pu(f);
                return
            }
            Qu((c[b >> 2] | 0) - 12 | 0);
            e = a | 0;
            f = a;
            Pu(f);
            return
        }

        function am(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            c[a >> 2] = 19536;
            b = a + 4 | 0;
            d = (c[b >> 2] | 0) - 4 | 0;
            if (((I = c[d >> 2] | 0, c[d >> 2] = I + -1, I) - 1 | 0) >= 0) { e = a | 0; return }
            Qu((c[b >> 2] | 0) - 12 | 0);
            e = a | 0;
            return
        }

        function bm(a) { a = a | 0; return c[a + 4 >> 2] | 0 }

        function cm(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0;
            c[a >> 2] = 19600;
            b = a + 4 | 0;
            d = (c[b >> 2] | 0) - 4 | 0;
            if (((I = c[d >> 2] | 0, c[d >> 2] = I + -1, I) - 1 | 0) >= 0) {
                e = a | 0;
                f = a;
                Pu(f);
                return
            }
            Qu((c[b >> 2] | 0) - 12 | 0);
            e = a | 0;
            f = a;
            Pu(f);
            return
        }

        function dm(a) { a = a | 0; return }

        function em(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = d;
            c[a + 4 >> 2] = b;
            return
        }

        function fm(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            e = i;
            i = i + 8 | 0;
            f = e | 0;
            Tc[c[(c[a >> 2] | 0) + 12 >> 2] & 63](f, a, b);
            if ((c[f + 4 >> 2] | 0) != (c[d + 4 >> 2] | 0)) {
                g = 0;
                i = e;
                return g | 0
            }
            g = (c[f >> 2] | 0) == (c[d >> 2] | 0);
            i = e;
            return g | 0
        }

        function gm(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            if ((c[b + 4 >> 2] | 0) != (a | 0)) { e = 0; return e | 0 }
            e = (c[b >> 2] | 0) == (d | 0);
            return e | 0
        }

        function hm(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0;
            d = Wb(e | 0) | 0;
            e = ev(d | 0) | 0;
            if (e >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (e >>> 0 < 11 >>> 0) {
                a[b] = e << 1;
                f = b + 1 | 0;
                cv(f | 0, d | 0, e) | 0;
                g = f + e | 0;
                a[g] = 0;
                return
            } else {
                h = e + 16 & -16;
                i = Nu(h) | 0;
                c[b + 8 >> 2] = i;
                c[b >> 2] = h | 1;
                c[b + 4 >> 2] = e;
                f = i;
                cv(f | 0, d | 0, e) | 0;
                g = f + e | 0;
                a[g] = 0;
                return
            }
        }

        function im(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            f = i;
            i = i + 16 | 0;
            g = f | 0;
            h = d | 0;
            j = c[h >> 2] | 0;
            k = e;
            do {
                if ((j | 0) != 0) {
                    l = a[k] | 0;
                    if ((l & 1) == 0) { m = (l & 255) >>> 1 } else { m = c[e + 4 >> 2] | 0 }
                    if ((m | 0) == 0) { n = j } else {
                        xm(e, 12816, 2) | 0;
                        n = c[h >> 2] | 0
                    }
                    l = c[d + 4 >> 2] | 0;
                    Tc[c[(c[l >> 2] | 0) + 24 >> 2] & 63](g, l, n);
                    l = g;
                    o = a[l] | 0;
                    if ((o & 1) == 0) {
                        p = (o & 255) >>> 1;
                        q = g + 1 | 0
                    } else {
                        p = c[g + 4 >> 2] | 0;
                        q = c[g + 8 >> 2] | 0
                    }
                    xm(e, q, p) | 0;
                    if ((a[l] & 1) == 0) { break }
                    Pu(c[g + 8 >> 2] | 0)
                }
            } while (0);
            g = b;
            c[g >> 2] = c[k >> 2];
            c[g + 4 >> 2] = c[k + 4 >> 2];
            c[g + 8 >> 2] = c[k + 8 >> 2];
            dv(k | 0, 0, 12) | 0;
            i = f;
            return
        }

        function jm(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            f = i;
            i = i + 32 | 0;
            g = d;
            d = i;
            i = i + 8 | 0;
            c[d >> 2] = c[g >> 2];
            c[d + 4 >> 2] = c[g + 4 >> 2];
            g = f | 0;
            h = f + 16 | 0;
            j = ev(e | 0) | 0;
            if (j >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (j >>> 0 < 11 >>> 0) {
                a[h] = j << 1;
                k = h + 1 | 0
            } else {
                l = j + 16 & -16;
                m = Nu(l) | 0;
                c[h + 8 >> 2] = m;
                c[h >> 2] = l | 1;
                c[h + 4 >> 2] = j;
                k = m
            }
            cv(k | 0, e | 0, j) | 0;
            a[k + j | 0] = 0;
            im(g, d, h);
            Zl(b | 0, g);
            if (!((a[g] & 1) == 0)) { Pu(c[g + 8 >> 2] | 0) }
            if (!((a[h] & 1) == 0)) { Pu(c[h + 8 >> 2] | 0) }
            c[b >> 2] = 21560;
            h = d;
            d = b + 8 | 0;
            b = c[h + 4 >> 2] | 0;
            c[d >> 2] = c[h >> 2];
            c[d + 4 >> 2] = b;
            i = f;
            return
        }

        function km(a) {
            a = a | 0;
            am(a | 0);
            Pu(a);
            return
        }

        function lm(a) {
            a = a | 0;
            am(a | 0);
            return
        }

        function mm(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            e;
            if ((c[a >> 2] | 0) == 1) { do { Za(34312, 34288) | 0; } while ((c[a >> 2] | 0) == 1) }
            if ((c[a >> 2] | 0) != 0) { f; return }
            c[a >> 2] = 1;
            g;
            Dc[d & 511](b);
            h;
            c[a >> 2] = -1;
            i;
            Ob(34312) | 0;
            return
        }

        function nm(a) {
            a = a | 0;
            a = pc(8) | 0;
            Vl(a, 1304);
            c[a >> 2] = 19568;
            Fb(a | 0, 25576, 40)
        }

        function om(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0;
            e = d;
            if ((a[e] & 1) == 0) {
                f = b;
                c[f >> 2] = c[e >> 2];
                c[f + 4 >> 2] = c[e + 4 >> 2];
                c[f + 8 >> 2] = c[e + 8 >> 2];
                return
            }
            e = c[d + 8 >> 2] | 0;
            f = c[d + 4 >> 2] | 0;
            if (f >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (f >>> 0 < 11 >>> 0) {
                a[b] = f << 1;
                g = b + 1 | 0
            } else {
                d = f + 16 & -16;
                h = Nu(d) | 0;
                c[b + 8 >> 2] = h;
                c[b >> 2] = d | 1;
                c[b + 4 >> 2] = f;
                g = h
            }
            cv(g | 0, e | 0, f) | 0;
            a[g + f | 0] = 0;
            return
        }

        function pm(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0;
            if (e >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (e >>> 0 < 11 >>> 0) {
                a[b] = e << 1;
                f = b + 1 | 0;
                cv(f | 0, d | 0, e) | 0;
                g = f + e | 0;
                a[g] = 0;
                return
            } else {
                h = e + 16 & -16;
                i = Nu(h) | 0;
                c[b + 8 >> 2] = i;
                c[b >> 2] = h | 1;
                c[b + 4 >> 2] = e;
                f = i;
                cv(f | 0, d | 0, e) | 0;
                g = f + e | 0;
                a[g] = 0;
                return
            }
        }

        function qm(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0;
            if (d >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (d >>> 0 < 11 >>> 0) {
                a[b] = d << 1;
                f = b + 1 | 0
            } else {
                g = d + 16 & -16;
                h = Nu(g) | 0;
                c[b + 8 >> 2] = h;
                c[b >> 2] = g | 1;
                c[b + 4 >> 2] = d;
                f = h
            }
            dv(f | 0, e | 0, d | 0) | 0;
            a[f + d | 0] = 0;
            return
        }

        function rm(b) {
            b = b | 0;
            if ((a[b] & 1) == 0) { return }
            Pu(c[b + 8 >> 2] | 0);
            return
        }

        function sm(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            e = ev(d | 0) | 0;
            f = b;
            g = a[f] | 0;
            if ((g & 1) == 0) {
                h = 10;
                i = g
            } else {
                g = c[b >> 2] | 0;
                h = (g & -2) - 1 | 0;
                i = g & 255
            }
            g = (i & 1) == 0;
            if (h >>> 0 < e >>> 0) {
                if (g) { j = (i & 255) >>> 1 } else { j = c[b + 4 >> 2] | 0 }
                ym(b, h, e - h | 0, j, 0, j, e, d);
                return b | 0
            }
            if (g) { k = b + 1 | 0 } else { k = c[b + 8 >> 2] | 0 }
            fv(k | 0, d | 0, e | 0) | 0;
            a[k + e | 0] = 0;
            if ((a[f] & 1) == 0) { a[f] = e << 1; return b | 0 } else { c[b + 4 >> 2] = e; return b | 0 }
            return 0
        }

        function tm(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0;
            f = b;
            g = a[f] | 0;
            h = (g & 1) == 0;
            if (h) { i = (g & 255) >>> 1 } else { i = c[b + 4 >> 2] | 0 }
            if (i >>> 0 < d >>> 0) { um(b, d - i | 0, e) | 0; return }
            if (h) {
                a[b + 1 + d | 0] = 0;
                a[f] = d << 1;
                return
            } else {
                a[(c[b + 8 >> 2] | 0) + d | 0] = 0;
                c[b + 4 >> 2] = d;
                return
            }
        }

        function um(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            if ((d | 0) == 0) { return b | 0 }
            f = b;
            g = a[f] | 0;
            if ((g & 1) == 0) {
                h = 10;
                i = g
            } else {
                g = c[b >> 2] | 0;
                h = (g & -2) - 1 | 0;
                i = g & 255
            }
            if ((i & 1) == 0) { j = (i & 255) >>> 1 } else { j = c[b + 4 >> 2] | 0 }
            if ((h - j | 0) >>> 0 < d >>> 0) {
                zm(b, h, d - h + j | 0, j, j, 0, 0);
                k = a[f] | 0
            } else { k = i }
            if ((k & 1) == 0) { l = b + 1 | 0 } else { l = c[b + 8 >> 2] | 0 }
            dv(l + j | 0, e | 0, d | 0) | 0;
            e = j + d | 0;
            if ((a[f] & 1) == 0) { a[f] = e << 1 } else { c[b + 4 >> 2] = e }
            a[l + e | 0] = 0;
            return b | 0
        }

        function vm(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            if (d >>> 0 > 4294967279 >>> 0) { nm(0) }
            e = b;
            f = a[e] | 0;
            if ((f & 1) == 0) {
                g = 10;
                h = f
            } else {
                f = c[b >> 2] | 0;
                g = (f & -2) - 1 | 0;
                h = f & 255
            }
            if ((h & 1) == 0) { i = (h & 255) >>> 1 } else { i = c[b + 4 >> 2] | 0 }
            f = i >>> 0 > d >>> 0 ? i : d;
            if (f >>> 0 < 11 >>> 0) { j = 10 } else { j = (f + 16 & -16) - 1 | 0 }
            if ((j | 0) == (g | 0)) { return }
            do {
                if ((j | 0) == 10) {
                    k = b + 1 | 0;
                    l = c[b + 8 >> 2] | 0;
                    m = 1;
                    n = 0
                } else {
                    f = j + 1 | 0;
                    if (j >>> 0 > g >>> 0) { o = Nu(f) | 0 } else { o = Nu(f) | 0 }
                    if ((h & 1) == 0) {
                        k = o;
                        l = b + 1 | 0;
                        m = 0;
                        n = 1;
                        break
                    } else {
                        k = o;
                        l = c[b + 8 >> 2] | 0;
                        m = 1;
                        n = 1;
                        break
                    }
                }
            } while (0);
            if ((h & 1) == 0) { p = (h & 255) >>> 1 } else { p = c[b + 4 >> 2] | 0 }
            cv(k | 0, l | 0, p + 1 | 0) | 0;
            if (m) { Pu(l) }
            if (n) {
                c[b >> 2] = j + 1 | 1;
                c[b + 4 >> 2] = i;
                c[b + 8 >> 2] = k;
                return
            } else { a[e] = i << 1; return }
        }

        function wm(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            e = b;
            f = a[e] | 0;
            g = (f & 1) != 0;
            if (g) {
                h = c[b + 4 >> 2] | 0;
                i = (c[b >> 2] & -2) - 1 | 0
            } else {
                h = (f & 255) >>> 1;
                i = 10
            }
            if ((h | 0) == (i | 0)) { zm(b, i, 1, i, i, 0, 0); if ((a[e] & 1) == 0) { j = 7 } else { j = 8 } } else { if (g) { j = 8 } else { j = 7 } }
            if ((j | 0) == 7) {
                a[e] = (h << 1) + 2;
                k = b + 1 | 0;
                l = h + 1 | 0;
                m = k + h | 0;
                a[m] = d;
                n = k + l | 0;
                a[n] = 0;
                return
            } else if ((j | 0) == 8) {
                j = c[b + 8 >> 2] | 0;
                e = h + 1 | 0;
                c[b + 4 >> 2] = e;
                k = j;
                l = e;
                m = k + h | 0;
                a[m] = d;
                n = k + l | 0;
                a[n] = 0;
                return
            }
        }

        function xm(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            f = b;
            g = a[f] | 0;
            if ((g & 1) == 0) {
                h = 10;
                i = g
            } else {
                g = c[b >> 2] | 0;
                h = (g & -2) - 1 | 0;
                i = g & 255
            }
            if ((i & 1) == 0) { j = (i & 255) >>> 1 } else { j = c[b + 4 >> 2] | 0 }
            if ((h - j | 0) >>> 0 < e >>> 0) { ym(b, h, e - h + j | 0, j, j, 0, e, d); return b | 0 }
            if ((e | 0) == 0) { return b | 0 }
            if ((i & 1) == 0) { k = b + 1 | 0 } else { k = c[b + 8 >> 2] | 0 }
            cv(k + j | 0, d | 0, e) | 0;
            d = j + e | 0;
            if ((a[f] & 1) == 0) { a[f] = d << 1 } else { c[b + 4 >> 2] = d }
            a[k + d | 0] = 0;
            return b | 0
        }

        function ym(b, d, e, f, g, h, i, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            if ((-18 - d | 0) >>> 0 < e >>> 0) { nm(0) }
            if ((a[b] & 1) == 0) { k = b + 1 | 0 } else { k = c[b + 8 >> 2] | 0 }
            do {
                if (d >>> 0 < 2147483623 >>> 0) {
                    l = e + d | 0;
                    m = d << 1;
                    n = l >>> 0 < m >>> 0 ? m : l;
                    if (n >>> 0 < 11 >>> 0) { o = 11; break }
                    o = n + 16 & -16
                } else { o = -17 }
            } while (0);
            e = Nu(o) | 0;
            if ((g | 0) != 0) { cv(e | 0, k | 0, g) | 0 }
            if ((i | 0) != 0) { cv(e + g | 0, j | 0, i) | 0 }
            j = f - h | 0;
            if ((j | 0) != (g | 0)) { cv(e + (i + g) | 0, k + (h + g) | 0, j - g | 0) | 0 }
            if ((d | 0) == 10) {
                p = b + 8 | 0;
                c[p >> 2] = e;
                q = o | 1;
                r = b | 0;
                c[r >> 2] = q;
                s = j + i | 0;
                t = b + 4 | 0;
                c[t >> 2] = s;
                u = e + s | 0;
                a[u] = 0;
                return
            }
            Pu(k);
            p = b + 8 | 0;
            c[p >> 2] = e;
            q = o | 1;
            r = b | 0;
            c[r >> 2] = q;
            s = j + i | 0;
            t = b + 4 | 0;
            c[t >> 2] = s;
            u = e + s | 0;
            a[u] = 0;
            return
        }

        function zm(b, d, e, f, g, h, i) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            if ((-17 - d | 0) >>> 0 < e >>> 0) { nm(0) }
            if ((a[b] & 1) == 0) { j = b + 1 | 0 } else { j = c[b + 8 >> 2] | 0 }
            do {
                if (d >>> 0 < 2147483623 >>> 0) {
                    k = e + d | 0;
                    l = d << 1;
                    m = k >>> 0 < l >>> 0 ? l : k;
                    if (m >>> 0 < 11 >>> 0) { n = 11; break }
                    n = m + 16 & -16
                } else { n = -17 }
            } while (0);
            e = Nu(n) | 0;
            if ((g | 0) != 0) { cv(e | 0, j | 0, g) | 0 }
            m = f - h | 0;
            if ((m | 0) != (g | 0)) { cv(e + (i + g) | 0, j + (h + g) | 0, m - g | 0) | 0 }
            if ((d | 0) == 10) {
                o = b + 8 | 0;
                c[o >> 2] = e;
                p = n | 1;
                q = b | 0;
                c[q >> 2] = p;
                return
            }
            Pu(j);
            o = b + 8 | 0;
            c[o >> 2] = e;
            p = n | 1;
            q = b | 0;
            c[q >> 2] = p;
            return
        }

        function Am(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            if (e >>> 0 > 1073741807 >>> 0) { nm(0) }
            if (e >>> 0 < 2 >>> 0) {
                a[b] = e << 1;
                f = b + 4 | 0;
                g = hu(f, d, e) | 0;
                h = f + (e << 2) | 0;
                c[h >> 2] = 0;
                return
            } else {
                i = e + 4 & -4;
                j = Nu(i << 2) | 0;
                c[b + 8 >> 2] = j;
                c[b >> 2] = i | 1;
                c[b + 4 >> 2] = e;
                f = j;
                g = hu(f, d, e) | 0;
                h = f + (e << 2) | 0;
                c[h >> 2] = 0;
                return
            }
        }

        function Bm(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            if (d >>> 0 > 1073741807 >>> 0) { nm(0) }
            if (d >>> 0 < 2 >>> 0) {
                a[b] = d << 1;
                f = b + 4 | 0;
                g = ju(f, e, d) | 0;
                h = f + (d << 2) | 0;
                c[h >> 2] = 0;
                return
            } else {
                i = d + 4 & -4;
                j = Nu(i << 2) | 0;
                c[b + 8 >> 2] = j;
                c[b >> 2] = i | 1;
                c[b + 4 >> 2] = d;
                f = j;
                g = ju(f, e, d) | 0;
                h = f + (d << 2) | 0;
                c[h >> 2] = 0;
                return
            }
        }

        function Cm(b) {
            b = b | 0;
            if ((a[b] & 1) == 0) { return }
            Pu(c[b + 8 >> 2] | 0);
            return
        }

        function Dm(a, b) {
            a = a | 0;
            b = b | 0;
            return Em(a, b, gu(b) | 0) | 0
        }

        function Em(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            f = b;
            g = a[f] | 0;
            if ((g & 1) == 0) {
                h = 1;
                i = g
            } else {
                g = c[b >> 2] | 0;
                h = (g & -2) - 1 | 0;
                i = g & 255
            }
            g = (i & 1) == 0;
            if (h >>> 0 < e >>> 0) {
                if (g) { j = (i & 255) >>> 1 } else { j = c[b + 4 >> 2] | 0 }
                Hm(b, h, e - h | 0, j, 0, j, e, d);
                return b | 0
            }
            if (g) { k = b + 4 | 0 } else { k = c[b + 8 >> 2] | 0 }
            iu(k, d, e) | 0;
            c[k + (e << 2) >> 2] = 0;
            if ((a[f] & 1) == 0) { a[f] = e << 1; return b | 0 } else { c[b + 4 >> 2] = e; return b | 0 }
            return 0
        }

        function Fm(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            if (d >>> 0 > 1073741807 >>> 0) { nm(0) }
            e = b;
            f = a[e] | 0;
            if ((f & 1) == 0) {
                g = 1;
                h = f
            } else {
                f = c[b >> 2] | 0;
                g = (f & -2) - 1 | 0;
                h = f & 255
            }
            if ((h & 1) == 0) { i = (h & 255) >>> 1 } else { i = c[b + 4 >> 2] | 0 }
            f = i >>> 0 > d >>> 0 ? i : d;
            if (f >>> 0 < 2 >>> 0) { j = 1 } else { j = (f + 4 & -4) - 1 | 0 }
            if ((j | 0) == (g | 0)) { return }
            do {
                if ((j | 0) == 1) {
                    k = b + 4 | 0;
                    l = c[b + 8 >> 2] | 0;
                    m = 1;
                    n = 0
                } else {
                    f = (j << 2) + 4 | 0;
                    if (j >>> 0 > g >>> 0) { o = Nu(f) | 0 } else { o = Nu(f) | 0 }
                    f = o;
                    if ((h & 1) == 0) {
                        k = f;
                        l = b + 4 | 0;
                        m = 0;
                        n = 1;
                        break
                    } else {
                        k = f;
                        l = c[b + 8 >> 2] | 0;
                        m = 1;
                        n = 1;
                        break
                    }
                }
            } while (0);
            if ((h & 1) == 0) { p = (h & 255) >>> 1 } else { p = c[b + 4 >> 2] | 0 }
            hu(k, l, p + 1 | 0) | 0;
            if (m) { Pu(l) }
            if (n) {
                c[b >> 2] = j + 1 | 1;
                c[b + 4 >> 2] = i;
                c[b + 8 >> 2] = k;
                return
            } else { a[e] = i << 1; return }
        }

        function Gm(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            e = b;
            f = a[e] | 0;
            g = (f & 1) != 0;
            if (g) {
                h = c[b + 4 >> 2] | 0;
                i = (c[b >> 2] & -2) - 1 | 0
            } else {
                h = (f & 255) >>> 1;
                i = 1
            }
            if ((h | 0) == (i | 0)) { Im(b, i, 1, i, i, 0, 0); if ((a[e] & 1) == 0) { j = 7 } else { j = 8 } } else { if (g) { j = 8 } else { j = 7 } }
            if ((j | 0) == 7) {
                a[e] = (h << 1) + 2;
                k = b + 4 | 0;
                l = h + 1 | 0;
                m = k + (h << 2) | 0;
                c[m >> 2] = d;
                n = k + (l << 2) | 0;
                c[n >> 2] = 0;
                return
            } else if ((j | 0) == 8) {
                j = c[b + 8 >> 2] | 0;
                e = h + 1 | 0;
                c[b + 4 >> 2] = e;
                k = j;
                l = e;
                m = k + (h << 2) | 0;
                c[m >> 2] = d;
                n = k + (l << 2) | 0;
                c[n >> 2] = 0;
                return
            }
        }

        function Hm(b, d, e, f, g, h, i, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            if ((1073741806 - d | 0) >>> 0 < e >>> 0) { nm(0) }
            if ((a[b] & 1) == 0) { k = b + 4 | 0 } else { k = c[b + 8 >> 2] | 0 }
            do {
                if (d >>> 0 < 536870887 >>> 0) {
                    l = e + d | 0;
                    m = d << 1;
                    n = l >>> 0 < m >>> 0 ? m : l;
                    if (n >>> 0 < 2 >>> 0) { o = 2; break }
                    o = n + 4 & -4
                } else { o = 1073741807 }
            } while (0);
            e = Nu(o << 2) | 0;
            if ((g | 0) != 0) { hu(e, k, g) | 0 }
            if ((i | 0) != 0) { hu(e + (g << 2) | 0, j, i) | 0 }
            j = f - h | 0;
            if ((j | 0) != (g | 0)) { hu(e + (i + g << 2) | 0, k + (h + g << 2) | 0, j - g | 0) | 0 }
            if ((d | 0) == 1) {
                p = b + 8 | 0;
                c[p >> 2] = e;
                q = o | 1;
                r = b | 0;
                c[r >> 2] = q;
                s = j + i | 0;
                t = b + 4 | 0;
                c[t >> 2] = s;
                u = e + (s << 2) | 0;
                c[u >> 2] = 0;
                return
            }
            Pu(k);
            p = b + 8 | 0;
            c[p >> 2] = e;
            q = o | 1;
            r = b | 0;
            c[r >> 2] = q;
            s = j + i | 0;
            t = b + 4 | 0;
            c[t >> 2] = s;
            u = e + (s << 2) | 0;
            c[u >> 2] = 0;
            return
        }

        function Im(b, d, e, f, g, h, i) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            if ((1073741807 - d | 0) >>> 0 < e >>> 0) { nm(0) }
            if ((a[b] & 1) == 0) { j = b + 4 | 0 } else { j = c[b + 8 >> 2] | 0 }
            do {
                if (d >>> 0 < 536870887 >>> 0) {
                    k = e + d | 0;
                    l = d << 1;
                    m = k >>> 0 < l >>> 0 ? l : k;
                    if (m >>> 0 < 2 >>> 0) { n = 2; break }
                    n = m + 4 & -4
                } else { n = 1073741807 }
            } while (0);
            e = Nu(n << 2) | 0;
            if ((g | 0) != 0) { hu(e, j, g) | 0 }
            m = f - h | 0;
            if ((m | 0) != (g | 0)) { hu(e + (i + g << 2) | 0, j + (h + g << 2) | 0, m - g | 0) | 0 }
            if ((d | 0) == 1) {
                o = b + 8 | 0;
                c[o >> 2] = e;
                p = n | 1;
                q = b | 0;
                c[q >> 2] = p;
                return
            }
            Pu(j);
            o = b + 8 | 0;
            c[o >> 2] = e;
            p = n | 1;
            q = b | 0;
            c[q >> 2] = p;
            return
        }

        function Jm(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            e = i;
            i = i + 8 | 0;
            f = e | 0;
            g = (c[b + 24 >> 2] | 0) == 0;
            if (g) { c[b + 16 >> 2] = d | 1 } else { c[b + 16 >> 2] = d }
            if (((g & 1 | d) & c[b + 20 >> 2] | 0) == 0) { i = e; return }
            e = pc(16) | 0;
            do {
                if ((a[51816] | 0) == 0) {
                    if ((ub(51816) | 0) == 0) { break }
                    c[8332] = 21064;
                    Ub(74, 33328, u | 0) | 0
                }
            } while (0);
            b = jv(33328, 0, 32) | 0;
            c[f >> 2] = b | 1;
            c[f + 4 >> 2] = K;
            jm(e, f, 13504);
            c[e >> 2] = 20248;
            Fb(e | 0, 26120, 38)
        }

        function Km(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0;
            c[a >> 2] = 20224;
            b = c[a + 40 >> 2] | 0;
            d = a + 32 | 0;
            e = a + 36 | 0;
            if ((b | 0) != 0) {
                f = b;
                do {
                    f = f - 1 | 0;
                    Tc[c[(c[d >> 2] | 0) + (f << 2) >> 2] & 63](0, a, c[(c[e >> 2] | 0) + (f << 2) >> 2] | 0);
                } while ((f | 0) != 0)
            }
            Vr(a + 28 | 0);
            Hu(c[d >> 2] | 0);
            Hu(c[e >> 2] | 0);
            Hu(c[a + 48 >> 2] | 0);
            Hu(c[a + 60 >> 2] | 0);
            return
        }

        function Lm(a, b) {
            a = a | 0;
            b = b | 0;
            Ur(a, b + 28 | 0);
            return
        }

        function Mm(a, b) {
            a = a | 0;
            b = b | 0;
            c[a + 24 >> 2] = b;
            c[a + 16 >> 2] = (b | 0) == 0;
            c[a + 20 >> 2] = 0;
            c[a + 4 >> 2] = 4098;
            c[a + 12 >> 2] = 0;
            c[a + 8 >> 2] = 6;
            dv(a + 32 | 0, 0, 40) | 0;
            Tr(a + 28 | 0);
            return
        }

        function Nm(a) {
            a = a | 0;
            c[a >> 2] = 21296;
            Vr(a + 4 | 0);
            Pu(a);
            return
        }

        function Om(a) {
            a = a | 0;
            c[a >> 2] = 21296;
            Vr(a + 4 | 0);
            return
        }

        function Pm(a, b) {
            a = a | 0;
            b = b | 0;
            return
        }

        function Qm(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            return a | 0
        }

        function Rm(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            g = a;
            c[g >> 2] = 0;
            c[g + 4 >> 2] = 0;
            g = a + 8 | 0;
            c[g >> 2] = -1;
            c[g + 4 >> 2] = -1;
            return
        }

        function Sm(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            e = i;
            b = d;
            d = i;
            i = i + 16 | 0;
            c[d >> 2] = c[b >> 2];
            c[d + 4 >> 2] = c[b + 4 >> 2];
            c[d + 8 >> 2] = c[b + 8 >> 2];
            c[d + 12 >> 2] = c[b + 12 >> 2];
            b = a;
            c[b >> 2] = 0;
            c[b + 4 >> 2] = 0;
            b = a + 8 | 0;
            c[b >> 2] = -1;
            c[b + 4 >> 2] = -1;
            i = e;
            return
        }

        function Tm(a) { a = a | 0; return 0 }

        function Um(a) { a = a | 0; return 0 }

        function Vm(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            f = b;
            if ((e | 0) <= 0) { g = 0; return g | 0 }
            h = b + 12 | 0;
            i = b + 16 | 0;
            j = d;
            d = 0;
            while (1) {
                k = c[h >> 2] | 0;
                if (k >>> 0 < (c[i >> 2] | 0) >>> 0) {
                    c[h >> 2] = k + 1;
                    l = a[k] | 0
                } else {
                    k = Fc[c[(c[f >> 2] | 0) + 40 >> 2] & 255](b) | 0;
                    if ((k | 0) == -1) {
                        g = d;
                        m = 8;
                        break
                    }
                    l = k & 255
                }
                a[j] = l;
                k = d + 1 | 0;
                if ((k | 0) < (e | 0)) {
                    j = j + 1 | 0;
                    d = k
                } else {
                    g = k;
                    m = 8;
                    break
                }
            }
            if ((m | 0) == 8) { return g | 0 }
            return 0
        }

        function Wm(a) { a = a | 0; return -1 | 0 }

        function Xm(a) {
            a = a | 0;
            var b = 0,
                e = 0;
            if ((Fc[c[(c[a >> 2] | 0) + 36 >> 2] & 255](a) | 0) == -1) { b = -1; return b | 0 }
            e = a + 12 | 0;
            a = c[e >> 2] | 0;
            c[e >> 2] = a + 1;
            b = d[a] | 0;
            return b | 0
        }

        function Ym(a, b) {
            a = a | 0;
            b = b | 0;
            return -1 | 0
        }

        function Zm(b, e, f) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            g = b;
            if ((f | 0) <= 0) { h = 0; return h | 0 }
            i = b + 24 | 0;
            j = b + 28 | 0;
            k = 0;
            l = e;
            while (1) {
                e = c[i >> 2] | 0;
                if (e >>> 0 < (c[j >> 2] | 0) >>> 0) {
                    m = a[l] | 0;
                    c[i >> 2] = e + 1;
                    a[e] = m
                } else {
                    if ((Qc[c[(c[g >> 2] | 0) + 52 >> 2] & 63](b, d[l] | 0) | 0) == -1) {
                        h = k;
                        n = 7;
                        break
                    }
                }
                m = k + 1 | 0;
                if ((m | 0) < (f | 0)) {
                    k = m;
                    l = l + 1 | 0
                } else {
                    h = m;
                    n = 7;
                    break
                }
            }
            if ((n | 0) == 7) { return h | 0 }
            return 0
        }

        function _m(a, b) {
            a = a | 0;
            b = b | 0;
            return -1 | 0
        }

        function $m(a) {
            a = a | 0;
            c[a >> 2] = 21224;
            Vr(a + 4 | 0);
            Pu(a);
            return
        }

        function an(a) {
            a = a | 0;
            c[a >> 2] = 21224;
            Vr(a + 4 | 0);
            return
        }

        function bn(a, b) {
            a = a | 0;
            b = b | 0;
            return
        }

        function cn(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            return a | 0
        }

        function dn(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            g = a;
            c[g >> 2] = 0;
            c[g + 4 >> 2] = 0;
            g = a + 8 | 0;
            c[g >> 2] = -1;
            c[g + 4 >> 2] = -1;
            return
        }

        function en(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            e = i;
            b = d;
            d = i;
            i = i + 16 | 0;
            c[d >> 2] = c[b >> 2];
            c[d + 4 >> 2] = c[b + 4 >> 2];
            c[d + 8 >> 2] = c[b + 8 >> 2];
            c[d + 12 >> 2] = c[b + 12 >> 2];
            b = a;
            c[b >> 2] = 0;
            c[b + 4 >> 2] = 0;
            b = a + 8 | 0;
            c[b >> 2] = -1;
            c[b + 4 >> 2] = -1;
            i = e;
            return
        }

        function fn(a) { a = a | 0; return 0 }

        function gn(a) { a = a | 0; return 0 }

        function hn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            e = a;
            if ((d | 0) <= 0) { f = 0; return f | 0 }
            g = a + 12 | 0;
            h = a + 16 | 0;
            i = b;
            b = 0;
            while (1) {
                j = c[g >> 2] | 0;
                if (j >>> 0 < (c[h >> 2] | 0) >>> 0) {
                    c[g >> 2] = j + 4;
                    k = c[j >> 2] | 0
                } else {
                    j = Fc[c[(c[e >> 2] | 0) + 40 >> 2] & 255](a) | 0;
                    if ((j | 0) == -1) {
                        f = b;
                        l = 8;
                        break
                    } else { k = j }
                }
                c[i >> 2] = k;
                j = b + 1 | 0;
                if ((j | 0) >= (d | 0)) {
                    f = j;
                    l = 8;
                    break
                }
                i = i + 4 | 0;
                b = j
            }
            if ((l | 0) == 8) { return f | 0 }
            return 0
        }

        function jn(a) { a = a | 0; return -1 | 0 }

        function kn(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            if ((Fc[c[(c[a >> 2] | 0) + 36 >> 2] & 255](a) | 0) == -1) { b = -1; return b | 0 }
            d = a + 12 | 0;
            a = c[d >> 2] | 0;
            c[d >> 2] = a + 4;
            b = c[a >> 2] | 0;
            return b | 0
        }

        function ln(a, b) {
            a = a | 0;
            b = b | 0;
            return -1 | 0
        }

        function mn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            e = a;
            if ((d | 0) <= 0) { f = 0; return f | 0 }
            g = a + 24 | 0;
            h = a + 28 | 0;
            i = 0;
            j = b;
            while (1) {
                b = c[g >> 2] | 0;
                if (b >>> 0 < (c[h >> 2] | 0) >>> 0) {
                    k = c[j >> 2] | 0;
                    c[g >> 2] = b + 4;
                    c[b >> 2] = k
                } else {
                    if ((Qc[c[(c[e >> 2] | 0) + 52 >> 2] & 63](a, c[j >> 2] | 0) | 0) == -1) {
                        f = i;
                        l = 8;
                        break
                    }
                }
                k = i + 1 | 0;
                if ((k | 0) >= (d | 0)) {
                    f = k;
                    l = 8;
                    break
                }
                i = k;
                j = j + 4 | 0
            }
            if ((l | 0) == 8) { return f | 0 }
            return 0
        }

        function nn(a, b) {
            a = a | 0;
            b = b | 0;
            return -1 | 0
        }

        function on(a) {
            a = a | 0;
            Km(a + 8 | 0);
            Pu(a);
            return
        }

        function pn(a) {
            a = a | 0;
            Km(a + 8 | 0);
            return
        }

        function qn(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = a;
            d = c[(c[a >> 2] | 0) - 12 >> 2] | 0;
            Km(b + (d + 8) | 0);
            Pu(b + d | 0);
            return
        }

        function rn(a) {
            a = a | 0;
            Km(a + ((c[(c[a >> 2] | 0) - 12 >> 2] | 0) + 8) | 0);
            return
        }

        function sn(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0;
            d = i;
            i = i + 8 | 0;
            e = d | 0;
            f = b;
            g = c[(c[f >> 2] | 0) - 12 >> 2] | 0;
            h = b;
            if ((c[h + (g + 24) >> 2] | 0) == 0) { i = d; return b | 0 }
            j = e | 0;
            a[j] = 0;
            c[e + 4 >> 2] = b;
            do {
                if ((c[h + (g + 16) >> 2] | 0) == 0) {
                    k = c[h + (g + 72) >> 2] | 0;
                    if ((k | 0) == 0) { l = g } else {
                        sn(k) | 0;
                        l = c[(c[f >> 2] | 0) - 12 >> 2] | 0
                    }
                    a[j] = 1;
                    k = c[h + (l + 24) >> 2] | 0;
                    if (!((Fc[c[(c[k >> 2] | 0) + 24 >> 2] & 255](k) | 0) == -1)) { break }
                    k = c[(c[f >> 2] | 0) - 12 >> 2] | 0;
                    Jm(h + k | 0, c[h + (k + 16) >> 2] | 1)
                }
            } while (0);
            Cn(e);
            i = d;
            return b | 0
        }

        function tn(a) {
            a = a | 0;
            Km(a + 8 | 0);
            Pu(a);
            return
        }

        function un(a) {
            a = a | 0;
            Km(a + 8 | 0);
            return
        }

        function vn(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = a;
            d = c[(c[a >> 2] | 0) - 12 >> 2] | 0;
            Km(b + (d + 8) | 0);
            Pu(b + d | 0);
            return
        }

        function wn(a) {
            a = a | 0;
            Km(a + ((c[(c[a >> 2] | 0) - 12 >> 2] | 0) + 8) | 0);
            return
        }

        function xn(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0;
            d = i;
            i = i + 8 | 0;
            e = d | 0;
            f = b;
            g = c[(c[f >> 2] | 0) - 12 >> 2] | 0;
            h = b;
            if ((c[h + (g + 24) >> 2] | 0) == 0) { i = d; return b | 0 }
            j = e | 0;
            a[j] = 0;
            c[e + 4 >> 2] = b;
            do {
                if ((c[h + (g + 16) >> 2] | 0) == 0) {
                    k = c[h + (g + 72) >> 2] | 0;
                    if ((k | 0) == 0) { l = g } else {
                        xn(k) | 0;
                        l = c[(c[f >> 2] | 0) - 12 >> 2] | 0
                    }
                    a[j] = 1;
                    k = c[h + (l + 24) >> 2] | 0;
                    if (!((Fc[c[(c[k >> 2] | 0) + 24 >> 2] & 255](k) | 0) == -1)) { break }
                    k = c[(c[f >> 2] | 0) - 12 >> 2] | 0;
                    Jm(h + k | 0, c[h + (k + 16) >> 2] | 1)
                }
            } while (0);
            Hn(e);
            i = d;
            return b | 0
        }

        function yn(a) {
            a = a | 0;
            Km(a + 4 | 0);
            Pu(a);
            return
        }

        function zn(a) {
            a = a | 0;
            Km(a + 4 | 0);
            return
        }

        function An(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = a;
            d = c[(c[a >> 2] | 0) - 12 >> 2] | 0;
            Km(b + (d + 4) | 0);
            Pu(b + d | 0);
            return
        }

        function Bn(a) {
            a = a | 0;
            Km(a + ((c[(c[a >> 2] | 0) - 12 >> 2] | 0) + 4) | 0);
            return
        }

        function Cn(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            b = a + 4 | 0;
            a = c[b >> 2] | 0;
            d = c[(c[a >> 2] | 0) - 12 >> 2] | 0;
            e = a;
            if ((c[e + (d + 24) >> 2] | 0) == 0) { return }
            if ((c[e + (d + 16) >> 2] | 0) != 0) { return }
            if ((c[e + (d + 4) >> 2] & 8192 | 0) == 0) { return }
            if (zb() | 0) { return }
            d = c[b >> 2] | 0;
            e = c[d + ((c[(c[d >> 2] | 0) - 12 >> 2] | 0) + 24) >> 2] | 0;
            if (!((Fc[c[(c[e >> 2] | 0) + 24 >> 2] & 255](e) | 0) == -1)) { return }
            e = c[b >> 2] | 0;
            b = c[(c[e >> 2] | 0) - 12 >> 2] | 0;
            d = e;
            Jm(d + b | 0, c[d + (b + 16) >> 2] | 1);
            return
        }

        function Dn(a) {
            a = a | 0;
            Km(a + 4 | 0);
            Pu(a);
            return
        }

        function En(a) {
            a = a | 0;
            Km(a + 4 | 0);
            return
        }

        function Fn(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = a;
            d = c[(c[a >> 2] | 0) - 12 >> 2] | 0;
            Km(b + (d + 4) | 0);
            Pu(b + d | 0);
            return
        }

        function Gn(a) {
            a = a | 0;
            Km(a + ((c[(c[a >> 2] | 0) - 12 >> 2] | 0) + 4) | 0);
            return
        }

        function Hn(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            b = a + 4 | 0;
            a = c[b >> 2] | 0;
            d = c[(c[a >> 2] | 0) - 12 >> 2] | 0;
            e = a;
            if ((c[e + (d + 24) >> 2] | 0) == 0) { return }
            if ((c[e + (d + 16) >> 2] | 0) != 0) { return }
            if ((c[e + (d + 4) >> 2] & 8192 | 0) == 0) { return }
            if (zb() | 0) { return }
            d = c[b >> 2] | 0;
            e = c[d + ((c[(c[d >> 2] | 0) - 12 >> 2] | 0) + 24) >> 2] | 0;
            if (!((Fc[c[(c[e >> 2] | 0) + 24 >> 2] & 255](e) | 0) == -1)) { return }
            e = c[b >> 2] | 0;
            b = c[(c[e >> 2] | 0) - 12 >> 2] | 0;
            d = e;
            Jm(d + b | 0, c[d + (b + 16) >> 2] | 1);
            return
        }

        function In(a) { a = a | 0; return 15656 }

        function Jn(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) == 1) { pm(a, 16464, 35); return } else { hm(a, b | 0, c); return }
        }

        function Kn(a) {
            a = a | 0;
            dm(a | 0);
            return
        }

        function Ln(a) {
            a = a | 0;
            lm(a | 0);
            Pu(a);
            return
        }

        function Mn(a) {
            a = a | 0;
            lm(a | 0);
            return
        }

        function Nn(a) {
            a = a | 0;
            Km(a);
            Pu(a);
            return
        }

        function On(a) {
            a = a | 0;
            dm(a | 0);
            Pu(a);
            return
        }

        function Pn(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Qn(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Rn(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Sn(b, c, d, e, f) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            a: do {
                if ((e | 0) == (f | 0)) { g = c } else {
                    b = c;
                    h = e;
                    while (1) {
                        if ((b | 0) == (d | 0)) {
                            i = -1;
                            j = 7;
                            break
                        }
                        k = a[b] | 0;
                        l = a[h] | 0;
                        if (k << 24 >> 24 < l << 24 >> 24) {
                            i = -1;
                            j = 7;
                            break
                        }
                        if (l << 24 >> 24 < k << 24 >> 24) {
                            i = 1;
                            j = 7;
                            break
                        }
                        k = b + 1 | 0;
                        l = h + 1 | 0;
                        if ((l | 0) == (f | 0)) { g = k; break a } else {
                            b = k;
                            h = l
                        }
                    }
                    if ((j | 0) == 7) { return i | 0 }
                }
            } while (0);
            i = (g | 0) != (d | 0) | 0;
            return i | 0
        }

        function Tn(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            d = e;
            g = f - d | 0;
            if (g >>> 0 > 4294967279 >>> 0) { nm(b) }
            if (g >>> 0 < 11 >>> 0) {
                a[b] = g << 1;
                h = b + 1 | 0
            } else {
                i = g + 16 & -16;
                j = Nu(i) | 0;
                c[b + 8 >> 2] = j;
                c[b >> 2] = i | 1;
                c[b + 4 >> 2] = g;
                h = j
            }
            if ((e | 0) == (f | 0)) {
                k = h;
                a[k] = 0;
                return
            } else {
                l = h;
                m = e
            }
            while (1) {
                a[l] = a[m] | 0;
                e = m + 1 | 0;
                if ((e | 0) == (f | 0)) { break } else {
                    l = l + 1 | 0;
                    m = e
                }
            }
            k = h + (f + (-d | 0)) | 0;
            a[k] = 0;
            return
        }

        function Un(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0;
            if ((c | 0) == (d | 0)) { e = 0; return e | 0 } else {
                f = c;
                g = 0
            }
            while (1) {
                c = (a[f] | 0) + (g << 4) | 0;
                b = c & -268435456;
                h = (b >>> 24 | b) ^ c;
                c = f + 1 | 0;
                if ((c | 0) == (d | 0)) { e = h; break } else {
                    f = c;
                    g = h
                }
            }
            return e | 0
        }

        function Vn(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Wn(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Xn(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            a: do {
                if ((e | 0) == (f | 0)) {
                    g = b;
                    h = 6
                } else {
                    a = b;
                    i = e;
                    while (1) {
                        if ((a | 0) == (d | 0)) { j = -1; break a }
                        k = c[a >> 2] | 0;
                        l = c[i >> 2] | 0;
                        if ((k | 0) < (l | 0)) { j = -1; break a }
                        if ((l | 0) < (k | 0)) { j = 1; break a }
                        k = a + 4 | 0;
                        l = i + 4 | 0;
                        if ((l | 0) == (f | 0)) {
                            g = k;
                            h = 6;
                            break
                        } else {
                            a = k;
                            i = l
                        }
                    }
                }
            } while (0);
            if ((h | 0) == 6) { j = (g | 0) != (d | 0) | 0 }
            return j | 0
        }

        function Yn(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            d = e;
            g = f - d | 0;
            h = g >> 2;
            if (h >>> 0 > 1073741807 >>> 0) { nm(b) }
            if (h >>> 0 < 2 >>> 0) {
                a[b] = g >>> 1;
                i = b + 4 | 0
            } else {
                g = h + 4 & -4;
                j = Nu(g << 2) | 0;
                c[b + 8 >> 2] = j;
                c[b >> 2] = g | 1;
                c[b + 4 >> 2] = h;
                i = j
            }
            if ((e | 0) == (f | 0)) {
                k = i;
                c[k >> 2] = 0;
                return
            }
            j = f - 4 + (-d | 0) | 0;
            d = i;
            h = e;
            while (1) {
                c[d >> 2] = c[h >> 2];
                e = h + 4 | 0;
                if ((e | 0) == (f | 0)) { break } else {
                    d = d + 4 | 0;
                    h = e
                }
            }
            k = i + ((j >>> 2) + 1 << 2) | 0;
            c[k >> 2] = 0;
            return
        }

        function Zn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0;
            if ((b | 0) == (d | 0)) { e = 0; return e | 0 } else {
                f = b;
                g = 0
            }
            while (1) {
                b = (c[f >> 2] | 0) + (g << 4) | 0;
                a = b & -268435456;
                h = (a >>> 24 | a) ^ b;
                b = f + 4 | 0;
                if ((b | 0) == (d | 0)) { e = h; break } else {
                    f = b;
                    g = h
                }
            }
            return e | 0
        }

        function _n(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function $n(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function ao(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0;
            k = i;
            i = i + 112 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = k | 0;
            m = k + 16 | 0;
            n = k + 32 | 0;
            o = k + 40 | 0;
            p = k + 48 | 0;
            q = k + 56 | 0;
            r = k + 64 | 0;
            s = k + 72 | 0;
            t = k + 80 | 0;
            u = k + 104 | 0;
            if ((c[g + 4 >> 2] & 1 | 0) == 0) {
                c[n >> 2] = -1;
                v = c[(c[d >> 2] | 0) + 16 >> 2] | 0;
                w = e | 0;
                c[p >> 2] = c[w >> 2];
                c[q >> 2] = c[f >> 2];
                Mc[v & 127](o, d, p, q, g, h, n);
                q = c[o >> 2] | 0;
                c[w >> 2] = q;
                w = c[n >> 2] | 0;
                if ((w | 0) == 0) { a[j] = 0 } else if ((w | 0) == 1) { a[j] = 1 } else {
                    a[j] = 1;
                    c[h >> 2] = 4
                }
                c[b >> 2] = q;
                i = k;
                return
            }
            Lm(r, g);
            q = r | 0;
            r = c[q >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[m >> 2] = 34864;
                c[m + 4 >> 2] = 16;
                c[m + 8 >> 2] = 0;
                mm(34864, m, 114)
            }
            m = (c[8717] | 0) - 1 | 0;
            w = c[r + 8 >> 2] | 0;
            do {
                if ((c[r + 12 >> 2] | 0) - w >> 2 >>> 0 > m >>> 0) {
                    n = c[w + (m << 2) >> 2] | 0;
                    if ((n | 0) == 0) { break }
                    o = n;
                    Ul(c[q >> 2] | 0) | 0;
                    Lm(s, g);
                    n = s | 0;
                    p = c[n >> 2] | 0;
                    if (!((c[8620] | 0) == -1)) {
                        c[l >> 2] = 34480;
                        c[l + 4 >> 2] = 16;
                        c[l + 8 >> 2] = 0;
                        mm(34480, l, 114)
                    }
                    d = (c[8621] | 0) - 1 | 0;
                    v = c[p + 8 >> 2] | 0;
                    do {
                        if ((c[p + 12 >> 2] | 0) - v >> 2 >>> 0 > d >>> 0) {
                            x = c[v + (d << 2) >> 2] | 0;
                            if ((x | 0) == 0) { break }
                            y = x;
                            Ul(c[n >> 2] | 0) | 0;
                            z = t | 0;
                            A = x;
                            Ec[c[(c[A >> 2] | 0) + 24 >> 2] & 127](z, y);
                            Ec[c[(c[A >> 2] | 0) + 28 >> 2] & 127](t + 12 | 0, y);
                            c[u >> 2] = c[f >> 2];
                            y = (bo(e, u, z, t + 24 | 0, o, h, 1) | 0) == (z | 0) | 0;
                            a[j] = y;
                            c[b >> 2] = c[e >> 2];
                            rm(t + 12 | 0);
                            rm(t | 0);
                            i = k;
                            return
                        }
                    } while (0);
                    o = pc(4) | 0;
                    lu(o);
                    Fb(o | 0, 25544, 156)
                }
            } while (0);
            k = pc(4) | 0;
            lu(k);
            Fb(k | 0, 25544, 156)
        }

        function bo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0;
            k = i;
            i = i + 104 | 0;
            l = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[l >> 2];
            l = (f - e | 0) / 12 | 0;
            m = k | 0;
            do {
                if (l >>> 0 > 100 >>> 0) {
                    n = Gu(l) | 0;
                    if ((n | 0) != 0) {
                        o = n;
                        p = n;
                        break
                    }
                    Uu();
                    o = 0;
                    p = 0
                } else {
                    o = m;
                    p = 0
                }
            } while (0);
            m = (e | 0) == (f | 0);
            if (m) {
                q = l;
                r = 0
            } else {
                n = l;
                l = 0;
                s = o;
                t = e;
                while (1) {
                    u = a[t] | 0;
                    if ((u & 1) == 0) { v = (u & 255) >>> 1 } else { v = c[t + 4 >> 2] | 0 }
                    if ((v | 0) == 0) {
                        a[s] = 2;
                        w = l + 1 | 0;
                        x = n - 1 | 0
                    } else {
                        a[s] = 1;
                        w = l;
                        x = n
                    }
                    u = t + 12 | 0;
                    if ((u | 0) == (f | 0)) {
                        q = x;
                        r = w;
                        break
                    } else {
                        n = x;
                        l = w;
                        s = s + 1 | 0;
                        t = u
                    }
                }
            }
            t = b | 0;
            b = d | 0;
            d = g;
            s = 0;
            w = r;
            r = q;
            a: while (1) {
                q = c[t >> 2] | 0;
                do {
                    if ((q | 0) == 0) { y = 0 } else {
                        if ((c[q + 12 >> 2] | 0) != (c[q + 16 >> 2] | 0)) { y = q; break }
                        if ((Fc[c[(c[q >> 2] | 0) + 36 >> 2] & 255](q) | 0) == -1) {
                            c[t >> 2] = 0;
                            y = 0;
                            break
                        } else { y = c[t >> 2] | 0; break }
                    }
                } while (0);
                q = (y | 0) == 0;
                l = c[b >> 2] | 0;
                do {
                    if ((l | 0) == 0) { z = 0 } else {
                        if ((c[l + 12 >> 2] | 0) != (c[l + 16 >> 2] | 0)) { z = l; break }
                        if (!((Fc[c[(c[l >> 2] | 0) + 36 >> 2] & 255](l) | 0) == -1)) { z = l; break }
                        c[b >> 2] = 0;
                        z = 0
                    }
                } while (0);
                A = (z | 0) == 0;
                B = c[t >> 2] | 0;
                if (!((q ^ A) & (r | 0) != 0)) { break }
                l = c[B + 12 >> 2] | 0;
                if ((l | 0) == (c[B + 16 >> 2] | 0)) { C = (Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0) & 255 } else { C = a[l] | 0 }
                if (j) { D = C } else { D = Qc[c[(c[d >> 2] | 0) + 12 >> 2] & 63](g, C) | 0 }
                l = s + 1 | 0;
                if (m) {
                    s = l;
                    w = w;
                    r = r;
                    continue
                }
                b: do {
                    if (j) {
                        x = r;
                        n = w;
                        v = o;
                        u = 0;
                        E = e;
                        while (1) {
                            do {
                                if ((a[v] | 0) == 1) {
                                    F = a[E] | 0;
                                    G = (F & 1) == 0;
                                    if (G) { H = E + 1 | 0 } else { H = c[E + 8 >> 2] | 0 }
                                    if (!(D << 24 >> 24 == (a[H + s | 0] | 0))) {
                                        a[v] = 0;
                                        I = u;
                                        J = n;
                                        K = x - 1 | 0;
                                        break
                                    }
                                    if (G) { L = (F & 255) >>> 1 } else { L = c[E + 4 >> 2] | 0 }
                                    if ((L | 0) != (l | 0)) {
                                        I = 1;
                                        J = n;
                                        K = x;
                                        break
                                    }
                                    a[v] = 2;
                                    I = 1;
                                    J = n + 1 | 0;
                                    K = x - 1 | 0
                                } else {
                                    I = u;
                                    J = n;
                                    K = x
                                }
                            } while (0);
                            F = E + 12 | 0;
                            if ((F | 0) == (f | 0)) {
                                M = K;
                                N = J;
                                O = I;
                                break b
                            }
                            x = K;
                            n = J;
                            v = v + 1 | 0;
                            u = I;
                            E = F
                        }
                    } else {
                        E = r;
                        u = w;
                        v = o;
                        n = 0;
                        x = e;
                        while (1) {
                            do {
                                if ((a[v] | 0) == 1) {
                                    F = x;
                                    if ((a[F] & 1) == 0) { P = x + 1 | 0 } else { P = c[x + 8 >> 2] | 0 }
                                    if (!(D << 24 >> 24 == (Qc[c[(c[d >> 2] | 0) + 12 >> 2] & 63](g, a[P + s | 0] | 0) | 0) << 24 >> 24)) {
                                        a[v] = 0;
                                        Q = n;
                                        R = u;
                                        S = E - 1 | 0;
                                        break
                                    }
                                    G = a[F] | 0;
                                    if ((G & 1) == 0) { T = (G & 255) >>> 1 } else { T = c[x + 4 >> 2] | 0 }
                                    if ((T | 0) != (l | 0)) {
                                        Q = 1;
                                        R = u;
                                        S = E;
                                        break
                                    }
                                    a[v] = 2;
                                    Q = 1;
                                    R = u + 1 | 0;
                                    S = E - 1 | 0
                                } else {
                                    Q = n;
                                    R = u;
                                    S = E
                                }
                            } while (0);
                            G = x + 12 | 0;
                            if ((G | 0) == (f | 0)) {
                                M = S;
                                N = R;
                                O = Q;
                                break b
                            }
                            E = S;
                            u = R;
                            v = v + 1 | 0;
                            n = Q;
                            x = G
                        }
                    }
                } while (0);
                if (!O) {
                    s = l;
                    w = N;
                    r = M;
                    continue
                }
                q = c[t >> 2] | 0;
                x = q + 12 | 0;
                n = c[x >> 2] | 0;
                if ((n | 0) == (c[q + 16 >> 2] | 0)) { Fc[c[(c[q >> 2] | 0) + 40 >> 2] & 255](q) | 0 } else { c[x >> 2] = n + 1 }
                if ((M + N | 0) >>> 0 < 2 >>> 0) {
                    s = l;
                    w = N;
                    r = M;
                    continue
                } else {
                    U = N;
                    V = o;
                    W = e
                }
                while (1) {
                    do {
                        if ((a[V] | 0) == 2) {
                            n = a[W] | 0;
                            if ((n & 1) == 0) { X = (n & 255) >>> 1 } else { X = c[W + 4 >> 2] | 0 }
                            if ((X | 0) == (l | 0)) { Y = U; break }
                            a[V] = 0;
                            Y = U - 1 | 0
                        } else { Y = U }
                    } while (0);
                    n = W + 12 | 0;
                    if ((n | 0) == (f | 0)) {
                        s = l;
                        w = Y;
                        r = M;
                        continue a
                    } else {
                        U = Y;
                        V = V + 1 | 0;
                        W = n
                    }
                }
            }
            do {
                if ((B | 0) == 0) { Z = 0 } else {
                    if ((c[B + 12 >> 2] | 0) != (c[B + 16 >> 2] | 0)) { Z = B; break }
                    if ((Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0) == -1) {
                        c[t >> 2] = 0;
                        Z = 0;
                        break
                    } else { Z = c[t >> 2] | 0; break }
                }
            } while (0);
            t = (Z | 0) == 0;
            do {
                if (A) { _ = 92 } else {
                    if ((c[z + 12 >> 2] | 0) != (c[z + 16 >> 2] | 0)) { if (t) { break } else { _ = 94; break } }
                    if ((Fc[c[(c[z >> 2] | 0) + 36 >> 2] & 255](z) | 0) == -1) {
                        c[b >> 2] = 0;
                        _ = 92;
                        break
                    } else { if (t) { break } else { _ = 94; break } }
                }
            } while (0);
            if ((_ | 0) == 92) { if (t) { _ = 94 } }
            if ((_ | 0) == 94) { c[h >> 2] = c[h >> 2] | 2 }
            c: do {
                if (m) { _ = 99 } else {
                    if ((a[o] | 0) == 2) { $ = e; break } else {
                        aa = e;
                        ba = o
                    }
                    while (1) {
                        t = aa + 12 | 0;
                        b = ba + 1 | 0;
                        if ((t | 0) == (f | 0)) { _ = 99; break c }
                        if ((a[b] | 0) == 2) { $ = t; break } else {
                            aa = t;
                            ba = b
                        }
                    }
                }
            } while (0);
            if ((_ | 0) == 99) {
                c[h >> 2] = c[h >> 2] | 4;
                $ = f
            }
            if ((p | 0) == 0) {
                ca = 100;
                da = 0;
                i = k;
                return $ | 0
            }
            Hu(p);
            ca = 100;
            da = 0;
            i = k;
            return $ | 0
        }

        function co(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            eo(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function eo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0;
            d = i;
            i = i + 256 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 32 | 0;
            m = d + 40 | 0;
            n = d + 56 | 0;
            o = d + 72 | 0;
            p = d + 80 | 0;
            q = d + 240 | 0;
            r = d + 248 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 64) { t = 8 } else if ((s | 0) == 0) { t = 0 } else if ((s | 0) == 8) { t = 16 } else { t = 10 }
            s = k | 0;
            Wo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = a[l] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) { A = 0 } else {
                        if ((c[u + 12 >> 2] | 0) != (c[u + 16 >> 2] | 0)) { A = u; break }
                        if (!((Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0) == -1)) { A = u; break }
                        c[x >> 2] = 0;
                        A = 0
                    }
                } while (0);
                B = (A | 0) == 0;
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { D = 21 } else {
                        if ((c[C + 12 >> 2] | 0) != (c[C + 16 >> 2] | 0)) {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                        if ((Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0) == -1) {
                            c[e >> 2] = 0;
                            D = 21;
                            break
                        } else {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((D | 0) == 21) {
                    D = 0;
                    if (B) {
                        F = l;
                        G = 0;
                        break
                    } else { E = 0 }
                }
                C = a[g] | 0;
                H = (C & 1) == 0;
                if (H) { I = (C & 255) >>> 1 } else { I = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (I | 0)) {
                    if (H) {
                        J = (C & 255) >>> 1;
                        K = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        J = C;
                        K = C
                    }
                    tm(n, J << 1, 0);
                    if ((a[g] & 1) == 0) { L = 10 } else { L = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, L, 0);
                    if ((a[g] & 1) == 0) { M = v } else { M = c[w >> 2] | 0 }
                    c[o >> 2] = M + K;
                    N = M
                } else { N = l }
                C = A + 12 | 0;
                H = c[C >> 2] | 0;
                O = A + 16 | 0;
                if ((H | 0) == (c[O >> 2] | 0)) { P = (Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) & 255 } else { P = a[H] | 0 }
                if ((wo(P, t, N, o, r, z, m, k, q, s) | 0) != 0) {
                    F = N;
                    G = E;
                    break
                }
                H = c[C >> 2] | 0;
                if ((H | 0) == (c[O >> 2] | 0)) {
                    Fc[c[(c[A >> 2] | 0) + 40 >> 2] & 255](A) | 0;
                    l = N;
                    u = A;
                    continue
                } else {
                    c[C >> 2] = H + 1;
                    l = N;
                    u = A;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { Q = (u & 255) >>> 1 } else { Q = c[m + 4 >> 2] | 0 }
            do {
                if ((Q | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    N = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = N
                }
            } while (0);
            r = Rt(F, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((A | 0) == 0) { R = 0 } else {
                    if ((c[A + 12 >> 2] | 0) != (c[A + 16 >> 2] | 0)) { R = A; break }
                    if (!((Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) == -1)) { R = A; break }
                    c[x >> 2] = 0;
                    R = 0
                }
            } while (0);
            x = (R | 0) == 0;
            do {
                if ((G | 0) == 0) { D = 66 } else {
                    if ((c[G + 12 >> 2] | 0) != (c[G + 16 >> 2] | 0)) {
                        if (!x) { break }
                        S = b | 0;
                        c[S >> 2] = R;
                        T = 160;
                        U = 0;
                        rm(n);
                        rm(m);
                        i = d;
                        return
                    }
                    if ((Fc[c[(c[G >> 2] | 0) + 36 >> 2] & 255](G) | 0) == -1) {
                        c[e >> 2] = 0;
                        D = 66;
                        break
                    }
                    if (!(x ^ (G | 0) == 0)) { break }
                    S = b | 0;
                    c[S >> 2] = R;
                    T = 160;
                    U = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((D | 0) == 66) {
                    if (x) { break }
                    S = b | 0;
                    c[S >> 2] = R;
                    T = 160;
                    U = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            S = b | 0;
            c[S >> 2] = R;
            T = 160;
            U = 0;
            rm(n);
            rm(m);
            i = d;
            return
        }

        function fo(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            go(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function go(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0;
            d = i;
            i = i + 256 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 32 | 0;
            m = d + 40 | 0;
            n = d + 56 | 0;
            o = d + 72 | 0;
            p = d + 80 | 0;
            q = d + 240 | 0;
            r = d + 248 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 64) { t = 8 } else if ((s | 0) == 8) { t = 16 } else if ((s | 0) == 0) { t = 0 } else { t = 10 }
            s = k | 0;
            Wo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = a[l] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) { A = 0 } else {
                        if ((c[u + 12 >> 2] | 0) != (c[u + 16 >> 2] | 0)) { A = u; break }
                        if (!((Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0) == -1)) { A = u; break }
                        c[x >> 2] = 0;
                        A = 0
                    }
                } while (0);
                B = (A | 0) == 0;
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { D = 21 } else {
                        if ((c[C + 12 >> 2] | 0) != (c[C + 16 >> 2] | 0)) {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                        if ((Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0) == -1) {
                            c[e >> 2] = 0;
                            D = 21;
                            break
                        } else {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((D | 0) == 21) {
                    D = 0;
                    if (B) {
                        F = l;
                        G = 0;
                        break
                    } else { E = 0 }
                }
                C = a[g] | 0;
                H = (C & 1) == 0;
                if (H) { I = (C & 255) >>> 1 } else { I = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (I | 0)) {
                    if (H) {
                        J = (C & 255) >>> 1;
                        L = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        J = C;
                        L = C
                    }
                    tm(n, J << 1, 0);
                    if ((a[g] & 1) == 0) { M = 10 } else { M = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, M, 0);
                    if ((a[g] & 1) == 0) { N = v } else { N = c[w >> 2] | 0 }
                    c[o >> 2] = N + L;
                    O = N
                } else { O = l }
                C = A + 12 | 0;
                H = c[C >> 2] | 0;
                P = A + 16 | 0;
                if ((H | 0) == (c[P >> 2] | 0)) { Q = (Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) & 255 } else { Q = a[H] | 0 }
                if ((wo(Q, t, O, o, r, z, m, k, q, s) | 0) != 0) {
                    F = O;
                    G = E;
                    break
                }
                H = c[C >> 2] | 0;
                if ((H | 0) == (c[P >> 2] | 0)) {
                    Fc[c[(c[A >> 2] | 0) + 40 >> 2] & 255](A) | 0;
                    l = O;
                    u = A;
                    continue
                } else {
                    c[C >> 2] = H + 1;
                    l = O;
                    u = A;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { R = (u & 255) >>> 1 } else { R = c[m + 4 >> 2] | 0 }
            do {
                if ((R | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    O = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = O
                }
            } while (0);
            r = Qt(F, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            c[j + 4 >> 2] = K;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((A | 0) == 0) { S = 0 } else {
                    if ((c[A + 12 >> 2] | 0) != (c[A + 16 >> 2] | 0)) { S = A; break }
                    if (!((Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) == -1)) { S = A; break }
                    c[x >> 2] = 0;
                    S = 0
                }
            } while (0);
            x = (S | 0) == 0;
            do {
                if ((G | 0) == 0) { D = 66 } else {
                    if ((c[G + 12 >> 2] | 0) != (c[G + 16 >> 2] | 0)) {
                        if (!x) { break }
                        T = b | 0;
                        c[T >> 2] = S;
                        U = 160;
                        V = 0;
                        rm(n);
                        rm(m);
                        i = d;
                        return
                    }
                    if ((Fc[c[(c[G >> 2] | 0) + 36 >> 2] & 255](G) | 0) == -1) {
                        c[e >> 2] = 0;
                        D = 66;
                        break
                    }
                    if (!(x ^ (G | 0) == 0)) { break }
                    T = b | 0;
                    c[T >> 2] = S;
                    U = 160;
                    V = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((D | 0) == 66) {
                    if (x) { break }
                    T = b | 0;
                    c[T >> 2] = S;
                    U = 160;
                    V = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            T = b | 0;
            c[T >> 2] = S;
            U = 160;
            V = 0;
            rm(n);
            rm(m);
            i = d;
            return
        }

        function ho(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            io(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function io(d, e, f, g, h, j, k) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0;
            e = i;
            i = i + 256 | 0;
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = g;
            g = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[g >> 2] = c[l >> 2];
            l = e | 0;
            m = e + 32 | 0;
            n = e + 40 | 0;
            o = e + 56 | 0;
            p = e + 72 | 0;
            q = e + 80 | 0;
            r = e + 240 | 0;
            s = e + 248 | 0;
            t = c[h + 4 >> 2] & 74;
            if ((t | 0) == 64) { u = 8 } else if ((t | 0) == 0) { u = 0 } else if ((t | 0) == 8) { u = 16 } else { u = 10 }
            t = l | 0;
            Wo(n, h, t, m);
            h = o;
            dv(h | 0, 0, 12) | 0;
            tm(o, 10, 0);
            if ((a[h] & 1) == 0) {
                l = o + 1 | 0;
                v = l;
                w = l;
                x = o + 8 | 0
            } else {
                l = o + 8 | 0;
                v = c[l >> 2] | 0;
                w = o + 1 | 0;
                x = l
            }
            c[p >> 2] = v;
            l = q | 0;
            c[r >> 2] = l;
            c[s >> 2] = 0;
            y = f | 0;
            f = g | 0;
            g = o | 0;
            z = o + 4 | 0;
            A = a[m] | 0;
            m = v;
            v = c[y >> 2] | 0;
            a: while (1) {
                do {
                    if ((v | 0) == 0) { B = 0 } else {
                        if ((c[v + 12 >> 2] | 0) != (c[v + 16 >> 2] | 0)) { B = v; break }
                        if (!((Fc[c[(c[v >> 2] | 0) + 36 >> 2] & 255](v) | 0) == -1)) { B = v; break }
                        c[y >> 2] = 0;
                        B = 0
                    }
                } while (0);
                C = (B | 0) == 0;
                D = c[f >> 2] | 0;
                do {
                    if ((D | 0) == 0) { E = 21 } else {
                        if ((c[D + 12 >> 2] | 0) != (c[D + 16 >> 2] | 0)) {
                            if (C) { F = D; break } else {
                                G = m;
                                H = D;
                                break a
                            }
                        }
                        if ((Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0) == -1) {
                            c[f >> 2] = 0;
                            E = 21;
                            break
                        } else {
                            if (C) { F = D; break } else {
                                G = m;
                                H = D;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((E | 0) == 21) {
                    E = 0;
                    if (C) {
                        G = m;
                        H = 0;
                        break
                    } else { F = 0 }
                }
                D = a[h] | 0;
                I = (D & 1) == 0;
                if (I) { J = (D & 255) >>> 1 } else { J = c[z >> 2] | 0 }
                if (((c[p >> 2] | 0) - m | 0) == (J | 0)) {
                    if (I) {
                        K = (D & 255) >>> 1;
                        L = (D & 255) >>> 1
                    } else {
                        D = c[z >> 2] | 0;
                        K = D;
                        L = D
                    }
                    tm(o, K << 1, 0);
                    if ((a[h] & 1) == 0) { M = 10 } else { M = (c[g >> 2] & -2) - 1 | 0 }
                    tm(o, M, 0);
                    if ((a[h] & 1) == 0) { N = w } else { N = c[x >> 2] | 0 }
                    c[p >> 2] = N + L;
                    O = N
                } else { O = m }
                D = B + 12 | 0;
                I = c[D >> 2] | 0;
                P = B + 16 | 0;
                if ((I | 0) == (c[P >> 2] | 0)) { Q = (Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0) & 255 } else { Q = a[I] | 0 }
                if ((wo(Q, u, O, p, s, A, n, l, r, t) | 0) != 0) {
                    G = O;
                    H = F;
                    break
                }
                I = c[D >> 2] | 0;
                if ((I | 0) == (c[P >> 2] | 0)) {
                    Fc[c[(c[B >> 2] | 0) + 40 >> 2] & 255](B) | 0;
                    m = O;
                    v = B;
                    continue
                } else {
                    c[D >> 2] = I + 1;
                    m = O;
                    v = B;
                    continue
                }
            }
            v = a[n] | 0;
            if ((v & 1) == 0) { R = (v & 255) >>> 1 } else { R = c[n + 4 >> 2] | 0 }
            do {
                if ((R | 0) != 0) {
                    v = c[r >> 2] | 0;
                    if ((v - q | 0) >= 160) { break }
                    O = c[s >> 2] | 0;
                    c[r >> 2] = v + 4;
                    c[v >> 2] = O
                }
            } while (0);
            s = Pt(G, c[p >> 2] | 0, j, u) | 0;
            b[k >> 1] = s;
            hr(n, l, c[r >> 2] | 0, j);
            do {
                if ((B | 0) == 0) { S = 0 } else {
                    if ((c[B + 12 >> 2] | 0) != (c[B + 16 >> 2] | 0)) { S = B; break }
                    if (!((Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0) == -1)) { S = B; break }
                    c[y >> 2] = 0;
                    S = 0
                }
            } while (0);
            y = (S | 0) == 0;
            do {
                if ((H | 0) == 0) { E = 66 } else {
                    if ((c[H + 12 >> 2] | 0) != (c[H + 16 >> 2] | 0)) {
                        if (!y) { break }
                        T = d | 0;
                        c[T >> 2] = S;
                        U = 160;
                        V = 0;
                        rm(o);
                        rm(n);
                        i = e;
                        return
                    }
                    if ((Fc[c[(c[H >> 2] | 0) + 36 >> 2] & 255](H) | 0) == -1) {
                        c[f >> 2] = 0;
                        E = 66;
                        break
                    }
                    if (!(y ^ (H | 0) == 0)) { break }
                    T = d | 0;
                    c[T >> 2] = S;
                    U = 160;
                    V = 0;
                    rm(o);
                    rm(n);
                    i = e;
                    return
                }
            } while (0);
            do {
                if ((E | 0) == 66) {
                    if (y) { break }
                    T = d | 0;
                    c[T >> 2] = S;
                    U = 160;
                    V = 0;
                    rm(o);
                    rm(n);
                    i = e;
                    return
                }
            } while (0);
            c[j >> 2] = c[j >> 2] | 2;
            T = d | 0;
            c[T >> 2] = S;
            U = 160;
            V = 0;
            rm(o);
            rm(n);
            i = e;
            return
        }

        function jo(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            ko(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function ko(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0;
            d = i;
            i = i + 256 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 32 | 0;
            m = d + 40 | 0;
            n = d + 56 | 0;
            o = d + 72 | 0;
            p = d + 80 | 0;
            q = d + 240 | 0;
            r = d + 248 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 64) { t = 8 } else if ((s | 0) == 8) { t = 16 } else if ((s | 0) == 0) { t = 0 } else { t = 10 }
            s = k | 0;
            Wo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = a[l] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) { A = 0 } else {
                        if ((c[u + 12 >> 2] | 0) != (c[u + 16 >> 2] | 0)) { A = u; break }
                        if (!((Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0) == -1)) { A = u; break }
                        c[x >> 2] = 0;
                        A = 0
                    }
                } while (0);
                B = (A | 0) == 0;
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { D = 21 } else {
                        if ((c[C + 12 >> 2] | 0) != (c[C + 16 >> 2] | 0)) {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                        if ((Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0) == -1) {
                            c[e >> 2] = 0;
                            D = 21;
                            break
                        } else {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((D | 0) == 21) {
                    D = 0;
                    if (B) {
                        F = l;
                        G = 0;
                        break
                    } else { E = 0 }
                }
                C = a[g] | 0;
                H = (C & 1) == 0;
                if (H) { I = (C & 255) >>> 1 } else { I = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (I | 0)) {
                    if (H) {
                        J = (C & 255) >>> 1;
                        K = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        J = C;
                        K = C
                    }
                    tm(n, J << 1, 0);
                    if ((a[g] & 1) == 0) { L = 10 } else { L = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, L, 0);
                    if ((a[g] & 1) == 0) { M = v } else { M = c[w >> 2] | 0 }
                    c[o >> 2] = M + K;
                    N = M
                } else { N = l }
                C = A + 12 | 0;
                H = c[C >> 2] | 0;
                O = A + 16 | 0;
                if ((H | 0) == (c[O >> 2] | 0)) { P = (Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) & 255 } else { P = a[H] | 0 }
                if ((wo(P, t, N, o, r, z, m, k, q, s) | 0) != 0) {
                    F = N;
                    G = E;
                    break
                }
                H = c[C >> 2] | 0;
                if ((H | 0) == (c[O >> 2] | 0)) {
                    Fc[c[(c[A >> 2] | 0) + 40 >> 2] & 255](A) | 0;
                    l = N;
                    u = A;
                    continue
                } else {
                    c[C >> 2] = H + 1;
                    l = N;
                    u = A;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { Q = (u & 255) >>> 1 } else { Q = c[m + 4 >> 2] | 0 }
            do {
                if ((Q | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    N = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = N
                }
            } while (0);
            r = Ot(F, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((A | 0) == 0) { R = 0 } else {
                    if ((c[A + 12 >> 2] | 0) != (c[A + 16 >> 2] | 0)) { R = A; break }
                    if (!((Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) == -1)) { R = A; break }
                    c[x >> 2] = 0;
                    R = 0
                }
            } while (0);
            x = (R | 0) == 0;
            do {
                if ((G | 0) == 0) { D = 66 } else {
                    if ((c[G + 12 >> 2] | 0) != (c[G + 16 >> 2] | 0)) {
                        if (!x) { break }
                        S = b | 0;
                        c[S >> 2] = R;
                        T = 160;
                        U = 0;
                        rm(n);
                        rm(m);
                        i = d;
                        return
                    }
                    if ((Fc[c[(c[G >> 2] | 0) + 36 >> 2] & 255](G) | 0) == -1) {
                        c[e >> 2] = 0;
                        D = 66;
                        break
                    }
                    if (!(x ^ (G | 0) == 0)) { break }
                    S = b | 0;
                    c[S >> 2] = R;
                    T = 160;
                    U = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((D | 0) == 66) {
                    if (x) { break }
                    S = b | 0;
                    c[S >> 2] = R;
                    T = 160;
                    U = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            S = b | 0;
            c[S >> 2] = R;
            T = 160;
            U = 0;
            rm(n);
            rm(m);
            i = d;
            return
        }

        function lo(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            mo(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function mo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0;
            d = i;
            i = i + 256 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 32 | 0;
            m = d + 40 | 0;
            n = d + 56 | 0;
            o = d + 72 | 0;
            p = d + 80 | 0;
            q = d + 240 | 0;
            r = d + 248 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 64) { t = 8 } else if ((s | 0) == 0) { t = 0 } else if ((s | 0) == 8) { t = 16 } else { t = 10 }
            s = k | 0;
            Wo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = a[l] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) { A = 0 } else {
                        if ((c[u + 12 >> 2] | 0) != (c[u + 16 >> 2] | 0)) { A = u; break }
                        if (!((Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0) == -1)) { A = u; break }
                        c[x >> 2] = 0;
                        A = 0
                    }
                } while (0);
                B = (A | 0) == 0;
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { D = 21 } else {
                        if ((c[C + 12 >> 2] | 0) != (c[C + 16 >> 2] | 0)) {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                        if ((Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0) == -1) {
                            c[e >> 2] = 0;
                            D = 21;
                            break
                        } else {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((D | 0) == 21) {
                    D = 0;
                    if (B) {
                        F = l;
                        G = 0;
                        break
                    } else { E = 0 }
                }
                C = a[g] | 0;
                H = (C & 1) == 0;
                if (H) { I = (C & 255) >>> 1 } else { I = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (I | 0)) {
                    if (H) {
                        J = (C & 255) >>> 1;
                        K = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        J = C;
                        K = C
                    }
                    tm(n, J << 1, 0);
                    if ((a[g] & 1) == 0) { L = 10 } else { L = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, L, 0);
                    if ((a[g] & 1) == 0) { M = v } else { M = c[w >> 2] | 0 }
                    c[o >> 2] = M + K;
                    N = M
                } else { N = l }
                C = A + 12 | 0;
                H = c[C >> 2] | 0;
                O = A + 16 | 0;
                if ((H | 0) == (c[O >> 2] | 0)) { P = (Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) & 255 } else { P = a[H] | 0 }
                if ((wo(P, t, N, o, r, z, m, k, q, s) | 0) != 0) {
                    F = N;
                    G = E;
                    break
                }
                H = c[C >> 2] | 0;
                if ((H | 0) == (c[O >> 2] | 0)) {
                    Fc[c[(c[A >> 2] | 0) + 40 >> 2] & 255](A) | 0;
                    l = N;
                    u = A;
                    continue
                } else {
                    c[C >> 2] = H + 1;
                    l = N;
                    u = A;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { Q = (u & 255) >>> 1 } else { Q = c[m + 4 >> 2] | 0 }
            do {
                if ((Q | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    N = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = N
                }
            } while (0);
            r = Nt(F, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((A | 0) == 0) { R = 0 } else {
                    if ((c[A + 12 >> 2] | 0) != (c[A + 16 >> 2] | 0)) { R = A; break }
                    if (!((Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) == -1)) { R = A; break }
                    c[x >> 2] = 0;
                    R = 0
                }
            } while (0);
            x = (R | 0) == 0;
            do {
                if ((G | 0) == 0) { D = 66 } else {
                    if ((c[G + 12 >> 2] | 0) != (c[G + 16 >> 2] | 0)) {
                        if (!x) { break }
                        S = b | 0;
                        c[S >> 2] = R;
                        T = 160;
                        U = 0;
                        rm(n);
                        rm(m);
                        i = d;
                        return
                    }
                    if ((Fc[c[(c[G >> 2] | 0) + 36 >> 2] & 255](G) | 0) == -1) {
                        c[e >> 2] = 0;
                        D = 66;
                        break
                    }
                    if (!(x ^ (G | 0) == 0)) { break }
                    S = b | 0;
                    c[S >> 2] = R;
                    T = 160;
                    U = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((D | 0) == 66) {
                    if (x) { break }
                    S = b | 0;
                    c[S >> 2] = R;
                    T = 160;
                    U = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            S = b | 0;
            c[S >> 2] = R;
            T = 160;
            U = 0;
            rm(n);
            rm(m);
            i = d;
            return
        }

        function no(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            oo(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function oo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0;
            d = i;
            i = i + 256 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 32 | 0;
            m = d + 40 | 0;
            n = d + 56 | 0;
            o = d + 72 | 0;
            p = d + 80 | 0;
            q = d + 240 | 0;
            r = d + 248 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 64) { t = 8 } else if ((s | 0) == 8) { t = 16 } else if ((s | 0) == 0) { t = 0 } else { t = 10 }
            s = k | 0;
            Wo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = a[l] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) { A = 0 } else {
                        if ((c[u + 12 >> 2] | 0) != (c[u + 16 >> 2] | 0)) { A = u; break }
                        if (!((Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0) == -1)) { A = u; break }
                        c[x >> 2] = 0;
                        A = 0
                    }
                } while (0);
                B = (A | 0) == 0;
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { D = 21 } else {
                        if ((c[C + 12 >> 2] | 0) != (c[C + 16 >> 2] | 0)) {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                        if ((Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0) == -1) {
                            c[e >> 2] = 0;
                            D = 21;
                            break
                        } else {
                            if (B) { E = C; break } else {
                                F = l;
                                G = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((D | 0) == 21) {
                    D = 0;
                    if (B) {
                        F = l;
                        G = 0;
                        break
                    } else { E = 0 }
                }
                C = a[g] | 0;
                H = (C & 1) == 0;
                if (H) { I = (C & 255) >>> 1 } else { I = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (I | 0)) {
                    if (H) {
                        J = (C & 255) >>> 1;
                        L = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        J = C;
                        L = C
                    }
                    tm(n, J << 1, 0);
                    if ((a[g] & 1) == 0) { M = 10 } else { M = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, M, 0);
                    if ((a[g] & 1) == 0) { N = v } else { N = c[w >> 2] | 0 }
                    c[o >> 2] = N + L;
                    O = N
                } else { O = l }
                C = A + 12 | 0;
                H = c[C >> 2] | 0;
                P = A + 16 | 0;
                if ((H | 0) == (c[P >> 2] | 0)) { Q = (Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) & 255 } else { Q = a[H] | 0 }
                if ((wo(Q, t, O, o, r, z, m, k, q, s) | 0) != 0) {
                    F = O;
                    G = E;
                    break
                }
                H = c[C >> 2] | 0;
                if ((H | 0) == (c[P >> 2] | 0)) {
                    Fc[c[(c[A >> 2] | 0) + 40 >> 2] & 255](A) | 0;
                    l = O;
                    u = A;
                    continue
                } else {
                    c[C >> 2] = H + 1;
                    l = O;
                    u = A;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { R = (u & 255) >>> 1 } else { R = c[m + 4 >> 2] | 0 }
            do {
                if ((R | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    O = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = O
                }
            } while (0);
            r = Mt(F, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            c[j + 4 >> 2] = K;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((A | 0) == 0) { S = 0 } else {
                    if ((c[A + 12 >> 2] | 0) != (c[A + 16 >> 2] | 0)) { S = A; break }
                    if (!((Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) == -1)) { S = A; break }
                    c[x >> 2] = 0;
                    S = 0
                }
            } while (0);
            x = (S | 0) == 0;
            do {
                if ((G | 0) == 0) { D = 66 } else {
                    if ((c[G + 12 >> 2] | 0) != (c[G + 16 >> 2] | 0)) {
                        if (!x) { break }
                        T = b | 0;
                        c[T >> 2] = S;
                        U = 160;
                        V = 0;
                        rm(n);
                        rm(m);
                        i = d;
                        return
                    }
                    if ((Fc[c[(c[G >> 2] | 0) + 36 >> 2] & 255](G) | 0) == -1) {
                        c[e >> 2] = 0;
                        D = 66;
                        break
                    }
                    if (!(x ^ (G | 0) == 0)) { break }
                    T = b | 0;
                    c[T >> 2] = S;
                    U = 160;
                    V = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((D | 0) == 66) {
                    if (x) { break }
                    T = b | 0;
                    c[T >> 2] = S;
                    U = 160;
                    V = 0;
                    rm(n);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            T = b | 0;
            c[T >> 2] = S;
            U = 160;
            V = 0;
            rm(n);
            rm(m);
            i = d;
            return
        }

        function po(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            qo(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function qo(b, d, e, f, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0.0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            d = i;
            i = i + 280 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d + 32 | 0;
            m = d + 40 | 0;
            n = d + 48 | 0;
            o = d + 64 | 0;
            p = d + 80 | 0;
            q = d + 88 | 0;
            r = d + 248 | 0;
            s = d + 256 | 0;
            t = d + 264 | 0;
            u = d + 272 | 0;
            v = d | 0;
            Xo(n, h, v, l, m);
            h = o;
            dv(h | 0, 0, 12) | 0;
            tm(o, 10, 0);
            if ((a[h] & 1) == 0) {
                w = o + 1 | 0;
                x = w;
                y = w;
                z = o + 8 | 0
            } else {
                w = o + 8 | 0;
                x = c[w >> 2] | 0;
                y = o + 1 | 0;
                z = w
            }
            c[p >> 2] = x;
            w = q | 0;
            c[r >> 2] = w;
            c[s >> 2] = 0;
            a[t] = 1;
            a[u] = 69;
            A = e | 0;
            e = f | 0;
            f = o | 0;
            B = o + 4 | 0;
            C = a[l] | 0;
            l = a[m] | 0;
            m = x;
            x = c[A >> 2] | 0;
            a: while (1) {
                do {
                    if ((x | 0) == 0) { D = 0 } else {
                        if ((c[x + 12 >> 2] | 0) != (c[x + 16 >> 2] | 0)) { D = x; break }
                        if (!((Fc[c[(c[x >> 2] | 0) + 36 >> 2] & 255](x) | 0) == -1)) { D = x; break }
                        c[A >> 2] = 0;
                        D = 0
                    }
                } while (0);
                E = (D | 0) == 0;
                F = c[e >> 2] | 0;
                do {
                    if ((F | 0) == 0) { G = 17 } else {
                        if ((c[F + 12 >> 2] | 0) != (c[F + 16 >> 2] | 0)) {
                            if (E) { H = F; break } else {
                                I = m;
                                J = F;
                                break a
                            }
                        }
                        if ((Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0) == -1) {
                            c[e >> 2] = 0;
                            G = 17;
                            break
                        } else {
                            if (E) { H = F; break } else {
                                I = m;
                                J = F;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((G | 0) == 17) {
                    G = 0;
                    if (E) {
                        I = m;
                        J = 0;
                        break
                    } else { H = 0 }
                }
                F = a[h] | 0;
                K = (F & 1) == 0;
                if (K) { L = (F & 255) >>> 1 } else { L = c[B >> 2] | 0 }
                if (((c[p >> 2] | 0) - m | 0) == (L | 0)) {
                    if (K) {
                        M = (F & 255) >>> 1;
                        N = (F & 255) >>> 1
                    } else {
                        F = c[B >> 2] | 0;
                        M = F;
                        N = F
                    }
                    tm(o, M << 1, 0);
                    if ((a[h] & 1) == 0) { O = 10 } else { O = (c[f >> 2] & -2) - 1 | 0 }
                    tm(o, O, 0);
                    if ((a[h] & 1) == 0) { P = y } else { P = c[z >> 2] | 0 }
                    c[p >> 2] = P + N;
                    Q = P
                } else { Q = m }
                F = D + 12 | 0;
                K = c[F >> 2] | 0;
                R = D + 16 | 0;
                if ((K | 0) == (c[R >> 2] | 0)) { S = (Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0) & 255 } else { S = a[K] | 0 }
                if ((Yo(S, t, u, Q, p, C, l, n, w, r, s, v) | 0) != 0) {
                    I = Q;
                    J = H;
                    break
                }
                K = c[F >> 2] | 0;
                if ((K | 0) == (c[R >> 2] | 0)) {
                    Fc[c[(c[D >> 2] | 0) + 40 >> 2] & 255](D) | 0;
                    m = Q;
                    x = D;
                    continue
                } else {
                    c[F >> 2] = K + 1;
                    m = Q;
                    x = D;
                    continue
                }
            }
            x = a[n] | 0;
            if ((x & 1) == 0) { T = (x & 255) >>> 1 } else { T = c[n + 4 >> 2] | 0 }
            do {
                if ((T | 0) != 0) {
                    if ((a[t] | 0) == 0) { break }
                    x = c[r >> 2] | 0;
                    if ((x - q | 0) >= 160) { break }
                    Q = c[s >> 2] | 0;
                    c[r >> 2] = x + 4;
                    c[x >> 2] = Q
                }
            } while (0);
            U = +Lt(I, c[p >> 2] | 0, j);
            g[k >> 2] = U;
            hr(n, w, c[r >> 2] | 0, j);
            do {
                if ((D | 0) == 0) { V = 0 } else {
                    if ((c[D + 12 >> 2] | 0) != (c[D + 16 >> 2] | 0)) { V = D; break }
                    if (!((Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0) == -1)) { V = D; break }
                    c[A >> 2] = 0;
                    V = 0
                }
            } while (0);
            A = (V | 0) == 0;
            do {
                if ((J | 0) == 0) { G = 63 } else {
                    if ((c[J + 12 >> 2] | 0) != (c[J + 16 >> 2] | 0)) {
                        if (!A) { break }
                        W = b | 0;
                        c[W >> 2] = V;
                        X = 160;
                        Y = 0;
                        rm(o);
                        rm(n);
                        i = d;
                        return
                    }
                    if ((Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0) == -1) {
                        c[e >> 2] = 0;
                        G = 63;
                        break
                    }
                    if (!(A ^ (J | 0) == 0)) { break }
                    W = b | 0;
                    c[W >> 2] = V;
                    X = 160;
                    Y = 0;
                    rm(o);
                    rm(n);
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((G | 0) == 63) {
                    if (A) { break }
                    W = b | 0;
                    c[W >> 2] = V;
                    X = 160;
                    Y = 0;
                    rm(o);
                    rm(n);
                    i = d;
                    return
                }
            } while (0);
            c[j >> 2] = c[j >> 2] | 2;
            W = b | 0;
            c[W >> 2] = V;
            X = 160;
            Y = 0;
            rm(o);
            rm(n);
            i = d;
            return
        }

        function ro(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            so(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function so(b, d, e, f, g, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0.0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            d = i;
            i = i + 280 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d + 32 | 0;
            m = d + 40 | 0;
            n = d + 48 | 0;
            o = d + 64 | 0;
            p = d + 80 | 0;
            q = d + 88 | 0;
            r = d + 248 | 0;
            s = d + 256 | 0;
            t = d + 264 | 0;
            u = d + 272 | 0;
            v = d | 0;
            Xo(n, g, v, l, m);
            g = o;
            dv(g | 0, 0, 12) | 0;
            tm(o, 10, 0);
            if ((a[g] & 1) == 0) {
                w = o + 1 | 0;
                x = w;
                y = w;
                z = o + 8 | 0
            } else {
                w = o + 8 | 0;
                x = c[w >> 2] | 0;
                y = o + 1 | 0;
                z = w
            }
            c[p >> 2] = x;
            w = q | 0;
            c[r >> 2] = w;
            c[s >> 2] = 0;
            a[t] = 1;
            a[u] = 69;
            A = e | 0;
            e = f | 0;
            f = o | 0;
            B = o + 4 | 0;
            C = a[l] | 0;
            l = a[m] | 0;
            m = x;
            x = c[A >> 2] | 0;
            a: while (1) {
                do {
                    if ((x | 0) == 0) { D = 0 } else {
                        if ((c[x + 12 >> 2] | 0) != (c[x + 16 >> 2] | 0)) { D = x; break }
                        if (!((Fc[c[(c[x >> 2] | 0) + 36 >> 2] & 255](x) | 0) == -1)) { D = x; break }
                        c[A >> 2] = 0;
                        D = 0
                    }
                } while (0);
                E = (D | 0) == 0;
                F = c[e >> 2] | 0;
                do {
                    if ((F | 0) == 0) { G = 17 } else {
                        if ((c[F + 12 >> 2] | 0) != (c[F + 16 >> 2] | 0)) {
                            if (E) { H = F; break } else {
                                I = m;
                                J = F;
                                break a
                            }
                        }
                        if ((Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0) == -1) {
                            c[e >> 2] = 0;
                            G = 17;
                            break
                        } else {
                            if (E) { H = F; break } else {
                                I = m;
                                J = F;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((G | 0) == 17) {
                    G = 0;
                    if (E) {
                        I = m;
                        J = 0;
                        break
                    } else { H = 0 }
                }
                F = a[g] | 0;
                K = (F & 1) == 0;
                if (K) { L = (F & 255) >>> 1 } else { L = c[B >> 2] | 0 }
                if (((c[p >> 2] | 0) - m | 0) == (L | 0)) {
                    if (K) {
                        M = (F & 255) >>> 1;
                        N = (F & 255) >>> 1
                    } else {
                        F = c[B >> 2] | 0;
                        M = F;
                        N = F
                    }
                    tm(o, M << 1, 0);
                    if ((a[g] & 1) == 0) { O = 10 } else { O = (c[f >> 2] & -2) - 1 | 0 }
                    tm(o, O, 0);
                    if ((a[g] & 1) == 0) { P = y } else { P = c[z >> 2] | 0 }
                    c[p >> 2] = P + N;
                    Q = P
                } else { Q = m }
                F = D + 12 | 0;
                K = c[F >> 2] | 0;
                R = D + 16 | 0;
                if ((K | 0) == (c[R >> 2] | 0)) { S = (Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0) & 255 } else { S = a[K] | 0 }
                if ((Yo(S, t, u, Q, p, C, l, n, w, r, s, v) | 0) != 0) {
                    I = Q;
                    J = H;
                    break
                }
                K = c[F >> 2] | 0;
                if ((K | 0) == (c[R >> 2] | 0)) {
                    Fc[c[(c[D >> 2] | 0) + 40 >> 2] & 255](D) | 0;
                    m = Q;
                    x = D;
                    continue
                } else {
                    c[F >> 2] = K + 1;
                    m = Q;
                    x = D;
                    continue
                }
            }
            x = a[n] | 0;
            if ((x & 1) == 0) { T = (x & 255) >>> 1 } else { T = c[n + 4 >> 2] | 0 }
            do {
                if ((T | 0) != 0) {
                    if ((a[t] | 0) == 0) { break }
                    x = c[r >> 2] | 0;
                    if ((x - q | 0) >= 160) { break }
                    Q = c[s >> 2] | 0;
                    c[r >> 2] = x + 4;
                    c[x >> 2] = Q
                }
            } while (0);
            U = +Kt(I, c[p >> 2] | 0, j);
            h[k >> 3] = U;
            hr(n, w, c[r >> 2] | 0, j);
            do {
                if ((D | 0) == 0) { V = 0 } else {
                    if ((c[D + 12 >> 2] | 0) != (c[D + 16 >> 2] | 0)) { V = D; break }
                    if (!((Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0) == -1)) { V = D; break }
                    c[A >> 2] = 0;
                    V = 0
                }
            } while (0);
            A = (V | 0) == 0;
            do {
                if ((J | 0) == 0) { G = 63 } else {
                    if ((c[J + 12 >> 2] | 0) != (c[J + 16 >> 2] | 0)) {
                        if (!A) { break }
                        W = b | 0;
                        c[W >> 2] = V;
                        X = 160;
                        Y = 0;
                        rm(o);
                        rm(n);
                        i = d;
                        return
                    }
                    if ((Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0) == -1) {
                        c[e >> 2] = 0;
                        G = 63;
                        break
                    }
                    if (!(A ^ (J | 0) == 0)) { break }
                    W = b | 0;
                    c[W >> 2] = V;
                    X = 160;
                    Y = 0;
                    rm(o);
                    rm(n);
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((G | 0) == 63) {
                    if (A) { break }
                    W = b | 0;
                    c[W >> 2] = V;
                    X = 160;
                    Y = 0;
                    rm(o);
                    rm(n);
                    i = d;
                    return
                }
            } while (0);
            c[j >> 2] = c[j >> 2] | 2;
            W = b | 0;
            c[W >> 2] = V;
            X = 160;
            Y = 0;
            rm(o);
            rm(n);
            i = d;
            return
        }

        function to(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            uo(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function uo(b, d, e, f, g, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0.0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            d = i;
            i = i + 280 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d + 32 | 0;
            m = d + 40 | 0;
            n = d + 48 | 0;
            o = d + 64 | 0;
            p = d + 80 | 0;
            q = d + 88 | 0;
            r = d + 248 | 0;
            s = d + 256 | 0;
            t = d + 264 | 0;
            u = d + 272 | 0;
            v = d | 0;
            Xo(n, g, v, l, m);
            g = o;
            dv(g | 0, 0, 12) | 0;
            tm(o, 10, 0);
            if ((a[g] & 1) == 0) {
                w = o + 1 | 0;
                x = w;
                y = w;
                z = o + 8 | 0
            } else {
                w = o + 8 | 0;
                x = c[w >> 2] | 0;
                y = o + 1 | 0;
                z = w
            }
            c[p >> 2] = x;
            w = q | 0;
            c[r >> 2] = w;
            c[s >> 2] = 0;
            a[t] = 1;
            a[u] = 69;
            A = e | 0;
            e = f | 0;
            f = o | 0;
            B = o + 4 | 0;
            C = a[l] | 0;
            l = a[m] | 0;
            m = x;
            x = c[A >> 2] | 0;
            a: while (1) {
                do {
                    if ((x | 0) == 0) { D = 0 } else {
                        if ((c[x + 12 >> 2] | 0) != (c[x + 16 >> 2] | 0)) { D = x; break }
                        if (!((Fc[c[(c[x >> 2] | 0) + 36 >> 2] & 255](x) | 0) == -1)) { D = x; break }
                        c[A >> 2] = 0;
                        D = 0
                    }
                } while (0);
                E = (D | 0) == 0;
                F = c[e >> 2] | 0;
                do {
                    if ((F | 0) == 0) { G = 17 } else {
                        if ((c[F + 12 >> 2] | 0) != (c[F + 16 >> 2] | 0)) {
                            if (E) { H = F; break } else {
                                I = m;
                                J = F;
                                break a
                            }
                        }
                        if ((Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0) == -1) {
                            c[e >> 2] = 0;
                            G = 17;
                            break
                        } else {
                            if (E) { H = F; break } else {
                                I = m;
                                J = F;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((G | 0) == 17) {
                    G = 0;
                    if (E) {
                        I = m;
                        J = 0;
                        break
                    } else { H = 0 }
                }
                F = a[g] | 0;
                K = (F & 1) == 0;
                if (K) { L = (F & 255) >>> 1 } else { L = c[B >> 2] | 0 }
                if (((c[p >> 2] | 0) - m | 0) == (L | 0)) {
                    if (K) {
                        M = (F & 255) >>> 1;
                        N = (F & 255) >>> 1
                    } else {
                        F = c[B >> 2] | 0;
                        M = F;
                        N = F
                    }
                    tm(o, M << 1, 0);
                    if ((a[g] & 1) == 0) { O = 10 } else { O = (c[f >> 2] & -2) - 1 | 0 }
                    tm(o, O, 0);
                    if ((a[g] & 1) == 0) { P = y } else { P = c[z >> 2] | 0 }
                    c[p >> 2] = P + N;
                    Q = P
                } else { Q = m }
                F = D + 12 | 0;
                K = c[F >> 2] | 0;
                R = D + 16 | 0;
                if ((K | 0) == (c[R >> 2] | 0)) { S = (Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0) & 255 } else { S = a[K] | 0 }
                if ((Yo(S, t, u, Q, p, C, l, n, w, r, s, v) | 0) != 0) {
                    I = Q;
                    J = H;
                    break
                }
                K = c[F >> 2] | 0;
                if ((K | 0) == (c[R >> 2] | 0)) {
                    Fc[c[(c[D >> 2] | 0) + 40 >> 2] & 255](D) | 0;
                    m = Q;
                    x = D;
                    continue
                } else {
                    c[F >> 2] = K + 1;
                    m = Q;
                    x = D;
                    continue
                }
            }
            x = a[n] | 0;
            if ((x & 1) == 0) { T = (x & 255) >>> 1 } else { T = c[n + 4 >> 2] | 0 }
            do {
                if ((T | 0) != 0) {
                    if ((a[t] | 0) == 0) { break }
                    x = c[r >> 2] | 0;
                    if ((x - q | 0) >= 160) { break }
                    Q = c[s >> 2] | 0;
                    c[r >> 2] = x + 4;
                    c[x >> 2] = Q
                }
            } while (0);
            U = +Jt(I, c[p >> 2] | 0, j);
            h[k >> 3] = U;
            hr(n, w, c[r >> 2] | 0, j);
            do {
                if ((D | 0) == 0) { V = 0 } else {
                    if ((c[D + 12 >> 2] | 0) != (c[D + 16 >> 2] | 0)) { V = D; break }
                    if (!((Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0) == -1)) { V = D; break }
                    c[A >> 2] = 0;
                    V = 0
                }
            } while (0);
            A = (V | 0) == 0;
            do {
                if ((J | 0) == 0) { G = 63 } else {
                    if ((c[J + 12 >> 2] | 0) != (c[J + 16 >> 2] | 0)) {
                        if (!A) { break }
                        W = b | 0;
                        c[W >> 2] = V;
                        X = 160;
                        Y = 0;
                        rm(o);
                        rm(n);
                        i = d;
                        return
                    }
                    if ((Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0) == -1) {
                        c[e >> 2] = 0;
                        G = 63;
                        break
                    }
                    if (!(A ^ (J | 0) == 0)) { break }
                    W = b | 0;
                    c[W >> 2] = V;
                    X = 160;
                    Y = 0;
                    rm(o);
                    rm(n);
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((G | 0) == 63) {
                    if (A) { break }
                    W = b | 0;
                    c[W >> 2] = V;
                    X = 160;
                    Y = 0;
                    rm(o);
                    rm(n);
                    i = d;
                    return
                }
            } while (0);
            c[j >> 2] = c[j >> 2] | 2;
            W = b | 0;
            c[W >> 2] = V;
            X = 160;
            Y = 0;
            rm(o);
            rm(n);
            i = d;
            return
        }

        function vo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0;
            d = i;
            i = i + 272 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 16 | 0;
            m = d + 48 | 0;
            n = d + 64 | 0;
            o = d + 72 | 0;
            p = d + 88 | 0;
            q = d + 96 | 0;
            r = d + 256 | 0;
            s = d + 264 | 0;
            dv(m | 0, 0, 12) | 0;
            Lm(n, g);
            g = n | 0;
            n = c[g >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[k >> 2] = 34864;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34864, k, 114)
            }
            k = (c[8717] | 0) - 1 | 0;
            t = c[n + 8 >> 2] | 0;
            do {
                if ((c[n + 12 >> 2] | 0) - t >> 2 >>> 0 > k >>> 0) {
                    u = c[t + (k << 2) >> 2] | 0;
                    if ((u | 0) == 0) { break }
                    v = l | 0;
                    Sc[c[(c[u >> 2] | 0) + 32 >> 2] & 15](u, 27208, 27234, v) | 0;
                    Ul(c[g >> 2] | 0) | 0;
                    u = o;
                    dv(u | 0, 0, 12) | 0;
                    tm(o, 10, 0);
                    if ((a[u] & 1) == 0) {
                        w = o + 1 | 0;
                        x = w;
                        y = w;
                        z = o + 8 | 0
                    } else {
                        w = o + 8 | 0;
                        x = c[w >> 2] | 0;
                        y = o + 1 | 0;
                        z = w
                    }
                    c[p >> 2] = x;
                    w = q | 0;
                    c[r >> 2] = w;
                    c[s >> 2] = 0;
                    A = e | 0;
                    B = f | 0;
                    C = o | 0;
                    D = o + 4 | 0;
                    E = x;
                    F = c[A >> 2] | 0;
                    a: while (1) {
                        do {
                            if ((F | 0) == 0) { G = 0 } else {
                                if ((c[F + 12 >> 2] | 0) != (c[F + 16 >> 2] | 0)) { G = F; break }
                                if (!((Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0) == -1)) { G = F; break }
                                c[A >> 2] = 0;
                                G = 0
                            }
                        } while (0);
                        H = (G | 0) == 0;
                        I = c[B >> 2] | 0;
                        do {
                            if ((I | 0) == 0) { J = 25 } else {
                                if ((c[I + 12 >> 2] | 0) != (c[I + 16 >> 2] | 0)) { if (H) { break } else { K = E; break a } }
                                if ((Fc[c[(c[I >> 2] | 0) + 36 >> 2] & 255](I) | 0) == -1) {
                                    c[B >> 2] = 0;
                                    J = 25;
                                    break
                                } else { if (H) { break } else { K = E; break a } }
                            }
                        } while (0);
                        if ((J | 0) == 25) { J = 0; if (H) { K = E; break } }
                        I = a[u] | 0;
                        L = (I & 1) == 0;
                        if (L) { M = (I & 255) >>> 1 } else { M = c[D >> 2] | 0 }
                        if (((c[p >> 2] | 0) - E | 0) == (M | 0)) {
                            if (L) {
                                N = (I & 255) >>> 1;
                                O = (I & 255) >>> 1
                            } else {
                                I = c[D >> 2] | 0;
                                N = I;
                                O = I
                            }
                            tm(o, N << 1, 0);
                            if ((a[u] & 1) == 0) { P = 10 } else { P = (c[C >> 2] & -2) - 1 | 0 }
                            tm(o, P, 0);
                            if ((a[u] & 1) == 0) { Q = y } else { Q = c[z >> 2] | 0 }
                            c[p >> 2] = Q + O;
                            R = Q
                        } else { R = E }
                        I = G + 12 | 0;
                        L = c[I >> 2] | 0;
                        S = G + 16 | 0;
                        if ((L | 0) == (c[S >> 2] | 0)) { T = (Fc[c[(c[G >> 2] | 0) + 36 >> 2] & 255](G) | 0) & 255 } else { T = a[L] | 0 }
                        if ((wo(T, 16, R, p, s, 0, m, w, r, v) | 0) != 0) { K = R; break }
                        L = c[I >> 2] | 0;
                        if ((L | 0) == (c[S >> 2] | 0)) {
                            Fc[c[(c[G >> 2] | 0) + 40 >> 2] & 255](G) | 0;
                            E = R;
                            F = G;
                            continue
                        } else {
                            c[I >> 2] = L + 1;
                            E = R;
                            F = G;
                            continue
                        }
                    }
                    a[K + 3 | 0] = 0;
                    do {
                        if ((a[51808] | 0) == 0) {
                            if ((ub(51808) | 0) == 0) { break }
                            F = Xa(2147483647, 14472, 0) | 0;
                            c[8330] = F
                        }
                    } while (0);
                    F = xo(K, c[8330] | 0, 11744, (E = i, i = i + 8 | 0, c[E >> 2] = j, E) | 0) | 0;
                    i = E;
                    if ((F | 0) != 1) { c[h >> 2] = 4 }
                    F = c[A >> 2] | 0;
                    do {
                        if ((F | 0) == 0) { U = 0 } else {
                            if ((c[F + 12 >> 2] | 0) != (c[F + 16 >> 2] | 0)) { U = F; break }
                            if (!((Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0) == -1)) { U = F; break }
                            c[A >> 2] = 0;
                            U = 0
                        }
                    } while (0);
                    A = (U | 0) == 0;
                    F = c[B >> 2] | 0;
                    do {
                        if ((F | 0) == 0) { J = 73 } else {
                            if ((c[F + 12 >> 2] | 0) != (c[F + 16 >> 2] | 0)) {
                                if (!A) { break }
                                V = b | 0;
                                c[V >> 2] = U;
                                W = 160;
                                X = 0;
                                rm(o);
                                rm(m);
                                i = d;
                                return
                            }
                            if ((Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0) == -1) {
                                c[B >> 2] = 0;
                                J = 73;
                                break
                            }
                            if (!(A ^ (F | 0) == 0)) { break }
                            V = b | 0;
                            c[V >> 2] = U;
                            W = 160;
                            X = 0;
                            rm(o);
                            rm(m);
                            i = d;
                            return
                        }
                    } while (0);
                    do {
                        if ((J | 0) == 73) {
                            if (A) { break }
                            V = b | 0;
                            c[V >> 2] = U;
                            W = 160;
                            X = 0;
                            rm(o);
                            rm(m);
                            i = d;
                            return
                        }
                    } while (0);
                    c[h >> 2] = c[h >> 2] | 2;
                    V = b | 0;
                    c[V >> 2] = U;
                    W = 160;
                    X = 0;
                    rm(o);
                    rm(m);
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function wo(b, d, e, f, g, h, i, j, k, l) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            m = c[f >> 2] | 0;
            n = (m | 0) == (e | 0);
            do {
                if (n) {
                    o = (a[l + 24 | 0] | 0) == b << 24 >> 24;
                    if (!o) { if (!((a[l + 25 | 0] | 0) == b << 24 >> 24)) { break } }
                    c[f >> 2] = e + 1;
                    a[e] = o ? 43 : 45;
                    c[g >> 2] = 0;
                    p = 0;
                    return p | 0
                }
            } while (0);
            o = a[i] | 0;
            if ((o & 1) == 0) { q = (o & 255) >>> 1 } else { q = c[i + 4 >> 2] | 0 }
            if ((q | 0) != 0 & b << 24 >> 24 == h << 24 >> 24) {
                h = c[k >> 2] | 0;
                if ((h - j | 0) >= 160) { p = 0; return p | 0 }
                j = c[g >> 2] | 0;
                c[k >> 2] = h + 4;
                c[h >> 2] = j;
                c[g >> 2] = 0;
                p = 0;
                return p | 0
            }
            j = l + 26 | 0;
            h = l;
            while (1) { k = h + 1 | 0; if ((a[h] | 0) == b << 24 >> 24) { r = h; break } if ((k | 0) == (j | 0)) { r = j; break } else { h = k } }
            h = r - l | 0;
            if ((h | 0) > 23) { p = -1; return p | 0 }
            do {
                if ((d | 0) == 8 | (d | 0) == 10) { if ((h | 0) < (d | 0)) { break } else { p = -1 } return p | 0 } else if ((d | 0) == 16) {
                    if ((h | 0) < 22) { break }
                    if (n) { p = -1; return p | 0 }
                    if ((m - e | 0) >= 3) { p = -1; return p | 0 }
                    if ((a[m - 1 | 0] | 0) != 48) { p = -1; return p | 0 }
                    c[g >> 2] = 0;
                    l = a[27208 + h | 0] | 0;
                    c[f >> 2] = m + 1;
                    a[m] = l;
                    p = 0;
                    return p | 0
                }
            } while (0);
            e = a[27208 + h | 0] | 0;
            c[f >> 2] = m + 1;
            a[m] = e;
            c[g >> 2] = (c[g >> 2] | 0) + 1;
            p = 0;
            return p | 0
        }

        function xo(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0;
            f = i;
            i = i + 16 | 0;
            g = f | 0;
            h = g;
            c[h >> 2] = e;
            c[h + 4 >> 2] = 0;
            h = bc(b | 0) | 0;
            b = cb(a | 0, d | 0, g | 0) | 0;
            if ((h | 0) == 0) { i = f; return b | 0 }
            bc(h | 0) | 0;
            i = f;
            return b | 0
        }

        function yo(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function zo(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Ao(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0;
            k = i;
            i = i + 112 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = k | 0;
            m = k + 16 | 0;
            n = k + 32 | 0;
            o = k + 40 | 0;
            p = k + 48 | 0;
            q = k + 56 | 0;
            r = k + 64 | 0;
            s = k + 72 | 0;
            t = k + 80 | 0;
            u = k + 104 | 0;
            if ((c[g + 4 >> 2] & 1 | 0) == 0) {
                c[n >> 2] = -1;
                v = c[(c[d >> 2] | 0) + 16 >> 2] | 0;
                w = e | 0;
                c[p >> 2] = c[w >> 2];
                c[q >> 2] = c[f >> 2];
                Mc[v & 127](o, d, p, q, g, h, n);
                q = c[o >> 2] | 0;
                c[w >> 2] = q;
                w = c[n >> 2] | 0;
                if ((w | 0) == 1) { a[j] = 1 } else if ((w | 0) == 0) { a[j] = 0 } else {
                    a[j] = 1;
                    c[h >> 2] = 4
                }
                c[b >> 2] = q;
                i = k;
                return
            }
            Lm(r, g);
            q = r | 0;
            r = c[q >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[m >> 2] = 34856;
                c[m + 4 >> 2] = 16;
                c[m + 8 >> 2] = 0;
                mm(34856, m, 114)
            }
            m = (c[8715] | 0) - 1 | 0;
            w = c[r + 8 >> 2] | 0;
            do {
                if ((c[r + 12 >> 2] | 0) - w >> 2 >>> 0 > m >>> 0) {
                    n = c[w + (m << 2) >> 2] | 0;
                    if ((n | 0) == 0) { break }
                    o = n;
                    Ul(c[q >> 2] | 0) | 0;
                    Lm(s, g);
                    n = s | 0;
                    p = c[n >> 2] | 0;
                    if (!((c[8618] | 0) == -1)) {
                        c[l >> 2] = 34472;
                        c[l + 4 >> 2] = 16;
                        c[l + 8 >> 2] = 0;
                        mm(34472, l, 114)
                    }
                    d = (c[8619] | 0) - 1 | 0;
                    v = c[p + 8 >> 2] | 0;
                    do {
                        if ((c[p + 12 >> 2] | 0) - v >> 2 >>> 0 > d >>> 0) {
                            x = c[v + (d << 2) >> 2] | 0;
                            if ((x | 0) == 0) { break }
                            y = x;
                            Ul(c[n >> 2] | 0) | 0;
                            z = t | 0;
                            A = x;
                            Ec[c[(c[A >> 2] | 0) + 24 >> 2] & 127](z, y);
                            Ec[c[(c[A >> 2] | 0) + 28 >> 2] & 127](t + 12 | 0, y);
                            c[u >> 2] = c[f >> 2];
                            y = (Bo(e, u, z, t + 24 | 0, o, h, 1) | 0) == (z | 0) | 0;
                            a[j] = y;
                            c[b >> 2] = c[e >> 2];
                            Cm(t + 12 | 0);
                            Cm(t | 0);
                            i = k;
                            return
                        }
                    } while (0);
                    o = pc(4) | 0;
                    lu(o);
                    Fb(o | 0, 25544, 156)
                }
            } while (0);
            k = pc(4) | 0;
            lu(k);
            Fb(k | 0, 25544, 156)
        }

        function Bo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0;
            k = i;
            i = i + 104 | 0;
            l = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[l >> 2];
            l = (f - e | 0) / 12 | 0;
            m = k | 0;
            do {
                if (l >>> 0 > 100 >>> 0) {
                    n = Gu(l) | 0;
                    if ((n | 0) != 0) {
                        o = n;
                        p = n;
                        break
                    }
                    Uu();
                    o = 0;
                    p = 0
                } else {
                    o = m;
                    p = 0
                }
            } while (0);
            m = (e | 0) == (f | 0);
            if (m) {
                q = l;
                r = 0
            } else {
                n = l;
                l = 0;
                s = o;
                t = e;
                while (1) {
                    u = a[t] | 0;
                    if ((u & 1) == 0) { v = (u & 255) >>> 1 } else { v = c[t + 4 >> 2] | 0 }
                    if ((v | 0) == 0) {
                        a[s] = 2;
                        w = l + 1 | 0;
                        x = n - 1 | 0
                    } else {
                        a[s] = 1;
                        w = l;
                        x = n
                    }
                    u = t + 12 | 0;
                    if ((u | 0) == (f | 0)) {
                        q = x;
                        r = w;
                        break
                    } else {
                        n = x;
                        l = w;
                        s = s + 1 | 0;
                        t = u
                    }
                }
            }
            t = b | 0;
            b = d | 0;
            d = g;
            s = 0;
            w = r;
            r = q;
            a: while (1) {
                q = c[t >> 2] | 0;
                do {
                    if ((q | 0) == 0) { y = 1 } else {
                        l = c[q + 12 >> 2] | 0;
                        if ((l | 0) == (c[q + 16 >> 2] | 0)) { z = Fc[c[(c[q >> 2] | 0) + 36 >> 2] & 255](q) | 0 } else { z = c[l >> 2] | 0 }
                        if ((z | 0) == -1) {
                            c[t >> 2] = 0;
                            y = 1;
                            break
                        } else { y = (c[t >> 2] | 0) == 0; break }
                    }
                } while (0);
                q = c[b >> 2] | 0;
                do {
                    if ((q | 0) == 0) {
                        A = 1;
                        B = 0
                    } else {
                        l = c[q + 12 >> 2] | 0;
                        if ((l | 0) == (c[q + 16 >> 2] | 0)) { C = Fc[c[(c[q >> 2] | 0) + 36 >> 2] & 255](q) | 0 } else { C = c[l >> 2] | 0 }
                        if (!((C | 0) == -1)) {
                            A = 0;
                            B = q;
                            break
                        }
                        c[b >> 2] = 0;
                        A = 1;
                        B = 0
                    }
                } while (0);
                D = c[t >> 2] | 0;
                if (!((y ^ A) & (r | 0) != 0)) { break }
                q = c[D + 12 >> 2] | 0;
                if ((q | 0) == (c[D + 16 >> 2] | 0)) { E = Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0 } else { E = c[q >> 2] | 0 }
                if (j) { F = E } else { F = Qc[c[(c[d >> 2] | 0) + 28 >> 2] & 63](g, E) | 0 }
                q = s + 1 | 0;
                if (m) {
                    s = q;
                    w = w;
                    r = r;
                    continue
                }
                b: do {
                    if (j) {
                        l = r;
                        x = w;
                        n = o;
                        v = 0;
                        u = e;
                        while (1) {
                            do {
                                if ((a[n] | 0) == 1) {
                                    G = a[u] | 0;
                                    H = (G & 1) == 0;
                                    if (H) { I = u + 4 | 0 } else { I = c[u + 8 >> 2] | 0 }
                                    if ((F | 0) != (c[I + (s << 2) >> 2] | 0)) {
                                        a[n] = 0;
                                        J = v;
                                        K = x;
                                        L = l - 1 | 0;
                                        break
                                    }
                                    if (H) { M = (G & 255) >>> 1 } else { M = c[u + 4 >> 2] | 0 }
                                    if ((M | 0) != (q | 0)) {
                                        J = 1;
                                        K = x;
                                        L = l;
                                        break
                                    }
                                    a[n] = 2;
                                    J = 1;
                                    K = x + 1 | 0;
                                    L = l - 1 | 0
                                } else {
                                    J = v;
                                    K = x;
                                    L = l
                                }
                            } while (0);
                            G = u + 12 | 0;
                            if ((G | 0) == (f | 0)) {
                                N = L;
                                O = K;
                                P = J;
                                break b
                            }
                            l = L;
                            x = K;
                            n = n + 1 | 0;
                            v = J;
                            u = G
                        }
                    } else {
                        u = r;
                        v = w;
                        n = o;
                        x = 0;
                        l = e;
                        while (1) {
                            do {
                                if ((a[n] | 0) == 1) {
                                    G = l;
                                    if ((a[G] & 1) == 0) { Q = l + 4 | 0 } else { Q = c[l + 8 >> 2] | 0 }
                                    if ((F | 0) != (Qc[c[(c[d >> 2] | 0) + 28 >> 2] & 63](g, c[Q + (s << 2) >> 2] | 0) | 0)) {
                                        a[n] = 0;
                                        R = x;
                                        S = v;
                                        T = u - 1 | 0;
                                        break
                                    }
                                    H = a[G] | 0;
                                    if ((H & 1) == 0) { U = (H & 255) >>> 1 } else { U = c[l + 4 >> 2] | 0 }
                                    if ((U | 0) != (q | 0)) {
                                        R = 1;
                                        S = v;
                                        T = u;
                                        break
                                    }
                                    a[n] = 2;
                                    R = 1;
                                    S = v + 1 | 0;
                                    T = u - 1 | 0
                                } else {
                                    R = x;
                                    S = v;
                                    T = u
                                }
                            } while (0);
                            H = l + 12 | 0;
                            if ((H | 0) == (f | 0)) {
                                N = T;
                                O = S;
                                P = R;
                                break b
                            }
                            u = T;
                            v = S;
                            n = n + 1 | 0;
                            x = R;
                            l = H
                        }
                    }
                } while (0);
                if (!P) {
                    s = q;
                    w = O;
                    r = N;
                    continue
                }
                l = c[t >> 2] | 0;
                x = l + 12 | 0;
                n = c[x >> 2] | 0;
                if ((n | 0) == (c[l + 16 >> 2] | 0)) { Fc[c[(c[l >> 2] | 0) + 40 >> 2] & 255](l) | 0 } else { c[x >> 2] = n + 4 }
                if ((N + O | 0) >>> 0 < 2 >>> 0) {
                    s = q;
                    w = O;
                    r = N;
                    continue
                } else {
                    V = O;
                    W = o;
                    X = e
                }
                while (1) {
                    do {
                        if ((a[W] | 0) == 2) {
                            n = a[X] | 0;
                            if ((n & 1) == 0) { Y = (n & 255) >>> 1 } else { Y = c[X + 4 >> 2] | 0 }
                            if ((Y | 0) == (q | 0)) { Z = V; break }
                            a[W] = 0;
                            Z = V - 1 | 0
                        } else { Z = V }
                    } while (0);
                    n = X + 12 | 0;
                    if ((n | 0) == (f | 0)) {
                        s = q;
                        w = Z;
                        r = N;
                        continue a
                    } else {
                        V = Z;
                        W = W + 1 | 0;
                        X = n
                    }
                }
            }
            do {
                if ((D | 0) == 0) { _ = 1 } else {
                    X = c[D + 12 >> 2] | 0;
                    if ((X | 0) == (c[D + 16 >> 2] | 0)) { $ = Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0 } else { $ = c[X >> 2] | 0 }
                    if (($ | 0) == -1) {
                        c[t >> 2] = 0;
                        _ = 1;
                        break
                    } else { _ = (c[t >> 2] | 0) == 0; break }
                }
            } while (0);
            do {
                if ((B | 0) == 0) { aa = 94 } else {
                    t = c[B + 12 >> 2] | 0;
                    if ((t | 0) == (c[B + 16 >> 2] | 0)) { ba = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { ba = c[t >> 2] | 0 }
                    if ((ba | 0) == -1) {
                        c[b >> 2] = 0;
                        aa = 94;
                        break
                    } else { if (_) { break } else { aa = 96; break } }
                }
            } while (0);
            if ((aa | 0) == 94) { if (_) { aa = 96 } }
            if ((aa | 0) == 96) { c[h >> 2] = c[h >> 2] | 2 }
            c: do {
                if (m) { aa = 101 } else {
                    if ((a[o] | 0) == 2) { ca = e; break } else {
                        da = e;
                        ea = o
                    }
                    while (1) {
                        _ = da + 12 | 0;
                        b = ea + 1 | 0;
                        if ((_ | 0) == (f | 0)) { aa = 101; break c }
                        if ((a[b] | 0) == 2) { ca = _; break } else {
                            da = _;
                            ea = b
                        }
                    }
                }
            } while (0);
            if ((aa | 0) == 101) {
                c[h >> 2] = c[h >> 2] | 4;
                ca = f
            }
            if ((p | 0) == 0) {
                fa = 100;
                ga = 0;
                i = k;
                return ca | 0
            }
            Hu(p);
            fa = 100;
            ga = 0;
            i = k;
            return ca | 0
        }

        function Co(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            Do(a, 0, j, k, f, g, h);
            i = b;
            return
        }



        function Xi(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0;
            j = i;
            i = i + 8 | 0;
            k = j | 0;
            a[b + 1 | 0] = 0;
            l = b + 8 | 0;
            m = c[l >> 2] | 0;
            n = e + 3 | 0;
            do {
                if ((m | 0) == 0) {
                    o = Wi(b, n) | 0;
                    c[l >> 2] = o;
                    if ((o | 0) == 0) {
                        p = 7;
                        i = j;
                        return p | 0
                    } else {
                        q = o + 8 | 0;
                        c[q >> 2] = f;
                        c[q + 4 >> 2] = g;
                        c[o + 16 >> 2] = h;
                        r = c[l >> 2] | 0;
                        break
                    }
                } else { r = m }
            } while (0);
            m = r + 24 | 0;
            o = c[m >> 2] | 0;
            q = n + o | 0;
            s = r + 28 | 0;
            if ((c[s >> 2] | 0) < (q | 0)) {
                t = Gu(q) | 0;
                if ((t | 0) == 0) {
                    p = 7;
                    i = j;
                    return p | 0
                }
                u = r + 20 | 0;
                v = c[u >> 2] | 0;
                if ((v | 0) != 0) {
                    cv(t | 0, v | 0, c[m >> 2] | 0) | 0;
                    Hu(v)
                }
                c[u >> 2] = t;
                c[s >> 2] = q;
                w = c[m >> 2] | 0;
                x = t
            } else {
                w = o;
                x = c[r + 20 >> 2] | 0
            }
            o = x + w | 0;
            do {
                if ((e | 0) > 0) {
                    w = b + 4 | 0;
                    t = b + 12 | 0;
                    m = b + 20 | 0;
                    q = b + 16 | 0;
                    s = b + 28 | 0;
                    u = b + 32 | 0;
                    v = b + 36 | 0;
                    y = d;
                    z = r;
                    A = o;
                    B = 1;
                    a: while (1) {
                        C = c[w >> 2] | 0;
                        b: do {
                            switch (C | 0) {
                                case 7:
                                    {
                                        D = a[y] | 0;
                                        if ((D << 24 >> 24 | 0) == 0) {
                                            a[A] = 0;
                                            E = A + 1 | 0;
                                            F = z;
                                            break b
                                        } else if ((D << 24 >> 24 | 0) == 1) {
                                            G = z + 24 | 0;
                                            c[G >> 2] = A - (c[z + 20 >> 2] | 0);
                                            H = c[m >> 2] | 0;
                                            I = c[q >> 2] | 0;
                                            if ((H | 0) == (I | 0)) { J = 0 } else { J = (H - I << 8) - 1 | 0 }
                                            K = c[s >> 2] | 0;
                                            L = c[u >> 2] | 0;
                                            if ((J - K | 0) == (L | 0)) {
                                                $i(t);
                                                M = c[u >> 2] | 0;
                                                N = c[s >> 2] | 0;
                                                O = c[q >> 2] | 0;
                                                P = c[m >> 2] | 0
                                            } else {
                                                M = L;
                                                N = K;
                                                O = I;
                                                P = H
                                            }
                                            H = M + N | 0;
                                            do {
                                                if ((P | 0) != (O | 0)) {
                                                    I = (c[O + (H >>> 10 << 2) >> 2] | 0) + ((H & 1023) << 2) | 0;
                                                    if ((I | 0) == 0) { break }
                                                    c[I >> 2] = z
                                                }
                                            } while (0);
                                            c[u >> 2] = M + 1;
                                            c[v >> 2] = (c[v >> 2] | 0) + (c[G >> 2] | 0);
                                            H = Wi(b, n) | 0;
                                            c[l >> 2] = H;
                                            if ((H | 0) == 0) {
                                                p = 7;
                                                Q = 48;
                                                break a
                                            }
                                            I = H + 8 | 0;
                                            c[I >> 2] = f;
                                            c[I + 4 >> 2] = g;
                                            c[H + 16 >> 2] = h;
                                            H = c[l >> 2] | 0;
                                            I = c[H + 20 >> 2] | 0;
                                            c[w >> 2] = 3;
                                            E = I;
                                            F = H;
                                            break b
                                        } else if ((D << 24 >> 24 | 0) == 3) {
                                            a[A] = 0;
                                            H = A + 2 | 0;
                                            a[A + 1 | 0] = 0;
                                            c[w >> 2] = 5;
                                            I = z + 36 | 0;
                                            K = c[I >> 2] | 0;
                                            L = (K - (c[z + 32 >> 2] | 0) >> 2) + (H - (c[z + 20 >> 2] | 0)) | 0;
                                            c[k >> 2] = L;
                                            if ((K | 0) == (c[z + 40 >> 2] | 0)) {
                                                fj(z + 32 | 0, k);
                                                E = H;
                                                F = z;
                                                break b
                                            }
                                            if ((K | 0) != 0) { c[K >> 2] = L }
                                            c[I >> 2] = K + 4;
                                            E = H;
                                            F = z;
                                            break b
                                        } else {
                                            a[A] = 0;
                                            a[A + 1 | 0] = 0;
                                            a[A + 2 | 0] = a[y] | 0;
                                            c[w >> 2] = 5;
                                            E = A + 3 | 0;
                                            F = z;
                                            break b
                                        }
                                        break
                                    };
                                case 0:
                                case 1:
                                    {
                                        if ((a[y] | 0) == 0) {
                                            c[w >> 2] = C + 1;
                                            E = A;
                                            F = z;
                                            break b
                                        } else {
                                            c[w >> 2] = 0;
                                            E = A;
                                            F = z;
                                            break b
                                        }
                                        break
                                    };
                                case 3:
                                    { a[A] = a[y] | 0;c[w >> 2] = 4;E = A + 1 | 0;F = z; break };
                                case 5:
                                    {
                                        H = a[y] | 0;
                                        if (H << 24 >> 24 == 0) {
                                            c[w >> 2] = 6;
                                            E = A;
                                            F = z;
                                            break b
                                        } else {
                                            a[A] = H;
                                            E = A + 1 | 0;
                                            F = z;
                                            break b
                                        }
                                        break
                                    };
                                case 2:
                                    {
                                        H = a[y] | 0;
                                        if ((H << 24 >> 24 | 0) == 0) {
                                            E = A;
                                            F = z;
                                            break b
                                        } else if ((H << 24 >> 24 | 0) == 1) {
                                            c[w >> 2] = 3;
                                            E = A;
                                            F = z;
                                            break b
                                        } else {
                                            c[w >> 2] = 0;
                                            E = A;
                                            F = z;
                                            break b
                                        }
                                        break
                                    };
                                case 6:
                                    {
                                        if ((a[y] | 0) == 0) {
                                            c[w >> 2] = 7;
                                            E = A;
                                            F = z;
                                            break b
                                        } else {
                                            a[A] = 0;
                                            a[A + 1 | 0] = a[y] | 0;
                                            c[w >> 2] = 5;
                                            E = A + 2 | 0;
                                            F = z;
                                            break b
                                        }
                                        break
                                    };
                                case 4:
                                    { a[A] = a[y] | 0;c[w >> 2] = 5;E = A + 1 | 0;F = z; break };
                                default:
                                    { E = A;F = z }
                            }
                        } while (0);
                        if ((B | 0) >= (e | 0)) { Q = 46; break }
                        y = y + 1 | 0;
                        z = F;
                        A = E;
                        B = B + 1 | 0
                    }
                    if ((Q | 0) == 46) {
                        R = F;
                        S = E;
                        T = c[F + 20 >> 2] | 0;
                        break
                    } else if ((Q | 0) == 48) { i = j; return p | 0 }
                } else {
                    R = r;
                    S = o;
                    T = x
                }
            } while (0);
            c[R + 24 >> 2] = S - T;
            p = 0;
            i = j;
            return p | 0
        }

        function Yi(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            if ((c[b + 8 >> 2] | 0) != 0) { ec(6496, 15256, 375, 17864); return 0 }
            a[b + 1 | 0] = 0;
            i = Wi(b, e) | 0;
            do {
                if ((i | 0) != 0) {
                    j = i + 28 | 0;
                    if ((c[j >> 2] | 0) < (e | 0)) {
                        k = Gu(e) | 0;
                        if ((k | 0) == 0) { break }
                        l = i + 20 | 0;
                        m = c[l >> 2] | 0;
                        if ((m | 0) != 0) {
                            cv(k | 0, m | 0, c[i + 24 >> 2] | 0) | 0;
                            Hu(m)
                        }
                        c[l >> 2] = k;
                        c[j >> 2] = e;
                        n = k
                    } else { n = c[i + 20 >> 2] | 0 }
                    cv(n | 0, d | 0, e) | 0;
                    k = i + 24 | 0;
                    c[k >> 2] = e;
                    j = i + 8 | 0;
                    c[j >> 2] = f;
                    c[j + 4 >> 2] = g;
                    c[i + 16 >> 2] = h;
                    Ri(i);
                    j = b + 20 | 0;
                    l = c[j >> 2] | 0;
                    m = b + 16 | 0;
                    o = c[m >> 2] | 0;
                    if ((l | 0) == (o | 0)) { p = 0 } else { p = (l - o << 8) - 1 | 0 }
                    q = b + 28 | 0;
                    r = c[q >> 2] | 0;
                    s = b + 32 | 0;
                    t = c[s >> 2] | 0;
                    if ((p - r | 0) == (t | 0)) {
                        $i(b + 12 | 0);
                        u = c[s >> 2] | 0;
                        v = c[q >> 2] | 0;
                        w = c[m >> 2] | 0;
                        x = c[j >> 2] | 0
                    } else {
                        u = t;
                        v = r;
                        w = o;
                        x = l
                    }
                    l = u + v | 0;
                    do {
                        if ((x | 0) != (w | 0)) {
                            o = (c[w + (l >>> 10 << 2) >> 2] | 0) + ((l & 1023) << 2) | 0;
                            if ((o | 0) == 0) { break }
                            c[o >> 2] = i
                        }
                    } while (0);
                    c[s >> 2] = u + 1;
                    l = b + 36 | 0;
                    c[l >> 2] = (c[l >> 2] | 0) + (c[k >> 2] | 0);
                    y = 0;
                    return y | 0
                }
            } while (0);
            Vi(b, i);
            y = 7;
            return y | 0
        }

        function Zi(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0;
            d = b + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) == 0) { f = 0; return f | 0 }
            g = b + 4 | 0;
            h = c[g >> 2] | 0;
            if ((h | 0) == 6) {
                i = e + 24 | 0;
                j = c[i >> 2] | 0;
                k = j + 1 | 0;
                l = e + 28 | 0;
                if ((c[l >> 2] | 0) < (k | 0)) {
                    m = Gu(k) | 0;
                    if ((m | 0) == 0) { f = 7; return f | 0 }
                    n = e + 20 | 0;
                    o = c[n >> 2] | 0;
                    if ((o | 0) == 0) { p = j } else {
                        cv(m | 0, o | 0, j) | 0;
                        Hu(o);
                        p = c[i >> 2] | 0
                    }
                    c[n >> 2] = m;
                    c[l >> 2] = k;
                    q = p;
                    r = m
                } else {
                    q = j;
                    r = c[e + 20 >> 2] | 0
                }
                a[r + q | 0] = 0;
                c[i >> 2] = (c[i >> 2] | 0) + 1;
                s = c[g >> 2] | 0
            } else { s = h }
            if ((s | 0) == 7) {
                h = e + 24 | 0;
                i = c[h >> 2] | 0;
                q = i + 2 | 0;
                r = e + 28 | 0;
                if ((c[r >> 2] | 0) < (q | 0)) {
                    j = Gu(q) | 0;
                    if ((j | 0) == 0) { f = 7; return f | 0 }
                    m = e + 20 | 0;
                    p = c[m >> 2] | 0;
                    if ((p | 0) == 0) { t = i } else {
                        cv(j | 0, p | 0, i) | 0;
                        Hu(p);
                        t = c[h >> 2] | 0
                    }
                    c[m >> 2] = j;
                    c[r >> 2] = q;
                    u = t;
                    v = j
                } else {
                    u = i;
                    v = c[e + 20 >> 2] | 0
                }
                i = v + u | 0;
                C = 0;
                a[i] = C;
                C = C >> 8;
                a[i + 1 | 0] = C;
                c[h >> 2] = (c[h >> 2] | 0) + 2;
                w = c[g >> 2] | 0
            } else { w = s }
            if ((w | 0) > 4) {
                w = b + 20 | 0;
                s = c[w >> 2] | 0;
                h = b + 16 | 0;
                i = c[h >> 2] | 0;
                if ((s | 0) == (i | 0)) { x = 0 } else { x = (s - i << 8) - 1 | 0 }
                u = b + 28 | 0;
                v = c[u >> 2] | 0;
                j = b + 32 | 0;
                t = c[j >> 2] | 0;
                if ((x - v | 0) == (t | 0)) {
                    $i(b + 12 | 0);
                    y = c[j >> 2] | 0;
                    z = c[u >> 2] | 0;
                    A = c[h >> 2] | 0;
                    B = c[w >> 2] | 0
                } else {
                    y = t;
                    z = v;
                    A = i;
                    B = s
                }
                s = y + z | 0;
                do {
                    if ((B | 0) != (A | 0)) {
                        z = (c[A + (s >>> 10 << 2) >> 2] | 0) + ((s & 1023) << 2) | 0;
                        if ((z | 0) == 0) { break }
                        c[z >> 2] = e
                    }
                } while (0);
                c[j >> 2] = y + 1;
                y = b + 36 | 0;
                c[y >> 2] = (c[y >> 2] | 0) + (c[e + 24 >> 2] | 0);
                c[d >> 2] = 0
            }
            c[g >> 2] = 0;
            f = 0;
            return f | 0
        }

        function _i(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            b = a + 8 | 0;
            d = c[b >> 2] | 0;
            if ((d | 0) != 0) {
                Vi(a, d);
                c[b >> 2] = 0
            }
            b = a + 32 | 0;
            d = c[b >> 2] | 0;
            if ((d | 0) == 0) {
                e = a + 36 | 0;
                f = a + 4 | 0;
                c[f >> 2] = 0;
                c[e >> 2] = 0;
                return
            }
            g = a + 16 | 0;
            h = a + 28 | 0;
            i = a + 36 | 0;
            j = d;
            while (1) {
                d = c[g >> 2] | 0;
                k = c[h >> 2] | 0;
                l = c[(c[d + (k >>> 10 << 2) >> 2] | 0) + ((k & 1023) << 2) >> 2] | 0;
                c[b >> 2] = j - 1;
                m = k + 1 | 0;
                c[h >> 2] = m;
                if (m >>> 0 > 2047 >>> 0) {
                    Pu(c[d >> 2] | 0);
                    c[g >> 2] = (c[g >> 2] | 0) + 4;
                    c[h >> 2] = (c[h >> 2] | 0) - 1024
                }
                c[i >> 2] = (c[i >> 2] | 0) - (c[l + 24 >> 2] | 0);
                if ((l | 0) == 0) {
                    e = i;
                    n = 10;
                    break
                }
                Vi(a, l);
                l = c[b >> 2] | 0;
                if ((l | 0) == 0) {
                    e = i;
                    n = 10;
                    break
                } else { j = l }
            }
            if ((n | 0) == 10) {
                f = a + 4 | 0;
                c[f >> 2] = 0;
                c[e >> 2] = 0;
                return
            }
        }

        function $i(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0;
            b = i;
            i = i + 48 | 0;
            d = b | 0;
            e = b + 8 | 0;
            f = b + 16 | 0;
            g = b + 40 | 0;
            h = a + 16 | 0;
            j = c[h >> 2] | 0;
            if (j >>> 0 > 1023 >>> 0) {
                c[h >> 2] = j - 1024;
                j = a + 4 | 0;
                h = c[j >> 2] | 0;
                k = c[h >> 2] | 0;
                l = h + 4 | 0;
                c[j >> 2] = l;
                m = a + 8 | 0;
                n = c[m >> 2] | 0;
                o = a + 12 | 0;
                do {
                    if ((n | 0) == (c[o >> 2] | 0)) {
                        p = a | 0;
                        q = c[p >> 2] | 0;
                        if (l >>> 0 > q >>> 0) {
                            r = l;
                            s = ((r - q >> 2) + 1 | 0) / -2 | 0;
                            t = n - r | 0;
                            fv(h + (s + 1 << 2) | 0, l | 0, t | 0) | 0;
                            r = h + ((t >> 2) + 1 + s << 2) | 0;
                            c[m >> 2] = r;
                            c[j >> 2] = (c[j >> 2] | 0) + (s << 2);
                            u = r;
                            v = 13;
                            break
                        }
                        r = n - q >> 1;
                        s = (r | 0) == 0 ? 1 : r;
                        r = Nu(s << 2) | 0;
                        t = r + (s >>> 2 << 2) | 0;
                        w = r + (s << 2) | 0;
                        if ((l | 0) == (n | 0)) {
                            x = t;
                            y = q
                        } else {
                            q = l;
                            s = t;
                            do {
                                if ((s | 0) == 0) { z = 0 } else {
                                    c[s >> 2] = c[q >> 2];
                                    z = s
                                }
                                s = z + 4 | 0;
                                q = q + 4 | 0;
                            } while ((q | 0) != (n | 0));
                            x = s;
                            y = c[p >> 2] | 0
                        }
                        c[p >> 2] = r;
                        c[j >> 2] = t;
                        c[m >> 2] = x;
                        c[o >> 2] = w;
                        if ((y | 0) == 0) {
                            A = x;
                            v = 12;
                            break
                        }
                        Pu(y);
                        A = c[m >> 2] | 0;
                        v = 12
                    } else {
                        A = n;
                        v = 12
                    }
                } while (0);
                if ((v | 0) == 12) {
                    if ((A | 0) == 0) { B = 0 } else {
                        u = A;
                        v = 13
                    }
                }
                if ((v | 0) == 13) {
                    c[u >> 2] = k;
                    B = c[m >> 2] | 0
                }
                c[m >> 2] = B + 4;
                i = b;
                return
            }
            B = a | 0;
            m = a + 8 | 0;
            k = c[m >> 2] | 0;
            u = a + 4 | 0;
            A = k - (c[u >> 2] | 0) >> 2;
            n = a + 12 | 0;
            y = c[n >> 2] | 0;
            x = a | 0;
            o = y - (c[x >> 2] | 0) | 0;
            if (!(A >>> 0 < o >> 2 >>> 0)) {
                j = o >> 1;
                o = (j | 0) == 0 ? 1 : j;
                j = f + 12 | 0;
                c[f + 16 >> 2] = a + 12;
                a = Nu(o << 2) | 0;
                z = f | 0;
                c[z >> 2] = a;
                l = a + (A << 2) | 0;
                A = f + 8 | 0;
                c[A >> 2] = l;
                h = f + 4 | 0;
                c[h >> 2] = l;
                c[j >> 2] = a + (o << 2);
                o = Nu(4096) | 0;
                c[g >> 2] = o;
                cj(f, g);
                g = c[m >> 2] | 0;
                while (1) {
                    if ((g | 0) == (c[u >> 2] | 0)) { break }
                    o = g - 4 | 0;
                    dj(f, o);
                    g = o
                }
                f = c[x >> 2] | 0;
                c[x >> 2] = c[z >> 2];
                c[z >> 2] = f;
                c[u >> 2] = c[h >> 2];
                c[h >> 2] = g;
                h = c[m >> 2] | 0;
                c[m >> 2] = c[A >> 2];
                c[A >> 2] = h;
                z = c[n >> 2] | 0;
                c[n >> 2] = c[j >> 2];
                c[j >> 2] = z;
                if ((h | 0) != (g | 0)) { c[A >> 2] = h + (~((h - 4 + (-g | 0) | 0) >>> 2) << 2) }
                if ((f | 0) == 0) { i = b; return }
                Pu(f);
                i = b;
                return
            }
            f = Nu(4096) | 0;
            if ((y | 0) != (k | 0)) {
                c[d >> 2] = f;
                aj(B, d);
                i = b;
                return
            }
            c[e >> 2] = f;
            bj(B, e);
            e = c[u >> 2] | 0;
            B = c[e >> 2] | 0;
            f = e + 4 | 0;
            c[u >> 2] = f;
            d = c[m >> 2] | 0;
            do {
                if ((d | 0) == (c[n >> 2] | 0)) {
                    k = c[x >> 2] | 0;
                    if (f >>> 0 > k >>> 0) {
                        y = f;
                        g = ((y - k >> 2) + 1 | 0) / -2 | 0;
                        h = d - y | 0;
                        fv(e + (g + 1 << 2) | 0, f | 0, h | 0) | 0;
                        y = e + ((h >> 2) + 1 + g << 2) | 0;
                        c[m >> 2] = y;
                        c[u >> 2] = (c[u >> 2] | 0) + (g << 2);
                        C = y;
                        v = 29;
                        break
                    }
                    y = d - k >> 1;
                    g = (y | 0) == 0 ? 1 : y;
                    y = Nu(g << 2) | 0;
                    h = y + (g >>> 2 << 2) | 0;
                    A = y + (g << 2) | 0;
                    if ((f | 0) == (d | 0)) {
                        D = h;
                        E = k
                    } else {
                        k = f;
                        g = h;
                        do {
                            if ((g | 0) == 0) { F = 0 } else {
                                c[g >> 2] = c[k >> 2];
                                F = g
                            }
                            g = F + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (d | 0));
                        D = g;
                        E = c[x >> 2] | 0
                    }
                    c[x >> 2] = y;
                    c[u >> 2] = h;
                    c[m >> 2] = D;
                    c[n >> 2] = A;
                    if ((E | 0) == 0) {
                        G = D;
                        v = 28;
                        break
                    }
                    Pu(E);
                    G = c[m >> 2] | 0;
                    v = 28
                } else {
                    G = d;
                    v = 28
                }
            } while (0);
            if ((v | 0) == 28) {
                if ((G | 0) == 0) { H = 0 } else {
                    C = G;
                    v = 29
                }
            }
            if ((v | 0) == 29) {
                c[C >> 2] = B;
                H = c[m >> 2] | 0
            }
            c[m >> 2] = H + 4;
            i = b;
            return
        }

        function aj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            f = a + 12 | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 4 | 0;
                    h = c[g >> 2] | 0;
                    i = a | 0;
                    j = c[i >> 2] | 0;
                    if (h >>> 0 > j >>> 0) {
                        k = h;
                        l = ((k - j >> 2) + 1 | 0) / -2 | 0;
                        m = e - k | 0;
                        fv(h + (l << 2) | 0, h | 0, m | 0) | 0;
                        k = h + (l + (m >> 2) << 2) | 0;
                        c[d >> 2] = k;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = k;
                        break
                    }
                    k = e - j >> 1;
                    l = (k | 0) == 0 ? 1 : k;
                    k = Nu(l << 2) | 0;
                    m = k + (l >>> 2 << 2) | 0;
                    o = k + (l << 2) | 0;
                    if ((h | 0) == (e | 0)) {
                        p = m;
                        q = j
                    } else {
                        j = h;
                        h = m;
                        do {
                            if ((h | 0) == 0) { r = 0 } else {
                                c[h >> 2] = c[j >> 2];
                                r = h
                            }
                            h = r + 4 | 0;
                            j = j + 4 | 0;
                        } while ((j | 0) != (e | 0));
                        p = h;
                        q = c[i >> 2] | 0
                    }
                    c[i >> 2] = k;
                    c[g >> 2] = m;
                    c[d >> 2] = p;
                    c[f >> 2] = o;
                    if ((q | 0) == 0) { n = p; break }
                    Pu(q);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            if ((n | 0) == 0) {
                s = 0;
                t = s + 4 | 0;
                c[d >> 2] = t;
                return
            }
            c[n >> 2] = c[b >> 2];
            s = c[d >> 2] | 0;
            t = s + 4 | 0;
            c[d >> 2] = t;
            return
        }

        function bj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            d = a + 4 | 0;
            e = c[d >> 2] | 0;
            f = a | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 8 | 0;
                    h = c[g >> 2] | 0;
                    i = a + 12 | 0;
                    j = c[i >> 2] | 0;
                    k = j;
                    if (h >>> 0 < j >>> 0) {
                        j = h;
                        l = ((k - j >> 2) + 1 | 0) / 2 | 0;
                        m = j - e | 0;
                        j = h + (l - (m >> 2) << 2) | 0;
                        fv(j | 0, e | 0, m | 0) | 0;
                        c[d >> 2] = j;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = j;
                        break
                    }
                    j = k - e >> 1;
                    k = (j | 0) == 0 ? 1 : j;
                    j = Nu(k << 2) | 0;
                    l = j + ((k + 3 | 0) >>> 2 << 2) | 0;
                    m = j + (k << 2) | 0;
                    if ((e | 0) == (h | 0)) {
                        o = l;
                        p = e
                    } else {
                        k = e;
                        q = l;
                        do {
                            if ((q | 0) == 0) { r = 0 } else {
                                c[q >> 2] = c[k >> 2];
                                r = q
                            }
                            q = r + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (h | 0));
                        o = q;
                        p = c[f >> 2] | 0
                    }
                    c[f >> 2] = j;
                    c[d >> 2] = l;
                    c[g >> 2] = o;
                    c[i >> 2] = m;
                    if ((p | 0) == 0) { n = l; break }
                    Pu(p);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            c[n - 4 >> 2] = c[b >> 2];
            c[d >> 2] = (c[d >> 2] | 0) - 4;
            return
        }

        function cj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            f = a + 12 | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 4 | 0;
                    h = c[g >> 2] | 0;
                    i = a | 0;
                    j = c[i >> 2] | 0;
                    if (h >>> 0 > j >>> 0) {
                        k = h;
                        l = ((k - j >> 2) + 1 | 0) / -2 | 0;
                        m = e - k | 0;
                        fv(h + (l << 2) | 0, h | 0, m | 0) | 0;
                        k = h + (l + (m >> 2) << 2) | 0;
                        c[d >> 2] = k;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = k;
                        break
                    }
                    k = e - j >> 1;
                    l = (k | 0) == 0 ? 1 : k;
                    k = Nu(l << 2) | 0;
                    m = k + (l >>> 2 << 2) | 0;
                    o = k + (l << 2) | 0;
                    if ((h | 0) == (e | 0)) {
                        p = m;
                        q = j
                    } else {
                        j = h;
                        h = m;
                        do {
                            if ((h | 0) == 0) { r = 0 } else {
                                c[h >> 2] = c[j >> 2];
                                r = h
                            }
                            h = r + 4 | 0;
                            j = j + 4 | 0;
                        } while ((j | 0) != (e | 0));
                        p = h;
                        q = c[i >> 2] | 0
                    }
                    c[i >> 2] = k;
                    c[g >> 2] = m;
                    c[d >> 2] = p;
                    c[f >> 2] = o;
                    if ((q | 0) == 0) { n = p; break }
                    Pu(q);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            if ((n | 0) == 0) {
                s = 0;
                t = s + 4 | 0;
                c[d >> 2] = t;
                return
            }
            c[n >> 2] = c[b >> 2];
            s = c[d >> 2] | 0;
            t = s + 4 | 0;
            c[d >> 2] = t;
            return
        }

        function dj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            d = a + 4 | 0;
            e = c[d >> 2] | 0;
            f = a | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 8 | 0;
                    h = c[g >> 2] | 0;
                    i = a + 12 | 0;
                    j = c[i >> 2] | 0;
                    k = j;
                    if (h >>> 0 < j >>> 0) {
                        j = h;
                        l = ((k - j >> 2) + 1 | 0) / 2 | 0;
                        m = j - e | 0;
                        j = h + (l - (m >> 2) << 2) | 0;
                        fv(j | 0, e | 0, m | 0) | 0;
                        c[d >> 2] = j;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = j;
                        break
                    }
                    j = k - e >> 1;
                    k = (j | 0) == 0 ? 1 : j;
                    j = Nu(k << 2) | 0;
                    l = j + ((k + 3 | 0) >>> 2 << 2) | 0;
                    m = j + (k << 2) | 0;
                    if ((e | 0) == (h | 0)) {
                        o = l;
                        p = e
                    } else {
                        k = e;
                        q = l;
                        do {
                            if ((q | 0) == 0) { r = 0 } else {
                                c[q >> 2] = c[k >> 2];
                                r = q
                            }
                            q = r + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (h | 0));
                        o = q;
                        p = c[f >> 2] | 0
                    }
                    c[f >> 2] = j;
                    c[d >> 2] = l;
                    c[g >> 2] = o;
                    c[i >> 2] = m;
                    if ((p | 0) == 0) { n = l; break }
                    Pu(p);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            c[n - 4 >> 2] = c[b >> 2];
            c[d >> 2] = (c[d >> 2] | 0) - 4;
            return
        }

        function ej(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = h >> 2;
            j = i + 1 | 0;
            if (j >>> 0 > 1073741823 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = (c[k >> 2] | 0) - g | 0;
            if (a >> 2 >>> 0 < 536870911 >>> 0) {
                g = a >> 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 1073741823;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n << 2) | 0;
                m = n
            }
            n = l + (i << 2) | 0;
            if ((n | 0) != 0) { c[n >> 2] = c[b >> 2] }
            b = f;
            cv(l | 0, b | 0, h) | 0;
            c[e >> 2] = l;
            c[d >> 2] = l + (j << 2);
            c[k >> 2] = l + (m << 2);
            if ((f | 0) == 0) { return }
            Pu(b);
            return
        }

        function fj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = h >> 2;
            j = i + 1 | 0;
            if (j >>> 0 > 1073741823 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = (c[k >> 2] | 0) - g | 0;
            if (a >> 2 >>> 0 < 536870911 >>> 0) {
                g = a >> 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 1073741823;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n << 2) | 0;
                m = n
            }
            n = l + (i << 2) | 0;
            if ((n | 0) != 0) { c[n >> 2] = c[b >> 2] }
            b = f;
            cv(l | 0, b | 0, h) | 0;
            c[e >> 2] = l;
            c[d >> 2] = l + (j << 2);
            c[k >> 2] = l + (m << 2);
            if ((f | 0) == 0) { return }
            Pu(b);
            return
        }

        function gj(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            b = a + 4 | 0;
            d = c[b >> 2] | 0;
            e = a + 16 | 0;
            f = c[e >> 2] | 0;
            g = d + (f >>> 10 << 2) | 0;
            h = a + 8 | 0;
            i = c[h >> 2] | 0;
            if ((i | 0) == (d | 0)) {
                j = 0;
                k = 0;
                l = a + 20 | 0
            } else {
                m = a + 20 | 0;
                a = f + (c[m >> 2] | 0) | 0;
                j = (c[d + (a >>> 10 << 2) >> 2] | 0) + ((a & 1023) << 2) | 0;
                k = (c[g >> 2] | 0) + ((f & 1023) << 2) | 0;
                l = m
            }
            m = g;
            g = k;
            a: while (1) {
                k = g;
                do {
                    if ((k | 0) == (j | 0)) { break a }
                    k = k + 4 | 0;
                } while ((k - (c[m >> 2] | 0) | 0) != 4096);
                k = m + 4 | 0;
                m = k;
                g = c[k >> 2] | 0
            }
            c[l >> 2] = 0;
            l = i - d >> 2;
            if (l >>> 0 > 2 >>> 0) {
                i = d;
                while (1) {
                    Pu(c[i >> 2] | 0);
                    d = (c[b >> 2] | 0) + 4 | 0;
                    c[b >> 2] = d;
                    g = (c[h >> 2] | 0) - d >> 2;
                    if (g >>> 0 > 2 >>> 0) { i = d } else { n = g; break }
                }
            } else { n = l }
            if ((n | 0) == 2) { c[e >> 2] = 1024; return } else if ((n | 0) == 1) { c[e >> 2] = 512; return } else { return }
        }

        function hj(b, e, f, g) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            h = a[g + 2 | 0] | 0;
            if ((a[g + 13 | 0] | 0) != 0) {
                g = (qd(e) | 0) + 2 & 255;
                a[b | 0] = g
            }
            g = (nd(e, 1) | 0) != 0;
            a[b + 1 | 0] = g & 1;
            i = f + 11096 + (h * 5168 | 0) + 5012 | 0;
            if (!((c[i >> 2] | 0) == 3 | g ^ 1)) { Ue(f + 4 | 0, 1006, 0) }
            g = (nd(e, 1) | 0) != 0;
            j = b + 2 | 0;
            k = g & 1;
            a[j] = k;
            if ((c[i >> 2] | 0) != 0 | g ^ 1) { l = k } else {
                Ue(f + 4 | 0, 1006, 0);
                l = a[j] | 0
            }
            a: do {
                if (!(l << 24 >> 24 == 0)) {
                    j = qd(e) | 0;
                    do {
                        if (!((j | 0) == -99999)) {
                            if ((j | 0) > (c[f + 11096 + (h * 5168 | 0) + 616 >> 2] | 0)) { break }
                            a[b + 3 | 0] = j;
                            k = qd(e) | 0;
                            if ((k | 0) == -99999 | (k | 0) > 5) {
                                Ue(f + 4 | 0, 1006, 0);
                                m = 0;
                                return m | 0
                            }
                            g = k + 1 | 0;
                            k = b + 4 | 0;
                            a[k] = g;
                            if ((g & 255 | 0) == 0) { break a } else { n = 0 }
                            while (1) {
                                g = rd(e) | 0;
                                if ((g + 12 | 0) >>> 0 > 24 >>> 0) { o = 15; break }
                                a[b + 5 + n | 0] = g;
                                g = rd(e) | 0;
                                if ((g + 12 | 0) >>> 0 > 24 >>> 0) { o = 17; break }
                                a[b + 11 + n | 0] = g;
                                n = n + 1 | 0;
                                if ((n | 0) >= (d[k] | 0)) { break a }
                            }
                            if ((o | 0) == 15) {
                                Ue(f + 4 | 0, 1006, 0);
                                m = 0;
                                return m | 0
                            } else if ((o | 0) == 17) {
                                Ue(f + 4 | 0, 1006, 0);
                                m = 0;
                                return m | 0
                            }
                        }
                    } while (0);
                    Ue(f + 4 | 0, 1006, 0);
                    m = 0;
                    return m | 0
                }
            } while (0);
            o = qd(e) | 0;
            do {
                if (!((o | 0) == -99999)) {
                    n = (c[f + 11096 + (h * 5168 | 0) + 4996 >> 2] | 0) - 10 | 0;
                    if ((o | 0) > (((n | 0) < 0 ? 0 : n) | 0)) { break }
                    a[b + 17 | 0] = o;
                    n = qd(e) | 0;
                    do {
                        if (!((n | 0) == -99999)) {
                            l = (c[f + 11096 + (h * 5168 | 0) + 5004 >> 2] | 0) - 10 | 0;
                            if ((n | 0) > (((l | 0) < 0 ? 0 : l) | 0)) { break }
                            a[b + 18 | 0] = n;
                            m = 1;
                            return m | 0
                        }
                    } while (0);
                    Ue(f + 4 | 0, 1006, 0);
                    m = 0;
                    return m | 0
                }
            } while (0);
            Ue(f + 4 | 0, 1006, 0);
            m = 0;
            return m | 0
        }

        function ij(b, e) {
            b = b | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0;
            f = i;
            if ((e | 0) == 2) { g = q } else if ((e | 0) == 1) { g = t } else { i = f; return }
            e = c[g >> 2] | 0;
            Zk(e, 6144, (g = i, i = i + 1 | 0, i = i + 7 & -8, c[g >> 2] = 0, g) | 0);
            i = g;
            Zk(e, 15168, (g = i, i = i + 8 | 0, c[g >> 2] = d[b | 0] | 0, g) | 0);
            i = g;
            Zk(e, 12656, (g = i, i = i + 8 | 0, c[g >> 2] = d[b + 1 | 0] | 0, g) | 0);
            i = g;
            h = b + 2 | 0;
            Zk(e, 9712, (g = i, i = i + 8 | 0, c[g >> 2] = d[h] | 0, g) | 0);
            i = g;
            do {
                if ((a[h] | 0) != 0) {
                    Zk(e, 6704, (g = i, i = i + 8 | 0, c[g >> 2] = d[b + 3 | 0] | 0, g) | 0);
                    i = g;
                    j = b + 4 | 0;
                    Zk(e, 4920, (g = i, i = i + 8 | 0, c[g >> 2] = d[j] | 0, g) | 0);
                    i = g;
                    if ((a[j] | 0) == 0) { break } else { k = 0 }
                    do {
                        l = a[b + 5 + k | 0] | 0;
                        Zk(e, 3496, (g = i, i = i + 16 | 0, c[g >> 2] = k, c[g + 8 >> 2] = l, g) | 0);
                        i = g;
                        l = a[b + 11 + k | 0] | 0;
                        Zk(e, 2176, (g = i, i = i + 16 | 0, c[g >> 2] = k, c[g + 8 >> 2] = l, g) | 0);
                        i = g;
                        k = k + 1 | 0;
                    } while ((k | 0) < (d[j] | 0))
                }
            } while (0);
            Zk(e, 1128, (g = i, i = i + 8 | 0, c[g >> 2] = d[b + 17 | 0] | 0, g) | 0);
            i = g;
            Zk(e, 448, (g = i, i = i + 8 | 0, c[g >> 2] = d[b + 18 | 0] | 0, g) | 0);
            i = g;
            i = f;
            return
        }

        function jj(b) {
            b = b | 0;
            var c = 0;
            a[b + 4138 | 0] = 2;
            a[b + 4155 | 0] = 0;
            a[b + 4156 | 0] = 0;
            c = b + 4139 | 0;
            C = 0;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            dv(b + 4340 | 0, 0, 60) | 0;
            lj(b, 0);
            return
        }

        function kj(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            b = c[a + 4388 >> 2] | 0;
            if ((b | 0) != 0) {
                d = a + 4392 | 0;
                e = c[d >> 2] | 0;
                if ((e | 0) != (b | 0)) { c[d >> 2] = e + (~((e - 4 + (-b | 0) | 0) >>> 2) << 2) }
                Pu(b)
            }
            b = c[a + 4376 >> 2] | 0;
            if ((b | 0) != 0) {
                e = a + 4380 | 0;
                d = c[e >> 2] | 0;
                if ((d | 0) != (b | 0)) { c[e >> 2] = d + (~((d - 4 + (-b | 0) | 0) >>> 2) << 2) }
                Pu(b)
            }
            b = c[a + 4364 >> 2] | 0;
            if ((b | 0) != 0) {
                d = a + 4368 | 0;
                e = c[d >> 2] | 0;
                if ((e | 0) != (b | 0)) { c[d >> 2] = e + (~((e - 4 + (-b | 0) | 0) >>> 2) << 2) }
                Pu(b)
            }
            b = c[a + 4352 >> 2] | 0;
            if ((b | 0) != 0) {
                e = a + 4356 | 0;
                d = c[e >> 2] | 0;
                if ((d | 0) != (b | 0)) { c[e >> 2] = d + (~((d - 4 + (-b | 0) | 0) >>> 2) << 2) }
                Pu(b)
            }
            b = c[a + 4340 >> 2] | 0;
            if ((b | 0) == 0) { return }
            d = a + 4344 | 0;
            a = c[d >> 2] | 0;
            if ((a | 0) != (b | 0)) { c[d >> 2] = a + (~((a - 4 + (-b | 0) | 0) >>> 2) << 2) }
            Pu(b);
            return
        }

        function lj(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            dv(b | 0, 0, 6) | 0;
            a[b + 6 | 0] = 1;
            a[b + 7 | 0] = 1;
            c[b + 8 >> 2] = 27;
            a[b + 12 | 0] = 0;
            a[b + 13 | 0] = 0;
            a[b + 14 | 0] = 0;
            dv(b + 16 | 0, 0, 19) | 0;
            c[b + 36 >> 2] = 1;
            c[b + 40 >> 2] = 1;
            a[b + 44 | 0] = 1;
            a[b + 45 | 0] = 1;
            a[b + 46 | 0] = 1;
            dv(b + 4172 | 0, 0, 168) | 0;
            d = c[b + 4340 >> 2] | 0;
            e = b + 4344 | 0;
            f = c[e >> 2] | 0;
            if ((f | 0) != (d | 0)) { c[e >> 2] = f + (~((f - 4 + (-d | 0) | 0) >>> 2) << 2) }
            d = c[b + 4352 >> 2] | 0;
            f = b + 4356 | 0;
            e = c[f >> 2] | 0;
            if ((e | 0) != (d | 0)) { c[f >> 2] = e + (~((e - 4 + (-d | 0) | 0) >>> 2) << 2) }
            d = c[b + 4364 >> 2] | 0;
            e = b + 4368 | 0;
            f = c[e >> 2] | 0;
            if ((f | 0) != (d | 0)) { c[e >> 2] = f + (~((f - 4 + (-d | 0) | 0) >>> 2) << 2) }
            d = c[b + 4376 >> 2] | 0;
            f = b + 4380 | 0;
            e = c[f >> 2] | 0;
            if ((e | 0) != (d | 0)) { c[f >> 2] = e + (~((e - 4 + (-d | 0) | 0) >>> 2) << 2) }
            d = c[b + 4388 >> 2] | 0;
            e = b + 4392 | 0;
            f = c[e >> 2] | 0;
            if ((f | 0) == (d | 0)) {
                g = b + 4160 | 0;
                c[g >> 2] = 0;
                h = b + 47 | 0;
                a[h] = 0;
                i = b + 48 | 0;
                a[i] = 0;
                j = b + 49 | 0;
                a[j] = 0;
                k = b + 52 | 0;
                c[k >> 2] = 0;
                l = b + 56 | 0;
                c[l >> 2] = 0;
                m = b + 60 | 0;
                a[m] = 0;
                n = b + 4125 | 0;
                a[n] = 0;
                o = b + 4128 | 0;
                c[o >> 2] = 2;
                p = b + 4132 | 0;
                dv(p | 0, 0, 6) | 0;
                return
            }
            c[e >> 2] = f + (~((f - 4 + (-d | 0) | 0) >>> 2) << 2);
            g = b + 4160 | 0;
            c[g >> 2] = 0;
            h = b + 47 | 0;
            a[h] = 0;
            i = b + 48 | 0;
            a[i] = 0;
            j = b + 49 | 0;
            a[j] = 0;
            k = b + 52 | 0;
            c[k >> 2] = 0;
            l = b + 56 | 0;
            c[l >> 2] = 0;
            m = b + 60 | 0;
            a[m] = 0;
            n = b + 4125 | 0;
            a[n] = 0;
            o = b + 4128 | 0;
            c[o >> 2] = 2;
            p = b + 4132 | 0;
            dv(p | 0, 0, 6) | 0;
            return
        }

        function mj(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            lj(b, 0);
            f = qd(d) | 0;
            a[b + 1 | 0] = f;
            if ((f | 0) > 63 | (f | 0) == -99999) {
                Ue(e + 4 | 0, 1009, 0);
                g = 0;
                return g | 0
            }
            f = qd(d) | 0;
            h = b + 2 | 0;
            a[h] = f;
            if ((f | 0) > 63 | (f | 0) == -99999) {
                Ue(e + 4 | 0, 1010, 0);
                g = 0;
                return g | 0
            }
            f = (nd(d, 1) | 0) & 255;
            a[b + 3 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 31 | 0] = f;
            f = (nd(d, 3) | 0) & 255;
            a[b + 4132 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 4 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 5 | 0] = f;
            f = qd(d) | 0;
            i = f & 255;
            j = b + 6 | 0;
            a[j] = i;
            if ((f | 0) == -99999) {
                Ue(e + 4 | 0, 1006, 0);
                g = 0;
                return g | 0
            }
            a[j] = i + 1;
            i = qd(d) | 0;
            j = i & 255;
            f = b + 7 | 0;
            a[f] = j;
            if ((i | 0) == -99999) {
                Ue(e + 4 | 0, 1006, 0);
                g = 0;
                return g | 0
            }
            a[f] = j + 1;
            j = a[h] | 0;
            h = e + 11096 + (j * 5168 | 0) | 0;
            if ((a[h | 0] | 0) == 0) {
                Ue(e + 4 | 0, 1010, 0);
                g = 0;
                return g | 0
            }
            f = rd(d) | 0;
            i = b + 8 | 0;
            c[i >> 2] = f;
            if ((f | 0) == -99999) {
                Ue(e + 4 | 0, 1006, 0);
                g = 0;
                return g | 0
            }
            c[i >> 2] = f + 26;
            f = (nd(d, 1) | 0) & 255;
            a[b + 12 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 13 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 14 | 0] = f;
            do {
                if (f << 24 >> 24 == 0) { c[b + 16 >> 2] = 0 } else {
                    i = qd(d) | 0;
                    c[b + 16 >> 2] = i;
                    if (!((i | 0) == -99999)) { break }
                    Ue(e + 4 | 0, 1006, 0);
                    g = 0;
                    return g | 0
                }
            } while (0);
            f = rd(d) | 0;
            c[b + 20 >> 2] = f;
            if ((f | 0) == -99999) {
                Ue(e + 4 | 0, 1006, 0);
                g = 0;
                return g | 0
            }
            f = rd(d) | 0;
            c[b + 24 >> 2] = f;
            if ((f | 0) == -99999) {
                Ue(e + 4 | 0, 1006, 0);
                g = 0;
                return g | 0
            }
            f = (nd(d, 1) | 0) & 255;
            a[b + 28 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 29 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 30 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 32 | 0] = f;
            f = (nd(d, 1) | 0) & 255;
            i = b + 34 | 0;
            a[i] = f;
            f = (nd(d, 1) | 0) & 255;
            a[b + 33 | 0] = f;
            if ((a[i] | 0) == 0) {
                c[b + 36 >> 2] = 1;
                c[b + 40 >> 2] = 1;
                a[b + 44 | 0] = 1;
                a[b + 45 | 0] = 0
            } else {
                i = qd(d) | 0;
                f = b + 36 | 0;
                c[f >> 2] = i;
                if ((i | 0) == -99999 | (i | 0) > 9) {
                    Ue(e + 4 | 0, 1006, 0);
                    g = 0;
                    return g | 0
                }
                c[f >> 2] = i + 1;
                i = qd(d) | 0;
                k = b + 40 | 0;
                c[k >> 2] = i;
                if ((i | 0) == -99999 | (i | 0) > 9) {
                    Ue(e + 4 | 0, 1006, 0);
                    g = 0;
                    return g | 0
                }
                c[k >> 2] = i + 1;
                i = (nd(d, 1) | 0) & 255;
                a[b + 44 | 0] = i;
                do {
                    if (i << 24 >> 24 == 0) {
                        l = c[e + 11096 + (j * 5168 | 0) + 5056 >> 2] | 0;
                        m = c[e + 11096 + (j * 5168 | 0) + 5064 >> 2] | 0;
                        n = (c[f >> 2] | 0) - 1 | 0;
                        a: do {
                            if ((n | 0) > 0) {
                                o = l;
                                p = 0;
                                while (1) {
                                    q = qd(d) | 0;
                                    r = b + 4172 + (p << 2) | 0;
                                    c[r >> 2] = q;
                                    if ((q | 0) == -99999) { break }
                                    s = q + 1 | 0;
                                    c[r >> 2] = s;
                                    r = o - s | 0;
                                    s = p + 1 | 0;
                                    q = (c[f >> 2] | 0) - 1 | 0;
                                    if ((s | 0) < (q | 0)) {
                                        o = r;
                                        p = s
                                    } else {
                                        t = r;
                                        u = q;
                                        break a
                                    }
                                }
                                Ue(e + 4 | 0, 1006, 0);
                                g = 0;
                                return g | 0
                            } else {
                                t = l;
                                u = n
                            }
                        } while (0);
                        if ((t | 0) < 1) { g = 0; return g | 0 }
                        c[b + 4172 + (u << 2) >> 2] = t;
                        n = (c[k >> 2] | 0) - 1 | 0;
                        b: do {
                            if ((n | 0) > 0) {
                                l = m;
                                p = 0;
                                while (1) {
                                    o = qd(d) | 0;
                                    q = b + 4212 + (p << 2) | 0;
                                    c[q >> 2] = o;
                                    if ((o | 0) == -99999) { break }
                                    r = o + 1 | 0;
                                    c[q >> 2] = r;
                                    q = l - r | 0;
                                    r = p + 1 | 0;
                                    o = (c[k >> 2] | 0) - 1 | 0;
                                    if ((r | 0) < (o | 0)) {
                                        l = q;
                                        p = r
                                    } else {
                                        v = q;
                                        w = o;
                                        break b
                                    }
                                }
                                Ue(e + 4 | 0, 1006, 0);
                                g = 0;
                                return g | 0
                            } else {
                                v = m;
                                w = n
                            }
                        } while (0);
                        if ((v | 0) < 1) { g = 0; return g | 0 } else { c[b + 4212 + (w << 2) >> 2] = v; break }
                    }
                } while (0);
                v = (nd(d, 1) | 0) & 255;
                a[b + 45 | 0] = v
            }
            v = b + 52 | 0;
            c[v >> 2] = 0;
            w = b + 56 | 0;
            c[w >> 2] = 0;
            k = (nd(d, 1) | 0) & 255;
            a[b + 46 | 0] = k;
            k = (nd(d, 1) | 0) & 255;
            a[b + 47 | 0] = k;
            do {
                if (k << 24 >> 24 == 0) {
                    a[b + 48 | 0] = 0;
                    a[b + 49 | 0] = 0
                } else {
                    t = (nd(d, 1) | 0) & 255;
                    a[b + 48 | 0] = t;
                    t = (nd(d, 1) | 0) & 255;
                    a[b + 49 | 0] = t;
                    if (!(t << 24 >> 24 == 0)) { break }
                    t = rd(d) | 0;
                    c[v >> 2] = t;
                    if ((t | 0) == -99999) {
                        Ue(e + 4 | 0, 1006, 0);
                        g = 0;
                        return g | 0
                    }
                    c[v >> 2] = t << 1;
                    t = rd(d) | 0;
                    c[w >> 2] = t;
                    if (!((t | 0) == -99999)) { c[w >> 2] = t << 1; break }
                    Ue(e + 4 | 0, 1006, 0);
                    g = 0;
                    return g | 0
                }
            } while (0);
            w = (nd(d, 1) | 0) & 255;
            a[b + 60 | 0] = w;
            v = w << 24 >> 24 == 0;
            if (!((a[e + 11096 + (j * 5168 | 0) + 636 | 0] | 0) != 0 | v)) {
                Ue(e + 4 | 0, 1006, 0);
                g = 0;
                return g | 0
            }
            do {
                if (v) { cv(b + 61 | 0, e + 11096 + (j * 5168 | 0) + 638 | 0, 4064) | 0 } else {
                    w = lk(d, h, b + 61 | 0, 1) | 0;
                    if ((w | 0) == 0) { break }
                    Ue(e + 4 | 0, w, 0);
                    g = 0;
                    return g | 0
                }
            } while (0);
            v = (nd(d, 1) | 0) & 255;
            a[b + 4125 | 0] = v;
            v = qd(d) | 0;
            w = b + 4128 | 0;
            c[w >> 2] = v;
            if ((v | 0) == -99999) {
                Ue(e + 4 | 0, 1006, 0);
                g = 0;
                return g | 0
            }
            c[w >> 2] = v + 2;
            if ((v | 0) > ((c[e + 11096 + (j * 5168 | 0) + 612 >> 2] | 0) - 2 + (c[e + 11096 + (j * 5168 | 0) + 616 >> 2] | 0) | 0)) { g = 0; return g | 0 }
            j = (nd(d, 1) | 0) & 255;
            a[b + 4133 | 0] = j;
            j = (nd(d, 1) | 0) & 255;
            a[b + 4134 | 0] = j;
            do {
                if (!(j << 24 >> 24 == 0)) {
                    v = (nd(d, 1) | 0) & 255;
                    w = b + 4135 | 0;
                    a[w] = v;
                    v = (nd(d, 1) | 0) & 255;
                    a[b + 4136 | 0] = v;
                    v = (nd(d, 6) | 0) & 255;
                    a[b + 4137 | 0] = v;
                    if ((a[w] | 0) == 0) { break }
                    if (hj(b + 4138 | 0, d, e, b) | 0) { break } else { g = 0 }
                    return g | 0
                }
            } while (0);
            nj(b, h);
            a[b | 0] = 1;
            g = 1;
            return g | 0
        }

        function nj(b, e) {
            b = b | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0;
            f = i;
            g = e + 5040 | 0;
            c[b + 4160 >> 2] = (c[g >> 2] | 0) - (c[b + 16 >> 2] | 0);
            c[b + 4164 >> 2] = (c[g >> 2] | 0) - (d[b + 4141 | 0] | 0);
            c[b + 4168 >> 2] = d[b + 4138 | 0] | 0;
            h = b + 36 | 0;
            do {
                if ((a[b + 44 | 0] | 0) != 0) {
                    j = c[h >> 2] | 0;
                    k = i;
                    i = i + ((j << 2) + 4) | 0;
                    i = i + 7 & -8;
                    l = k;
                    do {
                        if ((j | 0) >= 0) {
                            k = c[e + 5056 >> 2] | 0;
                            m = 0;
                            while (1) {
                                n = (ga(k, m) | 0) / (j | 0) | 0;
                                c[l + (m << 2) >> 2] = n;
                                if ((m | 0) < (j | 0)) { m = m + 1 | 0 } else { break }
                            }
                            if ((j | 0) <= 0) { break }
                            m = 0;
                            k = c[l >> 2] | 0;
                            while (1) {
                                n = m + 1 | 0;
                                o = c[l + (n << 2) >> 2] | 0;
                                c[b + 4172 + (m << 2) >> 2] = o - k;
                                if ((n | 0) < (c[h >> 2] | 0)) {
                                    m = n;
                                    k = o
                                } else { break }
                            }
                        }
                    } while (0);
                    l = b + 40 | 0;
                    j = c[l >> 2] | 0;
                    k = i;
                    i = i + ((j << 2) + 4) | 0;
                    i = i + 7 & -8;
                    m = k;
                    if ((j | 0) < 0) { break }
                    k = c[e + 5064 >> 2] | 0;
                    o = 0;
                    while (1) {
                        n = (ga(k, o) | 0) / (j | 0) | 0;
                        c[m + (o << 2) >> 2] = n;
                        if ((o | 0) < (j | 0)) { o = o + 1 | 0 } else { break }
                    }
                    if ((j | 0) <= 0) { break }
                    o = 0;
                    k = c[m >> 2] | 0;
                    while (1) {
                        n = o + 1 | 0;
                        p = c[m + (n << 2) >> 2] | 0;
                        c[b + 4212 + (o << 2) >> 2] = p - k;
                        if ((n | 0) < (c[l >> 2] | 0)) {
                            o = n;
                            k = p
                        } else { break }
                    }
                }
            } while (0);
            c[b + 4252 >> 2] = 0;
            if ((c[h >> 2] | 0) > 0) {
                k = 0;
                o = 0;
                do {
                    o = (c[b + 4172 + (k << 2) >> 2] | 0) + o | 0;
                    k = k + 1 | 0;
                    c[b + 4252 + (k << 2) >> 2] = o;
                } while ((k | 0) < (c[h >> 2] | 0))
            }
            c[b + 4296 >> 2] = 0;
            k = b + 40 | 0;
            if ((c[k >> 2] | 0) > 0) {
                o = 0;
                l = 0;
                do {
                    l = (c[b + 4212 + (o << 2) >> 2] | 0) + l | 0;
                    o = o + 1 | 0;
                    c[b + 4296 + (o << 2) >> 2] = l;
                } while ((o | 0) < (c[k >> 2] | 0))
            }
            o = b + 4340 | 0;
            l = e + 5072 | 0;
            m = c[l >> 2] | 0;
            j = b + 4344 | 0;
            p = c[j >> 2] | 0;
            n = o | 0;
            q = c[n >> 2] | 0;
            r = p - q >> 2;
            do {
                if (r >>> 0 < m >>> 0) {
                    qj(o, m - r | 0);
                    s = c[l >> 2] | 0
                } else {
                    if (!(r >>> 0 > m >>> 0)) { s = m; break }
                    t = q + (m << 2) | 0;
                    if ((p | 0) == (t | 0)) { s = m; break }
                    c[j >> 2] = p + (~((p - 4 + (-t | 0) | 0) >>> 2) << 2);
                    s = m
                }
            } while (0);
            m = b + 4352 | 0;
            p = b + 4356 | 0;
            j = c[p >> 2] | 0;
            q = m | 0;
            r = c[q >> 2] | 0;
            o = j - r >> 2;
            do {
                if (o >>> 0 < s >>> 0) {
                    qj(m, s - o | 0);
                    u = c[l >> 2] | 0
                } else {
                    if (!(o >>> 0 > s >>> 0)) { u = s; break }
                    t = r + (s << 2) | 0;
                    if ((j | 0) == (t | 0)) { u = s; break }
                    c[p >> 2] = j + (~((j - 4 + (-t | 0) | 0) >>> 2) << 2);
                    u = s
                }
            } while (0);
            s = b + 4364 | 0;
            j = b + 4368 | 0;
            p = c[j >> 2] | 0;
            r = s | 0;
            o = c[r >> 2] | 0;
            m = p - o >> 2;
            do {
                if (m >>> 0 < u >>> 0) {
                    qj(s, u - m | 0);
                    v = c[l >> 2] | 0
                } else {
                    if (!(m >>> 0 > u >>> 0)) { v = u; break }
                    t = o + (u << 2) | 0;
                    if ((p | 0) == (t | 0)) { v = u; break }
                    c[j >> 2] = p + (~((p - 4 + (-t | 0) | 0) >>> 2) << 2);
                    v = u
                }
            } while (0);
            u = b + 4376 | 0;
            p = b + 4380 | 0;
            j = c[p >> 2] | 0;
            o = u | 0;
            m = c[o >> 2] | 0;
            s = j - m >> 2;
            do {
                if (s >>> 0 < v >>> 0) { qj(u, v - s | 0) } else {
                    if (!(s >>> 0 > v >>> 0)) { break }
                    t = m + (v << 2) | 0;
                    if ((j | 0) == (t | 0)) { break }
                    c[p >> 2] = j + (~((j - 4 + (-t | 0) | 0) >>> 2) << 2)
                }
            } while (0);
            j = b + 4388 | 0;
            p = c[e + 5096 >> 2] | 0;
            v = b + 4392 | 0;
            m = c[v >> 2] | 0;
            s = j | 0;
            u = c[s >> 2] | 0;
            t = m - u >> 2;
            do {
                if (t >>> 0 < p >>> 0) { qj(j, p - t | 0) } else {
                    if (!(t >>> 0 > p >>> 0)) { break }
                    w = u + (p << 2) | 0;
                    if ((m | 0) == (w | 0)) { break }
                    c[v >> 2] = m + (~((m - 4 + (-w | 0) | 0) >>> 2) << 2)
                }
            } while (0);
            a: do {
                if ((c[l >> 2] | 0) > 0) {
                    m = e + 5056 | 0;
                    v = 0;
                    while (1) {
                        p = c[m >> 2] | 0;
                        u = (v | 0) % (p | 0) | 0;
                        t = (v | 0) / (p | 0) | 0;
                        p = c[h >> 2] | 0;
                        if ((p | 0) > 0) {
                            j = -1;
                            w = 0;
                            while (1) {
                                x = (u | 0) < (c[b + 4252 + (w << 2) >> 2] | 0) ? j : w;
                                y = w + 1 | 0;
                                if ((y | 0) < (p | 0)) {
                                    j = x;
                                    w = y
                                } else { z = x; break }
                            }
                        } else { z = -1 }
                        w = c[k >> 2] | 0;
                        if ((w | 0) > 0) {
                            j = -1;
                            p = 0;
                            while (1) {
                                x = (t | 0) < (c[b + 4296 + (p << 2) >> 2] | 0) ? j : p;
                                y = p + 1 | 0;
                                if ((y | 0) < (w | 0)) {
                                    j = x;
                                    p = y
                                } else { A = x; break }
                            }
                        } else { A = -1 }
                        p = (c[n >> 2] | 0) + (v << 2) | 0;
                        c[p >> 2] = 0;
                        if ((z | 0) > 0) {
                            j = b + 4212 + (A << 2) | 0;
                            w = 0;
                            x = 0;
                            while (1) {
                                y = x + (ga(c[b + 4172 + (w << 2) >> 2] | 0, c[j >> 2] | 0) | 0) | 0;
                                c[p >> 2] = y;
                                B = w + 1 | 0;
                                if ((B | 0) < (z | 0)) {
                                    w = B;
                                    x = y
                                } else { C = y; break }
                            }
                        } else { C = 0 }
                        if ((A | 0) > 0) {
                            x = 0;
                            w = C;
                            while (1) {
                                j = w + (ga(c[b + 4212 + (x << 2) >> 2] | 0, c[m >> 2] | 0) | 0) | 0;
                                c[p >> 2] = j;
                                y = x + 1 | 0;
                                if ((y | 0) < (A | 0)) {
                                    x = y;
                                    w = j
                                } else { D = j; break }
                            }
                        } else { D = C }
                        if (!((A | z | 0) > -1)) { break }
                        w = D + (ga(t - (c[b + 4296 + (A << 2) >> 2] | 0) | 0, c[b + 4172 + (z << 2) >> 2] | 0) | 0) | 0;
                        c[p >> 2] = w;
                        x = u - (c[b + 4252 + (z << 2) >> 2] | 0) + w | 0;
                        c[p >> 2] = x;
                        c[(c[q >> 2] | 0) + (x << 2) >> 2] = v;
                        v = v + 1 | 0;
                        if ((v | 0) >= (c[l >> 2] | 0)) { break a }
                    }
                    ec(16944, 16440, 618, 17488)
                }
            } while (0);
            l = c[k >> 2] | 0;
            if ((l | 0) > 0) {
                q = e + 5056 | 0;
                z = 0;
                A = 0;
                D = c[h >> 2] | 0;
                C = l;
                while (1) {
                    if ((D | 0) > 0) {
                        l = b + 4296 + (z << 2) | 0;
                        v = z + 1 | 0;
                        m = b + 4296 + (v << 2) | 0;
                        x = A;
                        w = 0;
                        j = c[m >> 2] | 0;
                        y = D;
                        while (1) {
                            B = c[l >> 2] | 0;
                            if ((B | 0) < (j | 0)) {
                                E = b + 4252 + (w << 2) | 0;
                                F = w + 1 | 0;
                                G = b + 4252 + (F << 2) | 0;
                                H = B;
                                B = c[G >> 2] | 0;
                                I = j;
                                while (1) {
                                    J = c[E >> 2] | 0;
                                    if ((J | 0) < (B | 0)) {
                                        K = c[n >> 2] | 0;
                                        L = c[r >> 2] | 0;
                                        M = c[o >> 2] | 0;
                                        N = J;
                                        do {
                                            J = K + ((ga(c[q >> 2] | 0, H) | 0) + N << 2) | 0;
                                            c[L + (c[J >> 2] << 2) >> 2] = x;
                                            J = M + ((ga(c[q >> 2] | 0, H) | 0) + N << 2) | 0;
                                            c[J >> 2] = x;
                                            N = N + 1 | 0;
                                            O = c[G >> 2] | 0;
                                        } while ((N | 0) < (O | 0));
                                        P = O;
                                        Q = c[m >> 2] | 0
                                    } else {
                                        P = B;
                                        Q = I
                                    }
                                    N = H + 1 | 0;
                                    if ((N | 0) < (Q | 0)) {
                                        H = N;
                                        B = P;
                                        I = Q
                                    } else { break }
                                }
                                R = Q;
                                S = c[h >> 2] | 0;
                                T = F
                            } else {
                                R = j;
                                S = y;
                                T = w + 1 | 0
                            }
                            U = x + 1 | 0;
                            if ((T | 0) < (S | 0)) {
                                x = U;
                                w = T;
                                j = R;
                                y = S
                            } else { break }
                        }
                        V = U;
                        W = S;
                        X = c[k >> 2] | 0;
                        Y = v
                    } else {
                        V = A;
                        W = D;
                        X = C;
                        Y = z + 1 | 0
                    }
                    if ((Y | 0) < (X | 0)) {
                        z = Y;
                        A = V;
                        D = W;
                        C = X
                    } else { break }
                }
            }
            X = e + 5092 | 0;
            C = c[X >> 2] | 0;
            if ((C | 0) <= 0) { i = f; return }
            W = e + 5088 | 0;
            D = e + 5100 | 0;
            V = e + 5056 | 0;
            e = 0;
            A = c[W >> 2] | 0;
            Y = C;
            while (1) {
                if ((A | 0) > 0) {
                    C = c[n >> 2] | 0;
                    z = c[s >> 2] | 0;
                    k = 0;
                    S = A;
                    do {
                        U = c[D >> 2] | 0;
                        R = c[g >> 2] | 0;
                        T = C + ((ga(c[V >> 2] | 0, e << U >> R) | 0) + (k << U >> R) << 2) | 0;
                        h = z + ((ga(S, e) | 0) + k << 2) | 0;
                        c[h >> 2] = c[T >> 2] << (R - U << 1);
                        U = (c[g >> 2] | 0) - (c[D >> 2] | 0) | 0;
                        if ((U | 0) > 0) {
                            R = 0;
                            T = 0;
                            while (1) {
                                h = 1 << T;
                                if ((h & e | 0) == 0) { Z = 0 } else { Z = h << 1 << T }
                                Q = ((h & k | 0) == 0 ? 0 : h << T) + R + Z | 0;
                                h = T + 1 | 0;
                                if ((h | 0) < (U | 0)) {
                                    R = Q;
                                    T = h
                                } else { _ = Q; break }
                            }
                        } else { _ = 0 }
                        T = z + ((ga(c[W >> 2] | 0, e) | 0) + k << 2) | 0;
                        c[T >> 2] = (c[T >> 2] | 0) + _;
                        k = k + 1 | 0;
                        S = c[W >> 2] | 0;
                    } while ((k | 0) < (S | 0));
                    $ = S;
                    aa = c[X >> 2] | 0
                } else {
                    $ = A;
                    aa = Y
                }
                k = e + 1 | 0;
                if ((k | 0) < (aa | 0)) {
                    e = k;
                    A = $;
                    Y = aa
                } else { break }
            }
            i = f;
            return
        }

        function oj(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0;
            e = i;
            if ((d | 0) == 2) { f = q } else if ((d | 0) == 1) { f = t } else { i = e; return }
            g = c[f >> 2] | 0;
            Zk(g, 16080, (f = i, i = i + 1 | 0, i = i + 7 & -8, c[f >> 2] = 0, f) | 0);
            i = f;
            Zk(g, 15672, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 1 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 15304, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 2 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 14992, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 3 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 14728, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 14432, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 5 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 14168, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 6 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 13904, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 7 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 13664, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 8 >> 2], f) | 0);
            i = f;
            Zk(g, 13464, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 12 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 13272, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 13 | 0] | 0, f) | 0);
            i = f;
            h = b + 14 | 0;
            Zk(g, 13072, (f = i, i = i + 8 | 0, c[f >> 2] = a[h] | 0, f) | 0);
            i = f;
            if ((a[h] | 0) != 0) {
                Zk(g, 12776, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 16 >> 2], f) | 0);
                i = f
            }
            Zk(g, 12464, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 20 >> 2], f) | 0);
            i = f;
            Zk(g, 12256, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 24 >> 2], f) | 0);
            i = f;
            Zk(g, 11904, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 28 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 11560, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 29 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 11280, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 30 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 11032, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 31 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 10768, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 32 | 0] | 0, f) | 0);
            i = f;
            h = b + 34 | 0;
            Zk(g, 10520, (f = i, i = i + 8 | 0, c[f >> 2] = a[h] | 0, f) | 0);
            i = f;
            Zk(g, 10192, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 33 | 0] | 0, f) | 0);
            i = f;
            if ((a[h] | 0) != 0) {
                h = b + 36 | 0;
                Zk(g, 9856, (f = i, i = i + 8 | 0, c[f >> 2] = c[h >> 2], f) | 0);
                i = f;
                j = b + 40 | 0;
                Zk(g, 9448, (f = i, i = i + 8 | 0, c[f >> 2] = c[j >> 2], f) | 0);
                i = f;
                Zk(g, 9112, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 44 | 0] | 0, f) | 0);
                i = f;
                Zk(g, 8800, (f = i, i = i + 1 | 0, i = i + 7 & -8, c[f >> 2] = 0, f) | 0);
                i = f;
                if ((c[h >> 2] | 0) >= 0) {
                    k = 0;
                    while (1) {
                        Zk(g, 8464, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 4252 + (k << 2) >> 2], f) | 0);
                        i = f;
                        if ((k | 0) < (c[h >> 2] | 0)) { k = k + 1 | 0 } else { break }
                    }
                }
                Zk(g, 8280, (f = i, i = i + 1 | 0, i = i + 7 & -8, c[f >> 2] = 0, f) | 0);
                i = f;
                Zk(g, 8008, (f = i, i = i + 1 | 0, i = i + 7 & -8, c[f >> 2] = 0, f) | 0);
                i = f;
                if ((c[j >> 2] | 0) >= 0) {
                    k = 0;
                    while (1) {
                        Zk(g, 8464, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 4296 + (k << 2) >> 2], f) | 0);
                        i = f;
                        if ((k | 0) < (c[j >> 2] | 0)) { k = k + 1 | 0 } else { break }
                    }
                }
                Zk(g, 8280, (f = i, i = i + 1 | 0, i = i + 7 & -8, c[f >> 2] = 0, f) | 0);
                i = f;
                Zk(g, 7728, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 45 | 0] | 0, f) | 0);
                i = f
            }
            Zk(g, 7432, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 46 | 0] | 0, f) | 0);
            i = f;
            k = b + 47 | 0;
            Zk(g, 7144, (f = i, i = i + 8 | 0, c[f >> 2] = a[k] | 0, f) | 0);
            i = f;
            if ((a[k] | 0) != 0) {
                Zk(g, 6848, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 48 | 0] | 0, f) | 0);
                i = f;
                Zk(g, 6576, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 49 | 0] | 0, f) | 0);
                i = f;
                Zk(g, 6416, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 52 >> 2], f) | 0);
                i = f;
                Zk(g, 6240, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 56 >> 2], f) | 0);
                i = f
            }
            Zk(g, 6056, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 60 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 5896, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4125 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 5752, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 4128 >> 2], f) | 0);
            i = f;
            Zk(g, 5584, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4132 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 5448, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4133 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 5280, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4134 | 0] | 0, f) | 0);
            i = f;
            k = b + 4135 | 0;
            Zk(g, 5096, (f = i, i = i + 8 | 0, c[f >> 2] = a[k] | 0, f) | 0);
            i = f;
            Zk(g, 4880, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4136 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 4752, (f = i, i = i + 8 | 0, c[f >> 2] = a[b + 4137 | 0] | 0, f) | 0);
            i = f;
            Zk(g, 4632, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 4160 >> 2], f) | 0);
            i = f;
            Zk(g, 4392, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 4164 >> 2], f) | 0);
            i = f;
            Zk(g, 4176, (f = i, i = i + 8 | 0, c[f >> 2] = c[b + 4168 >> 2], f) | 0);
            i = f;
            if ((a[k] | 0) == 0) { i = e; return }
            ij(b + 4138 | 0, d);
            i = e;
            return
        }

        function pj(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            if ((a[b + 34 | 0] | 0) == 0) { f = (e | d | 0) == 0; return f | 0 }
            g = c[b + 36 >> 2] | 0;
            if ((g | 0) > 0) { h = 0 } else { f = 0; return f | 0 }
            while (1) {
                i = h + 1 | 0;
                if ((c[b + 4252 + (h << 2) >> 2] | 0) == (d | 0)) { break }
                if ((i | 0) < (g | 0)) { h = i } else {
                    f = 0;
                    j = 9;
                    break
                }
            }
            if ((j | 0) == 9) { return f | 0 }
            h = c[b + 40 >> 2] | 0;
            if ((h | 0) > 0) { k = 0 } else { f = 0; return f | 0 }
            while (1) {
                g = k + 1 | 0;
                if ((c[b + 4296 + (k << 2) >> 2] | 0) == (e | 0)) {
                    f = 1;
                    j = 9;
                    break
                }
                if ((g | 0) < (h | 0)) { k = g } else {
                    f = 0;
                    j = 9;
                    break
                }
            }
            if ((j | 0) == 9) { return f | 0 }
            return 0
        }

        function qj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            d = a + 8 | 0;
            e = a + 4 | 0;
            f = c[e >> 2] | 0;
            g = c[d >> 2] | 0;
            h = f;
            if (!(g - h >> 2 >>> 0 < b >>> 0)) {
                i = b;
                j = f;
                while (1) {
                    if ((j | 0) != 0) { c[j >> 2] = 0 }
                    k = i - 1 | 0;
                    if ((k | 0) == 0) { break } else {
                        i = k;
                        j = j + 4 | 0
                    }
                }
                c[e >> 2] = f + (b << 2);
                return
            }
            f = a | 0;
            a = c[f >> 2] | 0;
            j = a;
            i = h - j | 0;
            h = i >> 2;
            k = h + b | 0;
            if (k >>> 0 > 1073741823 >>> 0) { Nr(0) }
            l = g - j | 0;
            if (l >> 2 >>> 0 < 536870911 >>> 0) {
                j = l >> 1;
                l = j >>> 0 < k >>> 0 ? k : j;
                if ((l | 0) == 0) {
                    m = 0;
                    n = 0
                } else {
                    o = l;
                    p = 10
                }
            } else {
                o = 1073741823;
                p = 10
            }
            if ((p | 0) == 10) {
                m = Nu(o << 2) | 0;
                n = o
            }
            o = b;
            b = m + (h << 2) | 0;
            while (1) {
                if ((b | 0) != 0) { c[b >> 2] = 0 }
                h = o - 1 | 0;
                if ((h | 0) == 0) { break } else {
                    o = h;
                    b = b + 4 | 0
                }
            }
            b = a;
            cv(m | 0, b | 0, i) | 0;
            c[f >> 2] = m;
            c[e >> 2] = m + (k << 2);
            c[d >> 2] = m + (n << 2);
            if ((a | 0) == 0) { return }
            Pu(b);
            return
        }

        function rj(c) {
            c = c | 0;
            var d = 0;
            d = c + 96 | 0;
            C = 0;
            a[d] = C;
            C = C >> 8;
            a[d + 1 | 0] = C;
            C = C >> 8;
            a[d + 2 | 0] = C;
            C = C >> 8;
            a[d + 3 | 0] = C;
            d = 0;
            do {
                b[c + (d << 1) >> 1] = 0;
                b[c + 32 + (d << 1) >> 1] = 0;
                a[c + 64 + d | 0] = 0;
                a[c + 80 + d | 0] = 0;
                d = d + 1 | 0;
            } while ((d | 0) < 16);
            return
        }

        function sj(e, f, g, h, j, k, l) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0;
            m = i;
            do {
                if ((j | 0) == 0) { n = 56 } else {
                    if (((nd(g, 1) | 0) & 255) << 24 >> 24 == 0) { n = 56; break }
                    do {
                        if (l) {
                            o = qd(g) | 0;
                            if ((o | 0) != -99999 & (o | 0) < (j | 0)) { p = o + 1 | 0; break } else {
                                q = 0;
                                i = m;
                                return q | 0
                            }
                        } else { p = 1 }
                    } while (0);
                    o = j - p | 0;
                    if (!((o | 0) > -1)) { ec(5088, 15040, 129, 18616); return 0 }
                    r = nd(g, 1) | 0;
                    s = qd(g) | 0;
                    if ((s | 0) == -99999) {
                        q = 0;
                        i = m;
                        return q | 0
                    }
                    t = s + 1 | 0;
                    u = ~s;
                    s = k | 0;
                    v = d[(c[s >> 2] | 0) + (o * 100 | 0) + 98 | 0] | 0;
                    w = v + 1 | 0;
                    x = i;
                    i = i + w | 0;
                    i = i + 7 & -8;
                    y = i;
                    i = i + w | 0;
                    i = i + 7 & -8;
                    w = 0;
                    while (1) {
                        z = (nd(g, 1) | 0) & 255;
                        a[x + w | 0] = z;
                        if (z << 24 >> 24 == 0) {
                            z = (nd(g, 1) | 0) & 255;
                            a[y + w | 0] = z
                        } else { a[y + w | 0] = 1 }
                        if ((w | 0) < (v | 0)) { w = w + 1 | 0 } else { break }
                    }
                    w = (r | 0) != 0 ? u : t;
                    z = c[s >> 2] | 0;
                    A = a[z + (o * 100 | 0) + 96 | 0] | 0;
                    B = A & 255;
                    D = a[z + (o * 100 | 0) + 97 | 0] | 0;
                    z = D & 255;
                    E = D << 24 >> 24 == 0;
                    a: do {
                        if (E) { F = 0 } else {
                            D = k + 4 | 0;
                            G = 0;
                            H = z;
                            b: while (1) {
                                I = H;
                                while (1) {
                                    J = I - 1 | 0;
                                    K = c[s >> 2] | 0;
                                    if (!(o >>> 0 < (((c[D >> 2] | 0) - K | 0) / 100 | 0) >>> 0)) { n = 18; break b }
                                    if (!((I - 1 | 0) >>> 0 < 16 >>> 0)) { n = 20; break b }
                                    L = (b[K + (o * 100 | 0) + 32 + (J << 1) >> 1] | 0) + w | 0;
                                    if ((L | 0) < 0) { M = J + B | 0; if ((a[y + M | 0] | 0) != 0) { break } }
                                    if ((J | 0) > 0) { I = J } else { F = G; break a }
                                }
                                if ((G | 0) > 15) {
                                    q = 0;
                                    n = 77;
                                    break
                                }
                                b[h + (G << 1) >> 1] = L;
                                a[h + 64 + G | 0] = a[x + M | 0] | 0;
                                I = G + 1 | 0;
                                if ((J | 0) > 0) {
                                    G = I;
                                    H = J
                                } else { F = I; break a }
                            }
                            if ((n | 0) == 18) { ec(12504, 15040, 174, 18616); return 0 } else if ((n | 0) == 20) { ec(9480, 15040, 175, 18616); return 0 } else if ((n | 0) == 77) { i = m; return q | 0 }
                        }
                    } while (0);
                    do {
                        if ((w | 0) < 0) {
                            if ((a[y + v | 0] | 0) == 0) { N = F; break }
                            if ((F | 0) > 15) {
                                q = 0;
                                i = m;
                                return q | 0
                            } else {
                                b[h + (F << 1) >> 1] = w;
                                a[h + 64 + F | 0] = a[x + v | 0] | 0;
                                N = F + 1 | 0;
                                break
                            }
                        } else { N = F }
                    } while (0);
                    t = A << 24 >> 24 == 0;
                    c: do {
                        if (t) {
                            a[h + 96 | 0] = N;
                            O = 0
                        } else {
                            u = N;
                            r = 0;
                            d: while (1) {
                                H = (b[(c[s >> 2] | 0) + (o * 100 | 0) + (r << 1) >> 1] | 0) + w | 0;
                                do {
                                    if ((H | 0) < 0) {
                                        if ((a[y + r | 0] | 0) == 0) { P = u; break }
                                        if ((u | 0) > 15) {
                                            q = 0;
                                            n = 77;
                                            break d
                                        }
                                        b[h + (u << 1) >> 1] = H;
                                        a[h + 64 + u | 0] = a[x + r | 0] | 0;
                                        P = u + 1 | 0
                                    } else { P = u }
                                } while (0);
                                H = r + 1 | 0;
                                if ((H | 0) < (B | 0)) {
                                    u = P;
                                    r = H
                                } else { break }
                            }
                            if ((n | 0) == 77) { i = m; return q | 0 }
                            a[h + 96 | 0] = P;
                            if (t) { O = 0; break } else {
                                Q = 0;
                                R = B
                            }
                            while (1) {
                                r = c[s >> 2] | 0;
                                u = R;
                                while (1) {
                                    S = u - 1 | 0;
                                    T = (b[r + (o * 100 | 0) + (S << 1) >> 1] | 0) + w | 0;
                                    if ((T | 0) > 0) { if ((a[y + S | 0] | 0) != 0) { break } }
                                    if ((S | 0) > 0) { u = S } else { O = Q; break c }
                                }
                                if ((Q | 0) > 15) { q = 0; break }
                                b[h + 32 + (Q << 1) >> 1] = T;
                                a[h + 80 + Q | 0] = a[x + S | 0] | 0;
                                u = Q + 1 | 0;
                                if ((S | 0) > 0) {
                                    Q = u;
                                    R = S
                                } else { O = u; break c }
                            }
                            i = m;
                            return q | 0
                        }
                    } while (0);
                    do {
                        if ((w | 0) > 0) {
                            if ((a[y + v | 0] | 0) == 0) { U = O; break }
                            if ((O | 0) > 15) {
                                q = 0;
                                i = m;
                                return q | 0
                            } else {
                                b[h + 32 + (O << 1) >> 1] = w;
                                a[h + 80 + O | 0] = a[x + v | 0] | 0;
                                U = O + 1 | 0;
                                break
                            }
                        } else { U = O }
                    } while (0);
                    do {
                        if (E) { V = U & 255 } else {
                            v = U;
                            t = 0;
                            e: while (1) {
                                A = (b[(c[s >> 2] | 0) + (o * 100 | 0) + 32 + (t << 1) >> 1] | 0) + w | 0;
                                do {
                                    if ((A | 0) > 0) {
                                        u = t + B | 0;
                                        if ((a[y + u | 0] | 0) == 0) { W = v; break }
                                        if ((v | 0) > 15) {
                                            q = 0;
                                            n = 77;
                                            break e
                                        }
                                        b[h + 32 + (v << 1) >> 1] = A;
                                        a[h + 80 + v | 0] = a[x + u | 0] | 0;
                                        W = v + 1 | 0
                                    } else { W = v }
                                } while (0);
                                A = t + 1 | 0;
                                if ((A | 0) < (z | 0)) {
                                    v = W;
                                    t = A
                                } else { n = 54; break }
                            }
                            if ((n | 0) == 54) { V = W & 255; break } else if ((n | 0) == 77) { i = m; return q | 0 }
                        }
                    } while (0);
                    a[h + 97 | 0] = V
                }
            } while (0);
            f: do {
                if ((n | 0) == 56) {
                    V = qd(g) | 0;
                    W = qd(g) | 0;
                    if ((W + V | 0) > (c[f + 528 + ((a[f + 2 | 0] | 0) - 1 << 2) >> 2] | 0)) {
                        U = h + 96 | 0;
                        C = 0;
                        a[U] = C;
                        C = C >> 8;
                        a[U + 1 | 0] = C;
                        C = C >> 8;
                        a[U + 2 | 0] = C;
                        C = C >> 8;
                        a[U + 3 | 0] = C;
                        Ue(e, 1018, 0);
                        q = 0;
                        i = m;
                        return q | 0
                    }
                    if ((V | 0) > 16 | (W | 0) > 16) {
                        Ue(e, 1018, 0);
                        q = 0;
                        i = m;
                        return q | 0
                    }
                    a[h + 96 | 0] = V;
                    a[h + 97 | 0] = W;
                    g: do {
                        if ((V | 0) > 0) {
                            U = 0;
                            O = 0;
                            while (1) {
                                S = qd(g) | 0;
                                if ((S | 0) == -99999) { q = 0; break }
                                R = (nd(g, 1) | 0) & 255;
                                Q = h + (O << 1) | 0;
                                b[Q >> 1] = U + 65535 - S;
                                a[h + 64 + O | 0] = R;
                                R = O + 1 | 0;
                                if ((R | 0) < (V | 0)) {
                                    U = b[Q >> 1] | 0;
                                    O = R
                                } else { break g }
                            }
                            i = m;
                            return q | 0
                        }
                    } while (0);
                    if ((W | 0) > 0) {
                        X = 0;
                        Y = 0
                    } else { break }
                    while (1) {
                        V = qd(g) | 0;
                        if ((V | 0) == -99999) { q = 0; break }
                        O = (nd(g, 1) | 0) & 255;
                        U = h + 32 + (Y << 1) | 0;
                        b[U >> 1] = X + 1 + V;
                        a[h + 80 + Y | 0] = O;
                        O = Y + 1 | 0;
                        if ((O | 0) < (W | 0)) {
                            X = b[U >> 1] | 0;
                            Y = O
                        } else { break f }
                    }
                    i = m;
                    return q | 0
                }
            } while (0);
            Y = h + 99 | 0;
            a[Y] = 0;
            X = a[h + 96 | 0] | 0;
            if (X << 24 >> 24 == 0) {
                Z = 0;
                _ = 0
            } else {
                g = X & 255;
                e = 0;
                f = 0;
                while (1) {
                    if ((a[h + 64 + e | 0] | 0) == 0) { $ = f } else {
                        n = f + 1 & 255;
                        a[Y] = n;
                        $ = n
                    }
                    n = e + 1 | 0;
                    if ((n | 0) < (g | 0)) {
                        e = n;
                        f = $
                    } else {
                        Z = X;
                        _ = $;
                        break
                    }
                }
            }
            $ = a[h + 97 | 0] | 0;
            if ($ << 24 >> 24 == 0) { aa = 0 } else {
                X = $ & 255;
                f = 0;
                e = _;
                while (1) {
                    if ((a[h + 80 + f | 0] | 0) == 0) { ba = e } else {
                        _ = e + 1 & 255;
                        a[Y] = _;
                        ba = _
                    }
                    _ = f + 1 | 0;
                    if ((_ | 0) < (X | 0)) {
                        f = _;
                        e = ba
                    } else { aa = $; break }
                }
            }
            a[h + 98 | 0] = aa + Z;
            q = 1;
            i = m;
            return q | 0
        }

        function tj(d, e, f) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            g = i;
            h = e << 1;
            j = i;
            i = i + (h + 2) | 0;
            i = i + 7 & -8;
            k = h | 1;
            a[j + k | 0] = 0;
            if ((k | 0) > 0) { dv(j | 0, 46, k | 0) | 0 }
            a[j + e | 0] = 124;
            k = a[d + 96 | 0] | 0;
            if (!(k << 24 >> 24 == 0)) {
                h = -e | 0;
                l = k & 255;
                do {
                    l = l - 1 | 0;
                    k = b[d + (l << 1) >> 1] | 0;
                    m = a[d + 64 + l | 0] | 0;
                    do {
                        if ((k | 0) < (h | 0)) {
                            Zk(f, 16008, (n = i, i = i + 16 | 0, c[n >> 2] = k, c[n + 8 >> 2] = m << 24 >> 24 != 0 ? 88 : 111, n) | 0);
                            i = n
                        } else { o = j + (k + e) | 0; if (m << 24 >> 24 == 0) { a[o] = 111; break } else { a[o] = 88; break } }
                    } while (0);
                } while ((l | 0) > 0)
            }
            l = a[d + 97 | 0] | 0;
            if (l << 24 >> 24 == 0) {
                Zk(f, 15608, (n = i, i = i + 8 | 0, c[n >> 2] = j, n) | 0);
                i = n;
                i = g;
                return
            }
            h = l & 255;
            do {
                h = h - 1 | 0;
                l = b[d + 32 + (h << 1) >> 1] | 0;
                m = a[d + 80 + h | 0] | 0;
                do {
                    if ((l | 0) > (e | 0)) {
                        Zk(f, 16008, (n = i, i = i + 16 | 0, c[n >> 2] = l, c[n + 8 >> 2] = m << 24 >> 24 != 0 ? 88 : 111, n) | 0);
                        i = n
                    } else { k = j + (l + e) | 0; if (m << 24 >> 24 == 0) { a[k] = 111; break } else { a[k] = 88; break } }
                } while (0);
            } while ((h | 0) > 0);
            Zk(f, 15608, (n = i, i = i + 8 | 0, c[n >> 2] = j, n) | 0);
            i = n;
            i = g;
            return
        }

        function uj(b) {
            b = b | 0;
            var d = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0;
            if ((a[b + 5467 | 0] | 0) == 0) { return }
            d = b + 40 | 0;
            f = b + 28 | 0;
            g = ga(c[f >> 2] | 0, c[d >> 2] | 0) | 0;
            h = b + 5760 | 0;
            i = ga(g, ((c[h >> 2] | 0) + 7 | 0) / 8 | 0) | 0;
            g = b + 44 | 0;
            j = b + 36 | 0;
            k = ga(c[j >> 2] | 0, c[g >> 2] | 0) | 0;
            l = b + 5768 | 0;
            m = ga(k, ((c[l >> 2] | 0) + 7 | 0) / 8 | 0) | 0;
            k = (i | 0) > (m | 0) ? i : m;
            m = Ou((k | 0) > -1 ? k : -1) | 0;
            if ((m | 0) == 0) { Ue((c[b + 10332 >> 2] | 0) + 4 | 0, 1024, 0); return }
            k = (c[b + 5776 >> 2] | 0) == 0 ? 1 : 3;
            i = b + 5828 | 0;
            n = b + 5820 | 0;
            o = b + 10352 | 0;
            p = b + 10340 | 0;
            q = b + 52 | 0;
            r = b + 48 | 0;
            s = b + 5804 | 0;
            t = b + 4 | 0;
            u = m;
            v = b + 5780 | 0;
            w = b + 5784 | 0;
            x = 0;
            y = c[i >> 2] | 0;
            a: while (1) {
                z = (x | 0) == 0;
                A = z ? d : g;
                B = c[A >> 2] | 0;
                C = b + 4 + (x << 2) | 0;
                D = ga(c[(z ? f : j) >> 2] | 0, B) | 0;
                E = z ? h : l;
                cv(m | 0, c[C >> 2] | 0, ga(D, ((c[E >> 2] | 0) + 7 | 0) / 8 | 0) | 0) | 0;
                if ((y | 0) > 0) {
                    D = 0;
                    F = c[n >> 2] | 0;
                    G = y;
                    while (1) {
                        if ((F | 0) > 0) {
                            H = 0;
                            do {
                                I = (ga(c[o >> 2] | 0, D) | 0) + H | 0;
                                J = e[(c[p >> 2] | 0) + (I * 24 | 0) + 2 >> 1] | 0;
                                I = c[r >> 2] | 0;
                                if (!(J >>> 0 < (c[q >> 2] | 0) - I >> 2 >>> 0)) { K = 24; break a }
                                L = c[I + (J << 2) >> 2] | 0;
                                if ((L | 0) == 0) { K = 24; break a }
                                do {
                                    if (z) {
                                        if ((a[L + 325 | 0] | 0) == 0) { break }
                                        J = 1 << c[s >> 2];
                                        I = c[t >> 2] | 0;
                                        M = c[d >> 2] | 0;
                                        if ((c[h >> 2] | 0) > 8) { Aj(b, H, D, 0, 0, J, J, u, B, I, M); break } else { Bj(b, H, D, 0, 0, J, J, m, B, I, M); break }
                                    } else {
                                        if ((a[L + 326 | 0] | 0) == 0) { break }
                                        M = 1 << c[s >> 2];
                                        I = (M | 0) / (c[v >> 2] | 0) | 0;
                                        J = (M | 0) / (c[w >> 2] | 0) | 0;
                                        M = c[C >> 2] | 0;
                                        N = c[A >> 2] | 0;
                                        if ((c[E >> 2] | 0) > 8) { Aj(b, H, D, 0, x, I, J, u, B, M, N); break } else { Bj(b, H, D, 0, x, I, J, m, B, M, N); break }
                                    }
                                } while (0);
                                H = H + 1 | 0;
                                O = c[n >> 2] | 0;
                            } while ((H | 0) < (O | 0));
                            P = O;
                            Q = c[i >> 2] | 0
                        } else {
                            P = F;
                            Q = G
                        }
                        H = D + 1 | 0;
                        if ((H | 0) < (Q | 0)) {
                            D = H;
                            F = P;
                            G = Q
                        } else { R = Q; break }
                    }
                } else { R = y }
                G = x + 1 | 0;
                if ((G | 0) < (k | 0)) {
                    x = G;
                    y = R
                } else { K = 23; break }
            }
            if ((K | 0) == 23) { Qu(m); return } else if ((K | 0) == 24) { return }
        }

        function vj(b) {
            b = b | 0;
            var d = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0;
            d = b | 0;
            f = b + 4 | 0;
            c[f >> 2] = 1;
            g = b + 12 | 0;
            Wh(c[g >> 2] | 0, d);
            h = c[g >> 2] | 0;
            i = c[h + 5820 >> 2] | 0;
            j = i - 1 | 0;
            k = c[h + 5804 >> 2] | 0;
            l = 1 << k;
            m = b + 8 | 0;
            n = b + 24 | 0;
            Yh(h, d, j, c[m >> 2] | 0, c[n >> 2] | 0);
            h = c[m >> 2] | 0;
            if ((h | 0) > 0) {
                Yh(c[g >> 2] | 0, d, j, h - 1 | 0, c[n >> 2] | 0);
                o = c[m >> 2] | 0
            } else { o = h }
            h = o + 1 | 0;
            p = c[g >> 2] | 0;
            if ((h | 0) < (c[p + 5828 >> 2] | 0)) {
                Yh(p, d, j, h, c[n >> 2] | 0);
                q = c[m >> 2] | 0
            } else { q = o }
            o = b + 20 | 0;
            n = b + 16 | 0;
            Th(c[o >> 2] | 0, c[n >> 2] | 0, q << k, q + 1 << k);
            k = c[g >> 2] | 0;
            a: do {
                if ((c[k + 5820 >> 2] | 0) > 0) {
                    q = 0;
                    b = k;
                    while (1) {
                        h = c[m >> 2] | 0;
                        p = (ga(c[b + 10352 >> 2] | 0, h) | 0) + q | 0;
                        r = e[(c[b + 10340 >> 2] | 0) + (p * 24 | 0) + 2 >> 1] | 0;
                        p = c[b + 48 >> 2] | 0;
                        if (!(r >>> 0 < (c[b + 52 >> 2] | 0) - p >> 2 >>> 0)) { s = b; break a }
                        t = c[p + (r << 2) >> 2] | 0;
                        if ((t | 0) == 0) { s = b; break a }
                        do {
                            if ((a[t + 325 | 0] | 0) != 0) {
                                r = c[n >> 2] | 0;
                                p = c[r + 4 >> 2] | 0;
                                u = c[r + 40 >> 2] | 0;
                                r = c[o >> 2] | 0;
                                v = c[r + 4 >> 2] | 0;
                                w = c[r + 40 >> 2] | 0;
                                if ((c[b + 5760 >> 2] | 0) > 8) { Aj(b, q, h, 0, 0, l, l, p, u, v, w); break } else { Bj(b, q, h, 0, 0, l, l, p, u, v, w); break }
                            }
                        } while (0);
                        do {
                            if ((a[t + 326 | 0] | 0) != 0) {
                                h = c[g >> 2] | 0;
                                w = (l | 0) / (c[h + 5780 >> 2] | 0) | 0;
                                v = (l | 0) / (c[h + 5784 >> 2] | 0) | 0;
                                u = c[m >> 2] | 0;
                                p = c[n >> 2] | 0;
                                r = c[p + 8 >> 2] | 0;
                                x = c[p + 44 >> 2] | 0;
                                p = c[o >> 2] | 0;
                                y = c[p + 8 >> 2] | 0;
                                z = c[p + 44 >> 2] | 0;
                                if ((c[h + 5768 >> 2] | 0) > 8) { Aj(h, q, u, 0, 1, w, v, r, x, y, z) } else { Bj(h, q, u, 0, 1, w, v, r, x, y, z) }
                                z = c[g >> 2] | 0;
                                y = c[m >> 2] | 0;
                                x = c[n >> 2] | 0;
                                r = c[x + 12 >> 2] | 0;
                                u = c[x + 44 >> 2] | 0;
                                x = c[o >> 2] | 0;
                                h = c[x + 12 >> 2] | 0;
                                p = c[x + 44 >> 2] | 0;
                                if ((c[z + 5768 >> 2] | 0) > 8) { Aj(z, q, y, 0, 2, w, v, r, u, h, p); break } else { Bj(z, q, y, 0, 2, w, v, r, u, h, p); break }
                            }
                        } while (0);
                        t = q + 1 | 0;
                        p = c[g >> 2] | 0;
                        if ((t | 0) < (c[p + 5820 >> 2] | 0)) {
                            q = t;
                            b = p
                        } else { s = p; break }
                    }
                } else { s = k }
            } while (0);
            if ((i | 0) < 1) {
                A = s;
                c[f >> 2] = 3;
                Xh(A, d);
                return
            } else {
                B = 0;
                C = s
            }
            while (1) {
                s = (ga(c[m >> 2] | 0, c[C + 5820 >> 2] | 0) | 0) + B | 0;
                Ek((c[C + 10524 >> 2] | 0) + (s * 76 | 0) | 0, 4);
                if ((B | 0) >= (j | 0)) { break }
                B = B + 1 | 0;
                C = c[g >> 2] | 0
            }
            A = c[g >> 2] | 0;
            c[f >> 2] = 3;
            Xh(A, d);
            return
        }

        function wj(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            e = i;
            i = i + 8 | 0;
            f = e | 0;
            g = c[b >> 2] | 0;
            if ((a[g + 5467 | 0] | 0) == 0) {
                h = 0;
                i = e;
                return h | 0
            }
            j = g + 10332 | 0;
            k = c[j >> 2] | 0;
            l = b + 8 | 0;
            m = g + 10480 | 0;
            if ((Ph(l, c[g + 24 >> 2] | 0, c[g + 28 >> 2] | 0, c[g + 20 >> 2] | 0, g + 764 | 0, 0, k, c[g + 10336 >> 2] | 0, c[m >> 2] | 0, c[m + 4 >> 2] | 0, c[g + 10488 >> 2] | 0, 1) | 0) != 0) {
                Ue((c[j >> 2] | 0) + 4 | 0, 1024, 0);
                h = 0;
                i = e;
                return h | 0
            }
            j = c[g + 5828 >> 2] | 0;
            Vh(g, j);
            if ((j | 0) > 0) {
                m = b + 10668 | 0;
                n = b + 10672 | 0;
                o = k + 375396 | 0;
                k = b + 10664 | 0;
                b = 0;
                do {
                    p = Nu(28) | 0;
                    c[p + 4 >> 2] = 0;
                    c[p >> 2] = 22280;
                    c[p + 16 >> 2] = g;
                    c[p + 20 >> 2] = l;
                    c[p + 12 >> 2] = g;
                    c[p + 8 >> 2] = b;
                    c[p + 24 >> 2] = d;
                    q = p;
                    c[f >> 2] = q;
                    p = c[m >> 2] | 0;
                    if (p >>> 0 < (c[n >> 2] | 0) >>> 0) {
                        if ((p | 0) == 0) { r = 0 } else {
                            c[p >> 2] = q;
                            r = c[m >> 2] | 0
                        }
                        c[m >> 2] = r + 4
                    } else { He(k, f) }
                    Kk(o, q);
                    b = b + 1 | 0;
                } while ((b | 0) < (j | 0))
            }
            _h(g);
            Uh(g, l);
            h = 1;
            i = e;
            return h | 0
        }

        function xj(a) { a = a | 0; return }

        function yj(a) {
            a = a | 0;
            Pu(a);
            return
        }

        function zj(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            e = i;
            i = i + 104 | 0;
            f = e | 0;
            mb(f | 0, 6568, (g = i, i = i + 8 | 0, c[g >> 2] = c[d + 8 >> 2], g) | 0) | 0;
            i = g;
            g = ev(f | 0) | 0;
            if (g >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (g >>> 0 < 11 >>> 0) {
                a[b] = g << 1;
                h = b + 1 | 0;
                cv(h | 0, f | 0, g) | 0;
                j = h + g | 0;
                a[j] = 0;
                k = 100;
                l = 0;
                i = e;
                return
            } else {
                d = g + 16 & -16;
                m = Nu(d) | 0;
                c[b + 8 >> 2] = m;
                c[b >> 2] = d | 1;
                c[b + 4 >> 2] = g;
                h = m;
                cv(h | 0, f | 0, g) | 0;
                j = h + g | 0;
                a[j] = 0;
                k = 100;
                l = 0;
                i = e;
                return
            }
        }

        function Aj(f, g, h, j, k, l, m, n, o, p, q) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            var r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0,
                Fa = 0,
                Ga = 0;
            j = i;
            i = i + 152 | 0;
            r = j | 0;
            s = j + 8 | 0;
            t = j + 16 | 0;
            u = j + 24 | 0;
            v = c[f + 10352 >> 2] | 0;
            w = (ga(v, h) | 0) + g | 0;
            x = c[f + 10340 >> 2] | 0;
            y = k << 1;
            z = (d[x + (w * 24 | 0) + 4 | 0] | 0) >>> (y >>> 0) & 3;
            if ((z | 0) == 0) { i = j; return }
            A = (k | 0) == 0;
            B = c[(A ? f + 5760 | 0 : f + 5768 | 0) >> 2] | 0;
            C = (1 << B) - 1 | 0;
            D = ga(l, g) | 0;
            g = ga(m, h) | 0;
            h = c[(A ? f + 24 | 0 : f + 32 | 0) >> 2] | 0;
            E = c[(A ? f + 28 | 0 : f + 36 | 0) >> 2] | 0;
            F = c[f + 10348 >> 2] | 0;
            G = D >> F;
            H = g >> F;
            if (!((G | 0) > -1 & (G | 0) < (v | 0))) { ec(14920, 12440, 118, 17328) }
            if (!((H | 0) > -1)) { ec(9408, 12440, 119, 17328) }
            I = c[f + 10356 >> 2] | 0;
            if ((H | 0) >= (I | 0)) { ec(9408, 12440, 119, 17328) }
            J = x + (((ga(H, v) | 0) + G | 0) * 24 | 0) + 2 | 0;
            G = f + 52 | 0;
            H = c[f + 48 >> 2] | 0;
            K = c[(c[H + (e[J >> 1] << 2) >> 2] | 0) + 800 >> 2] | 0;
            J = c[f + 5820 >> 2] | 0;
            if (A) {
                L = 0;
                M = 0
            } else {
                L = (c[f + 5784 >> 2] | 0) - 1 | 0;
                M = (c[f + 5780 >> 2] | 0) - 1 | 0
            }
            A = c[f + 5804 >> 2] | 0;
            N = A - M | 0;
            O = A - L | 0;
            A = (D + l | 0) > (h | 0) ? h - D | 0 : l;
            l = (g + m | 0) > (E | 0) ? E - g | 0 : m;
            m = (a[x + (w * 24 | 0) + 22 | 0] | 0) != 0;
            if ((z | 0) == 2) {
                z = (d[x + (w * 24 | 0) + 5 | 0] | 0) >>> (y >>> 0) & 3;
                if ((z | 0) == 3) {
                    c[r >> 2] = 1;
                    c[r + 4 >> 2] = -1;
                    c[s >> 2] = -1;
                    c[s + 4 >> 2] = 1;
                    P = -1;
                    Q = 1;
                    R = 1;
                    S = -1
                } else if ((z | 0) == 1) {
                    c[r >> 2] = 0;
                    c[r + 4 >> 2] = 0;
                    c[s >> 2] = -1;
                    c[s + 4 >> 2] = 1;
                    P = -1;
                    Q = 1;
                    R = 0;
                    S = 0
                } else if ((z | 0) == 2) {
                    c[r >> 2] = -1;
                    c[r + 4 >> 2] = 1;
                    c[s >> 2] = -1;
                    c[s + 4 >> 2] = 1;
                    P = -1;
                    Q = 1;
                    R = -1;
                    S = 1
                } else if ((z | 0) == 0) {
                    c[r >> 2] = -1;
                    c[r + 4 >> 2] = 1;
                    c[s >> 2] = 0;
                    c[s + 4 >> 2] = 0;
                    P = 0;
                    Q = 0;
                    R = -1;
                    S = 1
                } else {
                    P = 0;
                    Q = 0;
                    R = 0;
                    S = 0
                }
                z = ga(P, o) | 0;
                P = ga(Q, o) | 0;
                a[t | 0] = a[x + (w * 24 | 0) + 9 + (k << 2) | 0] | 0;
                a[t + 1 | 0] = a[x + (w * 24 | 0) + 9 + (k << 2) + 1 | 0] | 0;
                a[t + 2 | 0] = 0;
                a[t + 3 | 0] = a[x + (w * 24 | 0) + 9 + (k << 2) + 2 | 0] | 0;
                a[t + 4 | 0] = a[x + (w * 24 | 0) + 9 + (k << 2) + 3 | 0] | 0;
                if ((l | 0) <= 0) { i = j; return }
                Q = (A | 0) > 0;
                y = f + 5480 | 0;
                T = f + 10368 | 0;
                U = f + 10372 | 0;
                V = f + 10376 | 0;
                W = f + 10360 | 0;
                X = A - 1 | 0;
                Y = l - 1 | 0;
                Z = f + 5977 | 0;
                _ = f + 10308 | 0;
                $ = (ga(g >> O, J) | 0) + (D >> N) | 0;
                aa = 0;
                a: while (1) {
                    ba = aa + g | 0;
                    ca = (ga(ba, o) | 0) + D | 0;
                    da = (ga(ba, q) | 0) + D | 0;
                    if (Q) {
                        ea = ba << L;
                        fa = (aa | 0) == 0;
                        ha = ca + z | 0;
                        ia = ca + P | 0;
                        ja = (aa | 0) == (Y | 0);
                        ka = 0;
                        do {
                            do {
                                if (m) {
                                    if ((a[y] | 0) == 0) { la = 28; break }
                                    ma = c[T >> 2] | 0;
                                    na = ka + D << M >> ma;
                                    oa = ea >> ma;
                                    if (!((na | 0) > -1)) { la = 23; break a }
                                    ma = c[U >> 2] | 0;
                                    if ((na | 0) >= (ma | 0)) { la = 23; break a }
                                    if (!((oa | 0) > -1)) { la = 26; break a }
                                    if ((oa | 0) >= (c[V >> 2] | 0)) { la = 26; break a }
                                    pa = (ga(ma, oa) | 0) + na | 0;
                                    na = (c[W >> 2] | 0) + (pa * 3 | 0) | 0;
                                    if (((d[na] | d[na + 1 | 0] << 8) << 16 >> 16 & 1024) == 0) { la = 28 }
                                } else { la = 28 }
                            } while (0);
                            b: do {
                                if ((la | 0) == 28) {
                                    la = 0;
                                    na = ka + D | 0;
                                    pa = na << M;
                                    oa = c[T >> 2] | 0;
                                    ma = pa >> oa;
                                    qa = ea >> oa;
                                    if (!((ma | 0) > -1)) { la = 30; break a }
                                    oa = c[U >> 2] | 0;
                                    if ((ma | 0) >= (oa | 0)) { la = 30; break a }
                                    if (!((qa | 0) > -1)) { la = 33; break a }
                                    if ((qa | 0) >= (c[V >> 2] | 0)) { la = 33; break a }
                                    ra = (ga(oa, qa) | 0) + ma | 0;
                                    ma = (c[W >> 2] | 0) + (ra * 3 | 0) | 0;
                                    if (!(((d[ma] | d[ma + 1 | 0] << 8) << 16 >> 16 & 2048) == 0)) { break }
                                    if ((ka | 0) == 0 | fa | (ka | 0) == (X | 0) | ja) {
                                        ma = 0;
                                        do {
                                            ra = (c[r + (ma << 2) >> 2] | 0) + na | 0;
                                            qa = (c[s + (ma << 2) >> 2] | 0) + ba | 0;
                                            if (!((qa | ra | 0) > -1 & (ra | 0) < (h | 0) & (qa | 0) < (E | 0))) { break b }
                                            oa = ra << M >> F;
                                            sa = qa << L >> F;
                                            if (!((oa | 0) > -1 & (oa | 0) < (v | 0))) { la = 38; break a }
                                            if (!((sa | 0) > -1 & (sa | 0) < (I | 0))) { la = 40; break a }
                                            ta = x + (((ga(v, sa) | 0) + oa | 0) * 24 | 0) + 2 | 0;
                                            oa = e[ta >> 1] | 0;
                                            if (!(oa >>> 0 < (c[G >> 2] | 0) - H >> 2 >>> 0)) { la = 113; break a }
                                            ta = c[H + (oa << 2) >> 2] | 0;
                                            if ((ta | 0) == 0) { la = 113; break a }
                                            oa = c[ta + 800 >> 2] | 0;
                                            if ((oa | 0) < (K | 0)) {
                                                sa = pa >> F;
                                                ua = ea >> F;
                                                if (!((sa | 0) > -1 & (sa | 0) < (v | 0))) { la = 45; break a }
                                                if (!((ua | 0) > -1 & (ua | 0) < (I | 0))) { la = 47; break a }
                                                va = x + (((ga(v, ua) | 0) + sa | 0) * 24 | 0) + 2 | 0;
                                                if ((a[(c[H + (e[va >> 1] << 2) >> 2] | 0) + 764 | 0] | 0) == 0) { break b }
                                            }
                                            if ((oa | 0) > (K | 0)) { if ((a[ta + 764 | 0] | 0) == 0) { break b } }
                                            if ((a[Z] | 0) == 0) {
                                                ta = (ga(qa >> O, J) | 0) + (ra >> N) | 0;
                                                ra = c[_ >> 2] | 0;
                                                if ((c[ra + (ta << 2) >> 2] | 0) != (c[ra + ($ << 2) >> 2] | 0)) { break b }
                                            }
                                            ma = ma + 1 | 0;
                                        } while ((ma | 0) < 2)
                                    }
                                    ma = e[n + (ka + ca << 1) >> 1] | 0;
                                    pa = ma - (e[n + (ha + ka + R << 1) >> 1] | 0) | 0;
                                    if ((pa | 0) < 0) { wa = 1 } else { wa = (pa | 0) > 0 | 2 }
                                    pa = ma - (e[n + (ia + ka + S << 1) >> 1] | 0) | 0;
                                    if ((pa | 0) < 0) { xa = -1 } else { xa = (pa | 0) > 0 | 0 }
                                    pa = ma + (a[t + (wa + xa) | 0] | 0) | 0;
                                    if ((pa | 0) < 0) { ya = 0 } else { ya = ((pa | 0) > (C | 0) ? C : pa) & 65535 }
                                    b[p + (da + ka << 1) >> 1] = ya
                                }
                            } while (0);
                            ka = ka + 1 | 0;
                        } while ((ka | 0) < (A | 0))
                    }
                    ka = aa + 1 | 0;
                    if ((ka | 0) < (l | 0)) { aa = ka } else { la = 113; break }
                }
                if ((la | 0) == 23) { ec(14920, 12440, 118, 17328) } else if ((la | 0) == 26) { ec(9408, 12440, 119, 17328) } else if ((la | 0) == 30) { ec(14920, 12440, 118, 17328) } else if ((la | 0) == 33) { ec(9408, 12440, 119, 17328) } else if ((la | 0) == 38) { ec(14920, 12440, 118, 17328) } else if ((la | 0) == 40) { ec(9408, 12440, 119, 17328) } else if ((la | 0) == 45) { ec(14920, 12440, 118, 17328) } else if ((la | 0) == 47) { ec(9408, 12440, 119, 17328) } else if ((la | 0) == 113) { i = j; return }
            }
            aa = d[x + (w * 24 | 0) + 6 + k | 0] | 0;
            dv(u | 0, 0, 128) | 0;
            c[u + ((aa & 31) << 2) >> 2] = 1;
            c[u + ((aa + 1 & 31) << 2) >> 2] = 2;
            c[u + ((aa + 2 & 31) << 2) >> 2] = 3;
            c[u + ((aa + 3 & 31) << 2) >> 2] = 4;
            aa = B - 5 | 0;
            B = (l | 0) > 0;
            if (!m) {
                if (!B) { i = j; return }
                m = (A | 0) > 0;
                ya = (aa | 0) > 7;
                xa = 0;
                do {
                    if (m) {
                        wa = xa + g | 0;
                        t = ga(wa, o) | 0;
                        S = ga(wa, q) | 0;
                        wa = 0;
                        do {
                            R = wa + D | 0;
                            $ = e[n + (R + t << 1) >> 1] | 0;
                            _ = ya ? 0 : c[u + ($ >>> (aa >>> 0) << 2) >> 2] | 0;
                            if ((_ | 0) > 0) {
                                N = (a[_ - 1 + (x + (w * 24 | 0) + 9 + (k << 2)) | 0] | 0) + $ | 0;
                                if ((N | 0) < 0) { za = 0 } else { za = ((N | 0) > (C | 0) ? C : N) & 65535 }
                                b[p + (R + S << 1) >> 1] = za
                            }
                            wa = wa + 1 | 0;
                        } while ((wa | 0) < (A | 0))
                    }
                    xa = xa + 1 | 0;
                } while ((xa | 0) < (l | 0));
                i = j;
                return
            }
            if (!B) { i = j; return }
            B = (A | 0) > 0;
            xa = f + 5480 | 0;
            za = f + 10368 | 0;
            ya = f + 10372 | 0;
            m = f + 10376 | 0;
            wa = f + 10360 | 0;
            f = (aa | 0) > 7;
            S = 0;
            c: while (1) {
                d: do {
                    if (B) {
                        t = S + g | 0;
                        R = t << L;
                        N = ga(t, o) | 0;
                        $ = ga(t, q) | 0;
                        if (f) {
                            t = a[xa] | 0;
                            _ = 0;
                            while (1) {
                                if (t << 24 >> 24 == 0) {
                                    Aa = c[za >> 2] | 0;
                                    Ba = _ + D << M;
                                    la = 78
                                } else {
                                    J = _ + D << M;
                                    O = c[za >> 2] | 0;
                                    Z = J >> O;
                                    K = R >> O;
                                    if (!((Z | 0) > -1)) { la = 87; break c }
                                    H = c[ya >> 2] | 0;
                                    if ((Z | 0) >= (H | 0)) { la = 87; break c }
                                    if (!((K | 0) > -1)) { la = 90; break c }
                                    if ((K | 0) >= (c[m >> 2] | 0)) { la = 90; break c }
                                    v = (ga(H, K) | 0) + Z | 0;
                                    Z = (c[wa >> 2] | 0) + (v * 3 | 0) | 0;
                                    if (((d[Z] | d[Z + 1 | 0] << 8) << 16 >> 16 & 1024) == 0) {
                                        Aa = O;
                                        Ba = J;
                                        la = 78
                                    }
                                }
                                if ((la | 0) == 78) {
                                    la = 0;
                                    J = Ba >> Aa;
                                    O = R >> Aa;
                                    if (!((J | 0) > -1)) { la = 94; break c }
                                    if ((J | 0) >= (c[ya >> 2] | 0)) { la = 94; break c }
                                    if (!((O | 0) > -1)) { la = 97; break c }
                                    if ((O | 0) >= (c[m >> 2] | 0)) { la = 97; break c }
                                }
                                _ = _ + 1 | 0;
                                if ((_ | 0) >= (A | 0)) { break d }
                            }
                        } else { Ca = 0 }
                        do {
                            if ((a[xa] | 0) == 0) {
                                _ = Ca + D | 0;
                                Da = c[za >> 2] | 0;
                                Ea = _;
                                Fa = _ << M;
                                la = 92
                            } else {
                                _ = Ca + D | 0;
                                t = _ << M;
                                O = c[za >> 2] | 0;
                                J = t >> O;
                                Z = R >> O;
                                if (!((J | 0) > -1)) { la = 87; break c }
                                v = c[ya >> 2] | 0;
                                if ((J | 0) >= (v | 0)) { la = 87; break c }
                                if (!((Z | 0) > -1)) { la = 90; break c }
                                if ((Z | 0) >= (c[m >> 2] | 0)) { la = 90; break c }
                                K = (ga(v, Z) | 0) + J | 0;
                                J = (c[wa >> 2] | 0) + (K * 3 | 0) | 0;
                                if (((d[J] | d[J + 1 | 0] << 8) << 16 >> 16 & 1024) == 0) {
                                    Da = O;
                                    Ea = _;
                                    Fa = t;
                                    la = 92
                                }
                            }
                            do {
                                if ((la | 0) == 92) {
                                    la = 0;
                                    t = Fa >> Da;
                                    _ = R >> Da;
                                    if (!((t | 0) > -1)) { la = 94; break c }
                                    O = c[ya >> 2] | 0;
                                    if ((t | 0) >= (O | 0)) { la = 94; break c }
                                    if (!((_ | 0) > -1)) { la = 97; break c }
                                    if ((_ | 0) >= (c[m >> 2] | 0)) { la = 97; break c }
                                    J = (ga(O, _) | 0) + t | 0;
                                    t = (c[wa >> 2] | 0) + (J * 3 | 0) | 0;
                                    if (!(((d[t] | d[t + 1 | 0] << 8) << 16 >> 16 & 2048) == 0)) { break }
                                    t = e[n + (Ea + N << 1) >> 1] | 0;
                                    J = c[u + (t >>> (aa >>> 0) << 2) >> 2] | 0;
                                    if ((J | 0) <= 0) { break }
                                    _ = (a[J - 1 + (x + (w * 24 | 0) + 9 + (k << 2)) | 0] | 0) + t | 0;
                                    if ((_ | 0) < 0) { Ga = 0 } else { Ga = ((_ | 0) > (C | 0) ? C : _) & 65535 }
                                    b[p + (Ea + $ << 1) >> 1] = Ga
                                }
                            } while (0);
                            Ca = Ca + 1 | 0;
                        } while ((Ca | 0) < (A | 0))
                    }
                } while (0);$ = S + 1 | 0;
                if (($ | 0) < (l | 0)) { S = $ } else { la = 113; break }
            }
            if ((la | 0) == 87) { ec(14920, 12440, 118, 17328) } else if ((la | 0) == 90) { ec(9408, 12440, 119, 17328) } else if ((la | 0) == 94) { ec(14920, 12440, 118, 17328) } else if ((la | 0) == 97) { ec(9408, 12440, 119, 17328) } else if ((la | 0) == 113) { i = j; return }
        }

        function Bj(b, f, g, h, j, k, l, m, n, o, p) {
            b = b | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            var q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0;
            h = i;
            i = i + 152 | 0;
            q = h | 0;
            r = h + 8 | 0;
            s = h + 16 | 0;
            t = h + 24 | 0;
            u = b + 10352 | 0;
            v = c[u >> 2] | 0;
            w = (ga(v, g) | 0) + f | 0;
            x = b + 10340 | 0;
            y = c[x >> 2] | 0;
            z = j << 1;
            A = (d[y + (w * 24 | 0) + 4 | 0] | 0) >>> (z >>> 0) & 3;
            if ((A | 0) == 0) { i = h; return }
            B = (j | 0) == 0;
            C = c[(B ? b + 5760 | 0 : b + 5768 | 0) >> 2] | 0;
            D = (1 << C) - 1 | 0;
            E = ga(k, f) | 0;
            f = ga(l, g) | 0;
            g = c[(B ? b + 24 | 0 : b + 32 | 0) >> 2] | 0;
            F = c[(B ? b + 28 | 0 : b + 36 | 0) >> 2] | 0;
            G = b + 10348 | 0;
            H = c[G >> 2] | 0;
            I = E >> H;
            J = f >> H;
            if (!((I | 0) > -1 & (I | 0) < (v | 0))) { ec(14920, 12440, 118, 17328) }
            if (!((J | 0) > -1)) { ec(9408, 12440, 119, 17328) }
            H = b + 10356 | 0;
            if ((J | 0) >= (c[H >> 2] | 0)) { ec(9408, 12440, 119, 17328) }
            K = y + (((ga(J, v) | 0) + I | 0) * 24 | 0) + 2 | 0;
            I = b + 52 | 0;
            v = b + 48 | 0;
            J = c[(c[(c[v >> 2] | 0) + (e[K >> 1] << 2) >> 2] | 0) + 800 >> 2] | 0;
            K = c[b + 5820 >> 2] | 0;
            if (B) {
                L = 0;
                M = 0
            } else {
                L = (c[b + 5784 >> 2] | 0) - 1 | 0;
                M = (c[b + 5780 >> 2] | 0) - 1 | 0
            }
            B = c[b + 5804 >> 2] | 0;
            N = B - M | 0;
            O = B - L | 0;
            B = (E + k | 0) > (g | 0) ? g - E | 0 : k;
            k = (f + l | 0) > (F | 0) ? F - f | 0 : l;
            l = (a[y + (w * 24 | 0) + 22 | 0] | 0) != 0;
            if ((A | 0) != 2) {
                A = d[y + (w * 24 | 0) + 6 + j | 0] | 0;
                dv(t | 0, 0, 128) | 0;
                c[t + ((A & 31) << 2) >> 2] = 1;
                c[t + ((A + 1 & 31) << 2) >> 2] = 2;
                c[t + ((A + 2 & 31) << 2) >> 2] = 3;
                c[t + ((A + 3 & 31) << 2) >> 2] = 4;
                A = C - 5 | 0;
                C = (k | 0) > 0;
                if (!l) {
                    if (!C) { i = h; return }
                    P = (B | 0) > 0;
                    Q = (A | 0) > 7;
                    R = 0;
                    do {
                        if (P) {
                            S = R + f | 0;
                            T = ga(S, n) | 0;
                            U = ga(S, p) | 0;
                            S = 0;
                            do {
                                V = S + E | 0;
                                W = d[m + (V + T) | 0] | 0;
                                X = Q ? 0 : c[t + (W >>> (A >>> 0) << 2) >> 2] | 0;
                                if ((X | 0) > 0) {
                                    Y = (a[X - 1 + (y + (w * 24 | 0) + 9 + (j << 2)) | 0] | 0) + W | 0;
                                    if ((Y | 0) < 0) { Z = 0 } else { Z = ((Y | 0) > (D | 0) ? D : Y) & 255 }
                                    a[o + (V + U) | 0] = Z
                                }
                                S = S + 1 | 0;
                            } while ((S | 0) < (B | 0))
                        }
                        R = R + 1 | 0;
                    } while ((R | 0) < (k | 0));
                    i = h;
                    return
                }
                if (!C) { i = h; return }
                C = (B | 0) > 0;
                R = b + 5480 | 0;
                Z = b + 10368 | 0;
                Q = b + 10372 | 0;
                P = b + 10376 | 0;
                S = b + 10360 | 0;
                U = (A | 0) > 7;
                T = 0;
                a: while (1) {
                    if (C) {
                        V = T + f | 0;
                        Y = V << L;
                        W = ga(V, n) | 0;
                        X = ga(V, p) | 0;
                        V = 0;
                        do {
                            if ((a[R] | 0) == 0) {
                                _ = V + E | 0;
                                $ = c[Z >> 2] | 0;
                                aa = _;
                                ba = _ << M;
                                ca = 81
                            } else {
                                _ = V + E | 0;
                                da = _ << M;
                                ea = c[Z >> 2] | 0;
                                fa = da >> ea;
                                ha = Y >> ea;
                                if (!((fa | 0) > -1)) { ca = 76; break a }
                                ia = c[Q >> 2] | 0;
                                if ((fa | 0) >= (ia | 0)) { ca = 76; break a }
                                if (!((ha | 0) > -1)) { ca = 79; break a }
                                if ((ha | 0) >= (c[P >> 2] | 0)) { ca = 79; break a }
                                ja = (ga(ia, ha) | 0) + fa | 0;
                                fa = (c[S >> 2] | 0) + (ja * 3 | 0) | 0;
                                if (((d[fa] | d[fa + 1 | 0] << 8) << 16 >> 16 & 1024) == 0) {
                                    $ = ea;
                                    aa = _;
                                    ba = da;
                                    ca = 81
                                }
                            }
                            do {
                                if ((ca | 0) == 81) {
                                    ca = 0;
                                    da = ba >> $;
                                    _ = Y >> $;
                                    if (!((da | 0) > -1)) { ca = 83; break a }
                                    ea = c[Q >> 2] | 0;
                                    if ((da | 0) >= (ea | 0)) { ca = 83; break a }
                                    if (!((_ | 0) > -1)) { ca = 86; break a }
                                    if ((_ | 0) >= (c[P >> 2] | 0)) { ca = 86; break a }
                                    fa = (ga(ea, _) | 0) + da | 0;
                                    da = (c[S >> 2] | 0) + (fa * 3 | 0) | 0;
                                    if (!(((d[da] | d[da + 1 | 0] << 8) << 16 >> 16 & 2048) == 0)) { break }
                                    da = d[m + (aa + W) | 0] | 0;
                                    fa = U ? 0 : c[t + (da >>> (A >>> 0) << 2) >> 2] | 0;
                                    if ((fa | 0) <= 0) { break }
                                    _ = (a[fa - 1 + (y + (w * 24 | 0) + 9 + (j << 2)) | 0] | 0) + da | 0;
                                    if ((_ | 0) < 0) { ka = 0 } else { ka = ((_ | 0) > (D | 0) ? D : _) & 255 }
                                    a[o + (aa + X) | 0] = ka
                                }
                            } while (0);
                            V = V + 1 | 0;
                        } while ((V | 0) < (B | 0))
                    }
                    V = T + 1 | 0;
                    if ((V | 0) < (k | 0)) { T = V } else { ca = 102; break }
                }
                if ((ca | 0) == 76) { ec(14920, 12440, 118, 17328) } else if ((ca | 0) == 79) { ec(9408, 12440, 119, 17328) } else if ((ca | 0) == 83) { ec(14920, 12440, 118, 17328) } else if ((ca | 0) == 86) { ec(9408, 12440, 119, 17328) } else if ((ca | 0) == 102) { i = h; return }
            }
            T = (d[y + (w * 24 | 0) + 5 | 0] | 0) >>> (z >>> 0) & 3;
            if ((T | 0) == 1) {
                c[q >> 2] = 0;
                c[q + 4 >> 2] = 0;
                c[r >> 2] = -1;
                c[r + 4 >> 2] = 1;
                la = -1;
                ma = 1;
                na = 0;
                oa = 0
            } else if ((T | 0) == 2) {
                c[q >> 2] = -1;
                c[q + 4 >> 2] = 1;
                c[r >> 2] = -1;
                c[r + 4 >> 2] = 1;
                la = -1;
                ma = 1;
                na = -1;
                oa = 1
            } else if ((T | 0) == 3) {
                c[q >> 2] = 1;
                c[q + 4 >> 2] = -1;
                c[r >> 2] = -1;
                c[r + 4 >> 2] = 1;
                la = -1;
                ma = 1;
                na = 1;
                oa = -1
            } else if ((T | 0) == 0) {
                c[q >> 2] = -1;
                c[q + 4 >> 2] = 1;
                c[r >> 2] = 0;
                c[r + 4 >> 2] = 0;
                la = 0;
                ma = 0;
                na = -1;
                oa = 1
            } else {
                la = 0;
                ma = 0;
                na = 0;
                oa = 0
            }
            T = ga(la, n) | 0;
            la = ga(ma, n) | 0;
            a[s | 0] = a[y + (w * 24 | 0) + 9 + (j << 2) | 0] | 0;
            a[s + 1 | 0] = a[y + (w * 24 | 0) + 9 + (j << 2) + 1 | 0] | 0;
            a[s + 2 | 0] = 0;
            a[s + 3 | 0] = a[y + (w * 24 | 0) + 9 + (j << 2) + 2 | 0] | 0;
            a[s + 4 | 0] = a[y + (w * 24 | 0) + 9 + (j << 2) + 3 | 0] | 0;
            if ((k | 0) <= 0) { i = h; return }
            j = (B | 0) > 0;
            w = b + 5480 | 0;
            y = b + 10368 | 0;
            ma = b + 10372 | 0;
            z = b + 10376 | 0;
            ka = b + 10360 | 0;
            aa = B - 1 | 0;
            A = k - 1 | 0;
            t = b + 5977 | 0;
            U = b + 10308 | 0;
            b = (ga(f >> O, K) | 0) + (E >> N) | 0;
            S = 0;
            b: while (1) {
                P = S + f | 0;
                Q = (ga(P, n) | 0) + E | 0;
                $ = (ga(P, p) | 0) + E | 0;
                if (j) {
                    ba = P << L;
                    Z = (S | 0) == 0;
                    R = Q + T | 0;
                    C = Q + la | 0;
                    V = (S | 0) == (A | 0);
                    X = 0;
                    do {
                        do {
                            if (l) {
                                if ((a[w] | 0) == 0) { ca = 28; break }
                                W = c[y >> 2] | 0;
                                Y = X + E << M >> W;
                                _ = ba >> W;
                                if (!((Y | 0) > -1)) { ca = 23; break b }
                                W = c[ma >> 2] | 0;
                                if ((Y | 0) >= (W | 0)) { ca = 23; break b }
                                if (!((_ | 0) > -1)) { ca = 26; break b }
                                if ((_ | 0) >= (c[z >> 2] | 0)) { ca = 26; break b }
                                da = (ga(W, _) | 0) + Y | 0;
                                Y = (c[ka >> 2] | 0) + (da * 3 | 0) | 0;
                                if (((d[Y] | d[Y + 1 | 0] << 8) << 16 >> 16 & 1024) == 0) { ca = 28 }
                            } else { ca = 28 }
                        } while (0);
                        c: do {
                            if ((ca | 0) == 28) {
                                ca = 0;
                                Y = X + E | 0;
                                da = Y << M;
                                _ = c[y >> 2] | 0;
                                W = da >> _;
                                fa = ba >> _;
                                if (!((W | 0) > -1)) { ca = 30; break b }
                                _ = c[ma >> 2] | 0;
                                if ((W | 0) >= (_ | 0)) { ca = 30; break b }
                                if (!((fa | 0) > -1)) { ca = 33; break b }
                                if ((fa | 0) >= (c[z >> 2] | 0)) { ca = 33; break b }
                                ea = (ga(_, fa) | 0) + W | 0;
                                W = (c[ka >> 2] | 0) + (ea * 3 | 0) | 0;
                                if (!(((d[W] | d[W + 1 | 0] << 8) << 16 >> 16 & 2048) == 0)) { break }
                                if ((X | 0) == 0 | Z | (X | 0) == (aa | 0) | V) {
                                    W = 0;
                                    do {
                                        ea = (c[q + (W << 2) >> 2] | 0) + Y | 0;
                                        fa = (c[r + (W << 2) >> 2] | 0) + P | 0;
                                        if (!((fa | ea | 0) > -1 & (ea | 0) < (g | 0) & (fa | 0) < (F | 0))) { break c }
                                        _ = c[G >> 2] | 0;
                                        ja = ea << M >> _;
                                        ha = fa << L >> _;
                                        if (!((ja | 0) > -1)) { ca = 39; break b }
                                        ia = c[u >> 2] | 0;
                                        if ((ja | 0) >= (ia | 0)) { ca = 39; break b }
                                        if (!((ha | 0) > -1)) { ca = 42; break b }
                                        pa = c[H >> 2] | 0;
                                        if ((ha | 0) >= (pa | 0)) { ca = 42; break b }
                                        qa = (ga(ia, ha) | 0) + ja | 0;
                                        ja = c[x >> 2] | 0;
                                        ha = e[ja + (qa * 24 | 0) + 2 >> 1] | 0;
                                        qa = c[v >> 2] | 0;
                                        if (!(ha >>> 0 < (c[I >> 2] | 0) - qa >> 2 >>> 0)) { ca = 102; break b }
                                        ra = c[qa + (ha << 2) >> 2] | 0;
                                        if ((ra | 0) == 0) { ca = 102; break b }
                                        ha = c[ra + 800 >> 2] | 0;
                                        if ((ha | 0) < (J | 0)) {
                                            sa = da >> _;
                                            ta = ba >> _;
                                            if (!((sa | 0) > -1 & (sa | 0) < (ia | 0))) { ca = 47; break b }
                                            if (!((ta | 0) > -1 & (ta | 0) < (pa | 0))) { ca = 49; break b }
                                            pa = ja + (((ga(ia, ta) | 0) + sa | 0) * 24 | 0) + 2 | 0;
                                            if ((a[(c[qa + (e[pa >> 1] << 2) >> 2] | 0) + 764 | 0] | 0) == 0) { break c }
                                        }
                                        if ((ha | 0) > (J | 0)) { if ((a[ra + 764 | 0] | 0) == 0) { break c } }
                                        if ((a[t] | 0) == 0) {
                                            ra = (ga(fa >> O, K) | 0) + (ea >> N) | 0;
                                            ea = c[U >> 2] | 0;
                                            if ((c[ea + (ra << 2) >> 2] | 0) != (c[ea + (b << 2) >> 2] | 0)) { break c }
                                        }
                                        W = W + 1 | 0;
                                    } while ((W | 0) < 2)
                                }
                                W = d[m + (X + Q) | 0] | 0;
                                da = W - (d[m + (R + X + na) | 0] | 0) | 0;
                                if ((da | 0) < 0) { ua = 1 } else { ua = (da | 0) > 0 | 2 }
                                da = W - (d[m + (C + X + oa) | 0] | 0) | 0;
                                if ((da | 0) < 0) { va = -1 } else { va = (da | 0) > 0 | 0 }
                                da = W + (a[s + (ua + va) | 0] | 0) | 0;
                                if ((da | 0) < 0) { wa = 0 } else { wa = ((da | 0) > (D | 0) ? D : da) & 255 }
                                a[o + ($ + X) | 0] = wa
                            }
                        } while (0);
                        X = X + 1 | 0;
                    } while ((X | 0) < (B | 0))
                }
                X = S + 1 | 0;
                if ((X | 0) < (k | 0)) { S = X } else { ca = 102; break }
            }
            if ((ca | 0) == 23) { ec(14920, 12440, 118, 17328) } else if ((ca | 0) == 26) { ec(9408, 12440, 119, 17328) } else if ((ca | 0) == 30) { ec(14920, 12440, 118, 17328) } else if ((ca | 0) == 33) { ec(9408, 12440, 119, 17328) } else if ((ca | 0) == 39) { ec(14920, 12440, 118, 17328) } else if ((ca | 0) == 42) { ec(9408, 12440, 119, 17328) } else if ((ca | 0) == 47) { ec(14920, 12440, 118, 17328) } else if ((ca | 0) == 49) { ec(9408, 12440, 119, 17328) } else if ((ca | 0) == 102) { i = h; return }
        }

        function Cj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if ((b | 0) == 1) { d = c[28672 + (a << 2) >> 2] | 0 } else if ((b | 0) == 0) { d = c[28704 + (a << 2) >> 2] | 0 } else if ((b | 0) == 2) { d = c[28640 + (a << 2) >> 2] | 0 } else { d = 0 }
            return d | 0
        }

        function Dj(b, e, f, g, h) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0;
            i = (c[27544 + (g * 24 | 0) + (h << 2) >> 2] | 0) + ((f << h) + e << 1) | 0;
            e = b;
            C = (d[i] | d[i + 1 | 0] << 8) << 16 >> 16;
            a[e] = C;
            C = C >> 8;
            a[e + 1 | 0] = C;
            return
        }

        function Ej() {
            var b = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0;
            b = 1;
            while (1) {
                e = c[28672 + (b << 2) >> 2] | 0;
                f = 1 << b;
                if ((f | 0) > 0) {
                    g = 0;
                    h = 0;
                    while (1) {
                        i = h & 255;
                        j = g;
                        k = 0;
                        while (1) {
                            a[e + (j << 1) | 0] = k;
                            a[e + (j << 1) + 1 | 0] = i;
                            l = k + 1 | 0;
                            if ((l | 0) < (f | 0)) {
                                j = j + 1 | 0;
                                k = l
                            } else { break }
                        }
                        k = h + 1 | 0;
                        if ((k | 0) < (f | 0)) {
                            g = g + f | 0;
                            h = k
                        } else { break }
                    }
                    h = c[28640 + (b << 2) >> 2] | 0;
                    g = 0;
                    e = 0;
                    while (1) {
                        k = e & 255;
                        j = g;
                        i = 0;
                        while (1) {
                            a[h + (j << 1) | 0] = k;
                            a[h + (j << 1) + 1 | 0] = i;
                            l = i + 1 | 0;
                            if ((l | 0) < (f | 0)) {
                                j = j + 1 | 0;
                                i = l
                            } else { break }
                        }
                        i = e + 1 | 0;
                        if ((i | 0) < (f | 0)) {
                            g = g + f | 0;
                            e = i
                        } else { break }
                    }
                }
                e = c[28704 + (b << 2) >> 2] | 0;
                g = f << b;
                h = 0;
                i = 0;
                j = 0;
                while (1) {
                    if ((j | 0) < (g | 0)) {
                        k = h;
                        l = i;
                        while (1) {
                            if ((k | 0) > -1) {
                                m = l;
                                n = k;
                                break
                            } else {
                                k = l;
                                l = 0
                            }
                        }
                    } else {
                        if ((h | 0) > -1) {
                            m = i;
                            n = h
                        } else { break }
                    }
                    if ((m | 0) < (f | 0) & (n | 0) < (f | 0)) {
                        a[e + (j << 1) | 0] = m;
                        a[e + (j << 1) + 1 | 0] = n;
                        o = j + 1 | 0
                    } else { o = j }
                    h = n - 1 | 0;
                    i = m + 1 | 0;
                    j = o
                }
                j = b + 1 | 0;
                if ((j | 0) < 6) { b = j } else { p = 2; break }
            }
            do {
                b = 1 << p;
                o = (b | 0) > 0;
                m = p - 2 | 0;
                n = (1 << m << m) - 1 | 0;
                j = 28704 + (m << 2) | 0;
                i = 28672 + (m << 2) | 0;
                h = 28640 + (m << 2) | 0;
                m = 0;
                do {
                    if (o) {
                        e = 27544 + (m * 24 | 0) + (p << 2) | 0;
                        f = (m | 0) == 0;
                        g = 0;
                        do {
                            l = g << p;
                            k = c[e >> 2] | 0;
                            if (f) {
                                q = 0;
                                do {
                                    r = q + l | 0;
                                    s = c[j >> 2] | 0;
                                    t = 16;
                                    u = n;
                                    while (1) {
                                        v = (t | 0) == 0;
                                        w = (v << 31 >> 31) + u | 0;
                                        x = v ? 15 : t - 1 | 0;
                                        if ((((d[s + (w << 1) | 0] | 0) << 2) + (d[43504 + (x << 1) | 0] | 0) | 0) != (q | 0)) {
                                            t = x;
                                            u = w;
                                            continue
                                        }
                                        if ((((d[s + (w << 1) + 1 | 0] | 0) << 2) + (d[43505 + (x << 1) | 0] | 0) | 0) == (g | 0)) { break } else {
                                            t = x;
                                            u = w
                                        }
                                    }
                                    a[k + (r << 1) | 0] = w;
                                    a[k + (r << 1) + 1 | 0] = x;
                                    q = q + 1 | 0;
                                } while ((q | 0) < (b | 0))
                            } else {
                                q = 0;
                                do {
                                    u = q + l | 0;
                                    if ((m | 0) == 2) {
                                        y = 38048;
                                        z = c[h >> 2] | 0
                                    } else if ((m | 0) == 1) {
                                        y = 40776;
                                        z = c[i >> 2] | 0
                                    } else {
                                        y = 0;
                                        z = 0
                                    }
                                    t = 16;
                                    s = n;
                                    while (1) {
                                        v = (t | 0) == 0;
                                        A = (v << 31 >> 31) + s | 0;
                                        B = v ? 15 : t - 1 | 0;
                                        if ((((d[z + (A << 1) | 0] | 0) << 2) + (d[y + (B << 1) | 0] | 0) | 0) != (q | 0)) {
                                            t = B;
                                            s = A;
                                            continue
                                        }
                                        if ((((d[z + (A << 1) + 1 | 0] | 0) << 2) + (d[y + (B << 1) + 1 | 0] | 0) | 0) == (g | 0)) { break } else {
                                            t = B;
                                            s = A
                                        }
                                    }
                                    a[k + (u << 1) | 0] = A;
                                    a[k + (u << 1) + 1 | 0] = B;
                                    q = q + 1 | 0;
                                } while ((q | 0) < (b | 0))
                            }
                            g = g + 1 | 0;
                        } while ((g | 0) < (b | 0))
                    }
                    m = m + 1 | 0;
                } while ((m | 0) < 3);
                p = p + 1 | 0;
            } while ((p | 0) < 6);
            return
        }

        function Fj(d, e, f, g) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0;
            f = 0;
            while (1) {
                h = nd(d, 8) | 0;
                i = h + f | 0;
                if ((h | 0) == 255) { f = i } else { j = 0; break }
            }
            do {
                f = nd(d, 8) | 0;
                j = f + j | 0;
            } while ((f | 0) == 255);
            c[e >> 2] = i;
            c[e + 4 >> 2] = j;
            if ((i | 0) != 132) { k = 0; return k | 0 }
            i = nd(d, 8) | 0;
            j = e + 8 | 0;
            c[j >> 2] = i;
            if ((g | 0) == 0) { k = 1025; return k | 0 }
            f = (c[g + 476 >> 2] | 0) == 0 ? 1 : 3;
            g = 0;
            h = i;
            while (1) {
                if ((h | 0) == 2) {
                    i = nd(d, 32) | 0;
                    c[e + 68 + (g << 2) >> 2] = i
                } else if ((h | 0) == 1) {
                    i = (nd(d, 16) | 0) & 65535;
                    b[e + 60 + (g << 1) >> 1] = i
                } else if ((h | 0) == 0) {
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 1 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 2 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 3 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 4 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 5 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 6 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 7 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 8 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 9 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 10 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 11 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 12 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 13 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 14 | 0] = i;
                    i = (nd(d, 8) | 0) & 255;
                    a[e + 12 + (g << 4) + 15 | 0] = i
                }
                i = g + 1 | 0;
                if ((i | 0) >= (f | 0)) { k = 0; break }
                g = i;
                h = c[j >> 2] | 0
            }
            return k | 0
        }

        function Gj(a, b) {
            a = a | 0;
            b = b | 0;
            return
        }

        function Hj(f, g) {
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0;
            h = i;
            i = i + 168 | 0;
            j = h | 0;
            k = h + 152 | 0;
            if ((c[f >> 2] | 0) != 132) {
                l = 0;
                i = h;
                return l | 0
            }
            if ((a[(c[g + 10332 >> 2] | 0) + 512 | 0] | 0) == 0) {
                l = 0;
                i = h;
                return l | 0
            }
            m = k | 0;
            if ((a[g + 100 | 0] | 0) == 0) {
                l = 0;
                i = h;
                return l | 0
            }
            n = (c[g + 1240 >> 2] | 0) == 0 ? 1 : 3;
            o = g + 24 | 0;
            p = g + 32 | 0;
            r = g + 28 | 0;
            s = g + 36 | 0;
            t = g + 40 | 0;
            u = g + 44 | 0;
            v = f + 8 | 0;
            w = g + 5760 | 0;
            x = g + 5768 | 0;
            y = 0;
            a: while (1) {
                z = (y | 0) == 0;
                A = c[(z ? o : p) >> 2] | 0;
                B = c[(z ? r : s) >> 2] | 0;
                C = c[g + 4 + (y << 2) >> 2] | 0;
                D = c[(z ? t : u) >> 2] | 0;
                E = c[v >> 2] | 0;
                if ((E | 0) == 0) {
                    F = c[(z ? w : x) >> 2] | 0;
                    qi(j);
                    b: do {
                        if ((B | 0) > 0) {
                            G = A << 1;
                            H = (A | 0) < 0 ? -1 : G;
                            I = C;
                            J = (A | 0) > 0;
                            if ((F | 0) > 8) {
                                K = 0;
                                L = 0
                            } else {
                                if (J) {
                                    M = 0;
                                    while (1) {
                                        ri(j, C + (ga(M, D) | 0) | 0, A);
                                        N = M + 1 | 0;
                                        if ((N | 0) < (B | 0)) { M = N } else { O = 0; break b }
                                    }
                                } else {
                                    M = 0;
                                    while (1) {
                                        ri(j, C + (ga(M, D) | 0) | 0, A);
                                        N = M + 1 | 0;
                                        if ((N | 0) < (B | 0)) { M = N } else { O = 0; break b }
                                    }
                                }
                            }
                            while (1) {
                                if ((K | 0) == 0) { P = Ou(H) | 0 } else { P = K }
                                if (J) {
                                    M = ga(L, D) | 0;
                                    N = 0;
                                    do {
                                        Q = I + (N + M << 1) | 0;
                                        R = N << 1;
                                        a[P + R | 0] = b[Q >> 1];
                                        a[P + (R | 1) | 0] = (e[Q >> 1] | 0) >>> 8;
                                        N = N + 1 | 0;
                                    } while ((N | 0) < (A | 0))
                                }
                                ri(j, P, G);
                                N = L + 1 | 0;
                                if ((N | 0) < (B | 0)) {
                                    K = P;
                                    L = N
                                } else { O = P; break }
                            }
                        } else { O = 0 }
                    } while (0);
                    ti(m, j);
                    if ((O | 0) == 0) { S = 0 } else {
                        Qu(O);
                        S = 0
                    }
                    while (1) { F = S + 1 | 0; if ((a[k + S | 0] | 0) != (a[f + 12 + (y << 4) + S | 0] | 0)) { T = 33; break a } if ((F | 0) < 16) { S = F } else { break } }
                } else if ((E | 0) == 2) {
                    F = (B | 0) > 0;
                    do {
                        if ((c[(z ? w : x) >> 2] | 0) < 9) {
                            if (!F) { U = 0; break }
                            G = (A | 0) > 0;
                            I = 0;
                            J = 0;
                            while (1) {
                                if (G) {
                                    H = I >>> 8 ^ I;
                                    N = ga(I, D) | 0;
                                    M = 0;
                                    Q = J;
                                    while (1) {
                                        R = ((H ^ M ^ M >>> 8) & 255 ^ d[C + (M + N) | 0]) + Q | 0;
                                        V = M + 1 | 0;
                                        if ((V | 0) < (A | 0)) {
                                            M = V;
                                            Q = R
                                        } else { W = R; break }
                                    }
                                } else { W = J }
                                Q = I + 1 | 0;
                                if ((Q | 0) < (B | 0)) {
                                    I = Q;
                                    J = W
                                } else { U = W; break }
                            }
                        } else {
                            if (!F) { U = 0; break }
                            J = (A | 0) > 0;
                            I = 0;
                            G = 0;
                            while (1) {
                                if (J) {
                                    Q = I >>> 8 ^ I;
                                    M = ga(I, D) | 0;
                                    N = 0;
                                    H = G;
                                    while (1) {
                                        R = (Q ^ N ^ N >>> 8) & 255;
                                        V = R + H + (R ^ d[C + (N + M) | 0]) | 0;
                                        R = N + 1 | 0;
                                        if ((R | 0) < (A | 0)) {
                                            N = R;
                                            H = V
                                        } else { X = V; break }
                                    }
                                } else { X = G }
                                H = I + 1 | 0;
                                if ((H | 0) < (B | 0)) {
                                    I = H;
                                    G = X
                                } else { U = X; break }
                            }
                        }
                    } while (0);
                    Y = c[f + 68 + (y << 2) >> 2] | 0;
                    if ((U | 0) != (Y | 0)) { T = 64; break }
                } else if ((E | 0) == 1) {
                    do {
                        if ((B | 0) > 0) {
                            F = (c[(z ? w : x) >> 2] | 0) > 8;
                            G = A << 1;
                            I = (A | 0) < 0 ? -1 : G;
                            J = C;
                            H = (A | 0) > 0;
                            N = 0;
                            M = 0;
                            Q = 7439;
                            while (1) {
                                do {
                                    if (F) {
                                        if ((N | 0) == 0) { Z = Ou(I) | 0 } else { Z = N }
                                        if (!H) {
                                            _ = Z;
                                            $ = G;
                                            aa = Z;
                                            break
                                        }
                                        V = ga(M, D) | 0;
                                        R = 0;
                                        while (1) {
                                            ba = J + (R + V << 1) | 0;
                                            ca = R << 1;
                                            a[Z + ca | 0] = b[ba >> 1];
                                            a[Z + (ca | 1) | 0] = (e[ba >> 1] | 0) >>> 8;
                                            ba = R + 1 | 0;
                                            if ((ba | 0) < (A | 0)) { R = ba } else {
                                                _ = Z;
                                                $ = G;
                                                aa = Z;
                                                break
                                            }
                                        }
                                    } else {
                                        _ = C + (ga(M, D) | 0) | 0;
                                        $ = A;
                                        aa = N
                                    }
                                } while (0);
                                if (($ | 0) > 0) {
                                    R = 0;
                                    V = Q;
                                    while (1) {
                                        ba = d[_ + R | 0] ^ (V & 65535) >>> 8;
                                        ca = (ba & 65535) >>> 4 ^ ba;
                                        ba = (ca | V << 8) ^ ca << 5 ^ ca << 12;
                                        ca = R + 1 | 0;
                                        if ((ca | 0) < ($ | 0)) {
                                            R = ca;
                                            V = ba
                                        } else { da = ba; break }
                                    }
                                } else { da = Q }
                                V = M + 1 | 0;
                                if ((V | 0) < (B | 0)) {
                                    N = aa;
                                    M = V;
                                    Q = da
                                } else { break }
                            }
                            Q = da & 65535;
                            if ((aa | 0) == 0) { ea = Q; break }
                            Qu(aa);
                            ea = Q
                        } else { ea = 7439 }
                    } while (0);
                    fa = e[f + 60 + (y << 1) >> 1] | 0;
                    if ((ea | 0) != (fa | 0)) { T = 49; break }
                }
                B = y + 1 | 0;
                if ((B | 0) < (n | 0)) { y = B } else {
                    l = 0;
                    T = 66;
                    break
                }
            }
            if ((T | 0) == 33) {
                ic(c[q >> 2] | 0, 12208, (ha = i, i = i + 8 | 0, c[ha >> 2] = c[g + 92 >> 2], ha) | 0) | 0;
                i = ha;
                l = 5;
                i = h;
                return l | 0
            } else if ((T | 0) == 49) {
                y = c[g + 92 >> 2] | 0;
                ic(c[q >> 2] | 0, 11840, (ha = i, i = i + 24 | 0, c[ha >> 2] = fa, c[ha + 8 >> 2] = ea, c[ha + 16 >> 2] = y, ha) | 0) | 0;
                i = ha;
                l = 5;
                i = h;
                return l | 0
            } else if ((T | 0) == 64) {
                y = c[g + 92 >> 2] | 0;
                ic(c[q >> 2] | 0, 11840, (ha = i, i = i + 24 | 0, c[ha >> 2] = Y, c[ha + 8 >> 2] = U, c[ha + 16 >> 2] = y, ha) | 0) | 0;
                i = ha;
                l = 5;
                i = h;
                return l | 0
            } else if ((T | 0) == 66) { i = h; return l | 0 }
            return 0
        }

        function Ij(e, f, g) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0;
            h = a[g + 93784 + ((c[f + 8 >> 2] | 0) * 4400 | 0) + 2 | 0] | 0;
            i = qd(e) | 0;
            j = f + 380 | 0;
            a[j] = i;
            if (i >>> 0 > 7 >>> 0) { k = 0; return k | 0 }
            i = g + 11096 + (h * 5168 | 0) + 476 | 0;
            do {
                if ((c[i >> 2] | 0) == 0) { l = f + 381 | 0 } else {
                    m = rd(e) | 0;
                    n = (d[j] | 0) + m | 0;
                    if (n >>> 0 > 7 >>> 0) { k = 0; return k | 0 } else {
                        m = f + 381 | 0;
                        a[m] = n;
                        l = m;
                        break
                    }
                }
            } while (0);
            m = f + 328 | 0;
            n = g + 11096 + (h * 5168 | 0) + 5164 | 0;
            o = g + 11096 + (h * 5168 | 0) + 5160 | 0;
            h = f + 20 | 0;
            g = f + 332 | 0;
            p = 0;
            a: while (1) {
                if ((p | 0) == 0) {
                    q = m;
                    r = 9
                } else if ((p | 0) == 1) {
                    if ((c[h >> 2] | 0) == 0) {
                        q = g;
                        r = 9
                    } else {
                        k = 1;
                        r = 33;
                        break
                    }
                }
                do {
                    if ((r | 0) == 9) {
                        r = 0;
                        s = c[q >> 2] | 0;
                        t = s - 1 | 0;
                        u = (s | 0) < 1;
                        if (!u) {
                            s = 0;
                            while (1) {
                                v = (nd(e, 1) | 0) & 255;
                                a[f + 382 + (p << 4) + s | 0] = v;
                                if ((s | 0) < (t | 0)) { s = s + 1 | 0 } else { break }
                            }
                        }
                        if ((c[i >> 2] | 0) != 0) {
                            if (u) { break } else { w = 0 }
                            while (1) {
                                s = (nd(e, 1) | 0) & 255;
                                a[f + 414 + (p << 4) + w | 0] = s;
                                if ((w | 0) < (t | 0)) { w = w + 1 | 0 } else { break }
                            }
                        }
                        if (u) { break } else { x = 0 }
                        while (1) {
                            if ((a[f + 382 + (p << 4) + x | 0] | 0) == 0) {
                                b[f + 446 + (p << 5) + (x << 1) >> 1] = 1 << d[j];
                                a[f + 510 + (p << 4) + x | 0] = 0
                            } else {
                                s = rd(e) | 0;
                                if ((s + 128 | 0) >>> 0 > 255 >>> 0) {
                                    k = 0;
                                    r = 33;
                                    break a
                                }
                                b[f + 446 + (p << 5) + (x << 1) >> 1] = (1 << d[j]) + s;
                                s = rd(e) | 0;
                                v = c[o >> 2] | 0;
                                if ((s | 0) < (-v | 0) | (s | 0) > (v - 1 | 0)) {
                                    k = 0;
                                    r = 33;
                                    break a
                                }
                                a[f + 510 + (p << 4) + x | 0] = s
                            }
                            if ((a[f + 414 + (p << 4) + x | 0] | 0) == 0) {
                                s = 1 << d[l] & 65535;
                                b[f + 542 + (p << 6) + (x << 2) >> 1] = s;
                                a[f + 670 + (p << 5) + (x << 1) | 0] = 0;
                                b[f + 542 + (p << 6) + (x << 2) + 2 >> 1] = s;
                                a[f + 670 + (p << 5) + (x << 1) + 1 | 0] = 0
                            } else {
                                s = 0;
                                do {
                                    v = rd(e) | 0;
                                    if ((v + 128 | 0) >>> 0 > 255 >>> 0) {
                                        k = 0;
                                        r = 33;
                                        break a
                                    }
                                    y = f + 542 + (p << 6) + (x << 2) + (s << 1) | 0;
                                    b[y >> 1] = (1 << d[l]) + v;
                                    v = rd(e) | 0;
                                    z = c[n >> 2] | 0;
                                    if ((v | 0) < (z * -4 | 0 | 0)) {
                                        k = 0;
                                        r = 33;
                                        break a
                                    }
                                    if ((v | 0) > ((z << 2) - 1 | 0)) {
                                        k = 0;
                                        r = 33;
                                        break a
                                    }
                                    A = ga(b[y >> 1] | 0, z) | 0;
                                    y = z + v - (A >> d[l]) | 0;
                                    A = -z | 0;
                                    do { if ((y | 0) < (A | 0)) { B = A & 255 } else { v = z - 1 | 0; if ((y | 0) > (v | 0)) { B = v & 255; break } else { B = y & 255; break } } } while (0);
                                    a[f + 670 + (p << 5) + (x << 1) + s | 0] = B;
                                    s = s + 1 | 0;
                                } while ((s | 0) < 2)
                            }
                            if ((x | 0) < (t | 0)) { x = x + 1 | 0 } else { break }
                        }
                    }
                } while (0);
                t = p + 1 | 0;
                if ((t | 0) < 2) { p = t } else {
                    k = 1;
                    r = 33;
                    break
                }
            }
            if ((r | 0) == 33) { return k | 0 }
            return 0
        }

        function Jj(d) {
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            c[d >> 2] = 0;
            a[d + 4 | 0] = 0;
            a[d + 5 | 0] = 0;
            c[d + 8 >> 2] = 0;
            a[d + 12 | 0] = 0;
            c[d + 28 >> 2] = 0;
            a[d + 32 | 0] = 0;
            dv(d + 16 | 0, 0, 10) | 0;
            rj(d + 34 | 0);
            c[d + 136 >> 2] = 0;
            c[d + 140 >> 2] = 0;
            c[d + 144 >> 2] = 0;
            e = 0;
            do {
                a[d + 148 + e | 0] = 0;
                c[d + 164 + (e << 2) >> 2] = 0;
                a[d + 228 + e | 0] = 0;
                a[d + 244 + e | 0] = 0;
                c[d + 260 + (e << 2) >> 2] = 0;
                e = e + 1 | 0;
            } while ((e | 0) < 16);
            c[d + 376 >> 2] = 0;
            a[d + 380 | 0] = 0;
            a[d + 381 | 0] = 0;
            dv(d + 324 | 0, 0, 49) | 0;
            e = 0;
            while (1) {
                a[d + 382 + e | 0] = 0;
                a[d + 414 + e | 0] = 0;
                b[d + 446 + (e << 1) >> 1] = 0;
                a[d + 510 + e | 0] = 0;
                b[d + 542 + (e << 2) + 2 >> 1] = 0;
                b[d + 542 + (e << 2) >> 1] = 0;
                a[d + 670 + (e << 1) + 1 | 0] = 0;
                a[d + 670 + (e << 1) | 0] = 0;
                f = e + 1 | 0;
                if ((f | 0) < 16) { e = f } else { g = 0; break }
            }
            do {
                a[d + 398 + g | 0] = 0;
                a[d + 430 + g | 0] = 0;
                b[d + 478 + (g << 1) >> 1] = 0;
                a[d + 526 + g | 0] = 0;
                b[d + 606 + (g << 2) + 2 >> 1] = 0;
                b[d + 606 + (g << 2) >> 1] = 0;
                a[d + 702 + (g << 1) + 1 | 0] = 0;
                a[d + 702 + (g << 1) | 0] = 0;
                g = g + 1 | 0;
            } while ((g | 0) < 16);
            c[d + 756 >> 2] = 0;
            c[d + 760 >> 2] = 0;
            a[d + 764 | 0] = 0;
            c[d + 768 >> 2] = 0;
            c[d + 772 >> 2] = 0;
            dv(d + 736 | 0, 0, 19) | 0;
            g = c[d + 776 >> 2] | 0;
            e = d + 780 | 0;
            f = c[e >> 2] | 0;
            if ((f | 0) != (g | 0)) { c[e >> 2] = f + (~((f - 4 + (-g | 0) | 0) >>> 2) << 2) }
            dv(d + 788 | 0, 0, 24) | 0;
            rj(d + 812 | 0);
            c[d + 912 >> 2] = 0;
            g = 0;
            while (1) {
                c[d + 916 + (g << 2) >> 2] = 0;
                c[d + 1044 + (g << 2) >> 2] = 0;
                c[d + 1172 + (g << 2) >> 2] = 0;
                a[d + 1300 + g | 0] = 0;
                f = g + 1 | 0;
                if ((f | 0) < 16) { g = f } else { h = 0; break }
            }
            do {
                c[d + 980 + (h << 2) >> 2] = 0;
                c[d + 1108 + (h << 2) >> 2] = 0;
                c[d + 1236 + (h << 2) >> 2] = 0;
                a[d + 1316 + h | 0] = 0;
                h = h + 1 | 0;
            } while ((h | 0) < 16);
            h = c[d + 1344 >> 2] | 0;
            g = d + 1348 | 0;
            f = c[g >> 2] | 0;
            if ((f | 0) == (h | 0)) {
                i = d + 1340 | 0;
                a[i] = 0;
                return
            }
            c[g >> 2] = f + (~((f - 4 + (-h | 0) | 0) >>> 2) << 2);
            i = d + 1340 | 0;
            a[i] = 0;
            return
        }

        function Kj(b, e, f, g) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0;
            a[g] = 0;
            Jj(b);
            h = b + 12 | 0;
            a[h] = 0;
            i = (nd(e, 1) | 0) & 255;
            j = b + 4 | 0;
            a[j] = i;
            if ((a[f + 377210 | 0] | 0) != 0) {
                i = (nd(e, 1) | 0) & 255;
                a[b + 5 | 0] = i
            }
            i = qd(e) | 0;
            c[b + 8 >> 2] = i;
            if ((i | 0) > 64 | (i | 0) == -99999) {
                Ue(f + 4 | 0, 1009, 0);
                k = 0;
                return k | 0
            }
            if ((a[f + 93784 + (i * 4400 | 0) | 0] | 0) == 0) {
                Ue(f + 4 | 0, 1009, 0);
                k = 0;
                return k | 0
            }
            l = a[f + 93784 + (i * 4400 | 0) + 2 | 0] | 0;
            m = f + 11096 + (l * 5168 | 0) | 0;
            if ((a[m | 0] | 0) == 0) {
                Ue(f + 4 | 0, 1010, 0);
                a[g] = 0;
                k = 0;
                return k | 0
            }
            if ((a[j] | 0) == 0) {
                if ((a[f + 93784 + (i * 4400 | 0) + 3 | 0] | 0) == 0) { n = 0 } else { n = (nd(e, 1) | 0) & 255 }
                a[h] = n;
                n = c[f + 11096 + (l * 5168 | 0) + 5072 >> 2] | 0;
                o = 0;
                while (1) { if ((1 << o | 0) < (n | 0)) { o = o + 1 | 0 } else { break } }
                n = nd(e, o) | 0;
                if ((a[h] | 0) == 0) { p = 0 } else {
                    if ((n | 0) == 0) {
                        a[g] = 0;
                        Ue(f + 4 | 0, 1021, 0);
                        k = 0;
                        return k | 0
                    }
                    o = c[f + 376224 >> 2] | 0;
                    if ((o | 0) == 0) { k = 16; return k | 0 }
                    cv(b | 0, o | 0, 776) | 0;
                    q = (o | 0) == (b | 0);
                    if (!q) { tf(b + 776 | 0, c[o + 776 >> 2] | 0, c[o + 780 >> 2] | 0) }
                    cv(b + 788 | 0, o + 788 | 0, 544) | 0;
                    Jd(b + 1332 | 0, o + 1332 | 0) | 0;
                    a[b + 1340 | 0] = a[o + 1340 | 0] | 0;
                    if (!q) { tf(b + 1344 | 0, c[o + 1344 >> 2] | 0, c[o + 1348 >> 2] | 0) }
                    a[j] = 0;
                    a[h] = 1;
                    p = 1
                }
                c[b + 16 >> 2] = n;
                if ((n | 0) >= 0) {
                    r = p;
                    s = n;
                    t = 25
                }
            } else {
                a[h] = 0;
                c[b + 16 >> 2] = 0;
                r = 0;
                s = 0;
                t = 25
            }
            do {
                if ((t | 0) == 25) {
                    h = b + 16 | 0;
                    if ((s | 0) >= (c[f + 11096 + (l * 5168 | 0) + 5072 >> 2] | 0)) { break }
                    a: do {
                        if (r << 24 >> 24 == 0) {
                            n = f + 93784 + (i * 4400 | 0) + 4132 | 0;
                            if ((a[n] | 0) > 0) {
                                p = 0;
                                do {
                                    od(e, 1);
                                    p = p + 1 | 0;
                                } while ((p | 0) < (a[n] | 0))
                            }
                            n = qd(e) | 0;
                            p = b + 20 | 0;
                            c[p >> 2] = n;
                            if ((n | 0) > 2 | (n | 0) == -99999) {
                                Ue(f + 4 | 0, 1007, 0);
                                a[g] = 0;
                                k = 0;
                                return k | 0
                            }
                            if ((a[f + 93784 + (i * 4400 | 0) + 31 | 0] | 0) == 0) { a[b + 24 | 0] = 1 } else {
                                n = (nd(e, 1) | 0) & 255;
                                a[b + 24 | 0] = n
                            }
                            if ((a[f + 11096 + (l * 5168 | 0) + 480 | 0] | 0) == 1) {
                                n = (nd(e, 2) | 0) & 255;
                                a[b + 25 | 0] = n
                            }
                            n = b + 28 | 0;
                            c[n >> 2] = 0;
                            j = b + 32 | 0;
                            a[j] = 0;
                            do {
                                if (((a[f + 377208 | 0] | 0) - 19 & 255) >>> 0 < 2 >>> 0) {
                                    c[n >> 2] = 0;
                                    c[b + 140 >> 2] = 0;
                                    c[b + 144 >> 2] = 0;
                                    u = 0
                                } else {
                                    o = f + 11096 + (l * 5168 | 0) + 520 | 0;
                                    q = nd(e, c[o >> 2] | 0) | 0;
                                    c[n >> 2] = q;
                                    q = (nd(e, 1) | 0) & 255;
                                    a[j] = q;
                                    do {
                                        if (q << 24 >> 24 == 0) {
                                            v = b + 34 | 0;
                                            w = f + 11096 + (l * 5168 | 0) + 4724 | 0;
                                            x = f + 11096 + (l * 5168 | 0) + 4720 | 0;
                                            sj((f | 0) == 0 ? 0 : f + 4 | 0, m, e, v, ((c[w >> 2] | 0) - (c[x >> 2] | 0) | 0) / 100 | 0, f + 11096 + (l * 5168 | 0) + 4720 | 0, 1) | 0;
                                            c[b + 808 >> 2] = ((c[w >> 2] | 0) - (c[x >> 2] | 0) | 0) / 100 | 0;
                                            cv(b + 812 | 0, v | 0, 100) | 0
                                        } else {
                                            v = f + 11096 + (l * 5168 | 0) + 4724 | 0;
                                            x = c[v >> 2] | 0;
                                            w = f + 11096 + (l * 5168 | 0) + 4720 | 0;
                                            y = c[w >> 2] | 0;
                                            z = (x - y | 0) / 100 | 0;
                                            A = 0;
                                            while (1) { if ((1 << A | 0) < (z | 0)) { A = A + 1 | 0 } else { break } }
                                            if ((A | 0) > 0) {
                                                z = nd(e, A) | 0;
                                                c[b + 136 >> 2] = z;
                                                B = z;
                                                C = c[v >> 2] | 0;
                                                D = c[w >> 2] | 0
                                            } else {
                                                c[b + 136 >> 2] = 0;
                                                B = 0;
                                                C = x;
                                                D = y
                                            }
                                            if ((B | 0) < ((C - D | 0) / 100 | 0 | 0)) {
                                                c[b + 808 >> 2] = B;
                                                cv(b + 812 | 0, D + (B * 100 | 0) | 0, 100) | 0;
                                                break
                                            }
                                            Ue(f + 4 | 0, 1015, 0);
                                            k = 8;
                                            return k | 0
                                        }
                                    } while (0);
                                    b: do {
                                        if ((a[f + 11096 + (l * 5168 | 0) + 4732 | 0] | 0) == 0) {
                                            c[b + 140 >> 2] = 0;
                                            c[b + 144 >> 2] = 0;
                                            E = 0
                                        } else {
                                            q = f + 11096 + (l * 5168 | 0) + 4736 | 0;
                                            do {
                                                if ((c[q >> 2] | 0) > 0) {
                                                    z = qd(e) | 0;
                                                    c[b + 140 >> 2] = z;
                                                    if ((z | 0) == -99999) { k = 8 } else { break }
                                                    return k | 0
                                                } else { c[b + 140 >> 2] = 0 }
                                            } while (0);
                                            y = qd(e) | 0;
                                            x = b + 144 | 0;
                                            c[x >> 2] = y;
                                            if ((y | 0) == -99999) { k = 8; return k | 0 }
                                            w = b + 140 | 0;
                                            v = c[w >> 2] | 0;
                                            A = v + y | 0;
                                            if ((A + (d[b + 908 | 0] | 0) + (d[b + 909 | 0] | 0) | 0) > (c[f + 11096 + (l * 5168 | 0) + 528 + ((a[f + 11096 + (l * 5168 | 0) + 2 | 0] | 0) - 1 << 2) >> 2] | 0)) {
                                                Ue(f + 4 | 0, 1018, 0);
                                                a[g] = 0;
                                                k = 0;
                                                return k | 0
                                            }
                                            if ((A | 0) > 0) {
                                                F = 0;
                                                G = 0;
                                                H = v
                                            } else { E = 0; break }
                                            while (1) {
                                                if ((F | 0) < (H | 0)) {
                                                    v = c[q >> 2] | 0;
                                                    A = 0;
                                                    while (1) { if ((1 << A | 0) < (v | 0)) { A = A + 1 | 0 } else { break } }
                                                    v = nd(e, A) | 0;
                                                    y = b + 148 + F | 0;
                                                    a[y] = v;
                                                    z = v & 255;
                                                    if ((z | 0) >= (c[q >> 2] | 0)) { break }
                                                    c[f + 376228 + (F << 2) >> 2] = c[f + 11096 + (l * 5168 | 0) + 4740 + (z << 2) >> 2];
                                                    z = a[(d[y] | 0) + (f + 11096 + (l * 5168 | 0) + 4868) | 0] | 0;
                                                    c[f + 376292 + (F << 2) >> 2] = z;
                                                    I = z
                                                } else {
                                                    z = nd(e, c[o >> 2] | 0) | 0;
                                                    y = b + 164 + (F << 2) | 0;
                                                    c[y >> 2] = z;
                                                    z = (nd(e, 1) | 0) & 255;
                                                    v = b + 228 + F | 0;
                                                    a[v] = z;
                                                    c[f + 376228 + (F << 2) >> 2] = c[y >> 2];
                                                    y = a[v] | 0;
                                                    c[f + 376292 + (F << 2) >> 2] = y;
                                                    I = y
                                                }
                                                y = ((I | 0) != 0) + G | 0;
                                                v = (nd(e, 1) | 0) & 255;
                                                a[b + 244 + F | 0] = v;
                                                if (v << 24 >> 24 == 0) {
                                                    c[b + 260 + (F << 2) >> 2] = 0;
                                                    J = 0
                                                } else {
                                                    v = qd(e) | 0;
                                                    c[b + 260 + (F << 2) >> 2] = v;
                                                    if ((v | 0) == -99999) {
                                                        k = 8;
                                                        t = 194;
                                                        break
                                                    } else { J = v }
                                                }
                                                do {
                                                    if ((F | 0) == 0) { t = 68 } else {
                                                        if ((F | 0) == (c[w >> 2] | 0)) { t = 68; break }
                                                        c[f + 376356 + (F << 2) >> 2] = (c[f + 376356 + (F - 1 << 2) >> 2] | 0) + J
                                                    }
                                                } while (0);
                                                if ((t | 0) == 68) {
                                                    t = 0;
                                                    c[f + 376356 + (F << 2) >> 2] = J
                                                }
                                                A = F + 1 | 0;
                                                v = c[w >> 2] | 0;
                                                if ((A | 0) < ((c[x >> 2] | 0) + v | 0)) {
                                                    F = A;
                                                    G = y;
                                                    H = v
                                                } else { E = y; break b }
                                            }
                                            if ((t | 0) == 194) { return k | 0 }
                                            Ue(f + 4 | 0, 1023, 0);
                                            a[g] = 0;
                                            k = 0;
                                            return k | 0
                                        }
                                    } while (0);
                                    if ((a[f + 11096 + (l * 5168 | 0) + 4900 | 0] | 0) == 0) {
                                        a[b + 324 | 0] = 0;
                                        u = E;
                                        break
                                    } else {
                                        o = (nd(e, 1) | 0) & 255;
                                        a[b + 324 | 0] = o;
                                        u = E;
                                        break
                                    }
                                }
                            } while (0);
                            do {
                                if ((a[f + 11096 + (l * 5168 | 0) + 4703 | 0] | 0) == 0) {
                                    a[b + 325 | 0] = 0;
                                    a[b + 326 | 0] = 0
                                } else {
                                    j = (nd(e, 1) | 0) & 255;
                                    a[b + 325 | 0] = j;
                                    if ((c[f + 11096 + (l * 5168 | 0) + 5012 >> 2] | 0) == 0) { a[b + 326 | 0] = 0; break } else {
                                        j = (nd(e, 1) | 0) & 255;
                                        a[b + 326 | 0] = j;
                                        break
                                    }
                                }
                            } while (0);
                            j = b + 328 | 0;
                            c[j >> 2] = 0;
                            n = b + 332 | 0;
                            c[n >> 2] = 0;
                            do {
                                if ((c[p >> 2] | 0) >>> 0 < 2 >>> 0) {
                                    o = (nd(e, 1) | 0) & 255;
                                    a[b + 327 | 0] = o;
                                    do {
                                        if (o << 24 >> 24 == 0) {
                                            x = a[f + 93784 + (i * 4400 | 0) + 6 | 0] | 0;
                                            c[j >> 2] = x;
                                            K = a[f + 93784 + (i * 4400 | 0) + 7 | 0] | 0;
                                            L = x;
                                            t = 90
                                        } else {
                                            x = qd(e) | 0;
                                            c[j >> 2] = x;
                                            if ((x | 0) == -99999) {
                                                Ue(f + 4 | 0, 1007, 0);
                                                k = 8;
                                                return k | 0
                                            }
                                            w = x + 1 | 0;
                                            c[j >> 2] = w;
                                            if ((c[p >> 2] | 0) != 0) { M = w; break }
                                            w = qd(e) | 0;
                                            c[n >> 2] = w;
                                            if (!((w | 0) == -99999)) {
                                                K = w + 1 | 0;
                                                L = c[j >> 2] | 0;
                                                t = 90;
                                                break
                                            }
                                            Ue(f + 4 | 0, 1007, 0);
                                            k = 8;
                                            return k | 0
                                        }
                                    } while (0);
                                    if ((t | 0) == 90) {
                                        c[n >> 2] = K;
                                        M = L
                                    }
                                    if ((M | 0) > 16) { k = 8; return k | 0 }
                                    if ((c[n >> 2] | 0) > 16) { k = 8; return k | 0 }
                                    o = (d[b + 911 | 0] | 0) + u | 0;
                                    c[b + 912 >> 2] = o;
                                    do {
                                        if ((a[f + 93784 + (i * 4400 | 0) + 4125 | 0] | 0) != 0 & (o | 0) > 1) {
                                            w = 0;
                                            while (1) { if ((1 << w | 0) < (o | 0)) { w = w + 1 | 0 } else { break } }
                                            x = (nd(e, 1) | 0) & 255;
                                            a[b + 336 | 0] = x;
                                            do {
                                                if (!(x << 24 >> 24 == 0)) {
                                                    if ((c[j >> 2] | 0) > 0) { N = 0 } else { break }
                                                    do {
                                                        q = (nd(e, w) | 0) & 255;
                                                        a[b + 338 + N | 0] = q;
                                                        N = N + 1 | 0;
                                                    } while ((N | 0) < (c[j >> 2] | 0))
                                                }
                                            } while (0);
                                            if ((c[p >> 2] | 0) != 0) { a[b + 337 | 0] = 0; break }
                                            x = (nd(e, 1) | 0) & 255;
                                            a[b + 337 | 0] = x;
                                            if (x << 24 >> 24 == 0) { break }
                                            if ((c[n >> 2] | 0) > 0) { O = 0 } else { break }
                                            do {
                                                x = (nd(e, w) | 0) & 255;
                                                a[b + 354 + O | 0] = x;
                                                O = O + 1 | 0;
                                            } while ((O | 0) < (c[n >> 2] | 0))
                                        } else {
                                            a[b + 336 | 0] = 0;
                                            a[b + 337 | 0] = 0
                                        }
                                    } while (0);
                                    if ((c[p >> 2] | 0) == 0) {
                                        o = (nd(e, 1) | 0) & 255;
                                        a[b + 370 | 0] = o
                                    }
                                    if ((a[f + 93784 + (i * 4400 | 0) + 5 | 0] | 0) == 0) { a[b + 371 | 0] = 0 } else {
                                        o = (nd(e, 1) | 0) & 255;
                                        a[b + 371 | 0] = o
                                    }
                                    do {
                                        if ((a[b + 324 | 0] | 0) != 0) {
                                            do {
                                                if ((c[p >> 2] | 0) == 0) {
                                                    o = (nd(e, 1) | 0) & 255;
                                                    a[b + 372 | 0] = o;
                                                    w = b + 372 | 0;
                                                    if (!(o << 24 >> 24 == 0)) {
                                                        P = o;
                                                        Q = w;
                                                        t = 113;
                                                        break
                                                    }
                                                    if ((c[n >> 2] | 0) > 1) {
                                                        R = w;
                                                        t = 115
                                                    } else {
                                                        S = 0;
                                                        t = 118
                                                    }
                                                } else {
                                                    a[b + 372 | 0] = 1;
                                                    P = 1;
                                                    Q = b + 372 | 0;
                                                    t = 113
                                                }
                                            } while (0);
                                            if ((t | 0) == 113) {
                                                if ((c[j >> 2] | 0) > 1) {
                                                    R = Q;
                                                    t = 115
                                                } else {
                                                    S = P;
                                                    t = 118
                                                }
                                            }
                                            do {
                                                if ((t | 0) == 115) {
                                                    w = qd(e) | 0;
                                                    c[b + 376 >> 2] = w;
                                                    if (!((w | 0) == -99999)) {
                                                        T = w;
                                                        U = a[R] | 0;
                                                        break
                                                    }
                                                    Ue(f + 4 | 0, 1007, 0);
                                                    k = 8;
                                                    return k | 0
                                                } else if ((t | 0) == 118) {
                                                    c[b + 376 >> 2] = 0;
                                                    T = 0;
                                                    U = S
                                                }
                                            } while (0);
                                            if (U << 24 >> 24 == 0) { if ((T | 0) < (c[n >> 2] | 0)) { break } } else { if ((T | 0) < (c[j >> 2] | 0)) { break } }
                                            Ue(f + 4 | 0, 8, 0);
                                            k = 8;
                                            return k | 0
                                        }
                                    } while (0);
                                    if ((a[f + 93784 + (i * 4400 | 0) + 29 | 0] | 0) == 0) { t = 125 } else { if ((c[p >> 2] | 0) == 1) { t = 127 } else { t = 125 } }
                                    do { if ((t | 0) == 125) { if ((a[f + 93784 + (i * 4400 | 0) + 30 | 0] | 0) == 0) { break } if ((c[p >> 2] | 0) == 0) { t = 127 } } } while (0);
                                    do {
                                        if ((t | 0) == 127) {
                                            if (Ij(e, b, f) | 0) { break }
                                            Ue(f + 4 | 0, 8, 0);
                                            k = 8;
                                            return k | 0
                                        }
                                    } while (0);
                                    w = qd(e) | 0;
                                    c[b + 736 >> 2] = w;
                                    if (!((w | 0) == -99999)) { c[b + 804 >> 2] = 5 - w; break }
                                    Ue(f + 4 | 0, 1007, 0);
                                    k = 8;
                                    return k | 0
                                }
                            } while (0);
                            p = rd(e) | 0;
                            c[b + 740 >> 2] = p;
                            if ((p | 0) == -99999) {
                                Ue(f + 4 | 0, 1007, 0);
                                k = 8;
                                return k | 0
                            }
                            do {
                                if ((a[f + 93784 + (i * 4400 | 0) + 28 | 0] | 0) == 0) {
                                    c[b + 744 >> 2] = 0;
                                    c[b + 748 >> 2] = 0
                                } else {
                                    p = rd(e) | 0;
                                    c[b + 744 >> 2] = p;
                                    if ((p | 0) == -99999) {
                                        Ue(f + 4 | 0, 1007, 0);
                                        k = 8;
                                        return k | 0
                                    }
                                    p = rd(e) | 0;
                                    c[b + 748 >> 2] = p;
                                    if (!((p | 0) == -99999)) { break }
                                    Ue(f + 4 | 0, 1007, 0);
                                    k = 8;
                                    return k | 0
                                }
                            } while (0);
                            if ((a[f + 93784 + (i * 4400 | 0) + 4140 | 0] | 0) != 0) {
                                p = (nd(e, 1) | 0) & 255;
                                a[b + 752 | 0] = p
                            }
                            if ((a[f + 93784 + (i * 4400 | 0) + 48 | 0] | 0) == 0) {
                                a[b + 753 | 0] = 0;
                                V = 1
                            } else {
                                p = (nd(e, 1) | 0) & 255;
                                a[b + 753 | 0] = p;
                                V = p << 24 >> 24 == 0
                            }
                            p = b + 756 | 0;
                            c[p >> 2] = c[f + 93784 + (i * 4400 | 0) + 52 >> 2];
                            j = b + 760 | 0;
                            c[j >> 2] = c[f + 93784 + (i * 4400 | 0) + 56 >> 2];
                            do {
                                if (V) { a[b + 754 | 0] = a[f + 93784 + (i * 4400 | 0) + 49 | 0] | 0 } else {
                                    n = (nd(e, 1) | 0) & 255;
                                    a[b + 754 | 0] = n;
                                    if (!(n << 24 >> 24 == 0)) { break }
                                    n = rd(e) | 0;
                                    c[p >> 2] = n;
                                    if ((n | 0) == -99999) {
                                        Ue(f + 4 | 0, 1007, 0);
                                        k = 8;
                                        return k | 0
                                    }
                                    c[p >> 2] = n << 1;
                                    n = rd(e) | 0;
                                    c[j >> 2] = n;
                                    if (!((n | 0) == -99999)) { c[j >> 2] = n << 1; break }
                                    Ue(f + 4 | 0, 1007, 0);
                                    k = 8;
                                    return k | 0
                                }
                            } while (0);
                            j = a[f + 93784 + (i * 4400 | 0) + 46 | 0] | 0;
                            c: do {
                                if (!(j << 24 >> 24 == 0)) {
                                    do { if ((a[b + 325 | 0] | 0) == 0) { if ((a[b + 326 | 0] | 0) != 0) { break } if ((a[b + 754 | 0] | 0) != 0) { break c } } } while (0);
                                    p = (nd(e, 1) | 0) & 255;
                                    a[b + 764 | 0] = p;
                                    break a
                                }
                            } while (0);
                            a[b + 764 | 0] = j
                        }
                    } while (0);
                    p = f + 93784 + (i * 4400 | 0) + 34 | 0;
                    do {
                        if ((a[p] | 0) == 0) {
                            if ((a[f + 93784 + (i * 4400 | 0) + 33 | 0] | 0) != 0) { t = 161; break }
                            c[b + 768 >> 2] = 0
                        } else { t = 161 }
                    } while (0);
                    d: do {
                        if ((t | 0) == 161) {
                            n = qd(e) | 0;
                            w = b + 768 | 0;
                            c[w >> 2] = n;
                            if ((n | 0) == -99999) {
                                Ue(f + 4 | 0, 1007, 0);
                                k = 8;
                                return k | 0
                            }
                            do {
                                if ((a[f + 93784 + (i * 4400 | 0) + 33 | 0] | 0) != 0) {
                                    if ((((c[h >> 2] | 0) / (c[f + 11096 + (l * 5168 | 0) + 5056 >> 2] | 0) | 0) + n | 0) < (c[f + 11096 + (l * 5168 | 0) + 5064 >> 2] | 0)) { break }
                                    Ue(f + 4 | 0, 1007, 0);
                                    k = 8;
                                    return k | 0
                                }
                            } while (0);
                            do {
                                if ((a[p] | 0) != 0) {
                                    if ((n | 0) <= (ga(c[f + 93784 + (i * 4400 | 0) + 40 >> 2] | 0, c[f + 93784 + (i * 4400 | 0) + 36 >> 2] | 0) | 0)) { break }
                                    Ue(f + 4 | 0, 1007, 0);
                                    k = 8;
                                    return k | 0
                                }
                            } while (0);
                            j = b + 776 | 0;
                            o = b + 780 | 0;
                            x = c[o >> 2] | 0;
                            y = j | 0;
                            q = c[y >> 2] | 0;
                            v = x - q >> 2;
                            do {
                                if (v >>> 0 < n >>> 0) {
                                    qj(j, n - v | 0);
                                    W = c[w >> 2] | 0
                                } else {
                                    if (!(v >>> 0 > n >>> 0)) { W = n; break }
                                    A = q + (n << 2) | 0;
                                    if ((x | 0) == (A | 0)) { W = n; break }
                                    c[o >> 2] = x + (~((x - 4 + (-A | 0) | 0) >>> 2) << 2);
                                    W = n
                                }
                            } while (0);
                            if ((W | 0) <= 0) { break }
                            n = qd(e) | 0;
                            x = b + 772 | 0;
                            c[x >> 2] = n;
                            if ((n | 0) == -99999) {
                                Ue(f + 4 | 0, 1007, 0);
                                k = 8;
                                return k | 0
                            }
                            o = n + 1 | 0;
                            c[x >> 2] = o;
                            if ((n | 0) > 31) { k = 8; return k | 0 }
                            if ((c[w >> 2] | 0) > 0) {
                                X = 0;
                                Y = o
                            } else { break }
                            while (1) {
                                o = (nd(e, Y) | 0) + 1 | 0;
                                n = c[y >> 2] | 0;
                                q = n + (X << 2) | 0;
                                c[q >> 2] = o;
                                if ((X | 0) > 0) { c[q >> 2] = o + (c[n + (X - 1 << 2) >> 2] | 0) }
                                n = X + 1 | 0;
                                if ((n | 0) >= (c[w >> 2] | 0)) { break d }
                                X = n;
                                Y = c[x >> 2] | 0
                            }
                        }
                    } while (0);
                    do {
                        if ((a[f + 93784 + (i * 4400 | 0) + 4133 | 0] | 0) != 0) {
                            p = qd(e) | 0;
                            h = b + 788 | 0;
                            c[h >> 2] = p;
                            if ((p | 0) == -99999 | (p | 0) > 1e3) {
                                Ue(f + 4 | 0, 1007, 0);
                                k = 8;
                                return k | 0
                            } else {
                                if ((p | 0) > 0) { Z = 0 } else { break }
                                do {
                                    nd(e, 8) | 0;
                                    Z = Z + 1 | 0;
                                } while ((Z | 0) < (c[h >> 2] | 0))
                            }
                        }
                    } while (0);
                    c[b + 792 >> 2] = (c[b + 740 >> 2] | 0) + (c[f + 93784 + (i * 4400 | 0) + 8 >> 2] | 0);
                    h = c[b + 20 >> 2] | 0;
                    if ((h | 0) == 2) { c[b + 796 >> 2] = 0 } else if ((h | 0) == 1) { c[b + 796 >> 2] = (a[b + 371 | 0] | 0) + 1 } else if ((h | 0) == 0) { c[b + 796 >> 2] = 2 - (a[b + 371 | 0] | 0) }
                    c[b + 804 >> 2] = 5 - (c[b + 736 >> 2] | 0);
                    a[g] = 1;
                    k = 0;
                    return k | 0
                }
            } while (0);
            Ue(f + 4 | 0, 1020, 0);
            k = 8;
            return k | 0
        }

        function Lj(e, f, g) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                r = 0,
                s = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            h = i;
            if ((g | 0) == 2) { j = q } else if ((g | 0) == 1) { j = t } else { i = h; return }
            g = c[j >> 2] | 0;
            j = e + 8 | 0;
            k = c[j >> 2] | 0;
            if ((a[f + 93784 + (k * 4400 | 0) | 0] | 0) == 0) { ec(12424, 14776, 1278, 17264) }
            l = a[f + 93784 + (k * 4400 | 0) + 2 | 0] | 0;
            if ((a[f + 11096 + (l * 5168 | 0) | 0] | 0) == 0) { ec(12192, 14776, 1281, 17264) }
            Zk(g, 11792, (m = i, i = i + 1 | 0, i = i + 7 & -8, c[m >> 2] = 0, m) | 0);
            i = m;
            n = e + 4 | 0;
            Zk(g, 11512, (m = i, i = i + 8 | 0, c[m >> 2] = a[n] | 0, m) | 0);
            i = m;
            o = f + 377208 | 0;
            if (((a[o] | 0) - 16 & 255) >>> 0 < 8 >>> 0) {
                Zk(g, 11232, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 5 | 0] | 0, m) | 0);
                i = m
            }
            Zk(g, 10984, (m = i, i = i + 8 | 0, c[m >> 2] = c[j >> 2], m) | 0);
            i = m;
            if ((a[n] | 0) == 0) {
                Zk(g, 10720, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 12 | 0] | 0, m) | 0);
                i = m;
                Zk(g, 10472, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 16 >> 2], m) | 0);
                i = m
            }
            n = e + 20 | 0;
            j = c[n >> 2] | 0;
            if ((j | 0) == 0) { p = 66 } else { p = (j | 0) == 1 ? 80 : 73 }
            Zk(g, 10144, (m = i, i = i + 8 | 0, c[m >> 2] = p, m) | 0);
            i = m;
            if ((a[f + 93784 + (k * 4400 | 0) + 31 | 0] | 0) != 0) {
                Zk(g, 9808, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 24 | 0] | 0, m) | 0);
                i = m
            }
            if ((a[f + 11096 + (l * 5168 | 0) + 480 | 0] | 0) == 1) {
                Zk(g, 9360, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 25 | 0] | 0, m) | 0);
                i = m
            }
            Zk(g, 9064, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 28 >> 2], m) | 0);
            i = m;
            do {
                if (!(((a[o] | 0) - 19 & 255) >>> 0 < 2 >>> 0)) {
                    p = e + 32 | 0;
                    Zk(g, 8752, (m = i, i = i + 8 | 0, c[m >> 2] = a[p] | 0, m) | 0);
                    i = m;
                    j = f + 11096 + (l * 5168 | 0) + 4720 | 0;
                    r = (c[f + 11096 + (l * 5168 | 0) + 4724 >> 2] | 0) - (c[j >> 2] | 0) | 0;
                    do {
                        if ((a[p] | 0) == 0) {
                            Zk(g, 8440, (m = i, i = i + 8 | 0, c[m >> 2] = (r | 0) / 100 | 0, m) | 0);
                            i = m;
                            tj(e + 34 | 0, 16, g)
                        } else {
                            if ((r | 0) <= 100) { break }
                            s = e + 136 | 0;
                            Zk(g, 8232, (m = i, i = i + 8 | 0, c[m >> 2] = c[s >> 2], m) | 0);
                            i = m;
                            tj((c[j >> 2] | 0) + ((c[s >> 2] | 0) * 100 | 0) | 0, 16, g)
                        }
                    } while (0);
                    if ((a[f + 11096 + (l * 5168 | 0) + 4732 | 0] | 0) != 0) {
                        if ((c[f + 11096 + (l * 5168 | 0) + 4736 >> 2] | 0) > 0) {
                            Zk(g, 7960, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 140 >> 2], m) | 0);
                            i = m
                        }
                        Zk(g, 7680, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 144 >> 2], m) | 0);
                        i = m
                    }
                    if ((a[f + 11096 + (l * 5168 | 0) + 4900 | 0] | 0) == 0) { break }
                    Zk(g, 7392, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 324 | 0] | 0, m) | 0);
                    i = m
                }
            } while (0);
            if ((a[f + 11096 + (l * 5168 | 0) + 4703 | 0] | 0) != 0) {
                Zk(g, 7088, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 325 | 0] | 0, m) | 0);
                i = m;
                Zk(g, 6808, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 326 | 0] | 0, m) | 0);
                i = m
            }
            if ((c[n >> 2] | 0) >>> 0 < 2 >>> 0) {
                o = e + 327 | 0;
                Zk(g, 6528, (m = i, i = i + 8 | 0, c[m >> 2] = a[o] | 0, m) | 0);
                i = m;
                j = e + 328 | 0;
                r = (a[o] | 0) != 0 ? 31320 : 6040;
                Zk(g, 6376, (m = i, i = i + 16 | 0, c[m >> 2] = c[j >> 2], c[m + 8 >> 2] = r, m) | 0);
                i = m;
                if ((c[n >> 2] | 0) == 0) {
                    r = (a[o] | 0) != 0 ? 31320 : 6040;
                    Zk(g, 5856, (m = i, i = i + 16 | 0, c[m >> 2] = c[e + 332 >> 2], c[m + 8 >> 2] = r, m) | 0);
                    i = m
                }
                do {
                    if ((a[f + 93784 + (k * 4400 | 0) + 4125 | 0] | 0) != 0) {
                        if ((c[e + 912 >> 2] | 0) <= 1) { break }
                        r = e + 336 | 0;
                        Zk(g, 5712, (m = i, i = i + 8 | 0, c[m >> 2] = a[r] | 0, m) | 0);
                        i = m;
                        do {
                            if ((a[r] | 0) != 0) {
                                if ((c[j >> 2] | 0) > 0) { u = 0 } else { break }
                                do {
                                    o = d[e + 338 + u | 0] | 0;
                                    Zk(g, 5552, (m = i, i = i + 16 | 0, c[m >> 2] = u, c[m + 8 >> 2] = o, m) | 0);
                                    i = m;
                                    u = u + 1 | 0;
                                } while ((u | 0) < (c[j >> 2] | 0))
                            }
                        } while (0);
                        r = e + 337 | 0;
                        Zk(g, 5392, (m = i, i = i + 8 | 0, c[m >> 2] = a[r] | 0, m) | 0);
                        i = m;
                        if ((a[r] | 0) == 0) { break }
                        r = e + 332 | 0;
                        if ((c[r >> 2] | 0) > 0) { v = 0 } else { break }
                        do {
                            o = d[e + 354 + v | 0] | 0;
                            Zk(g, 5552, (m = i, i = i + 16 | 0, c[m >> 2] = v, c[m + 8 >> 2] = o, m) | 0);
                            i = m;
                            v = v + 1 | 0;
                        } while ((v | 0) < (c[r >> 2] | 0))
                    }
                } while (0);
                if ((c[n >> 2] | 0) == 0) {
                    Zk(g, 5224, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 370 | 0] | 0, m) | 0);
                    i = m
                }
                Zk(g, 5008, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 371 | 0] | 0, m) | 0);
                i = m;
                if ((a[e + 324 | 0] | 0) != 0) {
                    Zk(g, 4832, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 372 | 0] | 0, m) | 0);
                    i = m;
                    Zk(g, 4712, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 376 >> 2], m) | 0);
                    i = m
                }
                if ((a[f + 93784 + (k * 4400 | 0) + 29 | 0] | 0) == 0) { w = 47 } else { if ((c[n >> 2] | 0) == 1) { w = 49 } else { w = 47 } }
                do { if ((w | 0) == 47) { if ((a[f + 93784 + (k * 4400 | 0) + 30 | 0] | 0) == 0) { break } if ((c[n >> 2] | 0) == 0) { w = 49 } } } while (0);
                a: do {
                    if ((w | 0) == 49) {
                        Zk(g, 4480, (m = i, i = i + 8 | 0, c[m >> 2] = d[e + 380 | 0] | 0, m) | 0);
                        i = m;
                        if ((c[f + 11096 + (l * 5168 | 0) + 476 >> 2] | 0) != 0) {
                            Zk(g, 4248, (m = i, i = i + 8 | 0, c[m >> 2] = d[e + 381 | 0] | 0, m) | 0);
                            i = m
                        }
                        v = e + 332 | 0;
                        u = 0;
                        do {
                            if ((u | 0) == 1) {
                                if ((c[n >> 2] | 0) == 0) {
                                    x = v;
                                    w = 54
                                } else { break a }
                            } else if ((u | 0) == 0) {
                                x = j;
                                w = 54
                            }
                            do {
                                if ((w | 0) == 54) {
                                    w = 0;
                                    r = c[x >> 2] | 0;
                                    o = r - 1 | 0;
                                    if ((r | 0) < 1) { break } else { y = 0 }
                                    while (1) {
                                        r = b[e + 446 + (u << 5) + (y << 1) >> 1] | 0;
                                        Zk(g, 4096, (m = i, i = i + 24 | 0, c[m >> 2] = u, c[m + 8 >> 2] = y, c[m + 16 >> 2] = r, m) | 0);
                                        i = m;
                                        r = a[e + 510 + (u << 4) + y | 0] | 0;
                                        Zk(g, 4008, (m = i, i = i + 24 | 0, c[m >> 2] = u, c[m + 8 >> 2] = y, c[m + 16 >> 2] = r, m) | 0);
                                        i = m;
                                        r = b[e + 542 + (u << 6) + (y << 2) >> 1] | 0;
                                        Zk(g, 3944, (m = i, i = i + 32 | 0, c[m >> 2] = u, c[m + 8 >> 2] = y, c[m + 16 >> 2] = 0, c[m + 24 >> 2] = r, m) | 0);
                                        i = m;
                                        r = a[e + 670 + (u << 5) + (y << 1) | 0] | 0;
                                        Zk(g, 3880, (m = i, i = i + 32 | 0, c[m >> 2] = u, c[m + 8 >> 2] = y, c[m + 16 >> 2] = 0, c[m + 24 >> 2] = r, m) | 0);
                                        i = m;
                                        r = b[e + 542 + (u << 6) + (y << 2) + 2 >> 1] | 0;
                                        Zk(g, 3944, (m = i, i = i + 32 | 0, c[m >> 2] = u, c[m + 8 >> 2] = y, c[m + 16 >> 2] = 1, c[m + 24 >> 2] = r, m) | 0);
                                        i = m;
                                        r = a[e + 670 + (u << 5) + (y << 1) + 1 | 0] | 0;
                                        Zk(g, 3880, (m = i, i = i + 32 | 0, c[m >> 2] = u, c[m + 8 >> 2] = y, c[m + 16 >> 2] = 1, c[m + 24 >> 2] = r, m) | 0);
                                        i = m;
                                        if ((y | 0) < (o | 0)) { y = y + 1 | 0 } else { break }
                                    }
                                }
                            } while (0);
                            u = u + 1 | 0;
                        } while ((u | 0) < 2)
                    }
                } while (0);
                Zk(g, 3792, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 736 >> 2], m) | 0);
                i = m
            }
            Zk(g, 3624, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 740 >> 2], m) | 0);
            i = m;
            if ((a[f + 93784 + (k * 4400 | 0) + 28 | 0] | 0) != 0) {
                Zk(g, 3464, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 744 >> 2], m) | 0);
                i = m;
                Zk(g, 3360, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 748 >> 2], m) | 0);
                i = m
            }
            y = e + 753 | 0;
            if ((a[f + 93784 + (k * 4400 | 0) + 48 | 0] | 0) != 0) {
                Zk(g, 3144, (m = i, i = i + 8 | 0, c[m >> 2] = a[y] | 0, m) | 0);
                i = m
            }
            x = e + 754 | 0;
            w = ((a[y] | 0) != 0 ? 2896 : 2816) | 0;
            Zk(g, 3088, (m = i, i = i + 16 | 0, c[m >> 2] = a[x] | 0, c[m + 8 >> 2] = w, m) | 0);
            i = m;
            do {
                if ((a[y] | 0) != 0) {
                    if ((a[x] | 0) != 0) { break }
                    Zk(g, 2696, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 756 >> 2], m) | 0);
                    i = m;
                    Zk(g, 2600, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 760 >> 2], m) | 0);
                    i = m
                }
            } while (0);
            b: do {
                if ((a[f + 93784 + (k * 4400 | 0) + 46 | 0] | 0) != 0) {
                    do { if ((a[e + 325 | 0] | 0) == 0) { if ((a[e + 326 | 0] | 0) != 0) { break } if ((a[x] | 0) != 0) { break b } } } while (0);
                    Zk(g, 2480, (m = i, i = i + 8 | 0, c[m >> 2] = a[e + 764 | 0] | 0, m) | 0);
                    i = m
                }
            } while (0);
            do {
                if ((a[f + 93784 + (k * 4400 | 0) + 34 | 0] | 0) == 0) {
                    if ((a[f + 93784 + (k * 4400 | 0) + 33 | 0] | 0) != 0) { break }
                    i = h;
                    return
                }
            } while (0);
            k = e + 768 | 0;
            Zk(g, 2320, (m = i, i = i + 8 | 0, c[m >> 2] = c[k >> 2], m) | 0);
            i = m;
            if ((c[k >> 2] | 0) <= 0) { i = h; return }
            Zk(g, 2136, (m = i, i = i + 8 | 0, c[m >> 2] = c[e + 772 >> 2], m) | 0);
            i = m;
            if ((c[k >> 2] | 0) <= 0) { i = h; return }
            f = e + 776 | 0;
            e = 0;
            do {
                x = c[(c[f >> 2] | 0) + (e << 2) >> 2] | 0;
                Zk(g, 2048, (m = i, i = i + 16 | 0, c[m >> 2] = e, c[m + 8 >> 2] = x, m) | 0);
                i = m;
                e = e + 1 | 0;
            } while ((e | 0) < (c[k >> 2] | 0));
            i = h;
            return
        }

        function Mj() {
            var b = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0;
            b = Gu(11296) | 0;
            if ((b | 0) == 0) { e = 0; return e | 0 }
            dv(b | 0, -1 | 0, 11296) | 0;
            c[7766] = b;
            c[7767] = b;
            c[7768] = b;
            c[7769] = b;
            c[7770] = b;
            c[7771] = b;
            c[7772] = b;
            c[7773] = b;
            f = b + 16 | 0;
            c[7774] = f;
            c[7775] = f;
            c[7776] = f;
            c[7777] = f;
            c[7778] = f;
            c[7779] = f;
            c[7780] = f;
            c[7781] = f;
            f = b + 1056 | 0;
            c[7782] = b + 32;
            c[7783] = b + 96;
            c[7784] = b + 160;
            c[7785] = b + 224;
            c[7786] = b + 288;
            c[7787] = b + 352;
            c[7788] = b + 416;
            c[7789] = b + 480;
            c[7790] = b + 544;
            c[7791] = b + 608;
            c[7792] = b + 672;
            c[7793] = b + 736;
            c[7794] = b + 800;
            c[7795] = b + 864;
            c[7796] = b + 928;
            c[7797] = b + 992;
            c[7798] = f;
            c[7802] = f;
            f = b + 1312 | 0;
            c[7799] = f;
            c[7803] = f;
            f = b + 1568 | 0;
            c[7800] = f;
            c[7804] = f;
            f = b + 1824 | 0;
            c[7801] = f;
            c[7805] = f;
            f = b + 2080 | 0;
            c[7806] = f;
            c[7810] = f;
            f = b + 2336 | 0;
            c[7807] = f;
            c[7811] = f;
            f = b + 2592 | 0;
            c[7808] = f;
            c[7812] = f;
            f = b + 2848 | 0;
            c[7809] = f;
            c[7813] = f;
            f = b + 3104 | 0;
            c[7814] = f;
            c[7818] = f;
            f = b + 4128 | 0;
            c[7815] = f;
            c[7819] = f;
            f = b + 5152 | 0;
            c[7816] = f;
            c[7820] = f;
            f = b + 6176 | 0;
            c[7817] = f;
            c[7821] = f;
            f = b + 7200 | 0;
            c[7822] = f;
            c[7826] = f;
            f = b + 8224 | 0;
            c[7823] = f;
            c[7827] = f;
            f = b + 9248 | 0;
            c[7824] = f;
            c[7828] = f;
            f = b + 10272 | 0;
            c[7825] = f;
            c[7829] = f;
            f = 2;
            a: while (1) {
                b = 1 << f;
                g = (b | 0) > 0;
                h = b >> 2;
                i = (h | 0) == 1;
                j = f - 2 | 0;
                k = (h | 0) == 2;
                h = 0;
                do {
                    l = (h | 0) == 0;
                    m = 0;
                    do {
                        n = (m | 0) == 0 ? 9 : 15;
                        o = 0;
                        do {
                            if (g) {
                                p = 31064 + (j << 6) + (h << 5) + (m << 4) + (o << 2) | 0;
                                q = 0;
                                do {
                                    r = q << 2;
                                    s = q << f;
                                    t = -q | 0;
                                    u = q >> 2;
                                    v = q & 3;
                                    w = (v | 0) == 0;
                                    x = (v | 0) == 1 | 0;
                                    if (i) {
                                        y = 0;
                                        do {
                                            z = d[27272 + (y + r) | 0] | 0;
                                            A = l ? z : z + 27 | 0;
                                            z = (c[p >> 2] | 0) + (y + s) | 0;
                                            B = a[z] | 0;
                                            if (!(B << 24 >> 24 == -1 | (B & 255 | 0) == (A | 0))) { C = 26; break a }
                                            a[z] = A;
                                            y = y + 1 | 0;
                                        } while ((y | 0) < (b | 0))
                                    } else {
                                        y = 0;
                                        do {
                                            do {
                                                if ((y | 0) == (t | 0)) { D = 0 } else {
                                                    r = y >> 2;
                                                    A = y & 3;
                                                    do {
                                                        if ((o | 0) == 1) { E = w ? 2 : x } else if ((o | 0) == 2) {
                                                            if ((A | 0) == 0) { E = 2; break }
                                                            E = (A | 0) == 1 | 0
                                                        } else if ((o | 0) == 0) {
                                                            z = A + v | 0;
                                                            if ((z | 0) > 2) { E = 0; break }
                                                            E = (z | 0) > 0 ? 1 : 2
                                                        } else { E = 2 }
                                                    } while (0);
                                                    if (l) { A = (r + u | 0) > 0 ? E + 3 | 0 : E; if (k) { D = A + n | 0; break } else { D = A + 21 | 0; break } } else { if (k) { D = E + 9 | 0; break } else { D = E | 12; break } }
                                                }
                                            } while (0);
                                            A = l ? D : D + 27 | 0;
                                            z = (c[p >> 2] | 0) + (y + s) | 0;
                                            B = a[z] | 0;
                                            if (!(B << 24 >> 24 == -1 | (B & 255 | 0) == (A | 0))) { C = 26; break a }
                                            a[z] = A;
                                            y = y + 1 | 0;
                                        } while ((y | 0) < (b | 0))
                                    }
                                    q = q + 1 | 0;
                                } while ((q | 0) < (b | 0))
                            }
                            o = o + 1 | 0;
                        } while ((o | 0) < 4);
                        m = m + 1 | 0;
                    } while ((m | 0) < 2);
                    h = h + 1 | 0;
                } while ((h | 0) < 2);
                h = f + 1 | 0;
                if ((h | 0) < 6) { f = h } else {
                    e = 1;
                    C = 33;
                    break
                }
            }
            if ((C | 0) == 26) { ec(1728, 14776, 2100, 18008); return 0 } else if ((C | 0) == 33) { return e | 0 }
            return 0
        }

        function Nj() {
            Hu(c[7766] | 0);
            c[7766] = 0;
            return
        }

        function Oj(b, e, f, g) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0;
            g = i;
            i = i + 24 | 0;
            h = g | 0;
            j = c[b + 18600 >> 2] | 0;
            k = c[b + 18596 >> 2] | 0;
            l = h | 0;
            dv(l | 0, 0, 17) | 0;
            do {
                if ((e | 0) > 0) {
                    m = ga(c[k + 5820 >> 2] | 0, f) | 0;
                    n = c[k + 10308 >> 2] | 0;
                    if ((c[b >> 2] | 0) <= (c[j + 800 >> 2] | 0)) { o = 1; break }
                    if ((c[n + (m + e << 2) >> 2] | 0) != (c[n + (e - 1 + m << 2) >> 2] | 0)) { o = 1; break }
                    o = ((ud(b + 18556 | 0, c[b + 18580 >> 2] | 0) | 0) & 255) << 24 >> 24 == 0
                } else { o = 1 }
            } while (0);
            do {
                if ((f | 0) > 0 & o) {
                    m = c[k + 5820 >> 2] | 0;
                    n = c[k + 10308 >> 2] | 0;
                    if (((c[b >> 2] | 0) - m | 0) < (c[j + 800 >> 2] | 0)) { p = 0; break }
                    q = n + ((ga(m, f) | 0) + e << 2) | 0;
                    r = n + ((ga(m, f - 1 | 0) | 0) + e << 2) | 0;
                    if ((c[q >> 2] | 0) != (c[r >> 2] | 0)) { p = 0; break }
                    p = ((ud(b + 18556 | 0, c[b + 18580 >> 2] | 0) | 0) & 255) << 24 >> 24 != 0
                } else { p = 0 }
            } while (0);
            if (o & (p ^ 1)) {
                r = (c[k + 5776 >> 2] | 0) == 0 ? 1 : 3;
                q = j + 325 | 0;
                m = b + 18556 | 0;
                n = b + 18580 | 0;
                b = k + 5760 | 0;
                s = k + 5768 | 0;
                t = k + 10087 | 0;
                u = k + 10088 | 0;
                v = h + 1 | 0;
                w = j + 326 | 0;
                j = 0;
                do {
                    x = (j | 0) == 0;
                    if ((a[q] | 0) != 0 & x) { y = 13 } else { if ((a[w] | 0) != 0 & (j | 0) > 0) { y = 13 } }
                    do {
                        if ((y | 0) == 13) {
                            y = 0;
                            do {
                                if (x) {
                                    if ((ud(m, (c[n >> 2] | 0) + 1 | 0) | 0) == 0) { z = 0 } else {
                                        A = (wd(m) | 0) == 0;
                                        z = A ? 1 : 2
                                    }
                                    a[l] = z;
                                    B = z
                                } else {
                                    if ((j | 0) != 1) { B = (d[l] | 0) >>> (j << 1 >>> 0) & 3; break }
                                    if ((ud(m, (c[n >> 2] | 0) + 1 | 0) | 0) == 0) { C = 0 } else {
                                        A = (wd(m) | 0) == 0;
                                        C = A ? 1 : 2
                                    }
                                    a[l] = C << 4 | C << 2 | d[l];
                                    B = C & 255
                                }
                            } while (0);
                            if (B << 24 >> 24 == 0) { break }
                            A = x ? b : s;
                            D = c[A >> 2] | 0;
                            E = (xd(m, (D | 0) < 10 ? (1 << D - 5) - 1 | 0 : 31) | 0) & 255;
                            D = h + 5 + (j << 2) | 0;
                            a[D] = E;
                            F = c[A >> 2] | 0;
                            G = (xd(m, (F | 0) < 10 ? (1 << F - 5) - 1 | 0 : 31) | 0) & 255;
                            F = h + 5 + (j << 2) + 1 | 0;
                            a[F] = G;
                            H = c[A >> 2] | 0;
                            I = (xd(m, (H | 0) < 10 ? (1 << H - 5) - 1 | 0 : 31) | 0) & 255;
                            H = h + 5 + (j << 2) + 2 | 0;
                            a[H] = I;
                            J = c[A >> 2] | 0;
                            A = (xd(m, (J | 0) < 10 ? (1 << J - 5) - 1 | 0 : 31) | 0) & 255;
                            J = h + 5 + (j << 2) + 3 | 0;
                            a[J] = A;
                            do {
                                if (B << 24 >> 24 == 1) {
                                    if (E << 24 >> 24 == 0) { K = 0 } else {
                                        L = (wd(m) | 0) != 0;
                                        K = L ? -1 : 1
                                    }
                                    if (G << 24 >> 24 == 0) { M = 0 } else {
                                        L = (wd(m) | 0) != 0;
                                        M = L ? -1 : 1
                                    }
                                    if (I << 24 >> 24 == 0) { N = 0 } else {
                                        L = (wd(m) | 0) != 0;
                                        N = L ? -1 : 1
                                    }
                                    if (A << 24 >> 24 == 0) { O = 0 } else {
                                        L = (wd(m) | 0) != 0;
                                        O = L ? -1 : 1
                                    }
                                    L = (yd(m, 5) | 0) & 255;
                                    a[h + 2 + j | 0] = L;
                                    P = K;
                                    Q = M;
                                    R = a[F] | 0;
                                    S = N;
                                    T = a[H] | 0;
                                    U = O;
                                    V = a[J] | 0
                                } else {
                                    if (x) {
                                        L = (yd(m, 2) | 0) & 255;
                                        a[v] = L;
                                        P = 1;
                                        Q = 1;
                                        R = G;
                                        S = -1;
                                        T = I;
                                        U = -1;
                                        V = A;
                                        break
                                    }
                                    if ((j | 0) != 1) {
                                        P = 1;
                                        Q = 1;
                                        R = G;
                                        S = -1;
                                        T = I;
                                        U = -1;
                                        V = A;
                                        break
                                    }
                                    L = (yd(m, 2) | 0) & 255;
                                    a[v] = d[v] | L << 2 | L << 4;
                                    P = 1;
                                    Q = 1;
                                    R = G;
                                    S = -1;
                                    T = I;
                                    U = -1;
                                    V = A
                                }
                            } while (0);
                            A = d[x ? t : u] | 0;
                            I = (ga(a[D] << A, P) | 0) & 255;
                            a[D] = I;
                            I = (ga(R << 24 >> 24 << A, Q) | 0) & 255;
                            a[F] = I;
                            I = (ga(T << 24 >> 24 << A, S) | 0) & 255;
                            a[H] = I;
                            I = (ga(V << 24 >> 24 << A, U) | 0) & 255;
                            a[J] = I
                        }
                    } while (0);
                    j = j + 1 | 0;
                } while ((j | 0) < (r | 0));
                r = (ga(c[k + 10352 >> 2] | 0, f) | 0) + e | 0;
                cv((c[k + 10340 >> 2] | 0) + (r * 24 | 0) + 4 | 0, l | 0, 17) | 0
            }
            if (!o) {
                o = ga(c[k + 10352 >> 2] | 0, f) | 0;
                l = c[k + 10340 >> 2] | 0;
                cv(l + ((o + e | 0) * 24 | 0) + 4 | 0, l + ((e - 1 + o | 0) * 24 | 0) + 4 | 0, 17) | 0
            }
            if (!p) { i = g; return }
            p = c[k + 10352 >> 2] | 0;
            o = (ga(p, f - 1 | 0) | 0) + e | 0;
            l = c[k + 10340 >> 2] | 0;
            cv(l + (((ga(p, f) | 0) + e | 0) * 24 | 0) + 4 | 0, l + (o * 24 | 0) + 4 | 0, 17) | 0;
            i = g;
            return
        }

        function Pj(d) {
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            e = c[d + 18600 >> 2] | 0;
            f = c[d + 18596 >> 2] | 0;
            g = c[d >> 2] | 0;
            h = c[f + 5820 >> 2] | 0;
            i = (g | 0) % (h | 0) | 0;
            j = (g | 0) / (h | 0) | 0;
            h = f + 5804 | 0;
            g = c[h >> 2] | 0;
            k = i << g;
            l = j << g;
            m = c[f + 10352 >> 2] | 0;
            n = (ga(m, j) | 0) + i | 0;
            o = c[f + 10340 >> 2] | 0;
            b[o + (n * 24 | 0) >> 1] = c[e + 800 >> 2];
            n = c[e >> 2] & 65535;
            p = c[f + 10348 >> 2] | 0;
            q = k >> p;
            r = l >> p;
            if (!((q | 0) > -1 & (q | 0) < (m | 0))) { ec(1024, 904, 128, 17320) }
            if (!((r | 0) > -1)) { ec(816, 904, 129, 17320) }
            if ((r | 0) >= (c[f + 10356 >> 2] | 0)) { ec(816, 904, 129, 17320) }
            f = o + (((ga(m, r) | 0) + q | 0) * 24 | 0) + 2 | 0;
            b[f >> 1] = n;
            do {
                if ((a[e + 325 | 0] | 0) == 0) {
                    if ((a[e + 326 | 0] | 0) == 0) { s = g } else { break }
                    Qj(d, k, l, s, 0);
                    return
                }
            } while (0);
            Oj(d, i, j, 0);
            s = c[h >> 2] | 0;
            Qj(d, k, l, s, 0);
            return
        }

        function Qj(e, f, g, h, i) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0;
            j = e + 18596 | 0;
            k = e + 18600 | 0;
            l = e + 18516 | 0;
            m = e + 18508 | 0;
            n = e + 18512 | 0;
            o = e + 18556 | 0;
            p = e + 18580 | 0;
            q = i;
            i = h;
            h = g;
            g = f;
            a: while (1) {
                r = c[j >> 2] | 0;
                f = 1 << i;
                s = r + 1248 | 0;
                t = c[s >> 2] | 0;
                do {
                    if ((f + g | 0) > (t | 0)) { u = 28 } else {
                        v = c[r + 1252 >> 2] | 0;
                        if ((f + h | 0) > (v | 0)) { u = 28; break }
                        if ((c[r + 5800 >> 2] | 0) >= (i | 0)) { u = 28; break }
                        w = g - 1 | 0;
                        do {
                            if ((w | h | 0) > -1 & (t | 0) > (w | 0) & (v | 0) > (h | 0)) {
                                x = c[r + 5804 >> 2] | 0;
                                y = ga(h >> x, c[r + 5820 >> 2] | 0) | 0;
                                z = y + (g >> x) | 0;
                                A = y + (w >> x) | 0;
                                x = c[r + 10340 >> 2] | 0;
                                if ((b[x + (z * 24 | 0) >> 1] | 0) != (b[x + (A * 24 | 0) >> 1] | 0)) { B = 0; break }
                                x = c[r + 10308 >> 2] | 0;
                                B = (c[x + (z << 2) >> 2] | 0) == (c[x + (A << 2) >> 2] | 0) | 0
                            } else { B = 0 }
                        } while (0);
                        A = h - 1 | 0;
                        do {
                            if ((A | g | 0) > -1 & (t | 0) > (g | 0) & (v | 0) > (A | 0)) {
                                x = c[r + 5804 >> 2] | 0;
                                z = c[r + 5820 >> 2] | 0;
                                y = g >> x;
                                D = (ga(h >> x, z) | 0) + y | 0;
                                E = (ga(A >> x, z) | 0) + y | 0;
                                y = c[r + 10340 >> 2] | 0;
                                if ((b[y + (D * 24 | 0) >> 1] | 0) != (b[y + (E * 24 | 0) >> 1] | 0)) { F = 0; break }
                                y = c[r + 10308 >> 2] | 0;
                                F = (c[y + (D << 2) >> 2] | 0) == (c[y + (E << 2) >> 2] | 0) | 0
                            } else { F = 0 }
                        } while (0);
                        if ((B | 0) == 0) { G = 2 } else {
                            v = c[r + 10368 >> 2] | 0;
                            E = w >> v;
                            y = h >> v;
                            if (!((E | 0) > -1)) { u = 14; break a }
                            v = c[r + 10372 >> 2] | 0;
                            if ((E | 0) >= (v | 0)) { u = 14; break a }
                            if (!((y | 0) > -1)) { u = 17; break a }
                            if ((y | 0) >= (c[r + 10376 >> 2] | 0)) { u = 17; break a }
                            D = (ga(v, y) | 0) + E | 0;
                            E = (c[r + 10360 >> 2] | 0) + (D * 3 | 0) | 0;
                            G = (((d[E] | d[E + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 6 & 255 & 3 | 0) > (q | 0) | 2
                        }
                        if ((F | 0) == 0) { H = 0 } else {
                            E = c[r + 10368 >> 2] | 0;
                            D = g >> E;
                            y = A >> E;
                            if (!((D | 0) > -1)) { u = 22; break a }
                            E = c[r + 10372 >> 2] | 0;
                            if ((D | 0) >= (E | 0)) { u = 22; break a }
                            if (!((y | 0) > -1)) { u = 25; break a }
                            if ((y | 0) >= (c[r + 10376 >> 2] | 0)) { u = 25; break a }
                            v = (ga(E, y) | 0) + D | 0;
                            D = (c[r + 10360 >> 2] | 0) + (v * 3 | 0) | 0;
                            H = (((d[D] | d[D + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 6 & 255 & 3 | 0) > (q | 0) | 0
                        }
                        I = ud(o, (c[p >> 2] | 0) + (H + G) | 0) | 0
                    }
                } while (0);
                if ((u | 0) == 28) {
                    u = 0;
                    I = (c[r + 5800 >> 2] | 0) < (i | 0) | 0
                }
                do {
                    if ((a[r + 5946 | 0] | 0) != 0) {
                        if ((c[r + 10092 >> 2] | 0) > (i | 0)) { break }
                        c[m >> 2] = 0;
                        c[n >> 2] = 0
                    }
                } while (0);
                do {
                    if ((a[(c[k >> 2] | 0) + 752 | 0] | 0) != 0) {
                        if ((c[r + 10096 >> 2] | 0) > (i | 0)) { break }
                        c[l >> 2] = 0
                    }
                } while (0);
                if ((I | 0) == 0) { u = 42; break }
                t = i - 1 | 0;
                f = 1 << t;
                D = f + g | 0;
                v = f + h | 0;
                f = q + 1 | 0;
                Qj(e, g, h, t, f);
                if ((D | 0) < (c[s >> 2] | 0)) { Qj(e, D, h, t, f) }
                y = r + 1252 | 0;
                if ((v | 0) < (c[y >> 2] | 0)) { Qj(e, g, v, t, f) }
                if ((D | 0) >= (c[s >> 2] | 0)) { u = 48; break }
                if ((v | 0) < (c[y >> 2] | 0)) {
                    q = f;
                    i = t;
                    h = v;
                    g = D
                } else { u = 48; break }
            }
            if ((u | 0) == 14) { ec(1024, 904, 118, 17320) } else if ((u | 0) == 17) { ec(816, 904, 119, 17320) } else if ((u | 0) == 22) { ec(1024, 904, 118, 17320) } else if ((u | 0) == 25) { ec(816, 904, 119, 17320) } else if ((u | 0) == 42) {
                I = c[r + 10368 >> 2] | 0;
                l = g >> I;
                k = h >> I;
                n = 1 << i - I;
                I = n + k | 0;
                if ((n | 0) > 0) {
                    m = n + l | 0;
                    n = r + 10372 | 0;
                    G = r + 10360 | 0;
                    r = (q & 65535) << 6 & 192;
                    H = k;
                    do {
                        k = l;
                        do {
                            p = (ga(c[n >> 2] | 0, H) | 0) + k | 0;
                            o = (c[G >> 2] | 0) + (p * 3 | 0) | 0;
                            C = (d[o] | d[o + 1 | 0] << 8) << 16 >> 16 & -193 | r;
                            a[o] = C;
                            C = C >> 8;
                            a[o + 1 | 0] = C;
                            k = k + 1 | 0;
                        } while ((k | 0) < (m | 0));
                        H = H + 1 | 0;
                    } while ((H | 0) < (I | 0))
                }
                Xj(e, g, h, i, q);
                return
            } else if ((u | 0) == 48) { return }
        }

        function Rj(f, g, h, j, k) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0,
                Fa = 0,
                Ga = 0,
                Ha = 0,
                Ia = 0,
                Ja = 0,
                Ka = 0,
                La = 0,
                Ma = 0,
                Na = 0,
                Oa = 0,
                Pa = 0,
                Qa = 0,
                Ra = 0,
                Sa = 0,
                Ta = 0,
                Ua = 0,
                Va = 0,
                Wa = 0,
                Xa = 0,
                Ya = 0;
            l = i;
            i = i + 152 | 0;
            m = l | 0;
            n = l + 8 | 0;
            o = l + 72 | 0;
            p = l + 104 | 0;
            q = l + 120 | 0;
            r = l + 136 | 0;
            s = c[f + 18596 >> 2] | 0;
            t = s + 764 | 0;
            u = c[s + 10368 >> 2] | 0;
            v = g >> u;
            w = h >> u;
            if (!((v | 0) > -1)) { ec(1024, 904, 118, 17320); return 0 }
            u = c[s + 10372 >> 2] | 0;
            if ((v | 0) >= (u | 0)) { ec(1024, 904, 118, 17320); return 0 }
            if (!((w | 0) > -1)) { ec(816, 904, 119, 17320); return 0 }
            if ((w | 0) >= (c[s + 10376 >> 2] | 0)) { ec(816, 904, 119, 17320); return 0 }
            x = (ga(u, w) | 0) + v | 0;
            v = (c[s + 10360 >> 2] | 0) + (x * 3 | 0) | 0;
            x = ((d[v] | d[v + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 8 & 3;
            v = (k | 0) == 0;
            do {
                if (v) {
                    w = c[s + 10448 >> 2] | 0;
                    u = g >> w;
                    y = h >> w;
                    z = 1 << j - w;
                    w = z + y | 0;
                    if ((z | 0) <= 0) { break }
                    A = z + u | 0;
                    z = s + 10452 | 0;
                    B = s + 10440 | 0;
                    C = y;
                    do {
                        y = u;
                        do {
                            D = (ga(c[z >> 2] | 0, C) | 0) + y | 0;
                            E = (c[B >> 2] | 0) + D | 0;
                            a[E] = a[E] | -128;
                            y = y + 1 | 0;
                        } while ((y | 0) < (A | 0));
                        C = C + 1 | 0;
                    } while ((C | 0) < (w | 0))
                }
            } while (0);
            do {
                if ((a[s + 5945 | 0] | 0) == 0) { F = 17 } else {
                    if ((a[f + 32 | 0] | 0) != 0) { F = 17; break }
                    if ((c[s + 10100 >> 2] | 0) < (j | 0)) { F = 17; break }
                    w = (ud(f + 18556 | 0, (c[f + 18580 >> 2] | 0) + ((k | 0) != 0 ? 142 : 141) | 0) | 0) & 255;
                    a[f + 33 + k | 0] = w
                }
            } while (0);
            if ((F | 0) == 17) { a[f + 33 + k | 0] = 0 }
            w = f + 36 | 0;
            a[w] = 0;
            do {
                if (x << 24 >> 24 == 1) {
                    if ((a[s + 5751 | 0] | 0) == 0) { F = 24; break }
                    C = f + 33 + k | 0;
                    if ((a[C] | 0) == 0) { if ((a[f + 32 | 0] | 0) == 0) { F = 24; break } }
                    A = f + 18580 | 0;
                    B = f + 18556 | 0;
                    z = (k | 0) != 0;
                    u = (ud(B, (c[A >> 2] | 0) + (z ? 144 : 143) | 0) | 0) & 255;
                    a[w] = u;
                    if (u << 24 >> 24 == 0) { G = C; break }
                    u = (ud(B, (c[A >> 2] | 0) + (z ? 146 : 145) | 0) | 0) & 255;
                    a[f + 37 | 0] = u;
                    G = C
                } else { F = 24 }
            } while (0);
            if ((F | 0) == 24) {
                a[w] = 0;
                G = f + 33 + k | 0
            }
            C = v ? 2 : 0;
            if ((a[G] | 0) == 0) { if ((a[f + 32 | 0] | 0) == 0) { H = C } else { F = 27 } } else { F = 27 }
            if ((F | 0) == 27) { H = C | 1 }
            C = f + 18580 | 0;
            u = c[C >> 2] | 0;
            z = (j << 1) - 1 | 0;
            if (v) {
                I = (j * 3 | 0) - 6 + (j - 1 >> 2) + 25 | 0;
                J = j + 1 >> 2
            } else {
                I = 40;
                J = j - 2 | 0
            }
            A = (z | 0) > 0;
            if (A) {
                B = f + 18556 | 0;
                y = 0;
                while (1) { E = y + 1 | 0; if ((ud(B, u + (I + (y >> J)) | 0) | 0) == 0) { K = y; break } if ((E | 0) < (z | 0)) { y = E } else { K = z; break } }
                L = K;
                M = c[C >> 2] | 0
            } else {
                L = z;
                M = u
            }
            if (v) {
                N = (j * 3 | 0) - 6 + (j - 1 >> 2) + 43 | 0;
                O = j + 1 >> 2
            } else {
                N = 58;
                O = j - 2 | 0
            }
            a: do {
                if (A) {
                    u = f + 18556 | 0;
                    K = 0;
                    while (1) { y = K + 1 | 0; if ((ud(u, M + (N + (K >> O)) | 0) | 0) == 0) { P = K; break a } if ((y | 0) < (z | 0)) { K = y } else { P = z; break } }
                } else { P = z }
            } while (0);
            if ((L | 0) > 3) {
                z = (L >> 1) - 1 | 0;
                Q = (yd(f + 18556 | 0, z) | 0) + ((L & 1 | 2) << z) | 0
            } else { Q = L }
            if ((P | 0) > 3) {
                L = (P >> 1) - 1 | 0;
                R = (yd(f + 18556 | 0, L) | 0) + ((P & 1 | 2) << L) | 0
            } else { R = P }
            P = x << 24 >> 24 == 0;
            if (P) {
                do {
                    if (v) {
                        x = c[s + 10408 >> 2] | 0;
                        L = g >> x;
                        z = h >> x;
                        if (!((L | 0) > -1)) { ec(1024, 904, 118, 17320); return 0 }
                        x = c[s + 10412 >> 2] | 0;
                        if ((L | 0) >= (x | 0)) { ec(1024, 904, 118, 17320); return 0 }
                        if (!((z | 0) > -1)) { ec(816, 904, 119, 17320); return 0 }
                        if ((z | 0) < (c[s + 10416 >> 2] | 0)) {
                            O = (ga(x, z) | 0) + L | 0;
                            S = ei(j, d[(c[s + 10400 >> 2] | 0) + O | 0] | 0, 0, t) | 0;
                            break
                        } else { ec(816, 904, 119, 17320); return 0 }
                    } else {
                        O = c[s + 10428 >> 2] | 0;
                        L = g >> O;
                        z = h >> O;
                        if (!((L | 0) > -1)) { ec(1024, 904, 118, 17320); return 0 }
                        O = c[s + 10432 >> 2] | 0;
                        if ((L | 0) >= (O | 0)) { ec(1024, 904, 118, 17320); return 0 }
                        if (!((z | 0) > -1)) { ec(816, 904, 119, 17320); return 0 }
                        if ((z | 0) < (c[s + 10436 >> 2] | 0)) {
                            x = (ga(O, z) | 0) + L | 0;
                            S = ei(j, a[(c[s + 10420 >> 2] | 0) + x | 0] & 63, k, t) | 0;
                            break
                        } else { ec(816, 904, 119, 17320); return 0 }
                    }
                } while (0);
                t = (S | 0) == 2;
                T = t ? Q : R;
                U = t ? R : Q;
                V = S
            } else {
                T = R;
                U = Q;
                V = 0
            }
            Q = j - 2 | 0;
            R = Cj(Q, V) | 0;
            S = Cj(2, V) | 0;
            Dj(m, U, T, V, j);
            T = a[m + 1 | 0] | 0;
            U = d[m | 0] | 0;
            dv(n | 0, 0, 1 << Q << Q | 0) | 0;
            m = f + 14404 + (k << 1) | 0;
            b[m >> 1] = 0;
            t = f + 18556 | 0;
            x = (V | 0) != 0 | 0;
            V = (k | 0) != 0 | 0;
            L = (T & 255) - 1 | 0;
            z = o | 0;
            O = r | 0;
            N = p | 0;
            M = s + 5749 | 0;
            A = f + 32 | 0;
            K = v ? 42 : 43;
            u = (k | 0) > 0;
            y = s + 10408 | 0;
            J = s + 10412 | 0;
            I = s + 10416 | 0;
            B = s + 10400 | 0;
            E = s + 5750 | 0;
            D = s + 5936 | 0;
            W = s + 5755 | 0;
            X = f + 18588 + H | 0;
            H = s + 10428 | 0;
            Y = s + 10432 | 0;
            Z = s + 10436 | 0;
            _ = s + 10420 | 0;
            s = 0;
            $ = 0;
            aa = U;
            ba = 1;
            b: while (1) {
                ca = a[R + (aa << 1) | 0] | 0;
                da = a[R + (aa << 1) + 1 | 0] | 0;
                ea = (aa | 0) > 0;
                do {
                    if ((aa | 0) < (U | 0) & ea) {
                        fa = ca & 255;
                        ha = d[n + (((da & 255) << Q) + fa) | 0] | 0;
                        ia = ha & 1 | ha >>> 1;
                        if ((ud(t, (c[C >> 2] | 0) + ((v ? ia : ia + 2 | 0) + 61) | 0) | 0) == 0) {
                            ja = ba;
                            ka = $;
                            la = s
                        } else {
                            ma = 1;
                            na = fa;
                            F = 69
                        }
                    } else {
                        if (!((aa | 0) == 0 | (aa | 0) == (U | 0))) {
                            ja = ba;
                            ka = $;
                            la = s;
                            break
                        }
                        ma = 0;
                        na = ca & 255;
                        F = 69
                    }
                } while (0);
                do {
                    if ((F | 0) == 69) {
                        F = 0;
                        if (!(ca << 24 >> 24 == 0)) {
                            fa = n + (na - 1 + ((da & 255) << Q)) | 0;
                            a[fa] = a[fa] | 1
                        }
                        fa = da & 255;
                        if (!(da << 24 >> 24 == 0)) {
                            ia = n + ((fa - 1 << Q) + na) | 0;
                            a[ia] = a[ia] | 2
                        }
                        ia = na << 2;
                        ha = fa << 2;
                        oa = c[31064 + (Q << 6) + (V << 5) + (x << 4) + (d[n + ((fa << Q) + na) | 0] << 2) >> 2] | 0;
                        fa = (aa | 0) == (U | 0);
                        pa = fa ? L : 15;
                        if (fa) {
                            b[z >> 1] = 1;
                            a[O] = 1;
                            a[N] = T;
                            qa = 1
                        } else { qa = 0 }
                        if ((pa | 0) > 0) {
                            fa = qa;
                            ra = pa;
                            sa = ma;
                            while (1) {
                                ta = (d[S + (ra << 1) | 0] | 0) + ia | 0;
                                ua = (d[S + (ra << 1) + 1 | 0] | 0) + ha | 0;
                                do { if ((a[M] | 0) == 0) { F = 79 } else { if ((a[A] | 0) != 0) { va = K; break } if ((a[G] | 0) == 0) { F = 79 } else { va = K } } } while (0);
                                if ((F | 0) == 79) {
                                    F = 0;
                                    va = a[oa + (ta + (ua << j)) | 0] | 0
                                }
                                if ((ud(t, (c[C >> 2] | 0) + ((va & 255) + 65) | 0) | 0) == 0) {
                                    wa = sa;
                                    xa = fa
                                } else {
                                    b[o + (fa << 1) >> 1] = 1;
                                    a[r + fa | 0] = 1;
                                    a[p + fa | 0] = ra;
                                    wa = 0;
                                    xa = fa + 1 | 0
                                }
                                ya = ra - 1 | 0;
                                if ((ya | 0) > 0) {
                                    fa = xa;
                                    ra = ya;
                                    sa = wa
                                } else {
                                    za = xa;
                                    Aa = wa;
                                    break
                                }
                            }
                        } else {
                            za = qa;
                            Aa = ma
                        }
                        do {
                            if ((pa | 0) > -1) {
                                if ((Aa | 0) != 0) {
                                    b[o + (za << 1) >> 1] = 1;
                                    a[r + za | 0] = 1;
                                    a[p + za | 0] = 0;
                                    Ba = za + 1 | 0;
                                    break
                                }
                                do { if ((a[M] | 0) == 0) { F = 88 } else { if ((a[A] | 0) != 0) { Ca = K; break } if ((a[G] | 0) == 0) { F = 88 } else { Ca = K } } } while (0);
                                if ((F | 0) == 88) {
                                    F = 0;
                                    Ca = a[oa + ((ha << j) + ia) | 0] | 0
                                }
                                if ((ud(t, (c[C >> 2] | 0) + ((Ca & 255) + 65) | 0) | 0) == 0) { Ba = za; break }
                                b[o + (za << 1) >> 1] = 1;
                                a[r + za | 0] = 1;
                                a[p + za | 0] = 0;
                                Ba = za + 1 | 0
                            } else { Ba = za }
                        } while (0);
                        if ((Ba | 0) == 0) {
                            ja = ba;
                            ka = $;
                            la = s;
                            break
                        }
                        oa = ((aa | 0) == 0 | u ? 0 : 2) | (ba | 0) == 0;
                        pa = (Ba | 0) > 8 ? 8 : Ba;
                        do {
                            if ((pa | 0) > 0) {
                                ua = oa << 2;
                                ta = s;
                                sa = $;
                                ra = -1;
                                fa = 1;
                                ya = 0;
                                while (1) {
                                    do {
                                        if ((ya | 0) == 0) { Da = 1 } else {
                                            if ((ta | 0) <= 0) { Da = ta; break }
                                            Da = (sa | 0) == 1 ? 0 : ta + 1 | 0
                                        }
                                    } while (0);
                                    Ea = ((Da | 0) < 3 ? Da : 3) + ua | 0;
                                    Fa = ud(t, (c[C >> 2] | 0) + ((u ? Ea + 16 | 0 : Ea) + 109) | 0) | 0;
                                    if ((Fa | 0) == 0) {
                                        a[r + ya | 0] = 0;
                                        Ga = ((fa - 1 | 0) >>> 0 < 2 >>> 0) + fa | 0;
                                        Ha = ra
                                    } else {
                                        Ea = o + (ya << 1) | 0;
                                        b[Ea >> 1] = (b[Ea >> 1] | 0) + 1;
                                        Ga = 0;
                                        Ha = (ra | 0) == -1 ? ya : ra
                                    }
                                    Ea = ya + 1 | 0;
                                    if ((Ea | 0) < (pa | 0)) {
                                        ta = Da;
                                        sa = Fa;
                                        ra = Ha;
                                        fa = Ga;
                                        ya = Ea
                                    } else { break }
                                }
                                if ((Ha | 0) == -1) {
                                    Ia = Ga;
                                    Ja = Fa;
                                    Ka = Da;
                                    break
                                }
                                ya = ud(t, (c[C >> 2] | 0) + ((u ? oa | 4 : oa) + 133) | 0) | 0;
                                fa = o + (Ha << 1) | 0;
                                b[fa >> 1] = (e[fa >> 1] | 0) + ya;
                                a[r + Ha | 0] = ya;
                                Ia = Ga;
                                Ja = Fa;
                                Ka = Da
                            } else {
                                Ia = 1;
                                Ja = $;
                                Ka = s
                            }
                        } while (0);
                        if (v) {
                            oa = c[y >> 2] | 0;
                            pa = g >> oa;
                            ya = h >> oa;
                            if (!((pa | 0) > -1)) { F = 107; break b }
                            oa = c[J >> 2] | 0;
                            if ((pa | 0) >= (oa | 0)) { F = 107; break b }
                            if (!((ya | 0) > -1)) { F = 110; break b }
                            if ((ya | 0) >= (c[I >> 2] | 0)) { F = 110; break b }
                            fa = (ga(oa, ya) | 0) + pa | 0;
                            La = d[(c[B >> 2] | 0) + fa | 0] | 0
                        } else {
                            fa = c[H >> 2] | 0;
                            pa = g >> fa;
                            ya = h >> fa;
                            if (!((pa | 0) > -1)) { F = 114; break b }
                            fa = c[Y >> 2] | 0;
                            if ((pa | 0) >= (fa | 0)) { F = 114; break b }
                            if (!((ya | 0) > -1)) { F = 117; break b }
                            if ((ya | 0) >= (c[Z >> 2] | 0)) { F = 117; break b }
                            oa = (ga(fa, ya) | 0) + pa | 0;
                            La = a[(c[_ >> 2] | 0) + oa | 0] & 63
                        }
                        c: do {
                            if ((a[A] | 0) == 0) {
                                do { if (P) { if ((a[E] | 0) == 0) { break } if ((a[G] | 0) == 0) { break } if ((La & 239 | 0) == 10) { Ma = 0; break c } } } while (0);
                                if ((a[w] | 0) != 0) { Ma = 0; break }
                                Ma = ((a[N] | 0) - (a[p + (Ba - 1) | 0] | 0) | 0) > 3 | 0
                            } else { Ma = 0 }
                        } while (0);
                        oa = Ba - 1 | 0;
                        if ((oa | 0) > 0) {
                            pa = 0;
                            do {
                                ya = (wd(t) | 0) & 255;
                                a[q + pa | 0] = ya;
                                pa = pa + 1 | 0;
                            } while ((pa | 0) < (oa | 0))
                        }
                        pa = (Ma | 0) == 0;
                        if ((a[D] | 0) == 0 | pa) {
                            ya = (wd(t) | 0) & 255;
                            a[q + oa | 0] = ya
                        } else { a[q + oa | 0] = 0 }
                        if ((a[W] | 0) == 0) { Na = 0 } else { Na = (d[X] | 0) >>> 2 }
                        if ((Ba | 0) > 0) {
                            Oa = 0;
                            Pa = Na;
                            Qa = 1;
                            Ra = 0
                        } else {
                            ja = Ia;
                            ka = Ja;
                            la = Ka;
                            break
                        }
                        while (1) {
                            ya = b[o + (Ra << 1) >> 1] | 0;
                            do {
                                if ((a[r + Ra | 0] | 0) == 0) {
                                    Sa = 0;
                                    Ta = Qa;
                                    Ua = Pa
                                } else {
                                    fa = -1;
                                    while (1) {
                                        Va = fa + 1 | 0;
                                        ra = wd(t) | 0;
                                        if ((fa | 0) > 63) { Wa = 0; break }
                                        if ((ra | 0) == 0) { F = 137; break } else { fa = Va }
                                    }
                                    do {
                                        if ((F | 0) == 137) {
                                            F = 0;
                                            if ((Va | 0) < 4) { Wa = (yd(t, Pa) | 0) + (Va << Pa) | 0; break } else {
                                                ra = fa - 2 | 0;
                                                Wa = (yd(t, ra + Pa | 0) | 0) + ((1 << ra) + 2 << Pa) | 0;
                                                break
                                            }
                                        }
                                    } while (0);
                                    fa = (a[W] | 0) == 0;
                                    ra = (Wa + ya | 0) > (3 << Pa | 0);
                                    if (fa) {
                                        if (!ra) {
                                            Sa = Wa;
                                            Ta = 0;
                                            Ua = Pa;
                                            break
                                        }
                                        sa = Pa + 1 | 0;
                                        Sa = Wa;
                                        Ta = 0;
                                        Ua = (sa | 0) > 4 ? 4 : sa;
                                        break
                                    }
                                    sa = (ra & 1) + Pa | 0;
                                    if (fa | Qa ^ 1) {
                                        Sa = Wa;
                                        Ta = 0;
                                        Ua = sa;
                                        break
                                    }
                                    fa = a[X] | 0;
                                    ra = (fa & 255) >>> 2;
                                    if ((Wa | 0) >= (3 << ra | 0)) {
                                        a[X] = fa + 1;
                                        Sa = Wa;
                                        Ta = 0;
                                        Ua = sa;
                                        break
                                    }
                                    if ((Wa << 1 | 0) >= (1 << ra | 0) | fa << 24 >> 24 == 0) {
                                        Sa = Wa;
                                        Ta = 0;
                                        Ua = sa;
                                        break
                                    }
                                    a[X] = fa - 1;
                                    Sa = Wa;
                                    Ta = 0;
                                    Ua = sa
                                }
                            } while (0);
                            sa = Sa + ya | 0;
                            fa = sa & 65535;
                            ra = (a[q + Ra | 0] | 0) == 0 ? fa : -fa & 65535;
                            do {
                                if ((a[D] | 0) == 0 | pa) {
                                    Xa = ra;
                                    Ya = Oa
                                } else {
                                    fa = sa + Oa | 0;
                                    if ((Ra | 0) != (oa | 0)) {
                                        Xa = ra;
                                        Ya = fa;
                                        break
                                    }
                                    Xa = (fa & 1 | 0) == 0 ? ra : -ra & 65535;
                                    Ya = fa
                                }
                            } while (0);
                            ra = a[p + Ra | 0] | 0;
                            sa = (d[S + (ra << 1) | 0] | 0) + ia | 0;
                            ya = (d[S + (ra << 1) + 1 | 0] | 0) + ha | 0;
                            b[f + 2116 + (k << 11) + (b[m >> 1] << 1) >> 1] = Xa;
                            b[f + 8260 + (k << 11) + (b[m >> 1] << 1) >> 1] = sa + (ya << j);
                            b[m >> 1] = (b[m >> 1] | 0) + 1;
                            ya = Ra + 1 | 0;
                            if ((ya | 0) < (Ba | 0)) {
                                Oa = Ya;
                                Pa = Ua;
                                Qa = Ta;
                                Ra = ya
                            } else {
                                ja = Ia;
                                ka = Ja;
                                la = Ka;
                                break
                            }
                        }
                    }
                } while (0);
                if (ea) {
                    s = la;
                    $ = ka;
                    aa = aa - 1 | 0;
                    ba = ja
                } else { F = 153; break }
            }
            if ((F | 0) == 107) { ec(1024, 904, 118, 17320); return 0 } else if ((F | 0) == 110) { ec(816, 904, 119, 17320); return 0 } else if ((F | 0) == 114) { ec(1024, 904, 118, 17320); return 0 } else if ((F | 0) == 117) { ec(816, 904, 119, 17320); return 0 } else if ((F | 0) == 153) { i = l; return 0 }
            return 0
        }

        function Sj(b, e, f, g, h, i, j, k, l, m, n, o, p) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            var q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0;
            if ((o | 0) == -1) { ec(1560, 14776, 3547, 18792); return 0 }
            if ((p | 0) == -1) { ec(1424, 14776, 3548, 18792); return 0 }
            if ((n | 0) == -1) { ec(1392, 14776, 3549, 18792); return 0 }
            l = b + 18596 | 0;
            q = c[l >> 2] | 0;
            r = c[q + 5776 >> 2] | 0;
            s = (r | 0) == 3;
            t = ((s ^ 1) << 31 >> 31) + k | 0;
            u = (t | 0) < 2 ? 2 : t;
            t = b + 33 | 0;
            C = 0;
            a[t] = C;
            C = C >> 8;
            a[t + 1 | 0] = C;
            C = C >> 8;
            a[t + 2 | 0] = C;
            C = C >> 8;
            a[t + 3 | 0] = C;
            t = c[q + 10368 >> 2] | 0;
            v = e >> t;
            w = f >> t;
            if (!((v | 0) > -1)) { ec(1024, 904, 118, 17320); return 0 }
            t = c[q + 10372 >> 2] | 0;
            if ((v | 0) >= (t | 0)) { ec(1024, 904, 118, 17320); return 0 }
            if (!((w | 0) > -1)) { ec(816, 904, 119, 17320); return 0 }
            if ((w | 0) >= (c[q + 10376 >> 2] | 0)) { ec(816, 904, 119, 17320); return 0 }
            x = (ga(t, w) | 0) + v | 0;
            v = (c[q + 10360 >> 2] | 0) + (x * 3 | 0) | 0;
            x = ((d[v] | d[v + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 8 & 3;
            v = x & 255;
            w = (n | 0) != 0;
            n = w ^ 1;
            t = (p | o | 0) == 0;
            do {
                if (!(t & n)) {
                    do {
                        if ((a[q + 5946 | 0] | 0) == 0) { y = 0 } else {
                            z = b + 18508 | 0;
                            if ((c[z >> 2] | 0) != 0) { y = 0; break }
                            A = b + 18556 | 0;
                            B = b + 18580 | 0;
                            do {
                                if ((ud(A, (c[B >> 2] | 0) + 139 | 0) | 0) == 0) {
                                    D = 0;
                                    E = 0
                                } else {
                                    F = 1;
                                    G = 0;
                                    while (1) {
                                        if ((ud(A, (c[B >> 2] | 0) + 140 | 0) | 0) == 0) { H = F; break }
                                        I = F + 1 | 0;
                                        J = G + 1 | 0;
                                        if ((J | 0) < 4) {
                                            F = I;
                                            G = J
                                        } else { H = I; break }
                                    }
                                    if ((H | 0) == 5) { K = (zd(A, 0) | 0) + 5 | 0 } else { K = H }
                                    if ((K | 0) == 0) {
                                        D = 0;
                                        E = 0;
                                        break
                                    }
                                    D = (wd(A) | 0) << 1;
                                    E = K
                                }
                            } while (0);
                            c[z >> 2] = 1;
                            A = ga(1 - D | 0, E) | 0;
                            c[b + 18512 >> 2] = A;
                            y = 1
                        }
                    } while (0);
                    do {
                        if ((a[(c[b + 18600 >> 2] | 0) + 752 | 0] | 0) == 0 | t) { L = 32 } else {
                            if ((a[b + 32 | 0] | 0) != 0) { L = 32; break }
                            A = b + 18516 | 0;
                            if ((c[A >> 2] | 0) != 0) { L = 32; break }
                            B = b + 18556 | 0;
                            G = b + 18580 | 0;
                            F = ud(B, (c[G >> 2] | 0) + 23 | 0) | 0;
                            I = c[l >> 2] | 0;
                            if ((F | 0) == 0) {
                                c[A >> 2] = 1;
                                c[b + 18520 >> 2] = 0;
                                c[b + 18524 >> 2] = 0;
                                break
                            }
                            if ((d[I + 10074 | 0] | 0) >>> 0 > 1 >>> 0) { M = ud(B, (c[G >> 2] | 0) + 24 | 0) | 0 } else { M = 0 }
                            c[A >> 2] = 1;
                            c[b + 18520 >> 2] = a[I + 10075 + M | 0] | 0;
                            c[b + 18524 >> 2] = a[I + 10081 + M | 0] | 0
                        }
                    } while (0);
                    if ((L | 0) == 32) { if (!y) { break } }
                    Qk(b, e, f, i, j)
                }
            } while (0);
            y = 1 << k;
            M = 1 << u;
            t = c[l >> 2] | 0;
            E = c[t + 5780 >> 2] | 0;
            D = c[t + 5784 >> 2] | 0;
            t = b + 28 | 0;
            c[t >> 2] = 0;
            if (w) { Rj(b, e, f, k, 0) | 0 }
            Tj(b, e, f, i, j, y, 0, v, w);
            if (!((k | 0) > 2 | s)) {
                if ((m | 0) != 3) { return 0 }
                m = (o & 1 | 0) != 0;
                if (m) { Rj(b, g, h, k, 1) | 0 }
                if ((c[(c[l >> 2] | 0) + 5776 >> 2] | 0) != 0) { Tj(b, (g | 0) / (E | 0) | 0, (h | 0) / (D | 0) | 0, (i | 0) / (E | 0) | 0, (j | 0) / (D | 0) | 0, y, 1, v, m) }
                m = (o & 2 | 0) != 0;
                if (m) { Rj(b, g, y + h | 0, k, 1) | 0 }
                s = (r | 0) == 2;
                if (s) { Tj(b, (g | 0) / (E | 0) | 0, ((h | 0) / (D | 0) | 0) + y | 0, (i | 0) / (E | 0) | 0, (j | 0) / (D | 0) | 0, y, 1, v, m) }
                m = (p & 1 | 0) != 0;
                if (m) { Rj(b, g, h, k, 2) | 0 }
                if ((c[(c[l >> 2] | 0) + 5776 >> 2] | 0) != 0) { Tj(b, (g | 0) / (E | 0) | 0, (h | 0) / (D | 0) | 0, (i | 0) / (E | 0) | 0, (j | 0) / (D | 0) | 0, y, 2, v, m) }
                m = (p & 2 | 0) != 0;
                if (m) { Rj(b, g, M + h | 0, k, 2) | 0 }
                if (!s) { return 0 }
                Tj(b, (g | 0) / (E | 0) | 0, ((h | 0) / (D | 0) | 0) + y | 0, (i | 0) / (E | 0) | 0, (j | 0) / (D | 0) | 0, y, 2, v, m);
                return 0
            }
            m = c[l >> 2] | 0;
            a: do {
                if ((a[m + 10071 | 0] | 0) == 0 | n) {
                    N = 0;
                    O = 0
                } else {
                    do {
                        if (!(x << 24 >> 24 == 1)) {
                            y = c[m + 10428 >> 2] | 0;
                            h = e >> y;
                            g = f >> y;
                            if (!((h | 0) > -1)) { ec(1024, 904, 118, 17320); return 0 }
                            y = c[m + 10432 >> 2] | 0;
                            if ((h | 0) >= (y | 0)) { ec(1024, 904, 118, 17320); return 0 }
                            if (!((g | 0) > -1)) { ec(816, 904, 119, 17320); return 0 }
                            if ((g | 0) < (c[m + 10436 >> 2] | 0)) {
                                s = (ga(y, g) | 0) + h | 0;
                                if ((a[(c[m + 10420 >> 2] | 0) + s | 0] | 0) < 0) { break } else {
                                    N = 0;
                                    O = 0;
                                    break a
                                }
                            } else { ec(816, 904, 119, 17320); return 0 }
                        }
                    } while (0);
                    s = b + 18556 | 0;
                    h = b + 18580 | 0;
                    g = 0;
                    while (1) {
                        if ((ud(s, (c[h >> 2] | 0) + (g + 162) | 0) | 0) == 0) { L = 49; break }
                        y = g + 1 | 0;
                        if ((y | 0) < 4) { g = y } else { P = y; break }
                    }
                    if ((L | 0) == 49) {
                        if ((g | 0) == 0) {
                            N = 1;
                            O = 0;
                            break
                        } else { P = g }
                    }
                    N = 1;
                    O = 1 - ((ud(s, (c[h >> 2] | 0) + 170 | 0) | 0) << 1) << P - 1
                }
            } while (0);
            c[t >> 2] = O;
            O = (o & 1 | 0) != 0;
            if (O) { Rj(b, e, f, u, 1) | 0 }
            if ((c[(c[l >> 2] | 0) + 5776 >> 2] | 0) != 0) { Tj(b, (e | 0) / (E | 0) | 0, (f | 0) / (D | 0) | 0, (i | 0) / (E | 0) | 0, (j | 0) / (D | 0) | 0, M, 1, v, O) }
            O = (r | 0) == 2;
            if (O) {
                r = (o & 2 | 0) != 0;
                if (r) { Rj(b, e, (D << u) + f | 0, u, 1) | 0 }
                Tj(b, (e | 0) / (E | 0) | 0, ((f | 0) / (D | 0) | 0) + M | 0, (i | 0) / (E | 0) | 0, ((j | 0) / (D | 0) | 0) + M | 0, M, 1, v, r)
            }
            do {
                if (N) {
                    r = b + 18556 | 0;
                    o = b + 18580 | 0;
                    P = 0;
                    while (1) {
                        if ((ud(r, (c[o >> 2] | 0) + (P + 166) | 0) | 0) == 0) { L = 63; break }
                        m = P + 1 | 0;
                        if ((m | 0) < 4) { P = m } else { Q = m; break }
                    }
                    if ((L | 0) == 63) { if ((P | 0) == 0) { R = 0; break } else { Q = P } }
                    R = 1 - ((ud(r, (c[o >> 2] | 0) + 171 | 0) | 0) << 1) << Q - 1
                } else { R = 0 }
            } while (0);
            c[t >> 2] = R;
            R = (p & 1 | 0) != 0;
            if (R) { Rj(b, e, f, u, 2) | 0 }
            if ((c[(c[l >> 2] | 0) + 5776 >> 2] | 0) != 0) { Tj(b, (e | 0) / (E | 0) | 0, (f | 0) / (D | 0) | 0, (i | 0) / (E | 0) | 0, (j | 0) / (D | 0) | 0, M, 2, v, R) }
            if (!O) { return 0 }
            O = (p & 2 | 0) != 0;
            if (O) { Rj(b, e, (D << u) + f | 0, u, 2) | 0 }
            Tj(b, (e | 0) / (E | 0) | 0, ((f | 0) / (D | 0) | 0) + M | 0, (i | 0) / (E | 0) | 0, ((j | 0) / (D | 0) | 0) + M | 0, M, 2, v, O);
            return 0
        }

        function Tj(e, f, g, h, i, j, k, l, m) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            n = e + 18596 | 0;
            o = c[n >> 2] | 0;
            p = (l | 0) == 0;
            do {
                if (p) {
                    do {
                        if ((k | 0) == 0) {
                            l = c[o + 10408 >> 2] | 0;
                            q = f >> l;
                            r = g >> l;
                            if (!((q | 0) > -1)) { ec(1024, 904, 118, 17320) }
                            l = c[o + 10412 >> 2] | 0;
                            if ((q | 0) >= (l | 0)) { ec(1024, 904, 118, 17320) }
                            if (!((r | 0) > -1)) { ec(816, 904, 119, 17320) }
                            if ((r | 0) < (c[o + 10416 >> 2] | 0)) {
                                s = (ga(l, r) | 0) + q | 0;
                                t = d[(c[o + 10400 >> 2] | 0) + s | 0] | 0;
                                break
                            } else { ec(816, 904, 119, 17320) }
                        } else {
                            s = ga(c[o + 5780 >> 2] | 0, f) | 0;
                            q = ga(c[o + 5784 >> 2] | 0, g) | 0;
                            r = c[o + 10428 >> 2] | 0;
                            l = s >> r;
                            s = q >> r;
                            if (!((l | 0) > -1)) { ec(1024, 904, 118, 17320) }
                            r = c[o + 10432 >> 2] | 0;
                            if ((l | 0) >= (r | 0)) { ec(1024, 904, 118, 17320) }
                            if (!((s | 0) > -1)) { ec(816, 904, 119, 17320) }
                            if ((s | 0) < (c[o + 10436 >> 2] | 0)) {
                                q = (ga(r, s) | 0) + l | 0;
                                t = a[(c[o + 10420 >> 2] | 0) + q | 0] & 63;
                                break
                            } else { ec(816, 904, 119, 17320) }
                        }
                    } while (0);
                    q = t >>> 0 > 34 >>> 0 ? 1 : t;
                    fi(o, f, g, q, j, k);
                    do {
                        if ((a[(c[n >> 2] | 0) + 5750 | 0] | 0) == 0) { u = 0 } else {
                            if ((a[e + 32 | 0] | 0) == 0) { if ((a[e + 33 + k | 0] | 0) == 0) { u = 0; break } }
                            u = (q & 239 | 0) == 10
                        }
                    } while (0);
                    v = u & (q | 0) == 26 ? 2 : u & 1
                } else {
                    if ((a[e + 36 | 0] | 0) == 0) { v = 0; break }
                    v = (a[e + 37 | 0] | 0) != 0 ? 2 : 1
                }
            } while (0);
            if (m) { Rk(e, f, g, h, i, j, k, (a[e + 33 + k | 0] | 0) != 0, p, v); return }
            if ((k | 0) == 0) { return }
            if ((c[e + 28 >> 2] | 0) == 0) { return }
            b[e + 14404 + (k << 1) >> 1] = 0;
            Rk(e, f, g, h, i, j, k, (a[e + 33 + k | 0] | 0) != 0, p, 0);
            return
        }

        function Uj(b, e, f, g, h, i, j, k, l, m, n, o, p, q, r) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            r = r | 0;
            var s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0;
            s = b + 18596 | 0;
            t = c[s >> 2] | 0;
            u = c[t + 10368 >> 2] | 0;
            v = e >> u;
            if (!((v | 0) > -1)) { ec(1024, 904, 118, 17320) }
            w = (o | 0) == 1;
            x = b + 18556 | 0;
            y = b + 18580 | 0;
            z = (o | 0) != 0;
            A = e;
            e = f;
            B = g;
            g = h;
            h = k;
            k = l;
            l = m;
            m = q;
            q = r;
            r = t;
            t = v;
            v = f >> u;
            f = u;
            a: while (1) {
                u = c[r + 10372 >> 2] | 0;
                if ((t | 0) >= (u | 0)) { C = 4; break }
                if (!((v | 0) > -1)) { C = 7; break }
                D = c[r + 10376 >> 2] | 0;
                if ((v | 0) >= (D | 0)) { C = 7; break }
                E = (ga(u, v) | 0) + t | 0;
                F = c[r + 10360 >> 2] | 0;
                G = F + (E * 3 | 0) | 0;
                H = ((d[G] | d[G + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 8 & 3;
                if ((H & 255 | 0) != (p | 0)) { C = 9; break }
                G = (c[r + 5868 >> 2] | 0) < (h | 0);
                do {
                    if (G) { C = 15 } else {
                        if ((k | 0) >= (n | 0) | (c[r + 5864 >> 2] | 0) >= (h | 0) | z & (k | 0) == 0) { C = 15; break }
                        E = 5 - h | 0;
                        if (!(E >>> 0 < 3 >>> 0)) { C = 13; break a }
                        I = ud(x, (c[y >> 2] | 0) + (E + 20) | 0) | 0;
                        C = 21
                    }
                } while (0);
                do {
                    if ((C | 0) == 15) {
                        C = 0;
                        E = A >> f;
                        J = e >> f;
                        if (!((E | 0) > -1 & (E | 0) < (u | 0))) { C = 16; break a }
                        if (!((J | 0) > -1 & (J | 0) < (D | 0))) { C = 18; break a }
                        if (G) { C = 22; break }
                        K = F + (((ga(u, J) | 0) + E | 0) * 3 | 0) | 0;
                        E = K;
                        I = (w & (k | 0) == 0 | (c[r + 1392 >> 2] | k | 0) == 0 & H << 24 >> 24 == 1 & ((d[E] | d[E + 1 | 0] << 8) << 16 >> 16 & 56) != 0) & 1;
                        C = 21
                    }
                } while (0);
                if ((C | 0) == 21) { C = 0; if ((I | 0) == 0) { L = 0 } else { C = 22 } }
                if ((C | 0) == 22) {
                    C = 0;
                    u = c[r + 10448 >> 2] | 0;
                    F = A >> u;
                    G = e >> u;
                    if (!((F | 0) > -1)) { C = 24; break }
                    u = c[r + 10452 >> 2] | 0;
                    if ((F | 0) >= (u | 0)) { C = 24; break }
                    if (!((G | 0) > -1)) { C = 27; break }
                    if ((G | 0) >= (c[r + 10456 >> 2] | 0)) { C = 27; break }
                    D = (ga(u, G) | 0) + F | 0;
                    F = (c[r + 10440 >> 2] | 0) + D | 0;
                    a[F] = d[F] | 0 | 1 << k;
                    L = 1
                }
                F = c[r + 5776 >> 2] | 0;
                if ((h | 0) > 2) {
                    if ((F | 0) == 0) {
                        M = -1;
                        C = 41
                    } else { C = 32 }
                } else {
                    if ((F | 0) == 3) { C = 32 } else {
                        M = -1;
                        C = 41
                    }
                }
                if ((C | 0) == 32) {
                    C = 0;
                    do {
                        if (m << 24 >> 24 == 0) { N = -1 } else {
                            F = k + 16 | 0;
                            D = ud(x, (c[y >> 2] | 0) + F | 0) | 0;
                            if ((c[r + 5776 >> 2] | 0) != 2) { N = D; break }
                            if (!((h | 0) == 3 | L ^ 1)) { N = D; break }
                            N = (ud(x, (c[y >> 2] | 0) + F | 0) | 0) << 1 | D
                        }
                    } while (0);
                    do {
                        if (q << 24 >> 24 == 0) { O = -1 } else {
                            D = k + 16 | 0;
                            F = ud(x, (c[y >> 2] | 0) + D | 0) | 0;
                            if ((c[r + 5776 >> 2] | 0) != 2) { O = F; break }
                            if (!((h | 0) == 3 | L ^ 1)) { O = F; break }
                            O = (ud(x, (c[y >> 2] | 0) + D | 0) | 0) << 1 | F
                        }
                    } while (0);
                    if ((N | 0) < 0) {
                        M = O;
                        C = 41
                    } else {
                        P = N;
                        Q = O
                    }
                }
                if ((C | 0) == 41) {
                    C = 0;
                    F = (h | 0) == 2;
                    if ((k | 0) == 0 & F) { C = 42; break }
                    P = (k | 0) > 0 & F ? m & 255 : 0;
                    Q = M
                }
                if ((Q | 0) < 0) { R = (k | 0) > 0 & (h | 0) == 2 ? q & 255 : 0 } else { R = Q }
                if (!L) { C = 48; break }
                F = h - 1 | 0;
                D = 1 << F;
                G = D + A | 0;
                u = D + e | 0;
                D = k + 1 | 0;
                E = P & 255;
                K = R & 255;
                Uj(b, A, e, A, e, i, j, F, D, 0, n, o, p, E, K);
                Uj(b, G, e, A, e, i, j, F, D, 1, n, o, p, E, K);
                Uj(b, A, u, A, e, i, j, F, D, 2, n, o, p, E, K);
                J = c[s >> 2] | 0;
                S = c[J + 10368 >> 2] | 0;
                T = G >> S;
                if ((T | 0) > -1) {
                    B = A;
                    A = G;
                    g = e;
                    e = u;
                    h = F;
                    k = D;
                    l = 3;
                    m = E;
                    q = K;
                    r = J;
                    t = T;
                    v = u >> S;
                    f = S
                } else { C = 4; break }
            }
            if ((C | 0) == 4) { ec(1024, 904, 118, 17320) } else if ((C | 0) == 7) { ec(816, 904, 119, 17320) } else if ((C | 0) == 9) { ec(1368, 14776, 3827, 18816) } else if ((C | 0) == 13) { ec(416, 14776, 1820, 17880) } else if ((C | 0) == 16) { ec(1024, 904, 118, 17320) } else if ((C | 0) == 18) { ec(816, 904, 119, 17320) } else if ((C | 0) == 24) { ec(1024, 904, 128, 17320) } else if ((C | 0) == 27) { ec(816, 904, 129, 17320) } else if ((C | 0) == 42) { ec(1320, 14776, 3894, 18816) } else if ((C | 0) == 48) {
                C = (k | 0) == 0;
                if (H << 24 >> 24 != 0 & C & (P | 0) == 0 & (R | 0) == 0) {
                    U = 1;
                    V = Sj(b, A, e, B, g, i, j, h, 0, l, U, P, R) | 0;
                    return
                }
                U = ud(x, (c[y >> 2] | 0) + (C & 1 | 14) | 0) | 0;
                V = Sj(b, A, e, B, g, i, j, h, 0, l, U, P, R) | 0;
                return
            }
        }

        function Vj(a, d, e, f) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            e = a + 18556 | 0;
            d = a + 18580 | 0;
            g = ud(e, (c[d >> 2] | 0) + 150 | 0) | 0;
            h = ud(e, (c[d >> 2] | 0) + 150 | 0) | 0;
            i = (g | 0) == 0;
            if (i) { j = 0 } else { j = ud(e, (c[d >> 2] | 0) + 151 | 0) | 0 }
            g = (h | 0) == 0;
            if (g) { k = 0 } else { k = ud(e, (c[d >> 2] | 0) + 151 | 0) | 0 }
            do {
                if (i) { l = 0 } else {
                    if ((j | 0) == 0) { m = -1 } else { m = zd(e, 1) | 0 }
                    if ((wd(e) | 0) == 0) { l = m + 2 & 65535; break }
                    l = -2 - m & 65535
                }
            } while (0);
            do {
                if (g) { n = 0 } else {
                    if ((k | 0) == 0) { o = -1 } else { o = zd(e, 1) | 0 }
                    if ((wd(e) | 0) == 0) { n = o + 2 & 65535; break }
                    n = -2 - o & 65535
                }
            } while (0);
            b[a + 18 + (f << 2) >> 1] = l;
            b[a + 18 + (f << 2) + 2 >> 1] = n;
            return
        }

        function Wj(d, e, f, g, h, i, j, k, l, m) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0;
            n = d + 18600 | 0;
            o = c[n >> 2] | 0;
            p = d + 18556 | 0;
            q = d + 18580 | 0;
            r = ud(p, (c[q >> 2] | 0) + 147 | 0) | 0;
            s = d + 16 | 0;
            t = d + 26 | 0;
            u = (r & 255) << 4 & 16 | a[t] & -17;
            a[t] = u;
            if ((r | 0) != 0) { a: do { if ((c[(c[n >> 2] | 0) + 804 >> 2] | 0) < 2) { v = 0 } else { if ((ud(p, (c[q >> 2] | 0) + 148 | 0) | 0) == 0) { v = 0; break } if (((c[(c[n >> 2] | 0) + 804 >> 2] | 0) - 1 | 0) > 1) { w = 1 } else { v = 1; break } while (1) { r = w + 1 | 0; if ((wd(p) | 0) == 0) { v = w & 255; break a } if ((r | 0) < ((c[(c[n >> 2] | 0) + 804 >> 2] | 0) - 1 | 0)) { w = r } else { v = r & 255; break } } } } while (0);a[t] = a[t] & 31 | v << 5;x = d + 18592 | 0;y = c[x >> 2] | 0;z = y | 0;A = c[n >> 2] | 0;B = d + 18596 | 0;C = c[B >> 2] | 0;Ii(z, A, C, s, e, f, g, h, l, i, j, m); return }
            if ((c[o + 20 >> 2] | 0) == 0) {
                v = c[q >> 2] | 0;
                do {
                    if ((j + i | 0) == 12) { D = ud(p, v + 160 | 0) | 0 } else {
                        if ((ud(p, v + (k + 156) | 0) | 0) != 0) { D = 2; break }
                        D = ud(p, v + 160 | 0) | 0
                    }
                } while (0);
                v = D + 1 | 0;
                a[t] = a[t] & -4 | v & 3;
                if ((v | 0) == 2) { E = 2 } else {
                    F = v;
                    G = 15
                }
            } else {
                a[t] = u & -4 | 1;
                F = 1;
                G = 15
            }
            do {
                if ((G | 0) == 15) {
                    u = (c[o + 328 >> 2] | 0) - 1 | 0;
                    b: do {
                        if ((u | 0) == 0) { H = 0 } else {
                            if ((ud(p, (c[q >> 2] | 0) + 154 | 0) | 0) == 0) { H = 0; break }
                            v = u & 255;
                            D = 0;
                            while (1) { k = D + 1 | 0; if ((k | 0) == (u | 0)) { H = v; break b } if ((D | 0) == 0) { I = ud(p, (c[q >> 2] | 0) + 155 | 0) | 0 } else { I = wd(p) | 0 } if ((I | 0) == 0) { H = k & 255; break } else { D = k } }
                        }
                    } while (0);
                    a[s | 0] = H;
                    Vj(d, 0, 0, 0);
                    u = (ud(p, (c[q >> 2] | 0) + 152 | 0) | 0) & 255;
                    a[t] = u << 2 & 4 | a[t] & -5;
                    if ((F | 0) != 1) { E = F; break }
                    x = d + 18592 | 0;
                    y = c[x >> 2] | 0;
                    z = y | 0;
                    A = c[n >> 2] | 0;
                    B = d + 18596 | 0;
                    C = c[B >> 2] | 0;
                    Ii(z, A, C, s, e, f, g, h, l, i, j, m);
                    return
                }
            } while (0);
            F = (c[o + 332 >> 2] | 0) - 1 | 0;
            c: do {
                if ((F | 0) == 0) { J = 0 } else {
                    if ((ud(p, (c[q >> 2] | 0) + 154 | 0) | 0) == 0) { J = 0; break }
                    H = F & 255;
                    I = 0;
                    while (1) { G = I + 1 | 0; if ((G | 0) == (F | 0)) { J = H; break c } if ((I | 0) == 0) { K = ud(p, (c[q >> 2] | 0) + 155 | 0) | 0 } else { K = wd(p) | 0 } if ((K | 0) == 0) { J = G & 255; break } else { I = G } }
                }
            } while (0);
            a[d + 17 | 0] = J;
            if ((a[o + 370 | 0] | 0) != 0 & (E | 0) == 3) {
                b[d + 22 >> 1] = 0;
                b[d + 24 >> 1] = 0
            } else { Vj(d, 0, 0, 1) }
            E = (ud(p, (c[q >> 2] | 0) + 152 | 0) | 0) & 255;
            a[t] = E << 3 & 8 | a[t] & -9;
            x = d + 18592 | 0;
            y = c[x >> 2] | 0;
            z = y | 0;
            A = c[n >> 2] | 0;
            B = d + 18596 | 0;
            C = c[B >> 2] | 0;
            Ii(z, A, C, s, e, f, g, h, l, i, j, m);
            return
        }

        function Xj(e, f, g, h, j) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0,
                Fa = 0,
                Ga = 0,
                Ha = 0;
            k = i;
            i = i + 88 | 0;
            l = k | 0;
            m = k + 24 | 0;
            n = k + 40 | 0;
            o = k + 56 | 0;
            p = k + 72 | 0;
            q = e + 18596 | 0;
            r = c[q >> 2] | 0;
            s = e + 18600 | 0;
            t = c[s >> 2] | 0;
            u = r + 10368 | 0;
            v = c[u >> 2] | 0;
            w = f >> v;
            x = g >> v;
            y = 1 << h - v;
            z = y + x | 0;
            if ((y | 0) > 0) {
                A = y + w | 0;
                y = r + 10372 | 0;
                B = r + 10360 | 0;
                D = x;
                do {
                    x = w;
                    do {
                        E = (ga(c[y >> 2] | 0, D) | 0) + x | 0;
                        F = (c[B >> 2] | 0) + (E * 3 | 0) | 0;
                        C = (d[F] | d[F + 1 | 0] << 8) << 16 >> 16 & -8;
                        a[F] = C;
                        C = C >> 8;
                        a[F + 1 | 0] = C;
                        x = x + 1 | 0;
                    } while ((x | 0) < (A | 0));
                    D = D + 1 | 0;
                } while ((D | 0) < (z | 0));
                G = c[u >> 2] | 0
            } else { G = v }
            v = f >> G;
            z = g >> G;
            if (!((v | 0) > -1)) { ec(1024, 904, 128, 17320) }
            G = r + 10372 | 0;
            D = c[G >> 2] | 0;
            if ((v | 0) >= (D | 0)) { ec(1024, 904, 128, 17320) }
            if (!((z | 0) > -1)) { ec(816, 904, 129, 17320) }
            A = r + 10376 | 0;
            if ((z | 0) >= (c[A >> 2] | 0)) { ec(816, 904, 129, 17320) }
            B = (ga(D, z) | 0) + v | 0;
            v = r + 10360 | 0;
            z = (c[v >> 2] | 0) + (B * 3 | 0) | 0;
            C = (d[z] | d[z + 1 | 0] << 8) << 16 >> 16 & -8 | h & 7;
            a[z] = C;
            C = C >> 8;
            a[z + 1 | 0] = C;
            z = c[r + 10448 >> 2] | 0;
            B = f >> z;
            D = g >> z;
            y = 1 << h - z;
            z = y + D | 0;
            if ((y | 0) > 0) {
                w = y + B | 0;
                y = r + 10452 | 0;
                x = r + 10440 | 0;
                F = D;
                do {
                    D = B;
                    do {
                        E = (ga(c[y >> 2] | 0, F) | 0) + D | 0;
                        a[(c[x >> 2] | 0) + E | 0] = 0;
                        D = D + 1 | 0;
                    } while ((D | 0) < (w | 0));
                    F = F + 1 | 0;
                } while ((F | 0) < (z | 0))
            }
            z = 1 << h;
            Qk(e, f, g, f, g);
            do {
                if ((a[r + 5964 | 0] | 0) == 0) { a[e + 32 | 0] = 0 } else {
                    F = ud(e + 18556 | 0, (c[e + 18580 >> 2] | 0) + 161 | 0) | 0;
                    a[e + 32 | 0] = F;
                    if ((F | 0) == 0) { break }
                    F = c[u >> 2] | 0;
                    w = f >> F;
                    x = g >> F;
                    y = 1 << h - F;
                    F = y + x | 0;
                    if ((y | 0) > 0) {
                        B = y + w | 0;
                        y = x;
                        do {
                            x = w;
                            do {
                                D = (ga(c[G >> 2] | 0, y) | 0) + x | 0;
                                E = (c[v >> 2] | 0) + (D * 3 | 0) | 0;
                                C = (d[E] | d[E + 1 | 0] << 8) << 16 >> 16 | 2048;
                                a[E] = C;
                                C = C >> 8;
                                a[E + 1 | 0] = C;
                                x = x + 1 | 0;
                            } while ((x | 0) < (B | 0));
                            y = y + 1 | 0;
                        } while ((y | 0) < (F | 0))
                    }
                    F = c[r + 10348 >> 2] | 0;
                    y = f >> F;
                    B = g >> F;
                    if (!((y | 0) > -1)) { ec(1024, 904, 128, 17320) }
                    F = c[r + 10352 >> 2] | 0;
                    if ((y | 0) >= (F | 0)) { ec(1024, 904, 128, 17320) }
                    if (!((B | 0) > -1)) { ec(816, 904, 129, 17320) }
                    if ((B | 0) < (c[r + 10356 >> 2] | 0)) {
                        w = (ga(F, B) | 0) + y | 0;
                        a[(c[r + 10340 >> 2] | 0) + (w * 24 | 0) + 22 | 0] = 1;
                        break
                    } else { ec(816, 904, 129, 17320) }
                }
            } while (0);
            w = t + 20 | 0;
            do {
                if ((c[w >> 2] | 0) == 2) { H = 0 } else {
                    t = c[q >> 2] | 0;
                    y = f - 1 | 0;
                    do {
                        if ((y | g | 0) < 0) { I = 0 } else {
                            if ((c[t + 1248 >> 2] | 0) <= (y | 0)) { I = 0; break }
                            if ((c[t + 1252 >> 2] | 0) <= (g | 0)) { I = 0; break }
                            B = c[t + 5804 >> 2] | 0;
                            F = ga(g >> B, c[t + 5820 >> 2] | 0) | 0;
                            x = F + (f >> B) | 0;
                            E = F + (y >> B) | 0;
                            B = c[t + 10340 >> 2] | 0;
                            if ((b[B + (x * 24 | 0) >> 1] | 0) != (b[B + (E * 24 | 0) >> 1] | 0)) { I = 0; break }
                            B = c[t + 10308 >> 2] | 0;
                            I = (c[B + (x << 2) >> 2] | 0) == (c[B + (E << 2) >> 2] | 0) | 0
                        }
                    } while (0);
                    E = g - 1 | 0;
                    do {
                        if ((E | f | 0) < 0) { J = 0 } else {
                            if ((c[t + 1248 >> 2] | 0) <= (f | 0)) { J = 0; break }
                            if ((c[t + 1252 >> 2] | 0) <= (E | 0)) { J = 0; break }
                            B = c[t + 5804 >> 2] | 0;
                            x = c[t + 5820 >> 2] | 0;
                            F = f >> B;
                            D = (ga(g >> B, x) | 0) + F | 0;
                            K = (ga(E >> B, x) | 0) + F | 0;
                            F = c[t + 10340 >> 2] | 0;
                            if ((b[F + (D * 24 | 0) >> 1] | 0) != (b[F + (K * 24 | 0) >> 1] | 0)) { J = 0; break }
                            F = c[t + 10308 >> 2] | 0;
                            J = (c[F + (D << 2) >> 2] | 0) == (c[F + (K << 2) >> 2] | 0) | 0
                        }
                    } while (0);
                    do {
                        if ((I | 0) == 0) { L = 5 } else {
                            K = c[t + 10368 >> 2] | 0;
                            F = y >> K;
                            D = g >> K;
                            if (!((F | 0) > -1)) { ec(1024, 904, 118, 17320) }
                            K = c[t + 10372 >> 2] | 0;
                            if ((F | 0) >= (K | 0)) { ec(1024, 904, 118, 17320) }
                            if (!((D | 0) > -1)) { ec(816, 904, 119, 17320) }
                            if ((D | 0) < (c[t + 10376 >> 2] | 0)) {
                                x = (ga(K, D) | 0) + F | 0;
                                F = (c[t + 10360 >> 2] | 0) + (x * 3 | 0) | 0;
                                L = ((d[F] | d[F + 1 | 0] << 8) << 16 >> 16 & 768) == 512 ? 6 : 5;
                                break
                            } else { ec(816, 904, 119, 17320) }
                        }
                    } while (0);
                    do {
                        if ((J | 0) == 0) { M = 0 } else {
                            y = c[t + 10368 >> 2] | 0;
                            F = f >> y;
                            x = E >> y;
                            if (!((F | 0) > -1)) { ec(1024, 904, 118, 17320) }
                            y = c[t + 10372 >> 2] | 0;
                            if ((F | 0) >= (y | 0)) { ec(1024, 904, 118, 17320) }
                            if (!((x | 0) > -1)) { ec(816, 904, 119, 17320) }
                            if ((x | 0) < (c[t + 10376 >> 2] | 0)) {
                                D = (ga(y, x) | 0) + F | 0;
                                F = (c[t + 10360 >> 2] | 0) + (D * 3 | 0) | 0;
                                M = ((d[F] | d[F + 1 | 0] << 8) << 16 >> 16 & 768) == 512 | 0;
                                break
                            } else { ec(816, 904, 119, 17320) }
                        }
                    } while (0);
                    t = e + 18556 | 0;
                    E = e + 18580 | 0;
                    if (((ud(t, (c[E >> 2] | 0) + (M + L) | 0) | 0) & 255) << 24 >> 24 == 0) {
                        if ((c[w >> 2] | 0) == 2) { H = 0; break }
                        H = (ud(t, (c[E >> 2] | 0) + 149 | 0) | 0) == 0 | 0;
                        break
                    }
                    a: do { if ((c[(c[s >> 2] | 0) + 804 >> 2] | 0) < 2) { N = 0 } else { if ((ud(t, (c[E >> 2] | 0) + 148 | 0) | 0) == 0) { N = 0; break } if (((c[(c[s >> 2] | 0) + 804 >> 2] | 0) - 1 | 0) > 1) { O = 1 } else { N = 1; break } while (1) { F = O + 1 | 0; if ((wd(t) | 0) == 0) { N = O & 255; break a } if ((F | 0) < ((c[(c[s >> 2] | 0) + 804 >> 2] | 0) - 1 | 0)) { O = F } else { N = F & 255; break } } } } while (0);
                    t = e + 26 | 0;
                    a[t] = N << 5 | a[t] & 15 | 16;
                    t = c[u >> 2] | 0;
                    E = f >> t;
                    F = g >> t;
                    if (!((E | 0) > -1)) { ec(1024, 904, 128, 17320) }
                    t = c[G >> 2] | 0;
                    if ((E | 0) >= (t | 0)) { ec(1024, 904, 128, 17320) }
                    if (!((F | 0) > -1)) { ec(816, 904, 129, 17320) }
                    if ((F | 0) >= (c[A >> 2] | 0)) { ec(816, 904, 129, 17320) }
                    D = (ga(t, F) | 0) + E | 0;
                    E = (c[v >> 2] | 0) + (D * 3 | 0) | 0;
                    C = (d[E] | d[E + 1 | 0] << 8) << 16 >> 16 & -57;
                    a[E] = C;
                    C = C >> 8;
                    a[E + 1 | 0] = C;
                    E = c[u >> 2] | 0;
                    D = f >> E;
                    F = g >> E;
                    t = 1 << h - E;
                    E = t + F | 0;
                    if ((t | 0) > 0) {
                        x = t + D | 0;
                        t = F;
                        do {
                            F = D;
                            do {
                                y = (ga(c[G >> 2] | 0, t) | 0) + F | 0;
                                K = (c[v >> 2] | 0) + (y * 3 | 0) | 0;
                                C = (d[K] | d[K + 1 | 0] << 8) << 16 >> 16 & -769 | 512;
                                a[K] = C;
                                C = C >> 8;
                                a[K + 1 | 0] = C;
                                F = F + 1 | 0;
                            } while ((F | 0) < (x | 0));
                            t = t + 1 | 0;
                        } while ((t | 0) < (E | 0))
                    }
                    Ii(c[e + 18592 >> 2] | 0, c[s >> 2] | 0, c[q >> 2] | 0, e + 16 | 0, f, g, 0, 0, z, z, z, 0);
                    i = k;
                    return
                }
            } while (0);
            s = c[u >> 2] | 0;
            N = f >> s;
            O = g >> s;
            w = 1 << h - s;
            s = w + O | 0;
            if ((w | 0) > 0) {
                L = w + N | 0;
                w = (H & 65535) << 8;
                M = O;
                do {
                    O = N;
                    do {
                        J = (ga(c[G >> 2] | 0, M) | 0) + O | 0;
                        I = (c[v >> 2] | 0) + (J * 3 | 0) | 0;
                        C = (d[I] | d[I + 1 | 0] << 8) << 16 >> 16 & -769 | w;
                        a[I] = C;
                        C = C >> 8;
                        a[I + 1 | 0] = C;
                        O = O + 1 | 0;
                    } while ((O | 0) < (L | 0));
                    M = M + 1 | 0;
                } while ((M | 0) < (s | 0))
            }
            s = (H | 0) != 0;
            if (s) { P = 87 } else {
                if ((c[r + 5800 >> 2] | 0) == (h | 0)) { P = 87 } else {
                    Q = 0;
                    R = 0
                }
            }
            if ((P | 0) == 87) {
                M = c[q >> 2] | 0;
                L = (H | 0) == 0;
                w = e + 18556 | 0;
                N = e + 18580 | 0;
                O = ud(w, (c[N >> 2] | 0) + 8 | 0) | 0;
                do {
                    if (L) { S = (O | 0) != 0 ? 0 : 3 } else {
                        if ((O | 0) != 0) { S = 0; break }
                        I = ud(w, (c[N >> 2] | 0) + 9 | 0) | 0;
                        if ((c[M + 5800 >> 2] | 0) >= (h | 0)) {
                            if ((I | 0) != 0) { S = 1; break }
                            if ((h | 0) == 3) { S = 2; break }
                            S = 3 - (ud(w, (c[N >> 2] | 0) + 10 | 0) | 0) | 0;
                            break
                        }
                        if ((a[M + 5466 | 0] | 0) == 0) { S = (I | 0) != 0 ? 1 : 2; break }
                        if ((ud(w, (c[N >> 2] | 0) + 11 | 0) | 0) != 0) { S = (I | 0) != 0 ? 1 : 2; break }
                        J = (I | 0) != 0;
                        I = J ^ 1;
                        E = (wd(w) | 0) == 0;
                        if (!(E | I)) { S = 5; break }
                        if (J & E) { S = 4; break }
                        if (E & I) { S = 6; break }
                        if (!(J | E)) { S = 7; break }
                        ec(536, 14776, 1760, 17936)
                    }
                } while (0);
                Q = (S | 0) == 3 & L & 1;
                R = S
            }
            S = c[u >> 2] | 0;
            L = f >> S;
            w = g >> S;
            if (!((L | 0) > -1)) { ec(1024, 904, 128, 17320) }
            S = c[G >> 2] | 0;
            if ((L | 0) >= (S | 0)) { ec(1024, 904, 128, 17320) }
            if (!((w | 0) > -1)) { ec(816, 904, 129, 17320) }
            if ((w | 0) >= (c[A >> 2] | 0)) { ec(816, 904, 129, 17320) }
            A = (ga(S, w) | 0) + L | 0;
            L = (c[v >> 2] | 0) + (A * 3 | 0) | 0;
            C = (d[L] | d[L + 1 | 0] << 8) << 16 >> 16 & -57 | (R & 65535) << 3 & 56;
            a[L] = C;
            C = C >> 8;
            a[L + 1 | 0] = C;
            L = (H | 0) == 0;
            A = (R | 0) == 0;
            b: do {
                if (L) {
                    do {
                        if (A) {
                            if ((a[r + 5468 | 0] | 0) == 0) {
                                T = z;
                                U = 0;
                                break
                            }
                            if ((c[r + 5884 >> 2] | 0) > (h | 0)) { P = 165; break }
                            if ((c[r + 5888 >> 2] | 0) < (h | 0)) { P = 165; break }
                            w = e + 18556 | 0;
                            if ((vd(w) | 0) == 0) { P = 165; break }
                            S = c[u >> 2] | 0;
                            N = f >> S;
                            M = g >> S;
                            O = 1 << h - S;
                            S = O + M | 0;
                            if ((O | 0) > 0) {
                                E = O + N | 0;
                                O = M;
                                do {
                                    M = N;
                                    do {
                                        J = (ga(c[G >> 2] | 0, O) | 0) + M | 0;
                                        I = (c[v >> 2] | 0) + (J * 3 | 0) | 0;
                                        C = (d[I] | d[I + 1 | 0] << 8) << 16 >> 16 | 1024;
                                        a[I] = C;
                                        C = C >> 8;
                                        a[I + 1 | 0] = C;
                                        M = M + 1 | 0;
                                    } while ((M | 0) < (E | 0));
                                    O = O + 1 | 0;
                                } while ((O | 0) < (S | 0))
                            }
                            S = c[r + 10348 >> 2] | 0;
                            O = f >> S;
                            E = g >> S;
                            if (!((O | 0) > -1)) { ec(1024, 904, 128, 17320) }
                            S = c[r + 10352 >> 2] | 0;
                            if ((O | 0) >= (S | 0)) { ec(1024, 904, 128, 17320) }
                            if (!((E | 0) > -1)) { ec(816, 904, 129, 17320) }
                            if ((E | 0) >= (c[r + 10356 >> 2] | 0)) { ec(816, 904, 129, 17320) }
                            N = (ga(S, E) | 0) + O | 0;
                            a[(c[r + 10340 >> 2] | 0) + (N * 24 | 0) + 22 | 0] = 1;
                            N = e + 18560 | 0;
                            O = c[N >> 2] | 0;
                            E = l | 0;
                            c[E >> 2] = O;
                            c[l + 4 >> 2] = (c[e + 18564 >> 2] | 0) - O;
                            O = l + 8 | 0;
                            c[O >> 2] = 0;
                            c[O + 4 >> 2] = 0;
                            c[l + 16 >> 2] = 0;
                            O = c[q >> 2] | 0;
                            S = c[O + 5760 >> 2] | 0;
                            M = a[O + 5469 | 0] | 0;
                            I = c[O + 40 >> 2] | 0;
                            J = c[O + 4 >> 2] | 0;
                            do {
                                if ((S | 0) > 8) {
                                    O = J + ((ga(I, g) | 0) + f << 1) | 0;
                                    t = S - M | 0;
                                    if ((z | 0) > 0) { V = 0 } else { break }
                                    do {
                                        x = ga(V, I) | 0;
                                        D = 0;
                                        do {
                                            F = (nd(l, M) | 0) << t & 65535;
                                            b[O + (D + x << 1) >> 1] = F;
                                            D = D + 1 | 0;
                                        } while ((D | 0) < (z | 0));
                                        V = V + 1 | 0;
                                    } while ((V | 0) < (z | 0))
                                } else {
                                    O = S - M | 0;
                                    if ((z | 0) > 0) { W = 0 } else { break }
                                    do {
                                        t = (ga(W + g | 0, I) | 0) + f | 0;
                                        D = 0;
                                        do {
                                            x = (nd(l, M) | 0) << O & 255;
                                            a[J + (t + D) | 0] = x;
                                            D = D + 1 | 0;
                                        } while ((D | 0) < (z | 0));
                                        W = W + 1 | 0;
                                    } while ((W | 0) < (z | 0))
                                }
                            } while (0);
                            J = c[q >> 2] | 0;
                            do {
                                if ((c[J + 5776 >> 2] | 0) != 0) {
                                    M = c[J + 5768 >> 2] | 0;
                                    I = c[J + 5780 >> 2] | 0;
                                    S = (z | 0) / (I | 0) | 0;
                                    O = c[J + 5784 >> 2] | 0;
                                    D = (z | 0) / (O | 0) | 0;
                                    t = (f | 0) / (I | 0) | 0;
                                    x = (g | 0) / (O | 0) | 0;
                                    F = a[J + 5470 | 0] | 0;
                                    K = F << 24 >> 24;
                                    y = c[J + 44 >> 2] | 0;
                                    B = c[J + 8 >> 2] | 0;
                                    if ((M | 0) > 8) {
                                        X = B + ((ga(y, x) | 0) + t << 1) | 0;
                                        Y = M - K | 0;
                                        if ((D | 0) > 0) {
                                            Z = (S | 0) > 0;
                                            _ = 0;
                                            do {
                                                if (Z) {
                                                    $ = ga(_, y) | 0;
                                                    aa = 0;
                                                    do {
                                                        ba = (nd(l, K) | 0) << Y & 65535;
                                                        b[X + (aa + $ << 1) >> 1] = ba;
                                                        aa = aa + 1 | 0;
                                                    } while ((aa | 0) < (S | 0))
                                                }
                                                _ = _ + 1 | 0;
                                            } while ((_ | 0) < (D | 0));
                                            _ = c[q >> 2] | 0;
                                            ca = _;
                                            da = c[_ + 5780 >> 2] | 0;
                                            ea = c[_ + 5784 >> 2] | 0;
                                            fa = a[_ + 5470 | 0] | 0;
                                            ha = c[_ + 5768 >> 2] | 0;
                                            ia = c[_ + 44 >> 2] | 0
                                        } else {
                                            ca = J;
                                            da = I;
                                            ea = O;
                                            fa = F;
                                            ha = M;
                                            ia = y
                                        }
                                        _ = (z | 0) / (da | 0) | 0;
                                        X = (z | 0) / (ea | 0) | 0;
                                        Y = fa << 24 >> 24;
                                        Z = (c[ca + 12 >> 2] | 0) + ((ga((g | 0) / (ea | 0) | 0, ia) | 0) + ((f | 0) / (da | 0) | 0) << 1) | 0;
                                        aa = ha - Y | 0;
                                        if ((X | 0) <= 0) { break }
                                        $ = (_ | 0) > 0;
                                        ba = 0;
                                        do {
                                            if ($) {
                                                ja = ga(ba, ia) | 0;
                                                ka = 0;
                                                do {
                                                    la = (nd(l, Y) | 0) << aa & 65535;
                                                    b[Z + (ka + ja << 1) >> 1] = la;
                                                    ka = ka + 1 | 0;
                                                } while ((ka | 0) < (_ | 0))
                                            }
                                            ba = ba + 1 | 0;
                                        } while ((ba | 0) < (X | 0))
                                    } else {
                                        X = M - K | 0;
                                        if ((D | 0) > 0) {
                                            ba = (S | 0) > 0;
                                            _ = 0;
                                            do {
                                                if (ba) {
                                                    Z = (ga(_ + x | 0, y) | 0) + t | 0;
                                                    aa = 0;
                                                    do {
                                                        Y = (nd(l, K) | 0) << X & 255;
                                                        a[B + (Z + aa) | 0] = Y;
                                                        aa = aa + 1 | 0;
                                                    } while ((aa | 0) < (S | 0))
                                                }
                                                _ = _ + 1 | 0;
                                            } while ((_ | 0) < (D | 0));
                                            D = c[q >> 2] | 0;
                                            ma = D;
                                            na = c[D + 5780 >> 2] | 0;
                                            oa = c[D + 5784 >> 2] | 0;
                                            pa = a[D + 5470 | 0] | 0;
                                            qa = c[D + 5768 >> 2] | 0;
                                            ra = c[D + 44 >> 2] | 0
                                        } else {
                                            ma = J;
                                            na = I;
                                            oa = O;
                                            pa = F;
                                            qa = M;
                                            ra = y
                                        }
                                        D = (z | 0) / (na | 0) | 0;
                                        _ = (z | 0) / (oa | 0) | 0;
                                        S = (f | 0) / (na | 0) | 0;
                                        B = (g | 0) / (oa | 0) | 0;
                                        X = pa << 24 >> 24;
                                        K = c[ma + 12 >> 2] | 0;
                                        t = qa - X | 0;
                                        if ((_ | 0) <= 0) { break }
                                        x = (D | 0) > 0;
                                        ba = 0;
                                        do {
                                            if (x) {
                                                aa = (ga(ba + B | 0, ra) | 0) + S | 0;
                                                Z = 0;
                                                do {
                                                    Y = (nd(l, X) | 0) << t & 255;
                                                    a[K + (aa + Z) | 0] = Y;
                                                    Z = Z + 1 | 0;
                                                } while ((Z | 0) < (D | 0))
                                            }
                                            ba = ba + 1 | 0;
                                        } while ((ba | 0) < (_ | 0))
                                    }
                                }
                            } while (0);
                            pd(l);
                            c[N >> 2] = c[E >> 2];
                            td(w);
                            i = k;
                            return
                        } else { P = 165 }
                    } while (0);
                    do {
                        if ((P | 0) == 165) {
                            if ((R | 0) != 3) {
                                T = z;
                                U = 0;
                                break
                            }
                            T = (z | 0) / 2 | 0;
                            U = -1
                        }
                    } while (0);
                    J = U + h | 0;
                    _ = (z | 0) > 0;
                    if (_) {
                        ba = e + 18556 | 0;
                        D = e + 18580 | 0;
                        K = 0;
                        t = 0;
                        while (1) {
                            X = 0;
                            S = t;
                            while (1) {
                                B = ud(ba, (c[D >> 2] | 0) + 12 | 0) | 0;
                                sa = S + 1 | 0;
                                c[m + (S << 2) >> 2] = B;
                                B = X + T | 0;
                                if ((B | 0) < (z | 0)) {
                                    X = B;
                                    S = sa
                                } else { break }
                            }
                            S = K + T | 0;
                            if ((S | 0) < (z | 0)) {
                                K = S;
                                t = sa
                            } else { break }
                        }
                    }
                    t = f - 1 | 0;
                    do {
                        if ((t | g | 0) < 0) { ta = 0 } else {
                            if ((c[r + 1248 >> 2] | 0) <= (t | 0)) { ta = 0; break }
                            if ((c[r + 1252 >> 2] | 0) <= (g | 0)) { ta = 0; break }
                            K = c[r + 5804 >> 2] | 0;
                            D = ga(g >> K, c[r + 5820 >> 2] | 0) | 0;
                            ba = D + (f >> K) | 0;
                            S = D + (t >> K) | 0;
                            K = c[r + 10340 >> 2] | 0;
                            if ((b[K + (ba * 24 | 0) >> 1] | 0) != (b[K + (S * 24 | 0) >> 1] | 0)) { ta = 0; break }
                            K = c[r + 10308 >> 2] | 0;
                            ta = (c[K + (ba << 2) >> 2] | 0) == (c[K + (S << 2) >> 2] | 0) | 0
                        }
                    } while (0);
                    t = g - 1 | 0;
                    do {
                        if ((t | f | 0) < 0) { ua = 0 } else {
                            if ((c[r + 1248 >> 2] | 0) <= (f | 0)) { ua = 0; break }
                            if ((c[r + 1252 >> 2] | 0) <= (t | 0)) { ua = 0; break }
                            S = c[r + 5804 >> 2] | 0;
                            K = c[r + 5820 >> 2] | 0;
                            ba = f >> S;
                            D = (ga(g >> S, K) | 0) + ba | 0;
                            X = (ga(t >> S, K) | 0) + ba | 0;
                            ba = c[r + 10340 >> 2] | 0;
                            if ((b[ba + (D * 24 | 0) >> 1] | 0) != (b[ba + (X * 24 | 0) >> 1] | 0)) { ua = 0; break }
                            ba = c[r + 10308 >> 2] | 0;
                            ua = (c[ba + (D << 2) >> 2] | 0) == (c[ba + (X << 2) >> 2] | 0) | 0
                        }
                    } while (0);
                    if (_) {
                        t = e + 18556 | 0;
                        X = (ta | 0) != 0;
                        ba = (ua | 0) != 0;
                        D = r + 5872 | 0;
                        K = r + 5876 | 0;
                        S = p | 0;
                        w = r + 10408 | 0;
                        E = r + 10412 | 0;
                        N = r + 10400 | 0;
                        B = p + 4 | 0;
                        x = p + 8 | 0;
                        y = 0;
                        M = 0;
                        while (1) {
                            F = y + g | 0;
                            O = (y | 0) > 0 | ba;
                            I = 0;
                            Z = M;
                            do {
                                aa = c[m + (Z << 2) >> 2] | 0;
                                if ((aa | 0) == 0) {
                                    Y = yd(t, 5) | 0;
                                    c[o + (Z << 2) >> 2] = Y
                                } else {
                                    Y = xd(t, 2) | 0;
                                    c[n + (Z << 2) >> 2] = Y
                                }
                                Y = I + f | 0;
                                $ = c[D >> 2] | 0;
                                ka = (ga(F >> $, c[K >> 2] | 0) | 0) + (Y >> $) | 0;
                                di(S, Y, F, ka, (I | 0) > 0 | X, O, r);
                                if ((aa | 0) == 1) { va = c[p + (c[n + (Z << 2) >> 2] << 2) >> 2] & 255 } else {
                                    aa = c[S >> 2] | 0;
                                    Y = c[B >> 2] | 0;
                                    if ((aa | 0) > (Y | 0)) {
                                        c[S >> 2] = Y;
                                        c[B >> 2] = aa;
                                        wa = Y;
                                        xa = aa
                                    } else {
                                        wa = aa;
                                        xa = Y
                                    }
                                    Y = c[x >> 2] | 0;
                                    if ((wa | 0) > (Y | 0)) {
                                        c[S >> 2] = Y;
                                        c[x >> 2] = wa;
                                        ya = wa;
                                        za = Y
                                    } else {
                                        ya = Y;
                                        za = wa
                                    }
                                    if ((xa | 0) > (ya | 0)) {
                                        c[B >> 2] = ya;
                                        c[x >> 2] = xa;
                                        Aa = ya;
                                        Ba = xa
                                    } else {
                                        Aa = xa;
                                        Ba = ya
                                    }
                                    Y = c[o + (Z << 2) >> 2] | 0;
                                    aa = ((Y | 0) >= (za | 0)) + Y | 0;
                                    Y = ((aa | 0) >= (Aa | 0)) + aa | 0;
                                    va = ((Y | 0) >= (Ba | 0)) + Y & 255
                                }
                                Y = 1 << J - (c[w >> 2] | 0);
                                if ((Y | 0) > 0) {
                                    aa = 0;
                                    do {
                                        $ = 0;
                                        do {
                                            ja = $ + ka + (ga(c[E >> 2] | 0, aa) | 0) | 0;
                                            a[(c[N >> 2] | 0) + ja | 0] = va;
                                            $ = $ + 1 | 0;
                                        } while (($ | 0) < (Y | 0));
                                        aa = aa + 1 | 0;
                                    } while ((aa | 0) < (Y | 0))
                                }
                                Z = Z + 1 | 0;
                                I = I + T | 0;
                            } while ((I | 0) < (z | 0));
                            I = y + T | 0;
                            if ((I | 0) < (z | 0)) {
                                y = I;
                                M = Z
                            } else { break }
                        }
                    }
                    M = r + 5776 | 0;
                    y = c[M >> 2] | 0;
                    if ((y | 0) == 0) { break } else if ((y | 0) != 3) {
                        y = e + 18556 | 0;
                        if ((ud(y, (c[e + 18580 >> 2] | 0) + 13 | 0) | 0) == 0) { Ca = 4 } else { Ca = yd(y, 2) | 0 }
                        y = c[r + 10408 >> 2] | 0;
                        N = f >> y;
                        E = g >> y;
                        if (!((N | 0) > -1)) { ec(1024, 904, 118, 17320) }
                        y = c[r + 10412 >> 2] | 0;
                        if ((N | 0) >= (y | 0)) { ec(1024, 904, 118, 17320) }
                        if (!((E | 0) > -1)) { ec(816, 904, 119, 17320) }
                        if ((E | 0) >= (c[r + 10416 >> 2] | 0)) { ec(816, 904, 119, 17320) }
                        w = (ga(y, E) | 0) + N | 0;
                        N = d[(c[r + 10400 >> 2] | 0) + w | 0] | 0;
                        w = (Ca | 0) == 4;
                        if (w) { Da = N } else {
                            E = c[19448 + (Ca << 2) >> 2] | 0;
                            Da = (E | 0) == (N | 0) ? 34 : E
                        }
                        if ((c[M >> 2] | 0) == 2) { Ea = d[30544 + Da | 0] | 0 } else { Ea = Da }
                        Yj(r, f, g, h, Ea, w);
                        break
                    }
                    if (!_) { break }
                    w = e + 18556 | 0;
                    M = e + 18580 | 0;
                    E = r + 10408 | 0;
                    N = r + 10412 | 0;
                    y = r + 10416 | 0;
                    x = r + 10400 | 0;
                    B = 0;
                    c: while (1) {
                        S = B + g | 0;
                        X = 0;
                        do {
                            K = X + f | 0;
                            if ((ud(w, (c[M >> 2] | 0) + 13 | 0) | 0) == 0) { Fa = 4 } else { Fa = yd(w, 2) | 0 }
                            D = c[E >> 2] | 0;
                            t = K >> D;
                            ba = S >> D;
                            if (!((t | 0) > -1)) { P = 211; break c }
                            D = c[N >> 2] | 0;
                            if ((t | 0) >= (D | 0)) { P = 211; break c }
                            if (!((ba | 0) > -1)) { P = 214; break c }
                            if ((ba | 0) >= (c[y >> 2] | 0)) { P = 214; break c }
                            I = (ga(D, ba) | 0) + t | 0;
                            t = d[(c[x >> 2] | 0) + I | 0] | 0;
                            I = (Fa | 0) == 4;
                            if (I) { Ga = t } else {
                                ba = c[19448 + (Fa << 2) >> 2] | 0;
                                Ga = (ba | 0) == (t | 0) ? 34 : ba
                            }
                            Yj(r, K, S, J, Ga, I);
                            X = X + T | 0;
                        } while ((X | 0) < (z | 0));
                        B = B + T | 0;
                        if ((B | 0) >= (z | 0)) { break b }
                    }
                    if ((P | 0) == 211) { ec(1024, 904, 118, 17320) } else if ((P | 0) == 214) { ec(816, 904, 119, 17320) }
                } else {
                    if (A) { Wj(e, f, g, 0, 0, z, z, j, z, 0); break }
                    switch (R | 0) {
                        case 1:
                            { B = (z | 0) / 2 | 0;Wj(e, f, g, 0, 0, z, B, j, z, 0);Wj(e, f, g, 0, B, z, B, j, z, 1); break b; break };
                        case 2:
                            { B = (z | 0) / 2 | 0;Wj(e, f, g, 0, 0, B, z, j, z, 0);Wj(e, f, g, B, 0, B, z, j, z, 1); break b; break };
                        case 4:
                            { B = (z | 0) / 4 | 0;Wj(e, f, g, 0, 0, z, B, j, z, 0);Wj(e, f, g, 0, B, z, (3 << h | 0) / 4 | 0, j, z, 1); break b; break };
                        case 5:
                            { B = (3 << h | 0) / 4 | 0;Wj(e, f, g, 0, 0, z, B, j, z, 0);Wj(e, f, g, 0, B, z, (z | 0) / 4 | 0, j, z, 1); break b; break };
                        case 6:
                            { B = (z | 0) / 4 | 0;Wj(e, f, g, 0, 0, B, z, j, z, 0);Wj(e, f, g, B, 0, (3 << h | 0) / 4 | 0, z, j, z, 1); break b; break };
                        case 7:
                            { B = (3 << h | 0) / 4 | 0;Wj(e, f, g, 0, 0, B, z, j, z, 0);Wj(e, f, g, B, 0, (z | 0) / 4 | 0, z, j, z, 1); break b; break };
                        case 3:
                            { B = (z | 0) / 2 | 0;Wj(e, f, g, 0, 0, B, B, j, z, 0);Wj(e, f, g, B, 0, B, B, j, z, 1);Wj(e, f, g, 0, B, B, B, j, z, 2);Wj(e, f, g, B, B, B, B, j, z, 3); break b; break };
                        default:
                            { ec(14128, 14776, 4511, 18912) }
                    }
                }
            } while (0);
            do {
                if (s) {
                    if (!((R | 0) != 0 | (a[e + 26 | 0] & 16) == 0)) { break }
                    if ((ud(e + 18556 | 0, (c[e + 18580 >> 2] | 0) + 153 | 0) | 0) != 0) { break }
                    i = k;
                    return
                }
            } while (0);
            if (L) { Ha = (c[r + 1396 >> 2] | 0) + Q | 0 } else { Ha = c[r + 1392 >> 2] | 0 }
            L = (c[r + 5776 >> 2] | 0) != 0 | 0;
            Uj(e, f, g, f, g, f, g, h, 0, 0, Ha, Q, H, L, L);
            i = k;
            return
        }

        function Yj(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            if (h) { i = (g | 128) & 255 } else { i = g & 255 }
            g = 1 << f - (c[b + 10408 >> 2] | 0);
            f = c[b + 5872 >> 2] | 0;
            h = b + 5876 | 0;
            j = (ga(e >> f, c[h >> 2] | 0) | 0) + (d >> f) | 0;
            if ((g | 0) <= 0) { return }
            f = b + 5880 | 0;
            d = b + 10432 | 0;
            e = b + 10424 | 0;
            k = b + 10420 | 0;
            b = 0;
            a: while (1) {
                l = 0;
                do {
                    if ((l | 0) >= (c[h >> 2] | 0)) { m = 7; break a }
                    if ((b | 0) >= (c[f >> 2] | 0)) { m = 9; break a }
                    n = j + l + (ga(c[d >> 2] | 0, b) | 0) | 0;
                    if ((n | 0) >= (c[e >> 2] | 0)) { m = 11; break a }
                    a[(c[k >> 2] | 0) + n | 0] = i;
                    l = l + 1 | 0;
                } while ((l | 0) < (g | 0));
                l = b + 1 | 0;
                if ((l | 0) < (g | 0)) { b = l } else { m = 14; break }
            }
            if ((m | 0) == 7) { ec(776, 904, 659, 17736) } else if ((m | 0) == 9) { ec(704, 904, 660, 17736) } else if ((m | 0) == 11) { ec(640, 904, 663, 17736) } else if ((m | 0) == 14) { return }
        }

        function Zj(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0;
            f = b + 18596 | 0;
            g = c[f >> 2] | 0;
            h = c[g + 5820 >> 2] | 0;
            i = b + 12 | 0;
            j = g + 5965 | 0;
            do {
                if (!e) {
                    if ((a[j] | 0) == 0) { break }
                    k = c[i >> 2] | 0;
                    if ((k | 0) <= 0) { break }
                    if ((c[b + 8 >> 2] | 0) != 0) { break }
                    if ((h | 0) > 1) {
                        l = k - 1 | 0;
                        m = b + 18604 | 0;
                        n = c[m >> 2] | 0;
                        if (l >>> 0 < (c[n + 10680 >> 2] | 0) - (c[n + 10676 >> 2] | 0) >> 3 >>> 0) {
                            Yh(g, c[b + 18612 >> 2] | 0, 1, l, 1);
                            Jd(b + 18580 | 0, (c[(c[m >> 2] | 0) + 10676 >> 2] | 0) + ((c[i >> 2] | 0) - 1 << 3) | 0) | 0;
                            Hd((c[(c[m >> 2] | 0) + 10676 >> 2] | 0) + ((c[i >> 2] | 0) - 1 << 3) | 0);
                            break
                        } else { o = 2; return o | 0 }
                    } else {
                        Yh(g, c[b + 18612 >> 2] | 0, 0, k - 1 | 0, 1);
                        k = c[b + 18600 >> 2] | 0;
                        m = c[k + 796 >> 2] | 0;
                        if (m >>> 0 < 3 >>> 0) {
                            Fd(b + 18580 | 0, m, c[k + 792 >> 2] | 0);
                            k = b + 18588 | 0;
                            C = 0;
                            a[k] = C;
                            C = C >> 8;
                            a[k + 1 | 0] = C;
                            C = C >> 8;
                            a[k + 2 | 0] = C;
                            C = C >> 8;
                            a[k + 3 | 0] = C;
                            break
                        } else { ec(1856, 14776, 1508, 18744); return 0 }
                    }
                }
            } while (0);
            e = b + 8 | 0;
            k = h - 1 | 0;
            m = b + 18612 | 0;
            l = b + 18580 | 0;
            n = b + 18584 | 0;
            p = g + 5828 | 0;
            q = b + 18604 | 0;
            r = b + 18556 | 0;
            s = g + 5935 | 0;
            t = b + 18600 | 0;
            u = b + 4 | 0;
            v = b | 0;
            w = g + 5966 | 0;
            x = g + 10296 | 0;
            g = c[e >> 2] | 0;
            y = c[i >> 2] | 0;
            z = c[f >> 2] | 0;
            a: while (1) {
                A = (ga(y, h) | 0) + g | 0;
                if (!(A >>> 0 < (c[z + 10276 >> 2] | 0) - (c[z + 10272 >> 2] | 0) >> 2 >>> 0)) {
                    o = 2;
                    B = 38;
                    break
                }
                if ((g | 0) >= (c[z + 5820 >> 2] | 0)) {
                    o = 2;
                    B = 38;
                    break
                }
                if ((y | 0) >= (c[z + 5828 >> 2] | 0)) {
                    o = 2;
                    B = 38;
                    break
                }
                if ((y | 0) > 0 & d & (g | 0) < (k | 0)) { Yh(z, c[m >> 2] | 0, g + 1 | 0, y - 1 | 0, 1) }
                if ((c[n >> 2] | 0) == 0) {
                    o = 2;
                    B = 38;
                    break
                }
                Pj(b);
                do {
                    if ((a[j] | 0) != 0 & (g | 0) == 1) {
                        if ((y | 0) >= ((c[p >> 2] | 0) - 1 | 0)) { break }
                        D = c[q >> 2] | 0;
                        E = c[D + 10676 >> 2] | 0;
                        if (!((c[D + 10680 >> 2] | 0) - E >> 3 >>> 0 > y >>> 0)) {
                            o = 2;
                            B = 38;
                            break a
                        }
                        Jd(E + (y << 3) | 0, l) | 0;
                        Id((c[(c[q >> 2] | 0) + 10676 >> 2] | 0) + (y << 3) | 0)
                    }
                } while (0);
                E = vd(r) | 0;
                D = (E | 0) != 0;
                do {
                    if (D) {
                        if ((a[s] | 0) == 0) { break }
                        Jd((c[t >> 2] | 0) + 1332 | 0, l) | 0;
                        Id((c[t >> 2] | 0) + 1332 | 0);
                        a[(c[t >> 2] | 0) + 1340 | 0] = 1
                    }
                } while (0);
                Ek((c[(c[f >> 2] | 0) + 10524 >> 2] | 0) + (A * 76 | 0) | 0, 1);
                F = c[i >> 2] | 0;
                G = c[u >> 2] | 0;
                H = G + 1 | 0;
                c[u >> 2] = H;
                I = c[f >> 2] | 0;
                J = c[I + 5836 >> 2] | 0;
                if ((H | 0) < (J | 0)) {
                    K = c[(c[I + 10284 >> 2] | 0) + (H << 2) >> 2] | 0;
                    c[v >> 2] = K;
                    L = I + 5820 | 0;
                    M = (K | 0) % (c[L >> 2] | 0) | 0;
                    c[e >> 2] = M;
                    N = (K | 0) / (c[L >> 2] | 0) | 0;
                    c[i >> 2] = N;
                    O = M;
                    P = N
                } else {
                    c[v >> 2] = J;
                    N = I + 5820 | 0;
                    M = (J | 0) % (c[N >> 2] | 0) | 0;
                    c[e >> 2] = M;
                    L = (J | 0) / (c[N >> 2] | 0) | 0;
                    c[i >> 2] = L;
                    if ((E | 0) == 0) { B = 28; break } else {
                        O = M;
                        P = L
                    }
                }
                if (D) {
                    o = 0;
                    B = 38;
                    break
                }
                if ((a[w] | 0) == 0) { Q = 0 } else {
                    L = c[x >> 2] | 0;
                    Q = (c[L + (H << 2) >> 2] | 0) != (c[L + (G << 2) >> 2] | 0) | 0
                }
                if ((a[j] | 0) == 0) { R = 0 } else { R = (F | 0) != (P | 0) | 0 }
                if ((R | Q | 0) == 0) {
                    g = O;
                    y = P;
                    z = I
                } else { B = 35; break }
            }
            if ((B | 0) == 28) {
                Ue((c[b + 18592 >> 2] | 0) + 4 | 0, 1004, 0);
                a[(c[f >> 2] | 0) + 10516 | 0] = 3;
                o = 2;
                return o | 0
            } else if ((B | 0) == 35) {
                if ((vd(r) | 0) == 0) {
                    Ue((c[b + 18592 >> 2] | 0) + 4 | 0, 1017, 0);
                    a[(c[f >> 2] | 0) + 10516 | 0] = 3;
                    o = 2;
                    return o | 0
                } else {
                    td(r);
                    o = 1;
                    return o | 0
                }
            } else if ((B | 0) == 38) { return o | 0 }
            return 0
        }

        function _j(b) {
            b = b | 0;
            var d = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            d = c[b + 18596 >> 2] | 0;
            f = d + 5932 | 0;
            g = b + 18600 | 0;
            h = c[g >> 2] | 0;
            if ((a[h + 12 | 0] | 0) == 0) {
                i = c[h + 796 >> 2] | 0;
                if (!(i >>> 0 < 3 >>> 0)) { ec(1856, 14776, 1508, 18744); return 0 }
                Fd(b + 18580 | 0, i, c[h + 792 >> 2] | 0);
                i = b + 18588 | 0;
                C = 0;
                a[i] = C;
                C = C >> 8;
                a[i + 1 | 0] = C;
                C = C >> 8;
                a[i + 2 | 0] = C;
                C = C >> 8;
                a[i + 3 | 0] = C;
                j = 1;
                return j | 0
            }
            i = c[h + 16 >> 2] | 0;
            h = e[(c[d + 10340 >> 2] | 0) + ((c[(c[d + 10284 >> 2] | 0) + ((c[(c[d + 10272 >> 2] | 0) + (i << 2) >> 2] | 0) - 1 << 2) >> 2] | 0) * 24 | 0) + 2 >> 1] | 0;
            k = c[d + 48 >> 2] | 0;
            if (!(h >>> 0 < (c[d + 52 >> 2] | 0) - k >> 2 >>> 0)) { j = 0; return j | 0 }
            l = c[k + (h << 2) >> 2] | 0;
            h = c[d + 5820 >> 2] | 0;
            if (pj(f, (i | 0) % (h | 0) | 0, (i | 0) / (h | 0) | 0) | 0) {
                h = c[g >> 2] | 0;
                g = c[h + 796 >> 2] | 0;
                if (!(g >>> 0 < 3 >>> 0)) { ec(1856, 14776, 1508, 18744); return 0 }
                Fd(b + 18580 | 0, g, c[h + 792 >> 2] | 0);
                h = b + 18588 | 0;
                C = 0;
                a[h] = C;
                C = C >> 8;
                a[h + 1 | 0] = C;
                C = C >> 8;
                a[h + 2 | 0] = C;
                C = C >> 8;
                a[h + 3 | 0] = C;
                j = 1;
                return j | 0
            }
            h = c[b + 18604 >> 2] | 0;
            g = c[b + 18608 >> 2] | 0;
            i = c[h + 10632 >> 2] | 0;
            f = (c[h + 10636 >> 2] | 0) - i >> 2;
            if (f >>> 0 > 1 >>> 0) { m = 1 } else { j = 0; return j | 0 }
            while (1) {
                h = m + 1 | 0;
                if ((c[i + (m << 2) >> 2] | 0) == (g | 0)) { break }
                if (h >>> 0 < f >>> 0) { m = h } else {
                    j = 0;
                    n = 16;
                    break
                }
            }
            if ((n | 0) == 16) { return j | 0 }
            n = c[i + (m - 1 << 2) >> 2] | 0;
            if ((n | 0) == 0) { j = 0; return j | 0 }
            Dk(n + 44 | 0, c[n + 120 >> 2] | 0);
            if ((a[l + 1340 | 0] | 0) == 0) { j = 0; return j | 0 }
            n = l + 1332 | 0;
            Jd(b + 18580 | 0, n) | 0;
            Hd(n);
            j = 1;
            return j | 0
        }

        function $j(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            e = i;
            i = i + 104 | 0;
            f = e | 0;
            mb(f | 0, 1216, (g = i, i = i + 8 | 0, c[g >> 2] = c[d + 12 >> 2], g) | 0) | 0;
            i = g;
            g = ev(f | 0) | 0;
            if (g >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (g >>> 0 < 11 >>> 0) {
                a[b] = g << 1;
                h = b + 1 | 0;
                cv(h | 0, f | 0, g) | 0;
                j = h + g | 0;
                a[j] = 0;
                k = 100;
                l = 0;
                i = e;
                return
            } else {
                d = g + 16 & -16;
                m = Nu(d) | 0;
                c[b + 8 >> 2] = m;
                c[b >> 2] = d | 1;
                c[b + 4 >> 2] = g;
                h = m;
                cv(h | 0, f | 0, g) | 0;
                j = h + g | 0;
                a[j] = 0;
                k = 100;
                l = 0;
                i = e;
                return
            }
        }

        function ak(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            e = i;
            i = i + 104 | 0;
            f = e | 0;
            g = c[d + 16 >> 2] | 0;
            mb(f | 0, 1104, (h = i, i = i + 16 | 0, c[h >> 2] = c[d + 12 >> 2], c[h + 8 >> 2] = g, h) | 0) | 0;
            i = h;
            h = ev(f | 0) | 0;
            if (h >>> 0 > 4294967279 >>> 0) { nm(0) }
            if (h >>> 0 < 11 >>> 0) {
                a[b] = h << 1;
                j = b + 1 | 0;
                cv(j | 0, f | 0, h) | 0;
                k = j + h | 0;
                a[k] = 0;
                l = 100;
                m = 0;
                i = e;
                return
            } else {
                g = h + 16 & -16;
                d = Nu(g) | 0;
                c[b + 8 >> 2] = d;
                c[b >> 2] = g | 1;
                c[b + 4 >> 2] = h;
                j = d;
                cv(j | 0, f | 0, h) | 0;
                k = j + h | 0;
                a[k] = 0;
                l = 100;
                m = 0;
                i = e;
                return
            }
        }

        function bk(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            d = c[b + 20 >> 2] | 0;
            e = d + 18596 | 0;
            f = c[e >> 2] | 0;
            g = b | 0;
            h = b + 4 | 0;
            c[h >> 2] = 1;
            Wh(f, g);
            i = c[e >> 2] | 0;
            e = c[d + 4 >> 2] | 0;
            j = c[i + 5836 >> 2] | 0;
            if ((e | 0) < (j | 0)) {
                k = c[(c[i + 10284 >> 2] | 0) + (e << 2) >> 2] | 0;
                c[d >> 2] = k;
                e = i + 5820 | 0;
                c[d + 8 >> 2] = (k | 0) % (c[e >> 2] | 0) | 0;
                c[d + 12 >> 2] = (k | 0) / (c[e >> 2] | 0) | 0
            } else {
                c[d >> 2] = j;
                e = i + 5820 | 0;
                c[d + 8 >> 2] = (j | 0) % (c[e >> 2] | 0) | 0;
                c[d + 12 >> 2] = (j | 0) / (c[e >> 2] | 0) | 0
            }
            e = b + 8 | 0;
            do {
                if ((a[e] | 0) == 0) {
                    b = c[d + 18600 >> 2] | 0;
                    j = c[b + 796 >> 2] | 0;
                    if (j >>> 0 < 3 >>> 0) {
                        Fd(d + 18580 | 0, j, c[b + 792 >> 2] | 0);
                        b = d + 18588 | 0;
                        C = 0;
                        a[b] = C;
                        C = C >> 8;
                        a[b + 1 | 0] = C;
                        C = C >> 8;
                        a[b + 2 | 0] = C;
                        C = C >> 8;
                        a[b + 3 | 0] = C;
                        break
                    } else { ec(1856, 14776, 1508, 18744) }
                } else {
                    if (_j(d) | 0) { break }
                    c[h >> 2] = 3;
                    Fk((c[d + 18608 >> 2] | 0) + 44 | 0, 1);
                    Xh(f, g);
                    return
                }
            } while (0);
            td(d + 18556 | 0);
            Zj(d, 0, (a[e] | 0) != 0) | 0;
            c[h >> 2] = 3;
            Fk((c[d + 18608 >> 2] | 0) + 44 | 0, 1);
            Xh(f, g);
            return
        }

        function ck(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            d = c[b + 16 >> 2] | 0;
            e = d + 18596 | 0;
            f = c[e >> 2] | 0;
            g = f + 5820 | 0;
            h = c[g >> 2] | 0;
            i = b | 0;
            j = b + 4 | 0;
            c[j >> 2] = 1;
            Wh(f, i);
            k = c[e >> 2] | 0;
            e = c[d + 4 >> 2] | 0;
            l = c[k + 5836 >> 2] | 0;
            if ((e | 0) < (l | 0)) {
                m = c[(c[k + 10284 >> 2] | 0) + (e << 2) >> 2] | 0;
                c[d >> 2] = m;
                e = k + 5820 | 0;
                c[d + 8 >> 2] = (m | 0) % (c[e >> 2] | 0) | 0;
                c[d + 12 >> 2] = (m | 0) / (c[e >> 2] | 0) | 0;
                n = m
            } else {
                c[d >> 2] = l;
                m = k + 5820 | 0;
                c[d + 8 >> 2] = (l | 0) % (c[m >> 2] | 0) | 0;
                c[d + 12 >> 2] = (l | 0) / (c[m >> 2] | 0) | 0;
                n = l
            }
            l = (n | 0) / (h | 0) | 0;
            n = b + 8 | 0;
            do {
                if ((a[n] | 0) != 0) {
                    if (_j(d) | 0) { break }
                    if ((h | 0) > 0) {
                        b = ga(l, h) | 0;
                        m = f + 10524 | 0;
                        k = 0;
                        do {
                            Ek((c[m >> 2] | 0) + ((k + b | 0) * 76 | 0) | 0, 1);
                            k = k + 1 | 0;
                        } while ((k | 0) < (h | 0))
                    }
                    c[j >> 2] = 3;
                    Fk((c[d + 18608 >> 2] | 0) + 44 | 0, 1);
                    Xh(f, i);
                    return
                }
            } while (0);
            td(d + 18556 | 0);
            if ((a[n] | 0) == 0) { o = 0 } else { o = (a[(c[d + 18600 >> 2] | 0) + 12 | 0] | 0) == 0 }
            Zj(d, 1, o) | 0;
            a: do {
                if ((c[d + 12 >> 2] | 0) == (l | 0)) {
                    o = c[g >> 2] | 0;
                    n = c[d + 8 >> 2] | 0;
                    if ((n | 0) >= (o | 0)) { break }
                    k = f + 5828 | 0;
                    b = ga(l, h) | 0;
                    m = f + 10524 | 0;
                    e = n;
                    n = o;
                    while (1) {
                        do {
                            if ((e | 0) < (n | 0)) {
                                if ((l | 0) >= (c[k >> 2] | 0)) { break }
                                Ek((c[m >> 2] | 0) + ((e + b | 0) * 76 | 0) | 0, 1)
                            }
                        } while (0);
                        p = e + 1 | 0;
                        if ((p | 0) >= (o | 0)) { break a }
                        e = p;
                        n = c[g >> 2] | 0
                    }
                }
            } while (0);
            c[j >> 2] = 3;
            Fk((c[d + 18608 >> 2] | 0) + 44 | 0, 1);
            Xh(f, i);
            return
        }

        function dk(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            d = c[b + 18596 >> 2] | 0;
            e = c[b + 4 >> 2] | 0;
            f = c[d + 5836 >> 2] | 0;
            if ((e | 0) < (f | 0)) {
                g = c[(c[d + 10284 >> 2] | 0) + (e << 2) >> 2] | 0;
                c[b >> 2] = g;
                e = d + 5820 | 0;
                c[b + 8 >> 2] = (g | 0) % (c[e >> 2] | 0) | 0;
                c[b + 12 >> 2] = (g | 0) / (c[e >> 2] | 0) | 0
            } else {
                c[b >> 2] = f;
                e = d + 5820 | 0;
                c[b + 8 >> 2] = (f | 0) % (c[e >> 2] | 0) | 0;
                c[b + 12 >> 2] = (f | 0) / (c[e >> 2] | 0) | 0
            }
            e = b + 18600 | 0;
            f = c[e >> 2] | 0;
            if (!(_j(b) | 0)) { h = 18; return h | 0 }
            g = b + 18556 | 0;
            td(g);
            i = b + 18560 | 0;
            j = g | 0;
            g = b + 18592 | 0;
            k = d + 5966 | 0;
            d = b + 18580 | 0;
            l = b + 18588 | 0;
            m = (a[f + 12 | 0] | 0) == 0;
            f = 0;
            while (1) {
                do {
                    if ((f | 0) > 0) {
                        n = f - 1 | 0;
                        o = c[e >> 2] | 0;
                        p = c[o + 776 >> 2] | 0;
                        if (n >>> 0 < (c[o + 780 >> 2] | 0) - p >> 2 >>> 0) { if (((c[i >> 2] | 0) - 2 - (c[j >> 2] | 0) | 0) == (c[p + (n << 2) >> 2] | 0)) { break } }
                        Ue((c[g >> 2] | 0) + 4 | 0, 1003, 1)
                    }
                } while (0);
                n = f + 1 | 0;
                if (((Zj(b, 0, m) | 0) & -3 | 0) == 0) {
                    h = 0;
                    q = 15;
                    break
                }
                if ((a[k] | 0) == 0) {
                    m = 0;
                    f = n;
                    continue
                }
                p = c[e >> 2] | 0;
                o = c[p + 796 >> 2] | 0;
                if (!(o >>> 0 < 3 >>> 0)) { q = 13; break }
                Fd(d, o, c[p + 792 >> 2] | 0);
                C = 0;
                a[l] = C;
                C = C >> 8;
                a[l + 1 | 0] = C;
                C = C >> 8;
                a[l + 2 | 0] = C;
                C = C >> 8;
                a[l + 3 | 0] = C;
                m = 0;
                f = n
            }
            if ((q | 0) == 13) { ec(1856, 14776, 1508, 18744); return 0 } else if ((q | 0) == 15) { return h | 0 }
            return 0
        }

        function ek(a) { a = a | 0; return }

        function fk(a) {
            a = a | 0;
            Pu(a);
            return
        }

        function gk(a) { a = a | 0; return }

        function hk(a) {
            a = a | 0;
            Pu(a);
            return
        }

        function ik(b) {
            b = b | 0;
            c[b + 4720 >> 2] = 0;
            c[b + 4724 >> 2] = 0;
            c[b + 4728 >> 2] = 0;
            kl(b + 4904 | 0);
            dv(b + 4984 | 0, 0, 9) | 0;
            a[b | 0] = 0;
            return
        }

        function jk(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = c[a + 4720 >> 2] | 0;
            if ((b | 0) == 0) { return }
            d = a + 4724 | 0;
            a = c[d >> 2] | 0;
            if ((a | 0) != (b | 0)) { c[d >> 2] = a + (~(((a - 100 + (-b | 0) | 0) >>> 0) / 100 | 0) * 100 | 0) }
            Pu(b);
            return
        }



        function cr(e, f, g, h, j, k, l, m, n, o, p) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            var q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0,
                Fa = 0,
                Ga = 0,
                Ha = 0,
                Ia = 0,
                Ja = 0,
                Ka = 0,
                La = 0,
                Ma = 0,
                Na = 0,
                Oa = 0,
                Pa = 0,
                Qa = 0,
                Ra = 0,
                Sa = 0,
                Ta = 0,
                Ua = 0,
                Va = 0,
                Wa = 0,
                Xa = 0,
                Ya = 0,
                Za = 0,
                _a = 0,
                $a = 0,
                ab = 0,
                bb = 0,
                cb = 0,
                db = 0,
                eb = 0,
                fb = 0,
                gb = 0,
                hb = 0,
                ib = 0,
                jb = 0,
                kb = 0,
                lb = 0,
                mb = 0,
                nb = 0,
                ob = 0,
                pb = 0,
                qb = 0,
                rb = 0,
                sb = 0,
                tb = 0,
                ub = 0,
                vb = 0,
                wb = 0,
                xb = 0,
                yb = 0,
                zb = 0,
                Ab = 0,
                Bb = 0,
                Cb = 0,
                Db = 0,
                Eb = 0,
                Fb = 0,
                Gb = 0,
                Hb = 0,
                Ib = 0,
                Jb = 0,
                Kb = 0,
                Lb = 0,
                Mb = 0,
                Nb = 0,
                Ob = 0,
                Pb = 0,
                Qb = 0,
                Rb = 0,
                Sb = 0,
                Tb = 0,
                Ub = 0,
                Vb = 0,
                Wb = 0,
                Xb = 0,
                Yb = 0,
                Zb = 0,
                _b = 0,
                $b = 0,
                ac = 0,
                bc = 0,
                cc = 0,
                dc = 0,
                ec = 0,
                fc = 0,
                gc = 0,
                hc = 0,
                ic = 0,
                jc = 0,
                kc = 0,
                lc = 0,
                mc = 0,
                nc = 0,
                oc = 0,
                pc = 0,
                qc = 0,
                rc = 0,
                sc = 0;
            q = i;
            i = i + 408 | 0;
            r = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[r >> 2];
            r = q | 0;
            s = q + 400 | 0;
            t = i;
            i = i + 1 | 0;
            i = i + 7 & -8;
            u = i;
            i = i + 1 | 0;
            i = i + 7 & -8;
            v = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            w = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            x = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            y = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            z = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            A = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            B = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            C = r | 0;
            c[s >> 2] = 0;
            D = v;
            dv(D | 0, 0, 12) | 0;
            E = w;
            dv(E | 0, 0, 12) | 0;
            F = x;
            dv(F | 0, 0, 12) | 0;
            G = y;
            dv(G | 0, 0, 12) | 0;
            H = z;
            dv(H | 0, 0, 12) | 0;
            gr(g, h, s, t, u, v, w, x, y, A);
            h = n | 0;
            c[o >> 2] = c[h >> 2];
            g = e | 0;
            e = f | 0;
            f = s;
            s = m + 8 | 0;
            m = y + 1 | 0;
            I = y + 4 | 0;
            J = y + 8 | 0;
            K = x + 1 | 0;
            L = x + 4 | 0;
            M = x + 8 | 0;
            N = (j & 512 | 0) != 0;
            j = w + 1 | 0;
            O = w + 8 | 0;
            P = w + 4 | 0;
            Q = z;
            R = Q + 1 | 0;
            S = z + 8 | 0;
            T = z + 4 | 0;
            U = f + 3 | 0;
            V = n + 4 | 0;
            n = v + 4 | 0;
            W = p;
            p = 194;
            X = C;
            Y = C;
            C = r + 400 | 0;
            r = 0;
            Z = 0;
            a: while (1) {
                _ = c[g >> 2] | 0;
                do {
                    if ((_ | 0) == 0) { $ = 0 } else {
                        if ((c[_ + 12 >> 2] | 0) != (c[_ + 16 >> 2] | 0)) { $ = _; break }
                        if ((Fc[c[(c[_ >> 2] | 0) + 36 >> 2] & 255](_) | 0) == -1) {
                            c[g >> 2] = 0;
                            $ = 0;
                            break
                        } else { $ = c[g >> 2] | 0; break }
                    }
                } while (0);
                _ = ($ | 0) == 0;
                aa = c[e >> 2] | 0;
                do {
                    if ((aa | 0) == 0) { ba = 15 } else {
                        if ((c[aa + 12 >> 2] | 0) != (c[aa + 16 >> 2] | 0)) {
                            if (_) { ca = aa; break } else {
                                da = p;
                                ea = X;
                                fa = Y;
                                ga = Z;
                                ba = 310;
                                break a
                            }
                        }
                        if ((Fc[c[(c[aa >> 2] | 0) + 36 >> 2] & 255](aa) | 0) == -1) {
                            c[e >> 2] = 0;
                            ba = 15;
                            break
                        } else {
                            if (_) { ca = aa; break } else {
                                da = p;
                                ea = X;
                                fa = Y;
                                ga = Z;
                                ba = 310;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((ba | 0) == 15) {
                    ba = 0;
                    if (_) {
                        da = p;
                        ea = X;
                        fa = Y;
                        ga = Z;
                        ba = 310;
                        break
                    } else { ca = 0 }
                }
                b: do {
                    switch (a[f + r | 0] | 0) {
                        case 1:
                            {
                                if ((r | 0) == 3) {
                                    da = p;
                                    ea = X;
                                    fa = Y;
                                    ga = Z;
                                    ba = 310;
                                    break a
                                }
                                aa = c[g >> 2] | 0;ha = c[aa + 12 >> 2] | 0;
                                if ((ha | 0) == (c[aa + 16 >> 2] | 0)) { ia = (Fc[c[(c[aa >> 2] | 0) + 36 >> 2] & 255](aa) | 0) & 255 } else { ia = a[ha] | 0 }
                                if (!(ia << 24 >> 24 > -1)) { ba = 41; break a }
                                if ((b[(c[s >> 2] | 0) + (ia << 24 >> 24 << 1) >> 1] & 8192) == 0) { ba = 41; break a }
                                ha = c[g >> 2] | 0;aa = ha + 12 | 0;ja = c[aa >> 2] | 0;
                                if ((ja | 0) == (c[ha + 16 >> 2] | 0)) { ka = (Fc[c[(c[ha >> 2] | 0) + 40 >> 2] & 255](ha) | 0) & 255 } else {
                                    c[aa >> 2] = ja + 1;
                                    ka = a[ja] | 0
                                }
                                wm(z, ka);ba = 42;
                                break
                            };
                        case 0:
                            { ba = 42; break };
                        case 3:
                            {
                                ja = a[F] | 0;aa = (ja & 1) == 0;
                                if (aa) { la = (ja & 255) >>> 1 } else { la = c[L >> 2] | 0 }
                                ha = a[G] | 0;ma = (ha & 1) == 0;
                                if (ma) { na = (ha & 255) >>> 1 } else { na = c[I >> 2] | 0 }
                                if ((la | 0) == (-na | 0)) {
                                    oa = Z;
                                    pa = C;
                                    qa = Y;
                                    ra = X;
                                    sa = p;
                                    ta = W;
                                    break b
                                }
                                if (aa) { ua = (ja & 255) >>> 1 } else { ua = c[L >> 2] | 0 }
                                do {
                                    if ((ua | 0) != 0) {
                                        if (ma) { va = (ha & 255) >>> 1 } else { va = c[I >> 2] | 0 }
                                        if ((va | 0) == 0) { break }
                                        wa = c[g >> 2] | 0;
                                        xa = c[wa + 12 >> 2] | 0;
                                        ya = c[wa + 16 >> 2] | 0;
                                        if ((xa | 0) == (ya | 0)) {
                                            za = (Fc[c[(c[wa >> 2] | 0) + 36 >> 2] & 255](wa) | 0) & 255;
                                            Aa = c[g >> 2] | 0;
                                            Ba = za;
                                            Ca = a[F] | 0;
                                            Da = Aa;
                                            Ea = c[Aa + 12 >> 2] | 0;
                                            Fa = c[Aa + 16 >> 2] | 0
                                        } else {
                                            Ba = a[xa] | 0;
                                            Ca = ja;
                                            Da = wa;
                                            Ea = xa;
                                            Fa = ya
                                        }
                                        ya = Da + 12 | 0;
                                        xa = (Ea | 0) == (Fa | 0);
                                        if (Ba << 24 >> 24 == (a[(Ca & 1) == 0 ? K : c[M >> 2] | 0] | 0)) {
                                            if (xa) { Fc[c[(c[Da >> 2] | 0) + 40 >> 2] & 255](Da) | 0 } else { c[ya >> 2] = Ea + 1 }
                                            ya = a[F] | 0;
                                            if ((ya & 1) == 0) { Ga = (ya & 255) >>> 1 } else { Ga = c[L >> 2] | 0 }
                                            oa = Ga >>> 0 > 1 >>> 0 ? x : Z;
                                            pa = C;
                                            qa = Y;
                                            ra = X;
                                            sa = p;
                                            ta = W;
                                            break b
                                        }
                                        if (xa) { Ha = (Fc[c[(c[Da >> 2] | 0) + 36 >> 2] & 255](Da) | 0) & 255 } else { Ha = a[Ea] | 0 }
                                        if (!(Ha << 24 >> 24 == (a[(a[G] & 1) == 0 ? m : c[J >> 2] | 0] | 0))) { ba = 136; break a }
                                        xa = c[g >> 2] | 0;
                                        ya = xa + 12 | 0;
                                        wa = c[ya >> 2] | 0;
                                        if ((wa | 0) == (c[xa + 16 >> 2] | 0)) { Fc[c[(c[xa >> 2] | 0) + 40 >> 2] & 255](xa) | 0 } else { c[ya >> 2] = wa + 1 }
                                        a[l] = 1;
                                        wa = a[G] | 0;
                                        if ((wa & 1) == 0) { Ia = (wa & 255) >>> 1 } else { Ia = c[I >> 2] | 0 }
                                        oa = Ia >>> 0 > 1 >>> 0 ? y : Z;
                                        pa = C;
                                        qa = Y;
                                        ra = X;
                                        sa = p;
                                        ta = W;
                                        break b
                                    }
                                } while (0);
                                if (aa) { Ja = (ja & 255) >>> 1 } else { Ja = c[L >> 2] | 0 }
                                ma = c[g >> 2] | 0;wa = c[ma + 12 >> 2] | 0;ya = (wa | 0) == (c[ma + 16 >> 2] | 0);
                                if ((Ja | 0) == 0) {
                                    if (ya) {
                                        xa = (Fc[c[(c[ma >> 2] | 0) + 36 >> 2] & 255](ma) | 0) & 255;
                                        Ka = xa;
                                        La = a[G] | 0
                                    } else {
                                        Ka = a[wa] | 0;
                                        La = ha
                                    }
                                    if (!(Ka << 24 >> 24 == (a[(La & 1) == 0 ? m : c[J >> 2] | 0] | 0))) {
                                        oa = Z;
                                        pa = C;
                                        qa = Y;
                                        ra = X;
                                        sa = p;
                                        ta = W;
                                        break b
                                    }
                                    xa = c[g >> 2] | 0;
                                    Aa = xa + 12 | 0;
                                    za = c[Aa >> 2] | 0;
                                    if ((za | 0) == (c[xa + 16 >> 2] | 0)) { Fc[c[(c[xa >> 2] | 0) + 40 >> 2] & 255](xa) | 0 } else { c[Aa >> 2] = za + 1 }
                                    a[l] = 1;
                                    za = a[G] | 0;
                                    if ((za & 1) == 0) { Ma = (za & 255) >>> 1 } else { Ma = c[I >> 2] | 0 }
                                    oa = Ma >>> 0 > 1 >>> 0 ? y : Z;
                                    pa = C;
                                    qa = Y;
                                    ra = X;
                                    sa = p;
                                    ta = W;
                                    break b
                                }
                                if (ya) {
                                    ya = (Fc[c[(c[ma >> 2] | 0) + 36 >> 2] & 255](ma) | 0) & 255;
                                    Na = ya;
                                    Oa = a[F] | 0
                                } else {
                                    Na = a[wa] | 0;
                                    Oa = ja
                                }
                                if (!(Na << 24 >> 24 == (a[(Oa & 1) == 0 ? K : c[M >> 2] | 0] | 0))) {
                                    a[l] = 1;
                                    oa = Z;
                                    pa = C;
                                    qa = Y;
                                    ra = X;
                                    sa = p;
                                    ta = W;
                                    break b
                                }
                                wa = c[g >> 2] | 0;ya = wa + 12 | 0;ma = c[ya >> 2] | 0;
                                if ((ma | 0) == (c[wa + 16 >> 2] | 0)) { Fc[c[(c[wa >> 2] | 0) + 40 >> 2] & 255](wa) | 0 } else { c[ya >> 2] = ma + 1 }
                                ma = a[F] | 0;
                                if ((ma & 1) == 0) { Pa = (ma & 255) >>> 1 } else { Pa = c[L >> 2] | 0 }
                                oa = Pa >>> 0 > 1 >>> 0 ? x : Z;pa = C;qa = Y;ra = X;sa = p;ta = W;
                                break
                            };
                        case 2:
                            {
                                if (!((Z | 0) != 0 | r >>> 0 < 2 >>> 0)) {
                                    if ((r | 0) == 2) { Qa = (a[U] | 0) != 0 } else { Qa = 0 }
                                    if (!(N | Qa)) {
                                        oa = 0;
                                        pa = C;
                                        qa = Y;
                                        ra = X;
                                        sa = p;
                                        ta = W;
                                        break b
                                    }
                                }
                                ma = a[E] | 0;ya = (ma & 1) == 0;wa = ya ? j : c[O >> 2] | 0;c: do {
                                    if ((r | 0) == 0) {
                                        Ra = wa;
                                        Sa = ma;
                                        Ta = ca;
                                        Ua = ca
                                    } else {
                                        if (!((d[f + (r - 1) | 0] | 0) >>> 0 < 2 >>> 0)) {
                                            Ra = wa;
                                            Sa = ma;
                                            Ta = ca;
                                            Ua = ca;
                                            break
                                        }
                                        za = wa + (ya ? (ma & 255) >>> 1 : c[P >> 2] | 0) | 0;
                                        Aa = wa;
                                        while (1) {
                                            if ((Aa | 0) == (za | 0)) { Va = za; break }
                                            xa = a[Aa] | 0;
                                            if (!(xa << 24 >> 24 > -1)) { Va = Aa; break }
                                            if ((b[(c[s >> 2] | 0) + (xa << 24 >> 24 << 1) >> 1] & 8192) == 0) { Va = Aa; break } else { Aa = Aa + 1 | 0 }
                                        }
                                        Aa = Va - wa | 0;
                                        za = a[H] | 0;
                                        xa = (za & 1) == 0;
                                        if (xa) { Wa = (za & 255) >>> 1 } else { Wa = c[T >> 2] | 0 }
                                        if (Aa >>> 0 > Wa >>> 0) {
                                            Ra = wa;
                                            Sa = ma;
                                            Ta = ca;
                                            Ua = ca;
                                            break
                                        }
                                        if (xa) {
                                            xa = (za & 255) >>> 1;
                                            Xa = xa;
                                            Ya = R;
                                            Za = xa - Aa + (Q + 1) | 0
                                        } else {
                                            xa = c[S >> 2] | 0;
                                            za = c[T >> 2] | 0;
                                            Xa = za;
                                            Ya = xa;
                                            Za = xa + (za - Aa) | 0
                                        }
                                        Aa = Ya + Xa | 0;
                                        if ((Za | 0) == (Aa | 0)) {
                                            Ra = Va;
                                            Sa = ma;
                                            Ta = ca;
                                            Ua = ca;
                                            break
                                        } else {
                                            _a = Za;
                                            $a = wa
                                        }
                                        while (1) {
                                            if ((a[_a] | 0) != (a[$a] | 0)) {
                                                Ra = wa;
                                                Sa = ma;
                                                Ta = ca;
                                                Ua = ca;
                                                break c
                                            }
                                            za = _a + 1 | 0;
                                            if ((za | 0) == (Aa | 0)) {
                                                Ra = Va;
                                                Sa = ma;
                                                Ta = ca;
                                                Ua = ca;
                                                break
                                            } else {
                                                _a = za;
                                                $a = $a + 1 | 0
                                            }
                                        }
                                    }
                                } while (0);d: while (1) {
                                    if ((Sa & 1) == 0) {
                                        ab = (Sa & 255) >>> 1;
                                        bb = j
                                    } else {
                                        ab = c[P >> 2] | 0;
                                        bb = c[O >> 2] | 0
                                    }
                                    if ((Ra | 0) == (bb + ab | 0)) { break }
                                    ma = c[g >> 2] | 0;
                                    do {
                                        if ((ma | 0) == 0) { cb = 0 } else {
                                            if ((c[ma + 12 >> 2] | 0) != (c[ma + 16 >> 2] | 0)) { cb = ma; break }
                                            if ((Fc[c[(c[ma >> 2] | 0) + 36 >> 2] & 255](ma) | 0) == -1) {
                                                c[g >> 2] = 0;
                                                cb = 0;
                                                break
                                            } else { cb = c[g >> 2] | 0; break }
                                        }
                                    } while (0);
                                    ma = (cb | 0) == 0;
                                    do {
                                        if ((Ta | 0) == 0) {
                                            db = Ua;
                                            ba = 173
                                        } else {
                                            if ((c[Ta + 12 >> 2] | 0) != (c[Ta + 16 >> 2] | 0)) {
                                                if (ma) {
                                                    eb = Ta;
                                                    fb = Ua;
                                                    break
                                                } else { break d }
                                            }
                                            if ((Fc[c[(c[Ta >> 2] | 0) + 36 >> 2] & 255](Ta) | 0) == -1) {
                                                c[e >> 2] = 0;
                                                db = 0;
                                                ba = 173;
                                                break
                                            } else {
                                                if (ma ^ (Ua | 0) == 0) {
                                                    eb = Ua;
                                                    fb = Ua;
                                                    break
                                                } else { break d }
                                            }
                                        }
                                    } while (0);
                                    if ((ba | 0) == 173) {
                                        ba = 0;
                                        if (ma) { break } else {
                                            eb = 0;
                                            fb = db
                                        }
                                    }
                                    wa = c[g >> 2] | 0;
                                    ya = c[wa + 12 >> 2] | 0;
                                    if ((ya | 0) == (c[wa + 16 >> 2] | 0)) { gb = (Fc[c[(c[wa >> 2] | 0) + 36 >> 2] & 255](wa) | 0) & 255 } else { gb = a[ya] | 0 }
                                    if (!(gb << 24 >> 24 == (a[Ra] | 0))) { break }
                                    ya = c[g >> 2] | 0;
                                    wa = ya + 12 | 0;
                                    ja = c[wa >> 2] | 0;
                                    if ((ja | 0) == (c[ya + 16 >> 2] | 0)) { Fc[c[(c[ya >> 2] | 0) + 40 >> 2] & 255](ya) | 0 } else { c[wa >> 2] = ja + 1 }
                                    Ra = Ra + 1 | 0;
                                    Sa = a[E] | 0;
                                    Ta = eb;
                                    Ua = fb
                                }
                                if (!N) {
                                    oa = Z;
                                    pa = C;
                                    qa = Y;
                                    ra = X;
                                    sa = p;
                                    ta = W;
                                    break b
                                }
                                ja = a[E] | 0;
                                if ((ja & 1) == 0) {
                                    hb = (ja & 255) >>> 1;
                                    ib = j
                                } else {
                                    hb = c[P >> 2] | 0;
                                    ib = c[O >> 2] | 0
                                }
                                if ((Ra | 0) == (ib + hb | 0)) {
                                    oa = Z;
                                    pa = C;
                                    qa = Y;
                                    ra = X;
                                    sa = p;
                                    ta = W
                                } else { ba = 189; break a }
                                break
                            };
                        case 4:
                            {
                                ja = 0;wa = C;ya = Y;ha = X;aa = p;Aa = W;e: while (1) {
                                    za = c[g >> 2] | 0;
                                    do {
                                        if ((za | 0) == 0) { jb = 0 } else {
                                            if ((c[za + 12 >> 2] | 0) != (c[za + 16 >> 2] | 0)) { jb = za; break }
                                            if ((Fc[c[(c[za >> 2] | 0) + 36 >> 2] & 255](za) | 0) == -1) {
                                                c[g >> 2] = 0;
                                                jb = 0;
                                                break
                                            } else { jb = c[g >> 2] | 0; break }
                                        }
                                    } while (0);
                                    za = (jb | 0) == 0;
                                    ma = c[e >> 2] | 0;
                                    do {
                                        if ((ma | 0) == 0) { ba = 202 } else {
                                            if ((c[ma + 12 >> 2] | 0) != (c[ma + 16 >> 2] | 0)) { if (za) { break } else { break e } }
                                            if ((Fc[c[(c[ma >> 2] | 0) + 36 >> 2] & 255](ma) | 0) == -1) {
                                                c[e >> 2] = 0;
                                                ba = 202;
                                                break
                                            } else { if (za) { break } else { break e } }
                                        }
                                    } while (0);
                                    if ((ba | 0) == 202) { ba = 0; if (za) { break } }
                                    ma = c[g >> 2] | 0;
                                    xa = c[ma + 12 >> 2] | 0;
                                    if ((xa | 0) == (c[ma + 16 >> 2] | 0)) { kb = (Fc[c[(c[ma >> 2] | 0) + 36 >> 2] & 255](ma) | 0) & 255 } else { kb = a[xa] | 0 }
                                    do {
                                        if (kb << 24 >> 24 > -1) {
                                            if ((b[(c[s >> 2] | 0) + (kb << 24 >> 24 << 1) >> 1] & 2048) == 0) { ba = 221; break }
                                            xa = c[o >> 2] | 0;
                                            if ((xa | 0) == (Aa | 0)) {
                                                ma = (c[V >> 2] | 0) != 194;
                                                lb = c[h >> 2] | 0;
                                                mb = Aa - lb | 0;
                                                nb = mb >>> 0 < 2147483647 >>> 0 ? mb << 1 : -1;
                                                ob = Iu(ma ? lb : 0, nb) | 0;
                                                if ((ob | 0) == 0) { Uu() }
                                                do {
                                                    if (ma) {
                                                        c[h >> 2] = ob;
                                                        pb = ob
                                                    } else {
                                                        lb = c[h >> 2] | 0;
                                                        c[h >> 2] = ob;
                                                        if ((lb | 0) == 0) { pb = ob; break }
                                                        Dc[c[V >> 2] & 511](lb);
                                                        pb = c[h >> 2] | 0
                                                    }
                                                } while (0);
                                                c[V >> 2] = 88;
                                                ob = pb + mb | 0;
                                                c[o >> 2] = ob;
                                                qb = (c[h >> 2] | 0) + nb | 0;
                                                rb = ob
                                            } else {
                                                qb = Aa;
                                                rb = xa
                                            }
                                            c[o >> 2] = rb + 1;
                                            a[rb] = kb;
                                            sb = ja + 1 | 0;
                                            tb = wa;
                                            ub = ya;
                                            vb = ha;
                                            wb = aa;
                                            xb = qb
                                        } else { ba = 221 }
                                    } while (0);
                                    if ((ba | 0) == 221) {
                                        ba = 0;
                                        za = a[D] | 0;
                                        if ((za & 1) == 0) { yb = (za & 255) >>> 1 } else { yb = c[n >> 2] | 0 }
                                        if ((yb | 0) == 0 | (ja | 0) == 0) { break }
                                        if (!(kb << 24 >> 24 == (a[u] | 0))) { break }
                                        if ((ya | 0) == (wa | 0)) {
                                            za = ya - ha | 0;
                                            ob = za >>> 0 < 2147483647 >>> 0 ? za << 1 : -1;
                                            if ((aa | 0) == 194) { zb = 0 } else { zb = ha }
                                            ma = Iu(zb, ob) | 0;
                                            lb = ma;
                                            if ((ma | 0) == 0) { Uu() }
                                            Ab = lb + (ob >>> 2 << 2) | 0;
                                            Bb = lb + (za >> 2 << 2) | 0;
                                            Cb = lb;
                                            Db = 88
                                        } else {
                                            Ab = wa;
                                            Bb = ya;
                                            Cb = ha;
                                            Db = aa
                                        }
                                        c[Bb >> 2] = ja;
                                        sb = 0;
                                        tb = Ab;
                                        ub = Bb + 4 | 0;
                                        vb = Cb;
                                        wb = Db;
                                        xb = Aa
                                    }
                                    lb = c[g >> 2] | 0;
                                    za = lb + 12 | 0;
                                    ob = c[za >> 2] | 0;
                                    if ((ob | 0) == (c[lb + 16 >> 2] | 0)) {
                                        Fc[c[(c[lb >> 2] | 0) + 40 >> 2] & 255](lb) | 0;
                                        ja = sb;
                                        wa = tb;
                                        ya = ub;
                                        ha = vb;
                                        aa = wb;
                                        Aa = xb;
                                        continue
                                    } else {
                                        c[za >> 2] = ob + 1;
                                        ja = sb;
                                        wa = tb;
                                        ya = ub;
                                        ha = vb;
                                        aa = wb;
                                        Aa = xb;
                                        continue
                                    }
                                }
                                if ((ha | 0) == (ya | 0) | (ja | 0) == 0) {
                                    Eb = wa;
                                    Fb = ya;
                                    Gb = ha;
                                    Hb = aa
                                } else {
                                    if ((ya | 0) == (wa | 0)) {
                                        ob = ya - ha | 0;
                                        za = ob >>> 0 < 2147483647 >>> 0 ? ob << 1 : -1;
                                        if ((aa | 0) == 194) { Ib = 0 } else { Ib = ha }
                                        lb = Iu(Ib, za) | 0;
                                        ma = lb;
                                        if ((lb | 0) == 0) { Uu() }
                                        Jb = ma + (za >>> 2 << 2) | 0;
                                        Kb = ma + (ob >> 2 << 2) | 0;
                                        Lb = ma;
                                        Mb = 88
                                    } else {
                                        Jb = wa;
                                        Kb = ya;
                                        Lb = ha;
                                        Mb = aa
                                    }
                                    c[Kb >> 2] = ja;
                                    Eb = Jb;
                                    Fb = Kb + 4 | 0;
                                    Gb = Lb;
                                    Hb = Mb
                                }
                                if ((c[A >> 2] | 0) > 0) {
                                    ma = c[g >> 2] | 0;
                                    do {
                                        if ((ma | 0) == 0) { Nb = 0 } else {
                                            if ((c[ma + 12 >> 2] | 0) != (c[ma + 16 >> 2] | 0)) { Nb = ma; break }
                                            if ((Fc[c[(c[ma >> 2] | 0) + 36 >> 2] & 255](ma) | 0) == -1) {
                                                c[g >> 2] = 0;
                                                Nb = 0;
                                                break
                                            } else { Nb = c[g >> 2] | 0; break }
                                        }
                                    } while (0);
                                    ma = (Nb | 0) == 0;
                                    ja = c[e >> 2] | 0;
                                    do {
                                        if ((ja | 0) == 0) { ba = 257 } else {
                                            if ((c[ja + 12 >> 2] | 0) != (c[ja + 16 >> 2] | 0)) { if (ma) { Ob = ja; break } else { ba = 264; break a } }
                                            if ((Fc[c[(c[ja >> 2] | 0) + 36 >> 2] & 255](ja) | 0) == -1) {
                                                c[e >> 2] = 0;
                                                ba = 257;
                                                break
                                            } else { if (ma) { Ob = ja; break } else { ba = 264; break a } }
                                        }
                                    } while (0);
                                    if ((ba | 0) == 257) { ba = 0; if (ma) { ba = 264; break a } else { Ob = 0 } }
                                    ja = c[g >> 2] | 0;
                                    aa = c[ja + 12 >> 2] | 0;
                                    if ((aa | 0) == (c[ja + 16 >> 2] | 0)) { Pb = (Fc[c[(c[ja >> 2] | 0) + 36 >> 2] & 255](ja) | 0) & 255 } else { Pb = a[aa] | 0 }
                                    if (!(Pb << 24 >> 24 == (a[t] | 0))) { ba = 264; break a }
                                    aa = c[g >> 2] | 0;
                                    ja = aa + 12 | 0;
                                    ha = c[ja >> 2] | 0;
                                    if ((ha | 0) == (c[aa + 16 >> 2] | 0)) {
                                        Fc[c[(c[aa >> 2] | 0) + 40 >> 2] & 255](aa) | 0;
                                        Qb = Aa;
                                        Rb = Ob;
                                        Sb = Ob
                                    } else {
                                        c[ja >> 2] = ha + 1;
                                        Qb = Aa;
                                        Rb = Ob;
                                        Sb = Ob
                                    }
                                    while (1) {
                                        ha = c[g >> 2] | 0;
                                        do {
                                            if ((ha | 0) == 0) { Tb = 0 } else {
                                                if ((c[ha + 12 >> 2] | 0) != (c[ha + 16 >> 2] | 0)) { Tb = ha; break }
                                                if ((Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0) == -1) {
                                                    c[g >> 2] = 0;
                                                    Tb = 0;
                                                    break
                                                } else { Tb = c[g >> 2] | 0; break }
                                            }
                                        } while (0);
                                        ha = (Tb | 0) == 0;
                                        do {
                                            if ((Rb | 0) == 0) {
                                                Ub = Sb;
                                                ba = 280
                                            } else {
                                                if ((c[Rb + 12 >> 2] | 0) != (c[Rb + 16 >> 2] | 0)) {
                                                    if (ha) {
                                                        Vb = Sb;
                                                        Wb = Rb;
                                                        break
                                                    } else { ba = 288; break a }
                                                }
                                                if ((Fc[c[(c[Rb >> 2] | 0) + 36 >> 2] & 255](Rb) | 0) == -1) {
                                                    c[e >> 2] = 0;
                                                    Ub = 0;
                                                    ba = 280;
                                                    break
                                                } else {
                                                    if (ha ^ (Sb | 0) == 0) {
                                                        Vb = Sb;
                                                        Wb = Sb;
                                                        break
                                                    } else { ba = 288; break a }
                                                }
                                            }
                                        } while (0);
                                        if ((ba | 0) == 280) {
                                            ba = 0;
                                            if (ha) { ba = 288; break a } else {
                                                Vb = Ub;
                                                Wb = 0
                                            }
                                        }
                                        ja = c[g >> 2] | 0;
                                        aa = c[ja + 12 >> 2] | 0;
                                        if ((aa | 0) == (c[ja + 16 >> 2] | 0)) { Xb = (Fc[c[(c[ja >> 2] | 0) + 36 >> 2] & 255](ja) | 0) & 255 } else { Xb = a[aa] | 0 }
                                        if (!(Xb << 24 >> 24 > -1)) { ba = 288; break a }
                                        if ((b[(c[s >> 2] | 0) + (Xb << 24 >> 24 << 1) >> 1] & 2048) == 0) { ba = 288; break a }
                                        aa = c[o >> 2] | 0;
                                        if ((aa | 0) == (Qb | 0)) {
                                            ja = (c[V >> 2] | 0) != 194;
                                            ya = c[h >> 2] | 0;
                                            wa = Qb - ya | 0;
                                            ob = wa >>> 0 < 2147483647 >>> 0 ? wa << 1 : -1;
                                            za = Iu(ja ? ya : 0, ob) | 0;
                                            if ((za | 0) == 0) { Uu() }
                                            do {
                                                if (ja) {
                                                    c[h >> 2] = za;
                                                    Yb = za
                                                } else {
                                                    ya = c[h >> 2] | 0;
                                                    c[h >> 2] = za;
                                                    if ((ya | 0) == 0) { Yb = za; break }
                                                    Dc[c[V >> 2] & 511](ya);
                                                    Yb = c[h >> 2] | 0
                                                }
                                            } while (0);
                                            c[V >> 2] = 88;
                                            za = Yb + wa | 0;
                                            c[o >> 2] = za;
                                            Zb = (c[h >> 2] | 0) + ob | 0;
                                            _b = za
                                        } else {
                                            Zb = Qb;
                                            _b = aa
                                        }
                                        za = c[g >> 2] | 0;
                                        ja = c[za + 12 >> 2] | 0;
                                        if ((ja | 0) == (c[za + 16 >> 2] | 0)) {
                                            ha = (Fc[c[(c[za >> 2] | 0) + 36 >> 2] & 255](za) | 0) & 255;
                                            $b = ha;
                                            ac = c[o >> 2] | 0
                                        } else {
                                            $b = a[ja] | 0;
                                            ac = _b
                                        }
                                        c[o >> 2] = ac + 1;
                                        a[ac] = $b;
                                        ja = (c[A >> 2] | 0) - 1 | 0;
                                        c[A >> 2] = ja;
                                        ha = c[g >> 2] | 0;
                                        za = ha + 12 | 0;
                                        ya = c[za >> 2] | 0;
                                        if ((ya | 0) == (c[ha + 16 >> 2] | 0)) { Fc[c[(c[ha >> 2] | 0) + 40 >> 2] & 255](ha) | 0 } else { c[za >> 2] = ya + 1 }
                                        if ((ja | 0) > 0) {
                                            Qb = Zb;
                                            Rb = Wb;
                                            Sb = Vb
                                        } else { bc = Zb; break }
                                    }
                                } else { bc = Aa }
                                if ((c[o >> 2] | 0) == (c[h >> 2] | 0)) { ba = 308; break a } else {
                                    oa = Z;
                                    pa = Eb;
                                    qa = Fb;
                                    ra = Gb;
                                    sa = Hb;
                                    ta = bc
                                }
                                break
                            };
                        default:
                            { oa = Z;pa = C;qa = Y;ra = X;sa = p;ta = W }
                    }
                } while (0);
                f: do {
                    if ((ba | 0) == 42) {
                        ba = 0;
                        if ((r | 0) == 3) {
                            da = p;
                            ea = X;
                            fa = Y;
                            ga = Z;
                            ba = 310;
                            break a
                        } else {
                            cc = ca;
                            dc = ca
                        }
                        while (1) {
                            _ = c[g >> 2] | 0;
                            do {
                                if ((_ | 0) == 0) { ec = 0 } else {
                                    if ((c[_ + 12 >> 2] | 0) != (c[_ + 16 >> 2] | 0)) { ec = _; break }
                                    if ((Fc[c[(c[_ >> 2] | 0) + 36 >> 2] & 255](_) | 0) == -1) {
                                        c[g >> 2] = 0;
                                        ec = 0;
                                        break
                                    } else { ec = c[g >> 2] | 0; break }
                                }
                            } while (0);
                            _ = (ec | 0) == 0;
                            do {
                                if ((cc | 0) == 0) {
                                    fc = dc;
                                    ba = 55
                                } else {
                                    if ((c[cc + 12 >> 2] | 0) != (c[cc + 16 >> 2] | 0)) {
                                        if (_) {
                                            gc = cc;
                                            hc = dc;
                                            break
                                        } else {
                                            oa = Z;
                                            pa = C;
                                            qa = Y;
                                            ra = X;
                                            sa = p;
                                            ta = W;
                                            break f
                                        }
                                    }
                                    if ((Fc[c[(c[cc >> 2] | 0) + 36 >> 2] & 255](cc) | 0) == -1) {
                                        c[e >> 2] = 0;
                                        fc = 0;
                                        ba = 55;
                                        break
                                    } else {
                                        if (_ ^ (dc | 0) == 0) {
                                            gc = dc;
                                            hc = dc;
                                            break
                                        } else {
                                            oa = Z;
                                            pa = C;
                                            qa = Y;
                                            ra = X;
                                            sa = p;
                                            ta = W;
                                            break f
                                        }
                                    }
                                }
                            } while (0);
                            if ((ba | 0) == 55) {
                                ba = 0;
                                if (_) {
                                    oa = Z;
                                    pa = C;
                                    qa = Y;
                                    ra = X;
                                    sa = p;
                                    ta = W;
                                    break f
                                } else {
                                    gc = 0;
                                    hc = fc
                                }
                            }
                            aa = c[g >> 2] | 0;
                            ob = c[aa + 12 >> 2] | 0;
                            if ((ob | 0) == (c[aa + 16 >> 2] | 0)) { ic = (Fc[c[(c[aa >> 2] | 0) + 36 >> 2] & 255](aa) | 0) & 255 } else { ic = a[ob] | 0 }
                            if (!(ic << 24 >> 24 > -1)) {
                                oa = Z;
                                pa = C;
                                qa = Y;
                                ra = X;
                                sa = p;
                                ta = W;
                                break f
                            }
                            if ((b[(c[s >> 2] | 0) + (ic << 24 >> 24 << 1) >> 1] & 8192) == 0) {
                                oa = Z;
                                pa = C;
                                qa = Y;
                                ra = X;
                                sa = p;
                                ta = W;
                                break f
                            }
                            ob = c[g >> 2] | 0;
                            aa = ob + 12 | 0;
                            wa = c[aa >> 2] | 0;
                            if ((wa | 0) == (c[ob + 16 >> 2] | 0)) { jc = (Fc[c[(c[ob >> 2] | 0) + 40 >> 2] & 255](ob) | 0) & 255 } else {
                                c[aa >> 2] = wa + 1;
                                jc = a[wa] | 0
                            }
                            wm(z, jc);
                            cc = gc;
                            dc = hc
                        }
                    }
                } while (0);
                Aa = r + 1 | 0;
                if (Aa >>> 0 < 4 >>> 0) {
                    W = ta;
                    p = sa;
                    X = ra;
                    Y = qa;
                    C = pa;
                    r = Aa;
                    Z = oa
                } else {
                    da = sa;
                    ea = ra;
                    fa = qa;
                    ga = oa;
                    ba = 310;
                    break
                }
            }
            g: do {
                if ((ba | 0) == 41) {
                    c[k >> 2] = c[k >> 2] | 4;
                    kc = 0;
                    lc = X;
                    mc = p
                } else if ((ba | 0) == 136) {
                    c[k >> 2] = c[k >> 2] | 4;
                    kc = 0;
                    lc = X;
                    mc = p
                } else if ((ba | 0) == 189) {
                    c[k >> 2] = c[k >> 2] | 4;
                    kc = 0;
                    lc = X;
                    mc = p
                } else if ((ba | 0) == 264) {
                    c[k >> 2] = c[k >> 2] | 4;
                    kc = 0;
                    lc = Gb;
                    mc = Hb
                } else if ((ba | 0) == 288) {
                    c[k >> 2] = c[k >> 2] | 4;
                    kc = 0;
                    lc = Gb;
                    mc = Hb
                } else if ((ba | 0) == 308) {
                    c[k >> 2] = c[k >> 2] | 4;
                    kc = 0;
                    lc = Gb;
                    mc = Hb
                } else if ((ba | 0) == 310) {
                    h: do {
                        if ((ga | 0) != 0) {
                            oa = ga;
                            qa = ga + 1 | 0;
                            ra = ga + 8 | 0;
                            sa = ga + 4 | 0;
                            Z = 1;
                            i: while (1) {
                                r = a[oa] | 0;
                                if ((r & 1) == 0) { nc = (r & 255) >>> 1 } else { nc = c[sa >> 2] | 0 }
                                if (!(Z >>> 0 < nc >>> 0)) { break h }
                                r = c[g >> 2] | 0;
                                do {
                                    if ((r | 0) == 0) { oc = 0 } else {
                                        if ((c[r + 12 >> 2] | 0) != (c[r + 16 >> 2] | 0)) { oc = r; break }
                                        if ((Fc[c[(c[r >> 2] | 0) + 36 >> 2] & 255](r) | 0) == -1) {
                                            c[g >> 2] = 0;
                                            oc = 0;
                                            break
                                        } else { oc = c[g >> 2] | 0; break }
                                    }
                                } while (0);
                                r = (oc | 0) == 0;
                                _ = c[e >> 2] | 0;
                                do {
                                    if ((_ | 0) == 0) { ba = 328 } else {
                                        if ((c[_ + 12 >> 2] | 0) != (c[_ + 16 >> 2] | 0)) { if (r) { break } else { break i } }
                                        if ((Fc[c[(c[_ >> 2] | 0) + 36 >> 2] & 255](_) | 0) == -1) {
                                            c[e >> 2] = 0;
                                            ba = 328;
                                            break
                                        } else { if (r) { break } else { break i } }
                                    }
                                } while (0);
                                if ((ba | 0) == 328) { ba = 0; if (r) { break } }
                                _ = c[g >> 2] | 0;
                                pa = c[_ + 12 >> 2] | 0;
                                if ((pa | 0) == (c[_ + 16 >> 2] | 0)) { pc = (Fc[c[(c[_ >> 2] | 0) + 36 >> 2] & 255](_) | 0) & 255 } else { pc = a[pa] | 0 }
                                if ((a[oa] & 1) == 0) { qc = qa } else { qc = c[ra >> 2] | 0 }
                                if (!(pc << 24 >> 24 == (a[qc + Z | 0] | 0))) { break }
                                pa = Z + 1 | 0;
                                _ = c[g >> 2] | 0;
                                C = _ + 12 | 0;
                                Y = c[C >> 2] | 0;
                                if ((Y | 0) == (c[_ + 16 >> 2] | 0)) {
                                    Fc[c[(c[_ >> 2] | 0) + 40 >> 2] & 255](_) | 0;
                                    Z = pa;
                                    continue
                                } else {
                                    c[C >> 2] = Y + 1;
                                    Z = pa;
                                    continue
                                }
                            }
                            c[k >> 2] = c[k >> 2] | 4;
                            kc = 0;
                            lc = ea;
                            mc = da;
                            break g
                        }
                    } while (0);
                    if ((ea | 0) == (fa | 0)) {
                        kc = 1;
                        lc = fa;
                        mc = da;
                        break
                    }
                    c[B >> 2] = 0;hr(v, ea, fa, B);
                    if ((c[B >> 2] | 0) == 0) {
                        kc = 1;
                        lc = ea;
                        mc = da;
                        break
                    }
                    c[k >> 2] = c[k >> 2] | 4;kc = 0;lc = ea;mc = da
                }
            } while (0);
            rm(z);
            rm(y);
            rm(x);
            rm(w);
            rm(v);
            if ((lc | 0) == 0) {
                rc = 400;
                sc = 0;
                i = q;
                return kc | 0
            }
            Dc[mc & 511](lc);
            rc = 400;
            sc = 0;
            i = q;
            return kc | 0
        }

        function dr(a) {
            a = a | 0;
            var b = 0;
            b = pc(8) | 0;
            _l(b, a);
            Fb(b | 0, 25560, 30)
        }

        function er(b, d, e, f, g, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            d = i;
            i = i + 160 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d | 0;
            m = d + 16 | 0;
            n = d + 120 | 0;
            o = d + 128 | 0;
            p = d + 136 | 0;
            q = d + 144 | 0;
            r = d + 152 | 0;
            s = n | 0;
            c[s >> 2] = m;
            t = n + 4 | 0;
            c[t >> 2] = 194;
            u = m + 100 | 0;
            Lm(p, h);
            m = p | 0;
            v = c[m >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[l >> 2] = 34864;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34864, l, 114)
            }
            l = (c[8717] | 0) - 1 | 0;
            w = c[v + 8 >> 2] | 0;
            do {
                if ((c[v + 12 >> 2] | 0) - w >> 2 >>> 0 > l >>> 0) {
                    x = c[w + (l << 2) >> 2] | 0;
                    if ((x | 0) == 0) { break }
                    y = x;
                    a[q] = 0;
                    z = f | 0;
                    A = c[z >> 2] | 0;
                    c[r >> 2] = A;
                    if (cr(e, r, g, p, c[h + 4 >> 2] | 0, j, q, y, n, o, u) | 0) {
                        B = k;
                        if ((a[B] & 1) == 0) {
                            a[k + 1 | 0] = 0;
                            a[B] = 0
                        } else {
                            a[c[k + 8 >> 2] | 0] = 0;
                            c[k + 4 >> 2] = 0
                        }
                        B = x;
                        if ((a[q] | 0) != 0) { wm(k, Qc[c[(c[B >> 2] | 0) + 28 >> 2] & 63](y, 45) | 0) }
                        x = Qc[c[(c[B >> 2] | 0) + 28 >> 2] & 63](y, 48) | 0;
                        y = c[s >> 2] | 0;
                        B = c[o >> 2] | 0;
                        C = B - 1 | 0;
                        a: do { if (y >>> 0 < C >>> 0) { D = y; while (1) { E = D + 1 | 0; if (!((a[D] | 0) == x << 24 >> 24)) { F = D; break a } if (E >>> 0 < C >>> 0) { D = E } else { F = E; break } } } else { F = y } } while (0);
                        fr(k, F, B) | 0
                    }
                    y = e | 0;
                    C = c[y >> 2] | 0;
                    do {
                        if ((C | 0) == 0) { G = 0 } else {
                            if ((c[C + 12 >> 2] | 0) != (c[C + 16 >> 2] | 0)) { G = C; break }
                            if (!((Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0) == -1)) { G = C; break }
                            c[y >> 2] = 0;
                            G = 0
                        }
                    } while (0);
                    y = (G | 0) == 0;
                    do {
                        if ((A | 0) == 0) { H = 33 } else {
                            if ((c[A + 12 >> 2] | 0) != (c[A + 16 >> 2] | 0)) { if (y) { break } else { H = 35; break } }
                            if ((Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0) == -1) {
                                c[z >> 2] = 0;
                                H = 33;
                                break
                            } else { if (y ^ (A | 0) == 0) { break } else { H = 35; break } }
                        }
                    } while (0);
                    if ((H | 0) == 33) { if (y) { H = 35 } }
                    if ((H | 0) == 35) { c[j >> 2] = c[j >> 2] | 2 }
                    c[b >> 2] = G;
                    Ul(c[m >> 2] | 0) | 0;
                    A = c[s >> 2] | 0;
                    c[s >> 2] = 0;
                    if ((A | 0) == 0) {
                        I = 100;
                        J = 0;
                        i = d;
                        return
                    }
                    Dc[c[t >> 2] & 511](A);
                    I = 100;
                    J = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function fr(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            f = b;
            g = d;
            h = a[f] | 0;
            if ((h & 1) == 0) {
                i = 10;
                j = h;
                k = (h & 255) >>> 1
            } else {
                h = c[b >> 2] | 0;
                i = (h & -2) - 1 | 0;
                j = h & 255;
                k = c[b + 4 >> 2] | 0
            }
            h = e - g | 0;
            if ((e | 0) == (d | 0)) { return b | 0 }
            if ((i - k | 0) >>> 0 < h >>> 0) {
                zm(b, i, k + h - i | 0, k, k, 0, 0);
                l = a[f] | 0
            } else { l = j }
            if ((l & 1) == 0) { m = b + 1 | 0 } else { m = c[b + 8 >> 2] | 0 }
            l = e + (k - g) | 0;
            g = d;
            d = m + k | 0;
            while (1) {
                a[d] = a[g] | 0;
                j = g + 1 | 0;
                if ((j | 0) == (e | 0)) { break } else {
                    g = j;
                    d = d + 1 | 0
                }
            }
            a[m + l | 0] = 0;
            l = k + h | 0;
            if ((a[f] & 1) == 0) { a[f] = l << 1; return b | 0 } else { c[b + 4 >> 2] = l; return b | 0 }
            return 0
        }

        function gr(b, d, e, f, g, h, j, k, l, m) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0;
            n = i;
            i = i + 176 | 0;
            o = n | 0;
            p = n + 16 | 0;
            q = n + 32 | 0;
            r = n + 40 | 0;
            s = n + 56 | 0;
            t = n + 72 | 0;
            u = n + 88 | 0;
            v = n + 104 | 0;
            w = n + 112 | 0;
            x = n + 128 | 0;
            y = n + 144 | 0;
            z = n + 160 | 0;
            if (b) {
                b = c[d >> 2] | 0;
                if (!((c[8834] | 0) == -1)) {
                    c[p >> 2] = 35336;
                    c[p + 4 >> 2] = 16;
                    c[p + 8 >> 2] = 0;
                    mm(35336, p, 114)
                }
                p = (c[8835] | 0) - 1 | 0;
                A = c[b + 8 >> 2] | 0;
                if (!((c[b + 12 >> 2] | 0) - A >> 2 >>> 0 > p >>> 0)) {
                    B = pc(4) | 0;
                    D = B;
                    lu(D);
                    Fb(B | 0, 25544, 156)
                }
                b = c[A + (p << 2) >> 2] | 0;
                if ((b | 0) == 0) {
                    B = pc(4) | 0;
                    D = B;
                    lu(D);
                    Fb(B | 0, 25544, 156)
                }
                B = b;
                Ec[c[(c[b >> 2] | 0) + 44 >> 2] & 127](q, B);
                D = e;
                C = c[q >> 2] | 0;
                a[D] = C;
                C = C >> 8;
                a[D + 1 | 0] = C;
                C = C >> 8;
                a[D + 2 | 0] = C;
                C = C >> 8;
                a[D + 3 | 0] = C;
                D = b;
                Ec[c[(c[D >> 2] | 0) + 32 >> 2] & 127](r, B);
                q = l;
                if ((a[q] & 1) == 0) {
                    a[l + 1 | 0] = 0;
                    a[q] = 0
                } else {
                    a[c[l + 8 >> 2] | 0] = 0;
                    c[l + 4 >> 2] = 0
                }
                vm(l, 0);
                p = r;
                c[q >> 2] = c[p >> 2];
                c[q + 4 >> 2] = c[p + 4 >> 2];
                c[q + 8 >> 2] = c[p + 8 >> 2];
                dv(p | 0, 0, 12) | 0;
                rm(r);
                Ec[c[(c[D >> 2] | 0) + 28 >> 2] & 127](s, B);
                r = k;
                if ((a[r] & 1) == 0) {
                    a[k + 1 | 0] = 0;
                    a[r] = 0
                } else {
                    a[c[k + 8 >> 2] | 0] = 0;
                    c[k + 4 >> 2] = 0
                }
                vm(k, 0);
                p = s;
                c[r >> 2] = c[p >> 2];
                c[r + 4 >> 2] = c[p + 4 >> 2];
                c[r + 8 >> 2] = c[p + 8 >> 2];
                dv(p | 0, 0, 12) | 0;
                rm(s);
                s = b;
                p = Fc[c[(c[s >> 2] | 0) + 12 >> 2] & 255](B) | 0;
                a[f] = p;
                p = Fc[c[(c[s >> 2] | 0) + 16 >> 2] & 255](B) | 0;
                a[g] = p;
                Ec[c[(c[D >> 2] | 0) + 20 >> 2] & 127](t, B);
                p = h;
                if ((a[p] & 1) == 0) {
                    a[h + 1 | 0] = 0;
                    a[p] = 0
                } else {
                    a[c[h + 8 >> 2] | 0] = 0;
                    c[h + 4 >> 2] = 0
                }
                vm(h, 0);
                s = t;
                c[p >> 2] = c[s >> 2];
                c[p + 4 >> 2] = c[s + 4 >> 2];
                c[p + 8 >> 2] = c[s + 8 >> 2];
                dv(s | 0, 0, 12) | 0;
                rm(t);
                Ec[c[(c[D >> 2] | 0) + 24 >> 2] & 127](u, B);
                D = j;
                if ((a[D] & 1) == 0) {
                    a[j + 1 | 0] = 0;
                    a[D] = 0
                } else {
                    a[c[j + 8 >> 2] | 0] = 0;
                    c[j + 4 >> 2] = 0
                }
                vm(j, 0);
                t = u;
                c[D >> 2] = c[t >> 2];
                c[D + 4 >> 2] = c[t + 4 >> 2];
                c[D + 8 >> 2] = c[t + 8 >> 2];
                dv(t | 0, 0, 12) | 0;
                rm(u);
                E = Fc[c[(c[b >> 2] | 0) + 36 >> 2] & 255](B) | 0;
                c[m >> 2] = E;
                i = n;
                return
            } else {
                B = c[d >> 2] | 0;
                if (!((c[8836] | 0) == -1)) {
                    c[o >> 2] = 35344;
                    c[o + 4 >> 2] = 16;
                    c[o + 8 >> 2] = 0;
                    mm(35344, o, 114)
                }
                o = (c[8837] | 0) - 1 | 0;
                d = c[B + 8 >> 2] | 0;
                if (!((c[B + 12 >> 2] | 0) - d >> 2 >>> 0 > o >>> 0)) {
                    F = pc(4) | 0;
                    G = F;
                    lu(G);
                    Fb(F | 0, 25544, 156)
                }
                B = c[d + (o << 2) >> 2] | 0;
                if ((B | 0) == 0) {
                    F = pc(4) | 0;
                    G = F;
                    lu(G);
                    Fb(F | 0, 25544, 156)
                }
                F = B;
                Ec[c[(c[B >> 2] | 0) + 44 >> 2] & 127](v, F);
                G = e;
                C = c[v >> 2] | 0;
                a[G] = C;
                C = C >> 8;
                a[G + 1 | 0] = C;
                C = C >> 8;
                a[G + 2 | 0] = C;
                C = C >> 8;
                a[G + 3 | 0] = C;
                G = B;
                Ec[c[(c[G >> 2] | 0) + 32 >> 2] & 127](w, F);
                v = l;
                if ((a[v] & 1) == 0) {
                    a[l + 1 | 0] = 0;
                    a[v] = 0
                } else {
                    a[c[l + 8 >> 2] | 0] = 0;
                    c[l + 4 >> 2] = 0
                }
                vm(l, 0);
                l = w;
                c[v >> 2] = c[l >> 2];
                c[v + 4 >> 2] = c[l + 4 >> 2];
                c[v + 8 >> 2] = c[l + 8 >> 2];
                dv(l | 0, 0, 12) | 0;
                rm(w);
                Ec[c[(c[G >> 2] | 0) + 28 >> 2] & 127](x, F);
                w = k;
                if ((a[w] & 1) == 0) {
                    a[k + 1 | 0] = 0;
                    a[w] = 0
                } else {
                    a[c[k + 8 >> 2] | 0] = 0;
                    c[k + 4 >> 2] = 0
                }
                vm(k, 0);
                k = x;
                c[w >> 2] = c[k >> 2];
                c[w + 4 >> 2] = c[k + 4 >> 2];
                c[w + 8 >> 2] = c[k + 8 >> 2];
                dv(k | 0, 0, 12) | 0;
                rm(x);
                x = B;
                k = Fc[c[(c[x >> 2] | 0) + 12 >> 2] & 255](F) | 0;
                a[f] = k;
                k = Fc[c[(c[x >> 2] | 0) + 16 >> 2] & 255](F) | 0;
                a[g] = k;
                Ec[c[(c[G >> 2] | 0) + 20 >> 2] & 127](y, F);
                k = h;
                if ((a[k] & 1) == 0) {
                    a[h + 1 | 0] = 0;
                    a[k] = 0
                } else {
                    a[c[h + 8 >> 2] | 0] = 0;
                    c[h + 4 >> 2] = 0
                }
                vm(h, 0);
                h = y;
                c[k >> 2] = c[h >> 2];
                c[k + 4 >> 2] = c[h + 4 >> 2];
                c[k + 8 >> 2] = c[h + 8 >> 2];
                dv(h | 0, 0, 12) | 0;
                rm(y);
                Ec[c[(c[G >> 2] | 0) + 24 >> 2] & 127](z, F);
                G = j;
                if ((a[G] & 1) == 0) {
                    a[j + 1 | 0] = 0;
                    a[G] = 0
                } else {
                    a[c[j + 8 >> 2] | 0] = 0;
                    c[j + 4 >> 2] = 0
                }
                vm(j, 0);
                j = z;
                c[G >> 2] = c[j >> 2];
                c[G + 4 >> 2] = c[j + 4 >> 2];
                c[G + 8 >> 2] = c[j + 8 >> 2];
                dv(j | 0, 0, 12) | 0;
                rm(z);
                E = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](F) | 0;
                c[m >> 2] = E;
                i = n;
                return
            }
        }

        function hr(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            g = b;
            h = a[g] | 0;
            if ((h & 1) == 0) { i = (h & 255) >>> 1 } else { i = c[b + 4 >> 2] | 0 }
            if ((i | 0) == 0) { return }
            do {
                if ((d | 0) == (e | 0)) { j = h } else {
                    i = e - 4 | 0;
                    if (i >>> 0 > d >>> 0) {
                        k = d;
                        l = i
                    } else { j = h; break }
                    do {
                        i = c[k >> 2] | 0;
                        c[k >> 2] = c[l >> 2];
                        c[l >> 2] = i;
                        k = k + 4 | 0;
                        l = l - 4 | 0;
                    } while (k >>> 0 < l >>> 0);
                    j = a[g] | 0
                }
            } while (0);
            if ((j & 1) == 0) {
                m = (j & 255) >>> 1;
                n = b + 1 | 0
            } else {
                m = c[b + 4 >> 2] | 0;
                n = c[b + 8 >> 2] | 0
            }
            b = e - 4 | 0;
            e = a[n] | 0;
            j = e << 24 >> 24 < 1 | e << 24 >> 24 == 127;
            a: do {
                if (b >>> 0 > d >>> 0) {
                    g = n + m | 0;
                    l = n;
                    k = d;
                    h = e;
                    i = j;
                    while (1) {
                        if (!i) { if ((h << 24 >> 24 | 0) != (c[k >> 2] | 0)) { break } }
                        o = (g - l | 0) > 1 ? l + 1 | 0 : l;
                        p = k + 4 | 0;
                        q = a[o] | 0;
                        r = q << 24 >> 24 < 1 | q << 24 >> 24 == 127;
                        if (p >>> 0 < b >>> 0) {
                            l = o;
                            k = p;
                            h = q;
                            i = r
                        } else {
                            s = q;
                            t = r;
                            break a
                        }
                    }
                    c[f >> 2] = 4;
                    return
                } else {
                    s = e;
                    t = j
                }
            } while (0);
            if (t) { return }
            t = c[b >> 2] | 0;
            if (!(s << 24 >> 24 >>> 0 < t >>> 0 | (t | 0) == 0)) { return }
            c[f >> 2] = 4;
            return
        }

        function ir(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function jr(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function kr(b, d, e, f, g, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0;
            d = i;
            i = i + 600 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d | 0;
            m = d + 16 | 0;
            n = d + 416 | 0;
            o = d + 424 | 0;
            p = d + 432 | 0;
            q = d + 440 | 0;
            r = d + 448 | 0;
            s = d + 456 | 0;
            t = d + 496 | 0;
            u = n | 0;
            c[u >> 2] = m;
            v = n + 4 | 0;
            c[v >> 2] = 194;
            w = m + 400 | 0;
            Lm(p, h);
            m = p | 0;
            x = c[m >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[l >> 2] = 34856;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34856, l, 114)
            }
            l = (c[8715] | 0) - 1 | 0;
            y = c[x + 8 >> 2] | 0;
            do {
                if ((c[x + 12 >> 2] | 0) - y >> 2 >>> 0 > l >>> 0) {
                    z = c[y + (l << 2) >> 2] | 0;
                    if ((z | 0) == 0) { break }
                    A = z;
                    a[q] = 0;
                    B = f | 0;
                    c[r >> 2] = c[B >> 2];
                    do {
                        if (lr(e, r, g, p, c[h + 4 >> 2] | 0, j, q, A, n, o, w) | 0) {
                            C = s | 0;
                            Sc[c[(c[z >> 2] | 0) + 48 >> 2] & 15](A, 19144, 19154, C) | 0;
                            D = t | 0;
                            E = c[o >> 2] | 0;
                            F = c[u >> 2] | 0;
                            G = E - F | 0;
                            do {
                                if ((G | 0) > 392) {
                                    H = Gu((G >> 2) + 2 | 0) | 0;
                                    if ((H | 0) != 0) {
                                        I = H;
                                        J = H;
                                        break
                                    }
                                    Uu();
                                    I = 0;
                                    J = 0
                                } else {
                                    I = D;
                                    J = 0
                                }
                            } while (0);
                            if ((a[q] | 0) == 0) { K = I } else {
                                a[I] = 45;
                                K = I + 1 | 0
                            }
                            if (F >>> 0 < E >>> 0) {
                                G = s + 40 | 0;
                                H = s;
                                L = K;
                                M = F;
                                while (1) {
                                    N = c[M >> 2] | 0;
                                    O = C;
                                    while (1) { P = O + 4 | 0; if ((c[O >> 2] | 0) == (N | 0)) { Q = O; break } if ((P | 0) == (G | 0)) { Q = G; break } else { O = P } }
                                    a[L] = a[19144 + (Q - H >> 2) | 0] | 0;
                                    O = M + 4 | 0;
                                    N = L + 1 | 0;
                                    if (O >>> 0 < (c[o >> 2] | 0) >>> 0) {
                                        L = N;
                                        M = O
                                    } else { R = N; break }
                                }
                            } else { R = K }
                            a[R] = 0;
                            M = dc(D | 0, 15784, (L = i, i = i + 8 | 0, c[L >> 2] = k, L) | 0) | 0;
                            i = L;
                            if ((M | 0) == 1) {
                                if ((J | 0) == 0) { break }
                                Hu(J);
                                break
                            }
                            M = pc(8) | 0;
                            _l(M, 15400);
                            Fb(M | 0, 25560, 30)
                        }
                    } while (0);
                    A = e | 0;
                    z = c[A >> 2] | 0;
                    do {
                        if ((z | 0) == 0) { S = 1 } else {
                            M = c[z + 12 >> 2] | 0;
                            if ((M | 0) == (c[z + 16 >> 2] | 0)) { T = Fc[c[(c[z >> 2] | 0) + 36 >> 2] & 255](z) | 0 } else { T = c[M >> 2] | 0 }
                            if ((T | 0) == -1) {
                                c[A >> 2] = 0;
                                S = 1;
                                break
                            } else { S = (c[A >> 2] | 0) == 0; break }
                        }
                    } while (0);
                    z = c[B >> 2] | 0;
                    do {
                        if ((z | 0) == 0) { U = 47 } else {
                            M = c[z + 12 >> 2] | 0;
                            if ((M | 0) == (c[z + 16 >> 2] | 0)) { V = Fc[c[(c[z >> 2] | 0) + 36 >> 2] & 255](z) | 0 } else { V = c[M >> 2] | 0 }
                            if ((V | 0) == -1) {
                                c[B >> 2] = 0;
                                U = 47;
                                break
                            } else { if (S) { break } else { U = 49; break } }
                        }
                    } while (0);
                    if ((U | 0) == 47) { if (S) { U = 49 } }
                    if ((U | 0) == 49) { c[j >> 2] = c[j >> 2] | 2 }
                    c[b >> 2] = c[A >> 2];
                    Ul(c[m >> 2] | 0) | 0;
                    B = c[u >> 2] | 0;
                    c[u >> 2] = 0;
                    if ((B | 0) == 0) {
                        W = 400;
                        X = 0;
                        i = d;
                        return
                    }
                    Dc[c[v >> 2] & 511](B);
                    W = 400;
                    X = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function lr(b, e, f, g, h, j, k, l, m, n, o) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            var p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0,
                Fa = 0,
                Ga = 0,
                Ha = 0,
                Ia = 0,
                Ja = 0,
                Ka = 0,
                La = 0,
                Ma = 0,
                Na = 0,
                Oa = 0,
                Pa = 0,
                Qa = 0,
                Ra = 0,
                Sa = 0,
                Ta = 0,
                Ua = 0,
                Va = 0,
                Wa = 0,
                Xa = 0,
                Ya = 0,
                Za = 0,
                _a = 0,
                $a = 0,
                ab = 0,
                bb = 0,
                cb = 0,
                db = 0,
                eb = 0,
                fb = 0,
                gb = 0,
                hb = 0,
                ib = 0,
                jb = 0,
                kb = 0,
                lb = 0,
                mb = 0,
                nb = 0,
                ob = 0,
                pb = 0,
                qb = 0,
                rb = 0,
                sb = 0,
                tb = 0,
                ub = 0,
                vb = 0,
                wb = 0,
                xb = 0,
                yb = 0,
                zb = 0,
                Ab = 0,
                Bb = 0,
                Cb = 0,
                Db = 0,
                Eb = 0,
                Fb = 0,
                Gb = 0,
                Hb = 0,
                Ib = 0,
                Jb = 0,
                Kb = 0,
                Lb = 0,
                Mb = 0,
                Nb = 0,
                Ob = 0,
                Pb = 0,
                Qb = 0,
                Rb = 0,
                Sb = 0,
                Tb = 0,
                Ub = 0,
                Vb = 0,
                Wb = 0,
                Xb = 0,
                Yb = 0,
                Zb = 0,
                _b = 0,
                $b = 0,
                ac = 0,
                bc = 0,
                cc = 0,
                dc = 0,
                ec = 0,
                fc = 0,
                gc = 0,
                hc = 0,
                ic = 0,
                jc = 0,
                kc = 0,
                lc = 0,
                mc = 0,
                nc = 0,
                oc = 0,
                pc = 0,
                qc = 0;
            p = i;
            i = i + 416 | 0;
            q = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[q >> 2];
            q = p | 0;
            r = p + 8 | 0;
            s = p + 408 | 0;
            t = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            u = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            v = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            w = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            x = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            y = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            z = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            A = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            B = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[q >> 2] = o;
            o = r | 0;
            c[s >> 2] = 0;
            C = v;
            dv(C | 0, 0, 12) | 0;
            D = w;
            dv(D | 0, 0, 12) | 0;
            E = x;
            dv(E | 0, 0, 12) | 0;
            F = y;
            dv(F | 0, 0, 12) | 0;
            G = z;
            dv(G | 0, 0, 12) | 0;
            or(f, g, s, t, u, v, w, x, y, A);
            g = m | 0;
            c[n >> 2] = c[g >> 2];
            f = b | 0;
            b = e | 0;
            e = s;
            s = l;
            H = y + 4 | 0;
            I = y + 8 | 0;
            J = x + 4 | 0;
            K = x + 8 | 0;
            L = (h & 512 | 0) != 0;
            h = w + 4 | 0;
            M = w + 8 | 0;
            N = z + 4 | 0;
            O = z + 8 | 0;
            P = e + 3 | 0;
            Q = v + 4 | 0;
            R = 194;
            S = o;
            T = o;
            o = r + 400 | 0;
            r = 0;
            U = 0;
            a: while (1) {
                V = c[f >> 2] | 0;
                do {
                    if ((V | 0) == 0) { W = 1 } else {
                        X = c[V + 12 >> 2] | 0;
                        if ((X | 0) == (c[V + 16 >> 2] | 0)) { Y = Fc[c[(c[V >> 2] | 0) + 36 >> 2] & 255](V) | 0 } else { Y = c[X >> 2] | 0 }
                        if ((Y | 0) == -1) {
                            c[f >> 2] = 0;
                            W = 1;
                            break
                        } else { W = (c[f >> 2] | 0) == 0; break }
                    }
                } while (0);
                V = c[b >> 2] | 0;
                do {
                    if ((V | 0) == 0) { Z = 16 } else {
                        X = c[V + 12 >> 2] | 0;
                        if ((X | 0) == (c[V + 16 >> 2] | 0)) { _ = Fc[c[(c[V >> 2] | 0) + 36 >> 2] & 255](V) | 0 } else { _ = c[X >> 2] | 0 }
                        if ((_ | 0) == -1) {
                            c[b >> 2] = 0;
                            Z = 16;
                            break
                        } else {
                            if (W) { $ = V; break } else {
                                aa = R;
                                ba = S;
                                ca = T;
                                da = U;
                                Z = 302;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((Z | 0) == 16) {
                    Z = 0;
                    if (W) {
                        aa = R;
                        ba = S;
                        ca = T;
                        da = U;
                        Z = 302;
                        break
                    } else { $ = 0 }
                }
                b: do {
                    switch (a[e + r | 0] | 0) {
                        case 4:
                            {
                                V = 0;X = o;ea = T;fa = S;ga = R;c: while (1) {
                                    ha = c[f >> 2] | 0;
                                    do {
                                        if ((ha | 0) == 0) { ia = 1 } else {
                                            ja = c[ha + 12 >> 2] | 0;
                                            if ((ja | 0) == (c[ha + 16 >> 2] | 0)) { ka = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0 } else { ka = c[ja >> 2] | 0 }
                                            if ((ka | 0) == -1) {
                                                c[f >> 2] = 0;
                                                ia = 1;
                                                break
                                            } else { ia = (c[f >> 2] | 0) == 0; break }
                                        }
                                    } while (0);
                                    ha = c[b >> 2] | 0;
                                    do {
                                        if ((ha | 0) == 0) { Z = 207 } else {
                                            ja = c[ha + 12 >> 2] | 0;
                                            if ((ja | 0) == (c[ha + 16 >> 2] | 0)) { la = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0 } else { la = c[ja >> 2] | 0 }
                                            if ((la | 0) == -1) {
                                                c[b >> 2] = 0;
                                                Z = 207;
                                                break
                                            } else { if (ia) { break } else { break c } }
                                        }
                                    } while (0);
                                    if ((Z | 0) == 207) { Z = 0; if (ia) { break } }
                                    ha = c[f >> 2] | 0;
                                    ja = c[ha + 12 >> 2] | 0;
                                    if ((ja | 0) == (c[ha + 16 >> 2] | 0)) { ma = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0 } else { ma = c[ja >> 2] | 0 }
                                    if (Hc[c[(c[s >> 2] | 0) + 12 >> 2] & 63](l, 2048, ma) | 0) {
                                        ja = c[n >> 2] | 0;
                                        if ((ja | 0) == (c[q >> 2] | 0)) {
                                            pr(m, n, q);
                                            na = c[n >> 2] | 0
                                        } else { na = ja }
                                        c[n >> 2] = na + 4;
                                        c[na >> 2] = ma;
                                        oa = V + 1 | 0;
                                        pa = X;
                                        qa = ea;
                                        ra = fa;
                                        sa = ga
                                    } else {
                                        ja = a[C] | 0;
                                        if ((ja & 1) == 0) { ta = (ja & 255) >>> 1 } else { ta = c[Q >> 2] | 0 }
                                        if ((ta | 0) == 0 | (V | 0) == 0) { break }
                                        if ((ma | 0) != (c[u >> 2] | 0)) { break }
                                        if ((ea | 0) == (X | 0)) {
                                            ja = (ga | 0) != 194;
                                            ha = ea - fa | 0;
                                            ua = ha >>> 0 < 2147483647 >>> 0 ? ha << 1 : -1;
                                            if (ja) { va = fa } else { va = 0 }
                                            ja = Iu(va, ua) | 0;
                                            wa = ja;
                                            if ((ja | 0) == 0) { Uu() }
                                            xa = wa + (ua >>> 2 << 2) | 0;
                                            ya = wa + (ha >> 2 << 2) | 0;
                                            za = wa;
                                            Aa = 88
                                        } else {
                                            xa = X;
                                            ya = ea;
                                            za = fa;
                                            Aa = ga
                                        }
                                        c[ya >> 2] = V;
                                        oa = 0;
                                        pa = xa;
                                        qa = ya + 4 | 0;
                                        ra = za;
                                        sa = Aa
                                    }
                                    wa = c[f >> 2] | 0;
                                    ha = wa + 12 | 0;
                                    ua = c[ha >> 2] | 0;
                                    if ((ua | 0) == (c[wa + 16 >> 2] | 0)) {
                                        Fc[c[(c[wa >> 2] | 0) + 40 >> 2] & 255](wa) | 0;
                                        V = oa;
                                        X = pa;
                                        ea = qa;
                                        fa = ra;
                                        ga = sa;
                                        continue
                                    } else {
                                        c[ha >> 2] = ua + 4;
                                        V = oa;
                                        X = pa;
                                        ea = qa;
                                        fa = ra;
                                        ga = sa;
                                        continue
                                    }
                                }
                                if ((fa | 0) == (ea | 0) | (V | 0) == 0) {
                                    Ba = X;
                                    Ca = ea;
                                    Da = fa;
                                    Ea = ga
                                } else {
                                    if ((ea | 0) == (X | 0)) {
                                        ua = (ga | 0) != 194;
                                        ha = ea - fa | 0;
                                        wa = ha >>> 0 < 2147483647 >>> 0 ? ha << 1 : -1;
                                        if (ua) { Fa = fa } else { Fa = 0 }
                                        ua = Iu(Fa, wa) | 0;
                                        ja = ua;
                                        if ((ua | 0) == 0) { Uu() }
                                        Ga = ja + (wa >>> 2 << 2) | 0;
                                        Ha = ja + (ha >> 2 << 2) | 0;
                                        Ia = ja;
                                        Ja = 88
                                    } else {
                                        Ga = X;
                                        Ha = ea;
                                        Ia = fa;
                                        Ja = ga
                                    }
                                    c[Ha >> 2] = V;
                                    Ba = Ga;
                                    Ca = Ha + 4 | 0;
                                    Da = Ia;
                                    Ea = Ja
                                }
                                ja = c[A >> 2] | 0;
                                if ((ja | 0) > 0) {
                                    ha = c[f >> 2] | 0;
                                    do {
                                        if ((ha | 0) == 0) { Ka = 1 } else {
                                            wa = c[ha + 12 >> 2] | 0;
                                            if ((wa | 0) == (c[ha + 16 >> 2] | 0)) { La = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0 } else { La = c[wa >> 2] | 0 }
                                            if ((La | 0) == -1) {
                                                c[f >> 2] = 0;
                                                Ka = 1;
                                                break
                                            } else { Ka = (c[f >> 2] | 0) == 0; break }
                                        }
                                    } while (0);
                                    ha = c[b >> 2] | 0;
                                    do {
                                        if ((ha | 0) == 0) { Z = 259 } else {
                                            V = c[ha + 12 >> 2] | 0;
                                            if ((V | 0) == (c[ha + 16 >> 2] | 0)) { Ma = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0 } else { Ma = c[V >> 2] | 0 }
                                            if ((Ma | 0) == -1) {
                                                c[b >> 2] = 0;
                                                Z = 259;
                                                break
                                            } else { if (Ka) { Na = ha; break } else { Z = 265; break a } }
                                        }
                                    } while (0);
                                    if ((Z | 0) == 259) { Z = 0; if (Ka) { Z = 265; break a } else { Na = 0 } }
                                    ha = c[f >> 2] | 0;
                                    V = c[ha + 12 >> 2] | 0;
                                    if ((V | 0) == (c[ha + 16 >> 2] | 0)) { Oa = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0 } else { Oa = c[V >> 2] | 0 }
                                    if ((Oa | 0) != (c[t >> 2] | 0)) { Z = 265; break a }
                                    V = c[f >> 2] | 0;
                                    ha = V + 12 | 0;
                                    ga = c[ha >> 2] | 0;
                                    if ((ga | 0) == (c[V + 16 >> 2] | 0)) {
                                        Fc[c[(c[V >> 2] | 0) + 40 >> 2] & 255](V) | 0;
                                        Pa = Na;
                                        Qa = ja;
                                        Ra = Na
                                    } else {
                                        c[ha >> 2] = ga + 4;
                                        Pa = Na;
                                        Qa = ja;
                                        Ra = Na
                                    }
                                    while (1) {
                                        ga = c[f >> 2] | 0;
                                        do {
                                            if ((ga | 0) == 0) { Sa = 1 } else {
                                                ha = c[ga + 12 >> 2] | 0;
                                                if ((ha | 0) == (c[ga + 16 >> 2] | 0)) { Ta = Fc[c[(c[ga >> 2] | 0) + 36 >> 2] & 255](ga) | 0 } else { Ta = c[ha >> 2] | 0 }
                                                if ((Ta | 0) == -1) {
                                                    c[f >> 2] = 0;
                                                    Sa = 1;
                                                    break
                                                } else { Sa = (c[f >> 2] | 0) == 0; break }
                                            }
                                        } while (0);
                                        do {
                                            if ((Pa | 0) == 0) {
                                                Ua = Ra;
                                                Z = 282
                                            } else {
                                                ga = c[Pa + 12 >> 2] | 0;
                                                if ((ga | 0) == (c[Pa + 16 >> 2] | 0)) { Va = Fc[c[(c[Pa >> 2] | 0) + 36 >> 2] & 255](Pa) | 0 } else { Va = c[ga >> 2] | 0 }
                                                if ((Va | 0) == -1) {
                                                    c[b >> 2] = 0;
                                                    Ua = 0;
                                                    Z = 282;
                                                    break
                                                } else {
                                                    if (Sa ^ (Ra | 0) == 0) {
                                                        Wa = Ra;
                                                        Xa = Ra;
                                                        break
                                                    } else { Z = 289; break a }
                                                }
                                            }
                                        } while (0);
                                        if ((Z | 0) == 282) {
                                            Z = 0;
                                            if (Sa) { Z = 289; break a } else {
                                                Wa = Ua;
                                                Xa = 0
                                            }
                                        }
                                        ga = c[f >> 2] | 0;
                                        ha = c[ga + 12 >> 2] | 0;
                                        if ((ha | 0) == (c[ga + 16 >> 2] | 0)) { Ya = Fc[c[(c[ga >> 2] | 0) + 36 >> 2] & 255](ga) | 0 } else { Ya = c[ha >> 2] | 0 }
                                        if (!(Hc[c[(c[s >> 2] | 0) + 12 >> 2] & 63](l, 2048, Ya) | 0)) { Z = 289; break a }
                                        if ((c[n >> 2] | 0) == (c[q >> 2] | 0)) { pr(m, n, q) }
                                        ha = c[f >> 2] | 0;
                                        ga = c[ha + 12 >> 2] | 0;
                                        if ((ga | 0) == (c[ha + 16 >> 2] | 0)) { Za = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0 } else { Za = c[ga >> 2] | 0 }
                                        ga = c[n >> 2] | 0;
                                        c[n >> 2] = ga + 4;
                                        c[ga >> 2] = Za;
                                        ga = Qa - 1 | 0;
                                        c[A >> 2] = ga;
                                        ha = c[f >> 2] | 0;
                                        V = ha + 12 | 0;
                                        fa = c[V >> 2] | 0;
                                        if ((fa | 0) == (c[ha + 16 >> 2] | 0)) { Fc[c[(c[ha >> 2] | 0) + 40 >> 2] & 255](ha) | 0 } else { c[V >> 2] = fa + 4 }
                                        if ((ga | 0) > 0) {
                                            Pa = Xa;
                                            Qa = ga;
                                            Ra = Wa
                                        } else { break }
                                    }
                                }
                                if ((c[n >> 2] | 0) == (c[g >> 2] | 0)) { Z = 300; break a } else {
                                    _a = U;
                                    $a = Ba;
                                    ab = Ca;
                                    bb = Da;
                                    cb = Ea
                                }
                                break
                            };
                        case 1:
                            {
                                if ((r | 0) == 3) {
                                    aa = R;
                                    ba = S;
                                    ca = T;
                                    da = U;
                                    Z = 302;
                                    break a
                                }
                                ja = c[f >> 2] | 0;ga = c[ja + 12 >> 2] | 0;
                                if ((ga | 0) == (c[ja + 16 >> 2] | 0)) { db = Fc[c[(c[ja >> 2] | 0) + 36 >> 2] & 255](ja) | 0 } else { db = c[ga >> 2] | 0 }
                                if (!(Hc[c[(c[s >> 2] | 0) + 12 >> 2] & 63](l, 8192, db) | 0)) { Z = 41; break a }
                                ga = c[f >> 2] | 0;ja = ga + 12 | 0;fa = c[ja >> 2] | 0;
                                if ((fa | 0) == (c[ga + 16 >> 2] | 0)) { eb = Fc[c[(c[ga >> 2] | 0) + 40 >> 2] & 255](ga) | 0 } else {
                                    c[ja >> 2] = fa + 4;
                                    eb = c[fa >> 2] | 0
                                }
                                Gm(z, eb);Z = 42;
                                break
                            };
                        case 0:
                            { Z = 42; break };
                        case 3:
                            {
                                fa = a[E] | 0;ja = (fa & 1) == 0;
                                if (ja) { fb = (fa & 255) >>> 1 } else { fb = c[J >> 2] | 0 }
                                ga = a[F] | 0;V = (ga & 1) == 0;
                                if (V) { gb = (ga & 255) >>> 1 } else { gb = c[H >> 2] | 0 }
                                if ((fb | 0) == (-gb | 0)) {
                                    _a = U;
                                    $a = o;
                                    ab = T;
                                    bb = S;
                                    cb = R;
                                    break b
                                }
                                if (ja) { hb = (fa & 255) >>> 1 } else { hb = c[J >> 2] | 0 }
                                do {
                                    if ((hb | 0) != 0) {
                                        if (V) { ib = (ga & 255) >>> 1 } else { ib = c[H >> 2] | 0 }
                                        if ((ib | 0) == 0) { break }
                                        ha = c[f >> 2] | 0;
                                        ea = c[ha + 12 >> 2] | 0;
                                        if ((ea | 0) == (c[ha + 16 >> 2] | 0)) {
                                            X = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0;
                                            jb = X;
                                            kb = a[E] | 0
                                        } else {
                                            jb = c[ea >> 2] | 0;
                                            kb = fa
                                        }
                                        ea = c[f >> 2] | 0;
                                        X = ea + 12 | 0;
                                        ha = c[X >> 2] | 0;
                                        wa = (ha | 0) == (c[ea + 16 >> 2] | 0);
                                        if ((jb | 0) == (c[((kb & 1) == 0 ? J : c[K >> 2] | 0) >> 2] | 0)) {
                                            if (wa) { Fc[c[(c[ea >> 2] | 0) + 40 >> 2] & 255](ea) | 0 } else { c[X >> 2] = ha + 4 }
                                            X = a[E] | 0;
                                            if ((X & 1) == 0) { lb = (X & 255) >>> 1 } else { lb = c[J >> 2] | 0 }
                                            _a = lb >>> 0 > 1 >>> 0 ? x : U;
                                            $a = o;
                                            ab = T;
                                            bb = S;
                                            cb = R;
                                            break b
                                        }
                                        if (wa) { mb = Fc[c[(c[ea >> 2] | 0) + 36 >> 2] & 255](ea) | 0 } else { mb = c[ha >> 2] | 0 }
                                        if ((mb | 0) != (c[((a[F] & 1) == 0 ? H : c[I >> 2] | 0) >> 2] | 0)) { Z = 134; break a }
                                        ha = c[f >> 2] | 0;
                                        ea = ha + 12 | 0;
                                        wa = c[ea >> 2] | 0;
                                        if ((wa | 0) == (c[ha + 16 >> 2] | 0)) { Fc[c[(c[ha >> 2] | 0) + 40 >> 2] & 255](ha) | 0 } else { c[ea >> 2] = wa + 4 }
                                        a[k] = 1;
                                        wa = a[F] | 0;
                                        if ((wa & 1) == 0) { nb = (wa & 255) >>> 1 } else { nb = c[H >> 2] | 0 }
                                        _a = nb >>> 0 > 1 >>> 0 ? y : U;
                                        $a = o;
                                        ab = T;
                                        bb = S;
                                        cb = R;
                                        break b
                                    }
                                } while (0);
                                if (ja) { ob = (fa & 255) >>> 1 } else { ob = c[J >> 2] | 0 }
                                V = c[f >> 2] | 0;wa = c[V + 12 >> 2] | 0;ea = (wa | 0) == (c[V + 16 >> 2] | 0);
                                if ((ob | 0) == 0) {
                                    if (ea) {
                                        ha = Fc[c[(c[V >> 2] | 0) + 36 >> 2] & 255](V) | 0;
                                        pb = ha;
                                        qb = a[F] | 0
                                    } else {
                                        pb = c[wa >> 2] | 0;
                                        qb = ga
                                    }
                                    if ((pb | 0) != (c[((qb & 1) == 0 ? H : c[I >> 2] | 0) >> 2] | 0)) {
                                        _a = U;
                                        $a = o;
                                        ab = T;
                                        bb = S;
                                        cb = R;
                                        break b
                                    }
                                    ha = c[f >> 2] | 0;
                                    X = ha + 12 | 0;
                                    ua = c[X >> 2] | 0;
                                    if ((ua | 0) == (c[ha + 16 >> 2] | 0)) { Fc[c[(c[ha >> 2] | 0) + 40 >> 2] & 255](ha) | 0 } else { c[X >> 2] = ua + 4 }
                                    a[k] = 1;
                                    ua = a[F] | 0;
                                    if ((ua & 1) == 0) { rb = (ua & 255) >>> 1 } else { rb = c[H >> 2] | 0 }
                                    _a = rb >>> 0 > 1 >>> 0 ? y : U;
                                    $a = o;
                                    ab = T;
                                    bb = S;
                                    cb = R;
                                    break b
                                }
                                if (ea) {
                                    ea = Fc[c[(c[V >> 2] | 0) + 36 >> 2] & 255](V) | 0;
                                    sb = ea;
                                    tb = a[E] | 0
                                } else {
                                    sb = c[wa >> 2] | 0;
                                    tb = fa
                                }
                                if ((sb | 0) != (c[((tb & 1) == 0 ? J : c[K >> 2] | 0) >> 2] | 0)) {
                                    a[k] = 1;
                                    _a = U;
                                    $a = o;
                                    ab = T;
                                    bb = S;
                                    cb = R;
                                    break b
                                }
                                wa = c[f >> 2] | 0;ea = wa + 12 | 0;V = c[ea >> 2] | 0;
                                if ((V | 0) == (c[wa + 16 >> 2] | 0)) { Fc[c[(c[wa >> 2] | 0) + 40 >> 2] & 255](wa) | 0 } else { c[ea >> 2] = V + 4 }
                                V = a[E] | 0;
                                if ((V & 1) == 0) { ub = (V & 255) >>> 1 } else { ub = c[J >> 2] | 0 }
                                _a = ub >>> 0 > 1 >>> 0 ? x : U;$a = o;ab = T;bb = S;cb = R;
                                break
                            };
                        case 2:
                            {
                                if (!((U | 0) != 0 | r >>> 0 < 2 >>> 0)) {
                                    if ((r | 0) == 2) { vb = (a[P] | 0) != 0 } else { vb = 0 }
                                    if (!(L | vb)) {
                                        _a = 0;
                                        $a = o;
                                        ab = T;
                                        bb = S;
                                        cb = R;
                                        break b
                                    }
                                }
                                V = a[D] | 0;ea = (V & 1) == 0 ? h : c[M >> 2] | 0;d: do {
                                    if ((r | 0) == 0) {
                                        wb = ea;
                                        xb = V;
                                        yb = $;
                                        zb = $
                                    } else {
                                        if ((d[e + (r - 1) | 0] | 0) >>> 0 < 2 >>> 0) {
                                            Ab = ea;
                                            Bb = V
                                        } else {
                                            wb = ea;
                                            xb = V;
                                            yb = $;
                                            zb = $;
                                            break
                                        }
                                        while (1) {
                                            if ((Bb & 1) == 0) {
                                                Cb = (Bb & 255) >>> 1;
                                                Db = h
                                            } else {
                                                Cb = c[h >> 2] | 0;
                                                Db = c[M >> 2] | 0
                                            }
                                            if ((Ab | 0) == (Db + (Cb << 2) | 0)) { Eb = Bb; break }
                                            if (!(Hc[c[(c[s >> 2] | 0) + 12 >> 2] & 63](l, 8192, c[Ab >> 2] | 0) | 0)) { Z = 148; break }
                                            Ab = Ab + 4 | 0;
                                            Bb = a[D] | 0
                                        }
                                        if ((Z | 0) == 148) {
                                            Z = 0;
                                            Eb = a[D] | 0
                                        }
                                        wa = (Eb & 1) == 0;
                                        ua = Ab - (wa ? h : c[M >> 2] | 0) >> 2;
                                        X = a[G] | 0;
                                        ha = (X & 1) == 0;
                                        if (ha) { Fb = (X & 255) >>> 1 } else { Fb = c[N >> 2] | 0 }
                                        e: do {
                                            if (!(ua >>> 0 > Fb >>> 0)) {
                                                if (ha) {
                                                    Gb = (X & 255) >>> 1;
                                                    Hb = N;
                                                    Ib = N + (((X & 255) >>> 1) - ua << 2) | 0
                                                } else {
                                                    Jb = c[O >> 2] | 0;
                                                    Kb = c[N >> 2] | 0;
                                                    Gb = Kb;
                                                    Hb = Jb;
                                                    Ib = Jb + (Kb - ua << 2) | 0
                                                }
                                                Kb = Hb + (Gb << 2) | 0;
                                                if ((Ib | 0) == (Kb | 0)) {
                                                    wb = Ab;
                                                    xb = Eb;
                                                    yb = $;
                                                    zb = $;
                                                    break d
                                                } else {
                                                    Lb = Ib;
                                                    Mb = wa ? h : c[M >> 2] | 0
                                                }
                                                while (1) {
                                                    if ((c[Lb >> 2] | 0) != (c[Mb >> 2] | 0)) { break e }
                                                    Jb = Lb + 4 | 0;
                                                    if ((Jb | 0) == (Kb | 0)) {
                                                        wb = Ab;
                                                        xb = Eb;
                                                        yb = $;
                                                        zb = $;
                                                        break d
                                                    }
                                                    Lb = Jb;
                                                    Mb = Mb + 4 | 0
                                                }
                                            }
                                        } while (0);
                                        wb = wa ? h : c[M >> 2] | 0;
                                        xb = Eb;
                                        yb = $;
                                        zb = $
                                    }
                                } while (0);f: while (1) {
                                    if ((xb & 1) == 0) {
                                        Nb = (xb & 255) >>> 1;
                                        Ob = h
                                    } else {
                                        Nb = c[h >> 2] | 0;
                                        Ob = c[M >> 2] | 0
                                    }
                                    if ((wb | 0) == (Ob + (Nb << 2) | 0)) { break }
                                    V = c[f >> 2] | 0;
                                    do {
                                        if ((V | 0) == 0) { Pb = 1 } else {
                                            ea = c[V + 12 >> 2] | 0;
                                            if ((ea | 0) == (c[V + 16 >> 2] | 0)) { Qb = Fc[c[(c[V >> 2] | 0) + 36 >> 2] & 255](V) | 0 } else { Qb = c[ea >> 2] | 0 }
                                            if ((Qb | 0) == -1) {
                                                c[f >> 2] = 0;
                                                Pb = 1;
                                                break
                                            } else { Pb = (c[f >> 2] | 0) == 0; break }
                                        }
                                    } while (0);
                                    do {
                                        if ((yb | 0) == 0) {
                                            Rb = zb;
                                            Z = 178
                                        } else {
                                            V = c[yb + 12 >> 2] | 0;
                                            if ((V | 0) == (c[yb + 16 >> 2] | 0)) { Sb = Fc[c[(c[yb >> 2] | 0) + 36 >> 2] & 255](yb) | 0 } else { Sb = c[V >> 2] | 0 }
                                            if ((Sb | 0) == -1) {
                                                c[b >> 2] = 0;
                                                Rb = 0;
                                                Z = 178;
                                                break
                                            } else {
                                                if (Pb ^ (zb | 0) == 0) {
                                                    Tb = zb;
                                                    Ub = zb;
                                                    break
                                                } else { break f }
                                            }
                                        }
                                    } while (0);
                                    if ((Z | 0) == 178) {
                                        Z = 0;
                                        if (Pb) { break } else {
                                            Tb = 0;
                                            Ub = Rb
                                        }
                                    }
                                    V = c[f >> 2] | 0;
                                    wa = c[V + 12 >> 2] | 0;
                                    if ((wa | 0) == (c[V + 16 >> 2] | 0)) { Vb = Fc[c[(c[V >> 2] | 0) + 36 >> 2] & 255](V) | 0 } else { Vb = c[wa >> 2] | 0 }
                                    if ((Vb | 0) != (c[wb >> 2] | 0)) { break }
                                    wa = c[f >> 2] | 0;
                                    V = wa + 12 | 0;
                                    ea = c[V >> 2] | 0;
                                    if ((ea | 0) == (c[wa + 16 >> 2] | 0)) { Fc[c[(c[wa >> 2] | 0) + 40 >> 2] & 255](wa) | 0 } else { c[V >> 2] = ea + 4 }
                                    wb = wb + 4 | 0;
                                    xb = a[D] | 0;
                                    yb = Tb;
                                    zb = Ub
                                }
                                if (!L) {
                                    _a = U;
                                    $a = o;
                                    ab = T;
                                    bb = S;
                                    cb = R;
                                    break b
                                }
                                ea = a[D] | 0;
                                if ((ea & 1) == 0) {
                                    Wb = (ea & 255) >>> 1;
                                    Xb = h
                                } else {
                                    Wb = c[h >> 2] | 0;
                                    Xb = c[M >> 2] | 0
                                }
                                if ((wb | 0) == (Xb + (Wb << 2) | 0)) {
                                    _a = U;
                                    $a = o;
                                    ab = T;
                                    bb = S;
                                    cb = R
                                } else { Z = 193; break a }
                                break
                            };
                        default:
                            { _a = U;$a = o;ab = T;bb = S;cb = R }
                    }
                } while (0);
                g: do {
                    if ((Z | 0) == 42) {
                        Z = 0;
                        if ((r | 0) == 3) {
                            aa = R;
                            ba = S;
                            ca = T;
                            da = U;
                            Z = 302;
                            break a
                        } else {
                            Yb = $;
                            Zb = $
                        }
                        while (1) {
                            ea = c[f >> 2] | 0;
                            do {
                                if ((ea | 0) == 0) { _b = 1 } else {
                                    V = c[ea + 12 >> 2] | 0;
                                    if ((V | 0) == (c[ea + 16 >> 2] | 0)) { $b = Fc[c[(c[ea >> 2] | 0) + 36 >> 2] & 255](ea) | 0 } else { $b = c[V >> 2] | 0 }
                                    if (($b | 0) == -1) {
                                        c[f >> 2] = 0;
                                        _b = 1;
                                        break
                                    } else { _b = (c[f >> 2] | 0) == 0; break }
                                }
                            } while (0);
                            do {
                                if ((Yb | 0) == 0) {
                                    ac = Zb;
                                    Z = 56
                                } else {
                                    ea = c[Yb + 12 >> 2] | 0;
                                    if ((ea | 0) == (c[Yb + 16 >> 2] | 0)) { bc = Fc[c[(c[Yb >> 2] | 0) + 36 >> 2] & 255](Yb) | 0 } else { bc = c[ea >> 2] | 0 }
                                    if ((bc | 0) == -1) {
                                        c[b >> 2] = 0;
                                        ac = 0;
                                        Z = 56;
                                        break
                                    } else {
                                        if (_b ^ (Zb | 0) == 0) {
                                            cc = Zb;
                                            dc = Zb;
                                            break
                                        } else {
                                            _a = U;
                                            $a = o;
                                            ab = T;
                                            bb = S;
                                            cb = R;
                                            break g
                                        }
                                    }
                                }
                            } while (0);
                            if ((Z | 0) == 56) {
                                Z = 0;
                                if (_b) {
                                    _a = U;
                                    $a = o;
                                    ab = T;
                                    bb = S;
                                    cb = R;
                                    break g
                                } else {
                                    cc = 0;
                                    dc = ac
                                }
                            }
                            ea = c[f >> 2] | 0;
                            V = c[ea + 12 >> 2] | 0;
                            if ((V | 0) == (c[ea + 16 >> 2] | 0)) { ec = Fc[c[(c[ea >> 2] | 0) + 36 >> 2] & 255](ea) | 0 } else { ec = c[V >> 2] | 0 }
                            if (!(Hc[c[(c[s >> 2] | 0) + 12 >> 2] & 63](l, 8192, ec) | 0)) {
                                _a = U;
                                $a = o;
                                ab = T;
                                bb = S;
                                cb = R;
                                break g
                            }
                            V = c[f >> 2] | 0;
                            ea = V + 12 | 0;
                            wa = c[ea >> 2] | 0;
                            if ((wa | 0) == (c[V + 16 >> 2] | 0)) { fc = Fc[c[(c[V >> 2] | 0) + 40 >> 2] & 255](V) | 0 } else {
                                c[ea >> 2] = wa + 4;
                                fc = c[wa >> 2] | 0
                            }
                            Gm(z, fc);
                            Yb = cc;
                            Zb = dc
                        }
                    }
                } while (0);
                wa = r + 1 | 0;
                if (wa >>> 0 < 4 >>> 0) {
                    R = cb;
                    S = bb;
                    T = ab;
                    o = $a;
                    r = wa;
                    U = _a
                } else {
                    aa = cb;
                    ba = bb;
                    ca = ab;
                    da = _a;
                    Z = 302;
                    break
                }
            }
            h: do {
                if ((Z | 0) == 41) {
                    c[j >> 2] = c[j >> 2] | 4;
                    gc = 0;
                    hc = S;
                    ic = R
                } else if ((Z | 0) == 134) {
                    c[j >> 2] = c[j >> 2] | 4;
                    gc = 0;
                    hc = S;
                    ic = R
                } else if ((Z | 0) == 193) {
                    c[j >> 2] = c[j >> 2] | 4;
                    gc = 0;
                    hc = S;
                    ic = R
                } else if ((Z | 0) == 265) {
                    c[j >> 2] = c[j >> 2] | 4;
                    gc = 0;
                    hc = Da;
                    ic = Ea
                } else if ((Z | 0) == 289) {
                    c[j >> 2] = c[j >> 2] | 4;
                    gc = 0;
                    hc = Da;
                    ic = Ea
                } else if ((Z | 0) == 300) {
                    c[j >> 2] = c[j >> 2] | 4;
                    gc = 0;
                    hc = Da;
                    ic = Ea
                } else if ((Z | 0) == 302) {
                    i: do {
                        if ((da | 0) != 0) {
                            _a = da;
                            ab = da + 4 | 0;
                            bb = da + 8 | 0;
                            cb = 1;
                            j: while (1) {
                                U = a[_a] | 0;
                                if ((U & 1) == 0) { jc = (U & 255) >>> 1 } else { jc = c[ab >> 2] | 0 }
                                if (!(cb >>> 0 < jc >>> 0)) { break i }
                                U = c[f >> 2] | 0;
                                do {
                                    if ((U | 0) == 0) { kc = 1 } else {
                                        r = c[U + 12 >> 2] | 0;
                                        if ((r | 0) == (c[U + 16 >> 2] | 0)) { lc = Fc[c[(c[U >> 2] | 0) + 36 >> 2] & 255](U) | 0 } else { lc = c[r >> 2] | 0 }
                                        if ((lc | 0) == -1) {
                                            c[f >> 2] = 0;
                                            kc = 1;
                                            break
                                        } else { kc = (c[f >> 2] | 0) == 0; break }
                                    }
                                } while (0);
                                U = c[b >> 2] | 0;
                                do {
                                    if ((U | 0) == 0) { Z = 321 } else {
                                        r = c[U + 12 >> 2] | 0;
                                        if ((r | 0) == (c[U + 16 >> 2] | 0)) { mc = Fc[c[(c[U >> 2] | 0) + 36 >> 2] & 255](U) | 0 } else { mc = c[r >> 2] | 0 }
                                        if ((mc | 0) == -1) {
                                            c[b >> 2] = 0;
                                            Z = 321;
                                            break
                                        } else { if (kc) { break } else { break j } }
                                    }
                                } while (0);
                                if ((Z | 0) == 321) { Z = 0; if (kc) { break } }
                                U = c[f >> 2] | 0;
                                r = c[U + 12 >> 2] | 0;
                                if ((r | 0) == (c[U + 16 >> 2] | 0)) { nc = Fc[c[(c[U >> 2] | 0) + 36 >> 2] & 255](U) | 0 } else { nc = c[r >> 2] | 0 }
                                if ((a[_a] & 1) == 0) { oc = ab } else { oc = c[bb >> 2] | 0 }
                                if ((nc | 0) != (c[oc + (cb << 2) >> 2] | 0)) { break }
                                r = cb + 1 | 0;
                                U = c[f >> 2] | 0;
                                $a = U + 12 | 0;
                                o = c[$a >> 2] | 0;
                                if ((o | 0) == (c[U + 16 >> 2] | 0)) {
                                    Fc[c[(c[U >> 2] | 0) + 40 >> 2] & 255](U) | 0;
                                    cb = r;
                                    continue
                                } else {
                                    c[$a >> 2] = o + 4;
                                    cb = r;
                                    continue
                                }
                            }
                            c[j >> 2] = c[j >> 2] | 4;
                            gc = 0;
                            hc = ba;
                            ic = aa;
                            break h
                        }
                    } while (0);
                    if ((ba | 0) == (ca | 0)) {
                        gc = 1;
                        hc = ca;
                        ic = aa;
                        break
                    }
                    c[B >> 2] = 0;hr(v, ba, ca, B);
                    if ((c[B >> 2] | 0) == 0) {
                        gc = 1;
                        hc = ba;
                        ic = aa;
                        break
                    }
                    c[j >> 2] = c[j >> 2] | 4;gc = 0;hc = ba;ic = aa
                }
            } while (0);
            Cm(z);
            Cm(y);
            Cm(x);
            Cm(w);
            rm(v);
            if ((hc | 0) == 0) {
                pc = 400;
                qc = 0;
                i = p;
                return gc | 0
            }
            Dc[ic & 511](hc);
            pc = 400;
            qc = 0;
            i = p;
            return gc | 0
        }

        function mr(b, d, e, f, g, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0;
            d = i;
            i = i + 456 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d | 0;
            m = d + 16 | 0;
            n = d + 416 | 0;
            o = d + 424 | 0;
            p = d + 432 | 0;
            q = d + 440 | 0;
            r = d + 448 | 0;
            s = n | 0;
            c[s >> 2] = m;
            t = n + 4 | 0;
            c[t >> 2] = 194;
            u = m + 400 | 0;
            Lm(p, h);
            m = p | 0;
            v = c[m >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[l >> 2] = 34856;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34856, l, 114)
            }
            l = (c[8715] | 0) - 1 | 0;
            w = c[v + 8 >> 2] | 0;
            do {
                if ((c[v + 12 >> 2] | 0) - w >> 2 >>> 0 > l >>> 0) {
                    x = c[w + (l << 2) >> 2] | 0;
                    if ((x | 0) == 0) { break }
                    y = x;
                    a[q] = 0;
                    z = f | 0;
                    A = c[z >> 2] | 0;
                    c[r >> 2] = A;
                    if (lr(e, r, g, p, c[h + 4 >> 2] | 0, j, q, y, n, o, u) | 0) {
                        B = k;
                        if ((a[B] & 1) == 0) {
                            c[k + 4 >> 2] = 0;
                            a[B] = 0
                        } else {
                            c[c[k + 8 >> 2] >> 2] = 0;
                            c[k + 4 >> 2] = 0
                        }
                        B = x;
                        if ((a[q] | 0) != 0) { Gm(k, Qc[c[(c[B >> 2] | 0) + 44 >> 2] & 63](y, 45) | 0) }
                        x = Qc[c[(c[B >> 2] | 0) + 44 >> 2] & 63](y, 48) | 0;
                        y = c[s >> 2] | 0;
                        B = c[o >> 2] | 0;
                        C = B - 4 | 0;
                        a: do { if (y >>> 0 < C >>> 0) { D = y; while (1) { E = D + 4 | 0; if ((c[D >> 2] | 0) != (x | 0)) { F = D; break a } if (E >>> 0 < C >>> 0) { D = E } else { F = E; break } } } else { F = y } } while (0);
                        nr(k, F, B) | 0
                    }
                    y = e | 0;
                    C = c[y >> 2] | 0;
                    do {
                        if ((C | 0) == 0) { G = 1 } else {
                            x = c[C + 12 >> 2] | 0;
                            if ((x | 0) == (c[C + 16 >> 2] | 0)) { H = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { H = c[x >> 2] | 0 }
                            if ((H | 0) == -1) {
                                c[y >> 2] = 0;
                                G = 1;
                                break
                            } else { G = (c[y >> 2] | 0) == 0; break }
                        }
                    } while (0);
                    do {
                        if ((A | 0) == 0) { I = 35 } else {
                            C = c[A + 12 >> 2] | 0;
                            if ((C | 0) == (c[A + 16 >> 2] | 0)) { J = Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0 } else { J = c[C >> 2] | 0 }
                            if ((J | 0) == -1) {
                                c[z >> 2] = 0;
                                I = 35;
                                break
                            } else { if (G) { break } else { I = 37; break } }
                        }
                    } while (0);
                    if ((I | 0) == 35) { if (G) { I = 37 } }
                    if ((I | 0) == 37) { c[j >> 2] = c[j >> 2] | 2 }
                    c[b >> 2] = c[y >> 2];
                    Ul(c[m >> 2] | 0) | 0;
                    z = c[s >> 2] | 0;
                    c[s >> 2] = 0;
                    if ((z | 0) == 0) {
                        K = 400;
                        L = 0;
                        i = d;
                        return
                    }
                    Dc[c[t >> 2] & 511](z);
                    K = 400;
                    L = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function nr(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            f = b;
            g = d;
            h = a[f] | 0;
            if ((h & 1) == 0) {
                i = 1;
                j = h;
                k = (h & 255) >>> 1
            } else {
                h = c[b >> 2] | 0;
                i = (h & -2) - 1 | 0;
                j = h & 255;
                k = c[b + 4 >> 2] | 0
            }
            h = e - g >> 2;
            if ((h | 0) == 0) { return b | 0 }
            if ((i - k | 0) >>> 0 < h >>> 0) {
                Im(b, i, k + h - i | 0, k, k, 0, 0);
                l = a[f] | 0
            } else { l = j }
            if ((l & 1) == 0) { m = b + 4 | 0 } else { m = c[b + 8 >> 2] | 0 }
            l = m + (k << 2) | 0;
            if ((d | 0) == (e | 0)) { n = l } else {
                j = k + ((e - 4 + (-g | 0) | 0) >>> 2) + 1 | 0;
                g = d;
                d = l;
                while (1) {
                    c[d >> 2] = c[g >> 2];
                    l = g + 4 | 0;
                    if ((l | 0) == (e | 0)) { break } else {
                        g = l;
                        d = d + 4 | 0
                    }
                }
                n = m + (j << 2) | 0
            }
            c[n >> 2] = 0;
            n = k + h | 0;
            if ((a[f] & 1) == 0) { a[f] = n << 1; return b | 0 } else { c[b + 4 >> 2] = n; return b | 0 }
            return 0
        }

        function or(b, d, e, f, g, h, j, k, l, m) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0;
            n = i;
            i = i + 176 | 0;
            o = n | 0;
            p = n + 16 | 0;
            q = n + 32 | 0;
            r = n + 40 | 0;
            s = n + 56 | 0;
            t = n + 72 | 0;
            u = n + 88 | 0;
            v = n + 104 | 0;
            w = n + 112 | 0;
            x = n + 128 | 0;
            y = n + 144 | 0;
            z = n + 160 | 0;
            if (b) {
                b = c[d >> 2] | 0;
                if (!((c[8830] | 0) == -1)) {
                    c[p >> 2] = 35320;
                    c[p + 4 >> 2] = 16;
                    c[p + 8 >> 2] = 0;
                    mm(35320, p, 114)
                }
                p = (c[8831] | 0) - 1 | 0;
                A = c[b + 8 >> 2] | 0;
                if (!((c[b + 12 >> 2] | 0) - A >> 2 >>> 0 > p >>> 0)) {
                    B = pc(4) | 0;
                    D = B;
                    lu(D);
                    Fb(B | 0, 25544, 156)
                }
                b = c[A + (p << 2) >> 2] | 0;
                if ((b | 0) == 0) {
                    B = pc(4) | 0;
                    D = B;
                    lu(D);
                    Fb(B | 0, 25544, 156)
                }
                B = b;
                Ec[c[(c[b >> 2] | 0) + 44 >> 2] & 127](q, B);
                D = e;
                C = c[q >> 2] | 0;
                a[D] = C;
                C = C >> 8;
                a[D + 1 | 0] = C;
                C = C >> 8;
                a[D + 2 | 0] = C;
                C = C >> 8;
                a[D + 3 | 0] = C;
                D = b;
                Ec[c[(c[D >> 2] | 0) + 32 >> 2] & 127](r, B);
                q = l;
                if ((a[q] & 1) == 0) {
                    c[l + 4 >> 2] = 0;
                    a[q] = 0
                } else {
                    c[c[l + 8 >> 2] >> 2] = 0;
                    c[l + 4 >> 2] = 0
                }
                Fm(l, 0);
                p = r;
                c[q >> 2] = c[p >> 2];
                c[q + 4 >> 2] = c[p + 4 >> 2];
                c[q + 8 >> 2] = c[p + 8 >> 2];
                dv(p | 0, 0, 12) | 0;
                Cm(r);
                Ec[c[(c[D >> 2] | 0) + 28 >> 2] & 127](s, B);
                r = k;
                if ((a[r] & 1) == 0) {
                    c[k + 4 >> 2] = 0;
                    a[r] = 0
                } else {
                    c[c[k + 8 >> 2] >> 2] = 0;
                    c[k + 4 >> 2] = 0
                }
                Fm(k, 0);
                p = s;
                c[r >> 2] = c[p >> 2];
                c[r + 4 >> 2] = c[p + 4 >> 2];
                c[r + 8 >> 2] = c[p + 8 >> 2];
                dv(p | 0, 0, 12) | 0;
                Cm(s);
                s = b;
                p = Fc[c[(c[s >> 2] | 0) + 12 >> 2] & 255](B) | 0;
                c[f >> 2] = p;
                p = Fc[c[(c[s >> 2] | 0) + 16 >> 2] & 255](B) | 0;
                c[g >> 2] = p;
                Ec[c[(c[b >> 2] | 0) + 20 >> 2] & 127](t, B);
                b = h;
                if ((a[b] & 1) == 0) {
                    a[h + 1 | 0] = 0;
                    a[b] = 0
                } else {
                    a[c[h + 8 >> 2] | 0] = 0;
                    c[h + 4 >> 2] = 0
                }
                vm(h, 0);
                p = t;
                c[b >> 2] = c[p >> 2];
                c[b + 4 >> 2] = c[p + 4 >> 2];
                c[b + 8 >> 2] = c[p + 8 >> 2];
                dv(p | 0, 0, 12) | 0;
                rm(t);
                Ec[c[(c[D >> 2] | 0) + 24 >> 2] & 127](u, B);
                D = j;
                if ((a[D] & 1) == 0) {
                    c[j + 4 >> 2] = 0;
                    a[D] = 0
                } else {
                    c[c[j + 8 >> 2] >> 2] = 0;
                    c[j + 4 >> 2] = 0
                }
                Fm(j, 0);
                t = u;
                c[D >> 2] = c[t >> 2];
                c[D + 4 >> 2] = c[t + 4 >> 2];
                c[D + 8 >> 2] = c[t + 8 >> 2];
                dv(t | 0, 0, 12) | 0;
                Cm(u);
                E = Fc[c[(c[s >> 2] | 0) + 36 >> 2] & 255](B) | 0;
                c[m >> 2] = E;
                i = n;
                return
            } else {
                B = c[d >> 2] | 0;
                if (!((c[8832] | 0) == -1)) {
                    c[o >> 2] = 35328;
                    c[o + 4 >> 2] = 16;
                    c[o + 8 >> 2] = 0;
                    mm(35328, o, 114)
                }
                o = (c[8833] | 0) - 1 | 0;
                d = c[B + 8 >> 2] | 0;
                if (!((c[B + 12 >> 2] | 0) - d >> 2 >>> 0 > o >>> 0)) {
                    F = pc(4) | 0;
                    G = F;
                    lu(G);
                    Fb(F | 0, 25544, 156)
                }
                B = c[d + (o << 2) >> 2] | 0;
                if ((B | 0) == 0) {
                    F = pc(4) | 0;
                    G = F;
                    lu(G);
                    Fb(F | 0, 25544, 156)
                }
                F = B;
                Ec[c[(c[B >> 2] | 0) + 44 >> 2] & 127](v, F);
                G = e;
                C = c[v >> 2] | 0;
                a[G] = C;
                C = C >> 8;
                a[G + 1 | 0] = C;
                C = C >> 8;
                a[G + 2 | 0] = C;
                C = C >> 8;
                a[G + 3 | 0] = C;
                G = B;
                Ec[c[(c[G >> 2] | 0) + 32 >> 2] & 127](w, F);
                v = l;
                if ((a[v] & 1) == 0) {
                    c[l + 4 >> 2] = 0;
                    a[v] = 0
                } else {
                    c[c[l + 8 >> 2] >> 2] = 0;
                    c[l + 4 >> 2] = 0
                }
                Fm(l, 0);
                l = w;
                c[v >> 2] = c[l >> 2];
                c[v + 4 >> 2] = c[l + 4 >> 2];
                c[v + 8 >> 2] = c[l + 8 >> 2];
                dv(l | 0, 0, 12) | 0;
                Cm(w);
                Ec[c[(c[G >> 2] | 0) + 28 >> 2] & 127](x, F);
                w = k;
                if ((a[w] & 1) == 0) {
                    c[k + 4 >> 2] = 0;
                    a[w] = 0
                } else {
                    c[c[k + 8 >> 2] >> 2] = 0;
                    c[k + 4 >> 2] = 0
                }
                Fm(k, 0);
                k = x;
                c[w >> 2] = c[k >> 2];
                c[w + 4 >> 2] = c[k + 4 >> 2];
                c[w + 8 >> 2] = c[k + 8 >> 2];
                dv(k | 0, 0, 12) | 0;
                Cm(x);
                x = B;
                k = Fc[c[(c[x >> 2] | 0) + 12 >> 2] & 255](F) | 0;
                c[f >> 2] = k;
                k = Fc[c[(c[x >> 2] | 0) + 16 >> 2] & 255](F) | 0;
                c[g >> 2] = k;
                Ec[c[(c[B >> 2] | 0) + 20 >> 2] & 127](y, F);
                B = h;
                if ((a[B] & 1) == 0) {
                    a[h + 1 | 0] = 0;
                    a[B] = 0
                } else {
                    a[c[h + 8 >> 2] | 0] = 0;
                    c[h + 4 >> 2] = 0
                }
                vm(h, 0);
                h = y;
                c[B >> 2] = c[h >> 2];
                c[B + 4 >> 2] = c[h + 4 >> 2];
                c[B + 8 >> 2] = c[h + 8 >> 2];
                dv(h | 0, 0, 12) | 0;
                rm(y);
                Ec[c[(c[G >> 2] | 0) + 24 >> 2] & 127](z, F);
                G = j;
                if ((a[G] & 1) == 0) {
                    c[j + 4 >> 2] = 0;
                    a[G] = 0
                } else {
                    c[c[j + 8 >> 2] >> 2] = 0;
                    c[j + 4 >> 2] = 0
                }
                Fm(j, 0);
                j = z;
                c[G >> 2] = c[j >> 2];
                c[G + 4 >> 2] = c[j + 4 >> 2];
                c[G + 8 >> 2] = c[j + 8 >> 2];
                dv(j | 0, 0, 12) | 0;
                Cm(z);
                E = Fc[c[(c[x >> 2] | 0) + 36 >> 2] & 255](F) | 0;
                c[m >> 2] = E;
                i = n;
                return
            }
        }

        function pr(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            e = a + 4 | 0;
            f = (c[e >> 2] | 0) != 194;
            g = a | 0;
            a = c[g >> 2] | 0;
            h = a;
            i = (c[d >> 2] | 0) - h | 0;
            j = i >>> 0 < 2147483647 >>> 0 ? i << 1 : -1;
            i = (c[b >> 2] | 0) - h >> 2;
            if (f) { k = a } else { k = 0 }
            a = Iu(k, j) | 0;
            k = a;
            if ((a | 0) == 0) { Uu() }
            do {
                if (f) {
                    c[g >> 2] = k;
                    l = k
                } else {
                    a = c[g >> 2] | 0;
                    c[g >> 2] = k;
                    if ((a | 0) == 0) { l = k; break }
                    Dc[c[e >> 2] & 511](a);
                    l = c[g >> 2] | 0
                }
            } while (0);
            c[e >> 2] = 88;
            c[b >> 2] = l + (i << 2);
            c[d >> 2] = (c[g >> 2] | 0) + (j >>> 2 << 2);
            return
        }

        function qr(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function rr(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function sr(b, d, e, f, g, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = j | 0;
            k = +k;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            d = i;
            i = i + 248 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = d | 0;
            m = d + 120 | 0;
            n = d + 232 | 0;
            o = d + 240 | 0;
            p = o;
            q = i;
            i = i + 1 | 0;
            i = i + 7 & -8;
            r = i;
            i = i + 1 | 0;
            i = i + 7 & -8;
            s = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            t = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            u = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            v = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            w = i;
            i = i + 100 | 0;
            i = i + 7 & -8;
            x = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            y = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            z = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            A = d + 16 | 0;
            c[m >> 2] = A;
            B = d + 128 | 0;
            C = db(A | 0, 100, 15056, (A = i, i = i + 8 | 0, h[A >> 3] = k, A) | 0) | 0;
            i = A;
            do {
                if (C >>> 0 > 99 >>> 0) {
                    do {
                        if ((a[51808] | 0) == 0) {
                            if ((ub(51808) | 0) == 0) { break }
                            D = Xa(2147483647, 14472, 0) | 0;
                            c[8330] = D
                        }
                    } while (0);
                    D = kp(m, c[8330] | 0, 15056, (A = i, i = i + 8 | 0, h[A >> 3] = k, A) | 0) | 0;
                    i = A;
                    E = c[m >> 2] | 0;
                    if ((E | 0) == 0) {
                        Uu();
                        F = c[m >> 2] | 0
                    } else { F = E }
                    E = Gu(D) | 0;
                    if ((E | 0) != 0) {
                        G = E;
                        H = D;
                        I = E;
                        J = F;
                        break
                    }
                    Uu();
                    G = 0;
                    H = D;
                    I = 0;
                    J = F
                } else {
                    G = B;
                    H = C;
                    I = 0;
                    J = 0
                }
            } while (0);
            Lm(n, g);
            C = n | 0;
            B = c[C >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[l >> 2] = 34864;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34864, l, 114)
            }
            l = (c[8717] | 0) - 1 | 0;
            F = c[B + 8 >> 2] | 0;
            do {
                if ((c[B + 12 >> 2] | 0) - F >> 2 >>> 0 > l >>> 0) {
                    A = c[F + (l << 2) >> 2] | 0;
                    if ((A | 0) == 0) { break }
                    D = A;
                    E = c[m >> 2] | 0;
                    Sc[c[(c[A >> 2] | 0) + 32 >> 2] & 15](D, E, E + H | 0, G) | 0;
                    if ((H | 0) == 0) { K = 0 } else { K = (a[c[m >> 2] | 0] | 0) == 45 }
                    c[o >> 2] = 0;
                    dv(s | 0, 0, 12) | 0;
                    E = t;
                    dv(E | 0, 0, 12) | 0;
                    A = u;
                    dv(A | 0, 0, 12) | 0;
                    tr(f, K, n, p, q, r, s, t, u, v);
                    L = w | 0;
                    M = c[v >> 2] | 0;
                    if ((H | 0) > (M | 0)) {
                        N = a[A] | 0;
                        if ((N & 1) == 0) { O = (N & 255) >>> 1 } else { O = c[u + 4 >> 2] | 0 }
                        N = a[E] | 0;
                        if ((N & 1) == 0) { P = (N & 255) >>> 1 } else { P = c[t + 4 >> 2] | 0 }
                        Q = O + (H - M << 1 | 1) + P | 0
                    } else {
                        N = a[A] | 0;
                        if ((N & 1) == 0) { R = (N & 255) >>> 1 } else { R = c[u + 4 >> 2] | 0 }
                        N = a[E] | 0;
                        if ((N & 1) == 0) { S = (N & 255) >>> 1 } else { S = c[t + 4 >> 2] | 0 }
                        Q = R + 2 + S | 0
                    }
                    N = Q + M | 0;
                    do {
                        if (N >>> 0 > 100 >>> 0) {
                            E = Gu(N) | 0;
                            if ((E | 0) != 0) {
                                T = E;
                                U = E;
                                break
                            }
                            Uu();
                            T = 0;
                            U = 0
                        } else {
                            T = L;
                            U = 0
                        }
                    } while (0);
                    ur(T, x, y, c[g + 4 >> 2] | 0, G, G + H | 0, D, K, p, a[q] | 0, a[r] | 0, s, t, u, M);
                    c[z >> 2] = c[e >> 2];
                    Bd(b, z, T, c[x >> 2] | 0, c[y >> 2] | 0, g, j);
                    if ((U | 0) != 0) { Hu(U) }
                    rm(u);
                    rm(t);
                    rm(s);
                    Ul(c[C >> 2] | 0) | 0;
                    if ((I | 0) != 0) { Hu(I) }
                    if ((J | 0) == 0) {
                        V = 100;
                        W = 0;
                        X = 100;
                        Y = 0;
                        i = d;
                        return
                    }
                    Hu(J);
                    V = 100;
                    W = 0;
                    X = 100;
                    Y = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function tr(b, d, e, f, g, h, j, k, l, m) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0;
            n = i;
            i = i + 40 | 0;
            o = n | 0;
            p = n + 16 | 0;
            q = n + 32 | 0;
            r = q;
            s = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            t = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            u = t;
            v = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            w = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            x = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            y = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            z = y;
            A = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            B = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            D = B;
            E = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            F = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            G = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            H = c[e >> 2] | 0;
            if (b) {
                if (!((c[8834] | 0) == -1)) {
                    c[p >> 2] = 35336;
                    c[p + 4 >> 2] = 16;
                    c[p + 8 >> 2] = 0;
                    mm(35336, p, 114)
                }
                p = (c[8835] | 0) - 1 | 0;
                b = c[H + 8 >> 2] | 0;
                if (!((c[H + 12 >> 2] | 0) - b >> 2 >>> 0 > p >>> 0)) {
                    I = pc(4) | 0;
                    J = I;
                    lu(J);
                    Fb(I | 0, 25544, 156)
                }
                e = c[b + (p << 2) >> 2] | 0;
                if ((e | 0) == 0) {
                    I = pc(4) | 0;
                    J = I;
                    lu(J);
                    Fb(I | 0, 25544, 156)
                }
                I = e;
                J = c[e >> 2] | 0;
                if (d) {
                    Ec[c[J + 44 >> 2] & 127](r, I);
                    r = f;
                    C = c[q >> 2] | 0;
                    a[r] = C;
                    C = C >> 8;
                    a[r + 1 | 0] = C;
                    C = C >> 8;
                    a[r + 2 | 0] = C;
                    C = C >> 8;
                    a[r + 3 | 0] = C;
                    Ec[c[(c[e >> 2] | 0) + 32 >> 2] & 127](s, I);
                    r = l;
                    if ((a[r] & 1) == 0) {
                        a[l + 1 | 0] = 0;
                        a[r] = 0
                    } else {
                        a[c[l + 8 >> 2] | 0] = 0;
                        c[l + 4 >> 2] = 0
                    }
                    vm(l, 0);
                    q = s;
                    c[r >> 2] = c[q >> 2];
                    c[r + 4 >> 2] = c[q + 4 >> 2];
                    c[r + 8 >> 2] = c[q + 8 >> 2];
                    dv(q | 0, 0, 12) | 0;
                    rm(s)
                } else {
                    Ec[c[J + 40 >> 2] & 127](u, I);
                    u = f;
                    C = c[t >> 2] | 0;
                    a[u] = C;
                    C = C >> 8;
                    a[u + 1 | 0] = C;
                    C = C >> 8;
                    a[u + 2 | 0] = C;
                    C = C >> 8;
                    a[u + 3 | 0] = C;
                    Ec[c[(c[e >> 2] | 0) + 28 >> 2] & 127](v, I);
                    u = l;
                    if ((a[u] & 1) == 0) {
                        a[l + 1 | 0] = 0;
                        a[u] = 0
                    } else {
                        a[c[l + 8 >> 2] | 0] = 0;
                        c[l + 4 >> 2] = 0
                    }
                    vm(l, 0);
                    t = v;
                    c[u >> 2] = c[t >> 2];
                    c[u + 4 >> 2] = c[t + 4 >> 2];
                    c[u + 8 >> 2] = c[t + 8 >> 2];
                    dv(t | 0, 0, 12) | 0;
                    rm(v)
                }
                v = e;
                t = Fc[c[(c[v >> 2] | 0) + 12 >> 2] & 255](I) | 0;
                a[g] = t;
                t = Fc[c[(c[v >> 2] | 0) + 16 >> 2] & 255](I) | 0;
                a[h] = t;
                t = e;
                Ec[c[(c[t >> 2] | 0) + 20 >> 2] & 127](w, I);
                v = j;
                if ((a[v] & 1) == 0) {
                    a[j + 1 | 0] = 0;
                    a[v] = 0
                } else {
                    a[c[j + 8 >> 2] | 0] = 0;
                    c[j + 4 >> 2] = 0
                }
                vm(j, 0);
                u = w;
                c[v >> 2] = c[u >> 2];
                c[v + 4 >> 2] = c[u + 4 >> 2];
                c[v + 8 >> 2] = c[u + 8 >> 2];
                dv(u | 0, 0, 12) | 0;
                rm(w);
                Ec[c[(c[t >> 2] | 0) + 24 >> 2] & 127](x, I);
                t = k;
                if ((a[t] & 1) == 0) {
                    a[k + 1 | 0] = 0;
                    a[t] = 0
                } else {
                    a[c[k + 8 >> 2] | 0] = 0;
                    c[k + 4 >> 2] = 0
                }
                vm(k, 0);
                w = x;
                c[t >> 2] = c[w >> 2];
                c[t + 4 >> 2] = c[w + 4 >> 2];
                c[t + 8 >> 2] = c[w + 8 >> 2];
                dv(w | 0, 0, 12) | 0;
                rm(x);
                K = Fc[c[(c[e >> 2] | 0) + 36 >> 2] & 255](I) | 0;
                c[m >> 2] = K;
                i = n;
                return
            } else {
                if (!((c[8836] | 0) == -1)) {
                    c[o >> 2] = 35344;
                    c[o + 4 >> 2] = 16;
                    c[o + 8 >> 2] = 0;
                    mm(35344, o, 114)
                }
                o = (c[8837] | 0) - 1 | 0;
                I = c[H + 8 >> 2] | 0;
                if (!((c[H + 12 >> 2] | 0) - I >> 2 >>> 0 > o >>> 0)) {
                    L = pc(4) | 0;
                    M = L;
                    lu(M);
                    Fb(L | 0, 25544, 156)
                }
                H = c[I + (o << 2) >> 2] | 0;
                if ((H | 0) == 0) {
                    L = pc(4) | 0;
                    M = L;
                    lu(M);
                    Fb(L | 0, 25544, 156)
                }
                L = H;
                M = c[H >> 2] | 0;
                if (d) {
                    Ec[c[M + 44 >> 2] & 127](z, L);
                    z = f;
                    C = c[y >> 2] | 0;
                    a[z] = C;
                    C = C >> 8;
                    a[z + 1 | 0] = C;
                    C = C >> 8;
                    a[z + 2 | 0] = C;
                    C = C >> 8;
                    a[z + 3 | 0] = C;
                    Ec[c[(c[H >> 2] | 0) + 32 >> 2] & 127](A, L);
                    z = l;
                    if ((a[z] & 1) == 0) {
                        a[l + 1 | 0] = 0;
                        a[z] = 0
                    } else {
                        a[c[l + 8 >> 2] | 0] = 0;
                        c[l + 4 >> 2] = 0
                    }
                    vm(l, 0);
                    y = A;
                    c[z >> 2] = c[y >> 2];
                    c[z + 4 >> 2] = c[y + 4 >> 2];
                    c[z + 8 >> 2] = c[y + 8 >> 2];
                    dv(y | 0, 0, 12) | 0;
                    rm(A)
                } else {
                    Ec[c[M + 40 >> 2] & 127](D, L);
                    D = f;
                    C = c[B >> 2] | 0;
                    a[D] = C;
                    C = C >> 8;
                    a[D + 1 | 0] = C;
                    C = C >> 8;
                    a[D + 2 | 0] = C;
                    C = C >> 8;
                    a[D + 3 | 0] = C;
                    Ec[c[(c[H >> 2] | 0) + 28 >> 2] & 127](E, L);
                    D = l;
                    if ((a[D] & 1) == 0) {
                        a[l + 1 | 0] = 0;
                        a[D] = 0
                    } else {
                        a[c[l + 8 >> 2] | 0] = 0;
                        c[l + 4 >> 2] = 0
                    }
                    vm(l, 0);
                    l = E;
                    c[D >> 2] = c[l >> 2];
                    c[D + 4 >> 2] = c[l + 4 >> 2];
                    c[D + 8 >> 2] = c[l + 8 >> 2];
                    dv(l | 0, 0, 12) | 0;
                    rm(E)
                }
                E = H;
                l = Fc[c[(c[E >> 2] | 0) + 12 >> 2] & 255](L) | 0;
                a[g] = l;
                l = Fc[c[(c[E >> 2] | 0) + 16 >> 2] & 255](L) | 0;
                a[h] = l;
                l = H;
                Ec[c[(c[l >> 2] | 0) + 20 >> 2] & 127](F, L);
                h = j;
                if ((a[h] & 1) == 0) {
                    a[j + 1 | 0] = 0;
                    a[h] = 0
                } else {
                    a[c[j + 8 >> 2] | 0] = 0;
                    c[j + 4 >> 2] = 0
                }
                vm(j, 0);
                j = F;
                c[h >> 2] = c[j >> 2];
                c[h + 4 >> 2] = c[j + 4 >> 2];
                c[h + 8 >> 2] = c[j + 8 >> 2];
                dv(j | 0, 0, 12) | 0;
                rm(F);
                Ec[c[(c[l >> 2] | 0) + 24 >> 2] & 127](G, L);
                l = k;
                if ((a[l] & 1) == 0) {
                    a[k + 1 | 0] = 0;
                    a[l] = 0
                } else {
                    a[c[k + 8 >> 2] | 0] = 0;
                    c[k + 4 >> 2] = 0
                }
                vm(k, 0);
                k = G;
                c[l >> 2] = c[k >> 2];
                c[l + 4 >> 2] = c[k + 4 >> 2];
                c[l + 8 >> 2] = c[k + 8 >> 2];
                dv(k | 0, 0, 12) | 0;
                rm(G);
                K = Fc[c[(c[H >> 2] | 0) + 36 >> 2] & 255](L) | 0;
                c[m >> 2] = K;
                i = n;
                return
            }
        }

        function ur(d, e, f, g, h, i, j, k, l, m, n, o, p, q, r) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            r = r | 0;
            var s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0;
            c[f >> 2] = d;
            s = j;
            t = q;
            u = q + 1 | 0;
            v = q + 8 | 0;
            w = q + 4 | 0;
            q = p;
            x = (g & 512 | 0) == 0;
            y = p + 1 | 0;
            z = p + 8 | 0;
            A = p + 4 | 0;
            p = (r | 0) > 0;
            B = o;
            C = o + 1 | 0;
            D = o + 8 | 0;
            E = o + 4 | 0;
            o = j + 8 | 0;
            F = -r | 0;
            G = 0;
            H = h;
            while (1) {
                a: do {
                    switch (a[l + G | 0] | 0) {
                        case 0:
                            { c[e >> 2] = c[f >> 2];I = H; break };
                        case 1:
                            { c[e >> 2] = c[f >> 2];h = Qc[c[(c[s >> 2] | 0) + 28 >> 2] & 63](j, 32) | 0;J = c[f >> 2] | 0;c[f >> 2] = J + 1;a[J] = h;I = H; break };
                        case 3:
                            {
                                h = a[t] | 0;J = (h & 1) == 0;
                                if (J) { K = (h & 255) >>> 1 } else { K = c[w >> 2] | 0 }
                                if ((K | 0) == 0) { I = H; break a }
                                if (J) { L = u } else { L = c[v >> 2] | 0 }
                                J = a[L] | 0;h = c[f >> 2] | 0;c[f >> 2] = h + 1;a[h] = J;I = H;
                                break
                            };
                        case 2:
                            {
                                J = a[q] | 0;h = (J & 1) == 0;
                                if (h) { M = (J & 255) >>> 1 } else { M = c[A >> 2] | 0 }
                                if ((M | 0) == 0 | x) { I = H; break a }
                                if (h) {
                                    N = (J & 255) >>> 1;
                                    O = y;
                                    P = y
                                } else {
                                    J = c[z >> 2] | 0;
                                    N = c[A >> 2] | 0;
                                    O = J;
                                    P = J
                                }
                                J = O + N | 0;h = c[f >> 2] | 0;
                                if ((P | 0) == (J | 0)) { Q = h } else {
                                    R = h;
                                    h = P;
                                    while (1) {
                                        a[R] = a[h] | 0;
                                        S = h + 1 | 0;
                                        T = R + 1 | 0;
                                        if ((S | 0) == (J | 0)) { Q = T; break } else {
                                            R = T;
                                            h = S
                                        }
                                    }
                                }
                                c[f >> 2] = Q;I = H;
                                break
                            };
                        case 4:
                            {
                                h = c[f >> 2] | 0;R = k ? H + 1 | 0 : H;b: do {
                                    if (R >>> 0 < i >>> 0) {
                                        J = R;
                                        while (1) {
                                            S = a[J] | 0;
                                            if (!(S << 24 >> 24 > -1)) { U = J; break b }
                                            T = J + 1 | 0;
                                            if ((b[(c[o >> 2] | 0) + (S << 24 >> 24 << 1) >> 1] & 2048) == 0) { U = J; break b }
                                            if (T >>> 0 < i >>> 0) { J = T } else { U = T; break }
                                        }
                                    } else { U = R }
                                } while (0);J = U;
                                if (p) {
                                    if (U >>> 0 > R >>> 0) {
                                        T = R + (-J | 0) | 0;
                                        J = T >>> 0 < F >>> 0 ? F : T;
                                        T = J + r | 0;
                                        S = U;
                                        V = r;
                                        W = h;
                                        while (1) {
                                            X = S - 1 | 0;
                                            Y = a[X] | 0;
                                            c[f >> 2] = W + 1;
                                            a[W] = Y;
                                            Y = V - 1 | 0;
                                            Z = (Y | 0) > 0;
                                            if (!(X >>> 0 > R >>> 0 & Z)) { break }
                                            S = X;
                                            V = Y;
                                            W = c[f >> 2] | 0
                                        }
                                        W = U + J | 0;
                                        if (Z) {
                                            _ = T;
                                            $ = W;
                                            aa = 32
                                        } else {
                                            ba = 0;
                                            ca = T;
                                            da = W
                                        }
                                    } else {
                                        _ = r;
                                        $ = U;
                                        aa = 32
                                    }
                                    if ((aa | 0) == 32) {
                                        aa = 0;
                                        ba = Qc[c[(c[s >> 2] | 0) + 28 >> 2] & 63](j, 48) | 0;
                                        ca = _;
                                        da = $
                                    }
                                    W = c[f >> 2] | 0;
                                    c[f >> 2] = W + 1;
                                    if ((ca | 0) > 0) {
                                        V = ca;
                                        S = W;
                                        while (1) {
                                            a[S] = ba;
                                            Y = V - 1 | 0;
                                            X = c[f >> 2] | 0;
                                            c[f >> 2] = X + 1;
                                            if ((Y | 0) > 0) {
                                                V = Y;
                                                S = X
                                            } else { ea = X; break }
                                        }
                                    } else { ea = W }
                                    a[ea] = m;
                                    fa = da
                                } else { fa = U }
                                if ((fa | 0) == (R | 0)) {
                                    S = Qc[c[(c[s >> 2] | 0) + 28 >> 2] & 63](j, 48) | 0;
                                    V = c[f >> 2] | 0;
                                    c[f >> 2] = V + 1;
                                    a[V] = S
                                } else {
                                    S = a[B] | 0;
                                    V = (S & 1) == 0;
                                    if (V) { ga = (S & 255) >>> 1 } else { ga = c[E >> 2] | 0 }
                                    if ((ga | 0) == 0) {
                                        ha = fa;
                                        ia = 0;
                                        ja = 0;
                                        ka = -1
                                    } else {
                                        if (V) { la = C } else { la = c[D >> 2] | 0 }
                                        ha = fa;
                                        ia = 0;
                                        ja = 0;
                                        ka = a[la] | 0
                                    }
                                    while (1) {
                                        do {
                                            if ((ia | 0) == (ka | 0)) {
                                                V = c[f >> 2] | 0;
                                                c[f >> 2] = V + 1;
                                                a[V] = n;
                                                V = ja + 1 | 0;
                                                S = a[B] | 0;
                                                T = (S & 1) == 0;
                                                if (T) { ma = (S & 255) >>> 1 } else { ma = c[E >> 2] | 0 }
                                                if (!(V >>> 0 < ma >>> 0)) {
                                                    na = ka;
                                                    oa = V;
                                                    pa = 0;
                                                    break
                                                }
                                                if (T) { qa = C } else { qa = c[D >> 2] | 0 }
                                                if ((a[qa + V | 0] | 0) == 127) {
                                                    na = -1;
                                                    oa = V;
                                                    pa = 0;
                                                    break
                                                }
                                                if (T) { ra = C } else { ra = c[D >> 2] | 0 }
                                                na = a[ra + V | 0] | 0;
                                                oa = V;
                                                pa = 0
                                            } else {
                                                na = ka;
                                                oa = ja;
                                                pa = ia
                                            }
                                        } while (0);
                                        V = ha - 1 | 0;
                                        T = a[V] | 0;
                                        S = c[f >> 2] | 0;
                                        c[f >> 2] = S + 1;
                                        a[S] = T;
                                        if ((V | 0) == (R | 0)) { break } else {
                                            ha = V;
                                            ia = pa + 1 | 0;
                                            ja = oa;
                                            ka = na
                                        }
                                    }
                                }
                                W = c[f >> 2] | 0;
                                if ((h | 0) == (W | 0)) { I = R; break a }
                                V = W - 1 | 0;
                                if (V >>> 0 > h >>> 0) {
                                    sa = h;
                                    ta = V
                                } else { I = R; break a }
                                while (1) {
                                    V = a[sa] | 0;
                                    a[sa] = a[ta] | 0;
                                    a[ta] = V;
                                    V = sa + 1 | 0;
                                    W = ta - 1 | 0;
                                    if (V >>> 0 < W >>> 0) {
                                        sa = V;
                                        ta = W
                                    } else { I = R; break }
                                }
                                break
                            };
                        default:
                            { I = H }
                    }
                } while (0);R = G + 1 | 0;
                if (R >>> 0 < 4 >>> 0) {
                    G = R;
                    H = I
                } else { break }
            }
            I = a[t] | 0;
            t = (I & 1) == 0;
            if (t) { ua = (I & 255) >>> 1 } else { ua = c[w >> 2] | 0 }
            if (ua >>> 0 > 1 >>> 0) {
                if (t) {
                    va = (I & 255) >>> 1;
                    wa = u;
                    xa = u
                } else {
                    u = c[v >> 2] | 0;
                    va = c[w >> 2] | 0;
                    wa = u;
                    xa = u
                }
                u = xa + 1 | 0;
                xa = wa + va | 0;
                va = c[f >> 2] | 0;
                if ((u | 0) == (xa | 0)) { ya = va } else {
                    wa = va;
                    va = u;
                    while (1) {
                        a[wa] = a[va] | 0;
                        u = va + 1 | 0;
                        w = wa + 1 | 0;
                        if ((u | 0) == (xa | 0)) { ya = w; break } else {
                            wa = w;
                            va = u
                        }
                    }
                }
                c[f >> 2] = ya
            }
            ya = g & 176;
            if ((ya | 0) == 32) { c[e >> 2] = c[f >> 2]; return } else if ((ya | 0) == 16) { return } else { c[e >> 2] = d; return }
        }

        function vr(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0;
            d = i;
            i = i + 32 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 16 | 0;
            m = d + 24 | 0;
            n = m;
            o = i;
            i = i + 1 | 0;
            i = i + 7 & -8;
            p = i;
            i = i + 1 | 0;
            i = i + 7 & -8;
            q = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            r = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            s = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            t = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            u = i;
            i = i + 100 | 0;
            i = i + 7 & -8;
            v = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            w = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            x = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            Lm(l, g);
            y = l | 0;
            z = c[y >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[k >> 2] = 34864;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34864, k, 114)
            }
            k = (c[8717] | 0) - 1 | 0;
            A = c[z + 8 >> 2] | 0;
            do {
                if ((c[z + 12 >> 2] | 0) - A >> 2 >>> 0 > k >>> 0) {
                    B = c[A + (k << 2) >> 2] | 0;
                    if ((B | 0) == 0) { break }
                    C = B;
                    D = j;
                    E = a[D] | 0;
                    F = (E & 1) == 0;
                    if (F) { G = (E & 255) >>> 1 } else { G = c[j + 4 >> 2] | 0 }
                    if ((G | 0) == 0) { H = 0 } else {
                        if (F) { I = j + 1 | 0 } else { I = c[j + 8 >> 2] | 0 }
                        F = a[I] | 0;
                        H = F << 24 >> 24 == (Qc[c[(c[B >> 2] | 0) + 28 >> 2] & 63](C, 45) | 0) << 24 >> 24
                    }
                    c[m >> 2] = 0;
                    dv(q | 0, 0, 12) | 0;
                    B = r;
                    dv(B | 0, 0, 12) | 0;
                    F = s;
                    dv(F | 0, 0, 12) | 0;
                    tr(f, H, l, n, o, p, q, r, s, t);
                    E = u | 0;
                    J = a[D] | 0;
                    K = (J & 1) == 0;
                    if (K) { L = (J & 255) >>> 1 } else { L = c[j + 4 >> 2] | 0 }
                    M = c[t >> 2] | 0;
                    if ((L | 0) > (M | 0)) {
                        if (K) { N = (J & 255) >>> 1 } else { N = c[j + 4 >> 2] | 0 }
                        K = a[F] | 0;
                        if ((K & 1) == 0) { O = (K & 255) >>> 1 } else { O = c[s + 4 >> 2] | 0 }
                        K = a[B] | 0;
                        if ((K & 1) == 0) { P = (K & 255) >>> 1 } else { P = c[r + 4 >> 2] | 0 }
                        Q = O + (N - M << 1 | 1) + P | 0
                    } else {
                        K = a[F] | 0;
                        if ((K & 1) == 0) { R = (K & 255) >>> 1 } else { R = c[s + 4 >> 2] | 0 }
                        K = a[B] | 0;
                        if ((K & 1) == 0) { S = (K & 255) >>> 1 } else { S = c[r + 4 >> 2] | 0 }
                        Q = R + 2 + S | 0
                    }
                    K = Q + M | 0;
                    do {
                        if (K >>> 0 > 100 >>> 0) {
                            B = Gu(K) | 0;
                            if ((B | 0) != 0) {
                                T = B;
                                U = B;
                                V = J;
                                break
                            }
                            Uu();
                            T = 0;
                            U = 0;
                            V = a[D] | 0
                        } else {
                            T = E;
                            U = 0;
                            V = J
                        }
                    } while (0);
                    if ((V & 1) == 0) {
                        W = (V & 255) >>> 1;
                        X = j + 1 | 0
                    } else {
                        W = c[j + 4 >> 2] | 0;
                        X = c[j + 8 >> 2] | 0
                    }
                    ur(T, v, w, c[g + 4 >> 2] | 0, X, X + W | 0, C, H, n, a[o] | 0, a[p] | 0, q, r, s, M);
                    c[x >> 2] = c[e >> 2];
                    Bd(b, x, T, c[v >> 2] | 0, c[w >> 2] | 0, g, h);
                    if ((U | 0) == 0) {
                        Y = 100;
                        Z = 0;
                        rm(s);
                        rm(r);
                        rm(q);
                        _ = c[y >> 2] | 0;
                        $ = _ | 0;
                        aa = Ul($) | 0;
                        i = d;
                        return
                    }
                    Hu(U);
                    Y = 100;
                    Z = 0;
                    rm(s);
                    rm(r);
                    rm(q);
                    _ = c[y >> 2] | 0;
                    $ = _ | 0;
                    aa = Ul($) | 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function wr(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function xr(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function yr(b, d, e, f, g, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = j | 0;
            k = +k;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            d = i;
            i = i + 544 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = d | 0;
            m = d + 120 | 0;
            n = d + 528 | 0;
            o = d + 536 | 0;
            p = o;
            q = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            r = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            s = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            t = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            u = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            v = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            w = i;
            i = i + 400 | 0;
            x = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            y = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            z = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            A = d + 16 | 0;
            c[m >> 2] = A;
            B = d + 128 | 0;
            C = db(A | 0, 100, 15056, (A = i, i = i + 8 | 0, h[A >> 3] = k, A) | 0) | 0;
            i = A;
            do {
                if (C >>> 0 > 99 >>> 0) {
                    do {
                        if ((a[51808] | 0) == 0) {
                            if ((ub(51808) | 0) == 0) { break }
                            D = Xa(2147483647, 14472, 0) | 0;
                            c[8330] = D
                        }
                    } while (0);
                    D = kp(m, c[8330] | 0, 15056, (A = i, i = i + 8 | 0, h[A >> 3] = k, A) | 0) | 0;
                    i = A;
                    E = c[m >> 2] | 0;
                    if ((E | 0) == 0) {
                        Uu();
                        F = c[m >> 2] | 0
                    } else { F = E }
                    E = Gu(D << 2) | 0;
                    G = E;
                    if ((E | 0) != 0) {
                        H = G;
                        I = D;
                        J = G;
                        K = F;
                        break
                    }
                    Uu();
                    H = 0;
                    I = D;
                    J = 0;
                    K = F
                } else {
                    H = B;
                    I = C;
                    J = 0;
                    K = 0
                }
            } while (0);
            Lm(n, g);
            C = n | 0;
            B = c[C >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[l >> 2] = 34856;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34856, l, 114)
            }
            l = (c[8715] | 0) - 1 | 0;
            F = c[B + 8 >> 2] | 0;
            do {
                if ((c[B + 12 >> 2] | 0) - F >> 2 >>> 0 > l >>> 0) {
                    A = c[F + (l << 2) >> 2] | 0;
                    if ((A | 0) == 0) { break }
                    D = A;
                    G = c[m >> 2] | 0;
                    Sc[c[(c[A >> 2] | 0) + 48 >> 2] & 15](D, G, G + I | 0, H) | 0;
                    if ((I | 0) == 0) { L = 0 } else { L = (a[c[m >> 2] | 0] | 0) == 45 }
                    c[o >> 2] = 0;
                    dv(s | 0, 0, 12) | 0;
                    G = t;
                    dv(G | 0, 0, 12) | 0;
                    A = u;
                    dv(A | 0, 0, 12) | 0;
                    zr(f, L, n, p, q, r, s, t, u, v);
                    E = w | 0;
                    M = c[v >> 2] | 0;
                    if ((I | 0) > (M | 0)) {
                        N = a[A] | 0;
                        if ((N & 1) == 0) { O = (N & 255) >>> 1 } else { O = c[u + 4 >> 2] | 0 }
                        N = a[G] | 0;
                        if ((N & 1) == 0) { P = (N & 255) >>> 1 } else { P = c[t + 4 >> 2] | 0 }
                        Q = O + (I - M << 1 | 1) + P | 0
                    } else {
                        N = a[A] | 0;
                        if ((N & 1) == 0) { R = (N & 255) >>> 1 } else { R = c[u + 4 >> 2] | 0 }
                        N = a[G] | 0;
                        if ((N & 1) == 0) { S = (N & 255) >>> 1 } else { S = c[t + 4 >> 2] | 0 }
                        Q = R + 2 + S | 0
                    }
                    N = Q + M | 0;
                    do {
                        if (N >>> 0 > 100 >>> 0) {
                            G = Gu(N << 2) | 0;
                            A = G;
                            if ((G | 0) != 0) {
                                T = A;
                                U = A;
                                break
                            }
                            Uu();
                            T = 0;
                            U = 0
                        } else {
                            T = E;
                            U = 0
                        }
                    } while (0);
                    Ar(T, x, y, c[g + 4 >> 2] | 0, H, H + (I << 2) | 0, D, L, p, c[q >> 2] | 0, c[r >> 2] | 0, s, t, u, M);
                    c[z >> 2] = c[e >> 2];
                    tp(b, z, T, c[x >> 2] | 0, c[y >> 2] | 0, g, j);
                    if ((U | 0) != 0) { Hu(U) }
                    Cm(u);
                    Cm(t);
                    rm(s);
                    Ul(c[C >> 2] | 0) | 0;
                    if ((J | 0) != 0) { Hu(J) }
                    if ((K | 0) == 0) {
                        V = 400;
                        W = 0;
                        X = 100;
                        Y = 0;
                        i = d;
                        return
                    }
                    Hu(K);
                    V = 400;
                    W = 0;
                    X = 100;
                    Y = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function zr(b, d, e, f, g, h, j, k, l, m) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0;
            n = i;
            i = i + 40 | 0;
            o = n | 0;
            p = n + 16 | 0;
            q = n + 32 | 0;
            r = q;
            s = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            t = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            u = t;
            v = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            w = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            x = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            y = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            z = y;
            A = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            B = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            D = B;
            E = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            F = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            G = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            H = c[e >> 2] | 0;
            if (b) {
                if (!((c[8830] | 0) == -1)) {
                    c[p >> 2] = 35320;
                    c[p + 4 >> 2] = 16;
                    c[p + 8 >> 2] = 0;
                    mm(35320, p, 114)
                }
                p = (c[8831] | 0) - 1 | 0;
                b = c[H + 8 >> 2] | 0;
                if (!((c[H + 12 >> 2] | 0) - b >> 2 >>> 0 > p >>> 0)) {
                    I = pc(4) | 0;
                    J = I;
                    lu(J);
                    Fb(I | 0, 25544, 156)
                }
                e = c[b + (p << 2) >> 2] | 0;
                if ((e | 0) == 0) {
                    I = pc(4) | 0;
                    J = I;
                    lu(J);
                    Fb(I | 0, 25544, 156)
                }
                I = e;
                J = c[e >> 2] | 0;
                if (d) {
                    Ec[c[J + 44 >> 2] & 127](r, I);
                    r = f;
                    C = c[q >> 2] | 0;
                    a[r] = C;
                    C = C >> 8;
                    a[r + 1 | 0] = C;
                    C = C >> 8;
                    a[r + 2 | 0] = C;
                    C = C >> 8;
                    a[r + 3 | 0] = C;
                    Ec[c[(c[e >> 2] | 0) + 32 >> 2] & 127](s, I);
                    r = l;
                    if ((a[r] & 1) == 0) {
                        c[l + 4 >> 2] = 0;
                        a[r] = 0
                    } else {
                        c[c[l + 8 >> 2] >> 2] = 0;
                        c[l + 4 >> 2] = 0
                    }
                    Fm(l, 0);
                    q = s;
                    c[r >> 2] = c[q >> 2];
                    c[r + 4 >> 2] = c[q + 4 >> 2];
                    c[r + 8 >> 2] = c[q + 8 >> 2];
                    dv(q | 0, 0, 12) | 0;
                    Cm(s)
                } else {
                    Ec[c[J + 40 >> 2] & 127](u, I);
                    u = f;
                    C = c[t >> 2] | 0;
                    a[u] = C;
                    C = C >> 8;
                    a[u + 1 | 0] = C;
                    C = C >> 8;
                    a[u + 2 | 0] = C;
                    C = C >> 8;
                    a[u + 3 | 0] = C;
                    Ec[c[(c[e >> 2] | 0) + 28 >> 2] & 127](v, I);
                    u = l;
                    if ((a[u] & 1) == 0) {
                        c[l + 4 >> 2] = 0;
                        a[u] = 0
                    } else {
                        c[c[l + 8 >> 2] >> 2] = 0;
                        c[l + 4 >> 2] = 0
                    }
                    Fm(l, 0);
                    t = v;
                    c[u >> 2] = c[t >> 2];
                    c[u + 4 >> 2] = c[t + 4 >> 2];
                    c[u + 8 >> 2] = c[t + 8 >> 2];
                    dv(t | 0, 0, 12) | 0;
                    Cm(v)
                }
                v = e;
                t = Fc[c[(c[v >> 2] | 0) + 12 >> 2] & 255](I) | 0;
                c[g >> 2] = t;
                t = Fc[c[(c[v >> 2] | 0) + 16 >> 2] & 255](I) | 0;
                c[h >> 2] = t;
                Ec[c[(c[e >> 2] | 0) + 20 >> 2] & 127](w, I);
                t = j;
                if ((a[t] & 1) == 0) {
                    a[j + 1 | 0] = 0;
                    a[t] = 0
                } else {
                    a[c[j + 8 >> 2] | 0] = 0;
                    c[j + 4 >> 2] = 0
                }
                vm(j, 0);
                u = w;
                c[t >> 2] = c[u >> 2];
                c[t + 4 >> 2] = c[u + 4 >> 2];
                c[t + 8 >> 2] = c[u + 8 >> 2];
                dv(u | 0, 0, 12) | 0;
                rm(w);
                Ec[c[(c[e >> 2] | 0) + 24 >> 2] & 127](x, I);
                e = k;
                if ((a[e] & 1) == 0) {
                    c[k + 4 >> 2] = 0;
                    a[e] = 0
                } else {
                    c[c[k + 8 >> 2] >> 2] = 0;
                    c[k + 4 >> 2] = 0
                }
                Fm(k, 0);
                w = x;
                c[e >> 2] = c[w >> 2];
                c[e + 4 >> 2] = c[w + 4 >> 2];
                c[e + 8 >> 2] = c[w + 8 >> 2];
                dv(w | 0, 0, 12) | 0;
                Cm(x);
                K = Fc[c[(c[v >> 2] | 0) + 36 >> 2] & 255](I) | 0;
                c[m >> 2] = K;
                i = n;
                return
            } else {
                if (!((c[8832] | 0) == -1)) {
                    c[o >> 2] = 35328;
                    c[o + 4 >> 2] = 16;
                    c[o + 8 >> 2] = 0;
                    mm(35328, o, 114)
                }
                o = (c[8833] | 0) - 1 | 0;
                I = c[H + 8 >> 2] | 0;
                if (!((c[H + 12 >> 2] | 0) - I >> 2 >>> 0 > o >>> 0)) {
                    L = pc(4) | 0;
                    M = L;
                    lu(M);
                    Fb(L | 0, 25544, 156)
                }
                H = c[I + (o << 2) >> 2] | 0;
                if ((H | 0) == 0) {
                    L = pc(4) | 0;
                    M = L;
                    lu(M);
                    Fb(L | 0, 25544, 156)
                }
                L = H;
                M = c[H >> 2] | 0;
                if (d) {
                    Ec[c[M + 44 >> 2] & 127](z, L);
                    z = f;
                    C = c[y >> 2] | 0;
                    a[z] = C;
                    C = C >> 8;
                    a[z + 1 | 0] = C;
                    C = C >> 8;
                    a[z + 2 | 0] = C;
                    C = C >> 8;
                    a[z + 3 | 0] = C;
                    Ec[c[(c[H >> 2] | 0) + 32 >> 2] & 127](A, L);
                    z = l;
                    if ((a[z] & 1) == 0) {
                        c[l + 4 >> 2] = 0;
                        a[z] = 0
                    } else {
                        c[c[l + 8 >> 2] >> 2] = 0;
                        c[l + 4 >> 2] = 0
                    }
                    Fm(l, 0);
                    y = A;
                    c[z >> 2] = c[y >> 2];
                    c[z + 4 >> 2] = c[y + 4 >> 2];
                    c[z + 8 >> 2] = c[y + 8 >> 2];
                    dv(y | 0, 0, 12) | 0;
                    Cm(A)
                } else {
                    Ec[c[M + 40 >> 2] & 127](D, L);
                    D = f;
                    C = c[B >> 2] | 0;
                    a[D] = C;
                    C = C >> 8;
                    a[D + 1 | 0] = C;
                    C = C >> 8;
                    a[D + 2 | 0] = C;
                    C = C >> 8;
                    a[D + 3 | 0] = C;
                    Ec[c[(c[H >> 2] | 0) + 28 >> 2] & 127](E, L);
                    D = l;
                    if ((a[D] & 1) == 0) {
                        c[l + 4 >> 2] = 0;
                        a[D] = 0
                    } else {
                        c[c[l + 8 >> 2] >> 2] = 0;
                        c[l + 4 >> 2] = 0
                    }
                    Fm(l, 0);
                    l = E;
                    c[D >> 2] = c[l >> 2];
                    c[D + 4 >> 2] = c[l + 4 >> 2];
                    c[D + 8 >> 2] = c[l + 8 >> 2];
                    dv(l | 0, 0, 12) | 0;
                    Cm(E)
                }
                E = H;
                l = Fc[c[(c[E >> 2] | 0) + 12 >> 2] & 255](L) | 0;
                c[g >> 2] = l;
                l = Fc[c[(c[E >> 2] | 0) + 16 >> 2] & 255](L) | 0;
                c[h >> 2] = l;
                Ec[c[(c[H >> 2] | 0) + 20 >> 2] & 127](F, L);
                l = j;
                if ((a[l] & 1) == 0) {
                    a[j + 1 | 0] = 0;
                    a[l] = 0
                } else {
                    a[c[j + 8 >> 2] | 0] = 0;
                    c[j + 4 >> 2] = 0
                }
                vm(j, 0);
                j = F;
                c[l >> 2] = c[j >> 2];
                c[l + 4 >> 2] = c[j + 4 >> 2];
                c[l + 8 >> 2] = c[j + 8 >> 2];
                dv(j | 0, 0, 12) | 0;
                rm(F);
                Ec[c[(c[H >> 2] | 0) + 24 >> 2] & 127](G, L);
                H = k;
                if ((a[H] & 1) == 0) {
                    c[k + 4 >> 2] = 0;
                    a[H] = 0
                } else {
                    c[c[k + 8 >> 2] >> 2] = 0;
                    c[k + 4 >> 2] = 0
                }
                Fm(k, 0);
                k = G;
                c[H >> 2] = c[k >> 2];
                c[H + 4 >> 2] = c[k + 4 >> 2];
                c[H + 8 >> 2] = c[k + 8 >> 2];
                dv(k | 0, 0, 12) | 0;
                Cm(G);
                K = Fc[c[(c[E >> 2] | 0) + 36 >> 2] & 255](L) | 0;
                c[m >> 2] = K;
                i = n;
                return
            }
        }

        function Ar(b, d, e, f, g, h, i, j, k, l, m, n, o, p, q) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            var r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0;
            c[e >> 2] = b;
            r = i;
            s = p;
            t = p + 4 | 0;
            u = p + 8 | 0;
            p = o;
            v = (f & 512 | 0) == 0;
            w = o + 4 | 0;
            x = o + 8 | 0;
            o = (q | 0) > 0;
            y = n;
            z = n + 1 | 0;
            A = n + 8 | 0;
            B = n + 4 | 0;
            n = i;
            C = 0;
            D = g;
            while (1) {
                a: do {
                    switch (a[k + C | 0] | 0) {
                        case 0:
                            { c[d >> 2] = c[e >> 2];E = D; break };
                        case 1:
                            { c[d >> 2] = c[e >> 2];g = Qc[c[(c[r >> 2] | 0) + 44 >> 2] & 63](i, 32) | 0;F = c[e >> 2] | 0;c[e >> 2] = F + 4;c[F >> 2] = g;E = D; break };
                        case 3:
                            {
                                g = a[s] | 0;F = (g & 1) == 0;
                                if (F) { G = (g & 255) >>> 1 } else { G = c[t >> 2] | 0 }
                                if ((G | 0) == 0) { E = D; break a }
                                if (F) { H = t } else { H = c[u >> 2] | 0 }
                                F = c[H >> 2] | 0;g = c[e >> 2] | 0;c[e >> 2] = g + 4;c[g >> 2] = F;E = D;
                                break
                            };
                        case 2:
                            {
                                F = a[p] | 0;g = (F & 1) == 0;
                                if (g) { I = (F & 255) >>> 1 } else { I = c[w >> 2] | 0 }
                                if ((I | 0) == 0 | v) { E = D; break a }
                                if (g) {
                                    J = (F & 255) >>> 1;
                                    K = w;
                                    L = w
                                } else {
                                    F = c[x >> 2] | 0;
                                    J = c[w >> 2] | 0;
                                    K = F;
                                    L = F
                                }
                                F = K + (J << 2) | 0;g = c[e >> 2] | 0;
                                if ((L | 0) == (F | 0)) { M = g } else {
                                    N = (K + (J - 1 << 2) + (-L | 0) | 0) >>> 2;
                                    O = g;
                                    P = L;
                                    while (1) {
                                        c[O >> 2] = c[P >> 2];
                                        Q = P + 4 | 0;
                                        if ((Q | 0) == (F | 0)) { break }
                                        O = O + 4 | 0;
                                        P = Q
                                    }
                                    M = g + (N + 1 << 2) | 0
                                }
                                c[e >> 2] = M;E = D;
                                break
                            };
                        case 4:
                            {
                                P = c[e >> 2] | 0;O = j ? D + 4 | 0 : D;b: do { if (O >>> 0 < h >>> 0) { F = O; while (1) { Q = F + 4 | 0; if (!(Hc[c[(c[n >> 2] | 0) + 12 >> 2] & 63](i, 2048, c[F >> 2] | 0) | 0)) { R = F; break b } if (Q >>> 0 < h >>> 0) { F = Q } else { R = Q; break } } } else { R = O } } while (0);
                                if (o) {
                                    do {
                                        if (R >>> 0 > O >>> 0) {
                                            N = R;
                                            g = q;
                                            F = c[e >> 2] | 0;
                                            while (1) {
                                                S = N - 4 | 0;
                                                T = F + 4 | 0;
                                                c[F >> 2] = c[S >> 2];
                                                U = g - 1 | 0;
                                                V = (U | 0) > 0;
                                                if (S >>> 0 > O >>> 0 & V) {
                                                    N = S;
                                                    g = U;
                                                    F = T
                                                } else { break }
                                            }
                                            c[e >> 2] = T;
                                            if (V) {
                                                W = U;
                                                X = S;
                                                Y = 34;
                                                break
                                            }
                                            F = c[e >> 2] | 0;
                                            c[e >> 2] = F + 4;
                                            Z = F;
                                            _ = S
                                        } else {
                                            W = q;
                                            X = R;
                                            Y = 34
                                        }
                                    } while (0);
                                    do {
                                        if ((Y | 0) == 34) {
                                            Y = 0;
                                            F = Qc[c[(c[r >> 2] | 0) + 44 >> 2] & 63](i, 48) | 0;
                                            g = c[e >> 2] | 0;
                                            N = g + 4 | 0;
                                            c[e >> 2] = N;
                                            if ((W | 0) > 0) {
                                                $ = W;
                                                aa = g;
                                                ba = N
                                            } else {
                                                Z = g;
                                                _ = X;
                                                break
                                            }
                                            while (1) {
                                                c[aa >> 2] = F;
                                                N = $ - 1 | 0;
                                                if ((N | 0) > 0) {
                                                    $ = N;
                                                    aa = ba;
                                                    ba = ba + 4 | 0
                                                } else { break }
                                            }
                                            c[e >> 2] = g + (W + 1 << 2);
                                            Z = g + (W << 2) | 0;
                                            _ = X
                                        }
                                    } while (0);
                                    c[Z >> 2] = l;
                                    ca = _
                                } else { ca = R }
                                if ((ca | 0) == (O | 0)) {
                                    F = Qc[c[(c[r >> 2] | 0) + 44 >> 2] & 63](i, 48) | 0;
                                    N = c[e >> 2] | 0;
                                    Q = N + 4 | 0;
                                    c[e >> 2] = Q;
                                    c[N >> 2] = F;
                                    da = Q
                                } else {
                                    Q = a[y] | 0;
                                    F = (Q & 1) == 0;
                                    if (F) { ea = (Q & 255) >>> 1 } else { ea = c[B >> 2] | 0 }
                                    if ((ea | 0) == 0) {
                                        fa = ca;
                                        ga = 0;
                                        ha = 0;
                                        ia = -1
                                    } else {
                                        if (F) { ja = z } else { ja = c[A >> 2] | 0 }
                                        fa = ca;
                                        ga = 0;
                                        ha = 0;
                                        ia = a[ja] | 0
                                    }
                                    while (1) {
                                        F = c[e >> 2] | 0;
                                        do {
                                            if ((ga | 0) == (ia | 0)) {
                                                Q = F + 4 | 0;
                                                c[e >> 2] = Q;
                                                c[F >> 2] = m;
                                                N = ha + 1 | 0;
                                                ka = a[y] | 0;
                                                la = (ka & 1) == 0;
                                                if (la) { ma = (ka & 255) >>> 1 } else { ma = c[B >> 2] | 0 }
                                                if (!(N >>> 0 < ma >>> 0)) {
                                                    na = ia;
                                                    oa = N;
                                                    pa = 0;
                                                    qa = Q;
                                                    break
                                                }
                                                if (la) { ra = z } else { ra = c[A >> 2] | 0 }
                                                if ((a[ra + N | 0] | 0) == 127) {
                                                    na = -1;
                                                    oa = N;
                                                    pa = 0;
                                                    qa = Q;
                                                    break
                                                }
                                                if (la) { sa = z } else { sa = c[A >> 2] | 0 }
                                                na = a[sa + N | 0] | 0;
                                                oa = N;
                                                pa = 0;
                                                qa = Q
                                            } else {
                                                na = ia;
                                                oa = ha;
                                                pa = ga;
                                                qa = F
                                            }
                                        } while (0);
                                        F = fa - 4 | 0;
                                        g = c[F >> 2] | 0;
                                        Q = qa + 4 | 0;
                                        c[e >> 2] = Q;
                                        c[qa >> 2] = g;
                                        if ((F | 0) == (O | 0)) { da = Q; break } else {
                                            fa = F;
                                            ga = pa + 1 | 0;
                                            ha = oa;
                                            ia = na
                                        }
                                    }
                                }
                                if ((P | 0) == (da | 0)) { E = O; break a }
                                F = da - 4 | 0;
                                if (F >>> 0 > P >>> 0) {
                                    ta = P;
                                    ua = F
                                } else { E = O; break a }
                                while (1) {
                                    F = c[ta >> 2] | 0;
                                    c[ta >> 2] = c[ua >> 2];
                                    c[ua >> 2] = F;
                                    F = ta + 4 | 0;
                                    Q = ua - 4 | 0;
                                    if (F >>> 0 < Q >>> 0) {
                                        ta = F;
                                        ua = Q
                                    } else { E = O; break }
                                }
                                break
                            };
                        default:
                            { E = D }
                    }
                } while (0);O = C + 1 | 0;
                if (O >>> 0 < 4 >>> 0) {
                    C = O;
                    D = E
                } else { break }
            }
            E = a[s] | 0;
            s = (E & 1) == 0;
            if (s) { va = (E & 255) >>> 1 } else { va = c[t >> 2] | 0 }
            if (va >>> 0 > 1 >>> 0) {
                if (s) {
                    wa = (E & 255) >>> 1;
                    xa = t;
                    ya = t
                } else {
                    E = c[u >> 2] | 0;
                    wa = c[t >> 2] | 0;
                    xa = E;
                    ya = E
                }
                E = ya + 4 | 0;
                ya = xa + (wa << 2) | 0;
                t = c[e >> 2] | 0;
                if ((E | 0) == (ya | 0)) { za = t } else {
                    u = (xa + (wa - 1 << 2) + (-E | 0) | 0) >>> 2;
                    wa = t;
                    xa = E;
                    while (1) {
                        c[wa >> 2] = c[xa >> 2];
                        E = xa + 4 | 0;
                        if ((E | 0) == (ya | 0)) { break } else {
                            wa = wa + 4 | 0;
                            xa = E
                        }
                    }
                    za = t + (u + 1 << 2) | 0
                }
                c[e >> 2] = za
            }
            za = f & 176;
            if ((za | 0) == 32) { c[d >> 2] = c[e >> 2]; return } else if ((za | 0) == 16) { return } else { c[d >> 2] = b; return }
        }

        function Br(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0;
            d = i;
            i = i + 32 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 16 | 0;
            m = d + 24 | 0;
            n = m;
            o = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            p = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            q = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            r = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            s = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            t = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            u = i;
            i = i + 400 | 0;
            v = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            w = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            x = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            Lm(l, g);
            y = l | 0;
            z = c[y >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[k >> 2] = 34856;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34856, k, 114)
            }
            k = (c[8715] | 0) - 1 | 0;
            A = c[z + 8 >> 2] | 0;
            do {
                if ((c[z + 12 >> 2] | 0) - A >> 2 >>> 0 > k >>> 0) {
                    B = c[A + (k << 2) >> 2] | 0;
                    if ((B | 0) == 0) { break }
                    C = B;
                    D = j;
                    E = a[D] | 0;
                    F = (E & 1) == 0;
                    if (F) { G = (E & 255) >>> 1 } else { G = c[j + 4 >> 2] | 0 }
                    if ((G | 0) == 0) { H = 0 } else {
                        if (F) { I = j + 4 | 0 } else { I = c[j + 8 >> 2] | 0 }
                        F = c[I >> 2] | 0;
                        H = (F | 0) == (Qc[c[(c[B >> 2] | 0) + 44 >> 2] & 63](C, 45) | 0)
                    }
                    c[m >> 2] = 0;
                    dv(q | 0, 0, 12) | 0;
                    B = r;
                    dv(B | 0, 0, 12) | 0;
                    F = s;
                    dv(F | 0, 0, 12) | 0;
                    zr(f, H, l, n, o, p, q, r, s, t);
                    E = u | 0;
                    J = a[D] | 0;
                    K = (J & 1) == 0;
                    if (K) { L = (J & 255) >>> 1 } else { L = c[j + 4 >> 2] | 0 }
                    M = c[t >> 2] | 0;
                    if ((L | 0) > (M | 0)) {
                        if (K) { N = (J & 255) >>> 1 } else { N = c[j + 4 >> 2] | 0 }
                        K = a[F] | 0;
                        if ((K & 1) == 0) { O = (K & 255) >>> 1 } else { O = c[s + 4 >> 2] | 0 }
                        K = a[B] | 0;
                        if ((K & 1) == 0) { P = (K & 255) >>> 1 } else { P = c[r + 4 >> 2] | 0 }
                        Q = O + (N - M << 1 | 1) + P | 0
                    } else {
                        K = a[F] | 0;
                        if ((K & 1) == 0) { R = (K & 255) >>> 1 } else { R = c[s + 4 >> 2] | 0 }
                        K = a[B] | 0;
                        if ((K & 1) == 0) { S = (K & 255) >>> 1 } else { S = c[r + 4 >> 2] | 0 }
                        Q = R + 2 + S | 0
                    }
                    K = Q + M | 0;
                    do {
                        if (K >>> 0 > 100 >>> 0) {
                            B = Gu(K << 2) | 0;
                            F = B;
                            if ((B | 0) != 0) {
                                T = F;
                                U = F;
                                V = J;
                                break
                            }
                            Uu();
                            T = 0;
                            U = 0;
                            V = a[D] | 0
                        } else {
                            T = E;
                            U = 0;
                            V = J
                        }
                    } while (0);
                    if ((V & 1) == 0) {
                        W = (V & 255) >>> 1;
                        X = j + 4 | 0
                    } else {
                        W = c[j + 4 >> 2] | 0;
                        X = c[j + 8 >> 2] | 0
                    }
                    Ar(T, v, w, c[g + 4 >> 2] | 0, X, X + (W << 2) | 0, C, H, n, c[o >> 2] | 0, c[p >> 2] | 0, q, r, s, M);
                    c[x >> 2] = c[e >> 2];
                    tp(b, x, T, c[v >> 2] | 0, c[w >> 2] | 0, g, h);
                    if ((U | 0) == 0) {
                        Y = 400;
                        Z = 0;
                        Cm(s);
                        Cm(r);
                        rm(q);
                        _ = c[y >> 2] | 0;
                        $ = _ | 0;
                        aa = Ul($) | 0;
                        i = d;
                        return
                    }
                    Hu(U);
                    Y = 400;
                    Z = 0;
                    Cm(s);
                    Cm(r);
                    rm(q);
                    _ = c[y >> 2] | 0;
                    $ = _ | 0;
                    aa = Ul($) | 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function Cr(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Dr(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Er(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            if ((a[d] & 1) == 0) { f = d + 1 | 0 } else { f = c[d + 8 >> 2] | 0 }
            d = sc(f | 0, 1) | 0;
            return d >>> (((d | 0) != -1 | 0) >>> 0) | 0
        }

        function Fr(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = i;
            i = i + 16 | 0;
            j = d | 0;
            k = j;
            dv(k | 0, 0, 12) | 0;
            l = a[h] | 0;
            if ((l & 1) == 0) {
                m = (l & 255) >>> 1;
                n = h + 1 | 0;
                o = h + 1 | 0
            } else {
                l = c[h + 8 >> 2] | 0;
                m = c[h + 4 >> 2] | 0;
                n = l;
                o = l
            }
            l = o + m | 0;
            do {
                if (n >>> 0 < l >>> 0) {
                    m = n;
                    do {
                        wm(j, a[m] | 0);
                        m = m + 1 | 0;
                    } while (m >>> 0 < l >>> 0);
                    m = (e | 0) == -1 ? -1 : e << 1;
                    if ((a[k] & 1) == 0) {
                        p = m;
                        q = 10;
                        break
                    }
                    r = c[j + 8 >> 2] | 0;
                    s = m
                } else {
                    p = (e | 0) == -1 ? -1 : e << 1;
                    q = 10
                }
            } while (0);
            if ((q | 0) == 10) {
                r = j + 1 | 0;
                s = p
            }
            p = qb(s | 0, f | 0, g | 0, r | 0) | 0;
            dv(b | 0, 0, 12) | 0;
            r = ev(p | 0) | 0;
            g = p + r | 0;
            if ((r | 0) > 0) { t = p } else {
                rm(j);
                i = d;
                return
            }
            do {
                wm(b, a[t] | 0);
                t = t + 1 | 0;
            } while (t >>> 0 < g >>> 0);
            rm(j);
            i = d;
            return
        }

        function Gr(a, b) {
            a = a | 0;
            b = b | 0;
            Yb(((b | 0) == -1 ? -1 : b << 1) | 0) | 0;
            return
        }

        function Hr(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Ir(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Jr(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            if ((a[d] & 1) == 0) { f = d + 1 | 0 } else { f = c[d + 8 >> 2] | 0 }
            d = sc(f | 0, 1) | 0;
            return d >>> (((d | 0) != -1 | 0) >>> 0) | 0
        }

        function Kr(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0;
            d = i;
            i = i + 240 | 0;
            j = d | 0;
            k = d + 8 | 0;
            l = d + 40 | 0;
            m = d + 48 | 0;
            n = d + 56 | 0;
            o = d + 64 | 0;
            p = d + 192 | 0;
            q = d + 200 | 0;
            r = d + 208 | 0;
            s = d + 224 | 0;
            t = d + 232 | 0;
            u = r;
            dv(u | 0, 0, 12) | 0;
            c[s + 4 >> 2] = 0;
            c[s >> 2] = 21168;
            v = a[h] | 0;
            if ((v & 1) == 0) {
                w = (v & 255) >>> 1;
                x = h + 4 | 0;
                y = h + 4 | 0
            } else {
                v = c[h + 8 >> 2] | 0;
                w = c[h + 4 >> 2] | 0;
                x = v;
                y = v
            }
            v = y + (w << 2) | 0;
            w = k | 0;
            y = j;
            c[j >> 2] = 0;
            c[j + 4 >> 2] = 0;
            a: do {
                if (x >>> 0 < v >>> 0) {
                    j = s | 0;
                    h = s;
                    z = k + 32 | 0;
                    A = x;
                    B = 21168;
                    while (1) {
                        c[m >> 2] = A;
                        C = (Vc[c[B + 12 >> 2] & 31](j, y, A, v, m, w, z, l) | 0) == 2;
                        D = c[m >> 2] | 0;
                        if (C | (D | 0) == (A | 0)) { break }
                        if (w >>> 0 < (c[l >> 2] | 0) >>> 0) {
                            C = w;
                            do {
                                wm(r, a[C] | 0);
                                C = C + 1 | 0;
                            } while (C >>> 0 < (c[l >> 2] | 0) >>> 0);
                            E = c[m >> 2] | 0
                        } else { E = D }
                        if (!(E >>> 0 < v >>> 0)) { break a }
                        A = E;
                        B = c[h >> 2] | 0
                    }
                    dr(8296)
                }
            } while (0);
            Sl(s | 0);
            if ((a[u] & 1) == 0) { F = r + 1 | 0 } else { F = c[r + 8 >> 2] | 0 }
            u = qb(((e | 0) == -1 ? -1 : e << 1) | 0, f | 0, g | 0, F | 0) | 0;
            dv(b | 0, 0, 12) | 0;
            c[t + 4 >> 2] = 0;
            c[t >> 2] = 21112;
            F = ev(u | 0) | 0;
            g = u + F | 0;
            f = n;
            c[n >> 2] = 0;
            c[n + 4 >> 2] = 0;
            if ((F | 0) <= 0) {
                G = 8;
                H = 0;
                I = 4;
                J = 0;
                K = 4;
                L = 0;
                M = t | 0;
                Sl(M);
                rm(r);
                i = d;
                return
            }
            F = t | 0;
            n = t;
            e = g;
            s = o | 0;
            E = o + 128 | 0;
            o = u;
            u = 21112;
            while (1) {
                c[q >> 2] = o;
                v = (Vc[c[u + 16 >> 2] & 31](F, f, o, (e - o | 0) > 32 ? o + 32 | 0 : g, q, s, E, p) | 0) == 2;
                m = c[q >> 2] | 0;
                if (v | (m | 0) == (o | 0)) { break }
                if (s >>> 0 < (c[p >> 2] | 0) >>> 0) {
                    v = s;
                    do {
                        Gm(b, c[v >> 2] | 0);
                        v = v + 4 | 0;
                    } while (v >>> 0 < (c[p >> 2] | 0) >>> 0);
                    N = c[q >> 2] | 0
                } else { N = m }
                if (!(N >>> 0 < g >>> 0)) { O = 37; break }
                o = N;
                u = c[n >> 2] | 0
            }
            if ((O | 0) == 37) {
                G = 8;
                H = 0;
                I = 4;
                J = 0;
                K = 4;
                L = 0;
                M = t | 0;
                Sl(M);
                rm(r);
                i = d;
                return
            }
            dr(8296)
        }

        function Lr(a, b) {
            a = a | 0;
            b = b | 0;
            Yb(((b | 0) == -1 ? -1 : b << 1) | 0) | 0;
            return
        }

        function Mr(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0;
            c[b >> 2] = 20632;
            d = b + 8 | 0;
            e = c[d >> 2] | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    f = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = f
                }
            } while (0);
            if ((e | 0) == (c[8330] | 0)) {
                g = b | 0;
                Sl(g);
                return
            }
            pb(c[d >> 2] | 0);
            g = b | 0;
            Sl(g);
            return
        }

        function Nr(a) {
            a = a | 0;
            a = pc(8) | 0;
            Vl(a, 14768);
            c[a >> 2] = 19568;
            Fb(a | 0, 25576, 40)
        }

        function Or(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0;
            e = i;
            i = i + 448 | 0;
            f = e | 0;
            g = e + 16 | 0;
            h = e + 32 | 0;
            j = e + 48 | 0;
            k = e + 64 | 0;
            l = e + 80 | 0;
            m = e + 96 | 0;
            n = e + 112 | 0;
            o = e + 128 | 0;
            p = e + 144 | 0;
            q = e + 160 | 0;
            r = e + 176 | 0;
            s = e + 192 | 0;
            t = e + 208 | 0;
            u = e + 224 | 0;
            v = e + 240 | 0;
            w = e + 256 | 0;
            x = e + 272 | 0;
            y = e + 288 | 0;
            z = e + 304 | 0;
            A = e + 320 | 0;
            B = e + 336 | 0;
            C = e + 352 | 0;
            D = e + 368 | 0;
            E = e + 384 | 0;
            F = e + 400 | 0;
            G = e + 416 | 0;
            H = e + 432 | 0;
            c[b + 4 >> 2] = d - 1;
            c[b >> 2] = 20888;
            d = b + 8 | 0;
            I = b + 12 | 0;
            J = b + 136 | 0;
            a[J] = 1;
            K = b + 24 | 0;
            c[I >> 2] = K;
            c[d >> 2] = K;
            c[b + 16 >> 2] = J;
            J = 28;
            L = K;
            do {
                if ((L | 0) == 0) { M = 0 } else {
                    c[L >> 2] = 0;
                    M = c[I >> 2] | 0
                }
                L = M + 4 | 0;
                c[I >> 2] = L;
                J = J - 1 | 0;
            } while ((J | 0) != 0);
            pm(b + 144 | 0, 14472, 1);
            J = c[d >> 2] | 0;
            d = c[I >> 2] | 0;
            if ((d | 0) != (J | 0)) { c[I >> 2] = d + (~((d - 4 + (-J | 0) | 0) >>> 2) << 2) }
            c[8387] = 0;
            c[8386] = 20592;
            if (!((c[8636] | 0) == -1)) {
                c[G >> 2] = 34544;
                c[G + 4 >> 2] = 16;
                c[G + 8 >> 2] = 0;
                mm(34544, G, 114)
            }
            Pr(b, 33544, (c[8637] | 0) - 1 | 0);
            c[8385] = 0;
            c[8384] = 20552;
            if (!((c[8634] | 0) == -1)) {
                c[F >> 2] = 34536;
                c[F + 4 >> 2] = 16;
                c[F + 8 >> 2] = 0;
                mm(34536, F, 114)
            }
            Pr(b, 33536, (c[8635] | 0) - 1 | 0);
            c[8441] = 0;
            c[8440] = 21e3;
            c[8442] = 0;
            a[33772] = 0;
            F = ob() | 0;
            c[8442] = c[F >> 2];
            if (!((c[8716] | 0) == -1)) {
                c[E >> 2] = 34864;
                c[E + 4 >> 2] = 16;
                c[E + 8 >> 2] = 0;
                mm(34864, E, 114)
            }
            Pr(b, 33760, (c[8717] | 0) - 1 | 0);
            c[8439] = 0;
            c[8438] = 20920;
            if (!((c[8714] | 0) == -1)) {
                c[D >> 2] = 34856;
                c[D + 4 >> 2] = 16;
                c[D + 8 >> 2] = 0;
                mm(34856, D, 114)
            }
            Pr(b, 33752, (c[8715] | 0) - 1 | 0);
            c[8393] = 0;
            c[8392] = 20688;
            if (!((c[8640] | 0) == -1)) {
                c[C >> 2] = 34560;
                c[C + 4 >> 2] = 16;
                c[C + 8 >> 2] = 0;
                mm(34560, C, 114)
            }
            Pr(b, 33568, (c[8641] | 0) - 1 | 0);
            c[8389] = 0;
            c[8388] = 20632;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    C = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = C
                }
            } while (0);
            c[8390] = c[8330];
            if (!((c[8638] | 0) == -1)) {
                c[B >> 2] = 34552;
                c[B + 4 >> 2] = 16;
                c[B + 8 >> 2] = 0;
                mm(34552, B, 114)
            }
            Pr(b, 33552, (c[8639] | 0) - 1 | 0);
            c[8395] = 0;
            c[8394] = 20744;
            if (!((c[8642] | 0) == -1)) {
                c[A >> 2] = 34568;
                c[A + 4 >> 2] = 16;
                c[A + 8 >> 2] = 0;
                mm(34568, A, 114)
            }
            Pr(b, 33576, (c[8643] | 0) - 1 | 0);
            c[8397] = 0;
            c[8396] = 20800;
            if (!((c[8644] | 0) == -1)) {
                c[z >> 2] = 34576;
                c[z + 4 >> 2] = 16;
                c[z + 8 >> 2] = 0;
                mm(34576, z, 114)
            }
            Pr(b, 33584, (c[8645] | 0) - 1 | 0);
            c[8367] = 0;
            c[8366] = 20096;
            a[33472] = 46;
            a[33473] = 44;
            dv(33476, 0, 12) | 0;
            if (!((c[8620] | 0) == -1)) {
                c[y >> 2] = 34480;
                c[y + 4 >> 2] = 16;
                c[y + 8 >> 2] = 0;
                mm(34480, y, 114)
            }
            Pr(b, 33464, (c[8621] | 0) - 1 | 0);
            c[8359] = 0;
            c[8358] = 20048;
            c[8360] = 46;
            c[8361] = 44;
            dv(33448, 0, 12) | 0;
            if (!((c[8618] | 0) == -1)) {
                c[x >> 2] = 34472;
                c[x + 4 >> 2] = 16;
                c[x + 8 >> 2] = 0;
                mm(34472, x, 114)
            }
            Pr(b, 33432, (c[8619] | 0) - 1 | 0);
            c[8383] = 0;
            c[8382] = 20480;
            if (!((c[8632] | 0) == -1)) {
                c[w >> 2] = 34528;
                c[w + 4 >> 2] = 16;
                c[w + 8 >> 2] = 0;
                mm(34528, w, 114)
            }
            Pr(b, 33528, (c[8633] | 0) - 1 | 0);
            c[8381] = 0;
            c[8380] = 20408;
            if (!((c[8630] | 0) == -1)) {
                c[v >> 2] = 34520;
                c[v + 4 >> 2] = 16;
                c[v + 8 >> 2] = 0;
                mm(34520, v, 114)
            }
            Pr(b, 33520, (c[8631] | 0) - 1 | 0);
            c[8379] = 0;
            c[8378] = 20344;
            if (!((c[8628] | 0) == -1)) {
                c[u >> 2] = 34512;
                c[u + 4 >> 2] = 16;
                c[u + 8 >> 2] = 0;
                mm(34512, u, 114)
            }
            Pr(b, 33512, (c[8629] | 0) - 1 | 0);
            c[8377] = 0;
            c[8376] = 20280;
            if (!((c[8626] | 0) == -1)) {
                c[t >> 2] = 34504;
                c[t + 4 >> 2] = 16;
                c[t + 8 >> 2] = 0;
                mm(34504, t, 114)
            }
            Pr(b, 33504, (c[8627] | 0) - 1 | 0);
            c[8451] = 0;
            c[8450] = 21928;
            if (!((c[8836] | 0) == -1)) {
                c[s >> 2] = 35344;
                c[s + 4 >> 2] = 16;
                c[s + 8 >> 2] = 0;
                mm(35344, s, 114)
            }
            Pr(b, 33800, (c[8837] | 0) - 1 | 0);
            c[8449] = 0;
            c[8448] = 21864;
            if (!((c[8834] | 0) == -1)) {
                c[r >> 2] = 35336;
                c[r + 4 >> 2] = 16;
                c[r + 8 >> 2] = 0;
                mm(35336, r, 114)
            }
            Pr(b, 33792, (c[8835] | 0) - 1 | 0);
            c[8447] = 0;
            c[8446] = 21800;
            if (!((c[8832] | 0) == -1)) {
                c[q >> 2] = 35328;
                c[q + 4 >> 2] = 16;
                c[q + 8 >> 2] = 0;
                mm(35328, q, 114)
            }
            Pr(b, 33784, (c[8833] | 0) - 1 | 0);
            c[8445] = 0;
            c[8444] = 21736;
            if (!((c[8830] | 0) == -1)) {
                c[p >> 2] = 35320;
                c[p + 4 >> 2] = 16;
                c[p + 8 >> 2] = 0;
                mm(35320, p, 114)
            }
            Pr(b, 33776, (c[8831] | 0) - 1 | 0);
            c[8341] = 0;
            c[8340] = 19752;
            if (!((c[8608] | 0) == -1)) {
                c[o >> 2] = 34432;
                c[o + 4 >> 2] = 16;
                c[o + 8 >> 2] = 0;
                mm(34432, o, 114)
            }
            Pr(b, 33360, (c[8609] | 0) - 1 | 0);
            c[8339] = 0;
            c[8338] = 19712;
            if (!((c[8606] | 0) == -1)) {
                c[n >> 2] = 34424;
                c[n + 4 >> 2] = 16;
                c[n + 8 >> 2] = 0;
                mm(34424, n, 114)
            }
            Pr(b, 33352, (c[8607] | 0) - 1 | 0);
            c[8337] = 0;
            c[8336] = 19672;
            if (!((c[8604] | 0) == -1)) {
                c[m >> 2] = 34416;
                c[m + 4 >> 2] = 16;
                c[m + 8 >> 2] = 0;
                mm(34416, m, 114)
            }
            Pr(b, 33344, (c[8605] | 0) - 1 | 0);
            c[8335] = 0;
            c[8334] = 19632;
            if (!((c[8602] | 0) == -1)) {
                c[l >> 2] = 34408;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34408, l, 114)
            }
            Pr(b, 33336, (c[8603] | 0) - 1 | 0);
            c[8355] = 0;
            c[8354] = 19952;
            c[8356] = 2e4;
            if (!((c[8616] | 0) == -1)) {
                c[k >> 2] = 34464;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34464, k, 114)
            }
            Pr(b, 33416, (c[8617] | 0) - 1 | 0);
            c[8351] = 0;
            c[8350] = 19856;
            c[8352] = 19904;
            if (!((c[8614] | 0) == -1)) {
                c[j >> 2] = 34456;
                c[j + 4 >> 2] = 16;
                c[j + 8 >> 2] = 0;
                mm(34456, j, 114)
            }
            Pr(b, 33400, (c[8615] | 0) - 1 | 0);
            c[8347] = 0;
            c[8346] = 20856;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    j = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = j
                }
            } while (0);
            c[8348] = c[8330];
            c[8346] = 19824;
            if (!((c[8612] | 0) == -1)) {
                c[h >> 2] = 34448;
                c[h + 4 >> 2] = 16;
                c[h + 8 >> 2] = 0;
                mm(34448, h, 114)
            }
            Pr(b, 33384, (c[8613] | 0) - 1 | 0);
            c[8343] = 0;
            c[8342] = 20856;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    h = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = h
                }
            } while (0);
            c[8344] = c[8330];
            c[8342] = 19792;
            if (!((c[8610] | 0) == -1)) {
                c[g >> 2] = 34440;
                c[g + 4 >> 2] = 16;
                c[g + 8 >> 2] = 0;
                mm(34440, g, 114)
            }
            Pr(b, 33368, (c[8611] | 0) - 1 | 0);
            c[8375] = 0;
            c[8374] = 20184;
            if (!((c[8624] | 0) == -1)) {
                c[f >> 2] = 34496;
                c[f + 4 >> 2] = 16;
                c[f + 8 >> 2] = 0;
                mm(34496, f, 114)
            }
            Pr(b, 33496, (c[8625] | 0) - 1 | 0);
            c[8373] = 0;
            c[8372] = 20144;
            if (!((c[8622] | 0) == -1)) {
                c[H >> 2] = 34488;
                c[H + 4 >> 2] = 16;
                c[H + 8 >> 2] = 0;
                mm(34488, H, 114)
            }
            Pr(b, 33488, (c[8623] | 0) - 1 | 0);
            i = e;
            return
        }

        function Pr(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            Tl(b | 0);
            e = a + 8 | 0;
            f = a + 12 | 0;
            a = c[f >> 2] | 0;
            g = e | 0;
            h = c[g >> 2] | 0;
            i = a - h >> 2;
            do {
                if (i >>> 0 > d >>> 0) { j = h } else {
                    k = d + 1 | 0;
                    if (i >>> 0 < k >>> 0) {
                        Tt(e, k - i | 0);
                        j = c[g >> 2] | 0;
                        break
                    }
                    if (!(i >>> 0 > k >>> 0)) { j = h; break }
                    l = h + (k << 2) | 0;
                    if ((a | 0) == (l | 0)) { j = h; break }
                    c[f >> 2] = a + (~((a - 4 + (-l | 0) | 0) >>> 2) << 2);
                    j = h
                }
            } while (0);
            h = c[j + (d << 2) >> 2] | 0;
            if ((h | 0) == 0) {
                m = j;
                n = m + (d << 2) | 0;
                c[n >> 2] = b;
                return
            }
            Ul(h | 0) | 0;
            m = c[g >> 2] | 0;
            n = m + (d << 2) | 0;
            c[n >> 2] = b;
            return
        }

        function Qr(a) {
            a = a | 0;
            Rr(a);
            Pu(a);
            return
        }

        function Rr(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            c[b >> 2] = 20888;
            d = b + 12 | 0;
            e = c[d >> 2] | 0;
            f = b + 8 | 0;
            g = c[f >> 2] | 0;
            if ((e | 0) != (g | 0)) {
                h = 0;
                i = g;
                g = e;
                while (1) {
                    e = c[i + (h << 2) >> 2] | 0;
                    if ((e | 0) == 0) {
                        j = g;
                        k = i
                    } else {
                        Ul(e | 0) | 0;
                        j = c[d >> 2] | 0;
                        k = c[f >> 2] | 0
                    }
                    e = h + 1 | 0;
                    if (e >>> 0 < j - k >> 2 >>> 0) {
                        h = e;
                        i = k;
                        g = j
                    } else { break }
                }
            }
            rm(b + 144 | 0);
            j = c[f >> 2] | 0;
            if ((j | 0) == 0) {
                l = b | 0;
                Sl(l);
                return
            }
            f = c[d >> 2] | 0;
            if ((f | 0) != (j | 0)) { c[d >> 2] = f + (~((f - 4 + (-j | 0) | 0) >>> 2) << 2) }
            if ((b + 24 | 0) == (j | 0)) {
                a[b + 136 | 0] = 0;
                l = b | 0;
                Sl(l);
                return
            } else {
                Pu(j);
                l = b | 0;
                Sl(l);
                return
            }
        }

        function Sr() {
            var b = 0,
                d = 0;
            if ((a[51792] | 0) != 0) { b = c[8322] | 0; return b | 0 }
            if ((ub(51792) | 0) == 0) { b = c[8322] | 0; return b | 0 }
            do {
                if ((a[51800] | 0) == 0) {
                    if ((ub(51800) | 0) == 0) { break }
                    Or(33592, 1);
                    c[8326] = 33592;
                    c[8324] = 33304
                }
            } while (0);
            d = c[c[8324] >> 2] | 0;
            c[8328] = d;
            Tl(d | 0);
            c[8322] = 33312;
            b = c[8322] | 0;
            return b | 0
        }

        function Tr(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = Sr() | 0;
            d = c[b >> 2] | 0;
            c[a >> 2] = d;
            Tl(d | 0);
            return
        }

        function Ur(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[b >> 2] | 0;
            c[a >> 2] = d;
            Tl(d | 0);
            return
        }

        function Vr(a) {
            a = a | 0;
            Ul(c[a >> 2] | 0) | 0;
            return
        }

        function Wr(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0;
            d = i;
            i = i + 16 | 0;
            e = d | 0;
            f = c[a >> 2] | 0;
            a = b | 0;
            if (!((c[a >> 2] | 0) == -1)) {
                c[e >> 2] = b;
                c[e + 4 >> 2] = 16;
                c[e + 8 >> 2] = 0;
                mm(a, e, 114)
            }
            e = (c[b + 4 >> 2] | 0) - 1 | 0;
            b = c[f + 8 >> 2] | 0;
            if (!((c[f + 12 >> 2] | 0) - b >> 2 >>> 0 > e >>> 0)) {
                g = pc(4) | 0;
                h = g;
                lu(h);
                Fb(g | 0, 25544, 156);
                return 0
            }
            f = c[b + (e << 2) >> 2] | 0;
            if ((f | 0) == 0) {
                g = pc(4) | 0;
                h = g;
                lu(h);
                Fb(g | 0, 25544, 156);
                return 0
            } else { i = d; return f | 0 }
            return 0
        }

        function Xr(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Yr(a) {
            a = a | 0;
            if ((a | 0) == 0) { return }
            Dc[c[(c[a >> 2] | 0) + 4 >> 2] & 511](a);
            return
        }

        function Zr(a) {
            a = a | 0;
            c[a + 4 >> 2] = (I = c[8646] | 0, c[8646] = I + 1, I) + 1;
            return
        }

        function _r(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function $r(a, d, e) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            if (!(e >>> 0 < 128 >>> 0)) { f = 0; return f | 0 }
            a = ob() | 0;
            f = (b[(c[a >> 2] | 0) + (e << 1) >> 1] & d) << 16 >> 16 != 0;
            return f | 0
        }

        function as(a, d, e, f) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0;
            if ((d | 0) == (e | 0)) { g = d; return g | 0 } else {
                h = d;
                i = f
            }
            while (1) {
                f = c[h >> 2] | 0;
                if (f >>> 0 < 128 >>> 0) {
                    d = ob() | 0;
                    j = b[(c[d >> 2] | 0) + (f << 1) >> 1] | 0
                } else { j = 0 }
                b[i >> 1] = j;
                f = h + 4 | 0;
                if ((f | 0) == (e | 0)) { g = e; break } else {
                    h = f;
                    i = i + 2 | 0
                }
            }
            return g | 0
        }

        function bs(a, d, e, f) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0;
            if ((e | 0) == (f | 0)) { g = e; return g | 0 } else { h = e }
            while (1) {
                e = c[h >> 2] | 0;
                if (e >>> 0 < 128 >>> 0) {
                    a = ob() | 0;
                    if (!((b[(c[a >> 2] | 0) + (e << 1) >> 1] & d) << 16 >> 16 == 0)) {
                        g = h;
                        i = 7;
                        break
                    }
                }
                e = h + 4 | 0;
                if ((e | 0) == (f | 0)) {
                    g = f;
                    i = 7;
                    break
                } else { h = e }
            }
            if ((i | 0) == 7) { return g | 0 }
            return 0
        }

        function cs(a, d, e, f) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0;
            a: do {
                if ((e | 0) == (f | 0)) { g = e } else {
                    a = e;
                    while (1) {
                        h = c[a >> 2] | 0;
                        if (!(h >>> 0 < 128 >>> 0)) { g = a; break a }
                        i = ob() | 0;
                        j = a + 4 | 0;
                        if ((b[(c[i >> 2] | 0) + (h << 1) >> 1] & d) << 16 >> 16 == 0) { g = a; break a }
                        if ((j | 0) == (f | 0)) { g = f; break } else { a = j }
                    }
                }
            } while (0);
            return g | 0
        }

        function ds(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if (!(b >>> 0 < 128 >>> 0)) { d = b; return d | 0 }
            a = tc() | 0;
            d = c[(c[a >> 2] | 0) + (b << 2) >> 2] | 0;
            return d | 0
        }

        function es(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            if ((b | 0) == (d | 0)) { e = b; return e | 0 } else { f = b }
            while (1) {
                b = c[f >> 2] | 0;
                if (b >>> 0 < 128 >>> 0) {
                    a = tc() | 0;
                    g = c[(c[a >> 2] | 0) + (b << 2) >> 2] | 0
                } else { g = b }
                c[f >> 2] = g;
                b = f + 4 | 0;
                if ((b | 0) == (d | 0)) { e = d; break } else { f = b }
            }
            return e | 0
        }

        function fs(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if (!(b >>> 0 < 128 >>> 0)) { d = b; return d | 0 }
            a = uc() | 0;
            d = c[(c[a >> 2] | 0) + (b << 2) >> 2] | 0;
            return d | 0
        }

        function gs(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            if ((b | 0) == (d | 0)) { e = b; return e | 0 } else { f = b }
            while (1) {
                b = c[f >> 2] | 0;
                if (b >>> 0 < 128 >>> 0) {
                    a = uc() | 0;
                    g = c[(c[a >> 2] | 0) + (b << 2) >> 2] | 0
                } else { g = b }
                c[f >> 2] = g;
                b = f + 4 | 0;
                if ((b | 0) == (d | 0)) { e = d; break } else { f = b }
            }
            return e | 0
        }

        function hs(a, b) {
            a = a | 0;
            b = b | 0;
            return b << 24 >> 24 | 0
        }

        function is(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0;
            if ((d | 0) == (e | 0)) { g = d; return g | 0 } else {
                h = d;
                i = f
            }
            while (1) {
                c[i >> 2] = a[h] | 0;
                f = h + 1 | 0;
                if ((f | 0) == (e | 0)) { g = e; break } else {
                    h = f;
                    i = i + 4 | 0
                }
            }
            return g | 0
        }

        function js(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            return (b >>> 0 < 128 >>> 0 ? b & 255 : c) | 0
        }

        function ks(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0;
            if ((d | 0) == (e | 0)) { h = d; return h | 0 }
            b = ((e - 4 + (-d | 0) | 0) >>> 2) + 1 | 0;
            i = d;
            j = g;
            while (1) {
                g = c[i >> 2] | 0;
                a[j] = g >>> 0 < 128 >>> 0 ? g & 255 : f;
                g = i + 4 | 0;
                if ((g | 0) == (e | 0)) { break } else {
                    i = g;
                    j = j + 1 | 0
                }
            }
            h = d + (b << 2) | 0;
            return h | 0
        }

        function ls(b) {
            b = b | 0;
            var d = 0;
            c[b >> 2] = 21e3;
            d = c[b + 8 >> 2] | 0;
            do {
                if ((d | 0) != 0) {
                    if ((a[b + 12 | 0] | 0) == 0) { break }
                    Qu(d)
                }
            } while (0);
            Sl(b | 0);
            Pu(b);
            return
        }

        function ms(b) {
            b = b | 0;
            var d = 0;
            c[b >> 2] = 21e3;
            d = c[b + 8 >> 2] | 0;
            do {
                if ((d | 0) != 0) {
                    if ((a[b + 12 | 0] | 0) == 0) { break }
                    Qu(d)
                }
            } while (0);
            Sl(b | 0);
            return
        }

        function ns(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if (!(b << 24 >> 24 > -1)) { d = b; return d | 0 }
            a = tc() | 0;
            d = c[(c[a >> 2] | 0) + ((b & 255) << 2) >> 2] & 255;
            return d | 0
        }

        function os(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0;
            if ((d | 0) == (e | 0)) { f = d; return f | 0 } else { g = d }
            while (1) {
                d = a[g] | 0;
                if (d << 24 >> 24 > -1) {
                    b = tc() | 0;
                    h = c[(c[b >> 2] | 0) + (d << 24 >> 24 << 2) >> 2] & 255
                } else { h = d }
                a[g] = h;
                d = g + 1 | 0;
                if ((d | 0) == (e | 0)) { f = e; break } else { g = d }
            }
            return f | 0
        }

        function ps(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if (!(b << 24 >> 24 > -1)) { d = b; return d | 0 }
            a = uc() | 0;
            d = c[(c[a >> 2] | 0) + (b << 24 >> 24 << 2) >> 2] & 255;
            return d | 0
        }

        function qs(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0;
            if ((d | 0) == (e | 0)) { f = d; return f | 0 } else { g = d }
            while (1) {
                d = a[g] | 0;
                if (d << 24 >> 24 > -1) {
                    b = uc() | 0;
                    h = c[(c[b >> 2] | 0) + (d << 24 >> 24 << 2) >> 2] & 255
                } else { h = d }
                a[g] = h;
                d = g + 1 | 0;
                if ((d | 0) == (e | 0)) { f = e; break } else { g = d }
            }
            return f | 0
        }

        function rs(a, b) {
            a = a | 0;
            b = b | 0;
            return b | 0
        }

        function ss(b, c, d, e) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0;
            if ((c | 0) == (d | 0)) { f = c; return f | 0 } else {
                g = c;
                h = e
            }
            while (1) {
                a[h] = a[g] | 0;
                e = g + 1 | 0;
                if ((e | 0) == (d | 0)) { f = d; break } else {
                    g = e;
                    h = h + 1 | 0
                }
            }
            return f | 0
        }

        function ts(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            return (b << 24 >> 24 > -1 ? b : c) | 0
        }

        function us(b, c, d, e, f) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0;
            if ((c | 0) == (d | 0)) { g = c; return g | 0 } else {
                h = c;
                i = f
            }
            while (1) {
                f = a[h] | 0;
                a[i] = f << 24 >> 24 > -1 ? f : e;
                f = h + 1 | 0;
                if ((f | 0) == (d | 0)) { g = d; break } else {
                    h = f;
                    i = i + 1 | 0
                }
            }
            return g | 0
        }

        function vs(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function ws(a, b, d, e, f, g, h, i) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            c[f >> 2] = d;
            c[i >> 2] = g;
            return 3
        }

        function xs(a, b, d, e, f, g, h, i) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            c[f >> 2] = d;
            c[i >> 2] = g;
            return 3
        }

        function ys(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            c[f >> 2] = d;
            return 3
        }

        function zs(a) { a = a | 0; return 1 }

        function As(a) { a = a | 0; return 1 }

        function Bs(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            b = d - c | 0;
            return (b >>> 0 < e >>> 0 ? b : e) | 0
        }

        function Cs(a) { a = a | 0; return 1 }

        function Ds(a) {
            a = a | 0;
            Mr(a);
            Pu(a);
            return
        }

        function Es(b, d, e, f, g, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0;
            l = i;
            i = i + 8 | 0;
            m = l | 0;
            n = m;
            o = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            p = (e | 0) == (f | 0);
            a: do {
                if (p) {
                    c[k >> 2] = h;
                    c[g >> 2] = e;
                    q = e
                } else {
                    r = e;
                    while (1) { s = r + 4 | 0; if ((c[r >> 2] | 0) == 0) { t = r; break } if ((s | 0) == (f | 0)) { t = f; break } else { r = s } }
                    c[k >> 2] = h;
                    c[g >> 2] = e;
                    if (p | (h | 0) == (j | 0)) { q = e; break }
                    r = d;
                    s = j;
                    u = b + 8 | 0;
                    v = o | 0;
                    w = h;
                    x = e;
                    y = t;
                    while (1) {
                        z = c[r + 4 >> 2] | 0;
                        c[m >> 2] = c[r >> 2];
                        c[m + 4 >> 2] = z;
                        z = bc(c[u >> 2] | 0) | 0;
                        A = eu(w, g, y - x >> 2, s - w | 0, d) | 0;
                        if ((z | 0) != 0) { bc(z | 0) | 0 }
                        if ((A | 0) == (-1 | 0)) { B = 16; break } else if ((A | 0) == 0) {
                            C = 1;
                            B = 51;
                            break
                        }
                        z = (c[k >> 2] | 0) + A | 0;
                        c[k >> 2] = z;
                        if ((z | 0) == (j | 0)) { B = 49; break }
                        if ((y | 0) == (f | 0)) {
                            D = f;
                            E = z;
                            F = c[g >> 2] | 0
                        } else {
                            z = bc(c[u >> 2] | 0) | 0;
                            A = du(v, 0, d) | 0;
                            if ((z | 0) != 0) { bc(z | 0) | 0 }
                            if ((A | 0) == -1) {
                                C = 2;
                                B = 51;
                                break
                            }
                            z = c[k >> 2] | 0;
                            if (A >>> 0 > (s - z | 0) >>> 0) {
                                C = 1;
                                B = 51;
                                break
                            }
                            b: do {
                                if ((A | 0) != 0) {
                                    G = A;
                                    H = v;
                                    I = z;
                                    while (1) {
                                        J = a[H] | 0;
                                        c[k >> 2] = I + 1;
                                        a[I] = J;
                                        J = G - 1 | 0;
                                        if ((J | 0) == 0) { break b }
                                        G = J;
                                        H = H + 1 | 0;
                                        I = c[k >> 2] | 0
                                    }
                                }
                            } while (0);
                            z = (c[g >> 2] | 0) + 4 | 0;
                            c[g >> 2] = z;
                            c: do { if ((z | 0) == (f | 0)) { K = f } else { A = z; while (1) { I = A + 4 | 0; if ((c[A >> 2] | 0) == 0) { K = A; break c } if ((I | 0) == (f | 0)) { K = f; break } else { A = I } } } } while (0);
                            D = K;
                            E = c[k >> 2] | 0;
                            F = z
                        }
                        if ((F | 0) == (f | 0) | (E | 0) == (j | 0)) { q = F; break a } else {
                            w = E;
                            x = F;
                            y = D
                        }
                    }
                    if ((B | 0) == 16) {
                        c[k >> 2] = w;
                        d: do {
                            if ((x | 0) == (c[g >> 2] | 0)) { L = x } else {
                                y = x;
                                v = w;
                                while (1) {
                                    s = c[y >> 2] | 0;
                                    r = bc(c[u >> 2] | 0) | 0;
                                    A = du(v, s, n) | 0;
                                    if ((r | 0) != 0) { bc(r | 0) | 0 }
                                    if ((A | 0) == -1) { L = y; break d }
                                    r = (c[k >> 2] | 0) + A | 0;
                                    c[k >> 2] = r;
                                    A = y + 4 | 0;
                                    if ((A | 0) == (c[g >> 2] | 0)) { L = A; break } else {
                                        y = A;
                                        v = r
                                    }
                                }
                            }
                        } while (0);
                        c[g >> 2] = L;
                        C = 2;
                        i = l;
                        return C | 0
                    } else if ((B | 0) == 49) { q = c[g >> 2] | 0; break } else if ((B | 0) == 51) { i = l; return C | 0 }
                }
            } while (0);
            C = (q | 0) != (f | 0) | 0;
            i = l;
            return C | 0
        }

        function Fs(b, d, e, f, g, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            l = i;
            i = i + 8 | 0;
            m = l | 0;
            n = m;
            o = (e | 0) == (f | 0);
            a: do {
                if (o) {
                    c[k >> 2] = h;
                    c[g >> 2] = e;
                    p = e
                } else {
                    q = e;
                    while (1) { r = q + 1 | 0; if ((a[q] | 0) == 0) { s = q; break } if ((r | 0) == (f | 0)) { s = f; break } else { q = r } }
                    c[k >> 2] = h;
                    c[g >> 2] = e;
                    if (o | (h | 0) == (j | 0)) { p = e; break }
                    q = d;
                    r = j;
                    t = b + 8 | 0;
                    u = h;
                    v = e;
                    w = s;
                    while (1) {
                        x = c[q + 4 >> 2] | 0;
                        c[m >> 2] = c[q >> 2];
                        c[m + 4 >> 2] = x;
                        y = w;
                        x = bc(c[t >> 2] | 0) | 0;
                        z = au(u, g, y - v | 0, r - u >> 2, d) | 0;
                        if ((x | 0) != 0) { bc(x | 0) | 0 }
                        if ((z | 0) == (-1 | 0)) { A = 16; break } else if ((z | 0) == 0) {
                            B = 2;
                            A = 50;
                            break
                        }
                        x = (c[k >> 2] | 0) + (z << 2) | 0;
                        c[k >> 2] = x;
                        if ((x | 0) == (j | 0)) { A = 48; break }
                        z = c[g >> 2] | 0;
                        if ((w | 0) == (f | 0)) {
                            C = f;
                            D = x;
                            E = z
                        } else {
                            F = bc(c[t >> 2] | 0) | 0;
                            G = $t(x, z, 1, d) | 0;
                            if ((F | 0) != 0) { bc(F | 0) | 0 }
                            if ((G | 0) != 0) {
                                B = 2;
                                A = 50;
                                break
                            }
                            c[k >> 2] = (c[k >> 2] | 0) + 4;
                            G = (c[g >> 2] | 0) + 1 | 0;
                            c[g >> 2] = G;
                            b: do { if ((G | 0) == (f | 0)) { H = f } else { F = G; while (1) { z = F + 1 | 0; if ((a[F] | 0) == 0) { H = F; break b } if ((z | 0) == (f | 0)) { H = f; break } else { F = z } } } } while (0);
                            C = H;
                            D = c[k >> 2] | 0;
                            E = G
                        }
                        if ((E | 0) == (f | 0) | (D | 0) == (j | 0)) { p = E; break a } else {
                            u = D;
                            v = E;
                            w = C
                        }
                    }
                    if ((A | 0) == 16) {
                        c[k >> 2] = u;
                        c: do {
                            if ((v | 0) == (c[g >> 2] | 0)) { I = v } else {
                                w = u;
                                r = v;
                                while (1) {
                                    q = bc(c[t >> 2] | 0) | 0;
                                    F = $t(w, r, y - r | 0, n) | 0;
                                    if ((q | 0) != 0) { bc(q | 0) | 0 }
                                    if ((F | 0) == 0) { J = r + 1 | 0 } else if ((F | 0) == (-1 | 0)) { A = 27; break } else if ((F | 0) == (-2 | 0)) { A = 28; break } else { J = r + F | 0 }
                                    F = (c[k >> 2] | 0) + 4 | 0;
                                    c[k >> 2] = F;
                                    if ((J | 0) == (c[g >> 2] | 0)) { I = J; break c } else {
                                        w = F;
                                        r = J
                                    }
                                }
                                if ((A | 0) == 27) {
                                    c[g >> 2] = r;
                                    B = 2;
                                    i = l;
                                    return B | 0
                                } else if ((A | 0) == 28) {
                                    c[g >> 2] = r;
                                    B = 1;
                                    i = l;
                                    return B | 0
                                }
                            }
                        } while (0);
                        c[g >> 2] = I;
                        B = (I | 0) != (f | 0) | 0;
                        i = l;
                        return B | 0
                    } else if ((A | 0) == 48) { p = c[g >> 2] | 0; break } else if ((A | 0) == 50) { i = l; return B | 0 }
                }
            } while (0);
            B = (p | 0) != (f | 0) | 0;
            i = l;
            return B | 0
        }

        function Gs(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            h = i;
            i = i + 8 | 0;
            c[g >> 2] = e;
            e = h | 0;
            j = bc(c[b + 8 >> 2] | 0) | 0;
            b = du(e, 0, d) | 0;
            if ((j | 0) != 0) { bc(j | 0) | 0 }
            if ((b | 0) == (-1 | 0) | (b | 0) == 0) {
                k = 2;
                i = h;
                return k | 0
            }
            j = b - 1 | 0;
            b = c[g >> 2] | 0;
            if (j >>> 0 > (f - b | 0) >>> 0) {
                k = 1;
                i = h;
                return k | 0
            }
            if ((j | 0) == 0) {
                k = 0;
                i = h;
                return k | 0
            } else {
                l = j;
                m = e;
                n = b
            }
            while (1) {
                b = a[m] | 0;
                c[g >> 2] = n + 1;
                a[n] = b;
                b = l - 1 | 0;
                if ((b | 0) == 0) { k = 0; break }
                l = b;
                m = m + 1 | 0;
                n = c[g >> 2] | 0
            }
            i = h;
            return k | 0
        }

        function Hs(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            b = a + 8 | 0;
            a = bc(c[b >> 2] | 0) | 0;
            d = cu(0, 0, 4) | 0;
            if ((a | 0) != 0) { bc(a | 0) | 0 }
            if ((d | 0) != 0) { e = -1; return e | 0 }
            d = c[b >> 2] | 0;
            if ((d | 0) == 0) { e = 1; return e | 0 }
            b = bc(d | 0) | 0;
            if ((b | 0) == 0) { e = 0; return e | 0 }
            bc(b | 0) | 0;
            e = 0;
            return e | 0
        }

        function Is(a) { a = a | 0; return 0 }

        function Js(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            if ((f | 0) == 0 | (d | 0) == (e | 0)) { g = 0; return g | 0 }
            h = e;
            i = a + 8 | 0;
            a = d;
            d = 0;
            j = 0;
            while (1) {
                k = bc(c[i >> 2] | 0) | 0;
                l = _t(a, h - a | 0, b) | 0;
                if ((k | 0) != 0) { bc(k | 0) | 0 }
                if ((l | 0) == (-1 | 0) | (l | 0) == (-2 | 0)) {
                    g = d;
                    m = 15;
                    break
                } else if ((l | 0) == 0) {
                    n = 1;
                    o = a + 1 | 0
                } else {
                    n = l;
                    o = a + l | 0
                }
                l = n + d | 0;
                k = j + 1 | 0;
                if (k >>> 0 >= f >>> 0 | (o | 0) == (e | 0)) {
                    g = l;
                    m = 15;
                    break
                } else {
                    a = o;
                    d = l;
                    j = k
                }
            }
            if ((m | 0) == 15) { return g | 0 }
            return 0
        }

        function Ks(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = c[a + 8 >> 2] | 0;
            do {
                if ((b | 0) == 0) { d = 1 } else {
                    a = bc(b | 0) | 0;
                    if ((a | 0) == 0) { d = 4; break }
                    bc(a | 0) | 0;
                    d = 4
                }
            } while (0);
            return d | 0
        }

        function Ls(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Ms(a, b, d, e, f, g, h, j) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0;
            b = i;
            i = i + 16 | 0;
            a = b | 0;
            k = b + 8 | 0;
            c[a >> 2] = d;
            c[k >> 2] = g;
            l = Ns(d, e, a, g, h, k, 1114111, 0) | 0;
            c[f >> 2] = d + ((c[a >> 2] | 0) - d >> 1 << 1);
            c[j >> 2] = g + ((c[k >> 2] | 0) - g);
            i = b;
            return l | 0
        }

        function Ns(d, f, g, h, i, j, k, l) {
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            c[g >> 2] = d;
            c[j >> 2] = h;
            do {
                if ((l & 2 | 0) != 0) {
                    if ((i - h | 0) < 3) { m = 1; return m | 0 } else {
                        c[j >> 2] = h + 1;
                        a[h] = -17;
                        d = c[j >> 2] | 0;
                        c[j >> 2] = d + 1;
                        a[d] = -69;
                        d = c[j >> 2] | 0;
                        c[j >> 2] = d + 1;
                        a[d] = -65;
                        break
                    }
                }
            } while (0);
            h = f;
            l = c[g >> 2] | 0;
            if (!(l >>> 0 < f >>> 0)) { m = 0; return m | 0 }
            d = i;
            i = l;
            a: while (1) {
                l = b[i >> 1] | 0;
                n = l & 65535;
                if (n >>> 0 > k >>> 0) {
                    m = 2;
                    o = 26;
                    break
                }
                do {
                    if ((l & 65535) >>> 0 < 128 >>> 0) {
                        p = c[j >> 2] | 0;
                        if ((d - p | 0) < 1) {
                            m = 1;
                            o = 26;
                            break a
                        }
                        c[j >> 2] = p + 1;
                        a[p] = l
                    } else {
                        if ((l & 65535) >>> 0 < 2048 >>> 0) {
                            p = c[j >> 2] | 0;
                            if ((d - p | 0) < 2) {
                                m = 1;
                                o = 26;
                                break a
                            }
                            c[j >> 2] = p + 1;
                            a[p] = n >>> 6 | 192;
                            p = c[j >> 2] | 0;
                            c[j >> 2] = p + 1;
                            a[p] = n & 63 | 128;
                            break
                        }
                        if ((l & 65535) >>> 0 < 55296 >>> 0) {
                            p = c[j >> 2] | 0;
                            if ((d - p | 0) < 3) {
                                m = 1;
                                o = 26;
                                break a
                            }
                            c[j >> 2] = p + 1;
                            a[p] = n >>> 12 | 224;
                            p = c[j >> 2] | 0;
                            c[j >> 2] = p + 1;
                            a[p] = n >>> 6 & 63 | 128;
                            p = c[j >> 2] | 0;
                            c[j >> 2] = p + 1;
                            a[p] = n & 63 | 128;
                            break
                        }
                        if (!((l & 65535) >>> 0 < 56320 >>> 0)) {
                            if ((l & 65535) >>> 0 < 57344 >>> 0) {
                                m = 2;
                                o = 26;
                                break a
                            }
                            p = c[j >> 2] | 0;
                            if ((d - p | 0) < 3) {
                                m = 1;
                                o = 26;
                                break a
                            }
                            c[j >> 2] = p + 1;
                            a[p] = n >>> 12 | 224;
                            p = c[j >> 2] | 0;
                            c[j >> 2] = p + 1;
                            a[p] = n >>> 6 & 63 | 128;
                            p = c[j >> 2] | 0;
                            c[j >> 2] = p + 1;
                            a[p] = n & 63 | 128;
                            break
                        }
                        if ((h - i | 0) < 4) {
                            m = 1;
                            o = 26;
                            break a
                        }
                        p = i + 2 | 0;
                        q = e[p >> 1] | 0;
                        if ((q & 64512 | 0) != 56320) {
                            m = 2;
                            o = 26;
                            break a
                        }
                        if ((d - (c[j >> 2] | 0) | 0) < 4) {
                            m = 1;
                            o = 26;
                            break a
                        }
                        r = n & 960;
                        if (((r << 10) + 65536 | n << 10 & 64512 | q & 1023) >>> 0 > k >>> 0) {
                            m = 2;
                            o = 26;
                            break a
                        }
                        c[g >> 2] = p;
                        p = (r >>> 6) + 1 | 0;
                        r = c[j >> 2] | 0;
                        c[j >> 2] = r + 1;
                        a[r] = p >>> 2 | 240;
                        r = c[j >> 2] | 0;
                        c[j >> 2] = r + 1;
                        a[r] = n >>> 2 & 15 | p << 4 & 48 | 128;
                        p = c[j >> 2] | 0;
                        c[j >> 2] = p + 1;
                        a[p] = n << 4 & 48 | q >>> 6 & 15 | 128;
                        p = c[j >> 2] | 0;
                        c[j >> 2] = p + 1;
                        a[p] = q & 63 | 128
                    }
                } while (0);
                n = (c[g >> 2] | 0) + 2 | 0;
                c[g >> 2] = n;
                if (n >>> 0 < f >>> 0) { i = n } else {
                    m = 0;
                    o = 26;
                    break
                }
            }
            if ((o | 0) == 26) { return m | 0 }
            return 0
        }

        function Os(a, b, d, e, f, g, h, j) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0;
            b = i;
            i = i + 16 | 0;
            a = b | 0;
            k = b + 8 | 0;
            c[a >> 2] = d;
            c[k >> 2] = g;
            l = Ps(d, e, a, g, h, k, 1114111, 0) | 0;
            c[f >> 2] = d + ((c[a >> 2] | 0) - d);
            c[j >> 2] = g + ((c[k >> 2] | 0) - g >> 1 << 1);
            i = b;
            return l | 0
        }

        function Ps(e, f, g, h, i, j, k, l) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            c[g >> 2] = e;
            c[j >> 2] = h;
            h = c[g >> 2] | 0;
            do {
                if ((l & 4 | 0) == 0) { m = h } else {
                    if ((f - h | 0) <= 2) { m = h; break }
                    if (!((a[h] | 0) == -17)) { m = h; break }
                    if (!((a[h + 1 | 0] | 0) == -69)) { m = h; break }
                    if (!((a[h + 2 | 0] | 0) == -65)) { m = h; break }
                    e = h + 3 | 0;
                    c[g >> 2] = e;
                    m = e
                }
            } while (0);
            a: do {
                if (m >>> 0 < f >>> 0) {
                    h = f;
                    l = i;
                    e = c[j >> 2] | 0;
                    n = m;
                    b: while (1) {
                        if (!(e >>> 0 < i >>> 0)) { o = n; break a }
                        p = a[n] | 0;
                        q = p & 255;
                        if (q >>> 0 > k >>> 0) {
                            r = 2;
                            s = 41;
                            break
                        }
                        do {
                            if (p << 24 >> 24 > -1) {
                                b[e >> 1] = p & 255;
                                c[g >> 2] = n + 1
                            } else {
                                if ((p & 255) >>> 0 < 194 >>> 0) {
                                    r = 2;
                                    s = 41;
                                    break b
                                }
                                if ((p & 255) >>> 0 < 224 >>> 0) {
                                    if ((h - n | 0) < 2) {
                                        r = 1;
                                        s = 41;
                                        break b
                                    }
                                    t = d[n + 1 | 0] | 0;
                                    if ((t & 192 | 0) != 128) {
                                        r = 2;
                                        s = 41;
                                        break b
                                    }
                                    u = t & 63 | q << 6 & 1984;
                                    if (u >>> 0 > k >>> 0) {
                                        r = 2;
                                        s = 41;
                                        break b
                                    }
                                    b[e >> 1] = u;
                                    c[g >> 2] = n + 2;
                                    break
                                }
                                if ((p & 255) >>> 0 < 240 >>> 0) {
                                    if ((h - n | 0) < 3) {
                                        r = 1;
                                        s = 41;
                                        break b
                                    }
                                    u = a[n + 1 | 0] | 0;
                                    t = a[n + 2 | 0] | 0;
                                    if ((q | 0) == 224) {
                                        if (!((u & -32) << 24 >> 24 == -96)) {
                                            r = 2;
                                            s = 41;
                                            break b
                                        }
                                    } else if ((q | 0) == 237) {
                                        if (!((u & -32) << 24 >> 24 == -128)) {
                                            r = 2;
                                            s = 41;
                                            break b
                                        }
                                    } else {
                                        if (!((u & -64) << 24 >> 24 == -128)) {
                                            r = 2;
                                            s = 41;
                                            break b
                                        }
                                    }
                                    v = t & 255;
                                    if ((v & 192 | 0) != 128) {
                                        r = 2;
                                        s = 41;
                                        break b
                                    }
                                    t = (u & 255) << 6 & 4032 | q << 12 | v & 63;
                                    if ((t & 65535) >>> 0 > k >>> 0) {
                                        r = 2;
                                        s = 41;
                                        break b
                                    }
                                    b[e >> 1] = t;
                                    c[g >> 2] = n + 3;
                                    break
                                }
                                if (!((p & 255) >>> 0 < 245 >>> 0)) {
                                    r = 2;
                                    s = 41;
                                    break b
                                }
                                if ((h - n | 0) < 4) {
                                    r = 1;
                                    s = 41;
                                    break b
                                }
                                t = a[n + 1 | 0] | 0;
                                v = a[n + 2 | 0] | 0;
                                u = a[n + 3 | 0] | 0;
                                if ((q | 0) == 240) {
                                    if (!((t + 112 & 255) >>> 0 < 48 >>> 0)) {
                                        r = 2;
                                        s = 41;
                                        break b
                                    }
                                } else if ((q | 0) == 244) {
                                    if (!((t & -16) << 24 >> 24 == -128)) {
                                        r = 2;
                                        s = 41;
                                        break b
                                    }
                                } else {
                                    if (!((t & -64) << 24 >> 24 == -128)) {
                                        r = 2;
                                        s = 41;
                                        break b
                                    }
                                }
                                w = v & 255;
                                if ((w & 192 | 0) != 128) {
                                    r = 2;
                                    s = 41;
                                    break b
                                }
                                v = u & 255;
                                if ((v & 192 | 0) != 128) {
                                    r = 2;
                                    s = 41;
                                    break b
                                }
                                if ((l - e | 0) < 4) {
                                    r = 1;
                                    s = 41;
                                    break b
                                }
                                u = q & 7;
                                x = t & 255;
                                t = w << 6;
                                y = v & 63;
                                if ((x << 12 & 258048 | u << 18 | t & 4032 | y) >>> 0 > k >>> 0) {
                                    r = 2;
                                    s = 41;
                                    break b
                                }
                                b[e >> 1] = x << 2 & 60 | w >>> 4 & 3 | ((x >>> 4 & 3 | u << 2) << 6) + 16320 | 55296;
                                u = e + 2 | 0;
                                c[j >> 2] = u;
                                b[u >> 1] = y | t & 960 | 56320;
                                c[g >> 2] = (c[g >> 2] | 0) + 4
                            }
                        } while (0);
                        q = (c[j >> 2] | 0) + 2 | 0;
                        c[j >> 2] = q;
                        p = c[g >> 2] | 0;
                        if (p >>> 0 < f >>> 0) {
                            e = q;
                            n = p
                        } else { o = p; break a }
                    }
                    if ((s | 0) == 41) { return r | 0 }
                } else { o = m }
            } while (0);
            r = o >>> 0 < f >>> 0 | 0;
            return r | 0
        }

        function Qs(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            c[f >> 2] = d;
            return 3
        }

        function Rs(a) { a = a | 0; return 0 }

        function Ss(a) { a = a | 0; return 0 }

        function Ts(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            return Us(c, d, e, 1114111, 0) | 0
        }

        function Us(b, c, e, f, g) {
            b = b | 0;
            c = c | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            do {
                if ((g & 4 | 0) == 0) { h = b } else {
                    if ((c - b | 0) <= 2) { h = b; break }
                    if (!((a[b] | 0) == -17)) { h = b; break }
                    if (!((a[b + 1 | 0] | 0) == -69)) { h = b; break }
                    h = (a[b + 2 | 0] | 0) == -65 ? b + 3 | 0 : b
                }
            } while (0);
            a: do {
                if (h >>> 0 < c >>> 0 & (e | 0) != 0) {
                    g = c;
                    i = 0;
                    j = h;
                    b: while (1) {
                        k = a[j] | 0;
                        l = k & 255;
                        if (l >>> 0 > f >>> 0) { m = j; break a }
                        do {
                            if (k << 24 >> 24 > -1) {
                                n = j + 1 | 0;
                                o = i
                            } else {
                                if ((k & 255) >>> 0 < 194 >>> 0) { m = j; break a }
                                if ((k & 255) >>> 0 < 224 >>> 0) {
                                    if ((g - j | 0) < 2) { m = j; break a }
                                    p = d[j + 1 | 0] | 0;
                                    if ((p & 192 | 0) != 128) { m = j; break a }
                                    if ((p & 63 | l << 6 & 1984) >>> 0 > f >>> 0) { m = j; break a }
                                    n = j + 2 | 0;
                                    o = i;
                                    break
                                }
                                if ((k & 255) >>> 0 < 240 >>> 0) {
                                    q = j;
                                    if ((g - q | 0) < 3) { m = j; break a }
                                    p = a[j + 1 | 0] | 0;
                                    r = a[j + 2 | 0] | 0;
                                    if ((l | 0) == 224) { if (!((p & -32) << 24 >> 24 == -96)) { s = 21; break b } } else if ((l | 0) == 237) { if (!((p & -32) << 24 >> 24 == -128)) { s = 23; break b } } else { if (!((p & -64) << 24 >> 24 == -128)) { s = 25; break b } }
                                    t = r & 255;
                                    if ((t & 192 | 0) != 128) { m = j; break a }
                                    if (((p & 255) << 6 & 4032 | l << 12 & 61440 | t & 63) >>> 0 > f >>> 0) { m = j; break a }
                                    n = j + 3 | 0;
                                    o = i;
                                    break
                                }
                                if (!((k & 255) >>> 0 < 245 >>> 0)) { m = j; break a }
                                u = j;
                                if ((g - u | 0) < 4) { m = j; break a }
                                if ((e - i | 0) >>> 0 < 2 >>> 0) { m = j; break a }
                                t = a[j + 1 | 0] | 0;
                                p = a[j + 2 | 0] | 0;
                                r = a[j + 3 | 0] | 0;
                                if ((l | 0) == 244) { if (!((t & -16) << 24 >> 24 == -128)) { s = 36; break b } } else if ((l | 0) == 240) { if (!((t + 112 & 255) >>> 0 < 48 >>> 0)) { s = 34; break b } } else { if (!((t & -64) << 24 >> 24 == -128)) { s = 38; break b } }
                                v = p & 255;
                                if ((v & 192 | 0) != 128) { m = j; break a }
                                p = r & 255;
                                if ((p & 192 | 0) != 128) { m = j; break a }
                                if (((t & 255) << 12 & 258048 | l << 18 & 1835008 | v << 6 & 4032 | p & 63) >>> 0 > f >>> 0) { m = j; break a }
                                n = j + 4 | 0;
                                o = i + 1 | 0
                            }
                        } while (0);
                        l = o + 1 | 0;
                        if (n >>> 0 < c >>> 0 & l >>> 0 < e >>> 0) {
                            i = l;
                            j = n
                        } else { m = n; break a }
                    }
                    if ((s | 0) == 21) { w = q - b | 0; return w | 0 } else if ((s | 0) == 23) { w = q - b | 0; return w | 0 } else if ((s | 0) == 25) { w = q - b | 0; return w | 0 } else if ((s | 0) == 34) { w = u - b | 0; return w | 0 } else if ((s | 0) == 36) { w = u - b | 0; return w | 0 } else if ((s | 0) == 38) { w = u - b | 0; return w | 0 }
                } else { m = h }
            } while (0);
            w = m - b | 0;
            return w | 0
        }

        function Vs(a) { a = a | 0; return 4 }

        function Ws(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Xs(a, b, d, e, f, g, h, j) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0;
            b = i;
            i = i + 16 | 0;
            a = b | 0;
            k = b + 8 | 0;
            c[a >> 2] = d;
            c[k >> 2] = g;
            l = Ys(d, e, a, g, h, k, 1114111, 0) | 0;
            c[f >> 2] = d + ((c[a >> 2] | 0) - d >> 2 << 2);
            c[j >> 2] = g + ((c[k >> 2] | 0) - g);
            i = b;
            return l | 0
        }

        function Ys(b, d, e, f, g, h, i, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0;
            c[e >> 2] = b;
            c[h >> 2] = f;
            do {
                if ((j & 2 | 0) != 0) {
                    if ((g - f | 0) < 3) { k = 1; return k | 0 } else {
                        c[h >> 2] = f + 1;
                        a[f] = -17;
                        b = c[h >> 2] | 0;
                        c[h >> 2] = b + 1;
                        a[b] = -69;
                        b = c[h >> 2] | 0;
                        c[h >> 2] = b + 1;
                        a[b] = -65;
                        break
                    }
                }
            } while (0);
            f = c[e >> 2] | 0;
            if (!(f >>> 0 < d >>> 0)) { k = 0; return k | 0 }
            j = g;
            g = f;
            a: while (1) {
                f = c[g >> 2] | 0;
                if ((f & -2048 | 0) == 55296 | f >>> 0 > i >>> 0) {
                    k = 2;
                    l = 19;
                    break
                }
                do {
                    if (f >>> 0 < 128 >>> 0) {
                        b = c[h >> 2] | 0;
                        if ((j - b | 0) < 1) {
                            k = 1;
                            l = 19;
                            break a
                        }
                        c[h >> 2] = b + 1;
                        a[b] = f
                    } else {
                        if (f >>> 0 < 2048 >>> 0) {
                            b = c[h >> 2] | 0;
                            if ((j - b | 0) < 2) {
                                k = 1;
                                l = 19;
                                break a
                            }
                            c[h >> 2] = b + 1;
                            a[b] = f >>> 6 | 192;
                            b = c[h >> 2] | 0;
                            c[h >> 2] = b + 1;
                            a[b] = f & 63 | 128;
                            break
                        }
                        b = c[h >> 2] | 0;
                        m = j - b | 0;
                        if (f >>> 0 < 65536 >>> 0) {
                            if ((m | 0) < 3) {
                                k = 1;
                                l = 19;
                                break a
                            }
                            c[h >> 2] = b + 1;
                            a[b] = f >>> 12 | 224;
                            n = c[h >> 2] | 0;
                            c[h >> 2] = n + 1;
                            a[n] = f >>> 6 & 63 | 128;
                            n = c[h >> 2] | 0;
                            c[h >> 2] = n + 1;
                            a[n] = f & 63 | 128;
                            break
                        } else {
                            if ((m | 0) < 4) {
                                k = 1;
                                l = 19;
                                break a
                            }
                            c[h >> 2] = b + 1;
                            a[b] = f >>> 18 | 240;
                            b = c[h >> 2] | 0;
                            c[h >> 2] = b + 1;
                            a[b] = f >>> 12 & 63 | 128;
                            b = c[h >> 2] | 0;
                            c[h >> 2] = b + 1;
                            a[b] = f >>> 6 & 63 | 128;
                            b = c[h >> 2] | 0;
                            c[h >> 2] = b + 1;
                            a[b] = f & 63 | 128;
                            break
                        }
                    }
                } while (0);
                f = (c[e >> 2] | 0) + 4 | 0;
                c[e >> 2] = f;
                if (f >>> 0 < d >>> 0) { g = f } else {
                    k = 0;
                    l = 19;
                    break
                }
            }
            if ((l | 0) == 19) { return k | 0 }
            return 0
        }

        function Zs(a, b, d, e, f, g, h, j) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0;
            b = i;
            i = i + 16 | 0;
            a = b | 0;
            k = b + 8 | 0;
            c[a >> 2] = d;
            c[k >> 2] = g;
            l = _s(d, e, a, g, h, k, 1114111, 0) | 0;
            c[f >> 2] = d + ((c[a >> 2] | 0) - d);
            c[j >> 2] = g + ((c[k >> 2] | 0) - g >> 2 << 2);
            i = b;
            return l | 0
        }

        function _s(b, e, f, g, h, i, j, k) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            c[f >> 2] = b;
            c[i >> 2] = g;
            g = c[f >> 2] | 0;
            do {
                if ((k & 4 | 0) == 0) { l = g } else {
                    if ((e - g | 0) <= 2) { l = g; break }
                    if (!((a[g] | 0) == -17)) { l = g; break }
                    if (!((a[g + 1 | 0] | 0) == -69)) { l = g; break }
                    if (!((a[g + 2 | 0] | 0) == -65)) { l = g; break }
                    b = g + 3 | 0;
                    c[f >> 2] = b;
                    l = b
                }
            } while (0);
            a: do {
                if (l >>> 0 < e >>> 0) {
                    g = e;
                    k = c[i >> 2] | 0;
                    b = l;
                    b: while (1) {
                        if (!(k >>> 0 < h >>> 0)) { m = b; break a }
                        n = a[b] | 0;
                        o = n & 255;
                        do {
                            if (n << 24 >> 24 > -1) {
                                if (o >>> 0 > j >>> 0) {
                                    p = 2;
                                    q = 40;
                                    break b
                                }
                                c[k >> 2] = o;
                                c[f >> 2] = b + 1
                            } else {
                                if ((n & 255) >>> 0 < 194 >>> 0) {
                                    p = 2;
                                    q = 40;
                                    break b
                                }
                                if ((n & 255) >>> 0 < 224 >>> 0) {
                                    if ((g - b | 0) < 2) {
                                        p = 1;
                                        q = 40;
                                        break b
                                    }
                                    r = d[b + 1 | 0] | 0;
                                    if ((r & 192 | 0) != 128) {
                                        p = 2;
                                        q = 40;
                                        break b
                                    }
                                    s = r & 63 | o << 6 & 1984;
                                    if (s >>> 0 > j >>> 0) {
                                        p = 2;
                                        q = 40;
                                        break b
                                    }
                                    c[k >> 2] = s;
                                    c[f >> 2] = b + 2;
                                    break
                                }
                                if ((n & 255) >>> 0 < 240 >>> 0) {
                                    if ((g - b | 0) < 3) {
                                        p = 1;
                                        q = 40;
                                        break b
                                    }
                                    s = a[b + 1 | 0] | 0;
                                    r = a[b + 2 | 0] | 0;
                                    if ((o | 0) == 224) {
                                        if (!((s & -32) << 24 >> 24 == -96)) {
                                            p = 2;
                                            q = 40;
                                            break b
                                        }
                                    } else if ((o | 0) == 237) {
                                        if (!((s & -32) << 24 >> 24 == -128)) {
                                            p = 2;
                                            q = 40;
                                            break b
                                        }
                                    } else {
                                        if (!((s & -64) << 24 >> 24 == -128)) {
                                            p = 2;
                                            q = 40;
                                            break b
                                        }
                                    }
                                    t = r & 255;
                                    if ((t & 192 | 0) != 128) {
                                        p = 2;
                                        q = 40;
                                        break b
                                    }
                                    r = (s & 255) << 6 & 4032 | o << 12 & 61440 | t & 63;
                                    if (r >>> 0 > j >>> 0) {
                                        p = 2;
                                        q = 40;
                                        break b
                                    }
                                    c[k >> 2] = r;
                                    c[f >> 2] = b + 3;
                                    break
                                }
                                if (!((n & 255) >>> 0 < 245 >>> 0)) {
                                    p = 2;
                                    q = 40;
                                    break b
                                }
                                if ((g - b | 0) < 4) {
                                    p = 1;
                                    q = 40;
                                    break b
                                }
                                r = a[b + 1 | 0] | 0;
                                t = a[b + 2 | 0] | 0;
                                s = a[b + 3 | 0] | 0;
                                if ((o | 0) == 240) {
                                    if (!((r + 112 & 255) >>> 0 < 48 >>> 0)) {
                                        p = 2;
                                        q = 40;
                                        break b
                                    }
                                } else if ((o | 0) == 244) {
                                    if (!((r & -16) << 24 >> 24 == -128)) {
                                        p = 2;
                                        q = 40;
                                        break b
                                    }
                                } else {
                                    if (!((r & -64) << 24 >> 24 == -128)) {
                                        p = 2;
                                        q = 40;
                                        break b
                                    }
                                }
                                u = t & 255;
                                if ((u & 192 | 0) != 128) {
                                    p = 2;
                                    q = 40;
                                    break b
                                }
                                t = s & 255;
                                if ((t & 192 | 0) != 128) {
                                    p = 2;
                                    q = 40;
                                    break b
                                }
                                s = (r & 255) << 12 & 258048 | o << 18 & 1835008 | u << 6 & 4032 | t & 63;
                                if (s >>> 0 > j >>> 0) {
                                    p = 2;
                                    q = 40;
                                    break b
                                }
                                c[k >> 2] = s;
                                c[f >> 2] = b + 4
                            }
                        } while (0);
                        o = (c[i >> 2] | 0) + 4 | 0;
                        c[i >> 2] = o;
                        n = c[f >> 2] | 0;
                        if (n >>> 0 < e >>> 0) {
                            k = o;
                            b = n
                        } else { m = n; break a }
                    }
                    if ((q | 0) == 40) { return p | 0 }
                } else { m = l }
            } while (0);
            p = m >>> 0 < e >>> 0 | 0;
            return p | 0
        }

        function $s(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            c[f >> 2] = d;
            return 3
        }

        function at(a) { a = a | 0; return 0 }

        function bt(a) { a = a | 0; return 0 }

        function ct(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            return dt(c, d, e, 1114111, 0) | 0
        }

        function dt(b, c, e, f, g) {
            b = b | 0;
            c = c | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            do {
                if ((g & 4 | 0) == 0) { h = b } else {
                    if ((c - b | 0) <= 2) { h = b; break }
                    if (!((a[b] | 0) == -17)) { h = b; break }
                    if (!((a[b + 1 | 0] | 0) == -69)) { h = b; break }
                    h = (a[b + 2 | 0] | 0) == -65 ? b + 3 | 0 : b
                }
            } while (0);
            a: do {
                if (h >>> 0 < c >>> 0 & (e | 0) != 0) {
                    g = c;
                    i = 1;
                    j = h;
                    b: while (1) {
                        k = a[j] | 0;
                        l = k & 255;
                        do {
                            if (k << 24 >> 24 > -1) {
                                if (l >>> 0 > f >>> 0) { m = j; break a }
                                n = j + 1 | 0
                            } else {
                                if ((k & 255) >>> 0 < 194 >>> 0) { m = j; break a }
                                if ((k & 255) >>> 0 < 224 >>> 0) {
                                    if ((g - j | 0) < 2) { m = j; break a }
                                    o = d[j + 1 | 0] | 0;
                                    if ((o & 192 | 0) != 128) { m = j; break a }
                                    if ((o & 63 | l << 6 & 1984) >>> 0 > f >>> 0) { m = j; break a }
                                    n = j + 2 | 0;
                                    break
                                }
                                if ((k & 255) >>> 0 < 240 >>> 0) {
                                    p = j;
                                    if ((g - p | 0) < 3) { m = j; break a }
                                    o = a[j + 1 | 0] | 0;
                                    q = a[j + 2 | 0] | 0;
                                    if ((l | 0) == 224) { if (!((o & -32) << 24 >> 24 == -96)) { r = 21; break b } } else if ((l | 0) == 237) { if (!((o & -32) << 24 >> 24 == -128)) { r = 23; break b } } else { if (!((o & -64) << 24 >> 24 == -128)) { r = 25; break b } }
                                    s = q & 255;
                                    if ((s & 192 | 0) != 128) { m = j; break a }
                                    if (((o & 255) << 6 & 4032 | l << 12 & 61440 | s & 63) >>> 0 > f >>> 0) { m = j; break a }
                                    n = j + 3 | 0;
                                    break
                                }
                                if (!((k & 255) >>> 0 < 245 >>> 0)) { m = j; break a }
                                t = j;
                                if ((g - t | 0) < 4) { m = j; break a }
                                s = a[j + 1 | 0] | 0;
                                o = a[j + 2 | 0] | 0;
                                q = a[j + 3 | 0] | 0;
                                if ((l | 0) == 240) { if (!((s + 112 & 255) >>> 0 < 48 >>> 0)) { r = 33; break b } } else if ((l | 0) == 244) { if (!((s & -16) << 24 >> 24 == -128)) { r = 35; break b } } else { if (!((s & -64) << 24 >> 24 == -128)) { r = 37; break b } }
                                u = o & 255;
                                if ((u & 192 | 0) != 128) { m = j; break a }
                                o = q & 255;
                                if ((o & 192 | 0) != 128) { m = j; break a }
                                if (((s & 255) << 12 & 258048 | l << 18 & 1835008 | u << 6 & 4032 | o & 63) >>> 0 > f >>> 0) { m = j; break a }
                                n = j + 4 | 0
                            }
                        } while (0);
                        if (!(n >>> 0 < c >>> 0 & i >>> 0 < e >>> 0)) { m = n; break a }
                        i = i + 1 | 0;
                        j = n
                    }
                    if ((r | 0) == 21) { v = p - b | 0; return v | 0 } else if ((r | 0) == 23) { v = p - b | 0; return v | 0 } else if ((r | 0) == 25) { v = p - b | 0; return v | 0 } else if ((r | 0) == 33) { v = t - b | 0; return v | 0 } else if ((r | 0) == 35) { v = t - b | 0; return v | 0 } else if ((r | 0) == 37) { v = t - b | 0; return v | 0 }
                } else { m = h }
            } while (0);
            v = m - b | 0;
            return v | 0
        }

        function et(a) { a = a | 0; return 4 }

        function ft(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function gt(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function ht(a) {
            a = a | 0;
            c[a >> 2] = 20096;
            rm(a + 12 | 0);
            Sl(a | 0);
            Pu(a);
            return
        }

        function it(a) {
            a = a | 0;
            c[a >> 2] = 20096;
            rm(a + 12 | 0);
            Sl(a | 0);
            return
        }

        function jt(a) {
            a = a | 0;
            c[a >> 2] = 20048;
            rm(a + 16 | 0);
            Sl(a | 0);
            Pu(a);
            return
        }

        function kt(a) {
            a = a | 0;
            c[a >> 2] = 20048;
            rm(a + 16 | 0);
            Sl(a | 0);
            return
        }

        function lt(b) { b = b | 0; return a[b + 8 | 0] | 0 }

        function mt(a) { a = a | 0; return c[a + 8 >> 2] | 0 }

        function nt(b) { b = b | 0; return a[b + 9 | 0] | 0 }

        function ot(a) { a = a | 0; return c[a + 12 >> 2] | 0 }

        function pt(a, b) {
            a = a | 0;
            b = b | 0;
            om(a, b + 12 | 0);
            return
        }

        function qt(a, b) {
            a = a | 0;
            b = b | 0;
            om(a, b + 16 | 0);
            return
        }

        function rt(a, b) {
            a = a | 0;
            b = b | 0;
            pm(a, 12536, 4);
            return
        }

        function st(a, b) {
            a = a | 0;
            b = b | 0;
            Am(a, 12296, gu(12296) | 0);
            return
        }

        function tt(a, b) {
            a = a | 0;
            b = b | 0;
            pm(a, 11952, 5);
            return
        }

        function ut(a, b) {
            a = a | 0;
            b = b | 0;
            Am(a, 11608, gu(11608) | 0);
            return
        }

        function vt(b) {
            b = b | 0;
            var d = 0;
            if ((a[51888] | 0) != 0) { d = c[8476] | 0; return d | 0 }
            if ((ub(51888) | 0) == 0) { d = c[8476] | 0; return d | 0 }
            do {
                if ((a[51776] | 0) == 0) {
                    if ((ub(51776) | 0) == 0) { break }
                    dv(32832, 0, 168) | 0;
                    Ub(322, 0, u | 0) | 0
                }
            } while (0);
            sm(32832, 16184) | 0;
            sm(32844, 16176) | 0;
            sm(32856, 16168) | 0;
            sm(32868, 16128) | 0;
            sm(32880, 16016) | 0;
            sm(32892, 16e3) | 0;
            sm(32904, 15984) | 0;
            sm(32916, 15960) | 0;
            sm(32928, 15904) | 0;
            sm(32940, 15824) | 0;
            sm(32952, 15816) | 0;
            sm(32964, 15808) | 0;
            sm(32976, 15776) | 0;
            sm(32988, 15712) | 0;
            c[8476] = 32832;
            d = c[8476] | 0;
            return d | 0
        }

        function wt(b) {
            b = b | 0;
            var d = 0;
            if ((a[51832] | 0) != 0) { d = c[8454] | 0; return d | 0 }
            if ((ub(51832) | 0) == 0) { d = c[8454] | 0; return d | 0 }
            do {
                if ((a[51752] | 0) == 0) {
                    if ((ub(51752) | 0) == 0) { break }
                    dv(32088, 0, 168) | 0;
                    Ub(176, 0, u | 0) | 0
                }
            } while (0);
            Dm(32088, 16912) | 0;
            Dm(32100, 16880) | 0;
            Dm(32112, 16840) | 0;
            Dm(32124, 16728) | 0;
            Dm(32136, 16648) | 0;
            Dm(32148, 16616) | 0;
            Dm(32160, 16576) | 0;
            Dm(32172, 16544) | 0;
            Dm(32184, 16448) | 0;
            Dm(32196, 16424) | 0;
            Dm(32208, 16360) | 0;
            Dm(32220, 16344) | 0;
            Dm(32232, 16320) | 0;
            Dm(32244, 16256) | 0;
            c[8454] = 32088;
            d = c[8454] | 0;
            return d | 0
        }

        function xt(b) {
            b = b | 0;
            var d = 0;
            if ((a[51880] | 0) != 0) { d = c[8474] | 0; return d | 0 }
            if ((ub(51880) | 0) == 0) { d = c[8474] | 0; return d | 0 }
            do {
                if ((a[51768] | 0) == 0) {
                    if ((ub(51768) | 0) == 0) { break }
                    dv(32544, 0, 288) | 0;
                    Ub(198, 0, u | 0) | 0
                }
            } while (0);
            sm(32544, 1360) | 0;
            sm(32556, 1272) | 0;
            sm(32568, 1208) | 0;
            sm(32580, 1096) | 0;
            sm(32592, 1088) | 0;
            sm(32604, 1064) | 0;
            sm(32616, 1016) | 0;
            sm(32628, 896) | 0;
            sm(32640, 800) | 0;
            sm(32652, 728) | 0;
            sm(32664, 688) | 0;
            sm(32676, 624) | 0;
            sm(32688, 528) | 0;
            sm(32700, 408) | 0;
            sm(32712, 400) | 0;
            sm(32724, 392) | 0;
            sm(32736, 1088) | 0;
            sm(32748, 376) | 0;
            sm(32760, 288) | 0;
            sm(32772, 17112) | 0;
            sm(32784, 17104) | 0;
            sm(32796, 17096) | 0;
            sm(32808, 17088) | 0;
            sm(32820, 17008) | 0;
            c[8474] = 32544;
            d = c[8474] | 0;
            return d | 0
        }

        function yt(b) {
            b = b | 0;
            var d = 0;
            if ((a[51824] | 0) != 0) { d = c[8452] | 0; return d | 0 }
            if ((ub(51824) | 0) == 0) { d = c[8452] | 0; return d | 0 }
            do {
                if ((a[51744] | 0) == 0) {
                    if ((ub(51744) | 0) == 0) { break }
                    dv(31800, 0, 288) | 0;
                    Ub(146, 0, u | 0) | 0
                }
            } while (0);
            Dm(31800, 4560) | 0;
            Dm(31812, 4352) | 0;
            Dm(31824, 4152) | 0;
            Dm(31836, 4048) | 0;
            Dm(31848, 2448) | 0;
            Dm(31860, 3856) | 0;
            Dm(31872, 3760) | 0;
            Dm(31884, 3592) | 0;
            Dm(31896, 3424) | 0;
            Dm(31908, 3312) | 0;
            Dm(31920, 3184) | 0;
            Dm(31932, 3040) | 0;
            Dm(31944, 2880) | 0;
            Dm(31956, 2800) | 0;
            Dm(31968, 2680) | 0;
            Dm(31980, 2584) | 0;
            Dm(31992, 2448) | 0;
            Dm(32004, 2304) | 0;
            Dm(32016, 2120) | 0;
            Dm(32028, 2032) | 0;
            Dm(32040, 1904) | 0;
            Dm(32052, 1712) | 0;
            Dm(32064, 1544) | 0;
            Dm(32076, 1408) | 0;
            c[8452] = 31800;
            d = c[8452] | 0;
            return d | 0
        }

        function zt(b) {
            b = b | 0;
            var d = 0;
            if ((a[51896] | 0) != 0) { d = c[8478] | 0; return d | 0 }
            if ((ub(51896) | 0) == 0) { d = c[8478] | 0; return d | 0 }
            do {
                if ((a[51784] | 0) == 0) {
                    if ((ub(51784) | 0) == 0) { break }
                    dv(33e3, 0, 288) | 0;
                    Ub(144, 0, u | 0) | 0
                }
            } while (0);
            sm(33e3, 5080) | 0;
            sm(33012, 4872) | 0;
            c[8478] = 33e3;
            d = c[8478] | 0;
            return d | 0
        }

        function At(b) {
            b = b | 0;
            var d = 0;
            if ((a[51840] | 0) != 0) { d = c[8456] | 0; return d | 0 }
            if ((ub(51840) | 0) == 0) { d = c[8456] | 0; return d | 0 }
            do {
                if ((a[51760] | 0) == 0) {
                    if ((ub(51760) | 0) == 0) { break }
                    dv(32256, 0, 288) | 0;
                    Ub(208, 0, u | 0) | 0
                }
            } while (0);
            Dm(32256, 5568) | 0;
            Dm(32268, 5432) | 0;
            c[8456] = 32256;
            d = c[8456] | 0;
            return d | 0
        }

        function Bt(b) {
            b = b | 0;
            if ((a[51904] | 0) != 0) { return 33920 }
            if ((ub(51904) | 0) == 0) { return 33920 }
            pm(33920, 11072, 8);
            Ub(314, 33920, u | 0) | 0;
            return 33920
        }

        function Ct(b) {
            b = b | 0;
            if ((a[51848] | 0) != 0) { return 33832 }
            if ((ub(51848) | 0) == 0) { return 33832 }
            Am(33832, 10808, gu(10808) | 0);
            Ub(230, 33832, u | 0) | 0;
            return 33832
        }

        function Dt(b) {
            b = b | 0;
            if ((a[51928] | 0) != 0) { return 33968 }
            if ((ub(51928) | 0) == 0) { return 33968 }
            pm(33968, 10560, 8);
            Ub(314, 33968, u | 0) | 0;
            return 33968
        }

        function Et(b) {
            b = b | 0;
            if ((a[51872] | 0) != 0) { return 33880 }
            if ((ub(51872) | 0) == 0) { return 33880 }
            Am(33880, 10240, gu(10240) | 0);
            Ub(230, 33880, u | 0) | 0;
            return 33880
        }

        function Ft(b) {
            b = b | 0;
            if ((a[51920] | 0) != 0) { return 33952 }
            if ((ub(51920) | 0) == 0) { return 33952 }
            pm(33952, 9920, 20);
            Ub(314, 33952, u | 0) | 0;
            return 33952
        }

        function Gt(b) {
            b = b | 0;
            if ((a[51864] | 0) != 0) { return 33864 }
            if ((ub(51864) | 0) == 0) { return 33864 }
            Am(33864, 9512, gu(9512) | 0);
            Ub(230, 33864, u | 0) | 0;
            return 33864
        }

        function Ht(b) {
            b = b | 0;
            if ((a[51912] | 0) != 0) { return 33936 }
            if ((ub(51912) | 0) == 0) { return 33936 }
            pm(33936, 9144, 11);
            Ub(314, 33936, u | 0) | 0;
            return 33936
        }

        function It(b) {
            b = b | 0;
            if ((a[51856] | 0) != 0) { return 33848 }
            if ((ub(51856) | 0) == 0) { return 33848 }
            Am(33848, 8832, gu(8832) | 0);
            Ub(230, 33848, u | 0) | 0;
            return 33848
        }

        function Jt(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0.0,
                j = 0,
                k = 0,
                l = 0,
                m = 0.0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            if ((b | 0) == (d | 0)) {
                c[e >> 2] = 4;
                h = 0.0;
                i = f;
                return +h
            }
            j = Vb() | 0;
            k = c[j >> 2] | 0;
            c[j >> 2] = 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    l = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = l
                }
            } while (0);
            m = +bv(b, g, c[8330] | 0);
            b = c[j >> 2] | 0;
            if ((b | 0) == 0) { c[j >> 2] = k }
            if ((c[g >> 2] | 0) != (d | 0)) {
                c[e >> 2] = 4;
                h = 0.0;
                i = f;
                return +h
            }
            if ((b | 0) != 34) {
                h = m;
                i = f;
                return +h
            }
            c[e >> 2] = 4;
            h = m;
            i = f;
            return +h
        }

        function Kt(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0.0,
                j = 0,
                k = 0,
                l = 0,
                m = 0.0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            if ((b | 0) == (d | 0)) {
                c[e >> 2] = 4;
                h = 0.0;
                i = f;
                return +h
            }
            j = Vb() | 0;
            k = c[j >> 2] | 0;
            c[j >> 2] = 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    l = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = l
                }
            } while (0);
            m = +bv(b, g, c[8330] | 0);
            b = c[j >> 2] | 0;
            if ((b | 0) == 0) { c[j >> 2] = k }
            if ((c[g >> 2] | 0) != (d | 0)) {
                c[e >> 2] = 4;
                h = 0.0;
                i = f;
                return +h
            }
            if ((b | 0) != 34) {
                h = m;
                i = f;
                return +h
            }
            c[e >> 2] = 4;
            h = m;
            i = f;
            return +h
        }

        function Lt(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0.0,
                j = 0,
                k = 0,
                l = 0,
                m = 0.0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            if ((b | 0) == (d | 0)) {
                c[e >> 2] = 4;
                h = 0.0;
                i = f;
                return +h
            }
            j = Vb() | 0;
            k = c[j >> 2] | 0;
            c[j >> 2] = 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    l = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = l
                }
            } while (0);
            m = +bv(b, g, c[8330] | 0);
            b = c[j >> 2] | 0;
            if ((b | 0) == 0) { c[j >> 2] = k }
            if ((c[g >> 2] | 0) != (d | 0)) {
                c[e >> 2] = 4;
                h = 0.0;
                i = f;
                return +h
            }
            if ((b | 0) == 34) { c[e >> 2] = 4 }
            h = m;
            i = f;
            return +h
        }

        function Mt(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            do {
                if ((b | 0) == (d | 0)) {
                    c[e >> 2] = 4;
                    j = 0;
                    k = 0
                } else {
                    if ((a[b] | 0) == 45) {
                        c[e >> 2] = 4;
                        j = 0;
                        k = 0;
                        break
                    }
                    l = Vb() | 0;
                    m = c[l >> 2] | 0;
                    c[l >> 2] = 0;
                    do {
                        if ((a[51808] | 0) == 0) {
                            if ((ub(51808) | 0) == 0) { break }
                            n = Xa(2147483647, 14472, 0) | 0;
                            c[8330] = n
                        }
                    } while (0);
                    n = Ib(b | 0, h | 0, f | 0, c[8330] | 0) | 0;
                    o = c[l >> 2] | 0;
                    if ((o | 0) == 0) { c[l >> 2] = m }
                    if ((c[h >> 2] | 0) != (d | 0)) {
                        c[e >> 2] = 4;
                        j = 0;
                        k = 0;
                        break
                    }
                    if ((o | 0) != 34) {
                        j = K;
                        k = n;
                        break
                    }
                    c[e >> 2] = 4;
                    j = -1;
                    k = -1
                }
            } while (0);
            i = g;
            return (K = j, k) | 0
        }

        function Nt(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            if ((b | 0) == (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            if ((a[b] | 0) == 45) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            k = Vb() | 0;
            l = c[k >> 2] | 0;
            c[k >> 2] = 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    m = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = m
                }
            } while (0);
            m = Ib(b | 0, h | 0, f | 0, c[8330] | 0) | 0;
            f = K;
            b = c[k >> 2] | 0;
            if ((b | 0) == 0) { c[k >> 2] = l }
            if ((c[h >> 2] | 0) != (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            d = 0;
            if ((b | 0) == 34 | (f >>> 0 > d >>> 0 | f >>> 0 == d >>> 0 & m >>> 0 > -1 >>> 0)) {
                c[e >> 2] = 4;
                j = -1;
                i = g;
                return j | 0
            } else {
                j = m;
                i = g;
                return j | 0
            }
            return 0
        }

        function Ot(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            if ((b | 0) == (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            if ((a[b] | 0) == 45) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            k = Vb() | 0;
            l = c[k >> 2] | 0;
            c[k >> 2] = 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    m = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = m
                }
            } while (0);
            m = Ib(b | 0, h | 0, f | 0, c[8330] | 0) | 0;
            f = K;
            b = c[k >> 2] | 0;
            if ((b | 0) == 0) { c[k >> 2] = l }
            if ((c[h >> 2] | 0) != (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            d = 0;
            if ((b | 0) == 34 | (f >>> 0 > d >>> 0 | f >>> 0 == d >>> 0 & m >>> 0 > -1 >>> 0)) {
                c[e >> 2] = 4;
                j = -1;
                i = g;
                return j | 0
            } else {
                j = m;
                i = g;
                return j | 0
            }
            return 0
        }

        function Pt(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            if ((b | 0) == (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            if ((a[b] | 0) == 45) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            k = Vb() | 0;
            l = c[k >> 2] | 0;
            c[k >> 2] = 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    m = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = m
                }
            } while (0);
            m = Ib(b | 0, h | 0, f | 0, c[8330] | 0) | 0;
            f = K;
            b = c[k >> 2] | 0;
            if ((b | 0) == 0) { c[k >> 2] = l }
            if ((c[h >> 2] | 0) != (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            d = 0;
            if ((b | 0) == 34 | (f >>> 0 > d >>> 0 | f >>> 0 == d >>> 0 & m >>> 0 > 65535 >>> 0)) {
                c[e >> 2] = 4;
                j = -1;
                i = g;
                return j | 0
            } else {
                j = m & 65535;
                i = g;
                return j | 0
            }
            return 0
        }

        function Qt(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            if ((b | 0) == (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                k = 0;
                i = g;
                return (K = j, k) | 0
            }
            l = Vb() | 0;
            m = c[l >> 2] | 0;
            c[l >> 2] = 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    n = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = n
                }
            } while (0);
            n = Lb(b | 0, h | 0, f | 0, c[8330] | 0) | 0;
            f = K;
            b = c[l >> 2] | 0;
            if ((b | 0) == 0) { c[l >> 2] = m }
            if ((c[h >> 2] | 0) != (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                k = 0;
                i = g;
                return (K = j, k) | 0
            }
            if ((b | 0) == 34) {
                c[e >> 2] = 4;
                e = 0;
                b = (f | 0) > (e | 0) | (f | 0) == (e | 0) & n >>> 0 > 0 >>> 0;
                i = g;
                return (K = b ? 2147483647 : -2147483648, b ? -1 : 0) | 0
            } else {
                j = f;
                k = n;
                i = g;
                return (K = j, k) | 0
            }
            return 0
        }

        function Rt(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            if ((b | 0) == (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            k = Vb() | 0;
            l = c[k >> 2] | 0;
            c[k >> 2] = 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    m = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = m
                }
            } while (0);
            m = Lb(b | 0, h | 0, f | 0, c[8330] | 0) | 0;
            f = K;
            b = c[k >> 2] | 0;
            if ((b | 0) == 0) { c[k >> 2] = l }
            if ((c[h >> 2] | 0) != (d | 0)) {
                c[e >> 2] = 4;
                j = 0;
                i = g;
                return j | 0
            }
            do {
                if ((b | 0) == 34) {
                    c[e >> 2] = 4;
                    d = 0;
                    if ((f | 0) > (d | 0) | (f | 0) == (d | 0) & m >>> 0 > 0 >>> 0) { j = 2147483647 } else { break }
                    i = g;
                    return j | 0
                } else {
                    d = -1;
                    if ((f | 0) < (d | 0) | (f | 0) == (d | 0) & m >>> 0 < -2147483648 >>> 0) { c[e >> 2] = 4; break }
                    d = 0;
                    if ((f | 0) > (d | 0) | (f | 0) == (d | 0) & m >>> 0 > 2147483647 >>> 0) {
                        c[e >> 2] = 4;
                        j = 2147483647;
                        i = g;
                        return j | 0
                    } else {
                        j = m;
                        i = g;
                        return j | 0
                    }
                }
            } while (0);
            j = -2147483648;
            i = g;
            return j | 0
        }

        function St(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0;
            b = a + 4 | 0;
            d = (c[a >> 2] | 0) + (c[b + 4 >> 2] | 0) | 0;
            a = d;
            e = c[b >> 2] | 0;
            if ((e & 1 | 0) == 0) {
                f = e;
                Dc[f & 511](a);
                return
            } else {
                f = c[(c[d >> 2] | 0) + (e - 1) >> 2] | 0;
                Dc[f & 511](a);
                return
            }
        }

        function Tt(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            e = b + 8 | 0;
            f = b + 4 | 0;
            g = c[f >> 2] | 0;
            h = c[e >> 2] | 0;
            i = g;
            if (!(h - i >> 2 >>> 0 < d >>> 0)) {
                j = d;
                k = g;
                do {
                    if ((k | 0) == 0) { l = 0 } else {
                        c[k >> 2] = 0;
                        l = c[f >> 2] | 0
                    }
                    k = l + 4 | 0;
                    c[f >> 2] = k;
                    j = j - 1 | 0;
                } while ((j | 0) != 0);
                return
            }
            j = b + 16 | 0;
            k = b | 0;
            l = c[k >> 2] | 0;
            g = i - l >> 2;
            i = g + d | 0;
            if (i >>> 0 > 1073741823 >>> 0) { Nr(0) }
            m = h - l | 0;
            do {
                if (m >> 2 >>> 0 < 536870911 >>> 0) {
                    l = m >> 1;
                    h = l >>> 0 < i >>> 0 ? i : l;
                    if ((h | 0) == 0) {
                        n = 0;
                        o = 0;
                        break
                    }
                    l = b + 128 | 0;
                    if (!((a[l] | 0) == 0 & h >>> 0 < 29 >>> 0)) {
                        p = h;
                        q = 11;
                        break
                    }
                    a[l] = 1;
                    n = j;
                    o = h
                } else {
                    p = 1073741823;
                    q = 11
                }
            } while (0);
            if ((q | 0) == 11) {
                n = Nu(p << 2) | 0;
                o = p
            }
            p = d;
            d = n + (g << 2) | 0;
            do {
                if ((d | 0) == 0) { r = 0 } else {
                    c[d >> 2] = 0;
                    r = d
                }
                d = r + 4 | 0;
                p = p - 1 | 0;
            } while ((p | 0) != 0);
            p = c[k >> 2] | 0;
            r = (c[f >> 2] | 0) - p | 0;
            q = n + (g - (r >> 2) << 2) | 0;
            g = p;
            cv(q | 0, g | 0, r) | 0;
            c[k >> 2] = q;
            c[f >> 2] = d;
            c[e >> 2] = n + (o << 2);
            if ((p | 0) == 0) { return }
            if ((j | 0) == (p | 0)) { a[b + 128 | 0] = 0; return } else { Pu(g); return }
        }

        function Ut(a) {
            a = a | 0;
            Cm(32532);
            Cm(32520);
            Cm(32508);
            Cm(32496);
            Cm(32484);
            Cm(32472);
            Cm(32460);
            Cm(32448);
            Cm(32436);
            Cm(32424);
            Cm(32412);
            Cm(32400);
            Cm(32388);
            Cm(32376);
            Cm(32364);
            Cm(32352);
            Cm(32340);
            Cm(32328);
            Cm(32316);
            Cm(32304);
            Cm(32292);
            Cm(32280);
            Cm(32268);
            Cm(32256);
            return
        }

        function Vt(a) {
            a = a | 0;
            rm(33276);
            rm(33264);
            rm(33252);
            rm(33240);
            rm(33228);
            rm(33216);
            rm(33204);
            rm(33192);
            rm(33180);
            rm(33168);
            rm(33156);
            rm(33144);
            rm(33132);
            rm(33120);
            rm(33108);
            rm(33096);
            rm(33084);
            rm(33072);
            rm(33060);
            rm(33048);
            rm(33036);
            rm(33024);
            rm(33012);
            rm(33e3);
            return
        }

        function Wt(a) {
            a = a | 0;
            Cm(32076);
            Cm(32064);
            Cm(32052);
            Cm(32040);
            Cm(32028);
            Cm(32016);
            Cm(32004);
            Cm(31992);
            Cm(31980);
            Cm(31968);
            Cm(31956);
            Cm(31944);
            Cm(31932);
            Cm(31920);
            Cm(31908);
            Cm(31896);
            Cm(31884);
            Cm(31872);
            Cm(31860);
            Cm(31848);
            Cm(31836);
            Cm(31824);
            Cm(31812);
            Cm(31800);
            return
        }

        function Xt(a) {
            a = a | 0;
            rm(32820);
            rm(32808);
            rm(32796);
            rm(32784);
            rm(32772);
            rm(32760);
            rm(32748);
            rm(32736);
            rm(32724);
            rm(32712);
            rm(32700);
            rm(32688);
            rm(32676);
            rm(32664);
            rm(32652);
            rm(32640);
            rm(32628);
            rm(32616);
            rm(32604);
            rm(32592);
            rm(32580);
            rm(32568);
            rm(32556);
            rm(32544);
            return
        }

        function Yt(a) {
            a = a | 0;
            Cm(32244);
            Cm(32232);
            Cm(32220);
            Cm(32208);
            Cm(32196);
            Cm(32184);
            Cm(32172);
            Cm(32160);
            Cm(32148);
            Cm(32136);
            Cm(32124);
            Cm(32112);
            Cm(32100);
            Cm(32088);
            return
        }

        function Zt(a) {
            a = a | 0;
            rm(32988);
            rm(32976);
            rm(32964);
            rm(32952);
            rm(32940);
            rm(32928);
            rm(32916);
            rm(32904);
            rm(32892);
            rm(32880);
            rm(32868);
            rm(32856);
            rm(32844);
            rm(32832);
            return
        }

        function _t(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            return $t(0, a, b, (c | 0) != 0 ? c : 31056) | 0
        }

        function $t(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            c[h >> 2] = b;
            j = ((f | 0) == 0 ? 31048 : f) | 0;
            f = c[j >> 2] | 0;
            a: do {
                if ((d | 0) == 0) {
                    if ((f | 0) == 0) { k = 0 } else { break }
                    i = g;
                    return k | 0
                } else {
                    if ((b | 0) == 0) {
                        l = h;
                        c[h >> 2] = l;
                        m = l
                    } else { m = b }
                    if ((e | 0) == 0) {
                        k = -2;
                        i = g;
                        return k | 0
                    }
                    do {
                        if ((f | 0) == 0) {
                            l = a[d] | 0;
                            n = l & 255;
                            if (l << 24 >> 24 > -1) {
                                c[m >> 2] = n;
                                k = l << 24 >> 24 != 0 | 0;
                                i = g;
                                return k | 0
                            } else {
                                l = n - 194 | 0;
                                if (l >>> 0 > 50 >>> 0) { break a }
                                o = d + 1 | 0;
                                p = c[18936 + (l << 2) >> 2] | 0;
                                q = e - 1 | 0;
                                break
                            }
                        } else {
                            o = d;
                            p = f;
                            q = e
                        }
                    } while (0);
                    b: do {
                        if ((q | 0) == 0) { r = p } else {
                            l = a[o] | 0;
                            n = (l & 255) >>> 3;
                            if ((n - 16 | n + (p >> 26)) >>> 0 > 7 >>> 0) { break a } else {
                                s = o;
                                t = p;
                                u = q;
                                v = l
                            }
                            while (1) {
                                s = s + 1 | 0;
                                t = (v & 255) - 128 | t << 6;
                                u = u - 1 | 0;
                                if ((t | 0) >= 0) { break }
                                if ((u | 0) == 0) { r = t; break b }
                                v = a[s] | 0;
                                if (((v & 255) - 128 | 0) >>> 0 > 63 >>> 0) { break a }
                            }
                            c[j >> 2] = 0;
                            c[m >> 2] = t;
                            k = e - u | 0;
                            i = g;
                            return k | 0
                        }
                    } while (0);
                    c[j >> 2] = r;
                    k = -2;
                    i = g;
                    return k | 0
                }
            } while (0);
            c[j >> 2] = 0;
            j = Vb() | 0;
            c[j >> 2] = 84;
            k = -1;
            i = g;
            return k | 0
        }

        function au(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0;
            g = i;
            i = i + 1032 | 0;
            h = g + 1024 | 0;
            j = c[b >> 2] | 0;
            c[h >> 2] = j;
            k = (a | 0) != 0;
            l = g | 0;
            m = k ? e : 256;
            e = k ? a : l;
            a: do {
                if ((j | 0) == 0 | (m | 0) == 0) {
                    n = d;
                    o = 0;
                    p = m;
                    q = e;
                    r = j
                } else {
                    a = m;
                    s = 0;
                    t = e;
                    u = d;
                    v = j;
                    while (1) {
                        w = u >>> 2;
                        x = w >>> 0 >= a >>> 0;
                        if (!(x | u >>> 0 > 131 >>> 0)) {
                            n = u;
                            o = s;
                            p = a;
                            q = t;
                            r = v;
                            break a
                        }
                        y = x ? a : w;
                        z = u - y | 0;
                        w = bu(t, h, y, f) | 0;
                        if ((w | 0) == -1) { break }
                        if ((t | 0) == (l | 0)) {
                            A = l;
                            B = a
                        } else {
                            A = t + (w << 2) | 0;
                            B = a - w | 0
                        }
                        y = w + s | 0;
                        w = c[h >> 2] | 0;
                        if ((w | 0) == 0 | (B | 0) == 0) {
                            n = z;
                            o = y;
                            p = B;
                            q = A;
                            r = w;
                            break a
                        } else {
                            a = B;
                            s = y;
                            t = A;
                            u = z;
                            v = w
                        }
                    }
                    n = z;
                    o = -1;
                    p = 0;
                    q = t;
                    r = c[h >> 2] | 0
                }
            } while (0);
            b: do {
                if ((r | 0) == 0) { C = o } else {
                    if ((p | 0) == 0 | (n | 0) == 0) { C = o; break } else {
                        D = p;
                        E = o;
                        F = q;
                        G = n;
                        H = r
                    }
                    while (1) {
                        I = $t(F, H, G, f) | 0;
                        if ((I + 2 | 0) >>> 0 < 3 >>> 0) { break }
                        z = (c[h >> 2] | 0) + I | 0;
                        c[h >> 2] = z;
                        A = D - 1 | 0;
                        B = E + 1 | 0;
                        if ((A | 0) == 0 | (G | 0) == (I | 0)) { C = B; break b } else {
                            D = A;
                            E = B;
                            F = F + 4 | 0;
                            G = G - I | 0;
                            H = z
                        }
                    }
                    if ((I | 0) == 0) {
                        c[h >> 2] = 0;
                        C = E;
                        break
                    } else if ((I | 0) == (-1 | 0)) { C = -1; break } else {
                        c[f >> 2] = 0;
                        C = E;
                        break
                    }
                }
            } while (0);
            if (!k) {
                J = 1024;
                K = 0;
                i = g;
                return C | 0
            }
            c[b >> 2] = c[h >> 2];
            J = 1024;
            K = 0;
            i = g;
            return C | 0
        }

        function bu(b, e, f, g) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0;
            h = c[e >> 2] | 0;
            do {
                if ((g | 0) == 0) { i = 5 } else {
                    j = g | 0;
                    k = c[j >> 2] | 0;
                    if ((k | 0) == 0) { i = 5; break }
                    if ((b | 0) == 0) {
                        l = k;
                        m = h;
                        n = f;
                        i = 16;
                        break
                    }
                    c[j >> 2] = 0;
                    o = k;
                    p = h;
                    q = b;
                    r = f;
                    i = 36
                }
            } while (0);
            if ((i | 0) == 5) {
                if ((b | 0) == 0) {
                    s = h;
                    t = f;
                    i = 7
                } else {
                    u = h;
                    v = b;
                    w = f;
                    i = 6
                }
            }
            a: while (1) {
                if ((i | 0) == 6) {
                    i = 0;
                    if ((w | 0) == 0) {
                        x = f;
                        i = 53;
                        break
                    } else {
                        y = w;
                        z = v;
                        A = u
                    }
                    while (1) {
                        h = a[A] | 0;
                        do {
                            if (((h & 255) - 1 | 0) >>> 0 < 127 >>> 0) {
                                if ((A & 3 | 0) == 0 & y >>> 0 > 3 >>> 0) {
                                    B = y;
                                    C = z;
                                    D = A
                                } else {
                                    E = A;
                                    F = z;
                                    G = y;
                                    H = h;
                                    break
                                }
                                while (1) {
                                    I = c[D >> 2] | 0;
                                    if (((I - 16843009 | I) & -2139062144 | 0) != 0) { i = 30; break }
                                    c[C >> 2] = I & 255;
                                    c[C + 4 >> 2] = d[D + 1 | 0] | 0;
                                    c[C + 8 >> 2] = d[D + 2 | 0] | 0;
                                    J = D + 4 | 0;
                                    K = C + 16 | 0;
                                    c[C + 12 >> 2] = d[D + 3 | 0] | 0;
                                    L = B - 4 | 0;
                                    if (L >>> 0 > 3 >>> 0) {
                                        B = L;
                                        C = K;
                                        D = J
                                    } else { i = 31; break }
                                }
                                if ((i | 0) == 30) {
                                    i = 0;
                                    E = D;
                                    F = C;
                                    G = B;
                                    H = I & 255;
                                    break
                                } else if ((i | 0) == 31) {
                                    i = 0;
                                    E = J;
                                    F = K;
                                    G = L;
                                    H = a[J] | 0;
                                    break
                                }
                            } else {
                                E = A;
                                F = z;
                                G = y;
                                H = h
                            }
                        } while (0);
                        M = H & 255;
                        if (!((M - 1 | 0) >>> 0 < 127 >>> 0)) { break }
                        c[F >> 2] = M;
                        h = G - 1 | 0;
                        if ((h | 0) == 0) {
                            x = f;
                            i = 53;
                            break a
                        } else {
                            y = h;
                            z = F + 4 | 0;
                            A = E + 1 | 0
                        }
                    }
                    h = M - 194 | 0;
                    if (h >>> 0 > 50 >>> 0) {
                        N = G;
                        O = F;
                        P = E;
                        i = 47;
                        break
                    }
                    o = c[18936 + (h << 2) >> 2] | 0;
                    p = E + 1 | 0;
                    q = F;
                    r = G;
                    i = 36;
                    continue
                } else if ((i | 0) == 7) {
                    i = 0;
                    h = a[s] | 0;
                    do {
                        if (((h & 255) - 1 | 0) >>> 0 < 127 >>> 0) {
                            if ((s & 3 | 0) != 0) {
                                Q = s;
                                R = t;
                                S = h;
                                break
                            }
                            g = c[s >> 2] | 0;
                            if (((g - 16843009 | g) & -2139062144 | 0) == 0) {
                                T = t;
                                U = s
                            } else {
                                Q = s;
                                R = t;
                                S = g & 255;
                                break
                            }
                            do {
                                U = U + 4 | 0;
                                T = T - 4 | 0;
                                V = c[U >> 2] | 0;
                            } while (((V - 16843009 | V) & -2139062144 | 0) == 0);
                            Q = U;
                            R = T;
                            S = V & 255
                        } else {
                            Q = s;
                            R = t;
                            S = h
                        }
                    } while (0);
                    h = S & 255;
                    if ((h - 1 | 0) >>> 0 < 127 >>> 0) {
                        s = Q + 1 | 0;
                        t = R - 1 | 0;
                        i = 7;
                        continue
                    }
                    g = h - 194 | 0;
                    if (g >>> 0 > 50 >>> 0) {
                        N = R;
                        O = b;
                        P = Q;
                        i = 47;
                        break
                    }
                    l = c[18936 + (g << 2) >> 2] | 0;
                    m = Q + 1 | 0;
                    n = R;
                    i = 16;
                    continue
                } else if ((i | 0) == 16) {
                    i = 0;
                    g = (d[m] | 0) >>> 3;
                    if ((g - 16 | g + (l >> 26)) >>> 0 > 7 >>> 0) { i = 17; break }
                    g = m + 1 | 0;
                    do {
                        if ((l & 33554432 | 0) == 0) { W = g } else {
                            if (((d[g] | 0) - 128 | 0) >>> 0 > 63 >>> 0) { i = 20; break a }
                            h = m + 2 | 0;
                            if ((l & 524288 | 0) == 0) { W = h; break }
                            if (((d[h] | 0) - 128 | 0) >>> 0 > 63 >>> 0) { i = 23; break a }
                            W = m + 3 | 0
                        }
                    } while (0);
                    s = W;
                    t = n - 1 | 0;
                    i = 7;
                    continue
                } else if ((i | 0) == 36) {
                    i = 0;
                    g = d[p] | 0;
                    h = g >>> 3;
                    if ((h - 16 | h + (o >> 26)) >>> 0 > 7 >>> 0) { i = 37; break }
                    h = p + 1 | 0;
                    X = g - 128 | o << 6;
                    do {
                        if ((X | 0) < 0) {
                            g = (d[h] | 0) - 128 | 0;
                            if (g >>> 0 > 63 >>> 0) { i = 40; break a }
                            k = p + 2 | 0;
                            Y = g | X << 6;
                            if ((Y | 0) >= 0) {
                                Z = Y;
                                _ = k;
                                break
                            }
                            g = (d[k] | 0) - 128 | 0;
                            if (g >>> 0 > 63 >>> 0) { i = 43; break a }
                            Z = g | Y << 6;
                            _ = p + 3 | 0
                        } else {
                            Z = X;
                            _ = h
                        }
                    } while (0);
                    c[q >> 2] = Z;
                    u = _;
                    v = q + 4 | 0;
                    w = r - 1 | 0;
                    i = 6;
                    continue
                }
            }
            if ((i | 0) == 17) {
                $ = l;
                aa = m - 1 | 0;
                ba = b;
                ca = n;
                i = 46
            } else if ((i | 0) == 20) {
                $ = l;
                aa = m - 1 | 0;
                ba = b;
                ca = n;
                i = 46
            } else if ((i | 0) == 23) {
                $ = l;
                aa = m - 1 | 0;
                ba = b;
                ca = n;
                i = 46
            } else if ((i | 0) == 37) {
                $ = o;
                aa = p - 1 | 0;
                ba = q;
                ca = r;
                i = 46
            } else if ((i | 0) == 40) {
                $ = X;
                aa = p - 1 | 0;
                ba = q;
                ca = r;
                i = 46
            } else if ((i | 0) == 43) {
                $ = Y;
                aa = p - 1 | 0;
                ba = q;
                ca = r;
                i = 46
            } else if ((i | 0) == 53) { return x | 0 }
            if ((i | 0) == 46) {
                if (($ | 0) == 0) {
                    N = ca;
                    O = ba;
                    P = aa;
                    i = 47
                } else {
                    da = ba;
                    ea = aa
                }
            }
            do {
                if ((i | 0) == 47) {
                    if ((a[P] | 0) != 0) {
                        da = O;
                        ea = P;
                        break
                    }
                    if ((O | 0) != 0) {
                        c[O >> 2] = 0;
                        c[e >> 2] = 0
                    }
                    x = f - N | 0;
                    return x | 0
                }
            } while (0);
            N = Vb() | 0;
            c[N >> 2] = 84;
            if ((da | 0) == 0) { x = -1; return x | 0 }
            c[e >> 2] = ea;
            x = -1;
            return x | 0
        }

        function cu(b, e, f) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            g = i;
            i = i + 8 | 0;
            h = g | 0;
            c[h >> 2] = b;
            if ((e | 0) == 0) {
                j = 0;
                i = g;
                return j | 0
            }
            do {
                if ((f | 0) != 0) {
                    if ((b | 0) == 0) {
                        k = h;
                        c[h >> 2] = k;
                        l = k
                    } else { l = b }
                    k = a[e] | 0;
                    m = k & 255;
                    if (k << 24 >> 24 > -1) {
                        c[l >> 2] = m;
                        j = k << 24 >> 24 != 0 | 0;
                        i = g;
                        return j | 0
                    }
                    k = m - 194 | 0;
                    if (k >>> 0 > 50 >>> 0) { break }
                    m = e + 1 | 0;
                    n = c[18936 + (k << 2) >> 2] | 0;
                    if (f >>> 0 < 4 >>> 0) { if ((n & -2147483648 >>> (((f * 6 | 0) - 6 | 0) >>> 0) | 0) != 0) { break } }
                    k = d[m] | 0;
                    m = k >>> 3;
                    if ((m - 16 | m + (n >> 26)) >>> 0 > 7 >>> 0) { break }
                    m = k - 128 | n << 6;
                    if ((m | 0) >= 0) {
                        c[l >> 2] = m;
                        j = 2;
                        i = g;
                        return j | 0
                    }
                    n = (d[e + 2 | 0] | 0) - 128 | 0;
                    if (n >>> 0 > 63 >>> 0) { break }
                    k = n | m << 6;
                    if ((k | 0) >= 0) {
                        c[l >> 2] = k;
                        j = 3;
                        i = g;
                        return j | 0
                    }
                    m = (d[e + 3 | 0] | 0) - 128 | 0;
                    if (m >>> 0 > 63 >>> 0) { break }
                    c[l >> 2] = m | k << 6;
                    j = 4;
                    i = g;
                    return j | 0
                }
            } while (0);
            l = Vb() | 0;
            c[l >> 2] = 84;
            j = -1;
            i = g;
            return j | 0
        }

        function du(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            if ((b | 0) == 0) { f = 1; return f | 0 }
            if (d >>> 0 < 128 >>> 0) {
                a[b] = d;
                f = 1;
                return f | 0
            }
            if (d >>> 0 < 2048 >>> 0) {
                a[b] = d >>> 6 | 192;
                a[b + 1 | 0] = d & 63 | 128;
                f = 2;
                return f | 0
            }
            if (d >>> 0 < 55296 >>> 0 | (d - 57344 | 0) >>> 0 < 8192 >>> 0) {
                a[b] = d >>> 12 | 224;
                a[b + 1 | 0] = d >>> 6 & 63 | 128;
                a[b + 2 | 0] = d & 63 | 128;
                f = 3;
                return f | 0
            }
            if ((d - 65536 | 0) >>> 0 < 1048576 >>> 0) {
                a[b] = d >>> 18 | 240;
                a[b + 1 | 0] = d >>> 12 & 63 | 128;
                a[b + 2 | 0] = d >>> 6 & 63 | 128;
                a[b + 3 | 0] = d & 63 | 128;
                f = 4;
                return f | 0
            } else {
                d = Vb() | 0;
                c[d >> 2] = 84;
                f = -1;
                return f | 0
            }
            return 0
        }

        function eu(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0;
            f = i;
            i = i + 264 | 0;
            g = f + 256 | 0;
            h = f | 0;
            j = c[b >> 2] | 0;
            c[g >> 2] = j;
            k = (a | 0) != 0;
            l = k ? e : 256;
            e = k ? a : h;
            a: do {
                if ((j | 0) == 0 | (l | 0) == 0) {
                    m = d;
                    n = 0;
                    o = l;
                    p = e;
                    q = j
                } else {
                    a = l;
                    r = 0;
                    s = e;
                    t = d;
                    u = j;
                    while (1) {
                        v = t >>> 0 >= a >>> 0;
                        if (!(v | t >>> 0 > 32 >>> 0)) {
                            m = t;
                            n = r;
                            o = a;
                            p = s;
                            q = u;
                            break a
                        }
                        w = v ? a : t;
                        x = t - w | 0;
                        v = fu(s, g, w, 0) | 0;
                        if ((v | 0) == -1) { break }
                        if ((s | 0) == (h | 0)) {
                            y = h;
                            z = a
                        } else {
                            y = s + v | 0;
                            z = a - v | 0
                        }
                        w = v + r | 0;
                        v = c[g >> 2] | 0;
                        if ((v | 0) == 0 | (z | 0) == 0) {
                            m = x;
                            n = w;
                            o = z;
                            p = y;
                            q = v;
                            break a
                        } else {
                            a = z;
                            r = w;
                            s = y;
                            t = x;
                            u = v
                        }
                    }
                    m = x;
                    n = -1;
                    o = 0;
                    p = s;
                    q = c[g >> 2] | 0
                }
            } while (0);
            b: do {
                if ((q | 0) == 0) { A = n } else {
                    if ((o | 0) == 0 | (m | 0) == 0) { A = n; break } else {
                        B = o;
                        C = n;
                        D = p;
                        E = m;
                        F = q
                    }
                    while (1) {
                        G = du(D, c[F >> 2] | 0, 0) | 0;
                        if ((G + 1 | 0) >>> 0 < 2 >>> 0) { break }
                        x = (c[g >> 2] | 0) + 4 | 0;
                        c[g >> 2] = x;
                        y = E - 1 | 0;
                        z = C + 1 | 0;
                        if ((B | 0) == (G | 0) | (y | 0) == 0) { A = z; break b } else {
                            B = B - G | 0;
                            C = z;
                            D = D + G | 0;
                            E = y;
                            F = x
                        }
                    }
                    if ((G | 0) != 0) { A = -1; break }
                    c[g >> 2] = 0;
                    A = C
                }
            } while (0);
            if (!k) {
                H = 256;
                I = 0;
                i = f;
                return A | 0
            }
            c[b >> 2] = c[g >> 2];
            H = 256;
            I = 0;
            i = f;
            return A | 0
        }

        function fu(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            if ((b | 0) == 0) {
                h = c[d >> 2] | 0;
                j = g | 0;
                k = c[h >> 2] | 0;
                if ((k | 0) == 0) {
                    l = 0;
                    i = f;
                    return l | 0
                } else {
                    m = 0;
                    n = h;
                    o = k
                }
                while (1) {
                    if (o >>> 0 > 127 >>> 0) {
                        k = du(j, o, 0) | 0;
                        if ((k | 0) == -1) {
                            l = -1;
                            p = 26;
                            break
                        } else { q = k }
                    } else { q = 1 }
                    k = q + m | 0;
                    h = n + 4 | 0;
                    r = c[h >> 2] | 0;
                    if ((r | 0) == 0) {
                        l = k;
                        p = 26;
                        break
                    } else {
                        m = k;
                        n = h;
                        o = r
                    }
                }
                if ((p | 0) == 26) { i = f; return l | 0 }
            }
            a: do {
                if (e >>> 0 > 3 >>> 0) {
                    o = e;
                    n = b;
                    m = c[d >> 2] | 0;
                    while (1) {
                        q = c[m >> 2] | 0;
                        if ((q | 0) == 0) {
                            s = o;
                            t = n;
                            break a
                        }
                        if (q >>> 0 > 127 >>> 0) {
                            j = du(n, q, 0) | 0;
                            if ((j | 0) == -1) { l = -1; break }
                            u = n + j | 0;
                            v = o - j | 0;
                            w = m
                        } else {
                            a[n] = q;
                            u = n + 1 | 0;
                            v = o - 1 | 0;
                            w = c[d >> 2] | 0
                        }
                        q = w + 4 | 0;
                        c[d >> 2] = q;
                        if (v >>> 0 > 3 >>> 0) {
                            o = v;
                            n = u;
                            m = q
                        } else {
                            s = v;
                            t = u;
                            break a
                        }
                    }
                    i = f;
                    return l | 0
                } else {
                    s = e;
                    t = b
                }
            } while (0);
            b: do {
                if ((s | 0) == 0) { x = 0 } else {
                    b = g | 0;
                    u = s;
                    v = t;
                    w = c[d >> 2] | 0;
                    while (1) {
                        m = c[w >> 2] | 0;
                        if ((m | 0) == 0) { p = 24; break }
                        if (m >>> 0 > 127 >>> 0) {
                            n = du(b, m, 0) | 0;
                            if ((n | 0) == -1) {
                                l = -1;
                                p = 26;
                                break
                            }
                            if (n >>> 0 > u >>> 0) { p = 20; break }
                            du(v, c[w >> 2] | 0, 0) | 0;
                            y = v + n | 0;
                            z = u - n | 0;
                            A = w
                        } else {
                            a[v] = m;
                            y = v + 1 | 0;
                            z = u - 1 | 0;
                            A = c[d >> 2] | 0
                        }
                        m = A + 4 | 0;
                        c[d >> 2] = m;
                        if ((z | 0) == 0) { x = 0; break b } else {
                            u = z;
                            v = y;
                            w = m
                        }
                    }
                    if ((p | 0) == 20) {
                        l = e - u | 0;
                        i = f;
                        return l | 0
                    } else if ((p | 0) == 24) {
                        a[v] = 0;
                        x = u;
                        break
                    } else if ((p | 0) == 26) { i = f; return l | 0 }
                }
            } while (0);
            c[d >> 2] = 0;
            l = e - x | 0;
            i = f;
            return l | 0
        }

        function gu(a) {
            a = a | 0;
            var b = 0;
            b = a;
            while (1) { if ((c[b >> 2] | 0) == 0) { break } else { b = b + 4 | 0 } }
            return b - a >> 2 | 0
        }

        function hu(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0;
            if ((d | 0) == 0) { return a | 0 } else {
                e = b;
                f = d;
                g = a
            }
            while (1) {
                d = f - 1 | 0;
                c[g >> 2] = c[e >> 2];
                if ((d | 0) == 0) { break } else {
                    e = e + 4 | 0;
                    f = d;
                    g = g + 4 | 0
                }
            }
            return a | 0
        }

        function iu(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            e = (d | 0) == 0;
            if (a - b >> 2 >>> 0 < d >>> 0) {
                if (e) { return a | 0 } else { f = d }
                do {
                    f = f - 1 | 0;
                    c[a + (f << 2) >> 2] = c[b + (f << 2) >> 2];
                } while ((f | 0) != 0);
                return a | 0
            } else {
                if (e) { return a | 0 } else {
                    g = b;
                    h = d;
                    i = a
                }
                while (1) {
                    d = h - 1 | 0;
                    c[i >> 2] = c[g >> 2];
                    if ((d | 0) == 0) { break } else {
                        g = g + 4 | 0;
                        h = d;
                        i = i + 4 | 0
                    }
                }
                return a | 0
            }
            return 0
        }

        function ju(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0;
            if ((d | 0) == 0) { return a | 0 } else {
                e = d;
                f = a
            }
            while (1) {
                d = e - 1 | 0;
                c[f >> 2] = b;
                if ((d | 0) == 0) { break } else {
                    e = d;
                    f = f + 4 | 0
                }
            }
            return a | 0
        }

        function ku(a) { a = a | 0; return }

        function lu(a) {
            a = a | 0;
            c[a >> 2] = 19504;
            return
        }

        function mu(a) {
            a = a | 0;
            Pu(a);
            return
        }

        function nu(a) { a = a | 0; return }

        function ou(a) { a = a | 0; return 7128 }

        function pu(a) {
            a = a | 0;
            ku(a | 0);
            return
        }

        function qu(a) { a = a | 0; return }

        function ru(a) { a = a | 0; return }

        function su(a) {
            a = a | 0;
            ku(a | 0);
            Pu(a);
            return
        }

        function tu(a) {
            a = a | 0;
            ku(a | 0);
            Pu(a);
            return
        }

        function uu(a) {
            a = a | 0;
            ku(a | 0);
            Pu(a);
            return
        }

        function vu(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0;
            e = i;
            i = i + 56 | 0;
            f = e | 0;
            if ((a | 0) == (b | 0)) {
                g = 1;
                i = e;
                return g | 0
            }
            if ((b | 0) == 0) {
                g = 0;
                i = e;
                return g | 0
            }
            h = zu(b, 27072, 27056, 0) | 0;
            b = h;
            if ((h | 0) == 0) {
                g = 0;
                i = e;
                return g | 0
            }
            dv(f | 0, 0, 56) | 0;
            c[f >> 2] = b;
            c[f + 8 >> 2] = a;
            c[f + 12 >> 2] = -1;
            c[f + 48 >> 2] = 1;
            Wc[c[(c[h >> 2] | 0) + 28 >> 2] & 63](b, f, c[d >> 2] | 0, 1);
            if ((c[f + 24 >> 2] | 0) != 1) {
                g = 0;
                i = e;
                return g | 0
            }
            c[d >> 2] = c[f + 16 >> 2];
            g = 1;
            i = e;
            return g | 0
        }

        function wu(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0;
            if ((c[d + 8 >> 2] | 0) != (b | 0)) { return }
            b = d + 16 | 0;
            g = c[b >> 2] | 0;
            if ((g | 0) == 0) {
                c[b >> 2] = e;
                c[d + 24 >> 2] = f;
                c[d + 36 >> 2] = 1;
                return
            }
            if ((g | 0) != (e | 0)) {
                e = d + 36 | 0;
                c[e >> 2] = (c[e >> 2] | 0) + 1;
                c[d + 24 >> 2] = 2;
                a[d + 54 | 0] = 1;
                return
            }
            e = d + 24 | 0;
            if ((c[e >> 2] | 0) != 2) { return }
            c[e >> 2] = f;
            return
        }

        function xu(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0;
            if ((b | 0) != (c[d + 8 >> 2] | 0)) {
                g = c[b + 8 >> 2] | 0;
                Wc[c[(c[g >> 2] | 0) + 28 >> 2] & 63](g, d, e, f);
                return
            }
            g = d + 16 | 0;
            b = c[g >> 2] | 0;
            if ((b | 0) == 0) {
                c[g >> 2] = e;
                c[d + 24 >> 2] = f;
                c[d + 36 >> 2] = 1;
                return
            }
            if ((b | 0) != (e | 0)) {
                e = d + 36 | 0;
                c[e >> 2] = (c[e >> 2] | 0) + 1;
                c[d + 24 >> 2] = 2;
                a[d + 54 | 0] = 1;
                return
            }
            e = d + 24 | 0;
            if ((c[e >> 2] | 0) != 2) { return }
            c[e >> 2] = f;
            return
        }

        function yu(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            if ((b | 0) == (c[d + 8 >> 2] | 0)) {
                g = d + 16 | 0;
                h = c[g >> 2] | 0;
                if ((h | 0) == 0) {
                    c[g >> 2] = e;
                    c[d + 24 >> 2] = f;
                    c[d + 36 >> 2] = 1;
                    return
                }
                if ((h | 0) != (e | 0)) {
                    h = d + 36 | 0;
                    c[h >> 2] = (c[h >> 2] | 0) + 1;
                    c[d + 24 >> 2] = 2;
                    a[d + 54 | 0] = 1;
                    return
                }
                h = d + 24 | 0;
                if ((c[h >> 2] | 0) != 2) { return }
                c[h >> 2] = f;
                return
            }
            h = c[b + 12 >> 2] | 0;
            g = b + 16 + (h << 3) | 0;
            i = c[b + 20 >> 2] | 0;
            j = i >> 8;
            if ((i & 1 | 0) == 0) { k = j } else { k = c[(c[e >> 2] | 0) + j >> 2] | 0 }
            j = c[b + 16 >> 2] | 0;
            Wc[c[(c[j >> 2] | 0) + 28 >> 2] & 63](j, d, e + k | 0, (i & 2 | 0) != 0 ? f : 2);
            if ((h | 0) <= 1) { return }
            h = d + 54 | 0;
            i = e;
            k = b + 24 | 0;
            while (1) {
                b = c[k + 4 >> 2] | 0;
                j = b >> 8;
                if ((b & 1 | 0) == 0) { l = j } else { l = c[(c[i >> 2] | 0) + j >> 2] | 0 }
                j = c[k >> 2] | 0;
                Wc[c[(c[j >> 2] | 0) + 28 >> 2] & 63](j, d, e + l | 0, (b & 2 | 0) != 0 ? f : 2);
                if ((a[h] | 0) != 0) { m = 16; break }
                b = k + 8 | 0;
                if (b >>> 0 < g >>> 0) { k = b } else { m = 16; break }
            }
            if ((m | 0) == 16) { return }
        }

        function zu(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            f = i;
            i = i + 56 | 0;
            g = f | 0;
            h = c[a >> 2] | 0;
            j = a + (c[h - 8 >> 2] | 0) | 0;
            k = c[h - 4 >> 2] | 0;
            h = k;
            c[g >> 2] = d;
            c[g + 4 >> 2] = a;
            c[g + 8 >> 2] = b;
            c[g + 12 >> 2] = e;
            e = g + 16 | 0;
            b = g + 20 | 0;
            a = g + 24 | 0;
            l = g + 28 | 0;
            m = g + 32 | 0;
            n = g + 40 | 0;
            dv(e | 0, 0, 39) | 0;
            do {
                if ((k | 0) == (d | 0)) {
                    c[g + 48 >> 2] = 1;
                    Kc[c[(c[k >> 2] | 0) + 20 >> 2] & 63](h, g, j, j, 1, 0);
                    o = (c[a >> 2] | 0) == 1 ? j : 0
                } else {
                    Cc[c[(c[k >> 2] | 0) + 24 >> 2] & 31](h, g, j, 1, 0);
                    p = c[g + 36 >> 2] | 0;
                    if ((p | 0) == 0) {
                        if ((c[n >> 2] | 0) != 1) { o = 0; break }
                        if ((c[l >> 2] | 0) != 1) { o = 0; break }
                        o = (c[m >> 2] | 0) == 1 ? c[b >> 2] | 0 : 0;
                        break
                    } else if ((p | 0) != 1) { o = 0; break }
                    if ((c[a >> 2] | 0) != 1) { if ((c[n >> 2] | 0) != 0) { o = 0; break } if ((c[l >> 2] | 0) != 1) { o = 0; break } if ((c[m >> 2] | 0) != 1) { o = 0; break } }
                    o = c[e >> 2] | 0
                }
            } while (0);
            i = f;
            return o | 0
        }

        function Au(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0;
            h = b | 0;
            if ((h | 0) == (c[d + 8 >> 2] | 0)) {
                if ((c[d + 4 >> 2] | 0) != (e | 0)) { return }
                i = d + 28 | 0;
                if ((c[i >> 2] | 0) == 1) { return }
                c[i >> 2] = f;
                return
            }
            if ((h | 0) == (c[d >> 2] | 0)) {
                do {
                    if ((c[d + 16 >> 2] | 0) != (e | 0)) {
                        h = d + 20 | 0;
                        if ((c[h >> 2] | 0) == (e | 0)) { break }
                        c[d + 32 >> 2] = f;
                        i = d + 44 | 0;
                        if ((c[i >> 2] | 0) == 4) { return }
                        j = c[b + 12 >> 2] | 0;
                        k = b + 16 + (j << 3) | 0;
                        a: do {
                            if ((j | 0) > 0) {
                                l = d + 52 | 0;
                                m = d + 53 | 0;
                                n = d + 54 | 0;
                                o = b + 8 | 0;
                                p = d + 24 | 0;
                                q = e;
                                r = 0;
                                s = b + 16 | 0;
                                t = 0;
                                b: while (1) {
                                    a[l] = 0;
                                    a[m] = 0;
                                    u = c[s + 4 >> 2] | 0;
                                    v = u >> 8;
                                    if ((u & 1 | 0) == 0) { w = v } else { w = c[(c[q >> 2] | 0) + v >> 2] | 0 }
                                    v = c[s >> 2] | 0;
                                    Kc[c[(c[v >> 2] | 0) + 20 >> 2] & 63](v, d, e, e + w | 0, 2 - (u >>> 1 & 1) | 0, g);
                                    if ((a[n] | 0) != 0) {
                                        x = t;
                                        y = r;
                                        break
                                    }
                                    do {
                                        if ((a[m] | 0) == 0) {
                                            z = t;
                                            A = r
                                        } else {
                                            if ((a[l] | 0) == 0) {
                                                if ((c[o >> 2] & 1 | 0) == 0) {
                                                    x = 1;
                                                    y = r;
                                                    break b
                                                } else {
                                                    z = 1;
                                                    A = r;
                                                    break
                                                }
                                            }
                                            if ((c[p >> 2] | 0) == 1) { B = 27; break a }
                                            if ((c[o >> 2] & 2 | 0) == 0) { B = 27; break a } else {
                                                z = 1;
                                                A = 1
                                            }
                                        }
                                    } while (0);
                                    u = s + 8 | 0;
                                    if (u >>> 0 < k >>> 0) {
                                        r = A;
                                        s = u;
                                        t = z
                                    } else {
                                        x = z;
                                        y = A;
                                        break
                                    }
                                }
                                if (y) {
                                    C = x;
                                    B = 26
                                } else {
                                    D = x;
                                    B = 23
                                }
                            } else {
                                D = 0;
                                B = 23
                            }
                        } while (0);
                        do {
                            if ((B | 0) == 23) {
                                c[h >> 2] = e;
                                k = d + 40 | 0;
                                c[k >> 2] = (c[k >> 2] | 0) + 1;
                                if ((c[d + 36 >> 2] | 0) != 1) {
                                    C = D;
                                    B = 26;
                                    break
                                }
                                if ((c[d + 24 >> 2] | 0) != 2) {
                                    C = D;
                                    B = 26;
                                    break
                                }
                                a[d + 54 | 0] = 1;
                                if (D) { B = 27 } else { B = 28 }
                            }
                        } while (0);
                        if ((B | 0) == 26) { if (C) { B = 27 } else { B = 28 } }
                        if ((B | 0) == 27) { c[i >> 2] = 3; return } else if ((B | 0) == 28) { c[i >> 2] = 4; return }
                    }
                } while (0);
                if ((f | 0) != 1) { return }
                c[d + 32 >> 2] = 1;
                return
            }
            C = c[b + 12 >> 2] | 0;
            D = b + 16 + (C << 3) | 0;
            x = c[b + 20 >> 2] | 0;
            y = x >> 8;
            if ((x & 1 | 0) == 0) { E = y } else { E = c[(c[e >> 2] | 0) + y >> 2] | 0 }
            y = c[b + 16 >> 2] | 0;
            Cc[c[(c[y >> 2] | 0) + 24 >> 2] & 31](y, d, e + E | 0, (x & 2 | 0) != 0 ? f : 2, g);
            x = b + 24 | 0;
            if ((C | 0) <= 1) { return }
            C = c[b + 8 >> 2] | 0;
            do {
                if ((C & 2 | 0) == 0) {
                    b = d + 36 | 0;
                    if ((c[b >> 2] | 0) == 1) { break }
                    if ((C & 1 | 0) == 0) {
                        E = d + 54 | 0;
                        y = e;
                        A = x;
                        while (1) {
                            if ((a[E] | 0) != 0) { B = 53; break }
                            if ((c[b >> 2] | 0) == 1) { B = 53; break }
                            z = c[A + 4 >> 2] | 0;
                            w = z >> 8;
                            if ((z & 1 | 0) == 0) { F = w } else { F = c[(c[y >> 2] | 0) + w >> 2] | 0 }
                            w = c[A >> 2] | 0;
                            Cc[c[(c[w >> 2] | 0) + 24 >> 2] & 31](w, d, e + F | 0, (z & 2 | 0) != 0 ? f : 2, g);
                            z = A + 8 | 0;
                            if (z >>> 0 < D >>> 0) { A = z } else { B = 53; break }
                        }
                        if ((B | 0) == 53) { return }
                    }
                    A = d + 24 | 0;
                    y = d + 54 | 0;
                    E = e;
                    i = x;
                    while (1) {
                        if ((a[y] | 0) != 0) { B = 53; break }
                        if ((c[b >> 2] | 0) == 1) { if ((c[A >> 2] | 0) == 1) { B = 53; break } }
                        z = c[i + 4 >> 2] | 0;
                        w = z >> 8;
                        if ((z & 1 | 0) == 0) { G = w } else { G = c[(c[E >> 2] | 0) + w >> 2] | 0 }
                        w = c[i >> 2] | 0;
                        Cc[c[(c[w >> 2] | 0) + 24 >> 2] & 31](w, d, e + G | 0, (z & 2 | 0) != 0 ? f : 2, g);
                        z = i + 8 | 0;
                        if (z >>> 0 < D >>> 0) { i = z } else { B = 53; break }
                    }
                    if ((B | 0) == 53) { return }
                }
            } while (0);
            G = d + 54 | 0;
            F = e;
            C = x;
            while (1) {
                if ((a[G] | 0) != 0) { B = 53; break }
                x = c[C + 4 >> 2] | 0;
                i = x >> 8;
                if ((x & 1 | 0) == 0) { H = i } else { H = c[(c[F >> 2] | 0) + i >> 2] | 0 }
                i = c[C >> 2] | 0;
                Cc[c[(c[i >> 2] | 0) + 24 >> 2] & 31](i, d, e + H | 0, (x & 2 | 0) != 0 ? f : 2, g);
                x = C + 8 | 0;
                if (x >>> 0 < D >>> 0) { C = x } else { B = 53; break }
            }
            if ((B | 0) == 53) { return }
        }

        function Bu(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            h = b | 0;
            if ((h | 0) == (c[d + 8 >> 2] | 0)) {
                if ((c[d + 4 >> 2] | 0) != (e | 0)) { return }
                i = d + 28 | 0;
                if ((c[i >> 2] | 0) == 1) { return }
                c[i >> 2] = f;
                return
            }
            if ((h | 0) != (c[d >> 2] | 0)) {
                h = c[b + 8 >> 2] | 0;
                Cc[c[(c[h >> 2] | 0) + 24 >> 2] & 31](h, d, e, f, g);
                return
            }
            do {
                if ((c[d + 16 >> 2] | 0) != (e | 0)) {
                    h = d + 20 | 0;
                    if ((c[h >> 2] | 0) == (e | 0)) { break }
                    c[d + 32 >> 2] = f;
                    i = d + 44 | 0;
                    if ((c[i >> 2] | 0) == 4) { return }
                    j = d + 52 | 0;
                    a[j] = 0;
                    k = d + 53 | 0;
                    a[k] = 0;
                    l = c[b + 8 >> 2] | 0;
                    Kc[c[(c[l >> 2] | 0) + 20 >> 2] & 63](l, d, e, e, 1, g);
                    if ((a[k] | 0) == 0) {
                        m = 0;
                        n = 13
                    } else {
                        if ((a[j] | 0) == 0) {
                            m = 1;
                            n = 13
                        }
                    }
                    a: do {
                        if ((n | 0) == 13) {
                            c[h >> 2] = e;
                            j = d + 40 | 0;
                            c[j >> 2] = (c[j >> 2] | 0) + 1;
                            do {
                                if ((c[d + 36 >> 2] | 0) == 1) {
                                    if ((c[d + 24 >> 2] | 0) != 2) { n = 16; break }
                                    a[d + 54 | 0] = 1;
                                    if (m) { break a }
                                } else { n = 16 }
                            } while (0);
                            if ((n | 0) == 16) { if (m) { break } }
                            c[i >> 2] = 4;
                            return
                        }
                    } while (0);
                    c[i >> 2] = 3;
                    return
                }
            } while (0);
            if ((f | 0) != 1) { return }
            c[d + 32 >> 2] = 1;
            return
        }

        function Cu(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            if ((c[d + 8 >> 2] | 0) == (b | 0)) {
                if ((c[d + 4 >> 2] | 0) != (e | 0)) { return }
                g = d + 28 | 0;
                if ((c[g >> 2] | 0) == 1) { return }
                c[g >> 2] = f;
                return
            }
            if ((c[d >> 2] | 0) != (b | 0)) { return }
            do {
                if ((c[d + 16 >> 2] | 0) != (e | 0)) {
                    b = d + 20 | 0;
                    if ((c[b >> 2] | 0) == (e | 0)) { break }
                    c[d + 32 >> 2] = f;
                    c[b >> 2] = e;
                    b = d + 40 | 0;
                    c[b >> 2] = (c[b >> 2] | 0) + 1;
                    do {
                        if ((c[d + 36 >> 2] | 0) == 1) {
                            if ((c[d + 24 >> 2] | 0) != 2) { break }
                            a[d + 54 | 0] = 1
                        }
                    } while (0);
                    c[d + 44 >> 2] = 4;
                    return
                }
            } while (0);
            if ((f | 0) != 1) { return }
            c[d + 32 >> 2] = 1;
            return
        }

        function Du(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            if ((b | 0) != (c[d + 8 >> 2] | 0)) {
                i = d + 52 | 0;
                j = a[i] | 0;
                k = d + 53 | 0;
                l = a[k] | 0;
                m = c[b + 12 >> 2] | 0;
                n = b + 16 + (m << 3) | 0;
                a[i] = 0;
                a[k] = 0;
                o = c[b + 20 >> 2] | 0;
                p = o >> 8;
                if ((o & 1 | 0) == 0) { q = p } else { q = c[(c[f >> 2] | 0) + p >> 2] | 0 }
                p = c[b + 16 >> 2] | 0;
                Kc[c[(c[p >> 2] | 0) + 20 >> 2] & 63](p, d, e, f + q | 0, (o & 2 | 0) != 0 ? g : 2, h);
                a: do {
                    if ((m | 0) > 1) {
                        o = d + 24 | 0;
                        q = b + 8 | 0;
                        p = d + 54 | 0;
                        r = f;
                        s = b + 24 | 0;
                        do {
                            if ((a[p] | 0) != 0) { break a }
                            do { if ((a[i] | 0) == 0) { if ((a[k] | 0) == 0) { break } if ((c[q >> 2] & 1 | 0) == 0) { break a } } else { if ((c[o >> 2] | 0) == 1) { break a } if ((c[q >> 2] & 2 | 0) == 0) { break a } } } while (0);
                            a[i] = 0;
                            a[k] = 0;
                            t = c[s + 4 >> 2] | 0;
                            u = t >> 8;
                            if ((t & 1 | 0) == 0) { v = u } else { v = c[(c[r >> 2] | 0) + u >> 2] | 0 }
                            u = c[s >> 2] | 0;
                            Kc[c[(c[u >> 2] | 0) + 20 >> 2] & 63](u, d, e, f + v | 0, (t & 2 | 0) != 0 ? g : 2, h);
                            s = s + 8 | 0;
                        } while (s >>> 0 < n >>> 0)
                    }
                } while (0);
                a[i] = j;
                a[k] = l;
                return
            }
            a[d + 53 | 0] = 1;
            if ((c[d + 4 >> 2] | 0) != (f | 0)) { return }
            a[d + 52 | 0] = 1;
            f = d + 16 | 0;
            l = c[f >> 2] | 0;
            if ((l | 0) == 0) {
                c[f >> 2] = e;
                c[d + 24 >> 2] = g;
                c[d + 36 >> 2] = 1;
                if (!((c[d + 48 >> 2] | 0) == 1 & (g | 0) == 1)) { return }
                a[d + 54 | 0] = 1;
                return
            }
            if ((l | 0) != (e | 0)) {
                e = d + 36 | 0;
                c[e >> 2] = (c[e >> 2] | 0) + 1;
                a[d + 54 | 0] = 1;
                return
            }
            e = d + 24 | 0;
            l = c[e >> 2] | 0;
            if ((l | 0) == 2) {
                c[e >> 2] = g;
                w = g
            } else { w = l }
            if (!((c[d + 48 >> 2] | 0) == 1 & (w | 0) == 1)) { return }
            a[d + 54 | 0] = 1;
            return
        }

        function Eu(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0;
            if ((b | 0) != (c[d + 8 >> 2] | 0)) {
                i = c[b + 8 >> 2] | 0;
                Kc[c[(c[i >> 2] | 0) + 20 >> 2] & 63](i, d, e, f, g, h);
                return
            }
            a[d + 53 | 0] = 1;
            if ((c[d + 4 >> 2] | 0) != (f | 0)) { return }
            a[d + 52 | 0] = 1;
            f = d + 16 | 0;
            h = c[f >> 2] | 0;
            if ((h | 0) == 0) {
                c[f >> 2] = e;
                c[d + 24 >> 2] = g;
                c[d + 36 >> 2] = 1;
                if (!((c[d + 48 >> 2] | 0) == 1 & (g | 0) == 1)) { return }
                a[d + 54 | 0] = 1;
                return
            }
            if ((h | 0) != (e | 0)) {
                e = d + 36 | 0;
                c[e >> 2] = (c[e >> 2] | 0) + 1;
                a[d + 54 | 0] = 1;
                return
            }
            e = d + 24 | 0;
            h = c[e >> 2] | 0;
            if ((h | 0) == 2) {
                c[e >> 2] = g;
                j = g
            } else { j = h }
            if (!((c[d + 48 >> 2] | 0) == 1 & (j | 0) == 1)) { return }
            a[d + 54 | 0] = 1;
            return
        }

        function Fu(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0;
            if ((c[d + 8 >> 2] | 0) != (b | 0)) { return }
            a[d + 53 | 0] = 1;
            if ((c[d + 4 >> 2] | 0) != (f | 0)) { return }
            a[d + 52 | 0] = 1;
            f = d + 16 | 0;
            b = c[f >> 2] | 0;
            if ((b | 0) == 0) {
                c[f >> 2] = e;
                c[d + 24 >> 2] = g;
                c[d + 36 >> 2] = 1;
                if (!((c[d + 48 >> 2] | 0) == 1 & (g | 0) == 1)) { return }
                a[d + 54 | 0] = 1;
                return
            }
            if ((b | 0) != (e | 0)) {
                e = d + 36 | 0;
                c[e >> 2] = (c[e >> 2] | 0) + 1;
                a[d + 54 | 0] = 1;
                return
            }
            e = d + 24 | 0;
            b = c[e >> 2] | 0;
            if ((b | 0) == 2) {
                c[e >> 2] = g;
                i = g
            } else { i = b }
            if (!((c[d + 48 >> 2] | 0) == 1 & (i | 0) == 1)) { return }
            a[d + 54 | 0] = 1;
            return
        }



        function mg(c, d, f, g, h) {
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0;
            j = i;
            i = i + 2048 | 0;
            k = j | 0;
            l = 20 - h | 0;
            m = 1 << l - 1;
            if ((f | 0) > 1) {
                n = f;
                o = 0;
                while (1) {
                    p = o + 1 | 0;
                    q = n >> 1;
                    if ((q | 0) > 1) {
                        n = q;
                        o = p
                    } else { r = p; break }
                }
            } else { r = 0 }
            o = 5 - r | 0;
            r = (f | 0) > 0;
            if (r) { s = 0 } else {
                t = 2048;
                u = 0;
                i = j;
                return
            }
            do {
                n = f;
                while (1) {
                    v = n - 1 | 0;
                    if ((n | 0) <= 0) { break }
                    p = g + ((ga(v, f) | 0) + s << 1) | 0;
                    if ((b[p >> 1] | 0) == 0) { n = v } else { break }
                }
                p = (n | 0) < 1;
                q = 0;
                do {
                    if (p) {
                        w = 0;
                        x = 13
                    } else {
                        y = 0;
                        z = 0;
                        while (1) {
                            A = g + ((ga(z, f) | 0) + s << 1) | 0;
                            B = (ga(b[A >> 1] | 0, a[27616 + (z << o << 5) + q | 0] | 0) | 0) + y | 0;
                            if ((z | 0) < (v | 0)) {
                                y = B;
                                z = z + 1 | 0
                            } else { break }
                        }
                        z = B + 64 >> 7;
                        if ((z | 0) < -32768) { C = -32768 } else {
                            w = z;
                            x = 13
                        }
                    }
                    if ((x | 0) == 13) {
                        x = 0;
                        C = (w | 0) > 32767 ? 32767 : w & 65535
                    }
                    z = k + ((ga(q, f) | 0) + s << 1) | 0;
                    b[z >> 1] = C;
                    q = q + 1 | 0;
                } while ((q | 0) < (f | 0));
                s = s + 1 | 0;
            } while ((s | 0) < (f | 0));
            if (!r) {
                t = 2048;
                u = 0;
                i = j;
                return
            }
            r = (1 << h) - 1 | 0;
            h = 0;
            do {
                s = ga(h, f) | 0;
                C = f;
                while (1) { D = C - 1 | 0; if ((C | 0) <= 0) { break } if ((b[k + (D + s << 1) >> 1] | 0) == 0) { C = D } else { break } }
                w = (C | 0) < 1;
                x = ga(h, d) | 0;
                B = 0;
                do {
                    if (w) { E = 0 } else {
                        v = 0;
                        g = 0;
                        while (1) {
                            q = (ga(b[k + (g + s << 1) >> 1] | 0, a[27616 + (g << o << 5) + B | 0] | 0) | 0) + v | 0;
                            if ((g | 0) < (D | 0)) {
                                v = q;
                                g = g + 1 | 0
                            } else { E = q; break }
                        }
                    }
                    g = c + (B + x << 1) | 0;
                    v = (e[g >> 1] | 0) + (E + m >> l) | 0;
                    if ((v | 0) < 0) { F = 0 } else { F = ((v | 0) > (r | 0) ? r : v) & 65535 }
                    b[g >> 1] = F;
                    B = B + 1 | 0;
                } while ((B | 0) < (f | 0));
                h = h + 1 | 0;
            } while ((h | 0) < (f | 0));
            t = 2048;
            u = 0;
            i = j;
            return
        }

        function ng(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            mg(a, c, 8, b, d);
            return
        }

        function og(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            mg(a, c, 16, b, d);
            return
        }

        function pg(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            mg(a, c, 32, b, d);
            return
        }

        function qg(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            rg(a, 4, b, c);
            return
        }

        function rg(c, d, e, f) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0;
            g = i;
            i = i + 2048 | 0;
            h = g | 0;
            if ((d | 0) > 1) {
                j = d;
                k = 0;
                while (1) {
                    l = j >> 1;
                    if ((l | 0) > 1) {
                        j = l;
                        k = k + 1 | 0
                    } else {
                        m = d;
                        n = 0;
                        break
                    }
                }
                while (1) {
                    j = m >> 1;
                    if ((j | 0) > 1) {
                        m = j;
                        n = n + 1 | 0
                    } else { break }
                }
                m = n + 7 | 0;
                j = 1 << k - 1;
                l = 1 << n + 6;
                n = d;
                o = 0;
                while (1) {
                    p = o + 1 | 0;
                    q = n >> 1;
                    if ((q | 0) > 1) {
                        n = q;
                        o = p
                    } else {
                        r = p;
                        s = k;
                        t = m;
                        u = j;
                        v = l;
                        break
                    }
                }
            } else {
                r = 0;
                s = -1;
                t = 6;
                u = 0;
                v = 32
            }
            l = 5 - r | 0;
            r = (d | 0) > 0;
            if (r) { w = 0 } else {
                x = 2048;
                y = 0;
                i = g;
                return
            }
            do {
                j = 0;
                do {
                    m = j << l;
                    k = 0;
                    o = 0;
                    do {
                        n = e + ((ga(o, f) | 0) + w << 1) | 0;
                        k = (ga(b[n >> 1] | 0, a[27616 + (m << 5) + o | 0] | 0) | 0) + k | 0;
                        o = o + 1 | 0;
                    } while ((o | 0) < (d | 0));
                    o = h + ((ga(j, d) | 0) + w << 1) | 0;
                    b[o >> 1] = k + u >> s;
                    j = j + 1 | 0;
                } while ((j | 0) < (d | 0));
                w = w + 1 | 0;
            } while ((w | 0) < (d | 0));
            if (r) { z = 0 } else {
                x = 2048;
                y = 0;
                i = g;
                return
            }
            do {
                r = ga(z, d) | 0;
                w = 0;
                do {
                    s = w << l;
                    u = 0;
                    f = 0;
                    do {
                        u = (ga(b[h + (f + r << 1) >> 1] | 0, a[27616 + (s << 5) + f | 0] | 0) | 0) + u | 0;
                        f = f + 1 | 0;
                    } while ((f | 0) < (d | 0));
                    b[c + (w + r << 1) >> 1] = u + v >> t;
                    w = w + 1 | 0;
                } while ((w | 0) < (d | 0));
                z = z + 1 | 0;
            } while ((z | 0) < (d | 0));
            x = 2048;
            y = 0;
            i = g;
            return
        }

        function sg(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            rg(a, 8, b, c);
            return
        }

        function tg(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            rg(a, 16, b, c);
            return
        }

        function ug(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            rg(a, 32, b, c);
            return
        }

        function vg(a, c, d, e) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0;
            f = i;
            i = i + 2176 | 0;
            g = f | 0;
            h = (c | 0) > 0;
            if (!h) {
                j = 64;
                k = 0;
                l = 64;
                m = 0;
                n = 2048;
                o = 0;
                i = f;
                return
            }
            p = c >> 1;
            q = (p | 0) > 0;
            r = c >> 2;
            s = (r | 0) > 1;
            t = f + 2048 | 0;
            u = f + 2112 | 0;
            v = 0;
            while (1) {
                w = ga(v, e) | 0;
                if (q) {
                    x = 0;
                    do {
                        y = d + (x + w << 1) | 0;
                        z = x + p | 0;
                        A = d + (z + w << 1) | 0;
                        b[t + (x << 1) >> 1] = (b[A >> 1] | 0) + (b[y >> 1] | 0);
                        b[t + (z << 1) >> 1] = (b[y >> 1] | 0) - (b[A >> 1] | 0);
                        x = x + 1 | 0;
                    } while ((x | 0) < (p | 0))
                }
                if (s) {
                    x = t;
                    w = u;
                    A = p;
                    y = r;
                    while (1) {
                        z = (y | 0) > 0;
                        B = 0;
                        do {
                            if (z) {
                                C = 0;
                                do {
                                    D = C + B | 0;
                                    E = b[x + (D << 1) >> 1] | 0;
                                    F = D + y | 0;
                                    G = b[x + (F << 1) >> 1] | 0;
                                    b[w + (D << 1) >> 1] = G + E;
                                    b[w + (F << 1) >> 1] = E - G;
                                    C = C + 1 | 0;
                                } while ((C | 0) < (y | 0))
                            }
                            B = B + A | 0;
                        } while ((B | 0) < (c | 0));
                        B = y >> 1;
                        if ((B | 0) > 1) {
                            z = x;
                            x = w;
                            A = A >> 1;
                            y = B;
                            w = z
                        } else {
                            H = w;
                            I = x;
                            break
                        }
                    }
                } else {
                    H = t;
                    I = u
                }
                x = ga(v, c) | 0;
                w = 0;
                do {
                    y = H + (w << 1) | 0;
                    A = w | 1;
                    z = H + (A << 1) | 0;
                    b[g + (w + x << 1) >> 1] = (b[z >> 1] | 0) + (b[y >> 1] | 0);
                    b[g + (A + x << 1) >> 1] = (b[y >> 1] | 0) - (b[z >> 1] | 0);
                    w = w + 2 | 0;
                } while ((w | 0) < (c | 0));
                w = v + 1 | 0;
                if ((w | 0) < (c | 0)) {
                    t = H;
                    u = I;
                    v = w
                } else { break }
            }
            if (!h) {
                j = 64;
                k = 0;
                l = 64;
                m = 0;
                n = 2048;
                o = 0;
                i = f;
                return
            }
            h = c >> 1;
            v = (h | 0) > 0;
            u = c >> 2;
            t = (u | 0) > 1;
            r = H;
            H = I;
            I = 0;
            while (1) {
                if (v) {
                    p = 0;
                    do {
                        s = g + ((ga(p, c) | 0) + I << 1) | 0;
                        d = p + h | 0;
                        q = g + ((ga(d, c) | 0) + I << 1) | 0;
                        b[r + (p << 1) >> 1] = (b[q >> 1] | 0) + (b[s >> 1] | 0);
                        b[r + (d << 1) >> 1] = (b[s >> 1] | 0) - (b[q >> 1] | 0);
                        p = p + 1 | 0;
                    } while ((p | 0) < (h | 0))
                }
                if (t) {
                    p = r;
                    q = H;
                    s = h;
                    d = u;
                    while (1) {
                        e = (d | 0) > 0;
                        w = 0;
                        do {
                            if (e) {
                                x = 0;
                                do {
                                    z = x + w | 0;
                                    y = b[p + (z << 1) >> 1] | 0;
                                    A = z + d | 0;
                                    B = b[p + (A << 1) >> 1] | 0;
                                    b[q + (z << 1) >> 1] = B + y;
                                    b[q + (A << 1) >> 1] = y - B;
                                    x = x + 1 | 0;
                                } while ((x | 0) < (d | 0))
                            }
                            w = w + s | 0;
                        } while ((w | 0) < (c | 0));
                        w = d >> 1;
                        if ((w | 0) > 1) {
                            e = p;
                            p = q;
                            s = s >> 1;
                            d = w;
                            q = e
                        } else {
                            J = q;
                            K = p;
                            break
                        }
                    }
                } else {
                    J = r;
                    K = H
                }
                p = 0;
                do {
                    q = J + (p << 1) | 0;
                    d = p | 1;
                    s = J + (d << 1) | 0;
                    e = a + ((ga(p, c) | 0) + I << 1) | 0;
                    b[e >> 1] = (b[s >> 1] | 0) + (b[q >> 1] | 0);
                    e = a + ((ga(d, c) | 0) + I << 1) | 0;
                    b[e >> 1] = (b[q >> 1] | 0) - (b[s >> 1] | 0);
                    p = p + 2 | 0;
                } while ((p | 0) < (c | 0));
                p = I + 1 | 0;
                if ((p | 0) < (c | 0)) {
                    r = J;
                    H = K;
                    I = p
                } else { break }
            }
            j = 64;
            k = 0;
            l = 64;
            m = 0;
            n = 2048;
            o = 0;
            i = f;
            return
        }

        function wg(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            e = i;
            i = i + 32 | 0;
            f = e | 0;
            g = b[c >> 1] | 0;
            h = b[c + 4 >> 1] | 0;
            j = h + g & 65535;
            k = b[c + 2 >> 1] | 0;
            l = b[c + 6 >> 1] | 0;
            m = l + k & 65535;
            n = g - h & 65535;
            h = k - l & 65535;
            l = f | 0;
            b[l >> 1] = m + j;
            k = f + 2 | 0;
            b[k >> 1] = j - m;
            m = f + 4 | 0;
            b[m >> 1] = h + n;
            j = f + 6 | 0;
            b[j >> 1] = n - h;
            h = b[c + (d << 1) >> 1] | 0;
            n = b[c + (d + 2 << 1) >> 1] | 0;
            g = n + h & 65535;
            o = b[c + (d + 1 << 1) >> 1] | 0;
            p = b[c + (d + 3 << 1) >> 1] | 0;
            q = p + o & 65535;
            r = h - n & 65535;
            n = o - p & 65535;
            p = q + g & 65535;
            b[f + 8 >> 1] = p;
            o = g - q & 65535;
            b[f + 10 >> 1] = o;
            q = f + 12 | 0;
            b[q >> 1] = n + r;
            g = f + 14 | 0;
            b[g >> 1] = r - n;
            n = d << 1;
            r = b[c + (n << 1) >> 1] | 0;
            h = b[c + (n + 2 << 1) >> 1] | 0;
            s = h + r & 65535;
            t = b[c + ((n | 1) << 1) >> 1] | 0;
            u = b[c + (n + 3 << 1) >> 1] | 0;
            n = u + t & 65535;
            v = r - h & 65535;
            h = t - u & 65535;
            u = n + s & 65535;
            b[f + 16 >> 1] = u;
            t = s - n & 65535;
            b[f + 18 >> 1] = t;
            n = h + v & 65535;
            b[f + 20 >> 1] = n;
            s = v - h & 65535;
            b[f + 22 >> 1] = s;
            h = d * 3 | 0;
            d = b[c + (h << 1) >> 1] | 0;
            v = b[c + (h + 2 << 1) >> 1] | 0;
            r = v + d & 65535;
            w = b[c + (h + 1 << 1) >> 1] | 0;
            x = b[c + (h + 3 << 1) >> 1] | 0;
            h = x + w & 65535;
            c = d - v & 65535;
            v = w - x & 65535;
            x = h + r & 65535;
            b[f + 24 >> 1] = x;
            w = r - h & 65535;
            b[f + 26 >> 1] = w;
            h = v + c & 65535;
            b[f + 28 >> 1] = h;
            r = c - v & 65535;
            b[f + 30 >> 1] = r;
            f = b[l >> 1] | 0;
            l = u + f & 65535;
            v = x + p & 65535;
            c = f - u & 65535;
            u = p - x & 65535;
            b[a >> 1] = v + l;
            b[a + 8 >> 1] = l - v;
            b[a + 16 >> 1] = u + c;
            b[a + 24 >> 1] = c - u;
            u = b[k >> 1] | 0;
            k = t + u & 65535;
            c = w + o & 65535;
            v = u - t & 65535;
            t = o - w & 65535;
            b[a + 2 >> 1] = c + k;
            b[a + 10 >> 1] = k - c;
            b[a + 18 >> 1] = t + v;
            b[a + 26 >> 1] = v - t;
            t = b[m >> 1] | 0;
            m = n + t & 65535;
            v = b[q >> 1] | 0;
            q = h + v & 65535;
            c = t - n & 65535;
            n = v - h & 65535;
            b[a + 4 >> 1] = q + m;
            b[a + 12 >> 1] = m - q;
            b[a + 20 >> 1] = n + c;
            b[a + 28 >> 1] = c - n;
            n = b[j >> 1] | 0;
            j = s + n & 65535;
            c = b[g >> 1] | 0;
            g = r + c & 65535;
            q = n - s & 65535;
            s = c - r & 65535;
            b[a + 6 >> 1] = g + j;
            b[a + 14 >> 1] = j - g;
            b[a + 22 >> 1] = s + q;
            b[a + 30 >> 1] = q - s;
            i = e;
            return
        }

        function xg(a, c, d) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0;
            e = i;
            i = i + 128 | 0;
            f = e | 0;
            g = 0;
            while (1) {
                h = ga(g, d) | 0;
                j = b[c + (h << 1) >> 1] | 0;
                k = b[c + (h + 4 << 1) >> 1] | 0;
                l = k + j & 65535;
                m = b[c + (h + 1 << 1) >> 1] | 0;
                n = b[c + (h + 5 << 1) >> 1] | 0;
                o = n + m & 65535;
                p = b[c + (h + 2 << 1) >> 1] | 0;
                q = b[c + (h + 6 << 1) >> 1] | 0;
                r = q + p & 65535;
                s = b[c + (h + 3 << 1) >> 1] | 0;
                t = b[c + (h + 7 << 1) >> 1] | 0;
                h = t + s & 65535;
                u = j - k & 65535;
                k = m - n & 65535;
                n = p - q & 65535;
                q = s - t & 65535;
                t = r + l & 65535;
                s = h + o & 65535;
                p = l - r & 65535;
                r = o - h & 65535;
                h = n + u & 65535;
                o = q + k & 65535;
                l = u - n & 65535;
                n = k - q & 65535;
                q = g << 3;
                b[f + (q << 1) >> 1] = s + t;
                b[f + ((q | 1) << 1) >> 1] = t - s;
                b[f + ((q | 2) << 1) >> 1] = r + p;
                b[f + ((q | 3) << 1) >> 1] = p - r;
                b[f + ((q | 4) << 1) >> 1] = o + h;
                b[f + ((q | 5) << 1) >> 1] = h - o;
                b[f + ((q | 6) << 1) >> 1] = n + l;
                b[f + ((q | 7) << 1) >> 1] = l - n;
                n = g + 1 | 0;
                if ((n | 0) < 8) { g = n } else { v = 0; break }
            }
            do {
                g = b[f + (v << 1) >> 1] | 0;
                c = v + 32 | 0;
                d = b[f + (c << 1) >> 1] | 0;
                n = d + g & 65535;
                l = v + 8 | 0;
                q = b[f + (l << 1) >> 1] | 0;
                o = v + 40 | 0;
                h = b[f + (o << 1) >> 1] | 0;
                r = h + q & 65535;
                p = v + 16 | 0;
                s = b[f + (p << 1) >> 1] | 0;
                t = v + 48 | 0;
                k = b[f + (t << 1) >> 1] | 0;
                u = k + s & 65535;
                m = v + 24 | 0;
                j = b[f + (m << 1) >> 1] | 0;
                w = v + 56 | 0;
                x = b[f + (w << 1) >> 1] | 0;
                y = x + j & 65535;
                z = g - d & 65535;
                d = q - h & 65535;
                h = s - k & 65535;
                k = j - x & 65535;
                x = u + n & 65535;
                j = y + r & 65535;
                s = n - u & 65535;
                u = r - y & 65535;
                y = h + z & 65535;
                r = k + d & 65535;
                n = z - h & 65535;
                h = d - k & 65535;
                b[a + (v << 1) >> 1] = j + x;
                b[a + (l << 1) >> 1] = x - j;
                b[a + (p << 1) >> 1] = u + s;
                b[a + (m << 1) >> 1] = s - u;
                b[a + (c << 1) >> 1] = r + y;
                b[a + (o << 1) >> 1] = y - r;
                b[a + (t << 1) >> 1] = h + n;
                b[a + (w << 1) >> 1] = n - h;
                v = v + 1 | 0;
            } while ((v | 0) < 8);
            i = e;
            return
        }

        function yg(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            vg(a, 16, b, c);
            return
        }

        function zg(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            vg(a, 32, b, c);
            return
        }

        function Ag(c, d, e, f, g, h) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            if ((g & 1 | 0) != 0) { ec(13704, 16192, 40, 18488) }
            if ((h | 0) > 0 & (g | 0) > 0) { i = 0 } else { return }
            do {
                j = e + ((ga(i, f) | 0) << 1) | 0;
                k = c + (ga(i, d) | 0) | 0;
                l = 0;
                while (1) {
                    m = (b[j >> 1] | 0) + 32 >> 6;
                    if ((m | 0) < 0) { n = 0 } else { n = (m | 0) > 255 ? -1 : m & 255 }
                    a[k] = n;
                    m = (b[j + 2 >> 1] | 0) + 32 >> 6;
                    if ((m | 0) < 0) { o = 0 } else { o = (m | 0) > 255 ? -1 : m & 255 }
                    a[k + 1 | 0] = o;
                    m = l + 2 | 0;
                    if ((m | 0) < (g | 0)) {
                        j = j + 4 | 0;
                        k = k + 2 | 0;
                        l = m
                    } else { break }
                }
                i = i + 1 | 0;
            } while ((i | 0) < (h | 0));
            return
        }

        function Bg(c, d, e, f, g, h, i, j, k) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            if ((k | 0) <= 0) { ec(13312, 16192, 60, 18552) }
            l = 1 << k - 1;
            if ((h | 0) > 0 & (g | 0) > 0) { m = 0 } else { return }
            do {
                n = e + ((ga(m, f) | 0) << 1) | 0;
                o = c + (ga(m, d) | 0) | 0;
                p = 0;
                while (1) {
                    q = ((ga(b[n >> 1] | 0, i) | 0) + l >> k) + j | 0;
                    if ((q | 0) < 0) { r = 0 } else { r = (q | 0) > 255 ? -1 : q & 255 }
                    a[o] = r;
                    q = p + 1 | 0;
                    if ((q | 0) < (g | 0)) {
                        n = n + 2 | 0;
                        o = o + 1 | 0;
                        p = q
                    } else { break }
                }
                m = m + 1 | 0;
            } while ((m | 0) < (h | 0));
            return
        }

        function Cg(c, d, e, f, g, h, i, j, k, l, m, n) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            var o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            if ((n | 0) <= 0) { ec(13312, 16192, 80, 18456) }
            o = k + 1 + m << n;
            if ((i | 0) <= 0) { return }
            m = n + 1 | 0;
            if ((h | 0) > 0) { p = 0 } else { return }
            do {
                n = ga(p, g) | 0;
                k = e + (n << 1) | 0;
                q = f + (n << 1) | 0;
                n = c + (ga(p, d) | 0) | 0;
                r = 0;
                while (1) {
                    s = ga(b[k >> 1] | 0, j) | 0;
                    t = s + o + (ga(b[q >> 1] | 0, l) | 0) >> m;
                    if ((t | 0) < 0) { u = 0 } else { u = (t | 0) > 255 ? -1 : t & 255 }
                    a[n] = u;
                    t = r + 1 | 0;
                    if ((t | 0) < (h | 0)) {
                        k = k + 2 | 0;
                        q = q + 2 | 0;
                        n = n + 1 | 0;
                        r = t
                    } else { break }
                }
                p = p + 1 | 0;
            } while ((p | 0) < (i | 0));
            return
        }

        function Dg(c, d, e, f, g, h, i) {
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            if ((h & 1 | 0) != 0) { ec(13704, 16192, 105, 18312) }
            if ((i | 0) <= 0) { return }
            j = (h | 0) > 0;
            k = 0;
            do {
                l = ga(k, g) | 0;
                if (j) {
                    m = e + (l << 1) | 0;
                    n = f + (l << 1) | 0;
                    l = c + (ga(k, d) | 0) | 0;
                    o = 0;
                    while (1) {
                        p = (b[m >> 1] | 0) + 64 + (b[n >> 1] | 0) >> 7;
                        if ((p | 0) < 0) { q = 0 } else { q = (p | 0) > 255 ? -1 : p & 255 }
                        a[l] = q;
                        p = (b[m + 2 >> 1] | 0) + 64 + (b[n + 2 >> 1] | 0) >> 7;
                        if ((p | 0) < 0) { r = 0 } else { r = (p | 0) > 255 ? -1 : p & 255 }
                        a[l + 1 | 0] = r;
                        p = o + 2 | 0;
                        if ((p | 0) < (h | 0)) {
                            m = m + 4 | 0;
                            n = n + 4 | 0;
                            l = l + 2 | 0;
                            o = p
                        } else { break }
                    }
                }
                k = k + 1 | 0;
            } while ((k | 0) < (i | 0));
            return
        }

        function Eg(a, c, d, e, f, g, h) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            i = 14 - h | 0;
            if ((i | 0) > 0) { j = 1 << i - 1 } else { j = 0 }
            if ((f & 1 | 0) != 0) { ec(13704, 16192, 172, 18424) }
            if ((g | 0) <= 0) { return }
            k = (f | 0) > 0;
            l = (1 << h) - 1 | 0;
            h = l & 65535;
            m = 0;
            do {
                if (k) {
                    n = d + ((ga(m, e) | 0) << 1) | 0;
                    o = a + ((ga(m, c) | 0) << 1) | 0;
                    p = 0;
                    while (1) {
                        q = (b[n >> 1] | 0) + j >> i;
                        if ((q | 0) < 0) { r = 0 } else { r = (q | 0) > (l | 0) ? h : q & 65535 }
                        b[o >> 1] = r;
                        q = (b[n + 2 >> 1] | 0) + j >> i;
                        if ((q | 0) < 0) { s = 0 } else { s = (q | 0) > (l | 0) ? h : q & 65535 }
                        b[o + 2 >> 1] = s;
                        q = p + 2 | 0;
                        if ((q | 0) < (f | 0)) {
                            n = n + 4 | 0;
                            o = o + 4 | 0;
                            p = q
                        } else { break }
                    }
                }
                m = m + 1 | 0;
            } while ((m | 0) < (g | 0));
            return
        }

        function Fg(a, c, d, e, f, g, h, i, j, k) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            if ((j | 0) <= 0) { ec(13312, 16192, 193, 18520) }
            l = 1 << j - 1;
            if ((g | 0) <= 0) { return }
            m = (f | 0) > 0;
            n = (1 << k) - 1 | 0;
            k = 0;
            do {
                if (m) {
                    o = d + ((ga(k, e) | 0) << 1) | 0;
                    p = a + ((ga(k, c) | 0) << 1) | 0;
                    q = 0;
                    while (1) {
                        r = ((ga(b[o >> 1] | 0, h) | 0) + l >> j) + i | 0;
                        if ((r | 0) < 0) { s = 0 } else { s = ((r | 0) > (n | 0) ? n : r) & 65535 }
                        b[p >> 1] = s;
                        r = q + 1 | 0;
                        if ((r | 0) < (f | 0)) {
                            o = o + 2 | 0;
                            p = p + 2 | 0;
                            q = r
                        } else { break }
                    }
                }
                k = k + 1 | 0;
            } while ((k | 0) < (g | 0));
            return
        }

        function Gg(a, c, d, e, f, g, h, i, j, k, l, m, n) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            var o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            if ((m | 0) <= 0) { ec(13312, 16192, 213, 18392) }
            o = j + 1 + l << m;
            if ((h | 0) <= 0) { return }
            l = (g | 0) > 0;
            j = m + 1 | 0;
            m = (1 << n) - 1 | 0;
            n = 0;
            do {
                p = ga(n, f) | 0;
                if (l) {
                    q = d + (p << 1) | 0;
                    r = e + (p << 1) | 0;
                    p = a + ((ga(n, c) | 0) << 1) | 0;
                    s = 0;
                    while (1) {
                        t = ga(b[q >> 1] | 0, i) | 0;
                        u = t + o + (ga(b[r >> 1] | 0, k) | 0) >> j;
                        if ((u | 0) < 0) { v = 0 } else { v = ((u | 0) > (m | 0) ? m : u) & 65535 }
                        b[p >> 1] = v;
                        u = s + 1 | 0;
                        if ((u | 0) < (g | 0)) {
                            q = q + 2 | 0;
                            r = r + 2 | 0;
                            p = p + 2 | 0;
                            s = u
                        } else { break }
                    }
                }
                n = n + 1 | 0;
            } while ((n | 0) < (h | 0));
            return
        }

        function Hg(a, c, d, e, f, g, h, i) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            j = 15 - i | 0;
            k = 1 << j - 1;
            if ((g & 1 | 0) != 0) { ec(13704, 16192, 238, 18192) }
            if ((h | 0) <= 0) { return }
            l = (g | 0) > 0;
            m = (1 << i) - 1 | 0;
            i = m & 65535;
            n = 0;
            do {
                o = ga(n, f) | 0;
                if (l) {
                    p = d + (o << 1) | 0;
                    q = e + (o << 1) | 0;
                    o = a + ((ga(n, c) | 0) << 1) | 0;
                    r = 0;
                    while (1) {
                        s = (b[p >> 1] | 0) + k + (b[q >> 1] | 0) >> j;
                        if ((s | 0) < 0) { t = 0 } else { t = (s | 0) > (m | 0) ? i : s & 65535 }
                        b[o >> 1] = t;
                        s = (b[p + 2 >> 1] | 0) + k + (b[q + 2 >> 1] | 0) >> j;
                        if ((s | 0) < 0) { u = 0 } else { u = (s | 0) > (m | 0) ? i : s & 65535 }
                        b[o + 2 >> 1] = u;
                        s = r + 2 | 0;
                        if ((s | 0) < (g | 0)) {
                            p = p + 4 | 0;
                            q = q + 4 | 0;
                            o = o + 4 | 0;
                            r = s
                        } else { break }
                    }
                }
                n = n + 1 | 0;
            } while ((n | 0) < (h | 0));
            return
        }

        function Ig(a, c, e, f, g, h, i, j, k) {
            a = a | 0;
            c = c | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0;
            if ((h | 0) <= 0) { return }
            k = (g | 0) > 0;
            j = 0;
            do {
                if (k) {
                    i = a + ((ga(j, c) | 0) << 1) | 0;
                    l = e + (ga(j, f) | 0) | 0;
                    m = 0;
                    while (1) {
                        b[i >> 1] = (d[l] | 0) << 6;
                        n = m + 1 | 0;
                        if ((n | 0) < (g | 0)) {
                            i = i + 2 | 0;
                            l = l + 1 | 0;
                            m = n
                        } else { break }
                    }
                }
                j = j + 1 | 0;
            } while ((j | 0) < (h | 0));
            return
        }

        function Jg(a, c, d, f, g, h, i, j, k, l) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0;
            k = 14 - l | 0;
            if ((h | 0) <= 0) { return }
            l = (g | 0) > 0;
            j = 0;
            do {
                if (l) {
                    i = a + ((ga(j, c) | 0) << 1) | 0;
                    m = d + ((ga(j, f) | 0) << 1) | 0;
                    n = 0;
                    while (1) {
                        b[i >> 1] = (e[m >> 1] | 0) << k;
                        o = n + 1 | 0;
                        if ((o | 0) < (g | 0)) {
                            i = i + 2 | 0;
                            m = m + 2 | 0;
                            n = o
                        } else { break }
                    }
                }
                j = j + 1 | 0;
            } while ((j | 0) < (h | 0));
            return
        }

        function Kg(a, c, e, f, g, h, j, k, l, m) {
            a = a | 0;
            c = c | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            l = i;
            n = m - 8 | 0;
            m = h + 3 | 0;
            o = ga(g << 1, m) | 0;
            p = i;
            i = i + o | 0;
            i = i + 7 & -8;
            o = p;
            p = h + 2 | 0;
            if ((p | 0) > -1) {
                q = (g | 0) > 0;
                r = -1;
                while (1) {
                    a: do {
                        if (q) {
                            s = r + 1 | 0;
                            t = e + ((ga(r, f) | 0) - 1) | 0;
                            u = 0;
                            while (1) {
                                switch (j | 0) {
                                    case 5:
                                        { v = ((d[t + 1 | 0] | 0) * 28 | 0) + ((d[t] | 0) * -4 | 0) + ((d[t + 2 | 0] | 0) * 46 | 0) + ((d[t + 3 | 0] | 0) * -6 | 0) >> n & 65535; break };
                                    case 6:
                                        { v = (d[t + 1 | 0] << 4) + ((d[t] | 0) * -2 | 0) + ((d[t + 2 | 0] | 0) * 54 | 0) - (d[t + 3 | 0] << 2) >> n & 65535; break };
                                    case 0:
                                        { v = d[t + 1 | 0] | 0; break };
                                    case 1:
                                        { v = ((d[t + 1 | 0] | 0) * 58 | 0) + ((d[t] | 0) * -2 | 0) + ((d[t + 2 | 0] | 0) * 10 | 0) - (d[t + 3 | 0] << 1) >> n & 65535; break };
                                    case 2:
                                        { v = ((d[t + 1 | 0] | 0) * 54 | 0) + ((d[t] | 0) * -4 | 0) + (d[t + 2 | 0] << 4) - (d[t + 3 | 0] << 1) >> n & 65535; break };
                                    case 3:
                                        { v = ((d[t + 1 | 0] | 0) * 46 | 0) + ((d[t] | 0) * -6 | 0) + ((d[t + 2 | 0] | 0) * 28 | 0) - (d[t + 3 | 0] << 2) >> n & 65535; break };
                                    case 4:
                                        { v = ((d[t] | 0) * -4 | 0) - (d[t + 3 | 0] << 2) + (((d[t + 2 | 0] | 0) + (d[t + 1 | 0] | 0) | 0) * 36 | 0) >> n & 65535; break };
                                    default:
                                        { v = ((d[t + 1 | 0] | 0) * 10 | 0) + ((d[t] | 0) * -2 | 0) + ((d[t + 2 | 0] | 0) * 58 | 0) - (d[t + 3 | 0] << 1) >> n & 65535 }
                                }
                                w = o + (s + (ga(u, m) | 0) << 1) | 0;
                                b[w >> 1] = v;
                                w = u + 1 | 0;
                                if ((w | 0) < (g | 0)) {
                                    t = t + 1 | 0;
                                    u = w
                                } else { x = s; break a }
                            }
                        } else { x = r + 1 | 0 }
                    } while (0);
                    if ((x | 0) < (p | 0)) { r = x } else { break }
                }
            }
            x = (j | 0) == 0 ? n : 6;
            if ((g | 0) <= 0) { i = l; return }
            n = (h | 0) > 0;
            j = 0;
            do {
                b: do {
                    if (n) {
                        r = o + ((ga(j, m) | 0) << 1) | 0;
                        p = 0;
                        while (1) {
                            switch (k | 0) {
                                case 0:
                                    { y = b[r + 2 >> 1] | 0; break };
                                case 1:
                                    { y = ((b[r + 2 >> 1] | 0) * 58 | 0) + ((b[r >> 1] | 0) * -2 | 0) + ((b[r + 4 >> 1] | 0) * 10 | 0) - (b[r + 6 >> 1] << 1) >> x & 65535; break };
                                case 2:
                                    { y = ((b[r + 2 >> 1] | 0) * 54 | 0) + ((b[r >> 1] | 0) * -4 | 0) + (b[r + 4 >> 1] << 4) - (b[r + 6 >> 1] << 1) >> x & 65535; break };
                                case 3:
                                    { y = ((b[r + 2 >> 1] | 0) * 46 | 0) + ((b[r >> 1] | 0) * -6 | 0) + ((b[r + 4 >> 1] | 0) * 28 | 0) - (b[r + 6 >> 1] << 2) >> x & 65535; break };
                                case 4:
                                    { y = ((b[r >> 1] | 0) * -4 | 0) - (b[r + 6 >> 1] << 2) + (((b[r + 4 >> 1] | 0) + (b[r + 2 >> 1] | 0) | 0) * 36 | 0) >> x & 65535; break };
                                case 5:
                                    { y = ((b[r + 2 >> 1] | 0) * 28 | 0) + ((b[r >> 1] | 0) * -4 | 0) + ((b[r + 4 >> 1] | 0) * 46 | 0) + ((b[r + 6 >> 1] | 0) * -6 | 0) >> x & 65535; break };
                                case 6:
                                    { y = (b[r + 2 >> 1] << 4) + ((b[r >> 1] | 0) * -2 | 0) + ((b[r + 4 >> 1] | 0) * 54 | 0) - (b[r + 6 >> 1] << 2) >> x & 65535; break };
                                default:
                                    { y = ((b[r + 2 >> 1] | 0) * 10 | 0) + ((b[r >> 1] | 0) * -2 | 0) + ((b[r + 4 >> 1] | 0) * 58 | 0) - (b[r + 6 >> 1] << 1) >> x & 65535 }
                            }
                            v = a + ((ga(p, c) | 0) + j << 1) | 0;
                            b[v >> 1] = y;
                            v = p + 1 | 0;
                            if ((v | 0) < (h | 0)) {
                                r = r + 2 | 0;
                                p = v
                            } else { break b }
                        }
                    }
                } while (0);j = j + 1 | 0;
            } while ((j | 0) < (g | 0));
            i = l;
            return
        }

        function Lg(a, c, d, f, g, h, j, k, l, m) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            l = i;
            n = m - 8 | 0;
            m = h + 3 | 0;
            o = ga(g << 1, m) | 0;
            p = i;
            i = i + o | 0;
            i = i + 7 & -8;
            o = p;
            p = h + 2 | 0;
            if ((p | 0) > -1) {
                q = (g | 0) > 0;
                r = -1;
                while (1) {
                    a: do {
                        if (q) {
                            s = r + 1 | 0;
                            t = d + ((ga(r, f) | 0) - 1 << 1) | 0;
                            u = 0;
                            while (1) {
                                switch (j | 0) {
                                    case 6:
                                        { v = (e[t + 2 >> 1] << 4) + ((e[t >> 1] | 0) * -2 | 0) + ((e[t + 4 >> 1] | 0) * 54 | 0) - (e[t + 6 >> 1] << 2) >> n & 65535; break };
                                    case 0:
                                        { v = b[t + 2 >> 1] | 0; break };
                                    case 1:
                                        { v = ((e[t + 2 >> 1] | 0) * 58 | 0) + ((e[t >> 1] | 0) * -2 | 0) + ((e[t + 4 >> 1] | 0) * 10 | 0) - (e[t + 6 >> 1] << 1) >> n & 65535; break };
                                    case 2:
                                        { v = ((e[t + 2 >> 1] | 0) * 54 | 0) + ((e[t >> 1] | 0) * -4 | 0) + (e[t + 4 >> 1] << 4) - (e[t + 6 >> 1] << 1) >> n & 65535; break };
                                    case 3:
                                        { v = ((e[t + 2 >> 1] | 0) * 46 | 0) + ((e[t >> 1] | 0) * -6 | 0) + ((e[t + 4 >> 1] | 0) * 28 | 0) - (e[t + 6 >> 1] << 2) >> n & 65535; break };
                                    case 4:
                                        { v = ((e[t >> 1] | 0) * -4 | 0) - (e[t + 6 >> 1] << 2) + (((e[t + 4 >> 1] | 0) + (e[t + 2 >> 1] | 0) | 0) * 36 | 0) >> n & 65535; break };
                                    case 5:
                                        { v = ((e[t + 2 >> 1] | 0) * 28 | 0) + ((e[t >> 1] | 0) * -4 | 0) + ((e[t + 4 >> 1] | 0) * 46 | 0) + ((e[t + 6 >> 1] | 0) * -6 | 0) >> n & 65535; break };
                                    default:
                                        { v = ((e[t + 2 >> 1] | 0) * 10 | 0) + ((e[t >> 1] | 0) * -2 | 0) + ((e[t + 4 >> 1] | 0) * 58 | 0) - (e[t + 6 >> 1] << 1) >> n & 65535 }
                                }
                                w = o + (s + (ga(u, m) | 0) << 1) | 0;
                                b[w >> 1] = v;
                                w = u + 1 | 0;
                                if ((w | 0) < (g | 0)) {
                                    t = t + 2 | 0;
                                    u = w
                                } else { x = s; break a }
                            }
                        } else { x = r + 1 | 0 }
                    } while (0);
                    if ((x | 0) < (p | 0)) { r = x } else { break }
                }
            }
            x = (j | 0) == 0 ? n : 6;
            if ((g | 0) <= 0) { i = l; return }
            n = (h | 0) > 0;
            j = 0;
            do {
                b: do {
                    if (n) {
                        r = o + ((ga(j, m) | 0) << 1) | 0;
                        p = 0;
                        while (1) {
                            switch (k | 0) {
                                case 0:
                                    { y = b[r + 2 >> 1] | 0; break };
                                case 1:
                                    { y = ((b[r + 2 >> 1] | 0) * 58 | 0) + ((b[r >> 1] | 0) * -2 | 0) + ((b[r + 4 >> 1] | 0) * 10 | 0) - (b[r + 6 >> 1] << 1) >> x & 65535; break };
                                case 2:
                                    { y = ((b[r + 2 >> 1] | 0) * 54 | 0) + ((b[r >> 1] | 0) * -4 | 0) + (b[r + 4 >> 1] << 4) - (b[r + 6 >> 1] << 1) >> x & 65535; break };
                                case 3:
                                    { y = ((b[r + 2 >> 1] | 0) * 46 | 0) + ((b[r >> 1] | 0) * -6 | 0) + ((b[r + 4 >> 1] | 0) * 28 | 0) - (b[r + 6 >> 1] << 2) >> x & 65535; break };
                                case 4:
                                    { y = ((b[r >> 1] | 0) * -4 | 0) - (b[r + 6 >> 1] << 2) + (((b[r + 4 >> 1] | 0) + (b[r + 2 >> 1] | 0) | 0) * 36 | 0) >> x & 65535; break };
                                case 5:
                                    { y = ((b[r + 2 >> 1] | 0) * 28 | 0) + ((b[r >> 1] | 0) * -4 | 0) + ((b[r + 4 >> 1] | 0) * 46 | 0) + ((b[r + 6 >> 1] | 0) * -6 | 0) >> x & 65535; break };
                                case 6:
                                    { y = (b[r + 2 >> 1] << 4) + ((b[r >> 1] | 0) * -2 | 0) + ((b[r + 4 >> 1] | 0) * 54 | 0) - (b[r + 6 >> 1] << 2) >> x & 65535; break };
                                default:
                                    { y = ((b[r + 2 >> 1] | 0) * 10 | 0) + ((b[r >> 1] | 0) * -2 | 0) + ((b[r + 4 >> 1] | 0) * 58 | 0) - (b[r + 6 >> 1] << 1) >> x & 65535 }
                            }
                            v = a + ((ga(p, c) | 0) + j << 1) | 0;
                            b[v >> 1] = y;
                            v = p + 1 | 0;
                            if ((v | 0) < (h | 0)) {
                                r = r + 2 | 0;
                                p = v
                            } else { break b }
                        }
                    }
                } while (0);j = j + 1 | 0;
            } while ((j | 0) < (g | 0));
            i = l;
            return
        }

        function Mg(a, c, e, f, g, h, i) {
            a = a | 0;
            c = c | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            if ((h | 0) <= 0) { return }
            i = (g | 0) > 0;
            j = 0;
            do {
                if (i) {
                    k = 0;
                    l = a + ((ga(j, c) | 0) << 1) | 0;
                    m = e + (ga(j, f) | 0) | 0;
                    while (1) {
                        n = (d[m + 1 | 0] | 0) << 6;
                        o = (d[m + 2 | 0] | 0) << 6;
                        p = (d[m + 3 | 0] | 0) << 6;
                        b[l >> 1] = (d[m] | 0) << 6;
                        b[l + 2 >> 1] = n;
                        b[l + 4 >> 1] = o;
                        b[l + 6 >> 1] = p;
                        p = k + 4 | 0;
                        if ((p | 0) < (g | 0)) {
                            k = p;
                            l = l + 8 | 0;
                            m = m + 4 | 0
                        } else { break }
                    }
                }
                j = j + 1 | 0;
            } while ((j | 0) < (h | 0));
            return
        }

        function Ng(a, c, d, f, g, h, i, j) {
            a = a | 0;
            c = c | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            i = 14 - j | 0;
            if ((h | 0) <= 0) { return }
            j = (g | 0) > 0;
            k = 0;
            do {
                if (j) {
                    l = d + ((ga(k, f) | 0) << 1) | 0;
                    m = a + ((ga(k, c) | 0) << 1) | 0;
                    n = 0;
                    while (1) {
                        b[m >> 1] = (e[l >> 1] | 0) << i;
                        o = n + 1 | 0;
                        if ((o | 0) < (g | 0)) {
                            l = l + 2 | 0;
                            m = m + 2 | 0;
                            n = o
                        } else { break }
                    }
                }
                k = k + 1 | 0;
            } while ((k | 0) < (h | 0));
            return
        }

        function Og(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 0, 1, 8);
            return
        }

        function Pg(a, e, f, g, h, i, j, k, l, m) {
            a = a | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            n = c[30784 + (k << 2) >> 2] | 0;
            o = c[30784 + (l << 2) >> 2] | 0;
            p = c[30888 + (l << 2) >> 2] | 0;
            q = o + i + p | 0;
            r = m - 8 | 0;
            do {
                if ((k | 0) == 1) {
                    m = -o | 0;
                    s = p + i | 0;
                    if ((s | 0) <= (m | 0)) { break }
                    t = (h | 0) > 0;
                    u = m;
                    do {
                        if (t) {
                            m = f + ((ga(u, g) | 0) - n) | 0;
                            v = j + (u + o << 1) | 0;
                            w = 0;
                            while (1) {
                                x = m + 1 | 0;
                                b[v >> 1] = (d[x] << 2) - (d[m] | 0) + ((d[m + 2 | 0] | 0) * -10 | 0) + ((d[m + 3 | 0] | 0) * 58 | 0) + ((d[m + 4 | 0] | 0) * 17 | 0) + ((d[m + 5 | 0] | 0) * -5 | 0) + (d[m + 6 | 0] | 0) >> r;
                                y = w + 1 | 0;
                                if ((y | 0) < (h | 0)) {
                                    m = x;
                                    v = v + (q << 1) | 0;
                                    w = y
                                } else { break }
                            }
                        }
                        u = u + 1 | 0;
                    } while ((u | 0) < (s | 0))
                } else if ((k | 0) == 3) {
                    s = -o | 0;
                    u = p + i | 0;
                    if ((u | 0) <= (s | 0)) { break }
                    t = (h | 0) > 0;
                    w = s;
                    do {
                        if (t) {
                            s = f + ((ga(w, g) | 0) - n) | 0;
                            v = j + (w + o << 1) | 0;
                            m = 0;
                            while (1) {
                                y = s + 1 | 0;
                                b[v >> 1] = ((d[y] | 0) * -5 | 0) + (d[s] | 0) + ((d[s + 2 | 0] | 0) * 17 | 0) + ((d[s + 3 | 0] | 0) * 58 | 0) + ((d[s + 4 | 0] | 0) * -10 | 0) + (d[s + 5 | 0] << 2) - (d[s + 6 | 0] | 0) >> r;
                                x = m + 1 | 0;
                                if ((x | 0) < (h | 0)) {
                                    s = y;
                                    v = v + (q << 1) | 0;
                                    m = x
                                } else { break }
                            }
                        }
                        w = w + 1 | 0;
                    } while ((w | 0) < (u | 0))
                } else if ((k | 0) == 0) {
                    u = -o | 0;
                    w = p + i | 0;
                    if ((w | 0) <= (u | 0)) { break }
                    t = (h | 0) > 0;
                    m = u;
                    do {
                        if (t) {
                            u = f + ((ga(m, g) | 0) - n) | 0;
                            v = j + (m + o << 1) | 0;
                            s = 0;
                            while (1) {
                                b[v >> 1] = d[u] | 0;
                                x = s + 1 | 0;
                                if ((x | 0) < (h | 0)) {
                                    u = u + 1 | 0;
                                    v = v + (q << 1) | 0;
                                    s = x
                                } else { break }
                            }
                        }
                        m = m + 1 | 0;
                    } while ((m | 0) < (w | 0))
                } else if ((k | 0) == 2) {
                    w = -o | 0;
                    m = p + i | 0;
                    if ((m | 0) <= (w | 0)) { break }
                    t = (h | 0) > 0;
                    s = w;
                    do {
                        if (t) {
                            w = f + ((ga(s, g) | 0) - n) | 0;
                            v = j + (s + o << 1) | 0;
                            u = 0;
                            while (1) {
                                x = w + 1 | 0;
                                b[v >> 1] = (d[x] << 2) - (d[w] | 0) + (d[w + 6 | 0] << 2) - (d[w + 7 | 0] | 0) + (((d[w + 4 | 0] | 0) + (d[w + 3 | 0] | 0) | 0) * 40 | 0) + (((d[w + 5 | 0] | 0) + (d[w + 2 | 0] | 0) | 0) * -11 | 0) >> r;
                                y = u + 1 | 0;
                                if ((y | 0) < (h | 0)) {
                                    w = x;
                                    v = v + (q << 1) | 0;
                                    u = y
                                } else { break }
                            }
                        }
                        s = s + 1 | 0;
                    } while ((s | 0) < (m | 0))
                }
            } while (0);
            o = (k | 0) == 0 ? r : 6;
            if ((l | 0) == 3) {
                if ((h | 0) <= 0) { return }
                r = (i | 0) > 0;
                k = 0;
                do {
                    if (r) {
                        n = j + ((ga(k, q) | 0) << 1) | 0;
                        g = a + (k << 1) | 0;
                        f = 0;
                        while (1) {
                            p = n + 2 | 0;
                            b[g >> 1] = ((b[p >> 1] | 0) * -5 | 0) + (b[n >> 1] | 0) + ((b[n + 4 >> 1] | 0) * 17 | 0) + ((b[n + 6 >> 1] | 0) * 58 | 0) + ((b[n + 8 >> 1] | 0) * -10 | 0) + (b[n + 10 >> 1] << 2) - (b[n + 12 >> 1] | 0) >> o;
                            m = f + 1 | 0;
                            if ((m | 0) < (i | 0)) {
                                n = p;
                                g = g + (e << 1) | 0;
                                f = m
                            } else { break }
                        }
                    }
                    k = k + 1 | 0;
                } while ((k | 0) < (h | 0));
                return
            } else if ((l | 0) == 2) {
                if ((h | 0) <= 0) { return }
                k = (i | 0) > 0;
                r = 0;
                do {
                    if (k) {
                        f = j + ((ga(r, q) | 0) << 1) | 0;
                        g = a + (r << 1) | 0;
                        n = 0;
                        while (1) {
                            m = f + 2 | 0;
                            b[g >> 1] = (b[m >> 1] << 2) - (b[f >> 1] | 0) + (b[f + 12 >> 1] << 2) - (b[f + 14 >> 1] | 0) + (((b[f + 8 >> 1] | 0) + (b[f + 6 >> 1] | 0) | 0) * 40 | 0) + (((b[f + 10 >> 1] | 0) + (b[f + 4 >> 1] | 0) | 0) * -11 | 0) >> o;
                            p = n + 1 | 0;
                            if ((p | 0) < (i | 0)) {
                                f = m;
                                g = g + (e << 1) | 0;
                                n = p
                            } else { break }
                        }
                    }
                    r = r + 1 | 0;
                } while ((r | 0) < (h | 0));
                return
            } else if ((l | 0) == 1) {
                if ((h | 0) <= 0) { return }
                r = (i | 0) > 0;
                k = 0;
                do {
                    if (r) {
                        n = j + ((ga(k, q) | 0) << 1) | 0;
                        g = a + (k << 1) | 0;
                        f = 0;
                        while (1) {
                            p = n + 2 | 0;
                            b[g >> 1] = (b[p >> 1] << 2) - (b[n >> 1] | 0) + ((b[n + 4 >> 1] | 0) * -10 | 0) + ((b[n + 6 >> 1] | 0) * 58 | 0) + ((b[n + 8 >> 1] | 0) * 17 | 0) + ((b[n + 10 >> 1] | 0) * -5 | 0) + (b[n + 12 >> 1] | 0) >> o;
                            m = f + 1 | 0;
                            if ((m | 0) < (i | 0)) {
                                n = p;
                                g = g + (e << 1) | 0;
                                f = m
                            } else { break }
                        }
                    }
                    k = k + 1 | 0;
                } while ((k | 0) < (h | 0));
                return
            } else if ((l | 0) == 0) {
                if ((h | 0) <= 0) { return }
                l = (i | 0) > 0;
                k = 0;
                do {
                    if (l) {
                        o = j + ((ga(k, q) | 0) << 1) | 0;
                        r = a + (k << 1) | 0;
                        f = 0;
                        while (1) {
                            b[r >> 1] = b[o >> 1] | 0;
                            g = f + 1 | 0;
                            if ((g | 0) < (i | 0)) {
                                o = o + 2 | 0;
                                r = r + (e << 1) | 0;
                                f = g
                            } else { break }
                        }
                    }
                    k = k + 1 | 0;
                } while ((k | 0) < (h | 0));
                return
            } else { return }
        }

        function Qg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 0, 2, 8);
            return
        }

        function Rg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 0, 3, 8);
            return
        }

        function Sg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 1, 0, 8);
            return
        }

        function Tg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 1, 1, 8);
            return
        }

        function Ug(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 1, 2, 8);
            return
        }

        function Vg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 1, 3, 8);
            return
        }

        function Wg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 2, 0, 8);
            return
        }

        function Xg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 2, 1, 8);
            return
        }

        function Yg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 2, 2, 8);
            return
        }

        function Zg(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 2, 3, 8);
            return
        }

        function _g(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 3, 0, 8);
            return
        }

        function $g(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 3, 1, 8);
            return
        }

        function ah(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 3, 2, 8);
            return
        }

        function bh(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Pg(a, b, c, d, e, f, g, 3, 3, 8);
            return
        }

        function ch(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 0, 1, h);
            return
        }

        function dh(a, d, f, g, h, i, j, k, l, m) {
            a = a | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            n = c[30784 + (k << 2) >> 2] | 0;
            o = c[30784 + (l << 2) >> 2] | 0;
            p = c[30888 + (l << 2) >> 2] | 0;
            q = o + i + p | 0;
            r = m - 8 | 0;
            do {
                if ((k | 0) == 0) {
                    m = -o | 0;
                    s = p + i | 0;
                    if ((s | 0) <= (m | 0)) { break }
                    t = (h | 0) > 0;
                    u = m;
                    do {
                        if (t) {
                            m = f + ((ga(u, g) | 0) - n << 1) | 0;
                            v = j + (u + o << 1) | 0;
                            w = 0;
                            while (1) {
                                b[v >> 1] = b[m >> 1] | 0;
                                x = w + 1 | 0;
                                if ((x | 0) < (h | 0)) {
                                    m = m + 2 | 0;
                                    v = v + (q << 1) | 0;
                                    w = x
                                } else { break }
                            }
                        }
                        u = u + 1 | 0;
                    } while ((u | 0) < (s | 0))
                } else if ((k | 0) == 1) {
                    s = -o | 0;
                    u = p + i | 0;
                    if ((u | 0) <= (s | 0)) { break }
                    t = (h | 0) > 0;
                    w = s;
                    do {
                        if (t) {
                            s = f + ((ga(w, g) | 0) - n << 1) | 0;
                            v = j + (w + o << 1) | 0;
                            m = 0;
                            while (1) {
                                x = s + 2 | 0;
                                b[v >> 1] = (e[x >> 1] << 2) - (e[s >> 1] | 0) + ((e[s + 4 >> 1] | 0) * -10 | 0) + ((e[s + 6 >> 1] | 0) * 58 | 0) + ((e[s + 8 >> 1] | 0) * 17 | 0) + ((e[s + 10 >> 1] | 0) * -5 | 0) + (e[s + 12 >> 1] | 0) >> r;
                                y = m + 1 | 0;
                                if ((y | 0) < (h | 0)) {
                                    s = x;
                                    v = v + (q << 1) | 0;
                                    m = y
                                } else { break }
                            }
                        }
                        w = w + 1 | 0;
                    } while ((w | 0) < (u | 0))
                } else if ((k | 0) == 2) {
                    u = -o | 0;
                    w = p + i | 0;
                    if ((w | 0) <= (u | 0)) { break }
                    t = (h | 0) > 0;
                    m = u;
                    do {
                        if (t) {
                            u = f + ((ga(m, g) | 0) - n << 1) | 0;
                            v = j + (m + o << 1) | 0;
                            s = 0;
                            while (1) {
                                y = u + 2 | 0;
                                b[v >> 1] = (e[y >> 1] << 2) - (e[u >> 1] | 0) + (e[u + 12 >> 1] << 2) - (e[u + 14 >> 1] | 0) + (((e[u + 8 >> 1] | 0) + (e[u + 6 >> 1] | 0) | 0) * 40 | 0) + (((e[u + 10 >> 1] | 0) + (e[u + 4 >> 1] | 0) | 0) * -11 | 0) >> r;
                                x = s + 1 | 0;
                                if ((x | 0) < (h | 0)) {
                                    u = y;
                                    v = v + (q << 1) | 0;
                                    s = x
                                } else { break }
                            }
                        }
                        m = m + 1 | 0;
                    } while ((m | 0) < (w | 0))
                } else if ((k | 0) == 3) {
                    w = -o | 0;
                    m = p + i | 0;
                    if ((m | 0) <= (w | 0)) { break }
                    t = (h | 0) > 0;
                    s = w;
                    do {
                        if (t) {
                            w = f + ((ga(s, g) | 0) - n << 1) | 0;
                            v = j + (s + o << 1) | 0;
                            u = 0;
                            while (1) {
                                x = w + 2 | 0;
                                b[v >> 1] = ((e[x >> 1] | 0) * -5 | 0) + (e[w >> 1] | 0) + ((e[w + 4 >> 1] | 0) * 17 | 0) + ((e[w + 6 >> 1] | 0) * 58 | 0) + ((e[w + 8 >> 1] | 0) * -10 | 0) + (e[w + 10 >> 1] << 2) - (e[w + 12 >> 1] | 0) >> r;
                                y = u + 1 | 0;
                                if ((y | 0) < (h | 0)) {
                                    w = x;
                                    v = v + (q << 1) | 0;
                                    u = y
                                } else { break }
                            }
                        }
                        s = s + 1 | 0;
                    } while ((s | 0) < (m | 0))
                }
            } while (0);
            o = (k | 0) == 0 ? r : 6;
            if ((l | 0) == 3) {
                if ((h | 0) <= 0) { return }
                r = (i | 0) > 0;
                k = 0;
                do {
                    if (r) {
                        n = j + ((ga(k, q) | 0) << 1) | 0;
                        g = a + (k << 1) | 0;
                        f = 0;
                        while (1) {
                            p = n + 2 | 0;
                            b[g >> 1] = ((b[p >> 1] | 0) * -5 | 0) + (b[n >> 1] | 0) + ((b[n + 4 >> 1] | 0) * 17 | 0) + ((b[n + 6 >> 1] | 0) * 58 | 0) + ((b[n + 8 >> 1] | 0) * -10 | 0) + (b[n + 10 >> 1] << 2) - (b[n + 12 >> 1] | 0) >> o;
                            m = f + 1 | 0;
                            if ((m | 0) < (i | 0)) {
                                n = p;
                                g = g + (d << 1) | 0;
                                f = m
                            } else { break }
                        }
                    }
                    k = k + 1 | 0;
                } while ((k | 0) < (h | 0));
                return
            } else if ((l | 0) == 0) {
                if ((h | 0) <= 0) { return }
                k = (i | 0) > 0;
                r = 0;
                do {
                    if (k) {
                        f = j + ((ga(r, q) | 0) << 1) | 0;
                        g = a + (r << 1) | 0;
                        n = 0;
                        while (1) {
                            b[g >> 1] = b[f >> 1] | 0;
                            m = n + 1 | 0;
                            if ((m | 0) < (i | 0)) {
                                f = f + 2 | 0;
                                g = g + (d << 1) | 0;
                                n = m
                            } else { break }
                        }
                    }
                    r = r + 1 | 0;
                } while ((r | 0) < (h | 0));
                return
            } else if ((l | 0) == 1) {
                if ((h | 0) <= 0) { return }
                r = (i | 0) > 0;
                k = 0;
                do {
                    if (r) {
                        n = j + ((ga(k, q) | 0) << 1) | 0;
                        g = a + (k << 1) | 0;
                        f = 0;
                        while (1) {
                            m = n + 2 | 0;
                            b[g >> 1] = (b[m >> 1] << 2) - (b[n >> 1] | 0) + ((b[n + 4 >> 1] | 0) * -10 | 0) + ((b[n + 6 >> 1] | 0) * 58 | 0) + ((b[n + 8 >> 1] | 0) * 17 | 0) + ((b[n + 10 >> 1] | 0) * -5 | 0) + (b[n + 12 >> 1] | 0) >> o;
                            p = f + 1 | 0;
                            if ((p | 0) < (i | 0)) {
                                n = m;
                                g = g + (d << 1) | 0;
                                f = p
                            } else { break }
                        }
                    }
                    k = k + 1 | 0;
                } while ((k | 0) < (h | 0));
                return
            } else if ((l | 0) == 2) {
                if ((h | 0) <= 0) { return }
                l = (i | 0) > 0;
                k = 0;
                do {
                    if (l) {
                        r = j + ((ga(k, q) | 0) << 1) | 0;
                        f = a + (k << 1) | 0;
                        g = 0;
                        while (1) {
                            n = r + 2 | 0;
                            b[f >> 1] = (b[n >> 1] << 2) - (b[r >> 1] | 0) + (b[r + 12 >> 1] << 2) - (b[r + 14 >> 1] | 0) + (((b[r + 8 >> 1] | 0) + (b[r + 6 >> 1] | 0) | 0) * 40 | 0) + (((b[r + 10 >> 1] | 0) + (b[r + 4 >> 1] | 0) | 0) * -11 | 0) >> o;
                            p = g + 1 | 0;
                            if ((p | 0) < (i | 0)) {
                                r = n;
                                f = f + (d << 1) | 0;
                                g = p
                            } else { break }
                        }
                    }
                    k = k + 1 | 0;
                } while ((k | 0) < (h | 0));
                return
            } else { return }
        }

        function eh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 0, 2, h);
            return
        }

        function fh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 0, 3, h);
            return
        }

        function gh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 1, 0, h);
            return
        }

        function hh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 1, 1, h);
            return
        }

        function ih(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 1, 2, h);
            return
        }

        function jh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 1, 3, h);
            return
        }

        function kh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 2, 0, h);
            return
        }

        function lh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 2, 1, h);
            return
        }

        function mh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 2, 2, h);
            return
        }

        function nh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 2, 3, h);
            return
        }

        function oh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 3, 0, h);
            return
        }

        function ph(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 3, 1, h);
            return
        }

        function qh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 3, 2, h);
            return
        }

        function rh(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            dh(a, b, c, d, e, f, g, 3, 3, h);
            return
        }

        function sh(a) {
            a = a | 0;
            dv(a + 8 | 0, 0, 48) | 0;
            c[a >> 2] = 30;
            c[a + 4 >> 2] = 30;
            return
        }

        function th(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            b = a + 12 | 0;
            d = c[b >> 2] | 0;
            e = a + 8 | 0;
            f = c[e >> 2] | 0;
            if ((d | 0) != (f | 0)) {
                g = 0;
                h = f;
                f = d;
                while (1) {
                    d = c[h + (g << 2) >> 2] | 0;
                    if ((d | 0) == 0) {
                        i = f;
                        j = h
                    } else {
                        Rh(d);
                        Pu(d);
                        i = c[b >> 2] | 0;
                        j = c[e >> 2] | 0
                    }
                    d = g + 1 | 0;
                    if (d >>> 0 < i - j >> 2 >>> 0) {
                        g = d;
                        h = j;
                        f = i
                    } else { break }
                }
            }
            i = a + 32 | 0;
            Gh(i | 0);
            f = a + 36 | 0;
            j = c[f >> 2] | 0;
            h = a + 40 | 0;
            g = c[h >> 2] | 0;
            do {
                if ((j | 0) != (g | 0)) {
                    d = j;
                    do {
                        Pu(c[d >> 2] | 0);
                        d = d + 4 | 0;
                    } while ((d | 0) != (g | 0));
                    d = c[f >> 2] | 0;
                    k = c[h >> 2] | 0;
                    if ((k | 0) == (d | 0)) { break }
                    c[h >> 2] = k + (~((k - 4 + (-d | 0) | 0) >>> 2) << 2)
                }
            } while (0);
            h = c[i >> 2] | 0;
            if ((h | 0) != 0) { Pu(h) }
            h = c[a + 20 >> 2] | 0;
            if ((h | 0) != 0) {
                i = a + 24 | 0;
                a = c[i >> 2] | 0;
                if ((a | 0) != (h | 0)) { c[i >> 2] = a + (~((a - 4 + (-h | 0) | 0) >>> 2) << 2) }
                Pu(h)
            }
            h = c[e >> 2] | 0;
            if ((h | 0) == 0) { return }
            e = c[b >> 2] | 0;
            if ((e | 0) != (h | 0)) { c[b >> 2] = e + (~((e - 4 + (-h | 0) | 0) >>> 2) << 2) }
            Pu(h);
            return
        }

        function uh(a) { a = a | 0; return }

        function vh(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            if (d) { e = 1; return e | 0 }
            d = c[b + 12 >> 2] | 0;
            f = c[b + 8 >> 2] | 0;
            g = d - f >> 2;
            if (g >>> 0 < (c[b >> 2] | 0) >>> 0) { e = 1; return e | 0 }
            if ((d | 0) == (f | 0)) { e = 0; return e | 0 } else { h = 0 }
            while (1) {
                d = c[f + (h << 2) >> 2] | 0;
                if ((a[d + 100 | 0] | 0) == 0) {
                    if ((c[d + 96 >> 2] | 0) == 0) {
                        e = 1;
                        i = 7;
                        break
                    }
                }
                d = h + 1 | 0;
                if (d >>> 0 < g >>> 0) { h = d } else {
                    e = 0;
                    i = 7;
                    break
                }
            }
            if ((i | 0) == 7) { return e | 0 }
            return 0
        }

        function wh(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            f = c[a + 12 >> 2] | 0;
            g = c[a + 8 >> 2] | 0;
            a: do {
                if (!((f | 0) == (g | 0) | e ^ 1)) {
                    a = 0;
                    b: while (1) {
                        h = c[g + (a << 2) >> 2] | 0;
                        do { if ((c[h + 92 >> 2] | 0) == (b | 0)) { if ((c[h + 104 >> 2] | 0) <= (d | 0)) { break } if ((c[h + 96 >> 2] | 0) == 2) { i = a; break b } } } while (0);
                        a = a + 1 | 0;
                        if (!(a >>> 0 < f - g >> 2 >>> 0)) { break a }
                    }
                    return i | 0
                }
            } while (0);
            if ((f | 0) == (g | 0)) { i = -1; return i | 0 } else { j = 0 }
            c: while (1) {
                e = c[g + (j << 2) >> 2] | 0;
                do {
                    if ((c[e + 92 >> 2] | 0) == (b | 0)) {
                        if ((c[e + 104 >> 2] | 0) <= (d | 0)) { break }
                        if ((c[e + 96 >> 2] | 0) != 0) {
                            i = j;
                            k = 11;
                            break c
                        }
                    }
                } while (0);
                e = j + 1 | 0;
                if (e >>> 0 < f - g >> 2 >>> 0) { j = e } else {
                    i = -1;
                    k = 11;
                    break
                }
            }
            if ((k | 0) == 11) { return i | 0 }
            return 0
        }

        function xh(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0;
            f = c[a + 12 >> 2] | 0;
            g = c[a + 8 >> 2] | 0;
            a: do {
                if (!((f | 0) == (g | 0) | e ^ 1)) {
                    a = 0;
                    b: while (1) {
                        h = c[g + (a << 2) >> 2] | 0;
                        do { if ((c[h + 88 >> 2] | 0) == (b | 0)) { if ((c[h + 104 >> 2] | 0) <= (d | 0)) { break } if ((c[h + 96 >> 2] | 0) == 2) { i = a; break b } } } while (0);
                        a = a + 1 | 0;
                        if (!(a >>> 0 < f - g >> 2 >>> 0)) { break a }
                    }
                    return i | 0
                }
            } while (0);
            if ((f | 0) == (g | 0)) { i = -1; return i | 0 } else { j = 0 }
            c: while (1) {
                e = c[g + (j << 2) >> 2] | 0;
                do {
                    if ((c[e + 88 >> 2] | 0) == (b | 0)) {
                        if ((c[e + 104 >> 2] | 0) <= (d | 0)) { break }
                        if ((c[e + 96 >> 2] | 0) != 0) {
                            i = j;
                            k = 11;
                            break c
                        }
                    }
                } while (0);
                e = j + 1 | 0;
                if (e >>> 0 < f - g >> 2 >>> 0) { j = e } else {
                    i = -1;
                    k = 11;
                    break
                }
            }
            if ((k | 0) == 11) { return i | 0 }
            return 0
        }

        function yh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0;
            d = c[a + 12 >> 2] | 0;
            e = c[a + 8 >> 2] | 0;
            if ((d | 0) == (e | 0)) { f = -1; return f | 0 } else { g = 0 }
            while (1) {
                a = g + 1 | 0;
                if ((c[c[e + (g << 2) >> 2] >> 2] | 0) == (b | 0)) {
                    f = g;
                    h = 4;
                    break
                }
                if (a >>> 0 < d - e >> 2 >>> 0) { g = a } else {
                    f = -1;
                    h = 4;
                    break
                }
            }
            if ((h | 0) == 4) { return f | 0 }
            return 0
        }

        function zh(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            b = a + 20 | 0;
            d = c[b >> 2] | 0;
            e = a + 24 | 0;
            f = c[e >> 2] | 0;
            if ((d | 0) == (f | 0)) { ec(11328, 15872, 147, 17376) }
            g = f - d >> 2;
            if (g >>> 0 > 1 >>> 0) {
                f = c[(c[d >> 2] | 0) + 92 >> 2] | 0;
                h = 0;
                i = 1;
                while (1) {
                    j = c[(c[d + (i << 2) >> 2] | 0) + 92 >> 2] | 0;
                    k = (j | 0) < (f | 0);
                    l = k ? i : h;
                    m = i + 1 | 0;
                    if (m >>> 0 < g >>> 0) {
                        f = k ? j : f;
                        h = l;
                        i = m
                    } else { n = l; break }
                }
            } else { n = 0 }
            i = d + (n << 2) | 0;
            d = a + 40 | 0;
            h = c[d >> 2] | 0;
            f = a + 36 | 0;
            g = c[f >> 2] | 0;
            if ((h | 0) == (g | 0)) { o = 0 } else { o = (h - g << 8) - 1 | 0 }
            l = a + 48 | 0;
            m = c[l >> 2] | 0;
            j = a + 52 | 0;
            k = c[j >> 2] | 0;
            if ((o - m | 0) == (k | 0)) {
                Hh(a + 32 | 0);
                p = c[j >> 2] | 0;
                q = c[l >> 2] | 0;
                r = c[f >> 2] | 0;
                s = c[d >> 2] | 0
            } else {
                p = k;
                q = m;
                r = g;
                s = h
            }
            h = p + q | 0;
            do {
                if ((s | 0) != (r | 0)) {
                    q = (c[r + (h >>> 10 << 2) >> 2] | 0) + ((h & 1023) << 2) | 0;
                    if ((q | 0) == 0) { break }
                    c[q >> 2] = c[i >> 2]
                }
            } while (0);
            c[j >> 2] = p + 1;
            c[(c[b >> 2] | 0) + (n << 2) >> 2] = c[(c[e >> 2] | 0) - 4 >> 2];
            n = c[e >> 2] | 0;
            b = n - 4 | 0;
            c[e >> 2] = n + (~((b + (-b | 0) | 0) >>> 2) << 2);
            return
        }

        function Ah(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            b = a + 20 | 0;
            d = a + 24 | 0;
            if ((c[b >> 2] | 0) == (c[d >> 2] | 0)) { e = 0; return e | 0 }
            while (1) { zh(a); if ((c[b >> 2] | 0) == (c[d >> 2] | 0)) { e = 1; break } }
            return e | 0
        }

        function Bh(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = b + 12 | 0;
            e = c[d >> 2] | 0;
            f = b + 8 | 0;
            g = c[f >> 2] | 0;
            if ((e | 0) != (g | 0)) {
                h = 0;
                i = g;
                g = e;
                while (1) {
                    e = c[i + (h << 2) >> 2] | 0;
                    j = e + 100 | 0;
                    k = e + 96 | 0;
                    if ((a[j] | 0) == 0) {
                        if ((c[k >> 2] | 0) == 0) {
                            l = g;
                            m = i
                        } else { n = 4 }
                    } else { n = 4 }
                    if ((n | 0) == 4) {
                        n = 0;
                        a[j] = 0;
                        c[k >> 2] = 0;
                        Qh(e);
                        l = c[d >> 2] | 0;
                        m = c[f >> 2] | 0
                    }
                    e = h + 1 | 0;
                    if (e >>> 0 < l - m >> 2 >>> 0) {
                        h = e;
                        i = m;
                        g = l
                    } else { break }
                }
            }
            l = c[b + 20 >> 2] | 0;
            g = b + 24 | 0;
            m = c[g >> 2] | 0;
            if ((m | 0) == (l | 0)) {
                o = b + 32 | 0;
                Gh(o);
                return
            }
            c[g >> 2] = m + (~((m - 4 + (-l | 0) | 0) >>> 2) << 2);
            o = b + 32 | 0;
            Gh(o);
            return
        }

        function Ch(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0;
            k = i;
            i = i + 8 | 0;
            l = k | 0;
            m = b + 8 | 0;
            n = b + 12 | 0;
            o = c[n >> 2] | 0;
            p = m | 0;
            q = c[p >> 2] | 0;
            a: do {
                if ((o | 0) == (q | 0)) {
                    r = -1;
                    s = o;
                    t = o
                } else {
                    u = 0;
                    while (1) {
                        v = c[q + (u << 2) >> 2] | 0;
                        if ((a[v + 100 | 0] | 0) == 0) { if ((c[v + 96 >> 2] | 0) == 0) { break } }
                        w = u + 1 | 0;
                        if (w >>> 0 < o - q >> 2 >>> 0) { u = w } else {
                            r = -1;
                            s = o;
                            t = q;
                            break a
                        }
                    }
                    Qh(v);
                    r = u;
                    s = c[n >> 2] | 0;
                    t = c[p >> 2] | 0
                }
            } while (0);
            v = s - t >> 2;
            do {
                if (v >>> 0 <= (c[b + 4 >> 2] | 0) >>> 0 | (r | 0) == (v - 1 | 0)) { x = s } else {
                    t = c[s - 4 >> 2] | 0;
                    if ((a[t + 100 | 0] | 0) != 0) { x = s; break }
                    if ((c[t + 96 >> 2] | 0) != 0) { x = s; break }
                    if ((t | 0) == 0) { y = s } else {
                        Rh(t);
                        Pu(t);
                        y = c[n >> 2] | 0
                    }
                    t = y - 4 | 0;
                    q = y + (~((t + (-t | 0) | 0) >>> 2) << 2) | 0;
                    c[n >> 2] = q;
                    x = q
                }
            } while (0);
            do {
                if ((r | 0) == -1) {
                    y = x - (c[p >> 2] | 0) >> 2;
                    s = Nu(10624) | 0;
                    Oh(s);
                    c[l >> 2] = s;
                    v = c[n >> 2] | 0;
                    if (!(v >>> 0 < (c[b + 16 >> 2] | 0) >>> 0)) {
                        Fh(m, l);
                        z = y;
                        break
                    }
                    if ((v | 0) == 0) { A = 0 } else {
                        c[v >> 2] = s;
                        A = c[n >> 2] | 0
                    }
                    c[n >> 2] = A + 4;
                    z = y
                } else { z = r }
            } while (0);
            r = c[(c[p >> 2] | 0) + (z << 2) >> 2] | 0;
            p = c[d + 476 >> 2] | 0;
            if (p >>> 0 < 4 >>> 0) {
                Ph(r, c[d + 484 >> 2] | 0, c[d + 488 >> 2] | 0, p, d, 1, e, 0, f, g, h, j) | 0;
                a[r + 10516 | 0] = 0;
                i = k;
                return z | 0
            } else { ec(13160, 15872, 259, 17360); return 0 }
            return 0
        }

        function Dh(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            b = a + 36 | 0;
            d = a + 48 | 0;
            e = a + 52 | 0;
            c[e >> 2] = (c[e >> 2] | 0) - 1;
            e = (c[d >> 2] | 0) + 1 | 0;
            c[d >> 2] = e;
            if (!(e >>> 0 > 2047 >>> 0)) { return }
            Pu(c[c[b >> 2] >> 2] | 0);
            c[b >> 2] = (c[b >> 2] | 0) + 4;
            c[d >> 2] = (c[d >> 2] | 0) - 1024;
            return
        }

        function Eh(a) { a = a | 0; return }

        function Fh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a + 4 | 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f;
            h = (c[d >> 2] | 0) - g | 0;
            i = h >> 2;
            j = i + 1 | 0;
            if (j >>> 0 > 1073741823 >>> 0) { Nr(0) }
            k = a + 8 | 0;
            a = (c[k >> 2] | 0) - g | 0;
            if (a >> 2 >>> 0 < 536870911 >>> 0) {
                g = a >> 1;
                a = g >>> 0 < j >>> 0 ? j : g;
                if ((a | 0) == 0) {
                    l = 0;
                    m = 0
                } else {
                    n = a;
                    o = 5
                }
            } else {
                n = 1073741823;
                o = 5
            }
            if ((o | 0) == 5) {
                l = Nu(n << 2) | 0;
                m = n
            }
            n = l + (i << 2) | 0;
            if ((n | 0) != 0) { c[n >> 2] = c[b >> 2] }
            b = f;
            cv(l | 0, b | 0, h) | 0;
            c[e >> 2] = l;
            c[d >> 2] = l + (j << 2);
            c[k >> 2] = l + (m << 2);
            if ((f | 0) == 0) { return }
            Pu(b);
            return
        }

        function Gh(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            b = a + 4 | 0;
            d = c[b >> 2] | 0;
            e = a + 16 | 0;
            f = c[e >> 2] | 0;
            g = d + (f >>> 10 << 2) | 0;
            h = a + 8 | 0;
            i = c[h >> 2] | 0;
            if ((i | 0) == (d | 0)) {
                j = 0;
                k = 0;
                l = a + 20 | 0
            } else {
                m = a + 20 | 0;
                a = f + (c[m >> 2] | 0) | 0;
                j = (c[d + (a >>> 10 << 2) >> 2] | 0) + ((a & 1023) << 2) | 0;
                k = (c[g >> 2] | 0) + ((f & 1023) << 2) | 0;
                l = m
            }
            m = g;
            g = k;
            a: while (1) {
                k = g;
                do {
                    if ((k | 0) == (j | 0)) { break a }
                    k = k + 4 | 0;
                } while ((k - (c[m >> 2] | 0) | 0) != 4096);
                k = m + 4 | 0;
                m = k;
                g = c[k >> 2] | 0
            }
            c[l >> 2] = 0;
            l = i - d >> 2;
            if (l >>> 0 > 2 >>> 0) {
                i = d;
                while (1) {
                    Pu(c[i >> 2] | 0);
                    d = (c[b >> 2] | 0) + 4 | 0;
                    c[b >> 2] = d;
                    g = (c[h >> 2] | 0) - d >> 2;
                    if (g >>> 0 > 2 >>> 0) { i = d } else { n = g; break }
                }
            } else { n = l }
            if ((n | 0) == 2) { c[e >> 2] = 1024; return } else if ((n | 0) == 1) { c[e >> 2] = 512; return } else { return }
        }

        function Hh(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0;
            b = i;
            i = i + 48 | 0;
            d = b | 0;
            e = b + 8 | 0;
            f = b + 16 | 0;
            g = b + 40 | 0;
            h = a + 16 | 0;
            j = c[h >> 2] | 0;
            if (j >>> 0 > 1023 >>> 0) {
                c[h >> 2] = j - 1024;
                j = a + 4 | 0;
                h = c[j >> 2] | 0;
                k = c[h >> 2] | 0;
                l = h + 4 | 0;
                c[j >> 2] = l;
                m = a + 8 | 0;
                n = c[m >> 2] | 0;
                o = a + 12 | 0;
                do {
                    if ((n | 0) == (c[o >> 2] | 0)) {
                        p = a | 0;
                        q = c[p >> 2] | 0;
                        if (l >>> 0 > q >>> 0) {
                            r = l;
                            s = ((r - q >> 2) + 1 | 0) / -2 | 0;
                            t = n - r | 0;
                            fv(h + (s + 1 << 2) | 0, l | 0, t | 0) | 0;
                            r = h + ((t >> 2) + 1 + s << 2) | 0;
                            c[m >> 2] = r;
                            c[j >> 2] = (c[j >> 2] | 0) + (s << 2);
                            u = r;
                            v = 13;
                            break
                        }
                        r = n - q >> 1;
                        s = (r | 0) == 0 ? 1 : r;
                        r = Nu(s << 2) | 0;
                        t = r + (s >>> 2 << 2) | 0;
                        w = r + (s << 2) | 0;
                        if ((l | 0) == (n | 0)) {
                            x = t;
                            y = q
                        } else {
                            q = l;
                            s = t;
                            do {
                                if ((s | 0) == 0) { z = 0 } else {
                                    c[s >> 2] = c[q >> 2];
                                    z = s
                                }
                                s = z + 4 | 0;
                                q = q + 4 | 0;
                            } while ((q | 0) != (n | 0));
                            x = s;
                            y = c[p >> 2] | 0
                        }
                        c[p >> 2] = r;
                        c[j >> 2] = t;
                        c[m >> 2] = x;
                        c[o >> 2] = w;
                        if ((y | 0) == 0) {
                            A = x;
                            v = 12;
                            break
                        }
                        Pu(y);
                        A = c[m >> 2] | 0;
                        v = 12
                    } else {
                        A = n;
                        v = 12
                    }
                } while (0);
                if ((v | 0) == 12) {
                    if ((A | 0) == 0) { B = 0 } else {
                        u = A;
                        v = 13
                    }
                }
                if ((v | 0) == 13) {
                    c[u >> 2] = k;
                    B = c[m >> 2] | 0
                }
                c[m >> 2] = B + 4;
                i = b;
                return
            }
            B = a | 0;
            m = a + 8 | 0;
            k = c[m >> 2] | 0;
            u = a + 4 | 0;
            A = k - (c[u >> 2] | 0) >> 2;
            n = a + 12 | 0;
            y = c[n >> 2] | 0;
            x = a | 0;
            o = y - (c[x >> 2] | 0) | 0;
            if (!(A >>> 0 < o >> 2 >>> 0)) {
                j = o >> 1;
                o = (j | 0) == 0 ? 1 : j;
                j = f + 12 | 0;
                c[f + 16 >> 2] = a + 12;
                a = Nu(o << 2) | 0;
                z = f | 0;
                c[z >> 2] = a;
                l = a + (A << 2) | 0;
                A = f + 8 | 0;
                c[A >> 2] = l;
                h = f + 4 | 0;
                c[h >> 2] = l;
                c[j >> 2] = a + (o << 2);
                o = Nu(4096) | 0;
                c[g >> 2] = o;
                Kh(f, g);
                g = c[m >> 2] | 0;
                while (1) {
                    if ((g | 0) == (c[u >> 2] | 0)) { break }
                    o = g - 4 | 0;
                    Lh(f, o);
                    g = o
                }
                f = c[x >> 2] | 0;
                c[x >> 2] = c[z >> 2];
                c[z >> 2] = f;
                c[u >> 2] = c[h >> 2];
                c[h >> 2] = g;
                h = c[m >> 2] | 0;
                c[m >> 2] = c[A >> 2];
                c[A >> 2] = h;
                z = c[n >> 2] | 0;
                c[n >> 2] = c[j >> 2];
                c[j >> 2] = z;
                if ((h | 0) != (g | 0)) { c[A >> 2] = h + (~((h - 4 + (-g | 0) | 0) >>> 2) << 2) }
                if ((f | 0) == 0) { i = b; return }
                Pu(f);
                i = b;
                return
            }
            f = Nu(4096) | 0;
            if ((y | 0) != (k | 0)) {
                c[d >> 2] = f;
                Ih(B, d);
                i = b;
                return
            }
            c[e >> 2] = f;
            Jh(B, e);
            e = c[u >> 2] | 0;
            B = c[e >> 2] | 0;
            f = e + 4 | 0;
            c[u >> 2] = f;
            d = c[m >> 2] | 0;
            do {
                if ((d | 0) == (c[n >> 2] | 0)) {
                    k = c[x >> 2] | 0;
                    if (f >>> 0 > k >>> 0) {
                        y = f;
                        g = ((y - k >> 2) + 1 | 0) / -2 | 0;
                        h = d - y | 0;
                        fv(e + (g + 1 << 2) | 0, f | 0, h | 0) | 0;
                        y = e + ((h >> 2) + 1 + g << 2) | 0;
                        c[m >> 2] = y;
                        c[u >> 2] = (c[u >> 2] | 0) + (g << 2);
                        C = y;
                        v = 29;
                        break
                    }
                    y = d - k >> 1;
                    g = (y | 0) == 0 ? 1 : y;
                    y = Nu(g << 2) | 0;
                    h = y + (g >>> 2 << 2) | 0;
                    A = y + (g << 2) | 0;
                    if ((f | 0) == (d | 0)) {
                        D = h;
                        E = k
                    } else {
                        k = f;
                        g = h;
                        do {
                            if ((g | 0) == 0) { F = 0 } else {
                                c[g >> 2] = c[k >> 2];
                                F = g
                            }
                            g = F + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (d | 0));
                        D = g;
                        E = c[x >> 2] | 0
                    }
                    c[x >> 2] = y;
                    c[u >> 2] = h;
                    c[m >> 2] = D;
                    c[n >> 2] = A;
                    if ((E | 0) == 0) {
                        G = D;
                        v = 28;
                        break
                    }
                    Pu(E);
                    G = c[m >> 2] | 0;
                    v = 28
                } else {
                    G = d;
                    v = 28
                }
            } while (0);
            if ((v | 0) == 28) {
                if ((G | 0) == 0) { H = 0 } else {
                    C = G;
                    v = 29
                }
            }
            if ((v | 0) == 29) {
                c[C >> 2] = B;
                H = c[m >> 2] | 0
            }
            c[m >> 2] = H + 4;
            i = b;
            return
        }

        function Ih(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            f = a + 12 | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 4 | 0;
                    h = c[g >> 2] | 0;
                    i = a | 0;
                    j = c[i >> 2] | 0;
                    if (h >>> 0 > j >>> 0) {
                        k = h;
                        l = ((k - j >> 2) + 1 | 0) / -2 | 0;
                        m = e - k | 0;
                        fv(h + (l << 2) | 0, h | 0, m | 0) | 0;
                        k = h + (l + (m >> 2) << 2) | 0;
                        c[d >> 2] = k;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = k;
                        break
                    }
                    k = e - j >> 1;
                    l = (k | 0) == 0 ? 1 : k;
                    k = Nu(l << 2) | 0;
                    m = k + (l >>> 2 << 2) | 0;
                    o = k + (l << 2) | 0;
                    if ((h | 0) == (e | 0)) {
                        p = m;
                        q = j
                    } else {
                        j = h;
                        h = m;
                        do {
                            if ((h | 0) == 0) { r = 0 } else {
                                c[h >> 2] = c[j >> 2];
                                r = h
                            }
                            h = r + 4 | 0;
                            j = j + 4 | 0;
                        } while ((j | 0) != (e | 0));
                        p = h;
                        q = c[i >> 2] | 0
                    }
                    c[i >> 2] = k;
                    c[g >> 2] = m;
                    c[d >> 2] = p;
                    c[f >> 2] = o;
                    if ((q | 0) == 0) { n = p; break }
                    Pu(q);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            if ((n | 0) == 0) {
                s = 0;
                t = s + 4 | 0;
                c[d >> 2] = t;
                return
            }
            c[n >> 2] = c[b >> 2];
            s = c[d >> 2] | 0;
            t = s + 4 | 0;
            c[d >> 2] = t;
            return
        }

        function Jh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            d = a + 4 | 0;
            e = c[d >> 2] | 0;
            f = a | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 8 | 0;
                    h = c[g >> 2] | 0;
                    i = a + 12 | 0;
                    j = c[i >> 2] | 0;
                    k = j;
                    if (h >>> 0 < j >>> 0) {
                        j = h;
                        l = ((k - j >> 2) + 1 | 0) / 2 | 0;
                        m = j - e | 0;
                        j = h + (l - (m >> 2) << 2) | 0;
                        fv(j | 0, e | 0, m | 0) | 0;
                        c[d >> 2] = j;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = j;
                        break
                    }
                    j = k - e >> 1;
                    k = (j | 0) == 0 ? 1 : j;
                    j = Nu(k << 2) | 0;
                    l = j + ((k + 3 | 0) >>> 2 << 2) | 0;
                    m = j + (k << 2) | 0;
                    if ((e | 0) == (h | 0)) {
                        o = l;
                        p = e
                    } else {
                        k = e;
                        q = l;
                        do {
                            if ((q | 0) == 0) { r = 0 } else {
                                c[q >> 2] = c[k >> 2];
                                r = q
                            }
                            q = r + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (h | 0));
                        o = q;
                        p = c[f >> 2] | 0
                    }
                    c[f >> 2] = j;
                    c[d >> 2] = l;
                    c[g >> 2] = o;
                    c[i >> 2] = m;
                    if ((p | 0) == 0) { n = l; break }
                    Pu(p);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            c[n - 4 >> 2] = c[b >> 2];
            c[d >> 2] = (c[d >> 2] | 0) - 4;
            return
        }

        function Kh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            f = a + 12 | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 4 | 0;
                    h = c[g >> 2] | 0;
                    i = a | 0;
                    j = c[i >> 2] | 0;
                    if (h >>> 0 > j >>> 0) {
                        k = h;
                        l = ((k - j >> 2) + 1 | 0) / -2 | 0;
                        m = e - k | 0;
                        fv(h + (l << 2) | 0, h | 0, m | 0) | 0;
                        k = h + (l + (m >> 2) << 2) | 0;
                        c[d >> 2] = k;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = k;
                        break
                    }
                    k = e - j >> 1;
                    l = (k | 0) == 0 ? 1 : k;
                    k = Nu(l << 2) | 0;
                    m = k + (l >>> 2 << 2) | 0;
                    o = k + (l << 2) | 0;
                    if ((h | 0) == (e | 0)) {
                        p = m;
                        q = j
                    } else {
                        j = h;
                        h = m;
                        do {
                            if ((h | 0) == 0) { r = 0 } else {
                                c[h >> 2] = c[j >> 2];
                                r = h
                            }
                            h = r + 4 | 0;
                            j = j + 4 | 0;
                        } while ((j | 0) != (e | 0));
                        p = h;
                        q = c[i >> 2] | 0
                    }
                    c[i >> 2] = k;
                    c[g >> 2] = m;
                    c[d >> 2] = p;
                    c[f >> 2] = o;
                    if ((q | 0) == 0) { n = p; break }
                    Pu(q);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            if ((n | 0) == 0) {
                s = 0;
                t = s + 4 | 0;
                c[d >> 2] = t;
                return
            }
            c[n >> 2] = c[b >> 2];
            s = c[d >> 2] | 0;
            t = s + 4 | 0;
            c[d >> 2] = t;
            return
        }

        function Lh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            d = a + 4 | 0;
            e = c[d >> 2] | 0;
            f = a | 0;
            do {
                if ((e | 0) == (c[f >> 2] | 0)) {
                    g = a + 8 | 0;
                    h = c[g >> 2] | 0;
                    i = a + 12 | 0;
                    j = c[i >> 2] | 0;
                    k = j;
                    if (h >>> 0 < j >>> 0) {
                        j = h;
                        l = ((k - j >> 2) + 1 | 0) / 2 | 0;
                        m = j - e | 0;
                        j = h + (l - (m >> 2) << 2) | 0;
                        fv(j | 0, e | 0, m | 0) | 0;
                        c[d >> 2] = j;
                        c[g >> 2] = (c[g >> 2] | 0) + (l << 2);
                        n = j;
                        break
                    }
                    j = k - e >> 1;
                    k = (j | 0) == 0 ? 1 : j;
                    j = Nu(k << 2) | 0;
                    l = j + ((k + 3 | 0) >>> 2 << 2) | 0;
                    m = j + (k << 2) | 0;
                    if ((e | 0) == (h | 0)) {
                        o = l;
                        p = e
                    } else {
                        k = e;
                        q = l;
                        do {
                            if ((q | 0) == 0) { r = 0 } else {
                                c[q >> 2] = c[k >> 2];
                                r = q
                            }
                            q = r + 4 | 0;
                            k = k + 4 | 0;
                        } while ((k | 0) != (h | 0));
                        o = q;
                        p = c[f >> 2] | 0
                    }
                    c[f >> 2] = j;
                    c[d >> 2] = l;
                    c[g >> 2] = o;
                    c[i >> 2] = m;
                    if ((p | 0) == 0) { n = l; break }
                    Pu(p);
                    n = c[d >> 2] | 0
                } else { n = e }
            } while (0);
            c[n - 4 >> 2] = c[b >> 2];
            c[d >> 2] = (c[d >> 2] | 0) - 4;
            return
        }

        function Mh(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            e = c[b + 4 >> 2] | 0;
            a = c[b + 8 >> 2] | 0;
            f = (a | 0) / (c[d + 5784 >> 2] | 0) | 0;
            g = c[b + 12 >> 2] | 0;
            b = e - 1 + g | 0;
            h = b - ((b | 0) % (g | 0) | 0) | 0;
            b = ((e | 0) / (c[d + 5780 >> 2] | 0) | 0) - 1 + g | 0;
            e = b - ((b | 0) % (g | 0) | 0) | 0;
            g = c[d + 5760 >> 2] | 0;
            if (!((g - 8 | 0) >>> 0 < 9 >>> 0)) { ec(15720, 15792, 115, 17912); return 0 }
            b = c[d + 5768 >> 2] | 0;
            if (!((b - 8 | 0) >>> 0 < 9 >>> 0)) { ec(15344, 15792, 116, 17912); return 0 }
            i = Ku(16, ga(ga(h, a) | 0, (g + 7 | 0) / 8 | 0) | 0) | 0;
            g = (i | 0) == 0;
            do {
                if ((c[d + 20 >> 2] | 0) == 0) {
                    if (g) { j = 0 } else {
                        k = 0;
                        l = 0;
                        m = 0;
                        break
                    }
                    return j | 0
                } else {
                    a = ga(ga(e, f) | 0, (b + 7 | 0) / 8 | 0) | 0;
                    n = Ku(16, a) | 0;
                    o = Ku(16, a) | 0;
                    if (!((n | 0) == 0 | (o | 0) == 0 | g)) {
                        k = e;
                        l = n;
                        m = o;
                        break
                    }
                    if (!g) { Hu(i) }
                    if ((n | 0) != 0) { Hu(n) }
                    if ((o | 0) == 0) { j = 0; return j | 0 }
                    Hu(o);
                    j = 0;
                    return j | 0
                }
            } while (0);
            c[d + 4 >> 2] = i;
            c[d + 10492 >> 2] = 0;
            c[d + 40 >> 2] = h;
            c[d + 8 >> 2] = l;
            c[d + 10496 >> 2] = 0;
            c[d + 12 >> 2] = m;
            c[d + 10500 >> 2] = 0;
            c[d + 44 >> 2] = k;
            j = 1;
            return j | 0
        }

        function Nh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            d = c[b + 4 >> 2] | 0;
            if ((d | 0) != 0) { Hu(d) }
            d = c[b + 8 >> 2] | 0;
            if ((d | 0) != 0) { Hu(d) }
            d = c[b + 12 >> 2] | 0;
            if ((d | 0) == 0) { return }
            Hu(d);
            return
        }

        function Oh(b) {
            b = b | 0;
            c[b + 48 >> 2] = 0;
            c[b + 52 >> 2] = 0;
            c[b + 56 >> 2] = 0;
            c[b + 700 >> 2] = 0;
            c[b + 704 >> 2] = 0;
            c[b + 708 >> 2] = 0;
            dv(b + 736 | 0, 0, 24) | 0;
            ik(b + 764 | 0);
            jj(b + 5932 | 0);
            a[b + 10518 | 0] = 0;
            a[b + 10519 | 0] = 0;
            a[b + 10520 | 0] = 0;
            dv(b + 10340 | 0, 0, 140) | 0;
            c[b >> 2] = -1;
            c[b + 104 >> 2] = 0;
            c[b + 10332 >> 2] = 0;
            c[b + 10336 >> 2] = 0;
            c[b + 10512 >> 2] = 0;
            c[b + 4 >> 2] = 0;
            c[b + 60 >> 2] = 0;
            c[b + 8 >> 2] = 0;
            c[b + 64 >> 2] = 0;
            c[b + 12 >> 2] = 0;
            c[b + 68 >> 2] = 0;
            c[b + 28 >> 2] = 0;
            c[b + 24 >> 2] = 0;
            c[b + 10524 >> 2] = 0;
            dv(b + 10480 | 0, 0, 24) | 0;
            a[b + 10516 | 0] = 2;
            c[b + 88 >> 2] = -1;
            c[b + 92 >> 2] = -1;
            c[b + 96 >> 2] = 0;
            a[b + 100 | 0] = 0;
            dv(b + 10528 | 0, 0, 20) | 0;
            tk(b + 10548 | 0);
            xk(b + 10572 | 0);
            return
        }

        function Ph(b, d, e, f, g, h, j, k, l, m, n, o) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            var p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0;
            p = i;
            i = i + 40 | 0;
            q = p | 0;
            if ((g | 0) == 0) { ec(13112, 15792, 240, 17792); return 0 }
            r = b + 764 | 0;
            cv(r | 0, g | 0, 4717) | 0;
            if ((r | 0) != (g | 0)) { zf(b + 5484 | 0, c[g + 4720 >> 2] | 0, c[g + 4724 >> 2] | 0) }
            cv(b + 5496 | 0, g + 4732 | 0, 436) | 0;
            Qh(b);
            r = c[8838] | 0;
            c[8838] = r + 1;
            c[b >> 2] = r;
            c[b + 104 >> 2] = 2147483647;
            c[b + 10332 >> 2] = j;
            c[b + 10336 >> 2] = k;
            c[b + 20 >> 2] = f;
            c[b + 24 >> 2] = d;
            c[b + 28 >> 2] = e;
            r = b + 32 | 0;
            c[r >> 2] = d;
            s = b + 36 | 0;
            c[s >> 2] = e;
            c[b + 10488 >> 2] = n;
            n = b + 10480 | 0;
            c[n >> 2] = l;
            c[n + 4 >> 2] = m;
            if ((f | 0) == 2) {
                t = 1;
                u = 8
            } else if ((f | 0) == 0 | (f | 0) == 3) {
                v = 1;
                w = 1
            } else if ((f | 0) == 1) {
                t = 2;
                u = 8
            } else { ec(10232, 15792, 276, 17792); return 0 }
            if ((u | 0) == 8) {
                v = 2;
                w = t
            }
            if ((f | 0) == 0) {
                c[q >> 2] = 1;
                c[r >> 2] = 0;
                c[s >> 2] = 0;
                x = 0;
                y = 0
            } else if ((f | 0) == 1) {
                c[q >> 2] = 2;
                t = (d + 1 | 0) / 2 | 0;
                c[r >> 2] = t;
                m = (e + 1 | 0) / 2 | 0;
                c[s >> 2] = m;
                x = t;
                y = m
            } else if ((f | 0) == 2) {
                c[q >> 2] = 3;
                m = (d + 1 | 0) / 2 | 0;
                c[r >> 2] = m;
                x = m;
                y = e
            } else if ((f | 0) == 3) {
                c[q >> 2] = 4;
                x = d;
                y = e
            } else { ec(7192, 15792, 302, 17792); return 0 }
            c[q + 4 >> 2] = d;
            c[q + 8 >> 2] = e;
            c[q + 12 >> 2] = 16;
            f = c[g + 496 >> 2] | 0;
            m = c[g + 500 >> 2] | 0;
            r = c[g + 504 >> 2] | 0;
            t = c[g + 508 >> 2] | 0;
            s = m + f | 0;
            n = d - (ga(s, v) | 0) | 0;
            c[b + 72 >> 2] = n;
            d = t + r | 0;
            l = e - (ga(d, w) | 0) | 0;
            c[b + 76 >> 2] = l;
            c[b + 80 >> 2] = x - s;
            c[b + 84 >> 2] = y - d;
            d = ga(f, v) | 0;
            c[q + 16 >> 2] = d;
            y = ga(m, v) | 0;
            c[q + 20 >> 2] = y;
            y = ga(r, w) | 0;
            c[q + 24 >> 2] = y;
            v = ga(t, w) | 0;
            c[q + 28 >> 2] = v;
            c[q + 32 >> 2] = n;
            c[q + 36 >> 2] = l;
            a[b + 16 | 0] = (c[g + 4996 >> 2] | 0) > 8 | 0;
            l = (c[g + 5004 >> 2] | 0) > 8 | 0;
            a[b + 17 | 0] = l;
            a[b + 18 | 0] = l;
            l = (j | 0) == 0;
            if (l) { z = 0 } else { z = c[j + 544 >> 2] | 0 }
            n = (k | 0) == 0;
            do {
                if (n) {
                    A = z;
                    B = o ^ 1;
                    u = 23
                } else {
                    v = c[k + 3060 >> 2] | 0;
                    w = o ^ 1;
                    if (n | w) {
                        A = v;
                        B = w;
                        u = 23;
                        break
                    }
                    w = c[k + 3064 >> 2] | 0;
                    c[b + 10512 >> 2] = w;
                    t = b + 10504 | 0;
                    if ((w | 0) == 0) {
                        w = t;
                        m = 27248;
                        s = c[m >> 2] | 0;
                        x = c[m + 4 >> 2] | 0;
                        c[w >> 2] = s;
                        c[w + 4 >> 2] = x;
                        C = s;
                        D = v;
                        u = 26;
                        break
                    } else {
                        c[t >> 2] = 0;
                        c[b + 10508 >> 2] = 0;
                        break
                    }
                }
            } while (0);
            do {
                if ((u | 0) == 23) {
                    k = b + 10504 | 0;
                    if (l | B) {
                        n = k;
                        o = 27248;
                        z = c[o >> 2] | 0;
                        t = c[o + 4 >> 2] | 0;
                        c[n >> 2] = z;
                        c[n + 4 >> 2] = t;
                        C = z;
                        D = A;
                        u = 26;
                        break
                    } else {
                        z = j + 536 | 0;
                        t = k;
                        k = c[z >> 2] | 0;
                        n = c[z + 4 >> 2] | 0;
                        c[t >> 2] = k;
                        c[t + 4 >> 2] = n;
                        C = k;
                        D = A;
                        u = 26;
                        break
                    }
                }
            } while (0);
            do {
                if ((u | 0) == 26) {
                    if ((C | 0) == 0) { break }
                    A = (Sc[C & 15](j, q, b, D) | 0) == 0;
                    B = (c[b + 4 >> 2] | 0) + ((ga(c[b + 40 >> 2] | 0, y) | 0) + d) | 0;
                    c[b + 60 >> 2] = B;
                    B = (ga(c[b + 44 >> 2] | 0, r) | 0) + f | 0;
                    c[b + 64 >> 2] = (c[b + 8 >> 2] | 0) + B;
                    c[b + 68 >> 2] = (c[b + 12 >> 2] | 0) + B;
                    if (A) { E = 7 } else { break }
                    F = 40;
                    G = 0;
                    i = p;
                    return E | 0
                }
            } while (0);
            do {
                if (h) {
                    f = g + 5112 | 0;
                    r = c[f >> 2] | 0;
                    d = g + 5116 | 0;
                    y = c[d >> 2] | 0;
                    D = g + 5108 | 0;
                    q = c[D >> 2] | 0;
                    j = ga(y, r) | 0;
                    C = b + 10404 | 0;
                    A = b + 10400 | 0;
                    B = c[A >> 2] | 0;
                    do {
                        if ((j | 0) == (c[C >> 2] | 0)) {
                            H = B;
                            u = 33
                        } else {
                            Hu(B);
                            l = Gu(j) | 0;
                            c[A >> 2] = l;
                            if ((l | 0) == 0) {
                                c[C >> 2] = 0;
                                I = 0;
                                break
                            } else {
                                c[C >> 2] = j;
                                H = l;
                                u = 33;
                                break
                            }
                        }
                    } while (0);
                    if ((u | 0) == 33) {
                        c[b + 10412 >> 2] = r;
                        c[b + 10416 >> 2] = y;
                        c[b + 10408 >> 2] = q;
                        I = (H | 0) != 0
                    }
                    j = c[f >> 2] | 0;
                    C = c[d >> 2] | 0;
                    A = c[D >> 2] | 0;
                    B = ga(C, j) | 0;
                    l = b + 10424 | 0;
                    k = b + 10420 | 0;
                    n = c[k >> 2] | 0;
                    do {
                        if ((B | 0) == (c[l >> 2] | 0)) {
                            J = n;
                            u = 38
                        } else {
                            Hu(n);
                            t = Gu(B) | 0;
                            c[k >> 2] = t;
                            if ((t | 0) == 0) {
                                c[l >> 2] = 0;
                                L = 0;
                                break
                            } else {
                                c[l >> 2] = B;
                                J = t;
                                u = 38;
                                break
                            }
                        }
                    } while (0);
                    if ((u | 0) == 38) {
                        c[b + 10432 >> 2] = j;
                        c[b + 10436 >> 2] = C;
                        c[b + 10428 >> 2] = A;
                        L = (J | 0) != 0
                    }
                    B = I & L;
                    l = g + 5052 | 0;
                    k = c[l >> 2] | 0;
                    n = g + 5060 | 0;
                    D = c[n >> 2] | 0;
                    d = g + 5036 | 0;
                    f = c[d >> 2] | 0;
                    q = ga(D, k) | 0;
                    y = b + 10364 | 0;
                    r = b + 10360 | 0;
                    t = c[r >> 2] | 0;
                    do {
                        if ((q | 0) == (c[y >> 2] | 0)) {
                            M = t;
                            u = 43
                        } else {
                            Hu(t | 0);
                            z = Gu(q * 3 | 0) | 0;
                            o = z;
                            c[r >> 2] = o;
                            if ((z | 0) == 0) {
                                c[y >> 2] = 0;
                                N = 0;
                                break
                            } else {
                                c[y >> 2] = q;
                                M = o;
                                u = 43;
                                break
                            }
                        }
                    } while (0);
                    if ((u | 0) == 43) {
                        c[b + 10372 >> 2] = k;
                        c[b + 10376 >> 2] = D;
                        c[b + 10368 >> 2] = f;
                        N = (M | 0) != 0
                    }
                    q = B & N;
                    y = (c[d >> 2] | 0) - 2 | 0;
                    r = c[l >> 2] << y;
                    t = c[n >> 2] << y;
                    y = ga(t, r) | 0;
                    A = b + 10384 | 0;
                    C = b + 10380 | 0;
                    j = c[C >> 2] | 0;
                    do {
                        if ((y | 0) == (c[A >> 2] | 0)) {
                            O = j;
                            u = 48
                        } else {
                            Hu(j | 0);
                            o = Gu(y * 12 | 0) | 0;
                            z = o;
                            c[C >> 2] = z;
                            if ((o | 0) == 0) {
                                c[A >> 2] = 0;
                                P = 0;
                                break
                            } else {
                                c[A >> 2] = y;
                                O = z;
                                u = 48;
                                break
                            }
                        }
                    } while (0);
                    if ((u | 0) == 48) {
                        c[b + 10392 >> 2] = r;
                        c[b + 10396 >> 2] = t;
                        c[b + 10388 >> 2] = 2;
                        P = (O | 0) != 0
                    }
                    y = q & P;
                    A = c[g + 5088 >> 2] | 0;
                    C = c[g + 5092 >> 2] | 0;
                    j = c[g + 5100 >> 2] | 0;
                    n = ga(C, A) | 0;
                    l = b + 10444 | 0;
                    d = b + 10440 | 0;
                    B = c[d >> 2] | 0;
                    do {
                        if ((n | 0) == (c[l >> 2] | 0)) {
                            Q = B;
                            u = 53
                        } else {
                            Hu(B);
                            f = Gu(n) | 0;
                            c[d >> 2] = f;
                            if ((f | 0) == 0) {
                                c[l >> 2] = 0;
                                R = 0;
                                break
                            } else {
                                c[l >> 2] = n;
                                Q = f;
                                u = 53;
                                break
                            }
                        }
                    } while (0);
                    if ((u | 0) == 53) {
                        c[b + 10452 >> 2] = A;
                        c[b + 10456 >> 2] = C;
                        c[b + 10448 >> 2] = j;
                        R = (Q | 0) != 0
                    }
                    n = y & R;
                    l = ((c[g + 484 >> 2] | 0) + 3 | 0) / 4 | 0;
                    d = ((c[g + 488 >> 2] | 0) + 3 | 0) / 4 | 0;
                    B = ga(d, l) | 0;
                    q = b + 10464 | 0;
                    t = b + 10460 | 0;
                    r = c[t >> 2] | 0;
                    do {
                        if ((B | 0) == (c[q >> 2] | 0)) {
                            S = r;
                            u = 58
                        } else {
                            Hu(r);
                            f = Gu(B) | 0;
                            c[t >> 2] = f;
                            if ((f | 0) == 0) {
                                c[q >> 2] = 0;
                                T = 0;
                                break
                            } else {
                                c[q >> 2] = B;
                                S = f;
                                u = 58;
                                break
                            }
                        }
                    } while (0);
                    if ((u | 0) == 58) {
                        c[b + 10472 >> 2] = l;
                        c[b + 10476 >> 2] = d;
                        c[b + 10468 >> 2] = 2;
                        T = (S | 0) != 0
                    }
                    B = n & T;
                    q = b + 10344 | 0;
                    t = c[q >> 2] | 0;
                    if ((t | 0) == (c[g + 5072 >> 2] | 0)) {
                        if (B) { break } else { E = 7 }
                        F = 40;
                        G = 0;
                        i = p;
                        return E | 0
                    }
                    r = b + 10524 | 0;
                    y = c[r >> 2] | 0;
                    if ((y | 0) == 0) { U = t } else {
                        t = y - 76 + 72 | 0;
                        j = t;
                        C = c[t >> 2] | 0;
                        if ((C | 0) != 0) {
                            t = y + (C * 76 | 0) | 0;
                            do {
                                t = t - 76 | 0;
                                Ck(t);
                            } while ((t | 0) != (y | 0))
                        }
                        Qu(j);
                        U = c[q >> 2] | 0
                    }
                    y = c[g + 5056 >> 2] | 0;
                    t = c[g + 5064 >> 2] | 0;
                    n = c[g + 5040 >> 2] | 0;
                    d = ga(t, y) | 0;
                    l = b + 10340 | 0;
                    C = c[l >> 2] | 0;
                    do {
                        if ((d | 0) == (U | 0)) {
                            V = C;
                            W = U;
                            u = 69
                        } else {
                            Hu(C);
                            A = Gu(d * 24 | 0) | 0;
                            f = A;
                            c[l >> 2] = f;
                            if ((A | 0) == 0) {
                                c[q >> 2] = 0;
                                X = 0;
                                Y = 0;
                                break
                            } else {
                                c[q >> 2] = d;
                                V = f;
                                W = d;
                                u = 69;
                                break
                            }
                        }
                    } while (0);
                    if ((u | 0) == 69) {
                        c[b + 10352 >> 2] = y;
                        c[b + 10356 >> 2] = t;
                        c[b + 10348 >> 2] = n;
                        X = (V | 0) != 0;
                        Y = W
                    }
                    d = B & X;
                    q = Ra(Y | 0, 76) | 0;
                    l = K;
                    C = sb(q | 0, 4) | 0;
                    q = Ou(l | K ? -1 : C) | 0;
                    c[q >> 2] = Y;
                    C = q + 4 | 0;
                    if ((Y | 0) != 0) {
                        q = C + (Y * 76 | 0) | 0;
                        l = C;
                        do {
                            Bk(l);
                            l = l + 76 | 0;
                        } while ((l | 0) != (q | 0))
                    }
                    c[r >> 2] = C;
                    if (d) { break } else { E = 7 }
                    F = 40;
                    G = 0;
                    i = p;
                    return E | 0
                }
            } while (0);
            E = 0;
            F = 40;
            G = 0;
            i = p;
            return E | 0
        }

        function Qh(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            b = a + 4 | 0;
            if ((c[b >> 2] | 0) != 0) {
                d = c[a + 10512 >> 2] | 0;
                if ((d | 0) == 0) {
                    e = c[a + 10332 >> 2] | 0;
                    if ((e | 0) == 0) { f = 0 } else { f = c[e + 544 >> 2] | 0 }
                    Tc[c[a + 10508 >> 2] & 63](e, a, f)
                } else {
                    f = c[a + 10336 >> 2] | 0;
                    Tc[d & 63](f, a, c[f + 3060 >> 2] | 0)
                }
                c[b >> 2] = 0;
                c[a + 60 >> 2] = 0;
                c[a + 8 >> 2] = 0;
                c[a + 64 >> 2] = 0;
                c[a + 12 >> 2] = 0;
                c[a + 68 >> 2] = 0
            }
            b = a + 52 | 0;
            f = c[b >> 2] | 0;
            d = a + 48 | 0;
            a = c[d >> 2] | 0;
            if ((f | 0) == (a | 0)) { return } else {
                g = 0;
                h = a;
                i = f
            }
            while (1) {
                f = c[h + (g << 2) >> 2] | 0;
                if ((f | 0) == 0) {
                    j = i;
                    k = h
                } else {
                    a = c[f + 1344 >> 2] | 0;
                    if ((a | 0) != 0) {
                        e = f + 1348 | 0;
                        l = c[e >> 2] | 0;
                        if ((l | 0) != (a | 0)) { c[e >> 2] = l + (~((l - 4 + (-a | 0) | 0) >>> 2) << 2) }
                        Pu(a)
                    }
                    Ed(f + 1332 | 0);
                    a = c[f + 776 >> 2] | 0;
                    if ((a | 0) != 0) {
                        l = f + 780 | 0;
                        e = c[l >> 2] | 0;
                        if ((e | 0) != (a | 0)) { c[l >> 2] = e + (~((e - 4 + (-a | 0) | 0) >>> 2) << 2) }
                        Pu(a)
                    }
                    Pu(f);
                    j = c[b >> 2] | 0;
                    k = c[d >> 2] | 0
                }
                f = g + 1 | 0;
                m = k;
                if (f >>> 0 < j - m >> 2 >>> 0) {
                    g = f;
                    h = k;
                    i = j
                } else { break }
            }
            if ((j | 0) == (k | 0)) { return }
            c[b >> 2] = j + (~((j - 4 + (-m | 0) | 0) >>> 2) << 2);
            return
        }

        function Rh(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0;
            Qh(a);
            b = c[a + 10524 >> 2] | 0;
            if ((b | 0) != 0) {
                d = b - 76 + 72 | 0;
                e = d;
                f = c[d >> 2] | 0;
                if ((f | 0) != 0) {
                    d = b + (f * 76 | 0) | 0;
                    do {
                        d = d - 76 | 0;
                        Ck(d);
                    } while ((d | 0) != (b | 0))
                }
                Qu(e)
            }
            yk(a + 10572 | 0);
            uk(a + 10548 | 0);
            Hu(c[a + 10460 >> 2] | 0);
            Hu(c[a + 10440 >> 2] | 0);
            Hu(c[a + 10420 >> 2] | 0);
            Hu(c[a + 10400 >> 2] | 0);
            Hu(c[a + 10380 >> 2] | 0);
            Hu(c[a + 10360 >> 2] | 0);
            Hu(c[a + 10340 >> 2] | 0);
            kj(a + 5932 | 0);
            jk(a + 764 | 0);
            Jf(a + 108 | 0);
            e = c[a + 48 >> 2] | 0;
            if ((e | 0) == 0) { return }
            b = a + 52 | 0;
            a = c[b >> 2] | 0;
            if ((a | 0) != (e | 0)) { c[b >> 2] = a + (~((a - 4 + (-e | 0) | 0) >>> 2) << 2) }
            Pu(e);
            return
        }

        function Sh(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            if ((b | 0) > -1) { dv(c[a + 4 >> 2] | 0, b & 255 | 0, ga(c[a + 28 >> 2] | 0, c[a + 40 >> 2] | 0) | 0) | 0 }
            if ((d | 0) > -1) { dv(c[a + 8 >> 2] | 0, d & 255 | 0, ga(c[a + 36 >> 2] | 0, c[a + 44 >> 2] | 0) | 0) | 0 }
            if (!((e | 0) > -1)) { return }
            dv(c[a + 12 >> 2] | 0, e & 255 | 0, ga(c[a + 36 >> 2] | 0, c[a + 44 >> 2] | 0) | 0) | 0;
            return
        }

        function Th(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            f = c[b + 28 >> 2] | 0;
            g = (f | 0) < (e | 0) ? f : e;
            if ((d & 1 | 0) != 0) { ec(5264, 15792, 535, 17776) }
            if ((g & 1 | 0) != 0) { ec(3744, 15792, 536, 17776) }
            e = ((c[a + 5760 >> 2] | 0) + 7 | 0) / 8 | 0;
            f = ((c[a + 5768 >> 2] | 0) + 7 | 0) / 8 | 0;
            h = b + 40 | 0;
            i = c[h >> 2] | 0;
            j = a + 40 | 0;
            k = c[j >> 2] | 0;
            a: do {
                if ((i | 0) == (k | 0)) {
                    l = ga(ga(e, d) | 0, i) | 0;
                    cv((c[a + 4 >> 2] | 0) + l | 0, (c[b + 4 >> 2] | 0) + l | 0, ga(ga(e, g - d | 0) | 0, i) | 0) | 0
                } else {
                    if ((g | 0) <= (d | 0)) { break }
                    l = a + 4 | 0;
                    m = b + 4 | 0;
                    n = b + 24 | 0;
                    o = d;
                    p = k;
                    q = i;
                    while (1) {
                        r = ga(o, e) | 0;
                        s = (c[l >> 2] | 0) + (ga(r, p) | 0) | 0;
                        t = (c[m >> 2] | 0) + (ga(r, q) | 0) | 0;
                        cv(s | 0, t | 0, ga(c[n >> 2] | 0, e) | 0) | 0;
                        t = o + 1 | 0;
                        if ((t | 0) >= (g | 0)) { break a }
                        o = t;
                        p = c[j >> 2] | 0;
                        q = c[h >> 2] | 0
                    }
                }
            } while (0);
            h = c[b + 5784 >> 2] | 0;
            j = (d | 0) / (h | 0) | 0;
            d = (g | 0) / (h | 0) | 0;
            if ((c[b + 20 >> 2] | 0) == 0) { return }
            h = b + 44 | 0;
            g = c[h >> 2] | 0;
            e = a + 44 | 0;
            i = c[e >> 2] | 0;
            if ((g | 0) == (i | 0)) {
                k = ga(j, f) | 0;
                q = ga(k, g) | 0;
                p = ga(d - j | 0, f) | 0;
                cv((c[a + 8 >> 2] | 0) + q | 0, (c[b + 8 >> 2] | 0) + q | 0, ga(p, g) | 0) | 0;
                q = c[e >> 2] | 0;
                o = ga(k, q) | 0;
                cv((c[a + 12 >> 2] | 0) + o | 0, (c[b + 12 >> 2] | 0) + o | 0, ga(p, q) | 0) | 0;
                return
            }
            if ((j | 0) >= (d | 0)) { return }
            q = a + 8 | 0;
            p = b + 8 | 0;
            o = b + 32 | 0;
            k = a + 12 | 0;
            a = b + 12 | 0;
            b = j;
            j = i;
            i = g;
            while (1) {
                g = ga(b, f) | 0;
                n = (c[q >> 2] | 0) + (ga(g, j) | 0) | 0;
                m = (c[p >> 2] | 0) + (ga(g, i) | 0) | 0;
                cv(n | 0, m | 0, ga(c[o >> 2] | 0, f) | 0) | 0;
                m = (c[k >> 2] | 0) + (ga(g, c[e >> 2] | 0) | 0) | 0;
                n = (c[a >> 2] | 0) + (ga(g, c[h >> 2] | 0) | 0) | 0;
                cv(m | 0, n | 0, ga(c[o >> 2] | 0, f) | 0) | 0;
                n = b + 1 | 0;
                if ((n | 0) >= (d | 0)) { break }
                b = n;
                j = c[e >> 2] | 0;
                i = c[h >> 2] | 0
            }
            return
        }

        function Uh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0;
            d = a + 4 | 0;
            e = b + 4 | 0;
            f = c[d >> 2] | 0;
            c[d >> 2] = c[e >> 2];
            c[e >> 2] = f;
            f = a + 60 | 0;
            e = b + 60 | 0;
            d = c[f >> 2] | 0;
            c[f >> 2] = c[e >> 2];
            c[e >> 2] = d;
            d = a + 10492 | 0;
            e = b + 10492 | 0;
            f = c[d >> 2] | 0;
            c[d >> 2] = c[e >> 2];
            c[e >> 2] = f;
            f = a + 8 | 0;
            e = b + 8 | 0;
            d = c[f >> 2] | 0;
            c[f >> 2] = c[e >> 2];
            c[e >> 2] = d;
            d = a + 64 | 0;
            e = b + 64 | 0;
            f = c[d >> 2] | 0;
            c[d >> 2] = c[e >> 2];
            c[e >> 2] = f;
            f = a + 10496 | 0;
            e = b + 10496 | 0;
            d = c[f >> 2] | 0;
            c[f >> 2] = c[e >> 2];
            c[e >> 2] = d;
            d = a + 12 | 0;
            e = b + 12 | 0;
            f = c[d >> 2] | 0;
            c[d >> 2] = c[e >> 2];
            c[e >> 2] = f;
            f = a + 68 | 0;
            e = b + 68 | 0;
            d = c[f >> 2] | 0;
            c[f >> 2] = c[e >> 2];
            c[e >> 2] = d;
            d = a + 10500 | 0;
            e = b + 10500 | 0;
            f = c[d >> 2] | 0;
            c[d >> 2] = c[e >> 2];
            c[e >> 2] = f;
            f = a + 40 | 0;
            e = b + 40 | 0;
            d = c[f >> 2] | 0;
            c[f >> 2] = c[e >> 2];
            c[e >> 2] = d;
            d = a + 44 | 0;
            e = b + 44 | 0;
            f = c[d >> 2] | 0;
            c[d >> 2] = c[e >> 2];
            c[e >> 2] = f;
            f = a + 10504 | 0;
            a = c[f >> 2] | 0;
            e = c[f + 4 >> 2] | 0;
            d = b + 10504 | 0;
            b = c[d + 4 >> 2] | 0;
            c[f >> 2] = c[d >> 2];
            c[f + 4 >> 2] = b;
            c[d >> 2] = a;
            c[d + 4 >> 2] = e;
            return
        }

        function Vh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0;
            d = a + 10548 | 0;
            vk(d);
            e = a + 10528 | 0;
            c[e >> 2] = (c[e >> 2] | 0) + b;
            e = a + 10544 | 0;
            c[e >> 2] = (c[e >> 2] | 0) + b;
            wk(d);
            return
        }

        function Wh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            b = a + 10548 | 0;
            vk(b);
            d = a + 10528 | 0;
            c[d >> 2] = (c[d >> 2] | 0) - 1;
            d = a + 10532 | 0;
            c[d >> 2] = (c[d >> 2] | 0) + 1;
            wk(b);
            return
        }

        function Xh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0;
            b = a + 10548 | 0;
            vk(b);
            d = a + 10532 | 0;
            e = c[d >> 2] | 0;
            c[d >> 2] = e - 1;
            d = a + 10540 | 0;
            f = (c[d >> 2] | 0) + 1 | 0;
            c[d >> 2] = f;
            if ((e | 0) <= 0) { ec(2424, 15792, 642, 17760) }
            if ((f | 0) != (c[a + 10544 >> 2] | 0)) { wk(b); return }
            zk(a + 10572 | 0, b);
            wk(b);
            return
        }

        function Yh(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            Zh(a, b, (ga(c[a + 5820 >> 2] | 0, e) | 0) + d | 0, f);
            return
        }

        function Zh(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0;
            if ((b | 0) == 0) { return }
            f = (c[a + 10524 >> 2] | 0) + (d * 76 | 0) | 0;
            if ((Gk(f) | 0) >= (e | 0)) { return }
            d = a + 10548 | 0;
            vk(d);
            g = a + 10532 | 0;
            c[g >> 2] = (c[g >> 2] | 0) - 1;
            h = a + 10536 | 0;
            c[h >> 2] = (c[h >> 2] | 0) + 1;
            wk(d);
            a = b + 4 | 0;
            c[a >> 2] = 2;
            Dk(f, e);
            c[a >> 2] = 1;
            vk(d);
            c[h >> 2] = (c[h >> 2] | 0) - 1;
            c[g >> 2] = (c[g >> 2] | 0) + 1;
            wk(d);
            return
        }

        function _h(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0;
            b = a + 10548 | 0;
            vk(b);
            d = a + 10540 | 0;
            e = a + 10544 | 0;
            if ((c[d >> 2] | 0) == (c[e >> 2] | 0)) { wk(b); return }
            f = a + 10572 | 0;
            do { Ak(f, b); } while ((c[d >> 2] | 0) != (c[e >> 2] | 0));
            wk(b);
            return
        }

        function $h(a) {
            a = a | 0;
            var b = 0,
                d = 0;
            b = c[a + 10360 >> 2] | 0;
            if ((b | 0) != 0) { dv(b | 0, 0, (c[a + 10364 >> 2] | 0) * 3 | 0 | 0) | 0 }
            b = c[a + 10340 >> 2] | 0;
            if ((b | 0) != 0) { dv(b | 0, 0, (c[a + 10344 >> 2] | 0) * 24 | 0 | 0) | 0 }
            b = c[a + 10460 >> 2] | 0;
            if ((b | 0) != 0) { dv(b | 0, 0, c[a + 10464 >> 2] | 0) | 0 }
            b = a + 10344 | 0;
            if ((c[b >> 2] | 0) <= 0) { return }
            d = c[a + 10524 >> 2] | 0;
            a = 0;
            do {
                c[d + (a * 76 | 0) >> 2] = 0;
                a = a + 1 | 0;
            } while ((a | 0) < (c[b >> 2] | 0));
            return
        }

        function ai(a, d, e, f, g, h) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            i = d >> 2;
            d = e >> 2;
            e = f >> 2;
            f = g >> 2;
            g = c[a + 10392 >> 2] | 0;
            if ((f | 0) <= 0) { return }
            j = a + 10380 | 0;
            a = h | 0;
            if ((e | 0) > 0) { k = 0 } else { return }
            do {
                h = (ga(k + d | 0, g) | 0) + i | 0;
                l = 0;
                do {
                    m = (c[j >> 2] | 0) + ((h + l | 0) * 12 | 0) | 0;
                    b[m >> 1] = b[a >> 1] | 0;
                    b[m + 2 >> 1] = b[a + 2 >> 1] | 0;
                    b[m + 4 >> 1] = b[a + 4 >> 1] | 0;
                    b[m + 6 >> 1] = b[a + 6 >> 1] | 0;
                    b[m + 8 >> 1] = b[a + 8 >> 1] | 0;
                    b[m + 10 >> 1] = b[a + 10 >> 1] | 0;
                    l = l + 1 | 0;
                } while ((l | 0) < (e | 0));
                k = k + 1 | 0;
            } while ((k | 0) < (f | 0));
            return
        }

        function bi(a, d, e, f, g) {
            a = a | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            if ((g | f | 0) < 0) { h = 0; return h | 0 }
            if ((c[a + 1248 >> 2] | 0) <= (f | 0)) { h = 0; return h | 0 }
            if ((c[a + 1252 >> 2] | 0) <= (g | 0)) { h = 0; return h | 0 }
            i = c[a + 5864 >> 2] | 0;
            j = c[a + 5852 >> 2] | 0;
            k = (ga(g >> i, j) | 0) + (f >> i) | 0;
            l = c[a + 10320 >> 2] | 0;
            m = l + ((ga(e >> i, j) | 0) + (d >> i) << 2) | 0;
            if ((c[l + (k << 2) >> 2] | 0) > (c[m >> 2] | 0)) { h = 0; return h | 0 }
            m = c[a + 5804 >> 2] | 0;
            k = d >> m;
            d = e >> m;
            e = f >> m;
            f = g >> m;
            m = c[a + 10352 >> 2] | 0;
            g = (ga(m, d) | 0) + k | 0;
            l = c[a + 10340 >> 2] | 0;
            i = l + (((ga(m, f) | 0) + e | 0) * 24 | 0) | 0;
            if ((b[l + (g * 24 | 0) >> 1] | 0) != (b[i >> 1] | 0)) { h = 0; return h | 0 }
            i = c[a + 5820 >> 2] | 0;
            g = (ga(i, d) | 0) + k | 0;
            k = c[a + 10308 >> 2] | 0;
            a = k + ((ga(i, f) | 0) + e << 2) | 0;
            h = (c[k + (g << 2) >> 2] | 0) == (c[a >> 2] | 0);
            return h | 0
        }

        function ci(a, e, f, g, h, i, j, k, l, m, n) {
            a = a | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            var o = 0,
                p = 0,
                q = 0;
            do { if ((e | 0) > (m | 0)) { o = 3 } else { if (!((f | 0) <= (n | 0) & (g + e | 0) > (m | 0) & (g + f | 0) > (n | 0))) { o = 3; break } if ((j << 1 | 0) != (g | 0)) { break } if (!((k << 1 | 0) == (g | 0) & (l | 0) == 1)) { break } if ((k + f | 0) > (n | 0)) { break } if ((j + e | 0) <= (m | 0)) { break } return 0 } } while (0);
            do {
                if ((o | 0) == 3) {
                    if ((n | m | 0) < 0) { return 0 }
                    if ((c[a + 1248 >> 2] | 0) <= (m | 0)) { return 0 }
                    if ((c[a + 1252 >> 2] | 0) <= (n | 0)) { return 0 }
                    e = c[a + 5864 >> 2] | 0;
                    j = c[a + 5852 >> 2] | 0;
                    f = (ga(n >> e, j) | 0) + (m >> e) | 0;
                    k = c[a + 10320 >> 2] | 0;
                    l = k + ((ga(i >> e, j) | 0) + (h >> e) << 2) | 0;
                    if ((c[k + (f << 2) >> 2] | 0) > (c[l >> 2] | 0)) { return 0 }
                    l = c[a + 5804 >> 2] | 0;
                    f = h >> l;
                    k = i >> l;
                    e = m >> l;
                    j = n >> l;
                    l = c[a + 10352 >> 2] | 0;
                    g = (ga(l, k) | 0) + f | 0;
                    p = c[a + 10340 >> 2] | 0;
                    q = p + (((ga(l, j) | 0) + e | 0) * 24 | 0) | 0;
                    if ((b[p + (g * 24 | 0) >> 1] | 0) != (b[q >> 1] | 0)) { return 0 }
                    q = c[a + 5820 >> 2] | 0;
                    g = (ga(q, k) | 0) + f | 0;
                    f = c[a + 10308 >> 2] | 0;
                    k = f + ((ga(q, j) | 0) + e << 2) | 0;
                    if ((c[f + (g << 2) >> 2] | 0) == (c[k >> 2] | 0)) { break }
                    return 0
                }
            } while (0);
            i = c[a + 10368 >> 2] | 0;
            h = m >> i;
            m = n >> i;
            if (!((h | 0) > -1)) { ec(568, 17072, 118, 17344); return 0 }
            i = c[a + 10372 >> 2] | 0;
            if ((h | 0) >= (i | 0)) { ec(568, 17072, 118, 17344); return 0 }
            if (!((m | 0) > -1)) { ec(16504, 17072, 119, 17344); return 0 }
            if ((m | 0) < (c[a + 10376 >> 2] | 0)) {
                n = (ga(i, m) | 0) + h | 0;
                h = (c[a + 10360 >> 2] | 0) + (n * 3 | 0) | 0;
                return ((d[h] | d[h + 1 | 0] << 8) << 16 >> 16 & 768) != 0 | 0
            } else { ec(16504, 17072, 119, 17344); return 0 }
            return 0
        }

        function di(a, b, e, f, g, h, i) {
            a = a | 0;
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            do {
                if (g) {
                    j = c[i + 10368 >> 2] | 0;
                    k = b - 1 >> j;
                    l = e >> j;
                    if (!((k | 0) > -1)) { ec(7e3, 5152, 118, 17336) }
                    j = c[i + 10372 >> 2] | 0;
                    if ((k | 0) >= (j | 0)) { ec(7e3, 5152, 118, 17336) }
                    if (!((l | 0) > -1)) { ec(3672, 5152, 119, 17336) }
                    if ((l | 0) >= (c[i + 10376 >> 2] | 0)) { ec(3672, 5152, 119, 17336) }
                    m = (ga(j, l) | 0) + k | 0;
                    k = (c[i + 10360 >> 2] | 0) + (m * 3 | 0) | 0;
                    if (!(((d[k] | d[k + 1 | 0] << 8) << 16 >> 16 & 1792) == 0)) { n = 1; break }
                    n = d[(c[i + 10400 >> 2] | 0) + (f - 1) | 0] | 0
                } else { n = 1 }
            } while (0);
            do {
                if (h) {
                    g = c[i + 10368 >> 2] | 0;
                    k = b >> g;
                    m = e - 1 >> g;
                    if (!((k | 0) > -1)) { ec(7e3, 5152, 118, 17336) }
                    g = c[i + 10372 >> 2] | 0;
                    if ((k | 0) >= (g | 0)) { ec(7e3, 5152, 118, 17336) }
                    if (!((m | 0) > -1)) { ec(3672, 5152, 119, 17336) }
                    if ((m | 0) >= (c[i + 10376 >> 2] | 0)) { ec(3672, 5152, 119, 17336) }
                    l = (ga(g, m) | 0) + k | 0;
                    k = (c[i + 10360 >> 2] | 0) + (l * 3 | 0) | 0;
                    if (!(((d[k] | d[k + 1 | 0] << 8) << 16 >> 16 & 1792) == 0)) { o = 1; break }
                    k = c[i + 5804 >> 2] | 0;
                    if ((e >> k << k | 0) >= (e | 0)) { o = 1; break }
                    o = d[(c[i + 10400 >> 2] | 0) + (f - (c[i + 5876 >> 2] | 0)) | 0] | 0
                } else { o = 1 }
            } while (0);
            if ((n | 0) == (o | 0)) {
                if (n >>> 0 < 2 >>> 0) {
                    c[a >> 2] = 0;
                    c[a + 4 >> 2] = 1;
                    c[a + 8 >> 2] = 26;
                    return
                } else {
                    c[a >> 2] = n;
                    c[a + 4 >> 2] = (n + 29 & 31) + 2;
                    c[a + 8 >> 2] = ((n - 1 | 0) % 32 | 0) + 2;
                    return
                }
            }
            c[a >> 2] = n;
            c[a + 4 >> 2] = o;
            if (!((n | 0) == 0 | (o | 0) == 0)) { c[a + 8 >> 2] = 0; return }
            i = a + 8 | 0;
            if ((n | 0) == 1 | (o | 0) == 1) { c[i >> 2] = 26; return } else { c[i >> 2] = 1; return }
        }

        function ei(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0;
            if ((a | 0) == 3) { f = 2 } else if ((a | 0) != 2) { g = 0; return g | 0 }
            do { if ((f | 0) == 2) { if ((d | 0) == 0) { break } if ((c[e + 5012 >> 2] | 0) == 3) { break } else { g = 0 } return g | 0 } } while (0);
            if ((b - 6 | 0) >>> 0 < 9 >>> 0) { g = 2; return g | 0 }
            g = (b - 22 | 0) >>> 0 < 9 >>> 0 | 0;
            return g | 0
        }

        function fi(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            if ((c[((g | 0) == 0 ? a + 5760 | 0 : a + 5768 | 0) >> 2] | 0) > 8) { gi(a, b, d, e, f, g); return } else { hi(a, b, d, e, f, g); return }
        }

        function gi(d, f, g, h, j, k) {
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0;
            l = i;
            i = i + 264 | 0;
            m = l | 0;
            n = m + 128 | 0;
            mi(d, f, g, j, k, n);
            do {
                if ((a[d + 5753 | 0] | 0) == 0) {
                    if ((k | 0) != 0) { if ((c[d + 5776 >> 2] | 0) != 3) { break } }
                    ni(d, n, j, k, h)
                }
            } while (0);
            if ((h | 0) == 0) {
                o = c[((k | 0) == 0 ? d + 40 | 0 : d + 44 | 0) >> 2] | 0;
                p = (c[d + 4 + (k << 2) >> 2] | 0) + ((ga(o, g) | 0) + f << 1) | 0;
                if ((j | 0) > 1) {
                    q = j;
                    r = 0;
                    while (1) {
                        s = q >> 1;
                        if ((s | 0) > 1) {
                            q = s;
                            r = r + 1 | 0
                        } else { break }
                    }
                    t = r + 2 | 0
                } else { t = 1 }
                if ((j | 0) <= 0) {
                    u = 258;
                    v = 0;
                    i = l;
                    return
                }
                r = j - 1 | 0;
                q = e[m + (j + 65 << 1) >> 1] | 0;
                s = e[m + (63 - j << 1) >> 1] | 0;
                w = 0;
                while (1) {
                    x = r - w | 0;
                    y = w + 1 | 0;
                    z = ga(w, o) | 0;
                    A = e[m + (63 - w << 1) >> 1] | 0;
                    B = ga(s, y) | 0;
                    C = 0;
                    while (1) {
                        D = ga(A, r - C | 0) | 0;
                        E = C + 1 | 0;
                        F = ga(q, E) | 0;
                        G = D + j + F + (ga(e[m + (C + 65 << 1) >> 1] | 0, x) | 0) + B >> t & 65535;
                        b[p + (C + z << 1) >> 1] = G;
                        if ((E | 0) < (j | 0)) { C = E } else { break }
                    }
                    if ((y | 0) < (j | 0)) { w = y } else { break }
                }
                u = 258;
                v = 0;
                i = l;
                return
            } else if ((h | 0) == 1) {
                oi(d, f, g, j, k, n);
                u = 258;
                v = 0;
                i = l;
                return
            } else {
                pi(d, f, g, h, j, k, n);
                u = 258;
                v = 0;
                i = l;
                return
            }
        }

        function hi(b, e, f, g, h, j) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0;
            k = i;
            i = i + 136 | 0;
            l = k | 0;
            m = l + 64 | 0;
            ii(b, e, f, h, j, m);
            do {
                if ((a[b + 5753 | 0] | 0) == 0) {
                    if ((j | 0) != 0) { if ((c[b + 5776 >> 2] | 0) != 3) { break } }
                    ji(b, m, h, j, g)
                }
            } while (0);
            if ((g | 0) == 0) {
                n = c[((j | 0) == 0 ? b + 40 | 0 : b + 44 | 0) >> 2] | 0;
                o = c[b + 4 + (j << 2) >> 2] | 0;
                if ((h | 0) > 1) {
                    p = h;
                    q = 0;
                    while (1) {
                        r = p >> 1;
                        if ((r | 0) > 1) {
                            p = r;
                            q = q + 1 | 0
                        } else { break }
                    }
                    s = q + 2 | 0
                } else { s = 1 }
                if ((h | 0) <= 0) {
                    t = 129;
                    u = 0;
                    i = k;
                    return
                }
                q = h - 1 | 0;
                p = d[l + (h + 65) | 0] | 0;
                r = d[l + (63 - h) | 0] | 0;
                v = 0;
                while (1) {
                    w = q - v | 0;
                    x = v + 1 | 0;
                    y = ga(v + f | 0, n) | 0;
                    z = d[l + (63 - v) | 0] | 0;
                    A = ga(r, x) | 0;
                    B = y + e | 0;
                    y = 0;
                    while (1) {
                        C = ga(z, q - y | 0) | 0;
                        D = y + 1 | 0;
                        E = ga(p, D) | 0;
                        F = C + h + E + (ga(d[l + (y + 65) | 0] | 0, w) | 0) + A >> s & 255;
                        a[o + (B + y) | 0] = F;
                        if ((D | 0) < (h | 0)) { y = D } else { break }
                    }
                    if ((x | 0) < (h | 0)) { v = x } else { break }
                }
                t = 129;
                u = 0;
                i = k;
                return
            } else if ((g | 0) == 1) {
                ki(b, e, f, h, j, m);
                t = 129;
                u = 0;
                i = k;
                return
            } else {
                li(b, e, f, g, h, j, m);
                t = 129;
                u = 0;
                i = k;
                return
            }
        }

        function ii(b, f, g, h, j, k) {
            b = b | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0;
            l = i;
            i = i + 136 | 0;
            m = l | 0;
            n = m + 64 | 0;
            o = c[b + 4 + (j << 2) >> 2] | 0;
            p = (j | 0) == 0;
            j = c[(p ? b + 40 | 0 : b + 44 | 0) >> 2] | 0;
            if (p) {
                q = 1;
                r = 1
            } else {
                q = c[b + 5784 >> 2] | 0;
                r = c[b + 5780 >> 2] | 0
            }
            s = c[(p ? b + 5760 | 0 : b + 5768 | 0) >> 2] | 0;
            p = ga(r, f) | 0;
            t = ga(q, g) | 0;
            u = c[b + 5804 >> 2] | 0;
            v = c[b + 5820 >> 2] | 0;
            w = (p | 0) != 0;
            x = (t | 0) == 0;
            y = x ^ 1;
            z = w & y;
            A = ga(r, h + f | 0) | 0;
            B = c[b + 1248 >> 2] | 0;
            D = (A | 0) < (B | 0) & y;
            E = p >> u;
            F = t >> u;
            G = p - 1 >> u;
            H = A >> u;
            A = t - 1 >> u;
            u = c[b + 10352 >> 2] | 0;
            I = ga(u, F) | 0;
            J = c[b + 10340 >> 2] | 0;
            K = e[J + ((I + E | 0) * 24 | 0) >> 1] | 0;
            if (w) { L = e[J + ((I + G | 0) * 24 | 0) >> 1] | 0 } else { L = -1 }
            if (x) { M = -1 } else {
                I = J + (((ga(u, A) | 0) + E | 0) * 24 | 0) | 0;
                M = e[I >> 1] | 0
            }
            if (D) {
                I = J + (((ga(u, A) | 0) + H | 0) * 24 | 0) | 0;
                N = e[I >> 1] | 0
            } else { N = -1 }
            if (z) {
                I = J + (((ga(u, A) | 0) + G | 0) * 24 | 0) | 0;
                O = e[I >> 1] | 0
            } else { O = -1 }
            I = ga(F, v) | 0;
            F = c[b + 10308 >> 2] | 0;
            u = c[F + (I + E << 2) >> 2] | 0;
            if (w) { P = c[F + (I + G << 2) >> 2] | 0 } else { P = -1 }
            if (x) { Q = -1 } else {
                x = F + ((ga(A, v) | 0) + E << 2) | 0;
                Q = c[x >> 2] | 0
            }
            if (z) {
                x = F + ((ga(A, v) | 0) + G << 2) | 0;
                R = c[x >> 2] | 0
            } else { R = -1 }
            if (D) {
                x = F + ((ga(A, v) | 0) + H << 2) | 0;
                S = c[x >> 2] | 0
            } else { S = -1 }
            x = (L | 0) == (K | 0) & (P | 0) == (u | 0) & w;
            w = (M | 0) == (K | 0) & (Q | 0) == (u | 0) & y;
            y = (O | 0) == (K | 0) & (R | 0) == (u | 0) & z;
            z = (N | 0) == (K | 0) & (S | 0) == (u | 0) & D;
            D = b + 5864 | 0;
            u = c[D >> 2] | 0;
            S = b + 5852 | 0;
            K = (ga(t >> u, c[S >> 2] | 0) | 0) + (p >> u) | 0;
            u = b + 10320 | 0;
            N = c[(c[u >> 2] | 0) + (K << 2) >> 2] | 0;
            K = (q - 1 - t + (c[b + 1252 >> 2] | 0) | 0) / (q | 0) | 0;
            t = h << 1;
            R = (K | 0) > (t | 0) ? t : K;
            O = (r - 1 - p + B | 0) / (r | 0) | 0;
            B = (O | 0) > (t | 0) ? t : O;
            O = -t | 0;
            p = h << 2 | 1;
            dv(m + (64 - t) | 0, 0, p | 0) | 0;
            a: do {
                if ((R | 0) > 0) {
                    Q = f - 1 | 0;
                    M = ga(r, Q) | 0;
                    P = b + 5944 | 0;
                    L = b + 10368 | 0;
                    H = b + 10372 | 0;
                    v = b + 10376 | 0;
                    A = b + 10360 | 0;
                    F = ~K;
                    G = ~(h << 1);
                    E = ((F | 0) > (G | 0) ? F : G) + 65 | 0;
                    G = 0;
                    F = 0;
                    I = R - 1 | 0;
                    J = 0;
                    b: while (1) {
                        T = m + (E + (J << 2)) | 0;
                        do {
                            if (x) {
                                U = c[D >> 2] | 0;
                                V = I + g | 0;
                                W = ga(V, q) | 0;
                                X = (ga(W >> U, c[S >> 2] | 0) | 0) + (M >> U) | 0;
                                U = (c[(c[u >> 2] | 0) + (X << 2) >> 2] | 0) <= (N | 0);
                                if ((a[P] | 0) == 0) {
                                    if (!U) {
                                        Y = F;
                                        Z = G;
                                        break
                                    }
                                } else {
                                    X = c[L >> 2] | 0;
                                    _ = M >> X;
                                    $ = W >> X;
                                    if (!((_ | 0) > -1)) { aa = 25; break b }
                                    X = c[H >> 2] | 0;
                                    if ((_ | 0) >= (X | 0)) { aa = 25; break b }
                                    if (!(($ | 0) > -1)) { aa = 28; break b }
                                    if (($ | 0) >= (c[v >> 2] | 0)) { aa = 28; break b }
                                    W = (ga(X, $) | 0) + _ | 0;
                                    _ = (c[A >> 2] | 0) + (W * 3 | 0) | 0;
                                    if (!(((d[_] | d[_ + 1 | 0] << 8) << 16 >> 16 & 768) == 0 & U)) {
                                        Y = F;
                                        Z = G;
                                        break
                                    }
                                }
                                U = o + ((ga(V, j) | 0) + Q) | 0;
                                if ((G | 0) == 0) { ba = a[U] | 0 } else { ba = F }
                                _ = T;
                                C = 16843009;
                                a[_] = C;
                                C = C >> 8;
                                a[_ + 1 | 0] = C;
                                C = C >> 8;
                                a[_ + 2 | 0] = C;
                                C = C >> 8;
                                a[_ + 3 | 0] = C;
                                a[k + ~I | 0] = a[U] | 0;
                                U = o + ((ga(V - 1 | 0, j) | 0) + Q) | 0;
                                a[k + (1 - I - 1) | 0] = a[U] | 0;
                                U = o + ((ga(V - 2 | 0, j) | 0) + Q) | 0;
                                a[k + (2 - I - 1) | 0] = a[U] | 0;
                                U = o + ((ga(V - 3 | 0, j) | 0) + Q) | 0;
                                a[k + (3 - I - 1) | 0] = a[U] | 0;
                                Y = ba;
                                Z = G + 4 | 0
                            } else {
                                Y = F;
                                Z = G
                            }
                        } while (0);
                        T = I - 4 | 0;
                        if ((T | 0) > -1) {
                            G = Z;
                            F = Y;
                            I = T;
                            J = J + 1 | 0
                        } else {
                            ca = Z;
                            da = Y;
                            break a
                        }
                    }
                    if ((aa | 0) == 25) { ec(7e3, 5152, 118, 17336) } else if ((aa | 0) == 28) { ec(3672, 5152, 119, 17336) }
                } else {
                    ca = 0;
                    da = 0
                }
            } while (0);
            c: do {
                if (y) {
                    Y = f - 1 | 0;
                    Z = ga(r, Y) | 0;
                    ba = c[D >> 2] | 0;
                    x = g - 1 | 0;
                    R = ga(q, x) | 0;
                    K = (ga(R >> ba, c[S >> 2] | 0) | 0) + (Z >> ba) | 0;
                    ba = (c[(c[u >> 2] | 0) + (K << 2) >> 2] | 0) <= (N | 0);
                    do {
                        if ((a[b + 5944 | 0] | 0) == 0) {
                            if (!ba) {
                                ea = da;
                                fa = ca;
                                break c
                            }
                        } else {
                            K = c[b + 10368 >> 2] | 0;
                            J = Z >> K;
                            I = R >> K;
                            if (!((J | 0) > -1)) { ec(7e3, 5152, 118, 17336) }
                            K = c[b + 10372 >> 2] | 0;
                            if ((J | 0) >= (K | 0)) { ec(7e3, 5152, 118, 17336) }
                            if (!((I | 0) > -1)) { ec(3672, 5152, 119, 17336) }
                            if ((I | 0) < (c[b + 10376 >> 2] | 0)) {
                                F = (ga(K, I) | 0) + J | 0;
                                J = (c[b + 10360 >> 2] | 0) + (F * 3 | 0) | 0;
                                if (((d[J] | d[J + 1 | 0] << 8) << 16 >> 16 & 768) == 0 & ba) { break } else {
                                    ea = da;
                                    fa = ca;
                                    break c
                                }
                            } else { ec(3672, 5152, 119, 17336) }
                        }
                    } while (0);
                    ba = o + ((ga(j, x) | 0) + Y) | 0;
                    if ((ca | 0) == 0) { ha = a[ba] | 0 } else { ha = da }
                    a[k] = a[ba] | 0;
                    a[n] = 1;
                    ea = ha;
                    fa = ca + 1 | 0
                } else {
                    ea = da;
                    fa = ca
                }
            } while (0);
            d: do {
                if ((B | 0) > 0) {
                    ca = g - 1 | 0;
                    da = ga(q, ca) | 0;
                    ha = b + 5944 | 0;
                    n = ga(j, ca) | 0;
                    ca = b + 10368 | 0;
                    y = b + 10372 | 0;
                    ba = b + 10376 | 0;
                    R = b + 10360 | 0;
                    Z = fa;
                    J = ea;
                    F = 0;
                    I = 0;
                    e: while (1) {
                        K = m + ((I << 2) + 65) | 0;
                        do {
                            if ((F | 0) < (h | 0) ? w : z) {
                                G = F + f | 0;
                                Q = ga(G, r) | 0;
                                A = c[D >> 2] | 0;
                                v = (ga(da >> A, c[S >> 2] | 0) | 0) + (Q >> A) | 0;
                                A = (c[(c[u >> 2] | 0) + (v << 2) >> 2] | 0) <= (N | 0);
                                if ((a[ha] | 0) == 0) {
                                    if (!A) {
                                        ia = J;
                                        ja = Z;
                                        break
                                    }
                                } else {
                                    v = c[ca >> 2] | 0;
                                    H = Q >> v;
                                    Q = da >> v;
                                    if (!((H | 0) > -1)) { aa = 54; break e }
                                    v = c[y >> 2] | 0;
                                    if ((H | 0) >= (v | 0)) { aa = 54; break e }
                                    if (!((Q | 0) > -1)) { aa = 57; break e }
                                    if ((Q | 0) >= (c[ba >> 2] | 0)) { aa = 57; break e }
                                    M = (ga(v, Q) | 0) + H | 0;
                                    H = (c[R >> 2] | 0) + (M * 3 | 0) | 0;
                                    if (!(((d[H] | d[H + 1 | 0] << 8) << 16 >> 16 & 768) == 0 & A)) {
                                        ia = J;
                                        ja = Z;
                                        break
                                    }
                                }
                                A = G + n | 0;
                                G = o + A | 0;
                                if ((Z | 0) == 0) { ka = a[G] | 0 } else { ka = J }
                                H = K;
                                C = 16843009;
                                a[H] = C;
                                C = C >> 8;
                                a[H + 1 | 0] = C;
                                C = C >> 8;
                                a[H + 2 | 0] = C;
                                C = C >> 8;
                                a[H + 3 | 0] = C;
                                H = F | 1;
                                a[k + H | 0] = a[G] | 0;
                                a[k + (H + 1) | 0] = a[o + (A + 1) | 0] | 0;
                                a[k + (F | 3) | 0] = a[o + (A + 2) | 0] | 0;
                                a[k + ((F | 3) + 1) | 0] = a[o + (A + 3) | 0] | 0;
                                ia = ka;
                                ja = Z + 4 | 0
                            } else {
                                ia = J;
                                ja = Z
                            }
                        } while (0);
                        K = F + 4 | 0;
                        if ((K | 0) < (B | 0)) {
                            Z = ja;
                            J = ia;
                            F = K;
                            I = I + 1 | 0
                        } else {
                            la = ja;
                            ma = ia;
                            break d
                        }
                    }
                    if ((aa | 0) == 54) { ec(7e3, 5152, 118, 17336) } else if ((aa | 0) == 57) { ec(3672, 5152, 119, 17336) }
                } else {
                    la = fa;
                    ma = ea
                }
            } while (0);
            if ((la | 0) == (p | 0)) {
                na = 129;
                oa = 0;
                i = l;
                return
            }
            if ((la | 0) == 0) {
                dv(k + O | 0, 1 << s - 1 & 255 | 0, p | 0) | 0;
                na = 129;
                oa = 0;
                i = l;
                return
            }
            p = h * -2 | 0;
            if ((a[m + (p + 64) | 0] | 0) == 0) { a[k + p | 0] = ma }
            ma = p | 1;
            if ((ma | 0) > (t | 0)) {
                na = 129;
                oa = 0;
                i = l;
                return
            } else { pa = ma }
            while (1) { if ((a[m + (pa + 64) | 0] | 0) == 0) { a[k + pa | 0] = a[k + (pa - 1) | 0] | 0 } if ((pa | 0) < (t | 0)) { pa = pa + 1 | 0 } else { break } }
            na = 129;
            oa = 0;
            i = l;
            return
        }

        function ji(b, e, f, g, h) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            j = i;
            i = i + 136 | 0;
            k = j | 0;
            if ((h | 0) == 1 | (f | 0) == 4) { i = j; return }
            l = h - 26 | 0;
            m = (l | 0) < 0 ? 26 - h | 0 : l;
            l = h - 10 | 0;
            n = (l | 0) < 0 ? 10 - h | 0 : l;
            l = (m | 0) < (n | 0) ? m : n;
            do {
                if ((f | 0) == 32) {
                    if ((l | 0) > 0) { break }
                    i = j;
                    return
                } else if ((f | 0) == 8) {
                    if ((l | 0) > 7) { break }
                    i = j;
                    return
                } else if ((f | 0) == 16) {
                    if ((l | 0) > 1) { break }
                    i = j;
                    return
                } else { ec(8920, 15552, 518, 18232) }
            } while (0);
            do {
                if ((a[b + 5665 | 0] | 0) != 0 & (g | 0) == 0 & (f | 0) == 32) {
                    l = d[e] | 0;
                    n = (d[e + 64 | 0] | 0) + l - (d[e + 32 | 0] << 1) | 0;
                    m = 1 << (c[b + 1276 >> 2] | 0) - 5;
                    if ((((n | 0) < 0 ? -n | 0 : n) | 0) >= (m | 0)) { o = 0; break }
                    n = (d[e - 64 | 0] | 0) + l - (d[e - 32 | 0] << 1) | 0;
                    o = (((n | 0) < 0 ? -n | 0 : n) | 0) < (m | 0)
                } else { o = 0 }
            } while (0);
            b = f * -2 | 0;
            a[k + (b + 64) | 0] = a[e + b | 0] | 0;
            b = f << 1;
            a[k + (b + 64) | 0] = a[e + b | 0] | 0;
            do {
                if (o) {
                    g = a[e] | 0;
                    a[k + 64 | 0] = g;
                    m = g & 255;
                    g = (d[e - 64 | 0] | 0) - m | 0;
                    n = (d[e + 64 | 0] | 0) - m | 0;
                    l = 1;
                    do {
                        h = (((ga(g, l) | 0) + 32 | 0) >>> 6) + m & 255;
                        a[k + (64 - l) | 0] = h;
                        h = (((ga(n, l) | 0) + 32 | 0) >>> 6) + m & 255;
                        a[k + (l + 64) | 0] = h;
                        l = l + 1 | 0;
                    } while ((l | 0) < 64)
                } else {
                    l = b - 1 | 0;
                    m = 1 - b | 0;
                    if ((m | 0) > (l | 0)) { break }
                    n = m;
                    g = a[e + m | 0] | 0;
                    while (1) {
                        m = n + 1 | 0;
                        h = a[e + m | 0] | 0;
                        a[k + (n + 64) | 0] = ((h & 255) + 2 + ((g & 255) << 1) + (d[e + (n - 1) | 0] | 0) | 0) >>> 2;
                        if ((n | 0) < (l | 0)) {
                            n = m;
                            g = h
                        } else { break }
                    }
                }
            } while (0);
            cv(e + (-b | 0) | 0, k + (64 - b) | 0, f << 2 | 1) | 0;
            i = j;
            return
        }

        function ki(b, e, f, g, h, i) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            j = (h | 0) == 0;
            k = c[(j ? b + 40 | 0 : b + 44 | 0) >> 2] | 0;
            l = c[b + 4 + (h << 2) >> 2] | 0;
            h = (ga(k, f) | 0) + e | 0;
            b = l + h | 0;
            m = (g | 0) > 1;
            if (m) {
                n = g;
                o = 0;
                while (1) {
                    p = n >> 1;
                    if ((p | 0) > 1) {
                        n = p;
                        o = o + 1 | 0
                    } else { break }
                }
                q = o + 2 | 0
            } else { q = 1 }
            o = (g | 0) > 0;
            if (o) {
                n = 0;
                p = 0;
                while (1) {
                    r = p + 1 | 0;
                    s = (d[i + r | 0] | 0) + n + (d[i + ~p | 0] | 0) | 0;
                    if ((r | 0) < (g | 0)) {
                        n = s;
                        p = r
                    } else { t = s; break }
                }
            } else { t = 0 }
            p = t + g >> q;
            if (!(j & (g | 0) < 32)) {
                if (!o) { return }
                o = p & 255;
                j = 0;
                do {
                    dv(l + (h + (ga(k, j) | 0)) | 0, o | 0, g | 0) | 0;
                    j = j + 1 | 0;
                } while ((j | 0) < (g | 0));
                return
            }
            a[b] = ((p << 1) + 2 + (d[i - 1 | 0] | 0) + (d[i + 1 | 0] | 0) | 0) >>> 2;
            if (!m) { return }
            b = (p * 3 | 0) + 2 | 0;
            j = 1;
            while (1) {
                o = j + 1 | 0;
                a[l + (j + h) | 0] = (b + (d[i + o | 0] | 0) | 0) >>> 2;
                if ((o | 0) < (g | 0)) { j = o } else { break }
            }
            if (!m) { return }
            j = (p * 3 | 0) + 2 | 0;
            b = 1;
            do {
                o = l + ((ga(b, k) | 0) + h) | 0;
                a[o] = (j + (d[i + ~b | 0] | 0) | 0) >>> 2;
                b = b + 1 | 0;
            } while ((b | 0) < (g | 0));
            if (!m) { return }
            m = p & 255;
            p = (ga(k, f + 1 | 0) | 0) + e + 1 | 0;
            e = g - 1 | 0;
            f = 1;
            b = 0;
            while (1) {
                dv(l + (p + (ga(k, b) | 0)) | 0, m | 0, e | 0) | 0;
                i = f + 1 | 0;
                if ((i | 0) < (g | 0)) {
                    f = i;
                    b = b + 1 | 0
                } else { break }
            }
            return
        }

        function li(b, e, f, g, h, j, k) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            l = i;
            i = i + 136 | 0;
            m = l | 0;
            n = (j | 0) == 0;
            o = c[(n ? b + 40 | 0 : b + 44 | 0) >> 2] | 0;
            p = c[b + 4 + (j << 2) >> 2] | 0;
            j = (ga(o, f) | 0) + e | 0;
            q = c[(n ? b + 5760 | 0 : b + 5768 | 0) >> 2] | 0;
            if ((g | 0) >= 35) { ec(12952, 15552, 596, 18712) }
            if ((g | 0) <= 1) { ec(10072, 15552, 597, 18712) }
            r = c[64 + (g << 2) >> 2] | 0;
            do {
                if ((a[b + 5750 | 0] | 0) == 0) { s = 0 } else {
                    t = c[b + 10368 >> 2] | 0;
                    u = e >> t;
                    v = f >> t;
                    if (!((u | 0) > -1)) { ec(7e3, 5152, 118, 17336) }
                    t = c[b + 10372 >> 2] | 0;
                    if ((u | 0) >= (t | 0)) { ec(7e3, 5152, 118, 17336) }
                    if (!((v | 0) > -1)) { ec(3672, 5152, 119, 17336) }
                    if ((v | 0) < (c[b + 10376 >> 2] | 0)) {
                        w = (ga(t, v) | 0) + u | 0;
                        u = (c[b + 10360 >> 2] | 0) + (w * 3 | 0) | 0;
                        s = ((d[u] | d[u + 1 | 0] << 8) << 16 >> 16 & 2048) != 0;
                        break
                    } else { ec(3672, 5152, 119, 17336) }
                }
            } while (0);
            b = (h | 0) < 0;
            if ((g | 0) > 17) {
                if (!b) { cv(m + 64 | 0, k | 0, h + 1 | 0) | 0 }
                f = g - 11 | 0;
                do {
                    if (f >>> 0 < 15 >>> 0) {
                        e = c[30584 + (f << 2) >> 2] | 0;
                        u = (ga(r, h) | 0) >> 5;
                        if ((u | 0) < -1) { x = u } else { break }
                        do {
                            u = k + (-((ga(x, e) | 0) + 128 >> 8) | 0) | 0;
                            a[m + (x + 64) | 0] = a[u] | 0;
                            x = x + 1 | 0;
                        } while ((x | 0) < 0)
                    } else {
                        if ((h << 1 | 0) <= (h | 0)) { break }
                        cv(m + (h + 65) | 0, k + (h + 1) | 0, h) | 0
                    }
                } while (0);
                x = (h | 0) > 0;
                if (x) {
                    f = 0;
                    while (1) {
                        e = f + 1 | 0;
                        u = ga(e, r) | 0;
                        w = u >> 5;
                        v = u & 31;
                        u = (v | 0) == 0;
                        t = w + 65 | 0;
                        y = (ga(f, o) | 0) + j | 0;
                        z = 32 - v | 0;
                        A = 0;
                        do {
                            if (u) { a[p + (y + A) | 0] = a[m + (t + A) | 0] | 0 } else {
                                B = A + w | 0;
                                C = ga(d[m + (B + 65) | 0] | 0, z) | 0;
                                D = (C + 16 + (ga(d[m + (B + 66) | 0] | 0, v) | 0) | 0) >>> 5 & 255;
                                a[p + (y + A) | 0] = D
                            }
                            A = A + 1 | 0;
                        } while ((A | 0) < (h | 0));
                        if ((e | 0) < (h | 0)) { f = e } else { break }
                    }
                }
                if (s | (g | 0) == 26 & n & (h | 0) < 32 ^ 1 | x ^ 1) {
                    E = 129;
                    F = 0;
                    i = l;
                    return
                }
                x = k + 1 | 0;
                f = (1 << q) - 1 | 0;
                A = 0;
                do {
                    y = ((d[k + ~A | 0] | 0) - (d[k] | 0) >> 1) + (d[x] | 0) | 0;
                    if ((y | 0) < 0) { G = 0 } else { G = ((y | 0) > (f | 0) ? f : y) & 255 }
                    y = p + ((ga(A, o) | 0) + j) | 0;
                    a[y] = G;
                    A = A + 1 | 0;
                } while ((A | 0) < (h | 0));
                E = 129;
                F = 0;
                i = l;
                return
            } else {
                if (!b) { b = 0; while (1) { a[m + (b + 64) | 0] = a[k + (-b | 0) | 0] | 0; if ((b | 0) < (h | 0)) { b = b + 1 | 0 } else { break } } }
                b = g - 11 | 0;
                do {
                    if (b >>> 0 < 15 >>> 0) {
                        A = c[30584 + (b << 2) >> 2] | 0;
                        G = (ga(r, h) | 0) >> 5;
                        if ((G | 0) < -1) { H = G } else { break }
                        do {
                            G = k + ((ga(H, A) | 0) + 128 >> 8) | 0;
                            a[m + (H + 64) | 0] = a[G] | 0;
                            H = H + 1 | 0;
                        } while ((H | 0) < 0)
                    } else {
                        A = h << 1;
                        if ((A | 0) > (h | 0)) { I = h } else { break }
                        while (1) {
                            e = I + 1 | 0;
                            a[m + (I + 65) | 0] = a[k + ~I | 0] | 0;
                            if ((e | 0) < (A | 0)) { I = e } else { break }
                        }
                    }
                } while (0);
                I = (h | 0) > 0;
                if (I) {
                    H = 0;
                    do {
                        b = H + 65 | 0;
                        A = (ga(H, o) | 0) + j | 0;
                        e = 0;
                        while (1) {
                            G = e + 1 | 0;
                            f = ga(G, r) | 0;
                            x = f >> 5;
                            y = f & 31;
                            if ((y | 0) == 0) { a[p + (A + e) | 0] = a[m + (b + x) | 0] | 0 } else {
                                f = x + H | 0;
                                x = ga(d[m + (f + 65) | 0] | 0, 32 - y | 0) | 0;
                                v = (x + 16 + (ga(d[m + (f + 66) | 0] | 0, y) | 0) | 0) >>> 5 & 255;
                                a[p + (A + e) | 0] = v
                            }
                            if ((G | 0) < (h | 0)) { e = G } else { break }
                        }
                        H = H + 1 | 0;
                    } while ((H | 0) < (h | 0))
                }
                if (s | (g | 0) == 10 & n & (h | 0) < 32 ^ 1 | I ^ 1) {
                    E = 129;
                    F = 0;
                    i = l;
                    return
                }
                I = k - 1 | 0;
                n = (1 << q) - 1 | 0;
                q = 0;
                while (1) {
                    g = q + 1 | 0;
                    s = ((d[k + g | 0] | 0) - (d[k] | 0) >> 1) + (d[I] | 0) | 0;
                    if ((s | 0) < 0) { J = 0 } else { J = ((s | 0) > (n | 0) ? n : s) & 255 }
                    a[p + (q + j) | 0] = J;
                    if ((g | 0) < (h | 0)) { q = g } else { break }
                }
                E = 129;
                F = 0;
                i = l;
                return
            }
        }

        function mi(f, g, h, j, k, l) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0;
            m = i;
            i = i + 136 | 0;
            n = m | 0;
            o = n + 64 | 0;
            p = c[f + 4 + (k << 2) >> 2] | 0;
            q = (k | 0) == 0;
            k = c[(q ? f + 40 | 0 : f + 44 | 0) >> 2] | 0;
            if (q) {
                r = 1;
                s = 1
            } else {
                r = c[f + 5784 >> 2] | 0;
                s = c[f + 5780 >> 2] | 0
            }
            t = c[(q ? f + 5760 | 0 : f + 5768 | 0) >> 2] | 0;
            q = ga(s, g) | 0;
            u = ga(r, h) | 0;
            v = c[f + 5804 >> 2] | 0;
            w = c[f + 5820 >> 2] | 0;
            x = (q | 0) != 0;
            y = (u | 0) == 0;
            z = y ^ 1;
            A = x & z;
            B = ga(s, j + g | 0) | 0;
            D = c[f + 1248 >> 2] | 0;
            E = (B | 0) < (D | 0) & z;
            F = q >> v;
            G = u >> v;
            H = q - 1 >> v;
            I = B >> v;
            B = u - 1 >> v;
            v = c[f + 10352 >> 2] | 0;
            J = ga(v, G) | 0;
            K = c[f + 10340 >> 2] | 0;
            L = e[K + ((J + F | 0) * 24 | 0) >> 1] | 0;
            if (x) { M = e[K + ((J + H | 0) * 24 | 0) >> 1] | 0 } else { M = -1 }
            if (y) { N = -1 } else {
                J = K + (((ga(v, B) | 0) + F | 0) * 24 | 0) | 0;
                N = e[J >> 1] | 0
            }
            if (E) {
                J = K + (((ga(v, B) | 0) + I | 0) * 24 | 0) | 0;
                O = e[J >> 1] | 0
            } else { O = -1 }
            if (A) {
                J = K + (((ga(v, B) | 0) + H | 0) * 24 | 0) | 0;
                P = e[J >> 1] | 0
            } else { P = -1 }
            J = ga(G, w) | 0;
            G = c[f + 10308 >> 2] | 0;
            v = c[G + (J + F << 2) >> 2] | 0;
            if (x) { Q = c[G + (J + H << 2) >> 2] | 0 } else { Q = -1 }
            if (y) { R = -1 } else {
                y = G + ((ga(B, w) | 0) + F << 2) | 0;
                R = c[y >> 2] | 0
            }
            if (A) {
                y = G + ((ga(B, w) | 0) + H << 2) | 0;
                S = c[y >> 2] | 0
            } else { S = -1 }
            if (E) {
                y = G + ((ga(B, w) | 0) + I << 2) | 0;
                T = c[y >> 2] | 0
            } else { T = -1 }
            y = (N | 0) == (L | 0) & (R | 0) == (v | 0) & z;
            z = (P | 0) == (L | 0) & (S | 0) == (v | 0) & A;
            A = (O | 0) == (L | 0) & (T | 0) == (v | 0) & E;
            E = c[f + 5864 >> 2] | 0;
            T = c[f + 5852 >> 2] | 0;
            O = (ga(u >> E, T) | 0) + (q >> E) | 0;
            S = c[f + 10320 >> 2] | 0;
            P = c[S + (O << 2) >> 2] | 0;
            O = (r - 1 - u + (c[f + 1252 >> 2] | 0) | 0) / (r | 0) | 0;
            u = j << 1;
            R = (O | 0) > (u | 0) ? u : O;
            N = (s - 1 - q + D | 0) / (s | 0) | 0;
            D = (N | 0) > (u | 0) ? u : N;
            N = j << 2 | 1;
            dv(n + (64 - u) | 0, 0, N | 0) | 0;
            q = R - 1 | 0;
            a: do {
                if ((R | 0) > 0) {
                    I = g - 1 | 0;
                    w = ga(s, I) | 0;
                    B = f + 5944 | 0;
                    G = f + 10368 | 0;
                    H = f + 10372 | 0;
                    F = f + 10376 | 0;
                    J = f + 10360 | 0;
                    if (!((M | 0) == (L | 0) & (Q | 0) == (v | 0) & x)) {
                        K = q;
                        while (1) {
                            U = K - 4 | 0;
                            if ((U | 0) > -1) { K = U } else {
                                V = 0;
                                W = 0;
                                break a
                            }
                        }
                    }
                    K = ~O;
                    U = ~(j << 1);
                    X = ((K | 0) > (U | 0) ? K : U) + 65 | 0;
                    U = 0;
                    K = 0;
                    Y = q;
                    Z = 0;
                    while (1) {
                        _ = n + (X + (Z << 2)) | 0;
                        $ = Y + h | 0;
                        aa = ga($, r) | 0;
                        ba = S + ((ga(aa >> E, T) | 0) + (w >> E) << 2) | 0;
                        ca = (c[ba >> 2] | 0) <= (P | 0);
                        if ((a[B] | 0) == 0) {
                            if (ca) { da = 29 } else {
                                ea = K;
                                fa = U
                            }
                        } else {
                            ba = c[G >> 2] | 0;
                            ha = w >> ba;
                            ia = aa >> ba;
                            if (!((ha | 0) > -1)) { da = 33; break }
                            ba = c[H >> 2] | 0;
                            if ((ha | 0) >= (ba | 0)) { da = 33; break }
                            if (!((ia | 0) > -1)) { da = 34; break }
                            if ((ia | 0) >= (c[F >> 2] | 0)) { da = 34; break }
                            aa = (ga(ba, ia) | 0) + ha | 0;
                            ha = (c[J >> 2] | 0) + (aa * 3 | 0) | 0;
                            if (((d[ha] | d[ha + 1 | 0] << 8) << 16 >> 16 & 768) == 0 & ca) { da = 29 } else {
                                ea = K;
                                fa = U
                            }
                        }
                        if ((da | 0) == 29) {
                            da = 0;
                            ca = p + ((ga($, k) | 0) + I << 1) | 0;
                            if ((U | 0) == 0) { ja = b[ca >> 1] | 0 } else { ja = K }
                            ha = _;
                            C = 16843009;
                            a[ha] = C;
                            C = C >> 8;
                            a[ha + 1 | 0] = C;
                            C = C >> 8;
                            a[ha + 2 | 0] = C;
                            C = C >> 8;
                            a[ha + 3 | 0] = C;
                            b[l + (~Y << 1) >> 1] = b[ca >> 1] | 0;
                            ca = p + ((ga($ - 1 | 0, k) | 0) + I << 1) | 0;
                            b[l + (1 - Y - 1 << 1) >> 1] = b[ca >> 1] | 0;
                            ca = p + ((ga($ - 2 | 0, k) | 0) + I << 1) | 0;
                            b[l + (2 - Y - 1 << 1) >> 1] = b[ca >> 1] | 0;
                            ca = p + ((ga($ - 3 | 0, k) | 0) + I << 1) | 0;
                            b[l + (3 - Y - 1 << 1) >> 1] = b[ca >> 1] | 0;
                            ea = ja;
                            fa = U + 4 | 0
                        }
                        ca = Y - 4 | 0;
                        if ((ca | 0) > -1) {
                            U = fa;
                            K = ea;
                            Y = ca;
                            Z = Z + 1 | 0
                        } else {
                            V = fa;
                            W = ea;
                            break a
                        }
                    }
                    if ((da | 0) == 33) { ec(7e3, 5152, 118, 17336) } else if ((da | 0) == 34) { ec(3672, 5152, 119, 17336) }
                } else {
                    V = 0;
                    W = 0
                }
            } while (0);
            b: do {
                if (z) {
                    ea = g - 1 | 0;
                    fa = ga(s, ea) | 0;
                    ja = h - 1 | 0;
                    q = ga(r, ja) | 0;
                    O = S + ((ga(q >> E, T) | 0) + (fa >> E) << 2) | 0;
                    x = (c[O >> 2] | 0) <= (P | 0);
                    do {
                        if ((a[f + 5944 | 0] | 0) == 0) {
                            if (!x) {
                                ka = W;
                                la = V;
                                break b
                            }
                        } else {
                            O = c[f + 10368 >> 2] | 0;
                            v = fa >> O;
                            Q = q >> O;
                            if (!((v | 0) > -1)) { ec(7e3, 5152, 118, 17336) }
                            O = c[f + 10372 >> 2] | 0;
                            if ((v | 0) >= (O | 0)) { ec(7e3, 5152, 118, 17336) }
                            if (!((Q | 0) > -1)) { ec(3672, 5152, 119, 17336) }
                            if ((Q | 0) < (c[f + 10376 >> 2] | 0)) {
                                L = (ga(O, Q) | 0) + v | 0;
                                v = (c[f + 10360 >> 2] | 0) + (L * 3 | 0) | 0;
                                if (((d[v] | d[v + 1 | 0] << 8) << 16 >> 16 & 768) == 0 & x) { break } else {
                                    ka = W;
                                    la = V;
                                    break b
                                }
                            } else { ec(3672, 5152, 119, 17336) }
                        }
                    } while (0);
                    x = p + ((ga(k, ja) | 0) + ea << 1) | 0;
                    if ((V | 0) == 0) { ma = b[x >> 1] | 0 } else { ma = W }
                    b[l >> 1] = b[x >> 1] | 0;
                    a[o] = 1;
                    ka = ma;
                    la = V + 1 | 0
                } else {
                    ka = W;
                    la = V
                }
            } while (0);
            c: do {
                if ((D | 0) > 0) {
                    V = h - 1 | 0;
                    W = ga(r, V) | 0;
                    ma = f + 5944 | 0;
                    o = ga(k, V) | 0;
                    V = f + 10368 | 0;
                    z = f + 10372 | 0;
                    x = f + 10376 | 0;
                    q = f + 10360 | 0;
                    fa = la;
                    v = ka;
                    L = 0;
                    Q = 0;
                    d: while (1) {
                        O = n + ((Q << 2) + 65) | 0;
                        do {
                            if ((L | 0) < (j | 0) ? y : A) {
                                M = L + g | 0;
                                R = ga(M, s) | 0;
                                Z = S + ((ga(W >> E, T) | 0) + (R >> E) << 2) | 0;
                                Y = (c[Z >> 2] | 0) <= (P | 0);
                                if ((a[ma] | 0) == 0) {
                                    if (!Y) {
                                        na = v;
                                        oa = fa;
                                        break
                                    }
                                } else {
                                    Z = c[V >> 2] | 0;
                                    K = R >> Z;
                                    R = W >> Z;
                                    if (!((K | 0) > -1)) { da = 55; break d }
                                    Z = c[z >> 2] | 0;
                                    if ((K | 0) >= (Z | 0)) { da = 55; break d }
                                    if (!((R | 0) > -1)) { da = 58; break d }
                                    if ((R | 0) >= (c[x >> 2] | 0)) { da = 58; break d }
                                    U = (ga(Z, R) | 0) + K | 0;
                                    K = (c[q >> 2] | 0) + (U * 3 | 0) | 0;
                                    if (!(((d[K] | d[K + 1 | 0] << 8) << 16 >> 16 & 768) == 0 & Y)) {
                                        na = v;
                                        oa = fa;
                                        break
                                    }
                                }
                                Y = M + o | 0;
                                M = p + (Y << 1) | 0;
                                if ((fa | 0) == 0) { pa = b[M >> 1] | 0 } else { pa = v }
                                K = O;
                                C = 16843009;
                                a[K] = C;
                                C = C >> 8;
                                a[K + 1 | 0] = C;
                                C = C >> 8;
                                a[K + 2 | 0] = C;
                                C = C >> 8;
                                a[K + 3 | 0] = C;
                                K = L | 1;
                                b[l + (K << 1) >> 1] = b[M >> 1] | 0;
                                b[l + (K + 1 << 1) >> 1] = b[p + (Y + 1 << 1) >> 1] | 0;
                                b[l + ((L | 3) << 1) >> 1] = b[p + (Y + 2 << 1) >> 1] | 0;
                                b[l + ((L | 3) + 1 << 1) >> 1] = b[p + (Y + 3 << 1) >> 1] | 0;
                                na = pa;
                                oa = fa + 4 | 0
                            } else {
                                na = v;
                                oa = fa
                            }
                        } while (0);
                        O = L + 4 | 0;
                        if ((O | 0) < (D | 0)) {
                            fa = oa;
                            v = na;
                            L = O;
                            Q = Q + 1 | 0
                        } else {
                            qa = oa;
                            ra = na;
                            break c
                        }
                    }
                    if ((da | 0) == 55) { ec(7e3, 5152, 118, 17336) } else if ((da | 0) == 58) { ec(3672, 5152, 119, 17336) }
                } else {
                    qa = la;
                    ra = ka
                }
            } while (0);
            if ((qa | 0) == (N | 0)) {
                sa = 129;
                ta = 0;
                i = m;
                return
            }
            N = j * -2 | 0;
            if ((qa | 0) == 0) {
                if ((N | 0) > (u | 0)) {
                    sa = 129;
                    ta = 0;
                    i = m;
                    return
                }
                qa = 1 << t - 1 & 65535;
                t = N;
                while (1) { b[l + (t << 1) >> 1] = qa; if ((t | 0) < (u | 0)) { t = t + 1 | 0 } else { break } }
                sa = 129;
                ta = 0;
                i = m;
                return
            }
            if ((a[n + (N + 64) | 0] | 0) == 0) { b[l + (N << 1) >> 1] = ra }
            ra = N | 1;
            if ((ra | 0) > (u | 0)) {
                sa = 129;
                ta = 0;
                i = m;
                return
            } else { ua = ra }
            while (1) { if ((a[n + (ua + 64) | 0] | 0) == 0) { b[l + (ua << 1) >> 1] = b[l + (ua - 1 << 1) >> 1] | 0 } if ((ua | 0) < (u | 0)) { ua = ua + 1 | 0 } else { break } }
            sa = 129;
            ta = 0;
            i = m;
            return
        }

        function ni(d, f, g, h, j) {
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            k = i;
            i = i + 264 | 0;
            l = k | 0;
            if ((j | 0) == 1 | (g | 0) == 4) { i = k; return }
            m = j - 26 | 0;
            n = (m | 0) < 0 ? 26 - j | 0 : m;
            m = j - 10 | 0;
            o = (m | 0) < 0 ? 10 - j | 0 : m;
            m = (n | 0) < (o | 0) ? n : o;
            do {
                if ((g | 0) == 16) {
                    if ((m | 0) > 1) { break }
                    i = k;
                    return
                } else if ((g | 0) == 8) {
                    if ((m | 0) > 7) { break }
                    i = k;
                    return
                } else if ((g | 0) == 32) {
                    if ((m | 0) > 0) { break }
                    i = k;
                    return
                } else { ec(8920, 15552, 518, 18232) }
            } while (0);
            do {
                if ((a[d + 5665 | 0] | 0) != 0 & (h | 0) == 0 & (g | 0) == 32) {
                    m = e[f >> 1] | 0;
                    o = (e[f + 128 >> 1] | 0) + m - (e[f + 64 >> 1] << 1) | 0;
                    n = 1 << (c[d + 1276 >> 2] | 0) - 5;
                    if ((((o | 0) < 0 ? -o | 0 : o) | 0) >= (n | 0)) { p = 0; break }
                    o = (e[f - 128 >> 1] | 0) + m - (e[f - 64 >> 1] << 1) | 0;
                    p = (((o | 0) < 0 ? -o | 0 : o) | 0) < (n | 0)
                } else { p = 0 }
            } while (0);
            d = g * -2 | 0;
            b[l + (d + 64 << 1) >> 1] = b[f + (d << 1) >> 1] | 0;
            d = g << 1;
            b[l + (d + 64 << 1) >> 1] = b[f + (d << 1) >> 1] | 0;
            do {
                if (p) {
                    h = b[f >> 1] | 0;
                    b[l + 128 >> 1] = h;
                    n = h & 65535;
                    h = (e[f - 128 >> 1] | 0) - n | 0;
                    o = (e[f + 128 >> 1] | 0) - n | 0;
                    m = 1;
                    do {
                        j = (((ga(h, m) | 0) + 32 | 0) >>> 6) + n & 65535;
                        b[l + (64 - m << 1) >> 1] = j;
                        j = (((ga(o, m) | 0) + 32 | 0) >>> 6) + n & 65535;
                        b[l + (m + 64 << 1) >> 1] = j;
                        m = m + 1 | 0;
                    } while ((m | 0) < 64)
                } else {
                    m = d - 1 | 0;
                    n = 1 - d | 0;
                    if ((n | 0) > (m | 0)) { break }
                    o = n;
                    h = b[f + (n << 1) >> 1] | 0;
                    while (1) {
                        n = o + 1 | 0;
                        j = b[f + (n << 1) >> 1] | 0;
                        b[l + (o + 64 << 1) >> 1] = ((j & 65535) + 2 + ((h & 65535) << 1) + (e[f + (o - 1 << 1) >> 1] | 0) | 0) >>> 2;
                        if ((o | 0) < (m | 0)) {
                            o = n;
                            h = j
                        } else { break }
                    }
                }
            } while (0);
            cv(f + (-d << 1) | 0, l + (64 - d << 1) | 0, g << 3 | 2) | 0;
            i = k;
            return
        }

        function oi(a, d, f, g, h, i) {
            a = a | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0;
            j = (h | 0) == 0;
            k = c[(j ? a + 40 | 0 : a + 44 | 0) >> 2] | 0;
            l = (c[a + 4 + (h << 2) >> 2] | 0) + ((ga(k, f) | 0) + d << 1) | 0;
            d = (g | 0) > 1;
            if (d) {
                f = g;
                h = 0;
                while (1) {
                    a = f >> 1;
                    if ((a | 0) > 1) {
                        f = a;
                        h = h + 1 | 0
                    } else { break }
                }
                m = h + 2 | 0
            } else { m = 1 }
            h = (g | 0) > 0;
            if (h) {
                f = 0;
                a = 0;
                while (1) {
                    n = a + 1 | 0;
                    o = (e[i + (n << 1) >> 1] | 0) + f + (e[i + (~a << 1) >> 1] | 0) | 0;
                    if ((n | 0) < (g | 0)) {
                        f = o;
                        a = n
                    } else { p = o; break }
                }
            } else { p = 0 }
            a = p + g >> m;
            if (!(j & (g | 0) < 32)) {
                if (!h) { return }
                h = a & 65535;
                j = 0;
                do {
                    m = ga(j, k) | 0;
                    p = 0;
                    do {
                        b[l + (p + m << 1) >> 1] = h;
                        p = p + 1 | 0;
                    } while ((p | 0) < (g | 0));
                    j = j + 1 | 0;
                } while ((j | 0) < (g | 0));
                return
            }
            b[l >> 1] = ((a << 1) + 2 + (e[i - 2 >> 1] | 0) + (e[i + 2 >> 1] | 0) | 0) >>> 2;
            if (!d) { return }
            j = (a * 3 | 0) + 2 | 0;
            h = 1;
            while (1) {
                p = h + 1 | 0;
                b[l + (h << 1) >> 1] = (j + (e[i + (p << 1) >> 1] | 0) | 0) >>> 2;
                if ((p | 0) < (g | 0)) { h = p } else { break }
            }
            if (!d) { return }
            h = (a * 3 | 0) + 2 | 0;
            j = 1;
            do {
                p = l + ((ga(j, k) | 0) << 1) | 0;
                b[p >> 1] = (h + (e[i + (~j << 1) >> 1] | 0) | 0) >>> 2;
                j = j + 1 | 0;
            } while ((j | 0) < (g | 0));
            if (!d) { return }
            d = a & 65535;
            a = 1;
            do {
                j = ga(a, k) | 0;
                i = 1;
                do {
                    b[l + (i + j << 1) >> 1] = d;
                    i = i + 1 | 0;
                } while ((i | 0) < (g | 0));
                a = a + 1 | 0;
            } while ((a | 0) < (g | 0));
            return
        }

        function pi(f, g, h, j, k, l, m) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0;
            n = i;
            o = m;
            p = i;
            i = i + 258 | 0;
            i = i + 7 & -8;
            q = (l | 0) == 0;
            r = c[(q ? f + 40 | 0 : f + 44 | 0) >> 2] | 0;
            s = (c[f + 4 + (l << 2) >> 2] | 0) + ((ga(r, h) | 0) + g << 1) | 0;
            l = c[(q ? f + 5760 | 0 : f + 5768 | 0) >> 2] | 0;
            if ((j | 0) >= 35) { ec(12952, 15552, 596, 18712) }
            if ((j | 0) <= 1) { ec(10072, 15552, 597, 18712) }
            t = c[64 + (j << 2) >> 2] | 0;
            do {
                if ((a[f + 5750 | 0] | 0) == 0) { u = 0 } else {
                    v = c[f + 10368 >> 2] | 0;
                    w = g >> v;
                    x = h >> v;
                    if (!((w | 0) > -1)) { ec(7e3, 5152, 118, 17336) }
                    v = c[f + 10372 >> 2] | 0;
                    if ((w | 0) >= (v | 0)) { ec(7e3, 5152, 118, 17336) }
                    if (!((x | 0) > -1)) { ec(3672, 5152, 119, 17336) }
                    if ((x | 0) < (c[f + 10376 >> 2] | 0)) {
                        y = (ga(v, x) | 0) + w | 0;
                        w = (c[f + 10360 >> 2] | 0) + (y * 3 | 0) | 0;
                        u = ((d[w] | d[w + 1 | 0] << 8) << 16 >> 16 & 2048) != 0;
                        break
                    } else { ec(3672, 5152, 119, 17336) }
                }
            } while (0);
            f = (k | 0) < 0;
            if ((j | 0) > 17) {
                if (!f) { cv(p + 128 | 0, o | 0, (k << 1) + 2 | 0) | 0 }
                o = j - 11 | 0;
                do {
                    if (o >>> 0 < 15 >>> 0) {
                        h = c[30584 + (o << 2) >> 2] | 0;
                        g = (ga(t, k) | 0) >> 5;
                        if ((g | 0) < -1) { z = g } else { break }
                        do {
                            g = m + (-((ga(z, h) | 0) + 128 >> 8) << 1) | 0;
                            b[p + (z + 64 << 1) >> 1] = b[g >> 1] | 0;
                            z = z + 1 | 0;
                        } while ((z | 0) < 0)
                    } else {
                        if ((k << 1 | 0) <= (k | 0)) { break }
                        cv(p + (k + 65 << 1) | 0, m + (k + 1 << 1) | 0, k << 1) | 0
                    }
                } while (0);
                z = (k | 0) > 0;
                if (z) {
                    o = 0;
                    while (1) {
                        h = o + 1 | 0;
                        g = ga(h, t) | 0;
                        w = g >> 5;
                        y = g & 31;
                        g = (y | 0) == 0;
                        x = w + 65 | 0;
                        v = ga(o, r) | 0;
                        A = 32 - y | 0;
                        B = 0;
                        do {
                            if (g) { b[s + (B + v << 1) >> 1] = b[p + (x + B << 1) >> 1] | 0 } else {
                                C = B + w | 0;
                                D = ga(e[p + (C + 65 << 1) >> 1] | 0, A) | 0;
                                E = (D + 16 + (ga(e[p + (C + 66 << 1) >> 1] | 0, y) | 0) | 0) >>> 5 & 65535;
                                b[s + (B + v << 1) >> 1] = E
                            }
                            B = B + 1 | 0;
                        } while ((B | 0) < (k | 0));
                        if ((h | 0) < (k | 0)) { o = h } else { break }
                    }
                }
                if (u | (j | 0) == 26 & q & (k | 0) < 32 ^ 1 | z ^ 1) {
                    F = 258;
                    G = 0;
                    i = n;
                    return
                }
                z = m + 2 | 0;
                o = (1 << l) - 1 | 0;
                B = 0;
                do {
                    v = ((e[m + (~B << 1) >> 1] | 0) - (e[m >> 1] | 0) >> 1) + (e[z >> 1] | 0) | 0;
                    if ((v | 0) < 0) { H = 0 } else { H = ((v | 0) > (o | 0) ? o : v) & 65535 }
                    v = s + ((ga(B, r) | 0) << 1) | 0;
                    b[v >> 1] = H;
                    B = B + 1 | 0;
                } while ((B | 0) < (k | 0));
                F = 258;
                G = 0;
                i = n;
                return
            } else {
                if (!f) { f = 0; while (1) { b[p + (f + 64 << 1) >> 1] = b[m + (-f << 1) >> 1] | 0; if ((f | 0) < (k | 0)) { f = f + 1 | 0 } else { break } } }
                f = j - 11 | 0;
                do {
                    if (f >>> 0 < 15 >>> 0) {
                        B = c[30584 + (f << 2) >> 2] | 0;
                        H = (ga(t, k) | 0) >> 5;
                        if ((H | 0) < -1) { I = H } else { break }
                        do {
                            H = m + ((ga(I, B) | 0) + 128 >> 8 << 1) | 0;
                            b[p + (I + 64 << 1) >> 1] = b[H >> 1] | 0;
                            I = I + 1 | 0;
                        } while ((I | 0) < 0)
                    } else {
                        B = k << 1;
                        if ((B | 0) > (k | 0)) { J = k } else { break }
                        while (1) {
                            h = J + 1 | 0;
                            b[p + (J + 65 << 1) >> 1] = b[m + (~J << 1) >> 1] | 0;
                            if ((h | 0) < (B | 0)) { J = h } else { break }
                        }
                    }
                } while (0);
                J = (k | 0) > 0;
                if (J) {
                    I = 0;
                    do {
                        f = I + 65 | 0;
                        B = ga(I, r) | 0;
                        h = 0;
                        while (1) {
                            H = h + 1 | 0;
                            o = ga(H, t) | 0;
                            z = o >> 5;
                            v = o & 31;
                            if ((v | 0) == 0) { b[s + (h + B << 1) >> 1] = b[p + (f + z << 1) >> 1] | 0 } else {
                                o = z + I | 0;
                                z = ga(e[p + (o + 65 << 1) >> 1] | 0, 32 - v | 0) | 0;
                                y = (z + 16 + (ga(e[p + (o + 66 << 1) >> 1] | 0, v) | 0) | 0) >>> 5 & 65535;
                                b[s + (h + B << 1) >> 1] = y
                            }
                            if ((H | 0) < (k | 0)) { h = H } else { break }
                        }
                        I = I + 1 | 0;
                    } while ((I | 0) < (k | 0))
                }
                if (u | (j | 0) == 10 & q & (k | 0) < 32 ^ 1 | J ^ 1) {
                    F = 258;
                    G = 0;
                    i = n;
                    return
                }
                J = m - 2 | 0;
                q = (1 << l) - 1 | 0;
                l = 0;
                while (1) {
                    j = l + 1 | 0;
                    u = ((e[m + (j << 1) >> 1] | 0) - (e[m >> 1] | 0) >> 1) + (e[J >> 1] | 0) | 0;
                    if ((u | 0) < 0) { K = 0 } else { K = ((u | 0) > (q | 0) ? q : u) & 65535 }
                    b[s + (l << 1) >> 1] = K;
                    if ((j | 0) < (k | 0)) { l = j } else { break }
                }
                F = 258;
                G = 0;
                i = n;
                return
            }
        }

        function qi(a) {
            a = a | 0;
            c[a + 8 >> 2] = 1732584193;
            c[a + 12 >> 2] = -271733879;
            c[a + 16 >> 2] = -1732584194;
            c[a + 20 >> 2] = 271733878;
            c[a >> 2] = 0;
            c[a + 4 >> 2] = 0;
            return
        }

        function ri(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            e = a | 0;
            f = c[e >> 2] | 0;
            g = f + d & 536870911;
            c[e >> 2] = g;
            e = a + 4 | 0;
            h = c[e >> 2] | 0;
            if (g >>> 0 < f >>> 0) {
                g = h + 1 | 0;
                c[e >> 2] = g;
                i = g
            } else { i = h }
            c[a + 4 >> 2] = i + (d >>> 29);
            i = f & 63;
            do {
                if ((i | 0) == 0) {
                    j = b;
                    k = d
                } else {
                    f = 64 - i | 0;
                    h = a + 24 + i | 0;
                    if (!(f >>> 0 > d >>> 0)) {
                        cv(h | 0, b | 0, f) | 0;
                        si(a, a + 24 | 0, 64) | 0;
                        j = b + f | 0;
                        k = d - f | 0;
                        break
                    }
                    cv(h | 0, b | 0, d) | 0;
                    return
                }
            } while (0);
            if (k >>> 0 > 63 >>> 0) {
                l = si(a, j, k & -64) | 0;
                m = k & 63
            } else {
                l = j;
                m = k
            }
            cv(a + 24 | 0, l | 0, m) | 0;
            return
        }

        function si(a, b, e) {
            a = a | 0;
            b = b | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0;
            f = a + 8 | 0;
            g = a + 12 | 0;
            h = a + 16 | 0;
            i = a + 20 | 0;
            j = a + 88 | 0;
            k = a + 92 | 0;
            l = a + 96 | 0;
            m = a + 100 | 0;
            n = a + 104 | 0;
            o = a + 108 | 0;
            p = a + 112 | 0;
            q = a + 116 | 0;
            r = a + 120 | 0;
            s = a + 124 | 0;
            t = a + 128 | 0;
            u = a + 132 | 0;
            v = a + 136 | 0;
            w = a + 140 | 0;
            x = a + 144 | 0;
            y = a + 148 | 0;
            a = e;
            e = b;
            b = c[f >> 2] | 0;
            z = c[g >> 2] | 0;
            A = c[i >> 2] | 0;
            B = c[h >> 2] | 0;
            do {
                C = (d[e + 1 | 0] | 0) << 8 | (d[e] | 0) | (d[e + 2 | 0] | 0) << 16 | (d[e + 3 | 0] | 0) << 24;
                c[j >> 2] = C;
                D = b - 680876936 + (z & (A ^ B) ^ A) + C | 0;
                C = (D << 7 | D >>> 25) + z | 0;
                D = (d[e + 5 | 0] | 0) << 8 | (d[e + 4 | 0] | 0) | (d[e + 6 | 0] | 0) << 16 | (d[e + 7 | 0] | 0) << 24;
                c[k >> 2] = D;
                E = A - 389564586 + D + (C & (z ^ B) ^ B) | 0;
                D = (E << 12 | E >>> 20) + C | 0;
                E = (d[e + 9 | 0] | 0) << 8 | (d[e + 8 | 0] | 0) | (d[e + 10 | 0] | 0) << 16 | (d[e + 11 | 0] | 0) << 24;
                c[l >> 2] = E;
                F = B + 606105819 + E + (D & (C ^ z) ^ z) | 0;
                E = (F << 17 | F >>> 15) + D | 0;
                F = (d[e + 13 | 0] | 0) << 8 | (d[e + 12 | 0] | 0) | (d[e + 14 | 0] | 0) << 16 | (d[e + 15 | 0] | 0) << 24;
                c[m >> 2] = F;
                G = z - 1044525330 + F + (E & (D ^ C) ^ C) | 0;
                F = (G << 22 | G >>> 10) + E | 0;
                G = (d[e + 17 | 0] | 0) << 8 | (d[e + 16 | 0] | 0) | (d[e + 18 | 0] | 0) << 16 | (d[e + 19 | 0] | 0) << 24;
                c[n >> 2] = G;
                H = C - 176418897 + G + (F & (E ^ D) ^ D) | 0;
                G = (H << 7 | H >>> 25) + F | 0;
                H = (d[e + 21 | 0] | 0) << 8 | (d[e + 20 | 0] | 0) | (d[e + 22 | 0] | 0) << 16 | (d[e + 23 | 0] | 0) << 24;
                c[o >> 2] = H;
                C = D + 1200080426 + H + (G & (F ^ E) ^ E) | 0;
                H = (C << 12 | C >>> 20) + G | 0;
                C = (d[e + 25 | 0] | 0) << 8 | (d[e + 24 | 0] | 0) | (d[e + 26 | 0] | 0) << 16 | (d[e + 27 | 0] | 0) << 24;
                c[p >> 2] = C;
                D = E - 1473231341 + C + (H & (G ^ F) ^ F) | 0;
                C = (D << 17 | D >>> 15) + H | 0;
                D = (d[e + 29 | 0] | 0) << 8 | (d[e + 28 | 0] | 0) | (d[e + 30 | 0] | 0) << 16 | (d[e + 31 | 0] | 0) << 24;
                c[q >> 2] = D;
                E = F - 45705983 + D + (C & (H ^ G) ^ G) | 0;
                D = (E << 22 | E >>> 10) + C | 0;
                E = (d[e + 33 | 0] | 0) << 8 | (d[e + 32 | 0] | 0) | (d[e + 34 | 0] | 0) << 16 | (d[e + 35 | 0] | 0) << 24;
                c[r >> 2] = E;
                F = G + 1770035416 + E + (D & (C ^ H) ^ H) | 0;
                E = (F << 7 | F >>> 25) + D | 0;
                F = (d[e + 37 | 0] | 0) << 8 | (d[e + 36 | 0] | 0) | (d[e + 38 | 0] | 0) << 16 | (d[e + 39 | 0] | 0) << 24;
                c[s >> 2] = F;
                G = H - 1958414417 + F + (E & (D ^ C) ^ C) | 0;
                F = (G << 12 | G >>> 20) + E | 0;
                G = (d[e + 41 | 0] | 0) << 8 | (d[e + 40 | 0] | 0) | (d[e + 42 | 0] | 0) << 16 | (d[e + 43 | 0] | 0) << 24;
                c[t >> 2] = G;
                H = G - 42063 + C + (F & (E ^ D) ^ D) | 0;
                C = (H << 17 | H >>> 15) + F | 0;
                H = (d[e + 45 | 0] | 0) << 8 | (d[e + 44 | 0] | 0) | (d[e + 46 | 0] | 0) << 16 | (d[e + 47 | 0] | 0) << 24;
                c[u >> 2] = H;
                G = H - 1990404162 + D + (C & (F ^ E) ^ E) | 0;
                D = (G << 22 | G >>> 10) + C | 0;
                G = (d[e + 49 | 0] | 0) << 8 | (d[e + 48 | 0] | 0) | (d[e + 50 | 0] | 0) << 16 | (d[e + 51 | 0] | 0) << 24;
                c[v >> 2] = G;
                H = G + 1804603682 + E + (D & (C ^ F) ^ F) | 0;
                E = (H << 7 | H >>> 25) + D | 0;
                H = (d[e + 53 | 0] | 0) << 8 | (d[e + 52 | 0] | 0) | (d[e + 54 | 0] | 0) << 16 | (d[e + 55 | 0] | 0) << 24;
                c[w >> 2] = H;
                G = H - 40341101 + F + (E & (D ^ C) ^ C) | 0;
                F = (G << 12 | G >>> 20) + E | 0;
                G = (d[e + 57 | 0] | 0) << 8 | (d[e + 56 | 0] | 0) | (d[e + 58 | 0] | 0) << 16 | (d[e + 59 | 0] | 0) << 24;
                c[x >> 2] = G;
                H = G - 1502002290 + C + (F & (E ^ D) ^ D) | 0;
                C = (H << 17 | H >>> 15) + F | 0;
                H = (d[e + 61 | 0] | 0) << 8 | (d[e + 60 | 0] | 0) | (d[e + 62 | 0] | 0) << 16 | (d[e + 63 | 0] | 0) << 24;
                c[y >> 2] = H;
                G = H + 1236535329 + D + (C & (F ^ E) ^ E) | 0;
                D = (G << 22 | G >>> 10) + C | 0;
                G = c[k >> 2] | 0;
                I = G - 165796510 + E + ((D ^ C) & F ^ C) | 0;
                E = (I << 5 | I >>> 27) + D | 0;
                I = c[p >> 2] | 0;
                J = I - 1069501632 + F + ((E ^ D) & C ^ D) | 0;
                F = (J << 9 | J >>> 23) + E | 0;
                J = c[u >> 2] | 0;
                K = J + 643717713 + C + ((F ^ E) & D ^ E) | 0;
                C = (K << 14 | K >>> 18) + F | 0;
                K = c[j >> 2] | 0;
                L = K - 373897302 + D + ((C ^ F) & E ^ F) | 0;
                D = (L << 20 | L >>> 12) + C | 0;
                L = c[o >> 2] | 0;
                M = L - 701558691 + E + ((D ^ C) & F ^ C) | 0;
                E = (M << 5 | M >>> 27) + D | 0;
                M = c[t >> 2] | 0;
                N = M + 38016083 + F + ((E ^ D) & C ^ D) | 0;
                F = (N << 9 | N >>> 23) + E | 0;
                N = H - 660478335 + C + ((F ^ E) & D ^ E) | 0;
                C = (N << 14 | N >>> 18) + F | 0;
                N = c[n >> 2] | 0;
                O = N - 405537848 + D + ((C ^ F) & E ^ F) | 0;
                D = (O << 20 | O >>> 12) + C | 0;
                O = c[s >> 2] | 0;
                P = O + 568446438 + E + ((D ^ C) & F ^ C) | 0;
                E = (P << 5 | P >>> 27) + D | 0;
                P = c[x >> 2] | 0;
                Q = P - 1019803690 + F + ((E ^ D) & C ^ D) | 0;
                F = (Q << 9 | Q >>> 23) + E | 0;
                Q = c[m >> 2] | 0;
                R = Q - 187363961 + C + ((F ^ E) & D ^ E) | 0;
                C = (R << 14 | R >>> 18) + F | 0;
                R = c[r >> 2] | 0;
                S = R + 1163531501 + D + ((C ^ F) & E ^ F) | 0;
                D = (S << 20 | S >>> 12) + C | 0;
                S = c[w >> 2] | 0;
                T = S - 1444681467 + E + ((D ^ C) & F ^ C) | 0;
                E = (T << 5 | T >>> 27) + D | 0;
                T = c[l >> 2] | 0;
                U = T - 51403784 + F + ((E ^ D) & C ^ D) | 0;
                F = (U << 9 | U >>> 23) + E | 0;
                U = c[q >> 2] | 0;
                V = U + 1735328473 + C + ((F ^ E) & D ^ E) | 0;
                C = (V << 14 | V >>> 18) + F | 0;
                V = C ^ F;
                W = c[v >> 2] | 0;
                X = W - 1926607734 + D + (V & E ^ F) | 0;
                D = (X << 20 | X >>> 12) + C | 0;
                X = L - 378558 + E + (V ^ D) | 0;
                V = (X << 4 | X >>> 28) + D | 0;
                X = R - 2022574463 + F + (D ^ C ^ V) | 0;
                F = (X << 11 | X >>> 21) + V | 0;
                X = J + 1839030562 + C + (V ^ D ^ F) | 0;
                C = (X << 16 | X >>> 16) + F | 0;
                X = P - 35309556 + D + (F ^ V ^ C) | 0;
                D = (X << 23 | X >>> 9) + C | 0;
                X = G - 1530992060 + V + (C ^ F ^ D) | 0;
                V = (X << 4 | X >>> 28) + D | 0;
                X = N + 1272893353 + F + (D ^ C ^ V) | 0;
                F = (X << 11 | X >>> 21) + V | 0;
                X = U - 155497632 + C + (V ^ D ^ F) | 0;
                C = (X << 16 | X >>> 16) + F | 0;
                X = M - 1094730640 + D + (F ^ V ^ C) | 0;
                D = (X << 23 | X >>> 9) + C | 0;
                X = S + 681279174 + V + (C ^ F ^ D) | 0;
                V = (X << 4 | X >>> 28) + D | 0;
                X = K - 358537222 + F + (D ^ C ^ V) | 0;
                F = (X << 11 | X >>> 21) + V | 0;
                X = Q - 722521979 + C + (V ^ D ^ F) | 0;
                C = (X << 16 | X >>> 16) + F | 0;
                X = I + 76029189 + D + (F ^ V ^ C) | 0;
                D = (X << 23 | X >>> 9) + C | 0;
                X = O - 640364487 + V + (C ^ F ^ D) | 0;
                V = (X << 4 | X >>> 28) + D | 0;
                X = W - 421815835 + F + (D ^ C ^ V) | 0;
                F = (X << 11 | X >>> 21) + V | 0;
                X = H + 530742520 + C + (V ^ D ^ F) | 0;
                C = (X << 16 | X >>> 16) + F | 0;
                X = T - 995338651 + D + (F ^ V ^ C) | 0;
                D = (X << 23 | X >>> 9) + C | 0;
                X = K - 198630844 + V + ((D | ~F) ^ C) | 0;
                V = (X << 6 | X >>> 26) + D | 0;
                X = U + 1126891415 + F + ((V | ~C) ^ D) | 0;
                F = (X << 10 | X >>> 22) + V | 0;
                X = P - 1416354905 + C + ((F | ~D) ^ V) | 0;
                C = (X << 15 | X >>> 17) + F | 0;
                X = L - 57434055 + D + ((C | ~V) ^ F) | 0;
                D = (X << 21 | X >>> 11) + C | 0;
                X = W + 1700485571 + V + ((D | ~F) ^ C) | 0;
                V = (X << 6 | X >>> 26) + D | 0;
                X = Q - 1894986606 + F + ((V | ~C) ^ D) | 0;
                F = (X << 10 | X >>> 22) + V | 0;
                X = M - 1051523 + C + ((F | ~D) ^ V) | 0;
                C = (X << 15 | X >>> 17) + F | 0;
                X = G - 2054922799 + D + ((C | ~V) ^ F) | 0;
                D = (X << 21 | X >>> 11) + C | 0;
                X = R + 1873313359 + V + ((D | ~F) ^ C) | 0;
                V = (X << 6 | X >>> 26) + D | 0;
                X = H - 30611744 + F + ((V | ~C) ^ D) | 0;
                F = (X << 10 | X >>> 22) + V | 0;
                X = I - 1560198380 + C + ((F | ~D) ^ V) | 0;
                C = (X << 15 | X >>> 17) + F | 0;
                X = S + 1309151649 + D + ((C | ~V) ^ F) | 0;
                D = (X << 21 | X >>> 11) + C | 0;
                X = N - 145523070 + V + ((D | ~F) ^ C) | 0;
                V = (X << 6 | X >>> 26) + D | 0;
                X = J - 1120210379 + F + ((V | ~C) ^ D) | 0;
                F = (X << 10 | X >>> 22) + V | 0;
                X = T + 718787259 + C + ((F | ~D) ^ V) | 0;
                C = (X << 15 | X >>> 17) + F | 0;
                X = O - 343485551 + D + ((C | ~V) ^ F) | 0;
                b = V + b | 0;
                z = C + z + (X << 21 | X >>> 11) | 0;
                B = C + B | 0;
                A = F + A | 0;
                e = e + 64 | 0;
                a = a - 64 | 0;
            } while ((a | 0) != 0);
            c[f >> 2] = b;
            c[g >> 2] = z;
            c[h >> 2] = B;
            c[i >> 2] = A;
            return e | 0
        }

        function ti(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            e = d | 0;
            f = c[e >> 2] & 63;
            g = f + 1 | 0;
            h = d + 24 | 0;
            a[d + 24 + f | 0] = -128;
            i = f ^ 63;
            if (i >>> 0 < 8 >>> 0) {
                dv(d + 24 + g | 0, 0, i | 0) | 0;
                f = h | 0;
                si(d, f, 64) | 0;
                j = 56;
                k = 0;
                l = f
            } else {
                j = i - 8 | 0;
                k = g;
                l = h | 0
            }
            dv(d + 24 + k | 0, 0, j | 0) | 0;
            j = c[e >> 2] | 0;
            k = j << 3;
            c[e >> 2] = k;
            a[d + 80 | 0] = k;
            a[d + 81 | 0] = j >>> 5;
            a[d + 82 | 0] = j >>> 13;
            a[d + 83 | 0] = j >>> 21;
            j = c[d + 4 >> 2] | 0;
            a[d + 84 | 0] = j;
            a[d + 85 | 0] = j >>> 8;
            a[d + 86 | 0] = j >>> 16;
            a[d + 87 | 0] = j >>> 24;
            si(d, l, 64) | 0;
            l = d + 8 | 0;
            a[b] = c[l >> 2];
            a[b + 1 | 0] = (c[l >> 2] | 0) >>> 8;
            a[b + 2 | 0] = (c[l >> 2] | 0) >>> 16;
            a[b + 3 | 0] = (c[l >> 2] | 0) >>> 24;
            l = d + 12 | 0;
            a[b + 4 | 0] = c[l >> 2];
            a[b + 5 | 0] = (c[l >> 2] | 0) >>> 8;
            a[b + 6 | 0] = (c[l >> 2] | 0) >>> 16;
            a[b + 7 | 0] = (c[l >> 2] | 0) >>> 24;
            l = d + 16 | 0;
            a[b + 8 | 0] = c[l >> 2];
            a[b + 9 | 0] = (c[l >> 2] | 0) >>> 8;
            a[b + 10 | 0] = (c[l >> 2] | 0) >>> 16;
            a[b + 11 | 0] = (c[l >> 2] | 0) >>> 24;
            l = d + 20 | 0;
            a[b + 12 | 0] = c[l >> 2];
            a[b + 13 | 0] = (c[l >> 2] | 0) >>> 8;
            a[b + 14 | 0] = (c[l >> 2] | 0) >>> 16;
            a[b + 15 | 0] = (c[l >> 2] | 0) >>> 24;
            dv(d | 0, 0, 152) | 0;
            return
        }

        function ui(e, f, g, h, j, k, l, m, n, o, p) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            var q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0;
            q = i;
            i = i + 49160 | 0;
            r = q | 0;
            s = q + 16384 | 0;
            t = q + 49152 | 0;
            u = k + h | 0;
            h = l + j | 0;
            j = g + 764 | 0;
            l = c[g + 5780 >> 2] | 0;
            k = c[g + 5784 >> 2] | 0;
            v = c[g + 40 >> 2] | 0;
            w = (ga(v, h) | 0) + u | 0;
            x = (c[g + 4 >> 2] | 0) + (w << d[g + 16 | 0]) | 0;
            w = c[g + 44 >> 2] | 0;
            y = (ga(w, (h | 0) / (k | 0) | 0) | 0) + ((u | 0) / (l | 0) | 0) | 0;
            z = (c[g + 8 >> 2] | 0) + (y << d[g + 17 | 0]) | 0;
            A = (c[g + 12 >> 2] | 0) + (y << d[g + 18 | 0]) | 0;
            y = a[p | 0] | 0;
            B = y & 255;
            c[t >> 2] = B;
            C = a[p + 1 | 0] | 0;
            D = C & 255;
            E = t + 4 | 0;
            c[E >> 2] = D;
            F = g + 5760 | 0;
            G = c[F >> 2] | 0;
            H = g + 5768 | 0;
            I = c[H >> 2] | 0;
            J = g + 5961 | 0;
            do {
                if ((a[J] | 0) == 0) {
                    if (y << 24 >> 24 == 0 | C << 24 >> 24 == 0) { K = D; break }
                    if ((b[p + 4 >> 1] | 0) != (b[p + 8 >> 1] | 0)) { K = D; break }
                    if ((b[p + 6 >> 1] | 0) != (b[p + 10 >> 1] | 0)) { K = D; break }
                    if ((c[f + 916 + (a[p + 2 | 0] << 2) >> 2] | 0) != (c[f + 980 + (a[p + 3 | 0] << 2) >> 2] | 0)) { K = D; break }
                    c[E >> 2] = 0;
                    K = 0
                } else { K = D }
            } while (0);
            D = e;
            E = g + 10516 | 0;
            C = e + 4 | 0;
            L = 0;
            M = B;
            a: while (1) {
                do {
                    if ((M | 0) != 0) {
                        B = a[p + 2 + L | 0] | 0;
                        if (B << 24 >> 24 > 15) { N = 10; break a }
                        O = Qc[c[(c[D >> 2] | 0) + 8 >> 2] & 63](e, c[f + 916 + (L << 6) + (B << 24 >> 24 << 2) >> 2] | 0) | 0;
                        if ((c[O + 96 >> 2] | 0) == 0) {
                            a[E] = 3;
                            Ue(C, 1012, 0);
                            break
                        }
                        B = p + 4 + (L << 2) | 0;
                        P = b[B >> 1] | 0;
                        Q = p + 4 + (L << 2) + 2 | 0;
                        R = b[Q >> 1] | 0;
                        S = r + (L << 13) | 0;
                        T = c[O + 4 >> 2] | 0;
                        if ((c[F >> 2] | 0) > 8) { vi(e, j, P, R, u, h, S, m, T, c[O + 40 >> 2] | 0, n, o, G) } else { wi(e, j, P, R, u, h, S, m, T, c[O + 40 >> 2] | 0, n, o, G) }
                        T = b[B >> 1] | 0;
                        S = b[Q >> 1] | 0;
                        R = s + (L << 13) | 0;
                        P = c[O + 8 >> 2] | 0;
                        if ((c[F >> 2] | 0) > 8) {
                            U = O + 44 | 0;
                            V = (n | 0) / (l | 0) | 0;
                            W = (o | 0) / (k | 0) | 0;
                            xi(e, j, T, S, u, h, R, m, P, c[U >> 2] | 0, V, W, I);
                            xi(e, j, b[B >> 1] | 0, b[Q >> 1] | 0, u, h, s + 16384 + (L << 13) | 0, m, c[O + 12 >> 2] | 0, c[U >> 2] | 0, V, W, I);
                            break
                        } else {
                            W = O + 44 | 0;
                            V = (n | 0) / (l | 0) | 0;
                            U = (o | 0) / (k | 0) | 0;
                            yi(e, j, T, S, u, h, R, m, P, c[W >> 2] | 0, V, U, I);
                            yi(e, j, b[B >> 1] | 0, b[Q >> 1] | 0, u, h, s + 16384 + (L << 13) | 0, m, c[O + 12 >> 2] | 0, c[W >> 2] | 0, V, U, I);
                            break
                        }
                    }
                } while (0);
                U = L + 1 | 0;
                if ((U | 0) >= 2) { break }
                L = U;
                M = c[t + (U << 2) >> 2] | 0
            }
            if ((N | 0) == 10) {
                a[E] = 3;
                Ue(C, 1012, 0);
                X = 32768;
                Y = 0;
                Z = 16384;
                _ = 0;
                i = q;
                return
            }
            N = 14 - (c[F >> 2] | 0) | 0;
            F = (N | 0) < 2 ? 2 : N;
            N = d[g + 5920 | 0] | 0;
            t = 14 - (c[H >> 2] | 0) | 0;
            H = (t | 0) < 2 ? 2 : t;
            t = d[g + 5921 | 0] | 0;
            M = c[f + 20 >> 2] | 0;
            if ((M | 0) == 1) {
                L = y << 24 >> 24 == 1 & (K | 0) == 0;
                if ((a[J] | 0) == 0) {
                    if (!L) {
                        Ue(C, 1011, 0);
                        a[E] = 3;
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    }
                    J = r | 0;
                    if ((G | 0) < 9) { Kc[c[e + 176 >> 2] & 63](x, v, J, m, n, o) } else { Mc[c[e + 192 >> 2] & 127](x, v, J, m, n, o, G) }
                    J = s | 0;
                    h = (n | 0) / (l | 0) | 0;
                    u = (o | 0) / (k | 0) | 0;
                    if ((I | 0) < 9) {
                        j = e + 176 | 0;
                        Kc[c[j >> 2] & 63](z, w, J, m, h, u);
                        Kc[c[j >> 2] & 63](A, w, s + 16384 | 0, m, h, u);
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    } else {
                        j = e + 192 | 0;
                        Mc[c[j >> 2] & 127](z, w, J, m, h, u, I);
                        Mc[c[j >> 2] & 127](A, w, s + 16384 | 0, m, h, u, I);
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    }
                } else {
                    if (!L) {
                        Ue(C, 1011, 0);
                        a[E] = 3;
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    }
                    L = a[p + 2 | 0] | 0;
                    u = (d[f + 380 | 0] | 0) + F | 0;
                    h = (d[f + 381 | 0] | 0) + H | 0;
                    j = b[f + 446 + (L << 1) >> 1] | 0;
                    J = a[f + 510 + L | 0] << N;
                    D = b[f + 542 + (L << 2) >> 1] | 0;
                    U = a[f + 670 + (L << 1) | 0] << t;
                    V = b[f + 542 + (L << 2) + 2 >> 1] | 0;
                    W = a[f + 670 + (L << 1) + 1 | 0] << t;
                    L = r | 0;
                    if ((G | 0) < 9) { Oc[c[e + 180 >> 2] & 15](x, v, L, m, n, o, j, J, u) } else { Pc[c[e + 196 >> 2] & 15](x, v, L, m, n, o, j, J, u, G) }
                    u = s | 0;
                    J = (n | 0) / (l | 0) | 0;
                    j = (o | 0) / (k | 0) | 0;
                    if ((I | 0) < 9) {
                        L = e + 180 | 0;
                        Oc[c[L >> 2] & 15](z, w, u, m, J, j, D, U, h);
                        Oc[c[L >> 2] & 15](A, w, s + 16384 | 0, m, J, j, V, W, h);
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    } else {
                        L = e + 196 | 0;
                        Pc[c[L >> 2] & 15](z, w, u, m, J, j, D, U, h, I);
                        Pc[c[L >> 2] & 15](A, w, s + 16384 | 0, m, J, j, V, W, h, I);
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    }
                }
            } else if ((M | 0) == 0) {
                M = (K | 0) == 1;
                do {
                    if (y << 24 >> 24 == 1) {
                        if (!M) { break }
                        if ((a[g + 5962 | 0] | 0) == 0) {
                            K = r | 0;
                            h = r + 8192 | 0;
                            W = e + 172 | 0;
                            if ((G | 0) < 9) { Mc[c[W >> 2] & 127](x, v, K, h, m, n, o) } else { Jc[c[e + 188 >> 2] & 63](x, v, K, h, m, n, o, G) }
                            h = s | 0;
                            K = s + 8192 | 0;
                            V = s + 16384 | 0;
                            j = s + 24576 | 0;
                            J = (n | 0) / (l | 0) | 0;
                            L = (o | 0) / (k | 0) | 0;
                            if ((I | 0) < 9) {
                                U = W | 0;
                                Mc[c[U >> 2] & 127](z, w, h, K, m, J, L);
                                Mc[c[U >> 2] & 127](A, w, V, j, m, J, L);
                                X = 32768;
                                Y = 0;
                                Z = 16384;
                                _ = 0;
                                i = q;
                                return
                            } else {
                                U = e + 188 | 0;
                                Jc[c[U >> 2] & 63](z, w, h, K, m, J, L, I);
                                Jc[c[U >> 2] & 63](A, w, V, j, m, J, L, I);
                                X = 32768;
                                Y = 0;
                                Z = 16384;
                                _ = 0;
                                i = q;
                                return
                            }
                        } else {
                            L = a[p + 2 | 0] | 0;
                            J = a[p + 3 | 0] | 0;
                            j = (d[f + 380 | 0] | 0) + F | 0;
                            V = (d[f + 381 | 0] | 0) + H | 0;
                            U = b[f + 446 + (L << 1) >> 1] | 0;
                            K = a[f + 510 + L | 0] << N;
                            h = b[f + 478 + (J << 1) >> 1] | 0;
                            W = a[f + 526 + J | 0] << N;
                            D = b[f + 542 + (L << 2) >> 1] | 0;
                            u = a[f + 670 + (L << 1) | 0] << t;
                            O = b[f + 542 + (L << 2) + 2 >> 1] | 0;
                            Q = a[f + 670 + (L << 1) + 1 | 0] << t;
                            L = b[f + 606 + (J << 2) >> 1] | 0;
                            B = a[f + 702 + (J << 1) | 0] << t;
                            P = b[f + 606 + (J << 2) + 2 >> 1] | 0;
                            R = a[f + 702 + (J << 1) + 1 | 0] << t;
                            J = r | 0;
                            S = r + 8192 | 0;
                            if ((G | 0) < 9) { Rc[c[e + 184 >> 2] & 3](x, v, J, S, m, n, o, U, K, h, W, j) } else { Lc[c[e + 200 >> 2] & 3](x, v, J, S, m, n, o, U, K, h, W, j, G) }
                            j = s | 0;
                            W = s + 8192 | 0;
                            h = s + 16384 | 0;
                            K = s + 24576 | 0;
                            U = (n | 0) / (l | 0) | 0;
                            S = (o | 0) / (k | 0) | 0;
                            if ((I | 0) < 9) {
                                J = e + 184 | 0;
                                Rc[c[J >> 2] & 3](z, w, j, W, m, U, S, D, u, L, B, V);
                                Rc[c[J >> 2] & 3](A, w, h, K, m, U, S, O, Q, P, R, V);
                                X = 32768;
                                Y = 0;
                                Z = 16384;
                                _ = 0;
                                i = q;
                                return
                            } else {
                                J = e + 200 | 0;
                                Lc[c[J >> 2] & 3](z, w, j, W, m, U, S, D, u, L, B, V, I);
                                Lc[c[J >> 2] & 3](A, w, h, K, m, U, S, O, Q, P, R, V, I);
                                X = 32768;
                                Y = 0;
                                Z = 16384;
                                _ = 0;
                                i = q;
                                return
                            }
                        }
                    } else {
                        if (M) { break }
                        Ue(C, 1011, 0);
                        a[E] = 3;
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    }
                } while (0);
                E = y << 24 >> 24 == 0 | 0;
                if ((a[g + 5962 | 0] | 0) == 0) {
                    g = r + (E << 13) | 0;
                    if ((G | 0) < 9) { Kc[c[e + 176 >> 2] & 63](x, v, g, m, n, o) } else { Mc[c[e + 192 >> 2] & 127](x, v, g, m, n, o, G) }
                    g = s + (E << 13) | 0;
                    y = (n | 0) / (l | 0) | 0;
                    C = (o | 0) / (k | 0) | 0;
                    if ((I | 0) < 9) {
                        M = e + 176 | 0;
                        Kc[c[M >> 2] & 63](z, w, g, m, y, C);
                        Kc[c[M >> 2] & 63](A, w, s + 16384 + (E << 13) | 0, m, y, C);
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    } else {
                        M = e + 192 | 0;
                        Mc[c[M >> 2] & 127](z, w, g, m, y, C, I);
                        Mc[c[M >> 2] & 127](A, w, s + 16384 + (E << 13) | 0, m, y, C, I);
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    }
                } else {
                    C = a[p + 2 + E | 0] | 0;
                    p = (d[f + 380 | 0] | 0) + F | 0;
                    F = (d[f + 381 | 0] | 0) + H | 0;
                    H = b[f + 446 + (E << 5) + (C << 1) >> 1] | 0;
                    y = a[f + 510 + (E << 4) + C | 0] << N;
                    N = b[f + 542 + (E << 6) + (C << 2) >> 1] | 0;
                    M = a[f + 670 + (E << 5) + (C << 1) | 0] << t;
                    g = b[f + 542 + (E << 6) + (C << 2) + 2 >> 1] | 0;
                    V = a[f + 670 + (E << 5) + (C << 1) + 1 | 0] << t;
                    t = r + (E << 13) | 0;
                    if ((G | 0) < 9) { Oc[c[e + 180 >> 2] & 15](x, v, t, m, n, o, H, y, p) } else { Pc[c[e + 196 >> 2] & 15](x, v, t, m, n, o, H, y, p, G) }
                    G = s + (E << 13) | 0;
                    p = (n | 0) / (l | 0) | 0;
                    l = (o | 0) / (k | 0) | 0;
                    if ((I | 0) < 9) {
                        k = e + 180 | 0;
                        Oc[c[k >> 2] & 15](z, w, G, m, p, l, N, M, F);
                        Oc[c[k >> 2] & 15](A, w, s + 16384 + (E << 13) | 0, m, p, l, g, V, F);
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    } else {
                        k = e + 196 | 0;
                        Pc[c[k >> 2] & 15](z, w, G, m, p, l, N, M, F, I);
                        Pc[c[k >> 2] & 15](A, w, s + 16384 + (E << 13) | 0, m, p, l, g, V, F, I);
                        X = 32768;
                        Y = 0;
                        Z = 16384;
                        _ = 0;
                        i = q;
                        return
                    }
                }
            } else { ec(8616, 15536, 489, 18272) }
        }

        function vi(a, d, f, g, h, j, k, l, m, n, o, p, q) {
            a = a | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            var r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0;
            r = i;
            i = i + 20448 | 0;
            s = r | 0;
            t = r + 9088 | 0;
            u = f & 3;
            v = g & 3;
            w = (f >> 2) + h | 0;
            h = (g >> 2) + j | 0;
            j = 14 - (c[d + 4996 >> 2] | 0) | 0;
            x = c[d + 484 >> 2] | 0;
            y = c[d + 488 >> 2] | 0;
            if (((g | f) & 3 | 0) == 0) {
                do {
                    if ((h | w | 0) > -1) {
                        if ((w + o | 0) > (x | 0)) { break }
                        if ((h + p | 0) > (y | 0)) { break }
                        f = m + ((ga(h, n) | 0) + w << 1) | 0;
                        g = s | 0;
                        if ((q | 0) < 9) {
                            Mc[c[a + 220 >> 2] & 127](k, l, f, n, o, p, g);
                            z = 9088;
                            A = 0;
                            i = r;
                            return
                        } else {
                            Jc[c[a + 300 >> 2] & 63](k, l, f, n, o, p, g, q);
                            z = 9088;
                            A = 0;
                            i = r;
                            return
                        }
                    }
                } while (0);
                if ((p | 0) <= 0) {
                    z = 9088;
                    A = 0;
                    i = r;
                    return
                }
                g = y - 1 | 0;
                f = x - 1 | 0;
                if ((o | 0) > 0) { B = 0 } else {
                    z = 9088;
                    A = 0;
                    i = r;
                    return
                }
                do {
                    d = B + h | 0;
                    C = ga(B, l) | 0;
                    D = (d | 0) > (g | 0) ? g : d;
                    if ((d | 0) < 0) {
                        d = 0;
                        do {
                            E = d + w | 0;
                            if ((E | 0) < 0) { F = 0 } else { F = (E | 0) > (f | 0) ? f : E }
                            b[k + (d + C << 1) >> 1] = (e[m + (F << 1) >> 1] | 0) << j;
                            d = d + 1 | 0;
                        } while ((d | 0) < (o | 0))
                    } else {
                        d = 0;
                        do {
                            E = d + w | 0;
                            if ((E | 0) < 0) { G = 0 } else { G = (E | 0) > (f | 0) ? f : E }
                            E = m + ((ga(D, n) | 0) + G << 1) | 0;
                            b[k + (d + C << 1) >> 1] = (e[E >> 1] | 0) << j;
                            d = d + 1 | 0;
                        } while ((d | 0) < (o | 0))
                    }
                    B = B + 1 | 0;
                } while ((B | 0) < (p | 0));
                z = 9088;
                A = 0;
                i = r;
                return
            }
            B = c[30768 + (u << 2) >> 2] | 0;
            j = c[30872 + (u << 2) >> 2] | 0;
            G = c[30768 + (v << 2) >> 2] | 0;
            f = c[30872 + (v << 2) >> 2] | 0;
            F = -B | 0;
            do {
                if ((w - B | 0) > -1) {
                    if (!((h - G | 0) > -1)) { H = 23; break }
                    if ((w + o + j | 0) >= (x | 0)) { H = 23; break }
                    if ((h + p + f | 0) >= (y | 0)) { H = 23; break }
                    I = n;
                    J = m + ((ga(h, n) | 0) + w << 1) | 0
                } else { H = 23 }
            } while (0);
            if ((H | 0) == 23) {
                H = -G | 0;
                g = f + p | 0;
                if ((g | 0) > (H | 0)) {
                    f = j + o | 0;
                    j = (f | 0) > (F | 0);
                    d = y - 1 | 0;
                    y = x - 1 | 0;
                    x = H;
                    do {
                        if (j) {
                            H = x + h | 0;
                            C = ((x + G | 0) * 80 | 0) + B | 0;
                            D = (H | 0) > (d | 0) ? d : H;
                            if ((H | 0) < 0) {
                                H = F;
                                do {
                                    E = H + w | 0;
                                    if ((E | 0) < 0) { K = 0 } else { K = (E | 0) > (y | 0) ? y : E }
                                    b[t + (C + H << 1) >> 1] = b[m + (K << 1) >> 1] | 0;
                                    H = H + 1 | 0;
                                } while ((H | 0) < (f | 0))
                            } else {
                                H = F;
                                do {
                                    E = H + w | 0;
                                    if ((E | 0) < 0) { L = 0 } else { L = (E | 0) > (y | 0) ? y : E }
                                    E = m + ((ga(D, n) | 0) + L << 1) | 0;
                                    b[t + (C + H << 1) >> 1] = b[E >> 1] | 0;
                                    H = H + 1 | 0;
                                } while ((H | 0) < (f | 0))
                            }
                        }
                        x = x + 1 | 0;
                    } while ((x | 0) < (g | 0))
                }
                I = 80;
                J = t + ((G * 80 | 0) + B << 1) | 0
            }
            B = s | 0;
            if ((q | 0) < 9) {
                Mc[c[a + 220 + (u << 4) + (v << 2) >> 2] & 127](k, l, J, I, o, p, B);
                z = 9088;
                A = 0;
                i = r;
                return
            } else {
                Jc[c[a + 300 + (u << 4) + (v << 2) >> 2] & 63](k, l, J, I, o, p, B, q);
                z = 9088;
                A = 0;
                i = r;
                return
            }
        }

        function wi(e, f, g, h, j, k, l, m, n, o, p, q, r) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            r = r | 0;
            var s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0;
            s = i;
            i = i + 14768 | 0;
            t = s | 0;
            u = s + 9088 | 0;
            v = g & 3;
            w = h & 3;
            x = (g >> 2) + j | 0;
            j = (h >> 2) + k | 0;
            k = 14 - (c[f + 4996 >> 2] | 0) | 0;
            y = c[f + 484 >> 2] | 0;
            z = c[f + 488 >> 2] | 0;
            if (((h | g) & 3 | 0) == 0) {
                do {
                    if ((j | x | 0) > -1) {
                        if ((x + p | 0) > (y | 0)) { break }
                        if ((j + q | 0) > (z | 0)) { break }
                        g = n + ((ga(j, o) | 0) + x) | 0;
                        h = t | 0;
                        if ((r | 0) < 9) {
                            Mc[c[e + 220 >> 2] & 127](l, m, g, o, p, q, h);
                            A = 9088;
                            B = 0;
                            i = s;
                            return
                        } else {
                            Jc[c[e + 300 >> 2] & 63](l, m, g, o, p, q, h, r);
                            A = 9088;
                            B = 0;
                            i = s;
                            return
                        }
                    }
                } while (0);
                if ((q | 0) <= 0) {
                    A = 9088;
                    B = 0;
                    i = s;
                    return
                }
                h = (p | 0) > 0;
                g = z - 1 | 0;
                f = y - 1 | 0;
                C = 0;
                do {
                    if (h) {
                        D = C + j | 0;
                        E = (D | 0) < 0;
                        F = ga(C, m) | 0;
                        G = (D | 0) > (g | 0) ? g : D;
                        D = 0;
                        do {
                            H = D + x | 0;
                            if ((H | 0) < 0) { I = 0 } else { I = (H | 0) > (f | 0) ? f : H }
                            H = n + ((ga(E ? 0 : G, o) | 0) + I) | 0;
                            b[l + (D + F << 1) >> 1] = (d[H] | 0) << k;
                            D = D + 1 | 0;
                        } while ((D | 0) < (p | 0))
                    }
                    C = C + 1 | 0;
                } while ((C | 0) < (q | 0));
                A = 9088;
                B = 0;
                i = s;
                return
            }
            C = c[30768 + (v << 2) >> 2] | 0;
            k = c[30872 + (v << 2) >> 2] | 0;
            I = c[30768 + (w << 2) >> 2] | 0;
            f = c[30872 + (w << 2) >> 2] | 0;
            g = -C | 0;
            do {
                if ((x - C | 0) > -1) {
                    if (!((j - I | 0) > -1)) { J = 21; break }
                    if ((x + p + k | 0) >= (y | 0)) { J = 21; break }
                    if ((j + q + f | 0) >= (z | 0)) { J = 21; break }
                    K = o;
                    L = n + ((ga(j, o) | 0) + x) | 0
                } else { J = 21 }
            } while (0);
            if ((J | 0) == 21) {
                J = -I | 0;
                h = f + q | 0;
                if ((h | 0) > (J | 0)) {
                    f = k + p | 0;
                    k = (f | 0) > (g | 0);
                    D = z - 1 | 0;
                    z = y - 1 | 0;
                    y = J;
                    do {
                        if (k) {
                            J = y + j | 0;
                            F = (J | 0) < 0;
                            G = ((y + I | 0) * 80 | 0) + C | 0;
                            E = (J | 0) > (D | 0) ? D : J;
                            J = g;
                            do {
                                H = J + x | 0;
                                if ((H | 0) < 0) { M = 0 } else { M = (H | 0) > (z | 0) ? z : H }
                                H = n + ((ga(F ? 0 : E, o) | 0) + M) | 0;
                                a[u + (G + J) | 0] = a[H] | 0;
                                J = J + 1 | 0;
                            } while ((J | 0) < (f | 0))
                        }
                        y = y + 1 | 0;
                    } while ((y | 0) < (h | 0))
                }
                K = 80;
                L = u + ((I * 80 | 0) + C) | 0
            }
            C = t | 0;
            if ((r | 0) < 9) {
                Mc[c[e + 220 + (v << 4) + (w << 2) >> 2] & 127](l, m, L, K, p, q, C);
                A = 9088;
                B = 0;
                i = s;
                return
            } else {
                Jc[c[e + 300 + (v << 4) + (w << 2) >> 2] & 63](l, m, L, K, p, q, C, r);
                A = 9088;
                B = 0;
                i = s;
                return
            }
        }

        function xi(a, d, f, g, h, j, k, l, m, n, o, p, q) {
            a = a | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            var r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0;
            r = i;
            i = i + 19808 | 0;
            s = r | 0;
            t = r + 9088 | 0;
            u = 14 - (c[d + 5004 >> 2] | 0) | 0;
            v = c[d + 5016 >> 2] | 0;
            w = (c[d + 484 >> 2] | 0) / (v | 0) | 0;
            x = c[d + 5020 >> 2] | 0;
            y = (c[d + 488 >> 2] | 0) / (x | 0) | 0;
            d = ga(2 / (v | 0) | 0, f) | 0;
            f = ga(2 / (x | 0) | 0, g) | 0;
            g = d & 7;
            z = f & 7;
            A = ((h | 0) / (v | 0) | 0) + (d >> 3) | 0;
            v = ((j | 0) / (x | 0) | 0) + (f >> 3) | 0;
            x = (z | 0) == 0;
            if (((f | d) & 7 | 0) == 0) {
                do {
                    if ((A | 0) > -1) {
                        if (!((A + o | 0) <= (w | 0) & (v | 0) > -1)) { break }
                        if ((v + p | 0) > (y | 0)) { break }
                        d = m + ((ga(v, n) | 0) + A << 1) | 0;
                        if ((q | 0) < 9) {
                            Oc[c[a + 204 >> 2] & 15](k, l, d, n, o, p, 0, 0, 0);
                            B = 9088;
                            C = 0;
                            i = r;
                            return
                        } else {
                            Pc[c[a + 284 >> 2] & 15](k, l, d, n, o, p, 0, 0, 0, q);
                            B = 9088;
                            C = 0;
                            i = r;
                            return
                        }
                    }
                } while (0);
                if ((p | 0) <= 0) {
                    B = 9088;
                    C = 0;
                    i = r;
                    return
                }
                d = (o | 0) > 0;
                f = y - 1 | 0;
                j = w - 1 | 0;
                h = 0;
                do {
                    if (d) {
                        D = h + v | 0;
                        E = (D | 0) < 0;
                        F = ga(h, l) | 0;
                        G = (D | 0) > (f | 0) ? f : D;
                        D = 0;
                        do {
                            H = D + A | 0;
                            if ((H | 0) < 0) { I = 0 } else { I = (H | 0) > (j | 0) ? j : H }
                            H = m + ((ga(E ? 0 : G, n) | 0) + I << 1) | 0;
                            b[k + (D + F << 1) >> 1] = (e[H >> 1] | 0) << u;
                            D = D + 1 | 0;
                        } while ((D | 0) < (o | 0))
                    }
                    h = h + 1 | 0;
                } while ((h | 0) < (p | 0));
                B = 9088;
                C = 0;
                i = r;
                return
            }
            do {
                if ((A | 0) > 0) {
                    if (!((A + o | 0) <= (w - 2 | 0) & (v | 0) > 0)) { J = 17; break }
                    if ((v + p | 0) > (y - 2 | 0)) { J = 17; break }
                    K = m + ((ga(v, n) | 0) + A << 1) | 0;
                    L = n
                } else { J = 17 }
            } while (0);
            if ((J | 0) == 17) {
                J = p + 2 | 0;
                if ((J | 0) > -1) {
                    h = o + 2 | 0;
                    u = (h | 0) > -1;
                    I = y - 1 | 0;
                    y = w - 1 | 0;
                    w = -1;
                    do {
                        if (u) {
                            j = w + v | 0;
                            f = (j | 0) < 0;
                            d = (w * 80 | 0) + 80 | 0;
                            D = (j | 0) > (I | 0) ? I : j;
                            j = -1;
                            do {
                                F = j + A | 0;
                                if ((F | 0) < 0) { M = 0 } else { M = (F | 0) > (y | 0) ? y : F }
                                F = m + ((ga(f ? 0 : D, n) | 0) + M << 1) | 0;
                                j = j + 1 | 0;
                                b[t + (d + j << 1) >> 1] = b[F >> 1] | 0;
                            } while ((j | 0) < (h | 0))
                        }
                        w = w + 1 | 0;
                    } while ((w | 0) < (J | 0))
                }
                K = t + 162 | 0;
                L = 80
            }
            t = (g | 0) != 0;
            if (!(x | t ^ 1)) {
                J = s | 0;
                if ((q | 0) < 9) {
                    Pc[c[a + 216 >> 2] & 15](k, l, K, L, o, p, g, z, J, q);
                    B = 9088;
                    C = 0;
                    i = r;
                    return
                } else {
                    Pc[c[a + 296 >> 2] & 15](k, l, K, L, o, p, g, z, J, q);
                    B = 9088;
                    C = 0;
                    i = r;
                    return
                }
            }
            if (t) {
                t = s | 0;
                if ((q | 0) < 9) {
                    Pc[c[a + 208 >> 2] & 15](k, l, K, L, o, p, g, z, t, q);
                    B = 9088;
                    C = 0;
                    i = r;
                    return
                } else {
                    Pc[c[a + 288 >> 2] & 15](k, l, K, L, o, p, g, z, t, q);
                    B = 9088;
                    C = 0;
                    i = r;
                    return
                }
            }
            if (x) { ec(10064, 15536, 268, 17976) }
            x = s | 0;
            if ((q | 0) < 9) {
                Pc[c[a + 212 >> 2] & 15](k, l, K, L, o, p, 0, z, x, q);
                B = 9088;
                C = 0;
                i = r;
                return
            } else {
                Pc[c[a + 292 >> 2] & 15](k, l, K, L, o, p, 0, z, x, q);
                B = 9088;
                C = 0;
                i = r;
                return
            }
        }

        function yi(e, f, g, h, j, k, l, m, n, o, p, q, r) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            r = r | 0;
            var s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0;
            s = i;
            i = i + 14448 | 0;
            t = s | 0;
            u = s + 9088 | 0;
            v = 14 - (c[f + 5004 >> 2] | 0) | 0;
            w = c[f + 5016 >> 2] | 0;
            x = (c[f + 484 >> 2] | 0) / (w | 0) | 0;
            y = c[f + 5020 >> 2] | 0;
            z = (c[f + 488 >> 2] | 0) / (y | 0) | 0;
            f = ga(2 / (w | 0) | 0, g) | 0;
            g = ga(2 / (y | 0) | 0, h) | 0;
            h = f & 7;
            A = g & 7;
            B = ((j | 0) / (w | 0) | 0) + (f >> 3) | 0;
            w = ((k | 0) / (y | 0) | 0) + (g >> 3) | 0;
            y = (A | 0) == 0;
            if (((g | f) & 7 | 0) == 0) {
                do {
                    if ((B | 0) > -1) {
                        if (!((B + p | 0) <= (x | 0) & (w | 0) > -1)) { break }
                        if ((w + q | 0) > (z | 0)) { break }
                        f = n + ((ga(w, o) | 0) + B) | 0;
                        if ((r | 0) < 9) {
                            Oc[c[e + 204 >> 2] & 15](l, m, f, o, p, q, 0, 0, 0);
                            C = 9088;
                            D = 0;
                            i = s;
                            return
                        } else {
                            Pc[c[e + 284 >> 2] & 15](l, m, f, o, p, q, 0, 0, 0, r);
                            C = 9088;
                            D = 0;
                            i = s;
                            return
                        }
                    }
                } while (0);
                if ((q | 0) <= 0) {
                    C = 9088;
                    D = 0;
                    i = s;
                    return
                }
                f = (p | 0) > 0;
                g = z - 1 | 0;
                k = x - 1 | 0;
                j = 0;
                do {
                    if (f) {
                        E = j + w | 0;
                        F = (E | 0) < 0;
                        G = ga(j, m) | 0;
                        H = (E | 0) > (g | 0) ? g : E;
                        E = 0;
                        do {
                            I = E + B | 0;
                            if ((I | 0) < 0) { J = 0 } else { J = (I | 0) > (k | 0) ? k : I }
                            I = n + ((ga(F ? 0 : H, o) | 0) + J) | 0;
                            b[l + (E + G << 1) >> 1] = (d[I] | 0) << v;
                            E = E + 1 | 0;
                        } while ((E | 0) < (p | 0))
                    }
                    j = j + 1 | 0;
                } while ((j | 0) < (q | 0));
                C = 9088;
                D = 0;
                i = s;
                return
            }
            do {
                if ((B | 0) > 0) {
                    if (!((B + p | 0) <= (x - 2 | 0) & (w | 0) > 0)) { K = 17; break }
                    if ((w + q | 0) > (z - 2 | 0)) { K = 17; break }
                    L = n + ((ga(w, o) | 0) + B) | 0;
                    M = o
                } else { K = 17 }
            } while (0);
            if ((K | 0) == 17) {
                K = q + 2 | 0;
                if ((K | 0) > -1) {
                    j = p + 2 | 0;
                    v = (j | 0) > -1;
                    J = z - 1 | 0;
                    z = x - 1 | 0;
                    x = -1;
                    do {
                        if (v) {
                            k = x + w | 0;
                            g = (k | 0) < 0;
                            f = (x * 80 | 0) + 80 | 0;
                            E = (k | 0) > (J | 0) ? J : k;
                            k = -1;
                            do {
                                G = k + B | 0;
                                if ((G | 0) < 0) { N = 0 } else { N = (G | 0) > (z | 0) ? z : G }
                                G = n + ((ga(g ? 0 : E, o) | 0) + N) | 0;
                                k = k + 1 | 0;
                                a[u + (f + k) | 0] = a[G] | 0;
                            } while ((k | 0) < (j | 0))
                        }
                        x = x + 1 | 0;
                    } while ((x | 0) < (K | 0))
                }
                L = u + 81 | 0;
                M = 80
            }
            u = (h | 0) != 0;
            if (!(y | u ^ 1)) {
                K = t | 0;
                if ((r | 0) < 9) {
                    Pc[c[e + 216 >> 2] & 15](l, m, L, M, p, q, h, A, K, r);
                    C = 9088;
                    D = 0;
                    i = s;
                    return
                } else {
                    Pc[c[e + 296 >> 2] & 15](l, m, L, M, p, q, h, A, K, r);
                    C = 9088;
                    D = 0;
                    i = s;
                    return
                }
            }
            if (u) {
                u = t | 0;
                if ((r | 0) < 9) {
                    Pc[c[e + 208 >> 2] & 15](l, m, L, M, p, q, h, A, u, r);
                    C = 9088;
                    D = 0;
                    i = s;
                    return
                } else {
                    Pc[c[e + 288 >> 2] & 15](l, m, L, M, p, q, h, A, u, r);
                    C = 9088;
                    D = 0;
                    i = s;
                    return
                }
            }
            if (y) { ec(10064, 15536, 268, 17976) }
            y = t | 0;
            if ((r | 0) < 9) {
                Pc[c[e + 212 >> 2] & 15](l, m, L, M, p, q, 0, A, y, r);
                C = 9088;
                D = 0;
                i = s;
                return
            } else {
                Pc[c[e + 292 >> 2] & 15](l, m, L, M, p, q, 0, A, y, r);
                C = 9088;
                D = 0;
                i = s;
                return
            }
        }

        function zi(e, f, g, h, i, j, k, l, m, n, o, p) {
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            var q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0;
            k = c[e + 10060 >> 2] | 0;
            q = c[e + 10368 >> 2] | 0;
            r = f >> q;
            s = g >> q;
            if (!((r | 0) > -1)) { ec(1232, 544, 118, 17296); return 0 }
            q = c[e + 10372 >> 2] | 0;
            if ((r | 0) >= (q | 0)) { ec(1232, 544, 118, 17296); return 0 }
            if (!((s | 0) > -1)) { ec(17016, 544, 119, 17296); return 0 }
            if ((s | 0) >= (c[e + 10376 >> 2] | 0)) { ec(17016, 544, 119, 17296); return 0 }
            t = (ga(q, s) | 0) + r | 0;
            r = (c[e + 10360 >> 2] | 0) + (t * 3 | 0) | 0;
            t = ((d[r] | d[r + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 3 & 7;
            r = t & 255;
            s = i - 1 | 0;
            q = m + j | 0;
            u = q - 1 | 0;
            v = i >> k;
            w = (v | 0) == (s >> k | 0);
            if (w) {
                if ((j >> k | 0) == (u >> k | 0)) {
                    x = 0;
                    y = 0
                } else { z = 9 }
            } else { z = 9 }
            do {
                if ((z | 0) == 9) {
                    if ((n | 0) == 1) {
                        if ((r & 3 | 0) == 2 | t << 24 >> 24 == 7) {
                            x = 0;
                            y = 0;
                            break
                        }
                    }
                    if (!(ci(e, f, g, h, i, j, l, m, n, s, u) | 0)) {
                        x = 0;
                        y = 0;
                        break
                    }
                    A = c[e + 10388 >> 2] | 0;
                    B = s >> A;
                    C = u >> A;
                    if (!((B | 0) > -1)) { ec(1232, 544, 118, 17296); return 0 }
                    A = c[e + 10392 >> 2] | 0;
                    if ((B | 0) >= (A | 0)) { ec(1232, 544, 118, 17296); return 0 }
                    if (!((C | 0) > -1)) { ec(17016, 544, 119, 17296); return 0 }
                    if ((C | 0) < (c[e + 10396 >> 2] | 0)) {
                        D = (ga(A, C) | 0) + B | 0;
                        B = o | 0;
                        C = (c[e + 10380 >> 2] | 0) + (D * 12 | 0) | 0;
                        b[B >> 1] = b[C >> 1] | 0;
                        b[B + 2 >> 1] = b[C + 2 >> 1] | 0;
                        b[B + 4 >> 1] = b[C + 4 >> 1] | 0;
                        b[B + 6 >> 1] = b[C + 6 >> 1] | 0;
                        b[B + 8 >> 1] = b[C + 8 >> 1] | 0;
                        b[B + 10 >> 1] = b[C + 10 >> 1] | 0;
                        x = 1;
                        y = 1;
                        break
                    } else { ec(17016, 544, 119, 17296); return 0 }
                }
            } while (0);
            if ((x | 0) >= (p | 0)) { E = x; return E | 0 }
            u = l + i | 0;
            t = u - 1 | 0;
            C = j - 1 | 0;
            if ((v | 0) == (t >> k | 0)) {
                if ((j >> k | 0) == (C >> k | 0)) {
                    F = x;
                    G = 0;
                    H = 0
                } else { z = 22 }
            } else { z = 22 }
            a: do {
                if ((z | 0) == 22) {
                    if ((n | 0) == 1) {
                        if ((r | 0) == 5 | (r | 0) == 4 | (r | 0) == 1) {
                            F = x;
                            G = 0;
                            H = 0;
                            break
                        }
                    }
                    if (!(ci(e, f, g, h, i, j, l, m, n, t, C) | 0)) {
                        F = x;
                        G = 0;
                        H = 0;
                        break
                    }
                    B = c[e + 10388 >> 2] | 0;
                    D = t >> B;
                    A = C >> B;
                    if (!((D | 0) > -1)) { ec(1232, 544, 118, 17296); return 0 }
                    B = c[e + 10392 >> 2] | 0;
                    if ((D | 0) >= (B | 0)) { ec(1232, 544, 118, 17296); return 0 }
                    if (!((A | 0) > -1)) { ec(17016, 544, 119, 17296); return 0 }
                    if ((A | 0) >= (c[e + 10396 >> 2] | 0)) { ec(17016, 544, 119, 17296); return 0 }
                    I = (ga(B, A) | 0) + D | 0;
                    D = c[e + 10380 >> 2] | 0;
                    b: do {
                        if (y) {
                            A = 0;
                            while (1) {
                                B = a[o + A | 0] | 0;
                                if (!(B << 24 >> 24 == (a[D + (I * 12 | 0) + A | 0] | 0))) { break b }
                                if (!(B << 24 >> 24 == 0)) { if ((b[o + 4 + (A << 2) >> 1] | 0) != (b[D + (I * 12 | 0) + 4 + (A << 2) >> 1] | 0)) { break b } if ((b[o + 4 + (A << 2) + 2 >> 1] | 0) != (b[D + (I * 12 | 0) + 4 + (A << 2) + 2 >> 1] | 0)) { break b } if ((a[o + 2 + A | 0] | 0) != (a[D + (I * 12 | 0) + 2 + A | 0] | 0)) { break b } }
                                B = A + 1 | 0;
                                if ((B | 0) < 2) { A = B } else {
                                    F = x;
                                    G = 0;
                                    H = 1;
                                    break a
                                }
                            }
                        }
                    } while (0);
                    A = o + (x * 12 | 0) | 0;
                    B = D + (I * 12 | 0) | 0;
                    b[A >> 1] = b[B >> 1] | 0;
                    b[A + 2 >> 1] = b[B + 2 >> 1] | 0;
                    b[A + 4 >> 1] = b[B + 4 >> 1] | 0;
                    b[A + 6 >> 1] = b[B + 6 >> 1] | 0;
                    b[A + 8 >> 1] = b[B + 8 >> 1] | 0;
                    b[A + 10 >> 1] = b[B + 10 >> 1] | 0;
                    F = x + 1 | 0;
                    G = x;
                    H = 1
                }
            } while (0);
            if ((F | 0) >= (p | 0)) { E = F; return E | 0 }
            if ((v | 0) == (u >> k | 0)) { if ((j >> k | 0) == (C >> k | 0)) { J = F } else { z = 42 } } else { z = 42 }
            c: do {
                if ((z | 0) == 42) {
                    if (!(ci(e, f, g, h, i, j, l, m, n, u, C) | 0)) { J = F; break }
                    v = c[e + 10388 >> 2] | 0;
                    x = u >> v;
                    t = C >> v;
                    if (!((x | 0) > -1)) { ec(1232, 544, 118, 17296); return 0 }
                    v = c[e + 10392 >> 2] | 0;
                    if ((x | 0) >= (v | 0)) { ec(1232, 544, 118, 17296); return 0 }
                    if (!((t | 0) > -1)) { ec(17016, 544, 119, 17296); return 0 }
                    if ((t | 0) >= (c[e + 10396 >> 2] | 0)) { ec(17016, 544, 119, 17296); return 0 }
                    r = (ga(v, t) | 0) + x | 0;
                    x = c[e + 10380 >> 2] | 0;
                    d: do {
                        if (H) {
                            t = 0;
                            while (1) {
                                v = a[o + (G * 12 | 0) + t | 0] | 0;
                                if (!(v << 24 >> 24 == (a[x + (r * 12 | 0) + t | 0] | 0))) { break d }
                                if (!(v << 24 >> 24 == 0)) { if ((b[o + (G * 12 | 0) + 4 + (t << 2) >> 1] | 0) != (b[x + (r * 12 | 0) + 4 + (t << 2) >> 1] | 0)) { break d } if ((b[o + (G * 12 | 0) + 4 + (t << 2) + 2 >> 1] | 0) != (b[x + (r * 12 | 0) + 4 + (t << 2) + 2 >> 1] | 0)) { break d } if ((a[o + (G * 12 | 0) + 2 + t | 0] | 0) != (a[x + (r * 12 | 0) + 2 + t | 0] | 0)) { break d } }
                                v = t + 1 | 0;
                                if ((v | 0) < 2) { t = v } else { J = F; break c }
                            }
                        }
                    } while (0);
                    I = o + (F * 12 | 0) | 0;
                    D = x + (r * 12 | 0) | 0;
                    b[I >> 1] = b[D >> 1] | 0;
                    b[I + 2 >> 1] = b[D + 2 >> 1] | 0;
                    b[I + 4 >> 1] = b[D + 4 >> 1] | 0;
                    b[I + 6 >> 1] = b[D + 6 >> 1] | 0;
                    b[I + 8 >> 1] = b[D + 8 >> 1] | 0;
                    b[I + 10 >> 1] = b[D + 10 >> 1] | 0;
                    J = F + 1 | 0
                }
            } while (0);
            if ((J | 0) >= (p | 0)) { E = J; return E | 0 }
            if (w) { if ((j >> k | 0) == (q >> k | 0)) { K = J } else { z = 60 } } else { z = 60 }
            e: do {
                if ((z | 0) == 60) {
                    if (!(ci(e, f, g, h, i, j, l, m, n, s, q) | 0)) { K = J; break }
                    F = c[e + 10388 >> 2] | 0;
                    u = s >> F;
                    D = q >> F;
                    if (!((u | 0) > -1)) { ec(1232, 544, 118, 17296); return 0 }
                    F = c[e + 10392 >> 2] | 0;
                    if ((u | 0) >= (F | 0)) { ec(1232, 544, 118, 17296); return 0 }
                    if (!((D | 0) > -1)) { ec(17016, 544, 119, 17296); return 0 }
                    if ((D | 0) >= (c[e + 10396 >> 2] | 0)) { ec(17016, 544, 119, 17296); return 0 }
                    I = (ga(F, D) | 0) + u | 0;
                    u = c[e + 10380 >> 2] | 0;
                    f: do {
                        if (y) {
                            D = 0;
                            while (1) {
                                F = a[o + D | 0] | 0;
                                if (!(F << 24 >> 24 == (a[u + (I * 12 | 0) + D | 0] | 0))) { break f }
                                if (!(F << 24 >> 24 == 0)) { if ((b[o + 4 + (D << 2) >> 1] | 0) != (b[u + (I * 12 | 0) + 4 + (D << 2) >> 1] | 0)) { break f } if ((b[o + 4 + (D << 2) + 2 >> 1] | 0) != (b[u + (I * 12 | 0) + 4 + (D << 2) + 2 >> 1] | 0)) { break f } if ((a[o + 2 + D | 0] | 0) != (a[u + (I * 12 | 0) + 2 + D | 0] | 0)) { break f } }
                                F = D + 1 | 0;
                                if ((F | 0) < 2) { D = F } else { K = J; break e }
                            }
                        }
                    } while (0);
                    r = o + (J * 12 | 0) | 0;
                    x = u + (I * 12 | 0) | 0;
                    b[r >> 1] = b[x >> 1] | 0;
                    b[r + 2 >> 1] = b[x + 2 >> 1] | 0;
                    b[r + 4 >> 1] = b[x + 4 >> 1] | 0;
                    b[r + 6 >> 1] = b[x + 6 >> 1] | 0;
                    b[r + 8 >> 1] = b[x + 8 >> 1] | 0;
                    b[r + 10 >> 1] = b[x + 10 >> 1] | 0;
                    K = J + 1 | 0
                }
            } while (0);
            if ((K | 0) >= (p | 0) | (K | 0) == 4) { E = K; return E | 0 }
            do { if (w) { if ((j >> k | 0) == (C >> k | 0)) { E = K } else { break } return E | 0 } } while (0);
            if (!(ci(e, f, g, h, i, j, l, m, n, s, C) | 0)) { E = K; return E | 0 }
            n = c[e + 10388 >> 2] | 0;
            m = s >> n;
            s = C >> n;
            if (!((m | 0) > -1)) { ec(1232, 544, 118, 17296); return 0 }
            n = c[e + 10392 >> 2] | 0;
            if ((m | 0) >= (n | 0)) { ec(1232, 544, 118, 17296); return 0 }
            if (!((s | 0) > -1)) { ec(17016, 544, 119, 17296); return 0 }
            if ((s | 0) >= (c[e + 10396 >> 2] | 0)) { ec(17016, 544, 119, 17296); return 0 }
            C = (ga(n, s) | 0) + m | 0;
            m = c[e + 10380 >> 2] | 0;
            g: do {
                if (H) {
                    e = 0;
                    while (1) {
                        s = a[o + (G * 12 | 0) + e | 0] | 0;
                        if (!(s << 24 >> 24 == (a[m + (C * 12 | 0) + e | 0] | 0))) { break g }
                        if (!(s << 24 >> 24 == 0)) { if ((b[o + (G * 12 | 0) + 4 + (e << 2) >> 1] | 0) != (b[m + (C * 12 | 0) + 4 + (e << 2) >> 1] | 0)) { break g } if ((b[o + (G * 12 | 0) + 4 + (e << 2) + 2 >> 1] | 0) != (b[m + (C * 12 | 0) + 4 + (e << 2) + 2 >> 1] | 0)) { break g } if ((a[o + (G * 12 | 0) + 2 + e | 0] | 0) != (a[m + (C * 12 | 0) + 2 + e | 0] | 0)) { break g } }
                        s = e + 1 | 0;
                        if ((s | 0) < 2) { e = s } else { E = K; break }
                    }
                    return E | 0
                }
            } while (0);
            h: do {
                if (y) {
                    G = 0;
                    while (1) {
                        H = a[o + G | 0] | 0;
                        if (!(H << 24 >> 24 == (a[m + (C * 12 | 0) + G | 0] | 0))) { break h }
                        if (!(H << 24 >> 24 == 0)) { if ((b[o + 4 + (G << 2) >> 1] | 0) != (b[m + (C * 12 | 0) + 4 + (G << 2) >> 1] | 0)) { break h } if ((b[o + 4 + (G << 2) + 2 >> 1] | 0) != (b[m + (C * 12 | 0) + 4 + (G << 2) + 2 >> 1] | 0)) { break h } if ((a[o + 2 + G | 0] | 0) != (a[m + (C * 12 | 0) + 2 + G | 0] | 0)) { break h } }
                        H = G + 1 | 0;
                        if ((H | 0) < 2) { G = H } else { E = K; break }
                    }
                    return E | 0
                }
            } while (0);
            y = o + (K * 12 | 0) | 0;
            o = m + (C * 12 | 0) | 0;
            b[y >> 1] = b[o >> 1] | 0;
            b[y + 2 >> 1] = b[o + 2 >> 1] | 0;
            b[y + 4 >> 1] = b[o + 4 >> 1] | 0;
            b[y + 6 >> 1] = b[o + 6 >> 1] | 0;
            b[y + 8 >> 1] = b[o + 8 >> 1] | 0;
            b[y + 10 >> 1] = b[o + 10 >> 1] | 0;
            E = K + 1 | 0;
            return E | 0
        }

        function Ai(a, d, f, g) {
            a = a | 0;
            d = d | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            h = i;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            if ((f | 0) < -128) { k = -128 } else { k = (f | 0) > 127 ? 127 : f }
            if ((g | 0) < -128) { l = -128 } else { l = (g | 0) > 127 ? 127 : g }
            if ((k | 0) == 0) {
                g = d;
                f = a;
                C = e[g >> 1] | e[g + 2 >> 1] << 16;
                b[f >> 1] = C;
                b[f + 2 >> 1] = C >> 16;
                m = 0;
                i = h;
                return m | 0
            }
            f = (ga(((((k | 0) < 0 ? -k | 0 : k) >> 1) + 16384 | 0) / (k | 0) | 0, l) | 0) + 32 >> 6;
            if ((f | 0) < -4096) { n = -4096 } else { n = (f | 0) > 4095 ? 4095 : f }
            f = ga(b[d >> 1] | 0, n) | 0;
            l = (f | 0) < 0;
            if (l) { o = -1 } else { o = (f | 0) > 0 | 0 }
            k = (l ? -f | 0 : f) + 127 >> 8;
            do {
                if ((ga(k, o) | 0) < -32768) { p = -32768 } else {
                    if (l) { q = -1 } else { q = (f | 0) > 0 | 0 }
                    if ((ga(k, q) | 0) > 32767) { p = 32767; break }
                    if (l) { r = -1 } else { r = (f | 0) > 0 | 0 }
                    p = (ga(k, r) | 0) & 65535
                }
            } while (0);
            b[a >> 1] = p;
            p = ga(b[d + 2 >> 1] | 0, n) | 0;
            n = (p | 0) < 0;
            if (n) { s = -1 } else { s = (p | 0) > 0 | 0 }
            d = (n ? -p | 0 : p) + 127 >> 8;
            do {
                if ((ga(d, s) | 0) < -32768) { t = -32768 } else {
                    if (n) { u = -1 } else { u = (p | 0) > 0 | 0 }
                    if ((ga(d, u) | 0) > 32767) { t = 32767; break }
                    if (n) { v = -1 } else { v = (p | 0) > 0 | 0 }
                    t = (ga(d, v) | 0) & 65535
                }
            } while (0);
            b[a + 2 >> 1] = t;
            m = 1;
            i = h;
            return m | 0
        }

        function Bi(f, g, h, j, k, l, m, n, o, p, q, r) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            r = r | 0;
            var s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0;
            k = i;
            i = i + 8 | 0;
            j = k | 0;
            s = j;
            if (!(Qc[c[(c[f >> 2] | 0) + 12 >> 2] & 63](f, l) | 0)) { ec(12928, 15536, 1074, 18352) }
            t = f;
            u = Qc[c[(c[t >> 2] | 0) + 8 >> 2] & 63](f, l) | 0;
            do {
                if ((c[u + 24 >> 2] | 0) > (m | 0)) {
                    if ((c[u + 28 >> 2] | 0) <= (n | 0)) { break }
                    l = c[u + 10368 >> 2] | 0;
                    v = m >> l;
                    w = n >> l;
                    if (!((v | 0) > -1)) { ec(1232, 544, 118, 17296) }
                    l = c[u + 10372 >> 2] | 0;
                    if ((v | 0) >= (l | 0)) { ec(1232, 544, 118, 17296) }
                    if (!((w | 0) > -1)) { ec(17016, 544, 119, 17296) }
                    if ((w | 0) >= (c[u + 10376 >> 2] | 0)) { ec(17016, 544, 119, 17296) }
                    x = (ga(l, w) | 0) + v | 0;
                    v = (c[u + 10360 >> 2] | 0) + (x * 3 | 0) | 0;
                    if (((d[v] | d[v + 1 | 0] << 8) << 16 >> 16 & 768) == 0) {
                        b[q >> 1] = 0;
                        b[q + 2 >> 1] = 0;
                        a[r] = 0;
                        i = k;
                        return
                    }
                    if ((a[u + 10516 | 0] | 0) == 1) {
                        b[q >> 1] = 0;
                        b[q + 2 >> 1] = 0;
                        a[r] = 0;
                        i = k;
                        return
                    }
                    v = c[u + 10388 >> 2] | 0;
                    x = m >> v;
                    w = n >> v;
                    if (!((x | 0) > -1)) { ec(1232, 544, 118, 17296) }
                    v = c[u + 10392 >> 2] | 0;
                    if ((x | 0) >= (v | 0)) { ec(1232, 544, 118, 17296) }
                    if (!((w | 0) > -1)) { ec(17016, 544, 119, 17296) }
                    if ((w | 0) >= (c[u + 10396 >> 2] | 0)) { ec(17016, 544, 119, 17296) }
                    l = (ga(v, w) | 0) + x | 0;
                    x = c[u + 10380 >> 2] | 0;
                    do {
                        if ((a[x + (l * 12 | 0) | 0] | 0) == 0) {
                            y = 1;
                            z = x + (l * 12 | 0) + 3 | 0;
                            A = x + (l * 12 | 0) + 8 | 0
                        } else {
                            if ((a[x + (l * 12 | 0) + 1 | 0] | 0) == 0) {
                                y = 0;
                                z = x + (l * 12 | 0) + 2 | 0;
                                A = x + (l * 12 | 0) + 4 | 0;
                                break
                            }
                            w = c[g + 92 >> 2] | 0;
                            v = h + 332 | 0;
                            if ((c[v >> 2] | 0) < 1) { B = 1 } else {
                                D = 0;
                                E = 1;
                                while (1) {
                                    F = (Qc[c[(c[t >> 2] | 0) + 8 >> 2] & 63](f, c[h + 980 + (D << 2) >> 2] | 0) | 0) + 92 | 0;
                                    G = E & (c[F >> 2] | 0) <= (w | 0);
                                    F = D + 1 | 0;
                                    if ((F | 0) >= (c[v >> 2] | 0) | G ^ 1) { B = G; break } else {
                                        D = F;
                                        E = G
                                    }
                                }
                            }
                            E = h + 328 | 0;
                            if ((c[E >> 2] | 0) < 1 | B ^ 1) { H = B } else {
                                D = 0;
                                v = B;
                                while (1) {
                                    G = (Qc[c[(c[t >> 2] | 0) + 8 >> 2] & 63](f, c[h + 916 + (D << 2) >> 2] | 0) | 0) + 92 | 0;
                                    F = v & (c[G >> 2] | 0) <= (w | 0);
                                    G = D + 1 | 0;
                                    if ((G | 0) >= (c[E >> 2] | 0) | F ^ 1) { H = F; break } else {
                                        D = G;
                                        v = F
                                    }
                                }
                            }
                            if (H) {
                                y = p;
                                z = x + (l * 12 | 0) + 2 + p | 0;
                                A = x + (l * 12 | 0) + 4 + (p << 2) | 0;
                                break
                            } else {
                                v = a[h + 372 | 0] | 0;
                                y = v;
                                z = x + (l * 12 | 0) + 2 + v | 0;
                                A = x + (l * 12 | 0) + 4 + (v << 2) | 0;
                                break
                            }
                        }
                    } while (0);
                    l = A;
                    x = e[l >> 1] | e[l + 2 >> 1] << 16;
                    l = a[z] | 0;
                    v = c[u + 10348 >> 2] | 0;
                    D = m >> v;
                    E = n >> v;
                    if (!((D | 0) > -1)) { ec(1232, 544, 118, 17296) }
                    v = c[u + 10352 >> 2] | 0;
                    if ((D | 0) >= (v | 0)) { ec(1232, 544, 118, 17296) }
                    if (!((E | 0) > -1)) { ec(17016, 544, 119, 17296) }
                    if ((E | 0) >= (c[u + 10356 >> 2] | 0)) { ec(17016, 544, 119, 17296) }
                    w = (ga(v, E) | 0) + D | 0;
                    D = c[(c[u + 48 >> 2] | 0) + (e[(c[u + 10340 >> 2] | 0) + (w * 24 | 0) + 2 >> 1] << 2) >> 2] | 0;
                    w = h + 1300 + (p << 4) + o | 0;
                    if ((a[w] | 0) != (a[D + 1300 + (y << 4) + l | 0] | 0)) {
                        a[r] = 0;
                        b[q >> 1] = 0;
                        b[q + 2 >> 1] = 0;
                        i = k;
                        return
                    }
                    a[r] = 1;
                    E = (c[u + 92 >> 2] | 0) - (c[D + 1044 + (y << 6) + (l << 2) >> 2] | 0) | 0;
                    l = (c[g + 92 >> 2] | 0) - (c[h + 1044 + (p << 6) + (o << 2) >> 2] | 0) | 0;
                    if ((a[w] | 0) != 0 | (E | 0) == (l | 0)) {
                        w = q;
                        C = x;
                        b[w >> 1] = C;
                        b[w + 2 >> 1] = C >> 16;
                        i = k;
                        return
                    }
                    c[j >> 2] = x;
                    if (Ai(q, s, E, l) | 0) { i = k; return }
                    Ue(f + 4 | 0, 1008, 0);
                    a[g + 10516 | 0] = 3;
                    i = k;
                    return
                }
            } while (0);
            Ue(f + 4 | 0, 1026, 0);
            a[r] = 0;
            i = k;
            return
        }

        function Ci(d, e, f, g, h, i, j, k, l, m, n) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            var o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            if ((a[f + 324 | 0] | 0) == 0) {
                b[m >> 1] = 0;
                b[m + 2 >> 1] = 0;
                a[n] = 0;
                return
            }
            o = c[e + 5804 >> 2] | 0;
            do {
                if ((c[f + 20 >> 2] | 0) == 0) {
                    if ((a[f + 372 | 0] | 0) != 0) { p = 6; break }
                    q = f + 980 + (c[f + 376 >> 2] << 2) | 0
                } else { p = 6 }
            } while (0);
            if ((p | 0) == 6) { q = f + 916 + (c[f + 376 >> 2] << 2) | 0 }
            r = c[q >> 2] | 0;
            if (!(Qc[c[(c[d >> 2] | 0) + 12 >> 2] & 63](d, r) | 0)) {
                b[m >> 1] = 0;
                b[m + 2 >> 1] = 0;
                a[n] = 0;
                Ue(d + 4 | 0, 1012, 0);
                return
            }
            q = j + h | 0;
            s = i + g | 0;
            do {
                if ((h >> o | 0) == (q >> o | 0)) {
                    if ((s | 0) >= (c[e + 1248 >> 2] | 0)) { p = 12; break }
                    if ((q | 0) >= (c[e + 1252 >> 2] | 0)) { p = 12; break }
                    Bi(d, e, f, 0, 0, r, s & -16, q & -16, k, l, m, n);
                    if ((a[n] | 0) == 0) { break }
                    return
                } else { p = 12 }
            } while (0);
            if ((p | 0) == 12) {
                b[m >> 1] = 0;
                b[m + 2 >> 1] = 0;
                a[n] = 0
            }
            Bi(d, e, f, 0, 0, r, (i >> 1) + g & -16, (j >> 1) + h & -16, k, l, m, n);
            return
        }

        function Di(d, f, g, h, i) {
            d = d | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            j = c[h >> 2] | 0;
            if (!((j | 0) > 1 & (j | 0) < (i | 0))) { return }
            k = ga(j - 1 | 0, j) | 0;
            l = d;
            m = 0;
            n = 1;
            a: while (1) {
                o = m;
                while (1) {
                    if (!n) { p = 20; break a }
                    q = c[30904 + (o << 2) >> 2] | 0;
                    r = c[30952 + (o << 2) >> 2] | 0;
                    if (!((q | 0) < (j | 0) & (r | 0) < (j | 0))) { p = 6; break a }
                    s = g + (q * 12 | 0) | 0;
                    if ((a[s] | 0) == 0) { t = 0 } else { t = Qc[c[(c[l >> 2] | 0) + 8 >> 2] & 63](d, c[f + 916 + (a[g + (q * 12 | 0) + 2 | 0] << 2) >> 2] | 0) | 0 }
                    u = g + (r * 12 | 0) + 1 | 0;
                    if ((a[u] | 0) == 0) { v = 0 } else { v = Qc[c[(c[l >> 2] | 0) + 8 >> 2] & 63](d, c[f + 980 + (a[g + (r * 12 | 0) + 3 | 0] << 2) >> 2] | 0) | 0 }
                    w = a[s] | 0;
                    if (w << 24 >> 24 != 0 & (t | 0) == 0) { p = 20; break a }
                    s = a[u] | 0;
                    if (s << 24 >> 24 != 0 & (v | 0) == 0) { p = 20; break a }
                    b: do {
                        if (!(w << 24 >> 24 == 0 | s << 24 >> 24 == 0)) {
                            do { if ((c[t + 92 >> 2] | 0) == (c[v + 92 >> 2] | 0)) { if ((b[g + (q * 12 | 0) + 4 >> 1] | 0) != (b[g + (r * 12 | 0) + 8 >> 1] | 0)) { break } if ((b[g + (q * 12 | 0) + 6 >> 1] | 0) == (b[g + (r * 12 | 0) + 10 >> 1] | 0)) { break b } } } while (0);
                            u = c[h >> 2] | 0;
                            a[g + (u * 12 | 0) + 2 | 0] = a[g + (q * 12 | 0) + 2 | 0] | 0;
                            a[g + (u * 12 | 0) + 3 | 0] = a[g + (r * 12 | 0) + 3 | 0] | 0;
                            a[g + (u * 12 | 0) | 0] = w;
                            a[g + (u * 12 | 0) + 1 | 0] = s;
                            x = g + (q * 12 | 0) + 4 | 0;
                            y = g + (u * 12 | 0) + 4 | 0;
                            C = e[x >> 1] | e[x + 2 >> 1] << 16;
                            b[y >> 1] = C;
                            b[y + 2 >> 1] = C >> 16;
                            y = g + (r * 12 | 0) + 8 | 0;
                            x = g + (u * 12 | 0) + 8 | 0;
                            C = e[y >> 1] | e[y + 2 >> 1] << 16;
                            b[x >> 1] = C;
                            b[x + 2 >> 1] = C >> 16;
                            c[h >> 2] = (c[h >> 2] | 0) + 1
                        }
                    } while (0);
                    r = o + 1 | 0;
                    if ((r | 0) == (k | 0)) {
                        m = k;
                        n = 0;
                        continue a
                    }
                    if ((c[h >> 2] | 0) == (i | 0)) {
                        m = r;
                        n = 0;
                        continue a
                    } else { o = r }
                }
            }
            if ((p | 0) == 6) { ec(10064, 15536, 1360, 18064) } else if ((p | 0) == 20) { return }
        }

        function Ei(d, e, f, g, h, j, k, l, m, n, o, p, q) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            var r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0;
            r = i;
            i = i + 24 | 0;
            s = r | 0;
            t = r + 8 | 0;
            u = r + 16 | 0;
            v = (c[f + 10060 >> 2] | 0) > 2 & (l | 0) == 8;
            w = v ? l : n;
            n = v ? l : m;
            m = v ? h : k;
            k = v ? g : j;
            j = p + 1 | 0;
            p = zi(f, g, h, l, k, m, 0, n, w, v ? 0 : o, q, j) | 0;
            c[s >> 2] = p;
            do {
                if ((p | 0) < (j | 0)) {
                    o = u | 0;
                    Ci(d, f, e, k, m, n, w, 0, 0, t | 0, o);
                    v = a[o] | 0;
                    l = u + 1 | 0;
                    a[l] = 0;
                    h = e + 20 | 0;
                    if ((c[h >> 2] | 0) == 0) {
                        Ci(d, f, e, k, m, n, w, 0, 1, t + 4 | 0, l);
                        g = a[l] | 0;
                        x = g | v;
                        y = g
                    } else {
                        x = v;
                        y = 0
                    }
                    if (x << 24 >> 24 == 0) { z = h; break }
                    c[s >> 2] = p + 1;
                    v = q + (p * 12 | 0) + 4 | 0;
                    C = c[t >> 2] | 0;
                    b[v >> 1] = C;
                    b[v + 2 >> 1] = C >> 16;
                    v = q + (p * 12 | 0) + 8 | 0;
                    C = c[t + 4 >> 2] | 0;
                    b[v >> 1] = C;
                    b[v + 2 >> 1] = C >> 16;
                    a[q + (p * 12 | 0) | 0] = a[o] | 0;
                    a[q + (p * 12 | 0) + 1 | 0] = y;
                    a[q + (p * 12 | 0) + 2 | 0] = 0;
                    a[q + (p * 12 | 0) + 3 | 0] = 0;
                    z = h
                } else { z = e + 20 | 0 }
            } while (0);
            p = c[z >> 2] | 0;
            if ((p | 0) == 0) {
                Di(d, e, q, s, j);
                A = c[z >> 2] | 0
            } else { A = p }
            p = c[e + 328 >> 2] | 0;
            if ((A | 0) == 1) { B = p } else {
                d = c[e + 332 >> 2] | 0;
                B = (p | 0) < (d | 0) ? p : d
            }
            d = c[s >> 2] | 0;
            if ((d | 0) < (j | 0)) {
                D = 0;
                E = A;
                F = d
            } else { i = r; return }
            while (1) {
                d = q + (F * 12 | 0) | 0;
                A = (D | 0) < (B | 0) ? D & 255 : 0;
                a[q + (F * 12 | 0) + 2 | 0] = A;
                p = q + (F * 12 | 0) + 3 | 0;
                if ((E | 0) == 1) {
                    a[p] = -1;
                    a[d | 0] = 1;
                    a[q + (F * 12 | 0) + 1 | 0] = 0
                } else {
                    a[p] = A;
                    a[d | 0] = 1;
                    a[q + (F * 12 | 0) + 1 | 0] = 1
                }
                d = q + (F * 12 | 0) + 4 | 0;
                A = d | 0;
                C = 0;
                b[A >> 1] = C;
                b[A + 2 >> 1] = C >> 16;
                A = d + 4 | 0;
                C = 0;
                b[A >> 1] = C;
                b[A + 2 >> 1] = C >> 16;
                G = F + 1 | 0;
                if ((G | 0) >= (j | 0)) { break }
                D = D + 1 | 0;
                E = c[z >> 2] | 0;
                F = G
            }
            c[s >> 2] = G;
            i = r;
            return
        }

        function Fi(f, g, h, j, k, l, m, n, o, p, q, r, s, t, u) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            r = r | 0;
            s = s | 0;
            t = t | 0;
            u = u | 0;
            var v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0;
            v = i;
            i = i + 32 | 0;
            w = v | 0;
            x = v + 8 | 0;
            y = v + 16 | 0;
            z = v + 24 | 0;
            A = z;
            B = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            D = i;
            i = i + 12 | 0;
            i = i + 7 & -8;
            E = i;
            i = i + 3 | 0;
            i = i + 7 & -8;
            F = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            G = F;
            H = t + 1 | 0;
            a[H] = 0;
            I = m - 1 | 0;
            c[w >> 2] = I;
            J = p + n | 0;
            c[x >> 2] = J;
            c[w + 4 >> 2] = I;
            K = J - 1 | 0;
            c[x + 4 >> 2] = K;
            a[t] = 0;
            b[u >> 1] = 0;
            b[u + 2 >> 1] = 0;
            L = ci(g, j, k, l, m, n, o, p, s, I, J) | 0;
            J = L & 1;
            a[y | 0] = J;
            M = ci(g, j, k, l, m, n, o, p, s, I, K) | 0;
            a[y + 1 | 0] = M & 1;
            K = L | M;
            M = f;
            L = h + 916 + (q << 6) + (r << 2) | 0;
            N = Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[L >> 2] | 0) | 0;
            if ((N | 0) == 0) { i = v; return }
            O = c[N + 92 >> 2] | 0;
            N = g + 10368 | 0;
            P = g + 10372 | 0;
            Q = g + 10376 | 0;
            R = g + 10360 | 0;
            S = 1 - q | 0;
            T = g + 10388 | 0;
            U = g + 10392 | 0;
            V = g + 10396 | 0;
            W = g + 10380 | 0;
            X = u;
            Y = 0;
            Z = -1;
            _ = J;
            a: while (1) {
                b: do {
                    if (_ << 24 >> 24 == 0) { $ = Z } else {
                        if ((a[t] | 0) != 0) { $ = Z; break }
                        J = c[w + (Y << 2) >> 2] | 0;
                        aa = c[x + (Y << 2) >> 2] | 0;
                        ba = c[N >> 2] | 0;
                        ca = J >> ba;
                        da = aa >> ba;
                        if (!((ca | 0) > -1)) { ea = 8; break a }
                        ba = c[P >> 2] | 0;
                        if ((ca | 0) >= (ba | 0)) { ea = 8; break a }
                        if (!((da | 0) > -1)) { ea = 11; break a }
                        if ((da | 0) >= (c[Q >> 2] | 0)) { ea = 11; break a }
                        fa = (ga(ba, da) | 0) + ca | 0;
                        ca = (c[R >> 2] | 0) + (fa * 3 | 0) | 0;
                        if (((d[ca] | d[ca + 1 | 0] << 8) << 16 >> 16 & 768) == 0) { $ = Z; break }
                        ca = c[T >> 2] | 0;
                        fa = J >> ca;
                        J = aa >> ca;
                        if (!((fa | 0) > -1)) { ea = 15; break a }
                        ca = c[U >> 2] | 0;
                        if ((fa | 0) >= (ca | 0)) { ea = 15; break a }
                        if (!((J | 0) > -1)) { ea = 18; break a }
                        if ((J | 0) >= (c[V >> 2] | 0)) { ea = 18; break a }
                        aa = (ga(ca, J) | 0) + fa | 0;
                        fa = c[W >> 2] | 0;
                        J = fa + (aa * 12 | 0) + q | 0;
                        if ((a[J] | 0) == 0) { ha = 0 } else { ha = Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[h + 916 + (q << 6) + (a[fa + (aa * 12 | 0) + 2 + q | 0] << 2) >> 2] | 0) | 0 }
                        ca = fa + (aa * 12 | 0) + S | 0;
                        if ((a[ca] | 0) == 0) { ia = 0 } else { ia = Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[h + 916 + (S << 6) + (a[fa + (aa * 12 | 0) + 2 + S | 0] << 2) >> 2] | 0) | 0 }
                        do {
                            if (!((a[J] | 0) == 0 | (ha | 0) == 0)) {
                                if ((c[ha + 92 >> 2] | 0) != (O | 0)) { break }
                                a[t] = 1;
                                da = fa + (aa * 12 | 0) + 4 + (q << 2) | 0;
                                C = e[da >> 1] | e[da + 2 >> 1] << 16;
                                b[X >> 1] = C;
                                b[X + 2 >> 1] = C >> 16;
                                $ = a[fa + (aa * 12 | 0) + 2 + q | 0] | 0;
                                break b
                            }
                        } while (0);
                        if ((a[ca] | 0) == 0 | (ia | 0) == 0) { $ = Z; break }
                        if ((c[ia + 92 >> 2] | 0) != (O | 0)) { $ = Z; break }
                        a[t] = 1;
                        J = fa + (aa * 12 | 0) + 4 + (S << 2) | 0;
                        C = e[J >> 1] | e[J + 2 >> 1] << 16;
                        b[X >> 1] = C;
                        b[X + 2 >> 1] = C >> 16;
                        $ = a[fa + (aa * 12 | 0) + 2 + S | 0] | 0
                    }
                } while (0);J = Y + 1 | 0;
                if ((J | 0) >= 2) { ea = 3; break }
                Y = J;Z = $;_ = a[y + J | 0] | 0
            }
            if ((ea | 0) == 3) {
                _ = h + 1300 + (q << 4) + r | 0;
                r = g + 92 | 0;
                Z = f + 4 | 0;
                Y = g + 10516 | 0;
                ia = 0;
                ha = $;
                c: while (1) {
                    if ((a[t] | 0) != 0) { ea = 62; break }
                    d: do {
                        if ((a[y + ia | 0] | 0) == 0) {
                            ja = ha;
                            ka = -1
                        } else {
                            $ = c[w + (ia << 2) >> 2] | 0;
                            J = c[x + (ia << 2) >> 2] | 0;
                            da = c[N >> 2] | 0;
                            ba = $ >> da;
                            la = J >> da;
                            if (!((ba | 0) > -1)) { ea = 35; break c }
                            da = c[P >> 2] | 0;
                            if ((ba | 0) >= (da | 0)) { ea = 35; break c }
                            if (!((la | 0) > -1)) { ea = 38; break c }
                            if ((la | 0) >= (c[Q >> 2] | 0)) { ea = 38; break c }
                            ma = (ga(da, la) | 0) + ba | 0;
                            ba = (c[R >> 2] | 0) + (ma * 3 | 0) | 0;
                            if (((d[ba] | d[ba + 1 | 0] << 8) << 16 >> 16 & 768) == 0) {
                                ja = ha;
                                ka = -1;
                                break
                            }
                            ba = c[T >> 2] | 0;
                            ma = $ >> ba;
                            $ = J >> ba;
                            if (!((ma | 0) > -1)) { ea = 42; break c }
                            ba = c[U >> 2] | 0;
                            if ((ma | 0) >= (ba | 0)) { ea = 42; break c }
                            if (!(($ | 0) > -1)) { ea = 45; break c }
                            if (($ | 0) >= (c[V >> 2] | 0)) { ea = 45; break c }
                            J = (ga(ba, $) | 0) + ma | 0;
                            ma = c[W >> 2] | 0;
                            do {
                                if ((a[ma + (J * 12 | 0) + q | 0] | 0) == 1) {
                                    $ = ma + (J * 12 | 0) + 2 + q | 0;
                                    if ((a[_] | 0) != (a[(a[$] | 0) + (h + 1300 + (q << 4)) | 0] | 0)) { break }
                                    a[t] = 1;
                                    ba = ma + (J * 12 | 0) + 4 + (q << 2) | 0;
                                    C = e[ba >> 1] | e[ba + 2 >> 1] << 16;
                                    b[X >> 1] = C;
                                    b[X + 2 >> 1] = C >> 16;
                                    ja = a[$] | 0;
                                    ka = q;
                                    break d
                                }
                            } while (0);
                            if ((a[ma + (J * 12 | 0) + S | 0] | 0) != 1) {
                                ja = ha;
                                ka = -1;
                                break
                            }
                            aa = ma + (J * 12 | 0) + 2 + S | 0;
                            if ((a[_] | 0) != (a[(a[aa] | 0) + (h + 1300 + (S << 4)) | 0] | 0)) {
                                ja = ha;
                                ka = -1;
                                break
                            }
                            a[t] = 1;
                            fa = ma + (J * 12 | 0) + 4 + (S << 2) | 0;
                            C = e[fa >> 1] | e[fa + 2 >> 1] << 16;
                            b[X >> 1] = C;
                            b[X + 2 >> 1] = C >> 16;
                            ja = a[aa] | 0;
                            ka = S
                        }
                    } while (0);
                    do {
                        if ((a[t] | 0) == 1) {
                            if ((ja | 0) < 0) { ea = 54; break c }
                            if (!((ka | 0) > -1)) { ea = 56; break c }
                            aa = Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[h + 916 + (ka << 6) + (ja << 2) >> 2] | 0) | 0;
                            Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[L >> 2] | 0) | 0;
                            if ((a[h + 1300 + (ka << 4) + ja | 0] | 0) != 0) { break }
                            if ((a[_] | 0) != 0) { break }
                            fa = c[r >> 2] | 0;
                            ca = fa - (c[aa + 92 >> 2] | 0) | 0;
                            c[z >> 2] = e[X >> 1] | e[X + 2 >> 1] << 16;
                            if (Ai(u, A, ca, fa - O | 0) | 0) { break }
                            Ue(Z, 1008, 0);
                            a[Y] = 3
                        }
                    } while (0);
                    fa = ia + 1 | 0;
                    if ((fa | 0) < 2) {
                        ia = fa;
                        ha = ja
                    } else { ea = 62; break }
                }
                if ((ea | 0) == 35) { ec(1232, 544, 118, 17296) } else if ((ea | 0) == 38) { ec(17016, 544, 119, 17296) } else if ((ea | 0) == 42) { ec(1232, 544, 118, 17296) } else if ((ea | 0) == 45) { ec(17016, 544, 119, 17296) } else if ((ea | 0) == 54) {
                    a[H] = 0;
                    a[t] = 0;
                    i = v;
                    return
                } else if ((ea | 0) == 56) { ec(5136, 15536, 1698, 18112) } else if ((ea | 0) == 62) {
                    ja = o + m | 0;
                    c[B >> 2] = ja;
                    ha = n - 1 | 0;
                    c[D >> 2] = ha;
                    c[B + 4 >> 2] = ja - 1;
                    c[D + 4 >> 2] = ha;
                    c[B + 8 >> 2] = I;
                    c[D + 8 >> 2] = ha;
                    a[H] = 0;
                    I = u + 4 | 0;
                    b[I >> 1] = 0;
                    b[u + 6 >> 1] = 0;
                    u = I;
                    ia = 0;
                    A = -1;
                    z = ja;
                    ja = ha;
                    e: while (1) {
                        ha = ci(g, j, k, l, m, n, o, p, s, z, ja) | 0;
                        a[E + ia | 0] = ha & 1;
                        f: do {
                            if (ha) {
                                if ((a[H] | 0) != 0) { na = A; break }
                                ka = c[T >> 2] | 0;
                                R = z >> ka;
                                Q = ja >> ka;
                                if (!((R | 0) > -1)) { ea = 67; break e }
                                ka = c[U >> 2] | 0;
                                if ((R | 0) >= (ka | 0)) { ea = 67; break e }
                                if (!((Q | 0) > -1)) { ea = 70; break e }
                                if ((Q | 0) >= (c[V >> 2] | 0)) { ea = 70; break e }
                                P = (ga(ka, Q) | 0) + R | 0;
                                R = c[W >> 2] | 0;
                                Q = R + (P * 12 | 0) + q | 0;
                                if ((a[Q] | 0) == 0) { oa = 0 } else { oa = Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[h + 916 + (q << 6) + (a[R + (P * 12 | 0) + 2 + q | 0] << 2) >> 2] | 0) | 0 }
                                ka = R + (P * 12 | 0) + S | 0;
                                if ((a[ka] | 0) == 0) { pa = 0 } else { pa = Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[h + 916 + (S << 6) + (a[R + (P * 12 | 0) + 2 + S | 0] << 2) >> 2] | 0) | 0 }
                                do {
                                    if (!((a[Q] | 0) == 0 | (oa | 0) == 0)) {
                                        if ((c[oa + 92 >> 2] | 0) != (O | 0)) { break }
                                        a[H] = 1;
                                        N = R + (P * 12 | 0) + 4 + (q << 2) | 0;
                                        C = e[N >> 1] | e[N + 2 >> 1] << 16;
                                        b[u >> 1] = C;
                                        b[u + 2 >> 1] = C >> 16;
                                        na = a[R + (P * 12 | 0) + 2 + q | 0] | 0;
                                        break f
                                    }
                                } while (0);
                                if ((a[ka] | 0) == 0 | (pa | 0) == 0) { na = A; break }
                                if ((c[pa + 92 >> 2] | 0) != (O | 0)) { na = A; break }
                                a[H] = 1;
                                Q = R + (P * 12 | 0) + 4 + (S << 2) | 0;
                                C = e[Q >> 1] | e[Q + 2 >> 1] << 16;
                                b[u >> 1] = C;
                                b[u + 2 >> 1] = C >> 16;
                                na = a[R + (P * 12 | 0) + 2 + S | 0] | 0
                            } else { na = A }
                        } while (0);
                        ha = ia + 1 | 0;
                        if ((ha | 0) >= 3) { ea = 83; break }
                        ia = ha;
                        A = na;
                        z = c[B + (ha << 2) >> 2] | 0;
                        ja = c[D + (ha << 2) >> 2] | 0
                    }
                    if ((ea | 0) == 67) { ec(1232, 544, 118, 17296) } else if ((ea | 0) == 70) { ec(17016, 544, 119, 17296) } else if ((ea | 0) == 83) {
                        if (K) { i = v; return }
                        if ((a[H] | 0) != 0) {
                            a[t] = 1;
                            C = e[u >> 1] | e[u + 2 >> 1] << 16;
                            b[X >> 1] = C;
                            b[X + 2 >> 1] = C >> 16
                        }
                        a[H] = 0;
                        X = g + 10332 | 0;
                        g = 0;
                        K = na;
                        na = 1;
                        g: while (1) {
                            if (!na) { ea = 115; break }
                            h: do {
                                if ((a[E + g | 0] | 0) == 0) {
                                    qa = K;
                                    ra = -1
                                } else {
                                    ja = c[T >> 2] | 0;
                                    z = c[B + (g << 2) >> 2] >> ja;
                                    A = c[D + (g << 2) >> 2] >> ja;
                                    if (!((z | 0) > -1)) { ea = 91; break g }
                                    ja = c[U >> 2] | 0;
                                    if ((z | 0) >= (ja | 0)) { ea = 91; break g }
                                    if (!((A | 0) > -1)) { ea = 94; break g }
                                    if ((A | 0) >= (c[V >> 2] | 0)) { ea = 94; break g }
                                    ia = (ga(ja, A) | 0) + z | 0;
                                    z = c[W >> 2] | 0;
                                    do {
                                        if ((a[z + (ia * 12 | 0) + q | 0] | 0) == 1) {
                                            A = z + (ia * 12 | 0) + 2 + q | 0;
                                            if ((a[_] | 0) != (a[(a[A] | 0) + (h + 1300 + (q << 4)) | 0] | 0)) { break }
                                            a[H] = 1;
                                            ja = z + (ia * 12 | 0) + 4 + (q << 2) | 0;
                                            C = e[ja >> 1] | e[ja + 2 >> 1] << 16;
                                            b[u >> 1] = C;
                                            b[u + 2 >> 1] = C >> 16;
                                            qa = a[A] | 0;
                                            ra = q;
                                            break h
                                        }
                                    } while (0);
                                    if ((a[z + (ia * 12 | 0) + S | 0] | 0) != 1) {
                                        qa = K;
                                        ra = -1;
                                        break
                                    }
                                    P = z + (ia * 12 | 0) + 2 + S | 0;
                                    if ((a[_] | 0) != (a[(a[P] | 0) + (h + 1300 + (S << 4)) | 0] | 0)) {
                                        qa = K;
                                        ra = -1;
                                        break
                                    }
                                    a[H] = 1;
                                    R = z + (ia * 12 | 0) + 4 + (S << 2) | 0;
                                    C = e[R >> 1] | e[R + 2 >> 1] << 16;
                                    b[u >> 1] = C;
                                    b[u + 2 >> 1] = C >> 16;
                                    qa = a[P] | 0;
                                    ra = S
                                }
                            } while (0);
                            do {
                                if ((a[H] | 0) == 1) {
                                    if ((qa | 0) < 0) { ea = 103; break g }
                                    if (!((ra | 0) > -1)) { ea = 105; break g }
                                    if (!((qa | 0) > -1)) { ea = 107; break g }
                                    P = Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[h + 916 + (ra << 6) + (qa << 2) >> 2] | 0) | 0;
                                    R = Qc[c[(c[M >> 2] | 0) + 8 >> 2] & 63](f, c[L >> 2] | 0) | 0;
                                    if ((P | 0) == 0 | (R | 0) == 0) {
                                        Ue((c[X >> 2] | 0) + 4 | 0, 1012, 0);
                                        a[Y] = 3;
                                        break
                                    }
                                    ka = c[P + 92 >> 2] | 0;
                                    if (!((ka | 0) != (c[R + 92 >> 2] | 0) & (a[h + 1300 + (ra << 4) + qa | 0] | 0) == 0 & (a[_] | 0) == 0)) { break }
                                    R = c[r >> 2] | 0;
                                    c[F >> 2] = e[u >> 1] | e[u + 2 >> 1] << 16;
                                    if (Ai(I, G, R - ka | 0, R - O | 0) | 0) { break }
                                    Ue(Z, 1008, 0);
                                    a[Y] = 3
                                }
                            } while (0);
                            R = g + 1 | 0;
                            if ((R | 0) >= 3) { ea = 115; break }
                            g = R;
                            K = qa;
                            na = (a[H] | 0) == 0
                        }
                        if ((ea | 0) == 91) { ec(1232, 544, 118, 17296) } else if ((ea | 0) == 94) { ec(17016, 544, 119, 17296) } else if ((ea | 0) == 103) {
                            a[H] = 0;
                            a[t] = 0;
                            i = v;
                            return
                        } else if ((ea | 0) == 105) { ec(5136, 15536, 1839, 18112) } else if ((ea | 0) == 107) { ec(3656, 15536, 1840, 18112) } else if ((ea | 0) == 115) { i = v; return }
                    }
                }
            } else if ((ea | 0) == 8) { ec(1232, 544, 118, 17296) } else if ((ea | 0) == 11) { ec(17016, 544, 119, 17296) } else if ((ea | 0) == 15) { ec(1232, 544, 118, 17296) } else if ((ea | 0) == 18) { ec(17016, 544, 119, 17296) }
        }

        function Gi(d, e, f, g, h, j, k, l, m, n, o, p, q, r) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            r = r | 0;
            var s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0;
            s = i;
            i = i + 32 | 0;
            t = s | 0;
            u = s + 8 | 0;
            v = s + 16 | 0;
            w = s + 24 | 0;
            x = w;
            y = t | 0;
            Fi(d, f, e, g, h, j, k, l, m, n, o, p, q, y, u | 0);
            q = (a[y] | 0) == 0;
            do {
                if (q) { z = 6 } else {
                    if ((a[t + 1 | 0] | 0) == 0) { z = 6; break }
                    if ((b[u >> 1] | 0) == (b[u + 4 >> 1] | 0)) { if ((b[u + 2 >> 1] | 0) == (b[u + 6 >> 1] | 0)) { z = 6; break } }
                    a[v] = 0
                }
            } while (0);
            if ((z | 0) == 6) { Ci(d, f, e, k, l, m, n, p, o, x, v) }
            if (q) { A = 0 } else {
                x = r;
                C = c[u >> 2] | 0;
                b[x >> 1] = C;
                b[x + 2 >> 1] = C >> 16;
                A = 1
            }
            a: do {
                if ((a[t + 1 | 0] | 0) == 0) { B = A } else {
                    do { if (!q) { if ((b[u >> 1] | 0) != (b[u + 4 >> 1] | 0)) { break } if ((b[u + 2 >> 1] | 0) == (b[u + 6 >> 1] | 0)) { B = A; break a } } } while (0);
                    x = r + (A << 2) | 0;
                    C = c[u + 4 >> 2] | 0;
                    b[x >> 1] = C;
                    b[x + 2 >> 1] = C >> 16;
                    B = A + 1 | 0
                }
            } while (0);
            if ((a[v] | 0) == 0) { D = B } else {
                v = r + (B << 2) | 0;
                C = c[w >> 2] | 0;
                b[v >> 1] = C;
                b[v + 2 >> 1] = C >> 16;
                D = B + 1 | 0
            }
            if ((D | 0) < 2) {
                B = D;
                do {
                    b[r + (B << 2) >> 1] = 0;
                    b[r + (B << 2) + 2 >> 1] = 0;
                    B = B + 1 | 0;
                } while ((B | 0) < 2);
                i = s;
                return
            }
            if ((D | 0) == 2) { i = s; return } else { ec(2360, 15536, 1943, 18152) }
        }

        function Hi(f, g, h, j, k, l, m, n, o, p, q, r, s) {
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            o = o | 0;
            p = p | 0;
            q = q | 0;
            r = r | 0;
            s = s | 0;
            var t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0;
            t = i;
            i = i + 80 | 0;
            u = t | 0;
            v = t + 8 | 0;
            w = t + 72 | 0;
            x = m + k | 0;
            m = n + l | 0;
            n = c[h + 10368 >> 2] | 0;
            y = k >> n;
            z = l >> n;
            if (!((y | 0) > -1)) { ec(1232, 544, 118, 17296) }
            n = c[h + 10372 >> 2] | 0;
            if ((y | 0) >= (n | 0)) { ec(1232, 544, 118, 17296) }
            if (!((z | 0) > -1)) { ec(17016, 544, 119, 17296) }
            if ((z | 0) >= (c[h + 10376 >> 2] | 0)) { ec(17016, 544, 119, 17296) }
            A = (ga(n, z) | 0) + y | 0;
            y = (c[h + 10360 >> 2] | 0) + (A * 3 | 0) | 0;
            A = ((d[y] | d[y + 1 | 0] << 8) << 16 >> 16 & 65535) >>> 8 & 255 & 3;
            if ((A | 0) == 2) {
                B = a[j + 10 | 0] | 0;
                D = 12
            } else if ((A | 0) == 1) {
                A = j + 10 | 0;
                y = a[A] | 0;
                if ((y & 16) == 0) {
                    E = A;
                    D = 11
                } else {
                    B = y;
                    D = 12
                }
            } else {
                E = j + 10 | 0;
                D = 11
            }
            if ((D | 0) == 11) {
                y = u | 0;
                A = 0;
                do {
                    z = a[E] & 3;
                    if ((z << 24 >> 24 | 0) == 1) { if ((A | 0) == 0) { D = 20 } else { D = 19 } } else if ((z << 24 >> 24 | 0) == 3) { D = 20 } else if ((z << 24 >> 24 | 0) == 2) { if ((A | 0) == 1) { D = 20 } else { D = 19 } } else { D = 19 }
                    if ((D | 0) == 19) {
                        D = 0;
                        a[s + 2 + A | 0] = -1;
                        a[s + A | 0] = 0
                    } else if ((D | 0) == 20) {
                        D = 0;
                        z = a[j + A | 0] | 0;
                        a[s + 2 + A | 0] = z;
                        a[s + A | 0] = 1;
                        n = b[j + 2 + (A << 2) + 2 >> 1] | 0;
                        F = e[j + 2 + (A << 2) >> 1] | 0;
                        Gi(f, g, h, k, l, o, x, m, p, q, A, z << 24 >> 24, r, y);
                        z = u + (((d[E] | 0) >>> (((A | 0) != 0 ? 3 : 2) >>> 0) & 1) << 2) | 0;
                        G = e[z >> 1] | e[z + 2 >> 1] << 16;
                        z = w + (A << 2) | 0;
                        C = G;
                        b[z >> 1] = C;
                        b[z + 2 >> 1] = C >> 16;
                        z = (b[w + (A << 2) + 2 >> 1] | 0) + n & 65535;
                        b[s + 4 + (A << 2) >> 1] = G + F;
                        b[s + 4 + (A << 2) + 2 >> 1] = z
                    }
                    A = A + 1 | 0;
                } while ((A | 0) < 2);
                i = t;
                return
            } else if ((D | 0) == 12) {
                D = (B & 255) >>> 5 & 255;
                Ei(f, g, h, k, l, x, m, o, p, q, r, D, v | 0);
                r = s | 0;
                o = v + (D * 12 | 0) | 0;
                b[r >> 1] = b[o >> 1] | 0;
                b[r + 2 >> 1] = b[o + 2 >> 1] | 0;
                b[r + 4 >> 1] = b[o + 4 >> 1] | 0;
                b[r + 6 >> 1] = b[o + 6 >> 1] | 0;
                b[r + 8 >> 1] = b[o + 8 >> 1] | 0;
                b[r + 10 >> 1] = b[o + 10 >> 1] | 0;
                if ((a[r] | 0) == 0) { i = t; return }
                r = s + 1 | 0;
                if ((a[r] | 0) == 0) { i = t; return }
                if ((q + p | 0) != 12) { i = t; return }
                a[s + 3 | 0] = -1;
                a[r] = 0;
                i = t;
                return
            }
        }

        function Ii(a, b, c, d, e, f, g, h, j, k, l, m) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0;
            n = i;
            i = i + 16 | 0;
            o = n | 0;
            Hi(a, b, c, d, e, f, g, h, j, k, l, m, o);
            ui(a, b, c, e, f, g, h, j, k, l, o);
            ai(c, g + e | 0, h + f | 0, k, l, o);
            i = n;
            return
        }

        function Ji(b, c) {
            b = b | 0;
            c = c | 0;
            var d = 0;
            od(c, 1);
            d = (nd(c, 6) | 0) & 255;
            a[b | 0] = d;
            d = (nd(c, 6) | 0) & 255;
            a[b + 1 | 0] = d;
            d = (nd(c, 3) | 0) + 255 & 255;
            a[b + 2 | 0] = d;
            return
        }

        function Ki(a) { a = a | 0; return (a - 19 & 255) >>> 0 < 2 >>> 0 | 0 }

        function Li(a) { a = a | 0; return (a - 16 & 255) >>> 0 < 3 >>> 0 | 0 }

        function Mi(a) { a = a | 0; return (a & -2) << 24 >> 24 == 8 | 0 }

        function Ni(a) { a = a | 0; return (a - 16 & 255) >>> 0 < 8 >>> 0 | 0 }

        function Oi(a) { a = a | 0; return (a & -2) << 24 >> 24 == 6 | 0 }

        function Pi(a) {
            a = a | 0;
            var b = 0;
            switch (a & 255 | 0) {
                case 0:
                case 2:
                case 4:
                case 6:
                case 8:
                case 10:
                case 12:
                case 14:
                    { b = 1; break };
                default:
                    { b = 0 }
            }
            return b | 0
        }

        function Qi(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0;
            e = c[a + 32 >> 2] | 0;
            f = (c[a + 36 >> 2] | 0) - e >> 2;
            while (1) {
                a = f - 1 | 0;
                if (!((a | 0) > -1)) {
                    g = 0;
                    h = 4;
                    break
                }
                if (((c[e + (a << 2) >> 2] | 0) - d | 0) > (b | 0)) { f = a } else {
                    g = f;
                    h = 4;
                    break
                }
            }
            if ((h | 0) == 4) { return g | 0 }
            return 0
        }

        function Ri(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            d = i;
            i = i + 8 | 0;
            e = d | 0;
            f = b + 24 | 0;
            g = c[f >> 2] | 0;
            if ((g - 2 | 0) <= 0) { i = d; return }
            h = b + 36 | 0;
            j = b + 32 | 0;
            k = b + 40 | 0;
            l = b + 32 | 0;
            m = c[b + 20 >> 2] | 0;
            b = 0;
            n = g;
            while (1) {
                g = m + 2 | 0;
                o = a[g] | 0;
                do {
                    if ((o << 24 >> 24 | 0) == 3 | (o << 24 >> 24 | 0) == 0) {
                        if ((a[m] | 0) != 0) {
                            p = b;
                            q = m;
                            r = n;
                            break
                        }
                        s = m + 1 | 0;
                        if (!((a[s] | 0) == 0 & o << 24 >> 24 == 3)) {
                            p = b;
                            q = m;
                            r = n;
                            break
                        }
                        t = c[h >> 2] | 0;
                        u = b + 2 + (t - (c[j >> 2] | 0) >> 2) | 0;
                        c[e >> 2] = u;
                        if ((t | 0) == (c[k >> 2] | 0)) { fj(l, e) } else {
                            if ((t | 0) != 0) { c[t >> 2] = u }
                            c[h >> 2] = t + 4
                        }
                        fv(g | 0, m + 3 | 0, -3 - b + (c[f >> 2] | 0) | 0) | 0;
                        t = (c[f >> 2] | 0) - 1 | 0;
                        c[f >> 2] = t;
                        p = b + 1 | 0;
                        q = s;
                        r = t
                    } else {
                        p = b + 2 | 0;
                        q = g;
                        r = n
                    }
                } while (0);
                g = p + 1 | 0;
                if ((g | 0) < (r - 2 | 0)) {
                    m = q + 1 | 0;
                    b = g;
                    n = r
                } else { break }
            }
            i = d;
            return
        }

        function Si(b) {
            b = b | 0;
            a[b | 0] = 0;
            a[b + 1 | 0] = 0;
            dv(b + 4 | 0, 0, 48) | 0;
            return
        }

        function Ti(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            b = a + 32 | 0;
            d = a + 16 | 0;
            e = a + 28 | 0;
            f = a + 36 | 0;
            while (1) {
                g = c[b >> 2] | 0;
                if ((g | 0) == 0) { break }
                h = c[d >> 2] | 0;
                i = c[e >> 2] | 0;
                j = c[(c[h + (i >>> 10 << 2) >> 2] | 0) + ((i & 1023) << 2) >> 2] | 0;
                c[b >> 2] = g - 1;
                g = i + 1 | 0;
                c[e >> 2] = g;
                if (g >>> 0 > 2047 >>> 0) {
                    Pu(c[h >> 2] | 0);
                    c[d >> 2] = (c[d >> 2] | 0) + 4;
                    c[e >> 2] = (c[e >> 2] | 0) - 1024
                }
                c[f >> 2] = (c[f >> 2] | 0) - (c[j + 24 >> 2] | 0);
                if ((j | 0) == 0) { break }
                Vi(a, j)
            }
            f = c[a + 8 >> 2] | 0;
            if ((f | 0) != 0) { Vi(a, f) }
            f = a + 44 | 0;
            e = c[f >> 2] | 0;
            b = a + 40 | 0;
            j = c[b >> 2] | 0;
            if ((e | 0) == (j | 0)) {
                k = e;
                l = e;
                m = j
            } else {
                h = 0;
                g = j;
                j = e;
                while (1) {
                    e = c[g + (h << 2) >> 2] | 0;
                    if ((e | 0) == 0) {
                        n = j;
                        o = g
                    } else {
                        Hu(c[e + 20 >> 2] | 0);
                        i = c[e + 32 >> 2] | 0;
                        if ((i | 0) != 0) {
                            p = e + 36 | 0;
                            q = c[p >> 2] | 0;
                            if ((q | 0) != (i | 0)) { c[p >> 2] = q + (~((q - 4 + (-i | 0) | 0) >>> 2) << 2) }
                            Pu(i)
                        }
                        Pu(e | 0);
                        n = c[f >> 2] | 0;
                        o = c[b >> 2] | 0
                    }
                    e = h + 1 | 0;
                    i = o;
                    if (e >>> 0 < n - i >> 2 >>> 0) {
                        h = e;
                        g = o;
                        j = n
                    } else {
                        k = n;
                        l = o;
                        m = i;
                        break
                    }
                }
            }
            if ((l | 0) != 0) {
                if ((k | 0) != (l | 0)) { c[f >> 2] = k + (~((k - 4 + (-m | 0) | 0) >>> 2) << 2) }
                Pu(l)
            }
            l = a + 12 | 0;
            gj(l | 0);
            m = c[d >> 2] | 0;
            k = a + 20 | 0;
            a = c[k >> 2] | 0;
            do {
                if ((m | 0) != (a | 0)) {
                    f = m;
                    do {
                        Pu(c[f >> 2] | 0);
                        f = f + 4 | 0;
                    } while ((f | 0) != (a | 0));
                    f = c[d >> 2] | 0;
                    o = c[k >> 2] | 0;
                    if ((o | 0) == (f | 0)) { break }
                    c[k >> 2] = o + (~((o - 4 + (-f | 0) | 0) >>> 2) << 2)
                }
            } while (0);
            k = c[l >> 2] | 0;
            if ((k | 0) == 0) { return }
            Pu(k);
            return
        }

        function Ui(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0;
            b = a + 32 | 0;
            d = c[b >> 2] | 0;
            if ((d | 0) == 0) { e = 0; return e | 0 }
            f = a + 16 | 0;
            g = c[f >> 2] | 0;
            h = a + 28 | 0;
            i = c[h >> 2] | 0;
            j = c[(c[g + (i >>> 10 << 2) >> 2] | 0) + ((i & 1023) << 2) >> 2] | 0;
            c[b >> 2] = d - 1;
            d = i + 1 | 0;
            c[h >> 2] = d;
            if (d >>> 0 > 2047 >>> 0) {
                Pu(c[g >> 2] | 0);
                c[f >> 2] = (c[f >> 2] | 0) + 4;
                c[h >> 2] = (c[h >> 2] | 0) - 1024
            }
            h = a + 36 | 0;
            c[h >> 2] = (c[h >> 2] | 0) - (c[j + 24 >> 2] | 0);
            e = j;
            return e | 0
        }

        function Vi(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            d = i;
            i = i + 8 | 0;
            e = d | 0;
            c[e >> 2] = b;
            if ((b | 0) == 0) { i = d; return }
            f = a + 40 | 0;
            g = a + 44 | 0;
            h = c[g >> 2] | 0;
            if (!(h - (c[f >> 2] | 0) >> 2 >>> 0 < 16 >>> 0)) {
                Hu(c[b + 20 >> 2] | 0);
                j = c[b + 32 >> 2] | 0;
                if ((j | 0) != 0) {
                    k = b + 36 | 0;
                    l = c[k >> 2] | 0;
                    if ((l | 0) != (j | 0)) { c[k >> 2] = l + (~((l - 4 + (-j | 0) | 0) >>> 2) << 2) }
                    Pu(j)
                }
                Pu(b | 0);
                i = d;
                return
            }
            if ((h | 0) == (c[a + 48 >> 2] | 0)) {
                ej(f, e);
                i = d;
                return
            }
            if ((h | 0) == 0) { m = 0 } else {
                c[h >> 2] = b;
                m = c[g >> 2] | 0
            }
            c[g >> 2] = m + 4;
            i = d;
            return
        }

        function Wi(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            e = b + 44 | 0;
            f = c[e >> 2] | 0;
            if ((f | 0) == (c[b + 40 >> 2] | 0)) {
                g = Nu(48) | 0;
                a[g] = 0;
                a[g + 1 | 0] = 0;
                a[g + 2 | 0] = 0;
                h = g + 32 | 0;
                c[h >> 2] = 0;
                i = g + 36 | 0;
                c[i >> 2] = 0;
                j = g + 40 | 0;
                c[j >> 2] = 0;
                k = Nu(64) | 0;
                l = k;
                c[i >> 2] = l;
                c[h >> 2] = l;
                h = k + 64 | 0;
                c[j >> 2] = h;
                if ((k | 0) != 0) { c[l >> 2] = 0 }
                dv(k + 4 | 0, 0, 60) | 0;
                c[i >> 2] = h;
                dv(g + 8 | 0, 0, 24) | 0;
                m = g
            } else {
                g = f - 4 | 0;
                h = c[g >> 2] | 0;
                c[e >> 2] = f + (~((g + (-g | 0) | 0) >>> 2) << 2);
                m = h
            }
            a[m | 0] = 0;
            a[m + 1 | 0] = 0;
            a[m + 2 | 0] = 0;
            h = m + 8 | 0;
            c[h >> 2] = 0;
            c[h + 4 >> 2] = 0;
            c[m + 16 >> 2] = 0;
            h = m + 24 | 0;
            c[h >> 2] = 0;
            g = c[m + 32 >> 2] | 0;
            f = m + 36 | 0;
            e = c[f >> 2] | 0;
            if ((e | 0) != (g | 0)) { c[f >> 2] = e + (~((e - 4 + (-g | 0) | 0) >>> 2) << 2) }
            g = m + 28 | 0;
            if ((c[g >> 2] | 0) >= (d | 0)) { n = m; return n | 0 }
            e = Gu(d) | 0;
            if ((e | 0) == 0) {
                Vi(b, m);
                n = 0;
                return n | 0
            }
            b = m + 20 | 0;
            f = c[b >> 2] | 0;
            if ((f | 0) != 0) {
                cv(e | 0, f | 0, c[h >> 2] | 0) | 0;
                Hu(f)
            }
            c[b >> 2] = e;
            c[g >> 2] = d;
            n = m;
            return n | 0
        }



        function Do(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0;
            d = i;
            i = i + 328 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 104 | 0;
            m = d + 112 | 0;
            n = d + 128 | 0;
            o = d + 144 | 0;
            p = d + 152 | 0;
            q = d + 312 | 0;
            r = d + 320 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 0) { t = 0 } else if ((s | 0) == 8) { t = 16 } else if ((s | 0) == 64) { t = 8 } else { t = 10 }
            s = k | 0;
            Zo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = c[l >> 2] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) {
                        A = 1;
                        B = 0
                    } else {
                        C = c[u + 12 >> 2] | 0;
                        if ((C | 0) == (c[u + 16 >> 2] | 0)) { D = Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0 } else { D = c[C >> 2] | 0 }
                        if (!((D | 0) == -1)) {
                            A = 0;
                            B = u;
                            break
                        }
                        c[x >> 2] = 0;
                        A = 1;
                        B = 0
                    }
                } while (0);
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { E = 22 } else {
                        F = c[C + 12 >> 2] | 0;
                        if ((F | 0) == (c[C + 16 >> 2] | 0)) { G = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { G = c[F >> 2] | 0 }
                        if ((G | 0) == -1) {
                            c[e >> 2] = 0;
                            E = 22;
                            break
                        } else {
                            if (A) { H = C; break } else {
                                I = l;
                                J = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((E | 0) == 22) {
                    E = 0;
                    if (A) {
                        I = l;
                        J = 0;
                        break
                    } else { H = 0 }
                }
                C = a[g] | 0;
                F = (C & 1) == 0;
                if (F) { K = (C & 255) >>> 1 } else { K = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (K | 0)) {
                    if (F) {
                        L = (C & 255) >>> 1;
                        M = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        L = C;
                        M = C
                    }
                    tm(n, L << 1, 0);
                    if ((a[g] & 1) == 0) { N = 10 } else { N = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, N, 0);
                    if ((a[g] & 1) == 0) { O = v } else { O = c[w >> 2] | 0 }
                    c[o >> 2] = O + M;
                    P = O
                } else { P = l }
                C = B + 12 | 0;
                F = c[C >> 2] | 0;
                Q = B + 16 | 0;
                if ((F | 0) == (c[Q >> 2] | 0)) { R = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { R = c[F >> 2] | 0 }
                if ((Vo(R, t, P, o, r, z, m, k, q, s) | 0) != 0) {
                    I = P;
                    J = H;
                    break
                }
                F = c[C >> 2] | 0;
                if ((F | 0) == (c[Q >> 2] | 0)) {
                    Fc[c[(c[B >> 2] | 0) + 40 >> 2] & 255](B) | 0;
                    l = P;
                    u = B;
                    continue
                } else {
                    c[C >> 2] = F + 4;
                    l = P;
                    u = B;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { S = (u & 255) >>> 1 } else { S = c[m + 4 >> 2] | 0 }
            do {
                if ((S | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    P = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = P
                }
            } while (0);
            r = Rt(I, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((B | 0) == 0) {
                    T = 1;
                    U = 0
                } else {
                    q = c[B + 12 >> 2] | 0;
                    if ((q | 0) == (c[B + 16 >> 2] | 0)) { V = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { V = c[q >> 2] | 0 }
                    if (!((V | 0) == -1)) {
                        T = 0;
                        U = B;
                        break
                    }
                    c[x >> 2] = 0;
                    T = 1;
                    U = 0
                }
            } while (0);
            do {
                if ((J | 0) == 0) { E = 67 } else {
                    x = c[J + 12 >> 2] | 0;
                    if ((x | 0) == (c[J + 16 >> 2] | 0)) { W = Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0 } else { W = c[x >> 2] | 0 }
                    if ((W | 0) == -1) {
                        c[e >> 2] = 0;
                        E = 67;
                        break
                    }
                    if (!T) { break }
                    X = b | 0;
                    c[X >> 2] = U;
                    Y = 160;
                    Z = 0;
                    rm(n);
                    rm(m);
                    _ = 104;
                    $ = 0;
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((E | 0) == 67) {
                    if (T) { break }
                    X = b | 0;
                    c[X >> 2] = U;
                    Y = 160;
                    Z = 0;
                    rm(n);
                    rm(m);
                    _ = 104;
                    $ = 0;
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            X = b | 0;
            c[X >> 2] = U;
            Y = 160;
            Z = 0;
            rm(n);
            rm(m);
            _ = 104;
            $ = 0;
            i = d;
            return
        }

        function Eo(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            Fo(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function Fo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0;
            d = i;
            i = i + 328 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 104 | 0;
            m = d + 112 | 0;
            n = d + 128 | 0;
            o = d + 144 | 0;
            p = d + 152 | 0;
            q = d + 312 | 0;
            r = d + 320 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 64) { t = 8 } else if ((s | 0) == 0) { t = 0 } else if ((s | 0) == 8) { t = 16 } else { t = 10 }
            s = k | 0;
            Zo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = c[l >> 2] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) {
                        A = 1;
                        B = 0
                    } else {
                        C = c[u + 12 >> 2] | 0;
                        if ((C | 0) == (c[u + 16 >> 2] | 0)) { D = Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0 } else { D = c[C >> 2] | 0 }
                        if (!((D | 0) == -1)) {
                            A = 0;
                            B = u;
                            break
                        }
                        c[x >> 2] = 0;
                        A = 1;
                        B = 0
                    }
                } while (0);
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { E = 22 } else {
                        F = c[C + 12 >> 2] | 0;
                        if ((F | 0) == (c[C + 16 >> 2] | 0)) { G = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { G = c[F >> 2] | 0 }
                        if ((G | 0) == -1) {
                            c[e >> 2] = 0;
                            E = 22;
                            break
                        } else {
                            if (A) { H = C; break } else {
                                I = l;
                                J = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((E | 0) == 22) {
                    E = 0;
                    if (A) {
                        I = l;
                        J = 0;
                        break
                    } else { H = 0 }
                }
                C = a[g] | 0;
                F = (C & 1) == 0;
                if (F) { L = (C & 255) >>> 1 } else { L = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (L | 0)) {
                    if (F) {
                        M = (C & 255) >>> 1;
                        N = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        M = C;
                        N = C
                    }
                    tm(n, M << 1, 0);
                    if ((a[g] & 1) == 0) { O = 10 } else { O = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, O, 0);
                    if ((a[g] & 1) == 0) { P = v } else { P = c[w >> 2] | 0 }
                    c[o >> 2] = P + N;
                    Q = P
                } else { Q = l }
                C = B + 12 | 0;
                F = c[C >> 2] | 0;
                R = B + 16 | 0;
                if ((F | 0) == (c[R >> 2] | 0)) { S = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { S = c[F >> 2] | 0 }
                if ((Vo(S, t, Q, o, r, z, m, k, q, s) | 0) != 0) {
                    I = Q;
                    J = H;
                    break
                }
                F = c[C >> 2] | 0;
                if ((F | 0) == (c[R >> 2] | 0)) {
                    Fc[c[(c[B >> 2] | 0) + 40 >> 2] & 255](B) | 0;
                    l = Q;
                    u = B;
                    continue
                } else {
                    c[C >> 2] = F + 4;
                    l = Q;
                    u = B;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { T = (u & 255) >>> 1 } else { T = c[m + 4 >> 2] | 0 }
            do {
                if ((T | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    Q = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = Q
                }
            } while (0);
            r = Qt(I, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            c[j + 4 >> 2] = K;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((B | 0) == 0) {
                    U = 1;
                    V = 0
                } else {
                    q = c[B + 12 >> 2] | 0;
                    if ((q | 0) == (c[B + 16 >> 2] | 0)) { W = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { W = c[q >> 2] | 0 }
                    if (!((W | 0) == -1)) {
                        U = 0;
                        V = B;
                        break
                    }
                    c[x >> 2] = 0;
                    U = 1;
                    V = 0
                }
            } while (0);
            do {
                if ((J | 0) == 0) { E = 67 } else {
                    x = c[J + 12 >> 2] | 0;
                    if ((x | 0) == (c[J + 16 >> 2] | 0)) { X = Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0 } else { X = c[x >> 2] | 0 }
                    if ((X | 0) == -1) {
                        c[e >> 2] = 0;
                        E = 67;
                        break
                    }
                    if (!U) { break }
                    Y = b | 0;
                    c[Y >> 2] = V;
                    Z = 160;
                    _ = 0;
                    rm(n);
                    rm(m);
                    $ = 104;
                    aa = 0;
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((E | 0) == 67) {
                    if (U) { break }
                    Y = b | 0;
                    c[Y >> 2] = V;
                    Z = 160;
                    _ = 0;
                    rm(n);
                    rm(m);
                    $ = 104;
                    aa = 0;
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            Y = b | 0;
            c[Y >> 2] = V;
            Z = 160;
            _ = 0;
            rm(n);
            rm(m);
            $ = 104;
            aa = 0;
            i = d;
            return
        }

        function Go(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            Ho(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function Ho(d, e, f, g, h, j, k) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0;
            e = i;
            i = i + 328 | 0;
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = g;
            g = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[g >> 2] = c[l >> 2];
            l = e | 0;
            m = e + 104 | 0;
            n = e + 112 | 0;
            o = e + 128 | 0;
            p = e + 144 | 0;
            q = e + 152 | 0;
            r = e + 312 | 0;
            s = e + 320 | 0;
            t = c[h + 4 >> 2] & 74;
            if ((t | 0) == 0) { u = 0 } else if ((t | 0) == 8) { u = 16 } else if ((t | 0) == 64) { u = 8 } else { u = 10 }
            t = l | 0;
            Zo(n, h, t, m);
            h = o;
            dv(h | 0, 0, 12) | 0;
            tm(o, 10, 0);
            if ((a[h] & 1) == 0) {
                l = o + 1 | 0;
                v = l;
                w = l;
                x = o + 8 | 0
            } else {
                l = o + 8 | 0;
                v = c[l >> 2] | 0;
                w = o + 1 | 0;
                x = l
            }
            c[p >> 2] = v;
            l = q | 0;
            c[r >> 2] = l;
            c[s >> 2] = 0;
            y = f | 0;
            f = g | 0;
            g = o | 0;
            z = o + 4 | 0;
            A = c[m >> 2] | 0;
            m = v;
            v = c[y >> 2] | 0;
            a: while (1) {
                do {
                    if ((v | 0) == 0) {
                        B = 1;
                        C = 0
                    } else {
                        D = c[v + 12 >> 2] | 0;
                        if ((D | 0) == (c[v + 16 >> 2] | 0)) { E = Fc[c[(c[v >> 2] | 0) + 36 >> 2] & 255](v) | 0 } else { E = c[D >> 2] | 0 }
                        if (!((E | 0) == -1)) {
                            B = 0;
                            C = v;
                            break
                        }
                        c[y >> 2] = 0;
                        B = 1;
                        C = 0
                    }
                } while (0);
                D = c[f >> 2] | 0;
                do {
                    if ((D | 0) == 0) { F = 22 } else {
                        G = c[D + 12 >> 2] | 0;
                        if ((G | 0) == (c[D + 16 >> 2] | 0)) { H = Fc[c[(c[D >> 2] | 0) + 36 >> 2] & 255](D) | 0 } else { H = c[G >> 2] | 0 }
                        if ((H | 0) == -1) {
                            c[f >> 2] = 0;
                            F = 22;
                            break
                        } else {
                            if (B) { I = D; break } else {
                                J = m;
                                K = D;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((F | 0) == 22) {
                    F = 0;
                    if (B) {
                        J = m;
                        K = 0;
                        break
                    } else { I = 0 }
                }
                D = a[h] | 0;
                G = (D & 1) == 0;
                if (G) { L = (D & 255) >>> 1 } else { L = c[z >> 2] | 0 }
                if (((c[p >> 2] | 0) - m | 0) == (L | 0)) {
                    if (G) {
                        M = (D & 255) >>> 1;
                        N = (D & 255) >>> 1
                    } else {
                        D = c[z >> 2] | 0;
                        M = D;
                        N = D
                    }
                    tm(o, M << 1, 0);
                    if ((a[h] & 1) == 0) { O = 10 } else { O = (c[g >> 2] & -2) - 1 | 0 }
                    tm(o, O, 0);
                    if ((a[h] & 1) == 0) { P = w } else { P = c[x >> 2] | 0 }
                    c[p >> 2] = P + N;
                    Q = P
                } else { Q = m }
                D = C + 12 | 0;
                G = c[D >> 2] | 0;
                R = C + 16 | 0;
                if ((G | 0) == (c[R >> 2] | 0)) { S = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { S = c[G >> 2] | 0 }
                if ((Vo(S, u, Q, p, s, A, n, l, r, t) | 0) != 0) {
                    J = Q;
                    K = I;
                    break
                }
                G = c[D >> 2] | 0;
                if ((G | 0) == (c[R >> 2] | 0)) {
                    Fc[c[(c[C >> 2] | 0) + 40 >> 2] & 255](C) | 0;
                    m = Q;
                    v = C;
                    continue
                } else {
                    c[D >> 2] = G + 4;
                    m = Q;
                    v = C;
                    continue
                }
            }
            v = a[n] | 0;
            if ((v & 1) == 0) { T = (v & 255) >>> 1 } else { T = c[n + 4 >> 2] | 0 }
            do {
                if ((T | 0) != 0) {
                    v = c[r >> 2] | 0;
                    if ((v - q | 0) >= 160) { break }
                    Q = c[s >> 2] | 0;
                    c[r >> 2] = v + 4;
                    c[v >> 2] = Q
                }
            } while (0);
            s = Pt(J, c[p >> 2] | 0, j, u) | 0;
            b[k >> 1] = s;
            hr(n, l, c[r >> 2] | 0, j);
            do {
                if ((C | 0) == 0) {
                    U = 1;
                    V = 0
                } else {
                    r = c[C + 12 >> 2] | 0;
                    if ((r | 0) == (c[C + 16 >> 2] | 0)) { W = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { W = c[r >> 2] | 0 }
                    if (!((W | 0) == -1)) {
                        U = 0;
                        V = C;
                        break
                    }
                    c[y >> 2] = 0;
                    U = 1;
                    V = 0
                }
            } while (0);
            do {
                if ((K | 0) == 0) { F = 67 } else {
                    y = c[K + 12 >> 2] | 0;
                    if ((y | 0) == (c[K + 16 >> 2] | 0)) { X = Fc[c[(c[K >> 2] | 0) + 36 >> 2] & 255](K) | 0 } else { X = c[y >> 2] | 0 }
                    if ((X | 0) == -1) {
                        c[f >> 2] = 0;
                        F = 67;
                        break
                    }
                    if (!U) { break }
                    Y = d | 0;
                    c[Y >> 2] = V;
                    Z = 160;
                    _ = 0;
                    rm(o);
                    rm(n);
                    $ = 104;
                    aa = 0;
                    i = e;
                    return
                }
            } while (0);
            do {
                if ((F | 0) == 67) {
                    if (U) { break }
                    Y = d | 0;
                    c[Y >> 2] = V;
                    Z = 160;
                    _ = 0;
                    rm(o);
                    rm(n);
                    $ = 104;
                    aa = 0;
                    i = e;
                    return
                }
            } while (0);
            c[j >> 2] = c[j >> 2] | 2;
            Y = d | 0;
            c[Y >> 2] = V;
            Z = 160;
            _ = 0;
            rm(o);
            rm(n);
            $ = 104;
            aa = 0;
            i = e;
            return
        }

        function Io(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            Jo(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function Jo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0;
            d = i;
            i = i + 328 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 104 | 0;
            m = d + 112 | 0;
            n = d + 128 | 0;
            o = d + 144 | 0;
            p = d + 152 | 0;
            q = d + 312 | 0;
            r = d + 320 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 0) { t = 0 } else if ((s | 0) == 64) { t = 8 } else if ((s | 0) == 8) { t = 16 } else { t = 10 }
            s = k | 0;
            Zo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = c[l >> 2] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) {
                        A = 1;
                        B = 0
                    } else {
                        C = c[u + 12 >> 2] | 0;
                        if ((C | 0) == (c[u + 16 >> 2] | 0)) { D = Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0 } else { D = c[C >> 2] | 0 }
                        if (!((D | 0) == -1)) {
                            A = 0;
                            B = u;
                            break
                        }
                        c[x >> 2] = 0;
                        A = 1;
                        B = 0
                    }
                } while (0);
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { E = 22 } else {
                        F = c[C + 12 >> 2] | 0;
                        if ((F | 0) == (c[C + 16 >> 2] | 0)) { G = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { G = c[F >> 2] | 0 }
                        if ((G | 0) == -1) {
                            c[e >> 2] = 0;
                            E = 22;
                            break
                        } else {
                            if (A) { H = C; break } else {
                                I = l;
                                J = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((E | 0) == 22) {
                    E = 0;
                    if (A) {
                        I = l;
                        J = 0;
                        break
                    } else { H = 0 }
                }
                C = a[g] | 0;
                F = (C & 1) == 0;
                if (F) { K = (C & 255) >>> 1 } else { K = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (K | 0)) {
                    if (F) {
                        L = (C & 255) >>> 1;
                        M = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        L = C;
                        M = C
                    }
                    tm(n, L << 1, 0);
                    if ((a[g] & 1) == 0) { N = 10 } else { N = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, N, 0);
                    if ((a[g] & 1) == 0) { O = v } else { O = c[w >> 2] | 0 }
                    c[o >> 2] = O + M;
                    P = O
                } else { P = l }
                C = B + 12 | 0;
                F = c[C >> 2] | 0;
                Q = B + 16 | 0;
                if ((F | 0) == (c[Q >> 2] | 0)) { R = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { R = c[F >> 2] | 0 }
                if ((Vo(R, t, P, o, r, z, m, k, q, s) | 0) != 0) {
                    I = P;
                    J = H;
                    break
                }
                F = c[C >> 2] | 0;
                if ((F | 0) == (c[Q >> 2] | 0)) {
                    Fc[c[(c[B >> 2] | 0) + 40 >> 2] & 255](B) | 0;
                    l = P;
                    u = B;
                    continue
                } else {
                    c[C >> 2] = F + 4;
                    l = P;
                    u = B;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { S = (u & 255) >>> 1 } else { S = c[m + 4 >> 2] | 0 }
            do {
                if ((S | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    P = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = P
                }
            } while (0);
            r = Ot(I, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((B | 0) == 0) {
                    T = 1;
                    U = 0
                } else {
                    q = c[B + 12 >> 2] | 0;
                    if ((q | 0) == (c[B + 16 >> 2] | 0)) { V = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { V = c[q >> 2] | 0 }
                    if (!((V | 0) == -1)) {
                        T = 0;
                        U = B;
                        break
                    }
                    c[x >> 2] = 0;
                    T = 1;
                    U = 0
                }
            } while (0);
            do {
                if ((J | 0) == 0) { E = 67 } else {
                    x = c[J + 12 >> 2] | 0;
                    if ((x | 0) == (c[J + 16 >> 2] | 0)) { W = Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0 } else { W = c[x >> 2] | 0 }
                    if ((W | 0) == -1) {
                        c[e >> 2] = 0;
                        E = 67;
                        break
                    }
                    if (!T) { break }
                    X = b | 0;
                    c[X >> 2] = U;
                    Y = 160;
                    Z = 0;
                    rm(n);
                    rm(m);
                    _ = 104;
                    $ = 0;
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((E | 0) == 67) {
                    if (T) { break }
                    X = b | 0;
                    c[X >> 2] = U;
                    Y = 160;
                    Z = 0;
                    rm(n);
                    rm(m);
                    _ = 104;
                    $ = 0;
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            X = b | 0;
            c[X >> 2] = U;
            Y = 160;
            Z = 0;
            rm(n);
            rm(m);
            _ = 104;
            $ = 0;
            i = d;
            return
        }

        function Ko(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            Lo(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function Lo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0;
            d = i;
            i = i + 328 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 104 | 0;
            m = d + 112 | 0;
            n = d + 128 | 0;
            o = d + 144 | 0;
            p = d + 152 | 0;
            q = d + 312 | 0;
            r = d + 320 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 0) { t = 0 } else if ((s | 0) == 8) { t = 16 } else if ((s | 0) == 64) { t = 8 } else { t = 10 }
            s = k | 0;
            Zo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = c[l >> 2] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) {
                        A = 1;
                        B = 0
                    } else {
                        C = c[u + 12 >> 2] | 0;
                        if ((C | 0) == (c[u + 16 >> 2] | 0)) { D = Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0 } else { D = c[C >> 2] | 0 }
                        if (!((D | 0) == -1)) {
                            A = 0;
                            B = u;
                            break
                        }
                        c[x >> 2] = 0;
                        A = 1;
                        B = 0
                    }
                } while (0);
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { E = 22 } else {
                        F = c[C + 12 >> 2] | 0;
                        if ((F | 0) == (c[C + 16 >> 2] | 0)) { G = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { G = c[F >> 2] | 0 }
                        if ((G | 0) == -1) {
                            c[e >> 2] = 0;
                            E = 22;
                            break
                        } else {
                            if (A) { H = C; break } else {
                                I = l;
                                J = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((E | 0) == 22) {
                    E = 0;
                    if (A) {
                        I = l;
                        J = 0;
                        break
                    } else { H = 0 }
                }
                C = a[g] | 0;
                F = (C & 1) == 0;
                if (F) { K = (C & 255) >>> 1 } else { K = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (K | 0)) {
                    if (F) {
                        L = (C & 255) >>> 1;
                        M = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        L = C;
                        M = C
                    }
                    tm(n, L << 1, 0);
                    if ((a[g] & 1) == 0) { N = 10 } else { N = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, N, 0);
                    if ((a[g] & 1) == 0) { O = v } else { O = c[w >> 2] | 0 }
                    c[o >> 2] = O + M;
                    P = O
                } else { P = l }
                C = B + 12 | 0;
                F = c[C >> 2] | 0;
                Q = B + 16 | 0;
                if ((F | 0) == (c[Q >> 2] | 0)) { R = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { R = c[F >> 2] | 0 }
                if ((Vo(R, t, P, o, r, z, m, k, q, s) | 0) != 0) {
                    I = P;
                    J = H;
                    break
                }
                F = c[C >> 2] | 0;
                if ((F | 0) == (c[Q >> 2] | 0)) {
                    Fc[c[(c[B >> 2] | 0) + 40 >> 2] & 255](B) | 0;
                    l = P;
                    u = B;
                    continue
                } else {
                    c[C >> 2] = F + 4;
                    l = P;
                    u = B;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { S = (u & 255) >>> 1 } else { S = c[m + 4 >> 2] | 0 }
            do {
                if ((S | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    P = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = P
                }
            } while (0);
            r = Nt(I, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((B | 0) == 0) {
                    T = 1;
                    U = 0
                } else {
                    q = c[B + 12 >> 2] | 0;
                    if ((q | 0) == (c[B + 16 >> 2] | 0)) { V = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { V = c[q >> 2] | 0 }
                    if (!((V | 0) == -1)) {
                        T = 0;
                        U = B;
                        break
                    }
                    c[x >> 2] = 0;
                    T = 1;
                    U = 0
                }
            } while (0);
            do {
                if ((J | 0) == 0) { E = 67 } else {
                    x = c[J + 12 >> 2] | 0;
                    if ((x | 0) == (c[J + 16 >> 2] | 0)) { W = Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0 } else { W = c[x >> 2] | 0 }
                    if ((W | 0) == -1) {
                        c[e >> 2] = 0;
                        E = 67;
                        break
                    }
                    if (!T) { break }
                    X = b | 0;
                    c[X >> 2] = U;
                    Y = 160;
                    Z = 0;
                    rm(n);
                    rm(m);
                    _ = 104;
                    $ = 0;
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((E | 0) == 67) {
                    if (T) { break }
                    X = b | 0;
                    c[X >> 2] = U;
                    Y = 160;
                    Z = 0;
                    rm(n);
                    rm(m);
                    _ = 104;
                    $ = 0;
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            X = b | 0;
            c[X >> 2] = U;
            Y = 160;
            Z = 0;
            rm(n);
            rm(m);
            _ = 104;
            $ = 0;
            i = d;
            return
        }

        function Mo(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            No(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function No(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0;
            d = i;
            i = i + 328 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 104 | 0;
            m = d + 112 | 0;
            n = d + 128 | 0;
            o = d + 144 | 0;
            p = d + 152 | 0;
            q = d + 312 | 0;
            r = d + 320 | 0;
            s = c[g + 4 >> 2] & 74;
            if ((s | 0) == 64) { t = 8 } else if ((s | 0) == 0) { t = 0 } else if ((s | 0) == 8) { t = 16 } else { t = 10 }
            s = k | 0;
            Zo(m, g, s, l);
            g = n;
            dv(g | 0, 0, 12) | 0;
            tm(n, 10, 0);
            if ((a[g] & 1) == 0) {
                k = n + 1 | 0;
                u = k;
                v = k;
                w = n + 8 | 0
            } else {
                k = n + 8 | 0;
                u = c[k >> 2] | 0;
                v = n + 1 | 0;
                w = k
            }
            c[o >> 2] = u;
            k = p | 0;
            c[q >> 2] = k;
            c[r >> 2] = 0;
            x = e | 0;
            e = f | 0;
            f = n | 0;
            y = n + 4 | 0;
            z = c[l >> 2] | 0;
            l = u;
            u = c[x >> 2] | 0;
            a: while (1) {
                do {
                    if ((u | 0) == 0) {
                        A = 1;
                        B = 0
                    } else {
                        C = c[u + 12 >> 2] | 0;
                        if ((C | 0) == (c[u + 16 >> 2] | 0)) { D = Fc[c[(c[u >> 2] | 0) + 36 >> 2] & 255](u) | 0 } else { D = c[C >> 2] | 0 }
                        if (!((D | 0) == -1)) {
                            A = 0;
                            B = u;
                            break
                        }
                        c[x >> 2] = 0;
                        A = 1;
                        B = 0
                    }
                } while (0);
                C = c[e >> 2] | 0;
                do {
                    if ((C | 0) == 0) { E = 22 } else {
                        F = c[C + 12 >> 2] | 0;
                        if ((F | 0) == (c[C + 16 >> 2] | 0)) { G = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { G = c[F >> 2] | 0 }
                        if ((G | 0) == -1) {
                            c[e >> 2] = 0;
                            E = 22;
                            break
                        } else {
                            if (A) { H = C; break } else {
                                I = l;
                                J = C;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((E | 0) == 22) {
                    E = 0;
                    if (A) {
                        I = l;
                        J = 0;
                        break
                    } else { H = 0 }
                }
                C = a[g] | 0;
                F = (C & 1) == 0;
                if (F) { L = (C & 255) >>> 1 } else { L = c[y >> 2] | 0 }
                if (((c[o >> 2] | 0) - l | 0) == (L | 0)) {
                    if (F) {
                        M = (C & 255) >>> 1;
                        N = (C & 255) >>> 1
                    } else {
                        C = c[y >> 2] | 0;
                        M = C;
                        N = C
                    }
                    tm(n, M << 1, 0);
                    if ((a[g] & 1) == 0) { O = 10 } else { O = (c[f >> 2] & -2) - 1 | 0 }
                    tm(n, O, 0);
                    if ((a[g] & 1) == 0) { P = v } else { P = c[w >> 2] | 0 }
                    c[o >> 2] = P + N;
                    Q = P
                } else { Q = l }
                C = B + 12 | 0;
                F = c[C >> 2] | 0;
                R = B + 16 | 0;
                if ((F | 0) == (c[R >> 2] | 0)) { S = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { S = c[F >> 2] | 0 }
                if ((Vo(S, t, Q, o, r, z, m, k, q, s) | 0) != 0) {
                    I = Q;
                    J = H;
                    break
                }
                F = c[C >> 2] | 0;
                if ((F | 0) == (c[R >> 2] | 0)) {
                    Fc[c[(c[B >> 2] | 0) + 40 >> 2] & 255](B) | 0;
                    l = Q;
                    u = B;
                    continue
                } else {
                    c[C >> 2] = F + 4;
                    l = Q;
                    u = B;
                    continue
                }
            }
            u = a[m] | 0;
            if ((u & 1) == 0) { T = (u & 255) >>> 1 } else { T = c[m + 4 >> 2] | 0 }
            do {
                if ((T | 0) != 0) {
                    u = c[q >> 2] | 0;
                    if ((u - p | 0) >= 160) { break }
                    Q = c[r >> 2] | 0;
                    c[q >> 2] = u + 4;
                    c[u >> 2] = Q
                }
            } while (0);
            r = Mt(I, c[o >> 2] | 0, h, t) | 0;
            c[j >> 2] = r;
            c[j + 4 >> 2] = K;
            hr(m, k, c[q >> 2] | 0, h);
            do {
                if ((B | 0) == 0) {
                    U = 1;
                    V = 0
                } else {
                    q = c[B + 12 >> 2] | 0;
                    if ((q | 0) == (c[B + 16 >> 2] | 0)) { W = Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0 } else { W = c[q >> 2] | 0 }
                    if (!((W | 0) == -1)) {
                        U = 0;
                        V = B;
                        break
                    }
                    c[x >> 2] = 0;
                    U = 1;
                    V = 0
                }
            } while (0);
            do {
                if ((J | 0) == 0) { E = 67 } else {
                    x = c[J + 12 >> 2] | 0;
                    if ((x | 0) == (c[J + 16 >> 2] | 0)) { X = Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0 } else { X = c[x >> 2] | 0 }
                    if ((X | 0) == -1) {
                        c[e >> 2] = 0;
                        E = 67;
                        break
                    }
                    if (!U) { break }
                    Y = b | 0;
                    c[Y >> 2] = V;
                    Z = 160;
                    _ = 0;
                    rm(n);
                    rm(m);
                    $ = 104;
                    aa = 0;
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((E | 0) == 67) {
                    if (U) { break }
                    Y = b | 0;
                    c[Y >> 2] = V;
                    Z = 160;
                    _ = 0;
                    rm(n);
                    rm(m);
                    $ = 104;
                    aa = 0;
                    i = d;
                    return
                }
            } while (0);
            c[h >> 2] = c[h >> 2] | 2;
            Y = b | 0;
            c[Y >> 2] = V;
            Z = 160;
            _ = 0;
            rm(n);
            rm(m);
            $ = 104;
            aa = 0;
            i = d;
            return
        }

        function Oo(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            Po(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function Po(b, d, e, f, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0.0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0;
            d = i;
            i = i + 376 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d + 128 | 0;
            m = d + 136 | 0;
            n = d + 144 | 0;
            o = d + 160 | 0;
            p = d + 176 | 0;
            q = d + 184 | 0;
            r = d + 344 | 0;
            s = d + 352 | 0;
            t = d + 360 | 0;
            u = d + 368 | 0;
            v = d | 0;
            _o(n, h, v, l, m);
            h = o;
            dv(h | 0, 0, 12) | 0;
            tm(o, 10, 0);
            if ((a[h] & 1) == 0) {
                w = o + 1 | 0;
                x = w;
                y = w;
                z = o + 8 | 0
            } else {
                w = o + 8 | 0;
                x = c[w >> 2] | 0;
                y = o + 1 | 0;
                z = w
            }
            c[p >> 2] = x;
            w = q | 0;
            c[r >> 2] = w;
            c[s >> 2] = 0;
            a[t] = 1;
            a[u] = 69;
            A = e | 0;
            e = f | 0;
            f = o | 0;
            B = o + 4 | 0;
            C = c[l >> 2] | 0;
            l = c[m >> 2] | 0;
            m = x;
            x = c[A >> 2] | 0;
            a: while (1) {
                do {
                    if ((x | 0) == 0) {
                        D = 1;
                        E = 0
                    } else {
                        F = c[x + 12 >> 2] | 0;
                        if ((F | 0) == (c[x + 16 >> 2] | 0)) { G = Fc[c[(c[x >> 2] | 0) + 36 >> 2] & 255](x) | 0 } else { G = c[F >> 2] | 0 }
                        if (!((G | 0) == -1)) {
                            D = 0;
                            E = x;
                            break
                        }
                        c[A >> 2] = 0;
                        D = 1;
                        E = 0
                    }
                } while (0);
                F = c[e >> 2] | 0;
                do {
                    if ((F | 0) == 0) { H = 18 } else {
                        I = c[F + 12 >> 2] | 0;
                        if ((I | 0) == (c[F + 16 >> 2] | 0)) { J = Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0 } else { J = c[I >> 2] | 0 }
                        if ((J | 0) == -1) {
                            c[e >> 2] = 0;
                            H = 18;
                            break
                        } else {
                            if (D) { K = F; break } else {
                                L = m;
                                M = F;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((H | 0) == 18) {
                    H = 0;
                    if (D) {
                        L = m;
                        M = 0;
                        break
                    } else { K = 0 }
                }
                F = a[h] | 0;
                I = (F & 1) == 0;
                if (I) { N = (F & 255) >>> 1 } else { N = c[B >> 2] | 0 }
                if (((c[p >> 2] | 0) - m | 0) == (N | 0)) {
                    if (I) {
                        O = (F & 255) >>> 1;
                        P = (F & 255) >>> 1
                    } else {
                        F = c[B >> 2] | 0;
                        O = F;
                        P = F
                    }
                    tm(o, O << 1, 0);
                    if ((a[h] & 1) == 0) { Q = 10 } else { Q = (c[f >> 2] & -2) - 1 | 0 }
                    tm(o, Q, 0);
                    if ((a[h] & 1) == 0) { R = y } else { R = c[z >> 2] | 0 }
                    c[p >> 2] = R + P;
                    S = R
                } else { S = m }
                F = E + 12 | 0;
                I = c[F >> 2] | 0;
                T = E + 16 | 0;
                if ((I | 0) == (c[T >> 2] | 0)) { U = Fc[c[(c[E >> 2] | 0) + 36 >> 2] & 255](E) | 0 } else { U = c[I >> 2] | 0 }
                if (($o(U, t, u, S, p, C, l, n, w, r, s, v) | 0) != 0) {
                    L = S;
                    M = K;
                    break
                }
                I = c[F >> 2] | 0;
                if ((I | 0) == (c[T >> 2] | 0)) {
                    Fc[c[(c[E >> 2] | 0) + 40 >> 2] & 255](E) | 0;
                    m = S;
                    x = E;
                    continue
                } else {
                    c[F >> 2] = I + 4;
                    m = S;
                    x = E;
                    continue
                }
            }
            x = a[n] | 0;
            if ((x & 1) == 0) { V = (x & 255) >>> 1 } else { V = c[n + 4 >> 2] | 0 }
            do {
                if ((V | 0) != 0) {
                    if ((a[t] | 0) == 0) { break }
                    x = c[r >> 2] | 0;
                    if ((x - q | 0) >= 160) { break }
                    S = c[s >> 2] | 0;
                    c[r >> 2] = x + 4;
                    c[x >> 2] = S
                }
            } while (0);
            W = +Lt(L, c[p >> 2] | 0, j);
            g[k >> 2] = W;
            hr(n, w, c[r >> 2] | 0, j);
            do {
                if ((E | 0) == 0) {
                    X = 1;
                    Y = 0
                } else {
                    r = c[E + 12 >> 2] | 0;
                    if ((r | 0) == (c[E + 16 >> 2] | 0)) { Z = Fc[c[(c[E >> 2] | 0) + 36 >> 2] & 255](E) | 0 } else { Z = c[r >> 2] | 0 }
                    if (!((Z | 0) == -1)) {
                        X = 0;
                        Y = E;
                        break
                    }
                    c[A >> 2] = 0;
                    X = 1;
                    Y = 0
                }
            } while (0);
            do {
                if ((M | 0) == 0) { H = 64 } else {
                    A = c[M + 12 >> 2] | 0;
                    if ((A | 0) == (c[M + 16 >> 2] | 0)) { _ = Fc[c[(c[M >> 2] | 0) + 36 >> 2] & 255](M) | 0 } else { _ = c[A >> 2] | 0 }
                    if ((_ | 0) == -1) {
                        c[e >> 2] = 0;
                        H = 64;
                        break
                    }
                    if (!X) { break }
                    $ = b | 0;
                    c[$ >> 2] = Y;
                    aa = 160;
                    ba = 0;
                    rm(o);
                    rm(n);
                    ca = 128;
                    da = 0;
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((H | 0) == 64) {
                    if (X) { break }
                    $ = b | 0;
                    c[$ >> 2] = Y;
                    aa = 160;
                    ba = 0;
                    rm(o);
                    rm(n);
                    ca = 128;
                    da = 0;
                    i = d;
                    return
                }
            } while (0);
            c[j >> 2] = c[j >> 2] | 2;
            $ = b | 0;
            c[$ >> 2] = Y;
            aa = 160;
            ba = 0;
            rm(o);
            rm(n);
            ca = 128;
            da = 0;
            i = d;
            return
        }

        function Qo(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            Ro(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function Ro(b, d, e, f, g, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0.0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0;
            d = i;
            i = i + 376 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d + 128 | 0;
            m = d + 136 | 0;
            n = d + 144 | 0;
            o = d + 160 | 0;
            p = d + 176 | 0;
            q = d + 184 | 0;
            r = d + 344 | 0;
            s = d + 352 | 0;
            t = d + 360 | 0;
            u = d + 368 | 0;
            v = d | 0;
            _o(n, g, v, l, m);
            g = o;
            dv(g | 0, 0, 12) | 0;
            tm(o, 10, 0);
            if ((a[g] & 1) == 0) {
                w = o + 1 | 0;
                x = w;
                y = w;
                z = o + 8 | 0
            } else {
                w = o + 8 | 0;
                x = c[w >> 2] | 0;
                y = o + 1 | 0;
                z = w
            }
            c[p >> 2] = x;
            w = q | 0;
            c[r >> 2] = w;
            c[s >> 2] = 0;
            a[t] = 1;
            a[u] = 69;
            A = e | 0;
            e = f | 0;
            f = o | 0;
            B = o + 4 | 0;
            C = c[l >> 2] | 0;
            l = c[m >> 2] | 0;
            m = x;
            x = c[A >> 2] | 0;
            a: while (1) {
                do {
                    if ((x | 0) == 0) {
                        D = 1;
                        E = 0
                    } else {
                        F = c[x + 12 >> 2] | 0;
                        if ((F | 0) == (c[x + 16 >> 2] | 0)) { G = Fc[c[(c[x >> 2] | 0) + 36 >> 2] & 255](x) | 0 } else { G = c[F >> 2] | 0 }
                        if (!((G | 0) == -1)) {
                            D = 0;
                            E = x;
                            break
                        }
                        c[A >> 2] = 0;
                        D = 1;
                        E = 0
                    }
                } while (0);
                F = c[e >> 2] | 0;
                do {
                    if ((F | 0) == 0) { H = 18 } else {
                        I = c[F + 12 >> 2] | 0;
                        if ((I | 0) == (c[F + 16 >> 2] | 0)) { J = Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0 } else { J = c[I >> 2] | 0 }
                        if ((J | 0) == -1) {
                            c[e >> 2] = 0;
                            H = 18;
                            break
                        } else {
                            if (D) { K = F; break } else {
                                L = m;
                                M = F;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((H | 0) == 18) {
                    H = 0;
                    if (D) {
                        L = m;
                        M = 0;
                        break
                    } else { K = 0 }
                }
                F = a[g] | 0;
                I = (F & 1) == 0;
                if (I) { N = (F & 255) >>> 1 } else { N = c[B >> 2] | 0 }
                if (((c[p >> 2] | 0) - m | 0) == (N | 0)) {
                    if (I) {
                        O = (F & 255) >>> 1;
                        P = (F & 255) >>> 1
                    } else {
                        F = c[B >> 2] | 0;
                        O = F;
                        P = F
                    }
                    tm(o, O << 1, 0);
                    if ((a[g] & 1) == 0) { Q = 10 } else { Q = (c[f >> 2] & -2) - 1 | 0 }
                    tm(o, Q, 0);
                    if ((a[g] & 1) == 0) { R = y } else { R = c[z >> 2] | 0 }
                    c[p >> 2] = R + P;
                    S = R
                } else { S = m }
                F = E + 12 | 0;
                I = c[F >> 2] | 0;
                T = E + 16 | 0;
                if ((I | 0) == (c[T >> 2] | 0)) { U = Fc[c[(c[E >> 2] | 0) + 36 >> 2] & 255](E) | 0 } else { U = c[I >> 2] | 0 }
                if (($o(U, t, u, S, p, C, l, n, w, r, s, v) | 0) != 0) {
                    L = S;
                    M = K;
                    break
                }
                I = c[F >> 2] | 0;
                if ((I | 0) == (c[T >> 2] | 0)) {
                    Fc[c[(c[E >> 2] | 0) + 40 >> 2] & 255](E) | 0;
                    m = S;
                    x = E;
                    continue
                } else {
                    c[F >> 2] = I + 4;
                    m = S;
                    x = E;
                    continue
                }
            }
            x = a[n] | 0;
            if ((x & 1) == 0) { V = (x & 255) >>> 1 } else { V = c[n + 4 >> 2] | 0 }
            do {
                if ((V | 0) != 0) {
                    if ((a[t] | 0) == 0) { break }
                    x = c[r >> 2] | 0;
                    if ((x - q | 0) >= 160) { break }
                    S = c[s >> 2] | 0;
                    c[r >> 2] = x + 4;
                    c[x >> 2] = S
                }
            } while (0);
            W = +Kt(L, c[p >> 2] | 0, j);
            h[k >> 3] = W;
            hr(n, w, c[r >> 2] | 0, j);
            do {
                if ((E | 0) == 0) {
                    X = 1;
                    Y = 0
                } else {
                    r = c[E + 12 >> 2] | 0;
                    if ((r | 0) == (c[E + 16 >> 2] | 0)) { Z = Fc[c[(c[E >> 2] | 0) + 36 >> 2] & 255](E) | 0 } else { Z = c[r >> 2] | 0 }
                    if (!((Z | 0) == -1)) {
                        X = 0;
                        Y = E;
                        break
                    }
                    c[A >> 2] = 0;
                    X = 1;
                    Y = 0
                }
            } while (0);
            do {
                if ((M | 0) == 0) { H = 64 } else {
                    A = c[M + 12 >> 2] | 0;
                    if ((A | 0) == (c[M + 16 >> 2] | 0)) { _ = Fc[c[(c[M >> 2] | 0) + 36 >> 2] & 255](M) | 0 } else { _ = c[A >> 2] | 0 }
                    if ((_ | 0) == -1) {
                        c[e >> 2] = 0;
                        H = 64;
                        break
                    }
                    if (!X) { break }
                    $ = b | 0;
                    c[$ >> 2] = Y;
                    aa = 160;
                    ba = 0;
                    rm(o);
                    rm(n);
                    ca = 128;
                    da = 0;
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((H | 0) == 64) {
                    if (X) { break }
                    $ = b | 0;
                    c[$ >> 2] = Y;
                    aa = 160;
                    ba = 0;
                    rm(o);
                    rm(n);
                    ca = 128;
                    da = 0;
                    i = d;
                    return
                }
            } while (0);
            c[j >> 2] = c[j >> 2] | 2;
            $ = b | 0;
            c[$ >> 2] = Y;
            aa = 160;
            ba = 0;
            rm(o);
            rm(n);
            ca = 128;
            da = 0;
            i = d;
            return
        }

        function So(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0;
            b = i;
            i = i + 16 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            c[j >> 2] = c[d >> 2];
            c[k >> 2] = c[e >> 2];
            To(a, 0, j, k, f, g, h);
            i = b;
            return
        }

        function To(b, d, e, f, g, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0.0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0;
            d = i;
            i = i + 376 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d + 128 | 0;
            m = d + 136 | 0;
            n = d + 144 | 0;
            o = d + 160 | 0;
            p = d + 176 | 0;
            q = d + 184 | 0;
            r = d + 344 | 0;
            s = d + 352 | 0;
            t = d + 360 | 0;
            u = d + 368 | 0;
            v = d | 0;
            _o(n, g, v, l, m);
            g = o;
            dv(g | 0, 0, 12) | 0;
            tm(o, 10, 0);
            if ((a[g] & 1) == 0) {
                w = o + 1 | 0;
                x = w;
                y = w;
                z = o + 8 | 0
            } else {
                w = o + 8 | 0;
                x = c[w >> 2] | 0;
                y = o + 1 | 0;
                z = w
            }
            c[p >> 2] = x;
            w = q | 0;
            c[r >> 2] = w;
            c[s >> 2] = 0;
            a[t] = 1;
            a[u] = 69;
            A = e | 0;
            e = f | 0;
            f = o | 0;
            B = o + 4 | 0;
            C = c[l >> 2] | 0;
            l = c[m >> 2] | 0;
            m = x;
            x = c[A >> 2] | 0;
            a: while (1) {
                do {
                    if ((x | 0) == 0) {
                        D = 1;
                        E = 0
                    } else {
                        F = c[x + 12 >> 2] | 0;
                        if ((F | 0) == (c[x + 16 >> 2] | 0)) { G = Fc[c[(c[x >> 2] | 0) + 36 >> 2] & 255](x) | 0 } else { G = c[F >> 2] | 0 }
                        if (!((G | 0) == -1)) {
                            D = 0;
                            E = x;
                            break
                        }
                        c[A >> 2] = 0;
                        D = 1;
                        E = 0
                    }
                } while (0);
                F = c[e >> 2] | 0;
                do {
                    if ((F | 0) == 0) { H = 18 } else {
                        I = c[F + 12 >> 2] | 0;
                        if ((I | 0) == (c[F + 16 >> 2] | 0)) { J = Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0 } else { J = c[I >> 2] | 0 }
                        if ((J | 0) == -1) {
                            c[e >> 2] = 0;
                            H = 18;
                            break
                        } else {
                            if (D) { K = F; break } else {
                                L = m;
                                M = F;
                                break a
                            }
                        }
                    }
                } while (0);
                if ((H | 0) == 18) {
                    H = 0;
                    if (D) {
                        L = m;
                        M = 0;
                        break
                    } else { K = 0 }
                }
                F = a[g] | 0;
                I = (F & 1) == 0;
                if (I) { N = (F & 255) >>> 1 } else { N = c[B >> 2] | 0 }
                if (((c[p >> 2] | 0) - m | 0) == (N | 0)) {
                    if (I) {
                        O = (F & 255) >>> 1;
                        P = (F & 255) >>> 1
                    } else {
                        F = c[B >> 2] | 0;
                        O = F;
                        P = F
                    }
                    tm(o, O << 1, 0);
                    if ((a[g] & 1) == 0) { Q = 10 } else { Q = (c[f >> 2] & -2) - 1 | 0 }
                    tm(o, Q, 0);
                    if ((a[g] & 1) == 0) { R = y } else { R = c[z >> 2] | 0 }
                    c[p >> 2] = R + P;
                    S = R
                } else { S = m }
                F = E + 12 | 0;
                I = c[F >> 2] | 0;
                T = E + 16 | 0;
                if ((I | 0) == (c[T >> 2] | 0)) { U = Fc[c[(c[E >> 2] | 0) + 36 >> 2] & 255](E) | 0 } else { U = c[I >> 2] | 0 }
                if (($o(U, t, u, S, p, C, l, n, w, r, s, v) | 0) != 0) {
                    L = S;
                    M = K;
                    break
                }
                I = c[F >> 2] | 0;
                if ((I | 0) == (c[T >> 2] | 0)) {
                    Fc[c[(c[E >> 2] | 0) + 40 >> 2] & 255](E) | 0;
                    m = S;
                    x = E;
                    continue
                } else {
                    c[F >> 2] = I + 4;
                    m = S;
                    x = E;
                    continue
                }
            }
            x = a[n] | 0;
            if ((x & 1) == 0) { V = (x & 255) >>> 1 } else { V = c[n + 4 >> 2] | 0 }
            do {
                if ((V | 0) != 0) {
                    if ((a[t] | 0) == 0) { break }
                    x = c[r >> 2] | 0;
                    if ((x - q | 0) >= 160) { break }
                    S = c[s >> 2] | 0;
                    c[r >> 2] = x + 4;
                    c[x >> 2] = S
                }
            } while (0);
            W = +Jt(L, c[p >> 2] | 0, j);
            h[k >> 3] = W;
            hr(n, w, c[r >> 2] | 0, j);
            do {
                if ((E | 0) == 0) {
                    X = 1;
                    Y = 0
                } else {
                    r = c[E + 12 >> 2] | 0;
                    if ((r | 0) == (c[E + 16 >> 2] | 0)) { Z = Fc[c[(c[E >> 2] | 0) + 36 >> 2] & 255](E) | 0 } else { Z = c[r >> 2] | 0 }
                    if (!((Z | 0) == -1)) {
                        X = 0;
                        Y = E;
                        break
                    }
                    c[A >> 2] = 0;
                    X = 1;
                    Y = 0
                }
            } while (0);
            do {
                if ((M | 0) == 0) { H = 64 } else {
                    A = c[M + 12 >> 2] | 0;
                    if ((A | 0) == (c[M + 16 >> 2] | 0)) { _ = Fc[c[(c[M >> 2] | 0) + 36 >> 2] & 255](M) | 0 } else { _ = c[A >> 2] | 0 }
                    if ((_ | 0) == -1) {
                        c[e >> 2] = 0;
                        H = 64;
                        break
                    }
                    if (!X) { break }
                    $ = b | 0;
                    c[$ >> 2] = Y;
                    aa = 160;
                    ba = 0;
                    rm(o);
                    rm(n);
                    ca = 128;
                    da = 0;
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((H | 0) == 64) {
                    if (X) { break }
                    $ = b | 0;
                    c[$ >> 2] = Y;
                    aa = 160;
                    ba = 0;
                    rm(o);
                    rm(n);
                    ca = 128;
                    da = 0;
                    i = d;
                    return
                }
            } while (0);
            c[j >> 2] = c[j >> 2] | 2;
            $ = b | 0;
            c[$ >> 2] = Y;
            aa = 160;
            ba = 0;
            rm(o);
            rm(n);
            ca = 128;
            da = 0;
            i = d;
            return
        }

        function Uo(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0;
            d = i;
            i = i + 344 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 16 | 0;
            m = d + 120 | 0;
            n = d + 136 | 0;
            o = d + 144 | 0;
            p = d + 160 | 0;
            q = d + 168 | 0;
            r = d + 328 | 0;
            s = d + 336 | 0;
            dv(m | 0, 0, 12) | 0;
            Lm(n, g);
            g = n | 0;
            n = c[g >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[k >> 2] = 34856;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34856, k, 114)
            }
            k = (c[8715] | 0) - 1 | 0;
            t = c[n + 8 >> 2] | 0;
            do {
                if ((c[n + 12 >> 2] | 0) - t >> 2 >>> 0 > k >>> 0) {
                    u = c[t + (k << 2) >> 2] | 0;
                    if ((u | 0) == 0) { break }
                    v = l | 0;
                    Sc[c[(c[u >> 2] | 0) + 48 >> 2] & 15](u, 27208, 27234, v) | 0;
                    Ul(c[g >> 2] | 0) | 0;
                    u = o;
                    dv(u | 0, 0, 12) | 0;
                    tm(o, 10, 0);
                    if ((a[u] & 1) == 0) {
                        w = o + 1 | 0;
                        x = w;
                        y = w;
                        z = o + 8 | 0
                    } else {
                        w = o + 8 | 0;
                        x = c[w >> 2] | 0;
                        y = o + 1 | 0;
                        z = w
                    }
                    c[p >> 2] = x;
                    w = q | 0;
                    c[r >> 2] = w;
                    c[s >> 2] = 0;
                    A = e | 0;
                    B = f | 0;
                    C = o | 0;
                    D = o + 4 | 0;
                    E = x;
                    F = c[A >> 2] | 0;
                    a: while (1) {
                        do {
                            if ((F | 0) == 0) {
                                G = 1;
                                H = 0
                            } else {
                                I = c[F + 12 >> 2] | 0;
                                if ((I | 0) == (c[F + 16 >> 2] | 0)) { J = Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0 } else { J = c[I >> 2] | 0 }
                                if (!((J | 0) == -1)) {
                                    G = 0;
                                    H = F;
                                    break
                                }
                                c[A >> 2] = 0;
                                G = 1;
                                H = 0
                            }
                        } while (0);
                        I = c[B >> 2] | 0;
                        do {
                            if ((I | 0) == 0) { K = 26 } else {
                                L = c[I + 12 >> 2] | 0;
                                if ((L | 0) == (c[I + 16 >> 2] | 0)) { M = Fc[c[(c[I >> 2] | 0) + 36 >> 2] & 255](I) | 0 } else { M = c[L >> 2] | 0 }
                                if ((M | 0) == -1) {
                                    c[B >> 2] = 0;
                                    K = 26;
                                    break
                                } else { if (G) { break } else { N = E; break a } }
                            }
                        } while (0);
                        if ((K | 0) == 26) { K = 0; if (G) { N = E; break } }
                        I = a[u] | 0;
                        L = (I & 1) == 0;
                        if (L) { O = (I & 255) >>> 1 } else { O = c[D >> 2] | 0 }
                        if (((c[p >> 2] | 0) - E | 0) == (O | 0)) {
                            if (L) {
                                P = (I & 255) >>> 1;
                                Q = (I & 255) >>> 1
                            } else {
                                I = c[D >> 2] | 0;
                                P = I;
                                Q = I
                            }
                            tm(o, P << 1, 0);
                            if ((a[u] & 1) == 0) { R = 10 } else { R = (c[C >> 2] & -2) - 1 | 0 }
                            tm(o, R, 0);
                            if ((a[u] & 1) == 0) { S = y } else { S = c[z >> 2] | 0 }
                            c[p >> 2] = S + Q;
                            T = S
                        } else { T = E }
                        I = H + 12 | 0;
                        L = c[I >> 2] | 0;
                        U = H + 16 | 0;
                        if ((L | 0) == (c[U >> 2] | 0)) { V = Fc[c[(c[H >> 2] | 0) + 36 >> 2] & 255](H) | 0 } else { V = c[L >> 2] | 0 }
                        if ((Vo(V, 16, T, p, s, 0, m, w, r, v) | 0) != 0) { N = T; break }
                        L = c[I >> 2] | 0;
                        if ((L | 0) == (c[U >> 2] | 0)) {
                            Fc[c[(c[H >> 2] | 0) + 40 >> 2] & 255](H) | 0;
                            E = T;
                            F = H;
                            continue
                        } else {
                            c[I >> 2] = L + 4;
                            E = T;
                            F = H;
                            continue
                        }
                    }
                    a[N + 3 | 0] = 0;
                    do {
                        if ((a[51808] | 0) == 0) {
                            if ((ub(51808) | 0) == 0) { break }
                            F = Xa(2147483647, 14472, 0) | 0;
                            c[8330] = F
                        }
                    } while (0);
                    F = xo(N, c[8330] | 0, 11744, (E = i, i = i + 8 | 0, c[E >> 2] = j, E) | 0) | 0;
                    i = E;
                    if ((F | 0) != 1) { c[h >> 2] = 4 }
                    F = c[A >> 2] | 0;
                    do {
                        if ((F | 0) == 0) {
                            W = 1;
                            X = 0
                        } else {
                            E = c[F + 12 >> 2] | 0;
                            if ((E | 0) == (c[F + 16 >> 2] | 0)) { Y = Fc[c[(c[F >> 2] | 0) + 36 >> 2] & 255](F) | 0 } else { Y = c[E >> 2] | 0 }
                            if (!((Y | 0) == -1)) {
                                W = 0;
                                X = F;
                                break
                            }
                            c[A >> 2] = 0;
                            W = 1;
                            X = 0
                        }
                    } while (0);
                    A = c[B >> 2] | 0;
                    do {
                        if ((A | 0) == 0) { K = 74 } else {
                            F = c[A + 12 >> 2] | 0;
                            if ((F | 0) == (c[A + 16 >> 2] | 0)) { Z = Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0 } else { Z = c[F >> 2] | 0 }
                            if ((Z | 0) == -1) {
                                c[B >> 2] = 0;
                                K = 74;
                                break
                            }
                            if (!W) { break }
                            _ = b | 0;
                            c[_ >> 2] = X;
                            $ = 160;
                            aa = 0;
                            rm(o);
                            rm(m);
                            ba = 104;
                            ca = 0;
                            i = d;
                            return
                        }
                    } while (0);
                    do {
                        if ((K | 0) == 74) {
                            if (W) { break }
                            _ = b | 0;
                            c[_ >> 2] = X;
                            $ = 160;
                            aa = 0;
                            rm(o);
                            rm(m);
                            ba = 104;
                            ca = 0;
                            i = d;
                            return
                        }
                    } while (0);
                    c[h >> 2] = c[h >> 2] | 2;
                    _ = b | 0;
                    c[_ >> 2] = X;
                    $ = 160;
                    aa = 0;
                    rm(o);
                    rm(m);
                    ba = 104;
                    ca = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function Vo(b, d, e, f, g, h, i, j, k, l) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            m = c[f >> 2] | 0;
            n = (m | 0) == (e | 0);
            do {
                if (n) {
                    o = (c[l + 96 >> 2] | 0) == (b | 0);
                    if (!o) { if ((c[l + 100 >> 2] | 0) != (b | 0)) { break } }
                    c[f >> 2] = e + 1;
                    a[e] = o ? 43 : 45;
                    c[g >> 2] = 0;
                    p = 0;
                    return p | 0
                }
            } while (0);
            o = a[i] | 0;
            if ((o & 1) == 0) { q = (o & 255) >>> 1 } else { q = c[i + 4 >> 2] | 0 }
            if ((q | 0) != 0 & (b | 0) == (h | 0)) {
                h = c[k >> 2] | 0;
                if ((h - j | 0) >= 160) { p = 0; return p | 0 }
                j = c[g >> 2] | 0;
                c[k >> 2] = h + 4;
                c[h >> 2] = j;
                c[g >> 2] = 0;
                p = 0;
                return p | 0
            }
            j = l + 104 | 0;
            h = l;
            while (1) { k = h + 4 | 0; if ((c[h >> 2] | 0) == (b | 0)) { r = h; break } if ((k | 0) == (j | 0)) { r = j; break } else { h = k } }
            h = r - l | 0;
            l = h >> 2;
            if ((h | 0) > 92) { p = -1; return p | 0 }
            do {
                if ((d | 0) == 8 | (d | 0) == 10) { if ((l | 0) < (d | 0)) { break } else { p = -1 } return p | 0 } else if ((d | 0) == 16) {
                    if ((h | 0) < 88) { break }
                    if (n) { p = -1; return p | 0 }
                    if ((m - e | 0) >= 3) { p = -1; return p | 0 }
                    if ((a[m - 1 | 0] | 0) != 48) { p = -1; return p | 0 }
                    c[g >> 2] = 0;
                    r = a[27208 + l | 0] | 0;
                    c[f >> 2] = m + 1;
                    a[m] = r;
                    p = 0;
                    return p | 0
                }
            } while (0);
            e = a[27208 + l | 0] | 0;
            c[f >> 2] = m + 1;
            a[m] = e;
            c[g >> 2] = (c[g >> 2] | 0) + 1;
            p = 0;
            return p | 0
        }

        function Wo(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            g = i;
            i = i + 40 | 0;
            h = g | 0;
            j = g + 16 | 0;
            k = g + 32 | 0;
            Lm(k, d);
            d = k | 0;
            k = c[d >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[j >> 2] = 34864;
                c[j + 4 >> 2] = 16;
                c[j + 8 >> 2] = 0;
                mm(34864, j, 114)
            }
            j = (c[8717] | 0) - 1 | 0;
            l = c[k + 8 >> 2] | 0;
            do {
                if ((c[k + 12 >> 2] | 0) - l >> 2 >>> 0 > j >>> 0) {
                    m = c[l + (j << 2) >> 2] | 0;
                    if ((m | 0) == 0) { break }
                    Sc[c[(c[m >> 2] | 0) + 32 >> 2] & 15](m, 27208, 27234, e) | 0;
                    m = c[d >> 2] | 0;
                    if (!((c[8620] | 0) == -1)) {
                        c[h >> 2] = 34480;
                        c[h + 4 >> 2] = 16;
                        c[h + 8 >> 2] = 0;
                        mm(34480, h, 114)
                    }
                    n = (c[8621] | 0) - 1 | 0;
                    o = c[m + 8 >> 2] | 0;
                    do {
                        if ((c[m + 12 >> 2] | 0) - o >> 2 >>> 0 > n >>> 0) {
                            p = c[o + (n << 2) >> 2] | 0;
                            if ((p | 0) == 0) { break }
                            q = p;
                            r = Fc[c[(c[p >> 2] | 0) + 16 >> 2] & 255](q) | 0;
                            a[f] = r;
                            Ec[c[(c[p >> 2] | 0) + 20 >> 2] & 127](b, q);
                            Ul(c[d >> 2] | 0) | 0;
                            i = g;
                            return
                        }
                    } while (0);
                    n = pc(4) | 0;
                    lu(n);
                    Fb(n | 0, 25544, 156)
                }
            } while (0);
            g = pc(4) | 0;
            lu(g);
            Fb(g | 0, 25544, 156)
        }

        function Xo(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0;
            h = i;
            i = i + 40 | 0;
            j = h | 0;
            k = h + 16 | 0;
            l = h + 32 | 0;
            Lm(l, d);
            d = l | 0;
            l = c[d >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[k >> 2] = 34864;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34864, k, 114)
            }
            k = (c[8717] | 0) - 1 | 0;
            m = c[l + 8 >> 2] | 0;
            do {
                if ((c[l + 12 >> 2] | 0) - m >> 2 >>> 0 > k >>> 0) {
                    n = c[m + (k << 2) >> 2] | 0;
                    if ((n | 0) == 0) { break }
                    Sc[c[(c[n >> 2] | 0) + 32 >> 2] & 15](n, 27208, 27240, e) | 0;
                    n = c[d >> 2] | 0;
                    if (!((c[8620] | 0) == -1)) {
                        c[j >> 2] = 34480;
                        c[j + 4 >> 2] = 16;
                        c[j + 8 >> 2] = 0;
                        mm(34480, j, 114)
                    }
                    o = (c[8621] | 0) - 1 | 0;
                    p = c[n + 8 >> 2] | 0;
                    do {
                        if ((c[n + 12 >> 2] | 0) - p >> 2 >>> 0 > o >>> 0) {
                            q = c[p + (o << 2) >> 2] | 0;
                            if ((q | 0) == 0) { break }
                            r = q;
                            s = q;
                            t = Fc[c[(c[s >> 2] | 0) + 12 >> 2] & 255](r) | 0;
                            a[f] = t;
                            t = Fc[c[(c[s >> 2] | 0) + 16 >> 2] & 255](r) | 0;
                            a[g] = t;
                            Ec[c[(c[q >> 2] | 0) + 20 >> 2] & 127](b, r);
                            Ul(c[d >> 2] | 0) | 0;
                            i = h;
                            return
                        }
                    } while (0);
                    o = pc(4) | 0;
                    lu(o);
                    Fb(o | 0, 25544, 156)
                }
            } while (0);
            h = pc(4) | 0;
            lu(h);
            Fb(h | 0, 25544, 156)
        }

        function Yo(b, d, e, f, g, h, i, j, k, l, m, n) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            var o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            if (b << 24 >> 24 == h << 24 >> 24) {
                if ((a[d] | 0) == 0) { o = -1; return o | 0 }
                a[d] = 0;
                h = c[g >> 2] | 0;
                c[g >> 2] = h + 1;
                a[h] = 46;
                h = a[j] | 0;
                if ((h & 1) == 0) { p = (h & 255) >>> 1 } else { p = c[j + 4 >> 2] | 0 }
                if ((p | 0) == 0) { o = 0; return o | 0 }
                p = c[l >> 2] | 0;
                if ((p - k | 0) >= 160) { o = 0; return o | 0 }
                h = c[m >> 2] | 0;
                c[l >> 2] = p + 4;
                c[p >> 2] = h;
                o = 0;
                return o | 0
            }
            do {
                if (b << 24 >> 24 == i << 24 >> 24) {
                    h = a[j] | 0;
                    if ((h & 1) == 0) { q = (h & 255) >>> 1 } else { q = c[j + 4 >> 2] | 0 }
                    if ((q | 0) == 0) { break }
                    if ((a[d] | 0) == 0) { o = -1; return o | 0 }
                    h = c[l >> 2] | 0;
                    if ((h - k | 0) >= 160) { o = 0; return o | 0 }
                    p = c[m >> 2] | 0;
                    c[l >> 2] = h + 4;
                    c[h >> 2] = p;
                    c[m >> 2] = 0;
                    o = 0;
                    return o | 0
                }
            } while (0);
            q = n + 32 | 0;
            i = n;
            while (1) { p = i + 1 | 0; if ((a[i] | 0) == b << 24 >> 24) { r = i; break } if ((p | 0) == (q | 0)) { r = q; break } else { i = p } }
            i = r - n | 0;
            if ((i | 0) > 31) { o = -1; return o | 0 }
            n = a[27208 + i | 0] | 0;
            if ((i | 0) == 25 | (i | 0) == 24) {
                r = c[g >> 2] | 0;
                do { if ((r | 0) != (f | 0)) { if ((a[r - 1 | 0] & 95 | 0) == (a[e] & 127 | 0)) { break } else { o = -1 } return o | 0 } } while (0);
                c[g >> 2] = r + 1;
                a[r] = n;
                o = 0;
                return o | 0
            } else if ((i | 0) == 22 | (i | 0) == 23) {
                a[e] = 80;
                r = c[g >> 2] | 0;
                c[g >> 2] = r + 1;
                a[r] = n;
                o = 0;
                return o | 0
            } else {
                r = a[e] | 0;
                do {
                    if ((n & 95 | 0) == (r << 24 >> 24 | 0)) {
                        a[e] = r | -128;
                        if ((a[d] | 0) == 0) { break }
                        a[d] = 0;
                        f = a[j] | 0;
                        if ((f & 1) == 0) { s = (f & 255) >>> 1 } else { s = c[j + 4 >> 2] | 0 }
                        if ((s | 0) == 0) { break }
                        f = c[l >> 2] | 0;
                        if ((f - k | 0) >= 160) { break }
                        q = c[m >> 2] | 0;
                        c[l >> 2] = f + 4;
                        c[f >> 2] = q
                    }
                } while (0);
                l = c[g >> 2] | 0;
                c[g >> 2] = l + 1;
                a[l] = n;
                if ((i | 0) > 21) { o = 0; return o | 0 }
                c[m >> 2] = (c[m >> 2] | 0) + 1;
                o = 0;
                return o | 0
            }
            return 0
        }

        function Zo(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            f = i;
            i = i + 40 | 0;
            g = f | 0;
            h = f + 16 | 0;
            j = f + 32 | 0;
            Lm(j, b);
            b = j | 0;
            j = c[b >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[h >> 2] = 34856;
                c[h + 4 >> 2] = 16;
                c[h + 8 >> 2] = 0;
                mm(34856, h, 114)
            }
            h = (c[8715] | 0) - 1 | 0;
            k = c[j + 8 >> 2] | 0;
            do {
                if ((c[j + 12 >> 2] | 0) - k >> 2 >>> 0 > h >>> 0) {
                    l = c[k + (h << 2) >> 2] | 0;
                    if ((l | 0) == 0) { break }
                    Sc[c[(c[l >> 2] | 0) + 48 >> 2] & 15](l, 27208, 27234, d) | 0;
                    l = c[b >> 2] | 0;
                    if (!((c[8618] | 0) == -1)) {
                        c[g >> 2] = 34472;
                        c[g + 4 >> 2] = 16;
                        c[g + 8 >> 2] = 0;
                        mm(34472, g, 114)
                    }
                    m = (c[8619] | 0) - 1 | 0;
                    n = c[l + 8 >> 2] | 0;
                    do {
                        if ((c[l + 12 >> 2] | 0) - n >> 2 >>> 0 > m >>> 0) {
                            o = c[n + (m << 2) >> 2] | 0;
                            if ((o | 0) == 0) { break }
                            p = o;
                            q = Fc[c[(c[o >> 2] | 0) + 16 >> 2] & 255](p) | 0;
                            c[e >> 2] = q;
                            Ec[c[(c[o >> 2] | 0) + 20 >> 2] & 127](a, p);
                            Ul(c[b >> 2] | 0) | 0;
                            i = f;
                            return
                        }
                    } while (0);
                    m = pc(4) | 0;
                    lu(m);
                    Fb(m | 0, 25544, 156)
                }
            } while (0);
            f = pc(4) | 0;
            lu(f);
            Fb(f | 0, 25544, 156)
        }

        function _o(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            g = i;
            i = i + 40 | 0;
            h = g | 0;
            j = g + 16 | 0;
            k = g + 32 | 0;
            Lm(k, b);
            b = k | 0;
            k = c[b >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[j >> 2] = 34856;
                c[j + 4 >> 2] = 16;
                c[j + 8 >> 2] = 0;
                mm(34856, j, 114)
            }
            j = (c[8715] | 0) - 1 | 0;
            l = c[k + 8 >> 2] | 0;
            do {
                if ((c[k + 12 >> 2] | 0) - l >> 2 >>> 0 > j >>> 0) {
                    m = c[l + (j << 2) >> 2] | 0;
                    if ((m | 0) == 0) { break }
                    Sc[c[(c[m >> 2] | 0) + 48 >> 2] & 15](m, 27208, 27240, d) | 0;
                    m = c[b >> 2] | 0;
                    if (!((c[8618] | 0) == -1)) {
                        c[h >> 2] = 34472;
                        c[h + 4 >> 2] = 16;
                        c[h + 8 >> 2] = 0;
                        mm(34472, h, 114)
                    }
                    n = (c[8619] | 0) - 1 | 0;
                    o = c[m + 8 >> 2] | 0;
                    do {
                        if ((c[m + 12 >> 2] | 0) - o >> 2 >>> 0 > n >>> 0) {
                            p = c[o + (n << 2) >> 2] | 0;
                            if ((p | 0) == 0) { break }
                            q = p;
                            r = p;
                            s = Fc[c[(c[r >> 2] | 0) + 12 >> 2] & 255](q) | 0;
                            c[e >> 2] = s;
                            s = Fc[c[(c[r >> 2] | 0) + 16 >> 2] & 255](q) | 0;
                            c[f >> 2] = s;
                            Ec[c[(c[p >> 2] | 0) + 20 >> 2] & 127](a, q);
                            Ul(c[b >> 2] | 0) | 0;
                            i = g;
                            return
                        }
                    } while (0);
                    n = pc(4) | 0;
                    lu(n);
                    Fb(n | 0, 25544, 156)
                }
            } while (0);
            g = pc(4) | 0;
            lu(g);
            Fb(g | 0, 25544, 156)
        }

        function $o(b, d, e, f, g, h, i, j, k, l, m, n) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            var o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            if ((b | 0) == (h | 0)) {
                if ((a[d] | 0) == 0) { o = -1; return o | 0 }
                a[d] = 0;
                h = c[g >> 2] | 0;
                c[g >> 2] = h + 1;
                a[h] = 46;
                h = a[j] | 0;
                if ((h & 1) == 0) { p = (h & 255) >>> 1 } else { p = c[j + 4 >> 2] | 0 }
                if ((p | 0) == 0) { o = 0; return o | 0 }
                p = c[l >> 2] | 0;
                if ((p - k | 0) >= 160) { o = 0; return o | 0 }
                h = c[m >> 2] | 0;
                c[l >> 2] = p + 4;
                c[p >> 2] = h;
                o = 0;
                return o | 0
            }
            do {
                if ((b | 0) == (i | 0)) {
                    h = a[j] | 0;
                    if ((h & 1) == 0) { q = (h & 255) >>> 1 } else { q = c[j + 4 >> 2] | 0 }
                    if ((q | 0) == 0) { break }
                    if ((a[d] | 0) == 0) { o = -1; return o | 0 }
                    h = c[l >> 2] | 0;
                    if ((h - k | 0) >= 160) { o = 0; return o | 0 }
                    p = c[m >> 2] | 0;
                    c[l >> 2] = h + 4;
                    c[h >> 2] = p;
                    c[m >> 2] = 0;
                    o = 0;
                    return o | 0
                }
            } while (0);
            q = n + 128 | 0;
            i = n;
            while (1) { p = i + 4 | 0; if ((c[i >> 2] | 0) == (b | 0)) { r = i; break } if ((p | 0) == (q | 0)) { r = q; break } else { i = p } }
            i = r - n | 0;
            n = i >> 2;
            if ((i | 0) > 124) { o = -1; return o | 0 }
            r = a[27208 + n | 0] | 0;
            do {
                if ((n | 0) == 25 | (n | 0) == 24) {
                    q = c[g >> 2] | 0;
                    do { if ((q | 0) != (f | 0)) { if ((a[q - 1 | 0] & 95 | 0) == (a[e] & 127 | 0)) { break } else { o = -1 } return o | 0 } } while (0);
                    c[g >> 2] = q + 1;
                    a[q] = r;
                    o = 0;
                    return o | 0
                } else if ((n | 0) == 22 | (n | 0) == 23) { a[e] = 80 } else {
                    b = a[e] | 0;
                    if ((r & 95 | 0) != (b << 24 >> 24 | 0)) { break }
                    a[e] = b | -128;
                    if ((a[d] | 0) == 0) { break }
                    a[d] = 0;
                    b = a[j] | 0;
                    if ((b & 1) == 0) { s = (b & 255) >>> 1 } else { s = c[j + 4 >> 2] | 0 }
                    if ((s | 0) == 0) { break }
                    b = c[l >> 2] | 0;
                    if ((b - k | 0) >= 160) { break }
                    p = c[m >> 2] | 0;
                    c[l >> 2] = b + 4;
                    c[b >> 2] = p
                }
            } while (0);
            l = c[g >> 2] | 0;
            c[g >> 2] = l + 1;
            a[l] = r;
            if ((i | 0) > 84) { o = 0; return o | 0 }
            c[m >> 2] = (c[m >> 2] | 0) + 1;
            o = 0;
            return o | 0
        }

        function ap(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function bp(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function cp(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0;
            j = i;
            i = i + 48 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = j | 0;
            l = j + 16 | 0;
            m = j + 24 | 0;
            n = j + 32 | 0;
            if ((c[f + 4 >> 2] & 1 | 0) == 0) {
                o = c[(c[d >> 2] | 0) + 24 >> 2] | 0;
                c[l >> 2] = c[e >> 2];
                Kc[o & 63](b, d, l, f, g, h & 1);
                i = j;
                return
            }
            Lm(m, f);
            f = m | 0;
            m = c[f >> 2] | 0;
            if (!((c[8620] | 0) == -1)) {
                c[k >> 2] = 34480;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34480, k, 114)
            }
            k = (c[8621] | 0) - 1 | 0;
            g = c[m + 8 >> 2] | 0;
            do {
                if ((c[m + 12 >> 2] | 0) - g >> 2 >>> 0 > k >>> 0) {
                    l = c[g + (k << 2) >> 2] | 0;
                    if ((l | 0) == 0) { break }
                    d = l;
                    Ul(c[f >> 2] | 0) | 0;
                    o = c[l >> 2] | 0;
                    if (h) { Ec[c[o + 24 >> 2] & 127](n, d) } else { Ec[c[o + 28 >> 2] & 127](n, d) }
                    d = n;
                    o = a[d] | 0;
                    if ((o & 1) == 0) {
                        l = n + 1 | 0;
                        p = l;
                        q = l;
                        r = n + 8 | 0
                    } else {
                        l = n + 8 | 0;
                        p = c[l >> 2] | 0;
                        q = n + 1 | 0;
                        r = l
                    }
                    l = e | 0;
                    s = n + 4 | 0;
                    t = p;
                    u = o;
                    while (1) {
                        if ((u & 1) == 0) {
                            v = (u & 255) >>> 1;
                            w = q
                        } else {
                            v = c[s >> 2] | 0;
                            w = c[r >> 2] | 0
                        }
                        if ((t | 0) == (w + v | 0)) { break }
                        o = a[t] | 0;
                        x = c[l >> 2] | 0;
                        do {
                            if ((x | 0) != 0) {
                                y = x + 24 | 0;
                                z = c[y >> 2] | 0;
                                if ((z | 0) != (c[x + 28 >> 2] | 0)) {
                                    c[y >> 2] = z + 1;
                                    a[z] = o;
                                    break
                                }
                                if (!((Qc[c[(c[x >> 2] | 0) + 52 >> 2] & 63](x, o & 255) | 0) == -1)) { break }
                                c[l >> 2] = 0
                            }
                        } while (0);
                        t = t + 1 | 0;
                        u = a[d] | 0
                    }
                    c[b >> 2] = c[l >> 2];
                    rm(n);
                    i = j;
                    return
                }
            } while (0);
            j = pc(4) | 0;
            lu(j);
            Fb(j | 0, 25544, 156)
        }

        function dp(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            d = i;
            i = i + 80 | 0;
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = d | 0;
            k = d + 8 | 0;
            l = d + 24 | 0;
            m = d + 48 | 0;
            n = d + 56 | 0;
            o = d + 64 | 0;
            p = d + 72 | 0;
            q = j | 0;
            a[q] = a[19432] | 0;
            a[q + 1 | 0] = a[19433] | 0;
            a[q + 2 | 0] = a[19434] | 0;
            a[q + 3 | 0] = a[19435] | 0;
            a[q + 4 | 0] = a[19436] | 0;
            a[q + 5 | 0] = a[19437] | 0;
            r = j + 1 | 0;
            s = f + 4 | 0;
            t = c[s >> 2] | 0;
            if ((t & 2048 | 0) == 0) { u = r } else {
                a[r] = 43;
                u = j + 2 | 0
            }
            if ((t & 512 | 0) == 0) { v = u } else {
                a[u] = 35;
                v = u + 1 | 0
            }
            a[v] = 108;
            u = v + 1 | 0;
            v = t & 74;
            do { if ((v | 0) == 64) { a[u] = 111 } else if ((v | 0) == 8) { if ((t & 16384 | 0) == 0) { a[u] = 120; break } else { a[u] = 88; break } } else { a[u] = 100 } } while (0);
            u = k | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    t = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = t
                }
            } while (0);
            t = ep(u, 12, c[8330] | 0, q, (q = i, i = i + 8 | 0, c[q >> 2] = h, q) | 0) | 0;
            i = q;
            q = k + t | 0;
            h = c[s >> 2] & 176;
            do {
                if ((h | 0) == 32) { w = q } else if ((h | 0) == 16) {
                    s = a[u] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { w = k + 1 | 0; break }
                    if (!((t | 0) > 1 & s << 24 >> 24 == 48)) { x = 22; break }
                    s = a[k + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { x = 22; break }
                    w = k + 2 | 0
                } else { x = 22 }
            } while (0);
            if ((x | 0) == 22) { w = u }
            x = l | 0;
            Lm(o, f);
            fp(u, w, q, x, m, n, o);
            Ul(c[o >> 2] | 0) | 0;
            c[p >> 2] = c[e >> 2];
            Bd(b, p, x, c[m >> 2] | 0, c[n >> 2] | 0, f, g);
            i = d;
            return
        }

        function ep(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0;
            g = i;
            i = i + 16 | 0;
            h = g | 0;
            j = h;
            c[j >> 2] = f;
            c[j + 4 >> 2] = 0;
            j = bc(d | 0) | 0;
            d = cc(a | 0, b | 0, e | 0, h | 0) | 0;
            if ((j | 0) == 0) { i = g; return d | 0 }
            bc(j | 0) | 0;
            i = g;
            return d | 0
        }

        function fp(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0;
            k = i;
            i = i + 48 | 0;
            l = k | 0;
            m = k + 16 | 0;
            n = k + 32 | 0;
            o = j | 0;
            j = c[o >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[m >> 2] = 34864;
                c[m + 4 >> 2] = 16;
                c[m + 8 >> 2] = 0;
                mm(34864, m, 114)
            }
            m = (c[8717] | 0) - 1 | 0;
            p = c[j + 8 >> 2] | 0;
            if (!((c[j + 12 >> 2] | 0) - p >> 2 >>> 0 > m >>> 0)) {
                q = pc(4) | 0;
                r = q;
                lu(r);
                Fb(q | 0, 25544, 156)
            }
            j = c[p + (m << 2) >> 2] | 0;
            if ((j | 0) == 0) {
                q = pc(4) | 0;
                r = q;
                lu(r);
                Fb(q | 0, 25544, 156)
            }
            q = j;
            r = c[o >> 2] | 0;
            if (!((c[8620] | 0) == -1)) {
                c[l >> 2] = 34480;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34480, l, 114)
            }
            l = (c[8621] | 0) - 1 | 0;
            o = c[r + 8 >> 2] | 0;
            if (!((c[r + 12 >> 2] | 0) - o >> 2 >>> 0 > l >>> 0)) {
                s = pc(4) | 0;
                t = s;
                lu(t);
                Fb(s | 0, 25544, 156)
            }
            r = c[o + (l << 2) >> 2] | 0;
            if ((r | 0) == 0) {
                s = pc(4) | 0;
                t = s;
                lu(t);
                Fb(s | 0, 25544, 156)
            }
            s = r;
            Ec[c[(c[r >> 2] | 0) + 20 >> 2] & 127](n, s);
            t = n;
            l = a[t] | 0;
            if ((l & 1) == 0) { u = (l & 255) >>> 1 } else { u = c[n + 4 >> 2] | 0 }
            do {
                if ((u | 0) == 0) {
                    Sc[c[(c[j >> 2] | 0) + 32 >> 2] & 15](q, b, e, f) | 0;
                    c[h >> 2] = f + (e - b)
                } else {
                    c[h >> 2] = f;
                    l = a[b] | 0;
                    if ((l << 24 >> 24 | 0) == 45 | (l << 24 >> 24 | 0) == 43) {
                        o = Qc[c[(c[j >> 2] | 0) + 28 >> 2] & 63](q, l) | 0;
                        l = c[h >> 2] | 0;
                        c[h >> 2] = l + 1;
                        a[l] = o;
                        v = b + 1 | 0
                    } else { v = b }
                    do {
                        if ((e - v | 0) > 1) {
                            if ((a[v] | 0) != 48) { w = v; break }
                            o = v + 1 | 0;
                            l = a[o] | 0;
                            if (!((l << 24 >> 24 | 0) == 120 | (l << 24 >> 24 | 0) == 88)) { w = v; break }
                            l = j;
                            m = Qc[c[(c[l >> 2] | 0) + 28 >> 2] & 63](q, 48) | 0;
                            p = c[h >> 2] | 0;
                            c[h >> 2] = p + 1;
                            a[p] = m;
                            m = Qc[c[(c[l >> 2] | 0) + 28 >> 2] & 63](q, a[o] | 0) | 0;
                            o = c[h >> 2] | 0;
                            c[h >> 2] = o + 1;
                            a[o] = m;
                            w = v + 2 | 0
                        } else { w = v }
                    } while (0);
                    do {
                        if ((w | 0) != (e | 0)) {
                            m = e - 1 | 0;
                            if (m >>> 0 > w >>> 0) {
                                x = w;
                                y = m
                            } else { break }
                            do {
                                m = a[x] | 0;
                                a[x] = a[y] | 0;
                                a[y] = m;
                                x = x + 1 | 0;
                                y = y - 1 | 0;
                            } while (x >>> 0 < y >>> 0)
                        }
                    } while (0);
                    m = Fc[c[(c[r >> 2] | 0) + 16 >> 2] & 255](s) | 0;
                    if (w >>> 0 < e >>> 0) {
                        o = n + 1 | 0;
                        l = j;
                        p = n + 4 | 0;
                        z = n + 8 | 0;
                        A = 0;
                        B = 0;
                        C = w;
                        while (1) {
                            D = (a[t] & 1) == 0;
                            do {
                                if ((a[(D ? o : c[z >> 2] | 0) + B | 0] | 0) == 0) {
                                    E = B;
                                    F = A
                                } else {
                                    if ((A | 0) != (a[(D ? o : c[z >> 2] | 0) + B | 0] | 0)) {
                                        E = B;
                                        F = A;
                                        break
                                    }
                                    G = c[h >> 2] | 0;
                                    c[h >> 2] = G + 1;
                                    a[G] = m;
                                    G = a[t] | 0;
                                    if ((G & 1) == 0) { H = (G & 255) >>> 1 } else { H = c[p >> 2] | 0 }
                                    E = (B >>> 0 < (H - 1 | 0) >>> 0) + B | 0;
                                    F = 0
                                }
                            } while (0);
                            D = Qc[c[(c[l >> 2] | 0) + 28 >> 2] & 63](q, a[C] | 0) | 0;
                            G = c[h >> 2] | 0;
                            c[h >> 2] = G + 1;
                            a[G] = D;
                            D = C + 1 | 0;
                            if (D >>> 0 < e >>> 0) {
                                A = F + 1 | 0;
                                B = E;
                                C = D
                            } else { break }
                        }
                    }
                    C = f + (w - b) | 0;
                    B = c[h >> 2] | 0;
                    if ((C | 0) == (B | 0)) { break }
                    A = B - 1 | 0;
                    if (A >>> 0 > C >>> 0) {
                        I = C;
                        J = A
                    } else { break }
                    do {
                        A = a[I] | 0;
                        a[I] = a[J] | 0;
                        a[J] = A;
                        I = I + 1 | 0;
                        J = J - 1 | 0;
                    } while (I >>> 0 < J >>> 0)
                }
            } while (0);
            if ((d | 0) == (e | 0)) {
                K = c[h >> 2] | 0;
                c[g >> 2] = K;
                rm(n);
                i = k;
                return
            } else {
                K = f + (d - b) | 0;
                c[g >> 2] = K;
                rm(n);
                i = k;
                return
            }
        }

        function gp(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            d = i;
            i = i + 112 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 8 | 0;
            m = d + 32 | 0;
            n = d + 80 | 0;
            o = d + 88 | 0;
            p = d + 96 | 0;
            q = d + 104 | 0;
            c[k >> 2] = 37;
            c[k + 4 >> 2] = 0;
            r = k;
            k = r + 1 | 0;
            s = f + 4 | 0;
            t = c[s >> 2] | 0;
            if ((t & 2048 | 0) == 0) { u = k } else {
                a[k] = 43;
                u = r + 2 | 0
            }
            if ((t & 512 | 0) == 0) { v = u } else {
                a[u] = 35;
                v = u + 1 | 0
            }
            a[v] = 108;
            a[v + 1 | 0] = 108;
            u = v + 2 | 0;
            v = t & 74;
            do { if ((v | 0) == 64) { a[u] = 111 } else if ((v | 0) == 8) { if ((t & 16384 | 0) == 0) { a[u] = 120; break } else { a[u] = 88; break } } else { a[u] = 100 } } while (0);
            u = l | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    t = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = t
                }
            } while (0);
            t = ep(u, 22, c[8330] | 0, r, (r = i, i = i + 16 | 0, c[r >> 2] = h, c[r + 8 >> 2] = j, r) | 0) | 0;
            i = r;
            r = l + t | 0;
            j = c[s >> 2] & 176;
            do {
                if ((j | 0) == 32) { w = r } else if ((j | 0) == 16) {
                    s = a[u] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { w = l + 1 | 0; break }
                    if (!((t | 0) > 1 & s << 24 >> 24 == 48)) { x = 22; break }
                    s = a[l + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { x = 22; break }
                    w = l + 2 | 0
                } else { x = 22 }
            } while (0);
            if ((x | 0) == 22) { w = u }
            x = m | 0;
            Lm(p, f);
            fp(u, w, r, x, n, o, p);
            Ul(c[p >> 2] | 0) | 0;
            c[q >> 2] = c[e >> 2];
            Bd(b, q, x, c[n >> 2] | 0, c[o >> 2] | 0, f, g);
            i = d;
            return
        }

        function hp(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            d = i;
            i = i + 80 | 0;
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = d | 0;
            k = d + 8 | 0;
            l = d + 24 | 0;
            m = d + 48 | 0;
            n = d + 56 | 0;
            o = d + 64 | 0;
            p = d + 72 | 0;
            q = j | 0;
            a[q] = a[19432] | 0;
            a[q + 1 | 0] = a[19433] | 0;
            a[q + 2 | 0] = a[19434] | 0;
            a[q + 3 | 0] = a[19435] | 0;
            a[q + 4 | 0] = a[19436] | 0;
            a[q + 5 | 0] = a[19437] | 0;
            r = j + 1 | 0;
            s = f + 4 | 0;
            t = c[s >> 2] | 0;
            if ((t & 2048 | 0) == 0) { u = r } else {
                a[r] = 43;
                u = j + 2 | 0
            }
            if ((t & 512 | 0) == 0) { v = u } else {
                a[u] = 35;
                v = u + 1 | 0
            }
            a[v] = 108;
            u = v + 1 | 0;
            v = t & 74;
            do { if ((v | 0) == 64) { a[u] = 111 } else if ((v | 0) == 8) { if ((t & 16384 | 0) == 0) { a[u] = 120; break } else { a[u] = 88; break } } else { a[u] = 117 } } while (0);
            u = k | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    t = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = t
                }
            } while (0);
            t = ep(u, 12, c[8330] | 0, q, (q = i, i = i + 8 | 0, c[q >> 2] = h, q) | 0) | 0;
            i = q;
            q = k + t | 0;
            h = c[s >> 2] & 176;
            do {
                if ((h | 0) == 16) {
                    s = a[u] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { w = k + 1 | 0; break }
                    if (!((t | 0) > 1 & s << 24 >> 24 == 48)) { x = 22; break }
                    s = a[k + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { x = 22; break }
                    w = k + 2 | 0
                } else if ((h | 0) == 32) { w = q } else { x = 22 }
            } while (0);
            if ((x | 0) == 22) { w = u }
            x = l | 0;
            Lm(o, f);
            fp(u, w, q, x, m, n, o);
            Ul(c[o >> 2] | 0) | 0;
            c[p >> 2] = c[e >> 2];
            Bd(b, p, x, c[m >> 2] | 0, c[n >> 2] | 0, f, g);
            i = d;
            return
        }

        function ip(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            d = i;
            i = i + 112 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 8 | 0;
            m = d + 32 | 0;
            n = d + 80 | 0;
            o = d + 88 | 0;
            p = d + 96 | 0;
            q = d + 104 | 0;
            c[k >> 2] = 37;
            c[k + 4 >> 2] = 0;
            r = k;
            k = r + 1 | 0;
            s = f + 4 | 0;
            t = c[s >> 2] | 0;
            if ((t & 2048 | 0) == 0) { u = k } else {
                a[k] = 43;
                u = r + 2 | 0
            }
            if ((t & 512 | 0) == 0) { v = u } else {
                a[u] = 35;
                v = u + 1 | 0
            }
            a[v] = 108;
            a[v + 1 | 0] = 108;
            u = v + 2 | 0;
            v = t & 74;
            do { if ((v | 0) == 64) { a[u] = 111 } else if ((v | 0) == 8) { if ((t & 16384 | 0) == 0) { a[u] = 120; break } else { a[u] = 88; break } } else { a[u] = 117 } } while (0);
            u = l | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    t = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = t
                }
            } while (0);
            t = ep(u, 23, c[8330] | 0, r, (r = i, i = i + 16 | 0, c[r >> 2] = h, c[r + 8 >> 2] = j, r) | 0) | 0;
            i = r;
            r = l + t | 0;
            j = c[s >> 2] & 176;
            do {
                if ((j | 0) == 32) { w = r } else if ((j | 0) == 16) {
                    s = a[u] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { w = l + 1 | 0; break }
                    if (!((t | 0) > 1 & s << 24 >> 24 == 48)) { x = 22; break }
                    s = a[l + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { x = 22; break }
                    w = l + 2 | 0
                } else { x = 22 }
            } while (0);
            if ((x | 0) == 22) { w = u }
            x = m | 0;
            Lm(p, f);
            fp(u, w, r, x, n, o, p);
            Ul(c[p >> 2] | 0) | 0;
            c[q >> 2] = c[e >> 2];
            Bd(b, q, x, c[n >> 2] | 0, c[o >> 2] | 0, f, g);
            i = d;
            return
        }

        function jp(b, d, e, f, g, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = +j;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            d = i;
            i = i + 152 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 8 | 0;
            m = d + 40 | 0;
            n = d + 48 | 0;
            o = d + 112 | 0;
            p = d + 120 | 0;
            q = d + 128 | 0;
            r = d + 136 | 0;
            s = d + 144 | 0;
            c[k >> 2] = 37;
            c[k + 4 >> 2] = 0;
            t = k;
            k = t + 1 | 0;
            u = f + 4 | 0;
            v = c[u >> 2] | 0;
            if ((v & 2048 | 0) == 0) { w = k } else {
                a[k] = 43;
                w = t + 2 | 0
            }
            if ((v & 1024 | 0) == 0) { x = w } else {
                a[w] = 35;
                x = w + 1 | 0
            }
            w = v & 260;
            k = v >>> 14;
            do {
                if ((w | 0) == 260) {
                    if ((k & 1 | 0) == 0) {
                        a[x] = 97;
                        y = 0;
                        break
                    } else {
                        a[x] = 65;
                        y = 0;
                        break
                    }
                } else {
                    a[x] = 46;
                    v = x + 2 | 0;
                    a[x + 1 | 0] = 42;
                    if ((w | 0) == 4) {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 102;
                            y = 1;
                            break
                        } else {
                            a[v] = 70;
                            y = 1;
                            break
                        }
                    } else if ((w | 0) == 256) {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 101;
                            y = 1;
                            break
                        } else {
                            a[v] = 69;
                            y = 1;
                            break
                        }
                    } else {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 103;
                            y = 1;
                            break
                        } else {
                            a[v] = 71;
                            y = 1;
                            break
                        }
                    }
                }
            } while (0);
            k = l | 0;
            c[m >> 2] = k;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    l = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = l
                }
            } while (0);
            l = c[8330] | 0;
            if (y) {
                w = ep(k, 30, l, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                i = z;
                A = w
            } else {
                w = ep(k, 30, l, t, (z = i, i = i + 8 | 0, h[z >> 3] = j, z) | 0) | 0;
                i = z;
                A = w
            }
            do {
                if ((A | 0) > 29) {
                    w = (a[51808] | 0) == 0;
                    if (y) {
                        do {
                            if (w) {
                                if ((ub(51808) | 0) == 0) { break }
                                l = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = l
                            }
                        } while (0);
                        l = kp(m, c[8330] | 0, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                        i = z;
                        B = l
                    } else {
                        do {
                            if (w) {
                                if ((ub(51808) | 0) == 0) { break }
                                l = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = l
                            }
                        } while (0);
                        w = kp(m, c[8330] | 0, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                        i = z;
                        B = w
                    }
                    w = c[m >> 2] | 0;
                    if ((w | 0) != 0) {
                        C = B;
                        D = w;
                        E = w;
                        break
                    }
                    Uu();
                    w = c[m >> 2] | 0;
                    C = B;
                    D = w;
                    E = w
                } else {
                    C = A;
                    D = 0;
                    E = c[m >> 2] | 0
                }
            } while (0);
            A = E + C | 0;
            B = c[u >> 2] & 176;
            do {
                if ((B | 0) == 32) { F = A } else if ((B | 0) == 16) {
                    u = a[E] | 0;
                    if ((u << 24 >> 24 | 0) == 45 | (u << 24 >> 24 | 0) == 43) { F = E + 1 | 0; break }
                    if (!((C | 0) > 1 & u << 24 >> 24 == 48)) { G = 53; break }
                    u = a[E + 1 | 0] | 0;
                    if (!((u << 24 >> 24 | 0) == 120 | (u << 24 >> 24 | 0) == 88)) { G = 53; break }
                    F = E + 2 | 0
                } else { G = 53 }
            } while (0);
            if ((G | 0) == 53) { F = E }
            do {
                if ((E | 0) == (k | 0)) {
                    H = n | 0;
                    I = 0;
                    J = k
                } else {
                    G = Gu(C << 1) | 0;
                    if ((G | 0) != 0) {
                        H = G;
                        I = G;
                        J = E;
                        break
                    }
                    Uu();
                    H = 0;
                    I = 0;
                    J = c[m >> 2] | 0
                }
            } while (0);
            Lm(q, f);
            lp(J, F, A, H, o, p, q);
            Ul(c[q >> 2] | 0) | 0;
            q = e | 0;
            c[s >> 2] = c[q >> 2];
            Bd(r, s, H, c[o >> 2] | 0, c[p >> 2] | 0, f, g);
            g = c[r >> 2] | 0;
            c[q >> 2] = g;
            c[b >> 2] = g;
            if ((I | 0) != 0) { Hu(I) }
            if ((D | 0) == 0) { i = d; return }
            Hu(D);
            i = d;
            return
        }

        function kp(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0;
            f = i;
            i = i + 16 | 0;
            g = f | 0;
            h = g;
            c[h >> 2] = e;
            c[h + 4 >> 2] = 0;
            h = bc(b | 0) | 0;
            b = rc(a | 0, d | 0, g | 0) | 0;
            if ((h | 0) == 0) { i = f; return b | 0 }
            bc(h | 0) | 0;
            i = f;
            return b | 0
        }

        function lp(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0;
            k = i;
            i = i + 48 | 0;
            l = k | 0;
            m = k + 16 | 0;
            n = k + 32 | 0;
            o = j | 0;
            j = c[o >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[m >> 2] = 34864;
                c[m + 4 >> 2] = 16;
                c[m + 8 >> 2] = 0;
                mm(34864, m, 114)
            }
            m = (c[8717] | 0) - 1 | 0;
            p = c[j + 8 >> 2] | 0;
            if (!((c[j + 12 >> 2] | 0) - p >> 2 >>> 0 > m >>> 0)) {
                q = pc(4) | 0;
                r = q;
                lu(r);
                Fb(q | 0, 25544, 156)
            }
            j = c[p + (m << 2) >> 2] | 0;
            if ((j | 0) == 0) {
                q = pc(4) | 0;
                r = q;
                lu(r);
                Fb(q | 0, 25544, 156)
            }
            q = j;
            r = c[o >> 2] | 0;
            if (!((c[8620] | 0) == -1)) {
                c[l >> 2] = 34480;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34480, l, 114)
            }
            l = (c[8621] | 0) - 1 | 0;
            o = c[r + 8 >> 2] | 0;
            if (!((c[r + 12 >> 2] | 0) - o >> 2 >>> 0 > l >>> 0)) {
                s = pc(4) | 0;
                t = s;
                lu(t);
                Fb(s | 0, 25544, 156)
            }
            r = c[o + (l << 2) >> 2] | 0;
            if ((r | 0) == 0) {
                s = pc(4) | 0;
                t = s;
                lu(t);
                Fb(s | 0, 25544, 156)
            }
            s = r;
            Ec[c[(c[r >> 2] | 0) + 20 >> 2] & 127](n, s);
            c[h >> 2] = f;
            t = a[b] | 0;
            if ((t << 24 >> 24 | 0) == 45 | (t << 24 >> 24 | 0) == 43) {
                l = Qc[c[(c[j >> 2] | 0) + 28 >> 2] & 63](q, t) | 0;
                t = c[h >> 2] | 0;
                c[h >> 2] = t + 1;
                a[t] = l;
                u = b + 1 | 0
            } else { u = b }
            l = e;
            a: do {
                if ((l - u | 0) > 1) {
                    if ((a[u] | 0) != 48) { v = 21; break }
                    t = u + 1 | 0;
                    o = a[t] | 0;
                    if (!((o << 24 >> 24 | 0) == 120 | (o << 24 >> 24 | 0) == 88)) { v = 21; break }
                    o = j;
                    m = Qc[c[(c[o >> 2] | 0) + 28 >> 2] & 63](q, 48) | 0;
                    p = c[h >> 2] | 0;
                    c[h >> 2] = p + 1;
                    a[p] = m;
                    m = u + 2 | 0;
                    p = Qc[c[(c[o >> 2] | 0) + 28 >> 2] & 63](q, a[t] | 0) | 0;
                    t = c[h >> 2] | 0;
                    c[h >> 2] = t + 1;
                    a[t] = p;
                    if (m >>> 0 < e >>> 0) { w = m } else {
                        x = m;
                        y = m;
                        break
                    }
                    while (1) {
                        p = a[w] | 0;
                        do {
                            if ((a[51808] | 0) == 0) {
                                if ((ub(51808) | 0) == 0) { break }
                                t = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = t
                            }
                        } while (0);
                        t = w + 1 | 0;
                        if ((Ua(p << 24 >> 24 | 0, c[8330] | 0) | 0) == 0) {
                            x = m;
                            y = w;
                            break a
                        }
                        if (t >>> 0 < e >>> 0) { w = t } else {
                            x = m;
                            y = t;
                            break
                        }
                    }
                } else { v = 21 }
            } while (0);
            b: do {
                if ((v | 0) == 21) {
                    if (u >>> 0 < e >>> 0) { z = u } else {
                        x = u;
                        y = u;
                        break
                    }
                    while (1) {
                        w = a[z] | 0;
                        do {
                            if ((a[51808] | 0) == 0) {
                                if ((ub(51808) | 0) == 0) { break }
                                m = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = m
                            }
                        } while (0);
                        p = z + 1 | 0;
                        if ((ib(w << 24 >> 24 | 0, c[8330] | 0) | 0) == 0) {
                            x = u;
                            y = z;
                            break b
                        }
                        if (p >>> 0 < e >>> 0) { z = p } else {
                            x = u;
                            y = p;
                            break
                        }
                    }
                }
            } while (0);
            u = n;
            z = a[u] | 0;
            if ((z & 1) == 0) { A = (z & 255) >>> 1 } else { A = c[n + 4 >> 2] | 0 }
            do {
                if ((A | 0) == 0) {
                    Sc[c[(c[j >> 2] | 0) + 32 >> 2] & 15](q, x, y, c[h >> 2] | 0) | 0;
                    c[h >> 2] = (c[h >> 2] | 0) + (y - x)
                } else {
                    do {
                        if ((x | 0) != (y | 0)) {
                            z = y - 1 | 0;
                            if (z >>> 0 > x >>> 0) {
                                B = x;
                                C = z
                            } else { break }
                            do {
                                z = a[B] | 0;
                                a[B] = a[C] | 0;
                                a[C] = z;
                                B = B + 1 | 0;
                                C = C - 1 | 0;
                            } while (B >>> 0 < C >>> 0)
                        }
                    } while (0);
                    w = Fc[c[(c[r >> 2] | 0) + 16 >> 2] & 255](s) | 0;
                    if (x >>> 0 < y >>> 0) {
                        z = n + 1 | 0;
                        v = n + 4 | 0;
                        p = n + 8 | 0;
                        m = j;
                        t = 0;
                        o = 0;
                        D = x;
                        while (1) {
                            E = (a[u] & 1) == 0;
                            do {
                                if ((a[(E ? z : c[p >> 2] | 0) + o | 0] | 0) > 0) {
                                    if ((t | 0) != (a[(E ? z : c[p >> 2] | 0) + o | 0] | 0)) {
                                        F = o;
                                        G = t;
                                        break
                                    }
                                    H = c[h >> 2] | 0;
                                    c[h >> 2] = H + 1;
                                    a[H] = w;
                                    H = a[u] | 0;
                                    if ((H & 1) == 0) { I = (H & 255) >>> 1 } else { I = c[v >> 2] | 0 }
                                    F = (o >>> 0 < (I - 1 | 0) >>> 0) + o | 0;
                                    G = 0
                                } else {
                                    F = o;
                                    G = t
                                }
                            } while (0);
                            E = Qc[c[(c[m >> 2] | 0) + 28 >> 2] & 63](q, a[D] | 0) | 0;
                            H = c[h >> 2] | 0;
                            c[h >> 2] = H + 1;
                            a[H] = E;
                            E = D + 1 | 0;
                            if (E >>> 0 < y >>> 0) {
                                t = G + 1 | 0;
                                o = F;
                                D = E
                            } else { break }
                        }
                    }
                    D = f + (x - b) | 0;
                    o = c[h >> 2] | 0;
                    if ((D | 0) == (o | 0)) { break }
                    t = o - 1 | 0;
                    if (t >>> 0 > D >>> 0) {
                        J = D;
                        K = t
                    } else { break }
                    do {
                        t = a[J] | 0;
                        a[J] = a[K] | 0;
                        a[K] = t;
                        J = J + 1 | 0;
                        K = K - 1 | 0;
                    } while (J >>> 0 < K >>> 0)
                }
            } while (0);
            c: do {
                if (y >>> 0 < e >>> 0) {
                    K = j;
                    J = y;
                    while (1) {
                        x = a[J] | 0;
                        if (x << 24 >> 24 == 46) { break }
                        F = Qc[c[(c[K >> 2] | 0) + 28 >> 2] & 63](q, x) | 0;
                        x = c[h >> 2] | 0;
                        c[h >> 2] = x + 1;
                        a[x] = F;
                        F = J + 1 | 0;
                        if (F >>> 0 < e >>> 0) { J = F } else { L = F; break c }
                    }
                    K = Fc[c[(c[r >> 2] | 0) + 12 >> 2] & 255](s) | 0;
                    F = c[h >> 2] | 0;
                    c[h >> 2] = F + 1;
                    a[F] = K;
                    L = J + 1 | 0
                } else { L = y }
            } while (0);
            Sc[c[(c[j >> 2] | 0) + 32 >> 2] & 15](q, L, e, c[h >> 2] | 0) | 0;
            q = (c[h >> 2] | 0) + (l - L) | 0;
            c[h >> 2] = q;
            if ((d | 0) == (e | 0)) {
                M = q;
                c[g >> 2] = M;
                rm(n);
                i = k;
                return
            }
            M = f + (d - b) | 0;
            c[g >> 2] = M;
            rm(n);
            i = k;
            return
        }

        function mp(b, d, e, f, g, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = +j;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            d = i;
            i = i + 152 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 8 | 0;
            m = d + 40 | 0;
            n = d + 48 | 0;
            o = d + 112 | 0;
            p = d + 120 | 0;
            q = d + 128 | 0;
            r = d + 136 | 0;
            s = d + 144 | 0;
            c[k >> 2] = 37;
            c[k + 4 >> 2] = 0;
            t = k;
            k = t + 1 | 0;
            u = f + 4 | 0;
            v = c[u >> 2] | 0;
            if ((v & 2048 | 0) == 0) { w = k } else {
                a[k] = 43;
                w = t + 2 | 0
            }
            if ((v & 1024 | 0) == 0) { x = w } else {
                a[w] = 35;
                x = w + 1 | 0
            }
            w = v & 260;
            k = v >>> 14;
            do {
                if ((w | 0) == 260) {
                    a[x] = 76;
                    v = x + 1 | 0;
                    if ((k & 1 | 0) == 0) {
                        a[v] = 97;
                        y = 0;
                        break
                    } else {
                        a[v] = 65;
                        y = 0;
                        break
                    }
                } else {
                    a[x] = 46;
                    a[x + 1 | 0] = 42;
                    a[x + 2 | 0] = 76;
                    v = x + 3 | 0;
                    if ((w | 0) == 4) {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 102;
                            y = 1;
                            break
                        } else {
                            a[v] = 70;
                            y = 1;
                            break
                        }
                    } else if ((w | 0) == 256) {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 101;
                            y = 1;
                            break
                        } else {
                            a[v] = 69;
                            y = 1;
                            break
                        }
                    } else {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 103;
                            y = 1;
                            break
                        } else {
                            a[v] = 71;
                            y = 1;
                            break
                        }
                    }
                }
            } while (0);
            k = l | 0;
            c[m >> 2] = k;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    l = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = l
                }
            } while (0);
            l = c[8330] | 0;
            if (y) {
                w = ep(k, 30, l, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                i = z;
                A = w
            } else {
                w = ep(k, 30, l, t, (z = i, i = i + 8 | 0, h[z >> 3] = j, z) | 0) | 0;
                i = z;
                A = w
            }
            do {
                if ((A | 0) > 29) {
                    w = (a[51808] | 0) == 0;
                    if (y) {
                        do {
                            if (w) {
                                if ((ub(51808) | 0) == 0) { break }
                                l = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = l
                            }
                        } while (0);
                        l = kp(m, c[8330] | 0, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                        i = z;
                        B = l
                    } else {
                        do {
                            if (w) {
                                if ((ub(51808) | 0) == 0) { break }
                                l = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = l
                            }
                        } while (0);
                        w = kp(m, c[8330] | 0, t, (z = i, i = i + 8 | 0, h[z >> 3] = j, z) | 0) | 0;
                        i = z;
                        B = w
                    }
                    w = c[m >> 2] | 0;
                    if ((w | 0) != 0) {
                        C = B;
                        D = w;
                        E = w;
                        break
                    }
                    Uu();
                    w = c[m >> 2] | 0;
                    C = B;
                    D = w;
                    E = w
                } else {
                    C = A;
                    D = 0;
                    E = c[m >> 2] | 0
                }
            } while (0);
            A = E + C | 0;
            B = c[u >> 2] & 176;
            do {
                if ((B | 0) == 32) { F = A } else if ((B | 0) == 16) {
                    u = a[E] | 0;
                    if ((u << 24 >> 24 | 0) == 45 | (u << 24 >> 24 | 0) == 43) { F = E + 1 | 0; break }
                    if (!((C | 0) > 1 & u << 24 >> 24 == 48)) { G = 53; break }
                    u = a[E + 1 | 0] | 0;
                    if (!((u << 24 >> 24 | 0) == 120 | (u << 24 >> 24 | 0) == 88)) { G = 53; break }
                    F = E + 2 | 0
                } else { G = 53 }
            } while (0);
            if ((G | 0) == 53) { F = E }
            do {
                if ((E | 0) == (k | 0)) {
                    H = n | 0;
                    I = 0;
                    J = k
                } else {
                    G = Gu(C << 1) | 0;
                    if ((G | 0) != 0) {
                        H = G;
                        I = G;
                        J = E;
                        break
                    }
                    Uu();
                    H = 0;
                    I = 0;
                    J = c[m >> 2] | 0
                }
            } while (0);
            Lm(q, f);
            lp(J, F, A, H, o, p, q);
            Ul(c[q >> 2] | 0) | 0;
            q = e | 0;
            c[s >> 2] = c[q >> 2];
            Bd(r, s, H, c[o >> 2] | 0, c[p >> 2] | 0, f, g);
            g = c[r >> 2] | 0;
            c[q >> 2] = g;
            c[b >> 2] = g;
            if ((I | 0) != 0) { Hu(I) }
            if ((D | 0) == 0) { i = d; return }
            Hu(D);
            i = d;
            return
        }

        function np(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0;
            d = i;
            i = i + 104 | 0;
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = d | 0;
            k = d + 24 | 0;
            l = d + 48 | 0;
            m = d + 88 | 0;
            n = d + 96 | 0;
            o = d + 16 | 0;
            a[o] = a[19440] | 0;
            a[o + 1 | 0] = a[19441] | 0;
            a[o + 2 | 0] = a[19442] | 0;
            a[o + 3 | 0] = a[19443] | 0;
            a[o + 4 | 0] = a[19444] | 0;
            a[o + 5 | 0] = a[19445] | 0;
            p = k | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    q = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = q
                }
            } while (0);
            q = ep(p, 20, c[8330] | 0, o, (o = i, i = i + 8 | 0, c[o >> 2] = h, o) | 0) | 0;
            i = o;
            o = k + q | 0;
            h = c[f + 4 >> 2] & 176;
            do {
                if ((h | 0) == 32) { r = o } else if ((h | 0) == 16) {
                    s = a[p] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { r = k + 1 | 0; break }
                    if (!((q | 0) > 1 & s << 24 >> 24 == 48)) { t = 12; break }
                    s = a[k + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { t = 12; break }
                    r = k + 2 | 0
                } else { t = 12 }
            } while (0);
            if ((t | 0) == 12) { r = p }
            t = l | 0;
            Lm(m, f);
            h = m | 0;
            m = c[h >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[j >> 2] = 34864;
                c[j + 4 >> 2] = 16;
                c[j + 8 >> 2] = 0;
                mm(34864, j, 114)
            }
            j = (c[8717] | 0) - 1 | 0;
            s = c[m + 8 >> 2] | 0;
            do {
                if ((c[m + 12 >> 2] | 0) - s >> 2 >>> 0 > j >>> 0) {
                    u = c[s + (j << 2) >> 2] | 0;
                    if ((u | 0) == 0) { break }
                    Ul(c[h >> 2] | 0) | 0;
                    Sc[c[(c[u >> 2] | 0) + 32 >> 2] & 15](u, p, o, t) | 0;
                    u = l + q | 0;
                    if ((r | 0) == (o | 0)) {
                        v = u;
                        w = e | 0;
                        x = c[w >> 2] | 0;
                        y = n | 0;
                        c[y >> 2] = x;
                        Bd(b, n, t, v, u, f, g);
                        z = 37;
                        A = 0;
                        i = d;
                        return
                    }
                    v = l + (r - k) | 0;
                    w = e | 0;
                    x = c[w >> 2] | 0;
                    y = n | 0;
                    c[y >> 2] = x;
                    Bd(b, n, t, v, u, f, g);
                    z = 37;
                    A = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function op(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function pp(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function qp(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0;
            j = i;
            i = i + 48 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = j | 0;
            l = j + 16 | 0;
            m = j + 24 | 0;
            n = j + 32 | 0;
            if ((c[f + 4 >> 2] & 1 | 0) == 0) {
                o = c[(c[d >> 2] | 0) + 24 >> 2] | 0;
                c[l >> 2] = c[e >> 2];
                Kc[o & 63](b, d, l, f, g, h & 1);
                i = j;
                return
            }
            Lm(m, f);
            f = m | 0;
            m = c[f >> 2] | 0;
            if (!((c[8618] | 0) == -1)) {
                c[k >> 2] = 34472;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34472, k, 114)
            }
            k = (c[8619] | 0) - 1 | 0;
            g = c[m + 8 >> 2] | 0;
            do {
                if ((c[m + 12 >> 2] | 0) - g >> 2 >>> 0 > k >>> 0) {
                    l = c[g + (k << 2) >> 2] | 0;
                    if ((l | 0) == 0) { break }
                    d = l;
                    Ul(c[f >> 2] | 0) | 0;
                    o = c[l >> 2] | 0;
                    if (h) { Ec[c[o + 24 >> 2] & 127](n, d) } else { Ec[c[o + 28 >> 2] & 127](n, d) }
                    d = n;
                    o = a[d] | 0;
                    if ((o & 1) == 0) {
                        l = n + 4 | 0;
                        p = l;
                        q = l;
                        r = n + 8 | 0
                    } else {
                        l = n + 8 | 0;
                        p = c[l >> 2] | 0;
                        q = n + 4 | 0;
                        r = l
                    }
                    l = e | 0;
                    s = p;
                    t = o;
                    while (1) {
                        if ((t & 1) == 0) {
                            u = (t & 255) >>> 1;
                            v = q
                        } else {
                            u = c[q >> 2] | 0;
                            v = c[r >> 2] | 0
                        }
                        if ((s | 0) == (v + (u << 2) | 0)) { break }
                        o = c[s >> 2] | 0;
                        w = c[l >> 2] | 0;
                        do {
                            if ((w | 0) != 0) {
                                x = w + 24 | 0;
                                y = c[x >> 2] | 0;
                                if ((y | 0) == (c[w + 28 >> 2] | 0)) { z = Qc[c[(c[w >> 2] | 0) + 52 >> 2] & 63](w, o) | 0 } else {
                                    c[x >> 2] = y + 4;
                                    c[y >> 2] = o;
                                    z = o
                                }
                                if (!((z | 0) == -1)) { break }
                                c[l >> 2] = 0
                            }
                        } while (0);
                        s = s + 4 | 0;
                        t = a[d] | 0
                    }
                    c[b >> 2] = c[l >> 2];
                    Cm(n);
                    i = j;
                    return
                }
            } while (0);
            j = pc(4) | 0;
            lu(j);
            Fb(j | 0, 25544, 156)
        }

        function rp(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            d = i;
            i = i + 144 | 0;
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = d | 0;
            k = d + 8 | 0;
            l = d + 24 | 0;
            m = d + 112 | 0;
            n = d + 120 | 0;
            o = d + 128 | 0;
            p = d + 136 | 0;
            q = j | 0;
            a[q] = a[19432] | 0;
            a[q + 1 | 0] = a[19433] | 0;
            a[q + 2 | 0] = a[19434] | 0;
            a[q + 3 | 0] = a[19435] | 0;
            a[q + 4 | 0] = a[19436] | 0;
            a[q + 5 | 0] = a[19437] | 0;
            r = j + 1 | 0;
            s = f + 4 | 0;
            t = c[s >> 2] | 0;
            if ((t & 2048 | 0) == 0) { u = r } else {
                a[r] = 43;
                u = j + 2 | 0
            }
            if ((t & 512 | 0) == 0) { v = u } else {
                a[u] = 35;
                v = u + 1 | 0
            }
            a[v] = 108;
            u = v + 1 | 0;
            v = t & 74;
            do { if ((v | 0) == 64) { a[u] = 111 } else if ((v | 0) == 8) { if ((t & 16384 | 0) == 0) { a[u] = 120; break } else { a[u] = 88; break } } else { a[u] = 100 } } while (0);
            u = k | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    t = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = t
                }
            } while (0);
            t = ep(u, 12, c[8330] | 0, q, (q = i, i = i + 8 | 0, c[q >> 2] = h, q) | 0) | 0;
            i = q;
            q = k + t | 0;
            h = c[s >> 2] & 176;
            do {
                if ((h | 0) == 16) {
                    s = a[u] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { w = k + 1 | 0; break }
                    if (!((t | 0) > 1 & s << 24 >> 24 == 48)) { x = 22; break }
                    s = a[k + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { x = 22; break }
                    w = k + 2 | 0
                } else if ((h | 0) == 32) { w = q } else { x = 22 }
            } while (0);
            if ((x | 0) == 22) { w = u }
            x = l | 0;
            Lm(o, f);
            sp(u, w, q, x, m, n, o);
            Ul(c[o >> 2] | 0) | 0;
            c[p >> 2] = c[e >> 2];
            tp(b, p, x, c[m >> 2] | 0, c[n >> 2] | 0, f, g);
            i = d;
            return
        }

        function sp(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0;
            k = i;
            i = i + 48 | 0;
            l = k | 0;
            m = k + 16 | 0;
            n = k + 32 | 0;
            o = j | 0;
            j = c[o >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[m >> 2] = 34856;
                c[m + 4 >> 2] = 16;
                c[m + 8 >> 2] = 0;
                mm(34856, m, 114)
            }
            m = (c[8715] | 0) - 1 | 0;
            p = c[j + 8 >> 2] | 0;
            if (!((c[j + 12 >> 2] | 0) - p >> 2 >>> 0 > m >>> 0)) {
                q = pc(4) | 0;
                r = q;
                lu(r);
                Fb(q | 0, 25544, 156)
            }
            j = c[p + (m << 2) >> 2] | 0;
            if ((j | 0) == 0) {
                q = pc(4) | 0;
                r = q;
                lu(r);
                Fb(q | 0, 25544, 156)
            }
            q = j;
            r = c[o >> 2] | 0;
            if (!((c[8618] | 0) == -1)) {
                c[l >> 2] = 34472;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34472, l, 114)
            }
            l = (c[8619] | 0) - 1 | 0;
            o = c[r + 8 >> 2] | 0;
            if (!((c[r + 12 >> 2] | 0) - o >> 2 >>> 0 > l >>> 0)) {
                s = pc(4) | 0;
                t = s;
                lu(t);
                Fb(s | 0, 25544, 156)
            }
            r = c[o + (l << 2) >> 2] | 0;
            if ((r | 0) == 0) {
                s = pc(4) | 0;
                t = s;
                lu(t);
                Fb(s | 0, 25544, 156)
            }
            s = r;
            Ec[c[(c[r >> 2] | 0) + 20 >> 2] & 127](n, s);
            t = n;
            l = a[t] | 0;
            if ((l & 1) == 0) { u = (l & 255) >>> 1 } else { u = c[n + 4 >> 2] | 0 }
            do {
                if ((u | 0) == 0) {
                    Sc[c[(c[j >> 2] | 0) + 48 >> 2] & 15](q, b, e, f) | 0;
                    l = f + (e - b << 2) | 0;
                    c[h >> 2] = l;
                    v = l
                } else {
                    c[h >> 2] = f;
                    l = a[b] | 0;
                    if ((l << 24 >> 24 | 0) == 45 | (l << 24 >> 24 | 0) == 43) {
                        o = Qc[c[(c[j >> 2] | 0) + 44 >> 2] & 63](q, l) | 0;
                        l = c[h >> 2] | 0;
                        c[h >> 2] = l + 4;
                        c[l >> 2] = o;
                        w = b + 1 | 0
                    } else { w = b }
                    do {
                        if ((e - w | 0) > 1) {
                            if ((a[w] | 0) != 48) { x = w; break }
                            o = w + 1 | 0;
                            l = a[o] | 0;
                            if (!((l << 24 >> 24 | 0) == 120 | (l << 24 >> 24 | 0) == 88)) { x = w; break }
                            l = j;
                            m = Qc[c[(c[l >> 2] | 0) + 44 >> 2] & 63](q, 48) | 0;
                            p = c[h >> 2] | 0;
                            c[h >> 2] = p + 4;
                            c[p >> 2] = m;
                            m = Qc[c[(c[l >> 2] | 0) + 44 >> 2] & 63](q, a[o] | 0) | 0;
                            o = c[h >> 2] | 0;
                            c[h >> 2] = o + 4;
                            c[o >> 2] = m;
                            x = w + 2 | 0
                        } else { x = w }
                    } while (0);
                    do {
                        if ((x | 0) != (e | 0)) {
                            m = e - 1 | 0;
                            if (m >>> 0 > x >>> 0) {
                                y = x;
                                z = m
                            } else { break }
                            do {
                                m = a[y] | 0;
                                a[y] = a[z] | 0;
                                a[z] = m;
                                y = y + 1 | 0;
                                z = z - 1 | 0;
                            } while (y >>> 0 < z >>> 0)
                        }
                    } while (0);
                    m = Fc[c[(c[r >> 2] | 0) + 16 >> 2] & 255](s) | 0;
                    if (x >>> 0 < e >>> 0) {
                        o = n + 1 | 0;
                        l = j;
                        p = n + 4 | 0;
                        A = n + 8 | 0;
                        B = 0;
                        C = 0;
                        D = x;
                        while (1) {
                            E = (a[t] & 1) == 0;
                            do {
                                if ((a[(E ? o : c[A >> 2] | 0) + C | 0] | 0) == 0) {
                                    F = C;
                                    G = B
                                } else {
                                    if ((B | 0) != (a[(E ? o : c[A >> 2] | 0) + C | 0] | 0)) {
                                        F = C;
                                        G = B;
                                        break
                                    }
                                    H = c[h >> 2] | 0;
                                    c[h >> 2] = H + 4;
                                    c[H >> 2] = m;
                                    H = a[t] | 0;
                                    if ((H & 1) == 0) { I = (H & 255) >>> 1 } else { I = c[p >> 2] | 0 }
                                    F = (C >>> 0 < (I - 1 | 0) >>> 0) + C | 0;
                                    G = 0
                                }
                            } while (0);
                            E = Qc[c[(c[l >> 2] | 0) + 44 >> 2] & 63](q, a[D] | 0) | 0;
                            H = c[h >> 2] | 0;
                            J = H + 4 | 0;
                            c[h >> 2] = J;
                            c[H >> 2] = E;
                            E = D + 1 | 0;
                            if (E >>> 0 < e >>> 0) {
                                B = G + 1 | 0;
                                C = F;
                                D = E
                            } else { K = J; break }
                        }
                    } else { K = c[h >> 2] | 0 }
                    D = f + (x - b << 2) | 0;
                    if ((D | 0) == (K | 0)) { v = K; break }
                    C = K - 4 | 0;
                    if (C >>> 0 > D >>> 0) {
                        L = D;
                        M = C
                    } else { v = K; break }
                    while (1) {
                        C = c[L >> 2] | 0;
                        c[L >> 2] = c[M >> 2];
                        c[M >> 2] = C;
                        C = L + 4 | 0;
                        D = M - 4 | 0;
                        if (C >>> 0 < D >>> 0) {
                            L = C;
                            M = D
                        } else { v = K; break }
                    }
                }
            } while (0);
            if ((d | 0) == (e | 0)) {
                N = v;
                c[g >> 2] = N;
                rm(n);
                i = k;
                return
            }
            N = f + (d - b << 2) | 0;
            c[g >> 2] = N;
            rm(n);
            i = k;
            return
        }

        function tp(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            k = i;
            i = i + 16 | 0;
            l = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[l >> 2];
            l = k | 0;
            m = d | 0;
            d = c[m >> 2] | 0;
            if ((d | 0) == 0) {
                c[b >> 2] = 0;
                i = k;
                return
            }
            n = g;
            g = e;
            o = n - g >> 2;
            p = h + 12 | 0;
            h = c[p >> 2] | 0;
            q = (h | 0) > (o | 0) ? h - o | 0 : 0;
            o = f;
            h = o - g | 0;
            g = h >> 2;
            do {
                if ((h | 0) > 0) {
                    if ((Hc[c[(c[d >> 2] | 0) + 48 >> 2] & 63](d, e, g) | 0) == (g | 0)) { break }
                    c[m >> 2] = 0;
                    c[b >> 2] = 0;
                    i = k;
                    return
                }
            } while (0);
            do {
                if ((q | 0) > 0) {
                    Bm(l, q, j);
                    if ((a[l] & 1) == 0) { r = l + 4 | 0 } else { r = c[l + 8 >> 2] | 0 }
                    if ((Hc[c[(c[d >> 2] | 0) + 48 >> 2] & 63](d, r, q) | 0) == (q | 0)) { Cm(l); break }
                    c[m >> 2] = 0;
                    c[b >> 2] = 0;
                    Cm(l);
                    i = k;
                    return
                }
            } while (0);
            l = n - o | 0;
            o = l >> 2;
            do {
                if ((l | 0) > 0) {
                    if ((Hc[c[(c[d >> 2] | 0) + 48 >> 2] & 63](d, f, o) | 0) == (o | 0)) { break }
                    c[m >> 2] = 0;
                    c[b >> 2] = 0;
                    i = k;
                    return
                }
            } while (0);
            c[p >> 2] = 0;
            c[b >> 2] = d;
            i = k;
            return
        }

        function up(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            d = i;
            i = i + 232 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 8 | 0;
            m = d + 32 | 0;
            n = d + 200 | 0;
            o = d + 208 | 0;
            p = d + 216 | 0;
            q = d + 224 | 0;
            c[k >> 2] = 37;
            c[k + 4 >> 2] = 0;
            r = k;
            k = r + 1 | 0;
            s = f + 4 | 0;
            t = c[s >> 2] | 0;
            if ((t & 2048 | 0) == 0) { u = k } else {
                a[k] = 43;
                u = r + 2 | 0
            }
            if ((t & 512 | 0) == 0) { v = u } else {
                a[u] = 35;
                v = u + 1 | 0
            }
            a[v] = 108;
            a[v + 1 | 0] = 108;
            u = v + 2 | 0;
            v = t & 74;
            do { if ((v | 0) == 64) { a[u] = 111 } else if ((v | 0) == 8) { if ((t & 16384 | 0) == 0) { a[u] = 120; break } else { a[u] = 88; break } } else { a[u] = 100 } } while (0);
            u = l | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    t = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = t
                }
            } while (0);
            t = ep(u, 22, c[8330] | 0, r, (r = i, i = i + 16 | 0, c[r >> 2] = h, c[r + 8 >> 2] = j, r) | 0) | 0;
            i = r;
            r = l + t | 0;
            j = c[s >> 2] & 176;
            do {
                if ((j | 0) == 32) { w = r } else if ((j | 0) == 16) {
                    s = a[u] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { w = l + 1 | 0; break }
                    if (!((t | 0) > 1 & s << 24 >> 24 == 48)) { x = 22; break }
                    s = a[l + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { x = 22; break }
                    w = l + 2 | 0
                } else { x = 22 }
            } while (0);
            if ((x | 0) == 22) { w = u }
            x = m | 0;
            Lm(p, f);
            sp(u, w, r, x, n, o, p);
            Ul(c[p >> 2] | 0) | 0;
            c[q >> 2] = c[e >> 2];
            tp(b, q, x, c[n >> 2] | 0, c[o >> 2] | 0, f, g);
            i = d;
            return
        }

        function vp(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            d = i;
            i = i + 144 | 0;
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = d | 0;
            k = d + 8 | 0;
            l = d + 24 | 0;
            m = d + 112 | 0;
            n = d + 120 | 0;
            o = d + 128 | 0;
            p = d + 136 | 0;
            q = j | 0;
            a[q] = a[19432] | 0;
            a[q + 1 | 0] = a[19433] | 0;
            a[q + 2 | 0] = a[19434] | 0;
            a[q + 3 | 0] = a[19435] | 0;
            a[q + 4 | 0] = a[19436] | 0;
            a[q + 5 | 0] = a[19437] | 0;
            r = j + 1 | 0;
            s = f + 4 | 0;
            t = c[s >> 2] | 0;
            if ((t & 2048 | 0) == 0) { u = r } else {
                a[r] = 43;
                u = j + 2 | 0
            }
            if ((t & 512 | 0) == 0) { v = u } else {
                a[u] = 35;
                v = u + 1 | 0
            }
            a[v] = 108;
            u = v + 1 | 0;
            v = t & 74;
            do { if ((v | 0) == 8) { if ((t & 16384 | 0) == 0) { a[u] = 120; break } else { a[u] = 88; break } } else if ((v | 0) == 64) { a[u] = 111 } else { a[u] = 117 } } while (0);
            u = k | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    v = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = v
                }
            } while (0);
            v = ep(u, 12, c[8330] | 0, q, (q = i, i = i + 8 | 0, c[q >> 2] = h, q) | 0) | 0;
            i = q;
            q = k + v | 0;
            h = c[s >> 2] & 176;
            do {
                if ((h | 0) == 32) { w = q } else if ((h | 0) == 16) {
                    s = a[u] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { w = k + 1 | 0; break }
                    if (!((v | 0) > 1 & s << 24 >> 24 == 48)) { x = 22; break }
                    s = a[k + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { x = 22; break }
                    w = k + 2 | 0
                } else { x = 22 }
            } while (0);
            if ((x | 0) == 22) { w = u }
            x = l | 0;
            Lm(o, f);
            sp(u, w, q, x, m, n, o);
            Ul(c[o >> 2] | 0) | 0;
            c[p >> 2] = c[e >> 2];
            tp(b, p, x, c[m >> 2] | 0, c[n >> 2] | 0, f, g);
            i = d;
            return
        }

        function wp(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0;
            d = i;
            i = i + 240 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 8 | 0;
            m = d + 32 | 0;
            n = d + 208 | 0;
            o = d + 216 | 0;
            p = d + 224 | 0;
            q = d + 232 | 0;
            c[k >> 2] = 37;
            c[k + 4 >> 2] = 0;
            r = k;
            k = r + 1 | 0;
            s = f + 4 | 0;
            t = c[s >> 2] | 0;
            if ((t & 2048 | 0) == 0) { u = k } else {
                a[k] = 43;
                u = r + 2 | 0
            }
            if ((t & 512 | 0) == 0) { v = u } else {
                a[u] = 35;
                v = u + 1 | 0
            }
            a[v] = 108;
            a[v + 1 | 0] = 108;
            u = v + 2 | 0;
            v = t & 74;
            do { if ((v | 0) == 8) { if ((t & 16384 | 0) == 0) { a[u] = 120; break } else { a[u] = 88; break } } else if ((v | 0) == 64) { a[u] = 111 } else { a[u] = 117 } } while (0);
            u = l | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    v = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = v
                }
            } while (0);
            v = ep(u, 23, c[8330] | 0, r, (r = i, i = i + 16 | 0, c[r >> 2] = h, c[r + 8 >> 2] = j, r) | 0) | 0;
            i = r;
            r = l + v | 0;
            j = c[s >> 2] & 176;
            do {
                if ((j | 0) == 32) { w = r } else if ((j | 0) == 16) {
                    s = a[u] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { w = l + 1 | 0; break }
                    if (!((v | 0) > 1 & s << 24 >> 24 == 48)) { x = 22; break }
                    s = a[l + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { x = 22; break }
                    w = l + 2 | 0
                } else { x = 22 }
            } while (0);
            if ((x | 0) == 22) { w = u }
            x = m | 0;
            Lm(p, f);
            sp(u, w, r, x, n, o, p);
            Ul(c[p >> 2] | 0) | 0;
            c[q >> 2] = c[e >> 2];
            tp(b, q, x, c[n >> 2] | 0, c[o >> 2] | 0, f, g);
            i = d;
            return
        }

        function xp(b, d, e, f, g, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = +j;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            d = i;
            i = i + 320 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 8 | 0;
            m = d + 40 | 0;
            n = d + 48 | 0;
            o = d + 280 | 0;
            p = d + 288 | 0;
            q = d + 296 | 0;
            r = d + 304 | 0;
            s = d + 312 | 0;
            c[k >> 2] = 37;
            c[k + 4 >> 2] = 0;
            t = k;
            k = t + 1 | 0;
            u = f + 4 | 0;
            v = c[u >> 2] | 0;
            if ((v & 2048 | 0) == 0) { w = k } else {
                a[k] = 43;
                w = t + 2 | 0
            }
            if ((v & 1024 | 0) == 0) { x = w } else {
                a[w] = 35;
                x = w + 1 | 0
            }
            w = v & 260;
            k = v >>> 14;
            do {
                if ((w | 0) == 260) {
                    if ((k & 1 | 0) == 0) {
                        a[x] = 97;
                        y = 0;
                        break
                    } else {
                        a[x] = 65;
                        y = 0;
                        break
                    }
                } else {
                    a[x] = 46;
                    v = x + 2 | 0;
                    a[x + 1 | 0] = 42;
                    if ((w | 0) == 256) {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 101;
                            y = 1;
                            break
                        } else {
                            a[v] = 69;
                            y = 1;
                            break
                        }
                    } else if ((w | 0) == 4) {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 102;
                            y = 1;
                            break
                        } else {
                            a[v] = 70;
                            y = 1;
                            break
                        }
                    } else {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 103;
                            y = 1;
                            break
                        } else {
                            a[v] = 71;
                            y = 1;
                            break
                        }
                    }
                }
            } while (0);
            k = l | 0;
            c[m >> 2] = k;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    l = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = l
                }
            } while (0);
            l = c[8330] | 0;
            if (y) {
                w = ep(k, 30, l, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                i = z;
                A = w
            } else {
                w = ep(k, 30, l, t, (z = i, i = i + 8 | 0, h[z >> 3] = j, z) | 0) | 0;
                i = z;
                A = w
            }
            do {
                if ((A | 0) > 29) {
                    w = (a[51808] | 0) == 0;
                    if (y) {
                        do {
                            if (w) {
                                if ((ub(51808) | 0) == 0) { break }
                                l = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = l
                            }
                        } while (0);
                        l = kp(m, c[8330] | 0, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                        i = z;
                        B = l
                    } else {
                        do {
                            if (w) {
                                if ((ub(51808) | 0) == 0) { break }
                                l = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = l
                            }
                        } while (0);
                        w = kp(m, c[8330] | 0, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                        i = z;
                        B = w
                    }
                    w = c[m >> 2] | 0;
                    if ((w | 0) != 0) {
                        C = B;
                        D = w;
                        E = w;
                        break
                    }
                    Uu();
                    w = c[m >> 2] | 0;
                    C = B;
                    D = w;
                    E = w
                } else {
                    C = A;
                    D = 0;
                    E = c[m >> 2] | 0
                }
            } while (0);
            A = E + C | 0;
            B = c[u >> 2] & 176;
            do {
                if ((B | 0) == 16) {
                    u = a[E] | 0;
                    if ((u << 24 >> 24 | 0) == 45 | (u << 24 >> 24 | 0) == 43) { F = E + 1 | 0; break }
                    if (!((C | 0) > 1 & u << 24 >> 24 == 48)) { G = 53; break }
                    u = a[E + 1 | 0] | 0;
                    if (!((u << 24 >> 24 | 0) == 120 | (u << 24 >> 24 | 0) == 88)) { G = 53; break }
                    F = E + 2 | 0
                } else if ((B | 0) == 32) { F = A } else { G = 53 }
            } while (0);
            if ((G | 0) == 53) { F = E }
            do {
                if ((E | 0) == (k | 0)) {
                    H = n | 0;
                    I = 0;
                    J = k
                } else {
                    G = Gu(C << 3) | 0;
                    B = G;
                    if ((G | 0) != 0) {
                        H = B;
                        I = B;
                        J = E;
                        break
                    }
                    Uu();
                    H = B;
                    I = B;
                    J = c[m >> 2] | 0
                }
            } while (0);
            Lm(q, f);
            yp(J, F, A, H, o, p, q);
            Ul(c[q >> 2] | 0) | 0;
            q = e | 0;
            c[s >> 2] = c[q >> 2];
            tp(r, s, H, c[o >> 2] | 0, c[p >> 2] | 0, f, g);
            g = c[r >> 2] | 0;
            c[q >> 2] = g;
            c[b >> 2] = g;
            if ((I | 0) != 0) { Hu(I) }
            if ((D | 0) == 0) { i = d; return }
            Hu(D);
            i = d;
            return
        }

        function yp(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0;
            k = i;
            i = i + 48 | 0;
            l = k | 0;
            m = k + 16 | 0;
            n = k + 32 | 0;
            o = j | 0;
            j = c[o >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[m >> 2] = 34856;
                c[m + 4 >> 2] = 16;
                c[m + 8 >> 2] = 0;
                mm(34856, m, 114)
            }
            m = (c[8715] | 0) - 1 | 0;
            p = c[j + 8 >> 2] | 0;
            if (!((c[j + 12 >> 2] | 0) - p >> 2 >>> 0 > m >>> 0)) {
                q = pc(4) | 0;
                r = q;
                lu(r);
                Fb(q | 0, 25544, 156)
            }
            j = c[p + (m << 2) >> 2] | 0;
            if ((j | 0) == 0) {
                q = pc(4) | 0;
                r = q;
                lu(r);
                Fb(q | 0, 25544, 156)
            }
            q = j;
            r = c[o >> 2] | 0;
            if (!((c[8618] | 0) == -1)) {
                c[l >> 2] = 34472;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34472, l, 114)
            }
            l = (c[8619] | 0) - 1 | 0;
            o = c[r + 8 >> 2] | 0;
            if (!((c[r + 12 >> 2] | 0) - o >> 2 >>> 0 > l >>> 0)) {
                s = pc(4) | 0;
                t = s;
                lu(t);
                Fb(s | 0, 25544, 156)
            }
            r = c[o + (l << 2) >> 2] | 0;
            if ((r | 0) == 0) {
                s = pc(4) | 0;
                t = s;
                lu(t);
                Fb(s | 0, 25544, 156)
            }
            s = r;
            Ec[c[(c[r >> 2] | 0) + 20 >> 2] & 127](n, s);
            c[h >> 2] = f;
            t = a[b] | 0;
            if ((t << 24 >> 24 | 0) == 45 | (t << 24 >> 24 | 0) == 43) {
                l = Qc[c[(c[j >> 2] | 0) + 44 >> 2] & 63](q, t) | 0;
                t = c[h >> 2] | 0;
                c[h >> 2] = t + 4;
                c[t >> 2] = l;
                u = b + 1 | 0
            } else { u = b }
            l = e;
            a: do {
                if ((l - u | 0) > 1) {
                    if ((a[u] | 0) != 48) { v = 21; break }
                    t = u + 1 | 0;
                    o = a[t] | 0;
                    if (!((o << 24 >> 24 | 0) == 120 | (o << 24 >> 24 | 0) == 88)) { v = 21; break }
                    o = j;
                    m = Qc[c[(c[o >> 2] | 0) + 44 >> 2] & 63](q, 48) | 0;
                    p = c[h >> 2] | 0;
                    c[h >> 2] = p + 4;
                    c[p >> 2] = m;
                    m = u + 2 | 0;
                    p = Qc[c[(c[o >> 2] | 0) + 44 >> 2] & 63](q, a[t] | 0) | 0;
                    t = c[h >> 2] | 0;
                    c[h >> 2] = t + 4;
                    c[t >> 2] = p;
                    if (m >>> 0 < e >>> 0) { w = m } else {
                        x = m;
                        y = m;
                        break
                    }
                    while (1) {
                        p = a[w] | 0;
                        do {
                            if ((a[51808] | 0) == 0) {
                                if ((ub(51808) | 0) == 0) { break }
                                t = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = t
                            }
                        } while (0);
                        t = w + 1 | 0;
                        if ((Ua(p << 24 >> 24 | 0, c[8330] | 0) | 0) == 0) {
                            x = m;
                            y = w;
                            break a
                        }
                        if (t >>> 0 < e >>> 0) { w = t } else {
                            x = m;
                            y = t;
                            break
                        }
                    }
                } else { v = 21 }
            } while (0);
            b: do {
                if ((v | 0) == 21) {
                    if (u >>> 0 < e >>> 0) { z = u } else {
                        x = u;
                        y = u;
                        break
                    }
                    while (1) {
                        w = a[z] | 0;
                        do {
                            if ((a[51808] | 0) == 0) {
                                if ((ub(51808) | 0) == 0) { break }
                                m = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = m
                            }
                        } while (0);
                        p = z + 1 | 0;
                        if ((ib(w << 24 >> 24 | 0, c[8330] | 0) | 0) == 0) {
                            x = u;
                            y = z;
                            break b
                        }
                        if (p >>> 0 < e >>> 0) { z = p } else {
                            x = u;
                            y = p;
                            break
                        }
                    }
                }
            } while (0);
            u = n;
            z = a[u] | 0;
            if ((z & 1) == 0) { A = (z & 255) >>> 1 } else { A = c[n + 4 >> 2] | 0 }
            do {
                if ((A | 0) == 0) {
                    Sc[c[(c[j >> 2] | 0) + 48 >> 2] & 15](q, x, y, c[h >> 2] | 0) | 0;
                    z = (c[h >> 2] | 0) + (y - x << 2) | 0;
                    c[h >> 2] = z;
                    B = z
                } else {
                    do {
                        if ((x | 0) != (y | 0)) {
                            z = y - 1 | 0;
                            if (z >>> 0 > x >>> 0) {
                                C = x;
                                D = z
                            } else { break }
                            do {
                                z = a[C] | 0;
                                a[C] = a[D] | 0;
                                a[D] = z;
                                C = C + 1 | 0;
                                D = D - 1 | 0;
                            } while (C >>> 0 < D >>> 0)
                        }
                    } while (0);
                    w = Fc[c[(c[r >> 2] | 0) + 16 >> 2] & 255](s) | 0;
                    if (x >>> 0 < y >>> 0) {
                        z = n + 1 | 0;
                        v = n + 4 | 0;
                        p = n + 8 | 0;
                        m = j;
                        t = 0;
                        o = 0;
                        E = x;
                        while (1) {
                            F = (a[u] & 1) == 0;
                            do {
                                if ((a[(F ? z : c[p >> 2] | 0) + o | 0] | 0) > 0) {
                                    if ((t | 0) != (a[(F ? z : c[p >> 2] | 0) + o | 0] | 0)) {
                                        G = o;
                                        H = t;
                                        break
                                    }
                                    I = c[h >> 2] | 0;
                                    c[h >> 2] = I + 4;
                                    c[I >> 2] = w;
                                    I = a[u] | 0;
                                    if ((I & 1) == 0) { J = (I & 255) >>> 1 } else { J = c[v >> 2] | 0 }
                                    G = (o >>> 0 < (J - 1 | 0) >>> 0) + o | 0;
                                    H = 0
                                } else {
                                    G = o;
                                    H = t
                                }
                            } while (0);
                            F = Qc[c[(c[m >> 2] | 0) + 44 >> 2] & 63](q, a[E] | 0) | 0;
                            I = c[h >> 2] | 0;
                            K = I + 4 | 0;
                            c[h >> 2] = K;
                            c[I >> 2] = F;
                            F = E + 1 | 0;
                            if (F >>> 0 < y >>> 0) {
                                t = H + 1 | 0;
                                o = G;
                                E = F
                            } else { L = K; break }
                        }
                    } else { L = c[h >> 2] | 0 }
                    E = f + (x - b << 2) | 0;
                    if ((E | 0) == (L | 0)) { B = L; break }
                    o = L - 4 | 0;
                    if (o >>> 0 > E >>> 0) {
                        M = E;
                        N = o
                    } else { B = L; break }
                    while (1) {
                        o = c[M >> 2] | 0;
                        c[M >> 2] = c[N >> 2];
                        c[N >> 2] = o;
                        o = M + 4 | 0;
                        E = N - 4 | 0;
                        if (o >>> 0 < E >>> 0) {
                            M = o;
                            N = E
                        } else { B = L; break }
                    }
                }
            } while (0);
            c: do {
                if (y >>> 0 < e >>> 0) {
                    L = j;
                    N = y;
                    while (1) {
                        M = a[N] | 0;
                        if (M << 24 >> 24 == 46) { break }
                        x = Qc[c[(c[L >> 2] | 0) + 44 >> 2] & 63](q, M) | 0;
                        M = c[h >> 2] | 0;
                        G = M + 4 | 0;
                        c[h >> 2] = G;
                        c[M >> 2] = x;
                        x = N + 1 | 0;
                        if (x >>> 0 < e >>> 0) { N = x } else {
                            O = x;
                            P = G;
                            break c
                        }
                    }
                    L = Fc[c[(c[r >> 2] | 0) + 12 >> 2] & 255](s) | 0;
                    G = c[h >> 2] | 0;
                    x = G + 4 | 0;
                    c[h >> 2] = x;
                    c[G >> 2] = L;
                    O = N + 1 | 0;
                    P = x
                } else {
                    O = y;
                    P = B
                }
            } while (0);
            Sc[c[(c[j >> 2] | 0) + 48 >> 2] & 15](q, O, e, P) | 0;
            P = (c[h >> 2] | 0) + (l - O << 2) | 0;
            c[h >> 2] = P;
            if ((d | 0) == (e | 0)) {
                Q = P;
                c[g >> 2] = Q;
                rm(n);
                i = k;
                return
            }
            Q = f + (d - b << 2) | 0;
            c[g >> 2] = Q;
            rm(n);
            i = k;
            return
        }

        function zp(b, d, e, f, g, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            j = +j;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0;
            d = i;
            i = i + 320 | 0;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            l = d + 8 | 0;
            m = d + 40 | 0;
            n = d + 48 | 0;
            o = d + 280 | 0;
            p = d + 288 | 0;
            q = d + 296 | 0;
            r = d + 304 | 0;
            s = d + 312 | 0;
            c[k >> 2] = 37;
            c[k + 4 >> 2] = 0;
            t = k;
            k = t + 1 | 0;
            u = f + 4 | 0;
            v = c[u >> 2] | 0;
            if ((v & 2048 | 0) == 0) { w = k } else {
                a[k] = 43;
                w = t + 2 | 0
            }
            if ((v & 1024 | 0) == 0) { x = w } else {
                a[w] = 35;
                x = w + 1 | 0
            }
            w = v & 260;
            k = v >>> 14;
            do {
                if ((w | 0) == 260) {
                    a[x] = 76;
                    v = x + 1 | 0;
                    if ((k & 1 | 0) == 0) {
                        a[v] = 97;
                        y = 0;
                        break
                    } else {
                        a[v] = 65;
                        y = 0;
                        break
                    }
                } else {
                    a[x] = 46;
                    a[x + 1 | 0] = 42;
                    a[x + 2 | 0] = 76;
                    v = x + 3 | 0;
                    if ((w | 0) == 4) {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 102;
                            y = 1;
                            break
                        } else {
                            a[v] = 70;
                            y = 1;
                            break
                        }
                    } else if ((w | 0) == 256) {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 101;
                            y = 1;
                            break
                        } else {
                            a[v] = 69;
                            y = 1;
                            break
                        }
                    } else {
                        if ((k & 1 | 0) == 0) {
                            a[v] = 103;
                            y = 1;
                            break
                        } else {
                            a[v] = 71;
                            y = 1;
                            break
                        }
                    }
                }
            } while (0);
            k = l | 0;
            c[m >> 2] = k;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    l = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = l
                }
            } while (0);
            l = c[8330] | 0;
            if (y) {
                w = ep(k, 30, l, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                i = z;
                A = w
            } else {
                w = ep(k, 30, l, t, (z = i, i = i + 8 | 0, h[z >> 3] = j, z) | 0) | 0;
                i = z;
                A = w
            }
            do {
                if ((A | 0) > 29) {
                    w = (a[51808] | 0) == 0;
                    if (y) {
                        do {
                            if (w) {
                                if ((ub(51808) | 0) == 0) { break }
                                l = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = l
                            }
                        } while (0);
                        l = kp(m, c[8330] | 0, t, (z = i, i = i + 16 | 0, c[z >> 2] = c[f + 8 >> 2], h[z + 8 >> 3] = j, z) | 0) | 0;
                        i = z;
                        B = l
                    } else {
                        do {
                            if (w) {
                                if ((ub(51808) | 0) == 0) { break }
                                l = Xa(2147483647, 14472, 0) | 0;
                                c[8330] = l
                            }
                        } while (0);
                        w = kp(m, c[8330] | 0, t, (z = i, i = i + 8 | 0, h[z >> 3] = j, z) | 0) | 0;
                        i = z;
                        B = w
                    }
                    w = c[m >> 2] | 0;
                    if ((w | 0) != 0) {
                        C = B;
                        D = w;
                        E = w;
                        break
                    }
                    Uu();
                    w = c[m >> 2] | 0;
                    C = B;
                    D = w;
                    E = w
                } else {
                    C = A;
                    D = 0;
                    E = c[m >> 2] | 0
                }
            } while (0);
            A = E + C | 0;
            B = c[u >> 2] & 176;
            do {
                if ((B | 0) == 32) { F = A } else if ((B | 0) == 16) {
                    u = a[E] | 0;
                    if ((u << 24 >> 24 | 0) == 45 | (u << 24 >> 24 | 0) == 43) { F = E + 1 | 0; break }
                    if (!((C | 0) > 1 & u << 24 >> 24 == 48)) { G = 53; break }
                    u = a[E + 1 | 0] | 0;
                    if (!((u << 24 >> 24 | 0) == 120 | (u << 24 >> 24 | 0) == 88)) { G = 53; break }
                    F = E + 2 | 0
                } else { G = 53 }
            } while (0);
            if ((G | 0) == 53) { F = E }
            do {
                if ((E | 0) == (k | 0)) {
                    H = n | 0;
                    I = 0;
                    J = k
                } else {
                    G = Gu(C << 3) | 0;
                    B = G;
                    if ((G | 0) != 0) {
                        H = B;
                        I = B;
                        J = E;
                        break
                    }
                    Uu();
                    H = B;
                    I = B;
                    J = c[m >> 2] | 0
                }
            } while (0);
            Lm(q, f);
            yp(J, F, A, H, o, p, q);
            Ul(c[q >> 2] | 0) | 0;
            q = e | 0;
            c[s >> 2] = c[q >> 2];
            tp(r, s, H, c[o >> 2] | 0, c[p >> 2] | 0, f, g);
            g = c[r >> 2] | 0;
            c[q >> 2] = g;
            c[b >> 2] = g;
            if ((I | 0) != 0) { Hu(I) }
            if ((D | 0) == 0) { i = d; return }
            Hu(D);
            i = d;
            return
        }

        function Ap(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0;
            d = i;
            i = i + 216 | 0;
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = d | 0;
            k = d + 24 | 0;
            l = d + 48 | 0;
            m = d + 200 | 0;
            n = d + 208 | 0;
            o = d + 16 | 0;
            a[o] = a[19440] | 0;
            a[o + 1 | 0] = a[19441] | 0;
            a[o + 2 | 0] = a[19442] | 0;
            a[o + 3 | 0] = a[19443] | 0;
            a[o + 4 | 0] = a[19444] | 0;
            a[o + 5 | 0] = a[19445] | 0;
            p = k | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    q = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = q
                }
            } while (0);
            q = ep(p, 20, c[8330] | 0, o, (o = i, i = i + 8 | 0, c[o >> 2] = h, o) | 0) | 0;
            i = o;
            o = k + q | 0;
            h = c[f + 4 >> 2] & 176;
            do {
                if ((h | 0) == 32) { r = o } else if ((h | 0) == 16) {
                    s = a[p] | 0;
                    if ((s << 24 >> 24 | 0) == 45 | (s << 24 >> 24 | 0) == 43) { r = k + 1 | 0; break }
                    if (!((q | 0) > 1 & s << 24 >> 24 == 48)) { t = 12; break }
                    s = a[k + 1 | 0] | 0;
                    if (!((s << 24 >> 24 | 0) == 120 | (s << 24 >> 24 | 0) == 88)) { t = 12; break }
                    r = k + 2 | 0
                } else { t = 12 }
            } while (0);
            if ((t | 0) == 12) { r = p }
            Lm(m, f);
            t = m | 0;
            m = c[t >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[j >> 2] = 34856;
                c[j + 4 >> 2] = 16;
                c[j + 8 >> 2] = 0;
                mm(34856, j, 114)
            }
            j = (c[8715] | 0) - 1 | 0;
            h = c[m + 8 >> 2] | 0;
            do {
                if ((c[m + 12 >> 2] | 0) - h >> 2 >>> 0 > j >>> 0) {
                    s = c[h + (j << 2) >> 2] | 0;
                    if ((s | 0) == 0) { break }
                    Ul(c[t >> 2] | 0) | 0;
                    u = l | 0;
                    Sc[c[(c[s >> 2] | 0) + 48 >> 2] & 15](s, p, o, u) | 0;
                    s = l + (q << 2) | 0;
                    if ((r | 0) == (o | 0)) {
                        v = s;
                        w = e | 0;
                        x = c[w >> 2] | 0;
                        y = n | 0;
                        c[y >> 2] = x;
                        tp(b, n, u, v, s, f, g);
                        z = 148;
                        A = 0;
                        i = d;
                        return
                    }
                    v = l + (r - k << 2) | 0;
                    w = e | 0;
                    x = c[w >> 2] | 0;
                    y = n | 0;
                    c[y >> 2] = x;
                    tp(b, n, u, v, s, f, g);
                    z = 148;
                    A = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function Bp(d, e, f, g, h, j, k, l, m) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            var n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0;
            n = i;
            i = i + 48 | 0;
            o = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[o >> 2];
            o = g;
            g = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[g >> 2] = c[o >> 2];
            o = n | 0;
            p = n + 16 | 0;
            q = n + 24 | 0;
            r = n + 32 | 0;
            s = n + 40 | 0;
            Lm(p, h);
            t = p | 0;
            p = c[t >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[o >> 2] = 34864;
                c[o + 4 >> 2] = 16;
                c[o + 8 >> 2] = 0;
                mm(34864, o, 114)
            }
            o = (c[8717] | 0) - 1 | 0;
            u = c[p + 8 >> 2] | 0;
            do {
                if ((c[p + 12 >> 2] | 0) - u >> 2 >>> 0 > o >>> 0) {
                    v = c[u + (o << 2) >> 2] | 0;
                    if ((v | 0) == 0) { break }
                    w = v;
                    Ul(c[t >> 2] | 0) | 0;
                    c[j >> 2] = 0;
                    x = f | 0;
                    a: do {
                        if ((l | 0) == (m | 0)) { y = 67 } else {
                            z = g | 0;
                            A = v;
                            B = v + 8 | 0;
                            C = v;
                            D = e;
                            E = r | 0;
                            F = s | 0;
                            G = q | 0;
                            H = l;
                            I = 0;
                            b: while (1) {
                                J = I;
                                while (1) {
                                    if ((J | 0) != 0) { y = 67; break a }
                                    K = c[x >> 2] | 0;
                                    do {
                                        if ((K | 0) == 0) { L = 0 } else {
                                            if ((c[K + 12 >> 2] | 0) != (c[K + 16 >> 2] | 0)) { L = K; break }
                                            if (!((Fc[c[(c[K >> 2] | 0) + 36 >> 2] & 255](K) | 0) == -1)) { L = K; break }
                                            c[x >> 2] = 0;
                                            L = 0
                                        }
                                    } while (0);
                                    K = (L | 0) == 0;
                                    M = c[z >> 2] | 0;
                                    c: do {
                                        if ((M | 0) == 0) { y = 20 } else {
                                            do {
                                                if ((c[M + 12 >> 2] | 0) == (c[M + 16 >> 2] | 0)) {
                                                    if (!((Fc[c[(c[M >> 2] | 0) + 36 >> 2] & 255](M) | 0) == -1)) { break }
                                                    c[z >> 2] = 0;
                                                    y = 20;
                                                    break c
                                                }
                                            } while (0);
                                            if (K) { N = M } else { y = 21; break b }
                                        }
                                    } while (0);
                                    if ((y | 0) == 20) { y = 0; if (K) { y = 21; break b } else { N = 0 } }
                                    if ((Hc[c[(c[A >> 2] | 0) + 36 >> 2] & 63](w, a[H] | 0, 0) | 0) << 24 >> 24 == 37) { y = 24; break }
                                    M = a[H] | 0;
                                    if (M << 24 >> 24 > -1) {
                                        O = c[B >> 2] | 0;
                                        if (!((b[O + (M << 24 >> 24 << 1) >> 1] & 8192) == 0)) {
                                            P = H;
                                            y = 35;
                                            break
                                        }
                                    }
                                    Q = L + 12 | 0;
                                    M = c[Q >> 2] | 0;
                                    R = L + 16 | 0;
                                    if ((M | 0) == (c[R >> 2] | 0)) { S = (Fc[c[(c[L >> 2] | 0) + 36 >> 2] & 255](L) | 0) & 255 } else { S = a[M] | 0 }
                                    M = Qc[c[(c[C >> 2] | 0) + 12 >> 2] & 63](w, S) | 0;
                                    if (M << 24 >> 24 == (Qc[c[(c[C >> 2] | 0) + 12 >> 2] & 63](w, a[H] | 0) | 0) << 24 >> 24) { y = 62; break }
                                    c[j >> 2] = 4;
                                    J = 4
                                }
                                d: do {
                                    if ((y | 0) == 24) {
                                        y = 0;
                                        J = H + 1 | 0;
                                        if ((J | 0) == (m | 0)) { y = 25; break b }
                                        M = Hc[c[(c[A >> 2] | 0) + 36 >> 2] & 63](w, a[J] | 0, 0) | 0;
                                        if ((M << 24 >> 24 | 0) == 69 | (M << 24 >> 24 | 0) == 48) {
                                            T = H + 2 | 0;
                                            if ((T | 0) == (m | 0)) { y = 28; break b }
                                            U = M;
                                            V = Hc[c[(c[A >> 2] | 0) + 36 >> 2] & 63](w, a[T] | 0, 0) | 0;
                                            W = T
                                        } else {
                                            U = 0;
                                            V = M;
                                            W = J
                                        }
                                        J = c[(c[D >> 2] | 0) + 36 >> 2] | 0;
                                        c[E >> 2] = L;
                                        c[F >> 2] = N;
                                        Oc[J & 15](q, e, r, s, h, j, k, V, U);
                                        c[x >> 2] = c[G >> 2];
                                        X = W + 1 | 0
                                    } else if ((y | 0) == 35) {
                                        while (1) {
                                            y = 0;
                                            J = P + 1 | 0;
                                            if ((J | 0) == (m | 0)) { Y = m; break }
                                            M = a[J] | 0;
                                            if (!(M << 24 >> 24 > -1)) { Y = J; break }
                                            if ((b[O + (M << 24 >> 24 << 1) >> 1] & 8192) == 0) { Y = J; break } else {
                                                P = J;
                                                y = 35
                                            }
                                        }
                                        K = L;
                                        J = N;
                                        M = N;
                                        while (1) {
                                            do {
                                                if ((K | 0) == 0) { Z = 0 } else {
                                                    if ((c[K + 12 >> 2] | 0) != (c[K + 16 >> 2] | 0)) { Z = K; break }
                                                    if (!((Fc[c[(c[K >> 2] | 0) + 36 >> 2] & 255](K) | 0) == -1)) { Z = K; break }
                                                    c[x >> 2] = 0;
                                                    Z = 0
                                                }
                                            } while (0);
                                            T = (Z | 0) == 0;
                                            do {
                                                if ((J | 0) == 0) {
                                                    _ = M;
                                                    y = 48
                                                } else {
                                                    if ((c[J + 12 >> 2] | 0) != (c[J + 16 >> 2] | 0)) {
                                                        if (T) {
                                                            $ = J;
                                                            aa = M;
                                                            break
                                                        } else { X = Y; break d }
                                                    }
                                                    if ((Fc[c[(c[J >> 2] | 0) + 36 >> 2] & 255](J) | 0) == -1) {
                                                        c[z >> 2] = 0;
                                                        _ = 0;
                                                        y = 48;
                                                        break
                                                    } else {
                                                        if (T ^ (M | 0) == 0) {
                                                            $ = M;
                                                            aa = M;
                                                            break
                                                        } else { X = Y; break d }
                                                    }
                                                }
                                            } while (0);
                                            if ((y | 0) == 48) {
                                                y = 0;
                                                if (T) { X = Y; break d } else {
                                                    $ = 0;
                                                    aa = _
                                                }
                                            }
                                            ba = Z + 12 | 0;
                                            ca = c[ba >> 2] | 0;
                                            da = Z + 16 | 0;
                                            if ((ca | 0) == (c[da >> 2] | 0)) { ea = (Fc[c[(c[Z >> 2] | 0) + 36 >> 2] & 255](Z) | 0) & 255 } else { ea = a[ca] | 0 }
                                            if (!(ea << 24 >> 24 > -1)) { X = Y; break d }
                                            if ((b[(c[B >> 2] | 0) + (ea << 24 >> 24 << 1) >> 1] & 8192) == 0) { X = Y; break d }
                                            ca = c[ba >> 2] | 0;
                                            if ((ca | 0) == (c[da >> 2] | 0)) {
                                                Fc[c[(c[Z >> 2] | 0) + 40 >> 2] & 255](Z) | 0;
                                                K = Z;
                                                J = $;
                                                M = aa;
                                                continue
                                            } else {
                                                c[ba >> 2] = ca + 1;
                                                K = Z;
                                                J = $;
                                                M = aa;
                                                continue
                                            }
                                        }
                                    } else if ((y | 0) == 62) {
                                        y = 0;
                                        M = c[Q >> 2] | 0;
                                        if ((M | 0) == (c[R >> 2] | 0)) { Fc[c[(c[L >> 2] | 0) + 40 >> 2] & 255](L) | 0 } else { c[Q >> 2] = M + 1 }
                                        X = H + 1 | 0
                                    }
                                } while (0);
                                if ((X | 0) == (m | 0)) { y = 67; break a }
                                H = X;
                                I = c[j >> 2] | 0
                            }
                            if ((y | 0) == 21) {
                                c[j >> 2] = 4;
                                fa = L;
                                break
                            } else if ((y | 0) == 25) {
                                c[j >> 2] = 4;
                                fa = L;
                                break
                            } else if ((y | 0) == 28) {
                                c[j >> 2] = 4;
                                fa = L;
                                break
                            }
                        }
                    } while (0);
                    if ((y | 0) == 67) { fa = c[x >> 2] | 0 }
                    w = f | 0;
                    do {
                        if ((fa | 0) == 0) { ga = 0 } else {
                            if ((c[fa + 12 >> 2] | 0) != (c[fa + 16 >> 2] | 0)) { ga = fa; break }
                            if (!((Fc[c[(c[fa >> 2] | 0) + 36 >> 2] & 255](fa) | 0) == -1)) { ga = fa; break }
                            c[w >> 2] = 0;
                            ga = 0
                        }
                    } while (0);
                    w = (ga | 0) == 0;
                    x = g | 0;
                    v = c[x >> 2] | 0;
                    e: do {
                        if ((v | 0) == 0) { y = 77 } else {
                            do {
                                if ((c[v + 12 >> 2] | 0) == (c[v + 16 >> 2] | 0)) {
                                    if (!((Fc[c[(c[v >> 2] | 0) + 36 >> 2] & 255](v) | 0) == -1)) { break }
                                    c[x >> 2] = 0;
                                    y = 77;
                                    break e
                                }
                            } while (0);
                            if (!w) { break }
                            ha = d | 0;
                            c[ha >> 2] = ga;
                            i = n;
                            return
                        }
                    } while (0);
                    do {
                        if ((y | 0) == 77) {
                            if (w) { break }
                            ha = d | 0;
                            c[ha >> 2] = ga;
                            i = n;
                            return
                        }
                    } while (0);
                    c[j >> 2] = c[j >> 2] | 2;
                    ha = d | 0;
                    c[ha >> 2] = ga;
                    i = n;
                    return
                }
            } while (0);
            n = pc(4) | 0;
            lu(n);
            Fb(n | 0, 25544, 156)
        }

        function Cp(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Dp(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Ep(a) { a = a | 0; return 2 }

        function Fp(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0;
            j = i;
            i = i + 16 | 0;
            k = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[k >> 2];
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = j | 0;
            l = j + 8 | 0;
            c[k >> 2] = c[d >> 2];
            c[l >> 2] = c[e >> 2];
            Bp(a, b, k, l, f, g, h, 19424, 19432);
            i = j;
            return
        }

        function Gp(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            k = i;
            i = i + 16 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = k | 0;
            m = k + 8 | 0;
            n = d + 8 | 0;
            o = Fc[c[(c[n >> 2] | 0) + 20 >> 2] & 255](n) | 0;
            c[l >> 2] = c[e >> 2];
            c[m >> 2] = c[f >> 2];
            f = a[o] | 0;
            if ((f & 1) == 0) {
                p = (f & 255) >>> 1;
                q = o + 1 | 0;
                r = o + 1 | 0
            } else {
                f = c[o + 8 >> 2] | 0;
                p = c[o + 4 >> 2] | 0;
                q = f;
                r = f
            }
            Bp(b, d, l, m, g, h, j, q, r + p | 0);
            i = k;
            return
        }

        function Hp(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            j = i;
            i = i + 32 | 0;
            k = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[k >> 2];
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = j | 0;
            l = j + 8 | 0;
            m = j + 24 | 0;
            Lm(m, f);
            f = m | 0;
            m = c[f >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[l >> 2] = 34864;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34864, l, 114)
            }
            l = (c[8717] | 0) - 1 | 0;
            n = c[m + 8 >> 2] | 0;
            do {
                if ((c[m + 12 >> 2] | 0) - n >> 2 >>> 0 > l >>> 0) {
                    o = c[n + (l << 2) >> 2] | 0;
                    if ((o | 0) == 0) { break }
                    Ul(c[f >> 2] | 0) | 0;
                    p = c[e >> 2] | 0;
                    q = b + 8 | 0;
                    r = Fc[c[c[q >> 2] >> 2] & 255](q) | 0;
                    c[k >> 2] = p;
                    p = (bo(d, k, r, r + 168 | 0, o, g, 0) | 0) - r | 0;
                    if ((p | 0) >= 168) {
                        s = 4;
                        t = 0;
                        u = d | 0;
                        v = c[u >> 2] | 0;
                        w = a | 0;
                        c[w >> 2] = v;
                        i = j;
                        return
                    }
                    c[h + 24 >> 2] = ((p | 0) / 12 | 0 | 0) % 7 | 0;
                    s = 4;
                    t = 0;
                    u = d | 0;
                    v = c[u >> 2] | 0;
                    w = a | 0;
                    c[w >> 2] = v;
                    i = j;
                    return
                }
            } while (0);
            j = pc(4) | 0;
            lu(j);
            Fb(j | 0, 25544, 156)
        }

        function Ip(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            j = i;
            i = i + 32 | 0;
            k = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[k >> 2];
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = j | 0;
            l = j + 8 | 0;
            m = j + 24 | 0;
            Lm(m, f);
            f = m | 0;
            m = c[f >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[l >> 2] = 34864;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34864, l, 114)
            }
            l = (c[8717] | 0) - 1 | 0;
            n = c[m + 8 >> 2] | 0;
            do {
                if ((c[m + 12 >> 2] | 0) - n >> 2 >>> 0 > l >>> 0) {
                    o = c[n + (l << 2) >> 2] | 0;
                    if ((o | 0) == 0) { break }
                    Ul(c[f >> 2] | 0) | 0;
                    p = c[e >> 2] | 0;
                    q = b + 8 | 0;
                    r = Fc[c[(c[q >> 2] | 0) + 4 >> 2] & 255](q) | 0;
                    c[k >> 2] = p;
                    p = (bo(d, k, r, r + 288 | 0, o, g, 0) | 0) - r | 0;
                    if ((p | 0) >= 288) {
                        s = 4;
                        t = 0;
                        u = d | 0;
                        v = c[u >> 2] | 0;
                        w = a | 0;
                        c[w >> 2] = v;
                        i = j;
                        return
                    }
                    c[h + 16 >> 2] = ((p | 0) / 12 | 0 | 0) % 12 | 0;
                    s = 4;
                    t = 0;
                    u = d | 0;
                    v = c[u >> 2] | 0;
                    w = a | 0;
                    c[w >> 2] = v;
                    i = j;
                    return
                }
            } while (0);
            j = pc(4) | 0;
            lu(j);
            Fb(j | 0, 25544, 156)
        }

        function Jp(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            b = i;
            i = i + 32 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            l = b + 24 | 0;
            Lm(l, f);
            f = l | 0;
            l = c[f >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[k >> 2] = 34864;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34864, k, 114)
            }
            k = (c[8717] | 0) - 1 | 0;
            m = c[l + 8 >> 2] | 0;
            do {
                if ((c[l + 12 >> 2] | 0) - m >> 2 >>> 0 > k >>> 0) {
                    n = c[m + (k << 2) >> 2] | 0;
                    if ((n | 0) == 0) { break }
                    Ul(c[f >> 2] | 0) | 0;
                    c[j >> 2] = c[e >> 2];
                    o = Op(d, j, g, n, 4) | 0;
                    if ((c[g >> 2] & 4 | 0) != 0) {
                        p = 4;
                        q = 0;
                        r = d | 0;
                        s = c[r >> 2] | 0;
                        t = a | 0;
                        c[t >> 2] = s;
                        i = b;
                        return
                    }
                    if ((o | 0) < 69) { u = o + 2e3 | 0 } else { u = (o - 69 | 0) >>> 0 < 31 >>> 0 ? o + 1900 | 0 : o }
                    c[h + 20 >> 2] = u - 1900;
                    p = 4;
                    q = 0;
                    r = d | 0;
                    s = c[r >> 2] | 0;
                    t = a | 0;
                    c[t >> 2] = s;
                    i = b;
                    return
                }
            } while (0);
            b = pc(4) | 0;
            lu(b);
            Fb(b | 0, 25544, 156)
        }

        function Kp(b, d, e, f, g, h, j, k, l) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0;
            l = i;
            i = i + 328 | 0;
            m = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[m >> 2];
            m = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[m >> 2];
            m = l | 0;
            n = l + 8 | 0;
            o = l + 16 | 0;
            p = l + 24 | 0;
            q = l + 32 | 0;
            r = l + 40 | 0;
            s = l + 48 | 0;
            t = l + 56 | 0;
            u = l + 64 | 0;
            v = l + 72 | 0;
            w = l + 80 | 0;
            x = l + 88 | 0;
            y = l + 96 | 0;
            z = l + 112 | 0;
            A = l + 120 | 0;
            B = l + 128 | 0;
            C = l + 136 | 0;
            D = l + 144 | 0;
            E = l + 152 | 0;
            F = l + 160 | 0;
            G = l + 168 | 0;
            H = l + 176 | 0;
            I = l + 184 | 0;
            J = l + 192 | 0;
            K = l + 200 | 0;
            L = l + 208 | 0;
            M = l + 216 | 0;
            N = l + 224 | 0;
            O = l + 232 | 0;
            P = l + 240 | 0;
            Q = l + 248 | 0;
            R = l + 256 | 0;
            S = l + 264 | 0;
            T = l + 272 | 0;
            U = l + 280 | 0;
            V = l + 288 | 0;
            W = l + 296 | 0;
            X = l + 304 | 0;
            Y = l + 312 | 0;
            Z = l + 320 | 0;
            c[h >> 2] = 0;
            Lm(z, g);
            _ = z | 0;
            z = c[_ >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[y >> 2] = 34864;
                c[y + 4 >> 2] = 16;
                c[y + 8 >> 2] = 0;
                mm(34864, y, 114)
            }
            y = (c[8717] | 0) - 1 | 0;
            $ = c[z + 8 >> 2] | 0;
            do {
                if ((c[z + 12 >> 2] | 0) - $ >> 2 >>> 0 > y >>> 0) {
                    aa = c[$ + (y << 2) >> 2] | 0;
                    if ((aa | 0) == 0) { break }
                    ba = aa;
                    Ul(c[_ >> 2] | 0) | 0;
                    a: do {
                        switch (k << 24 >> 24 | 0) {
                            case 109:
                                { c[r >> 2] = c[f >> 2];aa = Op(e, r, h, ba, 2) | 0;ca = c[h >> 2] | 0; if ((ca & 4 | 0) == 0 & (aa | 0) < 13) { c[j + 16 >> 2] = aa - 1; break a } else { c[h >> 2] = ca | 4; break a } break };
                            case 121:
                                {
                                    c[n >> 2] = c[f >> 2];ca = Op(e, n, h, ba, 4) | 0;
                                    if ((c[h >> 2] & 4 | 0) != 0) { break a }
                                    if ((ca | 0) < 69) { da = ca + 2e3 | 0 } else { da = (ca - 69 | 0) >>> 0 < 31 >>> 0 ? ca + 1900 | 0 : ca }
                                    c[j + 20 >> 2] = da - 1900;
                                    break
                                };
                            case 68:
                                { ca = e | 0;c[E >> 2] = c[ca >> 2];c[F >> 2] = c[f >> 2];Bp(D, d, E, F, g, h, j, 19416, 19424);c[ca >> 2] = c[D >> 2]; break };
                            case 106:
                                { c[s >> 2] = c[f >> 2];ca = Op(e, s, h, ba, 3) | 0;aa = c[h >> 2] | 0; if ((aa & 4 | 0) == 0 & (ca | 0) < 366) { c[j + 28 >> 2] = ca; break a } else { c[h >> 2] = aa | 4; break a } break };
                            case 98:
                            case 66:
                            case 104:
                                {
                                    aa = c[f >> 2] | 0;ca = d + 8 | 0;ea = Fc[c[(c[ca >> 2] | 0) + 4 >> 2] & 255](ca) | 0;c[w >> 2] = aa;aa = (bo(e, w, ea, ea + 288 | 0, ba, h, 0) | 0) - ea | 0;
                                    if ((aa | 0) >= 288) { break a }
                                    c[j + 16 >> 2] = ((aa | 0) / 12 | 0 | 0) % 12 | 0;
                                    break
                                };
                            case 114:
                                { aa = e | 0;c[M >> 2] = c[aa >> 2];c[N >> 2] = c[f >> 2];Bp(L, d, M, N, g, h, j, 19392, 19403);c[aa >> 2] = c[L >> 2]; break };
                            case 84:
                                { aa = e | 0;c[S >> 2] = c[aa >> 2];c[T >> 2] = c[f >> 2];Bp(R, d, S, T, g, h, j, 19376, 19384);c[aa >> 2] = c[R >> 2]; break };
                            case 119:
                                { c[o >> 2] = c[f >> 2];aa = Op(e, o, h, ba, 1) | 0;ea = c[h >> 2] | 0; if ((ea & 4 | 0) == 0 & (aa | 0) < 7) { c[j + 24 >> 2] = aa; break a } else { c[h >> 2] = ea | 4; break a } break };
                            case 82:
                                { ea = e | 0;c[P >> 2] = c[ea >> 2];c[Q >> 2] = c[f >> 2];Bp(O, d, P, Q, g, h, j, 19384, 19389);c[ea >> 2] = c[O >> 2]; break };
                            case 112:
                                { c[K >> 2] = c[f >> 2];Mp(d, j + 8 | 0, e, K, h, ba); break };
                            case 70:
                                { ea = e | 0;c[H >> 2] = c[ea >> 2];c[I >> 2] = c[f >> 2];Bp(G, d, H, I, g, h, j, 19408, 19416);c[ea >> 2] = c[G >> 2]; break };
                            case 97:
                            case 65:
                                {
                                    ea = c[f >> 2] | 0;aa = d + 8 | 0;ca = Fc[c[c[aa >> 2] >> 2] & 255](aa) | 0;c[x >> 2] = ea;ea = (bo(e, x, ca, ca + 168 | 0, ba, h, 0) | 0) - ca | 0;
                                    if ((ea | 0) >= 168) { break a }
                                    c[j + 24 >> 2] = ((ea | 0) / 12 | 0 | 0) % 7 | 0;
                                    break
                                };
                            case 110:
                            case 116:
                                { c[J >> 2] = c[f >> 2];Lp(0, e, J, h, ba); break };
                            case 83:
                                { c[p >> 2] = c[f >> 2];ea = Op(e, p, h, ba, 2) | 0;ca = c[h >> 2] | 0; if ((ca & 4 | 0) == 0 & (ea | 0) < 61) { c[j >> 2] = ea; break a } else { c[h >> 2] = ca | 4; break a } break };
                            case 73:
                                {
                                    ca = j + 8 | 0;c[t >> 2] = c[f >> 2];ea = Op(e, t, h, ba, 2) | 0;aa = c[h >> 2] | 0;do {
                                        if ((aa & 4 | 0) == 0) {
                                            if (!((ea - 1 | 0) >>> 0 < 12 >>> 0)) { break }
                                            c[ca >> 2] = ea;
                                            break a
                                        }
                                    } while (0);c[h >> 2] = aa | 4;
                                    break
                                };
                            case 77:
                                { c[q >> 2] = c[f >> 2];ea = Op(e, q, h, ba, 2) | 0;ca = c[h >> 2] | 0; if ((ca & 4 | 0) == 0 & (ea | 0) < 60) { c[j + 4 >> 2] = ea; break a } else { c[h >> 2] = ca | 4; break a } break };
                            case 120:
                                { ca = c[(c[d >> 2] | 0) + 20 >> 2] | 0;c[U >> 2] = c[e >> 2];c[V >> 2] = c[f >> 2];Mc[ca & 127](b, d, U, V, g, h, j);i = l; return };
                            case 88:
                                {
                                    ca = d + 8 | 0;ea = Fc[c[(c[ca >> 2] | 0) + 24 >> 2] & 255](ca) | 0;ca = e | 0;c[X >> 2] = c[ca >> 2];c[Y >> 2] = c[f >> 2];fa = a[ea] | 0;
                                    if ((fa & 1) == 0) {
                                        ga = (fa & 255) >>> 1;
                                        ha = ea + 1 | 0;
                                        ia = ea + 1 | 0
                                    } else {
                                        fa = c[ea + 8 >> 2] | 0;
                                        ga = c[ea + 4 >> 2] | 0;
                                        ha = fa;
                                        ia = fa
                                    }
                                    Bp(W, d, X, Y, g, h, j, ha, ia + ga | 0);c[ca >> 2] = c[W >> 2];
                                    break
                                };
                            case 99:
                                {
                                    ca = d + 8 | 0;fa = Fc[c[(c[ca >> 2] | 0) + 12 >> 2] & 255](ca) | 0;ca = e | 0;c[B >> 2] = c[ca >> 2];c[C >> 2] = c[f >> 2];ea = a[fa] | 0;
                                    if ((ea & 1) == 0) {
                                        ja = (ea & 255) >>> 1;
                                        ka = fa + 1 | 0;
                                        la = fa + 1 | 0
                                    } else {
                                        ea = c[fa + 8 >> 2] | 0;
                                        ja = c[fa + 4 >> 2] | 0;
                                        ka = ea;
                                        la = ea
                                    }
                                    Bp(A, d, B, C, g, h, j, ka, la + ja | 0);c[ca >> 2] = c[A >> 2];
                                    break
                                };
                            case 72:
                                { c[u >> 2] = c[f >> 2];ca = Op(e, u, h, ba, 2) | 0;ea = c[h >> 2] | 0; if ((ea & 4 | 0) == 0 & (ca | 0) < 24) { c[j + 8 >> 2] = ca; break a } else { c[h >> 2] = ea | 4; break a } break };
                            case 89:
                                {
                                    c[m >> 2] = c[f >> 2];ea = Op(e, m, h, ba, 4) | 0;
                                    if ((c[h >> 2] & 4 | 0) != 0) { break a }
                                    c[j + 20 >> 2] = ea - 1900;
                                    break
                                };
                            case 37:
                                { c[Z >> 2] = c[f >> 2];Np(0, e, Z, h, ba); break };
                            case 100:
                            case 101:
                                {
                                    ea = j + 12 | 0;c[v >> 2] = c[f >> 2];ca = Op(e, v, h, ba, 2) | 0;fa = c[h >> 2] | 0;do {
                                        if ((fa & 4 | 0) == 0) {
                                            if (!((ca - 1 | 0) >>> 0 < 31 >>> 0)) { break }
                                            c[ea >> 2] = ca;
                                            break a
                                        }
                                    } while (0);c[h >> 2] = fa | 4;
                                    break
                                };
                            default:
                                { c[h >> 2] = c[h >> 2] | 4 }
                        }
                    } while (0);
                    c[b >> 2] = c[e >> 2];
                    i = l;
                    return
                }
            } while (0);
            l = pc(4) | 0;
            lu(l);
            Fb(l | 0, 25544, 156)
        }

        function Lp(d, e, f, g, h) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0;
            d = i;
            j = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[j >> 2];
            j = e | 0;
            e = f | 0;
            f = h + 8 | 0;
            a: while (1) {
                h = c[j >> 2] | 0;
                do {
                    if ((h | 0) == 0) { k = 0 } else {
                        if ((c[h + 12 >> 2] | 0) != (c[h + 16 >> 2] | 0)) { k = h; break }
                        if ((Fc[c[(c[h >> 2] | 0) + 36 >> 2] & 255](h) | 0) == -1) {
                            c[j >> 2] = 0;
                            k = 0;
                            break
                        } else { k = c[j >> 2] | 0; break }
                    }
                } while (0);
                h = (k | 0) == 0;
                l = c[e >> 2] | 0;
                do {
                    if ((l | 0) == 0) { m = 12 } else {
                        if ((c[l + 12 >> 2] | 0) != (c[l + 16 >> 2] | 0)) { if (h) { n = l; break } else { o = l; break a } }
                        if ((Fc[c[(c[l >> 2] | 0) + 36 >> 2] & 255](l) | 0) == -1) {
                            c[e >> 2] = 0;
                            m = 12;
                            break
                        } else { if (h) { n = l; break } else { o = l; break a } }
                    }
                } while (0);
                if ((m | 0) == 12) { m = 0; if (h) { o = 0; break } else { n = 0 } }
                l = c[j >> 2] | 0;
                p = c[l + 12 >> 2] | 0;
                if ((p | 0) == (c[l + 16 >> 2] | 0)) { q = (Fc[c[(c[l >> 2] | 0) + 36 >> 2] & 255](l) | 0) & 255 } else { q = a[p] | 0 }
                if (!(q << 24 >> 24 > -1)) { o = n; break }
                if ((b[(c[f >> 2] | 0) + (q << 24 >> 24 << 1) >> 1] & 8192) == 0) { o = n; break }
                p = c[j >> 2] | 0;
                l = p + 12 | 0;
                r = c[l >> 2] | 0;
                if ((r | 0) == (c[p + 16 >> 2] | 0)) { Fc[c[(c[p >> 2] | 0) + 40 >> 2] & 255](p) | 0; continue } else { c[l >> 2] = r + 1; continue }
            }
            n = c[j >> 2] | 0;
            do {
                if ((n | 0) == 0) { s = 0 } else {
                    if ((c[n + 12 >> 2] | 0) != (c[n + 16 >> 2] | 0)) { s = n; break }
                    if ((Fc[c[(c[n >> 2] | 0) + 36 >> 2] & 255](n) | 0) == -1) {
                        c[j >> 2] = 0;
                        s = 0;
                        break
                    } else { s = c[j >> 2] | 0; break }
                }
            } while (0);
            j = (s | 0) == 0;
            b: do {
                if ((o | 0) == 0) { m = 32 } else {
                    do {
                        if ((c[o + 12 >> 2] | 0) == (c[o + 16 >> 2] | 0)) {
                            if (!((Fc[c[(c[o >> 2] | 0) + 36 >> 2] & 255](o) | 0) == -1)) { break }
                            c[e >> 2] = 0;
                            m = 32;
                            break b
                        }
                    } while (0);
                    if (!j) { break }
                    i = d;
                    return
                }
            } while (0);
            do {
                if ((m | 0) == 32) {
                    if (j) { break }
                    i = d;
                    return
                }
            } while (0);
            c[g >> 2] = c[g >> 2] | 2;
            i = d;
            return
        }

        function Mp(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            j = i;
            i = i + 8 | 0;
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = j | 0;
            l = b + 8 | 0;
            b = Fc[c[(c[l >> 2] | 0) + 8 >> 2] & 255](l) | 0;
            l = a[b] | 0;
            if ((l & 1) == 0) { m = (l & 255) >>> 1 } else { m = c[b + 4 >> 2] | 0 }
            l = a[b + 12 | 0] | 0;
            if ((l & 1) == 0) { n = (l & 255) >>> 1 } else { n = c[b + 16 >> 2] | 0 }
            if ((m | 0) == (-n | 0)) {
                c[g >> 2] = c[g >> 2] | 4;
                i = j;
                return
            }
            c[k >> 2] = c[f >> 2];
            f = bo(e, k, b, b + 24 | 0, h, g, 0) | 0;
            g = f - b | 0;
            do {
                if ((f | 0) == (b | 0)) {
                    if ((c[d >> 2] | 0) != 12) { break }
                    c[d >> 2] = 0;
                    i = j;
                    return
                }
            } while (0);
            if ((g | 0) != 12) { i = j; return }
            g = c[d >> 2] | 0;
            if ((g | 0) >= 12) { i = j; return }
            c[d >> 2] = g + 12;
            i = j;
            return
        }

        function Np(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            b = i;
            h = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[h >> 2];
            h = d | 0;
            d = c[h >> 2] | 0;
            do {
                if ((d | 0) == 0) { j = 0 } else {
                    if ((c[d + 12 >> 2] | 0) != (c[d + 16 >> 2] | 0)) { j = d; break }
                    if ((Fc[c[(c[d >> 2] | 0) + 36 >> 2] & 255](d) | 0) == -1) {
                        c[h >> 2] = 0;
                        j = 0;
                        break
                    } else { j = c[h >> 2] | 0; break }
                }
            } while (0);
            d = (j | 0) == 0;
            j = e | 0;
            e = c[j >> 2] | 0;
            a: do {
                if ((e | 0) == 0) { k = 11 } else {
                    do {
                        if ((c[e + 12 >> 2] | 0) == (c[e + 16 >> 2] | 0)) {
                            if (!((Fc[c[(c[e >> 2] | 0) + 36 >> 2] & 255](e) | 0) == -1)) { break }
                            c[j >> 2] = 0;
                            k = 11;
                            break a
                        }
                    } while (0);
                    if (d) { l = e } else { k = 12 }
                }
            } while (0);
            if ((k | 0) == 11) { if (d) { k = 12 } else { l = 0 } }
            if ((k | 0) == 12) {
                c[f >> 2] = c[f >> 2] | 6;
                i = b;
                return
            }
            d = c[h >> 2] | 0;
            e = c[d + 12 >> 2] | 0;
            if ((e | 0) == (c[d + 16 >> 2] | 0)) { m = (Fc[c[(c[d >> 2] | 0) + 36 >> 2] & 255](d) | 0) & 255 } else { m = a[e] | 0 }
            if (!((Hc[c[(c[g >> 2] | 0) + 36 >> 2] & 63](g, m, 0) | 0) << 24 >> 24 == 37)) {
                c[f >> 2] = c[f >> 2] | 4;
                i = b;
                return
            }
            m = c[h >> 2] | 0;
            g = m + 12 | 0;
            e = c[g >> 2] | 0;
            if ((e | 0) == (c[m + 16 >> 2] | 0)) { Fc[c[(c[m >> 2] | 0) + 40 >> 2] & 255](m) | 0 } else { c[g >> 2] = e + 1 }
            e = c[h >> 2] | 0;
            do {
                if ((e | 0) == 0) { n = 0 } else {
                    if ((c[e + 12 >> 2] | 0) != (c[e + 16 >> 2] | 0)) { n = e; break }
                    if ((Fc[c[(c[e >> 2] | 0) + 36 >> 2] & 255](e) | 0) == -1) {
                        c[h >> 2] = 0;
                        n = 0;
                        break
                    } else { n = c[h >> 2] | 0; break }
                }
            } while (0);
            h = (n | 0) == 0;
            b: do {
                if ((l | 0) == 0) { k = 31 } else {
                    do {
                        if ((c[l + 12 >> 2] | 0) == (c[l + 16 >> 2] | 0)) {
                            if (!((Fc[c[(c[l >> 2] | 0) + 36 >> 2] & 255](l) | 0) == -1)) { break }
                            c[j >> 2] = 0;
                            k = 31;
                            break b
                        }
                    } while (0);
                    if (!h) { break }
                    i = b;
                    return
                }
            } while (0);
            do {
                if ((k | 0) == 31) {
                    if (h) { break }
                    i = b;
                    return
                }
            } while (0);
            c[f >> 2] = c[f >> 2] | 2;
            i = b;
            return
        }

        function Op(d, e, f, g, h) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0;
            j = i;
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = d | 0;
            d = c[k >> 2] | 0;
            do {
                if ((d | 0) == 0) { l = 0 } else {
                    if ((c[d + 12 >> 2] | 0) != (c[d + 16 >> 2] | 0)) { l = d; break }
                    if ((Fc[c[(c[d >> 2] | 0) + 36 >> 2] & 255](d) | 0) == -1) {
                        c[k >> 2] = 0;
                        l = 0;
                        break
                    } else { l = c[k >> 2] | 0; break }
                }
            } while (0);
            d = (l | 0) == 0;
            l = e | 0;
            e = c[l >> 2] | 0;
            a: do {
                if ((e | 0) == 0) { m = 11 } else {
                    do {
                        if ((c[e + 12 >> 2] | 0) == (c[e + 16 >> 2] | 0)) {
                            if (!((Fc[c[(c[e >> 2] | 0) + 36 >> 2] & 255](e) | 0) == -1)) { break }
                            c[l >> 2] = 0;
                            m = 11;
                            break a
                        }
                    } while (0);
                    if (d) { n = e } else { m = 12 }
                }
            } while (0);
            if ((m | 0) == 11) { if (d) { m = 12 } else { n = 0 } }
            if ((m | 0) == 12) {
                c[f >> 2] = c[f >> 2] | 6;
                o = 0;
                i = j;
                return o | 0
            }
            d = c[k >> 2] | 0;
            e = c[d + 12 >> 2] | 0;
            if ((e | 0) == (c[d + 16 >> 2] | 0)) { p = (Fc[c[(c[d >> 2] | 0) + 36 >> 2] & 255](d) | 0) & 255 } else { p = a[e] | 0 }
            do {
                if (p << 24 >> 24 > -1) {
                    e = g + 8 | 0;
                    if ((b[(c[e >> 2] | 0) + (p << 24 >> 24 << 1) >> 1] & 2048) == 0) { break }
                    d = g;
                    q = (Hc[c[(c[d >> 2] | 0) + 36 >> 2] & 63](g, p, 0) | 0) << 24 >> 24;
                    r = c[k >> 2] | 0;
                    s = r + 12 | 0;
                    t = c[s >> 2] | 0;
                    if ((t | 0) == (c[r + 16 >> 2] | 0)) {
                        Fc[c[(c[r >> 2] | 0) + 40 >> 2] & 255](r) | 0;
                        u = q;
                        v = h;
                        w = n;
                        x = n
                    } else {
                        c[s >> 2] = t + 1;
                        u = q;
                        v = h;
                        w = n;
                        x = n
                    }
                    while (1) {
                        y = u - 48 | 0;
                        q = v - 1 | 0;
                        t = c[k >> 2] | 0;
                        do {
                            if ((t | 0) == 0) { z = 0 } else {
                                if ((c[t + 12 >> 2] | 0) != (c[t + 16 >> 2] | 0)) { z = t; break }
                                if ((Fc[c[(c[t >> 2] | 0) + 36 >> 2] & 255](t) | 0) == -1) {
                                    c[k >> 2] = 0;
                                    z = 0;
                                    break
                                } else { z = c[k >> 2] | 0; break }
                            }
                        } while (0);
                        t = (z | 0) == 0;
                        do {
                            if ((w | 0) == 0) {
                                A = 0;
                                B = x
                            } else {
                                if ((c[w + 12 >> 2] | 0) != (c[w + 16 >> 2] | 0)) {
                                    A = w;
                                    B = x;
                                    break
                                }
                                if (!((Fc[c[(c[w >> 2] | 0) + 36 >> 2] & 255](w) | 0) == -1)) {
                                    A = x;
                                    B = x;
                                    break
                                }
                                c[l >> 2] = 0;
                                A = 0;
                                B = 0
                            }
                        } while (0);
                        C = c[k >> 2] | 0;
                        if (!((t ^ (A | 0) == 0) & (q | 0) > 0)) { m = 40; break }
                        s = c[C + 12 >> 2] | 0;
                        if ((s | 0) == (c[C + 16 >> 2] | 0)) { D = (Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0) & 255 } else { D = a[s] | 0 }
                        if (!(D << 24 >> 24 > -1)) {
                            o = y;
                            m = 52;
                            break
                        }
                        if ((b[(c[e >> 2] | 0) + (D << 24 >> 24 << 1) >> 1] & 2048) == 0) {
                            o = y;
                            m = 52;
                            break
                        }
                        s = ((Hc[c[(c[d >> 2] | 0) + 36 >> 2] & 63](g, D, 0) | 0) << 24 >> 24) + (y * 10 | 0) | 0;
                        r = c[k >> 2] | 0;
                        E = r + 12 | 0;
                        F = c[E >> 2] | 0;
                        if ((F | 0) == (c[r + 16 >> 2] | 0)) {
                            Fc[c[(c[r >> 2] | 0) + 40 >> 2] & 255](r) | 0;
                            u = s;
                            v = q;
                            w = A;
                            x = B;
                            continue
                        } else {
                            c[E >> 2] = F + 1;
                            u = s;
                            v = q;
                            w = A;
                            x = B;
                            continue
                        }
                    }
                    if ((m | 0) == 40) {
                        do {
                            if ((C | 0) == 0) { G = 0 } else {
                                if ((c[C + 12 >> 2] | 0) != (c[C + 16 >> 2] | 0)) { G = C; break }
                                if ((Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0) == -1) {
                                    c[k >> 2] = 0;
                                    G = 0;
                                    break
                                } else { G = c[k >> 2] | 0; break }
                            }
                        } while (0);
                        d = (G | 0) == 0;
                        b: do {
                            if ((B | 0) == 0) { m = 50 } else {
                                do {
                                    if ((c[B + 12 >> 2] | 0) == (c[B + 16 >> 2] | 0)) {
                                        if (!((Fc[c[(c[B >> 2] | 0) + 36 >> 2] & 255](B) | 0) == -1)) { break }
                                        c[l >> 2] = 0;
                                        m = 50;
                                        break b
                                    }
                                } while (0);
                                if (d) { o = y } else { break }
                                i = j;
                                return o | 0
                            }
                        } while (0);
                        do {
                            if ((m | 0) == 50) {
                                if (d) { break } else { o = y }
                                i = j;
                                return o | 0
                            }
                        } while (0);
                        c[f >> 2] = c[f >> 2] | 2;
                        o = y;
                        i = j;
                        return o | 0
                    } else if ((m | 0) == 52) { i = j; return o | 0 }
                }
            } while (0);
            c[f >> 2] = c[f >> 2] | 4;
            o = 0;
            i = j;
            return o | 0
        }

        function Pp(a, b, d, e, f, g, h, j, k) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0;
            l = i;
            i = i + 48 | 0;
            m = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[m >> 2];
            m = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[m >> 2];
            m = l | 0;
            n = l + 16 | 0;
            o = l + 24 | 0;
            p = l + 32 | 0;
            q = l + 40 | 0;
            Lm(n, f);
            r = n | 0;
            n = c[r >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[m >> 2] = 34856;
                c[m + 4 >> 2] = 16;
                c[m + 8 >> 2] = 0;
                mm(34856, m, 114)
            }
            m = (c[8715] | 0) - 1 | 0;
            s = c[n + 8 >> 2] | 0;
            do {
                if ((c[n + 12 >> 2] | 0) - s >> 2 >>> 0 > m >>> 0) {
                    t = c[s + (m << 2) >> 2] | 0;
                    if ((t | 0) == 0) { break }
                    u = t;
                    Ul(c[r >> 2] | 0) | 0;
                    c[g >> 2] = 0;
                    v = d | 0;
                    a: do {
                        if ((j | 0) == (k | 0)) { w = 71 } else {
                            x = e | 0;
                            y = t;
                            z = t;
                            A = t;
                            B = b;
                            C = p | 0;
                            D = q | 0;
                            E = o | 0;
                            F = j;
                            G = 0;
                            b: while (1) {
                                H = G;
                                while (1) {
                                    if ((H | 0) != 0) { w = 71; break a }
                                    I = c[v >> 2] | 0;
                                    do {
                                        if ((I | 0) == 0) {
                                            J = 1;
                                            K = 0
                                        } else {
                                            L = c[I + 12 >> 2] | 0;
                                            if ((L | 0) == (c[I + 16 >> 2] | 0)) { M = Fc[c[(c[I >> 2] | 0) + 36 >> 2] & 255](I) | 0 } else { M = c[L >> 2] | 0 }
                                            if (!((M | 0) == -1)) {
                                                J = 0;
                                                K = I;
                                                break
                                            }
                                            c[v >> 2] = 0;
                                            J = 1;
                                            K = 0
                                        }
                                    } while (0);
                                    I = c[x >> 2] | 0;
                                    do {
                                        if ((I | 0) == 0) { w = 23 } else {
                                            L = c[I + 12 >> 2] | 0;
                                            if ((L | 0) == (c[I + 16 >> 2] | 0)) { N = Fc[c[(c[I >> 2] | 0) + 36 >> 2] & 255](I) | 0 } else { N = c[L >> 2] | 0 }
                                            if ((N | 0) == -1) {
                                                c[x >> 2] = 0;
                                                w = 23;
                                                break
                                            } else { if (J) { O = I; break } else { w = 25; break b } }
                                        }
                                    } while (0);
                                    if ((w | 0) == 23) { w = 0; if (J) { w = 25; break b } else { O = 0 } }
                                    if ((Hc[c[(c[y >> 2] | 0) + 52 >> 2] & 63](u, c[F >> 2] | 0, 0) | 0) << 24 >> 24 == 37) { w = 28; break }
                                    if (Hc[c[(c[z >> 2] | 0) + 12 >> 2] & 63](u, 8192, c[F >> 2] | 0) | 0) {
                                        P = F;
                                        w = 38;
                                        break
                                    }
                                    Q = K + 12 | 0;
                                    I = c[Q >> 2] | 0;
                                    R = K + 16 | 0;
                                    if ((I | 0) == (c[R >> 2] | 0)) { S = Fc[c[(c[K >> 2] | 0) + 36 >> 2] & 255](K) | 0 } else { S = c[I >> 2] | 0 }
                                    I = Qc[c[(c[A >> 2] | 0) + 28 >> 2] & 63](u, S) | 0;
                                    if ((I | 0) == (Qc[c[(c[A >> 2] | 0) + 28 >> 2] & 63](u, c[F >> 2] | 0) | 0)) { w = 66; break }
                                    c[g >> 2] = 4;
                                    H = 4
                                }
                                c: do {
                                    if ((w | 0) == 28) {
                                        w = 0;
                                        H = F + 4 | 0;
                                        if ((H | 0) == (k | 0)) { w = 29; break b }
                                        I = Hc[c[(c[y >> 2] | 0) + 52 >> 2] & 63](u, c[H >> 2] | 0, 0) | 0;
                                        if ((I << 24 >> 24 | 0) == 69 | (I << 24 >> 24 | 0) == 48) {
                                            L = F + 8 | 0;
                                            if ((L | 0) == (k | 0)) { w = 32; break b }
                                            T = I;
                                            U = Hc[c[(c[y >> 2] | 0) + 52 >> 2] & 63](u, c[L >> 2] | 0, 0) | 0;
                                            V = L
                                        } else {
                                            T = 0;
                                            U = I;
                                            V = H
                                        }
                                        H = c[(c[B >> 2] | 0) + 36 >> 2] | 0;
                                        c[C >> 2] = K;
                                        c[D >> 2] = O;
                                        Oc[H & 15](o, b, p, q, f, g, h, U, T);
                                        c[v >> 2] = c[E >> 2];
                                        W = V + 4 | 0
                                    } else if ((w | 0) == 38) {
                                        while (1) {
                                            w = 0;
                                            H = P + 4 | 0;
                                            if ((H | 0) == (k | 0)) { X = k; break }
                                            if (Hc[c[(c[z >> 2] | 0) + 12 >> 2] & 63](u, 8192, c[H >> 2] | 0) | 0) {
                                                P = H;
                                                w = 38
                                            } else { X = H; break }
                                        }
                                        H = K;
                                        I = O;
                                        L = O;
                                        while (1) {
                                            do {
                                                if ((H | 0) == 0) {
                                                    Y = 1;
                                                    Z = 0
                                                } else {
                                                    _ = c[H + 12 >> 2] | 0;
                                                    if ((_ | 0) == (c[H + 16 >> 2] | 0)) { $ = Fc[c[(c[H >> 2] | 0) + 36 >> 2] & 255](H) | 0 } else { $ = c[_ >> 2] | 0 }
                                                    if (!(($ | 0) == -1)) {
                                                        Y = 0;
                                                        Z = H;
                                                        break
                                                    }
                                                    c[v >> 2] = 0;
                                                    Y = 1;
                                                    Z = 0
                                                }
                                            } while (0);
                                            do {
                                                if ((I | 0) == 0) {
                                                    aa = L;
                                                    w = 53
                                                } else {
                                                    _ = c[I + 12 >> 2] | 0;
                                                    if ((_ | 0) == (c[I + 16 >> 2] | 0)) { ba = Fc[c[(c[I >> 2] | 0) + 36 >> 2] & 255](I) | 0 } else { ba = c[_ >> 2] | 0 }
                                                    if ((ba | 0) == -1) {
                                                        c[x >> 2] = 0;
                                                        aa = 0;
                                                        w = 53;
                                                        break
                                                    } else {
                                                        if (Y ^ (L | 0) == 0) {
                                                            ca = L;
                                                            da = L;
                                                            break
                                                        } else { W = X; break c }
                                                    }
                                                }
                                            } while (0);
                                            if ((w | 0) == 53) {
                                                w = 0;
                                                if (Y) { W = X; break c } else {
                                                    ca = 0;
                                                    da = aa
                                                }
                                            }
                                            _ = Z + 12 | 0;
                                            ea = c[_ >> 2] | 0;
                                            fa = Z + 16 | 0;
                                            if ((ea | 0) == (c[fa >> 2] | 0)) { ga = Fc[c[(c[Z >> 2] | 0) + 36 >> 2] & 255](Z) | 0 } else { ga = c[ea >> 2] | 0 }
                                            if (!(Hc[c[(c[z >> 2] | 0) + 12 >> 2] & 63](u, 8192, ga) | 0)) { W = X; break c }
                                            ea = c[_ >> 2] | 0;
                                            if ((ea | 0) == (c[fa >> 2] | 0)) {
                                                Fc[c[(c[Z >> 2] | 0) + 40 >> 2] & 255](Z) | 0;
                                                H = Z;
                                                I = ca;
                                                L = da;
                                                continue
                                            } else {
                                                c[_ >> 2] = ea + 4;
                                                H = Z;
                                                I = ca;
                                                L = da;
                                                continue
                                            }
                                        }
                                    } else if ((w | 0) == 66) {
                                        w = 0;
                                        L = c[Q >> 2] | 0;
                                        if ((L | 0) == (c[R >> 2] | 0)) { Fc[c[(c[K >> 2] | 0) + 40 >> 2] & 255](K) | 0 } else { c[Q >> 2] = L + 4 }
                                        W = F + 4 | 0
                                    }
                                } while (0);
                                if ((W | 0) == (k | 0)) { w = 71; break a }
                                F = W;
                                G = c[g >> 2] | 0
                            }
                            if ((w | 0) == 25) {
                                c[g >> 2] = 4;
                                ha = K;
                                break
                            } else if ((w | 0) == 29) {
                                c[g >> 2] = 4;
                                ha = K;
                                break
                            } else if ((w | 0) == 32) {
                                c[g >> 2] = 4;
                                ha = K;
                                break
                            }
                        }
                    } while (0);
                    if ((w | 0) == 71) { ha = c[v >> 2] | 0 }
                    u = d | 0;
                    do {
                        if ((ha | 0) == 0) {
                            ia = 1;
                            ja = 0
                        } else {
                            t = c[ha + 12 >> 2] | 0;
                            if ((t | 0) == (c[ha + 16 >> 2] | 0)) { ka = Fc[c[(c[ha >> 2] | 0) + 36 >> 2] & 255](ha) | 0 } else { ka = c[t >> 2] | 0 }
                            if (!((ka | 0) == -1)) {
                                ia = 0;
                                ja = ha;
                                break
                            }
                            c[u >> 2] = 0;
                            ia = 1;
                            ja = 0
                        }
                    } while (0);
                    u = e | 0;
                    v = c[u >> 2] | 0;
                    do {
                        if ((v | 0) == 0) { w = 84 } else {
                            t = c[v + 12 >> 2] | 0;
                            if ((t | 0) == (c[v + 16 >> 2] | 0)) { la = Fc[c[(c[v >> 2] | 0) + 36 >> 2] & 255](v) | 0 } else { la = c[t >> 2] | 0 }
                            if ((la | 0) == -1) {
                                c[u >> 2] = 0;
                                w = 84;
                                break
                            }
                            if (!ia) { break }
                            ma = a | 0;
                            c[ma >> 2] = ja;
                            i = l;
                            return
                        }
                    } while (0);
                    do {
                        if ((w | 0) == 84) {
                            if (ia) { break }
                            ma = a | 0;
                            c[ma >> 2] = ja;
                            i = l;
                            return
                        }
                    } while (0);
                    c[g >> 2] = c[g >> 2] | 2;
                    ma = a | 0;
                    c[ma >> 2] = ja;
                    i = l;
                    return
                }
            } while (0);
            l = pc(4) | 0;
            lu(l);
            Fb(l | 0, 25544, 156)
        }

        function Qp(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Rp(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Sp(a) { a = a | 0; return 2 }

        function Tp(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0;
            j = i;
            i = i + 16 | 0;
            k = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[k >> 2];
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = j | 0;
            l = j + 8 | 0;
            c[k >> 2] = c[d >> 2];
            c[l >> 2] = c[e >> 2];
            Pp(a, b, k, l, f, g, h, 19344, 19376);
            i = j;
            return
        }

        function Up(b, d, e, f, g, h, j) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            k = i;
            i = i + 16 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = k | 0;
            m = k + 8 | 0;
            n = d + 8 | 0;
            o = Fc[c[(c[n >> 2] | 0) + 20 >> 2] & 255](n) | 0;
            c[l >> 2] = c[e >> 2];
            c[m >> 2] = c[f >> 2];
            f = a[o] | 0;
            if ((f & 1) == 0) {
                p = (f & 255) >>> 1;
                q = o + 4 | 0;
                r = o + 4 | 0
            } else {
                f = c[o + 8 >> 2] | 0;
                p = c[o + 4 >> 2] | 0;
                q = f;
                r = f
            }
            Pp(b, d, l, m, g, h, j, q, r + (p << 2) | 0);
            i = k;
            return
        }

        function Vp(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            j = i;
            i = i + 32 | 0;
            k = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[k >> 2];
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = j | 0;
            l = j + 8 | 0;
            m = j + 24 | 0;
            Lm(m, f);
            f = m | 0;
            m = c[f >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[l >> 2] = 34856;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34856, l, 114)
            }
            l = (c[8715] | 0) - 1 | 0;
            n = c[m + 8 >> 2] | 0;
            do {
                if ((c[m + 12 >> 2] | 0) - n >> 2 >>> 0 > l >>> 0) {
                    o = c[n + (l << 2) >> 2] | 0;
                    if ((o | 0) == 0) { break }
                    Ul(c[f >> 2] | 0) | 0;
                    p = c[e >> 2] | 0;
                    q = b + 8 | 0;
                    r = Fc[c[c[q >> 2] >> 2] & 255](q) | 0;
                    c[k >> 2] = p;
                    p = (Bo(d, k, r, r + 168 | 0, o, g, 0) | 0) - r | 0;
                    if ((p | 0) >= 168) {
                        s = 4;
                        t = 0;
                        u = d | 0;
                        v = c[u >> 2] | 0;
                        w = a | 0;
                        c[w >> 2] = v;
                        i = j;
                        return
                    }
                    c[h + 24 >> 2] = ((p | 0) / 12 | 0 | 0) % 7 | 0;
                    s = 4;
                    t = 0;
                    u = d | 0;
                    v = c[u >> 2] | 0;
                    w = a | 0;
                    c[w >> 2] = v;
                    i = j;
                    return
                }
            } while (0);
            j = pc(4) | 0;
            lu(j);
            Fb(j | 0, 25544, 156)
        }

        function Wp(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            j = i;
            i = i + 32 | 0;
            k = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[k >> 2];
            k = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[k >> 2];
            k = j | 0;
            l = j + 8 | 0;
            m = j + 24 | 0;
            Lm(m, f);
            f = m | 0;
            m = c[f >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[l >> 2] = 34856;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34856, l, 114)
            }
            l = (c[8715] | 0) - 1 | 0;
            n = c[m + 8 >> 2] | 0;
            do {
                if ((c[m + 12 >> 2] | 0) - n >> 2 >>> 0 > l >>> 0) {
                    o = c[n + (l << 2) >> 2] | 0;
                    if ((o | 0) == 0) { break }
                    Ul(c[f >> 2] | 0) | 0;
                    p = c[e >> 2] | 0;
                    q = b + 8 | 0;
                    r = Fc[c[(c[q >> 2] | 0) + 4 >> 2] & 255](q) | 0;
                    c[k >> 2] = p;
                    p = (Bo(d, k, r, r + 288 | 0, o, g, 0) | 0) - r | 0;
                    if ((p | 0) >= 288) {
                        s = 4;
                        t = 0;
                        u = d | 0;
                        v = c[u >> 2] | 0;
                        w = a | 0;
                        c[w >> 2] = v;
                        i = j;
                        return
                    }
                    c[h + 16 >> 2] = ((p | 0) / 12 | 0 | 0) % 12 | 0;
                    s = 4;
                    t = 0;
                    u = d | 0;
                    v = c[u >> 2] | 0;
                    w = a | 0;
                    c[w >> 2] = v;
                    i = j;
                    return
                }
            } while (0);
            j = pc(4) | 0;
            lu(j);
            Fb(j | 0, 25544, 156)
        }

        function Xp(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            b = i;
            i = i + 32 | 0;
            j = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[j >> 2];
            j = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[j >> 2];
            j = b | 0;
            k = b + 8 | 0;
            l = b + 24 | 0;
            Lm(l, f);
            f = l | 0;
            l = c[f >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[k >> 2] = 34856;
                c[k + 4 >> 2] = 16;
                c[k + 8 >> 2] = 0;
                mm(34856, k, 114)
            }
            k = (c[8715] | 0) - 1 | 0;
            m = c[l + 8 >> 2] | 0;
            do {
                if ((c[l + 12 >> 2] | 0) - m >> 2 >>> 0 > k >>> 0) {
                    n = c[m + (k << 2) >> 2] | 0;
                    if ((n | 0) == 0) { break }
                    Ul(c[f >> 2] | 0) | 0;
                    c[j >> 2] = c[e >> 2];
                    o = aq(d, j, g, n, 4) | 0;
                    if ((c[g >> 2] & 4 | 0) != 0) {
                        p = 4;
                        q = 0;
                        r = d | 0;
                        s = c[r >> 2] | 0;
                        t = a | 0;
                        c[t >> 2] = s;
                        i = b;
                        return
                    }
                    if ((o | 0) < 69) { u = o + 2e3 | 0 } else { u = (o - 69 | 0) >>> 0 < 31 >>> 0 ? o + 1900 | 0 : o }
                    c[h + 20 >> 2] = u - 1900;
                    p = 4;
                    q = 0;
                    r = d | 0;
                    s = c[r >> 2] | 0;
                    t = a | 0;
                    c[t >> 2] = s;
                    i = b;
                    return
                }
            } while (0);
            b = pc(4) | 0;
            lu(b);
            Fb(b | 0, 25544, 156)
        }

        function Yp(b, d, e, f, g, h, j, k, l) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            var m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0;
            l = i;
            i = i + 328 | 0;
            m = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[m >> 2];
            m = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[m >> 2];
            m = l | 0;
            n = l + 8 | 0;
            o = l + 16 | 0;
            p = l + 24 | 0;
            q = l + 32 | 0;
            r = l + 40 | 0;
            s = l + 48 | 0;
            t = l + 56 | 0;
            u = l + 64 | 0;
            v = l + 72 | 0;
            w = l + 80 | 0;
            x = l + 88 | 0;
            y = l + 96 | 0;
            z = l + 112 | 0;
            A = l + 120 | 0;
            B = l + 128 | 0;
            C = l + 136 | 0;
            D = l + 144 | 0;
            E = l + 152 | 0;
            F = l + 160 | 0;
            G = l + 168 | 0;
            H = l + 176 | 0;
            I = l + 184 | 0;
            J = l + 192 | 0;
            K = l + 200 | 0;
            L = l + 208 | 0;
            M = l + 216 | 0;
            N = l + 224 | 0;
            O = l + 232 | 0;
            P = l + 240 | 0;
            Q = l + 248 | 0;
            R = l + 256 | 0;
            S = l + 264 | 0;
            T = l + 272 | 0;
            U = l + 280 | 0;
            V = l + 288 | 0;
            W = l + 296 | 0;
            X = l + 304 | 0;
            Y = l + 312 | 0;
            Z = l + 320 | 0;
            c[h >> 2] = 0;
            Lm(z, g);
            _ = z | 0;
            z = c[_ >> 2] | 0;
            if (!((c[8714] | 0) == -1)) {
                c[y >> 2] = 34856;
                c[y + 4 >> 2] = 16;
                c[y + 8 >> 2] = 0;
                mm(34856, y, 114)
            }
            y = (c[8715] | 0) - 1 | 0;
            $ = c[z + 8 >> 2] | 0;
            do {
                if ((c[z + 12 >> 2] | 0) - $ >> 2 >>> 0 > y >>> 0) {
                    aa = c[$ + (y << 2) >> 2] | 0;
                    if ((aa | 0) == 0) { break }
                    ba = aa;
                    Ul(c[_ >> 2] | 0) | 0;
                    a: do {
                        switch (k << 24 >> 24 | 0) {
                            case 84:
                                { aa = e | 0;c[S >> 2] = c[aa >> 2];c[T >> 2] = c[f >> 2];Pp(R, d, S, T, g, h, j, 19208, 19240);c[aa >> 2] = c[R >> 2]; break };
                            case 119:
                                { c[o >> 2] = c[f >> 2];aa = aq(e, o, h, ba, 1) | 0;ca = c[h >> 2] | 0; if ((ca & 4 | 0) == 0 & (aa | 0) < 7) { c[j + 24 >> 2] = aa; break a } else { c[h >> 2] = ca | 4; break a } break };
                            case 77:
                                { c[q >> 2] = c[f >> 2];ca = aq(e, q, h, ba, 2) | 0;aa = c[h >> 2] | 0; if ((aa & 4 | 0) == 0 & (ca | 0) < 60) { c[j + 4 >> 2] = ca; break a } else { c[h >> 2] = aa | 4; break a } break };
                            case 110:
                            case 116:
                                { c[J >> 2] = c[f >> 2];Zp(0, e, J, h, ba); break };
                            case 82:
                                { aa = e | 0;c[P >> 2] = c[aa >> 2];c[Q >> 2] = c[f >> 2];Pp(O, d, P, Q, g, h, j, 19240, 19260);c[aa >> 2] = c[O >> 2]; break };
                            case 106:
                                { c[s >> 2] = c[f >> 2];aa = aq(e, s, h, ba, 3) | 0;ca = c[h >> 2] | 0; if ((ca & 4 | 0) == 0 & (aa | 0) < 366) { c[j + 28 >> 2] = aa; break a } else { c[h >> 2] = ca | 4; break a } break };
                            case 89:
                                {
                                    c[m >> 2] = c[f >> 2];ca = aq(e, m, h, ba, 4) | 0;
                                    if ((c[h >> 2] & 4 | 0) != 0) { break a }
                                    c[j + 20 >> 2] = ca - 1900;
                                    break
                                };
                            case 37:
                                { c[Z >> 2] = c[f >> 2];$p(0, e, Z, h, ba); break };
                            case 109:
                                { c[r >> 2] = c[f >> 2];ca = aq(e, r, h, ba, 2) | 0;aa = c[h >> 2] | 0; if ((aa & 4 | 0) == 0 & (ca | 0) < 13) { c[j + 16 >> 2] = ca - 1; break a } else { c[h >> 2] = aa | 4; break a } break };
                            case 72:
                                { c[u >> 2] = c[f >> 2];aa = aq(e, u, h, ba, 2) | 0;ca = c[h >> 2] | 0; if ((ca & 4 | 0) == 0 & (aa | 0) < 24) { c[j + 8 >> 2] = aa; break a } else { c[h >> 2] = ca | 4; break a } break };
                            case 98:
                            case 66:
                            case 104:
                                {
                                    ca = c[f >> 2] | 0;aa = d + 8 | 0;da = Fc[c[(c[aa >> 2] | 0) + 4 >> 2] & 255](aa) | 0;c[w >> 2] = ca;ca = (Bo(e, w, da, da + 288 | 0, ba, h, 0) | 0) - da | 0;
                                    if ((ca | 0) >= 288) { break a }
                                    c[j + 16 >> 2] = ((ca | 0) / 12 | 0 | 0) % 12 | 0;
                                    break
                                };
                            case 68:
                                { ca = e | 0;c[E >> 2] = c[ca >> 2];c[F >> 2] = c[f >> 2];Pp(D, d, E, F, g, h, j, 19312, 19344);c[ca >> 2] = c[D >> 2]; break };
                            case 112:
                                { c[K >> 2] = c[f >> 2];_p(d, j + 8 | 0, e, K, h, ba); break };
                            case 114:
                                { ca = e | 0;c[M >> 2] = c[ca >> 2];c[N >> 2] = c[f >> 2];Pp(L, d, M, N, g, h, j, 19264, 19308);c[ca >> 2] = c[L >> 2]; break };
                            case 73:
                                {
                                    ca = j + 8 | 0;c[t >> 2] = c[f >> 2];da = aq(e, t, h, ba, 2) | 0;aa = c[h >> 2] | 0;do {
                                        if ((aa & 4 | 0) == 0) {
                                            if (!((da - 1 | 0) >>> 0 < 12 >>> 0)) { break }
                                            c[ca >> 2] = da;
                                            break a
                                        }
                                    } while (0);c[h >> 2] = aa | 4;
                                    break
                                };
                            case 120:
                                { da = c[(c[d >> 2] | 0) + 20 >> 2] | 0;c[U >> 2] = c[e >> 2];c[V >> 2] = c[f >> 2];Mc[da & 127](b, d, U, V, g, h, j);i = l; return };
                            case 88:
                                {
                                    da = d + 8 | 0;ca = Fc[c[(c[da >> 2] | 0) + 24 >> 2] & 255](da) | 0;da = e | 0;c[X >> 2] = c[da >> 2];c[Y >> 2] = c[f >> 2];ea = a[ca] | 0;
                                    if ((ea & 1) == 0) {
                                        fa = (ea & 255) >>> 1;
                                        ga = ca + 4 | 0;
                                        ha = ca + 4 | 0
                                    } else {
                                        ea = c[ca + 8 >> 2] | 0;
                                        fa = c[ca + 4 >> 2] | 0;
                                        ga = ea;
                                        ha = ea
                                    }
                                    Pp(W, d, X, Y, g, h, j, ga, ha + (fa << 2) | 0);c[da >> 2] = c[W >> 2];
                                    break
                                };
                            case 121:
                                {
                                    c[n >> 2] = c[f >> 2];da = aq(e, n, h, ba, 4) | 0;
                                    if ((c[h >> 2] & 4 | 0) != 0) { break a }
                                    if ((da | 0) < 69) { ia = da + 2e3 | 0 } else { ia = (da - 69 | 0) >>> 0 < 31 >>> 0 ? da + 1900 | 0 : da }
                                    c[j + 20 >> 2] = ia - 1900;
                                    break
                                };
                            case 70:
                                { da = e | 0;c[H >> 2] = c[da >> 2];c[I >> 2] = c[f >> 2];Pp(G, d, H, I, g, h, j, 19176, 19208);c[da >> 2] = c[G >> 2]; break };
                            case 100:
                            case 101:
                                {
                                    da = j + 12 | 0;c[v >> 2] = c[f >> 2];ea = aq(e, v, h, ba, 2) | 0;ca = c[h >> 2] | 0;do {
                                        if ((ca & 4 | 0) == 0) {
                                            if (!((ea - 1 | 0) >>> 0 < 31 >>> 0)) { break }
                                            c[da >> 2] = ea;
                                            break a
                                        }
                                    } while (0);c[h >> 2] = ca | 4;
                                    break
                                };
                            case 83:
                                { c[p >> 2] = c[f >> 2];ea = aq(e, p, h, ba, 2) | 0;da = c[h >> 2] | 0; if ((da & 4 | 0) == 0 & (ea | 0) < 61) { c[j >> 2] = ea; break a } else { c[h >> 2] = da | 4; break a } break };
                            case 99:
                                {
                                    da = d + 8 | 0;ea = Fc[c[(c[da >> 2] | 0) + 12 >> 2] & 255](da) | 0;da = e | 0;c[B >> 2] = c[da >> 2];c[C >> 2] = c[f >> 2];aa = a[ea] | 0;
                                    if ((aa & 1) == 0) {
                                        ja = (aa & 255) >>> 1;
                                        ka = ea + 4 | 0;
                                        la = ea + 4 | 0
                                    } else {
                                        aa = c[ea + 8 >> 2] | 0;
                                        ja = c[ea + 4 >> 2] | 0;
                                        ka = aa;
                                        la = aa
                                    }
                                    Pp(A, d, B, C, g, h, j, ka, la + (ja << 2) | 0);c[da >> 2] = c[A >> 2];
                                    break
                                };
                            case 97:
                            case 65:
                                {
                                    da = c[f >> 2] | 0;aa = d + 8 | 0;ea = Fc[c[c[aa >> 2] >> 2] & 255](aa) | 0;c[x >> 2] = da;da = (Bo(e, x, ea, ea + 168 | 0, ba, h, 0) | 0) - ea | 0;
                                    if ((da | 0) >= 168) { break a }
                                    c[j + 24 >> 2] = ((da | 0) / 12 | 0 | 0) % 7 | 0;
                                    break
                                };
                            default:
                                { c[h >> 2] = c[h >> 2] | 4 }
                        }
                    } while (0);
                    c[b >> 2] = c[e >> 2];
                    i = l;
                    return
                }
            } while (0);
            l = pc(4) | 0;
            lu(l);
            Fb(l | 0, 25544, 156)
        }

        function Zp(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0;
            a = i;
            g = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[g >> 2];
            g = b | 0;
            b = d | 0;
            d = f;
            a: while (1) {
                h = c[g >> 2] | 0;
                do {
                    if ((h | 0) == 0) { j = 1 } else {
                        k = c[h + 12 >> 2] | 0;
                        if ((k | 0) == (c[h + 16 >> 2] | 0)) { l = Fc[c[(c[h >> 2] | 0) + 36 >> 2] & 255](h) | 0 } else { l = c[k >> 2] | 0 }
                        if ((l | 0) == -1) {
                            c[g >> 2] = 0;
                            j = 1;
                            break
                        } else { j = (c[g >> 2] | 0) == 0; break }
                    }
                } while (0);
                h = c[b >> 2] | 0;
                do {
                    if ((h | 0) == 0) { m = 15 } else {
                        k = c[h + 12 >> 2] | 0;
                        if ((k | 0) == (c[h + 16 >> 2] | 0)) { n = Fc[c[(c[h >> 2] | 0) + 36 >> 2] & 255](h) | 0 } else { n = c[k >> 2] | 0 }
                        if ((n | 0) == -1) {
                            c[b >> 2] = 0;
                            m = 15;
                            break
                        } else { if (j) { o = h; break } else { p = h; break a } }
                    }
                } while (0);
                if ((m | 0) == 15) { m = 0; if (j) { p = 0; break } else { o = 0 } }
                h = c[g >> 2] | 0;
                k = c[h + 12 >> 2] | 0;
                if ((k | 0) == (c[h + 16 >> 2] | 0)) { q = Fc[c[(c[h >> 2] | 0) + 36 >> 2] & 255](h) | 0 } else { q = c[k >> 2] | 0 }
                if (!(Hc[c[(c[d >> 2] | 0) + 12 >> 2] & 63](f, 8192, q) | 0)) { p = o; break }
                k = c[g >> 2] | 0;
                h = k + 12 | 0;
                r = c[h >> 2] | 0;
                if ((r | 0) == (c[k + 16 >> 2] | 0)) { Fc[c[(c[k >> 2] | 0) + 40 >> 2] & 255](k) | 0; continue } else { c[h >> 2] = r + 4; continue }
            }
            o = c[g >> 2] | 0;
            do {
                if ((o | 0) == 0) { s = 1 } else {
                    q = c[o + 12 >> 2] | 0;
                    if ((q | 0) == (c[o + 16 >> 2] | 0)) { t = Fc[c[(c[o >> 2] | 0) + 36 >> 2] & 255](o) | 0 } else { t = c[q >> 2] | 0 }
                    if ((t | 0) == -1) {
                        c[g >> 2] = 0;
                        s = 1;
                        break
                    } else { s = (c[g >> 2] | 0) == 0; break }
                }
            } while (0);
            do {
                if ((p | 0) == 0) { m = 37 } else {
                    g = c[p + 12 >> 2] | 0;
                    if ((g | 0) == (c[p + 16 >> 2] | 0)) { u = Fc[c[(c[p >> 2] | 0) + 36 >> 2] & 255](p) | 0 } else { u = c[g >> 2] | 0 }
                    if ((u | 0) == -1) {
                        c[b >> 2] = 0;
                        m = 37;
                        break
                    }
                    if (!s) { break }
                    i = a;
                    return
                }
            } while (0);
            do {
                if ((m | 0) == 37) {
                    if (s) { break }
                    i = a;
                    return
                }
            } while (0);
            c[e >> 2] = c[e >> 2] | 2;
            i = a;
            return
        }

        function _p(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0;
            j = i;
            i = i + 8 | 0;
            k = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[k >> 2];
            k = j | 0;
            l = b + 8 | 0;
            b = Fc[c[(c[l >> 2] | 0) + 8 >> 2] & 255](l) | 0;
            l = a[b] | 0;
            if ((l & 1) == 0) { m = (l & 255) >>> 1 } else { m = c[b + 4 >> 2] | 0 }
            l = a[b + 12 | 0] | 0;
            if ((l & 1) == 0) { n = (l & 255) >>> 1 } else { n = c[b + 16 >> 2] | 0 }
            if ((m | 0) == (-n | 0)) {
                c[g >> 2] = c[g >> 2] | 4;
                i = j;
                return
            }
            c[k >> 2] = c[f >> 2];
            f = Bo(e, k, b, b + 24 | 0, h, g, 0) | 0;
            g = f - b | 0;
            do {
                if ((f | 0) == (b | 0)) {
                    if ((c[d >> 2] | 0) != 12) { break }
                    c[d >> 2] = 0;
                    i = j;
                    return
                }
            } while (0);
            if ((g | 0) != 12) { i = j; return }
            g = c[d >> 2] | 0;
            if ((g | 0) >= 12) { i = j; return }
            c[d >> 2] = g + 12;
            i = j;
            return
        }

        function $p(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0;
            a = i;
            g = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[g >> 2];
            g = b | 0;
            b = c[g >> 2] | 0;
            do {
                if ((b | 0) == 0) { h = 1 } else {
                    j = c[b + 12 >> 2] | 0;
                    if ((j | 0) == (c[b + 16 >> 2] | 0)) { k = Fc[c[(c[b >> 2] | 0) + 36 >> 2] & 255](b) | 0 } else { k = c[j >> 2] | 0 }
                    if ((k | 0) == -1) {
                        c[g >> 2] = 0;
                        h = 1;
                        break
                    } else { h = (c[g >> 2] | 0) == 0; break }
                }
            } while (0);
            k = d | 0;
            d = c[k >> 2] | 0;
            do {
                if ((d | 0) == 0) { l = 14 } else {
                    b = c[d + 12 >> 2] | 0;
                    if ((b | 0) == (c[d + 16 >> 2] | 0)) { m = Fc[c[(c[d >> 2] | 0) + 36 >> 2] & 255](d) | 0 } else { m = c[b >> 2] | 0 }
                    if ((m | 0) == -1) {
                        c[k >> 2] = 0;
                        l = 14;
                        break
                    } else { if (h) { n = d; break } else { l = 16; break } }
                }
            } while (0);
            if ((l | 0) == 14) { if (h) { l = 16 } else { n = 0 } }
            if ((l | 0) == 16) {
                c[e >> 2] = c[e >> 2] | 6;
                i = a;
                return
            }
            h = c[g >> 2] | 0;
            d = c[h + 12 >> 2] | 0;
            if ((d | 0) == (c[h + 16 >> 2] | 0)) { o = Fc[c[(c[h >> 2] | 0) + 36 >> 2] & 255](h) | 0 } else { o = c[d >> 2] | 0 }
            if (!((Hc[c[(c[f >> 2] | 0) + 52 >> 2] & 63](f, o, 0) | 0) << 24 >> 24 == 37)) {
                c[e >> 2] = c[e >> 2] | 4;
                i = a;
                return
            }
            o = c[g >> 2] | 0;
            f = o + 12 | 0;
            d = c[f >> 2] | 0;
            if ((d | 0) == (c[o + 16 >> 2] | 0)) { Fc[c[(c[o >> 2] | 0) + 40 >> 2] & 255](o) | 0 } else { c[f >> 2] = d + 4 }
            d = c[g >> 2] | 0;
            do {
                if ((d | 0) == 0) { p = 1 } else {
                    f = c[d + 12 >> 2] | 0;
                    if ((f | 0) == (c[d + 16 >> 2] | 0)) { q = Fc[c[(c[d >> 2] | 0) + 36 >> 2] & 255](d) | 0 } else { q = c[f >> 2] | 0 }
                    if ((q | 0) == -1) {
                        c[g >> 2] = 0;
                        p = 1;
                        break
                    } else { p = (c[g >> 2] | 0) == 0; break }
                }
            } while (0);
            do {
                if ((n | 0) == 0) { l = 38 } else {
                    g = c[n + 12 >> 2] | 0;
                    if ((g | 0) == (c[n + 16 >> 2] | 0)) { r = Fc[c[(c[n >> 2] | 0) + 36 >> 2] & 255](n) | 0 } else { r = c[g >> 2] | 0 }
                    if ((r | 0) == -1) {
                        c[k >> 2] = 0;
                        l = 38;
                        break
                    }
                    if (!p) { break }
                    i = a;
                    return
                }
            } while (0);
            do {
                if ((l | 0) == 38) {
                    if (p) { break }
                    i = a;
                    return
                }
            } while (0);
            c[e >> 2] = c[e >> 2] | 2;
            i = a;
            return
        }

        function aq(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0;
            g = i;
            h = b;
            b = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[b >> 2] = c[h >> 2];
            h = a | 0;
            a = c[h >> 2] | 0;
            do {
                if ((a | 0) == 0) { j = 1 } else {
                    k = c[a + 12 >> 2] | 0;
                    if ((k | 0) == (c[a + 16 >> 2] | 0)) { l = Fc[c[(c[a >> 2] | 0) + 36 >> 2] & 255](a) | 0 } else { l = c[k >> 2] | 0 }
                    if ((l | 0) == -1) {
                        c[h >> 2] = 0;
                        j = 1;
                        break
                    } else { j = (c[h >> 2] | 0) == 0; break }
                }
            } while (0);
            l = b | 0;
            b = c[l >> 2] | 0;
            do {
                if ((b | 0) == 0) { m = 14 } else {
                    a = c[b + 12 >> 2] | 0;
                    if ((a | 0) == (c[b + 16 >> 2] | 0)) { n = Fc[c[(c[b >> 2] | 0) + 36 >> 2] & 255](b) | 0 } else { n = c[a >> 2] | 0 }
                    if ((n | 0) == -1) {
                        c[l >> 2] = 0;
                        m = 14;
                        break
                    } else { if (j) { o = b; break } else { m = 16; break } }
                }
            } while (0);
            if ((m | 0) == 14) { if (j) { m = 16 } else { o = 0 } }
            if ((m | 0) == 16) {
                c[d >> 2] = c[d >> 2] | 6;
                p = 0;
                i = g;
                return p | 0
            }
            j = c[h >> 2] | 0;
            b = c[j + 12 >> 2] | 0;
            if ((b | 0) == (c[j + 16 >> 2] | 0)) { q = Fc[c[(c[j >> 2] | 0) + 36 >> 2] & 255](j) | 0 } else { q = c[b >> 2] | 0 }
            b = e;
            if (!(Hc[c[(c[b >> 2] | 0) + 12 >> 2] & 63](e, 2048, q) | 0)) {
                c[d >> 2] = c[d >> 2] | 4;
                p = 0;
                i = g;
                return p | 0
            }
            j = e;
            n = (Hc[c[(c[j >> 2] | 0) + 52 >> 2] & 63](e, q, 0) | 0) << 24 >> 24;
            q = c[h >> 2] | 0;
            a = q + 12 | 0;
            k = c[a >> 2] | 0;
            if ((k | 0) == (c[q + 16 >> 2] | 0)) {
                Fc[c[(c[q >> 2] | 0) + 40 >> 2] & 255](q) | 0;
                r = n;
                s = f;
                t = o;
                u = o
            } else {
                c[a >> 2] = k + 4;
                r = n;
                s = f;
                t = o;
                u = o
            }
            while (1) {
                v = r - 48 | 0;
                o = s - 1 | 0;
                f = c[h >> 2] | 0;
                do {
                    if ((f | 0) == 0) { w = 1 } else {
                        n = c[f + 12 >> 2] | 0;
                        if ((n | 0) == (c[f + 16 >> 2] | 0)) { x = Fc[c[(c[f >> 2] | 0) + 36 >> 2] & 255](f) | 0 } else { x = c[n >> 2] | 0 }
                        if ((x | 0) == -1) {
                            c[h >> 2] = 0;
                            w = 1;
                            break
                        } else { w = (c[h >> 2] | 0) == 0; break }
                    }
                } while (0);
                do {
                    if ((t | 0) == 0) {
                        y = 1;
                        z = 0;
                        A = u
                    } else {
                        f = c[t + 12 >> 2] | 0;
                        if ((f | 0) == (c[t + 16 >> 2] | 0)) { B = Fc[c[(c[t >> 2] | 0) + 36 >> 2] & 255](t) | 0 } else { B = c[f >> 2] | 0 }
                        if ((B | 0) == -1) {
                            c[l >> 2] = 0;
                            y = 1;
                            z = 0;
                            A = 0;
                            break
                        } else {
                            y = (u | 0) == 0;
                            z = u;
                            A = u;
                            break
                        }
                    }
                } while (0);
                C = c[h >> 2] | 0;
                if (!((w ^ y) & (o | 0) > 0)) { break }
                f = c[C + 12 >> 2] | 0;
                if ((f | 0) == (c[C + 16 >> 2] | 0)) { D = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { D = c[f >> 2] | 0 }
                if (!(Hc[c[(c[b >> 2] | 0) + 12 >> 2] & 63](e, 2048, D) | 0)) {
                    p = v;
                    m = 63;
                    break
                }
                f = ((Hc[c[(c[j >> 2] | 0) + 52 >> 2] & 63](e, D, 0) | 0) << 24 >> 24) + (v * 10 | 0) | 0;
                n = c[h >> 2] | 0;
                k = n + 12 | 0;
                a = c[k >> 2] | 0;
                if ((a | 0) == (c[n + 16 >> 2] | 0)) {
                    Fc[c[(c[n >> 2] | 0) + 40 >> 2] & 255](n) | 0;
                    r = f;
                    s = o;
                    t = z;
                    u = A;
                    continue
                } else {
                    c[k >> 2] = a + 4;
                    r = f;
                    s = o;
                    t = z;
                    u = A;
                    continue
                }
            }
            if ((m | 0) == 63) { i = g; return p | 0 }
            do {
                if ((C | 0) == 0) { E = 1 } else {
                    u = c[C + 12 >> 2] | 0;
                    if ((u | 0) == (c[C + 16 >> 2] | 0)) { F = Fc[c[(c[C >> 2] | 0) + 36 >> 2] & 255](C) | 0 } else { F = c[u >> 2] | 0 }
                    if ((F | 0) == -1) {
                        c[h >> 2] = 0;
                        E = 1;
                        break
                    } else { E = (c[h >> 2] | 0) == 0; break }
                }
            } while (0);
            do {
                if ((A | 0) == 0) { m = 60 } else {
                    h = c[A + 12 >> 2] | 0;
                    if ((h | 0) == (c[A + 16 >> 2] | 0)) { G = Fc[c[(c[A >> 2] | 0) + 36 >> 2] & 255](A) | 0 } else { G = c[h >> 2] | 0 }
                    if ((G | 0) == -1) {
                        c[l >> 2] = 0;
                        m = 60;
                        break
                    }
                    if (E) { p = v } else { break }
                    i = g;
                    return p | 0
                }
            } while (0);
            do {
                if ((m | 0) == 60) {
                    if (E) { break } else { p = v }
                    i = g;
                    return p | 0
                }
            } while (0);
            c[d >> 2] = c[d >> 2] | 2;
            p = v;
            i = g;
            return p | 0
        }

        function bq(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0;
            d = b + 8 | 0;
            e = c[d >> 2] | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    f = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = f
                }
            } while (0);
            if ((e | 0) != (c[8330] | 0)) { pb(c[d >> 2] | 0) }
            Sl(b | 0);
            Pu(b);
            return
        }

        function cq(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0;
            d = b + 8 | 0;
            e = c[d >> 2] | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    f = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = f
                }
            } while (0);
            if ((e | 0) == (c[8330] | 0)) {
                g = b | 0;
                Sl(g);
                return
            }
            pb(c[d >> 2] | 0);
            g = b | 0;
            Sl(g);
            return
        }

        function dq(b, d, e, f, g, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0;
            g = i;
            i = i + 112 | 0;
            f = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[f >> 2];
            f = g | 0;
            l = g + 8 | 0;
            m = l | 0;
            n = f | 0;
            a[n] = 37;
            o = f + 1 | 0;
            a[o] = j;
            p = f + 2 | 0;
            a[p] = k;
            a[f + 3 | 0] = 0;
            if (!(k << 24 >> 24 == 0)) {
                a[o] = k;
                a[p] = j
            }
            j = gc(m | 0, 100, n | 0, h | 0, c[d + 8 >> 2] | 0) | 0;
            d = l + j | 0;
            l = c[e >> 2] | 0;
            if ((j | 0) == 0) {
                q = l;
                r = b | 0;
                c[r >> 2] = q;
                s = 100;
                t = 0;
                i = g;
                return
            } else {
                u = m;
                v = l;
                w = l
            }
            while (1) {
                l = a[u] | 0;
                do {
                    if ((v | 0) == 0) {
                        x = 0;
                        y = w
                    } else {
                        m = v + 24 | 0;
                        j = c[m >> 2] | 0;
                        if ((j | 0) == (c[v + 28 >> 2] | 0)) {
                            e = (Qc[c[(c[v >> 2] | 0) + 52 >> 2] & 63](v, l & 255) | 0) == -1;
                            x = e ? 0 : v;
                            y = e ? 0 : w;
                            break
                        } else {
                            c[m >> 2] = j + 1;
                            a[j] = l;
                            x = v;
                            y = w;
                            break
                        }
                    }
                } while (0);
                l = u + 1 | 0;
                if ((l | 0) == (d | 0)) { q = y; break } else {
                    u = l;
                    v = x;
                    w = y
                }
            }
            r = b | 0;
            c[r >> 2] = q;
            s = 100;
            t = 0;
            i = g;
            return
        }

        function eq(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0;
            d = b + 8 | 0;
            e = c[d >> 2] | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    f = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = f
                }
            } while (0);
            if ((e | 0) != (c[8330] | 0)) { pb(c[d >> 2] | 0) }
            Sl(b | 0);
            Pu(b);
            return
        }

        function fq(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0;
            d = b + 8 | 0;
            e = c[d >> 2] | 0;
            do {
                if ((a[51808] | 0) == 0) {
                    if ((ub(51808) | 0) == 0) { break }
                    f = Xa(2147483647, 14472, 0) | 0;
                    c[8330] = f
                }
            } while (0);
            if ((e | 0) == (c[8330] | 0)) {
                g = b | 0;
                Sl(g);
                return
            }
            pb(c[d >> 2] | 0);
            g = b | 0;
            Sl(g);
            return
        }

        function gq(a, b, d, e, f, g, h, j) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            var k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0;
            f = i;
            i = i + 408 | 0;
            e = d;
            d = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[d >> 2] = c[e >> 2];
            e = f | 0;
            k = f + 400 | 0;
            l = e | 0;
            c[k >> 2] = e + 400;
            hq(b + 8 | 0, l, k, g, h, j);
            j = c[k >> 2] | 0;
            k = c[d >> 2] | 0;
            if ((l | 0) == (j | 0)) {
                m = k;
                n = a | 0;
                c[n >> 2] = m;
                o = 400;
                p = 0;
                i = f;
                return
            } else {
                q = l;
                r = k;
                s = k
            }
            while (1) {
                k = c[q >> 2] | 0;
                if ((r | 0) == 0) {
                    t = 0;
                    u = s
                } else {
                    l = r + 24 | 0;
                    d = c[l >> 2] | 0;
                    if ((d | 0) == (c[r + 28 >> 2] | 0)) { v = Qc[c[(c[r >> 2] | 0) + 52 >> 2] & 63](r, k) | 0 } else {
                        c[l >> 2] = d + 4;
                        c[d >> 2] = k;
                        v = k
                    }
                    k = (v | 0) == -1;
                    t = k ? 0 : r;
                    u = k ? 0 : s
                }
                k = q + 4 | 0;
                if ((k | 0) == (j | 0)) { m = u; break } else {
                    q = k;
                    r = t;
                    s = u
                }
            }
            n = a | 0;
            c[n >> 2] = m;
            o = 400;
            p = 0;
            i = f;
            return
        }

        function hq(b, d, e, f, g, h) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            var j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0;
            j = i;
            i = i + 120 | 0;
            k = j | 0;
            l = j + 112 | 0;
            m = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            n = j + 8 | 0;
            o = k | 0;
            a[o] = 37;
            p = k + 1 | 0;
            a[p] = g;
            q = k + 2 | 0;
            a[q] = h;
            a[k + 3 | 0] = 0;
            if (!(h << 24 >> 24 == 0)) {
                a[p] = h;
                a[q] = g
            }
            g = b | 0;
            gc(n | 0, 100, o | 0, f | 0, c[g >> 2] | 0) | 0;
            c[l >> 2] = 0;
            c[l + 4 >> 2] = 0;
            c[m >> 2] = n;
            n = (c[e >> 2] | 0) - d >> 2;
            f = bc(c[g >> 2] | 0) | 0;
            g = bu(d, m, n, l) | 0;
            if ((f | 0) != 0) { bc(f | 0) | 0 }
            if ((g | 0) == -1) { dr(8296) } else {
                c[e >> 2] = d + (g << 2);
                i = j;
                return
            }
        }

        function iq(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function jq(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function kq(a) { a = a | 0; return 127 }

        function lq(a) { a = a | 0; return 127 }

        function mq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function nq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function oq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function pq(a, b) {
            a = a | 0;
            b = b | 0;
            qm(a, 1, 45);
            return
        }

        function qq(a) { a = a | 0; return 0 }

        function rq(b, c) {
            b = b | 0;
            c = c | 0;
            c = b;
            C = 67109634;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            return
        }

        function sq(b, c) {
            b = b | 0;
            c = c | 0;
            c = b;
            C = 67109634;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            return
        }

        function tq(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function uq(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function vq(a) { a = a | 0; return 127 }

        function wq(a) { a = a | 0; return 127 }

        function xq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function yq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function zq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function Aq(a, b) {
            a = a | 0;
            b = b | 0;
            qm(a, 1, 45);
            return
        }

        function Bq(a) { a = a | 0; return 0 }

        function Cq(b, c) {
            b = b | 0;
            c = c | 0;
            c = b;
            C = 67109634;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            return
        }

        function Dq(b, c) {
            b = b | 0;
            c = c | 0;
            c = b;
            C = 67109634;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            return
        }

        function Eq(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Fq(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Gq(a) { a = a | 0; return 2147483647 }

        function Hq(a) { a = a | 0; return 2147483647 }

        function Iq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function Jq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function Kq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function Lq(a, b) {
            a = a | 0;
            b = b | 0;
            Bm(a, 1, 45);
            return
        }

        function Mq(a) { a = a | 0; return 0 }

        function Nq(b, c) {
            b = b | 0;
            c = c | 0;
            c = b;
            C = 67109634;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            return
        }

        function Oq(b, c) {
            b = b | 0;
            c = c | 0;
            c = b;
            C = 67109634;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            return
        }

        function Pq(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function Qq(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function Rq(a) { a = a | 0; return 2147483647 }

        function Sq(a) { a = a | 0; return 2147483647 }

        function Tq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function Uq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function Vq(a, b) {
            a = a | 0;
            b = b | 0;
            dv(a | 0, 0, 12) | 0;
            return
        }

        function Wq(a, b) {
            a = a | 0;
            b = b | 0;
            Bm(a, 1, 45);
            return
        }

        function Xq(a) { a = a | 0; return 0 }

        function Yq(b, c) {
            b = b | 0;
            c = c | 0;
            c = b;
            C = 67109634;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            return
        }

        function Zq(b, c) {
            b = b | 0;
            c = c | 0;
            c = b;
            C = 67109634;
            a[c] = C;
            C = C >> 8;
            a[c + 1 | 0] = C;
            C = C >> 8;
            a[c + 2 | 0] = C;
            C = C >> 8;
            a[c + 3 | 0] = C;
            return
        }

        function _q(a) {
            a = a | 0;
            Sl(a | 0);
            Pu(a);
            return
        }

        function $q(a) {
            a = a | 0;
            Sl(a | 0);
            return
        }

        function ar(b, d, e, f, g, h, j, k) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            j = j | 0;
            k = k | 0;
            var l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0;
            d = i;
            i = i + 280 | 0;
            l = e;
            e = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[e >> 2] = c[l >> 2];
            l = f;
            f = i;
            i = i + 4 | 0;
            i = i + 7 & -8;
            c[f >> 2] = c[l >> 2];
            l = d | 0;
            m = d + 16 | 0;
            n = d + 120 | 0;
            o = d + 128 | 0;
            p = d + 136 | 0;
            q = d + 144 | 0;
            r = d + 152 | 0;
            s = d + 160 | 0;
            t = d + 176 | 0;
            u = n | 0;
            c[u >> 2] = m;
            v = n + 4 | 0;
            c[v >> 2] = 194;
            w = m + 100 | 0;
            Lm(p, h);
            m = p | 0;
            x = c[m >> 2] | 0;
            if (!((c[8716] | 0) == -1)) {
                c[l >> 2] = 34864;
                c[l + 4 >> 2] = 16;
                c[l + 8 >> 2] = 0;
                mm(34864, l, 114)
            }
            l = (c[8717] | 0) - 1 | 0;
            y = c[x + 8 >> 2] | 0;
            do {
                if ((c[x + 12 >> 2] | 0) - y >> 2 >>> 0 > l >>> 0) {
                    z = c[y + (l << 2) >> 2] | 0;
                    if ((z | 0) == 0) { break }
                    A = z;
                    a[q] = 0;
                    B = f | 0;
                    c[r >> 2] = c[B >> 2];
                    do {
                        if (cr(e, r, g, p, c[h + 4 >> 2] | 0, j, q, A, n, o, w) | 0) {
                            C = s | 0;
                            Sc[c[(c[z >> 2] | 0) + 32 >> 2] & 15](A, 19160, 19170, C) | 0;
                            D = t | 0;
                            E = c[o >> 2] | 0;
                            F = c[u >> 2] | 0;
                            G = E - F | 0;
                            do {
                                if ((G | 0) > 98) {
                                    H = Gu(G + 2 | 0) | 0;
                                    if ((H | 0) != 0) {
                                        I = H;
                                        J = H;
                                        break
                                    }
                                    Uu();
                                    I = 0;
                                    J = 0
                                } else {
                                    I = D;
                                    J = 0
                                }
                            } while (0);
                            if ((a[q] | 0) == 0) { K = I } else {
                                a[I] = 45;
                                K = I + 1 | 0
                            }
                            if (F >>> 0 < E >>> 0) {
                                G = s + 10 | 0;
                                H = s;
                                L = K;
                                M = F;
                                while (1) {
                                    N = a[M] | 0;
                                    O = C;
                                    while (1) { P = O + 1 | 0; if ((a[O] | 0) == N << 24 >> 24) { Q = O; break } if ((P | 0) == (G | 0)) { Q = G; break } else { O = P } }
                                    a[L] = a[19160 + (Q - H) | 0] | 0;
                                    O = M + 1 | 0;
                                    N = L + 1 | 0;
                                    if (O >>> 0 < (c[o >> 2] | 0) >>> 0) {
                                        L = N;
                                        M = O
                                    } else { R = N; break }
                                }
                            } else { R = K }
                            a[R] = 0;
                            M = dc(D | 0, 15784, (L = i, i = i + 8 | 0, c[L >> 2] = k, L) | 0) | 0;
                            i = L;
                            if ((M | 0) == 1) {
                                if ((J | 0) == 0) { break }
                                Hu(J);
                                break
                            }
                            M = pc(8) | 0;
                            _l(M, 15400);
                            Fb(M | 0, 25560, 30)
                        }
                    } while (0);
                    A = e | 0;
                    z = c[A >> 2] | 0;
                    do {
                        if ((z | 0) == 0) { S = 0 } else {
                            if ((c[z + 12 >> 2] | 0) != (c[z + 16 >> 2] | 0)) { S = z; break }
                            if (!((Fc[c[(c[z >> 2] | 0) + 36 >> 2] & 255](z) | 0) == -1)) { S = z; break }
                            c[A >> 2] = 0;
                            S = 0
                        }
                    } while (0);
                    A = (S | 0) == 0;
                    z = c[B >> 2] | 0;
                    do {
                        if ((z | 0) == 0) { T = 45 } else {
                            if ((c[z + 12 >> 2] | 0) != (c[z + 16 >> 2] | 0)) { if (A) { break } else { T = 47; break } }
                            if ((Fc[c[(c[z >> 2] | 0) + 36 >> 2] & 255](z) | 0) == -1) {
                                c[B >> 2] = 0;
                                T = 45;
                                break
                            } else { if (A) { break } else { T = 47; break } }
                        }
                    } while (0);
                    if ((T | 0) == 45) { if (A) { T = 47 } }
                    if ((T | 0) == 47) { c[j >> 2] = c[j >> 2] | 2 }
                    c[b >> 2] = S;
                    Ul(c[m >> 2] | 0) | 0;
                    B = c[u >> 2] | 0;
                    c[u >> 2] = 0;
                    if ((B | 0) == 0) {
                        U = 100;
                        V = 0;
                        i = d;
                        return
                    }
                    Dc[c[v >> 2] & 511](B);
                    U = 100;
                    V = 0;
                    i = d;
                    return
                }
            } while (0);
            d = pc(4) | 0;
            lu(d);
            Fb(d | 0, 25544, 156)
        }

        function br(a) { a = a | 0; return }



        function Gu(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0,
                P = 0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                V = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0,
                ea = 0,
                fa = 0,
                ga = 0,
                ha = 0,
                ia = 0,
                ja = 0,
                ka = 0,
                la = 0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0,
                va = 0,
                wa = 0,
                xa = 0,
                ya = 0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0,
                Da = 0,
                Ea = 0,
                Fa = 0,
                Ga = 0,
                Ha = 0,
                Ia = 0,
                Ja = 0;
            do {
                if (a >>> 0 < 245 >>> 0) {
                    if (a >>> 0 < 11 >>> 0) { b = 16 } else { b = a + 11 & -8 }
                    d = b >>> 3;
                    e = c[7832] | 0;
                    f = e >>> (d >>> 0);
                    if ((f & 3 | 0) != 0) {
                        g = (f & 1 ^ 1) + d | 0;
                        h = g << 1;
                        i = 31368 + (h << 2) | 0;
                        j = 31368 + (h + 2 << 2) | 0;
                        h = c[j >> 2] | 0;
                        k = h + 8 | 0;
                        l = c[k >> 2] | 0;
                        do {
                            if ((i | 0) == (l | 0)) { c[7832] = e & ~(1 << g) } else {
                                if (l >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                m = l + 12 | 0;
                                if ((c[m >> 2] | 0) == (h | 0)) {
                                    c[m >> 2] = i;
                                    c[j >> 2] = l;
                                    break
                                } else { hc(); return 0 }
                            }
                        } while (0);
                        l = g << 3;
                        c[h + 4 >> 2] = l | 3;
                        j = h + (l | 4) | 0;
                        c[j >> 2] = c[j >> 2] | 1;
                        n = k;
                        return n | 0
                    }
                    if (!(b >>> 0 > (c[7834] | 0) >>> 0)) { o = b; break }
                    if ((f | 0) != 0) {
                        j = 2 << d;
                        l = f << d & (j | -j);
                        j = (l & -l) - 1 | 0;
                        l = j >>> 12 & 16;
                        i = j >>> (l >>> 0);
                        j = i >>> 5 & 8;
                        m = i >>> (j >>> 0);
                        i = m >>> 2 & 4;
                        p = m >>> (i >>> 0);
                        m = p >>> 1 & 2;
                        q = p >>> (m >>> 0);
                        p = q >>> 1 & 1;
                        r = (j | l | i | m | p) + (q >>> (p >>> 0)) | 0;
                        p = r << 1;
                        q = 31368 + (p << 2) | 0;
                        m = 31368 + (p + 2 << 2) | 0;
                        p = c[m >> 2] | 0;
                        i = p + 8 | 0;
                        l = c[i >> 2] | 0;
                        do {
                            if ((q | 0) == (l | 0)) { c[7832] = e & ~(1 << r) } else {
                                if (l >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                j = l + 12 | 0;
                                if ((c[j >> 2] | 0) == (p | 0)) {
                                    c[j >> 2] = q;
                                    c[m >> 2] = l;
                                    break
                                } else { hc(); return 0 }
                            }
                        } while (0);
                        l = r << 3;
                        m = l - b | 0;
                        c[p + 4 >> 2] = b | 3;
                        q = p;
                        e = q + b | 0;
                        c[q + (b | 4) >> 2] = m | 1;
                        c[q + l >> 2] = m;
                        l = c[7834] | 0;
                        if ((l | 0) != 0) {
                            q = c[7837] | 0;
                            d = l >>> 3;
                            l = d << 1;
                            f = 31368 + (l << 2) | 0;
                            k = c[7832] | 0;
                            h = 1 << d;
                            do {
                                if ((k & h | 0) == 0) {
                                    c[7832] = k | h;
                                    s = f;
                                    t = 31368 + (l + 2 << 2) | 0
                                } else {
                                    d = 31368 + (l + 2 << 2) | 0;
                                    g = c[d >> 2] | 0;
                                    if (!(g >>> 0 < (c[7836] | 0) >>> 0)) {
                                        s = g;
                                        t = d;
                                        break
                                    }
                                    hc();
                                    return 0
                                }
                            } while (0);
                            c[t >> 2] = q;
                            c[s + 12 >> 2] = q;
                            c[q + 8 >> 2] = s;
                            c[q + 12 >> 2] = f
                        }
                        c[7834] = m;
                        c[7837] = e;
                        n = i;
                        return n | 0
                    }
                    l = c[7833] | 0;
                    if ((l | 0) == 0) { o = b; break }
                    h = (l & -l) - 1 | 0;
                    l = h >>> 12 & 16;
                    k = h >>> (l >>> 0);
                    h = k >>> 5 & 8;
                    p = k >>> (h >>> 0);
                    k = p >>> 2 & 4;
                    r = p >>> (k >>> 0);
                    p = r >>> 1 & 2;
                    d = r >>> (p >>> 0);
                    r = d >>> 1 & 1;
                    g = c[31632 + ((h | l | k | p | r) + (d >>> (r >>> 0)) << 2) >> 2] | 0;
                    r = g;
                    d = g;
                    p = (c[g + 4 >> 2] & -8) - b | 0;
                    while (1) {
                        g = c[r + 16 >> 2] | 0;
                        if ((g | 0) == 0) { k = c[r + 20 >> 2] | 0; if ((k | 0) == 0) { break } else { u = k } } else { u = g }
                        g = (c[u + 4 >> 2] & -8) - b | 0;
                        k = g >>> 0 < p >>> 0;
                        r = u;
                        d = k ? u : d;
                        p = k ? g : p
                    }
                    r = d;
                    i = c[7836] | 0;
                    if (r >>> 0 < i >>> 0) { hc(); return 0 }
                    e = r + b | 0;
                    m = e;
                    if (!(r >>> 0 < e >>> 0)) { hc(); return 0 }
                    e = c[d + 24 >> 2] | 0;
                    f = c[d + 12 >> 2] | 0;
                    do {
                        if ((f | 0) == (d | 0)) {
                            q = d + 20 | 0;
                            g = c[q >> 2] | 0;
                            if ((g | 0) == 0) {
                                k = d + 16 | 0;
                                l = c[k >> 2] | 0;
                                if ((l | 0) == 0) { v = 0; break } else {
                                    w = l;
                                    x = k
                                }
                            } else {
                                w = g;
                                x = q
                            }
                            while (1) {
                                q = w + 20 | 0;
                                g = c[q >> 2] | 0;
                                if ((g | 0) != 0) {
                                    w = g;
                                    x = q;
                                    continue
                                }
                                q = w + 16 | 0;
                                g = c[q >> 2] | 0;
                                if ((g | 0) == 0) { break } else {
                                    w = g;
                                    x = q
                                }
                            }
                            if (x >>> 0 < i >>> 0) { hc(); return 0 } else {
                                c[x >> 2] = 0;
                                v = w;
                                break
                            }
                        } else {
                            q = c[d + 8 >> 2] | 0;
                            if (q >>> 0 < i >>> 0) { hc(); return 0 }
                            g = q + 12 | 0;
                            if ((c[g >> 2] | 0) != (d | 0)) { hc(); return 0 }
                            k = f + 8 | 0;
                            if ((c[k >> 2] | 0) == (d | 0)) {
                                c[g >> 2] = f;
                                c[k >> 2] = q;
                                v = f;
                                break
                            } else { hc(); return 0 }
                        }
                    } while (0);
                    a: do {
                        if ((e | 0) != 0) {
                            f = c[d + 28 >> 2] | 0;
                            i = 31632 + (f << 2) | 0;
                            do {
                                if ((d | 0) == (c[i >> 2] | 0)) {
                                    c[i >> 2] = v;
                                    if ((v | 0) != 0) { break }
                                    c[7833] = c[7833] & ~(1 << f);
                                    break a
                                } else {
                                    if (e >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                    q = e + 16 | 0;
                                    if ((c[q >> 2] | 0) == (d | 0)) { c[q >> 2] = v } else { c[e + 20 >> 2] = v }
                                    if ((v | 0) == 0) { break a }
                                }
                            } while (0);
                            if (v >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                            c[v + 24 >> 2] = e;
                            f = c[d + 16 >> 2] | 0;
                            do {
                                if ((f | 0) != 0) {
                                    if (f >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                        c[v + 16 >> 2] = f;
                                        c[f + 24 >> 2] = v;
                                        break
                                    }
                                }
                            } while (0);
                            f = c[d + 20 >> 2] | 0;
                            if ((f | 0) == 0) { break }
                            if (f >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                c[v + 20 >> 2] = f;
                                c[f + 24 >> 2] = v;
                                break
                            }
                        }
                    } while (0);
                    if (p >>> 0 < 16 >>> 0) {
                        e = p + b | 0;
                        c[d + 4 >> 2] = e | 3;
                        f = r + (e + 4) | 0;
                        c[f >> 2] = c[f >> 2] | 1
                    } else {
                        c[d + 4 >> 2] = b | 3;
                        c[r + (b | 4) >> 2] = p | 1;
                        c[r + (p + b) >> 2] = p;
                        f = c[7834] | 0;
                        if ((f | 0) != 0) {
                            e = c[7837] | 0;
                            i = f >>> 3;
                            f = i << 1;
                            q = 31368 + (f << 2) | 0;
                            k = c[7832] | 0;
                            g = 1 << i;
                            do {
                                if ((k & g | 0) == 0) {
                                    c[7832] = k | g;
                                    y = q;
                                    z = 31368 + (f + 2 << 2) | 0
                                } else {
                                    i = 31368 + (f + 2 << 2) | 0;
                                    l = c[i >> 2] | 0;
                                    if (!(l >>> 0 < (c[7836] | 0) >>> 0)) {
                                        y = l;
                                        z = i;
                                        break
                                    }
                                    hc();
                                    return 0
                                }
                            } while (0);
                            c[z >> 2] = e;
                            c[y + 12 >> 2] = e;
                            c[e + 8 >> 2] = y;
                            c[e + 12 >> 2] = q
                        }
                        c[7834] = p;
                        c[7837] = m
                    }
                    n = d + 8 | 0;
                    return n | 0
                } else {
                    if (a >>> 0 > 4294967231 >>> 0) { o = -1; break }
                    f = a + 11 | 0;
                    g = f & -8;
                    k = c[7833] | 0;
                    if ((k | 0) == 0) { o = g; break }
                    r = -g | 0;
                    i = f >>> 8;
                    do {
                        if ((i | 0) == 0) { A = 0 } else {
                            if (g >>> 0 > 16777215 >>> 0) { A = 31; break }
                            f = (i + 1048320 | 0) >>> 16 & 8;
                            l = i << f;
                            h = (l + 520192 | 0) >>> 16 & 4;
                            j = l << h;
                            l = (j + 245760 | 0) >>> 16 & 2;
                            B = 14 - (h | f | l) + (j << l >>> 15) | 0;
                            A = g >>> ((B + 7 | 0) >>> 0) & 1 | B << 1
                        }
                    } while (0);
                    i = c[31632 + (A << 2) >> 2] | 0;
                    b: do {
                        if ((i | 0) == 0) {
                            C = 0;
                            D = r;
                            E = 0
                        } else {
                            if ((A | 0) == 31) { F = 0 } else { F = 25 - (A >>> 1) | 0 }
                            d = 0;
                            m = r;
                            p = i;
                            q = g << F;
                            e = 0;
                            while (1) {
                                B = c[p + 4 >> 2] & -8;
                                l = B - g | 0;
                                if (l >>> 0 < m >>> 0) {
                                    if ((B | 0) == (g | 0)) {
                                        C = p;
                                        D = l;
                                        E = p;
                                        break b
                                    } else {
                                        G = p;
                                        H = l
                                    }
                                } else {
                                    G = d;
                                    H = m
                                }
                                l = c[p + 20 >> 2] | 0;
                                B = c[p + 16 + (q >>> 31 << 2) >> 2] | 0;
                                j = (l | 0) == 0 | (l | 0) == (B | 0) ? e : l;
                                if ((B | 0) == 0) {
                                    C = G;
                                    D = H;
                                    E = j;
                                    break
                                } else {
                                    d = G;
                                    m = H;
                                    p = B;
                                    q = q << 1;
                                    e = j
                                }
                            }
                        }
                    } while (0);
                    if ((E | 0) == 0 & (C | 0) == 0) {
                        i = 2 << A;
                        r = k & (i | -i);
                        if ((r | 0) == 0) { o = g; break }
                        i = (r & -r) - 1 | 0;
                        r = i >>> 12 & 16;
                        e = i >>> (r >>> 0);
                        i = e >>> 5 & 8;
                        q = e >>> (i >>> 0);
                        e = q >>> 2 & 4;
                        p = q >>> (e >>> 0);
                        q = p >>> 1 & 2;
                        m = p >>> (q >>> 0);
                        p = m >>> 1 & 1;
                        I = c[31632 + ((i | r | e | q | p) + (m >>> (p >>> 0)) << 2) >> 2] | 0
                    } else { I = E }
                    if ((I | 0) == 0) {
                        J = D;
                        K = C
                    } else {
                        p = I;
                        m = D;
                        q = C;
                        while (1) {
                            e = (c[p + 4 >> 2] & -8) - g | 0;
                            r = e >>> 0 < m >>> 0;
                            i = r ? e : m;
                            e = r ? p : q;
                            r = c[p + 16 >> 2] | 0;
                            if ((r | 0) != 0) {
                                p = r;
                                m = i;
                                q = e;
                                continue
                            }
                            r = c[p + 20 >> 2] | 0;
                            if ((r | 0) == 0) {
                                J = i;
                                K = e;
                                break
                            } else {
                                p = r;
                                m = i;
                                q = e
                            }
                        }
                    }
                    if ((K | 0) == 0) { o = g; break }
                    if (!(J >>> 0 < ((c[7834] | 0) - g | 0) >>> 0)) { o = g; break }
                    q = K;
                    m = c[7836] | 0;
                    if (q >>> 0 < m >>> 0) { hc(); return 0 }
                    p = q + g | 0;
                    k = p;
                    if (!(q >>> 0 < p >>> 0)) { hc(); return 0 }
                    e = c[K + 24 >> 2] | 0;
                    i = c[K + 12 >> 2] | 0;
                    do {
                        if ((i | 0) == (K | 0)) {
                            r = K + 20 | 0;
                            d = c[r >> 2] | 0;
                            if ((d | 0) == 0) {
                                j = K + 16 | 0;
                                B = c[j >> 2] | 0;
                                if ((B | 0) == 0) { L = 0; break } else {
                                    M = B;
                                    N = j
                                }
                            } else {
                                M = d;
                                N = r
                            }
                            while (1) {
                                r = M + 20 | 0;
                                d = c[r >> 2] | 0;
                                if ((d | 0) != 0) {
                                    M = d;
                                    N = r;
                                    continue
                                }
                                r = M + 16 | 0;
                                d = c[r >> 2] | 0;
                                if ((d | 0) == 0) { break } else {
                                    M = d;
                                    N = r
                                }
                            }
                            if (N >>> 0 < m >>> 0) { hc(); return 0 } else {
                                c[N >> 2] = 0;
                                L = M;
                                break
                            }
                        } else {
                            r = c[K + 8 >> 2] | 0;
                            if (r >>> 0 < m >>> 0) { hc(); return 0 }
                            d = r + 12 | 0;
                            if ((c[d >> 2] | 0) != (K | 0)) { hc(); return 0 }
                            j = i + 8 | 0;
                            if ((c[j >> 2] | 0) == (K | 0)) {
                                c[d >> 2] = i;
                                c[j >> 2] = r;
                                L = i;
                                break
                            } else { hc(); return 0 }
                        }
                    } while (0);
                    c: do {
                        if ((e | 0) != 0) {
                            i = c[K + 28 >> 2] | 0;
                            m = 31632 + (i << 2) | 0;
                            do {
                                if ((K | 0) == (c[m >> 2] | 0)) {
                                    c[m >> 2] = L;
                                    if ((L | 0) != 0) { break }
                                    c[7833] = c[7833] & ~(1 << i);
                                    break c
                                } else {
                                    if (e >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                    r = e + 16 | 0;
                                    if ((c[r >> 2] | 0) == (K | 0)) { c[r >> 2] = L } else { c[e + 20 >> 2] = L }
                                    if ((L | 0) == 0) { break c }
                                }
                            } while (0);
                            if (L >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                            c[L + 24 >> 2] = e;
                            i = c[K + 16 >> 2] | 0;
                            do {
                                if ((i | 0) != 0) {
                                    if (i >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                        c[L + 16 >> 2] = i;
                                        c[i + 24 >> 2] = L;
                                        break
                                    }
                                }
                            } while (0);
                            i = c[K + 20 >> 2] | 0;
                            if ((i | 0) == 0) { break }
                            if (i >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                c[L + 20 >> 2] = i;
                                c[i + 24 >> 2] = L;
                                break
                            }
                        }
                    } while (0);
                    d: do {
                        if (J >>> 0 < 16 >>> 0) {
                            e = J + g | 0;
                            c[K + 4 >> 2] = e | 3;
                            i = q + (e + 4) | 0;
                            c[i >> 2] = c[i >> 2] | 1
                        } else {
                            c[K + 4 >> 2] = g | 3;
                            c[q + (g | 4) >> 2] = J | 1;
                            c[q + (J + g) >> 2] = J;
                            i = J >>> 3;
                            if (J >>> 0 < 256 >>> 0) {
                                e = i << 1;
                                m = 31368 + (e << 2) | 0;
                                r = c[7832] | 0;
                                j = 1 << i;
                                do {
                                    if ((r & j | 0) == 0) {
                                        c[7832] = r | j;
                                        O = m;
                                        P = 31368 + (e + 2 << 2) | 0
                                    } else {
                                        i = 31368 + (e + 2 << 2) | 0;
                                        d = c[i >> 2] | 0;
                                        if (!(d >>> 0 < (c[7836] | 0) >>> 0)) {
                                            O = d;
                                            P = i;
                                            break
                                        }
                                        hc();
                                        return 0
                                    }
                                } while (0);
                                c[P >> 2] = k;
                                c[O + 12 >> 2] = k;
                                c[q + (g + 8) >> 2] = O;
                                c[q + (g + 12) >> 2] = m;
                                break
                            }
                            e = p;
                            j = J >>> 8;
                            do {
                                if ((j | 0) == 0) { Q = 0 } else {
                                    if (J >>> 0 > 16777215 >>> 0) { Q = 31; break }
                                    r = (j + 1048320 | 0) >>> 16 & 8;
                                    i = j << r;
                                    d = (i + 520192 | 0) >>> 16 & 4;
                                    B = i << d;
                                    i = (B + 245760 | 0) >>> 16 & 2;
                                    l = 14 - (d | r | i) + (B << i >>> 15) | 0;
                                    Q = J >>> ((l + 7 | 0) >>> 0) & 1 | l << 1
                                }
                            } while (0);
                            j = 31632 + (Q << 2) | 0;
                            c[q + (g + 28) >> 2] = Q;
                            c[q + (g + 20) >> 2] = 0;
                            c[q + (g + 16) >> 2] = 0;
                            m = c[7833] | 0;
                            l = 1 << Q;
                            if ((m & l | 0) == 0) {
                                c[7833] = m | l;
                                c[j >> 2] = e;
                                c[q + (g + 24) >> 2] = j;
                                c[q + (g + 12) >> 2] = e;
                                c[q + (g + 8) >> 2] = e;
                                break
                            }
                            l = c[j >> 2] | 0;
                            if ((Q | 0) == 31) { R = 0 } else { R = 25 - (Q >>> 1) | 0 }
                            e: do {
                                if ((c[l + 4 >> 2] & -8 | 0) == (J | 0)) { S = l } else {
                                    j = l;
                                    m = J << R;
                                    while (1) {
                                        T = j + 16 + (m >>> 31 << 2) | 0;
                                        i = c[T >> 2] | 0;
                                        if ((i | 0) == 0) { break }
                                        if ((c[i + 4 >> 2] & -8 | 0) == (J | 0)) { S = i; break e } else {
                                            j = i;
                                            m = m << 1
                                        }
                                    }
                                    if (T >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                        c[T >> 2] = e;
                                        c[q + (g + 24) >> 2] = j;
                                        c[q + (g + 12) >> 2] = e;
                                        c[q + (g + 8) >> 2] = e;
                                        break d
                                    }
                                }
                            } while (0);
                            l = S + 8 | 0;
                            m = c[l >> 2] | 0;
                            i = c[7836] | 0;
                            if (S >>> 0 < i >>> 0) { hc(); return 0 }
                            if (m >>> 0 < i >>> 0) { hc(); return 0 } else {
                                c[m + 12 >> 2] = e;
                                c[l >> 2] = e;
                                c[q + (g + 8) >> 2] = m;
                                c[q + (g + 12) >> 2] = S;
                                c[q + (g + 24) >> 2] = 0;
                                break
                            }
                        }
                    } while (0);
                    n = K + 8 | 0;
                    return n | 0
                }
            } while (0);
            K = c[7834] | 0;
            if (!(o >>> 0 > K >>> 0)) {
                S = K - o | 0;
                T = c[7837] | 0;
                if (S >>> 0 > 15 >>> 0) {
                    J = T;
                    c[7837] = J + o;
                    c[7834] = S;
                    c[J + (o + 4) >> 2] = S | 1;
                    c[J + K >> 2] = S;
                    c[T + 4 >> 2] = o | 3
                } else {
                    c[7834] = 0;
                    c[7837] = 0;
                    c[T + 4 >> 2] = K | 3;
                    S = T + (K + 4) | 0;
                    c[S >> 2] = c[S >> 2] | 1
                }
                n = T + 8 | 0;
                return n | 0
            }
            T = c[7835] | 0;
            if (o >>> 0 < T >>> 0) {
                S = T - o | 0;
                c[7835] = S;
                T = c[7838] | 0;
                K = T;
                c[7838] = K + o;
                c[K + (o + 4) >> 2] = S | 1;
                c[T + 4 >> 2] = o | 3;
                n = T + 8 | 0;
                return n | 0
            }
            do {
                if ((c[7756] | 0) == 0) {
                    T = Kb(30) | 0;
                    if ((T - 1 & T | 0) == 0) {
                        c[7758] = T;
                        c[7757] = T;
                        c[7759] = -1;
                        c[7760] = -1;
                        c[7761] = 0;
                        c[7943] = 0;
                        T = (Ac(0) | 0) & -16 ^ 1431655768;
                        c[7756] = T;
                        break
                    } else { hc(); return 0 }
                }
            } while (0);
            T = o + 48 | 0;
            S = c[7758] | 0;
            K = o + 47 | 0;
            J = S + K | 0;
            R = -S | 0;
            S = J & R;
            if (!(S >>> 0 > o >>> 0)) { n = 0; return n | 0 }
            Q = c[7942] | 0;
            do {
                if ((Q | 0) != 0) {
                    O = c[7940] | 0;
                    P = O + S | 0;
                    if (P >>> 0 <= O >>> 0 | P >>> 0 > Q >>> 0) { n = 0 } else { break }
                    return n | 0
                }
            } while (0);
            f: do {
                if ((c[7943] & 4 | 0) == 0) {
                    Q = c[7838] | 0;
                    g: do {
                        if ((Q | 0) == 0) { U = 182 } else {
                            P = Q;
                            O = 31776;
                            while (1) {
                                V = O | 0;
                                L = c[V >> 2] | 0;
                                if (!(L >>> 0 > P >>> 0)) { W = O + 4 | 0; if ((L + (c[W >> 2] | 0) | 0) >>> 0 > P >>> 0) { break } }
                                L = c[O + 8 >> 2] | 0;
                                if ((L | 0) == 0) { U = 182; break g } else { O = L }
                            }
                            if ((O | 0) == 0) { U = 182; break }
                            P = J - (c[7835] | 0) & R;
                            if (!(P >>> 0 < 2147483647 >>> 0)) { X = 0; break }
                            e = Tb(P | 0) | 0;
                            L = (e | 0) == ((c[V >> 2] | 0) + (c[W >> 2] | 0) | 0);
                            Y = L ? e : -1;
                            Z = L ? P : 0;
                            _ = e;
                            $ = P;
                            U = 191
                        }
                    } while (0);
                    do {
                        if ((U | 0) == 182) {
                            Q = Tb(0) | 0;
                            if ((Q | 0) == -1) { X = 0; break }
                            P = Q;
                            e = c[7757] | 0;
                            L = e - 1 | 0;
                            if ((L & P | 0) == 0) { aa = S } else { aa = S - P + (L + P & -e) | 0 }
                            e = c[7940] | 0;
                            P = e + aa | 0;
                            if (!(aa >>> 0 > o >>> 0 & aa >>> 0 < 2147483647 >>> 0)) { X = 0; break }
                            L = c[7942] | 0;
                            if ((L | 0) != 0) { if (P >>> 0 <= e >>> 0 | P >>> 0 > L >>> 0) { X = 0; break } }
                            L = Tb(aa | 0) | 0;
                            P = (L | 0) == (Q | 0);
                            Y = P ? Q : -1;
                            Z = P ? aa : 0;
                            _ = L;
                            $ = aa;
                            U = 191
                        }
                    } while (0);
                    h: do {
                        if ((U | 0) == 191) {
                            L = -$ | 0;
                            if (!((Y | 0) == -1)) {
                                ba = Z;
                                ca = Y;
                                U = 202;
                                break f
                            }
                            do {
                                if ((_ | 0) != -1 & $ >>> 0 < 2147483647 >>> 0 & $ >>> 0 < T >>> 0) {
                                    P = c[7758] | 0;
                                    Q = K - $ + P & -P;
                                    if (!(Q >>> 0 < 2147483647 >>> 0)) { da = $; break }
                                    if ((Tb(Q | 0) | 0) == -1) {
                                        Tb(L | 0) | 0;
                                        X = Z;
                                        break h
                                    } else { da = Q + $ | 0; break }
                                } else { da = $ }
                            } while (0);
                            if ((_ | 0) == -1) { X = Z } else {
                                ba = da;
                                ca = _;
                                U = 202;
                                break f
                            }
                        }
                    } while (0);
                    c[7943] = c[7943] | 4;
                    ea = X;
                    U = 199
                } else {
                    ea = 0;
                    U = 199
                }
            } while (0);
            do {
                if ((U | 0) == 199) {
                    if (!(S >>> 0 < 2147483647 >>> 0)) { break }
                    X = Tb(S | 0) | 0;
                    _ = Tb(0) | 0;
                    if (!((_ | 0) != -1 & (X | 0) != -1 & X >>> 0 < _ >>> 0)) { break }
                    da = _ - X | 0;
                    _ = da >>> 0 > (o + 40 | 0) >>> 0;
                    if (_) {
                        ba = _ ? da : ea;
                        ca = X;
                        U = 202
                    }
                }
            } while (0);
            do {
                if ((U | 0) == 202) {
                    ea = (c[7940] | 0) + ba | 0;
                    c[7940] = ea;
                    if (ea >>> 0 > (c[7941] | 0) >>> 0) { c[7941] = ea }
                    ea = c[7838] | 0;
                    i: do {
                        if ((ea | 0) == 0) {
                            S = c[7836] | 0;
                            if ((S | 0) == 0 | ca >>> 0 < S >>> 0) { c[7836] = ca }
                            c[7944] = ca;
                            c[7945] = ba;
                            c[7947] = 0;
                            c[7841] = c[7756];
                            c[7840] = -1;
                            S = 0;
                            do {
                                X = S << 1;
                                da = 31368 + (X << 2) | 0;
                                c[31368 + (X + 3 << 2) >> 2] = da;
                                c[31368 + (X + 2 << 2) >> 2] = da;
                                S = S + 1 | 0;
                            } while (S >>> 0 < 32 >>> 0);
                            S = ca + 8 | 0;
                            if ((S & 7 | 0) == 0) { fa = 0 } else { fa = -S & 7 }
                            S = ba - 40 - fa | 0;
                            c[7838] = ca + fa;
                            c[7835] = S;
                            c[ca + (fa + 4) >> 2] = S | 1;
                            c[ca + (ba - 36) >> 2] = 40;
                            c[7839] = c[7760]
                        } else {
                            S = 31776;
                            while (1) {
                                ga = c[S >> 2] | 0;
                                ha = S + 4 | 0;
                                ia = c[ha >> 2] | 0;
                                if ((ca | 0) == (ga + ia | 0)) { U = 214; break }
                                da = c[S + 8 >> 2] | 0;
                                if ((da | 0) == 0) { break } else { S = da }
                            }
                            do {
                                if ((U | 0) == 214) {
                                    if ((c[S + 12 >> 2] & 8 | 0) != 0) { break }
                                    da = ea;
                                    if (!(da >>> 0 >= ga >>> 0 & da >>> 0 < ca >>> 0)) { break }
                                    c[ha >> 2] = ia + ba;
                                    X = (c[7835] | 0) + ba | 0;
                                    _ = ea + 8 | 0;
                                    if ((_ & 7 | 0) == 0) { ja = 0 } else { ja = -_ & 7 }
                                    _ = X - ja | 0;
                                    c[7838] = da + ja;
                                    c[7835] = _;
                                    c[da + (ja + 4) >> 2] = _ | 1;
                                    c[da + (X + 4) >> 2] = 40;
                                    c[7839] = c[7760];
                                    break i
                                }
                            } while (0);
                            if (ca >>> 0 < (c[7836] | 0) >>> 0) { c[7836] = ca }
                            S = ca + ba | 0;
                            X = 31776;
                            while (1) {
                                ka = X | 0;
                                if ((c[ka >> 2] | 0) == (S | 0)) { U = 224; break }
                                da = c[X + 8 >> 2] | 0;
                                if ((da | 0) == 0) { break } else { X = da }
                            }
                            do {
                                if ((U | 0) == 224) {
                                    if ((c[X + 12 >> 2] & 8 | 0) != 0) { break }
                                    c[ka >> 2] = ca;
                                    S = X + 4 | 0;
                                    c[S >> 2] = (c[S >> 2] | 0) + ba;
                                    S = ca + 8 | 0;
                                    if ((S & 7 | 0) == 0) { la = 0 } else { la = -S & 7 }
                                    S = ca + (ba + 8) | 0;
                                    if ((S & 7 | 0) == 0) { ma = 0 } else { ma = -S & 7 }
                                    S = ca + (ma + ba) | 0;
                                    da = S;
                                    _ = la + o | 0;
                                    Z = ca + _ | 0;
                                    $ = Z;
                                    K = S - (ca + la) - o | 0;
                                    c[ca + (la + 4) >> 2] = o | 3;
                                    j: do {
                                        if ((da | 0) == (c[7838] | 0)) {
                                            T = (c[7835] | 0) + K | 0;
                                            c[7835] = T;
                                            c[7838] = $;
                                            c[ca + (_ + 4) >> 2] = T | 1
                                        } else {
                                            if ((da | 0) == (c[7837] | 0)) {
                                                T = (c[7834] | 0) + K | 0;
                                                c[7834] = T;
                                                c[7837] = $;
                                                c[ca + (_ + 4) >> 2] = T | 1;
                                                c[ca + (T + _) >> 2] = T;
                                                break
                                            }
                                            T = ba + 4 | 0;
                                            Y = c[ca + (T + ma) >> 2] | 0;
                                            if ((Y & 3 | 0) == 1) {
                                                aa = Y & -8;
                                                W = Y >>> 3;
                                                k: do {
                                                    if (Y >>> 0 < 256 >>> 0) {
                                                        V = c[ca + ((ma | 8) + ba) >> 2] | 0;
                                                        R = c[ca + (ba + 12 + ma) >> 2] | 0;
                                                        J = 31368 + (W << 1 << 2) | 0;
                                                        do {
                                                            if ((V | 0) != (J | 0)) {
                                                                if (V >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                                                if ((c[V + 12 >> 2] | 0) == (da | 0)) { break }
                                                                hc();
                                                                return 0
                                                            }
                                                        } while (0);
                                                        if ((R | 0) == (V | 0)) { c[7832] = c[7832] & ~(1 << W); break }
                                                        do {
                                                            if ((R | 0) == (J | 0)) { na = R + 8 | 0 } else {
                                                                if (R >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                                                L = R + 8 | 0;
                                                                if ((c[L >> 2] | 0) == (da | 0)) { na = L; break }
                                                                hc();
                                                                return 0
                                                            }
                                                        } while (0);
                                                        c[V + 12 >> 2] = R;
                                                        c[na >> 2] = V
                                                    } else {
                                                        J = S;
                                                        L = c[ca + ((ma | 24) + ba) >> 2] | 0;
                                                        O = c[ca + (ba + 12 + ma) >> 2] | 0;
                                                        do {
                                                            if ((O | 0) == (J | 0)) {
                                                                Q = ma | 16;
                                                                P = ca + (T + Q) | 0;
                                                                e = c[P >> 2] | 0;
                                                                if ((e | 0) == 0) {
                                                                    M = ca + (Q + ba) | 0;
                                                                    Q = c[M >> 2] | 0;
                                                                    if ((Q | 0) == 0) { oa = 0; break } else {
                                                                        pa = Q;
                                                                        qa = M
                                                                    }
                                                                } else {
                                                                    pa = e;
                                                                    qa = P
                                                                }
                                                                while (1) {
                                                                    P = pa + 20 | 0;
                                                                    e = c[P >> 2] | 0;
                                                                    if ((e | 0) != 0) {
                                                                        pa = e;
                                                                        qa = P;
                                                                        continue
                                                                    }
                                                                    P = pa + 16 | 0;
                                                                    e = c[P >> 2] | 0;
                                                                    if ((e | 0) == 0) { break } else {
                                                                        pa = e;
                                                                        qa = P
                                                                    }
                                                                }
                                                                if (qa >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                                                    c[qa >> 2] = 0;
                                                                    oa = pa;
                                                                    break
                                                                }
                                                            } else {
                                                                P = c[ca + ((ma | 8) + ba) >> 2] | 0;
                                                                if (P >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                                                e = P + 12 | 0;
                                                                if ((c[e >> 2] | 0) != (J | 0)) { hc(); return 0 }
                                                                M = O + 8 | 0;
                                                                if ((c[M >> 2] | 0) == (J | 0)) {
                                                                    c[e >> 2] = O;
                                                                    c[M >> 2] = P;
                                                                    oa = O;
                                                                    break
                                                                } else { hc(); return 0 }
                                                            }
                                                        } while (0);
                                                        if ((L | 0) == 0) { break }
                                                        O = c[ca + (ba + 28 + ma) >> 2] | 0;
                                                        V = 31632 + (O << 2) | 0;
                                                        do {
                                                            if ((J | 0) == (c[V >> 2] | 0)) {
                                                                c[V >> 2] = oa;
                                                                if ((oa | 0) != 0) { break }
                                                                c[7833] = c[7833] & ~(1 << O);
                                                                break k
                                                            } else {
                                                                if (L >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                                                R = L + 16 | 0;
                                                                if ((c[R >> 2] | 0) == (J | 0)) { c[R >> 2] = oa } else { c[L + 20 >> 2] = oa }
                                                                if ((oa | 0) == 0) { break k }
                                                            }
                                                        } while (0);
                                                        if (oa >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                                                        c[oa + 24 >> 2] = L;
                                                        J = ma | 16;
                                                        O = c[ca + (J + ba) >> 2] | 0;
                                                        do {
                                                            if ((O | 0) != 0) {
                                                                if (O >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                                                    c[oa + 16 >> 2] = O;
                                                                    c[O + 24 >> 2] = oa;
                                                                    break
                                                                }
                                                            }
                                                        } while (0);
                                                        O = c[ca + (T + J) >> 2] | 0;
                                                        if ((O | 0) == 0) { break }
                                                        if (O >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                                            c[oa + 20 >> 2] = O;
                                                            c[O + 24 >> 2] = oa;
                                                            break
                                                        }
                                                    }
                                                } while (0);
                                                ra = ca + ((aa | ma) + ba) | 0;
                                                sa = aa + K | 0
                                            } else {
                                                ra = da;
                                                sa = K
                                            }
                                            T = ra + 4 | 0;
                                            c[T >> 2] = c[T >> 2] & -2;
                                            c[ca + (_ + 4) >> 2] = sa | 1;
                                            c[ca + (sa + _) >> 2] = sa;
                                            T = sa >>> 3;
                                            if (sa >>> 0 < 256 >>> 0) {
                                                W = T << 1;
                                                Y = 31368 + (W << 2) | 0;
                                                O = c[7832] | 0;
                                                L = 1 << T;
                                                do {
                                                    if ((O & L | 0) == 0) {
                                                        c[7832] = O | L;
                                                        ta = Y;
                                                        ua = 31368 + (W + 2 << 2) | 0
                                                    } else {
                                                        T = 31368 + (W + 2 << 2) | 0;
                                                        V = c[T >> 2] | 0;
                                                        if (!(V >>> 0 < (c[7836] | 0) >>> 0)) {
                                                            ta = V;
                                                            ua = T;
                                                            break
                                                        }
                                                        hc();
                                                        return 0
                                                    }
                                                } while (0);
                                                c[ua >> 2] = $;
                                                c[ta + 12 >> 2] = $;
                                                c[ca + (_ + 8) >> 2] = ta;
                                                c[ca + (_ + 12) >> 2] = Y;
                                                break
                                            }
                                            W = Z;
                                            L = sa >>> 8;
                                            do {
                                                if ((L | 0) == 0) { va = 0 } else {
                                                    if (sa >>> 0 > 16777215 >>> 0) { va = 31; break }
                                                    O = (L + 1048320 | 0) >>> 16 & 8;
                                                    aa = L << O;
                                                    T = (aa + 520192 | 0) >>> 16 & 4;
                                                    V = aa << T;
                                                    aa = (V + 245760 | 0) >>> 16 & 2;
                                                    R = 14 - (T | O | aa) + (V << aa >>> 15) | 0;
                                                    va = sa >>> ((R + 7 | 0) >>> 0) & 1 | R << 1
                                                }
                                            } while (0);
                                            L = 31632 + (va << 2) | 0;
                                            c[ca + (_ + 28) >> 2] = va;
                                            c[ca + (_ + 20) >> 2] = 0;
                                            c[ca + (_ + 16) >> 2] = 0;
                                            Y = c[7833] | 0;
                                            R = 1 << va;
                                            if ((Y & R | 0) == 0) {
                                                c[7833] = Y | R;
                                                c[L >> 2] = W;
                                                c[ca + (_ + 24) >> 2] = L;
                                                c[ca + (_ + 12) >> 2] = W;
                                                c[ca + (_ + 8) >> 2] = W;
                                                break
                                            }
                                            R = c[L >> 2] | 0;
                                            if ((va | 0) == 31) { wa = 0 } else { wa = 25 - (va >>> 1) | 0 }
                                            l: do {
                                                if ((c[R + 4 >> 2] & -8 | 0) == (sa | 0)) { xa = R } else {
                                                    L = R;
                                                    Y = sa << wa;
                                                    while (1) {
                                                        ya = L + 16 + (Y >>> 31 << 2) | 0;
                                                        aa = c[ya >> 2] | 0;
                                                        if ((aa | 0) == 0) { break }
                                                        if ((c[aa + 4 >> 2] & -8 | 0) == (sa | 0)) { xa = aa; break l } else {
                                                            L = aa;
                                                            Y = Y << 1
                                                        }
                                                    }
                                                    if (ya >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                                        c[ya >> 2] = W;
                                                        c[ca + (_ + 24) >> 2] = L;
                                                        c[ca + (_ + 12) >> 2] = W;
                                                        c[ca + (_ + 8) >> 2] = W;
                                                        break j
                                                    }
                                                }
                                            } while (0);
                                            R = xa + 8 | 0;
                                            Y = c[R >> 2] | 0;
                                            J = c[7836] | 0;
                                            if (xa >>> 0 < J >>> 0) { hc(); return 0 }
                                            if (Y >>> 0 < J >>> 0) { hc(); return 0 } else {
                                                c[Y + 12 >> 2] = W;
                                                c[R >> 2] = W;
                                                c[ca + (_ + 8) >> 2] = Y;
                                                c[ca + (_ + 12) >> 2] = xa;
                                                c[ca + (_ + 24) >> 2] = 0;
                                                break
                                            }
                                        }
                                    } while (0);
                                    n = ca + (la | 8) | 0;
                                    return n | 0
                                }
                            } while (0);
                            X = ea;
                            _ = 31776;
                            while (1) {
                                za = c[_ >> 2] | 0;
                                if (!(za >>> 0 > X >>> 0)) {
                                    Aa = c[_ + 4 >> 2] | 0;
                                    Ba = za + Aa | 0;
                                    if (Ba >>> 0 > X >>> 0) { break }
                                }
                                _ = c[_ + 8 >> 2] | 0
                            }
                            _ = za + (Aa - 39) | 0;
                            if ((_ & 7 | 0) == 0) { Ca = 0 } else { Ca = -_ & 7 }
                            _ = za + (Aa - 47 + Ca) | 0;
                            Z = _ >>> 0 < (ea + 16 | 0) >>> 0 ? X : _;
                            _ = Z + 8 | 0;
                            $ = ca + 8 | 0;
                            if (($ & 7 | 0) == 0) { Da = 0 } else { Da = -$ & 7 }
                            $ = ba - 40 - Da | 0;
                            c[7838] = ca + Da;
                            c[7835] = $;
                            c[ca + (Da + 4) >> 2] = $ | 1;
                            c[ca + (ba - 36) >> 2] = 40;
                            c[7839] = c[7760];
                            c[Z + 4 >> 2] = 27;
                            c[_ >> 2] = c[7944];
                            c[_ + 4 >> 2] = c[7945];
                            c[_ + 8 >> 2] = c[7946];
                            c[_ + 12 >> 2] = c[7947];
                            c[7944] = ca;
                            c[7945] = ba;
                            c[7947] = 0;
                            c[7946] = _;
                            _ = Z + 28 | 0;
                            c[_ >> 2] = 7;
                            if ((Z + 32 | 0) >>> 0 < Ba >>> 0) {
                                $ = _;
                                while (1) {
                                    _ = $ + 4 | 0;
                                    c[_ >> 2] = 7;
                                    if (($ + 8 | 0) >>> 0 < Ba >>> 0) { $ = _ } else { break }
                                }
                            }
                            if ((Z | 0) == (X | 0)) { break }
                            $ = Z - ea | 0;
                            _ = X + ($ + 4) | 0;
                            c[_ >> 2] = c[_ >> 2] & -2;
                            c[ea + 4 >> 2] = $ | 1;
                            c[X + $ >> 2] = $;
                            _ = $ >>> 3;
                            if ($ >>> 0 < 256 >>> 0) {
                                K = _ << 1;
                                da = 31368 + (K << 2) | 0;
                                S = c[7832] | 0;
                                j = 1 << _;
                                do {
                                    if ((S & j | 0) == 0) {
                                        c[7832] = S | j;
                                        Ea = da;
                                        Fa = 31368 + (K + 2 << 2) | 0
                                    } else {
                                        _ = 31368 + (K + 2 << 2) | 0;
                                        Y = c[_ >> 2] | 0;
                                        if (!(Y >>> 0 < (c[7836] | 0) >>> 0)) {
                                            Ea = Y;
                                            Fa = _;
                                            break
                                        }
                                        hc();
                                        return 0
                                    }
                                } while (0);
                                c[Fa >> 2] = ea;
                                c[Ea + 12 >> 2] = ea;
                                c[ea + 8 >> 2] = Ea;
                                c[ea + 12 >> 2] = da;
                                break
                            }
                            K = ea;
                            j = $ >>> 8;
                            do {
                                if ((j | 0) == 0) { Ga = 0 } else {
                                    if ($ >>> 0 > 16777215 >>> 0) { Ga = 31; break }
                                    S = (j + 1048320 | 0) >>> 16 & 8;
                                    X = j << S;
                                    Z = (X + 520192 | 0) >>> 16 & 4;
                                    _ = X << Z;
                                    X = (_ + 245760 | 0) >>> 16 & 2;
                                    Y = 14 - (Z | S | X) + (_ << X >>> 15) | 0;
                                    Ga = $ >>> ((Y + 7 | 0) >>> 0) & 1 | Y << 1
                                }
                            } while (0);
                            j = 31632 + (Ga << 2) | 0;
                            c[ea + 28 >> 2] = Ga;
                            c[ea + 20 >> 2] = 0;
                            c[ea + 16 >> 2] = 0;
                            da = c[7833] | 0;
                            Y = 1 << Ga;
                            if ((da & Y | 0) == 0) {
                                c[7833] = da | Y;
                                c[j >> 2] = K;
                                c[ea + 24 >> 2] = j;
                                c[ea + 12 >> 2] = ea;
                                c[ea + 8 >> 2] = ea;
                                break
                            }
                            Y = c[j >> 2] | 0;
                            if ((Ga | 0) == 31) { Ha = 0 } else { Ha = 25 - (Ga >>> 1) | 0 }
                            m: do {
                                if ((c[Y + 4 >> 2] & -8 | 0) == ($ | 0)) { Ia = Y } else {
                                    j = Y;
                                    da = $ << Ha;
                                    while (1) {
                                        Ja = j + 16 + (da >>> 31 << 2) | 0;
                                        X = c[Ja >> 2] | 0;
                                        if ((X | 0) == 0) { break }
                                        if ((c[X + 4 >> 2] & -8 | 0) == ($ | 0)) { Ia = X; break m } else {
                                            j = X;
                                            da = da << 1
                                        }
                                    }
                                    if (Ja >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                        c[Ja >> 2] = K;
                                        c[ea + 24 >> 2] = j;
                                        c[ea + 12 >> 2] = ea;
                                        c[ea + 8 >> 2] = ea;
                                        break i
                                    }
                                }
                            } while (0);
                            $ = Ia + 8 | 0;
                            Y = c[$ >> 2] | 0;
                            da = c[7836] | 0;
                            if (Ia >>> 0 < da >>> 0) { hc(); return 0 }
                            if (Y >>> 0 < da >>> 0) { hc(); return 0 } else {
                                c[Y + 12 >> 2] = K;
                                c[$ >> 2] = K;
                                c[ea + 8 >> 2] = Y;
                                c[ea + 12 >> 2] = Ia;
                                c[ea + 24 >> 2] = 0;
                                break
                            }
                        }
                    } while (0);
                    ea = c[7835] | 0;
                    if (!(ea >>> 0 > o >>> 0)) { break }
                    Y = ea - o | 0;
                    c[7835] = Y;
                    ea = c[7838] | 0;
                    $ = ea;
                    c[7838] = $ + o;
                    c[$ + (o + 4) >> 2] = Y | 1;
                    c[ea + 4 >> 2] = o | 3;
                    n = ea + 8 | 0;
                    return n | 0
                }
            } while (0);
            o = Vb() | 0;
            c[o >> 2] = 12;
            n = 0;
            return n | 0
        }

        function Hu(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0;
            if ((a | 0) == 0) { return }
            b = a - 8 | 0;
            d = b;
            e = c[7836] | 0;
            if (b >>> 0 < e >>> 0) { hc() }
            f = c[a - 4 >> 2] | 0;
            g = f & 3;
            if ((g | 0) == 1) { hc() }
            h = f & -8;
            i = a + (h - 8) | 0;
            j = i;
            a: do {
                if ((f & 1 | 0) == 0) {
                    k = c[b >> 2] | 0;
                    if ((g | 0) == 0) { return }
                    l = -8 - k | 0;
                    m = a + l | 0;
                    n = m;
                    o = k + h | 0;
                    if (m >>> 0 < e >>> 0) { hc() }
                    if ((n | 0) == (c[7837] | 0)) {
                        p = a + (h - 4) | 0;
                        if ((c[p >> 2] & 3 | 0) != 3) {
                            q = n;
                            r = o;
                            break
                        }
                        c[7834] = o;
                        c[p >> 2] = c[p >> 2] & -2;
                        c[a + (l + 4) >> 2] = o | 1;
                        c[i >> 2] = o;
                        return
                    }
                    p = k >>> 3;
                    if (k >>> 0 < 256 >>> 0) {
                        k = c[a + (l + 8) >> 2] | 0;
                        s = c[a + (l + 12) >> 2] | 0;
                        t = 31368 + (p << 1 << 2) | 0;
                        do {
                            if ((k | 0) != (t | 0)) {
                                if (k >>> 0 < e >>> 0) { hc() }
                                if ((c[k + 12 >> 2] | 0) == (n | 0)) { break }
                                hc()
                            }
                        } while (0);
                        if ((s | 0) == (k | 0)) {
                            c[7832] = c[7832] & ~(1 << p);
                            q = n;
                            r = o;
                            break
                        }
                        do {
                            if ((s | 0) == (t | 0)) { u = s + 8 | 0 } else {
                                if (s >>> 0 < e >>> 0) { hc() }
                                v = s + 8 | 0;
                                if ((c[v >> 2] | 0) == (n | 0)) { u = v; break }
                                hc()
                            }
                        } while (0);
                        c[k + 12 >> 2] = s;
                        c[u >> 2] = k;
                        q = n;
                        r = o;
                        break
                    }
                    t = m;
                    p = c[a + (l + 24) >> 2] | 0;
                    v = c[a + (l + 12) >> 2] | 0;
                    do {
                        if ((v | 0) == (t | 0)) {
                            w = a + (l + 20) | 0;
                            x = c[w >> 2] | 0;
                            if ((x | 0) == 0) {
                                y = a + (l + 16) | 0;
                                z = c[y >> 2] | 0;
                                if ((z | 0) == 0) { A = 0; break } else {
                                    B = z;
                                    C = y
                                }
                            } else {
                                B = x;
                                C = w
                            }
                            while (1) {
                                w = B + 20 | 0;
                                x = c[w >> 2] | 0;
                                if ((x | 0) != 0) {
                                    B = x;
                                    C = w;
                                    continue
                                }
                                w = B + 16 | 0;
                                x = c[w >> 2] | 0;
                                if ((x | 0) == 0) { break } else {
                                    B = x;
                                    C = w
                                }
                            }
                            if (C >>> 0 < e >>> 0) { hc() } else {
                                c[C >> 2] = 0;
                                A = B;
                                break
                            }
                        } else {
                            w = c[a + (l + 8) >> 2] | 0;
                            if (w >>> 0 < e >>> 0) { hc() }
                            x = w + 12 | 0;
                            if ((c[x >> 2] | 0) != (t | 0)) { hc() }
                            y = v + 8 | 0;
                            if ((c[y >> 2] | 0) == (t | 0)) {
                                c[x >> 2] = v;
                                c[y >> 2] = w;
                                A = v;
                                break
                            } else { hc() }
                        }
                    } while (0);
                    if ((p | 0) == 0) {
                        q = n;
                        r = o;
                        break
                    }
                    v = c[a + (l + 28) >> 2] | 0;
                    m = 31632 + (v << 2) | 0;
                    do {
                        if ((t | 0) == (c[m >> 2] | 0)) {
                            c[m >> 2] = A;
                            if ((A | 0) != 0) { break }
                            c[7833] = c[7833] & ~(1 << v);
                            q = n;
                            r = o;
                            break a
                        } else {
                            if (p >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                            k = p + 16 | 0;
                            if ((c[k >> 2] | 0) == (t | 0)) { c[k >> 2] = A } else { c[p + 20 >> 2] = A }
                            if ((A | 0) == 0) {
                                q = n;
                                r = o;
                                break a
                            }
                        }
                    } while (0);
                    if (A >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                    c[A + 24 >> 2] = p;
                    t = c[a + (l + 16) >> 2] | 0;
                    do {
                        if ((t | 0) != 0) {
                            if (t >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                                c[A + 16 >> 2] = t;
                                c[t + 24 >> 2] = A;
                                break
                            }
                        }
                    } while (0);
                    t = c[a + (l + 20) >> 2] | 0;
                    if ((t | 0) == 0) {
                        q = n;
                        r = o;
                        break
                    }
                    if (t >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                        c[A + 20 >> 2] = t;
                        c[t + 24 >> 2] = A;
                        q = n;
                        r = o;
                        break
                    }
                } else {
                    q = d;
                    r = h
                }
            } while (0);
            d = q;
            if (!(d >>> 0 < i >>> 0)) { hc() }
            A = a + (h - 4) | 0;
            e = c[A >> 2] | 0;
            if ((e & 1 | 0) == 0) { hc() }
            do {
                if ((e & 2 | 0) == 0) {
                    if ((j | 0) == (c[7838] | 0)) {
                        B = (c[7835] | 0) + r | 0;
                        c[7835] = B;
                        c[7838] = q;
                        c[q + 4 >> 2] = B | 1;
                        if ((q | 0) != (c[7837] | 0)) { return }
                        c[7837] = 0;
                        c[7834] = 0;
                        return
                    }
                    if ((j | 0) == (c[7837] | 0)) {
                        B = (c[7834] | 0) + r | 0;
                        c[7834] = B;
                        c[7837] = q;
                        c[q + 4 >> 2] = B | 1;
                        c[d + B >> 2] = B;
                        return
                    }
                    B = (e & -8) + r | 0;
                    C = e >>> 3;
                    b: do {
                        if (e >>> 0 < 256 >>> 0) {
                            u = c[a + h >> 2] | 0;
                            g = c[a + (h | 4) >> 2] | 0;
                            b = 31368 + (C << 1 << 2) | 0;
                            do {
                                if ((u | 0) != (b | 0)) {
                                    if (u >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                                    if ((c[u + 12 >> 2] | 0) == (j | 0)) { break }
                                    hc()
                                }
                            } while (0);
                            if ((g | 0) == (u | 0)) { c[7832] = c[7832] & ~(1 << C); break }
                            do {
                                if ((g | 0) == (b | 0)) { D = g + 8 | 0 } else {
                                    if (g >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                                    f = g + 8 | 0;
                                    if ((c[f >> 2] | 0) == (j | 0)) { D = f; break }
                                    hc()
                                }
                            } while (0);
                            c[u + 12 >> 2] = g;
                            c[D >> 2] = u
                        } else {
                            b = i;
                            f = c[a + (h + 16) >> 2] | 0;
                            t = c[a + (h | 4) >> 2] | 0;
                            do {
                                if ((t | 0) == (b | 0)) {
                                    p = a + (h + 12) | 0;
                                    v = c[p >> 2] | 0;
                                    if ((v | 0) == 0) {
                                        m = a + (h + 8) | 0;
                                        k = c[m >> 2] | 0;
                                        if ((k | 0) == 0) { E = 0; break } else {
                                            F = k;
                                            G = m
                                        }
                                    } else {
                                        F = v;
                                        G = p
                                    }
                                    while (1) {
                                        p = F + 20 | 0;
                                        v = c[p >> 2] | 0;
                                        if ((v | 0) != 0) {
                                            F = v;
                                            G = p;
                                            continue
                                        }
                                        p = F + 16 | 0;
                                        v = c[p >> 2] | 0;
                                        if ((v | 0) == 0) { break } else {
                                            F = v;
                                            G = p
                                        }
                                    }
                                    if (G >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                                        c[G >> 2] = 0;
                                        E = F;
                                        break
                                    }
                                } else {
                                    p = c[a + h >> 2] | 0;
                                    if (p >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                                    v = p + 12 | 0;
                                    if ((c[v >> 2] | 0) != (b | 0)) { hc() }
                                    m = t + 8 | 0;
                                    if ((c[m >> 2] | 0) == (b | 0)) {
                                        c[v >> 2] = t;
                                        c[m >> 2] = p;
                                        E = t;
                                        break
                                    } else { hc() }
                                }
                            } while (0);
                            if ((f | 0) == 0) { break }
                            t = c[a + (h + 20) >> 2] | 0;
                            u = 31632 + (t << 2) | 0;
                            do {
                                if ((b | 0) == (c[u >> 2] | 0)) {
                                    c[u >> 2] = E;
                                    if ((E | 0) != 0) { break }
                                    c[7833] = c[7833] & ~(1 << t);
                                    break b
                                } else {
                                    if (f >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                                    g = f + 16 | 0;
                                    if ((c[g >> 2] | 0) == (b | 0)) { c[g >> 2] = E } else { c[f + 20 >> 2] = E }
                                    if ((E | 0) == 0) { break b }
                                }
                            } while (0);
                            if (E >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                            c[E + 24 >> 2] = f;
                            b = c[a + (h + 8) >> 2] | 0;
                            do {
                                if ((b | 0) != 0) {
                                    if (b >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                                        c[E + 16 >> 2] = b;
                                        c[b + 24 >> 2] = E;
                                        break
                                    }
                                }
                            } while (0);
                            b = c[a + (h + 12) >> 2] | 0;
                            if ((b | 0) == 0) { break }
                            if (b >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                                c[E + 20 >> 2] = b;
                                c[b + 24 >> 2] = E;
                                break
                            }
                        }
                    } while (0);
                    c[q + 4 >> 2] = B | 1;
                    c[d + B >> 2] = B;
                    if ((q | 0) != (c[7837] | 0)) { H = B; break }
                    c[7834] = B;
                    return
                } else {
                    c[A >> 2] = e & -2;
                    c[q + 4 >> 2] = r | 1;
                    c[d + r >> 2] = r;
                    H = r
                }
            } while (0);
            r = H >>> 3;
            if (H >>> 0 < 256 >>> 0) {
                d = r << 1;
                e = 31368 + (d << 2) | 0;
                A = c[7832] | 0;
                E = 1 << r;
                do {
                    if ((A & E | 0) == 0) {
                        c[7832] = A | E;
                        I = e;
                        J = 31368 + (d + 2 << 2) | 0
                    } else {
                        r = 31368 + (d + 2 << 2) | 0;
                        h = c[r >> 2] | 0;
                        if (!(h >>> 0 < (c[7836] | 0) >>> 0)) {
                            I = h;
                            J = r;
                            break
                        }
                        hc()
                    }
                } while (0);
                c[J >> 2] = q;
                c[I + 12 >> 2] = q;
                c[q + 8 >> 2] = I;
                c[q + 12 >> 2] = e;
                return
            }
            e = q;
            I = H >>> 8;
            do {
                if ((I | 0) == 0) { K = 0 } else {
                    if (H >>> 0 > 16777215 >>> 0) { K = 31; break }
                    J = (I + 1048320 | 0) >>> 16 & 8;
                    d = I << J;
                    E = (d + 520192 | 0) >>> 16 & 4;
                    A = d << E;
                    d = (A + 245760 | 0) >>> 16 & 2;
                    r = 14 - (E | J | d) + (A << d >>> 15) | 0;
                    K = H >>> ((r + 7 | 0) >>> 0) & 1 | r << 1
                }
            } while (0);
            I = 31632 + (K << 2) | 0;
            c[q + 28 >> 2] = K;
            c[q + 20 >> 2] = 0;
            c[q + 16 >> 2] = 0;
            r = c[7833] | 0;
            d = 1 << K;
            c: do {
                if ((r & d | 0) == 0) {
                    c[7833] = r | d;
                    c[I >> 2] = e;
                    c[q + 24 >> 2] = I;
                    c[q + 12 >> 2] = q;
                    c[q + 8 >> 2] = q
                } else {
                    A = c[I >> 2] | 0;
                    if ((K | 0) == 31) { L = 0 } else { L = 25 - (K >>> 1) | 0 }
                    d: do {
                        if ((c[A + 4 >> 2] & -8 | 0) == (H | 0)) { M = A } else {
                            J = A;
                            E = H << L;
                            while (1) {
                                N = J + 16 + (E >>> 31 << 2) | 0;
                                h = c[N >> 2] | 0;
                                if ((h | 0) == 0) { break }
                                if ((c[h + 4 >> 2] & -8 | 0) == (H | 0)) { M = h; break d } else {
                                    J = h;
                                    E = E << 1
                                }
                            }
                            if (N >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                                c[N >> 2] = e;
                                c[q + 24 >> 2] = J;
                                c[q + 12 >> 2] = q;
                                c[q + 8 >> 2] = q;
                                break c
                            }
                        }
                    } while (0);
                    A = M + 8 | 0;
                    B = c[A >> 2] | 0;
                    E = c[7836] | 0;
                    if (M >>> 0 < E >>> 0) { hc() }
                    if (B >>> 0 < E >>> 0) { hc() } else {
                        c[B + 12 >> 2] = e;
                        c[A >> 2] = e;
                        c[q + 8 >> 2] = B;
                        c[q + 12 >> 2] = M;
                        c[q + 24 >> 2] = 0;
                        break
                    }
                }
            } while (0);
            q = (c[7840] | 0) - 1 | 0;
            c[7840] = q;
            if ((q | 0) == 0) { O = 31784 } else { return }
            while (1) { q = c[O >> 2] | 0; if ((q | 0) == 0) { break } else { O = q + 8 | 0 } }
            c[7840] = -1;
            return
        }

        function Iu(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0;
            if ((a | 0) == 0) { d = Gu(b) | 0; return d | 0 }
            if (b >>> 0 > 4294967231 >>> 0) {
                e = Vb() | 0;
                c[e >> 2] = 12;
                d = 0;
                return d | 0
            }
            if (b >>> 0 < 11 >>> 0) { f = 16 } else { f = b + 11 & -8 }
            e = Ju(a - 8 | 0, f) | 0;
            if ((e | 0) != 0) { d = e + 8 | 0; return d | 0 }
            e = Gu(b) | 0;
            if ((e | 0) == 0) { d = 0; return d | 0 }
            f = c[a - 4 >> 2] | 0;
            g = (f & -8) - ((f & 3 | 0) == 0 ? 8 : 4) | 0;
            cv(e | 0, a | 0, g >>> 0 < b >>> 0 ? g : b) | 0;
            Hu(a);
            d = e;
            return d | 0
        }

        function Ju(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0;
            d = a + 4 | 0;
            e = c[d >> 2] | 0;
            f = e & -8;
            g = a;
            h = g + f | 0;
            i = h;
            j = c[7836] | 0;
            if (g >>> 0 < j >>> 0) { hc(); return 0 }
            k = e & 3;
            if (!((k | 0) != 1 & g >>> 0 < h >>> 0)) { hc(); return 0 }
            l = g + (f | 4) | 0;
            m = c[l >> 2] | 0;
            if ((m & 1 | 0) == 0) { hc(); return 0 }
            if ((k | 0) == 0) {
                if (b >>> 0 < 256 >>> 0) { n = 0; return n | 0 }
                do { if (!(f >>> 0 < (b + 4 | 0) >>> 0)) { if ((f - b | 0) >>> 0 > c[7758] << 1 >>> 0) { break } else { n = a } return n | 0 } } while (0);
                n = 0;
                return n | 0
            }
            if (!(f >>> 0 < b >>> 0)) {
                k = f - b | 0;
                if (!(k >>> 0 > 15 >>> 0)) { n = a; return n | 0 }
                c[d >> 2] = e & 1 | b | 2;
                c[g + (b + 4) >> 2] = k | 3;
                c[l >> 2] = c[l >> 2] | 1;
                Mu(g + b | 0, k);
                n = a;
                return n | 0
            }
            if ((i | 0) == (c[7838] | 0)) {
                k = (c[7835] | 0) + f | 0;
                if (!(k >>> 0 > b >>> 0)) { n = 0; return n | 0 }
                l = k - b | 0;
                c[d >> 2] = e & 1 | b | 2;
                c[g + (b + 4) >> 2] = l | 1;
                c[7838] = g + b;
                c[7835] = l;
                n = a;
                return n | 0
            }
            if ((i | 0) == (c[7837] | 0)) {
                l = (c[7834] | 0) + f | 0;
                if (l >>> 0 < b >>> 0) { n = 0; return n | 0 }
                k = l - b | 0;
                if (k >>> 0 > 15 >>> 0) {
                    c[d >> 2] = e & 1 | b | 2;
                    c[g + (b + 4) >> 2] = k | 1;
                    c[g + l >> 2] = k;
                    o = g + (l + 4) | 0;
                    c[o >> 2] = c[o >> 2] & -2;
                    p = g + b | 0;
                    q = k
                } else {
                    c[d >> 2] = e & 1 | l | 2;
                    e = g + (l + 4) | 0;
                    c[e >> 2] = c[e >> 2] | 1;
                    p = 0;
                    q = 0
                }
                c[7834] = q;
                c[7837] = p;
                n = a;
                return n | 0
            }
            if ((m & 2 | 0) != 0) { n = 0; return n | 0 }
            p = (m & -8) + f | 0;
            if (p >>> 0 < b >>> 0) { n = 0; return n | 0 }
            q = p - b | 0;
            e = m >>> 3;
            a: do {
                if (m >>> 0 < 256 >>> 0) {
                    l = c[g + (f + 8) >> 2] | 0;
                    k = c[g + (f + 12) >> 2] | 0;
                    o = 31368 + (e << 1 << 2) | 0;
                    do {
                        if ((l | 0) != (o | 0)) {
                            if (l >>> 0 < j >>> 0) { hc(); return 0 }
                            if ((c[l + 12 >> 2] | 0) == (i | 0)) { break }
                            hc();
                            return 0
                        }
                    } while (0);
                    if ((k | 0) == (l | 0)) { c[7832] = c[7832] & ~(1 << e); break }
                    do {
                        if ((k | 0) == (o | 0)) { r = k + 8 | 0 } else {
                            if (k >>> 0 < j >>> 0) { hc(); return 0 }
                            s = k + 8 | 0;
                            if ((c[s >> 2] | 0) == (i | 0)) { r = s; break }
                            hc();
                            return 0
                        }
                    } while (0);
                    c[l + 12 >> 2] = k;
                    c[r >> 2] = l
                } else {
                    o = h;
                    s = c[g + (f + 24) >> 2] | 0;
                    t = c[g + (f + 12) >> 2] | 0;
                    do {
                        if ((t | 0) == (o | 0)) {
                            u = g + (f + 20) | 0;
                            v = c[u >> 2] | 0;
                            if ((v | 0) == 0) {
                                w = g + (f + 16) | 0;
                                x = c[w >> 2] | 0;
                                if ((x | 0) == 0) { y = 0; break } else {
                                    z = x;
                                    A = w
                                }
                            } else {
                                z = v;
                                A = u
                            }
                            while (1) {
                                u = z + 20 | 0;
                                v = c[u >> 2] | 0;
                                if ((v | 0) != 0) {
                                    z = v;
                                    A = u;
                                    continue
                                }
                                u = z + 16 | 0;
                                v = c[u >> 2] | 0;
                                if ((v | 0) == 0) { break } else {
                                    z = v;
                                    A = u
                                }
                            }
                            if (A >>> 0 < j >>> 0) { hc(); return 0 } else {
                                c[A >> 2] = 0;
                                y = z;
                                break
                            }
                        } else {
                            u = c[g + (f + 8) >> 2] | 0;
                            if (u >>> 0 < j >>> 0) { hc(); return 0 }
                            v = u + 12 | 0;
                            if ((c[v >> 2] | 0) != (o | 0)) { hc(); return 0 }
                            w = t + 8 | 0;
                            if ((c[w >> 2] | 0) == (o | 0)) {
                                c[v >> 2] = t;
                                c[w >> 2] = u;
                                y = t;
                                break
                            } else { hc(); return 0 }
                        }
                    } while (0);
                    if ((s | 0) == 0) { break }
                    t = c[g + (f + 28) >> 2] | 0;
                    l = 31632 + (t << 2) | 0;
                    do {
                        if ((o | 0) == (c[l >> 2] | 0)) {
                            c[l >> 2] = y;
                            if ((y | 0) != 0) { break }
                            c[7833] = c[7833] & ~(1 << t);
                            break a
                        } else {
                            if (s >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                            k = s + 16 | 0;
                            if ((c[k >> 2] | 0) == (o | 0)) { c[k >> 2] = y } else { c[s + 20 >> 2] = y }
                            if ((y | 0) == 0) { break a }
                        }
                    } while (0);
                    if (y >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 }
                    c[y + 24 >> 2] = s;
                    o = c[g + (f + 16) >> 2] | 0;
                    do {
                        if ((o | 0) != 0) {
                            if (o >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                                c[y + 16 >> 2] = o;
                                c[o + 24 >> 2] = y;
                                break
                            }
                        }
                    } while (0);
                    o = c[g + (f + 20) >> 2] | 0;
                    if ((o | 0) == 0) { break }
                    if (o >>> 0 < (c[7836] | 0) >>> 0) { hc(); return 0 } else {
                        c[y + 20 >> 2] = o;
                        c[o + 24 >> 2] = y;
                        break
                    }
                }
            } while (0);
            if (q >>> 0 < 16 >>> 0) {
                c[d >> 2] = p | c[d >> 2] & 1 | 2;
                y = g + (p | 4) | 0;
                c[y >> 2] = c[y >> 2] | 1;
                n = a;
                return n | 0
            } else {
                c[d >> 2] = c[d >> 2] & 1 | b | 2;
                c[g + (b + 4) >> 2] = q | 3;
                d = g + (p | 4) | 0;
                c[d >> 2] = c[d >> 2] | 1;
                Mu(g + b | 0, q);
                n = a;
                return n | 0
            }
            return 0
        }

        function Ku(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            if (a >>> 0 < 9 >>> 0) { c = Gu(b) | 0; return c | 0 } else { c = Lu(a, b) | 0; return c | 0 }
            return 0
        }

        function Lu(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0;
            d = a >>> 0 < 16 >>> 0 ? 16 : a;
            if ((d - 1 & d | 0) == 0) { e = d } else { a = 16; while (1) { if (a >>> 0 < d >>> 0) { a = a << 1 } else { e = a; break } } }
            if (!((-64 - e | 0) >>> 0 > b >>> 0)) {
                a = Vb() | 0;
                c[a >> 2] = 12;
                f = 0;
                return f | 0
            }
            if (b >>> 0 < 11 >>> 0) { g = 16 } else { g = b + 11 & -8 }
            b = Gu(e + 12 + g | 0) | 0;
            if ((b | 0) == 0) { f = 0; return f | 0 }
            a = b - 8 | 0;
            d = a;
            h = e - 1 | 0;
            do {
                if ((b & h | 0) == 0) { i = d } else {
                    j = b + h & -e;
                    k = j - 8 | 0;
                    l = a;
                    if ((k - l | 0) >>> 0 > 15 >>> 0) { m = k } else { m = j + (e - 8) | 0 }
                    j = m;
                    k = m - l | 0;
                    l = b - 4 | 0;
                    n = c[l >> 2] | 0;
                    o = (n & -8) - k | 0;
                    if ((n & 3 | 0) == 0) {
                        c[m >> 2] = (c[a >> 2] | 0) + k;
                        c[m + 4 >> 2] = o;
                        i = j;
                        break
                    } else {
                        n = m + 4 | 0;
                        c[n >> 2] = o | c[n >> 2] & 1 | 2;
                        n = m + (o + 4) | 0;
                        c[n >> 2] = c[n >> 2] | 1;
                        c[l >> 2] = k | c[l >> 2] & 1 | 2;
                        l = b + (k - 4) | 0;
                        c[l >> 2] = c[l >> 2] | 1;
                        Mu(d, k);
                        i = j;
                        break
                    }
                }
            } while (0);
            d = i + 4 | 0;
            b = c[d >> 2] | 0;
            do {
                if ((b & 3 | 0) != 0) {
                    m = b & -8;
                    if (!(m >>> 0 > (g + 16 | 0) >>> 0)) { break }
                    a = m - g | 0;
                    e = i;
                    c[d >> 2] = g | b & 1 | 2;
                    c[e + (g | 4) >> 2] = a | 3;
                    h = e + (m | 4) | 0;
                    c[h >> 2] = c[h >> 2] | 1;
                    Mu(e + g | 0, a)
                }
            } while (0);
            f = i + 8 | 0;
            return f | 0
        }

        function Mu(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                K = 0,
                L = 0;
            d = a;
            e = d + b | 0;
            f = e;
            g = c[a + 4 >> 2] | 0;
            a: do {
                if ((g & 1 | 0) == 0) {
                    h = c[a >> 2] | 0;
                    if ((g & 3 | 0) == 0) { return }
                    i = d + (-h | 0) | 0;
                    j = i;
                    k = h + b | 0;
                    l = c[7836] | 0;
                    if (i >>> 0 < l >>> 0) { hc() }
                    if ((j | 0) == (c[7837] | 0)) {
                        m = d + (b + 4) | 0;
                        if ((c[m >> 2] & 3 | 0) != 3) {
                            n = j;
                            o = k;
                            break
                        }
                        c[7834] = k;
                        c[m >> 2] = c[m >> 2] & -2;
                        c[d + (4 - h) >> 2] = k | 1;
                        c[e >> 2] = k;
                        return
                    }
                    m = h >>> 3;
                    if (h >>> 0 < 256 >>> 0) {
                        p = c[d + (8 - h) >> 2] | 0;
                        q = c[d + (12 - h) >> 2] | 0;
                        r = 31368 + (m << 1 << 2) | 0;
                        do {
                            if ((p | 0) != (r | 0)) {
                                if (p >>> 0 < l >>> 0) { hc() }
                                if ((c[p + 12 >> 2] | 0) == (j | 0)) { break }
                                hc()
                            }
                        } while (0);
                        if ((q | 0) == (p | 0)) {
                            c[7832] = c[7832] & ~(1 << m);
                            n = j;
                            o = k;
                            break
                        }
                        do {
                            if ((q | 0) == (r | 0)) { s = q + 8 | 0 } else {
                                if (q >>> 0 < l >>> 0) { hc() }
                                t = q + 8 | 0;
                                if ((c[t >> 2] | 0) == (j | 0)) { s = t; break }
                                hc()
                            }
                        } while (0);
                        c[p + 12 >> 2] = q;
                        c[s >> 2] = p;
                        n = j;
                        o = k;
                        break
                    }
                    r = i;
                    m = c[d + (24 - h) >> 2] | 0;
                    t = c[d + (12 - h) >> 2] | 0;
                    do {
                        if ((t | 0) == (r | 0)) {
                            u = 16 - h | 0;
                            v = d + (u + 4) | 0;
                            w = c[v >> 2] | 0;
                            if ((w | 0) == 0) {
                                x = d + u | 0;
                                u = c[x >> 2] | 0;
                                if ((u | 0) == 0) { y = 0; break } else {
                                    z = u;
                                    A = x
                                }
                            } else {
                                z = w;
                                A = v
                            }
                            while (1) {
                                v = z + 20 | 0;
                                w = c[v >> 2] | 0;
                                if ((w | 0) != 0) {
                                    z = w;
                                    A = v;
                                    continue
                                }
                                v = z + 16 | 0;
                                w = c[v >> 2] | 0;
                                if ((w | 0) == 0) { break } else {
                                    z = w;
                                    A = v
                                }
                            }
                            if (A >>> 0 < l >>> 0) { hc() } else {
                                c[A >> 2] = 0;
                                y = z;
                                break
                            }
                        } else {
                            v = c[d + (8 - h) >> 2] | 0;
                            if (v >>> 0 < l >>> 0) { hc() }
                            w = v + 12 | 0;
                            if ((c[w >> 2] | 0) != (r | 0)) { hc() }
                            x = t + 8 | 0;
                            if ((c[x >> 2] | 0) == (r | 0)) {
                                c[w >> 2] = t;
                                c[x >> 2] = v;
                                y = t;
                                break
                            } else { hc() }
                        }
                    } while (0);
                    if ((m | 0) == 0) {
                        n = j;
                        o = k;
                        break
                    }
                    t = c[d + (28 - h) >> 2] | 0;
                    l = 31632 + (t << 2) | 0;
                    do {
                        if ((r | 0) == (c[l >> 2] | 0)) {
                            c[l >> 2] = y;
                            if ((y | 0) != 0) { break }
                            c[7833] = c[7833] & ~(1 << t);
                            n = j;
                            o = k;
                            break a
                        } else {
                            if (m >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                            i = m + 16 | 0;
                            if ((c[i >> 2] | 0) == (r | 0)) { c[i >> 2] = y } else { c[m + 20 >> 2] = y }
                            if ((y | 0) == 0) {
                                n = j;
                                o = k;
                                break a
                            }
                        }
                    } while (0);
                    if (y >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                    c[y + 24 >> 2] = m;
                    r = 16 - h | 0;
                    t = c[d + r >> 2] | 0;
                    do {
                        if ((t | 0) != 0) {
                            if (t >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                                c[y + 16 >> 2] = t;
                                c[t + 24 >> 2] = y;
                                break
                            }
                        }
                    } while (0);
                    t = c[d + (r + 4) >> 2] | 0;
                    if ((t | 0) == 0) {
                        n = j;
                        o = k;
                        break
                    }
                    if (t >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                        c[y + 20 >> 2] = t;
                        c[t + 24 >> 2] = y;
                        n = j;
                        o = k;
                        break
                    }
                } else {
                    n = a;
                    o = b
                }
            } while (0);
            a = c[7836] | 0;
            if (e >>> 0 < a >>> 0) { hc() }
            y = d + (b + 4) | 0;
            z = c[y >> 2] | 0;
            do {
                if ((z & 2 | 0) == 0) {
                    if ((f | 0) == (c[7838] | 0)) {
                        A = (c[7835] | 0) + o | 0;
                        c[7835] = A;
                        c[7838] = n;
                        c[n + 4 >> 2] = A | 1;
                        if ((n | 0) != (c[7837] | 0)) { return }
                        c[7837] = 0;
                        c[7834] = 0;
                        return
                    }
                    if ((f | 0) == (c[7837] | 0)) {
                        A = (c[7834] | 0) + o | 0;
                        c[7834] = A;
                        c[7837] = n;
                        c[n + 4 >> 2] = A | 1;
                        c[n + A >> 2] = A;
                        return
                    }
                    A = (z & -8) + o | 0;
                    s = z >>> 3;
                    b: do {
                        if (z >>> 0 < 256 >>> 0) {
                            g = c[d + (b + 8) >> 2] | 0;
                            t = c[d + (b + 12) >> 2] | 0;
                            h = 31368 + (s << 1 << 2) | 0;
                            do {
                                if ((g | 0) != (h | 0)) {
                                    if (g >>> 0 < a >>> 0) { hc() }
                                    if ((c[g + 12 >> 2] | 0) == (f | 0)) { break }
                                    hc()
                                }
                            } while (0);
                            if ((t | 0) == (g | 0)) { c[7832] = c[7832] & ~(1 << s); break }
                            do {
                                if ((t | 0) == (h | 0)) { B = t + 8 | 0 } else {
                                    if (t >>> 0 < a >>> 0) { hc() }
                                    m = t + 8 | 0;
                                    if ((c[m >> 2] | 0) == (f | 0)) { B = m; break }
                                    hc()
                                }
                            } while (0);
                            c[g + 12 >> 2] = t;
                            c[B >> 2] = g
                        } else {
                            h = e;
                            m = c[d + (b + 24) >> 2] | 0;
                            l = c[d + (b + 12) >> 2] | 0;
                            do {
                                if ((l | 0) == (h | 0)) {
                                    i = d + (b + 20) | 0;
                                    p = c[i >> 2] | 0;
                                    if ((p | 0) == 0) {
                                        q = d + (b + 16) | 0;
                                        v = c[q >> 2] | 0;
                                        if ((v | 0) == 0) { C = 0; break } else {
                                            D = v;
                                            E = q
                                        }
                                    } else {
                                        D = p;
                                        E = i
                                    }
                                    while (1) {
                                        i = D + 20 | 0;
                                        p = c[i >> 2] | 0;
                                        if ((p | 0) != 0) {
                                            D = p;
                                            E = i;
                                            continue
                                        }
                                        i = D + 16 | 0;
                                        p = c[i >> 2] | 0;
                                        if ((p | 0) == 0) { break } else {
                                            D = p;
                                            E = i
                                        }
                                    }
                                    if (E >>> 0 < a >>> 0) { hc() } else {
                                        c[E >> 2] = 0;
                                        C = D;
                                        break
                                    }
                                } else {
                                    i = c[d + (b + 8) >> 2] | 0;
                                    if (i >>> 0 < a >>> 0) { hc() }
                                    p = i + 12 | 0;
                                    if ((c[p >> 2] | 0) != (h | 0)) { hc() }
                                    q = l + 8 | 0;
                                    if ((c[q >> 2] | 0) == (h | 0)) {
                                        c[p >> 2] = l;
                                        c[q >> 2] = i;
                                        C = l;
                                        break
                                    } else { hc() }
                                }
                            } while (0);
                            if ((m | 0) == 0) { break }
                            l = c[d + (b + 28) >> 2] | 0;
                            g = 31632 + (l << 2) | 0;
                            do {
                                if ((h | 0) == (c[g >> 2] | 0)) {
                                    c[g >> 2] = C;
                                    if ((C | 0) != 0) { break }
                                    c[7833] = c[7833] & ~(1 << l);
                                    break b
                                } else {
                                    if (m >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                                    t = m + 16 | 0;
                                    if ((c[t >> 2] | 0) == (h | 0)) { c[t >> 2] = C } else { c[m + 20 >> 2] = C }
                                    if ((C | 0) == 0) { break b }
                                }
                            } while (0);
                            if (C >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                            c[C + 24 >> 2] = m;
                            h = c[d + (b + 16) >> 2] | 0;
                            do {
                                if ((h | 0) != 0) {
                                    if (h >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                                        c[C + 16 >> 2] = h;
                                        c[h + 24 >> 2] = C;
                                        break
                                    }
                                }
                            } while (0);
                            h = c[d + (b + 20) >> 2] | 0;
                            if ((h | 0) == 0) { break }
                            if (h >>> 0 < (c[7836] | 0) >>> 0) { hc() } else {
                                c[C + 20 >> 2] = h;
                                c[h + 24 >> 2] = C;
                                break
                            }
                        }
                    } while (0);
                    c[n + 4 >> 2] = A | 1;
                    c[n + A >> 2] = A;
                    if ((n | 0) != (c[7837] | 0)) { F = A; break }
                    c[7834] = A;
                    return
                } else {
                    c[y >> 2] = z & -2;
                    c[n + 4 >> 2] = o | 1;
                    c[n + o >> 2] = o;
                    F = o
                }
            } while (0);
            o = F >>> 3;
            if (F >>> 0 < 256 >>> 0) {
                z = o << 1;
                y = 31368 + (z << 2) | 0;
                C = c[7832] | 0;
                b = 1 << o;
                do {
                    if ((C & b | 0) == 0) {
                        c[7832] = C | b;
                        G = y;
                        H = 31368 + (z + 2 << 2) | 0
                    } else {
                        o = 31368 + (z + 2 << 2) | 0;
                        d = c[o >> 2] | 0;
                        if (!(d >>> 0 < (c[7836] | 0) >>> 0)) {
                            G = d;
                            H = o;
                            break
                        }
                        hc()
                    }
                } while (0);
                c[H >> 2] = n;
                c[G + 12 >> 2] = n;
                c[n + 8 >> 2] = G;
                c[n + 12 >> 2] = y;
                return
            }
            y = n;
            G = F >>> 8;
            do {
                if ((G | 0) == 0) { I = 0 } else {
                    if (F >>> 0 > 16777215 >>> 0) { I = 31; break }
                    H = (G + 1048320 | 0) >>> 16 & 8;
                    z = G << H;
                    b = (z + 520192 | 0) >>> 16 & 4;
                    C = z << b;
                    z = (C + 245760 | 0) >>> 16 & 2;
                    o = 14 - (b | H | z) + (C << z >>> 15) | 0;
                    I = F >>> ((o + 7 | 0) >>> 0) & 1 | o << 1
                }
            } while (0);
            G = 31632 + (I << 2) | 0;
            c[n + 28 >> 2] = I;
            c[n + 20 >> 2] = 0;
            c[n + 16 >> 2] = 0;
            o = c[7833] | 0;
            z = 1 << I;
            if ((o & z | 0) == 0) {
                c[7833] = o | z;
                c[G >> 2] = y;
                c[n + 24 >> 2] = G;
                c[n + 12 >> 2] = n;
                c[n + 8 >> 2] = n;
                return
            }
            z = c[G >> 2] | 0;
            if ((I | 0) == 31) { J = 0 } else { J = 25 - (I >>> 1) | 0 }
            c: do {
                if ((c[z + 4 >> 2] & -8 | 0) == (F | 0)) { K = z } else {
                    I = z;
                    G = F << J;
                    while (1) {
                        L = I + 16 + (G >>> 31 << 2) | 0;
                        o = c[L >> 2] | 0;
                        if ((o | 0) == 0) { break }
                        if ((c[o + 4 >> 2] & -8 | 0) == (F | 0)) { K = o; break c } else {
                            I = o;
                            G = G << 1
                        }
                    }
                    if (L >>> 0 < (c[7836] | 0) >>> 0) { hc() }
                    c[L >> 2] = y;
                    c[n + 24 >> 2] = I;
                    c[n + 12 >> 2] = n;
                    c[n + 8 >> 2] = n;
                    return
                }
            } while (0);
            L = K + 8 | 0;
            F = c[L >> 2] | 0;
            J = c[7836] | 0;
            if (K >>> 0 < J >>> 0) { hc() }
            if (F >>> 0 < J >>> 0) { hc() }
            c[F + 12 >> 2] = y;
            c[L >> 2] = y;
            c[n + 8 >> 2] = F;
            c[n + 12 >> 2] = K;
            c[n + 24 >> 2] = 0;
            return
        }

        function Nu(a) {
            a = a | 0;
            var b = 0,
                d = 0,
                e = 0;
            b = (a | 0) == 0 ? 1 : a;
            while (1) {
                d = Gu(b) | 0;
                if ((d | 0) != 0) { e = 10; break }
                a = (I = c[10888] | 0, c[10888] = I + 0, I);
                if ((a | 0) == 0) { break }
                Uc[a & 3]()
            }
            if ((e | 0) == 10) { return d | 0 }
            d = pc(4) | 0;
            c[d >> 2] = 19472;
            Fb(d | 0, 25528, 174);
            return 0
        }

        function Ou(a) { a = a | 0; return Nu(a) | 0 }

        function Pu(a) {
            a = a | 0;
            if ((a | 0) == 0) { return }
            Hu(a);
            return
        }

        function Qu(a) {
            a = a | 0;
            Pu(a);
            return
        }

        function Ru(a) {
            a = a | 0;
            Pu(a);
            return
        }

        function Su(a) { a = a | 0; return }

        function Tu(a) { a = a | 0; return 9160 }

        function Uu() {
            var a = 0;
            a = pc(4) | 0;
            c[a >> 2] = 19472;
            Fb(a | 0, 25528, 174)
        }

        function Vu(b, e, f) {
            b = b | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0.0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0,
                N = 0,
                O = 0.0,
                P = 0.0,
                Q = 0,
                R = 0,
                S = 0,
                T = 0,
                U = 0,
                W = 0,
                X = 0,
                Y = 0,
                Z = 0,
                _ = 0,
                $ = 0,
                aa = 0,
                ba = 0,
                ca = 0,
                da = 0.0,
                ea = 0.0,
                fa = 0,
                ha = 0,
                ia = 0.0,
                ja = 0.0,
                ka = 0,
                la = 0.0,
                ma = 0,
                na = 0,
                oa = 0,
                pa = 0,
                qa = 0,
                ra = 0,
                sa = 0,
                ta = 0,
                ua = 0.0,
                va = 0,
                wa = 0.0,
                xa = 0,
                ya = 0.0,
                za = 0,
                Aa = 0,
                Ba = 0,
                Ca = 0.0,
                Da = 0,
                Ea = 0.0,
                Fa = 0.0,
                Ga = 0,
                Ha = 0,
                Ia = 0,
                Ja = 0,
                Ka = 0,
                La = 0,
                Ma = 0,
                Na = 0,
                Oa = 0,
                Pa = 0,
                Qa = 0,
                Ra = 0,
                Ta = 0,
                Ua = 0,
                Va = 0,
                Wa = 0,
                Xa = 0,
                Ya = 0,
                Za = 0,
                _a = 0,
                ab = 0,
                bb = 0,
                cb = 0,
                db = 0,
                eb = 0,
                fb = 0,
                gb = 0,
                hb = 0,
                ib = 0,
                jb = 0,
                kb = 0,
                lb = 0,
                mb = 0,
                nb = 0,
                ob = 0,
                pb = 0,
                qb = 0,
                rb = 0,
                sb = 0,
                tb = 0,
                ub = 0,
                vb = 0,
                wb = 0,
                xb = 0,
                yb = 0,
                zb = 0,
                Ab = 0,
                Bb = 0,
                Db = 0,
                Eb = 0,
                Fb = 0,
                Gb = 0,
                Hb = 0,
                Ib = 0,
                Jb = 0,
                Kb = 0,
                Lb = 0,
                Mb = 0,
                Nb = 0,
                Ob = 0,
                Pb = 0,
                Qb = 0,
                Rb = 0,
                Sb = 0,
                Tb = 0,
                Ub = 0,
                Wb = 0,
                Xb = 0,
                Yb = 0,
                Zb = 0,
                _b = 0,
                $b = 0,
                ac = 0,
                bc = 0,
                cc = 0,
                dc = 0,
                ec = 0,
                fc = 0,
                gc = 0,
                hc = 0,
                ic = 0,
                jc = 0,
                kc = 0,
                lc = 0,
                mc = 0,
                nc = 0,
                oc = 0,
                pc = 0,
                qc = 0,
                rc = 0,
                sc = 0,
                tc = 0,
                uc = 0,
                vc = 0,
                wc = 0.0,
                xc = 0,
                yc = 0,
                zc = 0.0,
                Ac = 0.0,
                Bc = 0.0,
                Cc = 0.0,
                Dc = 0.0,
                Ec = 0.0,
                Fc = 0.0,
                Gc = 0,
                Hc = 0,
                Ic = 0.0,
                Jc = 0,
                Kc = 0,
                Lc = 0,
                Mc = 0,
                Nc = 0,
                Oc = 0;
            g = i;
            i = i + 512 | 0;
            h = g | 0;
            if ((e | 0) == 1) {
                j = -1074;
                k = 53
            } else if ((e | 0) == 0) {
                j = -149;
                k = 24
            } else if ((e | 0) == 2) {
                j = -1074;
                k = 53
            } else {
                l = 0.0;
                i = g;
                return +l
            }
            e = b + 4 | 0;
            m = b + 100 | 0;
            do {
                n = c[e >> 2] | 0;
                if (n >>> 0 < (c[m >> 2] | 0) >>> 0) {
                    c[e >> 2] = n + 1;
                    o = d[n] | 0
                } else { o = Yu(b) | 0 }
            } while ((Sa(o | 0) | 0) != 0);
            do {
                if ((o | 0) == 45 | (o | 0) == 43) {
                    n = 1 - (((o | 0) == 45) << 1) | 0;
                    p = c[e >> 2] | 0;
                    if (p >>> 0 < (c[m >> 2] | 0) >>> 0) {
                        c[e >> 2] = p + 1;
                        q = d[p] | 0;
                        r = n;
                        break
                    } else {
                        q = Yu(b) | 0;
                        r = n;
                        break
                    }
                } else {
                    q = o;
                    r = 1
                }
            } while (0);
            o = 0;
            n = q;
            while (1) {
                if ((n | 32 | 0) != (a[3344 + o | 0] | 0)) {
                    s = o;
                    t = n;
                    break
                }
                do {
                    if (o >>> 0 < 7 >>> 0) {
                        q = c[e >> 2] | 0;
                        if (q >>> 0 < (c[m >> 2] | 0) >>> 0) {
                            c[e >> 2] = q + 1;
                            u = d[q] | 0;
                            break
                        } else { u = Yu(b) | 0; break }
                    } else { u = n }
                } while (0);
                q = o + 1 | 0;
                if (q >>> 0 < 8 >>> 0) {
                    o = q;
                    n = u
                } else {
                    s = q;
                    t = u;
                    break
                }
            }
            do {
                if ((s | 0) == 3) { x = 23 } else if ((s | 0) != 8) {
                    u = (f | 0) == 0;
                    if (!(s >>> 0 < 4 >>> 0 | u)) { if ((s | 0) == 8) { break } else { x = 23; break } }
                    a: do {
                        if ((s | 0) == 0) {
                            n = 0;
                            o = t;
                            while (1) {
                                if ((o | 32 | 0) != (a[14392 + n | 0] | 0)) {
                                    y = o;
                                    z = n;
                                    break a
                                }
                                do {
                                    if (n >>> 0 < 2 >>> 0) {
                                        q = c[e >> 2] | 0;
                                        if (q >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                            c[e >> 2] = q + 1;
                                            A = d[q] | 0;
                                            break
                                        } else { A = Yu(b) | 0; break }
                                    } else { A = o }
                                } while (0);
                                q = n + 1 | 0;
                                if (q >>> 0 < 3 >>> 0) {
                                    n = q;
                                    o = A
                                } else {
                                    y = A;
                                    z = q;
                                    break
                                }
                            }
                        } else {
                            y = t;
                            z = s
                        }
                    } while (0);
                    if ((z | 0) == 0) {
                        do {
                            if ((y | 0) == 48) {
                                o = c[e >> 2] | 0;
                                if (o >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                    c[e >> 2] = o + 1;
                                    B = d[o] | 0
                                } else { B = Yu(b) | 0 }
                                if ((B | 32 | 0) != 120) {
                                    if ((c[m >> 2] | 0) == 0) { C = 48; break }
                                    c[e >> 2] = (c[e >> 2] | 0) - 1;
                                    C = 48;
                                    break
                                }
                                o = c[e >> 2] | 0;
                                if (o >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                    c[e >> 2] = o + 1;
                                    D = d[o] | 0;
                                    E = 0
                                } else {
                                    D = Yu(b) | 0;
                                    E = 0
                                }
                                while (1) {
                                    if ((D | 0) == 46) { x = 70; break } else if ((D | 0) != 48) {
                                        F = D;
                                        G = 0;
                                        H = 0;
                                        I = 0;
                                        J = 0;
                                        L = E;
                                        M = 0;
                                        N = 0;
                                        O = 1.0;
                                        P = 0.0;
                                        Q = 0;
                                        break
                                    }
                                    o = c[e >> 2] | 0;
                                    if (o >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                        c[e >> 2] = o + 1;
                                        D = d[o] | 0;
                                        E = 1;
                                        continue
                                    } else {
                                        D = Yu(b) | 0;
                                        E = 1;
                                        continue
                                    }
                                }
                                b: do {
                                    if ((x | 0) == 70) {
                                        o = c[e >> 2] | 0;
                                        if (o >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                            c[e >> 2] = o + 1;
                                            R = d[o] | 0
                                        } else { R = Yu(b) | 0 }
                                        if ((R | 0) == 48) {
                                            S = -1;
                                            T = -1
                                        } else {
                                            F = R;
                                            G = 0;
                                            H = 0;
                                            I = 0;
                                            J = 0;
                                            L = E;
                                            M = 1;
                                            N = 0;
                                            O = 1.0;
                                            P = 0.0;
                                            Q = 0;
                                            break
                                        }
                                        while (1) {
                                            o = c[e >> 2] | 0;
                                            if (o >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                                c[e >> 2] = o + 1;
                                                U = d[o] | 0
                                            } else { U = Yu(b) | 0 }
                                            if ((U | 0) != 48) {
                                                F = U;
                                                G = 0;
                                                H = 0;
                                                I = S;
                                                J = T;
                                                L = 1;
                                                M = 1;
                                                N = 0;
                                                O = 1.0;
                                                P = 0.0;
                                                Q = 0;
                                                break b
                                            }
                                            o = hv(T, S, -1, -1) | 0;
                                            S = K;
                                            T = o
                                        }
                                    }
                                } while (0);
                                c: while (1) {
                                    o = F - 48 | 0;
                                    do {
                                        if (o >>> 0 < 10 >>> 0) {
                                            W = o;
                                            x = 84
                                        } else {
                                            n = F | 32;
                                            q = (F | 0) == 46;
                                            if (!((n - 97 | 0) >>> 0 < 6 >>> 0 | q)) { X = F; break c }
                                            if (q) {
                                                if ((M | 0) == 0) {
                                                    Y = G;
                                                    Z = H;
                                                    _ = G;
                                                    $ = H;
                                                    aa = L;
                                                    ba = 1;
                                                    ca = N;
                                                    da = O;
                                                    ea = P;
                                                    fa = Q;
                                                    break
                                                } else { X = 46; break c }
                                            } else {
                                                W = (F | 0) > 57 ? n - 87 | 0 : o;
                                                x = 84;
                                                break
                                            }
                                        }
                                    } while (0);
                                    if ((x | 0) == 84) {
                                        x = 0;
                                        o = 0;
                                        do {
                                            if ((G | 0) < (o | 0) | (G | 0) == (o | 0) & H >>> 0 < 8 >>> 0) {
                                                ha = N;
                                                ia = O;
                                                ja = P;
                                                ka = W + (Q << 4) | 0
                                            } else {
                                                n = 0;
                                                if ((G | 0) < (n | 0) | (G | 0) == (n | 0) & H >>> 0 < 14 >>> 0) {
                                                    la = O * .0625;
                                                    ha = N;
                                                    ia = la;
                                                    ja = P + la * +(W | 0);
                                                    ka = Q;
                                                    break
                                                }
                                                if (!((W | 0) != 0 & (N | 0) == 0)) {
                                                    ha = N;
                                                    ia = O;
                                                    ja = P;
                                                    ka = Q;
                                                    break
                                                }
                                                ha = 1;
                                                ia = O;
                                                ja = P + O * .5;
                                                ka = Q
                                            }
                                        } while (0);
                                        o = hv(H, G, 1, 0) | 0;
                                        Y = K;
                                        Z = o;
                                        _ = I;
                                        $ = J;
                                        aa = 1;
                                        ba = M;
                                        ca = ha;
                                        da = ia;
                                        ea = ja;
                                        fa = ka
                                    }
                                    o = c[e >> 2] | 0;
                                    if (o >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                        c[e >> 2] = o + 1;
                                        F = d[o] | 0;
                                        G = Y;
                                        H = Z;
                                        I = _;
                                        J = $;
                                        L = aa;
                                        M = ba;
                                        N = ca;
                                        O = da;
                                        P = ea;
                                        Q = fa;
                                        continue
                                    } else {
                                        F = Yu(b) | 0;
                                        G = Y;
                                        H = Z;
                                        I = _;
                                        J = $;
                                        L = aa;
                                        M = ba;
                                        N = ca;
                                        O = da;
                                        P = ea;
                                        Q = fa;
                                        continue
                                    }
                                }
                                if ((L | 0) == 0) {
                                    o = (c[m >> 2] | 0) == 0;
                                    if (!o) { c[e >> 2] = (c[e >> 2] | 0) - 1 }
                                    do {
                                        if (u) { Xu(b, 0) } else {
                                            if (o) { break }
                                            n = c[e >> 2] | 0;
                                            c[e >> 2] = n - 1;
                                            if ((M | 0) == 0) { break }
                                            c[e >> 2] = n - 2
                                        }
                                    } while (0);
                                    l = +(r | 0) * 0.0;
                                    i = g;
                                    return +l
                                }
                                o = (M | 0) == 0;
                                n = o ? H : J;
                                q = o ? G : I;
                                o = 0;
                                if ((G | 0) < (o | 0) | (G | 0) == (o | 0) & H >>> 0 < 8 >>> 0) {
                                    o = Q;
                                    p = G;
                                    ma = H;
                                    while (1) {
                                        na = o << 4;
                                        oa = hv(ma, p, 1, 0) | 0;
                                        pa = K;
                                        qa = 0;
                                        if ((pa | 0) < (qa | 0) | (pa | 0) == (qa | 0) & oa >>> 0 < 8 >>> 0) {
                                            o = na;
                                            p = pa;
                                            ma = oa
                                        } else { ra = na; break }
                                    }
                                } else { ra = Q }
                                do {
                                    if ((X | 32 | 0) == 112) {
                                        ma = Wu(b, f) | 0;
                                        p = K;
                                        if (!((ma | 0) == 0 & (p | 0) == (-2147483648 | 0))) {
                                            sa = p;
                                            ta = ma;
                                            break
                                        }
                                        if (u) {
                                            Xu(b, 0);
                                            l = 0.0;
                                            i = g;
                                            return +l
                                        } else {
                                            if ((c[m >> 2] | 0) == 0) {
                                                sa = 0;
                                                ta = 0;
                                                break
                                            }
                                            c[e >> 2] = (c[e >> 2] | 0) - 1;
                                            sa = 0;
                                            ta = 0;
                                            break
                                        }
                                    } else {
                                        if ((c[m >> 2] | 0) == 0) {
                                            sa = 0;
                                            ta = 0;
                                            break
                                        }
                                        c[e >> 2] = (c[e >> 2] | 0) - 1;
                                        sa = 0;
                                        ta = 0
                                    }
                                } while (0);
                                ma = hv(n << 2 | 0 >>> 30, q << 2 | n >>> 30, -32, -1) | 0;
                                p = hv(ma, K, ta, sa) | 0;
                                ma = K;
                                if ((ra | 0) == 0) {
                                    l = +(r | 0) * 0.0;
                                    i = g;
                                    return +l
                                }
                                o = 0;
                                if ((ma | 0) > (o | 0) | (ma | 0) == (o | 0) & p >>> 0 > (-j | 0) >>> 0) {
                                    o = Vb() | 0;
                                    c[o >> 2] = 34;
                                    l = +(r | 0) * 1.7976931348623157e+308 * 1.7976931348623157e+308;
                                    i = g;
                                    return +l
                                }
                                o = j - 106 | 0;
                                na = (o | 0) < 0 | 0 ? -1 : 0;
                                if ((ma | 0) < (na | 0) | (ma | 0) == (na | 0) & p >>> 0 < o >>> 0) {
                                    o = Vb() | 0;
                                    c[o >> 2] = 34;
                                    l = +(r | 0) * 2.2250738585072014e-308 * 2.2250738585072014e-308;
                                    i = g;
                                    return +l
                                }
                                if ((ra | 0) > -1) {
                                    o = ra;
                                    la = P;
                                    na = ma;
                                    oa = p;
                                    while (1) {
                                        pa = o << 1;
                                        if (la < .5) {
                                            ua = la;
                                            va = pa
                                        } else {
                                            ua = la + -1.0;
                                            va = pa | 1
                                        }
                                        wa = la + ua;
                                        pa = hv(oa, na, -1, -1) | 0;
                                        qa = K;
                                        if ((va | 0) > -1) {
                                            o = va;
                                            la = wa;
                                            na = qa;
                                            oa = pa
                                        } else {
                                            xa = va;
                                            ya = wa;
                                            za = qa;
                                            Aa = pa;
                                            break
                                        }
                                    }
                                } else {
                                    xa = ra;
                                    ya = P;
                                    za = ma;
                                    Aa = p
                                }
                                oa = 0;
                                na = iv(32, 0, j, (j | 0) < 0 | 0 ? -1 : 0) | 0;
                                o = hv(Aa, za, na, K) | 0;
                                na = K;
                                if ((oa | 0) > (na | 0) | (oa | 0) == (na | 0) & k >>> 0 > o >>> 0) {
                                    na = o;
                                    Ba = (na | 0) < 0 ? 0 : na
                                } else { Ba = k }
                                do {
                                    if ((Ba | 0) < 53) {
                                        la = +(r | 0);
                                        wa = +Cb(+(+Zu(1.0, 84 - Ba | 0)), +la);
                                        if (!((Ba | 0) < 32 & ya != 0.0)) {
                                            Ca = ya;
                                            Da = xa;
                                            Ea = wa;
                                            Fa = la;
                                            break
                                        }
                                        na = xa & 1;
                                        Ca = (na | 0) == 0 ? 0.0 : ya;
                                        Da = (na ^ 1) + xa | 0;
                                        Ea = wa;
                                        Fa = la
                                    } else {
                                        Ca = ya;
                                        Da = xa;
                                        Ea = 0.0;
                                        Fa = +(r | 0)
                                    }
                                } while (0);
                                la = Fa * Ca + (Ea + Fa * +(Da >>> 0 >>> 0)) - Ea;
                                if (!(la != 0.0)) {
                                    p = Vb() | 0;
                                    c[p >> 2] = 34
                                }
                                l = +_u(la, Aa);
                                i = g;
                                return +l
                            } else { C = y }
                        } while (0);
                        p = j + k | 0;
                        ma = -p | 0;
                        na = C;
                        o = 0;
                        while (1) {
                            if ((na | 0) == 46) { x = 139; break } else if ((na | 0) != 48) {
                                Ga = na;
                                Ha = 0;
                                Ia = o;
                                Ja = 0;
                                Ka = 0;
                                break
                            }
                            oa = c[e >> 2] | 0;
                            if (oa >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                c[e >> 2] = oa + 1;
                                na = d[oa] | 0;
                                o = 1;
                                continue
                            } else {
                                na = Yu(b) | 0;
                                o = 1;
                                continue
                            }
                        }
                        d: do {
                            if ((x | 0) == 139) {
                                na = c[e >> 2] | 0;
                                if (na >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                    c[e >> 2] = na + 1;
                                    La = d[na] | 0
                                } else { La = Yu(b) | 0 }
                                if ((La | 0) == 48) {
                                    Ma = -1;
                                    Na = -1
                                } else {
                                    Ga = La;
                                    Ha = 1;
                                    Ia = o;
                                    Ja = 0;
                                    Ka = 0;
                                    break
                                }
                                while (1) {
                                    na = c[e >> 2] | 0;
                                    if (na >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                        c[e >> 2] = na + 1;
                                        Oa = d[na] | 0
                                    } else { Oa = Yu(b) | 0 }
                                    if ((Oa | 0) != 48) {
                                        Ga = Oa;
                                        Ha = 1;
                                        Ia = 1;
                                        Ja = Ma;
                                        Ka = Na;
                                        break d
                                    }
                                    na = hv(Na, Ma, -1, -1) | 0;
                                    Ma = K;
                                    Na = na
                                }
                            }
                        } while (0);
                        o = h | 0;
                        c[o >> 2] = 0;
                        na = Ga - 48 | 0;
                        oa = (Ga | 0) == 46;
                        e: do {
                            if (na >>> 0 < 10 >>> 0 | oa) {
                                n = h + 496 | 0;
                                q = Ja;
                                pa = Ka;
                                qa = 0;
                                Pa = 0;
                                Qa = 0;
                                Ra = Ia;
                                Ta = Ha;
                                Ua = 0;
                                Va = 0;
                                Wa = Ga;
                                Xa = na;
                                Ya = oa;
                                while (1) {
                                    do {
                                        if (Ya) {
                                            if ((Ta | 0) == 0) {
                                                Za = Va;
                                                _a = Ua;
                                                ab = 1;
                                                bb = Ra;
                                                cb = Qa;
                                                db = qa;
                                                eb = Pa;
                                                fb = qa;
                                                gb = Pa
                                            } else {
                                                hb = q;
                                                ib = pa;
                                                jb = qa;
                                                kb = Pa;
                                                lb = Qa;
                                                mb = Ra;
                                                nb = Ua;
                                                ob = Va;
                                                pb = Wa;
                                                break e
                                            }
                                        } else {
                                            qb = hv(Pa, qa, 1, 0) | 0;
                                            rb = K;
                                            sb = (Wa | 0) != 48;
                                            if ((Ua | 0) >= 125) {
                                                if (!sb) {
                                                    Za = Va;
                                                    _a = Ua;
                                                    ab = Ta;
                                                    bb = Ra;
                                                    cb = Qa;
                                                    db = rb;
                                                    eb = qb;
                                                    fb = q;
                                                    gb = pa;
                                                    break
                                                }
                                                c[n >> 2] = c[n >> 2] | 1;
                                                Za = Va;
                                                _a = Ua;
                                                ab = Ta;
                                                bb = Ra;
                                                cb = Qa;
                                                db = rb;
                                                eb = qb;
                                                fb = q;
                                                gb = pa;
                                                break
                                            }
                                            tb = h + (Ua << 2) | 0;
                                            if ((Va | 0) == 0) { ub = Xa } else { ub = Wa - 48 + ((c[tb >> 2] | 0) * 10 | 0) | 0 }
                                            c[tb >> 2] = ub;
                                            tb = Va + 1 | 0;
                                            vb = (tb | 0) == 9;
                                            Za = vb ? 0 : tb;
                                            _a = (vb & 1) + Ua | 0;
                                            ab = Ta;
                                            bb = 1;
                                            cb = sb ? qb : Qa;
                                            db = rb;
                                            eb = qb;
                                            fb = q;
                                            gb = pa
                                        }
                                    } while (0);
                                    qb = c[e >> 2] | 0;
                                    if (qb >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                        c[e >> 2] = qb + 1;
                                        wb = d[qb] | 0
                                    } else { wb = Yu(b) | 0 }
                                    qb = wb - 48 | 0;
                                    rb = (wb | 0) == 46;
                                    if (qb >>> 0 < 10 >>> 0 | rb) {
                                        q = fb;
                                        pa = gb;
                                        qa = db;
                                        Pa = eb;
                                        Qa = cb;
                                        Ra = bb;
                                        Ta = ab;
                                        Ua = _a;
                                        Va = Za;
                                        Wa = wb;
                                        Xa = qb;
                                        Ya = rb
                                    } else {
                                        xb = fb;
                                        yb = gb;
                                        zb = db;
                                        Ab = eb;
                                        Bb = cb;
                                        Db = bb;
                                        Eb = ab;
                                        Fb = _a;
                                        Gb = Za;
                                        Hb = wb;
                                        x = 162;
                                        break
                                    }
                                }
                            } else {
                                xb = Ja;
                                yb = Ka;
                                zb = 0;
                                Ab = 0;
                                Bb = 0;
                                Db = Ia;
                                Eb = Ha;
                                Fb = 0;
                                Gb = 0;
                                Hb = Ga;
                                x = 162
                            }
                        } while (0);
                        if ((x | 0) == 162) {
                            oa = (Eb | 0) == 0;
                            hb = oa ? zb : xb;
                            ib = oa ? Ab : yb;
                            jb = zb;
                            kb = Ab;
                            lb = Bb;
                            mb = Db;
                            nb = Fb;
                            ob = Gb;
                            pb = Hb
                        }
                        oa = (mb | 0) != 0;
                        do {
                            if (oa) {
                                if ((pb | 32 | 0) != 101) { x = 171; break }
                                na = Wu(b, f) | 0;
                                Ya = K;
                                do {
                                    if ((na | 0) == 0 & (Ya | 0) == (-2147483648 | 0)) {
                                        if (u) {
                                            Xu(b, 0);
                                            l = 0.0;
                                            i = g;
                                            return +l
                                        } else {
                                            if ((c[m >> 2] | 0) == 0) {
                                                Ib = 0;
                                                Jb = 0;
                                                break
                                            }
                                            c[e >> 2] = (c[e >> 2] | 0) - 1;
                                            Ib = 0;
                                            Jb = 0;
                                            break
                                        }
                                    } else {
                                        Ib = Ya;
                                        Jb = na
                                    }
                                } while (0);
                                na = hv(Jb, Ib, ib, hb) | 0;
                                Kb = K;
                                Lb = na
                            } else { x = 171 }
                        } while (0);
                        do {
                            if ((x | 0) == 171) {
                                if (!((pb | 0) > -1)) {
                                    Kb = hb;
                                    Lb = ib;
                                    break
                                }
                                if ((c[m >> 2] | 0) == 0) {
                                    Kb = hb;
                                    Lb = ib;
                                    break
                                }
                                c[e >> 2] = (c[e >> 2] | 0) - 1;
                                Kb = hb;
                                Lb = ib
                            }
                        } while (0);
                        if (!oa) {
                            na = Vb() | 0;
                            c[na >> 2] = 22;
                            Xu(b, 0);
                            l = 0.0;
                            i = g;
                            return +l
                        }
                        na = c[o >> 2] | 0;
                        if ((na | 0) == 0) {
                            l = +(r | 0) * 0.0;
                            i = g;
                            return +l
                        }
                        Ya = 0;
                        do {
                            if ((Lb | 0) == (kb | 0) & (Kb | 0) == (jb | 0) & ((jb | 0) < (Ya | 0) | (jb | 0) == (Ya | 0) & kb >>> 0 < 10 >>> 0)) {
                                if (!(k >>> 0 > 30 >>> 0)) { if ((na >>> (k >>> 0) | 0) != 0) { break } }
                                l = +(r | 0) * +(na >>> 0 >>> 0);
                                i = g;
                                return +l
                            }
                        } while (0);
                        na = (j | 0) / -2 | 0;
                        Ya = (na | 0) < 0 | 0 ? -1 : 0;
                        if ((Kb | 0) > (Ya | 0) | (Kb | 0) == (Ya | 0) & Lb >>> 0 > na >>> 0) {
                            na = Vb() | 0;
                            c[na >> 2] = 34;
                            l = +(r | 0) * 1.7976931348623157e+308 * 1.7976931348623157e+308;
                            i = g;
                            return +l
                        }
                        na = j - 106 | 0;
                        Ya = (na | 0) < 0 | 0 ? -1 : 0;
                        if ((Kb | 0) < (Ya | 0) | (Kb | 0) == (Ya | 0) & Lb >>> 0 < na >>> 0) {
                            na = Vb() | 0;
                            c[na >> 2] = 34;
                            l = +(r | 0) * 2.2250738585072014e-308 * 2.2250738585072014e-308;
                            i = g;
                            return +l
                        }
                        if ((ob | 0) == 0) { Mb = nb } else {
                            if ((ob | 0) < 9) {
                                na = h + (nb << 2) | 0;
                                Ya = ob;
                                oa = c[na >> 2] | 0;
                                do {
                                    oa = oa * 10 | 0;
                                    Ya = Ya + 1 | 0;
                                } while ((Ya | 0) < 9);
                                c[na >> 2] = oa
                            }
                            Mb = nb + 1 | 0
                        }
                        Ya = Lb;
                        do {
                            if ((lb | 0) < 9) {
                                if (!((lb | 0) <= (Ya | 0) & (Ya | 0) < 18)) { break }
                                if ((Ya | 0) == 9) {
                                    l = +(r | 0) * +((c[o >> 2] | 0) >>> 0 >>> 0);
                                    i = g;
                                    return +l
                                }
                                if ((Ya | 0) < 9) {
                                    l = +(r | 0) * +((c[o >> 2] | 0) >>> 0 >>> 0) / +(c[216 + (8 - Ya << 2) >> 2] | 0);
                                    i = g;
                                    return +l
                                }
                                Xa = k + 27 + (Ya * -3 | 0) | 0;
                                Wa = c[o >> 2] | 0;
                                if ((Xa | 0) <= 30) { if ((Wa >>> (Xa >>> 0) | 0) != 0) { break } }
                                l = +(r | 0) * +(Wa >>> 0 >>> 0) * +(c[216 + (Ya - 10 << 2) >> 2] | 0);
                                i = g;
                                return +l
                            }
                        } while (0);
                        o = (Ya | 0) % 9 | 0;
                        if ((o | 0) == 0) {
                            Nb = 0;
                            Ob = Mb;
                            Pb = 0;
                            Qb = Ya
                        } else {
                            oa = (Ya | 0) > -1 ? o : o + 9 | 0;
                            o = c[216 + (8 - oa << 2) >> 2] | 0;
                            do {
                                if ((Mb | 0) == 0) {
                                    Rb = 0;
                                    Sb = 0;
                                    Tb = Ya
                                } else {
                                    na = 1e9 / (o | 0) | 0;
                                    Wa = Ya;
                                    Xa = 0;
                                    Va = 0;
                                    Ua = 0;
                                    while (1) {
                                        Ta = h + (Va << 2) | 0;
                                        Ra = c[Ta >> 2] | 0;
                                        Qa = ((Ra >>> 0) / (o >>> 0) | 0) + Ua | 0;
                                        c[Ta >> 2] = Qa;
                                        Ub = ga((Ra >>> 0) % (o >>> 0) | 0, na) | 0;
                                        Ra = Va + 1 | 0;
                                        if ((Va | 0) == (Xa | 0) & (Qa | 0) == 0) {
                                            Wb = Ra & 127;
                                            Xb = Wa - 9 | 0
                                        } else {
                                            Wb = Xa;
                                            Xb = Wa
                                        }
                                        if ((Ra | 0) == (Mb | 0)) { break } else {
                                            Wa = Xb;
                                            Xa = Wb;
                                            Va = Ra;
                                            Ua = Ub
                                        }
                                    }
                                    if ((Ub | 0) == 0) {
                                        Rb = Mb;
                                        Sb = Wb;
                                        Tb = Xb;
                                        break
                                    }
                                    c[h + (Mb << 2) >> 2] = Ub;
                                    Rb = Mb + 1 | 0;
                                    Sb = Wb;
                                    Tb = Xb
                                }
                            } while (0);
                            Nb = Sb;
                            Ob = Rb;
                            Pb = 0;
                            Qb = 9 - oa + Tb | 0
                        }
                        f: while (1) {
                            o = h + (Nb << 2) | 0;
                            if ((Qb | 0) < 18) {
                                Ya = Ob;
                                Ua = Pb;
                                while (1) {
                                    Va = 0;
                                    Xa = Ya + 127 | 0;
                                    Wa = Ya;
                                    while (1) {
                                        na = Xa & 127;
                                        Ra = h + (na << 2) | 0;
                                        Qa = c[Ra >> 2] | 0;
                                        Ta = hv(Qa << 29 | 0 >>> 3, 0 << 29 | Qa >>> 3, Va, 0) | 0;
                                        Qa = K;
                                        Pa = 0;
                                        if (Qa >>> 0 > Pa >>> 0 | Qa >>> 0 == Pa >>> 0 & Ta >>> 0 > 1e9 >>> 0) {
                                            Pa = sv(Ta, Qa, 1e9, 0) | 0;
                                            qa = tv(Ta, Qa, 1e9, 0) | 0;
                                            Yb = Pa;
                                            Zb = qa
                                        } else {
                                            Yb = 0;
                                            Zb = Ta
                                        }
                                        c[Ra >> 2] = Zb;
                                        Ra = (na | 0) == (Nb | 0);
                                        if ((na | 0) != (Wa + 127 & 127 | 0) | Ra) { _b = Wa } else { _b = (Zb | 0) == 0 ? na : Wa }
                                        if (Ra) { break } else {
                                            Va = Yb;
                                            Xa = na - 1 | 0;
                                            Wa = _b
                                        }
                                    }
                                    Wa = Ua - 29 | 0;
                                    if ((Yb | 0) == 0) {
                                        Ya = _b;
                                        Ua = Wa
                                    } else {
                                        $b = Wa;
                                        ac = _b;
                                        bc = Yb;
                                        break
                                    }
                                }
                            } else {
                                if ((Qb | 0) == 18) {
                                    cc = Ob;
                                    dc = Pb
                                } else {
                                    ec = Nb;
                                    fc = Ob;
                                    gc = Pb;
                                    hc = Qb;
                                    break
                                }
                                while (1) {
                                    if (!((c[o >> 2] | 0) >>> 0 < 9007199 >>> 0)) {
                                        ec = Nb;
                                        fc = cc;
                                        gc = dc;
                                        hc = 18;
                                        break f
                                    }
                                    Ua = 0;
                                    Ya = cc + 127 | 0;
                                    Wa = cc;
                                    while (1) {
                                        Xa = Ya & 127;
                                        Va = h + (Xa << 2) | 0;
                                        na = c[Va >> 2] | 0;
                                        Ra = hv(na << 29 | 0 >>> 3, 0 << 29 | na >>> 3, Ua, 0) | 0;
                                        na = K;
                                        Ta = 0;
                                        if (na >>> 0 > Ta >>> 0 | na >>> 0 == Ta >>> 0 & Ra >>> 0 > 1e9 >>> 0) {
                                            Ta = sv(Ra, na, 1e9, 0) | 0;
                                            qa = tv(Ra, na, 1e9, 0) | 0;
                                            ic = Ta;
                                            jc = qa
                                        } else {
                                            ic = 0;
                                            jc = Ra
                                        }
                                        c[Va >> 2] = jc;
                                        Va = (Xa | 0) == (Nb | 0);
                                        if ((Xa | 0) != (Wa + 127 & 127 | 0) | Va) { kc = Wa } else { kc = (jc | 0) == 0 ? Xa : Wa }
                                        if (Va) { break } else {
                                            Ua = ic;
                                            Ya = Xa - 1 | 0;
                                            Wa = kc
                                        }
                                    }
                                    Wa = dc - 29 | 0;
                                    if ((ic | 0) == 0) {
                                        cc = kc;
                                        dc = Wa
                                    } else {
                                        $b = Wa;
                                        ac = kc;
                                        bc = ic;
                                        break
                                    }
                                }
                            }
                            o = Nb + 127 & 127;
                            if ((o | 0) == (ac | 0)) {
                                Wa = ac + 127 & 127;
                                Ya = h + ((ac + 126 & 127) << 2) | 0;
                                c[Ya >> 2] = c[Ya >> 2] | c[h + (Wa << 2) >> 2];
                                lc = Wa
                            } else { lc = ac }
                            c[h + (o << 2) >> 2] = bc;
                            Nb = o;
                            Ob = lc;
                            Pb = $b;
                            Qb = Qb + 9 | 0
                        }
                        g: while (1) {
                            mc = fc + 1 & 127;
                            oa = h + ((fc + 127 & 127) << 2) | 0;
                            o = ec;
                            Wa = gc;
                            Ya = hc;
                            while (1) {
                                Ua = (Ya | 0) == 18;
                                Xa = (Ya | 0) > 27 ? 9 : 1;
                                nc = o;
                                oc = Wa;
                                while (1) {
                                    Va = 0;
                                    while (1) {
                                        Ra = Va + nc & 127;
                                        if ((Ra | 0) == (fc | 0)) { pc = 2; break }
                                        qa = c[h + (Ra << 2) >> 2] | 0;
                                        Ra = c[208 + (Va << 2) >> 2] | 0;
                                        if (qa >>> 0 < Ra >>> 0) { pc = 2; break }
                                        Ta = Va + 1 | 0;
                                        if (qa >>> 0 > Ra >>> 0) { pc = Va; break }
                                        if ((Ta | 0) < 2) { Va = Ta } else { pc = Ta; break }
                                    }
                                    if ((pc | 0) == 2 & Ua) { break g }
                                    qc = Xa + oc | 0;
                                    if ((nc | 0) == (fc | 0)) {
                                        nc = fc;
                                        oc = qc
                                    } else { break }
                                }
                                Ua = (1 << Xa) - 1 | 0;
                                Va = 1e9 >>> (Xa >>> 0);
                                rc = Ya;
                                sc = nc;
                                Ta = nc;
                                tc = 0;
                                do {
                                    Ra = h + (Ta << 2) | 0;
                                    qa = c[Ra >> 2] | 0;
                                    na = (qa >>> (Xa >>> 0)) + tc | 0;
                                    c[Ra >> 2] = na;
                                    tc = ga(qa & Ua, Va) | 0;
                                    qa = (Ta | 0) == (sc | 0) & (na | 0) == 0;
                                    Ta = Ta + 1 & 127;
                                    rc = qa ? rc - 9 | 0 : rc;
                                    sc = qa ? Ta : sc;
                                } while ((Ta | 0) != (fc | 0));
                                if ((tc | 0) == 0) {
                                    o = sc;
                                    Wa = qc;
                                    Ya = rc;
                                    continue
                                }
                                if ((mc | 0) != (sc | 0)) { break }
                                c[oa >> 2] = c[oa >> 2] | 1;
                                o = sc;
                                Wa = qc;
                                Ya = rc
                            }
                            c[h + (fc << 2) >> 2] = tc;
                            ec = sc;
                            fc = mc;
                            gc = qc;
                            hc = rc
                        }
                        Ya = nc & 127;
                        if ((Ya | 0) == (fc | 0)) {
                            c[h + (mc - 1 << 2) >> 2] = 0;
                            uc = mc
                        } else { uc = fc }
                        la = +((c[h + (Ya << 2) >> 2] | 0) >>> 0 >>> 0);
                        Ya = nc + 1 & 127;
                        if ((Ya | 0) == (uc | 0)) {
                            Wa = uc + 1 & 127;
                            c[h + (Wa - 1 << 2) >> 2] = 0;
                            vc = Wa
                        } else { vc = uc }
                        wa = +(r | 0);
                        wc = wa * (la * 1.0e9 + +((c[h + (Ya << 2) >> 2] | 0) >>> 0 >>> 0));
                        Ya = oc + 53 | 0;
                        Wa = Ya - j | 0;
                        if ((Wa | 0) < (k | 0)) {
                            xc = (Wa | 0) < 0 ? 0 : Wa;
                            yc = 1
                        } else {
                            xc = k;
                            yc = 0
                        }
                        if ((xc | 0) < 53) {
                            la = +Cb(+(+Zu(1.0, 105 - xc | 0)), +wc);
                            zc = +$a(+wc, +(+Zu(1.0, 53 - xc | 0)));
                            Ac = la;
                            Bc = zc;
                            Cc = la + (wc - zc)
                        } else {
                            Ac = 0.0;
                            Bc = 0.0;
                            Cc = wc
                        }
                        o = nc + 2 & 127;
                        do {
                            if ((o | 0) == (vc | 0)) { Dc = Bc } else {
                                oa = c[h + (o << 2) >> 2] | 0;
                                do {
                                    if (oa >>> 0 < 5e8 >>> 0) {
                                        if ((oa | 0) == 0) { if ((nc + 3 & 127 | 0) == (vc | 0)) { Ec = Bc; break } }
                                        Ec = wa * .25 + Bc
                                    } else { if (oa >>> 0 > 5e8 >>> 0) { Ec = wa * .75 + Bc; break } if ((nc + 3 & 127 | 0) == (vc | 0)) { Ec = wa * .5 + Bc; break } else { Ec = wa * .75 + Bc; break } }
                                } while (0);
                                if ((53 - xc | 0) <= 1) { Dc = Ec; break }
                                if (+$a(+Ec, +1.0) != 0.0) { Dc = Ec; break }
                                Dc = Ec + 1.0
                            }
                        } while (0);
                        wa = Cc + Dc - Ac;
                        do {
                            if ((Ya & 2147483647 | 0) > (-2 - p | 0)) {
                                if (+V(+wa) < 9007199254740992.0) {
                                    Fc = wa;
                                    Gc = yc;
                                    Hc = oc
                                } else {
                                    Fc = wa * .5;
                                    Gc = (yc | 0) != 0 & (xc | 0) == (Wa | 0) ? 0 : yc;
                                    Hc = oc + 1 | 0
                                }
                                if ((Hc + 50 | 0) <= (ma | 0)) {
                                    if (!((Gc | 0) != 0 & Dc != 0.0)) {
                                        Ic = Fc;
                                        Jc = Hc;
                                        break
                                    }
                                }
                                o = Vb() | 0;
                                c[o >> 2] = 34;
                                Ic = Fc;
                                Jc = Hc
                            } else {
                                Ic = wa;
                                Jc = oc
                            }
                        } while (0);
                        l = +_u(Ic, Jc);
                        i = g;
                        return +l
                    } else if ((z | 0) == 3) {
                        ma = c[e >> 2] | 0;
                        if (ma >>> 0 < (c[m >> 2] | 0) >>> 0) {
                            c[e >> 2] = ma + 1;
                            Kc = d[ma] | 0
                        } else { Kc = Yu(b) | 0 }
                        if ((Kc | 0) == 40) { Lc = 1 } else {
                            if ((c[m >> 2] | 0) == 0) {
                                l = +v;
                                i = g;
                                return +l
                            }
                            c[e >> 2] = (c[e >> 2] | 0) - 1;
                            l = +v;
                            i = g;
                            return +l
                        }
                        while (1) {
                            ma = c[e >> 2] | 0;
                            if (ma >>> 0 < (c[m >> 2] | 0) >>> 0) {
                                c[e >> 2] = ma + 1;
                                Mc = d[ma] | 0
                            } else { Mc = Yu(b) | 0 }
                            if (!((Mc - 48 | 0) >>> 0 < 10 >>> 0 | (Mc - 65 | 0) >>> 0 < 26 >>> 0)) { if (!((Mc - 97 | 0) >>> 0 < 26 >>> 0 | (Mc | 0) == 95)) { break } }
                            Lc = Lc + 1 | 0
                        }
                        if ((Mc | 0) == 41) {
                            l = +v;
                            i = g;
                            return +l
                        }
                        ma = (c[m >> 2] | 0) == 0;
                        if (!ma) { c[e >> 2] = (c[e >> 2] | 0) - 1 }
                        if (u) {
                            Wa = Vb() | 0;
                            c[Wa >> 2] = 22;
                            Xu(b, 0);
                            l = 0.0;
                            i = g;
                            return +l
                        }
                        if ((Lc | 0) == 0 | ma) {
                            l = +v;
                            i = g;
                            return +l
                        } else { Nc = Lc }
                        while (1) {
                            ma = Nc - 1 | 0;
                            c[e >> 2] = (c[e >> 2] | 0) - 1;
                            if ((ma | 0) == 0) { l = +v; break } else { Nc = ma }
                        }
                        i = g;
                        return +l
                    } else {
                        if ((c[m >> 2] | 0) != 0) { c[e >> 2] = (c[e >> 2] | 0) - 1 }
                        u = Vb() | 0;
                        c[u >> 2] = 22;
                        Xu(b, 0);
                        l = 0.0;
                        i = g;
                        return +l
                    }
                }
            } while (0);
            do {
                if ((x | 0) == 23) {
                    b = (c[m >> 2] | 0) == 0;
                    if (!b) { c[e >> 2] = (c[e >> 2] | 0) - 1 }
                    if (s >>> 0 < 4 >>> 0 | (f | 0) == 0 | b) { break } else { Oc = s }
                    do {
                        c[e >> 2] = (c[e >> 2] | 0) - 1;
                        Oc = Oc - 1 | 0;
                    } while (Oc >>> 0 > 3 >>> 0)
                }
            } while (0);
            l = +(r | 0) * w;
            i = g;
            return +l
        }

        function Wu(a, b) {
            a = a | 0;
            b = b | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0;
            e = a + 4 | 0;
            f = c[e >> 2] | 0;
            g = a + 100 | 0;
            if (f >>> 0 < (c[g >> 2] | 0) >>> 0) {
                c[e >> 2] = f + 1;
                h = d[f] | 0
            } else { h = Yu(a) | 0 }
            do {
                if ((h | 0) == 45 | (h | 0) == 43) {
                    f = (h | 0) == 45 | 0;
                    i = c[e >> 2] | 0;
                    if (i >>> 0 < (c[g >> 2] | 0) >>> 0) {
                        c[e >> 2] = i + 1;
                        j = d[i] | 0
                    } else { j = Yu(a) | 0 }
                    if ((j - 48 | 0) >>> 0 < 10 >>> 0 | (b | 0) == 0) {
                        k = f;
                        l = j;
                        break
                    }
                    if ((c[g >> 2] | 0) == 0) {
                        k = f;
                        l = j;
                        break
                    }
                    c[e >> 2] = (c[e >> 2] | 0) - 1;
                    k = f;
                    l = j
                } else {
                    k = 0;
                    l = h
                }
            } while (0);
            if ((l - 48 | 0) >>> 0 > 9 >>> 0) {
                if ((c[g >> 2] | 0) == 0) {
                    m = -2147483648;
                    n = 0;
                    return (K = m, n) | 0
                }
                c[e >> 2] = (c[e >> 2] | 0) - 1;
                m = -2147483648;
                n = 0;
                return (K = m, n) | 0
            } else {
                o = l;
                p = 0
            }
            while (1) {
                q = o - 48 + p | 0;
                l = c[e >> 2] | 0;
                if (l >>> 0 < (c[g >> 2] | 0) >>> 0) {
                    c[e >> 2] = l + 1;
                    r = d[l] | 0
                } else { r = Yu(a) | 0 }
                if (!((r - 48 | 0) >>> 0 < 10 >>> 0 & (q | 0) < 214748364)) { break }
                o = r;
                p = q * 10 | 0
            }
            p = q;
            o = (q | 0) < 0 | 0 ? -1 : 0;
            if ((r - 48 | 0) >>> 0 < 10 >>> 0) {
                q = r;
                l = o;
                h = p;
                while (1) {
                    j = rv(h, l, 10, 0) | 0;
                    b = K;
                    f = hv(q, (q | 0) < 0 | 0 ? -1 : 0, -48, -1) | 0;
                    i = hv(f, K, j, b) | 0;
                    b = K;
                    j = c[e >> 2] | 0;
                    if (j >>> 0 < (c[g >> 2] | 0) >>> 0) {
                        c[e >> 2] = j + 1;
                        s = d[j] | 0
                    } else { s = Yu(a) | 0 }
                    j = 21474836;
                    if ((s - 48 | 0) >>> 0 < 10 >>> 0 & ((b | 0) < (j | 0) | (b | 0) == (j | 0) & i >>> 0 < 2061584302 >>> 0)) {
                        q = s;
                        l = b;
                        h = i
                    } else {
                        t = s;
                        u = b;
                        v = i;
                        break
                    }
                }
            } else {
                t = r;
                u = o;
                v = p
            }
            if ((t - 48 | 0) >>> 0 < 10 >>> 0) {
                do {
                    t = c[e >> 2] | 0;
                    if (t >>> 0 < (c[g >> 2] | 0) >>> 0) {
                        c[e >> 2] = t + 1;
                        w = d[t] | 0
                    } else { w = Yu(a) | 0 }
                } while ((w - 48 | 0) >>> 0 < 10 >>> 0)
            }
            if ((c[g >> 2] | 0) != 0) { c[e >> 2] = (c[e >> 2] | 0) - 1 }
            e = (k | 0) != 0;
            k = iv(0, 0, v, u) | 0;
            m = e ? K : u;
            n = e ? k : v;
            return (K = m, n) | 0
        }

        function Xu(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0;
            c[a + 104 >> 2] = b;
            d = c[a + 8 >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            f = d - e | 0;
            c[a + 108 >> 2] = f;
            if ((b | 0) != 0 & (f | 0) > (b | 0)) { c[a + 100 >> 2] = e + b; return } else { c[a + 100 >> 2] = d; return }
        }

        function Yu(b) {
            b = b | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0;
            e = b + 104 | 0;
            f = c[e >> 2] | 0;
            if ((f | 0) == 0) { g = 3 } else { if ((c[b + 108 >> 2] | 0) < (f | 0)) { g = 3 } }
            do {
                if ((g | 0) == 3) {
                    f = av(b) | 0;
                    if ((f | 0) < 0) { break }
                    h = c[e >> 2] | 0;
                    i = c[b + 8 >> 2] | 0;
                    do {
                        if ((h | 0) == 0) { g = 8 } else {
                            j = c[b + 4 >> 2] | 0;
                            k = h - (c[b + 108 >> 2] | 0) - 1 | 0;
                            if ((i - j | 0) <= (k | 0)) { g = 8; break }
                            c[b + 100 >> 2] = j + k
                        }
                    } while (0);
                    if ((g | 0) == 8) { c[b + 100 >> 2] = i }
                    h = c[b + 4 >> 2] | 0;
                    if ((i | 0) != 0) {
                        k = b + 108 | 0;
                        c[k >> 2] = i + 1 - h + (c[k >> 2] | 0)
                    }
                    k = h - 1 | 0;
                    if ((d[k] | 0 | 0) == (f | 0)) { l = f; return l | 0 }
                    a[k] = f;
                    l = f;
                    return l | 0
                }
            } while (0);
            c[b + 100 >> 2] = 0;
            l = -1;
            return l | 0
        }

        function Zu(a, b) {
            a = +a;
            b = b | 0;
            var d = 0.0,
                e = 0,
                f = 0.0,
                g = 0;
            do {
                if ((b | 0) > 1023) {
                    d = a * 8.98846567431158e+307;
                    e = b - 1023 | 0;
                    if ((e | 0) <= 1023) {
                        f = d;
                        g = e;
                        break
                    }
                    e = b - 2046 | 0;
                    f = d * 8.98846567431158e+307;
                    g = (e | 0) > 1023 ? 1023 : e
                } else {
                    if (!((b | 0) < -1022)) {
                        f = a;
                        g = b;
                        break
                    }
                    d = a * 2.2250738585072014e-308;
                    e = b + 1022 | 0;
                    if (!((e | 0) < -1022)) {
                        f = d;
                        g = e;
                        break
                    }
                    e = b + 2044 | 0;
                    f = d * 2.2250738585072014e-308;
                    g = (e | 0) < -1022 ? -1022 : e
                }
            } while (0);
            return +(f * (c[k >> 2] = 0 << 20 | 0 >>> 12, c[k + 4 >> 2] = g + 1023 << 20 | 0 >>> 12, +h[k >> 3]))
        }

        function _u(a, b) {
            a = +a;
            b = b | 0;
            return +(+Zu(a, b))
        }

        function $u(b) {
            b = b | 0;
            var d = 0,
                e = 0,
                f = 0,
                g = 0,
                h = 0;
            d = b + 74 | 0;
            e = a[d] | 0;
            a[d] = e - 1 & 255 | e;
            e = b + 20 | 0;
            d = b + 44 | 0;
            if ((c[e >> 2] | 0) >>> 0 > (c[d >> 2] | 0) >>> 0) { Hc[c[b + 36 >> 2] & 63](b, 0, 0) | 0 }
            c[b + 16 >> 2] = 0;
            c[b + 28 >> 2] = 0;
            c[e >> 2] = 0;
            e = b | 0;
            f = c[e >> 2] | 0;
            if ((f & 20 | 0) == 0) {
                g = c[d >> 2] | 0;
                c[b + 8 >> 2] = g;
                c[b + 4 >> 2] = g;
                h = 0;
                return h | 0
            }
            if ((f & 4 | 0) == 0) { h = -1; return h | 0 }
            c[e >> 2] = f | 32;
            h = -1;
            return h | 0
        }

        function av(a) {
            a = a | 0;
            var b = 0,
                e = 0,
                f = 0,
                g = 0;
            b = i;
            i = i + 8 | 0;
            e = b | 0;
            if ((c[a + 8 >> 2] | 0) == 0) { if (($u(a) | 0) == 0) { f = 3 } else { g = -1 } } else { f = 3 }
            do {
                if ((f | 0) == 3) {
                    if ((Hc[c[a + 32 >> 2] & 63](a, e, 1) | 0) != 1) { g = -1; break }
                    g = d[e] | 0
                }
            } while (0);
            i = b;
            return g | 0
        }

        function bv(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0.0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            d = i;
            i = i + 112 | 0;
            e = d | 0;
            dv(e | 0, 0, 112) | 0;
            f = e + 4 | 0;
            c[f >> 2] = a;
            g = e + 8 | 0;
            c[g >> 2] = -1;
            c[e + 44 >> 2] = a;
            c[e + 76 >> 2] = -1;
            Xu(e, 0);
            h = +Vu(e, 2, 1);
            j = (c[f >> 2] | 0) - (c[g >> 2] | 0) + (c[e + 108 >> 2] | 0) | 0;
            if ((b | 0) == 0) {
                k = 112;
                l = 0;
                i = d;
                return +h
            }
            if ((j | 0) == 0) { m = a } else { m = a + j | 0 }
            c[b >> 2] = m;
            k = 112;
            l = 0;
            i = d;
            return +h
        }

        function cv(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            if ((e | 0) >= 4096) return wb(b | 0, d | 0, e | 0) | 0;
            f = b | 0;
            if ((b & 3) == (d & 3)) {
                while (b & 3) {
                    if ((e | 0) == 0) return f | 0;
                    a[b] = a[d] | 0;
                    b = b + 1 | 0;
                    d = d + 1 | 0;
                    e = e - 1 | 0
                }
                while ((e | 0) >= 4) {
                    c[b >> 2] = c[d >> 2];
                    b = b + 4 | 0;
                    d = d + 4 | 0;
                    e = e - 4 | 0
                }
            }
            while ((e | 0) > 0) {
                a[b] = a[d] | 0;
                b = b + 1 | 0;
                d = d + 1 | 0;
                e = e - 1 | 0
            }
            return f | 0
        }

        function dv(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                i = 0;
            f = b + e | 0;
            if ((e | 0) >= 20) {
                d = d & 255;
                g = b & 3;
                h = d | d << 8 | d << 16 | d << 24;
                i = f & ~3;
                if (g) {
                    g = b + 4 - g | 0;
                    while ((b | 0) < (g | 0)) {
                        a[b] = d;
                        b = b + 1 | 0
                    }
                }
                while ((b | 0) < (i | 0)) {
                    c[b >> 2] = h;
                    b = b + 4 | 0
                }
            }
            while ((b | 0) < (f | 0)) {
                a[b] = d;
                b = b + 1 | 0
            }
            return b - e | 0
        }

        function ev(b) {
            b = b | 0;
            var c = 0;
            c = b;
            while (a[c] | 0) { c = c + 1 | 0 }
            return c - b | 0
        }

        function fv(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            if ((c | 0) < (b | 0) & (b | 0) < (c + d | 0)) {
                e = b;
                c = c + d | 0;
                b = b + d | 0;
                while ((d | 0) > 0) {
                    b = b - 1 | 0;
                    c = c - 1 | 0;
                    d = d - 1 | 0;
                    a[b] = a[c] | 0
                }
                b = e
            } else { cv(b, c, d) | 0 }
            return b | 0
        }

        function gv(i, j, k, l, m, n, o, p) {
            i = i;
            j = j;
            k = k;
            l = l;
            m = m;
            n = n;
            o = o;
            p = p;
            a = i;
            b = j;
            c = k;
            d = l;
            e = m;
            f = n;
            g = o;
            h = p
        }

        function hv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            e = a + c >>> 0;
            return (K = b + d + (e >>> 0 < a >>> 0 | 0) >>> 0, e | 0) | 0
        }

        function iv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            e = b - d >>> 0;
            e = b - d - (c >>> 0 > a >>> 0 | 0) >>> 0;
            return (K = e, a - c >>> 0 | 0) | 0
        }

        function jv(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) { K = b << c | (a & (1 << c) - 1 << 32 - c) >>> 32 - c; return a << c }
            K = a << c - 32;
            return 0
        }

        function kv(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) { K = b >>> c; return a >>> c | (b & (1 << c) - 1) << 32 - c }
            K = 0;
            return b >>> c - 32 | 0
        }

        function lv(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) { K = b >> c; return a >>> c | (b & (1 << c) - 1) << 32 - c }
            K = (b | 0) < 0 ? -1 : 0;
            return b >> c - 32 | 0
        }

        function mv(b) {
            b = b | 0;
            var c = 0;
            c = a[n + (b >>> 24) | 0] | 0;
            if ((c | 0) < 8) return c | 0;
            c = a[n + (b >> 16 & 255) | 0] | 0;
            if ((c | 0) < 8) return c + 8 | 0;
            c = a[n + (b >> 8 & 255) | 0] | 0;
            if ((c | 0) < 8) return c + 16 | 0;
            return (a[n + (b & 255) | 0] | 0) + 24 | 0
        }

        function nv(b) {
            b = b | 0;
            var c = 0;
            c = a[m + (b & 255) | 0] | 0;
            if ((c | 0) < 8) return c | 0;
            c = a[m + (b >> 8 & 255) | 0] | 0;
            if ((c | 0) < 8) return c + 8 | 0;
            c = a[m + (b >> 16 & 255) | 0] | 0;
            if ((c | 0) < 8) return c + 16 | 0;
            return (a[m + (b >>> 24) | 0] | 0) + 24 | 0
        }

        function ov(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0,
                d = 0,
                e = 0,
                f = 0;
            c = a & 65535;
            d = b & 65535;
            e = ga(d, c) | 0;
            f = a >>> 16;
            a = (e >>> 16) + (ga(d, f) | 0) | 0;
            d = b >>> 16;
            b = ga(d, c) | 0;
            return (K = (a >>> 16) + (ga(d, f) | 0) + (((a & 65535) + b | 0) >>> 16) | 0, a + b << 16 | e & 65535 | 0) | 0
        }

        function pv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0,
                f = 0,
                g = 0,
                h = 0,
                i = 0;
            e = b >> 31 | ((b | 0) < 0 ? -1 : 0) << 1;
            f = ((b | 0) < 0 ? -1 : 0) >> 31 | ((b | 0) < 0 ? -1 : 0) << 1;
            g = d >> 31 | ((d | 0) < 0 ? -1 : 0) << 1;
            h = ((d | 0) < 0 ? -1 : 0) >> 31 | ((d | 0) < 0 ? -1 : 0) << 1;
            i = iv(e ^ a, f ^ b, e, f) | 0;
            b = K;
            a = g ^ e;
            e = h ^ f;
            f = iv((uv(i, b, iv(g ^ c, h ^ d, g, h) | 0, K, 0) | 0) ^ a, K ^ e, a, e) | 0;
            return (K = K, f) | 0
        }

        function qv(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0,
                h = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            h = b >> 31 | ((b | 0) < 0 ? -1 : 0) << 1;
            j = ((b | 0) < 0 ? -1 : 0) >> 31 | ((b | 0) < 0 ? -1 : 0) << 1;
            k = e >> 31 | ((e | 0) < 0 ? -1 : 0) << 1;
            l = ((e | 0) < 0 ? -1 : 0) >> 31 | ((e | 0) < 0 ? -1 : 0) << 1;
            m = iv(h ^ a, j ^ b, h, j) | 0;
            b = K;
            uv(m, b, iv(k ^ d, l ^ e, k, l) | 0, K, g) | 0;
            l = iv(c[g >> 2] ^ h, c[g + 4 >> 2] ^ j, h, j) | 0;
            j = K;
            i = f;
            return (K = j, l) | 0
        }

        function rv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0,
                f = 0;
            e = a;
            a = c;
            c = ov(e, a) | 0;
            f = K;
            return (K = (ga(b, a) | 0) + (ga(d, e) | 0) + f | f & 0, c | 0 | 0) | 0
        }

        function sv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            e = uv(a, b, c, d, 0) | 0;
            return (K = K, e) | 0
        }

        function tv(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0,
                g = 0;
            f = i;
            i = i + 8 | 0;
            g = f | 0;
            uv(a, b, d, e, g) | 0;
            i = f;
            return (K = c[g + 4 >> 2] | 0, c[g >> 2] | 0) | 0
        }

        function uv(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0,
                h = 0,
                i = 0,
                j = 0,
                k = 0,
                l = 0,
                m = 0,
                n = 0,
                o = 0,
                p = 0,
                q = 0,
                r = 0,
                s = 0,
                t = 0,
                u = 0,
                v = 0,
                w = 0,
                x = 0,
                y = 0,
                z = 0,
                A = 0,
                B = 0,
                C = 0,
                D = 0,
                E = 0,
                F = 0,
                G = 0,
                H = 0,
                I = 0,
                J = 0,
                L = 0,
                M = 0;
            g = a;
            h = b;
            i = h;
            j = d;
            k = e;
            l = k;
            if ((i | 0) == 0) {
                m = (f | 0) != 0;
                if ((l | 0) == 0) {
                    if (m) {
                        c[f >> 2] = (g >>> 0) % (j >>> 0);
                        c[f + 4 >> 2] = 0
                    }
                    n = 0;
                    o = (g >>> 0) / (j >>> 0) >>> 0;
                    return (K = n, o) | 0
                } else {
                    if (!m) {
                        n = 0;
                        o = 0;
                        return (K = n, o) | 0
                    }
                    c[f >> 2] = a | 0;
                    c[f + 4 >> 2] = b & 0;
                    n = 0;
                    o = 0;
                    return (K = n, o) | 0
                }
            }
            m = (l | 0) == 0;
            do {
                if ((j | 0) == 0) {
                    if (m) {
                        if ((f | 0) != 0) {
                            c[f >> 2] = (i >>> 0) % (j >>> 0);
                            c[f + 4 >> 2] = 0
                        }
                        n = 0;
                        o = (i >>> 0) / (j >>> 0) >>> 0;
                        return (K = n, o) | 0
                    }
                    if ((g | 0) == 0) {
                        if ((f | 0) != 0) {
                            c[f >> 2] = 0;
                            c[f + 4 >> 2] = (i >>> 0) % (l >>> 0)
                        }
                        n = 0;
                        o = (i >>> 0) / (l >>> 0) >>> 0;
                        return (K = n, o) | 0
                    }
                    p = l - 1 | 0;
                    if ((p & l | 0) == 0) {
                        if ((f | 0) != 0) {
                            c[f >> 2] = a | 0;
                            c[f + 4 >> 2] = p & i | b & 0
                        }
                        n = 0;
                        o = i >>> ((nv(l | 0) | 0) >>> 0);
                        return (K = n, o) | 0
                    }
                    p = (mv(l | 0) | 0) - (mv(i | 0) | 0) | 0;
                    if (p >>> 0 <= 30) {
                        q = p + 1 | 0;
                        r = 31 - p | 0;
                        s = q;
                        t = i << r | g >>> (q >>> 0);
                        u = i >>> (q >>> 0);
                        v = 0;
                        w = g << r;
                        break
                    }
                    if ((f | 0) == 0) {
                        n = 0;
                        o = 0;
                        return (K = n, o) | 0
                    }
                    c[f >> 2] = a | 0;
                    c[f + 4 >> 2] = h | b & 0;
                    n = 0;
                    o = 0;
                    return (K = n, o) | 0
                } else {
                    if (!m) {
                        r = (mv(l | 0) | 0) - (mv(i | 0) | 0) | 0;
                        if (r >>> 0 <= 31) {
                            q = r + 1 | 0;
                            p = 31 - r | 0;
                            x = r - 31 >> 31;
                            s = q;
                            t = g >>> (q >>> 0) & x | i << p;
                            u = i >>> (q >>> 0) & x;
                            v = 0;
                            w = g << p;
                            break
                        }
                        if ((f | 0) == 0) {
                            n = 0;
                            o = 0;
                            return (K = n, o) | 0
                        }
                        c[f >> 2] = a | 0;
                        c[f + 4 >> 2] = h | b & 0;
                        n = 0;
                        o = 0;
                        return (K = n, o) | 0
                    }
                    p = j - 1 | 0;
                    if ((p & j | 0) != 0) {
                        x = (mv(j | 0) | 0) + 33 - (mv(i | 0) | 0) | 0;
                        q = 64 - x | 0;
                        r = 32 - x | 0;
                        y = r >> 31;
                        z = x - 32 | 0;
                        A = z >> 31;
                        s = x;
                        t = r - 1 >> 31 & i >>> (z >>> 0) | (i << r | g >>> (x >>> 0)) & A;
                        u = A & i >>> (x >>> 0);
                        v = g << q & y;
                        w = (i << q | g >>> (z >>> 0)) & y | g << r & x - 33 >> 31;
                        break
                    }
                    if ((f | 0) != 0) {
                        c[f >> 2] = p & g;
                        c[f + 4 >> 2] = 0
                    }
                    if ((j | 0) == 1) {
                        n = h | b & 0;
                        o = a | 0 | 0;
                        return (K = n, o) | 0
                    } else {
                        p = nv(j | 0) | 0;
                        n = i >>> (p >>> 0) | 0;
                        o = i << 32 - p | g >>> (p >>> 0) | 0;
                        return (K = n, o) | 0
                    }
                }
            } while (0);
            if ((s | 0) == 0) {
                B = w;
                C = v;
                D = u;
                E = t;
                F = 0;
                G = 0
            } else {
                g = d | 0 | 0;
                d = k | e & 0;
                e = hv(g, d, -1, -1) | 0;
                k = K;
                i = w;
                w = v;
                v = u;
                u = t;
                t = s;
                s = 0;
                while (1) {
                    H = w >>> 31 | i << 1;
                    I = s | w << 1;
                    j = u << 1 | i >>> 31 | 0;
                    a = u >>> 31 | v << 1 | 0;
                    iv(e, k, j, a) | 0;
                    b = K;
                    h = b >> 31 | ((b | 0) < 0 ? -1 : 0) << 1;
                    J = h & 1;
                    L = iv(j, a, h & g, (((b | 0) < 0 ? -1 : 0) >> 31 | ((b | 0) < 0 ? -1 : 0) << 1) & d) | 0;
                    M = K;
                    b = t - 1 | 0;
                    if ((b | 0) == 0) { break } else {
                        i = H;
                        w = I;
                        v = M;
                        u = L;
                        t = b;
                        s = J
                    }
                }
                B = H;
                C = I;
                D = M;
                E = L;
                F = 0;
                G = J
            }
            J = C;
            C = 0;
            if ((f | 0) != 0) {
                c[f >> 2] = E;
                c[f + 4 >> 2] = D
            }
            n = (J | 0) >>> 31 | (B | C) << 1 | (C << 1 | J >>> 31) & 0 | F;
            o = (J << 1 | 0 >>> 31) & -2 | G;
            return (K = n, o) | 0
        }

        function vv() { qc() }

        function wv(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            Cc[a & 31](b | 0, c | 0, d | 0, e | 0, f | 0)
        }

        function xv(a, b) {
            a = a | 0;
            b = b | 0;
            Dc[a & 511](b | 0)
        }

        function yv(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            Ec[a & 127](b | 0, c | 0)
        }

        function zv(a, b) {
            a = a | 0;
            b = b | 0;
            return Fc[a & 255](b | 0) | 0
        }

        function Av(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            return Gc[a & 31](b | 0, c | 0, d | 0, e | 0, f | 0) | 0
        }

        function Bv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            return Hc[a & 63](b | 0, c | 0, d | 0) | 0
        }

        function Cv(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = +g;
            Ic[a & 15](b | 0, c | 0, d | 0, e | 0, f | 0, +g)
        }

        function Dv(a, b, c, d, e, f, g, h, i) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            Jc[a & 63](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0, h | 0, i | 0)
        }

        function Ev(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Kc[a & 63](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0)
        }

        function Fv(a, b, c, d, e, f, g, h, i, j, k, l, m, n) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            n = n | 0;
            Lc[a & 3](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0, h | 0, i | 0, j | 0, k | 0, l | 0, m | 0, n | 0)
        }

        function Gv(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            Mc[a & 127](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0, h | 0)
        }

        function Hv(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = +h;
            Nc[a & 7](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0, +h)
        }

        function Iv(a, b, c, d, e, f, g, h, i, j) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            Oc[a & 15](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0, h | 0, i | 0, j | 0)
        }

        function Jv(a, b, c, d, e, f, g, h, i, j, k) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            Pc[a & 15](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0, h | 0, i | 0, j | 0, k | 0)
        }

        function Kv(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            return Qc[a & 63](b | 0, c | 0) | 0
        }

        function Lv(a, b, c, d, e, f, g, h, i, j, k, l, m) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            Rc[a & 3](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0, h | 0, i | 0, j | 0, k | 0, l | 0, m | 0)
        }

        function Mv(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            return Sc[a & 15](b | 0, c | 0, d | 0, e | 0) | 0
        }

        function Nv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            Tc[a & 63](b | 0, c | 0, d | 0)
        }

        function Ov(a) {
            a = a | 0;
            Uc[a & 3]()
        }

        function Pv(a, b, c, d, e, f, g, h, i) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            return Vc[a & 31](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0, h | 0, i | 0) | 0
        }

        function Qv(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            Wc[a & 63](b | 0, c | 0, d | 0, e | 0)
        }

        function Rv(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            ha(0)
        }

        function Sv(a) {
            a = a | 0;
            ha(1)
        }

        function Tv(a, b) {
            a = a | 0;
            b = b | 0;
            ha(2)
        }

        function Uv(a) {
            a = a | 0;
            ha(3);
            return 0
        }

        function Vv(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            ha(4);
            return 0
        }

        function Wv(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            ha(5);
            return 0
        }

        function Xv(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = +f;
            ha(6)
        }

        function Yv(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            ha(7)
        }

        function Zv(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            ha(8)
        }

        function _v(a, b, c, d, e, f, g, h, i, j, k, l, m) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            m = m | 0;
            ha(9)
        }

        function $v(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            ha(10)
        }

        function aw(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = +g;
            ha(11)
        }

        function bw(a, b, c, d, e, f, g, h, i) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            ha(12)
        }

        function cw(a, b, c, d, e, f, g, h, i, j) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            ha(13)
        }

        function dw(a, b) {
            a = a | 0;
            b = b | 0;
            ha(14);
            return 0
        }

        function ew(a, b, c, d, e, f, g, h, i, j, k, l) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            j = j | 0;
            k = k | 0;
            l = l | 0;
            ha(15)
        }

        function fw(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            ha(16);
            return 0
        }

        function gw(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            ha(17)
        }

        function hw() { ha(18) }

        function iw(a, b, c, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            ha(19);
            return 0
        }

        function jw(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            ha(20)
        }




        // EMSCRIPTEN_END_FUNCS
        var Cc = [Rv, Rv, Vf, Rv, Nf, Rv, Bu, Rv, Cu, Rv, Qf, Rv, Au, Rv, Mf, Rv, Wf, Rv, Rv, Rv, Rv, Rv, Rv, Rv, Rv, Rv, Rv, Rv, Rv, Rv, Rv, Rv];
        var Dc = [Sv, Sv, Hr, Sv, _n, Sv, pp, Sv, cm, Sv, jk, Sv, Om, Sv, Mr, Sv, Zr, Sv, Kl, Sv, Rh, Sv, xl, Sv, ap, Sv, Wl, Sv, Ls, Sv, am, Sv, yo, Sv, Ti, Sv, Qn, Sv, Mn, Sv, Xl, Sv, Xr, Sv, ls, Sv, Rp, Sv, zo, Sv, lu, Sv, En, Sv, Dr, Sv, Yr, Sv, qn, Sv, $n, Sv, Eq, Sv, Rr, Sv, yj, Sv, it, Sv, qu, Sv, ht, Sv, Kn, Sv, am, Sv, Wn, Sv, fk, Sv, jq, Sv, kt, Sv, _r, Sv, Hu, Sv, wr, Sv, gt, Sv, On, Sv, jj, Sv, un, Sv, wl, Sv, th, Sv, ck, Sv, Vn, Sv, eq, Sv, Xl, Sv, Ed, Sv, St, Sv, bp, Sv, Ws, Sv, rf, Sv, Fq, Sv, pn, Sv, Bn, Sv, bq, Sv, Qp, Sv, Nn, Sv, tq, Sv, Bk, Sv, Ru, Sv, Nm, Sv, Le, Sv, Vt, Sv, Wt, Sv, Fn, Sv, an, Sv, Si, Sv, vs, Sv, nu, Sv, rn, Sv, Ln, Sv, _q, Sv, ol, Sv, Pq, Sv, Gn, Sv, Vr, Sv, tu, Sv, Su, Sv, Yt, Sv, ru, Sv, Dl, Sv, Qr, Sv, vj, Sv, cq, Sv, jr, Sv, mu, Sv, ft, Sv, br, Sv, Oh, Sv, Xt, Sv, iq, Sv, op, Sv, Pn, Sv, El, Sv, Ut, Sv, Rn, Sv, wn, Sv, km, Sv, ql, Sv, Ds, Sv, qr, Sv, ir, Sv, sh, Sv, jt, Sv, xr, Sv, Cm, Sv, kj, Sv, Cd, Sv, nu, Sv, uu, Sv, An, Sv, Me, Sv, lm, Sv, bk, Sv, on, Sv, pu, Sv, ik, Sv, qf, Sv, Be, Sv, Dn, Sv, gk, Sv, Cr, Sv, hk, Sv, Km, Sv, zn, Sv, Ll, Sv, Tr, Sv, Qq, Sv, Cp, Sv, uq, Sv, Ne, Sv, Fe, Sv, vn, Sv, $m, Sv, yn, Sv, xj, Sv, Dp, Sv, su, Sv, Ir, Sv, pl, Sv, tn, Sv, ek, Sv, fq, Sv, Ee, Sv, Ck, Sv, rr, Sv, $q, Sv, rm, Sv, ms, Sv, $l, Sv, kl, Sv, Zt, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv, Sv];
        var Ec = [Tv, Tv, tt, Tv, Vq, Tv, xq, Tv, qt, Tv, Oq, Tv, pt, Tv, Dq, Tv, zj, Tv, rl, Tv, ak, Tv, Gr, Tv, Jq, Tv, pq, Tv, Yq, Tv, Lq, Tv, oq, Tv, Tq, Tv, mq, Tv, Wq, Tv, Ur, Tv, Fl, Tv, yl, Tv, Zq, Tv, Dd, Tv, st, Tv, Yf, Tv, yq, Tv, _l, Tv, ut, Tv, Nq, Tv, Aq, Tv, rt, Tv, Cq, Tv, Pm, Tv, Ml, Tv, Lr, Tv, Iq, Tv, $j, Tv, sq, Tv, rq, Tv, nq, Tv, bn, Tv, Kq, Tv, Ge, Tv, Uq, Tv, zq, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv, Tv];
        var Fc = [Uv, Uv, It, Uv, Hq, Uv, Wm, Uv, As, Uv, yt, Uv, Xm, Uv, bt, Uv, Gt, Uv, vq, Uv, Ep, Uv, wt, Uv, Ol, Uv, kn, Uv, jn, Uv, at, Uv, Ct, Uv, At, Uv, ou, Uv, bm, Uv, lt, Uv, Bt, Uv, Ft, Uv, mt, Uv, Tm, Uv, zs, Uv, Xq, Uv, Dt, Uv, sl, Uv, wq, Uv, Ss, Uv, Rq, Uv, vt, Uv, zl, Uv, Tu, Uv, In, Uv, qq, Uv, Al, Uv, nt, Uv, Um, Uv, fn, Uv, Gl, Uv, Cs, Uv, Bq, Uv, Ht, Uv, Nl, Uv, Rs, Uv, Is, Uv, gn, Uv, kq, Uv, xt, Uv, lq, Uv, Yl, Uv, Ik, Uv, Gq, Uv, Ks, Uv, Mq, Uv, zt, Uv, Sq, Uv, Hs, Uv, Sp, Uv, ot, Uv, Et, Uv, Vs, Uv, et, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv, Uv];
        var Gc = [Vv, Vv, ks, Vv, Qs, Vv, Xn, Vv, ct, Vv, Ts, Vv, us, Vv, Gs, Vv, Sn, Vv, ys, Vv, Bs, Vv, $s, Vv, Js, Vv, Vv, Vv, Vv, Vv, Vv, Vv];
        var Hc = [Wv, Wv, Un, Wv, os, Wv, gs, Wv, vu, Wv, js, Wv, Zn, Wv, fm, Wv, Zm, Wv, Vm, Wv, $r, Wv, cn, Wv, Jr, Wv, ts, Wv, es, Wv, tl, Wv, gm, Wv, hn, Wv, qs, Wv, Er, Wv, Qm, Wv, Hl, Wv, mn, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv, Wv];
        var Ic = [Xv, Xv, zp, Xv, xp, Xv, mp, Xv, jp, Xv, Xv, Xv, Xv, Xv, Xv, Xv];
        var Jc = [Yv, Yv, gh, Yv, qh, Yv, ch, Yv, Hg, Yv, gq, Yv, fh, Yv, ph, Yv, dq, Yv, eh, Yv, mh, Yv, oh, Yv, ih, Yv, hh, Yv, ar, Yv, kr, Yv, jh, Yv, lh, Yv, nh, Yv, er, Yv, kh, Yv, Ng, Yv, rh, Yv, mr, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv, Yv];
        var Kc = [Zv, Zv, Du, Zv, vp, Zv, rp, Zv, qp, Zv, Eu, Zv, Ap, Zv, Fr, Zv, dn, Zv, np, Zv, Ag, Zv, cp, Zv, hp, Zv, dp, Zv, Fu, Zv, Rm, Zv, Kr, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv, Zv];
        var Lc = [_v, _v, Gg, _v];
        var Mc = [$v, $v, Jp, $v, Tp, $v, Tg, $v, _g, $v, Vp, $v, Br, $v, Wg, $v, wp, $v, up, $v, vr, $v, $g, $v, Fp, $v, Mg, $v, Og, $v, Dg, $v, ah, $v, Ip, $v, Ug, $v, Wp, $v, Eg, $v, ip, $v, Rg, $v, Oo, $v, Yg, $v, Uo, $v, Qg, $v, Hp, $v, Vg, $v, Io, $v, Up, $v, gp, $v, Xg, $v, Mo, $v, Eo, $v, Go, $v, vo, $v, Ko, $v, Co, $v, Ao, $v, So, $v, Qo, $v, bh, $v, Sg, $v, Xp, $v, jo, $v, Gp, $v, no, $v, fo, $v, ho, $v, lo, $v, co, $v, to, $v, ro, $v, po, $v, ao, $v, Zg, $v, $v, $v, $v, $v, $v, $v, $v, $v, $v, $v, $v, $v, $v, $v];
        var Nc = [aw, aw, yr, aw, sr, aw, aw, aw];
        var Oc = [bw, bw, Bg, bw, Yp, bw, Ig, bw, Kp, bw, bw, bw, bw, bw, bw, bw];
        var Pc = [cw, cw, Jg, cw, Lg, cw, Fg, cw, Kg, cw, cw, cw, cw, cw, cw, cw];
        var Qc = [dw, dw, ps, dw, Pl, dw, hs, dw, ln, dw, rs, dw, of, dw, ns, dw, Bl, dw, Il, dw, ds, dw, pf, dw, nn, dw, fs, dw, _m, dw, Ym, dw, ul, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw, dw];
        var Rc = [ew, ew, Cg, ew];
        var Sc = [fw, fw, as, fw, Mh, fw, bs, fw, ss, fw, is, fw, cs, fw, fw, fw];
        var Tc = [gw, gw, yg, gw, Xf, gw, xg, gw, qg, gw, Uf, gw, gg, gw, tg, gw, jg, gw, wg, gw, ug, gw, Of, gw, $f, gw, zg, gw, Zf, gw, kg, gw, sg, gw, em, gw, Jn, gw, ig, gw, Tf, gw, Nh, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw, gw];
        var Uc = [hw, hw, vv, hw];
        var Vc = [iw, iw, Es, iw, Os, iw, Ms, iw, Zs, iw, Fs, iw, Xs, iw, ws, iw, xs, iw, iw, iw, iw, iw, iw, iw, iw, iw, iw, iw, iw, iw, iw, iw];
        var Wc = [jw, jw, eg, jw, cg, jw, xu, jw, yu, jw, ag, jw, lg, jw, dg, jw, Pf, jw, ng, jw, Sf, jw, wu, jw, og, jw, pg, jw, fg, jw, Sm, jw, Yn, jw, en, jw, Rf, jw, Tn, jw, _f, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw, jw];
        return { _de265_get_error_text: Nd, _strlen: ev, _de265_get_image_plane_user_data: pe, _de265_release_next_picture: _d, _de265_push_end_of_NAL: Vd, _de265_get_highest_TID: $d, _de265_free_decoder: Qd, _de265_set_limit_TID: be, _de265_get_image_plane: oe, _de265_get_parameter_bool: he, _de265_get_version: Ld, _de265_change_framerate: de, _de265_get_image_width: ke, _de265_set_parameter_int: ge, _de265_get_current_TID: ae, _memset: dv, _de265_isOK: Od, _de265_push_end_of_frame: Wd, _memcpy: cv, _de265_set_framerate_ratio: ce, _de265_get_bits_per_pixel: me, _de265_get_chroma_format: ne, _de265_get_image_user_data: re, _de265_get_version_number: Md, _de265_get_image_PTS: qe, _de265_get_number_of_input_bytes_pending: ie, _de265_flush_data: Sd, _realloc: Iu, _de265_new_decoder: Pd, _de265_get_number_of_NAL_units_pending: je, _de265_get_next_picture: Yd, _de265_peek_next_picture: Zd, _de265_decode: Td, _de265_set_parameter_bool: fe, _de265_push_NAL: Ud, _free: Hu, _memmove: fv, __GLOBAL__I_a: Rl, _de265_set_verbosity: Xk, _de265_get_image_height: le, _de265_reset: Xd, _malloc: Gu, _emscripten_replace_memory: gv, _de265_get_warning: ee, _de265_push_data: Rd, _de265_set_image_user_data: se, runPostSets: ld, stackAlloc: Xc, stackSave: Yc, stackRestore: Zc, setThrew: _c, setTempRet0: bd, setTempRet1: cd, setTempRet2: dd, setTempRet3: ed, setTempRet4: fd, setTempRet5: gd, setTempRet6: hd, setTempRet7: id, setTempRet8: jd, setTempRet9: kd, dynCall_viiiii: wv, dynCall_vi: xv, dynCall_vii: yv, dynCall_ii: zv, dynCall_iiiiii: Av, dynCall_iiii: Bv, dynCall_viiiiid: Cv, dynCall_viiiiiiii: Dv, dynCall_viiiiii: Ev, dynCall_viiiiiiiiiiiii: Fv, dynCall_viiiiiii: Gv, dynCall_viiiiiid: Hv, dynCall_viiiiiiiii: Iv, dynCall_viiiiiiiiii: Jv, dynCall_iii: Kv, dynCall_viiiiiiiiiiii: Lv, dynCall_iiiii: Mv, dynCall_viii: Nv, dynCall_v: Ov, dynCall_iiiiiiiii: Pv, dynCall_viiii: Qv }
    })


    // EMSCRIPTEN_END_ASM
    ({ "Math": Math, "Int8Array": Int8Array, "Int16Array": Int16Array, "Int32Array": Int32Array, "Uint8Array": Uint8Array, "Uint16Array": Uint16Array, "Uint32Array": Uint32Array, "Float32Array": Float32Array, "Float64Array": Float64Array }, { "abort": abort, "assert": assert, "asmPrintInt": asmPrintInt, "asmPrintFloat": asmPrintFloat, "min": Math_min, "invoke_viiiii": invoke_viiiii, "invoke_vi": invoke_vi, "invoke_vii": invoke_vii, "invoke_ii": invoke_ii, "invoke_iiiiii": invoke_iiiiii, "invoke_iiii": invoke_iiii, "invoke_viiiiid": invoke_viiiiid, "invoke_viiiiiiii": invoke_viiiiiiii, "invoke_viiiiii": invoke_viiiiii, "invoke_viiiiiiiiiiiii": invoke_viiiiiiiiiiiii, "invoke_viiiiiii": invoke_viiiiiii, "invoke_viiiiiid": invoke_viiiiiid, "invoke_viiiiiiiii": invoke_viiiiiiiii, "invoke_viiiiiiiiii": invoke_viiiiiiiiii, "invoke_iii": invoke_iii, "invoke_viiiiiiiiiiii": invoke_viiiiiiiiiiii, "invoke_iiiii": invoke_iiiii, "invoke_viii": invoke_viii, "invoke_v": invoke_v, "invoke_iiiiiiiii": invoke_iiiiiiiii, "invoke_viiii": invoke_viiii, "_llvm_lifetime_end": _llvm_lifetime_end, "__scanString": __scanString, "_pthread_mutex_lock": _pthread_mutex_lock, "___cxa_end_catch": ___cxa_end_catch, "_strtoull": _strtoull, "_fflush": _fflush, "__isLeapYear": __isLeapYear, "_fwrite": _fwrite, "_send": _send, "_pthread_mutex_init": _pthread_mutex_init, "_llvm_umul_with_overflow_i32": _llvm_umul_with_overflow_i32, "_isspace": _isspace, "_read": _read, "_isxdigit_l": _isxdigit_l, "_fileno": _fileno, "___cxa_guard_abort": ___cxa_guard_abort, "_newlocale": _newlocale, "___gxx_personality_v0": ___gxx_personality_v0, "_pthread_cond_wait": _pthread_cond_wait, "___cxa_rethrow": ___cxa_rethrow, "_fmod": _fmod, "___resumeException": ___resumeException, "_llvm_va_end": _llvm_va_end, "_vsscanf": _vsscanf, "_snprintf": _snprintf, "_fgetc": _fgetc, "__getFloat": __getFloat, "_pthread_cond_signal": _pthread_cond_signal, "___cxa_free_exception": ___cxa_free_exception, "_isdigit_l": _isdigit_l, "___setErrNo": ___setErrNo, "_isxdigit": _isxdigit, "_exit": _exit, "_sprintf": _sprintf, "_asprintf": _asprintf, "___ctype_b_loc": ___ctype_b_loc, "_freelocale": _freelocale, "_catgets": _catgets, "___cxa_is_number_type": ___cxa_is_number_type, "_llvm_uadd_with_overflow_i32": _llvm_uadd_with_overflow_i32, "___cxa_does_inherit": ___cxa_does_inherit, "___cxa_guard_acquire": ___cxa_guard_acquire, "___cxa_begin_catch": ___cxa_begin_catch, "_emscripten_memcpy_big": _emscripten_memcpy_big, "_recv": _recv, "__parseInt64": __parseInt64, "__ZSt18uncaught_exceptionv": __ZSt18uncaught_exceptionv, "__ZNSt9exceptionD2Ev": __ZNSt9exceptionD2Ev, "_mkport": _mkport, "_copysign": _copysign, "__exit": __exit, "_strftime": _strftime, "___cxa_throw": ___cxa_throw, "_printf": _printf, "_pread": _pread, "_strtoull_l": _strtoull_l, "__arraySum": __arraySum, "_sysconf": _sysconf, "_strtoll_l": _strtoll_l, "___cxa_find_matching_catch": ___cxa_find_matching_catch, "__formatString": __formatString, "_pthread_cond_broadcast": _pthread_cond_broadcast, "__ZSt9terminatev": __ZSt9terminatev, "_vfprintf": _vfprintf, "_pthread_mutex_unlock": _pthread_mutex_unlock, "___cxa_call_unexpected": ___cxa_call_unexpected, "_sbrk": _sbrk, "_atexit": _atexit, "___errno_location": ___errno_location, "_strerror": _strerror, "_pthread_mutex_destroy": _pthread_mutex_destroy, "_catclose": _catclose, "_llvm_lifetime_start": _llvm_lifetime_start, "___cxa_guard_release": ___cxa_guard_release, "_ungetc": _ungetc, "_pthread_cond_destroy": _pthread_cond_destroy, "_uselocale": _uselocale, "_vsnprintf": _vsnprintf, "_sscanf": _sscanf, "___assert_fail": ___assert_fail, "_fread": _fread, "_strftime_l": _strftime_l, "_abort": _abort, "_fprintf": _fprintf, "_isdigit": _isdigit, "_strtoll": _strtoll, "__addDays": __addDays, "_fabs": _fabs, "__reallyNegative": __reallyNegative, "_write": _write, "___cxa_allocate_exception": ___cxa_allocate_exception, "___cxa_pure_virtual": ___cxa_pure_virtual, "_vasprintf": _vasprintf, "_catopen": _catopen, "___ctype_toupper_loc": ___ctype_toupper_loc, "___ctype_tolower_loc": ___ctype_tolower_loc, "_pthread_join": _pthread_join, "_pthread_cond_init": _pthread_cond_init, "_pwrite": _pwrite, "_strerror_r": _strerror_r, "_pthread_create": _pthread_create, "_time": _time, "STACKTOP": STACKTOP, "STACK_MAX": STACK_MAX, "tempDoublePtr": tempDoublePtr, "ABORT": ABORT, "cttz_i8": cttz_i8, "ctlz_i8": ctlz_i8, "NaN": NaN, "Infinity": Infinity, "_stdin": _stdin, "__ZTVN10__cxxabiv117__class_type_infoE": __ZTVN10__cxxabiv117__class_type_infoE, "_stderr": _stderr, "__ZTISt9exception": __ZTISt9exception, "__ZTVN10__cxxabiv120__si_class_type_infoE": __ZTVN10__cxxabiv120__si_class_type_infoE, "_stdout": _stdout, "___dso_handle": ___dso_handle }, buffer);
    var _de265_get_error_text = Module["_de265_get_error_text"] = asm["_de265_get_error_text"];
    var _strlen = Module["_strlen"] = asm["_strlen"];
    var _de265_get_image_plane_user_data = Module["_de265_get_image_plane_user_data"] = asm["_de265_get_image_plane_user_data"];
    var _de265_release_next_picture = Module["_de265_release_next_picture"] = asm["_de265_release_next_picture"];
    var _de265_push_end_of_NAL = Module["_de265_push_end_of_NAL"] = asm["_de265_push_end_of_NAL"];
    var _de265_get_highest_TID = Module["_de265_get_highest_TID"] = asm["_de265_get_highest_TID"];
    var _de265_free_decoder = Module["_de265_free_decoder"] = asm["_de265_free_decoder"];
    var _de265_set_limit_TID = Module["_de265_set_limit_TID"] = asm["_de265_set_limit_TID"];
    var _de265_get_image_plane = Module["_de265_get_image_plane"] = asm["_de265_get_image_plane"];
    var _de265_get_parameter_bool = Module["_de265_get_parameter_bool"] = asm["_de265_get_parameter_bool"];
    var _de265_get_version = Module["_de265_get_version"] = asm["_de265_get_version"];
    var _de265_change_framerate = Module["_de265_change_framerate"] = asm["_de265_change_framerate"];
    var _de265_get_image_width = Module["_de265_get_image_width"] = asm["_de265_get_image_width"];
    var _de265_set_parameter_int = Module["_de265_set_parameter_int"] = asm["_de265_set_parameter_int"];
    var _de265_get_current_TID = Module["_de265_get_current_TID"] = asm["_de265_get_current_TID"];
    var _memset = Module["_memset"] = asm["_memset"];
    var _de265_isOK = Module["_de265_isOK"] = asm["_de265_isOK"];
    var _de265_push_end_of_frame = Module["_de265_push_end_of_frame"] = asm["_de265_push_end_of_frame"];
    var _memcpy = Module["_memcpy"] = asm["_memcpy"];
    var _de265_set_framerate_ratio = Module["_de265_set_framerate_ratio"] = asm["_de265_set_framerate_ratio"];
    var _de265_get_bits_per_pixel = Module["_de265_get_bits_per_pixel"] = asm["_de265_get_bits_per_pixel"];
    var _de265_get_chroma_format = Module["_de265_get_chroma_format"] = asm["_de265_get_chroma_format"];
    var _de265_get_image_user_data = Module["_de265_get_image_user_data"] = asm["_de265_get_image_user_data"];
    var _de265_get_version_number = Module["_de265_get_version_number"] = asm["_de265_get_version_number"];
    var _de265_get_image_PTS = Module["_de265_get_image_PTS"] = asm["_de265_get_image_PTS"];
    var _de265_get_number_of_input_bytes_pending = Module["_de265_get_number_of_input_bytes_pending"] = asm["_de265_get_number_of_input_bytes_pending"];
    var _de265_flush_data = Module["_de265_flush_data"] = asm["_de265_flush_data"];
    var _realloc = Module["_realloc"] = asm["_realloc"];
    var _de265_new_decoder = Module["_de265_new_decoder"] = asm["_de265_new_decoder"];
    var _de265_get_number_of_NAL_units_pending = Module["_de265_get_number_of_NAL_units_pending"] = asm["_de265_get_number_of_NAL_units_pending"];
    var _de265_get_next_picture = Module["_de265_get_next_picture"] = asm["_de265_get_next_picture"];
    var _de265_peek_next_picture = Module["_de265_peek_next_picture"] = asm["_de265_peek_next_picture"];
    var _de265_decode = Module["_de265_decode"] = asm["_de265_decode"];
    var _de265_set_parameter_bool = Module["_de265_set_parameter_bool"] = asm["_de265_set_parameter_bool"];
    var _de265_push_NAL = Module["_de265_push_NAL"] = asm["_de265_push_NAL"];
    var _free = Module["_free"] = asm["_free"];
    var _memmove = Module["_memmove"] = asm["_memmove"];
    var __GLOBAL__I_a = Module["__GLOBAL__I_a"] = asm["__GLOBAL__I_a"];
    var _de265_set_verbosity = Module["_de265_set_verbosity"] = asm["_de265_set_verbosity"];
    var _de265_get_image_height = Module["_de265_get_image_height"] = asm["_de265_get_image_height"];
    var _de265_reset = Module["_de265_reset"] = asm["_de265_reset"];
    var _malloc = Module["_malloc"] = asm["_malloc"];
    var _emscripten_replace_memory = Module["_emscripten_replace_memory"] = asm["_emscripten_replace_memory"];
    var _de265_get_warning = Module["_de265_get_warning"] = asm["_de265_get_warning"];
    var _de265_push_data = Module["_de265_push_data"] = asm["_de265_push_data"];
    var _de265_set_image_user_data = Module["_de265_set_image_user_data"] = asm["_de265_set_image_user_data"];
    var runPostSets = Module["runPostSets"] = asm["runPostSets"];
    var dynCall_viiiii = Module["dynCall_viiiii"] = asm["dynCall_viiiii"];
    var dynCall_vi = Module["dynCall_vi"] = asm["dynCall_vi"];
    var dynCall_vii = Module["dynCall_vii"] = asm["dynCall_vii"];
    var dynCall_ii = Module["dynCall_ii"] = asm["dynCall_ii"];
    var dynCall_iiiiii = Module["dynCall_iiiiii"] = asm["dynCall_iiiiii"];
    var dynCall_iiii = Module["dynCall_iiii"] = asm["dynCall_iiii"];
    var dynCall_viiiiid = Module["dynCall_viiiiid"] = asm["dynCall_viiiiid"];
    var dynCall_viiiiiiii = Module["dynCall_viiiiiiii"] = asm["dynCall_viiiiiiii"];
    var dynCall_viiiiii = Module["dynCall_viiiiii"] = asm["dynCall_viiiiii"];
    var dynCall_viiiiiiiiiiiii = Module["dynCall_viiiiiiiiiiiii"] = asm["dynCall_viiiiiiiiiiiii"];
    var dynCall_viiiiiii = Module["dynCall_viiiiiii"] = asm["dynCall_viiiiiii"];
    var dynCall_viiiiiid = Module["dynCall_viiiiiid"] = asm["dynCall_viiiiiid"];
    var dynCall_viiiiiiiii = Module["dynCall_viiiiiiiii"] = asm["dynCall_viiiiiiiii"];
    var dynCall_viiiiiiiiii = Module["dynCall_viiiiiiiiii"] = asm["dynCall_viiiiiiiiii"];
    var dynCall_iii = Module["dynCall_iii"] = asm["dynCall_iii"];
    var dynCall_viiiiiiiiiiii = Module["dynCall_viiiiiiiiiiii"] = asm["dynCall_viiiiiiiiiiii"];
    var dynCall_iiiii = Module["dynCall_iiiii"] = asm["dynCall_iiiii"];
    var dynCall_viii = Module["dynCall_viii"] = asm["dynCall_viii"];
    var dynCall_v = Module["dynCall_v"] = asm["dynCall_v"];
    var dynCall_iiiiiiiii = Module["dynCall_iiiiiiiii"] = asm["dynCall_iiiiiiiii"];
    var dynCall_viiii = Module["dynCall_viiii"] = asm["dynCall_viiii"];

    Runtime.stackAlloc = function(size) { return asm['stackAlloc'](size) };
    Runtime.stackSave = function() { return asm['stackSave']() };
    Runtime.stackRestore = function(top) { asm['stackRestore'](top) };

    // TODO: strip out parts of this we do not need

    //======= begin closure i64 code =======

    // Copyright 2009 The Closure Library Authors. All Rights Reserved.
    //
    // Licensed under the Apache License, Version 2.0 (the "License");
    // you may not use this file except in compliance with the License.
    // You may obtain a copy of the License at
    //
    //      http://www.apache.org/licenses/LICENSE-2.0
    //
    // Unless required by applicable law or agreed to in writing, software
    // distributed under the License is distributed on an "AS-IS" BASIS,
    // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    // See the License for the specific language governing permissions and
    // limitations under the License.

    /**
     * @fileoverview Defines a Long class for representing a 64-bit two's-complement
     * integer value, which faithfully simulates the behavior of a Java "long". This
     * implementation is derived from LongLib in GWT.
     *
     */

    var i64Math = (function() { // Emscripten wrapper
        var goog = { math: {} };


        /**
         * Constructs a 64-bit two's-complement integer, given its low and high 32-bit
         * values as *signed* integers.  See the from* functions below for more
         * convenient ways of constructing Longs.
         *
         * The internal representation of a long is the two given signed, 32-bit values.
         * We use 32-bit pieces because these are the size of integers on which
         * Javascript performs bit-operations.  For operations like addition and
         * multiplication, we split each number into 16-bit pieces, which can easily be
         * multiplied within Javascript's floating-point representation without overflow
         * or change in sign.
         *
         * In the algorithms below, we frequently reduce the negative case to the
         * positive case by negating the input(s) and then post-processing the result.
         * Note that we must ALWAYS check specially whether those values are MIN_VALUE
         * (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
         * a positive number, it overflows back into a negative).  Not handling this
         * case would often result in infinite recursion.
         *
         * @param {number} low  The low (signed) 32 bits of the long.
         * @param {number} high  The high (signed) 32 bits of the long.
         * @constructor
         */
        goog.math.Long = function(low, high) {
            /**
             * @type {number}
             * @private
             */
            this.low_ = low | 0; // force into 32 signed bits.

            /**
             * @type {number}
             * @private
             */
            this.high_ = high | 0; // force into 32 signed bits.
        };


        // NOTE: Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the
        // from* methods on which they depend.


        /**
         * A cache of the Long representations of small integer values.
         * @type {!Object}
         * @private
         */
        goog.math.Long.IntCache_ = {};


        /**
         * Returns a Long representing the given (32-bit) integer value.
         * @param {number} value The 32-bit integer in question.
         * @return {!goog.math.Long} The corresponding Long value.
         */
        goog.math.Long.fromInt = function(value) {
            if (-128 <= value && value < 128) {
                var cachedObj = goog.math.Long.IntCache_[value];
                if (cachedObj) {
                    return cachedObj;
                }
            }

            var obj = new goog.math.Long(value | 0, value < 0 ? -1 : 0);
            if (-128 <= value && value < 128) {
                goog.math.Long.IntCache_[value] = obj;
            }
            return obj;
        };


        /**
         * Returns a Long representing the given value, provided that it is a finite
         * number.  Otherwise, zero is returned.
         * @param {number} value The number in question.
         * @return {!goog.math.Long} The corresponding Long value.
         */
        goog.math.Long.fromNumber = function(value) {
            if (isNaN(value) || !isFinite(value)) {
                return goog.math.Long.ZERO;
            } else if (value <= -goog.math.Long.TWO_PWR_63_DBL_) {
                return goog.math.Long.MIN_VALUE;
            } else if (value + 1 >= goog.math.Long.TWO_PWR_63_DBL_) {
                return goog.math.Long.MAX_VALUE;
            } else if (value < 0) {
                return goog.math.Long.fromNumber(-value).negate();
            } else {
                return new goog.math.Long(
                    (value % goog.math.Long.TWO_PWR_32_DBL_) | 0,
                    (value / goog.math.Long.TWO_PWR_32_DBL_) | 0);
            }
        };


        /**
         * Returns a Long representing the 64-bit integer that comes by concatenating
         * the given high and low bits.  Each is assumed to use 32 bits.
         * @param {number} lowBits The low 32-bits.
         * @param {number} highBits The high 32-bits.
         * @return {!goog.math.Long} The corresponding Long value.
         */
        goog.math.Long.fromBits = function(lowBits, highBits) {
            return new goog.math.Long(lowBits, highBits);
        };


        /**
         * Returns a Long representation of the given string, written using the given
         * radix.
         * @param {string} str The textual representation of the Long.
         * @param {number=} opt_radix The radix in which the text is written.
         * @return {!goog.math.Long} The corresponding Long value.
         */
        goog.math.Long.fromString = function(str, opt_radix) {
            if (str.length == 0) {
                throw Error('number format error: empty string');
            }

            var radix = opt_radix || 10;
            if (radix < 2 || 36 < radix) {
                throw Error('radix out of range: ' + radix);
            }

            if (str.charAt(0) == '-') {
                return goog.math.Long.fromString(str.substring(1), radix).negate();
            } else if (str.indexOf('-') >= 0) {
                throw Error('number format error: interior "-" character: ' + str);
            }

            // Do several (8) digits each time through the loop, so as to
            // minimize the calls to the very expensive emulated div.
            var radixToPower = goog.math.Long.fromNumber(Math.pow(radix, 8));

            var result = goog.math.Long.ZERO;
            for (var i = 0; i < str.length; i += 8) {
                var size = Math.min(8, str.length - i);
                var value = parseInt(str.substring(i, i + size), radix);
                if (size < 8) {
                    var power = goog.math.Long.fromNumber(Math.pow(radix, size));
                    result = result.multiply(power).add(goog.math.Long.fromNumber(value));
                } else {
                    result = result.multiply(radixToPower);
                    result = result.add(goog.math.Long.fromNumber(value));
                }
            }
            return result;
        };


        // NOTE: the compiler should inline these constant values below and then remove
        // these variables, so there should be no runtime penalty for these.


        /**
         * Number used repeated below in calculations.  This must appear before the
         * first call to any from* function below.
         * @type {number}
         * @private
         */
        goog.math.Long.TWO_PWR_16_DBL_ = 1 << 16;


        /**
         * @type {number}
         * @private
         */
        goog.math.Long.TWO_PWR_24_DBL_ = 1 << 24;


        /**
         * @type {number}
         * @private
         */
        goog.math.Long.TWO_PWR_32_DBL_ =
            goog.math.Long.TWO_PWR_16_DBL_ * goog.math.Long.TWO_PWR_16_DBL_;


        /**
         * @type {number}
         * @private
         */
        goog.math.Long.TWO_PWR_31_DBL_ =
            goog.math.Long.TWO_PWR_32_DBL_ / 2;


        /**
         * @type {number}
         * @private
         */
        goog.math.Long.TWO_PWR_48_DBL_ =
            goog.math.Long.TWO_PWR_32_DBL_ * goog.math.Long.TWO_PWR_16_DBL_;


        /**
         * @type {number}
         * @private
         */
        goog.math.Long.TWO_PWR_64_DBL_ =
            goog.math.Long.TWO_PWR_32_DBL_ * goog.math.Long.TWO_PWR_32_DBL_;


        /**
         * @type {number}
         * @private
         */
        goog.math.Long.TWO_PWR_63_DBL_ =
            goog.math.Long.TWO_PWR_64_DBL_ / 2;


        /** @type {!goog.math.Long} */
        goog.math.Long.ZERO = goog.math.Long.fromInt(0);


        /** @type {!goog.math.Long} */
        goog.math.Long.ONE = goog.math.Long.fromInt(1);


        /** @type {!goog.math.Long} */
        goog.math.Long.NEG_ONE = goog.math.Long.fromInt(-1);


        /** @type {!goog.math.Long} */
        goog.math.Long.MAX_VALUE =
            goog.math.Long.fromBits(0xFFFFFFFF | 0, 0x7FFFFFFF | 0);


        /** @type {!goog.math.Long} */
        goog.math.Long.MIN_VALUE = goog.math.Long.fromBits(0, 0x80000000 | 0);


        /**
         * @type {!goog.math.Long}
         * @private
         */
        goog.math.Long.TWO_PWR_24_ = goog.math.Long.fromInt(1 << 24);


        /** @return {number} The value, assuming it is a 32-bit integer. */
        goog.math.Long.prototype.toInt = function() {
            return this.low_;
        };


        /** @return {number} The closest floating-point representation to this value. */
        goog.math.Long.prototype.toNumber = function() {
            return this.high_ * goog.math.Long.TWO_PWR_32_DBL_ +
                this.getLowBitsUnsigned();
        };


        /**
         * @param {number=} opt_radix The radix in which the text should be written.
         * @return {string} The textual representation of this value.
         */
        goog.math.Long.prototype.toString = function(opt_radix) {
            var radix = opt_radix || 10;
            if (radix < 2 || 36 < radix) {
                throw Error('radix out of range: ' + radix);
            }

            if (this.isZero()) {
                return '0';
            }

            if (this.isNegative()) {
                if (this.equals(goog.math.Long.MIN_VALUE)) {
                    // We need to change the Long value before it can be negated, so we remove
                    // the bottom-most digit in this base and then recurse to do the rest.
                    var radixLong = goog.math.Long.fromNumber(radix);
                    var div = this.div(radixLong);
                    var rem = div.multiply(radixLong).subtract(this);
                    return div.toString(radix) + rem.toInt().toString(radix);
                } else {
                    return '-' + this.negate().toString(radix);
                }
            }

            // Do several (6) digits each time through the loop, so as to
            // minimize the calls to the very expensive emulated div.
            var radixToPower = goog.math.Long.fromNumber(Math.pow(radix, 6));

            var rem = this;
            var result = '';
            while (true) {
                var remDiv = rem.div(radixToPower);
                var intval = rem.subtract(remDiv.multiply(radixToPower)).toInt();
                var digits = intval.toString(radix);

                rem = remDiv;
                if (rem.isZero()) {
                    return digits + result;
                } else {
                    while (digits.length < 6) {
                        digits = '0' + digits;
                    }
                    result = '' + digits + result;
                }
            }
        };


        /** @return {number} The high 32-bits as a signed value. */
        goog.math.Long.prototype.getHighBits = function() {
            return this.high_;
        };


        /** @return {number} The low 32-bits as a signed value. */
        goog.math.Long.prototype.getLowBits = function() {
            return this.low_;
        };


        /** @return {number} The low 32-bits as an unsigned value. */
        goog.math.Long.prototype.getLowBitsUnsigned = function() {
            return (this.low_ >= 0) ?
                this.low_ : goog.math.Long.TWO_PWR_32_DBL_ + this.low_;
        };


        /**
         * @return {number} Returns the number of bits needed to represent the absolute
         *     value of this Long.
         */
        goog.math.Long.prototype.getNumBitsAbs = function() {
            if (this.isNegative()) {
                if (this.equals(goog.math.Long.MIN_VALUE)) {
                    return 64;
                } else {
                    return this.negate().getNumBitsAbs();
                }
            } else {
                var val = this.high_ != 0 ? this.high_ : this.low_;
                for (var bit = 31; bit > 0; bit--) {
                    if ((val & (1 << bit)) != 0) {
                        break;
                    }
                }
                return this.high_ != 0 ? bit + 33 : bit + 1;
            }
        };


        /** @return {boolean} Whether this value is zero. */
        goog.math.Long.prototype.isZero = function() {
            return this.high_ == 0 && this.low_ == 0;
        };


        /** @return {boolean} Whether this value is negative. */
        goog.math.Long.prototype.isNegative = function() {
            return this.high_ < 0;
        };


        /** @return {boolean} Whether this value is odd. */
        goog.math.Long.prototype.isOdd = function() {
            return (this.low_ & 1) == 1;
        };


        /**
         * @param {goog.math.Long} other Long to compare against.
         * @return {boolean} Whether this Long equals the other.
         */
        goog.math.Long.prototype.equals = function(other) {
            return (this.high_ == other.high_) && (this.low_ == other.low_);
        };


        /**
         * @param {goog.math.Long} other Long to compare against.
         * @return {boolean} Whether this Long does not equal the other.
         */
        goog.math.Long.prototype.notEquals = function(other) {
            return (this.high_ != other.high_) || (this.low_ != other.low_);
        };


        /**
         * @param {goog.math.Long} other Long to compare against.
         * @return {boolean} Whether this Long is less than the other.
         */
        goog.math.Long.prototype.lessThan = function(other) {
            return this.compare(other) < 0;
        };


        /**
         * @param {goog.math.Long} other Long to compare against.
         * @return {boolean} Whether this Long is less than or equal to the other.
         */
        goog.math.Long.prototype.lessThanOrEqual = function(other) {
            return this.compare(other) <= 0;
        };


        /**
         * @param {goog.math.Long} other Long to compare against.
         * @return {boolean} Whether this Long is greater than the other.
         */
        goog.math.Long.prototype.greaterThan = function(other) {
            return this.compare(other) > 0;
        };


        /**
         * @param {goog.math.Long} other Long to compare against.
         * @return {boolean} Whether this Long is greater than or equal to the other.
         */
        goog.math.Long.prototype.greaterThanOrEqual = function(other) {
            return this.compare(other) >= 0;
        };


        /**
         * Compares this Long with the given one.
         * @param {goog.math.Long} other Long to compare against.
         * @return {number} 0 if they are the same, 1 if the this is greater, and -1
         *     if the given one is greater.
         */
        goog.math.Long.prototype.compare = function(other) {
            if (this.equals(other)) {
                return 0;
            }

            var thisNeg = this.isNegative();
            var otherNeg = other.isNegative();
            if (thisNeg && !otherNeg) {
                return -1;
            }
            if (!thisNeg && otherNeg) {
                return 1;
            }

            // at this point, the signs are the same, so subtraction will not overflow
            if (this.subtract(other).isNegative()) {
                return -1;
            } else {
                return 1;
            }
        };


        /** @return {!goog.math.Long} The negation of this value. */
        goog.math.Long.prototype.negate = function() {
            if (this.equals(goog.math.Long.MIN_VALUE)) {
                return goog.math.Long.MIN_VALUE;
            } else {
                return this.not().add(goog.math.Long.ONE);
            }
        };


        /**
         * Returns the sum of this and the given Long.
         * @param {goog.math.Long} other Long to add to this one.
         * @return {!goog.math.Long} The sum of this and the given Long.
         */
        goog.math.Long.prototype.add = function(other) {
            // Divide each number into 4 chunks of 16 bits, and then sum the chunks.

            var a48 = this.high_ >>> 16;
            var a32 = this.high_ & 0xFFFF;
            var a16 = this.low_ >>> 16;
            var a00 = this.low_ & 0xFFFF;

            var b48 = other.high_ >>> 16;
            var b32 = other.high_ & 0xFFFF;
            var b16 = other.low_ >>> 16;
            var b00 = other.low_ & 0xFFFF;

            var c48 = 0,
                c32 = 0,
                c16 = 0,
                c00 = 0;
            c00 += a00 + b00;
            c16 += c00 >>> 16;
            c00 &= 0xFFFF;
            c16 += a16 + b16;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c32 += a32 + b32;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c48 += a48 + b48;
            c48 &= 0xFFFF;
            return goog.math.Long.fromBits((c16 << 16) | c00, (c48 << 16) | c32);
        };


        /**
         * Returns the difference of this and the given Long.
         * @param {goog.math.Long} other Long to subtract from this.
         * @return {!goog.math.Long} The difference of this and the given Long.
         */
        goog.math.Long.prototype.subtract = function(other) {
            return this.add(other.negate());
        };


        /**
         * Returns the product of this and the given long.
         * @param {goog.math.Long} other Long to multiply with this.
         * @return {!goog.math.Long} The product of this and the other.
         */
        goog.math.Long.prototype.multiply = function(other) {
            if (this.isZero()) {
                return goog.math.Long.ZERO;
            } else if (other.isZero()) {
                return goog.math.Long.ZERO;
            }

            if (this.equals(goog.math.Long.MIN_VALUE)) {
                return other.isOdd() ? goog.math.Long.MIN_VALUE : goog.math.Long.ZERO;
            } else if (other.equals(goog.math.Long.MIN_VALUE)) {
                return this.isOdd() ? goog.math.Long.MIN_VALUE : goog.math.Long.ZERO;
            }

            if (this.isNegative()) {
                if (other.isNegative()) {
                    return this.negate().multiply(other.negate());
                } else {
                    return this.negate().multiply(other).negate();
                }
            } else if (other.isNegative()) {
                return this.multiply(other.negate()).negate();
            }

            // If both longs are small, use float multiplication
            if (this.lessThan(goog.math.Long.TWO_PWR_24_) &&
                other.lessThan(goog.math.Long.TWO_PWR_24_)) {
                return goog.math.Long.fromNumber(this.toNumber() * other.toNumber());
            }

            // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
            // We can skip products that would overflow.

            var a48 = this.high_ >>> 16;
            var a32 = this.high_ & 0xFFFF;
            var a16 = this.low_ >>> 16;
            var a00 = this.low_ & 0xFFFF;

            var b48 = other.high_ >>> 16;
            var b32 = other.high_ & 0xFFFF;
            var b16 = other.low_ >>> 16;
            var b00 = other.low_ & 0xFFFF;

            var c48 = 0,
                c32 = 0,
                c16 = 0,
                c00 = 0;
            c00 += a00 * b00;
            c16 += c00 >>> 16;
            c00 &= 0xFFFF;
            c16 += a16 * b00;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c16 += a00 * b16;
            c32 += c16 >>> 16;
            c16 &= 0xFFFF;
            c32 += a32 * b00;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c32 += a16 * b16;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c32 += a00 * b32;
            c48 += c32 >>> 16;
            c32 &= 0xFFFF;
            c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
            c48 &= 0xFFFF;
            return goog.math.Long.fromBits((c16 << 16) | c00, (c48 << 16) | c32);
        };


        /**
         * Returns this Long divided by the given one.
         * @param {goog.math.Long} other Long by which to divide.
         * @return {!goog.math.Long} This Long divided by the given one.
         */
        goog.math.Long.prototype.div = function(other) {
            if (other.isZero()) {
                throw Error('division by zero');
            } else if (this.isZero()) {
                return goog.math.Long.ZERO;
            }

            if (this.equals(goog.math.Long.MIN_VALUE)) {
                if (other.equals(goog.math.Long.ONE) ||
                    other.equals(goog.math.Long.NEG_ONE)) {
                    return goog.math.Long.MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
                } else if (other.equals(goog.math.Long.MIN_VALUE)) {
                    return goog.math.Long.ONE;
                } else {
                    // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                    var halfThis = this.shiftRight(1);
                    var approx = halfThis.div(other).shiftLeft(1);
                    if (approx.equals(goog.math.Long.ZERO)) {
                        return other.isNegative() ? goog.math.Long.ONE : goog.math.Long.NEG_ONE;
                    } else {
                        var rem = this.subtract(other.multiply(approx));
                        var result = approx.add(rem.div(other));
                        return result;
                    }
                }
            } else if (other.equals(goog.math.Long.MIN_VALUE)) {
                return goog.math.Long.ZERO;
            }

            if (this.isNegative()) {
                if (other.isNegative()) {
                    return this.negate().div(other.negate());
                } else {
                    return this.negate().div(other).negate();
                }
            } else if (other.isNegative()) {
                return this.div(other.negate()).negate();
            }

            // Repeat the following until the remainder is less than other:  find a
            // floating-point that approximates remainder / other *from below*, add this
            // into the result, and subtract it from the remainder.  It is critical that
            // the approximate value is less than or equal to the real value so that the
            // remainder never becomes negative.
            var res = goog.math.Long.ZERO;
            var rem = this;
            while (rem.greaterThanOrEqual(other)) {
                // Approximate the result of division. This may be a little greater or
                // smaller than the actual value.
                var approx = Math.max(1, Math.floor(rem.toNumber() / other.toNumber()));

                // We will tweak the approximate result by changing it in the 48-th digit or
                // the smallest non-fractional digit, whichever is larger.
                var log2 = Math.ceil(Math.log(approx) / Math.LN2);
                var delta = (log2 <= 48) ? 1 : Math.pow(2, log2 - 48);

                // Decrease the approximation until it is smaller than the remainder.  Note
                // that if it is too large, the product overflows and is negative.
                var approxRes = goog.math.Long.fromNumber(approx);
                var approxRem = approxRes.multiply(other);
                while (approxRem.isNegative() || approxRem.greaterThan(rem)) {
                    approx -= delta;
                    approxRes = goog.math.Long.fromNumber(approx);
                    approxRem = approxRes.multiply(other);
                }

                // We know the answer can't be zero... and actually, zero would cause
                // infinite recursion since we would make no progress.
                if (approxRes.isZero()) {
                    approxRes = goog.math.Long.ONE;
                }

                res = res.add(approxRes);
                rem = rem.subtract(approxRem);
            }
            return res;
        };


        /**
         * Returns this Long modulo the given one.
         * @param {goog.math.Long} other Long by which to mod.
         * @return {!goog.math.Long} This Long modulo the given one.
         */
        goog.math.Long.prototype.modulo = function(other) {
            return this.subtract(this.div(other).multiply(other));
        };


        /** @return {!goog.math.Long} The bitwise-NOT of this value. */
        goog.math.Long.prototype.not = function() {
            return goog.math.Long.fromBits(~this.low_, ~this.high_);
        };


        /**
         * Returns the bitwise-AND of this Long and the given one.
         * @param {goog.math.Long} other The Long with which to AND.
         * @return {!goog.math.Long} The bitwise-AND of this and the other.
         */
        goog.math.Long.prototype.and = function(other) {
            return goog.math.Long.fromBits(this.low_ & other.low_,
                this.high_ & other.high_);
        };


        /**
         * Returns the bitwise-OR of this Long and the given one.
         * @param {goog.math.Long} other The Long with which to OR.
         * @return {!goog.math.Long} The bitwise-OR of this and the other.
         */
        goog.math.Long.prototype.or = function(other) {
            return goog.math.Long.fromBits(this.low_ | other.low_,
                this.high_ | other.high_);
        };


        /**
         * Returns the bitwise-XOR of this Long and the given one.
         * @param {goog.math.Long} other The Long with which to XOR.
         * @return {!goog.math.Long} The bitwise-XOR of this and the other.
         */
        goog.math.Long.prototype.xor = function(other) {
            return goog.math.Long.fromBits(this.low_ ^ other.low_,
                this.high_ ^ other.high_);
        };


        /**
         * Returns this Long with bits shifted to the left by the given amount.
         * @param {number} numBits The number of bits by which to shift.
         * @return {!goog.math.Long} This shifted to the left by the given amount.
         */
        goog.math.Long.prototype.shiftLeft = function(numBits) {
            numBits &= 63;
            if (numBits == 0) {
                return this;
            } else {
                var low = this.low_;
                if (numBits < 32) {
                    var high = this.high_;
                    return goog.math.Long.fromBits(
                        low << numBits,
                        (high << numBits) | (low >>> (32 - numBits)));
                } else {
                    return goog.math.Long.fromBits(0, low << (numBits - 32));
                }
            }
        };


        /**
         * Returns this Long with bits shifted to the right by the given amount.
         * @param {number} numBits The number of bits by which to shift.
         * @return {!goog.math.Long} This shifted to the right by the given amount.
         */
        goog.math.Long.prototype.shiftRight = function(numBits) {
            numBits &= 63;
            if (numBits == 0) {
                return this;
            } else {
                var high = this.high_;
                if (numBits < 32) {
                    var low = this.low_;
                    return goog.math.Long.fromBits(
                        (low >>> numBits) | (high << (32 - numBits)),
                        high >> numBits);
                } else {
                    return goog.math.Long.fromBits(
                        high >> (numBits - 32),
                        high >= 0 ? 0 : -1);
                }
            }
        };


        /**
         * Returns this Long with bits shifted to the right by the given amount, with
         * the new top bits matching the current sign bit.
         * @param {number} numBits The number of bits by which to shift.
         * @return {!goog.math.Long} This shifted to the right by the given amount, with
         *     zeros placed into the new leading bits.
         */
        goog.math.Long.prototype.shiftRightUnsigned = function(numBits) {
            numBits &= 63;
            if (numBits == 0) {
                return this;
            } else {
                var high = this.high_;
                if (numBits < 32) {
                    var low = this.low_;
                    return goog.math.Long.fromBits(
                        (low >>> numBits) | (high << (32 - numBits)),
                        high >>> numBits);
                } else if (numBits == 32) {
                    return goog.math.Long.fromBits(high, 0);
                } else {
                    return goog.math.Long.fromBits(high >>> (numBits - 32), 0);
                }
            }
        };

        //======= begin jsbn =======

        var navigator = { appName: 'Modern Browser' }; // polyfill a little

        // Copyright (c) 2005  Tom Wu
        // All Rights Reserved.
        // http://www-cs-students.stanford.edu/~tjw/jsbn/

        /*
         * Copyright (c) 2003-2005  Tom Wu
         * All Rights Reserved.
         *
         * Permission is hereby granted, free of charge, to any person obtaining
         * a copy of this software and associated documentation files (the
         * "Software"), to deal in the Software without restriction, including
         * without limitation the rights to use, copy, modify, merge, publish,
         * distribute, sublicense, and/or sell copies of the Software, and to
         * permit persons to whom the Software is furnished to do so, subject to
         * the following conditions:
         *
         * The above copyright notice and this permission notice shall be
         * included in all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
         * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
         * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
         *
         * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
         * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
         * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
         * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
         * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
         *
         * In addition, the following condition applies:
         *
         * All redistributions must retain an intact copy of this copyright notice
         * and disclaimer.
         */

        // Basic JavaScript BN library - subset useful for RSA encryption.

        // Bits per digit
        var dbits;

        // JavaScript engine analysis
        var canary = 0xdeadbeefcafe;
        var j_lm = ((canary & 0xffffff) == 0xefcafe);

        // (public) Constructor
        function BigInteger(a, b, c) {
            if (a != null)
                if ("number" == typeof a) this.fromNumber(a, b, c);
                else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }

        // return new, unset BigInteger
        function nbi() { return new BigInteger(null); }

        // am: Compute w_j += (x*this_i), propagate carries,
        // c is initial carry, returns final carry.
        // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
        // We need to select the fastest one that works in this environment.

        // am1: use a single mult and divide to get the high bits,
        // max digit bits should be 26 because
        // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
        function am1(i, x, w, j, c, n) {
            while (--n >= 0) {
                var v = x * this[i++] + w[j] + c;
                c = Math.floor(v / 0x4000000);
                w[j++] = v & 0x3ffffff;
            }
            return c;
        }
        // am2 avoids a big mult-and-extract completely.
        // Max digit bits should be <= 30 because we do bitwise ops
        // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
        function am2(i, x, w, j, c, n) {
            var xl = x & 0x7fff,
                xh = x >> 15;
            while (--n >= 0) {
                var l = this[i] & 0x7fff;
                var h = this[i++] >> 15;
                var m = xh * l + h * xl;
                l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
                c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
                w[j++] = l & 0x3fffffff;
            }
            return c;
        }
        // Alternately, set max digit bits to 28 since some
        // browsers slow down when dealing with 32-bit numbers.
        function am3(i, x, w, j, c, n) {
            var xl = x & 0x3fff,
                xh = x >> 14;
            while (--n >= 0) {
                var l = this[i] & 0x3fff;
                var h = this[i++] >> 14;
                var m = xh * l + h * xl;
                l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
                c = (l >> 28) + (m >> 14) + xh * h;
                w[j++] = l & 0xfffffff;
            }
            return c;
        }
        if (j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
            BigInteger.prototype.am = am2;
            dbits = 30;
        } else if (j_lm && (navigator.appName != "Netscape")) {
            BigInteger.prototype.am = am1;
            dbits = 26;
        } else { // Mozilla/Netscape seems to prefer am3
            BigInteger.prototype.am = am3;
            dbits = 28;
        }

        BigInteger.prototype.DB = dbits;
        BigInteger.prototype.DM = ((1 << dbits) - 1);
        BigInteger.prototype.DV = (1 << dbits);

        var BI_FP = 52;
        BigInteger.prototype.FV = Math.pow(2, BI_FP);
        BigInteger.prototype.F1 = BI_FP - dbits;
        BigInteger.prototype.F2 = 2 * dbits - BI_FP;

        // Digit conversions
        var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
        var BI_RC = new Array();
        var rr, vv;
        rr = "0".charCodeAt(0);
        for (vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
        rr = "a".charCodeAt(0);
        for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
        rr = "A".charCodeAt(0);
        for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

        function int2char(n) { return BI_RM.charAt(n); }

        function intAt(s, i) {
            var c = BI_RC[s.charCodeAt(i)];
            return (c == null) ? -1 : c;
        }

        // (protected) copy this to r
        function bnpCopyTo(r) {
            for (var i = this.t - 1; i >= 0; --i) r[i] = this[i];
            r.t = this.t;
            r.s = this.s;
        }

        // (protected) set from integer value x, -DV <= x < DV
        function bnpFromInt(x) {
            this.t = 1;
            this.s = (x < 0) ? -1 : 0;
            if (x > 0) this[0] = x;
            else if (x < -1) this[0] = x + DV;
            else this.t = 0;
        }

        // return bigint initialized to value
        function nbv(i) {
            var r = nbi();
            r.fromInt(i);
            return r;
        }

        // (protected) set from string and radix
        function bnpFromString(s, b) {
            var k;
            if (b == 16) k = 4;
            else if (b == 8) k = 3;
            else if (b == 256) k = 8; // byte array
            else if (b == 2) k = 1;
            else if (b == 32) k = 5;
            else if (b == 4) k = 2;
            else { this.fromRadix(s, b); return; }
            this.t = 0;
            this.s = 0;
            var i = s.length,
                mi = false,
                sh = 0;
            while (--i >= 0) {
                var x = (k == 8) ? s[i] & 0xff : intAt(s, i);
                if (x < 0) {
                    if (s.charAt(i) == "-") mi = true;
                    continue;
                }
                mi = false;
                if (sh == 0)
                    this[this.t++] = x;
                else if (sh + k > this.DB) {
                    this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh;
                    this[this.t++] = (x >> (this.DB - sh));
                } else
                    this[this.t - 1] |= x << sh;
                sh += k;
                if (sh >= this.DB) sh -= this.DB;
            }
            if (k == 8 && (s[0] & 0x80) != 0) {
                this.s = -1;
                if (sh > 0) this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh;
            }
            this.clamp();
            if (mi) BigInteger.ZERO.subTo(this, this);
        }

        // (protected) clamp off excess high words
        function bnpClamp() {
            var c = this.s & this.DM;
            while (this.t > 0 && this[this.t - 1] == c) --this.t;
        }

        // (public) return string representation in given radix
        function bnToString(b) {
            if (this.s < 0) return "-" + this.negate().toString(b);
            var k;
            if (b == 16) k = 4;
            else if (b == 8) k = 3;
            else if (b == 2) k = 1;
            else if (b == 32) k = 5;
            else if (b == 4) k = 2;
            else return this.toRadix(b);
            var km = (1 << k) - 1,
                d, m = false,
                r = "",
                i = this.t;
            var p = this.DB - (i * this.DB) % k;
            if (i-- > 0) {
                if (p < this.DB && (d = this[i] >> p) > 0) {
                    m = true;
                    r = int2char(d);
                }
                while (i >= 0) {
                    if (p < k) {
                        d = (this[i] & ((1 << p) - 1)) << (k - p);
                        d |= this[--i] >> (p += this.DB - k);
                    } else {
                        d = (this[i] >> (p -= k)) & km;
                        if (p <= 0) { p += this.DB;--i; }
                    }
                    if (d > 0) m = true;
                    if (m) r += int2char(d);
                }
            }
            return m ? r : "0";
        }

        // (public) -this
        function bnNegate() {
            var r = nbi();
            BigInteger.ZERO.subTo(this, r);
            return r;
        }

        // (public) |this|
        function bnAbs() { return (this.s < 0) ? this.negate() : this; }

        // (public) return + if this > a, - if this < a, 0 if equal
        function bnCompareTo(a) {
            var r = this.s - a.s;
            if (r != 0) return r;
            var i = this.t;
            r = i - a.t;
            if (r != 0) return (this.s < 0) ? -r : r;
            while (--i >= 0)
                if ((r = this[i] - a[i]) != 0) return r;
            return 0;
        }

        // returns bit length of the integer x
        function nbits(x) {
            var r = 1,
                t;
            if ((t = x >>> 16) != 0) {
                x = t;
                r += 16;
            }
            if ((t = x >> 8) != 0) {
                x = t;
                r += 8;
            }
            if ((t = x >> 4) != 0) {
                x = t;
                r += 4;
            }
            if ((t = x >> 2) != 0) {
                x = t;
                r += 2;
            }
            if ((t = x >> 1) != 0) {
                x = t;
                r += 1;
            }
            return r;
        }

        // (public) return the number of bits in "this"
        function bnBitLength() {
            if (this.t <= 0) return 0;
            return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM));
        }

        // (protected) r = this << n*DB
        function bnpDLShiftTo(n, r) {
            var i;
            for (i = this.t - 1; i >= 0; --i) r[i + n] = this[i];
            for (i = n - 1; i >= 0; --i) r[i] = 0;
            r.t = this.t + n;
            r.s = this.s;
        }

        // (protected) r = this >> n*DB
        function bnpDRShiftTo(n, r) {
            for (var i = n; i < this.t; ++i) r[i - n] = this[i];
            r.t = Math.max(this.t - n, 0);
            r.s = this.s;
        }

        // (protected) r = this << n
        function bnpLShiftTo(n, r) {
            var bs = n % this.DB;
            var cbs = this.DB - bs;
            var bm = (1 << cbs) - 1;
            var ds = Math.floor(n / this.DB),
                c = (this.s << bs) & this.DM,
                i;
            for (i = this.t - 1; i >= 0; --i) {
                r[i + ds + 1] = (this[i] >> cbs) | c;
                c = (this[i] & bm) << bs;
            }
            for (i = ds - 1; i >= 0; --i) r[i] = 0;
            r[ds] = c;
            r.t = this.t + ds + 1;
            r.s = this.s;
            r.clamp();
        }

        // (protected) r = this >> n
        function bnpRShiftTo(n, r) {
            r.s = this.s;
            var ds = Math.floor(n / this.DB);
            if (ds >= this.t) { r.t = 0; return; }
            var bs = n % this.DB;
            var cbs = this.DB - bs;
            var bm = (1 << bs) - 1;
            r[0] = this[ds] >> bs;
            for (var i = ds + 1; i < this.t; ++i) {
                r[i - ds - 1] |= (this[i] & bm) << cbs;
                r[i - ds] = this[i] >> bs;
            }
            if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
            r.t = this.t - ds;
            r.clamp();
        }

        // (protected) r = this - a
        function bnpSubTo(a, r) {
            var i = 0,
                c = 0,
                m = Math.min(a.t, this.t);
            while (i < m) {
                c += this[i] - a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            if (a.t < this.t) {
                c -= a.s;
                while (i < this.t) {
                    c += this[i];
                    r[i++] = c & this.DM;
                    c >>= this.DB;
                }
                c += this.s;
            } else {
                c += this.s;
                while (i < a.t) {
                    c -= a[i];
                    r[i++] = c & this.DM;
                    c >>= this.DB;
                }
                c -= a.s;
            }
            r.s = (c < 0) ? -1 : 0;
            if (c < -1) r[i++] = this.DV + c;
            else if (c > 0) r[i++] = c;
            r.t = i;
            r.clamp();
        }

        // (protected) r = this * a, r != this,a (HAC 14.12)
        // "this" should be the larger one if appropriate.
        function bnpMultiplyTo(a, r) {
            var x = this.abs(),
                y = a.abs();
            var i = x.t;
            r.t = i + y.t;
            while (--i >= 0) r[i] = 0;
            for (i = 0; i < y.t; ++i) r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
            r.s = 0;
            r.clamp();
            if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
        }

        // (protected) r = this^2, r != this (HAC 14.16)
        function bnpSquareTo(r) {
            var x = this.abs();
            var i = r.t = 2 * x.t;
            while (--i >= 0) r[i] = 0;
            for (i = 0; i < x.t - 1; ++i) {
                var c = x.am(i, x[i], r, 2 * i, 0, 1);
                if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                    r[i + x.t] -= x.DV;
                    r[i + x.t + 1] = 1;
                }
            }
            if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
            r.s = 0;
            r.clamp();
        }

        // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
        // r != q, this != m.  q or r may be null.
        function bnpDivRemTo(m, q, r) {
            var pm = m.abs();
            if (pm.t <= 0) return;
            var pt = this.abs();
            if (pt.t < pm.t) {
                if (q != null) q.fromInt(0);
                if (r != null) this.copyTo(r);
                return;
            }
            if (r == null) r = nbi();
            var y = nbi(),
                ts = this.s,
                ms = m.s;
            var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
            if (nsh > 0) {
                pm.lShiftTo(nsh, y);
                pt.lShiftTo(nsh, r);
            } else {
                pm.copyTo(y);
                pt.copyTo(r);
            }
            var ys = y.t;
            var y0 = y[ys - 1];
            if (y0 == 0) return;
            var yt = y0 * (1 << this.F1) + ((ys > 1) ? y[ys - 2] >> this.F2 : 0);
            var d1 = this.FV / yt,
                d2 = (1 << this.F1) / yt,
                e = 1 << this.F2;
            var i = r.t,
                j = i - ys,
                t = (q == null) ? nbi() : q;
            y.dlShiftTo(j, t);
            if (r.compareTo(t) >= 0) {
                r[r.t++] = 1;
                r.subTo(t, r);
            }
            BigInteger.ONE.dlShiftTo(ys, t);
            t.subTo(y, y); // "negative" y so we can replace sub with am later
            while (y.t < ys) y[y.t++] = 0;
            while (--j >= 0) {
                // Estimate quotient digit
                var qd = (r[--i] == y0) ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
                if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) { // Try it out
                    y.dlShiftTo(j, t);
                    r.subTo(t, r);
                    while (r[i] < --qd) r.subTo(t, r);
                }
            }
            if (q != null) {
                r.drShiftTo(ys, q);
                if (ts != ms) BigInteger.ZERO.subTo(q, q);
            }
            r.t = ys;
            r.clamp();
            if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
            if (ts < 0) BigInteger.ZERO.subTo(r, r);
        }

        // (public) this mod a
        function bnMod(a) {
            var r = nbi();
            this.abs().divRemTo(a, null, r);
            if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
            return r;
        }

        // Modular reduction using "classic" algorithm
        function Classic(m) { this.m = m; }

        function cConvert(x) {
            if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
            else return x;
        }

        function cRevert(x) { return x; }

        function cReduce(x) { x.divRemTo(this.m, null, x); }

        function cMulTo(x, y, r) {
            x.multiplyTo(y, r);
            this.reduce(r);
        }

        function cSqrTo(x, r) {
            x.squareTo(r);
            this.reduce(r);
        }

        Classic.prototype.convert = cConvert;
        Classic.prototype.revert = cRevert;
        Classic.prototype.reduce = cReduce;
        Classic.prototype.mulTo = cMulTo;
        Classic.prototype.sqrTo = cSqrTo;

        // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
        // justification:
        //         xy == 1 (mod m)
        //         xy =  1+km
        //   xy(2-xy) = (1+km)(1-km)
        // x[y(2-xy)] = 1-k^2m^2
        // x[y(2-xy)] == 1 (mod m^2)
        // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
        // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
        // JS multiply "overflows" differently from C/C++, so care is needed here.
        function bnpInvDigit() {
            if (this.t < 1) return 0;
            var x = this[0];
            if ((x & 1) == 0) return 0;
            var y = x & 3; // y == 1/x mod 2^2
            y = (y * (2 - (x & 0xf) * y)) & 0xf; // y == 1/x mod 2^4
            y = (y * (2 - (x & 0xff) * y)) & 0xff; // y == 1/x mod 2^8
            y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff; // y == 1/x mod 2^16
            // last step - calculate inverse mod DV directly;
            // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
            y = (y * (2 - x * y % this.DV)) % this.DV; // y == 1/x mod 2^dbits
            // we really want the negative inverse, and -DV < y < DV
            return (y > 0) ? this.DV - y : -y;
        }

        // Montgomery reduction
        function Montgomery(m) {
            this.m = m;
            this.mp = m.invDigit();
            this.mpl = this.mp & 0x7fff;
            this.mph = this.mp >> 15;
            this.um = (1 << (m.DB - 15)) - 1;
            this.mt2 = 2 * m.t;
        }

        // xR mod m
        function montConvert(x) {
            var r = nbi();
            x.abs().dlShiftTo(this.m.t, r);
            r.divRemTo(this.m, null, r);
            if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
            return r;
        }

        // x/R mod m
        function montRevert(x) {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }

        // x = x/R mod m (HAC 14.32)
        function montReduce(x) {
            while (x.t <= this.mt2) // pad x so am has enough room later
                x[x.t++] = 0;
            for (var i = 0; i < this.m.t; ++i) {
                // faster way of calculating u0 = x[i]*mp mod DV
                var j = x[i] & 0x7fff;
                var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM;
                // use am to combine the multiply-shift-add into one call
                j = i + this.m.t;
                x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
                // propagate carry
                while (x[j] >= x.DV) {
                    x[j] -= x.DV;
                    x[++j]++;
                }
            }
            x.clamp();
            x.drShiftTo(this.m.t, x);
            if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
        }

        // r = "x^2/R mod m"; x != r
        function montSqrTo(x, r) {
            x.squareTo(r);
            this.reduce(r);
        }

        // r = "xy/R mod m"; x,y != r
        function montMulTo(x, y, r) {
            x.multiplyTo(y, r);
            this.reduce(r);
        }

        Montgomery.prototype.convert = montConvert;
        Montgomery.prototype.revert = montRevert;
        Montgomery.prototype.reduce = montReduce;
        Montgomery.prototype.mulTo = montMulTo;
        Montgomery.prototype.sqrTo = montSqrTo;

        // (protected) true iff this is even
        function bnpIsEven() { return ((this.t > 0) ? (this[0] & 1) : this.s) == 0; }

        // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
        function bnpExp(e, z) {
            if (e > 0xffffffff || e < 1) return BigInteger.ONE;
            var r = nbi(),
                r2 = nbi(),
                g = z.convert(this),
                i = nbits(e) - 1;
            g.copyTo(r);
            while (--i >= 0) {
                z.sqrTo(r, r2);
                if ((e & (1 << i)) > 0) z.mulTo(r2, g, r);
                else {
                    var t = r;
                    r = r2;
                    r2 = t;
                }
            }
            return z.revert(r);
        }

        // (public) this^e % m, 0 <= e < 2^32
        function bnModPowInt(e, m) {
            var z;
            if (e < 256 || m.isEven()) z = new Classic(m);
            else z = new Montgomery(m);
            return this.exp(e, z);
        }

        // protected
        BigInteger.prototype.copyTo = bnpCopyTo;
        BigInteger.prototype.fromInt = bnpFromInt;
        BigInteger.prototype.fromString = bnpFromString;
        BigInteger.prototype.clamp = bnpClamp;
        BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
        BigInteger.prototype.drShiftTo = bnpDRShiftTo;
        BigInteger.prototype.lShiftTo = bnpLShiftTo;
        BigInteger.prototype.rShiftTo = bnpRShiftTo;
        BigInteger.prototype.subTo = bnpSubTo;
        BigInteger.prototype.multiplyTo = bnpMultiplyTo;
        BigInteger.prototype.squareTo = bnpSquareTo;
        BigInteger.prototype.divRemTo = bnpDivRemTo;
        BigInteger.prototype.invDigit = bnpInvDigit;
        BigInteger.prototype.isEven = bnpIsEven;
        BigInteger.prototype.exp = bnpExp;

        // public
        BigInteger.prototype.toString = bnToString;
        BigInteger.prototype.negate = bnNegate;
        BigInteger.prototype.abs = bnAbs;
        BigInteger.prototype.compareTo = bnCompareTo;
        BigInteger.prototype.bitLength = bnBitLength;
        BigInteger.prototype.mod = bnMod;
        BigInteger.prototype.modPowInt = bnModPowInt;

        // "constants"
        BigInteger.ZERO = nbv(0);
        BigInteger.ONE = nbv(1);

        // jsbn2 stuff

        // (protected) convert from radix string
        function bnpFromRadix(s, b) {
            this.fromInt(0);
            if (b == null) b = 10;
            var cs = this.chunkSize(b);
            var d = Math.pow(b, cs),
                mi = false,
                j = 0,
                w = 0;
            for (var i = 0; i < s.length; ++i) {
                var x = intAt(s, i);
                if (x < 0) {
                    if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                    continue;
                }
                w = b * w + x;
                if (++j >= cs) {
                    this.dMultiply(d);
                    this.dAddOffset(w, 0);
                    j = 0;
                    w = 0;
                }
            }
            if (j > 0) {
                this.dMultiply(Math.pow(b, j));
                this.dAddOffset(w, 0);
            }
            if (mi) BigInteger.ZERO.subTo(this, this);
        }

        // (protected) return x s.t. r^x < DV
        function bnpChunkSize(r) { return Math.floor(Math.LN2 * this.DB / Math.log(r)); }

        // (public) 0 if this == 0, 1 if this > 0
        function bnSigNum() {
            if (this.s < 0) return -1;
            else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0;
            else return 1;
        }

        // (protected) this *= n, this >= 0, 1 < n < DV
        function bnpDMultiply(n) {
            this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
            ++this.t;
            this.clamp();
        }

        // (protected) this += n << w words, this >= 0
        function bnpDAddOffset(n, w) {
            if (n == 0) return;
            while (this.t <= w) this[this.t++] = 0;
            this[w] += n;
            while (this[w] >= this.DV) {
                this[w] -= this.DV;
                if (++w >= this.t) this[this.t++] = 0;
                ++this[w];
            }
        }

        // (protected) convert to radix string
        function bnpToRadix(b) {
            if (b == null) b = 10;
            if (this.signum() == 0 || b < 2 || b > 36) return "0";
            var cs = this.chunkSize(b);
            var a = Math.pow(b, cs);
            var d = nbv(a),
                y = nbi(),
                z = nbi(),
                r = "";
            this.divRemTo(d, y, z);
            while (y.signum() > 0) {
                r = (a + z.intValue()).toString(b).substr(1) + r;
                y.divRemTo(d, y, z);
            }
            return z.intValue().toString(b) + r;
        }

        // (public) return value as integer
        function bnIntValue() {
            if (this.s < 0) {
                if (this.t == 1) return this[0] - this.DV;
                else if (this.t == 0) return -1;
            } else if (this.t == 1) return this[0];
            else if (this.t == 0) return 0;
            // assumes 16 < DB < 32
            return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
        }

        // (protected) r = this + a
        function bnpAddTo(a, r) {
            var i = 0,
                c = 0,
                m = Math.min(a.t, this.t);
            while (i < m) {
                c += this[i] + a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            if (a.t < this.t) {
                c += a.s;
                while (i < this.t) {
                    c += this[i];
                    r[i++] = c & this.DM;
                    c >>= this.DB;
                }
                c += this.s;
            } else {
                c += this.s;
                while (i < a.t) {
                    c += a[i];
                    r[i++] = c & this.DM;
                    c >>= this.DB;
                }
                c += a.s;
            }
            r.s = (c < 0) ? -1 : 0;
            if (c > 0) r[i++] = c;
            else if (c < -1) r[i++] = this.DV + c;
            r.t = i;
            r.clamp();
        }

        BigInteger.prototype.fromRadix = bnpFromRadix;
        BigInteger.prototype.chunkSize = bnpChunkSize;
        BigInteger.prototype.signum = bnSigNum;
        BigInteger.prototype.dMultiply = bnpDMultiply;
        BigInteger.prototype.dAddOffset = bnpDAddOffset;
        BigInteger.prototype.toRadix = bnpToRadix;
        BigInteger.prototype.intValue = bnIntValue;
        BigInteger.prototype.addTo = bnpAddTo;

        //======= end jsbn =======

        // Emscripten wrapper
        var Wrapper = {
            abs: function(l, h) {
                var x = new goog.math.Long(l, h);
                var ret;
                if (x.isNegative()) {
                    ret = x.negate();
                } else {
                    ret = x;
                }
                HEAP32[tempDoublePtr >> 2] = ret.low_;
                HEAP32[tempDoublePtr + 4 >> 2] = ret.high_;
            },
            ensureTemps: function() {
                if (Wrapper.ensuredTemps) return;
                Wrapper.ensuredTemps = true;
                Wrapper.two32 = new BigInteger();
                Wrapper.two32.fromString('4294967296', 10);
                Wrapper.two64 = new BigInteger();
                Wrapper.two64.fromString('18446744073709551616', 10);
                Wrapper.temp1 = new BigInteger();
                Wrapper.temp2 = new BigInteger();
            },
            lh2bignum: function(l, h) {
                var a = new BigInteger();
                a.fromString(h.toString(), 10);
                var b = new BigInteger();
                a.multiplyTo(Wrapper.two32, b);
                var c = new BigInteger();
                c.fromString(l.toString(), 10);
                var d = new BigInteger();
                c.addTo(b, d);
                return d;
            },
            stringify: function(l, h, unsigned) {
                var ret = new goog.math.Long(l, h).toString();
                if (unsigned && ret[0] == '-') {
                    // unsign slowly using jsbn bignums
                    Wrapper.ensureTemps();
                    var bignum = new BigInteger();
                    bignum.fromString(ret, 10);
                    ret = new BigInteger();
                    Wrapper.two64.addTo(bignum, ret);
                    ret = ret.toString(10);
                }
                return ret;
            },
            fromString: function(str, base, min, max, unsigned) {
                Wrapper.ensureTemps();
                var bignum = new BigInteger();
                bignum.fromString(str, base);
                var bigmin = new BigInteger();
                bigmin.fromString(min, 10);
                var bigmax = new BigInteger();
                bigmax.fromString(max, 10);
                if (unsigned && bignum.compareTo(BigInteger.ZERO) < 0) {
                    var temp = new BigInteger();
                    bignum.addTo(Wrapper.two64, temp);
                    bignum = temp;
                }
                var error = false;
                if (bignum.compareTo(bigmin) < 0) {
                    bignum = bigmin;
                    error = true;
                } else if (bignum.compareTo(bigmax) > 0) {
                    bignum = bigmax;
                    error = true;
                }
                var ret = goog.math.Long.fromString(bignum.toString()); // min-max checks should have clamped this to a range goog.math.Long can handle well
                HEAP32[tempDoublePtr >> 2] = ret.low_;
                HEAP32[tempDoublePtr + 4 >> 2] = ret.high_;
                if (error) throw 'range error';
            }
        };
        return Wrapper;
    })();

    //======= end closure i64 code =======



    // === Auto-generated postamble setup entry stuff ===

    if (memoryInitializer) {
        if (ENVIRONMENT_IS_NODE || ENVIRONMENT_IS_SHELL) {
            var data = Module['readBinary'](memoryInitializer);
            HEAPU8.set(data, STATIC_BASE);
        } else {
            addRunDependency('memory initializer');
            Browser.asyncLoad(memoryInitializer, function(data) {
                HEAPU8.set(data, STATIC_BASE);
                removeRunDependency('memory initializer');
            }, function(data) {
                throw 'could not load memory initializer ' + memoryInitializer;
            });
        }
    }

    function ExitStatus(status) {
        this.name = "ExitStatus";
        this.message = "Program terminated with exit(" + status + ")";
        this.status = status;
    };
    ExitStatus.prototype = new Error();
    ExitStatus.prototype.constructor = ExitStatus;

    var initialStackTop;
    var preloadStartTime = null;
    var calledMain = false;

    dependenciesFulfilled = function runCaller() {
        // If run has never been called, and we should call run (INVOKE_RUN is true, and Module.noInitialRun is not false)
        if (!Module['calledRun'] && shouldRunNow) run();
        if (!Module['calledRun']) dependenciesFulfilled = runCaller; // try this again later, after new deps are fulfilled
    }

    Module['callMain'] = Module.callMain = function callMain(args) {
        assert(runDependencies == 0, 'cannot call main when async dependencies remain! (listen on __ATMAIN__)');
        assert(__ATPRERUN__.length == 0, 'cannot call main when preRun functions remain to be called');

        args = args || [];

        if (ENVIRONMENT_IS_WEB && preloadStartTime !== null) {
            Module.printErr('preload time: ' + (Date.now() - preloadStartTime) + ' ms');
        }

        ensureInitRuntime();

        var argc = args.length + 1;

        function pad() {
            for (var i = 0; i < 4 - 1; i++) {
                argv.push(0);
            }
        }
        var argv = [allocate(intArrayFromString("/bin/this.program"), 'i8', ALLOC_NORMAL)];
        pad();
        for (var i = 0; i < argc - 1; i = i + 1) {
            argv.push(allocate(intArrayFromString(args[i]), 'i8', ALLOC_NORMAL));
            pad();
        }
        argv.push(0);
        argv = allocate(argv, 'i32', ALLOC_NORMAL);

        initialStackTop = STACKTOP;

        try {

            var ret = Module['_main'](argc, argv, 0);


            // if we're not running an evented main loop, it's time to exit
            if (!Module['noExitRuntime']) {
                exit(ret);
            }
        } catch (e) {
            if (e instanceof ExitStatus) {
                // exit() throws this once it's done to make sure execution
                // has been stopped completely
                return;
            } else if (e == 'SimulateInfiniteLoop') {
                // running an evented main loop, don't immediately exit
                Module['noExitRuntime'] = true;
                return;
            } else {
                if (e && typeof e === 'object' && e.stack) Module.printErr('exception thrown: ' + [e, e.stack]);
                throw e;
            }
        } finally {
            calledMain = true;
        }
    }




    function run(args) {
        args = args || Module['arguments'];

        if (preloadStartTime === null) preloadStartTime = Date.now();

        if (runDependencies > 0) {
            Module.printErr('run() called, but dependencies remain, so not running');
            return;
        }

        preRun();

        if (runDependencies > 0) return; // a preRun added a dependency, run will be called later
        if (Module['calledRun']) return; // run may have just been called through dependencies being fulfilled just in this very frame

        function doRun() {
            if (Module['calledRun']) return; // run may have just been called while the async setStatus time below was happening
            Module['calledRun'] = true;

            ensureInitRuntime();

            preMain();

            if (Module['_main'] && shouldRunNow) {
                Module['callMain'](args);
            }

            postRun();
        }

        if (Module['setStatus']) {
            Module['setStatus']('Running...');
            setTimeout(function() {
                setTimeout(function() {
                    Module['setStatus']('');
                }, 1);
                if (!ABORT) doRun();
            }, 1);
        } else {
            doRun();
        }
    }
    Module['run'] = Module.run = run;

    function exit(status) {
        ABORT = true;
        EXITSTATUS = status;
        STACKTOP = initialStackTop;

        // exit the runtime
        exitRuntime();

        // TODO We should handle this differently based on environment.
        // In the browser, the best we can do is throw an exception
        // to halt execution, but in node we could process.exit and
        // I'd imagine SM shell would have something equivalent.
        // This would let us set a proper exit status (which
        // would be great for checking test exit statuses).
        // https://github.com/kripken/emscripten/issues/1371

        // throw an exception to halt the current execution
        throw new ExitStatus(status);
    }
    Module['exit'] = Module.exit = exit;

    function abort(text) {
        if (text) {
            Module.print(text);
            Module.printErr(text);
        }

        ABORT = true;
        EXITSTATUS = 1;

        throw 'abort() at ' + stackTrace();
    }
    Module['abort'] = Module.abort = abort;

    // {{PRE_RUN_ADDITIONS}}

    if (Module['preInit']) {
        if (typeof Module['preInit'] == 'function') Module['preInit'] = [Module['preInit']];
        while (Module['preInit'].length > 0) {
            Module['preInit'].pop()();
        }
    }

    // shouldRunNow refers to calling main(), not run().
    var shouldRunNow = false;
    if (Module['noInitialRun']) {
        shouldRunNow = false;
    }

    Module["noExitRuntime"] = true;

    run();

    // {{POST_RUN_ADDITIONS}}






    // {{MODULE_ADDITIONS}}





    /**
     * libde265.js HEVC/H.265 decoder
     * (c)2014 struktur AG, http://www.struktur.de, opensource@struktur.de
     *
     * This file is part of libde265.js
     * https://github.com/strukturag/libde265.js
     *
     * libde265.js is free software: you can redistribute it and/or modify
     * it under the terms of the GNU Lesser General Public License as
     * published by the Free Software Foundation, either version 3 of
     * the License, or (at your option) any later version.
     *
     * libde265.js is distributed in the hope that it will be useful,
     * but WITHOUT ANY WARRANTY; without even the implied warranty of
     * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
     * GNU Lesser General Public License for more details.
     *
     * You should have received a copy of the GNU Lesser General Public License
     * along with libde265.js.  If not, see <http://www.gnu.org/licenses/>.
     */
    // don't pollute the global namespace
    delete this['Module'];

    /**
     * Public API.
     */
    var libde265 = {
        /** @expose */
        DE265_OK: 0,
        /** @expose */
        DE265_ERROR_NO_SUCH_FILE: 1,
        //DE265_ERROR_NO_STARTCODE: 2, obsolete
        /** @expose */
        DE265_ERROR_EOF: 3,
        /** @expose */
        DE265_ERROR_COEFFICIENT_OUT_OF_IMAGE_BOUNDS: 4,
        /** @expose */
        DE265_ERROR_CHECKSUM_MISMATCH: 5,
        /** @expose */
        DE265_ERROR_CTB_OUTSIDE_IMAGE_AREA: 6,
        /** @expose */
        DE265_ERROR_OUT_OF_MEMORY: 7,
        /** @expose */
        DE265_ERROR_CODED_PARAMETER_OUT_OF_RANGE: 8,
        /** @expose */
        DE265_ERROR_IMAGE_BUFFER_FULL: 9,
        /** @expose */
        DE265_ERROR_CANNOT_START_THREADPOOL: 10,
        /** @expose */
        DE265_ERROR_LIBRARY_INITIALIZATION_FAILED: 11,
        /** @expose */
        DE265_ERROR_LIBRARY_NOT_INITIALIZED: 12,
        /** @expose */
        DE265_ERROR_WAITING_FOR_INPUT_DATA: 13,
        /** @expose */
        DE265_ERROR_CANNOT_PROCESS_SEI: 14,
        /** @expose */
        DE265_ERROR_PARAMETER_PARSING: 15,
        /** @expose */
        DE265_ERROR_NO_INITIAL_SLICE_HEADER: 16,
        /** @expose */
        DE265_ERROR_PREMATURE_END_OF_SLICE: 17,
        /** @expose */
        DE265_ERROR_UNSPECIFIED_DECODING_ERROR: 18,

        // --- errors that should become obsolete in later libde265 versions ---

        /** @expose */
        DE265_ERROR_MAX_THREAD_CONTEXTS_EXCEEDED: 500,
        /** @expose */
        DE265_ERROR_MAX_NUMBER_OF_SLICES_EXCEEDED: 501,
        //DE265_ERROR_SCALING_LIST_NOT_IMPLEMENTED: 502, obsolete
        /** @expose */
        DE265_ERROR_NOT_IMPLEMENTED_YET: 502,

        // --- warnings ---

        /** @expose */
        DE265_WARNING_NO_WPP_CANNOT_USE_MULTITHREADING: 1000,
        /** @expose */
        DE265_WARNING_WARNING_BUFFER_FULL: 1001,
        /** @expose */
        DE265_WARNING_PREMATURE_END_OF_SLICE_SEGMENT: 1002,
        /** @expose */
        DE265_WARNING_INCORRECT_ENTRY_POINT_OFFSET: 1003,
        /** @expose */
        DE265_WARNING_CTB_OUTSIDE_IMAGE_AREA: 1004,
        /** @expose */
        DE265_WARNING_SPS_HEADER_INVALID: 1005,
        /** @expose */
        DE265_WARNING_PPS_HEADER_INVALID: 1006,
        /** @expose */
        DE265_WARNING_SLICEHEADER_INVALID: 1007,
        /** @expose */
        DE265_WARNING_INCORRECT_MOTION_VECTOR_SCALING: 1008,
        /** @expose */
        DE265_WARNING_NONEXISTING_PPS_REFERENCED: 1009,
        /** @expose */
        DE265_WARNING_NONEXISTING_SPS_REFERENCED: 1010,
        /** @expose */
        DE265_WARNING_BOTH_PREDFLAGS_ZERO: 1011,
        /** @expose */
        DE265_WARNING_NONEXISTING_REFERENCE_PICTURE_ACCESSED: 1012,
        /** @expose */
        DE265_WARNING_NUMMVP_NOT_EQUAL_TO_NUMMVQ: 1013,
        /** @expose */
        DE265_WARNING_NUMBER_OF_SHORT_TERM_REF_PIC_SETS_OUT_OF_RANGE: 1014,
        /** @expose */
        DE265_WARNING_SHORT_TERM_REF_PIC_SET_OUT_OF_RANGE: 1015,
        /** @expose */
        DE265_WARNING_FAULTY_REFERENCE_PICTURE_LIST: 1016,
        /** @expose */
        DE265_WARNING_EOSS_BIT_NOT_SET: 1017,
        /** @expose */
        DE265_WARNING_MAX_NUM_REF_PICS_EXCEEDED: 1018,
        /** @expose */
        DE265_WARNING_INVALID_CHROMA_FORMAT: 1019,
        /** @expose */
        DE265_WARNING_SLICE_SEGMENT_ADDRESS_INVALID: 1020,
        /** @expose */
        DE265_WARNING_DEPENDENT_SLICE_WITH_ADDRESS_ZERO: 1021,
        /** @expose */
        DE265_WARNING_NUMBER_OF_THREADS_LIMITED_TO_MAXIMUM: 1022,
        /** @expose */
        DE265_NON_EXISTING_LT_REFERENCE_CANDIDATE_IN_SLICE_HEADER: 1023,
        /** @expose */
        DE265_WARNING_CANNOT_APPLY_SAO_OUT_OF_MEMORY: 1024,
        /** @expose */
        DE265_WARNING_SPS_MISSING_CANNOT_DECODE_SEI: 1025,
        /** @expose */
        DE265_WARNING_COLLOCATED_MOTION_VECTOR_OUTSIDE_IMAGE_AREA: 1026,

        /** @expose */
        de265_get_version: cwrap('de265_get_version', 'string'),
        /** @expose */
        de265_get_version_number: cwrap('de265_get_version_number', 'number'),
        /** @expose */
        de265_get_error_text: cwrap('de265_get_error_text', 'string', ['number']),
        /** @expose */
        de265_isOK: cwrap('de265_isOK', 'number', ['number']),
        /** @expose */
        de265_set_verbosity: cwrap('de265_set_verbosity', 'number', ['number']),

        /** @expose */
        de265_chroma_mono: 0,
        /** @expose */
        de265_chroma_420: 1,
        /** @expose */
        de265_chroma_422: 2,
        /** @expose */
        de265_chroma_444: 3,

        /** @expose */
        de265_get_image_width: cwrap('de265_get_image_width', 'number', ['number', 'number']),
        /** @expose */
        de265_get_image_height: cwrap('de265_get_image_height', 'number', ['number', 'number']),
        /** @expose */
        de265_get_chroma_format: cwrap('de265_get_chroma_format', 'number', ['number']),
        /** @expose */
        de265_get_bits_per_pixel: cwrap('de265_get_bits_per_pixel', 'number', ['number', 'number']),
        /** @expose */
        de265_get_image_plane: cwrap('de265_get_image_plane', 'number', ['number', 'number', 'number']),
        /** @expose */
        de265_get_image_plane_user_data: cwrap('de265_get_image_plane_user_data', 'number', ['number', 'number']),
        /** @expose */
        de265_get_image_PTS: cwrap('de265_get_image_PTS', 'number', ['number']),
        /** @expose */
        de265_get_image_user_data: cwrap('de265_get_image_user_data', 'number', ['number']),
        /** @expose */
        de265_set_image_user_data: cwrap('de265_set_image_user_data', 'number', ['number', 'number']),
        // de265_get_image_NAL_header

        /** @expose */
        de265_new_decoder: cwrap('de265_new_decoder', 'number'),
        // de265_start_worker_threads
        /** @expose */
        de265_free_decoder: cwrap('de265_free_decoder', 'number', ['number']),
        /** @expose */
        de265_push_data: cwrap('de265_push_data', 'number', ['number', 'array', 'number', 'number', 'number']),
        /** @expose */
        de265_push_end_of_NAL: cwrap('de265_push_end_of_NAL', 'number', ['number']),
        /** @expose */
        de265_push_end_of_frame: cwrap('de265_push_end_of_frame', 'number', ['number']),
        /** @expose */
        de265_push_NAL: cwrap('de265_push_NAL', 'number', ['number', 'array', 'number', 'number', 'number']),
        /** @expose */
        de265_flush_data: cwrap('de265_flush_data', 'number', ['number']),
        /** @expose */
        de265_get_number_of_input_bytes_pending: cwrap('de265_get_number_of_input_bytes_pending', 'number', ['number']),
        /** @expose */
        de265_get_number_of_NAL_units_pending: cwrap('de265_get_number_of_NAL_units_pending', 'number', ['number']),
        /** @expose */
        de265_decode: cwrap('de265_decode', 'number', ['number', 'number']),
        /** @expose */
        de265_reset: cwrap('de265_reset', 'number', ['number']),
        /** @expose */
        de265_peek_next_picture: cwrap('de265_peek_next_picture', 'number', ['number']),
        /** @expose */
        de265_get_next_picture: cwrap('de265_get_next_picture', 'number', ['number']),
        /** @expose */
        de265_release_next_picture: cwrap('de265_release_next_picture', 'number', ['number']),
        /** @expose */
        de265_get_warning: cwrap('de265_get_warning', 'number', ['number']),

        // de265_set_image_allocation_functions
        // de265_get_default_image_allocation_functions
        // de265_set_image_plane

        /** @expose */
        de265_get_highest_TID: cwrap('de265_get_highest_TID', 'number', ['number']),
        /** @expose */
        de265_get_current_TID: cwrap('de265_get_current_TID', 'number', ['number']),
        /** @expose */
        de265_set_limit_TID: cwrap('de265_set_limit_TID', 'number', ['number', 'number']),
        /** @expose */
        de265_set_framerate_ratio: cwrap('de265_set_framerate_ratio', 'number', ['number', 'number']),
        /** @expose */
        de265_change_framerate: cwrap('de265_change_framerate', 'number', ['number', 'number']),

        /** @expose */
        DE265_DECODER_PARAM_BOOL_SEI_CHECK_HASH: 0, // (bool) Perform SEI hash check on decoded pictures.
        /** @expose */
        DE265_DECODER_PARAM_DUMP_SPS_HEADERS: 1, // (int)  Dump headers to specified file-descriptor.
        /** @expose */
        DE265_DECODER_PARAM_DUMP_VPS_HEADERS: 2,
        /** @expose */
        DE265_DECODER_PARAM_DUMP_PPS_HEADERS: 3,
        /** @expose */
        DE265_DECODER_PARAM_DUMP_SLICE_HEADERS: 4,
        /** @expose */
        DE265_DECODER_PARAM_ACCELERATION_CODE: 5, // (int)  enum de265_acceleration, default: AUTO
        /** @expose */
        DE265_DECODER_PARAM_SUPPRESS_FAULTY_PICTURES: 6, // (bool)  do not output frames with decoding errors, default: no (output all images)
        /** @expose */
        DE265_DECODER_PARAM_DISABLE_DEBLOCKING: 7, // (bool)  disable deblocking
        /** @expose */
        DE265_DECODER_PARAM_DISABLE_SAO: 8, // (bool)  disable SAO filter

        /** @expose */
        de265_acceleration_SCALAR: 0, // only fallback implementation
        /** @expose */
        de265_acceleration_MMX: 10,
        /** @expose */
        de265_acceleration_SSE: 20,
        /** @expose */
        de265_acceleration_SSE2: 30,
        /** @expose */
        de265_acceleration_SSE4: 40,
        /** @expose */
        de265_acceleration_AVX: 50, // not implemented yet
        /** @expose */
        de265_acceleration_AVX2: 60, // not implemented yet
        /** @expose */
        de265_acceleration_ARM: 70,
        /** @expose */
        de265_acceleration_NEON: 80,
        /** @expose */
        de265_acceleration_AUTO: 10000,

        /** @expose */
        de265_set_parameter_bool: cwrap('de265_set_parameter_bool', 'number', ['number', 'number', 'number']),
        /** @expose */
        de265_set_parameter_int: cwrap('de265_set_parameter_int', 'number', ['number', 'number', 'number']),
        /** @expose */
        de265_get_parameter_bool: cwrap('de265_get_parameter_bool', 'number', ['number', 'number'])
    };

    /**
     * A decoded image
     *
     * @constructor
     */
    var Image = function(decoder, img) {
        this.decoder = decoder;
        this.img = img;
        this.width = null;
        this.height = null;
    };

    /**
     * @expose
     */
    Image.prototype.free = function() {};

    /**
     * @expose
     */
    Image.prototype.get_width = function() {
        if (this.width === null) {
            this.width = libde265.de265_get_image_width(this.img, 0);
        }
        return this.width;
    };

    /**
     * @expose
     */
    Image.prototype.get_height = function() {
        if (this.height === null) {
            this.height = libde265.de265_get_image_height(this.img, 0);
        }
        return this.height;
    };

    /**
     * @expose
     */
    Image.prototype.display = function(imageData, callback) {
        var w = this.get_width();
        var h = this.get_height();
        var chroma = libde265.de265_get_chroma_format(this.img);
        var stride = _malloc(4);
        var y = libde265.de265_get_image_plane(this.img, 0, stride);
        var stridey = getValue(stride, "i32");
        var bppy = libde265.de265_get_bits_per_pixel(this.img, 0);
        var u = libde265.de265_get_image_plane(this.img, 1, stride);
        var strideu = getValue(stride, "i32");
        var bppu = libde265.de265_get_bits_per_pixel(this.img, 1);
        var v = libde265.de265_get_image_plane(this.img, 2, stride);
        var stridev = getValue(stride, "i32");
        var bppv = libde265.de265_get_bits_per_pixel(this.img, 2);
        _free(stride);

        this.decoder.convert_yuv2rgb(chroma, y, u, v, w, h, stridey, strideu, stridev, bppy, bppu, bppv, imageData, callback);
    };

    function worker_func() {
        self.addEventListener("message", function(e) {
            var data = e.data;
            switch (data["cmd"]) {
                case "start":
                    break;

                case "stop":
                    this.postMessage({ "cmd": "stopped" });
                    self.close();
                    break;

                case "convert":
                    var img = _do_convert_yuv2rgb(data["data"]["chroma"], data["data"]["y"], data["data"]["u"], data["data"]["v"], data["data"]["w"], data["data"]["h"], data["data"]["stridey"], data["data"]["strideu"], data["data"]["stridev"], data["data"]["bppy"], data["data"]["bppu"], data["data"]["bppv"]);
                    this.postMessage({ "cmd": "converted", "data": { "image": img } });
                    break;

                default:
                    // ignore unknown commands
                    break;
            }
        }, 0);
    }

    var worker_blob_url = null;

    var WorkerConverter = function() {
        this.callbacks = [];
        if (worker_blob_url === null) {
            // load worker from inplace blob so we don't have to depend
            // on additional external files
            var worker_func_data = worker_func.toString();
            var worker_func_name = worker_func.name;
            if (!worker_func_name) {
                // Get name of function for older browsers and IE.
                // See http://stackoverflow.com/a/17923727/608954
                worker_func_name = /^function\s+([\w\$]+)\s*\(/.exec(worker_func_data)[1];
            }
            var blob = new Blob([
                "(function() {\n",
                _do_convert_yuv420.toString() + ";\n",
                _do_convert_yuv2rgb.toString() + ";\n",
                worker_func_data + ";\n",
                worker_func_name + "();\n",
                "}).call(this);"
            ], { "type": "text/javascript" });

            worker_blob_url = window.URL.createObjectURL(blob);
        }

        var that = this;
        this.worker = new Worker(worker_blob_url);
        this.worker.addEventListener('message', function(e) {
            switch (e.data["cmd"]) {
                case "converted":
                    var cb = that.callbacks[0];
                    that.callbacks = that.callbacks.splice(1);
                    cb(e.data["data"]["image"]);
                    break;

                case "stopped":
                    that.callbacks = null;
                    that = null;
                    break;

                default:
                    // ignore unknown commands
                    break;
            }
        }, false);
        this.worker.postMessage({ "cmd": "start" });
    };

    WorkerConverter.prototype.destroy = function() {
        if (this.worker) {
            this.worker.postMessage({ "cmd": "stop" });
            this.worker = null;
        }
    };

    WorkerConverter.prototype.convert = function(chroma, y, u, v, w, h, stridey, strideu, stridev, bppy, bppu, bppv, imageData, callback) {
        var msg = {
            "cmd": "convert",
            "data": {
                "chroma": chroma,
                "y": new Uint8Array(y),
                "u": new Uint8Array(u),
                "v": new Uint8Array(v),
                "w": w,
                "h": h,
                "stridey": stridey,
                "strideu": strideu,
                "stridev": stridev,
                "bppy": bppy,
                "bppu": bppu,
                "bppv": bppv
            }
        };
        this.callbacks.push(function(data) {
            if (imageData.data.set) {
                imageData.data.set(data);
            } else {
                var dest = imageData.data;
                var cnt = dest.length;
                for (var i = 0; i < cnt; i++) {
                    dest[i] = data[i];
                }
            }
            callback(imageData);
        });
        this.worker.postMessage(msg);
    };

    var LocalConverter = function() {};

    LocalConverter.prototype.destroy = function() {};

    LocalConverter.prototype.convert = function(chroma, y, u, v, w, h, stridey, strideu, stridev, bppy, bppu, bppv, imageData, callback) {
        _do_convert_yuv2rgb(chroma,
            y, u, v,
            w, h,
            stridey, strideu, stridev,
            bppy, bppu, bppv,
            imageData.data);

        callback(imageData);
    };

    /**
     * The HEVC/H.265 decoder
     *
     * @constructor
     */
    var Decoder = function() {
        this.image_callback = null;
        this.more = _malloc(2);
        this.stop = false;
        this.ctx = libde265.de265_new_decoder();
        if (typeof Worker !== "undefined" && typeof Uint8ClampedArray !== "undefined" && typeof Blob !== "undefined") {
            this.converter = new WorkerConverter();
        } else {
            this.converter = new LocalConverter();
        }
    };

    /**
     * @expose
     */
    Decoder.prototype.free = function() {
        if (this.converter) {
            this.converter.destroy();
            this.converter = null;
        }
        libde265.de265_free_decoder(this.ctx);
        this.ctx = null;
        _free(this.more);
        this.more = null;
    };

    /**
     * @expose
     */
    Decoder.prototype.set_image_callback = function(callback) {
        this.image_callback = callback;
    };

    /**
     * @expose
     */
    Decoder.prototype.reset = function() {
        libde265.de265_reset(this.ctx);
    };

    /**
     * @expose
     */
    Decoder.prototype.push_data = function(data, pts) {
        pts = pts || 0;
        // console.log(libde265.de265_push_data(this.ctx, data, data.length, pts, 0))
        return libde265.de265_push_data(this.ctx, data, data.length, pts, 0);
    };

    /**
     * @expose
     */
    Decoder.prototype.flush = function() {
        this.stop = true;
        return libde265.de265_flush_data(this.ctx);
    };

    /**
     * @expose
     */
    Decoder.prototype.has_more = function() {
        return !this.stop || getValue(this.more, "i16") !== 0;
    };

    /**
     * @expose
     */
    Decoder.prototype.set_framerate_ratio = function(ratio) {
        libde265.de265_set_framerate_ratio(this.ctx, ratio);
    };

    /**
     * @expose
     */
    Decoder.prototype.disable_filters = function(disable) {
        libde265.de265_set_parameter_bool(this.ctx, libde265.DE265_DECODER_PARAM_DISABLE_DEBLOCKING, !!disable);
        libde265.de265_set_parameter_bool(this.ctx, libde265.DE265_DECODER_PARAM_DISABLE_SAO, !!disable);
    };

    /**
     * @expose
     */
    Decoder.prototype.decode = function(callback) {
        var err;
        setValue(this.more, 1, "i16");
        while (getValue(this.more, "i16") !== 0) {
            err = libde265.de265_decode(this.ctx, this.more);
            if (!libde265.de265_isOK(err)) {
                setValue(this.more, 0, "i16");
                break;
            }

            var img = libde265.de265_get_next_picture(this.ctx);
            if (img) {
                if (this.image_callback) {
                    this.image_callback(new Image(this, img));
                }
                break;
            }
        }
        callback(err);
        return;
    };

    function _do_convert_yuv420(y, u, v, w, h, stridey, strideu, stridev, bppy, bppu, bppv, dest) {
        var yval;
        var uval;
        var vval;
        var xpos = 0;
        var ypos = 0;
        var w2 = w >> 1;
        var maxi = w2 * h;
        var yoffset = 0;
        var uoffset = 0;
        var voffset = 0;
        var x2;
        var i2;
        for (var i = 0; i < maxi; i++) {
            i2 = i << 1;
            x2 = (xpos << 1);
            yval = 1.164 * (y[yoffset + x2] - 16);

            uval = u[uoffset + xpos] - 128;
            vval = v[voffset + xpos] - 128;
            dest[(i2 << 2) + 0] = yval + 1.596 * vval;
            dest[(i2 << 2) + 1] = yval - 0.813 * vval - 0.391 * uval;
            dest[(i2 << 2) + 2] = yval + 2.018 * uval;
            dest[(i2 << 2) + 3] = 0xff;

            yval = 1.164 * (y[yoffset + x2 + 1] - 16);
            dest[((i2 + 1) << 2) + 0] = yval + 1.596 * vval;
            dest[((i2 + 1) << 2) + 1] = yval - 0.813 * vval - 0.391 * uval;
            dest[((i2 + 1) << 2) + 2] = yval + 2.018 * uval;
            dest[((i2 + 1) << 2) + 3] = 0xff;

            xpos++;
            if (xpos === w2) {
                xpos = 0;
                ypos++;
                yoffset += stridey;
                uoffset = ((ypos >> 1) * strideu);
                voffset = ((ypos >> 1) * stridev);
            }
        }
    }

    function _do_convert_yuv2rgb(chroma, y, u, v, w, h, stridey, strideu, stridev, bppy, bppu, bppv, dest) {
        if (!dest) {
            dest = new Uint8ClampedArray(w * h * 4);
        }
        // NOTE: we can't use libde265 constants here as the function can also be
        // run inside the Worker where "libde265" is not available.
        switch (chroma) {
            case 0:
                /* libde265.de265_chroma_mono */
                // TODO(fancycode): implement me
                console.log("Chroma format not implemented yet", chroma, bppy, bppu, bppv);
                break;
            case 1:
                /* libde265.de265_chroma_420 */
                if (bppy !== 8 || bppu !== 8 || bppv !== 8) {
                    // TODO(fancycode): implement me
                    console.log("Chroma format not implemented yet", chroma, bppy, bppu, bppv);
                } else {
                    _do_convert_yuv420(y, u, v, w, h, stridey, strideu, stridev, bppy, bppu, bppv, dest);
                }
                break;
            case 2:
                /* libde265.de265_chroma_422 */
                // TODO(fancycode): implement me
                console.log("Chroma format not implemented yet", chroma, bppy, bppu, bppv);
                break;
            case 3:
                /* libde265.de265_chroma_444 */
                // TODO(fancycode): implement me
                console.log("Chroma format not implemented yet", chroma, bppy, bppu, bppv);
                break;
            default:
                console.log("Unsupported chroma format", chroma, bppy, bppu, bppv);
                break;
        }
        return dest;
    }

    Decoder.prototype.convert_yuv2rgb = function(chroma, y, u, v, w, h, stridey, strideu, stridev, bppy, bppu, bppv, imageData, callback) {
        y = HEAPU8.subarray(y, y + (h * stridey));
        u = HEAPU8.subarray(u, u + (h * strideu));
        v = HEAPU8.subarray(v, v + (h * stridev));
        this.converter.convert(chroma, y, u, v, w, h, stridey, strideu, stridev, bppy, bppu, bppv, imageData, callback);
    };

    /**
     * @expose
     */
    libde265.Decoder = Decoder;

    /**
     * A simple raw bitstream player interface.
     *
     * @constructor
     */
    var RawPlayer = function(canvas) {
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
        this.status_cb = null;
        this.error_cb = null;
        this.ratio = null;
        this.filters = false;
        this._reset();
    };

    RawPlayer.prototype._reset = function() {
        this.start = null;
        this.frames = 0;
        this.image_data = null;
        this.running = false;
        this.pending_image_data = null;
    };

    /** @expose */
    RawPlayer.prototype.set_status_callback = function(callback) {
        this.status_cb = callback;
    };

    RawPlayer.prototype._set_status = function() {
        if (this.status_cb) {
            this.status_cb.apply(this.status_cb, arguments);
        }
    };

    /** @expose */
    RawPlayer.prototype.set_error_callback = function(callback) {
        this.error_cb = callback;
    };

    RawPlayer.prototype._set_error = function(error, message) {
        if (this.error_cb) {
            this.error_cb(error, message);
        }
    };

    RawPlayer.prototype._display_image = function(image) {
        if (!this.start) {
            this.start = new Date();
            this._set_status("playing");
        } else {
            this.frames += 1;
            var duration = (new Date()) - this.start;
            if (duration > 1000) {
                this._set_status("fps", this.frames / (duration * 0.001));
            }
        }

        var w = image.get_width();
        var h = image.get_height();
        if (w != this.canvas.width || h != this.canvas.height || !this.image_data) {
            this.canvas.width = w;
            this.canvas.height = h;
            this.image_data = this.ctx.createImageData(w, h);
            var image_data = this.image_data.data;
            for (var i = 0; i < w * h; i++) {
                image_data[i * 4 + 3] = 255;
            }
        }

        var that = this;
        image.display(this.image_data, function(display_image_data) {
            if (window.requestAnimationFrame) {
                that.pending_image_data = display_image_data;
                window.requestAnimationFrame(function() {
                    if (that.pending_image_data) {
                        that.ctx.putImageData(that.pending_image_data, 0, 0);
                        that.pending_image_data = null;
                    }
                });
            } else {
                that.ctx.putImageData(display_image_data, 0, 0);
            }
        });
    };

    RawPlayer.prototype._handle_onload = function(request, event) {
        var that = this;
        this._set_status("initializing");

        var decoder = new Decoder();
        decoder.set_image_callback(function(image) {
            that._display_image(image);
            image.free();
        });

        var data = request.response;
        var pos = 0;
        var remaining = data.byteLength;
        var ratio = null;
        var filters = false;

        var decode = function() {
            if (!that.running) {
                return;
            }

            var err;
            if (remaining === 0) {
                err = decoder.flush();
            } else {
                var l = 4096;
                if (l > remaining) {
                    l = remaining;
                }
                var tmp = new Uint8Array(data, pos, remaining);
                
                err = decoder.push_data(tmp);
                
                pos += l;
                remaining -= l;
            }
            if (!libde265.de265_isOK(err)) {
                that._set_error(err, libde265.de265_get_error_text(err));
                return;
            }

            if (that.ratio !== ratio) {
                decoder.set_framerate_ratio(that.ratio);
                ratio = that.ratio;
            }

            if (that.filters !== filters) {
                decoder.disable_filters(that.filters);
                filters = that.filters;
            }

            decoder.decode(function(err) {
                switch (err) {
                    case libde265.DE265_ERROR_WAITING_FOR_INPUT_DATA:
                        setTimeout(decode, 0);
                        return;

                    default:
                        if (!libde265.de265_isOK(err)) {
                            that._set_error(err, libde265.de265_get_error_text(err));
                            return;
                        }
                }

                if (remaining > 0 || decoder.has_more()) {
                    setTimeout(decode, 0);
                    return;
                }

                decoder.free();
                that.stop();
            });
        };

        setTimeout(decode, 0);
    };

    /** @expose */
    RawPlayer.prototype.playback = function(url) {
        this._reset();
        var request = new XMLHttpRequest();
        request.open("get", url, true);
        request.responseType = "arraybuffer";
        var that = this;
        request.onload = function(event) {
            console.log('----------------------------------------');
            ;
            console.log('----------------------------------------');
            that._handle_onload(request, event);
        };
        this._set_status("loading");
        this.running = true;
        request.send();
    };

    /** @expose */
    RawPlayer.prototype.stop = function() {
        this._set_status("stopped");
        this._reset();
    };

    /** @expose */
    RawPlayer.prototype.set_framerate_ratio = function(ratio) {
        this.ratio = ratio;
    };

    /** @expose */
    RawPlayer.prototype.disable_filters = function(disable) {
        this.filters = disable;
    };

    /**
     * A simple raw stream bitstream player interface.
     *
     * @constructor
     */
    var StreamPlayer = function(canvas) {
        //;
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
        this.status_cb = null;
        this.error_cb = null;
        this.ratio = null;
        this.filters = false;
        this._reset();
    };

    StreamPlayer.prototype._reset = function() {
        this.start = null;
        this.frames = 0;
        this.image_data = null;
        this.running = false;
        this.pending_image_data = null;
    };

    /** @expose */
    StreamPlayer.prototype.set_status_callback = function(callback) {
        this.status_cb = callback;
    };

    StreamPlayer.prototype._set_status = function() {
        if (this.status_cb) {
            this.status_cb.apply(this.status_cb, arguments);
        }
    };

    /** @expose */
    StreamPlayer.prototype.set_error_callback = function(callback) {
        this.error_cb = callback;
    };

    StreamPlayer.prototype._set_error = function(error, message) {
        if (this.error_cb) {
            this.error_cb(error, message);
        }
    };

    StreamPlayer.prototype._display_image = function(image) {
        // console.log(this.frames)
        if (!this.start) {
            this.start = new Date();
            this._set_status("playing");
        } else {
            this.frames += 1;
            var duration = (new Date()) - this.start;
            if (duration > 1000) {
                this._set_status("fps", this.frames / (duration * 0.001));
            }
        }

        var w = image.get_width();
        var h = image.get_height();
        if (w != this.canvas.width || h != this.canvas.height || !this.image_data) {
            this.canvas.width = w;
            this.canvas.height = h;
            this.image_data = this.ctx.createImageData(w, h);
            var image_data = this.image_data.data;
            for (var i = 0; i < w * h; i++) {
                image_data[i * 4 + 3] = 255;
            }
        }

        var that = this;
        image.display(this.image_data, function(display_image_data) {
            // 
            if (window.requestAnimationFrame) {
                that.pending_image_data = display_image_data;
                window.requestAnimationFrame(function() {
                    if (that.pending_image_data) {
                        that.ctx.putImageData(that.pending_image_data, 0, 0);
                        that.pending_image_data = null;
                    }
                });
            } else {
                that.ctx.putImageData(display_image_data, 0, 0);
            }
        });
    };

    const appendByteArray = function(buffer1, buffer2) {
        // 
        // 
        const a = new Uint8Array(buffer1),
            b = new Uint8Array(buffer2);
        const tmp = new Uint8Array((buffer1.byteLength | 0) + (buffer2.byteLength | 0));
        tmp.set(a, 0);
        tmp.set(b, a.byteLength | 0);
        return tmp;
    }

    StreamPlayer.prototype.initLoginPlay = function(cameraIp) {
        console.log('init', event)
        return new Promise(((resolve, reject) => {
            request('POST', 'api/login', {
                username: 'a',
                password: 'a'
            }).then((data) => {
                request('POST', 'api/stream', {
                    ip: cameraIp
                }, data.token).then((camera) => {
                    camera.token = data.token
                    // 
                        // return camera
                    resolve(camera)
                }).catch((err) => {
                    
                    reject(err)
                        // return err
                })
            })
        }))
    }

    StreamPlayer.prototype.initPlay = function(cameraIp) {
        return new Promise(((resolve, reject) => {
            request('POST', 'api/stream', {
                ip: cameraIp
            }, data.token).then((camera) => {
                camera.token = data.token
                // 
                    // return camera
                resolve(camera)
            }).catch((err) => {
                // 
                reject(err)
                    // return err
            })
        }))
    }

    StreamPlayer.prototype.playbackStop = function(cameraIp, token) {
        return new Promise(((resolve, reject) => {
            request('POST', 'api/stream/stop', {
                ip: cameraIp
            }, token).then((camera) => {
                // camera.token = data.token
                this.stop();
                // 
                    // return camera
                resolve(camera)
            }).catch((err) => {
                // 
                reject(err)
                    // return err
            })
        }))
    }

    StreamPlayer.prototype.download = function() {
        // console.log('download')
        const video = new Blob([fileBuffer], { type: 'video/hevc' });
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        const url = window.URL.createObjectURL(video);
        a.href = url;
        a.download = 'demo.mkv';
        a.click();
        window.URL.revokeObjectURL(url);
    }

    StreamPlayer.prototype._handle_onload = function(ws) {
        var that = this;
        this._set_status("initializing");

        var decoder = new Decoder();
        decoder.set_image_callback(function(image) {
            that._display_image(image);
            image.free();
        });
        /**/
        var ratio = null;
        var filters = false;
        var chunk_size = 4096;
        var fps = 15.0;

        var decode = function(evt) {
            if (evt == null) {
                return;
            }

            if (!that.running) {
                return;
            }

            var err;
            //            ;
            if (evt.data == null) {
                err = decoder.flush();
            } else {

                let arrayBuffer = evt.data;
                try {

                    // var tmp = new Uint8Array(arrayBuffer);

                    // if (!fileBuffer) {
                    //fileBuffer = evt.data
                    // var tmp = new Uint8Array(arrayBuffer);
                    //   fileBuffer = tmp
                    //}

                    // console.log(arrayBuffer['Uint8Array'])
                    // fileBuffer = appendByteArray(fileBuffer, evt.data);
                    // var tmp = new Uint8Array(arrayBuffer);
                    //var tmp = new Uint8Array(evt.data, 0, evt.data.byteLength);
                    // fileBuffer = appendByteArray(fileBuffer, tmp);
                    /*
                    Module['HEAP8'] = HEAP8 = new Int8Array(buffer);
        Module['HEAP16'] = HEAP16 = new Int16Array(buffer);
        Module['HEAP32'] = HEAP32 = new Int32Array(buffer);
        Module['HEAPU8'] = HEAPU8 = new Uint8Array(buffer);
        Module['HEAPU16'] = HEAPU16 = new Uint16Array(buffer);
        Module['HEAPU32'] = HEAPU32 = new Uint32Array(buffer);
        Module['HEAPF32'] = HEAPF32 = new Float32Array(buffer);
        Module['HEAPF64'] = HEAPF64 = new Float64Array(buffer);
                    */
                    var tmp = new Uint8Array(arrayBuffer);
                    err = decoder.push_data(tmp);



                    //



                } catch (err) {
                    ;
                    err = decoder.flush();
                    return;
                }
            }
            if (!libde265.de265_isOK(err)) {
                that._set_error(err, libde265.de265_get_error_text(err));
                return;
            }

            if (that.ratio !== ratio) {
                decoder.set_framerate_ratio(that.ratio);
                ratio = that.ratio;
            }

            if (that.filters !== filters) {
                decoder.disable_filters(that.filters);
                filters = that.filters;
            }

            decoder.decode(function(err) {
                //;
                switch (err) {
                    case libde265.DE265_ERROR_WAITING_FOR_INPUT_DATA:
                        // console.log("DE265_ERROR_WAITING_FOR_INPUT_DATA");
                        setTimeout(decode(null), 0);
                        return;

                    default:
                        if (!libde265.de265_isOK(err)) {
                            that._set_error(err, libde265.de265_get_error_text(err));
                            return;
                        }
                }

                if (decoder.has_more()) {
                    //console.log("has more");
                    setTimeout(decode(null), 0);
                    return;
                }

                decoder.free();
                that.stop();
            });
        };

        ws.onmessage = decode;

        // Start the transaction
        ws.send("chunk_size " + chunk_size);
        ws.send("fps " + fps);
        ws.send("start");
    };

    /** @expose */
    StreamPlayer.prototype.playback = function(url_address) {
        this._reset();

        var that = this;

        var ws = new WebSocket(url_address);
        ws.binaryType = "arraybuffer";
        /* ; */
        ws.onopen = function() {
           /*console.log("Stream open");*/
            that._handle_onload(ws);
        };

        ws.onclose = function() {
            console.log("Connection closed.");
        }

        this._set_status("loading");
        this.running = true;
    };

    /** @expose */
    StreamPlayer.prototype.stop = function() {
        this._set_status("stopped");
        this._reset();
    };

    /** @expose */
    StreamPlayer.prototype.set_framerate_ratio = function(ratio) {
        this.ratio = ratio;
    };

    /** @expose */
    StreamPlayer.prototype.disable_filters = function(disable) {
        this.filters = disable;
    };

    /**
     * @expose
     */
    libde265.RawPlayer = RawPlayer;
    libde265.StreamPlayer = StreamPlayer;

    var root = this;

    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            /** @expose */
            exports = module.exports = libde265;
        }
        /** @expose */
        exports.libde265 = libde265;
    } else {
        /** @expose */
        root.libde265 = libde265;
    }

    if (typeof define === "function" && define.amd) {
        /** @expose */
        define([], function() {
            return libde265;
        });
    }

    // NOTE: wrapped inside "(function() {" block from pre.js
}).call(this);

const host = 'http://localhost:3002'
    //const host = 'http://srvstreambeta.westeurope.cloudapp.azure.com:3002'
const request = function(method, endpoint, data = {}, token = '') {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    if (token !== '')
        headers.append('Authorization', `Bearer ${token}`);
    return new Promise((resolve, reject) => {
        const myRequest = new Request(`${host}/${endpoint}`, {
            headers,
            method,
            mode: 'cors',
            body: JSON.stringify(data)
        })
        fetch(myRequest).then(response => response.json())
            .then((body) => {
                resolve(body)
            }).catch((err) => {
                reject(err)
            })
    })
}

const init = () => {
    return new Promise((resolve, reject) => {
        request('POST', 'api/login', {
            username: 'a',
            password: 'a'
        }).then((data) => {
            request('POST', 'api/stream', {
                ip: cameraIp
            }, data.token).then((camera) => {
                
                camera.token = data.token
                resolve(camera)
            }).catch((err) => {
                reject(err)
            })
        }).catch((err) => {
            reject(err)
        })
    })
}
/*
azure-maps-html-marker-layer Version: 0.0.1

MIT License

    Copyright (c) Microsoft Corporation.

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE
*/

(function (exports, azmaps) {
    'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    /**
     * Helper class for merging namespaces.
     */
    var Namespace = /** @class */ (function () {
        function Namespace() {
        }
        Namespace.merge = function (namespace, base) {
            var context = window || global;
            var parts = namespace.split(".");
            for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
                var part = parts_1[_i];
                if (context[part]) {
                    context = context[part];
                }
                else {
                    return base;
                }
            }
            return __assign(__assign({}, context), base);
        };
        return Namespace;
    }());

    /**
     * A layer that renders point data from a data source as HTML elements on the map.
     */
    var HtmlMarkerLayer = /** @class */ (function (_super) {
        __extends(HtmlMarkerLayer, _super);
        /*********************
         * Constructor
         *********************/
        /**
        * Constructs a new HtmlMarkerLayer.
        * @param source The id or instance of a data source which the layer will render.
        * @param id The id of the layer. If not specified a random one will be generated.
        * @param options The options of the Html marker layer.
        */
        function HtmlMarkerLayer(source, id, options) {
            var _this = _super.call(this, source, id) || this;
            /*********************
             * Private Properties
             *********************/
            _this._options = {
                minZoom: 0,
                maxZoom: 24,
                visible: true,
                updateWhileMoving: false,
                filter: ['==', ['geometry-type'], 'Point'],
                markerCallback: function (id, position, properties) {
                    if (properties.cluster) {
                        return new azmaps.HtmlMarker({
                            position: position,
                            text: properties.point_count_abbreviated
                        });
                    }
                    else {
                        return new azmaps.HtmlMarker({
                            position: position
                        });
                    }
                }
            };
            _this._markers = [];
            _this._markerIds = [];
            _this._markerCache = {};
            /** Events supported by the HTML Marker Layer */
            _this._supportedEvents = ["click", "contextmenu", "dblclick", "drag", "dragstart", "dragend", "keydown", "keypress", "keyup", "mousedown", "mouseenter", "mouseleave", "mousemove", "mouseout", "mouseover", "mouseup"];
            /*********************
             * Private methods
             *********************/
            /** Event handler for when the map moves. */
            _this._mapMoved = function () {
                if (_this._options.updateWhileMoving) {
                    _this._updateMarkers();
                }
            };
            /**
             * Event handler for when a data source in the map changes.
             */
            _this._sourceUpdated = function (e) {
                var s = _this._getSourceClass();
                if (s && s.getId() === e.source.id) {
                    //this._clearCache(true);
                    //Check to see if there is a timer already waiting, if so, remove it.
                    if (_this._timer) {
                        clearTimeout(_this._timer);
                    }
                    //Wait 33ms (~30 frames per second) before processing the update. This will help throttle updates.
                    //@ts-ignore
                    _this._timer = setTimeout(_this._sourceUpdater, 33);
                }
            };
            /**
             * Throttled event handler for updating the clearing cache.
             */
            _this._sourceUpdater = function () {
                //Clear the timer.
                _this._timer = null;
                //Clear the cache and force an update if the data source has changed.
                _this._clearCache(true);
            };
            /**
             * Main function that updates all displayed markers on the map.
             */
            _this._updateMarkers = function () { return __awaiter(_this, void 0, void 0, function () {
                var self, map, markers, opt, zoom, source, sourceId, shapes, newMarkers, newMarkerIds, id, properties, position, shape, feature, marker, i, len, i;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            self = this;
                            map = self._map;
                            markers = self._markers;
                            opt = self._options;
                            zoom = (map) ? map.getCamera().zoom : undefined;
                            if (!(opt.visible && zoom !== undefined && zoom >= opt.minZoom && zoom <= opt.maxZoom)) return [3 /*break*/, 5];
                            source = self.getSource();
                            sourceId = (typeof source === 'string') ? source : source.getId();
                            shapes = map.map.querySourceFeatures(sourceId, {
                                sourceLayer: self.getOptions().sourceLayer,
                                filter: opt.filter
                            });
                            newMarkers = [];
                            newMarkerIds = [];
                            id = void 0;
                            properties = void 0;
                            position = void 0;
                            shape = void 0;
                            feature = void 0;
                            marker = void 0;
                            i = 0, len = shapes.length;
                            _a.label = 1;
                        case 1:
                            if (!(i < len)) return [3 /*break*/, 4];
                            marker = null;
                            id = null;
                            if (shapes[i] instanceof azmaps.Shape) {
                                shape = shapes[i];
                                if (shape.getType() === 'Point') {
                                    position = shape.getCoordinates();
                                    properties = shape.getProperties();
                                    id = shape.getId();
                                }
                            }
                            else {
                                feature = shapes[i];
                                if (feature.geometry.type === 'Point') {
                                    position = feature.geometry.coordinates;
                                    properties = feature.properties;
                                    //Check to see if the point represents a clustered point from a GeoJSON data source. Vector tile sources may have cluster data, but may not align with the same property schema.
                                    if (properties && properties.cluster) {
                                        id = 'cluster_' + feature.properties.cluster_id;
                                    }
                                    else if (feature.id) {
                                        id = feature.id;
                                    }
                                }
                            }
                            if (!position) return [3 /*break*/, 3];
                            return [4 /*yield*/, self._getMarker(id, position, properties)];
                        case 2:
                            marker = _a.sent();
                            //Add marker events to wrap layer events.
                            if (!marker._eventsAttached) {
                                self._addEvents(marker);
                                marker._eventsAttached = true;
                            }
                            if (marker) {
                                if (marker.id) {
                                    newMarkerIds.push(marker.id);
                                }
                                if (!marker.id || self._markerIds.indexOf(marker.id) === -1) {
                                    newMarkers.push(marker);
                                    map.markers.add(marker);
                                }
                            }
                            _a.label = 3;
                        case 3:
                            i++;
                            return [3 /*break*/, 1];
                        case 4:
                            //Remove all markers that are no longer in view. 
                            for (i = markers.length - 1; i >= 0; i--) {
                                if (!markers[i].id || newMarkerIds.indexOf(markers[i].id) === -1) {
                                    map.markers.remove(markers[i]);
                                    markers.splice(i, 1);
                                }
                            }
                            self._markers = markers.concat(newMarkers);
                            self._markerIds = newMarkerIds;
                            return [3 /*break*/, 6];
                        case 5:
                            if (self._markers.length > 0) {
                                map.markers.remove(self._markers);
                                self._markers = [];
                            }
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); };
            /**
             * A simple event handler wrapper.
             * @param e Event arg. Will be a TargetedEvent from an HTML Marker.
             */
            _this._wrappedEvent = function (e) {
                _this.map.events.invoke(e.type, _this, e);
            };
            _super.prototype.setOptions.call(_this, {
                color: 'transparent',
                radius: 0,
                strokeWidth: 0
            });
            _this.setOptions(options || {});
            return _this;
        }
        /*********************
         * Public methods
         *********************/
        /**
        * Gets the options of the Html Marker layer.
        */
        HtmlMarkerLayer.prototype.getOptions = function () {
            return Object.assign({}, this._options);
        };
        /**
        * Sets the options of the Html marker layer.
        * @param options The new options of the Html marker layer.
        */
        HtmlMarkerLayer.prototype.setOptions = function (options) {
            var self = this;
            var opt = self._options;
            var newBaseOptions = {};
            var cc = false;
            if (options.source && opt.source !== options.source) {
                opt.source = options.source;
                newBaseOptions.source = options.source;
                cc = true;
            }
            if (options.sourceLayer && opt.sourceLayer !== options.sourceLayer) {
                opt.sourceLayer = options.sourceLayer;
                newBaseOptions.sourceLayer = options.sourceLayer;
                cc = true;
            }
            if (options.filter && opt.filter !== options.filter) {
                opt.filter = options.filter;
                newBaseOptions.filter = options.filter;
                cc = true;
            }
            if (typeof options.minZoom === 'number' && opt.minZoom !== options.minZoom) {
                opt.minZoom = options.minZoom;
                newBaseOptions.minZoom = options.minZoom;
            }
            if (typeof options.maxZoom === 'number' && opt.maxZoom !== options.maxZoom) {
                opt.maxZoom = options.maxZoom;
                newBaseOptions.maxZoom = options.maxZoom;
            }
            if (typeof options.visible !== 'undefined' && opt.visible !== options.visible) {
                opt.visible = options.visible;
                newBaseOptions.visible = options.visible;
            }
            if (options.markerCallback && opt.markerCallback != options.markerCallback) {
                opt.markerCallback = options.markerCallback;
                cc = true;
            }
            if (typeof options.updateWhileMoving === 'boolean' && opt.updateWhileMoving !== options.updateWhileMoving) {
                opt.updateWhileMoving = options.updateWhileMoving;
            }
            if (cc) {
                self._clearCache(true);
            }
            else {
                self._updateMarkers();
            }
            _super.prototype.setOptions.call(this, newBaseOptions);
        };
        /** Force the layer to refresh and update. */
        HtmlMarkerLayer.prototype.update = function () {
            this._clearCache(true);
            this._updateMarkers();
        };
        /***************************
         * Public override methods
         ***************************/
        //Override the layers onAdd function. 
        HtmlMarkerLayer.prototype.onAdd = function (map) {
            var self = this;
            var mapEvents = map.events;
            if (map) {
                mapEvents.remove('moveend', self._updateMarkers);
                mapEvents.remove('move', self._mapMoved);
                mapEvents.remove('sourcedata', self._sourceUpdated);
            }
            self._map = map;
            mapEvents = map.events;
            mapEvents.add('moveend', self._updateMarkers);
            mapEvents.add('move', self._mapMoved);
            mapEvents.add('sourcedata', self._sourceUpdated);
            //Call the underlying functionaly for this.
            _super.prototype.onAdd.call(this, map);
        };
        //Override the layers onRemove function.
        HtmlMarkerLayer.prototype.onRemove = function () {
            var self = this;
            var map = self._map;
            if (map) {
                var mapEvents = map.events;
                mapEvents.remove('moveend', self._updateMarkers);
                mapEvents.remove('move', self._mapMoved);
                mapEvents.remove('sourcedata', self._sourceUpdated);
            }
            self._clearCache(false);
            self._map = null;
            _super.prototype.onRemove.call(this);
        };
        /**
         * Gets the source class of the layer.
         */
        HtmlMarkerLayer.prototype._getSourceClass = function () {
            var self = this;
            var s = self.getSource();
            if (typeof s === 'string' && self._map !== null) {
                return self._map.sources.getById(s);
            }
            else if (s instanceof azmaps.source.Source) {
                return s;
            }
            return null;
        };
        /**
         * Clears the marker cache.
         * @param update A boolean indicating if the layer should rerender/update after clearing the cache.
         */
        HtmlMarkerLayer.prototype._clearCache = function (update) {
            var self = this;
            self._markerCache = {}; //Clear marker cache. 
            if (self._map) {
                for (var i = 0, len = self._markers.length; i < len; i++) {
                    var m = self._markers[i];
                    //Remove wrapped events from marker.
                    self._removeEvents(m);
                    m._eventsAttached = false;
                    //Remove marker from map.
                    self._map.markers.remove(m);
                }
            }
            self._markers = [];
            self._markerIds = [];
            if (update) {
                self._updateMarkers();
            }
        };
        /**
         * Gets a marker either from cache or from the rendering callback.
         * @param id The id of the marker.
         * @param position The position of the marker.
         * @param properties The properties of the marker.
         */
        HtmlMarkerLayer.prototype._getMarker = function (id, position, properties) {
            var self = this;
            var markerCache = self._markerCache;
            var opt = self._options;
            if (!id) {
                //If no id, create an ID based on the position and properties.
                id = position.join(',') + JSON.stringify(properties || {});
            }
            //Check cache for existing marker.
            if (markerCache[id]) {
                return markerCache[id];
            }
            else {
                var callbackResult_1 = opt.markerCallback(id, position, properties);
                if (callbackResult_1 instanceof azmaps.HtmlMarker) {
                    var m = self._getExtendedMarker(callbackResult_1, id, position, properties);
                    if (m) {
                        markerCache[id] = m;
                        return Promise.resolve(m);
                    }
                }
                else {
                    return new Promise(function (resolve) {
                        callbackResult_1.then(function (marker) {
                            var m = self._getExtendedMarker(marker, id, position, properties);
                            if (m) {
                                markerCache[id] = m;
                                resolve(m);
                            }
                        });
                    });
                }
                return null;
            }
        };
        HtmlMarkerLayer.prototype._getExtendedMarker = function (marker, id, position, properties) {
            var result = marker;
            if (result) {
                result.properties = properties;
                result.id = id;
                //Make sure position is set.
                result.setOptions({
                    position: position
                });
                return result;
            }
            return null;
        };
        /**
         * Wraps all events on a marker.
         * @param marker Marker to wrap events on.
         */
        HtmlMarkerLayer.prototype._addEvents = function (marker) {
            var self = this;
            self._supportedEvents.forEach(function (e) {
                //@ts-ignore
                self.map.events.add(e, marker, self._wrappedEvent);
            });
        };
        /**
         * Removes all wrapped events on a marker.
         * @param marker Marker to remove events from.
         */
        HtmlMarkerLayer.prototype._removeEvents = function (marker) {
            var self = this;
            self._supportedEvents.forEach(function (e) {
                //@ts-ignore
                self.map.events.remove(e, marker, self._wrappedEvent);
            });
        };
        return HtmlMarkerLayer;
    }(azmaps.layer.BubbleLayer));



    var baseLayer = /*#__PURE__*/Object.freeze({
        __proto__: null,
        HtmlMarkerLayer: HtmlMarkerLayer
    });

    /**
     * A class for creating Pie Charts as HTML Markers on a map.
     */
    var PieChartMarker = /** @class */ (function (_super) {
        __extends(PieChartMarker, _super);
        /********************
        * Constructor
        ********************/
        /**
         * Creates an HTML Marker in the shape of a pie chart.
         * @param options Options for rendering the Pie Chart marker.
         */
        function PieChartMarker(options) {
            var _this = _super.call(this, options) || this;
            /********************
            * Private Properties
            ********************/
            _this._options = {
                values: [],
                radius: 40,
                colors: ['#d7191c', '#fdae61', '#ffffbf', '#abdda4', '#2b83ba'],
                fillColor: 'transparent',
                strokeWidth: 0,
                strokeColor: '#666666',
                innerRadius: 0
            };
            /** The total of all values. */
            _this._total = 0;
            /** Any additional properties that you want to store with the marker. */
            _this.properties = {};
            _super.prototype.setOptions.call(_this, {
                htmlContent: document.createElement('div'),
                pixelOffset: [0, 0],
                anchor: 'center'
            });
            _this.setOptions(options);
            return _this;
        }
        /**
         * Gets the total value of all slices summed togehter.
         * @returns The total value of all slices summed togehter.
         */
        PieChartMarker.prototype.getTotalValue = function () {
            return this._total;
        };
        /**
         * Gets the value of a slice of the pie based on it's index.
         * @param idx The index of the slice.
         * @returns The value of a slice of the pie based on it's index.
         */
        PieChartMarker.prototype.getSliceValue = function (idx) {
            var vals = this._options.values;
            return (idx >= 0 && idx < vals.length) ? vals[idx] : 0;
        };
        /**
         * Gets the percentage value of a slice of the pie based on it's index.
         * @param idx The index of the slice.
         * @returns The percentage value of a slice of the pie based on it's index.
         */
        PieChartMarker.prototype.getSlicePercentage = function (idx) {
            var self = this;
            return (self._total > 0) ? Math.round(self.getSliceValue(idx) / self._total * 10000) / 100 : 0;
        };
        /**
         * Gets the options of the pie chart marker.
         * @returns The options of the pie chart marker.
         */
        PieChartMarker.prototype.getOptions = function () {
            return Object.assign({}, _super.prototype.getOptions.call(this), this._options);
        };
        /**
         * Sets the options of the pie chart marker.
         * @param options The options to set on the marker.
         */
        PieChartMarker.prototype.setOptions = function (options) {
            var self = this;
            var opt = self._options;
            var stringify = JSON.stringify;
            var rerender = false;
            if (options.radius && options.radius > 0 && options.radius != opt.radius) {
                opt.radius = options.radius;
                rerender = true;
            }
            if (options.innerRadius >= 0 && options.innerRadius != opt.innerRadius) {
                opt.innerRadius = options.innerRadius;
                rerender = true;
            }
            if (options.colors && stringify(options.colors) !== stringify(opt.colors)) {
                opt.colors = options.colors;
                rerender = true;
            }
            if (options.fillColor && stringify(options.fillColor) !== stringify(opt.fillColor)) {
                opt.fillColor = options.fillColor;
                rerender = true;
            }
            if (options.strokeColor && options.strokeColor !== opt.strokeColor) {
                opt.strokeColor = options.strokeColor;
                rerender = true;
            }
            if (options.strokeWidth >= 0 && options.strokeWidth != opt.strokeWidth) {
                opt.strokeWidth = options.strokeWidth;
                rerender = true;
            }
            if (options.tooltipCallback !== undefined && opt.tooltipCallback != options.tooltipCallback) {
                opt.tooltipCallback = options.tooltipCallback;
                rerender = true;
            }
            if (options.values && stringify(options.values) !== stringify(opt.values)) {
                opt.values = options.values;
                rerender = true;
            }
            if (options.text !== undefined && options.text !== opt.text) {
                //opt.text = options.text;
                _super.prototype.setOptions.call(this, { text: options.text });
                rerender = true;
            }
            if (options.textClassName !== undefined && options.textClassName !== opt.textClassName) {
                opt.textClassName = options.textClassName;
                rerender = true;
            }
            if (rerender) {
                self._render();
            }
            _super.prototype.setOptions.call(this, options);
        };
        /********************
        * Private Methods
        ********************/
        /**
         * Method that generates the SVG pie chart for the marker.
         */
        PieChartMarker.prototype._render = function () {
            var self = this;
            var opt = self._options;
            var data = opt.values;
            var radius = opt.radius;
            var startAngle = 0, angle = 0;
            if (data) {
                self._total = data.reduce(function (a, b) {
                    return a + b;
                }, 0);
                //Ensure that there are enough colors defined.
                var moreColors = PieChartMarker._moreColors;
                var random = Math.random;
                var round = Math.round;
                var mIdx = 0;
                while (data.length > opt.colors.length) {
                    //Generate additional random colors, but try and stagger them such that there is a good variation between agenct colors.
                    if (moreColors.length < data.length) {
                        moreColors.push("hsl(" + round(random() * 360) + "," + (round(random() * 20) + 70) + "%," + (round(random() * 40) + 30) + "%)");
                    }
                    //Grab the next additional color from the global pallet.
                    opt.colors.push(moreColors[mIdx]);
                    mIdx++;
                }
                //Origin for cx/cy
                var o = radius + opt.strokeWidth;
                var svg = ["<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"" + 2 * o + "px\" height=\"" + 2 * o + "px\">"];
                var tooltip = '';
                var maskId = void 0;
                if (opt.innerRadius > 0 && opt.innerRadius <= opt.radius) {
                    maskId = 'piechart-innercircle-' + round(random() * 10000000);
                    svg.push("<defs><mask id=\"" + maskId + "\"><rect width=\"100%\" height=\"100%\" fill=\"white\"/><circle r=\"" + opt.innerRadius + "\" cx=\"" + o + "\" cy=\"" + o + "\" fill=\"black\"/></mask></defs>\n                    <circle r=\"" + opt.innerRadius + "\" cx=\"" + o + "\" cy=\"" + o + "\" style=\"fill:" + opt.fillColor + ";stroke:" + opt.strokeColor + ";stroke-width:" + opt.strokeWidth * 2 + "px;\"/>");
                }
                if (self._total > 0) {
                    var ttc = opt.tooltipCallback;
                    var ratio = Math.PI * 2 / self._total;
                    for (var i = 0; i < data.length; i++) {
                        angle = ratio * data[i];
                        if (ttc) {
                            tooltip = ttc(self, i);
                        }
                        var c = (i < opt.colors.length) ? opt.colors[i] : moreColors[i];
                        svg.push(self._createSlice(o, o, radius, startAngle, angle, c, tooltip, maskId));
                        startAngle += angle;
                    }
                }
                var text = self.getOptions().text;
                if (text) {
                    svg.push("<text x=\"" + o + "\" y=\"" + (o + 7) + "\" style=\"font-size:16px;font-family:arial;fill:#000;font-weight:bold;\" class=\"" + (opt.textClassName || '') + "\" text-anchor=\"middle\">" + text + "</text>");
                }
                svg.push('</svg>');
                _super.prototype.getOptions.call(this).htmlContent.innerHTML = svg.join('');
            }
        };
        /**
         * Generates the SVG path for an arc slice of a pie.
         * @param cx Center x-origin of the arc.
         * @param cy Center y-origin of the arc.
         * @param r Radius of arc.
         * @param startAngle The start angle of the arc (0 = up, PI/2 = right, PI = down, 3/2 PI = left)
         * @param angle The angle width of the arc.
         * @param fillColor The fill color of the path.
         * @param tooltip The tooltip text to display when hovered.
         */
        PieChartMarker.prototype._createSlice = function (cx, cy, r, startAngle, angle, fillColor, tooltip, maskId) {
            var opt = this._options;
            var pi = Math.PI;
            var mask = '';
            if (maskId) {
                mask = " mask=\"url(#" + maskId + "\"";
            }
            if (angle > 2 * pi * 0.99) {
                //If the shape is nearly a complete circle, create a circle instead of an arc.
                return "<circle r=\"" + r + "\" cx=\"" + cx + "\" cy=\"" + cy + "\" style=\"fill:" + fillColor + ";stroke:" + opt.strokeColor + ";stroke-width:" + opt.strokeWidth + "px;\"" + mask + "><title>" + tooltip + "</title></circle>";
            }
            var sin = Math.sin;
            var cos = Math.cos;
            var x1 = cx + r * sin(startAngle);
            var y1 = cy - r * cos(startAngle);
            var x2 = cx + r * sin(startAngle + angle);
            var y2 = cy - r * cos(startAngle + angle);
            var x21 = cx + opt.innerRadius * sin(startAngle);
            var y21 = cy - opt.innerRadius * cos(startAngle);
            var x22 = cx + opt.innerRadius * sin(startAngle + angle);
            var y22 = cy - opt.innerRadius * cos(startAngle + angle);
            //Flag for when arcs are larger than 180 degrees in radians.
            var big = 0;
            if (angle > pi) {
                big = 1;
            }
            return "<path d=\"M" + cx + " " + cy + " L " + x1 + " " + y1 + " A " + r + "," + r + " 0 " + big + " 1 " + x2 + " " + y2 + "z\" style=\"fill:" + fillColor + ";stroke:" + opt.strokeColor + ";stroke-width:" + opt.strokeWidth + "px;\"" + mask + "><title>" + tooltip + "</title></path>";
        };
        /** Additional colors to use when enough haven't been specified. */
        PieChartMarker._moreColors = [];
        return PieChartMarker;
    }(azmaps.HtmlMarker));

    var layer = Namespace.merge("atlas.layer", baseLayer);

    exports.PieChartMarker = PieChartMarker;
    exports.layer = layer;

}(this.atlas = this.atlas || {}, atlas));

/**
 * TimeRangeSelector V3.3
 * Selector visual de rangos de tiempo semanales
 * 
 * @author Claude
 * @version 3.3.0
 * @license MIT
 * 
 * Características V3.3:
 * - Sistema de selección (click para activar)
 * - Fix responsive (ancho mínimo + scroll horizontal)
 * - ⭐ NUEVO: Alt + Drag para copiar bloques
 * - Crear, mover, redimensionar, eliminar bloques
 * - Modo responsive inteligente
 * - Validación de colisiones con gap
 * - Snap automático a grid
 * - Dos modos: normal y prohibir
 * - Modo disabled
 * 
 * Cambios V3.3:
 * - Añadido: Alt + Drag para copiar bloques
 * - Añadido: Preview visual de copia con línea punteada
 * - Añadido: Conversión dinámica entre mover y copiar
 */

(function (window) {
  'use strict';

  class TimeRangeSelector {
    /**
     * Constructor
     * @param {HTMLElement|string} container - Elemento DOM o selector
     * @param {Object} options - Opciones de configuración
     */
    constructor(container, options = {}) {
      this.container = typeof container === 'string'
        ? document.getElementById(container)
        : container;

      if (!this.container) {
        throw new Error('Container element not found');
      }

      // Configuración por defecto
      this.options = {
        cellWidth: 8,
        cellHeight: 40,
        minutesPerCell: 5,
        startHour: 0,
        endHour: 24,
        gapMinutes: 5,
        snapMinutes: 5,
        responsive: true,
        prohibir: false,
        singleSelect: false,
        days: ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'],
        dayLabels: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
        colors: {
          default: '#f0f0f0',
          disabledSelected: '#8f97c28b',
          disabledProhibir: '#ae898c90',
          selected: '#294adb',
          prohibir: '#dc3545',
          hover: '#5a7dd9',
          hoverProhibir: '#c9302c',
          border: '#ffffff',
          gridLine: '#e0e0e0',
          gridLineMajor: '#bdbdbd',
          blockBorder: '#ffffff',
          blockBorderHover: '#333333',
          selectedBorder: '#FFD700',
          copyBorder: '#00FF00'  // ⭐ NUEVO: Color para preview de copia
        },
        mode: 'normal',
        onChange: null,
        allowDebugging: false,
        ...options
      };

      this.days = this.options.days;
      this.prohibir = this.options.prohibir;
      this.dayLabels = this.options.dayLabels;
      this.currentMode = this.options.mode;
      this.allowDebugging = this.options.allowDebugging;
      this.singleSelect = this.options.singleSelect;

      // Estado
      this.blocks = [];
      this.disabled = false;
      this.nextBlockId = 1;
      this.selectedBlockId = null;
      this.activeBlock = null;
      this.dragState = null;
      this.resizeState = null;
      this.isCreating = false;
      this.createStart = null;
      this.lockedDay = null;
      this.svg = null;
      this.blocksGroup = null;
      this.gridDimensions = null;
      this.minX = 0;
      this.minY = 0;
      
      // ⭐ NUEVO: Estado de tecla Alt para copiar
      this.isAltPressed = false;

      this.init();
    }

    /**
     * Inicializa el selector
     */
    init() {
      this.createSVG();
      this.createGrid();
      this.attachEvents();
      this.attachKeyboardEvents();  // ⭐ NUEVO
    }

    /**
     * Imprime en consola
     * @param {string} text Debug a mostrar
     */
    printDebug(text, ...params) {
      if (this.allowDebugging) {
        console.log(text, ...params);
      }
    }

    /**
     * Indica si un bloque prohibir debe comportarse como bloque bloqueado
     */
    isProhibirLocked(block) {
      return Boolean(this.options.prohibir && block && block.prohibir);
    }

    /**
     * ⭐ NUEVO: Adjunta eventos de teclado para detectar Alt
     */
    attachKeyboardEvents() {
      // Detectar cuando se presiona Alt
      this.handleKeyDown = (e) => {
        if (e.key === 'Alt' || e.altKey) {
          this.isAltPressed = true;
          
          // Cambiar cursor si hay un bloque seleccionado
          if (this.selectedBlockId !== null) {
            this.svg.style.cursor = 'copy';
          }
          
          this.printDebug('[KEYBOARD] Alt presionado - Modo COPIA activado');
          
          // ⭐ Si ya está en drag normal, convertir a drag de copia
          if (this.dragState && !this.dragState.isCopying) {
            this.convertToCopyMode();
          }
        }
      };

      // Detectar cuando se suelta Alt
      this.handleKeyUp = (e) => {
        if (e.key === 'Alt' || !e.altKey) {
          this.isAltPressed = false;
          
          // Restaurar cursor
          if (this.selectedBlockId !== null) {
            this.svg.style.cursor = 'move';
          } else {
            this.svg.style.cursor = 'default';
          }
          
          this.printDebug('[KEYBOARD] Alt soltado - Modo MOVER');
          
          // ⭐ Si está en drag de copia, convertir a drag normal
          if (this.dragState && this.dragState.isCopying) {
            this.convertToMoveMode();
          }
        }
      };

      window.addEventListener('keydown', this.handleKeyDown);
      window.addEventListener('keyup', this.handleKeyUp);
    }

    /**
     * Crea el contenedor SVG
     */
    createSVG() {
      const { minutesPerCell, startHour, endHour, responsive } = this.options;
      const totalMinutes = (endHour - startHour) * 60;
      const cols = totalMinutes / minutesPerCell;
      const rows = this.days.length;

      const containerWidth = this.container.clientWidth || 1200;

      let leftMargin = 50;
      let topMargin = 30;
      let cellHeight = this.options.cellHeight;
      let cellWidth = this.options.cellWidth;

      // Definir anchos mínimos para evitar grid ilegible
      const minGridWidth = 800;
      const minCellWidth = 4;

      if (responsive) {
        if (containerWidth < 600) {
          leftMargin = 35;
          topMargin = 25;
          cellHeight = Math.max(25, Math.min(40, containerWidth / 15));
        }

        const availableWidth = containerWidth - leftMargin - 10;
        cellWidth = Math.floor(availableWidth / cols);

        if (cellWidth < minCellWidth) {
          cellWidth = minCellWidth;
        }

        const calculatedGridWidth = leftMargin + (cols * cellWidth);
        if (calculatedGridWidth < minGridWidth && containerWidth >= 600) {
          cellWidth = Math.floor((minGridWidth - leftMargin) / cols);
        }

        this.options.cellWidth = cellWidth;
        this.options.cellHeight = cellHeight;
      }

      const width = leftMargin + (cols * cellWidth);
      const height = topMargin + (rows * cellHeight);

      this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

      if (width > containerWidth) {
        this.svg.setAttribute('width', width);
      } else {
        this.svg.setAttribute('width', '100%');
      }

      this.svg.setAttribute('height', height);
      this.svg.setAttribute('viewBox', `${this.minX} ${this.minY} ${width} ${height}`);
      this.svg.setAttribute('preserveAspectRatio', 'xMinYMin meet');
      this.svg.style.userSelect = 'none';

      this.container.appendChild(this.svg);
      this.gridDimensions = { leftMargin, topMargin, cols, rows, width, height, containerWidth };

      this.blocksGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.blocksGroup.setAttribute('id', 'blocks-group');
      this.svg.appendChild(this.blocksGroup);
    }

    setDisabled(disabled) {
      this.disabled = disabled;

      if (disabled) {
        this.svg.style.pointerEvents = 'none';
      } else {
        this.svg.style.pointerEvents = 'all';
      }

      this.recreateGrid();
    }

    /**
     * Crea el grid de fondo
     */
    createGrid() {
      const { cellWidth, cellHeight, minutesPerCell, startHour, endHour, colors } = this.options;
      const { leftMargin, topMargin, cols, rows, containerWidth } = this.gridDimensions;

      const isSmall = containerWidth < 600;
      const isTiny = containerWidth < 400;

      // Celdas
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          const x = leftMargin + (col * cellWidth);
          const y = topMargin + (row * cellHeight);
          const cell = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
          cell.setAttribute('x', x);
          cell.setAttribute('y', y);
          cell.setAttribute('width', cellWidth);
          cell.setAttribute('height', cellHeight);
          cell.setAttribute('fill', colors.default);
          cell.setAttribute('stroke', colors.border);
          cell.setAttribute('stroke-width', '0.5');
          cell.setAttribute('data-day', row);
          cell.setAttribute('data-col', col);
          cell.classList.add('grid-cell');
          cell.style.pointerEvents = 'all';
          cell.style.cursor = 'crosshair';
          this.svg.insertBefore(cell, this.blocksGroup);
        }
      }

      // Etiquetas de horas
      let hourStep = 2;
      if (isTiny) hourStep = 6;
      else if (isSmall) hourStep = 4;

      const fontSize = isTiny ? '10' : isSmall ? '11' : '12';

      for (let h = startHour; h <= endHour; h += hourStep) {
        let x = leftMargin + ((h - startHour) * 60 / minutesPerCell) * cellWidth;
        let textX = x;

        if (h === 0) textX += 5;
        if (h === endHour) textX -= 5;

        this.createText(textX, topMargin - 10, h.toString().padStart(2, '0'), 'hour-label', 'middle', fontSize);

        if (h < endHour) {
          this.createLine(x, topMargin, x, topMargin + (rows * cellHeight), colors.gridLineMajor, 1.5);
        }
      }

      // Etiquetas de días
      const dayLabelsFontSize = isTiny ? '9' : isSmall ? '10' : '12';
      const labelsToUse = isTiny ? this.dayLabels.map(d => d.substring(0, 2)) : this.dayLabels;

      for (let row = 0; row < rows; row++) {
        let x = leftMargin - (isTiny ? 5 : 10);
        let y = topMargin + (row * cellHeight);

        this.createText(x, y + cellHeight / 2 + 4, labelsToUse[row], 'day-label', 'end', dayLabelsFontSize);
        this.createLine(leftMargin, y, leftMargin + (cols * cellWidth), y, colors.gridLine, 1);
      }

      this.createLine(leftMargin, topMargin + (rows * cellHeight), leftMargin + (cols * cellWidth), topMargin + (rows * cellHeight), colors.gridLine, 1);
    }

    /**
     * Crea una línea SVG
     */
    createLine(x1, y1, x2, y2, color, strokeWidth) {
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', x1);
      line.setAttribute('y1', y1);
      line.setAttribute('x2', x2);
      line.setAttribute('y2', y2);
      line.setAttribute('stroke', color);
      line.setAttribute('stroke-width', strokeWidth);
      line.style.pointerEvents = 'none';
      this.svg.insertBefore(line, this.blocksGroup);
      return line;
    }

    /**
     * Crea un texto SVG
     */
    createText(x, y, content, className, anchor = 'middle', fontSize = '12') {
      const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      text.setAttribute('x', x);
      text.setAttribute('y', y);
      text.setAttribute('class', className);
      text.setAttribute('text-anchor', anchor);
      text.setAttribute('font-size', fontSize);
      text.setAttribute('fill', '#666');
      text.textContent = content;
      text.style.pointerEvents = 'none';
      this.svg.insertBefore(text, this.blocksGroup);
      return text;
    }

    /**
     * Adjunta eventos del mouse
     */
    attachEvents() {
      this.svg.addEventListener('mousedown', (e) => this.handleMouseDown(e));
      this.svg.addEventListener('mousemove', (e) => this.handleMouseMove(e));
      document.addEventListener('mouseup', (e) => this.handleMouseUp(e));
      this.svg.addEventListener('contextmenu', (e) => e.preventDefault());
    }

    /**
     * Maneja mousedown con sistema de selección
     */
    handleMouseDown(e) {
      if (this.disabled) return;
      if (e.button !== 0) return;
      e.preventDefault();

      const target = e.target;

      // Resize handle - solo si está seleccionado
      if (target.classList.contains('resize-handle')) {
        const blockElement = target.closest('.time-block');
        if (blockElement) {
          const blockId = parseInt(blockElement.getAttribute('data-block-id'));
          if (this.selectedBlockId === blockId) {
            const point = this.getMousePosition(e);
            this.startResize(target, point);
            return;
          }
        }
        return;
      }

      // Botón eliminar - solo si está seleccionado
      if (target.classList.contains('delete-button')) {
        const blockElement = target.closest('.time-block');
        if (blockElement) {
          const blockId = parseInt(blockElement.getAttribute('data-block-id'));
          if (this.selectedBlockId === blockId) {
            e.stopPropagation();
            this.deleteBlock(blockId);
            return;
          }
        }
        return;
      }

      // Click en bloque
      const blockElement = target.closest('.time-block');
      if (blockElement) {
        const blockId = parseInt(blockElement.getAttribute('data-block-id'));
        const block = this.blocks.find(b => b.id === blockId);

        // Primera vez: seleccionar
        if (this.selectedBlockId !== blockId) {
          this.selectBlock(blockId);
          return;
        }

        // Segunda vez: permitir mover (o copiar si Alt está presionado)
        if (this.selectedBlockId === blockId) {
          // Los bloques prohibir quedan fijos: se pueden seleccionar pero no mover/copiar
          if (this.isProhibirLocked(block)) {
            return;
          }

          const point = this.getMousePosition(e);
          this.startDrag(blockId, point);
          return;
        }
      }

      // Click fuera: deseleccionar
      if (this.selectedBlockId !== null) {
        this.deselectBlock();
      }

      // Click en celda: crear nuevo bloque
      if (target.classList.contains('grid-cell')) {
        const day = parseInt(target.getAttribute('data-day'));
        const col = parseInt(target.getAttribute('data-col'));
        this.startCreation({ day, col });
        return;
      }

      const point = this.getMousePosition(e);
      const cell = this.getCellFromPoint(point);
      if (cell) {
        this.startCreation(cell);
      }
    }

    /**
     * Selecciona un bloque
     */
    selectBlock(blockId) {
      this.printDebug('[SELECT] Bloque seleccionado:', blockId);
      this.selectedBlockId = blockId;
      this.blocks.forEach(b => b.selected = b.id === blockId);
      this.renderBlocks();
    }

    /**
     * Deselecciona el bloque actual
     */
    deselectBlock() {
      this.printDebug('[DESELECT] Bloque deseleccionado');
      this.selectedBlockId = null;
      this.blocks.forEach(b => b.selected = false);
      this.renderBlocks();
    }

    /**
     * Maneja mousemove
     */
    handleMouseMove(e) {
      if (this.disabled) return;

      const point = this.getMousePosition(e);

      if (this.resizeState) {
        this.updateResize(point);
      } else if (this.dragState) {
        this.updateDrag(point);
      } else if (this.isCreating) {
        this.updateCreation(point);
      } else {
        this.updateCursor(e.target);
      }
    }

    /**
     * Maneja mouseup
     */
    handleMouseUp(e) {
      if (this.disabled) return;
      if (e.button !== 0) return;

      if (this.resizeState) {
        this.finishResize();
      } else if (this.dragState) {
        this.finishDrag();
      } else if (this.isCreating) {
        this.finishCreation();
      }
    }

    /**
     * Inicia creación de bloque
     */
    startCreation(cell) {
      this.lockedDay = cell.day;
      this.isCreating = true;
      this.createStart = { day: cell.day, col: cell.col };
    }

    /**
     * Actualiza creación durante arrastre
     */
    updateCreation(point) {
      if (!this.isCreating || !this.createStart) return;

      const cell = this.getCellFromPoint(point);
      if (!cell || cell.day !== this.lockedDay) return;

      const startCol = Math.min(this.createStart.col, cell.col);
      const endCol = Math.max(this.createStart.col, cell.col) + 1;

      this.showCreationPreview(this.createStart.day, startCol, endCol);
    }

    /**
     * Finaliza creación
     */
    finishCreation() {
      if (!this.isCreating || !this.createStart) return;

      const preview = this.svg.querySelector('.creation-preview');
      if (preview) {
        const day = parseInt(preview.getAttribute('data-day'));
        const startCol = parseInt(preview.getAttribute('data-start'));
        const endCol = parseInt(preview.getAttribute('data-end'));

        if (endCol - startCol >= 1) {
          const snappedStart = this.snapToGrid(startCol);
          const snappedEnd = this.snapToGrid(endCol);

          if (!this.hasCollision(day, snappedStart, snappedEnd)) {
            this.addBlock(day, snappedStart, snappedEnd, this.currentMode === 'prohibir');
          }
        }

        preview.remove();
      }

      this.isCreating = false;
      this.createStart = null;
      this.lockedDay = null;
    }

    /**
     * Muestra preview durante creación
     */
    showCreationPreview(day, startCol, endCol) {
      let preview = this.svg.querySelector('.creation-preview');

      const { cellWidth, cellHeight, colors } = this.options;
      const { leftMargin, topMargin, containerWidth } = this.gridDimensions;

      const x = leftMargin + (startCol * cellWidth);
      const y = topMargin + (day * cellHeight);
      const width = (endCol - startCol) * cellWidth;
      const height = cellHeight - 4;

      const color = this.currentMode === 'prohibir' ? colors.prohibir : colors.selected;

      if (!preview) {
        preview = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        preview.classList.add('creation-preview');
        preview.style.opacity = '0.6';
        preview.style.pointerEvents = 'none';

        const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        rect.setAttribute('x', x);
        rect.setAttribute('y', y + 2);
        rect.setAttribute('width', width);
        rect.setAttribute('height', height);
        rect.setAttribute('fill', color);
        rect.setAttribute('stroke', colors.blockBorder);
        rect.setAttribute('stroke-width', '2');
        rect.setAttribute('rx', '4');
        preview.appendChild(rect);

        const showText = width > 30;
        if (showText) {
          const isTiny = containerWidth < 400;
          const isSmall = containerWidth < 600;
          const textFontSize = isTiny ? '8' : isSmall ? '9' : '11';

          const timeText = this.getTimeFromColumn(startCol) + ' - ' + this.getTimeFromColumn(endCol);
          const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          text.setAttribute('x', x + width / 2);
          text.setAttribute('y', y + height / 2 + 4);
          text.setAttribute('text-anchor', 'middle');
          text.setAttribute('font-size', textFontSize);
          text.setAttribute('font-weight', 'bold');
          text.setAttribute('fill', 'white');
          text.style.pointerEvents = 'none';
          text.textContent = timeText;
          preview.appendChild(text);
        }

        preview.setAttribute('data-day', day);
        preview.setAttribute('data-start', startCol);
        preview.setAttribute('data-end', endCol);

        this.blocksGroup.appendChild(preview);
      } else {
        const rect = preview.querySelector('rect');
        rect.setAttribute('x', x);
        rect.setAttribute('y', y + 2);
        rect.setAttribute('width', width);

        const existingText = preview.querySelector('text');
        const showText = width > 30;

        if (showText) {
          const isTiny = containerWidth < 400;
          const isSmall = containerWidth < 600;
          const textFontSize = isTiny ? '8' : isSmall ? '9' : '11';
          const timeText = this.getTimeFromColumn(startCol) + ' - ' + this.getTimeFromColumn(endCol);

          if (existingText) {
            existingText.textContent = timeText;
            existingText.setAttribute('x', x + width / 2);
            existingText.setAttribute('y', y + height / 2 + 4);
            existingText.setAttribute('font-size', textFontSize);
          } else {
            const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            text.setAttribute('x', x + width / 2);
            text.setAttribute('y', y + height / 2 + 4);
            text.setAttribute('text-anchor', 'middle');
            text.setAttribute('font-size', textFontSize);
            text.setAttribute('font-weight', 'bold');
            text.setAttribute('fill', 'white');
            text.style.pointerEvents = 'none';
            text.textContent = timeText;
            preview.appendChild(text);
          }
        } else if (existingText) {
          existingText.remove();
        }

        preview.setAttribute('data-day', day);
        preview.setAttribute('data-start', startCol);
        preview.setAttribute('data-end', endCol);
      }
    }

    /**
     * Inicia arrastre de bloque
     */
    startDrag(blockId, point) {
      const block = this.blocks.find(b => b.id === blockId);
      if (!block) return;
      if (this.isProhibirLocked(block)) return;

      this.dragState = {
        blockId: blockId,
        startPoint: point,
        originalStartCol: block.startCol,
        originalEndCol: block.endCol,
        originalDay: block.dia,
        isCopying: this.isAltPressed  // ⭐ NUEVO: guardar si está en modo copia
      };

      this.activeBlock = blockId;
      
      // ⭐ NUEVO: Si está copiando, crear preview
      if (this.isAltPressed) {
        this.printDebug('[COPY] Iniciando copia de bloque', blockId);
        this.createCopyPreview(block);
      }
      
      this.updateBlockElement(block);
    }

    /**
     * ⭐ NUEVO: Crea preview visual de la copia
     */
    createCopyPreview(originalBlock) {
      const { cellWidth, cellHeight, colors } = this.options;
      const { leftMargin, topMargin, containerWidth } = this.gridDimensions;
      
      const x = leftMargin + (originalBlock.startCol * cellWidth);
      const y = topMargin + (originalBlock.dia * cellHeight);
      const width = (originalBlock.endCol - originalBlock.startCol) * cellWidth;
      const height = cellHeight - 4;
      
      const color = originalBlock.prohibir ? colors.prohibir : colors.selected;
      
      // Crear grupo para el preview
      const preview = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      preview.classList.add('copy-preview');
      preview.style.opacity = '0.7';
      preview.style.pointerEvents = 'none';
      
      // Rectángulo del preview con borde punteado
      const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      rect.setAttribute('x', x);
      rect.setAttribute('y', y + 2);
      rect.setAttribute('width', width);
      rect.setAttribute('height', height);
      rect.setAttribute('fill', color);
      rect.setAttribute('stroke', colors.copyBorder);  // Verde para indicar copia
      rect.setAttribute('stroke-width', '3');
      rect.setAttribute('stroke-dasharray', '5,5');  // ⭐ Línea punteada
      rect.setAttribute('rx', '4');
      preview.appendChild(rect);
      
      // Badge "COPIA"
      const badgeWidth = 45;
      const badgeHeight = 16;
      const badge = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      badge.setAttribute('x', x + 5);
      badge.setAttribute('y', y + 7);
      badge.setAttribute('width', badgeWidth);
      badge.setAttribute('height', badgeHeight);
      badge.setAttribute('fill', colors.copyBorder);
      badge.setAttribute('rx', '3');
      preview.appendChild(badge);
      
      const badgeText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      badgeText.setAttribute('x', x + 5 + badgeWidth / 2);
      badgeText.setAttribute('y', y + 7 + badgeHeight / 2 + 4);
      badgeText.setAttribute('text-anchor', 'middle');
      badgeText.setAttribute('font-size', '10');
      badgeText.setAttribute('font-weight', 'bold');
      badgeText.setAttribute('fill', '#000');
      badgeText.textContent = 'COPIA';
      badgeText.style.pointerEvents = 'none';
      preview.appendChild(badgeText);
      
      // Tiempo
      const showText = width > 30;
      if (showText) {
        const isTiny = containerWidth < 400;
        const isSmall = containerWidth < 600;
        const textFontSize = isTiny ? '8' : isSmall ? '9' : '11';
        
        const timeText = this.getTimeFromColumn(originalBlock.startCol) + ' - ' + 
                        this.getTimeFromColumn(originalBlock.endCol);
        const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text.setAttribute('x', x + width / 2);
        text.setAttribute('y', y + height / 2 + 12);
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('font-size', textFontSize);
        text.setAttribute('font-weight', 'bold');
        text.setAttribute('fill', 'white');
        text.style.pointerEvents = 'none';
        text.textContent = timeText;
        preview.appendChild(text);
      }
      
      // Guardar posición inicial
      preview.setAttribute('data-day', originalBlock.dia);
      preview.setAttribute('data-start', originalBlock.startCol);
      preview.setAttribute('data-end', originalBlock.endCol);
      
      this.blocksGroup.appendChild(preview);
    }

    /**
     * Actualiza arrastre
     */
    updateDrag(point) {
      if (!this.dragState) return;

      const { cellWidth, cellHeight } = this.options;
      const deltaX = point.x - this.dragState.startPoint.x;
      const deltaY = point.y - this.dragState.startPoint.y;

      const colOffset = Math.round(deltaX / cellWidth);
      const dayOffset = Math.round(deltaY / cellHeight);

      const blockWidth = this.dragState.originalEndCol - this.dragState.originalStartCol;
      let newStartCol = this.dragState.originalStartCol + colOffset;
      let newEndCol = newStartCol + blockWidth;
      let newDay = this.dragState.originalDay + dayOffset;

      newDay = Math.max(0, Math.min(this.days.length - 1, newDay));
      newStartCol = Math.max(0, newStartCol);
      newEndCol = Math.min(this.gridDimensions.cols, newEndCol);

      newStartCol = this.snapToGrid(newStartCol);
      newEndCol = this.snapToGrid(newEndCol);

      // ⭐ NUEVO: Bifurcación según modo
      if (this.dragState.isCopying) {
        // MODO COPIA: Actualizar preview, NO el bloque original
        if (!this.hasCollision(newDay, newStartCol, newEndCol, this.dragState.blockId)) {
          this.updateCopyPreview(newDay, newStartCol, newEndCol);
        }
      } else {
        // MODO NORMAL: Mover el bloque original
        const block = this.blocks.find(b => b.id === this.dragState.blockId);
        if (!block) return;

        if (!this.hasCollision(newDay, newStartCol, newEndCol, this.dragState.blockId)) {
          block.dia = newDay;
          block.startCol = newStartCol;
          block.endCol = newEndCol;
          this.updateBlockElement(block);
        }
      }
    }

    /**
     * ⭐ NUEVO: Actualiza posición del preview de copia
     */
    updateCopyPreview(day, startCol, endCol) {
      const preview = this.svg.querySelector('.copy-preview');
      if (!preview) return;

      const { cellWidth, cellHeight } = this.options;
      const { leftMargin, topMargin, containerWidth } = this.gridDimensions;
      
      const x = leftMargin + (startCol * cellWidth);
      const y = topMargin + (day * cellHeight);
      const width = (endCol - startCol) * cellWidth;
      const height = cellHeight - 4;
      
      // Actualizar rectángulo
      const rect = preview.querySelector('rect[stroke-dasharray]');
      if (rect) {
        rect.setAttribute('x', x);
        rect.setAttribute('y', y + 2);
        rect.setAttribute('width', width);
      }
      
      // Actualizar badge
      const badge = preview.querySelectorAll('rect')[1];
      if (badge) {
        badge.setAttribute('x', x + 5);
        badge.setAttribute('y', y + 7);
      }
      
      const badgeText = preview.querySelectorAll('text')[0];
      if (badgeText) {
        badgeText.setAttribute('x', x + 5 + 45 / 2);
        badgeText.setAttribute('y', y + 7 + 16 / 2 + 4);
      }
      
      // Actualizar texto de tiempo
      const texts = preview.querySelectorAll('text');
      const timeText = texts[texts.length - 1];
      if (timeText && width > 30) {
        const newTimeText = this.getTimeFromColumn(startCol) + ' - ' + this.getTimeFromColumn(endCol);
        timeText.textContent = newTimeText;
        timeText.setAttribute('x', x + width / 2);
        timeText.setAttribute('y', y + height / 2 + 12);
      }
      
      // Guardar posición para finishDrag
      preview.setAttribute('data-day', day);
      preview.setAttribute('data-start', startCol);
      preview.setAttribute('data-end', endCol);
    }

    /**
     * Finaliza arrastre
     */
    finishDrag() {
      if (!this.dragState) return;

      const originalBlock = this.blocks.find(b => b.id === this.dragState.blockId);
      
      // ⭐ NUEVO: Verificar si estaba en modo copia
      if (this.dragState.isCopying) {
        this.printDebug('[COPY] Finalizando copia');
        
        // 1. Restaurar bloque original a su posición
        if (originalBlock) {
          originalBlock.dia = this.dragState.originalDay;
          originalBlock.startCol = this.dragState.originalStartCol;
          originalBlock.endCol = this.dragState.originalEndCol;
        }
        
        // 2. Obtener posición del preview
        const preview = this.svg.querySelector('.copy-preview');
        if (preview) {
          const newDay = parseInt(preview.getAttribute('data-day'));
          const newStartCol = parseInt(preview.getAttribute('data-start'));
          const newEndCol = parseInt(preview.getAttribute('data-end'));
          
          // 3. Verificar colisión y crear copia
          if (!this.hasCollision(newDay, newStartCol, newEndCol)) {
            this.addBlock(newDay, newStartCol, newEndCol, originalBlock.prohibir);
            this.printDebug('[COPY] Copia creada exitosamente');
          } else {
            this.printDebug('[COPY] No se puede copiar: colisión detectada');
          }
          
          // 4. Remover preview
          preview.remove();
        }
        
      } else {
        // MODO NORMAL: El bloque ya se movió en updateDrag
        this.printDebug('[DRAG] Bloque movido');
      }

      this.dragState = null;
      this.activeBlock = null;
      this.notifyChange();
      this.renderBlocks();
    }

    /**
     * ⭐ NUEVO: Convierte drag normal a drag de copia (cuando se presiona Alt durante drag)
     */
    convertToCopyMode() {
      if (!this.dragState || this.dragState.isCopying) return;
      
      this.printDebug('[MOVE→COPY] Convirtiendo movimiento a copia');
      
      const block = this.blocks.find(b => b.id === this.dragState.blockId);
      if (!block) return;
      
      // Restaurar bloque a posición original
      block.dia = this.dragState.originalDay;
      block.startCol = this.dragState.originalStartCol;
      block.endCol = this.dragState.originalEndCol;
      this.updateBlockElement(block);
      
      // Crear preview de copia
      this.createCopyPreview(block);
      
      // Cambiar a modo copia
      this.dragState.isCopying = true;
      this.svg.style.cursor = 'copy';
    }

    /**
     * ⭐ NUEVO: Convierte drag de copia a drag normal (cuando se suelta Alt durante drag)
     */
    convertToMoveMode() {
      if (!this.dragState || !this.dragState.isCopying) return;
      
      this.printDebug('[COPY→MOVE] Convirtiendo copia a movimiento');
      
      // Obtener posición actual del preview
      const preview = this.svg.querySelector('.copy-preview');
      if (preview) {
        const newDay = parseInt(preview.getAttribute('data-day'));
        const newStartCol = parseInt(preview.getAttribute('data-start'));
        const newEndCol = parseInt(preview.getAttribute('data-end'));
        
        // Mover el bloque original a esa posición
        const block = this.blocks.find(b => b.id === this.dragState.blockId);
        if (block) {
          block.dia = newDay;
          block.startCol = newStartCol;
          block.endCol = newEndCol;
          this.updateBlockElement(block);
        }
        
        // Remover preview
        preview.remove();
      }
      
      // Cambiar a modo mover
      this.dragState.isCopying = false;
      this.svg.style.cursor = 'move';
    }

    /**
     * Inicia redimensionado
     */
    startResize(handle, point) {
      const blockElement = handle.closest('.time-block');
      const blockId = parseInt(blockElement.getAttribute('data-block-id'));
      const block = this.blocks.find(b => b.id === blockId);
      if (!block) return;
      if (this.isProhibirLocked(block)) return;

      const side = handle.getAttribute('data-side');

      this.resizeState = {
        blockId: blockId,
        side: side,
        startPoint: point,
        originalStartCol: block.startCol,
        originalEndCol: block.endCol
      };

      this.activeBlock = blockId;
    }

    /**
     * Actualiza redimensionado
     */
    updateResize(point) {
      if (!this.resizeState) return;

      const block = this.blocks.find(b => b.id === this.resizeState.blockId);
      if (!block) return;

      const { cellWidth } = this.options;
      const deltaX = point.x - this.resizeState.startPoint.x;
      const colOffset = Math.round(deltaX / cellWidth);

      let newStartCol = this.resizeState.originalStartCol;
      let newEndCol = this.resizeState.originalEndCol;

      if (this.resizeState.side === 'left') {
        newStartCol = this.resizeState.originalStartCol + colOffset;
        newStartCol = Math.max(0, Math.min(newEndCol - 1, newStartCol));
      } else {
        newEndCol = this.resizeState.originalEndCol + colOffset;
        newEndCol = Math.max(newStartCol + 1, Math.min(this.gridDimensions.cols, newEndCol));
      }

      newStartCol = this.snapToGrid(newStartCol);
      newEndCol = this.snapToGrid(newEndCol);

      if (!this.hasCollision(block.dia, newStartCol, newEndCol, this.resizeState.blockId)) {
        block.startCol = newStartCol;
        block.endCol = newEndCol;
        this.updateBlockElement(block);
      }
    }

    /**
     * Finaliza redimensionado
     */
    finishResize() {
      this.resizeState = null;
      this.activeBlock = null;
      this.notifyChange();
      this.renderBlocks();
    }

    /**
     * Aplica snap al grid
     */
    snapToGrid(col) {
      const { minutesPerCell, snapMinutes } = this.options;
      const snapCells = snapMinutes / minutesPerCell;
      return Math.round(col / snapCells) * snapCells;
    }

    /**
     * Detecta colisiones
     */
    hasCollision(day, startCol, endCol, excludeBlockId = null) {
      const { gapMinutes, minutesPerCell } = this.options;
      const gapCells = gapMinutes / minutesPerCell;

      for (const block of this.blocks) {
        if (block.id === excludeBlockId) continue;
        if (block.dia !== day) continue;

        const blockStart = block.startCol - gapCells;
        const blockEnd = block.endCol + gapCells;

        if (startCol < blockEnd && endCol > blockStart) {
          return true;
        }
      }

      return false;
    }

    /**
     * Agrega un bloque
     */
    addBlock(day, startCol, endCol, prohibir) {
      if (this.singleSelect) {
        this.blocks = [];
        this.selectedBlockId = null;
      }

      const block = {
        id: this.nextBlockId++,
        dia: day,
        startCol: startCol,
        endCol: endCol,
        prohibir: prohibir,
        selected: false
      };

      this.blocks.push(block);
      this.renderBlocks();
      this.notifyChange();
    }

    /**
     * Elimina un bloque
     */
    deleteBlock(blockId) {
      this.blocks = this.blocks.filter(b => b.id !== blockId);
      this.selectedBlockId = null;
      this.renderBlocks();
      this.notifyChange();
    }

    /**
     * Renderiza todos los bloques
     */
    renderBlocks() {
      this.blocksGroup.innerHTML = '';

      for (const block of this.blocks) {
        const element = this.createBlockElement(block);
        this.blocksGroup.appendChild(element);
      }
    }

    /**
     * Crea el elemento SVG de un bloque
     */
    createBlockElement(block) {
      const { cellWidth, cellHeight, colors } = this.options;
      const { leftMargin, topMargin, containerWidth } = this.gridDimensions;

      const x = leftMargin + (block.startCol * cellWidth);
      const y = topMargin + (block.dia * cellHeight);
      const width = (block.endCol - block.startCol) * cellWidth;
      const height = cellHeight - 4;

      const color = block.prohibir ? colors.prohibir : colors.selected;
      const disabledColor = block.prohibir ? colors.disabledProhibir : colors.disabledSelected;

      const isSelected = this.selectedBlockId === block.id;

      const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      group.classList.add('time-block');
      if (isSelected) {
        group.classList.add('selected');
      }
      group.setAttribute('data-block-id', block.id);
      group.style.pointerEvents = 'all';

      const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      rect.setAttribute('x', x);
      rect.setAttribute('y', y + 2);
      rect.setAttribute('width', width);
      rect.setAttribute('height', height);
      rect.setAttribute('fill', this.disabled ? disabledColor : color);
      rect.setAttribute('stroke', isSelected ? colors.selectedBorder : colors.blockBorder);
      rect.setAttribute('stroke-width', isSelected ? '3' : '2');
      rect.setAttribute('rx', '4');
      rect.style.cursor = this.isProhibirLocked(block)
        ? 'not-allowed'
        : (isSelected ? (this.isAltPressed ? 'copy' : 'move') : 'pointer');  // ⭐ NUEVO

      if (isSelected) {
        rect.setAttribute('filter', 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))');
      }

      group.appendChild(rect);

      const isTiny = containerWidth < 400;
      const isSmall = containerWidth < 600;
      const textFontSize = isTiny ? '8' : isSmall ? '9' : '11';

      const showText = width > 30;

      if (showText) {
        const timeText = this.getTimeFromColumn(block.startCol) + ' - ' + this.getTimeFromColumn(block.endCol);
        const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text.setAttribute('x', x + width / 2);
        text.setAttribute('y', y + height / 2 + 4);
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('font-size', textFontSize);
        text.setAttribute('font-weight', 'bold');
        text.setAttribute('fill', 'white');
        text.style.pointerEvents = 'none';
        text.textContent = timeText;
        group.appendChild(text);
      }

      // Solo mostrar handles y botón si está seleccionado
      if (isSelected) {
        if (!this.isProhibirLocked(block)) {
          this.addResizeHandles(group, x, y, width, height);
          this.addDeleteButton(group, x, y, width);
        }
      }

      return group;
    }

    /**
     * Agrega handles de resize
     */
    addResizeHandles(group, x, y, width, height) {
      const handleWidth = 8;

      const leftHandle = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      leftHandle.setAttribute('x', x);
      leftHandle.setAttribute('y', y + 2);
      leftHandle.setAttribute('width', handleWidth);
      leftHandle.setAttribute('height', height);
      leftHandle.setAttribute('fill', 'rgba(255,255,255,0.3)');
      leftHandle.setAttribute('data-side', 'left');
      leftHandle.classList.add('resize-handle');
      leftHandle.style.cursor = 'ew-resize';
      leftHandle.style.pointerEvents = 'all';
      group.appendChild(leftHandle);

      const rightHandle = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      rightHandle.setAttribute('x', x + width - handleWidth);
      rightHandle.setAttribute('y', y + 2);
      rightHandle.setAttribute('width', handleWidth);
      rightHandle.setAttribute('height', height);
      rightHandle.setAttribute('fill', 'rgba(255,255,255,0.3)');
      rightHandle.setAttribute('data-side', 'right');
      rightHandle.classList.add('resize-handle');
      rightHandle.style.cursor = 'ew-resize';
      rightHandle.style.pointerEvents = 'all';
      group.appendChild(rightHandle);
    }

    /**
     * Agrega botón de eliminar
     */
    addDeleteButton(group, x, y, width) {
      const btnSize = 16;
      const btnX = x + width - btnSize - 4;
      const btnY = y + 4;

      const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      circle.setAttribute('cx', btnX + btnSize / 2);
      circle.setAttribute('cy', btnY + btnSize / 2);
      circle.setAttribute('r', btnSize / 2);
      circle.setAttribute('fill', 'rgba(0,0,0,0.3)');
      circle.classList.add('delete-button');
      circle.style.cursor = 'pointer';
      circle.style.pointerEvents = 'all';
      group.appendChild(circle);

      const xMark = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      xMark.setAttribute('x', btnX + btnSize / 2);
      xMark.setAttribute('y', btnY + btnSize / 2 + 4);
      xMark.setAttribute('text-anchor', 'middle');
      xMark.setAttribute('font-size', '12');
      xMark.setAttribute('font-weight', 'bold');
      xMark.setAttribute('fill', 'white');
      xMark.textContent = '×';
      xMark.style.pointerEvents = 'none';
      group.appendChild(xMark);
    }

    /**
     * Actualiza elemento de bloque
     */
    updateBlockElement(block) {
      const element = this.svg.querySelector(`[data-block-id="${block.id}"]`);
      if (!element) return;

      const { cellWidth, cellHeight } = this.options;
      const { leftMargin, topMargin } = this.gridDimensions;

      const x = leftMargin + (block.startCol * cellWidth);
      const y = topMargin + (block.dia * cellHeight);
      const width = (block.endCol - block.startCol) * cellWidth;
      const height = cellHeight - 4;

      const rect = element.querySelector('rect');
      rect.setAttribute('x', x);
      rect.setAttribute('y', y + 2);
      rect.setAttribute('width', width);

      const text = element.querySelector('text');
      if (text) {
        const timeText = this.getTimeFromColumn(block.startCol) + ' - ' + this.getTimeFromColumn(block.endCol);
        text.textContent = timeText;
        text.setAttribute('x', x + width / 2);
        text.setAttribute('y', y + height / 2 + 4);
      }

      const handles = element.querySelectorAll('.resize-handle');
      if (handles.length > 0) {
        handles[0].setAttribute('x', x);
        handles[0].setAttribute('y', y + 2);
        handles[1].setAttribute('x', x + width - 8);
        handles[1].setAttribute('y', y + 2);
      }

      const deleteBtn = element.querySelector('.delete-button');
      if (deleteBtn) {
        deleteBtn.setAttribute('cx', x + width - 12);
        deleteBtn.setAttribute('cy', y + 6);
        const xMark = element.querySelectorAll('text')[1];
        if (xMark) {
          xMark.setAttribute('x', x + width - 12);
          xMark.setAttribute('y', y + 10);
        }
      }
    }

    /**
     * Actualiza cursor
     */
    updateCursor(target) {
      if (target.classList.contains('resize-handle')) {
        this.svg.style.cursor = 'ew-resize';
      } else if (target.closest('.time-block')) {
        const blockElement = target.closest('.time-block');
        const blockId = blockElement ? parseInt(blockElement.getAttribute('data-block-id')) : null;
        const block = blockId ? this.blocks.find(b => b.id === blockId) : null;

        // Los bloques prohibir no pueden moverse
        if (this.isProhibirLocked(block)) {
          this.svg.style.cursor = 'not-allowed';
        } else if (this.selectedBlockId) {
          // ⭐ NUEVO: Cursor diferente si Alt está presionado
          this.svg.style.cursor = this.isAltPressed ? 'copy' : 'move';
        } else {
          this.svg.style.cursor = 'pointer';
        }
      } else {
        this.svg.style.cursor = 'crosshair';
      }
    }

    /**
     * Obtiene posición del mouse
     */
    getMousePosition(e) {
      const rect = this.svg.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    }

    /**
     * Obtiene celda desde punto
     */
    getCellFromPoint(point) {
      const { cellWidth, cellHeight } = this.options;
      const { leftMargin, topMargin, cols, rows } = this.gridDimensions;

      const x = point.x - leftMargin;
      const y = point.y - topMargin;

      if (x < 0 || y < 0) return null;

      const col = Math.floor(x / cellWidth);
      const day = Math.floor(y / cellHeight);

      if (col >= 0 && col < cols && day >= 0 && day < rows) {
        return { day, col };
      }

      return null;
    }

    /**
     * Convierte columna a tiempo
     */
    getTimeFromColumn(col) {
      const totalMinutes = col * this.options.minutesPerCell;
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }

    /**
     * Convierte tiempo a columna
     */
    getColumnFromTime(time, roundMode = 'floor') {
      const [hoursStr = '0', minutesStr = '0', secondsStr = '0'] = String(time).split(':');
      const hours = Number(hoursStr) || 0;
      const minutes = Number(minutesStr) || 0;
      const seconds = Number(secondsStr) || 0;
      const totalMinutes = hours * 60 + minutes + (seconds / 60);
      const rawCol = totalMinutes / this.options.minutesPerCell;

      if (roundMode === 'ceil') {
        return Math.ceil(rawCol);
      }

      return Math.floor(rawCol);
    }

    /**
     * Convierte columna a tiempo con segundos
     */
    getTimeWithSeconds(col) {
      const totalMinutes = col * this.options.minutesPerCell;

      // 24:00 no es una hora valida en formato HH:mm:ss
      if (totalMinutes >= 24 * 60) {
        return '23:59:59';
      }

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    }

    setDays(days) {
      this.options.days = days;
      this.days = this.options.days;
      
      this.renderBlocks();
      this.notifyChange();
    }

    getDays() {
      return this.days;
    }

    /**
     * Obtiene rangos en formato JSON
     */
    getRanges() {
      return this.blocks.map(block => ({
        dia: this.days[block.dia],
        timeInit: this.getTimeFromColumn(block.startCol),
        timeEnd: this.getTimeWithSeconds(block.endCol),
        prohibir: block.prohibir
      }));
    }

    /**
     * Establece rangos desde JSON
     */
    setRanges(ranges) {
      this.blocks = [];
      this.nextBlockId = 1;
      this.selectedBlockId = null;

      ranges.forEach(range => {
        const dayIndex = this.days.indexOf(range.dia);
        if (dayIndex === -1) return;

        const timeEnd = String(range.timeEnd || '00:00');
        const endParts = timeEnd.split(':');
        const endMinutes = Number(endParts[1] || 0);
        const endSeconds = Number(endParts[2] || 0);

        // Para fin de rango: si viene con segundos o fuera del paso del grid,
        // redondeamos hacia arriba para no perder 1 celda al recargar.
        const endRoundMode = (endSeconds > 0 || (endMinutes % this.options.minutesPerCell !== 0))
          ? 'ceil'
          : 'floor';

        const startCol = this.getColumnFromTime(range.timeInit, 'floor');
        const endCol = this.getColumnFromTime(timeEnd, endRoundMode);

        this.blocks.push({
          id: this.nextBlockId++,
          dia: dayIndex,
          startCol: startCol,
          endCol: endCol,
          prohibir: range.prohibir,
          selected: false
        });
      });

      this.renderBlocks();
      this.notifyChange();
    }

    /**
     * Establece modo (normal/prohibir)
     */
    setMode(mode) {
      if (mode !== 'normal' && mode !== 'prohibir') return;
      this.currentMode = mode;
    }

    /**
     * Obtiene modo actual
     */
    getMode() {
      return this.currentMode;
    }

    /**
     * Establece gap
     */
    setGap(gapMinutes) {
      this.options.gapMinutes = gapMinutes;
    }

    /**
     * Limpia selección
     */
    clearSelection() {
      this.blocks = [];
      this.nextBlockId = 1;
      this.selectedBlockId = null;
      this.renderBlocks();
      this.notifyChange();
    }

    /**
     * Notifica cambios
     */
    notifyChange() {
      if (typeof this.options.onChange === 'function') {
        this.options.onChange(this.getRanges());
      }
    }

    /**
     * Convierte a JSON
     */
    toJSON() {
      return JSON.stringify(this.getRanges(), null, 2);
    }

    /**
     * Destruye el selector
     */
    destroy() {
      if (this.svg) this.svg.remove();
      this.blocks = [];

      if (this.options.responsive && this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }

      // ⭐ NUEVO: Remover eventos de teclado
      if (this.handleKeyDown) {
        window.removeEventListener('keydown', this.handleKeyDown);
      }
      if (this.handleKeyUp) {
        window.removeEventListener('keyup', this.handleKeyUp);
      }
    }

    /**
     * Debounce utility
     */
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    /**
     * Recrea el grid
     */
    recreateGrid() {
      const currentBlocks = [...this.blocks];

      this.svg.innerHTML = '';

      this.blocksGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.blocksGroup.setAttribute('id', 'blocks-group');
      this.svg.appendChild(this.blocksGroup);

      const { minutesPerCell, startHour, endHour } = this.options;
      const totalMinutes = (endHour - startHour) * 60;
      const cols = totalMinutes / minutesPerCell;
      const rows = this.days.length;

      const containerWidth = this.container.clientWidth || 1200;

      let leftMargin = 50;
      let topMargin = 30;
      let cellHeight = this.options.cellHeight;

      const width = leftMargin + (cols * this.options.cellWidth);
      const height = topMargin + (rows * cellHeight);

      this.svg.setAttribute('viewBox', `${this.minX} ${this.minY} ${width} ${height}`);
      this.svg.setAttribute('height', height);
      this.gridDimensions = { leftMargin, topMargin, cols, rows, width, height, containerWidth };

      this.createGrid();

      this.blocks = currentBlocks;
      this.renderBlocks();
    }

    /**
     * Activa/desactiva responsive
     */
    setResponsive(enabled) {
      if (this.options.responsive === enabled) return;

      this.options.responsive = enabled;

      if (enabled) {
        this.handleResize = this.debounce(() => {
          this.recreateGrid();
        }, 250);
        window.addEventListener('resize', this.handleResize);
        this.recreateGrid();
      } else {
        if (this.handleResize) {
          window.removeEventListener('resize', this.handleResize);
        }
        this.options.cellWidth = 8;
        this.recreateGrid();
      }
    }
  }

  // Exponer globalmente
  window.TimeRangeSelector = TimeRangeSelector;

})(window);